(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2133"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2133"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("g4RT4", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $bb46d1ef196f6d38$export$ffb0004e005737fa; }, function (v) { return $bb46d1ef196f6d38$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $bb46d1ef196f6d38$export$34b9dba7ce09269b; }, function (v) { return $bb46d1ef196f6d38$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $bb46d1ef196f6d38$export$25062201e9e25d76; }, function (v) { return $bb46d1ef196f6d38$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bb46d1ef196f6d38$export$ffb0004e005737fa;
var $bb46d1ef196f6d38$export$34b9dba7ce09269b;
var $bb46d1ef196f6d38$export$25062201e9e25d76;
'use strict';

var $cQQee = parcelRequire("cQQee");
var $bb46d1ef196f6d38$var$k = Symbol.for("react.element"), $bb46d1ef196f6d38$var$l = Symbol.for("react.fragment"), $bb46d1ef196f6d38$var$m = Object.prototype.hasOwnProperty, $bb46d1ef196f6d38$var$n = $cQQee.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $bb46d1ef196f6d38$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $bb46d1ef196f6d38$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$bb46d1ef196f6d38$var$m.call(a, b) && !$bb46d1ef196f6d38$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $bb46d1ef196f6d38$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $bb46d1ef196f6d38$var$n.current
    };
}
$bb46d1ef196f6d38$export$ffb0004e005737fa = $bb46d1ef196f6d38$var$l;
$bb46d1ef196f6d38$export$34b9dba7ce09269b = $bb46d1ef196f6d38$var$q;
$bb46d1ef196f6d38$export$25062201e9e25d76 = $bb46d1ef196f6d38$var$q;

});
parcelRegister("cQQee", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1554X"));

});
parcelRegister("1554X", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $0c9a32a3cad9de82$export$dca3b0875bd9a954; }, function (v) { return $0c9a32a3cad9de82$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $0c9a32a3cad9de82$export$16fa2f45be04daa8; }, function (v) { return $0c9a32a3cad9de82$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $0c9a32a3cad9de82$export$ffb0004e005737fa; }, function (v) { return $0c9a32a3cad9de82$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $0c9a32a3cad9de82$export$e2c29f18771995cb; }, function (v) { return $0c9a32a3cad9de82$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $0c9a32a3cad9de82$export$221d75b3f55bb0bd; }, function (v) { return $0c9a32a3cad9de82$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $0c9a32a3cad9de82$export$5f8d39834fd61797; }, function (v) { return $0c9a32a3cad9de82$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $0c9a32a3cad9de82$export$74bf444e3cd11ea5; }, function (v) { return $0c9a32a3cad9de82$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $0c9a32a3cad9de82$export$ae55be85d98224ed; }, function (v) { return $0c9a32a3cad9de82$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $0c9a32a3cad9de82$export$3ba232387fd5d6dd; }, function (v) { return $0c9a32a3cad9de82$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $0c9a32a3cad9de82$export$e530037191fcd5d7; }, function (v) { return $0c9a32a3cad9de82$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $0c9a32a3cad9de82$export$fd42f52fd3ae1109; }, function (v) { return $0c9a32a3cad9de82$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $0c9a32a3cad9de82$export$c8a8987d4410bf2d; }, function (v) { return $0c9a32a3cad9de82$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $0c9a32a3cad9de82$export$d38cd72104c1f0e9; }, function (v) { return $0c9a32a3cad9de82$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $0c9a32a3cad9de82$export$7d1e3a5e95ceca43; }, function (v) { return $0c9a32a3cad9de82$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $0c9a32a3cad9de82$export$257a8862b851cb5b; }, function (v) { return $0c9a32a3cad9de82$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $0c9a32a3cad9de82$export$a8257692ac88316c; }, function (v) { return $0c9a32a3cad9de82$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $0c9a32a3cad9de82$export$488013bae63b21da; }, function (v) { return $0c9a32a3cad9de82$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $0c9a32a3cad9de82$export$7c73462e0d25e514; }, function (v) { return $0c9a32a3cad9de82$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $0c9a32a3cad9de82$export$7568632d0d33d16d; }, function (v) { return $0c9a32a3cad9de82$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $0c9a32a3cad9de82$export$88948ce120ea2619; }, function (v) { return $0c9a32a3cad9de82$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $0c9a32a3cad9de82$export$35808ee640e87ca7; }, function (v) { return $0c9a32a3cad9de82$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $0c9a32a3cad9de82$export$fae74005e78b1a27; }, function (v) { return $0c9a32a3cad9de82$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $0c9a32a3cad9de82$export$dc8fbce3eb94dc1e; }, function (v) { return $0c9a32a3cad9de82$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $0c9a32a3cad9de82$export$6a7bc4e911dc01cf; }, function (v) { return $0c9a32a3cad9de82$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $0c9a32a3cad9de82$export$6d9c69b0de29b591; }, function (v) { return $0c9a32a3cad9de82$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $0c9a32a3cad9de82$export$f680877a34711e37; }, function (v) { return $0c9a32a3cad9de82$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $0c9a32a3cad9de82$export$d5a552a76deda3c2; }, function (v) { return $0c9a32a3cad9de82$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $0c9a32a3cad9de82$export$aaabe4eda9ed9969; }, function (v) { return $0c9a32a3cad9de82$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $0c9a32a3cad9de82$export$e5c5a5f917a5871c; }, function (v) { return $0c9a32a3cad9de82$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $0c9a32a3cad9de82$export$1538c33de8887b59; }, function (v) { return $0c9a32a3cad9de82$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $0c9a32a3cad9de82$export$13e3392192263954; }, function (v) { return $0c9a32a3cad9de82$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $0c9a32a3cad9de82$export$b8f5890fc79d6aca; }, function (v) { return $0c9a32a3cad9de82$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $0c9a32a3cad9de82$export$60241385465d0a34; }, function (v) { return $0c9a32a3cad9de82$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $0c9a32a3cad9de82$export$306c0aa65ff9ec16; }, function (v) { return $0c9a32a3cad9de82$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $0c9a32a3cad9de82$export$7b286972b8d8ccbf; }, function (v) { return $0c9a32a3cad9de82$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $0c9a32a3cad9de82$export$83d89fbfd8236492; }, function (v) { return $0c9a32a3cad9de82$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0c9a32a3cad9de82$export$dca3b0875bd9a954;
var $0c9a32a3cad9de82$export$16fa2f45be04daa8;
var $0c9a32a3cad9de82$export$ffb0004e005737fa;
var $0c9a32a3cad9de82$export$e2c29f18771995cb;
var $0c9a32a3cad9de82$export$221d75b3f55bb0bd;
var $0c9a32a3cad9de82$export$5f8d39834fd61797;
var $0c9a32a3cad9de82$export$74bf444e3cd11ea5;
var $0c9a32a3cad9de82$export$ae55be85d98224ed;
var $0c9a32a3cad9de82$export$3ba232387fd5d6dd;
var $0c9a32a3cad9de82$export$e530037191fcd5d7;
var $0c9a32a3cad9de82$export$fd42f52fd3ae1109;
var $0c9a32a3cad9de82$export$c8a8987d4410bf2d;
var $0c9a32a3cad9de82$export$d38cd72104c1f0e9;
var $0c9a32a3cad9de82$export$7d1e3a5e95ceca43;
var $0c9a32a3cad9de82$export$257a8862b851cb5b;
var $0c9a32a3cad9de82$export$a8257692ac88316c;
var $0c9a32a3cad9de82$export$488013bae63b21da;
var $0c9a32a3cad9de82$export$7c73462e0d25e514;
var $0c9a32a3cad9de82$export$7568632d0d33d16d;
var $0c9a32a3cad9de82$export$88948ce120ea2619;
var $0c9a32a3cad9de82$export$35808ee640e87ca7;
var $0c9a32a3cad9de82$export$fae74005e78b1a27;
var $0c9a32a3cad9de82$export$dc8fbce3eb94dc1e;
var $0c9a32a3cad9de82$export$6a7bc4e911dc01cf;
var $0c9a32a3cad9de82$export$6d9c69b0de29b591;
var $0c9a32a3cad9de82$export$f680877a34711e37;
var $0c9a32a3cad9de82$export$d5a552a76deda3c2;
var $0c9a32a3cad9de82$export$aaabe4eda9ed9969;
var $0c9a32a3cad9de82$export$e5c5a5f917a5871c;
var $0c9a32a3cad9de82$export$1538c33de8887b59;
var $0c9a32a3cad9de82$export$13e3392192263954;
var $0c9a32a3cad9de82$export$b8f5890fc79d6aca;
var $0c9a32a3cad9de82$export$60241385465d0a34;
var $0c9a32a3cad9de82$export$306c0aa65ff9ec16;
var $0c9a32a3cad9de82$export$7b286972b8d8ccbf;
var $0c9a32a3cad9de82$export$83d89fbfd8236492;
'use strict';
var $0c9a32a3cad9de82$var$l = Symbol.for("react.element"), $0c9a32a3cad9de82$var$n = Symbol.for("react.portal"), $0c9a32a3cad9de82$var$p = Symbol.for("react.fragment"), $0c9a32a3cad9de82$var$q = Symbol.for("react.strict_mode"), $0c9a32a3cad9de82$var$r = Symbol.for("react.profiler"), $0c9a32a3cad9de82$var$t = Symbol.for("react.provider"), $0c9a32a3cad9de82$var$u = Symbol.for("react.context"), $0c9a32a3cad9de82$var$v = Symbol.for("react.forward_ref"), $0c9a32a3cad9de82$var$w = Symbol.for("react.suspense"), $0c9a32a3cad9de82$var$x = Symbol.for("react.memo"), $0c9a32a3cad9de82$var$y = Symbol.for("react.lazy"), $0c9a32a3cad9de82$var$z = Symbol.iterator;
function $0c9a32a3cad9de82$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0c9a32a3cad9de82$var$z && a[$0c9a32a3cad9de82$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0c9a32a3cad9de82$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $0c9a32a3cad9de82$var$C = Object.assign, $0c9a32a3cad9de82$var$D = {};
function $0c9a32a3cad9de82$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $0c9a32a3cad9de82$var$D;
    this.updater = e || $0c9a32a3cad9de82$var$B;
}
$0c9a32a3cad9de82$var$E.prototype.isReactComponent = {};
$0c9a32a3cad9de82$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$0c9a32a3cad9de82$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $0c9a32a3cad9de82$var$F() {}
$0c9a32a3cad9de82$var$F.prototype = $0c9a32a3cad9de82$var$E.prototype;
function $0c9a32a3cad9de82$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $0c9a32a3cad9de82$var$D;
    this.updater = e || $0c9a32a3cad9de82$var$B;
}
var $0c9a32a3cad9de82$var$H = $0c9a32a3cad9de82$var$G.prototype = new $0c9a32a3cad9de82$var$F;
$0c9a32a3cad9de82$var$H.constructor = $0c9a32a3cad9de82$var$G;
$0c9a32a3cad9de82$var$C($0c9a32a3cad9de82$var$H, $0c9a32a3cad9de82$var$E.prototype);
$0c9a32a3cad9de82$var$H.isPureReactComponent = !0;
var $0c9a32a3cad9de82$var$I = Array.isArray, $0c9a32a3cad9de82$var$J = Object.prototype.hasOwnProperty, $0c9a32a3cad9de82$var$K = {
    current: null
}, $0c9a32a3cad9de82$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0c9a32a3cad9de82$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$0c9a32a3cad9de82$var$J.call(b, d) && !$0c9a32a3cad9de82$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $0c9a32a3cad9de82$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $0c9a32a3cad9de82$var$K.current
    };
}
function $0c9a32a3cad9de82$var$N(a, b) {
    return {
        $$typeof: $0c9a32a3cad9de82$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $0c9a32a3cad9de82$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $0c9a32a3cad9de82$var$l;
}
function $0c9a32a3cad9de82$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $0c9a32a3cad9de82$var$P = /\/+/g;
function $0c9a32a3cad9de82$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $0c9a32a3cad9de82$var$escape("" + a.key) : b.toString(36);
}
function $0c9a32a3cad9de82$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $0c9a32a3cad9de82$var$l:
                case $0c9a32a3cad9de82$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $0c9a32a3cad9de82$var$Q(h, 0) : d, $0c9a32a3cad9de82$var$I(c) ? (e = "", null != a && (e = a.replace($0c9a32a3cad9de82$var$P, "$&/") + "/"), $0c9a32a3cad9de82$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($0c9a32a3cad9de82$var$O(c) && (c = $0c9a32a3cad9de82$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($0c9a32a3cad9de82$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($0c9a32a3cad9de82$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $0c9a32a3cad9de82$var$Q(k, g);
        h += $0c9a32a3cad9de82$var$R(k, b, e, f, c);
    }
    else if (f = $0c9a32a3cad9de82$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $0c9a32a3cad9de82$var$Q(k, g++), h += $0c9a32a3cad9de82$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $0c9a32a3cad9de82$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $0c9a32a3cad9de82$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $0c9a32a3cad9de82$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $0c9a32a3cad9de82$var$U = {
    current: null
}, $0c9a32a3cad9de82$var$V = {
    transition: null
}, $0c9a32a3cad9de82$var$W = {
    ReactCurrentDispatcher: $0c9a32a3cad9de82$var$U,
    ReactCurrentBatchConfig: $0c9a32a3cad9de82$var$V,
    ReactCurrentOwner: $0c9a32a3cad9de82$var$K
};
function $0c9a32a3cad9de82$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$0c9a32a3cad9de82$export$dca3b0875bd9a954 = {
    map: $0c9a32a3cad9de82$var$S,
    forEach: function(a, b, e) {
        $0c9a32a3cad9de82$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $0c9a32a3cad9de82$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $0c9a32a3cad9de82$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$0c9a32a3cad9de82$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$0c9a32a3cad9de82$export$16fa2f45be04daa8 = $0c9a32a3cad9de82$var$E;
$0c9a32a3cad9de82$export$ffb0004e005737fa = $0c9a32a3cad9de82$var$p;
$0c9a32a3cad9de82$export$e2c29f18771995cb = $0c9a32a3cad9de82$var$r;
$0c9a32a3cad9de82$export$221d75b3f55bb0bd = $0c9a32a3cad9de82$var$G;
$0c9a32a3cad9de82$export$5f8d39834fd61797 = $0c9a32a3cad9de82$var$q;
$0c9a32a3cad9de82$export$74bf444e3cd11ea5 = $0c9a32a3cad9de82$var$w;
$0c9a32a3cad9de82$export$ae55be85d98224ed = $0c9a32a3cad9de82$var$W;
$0c9a32a3cad9de82$export$3ba232387fd5d6dd = $0c9a32a3cad9de82$var$X;
$0c9a32a3cad9de82$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $0c9a32a3cad9de82$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $0c9a32a3cad9de82$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$0c9a32a3cad9de82$var$J.call(b, f) && !$0c9a32a3cad9de82$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $0c9a32a3cad9de82$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$0c9a32a3cad9de82$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $0c9a32a3cad9de82$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $0c9a32a3cad9de82$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$0c9a32a3cad9de82$export$c8a8987d4410bf2d = $0c9a32a3cad9de82$var$M;
$0c9a32a3cad9de82$export$d38cd72104c1f0e9 = function(a) {
    var b = $0c9a32a3cad9de82$var$M.bind(null, a);
    b.type = a;
    return b;
};
$0c9a32a3cad9de82$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$0c9a32a3cad9de82$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $0c9a32a3cad9de82$var$v,
        render: a
    };
};
$0c9a32a3cad9de82$export$a8257692ac88316c = $0c9a32a3cad9de82$var$O;
$0c9a32a3cad9de82$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $0c9a32a3cad9de82$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $0c9a32a3cad9de82$var$T
    };
};
$0c9a32a3cad9de82$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $0c9a32a3cad9de82$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$0c9a32a3cad9de82$export$7568632d0d33d16d = function(a) {
    var b = $0c9a32a3cad9de82$var$V.transition;
    $0c9a32a3cad9de82$var$V.transition = {};
    try {
        a();
    } finally{
        $0c9a32a3cad9de82$var$V.transition = b;
    }
};
$0c9a32a3cad9de82$export$88948ce120ea2619 = $0c9a32a3cad9de82$var$X;
$0c9a32a3cad9de82$export$35808ee640e87ca7 = function(a, b) {
    return $0c9a32a3cad9de82$var$U.current.useCallback(a, b);
};
$0c9a32a3cad9de82$export$fae74005e78b1a27 = function(a) {
    return $0c9a32a3cad9de82$var$U.current.useContext(a);
};
$0c9a32a3cad9de82$export$dc8fbce3eb94dc1e = function() {};
$0c9a32a3cad9de82$export$6a7bc4e911dc01cf = function(a) {
    return $0c9a32a3cad9de82$var$U.current.useDeferredValue(a);
};
$0c9a32a3cad9de82$export$6d9c69b0de29b591 = function(a, b) {
    return $0c9a32a3cad9de82$var$U.current.useEffect(a, b);
};
$0c9a32a3cad9de82$export$f680877a34711e37 = function() {
    return $0c9a32a3cad9de82$var$U.current.useId();
};
$0c9a32a3cad9de82$export$d5a552a76deda3c2 = function(a, b, e) {
    return $0c9a32a3cad9de82$var$U.current.useImperativeHandle(a, b, e);
};
$0c9a32a3cad9de82$export$aaabe4eda9ed9969 = function(a, b) {
    return $0c9a32a3cad9de82$var$U.current.useInsertionEffect(a, b);
};
$0c9a32a3cad9de82$export$e5c5a5f917a5871c = function(a, b) {
    return $0c9a32a3cad9de82$var$U.current.useLayoutEffect(a, b);
};
$0c9a32a3cad9de82$export$1538c33de8887b59 = function(a, b) {
    return $0c9a32a3cad9de82$var$U.current.useMemo(a, b);
};
$0c9a32a3cad9de82$export$13e3392192263954 = function(a, b, e) {
    return $0c9a32a3cad9de82$var$U.current.useReducer(a, b, e);
};
$0c9a32a3cad9de82$export$b8f5890fc79d6aca = function(a) {
    return $0c9a32a3cad9de82$var$U.current.useRef(a);
};
$0c9a32a3cad9de82$export$60241385465d0a34 = function(a) {
    return $0c9a32a3cad9de82$var$U.current.useState(a);
};
$0c9a32a3cad9de82$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $0c9a32a3cad9de82$var$U.current.useSyncExternalStore(a, b, e);
};
$0c9a32a3cad9de82$export$7b286972b8d8ccbf = function() {
    return $0c9a32a3cad9de82$var$U.current.useTransition();
};
$0c9a32a3cad9de82$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("kC364", function(module, exports) {
'use strict';
function $f019c24034597263$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($f019c24034597263$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$f019c24034597263$var$checkDCE();

module.exports = (parcelRequire("i9JpX"));

});
parcelRegister("i9JpX", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $d37c4c3cfd90dfc6$export$ae55be85d98224ed; }, function (v) { return $d37c4c3cfd90dfc6$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $d37c4c3cfd90dfc6$export$d39a5bbd09211389; }, function (v) { return $d37c4c3cfd90dfc6$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $d37c4c3cfd90dfc6$export$882461b6382ed46c; }, function (v) { return $d37c4c3cfd90dfc6$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $d37c4c3cfd90dfc6$export$466bfc07425424d5; }, function (v) { return $d37c4c3cfd90dfc6$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $d37c4c3cfd90dfc6$export$cd75ccfd720a3cd4; }, function (v) { return $d37c4c3cfd90dfc6$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $d37c4c3cfd90dfc6$export$fa8d919ba61d84db; }, function (v) { return $d37c4c3cfd90dfc6$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $d37c4c3cfd90dfc6$export$757ceba2d55c277e; }, function (v) { return $d37c4c3cfd90dfc6$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $d37c4c3cfd90dfc6$export$b3890eb0ae9dca99; }, function (v) { return $d37c4c3cfd90dfc6$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $d37c4c3cfd90dfc6$export$502457920280e6be; }, function (v) { return $d37c4c3cfd90dfc6$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $d37c4c3cfd90dfc6$export$c78a37762a8d58e1; }, function (v) { return $d37c4c3cfd90dfc6$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $d37c4c3cfd90dfc6$export$dc54d992c10e8a18; }, function (v) { return $d37c4c3cfd90dfc6$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $d37c4c3cfd90dfc6$export$83d89fbfd8236492; }, function (v) { return $d37c4c3cfd90dfc6$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $d37c4c3cfd90dfc6$export$ae55be85d98224ed;
var $d37c4c3cfd90dfc6$export$d39a5bbd09211389;
var $d37c4c3cfd90dfc6$export$882461b6382ed46c;
var $d37c4c3cfd90dfc6$export$466bfc07425424d5;
var $d37c4c3cfd90dfc6$export$cd75ccfd720a3cd4;
var $d37c4c3cfd90dfc6$export$fa8d919ba61d84db;
var $d37c4c3cfd90dfc6$export$757ceba2d55c277e;
var $d37c4c3cfd90dfc6$export$b3890eb0ae9dca99;
var $d37c4c3cfd90dfc6$export$502457920280e6be;
var $d37c4c3cfd90dfc6$export$c78a37762a8d58e1;
var $d37c4c3cfd90dfc6$export$dc54d992c10e8a18;
var $d37c4c3cfd90dfc6$export$83d89fbfd8236492;
'use strict';

var $cQQee = parcelRequire("cQQee");

var $iDofG = parcelRequire("iDofG");
function $d37c4c3cfd90dfc6$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $d37c4c3cfd90dfc6$var$da = new Set, $d37c4c3cfd90dfc6$var$ea = {};
function $d37c4c3cfd90dfc6$var$fa(a, b) {
    $d37c4c3cfd90dfc6$var$ha(a, b);
    $d37c4c3cfd90dfc6$var$ha(a + "Capture", b);
}
function $d37c4c3cfd90dfc6$var$ha(a, b) {
    $d37c4c3cfd90dfc6$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$d37c4c3cfd90dfc6$var$da.add(b[a]);
}
var $d37c4c3cfd90dfc6$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $d37c4c3cfd90dfc6$var$ja = Object.prototype.hasOwnProperty, $d37c4c3cfd90dfc6$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $d37c4c3cfd90dfc6$var$la = {}, $d37c4c3cfd90dfc6$var$ma = {};
function $d37c4c3cfd90dfc6$var$oa(a) {
    if ($d37c4c3cfd90dfc6$var$ja.call($d37c4c3cfd90dfc6$var$ma, a)) return !0;
    if ($d37c4c3cfd90dfc6$var$ja.call($d37c4c3cfd90dfc6$var$la, a)) return !1;
    if ($d37c4c3cfd90dfc6$var$ka.test(a)) return $d37c4c3cfd90dfc6$var$ma[a] = !0;
    $d37c4c3cfd90dfc6$var$la[a] = !0;
    return !1;
}
function $d37c4c3cfd90dfc6$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $d37c4c3cfd90dfc6$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $d37c4c3cfd90dfc6$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $d37c4c3cfd90dfc6$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $d37c4c3cfd90dfc6$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $d37c4c3cfd90dfc6$var$z[a] = new $d37c4c3cfd90dfc6$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $d37c4c3cfd90dfc6$var$z[b] = new $d37c4c3cfd90dfc6$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $d37c4c3cfd90dfc6$var$z[a] = new $d37c4c3cfd90dfc6$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $d37c4c3cfd90dfc6$var$z[a] = new $d37c4c3cfd90dfc6$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $d37c4c3cfd90dfc6$var$z[a] = new $d37c4c3cfd90dfc6$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $d37c4c3cfd90dfc6$var$z[a] = new $d37c4c3cfd90dfc6$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $d37c4c3cfd90dfc6$var$z[a] = new $d37c4c3cfd90dfc6$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $d37c4c3cfd90dfc6$var$z[a] = new $d37c4c3cfd90dfc6$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $d37c4c3cfd90dfc6$var$z[a] = new $d37c4c3cfd90dfc6$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $d37c4c3cfd90dfc6$var$ra = /[\-:]([a-z])/g;
function $d37c4c3cfd90dfc6$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($d37c4c3cfd90dfc6$var$ra, $d37c4c3cfd90dfc6$var$sa);
    $d37c4c3cfd90dfc6$var$z[b] = new $d37c4c3cfd90dfc6$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($d37c4c3cfd90dfc6$var$ra, $d37c4c3cfd90dfc6$var$sa);
    $d37c4c3cfd90dfc6$var$z[b] = new $d37c4c3cfd90dfc6$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($d37c4c3cfd90dfc6$var$ra, $d37c4c3cfd90dfc6$var$sa);
    $d37c4c3cfd90dfc6$var$z[b] = new $d37c4c3cfd90dfc6$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $d37c4c3cfd90dfc6$var$z[a] = new $d37c4c3cfd90dfc6$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$d37c4c3cfd90dfc6$var$z.xlinkHref = new $d37c4c3cfd90dfc6$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $d37c4c3cfd90dfc6$var$z[a] = new $d37c4c3cfd90dfc6$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $d37c4c3cfd90dfc6$var$ta(a, b, c, d) {
    var e = $d37c4c3cfd90dfc6$var$z.hasOwnProperty(b) ? $d37c4c3cfd90dfc6$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $d37c4c3cfd90dfc6$var$qa(b, c, e, d) && (c = null), d || null === e ? $d37c4c3cfd90dfc6$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $d37c4c3cfd90dfc6$var$ua = $cQQee.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $d37c4c3cfd90dfc6$var$va = Symbol.for("react.element"), $d37c4c3cfd90dfc6$var$wa = Symbol.for("react.portal"), $d37c4c3cfd90dfc6$var$ya = Symbol.for("react.fragment"), $d37c4c3cfd90dfc6$var$za = Symbol.for("react.strict_mode"), $d37c4c3cfd90dfc6$var$Aa = Symbol.for("react.profiler"), $d37c4c3cfd90dfc6$var$Ba = Symbol.for("react.provider"), $d37c4c3cfd90dfc6$var$Ca = Symbol.for("react.context"), $d37c4c3cfd90dfc6$var$Da = Symbol.for("react.forward_ref"), $d37c4c3cfd90dfc6$var$Ea = Symbol.for("react.suspense"), $d37c4c3cfd90dfc6$var$Fa = Symbol.for("react.suspense_list"), $d37c4c3cfd90dfc6$var$Ga = Symbol.for("react.memo"), $d37c4c3cfd90dfc6$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $d37c4c3cfd90dfc6$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $d37c4c3cfd90dfc6$var$Ja = Symbol.iterator;
function $d37c4c3cfd90dfc6$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $d37c4c3cfd90dfc6$var$Ja && a[$d37c4c3cfd90dfc6$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $d37c4c3cfd90dfc6$var$A = Object.assign, $d37c4c3cfd90dfc6$var$La;
function $d37c4c3cfd90dfc6$var$Ma(a) {
    if (void 0 === $d37c4c3cfd90dfc6$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $d37c4c3cfd90dfc6$var$La = b && b[1] || "";
    }
    return "\n" + $d37c4c3cfd90dfc6$var$La + a;
}
var $d37c4c3cfd90dfc6$var$Na = !1;
function $d37c4c3cfd90dfc6$var$Oa(a, b) {
    if (!a || $d37c4c3cfd90dfc6$var$Na) return "";
    $d37c4c3cfd90dfc6$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $d37c4c3cfd90dfc6$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $d37c4c3cfd90dfc6$var$Ma(a) : "";
}
function $d37c4c3cfd90dfc6$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $d37c4c3cfd90dfc6$var$Ma(a.type);
        case 16:
            return $d37c4c3cfd90dfc6$var$Ma("Lazy");
        case 13:
            return $d37c4c3cfd90dfc6$var$Ma("Suspense");
        case 19:
            return $d37c4c3cfd90dfc6$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $d37c4c3cfd90dfc6$var$Oa(a.type, !1), a;
        case 11:
            return a = $d37c4c3cfd90dfc6$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $d37c4c3cfd90dfc6$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $d37c4c3cfd90dfc6$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $d37c4c3cfd90dfc6$var$ya:
            return "Fragment";
        case $d37c4c3cfd90dfc6$var$wa:
            return "Portal";
        case $d37c4c3cfd90dfc6$var$Aa:
            return "Profiler";
        case $d37c4c3cfd90dfc6$var$za:
            return "StrictMode";
        case $d37c4c3cfd90dfc6$var$Ea:
            return "Suspense";
        case $d37c4c3cfd90dfc6$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $d37c4c3cfd90dfc6$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $d37c4c3cfd90dfc6$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $d37c4c3cfd90dfc6$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $d37c4c3cfd90dfc6$var$Ga:
            return b = a.displayName || null, null !== b ? b : $d37c4c3cfd90dfc6$var$Qa(a.type) || "Memo";
        case $d37c4c3cfd90dfc6$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $d37c4c3cfd90dfc6$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $d37c4c3cfd90dfc6$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $d37c4c3cfd90dfc6$var$Qa(b);
        case 8:
            return b === $d37c4c3cfd90dfc6$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $d37c4c3cfd90dfc6$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $d37c4c3cfd90dfc6$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $d37c4c3cfd90dfc6$var$Ua(a) {
    var b = $d37c4c3cfd90dfc6$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $d37c4c3cfd90dfc6$var$Va(a) {
    a._valueTracker || (a._valueTracker = $d37c4c3cfd90dfc6$var$Ua(a));
}
function $d37c4c3cfd90dfc6$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $d37c4c3cfd90dfc6$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $d37c4c3cfd90dfc6$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $d37c4c3cfd90dfc6$var$Ya(a, b) {
    var c = b.checked;
    return $d37c4c3cfd90dfc6$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $d37c4c3cfd90dfc6$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $d37c4c3cfd90dfc6$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $d37c4c3cfd90dfc6$var$ab(a, b) {
    b = b.checked;
    null != b && $d37c4c3cfd90dfc6$var$ta(a, "checked", b, !1);
}
function $d37c4c3cfd90dfc6$var$bb(a, b) {
    $d37c4c3cfd90dfc6$var$ab(a, b);
    var c = $d37c4c3cfd90dfc6$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $d37c4c3cfd90dfc6$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $d37c4c3cfd90dfc6$var$cb(a, b.type, $d37c4c3cfd90dfc6$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $d37c4c3cfd90dfc6$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $d37c4c3cfd90dfc6$var$cb(a, b, c) {
    if ("number" !== b || $d37c4c3cfd90dfc6$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $d37c4c3cfd90dfc6$var$eb = Array.isArray;
function $d37c4c3cfd90dfc6$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $d37c4c3cfd90dfc6$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $d37c4c3cfd90dfc6$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($d37c4c3cfd90dfc6$var$p(91));
    return $d37c4c3cfd90dfc6$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $d37c4c3cfd90dfc6$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($d37c4c3cfd90dfc6$var$p(92));
            if ($d37c4c3cfd90dfc6$var$eb(c)) {
                if (1 < c.length) throw Error($d37c4c3cfd90dfc6$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $d37c4c3cfd90dfc6$var$Sa(c)
    };
}
function $d37c4c3cfd90dfc6$var$ib(a, b) {
    var c = $d37c4c3cfd90dfc6$var$Sa(b.value), d = $d37c4c3cfd90dfc6$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $d37c4c3cfd90dfc6$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $d37c4c3cfd90dfc6$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $d37c4c3cfd90dfc6$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $d37c4c3cfd90dfc6$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $d37c4c3cfd90dfc6$var$mb, $d37c4c3cfd90dfc6$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $d37c4c3cfd90dfc6$var$mb = $d37c4c3cfd90dfc6$var$mb || document.createElement("div");
        $d37c4c3cfd90dfc6$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $d37c4c3cfd90dfc6$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $d37c4c3cfd90dfc6$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $d37c4c3cfd90dfc6$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $d37c4c3cfd90dfc6$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($d37c4c3cfd90dfc6$var$pb).forEach(function(a) {
    $d37c4c3cfd90dfc6$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $d37c4c3cfd90dfc6$var$pb[b] = $d37c4c3cfd90dfc6$var$pb[a];
    });
});
function $d37c4c3cfd90dfc6$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $d37c4c3cfd90dfc6$var$pb.hasOwnProperty(a) && $d37c4c3cfd90dfc6$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $d37c4c3cfd90dfc6$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $d37c4c3cfd90dfc6$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $d37c4c3cfd90dfc6$var$tb = $d37c4c3cfd90dfc6$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $d37c4c3cfd90dfc6$var$ub(a, b) {
    if (b) {
        if ($d37c4c3cfd90dfc6$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($d37c4c3cfd90dfc6$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($d37c4c3cfd90dfc6$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($d37c4c3cfd90dfc6$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($d37c4c3cfd90dfc6$var$p(62));
    }
}
function $d37c4c3cfd90dfc6$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $d37c4c3cfd90dfc6$var$wb = null;
function $d37c4c3cfd90dfc6$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $d37c4c3cfd90dfc6$var$yb = null, $d37c4c3cfd90dfc6$var$zb = null, $d37c4c3cfd90dfc6$var$Ab = null;
function $d37c4c3cfd90dfc6$var$Bb(a) {
    if (a = $d37c4c3cfd90dfc6$var$Cb(a)) {
        if ("function" !== typeof $d37c4c3cfd90dfc6$var$yb) throw Error($d37c4c3cfd90dfc6$var$p(280));
        var b = a.stateNode;
        b && (b = $d37c4c3cfd90dfc6$var$Db(b), $d37c4c3cfd90dfc6$var$yb(a.stateNode, a.type, b));
    }
}
function $d37c4c3cfd90dfc6$var$Eb(a) {
    $d37c4c3cfd90dfc6$var$zb ? $d37c4c3cfd90dfc6$var$Ab ? $d37c4c3cfd90dfc6$var$Ab.push(a) : $d37c4c3cfd90dfc6$var$Ab = [
        a
    ] : $d37c4c3cfd90dfc6$var$zb = a;
}
function $d37c4c3cfd90dfc6$var$Fb() {
    if ($d37c4c3cfd90dfc6$var$zb) {
        var a = $d37c4c3cfd90dfc6$var$zb, b = $d37c4c3cfd90dfc6$var$Ab;
        $d37c4c3cfd90dfc6$var$Ab = $d37c4c3cfd90dfc6$var$zb = null;
        $d37c4c3cfd90dfc6$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$d37c4c3cfd90dfc6$var$Bb(b[a]);
    }
}
function $d37c4c3cfd90dfc6$var$Gb(a, b) {
    return a(b);
}
function $d37c4c3cfd90dfc6$var$Hb() {}
var $d37c4c3cfd90dfc6$var$Ib = !1;
function $d37c4c3cfd90dfc6$var$Jb(a, b, c) {
    if ($d37c4c3cfd90dfc6$var$Ib) return a(b, c);
    $d37c4c3cfd90dfc6$var$Ib = !0;
    try {
        return $d37c4c3cfd90dfc6$var$Gb(a, b, c);
    } finally{
        if ($d37c4c3cfd90dfc6$var$Ib = !1, null !== $d37c4c3cfd90dfc6$var$zb || null !== $d37c4c3cfd90dfc6$var$Ab) $d37c4c3cfd90dfc6$var$Hb(), $d37c4c3cfd90dfc6$var$Fb();
    }
}
function $d37c4c3cfd90dfc6$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $d37c4c3cfd90dfc6$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($d37c4c3cfd90dfc6$var$p(231, b, typeof c));
    return c;
}
var $d37c4c3cfd90dfc6$var$Lb = !1;
if ($d37c4c3cfd90dfc6$var$ia) try {
    var $d37c4c3cfd90dfc6$var$Mb = {};
    Object.defineProperty($d37c4c3cfd90dfc6$var$Mb, "passive", {
        get: function() {
            $d37c4c3cfd90dfc6$var$Lb = !0;
        }
    });
    window.addEventListener("test", $d37c4c3cfd90dfc6$var$Mb, $d37c4c3cfd90dfc6$var$Mb);
    window.removeEventListener("test", $d37c4c3cfd90dfc6$var$Mb, $d37c4c3cfd90dfc6$var$Mb);
} catch (a) {
    $d37c4c3cfd90dfc6$var$Lb = !1;
}
function $d37c4c3cfd90dfc6$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $d37c4c3cfd90dfc6$var$Ob = !1, $d37c4c3cfd90dfc6$var$Pb = null, $d37c4c3cfd90dfc6$var$Qb = !1, $d37c4c3cfd90dfc6$var$Rb = null, $d37c4c3cfd90dfc6$var$Sb = {
    onError: function(a) {
        $d37c4c3cfd90dfc6$var$Ob = !0;
        $d37c4c3cfd90dfc6$var$Pb = a;
    }
};
function $d37c4c3cfd90dfc6$var$Tb(a, b, c, d, e, f, g, h, k) {
    $d37c4c3cfd90dfc6$var$Ob = !1;
    $d37c4c3cfd90dfc6$var$Pb = null;
    $d37c4c3cfd90dfc6$var$Nb.apply($d37c4c3cfd90dfc6$var$Sb, arguments);
}
function $d37c4c3cfd90dfc6$var$Ub(a, b, c, d, e, f, g, h, k) {
    $d37c4c3cfd90dfc6$var$Tb.apply(this, arguments);
    if ($d37c4c3cfd90dfc6$var$Ob) {
        if ($d37c4c3cfd90dfc6$var$Ob) {
            var l = $d37c4c3cfd90dfc6$var$Pb;
            $d37c4c3cfd90dfc6$var$Ob = !1;
            $d37c4c3cfd90dfc6$var$Pb = null;
        } else throw Error($d37c4c3cfd90dfc6$var$p(198));
        $d37c4c3cfd90dfc6$var$Qb || ($d37c4c3cfd90dfc6$var$Qb = !0, $d37c4c3cfd90dfc6$var$Rb = l);
    }
}
function $d37c4c3cfd90dfc6$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $d37c4c3cfd90dfc6$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $d37c4c3cfd90dfc6$var$Xb(a) {
    if ($d37c4c3cfd90dfc6$var$Vb(a) !== a) throw Error($d37c4c3cfd90dfc6$var$p(188));
}
function $d37c4c3cfd90dfc6$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $d37c4c3cfd90dfc6$var$Vb(a);
        if (null === b) throw Error($d37c4c3cfd90dfc6$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $d37c4c3cfd90dfc6$var$Xb(e), a;
                if (f === d) return $d37c4c3cfd90dfc6$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($d37c4c3cfd90dfc6$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($d37c4c3cfd90dfc6$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($d37c4c3cfd90dfc6$var$p(190));
    }
    if (3 !== c.tag) throw Error($d37c4c3cfd90dfc6$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $d37c4c3cfd90dfc6$var$Zb(a) {
    a = $d37c4c3cfd90dfc6$var$Yb(a);
    return null !== a ? $d37c4c3cfd90dfc6$var$$b(a) : null;
}
function $d37c4c3cfd90dfc6$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $d37c4c3cfd90dfc6$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $d37c4c3cfd90dfc6$var$ac = $iDofG.unstable_scheduleCallback, $d37c4c3cfd90dfc6$var$bc = $iDofG.unstable_cancelCallback, $d37c4c3cfd90dfc6$var$cc = $iDofG.unstable_shouldYield, $d37c4c3cfd90dfc6$var$dc = $iDofG.unstable_requestPaint, $d37c4c3cfd90dfc6$var$B = $iDofG.unstable_now, $d37c4c3cfd90dfc6$var$ec = $iDofG.unstable_getCurrentPriorityLevel, $d37c4c3cfd90dfc6$var$fc = $iDofG.unstable_ImmediatePriority, $d37c4c3cfd90dfc6$var$gc = $iDofG.unstable_UserBlockingPriority, $d37c4c3cfd90dfc6$var$hc = $iDofG.unstable_NormalPriority, $d37c4c3cfd90dfc6$var$ic = $iDofG.unstable_LowPriority, $d37c4c3cfd90dfc6$var$jc = $iDofG.unstable_IdlePriority, $d37c4c3cfd90dfc6$var$kc = null, $d37c4c3cfd90dfc6$var$lc = null;
function $d37c4c3cfd90dfc6$var$mc(a) {
    if ($d37c4c3cfd90dfc6$var$lc && "function" === typeof $d37c4c3cfd90dfc6$var$lc.onCommitFiberRoot) try {
        $d37c4c3cfd90dfc6$var$lc.onCommitFiberRoot($d37c4c3cfd90dfc6$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $d37c4c3cfd90dfc6$var$oc = Math.clz32 ? Math.clz32 : $d37c4c3cfd90dfc6$var$nc, $d37c4c3cfd90dfc6$var$pc = Math.log, $d37c4c3cfd90dfc6$var$qc = Math.LN2;
function $d37c4c3cfd90dfc6$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($d37c4c3cfd90dfc6$var$pc(a) / $d37c4c3cfd90dfc6$var$qc | 0) | 0;
}
var $d37c4c3cfd90dfc6$var$rc = 64, $d37c4c3cfd90dfc6$var$sc = 4194304;
function $d37c4c3cfd90dfc6$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $d37c4c3cfd90dfc6$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $d37c4c3cfd90dfc6$var$tc(h) : (f &= g, 0 !== f && (d = $d37c4c3cfd90dfc6$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $d37c4c3cfd90dfc6$var$tc(g) : 0 !== f && (d = $d37c4c3cfd90dfc6$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $d37c4c3cfd90dfc6$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $d37c4c3cfd90dfc6$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $d37c4c3cfd90dfc6$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $d37c4c3cfd90dfc6$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $d37c4c3cfd90dfc6$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $d37c4c3cfd90dfc6$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $d37c4c3cfd90dfc6$var$yc() {
    var a = $d37c4c3cfd90dfc6$var$rc;
    $d37c4c3cfd90dfc6$var$rc <<= 1;
    0 === ($d37c4c3cfd90dfc6$var$rc & 4194240) && ($d37c4c3cfd90dfc6$var$rc = 64);
    return a;
}
function $d37c4c3cfd90dfc6$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $d37c4c3cfd90dfc6$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $d37c4c3cfd90dfc6$var$oc(b);
    a[b] = c;
}
function $d37c4c3cfd90dfc6$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $d37c4c3cfd90dfc6$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $d37c4c3cfd90dfc6$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $d37c4c3cfd90dfc6$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $d37c4c3cfd90dfc6$var$C = 0;
function $d37c4c3cfd90dfc6$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $d37c4c3cfd90dfc6$var$Ec, $d37c4c3cfd90dfc6$var$Fc, $d37c4c3cfd90dfc6$var$Gc, $d37c4c3cfd90dfc6$var$Hc, $d37c4c3cfd90dfc6$var$Ic, $d37c4c3cfd90dfc6$var$Jc = !1, $d37c4c3cfd90dfc6$var$Kc = [], $d37c4c3cfd90dfc6$var$Lc = null, $d37c4c3cfd90dfc6$var$Mc = null, $d37c4c3cfd90dfc6$var$Nc = null, $d37c4c3cfd90dfc6$var$Oc = new Map, $d37c4c3cfd90dfc6$var$Pc = new Map, $d37c4c3cfd90dfc6$var$Qc = [], $d37c4c3cfd90dfc6$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $d37c4c3cfd90dfc6$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $d37c4c3cfd90dfc6$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $d37c4c3cfd90dfc6$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $d37c4c3cfd90dfc6$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $d37c4c3cfd90dfc6$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $d37c4c3cfd90dfc6$var$Pc.delete(b.pointerId);
    }
}
function $d37c4c3cfd90dfc6$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $d37c4c3cfd90dfc6$var$Cb(b), null !== b && $d37c4c3cfd90dfc6$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $d37c4c3cfd90dfc6$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $d37c4c3cfd90dfc6$var$Lc = $d37c4c3cfd90dfc6$var$Tc($d37c4c3cfd90dfc6$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $d37c4c3cfd90dfc6$var$Mc = $d37c4c3cfd90dfc6$var$Tc($d37c4c3cfd90dfc6$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $d37c4c3cfd90dfc6$var$Nc = $d37c4c3cfd90dfc6$var$Tc($d37c4c3cfd90dfc6$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $d37c4c3cfd90dfc6$var$Oc.set(f, $d37c4c3cfd90dfc6$var$Tc($d37c4c3cfd90dfc6$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $d37c4c3cfd90dfc6$var$Pc.set(f, $d37c4c3cfd90dfc6$var$Tc($d37c4c3cfd90dfc6$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $d37c4c3cfd90dfc6$var$Vc(a) {
    var b = $d37c4c3cfd90dfc6$var$Wc(a.target);
    if (null !== b) {
        var c = $d37c4c3cfd90dfc6$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $d37c4c3cfd90dfc6$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $d37c4c3cfd90dfc6$var$Ic(a.priority, function() {
                        $d37c4c3cfd90dfc6$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $d37c4c3cfd90dfc6$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $d37c4c3cfd90dfc6$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $d37c4c3cfd90dfc6$var$wb = d;
            c.target.dispatchEvent(d);
            $d37c4c3cfd90dfc6$var$wb = null;
        } else return b = $d37c4c3cfd90dfc6$var$Cb(c), null !== b && $d37c4c3cfd90dfc6$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $d37c4c3cfd90dfc6$var$Zc(a, b, c) {
    $d37c4c3cfd90dfc6$var$Xc(a) && c.delete(b);
}
function $d37c4c3cfd90dfc6$var$$c() {
    $d37c4c3cfd90dfc6$var$Jc = !1;
    null !== $d37c4c3cfd90dfc6$var$Lc && $d37c4c3cfd90dfc6$var$Xc($d37c4c3cfd90dfc6$var$Lc) && ($d37c4c3cfd90dfc6$var$Lc = null);
    null !== $d37c4c3cfd90dfc6$var$Mc && $d37c4c3cfd90dfc6$var$Xc($d37c4c3cfd90dfc6$var$Mc) && ($d37c4c3cfd90dfc6$var$Mc = null);
    null !== $d37c4c3cfd90dfc6$var$Nc && $d37c4c3cfd90dfc6$var$Xc($d37c4c3cfd90dfc6$var$Nc) && ($d37c4c3cfd90dfc6$var$Nc = null);
    $d37c4c3cfd90dfc6$var$Oc.forEach($d37c4c3cfd90dfc6$var$Zc);
    $d37c4c3cfd90dfc6$var$Pc.forEach($d37c4c3cfd90dfc6$var$Zc);
}
function $d37c4c3cfd90dfc6$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $d37c4c3cfd90dfc6$var$Jc || ($d37c4c3cfd90dfc6$var$Jc = !0, $iDofG.unstable_scheduleCallback($iDofG.unstable_NormalPriority, $d37c4c3cfd90dfc6$var$$c)));
}
function $d37c4c3cfd90dfc6$var$bd(a) {
    function b(b) {
        return $d37c4c3cfd90dfc6$var$ad(b, a);
    }
    if (0 < $d37c4c3cfd90dfc6$var$Kc.length) {
        $d37c4c3cfd90dfc6$var$ad($d37c4c3cfd90dfc6$var$Kc[0], a);
        for(var c = 1; c < $d37c4c3cfd90dfc6$var$Kc.length; c++){
            var d = $d37c4c3cfd90dfc6$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $d37c4c3cfd90dfc6$var$Lc && $d37c4c3cfd90dfc6$var$ad($d37c4c3cfd90dfc6$var$Lc, a);
    null !== $d37c4c3cfd90dfc6$var$Mc && $d37c4c3cfd90dfc6$var$ad($d37c4c3cfd90dfc6$var$Mc, a);
    null !== $d37c4c3cfd90dfc6$var$Nc && $d37c4c3cfd90dfc6$var$ad($d37c4c3cfd90dfc6$var$Nc, a);
    $d37c4c3cfd90dfc6$var$Oc.forEach(b);
    $d37c4c3cfd90dfc6$var$Pc.forEach(b);
    for(c = 0; c < $d37c4c3cfd90dfc6$var$Qc.length; c++)d = $d37c4c3cfd90dfc6$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $d37c4c3cfd90dfc6$var$Qc.length && (c = $d37c4c3cfd90dfc6$var$Qc[0], null === c.blockedOn);)$d37c4c3cfd90dfc6$var$Vc(c), null === c.blockedOn && $d37c4c3cfd90dfc6$var$Qc.shift();
}
var $d37c4c3cfd90dfc6$var$cd = $d37c4c3cfd90dfc6$var$ua.ReactCurrentBatchConfig, $d37c4c3cfd90dfc6$var$dd = !0;
function $d37c4c3cfd90dfc6$var$ed(a, b, c, d) {
    var e = $d37c4c3cfd90dfc6$var$C, f = $d37c4c3cfd90dfc6$var$cd.transition;
    $d37c4c3cfd90dfc6$var$cd.transition = null;
    try {
        $d37c4c3cfd90dfc6$var$C = 1, $d37c4c3cfd90dfc6$var$fd(a, b, c, d);
    } finally{
        $d37c4c3cfd90dfc6$var$C = e, $d37c4c3cfd90dfc6$var$cd.transition = f;
    }
}
function $d37c4c3cfd90dfc6$var$gd(a, b, c, d) {
    var e = $d37c4c3cfd90dfc6$var$C, f = $d37c4c3cfd90dfc6$var$cd.transition;
    $d37c4c3cfd90dfc6$var$cd.transition = null;
    try {
        $d37c4c3cfd90dfc6$var$C = 4, $d37c4c3cfd90dfc6$var$fd(a, b, c, d);
    } finally{
        $d37c4c3cfd90dfc6$var$C = e, $d37c4c3cfd90dfc6$var$cd.transition = f;
    }
}
function $d37c4c3cfd90dfc6$var$fd(a, b, c, d) {
    if ($d37c4c3cfd90dfc6$var$dd) {
        var e = $d37c4c3cfd90dfc6$var$Yc(a, b, c, d);
        if (null === e) $d37c4c3cfd90dfc6$var$hd(a, b, d, $d37c4c3cfd90dfc6$var$id, c), $d37c4c3cfd90dfc6$var$Sc(a, d);
        else if ($d37c4c3cfd90dfc6$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($d37c4c3cfd90dfc6$var$Sc(a, d), b & 4 && -1 < $d37c4c3cfd90dfc6$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $d37c4c3cfd90dfc6$var$Cb(e);
                null !== f && $d37c4c3cfd90dfc6$var$Ec(f);
                f = $d37c4c3cfd90dfc6$var$Yc(a, b, c, d);
                null === f && $d37c4c3cfd90dfc6$var$hd(a, b, d, $d37c4c3cfd90dfc6$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $d37c4c3cfd90dfc6$var$hd(a, b, d, null, c);
    }
}
var $d37c4c3cfd90dfc6$var$id = null;
function $d37c4c3cfd90dfc6$var$Yc(a, b, c, d) {
    $d37c4c3cfd90dfc6$var$id = null;
    a = $d37c4c3cfd90dfc6$var$xb(d);
    a = $d37c4c3cfd90dfc6$var$Wc(a);
    if (null !== a) {
        if (b = $d37c4c3cfd90dfc6$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $d37c4c3cfd90dfc6$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $d37c4c3cfd90dfc6$var$id = a;
    return null;
}
function $d37c4c3cfd90dfc6$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($d37c4c3cfd90dfc6$var$ec()){
                case $d37c4c3cfd90dfc6$var$fc:
                    return 1;
                case $d37c4c3cfd90dfc6$var$gc:
                    return 4;
                case $d37c4c3cfd90dfc6$var$hc:
                case $d37c4c3cfd90dfc6$var$ic:
                    return 16;
                case $d37c4c3cfd90dfc6$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $d37c4c3cfd90dfc6$var$kd = null, $d37c4c3cfd90dfc6$var$ld = null, $d37c4c3cfd90dfc6$var$md = null;
function $d37c4c3cfd90dfc6$var$nd() {
    if ($d37c4c3cfd90dfc6$var$md) return $d37c4c3cfd90dfc6$var$md;
    var a, b = $d37c4c3cfd90dfc6$var$ld, c = b.length, d, e = "value" in $d37c4c3cfd90dfc6$var$kd ? $d37c4c3cfd90dfc6$var$kd.value : $d37c4c3cfd90dfc6$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $d37c4c3cfd90dfc6$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $d37c4c3cfd90dfc6$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $d37c4c3cfd90dfc6$var$pd() {
    return !0;
}
function $d37c4c3cfd90dfc6$var$qd() {
    return !1;
}
function $d37c4c3cfd90dfc6$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $d37c4c3cfd90dfc6$var$pd : $d37c4c3cfd90dfc6$var$qd;
        this.isPropagationStopped = $d37c4c3cfd90dfc6$var$qd;
        return this;
    }
    $d37c4c3cfd90dfc6$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $d37c4c3cfd90dfc6$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $d37c4c3cfd90dfc6$var$pd);
        },
        persist: function() {},
        isPersistent: $d37c4c3cfd90dfc6$var$pd
    });
    return b;
}
var $d37c4c3cfd90dfc6$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $d37c4c3cfd90dfc6$var$td = $d37c4c3cfd90dfc6$var$rd($d37c4c3cfd90dfc6$var$sd), $d37c4c3cfd90dfc6$var$ud = $d37c4c3cfd90dfc6$var$A({}, $d37c4c3cfd90dfc6$var$sd, {
    view: 0,
    detail: 0
}), $d37c4c3cfd90dfc6$var$vd = $d37c4c3cfd90dfc6$var$rd($d37c4c3cfd90dfc6$var$ud), $d37c4c3cfd90dfc6$var$wd, $d37c4c3cfd90dfc6$var$xd, $d37c4c3cfd90dfc6$var$yd, $d37c4c3cfd90dfc6$var$Ad = $d37c4c3cfd90dfc6$var$A({}, $d37c4c3cfd90dfc6$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $d37c4c3cfd90dfc6$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $d37c4c3cfd90dfc6$var$yd && ($d37c4c3cfd90dfc6$var$yd && "mousemove" === a.type ? ($d37c4c3cfd90dfc6$var$wd = a.screenX - $d37c4c3cfd90dfc6$var$yd.screenX, $d37c4c3cfd90dfc6$var$xd = a.screenY - $d37c4c3cfd90dfc6$var$yd.screenY) : $d37c4c3cfd90dfc6$var$xd = $d37c4c3cfd90dfc6$var$wd = 0, $d37c4c3cfd90dfc6$var$yd = a);
        return $d37c4c3cfd90dfc6$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $d37c4c3cfd90dfc6$var$xd;
    }
}), $d37c4c3cfd90dfc6$var$Bd = $d37c4c3cfd90dfc6$var$rd($d37c4c3cfd90dfc6$var$Ad), $d37c4c3cfd90dfc6$var$Cd = $d37c4c3cfd90dfc6$var$A({}, $d37c4c3cfd90dfc6$var$Ad, {
    dataTransfer: 0
}), $d37c4c3cfd90dfc6$var$Dd = $d37c4c3cfd90dfc6$var$rd($d37c4c3cfd90dfc6$var$Cd), $d37c4c3cfd90dfc6$var$Ed = $d37c4c3cfd90dfc6$var$A({}, $d37c4c3cfd90dfc6$var$ud, {
    relatedTarget: 0
}), $d37c4c3cfd90dfc6$var$Fd = $d37c4c3cfd90dfc6$var$rd($d37c4c3cfd90dfc6$var$Ed), $d37c4c3cfd90dfc6$var$Gd = $d37c4c3cfd90dfc6$var$A({}, $d37c4c3cfd90dfc6$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $d37c4c3cfd90dfc6$var$Hd = $d37c4c3cfd90dfc6$var$rd($d37c4c3cfd90dfc6$var$Gd), $d37c4c3cfd90dfc6$var$Id = $d37c4c3cfd90dfc6$var$A({}, $d37c4c3cfd90dfc6$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $d37c4c3cfd90dfc6$var$Jd = $d37c4c3cfd90dfc6$var$rd($d37c4c3cfd90dfc6$var$Id), $d37c4c3cfd90dfc6$var$Kd = $d37c4c3cfd90dfc6$var$A({}, $d37c4c3cfd90dfc6$var$sd, {
    data: 0
}), $d37c4c3cfd90dfc6$var$Ld = $d37c4c3cfd90dfc6$var$rd($d37c4c3cfd90dfc6$var$Kd), $d37c4c3cfd90dfc6$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $d37c4c3cfd90dfc6$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $d37c4c3cfd90dfc6$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $d37c4c3cfd90dfc6$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $d37c4c3cfd90dfc6$var$Od[a]) ? !!b[a] : !1;
}
function $d37c4c3cfd90dfc6$var$zd() {
    return $d37c4c3cfd90dfc6$var$Pd;
}
var $d37c4c3cfd90dfc6$var$Qd = $d37c4c3cfd90dfc6$var$A({}, $d37c4c3cfd90dfc6$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $d37c4c3cfd90dfc6$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $d37c4c3cfd90dfc6$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $d37c4c3cfd90dfc6$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $d37c4c3cfd90dfc6$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $d37c4c3cfd90dfc6$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $d37c4c3cfd90dfc6$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $d37c4c3cfd90dfc6$var$Rd = $d37c4c3cfd90dfc6$var$rd($d37c4c3cfd90dfc6$var$Qd), $d37c4c3cfd90dfc6$var$Sd = $d37c4c3cfd90dfc6$var$A({}, $d37c4c3cfd90dfc6$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $d37c4c3cfd90dfc6$var$Td = $d37c4c3cfd90dfc6$var$rd($d37c4c3cfd90dfc6$var$Sd), $d37c4c3cfd90dfc6$var$Ud = $d37c4c3cfd90dfc6$var$A({}, $d37c4c3cfd90dfc6$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $d37c4c3cfd90dfc6$var$zd
}), $d37c4c3cfd90dfc6$var$Vd = $d37c4c3cfd90dfc6$var$rd($d37c4c3cfd90dfc6$var$Ud), $d37c4c3cfd90dfc6$var$Wd = $d37c4c3cfd90dfc6$var$A({}, $d37c4c3cfd90dfc6$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $d37c4c3cfd90dfc6$var$Xd = $d37c4c3cfd90dfc6$var$rd($d37c4c3cfd90dfc6$var$Wd), $d37c4c3cfd90dfc6$var$Yd = $d37c4c3cfd90dfc6$var$A({}, $d37c4c3cfd90dfc6$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $d37c4c3cfd90dfc6$var$Zd = $d37c4c3cfd90dfc6$var$rd($d37c4c3cfd90dfc6$var$Yd), $d37c4c3cfd90dfc6$var$$d = [
    9,
    13,
    27,
    32
], $d37c4c3cfd90dfc6$var$ae = $d37c4c3cfd90dfc6$var$ia && "CompositionEvent" in window, $d37c4c3cfd90dfc6$var$be = null;
$d37c4c3cfd90dfc6$var$ia && "documentMode" in document && ($d37c4c3cfd90dfc6$var$be = document.documentMode);
var $d37c4c3cfd90dfc6$var$ce = $d37c4c3cfd90dfc6$var$ia && "TextEvent" in window && !$d37c4c3cfd90dfc6$var$be, $d37c4c3cfd90dfc6$var$de = $d37c4c3cfd90dfc6$var$ia && (!$d37c4c3cfd90dfc6$var$ae || $d37c4c3cfd90dfc6$var$be && 8 < $d37c4c3cfd90dfc6$var$be && 11 >= $d37c4c3cfd90dfc6$var$be), $d37c4c3cfd90dfc6$var$ee = String.fromCharCode(32), $d37c4c3cfd90dfc6$var$fe = !1;
function $d37c4c3cfd90dfc6$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $d37c4c3cfd90dfc6$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $d37c4c3cfd90dfc6$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $d37c4c3cfd90dfc6$var$ie = !1;
function $d37c4c3cfd90dfc6$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $d37c4c3cfd90dfc6$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $d37c4c3cfd90dfc6$var$fe = !0;
            return $d37c4c3cfd90dfc6$var$ee;
        case "textInput":
            return a = b.data, a === $d37c4c3cfd90dfc6$var$ee && $d37c4c3cfd90dfc6$var$fe ? null : a;
        default:
            return null;
    }
}
function $d37c4c3cfd90dfc6$var$ke(a, b) {
    if ($d37c4c3cfd90dfc6$var$ie) return "compositionend" === a || !$d37c4c3cfd90dfc6$var$ae && $d37c4c3cfd90dfc6$var$ge(a, b) ? (a = $d37c4c3cfd90dfc6$var$nd(), $d37c4c3cfd90dfc6$var$md = $d37c4c3cfd90dfc6$var$ld = $d37c4c3cfd90dfc6$var$kd = null, $d37c4c3cfd90dfc6$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $d37c4c3cfd90dfc6$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $d37c4c3cfd90dfc6$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $d37c4c3cfd90dfc6$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$d37c4c3cfd90dfc6$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $d37c4c3cfd90dfc6$var$ne(a, b, c, d) {
    $d37c4c3cfd90dfc6$var$Eb(d);
    b = $d37c4c3cfd90dfc6$var$oe(b, "onChange");
    0 < b.length && (c = new $d37c4c3cfd90dfc6$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $d37c4c3cfd90dfc6$var$pe = null, $d37c4c3cfd90dfc6$var$qe = null;
function $d37c4c3cfd90dfc6$var$re(a) {
    $d37c4c3cfd90dfc6$var$se(a, 0);
}
function $d37c4c3cfd90dfc6$var$te(a) {
    var b = $d37c4c3cfd90dfc6$var$ue(a);
    if ($d37c4c3cfd90dfc6$var$Wa(b)) return a;
}
function $d37c4c3cfd90dfc6$var$ve(a, b) {
    if ("change" === a) return b;
}
var $d37c4c3cfd90dfc6$var$we = !1;
if ($d37c4c3cfd90dfc6$var$ia) {
    var $d37c4c3cfd90dfc6$var$xe;
    if ($d37c4c3cfd90dfc6$var$ia) {
        var $d37c4c3cfd90dfc6$var$ye = "oninput" in document;
        if (!$d37c4c3cfd90dfc6$var$ye) {
            var $d37c4c3cfd90dfc6$var$ze = document.createElement("div");
            $d37c4c3cfd90dfc6$var$ze.setAttribute("oninput", "return;");
            $d37c4c3cfd90dfc6$var$ye = "function" === typeof $d37c4c3cfd90dfc6$var$ze.oninput;
        }
        $d37c4c3cfd90dfc6$var$xe = $d37c4c3cfd90dfc6$var$ye;
    } else $d37c4c3cfd90dfc6$var$xe = !1;
    $d37c4c3cfd90dfc6$var$we = $d37c4c3cfd90dfc6$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $d37c4c3cfd90dfc6$var$Ae() {
    $d37c4c3cfd90dfc6$var$pe && ($d37c4c3cfd90dfc6$var$pe.detachEvent("onpropertychange", $d37c4c3cfd90dfc6$var$Be), $d37c4c3cfd90dfc6$var$qe = $d37c4c3cfd90dfc6$var$pe = null);
}
function $d37c4c3cfd90dfc6$var$Be(a) {
    if ("value" === a.propertyName && $d37c4c3cfd90dfc6$var$te($d37c4c3cfd90dfc6$var$qe)) {
        var b = [];
        $d37c4c3cfd90dfc6$var$ne(b, $d37c4c3cfd90dfc6$var$qe, a, $d37c4c3cfd90dfc6$var$xb(a));
        $d37c4c3cfd90dfc6$var$Jb($d37c4c3cfd90dfc6$var$re, b);
    }
}
function $d37c4c3cfd90dfc6$var$Ce(a, b, c) {
    "focusin" === a ? ($d37c4c3cfd90dfc6$var$Ae(), $d37c4c3cfd90dfc6$var$pe = b, $d37c4c3cfd90dfc6$var$qe = c, $d37c4c3cfd90dfc6$var$pe.attachEvent("onpropertychange", $d37c4c3cfd90dfc6$var$Be)) : "focusout" === a && $d37c4c3cfd90dfc6$var$Ae();
}
function $d37c4c3cfd90dfc6$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $d37c4c3cfd90dfc6$var$te($d37c4c3cfd90dfc6$var$qe);
}
function $d37c4c3cfd90dfc6$var$Ee(a, b) {
    if ("click" === a) return $d37c4c3cfd90dfc6$var$te(b);
}
function $d37c4c3cfd90dfc6$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $d37c4c3cfd90dfc6$var$te(b);
}
function $d37c4c3cfd90dfc6$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $d37c4c3cfd90dfc6$var$He = "function" === typeof Object.is ? Object.is : $d37c4c3cfd90dfc6$var$Ge;
function $d37c4c3cfd90dfc6$var$Ie(a, b) {
    if ($d37c4c3cfd90dfc6$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$d37c4c3cfd90dfc6$var$ja.call(b, e) || !$d37c4c3cfd90dfc6$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $d37c4c3cfd90dfc6$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $d37c4c3cfd90dfc6$var$Ke(a, b) {
    var c = $d37c4c3cfd90dfc6$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $d37c4c3cfd90dfc6$var$Je(c);
    }
}
function $d37c4c3cfd90dfc6$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $d37c4c3cfd90dfc6$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $d37c4c3cfd90dfc6$var$Me() {
    for(var a = window, b = $d37c4c3cfd90dfc6$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $d37c4c3cfd90dfc6$var$Xa(a.document);
    }
    return b;
}
function $d37c4c3cfd90dfc6$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $d37c4c3cfd90dfc6$var$Oe(a) {
    var b = $d37c4c3cfd90dfc6$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $d37c4c3cfd90dfc6$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $d37c4c3cfd90dfc6$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $d37c4c3cfd90dfc6$var$Ke(c, f);
                var g = $d37c4c3cfd90dfc6$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $d37c4c3cfd90dfc6$var$Pe = $d37c4c3cfd90dfc6$var$ia && "documentMode" in document && 11 >= document.documentMode, $d37c4c3cfd90dfc6$var$Qe = null, $d37c4c3cfd90dfc6$var$Re = null, $d37c4c3cfd90dfc6$var$Se = null, $d37c4c3cfd90dfc6$var$Te = !1;
function $d37c4c3cfd90dfc6$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $d37c4c3cfd90dfc6$var$Te || null == $d37c4c3cfd90dfc6$var$Qe || $d37c4c3cfd90dfc6$var$Qe !== $d37c4c3cfd90dfc6$var$Xa(d) || (d = $d37c4c3cfd90dfc6$var$Qe, "selectionStart" in d && $d37c4c3cfd90dfc6$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $d37c4c3cfd90dfc6$var$Se && $d37c4c3cfd90dfc6$var$Ie($d37c4c3cfd90dfc6$var$Se, d) || ($d37c4c3cfd90dfc6$var$Se = d, d = $d37c4c3cfd90dfc6$var$oe($d37c4c3cfd90dfc6$var$Re, "onSelect"), 0 < d.length && (b = new $d37c4c3cfd90dfc6$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $d37c4c3cfd90dfc6$var$Qe)));
}
function $d37c4c3cfd90dfc6$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $d37c4c3cfd90dfc6$var$We = {
    animationend: $d37c4c3cfd90dfc6$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $d37c4c3cfd90dfc6$var$Ve("Animation", "AnimationIteration"),
    animationstart: $d37c4c3cfd90dfc6$var$Ve("Animation", "AnimationStart"),
    transitionend: $d37c4c3cfd90dfc6$var$Ve("Transition", "TransitionEnd")
}, $d37c4c3cfd90dfc6$var$Xe = {}, $d37c4c3cfd90dfc6$var$Ye = {};
$d37c4c3cfd90dfc6$var$ia && ($d37c4c3cfd90dfc6$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $d37c4c3cfd90dfc6$var$We.animationend.animation, delete $d37c4c3cfd90dfc6$var$We.animationiteration.animation, delete $d37c4c3cfd90dfc6$var$We.animationstart.animation), "TransitionEvent" in window || delete $d37c4c3cfd90dfc6$var$We.transitionend.transition);
function $d37c4c3cfd90dfc6$var$Ze(a) {
    if ($d37c4c3cfd90dfc6$var$Xe[a]) return $d37c4c3cfd90dfc6$var$Xe[a];
    if (!$d37c4c3cfd90dfc6$var$We[a]) return a;
    var b = $d37c4c3cfd90dfc6$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $d37c4c3cfd90dfc6$var$Ye) return $d37c4c3cfd90dfc6$var$Xe[a] = b[c];
    return a;
}
var $d37c4c3cfd90dfc6$var$$e = $d37c4c3cfd90dfc6$var$Ze("animationend"), $d37c4c3cfd90dfc6$var$af = $d37c4c3cfd90dfc6$var$Ze("animationiteration"), $d37c4c3cfd90dfc6$var$bf = $d37c4c3cfd90dfc6$var$Ze("animationstart"), $d37c4c3cfd90dfc6$var$cf = $d37c4c3cfd90dfc6$var$Ze("transitionend"), $d37c4c3cfd90dfc6$var$df = new Map, $d37c4c3cfd90dfc6$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $d37c4c3cfd90dfc6$var$ff(a, b) {
    $d37c4c3cfd90dfc6$var$df.set(a, b);
    $d37c4c3cfd90dfc6$var$fa(b, [
        a
    ]);
}
for(var $d37c4c3cfd90dfc6$var$gf = 0; $d37c4c3cfd90dfc6$var$gf < $d37c4c3cfd90dfc6$var$ef.length; $d37c4c3cfd90dfc6$var$gf++){
    var $d37c4c3cfd90dfc6$var$hf = $d37c4c3cfd90dfc6$var$ef[$d37c4c3cfd90dfc6$var$gf], $d37c4c3cfd90dfc6$var$jf = $d37c4c3cfd90dfc6$var$hf.toLowerCase(), $d37c4c3cfd90dfc6$var$kf = $d37c4c3cfd90dfc6$var$hf[0].toUpperCase() + $d37c4c3cfd90dfc6$var$hf.slice(1);
    $d37c4c3cfd90dfc6$var$ff($d37c4c3cfd90dfc6$var$jf, "on" + $d37c4c3cfd90dfc6$var$kf);
}
$d37c4c3cfd90dfc6$var$ff($d37c4c3cfd90dfc6$var$$e, "onAnimationEnd");
$d37c4c3cfd90dfc6$var$ff($d37c4c3cfd90dfc6$var$af, "onAnimationIteration");
$d37c4c3cfd90dfc6$var$ff($d37c4c3cfd90dfc6$var$bf, "onAnimationStart");
$d37c4c3cfd90dfc6$var$ff("dblclick", "onDoubleClick");
$d37c4c3cfd90dfc6$var$ff("focusin", "onFocus");
$d37c4c3cfd90dfc6$var$ff("focusout", "onBlur");
$d37c4c3cfd90dfc6$var$ff($d37c4c3cfd90dfc6$var$cf, "onTransitionEnd");
$d37c4c3cfd90dfc6$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$d37c4c3cfd90dfc6$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$d37c4c3cfd90dfc6$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$d37c4c3cfd90dfc6$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$d37c4c3cfd90dfc6$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$d37c4c3cfd90dfc6$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$d37c4c3cfd90dfc6$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$d37c4c3cfd90dfc6$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$d37c4c3cfd90dfc6$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$d37c4c3cfd90dfc6$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $d37c4c3cfd90dfc6$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $d37c4c3cfd90dfc6$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($d37c4c3cfd90dfc6$var$lf));
function $d37c4c3cfd90dfc6$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $d37c4c3cfd90dfc6$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $d37c4c3cfd90dfc6$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $d37c4c3cfd90dfc6$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $d37c4c3cfd90dfc6$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($d37c4c3cfd90dfc6$var$Qb) throw a = $d37c4c3cfd90dfc6$var$Rb, $d37c4c3cfd90dfc6$var$Qb = !1, $d37c4c3cfd90dfc6$var$Rb = null, a;
}
function $d37c4c3cfd90dfc6$var$D(a, b) {
    var c = b[$d37c4c3cfd90dfc6$var$of];
    void 0 === c && (c = b[$d37c4c3cfd90dfc6$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($d37c4c3cfd90dfc6$var$pf(b, a, 2, !1), c.add(d));
}
function $d37c4c3cfd90dfc6$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $d37c4c3cfd90dfc6$var$pf(c, a, d, b);
}
var $d37c4c3cfd90dfc6$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $d37c4c3cfd90dfc6$var$sf(a) {
    if (!a[$d37c4c3cfd90dfc6$var$rf]) {
        a[$d37c4c3cfd90dfc6$var$rf] = !0;
        $d37c4c3cfd90dfc6$var$da.forEach(function(b) {
            "selectionchange" !== b && ($d37c4c3cfd90dfc6$var$mf.has(b) || $d37c4c3cfd90dfc6$var$qf(b, !1, a), $d37c4c3cfd90dfc6$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$d37c4c3cfd90dfc6$var$rf] || (b[$d37c4c3cfd90dfc6$var$rf] = !0, $d37c4c3cfd90dfc6$var$qf("selectionchange", !1, b));
    }
}
function $d37c4c3cfd90dfc6$var$pf(a, b, c, d) {
    switch($d37c4c3cfd90dfc6$var$jd(b)){
        case 1:
            var e = $d37c4c3cfd90dfc6$var$ed;
            break;
        case 4:
            e = $d37c4c3cfd90dfc6$var$gd;
            break;
        default:
            e = $d37c4c3cfd90dfc6$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$d37c4c3cfd90dfc6$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $d37c4c3cfd90dfc6$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $d37c4c3cfd90dfc6$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $d37c4c3cfd90dfc6$var$Jb(function() {
        var d = f, e = $d37c4c3cfd90dfc6$var$xb(c), g = [];
        a: {
            var h = $d37c4c3cfd90dfc6$var$df.get(a);
            if (void 0 !== h) {
                var k = $d37c4c3cfd90dfc6$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $d37c4c3cfd90dfc6$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $d37c4c3cfd90dfc6$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $d37c4c3cfd90dfc6$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $d37c4c3cfd90dfc6$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $d37c4c3cfd90dfc6$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $d37c4c3cfd90dfc6$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $d37c4c3cfd90dfc6$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $d37c4c3cfd90dfc6$var$Vd;
                        break;
                    case $d37c4c3cfd90dfc6$var$$e:
                    case $d37c4c3cfd90dfc6$var$af:
                    case $d37c4c3cfd90dfc6$var$bf:
                        k = $d37c4c3cfd90dfc6$var$Hd;
                        break;
                    case $d37c4c3cfd90dfc6$var$cf:
                        k = $d37c4c3cfd90dfc6$var$Xd;
                        break;
                    case "scroll":
                        k = $d37c4c3cfd90dfc6$var$vd;
                        break;
                    case "wheel":
                        k = $d37c4c3cfd90dfc6$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $d37c4c3cfd90dfc6$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $d37c4c3cfd90dfc6$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $d37c4c3cfd90dfc6$var$Kb(w, x), null != F && t.push($d37c4c3cfd90dfc6$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $d37c4c3cfd90dfc6$var$wb && (n = c.relatedTarget || c.fromElement) && ($d37c4c3cfd90dfc6$var$Wc(n) || n[$d37c4c3cfd90dfc6$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $d37c4c3cfd90dfc6$var$Wc(n) : null, null !== n && (J = $d37c4c3cfd90dfc6$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $d37c4c3cfd90dfc6$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $d37c4c3cfd90dfc6$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $d37c4c3cfd90dfc6$var$ue(k);
                        u = null == n ? h : $d37c4c3cfd90dfc6$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $d37c4c3cfd90dfc6$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $d37c4c3cfd90dfc6$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $d37c4c3cfd90dfc6$var$vf(F))u++;
                            for(; 0 < w - u;)t = $d37c4c3cfd90dfc6$var$vf(t), w--;
                            for(; 0 < u - w;)x = $d37c4c3cfd90dfc6$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $d37c4c3cfd90dfc6$var$vf(t);
                                x = $d37c4c3cfd90dfc6$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $d37c4c3cfd90dfc6$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $d37c4c3cfd90dfc6$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $d37c4c3cfd90dfc6$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $d37c4c3cfd90dfc6$var$ve;
                else if ($d37c4c3cfd90dfc6$var$me(h)) {
                    if ($d37c4c3cfd90dfc6$var$we) na = $d37c4c3cfd90dfc6$var$Fe;
                    else {
                        na = $d37c4c3cfd90dfc6$var$De;
                        var xa = $d37c4c3cfd90dfc6$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $d37c4c3cfd90dfc6$var$Ee);
                if (na && (na = na(a, d))) {
                    $d37c4c3cfd90dfc6$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $d37c4c3cfd90dfc6$var$cb(h, "number", h.value);
            }
            xa = d ? $d37c4c3cfd90dfc6$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($d37c4c3cfd90dfc6$var$me(xa) || "true" === xa.contentEditable) $d37c4c3cfd90dfc6$var$Qe = xa, $d37c4c3cfd90dfc6$var$Re = d, $d37c4c3cfd90dfc6$var$Se = null;
                    break;
                case "focusout":
                    $d37c4c3cfd90dfc6$var$Se = $d37c4c3cfd90dfc6$var$Re = $d37c4c3cfd90dfc6$var$Qe = null;
                    break;
                case "mousedown":
                    $d37c4c3cfd90dfc6$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $d37c4c3cfd90dfc6$var$Te = !1;
                    $d37c4c3cfd90dfc6$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($d37c4c3cfd90dfc6$var$Pe) break;
                case "keydown":
                case "keyup":
                    $d37c4c3cfd90dfc6$var$Ue(g, c, e);
            }
            var $a;
            if ($d37c4c3cfd90dfc6$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $d37c4c3cfd90dfc6$var$ie ? $d37c4c3cfd90dfc6$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($d37c4c3cfd90dfc6$var$de && "ko" !== c.locale && ($d37c4c3cfd90dfc6$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $d37c4c3cfd90dfc6$var$ie && ($a = $d37c4c3cfd90dfc6$var$nd()) : ($d37c4c3cfd90dfc6$var$kd = e, $d37c4c3cfd90dfc6$var$ld = "value" in $d37c4c3cfd90dfc6$var$kd ? $d37c4c3cfd90dfc6$var$kd.value : $d37c4c3cfd90dfc6$var$kd.textContent, $d37c4c3cfd90dfc6$var$ie = !0)), xa = $d37c4c3cfd90dfc6$var$oe(d, ba), 0 < xa.length && (ba = new $d37c4c3cfd90dfc6$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $d37c4c3cfd90dfc6$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $d37c4c3cfd90dfc6$var$ce ? $d37c4c3cfd90dfc6$var$je(a, c) : $d37c4c3cfd90dfc6$var$ke(a, c)) d = $d37c4c3cfd90dfc6$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $d37c4c3cfd90dfc6$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $d37c4c3cfd90dfc6$var$se(g, b);
    });
}
function $d37c4c3cfd90dfc6$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $d37c4c3cfd90dfc6$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $d37c4c3cfd90dfc6$var$Kb(a, c), null != f && d.unshift($d37c4c3cfd90dfc6$var$tf(a, f, e)), f = $d37c4c3cfd90dfc6$var$Kb(a, b), null != f && d.push($d37c4c3cfd90dfc6$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $d37c4c3cfd90dfc6$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $d37c4c3cfd90dfc6$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $d37c4c3cfd90dfc6$var$Kb(c, f), null != k && g.unshift($d37c4c3cfd90dfc6$var$tf(c, k, h))) : e || (k = $d37c4c3cfd90dfc6$var$Kb(c, f), null != k && g.push($d37c4c3cfd90dfc6$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $d37c4c3cfd90dfc6$var$xf = /\r\n?/g, $d37c4c3cfd90dfc6$var$yf = /\u0000|\uFFFD/g;
function $d37c4c3cfd90dfc6$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($d37c4c3cfd90dfc6$var$xf, "\n").replace($d37c4c3cfd90dfc6$var$yf, "");
}
function $d37c4c3cfd90dfc6$var$Af(a, b, c) {
    b = $d37c4c3cfd90dfc6$var$zf(b);
    if ($d37c4c3cfd90dfc6$var$zf(a) !== b && c) throw Error($d37c4c3cfd90dfc6$var$p(425));
}
function $d37c4c3cfd90dfc6$var$Bf() {}
var $d37c4c3cfd90dfc6$var$Cf = null, $d37c4c3cfd90dfc6$var$Df = null;
function $d37c4c3cfd90dfc6$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $d37c4c3cfd90dfc6$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $d37c4c3cfd90dfc6$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $d37c4c3cfd90dfc6$var$Hf = "function" === typeof Promise ? Promise : void 0, $d37c4c3cfd90dfc6$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $d37c4c3cfd90dfc6$var$Hf ? function(a) {
    return $d37c4c3cfd90dfc6$var$Hf.resolve(null).then(a).catch($d37c4c3cfd90dfc6$var$If);
} : $d37c4c3cfd90dfc6$var$Ff;
function $d37c4c3cfd90dfc6$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $d37c4c3cfd90dfc6$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $d37c4c3cfd90dfc6$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $d37c4c3cfd90dfc6$var$bd(b);
}
function $d37c4c3cfd90dfc6$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $d37c4c3cfd90dfc6$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $d37c4c3cfd90dfc6$var$Nf = Math.random().toString(36).slice(2), $d37c4c3cfd90dfc6$var$Of = "__reactFiber$" + $d37c4c3cfd90dfc6$var$Nf, $d37c4c3cfd90dfc6$var$Pf = "__reactProps$" + $d37c4c3cfd90dfc6$var$Nf, $d37c4c3cfd90dfc6$var$uf = "__reactContainer$" + $d37c4c3cfd90dfc6$var$Nf, $d37c4c3cfd90dfc6$var$of = "__reactEvents$" + $d37c4c3cfd90dfc6$var$Nf, $d37c4c3cfd90dfc6$var$Qf = "__reactListeners$" + $d37c4c3cfd90dfc6$var$Nf, $d37c4c3cfd90dfc6$var$Rf = "__reactHandles$" + $d37c4c3cfd90dfc6$var$Nf;
function $d37c4c3cfd90dfc6$var$Wc(a) {
    var b = a[$d37c4c3cfd90dfc6$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$d37c4c3cfd90dfc6$var$uf] || c[$d37c4c3cfd90dfc6$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $d37c4c3cfd90dfc6$var$Mf(a); null !== a;){
                if (c = a[$d37c4c3cfd90dfc6$var$Of]) return c;
                a = $d37c4c3cfd90dfc6$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $d37c4c3cfd90dfc6$var$Cb(a) {
    a = a[$d37c4c3cfd90dfc6$var$Of] || a[$d37c4c3cfd90dfc6$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $d37c4c3cfd90dfc6$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($d37c4c3cfd90dfc6$var$p(33));
}
function $d37c4c3cfd90dfc6$var$Db(a) {
    return a[$d37c4c3cfd90dfc6$var$Pf] || null;
}
var $d37c4c3cfd90dfc6$var$Sf = [], $d37c4c3cfd90dfc6$var$Tf = -1;
function $d37c4c3cfd90dfc6$var$Uf(a) {
    return {
        current: a
    };
}
function $d37c4c3cfd90dfc6$var$E(a) {
    0 > $d37c4c3cfd90dfc6$var$Tf || (a.current = $d37c4c3cfd90dfc6$var$Sf[$d37c4c3cfd90dfc6$var$Tf], $d37c4c3cfd90dfc6$var$Sf[$d37c4c3cfd90dfc6$var$Tf] = null, $d37c4c3cfd90dfc6$var$Tf--);
}
function $d37c4c3cfd90dfc6$var$G(a, b) {
    $d37c4c3cfd90dfc6$var$Tf++;
    $d37c4c3cfd90dfc6$var$Sf[$d37c4c3cfd90dfc6$var$Tf] = a.current;
    a.current = b;
}
var $d37c4c3cfd90dfc6$var$Vf = {}, $d37c4c3cfd90dfc6$var$H = $d37c4c3cfd90dfc6$var$Uf($d37c4c3cfd90dfc6$var$Vf), $d37c4c3cfd90dfc6$var$Wf = $d37c4c3cfd90dfc6$var$Uf(!1), $d37c4c3cfd90dfc6$var$Xf = $d37c4c3cfd90dfc6$var$Vf;
function $d37c4c3cfd90dfc6$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $d37c4c3cfd90dfc6$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $d37c4c3cfd90dfc6$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $d37c4c3cfd90dfc6$var$$f() {
    $d37c4c3cfd90dfc6$var$E($d37c4c3cfd90dfc6$var$Wf);
    $d37c4c3cfd90dfc6$var$E($d37c4c3cfd90dfc6$var$H);
}
function $d37c4c3cfd90dfc6$var$ag(a, b, c) {
    if ($d37c4c3cfd90dfc6$var$H.current !== $d37c4c3cfd90dfc6$var$Vf) throw Error($d37c4c3cfd90dfc6$var$p(168));
    $d37c4c3cfd90dfc6$var$G($d37c4c3cfd90dfc6$var$H, b);
    $d37c4c3cfd90dfc6$var$G($d37c4c3cfd90dfc6$var$Wf, c);
}
function $d37c4c3cfd90dfc6$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($d37c4c3cfd90dfc6$var$p(108, $d37c4c3cfd90dfc6$var$Ra(a) || "Unknown", e));
    return $d37c4c3cfd90dfc6$var$A({}, c, d);
}
function $d37c4c3cfd90dfc6$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $d37c4c3cfd90dfc6$var$Vf;
    $d37c4c3cfd90dfc6$var$Xf = $d37c4c3cfd90dfc6$var$H.current;
    $d37c4c3cfd90dfc6$var$G($d37c4c3cfd90dfc6$var$H, a);
    $d37c4c3cfd90dfc6$var$G($d37c4c3cfd90dfc6$var$Wf, $d37c4c3cfd90dfc6$var$Wf.current);
    return !0;
}
function $d37c4c3cfd90dfc6$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($d37c4c3cfd90dfc6$var$p(169));
    c ? (a = $d37c4c3cfd90dfc6$var$bg(a, b, $d37c4c3cfd90dfc6$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $d37c4c3cfd90dfc6$var$E($d37c4c3cfd90dfc6$var$Wf), $d37c4c3cfd90dfc6$var$E($d37c4c3cfd90dfc6$var$H), $d37c4c3cfd90dfc6$var$G($d37c4c3cfd90dfc6$var$H, a)) : $d37c4c3cfd90dfc6$var$E($d37c4c3cfd90dfc6$var$Wf);
    $d37c4c3cfd90dfc6$var$G($d37c4c3cfd90dfc6$var$Wf, c);
}
var $d37c4c3cfd90dfc6$var$eg = null, $d37c4c3cfd90dfc6$var$fg = !1, $d37c4c3cfd90dfc6$var$gg = !1;
function $d37c4c3cfd90dfc6$var$hg(a) {
    null === $d37c4c3cfd90dfc6$var$eg ? $d37c4c3cfd90dfc6$var$eg = [
        a
    ] : $d37c4c3cfd90dfc6$var$eg.push(a);
}
function $d37c4c3cfd90dfc6$var$ig(a) {
    $d37c4c3cfd90dfc6$var$fg = !0;
    $d37c4c3cfd90dfc6$var$hg(a);
}
function $d37c4c3cfd90dfc6$var$jg() {
    if (!$d37c4c3cfd90dfc6$var$gg && null !== $d37c4c3cfd90dfc6$var$eg) {
        $d37c4c3cfd90dfc6$var$gg = !0;
        var a = 0, b = $d37c4c3cfd90dfc6$var$C;
        try {
            var c = $d37c4c3cfd90dfc6$var$eg;
            for($d37c4c3cfd90dfc6$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $d37c4c3cfd90dfc6$var$eg = null;
            $d37c4c3cfd90dfc6$var$fg = !1;
        } catch (e) {
            throw null !== $d37c4c3cfd90dfc6$var$eg && ($d37c4c3cfd90dfc6$var$eg = $d37c4c3cfd90dfc6$var$eg.slice(a + 1)), $d37c4c3cfd90dfc6$var$ac($d37c4c3cfd90dfc6$var$fc, $d37c4c3cfd90dfc6$var$jg), e;
        } finally{
            $d37c4c3cfd90dfc6$var$C = b, $d37c4c3cfd90dfc6$var$gg = !1;
        }
    }
    return null;
}
var $d37c4c3cfd90dfc6$var$kg = [], $d37c4c3cfd90dfc6$var$lg = 0, $d37c4c3cfd90dfc6$var$mg = null, $d37c4c3cfd90dfc6$var$ng = 0, $d37c4c3cfd90dfc6$var$og = [], $d37c4c3cfd90dfc6$var$pg = 0, $d37c4c3cfd90dfc6$var$qg = null, $d37c4c3cfd90dfc6$var$rg = 1, $d37c4c3cfd90dfc6$var$sg = "";
function $d37c4c3cfd90dfc6$var$tg(a, b) {
    $d37c4c3cfd90dfc6$var$kg[$d37c4c3cfd90dfc6$var$lg++] = $d37c4c3cfd90dfc6$var$ng;
    $d37c4c3cfd90dfc6$var$kg[$d37c4c3cfd90dfc6$var$lg++] = $d37c4c3cfd90dfc6$var$mg;
    $d37c4c3cfd90dfc6$var$mg = a;
    $d37c4c3cfd90dfc6$var$ng = b;
}
function $d37c4c3cfd90dfc6$var$ug(a, b, c) {
    $d37c4c3cfd90dfc6$var$og[$d37c4c3cfd90dfc6$var$pg++] = $d37c4c3cfd90dfc6$var$rg;
    $d37c4c3cfd90dfc6$var$og[$d37c4c3cfd90dfc6$var$pg++] = $d37c4c3cfd90dfc6$var$sg;
    $d37c4c3cfd90dfc6$var$og[$d37c4c3cfd90dfc6$var$pg++] = $d37c4c3cfd90dfc6$var$qg;
    $d37c4c3cfd90dfc6$var$qg = a;
    var d = $d37c4c3cfd90dfc6$var$rg;
    a = $d37c4c3cfd90dfc6$var$sg;
    var e = 32 - $d37c4c3cfd90dfc6$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $d37c4c3cfd90dfc6$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $d37c4c3cfd90dfc6$var$rg = 1 << 32 - $d37c4c3cfd90dfc6$var$oc(b) + e | c << e | d;
        $d37c4c3cfd90dfc6$var$sg = f + a;
    } else $d37c4c3cfd90dfc6$var$rg = 1 << f | c << e | d, $d37c4c3cfd90dfc6$var$sg = a;
}
function $d37c4c3cfd90dfc6$var$vg(a) {
    null !== a.return && ($d37c4c3cfd90dfc6$var$tg(a, 1), $d37c4c3cfd90dfc6$var$ug(a, 1, 0));
}
function $d37c4c3cfd90dfc6$var$wg(a) {
    for(; a === $d37c4c3cfd90dfc6$var$mg;)$d37c4c3cfd90dfc6$var$mg = $d37c4c3cfd90dfc6$var$kg[--$d37c4c3cfd90dfc6$var$lg], $d37c4c3cfd90dfc6$var$kg[$d37c4c3cfd90dfc6$var$lg] = null, $d37c4c3cfd90dfc6$var$ng = $d37c4c3cfd90dfc6$var$kg[--$d37c4c3cfd90dfc6$var$lg], $d37c4c3cfd90dfc6$var$kg[$d37c4c3cfd90dfc6$var$lg] = null;
    for(; a === $d37c4c3cfd90dfc6$var$qg;)$d37c4c3cfd90dfc6$var$qg = $d37c4c3cfd90dfc6$var$og[--$d37c4c3cfd90dfc6$var$pg], $d37c4c3cfd90dfc6$var$og[$d37c4c3cfd90dfc6$var$pg] = null, $d37c4c3cfd90dfc6$var$sg = $d37c4c3cfd90dfc6$var$og[--$d37c4c3cfd90dfc6$var$pg], $d37c4c3cfd90dfc6$var$og[$d37c4c3cfd90dfc6$var$pg] = null, $d37c4c3cfd90dfc6$var$rg = $d37c4c3cfd90dfc6$var$og[--$d37c4c3cfd90dfc6$var$pg], $d37c4c3cfd90dfc6$var$og[$d37c4c3cfd90dfc6$var$pg] = null;
}
var $d37c4c3cfd90dfc6$var$xg = null, $d37c4c3cfd90dfc6$var$yg = null, $d37c4c3cfd90dfc6$var$I = !1, $d37c4c3cfd90dfc6$var$zg = null;
function $d37c4c3cfd90dfc6$var$Ag(a, b) {
    var c = $d37c4c3cfd90dfc6$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $d37c4c3cfd90dfc6$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $d37c4c3cfd90dfc6$var$xg = a, $d37c4c3cfd90dfc6$var$yg = $d37c4c3cfd90dfc6$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $d37c4c3cfd90dfc6$var$xg = a, $d37c4c3cfd90dfc6$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $d37c4c3cfd90dfc6$var$qg ? {
                id: $d37c4c3cfd90dfc6$var$rg,
                overflow: $d37c4c3cfd90dfc6$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $d37c4c3cfd90dfc6$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $d37c4c3cfd90dfc6$var$xg = a, $d37c4c3cfd90dfc6$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $d37c4c3cfd90dfc6$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $d37c4c3cfd90dfc6$var$Eg(a) {
    if ($d37c4c3cfd90dfc6$var$I) {
        var b = $d37c4c3cfd90dfc6$var$yg;
        if (b) {
            var c = b;
            if (!$d37c4c3cfd90dfc6$var$Cg(a, b)) {
                if ($d37c4c3cfd90dfc6$var$Dg(a)) throw Error($d37c4c3cfd90dfc6$var$p(418));
                b = $d37c4c3cfd90dfc6$var$Lf(c.nextSibling);
                var d = $d37c4c3cfd90dfc6$var$xg;
                b && $d37c4c3cfd90dfc6$var$Cg(a, b) ? $d37c4c3cfd90dfc6$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $d37c4c3cfd90dfc6$var$I = !1, $d37c4c3cfd90dfc6$var$xg = a);
            }
        } else {
            if ($d37c4c3cfd90dfc6$var$Dg(a)) throw Error($d37c4c3cfd90dfc6$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $d37c4c3cfd90dfc6$var$I = !1;
            $d37c4c3cfd90dfc6$var$xg = a;
        }
    }
}
function $d37c4c3cfd90dfc6$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $d37c4c3cfd90dfc6$var$xg = a;
}
function $d37c4c3cfd90dfc6$var$Gg(a) {
    if (a !== $d37c4c3cfd90dfc6$var$xg) return !1;
    if (!$d37c4c3cfd90dfc6$var$I) return $d37c4c3cfd90dfc6$var$Fg(a), $d37c4c3cfd90dfc6$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$d37c4c3cfd90dfc6$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $d37c4c3cfd90dfc6$var$yg)) {
        if ($d37c4c3cfd90dfc6$var$Dg(a)) throw $d37c4c3cfd90dfc6$var$Hg(), Error($d37c4c3cfd90dfc6$var$p(418));
        for(; b;)$d37c4c3cfd90dfc6$var$Ag(a, b), b = $d37c4c3cfd90dfc6$var$Lf(b.nextSibling);
    }
    $d37c4c3cfd90dfc6$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($d37c4c3cfd90dfc6$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $d37c4c3cfd90dfc6$var$yg = $d37c4c3cfd90dfc6$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $d37c4c3cfd90dfc6$var$yg = null;
        }
    } else $d37c4c3cfd90dfc6$var$yg = $d37c4c3cfd90dfc6$var$xg ? $d37c4c3cfd90dfc6$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $d37c4c3cfd90dfc6$var$Hg() {
    for(var a = $d37c4c3cfd90dfc6$var$yg; a;)a = $d37c4c3cfd90dfc6$var$Lf(a.nextSibling);
}
function $d37c4c3cfd90dfc6$var$Ig() {
    $d37c4c3cfd90dfc6$var$yg = $d37c4c3cfd90dfc6$var$xg = null;
    $d37c4c3cfd90dfc6$var$I = !1;
}
function $d37c4c3cfd90dfc6$var$Jg(a) {
    null === $d37c4c3cfd90dfc6$var$zg ? $d37c4c3cfd90dfc6$var$zg = [
        a
    ] : $d37c4c3cfd90dfc6$var$zg.push(a);
}
var $d37c4c3cfd90dfc6$var$Kg = $d37c4c3cfd90dfc6$var$ua.ReactCurrentBatchConfig;
function $d37c4c3cfd90dfc6$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($d37c4c3cfd90dfc6$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($d37c4c3cfd90dfc6$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($d37c4c3cfd90dfc6$var$p(284));
        if (!c._owner) throw Error($d37c4c3cfd90dfc6$var$p(290, a));
    }
    return a;
}
function $d37c4c3cfd90dfc6$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($d37c4c3cfd90dfc6$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $d37c4c3cfd90dfc6$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $d37c4c3cfd90dfc6$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $d37c4c3cfd90dfc6$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $d37c4c3cfd90dfc6$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $d37c4c3cfd90dfc6$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $d37c4c3cfd90dfc6$var$Ha && $d37c4c3cfd90dfc6$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $d37c4c3cfd90dfc6$var$Lg(a, b, c), d.return = a, d;
        d = $d37c4c3cfd90dfc6$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $d37c4c3cfd90dfc6$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $d37c4c3cfd90dfc6$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $d37c4c3cfd90dfc6$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $d37c4c3cfd90dfc6$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $d37c4c3cfd90dfc6$var$va:
                    return c = $d37c4c3cfd90dfc6$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $d37c4c3cfd90dfc6$var$Lg(a, null, b), c.return = a, c;
                case $d37c4c3cfd90dfc6$var$wa:
                    return b = $d37c4c3cfd90dfc6$var$Sg(b, a.mode, c), b.return = a, b;
                case $d37c4c3cfd90dfc6$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($d37c4c3cfd90dfc6$var$eb(b) || $d37c4c3cfd90dfc6$var$Ka(b)) return b = $d37c4c3cfd90dfc6$var$Tg(b, a.mode, c, null), b.return = a, b;
            $d37c4c3cfd90dfc6$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $d37c4c3cfd90dfc6$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $d37c4c3cfd90dfc6$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $d37c4c3cfd90dfc6$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($d37c4c3cfd90dfc6$var$eb(c) || $d37c4c3cfd90dfc6$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $d37c4c3cfd90dfc6$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $d37c4c3cfd90dfc6$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $d37c4c3cfd90dfc6$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $d37c4c3cfd90dfc6$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($d37c4c3cfd90dfc6$var$eb(d) || $d37c4c3cfd90dfc6$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $d37c4c3cfd90dfc6$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $d37c4c3cfd90dfc6$var$I && $d37c4c3cfd90dfc6$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $d37c4c3cfd90dfc6$var$I && $d37c4c3cfd90dfc6$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $d37c4c3cfd90dfc6$var$I && $d37c4c3cfd90dfc6$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $d37c4c3cfd90dfc6$var$Ka(h);
        if ("function" !== typeof l) throw Error($d37c4c3cfd90dfc6$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($d37c4c3cfd90dfc6$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $d37c4c3cfd90dfc6$var$I && $d37c4c3cfd90dfc6$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $d37c4c3cfd90dfc6$var$I && $d37c4c3cfd90dfc6$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $d37c4c3cfd90dfc6$var$I && $d37c4c3cfd90dfc6$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $d37c4c3cfd90dfc6$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $d37c4c3cfd90dfc6$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $d37c4c3cfd90dfc6$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $d37c4c3cfd90dfc6$var$Ha && $d37c4c3cfd90dfc6$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $d37c4c3cfd90dfc6$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $d37c4c3cfd90dfc6$var$ya ? (d = $d37c4c3cfd90dfc6$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $d37c4c3cfd90dfc6$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $d37c4c3cfd90dfc6$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $d37c4c3cfd90dfc6$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $d37c4c3cfd90dfc6$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $d37c4c3cfd90dfc6$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($d37c4c3cfd90dfc6$var$eb(f)) return n(a, d, f, h);
            if ($d37c4c3cfd90dfc6$var$Ka(f)) return t(a, d, f, h);
            $d37c4c3cfd90dfc6$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $d37c4c3cfd90dfc6$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $d37c4c3cfd90dfc6$var$Ug = $d37c4c3cfd90dfc6$var$Og(!0), $d37c4c3cfd90dfc6$var$Vg = $d37c4c3cfd90dfc6$var$Og(!1), $d37c4c3cfd90dfc6$var$Wg = $d37c4c3cfd90dfc6$var$Uf(null), $d37c4c3cfd90dfc6$var$Xg = null, $d37c4c3cfd90dfc6$var$Yg = null, $d37c4c3cfd90dfc6$var$Zg = null;
function $d37c4c3cfd90dfc6$var$$g() {
    $d37c4c3cfd90dfc6$var$Zg = $d37c4c3cfd90dfc6$var$Yg = $d37c4c3cfd90dfc6$var$Xg = null;
}
function $d37c4c3cfd90dfc6$var$ah(a) {
    var b = $d37c4c3cfd90dfc6$var$Wg.current;
    $d37c4c3cfd90dfc6$var$E($d37c4c3cfd90dfc6$var$Wg);
    a._currentValue = b;
}
function $d37c4c3cfd90dfc6$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $d37c4c3cfd90dfc6$var$ch(a, b) {
    $d37c4c3cfd90dfc6$var$Xg = a;
    $d37c4c3cfd90dfc6$var$Zg = $d37c4c3cfd90dfc6$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($d37c4c3cfd90dfc6$var$dh = !0), a.firstContext = null);
}
function $d37c4c3cfd90dfc6$var$eh(a) {
    var b = a._currentValue;
    if ($d37c4c3cfd90dfc6$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $d37c4c3cfd90dfc6$var$Yg) {
            if (null === $d37c4c3cfd90dfc6$var$Xg) throw Error($d37c4c3cfd90dfc6$var$p(308));
            $d37c4c3cfd90dfc6$var$Yg = a;
            $d37c4c3cfd90dfc6$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $d37c4c3cfd90dfc6$var$Yg = $d37c4c3cfd90dfc6$var$Yg.next = a;
    }
    return b;
}
var $d37c4c3cfd90dfc6$var$fh = null;
function $d37c4c3cfd90dfc6$var$gh(a) {
    null === $d37c4c3cfd90dfc6$var$fh ? $d37c4c3cfd90dfc6$var$fh = [
        a
    ] : $d37c4c3cfd90dfc6$var$fh.push(a);
}
function $d37c4c3cfd90dfc6$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $d37c4c3cfd90dfc6$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $d37c4c3cfd90dfc6$var$ih(a, d);
}
function $d37c4c3cfd90dfc6$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $d37c4c3cfd90dfc6$var$jh = !1;
function $d37c4c3cfd90dfc6$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $d37c4c3cfd90dfc6$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $d37c4c3cfd90dfc6$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $d37c4c3cfd90dfc6$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($d37c4c3cfd90dfc6$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $d37c4c3cfd90dfc6$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $d37c4c3cfd90dfc6$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $d37c4c3cfd90dfc6$var$ih(a, c);
}
function $d37c4c3cfd90dfc6$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $d37c4c3cfd90dfc6$var$Cc(a, c);
    }
}
function $d37c4c3cfd90dfc6$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $d37c4c3cfd90dfc6$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $d37c4c3cfd90dfc6$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $d37c4c3cfd90dfc6$var$A({}, q, r);
                            break a;
                        case 2:
                            $d37c4c3cfd90dfc6$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $d37c4c3cfd90dfc6$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $d37c4c3cfd90dfc6$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($d37c4c3cfd90dfc6$var$p(191, e));
            e.call(d);
        }
    }
}
var $d37c4c3cfd90dfc6$var$th = {}, $d37c4c3cfd90dfc6$var$uh = $d37c4c3cfd90dfc6$var$Uf($d37c4c3cfd90dfc6$var$th), $d37c4c3cfd90dfc6$var$vh = $d37c4c3cfd90dfc6$var$Uf($d37c4c3cfd90dfc6$var$th), $d37c4c3cfd90dfc6$var$wh = $d37c4c3cfd90dfc6$var$Uf($d37c4c3cfd90dfc6$var$th);
function $d37c4c3cfd90dfc6$var$xh(a) {
    if (a === $d37c4c3cfd90dfc6$var$th) throw Error($d37c4c3cfd90dfc6$var$p(174));
    return a;
}
function $d37c4c3cfd90dfc6$var$yh(a, b) {
    $d37c4c3cfd90dfc6$var$G($d37c4c3cfd90dfc6$var$wh, b);
    $d37c4c3cfd90dfc6$var$G($d37c4c3cfd90dfc6$var$vh, a);
    $d37c4c3cfd90dfc6$var$G($d37c4c3cfd90dfc6$var$uh, $d37c4c3cfd90dfc6$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $d37c4c3cfd90dfc6$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $d37c4c3cfd90dfc6$var$lb(b, a);
    }
    $d37c4c3cfd90dfc6$var$E($d37c4c3cfd90dfc6$var$uh);
    $d37c4c3cfd90dfc6$var$G($d37c4c3cfd90dfc6$var$uh, b);
}
function $d37c4c3cfd90dfc6$var$zh() {
    $d37c4c3cfd90dfc6$var$E($d37c4c3cfd90dfc6$var$uh);
    $d37c4c3cfd90dfc6$var$E($d37c4c3cfd90dfc6$var$vh);
    $d37c4c3cfd90dfc6$var$E($d37c4c3cfd90dfc6$var$wh);
}
function $d37c4c3cfd90dfc6$var$Ah(a) {
    $d37c4c3cfd90dfc6$var$xh($d37c4c3cfd90dfc6$var$wh.current);
    var b = $d37c4c3cfd90dfc6$var$xh($d37c4c3cfd90dfc6$var$uh.current);
    var c = $d37c4c3cfd90dfc6$var$lb(b, a.type);
    b !== c && ($d37c4c3cfd90dfc6$var$G($d37c4c3cfd90dfc6$var$vh, a), $d37c4c3cfd90dfc6$var$G($d37c4c3cfd90dfc6$var$uh, c));
}
function $d37c4c3cfd90dfc6$var$Bh(a) {
    $d37c4c3cfd90dfc6$var$vh.current === a && ($d37c4c3cfd90dfc6$var$E($d37c4c3cfd90dfc6$var$uh), $d37c4c3cfd90dfc6$var$E($d37c4c3cfd90dfc6$var$vh));
}
var $d37c4c3cfd90dfc6$var$L = $d37c4c3cfd90dfc6$var$Uf(0);
function $d37c4c3cfd90dfc6$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $d37c4c3cfd90dfc6$var$Dh = [];
function $d37c4c3cfd90dfc6$var$Eh() {
    for(var a = 0; a < $d37c4c3cfd90dfc6$var$Dh.length; a++)$d37c4c3cfd90dfc6$var$Dh[a]._workInProgressVersionPrimary = null;
    $d37c4c3cfd90dfc6$var$Dh.length = 0;
}
var $d37c4c3cfd90dfc6$var$Fh = $d37c4c3cfd90dfc6$var$ua.ReactCurrentDispatcher, $d37c4c3cfd90dfc6$var$Gh = $d37c4c3cfd90dfc6$var$ua.ReactCurrentBatchConfig, $d37c4c3cfd90dfc6$var$Hh = 0, $d37c4c3cfd90dfc6$var$M = null, $d37c4c3cfd90dfc6$var$N = null, $d37c4c3cfd90dfc6$var$O = null, $d37c4c3cfd90dfc6$var$Ih = !1, $d37c4c3cfd90dfc6$var$Jh = !1, $d37c4c3cfd90dfc6$var$Kh = 0, $d37c4c3cfd90dfc6$var$Lh = 0;
function $d37c4c3cfd90dfc6$var$P() {
    throw Error($d37c4c3cfd90dfc6$var$p(321));
}
function $d37c4c3cfd90dfc6$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$d37c4c3cfd90dfc6$var$He(a[c], b[c])) return !1;
    return !0;
}
function $d37c4c3cfd90dfc6$var$Nh(a, b, c, d, e, f) {
    $d37c4c3cfd90dfc6$var$Hh = f;
    $d37c4c3cfd90dfc6$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $d37c4c3cfd90dfc6$var$Fh.current = null === a || null === a.memoizedState ? $d37c4c3cfd90dfc6$var$Oh : $d37c4c3cfd90dfc6$var$Ph;
    a = c(d, e);
    if ($d37c4c3cfd90dfc6$var$Jh) {
        f = 0;
        do {
            $d37c4c3cfd90dfc6$var$Jh = !1;
            $d37c4c3cfd90dfc6$var$Kh = 0;
            if (25 <= f) throw Error($d37c4c3cfd90dfc6$var$p(301));
            f += 1;
            $d37c4c3cfd90dfc6$var$O = $d37c4c3cfd90dfc6$var$N = null;
            b.updateQueue = null;
            $d37c4c3cfd90dfc6$var$Fh.current = $d37c4c3cfd90dfc6$var$Qh;
            a = c(d, e);
        }while ($d37c4c3cfd90dfc6$var$Jh);
    }
    $d37c4c3cfd90dfc6$var$Fh.current = $d37c4c3cfd90dfc6$var$Rh;
    b = null !== $d37c4c3cfd90dfc6$var$N && null !== $d37c4c3cfd90dfc6$var$N.next;
    $d37c4c3cfd90dfc6$var$Hh = 0;
    $d37c4c3cfd90dfc6$var$O = $d37c4c3cfd90dfc6$var$N = $d37c4c3cfd90dfc6$var$M = null;
    $d37c4c3cfd90dfc6$var$Ih = !1;
    if (b) throw Error($d37c4c3cfd90dfc6$var$p(300));
    return a;
}
function $d37c4c3cfd90dfc6$var$Sh() {
    var a = 0 !== $d37c4c3cfd90dfc6$var$Kh;
    $d37c4c3cfd90dfc6$var$Kh = 0;
    return a;
}
function $d37c4c3cfd90dfc6$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $d37c4c3cfd90dfc6$var$O ? $d37c4c3cfd90dfc6$var$M.memoizedState = $d37c4c3cfd90dfc6$var$O = a : $d37c4c3cfd90dfc6$var$O = $d37c4c3cfd90dfc6$var$O.next = a;
    return $d37c4c3cfd90dfc6$var$O;
}
function $d37c4c3cfd90dfc6$var$Uh() {
    if (null === $d37c4c3cfd90dfc6$var$N) {
        var a = $d37c4c3cfd90dfc6$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $d37c4c3cfd90dfc6$var$N.next;
    var b = null === $d37c4c3cfd90dfc6$var$O ? $d37c4c3cfd90dfc6$var$M.memoizedState : $d37c4c3cfd90dfc6$var$O.next;
    if (null !== b) $d37c4c3cfd90dfc6$var$O = b, $d37c4c3cfd90dfc6$var$N = a;
    else {
        if (null === a) throw Error($d37c4c3cfd90dfc6$var$p(310));
        $d37c4c3cfd90dfc6$var$N = a;
        a = {
            memoizedState: $d37c4c3cfd90dfc6$var$N.memoizedState,
            baseState: $d37c4c3cfd90dfc6$var$N.baseState,
            baseQueue: $d37c4c3cfd90dfc6$var$N.baseQueue,
            queue: $d37c4c3cfd90dfc6$var$N.queue,
            next: null
        };
        null === $d37c4c3cfd90dfc6$var$O ? $d37c4c3cfd90dfc6$var$M.memoizedState = $d37c4c3cfd90dfc6$var$O = a : $d37c4c3cfd90dfc6$var$O = $d37c4c3cfd90dfc6$var$O.next = a;
    }
    return $d37c4c3cfd90dfc6$var$O;
}
function $d37c4c3cfd90dfc6$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $d37c4c3cfd90dfc6$var$Wh(a) {
    var b = $d37c4c3cfd90dfc6$var$Uh(), c = b.queue;
    if (null === c) throw Error($d37c4c3cfd90dfc6$var$p(311));
    c.lastRenderedReducer = a;
    var d = $d37c4c3cfd90dfc6$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($d37c4c3cfd90dfc6$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $d37c4c3cfd90dfc6$var$M.lanes |= m;
                $d37c4c3cfd90dfc6$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $d37c4c3cfd90dfc6$var$He(d, b.memoizedState) || ($d37c4c3cfd90dfc6$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $d37c4c3cfd90dfc6$var$M.lanes |= f, $d37c4c3cfd90dfc6$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $d37c4c3cfd90dfc6$var$Xh(a) {
    var b = $d37c4c3cfd90dfc6$var$Uh(), c = b.queue;
    if (null === c) throw Error($d37c4c3cfd90dfc6$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $d37c4c3cfd90dfc6$var$He(f, b.memoizedState) || ($d37c4c3cfd90dfc6$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $d37c4c3cfd90dfc6$var$Yh() {}
function $d37c4c3cfd90dfc6$var$Zh(a, b) {
    var c = $d37c4c3cfd90dfc6$var$M, d = $d37c4c3cfd90dfc6$var$Uh(), e = b(), f = !$d37c4c3cfd90dfc6$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $d37c4c3cfd90dfc6$var$dh = !0);
    d = d.queue;
    $d37c4c3cfd90dfc6$var$$h($d37c4c3cfd90dfc6$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $d37c4c3cfd90dfc6$var$O && $d37c4c3cfd90dfc6$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $d37c4c3cfd90dfc6$var$bi(9, $d37c4c3cfd90dfc6$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $d37c4c3cfd90dfc6$var$Q) throw Error($d37c4c3cfd90dfc6$var$p(349));
        0 !== ($d37c4c3cfd90dfc6$var$Hh & 30) || $d37c4c3cfd90dfc6$var$di(c, b, e);
    }
    return e;
}
function $d37c4c3cfd90dfc6$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $d37c4c3cfd90dfc6$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $d37c4c3cfd90dfc6$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $d37c4c3cfd90dfc6$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $d37c4c3cfd90dfc6$var$ei(b) && $d37c4c3cfd90dfc6$var$fi(a);
}
function $d37c4c3cfd90dfc6$var$ai(a, b, c) {
    return c(function() {
        $d37c4c3cfd90dfc6$var$ei(b) && $d37c4c3cfd90dfc6$var$fi(a);
    });
}
function $d37c4c3cfd90dfc6$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$d37c4c3cfd90dfc6$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $d37c4c3cfd90dfc6$var$fi(a) {
    var b = $d37c4c3cfd90dfc6$var$ih(a, 1);
    null !== b && $d37c4c3cfd90dfc6$var$gi(b, a, 1, -1);
}
function $d37c4c3cfd90dfc6$var$hi(a) {
    var b = $d37c4c3cfd90dfc6$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $d37c4c3cfd90dfc6$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $d37c4c3cfd90dfc6$var$ii.bind(null, $d37c4c3cfd90dfc6$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $d37c4c3cfd90dfc6$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $d37c4c3cfd90dfc6$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $d37c4c3cfd90dfc6$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $d37c4c3cfd90dfc6$var$ji() {
    return $d37c4c3cfd90dfc6$var$Uh().memoizedState;
}
function $d37c4c3cfd90dfc6$var$ki(a, b, c, d) {
    var e = $d37c4c3cfd90dfc6$var$Th();
    $d37c4c3cfd90dfc6$var$M.flags |= a;
    e.memoizedState = $d37c4c3cfd90dfc6$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $d37c4c3cfd90dfc6$var$li(a, b, c, d) {
    var e = $d37c4c3cfd90dfc6$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $d37c4c3cfd90dfc6$var$N) {
        var g = $d37c4c3cfd90dfc6$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $d37c4c3cfd90dfc6$var$Mh(d, g.deps)) {
            e.memoizedState = $d37c4c3cfd90dfc6$var$bi(b, c, f, d);
            return;
        }
    }
    $d37c4c3cfd90dfc6$var$M.flags |= a;
    e.memoizedState = $d37c4c3cfd90dfc6$var$bi(1 | b, c, f, d);
}
function $d37c4c3cfd90dfc6$var$mi(a, b) {
    return $d37c4c3cfd90dfc6$var$ki(8390656, 8, a, b);
}
function $d37c4c3cfd90dfc6$var$$h(a, b) {
    return $d37c4c3cfd90dfc6$var$li(2048, 8, a, b);
}
function $d37c4c3cfd90dfc6$var$ni(a, b) {
    return $d37c4c3cfd90dfc6$var$li(4, 2, a, b);
}
function $d37c4c3cfd90dfc6$var$oi(a, b) {
    return $d37c4c3cfd90dfc6$var$li(4, 4, a, b);
}
function $d37c4c3cfd90dfc6$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $d37c4c3cfd90dfc6$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $d37c4c3cfd90dfc6$var$li(4, 4, $d37c4c3cfd90dfc6$var$pi.bind(null, b, a), c);
}
function $d37c4c3cfd90dfc6$var$ri() {}
function $d37c4c3cfd90dfc6$var$si(a, b) {
    var c = $d37c4c3cfd90dfc6$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $d37c4c3cfd90dfc6$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $d37c4c3cfd90dfc6$var$ti(a, b) {
    var c = $d37c4c3cfd90dfc6$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $d37c4c3cfd90dfc6$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $d37c4c3cfd90dfc6$var$ui(a, b, c) {
    if (0 === ($d37c4c3cfd90dfc6$var$Hh & 21)) return a.baseState && (a.baseState = !1, $d37c4c3cfd90dfc6$var$dh = !0), a.memoizedState = c;
    $d37c4c3cfd90dfc6$var$He(c, b) || (c = $d37c4c3cfd90dfc6$var$yc(), $d37c4c3cfd90dfc6$var$M.lanes |= c, $d37c4c3cfd90dfc6$var$rh |= c, a.baseState = !0);
    return b;
}
function $d37c4c3cfd90dfc6$var$vi(a, b) {
    var c = $d37c4c3cfd90dfc6$var$C;
    $d37c4c3cfd90dfc6$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $d37c4c3cfd90dfc6$var$Gh.transition;
    $d37c4c3cfd90dfc6$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $d37c4c3cfd90dfc6$var$C = c, $d37c4c3cfd90dfc6$var$Gh.transition = d;
    }
}
function $d37c4c3cfd90dfc6$var$wi() {
    return $d37c4c3cfd90dfc6$var$Uh().memoizedState;
}
function $d37c4c3cfd90dfc6$var$xi(a, b, c) {
    var d = $d37c4c3cfd90dfc6$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($d37c4c3cfd90dfc6$var$zi(a)) $d37c4c3cfd90dfc6$var$Ai(b, c);
    else if (c = $d37c4c3cfd90dfc6$var$hh(a, b, c, d), null !== c) {
        var e = $d37c4c3cfd90dfc6$var$R();
        $d37c4c3cfd90dfc6$var$gi(c, a, d, e);
        $d37c4c3cfd90dfc6$var$Bi(c, b, d);
    }
}
function $d37c4c3cfd90dfc6$var$ii(a, b, c) {
    var d = $d37c4c3cfd90dfc6$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($d37c4c3cfd90dfc6$var$zi(a)) $d37c4c3cfd90dfc6$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($d37c4c3cfd90dfc6$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $d37c4c3cfd90dfc6$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $d37c4c3cfd90dfc6$var$hh(a, b, e, d);
        null !== c && (e = $d37c4c3cfd90dfc6$var$R(), $d37c4c3cfd90dfc6$var$gi(c, a, d, e), $d37c4c3cfd90dfc6$var$Bi(c, b, d));
    }
}
function $d37c4c3cfd90dfc6$var$zi(a) {
    var b = a.alternate;
    return a === $d37c4c3cfd90dfc6$var$M || null !== b && b === $d37c4c3cfd90dfc6$var$M;
}
function $d37c4c3cfd90dfc6$var$Ai(a, b) {
    $d37c4c3cfd90dfc6$var$Jh = $d37c4c3cfd90dfc6$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $d37c4c3cfd90dfc6$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $d37c4c3cfd90dfc6$var$Cc(a, c);
    }
}
var $d37c4c3cfd90dfc6$var$Rh = {
    readContext: $d37c4c3cfd90dfc6$var$eh,
    useCallback: $d37c4c3cfd90dfc6$var$P,
    useContext: $d37c4c3cfd90dfc6$var$P,
    useEffect: $d37c4c3cfd90dfc6$var$P,
    useImperativeHandle: $d37c4c3cfd90dfc6$var$P,
    useInsertionEffect: $d37c4c3cfd90dfc6$var$P,
    useLayoutEffect: $d37c4c3cfd90dfc6$var$P,
    useMemo: $d37c4c3cfd90dfc6$var$P,
    useReducer: $d37c4c3cfd90dfc6$var$P,
    useRef: $d37c4c3cfd90dfc6$var$P,
    useState: $d37c4c3cfd90dfc6$var$P,
    useDebugValue: $d37c4c3cfd90dfc6$var$P,
    useDeferredValue: $d37c4c3cfd90dfc6$var$P,
    useTransition: $d37c4c3cfd90dfc6$var$P,
    useMutableSource: $d37c4c3cfd90dfc6$var$P,
    useSyncExternalStore: $d37c4c3cfd90dfc6$var$P,
    useId: $d37c4c3cfd90dfc6$var$P,
    unstable_isNewReconciler: !1
}, $d37c4c3cfd90dfc6$var$Oh = {
    readContext: $d37c4c3cfd90dfc6$var$eh,
    useCallback: function(a, b) {
        $d37c4c3cfd90dfc6$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $d37c4c3cfd90dfc6$var$eh,
    useEffect: $d37c4c3cfd90dfc6$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $d37c4c3cfd90dfc6$var$ki(4194308, 4, $d37c4c3cfd90dfc6$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $d37c4c3cfd90dfc6$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $d37c4c3cfd90dfc6$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $d37c4c3cfd90dfc6$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $d37c4c3cfd90dfc6$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $d37c4c3cfd90dfc6$var$xi.bind(null, $d37c4c3cfd90dfc6$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $d37c4c3cfd90dfc6$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $d37c4c3cfd90dfc6$var$hi,
    useDebugValue: $d37c4c3cfd90dfc6$var$ri,
    useDeferredValue: function(a) {
        return $d37c4c3cfd90dfc6$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $d37c4c3cfd90dfc6$var$hi(!1), b = a[0];
        a = $d37c4c3cfd90dfc6$var$vi.bind(null, a[1]);
        $d37c4c3cfd90dfc6$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $d37c4c3cfd90dfc6$var$M, e = $d37c4c3cfd90dfc6$var$Th();
        if ($d37c4c3cfd90dfc6$var$I) {
            if (void 0 === c) throw Error($d37c4c3cfd90dfc6$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $d37c4c3cfd90dfc6$var$Q) throw Error($d37c4c3cfd90dfc6$var$p(349));
            0 !== ($d37c4c3cfd90dfc6$var$Hh & 30) || $d37c4c3cfd90dfc6$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $d37c4c3cfd90dfc6$var$mi($d37c4c3cfd90dfc6$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $d37c4c3cfd90dfc6$var$bi(9, $d37c4c3cfd90dfc6$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $d37c4c3cfd90dfc6$var$Th(), b = $d37c4c3cfd90dfc6$var$Q.identifierPrefix;
        if ($d37c4c3cfd90dfc6$var$I) {
            var c = $d37c4c3cfd90dfc6$var$sg;
            var d = $d37c4c3cfd90dfc6$var$rg;
            c = (d & ~(1 << 32 - $d37c4c3cfd90dfc6$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $d37c4c3cfd90dfc6$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $d37c4c3cfd90dfc6$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $d37c4c3cfd90dfc6$var$Ph = {
    readContext: $d37c4c3cfd90dfc6$var$eh,
    useCallback: $d37c4c3cfd90dfc6$var$si,
    useContext: $d37c4c3cfd90dfc6$var$eh,
    useEffect: $d37c4c3cfd90dfc6$var$$h,
    useImperativeHandle: $d37c4c3cfd90dfc6$var$qi,
    useInsertionEffect: $d37c4c3cfd90dfc6$var$ni,
    useLayoutEffect: $d37c4c3cfd90dfc6$var$oi,
    useMemo: $d37c4c3cfd90dfc6$var$ti,
    useReducer: $d37c4c3cfd90dfc6$var$Wh,
    useRef: $d37c4c3cfd90dfc6$var$ji,
    useState: function() {
        return $d37c4c3cfd90dfc6$var$Wh($d37c4c3cfd90dfc6$var$Vh);
    },
    useDebugValue: $d37c4c3cfd90dfc6$var$ri,
    useDeferredValue: function(a) {
        var b = $d37c4c3cfd90dfc6$var$Uh();
        return $d37c4c3cfd90dfc6$var$ui(b, $d37c4c3cfd90dfc6$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $d37c4c3cfd90dfc6$var$Wh($d37c4c3cfd90dfc6$var$Vh)[0], b = $d37c4c3cfd90dfc6$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $d37c4c3cfd90dfc6$var$Yh,
    useSyncExternalStore: $d37c4c3cfd90dfc6$var$Zh,
    useId: $d37c4c3cfd90dfc6$var$wi,
    unstable_isNewReconciler: !1
}, $d37c4c3cfd90dfc6$var$Qh = {
    readContext: $d37c4c3cfd90dfc6$var$eh,
    useCallback: $d37c4c3cfd90dfc6$var$si,
    useContext: $d37c4c3cfd90dfc6$var$eh,
    useEffect: $d37c4c3cfd90dfc6$var$$h,
    useImperativeHandle: $d37c4c3cfd90dfc6$var$qi,
    useInsertionEffect: $d37c4c3cfd90dfc6$var$ni,
    useLayoutEffect: $d37c4c3cfd90dfc6$var$oi,
    useMemo: $d37c4c3cfd90dfc6$var$ti,
    useReducer: $d37c4c3cfd90dfc6$var$Xh,
    useRef: $d37c4c3cfd90dfc6$var$ji,
    useState: function() {
        return $d37c4c3cfd90dfc6$var$Xh($d37c4c3cfd90dfc6$var$Vh);
    },
    useDebugValue: $d37c4c3cfd90dfc6$var$ri,
    useDeferredValue: function(a) {
        var b = $d37c4c3cfd90dfc6$var$Uh();
        return null === $d37c4c3cfd90dfc6$var$N ? b.memoizedState = a : $d37c4c3cfd90dfc6$var$ui(b, $d37c4c3cfd90dfc6$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $d37c4c3cfd90dfc6$var$Xh($d37c4c3cfd90dfc6$var$Vh)[0], b = $d37c4c3cfd90dfc6$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $d37c4c3cfd90dfc6$var$Yh,
    useSyncExternalStore: $d37c4c3cfd90dfc6$var$Zh,
    useId: $d37c4c3cfd90dfc6$var$wi,
    unstable_isNewReconciler: !1
};
function $d37c4c3cfd90dfc6$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $d37c4c3cfd90dfc6$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $d37c4c3cfd90dfc6$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $d37c4c3cfd90dfc6$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $d37c4c3cfd90dfc6$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $d37c4c3cfd90dfc6$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $d37c4c3cfd90dfc6$var$R(), e = $d37c4c3cfd90dfc6$var$yi(a), f = $d37c4c3cfd90dfc6$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $d37c4c3cfd90dfc6$var$nh(a, f, e);
        null !== b && ($d37c4c3cfd90dfc6$var$gi(b, a, e, d), $d37c4c3cfd90dfc6$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $d37c4c3cfd90dfc6$var$R(), e = $d37c4c3cfd90dfc6$var$yi(a), f = $d37c4c3cfd90dfc6$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $d37c4c3cfd90dfc6$var$nh(a, f, e);
        null !== b && ($d37c4c3cfd90dfc6$var$gi(b, a, e, d), $d37c4c3cfd90dfc6$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $d37c4c3cfd90dfc6$var$R(), d = $d37c4c3cfd90dfc6$var$yi(a), e = $d37c4c3cfd90dfc6$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $d37c4c3cfd90dfc6$var$nh(a, e, d);
        null !== b && ($d37c4c3cfd90dfc6$var$gi(b, a, d, c), $d37c4c3cfd90dfc6$var$oh(b, a, d));
    }
};
function $d37c4c3cfd90dfc6$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$d37c4c3cfd90dfc6$var$Ie(c, d) || !$d37c4c3cfd90dfc6$var$Ie(e, f) : !0;
}
function $d37c4c3cfd90dfc6$var$Gi(a, b, c) {
    var d = !1, e = $d37c4c3cfd90dfc6$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $d37c4c3cfd90dfc6$var$eh(f) : (e = $d37c4c3cfd90dfc6$var$Zf(b) ? $d37c4c3cfd90dfc6$var$Xf : $d37c4c3cfd90dfc6$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $d37c4c3cfd90dfc6$var$Yf(a, e) : $d37c4c3cfd90dfc6$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $d37c4c3cfd90dfc6$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $d37c4c3cfd90dfc6$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $d37c4c3cfd90dfc6$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $d37c4c3cfd90dfc6$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $d37c4c3cfd90dfc6$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $d37c4c3cfd90dfc6$var$eh(f) : (f = $d37c4c3cfd90dfc6$var$Zf(b) ? $d37c4c3cfd90dfc6$var$Xf : $d37c4c3cfd90dfc6$var$H.current, e.context = $d37c4c3cfd90dfc6$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($d37c4c3cfd90dfc6$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $d37c4c3cfd90dfc6$var$Ei.enqueueReplaceState(e, e.state, null), $d37c4c3cfd90dfc6$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $d37c4c3cfd90dfc6$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $d37c4c3cfd90dfc6$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $d37c4c3cfd90dfc6$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $d37c4c3cfd90dfc6$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $d37c4c3cfd90dfc6$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $d37c4c3cfd90dfc6$var$Ni(a, b, c) {
    c = $d37c4c3cfd90dfc6$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $d37c4c3cfd90dfc6$var$Oi || ($d37c4c3cfd90dfc6$var$Oi = !0, $d37c4c3cfd90dfc6$var$Pi = d);
        $d37c4c3cfd90dfc6$var$Li(a, b);
    };
    return c;
}
function $d37c4c3cfd90dfc6$var$Qi(a, b, c) {
    c = $d37c4c3cfd90dfc6$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $d37c4c3cfd90dfc6$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $d37c4c3cfd90dfc6$var$Li(a, b);
        "function" !== typeof d && (null === $d37c4c3cfd90dfc6$var$Ri ? $d37c4c3cfd90dfc6$var$Ri = new Set([
            this
        ]) : $d37c4c3cfd90dfc6$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $d37c4c3cfd90dfc6$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $d37c4c3cfd90dfc6$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $d37c4c3cfd90dfc6$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $d37c4c3cfd90dfc6$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $d37c4c3cfd90dfc6$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $d37c4c3cfd90dfc6$var$mh(-1, 1), b.tag = 2, $d37c4c3cfd90dfc6$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $d37c4c3cfd90dfc6$var$Wi = $d37c4c3cfd90dfc6$var$ua.ReactCurrentOwner, $d37c4c3cfd90dfc6$var$dh = !1;
function $d37c4c3cfd90dfc6$var$Xi(a, b, c, d) {
    b.child = null === a ? $d37c4c3cfd90dfc6$var$Vg(b, null, c, d) : $d37c4c3cfd90dfc6$var$Ug(b, a.child, c, d);
}
function $d37c4c3cfd90dfc6$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $d37c4c3cfd90dfc6$var$ch(b, e);
    d = $d37c4c3cfd90dfc6$var$Nh(a, b, c, d, f, e);
    c = $d37c4c3cfd90dfc6$var$Sh();
    if (null !== a && !$d37c4c3cfd90dfc6$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $d37c4c3cfd90dfc6$var$Zi(a, b, e);
    $d37c4c3cfd90dfc6$var$I && c && $d37c4c3cfd90dfc6$var$vg(b);
    b.flags |= 1;
    $d37c4c3cfd90dfc6$var$Xi(a, b, d, e);
    return b.child;
}
function $d37c4c3cfd90dfc6$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$d37c4c3cfd90dfc6$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $d37c4c3cfd90dfc6$var$bj(a, b, f, d, e);
        a = $d37c4c3cfd90dfc6$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $d37c4c3cfd90dfc6$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $d37c4c3cfd90dfc6$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $d37c4c3cfd90dfc6$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $d37c4c3cfd90dfc6$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($d37c4c3cfd90dfc6$var$Ie(f, d) && a.ref === b.ref) {
            if ($d37c4c3cfd90dfc6$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($d37c4c3cfd90dfc6$var$dh = !0);
            else return b.lanes = a.lanes, $d37c4c3cfd90dfc6$var$Zi(a, b, e);
        }
    }
    return $d37c4c3cfd90dfc6$var$cj(a, b, c, d, e);
}
function $d37c4c3cfd90dfc6$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $d37c4c3cfd90dfc6$var$G($d37c4c3cfd90dfc6$var$ej, $d37c4c3cfd90dfc6$var$fj), $d37c4c3cfd90dfc6$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $d37c4c3cfd90dfc6$var$G($d37c4c3cfd90dfc6$var$ej, $d37c4c3cfd90dfc6$var$fj), $d37c4c3cfd90dfc6$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $d37c4c3cfd90dfc6$var$G($d37c4c3cfd90dfc6$var$ej, $d37c4c3cfd90dfc6$var$fj);
            $d37c4c3cfd90dfc6$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $d37c4c3cfd90dfc6$var$G($d37c4c3cfd90dfc6$var$ej, $d37c4c3cfd90dfc6$var$fj), $d37c4c3cfd90dfc6$var$fj |= d;
    $d37c4c3cfd90dfc6$var$Xi(a, b, e, c);
    return b.child;
}
function $d37c4c3cfd90dfc6$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $d37c4c3cfd90dfc6$var$cj(a, b, c, d, e) {
    var f = $d37c4c3cfd90dfc6$var$Zf(c) ? $d37c4c3cfd90dfc6$var$Xf : $d37c4c3cfd90dfc6$var$H.current;
    f = $d37c4c3cfd90dfc6$var$Yf(b, f);
    $d37c4c3cfd90dfc6$var$ch(b, e);
    c = $d37c4c3cfd90dfc6$var$Nh(a, b, c, d, f, e);
    d = $d37c4c3cfd90dfc6$var$Sh();
    if (null !== a && !$d37c4c3cfd90dfc6$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $d37c4c3cfd90dfc6$var$Zi(a, b, e);
    $d37c4c3cfd90dfc6$var$I && d && $d37c4c3cfd90dfc6$var$vg(b);
    b.flags |= 1;
    $d37c4c3cfd90dfc6$var$Xi(a, b, c, e);
    return b.child;
}
function $d37c4c3cfd90dfc6$var$hj(a, b, c, d, e) {
    if ($d37c4c3cfd90dfc6$var$Zf(c)) {
        var f = !0;
        $d37c4c3cfd90dfc6$var$cg(b);
    } else f = !1;
    $d37c4c3cfd90dfc6$var$ch(b, e);
    if (null === b.stateNode) $d37c4c3cfd90dfc6$var$ij(a, b), $d37c4c3cfd90dfc6$var$Gi(b, c, d), $d37c4c3cfd90dfc6$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $d37c4c3cfd90dfc6$var$eh(l) : (l = $d37c4c3cfd90dfc6$var$Zf(c) ? $d37c4c3cfd90dfc6$var$Xf : $d37c4c3cfd90dfc6$var$H.current, l = $d37c4c3cfd90dfc6$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $d37c4c3cfd90dfc6$var$Hi(b, g, d, l);
        $d37c4c3cfd90dfc6$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $d37c4c3cfd90dfc6$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $d37c4c3cfd90dfc6$var$Wf.current || $d37c4c3cfd90dfc6$var$jh ? ("function" === typeof m && ($d37c4c3cfd90dfc6$var$Di(b, c, m, d), k = b.memoizedState), (h = $d37c4c3cfd90dfc6$var$jh || $d37c4c3cfd90dfc6$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $d37c4c3cfd90dfc6$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $d37c4c3cfd90dfc6$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $d37c4c3cfd90dfc6$var$eh(k) : (k = $d37c4c3cfd90dfc6$var$Zf(c) ? $d37c4c3cfd90dfc6$var$Xf : $d37c4c3cfd90dfc6$var$H.current, k = $d37c4c3cfd90dfc6$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $d37c4c3cfd90dfc6$var$Hi(b, g, d, k);
        $d37c4c3cfd90dfc6$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $d37c4c3cfd90dfc6$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $d37c4c3cfd90dfc6$var$Wf.current || $d37c4c3cfd90dfc6$var$jh ? ("function" === typeof y && ($d37c4c3cfd90dfc6$var$Di(b, c, y, d), n = b.memoizedState), (l = $d37c4c3cfd90dfc6$var$jh || $d37c4c3cfd90dfc6$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $d37c4c3cfd90dfc6$var$jj(a, b, c, d, f, e);
}
function $d37c4c3cfd90dfc6$var$jj(a, b, c, d, e, f) {
    $d37c4c3cfd90dfc6$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $d37c4c3cfd90dfc6$var$dg(b, c, !1), $d37c4c3cfd90dfc6$var$Zi(a, b, f);
    d = b.stateNode;
    $d37c4c3cfd90dfc6$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $d37c4c3cfd90dfc6$var$Ug(b, a.child, null, f), b.child = $d37c4c3cfd90dfc6$var$Ug(b, null, h, f)) : $d37c4c3cfd90dfc6$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $d37c4c3cfd90dfc6$var$dg(b, c, !0);
    return b.child;
}
function $d37c4c3cfd90dfc6$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $d37c4c3cfd90dfc6$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $d37c4c3cfd90dfc6$var$ag(a, b.context, !1);
    $d37c4c3cfd90dfc6$var$yh(a, b.containerInfo);
}
function $d37c4c3cfd90dfc6$var$lj(a, b, c, d, e) {
    $d37c4c3cfd90dfc6$var$Ig();
    $d37c4c3cfd90dfc6$var$Jg(e);
    b.flags |= 256;
    $d37c4c3cfd90dfc6$var$Xi(a, b, c, d);
    return b.child;
}
var $d37c4c3cfd90dfc6$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $d37c4c3cfd90dfc6$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $d37c4c3cfd90dfc6$var$oj(a, b, c) {
    var d = b.pendingProps, e = $d37c4c3cfd90dfc6$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $d37c4c3cfd90dfc6$var$G($d37c4c3cfd90dfc6$var$L, e & 1);
    if (null === a) {
        $d37c4c3cfd90dfc6$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $d37c4c3cfd90dfc6$var$pj(g, d, 0, null), a = $d37c4c3cfd90dfc6$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $d37c4c3cfd90dfc6$var$nj(c), b.memoizedState = $d37c4c3cfd90dfc6$var$mj, a) : $d37c4c3cfd90dfc6$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $d37c4c3cfd90dfc6$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $d37c4c3cfd90dfc6$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $d37c4c3cfd90dfc6$var$Pg(h, f) : (f = $d37c4c3cfd90dfc6$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $d37c4c3cfd90dfc6$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $d37c4c3cfd90dfc6$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $d37c4c3cfd90dfc6$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $d37c4c3cfd90dfc6$var$qj(a, b) {
    b = $d37c4c3cfd90dfc6$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $d37c4c3cfd90dfc6$var$sj(a, b, c, d) {
    null !== d && $d37c4c3cfd90dfc6$var$Jg(d);
    $d37c4c3cfd90dfc6$var$Ug(b, a.child, null, c);
    a = $d37c4c3cfd90dfc6$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $d37c4c3cfd90dfc6$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $d37c4c3cfd90dfc6$var$Ki(Error($d37c4c3cfd90dfc6$var$p(422))), $d37c4c3cfd90dfc6$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $d37c4c3cfd90dfc6$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $d37c4c3cfd90dfc6$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $d37c4c3cfd90dfc6$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $d37c4c3cfd90dfc6$var$nj(g);
        b.memoizedState = $d37c4c3cfd90dfc6$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $d37c4c3cfd90dfc6$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($d37c4c3cfd90dfc6$var$p(419));
        d = $d37c4c3cfd90dfc6$var$Ki(f, d, void 0);
        return $d37c4c3cfd90dfc6$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($d37c4c3cfd90dfc6$var$dh || h) {
        d = $d37c4c3cfd90dfc6$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $d37c4c3cfd90dfc6$var$ih(a, e), $d37c4c3cfd90dfc6$var$gi(d, a, e, -1));
        }
        $d37c4c3cfd90dfc6$var$tj();
        d = $d37c4c3cfd90dfc6$var$Ki(Error($d37c4c3cfd90dfc6$var$p(421)));
        return $d37c4c3cfd90dfc6$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $d37c4c3cfd90dfc6$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $d37c4c3cfd90dfc6$var$yg = $d37c4c3cfd90dfc6$var$Lf(e.nextSibling);
    $d37c4c3cfd90dfc6$var$xg = b;
    $d37c4c3cfd90dfc6$var$I = !0;
    $d37c4c3cfd90dfc6$var$zg = null;
    null !== a && ($d37c4c3cfd90dfc6$var$og[$d37c4c3cfd90dfc6$var$pg++] = $d37c4c3cfd90dfc6$var$rg, $d37c4c3cfd90dfc6$var$og[$d37c4c3cfd90dfc6$var$pg++] = $d37c4c3cfd90dfc6$var$sg, $d37c4c3cfd90dfc6$var$og[$d37c4c3cfd90dfc6$var$pg++] = $d37c4c3cfd90dfc6$var$qg, $d37c4c3cfd90dfc6$var$rg = a.id, $d37c4c3cfd90dfc6$var$sg = a.overflow, $d37c4c3cfd90dfc6$var$qg = b);
    b = $d37c4c3cfd90dfc6$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $d37c4c3cfd90dfc6$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $d37c4c3cfd90dfc6$var$bh(a.return, b, c);
}
function $d37c4c3cfd90dfc6$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $d37c4c3cfd90dfc6$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $d37c4c3cfd90dfc6$var$Xi(a, b, d.children, c);
    d = $d37c4c3cfd90dfc6$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $d37c4c3cfd90dfc6$var$vj(a, c, b);
            else if (19 === a.tag) $d37c4c3cfd90dfc6$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $d37c4c3cfd90dfc6$var$G($d37c4c3cfd90dfc6$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $d37c4c3cfd90dfc6$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $d37c4c3cfd90dfc6$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $d37c4c3cfd90dfc6$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $d37c4c3cfd90dfc6$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $d37c4c3cfd90dfc6$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $d37c4c3cfd90dfc6$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $d37c4c3cfd90dfc6$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $d37c4c3cfd90dfc6$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($d37c4c3cfd90dfc6$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $d37c4c3cfd90dfc6$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $d37c4c3cfd90dfc6$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $d37c4c3cfd90dfc6$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $d37c4c3cfd90dfc6$var$kj(b);
            $d37c4c3cfd90dfc6$var$Ig();
            break;
        case 5:
            $d37c4c3cfd90dfc6$var$Ah(b);
            break;
        case 1:
            $d37c4c3cfd90dfc6$var$Zf(b.type) && $d37c4c3cfd90dfc6$var$cg(b);
            break;
        case 4:
            $d37c4c3cfd90dfc6$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $d37c4c3cfd90dfc6$var$G($d37c4c3cfd90dfc6$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $d37c4c3cfd90dfc6$var$G($d37c4c3cfd90dfc6$var$L, $d37c4c3cfd90dfc6$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $d37c4c3cfd90dfc6$var$oj(a, b, c);
                $d37c4c3cfd90dfc6$var$G($d37c4c3cfd90dfc6$var$L, $d37c4c3cfd90dfc6$var$L.current & 1);
                a = $d37c4c3cfd90dfc6$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $d37c4c3cfd90dfc6$var$G($d37c4c3cfd90dfc6$var$L, $d37c4c3cfd90dfc6$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $d37c4c3cfd90dfc6$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $d37c4c3cfd90dfc6$var$G($d37c4c3cfd90dfc6$var$L, $d37c4c3cfd90dfc6$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $d37c4c3cfd90dfc6$var$dj(a, b, c);
    }
    return $d37c4c3cfd90dfc6$var$Zi(a, b, c);
}
var $d37c4c3cfd90dfc6$var$zj, $d37c4c3cfd90dfc6$var$Aj, $d37c4c3cfd90dfc6$var$Bj, $d37c4c3cfd90dfc6$var$Cj;
$d37c4c3cfd90dfc6$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$d37c4c3cfd90dfc6$var$Aj = function() {};
$d37c4c3cfd90dfc6$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $d37c4c3cfd90dfc6$var$xh($d37c4c3cfd90dfc6$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $d37c4c3cfd90dfc6$var$Ya(a, e);
                d = $d37c4c3cfd90dfc6$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $d37c4c3cfd90dfc6$var$A({}, e, {
                    value: void 0
                });
                d = $d37c4c3cfd90dfc6$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $d37c4c3cfd90dfc6$var$gb(a, e);
                d = $d37c4c3cfd90dfc6$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $d37c4c3cfd90dfc6$var$Bf);
        }
        $d37c4c3cfd90dfc6$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($d37c4c3cfd90dfc6$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($d37c4c3cfd90dfc6$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $d37c4c3cfd90dfc6$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$d37c4c3cfd90dfc6$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $d37c4c3cfd90dfc6$var$Dj(a, b) {
    if (!$d37c4c3cfd90dfc6$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $d37c4c3cfd90dfc6$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $d37c4c3cfd90dfc6$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $d37c4c3cfd90dfc6$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $d37c4c3cfd90dfc6$var$S(b), null;
        case 1:
            return $d37c4c3cfd90dfc6$var$Zf(b.type) && $d37c4c3cfd90dfc6$var$$f(), $d37c4c3cfd90dfc6$var$S(b), null;
        case 3:
            d = b.stateNode;
            $d37c4c3cfd90dfc6$var$zh();
            $d37c4c3cfd90dfc6$var$E($d37c4c3cfd90dfc6$var$Wf);
            $d37c4c3cfd90dfc6$var$E($d37c4c3cfd90dfc6$var$H);
            $d37c4c3cfd90dfc6$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $d37c4c3cfd90dfc6$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $d37c4c3cfd90dfc6$var$zg && ($d37c4c3cfd90dfc6$var$Fj($d37c4c3cfd90dfc6$var$zg), $d37c4c3cfd90dfc6$var$zg = null));
            $d37c4c3cfd90dfc6$var$Aj(a, b);
            $d37c4c3cfd90dfc6$var$S(b);
            return null;
        case 5:
            $d37c4c3cfd90dfc6$var$Bh(b);
            var e = $d37c4c3cfd90dfc6$var$xh($d37c4c3cfd90dfc6$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $d37c4c3cfd90dfc6$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($d37c4c3cfd90dfc6$var$p(166));
                    $d37c4c3cfd90dfc6$var$S(b);
                    return null;
                }
                a = $d37c4c3cfd90dfc6$var$xh($d37c4c3cfd90dfc6$var$uh.current);
                if ($d37c4c3cfd90dfc6$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$d37c4c3cfd90dfc6$var$Of] = b;
                    d[$d37c4c3cfd90dfc6$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $d37c4c3cfd90dfc6$var$D("cancel", d);
                            $d37c4c3cfd90dfc6$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $d37c4c3cfd90dfc6$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $d37c4c3cfd90dfc6$var$lf.length; e++)$d37c4c3cfd90dfc6$var$D($d37c4c3cfd90dfc6$var$lf[e], d);
                            break;
                        case "source":
                            $d37c4c3cfd90dfc6$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $d37c4c3cfd90dfc6$var$D("error", d);
                            $d37c4c3cfd90dfc6$var$D("load", d);
                            break;
                        case "details":
                            $d37c4c3cfd90dfc6$var$D("toggle", d);
                            break;
                        case "input":
                            $d37c4c3cfd90dfc6$var$Za(d, f);
                            $d37c4c3cfd90dfc6$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $d37c4c3cfd90dfc6$var$D("invalid", d);
                            break;
                        case "textarea":
                            $d37c4c3cfd90dfc6$var$hb(d, f), $d37c4c3cfd90dfc6$var$D("invalid", d);
                    }
                    $d37c4c3cfd90dfc6$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $d37c4c3cfd90dfc6$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $d37c4c3cfd90dfc6$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $d37c4c3cfd90dfc6$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $d37c4c3cfd90dfc6$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $d37c4c3cfd90dfc6$var$Va(d);
                            $d37c4c3cfd90dfc6$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $d37c4c3cfd90dfc6$var$Va(d);
                            $d37c4c3cfd90dfc6$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $d37c4c3cfd90dfc6$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $d37c4c3cfd90dfc6$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$d37c4c3cfd90dfc6$var$Of] = b;
                    a[$d37c4c3cfd90dfc6$var$Pf] = d;
                    $d37c4c3cfd90dfc6$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $d37c4c3cfd90dfc6$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $d37c4c3cfd90dfc6$var$D("cancel", a);
                                $d37c4c3cfd90dfc6$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $d37c4c3cfd90dfc6$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $d37c4c3cfd90dfc6$var$lf.length; e++)$d37c4c3cfd90dfc6$var$D($d37c4c3cfd90dfc6$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $d37c4c3cfd90dfc6$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $d37c4c3cfd90dfc6$var$D("error", a);
                                $d37c4c3cfd90dfc6$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $d37c4c3cfd90dfc6$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $d37c4c3cfd90dfc6$var$Za(a, d);
                                e = $d37c4c3cfd90dfc6$var$Ya(a, d);
                                $d37c4c3cfd90dfc6$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $d37c4c3cfd90dfc6$var$A({}, d, {
                                    value: void 0
                                });
                                $d37c4c3cfd90dfc6$var$D("invalid", a);
                                break;
                            case "textarea":
                                $d37c4c3cfd90dfc6$var$hb(a, d);
                                e = $d37c4c3cfd90dfc6$var$gb(a, d);
                                $d37c4c3cfd90dfc6$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $d37c4c3cfd90dfc6$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $d37c4c3cfd90dfc6$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $d37c4c3cfd90dfc6$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $d37c4c3cfd90dfc6$var$ob(a, k) : "number" === typeof k && $d37c4c3cfd90dfc6$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($d37c4c3cfd90dfc6$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $d37c4c3cfd90dfc6$var$D("scroll", a) : null != k && $d37c4c3cfd90dfc6$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $d37c4c3cfd90dfc6$var$Va(a);
                                $d37c4c3cfd90dfc6$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $d37c4c3cfd90dfc6$var$Va(a);
                                $d37c4c3cfd90dfc6$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $d37c4c3cfd90dfc6$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $d37c4c3cfd90dfc6$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $d37c4c3cfd90dfc6$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $d37c4c3cfd90dfc6$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $d37c4c3cfd90dfc6$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $d37c4c3cfd90dfc6$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($d37c4c3cfd90dfc6$var$p(166));
                c = $d37c4c3cfd90dfc6$var$xh($d37c4c3cfd90dfc6$var$wh.current);
                $d37c4c3cfd90dfc6$var$xh($d37c4c3cfd90dfc6$var$uh.current);
                if ($d37c4c3cfd90dfc6$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$d37c4c3cfd90dfc6$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $d37c4c3cfd90dfc6$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $d37c4c3cfd90dfc6$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $d37c4c3cfd90dfc6$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$d37c4c3cfd90dfc6$var$Of] = b, b.stateNode = d;
            }
            $d37c4c3cfd90dfc6$var$S(b);
            return null;
        case 13:
            $d37c4c3cfd90dfc6$var$E($d37c4c3cfd90dfc6$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($d37c4c3cfd90dfc6$var$I && null !== $d37c4c3cfd90dfc6$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $d37c4c3cfd90dfc6$var$Hg(), $d37c4c3cfd90dfc6$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $d37c4c3cfd90dfc6$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($d37c4c3cfd90dfc6$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($d37c4c3cfd90dfc6$var$p(317));
                        f[$d37c4c3cfd90dfc6$var$Of] = b;
                    } else $d37c4c3cfd90dfc6$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $d37c4c3cfd90dfc6$var$S(b);
                    f = !1;
                } else null !== $d37c4c3cfd90dfc6$var$zg && ($d37c4c3cfd90dfc6$var$Fj($d37c4c3cfd90dfc6$var$zg), $d37c4c3cfd90dfc6$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($d37c4c3cfd90dfc6$var$L.current & 1) ? 0 === $d37c4c3cfd90dfc6$var$T && ($d37c4c3cfd90dfc6$var$T = 3) : $d37c4c3cfd90dfc6$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $d37c4c3cfd90dfc6$var$S(b);
            return null;
        case 4:
            return $d37c4c3cfd90dfc6$var$zh(), $d37c4c3cfd90dfc6$var$Aj(a, b), null === a && $d37c4c3cfd90dfc6$var$sf(b.stateNode.containerInfo), $d37c4c3cfd90dfc6$var$S(b), null;
        case 10:
            return $d37c4c3cfd90dfc6$var$ah(b.type._context), $d37c4c3cfd90dfc6$var$S(b), null;
        case 17:
            return $d37c4c3cfd90dfc6$var$Zf(b.type) && $d37c4c3cfd90dfc6$var$$f(), $d37c4c3cfd90dfc6$var$S(b), null;
        case 19:
            $d37c4c3cfd90dfc6$var$E($d37c4c3cfd90dfc6$var$L);
            f = b.memoizedState;
            if (null === f) return $d37c4c3cfd90dfc6$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $d37c4c3cfd90dfc6$var$Dj(f, !1);
                else {
                    if (0 !== $d37c4c3cfd90dfc6$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $d37c4c3cfd90dfc6$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $d37c4c3cfd90dfc6$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $d37c4c3cfd90dfc6$var$G($d37c4c3cfd90dfc6$var$L, $d37c4c3cfd90dfc6$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $d37c4c3cfd90dfc6$var$B() > $d37c4c3cfd90dfc6$var$Gj && (b.flags |= 128, d = !0, $d37c4c3cfd90dfc6$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $d37c4c3cfd90dfc6$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $d37c4c3cfd90dfc6$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$d37c4c3cfd90dfc6$var$I) return $d37c4c3cfd90dfc6$var$S(b), null;
                    } else 2 * $d37c4c3cfd90dfc6$var$B() - f.renderingStartTime > $d37c4c3cfd90dfc6$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $d37c4c3cfd90dfc6$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $d37c4c3cfd90dfc6$var$B(), b.sibling = null, c = $d37c4c3cfd90dfc6$var$L.current, $d37c4c3cfd90dfc6$var$G($d37c4c3cfd90dfc6$var$L, d ? c & 1 | 2 : c & 1), b;
            $d37c4c3cfd90dfc6$var$S(b);
            return null;
        case 22:
        case 23:
            return $d37c4c3cfd90dfc6$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($d37c4c3cfd90dfc6$var$fj & 1073741824) && ($d37c4c3cfd90dfc6$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $d37c4c3cfd90dfc6$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($d37c4c3cfd90dfc6$var$p(156, b.tag));
}
function $d37c4c3cfd90dfc6$var$Ij(a, b) {
    $d37c4c3cfd90dfc6$var$wg(b);
    switch(b.tag){
        case 1:
            return $d37c4c3cfd90dfc6$var$Zf(b.type) && $d37c4c3cfd90dfc6$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $d37c4c3cfd90dfc6$var$zh(), $d37c4c3cfd90dfc6$var$E($d37c4c3cfd90dfc6$var$Wf), $d37c4c3cfd90dfc6$var$E($d37c4c3cfd90dfc6$var$H), $d37c4c3cfd90dfc6$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $d37c4c3cfd90dfc6$var$Bh(b), null;
        case 13:
            $d37c4c3cfd90dfc6$var$E($d37c4c3cfd90dfc6$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($d37c4c3cfd90dfc6$var$p(340));
                $d37c4c3cfd90dfc6$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $d37c4c3cfd90dfc6$var$E($d37c4c3cfd90dfc6$var$L), null;
        case 4:
            return $d37c4c3cfd90dfc6$var$zh(), null;
        case 10:
            return $d37c4c3cfd90dfc6$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $d37c4c3cfd90dfc6$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $d37c4c3cfd90dfc6$var$Jj = !1, $d37c4c3cfd90dfc6$var$U = !1, $d37c4c3cfd90dfc6$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $d37c4c3cfd90dfc6$var$V = null;
function $d37c4c3cfd90dfc6$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $d37c4c3cfd90dfc6$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $d37c4c3cfd90dfc6$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $d37c4c3cfd90dfc6$var$W(a, b, d);
    }
}
var $d37c4c3cfd90dfc6$var$Nj = !1;
function $d37c4c3cfd90dfc6$var$Oj(a, b) {
    $d37c4c3cfd90dfc6$var$Cf = $d37c4c3cfd90dfc6$var$dd;
    a = $d37c4c3cfd90dfc6$var$Me();
    if ($d37c4c3cfd90dfc6$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $d37c4c3cfd90dfc6$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $d37c4c3cfd90dfc6$var$dd = !1;
    for($d37c4c3cfd90dfc6$var$V = b; null !== $d37c4c3cfd90dfc6$var$V;)if (b = $d37c4c3cfd90dfc6$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $d37c4c3cfd90dfc6$var$V = a;
    else for(; null !== $d37c4c3cfd90dfc6$var$V;){
        b = $d37c4c3cfd90dfc6$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $d37c4c3cfd90dfc6$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($d37c4c3cfd90dfc6$var$p(163));
            }
        } catch (F) {
            $d37c4c3cfd90dfc6$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $d37c4c3cfd90dfc6$var$V = a;
            break;
        }
        $d37c4c3cfd90dfc6$var$V = b.return;
    }
    n = $d37c4c3cfd90dfc6$var$Nj;
    $d37c4c3cfd90dfc6$var$Nj = !1;
    return n;
}
function $d37c4c3cfd90dfc6$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $d37c4c3cfd90dfc6$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $d37c4c3cfd90dfc6$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $d37c4c3cfd90dfc6$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $d37c4c3cfd90dfc6$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $d37c4c3cfd90dfc6$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$d37c4c3cfd90dfc6$var$Of], delete b[$d37c4c3cfd90dfc6$var$Pf], delete b[$d37c4c3cfd90dfc6$var$of], delete b[$d37c4c3cfd90dfc6$var$Qf], delete b[$d37c4c3cfd90dfc6$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $d37c4c3cfd90dfc6$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $d37c4c3cfd90dfc6$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $d37c4c3cfd90dfc6$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $d37c4c3cfd90dfc6$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $d37c4c3cfd90dfc6$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($d37c4c3cfd90dfc6$var$Vj(a, b, c), a = a.sibling; null !== a;)$d37c4c3cfd90dfc6$var$Vj(a, b, c), a = a.sibling;
}
function $d37c4c3cfd90dfc6$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($d37c4c3cfd90dfc6$var$Wj(a, b, c), a = a.sibling; null !== a;)$d37c4c3cfd90dfc6$var$Wj(a, b, c), a = a.sibling;
}
var $d37c4c3cfd90dfc6$var$X = null, $d37c4c3cfd90dfc6$var$Xj = !1;
function $d37c4c3cfd90dfc6$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$d37c4c3cfd90dfc6$var$Zj(a, b, c), c = c.sibling;
}
function $d37c4c3cfd90dfc6$var$Zj(a, b, c) {
    if ($d37c4c3cfd90dfc6$var$lc && "function" === typeof $d37c4c3cfd90dfc6$var$lc.onCommitFiberUnmount) try {
        $d37c4c3cfd90dfc6$var$lc.onCommitFiberUnmount($d37c4c3cfd90dfc6$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $d37c4c3cfd90dfc6$var$U || $d37c4c3cfd90dfc6$var$Lj(c, b);
        case 6:
            var d = $d37c4c3cfd90dfc6$var$X, e = $d37c4c3cfd90dfc6$var$Xj;
            $d37c4c3cfd90dfc6$var$X = null;
            $d37c4c3cfd90dfc6$var$Yj(a, b, c);
            $d37c4c3cfd90dfc6$var$X = d;
            $d37c4c3cfd90dfc6$var$Xj = e;
            null !== $d37c4c3cfd90dfc6$var$X && ($d37c4c3cfd90dfc6$var$Xj ? (a = $d37c4c3cfd90dfc6$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $d37c4c3cfd90dfc6$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $d37c4c3cfd90dfc6$var$X && ($d37c4c3cfd90dfc6$var$Xj ? (a = $d37c4c3cfd90dfc6$var$X, c = c.stateNode, 8 === a.nodeType ? $d37c4c3cfd90dfc6$var$Kf(a.parentNode, c) : 1 === a.nodeType && $d37c4c3cfd90dfc6$var$Kf(a, c), $d37c4c3cfd90dfc6$var$bd(a)) : $d37c4c3cfd90dfc6$var$Kf($d37c4c3cfd90dfc6$var$X, c.stateNode));
            break;
        case 4:
            d = $d37c4c3cfd90dfc6$var$X;
            e = $d37c4c3cfd90dfc6$var$Xj;
            $d37c4c3cfd90dfc6$var$X = c.stateNode.containerInfo;
            $d37c4c3cfd90dfc6$var$Xj = !0;
            $d37c4c3cfd90dfc6$var$Yj(a, b, c);
            $d37c4c3cfd90dfc6$var$X = d;
            $d37c4c3cfd90dfc6$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$d37c4c3cfd90dfc6$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $d37c4c3cfd90dfc6$var$Mj(c, b, g) : 0 !== (f & 4) && $d37c4c3cfd90dfc6$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $d37c4c3cfd90dfc6$var$Yj(a, b, c);
            break;
        case 1:
            if (!$d37c4c3cfd90dfc6$var$U && ($d37c4c3cfd90dfc6$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $d37c4c3cfd90dfc6$var$W(c, b, h);
            }
            $d37c4c3cfd90dfc6$var$Yj(a, b, c);
            break;
        case 21:
            $d37c4c3cfd90dfc6$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($d37c4c3cfd90dfc6$var$U = (d = $d37c4c3cfd90dfc6$var$U) || null !== c.memoizedState, $d37c4c3cfd90dfc6$var$Yj(a, b, c), $d37c4c3cfd90dfc6$var$U = d) : $d37c4c3cfd90dfc6$var$Yj(a, b, c);
            break;
        default:
            $d37c4c3cfd90dfc6$var$Yj(a, b, c);
    }
}
function $d37c4c3cfd90dfc6$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $d37c4c3cfd90dfc6$var$Kj);
        b.forEach(function(b) {
            var d = $d37c4c3cfd90dfc6$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $d37c4c3cfd90dfc6$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $d37c4c3cfd90dfc6$var$X = h.stateNode;
                        $d37c4c3cfd90dfc6$var$Xj = !1;
                        break a;
                    case 3:
                        $d37c4c3cfd90dfc6$var$X = h.stateNode.containerInfo;
                        $d37c4c3cfd90dfc6$var$Xj = !0;
                        break a;
                    case 4:
                        $d37c4c3cfd90dfc6$var$X = h.stateNode.containerInfo;
                        $d37c4c3cfd90dfc6$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $d37c4c3cfd90dfc6$var$X) throw Error($d37c4c3cfd90dfc6$var$p(160));
            $d37c4c3cfd90dfc6$var$Zj(f, g, e);
            $d37c4c3cfd90dfc6$var$X = null;
            $d37c4c3cfd90dfc6$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $d37c4c3cfd90dfc6$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$d37c4c3cfd90dfc6$var$dk(b, a), b = b.sibling;
}
function $d37c4c3cfd90dfc6$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $d37c4c3cfd90dfc6$var$ck(b, a);
            $d37c4c3cfd90dfc6$var$ek(a);
            if (d & 4) {
                try {
                    $d37c4c3cfd90dfc6$var$Pj(3, a, a.return), $d37c4c3cfd90dfc6$var$Qj(3, a);
                } catch (t) {
                    $d37c4c3cfd90dfc6$var$W(a, a.return, t);
                }
                try {
                    $d37c4c3cfd90dfc6$var$Pj(5, a, a.return);
                } catch (t) {
                    $d37c4c3cfd90dfc6$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $d37c4c3cfd90dfc6$var$ck(b, a);
            $d37c4c3cfd90dfc6$var$ek(a);
            d & 512 && null !== c && $d37c4c3cfd90dfc6$var$Lj(c, c.return);
            break;
        case 5:
            $d37c4c3cfd90dfc6$var$ck(b, a);
            $d37c4c3cfd90dfc6$var$ek(a);
            d & 512 && null !== c && $d37c4c3cfd90dfc6$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $d37c4c3cfd90dfc6$var$ob(e, "");
                } catch (t) {
                    $d37c4c3cfd90dfc6$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $d37c4c3cfd90dfc6$var$ab(e, f);
                    $d37c4c3cfd90dfc6$var$vb(h, g);
                    var l = $d37c4c3cfd90dfc6$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $d37c4c3cfd90dfc6$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $d37c4c3cfd90dfc6$var$nb(e, q) : "children" === m ? $d37c4c3cfd90dfc6$var$ob(e, q) : $d37c4c3cfd90dfc6$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $d37c4c3cfd90dfc6$var$bb(e, f);
                            break;
                        case "textarea":
                            $d37c4c3cfd90dfc6$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $d37c4c3cfd90dfc6$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $d37c4c3cfd90dfc6$var$fb(e, !!f.multiple, f.defaultValue, !0) : $d37c4c3cfd90dfc6$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$d37c4c3cfd90dfc6$var$Pf] = f;
                } catch (t) {
                    $d37c4c3cfd90dfc6$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $d37c4c3cfd90dfc6$var$ck(b, a);
            $d37c4c3cfd90dfc6$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($d37c4c3cfd90dfc6$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $d37c4c3cfd90dfc6$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $d37c4c3cfd90dfc6$var$ck(b, a);
            $d37c4c3cfd90dfc6$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $d37c4c3cfd90dfc6$var$bd(b.containerInfo);
            } catch (t) {
                $d37c4c3cfd90dfc6$var$W(a, a.return, t);
            }
            break;
        case 4:
            $d37c4c3cfd90dfc6$var$ck(b, a);
            $d37c4c3cfd90dfc6$var$ek(a);
            break;
        case 13:
            $d37c4c3cfd90dfc6$var$ck(b, a);
            $d37c4c3cfd90dfc6$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($d37c4c3cfd90dfc6$var$fk = $d37c4c3cfd90dfc6$var$B()));
            d & 4 && $d37c4c3cfd90dfc6$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($d37c4c3cfd90dfc6$var$U = (l = $d37c4c3cfd90dfc6$var$U) || m, $d37c4c3cfd90dfc6$var$ck(b, a), $d37c4c3cfd90dfc6$var$U = l) : $d37c4c3cfd90dfc6$var$ck(b, a);
            $d37c4c3cfd90dfc6$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($d37c4c3cfd90dfc6$var$V = a, m = a.child; null !== m;){
                    for(q = $d37c4c3cfd90dfc6$var$V = m; null !== $d37c4c3cfd90dfc6$var$V;){
                        r = $d37c4c3cfd90dfc6$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $d37c4c3cfd90dfc6$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $d37c4c3cfd90dfc6$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $d37c4c3cfd90dfc6$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $d37c4c3cfd90dfc6$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $d37c4c3cfd90dfc6$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $d37c4c3cfd90dfc6$var$V = y) : $d37c4c3cfd90dfc6$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $d37c4c3cfd90dfc6$var$rb("display", g));
                            } catch (t) {
                                $d37c4c3cfd90dfc6$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $d37c4c3cfd90dfc6$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $d37c4c3cfd90dfc6$var$ck(b, a);
            $d37c4c3cfd90dfc6$var$ek(a);
            d & 4 && $d37c4c3cfd90dfc6$var$ak(a);
            break;
        case 21:
            break;
        default:
            $d37c4c3cfd90dfc6$var$ck(b, a), $d37c4c3cfd90dfc6$var$ek(a);
    }
}
function $d37c4c3cfd90dfc6$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($d37c4c3cfd90dfc6$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($d37c4c3cfd90dfc6$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($d37c4c3cfd90dfc6$var$ob(e, ""), d.flags &= -33);
                    var f = $d37c4c3cfd90dfc6$var$Uj(a);
                    $d37c4c3cfd90dfc6$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $d37c4c3cfd90dfc6$var$Uj(a);
                    $d37c4c3cfd90dfc6$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($d37c4c3cfd90dfc6$var$p(161));
            }
        } catch (k) {
            $d37c4c3cfd90dfc6$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $d37c4c3cfd90dfc6$var$hk(a, b, c) {
    $d37c4c3cfd90dfc6$var$V = a;
    $d37c4c3cfd90dfc6$var$ik(a, b, c);
}
function $d37c4c3cfd90dfc6$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $d37c4c3cfd90dfc6$var$V;){
        var e = $d37c4c3cfd90dfc6$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $d37c4c3cfd90dfc6$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $d37c4c3cfd90dfc6$var$U;
                h = $d37c4c3cfd90dfc6$var$Jj;
                var l = $d37c4c3cfd90dfc6$var$U;
                $d37c4c3cfd90dfc6$var$Jj = g;
                if (($d37c4c3cfd90dfc6$var$U = k) && !l) for($d37c4c3cfd90dfc6$var$V = e; null !== $d37c4c3cfd90dfc6$var$V;)g = $d37c4c3cfd90dfc6$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $d37c4c3cfd90dfc6$var$jk(e) : null !== k ? (k.return = g, $d37c4c3cfd90dfc6$var$V = k) : $d37c4c3cfd90dfc6$var$jk(e);
                for(; null !== f;)$d37c4c3cfd90dfc6$var$V = f, $d37c4c3cfd90dfc6$var$ik(f, b, c), f = f.sibling;
                $d37c4c3cfd90dfc6$var$V = e;
                $d37c4c3cfd90dfc6$var$Jj = h;
                $d37c4c3cfd90dfc6$var$U = l;
            }
            $d37c4c3cfd90dfc6$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $d37c4c3cfd90dfc6$var$V = f) : $d37c4c3cfd90dfc6$var$kk(a, b, c);
    }
}
function $d37c4c3cfd90dfc6$var$kk(a) {
    for(; null !== $d37c4c3cfd90dfc6$var$V;){
        var b = $d37c4c3cfd90dfc6$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $d37c4c3cfd90dfc6$var$U || $d37c4c3cfd90dfc6$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$d37c4c3cfd90dfc6$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $d37c4c3cfd90dfc6$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $d37c4c3cfd90dfc6$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $d37c4c3cfd90dfc6$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $d37c4c3cfd90dfc6$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($d37c4c3cfd90dfc6$var$p(163));
                }
                $d37c4c3cfd90dfc6$var$U || b.flags & 512 && $d37c4c3cfd90dfc6$var$Rj(b);
            } catch (r) {
                $d37c4c3cfd90dfc6$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $d37c4c3cfd90dfc6$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $d37c4c3cfd90dfc6$var$V = c;
            break;
        }
        $d37c4c3cfd90dfc6$var$V = b.return;
    }
}
function $d37c4c3cfd90dfc6$var$gk(a) {
    for(; null !== $d37c4c3cfd90dfc6$var$V;){
        var b = $d37c4c3cfd90dfc6$var$V;
        if (b === a) {
            $d37c4c3cfd90dfc6$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $d37c4c3cfd90dfc6$var$V = c;
            break;
        }
        $d37c4c3cfd90dfc6$var$V = b.return;
    }
}
function $d37c4c3cfd90dfc6$var$jk(a) {
    for(; null !== $d37c4c3cfd90dfc6$var$V;){
        var b = $d37c4c3cfd90dfc6$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $d37c4c3cfd90dfc6$var$Qj(4, b);
                    } catch (k) {
                        $d37c4c3cfd90dfc6$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $d37c4c3cfd90dfc6$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $d37c4c3cfd90dfc6$var$Rj(b);
                    } catch (k) {
                        $d37c4c3cfd90dfc6$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $d37c4c3cfd90dfc6$var$Rj(b);
                    } catch (k) {
                        $d37c4c3cfd90dfc6$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $d37c4c3cfd90dfc6$var$W(b, b.return, k);
        }
        if (b === a) {
            $d37c4c3cfd90dfc6$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $d37c4c3cfd90dfc6$var$V = h;
            break;
        }
        $d37c4c3cfd90dfc6$var$V = b.return;
    }
}
var $d37c4c3cfd90dfc6$var$lk = Math.ceil, $d37c4c3cfd90dfc6$var$mk = $d37c4c3cfd90dfc6$var$ua.ReactCurrentDispatcher, $d37c4c3cfd90dfc6$var$nk = $d37c4c3cfd90dfc6$var$ua.ReactCurrentOwner, $d37c4c3cfd90dfc6$var$ok = $d37c4c3cfd90dfc6$var$ua.ReactCurrentBatchConfig, $d37c4c3cfd90dfc6$var$K = 0, $d37c4c3cfd90dfc6$var$Q = null, $d37c4c3cfd90dfc6$var$Y = null, $d37c4c3cfd90dfc6$var$Z = 0, $d37c4c3cfd90dfc6$var$fj = 0, $d37c4c3cfd90dfc6$var$ej = $d37c4c3cfd90dfc6$var$Uf(0), $d37c4c3cfd90dfc6$var$T = 0, $d37c4c3cfd90dfc6$var$pk = null, $d37c4c3cfd90dfc6$var$rh = 0, $d37c4c3cfd90dfc6$var$qk = 0, $d37c4c3cfd90dfc6$var$rk = 0, $d37c4c3cfd90dfc6$var$sk = null, $d37c4c3cfd90dfc6$var$tk = null, $d37c4c3cfd90dfc6$var$fk = 0, $d37c4c3cfd90dfc6$var$Gj = Infinity, $d37c4c3cfd90dfc6$var$uk = null, $d37c4c3cfd90dfc6$var$Oi = !1, $d37c4c3cfd90dfc6$var$Pi = null, $d37c4c3cfd90dfc6$var$Ri = null, $d37c4c3cfd90dfc6$var$vk = !1, $d37c4c3cfd90dfc6$var$wk = null, $d37c4c3cfd90dfc6$var$xk = 0, $d37c4c3cfd90dfc6$var$yk = 0, $d37c4c3cfd90dfc6$var$zk = null, $d37c4c3cfd90dfc6$var$Ak = -1, $d37c4c3cfd90dfc6$var$Bk = 0;
function $d37c4c3cfd90dfc6$var$R() {
    return 0 !== ($d37c4c3cfd90dfc6$var$K & 6) ? $d37c4c3cfd90dfc6$var$B() : -1 !== $d37c4c3cfd90dfc6$var$Ak ? $d37c4c3cfd90dfc6$var$Ak : $d37c4c3cfd90dfc6$var$Ak = $d37c4c3cfd90dfc6$var$B();
}
function $d37c4c3cfd90dfc6$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($d37c4c3cfd90dfc6$var$K & 2) && 0 !== $d37c4c3cfd90dfc6$var$Z) return $d37c4c3cfd90dfc6$var$Z & -$d37c4c3cfd90dfc6$var$Z;
    if (null !== $d37c4c3cfd90dfc6$var$Kg.transition) return 0 === $d37c4c3cfd90dfc6$var$Bk && ($d37c4c3cfd90dfc6$var$Bk = $d37c4c3cfd90dfc6$var$yc()), $d37c4c3cfd90dfc6$var$Bk;
    a = $d37c4c3cfd90dfc6$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $d37c4c3cfd90dfc6$var$jd(a.type);
    return a;
}
function $d37c4c3cfd90dfc6$var$gi(a, b, c, d) {
    if (50 < $d37c4c3cfd90dfc6$var$yk) throw $d37c4c3cfd90dfc6$var$yk = 0, $d37c4c3cfd90dfc6$var$zk = null, Error($d37c4c3cfd90dfc6$var$p(185));
    $d37c4c3cfd90dfc6$var$Ac(a, c, d);
    if (0 === ($d37c4c3cfd90dfc6$var$K & 2) || a !== $d37c4c3cfd90dfc6$var$Q) a === $d37c4c3cfd90dfc6$var$Q && (0 === ($d37c4c3cfd90dfc6$var$K & 2) && ($d37c4c3cfd90dfc6$var$qk |= c), 4 === $d37c4c3cfd90dfc6$var$T && $d37c4c3cfd90dfc6$var$Ck(a, $d37c4c3cfd90dfc6$var$Z)), $d37c4c3cfd90dfc6$var$Dk(a, d), 1 === c && 0 === $d37c4c3cfd90dfc6$var$K && 0 === (b.mode & 1) && ($d37c4c3cfd90dfc6$var$Gj = $d37c4c3cfd90dfc6$var$B() + 500, $d37c4c3cfd90dfc6$var$fg && $d37c4c3cfd90dfc6$var$jg());
}
function $d37c4c3cfd90dfc6$var$Dk(a, b) {
    var c = a.callbackNode;
    $d37c4c3cfd90dfc6$var$wc(a, b);
    var d = $d37c4c3cfd90dfc6$var$uc(a, a === $d37c4c3cfd90dfc6$var$Q ? $d37c4c3cfd90dfc6$var$Z : 0);
    if (0 === d) null !== c && $d37c4c3cfd90dfc6$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $d37c4c3cfd90dfc6$var$bc(c);
        if (1 === b) 0 === a.tag ? $d37c4c3cfd90dfc6$var$ig($d37c4c3cfd90dfc6$var$Ek.bind(null, a)) : $d37c4c3cfd90dfc6$var$hg($d37c4c3cfd90dfc6$var$Ek.bind(null, a)), $d37c4c3cfd90dfc6$var$Jf(function() {
            0 === ($d37c4c3cfd90dfc6$var$K & 6) && $d37c4c3cfd90dfc6$var$jg();
        }), c = null;
        else {
            switch($d37c4c3cfd90dfc6$var$Dc(d)){
                case 1:
                    c = $d37c4c3cfd90dfc6$var$fc;
                    break;
                case 4:
                    c = $d37c4c3cfd90dfc6$var$gc;
                    break;
                case 16:
                    c = $d37c4c3cfd90dfc6$var$hc;
                    break;
                case 536870912:
                    c = $d37c4c3cfd90dfc6$var$jc;
                    break;
                default:
                    c = $d37c4c3cfd90dfc6$var$hc;
            }
            c = $d37c4c3cfd90dfc6$var$Fk(c, $d37c4c3cfd90dfc6$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $d37c4c3cfd90dfc6$var$Gk(a, b) {
    $d37c4c3cfd90dfc6$var$Ak = -1;
    $d37c4c3cfd90dfc6$var$Bk = 0;
    if (0 !== ($d37c4c3cfd90dfc6$var$K & 6)) throw Error($d37c4c3cfd90dfc6$var$p(327));
    var c = a.callbackNode;
    if ($d37c4c3cfd90dfc6$var$Hk() && a.callbackNode !== c) return null;
    var d = $d37c4c3cfd90dfc6$var$uc(a, a === $d37c4c3cfd90dfc6$var$Q ? $d37c4c3cfd90dfc6$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $d37c4c3cfd90dfc6$var$Ik(a, d);
    else {
        b = d;
        var e = $d37c4c3cfd90dfc6$var$K;
        $d37c4c3cfd90dfc6$var$K |= 2;
        var f = $d37c4c3cfd90dfc6$var$Jk();
        if ($d37c4c3cfd90dfc6$var$Q !== a || $d37c4c3cfd90dfc6$var$Z !== b) $d37c4c3cfd90dfc6$var$uk = null, $d37c4c3cfd90dfc6$var$Gj = $d37c4c3cfd90dfc6$var$B() + 500, $d37c4c3cfd90dfc6$var$Kk(a, b);
        for(;;)try {
            $d37c4c3cfd90dfc6$var$Lk();
            break;
        } catch (h) {
            $d37c4c3cfd90dfc6$var$Mk(a, h);
        }
        $d37c4c3cfd90dfc6$var$$g();
        $d37c4c3cfd90dfc6$var$mk.current = f;
        $d37c4c3cfd90dfc6$var$K = e;
        null !== $d37c4c3cfd90dfc6$var$Y ? b = 0 : ($d37c4c3cfd90dfc6$var$Q = null, $d37c4c3cfd90dfc6$var$Z = 0, b = $d37c4c3cfd90dfc6$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $d37c4c3cfd90dfc6$var$xc(a), 0 !== e && (d = e, b = $d37c4c3cfd90dfc6$var$Nk(a, e)));
        if (1 === b) throw c = $d37c4c3cfd90dfc6$var$pk, $d37c4c3cfd90dfc6$var$Kk(a, 0), $d37c4c3cfd90dfc6$var$Ck(a, d), $d37c4c3cfd90dfc6$var$Dk(a, $d37c4c3cfd90dfc6$var$B()), c;
        if (6 === b) $d37c4c3cfd90dfc6$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$d37c4c3cfd90dfc6$var$Ok(e) && (b = $d37c4c3cfd90dfc6$var$Ik(a, d), 2 === b && (f = $d37c4c3cfd90dfc6$var$xc(a), 0 !== f && (d = f, b = $d37c4c3cfd90dfc6$var$Nk(a, f))), 1 === b)) throw c = $d37c4c3cfd90dfc6$var$pk, $d37c4c3cfd90dfc6$var$Kk(a, 0), $d37c4c3cfd90dfc6$var$Ck(a, d), $d37c4c3cfd90dfc6$var$Dk(a, $d37c4c3cfd90dfc6$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($d37c4c3cfd90dfc6$var$p(345));
                case 2:
                    $d37c4c3cfd90dfc6$var$Pk(a, $d37c4c3cfd90dfc6$var$tk, $d37c4c3cfd90dfc6$var$uk);
                    break;
                case 3:
                    $d37c4c3cfd90dfc6$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $d37c4c3cfd90dfc6$var$fk + 500 - $d37c4c3cfd90dfc6$var$B(), 10 < b)) {
                        if (0 !== $d37c4c3cfd90dfc6$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $d37c4c3cfd90dfc6$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $d37c4c3cfd90dfc6$var$Ff($d37c4c3cfd90dfc6$var$Pk.bind(null, a, $d37c4c3cfd90dfc6$var$tk, $d37c4c3cfd90dfc6$var$uk), b);
                        break;
                    }
                    $d37c4c3cfd90dfc6$var$Pk(a, $d37c4c3cfd90dfc6$var$tk, $d37c4c3cfd90dfc6$var$uk);
                    break;
                case 4:
                    $d37c4c3cfd90dfc6$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $d37c4c3cfd90dfc6$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $d37c4c3cfd90dfc6$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $d37c4c3cfd90dfc6$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $d37c4c3cfd90dfc6$var$Ff($d37c4c3cfd90dfc6$var$Pk.bind(null, a, $d37c4c3cfd90dfc6$var$tk, $d37c4c3cfd90dfc6$var$uk), d);
                        break;
                    }
                    $d37c4c3cfd90dfc6$var$Pk(a, $d37c4c3cfd90dfc6$var$tk, $d37c4c3cfd90dfc6$var$uk);
                    break;
                case 5:
                    $d37c4c3cfd90dfc6$var$Pk(a, $d37c4c3cfd90dfc6$var$tk, $d37c4c3cfd90dfc6$var$uk);
                    break;
                default:
                    throw Error($d37c4c3cfd90dfc6$var$p(329));
            }
        }
    }
    $d37c4c3cfd90dfc6$var$Dk(a, $d37c4c3cfd90dfc6$var$B());
    return a.callbackNode === c ? $d37c4c3cfd90dfc6$var$Gk.bind(null, a) : null;
}
function $d37c4c3cfd90dfc6$var$Nk(a, b) {
    var c = $d37c4c3cfd90dfc6$var$sk;
    a.current.memoizedState.isDehydrated && ($d37c4c3cfd90dfc6$var$Kk(a, b).flags |= 256);
    a = $d37c4c3cfd90dfc6$var$Ik(a, b);
    2 !== a && (b = $d37c4c3cfd90dfc6$var$tk, $d37c4c3cfd90dfc6$var$tk = c, null !== b && $d37c4c3cfd90dfc6$var$Fj(b));
    return a;
}
function $d37c4c3cfd90dfc6$var$Fj(a) {
    null === $d37c4c3cfd90dfc6$var$tk ? $d37c4c3cfd90dfc6$var$tk = a : $d37c4c3cfd90dfc6$var$tk.push.apply($d37c4c3cfd90dfc6$var$tk, a);
}
function $d37c4c3cfd90dfc6$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$d37c4c3cfd90dfc6$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $d37c4c3cfd90dfc6$var$Ck(a, b) {
    b &= ~$d37c4c3cfd90dfc6$var$rk;
    b &= ~$d37c4c3cfd90dfc6$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $d37c4c3cfd90dfc6$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $d37c4c3cfd90dfc6$var$Ek(a) {
    if (0 !== ($d37c4c3cfd90dfc6$var$K & 6)) throw Error($d37c4c3cfd90dfc6$var$p(327));
    $d37c4c3cfd90dfc6$var$Hk();
    var b = $d37c4c3cfd90dfc6$var$uc(a, 0);
    if (0 === (b & 1)) return $d37c4c3cfd90dfc6$var$Dk(a, $d37c4c3cfd90dfc6$var$B()), null;
    var c = $d37c4c3cfd90dfc6$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $d37c4c3cfd90dfc6$var$xc(a);
        0 !== d && (b = d, c = $d37c4c3cfd90dfc6$var$Nk(a, d));
    }
    if (1 === c) throw c = $d37c4c3cfd90dfc6$var$pk, $d37c4c3cfd90dfc6$var$Kk(a, 0), $d37c4c3cfd90dfc6$var$Ck(a, b), $d37c4c3cfd90dfc6$var$Dk(a, $d37c4c3cfd90dfc6$var$B()), c;
    if (6 === c) throw Error($d37c4c3cfd90dfc6$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $d37c4c3cfd90dfc6$var$Pk(a, $d37c4c3cfd90dfc6$var$tk, $d37c4c3cfd90dfc6$var$uk);
    $d37c4c3cfd90dfc6$var$Dk(a, $d37c4c3cfd90dfc6$var$B());
    return null;
}
function $d37c4c3cfd90dfc6$var$Qk(a, b) {
    var c = $d37c4c3cfd90dfc6$var$K;
    $d37c4c3cfd90dfc6$var$K |= 1;
    try {
        return a(b);
    } finally{
        $d37c4c3cfd90dfc6$var$K = c, 0 === $d37c4c3cfd90dfc6$var$K && ($d37c4c3cfd90dfc6$var$Gj = $d37c4c3cfd90dfc6$var$B() + 500, $d37c4c3cfd90dfc6$var$fg && $d37c4c3cfd90dfc6$var$jg());
    }
}
function $d37c4c3cfd90dfc6$var$Rk(a) {
    null !== $d37c4c3cfd90dfc6$var$wk && 0 === $d37c4c3cfd90dfc6$var$wk.tag && 0 === ($d37c4c3cfd90dfc6$var$K & 6) && $d37c4c3cfd90dfc6$var$Hk();
    var b = $d37c4c3cfd90dfc6$var$K;
    $d37c4c3cfd90dfc6$var$K |= 1;
    var c = $d37c4c3cfd90dfc6$var$ok.transition, d = $d37c4c3cfd90dfc6$var$C;
    try {
        if ($d37c4c3cfd90dfc6$var$ok.transition = null, $d37c4c3cfd90dfc6$var$C = 1, a) return a();
    } finally{
        $d37c4c3cfd90dfc6$var$C = d, $d37c4c3cfd90dfc6$var$ok.transition = c, $d37c4c3cfd90dfc6$var$K = b, 0 === ($d37c4c3cfd90dfc6$var$K & 6) && $d37c4c3cfd90dfc6$var$jg();
    }
}
function $d37c4c3cfd90dfc6$var$Hj() {
    $d37c4c3cfd90dfc6$var$fj = $d37c4c3cfd90dfc6$var$ej.current;
    $d37c4c3cfd90dfc6$var$E($d37c4c3cfd90dfc6$var$ej);
}
function $d37c4c3cfd90dfc6$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $d37c4c3cfd90dfc6$var$Gf(c));
    if (null !== $d37c4c3cfd90dfc6$var$Y) for(c = $d37c4c3cfd90dfc6$var$Y.return; null !== c;){
        var d = c;
        $d37c4c3cfd90dfc6$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $d37c4c3cfd90dfc6$var$$f();
                break;
            case 3:
                $d37c4c3cfd90dfc6$var$zh();
                $d37c4c3cfd90dfc6$var$E($d37c4c3cfd90dfc6$var$Wf);
                $d37c4c3cfd90dfc6$var$E($d37c4c3cfd90dfc6$var$H);
                $d37c4c3cfd90dfc6$var$Eh();
                break;
            case 5:
                $d37c4c3cfd90dfc6$var$Bh(d);
                break;
            case 4:
                $d37c4c3cfd90dfc6$var$zh();
                break;
            case 13:
                $d37c4c3cfd90dfc6$var$E($d37c4c3cfd90dfc6$var$L);
                break;
            case 19:
                $d37c4c3cfd90dfc6$var$E($d37c4c3cfd90dfc6$var$L);
                break;
            case 10:
                $d37c4c3cfd90dfc6$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $d37c4c3cfd90dfc6$var$Hj();
        }
        c = c.return;
    }
    $d37c4c3cfd90dfc6$var$Q = a;
    $d37c4c3cfd90dfc6$var$Y = a = $d37c4c3cfd90dfc6$var$Pg(a.current, null);
    $d37c4c3cfd90dfc6$var$Z = $d37c4c3cfd90dfc6$var$fj = b;
    $d37c4c3cfd90dfc6$var$T = 0;
    $d37c4c3cfd90dfc6$var$pk = null;
    $d37c4c3cfd90dfc6$var$rk = $d37c4c3cfd90dfc6$var$qk = $d37c4c3cfd90dfc6$var$rh = 0;
    $d37c4c3cfd90dfc6$var$tk = $d37c4c3cfd90dfc6$var$sk = null;
    if (null !== $d37c4c3cfd90dfc6$var$fh) {
        for(b = 0; b < $d37c4c3cfd90dfc6$var$fh.length; b++)if (c = $d37c4c3cfd90dfc6$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $d37c4c3cfd90dfc6$var$fh = null;
    }
    return a;
}
function $d37c4c3cfd90dfc6$var$Mk(a, b) {
    do {
        var c = $d37c4c3cfd90dfc6$var$Y;
        try {
            $d37c4c3cfd90dfc6$var$$g();
            $d37c4c3cfd90dfc6$var$Fh.current = $d37c4c3cfd90dfc6$var$Rh;
            if ($d37c4c3cfd90dfc6$var$Ih) {
                for(var d = $d37c4c3cfd90dfc6$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $d37c4c3cfd90dfc6$var$Ih = !1;
            }
            $d37c4c3cfd90dfc6$var$Hh = 0;
            $d37c4c3cfd90dfc6$var$O = $d37c4c3cfd90dfc6$var$N = $d37c4c3cfd90dfc6$var$M = null;
            $d37c4c3cfd90dfc6$var$Jh = !1;
            $d37c4c3cfd90dfc6$var$Kh = 0;
            $d37c4c3cfd90dfc6$var$nk.current = null;
            if (null === c || null === c.return) {
                $d37c4c3cfd90dfc6$var$T = 1;
                $d37c4c3cfd90dfc6$var$pk = b;
                $d37c4c3cfd90dfc6$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $d37c4c3cfd90dfc6$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $d37c4c3cfd90dfc6$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $d37c4c3cfd90dfc6$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $d37c4c3cfd90dfc6$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $d37c4c3cfd90dfc6$var$Si(f, l, b);
                            $d37c4c3cfd90dfc6$var$tj();
                            break a;
                        }
                        k = Error($d37c4c3cfd90dfc6$var$p(426));
                    }
                } else if ($d37c4c3cfd90dfc6$var$I && h.mode & 1) {
                    var J = $d37c4c3cfd90dfc6$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $d37c4c3cfd90dfc6$var$Vi(J, g, h, f, b);
                        $d37c4c3cfd90dfc6$var$Jg($d37c4c3cfd90dfc6$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $d37c4c3cfd90dfc6$var$Ji(k, h);
                4 !== $d37c4c3cfd90dfc6$var$T && ($d37c4c3cfd90dfc6$var$T = 2);
                null === $d37c4c3cfd90dfc6$var$sk ? $d37c4c3cfd90dfc6$var$sk = [
                    f
                ] : $d37c4c3cfd90dfc6$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $d37c4c3cfd90dfc6$var$Ni(f, k, b);
                            $d37c4c3cfd90dfc6$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $d37c4c3cfd90dfc6$var$Ri || !$d37c4c3cfd90dfc6$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $d37c4c3cfd90dfc6$var$Qi(f, h, b);
                                $d37c4c3cfd90dfc6$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $d37c4c3cfd90dfc6$var$Sk(c);
        } catch (na) {
            b = na;
            $d37c4c3cfd90dfc6$var$Y === c && null !== c && ($d37c4c3cfd90dfc6$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $d37c4c3cfd90dfc6$var$Jk() {
    var a = $d37c4c3cfd90dfc6$var$mk.current;
    $d37c4c3cfd90dfc6$var$mk.current = $d37c4c3cfd90dfc6$var$Rh;
    return null === a ? $d37c4c3cfd90dfc6$var$Rh : a;
}
function $d37c4c3cfd90dfc6$var$tj() {
    if (0 === $d37c4c3cfd90dfc6$var$T || 3 === $d37c4c3cfd90dfc6$var$T || 2 === $d37c4c3cfd90dfc6$var$T) $d37c4c3cfd90dfc6$var$T = 4;
    null === $d37c4c3cfd90dfc6$var$Q || 0 === ($d37c4c3cfd90dfc6$var$rh & 268435455) && 0 === ($d37c4c3cfd90dfc6$var$qk & 268435455) || $d37c4c3cfd90dfc6$var$Ck($d37c4c3cfd90dfc6$var$Q, $d37c4c3cfd90dfc6$var$Z);
}
function $d37c4c3cfd90dfc6$var$Ik(a, b) {
    var c = $d37c4c3cfd90dfc6$var$K;
    $d37c4c3cfd90dfc6$var$K |= 2;
    var d = $d37c4c3cfd90dfc6$var$Jk();
    if ($d37c4c3cfd90dfc6$var$Q !== a || $d37c4c3cfd90dfc6$var$Z !== b) $d37c4c3cfd90dfc6$var$uk = null, $d37c4c3cfd90dfc6$var$Kk(a, b);
    for(;;)try {
        $d37c4c3cfd90dfc6$var$Tk();
        break;
    } catch (e) {
        $d37c4c3cfd90dfc6$var$Mk(a, e);
    }
    $d37c4c3cfd90dfc6$var$$g();
    $d37c4c3cfd90dfc6$var$K = c;
    $d37c4c3cfd90dfc6$var$mk.current = d;
    if (null !== $d37c4c3cfd90dfc6$var$Y) throw Error($d37c4c3cfd90dfc6$var$p(261));
    $d37c4c3cfd90dfc6$var$Q = null;
    $d37c4c3cfd90dfc6$var$Z = 0;
    return $d37c4c3cfd90dfc6$var$T;
}
function $d37c4c3cfd90dfc6$var$Tk() {
    for(; null !== $d37c4c3cfd90dfc6$var$Y;)$d37c4c3cfd90dfc6$var$Uk($d37c4c3cfd90dfc6$var$Y);
}
function $d37c4c3cfd90dfc6$var$Lk() {
    for(; null !== $d37c4c3cfd90dfc6$var$Y && !$d37c4c3cfd90dfc6$var$cc();)$d37c4c3cfd90dfc6$var$Uk($d37c4c3cfd90dfc6$var$Y);
}
function $d37c4c3cfd90dfc6$var$Uk(a) {
    var b = $d37c4c3cfd90dfc6$var$Vk(a.alternate, a, $d37c4c3cfd90dfc6$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $d37c4c3cfd90dfc6$var$Sk(a) : $d37c4c3cfd90dfc6$var$Y = b;
    $d37c4c3cfd90dfc6$var$nk.current = null;
}
function $d37c4c3cfd90dfc6$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $d37c4c3cfd90dfc6$var$Ej(c, b, $d37c4c3cfd90dfc6$var$fj), null !== c) {
                $d37c4c3cfd90dfc6$var$Y = c;
                return;
            }
        } else {
            c = $d37c4c3cfd90dfc6$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $d37c4c3cfd90dfc6$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $d37c4c3cfd90dfc6$var$T = 6;
                $d37c4c3cfd90dfc6$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $d37c4c3cfd90dfc6$var$Y = b;
            return;
        }
        $d37c4c3cfd90dfc6$var$Y = b = a;
    }while (null !== b);
    0 === $d37c4c3cfd90dfc6$var$T && ($d37c4c3cfd90dfc6$var$T = 5);
}
function $d37c4c3cfd90dfc6$var$Pk(a, b, c) {
    var d = $d37c4c3cfd90dfc6$var$C, e = $d37c4c3cfd90dfc6$var$ok.transition;
    try {
        $d37c4c3cfd90dfc6$var$ok.transition = null, $d37c4c3cfd90dfc6$var$C = 1, $d37c4c3cfd90dfc6$var$Wk(a, b, c, d);
    } finally{
        $d37c4c3cfd90dfc6$var$ok.transition = e, $d37c4c3cfd90dfc6$var$C = d;
    }
    return null;
}
function $d37c4c3cfd90dfc6$var$Wk(a, b, c, d) {
    do $d37c4c3cfd90dfc6$var$Hk();
    while (null !== $d37c4c3cfd90dfc6$var$wk);
    if (0 !== ($d37c4c3cfd90dfc6$var$K & 6)) throw Error($d37c4c3cfd90dfc6$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($d37c4c3cfd90dfc6$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $d37c4c3cfd90dfc6$var$Bc(a, f);
    a === $d37c4c3cfd90dfc6$var$Q && ($d37c4c3cfd90dfc6$var$Y = $d37c4c3cfd90dfc6$var$Q = null, $d37c4c3cfd90dfc6$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $d37c4c3cfd90dfc6$var$vk || ($d37c4c3cfd90dfc6$var$vk = !0, $d37c4c3cfd90dfc6$var$Fk($d37c4c3cfd90dfc6$var$hc, function() {
        $d37c4c3cfd90dfc6$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $d37c4c3cfd90dfc6$var$ok.transition;
        $d37c4c3cfd90dfc6$var$ok.transition = null;
        var g = $d37c4c3cfd90dfc6$var$C;
        $d37c4c3cfd90dfc6$var$C = 1;
        var h = $d37c4c3cfd90dfc6$var$K;
        $d37c4c3cfd90dfc6$var$K |= 4;
        $d37c4c3cfd90dfc6$var$nk.current = null;
        $d37c4c3cfd90dfc6$var$Oj(a, c);
        $d37c4c3cfd90dfc6$var$dk(c, a);
        $d37c4c3cfd90dfc6$var$Oe($d37c4c3cfd90dfc6$var$Df);
        $d37c4c3cfd90dfc6$var$dd = !!$d37c4c3cfd90dfc6$var$Cf;
        $d37c4c3cfd90dfc6$var$Df = $d37c4c3cfd90dfc6$var$Cf = null;
        a.current = c;
        $d37c4c3cfd90dfc6$var$hk(c, a, e);
        $d37c4c3cfd90dfc6$var$dc();
        $d37c4c3cfd90dfc6$var$K = h;
        $d37c4c3cfd90dfc6$var$C = g;
        $d37c4c3cfd90dfc6$var$ok.transition = f;
    } else a.current = c;
    $d37c4c3cfd90dfc6$var$vk && ($d37c4c3cfd90dfc6$var$vk = !1, $d37c4c3cfd90dfc6$var$wk = a, $d37c4c3cfd90dfc6$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($d37c4c3cfd90dfc6$var$Ri = null);
    $d37c4c3cfd90dfc6$var$mc(c.stateNode, d);
    $d37c4c3cfd90dfc6$var$Dk(a, $d37c4c3cfd90dfc6$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($d37c4c3cfd90dfc6$var$Oi) throw $d37c4c3cfd90dfc6$var$Oi = !1, a = $d37c4c3cfd90dfc6$var$Pi, $d37c4c3cfd90dfc6$var$Pi = null, a;
    0 !== ($d37c4c3cfd90dfc6$var$xk & 1) && 0 !== a.tag && $d37c4c3cfd90dfc6$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $d37c4c3cfd90dfc6$var$zk ? $d37c4c3cfd90dfc6$var$yk++ : ($d37c4c3cfd90dfc6$var$yk = 0, $d37c4c3cfd90dfc6$var$zk = a) : $d37c4c3cfd90dfc6$var$yk = 0;
    $d37c4c3cfd90dfc6$var$jg();
    return null;
}
function $d37c4c3cfd90dfc6$var$Hk() {
    if (null !== $d37c4c3cfd90dfc6$var$wk) {
        var a = $d37c4c3cfd90dfc6$var$Dc($d37c4c3cfd90dfc6$var$xk), b = $d37c4c3cfd90dfc6$var$ok.transition, c = $d37c4c3cfd90dfc6$var$C;
        try {
            $d37c4c3cfd90dfc6$var$ok.transition = null;
            $d37c4c3cfd90dfc6$var$C = 16 > a ? 16 : a;
            if (null === $d37c4c3cfd90dfc6$var$wk) var d = !1;
            else {
                a = $d37c4c3cfd90dfc6$var$wk;
                $d37c4c3cfd90dfc6$var$wk = null;
                $d37c4c3cfd90dfc6$var$xk = 0;
                if (0 !== ($d37c4c3cfd90dfc6$var$K & 6)) throw Error($d37c4c3cfd90dfc6$var$p(331));
                var e = $d37c4c3cfd90dfc6$var$K;
                $d37c4c3cfd90dfc6$var$K |= 4;
                for($d37c4c3cfd90dfc6$var$V = a.current; null !== $d37c4c3cfd90dfc6$var$V;){
                    var f = $d37c4c3cfd90dfc6$var$V, g = f.child;
                    if (0 !== ($d37c4c3cfd90dfc6$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($d37c4c3cfd90dfc6$var$V = l; null !== $d37c4c3cfd90dfc6$var$V;){
                                    var m = $d37c4c3cfd90dfc6$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $d37c4c3cfd90dfc6$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $d37c4c3cfd90dfc6$var$V = q;
                                    else for(; null !== $d37c4c3cfd90dfc6$var$V;){
                                        m = $d37c4c3cfd90dfc6$var$V;
                                        var r = m.sibling, y = m.return;
                                        $d37c4c3cfd90dfc6$var$Sj(m);
                                        if (m === l) {
                                            $d37c4c3cfd90dfc6$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $d37c4c3cfd90dfc6$var$V = r;
                                            break;
                                        }
                                        $d37c4c3cfd90dfc6$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $d37c4c3cfd90dfc6$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $d37c4c3cfd90dfc6$var$V = g;
                    else b: for(; null !== $d37c4c3cfd90dfc6$var$V;){
                        f = $d37c4c3cfd90dfc6$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $d37c4c3cfd90dfc6$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $d37c4c3cfd90dfc6$var$V = x;
                            break b;
                        }
                        $d37c4c3cfd90dfc6$var$V = f.return;
                    }
                }
                var w = a.current;
                for($d37c4c3cfd90dfc6$var$V = w; null !== $d37c4c3cfd90dfc6$var$V;){
                    g = $d37c4c3cfd90dfc6$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $d37c4c3cfd90dfc6$var$V = u;
                    else b: for(g = w; null !== $d37c4c3cfd90dfc6$var$V;){
                        h = $d37c4c3cfd90dfc6$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $d37c4c3cfd90dfc6$var$Qj(9, h);
                            }
                        } catch (na) {
                            $d37c4c3cfd90dfc6$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $d37c4c3cfd90dfc6$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $d37c4c3cfd90dfc6$var$V = F;
                            break b;
                        }
                        $d37c4c3cfd90dfc6$var$V = h.return;
                    }
                }
                $d37c4c3cfd90dfc6$var$K = e;
                $d37c4c3cfd90dfc6$var$jg();
                if ($d37c4c3cfd90dfc6$var$lc && "function" === typeof $d37c4c3cfd90dfc6$var$lc.onPostCommitFiberRoot) try {
                    $d37c4c3cfd90dfc6$var$lc.onPostCommitFiberRoot($d37c4c3cfd90dfc6$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $d37c4c3cfd90dfc6$var$C = c, $d37c4c3cfd90dfc6$var$ok.transition = b;
        }
    }
    return !1;
}
function $d37c4c3cfd90dfc6$var$Xk(a, b, c) {
    b = $d37c4c3cfd90dfc6$var$Ji(c, b);
    b = $d37c4c3cfd90dfc6$var$Ni(a, b, 1);
    a = $d37c4c3cfd90dfc6$var$nh(a, b, 1);
    b = $d37c4c3cfd90dfc6$var$R();
    null !== a && ($d37c4c3cfd90dfc6$var$Ac(a, 1, b), $d37c4c3cfd90dfc6$var$Dk(a, b));
}
function $d37c4c3cfd90dfc6$var$W(a, b, c) {
    if (3 === a.tag) $d37c4c3cfd90dfc6$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $d37c4c3cfd90dfc6$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $d37c4c3cfd90dfc6$var$Ri || !$d37c4c3cfd90dfc6$var$Ri.has(d))) {
                a = $d37c4c3cfd90dfc6$var$Ji(c, a);
                a = $d37c4c3cfd90dfc6$var$Qi(b, a, 1);
                b = $d37c4c3cfd90dfc6$var$nh(b, a, 1);
                a = $d37c4c3cfd90dfc6$var$R();
                null !== b && ($d37c4c3cfd90dfc6$var$Ac(b, 1, a), $d37c4c3cfd90dfc6$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $d37c4c3cfd90dfc6$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $d37c4c3cfd90dfc6$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $d37c4c3cfd90dfc6$var$Q === a && ($d37c4c3cfd90dfc6$var$Z & c) === c && (4 === $d37c4c3cfd90dfc6$var$T || 3 === $d37c4c3cfd90dfc6$var$T && ($d37c4c3cfd90dfc6$var$Z & 130023424) === $d37c4c3cfd90dfc6$var$Z && 500 > $d37c4c3cfd90dfc6$var$B() - $d37c4c3cfd90dfc6$var$fk ? $d37c4c3cfd90dfc6$var$Kk(a, 0) : $d37c4c3cfd90dfc6$var$rk |= c);
    $d37c4c3cfd90dfc6$var$Dk(a, b);
}
function $d37c4c3cfd90dfc6$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $d37c4c3cfd90dfc6$var$sc, $d37c4c3cfd90dfc6$var$sc <<= 1, 0 === ($d37c4c3cfd90dfc6$var$sc & 130023424) && ($d37c4c3cfd90dfc6$var$sc = 4194304)));
    var c = $d37c4c3cfd90dfc6$var$R();
    a = $d37c4c3cfd90dfc6$var$ih(a, b);
    null !== a && ($d37c4c3cfd90dfc6$var$Ac(a, b, c), $d37c4c3cfd90dfc6$var$Dk(a, c));
}
function $d37c4c3cfd90dfc6$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $d37c4c3cfd90dfc6$var$Yk(a, c);
}
function $d37c4c3cfd90dfc6$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($d37c4c3cfd90dfc6$var$p(314));
    }
    null !== d && d.delete(b);
    $d37c4c3cfd90dfc6$var$Yk(a, c);
}
var $d37c4c3cfd90dfc6$var$Vk;
$d37c4c3cfd90dfc6$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $d37c4c3cfd90dfc6$var$Wf.current) $d37c4c3cfd90dfc6$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $d37c4c3cfd90dfc6$var$dh = !1, $d37c4c3cfd90dfc6$var$yj(a, b, c);
            $d37c4c3cfd90dfc6$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $d37c4c3cfd90dfc6$var$dh = !1, $d37c4c3cfd90dfc6$var$I && 0 !== (b.flags & 1048576) && $d37c4c3cfd90dfc6$var$ug(b, $d37c4c3cfd90dfc6$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $d37c4c3cfd90dfc6$var$ij(a, b);
            a = b.pendingProps;
            var e = $d37c4c3cfd90dfc6$var$Yf(b, $d37c4c3cfd90dfc6$var$H.current);
            $d37c4c3cfd90dfc6$var$ch(b, c);
            e = $d37c4c3cfd90dfc6$var$Nh(null, b, d, a, e, c);
            var f = $d37c4c3cfd90dfc6$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $d37c4c3cfd90dfc6$var$Zf(d) ? (f = !0, $d37c4c3cfd90dfc6$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $d37c4c3cfd90dfc6$var$kh(b), e.updater = $d37c4c3cfd90dfc6$var$Ei, b.stateNode = e, e._reactInternals = b, $d37c4c3cfd90dfc6$var$Ii(b, d, a, c), b = $d37c4c3cfd90dfc6$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $d37c4c3cfd90dfc6$var$I && f && $d37c4c3cfd90dfc6$var$vg(b), $d37c4c3cfd90dfc6$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $d37c4c3cfd90dfc6$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $d37c4c3cfd90dfc6$var$Zk(d);
                a = $d37c4c3cfd90dfc6$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $d37c4c3cfd90dfc6$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $d37c4c3cfd90dfc6$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $d37c4c3cfd90dfc6$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $d37c4c3cfd90dfc6$var$$i(null, b, d, $d37c4c3cfd90dfc6$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($d37c4c3cfd90dfc6$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $d37c4c3cfd90dfc6$var$Ci(d, e), $d37c4c3cfd90dfc6$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $d37c4c3cfd90dfc6$var$Ci(d, e), $d37c4c3cfd90dfc6$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $d37c4c3cfd90dfc6$var$kj(b);
                if (null === a) throw Error($d37c4c3cfd90dfc6$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $d37c4c3cfd90dfc6$var$lh(a, b);
                $d37c4c3cfd90dfc6$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $d37c4c3cfd90dfc6$var$Ji(Error($d37c4c3cfd90dfc6$var$p(423)), b);
                        b = $d37c4c3cfd90dfc6$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $d37c4c3cfd90dfc6$var$Ji(Error($d37c4c3cfd90dfc6$var$p(424)), b);
                        b = $d37c4c3cfd90dfc6$var$lj(a, b, d, c, e);
                        break a;
                    } else for($d37c4c3cfd90dfc6$var$yg = $d37c4c3cfd90dfc6$var$Lf(b.stateNode.containerInfo.firstChild), $d37c4c3cfd90dfc6$var$xg = b, $d37c4c3cfd90dfc6$var$I = !0, $d37c4c3cfd90dfc6$var$zg = null, c = $d37c4c3cfd90dfc6$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $d37c4c3cfd90dfc6$var$Ig();
                    if (d === e) {
                        b = $d37c4c3cfd90dfc6$var$Zi(a, b, c);
                        break a;
                    }
                    $d37c4c3cfd90dfc6$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $d37c4c3cfd90dfc6$var$Ah(b), null === a && $d37c4c3cfd90dfc6$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $d37c4c3cfd90dfc6$var$Ef(d, e) ? g = null : null !== f && $d37c4c3cfd90dfc6$var$Ef(d, f) && (b.flags |= 32), $d37c4c3cfd90dfc6$var$gj(a, b), $d37c4c3cfd90dfc6$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $d37c4c3cfd90dfc6$var$Eg(b), null;
        case 13:
            return $d37c4c3cfd90dfc6$var$oj(a, b, c);
        case 4:
            return $d37c4c3cfd90dfc6$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $d37c4c3cfd90dfc6$var$Ug(b, null, d, c) : $d37c4c3cfd90dfc6$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $d37c4c3cfd90dfc6$var$Ci(d, e), $d37c4c3cfd90dfc6$var$Yi(a, b, d, e, c);
        case 7:
            return $d37c4c3cfd90dfc6$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $d37c4c3cfd90dfc6$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $d37c4c3cfd90dfc6$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $d37c4c3cfd90dfc6$var$G($d37c4c3cfd90dfc6$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($d37c4c3cfd90dfc6$var$He(f.value, g)) {
                        if (f.children === e.children && !$d37c4c3cfd90dfc6$var$Wf.current) {
                            b = $d37c4c3cfd90dfc6$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $d37c4c3cfd90dfc6$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $d37c4c3cfd90dfc6$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($d37c4c3cfd90dfc6$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $d37c4c3cfd90dfc6$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $d37c4c3cfd90dfc6$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $d37c4c3cfd90dfc6$var$ch(b, c), e = $d37c4c3cfd90dfc6$var$eh(e), d = d(e), b.flags |= 1, $d37c4c3cfd90dfc6$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $d37c4c3cfd90dfc6$var$Ci(d, b.pendingProps), e = $d37c4c3cfd90dfc6$var$Ci(d.type, e), $d37c4c3cfd90dfc6$var$$i(a, b, d, e, c);
        case 15:
            return $d37c4c3cfd90dfc6$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $d37c4c3cfd90dfc6$var$Ci(d, e), $d37c4c3cfd90dfc6$var$ij(a, b), b.tag = 1, $d37c4c3cfd90dfc6$var$Zf(d) ? (a = !0, $d37c4c3cfd90dfc6$var$cg(b)) : a = !1, $d37c4c3cfd90dfc6$var$ch(b, c), $d37c4c3cfd90dfc6$var$Gi(b, d, e), $d37c4c3cfd90dfc6$var$Ii(b, d, e, c), $d37c4c3cfd90dfc6$var$jj(null, b, d, !0, a, c);
        case 19:
            return $d37c4c3cfd90dfc6$var$xj(a, b, c);
        case 22:
            return $d37c4c3cfd90dfc6$var$dj(a, b, c);
    }
    throw Error($d37c4c3cfd90dfc6$var$p(156, b.tag));
};
function $d37c4c3cfd90dfc6$var$Fk(a, b) {
    return $d37c4c3cfd90dfc6$var$ac(a, b);
}
function $d37c4c3cfd90dfc6$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $d37c4c3cfd90dfc6$var$Bg(a, b, c, d) {
    return new $d37c4c3cfd90dfc6$var$$k(a, b, c, d);
}
function $d37c4c3cfd90dfc6$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $d37c4c3cfd90dfc6$var$Zk(a) {
    if ("function" === typeof a) return $d37c4c3cfd90dfc6$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $d37c4c3cfd90dfc6$var$Da) return 11;
        if (a === $d37c4c3cfd90dfc6$var$Ga) return 14;
    }
    return 2;
}
function $d37c4c3cfd90dfc6$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $d37c4c3cfd90dfc6$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $d37c4c3cfd90dfc6$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $d37c4c3cfd90dfc6$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $d37c4c3cfd90dfc6$var$ya:
            return $d37c4c3cfd90dfc6$var$Tg(c.children, e, f, b);
        case $d37c4c3cfd90dfc6$var$za:
            g = 8;
            e |= 8;
            break;
        case $d37c4c3cfd90dfc6$var$Aa:
            return a = $d37c4c3cfd90dfc6$var$Bg(12, c, b, e | 2), a.elementType = $d37c4c3cfd90dfc6$var$Aa, a.lanes = f, a;
        case $d37c4c3cfd90dfc6$var$Ea:
            return a = $d37c4c3cfd90dfc6$var$Bg(13, c, b, e), a.elementType = $d37c4c3cfd90dfc6$var$Ea, a.lanes = f, a;
        case $d37c4c3cfd90dfc6$var$Fa:
            return a = $d37c4c3cfd90dfc6$var$Bg(19, c, b, e), a.elementType = $d37c4c3cfd90dfc6$var$Fa, a.lanes = f, a;
        case $d37c4c3cfd90dfc6$var$Ia:
            return $d37c4c3cfd90dfc6$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $d37c4c3cfd90dfc6$var$Ba:
                    g = 10;
                    break a;
                case $d37c4c3cfd90dfc6$var$Ca:
                    g = 9;
                    break a;
                case $d37c4c3cfd90dfc6$var$Da:
                    g = 11;
                    break a;
                case $d37c4c3cfd90dfc6$var$Ga:
                    g = 14;
                    break a;
                case $d37c4c3cfd90dfc6$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($d37c4c3cfd90dfc6$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $d37c4c3cfd90dfc6$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $d37c4c3cfd90dfc6$var$Tg(a, b, c, d) {
    a = $d37c4c3cfd90dfc6$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $d37c4c3cfd90dfc6$var$pj(a, b, c, d) {
    a = $d37c4c3cfd90dfc6$var$Bg(22, a, d, b);
    a.elementType = $d37c4c3cfd90dfc6$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $d37c4c3cfd90dfc6$var$Qg(a, b, c) {
    a = $d37c4c3cfd90dfc6$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $d37c4c3cfd90dfc6$var$Sg(a, b, c) {
    b = $d37c4c3cfd90dfc6$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $d37c4c3cfd90dfc6$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $d37c4c3cfd90dfc6$var$zc(0);
    this.expirationTimes = $d37c4c3cfd90dfc6$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $d37c4c3cfd90dfc6$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $d37c4c3cfd90dfc6$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $d37c4c3cfd90dfc6$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $d37c4c3cfd90dfc6$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $d37c4c3cfd90dfc6$var$kh(f);
    return a;
}
function $d37c4c3cfd90dfc6$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $d37c4c3cfd90dfc6$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $d37c4c3cfd90dfc6$var$dl(a) {
    if (!a) return $d37c4c3cfd90dfc6$var$Vf;
    a = a._reactInternals;
    a: {
        if ($d37c4c3cfd90dfc6$var$Vb(a) !== a || 1 !== a.tag) throw Error($d37c4c3cfd90dfc6$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($d37c4c3cfd90dfc6$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($d37c4c3cfd90dfc6$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($d37c4c3cfd90dfc6$var$Zf(c)) return $d37c4c3cfd90dfc6$var$bg(a, c, b);
    }
    return b;
}
function $d37c4c3cfd90dfc6$var$el(a, b, c, d, e, f, g, h, k) {
    a = $d37c4c3cfd90dfc6$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $d37c4c3cfd90dfc6$var$dl(null);
    c = a.current;
    d = $d37c4c3cfd90dfc6$var$R();
    e = $d37c4c3cfd90dfc6$var$yi(c);
    f = $d37c4c3cfd90dfc6$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $d37c4c3cfd90dfc6$var$nh(c, f, e);
    a.current.lanes = e;
    $d37c4c3cfd90dfc6$var$Ac(a, e, d);
    $d37c4c3cfd90dfc6$var$Dk(a, d);
    return a;
}
function $d37c4c3cfd90dfc6$var$fl(a, b, c, d) {
    var e = b.current, f = $d37c4c3cfd90dfc6$var$R(), g = $d37c4c3cfd90dfc6$var$yi(e);
    c = $d37c4c3cfd90dfc6$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $d37c4c3cfd90dfc6$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $d37c4c3cfd90dfc6$var$nh(e, b, g);
    null !== a && ($d37c4c3cfd90dfc6$var$gi(a, e, g, f), $d37c4c3cfd90dfc6$var$oh(a, e, g));
    return g;
}
function $d37c4c3cfd90dfc6$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $d37c4c3cfd90dfc6$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $d37c4c3cfd90dfc6$var$il(a, b) {
    $d37c4c3cfd90dfc6$var$hl(a, b);
    (a = a.alternate) && $d37c4c3cfd90dfc6$var$hl(a, b);
}
function $d37c4c3cfd90dfc6$var$jl() {
    return null;
}
var $d37c4c3cfd90dfc6$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $d37c4c3cfd90dfc6$var$ll(a) {
    this._internalRoot = a;
}
$d37c4c3cfd90dfc6$var$ml.prototype.render = $d37c4c3cfd90dfc6$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($d37c4c3cfd90dfc6$var$p(409));
    $d37c4c3cfd90dfc6$var$fl(a, b, null, null);
};
$d37c4c3cfd90dfc6$var$ml.prototype.unmount = $d37c4c3cfd90dfc6$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $d37c4c3cfd90dfc6$var$Rk(function() {
            $d37c4c3cfd90dfc6$var$fl(null, a, null, null);
        });
        b[$d37c4c3cfd90dfc6$var$uf] = null;
    }
};
function $d37c4c3cfd90dfc6$var$ml(a) {
    this._internalRoot = a;
}
$d37c4c3cfd90dfc6$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $d37c4c3cfd90dfc6$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $d37c4c3cfd90dfc6$var$Qc.length && 0 !== b && b < $d37c4c3cfd90dfc6$var$Qc[c].priority; c++);
        $d37c4c3cfd90dfc6$var$Qc.splice(c, 0, a);
        0 === c && $d37c4c3cfd90dfc6$var$Vc(a);
    }
};
function $d37c4c3cfd90dfc6$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $d37c4c3cfd90dfc6$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $d37c4c3cfd90dfc6$var$pl() {}
function $d37c4c3cfd90dfc6$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $d37c4c3cfd90dfc6$var$gl(g);
                f.call(a);
            };
        }
        var g = $d37c4c3cfd90dfc6$var$el(b, d, a, 0, null, !1, !1, "", $d37c4c3cfd90dfc6$var$pl);
        a._reactRootContainer = g;
        a[$d37c4c3cfd90dfc6$var$uf] = g.current;
        $d37c4c3cfd90dfc6$var$sf(8 === a.nodeType ? a.parentNode : a);
        $d37c4c3cfd90dfc6$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $d37c4c3cfd90dfc6$var$gl(k);
            h.call(a);
        };
    }
    var k = $d37c4c3cfd90dfc6$var$bl(a, 0, !1, null, null, !1, !1, "", $d37c4c3cfd90dfc6$var$pl);
    a._reactRootContainer = k;
    a[$d37c4c3cfd90dfc6$var$uf] = k.current;
    $d37c4c3cfd90dfc6$var$sf(8 === a.nodeType ? a.parentNode : a);
    $d37c4c3cfd90dfc6$var$Rk(function() {
        $d37c4c3cfd90dfc6$var$fl(b, k, c, d);
    });
    return k;
}
function $d37c4c3cfd90dfc6$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $d37c4c3cfd90dfc6$var$gl(g);
                h.call(a);
            };
        }
        $d37c4c3cfd90dfc6$var$fl(b, g, a, e);
    } else g = $d37c4c3cfd90dfc6$var$ql(c, b, a, e, d);
    return $d37c4c3cfd90dfc6$var$gl(g);
}
$d37c4c3cfd90dfc6$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $d37c4c3cfd90dfc6$var$tc(b.pendingLanes);
                0 !== c && ($d37c4c3cfd90dfc6$var$Cc(b, c | 1), $d37c4c3cfd90dfc6$var$Dk(b, $d37c4c3cfd90dfc6$var$B()), 0 === ($d37c4c3cfd90dfc6$var$K & 6) && ($d37c4c3cfd90dfc6$var$Gj = $d37c4c3cfd90dfc6$var$B() + 500, $d37c4c3cfd90dfc6$var$jg()));
            }
            break;
        case 13:
            $d37c4c3cfd90dfc6$var$Rk(function() {
                var b = $d37c4c3cfd90dfc6$var$ih(a, 1);
                if (null !== b) {
                    var c = $d37c4c3cfd90dfc6$var$R();
                    $d37c4c3cfd90dfc6$var$gi(b, a, 1, c);
                }
            }), $d37c4c3cfd90dfc6$var$il(a, 1);
    }
};
$d37c4c3cfd90dfc6$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $d37c4c3cfd90dfc6$var$ih(a, 134217728);
        if (null !== b) {
            var c = $d37c4c3cfd90dfc6$var$R();
            $d37c4c3cfd90dfc6$var$gi(b, a, 134217728, c);
        }
        $d37c4c3cfd90dfc6$var$il(a, 134217728);
    }
};
$d37c4c3cfd90dfc6$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $d37c4c3cfd90dfc6$var$yi(a), c = $d37c4c3cfd90dfc6$var$ih(a, b);
        if (null !== c) {
            var d = $d37c4c3cfd90dfc6$var$R();
            $d37c4c3cfd90dfc6$var$gi(c, a, b, d);
        }
        $d37c4c3cfd90dfc6$var$il(a, b);
    }
};
$d37c4c3cfd90dfc6$var$Hc = function() {
    return $d37c4c3cfd90dfc6$var$C;
};
$d37c4c3cfd90dfc6$var$Ic = function(a, b) {
    var c = $d37c4c3cfd90dfc6$var$C;
    try {
        return $d37c4c3cfd90dfc6$var$C = a, b();
    } finally{
        $d37c4c3cfd90dfc6$var$C = c;
    }
};
$d37c4c3cfd90dfc6$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $d37c4c3cfd90dfc6$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $d37c4c3cfd90dfc6$var$Db(d);
                        if (!e) throw Error($d37c4c3cfd90dfc6$var$p(90));
                        $d37c4c3cfd90dfc6$var$Wa(d);
                        $d37c4c3cfd90dfc6$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $d37c4c3cfd90dfc6$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $d37c4c3cfd90dfc6$var$fb(a, !!c.multiple, b, !1);
    }
};
$d37c4c3cfd90dfc6$var$Gb = $d37c4c3cfd90dfc6$var$Qk;
$d37c4c3cfd90dfc6$var$Hb = $d37c4c3cfd90dfc6$var$Rk;
var $d37c4c3cfd90dfc6$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $d37c4c3cfd90dfc6$var$Cb,
        $d37c4c3cfd90dfc6$var$ue,
        $d37c4c3cfd90dfc6$var$Db,
        $d37c4c3cfd90dfc6$var$Eb,
        $d37c4c3cfd90dfc6$var$Fb,
        $d37c4c3cfd90dfc6$var$Qk
    ]
}, $d37c4c3cfd90dfc6$var$tl = {
    findFiberByHostInstance: $d37c4c3cfd90dfc6$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $d37c4c3cfd90dfc6$var$ul = {
    bundleType: $d37c4c3cfd90dfc6$var$tl.bundleType,
    version: $d37c4c3cfd90dfc6$var$tl.version,
    rendererPackageName: $d37c4c3cfd90dfc6$var$tl.rendererPackageName,
    rendererConfig: $d37c4c3cfd90dfc6$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $d37c4c3cfd90dfc6$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $d37c4c3cfd90dfc6$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $d37c4c3cfd90dfc6$var$tl.findFiberByHostInstance || $d37c4c3cfd90dfc6$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $d37c4c3cfd90dfc6$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$d37c4c3cfd90dfc6$var$vl.isDisabled && $d37c4c3cfd90dfc6$var$vl.supportsFiber) try {
        $d37c4c3cfd90dfc6$var$kc = $d37c4c3cfd90dfc6$var$vl.inject($d37c4c3cfd90dfc6$var$ul), $d37c4c3cfd90dfc6$var$lc = $d37c4c3cfd90dfc6$var$vl;
    } catch (a) {}
}
$d37c4c3cfd90dfc6$export$ae55be85d98224ed = $d37c4c3cfd90dfc6$var$sl;
$d37c4c3cfd90dfc6$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$d37c4c3cfd90dfc6$var$nl(b)) throw Error($d37c4c3cfd90dfc6$var$p(200));
    return $d37c4c3cfd90dfc6$var$cl(a, b, null, c);
};
$d37c4c3cfd90dfc6$export$882461b6382ed46c = function(a, b) {
    if (!$d37c4c3cfd90dfc6$var$nl(a)) throw Error($d37c4c3cfd90dfc6$var$p(299));
    var c = !1, d = "", e = $d37c4c3cfd90dfc6$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $d37c4c3cfd90dfc6$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$d37c4c3cfd90dfc6$var$uf] = b.current;
    $d37c4c3cfd90dfc6$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $d37c4c3cfd90dfc6$var$ll(b);
};
$d37c4c3cfd90dfc6$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($d37c4c3cfd90dfc6$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($d37c4c3cfd90dfc6$var$p(268, a));
    }
    a = $d37c4c3cfd90dfc6$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$d37c4c3cfd90dfc6$export$cd75ccfd720a3cd4 = function(a) {
    return $d37c4c3cfd90dfc6$var$Rk(a);
};
$d37c4c3cfd90dfc6$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$d37c4c3cfd90dfc6$var$ol(b)) throw Error($d37c4c3cfd90dfc6$var$p(200));
    return $d37c4c3cfd90dfc6$var$rl(null, a, b, !0, c);
};
$d37c4c3cfd90dfc6$export$757ceba2d55c277e = function(a, b, c) {
    if (!$d37c4c3cfd90dfc6$var$nl(a)) throw Error($d37c4c3cfd90dfc6$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $d37c4c3cfd90dfc6$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $d37c4c3cfd90dfc6$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$d37c4c3cfd90dfc6$var$uf] = b.current;
    $d37c4c3cfd90dfc6$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $d37c4c3cfd90dfc6$var$ml(b);
};
$d37c4c3cfd90dfc6$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$d37c4c3cfd90dfc6$var$ol(b)) throw Error($d37c4c3cfd90dfc6$var$p(200));
    return $d37c4c3cfd90dfc6$var$rl(null, a, b, !1, c);
};
$d37c4c3cfd90dfc6$export$502457920280e6be = function(a) {
    if (!$d37c4c3cfd90dfc6$var$ol(a)) throw Error($d37c4c3cfd90dfc6$var$p(40));
    return a._reactRootContainer ? ($d37c4c3cfd90dfc6$var$Rk(function() {
        $d37c4c3cfd90dfc6$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$d37c4c3cfd90dfc6$var$uf] = null;
        });
    }), !0) : !1;
};
$d37c4c3cfd90dfc6$export$c78a37762a8d58e1 = $d37c4c3cfd90dfc6$var$Qk;
$d37c4c3cfd90dfc6$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$d37c4c3cfd90dfc6$var$ol(c)) throw Error($d37c4c3cfd90dfc6$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($d37c4c3cfd90dfc6$var$p(38));
    return $d37c4c3cfd90dfc6$var$rl(a, b, c, !1, d);
};
$d37c4c3cfd90dfc6$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("iDofG", function(module, exports) {
'use strict';

module.exports = (parcelRequire("lNLPx"));

});
parcelRegister("lNLPx", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $fdf346abbc87e12f$export$c4744153514ff05d; }, function (v) { return $fdf346abbc87e12f$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $fdf346abbc87e12f$export$3e506c1ccc9cc1a7; }, function (v) { return $fdf346abbc87e12f$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $fdf346abbc87e12f$export$e26fe2ed2fa76875; }, function (v) { return $fdf346abbc87e12f$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $fdf346abbc87e12f$export$502329bbf4b505b1; }, function (v) { return $fdf346abbc87e12f$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $fdf346abbc87e12f$export$6e3807111c4874c4; }, function (v) { return $fdf346abbc87e12f$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $fdf346abbc87e12f$export$c27134553091fb3a; }, function (v) { return $fdf346abbc87e12f$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $fdf346abbc87e12f$export$33ee1acdc04fd2a2; }, function (v) { return $fdf346abbc87e12f$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $fdf346abbc87e12f$export$b00a404bbd5edef2; }, function (v) { return $fdf346abbc87e12f$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $fdf346abbc87e12f$export$8352ce38b91d0c62; }, function (v) { return $fdf346abbc87e12f$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $fdf346abbc87e12f$export$d66a1c1c77bd778b; }, function (v) { return $fdf346abbc87e12f$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $fdf346abbc87e12f$export$d3dfb8e4810cb555; }, function (v) { return $fdf346abbc87e12f$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $fdf346abbc87e12f$export$839f9183b0465a69; }, function (v) { return $fdf346abbc87e12f$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $fdf346abbc87e12f$export$72fdf0e06517287b; }, function (v) { return $fdf346abbc87e12f$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $fdf346abbc87e12f$export$4b844e58a3e414b4; }, function (v) { return $fdf346abbc87e12f$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $fdf346abbc87e12f$export$816d2913ae6b83b1; }, function (v) { return $fdf346abbc87e12f$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $fdf346abbc87e12f$export$61bcfe829111a1d0; }, function (v) { return $fdf346abbc87e12f$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $fdf346abbc87e12f$export$7ee8c9beb337bc3f; }, function (v) { return $fdf346abbc87e12f$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $fdf346abbc87e12f$export$b5836b71941fa3ed; }, function (v) { return $fdf346abbc87e12f$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $fdf346abbc87e12f$export$cf845f2c119da08a; }, function (v) { return $fdf346abbc87e12f$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $fdf346abbc87e12f$export$c4744153514ff05d;
var $fdf346abbc87e12f$export$3e506c1ccc9cc1a7;
var $fdf346abbc87e12f$export$e26fe2ed2fa76875;
var $fdf346abbc87e12f$export$502329bbf4b505b1;
var $fdf346abbc87e12f$export$6e3807111c4874c4;
var $fdf346abbc87e12f$export$c27134553091fb3a;
var $fdf346abbc87e12f$export$33ee1acdc04fd2a2;
var $fdf346abbc87e12f$export$b00a404bbd5edef2;
var $fdf346abbc87e12f$export$8352ce38b91d0c62;
var $fdf346abbc87e12f$export$d66a1c1c77bd778b;
var $fdf346abbc87e12f$export$d3dfb8e4810cb555;
var $fdf346abbc87e12f$export$839f9183b0465a69;
var $fdf346abbc87e12f$export$72fdf0e06517287b;
var $fdf346abbc87e12f$export$4b844e58a3e414b4;
var $fdf346abbc87e12f$export$816d2913ae6b83b1;
var $fdf346abbc87e12f$export$61bcfe829111a1d0;
var $fdf346abbc87e12f$export$7ee8c9beb337bc3f;
var $fdf346abbc87e12f$export$b5836b71941fa3ed;
var $fdf346abbc87e12f$export$cf845f2c119da08a;
'use strict';
function $fdf346abbc87e12f$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $fdf346abbc87e12f$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $fdf346abbc87e12f$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $fdf346abbc87e12f$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $fdf346abbc87e12f$var$g(C, c)) n < e && 0 > $fdf346abbc87e12f$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $fdf346abbc87e12f$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $fdf346abbc87e12f$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $fdf346abbc87e12f$var$l = performance;
    $fdf346abbc87e12f$export$c4744153514ff05d = function() {
        return $fdf346abbc87e12f$var$l.now();
    };
} else {
    var $fdf346abbc87e12f$var$p = Date, $fdf346abbc87e12f$var$q = $fdf346abbc87e12f$var$p.now();
    $fdf346abbc87e12f$export$c4744153514ff05d = function() {
        return $fdf346abbc87e12f$var$p.now() - $fdf346abbc87e12f$var$q;
    };
}
var $fdf346abbc87e12f$var$r = [], $fdf346abbc87e12f$var$t = [], $fdf346abbc87e12f$var$u = 1, $fdf346abbc87e12f$var$v = null, $fdf346abbc87e12f$var$y = 3, $fdf346abbc87e12f$var$z = !1, $fdf346abbc87e12f$var$A = !1, $fdf346abbc87e12f$var$B = !1, $fdf346abbc87e12f$var$D = "function" === typeof setTimeout ? setTimeout : null, $fdf346abbc87e12f$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $fdf346abbc87e12f$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $fdf346abbc87e12f$var$G(a) {
    for(var b = $fdf346abbc87e12f$var$h($fdf346abbc87e12f$var$t); null !== b;){
        if (null === b.callback) $fdf346abbc87e12f$var$k($fdf346abbc87e12f$var$t);
        else if (b.startTime <= a) $fdf346abbc87e12f$var$k($fdf346abbc87e12f$var$t), b.sortIndex = b.expirationTime, $fdf346abbc87e12f$var$f($fdf346abbc87e12f$var$r, b);
        else break;
        b = $fdf346abbc87e12f$var$h($fdf346abbc87e12f$var$t);
    }
}
function $fdf346abbc87e12f$var$H(a) {
    $fdf346abbc87e12f$var$B = !1;
    $fdf346abbc87e12f$var$G(a);
    if (!$fdf346abbc87e12f$var$A) {
        if (null !== $fdf346abbc87e12f$var$h($fdf346abbc87e12f$var$r)) $fdf346abbc87e12f$var$A = !0, $fdf346abbc87e12f$var$I($fdf346abbc87e12f$var$J);
        else {
            var b = $fdf346abbc87e12f$var$h($fdf346abbc87e12f$var$t);
            null !== b && $fdf346abbc87e12f$var$K($fdf346abbc87e12f$var$H, b.startTime - a);
        }
    }
}
function $fdf346abbc87e12f$var$J(a, b) {
    $fdf346abbc87e12f$var$A = !1;
    $fdf346abbc87e12f$var$B && ($fdf346abbc87e12f$var$B = !1, $fdf346abbc87e12f$var$E($fdf346abbc87e12f$var$L), $fdf346abbc87e12f$var$L = -1);
    $fdf346abbc87e12f$var$z = !0;
    var c = $fdf346abbc87e12f$var$y;
    try {
        $fdf346abbc87e12f$var$G(b);
        for($fdf346abbc87e12f$var$v = $fdf346abbc87e12f$var$h($fdf346abbc87e12f$var$r); null !== $fdf346abbc87e12f$var$v && (!($fdf346abbc87e12f$var$v.expirationTime > b) || a && !$fdf346abbc87e12f$var$M());){
            var d = $fdf346abbc87e12f$var$v.callback;
            if ("function" === typeof d) {
                $fdf346abbc87e12f$var$v.callback = null;
                $fdf346abbc87e12f$var$y = $fdf346abbc87e12f$var$v.priorityLevel;
                var e = d($fdf346abbc87e12f$var$v.expirationTime <= b);
                b = $fdf346abbc87e12f$export$c4744153514ff05d();
                "function" === typeof e ? $fdf346abbc87e12f$var$v.callback = e : $fdf346abbc87e12f$var$v === $fdf346abbc87e12f$var$h($fdf346abbc87e12f$var$r) && $fdf346abbc87e12f$var$k($fdf346abbc87e12f$var$r);
                $fdf346abbc87e12f$var$G(b);
            } else $fdf346abbc87e12f$var$k($fdf346abbc87e12f$var$r);
            $fdf346abbc87e12f$var$v = $fdf346abbc87e12f$var$h($fdf346abbc87e12f$var$r);
        }
        if (null !== $fdf346abbc87e12f$var$v) var w = !0;
        else {
            var m = $fdf346abbc87e12f$var$h($fdf346abbc87e12f$var$t);
            null !== m && $fdf346abbc87e12f$var$K($fdf346abbc87e12f$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $fdf346abbc87e12f$var$v = null, $fdf346abbc87e12f$var$y = c, $fdf346abbc87e12f$var$z = !1;
    }
}
var $fdf346abbc87e12f$var$N = !1, $fdf346abbc87e12f$var$O = null, $fdf346abbc87e12f$var$L = -1, $fdf346abbc87e12f$var$P = 5, $fdf346abbc87e12f$var$Q = -1;
function $fdf346abbc87e12f$var$M() {
    return $fdf346abbc87e12f$export$c4744153514ff05d() - $fdf346abbc87e12f$var$Q < $fdf346abbc87e12f$var$P ? !1 : !0;
}
function $fdf346abbc87e12f$var$R() {
    if (null !== $fdf346abbc87e12f$var$O) {
        var a = $fdf346abbc87e12f$export$c4744153514ff05d();
        $fdf346abbc87e12f$var$Q = a;
        var b = !0;
        try {
            b = $fdf346abbc87e12f$var$O(!0, a);
        } finally{
            b ? $fdf346abbc87e12f$var$S() : ($fdf346abbc87e12f$var$N = !1, $fdf346abbc87e12f$var$O = null);
        }
    } else $fdf346abbc87e12f$var$N = !1;
}
var $fdf346abbc87e12f$var$S;
if ("function" === typeof $fdf346abbc87e12f$var$F) $fdf346abbc87e12f$var$S = function() {
    $fdf346abbc87e12f$var$F($fdf346abbc87e12f$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $fdf346abbc87e12f$var$T = new MessageChannel, $fdf346abbc87e12f$var$U = $fdf346abbc87e12f$var$T.port2;
    $fdf346abbc87e12f$var$T.port1.onmessage = $fdf346abbc87e12f$var$R;
    $fdf346abbc87e12f$var$S = function() {
        $fdf346abbc87e12f$var$U.postMessage(null);
    };
} else $fdf346abbc87e12f$var$S = function() {
    $fdf346abbc87e12f$var$D($fdf346abbc87e12f$var$R, 0);
};
function $fdf346abbc87e12f$var$I(a) {
    $fdf346abbc87e12f$var$O = a;
    $fdf346abbc87e12f$var$N || ($fdf346abbc87e12f$var$N = !0, $fdf346abbc87e12f$var$S());
}
function $fdf346abbc87e12f$var$K(a, b) {
    $fdf346abbc87e12f$var$L = $fdf346abbc87e12f$var$D(function() {
        a($fdf346abbc87e12f$export$c4744153514ff05d());
    }, b);
}
$fdf346abbc87e12f$export$3e506c1ccc9cc1a7 = 5;
$fdf346abbc87e12f$export$e26fe2ed2fa76875 = 1;
$fdf346abbc87e12f$export$502329bbf4b505b1 = 4;
$fdf346abbc87e12f$export$6e3807111c4874c4 = 3;
$fdf346abbc87e12f$export$c27134553091fb3a = null;
$fdf346abbc87e12f$export$33ee1acdc04fd2a2 = 2;
$fdf346abbc87e12f$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$fdf346abbc87e12f$export$8352ce38b91d0c62 = function() {
    $fdf346abbc87e12f$var$A || $fdf346abbc87e12f$var$z || ($fdf346abbc87e12f$var$A = !0, $fdf346abbc87e12f$var$I($fdf346abbc87e12f$var$J));
};
$fdf346abbc87e12f$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $fdf346abbc87e12f$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$fdf346abbc87e12f$export$d3dfb8e4810cb555 = function() {
    return $fdf346abbc87e12f$var$y;
};
$fdf346abbc87e12f$export$839f9183b0465a69 = function() {
    return $fdf346abbc87e12f$var$h($fdf346abbc87e12f$var$r);
};
$fdf346abbc87e12f$export$72fdf0e06517287b = function(a) {
    switch($fdf346abbc87e12f$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $fdf346abbc87e12f$var$y;
    }
    var c = $fdf346abbc87e12f$var$y;
    $fdf346abbc87e12f$var$y = b;
    try {
        return a();
    } finally{
        $fdf346abbc87e12f$var$y = c;
    }
};
$fdf346abbc87e12f$export$4b844e58a3e414b4 = function() {};
$fdf346abbc87e12f$export$816d2913ae6b83b1 = function() {};
$fdf346abbc87e12f$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $fdf346abbc87e12f$var$y;
    $fdf346abbc87e12f$var$y = a;
    try {
        return b();
    } finally{
        $fdf346abbc87e12f$var$y = c;
    }
};
$fdf346abbc87e12f$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $fdf346abbc87e12f$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $fdf346abbc87e12f$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $fdf346abbc87e12f$var$f($fdf346abbc87e12f$var$t, a), null === $fdf346abbc87e12f$var$h($fdf346abbc87e12f$var$r) && a === $fdf346abbc87e12f$var$h($fdf346abbc87e12f$var$t) && ($fdf346abbc87e12f$var$B ? ($fdf346abbc87e12f$var$E($fdf346abbc87e12f$var$L), $fdf346abbc87e12f$var$L = -1) : $fdf346abbc87e12f$var$B = !0, $fdf346abbc87e12f$var$K($fdf346abbc87e12f$var$H, c - d))) : (a.sortIndex = e, $fdf346abbc87e12f$var$f($fdf346abbc87e12f$var$r, a), $fdf346abbc87e12f$var$A || $fdf346abbc87e12f$var$z || ($fdf346abbc87e12f$var$A = !0, $fdf346abbc87e12f$var$I($fdf346abbc87e12f$var$J)));
    return a;
};
$fdf346abbc87e12f$export$b5836b71941fa3ed = $fdf346abbc87e12f$var$M;
$fdf346abbc87e12f$export$cf845f2c119da08a = function(a) {
    var b = $fdf346abbc87e12f$var$y;
    return function() {
        var c = $fdf346abbc87e12f$var$y;
        $fdf346abbc87e12f$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $fdf346abbc87e12f$var$y = c;
        }
    };
};

});




parcelRegister("pWRJW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $04dfff6e26a68f57$var$React = $04dfff6e26a68f57$var$_interopRequireWildcard((parcelRequire("cQQee")));

var $c7hp9 = parcelRequire("c7hp9");

var $04dfff6e26a68f57$var$_clsx = $04dfff6e26a68f57$var$_interopRequireDefault((parcelRequire("lY25K")));

var $29Wdk = parcelRequire("29Wdk");

var $bXTFA = parcelRequire("bXTFA");

var $04dfff6e26a68f57$var$_GridItem = $04dfff6e26a68f57$var$_interopRequireDefault((parcelRequire("6iFJN")));

var $04dfff6e26a68f57$var$_ReactGridLayoutPropTypes = $04dfff6e26a68f57$var$_interopRequireDefault((parcelRequire("kAZeL")));
function $04dfff6e26a68f57$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $04dfff6e26a68f57$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($04dfff6e26a68f57$var$_interopRequireWildcard = function(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(const t in e)"default" !== t && ({}).hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
        return f;
    })(e, t);
}
function $04dfff6e26a68f57$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $04dfff6e26a68f57$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $04dfff6e26a68f57$var$ownKeys(Object(t), !0).forEach(function(r) {
            $04dfff6e26a68f57$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $04dfff6e26a68f57$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $04dfff6e26a68f57$var$_defineProperty(e, r, t) {
    return (r = $04dfff6e26a68f57$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $04dfff6e26a68f57$var$_toPropertyKey(t) {
    var i = $04dfff6e26a68f57$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $04dfff6e26a68f57$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
/*:: import type {
  ChildrenArray as ReactChildrenArray,
  Element as ReactElement
} from "react";*/ /*:: import type {
  CompactType,
  GridResizeEvent,
  GridDragEvent,
  DragOverEvent,
  Layout,
  DroppingPosition,
  LayoutItem
} from "./utils";*/ // Types
/*:: import type { PositionParams } from "./calculateUtils";*/ /*:: type State = {
  activeDrag: ?LayoutItem,
  layout: Layout,
  mounted: boolean,
  oldDragItem: ?LayoutItem,
  oldLayout: ?Layout,
  oldResizeItem: ?LayoutItem,
  resizing: boolean,
  droppingDOMNode: ?ReactElement<any>,
  droppingPosition?: DroppingPosition,
  // Mirrored props
  children: ReactChildrenArray<ReactElement<any>>,
  compactType?: CompactType,
  propsLayout?: Layout
};*/ /*:: import type { Props, DefaultProps } from "./ReactGridLayoutPropTypes";*/ // End Types
const $04dfff6e26a68f57$var$layoutClassName = "react-grid-layout";
let $04dfff6e26a68f57$var$isFirefox = false;
// Try...catch will protect from navigator not existing (e.g. node) or a bad implementation of navigator
try {
    $04dfff6e26a68f57$var$isFirefox = /firefox/i.test(navigator.userAgent);
} catch (e) {
/* Ignore */ }
/**
 * A reactive, fluid grid layout with draggable, resizable components.
 */ class $04dfff6e26a68f57$var$ReactGridLayout extends $04dfff6e26a68f57$var$React.Component /*:: <Props, State>*/  {
    constructor(){
        super(...arguments);
        $04dfff6e26a68f57$var$_defineProperty(this, "state", {
            activeDrag: null,
            layout: (0, $29Wdk.synchronizeLayoutWithChildren)(this.props.layout, this.props.children, this.props.cols, // Legacy support for verticalCompact: false
            (0, $29Wdk.compactType)(this.props), this.props.allowOverlap),
            mounted: false,
            oldDragItem: null,
            oldLayout: null,
            oldResizeItem: null,
            resizing: false,
            droppingDOMNode: null,
            children: []
        });
        $04dfff6e26a68f57$var$_defineProperty(this, "dragEnterCounter", 0);
        /**
     * When dragging starts
     * @param {String} i Id of the child
     * @param {Number} x X position of the move
     * @param {Number} y Y position of the move
     * @param {Event} e The mousedown event
     * @param {Element} node The current dragging DOM element
     */ $04dfff6e26a68f57$var$_defineProperty(this, "onDragStart", (i /*: string*/ , x /*: number*/ , y /*: number*/ , _ref /*:: */ )=>{
            let { e: e, node: node } /*: GridDragEvent*/  = _ref /*: GridDragEvent*/ ;
            const { layout: layout } = this.state;
            const l = (0, $29Wdk.getLayoutItem)(layout, i);
            if (!l) return;
            // Create placeholder (display only)
            const placeholder = {
                w: l.w,
                h: l.h,
                x: l.x,
                y: l.y,
                placeholder: true,
                i: i
            };
            this.setState({
                oldDragItem: (0, $29Wdk.cloneLayoutItem)(l),
                oldLayout: layout,
                activeDrag: placeholder
            });
            return this.props.onDragStart(layout, l, l, null, e, node);
        });
        /**
     * Each drag movement create a new dragelement and move the element to the dragged location
     * @param {String} i Id of the child
     * @param {Number} x X position of the move
     * @param {Number} y Y position of the move
     * @param {Event} e The mousedown event
     * @param {Element} node The current dragging DOM element
     */ $04dfff6e26a68f57$var$_defineProperty(this, "onDrag", (i, x, y, _ref2)=>{
            let { e: e, node: node } = _ref2;
            const { oldDragItem: oldDragItem } = this.state;
            let { layout: layout } = this.state;
            const { cols: cols, allowOverlap: allowOverlap, preventCollision: preventCollision } = this.props;
            const l = (0, $29Wdk.getLayoutItem)(layout, i);
            if (!l) return;
            // Create placeholder (display only)
            const placeholder = {
                w: l.w,
                h: l.h,
                x: l.x,
                y: l.y,
                placeholder: true,
                i: i
            };
            // Move the element to the dragged location.
            const isUserAction = true;
            layout = (0, $29Wdk.moveElement)(layout, l, x, y, isUserAction, preventCollision, (0, $29Wdk.compactType)(this.props), cols, allowOverlap);
            this.props.onDrag(layout, oldDragItem, l, placeholder, e, node);
            this.setState({
                layout: allowOverlap ? layout : (0, $29Wdk.compact)(layout, (0, $29Wdk.compactType)(this.props), cols),
                activeDrag: placeholder
            });
        });
        /**
     * When dragging stops, figure out which position the element is closest to and update its x and y.
     * @param  {String} i Index of the child.
     * @param {Number} x X position of the move
     * @param {Number} y Y position of the move
     * @param {Event} e The mousedown event
     * @param {Element} node The current dragging DOM element
     */ $04dfff6e26a68f57$var$_defineProperty(this, "onDragStop", (i, x, y, _ref3)=>{
            let { e: e, node: node } = _ref3;
            if (!this.state.activeDrag) return;
            const { oldDragItem: oldDragItem } = this.state;
            let { layout: layout } = this.state;
            const { cols: cols, preventCollision: preventCollision, allowOverlap: allowOverlap } = this.props;
            const l = (0, $29Wdk.getLayoutItem)(layout, i);
            if (!l) return;
            // Move the element here
            const isUserAction = true;
            layout = (0, $29Wdk.moveElement)(layout, l, x, y, isUserAction, preventCollision, (0, $29Wdk.compactType)(this.props), cols, allowOverlap);
            // Set state
            const newLayout = allowOverlap ? layout : (0, $29Wdk.compact)(layout, (0, $29Wdk.compactType)(this.props), cols);
            this.props.onDragStop(newLayout, oldDragItem, l, null, e, node);
            const { oldLayout: oldLayout } = this.state;
            this.setState({
                activeDrag: null,
                layout: newLayout,
                oldDragItem: null,
                oldLayout: null
            });
            this.onLayoutMaybeChanged(newLayout, oldLayout);
        });
        $04dfff6e26a68f57$var$_defineProperty(this, "onResizeStart", (i, w, h, _ref4)=>{
            let { e: e, node: node } = _ref4;
            const { layout: layout } = this.state;
            const l = (0, $29Wdk.getLayoutItem)(layout, i);
            if (!l) return;
            this.setState({
                oldResizeItem: (0, $29Wdk.cloneLayoutItem)(l),
                oldLayout: this.state.layout,
                resizing: true
            });
            this.props.onResizeStart(layout, l, l, null, e, node);
        });
        $04dfff6e26a68f57$var$_defineProperty(this, "onResize", (i, w, h, _ref5)=>{
            let { e: e, node: node, size: size, handle: handle } = _ref5;
            const { oldResizeItem: oldResizeItem } = this.state;
            const { layout: layout } = this.state;
            const { cols: cols, preventCollision: preventCollision, allowOverlap: allowOverlap } = this.props;
            let shouldMoveItem = false;
            let finalLayout;
            let x;
            let y;
            const [newLayout, l] = (0, $29Wdk.withLayoutItem)(layout, i, (l)=>{
                let hasCollisions;
                x = l.x;
                y = l.y;
                if ([
                    "sw",
                    "w",
                    "nw",
                    "n",
                    "ne"
                ].indexOf(handle) !== -1) {
                    if ([
                        "sw",
                        "nw",
                        "w"
                    ].indexOf(handle) !== -1) {
                        x = l.x + (l.w - w);
                        w = l.x !== x && x < 0 ? l.w : w;
                        x = x < 0 ? 0 : x;
                    }
                    if ([
                        "ne",
                        "n",
                        "nw"
                    ].indexOf(handle) !== -1) {
                        y = l.y + (l.h - h);
                        h = l.y !== y && y < 0 ? l.h : h;
                        y = y < 0 ? 0 : y;
                    }
                    shouldMoveItem = true;
                }
                // Something like quad tree should be used
                // to find collisions faster
                if (preventCollision && !allowOverlap) {
                    const collisions = (0, $29Wdk.getAllCollisions)(layout, $04dfff6e26a68f57$var$_objectSpread($04dfff6e26a68f57$var$_objectSpread({}, l), {}, {
                        w: w,
                        h: h,
                        x: x,
                        y: y
                    })).filter((layoutItem)=>layoutItem.i !== l.i);
                    hasCollisions = collisions.length > 0;
                    // If we're colliding, we need adjust the placeholder.
                    if (hasCollisions) {
                        // Reset layoutItem dimensions if there were collisions
                        y = l.y;
                        h = l.h;
                        x = l.x;
                        w = l.w;
                        shouldMoveItem = false;
                    }
                }
                l.w = w;
                l.h = h;
                return l;
            });
            // Shouldn't ever happen, but typechecking makes it necessary
            if (!l) return;
            finalLayout = newLayout;
            if (shouldMoveItem) {
                // Move the element to the new position.
                const isUserAction = true;
                finalLayout = (0, $29Wdk.moveElement)(newLayout, l, x, y, isUserAction, this.props.preventCollision, (0, $29Wdk.compactType)(this.props), cols, allowOverlap);
            }
            // Create placeholder element (display only)
            const placeholder = {
                w: l.w,
                h: l.h,
                x: l.x,
                y: l.y,
                static: true,
                i: i
            };
            this.props.onResize(finalLayout, oldResizeItem, l, placeholder, e, node);
            // Re-compact the newLayout and set the drag placeholder.
            this.setState({
                layout: allowOverlap ? finalLayout : (0, $29Wdk.compact)(finalLayout, (0, $29Wdk.compactType)(this.props), cols),
                activeDrag: placeholder
            });
        });
        $04dfff6e26a68f57$var$_defineProperty(this, "onResizeStop", (i, w, h, _ref6)=>{
            let { e: e, node: node } = _ref6;
            const { layout: layout, oldResizeItem: oldResizeItem } = this.state;
            const { cols: cols, allowOverlap: allowOverlap } = this.props;
            const l = (0, $29Wdk.getLayoutItem)(layout, i);
            // Set state
            const newLayout = allowOverlap ? layout : (0, $29Wdk.compact)(layout, (0, $29Wdk.compactType)(this.props), cols);
            this.props.onResizeStop(newLayout, oldResizeItem, l, null, e, node);
            const { oldLayout: oldLayout } = this.state;
            this.setState({
                activeDrag: null,
                layout: newLayout,
                oldResizeItem: null,
                oldLayout: null,
                resizing: false
            });
            this.onLayoutMaybeChanged(newLayout, oldLayout);
        });
        // Called while dragging an element. Part of browser native drag/drop API.
        // Native event target might be the layout itself, or an element within the layout.
        $04dfff6e26a68f57$var$_defineProperty(this, "onDragOver", (e)=>{
            var _e$nativeEvent$target;
            e.preventDefault(); // Prevent any browser native action
            e.stopPropagation();
            // we should ignore events from layout's children in Firefox
            // to avoid unpredictable jumping of a dropping placeholder
            // FIXME remove this hack
            if ($04dfff6e26a68f57$var$isFirefox && // $FlowIgnore can't figure this out
            !((_e$nativeEvent$target = e.nativeEvent.target) !== null && _e$nativeEvent$target !== void 0 && _e$nativeEvent$target.classList.contains($04dfff6e26a68f57$var$layoutClassName))) return false;
            const { droppingItem: droppingItem, onDropDragOver: onDropDragOver, margin: margin, cols: cols, rowHeight: rowHeight, maxRows: maxRows, width: width, containerPadding: containerPadding, transformScale: transformScale } = this.props;
            // Allow user to customize the dropping item or short-circuit the drop based on the results
            // of the `onDragOver(e: Event)` callback.
            const onDragOverResult = onDropDragOver === null || onDropDragOver === void 0 ? void 0 : onDropDragOver(e);
            if (onDragOverResult === false) {
                if (this.state.droppingDOMNode) this.removeDroppingPlaceholder();
                return false;
            }
            const finalDroppingItem = $04dfff6e26a68f57$var$_objectSpread($04dfff6e26a68f57$var$_objectSpread({}, droppingItem), onDragOverResult);
            const { layout: layout } = this.state;
            // $FlowIgnore missing def
            const gridRect = e.currentTarget.getBoundingClientRect(); // The grid's position in the viewport
            // Calculate the mouse position relative to the grid
            const layerX = e.clientX - gridRect.left;
            const layerY = e.clientY - gridRect.top;
            const droppingPosition = {
                left: layerX / transformScale,
                top: layerY / transformScale,
                e: e
            };
            if (!this.state.droppingDOMNode) {
                const positionParams /*: PositionParams*/  = {
                    cols: cols,
                    margin: margin,
                    maxRows: maxRows,
                    rowHeight: rowHeight,
                    containerWidth: width,
                    containerPadding: containerPadding || margin
                };
                const calculatedPosition = (0, $bXTFA.calcXY)(positionParams, layerY, layerX, finalDroppingItem.w, finalDroppingItem.h);
                this.setState({
                    droppingDOMNode: /*#__PURE__*/ $04dfff6e26a68f57$var$React.createElement("div", {
                        key: finalDroppingItem.i
                    }),
                    droppingPosition: droppingPosition,
                    layout: [
                        ...layout,
                        $04dfff6e26a68f57$var$_objectSpread($04dfff6e26a68f57$var$_objectSpread({}, finalDroppingItem), {}, {
                            x: calculatedPosition.x,
                            y: calculatedPosition.y,
                            static: false,
                            isDraggable: true
                        })
                    ]
                });
            } else if (this.state.droppingPosition) {
                const { left: left, top: top } = this.state.droppingPosition;
                const shouldUpdatePosition = left != layerX || top != layerY;
                if (shouldUpdatePosition) this.setState({
                    droppingPosition: droppingPosition
                });
            }
        });
        $04dfff6e26a68f57$var$_defineProperty(this, "removeDroppingPlaceholder", ()=>{
            const { droppingItem: droppingItem, cols: cols } = this.props;
            const { layout: layout } = this.state;
            const newLayout = (0, $29Wdk.compact)(layout.filter((l)=>l.i !== droppingItem.i), (0, $29Wdk.compactType)(this.props), cols, this.props.allowOverlap);
            this.setState({
                layout: newLayout,
                droppingDOMNode: null,
                activeDrag: null,
                droppingPosition: undefined
            });
        });
        $04dfff6e26a68f57$var$_defineProperty(this, "onDragLeave", (e)=>{
            e.preventDefault(); // Prevent any browser native action
            e.stopPropagation();
            this.dragEnterCounter--;
            // onDragLeave can be triggered on each layout's child.
            // But we know that count of dragEnter and dragLeave events
            // will be balanced after leaving the layout's container
            // so we can increase and decrease count of dragEnter and
            // when it'll be equal to 0 we'll remove the placeholder
            if (this.dragEnterCounter === 0) this.removeDroppingPlaceholder();
        });
        $04dfff6e26a68f57$var$_defineProperty(this, "onDragEnter", (e)=>{
            e.preventDefault(); // Prevent any browser native action
            e.stopPropagation();
            this.dragEnterCounter++;
        });
        $04dfff6e26a68f57$var$_defineProperty(this, "onDrop", (e /*: Event*/ )=>{
            e.preventDefault(); // Prevent any browser native action
            e.stopPropagation();
            const { droppingItem: droppingItem } = this.props;
            const { layout: layout } = this.state;
            const item = layout.find((l)=>l.i === droppingItem.i);
            // reset dragEnter counter on drop
            this.dragEnterCounter = 0;
            this.removeDroppingPlaceholder();
            this.props.onDrop(layout, item, e);
        });
    }
    componentDidMount() {
        this.setState({
            mounted: true
        });
        // Possibly call back with layout on mount. This should be done after correcting the layout width
        // to ensure we don't rerender with the wrong width.
        this.onLayoutMaybeChanged(this.state.layout, this.props.layout);
    }
    static getDerivedStateFromProps(nextProps /*: Props*/ , prevState /*: State*/ ) /*: $Shape<State> | null*/ {
        let newLayoutBase;
        if (prevState.activeDrag) return null;
        // Legacy support for compactType
        // Allow parent to set layout directly.
        if (!(0, $c7hp9.deepEqual)(nextProps.layout, prevState.propsLayout) || nextProps.compactType !== prevState.compactType) newLayoutBase = nextProps.layout;
        else if (!(0, $29Wdk.childrenEqual)(nextProps.children, prevState.children)) // If children change, also regenerate the layout. Use our state
        // as the base in case because it may be more up to date than
        // what is in props.
        newLayoutBase = prevState.layout;
        // We need to regenerate the layout.
        if (newLayoutBase) {
            const newLayout = (0, $29Wdk.synchronizeLayoutWithChildren)(newLayoutBase, nextProps.children, nextProps.cols, (0, $29Wdk.compactType)(nextProps), nextProps.allowOverlap);
            return {
                layout: newLayout,
                // We need to save these props to state for using
                // getDerivedStateFromProps instead of componentDidMount (in which we would get extra rerender)
                compactType: nextProps.compactType,
                children: nextProps.children,
                propsLayout: nextProps.layout
            };
        }
        return null;
    }
    shouldComponentUpdate(nextProps /*: Props*/ , nextState /*: State*/ ) /*: boolean*/ {
        return(// NOTE: this is almost always unequal. Therefore the only way to get better performance
        // from SCU is if the user intentionally memoizes children. If they do, and they can
        // handle changes properly, performance will increase.
        this.props.children !== nextProps.children || !(0, $29Wdk.fastRGLPropsEqual)(this.props, nextProps, $c7hp9.deepEqual) || this.state.activeDrag !== nextState.activeDrag || this.state.mounted !== nextState.mounted || this.state.droppingPosition !== nextState.droppingPosition);
    }
    componentDidUpdate(prevProps /*: Props*/ , prevState /*: State*/ ) {
        if (!this.state.activeDrag) {
            const newLayout = this.state.layout;
            const oldLayout = prevState.layout;
            this.onLayoutMaybeChanged(newLayout, oldLayout);
        }
    }
    /**
   * Calculates a pixel value for the container.
   * @return {String} Container height in pixels.
   */ containerHeight() /*: ?string*/ {
        if (!this.props.autoSize) return;
        const nbRow = (0, $29Wdk.bottom)(this.state.layout);
        const containerPaddingY = this.props.containerPadding ? this.props.containerPadding[1] : this.props.margin[1];
        return nbRow * this.props.rowHeight + (nbRow - 1) * this.props.margin[1] + containerPaddingY * 2 + "px";
    }
    onLayoutMaybeChanged(newLayout /*: Layout*/ , oldLayout /*: ?Layout*/ ) {
        if (!oldLayout) oldLayout = this.state.layout;
        if (!(0, $c7hp9.deepEqual)(oldLayout, newLayout)) this.props.onLayoutChange(newLayout);
    }
    /**
   * Create a placeholder object.
   * @return {Element} Placeholder div.
   */ placeholder() /*: ?ReactElement<any>*/ {
        const { activeDrag: activeDrag } = this.state;
        if (!activeDrag) return null;
        const { width: width, cols: cols, margin: margin, containerPadding: containerPadding, rowHeight: rowHeight, maxRows: maxRows, useCSSTransforms: useCSSTransforms, transformScale: transformScale } = this.props;
        // {...this.state.activeDrag} is pretty slow, actually
        return /*#__PURE__*/ $04dfff6e26a68f57$var$React.createElement($04dfff6e26a68f57$var$_GridItem.default, {
            w: activeDrag.w,
            h: activeDrag.h,
            x: activeDrag.x,
            y: activeDrag.y,
            i: activeDrag.i,
            className: "react-grid-placeholder ".concat(this.state.resizing ? "placeholder-resizing" : ""),
            containerWidth: width,
            cols: cols,
            margin: margin,
            containerPadding: containerPadding || margin,
            maxRows: maxRows,
            rowHeight: rowHeight,
            isDraggable: false,
            isResizable: false,
            isBounded: false,
            useCSSTransforms: useCSSTransforms,
            transformScale: transformScale
        }, /*#__PURE__*/ $04dfff6e26a68f57$var$React.createElement("div", null));
    }
    /**
   * Given a grid item, set its style attributes & surround in a <Draggable>.
   * @param  {Element} child React element.
   * @return {Element}       Element wrapped in draggable and properly placed.
   */ processGridItem(child /*: ReactElement<any>*/ , isDroppingItem /*: boolean*/ ) /*: ?ReactElement<any>*/ {
        if (!child || !child.key) return;
        const l = (0, $29Wdk.getLayoutItem)(this.state.layout, String(child.key));
        if (!l) return null;
        const { width: width, cols: cols, margin: margin, containerPadding: containerPadding, rowHeight: rowHeight, maxRows: maxRows, isDraggable: isDraggable, isResizable: isResizable, isBounded: isBounded, useCSSTransforms: useCSSTransforms, transformScale: transformScale, draggableCancel: draggableCancel, draggableHandle: draggableHandle, resizeHandles: resizeHandles, resizeHandle: resizeHandle } = this.props;
        const { mounted: mounted, droppingPosition: droppingPosition } = this.state;
        // Determine user manipulations possible.
        // If an item is static, it can't be manipulated by default.
        // Any properties defined directly on the grid item will take precedence.
        const draggable = typeof l.isDraggable === "boolean" ? l.isDraggable : !l.static && isDraggable;
        const resizable = typeof l.isResizable === "boolean" ? l.isResizable : !l.static && isResizable;
        const resizeHandlesOptions = l.resizeHandles || resizeHandles;
        // isBounded set on child if set on parent, and child is not explicitly false
        const bounded = draggable && isBounded && l.isBounded !== false;
        return /*#__PURE__*/ $04dfff6e26a68f57$var$React.createElement($04dfff6e26a68f57$var$_GridItem.default, {
            containerWidth: width,
            cols: cols,
            margin: margin,
            containerPadding: containerPadding || margin,
            maxRows: maxRows,
            rowHeight: rowHeight,
            cancel: draggableCancel,
            handle: draggableHandle,
            onDragStop: this.onDragStop,
            onDragStart: this.onDragStart,
            onDrag: this.onDrag,
            onResizeStart: this.onResizeStart,
            onResize: this.onResize,
            onResizeStop: this.onResizeStop,
            isDraggable: draggable,
            isResizable: resizable,
            isBounded: bounded,
            useCSSTransforms: useCSSTransforms && mounted,
            usePercentages: !mounted,
            transformScale: transformScale,
            w: l.w,
            h: l.h,
            x: l.x,
            y: l.y,
            i: l.i,
            minH: l.minH,
            minW: l.minW,
            maxH: l.maxH,
            maxW: l.maxW,
            static: l.static,
            droppingPosition: isDroppingItem ? droppingPosition : undefined,
            resizeHandles: resizeHandlesOptions,
            resizeHandle: resizeHandle
        }, child);
    }
    render() /*: React.Element<"div">*/ {
        const { className: className, style: style, isDroppable: isDroppable, innerRef: innerRef } = this.props;
        const mergedClassName = (0, $04dfff6e26a68f57$var$_clsx.default)($04dfff6e26a68f57$var$layoutClassName, className);
        const mergedStyle = $04dfff6e26a68f57$var$_objectSpread({
            height: this.containerHeight()
        }, style);
        return /*#__PURE__*/ $04dfff6e26a68f57$var$React.createElement("div", {
            ref: innerRef,
            className: mergedClassName,
            style: mergedStyle,
            onDrop: isDroppable ? this.onDrop : $29Wdk.noop,
            onDragLeave: isDroppable ? this.onDragLeave : $29Wdk.noop,
            onDragEnter: isDroppable ? this.onDragEnter : $29Wdk.noop,
            onDragOver: isDroppable ? this.onDragOver : $29Wdk.noop
        }, $04dfff6e26a68f57$var$React.Children.map(this.props.children, (child)=>this.processGridItem(child)), isDroppable && this.state.droppingDOMNode && this.processGridItem(this.state.droppingDOMNode, true), this.placeholder());
    }
}
module.exports.default = $04dfff6e26a68f57$var$ReactGridLayout;
// TODO publish internal ReactClass displayName transform
$04dfff6e26a68f57$var$_defineProperty($04dfff6e26a68f57$var$ReactGridLayout, "displayName", "ReactGridLayout");
// Refactored to another module to make way for preval
$04dfff6e26a68f57$var$_defineProperty($04dfff6e26a68f57$var$ReactGridLayout, "propTypes", $04dfff6e26a68f57$var$_ReactGridLayoutPropTypes.default);
$04dfff6e26a68f57$var$_defineProperty($04dfff6e26a68f57$var$ReactGridLayout, "defaultProps", {
    autoSize: true,
    cols: 12,
    className: "",
    style: {},
    draggableHandle: "",
    draggableCancel: "",
    containerPadding: null,
    rowHeight: 150,
    maxRows: Infinity,
    // infinite vertical growth
    layout: [],
    margin: [
        10,
        10
    ],
    isBounded: false,
    isDraggable: true,
    isResizable: true,
    allowOverlap: false,
    isDroppable: false,
    useCSSTransforms: true,
    transformScale: 1,
    verticalCompact: true,
    compactType: "vertical",
    preventCollision: false,
    droppingItem: {
        i: "__dropping-elem__",
        h: 1,
        w: 1
    },
    resizeHandles: [
        "se"
    ],
    onLayoutChange: $29Wdk.noop,
    onDragStart: $29Wdk.noop,
    onDrag: $29Wdk.noop,
    onDragStop: $29Wdk.noop,
    onResizeStart: $29Wdk.noop,
    onResize: $29Wdk.noop,
    onResizeStop: $29Wdk.noop,
    onDrop: $29Wdk.noop,
    onDropDragOver: $29Wdk.noop
});

});
parcelRegister("c7hp9", function(module, exports) {
(function(global, factory) {
    factory(module.exports);
})(module.exports, function(exports1) {
    'use strict';
    /**
   * Default equality comparator pass-through, used as the standard `isEqual` creator for
   * use inside the built comparator.
   */ function createDefaultIsNestedEqual(comparator) {
        return function isEqual(a, b, _indexOrKeyA, _indexOrKeyB, _parentA, _parentB, meta) {
            return comparator(a, b, meta);
        };
    }
    /**
   * Wrap the provided `areItemsEqual` method to manage the circular cache, allowing
   * for circular references to be safely included in the comparison without creating
   * stack overflows.
   */ function createIsCircular(areItemsEqual) {
        return function isCircular(a, b, isEqual, cache) {
            if (!a || !b || typeof a !== 'object' || typeof b !== 'object') return areItemsEqual(a, b, isEqual, cache);
            var cachedA = cache.get(a);
            var cachedB = cache.get(b);
            if (cachedA && cachedB) return cachedA === b && cachedB === a;
            cache.set(a, b);
            cache.set(b, a);
            var result = areItemsEqual(a, b, isEqual, cache);
            cache.delete(a);
            cache.delete(b);
            return result;
        };
    }
    /**
   * Targeted shallow merge of two objects.
   *
   * @NOTE
   * This exists as a tinier compiled version of the `__assign` helper that
   * `tsc` injects in case of `Object.assign` not being present.
   */ function merge(a, b) {
        var merged = {};
        for(var key in a)merged[key] = a[key];
        for(var key in b)merged[key] = b[key];
        return merged;
    }
    /**
   * Whether the value is a plain object.
   *
   * @NOTE
   * This is a same-realm compariosn only.
   */ function isPlainObject(value) {
        return value.constructor === Object || value.constructor == null;
    }
    /**
   * When the value is `Promise`-like, aka "then-able".
   */ function isPromiseLike(value) {
        return typeof value.then === 'function';
    }
    /**
   * Whether the values passed are strictly equal or both NaN.
   */ function sameValueZeroEqual(a, b) {
        return a === b || a !== a && b !== b;
    }
    var ARGUMENTS_TAG = '[object Arguments]';
    var BOOLEAN_TAG = '[object Boolean]';
    var DATE_TAG = '[object Date]';
    var REG_EXP_TAG = '[object RegExp]';
    var MAP_TAG = '[object Map]';
    var NUMBER_TAG = '[object Number]';
    var OBJECT_TAG = '[object Object]';
    var SET_TAG = '[object Set]';
    var STRING_TAG = '[object String]';
    var toString = Object.prototype.toString;
    function createComparator(_a) {
        var areArraysEqual = _a.areArraysEqual, areDatesEqual = _a.areDatesEqual, areMapsEqual = _a.areMapsEqual, areObjectsEqual = _a.areObjectsEqual, areRegExpsEqual = _a.areRegExpsEqual, areSetsEqual = _a.areSetsEqual, createIsNestedEqual = _a.createIsNestedEqual;
        var isEqual = createIsNestedEqual(comparator);
        /**
       * compare the value of the two objects and return true if they are equivalent in values
       */ function comparator(a, b, meta) {
            // If the items are strictly equal, no need to do a value comparison.
            if (a === b) return true;
            // If the items are not non-nullish objects, then the only possibility
            // of them being equal but not strictly is if they are both `NaN`. Since
            // `NaN` is uniquely not equal to itself, we can use self-comparison of
            // both objects, which is faster than `isNaN()`.
            if (!a || !b || typeof a !== 'object' || typeof b !== 'object') return a !== a && b !== b;
            // Checks are listed in order of commonality of use-case:
            //   1. Common complex object types (plain object, array)
            //   2. Common data values (date, regexp)
            //   3. Less-common complex object types (map, set)
            //   4. Less-common data values (promise, primitive wrappers)
            // Inherently this is both subjective and assumptive, however
            // when reviewing comparable libraries in the wild this order
            // appears to be generally consistent.
            // `isPlainObject` only checks against the object's own realm. Cross-realm
            // comparisons are rare, and will be handled in the ultimate fallback, so
            // we can avoid the `toString.call()` cost unless necessary.
            if (isPlainObject(a) && isPlainObject(b)) return areObjectsEqual(a, b, isEqual, meta);
            // `isArray()` works on subclasses and is cross-realm, so we can again avoid
            // the `toString.call()` cost unless necessary by just checking if either
            // and then both are arrays.
            var aArray = Array.isArray(a);
            var bArray = Array.isArray(b);
            if (aArray || bArray) return aArray === bArray && areArraysEqual(a, b, isEqual, meta);
            // Since this is a custom object, use the classic `toString.call()` to get its
            // type. This is reasonably performant in modern environments like v8 and
            // SpiderMonkey, and allows for cross-realm comparison when other checks like
            // `instanceof` do not.
            var aTag = toString.call(a);
            if (aTag !== toString.call(b)) return false;
            if (aTag === DATE_TAG) // `getTime()` showed better results compared to alternatives like `valueOf()`
            // or the unary `+` operator.
            return areDatesEqual(a, b, isEqual, meta);
            if (aTag === REG_EXP_TAG) return areRegExpsEqual(a, b, isEqual, meta);
            if (aTag === MAP_TAG) return areMapsEqual(a, b, isEqual, meta);
            if (aTag === SET_TAG) return areSetsEqual(a, b, isEqual, meta);
            // If a simple object tag, then we can prioritize a simple object comparison because
            // it is likely a custom class. If an arguments tag, it should be treated as a standard
            // object.
            if (aTag === OBJECT_TAG || aTag === ARGUMENTS_TAG) // The exception for value comparison is `Promise`-like contracts. These should be
            // treated the same as standard `Promise` objects, which means strict equality.
            return isPromiseLike(a) || isPromiseLike(b) ? false : areObjectsEqual(a, b, isEqual, meta);
            // As the penultimate fallback, check if the values passed are primitive wrappers. This
            // is very rare in modern JS, which is why it is deprioritized compared to all other object
            // types.
            if (aTag === BOOLEAN_TAG || aTag === NUMBER_TAG || aTag === STRING_TAG) return sameValueZeroEqual(a.valueOf(), b.valueOf());
            // If not matching any tags that require a specific type of comparison, then we hard-code false because
            // the only thing remaining is strict equality, which has already been compared. This is for a few reasons:
            //   - Certain types that cannot be introspected (e.g., `WeakMap`). For these types, this is the only
            //     comparison that can be made.
            //   - For types that can be introspected, but rarely have requirements to be compared
            //     (`ArrayBuffer`, `DataView`, etc.), the cost is avoided to prioritize the common
            //     use-cases (may be included in a future release, if requested enough).
            //   - For types that can be introspected but do not have an objective definition of what
            //     equality is (`Error`, etc.), the subjective decision is to be conservative and strictly compare.
            // In all cases, these decisions should be reevaluated based on changes to the language and
            // common development practices.
            return false;
        }
        return comparator;
    }
    /**
   * Whether the arrays are equal in value.
   */ function areArraysEqual(a, b, isEqual, meta) {
        var index = a.length;
        if (b.length !== index) return false;
        // Decrementing `while` showed faster results than either incrementing or
        // decrementing `for` loop and than an incrementing `while` loop. Declarative
        // methods like `some` / `every` were not used to avoid incurring the garbage
        // cost of anonymous callbacks.
        while(index-- > 0){
            if (!isEqual(a[index], b[index], index, index, a, b, meta)) return false;
        }
        return true;
    }
    /**
   * Whether the arrays are equal in value, including circular references.
   */ var areArraysEqualCircular = createIsCircular(areArraysEqual);
    /**
   * Whether the dates passed are equal in value.
   *
   * @NOTE
   * This is a standalone function instead of done inline in the comparator
   * to allow for overrides.
   */ function areDatesEqual(a, b) {
        return sameValueZeroEqual(a.valueOf(), b.valueOf());
    }
    /**
   * Whether the `Map`s are equal in value.
   */ function areMapsEqual(a, b, isEqual, meta) {
        var isValueEqual = a.size === b.size;
        if (!isValueEqual) return false;
        if (!a.size) return true;
        // The use of `forEach()` is to avoid the transpilation cost of `for...of` comparisons, and
        // the inability to control the performance of the resulting code. It also avoids excessive
        // iteration compared to doing comparisons of `keys()` and `values()`. As a result, though,
        // we cannot short-circuit the iterations; bookkeeping must be done to short-circuit the
        // equality checks themselves.
        var matchedIndices = {};
        var indexA = 0;
        a.forEach(function(aValue, aKey) {
            if (!isValueEqual) return;
            var hasMatch = false;
            var matchIndexB = 0;
            b.forEach(function(bValue, bKey) {
                if (!hasMatch && !matchedIndices[matchIndexB] && (hasMatch = isEqual(aKey, bKey, indexA, matchIndexB, a, b, meta) && isEqual(aValue, bValue, aKey, bKey, a, b, meta))) matchedIndices[matchIndexB] = true;
                matchIndexB++;
            });
            indexA++;
            isValueEqual = hasMatch;
        });
        return isValueEqual;
    }
    /**
   * Whether the `Map`s are equal in value, including circular references.
   */ var areMapsEqualCircular = createIsCircular(areMapsEqual);
    var OWNER = '_owner';
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    /**
   * Whether the objects are equal in value.
   */ function areObjectsEqual(a, b, isEqual, meta) {
        var keysA = Object.keys(a);
        var index = keysA.length;
        if (Object.keys(b).length !== index) return false;
        var key;
        // Decrementing `while` showed faster results than either incrementing or
        // decrementing `for` loop and than an incrementing `while` loop. Declarative
        // methods like `some` / `every` were not used to avoid incurring the garbage
        // cost of anonymous callbacks.
        while(index-- > 0){
            key = keysA[index];
            if (key === OWNER) {
                var reactElementA = !!a.$$typeof;
                var reactElementB = !!b.$$typeof;
                if ((reactElementA || reactElementB) && reactElementA !== reactElementB) return false;
            }
            if (!hasOwnProperty.call(b, key) || !isEqual(a[key], b[key], key, key, a, b, meta)) return false;
        }
        return true;
    }
    /**
   * Whether the objects are equal in value, including circular references.
   */ var areObjectsEqualCircular = createIsCircular(areObjectsEqual);
    /**
   * Whether the regexps passed are equal in value.
   *
   * @NOTE
   * This is a standalone function instead of done inline in the comparator
   * to allow for overrides. An example of this would be supporting a
   * pre-ES2015 environment where the `flags` property is not available.
   */ function areRegExpsEqual(a, b) {
        return a.source === b.source && a.flags === b.flags;
    }
    /**
   * Whether the `Set`s are equal in value.
   */ function areSetsEqual(a, b, isEqual, meta) {
        var isValueEqual = a.size === b.size;
        if (!isValueEqual) return false;
        if (!a.size) return true;
        // The use of `forEach()` is to avoid the transpilation cost of `for...of` comparisons, and
        // the inability to control the performance of the resulting code. It also avoids excessive
        // iteration compared to doing comparisons of `keys()` and `values()`. As a result, though,
        // we cannot short-circuit the iterations; bookkeeping must be done to short-circuit the
        // equality checks themselves.
        var matchedIndices = {};
        a.forEach(function(aValue, aKey) {
            if (!isValueEqual) return;
            var hasMatch = false;
            var matchIndex = 0;
            b.forEach(function(bValue, bKey) {
                if (!hasMatch && !matchedIndices[matchIndex] && (hasMatch = isEqual(aValue, bValue, aKey, bKey, a, b, meta))) matchedIndices[matchIndex] = true;
                matchIndex++;
            });
            isValueEqual = hasMatch;
        });
        return isValueEqual;
    }
    /**
   * Whether the `Set`s are equal in value, including circular references.
   */ var areSetsEqualCircular = createIsCircular(areSetsEqual);
    var DEFAULT_CONFIG = Object.freeze({
        areArraysEqual: areArraysEqual,
        areDatesEqual: areDatesEqual,
        areMapsEqual: areMapsEqual,
        areObjectsEqual: areObjectsEqual,
        areRegExpsEqual: areRegExpsEqual,
        areSetsEqual: areSetsEqual,
        createIsNestedEqual: createDefaultIsNestedEqual
    });
    var DEFAULT_CIRCULAR_CONFIG = Object.freeze({
        areArraysEqual: areArraysEqualCircular,
        areDatesEqual: areDatesEqual,
        areMapsEqual: areMapsEqualCircular,
        areObjectsEqual: areObjectsEqualCircular,
        areRegExpsEqual: areRegExpsEqual,
        areSetsEqual: areSetsEqualCircular,
        createIsNestedEqual: createDefaultIsNestedEqual
    });
    var isDeepEqual = createComparator(DEFAULT_CONFIG);
    /**
   * Whether the items passed are deeply-equal in value.
   */ function deepEqual(a, b) {
        return isDeepEqual(a, b, undefined);
    }
    var isShallowEqual = createComparator(merge(DEFAULT_CONFIG, {
        createIsNestedEqual: function() {
            return sameValueZeroEqual;
        }
    }));
    /**
   * Whether the items passed are shallowly-equal in value.
   */ function shallowEqual(a, b) {
        return isShallowEqual(a, b, undefined);
    }
    var isCircularDeepEqual = createComparator(DEFAULT_CIRCULAR_CONFIG);
    /**
   * Whether the items passed are deeply-equal in value, including circular references.
   */ function circularDeepEqual(a, b) {
        return isCircularDeepEqual(a, b, new WeakMap());
    }
    var isCircularShallowEqual = createComparator(merge(DEFAULT_CIRCULAR_CONFIG, {
        createIsNestedEqual: function() {
            return sameValueZeroEqual;
        }
    }));
    /**
   * Whether the items passed are shallowly-equal in value, including circular references.
   */ function circularShallowEqual(a, b) {
        return isCircularShallowEqual(a, b, new WeakMap());
    }
    /**
   * Create a custom equality comparison method.
   *
   * This can be done to create very targeted comparisons in extreme hot-path scenarios
   * where the standard methods are not performant enough, but can also be used to provide
   * support for legacy environments that do not support expected features like
   * `RegExp.prototype.flags` out of the box.
   */ function createCustomEqual(getComparatorOptions) {
        return createComparator(merge(DEFAULT_CONFIG, getComparatorOptions(DEFAULT_CONFIG)));
    }
    /**
   * Create a custom equality comparison method that handles circular references. This is very
   * similar to `createCustomEqual`, with the only difference being that `meta` expects to be
   * populated with a `WeakMap`-like contract.
   *
   * This can be done to create very targeted comparisons in extreme hot-path scenarios
   * where the standard methods are not performant enough, but can also be used to provide
   * support for legacy environments that do not support expected features like
   * `WeakMap` out of the box.
   */ function createCustomCircularEqual(getComparatorOptions) {
        var comparator = createComparator(merge(DEFAULT_CIRCULAR_CONFIG, getComparatorOptions(DEFAULT_CIRCULAR_CONFIG)));
        return function(a, b, meta) {
            if (meta === void 0) meta = new WeakMap();
            return comparator(a, b, meta);
        };
    }
    exports1.circularDeepEqual = circularDeepEqual;
    exports1.circularShallowEqual = circularShallowEqual;
    exports1.createCustomCircularEqual = createCustomCircularEqual;
    exports1.createCustomEqual = createCustomEqual;
    exports1.deepEqual = deepEqual;
    exports1.sameValueZeroEqual = sameValueZeroEqual;
    exports1.shallowEqual = shallowEqual;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});

});

parcelRegister("lY25K", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "clsx", function () { return $a8e351e0d11fc13c$export$4f5d2d50c9deca37; });
$parcel$export(module.exports, "default", function () { return $a8e351e0d11fc13c$export$2e2bcd8739ae039; });
function $a8e351e0d11fc13c$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $a8e351e0d11fc13c$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $a8e351e0d11fc13c$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $a8e351e0d11fc13c$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $a8e351e0d11fc13c$export$2e2bcd8739ae039 = $a8e351e0d11fc13c$export$4f5d2d50c9deca37;

});

parcelRegister("29Wdk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bottom = $1929941c7e17f531$var$bottom;
module.exports.childrenEqual = $1929941c7e17f531$var$childrenEqual;
module.exports.cloneLayout = $1929941c7e17f531$var$cloneLayout;
module.exports.cloneLayoutItem = $1929941c7e17f531$var$cloneLayoutItem;
module.exports.collides = $1929941c7e17f531$var$collides;
module.exports.compact = $1929941c7e17f531$var$compact;
module.exports.compactItem = $1929941c7e17f531$var$compactItem;
module.exports.compactType = $1929941c7e17f531$var$compactType;
module.exports.correctBounds = $1929941c7e17f531$var$correctBounds;
module.exports.fastPositionEqual = $1929941c7e17f531$var$fastPositionEqual;
module.exports.fastRGLPropsEqual = void 0;
module.exports.getAllCollisions = $1929941c7e17f531$var$getAllCollisions;
module.exports.getFirstCollision = $1929941c7e17f531$var$getFirstCollision;
module.exports.getLayoutItem = $1929941c7e17f531$var$getLayoutItem;
module.exports.getStatics = $1929941c7e17f531$var$getStatics;
module.exports.modifyLayout = $1929941c7e17f531$var$modifyLayout;
module.exports.moveElement = $1929941c7e17f531$var$moveElement;
module.exports.moveElementAwayFromCollision = $1929941c7e17f531$var$moveElementAwayFromCollision;
module.exports.noop = void 0;
module.exports.perc = $1929941c7e17f531$var$perc;
module.exports.resizeItemInDirection = $1929941c7e17f531$var$resizeItemInDirection;
module.exports.setTopLeft = $1929941c7e17f531$var$setTopLeft;
module.exports.setTransform = $1929941c7e17f531$var$setTransform;
module.exports.sortLayoutItems = $1929941c7e17f531$var$sortLayoutItems;
module.exports.sortLayoutItemsByColRow = $1929941c7e17f531$var$sortLayoutItemsByColRow;
module.exports.sortLayoutItemsByRowCol = $1929941c7e17f531$var$sortLayoutItemsByRowCol;
module.exports.synchronizeLayoutWithChildren = $1929941c7e17f531$var$synchronizeLayoutWithChildren;
module.exports.validateLayout = $1929941c7e17f531$var$validateLayout;
module.exports.withLayoutItem = $1929941c7e17f531$var$withLayoutItem;

var $c7hp9 = parcelRequire("c7hp9");

var $1929941c7e17f531$var$_react = $1929941c7e17f531$var$_interopRequireDefault((parcelRequire("cQQee")));
function $1929941c7e17f531$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $1929941c7e17f531$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1929941c7e17f531$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1929941c7e17f531$var$ownKeys(Object(t), !0).forEach(function(r) {
            $1929941c7e17f531$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1929941c7e17f531$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1929941c7e17f531$var$_defineProperty(e, r, t) {
    return (r = $1929941c7e17f531$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $1929941c7e17f531$var$_toPropertyKey(t) {
    var i = $1929941c7e17f531$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $1929941c7e17f531$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
/*:: import type {
  ChildrenArray as ReactChildrenArray,
  Element as ReactElement
} from "react";*/ /*:: export type ResizeHandleAxis =
  | "s"
  | "w"
  | "e"
  | "n"
  | "sw"
  | "nw"
  | "se"
  | "ne";*/ /*:: export type LayoutItem = {
  w: number,
  h: number,
  x: number,
  y: number,
  i: string,
  minW?: number,
  minH?: number,
  maxW?: number,
  maxH?: number,
  moved?: boolean,
  static?: boolean,
  isDraggable?: ?boolean,
  isResizable?: ?boolean,
  resizeHandles?: Array<ResizeHandleAxis>,
  isBounded?: ?boolean
};*/ /*:: export type Layout = $ReadOnlyArray<LayoutItem>;*/ /*:: export type Position = {
  left: number,
  top: number,
  width: number,
  height: number
};*/ /*:: export type ReactDraggableCallbackData = {
  node: HTMLElement,
  x?: number,
  y?: number,
  deltaX: number,
  deltaY: number,
  lastX?: number,
  lastY?: number
};*/ /*:: export type PartialPosition = { left: number, top: number };*/ /*:: export type DroppingPosition = { left: number, top: number, e: Event };*/ /*:: export type Size = { width: number, height: number };*/ /*:: export type GridDragEvent = {
  e: Event,
  node: HTMLElement,
  newPosition: PartialPosition
};*/ /*:: export type GridResizeEvent = {
  e: Event,
  node: HTMLElement,
  size: Size,
  handle: string
};*/ /*:: export type DragOverEvent = MouseEvent & {
  nativeEvent: {
    layerX: number,
    layerY: number,
    ...Event
  }
};*/ /*:: export type Pick<FromType, Properties: { [string]: 0 }> = $Exact<
  $ObjMapi<Properties, <K, V>(k: K, v: V) => $ElementType<FromType, K>>
>;*/ // Helpful port from TS
/*:: type REl = ReactElement<any>;*/ /*:: export type ReactChildren = ReactChildrenArray<REl>;*/ /*:: export type EventCallback = (
  Layout,
  oldItem: ?LayoutItem,
  newItem: ?LayoutItem,
  placeholder: ?LayoutItem,
  Event,
  ?HTMLElement
) => void;*/ // All callbacks are of the signature (layout, oldItem, newItem, placeholder, e).
/*:: export type CompactType = ?("horizontal" | "vertical");*/ const $1929941c7e17f531$var$isProduction = true;
const $1929941c7e17f531$var$DEBUG = false;
/**
 * Return the bottom coordinate of the layout.
 *
 * @param  {Array} layout Layout array.
 * @return {Number}       Bottom coordinate.
 */ function $1929941c7e17f531$var$bottom(layout /*: Layout*/ ) /*: number*/ {
    let max = 0, bottomY;
    for(let i = 0, len = layout.length; i < len; i++){
        bottomY = layout[i].y + layout[i].h;
        if (bottomY > max) max = bottomY;
    }
    return max;
}
function $1929941c7e17f531$var$cloneLayout(layout /*: Layout*/ ) /*: Layout*/ {
    const newLayout = Array(layout.length);
    for(let i = 0, len = layout.length; i < len; i++)newLayout[i] = $1929941c7e17f531$var$cloneLayoutItem(layout[i]);
    return newLayout;
}
// Modify a layoutItem inside a layout. Returns a new Layout,
// does not mutate. Carries over all other LayoutItems unmodified.
function $1929941c7e17f531$var$modifyLayout(layout /*: Layout*/ , layoutItem /*: LayoutItem*/ ) /*: Layout*/ {
    const newLayout = Array(layout.length);
    for(let i = 0, len = layout.length; i < len; i++)if (layoutItem.i === layout[i].i) newLayout[i] = layoutItem;
    else newLayout[i] = layout[i];
    return newLayout;
}
// Function to be called to modify a layout item.
// Does defensive clones to ensure the layout is not modified.
function $1929941c7e17f531$var$withLayoutItem(layout /*: Layout*/ , itemKey /*: string*/ , cb /*: LayoutItem => LayoutItem*/ ) /*: [Layout, ?LayoutItem]*/ {
    let item = $1929941c7e17f531$var$getLayoutItem(layout, itemKey);
    if (!item) return [
        layout,
        null
    ];
    item = cb($1929941c7e17f531$var$cloneLayoutItem(item)); // defensive clone then modify
    // FIXME could do this faster if we already knew the index
    layout = $1929941c7e17f531$var$modifyLayout(layout, item);
    return [
        layout,
        item
    ];
}
// Fast path to cloning, since this is monomorphic
function $1929941c7e17f531$var$cloneLayoutItem(layoutItem /*: LayoutItem*/ ) /*: LayoutItem*/ {
    return {
        w: layoutItem.w,
        h: layoutItem.h,
        x: layoutItem.x,
        y: layoutItem.y,
        i: layoutItem.i,
        minW: layoutItem.minW,
        maxW: layoutItem.maxW,
        minH: layoutItem.minH,
        maxH: layoutItem.maxH,
        moved: Boolean(layoutItem.moved),
        static: Boolean(layoutItem.static),
        // These can be null/undefined
        isDraggable: layoutItem.isDraggable,
        isResizable: layoutItem.isResizable,
        resizeHandles: layoutItem.resizeHandles,
        isBounded: layoutItem.isBounded
    };
}
/**
 * Comparing React `children` is a bit difficult. This is a good way to compare them.
 * This will catch differences in keys, order, and length.
 */ function $1929941c7e17f531$var$childrenEqual(a /*: ReactChildren*/ , b /*: ReactChildren*/ ) /*: boolean*/ {
    return (0, $c7hp9.deepEqual)($1929941c7e17f531$var$_react.default.Children.map(a, (c)=>c === null || c === void 0 ? void 0 : c.key), $1929941c7e17f531$var$_react.default.Children.map(b, (c)=>c === null || c === void 0 ? void 0 : c.key)) && (0, $c7hp9.deepEqual)($1929941c7e17f531$var$_react.default.Children.map(a, (c)=>c === null || c === void 0 ? void 0 : c.props["data-grid"]), $1929941c7e17f531$var$_react.default.Children.map(b, (c)=>c === null || c === void 0 ? void 0 : c.props["data-grid"]));
}

/**
 * See `fastRGLPropsEqual.js`.
 * We want this to run as fast as possible - it is called often - and to be
 * resilient to new props that we add. So rather than call lodash.isEqual,
 * which isn't suited to comparing props very well, we use this specialized
 * function in conjunction with preval to generate the fastest possible comparison
 * function, tuned for exactly our props.
 */ /*:: type FastRGLPropsEqual = (Object, Object, Function) => boolean;*/ const $1929941c7e17f531$var$fastRGLPropsEqual /*: FastRGLPropsEqual*/  = module.exports.fastRGLPropsEqual = (parcelRequire("bdOaJ"));
// Like the above, but a lot simpler.
function $1929941c7e17f531$var$fastPositionEqual(a /*: Position*/ , b /*: Position*/ ) /*: boolean*/ {
    return a.left === b.left && a.top === b.top && a.width === b.width && a.height === b.height;
}
/**
 * Given two layoutitems, check if they collide.
 */ function $1929941c7e17f531$var$collides(l1 /*: LayoutItem*/ , l2 /*: LayoutItem*/ ) /*: boolean*/ {
    if (l1.i === l2.i) return false; // same element
    if (l1.x + l1.w <= l2.x) return false; // l1 is left of l2
    if (l1.x >= l2.x + l2.w) return false; // l1 is right of l2
    if (l1.y + l1.h <= l2.y) return false; // l1 is above l2
    if (l1.y >= l2.y + l2.h) return false; // l1 is below l2
    return true; // boxes overlap
}
/**
 * Given a layout, compact it. This involves going down each y coordinate and removing gaps
 * between items.
 *
 * Does not modify layout items (clones). Creates a new layout array.
 *
 * @param  {Array} layout Layout.
 * @param  {Boolean} verticalCompact Whether or not to compact the layout
 *   vertically.
 * @param  {Boolean} allowOverlap When `true`, allows overlapping grid items.
 * @return {Array}       Compacted Layout.
 */ function $1929941c7e17f531$var$compact(layout /*: Layout*/ , compactType /*: CompactType*/ , cols /*: number*/ , allowOverlap /*: ?boolean*/ ) /*: Layout*/ {
    // Statics go in the compareWith array right away so items flow around them.
    const compareWith = $1929941c7e17f531$var$getStatics(layout);
    // We keep track of the bottom position.
    let b = $1929941c7e17f531$var$bottom(compareWith);
    // We go through the items by row and column.
    const sorted = $1929941c7e17f531$var$sortLayoutItems(layout, compactType);
    // Holding for new items.
    const out = Array(layout.length);
    for(let i = 0, len = sorted.length; i < len; i++){
        let l = $1929941c7e17f531$var$cloneLayoutItem(sorted[i]);
        // Don't move static elements
        if (!l.static) {
            l = $1929941c7e17f531$var$compactItem(compareWith, l, compactType, cols, sorted, allowOverlap, b);
            b = Math.max(b, l.y + l.h);
            // Add to comparison array. We only collide with items before this one.
            // Statics are already in this array.
            compareWith.push(l);
        }
        // Add to output array to make sure they still come out in the right order.
        out[layout.indexOf(sorted[i])] = l;
        // Clear moved flag, if it exists.
        l.moved = false;
    }
    return out;
}
const $1929941c7e17f531$var$heightWidth = {
    x: "w",
    y: "h"
};
/**
 * Before moving item down, it will check if the movement will cause collisions and move those items down before.
 */ function $1929941c7e17f531$var$resolveCompactionCollision(layout /*: Layout*/ , item /*: LayoutItem*/ , moveToCoord /*: number*/ , axis /*: "x" | "y"*/ ) {
    const sizeProp = $1929941c7e17f531$var$heightWidth[axis];
    item[axis] += 1;
    const itemIndex = layout.map((layoutItem)=>{
        return layoutItem.i;
    }).indexOf(item.i);
    // Go through each item we collide with.
    for(let i = itemIndex + 1; i < layout.length; i++){
        const otherItem = layout[i];
        // Ignore static items
        if (otherItem.static) continue;
        // Optimization: we can break early if we know we're past this el
        // We can do this b/c it's a sorted layout
        if (otherItem.y > item.y + item.h) break;
        if ($1929941c7e17f531$var$collides(item, otherItem)) $1929941c7e17f531$var$resolveCompactionCollision(layout, otherItem, moveToCoord + item[sizeProp], axis);
    }
    item[axis] = moveToCoord;
}
/**
 * Compact an item in the layout.
 *
 * Modifies item.
 *
 */ function $1929941c7e17f531$var$compactItem(compareWith /*: Layout*/ , l /*: LayoutItem*/ , compactType /*: CompactType*/ , cols /*: number*/ , fullLayout /*: Layout*/ , allowOverlap /*: ?boolean*/ , b /*: ?number*/ ) /*: LayoutItem*/ {
    const compactV = compactType === "vertical";
    const compactH = compactType === "horizontal";
    if (compactV) {
        // Bottom 'y' possible is the bottom of the layout.
        // This allows you to do nice stuff like specify {y: Infinity}
        // This is here because the layout must be sorted in order to get the correct bottom `y`.
        if (typeof b === "number") l.y = Math.min(b, l.y);
        else l.y = Math.min($1929941c7e17f531$var$bottom(compareWith), l.y);
        // Move the element up as far as it can go without colliding.
        while(l.y > 0 && !$1929941c7e17f531$var$getFirstCollision(compareWith, l))l.y--;
    } else if (compactH) // Move the element left as far as it can go without colliding.
    while(l.x > 0 && !$1929941c7e17f531$var$getFirstCollision(compareWith, l))l.x--;
    // Move it down, and keep moving it down if it's colliding.
    let collides;
    // Checking the compactType null value to avoid breaking the layout when overlapping is allowed.
    while((collides = $1929941c7e17f531$var$getFirstCollision(compareWith, l)) && !(compactType === null && allowOverlap)){
        if (compactH) $1929941c7e17f531$var$resolveCompactionCollision(fullLayout, l, collides.x + collides.w, "x");
        else $1929941c7e17f531$var$resolveCompactionCollision(fullLayout, l, collides.y + collides.h, "y");
        // Since we can't grow without bounds horizontally, if we've overflown, let's move it down and try again.
        if (compactH && l.x + l.w > cols) {
            l.x = cols - l.w;
            l.y++;
            // ALso move element as left as we can
            while(l.x > 0 && !$1929941c7e17f531$var$getFirstCollision(compareWith, l))l.x--;
        }
    }
    // Ensure that there are no negative positions
    l.y = Math.max(l.y, 0);
    l.x = Math.max(l.x, 0);
    return l;
}
/**
 * Given a layout, make sure all elements fit within its bounds.
 *
 * Modifies layout items.
 *
 * @param  {Array} layout Layout array.
 * @param  {Number} bounds Number of columns.
 */ function $1929941c7e17f531$var$correctBounds(layout /*: Layout*/ , bounds /*: { cols: number }*/ ) /*: Layout*/ {
    const collidesWith = $1929941c7e17f531$var$getStatics(layout);
    for(let i = 0, len = layout.length; i < len; i++){
        const l = layout[i];
        // Overflows right
        if (l.x + l.w > bounds.cols) l.x = bounds.cols - l.w;
        // Overflows left
        if (l.x < 0) {
            l.x = 0;
            l.w = bounds.cols;
        }
        if (!l.static) collidesWith.push(l);
        else // If this is static and collides with other statics, we must move it down.
        // We have to do something nicer than just letting them overlap.
        while($1929941c7e17f531$var$getFirstCollision(collidesWith, l))l.y++;
    }
    return layout;
}
/**
 * Get a layout item by ID. Used so we can override later on if necessary.
 *
 * @param  {Array}  layout Layout array.
 * @param  {String} id     ID
 * @return {LayoutItem}    Item at ID.
 */ function $1929941c7e17f531$var$getLayoutItem(layout /*: Layout*/ , id /*: string*/ ) /*: ?LayoutItem*/ {
    for(let i = 0, len = layout.length; i < len; i++){
        if (layout[i].i === id) return layout[i];
    }
}
/**
 * Returns the first item this layout collides with.
 * It doesn't appear to matter which order we approach this from, although
 * perhaps that is the wrong thing to do.
 *
 * @param  {Object} layoutItem Layout item.
 * @return {Object|undefined}  A colliding layout item, or undefined.
 */ function $1929941c7e17f531$var$getFirstCollision(layout /*: Layout*/ , layoutItem /*: LayoutItem*/ ) /*: ?LayoutItem*/ {
    for(let i = 0, len = layout.length; i < len; i++){
        if ($1929941c7e17f531$var$collides(layout[i], layoutItem)) return layout[i];
    }
}
function $1929941c7e17f531$var$getAllCollisions(layout /*: Layout*/ , layoutItem /*: LayoutItem*/ ) /*: Array<LayoutItem>*/ {
    return layout.filter((l)=>$1929941c7e17f531$var$collides(l, layoutItem));
}
/**
 * Get all static elements.
 * @param  {Array} layout Array of layout objects.
 * @return {Array}        Array of static layout items..
 */ function $1929941c7e17f531$var$getStatics(layout /*: Layout*/ ) /*: Array<LayoutItem>*/ {
    return layout.filter((l)=>l.static);
}
/**
 * Move an element. Responsible for doing cascading movements of other elements.
 *
 * Modifies layout items.
 *
 * @param  {Array}      layout            Full layout to modify.
 * @param  {LayoutItem} l                 element to move.
 * @param  {Number}     [x]               X position in grid units.
 * @param  {Number}     [y]               Y position in grid units.
 */ function $1929941c7e17f531$var$moveElement(layout /*: Layout*/ , l /*: LayoutItem*/ , x /*: ?number*/ , y /*: ?number*/ , isUserAction /*: ?boolean*/ , preventCollision /*: ?boolean*/ , compactType /*: CompactType*/ , cols /*: number*/ , allowOverlap /*: ?boolean*/ ) /*: Layout*/ {
    // If this is static and not explicitly enabled as draggable,
    // no move is possible, so we can short-circuit this immediately.
    if (l.static && l.isDraggable !== true) return layout;
    // Short-circuit if nothing to do.
    if (l.y === y && l.x === x) return layout;
    $1929941c7e17f531$var$log("Moving element ".concat(l.i, " to [").concat(String(x), ",").concat(String(y), "] from [").concat(l.x, ",").concat(l.y, "]"));
    const oldX = l.x;
    const oldY = l.y;
    // This is quite a bit faster than extending the object
    if (typeof x === "number") l.x = x;
    if (typeof y === "number") l.y = y;
    l.moved = true;
    // If this collides with anything, move it.
    // When doing this comparison, we have to sort the items we compare with
    // to ensure, in the case of multiple collisions, that we're getting the
    // nearest collision.
    let sorted = $1929941c7e17f531$var$sortLayoutItems(layout, compactType);
    const movingUp = compactType === "vertical" && typeof y === "number" ? oldY >= y : compactType === "horizontal" && typeof x === "number" ? oldX >= x : false;
    // $FlowIgnore acceptable modification of read-only array as it was recently cloned
    if (movingUp) sorted = sorted.reverse();
    const collisions = $1929941c7e17f531$var$getAllCollisions(sorted, l);
    const hasCollisions = collisions.length > 0;
    // We may have collisions. We can short-circuit if we've turned off collisions or
    // allowed overlap.
    if (hasCollisions && allowOverlap) // Easy, we don't need to resolve collisions. But we *did* change the layout,
    // so clone it on the way out.
    return $1929941c7e17f531$var$cloneLayout(layout);
    else if (hasCollisions && preventCollision) {
        // If we are preventing collision but not allowing overlap, we need to
        // revert the position of this element so it goes to where it came from, rather
        // than the user's desired location.
        $1929941c7e17f531$var$log("Collision prevented on ".concat(l.i, ", reverting."));
        l.x = oldX;
        l.y = oldY;
        l.moved = false;
        return layout; // did not change so don't clone
    }
    // Move each item that collides away from this element.
    for(let i = 0, len = collisions.length; i < len; i++){
        const collision = collisions[i];
        $1929941c7e17f531$var$log("Resolving collision between ".concat(l.i, " at [").concat(l.x, ",").concat(l.y, "] and ").concat(collision.i, " at [").concat(collision.x, ",").concat(collision.y, "]"));
        // Short circuit so we can't infinite loop
        if (collision.moved) continue;
        // Don't move static items - we have to move *this* element away
        if (collision.static) layout = $1929941c7e17f531$var$moveElementAwayFromCollision(layout, collision, l, isUserAction, compactType, cols);
        else layout = $1929941c7e17f531$var$moveElementAwayFromCollision(layout, l, collision, isUserAction, compactType, cols);
    }
    return layout;
}
/**
 * This is where the magic needs to happen - given a collision, move an element away from the collision.
 * We attempt to move it up if there's room, otherwise it goes below.
 *
 * @param  {Array} layout            Full layout to modify.
 * @param  {LayoutItem} collidesWith Layout item we're colliding with.
 * @param  {LayoutItem} itemToMove   Layout item we're moving.
 */ function $1929941c7e17f531$var$moveElementAwayFromCollision(layout /*: Layout*/ , collidesWith /*: LayoutItem*/ , itemToMove /*: LayoutItem*/ , isUserAction /*: ?boolean*/ , compactType /*: CompactType*/ , cols /*: number*/ ) /*: Layout*/ {
    const compactH = compactType === "horizontal";
    // Compact vertically if not set to horizontal
    const compactV = compactType === "vertical";
    const preventCollision = collidesWith.static; // we're already colliding (not for static items)
    // If there is enough space above the collision to put this element, move it there.
    // We only do this on the main collision as this can get funky in cascades and cause
    // unwanted swapping behavior.
    if (isUserAction) {
        // Reset isUserAction flag because we're not in the main collision anymore.
        isUserAction = false;
        // Make a mock item so we don't modify the item here, only modify in moveElement.
        const fakeItem /*: LayoutItem*/  = {
            x: compactH ? Math.max(collidesWith.x - itemToMove.w, 0) : itemToMove.x,
            y: compactV ? Math.max(collidesWith.y - itemToMove.h, 0) : itemToMove.y,
            w: itemToMove.w,
            h: itemToMove.h,
            i: "-1"
        };
        const firstCollision = $1929941c7e17f531$var$getFirstCollision(layout, fakeItem);
        const collisionNorth = firstCollision && firstCollision.y + firstCollision.h > collidesWith.y;
        const collisionWest = firstCollision && collidesWith.x + collidesWith.w > firstCollision.x;
        // No collision? If so, we can go up there; otherwise, we'll end up moving down as normal
        if (!firstCollision) {
            $1929941c7e17f531$var$log("Doing reverse collision on ".concat(itemToMove.i, " up to [").concat(fakeItem.x, ",").concat(fakeItem.y, "]."));
            return $1929941c7e17f531$var$moveElement(layout, itemToMove, compactH ? fakeItem.x : undefined, compactV ? fakeItem.y : undefined, isUserAction, preventCollision, compactType, cols);
        } else if (collisionNorth && compactV) return $1929941c7e17f531$var$moveElement(layout, itemToMove, undefined, itemToMove.y + 1, isUserAction, preventCollision, compactType, cols);
        else if (collisionNorth && compactType == null) {
            collidesWith.y = itemToMove.y;
            itemToMove.y = itemToMove.y + itemToMove.h;
            return layout;
        } else if (collisionWest && compactH) return $1929941c7e17f531$var$moveElement(layout, collidesWith, itemToMove.x, undefined, isUserAction, preventCollision, compactType, cols);
    }
    const newX = compactH ? itemToMove.x + 1 : undefined;
    const newY = compactV ? itemToMove.y + 1 : undefined;
    if (newX == null && newY == null) return layout;
    return $1929941c7e17f531$var$moveElement(layout, itemToMove, compactH ? itemToMove.x + 1 : undefined, compactV ? itemToMove.y + 1 : undefined, isUserAction, preventCollision, compactType, cols);
}
/**
 * Helper to convert a number to a percentage string.
 *
 * @param  {Number} num Any number
 * @return {String}     That number as a percentage.
 */ function $1929941c7e17f531$var$perc(num /*: number*/ ) /*: string*/ {
    return num * 100 + "%";
}
/**
 * Helper functions to constrain dimensions of a GridItem
 */ const $1929941c7e17f531$var$constrainWidth = (left /*: number*/ , currentWidth /*: number*/ , newWidth /*: number*/ , containerWidth /*: number*/ )=>{
    return left + newWidth > containerWidth ? currentWidth : newWidth;
};
const $1929941c7e17f531$var$constrainHeight = (top /*: number*/ , currentHeight /*: number*/ , newHeight /*: number*/ )=>{
    return top < 0 ? currentHeight : newHeight;
};
const $1929941c7e17f531$var$constrainLeft = (left /*: number*/ )=>Math.max(0, left);
const $1929941c7e17f531$var$constrainTop = (top /*: number*/ )=>Math.max(0, top);
const $1929941c7e17f531$var$resizeNorth = (currentSize, _ref, _containerWidth)=>{
    let { left: left, height: height, width: width } = _ref;
    const top = currentSize.top - (height - currentSize.height);
    return {
        left: left,
        width: width,
        height: $1929941c7e17f531$var$constrainHeight(top, currentSize.height, height),
        top: $1929941c7e17f531$var$constrainTop(top)
    };
};
const $1929941c7e17f531$var$resizeEast = (currentSize, _ref2, containerWidth)=>{
    let { top: top, left: left, height: height, width: width } = _ref2;
    return {
        top: top,
        height: height,
        width: $1929941c7e17f531$var$constrainWidth(currentSize.left, currentSize.width, width, containerWidth),
        left: $1929941c7e17f531$var$constrainLeft(left)
    };
};
const $1929941c7e17f531$var$resizeWest = (currentSize, _ref3, containerWidth)=>{
    let { top: top, height: height, width: width } = _ref3;
    const left = currentSize.left - (width - currentSize.width);
    return {
        height: height,
        width: left < 0 ? currentSize.width : $1929941c7e17f531$var$constrainWidth(currentSize.left, currentSize.width, width, containerWidth),
        top: $1929941c7e17f531$var$constrainTop(top),
        left: $1929941c7e17f531$var$constrainLeft(left)
    };
};
const $1929941c7e17f531$var$resizeSouth = (currentSize, _ref4, containerWidth)=>{
    let { top: top, left: left, height: height, width: width } = _ref4;
    return {
        width: width,
        left: left,
        height: $1929941c7e17f531$var$constrainHeight(top, currentSize.height, height),
        top: $1929941c7e17f531$var$constrainTop(top)
    };
};
const $1929941c7e17f531$var$resizeNorthEast = function() {
    return $1929941c7e17f531$var$resizeNorth(arguments.length <= 0 ? undefined : arguments[0], $1929941c7e17f531$var$resizeEast(...arguments), arguments.length <= 2 ? undefined : arguments[2]);
};
const $1929941c7e17f531$var$resizeNorthWest = function() {
    return $1929941c7e17f531$var$resizeNorth(arguments.length <= 0 ? undefined : arguments[0], $1929941c7e17f531$var$resizeWest(...arguments), arguments.length <= 2 ? undefined : arguments[2]);
};
const $1929941c7e17f531$var$resizeSouthEast = function() {
    return $1929941c7e17f531$var$resizeSouth(arguments.length <= 0 ? undefined : arguments[0], $1929941c7e17f531$var$resizeEast(...arguments), arguments.length <= 2 ? undefined : arguments[2]);
};
const $1929941c7e17f531$var$resizeSouthWest = function() {
    return $1929941c7e17f531$var$resizeSouth(arguments.length <= 0 ? undefined : arguments[0], $1929941c7e17f531$var$resizeWest(...arguments), arguments.length <= 2 ? undefined : arguments[2]);
};
const $1929941c7e17f531$var$ordinalResizeHandlerMap = {
    n: $1929941c7e17f531$var$resizeNorth,
    ne: $1929941c7e17f531$var$resizeNorthEast,
    e: $1929941c7e17f531$var$resizeEast,
    se: $1929941c7e17f531$var$resizeSouthEast,
    s: $1929941c7e17f531$var$resizeSouth,
    sw: $1929941c7e17f531$var$resizeSouthWest,
    w: $1929941c7e17f531$var$resizeWest,
    nw: $1929941c7e17f531$var$resizeNorthWest
};
/**
 * Helper for clamping width and position when resizing an item.
 */ function $1929941c7e17f531$var$resizeItemInDirection(direction /*: ResizeHandleAxis*/ , currentSize /*: Position*/ , newSize /*: Position*/ , containerWidth /*: number*/ ) /*: Position*/ {
    const ordinalHandler = $1929941c7e17f531$var$ordinalResizeHandlerMap[direction];
    // Shouldn't be possible given types; that said, don't fail hard
    if (!ordinalHandler) return newSize;
    return ordinalHandler(currentSize, $1929941c7e17f531$var$_objectSpread($1929941c7e17f531$var$_objectSpread({}, currentSize), newSize), containerWidth);
}
function $1929941c7e17f531$var$setTransform(_ref5 /*:: */ ) /*: Object*/ {
    let { top: top, left: left, width: width, height: height } /*: Position*/  = _ref5 /*: Position*/ ;
    // Replace unitless items with px
    const translate = "translate(".concat(left, "px,").concat(top, "px)");
    return {
        transform: translate,
        WebkitTransform: translate,
        MozTransform: translate,
        msTransform: translate,
        OTransform: translate,
        width: "".concat(width, "px"),
        height: "".concat(height, "px"),
        position: "absolute"
    };
}
function $1929941c7e17f531$var$setTopLeft(_ref6 /*:: */ ) /*: Object*/ {
    let { top: top, left: left, width: width, height: height } /*: Position*/  = _ref6 /*: Position*/ ;
    return {
        top: "".concat(top, "px"),
        left: "".concat(left, "px"),
        width: "".concat(width, "px"),
        height: "".concat(height, "px"),
        position: "absolute"
    };
}
/**
 * Get layout items sorted from top left to right and down.
 *
 * @return {Array} Array of layout objects.
 * @return {Array}        Layout, sorted static items first.
 */ function $1929941c7e17f531$var$sortLayoutItems(layout /*: Layout*/ , compactType /*: CompactType*/ ) /*: Layout*/ {
    if (compactType === "horizontal") return $1929941c7e17f531$var$sortLayoutItemsByColRow(layout);
    if (compactType === "vertical") return $1929941c7e17f531$var$sortLayoutItemsByRowCol(layout);
    else return layout;
}
/**
 * Sort layout items by row ascending and column ascending.
 *
 * Does not modify Layout.
 */ function $1929941c7e17f531$var$sortLayoutItemsByRowCol(layout /*: Layout*/ ) /*: Layout*/ {
    // Slice to clone array as sort modifies
    return layout.slice(0).sort(function(a, b) {
        if (a.y > b.y || a.y === b.y && a.x > b.x) return 1;
        else if (a.y === b.y && a.x === b.x) // Without this, we can get different sort results in IE vs. Chrome/FF
        return 0;
        return -1;
    });
}
/**
 * Sort layout items by column ascending then row ascending.
 *
 * Does not modify Layout.
 */ function $1929941c7e17f531$var$sortLayoutItemsByColRow(layout /*: Layout*/ ) /*: Layout*/ {
    return layout.slice(0).sort(function(a, b) {
        if (a.x > b.x || a.x === b.x && a.y > b.y) return 1;
        return -1;
    });
}
/**
 * Generate a layout using the initialLayout and children as a template.
 * Missing entries will be added, extraneous ones will be truncated.
 *
 * Does not modify initialLayout.
 *
 * @param  {Array}  initialLayout Layout passed in through props.
 * @param  {String} breakpoint    Current responsive breakpoint.
 * @param  {?String} compact      Compaction option.
 * @return {Array}                Working layout.
 */ function $1929941c7e17f531$var$synchronizeLayoutWithChildren(initialLayout /*: Layout*/ , children /*: ReactChildren*/ , cols /*: number*/ , compactType /*: CompactType*/ , allowOverlap /*: ?boolean*/ ) /*: Layout*/ {
    initialLayout = initialLayout || [];
    // Generate one layout item per child.
    const layout /*: LayoutItem[]*/  = [];
    $1929941c7e17f531$var$_react.default.Children.forEach(children, (child /*: ReactElement<any>*/ )=>{
        // Child may not exist
        if ((child === null || child === void 0 ? void 0 : child.key) == null) return;
        const exists = $1929941c7e17f531$var$getLayoutItem(initialLayout, String(child.key));
        const g = child.props["data-grid"];
        // Don't overwrite the layout item if it's already in the initial layout.
        // If it has a `data-grid` property, prefer that over what's in the layout.
        if (exists && g == null) layout.push($1929941c7e17f531$var$cloneLayoutItem(exists));
        else // Hey, this item has a data-grid property, use it.
        if (g) {
            if (!$1929941c7e17f531$var$isProduction) $1929941c7e17f531$var$validateLayout([
                g
            ], "ReactGridLayout.children");
            // FIXME clone not really necessary here
            layout.push($1929941c7e17f531$var$cloneLayoutItem($1929941c7e17f531$var$_objectSpread($1929941c7e17f531$var$_objectSpread({}, g), {}, {
                i: child.key
            })));
        } else // Nothing provided: ensure this is added to the bottom
        // FIXME clone not really necessary here
        layout.push($1929941c7e17f531$var$cloneLayoutItem({
            w: 1,
            h: 1,
            x: 0,
            y: $1929941c7e17f531$var$bottom(layout),
            i: String(child.key)
        }));
    });
    // Correct the layout.
    const correctedLayout = $1929941c7e17f531$var$correctBounds(layout, {
        cols: cols
    });
    return allowOverlap ? correctedLayout : $1929941c7e17f531$var$compact(correctedLayout, compactType, cols);
}
/**
 * Validate a layout. Throws errors.
 *
 * @param  {Array}  layout        Array of layout items.
 * @param  {String} [contextName] Context name for errors.
 * @throw  {Error}                Validation error.
 */ function $1929941c7e17f531$var$validateLayout(layout /*: Layout*/ ) /*: void*/ {
    let contextName /*: string*/  = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Layout";
    const subProps = [
        "x",
        "y",
        "w",
        "h"
    ];
    if (!Array.isArray(layout)) throw new Error(contextName + " must be an array!");
    for(let i = 0, len = layout.length; i < len; i++){
        const item = layout[i];
        for(let j = 0; j < subProps.length; j++){
            const key = subProps[j];
            const value = item[key];
            if (typeof value !== "number" || Number.isNaN(value)) throw new Error("ReactGridLayout: ".concat(contextName, "[").concat(i, "].").concat(key, " must be a number! Received: ").concat(value, " (").concat(typeof value, ")"));
        }
        if (typeof item.i !== "undefined" && typeof item.i !== "string") throw new Error("ReactGridLayout: ".concat(contextName, "[").concat(i, "].i must be a string! Received: ").concat(item.i, " (").concat(typeof item.i, ")"));
    }
}
// Legacy support for verticalCompact: false
function $1929941c7e17f531$var$compactType(props /*: ?{ verticalCompact: boolean, compactType: CompactType }*/ ) /*: CompactType*/ {
    const { verticalCompact: verticalCompact, compactType: compactType } = props || {};
    return verticalCompact === false ? null : compactType;
}
function $1929941c7e17f531$var$log() {
    if (!$1929941c7e17f531$var$DEBUG) return;
    // eslint-disable-next-line no-console
    console.log(...arguments);
}
const $1929941c7e17f531$var$noop = ()=>{};
module.exports.noop = $1929941c7e17f531$var$noop;

});
parcelRegister("bdOaJ", function(module, exports) {
// this file was prevaled
module.exports = function fastRGLPropsEqual(a, b, isEqualImpl) {
    if (a === b) return true;
    return a.className === b.className && isEqualImpl(a.style, b.style) && a.width === b.width && a.autoSize === b.autoSize && a.cols === b.cols && a.draggableCancel === b.draggableCancel && a.draggableHandle === b.draggableHandle && isEqualImpl(a.verticalCompact, b.verticalCompact) && isEqualImpl(a.compactType, b.compactType) && isEqualImpl(a.layout, b.layout) && isEqualImpl(a.margin, b.margin) && isEqualImpl(a.containerPadding, b.containerPadding) && a.rowHeight === b.rowHeight && a.maxRows === b.maxRows && a.isBounded === b.isBounded && a.isDraggable === b.isDraggable && a.isResizable === b.isResizable && a.allowOverlap === b.allowOverlap && a.preventCollision === b.preventCollision && a.useCSSTransforms === b.useCSSTransforms && a.transformScale === b.transformScale && a.isDroppable === b.isDroppable && isEqualImpl(a.resizeHandles, b.resizeHandles) && isEqualImpl(a.resizeHandle, b.resizeHandle) && a.onLayoutChange === b.onLayoutChange && a.onDragStart === b.onDragStart && a.onDrag === b.onDrag && a.onDragStop === b.onDragStop && a.onResizeStart === b.onResizeStart && a.onResize === b.onResize && a.onResizeStop === b.onResizeStop && a.onDrop === b.onDrop && isEqualImpl(a.droppingItem, b.droppingItem) && isEqualImpl(a.innerRef, b.innerRef);
};

});


parcelRegister("bXTFA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.calcGridColWidth = $8b6063435b413cb5$var$calcGridColWidth;
module.exports.calcGridItemPosition = $8b6063435b413cb5$var$calcGridItemPosition;
module.exports.calcGridItemWHPx = $8b6063435b413cb5$var$calcGridItemWHPx;
module.exports.calcWH = $8b6063435b413cb5$var$calcWH;
module.exports.calcXY = $8b6063435b413cb5$var$calcXY;
module.exports.clamp = $8b6063435b413cb5$var$clamp;
/*:: import type { Position } from "./utils";*/ /*:: export type PositionParams = {
  margin: [number, number],
  containerPadding: [number, number],
  containerWidth: number,
  cols: number,
  rowHeight: number,
  maxRows: number
};*/ // Helper for generating column width
function $8b6063435b413cb5$var$calcGridColWidth(positionParams /*: PositionParams*/ ) /*: number*/ {
    const { margin: margin, containerPadding: containerPadding, containerWidth: containerWidth, cols: cols } = positionParams;
    return (containerWidth - margin[0] * (cols - 1) - containerPadding[0] * 2) / cols;
}
// This can either be called:
// calcGridItemWHPx(w, colWidth, margin[0])
// or
// calcGridItemWHPx(h, rowHeight, margin[1])
function $8b6063435b413cb5$var$calcGridItemWHPx(gridUnits /*: number*/ , colOrRowSize /*: number*/ , marginPx /*: number*/ ) /*: number*/ {
    // 0 * Infinity === NaN, which causes problems with resize contraints
    if (!Number.isFinite(gridUnits)) return gridUnits;
    return Math.round(colOrRowSize * gridUnits + Math.max(0, gridUnits - 1) * marginPx);
}
/**
 * Return position on the page given an x, y, w, h.
 * left, top, width, height are all in pixels.
 * @param  {PositionParams} positionParams  Parameters of grid needed for coordinates calculations.
 * @param  {Number}  x                      X coordinate in grid units.
 * @param  {Number}  y                      Y coordinate in grid units.
 * @param  {Number}  w                      W coordinate in grid units.
 * @param  {Number}  h                      H coordinate in grid units.
 * @return {Position}                       Object containing coords.
 */ function $8b6063435b413cb5$var$calcGridItemPosition(positionParams /*: PositionParams*/ , x /*: number*/ , y /*: number*/ , w /*: number*/ , h /*: number*/ , state /*: ?Object*/ ) /*: Position*/ {
    const { margin: margin, containerPadding: containerPadding, rowHeight: rowHeight } = positionParams;
    const colWidth = $8b6063435b413cb5$var$calcGridColWidth(positionParams);
    const out = {};
    // If resizing, use the exact width and height as returned from resizing callbacks.
    if (state && state.resizing) {
        out.width = Math.round(state.resizing.width);
        out.height = Math.round(state.resizing.height);
    } else {
        out.width = $8b6063435b413cb5$var$calcGridItemWHPx(w, colWidth, margin[0]);
        out.height = $8b6063435b413cb5$var$calcGridItemWHPx(h, rowHeight, margin[1]);
    }
    // If dragging, use the exact width and height as returned from dragging callbacks.
    if (state && state.dragging) {
        out.top = Math.round(state.dragging.top);
        out.left = Math.round(state.dragging.left);
    } else if (state && state.resizing && typeof state.resizing.top === "number" && typeof state.resizing.left === "number") {
        out.top = Math.round(state.resizing.top);
        out.left = Math.round(state.resizing.left);
    } else {
        out.top = Math.round((rowHeight + margin[1]) * y + containerPadding[1]);
        out.left = Math.round((colWidth + margin[0]) * x + containerPadding[0]);
    }
    return out;
}
/**
 * Translate x and y coordinates from pixels to grid units.
 * @param  {PositionParams} positionParams  Parameters of grid needed for coordinates calculations.
 * @param  {Number} top                     Top position (relative to parent) in pixels.
 * @param  {Number} left                    Left position (relative to parent) in pixels.
 * @param  {Number} w                       W coordinate in grid units.
 * @param  {Number} h                       H coordinate in grid units.
 * @return {Object}                         x and y in grid units.
 */ function $8b6063435b413cb5$var$calcXY(positionParams /*: PositionParams*/ , top /*: number*/ , left /*: number*/ , w /*: number*/ , h /*: number*/ ) /*: { x: number, y: number }*/ {
    const { margin: margin, containerPadding: containerPadding, cols: cols, rowHeight: rowHeight, maxRows: maxRows } = positionParams;
    const colWidth = $8b6063435b413cb5$var$calcGridColWidth(positionParams);
    // left = containerPaddingX + x * (colWidth + marginX)
    // x * (colWidth + marginX) = left - containerPaddingX
    // x = (left - containerPaddingX) / (colWidth + marginX)
    let x = Math.round((left - containerPadding[0]) / (colWidth + margin[0]));
    let y = Math.round((top - containerPadding[1]) / (rowHeight + margin[1]));
    // Capping
    x = $8b6063435b413cb5$var$clamp(x, 0, cols - w);
    y = $8b6063435b413cb5$var$clamp(y, 0, maxRows - h);
    return {
        x: x,
        y: y
    };
}
/**
 * Given a height and width in pixel values, calculate grid units.
 * @param  {PositionParams} positionParams  Parameters of grid needed for coordinates calcluations.
 * @param  {Number} height                  Height in pixels.
 * @param  {Number} width                   Width in pixels.
 * @param  {Number} x                       X coordinate in grid units.
 * @param  {Number} y                       Y coordinate in grid units.
 * @param {String} handle Resize Handle.
 * @return {Object}                         w, h as grid units.
 */ function $8b6063435b413cb5$var$calcWH(positionParams /*: PositionParams*/ , width /*: number*/ , height /*: number*/ , x /*: number*/ , y /*: number*/ , handle /*: string*/ ) /*: { w: number, h: number }*/ {
    const { margin: margin, maxRows: maxRows, cols: cols, rowHeight: rowHeight } = positionParams;
    const colWidth = $8b6063435b413cb5$var$calcGridColWidth(positionParams);
    // width = colWidth * w - (margin * (w - 1))
    // ...
    // w = (width + margin) / (colWidth + margin)
    let w = Math.round((width + margin[0]) / (colWidth + margin[0]));
    let h = Math.round((height + margin[1]) / (rowHeight + margin[1]));
    // Capping
    let _w = $8b6063435b413cb5$var$clamp(w, 0, cols - x);
    let _h = $8b6063435b413cb5$var$clamp(h, 0, maxRows - y);
    if ([
        "sw",
        "w",
        "nw"
    ].indexOf(handle) !== -1) _w = $8b6063435b413cb5$var$clamp(w, 0, cols);
    if ([
        "nw",
        "n",
        "ne"
    ].indexOf(handle) !== -1) _h = $8b6063435b413cb5$var$clamp(h, 0, maxRows);
    return {
        w: _w,
        h: _h
    };
}
// Similar to _.clamp
function $8b6063435b413cb5$var$clamp(num /*: number*/ , lowerBound /*: number*/ , upperBound /*: number*/ ) /*: number*/ {
    return Math.max(Math.min(num, upperBound), lowerBound);
}

});

parcelRegister("6iFJN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4964ccb8f7a67231$var$_react = $4964ccb8f7a67231$var$_interopRequireDefault((parcelRequire("cQQee")));

var $kC364 = parcelRequire("kC364");

var $4964ccb8f7a67231$var$_propTypes = $4964ccb8f7a67231$var$_interopRequireDefault((parcelRequire("9AqQV")));
parcelRequire("a8ZiJ");
var $iEQMr = parcelRequire("iEQMr");

var $3BCMg = parcelRequire("3BCMg");

var $29Wdk = parcelRequire("29Wdk");

var $bXTFA = parcelRequire("bXTFA");

var $kAZeL = parcelRequire("kAZeL");

var $4964ccb8f7a67231$var$_clsx = $4964ccb8f7a67231$var$_interopRequireDefault((parcelRequire("lY25K")));
function $4964ccb8f7a67231$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $4964ccb8f7a67231$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4964ccb8f7a67231$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4964ccb8f7a67231$var$ownKeys(Object(t), !0).forEach(function(r) {
            $4964ccb8f7a67231$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4964ccb8f7a67231$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $4964ccb8f7a67231$var$_defineProperty(e, r, t) {
    return (r = $4964ccb8f7a67231$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $4964ccb8f7a67231$var$_toPropertyKey(t) {
    var i = $4964ccb8f7a67231$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $4964ccb8f7a67231$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
/*:: import type { Element as ReactElement, Node as ReactNode } from "react";*/ /*:: import type {
  ReactDraggableCallbackData,
  GridDragEvent,
  GridResizeEvent,
  DroppingPosition,
  Position,
  ResizeHandleAxis
} from "./utils";*/ /*:: import type { PositionParams } from "./calculateUtils";*/ /*:: import type { ResizeHandle, ReactRef } from "./ReactGridLayoutPropTypes";*/ /*:: type PartialPosition = { top: number, left: number };*/ /*:: type GridItemCallback<Data: GridDragEvent | GridResizeEvent> = (
  i: string,
  w: number,
  h: number,
  Data
) => void;*/ /*:: type ResizeCallbackData = {
  node: HTMLElement,
  size: Position,
  handle: ResizeHandleAxis
};*/ /*:: type GridItemResizeCallback = (
  e: Event,
  data: ResizeCallbackData,
  position: Position
) => void;*/ /*:: type State = {
  resizing: ?{ top: number, left: number, width: number, height: number },
  dragging: ?{ top: number, left: number },
  className: string
};*/ /*:: type Props = {
  children: ReactElement<any>,
  cols: number,
  containerWidth: number,
  margin: [number, number],
  containerPadding: [number, number],
  rowHeight: number,
  maxRows: number,
  isDraggable: boolean,
  isResizable: boolean,
  isBounded: boolean,
  static?: boolean,
  useCSSTransforms?: boolean,
  usePercentages?: boolean,
  transformScale: number,
  droppingPosition?: DroppingPosition,

  className: string,
  style?: Object,
  // Draggability
  cancel: string,
  handle: string,

  x: number,
  y: number,
  w: number,
  h: number,

  minW: number,
  maxW: number,
  minH: number,
  maxH: number,
  i: string,

  resizeHandles?: ResizeHandleAxis[],
  resizeHandle?: ResizeHandle,

  onDrag?: GridItemCallback<GridDragEvent>,
  onDragStart?: GridItemCallback<GridDragEvent>,
  onDragStop?: GridItemCallback<GridDragEvent>,
  onResize?: GridItemCallback<GridResizeEvent>,
  onResizeStart?: GridItemCallback<GridResizeEvent>,
  onResizeStop?: GridItemCallback<GridResizeEvent>
};*/ /*:: type DefaultProps = {
  className: string,
  cancel: string,
  handle: string,
  minH: number,
  minW: number,
  maxH: number,
  maxW: number,
  transformScale: number
};*/ /**
 * An individual item within a ReactGridLayout.
 */ class $4964ccb8f7a67231$var$GridItem extends $4964ccb8f7a67231$var$_react.default.Component /*:: <Props, State>*/  {
    constructor(){
        super(...arguments);
        $4964ccb8f7a67231$var$_defineProperty(this, "state", {
            resizing: null,
            dragging: null,
            className: ""
        });
        $4964ccb8f7a67231$var$_defineProperty(this, "elementRef", /*#__PURE__*/ $4964ccb8f7a67231$var$_react.default.createRef());
        /**
     * onDragStart event handler
     * @param  {Event}  e             event data
     * @param  {Object} callbackData  an object with node, delta and position information
     */ $4964ccb8f7a67231$var$_defineProperty(this, "onDragStart", (e, _ref)=>{
            let { node: node } = _ref;
            const { onDragStart: onDragStart, transformScale: transformScale } = this.props;
            if (!onDragStart) return;
            const newPosition /*: PartialPosition*/  = {
                top: 0,
                left: 0
            };
            // TODO: this wont work on nested parents
            const { offsetParent: offsetParent } = node;
            if (!offsetParent) return;
            const parentRect = offsetParent.getBoundingClientRect();
            const clientRect = node.getBoundingClientRect();
            const cLeft = clientRect.left / transformScale;
            const pLeft = parentRect.left / transformScale;
            const cTop = clientRect.top / transformScale;
            const pTop = parentRect.top / transformScale;
            newPosition.left = cLeft - pLeft + offsetParent.scrollLeft;
            newPosition.top = cTop - pTop + offsetParent.scrollTop;
            this.setState({
                dragging: newPosition
            });
            // Call callback with this data
            const { x: x, y: y } = (0, $bXTFA.calcXY)(this.getPositionParams(), newPosition.top, newPosition.left, this.props.w, this.props.h);
            return onDragStart.call(this, this.props.i, x, y, {
                e: e,
                node: node,
                newPosition: newPosition
            });
        });
        /**
     * onDrag event handler
     * @param  {Event}  e             event data
     * @param  {Object} callbackData  an object with node, delta and position information
     * @param  {boolean} dontFlush    if true, will not call flushSync
     */ $4964ccb8f7a67231$var$_defineProperty(this, "onDrag", (e, _ref2, dontFlush)=>{
            let { node: node, deltaX: deltaX, deltaY: deltaY } = _ref2;
            const { onDrag: onDrag } = this.props;
            if (!onDrag) return;
            if (!this.state.dragging) throw new Error("onDrag called before onDragStart.");
            let top = this.state.dragging.top + deltaY;
            let left = this.state.dragging.left + deltaX;
            const { isBounded: isBounded, i: i, w: w, h: h, containerWidth: containerWidth } = this.props;
            const positionParams = this.getPositionParams();
            // Boundary calculations; keeps items within the grid
            if (isBounded) {
                const { offsetParent: offsetParent } = node;
                if (offsetParent) {
                    const { margin: margin, rowHeight: rowHeight } = this.props;
                    const bottomBoundary = offsetParent.clientHeight - (0, $bXTFA.calcGridItemWHPx)(h, rowHeight, margin[1]);
                    top = (0, $bXTFA.clamp)(top, 0, bottomBoundary);
                    const colWidth = (0, $bXTFA.calcGridColWidth)(positionParams);
                    const rightBoundary = containerWidth - (0, $bXTFA.calcGridItemWHPx)(w, colWidth, margin[0]);
                    left = (0, $bXTFA.clamp)(left, 0, rightBoundary);
                }
            }
            const newPosition /*: PartialPosition*/  = {
                top: top,
                left: left
            };
            // dontFlush is set if we're calling from inside
            if (dontFlush) this.setState({
                dragging: newPosition
            });
            else (0, $kC364.flushSync)(()=>{
                this.setState({
                    dragging: newPosition
                });
            });
            // Call callback with this data
            const { x: x, y: y } = (0, $bXTFA.calcXY)(positionParams, top, left, w, h);
            return onDrag.call(this, i, x, y, {
                e: e,
                node: node,
                newPosition: newPosition
            });
        });
        /**
     * onDragStop event handler
     * @param  {Event}  e             event data
     * @param  {Object} callbackData  an object with node, delta and position information
     */ $4964ccb8f7a67231$var$_defineProperty(this, "onDragStop", (e, _ref3)=>{
            let { node: node } = _ref3;
            const { onDragStop: onDragStop } = this.props;
            if (!onDragStop) return;
            if (!this.state.dragging) throw new Error("onDragEnd called before onDragStart.");
            const { w: w, h: h, i: i } = this.props;
            const { left: left, top: top } = this.state.dragging;
            const newPosition /*: PartialPosition*/  = {
                top: top,
                left: left
            };
            this.setState({
                dragging: null
            });
            const { x: x, y: y } = (0, $bXTFA.calcXY)(this.getPositionParams(), top, left, w, h);
            return onDragStop.call(this, i, x, y, {
                e: e,
                node: node,
                newPosition: newPosition
            });
        });
        /**
     * onResizeStop event handler
     * @param  {Event}  e             event data
     * @param  {Object} callbackData  an object with node and size information
     */ $4964ccb8f7a67231$var$_defineProperty(this, "onResizeStop", (e, callbackData, position)=>this.onResizeHandler(e, callbackData, position, "onResizeStop"));
        // onResizeStart event handler
        $4964ccb8f7a67231$var$_defineProperty(this, "onResizeStart", (e, callbackData, position)=>this.onResizeHandler(e, callbackData, position, "onResizeStart"));
        // onResize event handler
        $4964ccb8f7a67231$var$_defineProperty(this, "onResize", (e, callbackData, position)=>this.onResizeHandler(e, callbackData, position, "onResize"));
    }
    shouldComponentUpdate(nextProps /*: Props*/ , nextState /*: State*/ ) /*: boolean*/ {
        // We can't deeply compare children. If the developer memoizes them, we can
        // use this optimization.
        if (this.props.children !== nextProps.children) return true;
        if (this.props.droppingPosition !== nextProps.droppingPosition) return true;
        // TODO memoize these calculations so they don't take so long?
        const oldPosition = (0, $bXTFA.calcGridItemPosition)(this.getPositionParams(this.props), this.props.x, this.props.y, this.props.w, this.props.h, this.state);
        const newPosition = (0, $bXTFA.calcGridItemPosition)(this.getPositionParams(nextProps), nextProps.x, nextProps.y, nextProps.w, nextProps.h, nextState);
        return !(0, $29Wdk.fastPositionEqual)(oldPosition, newPosition) || this.props.useCSSTransforms !== nextProps.useCSSTransforms;
    }
    componentDidMount() {
        this.moveDroppingItem({});
    }
    componentDidUpdate(prevProps /*: Props*/ ) {
        this.moveDroppingItem(prevProps);
    }
    // When a droppingPosition is present, this means we should fire a move event, as if we had moved
    // this element by `x, y` pixels.
    moveDroppingItem(prevProps /*: Props*/ ) {
        const { droppingPosition: droppingPosition } = this.props;
        if (!droppingPosition) return;
        const node = this.elementRef.current;
        // Can't find DOM node (are we unmounted?)
        if (!node) return;
        const prevDroppingPosition = prevProps.droppingPosition || {
            left: 0,
            top: 0
        };
        const { dragging: dragging } = this.state;
        const shouldDrag = dragging && droppingPosition.left !== prevDroppingPosition.left || droppingPosition.top !== prevDroppingPosition.top;
        if (!dragging) this.onDragStart(droppingPosition.e, {
            node: node,
            deltaX: droppingPosition.left,
            deltaY: droppingPosition.top
        });
        else if (shouldDrag) {
            const deltaX = droppingPosition.left - dragging.left;
            const deltaY = droppingPosition.top - dragging.top;
            this.onDrag(droppingPosition.e, {
                node: node,
                deltaX: deltaX,
                deltaY: deltaY
            }, true // dontFLush: avoid flushSync to temper warnings
            );
        }
    }
    getPositionParams() /*: PositionParams*/ {
        let props /*: Props*/  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
        return {
            cols: props.cols,
            containerPadding: props.containerPadding,
            containerWidth: props.containerWidth,
            margin: props.margin,
            maxRows: props.maxRows,
            rowHeight: props.rowHeight
        };
    }
    /**
   * This is where we set the grid item's absolute placement. It gets a little tricky because we want to do it
   * well when server rendering, and the only way to do that properly is to use percentage width/left because
   * we don't know exactly what the browser viewport is.
   * Unfortunately, CSS Transforms, which are great for performance, break in this instance because a percentage
   * left is relative to the item itself, not its container! So we cannot use them on the server rendering pass.
   *
   * @param  {Object} pos Position object with width, height, left, top.
   * @return {Object}     Style object.
   */ createStyle(pos /*: Position*/ ) /*: { [key: string]: ?string }*/ {
        const { usePercentages: usePercentages, containerWidth: containerWidth, useCSSTransforms: useCSSTransforms } = this.props;
        let style;
        // CSS Transforms support (default)
        if (useCSSTransforms) style = (0, $29Wdk.setTransform)(pos);
        else {
            // top,left (slow)
            style = (0, $29Wdk.setTopLeft)(pos);
            // This is used for server rendering.
            if (usePercentages) {
                style.left = (0, $29Wdk.perc)(pos.left / containerWidth);
                style.width = (0, $29Wdk.perc)(pos.width / containerWidth);
            }
        }
        return style;
    }
    /**
   * Mix a Draggable instance into a child.
   * @param  {Element} child    Child element.
   * @return {Element}          Child wrapped in Draggable.
   */ mixinDraggable(child /*: ReactElement<any>*/ , isDraggable /*: boolean*/ ) /*: ReactElement<any>*/ {
        return /*#__PURE__*/ $4964ccb8f7a67231$var$_react.default.createElement($iEQMr.DraggableCore, {
            disabled: !isDraggable,
            onStart: this.onDragStart,
            onDrag: this.onDrag,
            onStop: this.onDragStop,
            handle: this.props.handle,
            cancel: ".react-resizable-handle" + (this.props.cancel ? "," + this.props.cancel : ""),
            scale: this.props.transformScale,
            nodeRef: this.elementRef
        }, child);
    }
    /**
   * Utility function to setup callback handler definitions for
   * similarily structured resize events.
   */ curryResizeHandler(position /*: Position*/ , handler /*: Function*/ ) /*: Function*/ {
        return (e /*: Event*/ , data /*: ResizeCallbackData*/ )=>/*: Function*/ handler(e, data, position);
    }
    /**
   * Mix a Resizable instance into a child.
   * @param  {Element} child    Child element.
   * @param  {Object} position  Position object (pixel values)
   * @return {Element}          Child wrapped in Resizable.
   */ mixinResizable(child /*: ReactElement<any>*/ , position /*: Position*/ , isResizable /*: boolean*/ ) /*: ReactElement<any>*/ {
        const { cols: cols, minW: minW, minH: minH, maxW: maxW, maxH: maxH, transformScale: transformScale, resizeHandles: resizeHandles, resizeHandle: resizeHandle } = this.props;
        const positionParams = this.getPositionParams();
        // This is the max possible width - doesn't go to infinity because of the width of the window
        const maxWidth = (0, $bXTFA.calcGridItemPosition)(positionParams, 0, 0, cols, 0).width;
        // Calculate min/max constraints using our min & maxes
        const mins = (0, $bXTFA.calcGridItemPosition)(positionParams, 0, 0, minW, minH);
        const maxes = (0, $bXTFA.calcGridItemPosition)(positionParams, 0, 0, maxW, maxH);
        const minConstraints = [
            mins.width,
            mins.height
        ];
        const maxConstraints = [
            Math.min(maxes.width, maxWidth),
            Math.min(maxes.height, Infinity)
        ];
        return /*#__PURE__*/ $4964ccb8f7a67231$var$_react.default.createElement($3BCMg.Resizable, {
            draggableOpts: {
                disabled: !isResizable
            },
            className: isResizable ? undefined : "react-resizable-hide",
            width: position.width,
            height: position.height,
            minConstraints: minConstraints,
            maxConstraints: maxConstraints,
            onResizeStop: this.curryResizeHandler(position, this.onResizeStop),
            onResizeStart: this.curryResizeHandler(position, this.onResizeStart),
            onResize: this.curryResizeHandler(position, this.onResize),
            transformScale: transformScale,
            resizeHandles: resizeHandles,
            handle: resizeHandle
        }, child);
    }
    /**
   * Wrapper around resize events to provide more useful data.
   */ onResizeHandler(e /*: Event*/ , _ref4 /*:: */ , // 'size' is updated position
    position /*: Position*/ , // existing position
    handlerName /*: string*/ ) /*: void*/ {
        let { node: node, size: size, handle: handle } /*: ResizeCallbackData*/  = _ref4 /*: ResizeCallbackData*/ ;
        const handler = this.props[handlerName];
        if (!handler) return;
        const { x: x, y: y, i: i, maxH: maxH, minH: minH, containerWidth: containerWidth } = this.props;
        const { minW: minW, maxW: maxW } = this.props;
        // Clamping of dimensions based on resize direction
        let updatedSize = size;
        if (node) {
            updatedSize = (0, $29Wdk.resizeItemInDirection)(handle, position, size, containerWidth);
            (0, $kC364.flushSync)(()=>{
                this.setState({
                    resizing: handlerName === "onResizeStop" ? null : updatedSize
                });
            });
        }
        // Get new XY based on pixel size
        let { w: w, h: h } = (0, $bXTFA.calcWH)(this.getPositionParams(), updatedSize.width, updatedSize.height, x, y, handle);
        // Min/max capping.
        // minW should be at least 1 (TODO propTypes validation?)
        w = (0, $bXTFA.clamp)(w, Math.max(minW, 1), maxW);
        h = (0, $bXTFA.clamp)(h, minH, maxH);
        handler.call(this, i, w, h, {
            e: e,
            node: node,
            size: updatedSize,
            handle: handle
        });
    }
    render() /*: ReactNode*/ {
        const { x: x, y: y, w: w, h: h, isDraggable: isDraggable, isResizable: isResizable, droppingPosition: droppingPosition, useCSSTransforms: useCSSTransforms } = this.props;
        const pos = (0, $bXTFA.calcGridItemPosition)(this.getPositionParams(), x, y, w, h, this.state);
        const child = $4964ccb8f7a67231$var$_react.default.Children.only(this.props.children);
        // Create the child element. We clone the existing element but modify its className and style.
        let newChild = /*#__PURE__*/ $4964ccb8f7a67231$var$_react.default.cloneElement(child, {
            ref: this.elementRef,
            className: (0, $4964ccb8f7a67231$var$_clsx.default)("react-grid-item", child.props.className, this.props.className, {
                static: this.props.static,
                resizing: Boolean(this.state.resizing),
                "react-draggable": isDraggable,
                "react-draggable-dragging": Boolean(this.state.dragging),
                dropping: Boolean(droppingPosition),
                cssTransforms: useCSSTransforms
            }),
            // We can set the width and height on the child, but unfortunately we can't set the position.
            style: $4964ccb8f7a67231$var$_objectSpread($4964ccb8f7a67231$var$_objectSpread($4964ccb8f7a67231$var$_objectSpread({}, this.props.style), child.props.style), this.createStyle(pos))
        });
        // Resizable support. This is usually on but the user can toggle it off.
        newChild = this.mixinResizable(newChild, pos, isResizable);
        // Draggable support. This is always on, except for with placeholders.
        newChild = this.mixinDraggable(newChild, isDraggable);
        return newChild;
    }
}
module.exports.default = $4964ccb8f7a67231$var$GridItem;
$4964ccb8f7a67231$var$_defineProperty($4964ccb8f7a67231$var$GridItem, "propTypes", {
    // Children must be only a single element
    children: $4964ccb8f7a67231$var$_propTypes.default.element,
    // General grid attributes
    cols: $4964ccb8f7a67231$var$_propTypes.default.number.isRequired,
    containerWidth: $4964ccb8f7a67231$var$_propTypes.default.number.isRequired,
    rowHeight: $4964ccb8f7a67231$var$_propTypes.default.number.isRequired,
    margin: $4964ccb8f7a67231$var$_propTypes.default.array.isRequired,
    maxRows: $4964ccb8f7a67231$var$_propTypes.default.number.isRequired,
    containerPadding: $4964ccb8f7a67231$var$_propTypes.default.array.isRequired,
    // These are all in grid units
    x: $4964ccb8f7a67231$var$_propTypes.default.number.isRequired,
    y: $4964ccb8f7a67231$var$_propTypes.default.number.isRequired,
    w: $4964ccb8f7a67231$var$_propTypes.default.number.isRequired,
    h: $4964ccb8f7a67231$var$_propTypes.default.number.isRequired,
    // All optional
    minW: function(props /*: Props*/ , propName /*: string*/ ) {
        const value = props[propName];
        if (typeof value !== "number") return new Error("minWidth not Number");
        if (value > props.w || value > props.maxW) return new Error("minWidth larger than item width/maxWidth");
    },
    maxW: function(props /*: Props*/ , propName /*: string*/ ) {
        const value = props[propName];
        if (typeof value !== "number") return new Error("maxWidth not Number");
        if (value < props.w || value < props.minW) return new Error("maxWidth smaller than item width/minWidth");
    },
    minH: function(props /*: Props*/ , propName /*: string*/ ) {
        const value = props[propName];
        if (typeof value !== "number") return new Error("minHeight not Number");
        if (value > props.h || value > props.maxH) return new Error("minHeight larger than item height/maxHeight");
    },
    maxH: function(props /*: Props*/ , propName /*: string*/ ) {
        const value = props[propName];
        if (typeof value !== "number") return new Error("maxHeight not Number");
        if (value < props.h || value < props.minH) return new Error("maxHeight smaller than item height/minHeight");
    },
    // ID is nice to have for callbacks
    i: $4964ccb8f7a67231$var$_propTypes.default.string.isRequired,
    // Resize handle options
    resizeHandles: $kAZeL.resizeHandleAxesType,
    resizeHandle: $kAZeL.resizeHandleType,
    // Functions
    onDragStop: $4964ccb8f7a67231$var$_propTypes.default.func,
    onDragStart: $4964ccb8f7a67231$var$_propTypes.default.func,
    onDrag: $4964ccb8f7a67231$var$_propTypes.default.func,
    onResizeStop: $4964ccb8f7a67231$var$_propTypes.default.func,
    onResizeStart: $4964ccb8f7a67231$var$_propTypes.default.func,
    onResize: $4964ccb8f7a67231$var$_propTypes.default.func,
    // Flags
    isDraggable: $4964ccb8f7a67231$var$_propTypes.default.bool.isRequired,
    isResizable: $4964ccb8f7a67231$var$_propTypes.default.bool.isRequired,
    isBounded: $4964ccb8f7a67231$var$_propTypes.default.bool.isRequired,
    static: $4964ccb8f7a67231$var$_propTypes.default.bool,
    // Use CSS transforms instead of top/left
    useCSSTransforms: $4964ccb8f7a67231$var$_propTypes.default.bool.isRequired,
    transformScale: $4964ccb8f7a67231$var$_propTypes.default.number,
    // Others
    className: $4964ccb8f7a67231$var$_propTypes.default.string,
    // Selector for draggable handle
    handle: $4964ccb8f7a67231$var$_propTypes.default.string,
    // Selector for draggable cancel (see react-draggable)
    cancel: $4964ccb8f7a67231$var$_propTypes.default.string,
    // Current position of a dropping element
    droppingPosition: $4964ccb8f7a67231$var$_propTypes.default.shape({
        e: $4964ccb8f7a67231$var$_propTypes.default.object.isRequired,
        left: $4964ccb8f7a67231$var$_propTypes.default.number.isRequired,
        top: $4964ccb8f7a67231$var$_propTypes.default.number.isRequired
    })
});
$4964ccb8f7a67231$var$_defineProperty($4964ccb8f7a67231$var$GridItem, "defaultProps", {
    className: "",
    cancel: "",
    handle: "",
    minH: 1,
    minW: 1,
    maxH: Infinity,
    maxW: Infinity,
    transformScale: 1
});

});
parcelRegister("9AqQV", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6fac4e3b97662ab2$var$ReactIs, $6fac4e3b97662ab2$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("6ceUr"))();

});
parcelRegister("6ceUr", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $UE35o = parcelRequire("UE35o");
function $482f6dc6d78687f4$var$emptyFunction() {}
function $482f6dc6d78687f4$var$emptyFunctionWithReset() {}
$482f6dc6d78687f4$var$emptyFunctionWithReset.resetWarningCache = $482f6dc6d78687f4$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $UE35o) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $482f6dc6d78687f4$var$emptyFunctionWithReset,
        resetWarningCache: $482f6dc6d78687f4$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("UE35o", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $0aa44bedf0d11fe9$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $0aa44bedf0d11fe9$var$ReactPropTypesSecret;

});



parcelRegister("a8ZiJ", function(module, exports) {

$parcel$export(module.exports, "DraggableCore", function () { return (parcelRequire("iEQMr")).DraggableCore; });

var $iEQMr = parcelRequire("iEQMr");
// lib/cjs.ts
var $1f2f75ee697caa74$export$2e2bcd8739ae039 = (0, $iEQMr.Draggable);

});
parcelRegister("iEQMr", function(module, exports) {

$parcel$export(module.exports, "DraggableCore", function () { return $e0b7d5471e064db6$export$512ffe43e525b6fc; });
$parcel$export(module.exports, "Draggable", function () { return $e0b7d5471e064db6$export$f2a139e5d18b9882; });
// lib/Draggable.tsx

var $cQQee = parcelRequire("cQQee");

var $9AqQV = parcelRequire("9AqQV");

var $kC364 = parcelRequire("kC364");

var $lY25K = parcelRequire("lY25K");
// lib/utils/shims.ts
function $e0b7d5471e064db6$var$findInArray(array, callback) {
    for(let i = 0, length = array.length; i < length; i++){
        if (callback.apply(callback, [
            array[i],
            i,
            array
        ])) return array[i];
    }
}
function $e0b7d5471e064db6$var$isFunction(func) {
    return typeof func === "function" || Object.prototype.toString.call(func) === "[object Function]";
}
function $e0b7d5471e064db6$var$isNum(num) {
    return typeof num === "number" && !isNaN(num);
}
function $e0b7d5471e064db6$var$int(a) {
    return parseInt(a, 10);
}
function $e0b7d5471e064db6$var$dontSetMe(props, propName, componentName) {
    if (props[propName]) return new Error(`Invalid prop ${propName} passed to ${componentName} - do not set this, set it on the child.`);
}
// lib/utils/getPrefix.ts
var $e0b7d5471e064db6$var$prefixes = [
    "Moz",
    "Webkit",
    "O",
    "ms"
];
function $e0b7d5471e064db6$var$getPrefix(prop = "transform") {
    var _a, _b;
    if (typeof window === "undefined") return "";
    const style = (_b = (_a = window.document) == null ? void 0 : _a.documentElement) == null ? void 0 : _b.style;
    if (!style) return "";
    if (prop in style) return "";
    for(let i = 0; i < $e0b7d5471e064db6$var$prefixes.length; i++){
        if ($e0b7d5471e064db6$var$browserPrefixToKey(prop, $e0b7d5471e064db6$var$prefixes[i]) in style) return $e0b7d5471e064db6$var$prefixes[i];
    }
    return "";
}
function $e0b7d5471e064db6$var$browserPrefixToKey(prop, prefix) {
    return prefix ? `${prefix}${$e0b7d5471e064db6$var$kebabToTitleCase(prop)}` : prop;
}
function $e0b7d5471e064db6$var$kebabToTitleCase(str) {
    let out = "";
    let shouldCapitalize = true;
    for(let i = 0; i < str.length; i++){
        if (shouldCapitalize) {
            out += str[i].toUpperCase();
            shouldCapitalize = false;
        } else if (str[i] === "-") shouldCapitalize = true;
        else out += str[i];
    }
    return out;
}
var $e0b7d5471e064db6$var$getPrefix_default = $e0b7d5471e064db6$var$getPrefix();
// lib/utils/domFns.ts
var $e0b7d5471e064db6$var$matchesSelectorFunc = "";
function $e0b7d5471e064db6$var$matchesSelector(el, selector) {
    var _a;
    if (!$e0b7d5471e064db6$var$matchesSelectorFunc) $e0b7d5471e064db6$var$matchesSelectorFunc = (_a = $e0b7d5471e064db6$var$findInArray([
        "matches",
        "webkitMatchesSelector",
        "mozMatchesSelector",
        "msMatchesSelector",
        "oMatchesSelector"
    ], function(method) {
        return $e0b7d5471e064db6$var$isFunction(el[method]);
    })) != null ? _a : "";
    const matchFn = el[$e0b7d5471e064db6$var$matchesSelectorFunc];
    if (!$e0b7d5471e064db6$var$isFunction(matchFn)) return false;
    return Boolean(matchFn.call(el, selector));
}
function $e0b7d5471e064db6$var$matchesSelectorAndParentsTo(el, selector, baseNode) {
    let node = el;
    do {
        if ($e0b7d5471e064db6$var$matchesSelector(node, selector)) return true;
        if (node === baseNode) return false;
        node = node.parentNode;
    }while (node);
    return false;
}
function $e0b7d5471e064db6$var$addEvent(el, event, handler, inputOptions) {
    if (!el) return;
    const options = {
        capture: true,
        ...inputOptions
    };
    const listener = handler;
    if (el.addEventListener) el.addEventListener(event, listener, options);
    else if (el.attachEvent) el.attachEvent("on" + event, listener);
    else el["on" + event] = listener;
}
function $e0b7d5471e064db6$var$removeEvent(el, event, handler, inputOptions) {
    if (!el) return;
    const options = {
        capture: true,
        ...inputOptions
    };
    const listener = handler;
    if (el.removeEventListener) el.removeEventListener(event, listener, options);
    else if (el.detachEvent) el.detachEvent("on" + event, listener);
    else el["on" + event] = null;
}
function $e0b7d5471e064db6$var$outerHeight(node) {
    let height = node.clientHeight;
    const computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    height += $e0b7d5471e064db6$var$int(computedStyle.borderTopWidth);
    height += $e0b7d5471e064db6$var$int(computedStyle.borderBottomWidth);
    return height;
}
function $e0b7d5471e064db6$var$outerWidth(node) {
    let width = node.clientWidth;
    const computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    width += $e0b7d5471e064db6$var$int(computedStyle.borderLeftWidth);
    width += $e0b7d5471e064db6$var$int(computedStyle.borderRightWidth);
    return width;
}
function $e0b7d5471e064db6$var$innerHeight(node) {
    let height = node.clientHeight;
    const computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    height -= $e0b7d5471e064db6$var$int(computedStyle.paddingTop);
    height -= $e0b7d5471e064db6$var$int(computedStyle.paddingBottom);
    return height;
}
function $e0b7d5471e064db6$var$innerWidth(node) {
    let width = node.clientWidth;
    const computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    width -= $e0b7d5471e064db6$var$int(computedStyle.paddingLeft);
    width -= $e0b7d5471e064db6$var$int(computedStyle.paddingRight);
    return width;
}
function $e0b7d5471e064db6$var$offsetXYFromParent(evt, offsetParent, scale) {
    const isBody = offsetParent === offsetParent.ownerDocument.body;
    const offsetParentRect = isBody ? {
        left: 0,
        top: 0
    } : offsetParent.getBoundingClientRect();
    const x = (evt.clientX + offsetParent.scrollLeft - offsetParentRect.left) / scale;
    const y = (evt.clientY + offsetParent.scrollTop - offsetParentRect.top) / scale;
    return {
        x: x,
        y: y
    };
}
function $e0b7d5471e064db6$var$createCSSTransform(controlPos, positionOffset) {
    const translation = $e0b7d5471e064db6$var$getTranslation(controlPos, positionOffset, "px");
    return {
        [$e0b7d5471e064db6$var$browserPrefixToKey("transform", $e0b7d5471e064db6$var$getPrefix_default)]: translation
    };
}
function $e0b7d5471e064db6$var$createSVGTransform(controlPos, positionOffset) {
    const translation = $e0b7d5471e064db6$var$getTranslation(controlPos, positionOffset, "");
    return translation;
}
function $e0b7d5471e064db6$var$getTranslation({ x: x, y: y }, positionOffset, unitSuffix) {
    let translation = `translate(${x}${unitSuffix},${y}${unitSuffix})`;
    if (positionOffset) {
        const defaultX = `${typeof positionOffset.x === "string" ? positionOffset.x : positionOffset.x + unitSuffix}`;
        const defaultY = `${typeof positionOffset.y === "string" ? positionOffset.y : positionOffset.y + unitSuffix}`;
        translation = `translate(${defaultX}, ${defaultY})` + translation;
    }
    return translation;
}
function $e0b7d5471e064db6$var$getTouch(e, identifier) {
    return e.targetTouches && $e0b7d5471e064db6$var$findInArray(e.targetTouches, (t)=>identifier === t.identifier) || e.changedTouches && $e0b7d5471e064db6$var$findInArray(e.changedTouches, (t)=>identifier === t.identifier);
}
function $e0b7d5471e064db6$var$getTouchIdentifier(e) {
    if (e.targetTouches && e.targetTouches[0]) return e.targetTouches[0].identifier;
    if (e.changedTouches && e.changedTouches[0]) return e.changedTouches[0].identifier;
}
function $e0b7d5471e064db6$var$getDefaultNonce() {
    return typeof __webpack_nonce__ !== "undefined" ? __webpack_nonce__ : void 0;
}
function $e0b7d5471e064db6$var$addUserSelectStyles(doc, nonce) {
    if (!doc) return;
    let styleEl = doc.getElementById("react-draggable-style-el");
    if (!styleEl) {
        styleEl = doc.createElement("style");
        styleEl.type = "text/css";
        styleEl.id = "react-draggable-style-el";
        const resolvedNonce = nonce != null ? nonce : $e0b7d5471e064db6$var$getDefaultNonce();
        if (resolvedNonce) styleEl.setAttribute("nonce", resolvedNonce);
        styleEl.innerHTML = ".react-draggable-transparent-selection *::-moz-selection {all: inherit;}\n";
        styleEl.innerHTML += ".react-draggable-transparent-selection *::selection {all: inherit;}\n";
        doc.getElementsByTagName("head")[0].appendChild(styleEl);
    }
    if (doc.body) $e0b7d5471e064db6$var$addClassName(doc.body, "react-draggable-transparent-selection");
}
function $e0b7d5471e064db6$var$scheduleRemoveUserSelectStyles(doc) {
    if (window.requestAnimationFrame) window.requestAnimationFrame(()=>{
        $e0b7d5471e064db6$var$removeUserSelectStyles(doc);
    });
    else $e0b7d5471e064db6$var$removeUserSelectStyles(doc);
}
function $e0b7d5471e064db6$var$removeUserSelectStyles(doc) {
    if (!doc) return;
    try {
        if (doc.body) $e0b7d5471e064db6$var$removeClassName(doc.body, "react-draggable-transparent-selection");
        const ieSelection = doc.selection;
        if (ieSelection) ieSelection.empty();
        else {
            const selection = (doc.defaultView || window).getSelection();
            if (selection && selection.type !== "Caret") selection.removeAllRanges();
        }
    } catch  {}
}
function $e0b7d5471e064db6$var$addClassName(el, className) {
    if (el.classList) el.classList.add(className);
    else if (!el.className.match(new RegExp(`(?:^|\\s)${className}(?!\\S)`))) el.className += ` ${className}`;
}
function $e0b7d5471e064db6$var$removeClassName(el, className) {
    if (el.classList) el.classList.remove(className);
    else el.className = el.className.replace(new RegExp(`(?:^|\\s)${className}(?!\\S)`, "g"), "");
}
// lib/utils/positionFns.ts
function $e0b7d5471e064db6$var$getBoundPosition(draggable, x, y) {
    if (!draggable.props.bounds) return [
        x,
        y
    ];
    let { bounds: bounds } = draggable.props;
    bounds = typeof bounds === "string" ? bounds : $e0b7d5471e064db6$var$cloneBounds(bounds);
    const node = $e0b7d5471e064db6$var$findDOMNode(draggable);
    if (typeof bounds === "string") {
        const { ownerDocument: ownerDocument } = node;
        const ownerWindow = ownerDocument.defaultView;
        if (!ownerWindow) throw new Error("Cannot resolve the owner window of the draggable node.");
        let boundNode;
        if (bounds === "parent") boundNode = node.parentNode;
        else {
            const rootNode = node.getRootNode();
            boundNode = rootNode.querySelector(bounds);
        }
        if (!(boundNode instanceof ownerWindow.HTMLElement)) throw new Error('Bounds selector "' + bounds + '" could not find an element.');
        const boundNodeEl = boundNode;
        const nodeStyle = ownerWindow.getComputedStyle(node);
        const boundNodeStyle = ownerWindow.getComputedStyle(boundNodeEl);
        bounds = {
            left: -node.offsetLeft + $e0b7d5471e064db6$var$int(boundNodeStyle.paddingLeft) + $e0b7d5471e064db6$var$int(nodeStyle.marginLeft),
            top: -node.offsetTop + $e0b7d5471e064db6$var$int(boundNodeStyle.paddingTop) + $e0b7d5471e064db6$var$int(nodeStyle.marginTop),
            right: $e0b7d5471e064db6$var$innerWidth(boundNodeEl) - $e0b7d5471e064db6$var$outerWidth(node) - node.offsetLeft + $e0b7d5471e064db6$var$int(boundNodeStyle.paddingRight) - $e0b7d5471e064db6$var$int(nodeStyle.marginRight),
            bottom: $e0b7d5471e064db6$var$innerHeight(boundNodeEl) - $e0b7d5471e064db6$var$outerHeight(node) - node.offsetTop + $e0b7d5471e064db6$var$int(boundNodeStyle.paddingBottom) - $e0b7d5471e064db6$var$int(nodeStyle.marginBottom)
        };
    }
    if ($e0b7d5471e064db6$var$isNum(bounds.right)) x = Math.min(x, bounds.right);
    if ($e0b7d5471e064db6$var$isNum(bounds.bottom)) y = Math.min(y, bounds.bottom);
    if ($e0b7d5471e064db6$var$isNum(bounds.left)) x = Math.max(x, bounds.left);
    if ($e0b7d5471e064db6$var$isNum(bounds.top)) y = Math.max(y, bounds.top);
    return [
        x,
        y
    ];
}
function $e0b7d5471e064db6$var$snapToGrid(grid, pendingX, pendingY) {
    const x = Math.round(pendingX / grid[0]) * grid[0];
    const y = Math.round(pendingY / grid[1]) * grid[1];
    return [
        x,
        y
    ];
}
function $e0b7d5471e064db6$var$canDragX(draggable) {
    return draggable.props.axis === "both" || draggable.props.axis === "x";
}
function $e0b7d5471e064db6$var$canDragY(draggable) {
    return draggable.props.axis === "both" || draggable.props.axis === "y";
}
function $e0b7d5471e064db6$var$getControlPosition(e, touchIdentifier, draggableCore) {
    const touchObj = typeof touchIdentifier === "number" ? $e0b7d5471e064db6$var$getTouch(e, touchIdentifier) : null;
    if (typeof touchIdentifier === "number" && !touchObj) return null;
    const node = $e0b7d5471e064db6$var$findDOMNode(draggableCore);
    const offsetParent = draggableCore.props.offsetParent || node.offsetParent || node.ownerDocument.body;
    return $e0b7d5471e064db6$var$offsetXYFromParent(touchObj || e, offsetParent, draggableCore.props.scale);
}
function $e0b7d5471e064db6$var$createCoreData(draggable, x, y) {
    const isStart = !$e0b7d5471e064db6$var$isNum(draggable.lastX);
    const node = $e0b7d5471e064db6$var$findDOMNode(draggable);
    if (isStart) return {
        node: node,
        deltaX: 0,
        deltaY: 0,
        lastX: x,
        lastY: y,
        x: x,
        y: y
    };
    else return {
        node: node,
        deltaX: x - draggable.lastX,
        deltaY: y - draggable.lastY,
        lastX: draggable.lastX,
        lastY: draggable.lastY,
        x: x,
        y: y
    };
}
function $e0b7d5471e064db6$var$createDraggableData(draggable, coreData) {
    const scale = draggable.props.scale;
    return {
        node: coreData.node,
        x: draggable.state.x + coreData.deltaX / scale,
        y: draggable.state.y + coreData.deltaY / scale,
        deltaX: coreData.deltaX / scale,
        deltaY: coreData.deltaY / scale,
        lastX: draggable.state.x,
        lastY: draggable.state.y
    };
}
function $e0b7d5471e064db6$var$cloneBounds(bounds) {
    return {
        left: bounds.left,
        top: bounds.top,
        right: bounds.right,
        bottom: bounds.bottom
    };
}
function $e0b7d5471e064db6$var$findDOMNode(draggable) {
    const node = draggable.findDOMNode();
    if (!node) throw new Error("<DraggableCore>: Unmounted during event!");
    return node;
}
// lib/utils/log.ts
var $e0b7d5471e064db6$var$log = function noop() {};
var $e0b7d5471e064db6$var$log_default = $e0b7d5471e064db6$var$log;
// lib/DraggableCore.tsx
var $e0b7d5471e064db6$var$eventsFor = {
    touch: {
        start: "touchstart",
        move: "touchmove",
        stop: "touchend"
    },
    mouse: {
        start: "mousedown",
        move: "mousemove",
        stop: "mouseup"
    }
};
var $e0b7d5471e064db6$var$dragEventFor = $e0b7d5471e064db6$var$eventsFor.mouse;
var $e0b7d5471e064db6$export$512ffe43e525b6fc = class extends $cQQee.Component {
    constructor(){
        super(...arguments);
        this.dragging = false;
        // Used while dragging to determine deltas.
        this.lastX = NaN;
        this.lastY = NaN;
        this.touchIdentifier = null;
        this.mounted = false;
        this.handleDragStart = (e)=>{
            this.props.onMouseDown(e);
            if (!this.props.allowAnyClick && (typeof e.button === "number" && e.button !== 0 || e.ctrlKey)) return false;
            const thisNode = this.findDOMNode();
            if (!thisNode || !thisNode.ownerDocument || !thisNode.ownerDocument.body) throw new Error("<DraggableCore> not mounted on DragStart!");
            const { ownerDocument: ownerDocument } = thisNode;
            if (this.props.disabled || !(e.target instanceof ownerDocument.defaultView.Node) || this.props.handle && !$e0b7d5471e064db6$var$matchesSelectorAndParentsTo(e.target, this.props.handle, thisNode) || this.props.cancel && $e0b7d5471e064db6$var$matchesSelectorAndParentsTo(e.target, this.props.cancel, thisNode)) return;
            if (e.type === "touchstart" && !this.props.allowMobileScroll) e.preventDefault();
            const touchIdentifier = $e0b7d5471e064db6$var$getTouchIdentifier(e);
            this.touchIdentifier = touchIdentifier;
            const position = $e0b7d5471e064db6$var$getControlPosition(e, touchIdentifier, this);
            if (position == null) return;
            const { x: x, y: y } = position;
            const coreEvent = $e0b7d5471e064db6$var$createCoreData(this, x, y);
            $e0b7d5471e064db6$var$log_default("DraggableCore: handleDragStart: %j", coreEvent);
            $e0b7d5471e064db6$var$log_default("calling", this.props.onStart);
            const shouldUpdate = this.props.onStart(e, coreEvent);
            if (shouldUpdate === false || this.mounted === false) return;
            if (this.props.enableUserSelectHack) $e0b7d5471e064db6$var$addUserSelectStyles(ownerDocument, this.props.nonce);
            this.dragging = true;
            this.lastX = x;
            this.lastY = y;
            $e0b7d5471e064db6$var$addEvent(ownerDocument, $e0b7d5471e064db6$var$dragEventFor.move, this.handleDrag);
            $e0b7d5471e064db6$var$addEvent(ownerDocument, $e0b7d5471e064db6$var$dragEventFor.stop, this.handleDragStop);
        };
        this.handleDrag = (e)=>{
            const position = $e0b7d5471e064db6$var$getControlPosition(e, this.touchIdentifier, this);
            if (position == null) return;
            let { x: x, y: y } = position;
            if (Array.isArray(this.props.grid)) {
                let deltaX = x - this.lastX, deltaY = y - this.lastY;
                [deltaX, deltaY] = $e0b7d5471e064db6$var$snapToGrid(this.props.grid, deltaX, deltaY);
                if (!deltaX && !deltaY) return;
                x = this.lastX + deltaX;
                y = this.lastY + deltaY;
            }
            const coreEvent = $e0b7d5471e064db6$var$createCoreData(this, x, y);
            $e0b7d5471e064db6$var$log_default("DraggableCore: handleDrag: %j", coreEvent);
            const shouldUpdate = this.props.onDrag(e, coreEvent);
            if (shouldUpdate === false || this.mounted === false) {
                try {
                    this.handleDragStop(new MouseEvent("mouseup"));
                } catch  {
                    const event = document.createEvent("MouseEvents");
                    event.initMouseEvent("mouseup", true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
                    this.handleDragStop(event);
                }
                return;
            }
            this.lastX = x;
            this.lastY = y;
        };
        this.handleDragStop = (e)=>{
            if (!this.dragging) return;
            const position = $e0b7d5471e064db6$var$getControlPosition(e, this.touchIdentifier, this);
            if (position == null) return;
            let { x: x, y: y } = position;
            if (Array.isArray(this.props.grid)) {
                let deltaX = x - this.lastX || 0;
                let deltaY = y - this.lastY || 0;
                [deltaX, deltaY] = $e0b7d5471e064db6$var$snapToGrid(this.props.grid, deltaX, deltaY);
                x = this.lastX + deltaX;
                y = this.lastY + deltaY;
            }
            const coreEvent = $e0b7d5471e064db6$var$createCoreData(this, x, y);
            const shouldContinue = this.props.onStop(e, coreEvent);
            if (shouldContinue === false || this.mounted === false) return false;
            const thisNode = this.findDOMNode();
            if (thisNode) {
                if (this.props.enableUserSelectHack) $e0b7d5471e064db6$var$scheduleRemoveUserSelectStyles(thisNode.ownerDocument);
            }
            $e0b7d5471e064db6$var$log_default("DraggableCore: handleDragStop: %j", coreEvent);
            this.dragging = false;
            this.lastX = NaN;
            this.lastY = NaN;
            if (thisNode) {
                $e0b7d5471e064db6$var$log_default("DraggableCore: Removing handlers");
                $e0b7d5471e064db6$var$removeEvent(thisNode.ownerDocument, $e0b7d5471e064db6$var$dragEventFor.move, this.handleDrag);
                $e0b7d5471e064db6$var$removeEvent(thisNode.ownerDocument, $e0b7d5471e064db6$var$dragEventFor.stop, this.handleDragStop);
            }
        };
        this.onMouseDown = (e)=>{
            $e0b7d5471e064db6$var$dragEventFor = $e0b7d5471e064db6$var$eventsFor.mouse;
            return this.handleDragStart(e);
        };
        this.onMouseUp = (e)=>{
            $e0b7d5471e064db6$var$dragEventFor = $e0b7d5471e064db6$var$eventsFor.mouse;
            return this.handleDragStop(e);
        };
        // Same as onMouseDown (start drag), but now consider this a touch device.
        this.onTouchStart = (e)=>{
            $e0b7d5471e064db6$var$dragEventFor = $e0b7d5471e064db6$var$eventsFor.touch;
            return this.handleDragStart(e);
        };
        this.onTouchEnd = (e)=>{
            $e0b7d5471e064db6$var$dragEventFor = $e0b7d5471e064db6$var$eventsFor.touch;
            return this.handleDragStop(e);
        };
    }
    componentDidMount() {
        this.mounted = true;
        const thisNode = this.findDOMNode();
        if (thisNode) $e0b7d5471e064db6$var$addEvent(thisNode, $e0b7d5471e064db6$var$eventsFor.touch.start, this.onTouchStart, {
            passive: false
        });
    }
    componentWillUnmount() {
        this.mounted = false;
        const thisNode = this.findDOMNode();
        if (thisNode) {
            const { ownerDocument: ownerDocument } = thisNode;
            $e0b7d5471e064db6$var$removeEvent(ownerDocument, $e0b7d5471e064db6$var$eventsFor.mouse.move, this.handleDrag);
            $e0b7d5471e064db6$var$removeEvent(ownerDocument, $e0b7d5471e064db6$var$eventsFor.touch.move, this.handleDrag);
            $e0b7d5471e064db6$var$removeEvent(ownerDocument, $e0b7d5471e064db6$var$eventsFor.mouse.stop, this.handleDragStop);
            $e0b7d5471e064db6$var$removeEvent(ownerDocument, $e0b7d5471e064db6$var$eventsFor.touch.stop, this.handleDragStop);
            $e0b7d5471e064db6$var$removeEvent(thisNode, $e0b7d5471e064db6$var$eventsFor.touch.start, this.onTouchStart, {
                passive: false
            });
            if (this.props.enableUserSelectHack) $e0b7d5471e064db6$var$scheduleRemoveUserSelectStyles(ownerDocument);
        }
    }
    // React 19 removed ReactDOM.findDOMNode, so nodeRef is now required.
    // For backward compatibility with React 18 and earlier, we still support findDOMNode if available.
    findDOMNode() {
        var _a;
        if ((_a = this.props) == null ? void 0 : _a.nodeRef) return this.props.nodeRef.current;
        const legacyReactDOM = (0, (/*@__PURE__*/$parcel$interopDefault($kC364)));
        if (typeof legacyReactDOM.findDOMNode === "function") return legacyReactDOM.findDOMNode(this);
        $e0b7d5471e064db6$var$log_default("react-draggable: ReactDOM.findDOMNode is not available in React 19+. You must provide a nodeRef prop. See: https://github.com/react-grid-layout/react-draggable#noderef");
        return null;
    }
    render() {
        return $cQQee.cloneElement($cQQee.Children.only(this.props.children), {
            // Note: mouseMove handler is attached to document so it will still function
            // when the user drags quickly and leaves the bounds of the element.
            onMouseDown: this.onMouseDown,
            onMouseUp: this.onMouseUp,
            // onTouchStart is added on `componentDidMount` so they can be added with
            // {passive: false}, which allows it to cancel. See
            // https://developers.google.com/web/updates/2017/01/scrolling-intervention
            onTouchEnd: this.onTouchEnd
        });
    }
};
$e0b7d5471e064db6$export$512ffe43e525b6fc.displayName = "DraggableCore";
// Both the annotation and the `?` are load-bearing:
//  - The index-signature annotation stops tsc from inferring the
//    PropTypes.Requireable<...> types and emitting `import PropTypes from
//    'prop-types'` into the generated public .d.ts, which would force consumers
//    to install @types/prop-types (the v4.5.0 hand-written typings had none).
//  - The `?` keeps `propTypes` from being a *required* member of the public
//    type. React <= 18's JSX LibraryManagedAttributes only consults a
//    component's `propTypes` when it is required (`C extends {propTypes: ...}`);
//    when it does, this index-signature `propTypes` makes `defaultProps` stop
//    marking props optional, so consumers are forced to pass every prop.
//    Optional dodges that branch; React 19 ignores `propTypes` entirely. The
//    typings/tsconfig.react18.json check guards against a regression here.
// Do not remove. See lib/Draggable.tsx for the same guard.
$e0b7d5471e064db6$export$512ffe43e525b6fc.propTypes = {
    /**
   * `allowAnyClick` allows dragging using any mouse button.
   * By default, we only accept the left button.
   *
   * Defaults to `false`.
   */ allowAnyClick: (0, (/*@__PURE__*/$parcel$interopDefault($9AqQV))).bool,
    /**
   * `allowMobileScroll` turns off cancellation of the 'touchstart' event
   * on mobile devices. Only enable this if you are having trouble with click
   * events. Prefer using 'handle' / 'cancel' instead.
   *
   * Defaults to `false`.
   */ allowMobileScroll: (0, (/*@__PURE__*/$parcel$interopDefault($9AqQV))).bool,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($9AqQV))).node.isRequired,
    /**
   * `disabled`, if true, stops the <Draggable> from dragging. All handlers,
   * with the exception of `onMouseDown`, will not fire.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($9AqQV))).bool,
    /**
   * By default, we add 'user-select:none' attributes to the document body
   * to prevent ugly text selection during drag. If this is causing problems
   * for your app, set this to `false`.
   */ enableUserSelectHack: (0, (/*@__PURE__*/$parcel$interopDefault($9AqQV))).bool,
    /**
   * `offsetParent`, if set, uses the passed DOM node to compute drag offsets
   * instead of using the parent node.
   */ offsetParent: function(props, propName) {
        if (props[propName] && props[propName].nodeType !== 1) throw new Error("Draggable's offsetParent must be a DOM Node.");
    },
    /**
   * `grid` specifies the x and y that dragging should snap to.
   */ grid: (0, (/*@__PURE__*/$parcel$interopDefault($9AqQV))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($9AqQV))).number),
    /**
   * `handle` specifies a selector to be used as the handle that initiates drag.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable handle=".handle">
   *              <div>
   *                  <div className="handle">Click me to drag</div>
   *                  <div>This is some other content</div>
   *              </div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */ handle: (0, (/*@__PURE__*/$parcel$interopDefault($9AqQV))).string,
    /**
   * `cancel` specifies a selector to be used to prevent drag initialization.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *           return(
   *               <Draggable cancel=".cancel">
   *                   <div>
   *                     <div className="cancel">You can't drag from here</div>
   *                     <div>Dragging here works fine</div>
   *                   </div>
   *               </Draggable>
   *           );
   *       }
   *   });
   * ```
   */ cancel: (0, (/*@__PURE__*/$parcel$interopDefault($9AqQV))).string,
    /* If running in React Strict mode, ReactDOM.findDOMNode() is deprecated.
   * Unfortunately, in order for <Draggable> to work properly, we need raw access
   * to the underlying DOM node. If you want to avoid the warning, pass a `nodeRef`
   * as in this example:
   *
   * function MyComponent() {
   *   const nodeRef = React.useRef(null);
   *   return (
   *     <Draggable nodeRef={nodeRef}>
   *       <div ref={nodeRef}>Example Target</div>
   *     </Draggable>
   *   );
   * }
   *
   * This can be used for arbitrarily nested components, so long as the ref ends up
   * pointing to the actual child DOM node and not a custom component.
   */ nodeRef: (0, (/*@__PURE__*/$parcel$interopDefault($9AqQV))).object,
    /**
   * `nonce` is applied to the dynamically-injected <style> element used by the
   * user-select hack, so it isn't blocked under a strict Content Security
   * Policy (`style-src` without `'unsafe-inline'`). If omitted, webpack's
   * `__webpack_nonce__` global is used when available.
   */ nonce: (0, (/*@__PURE__*/$parcel$interopDefault($9AqQV))).string,
    /**
   * Called when dragging starts.
   * If this function returns the boolean false, dragging will be canceled.
   */ onStart: (0, (/*@__PURE__*/$parcel$interopDefault($9AqQV))).func,
    /**
   * Called while dragging.
   * If this function returns the boolean false, dragging will be canceled.
   */ onDrag: (0, (/*@__PURE__*/$parcel$interopDefault($9AqQV))).func,
    /**
   * Called when dragging stops.
   * If this function returns the boolean false, the drag will remain active.
   */ onStop: (0, (/*@__PURE__*/$parcel$interopDefault($9AqQV))).func,
    /**
   * A workaround option which can be passed if onMouseDown needs to be accessed,
   * since it'll always be blocked (as there is internal use of onMouseDown)
   */ onMouseDown: (0, (/*@__PURE__*/$parcel$interopDefault($9AqQV))).func,
    /**
   * `scale`, if set, applies scaling while dragging an element
   */ scale: (0, (/*@__PURE__*/$parcel$interopDefault($9AqQV))).number,
    /**
   * These properties should be defined on the child, not here.
   */ className: $e0b7d5471e064db6$var$dontSetMe,
    style: $e0b7d5471e064db6$var$dontSetMe,
    transform: $e0b7d5471e064db6$var$dontSetMe
};
// Typed as the full `DraggableCoreProps` (not just the default-provided subset)
// so React's JSX LibraryManagedAttributes treats EVERY prop as optional for
// consumers, matching the historical hand-written typings. At runtime only the
// default-able props are actually populated.
$e0b7d5471e064db6$export$512ffe43e525b6fc.defaultProps = {
    allowAnyClick: false,
    // by default only accept left click
    allowMobileScroll: false,
    disabled: false,
    enableUserSelectHack: true,
    onStart: function() {},
    onDrag: function() {},
    onStop: function() {},
    onMouseDown: function() {},
    scale: 1
};
// lib/Draggable.tsx
var $e0b7d5471e064db6$export$f2a139e5d18b9882 = class extends $cQQee.Component {
    constructor(props){
        super(props);
        this.onDragStart = (e, coreData)=>{
            $e0b7d5471e064db6$var$log_default("Draggable: onDragStart: %j", coreData);
            const shouldStart = this.props.onStart(e, $e0b7d5471e064db6$var$createDraggableData(this, coreData));
            if (shouldStart === false) return false;
            this.setState({
                dragging: true,
                dragged: true
            });
        };
        this.onDrag = (e, coreData)=>{
            if (!this.state.dragging) return false;
            $e0b7d5471e064db6$var$log_default("Draggable: onDrag: %j", coreData);
            const uiData = $e0b7d5471e064db6$var$createDraggableData(this, coreData);
            const newState = {
                x: uiData.x,
                y: uiData.y,
                slackX: 0,
                slackY: 0
            };
            if (this.props.bounds) {
                const { x: x, y: y } = newState;
                newState.x += this.state.slackX;
                newState.y += this.state.slackY;
                const [newStateX, newStateY] = $e0b7d5471e064db6$var$getBoundPosition(this, newState.x, newState.y);
                newState.x = newStateX;
                newState.y = newStateY;
                newState.slackX = this.state.slackX + (x - newState.x);
                newState.slackY = this.state.slackY + (y - newState.y);
                uiData.x = newState.x;
                uiData.y = newState.y;
                uiData.deltaX = newState.x - this.state.x;
                uiData.deltaY = newState.y - this.state.y;
            }
            const shouldUpdate = this.props.onDrag(e, uiData);
            if (shouldUpdate === false) return false;
            this.setState(newState);
        };
        this.onDragStop = (e, coreData)=>{
            if (!this.state.dragging) return false;
            const shouldContinue = this.props.onStop(e, $e0b7d5471e064db6$var$createDraggableData(this, coreData));
            if (shouldContinue === false) return false;
            $e0b7d5471e064db6$var$log_default("Draggable: onDragStop: %j", coreData);
            const newState = {
                dragging: false,
                slackX: 0,
                slackY: 0
            };
            const controlled = Boolean(this.props.position);
            if (controlled) {
                const { x: x, y: y } = this.props.position;
                newState.x = x;
                newState.y = y;
            }
            this.setState(newState);
        };
        this.state = {
            // Whether or not we are currently dragging.
            dragging: false,
            // Whether or not we have been dragged before.
            dragged: false,
            // Current transform x and y.
            x: props.position ? props.position.x : props.defaultPosition.x,
            y: props.position ? props.position.y : props.defaultPosition.y,
            prevPropsPosition: {
                ...props.position
            },
            // Used for compensating for out-of-bounds drags
            slackX: 0,
            slackY: 0,
            // Can only determine if SVG after mounting
            isElementSVG: false
        };
        if (props.position && !(props.onDrag || props.onStop)) console.warn("A `position` was applied to this <Draggable>, without drag handlers. This will make this component effectively undraggable. Please attach `onDrag` or `onStop` handlers so you can adjust the `position` of this element.");
    }
    // React 16.3+
    // Arity (props, state)
    static getDerivedStateFromProps({ position: position }, { prevPropsPosition: prevPropsPosition }) {
        if (position && (!prevPropsPosition || position.x !== prevPropsPosition.x || position.y !== prevPropsPosition.y)) {
            $e0b7d5471e064db6$var$log_default("Draggable: getDerivedStateFromProps %j", {
                position: position,
                prevPropsPosition: prevPropsPosition
            });
            return {
                x: position.x,
                y: position.y,
                prevPropsPosition: {
                    ...position
                }
            };
        }
        return null;
    }
    componentDidMount() {
        if (typeof window.SVGElement !== "undefined" && this.findDOMNode() instanceof window.SVGElement) this.setState({
            isElementSVG: true
        });
    }
    componentWillUnmount() {
        if (this.state.dragging) this.setState({
            dragging: false
        });
    }
    // React 19 removed ReactDOM.findDOMNode, so nodeRef is now required.
    // For backward compatibility with React 18 and earlier, we still support findDOMNode if available.
    findDOMNode() {
        var _a;
        if ((_a = this.props) == null ? void 0 : _a.nodeRef) return this.props.nodeRef.current;
        const legacyReactDOM = (0, (/*@__PURE__*/$parcel$interopDefault($kC364)));
        if (typeof legacyReactDOM.findDOMNode === "function") return legacyReactDOM.findDOMNode(this);
        return null;
    }
    render() {
        const { axis: axis, bounds: bounds, children: children, defaultPosition: defaultPosition, defaultClassName: defaultClassName, defaultClassNameDragging: defaultClassNameDragging, defaultClassNameDragged: defaultClassNameDragged, position: position, positionOffset: positionOffset, scale: scale, ...draggableCoreProps } = this.props;
        let style = {};
        let svgTransform = null;
        const controlled = Boolean(position);
        const draggable = !controlled || this.state.dragging;
        const validPosition = position || defaultPosition;
        const transformOpts = {
            // Set left if horizontal drag is enabled
            x: $e0b7d5471e064db6$var$canDragX(this) && draggable ? this.state.x : validPosition.x,
            // Set top if vertical drag is enabled
            y: $e0b7d5471e064db6$var$canDragY(this) && draggable ? this.state.y : validPosition.y
        };
        if (this.state.isElementSVG) svgTransform = $e0b7d5471e064db6$var$createSVGTransform(transformOpts, positionOffset);
        else style = $e0b7d5471e064db6$var$createCSSTransform(transformOpts, positionOffset);
        const onlyChild = $cQQee.Children.only(children);
        const className = (0, $lY25K.clsx)(onlyChild.props.className || "", defaultClassName, {
            [defaultClassNameDragging]: this.state.dragging,
            [defaultClassNameDragged]: this.state.dragged
        });
        return /* @__PURE__ */ $cQQee.createElement($e0b7d5471e064db6$export$512ffe43e525b6fc, {
            ...draggableCoreProps,
            onStart: this.onDragStart,
            onDrag: this.onDrag,
            onStop: this.onDragStop
        }, $cQQee.cloneElement(onlyChild, {
            className: className,
            style: {
                ...onlyChild.props.style,
                ...style
            },
            transform: svgTransform
        }));
    }
};
$e0b7d5471e064db6$export$f2a139e5d18b9882.displayName = "Draggable";
// Both the annotation and the `?` are load-bearing:
//  - The index-signature annotation stops tsc from inferring the
//    PropTypes.Requireable<...> types and emitting `import PropTypes from
//    'prop-types'` into the generated public .d.ts, which would force consumers
//    to install @types/prop-types (the v4.5.0 hand-written typings had none).
//  - The `?` keeps `propTypes` from being a *required* member of the public
//    type. React <= 18's JSX LibraryManagedAttributes only consults a
//    component's `propTypes` when it is required (`C extends {propTypes: ...}`);
//    when it does, this index-signature `propTypes` makes `defaultProps` stop
//    marking props optional, so consumers are forced to pass every prop.
//    Optional dodges that branch; React 19 ignores `propTypes` entirely. The
//    typings/tsconfig.react18.json check guards against a regression here.
// Do not remove. See lib/DraggableCore.tsx for the same guard.
$e0b7d5471e064db6$export$f2a139e5d18b9882.propTypes = {
    // Accepts all props <DraggableCore> accepts.
    ...$e0b7d5471e064db6$export$512ffe43e525b6fc.propTypes,
    /**
   * `axis` determines which axis the draggable can move.
   *
   *  Note that all callbacks will still return data as normal. This only
   *  controls flushing to the DOM.
   *
   * 'both' allows movement horizontally and vertically.
   * 'x' limits movement to horizontal axis.
   * 'y' limits movement to vertical axis.
   * 'none' limits all movement.
   *
   * Defaults to 'both'.
   */ axis: (0, (/*@__PURE__*/$parcel$interopDefault($9AqQV))).oneOf([
        "both",
        "x",
        "y",
        "none"
    ]),
    /**
   * `bounds` determines the range of movement available to the element.
   * Available values are:
   *
   * 'parent' restricts movement within the Draggable's parent node.
   *
   * Alternatively, pass an object with the following properties, all of which are optional:
   *
   * {left: LEFT_BOUND, right: RIGHT_BOUND, bottom: BOTTOM_BOUND, top: TOP_BOUND}
   *
   * All values are in px.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable bounds={{right: 300, bottom: 300}}>
   *              <div>Content</div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */ bounds: (0, (/*@__PURE__*/$parcel$interopDefault($9AqQV))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($9AqQV))).shape({
            left: (0, (/*@__PURE__*/$parcel$interopDefault($9AqQV))).number,
            right: (0, (/*@__PURE__*/$parcel$interopDefault($9AqQV))).number,
            top: (0, (/*@__PURE__*/$parcel$interopDefault($9AqQV))).number,
            bottom: (0, (/*@__PURE__*/$parcel$interopDefault($9AqQV))).number
        }),
        (0, (/*@__PURE__*/$parcel$interopDefault($9AqQV))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($9AqQV))).oneOf([
            false
        ])
    ]),
    defaultClassName: (0, (/*@__PURE__*/$parcel$interopDefault($9AqQV))).string,
    defaultClassNameDragging: (0, (/*@__PURE__*/$parcel$interopDefault($9AqQV))).string,
    defaultClassNameDragged: (0, (/*@__PURE__*/$parcel$interopDefault($9AqQV))).string,
    /**
   * `defaultPosition` specifies the x and y that the dragged item should start at
   *
   * Example:
   *
   * ```jsx
   *      let App = React.createClass({
   *          render: function () {
   *              return (
   *                  <Draggable defaultPosition={{x: 25, y: 25}}>
   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
   *                  </Draggable>
   *              );
   *          }
   *      });
   * ```
   */ defaultPosition: (0, (/*@__PURE__*/$parcel$interopDefault($9AqQV))).shape({
        x: (0, (/*@__PURE__*/$parcel$interopDefault($9AqQV))).number,
        y: (0, (/*@__PURE__*/$parcel$interopDefault($9AqQV))).number
    }),
    positionOffset: (0, (/*@__PURE__*/$parcel$interopDefault($9AqQV))).shape({
        x: (0, (/*@__PURE__*/$parcel$interopDefault($9AqQV))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($9AqQV))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($9AqQV))).string
        ]),
        y: (0, (/*@__PURE__*/$parcel$interopDefault($9AqQV))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($9AqQV))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($9AqQV))).string
        ])
    }),
    /**
   * `position`, if present, defines the current position of the element.
   *
   *  This is similar to how form elements in React work - if no `position` is supplied, the component
   *  is uncontrolled.
   *
   * Example:
   *
   * ```jsx
   *      let App = React.createClass({
   *          render: function () {
   *              return (
   *                  <Draggable position={{x: 25, y: 25}}>
   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
   *                  </Draggable>
   *              );
   *          }
   *      });
   * ```
   */ position: (0, (/*@__PURE__*/$parcel$interopDefault($9AqQV))).shape({
        x: (0, (/*@__PURE__*/$parcel$interopDefault($9AqQV))).number,
        y: (0, (/*@__PURE__*/$parcel$interopDefault($9AqQV))).number
    }),
    /**
   * These properties should be defined on the child, not here.
   */ className: $e0b7d5471e064db6$var$dontSetMe,
    style: $e0b7d5471e064db6$var$dontSetMe,
    transform: $e0b7d5471e064db6$var$dontSetMe
};
// Typed as the full `DraggableProps` (not just the default-provided subset) so
// React's JSX LibraryManagedAttributes treats EVERY prop as optional for
// consumers, matching the historical hand-written typings. At runtime only the
// default-able props are actually populated.
$e0b7d5471e064db6$export$f2a139e5d18b9882.defaultProps = {
    ...$e0b7d5471e064db6$export$512ffe43e525b6fc.defaultProps,
    axis: "both",
    bounds: false,
    defaultClassName: "react-draggable",
    defaultClassNameDragging: "react-draggable-dragging",
    defaultClassNameDragged: "react-draggable-dragged",
    defaultPosition: {
        x: 0,
        y: 0
    },
    scale: 1
};

});


parcelRegister("3BCMg", function(module, exports) {
'use strict';
module.exports = function() {
    throw new Error("Don't instantiate Resizable directly! Use require('react-resizable').Resizable");
};

module.exports.Resizable = (parcelRequire("bZrGH")).default;

module.exports.ResizableBox = (parcelRequire("7WZri")).default;

});
parcelRegister("bZrGH", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", function () { return $8baade6a3b0d3be5$export$1e511d4a378977f5; }, function (v) { return $8baade6a3b0d3be5$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "default", function () { return $8baade6a3b0d3be5$export$2e2bcd8739ae039; }, function (v) { return $8baade6a3b0d3be5$export$2e2bcd8739ae039 = v; });
var $8baade6a3b0d3be5$export$1e511d4a378977f5;
var $8baade6a3b0d3be5$export$2e2bcd8739ae039;
"use strict";
$8baade6a3b0d3be5$export$1e511d4a378977f5 = true;
$8baade6a3b0d3be5$export$2e2bcd8739ae039 = void 0;

var $8baade6a3b0d3be5$var$React = $8baade6a3b0d3be5$var$_interopRequireWildcard((parcelRequire("cQQee")));
parcelRequire("a8ZiJ");
var $iEQMr = parcelRequire("iEQMr");

var $KiI3H = parcelRequire("KiI3H");

var $gfVpB = parcelRequire("gfVpB");
const $8baade6a3b0d3be5$var$_excluded = [
    "children",
    "className",
    "draggableOpts",
    "width",
    "height",
    "handle",
    "handleSize",
    "lockAspectRatio",
    "axis",
    "minConstraints",
    "maxConstraints",
    "onResize",
    "onResizeStop",
    "onResizeStart",
    "resizeHandles",
    "transformScale"
];
function $8baade6a3b0d3be5$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($8baade6a3b0d3be5$var$_interopRequireWildcard = function(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(const t in e)"default" !== t && ({}).hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
        return f;
    })(e, t);
}
function $8baade6a3b0d3be5$var$_extends() {
    return $8baade6a3b0d3be5$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $8baade6a3b0d3be5$var$_extends.apply(null, arguments);
}
function $8baade6a3b0d3be5$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $8baade6a3b0d3be5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8baade6a3b0d3be5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8baade6a3b0d3be5$var$ownKeys(Object(t), !0).forEach(function(r) {
            $8baade6a3b0d3be5$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8baade6a3b0d3be5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $8baade6a3b0d3be5$var$_defineProperty(e, r, t) {
    return (r = $8baade6a3b0d3be5$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $8baade6a3b0d3be5$var$_toPropertyKey(t) {
    var i = $8baade6a3b0d3be5$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $8baade6a3b0d3be5$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
// The base <Resizable> component.
// This component does not have state and relies on the parent to set its props based on callback data.
class $8baade6a3b0d3be5$var$Resizable extends $8baade6a3b0d3be5$var$React.Component {
    constructor(){
        super(...arguments);
        this.handleRefs = {};
        this.lastHandleRect = null;
        this.slack = null;
        this.lastSize = null;
    }
    componentWillUnmount() {
        this.resetData();
    }
    resetData() {
        this.lastHandleRect = this.slack = this.lastSize = null;
    }
    // Clamp width and height within provided constraints
    runConstraints(width, height) {
        const _this$props = this.props, minConstraints = _this$props.minConstraints, maxConstraints = _this$props.maxConstraints, lockAspectRatio = _this$props.lockAspectRatio;
        // short circuit
        if (!minConstraints && !maxConstraints && !lockAspectRatio) return [
            width,
            height
        ];
        // If constraining to min and max, we need to also fit width and height to aspect ratio.
        if (lockAspectRatio) {
            const ratio = this.props.width / this.props.height;
            const deltaW = width - this.props.width;
            const deltaH = height - this.props.height;
            // Find which coordinate was greater and should push the other toward it.
            // E.g.:
            // ratio = 1, deltaW = 10, deltaH = 5, deltaH should become 10.
            // ratio = 2, deltaW = 10, deltaH = 6, deltaW should become 12.
            if (Math.abs(deltaW) > Math.abs(deltaH * ratio)) height = width / ratio;
            else width = height * ratio;
        }
        const oldW = width, oldH = height;
        // Add slack to the values used to calculate bound position. This will ensure that if
        // we start removing slack, the element won't react to it right away until it's been
        // completely removed.
        let _ref = this.slack || [
            0,
            0
        ], slackW = _ref[0], slackH = _ref[1];
        width += slackW;
        height += slackH;
        if (minConstraints) {
            width = Math.max(minConstraints[0], width);
            height = Math.max(minConstraints[1], height);
        }
        if (maxConstraints) {
            width = Math.min(maxConstraints[0], width);
            height = Math.min(maxConstraints[1], height);
        }
        // If the width or height changed, we must have introduced some slack. Record it for the next iteration.
        this.slack = [
            slackW + (oldW - width),
            slackH + (oldH - height)
        ];
        return [
            width,
            height
        ];
    }
    /**
   * Wrapper around drag events to provide more useful data.
   *
   * @param  {String} handlerName Handler name to wrap.
   * @return {Function}           Handler function.
   */ resizeHandler(handlerName, axis) {
        return (e, _ref2)=>{
            var _this$lastSize$width, _this$lastSize, _this$lastSize$height, _this$lastSize2;
            let node = _ref2.node, deltaX = _ref2.deltaX, deltaY = _ref2.deltaY;
            // Reset data in case it was left over somehow (should not be possible)
            if (handlerName === 'onResizeStart') this.resetData();
            // Axis restrictions
            const canDragX = (this.props.axis === 'both' || this.props.axis === 'x') && axis !== 'n' && axis !== 's';
            const canDragY = (this.props.axis === 'both' || this.props.axis === 'y') && axis !== 'e' && axis !== 'w';
            // No dragging possible.
            if (!canDragX && !canDragY) return;
            // Decompose axis for later use
            const axisV = axis[0];
            const axisH = axis[axis.length - 1]; // intentionally not axis[1], so that this catches axis === 'w' for example
            // Track the element being dragged to account for changes in position.
            // If a handle's position is changed between callbacks, we need to factor this in to the next callback.
            // Failure to do so will cause the element to "skip" when resized upwards or leftwards.
            const handleRect = node.getBoundingClientRect();
            if (this.lastHandleRect != null) {
                // If the handle has repositioned on either axis since last render,
                // we need to increase our callback values by this much.
                // Only checking 'n', 'w' since resizing by 's', 'w' won't affect the overall position on page,
                if (axisH === 'w') {
                    const deltaLeftSinceLast = handleRect.left - this.lastHandleRect.left;
                    deltaX += deltaLeftSinceLast;
                }
                if (axisV === 'n') {
                    const deltaTopSinceLast = handleRect.top - this.lastHandleRect.top;
                    deltaY += deltaTopSinceLast;
                }
            }
            // Storage of last rect so we know how much it has really moved.
            this.lastHandleRect = handleRect;
            // Reverse delta if using top or left drag handles.
            if (axisH === 'w') deltaX = -deltaX;
            if (axisV === 'n') deltaY = -deltaY;
            // Update w/h by the deltas. Also factor in transformScale.
            // Use lastSize (if available) instead of props to avoid losing deltas
            // when React can't re-render between consecutive mouse events.
            const baseWidth = (_this$lastSize$width = (_this$lastSize = this.lastSize) == null ? void 0 : _this$lastSize.width) != null ? _this$lastSize$width : this.props.width;
            const baseHeight = (_this$lastSize$height = (_this$lastSize2 = this.lastSize) == null ? void 0 : _this$lastSize2.height) != null ? _this$lastSize$height : this.props.height;
            let width = baseWidth + (canDragX ? deltaX / this.props.transformScale : 0);
            let height = baseHeight + (canDragY ? deltaY / this.props.transformScale : 0);
            // Run user-provided constraints.
            // For onResizeStop, use the last size from onResize rather than recalculating.
            // This avoids issues where props.width/height are stale due to React's batched updates.
            var _this$runConstraints = this.runConstraints(width, height);
            width = _this$runConstraints[0];
            height = _this$runConstraints[1];
            if (handlerName === 'onResizeStop' && this.lastSize) {
                var _this$lastSize3 = this.lastSize;
                width = _this$lastSize3.width;
                height = _this$lastSize3.height;
            }
            // Compare against the base (lastSize-or-props) so that callbacks correctly
            // suppress when the net delta is zero, even if props are stale relative to
            // the accumulated lastSize.
            const dimensionsChanged = width !== baseWidth || height !== baseHeight;
            // Store the size for use in onResizeStop. We do this after the onResizeStop check
            // above so we don't overwrite the stored value with a potentially stale calculation.
            if (handlerName !== 'onResizeStop') this.lastSize = {
                width: width,
                height: height
            };
            // Call user-supplied callback if present.
            const cb = typeof this.props[handlerName] === 'function' ? this.props[handlerName] : null;
            // Don't call 'onResize' if dimensions haven't changed.
            const shouldSkipCb = handlerName === 'onResize' && !dimensionsChanged;
            if (cb && !shouldSkipCb) {
                e.persist == null || e.persist();
                cb(e, {
                    node: node,
                    size: {
                        width: width,
                        height: height
                    },
                    handle: axis
                });
            }
            // Reset internal data
            if (handlerName === 'onResizeStop') this.resetData();
        };
    }
    // Render a resize handle given an axis & DOM ref. Ref *must* be attached for
    // the underlying draggable library to work properly.
    renderResizeHandle(handleAxis, ref) {
        const handle = this.props.handle;
        // No handle provided, make the default
        if (!handle) return /*#__PURE__*/ $8baade6a3b0d3be5$var$React.createElement("span", {
            className: "react-resizable-handle react-resizable-handle-" + handleAxis,
            ref: ref
        });
        // Handle is a function, such as:
        // `handle={(handleAxis) => <span className={...} />}`
        if (typeof handle === 'function') return handle(handleAxis, ref);
        // Handle is a React component (composite or DOM).
        const isDOMElement = typeof handle.type === 'string';
        const props = $8baade6a3b0d3be5$var$_objectSpread({
            ref: ref
        }, isDOMElement ? {} : {
            handleAxis: handleAxis
        });
        return /*#__PURE__*/ $8baade6a3b0d3be5$var$React.cloneElement(handle, props);
    }
    render() {
        // Pass along only props not meant for the `<Resizable>`.`
        // eslint-disable-next-line no-unused-vars
        const _this$props2 = this.props, children = _this$props2.children, className = _this$props2.className, draggableOpts = _this$props2.draggableOpts, width = _this$props2.width, height = _this$props2.height, handle = _this$props2.handle, handleSize = _this$props2.handleSize, lockAspectRatio = _this$props2.lockAspectRatio, axis = _this$props2.axis, minConstraints = _this$props2.minConstraints, maxConstraints = _this$props2.maxConstraints, onResize = _this$props2.onResize, onResizeStop = _this$props2.onResizeStop, onResizeStart = _this$props2.onResizeStart, resizeHandles = _this$props2.resizeHandles, transformScale = _this$props2.transformScale, p = $8baade6a3b0d3be5$var$_objectWithoutPropertiesLoose(_this$props2, $8baade6a3b0d3be5$var$_excluded);
        // What we're doing here is getting the child of this element, and cloning it with this element's props.
        // We are then defining its children as:
        // 1. Its original children (resizable's child's children), and
        // 2. One or more draggable handles.
        return (0, $KiI3H.cloneElement)(children, $8baade6a3b0d3be5$var$_objectSpread($8baade6a3b0d3be5$var$_objectSpread({}, p), {}, {
            className: (className ? className + " " : '') + "react-resizable",
            children: [
                ...$8baade6a3b0d3be5$var$React.Children.toArray(children.props.children),
                ...resizeHandles.map((handleAxis)=>{
                    var _this$handleRefs$hand;
                    // Create a ref to the handle so that `<DraggableCore>` doesn't have to use ReactDOM.findDOMNode().
                    const ref = (_this$handleRefs$hand = this.handleRefs[handleAxis]) != null ? _this$handleRefs$hand : this.handleRefs[handleAxis] = /*#__PURE__*/ $8baade6a3b0d3be5$var$React.createRef();
                    return /*#__PURE__*/ $8baade6a3b0d3be5$var$React.createElement($iEQMr.DraggableCore, $8baade6a3b0d3be5$var$_extends({}, draggableOpts, {
                        nodeRef: ref,
                        key: "resizableHandle-" + handleAxis,
                        onStop: this.resizeHandler('onResizeStop', handleAxis),
                        onStart: this.resizeHandler('onResizeStart', handleAxis),
                        onDrag: this.resizeHandler('onResize', handleAxis)
                    }), this.renderResizeHandle(handleAxis, ref));
                })
            ]
        }));
    }
}
$8baade6a3b0d3be5$export$2e2bcd8739ae039 = $8baade6a3b0d3be5$var$Resizable;
$8baade6a3b0d3be5$var$Resizable.propTypes = $gfVpB.resizableProps;
$8baade6a3b0d3be5$var$Resizable.defaultProps = {
    axis: 'both',
    handleSize: [
        20,
        20
    ],
    lockAspectRatio: false,
    minConstraints: [
        20,
        20
    ],
    maxConstraints: [
        Infinity,
        Infinity
    ],
    resizeHandles: [
        'se'
    ],
    transformScale: 1
};

});
parcelRegister("KiI3H", function(module, exports) {

$parcel$export(module.exports, "cloneElement", function () { return $08b2cf5567650a7a$export$e530037191fcd5d7; }, function (v) { return $08b2cf5567650a7a$export$e530037191fcd5d7 = v; });
var $08b2cf5567650a7a$export$1e511d4a378977f5;
var $08b2cf5567650a7a$export$e530037191fcd5d7;
"use strict";
$08b2cf5567650a7a$export$1e511d4a378977f5 = true;
$08b2cf5567650a7a$export$e530037191fcd5d7 = $08b2cf5567650a7a$var$cloneElement;

var $08b2cf5567650a7a$var$_react = $08b2cf5567650a7a$var$_interopRequireDefault((parcelRequire("cQQee")));
function $08b2cf5567650a7a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $08b2cf5567650a7a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $08b2cf5567650a7a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $08b2cf5567650a7a$var$ownKeys(Object(t), !0).forEach(function(r) {
            $08b2cf5567650a7a$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $08b2cf5567650a7a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $08b2cf5567650a7a$var$_defineProperty(e, r, t) {
    return (r = $08b2cf5567650a7a$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $08b2cf5567650a7a$var$_toPropertyKey(t) {
    var i = $08b2cf5567650a7a$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $08b2cf5567650a7a$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
// React.addons.cloneWithProps look-alike that merges style & className.
function $08b2cf5567650a7a$var$cloneElement(element, props) {
    if (props.style && element.props.style) props.style = $08b2cf5567650a7a$var$_objectSpread($08b2cf5567650a7a$var$_objectSpread({}, element.props.style), props.style);
    if (props.className && element.props.className) props.className = element.props.className + " " + props.className;
    return /*#__PURE__*/ $08b2cf5567650a7a$var$_react.default.cloneElement(element, props);
}

});

parcelRegister("gfVpB", function(module, exports) {

$parcel$export(module.exports, "resizableProps", function () { return $bd5a94e3609d440d$export$32a002ec6a601762; }, function (v) { return $bd5a94e3609d440d$export$32a002ec6a601762 = v; });
var $bd5a94e3609d440d$export$1e511d4a378977f5;
var $bd5a94e3609d440d$export$32a002ec6a601762;
"use strict";
$bd5a94e3609d440d$export$1e511d4a378977f5 = true;
$bd5a94e3609d440d$export$32a002ec6a601762 = void 0;

var $bd5a94e3609d440d$var$_propTypes = $bd5a94e3609d440d$var$_interopRequireDefault((parcelRequire("9AqQV")));
parcelRequire("a8ZiJ");
function $bd5a94e3609d440d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/* global Element */ // <Resizable>
const $bd5a94e3609d440d$var$resizableProps = $bd5a94e3609d440d$export$32a002ec6a601762 = {
    /*
  * Restricts resizing to a particular axis (default: 'both')
  * 'both' - allows resizing by width or height
  * 'x' - only allows the width to be changed
  * 'y' - only allows the height to be changed
  * 'none' - disables resizing altogether
  * */ axis: $bd5a94e3609d440d$var$_propTypes.default.oneOf([
        'both',
        'x',
        'y',
        'none'
    ]),
    className: $bd5a94e3609d440d$var$_propTypes.default.string,
    /*
  * Require that one and only one child be present.
  * */ children: $bd5a94e3609d440d$var$_propTypes.default.element.isRequired,
    /*
  * These will be passed wholesale to react-draggable's DraggableCore
  * */ draggableOpts: $bd5a94e3609d440d$var$_propTypes.default.shape({
        allowAnyClick: $bd5a94e3609d440d$var$_propTypes.default.bool,
        cancel: $bd5a94e3609d440d$var$_propTypes.default.string,
        children: $bd5a94e3609d440d$var$_propTypes.default.node,
        disabled: $bd5a94e3609d440d$var$_propTypes.default.bool,
        enableUserSelectHack: $bd5a94e3609d440d$var$_propTypes.default.bool,
        // #251: Check for Element to support SSR environments where DOM globals don't exist
        offsetParent: typeof Element !== 'undefined' ? $bd5a94e3609d440d$var$_propTypes.default.instanceOf(Element) : $bd5a94e3609d440d$var$_propTypes.default.any,
        grid: $bd5a94e3609d440d$var$_propTypes.default.arrayOf($bd5a94e3609d440d$var$_propTypes.default.number),
        handle: $bd5a94e3609d440d$var$_propTypes.default.string,
        nodeRef: $bd5a94e3609d440d$var$_propTypes.default.object,
        onStart: $bd5a94e3609d440d$var$_propTypes.default.func,
        onDrag: $bd5a94e3609d440d$var$_propTypes.default.func,
        onStop: $bd5a94e3609d440d$var$_propTypes.default.func,
        onMouseDown: $bd5a94e3609d440d$var$_propTypes.default.func,
        scale: $bd5a94e3609d440d$var$_propTypes.default.number
    }),
    /*
  * Initial height
  * */ height: function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        const props = args[0];
        // Required if resizing height or both
        if (props.axis === 'both' || props.axis === 'y') return $bd5a94e3609d440d$var$_propTypes.default.number.isRequired(...args);
        return $bd5a94e3609d440d$var$_propTypes.default.number(...args);
    },
    /*
  * Customize cursor resize handle
  * */ handle: $bd5a94e3609d440d$var$_propTypes.default.oneOfType([
        $bd5a94e3609d440d$var$_propTypes.default.node,
        $bd5a94e3609d440d$var$_propTypes.default.func
    ]),
    /*
  * If you change this, be sure to update your css
  * */ handleSize: $bd5a94e3609d440d$var$_propTypes.default.arrayOf($bd5a94e3609d440d$var$_propTypes.default.number),
    lockAspectRatio: $bd5a94e3609d440d$var$_propTypes.default.bool,
    /*
  * Max X & Y measure
  * */ maxConstraints: $bd5a94e3609d440d$var$_propTypes.default.arrayOf($bd5a94e3609d440d$var$_propTypes.default.number),
    /*
  * Min X & Y measure
  * */ minConstraints: $bd5a94e3609d440d$var$_propTypes.default.arrayOf($bd5a94e3609d440d$var$_propTypes.default.number),
    /*
  * Called on stop resize event
  * */ onResizeStop: $bd5a94e3609d440d$var$_propTypes.default.func,
    /*
  * Called on start resize event
  * */ onResizeStart: $bd5a94e3609d440d$var$_propTypes.default.func,
    /*
  * Called on resize event
  * */ onResize: $bd5a94e3609d440d$var$_propTypes.default.func,
    /*
  * Defines which resize handles should be rendered (default: 'se')
  * 's' - South handle (bottom-center)
  * 'w' - West handle (left-center)
  * 'e' - East handle (right-center)
  * 'n' - North handle (top-center)
  * 'sw' - Southwest handle (bottom-left)
  * 'nw' - Northwest handle (top-left)
  * 'se' - Southeast handle (bottom-right)
  * 'ne' - Northeast handle (top-center)
  * */ resizeHandles: $bd5a94e3609d440d$var$_propTypes.default.arrayOf($bd5a94e3609d440d$var$_propTypes.default.oneOf([
        's',
        'w',
        'e',
        'n',
        'sw',
        'nw',
        'se',
        'ne'
    ])),
    /*
  * If `transform: scale(n)` is set on the parent, this should be set to `n`.
  * */ transformScale: $bd5a94e3609d440d$var$_propTypes.default.number,
    /*
   * Initial width
   */ width: function() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        const props = args[0];
        // Required if resizing width or both
        if (props.axis === 'both' || props.axis === 'x') return $bd5a94e3609d440d$var$_propTypes.default.number.isRequired(...args);
        return $bd5a94e3609d440d$var$_propTypes.default.number(...args);
    }
};

});


parcelRegister("7WZri", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c9d9bbe7a90e8f8$export$2e2bcd8739ae039; }, function (v) { return $5c9d9bbe7a90e8f8$export$2e2bcd8739ae039 = v; });
var $5c9d9bbe7a90e8f8$export$1e511d4a378977f5;
var $5c9d9bbe7a90e8f8$export$2e2bcd8739ae039;
"use strict";
$5c9d9bbe7a90e8f8$export$1e511d4a378977f5 = true;
$5c9d9bbe7a90e8f8$export$2e2bcd8739ae039 = void 0;

var $5c9d9bbe7a90e8f8$var$React = $5c9d9bbe7a90e8f8$var$_interopRequireWildcard((parcelRequire("cQQee")));

var $5c9d9bbe7a90e8f8$var$_propTypes = $5c9d9bbe7a90e8f8$var$_interopRequireDefault((parcelRequire("9AqQV")));

var $5c9d9bbe7a90e8f8$var$_Resizable = $5c9d9bbe7a90e8f8$var$_interopRequireDefault((parcelRequire("bZrGH")));

var $gfVpB = parcelRequire("gfVpB");
const $5c9d9bbe7a90e8f8$var$_excluded = [
    "handle",
    "handleSize",
    "onResize",
    "onResizeStart",
    "onResizeStop",
    "draggableOpts",
    "minConstraints",
    "maxConstraints",
    "lockAspectRatio",
    "axis",
    "width",
    "height",
    "resizeHandles",
    "style",
    "transformScale"
];
function $5c9d9bbe7a90e8f8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $5c9d9bbe7a90e8f8$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($5c9d9bbe7a90e8f8$var$_interopRequireWildcard = function(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(const t in e)"default" !== t && ({}).hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
        return f;
    })(e, t);
}
function $5c9d9bbe7a90e8f8$var$_extends() {
    return $5c9d9bbe7a90e8f8$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5c9d9bbe7a90e8f8$var$_extends.apply(null, arguments);
}
function $5c9d9bbe7a90e8f8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5c9d9bbe7a90e8f8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5c9d9bbe7a90e8f8$var$ownKeys(Object(t), !0).forEach(function(r) {
            $5c9d9bbe7a90e8f8$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5c9d9bbe7a90e8f8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $5c9d9bbe7a90e8f8$var$_defineProperty(e, r, t) {
    return (r = $5c9d9bbe7a90e8f8$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $5c9d9bbe7a90e8f8$var$_toPropertyKey(t) {
    var i = $5c9d9bbe7a90e8f8$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $5c9d9bbe7a90e8f8$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $5c9d9bbe7a90e8f8$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
// ElementConfig gives us an object type where all items present in `defaultProps` are made optional.
// <ResizableBox> does not have defaultProps, so we can use this type to tell Flow that we don't
// care about that and will handle it in <Resizable> instead.
// A <ResizableBox> can also have a `style` property.
class $5c9d9bbe7a90e8f8$var$ResizableBox extends $5c9d9bbe7a90e8f8$var$React.Component {
    constructor(){
        super(...arguments);
        this.state = {
            width: this.props.width,
            height: this.props.height,
            propsWidth: this.props.width,
            propsHeight: this.props.height
        };
        this.onResize = (e, data)=>{
            const size = data.size;
            if (this.props.onResize) {
                e.persist == null || e.persist();
                this.setState(size, ()=>this.props.onResize && this.props.onResize(e, data));
            } else this.setState(size);
        };
    }
    static getDerivedStateFromProps(props, state) {
        // If parent changes height/width, set that in our state.
        if (state.propsWidth !== props.width || state.propsHeight !== props.height) return {
            width: props.width,
            height: props.height,
            propsWidth: props.width,
            propsHeight: props.height
        };
        return null;
    }
    render() {
        // Basic wrapper around a Resizable instance.
        // If you use Resizable directly, you are responsible for updating the child component
        // with a new width and height.
        const _this$props = this.props, handle = _this$props.handle, handleSize = _this$props.handleSize, onResize = _this$props.onResize, onResizeStart = _this$props.onResizeStart, onResizeStop = _this$props.onResizeStop, draggableOpts = _this$props.draggableOpts, minConstraints = _this$props.minConstraints, maxConstraints = _this$props.maxConstraints, lockAspectRatio = _this$props.lockAspectRatio, axis = _this$props.axis, width = _this$props.width, height = _this$props.height, resizeHandles = _this$props.resizeHandles, style = _this$props.style, transformScale = _this$props.transformScale, props = $5c9d9bbe7a90e8f8$var$_objectWithoutPropertiesLoose(_this$props, $5c9d9bbe7a90e8f8$var$_excluded);
        return /*#__PURE__*/ $5c9d9bbe7a90e8f8$var$React.createElement($5c9d9bbe7a90e8f8$var$_Resizable.default, {
            axis: axis,
            draggableOpts: draggableOpts,
            handle: handle,
            handleSize: handleSize,
            height: this.state.height,
            lockAspectRatio: lockAspectRatio,
            maxConstraints: maxConstraints,
            minConstraints: minConstraints,
            onResizeStart: onResizeStart,
            onResize: this.onResize,
            onResizeStop: onResizeStop,
            resizeHandles: resizeHandles,
            transformScale: transformScale,
            width: this.state.width
        }, /*#__PURE__*/ $5c9d9bbe7a90e8f8$var$React.createElement("div", $5c9d9bbe7a90e8f8$var$_extends({}, props, {
            style: $5c9d9bbe7a90e8f8$var$_objectSpread($5c9d9bbe7a90e8f8$var$_objectSpread({}, style), {}, {
                width: this.state.width + 'px',
                height: this.state.height + 'px'
            })
        })));
    }
}
$5c9d9bbe7a90e8f8$export$2e2bcd8739ae039 = $5c9d9bbe7a90e8f8$var$ResizableBox;
// PropTypes are identical to <Resizable>, except that children are not strictly required to be present.
$5c9d9bbe7a90e8f8$var$ResizableBox.propTypes = $5c9d9bbe7a90e8f8$var$_objectSpread($5c9d9bbe7a90e8f8$var$_objectSpread({}, $gfVpB.resizableProps), {}, {
    children: $5c9d9bbe7a90e8f8$var$_propTypes.default.element
});

});


parcelRegister("kAZeL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.resizeHandleType = module.exports.resizeHandleAxesType = module.exports.default = void 0;

var $efe6abd737bf9707$var$_propTypes = $efe6abd737bf9707$var$_interopRequireDefault((parcelRequire("9AqQV")));

var $efe6abd737bf9707$var$_react = $efe6abd737bf9707$var$_interopRequireDefault((parcelRequire("cQQee")));
function $efe6abd737bf9707$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/*:: import type {
  Ref,
  ChildrenArray as ReactChildrenArray,
  Element as ReactElement
} from "react";*/ /*:: import type {
  DragOverEvent,
  EventCallback,
  CompactType,
  Layout,
  LayoutItem,
  ResizeHandleAxis
} from "./utils";*/ /*:: export type ReactRef<T: HTMLElement> = {|
  +current: T | null
|};*/ // util
/*:: export type ResizeHandle =
  | ReactElement<any>
  | ((
      resizeHandleAxis: ResizeHandleAxis,
      ref: ReactRef<HTMLElement>
    ) => ReactElement<any>);*/ // Defines which resize handles should be rendered (default: 'se')
// Allows for any combination of:
// 's' - South handle (bottom-center)
// 'w' - West handle (left-center)
// 'e' - East handle (right-center)
// 'n' - North handle (top-center)
// 'sw' - Southwest handle (bottom-left)
// 'nw' - Northwest handle (top-left)
// 'se' - Southeast handle (bottom-right)
// 'ne' - Northeast handle (top-right)
const $efe6abd737bf9707$var$resizeHandleAxesType /*: ReactPropsChainableTypeChecker*/  = module.exports.resizeHandleAxesType = $efe6abd737bf9707$var$_propTypes.default.arrayOf($efe6abd737bf9707$var$_propTypes.default.oneOf([
    "s",
    "w",
    "e",
    "n",
    "sw",
    "nw",
    "se",
    "ne"
]));
// Custom component for resize handles
const $efe6abd737bf9707$var$resizeHandleType /*: ReactPropsChainableTypeChecker*/  = module.exports.resizeHandleType = $efe6abd737bf9707$var$_propTypes.default.oneOfType([
    $efe6abd737bf9707$var$_propTypes.default.node,
    $efe6abd737bf9707$var$_propTypes.default.func
]);

/*:: export type Props = {|
  className: string,
  style: Object,
  width: number,
  autoSize: boolean,
  cols: number,
  draggableCancel: string,
  draggableHandle: string,
  verticalCompact: boolean,
  compactType: CompactType,
  layout: Layout,
  margin: [number, number],
  containerPadding: ?[number, number],
  rowHeight: number,
  maxRows: number,
  isBounded: boolean,
  isDraggable: boolean,
  isResizable: boolean,
  isDroppable: boolean,
  preventCollision: boolean,
  useCSSTransforms: boolean,
  transformScale: number,
  droppingItem: $Shape<LayoutItem>,
  resizeHandles: ResizeHandleAxis[],
  resizeHandle?: ResizeHandle,
  allowOverlap: boolean,

  // Callbacks
  onLayoutChange: Layout => void,
  onDrag: EventCallback,
  onDragStart: EventCallback,
  onDragStop: EventCallback,
  onResize: EventCallback,
  onResizeStart: EventCallback,
  onResizeStop: EventCallback,
  onDropDragOver: (e: DragOverEvent) => ?({| w?: number, h?: number |} | false),
  onDrop: (layout: Layout, item: ?LayoutItem, e: Event) => void,
  children: ReactChildrenArray<ReactElement<any>>,
  innerRef?: Ref<"div">
|};*/ /*:: export type DefaultProps = $Diff<
  Props,
  {
    children: ReactChildrenArray<ReactElement<any>>,
    width: number
  }
>;*/ var $efe6abd737bf9707$var$_default = module.exports.default = {
    //
    // Basic props
    //
    className: $efe6abd737bf9707$var$_propTypes.default.string,
    style: $efe6abd737bf9707$var$_propTypes.default.object,
    // This can be set explicitly. If it is not set, it will automatically
    // be set to the container width. Note that resizes will *not* cause this to adjust.
    // If you need that behavior, use WidthProvider.
    width: $efe6abd737bf9707$var$_propTypes.default.number,
    // If true, the container height swells and contracts to fit contents
    autoSize: $efe6abd737bf9707$var$_propTypes.default.bool,
    // # of cols.
    cols: $efe6abd737bf9707$var$_propTypes.default.number,
    // A selector that will not be draggable.
    draggableCancel: $efe6abd737bf9707$var$_propTypes.default.string,
    // A selector for the draggable handler
    draggableHandle: $efe6abd737bf9707$var$_propTypes.default.string,
    // Deprecated
    verticalCompact: function(props /*: Props*/ ) {
        props.verticalCompact;
    },
    // Choose vertical or hotizontal compaction
    compactType: $efe6abd737bf9707$var$_propTypes.default.oneOf([
        "vertical",
        "horizontal"
    ]),
    // layout is an array of object with the format:
    // {x: Number, y: Number, w: Number, h: Number, i: String}
    layout: function(props /*: Props*/ ) {
        var layout = props.layout;
        // I hope you're setting the data-grid property on the grid items
        if (layout === undefined) return;
        (parcelRequire("29Wdk")).validateLayout(layout, "layout");
    },
    //
    // Grid Dimensions
    //
    // Margin between items [x, y] in px
    margin: $efe6abd737bf9707$var$_propTypes.default.arrayOf($efe6abd737bf9707$var$_propTypes.default.number),
    // Padding inside the container [x, y] in px
    containerPadding: $efe6abd737bf9707$var$_propTypes.default.arrayOf($efe6abd737bf9707$var$_propTypes.default.number),
    // Rows have a static height, but you can change this based on breakpoints if you like
    rowHeight: $efe6abd737bf9707$var$_propTypes.default.number,
    // Default Infinity, but you can specify a max here if you like.
    // Note that this isn't fully fleshed out and won't error if you specify a layout that
    // extends beyond the row capacity. It will, however, not allow users to drag/resize
    // an item past the barrier. They can push items beyond the barrier, though.
    // Intentionally not documented for this reason.
    maxRows: $efe6abd737bf9707$var$_propTypes.default.number,
    //
    // Flags
    //
    isBounded: $efe6abd737bf9707$var$_propTypes.default.bool,
    isDraggable: $efe6abd737bf9707$var$_propTypes.default.bool,
    isResizable: $efe6abd737bf9707$var$_propTypes.default.bool,
    // If true, grid can be placed one over the other.
    allowOverlap: $efe6abd737bf9707$var$_propTypes.default.bool,
    // If true, grid items won't change position when being dragged over.
    preventCollision: $efe6abd737bf9707$var$_propTypes.default.bool,
    // Use CSS transforms instead of top/left
    useCSSTransforms: $efe6abd737bf9707$var$_propTypes.default.bool,
    // parent layout transform scale
    transformScale: $efe6abd737bf9707$var$_propTypes.default.number,
    // If true, an external element can trigger onDrop callback with a specific grid position as a parameter
    isDroppable: $efe6abd737bf9707$var$_propTypes.default.bool,
    // Resize handle options
    resizeHandles: $efe6abd737bf9707$var$resizeHandleAxesType,
    resizeHandle: $efe6abd737bf9707$var$resizeHandleType,
    //
    // Callbacks
    //
    // Callback so you can save the layout. Calls after each drag & resize stops.
    onLayoutChange: $efe6abd737bf9707$var$_propTypes.default.func,
    // Calls when drag starts. Callback is of the signature (layout, oldItem, newItem, placeholder, e, ?node).
    // All callbacks below have the same signature. 'start' and 'stop' callbacks omit the 'placeholder'.
    onDragStart: $efe6abd737bf9707$var$_propTypes.default.func,
    // Calls on each drag movement.
    onDrag: $efe6abd737bf9707$var$_propTypes.default.func,
    // Calls when drag is complete.
    onDragStop: $efe6abd737bf9707$var$_propTypes.default.func,
    //Calls when resize starts.
    onResizeStart: $efe6abd737bf9707$var$_propTypes.default.func,
    // Calls when resize movement happens.
    onResize: $efe6abd737bf9707$var$_propTypes.default.func,
    // Calls when resize is complete.
    onResizeStop: $efe6abd737bf9707$var$_propTypes.default.func,
    // Calls when some element is dropped.
    onDrop: $efe6abd737bf9707$var$_propTypes.default.func,
    //
    // Other validations
    //
    droppingItem: $efe6abd737bf9707$var$_propTypes.default.shape({
        i: $efe6abd737bf9707$var$_propTypes.default.string.isRequired,
        w: $efe6abd737bf9707$var$_propTypes.default.number.isRequired,
        h: $efe6abd737bf9707$var$_propTypes.default.number.isRequired
    }),
    // Children must not have duplicate keys.
    children: function(props /*: Props*/ , propName /*: string*/ ) {
        const children = props[propName];
        // Check children keys for duplicates. Throw if found.
        const keys = {};
        $efe6abd737bf9707$var$_react.default.Children.forEach(children, function(child) {
            if ((child === null || child === void 0 ? void 0 : child.key) == null) return;
            if (keys[child.key]) throw new Error('Duplicate child key "' + child.key + '" found! This will cause problems in ReactGridLayout.');
            keys[child.key] = true;
        });
    },
    // Optional ref for getting a reference for the wrapping div.
    innerRef: $efe6abd737bf9707$var$_propTypes.default.any
};

});



parcelRegister("eQFMR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $acf65609286de34f$var$React = $acf65609286de34f$var$_interopRequireWildcard((parcelRequire("cQQee")));

var $acf65609286de34f$var$_propTypes = $acf65609286de34f$var$_interopRequireDefault((parcelRequire("9AqQV")));

var $c7hp9 = parcelRequire("c7hp9");

var $29Wdk = parcelRequire("29Wdk");

var $fldjZ = parcelRequire("fldjZ");

var $acf65609286de34f$var$_ReactGridLayout = $acf65609286de34f$var$_interopRequireDefault((parcelRequire("pWRJW")));
const $acf65609286de34f$var$_excluded = [
    "breakpoint",
    "breakpoints",
    "cols",
    "layouts",
    "margin",
    "containerPadding",
    "onBreakpointChange",
    "onLayoutChange",
    "onWidthChange"
];
function $acf65609286de34f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $acf65609286de34f$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($acf65609286de34f$var$_interopRequireWildcard = function(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(const t in e)"default" !== t && ({}).hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
        return f;
    })(e, t);
}
function $acf65609286de34f$var$_extends() {
    return $acf65609286de34f$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $acf65609286de34f$var$_extends.apply(null, arguments);
}
function $acf65609286de34f$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $acf65609286de34f$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $acf65609286de34f$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $acf65609286de34f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $acf65609286de34f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $acf65609286de34f$var$ownKeys(Object(t), !0).forEach(function(r) {
            $acf65609286de34f$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $acf65609286de34f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $acf65609286de34f$var$_defineProperty(e, r, t) {
    return (r = $acf65609286de34f$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $acf65609286de34f$var$_toPropertyKey(t) {
    var i = $acf65609286de34f$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $acf65609286de34f$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
} /*:: import { type Layout, type Pick } from "./utils";*/  /*:: import { type ResponsiveLayout, type OnLayoutChangeCallback, type Breakpoints } from "./responsiveUtils";*/ 
// $FlowFixMe[method-unbinding]
const $acf65609286de34f$var$type = (obj)=>Object.prototype.toString.call(obj);
/**
 * Get a value of margin or containerPadding.
 *
 * @param  {Array | Object} param Margin | containerPadding, e.g. [10, 10] | {lg: [10, 10], ...}.
 * @param  {String} breakpoint   Breakpoint: lg, md, sm, xs and etc.
 * @return {Array}
 */ function $acf65609286de34f$var$getIndentationValue(param /*: { [key: string]: T } | T*/ , breakpoint /*: string*/ ) /*: T*/ {
    // $FlowIgnore TODO fix this typedef
    if (param == null) return null;
    // $FlowIgnore TODO fix this typedef
    return Array.isArray(param) ? param : param[breakpoint];
}
/*:: type State = {
  layout: Layout,
  breakpoint: string,
  cols: number,
  layouts?: ResponsiveLayout<string>
};*/ /*:: type Props<Breakpoint: string = string> = {|
  ...React.ElementConfig<typeof ReactGridLayout>,

  // Responsive config
  breakpoint?: ?Breakpoint,
  breakpoints: Breakpoints<Breakpoint>,
  cols: { [key: Breakpoint]: number },
  layouts: ResponsiveLayout<Breakpoint>,
  width: number,
  margin: { [key: Breakpoint]: [number, number] } | [number, number],
  /* prettier-ignore *-/
  containerPadding: { [key: Breakpoint]: ?[number, number] } | ?[number, number],

  // Callbacks
  onBreakpointChange: (Breakpoint, cols: number) => void,
  onLayoutChange: OnLayoutChangeCallback,
  onWidthChange: (
    containerWidth: number,
    margin: [number, number],
    cols: number,
    containerPadding: ?[number, number]
  ) => void
|};*/ /*:: type DefaultProps = Pick<
  Props<>,
  {|
    allowOverlap: 0,
    breakpoints: 0,
    cols: 0,
    containerPadding: 0,
    layouts: 0,
    margin: 0,
    onBreakpointChange: 0,
    onLayoutChange: 0,
    onWidthChange: 0
  |}
>;*/ class $acf65609286de34f$var$ResponsiveReactGridLayout extends $acf65609286de34f$var$React.Component {
    constructor(){
        super(...arguments);
        $acf65609286de34f$var$_defineProperty(this, "state", this.generateInitialState());
        // wrap layouts so we do not need to pass layouts to child
        $acf65609286de34f$var$_defineProperty(this, "onLayoutChange", (layout /*: Layout*/ )=>{
            this.props.onLayoutChange(layout, $acf65609286de34f$var$_objectSpread($acf65609286de34f$var$_objectSpread({}, this.props.layouts), {}, {
                [this.state.breakpoint]: layout
            }));
        });
    }
    generateInitialState() /*: State*/ {
        const { width: width, breakpoints: breakpoints, layouts: layouts, cols: cols } = this.props;
        const breakpoint = (0, $fldjZ.getBreakpointFromWidth)(breakpoints, width);
        const colNo = (0, $fldjZ.getColsFromBreakpoint)(breakpoint, cols);
        // verticalCompact compatibility, now deprecated
        const compactType = this.props.verticalCompact === false ? null : this.props.compactType;
        // Get the initial layout. This can tricky; we try to generate one however possible if one doesn't exist
        // for this layout.
        const initialLayout = (0, $fldjZ.findOrGenerateResponsiveLayout)(layouts, breakpoints, breakpoint, breakpoint, colNo, compactType);
        return {
            layout: initialLayout,
            breakpoint: breakpoint,
            cols: colNo
        };
    }
    static getDerivedStateFromProps(nextProps /*: Props<*>*/ , prevState /*: State*/ ) /*: ?$Shape<State>*/ {
        if (!(0, $c7hp9.deepEqual)(nextProps.layouts, prevState.layouts)) {
            // Allow parent to set layouts directly.
            const { breakpoint: breakpoint, cols: cols } = prevState;
            // Since we're setting an entirely new layout object, we must generate a new responsive layout
            // if one does not exist.
            const newLayout = (0, $fldjZ.findOrGenerateResponsiveLayout)(nextProps.layouts, nextProps.breakpoints, breakpoint, breakpoint, cols, nextProps.compactType);
            return {
                layout: newLayout,
                layouts: nextProps.layouts
            };
        }
        return null;
    }
    componentDidUpdate(prevProps /*: Props<*>*/ ) {
        // Allow parent to set width or breakpoint directly.
        if (this.props.width != prevProps.width || this.props.breakpoint !== prevProps.breakpoint || !(0, $c7hp9.deepEqual)(this.props.breakpoints, prevProps.breakpoints) || !(0, $c7hp9.deepEqual)(this.props.cols, prevProps.cols)) this.onWidthChange(prevProps);
    }
    /**
   * When the width changes work through breakpoints and reset state with the new width & breakpoint.
   * Width changes are necessary to figure out the widget widths.
   */ onWidthChange(prevProps /*: Props<*>*/ ) {
        const { breakpoints: breakpoints, cols: cols, layouts: layouts, compactType: compactType } = this.props;
        const newBreakpoint = this.props.breakpoint || (0, $fldjZ.getBreakpointFromWidth)(this.props.breakpoints, this.props.width);
        const lastBreakpoint = this.state.breakpoint;
        const newCols /*: number*/  = (0, $fldjZ.getColsFromBreakpoint)(newBreakpoint, cols);
        const newLayouts = $acf65609286de34f$var$_objectSpread({}, layouts);
        // Breakpoint change
        if (lastBreakpoint !== newBreakpoint || prevProps.breakpoints !== breakpoints || prevProps.cols !== cols) {
            // Preserve the current layout if the current breakpoint is not present in the next layouts.
            if (!(lastBreakpoint in newLayouts)) newLayouts[lastBreakpoint] = (0, $29Wdk.cloneLayout)(this.state.layout);
            // Find or generate a new layout.
            let layout = (0, $fldjZ.findOrGenerateResponsiveLayout)(newLayouts, breakpoints, newBreakpoint, lastBreakpoint, newCols, compactType);
            // This adds missing items.
            layout = (0, $29Wdk.synchronizeLayoutWithChildren)(layout, this.props.children, newCols, compactType, this.props.allowOverlap);
            // Store the new layout.
            newLayouts[newBreakpoint] = layout;
            // callbacks
            this.props.onBreakpointChange(newBreakpoint, newCols);
            this.props.onLayoutChange(layout, newLayouts);
            this.setState({
                breakpoint: newBreakpoint,
                layout: layout,
                cols: newCols
            });
        }
        const margin = $acf65609286de34f$var$getIndentationValue(this.props.margin, newBreakpoint);
        const containerPadding = $acf65609286de34f$var$getIndentationValue(this.props.containerPadding, newBreakpoint);
        //call onWidthChange on every change of width, not only on breakpoint changes
        this.props.onWidthChange(this.props.width, margin, newCols, containerPadding);
    }
    render() /*: React.Element<typeof ReactGridLayout>*/ {
        /* eslint-disable no-unused-vars */ const _this$props = this.props, { breakpoint: breakpoint, breakpoints: breakpoints, cols: cols, layouts: layouts, margin: margin, containerPadding: containerPadding, onBreakpointChange: onBreakpointChange, onLayoutChange: onLayoutChange, onWidthChange: onWidthChange } = _this$props, other = $acf65609286de34f$var$_objectWithoutProperties(_this$props, $acf65609286de34f$var$_excluded);
        /* eslint-enable no-unused-vars */ return /*#__PURE__*/ $acf65609286de34f$var$React.createElement($acf65609286de34f$var$_ReactGridLayout.default, $acf65609286de34f$var$_extends({}, other, {
            // $FlowIgnore should allow nullable here due to DefaultProps
            margin: $acf65609286de34f$var$getIndentationValue(margin, this.state.breakpoint),
            containerPadding: $acf65609286de34f$var$getIndentationValue(containerPadding, this.state.breakpoint),
            onLayoutChange: this.onLayoutChange,
            layout: this.state.layout,
            cols: this.state.cols
        }));
    }
}
module.exports.default = $acf65609286de34f$var$ResponsiveReactGridLayout;
// This should only include propTypes needed in this code; RGL itself
// will do validation of the rest props passed to it.
$acf65609286de34f$var$_defineProperty($acf65609286de34f$var$ResponsiveReactGridLayout, "propTypes", {
    //
    // Basic props
    //
    // Optional, but if you are managing width yourself you may want to set the breakpoint
    // yourself as well.
    breakpoint: $acf65609286de34f$var$_propTypes.default.string,
    // {name: pxVal}, e.g. {lg: 1200, md: 996, sm: 768, xs: 480}
    breakpoints: $acf65609286de34f$var$_propTypes.default.object,
    allowOverlap: $acf65609286de34f$var$_propTypes.default.bool,
    // # of cols. This is a breakpoint -> cols map
    cols: $acf65609286de34f$var$_propTypes.default.object,
    // # of margin. This is a breakpoint -> margin map
    // e.g. { lg: [5, 5], md: [10, 10], sm: [15, 15] }
    // Margin between items [x, y] in px
    // e.g. [10, 10]
    margin: $acf65609286de34f$var$_propTypes.default.oneOfType([
        $acf65609286de34f$var$_propTypes.default.array,
        $acf65609286de34f$var$_propTypes.default.object
    ]),
    // # of containerPadding. This is a breakpoint -> containerPadding map
    // e.g. { lg: [5, 5], md: [10, 10], sm: [15, 15] }
    // Padding inside the container [x, y] in px
    // e.g. [10, 10]
    containerPadding: $acf65609286de34f$var$_propTypes.default.oneOfType([
        $acf65609286de34f$var$_propTypes.default.array,
        $acf65609286de34f$var$_propTypes.default.object
    ]),
    // layouts is an object mapping breakpoints to layouts.
    // e.g. {lg: Layout, md: Layout, ...}
    layouts (props /*: Props<>*/ , propName /*: string*/ ) {
        if ($acf65609286de34f$var$type(props[propName]) !== "[object Object]") throw new Error("Layout property must be an object. Received: " + $acf65609286de34f$var$type(props[propName]));
        Object.keys(props[propName]).forEach((key)=>{
            if (!(key in props.breakpoints)) throw new Error("Each key in layouts must align with a key in breakpoints.");
            (0, $29Wdk.validateLayout)(props.layouts[key], "layouts." + key);
        });
    },
    // The width of this component.
    // Required in this propTypes stanza because generateInitialState() will fail without it.
    width: $acf65609286de34f$var$_propTypes.default.number.isRequired,
    //
    // Callbacks
    //
    // Calls back with breakpoint and new # cols
    onBreakpointChange: $acf65609286de34f$var$_propTypes.default.func,
    // Callback so you can save the layout.
    // Calls back with (currentLayout, allLayouts). allLayouts are keyed by breakpoint.
    onLayoutChange: $acf65609286de34f$var$_propTypes.default.func,
    // Calls back with (containerWidth, margin, cols, containerPadding)
    onWidthChange: $acf65609286de34f$var$_propTypes.default.func
});
$acf65609286de34f$var$_defineProperty($acf65609286de34f$var$ResponsiveReactGridLayout, "defaultProps", {
    breakpoints: {
        lg: 1200,
        md: 996,
        sm: 768,
        xs: 480,
        xxs: 0
    },
    cols: {
        lg: 12,
        md: 10,
        sm: 6,
        xs: 4,
        xxs: 2
    },
    containerPadding: {
        lg: null,
        md: null,
        sm: null,
        xs: null,
        xxs: null
    },
    layouts: {},
    margin: [
        10,
        10
    ],
    allowOverlap: false,
    onBreakpointChange: $29Wdk.noop,
    onLayoutChange: $29Wdk.noop,
    onWidthChange: $29Wdk.noop
});

});
parcelRegister("fldjZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.findOrGenerateResponsiveLayout = $b2b32685c7fe3c26$var$findOrGenerateResponsiveLayout;
module.exports.getBreakpointFromWidth = $b2b32685c7fe3c26$var$getBreakpointFromWidth;
module.exports.getColsFromBreakpoint = $b2b32685c7fe3c26$var$getColsFromBreakpoint;
module.exports.sortBreakpoints = $b2b32685c7fe3c26$var$sortBreakpoints;

var $29Wdk = parcelRequire("29Wdk");
/*:: import type { CompactType, Layout } from "./utils";*/ /*:: export type Breakpoint = string;*/ /*:: export type DefaultBreakpoints = "lg" | "md" | "sm" | "xs" | "xxs";*/ /*:: export type ResponsiveLayout<T: Breakpoint> = {
  +[breakpoint: T]: Layout
};*/ // + indicates read-only
/*:: export type Breakpoints<T: Breakpoint> = {
  +[breakpoint: T]: number
};*/ /*:: export type OnLayoutChangeCallback = (
  Layout,
  { [key: Breakpoint]: Layout }
) => void;*/ /**
 * Given a width, find the highest breakpoint that matches is valid for it (width > breakpoint).
 *
 * @param  {Object} breakpoints Breakpoints object (e.g. {lg: 1200, md: 960, ...})
 * @param  {Number} width Screen width.
 * @return {String}       Highest breakpoint that is less than width.
 */ function $b2b32685c7fe3c26$var$getBreakpointFromWidth(breakpoints /*: Breakpoints<Breakpoint>*/ , width /*: number*/ ) /*: Breakpoint*/ {
    const sorted = $b2b32685c7fe3c26$var$sortBreakpoints(breakpoints);
    let matching = sorted[0];
    for(let i = 1, len = sorted.length; i < len; i++){
        const breakpointName = sorted[i];
        if (width > breakpoints[breakpointName]) matching = breakpointName;
    }
    return matching;
}
/**
 * Given a breakpoint, get the # of cols set for it.
 * @param  {String} breakpoint Breakpoint name.
 * @param  {Object} cols       Map of breakpoints to cols.
 * @return {Number}            Number of cols.
 */ function $b2b32685c7fe3c26$var$getColsFromBreakpoint(breakpoint /*: Breakpoint*/ , cols /*: Breakpoints<Breakpoint>*/ ) /*: number*/ {
    if (!cols[breakpoint]) throw new Error("ResponsiveReactGridLayout: `cols` entry for breakpoint " + breakpoint + " is missing!");
    return cols[breakpoint];
}
/**
 * Given existing layouts and a new breakpoint, find or generate a new layout.
 *
 * This finds the layout above the new one and generates from it, if it exists.
 *
 * @param  {Object} layouts     Existing layouts.
 * @param  {Array} breakpoints All breakpoints.
 * @param  {String} breakpoint New breakpoint.
 * @param  {String} breakpoint Last breakpoint (for fallback).
 * @param  {Number} cols       Column count at new breakpoint.
 * @param  {Boolean} verticalCompact Whether or not to compact the layout
 *   vertically.
 * @return {Array}             New layout.
 */ function $b2b32685c7fe3c26$var$findOrGenerateResponsiveLayout(layouts /*: ResponsiveLayout<Breakpoint>*/ , breakpoints /*: Breakpoints<Breakpoint>*/ , breakpoint /*: Breakpoint*/ , lastBreakpoint /*: Breakpoint*/ , cols /*: number*/ , compactType /*: CompactType*/ ) /*: Layout*/ {
    // If it already exists, just return it.
    if (layouts[breakpoint]) return (0, $29Wdk.cloneLayout)(layouts[breakpoint]);
    // Find or generate the next layout
    let layout = layouts[lastBreakpoint];
    const breakpointsSorted = $b2b32685c7fe3c26$var$sortBreakpoints(breakpoints);
    const breakpointsAbove = breakpointsSorted.slice(breakpointsSorted.indexOf(breakpoint));
    for(let i = 0, len = breakpointsAbove.length; i < len; i++){
        const b = breakpointsAbove[i];
        if (layouts[b]) {
            layout = layouts[b];
            break;
        }
    }
    layout = (0, $29Wdk.cloneLayout)(layout || []); // clone layout so we don't modify existing items
    return (0, $29Wdk.compact)((0, $29Wdk.correctBounds)(layout, {
        cols: cols
    }), compactType, cols);
}
/**
 * Given breakpoints, return an array of breakpoints sorted by width. This is usually
 * e.g. ['xxs', 'xs', 'sm', ...]
 *
 * @param  {Object} breakpoints Key/value pair of breakpoint names to widths.
 * @return {Array}              Sorted breakpoints.
 */ function $b2b32685c7fe3c26$var$sortBreakpoints(breakpoints /*: Breakpoints<Breakpoint>*/ ) /*: Array<Breakpoint>*/ {
    const keys /*: Array<string>*/  = Object.keys(breakpoints);
    return keys.sort(function(a, b) {
        return breakpoints[a] - breakpoints[b];
    });
}

});


parcelRegister("9fCNy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6bc39c4d4c98531d$var$WidthProvideRGL;

var $6bc39c4d4c98531d$var$React = $6bc39c4d4c98531d$var$_interopRequireWildcard((parcelRequire("cQQee")));

var $6bc39c4d4c98531d$var$_propTypes = $6bc39c4d4c98531d$var$_interopRequireDefault((parcelRequire("9AqQV")));

var $6bc39c4d4c98531d$var$_resizeObserverPolyfill = $6bc39c4d4c98531d$var$_interopRequireDefault((parcelRequire("had0S")));

var $6bc39c4d4c98531d$var$_clsx = $6bc39c4d4c98531d$var$_interopRequireDefault((parcelRequire("lY25K")));
const $6bc39c4d4c98531d$var$_excluded = [
    "measureBeforeMount"
];
function $6bc39c4d4c98531d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $6bc39c4d4c98531d$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($6bc39c4d4c98531d$var$_interopRequireWildcard = function(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(const t in e)"default" !== t && ({}).hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
        return f;
    })(e, t);
}
function $6bc39c4d4c98531d$var$_extends() {
    return $6bc39c4d4c98531d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $6bc39c4d4c98531d$var$_extends.apply(null, arguments);
}
function $6bc39c4d4c98531d$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $6bc39c4d4c98531d$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $6bc39c4d4c98531d$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $6bc39c4d4c98531d$var$_defineProperty(e, r, t) {
    return (r = $6bc39c4d4c98531d$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $6bc39c4d4c98531d$var$_toPropertyKey(t) {
    var i = $6bc39c4d4c98531d$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $6bc39c4d4c98531d$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
/*:: import type { ReactRef } from "../ReactGridLayoutPropTypes";*/ /*:: type WPDefaultProps = {|
  measureBeforeMount: boolean
|};*/ /*:: type WPProps = {|
  className?: string,
  style?: Object,
  ...WPDefaultProps
|};*/ // eslint-disable-next-line no-unused-vars
/*:: type WPState = {|
  width: number
|};*/ /*:: type ComposedProps<Config> = {|
  ...Config,
  measureBeforeMount?: boolean,
  className?: string,
  style?: Object,
  width?: number
|};*/ const $6bc39c4d4c98531d$var$layoutClassName = "react-grid-layout";
/*
 * A simple HOC that provides facility for listening to container resizes.
 *
 * The Flow type is pretty janky here. I can't just spread `WPProps` into this returned object - I wish I could - but it triggers
 * a flow bug of some sort that causes it to stop typechecking.
 */ function $6bc39c4d4c98531d$var$WidthProvideRGL(ComposedComponent /*: React.AbstractComponent<Config>*/ ) /*: React.AbstractComponent<ComposedProps<Config>>*/ {
    var _WidthProvider;
    return _WidthProvider = class WidthProvider extends $6bc39c4d4c98531d$var$React.Component {
        constructor(){
            super(...arguments);
            $6bc39c4d4c98531d$var$_defineProperty(this, "state", {
                width: 1280
            });
            $6bc39c4d4c98531d$var$_defineProperty(this, "elementRef", /*#__PURE__*/ $6bc39c4d4c98531d$var$React.createRef());
            $6bc39c4d4c98531d$var$_defineProperty(this, "mounted", false);
            $6bc39c4d4c98531d$var$_defineProperty(this, "resizeObserver", void 0);
        }
        componentDidMount() {
            this.mounted = true;
            this.resizeObserver = new $6bc39c4d4c98531d$var$_resizeObserverPolyfill.default((entries)=>{
                const node = this.elementRef.current;
                if (node instanceof HTMLElement) {
                    const width = entries[0].contentRect.width;
                    this.setState({
                        width: width
                    });
                }
            });
            const node = this.elementRef.current;
            if (node instanceof HTMLElement) this.resizeObserver.observe(node);
        }
        componentWillUnmount() {
            this.mounted = false;
            const node = this.elementRef.current;
            if (node instanceof HTMLElement) this.resizeObserver.unobserve(node);
            this.resizeObserver.disconnect();
        }
        render() {
            const _this$props = this.props, { measureBeforeMount: measureBeforeMount } = _this$props, rest = $6bc39c4d4c98531d$var$_objectWithoutProperties(_this$props, $6bc39c4d4c98531d$var$_excluded);
            if (measureBeforeMount && !this.mounted) return /*#__PURE__*/ $6bc39c4d4c98531d$var$React.createElement("div", {
                className: (0, $6bc39c4d4c98531d$var$_clsx.default)(this.props.className, $6bc39c4d4c98531d$var$layoutClassName),
                style: this.props.style,
                ref: this.elementRef
            });
            return /*#__PURE__*/ $6bc39c4d4c98531d$var$React.createElement(ComposedComponent, $6bc39c4d4c98531d$var$_extends({
                innerRef: this.elementRef
            }, rest, this.state));
        }
    }, $6bc39c4d4c98531d$var$_defineProperty(_WidthProvider, "defaultProps", {
        measureBeforeMount: false
    }), $6bc39c4d4c98531d$var$_defineProperty(_WidthProvider, "propTypes", {
        // If true, will not render children until mounted. Useful for getting the exact width before
        // rendering, to prevent any unsightly resizing.
        measureBeforeMount: $6bc39c4d4c98531d$var$_propTypes.default.bool
    }), _WidthProvider;
}

});
parcelRegister("had0S", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $c7ed76f9ef9786b4$export$2e2bcd8739ae039; });
/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */ /* eslint-disable require-jsdoc, valid-jsdoc */ var $c7ed76f9ef9786b4$var$MapShim = function() {
    if (typeof Map !== 'undefined') return Map;
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */ function getIndex(arr, key) {
        var result = -1;
        arr.some(function(entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ function() {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */ get: function() {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */ class_1.prototype.get = function(key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */ class_1.prototype.set = function(key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) this.__entries__[index][1] = value;
            else this.__entries__.push([
                key,
                value
            ]);
        };
        /**
         * @param {*} key
         * @returns {void}
         */ class_1.prototype.delete = function(key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) entries.splice(index, 1);
        };
        /**
         * @param {*} key
         * @returns {void}
         */ class_1.prototype.has = function(key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */ class_1.prototype.clear = function() {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */ class_1.prototype.forEach = function(callback, ctx) {
            if (ctx === void 0) ctx = null;
            for(var _i = 0, _a = this.__entries__; _i < _a.length; _i++){
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }();
}();
/**
 * Detects whether window and document objects are available in current environment.
 */ var $c7ed76f9ef9786b4$var$isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;
// Returns global object of a current environment.
var $c7ed76f9ef9786b4$var$global$1 = function() {
    if (typeof $parcel$global !== 'undefined' && $parcel$global.Math === Math) return $parcel$global;
    if (typeof self !== 'undefined' && self.Math === Math) return self;
    if (typeof window !== 'undefined' && window.Math === Math) return window;
    // eslint-disable-next-line no-new-func
    return Function('return this')();
}();
/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */ var $c7ed76f9ef9786b4$var$requestAnimationFrame$1 = function() {
    if (typeof requestAnimationFrame === 'function') // It's required to use a bounded function because IE sometimes throws
    // an "Invalid calling object" error if rAF is invoked without the global
    // object on the left hand side.
    return requestAnimationFrame.bind($c7ed76f9ef9786b4$var$global$1);
    return function(callback) {
        return setTimeout(function() {
            return callback(Date.now());
        }, 1000 / 60);
    };
}();
// Defines minimum timeout before adding a trailing call.
var $c7ed76f9ef9786b4$var$trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */ function $c7ed76f9ef9786b4$var$throttle(callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */ function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) proxy();
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */ function timeoutCallback() {
        $c7ed76f9ef9786b4$var$requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */ function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < $c7ed76f9ef9786b4$var$trailingTimeout) return;
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        } else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}
// Minimum delay before invoking the update of observers.
var $c7ed76f9ef9786b4$var$REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var $c7ed76f9ef9786b4$var$transitionKeys = [
    'top',
    'right',
    'bottom',
    'left',
    'width',
    'height',
    'size',
    'weight'
];
// Check if MutationObserver is available.
var $c7ed76f9ef9786b4$var$mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */ var $c7ed76f9ef9786b4$var$ResizeObserverController = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */ function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */ this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */ this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */ this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */ this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = $c7ed76f9ef9786b4$var$throttle(this.refresh.bind(this), $c7ed76f9ef9786b4$var$REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */ ResizeObserverController.prototype.addObserver = function(observer) {
        if (!~this.observers_.indexOf(observer)) this.observers_.push(observer);
        // Add listeners if they haven't been added yet.
        if (!this.connected_) this.connect_();
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */ ResizeObserverController.prototype.removeObserver = function(observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) observers.splice(index, 1);
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) this.disconnect_();
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */ ResizeObserverController.prototype.refresh = function() {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) this.refresh();
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */ ResizeObserverController.prototype.updateObservers_ = function() {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function(observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function(observer) {
            return observer.broadcastActive();
        });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */ ResizeObserverController.prototype.connect_ = function() {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!$c7ed76f9ef9786b4$var$isBrowser || this.connected_) return;
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if ($c7ed76f9ef9786b4$var$mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        } else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */ ResizeObserverController.prototype.disconnect_ = function() {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!$c7ed76f9ef9786b4$var$isBrowser || !this.connected_) return;
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) this.mutationsObserver_.disconnect();
        if (this.mutationEventsAdded_) document.removeEventListener('DOMSubtreeModified', this.refresh);
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */ ResizeObserverController.prototype.onTransitionEnd_ = function(_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = $c7ed76f9ef9786b4$var$transitionKeys.some(function(key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) this.refresh();
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */ ResizeObserverController.getInstance = function() {
        if (!this.instance_) this.instance_ = new ResizeObserverController();
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */ ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}();
/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */ var $c7ed76f9ef9786b4$var$defineConfigurable = function(target, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
};
/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */ var $c7ed76f9ef9786b4$var$getWindowOf = function(target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || $c7ed76f9ef9786b4$var$global$1;
};
// Placeholder of an empty content rectangle.
var $c7ed76f9ef9786b4$var$emptyRect = $c7ed76f9ef9786b4$var$createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */ function $c7ed76f9ef9786b4$var$toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */ function $c7ed76f9ef9786b4$var$getBordersSize(styles) {
    var positions = [];
    for(var _i = 1; _i < arguments.length; _i++)positions[_i - 1] = arguments[_i];
    return positions.reduce(function(size, position) {
        var value = styles['border-' + position + '-width'];
        return size + $c7ed76f9ef9786b4$var$toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */ function $c7ed76f9ef9786b4$var$getPaddings(styles) {
    var positions = [
        'top',
        'right',
        'bottom',
        'left'
    ];
    var paddings = {};
    for(var _i = 0, positions_1 = positions; _i < positions_1.length; _i++){
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = $c7ed76f9ef9786b4$var$toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */ function $c7ed76f9ef9786b4$var$getSVGContentRect(target) {
    var bbox = target.getBBox();
    return $c7ed76f9ef9786b4$var$createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */ function $c7ed76f9ef9786b4$var$getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) return $c7ed76f9ef9786b4$var$emptyRect;
    var styles = $c7ed76f9ef9786b4$var$getWindowOf(target).getComputedStyle(target);
    var paddings = $c7ed76f9ef9786b4$var$getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = $c7ed76f9ef9786b4$var$toFloat(styles.width), height = $c7ed76f9ef9786b4$var$toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) width -= $c7ed76f9ef9786b4$var$getBordersSize(styles, 'left', 'right') + horizPad;
        if (Math.round(height + vertPad) !== clientHeight) height -= $c7ed76f9ef9786b4$var$getBordersSize(styles, 'top', 'bottom') + vertPad;
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!$c7ed76f9ef9786b4$var$isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) width -= vertScrollbar;
        if (Math.abs(horizScrollbar) !== 1) height -= horizScrollbar;
    }
    return $c7ed76f9ef9786b4$var$createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */ var $c7ed76f9ef9786b4$var$isSVGGraphicsElement = function() {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') return function(target) {
        return target instanceof $c7ed76f9ef9786b4$var$getWindowOf(target).SVGGraphicsElement;
    };
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function(target) {
        return target instanceof $c7ed76f9ef9786b4$var$getWindowOf(target).SVGElement && typeof target.getBBox === 'function';
    };
}();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */ function $c7ed76f9ef9786b4$var$isDocumentElement(target) {
    return target === $c7ed76f9ef9786b4$var$getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */ function $c7ed76f9ef9786b4$var$getContentRect(target) {
    if (!$c7ed76f9ef9786b4$var$isBrowser) return $c7ed76f9ef9786b4$var$emptyRect;
    if ($c7ed76f9ef9786b4$var$isSVGGraphicsElement(target)) return $c7ed76f9ef9786b4$var$getSVGContentRect(target);
    return $c7ed76f9ef9786b4$var$getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */ function $c7ed76f9ef9786b4$var$createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    $c7ed76f9ef9786b4$var$defineConfigurable(rect, {
        x: x,
        y: y,
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */ function $c7ed76f9ef9786b4$var$createRectInit(x, y, width, height) {
    return {
        x: x,
        y: y,
        width: width,
        height: height
    };
}
/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */ var $c7ed76f9ef9786b4$var$ResizeObservation = /** @class */ function() {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */ function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */ this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */ this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */ this.contentRect_ = $c7ed76f9ef9786b4$var$createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */ ResizeObservation.prototype.isActive = function() {
        var rect = $c7ed76f9ef9786b4$var$getContentRect(this.target);
        this.contentRect_ = rect;
        return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */ ResizeObservation.prototype.broadcastRect = function() {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}();
var $c7ed76f9ef9786b4$var$ResizeObserverEntry = /** @class */ function() {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */ function ResizeObserverEntry(target, rectInit) {
        var contentRect = $c7ed76f9ef9786b4$var$createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        $c7ed76f9ef9786b4$var$defineConfigurable(this, {
            target: target,
            contentRect: contentRect
        });
    }
    return ResizeObserverEntry;
}();
var $c7ed76f9ef9786b4$var$ResizeObserverSPI = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */ function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */ this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */ this.observations_ = new $c7ed76f9ef9786b4$var$MapShim();
        if (typeof callback !== 'function') throw new TypeError('The callback provided as parameter 1 is not a function.');
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */ ResizeObserverSPI.prototype.observe = function(target) {
        if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) return;
        if (!(target instanceof $c7ed76f9ef9786b4$var$getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) return;
        observations.set(target, new $c7ed76f9ef9786b4$var$ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */ ResizeObserverSPI.prototype.unobserve = function(target) {
        if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) return;
        if (!(target instanceof $c7ed76f9ef9786b4$var$getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) return;
        observations.delete(target);
        if (!observations.size) this.controller_.removeObserver(this);
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.disconnect = function() {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.gatherActive = function() {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function(observation) {
            if (observation.isActive()) _this.activeObservations_.push(observation);
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.broadcastActive = function() {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) return;
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function(observation) {
            return new $c7ed76f9ef9786b4$var$ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.clearActive = function() {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */ ResizeObserverSPI.prototype.hasActive = function() {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}();
// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var $c7ed76f9ef9786b4$var$observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new $c7ed76f9ef9786b4$var$MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */ var $c7ed76f9ef9786b4$var$ResizeObserver = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */ function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) throw new TypeError('Cannot call a class as a function.');
        if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
        var controller = $c7ed76f9ef9786b4$var$ResizeObserverController.getInstance();
        var observer = new $c7ed76f9ef9786b4$var$ResizeObserverSPI(callback, controller, this);
        $c7ed76f9ef9786b4$var$observers.set(this, observer);
    }
    return ResizeObserver;
}();
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function(method) {
    $c7ed76f9ef9786b4$var$ResizeObserver.prototype[method] = function() {
        var _a;
        return (_a = $c7ed76f9ef9786b4$var$observers.get(this))[method].apply(_a, arguments);
    };
});
var $c7ed76f9ef9786b4$var$index = function() {
    // Export existing implementation if available.
    if (typeof $c7ed76f9ef9786b4$var$global$1.ResizeObserver !== 'undefined') return $c7ed76f9ef9786b4$var$global$1.ResizeObserver;
    return $c7ed76f9ef9786b4$var$ResizeObserver;
}();
var $c7ed76f9ef9786b4$export$2e2bcd8739ae039 = $c7ed76f9ef9786b4$var$index;

});


parcelRegister("299WK", function(module, exports) {

$parcel$export(module.exports, "i", function () { return getNowTime; });
$parcel$export(module.exports, "M", function () { return MAX_BATCH_TIME_MS; });
$parcel$export(module.exports, "l", function () { return SESSION_RECORDING_DEFAULT_HEADERS; });
$parcel$export(module.exports, "o", function () { return SESSION_RECORDING_DEFAULT_ERROR_MESSAGE; });
$parcel$export(module.exports, "j", function () { return SESSION_RECORDING_NETWORK_ERR0R_MESSAGE; });
$parcel$export(module.exports, "B", function () { return BATCH_TIME_DELAY; });
$parcel$export(module.exports, "m", function () { return SESSION_RECORDING_POSTFIX_URL; });
$parcel$export(module.exports, "n", function () { return SESSION_RECORDER_KEY; });
$parcel$export(module.exports, "S", function () { return SESSION_RECORDER_SEGMENTS_MAP; });
$parcel$export(module.exports, "C", function () { return CxGlobal; });
$parcel$export(module.exports, "h", function () { return getSdkConfig; });
$parcel$export(module.exports, "g", function () { return getZoneJsOriginalDom; });
$parcel$export(module.exports, "c", function () { return cxSetTimeout; });
$parcel$export(module.exports, "k", function () { return cxSetInterval; });
$parcel$export(module.exports, "a", function () { return cxClearTimeout; });
$parcel$export(module.exports, "f", function () { return cxClearInterval; });
$parcel$export(module.exports, "d", function () { return cxRequestAnimationFrame; });
$parcel$export(module.exports, "e", function () { return cxCancelAnimationFrame; });
$parcel$export(module.exports, "b", function () { return createCxMutationObserver; });
$parcel$export(module.exports, "R", function () { return Request; });
$parcel$export(module.exports, "p", function () { return CoralogixRum; });

var $8yqJh = parcelRequire("8yqJh");

var $3eG03 = parcelRequire("3eG03");
var $956M5 = parcelRequire("956M5");
var $3ALgF = parcelRequire("3ALgF");

var $5neJ1 = parcelRequire("5neJ1");
var $a4zuf = parcelRequire("a4zuf");

var $fZlMi = parcelRequire("fZlMi");
var $5i7vv = parcelRequire("5i7vv");

var $djhfc = parcelRequire("djhfc");

var $6mRKV = parcelRequire("6mRKV");

var $gILhI = parcelRequire("gILhI");
parcelRequire("ejUix");
var $kTKKO = parcelRequire("kTKKO");

var $3mSe3 = parcelRequire("3mSe3");parcelRequire("ckckF");
var $4e6si = parcelRequire("4e6si");
var $7Y52R = parcelRequire("7Y52R");
var $6b1Zv = parcelRequire("6b1Zv");
var $g4DKS = parcelRequire("g4DKS");
var $jVu0G = parcelRequire("jVu0G");
var $laija = parcelRequire("laija");
var $kxoQ4 = parcelRequire("kxoQ4");

var $iF5nx = parcelRequire("iF5nx");
var $aUPqT = parcelRequire("aUPqT");
parcelRequire("3IGjv");
var $9xOok = parcelRequire("9xOok");
function isString(value) {
    return typeof value === 'string';
}
function isRegExp(value) {
    return value instanceof RegExp;
}
function isMatchingPattern(value, pattern, requireExactStringMatch) {
    if (requireExactStringMatch === void 0) requireExactStringMatch = false;
    if (!isString(value)) return false;
    if (isRegExp(pattern)) return pattern.test(value);
    if (isString(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
function stringMatchesSomePattern(testString, patterns, requireExactStringMatch) {
    if (patterns === void 0) patterns = [];
    if (requireExactStringMatch === void 0) requireExactStringMatch = false;
    return patterns.some(function(pattern) {
        return isMatchingPattern(testString, pattern, requireExactStringMatch);
    });
}
function generateUUID(placeholder) {
    return placeholder ? (+placeholder ^ Math.random() * 16 >> +placeholder / 4).toString(16) : "".concat(1e7, "-").concat(1e3, "-").concat(4e3, "-").concat(8e3, "-").concat(1e11).replace(/[018]/g, generateUUID);
}
var CoralogixEventType;
(function(CoralogixEventType) {
    CoralogixEventType["ERROR"] = "error";
    CoralogixEventType["NETWORK_REQUEST"] = "network-request";
    CoralogixEventType["LOG"] = "log";
    CoralogixEventType["USER_INTERACTION"] = "user-interaction";
    CoralogixEventType["WEB_VITALS"] = "web-vitals";
    CoralogixEventType["LONG_TASK"] = "longtask";
    CoralogixEventType["RESOURCES"] = "resources";
    CoralogixEventType["INTERNAL"] = "internal";
    CoralogixEventType["DOM"] = "dom";
    CoralogixEventType["CUSTOM_MEASUREMENT"] = "custom-measurement";
    CoralogixEventType["MEMORY_USAGE"] = "memory-usage";
    CoralogixEventType["SCREENSHOT"] = "screenshot";
    CoralogixEventType["CUSTOM_SPAN"] = "custom-span";
    CoralogixEventType["WORKER"] = "web-worker";
})(CoralogixEventType || (CoralogixEventType = {}));
var PerformanceTypes;
(function(PerformanceTypes) {
    PerformanceTypes["Resource"] = "resource";
    PerformanceTypes["LongTask"] = "longtask";
    PerformanceTypes["Navigation"] = "navigation";
    PerformanceTypes["SoftNavigation"] = "soft-navigation";
})(PerformanceTypes || (PerformanceTypes = {}));
var OtelNetworkAttrs;
(function(OtelNetworkAttrs) {
    OtelNetworkAttrs["METHOD"] = "http.method";
    OtelNetworkAttrs["URL"] = "http.url";
    OtelNetworkAttrs["STATUS_CODE"] = "http.status_code";
    OtelNetworkAttrs["HOST"] = "http.host";
    OtelNetworkAttrs["SCHEME"] = "http.scheme";
    OtelNetworkAttrs["STATUS_TEXT"] = "http.status_text";
    OtelNetworkAttrs["RESPONSE_CONTENT_LENGTH"] = "http.response_content_length";
})(OtelNetworkAttrs || (OtelNetworkAttrs = {}));
var UrlType;
(function(UrlType) {
    UrlType["PAGE"] = "page";
    UrlType["NETWORK_REQUEST"] = "network_request";
})(UrlType || (UrlType = {}));
function getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}
function isFunction(funktion) {
    return typeof funktion === 'function';
}
var logger = console.error.bind(console);
function defineProperty(obj, name, value) {
    var enumerable = !!obj[name] && obj.propertyIsEnumerable(name);
    Object.defineProperty(obj, name, {
        configurable: true,
        enumerable: enumerable,
        writable: true,
        value: value
    });
}
function shimmer(options) {
    if (options && options.logger) {
        if (!isFunction(options.logger)) logger("new logger isn't a function, not replacing");
        else logger = options.logger;
    }
}
function wrap(nodule, name, wrapper) {
    if (!nodule || !nodule[name]) {
        logger('no original function ' + name + ' to wrap');
        return;
    }
    if (!wrapper) {
        logger('no wrapper function');
        logger(new Error().stack);
        return;
    }
    if (!isFunction(nodule[name]) || !isFunction(wrapper)) {
        logger('original object and wrapper must be functions');
        return;
    }
    var original = nodule[name];
    var wrapped = wrapper(original, name);
    defineProperty(wrapped, '__original', original);
    defineProperty(wrapped, '__unwrap', function() {
        if (nodule[name] === wrapped) defineProperty(nodule, name, original);
    });
    defineProperty(wrapped, '__wrapped', true);
    defineProperty(nodule, name, wrapped);
    return wrapped;
}
function massWrap(nodules, names, wrapper) {
    if (!nodules) {
        logger('must provide one or more modules to patch');
        logger(new Error().stack);
        return;
    } else if (!Array.isArray(nodules)) nodules = [
        nodules
    ];
    if (!(names && Array.isArray(names))) {
        logger('must provide one or more functions to wrap on modules');
        return;
    }
    nodules.forEach(function(nodule) {
        names.forEach(function(name) {
            wrap(nodule, name, wrapper);
        });
    });
}
function unwrap(nodule, name) {
    if (!nodule || !nodule[name]) {
        logger('no function to unwrap.');
        logger(new Error().stack);
        return;
    }
    if (!nodule[name].__unwrap) logger('no original to unwrap to -- has ' + name + ' already been unwrapped?');
    else return nodule[name].__unwrap();
}
function massUnwrap(nodules, names) {
    if (!nodules) {
        logger('must provide one or more modules to patch');
        logger(new Error().stack);
        return;
    } else if (!Array.isArray(nodules)) nodules = [
        nodules
    ];
    if (!(names && Array.isArray(names))) {
        logger('must provide one or more functions to unwrap on modules');
        return;
    }
    nodules.forEach(function(nodule) {
        names.forEach(function(name) {
            unwrap(nodule, name);
        });
    });
}
shimmer.wrap = wrap;
shimmer.massWrap = massWrap;
shimmer.unwrap = unwrap;
shimmer.massUnwrap = massUnwrap;
var shimmer_1 = shimmer;
getDefaultExportFromCjs(shimmer_1);
var CoralogixLogSeverity;
(function(CoralogixLogSeverity) {
    CoralogixLogSeverity[CoralogixLogSeverity["Debug"] = 1] = "Debug";
    CoralogixLogSeverity[CoralogixLogSeverity["Verbose"] = 2] = "Verbose";
    CoralogixLogSeverity[CoralogixLogSeverity["Info"] = 3] = "Info";
    CoralogixLogSeverity[CoralogixLogSeverity["Warn"] = 4] = "Warn";
    CoralogixLogSeverity[CoralogixLogSeverity["Error"] = 5] = "Error";
    CoralogixLogSeverity[CoralogixLogSeverity["Critical"] = 6] = "Critical";
})(CoralogixLogSeverity || (CoralogixLogSeverity = {}));
var SDK_CONFIG_KEY = 'sdkConfig';
var USER_AGENT_KEY = 'userAgent';
var millisecondsPerSecond = 1000;
var millisecondsPerMinute = millisecondsPerSecond * 60;
var MILLISECONDS_PER_HOUR = millisecondsPerMinute * 60;
function getNowTime() {
    return new Date().getTime();
}
var MAX_BATCH_TIME_MS = 10000;
var SESSION_RECORDING_DEFAULT_HEADERS = {
    'Content-Encoding': 'gzip'
};
var SESSION_RECORDING_DEFAULT_ERROR_MESSAGE = 'Coralogix Browser SDK - Recording is not supported on this platform';
var SESSION_RECORDING_NETWORK_ERR0R_MESSAGE = 'Coralogix Browser SDK - Error while sending record';
var BATCH_TIME_DELAY = 1000;
var SESSION_RECORDING_POSTFIX_URL = '/browser/alpha/sessionrecording';
var SESSION_KEY = 'rum_session';
var PREV_SESSION_KEY = 'rum_prev_session';
var DEFAULT_SESSION_CONFIG = {
    sessionSampleRate: 100,
    onlyWithErrorConfig: {
        enable: false
    }
};
var SESSION_IDLE_TIME = 15 * millisecondsPerMinute;
var SESSION_EXPIRATION_TIME = MILLISECONDS_PER_HOUR;
var SESSION_MANAGER_KEY = 'rumSessionManager';
var SESSION_RECORDER_KEY = 'rumSessionRecorder';
var SESSION_RECORDER_SEGMENTS_MAP = 'rumSessionRecorderSegmentsMap';
var SNAPSHOT_MANAGER_KEY = 'rumSnapshotManager';
var INITIAL_SNAPSHOT_CONTEXT = {
    errorCount: 0,
    viewCount: 0,
    actionCount: 0,
    hasRecording: false,
    hasScreenshot: false
};
function getCxGlobal() {
    if (typeof globalThis === 'object') return globalThis;
    Object.defineProperty(Object.prototype, '__cx_global__', {
        get: function() {
            return this;
        },
        configurable: true
    });
    var globalObject = __cx_global__;
    delete Object.prototype.__cx_global__;
    if (typeof globalObject !== 'object') {
        if (typeof self === 'object') globalObject = self;
        else if (typeof window === 'object') globalObject = window;
        else globalObject = {};
    }
    return globalObject;
}
var CxGlobal = getCxGlobal();
function getSnapshotManager() {
    return CxGlobal[SNAPSHOT_MANAGER_KEY];
}
function getSessionManager() {
    return CxGlobal[SESSION_MANAGER_KEY];
}
function getSessionRecorder() {
    return CxGlobal[SESSION_RECORDER_KEY];
}
function getSdkConfig() {
    return CxGlobal[SDK_CONFIG_KEY];
}
function getUserAgentData() {
    return CxGlobal[USER_AGENT_KEY];
}
var GLOBAL_SPAN_KEY = '__globalSpan__';
var GLOBAL_SPAN_MAP_KEY = '__globalSpanMap__';
var CUSTOM_TRACER_KEY = '__customTracer__';
var CUSTOM_TRACER_IGNORED_INSTRUMENTS = '__customTracerIgnoredInstruments__';
function addGlobalSpanByTraceId(traceId, globalSpan) {
    var _a;
    CxGlobal[GLOBAL_SPAN_MAP_KEY] = (0, $8yqJh.__assign)((0, $8yqJh.__assign)({}, CxGlobal[GLOBAL_SPAN_MAP_KEY] || {}), (_a = {}, _a[traceId] = globalSpan, _a));
}
function getGlobalSpanByTraceId(traceId) {
    var _a;
    return (_a = CxGlobal[GLOBAL_SPAN_MAP_KEY]) === null || _a === void 0 ? void 0 : _a[traceId];
}
function clearGlobalSpanMap() {
    var globalSpanMap = CxGlobal[GLOBAL_SPAN_MAP_KEY];
    Object.keys(globalSpanMap || {}).forEach(function(traceId) {
        var globalSpan = globalSpanMap[traceId];
        globalSpan === null || globalSpan === void 0 || globalSpan.endSpan();
    });
    delete CxGlobal[GLOBAL_SPAN_MAP_KEY];
}
function setGlobalSpan(globalSpan) {
    CxGlobal[GLOBAL_SPAN_KEY] = globalSpan;
}
function getGlobalSpan() {
    return CxGlobal[GLOBAL_SPAN_KEY];
}
function clearGlobalSpan() {
    delete CxGlobal[GLOBAL_SPAN_KEY];
}
function setCustomTracer(customTracer) {
    CxGlobal[CUSTOM_TRACER_KEY] = customTracer;
}
function getActiveCustomTracer() {
    return CxGlobal[CUSTOM_TRACER_KEY];
}
function setCustomTracerIgnoredInstruments(ignoredInstruments) {
    CxGlobal[CUSTOM_TRACER_IGNORED_INSTRUMENTS] = ignoredInstruments;
}
function getCustomTracerIgnoredInstruments() {
    return CxGlobal[CUSTOM_TRACER_IGNORED_INSTRUMENTS];
}
function shouldAttachSpanToGlobalSpan(instrumentationType) {
    return getGlobalSpan() && !isInstrumentationIgnored(instrumentationType);
}
function isInstrumentationIgnored(instrumentationType) {
    var _a;
    return !!((_a = getCustomTracerIgnoredInstruments()) === null || _a === void 0 ? void 0 : _a.includes(instrumentationType));
}
function attachChildSpanToGlobalSpan(name) {
    var globalSpan = getGlobalSpan();
    return globalSpan.startCustomSpan(name).span;
}
var IS_OTEL_READY = 'otelReady';
var MAIN_TRACER_KEY = '@';
var ATTR_PROCESSOR_KEY = 'attrProcessor';
var SpanStatusCode;
(function(SpanStatusCode) {
    SpanStatusCode[SpanStatusCode["UNSET"] = 0] = "UNSET";
    SpanStatusCode[SpanStatusCode["OK"] = 1] = "OK";
    SpanStatusCode[SpanStatusCode["ERROR"] = 2] = "ERROR";
})(SpanStatusCode || (SpanStatusCode = {}));
function markSpanAsOtelToSend(span) {
    span[IS_OTEL_READY] = true;
}
function shouldAddOtelAttr(span) {
    return !!span[IS_OTEL_READY];
}
function setAttrProcessor(processor) {
    CxGlobal[ATTR_PROCESSOR_KEY] = processor;
}
function getAttrProcessor() {
    return CxGlobal[ATTR_PROCESSOR_KEY];
}
function setCustomLabelsForSpan(span, labels) {
    if (labels === void 0) labels = {};
    span.setAttribute(CoralogixAttributes.CUSTOM_LABELS, JSON.stringify(getCustomMergedLabels(labels)));
}
function getCustomMergedLabels(labels) {
    var _a;
    if (labels === void 0) labels = {};
    var globalLabels = ((_a = getAttrProcessor()) === null || _a === void 0 ? void 0 : _a.getCustomLabels()) || {};
    return (0, $8yqJh.__assign)((0, $8yqJh.__assign)({}, globalLabels), labels);
}
var CACHED_METADATA_KEY = '__cx_metadata__';
var ERROR_INSTRUMENTATION_VERSION = '1';
var STACK_FRAME_LIMIT = 50;
var STACK_LINE_LIMIT = 1024;
var MESSAGE_LIMIT = 1024;
var MFE_PATH_PATTERN = /https?:\/\/.*\//;
function extractMfePath(fileName) {
    var _a;
    var _b = (0, $8yqJh.__read)((_a = fileName.match(MFE_PATH_PATTERN)) !== null && _a !== void 0 ? _a : [], 1), mfePath = _b[0];
    return mfePath;
}
var ERROR_INSTRUMENTATION_NAME = 'errors';
var ErrorAttributes = {
    TYPE: 'error_type',
    STACK: 'error_stack',
    MESSAGE: 'error_message',
    DATA: 'error_custom_data'
};
var ErrorSource;
(function(ErrorSource) {
    ErrorSource["CONSOLE"] = "console";
    ErrorSource["WINDOW"] = "window";
    ErrorSource["UNHANDLED_REJECTION"] = "unhandledrejection";
    ErrorSource["DOCUMENT"] = "document";
    ErrorSource["CAPTURED"] = "captured";
    ErrorSource["WEB_WORKER"] = "web_worker";
})(ErrorSource || (ErrorSource = {}));
function parseStackFrames(err) {
    var stack = err.stack, message = err.message, name = err.name;
    if (!stack) return [];
    var sanitizedStack = stack.split('\n').map(function(line) {
        return line.slice(0, STACK_LINE_LIMIT);
    }).join('\n');
    return (0, (/*@__PURE__*/$parcel$interopDefault($djhfc))).parse({
        stack: sanitizedStack,
        message: message,
        name: name
    }).slice(0, STACK_FRAME_LIMIT).map(function(_a) {
        var fileName = _a.fileName, columnNumber = _a.columnNumber, lineNumber = _a.lineNumber, functionName = _a.functionName;
        return {
            fileName: fileName,
            columnNumber: columnNumber,
            lineNumber: lineNumber,
            functionName: functionName
        };
    });
}
function buildStacktrace(span, err) {
    return (0, $8yqJh.__awaiter)(this, void 0, void 0, function() {
        var stackFrames, supportMfe;
        return (0, $8yqJh.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    stackFrames = parseStackFrames(err);
                    if (stackFrames.length === 0) return [
                        2
                    ];
                    supportMfe = getSdkConfig().supportMfe;
                    if (!supportMfe) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        handleMFE(stackFrames, span)
                    ];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    span[ErrorAttributes.STACK] = stackFrames;
                    return [
                        2
                    ];
            }
        });
    });
}
function handleMFE(stackFrames, span) {
    return (0, $8yqJh.__awaiter)(this, void 0, void 0, function() {
        var i, metadata, _a, lastFrame;
        return (0, $8yqJh.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    i = 0;
                    _b.label = 1;
                case 1:
                    if (!(i < stackFrames.length)) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        extractMetadataFromMfeStacktrace(stackFrames[i].fileName)
                    ];
                case 2:
                    metadata = _b.sent();
                    stackFrames[i] = (0, $8yqJh.__assign)((0, $8yqJh.__assign)({}, stackFrames[i]), metadata || {
                        isShell: true
                    });
                    _b.label = 3;
                case 3:
                    i++;
                    return [
                        3,
                        1
                    ];
                case 4:
                    _a = (0, $8yqJh.__read)(stackFrames, 1), lastFrame = _a[0];
                    addLabelForMFE(span, lastFrame);
                    return [
                        2
                    ];
            }
        });
    });
}
function addLabelForMFE(span, lastFrame) {
    var app = lastFrame.app, version = lastFrame.version, isShell = lastFrame.isShell;
    if (!isShell) setCustomLabelsForSpan(span, {
        mfeApp: app,
        mfeVersion: version
    });
}
function extractMetadataFromMfeStacktrace() {
    return (0, $8yqJh.__awaiter)(this, arguments, void 0, function(fileName) {
        var metadata, cachedMetadata, MFE_METADATA_KEY, mfePath, response, _a, e_1;
        if (fileName === void 0) fileName = '';
        return (0, $8yqJh.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    cachedMetadata = CxGlobal[CACHED_METADATA_KEY];
                    MFE_METADATA_KEY = 'cx-metadata.json';
                    mfePath = extractMfePath(fileName);
                    if (!mfePath) return [
                        3,
                        7
                    ];
                    response = void 0;
                    if (!!(cachedMetadata === null || cachedMetadata === void 0 ? void 0 : cachedMetadata.has(mfePath))) return [
                        3,
                        6
                    ];
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        fetch("".concat(mfePath).concat(MFE_METADATA_KEY), {
                            cache: 'no-cache'
                        })
                    ];
                case 2:
                    response = _b.sent();
                    _a = [
                        {}
                    ];
                    return [
                        4,
                        response.json()
                    ];
                case 3:
                    metadata = (0, $8yqJh.__assign).apply(void 0, [
                        (0, $8yqJh.__assign).apply(void 0, _a.concat([
                            _b.sent()
                        ])),
                        {
                            mfePath: mfePath
                        }
                    ]);
                    return [
                        3,
                        5
                    ];
                case 4:
                    e_1 = _b.sent();
                    if (getSdkConfig().debug) console.warn('Coralogix Browser SDK - Error fetching metadata', e_1);
                    return [
                        3,
                        5
                    ];
                case 5:
                    CxGlobal[CACHED_METADATA_KEY] = cachedMetadata.set(mfePath, metadata);
                    return [
                        3,
                        7
                    ];
                case 6:
                    metadata = cachedMetadata === null || cachedMetadata === void 0 ? void 0 : cachedMetadata.get(mfePath);
                    _b.label = 7;
                case 7:
                    return [
                        2,
                        metadata
                    ];
            }
        });
    });
}
var _consoleErrorHandler = function(errorInstrumentation) {
    return function(original) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var stackContextError = new Error();
            errorInstrumentation.report(ErrorSource.CONSOLE, args, stackContextError);
            return original.apply(console, args);
        };
    };
};
var _errorListener = function(that) {
    return function(event) {
        that.report(ErrorSource.WINDOW, event);
    };
};
var _unhandledRejectionListener = function(that) {
    return function(event) {
        that.report(ErrorSource.UNHANDLED_REJECTION, event.reason);
    };
};
var _documentErrorListener = function(that) {
    return function(event) {
        that.report(ErrorSource.DOCUMENT, event);
    };
};
function addErrorDefaultAttributes(span) {
    span.setAttribute(CoralogixAttributes.EVENT_TYPE, CoralogixEventType.ERROR);
    span.setAttribute(CoralogixAttributes.SEVERITY, CoralogixLogSeverity.Error);
}
var CoralogixErrorInstrumentation = function(_super) {
    (0, $8yqJh.__extends)(CoralogixErrorInstrumentation, _super);
    function CoralogixErrorInstrumentation(config) {
        var _this = _super.call(this, ERROR_INSTRUMENTATION_NAME, ERROR_INSTRUMENTATION_VERSION, config) || this;
        _this.parseErrorObject = function(obj) {
            var _a;
            try {
                return (_a = obj === null || obj === void 0 ? void 0 : obj.message) !== null && _a !== void 0 ? _a : JSON.stringify(obj, getCircularReplacer());
            } catch (_b) {
                return obj === null || obj === void 0 ? void 0 : obj.toString();
            }
        };
        if (getSdkConfig().supportMfe) CxGlobal[CACHED_METADATA_KEY] = new Map();
        return _this;
    }
    CoralogixErrorInstrumentation.prototype.init = function() {};
    CoralogixErrorInstrumentation.prototype.enable = function() {
        var stackTraceLimit = getSdkConfig().stackTraceLimit;
        if (stackTraceLimit) Error.stackTraceLimit = stackTraceLimit;
        shimmer_1.wrap(console, 'error', _consoleErrorHandler(this));
        CxGlobal.addEventListener('error', _errorListener(this));
        CxGlobal.addEventListener('unhandledrejection', _unhandledRejectionListener(this));
        document.documentElement.addEventListener('error', _documentErrorListener(this), {
            capture: true
        });
    };
    CoralogixErrorInstrumentation.prototype.disable = function() {
        shimmer_1.unwrap(console, 'error');
        CxGlobal.removeEventListener('error', _errorListener(this));
        CxGlobal.removeEventListener('unhandledrejection', _unhandledRejectionListener(this));
        document.documentElement.removeEventListener('error', _documentErrorListener(this), {
            capture: true
        });
    };
    CoralogixErrorInstrumentation.prototype.report = function(source, arg, stackContextError) {
        var _this = this;
        if (arg instanceof Array) {
            if (arg.length === 0) return;
        }
        switch(true){
            case arg instanceof Error:
                this.reportError(source, arg);
                break;
            case arg instanceof ErrorEvent:
                this.reportErrorEvent(source, arg);
                break;
            case arg instanceof Event:
                this.reportEvent(source, arg);
                break;
            case typeof arg === 'string':
                this.reportString(source, arg, stackContextError);
                break;
            case arg instanceof Array:
                var firstError = arg.find(function(x) {
                    return x instanceof Error;
                });
                var message = arg.map(function(msg) {
                    return typeof msg === 'string' ? msg : _this.parseErrorObject(msg);
                }).join(' ');
                var stackSourceError = firstError !== null && firstError !== void 0 ? firstError : stackContextError;
                this.reportString(source, message, stackSourceError);
                break;
            default:
                this.reportString(source, typeof arg === 'string' ? arg : this.getPossibleEventMessage(arg));
        }
    };
    CoralogixErrorInstrumentation.prototype.reportError = function(source, err, customData, labels) {
        return (0, $8yqJh.__awaiter)(this, void 0, void 0, function() {
            var message, name, span, cleanMessage, supportMfe;
            return (0, $8yqJh.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        message = err.message, name = err.name;
                        span = this.createSpan('error');
                        cleanMessage = message.split('\n')[0];
                        addErrorDefaultAttributes(span);
                        span.setAttribute(CoralogixAttributes.SOURCE, source);
                        span.setAttribute(ErrorAttributes.TYPE, name);
                        span.setAttribute(ErrorAttributes.MESSAGE, cleanMessage);
                        if (customData) span[ErrorAttributes.DATA] = JSON.stringify(customData, getCircularReplacer());
                        if (labels) setCustomLabelsForSpan(span, labels);
                        supportMfe = getSdkConfig().supportMfe;
                        if (!supportMfe) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            buildStacktrace(span, err)
                        ];
                    case 1:
                        _b.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        buildStacktrace(span, err);
                        _b.label = 3;
                    case 3:
                        span.end();
                        return [
                            2
                        ];
                }
            });
        });
    };
    CoralogixErrorInstrumentation.prototype.reportString = function(source, message, stackError) {
        return (0, $8yqJh.__awaiter)(this, void 0, void 0, function() {
            var span, supportMfe;
            return (0, $8yqJh.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        span = this.createSpan(source);
                        addErrorDefaultAttributes(span);
                        span.setAttribute(CoralogixAttributes.SOURCE, source);
                        span.setAttribute(ErrorAttributes.MESSAGE, message === null || message === void 0 ? void 0 : message.substring(0, MESSAGE_LIMIT));
                        supportMfe = getSdkConfig().supportMfe;
                        if (!stackError) return [
                            3,
                            4
                        ];
                        if (!supportMfe) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            buildStacktrace(span, stackError)
                        ];
                    case 1:
                        _b.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        buildStacktrace(span, stackError);
                        _b.label = 3;
                    case 3:
                        _b.label = 4;
                    case 4:
                        span.end();
                        return [
                            2
                        ];
                }
            });
        });
    };
    CoralogixErrorInstrumentation.prototype.reportErrorEvent = function(source, _a) {
        var error = _a.error, message = _a.message;
        var event = error !== null && error !== void 0 ? error : message;
        this.report(source, event);
    };
    CoralogixErrorInstrumentation.prototype.reportEvent = function(source, ev) {
        if (!ev.target) return;
        var span = this.createSpan(source);
        addErrorDefaultAttributes(span);
        span.setAttribute(CoralogixAttributes.SOURCE, source);
        if (ev.target) {
            span.setAttribute('target_element', ev.target.tagName);
            span.setAttribute('target_xpath', (0, $5neJ1.getElementXPath)(ev.target, true));
            span.setAttribute('target_src', ev.target.src);
        }
        span.end();
    };
    CoralogixErrorInstrumentation.prototype.createSpan = function(name) {
        var span;
        if (shouldAttachSpanToGlobalSpan(CoralogixEventType.ERROR)) span = attachChildSpanToGlobalSpan(name);
        else span = this.tracer.startSpan(name);
        return span;
    };
    CoralogixErrorInstrumentation.prototype.getPossibleEventMessage = function(event) {
        var _a = event || {}, message = _a.message, statusMessage = _a.statusMessage;
        if (message && typeof message === 'string') return message;
        if (statusMessage && typeof statusMessage === 'string') return statusMessage;
        return JSON.stringify(event);
    };
    return CoralogixErrorInstrumentation;
}((0, $fZlMi.InstrumentationBase));
var propagateTraceHeaderCorsUrls = function(config) {
    var _a;
    var traceParentInHeader = config.traceParentInHeader;
    var propagateCorsUrls = (_a = traceParentInHeader === null || traceParentInHeader === void 0 ? void 0 : traceParentInHeader.options) === null || _a === void 0 ? void 0 : _a.propagateTraceHeaderCorsUrls;
    if ((traceParentInHeader === null || traceParentInHeader === void 0 ? void 0 : traceParentInHeader.enabled) && propagateCorsUrls) config.propagateTraceHeaderCorsUrls = propagateCorsUrls;
};
var NetworkDataManager = function() {
    function NetworkDataManager() {
        var _this = this;
        this.responseBodyParsers = new Map([
            [
                MimeType.Json,
                function(body) {
                    return (0, $8yqJh.__awaiter)(_this, void 0, void 0, function() {
                        var _a, _b;
                        return (0, $8yqJh.__generator)(this, function(_c) {
                            switch(_c.label){
                                case 0:
                                    _b = (_a = JSON).stringify;
                                    return [
                                        4,
                                        body.json()
                                    ];
                                case 1:
                                    return [
                                        2,
                                        _b.apply(_a, [
                                            _c.sent()
                                        ])
                                    ];
                            }
                        });
                    });
                }
            ],
            [
                MimeType.TextPlain,
                function(body) {
                    return (0, $8yqJh.__awaiter)(_this, void 0, void 0, function() {
                        return (0, $8yqJh.__generator)(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    return [
                                        4,
                                        body.text()
                                    ];
                                case 1:
                                    return [
                                        2,
                                        _a.sent()
                                    ];
                            }
                        });
                    });
                }
            ],
            [
                MimeType.TextHtml,
                function(body) {
                    return (0, $8yqJh.__awaiter)(_this, void 0, void 0, function() {
                        return (0, $8yqJh.__generator)(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    return [
                                        4,
                                        body.text()
                                    ];
                                case 1:
                                    return [
                                        2,
                                        _a.sent()
                                    ];
                            }
                        });
                    });
                }
            ],
            [
                MimeType.TextCss,
                function(body) {
                    return (0, $8yqJh.__awaiter)(_this, void 0, void 0, function() {
                        return (0, $8yqJh.__generator)(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    return [
                                        4,
                                        body.text()
                                    ];
                                case 1:
                                    return [
                                        2,
                                        _a.sent()
                                    ];
                            }
                        });
                    });
                }
            ],
            [
                MimeType.TextJavascript,
                function(body) {
                    return (0, $8yqJh.__awaiter)(_this, void 0, void 0, function() {
                        return (0, $8yqJh.__generator)(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    return [
                                        4,
                                        body.text()
                                    ];
                                case 1:
                                    return [
                                        2,
                                        _a.sent()
                                    ];
                            }
                        });
                    });
                }
            ],
            [
                MimeType.Xml,
                function(body) {
                    return (0, $8yqJh.__awaiter)(_this, void 0, void 0, function() {
                        return (0, $8yqJh.__generator)(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    return [
                                        4,
                                        body.text()
                                    ];
                                case 1:
                                    return [
                                        2,
                                        _a.sent()
                                    ];
                            }
                        });
                    });
                }
            ],
            [
                MimeType.FormData,
                function(body) {
                    return (0, $8yqJh.__awaiter)(_this, void 0, void 0, function() {
                        return (0, $8yqJh.__generator)(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    return [
                                        4,
                                        body.text()
                                    ];
                                case 1:
                                    return [
                                        2,
                                        _a.sent()
                                    ];
                            }
                        });
                    });
                }
            ]
        ]);
        this.requestBodySerializers = new Map([
            [
                BodyType.String,
                function(body) {
                    return (0, $8yqJh.__awaiter)(_this, void 0, void 0, function() {
                        return (0, $8yqJh.__generator)(this, function(_a) {
                            return [
                                2,
                                body
                            ];
                        });
                    });
                }
            ],
            [
                BodyType.Blob,
                function(body) {
                    return (0, $8yqJh.__awaiter)(_this, void 0, void 0, function() {
                        return (0, $8yqJh.__generator)(this, function(_a) {
                            return [
                                2,
                                body.text()
                            ];
                        });
                    });
                }
            ],
            [
                BodyType.FormData,
                function(body) {
                    return (0, $8yqJh.__awaiter)(_this, void 0, void 0, function() {
                        return (0, $8yqJh.__generator)(this, function(_a) {
                            return [
                                2,
                                this.serializeFormData(body)
                            ];
                        });
                    });
                }
            ],
            [
                BodyType.URLSearchParams,
                function(body) {
                    return (0, $8yqJh.__awaiter)(_this, void 0, void 0, function() {
                        return (0, $8yqJh.__generator)(this, function(_a) {
                            return [
                                2,
                                body.toString()
                            ];
                        });
                    });
                }
            ],
            [
                BodyType.JsonObject,
                function(body) {
                    return (0, $8yqJh.__awaiter)(_this, void 0, void 0, function() {
                        return (0, $8yqJh.__generator)(this, function(_a) {
                            return [
                                2,
                                JSON.stringify(body)
                            ];
                        });
                    });
                }
            ]
        ]);
    }
    NetworkDataManager.prototype.resolveConfigForUrl = function(url, configs) {
        if (configs === void 0) configs = [];
        return configs.find(function(_a) {
            var configUrl = _a.url;
            return configUrl === url || configUrl instanceof RegExp && configUrl.test(url);
        });
    };
    NetworkDataManager.prototype.stringifyRequestBody = function(request) {
        return (0, $8yqJh.__awaiter)(this, void 0, void 0, function() {
            var bodyContent;
            return (0, $8yqJh.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!(request === null || request === void 0 ? void 0 : request.body)) return [
                            2,
                            ''
                        ];
                        return [
                            4,
                            this.serializeRequestBody(request.body)
                        ];
                    case 1:
                        bodyContent = _a.sent();
                        return [
                            2,
                            this.truncateIfExceedsLimit(bodyContent)
                        ];
                }
            });
        });
    };
    NetworkDataManager.prototype.stringifyResponseBody = function(response) {
        return (0, $8yqJh.__awaiter)(this, void 0, void 0, function() {
            var contentType, mimeType, parser, parsedContent;
            return (0, $8yqJh.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        contentType = response.headers.get('content-type') || '';
                        mimeType = contentType.split(';')[0].trim();
                        parser = this.responseBodyParsers.get(mimeType);
                        if (!parser) return [
                            2,
                            ''
                        ];
                        return [
                            4,
                            parser(response)
                        ];
                    case 1:
                        parsedContent = _a.sent();
                        return [
                            2,
                            this.truncateIfExceedsLimit(parsedContent)
                        ];
                }
            });
        });
    };
    NetworkDataManager.prototype.truncateIfExceedsLimit = function(content) {
        return content.length > MAX_CHARACTERS ? undefined : content;
    };
    NetworkDataManager.prototype.serializeRequestBody = function(body) {
        return (0, $8yqJh.__awaiter)(this, void 0, void 0, function() {
            var handler, _a;
            return (0, $8yqJh.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        handler = this.requestBodySerializers.get(body.constructor.name);
                        if (!handler) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            handler(body)
                        ];
                    case 1:
                        _a = _b.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        _a = '';
                        _b.label = 3;
                    case 3:
                        return [
                            2,
                            _a
                        ];
                }
            });
        });
    };
    NetworkDataManager.prototype.serializeFormData = function(formData) {
        var result = '';
        formData.forEach(function(value, key) {
            result += "".concat(key, ": ").concat(value, "\n");
        });
        return result.trim();
    };
    return NetworkDataManager;
}();
var MimeType;
(function(MimeType) {
    MimeType["Json"] = "application/json";
    MimeType["TextPlain"] = "text/plain";
    MimeType["TextHtml"] = "text/html";
    MimeType["TextCss"] = "text/css";
    MimeType["TextJavascript"] = "application/javascript";
    MimeType["Xml"] = "application/xml";
    MimeType["FormData"] = "multipart/form-data";
})(MimeType || (MimeType = {}));
var BodyType;
(function(BodyType) {
    BodyType["String"] = "String";
    BodyType["Blob"] = "Blob";
    BodyType["FormData"] = "FormData";
    BodyType["URLSearchParams"] = "URLSearchParams";
    BodyType["JsonObject"] = "JsonObject";
    BodyType["Unknown"] = "Unknown";
})(BodyType || (BodyType = {}));
var HeadersManager = function() {
    function HeadersManager() {}
    HeadersManager.prototype.filterHeaders = function(headersInit, allowedKeys) {
        if (allowedKeys === void 0) allowedKeys = [];
        if (!headersInit) return new Map();
        var normalized = this.normalizeHeaders(headersInit);
        var filteredHeaders = new Map();
        allowedKeys.forEach(function(headerKey) {
            var normalizedKey = headerKey.toLowerCase();
            if (normalized.has(normalizedKey)) filteredHeaders.set(headerKey, normalized.get(normalizedKey));
        });
        return filteredHeaders;
    };
    HeadersManager.prototype.normalizeHeaders = function(headersInit) {
        if (typeof headersInit === 'string') return this.normalizeHeadersFromString(headersInit);
        var headers = new Headers(headersInit);
        var headersMap = new Map();
        headers.forEach(function(value, key) {
            headersMap.set(key.toLowerCase(), value);
        });
        return headersMap;
    };
    HeadersManager.prototype.normalizeHeadersFromString = function(headersString) {
        var headerMap = new Map();
        if (!headersString) return headerMap;
        var lines = headersString.trim().split(/\r\n/);
        lines.forEach(function(line) {
            var _a = (0, $8yqJh.__read)(line.split(': ', 2), 2), key = _a[0], value = _a[1];
            if (key && value) headerMap.set(key.trim().toLowerCase(), value.trim());
        });
        return headerMap;
    };
    return HeadersManager;
}();
var NetworkInstrumentationAttributes = {
    REQUEST_HEADERS: 'request_headers',
    RESPONSE_HEADERS: 'response_headers',
    RESPONSE_PAYLOAD: 'response_payload',
    REQUEST_PAYLOAD: 'request_payload'
};
function checkAttachingNetworkSpanToGlobalSpan(span) {
    var activeGlobalSpan = getGlobalSpanByTraceId(span.spanContext().traceId);
    if (activeGlobalSpan && !isInstrumentationIgnored(CoralogixEventType.NETWORK_REQUEST)) {
        var _a = activeGlobalSpan.span.spanContext(), traceId = _a.traceId, globalSpanId = _a.spanId;
        span['_spanContext'].traceId = traceId;
        span['parentSpanId'] = globalSpanId;
    }
}
var FetchSource;
(function(FetchSource) {
    FetchSource["FETCH"] = "fetch";
})(FetchSource || (FetchSource = {}));
var CoralogixFetchInstrumentation = function(_super) {
    (0, $8yqJh.__extends)(CoralogixFetchInstrumentation, _super);
    function CoralogixFetchInstrumentation(config) {
        var _this = this;
        propagateTraceHeaderCorsUrls(config);
        config.applyCustomAttributesOnSpan = function(span, request, result) {
            markSpanAsOtelToSend(span);
            checkAttachingNetworkSpanToGlobalSpan(span);
            _this.setNetworkSpanAttributes(span, request, result);
        };
        _this = _super.call(this, config) || this;
        _this.networkDataManager = new NetworkDataManager();
        _this.headersManager = new HeadersManager();
        return _this;
    }
    CoralogixFetchInstrumentation.prototype.setNetworkSpanAttributes = function(span, request, response) {
        return (0, $8yqJh.__awaiter)(this, void 0, void 0, function() {
            var status, networkExtraConfig, url, resolvedConfig;
            var _a;
            return (0, $8yqJh.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (!span.isRecording()) return [
                            2
                        ];
                        status = response.status;
                        networkExtraConfig = getSdkConfig().networkExtraConfig;
                        url = span.attributes['http.url'] || '';
                        resolvedConfig = this.networkDataManager.resolveConfigForUrl(url, networkExtraConfig);
                        if (!resolvedConfig) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            this.setRequestAttributes(span, request, resolvedConfig)
                        ];
                    case 1:
                        _b.sent();
                        return [
                            4,
                            this.setResponseAttributes(span, response, resolvedConfig)
                        ];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3:
                        span.setAttributes((_a = {}, _a[CoralogixAttributes.SEVERITY] = isNetworkError(status) ? CoralogixLogSeverity.Error : CoralogixLogSeverity.Info, _a[CoralogixAttributes.EVENT_TYPE] = CoralogixEventType.NETWORK_REQUEST, _a[CoralogixAttributes.SOURCE] = FetchSource.FETCH, _a));
                        return [
                            2
                        ];
                }
            });
        });
    };
    CoralogixFetchInstrumentation.prototype.setRequestAttributes = function(span, request, networkExtraConfig) {
        return (0, $8yqJh.__awaiter)(this, void 0, void 0, function() {
            var reqHeaders, collectReqPayload, requestPayload, _a, sanitizedHeaders, error_1;
            return (0, $8yqJh.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        reqHeaders = networkExtraConfig.reqHeaders, collectReqPayload = networkExtraConfig.collectReqPayload;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        if (!collectReqPayload) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            this.networkDataManager.stringifyRequestBody(request)
                        ];
                    case 2:
                        _a = _b.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        _a = undefined;
                        _b.label = 4;
                    case 4:
                        requestPayload = _a;
                        sanitizedHeaders = (reqHeaders === null || reqHeaders === void 0 ? void 0 : reqHeaders.length) ? this.headersManager.filterHeaders(request.headers, reqHeaders) : undefined;
                        if (requestPayload) span[NetworkInstrumentationAttributes.REQUEST_PAYLOAD] = requestPayload;
                        if (sanitizedHeaders === null || sanitizedHeaders === void 0 ? void 0 : sanitizedHeaders.size) span[NetworkInstrumentationAttributes.REQUEST_HEADERS] = Object.fromEntries(sanitizedHeaders);
                        return [
                            3,
                            6
                        ];
                    case 5:
                        error_1 = _b.sent();
                        if (getSdkConfig().debug) console.debug('Error setting request attributes on span:', error_1);
                        return [
                            3,
                            6
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
    };
    CoralogixFetchInstrumentation.prototype.setResponseAttributes = function(span, result, networkExtraConfig) {
        return (0, $8yqJh.__awaiter)(this, void 0, void 0, function() {
            var resHeaders, collectResPayload, responsePayload, _a, sanitizedHeaders, error_2;
            return (0, $8yqJh.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        resHeaders = networkExtraConfig.resHeaders, collectResPayload = networkExtraConfig.collectResPayload;
                        if (!(result instanceof Response)) return [
                            3,
                            6
                        ];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        if (!collectResPayload) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            this.networkDataManager.stringifyResponseBody(result)
                        ];
                    case 2:
                        _a = _b.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        _a = undefined;
                        _b.label = 4;
                    case 4:
                        responsePayload = _a;
                        sanitizedHeaders = (resHeaders === null || resHeaders === void 0 ? void 0 : resHeaders.length) ? this.headersManager.filterHeaders(result.headers, resHeaders) : undefined;
                        if (responsePayload) span[NetworkInstrumentationAttributes.RESPONSE_PAYLOAD] = responsePayload;
                        if (sanitizedHeaders === null || sanitizedHeaders === void 0 ? void 0 : sanitizedHeaders.size) span[NetworkInstrumentationAttributes.RESPONSE_HEADERS] = Object.fromEntries(sanitizedHeaders);
                        return [
                            3,
                            6
                        ];
                    case 5:
                        error_2 = _b.sent();
                        if (getSdkConfig().debug) console.debug('Error setting request attributes on span:', error_2);
                        return [
                            3,
                            6
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
    };
    CoralogixFetchInstrumentation.prototype.disable = function() {};
    return CoralogixFetchInstrumentation;
}((0, $6mRKV.FetchInstrumentation));
var XHRSource;
(function(XHRSource) {
    XHRSource["XHR"] = "xhr";
})(XHRSource || (XHRSource = {}));
var CoralogixXhrInstrumentation = function(_super) {
    (0, $8yqJh.__extends)(CoralogixXhrInstrumentation, _super);
    function CoralogixXhrInstrumentation(config) {
        var _this = this;
        propagateTraceHeaderCorsUrls(config);
        config.applyCustomAttributesOnSpan = function(span, xhr) {
            markSpanAsOtelToSend(span);
            checkAttachingNetworkSpanToGlobalSpan(span);
            _this.setNetworkSpanAttributes(span, xhr);
        };
        _this = _super.call(this, config) || this;
        _this.networkDataManager = new NetworkDataManager();
        _this.headersManager = new HeadersManager();
        return _this;
    }
    CoralogixXhrInstrumentation.prototype.setNetworkSpanAttributes = function(span, xhr) {
        var _a;
        if (!span.isRecording()) return;
        var status = xhr.status;
        var networkExtraConfig = getSdkConfig().networkExtraConfig;
        var resolvedConfig = this.networkDataManager.resolveConfigForUrl(xhr.responseURL, networkExtraConfig);
        span.setAttributes((_a = {}, _a[CoralogixAttributes.SEVERITY] = isNetworkError(status) ? CoralogixLogSeverity.Error : CoralogixLogSeverity.Info, _a[CoralogixAttributes.EVENT_TYPE] = CoralogixEventType.NETWORK_REQUEST, _a[CoralogixAttributes.SOURCE] = XHRSource.XHR, _a));
        if (resolvedConfig) this.setResponseAttributes(span, xhr, resolvedConfig);
    };
    CoralogixXhrInstrumentation.prototype.setResponseAttributes = function(span, xhr, resolvedConfig) {
        var resHeaders = resolvedConfig.resHeaders, collectResPayload = resolvedConfig.collectResPayload;
        var responsePayload = collectResPayload ? this.networkDataManager.truncateIfExceedsLimit(xhr.responseText) : undefined;
        var sanitizedHeaders = (resHeaders === null || resHeaders === void 0 ? void 0 : resHeaders.length) ? this.headersManager.filterHeaders(xhr.getAllResponseHeaders(), resHeaders) : undefined;
        if (responsePayload) span[NetworkInstrumentationAttributes.RESPONSE_PAYLOAD] = responsePayload;
        if (sanitizedHeaders === null || sanitizedHeaders === void 0 ? void 0 : sanitizedHeaders.size) span[NetworkInstrumentationAttributes.RESPONSE_HEADERS] = Object.fromEntries(sanitizedHeaders);
    };
    CoralogixXhrInstrumentation.prototype.disable = function() {};
    return CoralogixXhrInstrumentation;
}((0, $gILhI.XMLHttpRequestInstrumentation));
var CUSTOM_INSTRUMENTATION_VERSION = '1';
var LogSource;
(function(LogSource) {
    LogSource["CODE"] = "code";
})(LogSource || (LogSource = {}));
var CoralogixCustomLogInstrumentation = function(_super) {
    (0, $8yqJh.__extends)(CoralogixCustomLogInstrumentation, _super);
    function CoralogixCustomLogInstrumentation(config) {
        var _a;
        var _this = _super.call(this, CoralogixEventType.LOG, CUSTOM_INSTRUMENTATION_VERSION, config) || this;
        _this.stringifyCustomLogData = (_a = getSdkConfig()) === null || _a === void 0 ? void 0 : _a.stringifyCustomLogData;
        return _this;
    }
    CoralogixCustomLogInstrumentation.prototype.init = function() {};
    CoralogixCustomLogInstrumentation.prototype.disable = function() {};
    CoralogixCustomLogInstrumentation.prototype.enable = function() {};
    CoralogixCustomLogInstrumentation.prototype.log = function(_a) {
        var severity = _a.severity, message = _a.message, data = _a.data, labels = _a.labels;
        var span = this.tracer.startSpan(CoralogixEventType.LOG);
        span.setAttribute(CoralogixAttributes.EVENT_TYPE, CoralogixEventType.LOG);
        span.setAttribute(CoralogixAttributes.SOURCE, LogSource.CODE);
        span.setAttribute(CoralogixAttributes.SEVERITY, severity);
        span.setAttribute(CoralogixAttributes.LOG, JSON.stringify({
            severity: severity,
            message: message,
            data: this.stringifyCustomLogData ? JSON.stringify(data, getCircularReplacer()) : data
        }));
        if (labels) setCustomLabelsForSpan(span, labels);
        span.end();
    };
    return CoralogixCustomLogInstrumentation;
}((0, $fZlMi.InstrumentationBase));
function isNil(value) {
    return value == null;
}
function coerceArray(value) {
    if (isNil(value)) return [];
    if (value instanceof Set) return (0, $8yqJh.__spreadArray)([], (0, $8yqJh.__read)(value), false);
    return Array.isArray(value) ? value : [
        value
    ];
}
function isObject(value) {
    return typeof value === 'object';
}
function omit(object) {
    if (object === void 0) object = {};
    var paths = [];
    for(var _i = 1; _i < arguments.length; _i++)paths[_i - 1] = arguments[_i];
    if (isNil(object)) return {};
    var omitter = function(source, pathArray) {
        var _a;
        var _b = (0, $8yqJh.__read)(pathArray), firstKey = _b[0], remainingKeys = _b.slice(1);
        if (!source.hasOwnProperty(firstKey)) return source;
        if (!remainingKeys.length) {
            var _c = source, _d = firstKey;
            _c[_d];
            var rest = (0, $8yqJh.__rest)(_c, [
                typeof _d === "symbol" ? _d : _d + ""
            ]);
            return rest;
        }
        return (0, $8yqJh.__assign)((0, $8yqJh.__assign)({}, source), (_a = {}, _a[firstKey] = omitter(source[firstKey], remainingKeys), _a));
    };
    return coerceArray(paths).reduce(function(result, path) {
        return omitter(result, path.split('.'));
    }, object);
}
function isEmpty(value) {
    if (isNil(value)) return true;
    if (value instanceof Set || value instanceof Map) return value.size === 0;
    if (Array.isArray(value) || typeof value === 'string') return value.length === 0;
    if (isObject(value)) return Object.keys(value).length === 0;
    return false;
}
function isNotEmpty(value) {
    return !isEmpty(value);
}
var WEB_VITALS_INSTRUMENTATION_NAME = 'web_vitals';
var WEB_VITALS_INSTRUMENTATION_VERSION = '1.0.0';
var LONG_TASK_INSTRUMENTATION_VERSION = '1.0.0';
var LONG_TASKS_INSTRUMENTATION_NAME = 'long_tasks';
var RESOURCES_INSTRUMENTATION_NAME = 'resources';
var RESOURCES_INSTRUMENTATION_VERSION = '1.0.0';
var DOM_INSTRUMENTATION_NAME = 'dom';
var DOM_INSTRUMENTATION_VERSION = '1.0.0';
var CUSTOM_MEASUREMENT_INSTRUMENTATION_NAME = 'custom_measurement';
var CUSTOM_MEASUREMENT_INSTRUMENTATION_VERSION = '1.0.0';
var WORKER_INSTRUMENTATION = 'web_worker';
var WORKER_INSTRUMENTATION_VERSION = '1.0.0';
var XHR_INSTRUMENTATION_NAME = 'xhr';
var FETCH_INSTRUMENTATION_NAME = 'fetch';
var CUSTOM_INSTRUMENTATION_NAME = 'custom';
var SESSION_RECORDING_INSTRUMENTATION_NAME = 'session_recording';
var ALL_WEB_VITALS_METRICS = {
    lcp: true,
    fid: true,
    cls: true,
    fcp: true,
    inp: true,
    ttfb: true,
    tbt: false,
    lt: true
};
var LONGTASK_DURATION = 50;
var INTERNAL_INSTRUMENTATION_NAME = 'internal';
var FONTS_URL = 'fonts.googleapis.com';
var CSS_EXTENSIONS = [
    '.css'
];
var OTHER_EXTENSIONS = [
    '.wasm',
    '.manifest'
];
var SCRIPT_EXTENSIONS = [
    '.js',
    '.mjs'
];
var MEDIA_EXTENSIONS = [
    '.mp3',
    '.mp4',
    '.wav',
    '.ogg',
    '.webm',
    '.avi'
];
var DOC_EXTENSIONS = [
    '.pdf',
    '.doc',
    '.docx',
    '.ppt',
    '.pptx',
    '.xls',
    '.xlsx',
    '.csv',
    '.html'
];
var FONT_EXTENSIONS = [
    '.woff',
    '.woff2',
    '.ttf',
    '.otf',
    '.eot'
];
var IMG_EXTENSIONS = [
    '.svg',
    '.jpg',
    '.png',
    '.jpeg',
    '.bmp',
    '.webp'
];
function getBrowserWindow() {
    return CxGlobal;
}
function shouldRunOutsideZone() {
    var _a;
    return ((_a = getSdkConfig()) === null || _a === void 0 ? void 0 : _a.runOutsideAngularZone) !== false;
}
function getZoneJsOriginalDom(target, name) {
    if (!shouldRunOutsideZone()) return target[name];
    var browserWindow = getBrowserWindow();
    var original;
    if (browserWindow.Zone && typeof browserWindow.Zone.__symbol__ === 'function') original = target[browserWindow.Zone.__symbol__(name)];
    if (!original) original = target[name];
    return original;
}
function cxSetTimeout(callback, delay) {
    var browserWindow = getBrowserWindow();
    var originalSetTimeout = getZoneJsOriginalDom(browserWindow, 'setTimeout');
    return originalSetTimeout.call(browserWindow, callback, delay);
}
function cxSetInterval(callback, delay) {
    var browserWindow = getBrowserWindow();
    var originalSetInterval = getZoneJsOriginalDom(browserWindow, 'setInterval');
    return originalSetInterval.call(browserWindow, callback, delay);
}
function cxClearTimeout(id) {
    var browserWindow = getBrowserWindow();
    var originalClearTimeout = getZoneJsOriginalDom(browserWindow, 'clearTimeout');
    originalClearTimeout.call(browserWindow, id);
}
function cxClearInterval(id) {
    var browserWindow = getBrowserWindow();
    var originalClearInterval = getZoneJsOriginalDom(browserWindow, 'clearInterval');
    originalClearInterval.call(browserWindow, id);
}
function cxRequestAnimationFrame(callback) {
    var browserWindow = getBrowserWindow();
    var originalRaf = getZoneJsOriginalDom(browserWindow, 'requestAnimationFrame');
    return originalRaf.call(browserWindow, callback);
}
function cxCancelAnimationFrame(id) {
    var browserWindow = getBrowserWindow();
    var originalCaf = getZoneJsOriginalDom(browserWindow, 'cancelAnimationFrame');
    originalCaf.call(browserWindow, id);
}
function createCxMutationObserver(callback) {
    var browserWindow = getBrowserWindow();
    var OriginalMutationObserver = getZoneJsOriginalDom(browserWindow, 'MutationObserver');
    return new OriginalMutationObserver(callback);
}
/** Original source: https://www.npmjs.com/package/tti-polyfill?activeTab=code
 * @license Apache-2.0
 * @version 0.2.2
 * @description A polyfill for the Time to Interactive metric -
 * We decide to fork this package instead of installing it from npm
 * because it's not maintained anymore, and we want to have control over the codebase.
 * Also, we don't want to have a dependency on a package that is not maintained.
 */ var h = 'undefined' != typeof CxGlobal ? CxGlobal : {}, k = 'function' == typeof Object.defineProperties ? Object.defineProperty : function(a, b, c) {
    a != Array.prototype && a != Object.prototype && (a[b] = c.value);
};
function l() {
    l = function l() {};
    h.Symbol || (h.Symbol = m);
}
var n = 0;
function m(a) {
    return 'jscomp_symbol_' + (a || '') + n++;
}
function p() {
    l();
    var a = h.Symbol.iterator;
    a || (a = h.Symbol.iterator = h.Symbol('iterator'));
    'function' != typeof Array.prototype[a] && k(Array.prototype, a, {
        configurable: true,
        writable: true,
        value: function value() {
            return q(this);
        }
    });
    p = function p() {};
}
function q(a) {
    var b = 0;
    return r(function() {
        return b < a.length ? {
            done: false,
            value: a[b++]
        } : {
            done: true
        };
    });
}
function r(a) {
    p();
    a = {
        next: a
    };
    a[h.Symbol.iterator] = function() {
        return this;
    };
    return a;
}
function t(a) {
    p();
    var b = a[Symbol.iterator];
    return b ? b.call(a) : q(a);
}
function u(a) {
    if (!(a instanceof Array)) {
        a = t(a);
        for(var b, c = []; !(b = a.next()).done;)c.push(b.value);
        a = c;
    }
    return a;
}
var v = 0;
function w(a, b) {
    var c = XMLHttpRequest.prototype.send, d = v++;
    XMLHttpRequest.prototype.send = function(f) {
        for(var e = [], g = 0; g < arguments.length; ++g)e[g - 0] = arguments[g];
        var E = this;
        a(d);
        this.addEventListener('readystatechange', function() {
            4 === E.readyState && b(d);
        });
        return c.apply(this, e);
    };
}
function x(a, b) {
    var c = fetch;
    fetch = function fetch1(d) {
        for(var f = [], e = 0; e < arguments.length; ++e)f[e - 0] = arguments[e];
        return new Promise(function(d, e) {
            var g = v++;
            a(g);
            c.apply(null, [].concat(u(f))).then(function(a) {
                b(g);
                d(a);
            }, function(a) {
                b(a);
                e(a);
            });
        });
    };
}
var y = 'img script iframe link audio video source'.split(' ');
function z(a, b) {
    a = t(a);
    for(var c = a.next(); !c.done; c = a.next())if (c = c.value, b.includes(c.nodeName.toLowerCase()) || z(c.children, b)) return true;
    return false;
}
function A(a) {
    var b = createCxMutationObserver(function(c) {
        c = t(c);
        for(var b = c.next(); !b.done; b = c.next())b = b.value, 'childList' == b.type && z(b.addedNodes, y) ? a(b) : 'attributes' == b.type && y.includes(b.target.tagName.toLowerCase()) && a(b);
    });
    b.observe(document, {
        attributes: true,
        childList: true,
        subtree: true,
        attributeFilter: [
            'href',
            'src'
        ]
    });
    return b;
}
function B(a, b) {
    if (2 < a.length) return performance.now();
    var c = [];
    b = t(b);
    for(var d = b.next(); !d.done; d = b.next())d = d.value, c.push({
        timestamp: d.start,
        type: 'requestStart'
    }), c.push({
        timestamp: d.end,
        type: 'requestEnd'
    });
    b = t(a);
    for(d = b.next(); !d.done; d = b.next())c.push({
        timestamp: d.value,
        type: 'requestStart'
    });
    c.sort(function(a, b) {
        return a.timestamp - b.timestamp;
    });
    a = a.length;
    for(b = c.length - 1; 0 <= b; b--)switch(d = c[b], d.type){
        case 'requestStart':
            a--;
            break;
        case 'requestEnd':
            a++;
            if (2 < a) return d.timestamp;
            break;
        default:
            throw Error('Internal Error: This should never happen');
    }
    return 0;
}
function C(a) {
    a = a ? a : {};
    this.w = !!a.useMutationObserver;
    this.u = a.minValue || null;
    a = CxGlobal.__tti && CxGlobal.__tti.e;
    var b = CxGlobal.__tti && CxGlobal.__tti.o;
    this.a = a ? a.map(function(a) {
        return {
            start: a.startTime,
            end: a.startTime + a.duration
        };
    }) : [];
    b && b.disconnect();
    this.b = [];
    this.f = new Map();
    this.j = null;
    this.v = -Infinity;
    this.i = false;
    this.h = this.c = this.s = null;
    w(this.m.bind(this), this.l.bind(this));
    x(this.m.bind(this), this.l.bind(this));
    D(this);
    this.w && (this.h = A(this.B.bind(this)));
}
C.prototype.getFirstConsistentlyInteractive = function() {
    var a = this;
    return new Promise(function(b) {
        a.s = b;
        'complete' == document.readyState ? F(a) : CxGlobal.addEventListener('load', function() {
            F(a);
        });
    });
};
function F(a) {
    a.i = true;
    var b = 0 < a.a.length ? a.a[a.a.length - 1].end : 0, c = B(a.g, a.b);
    G(a, Math.max(c + 5e3, b));
}
function G(a, b) {
    !a.i || a.v > b || (cxClearTimeout(a.j), a.j = cxSetTimeout(function() {
        var b = performance.timing.navigationStart, d = B(a.g, a.b), b = (CxGlobal.a && CxGlobal.a.A ? 1e3 * CxGlobal.a.A().C - b : 0) || performance.timing.domContentLoadedEventEnd - b;
        if (a.u) var f = a.u;
        else performance.timing.domContentLoadedEventEnd ? (f = performance.timing, f = f.domContentLoadedEventEnd - f.navigationStart) : f = null;
        var e = performance.now();
        null === f && G(a, Math.max(d + 5e3, e + 1e3));
        var g = a.a;
        5e3 > e - d ? d = null : (d = g.length ? g[g.length - 1].end : b, d = 5e3 > e - d ? null : Math.max(d, f));
        d && (a.s(d), cxClearTimeout(a.j), a.i = false, a.c && a.c.disconnect(), a.h && a.h.disconnect());
        G(a, performance.now() + 1e3);
    }, b - performance.now()), a.v = b);
}
function D(a) {
    a.c = new PerformanceObserver(function(b) {
        b = t(b.getEntries());
        for(var c = b.next(); !c.done; c = b.next())if (c = c.value, 'resource' === c.entryType && (a.b.push({
            start: c.fetchStart,
            end: c.responseEnd
        }), G(a, B(a.g, a.b) + 5e3)), 'longtask' === c.entryType) {
            var d = c.startTime + c.duration;
            a.a.push({
                start: c.startTime,
                end: d
            });
            G(a, d + 5e3);
        }
    });
    a.c.observe({
        entryTypes: [
            'longtask',
            'resource'
        ]
    });
}
C.prototype.m = function(a) {
    this.f.set(a, performance.now());
};
C.prototype.l = function(a) {
    this.f["delete"](a);
};
C.prototype.B = function() {
    G(this, performance.now() + 5e3);
};
h.Object.defineProperties(C.prototype, {
    g: {
        configurable: true,
        enumerable: true,
        get: function get() {
            return [].concat(u(this.f.values()));
        }
    }
});
var H = {
    getFirstConsistentlyInteractive: function getFirstConsistentlyInteractive() {
        var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
        a = a ? a : {};
        return 'PerformanceLongTaskTiming' in CxGlobal ? new C(a).getFirstConsistentlyInteractive() : Promise.resolve(null);
    }
};
function observeIfSupported(observer, entryType) {
    if (!isPerformanceObserverSupported()) return;
    try {
        observer.observe({
            type: entryType,
            buffered: true
        });
    } catch (error) {
        observer.observe({
            entryTypes: [
                entryType
            ]
        });
    }
}
function isPerformanceObserverSupported() {
    var _a;
    if (!((_a = CxGlobal === null || CxGlobal === void 0 ? void 0 : CxGlobal.PerformanceObserver) === null || _a === void 0 ? void 0 : _a.supportedEntryTypes)) {
        console.warn('Coralogix Browser SDK  - browser does not support the required APIs ');
        return false;
    }
    return true;
}
var CoralogixWebVitalsInstrumentation = function(_super) {
    (0, $8yqJh.__extends)(CoralogixWebVitalsInstrumentation, _super);
    function CoralogixWebVitalsInstrumentation(config) {
        var _this = _super.call(this, WEB_VITALS_INSTRUMENTATION_NAME, WEB_VITALS_INSTRUMENTATION_VERSION, config) || this;
        _this.observers = [];
        _this.isSoftNavsEnabled = getSdkConfig().trackSoftNavigations;
        _this.onReport = function(metric) {
            if (!metric) return;
            if (metric.name === 'FCP') _this.registerToTBTMetric();
            var webVitalsSpan = _this.tracer.startSpan(CoralogixEventType.WEB_VITALS);
            var metricData = metric.entries ? omit(metric, 'entries') : metric;
            metricData = omit(metricData, 'attribution.navigationEntry');
            if (metricData.name === 'INP') metricData = omit(metricData, 'attribution');
            webVitalsSpan.setAttribute(CoralogixAttributes.EVENT_TYPE, CoralogixEventType.WEB_VITALS);
            webVitalsSpan.setAttribute(WEB_VITALS_INSTRUMENTATION_NAME, JSON.stringify(metricData, getCircularReplacer()));
            webVitalsSpan.end();
        };
        _this.metrics = isEmpty(config.metrics) ? ALL_WEB_VITALS_METRICS : (0, $8yqJh.__assign)((0, $8yqJh.__assign)({}, ALL_WEB_VITALS_METRICS), config.metrics);
        if (!isPerformanceObserverSupported()) return _this;
        _this.registerToCoreWebVitalMetrics();
        _this.registerToCalculatedWebVitalMetrics();
        if (_this.isSoftNavsEnabled) _this.registerToSoftNavigations();
        return _this;
    }
    CoralogixWebVitalsInstrumentation.prototype.registerToCoreWebVitalMetrics = function() {
        var shouldReportSoftNavs = this.isSoftNavsEnabled && supportedPerformanceTypes.has(PerformanceTypes.SoftNavigation);
        if (this.metrics.fid) (0, $kTKKO.onFID)(this.onReport);
        if (this.metrics.cls) (0, $kTKKO.onCLS)(this.onReport, {
            reportSoftNavs: shouldReportSoftNavs
        });
        if (this.metrics.lcp) (0, $kTKKO.onLCP)(this.onReport, {
            reportSoftNavs: shouldReportSoftNavs
        });
        if (this.metrics.fcp) (0, $kTKKO.onFCP)(this.onReport, {
            reportSoftNavs: shouldReportSoftNavs
        });
        if (this.metrics.inp) (0, $kTKKO.onINP)(this.onReport, {
            reportSoftNavs: shouldReportSoftNavs
        });
        if (this.metrics.ttfb) (0, $kTKKO.onTTFB)(this.onReport, {
            reportSoftNavs: shouldReportSoftNavs
        });
    };
    CoralogixWebVitalsInstrumentation.prototype.registerToSoftNavigations = function() {
        var _this = this;
        if (supportedPerformanceTypes.has(PerformanceTypes.SoftNavigation)) {
            var softNavObserver = new PerformanceObserver(function(list) {
                var softNavMetric;
                list.getEntries().forEach(function(entry) {
                    var duration = entry.duration, name = entry.name, startTime = entry.startTime, navigationId = entry.navigationId;
                    softNavMetric = {
                        name: 'SN',
                        id: generateWebVitalUniqueID(),
                        value: duration,
                        url: name,
                        navigationType: 'soft-navigation',
                        navigationId: navigationId,
                        startTime: startTime
                    };
                    _this.onReport(softNavMetric);
                });
            });
            this.observers.push(softNavObserver);
            observeIfSupported(softNavObserver, PerformanceTypes.SoftNavigation);
        } else console.warn('Coralogix Browser SDK - browser doesnt support soft navigation events');
    };
    CoralogixWebVitalsInstrumentation.prototype.registerToCalculatedWebVitalMetrics = function() {
        if (this.metrics.lt) {
            if (supportedPerformanceTypes.has(PerformanceTypes.Navigation)) this.calculateLoadingPageTime();
            else console.warn('Coralogix Browser SDK - browser doesnt support navigation events');
        }
    };
    CoralogixWebVitalsInstrumentation.prototype.registerToTBTMetric = function() {
        if (this.metrics.tbt) {
            if (supportedPerformanceTypes.has(PerformanceTypes.LongTask)) this.calculateAllTotalBlockingTime();
            else console.warn('Coralogix Browser SDK - browser doesnt support TBT events');
        }
    };
    CoralogixWebVitalsInstrumentation.prototype.calculateLoadingPageTime = function() {
        var _this = this;
        var loadingPageObserver = new PerformanceObserver(function(list) {
            var loadTimeMetric;
            list.getEntries().forEach(function(entry) {
                var _a = entry, duration = _a.duration, name = _a.name, type = _a.type;
                loadTimeMetric = (0, $8yqJh.__assign)((0, $8yqJh.__assign)({}, deepClone(entry)), {
                    name: 'LT',
                    id: generateWebVitalUniqueID(),
                    value: duration,
                    url: name,
                    navigationType: type
                });
                if (duration) _this.onReport(loadTimeMetric);
            });
        });
        this.observers.push(loadingPageObserver);
        observeIfSupported(loadingPageObserver, PerformanceTypes.Navigation);
    };
    CoralogixWebVitalsInstrumentation.prototype.calculateAllTotalBlockingTime = function() {
        var _this = this;
        var tbtMetric;
        var totalBLockingTimeObserver = new PerformanceObserver(function(list) {
            var _a;
            var totalBlockingTime = calculateTotalBlockingTime(list.getEntries());
            tbtMetric = {
                name: 'TBT',
                id: generateWebVitalUniqueID(),
                rating: rateForTBTMetricValue(totalBlockingTime),
                value: ((_a = tbtMetric === null || tbtMetric === void 0 ? void 0 : tbtMetric.value) !== null && _a !== void 0 ? _a : 0) + totalBlockingTime
            };
        });
        this.observers.push(totalBLockingTimeObserver);
        observeIfSupported(totalBLockingTimeObserver, PerformanceTypes.LongTask);
        H.getFirstConsistentlyInteractive().then(function(tti) {
            var _a, _b;
            if (tti) {
                _this.onReport(tbtMetric);
                _this.onReport({
                    name: 'TTI',
                    value: tti,
                    id: generateWebVitalUniqueID()
                });
                totalBLockingTimeObserver.disconnect();
                (_b = (_a = CxGlobal.__tti) === null || _a === void 0 ? void 0 : _a.o) === null || _b === void 0 || _b.disconnect();
            }
        });
    };
    CoralogixWebVitalsInstrumentation.prototype.enable = function() {};
    CoralogixWebVitalsInstrumentation.prototype.disable = function() {
        this.observers.forEach(function(observer) {
            return observer.disconnect();
        });
    };
    CoralogixWebVitalsInstrumentation.prototype.init = function() {};
    return CoralogixWebVitalsInstrumentation;
}((0, $fZlMi.InstrumentationBase));
var CoralogixLongTaskInstrumentation = function(_super) {
    (0, $8yqJh.__extends)(CoralogixLongTaskInstrumentation, _super);
    function CoralogixLongTaskInstrumentation(config) {
        var _this = _super.call(this, LONG_TASKS_INSTRUMENTATION_NAME, LONG_TASK_INSTRUMENTATION_VERSION, config) || this;
        if (supportedPerformanceTypes.has(PerformanceTypes.LongTask)) _this.registerToLongTasks();
        else console.warn('Coralogix Browser SDK - browser doesnt support longtask events');
        return _this;
    }
    CoralogixLongTaskInstrumentation.prototype.registerToLongTasks = function() {
        var _this = this;
        this.longTaskObserver = new PerformanceObserver(function(list) {
            list.getEntries().forEach(function(entry) {
                return _this.createSpanFromLongTask(entry);
            });
        });
        observeIfSupported(this.longTaskObserver, PerformanceTypes.LongTask);
    };
    CoralogixLongTaskInstrumentation.prototype.createSpanFromLongTask = function(entry) {
        var longTaskSpan = this.tracer.startSpan(CoralogixEventType.LONG_TASK);
        var longTaskContext = (0, $8yqJh.__assign)((0, $8yqJh.__assign)({}, deepClone(entry)), {
            id: generateUUID()
        });
        if (entry['toJSON']) delete longTaskContext['toJSON'];
        if (entry['attribution']) delete longTaskContext['attribution'];
        longTaskSpan.setAttribute(CoralogixAttributes.EVENT_TYPE, CoralogixEventType.LONG_TASK);
        longTaskSpan.setAttribute(CoralogixEventType.LONG_TASK, JSON.stringify(longTaskContext));
        longTaskSpan.end();
    };
    CoralogixLongTaskInstrumentation.prototype.enable = function() {};
    CoralogixLongTaskInstrumentation.prototype.disable = function() {
        var _a;
        (_a = this.longTaskObserver) === null || _a === void 0 || _a.disconnect();
    };
    CoralogixLongTaskInstrumentation.prototype.init = function() {};
    return CoralogixLongTaskInstrumentation;
}((0, $fZlMi.InstrumentationBase));
function resourceInitiatorTypeIs(value, types) {
    return types.some(function(type) {
        return type === value;
    });
}
var ResourceInitiatorTypes;
(function(ResourceInitiatorTypes) {
    ResourceInitiatorTypes["Media"] = "media";
    ResourceInitiatorTypes["Script"] = "script";
    ResourceInitiatorTypes["Css"] = "css";
    ResourceInitiatorTypes["Beacon"] = "beacon";
    ResourceInitiatorTypes["Img"] = "img";
    ResourceInitiatorTypes["Font"] = "font";
    ResourceInitiatorTypes["Doc"] = "doc";
    ResourceInitiatorTypes["Xhr"] = "xmlhttprequest";
    ResourceInitiatorTypes["Fetch"] = "fetch";
    ResourceInitiatorTypes["Iframe"] = "iframe";
    ResourceInitiatorTypes["Video"] = "video";
    ResourceInitiatorTypes["Audio"] = "audio";
    ResourceInitiatorTypes["Track"] = "track";
    ResourceInitiatorTypes["Other"] = "other";
})(ResourceInitiatorTypes || (ResourceInitiatorTypes = {}));
function isPatternMatch(str, arr, warnKey) {
    return arr.some(function(item) {
        if (item instanceof RegExp) return item.test(str);
        else if (typeof item === 'string') {
            item = item.toLowerCase();
            return item.includes(str.toLowerCase());
        }
        if (warnKey) console.warn("Coralogix Browser SDK - ".concat(warnKey, " must be from type string | Regex"));
        return false;
    });
}
var CoralogixResourcesInstrumentation = function(_super) {
    (0, $8yqJh.__extends)(CoralogixResourcesInstrumentation, _super);
    function CoralogixResourcesInstrumentation(config) {
        var _a;
        var _this = _super.call(this, RESOURCES_INSTRUMENTATION_NAME, RESOURCES_INSTRUMENTATION_VERSION, config) || this;
        _this.ignoreUrls = (_a = getSdkConfig()) === null || _a === void 0 ? void 0 : _a.ignoreUrls;
        if (supportedPerformanceTypes.has(PerformanceTypes.Resource)) _this.registerToResources();
        else console.warn('Coralogix Browser SDK - browser doesnt support resource events');
        return _this;
    }
    CoralogixResourcesInstrumentation.prototype.registerToResources = function() {
        var _this = this;
        this.resourcesObserver = new PerformanceObserver(function(list) {
            list.getEntries().forEach(function(entry) {
                if (_this.isProcessableResourceEntry(entry)) {
                    var mappedEntry = _this.mapResource(entry);
                    _this.createSpanFromResource(mappedEntry);
                }
            });
        });
        observeIfSupported(this.resourcesObserver, PerformanceTypes.Resource);
    };
    CoralogixResourcesInstrumentation.prototype.isProcessableResourceEntry = function(entry) {
        var isAcceptedResourceType = ![
            ResourceInitiatorTypes.Xhr,
            ResourceInitiatorTypes.Fetch
        ].includes(entry.initiatorType);
        var isNotIgnoredResource = !this.isResourceIgnored(entry.name);
        return isAcceptedResourceType && isNotIgnoredResource;
    };
    CoralogixResourcesInstrumentation.prototype.isResourceIgnored = function(resourceName) {
        var _a;
        if (!resourceName || !((_a = this.ignoreUrls) === null || _a === void 0 ? void 0 : _a.length)) return false;
        return isPatternMatch(resourceName, this.ignoreUrls, 'ignoreUrls');
    };
    CoralogixResourcesInstrumentation.prototype.mapResource = function(resource) {
        var resourceName = resource.name;
        var initiatorType = resource.initiatorType;
        switch(true){
            case resourceInitiatorTypeIs(initiatorType, [
                ResourceInitiatorTypes.Beacon
            ]) || valueEndWithOrInclude(resourceName, OTHER_EXTENSIONS):
                initiatorType = ResourceInitiatorTypes.Other;
                break;
            case initiatorType !== ResourceInitiatorTypes.Css && valueEndWithOrInclude(resourceName, CSS_EXTENSIONS):
                initiatorType = ResourceInitiatorTypes.Css;
                break;
            case initiatorType !== ResourceInitiatorTypes.Script && valueEndWithOrInclude(resourceName, SCRIPT_EXTENSIONS):
                initiatorType = ResourceInitiatorTypes.Script;
                break;
            case initiatorType !== ResourceInitiatorTypes.Img && valueEndWithOrInclude(resourceName, IMG_EXTENSIONS):
                initiatorType = ResourceInitiatorTypes.Img;
                break;
            case resourceName.includes(FONTS_URL) || valueEndWithOrInclude(resourceName, FONT_EXTENSIONS):
                initiatorType = ResourceInitiatorTypes.Font;
                break;
            case initiatorType !== ResourceInitiatorTypes.Iframe && valueEndWithOrInclude(resourceName, DOC_EXTENSIONS):
                initiatorType = ResourceInitiatorTypes.Doc;
                break;
            case resourceInitiatorTypeIs(initiatorType, [
                ResourceInitiatorTypes.Video,
                ResourceInitiatorTypes.Audio,
                ResourceInitiatorTypes.Track
            ]) || valueEndWithOrInclude(resourceName, MEDIA_EXTENSIONS):
                initiatorType = ResourceInitiatorTypes.Media;
                break;
        }
        return (0, $8yqJh.__assign)((0, $8yqJh.__assign)({}, deepClone(resource)), {
            initiatorType: initiatorType
        });
    };
    CoralogixResourcesInstrumentation.prototype.createSpanFromResource = function(entry) {
        var _a;
        var resourceSpan = this.tracer.startSpan(RESOURCES_INSTRUMENTATION_NAME);
        resourceSpan.setAttribute(CoralogixAttributes.EVENT_TYPE, CoralogixEventType.RESOURCES);
        var newEntry = (0, $8yqJh.__assign)((0, $8yqJh.__assign)({}, deepClone(entry)), {
            name: (_a = entry.name) === null || _a === void 0 ? void 0 : _a.slice(0, MAX_CHARACTERS)
        });
        resourceSpan.setAttribute(RESOURCES_INSTRUMENTATION_NAME, JSON.stringify(newEntry));
        resourceSpan.end();
    };
    CoralogixResourcesInstrumentation.prototype.enable = function() {};
    CoralogixResourcesInstrumentation.prototype.disable = function() {
        var _a;
        (_a = this.resourcesObserver) === null || _a === void 0 || _a.disconnect();
    };
    CoralogixResourcesInstrumentation.prototype.init = function() {};
    return CoralogixResourcesInstrumentation;
}((0, $fZlMi.InstrumentationBase));
function addEventListeners(eventTarget, eventNames, listener, _a) {
    var _b = _a === void 0 ? {} : _a, once = _b.once, capture = _b.capture, passive = _b.passive;
    var resolvedListener = once ? function(event) {
        stop();
        listener(event);
    } : listener;
    var options = passive ? {
        capture: capture,
        passive: passive
    } : capture;
    var addListener = getZoneJsOriginalDom(eventTarget, 'addEventListener');
    eventNames.forEach(function(eventName) {
        return addListener.call(eventTarget, eventName, resolvedListener, options);
    });
    function stop() {
        var remove = getZoneJsOriginalDom(eventTarget, 'removeEventListener');
        eventNames.forEach(function(eventName) {
            return remove.call(eventTarget, eventName, resolvedListener, options);
        });
    }
    return {
        stop: stop
    };
}
var PARENT_SEARCH_DEPTH = 5;
var CLICKABLE_ELEMENTS = [
    'BUTTON',
    'LABEL',
    'A',
    'INPUT',
    'OPTION'
];
function extractMaskedOrTextContent(element, config) {
    if (!element) return '';
    var clickableElement = findClickableElement(element, PARENT_SEARCH_DEPTH);
    if (!clickableElement) return '';
    return getMaskedOrTextualContent(clickableElement, config);
}
function findClickableElement(element, maxDepth) {
    if (!element || maxDepth <= 0) return null;
    if (CLICKABLE_ELEMENTS.includes(element.nodeName)) return element;
    return findClickableElement(element.parentElement, maxDepth - 1);
}
function getMaskedOrTextualContent(element, config) {
    if (shouldMaskElement(element, config.maskInputTypes, config.maskClass) || isParentMasked(element, config.maskClass, PARENT_SEARCH_DEPTH)) return MASKED_TEXT;
    var maskedChild = findMaskedChildren(element, config);
    if (maskedChild) return MASKED_TEXT;
    return getTextualContent(element);
}
function isParentMasked(element, maskClass, maxDepth) {
    if (maxDepth === void 0) maxDepth = PARENT_SEARCH_DEPTH;
    if (!element || maxDepth <= 0) return false;
    if (isMaskedByClass(element.className, maskClass)) return true;
    return isParentMasked(element.parentElement, maskClass, maxDepth - 1);
}
function findMaskedChildren(element, config) {
    if (!element.children) return null;
    return Array.from(element.children).find(function(child) {
        return shouldMaskElement(child, config.maskInputTypes, config.maskClass);
    });
}
function shouldMaskElement(element, maskInputTypes, maskClass) {
    if (!element) return false;
    return isMaskedInput(element, maskInputTypes) || isMaskedByClass(element.className, maskClass);
}
function isMaskedInput(element, maskInputTypes) {
    if (element instanceof HTMLInputElement) {
        var inputType = element.type || 'text';
        return maskInputTypes.includes(inputType);
    }
    return false;
}
function isMaskedByClass(className, maskClass) {
    if (maskClass instanceof RegExp) return maskClass.test(className);
    if (typeof className !== 'string') return false;
    return className.includes(maskClass);
}
function getTextualContent(element) {
    if (element instanceof HTMLInputElement) return element.value || '';
    return 'innerText' in element ? element.innerText : '';
}
var _a$3;
var USER_INTERACTION_INSTRUMENTATION_NAME = 'interactions';
var USER_INTERACTION_INSTRUMENTATION_VERSION = '1';
var DEFAULT_INSTRUMENTED_EVENTS = (_a$3 = {}, _a$3["click"] = true, _a$3);
var CoralogixUserInteractionInstrumentation = function(_super) {
    (0, $8yqJh.__extends)(CoralogixUserInteractionInstrumentation, _super);
    function CoralogixUserInteractionInstrumentation(config) {
        var _this = _super.call(this, USER_INTERACTION_INSTRUMENTATION_NAME, USER_INTERACTION_INSTRUMENTATION_VERSION, config) || this;
        _this.handler = function(_) {};
        _this.stop = function() {};
        return _this;
    }
    CoralogixUserInteractionInstrumentation.prototype.enable = function() {
        var _this = this;
        var _a;
        this.handler = function(e) {
            var span;
            if (shouldAttachSpanToGlobalSpan(CoralogixEventType.USER_INTERACTION)) span = attachChildSpanToGlobalSpan(CoralogixEventType.USER_INTERACTION);
            else span = _this.tracer.startSpan(CoralogixEventType.USER_INTERACTION);
            var eventTarget = e.target;
            var config = getSdkConfig();
            var id = eventTarget.id, type = eventTarget.type, className = eventTarget.className, nodeName = eventTarget.nodeName;
            var elementText = extractMaskedOrTextContent(eventTarget, config);
            span.setAttribute(CoralogixAttributes.EVENT_TYPE, CoralogixEventType.USER_INTERACTION);
            span.setAttribute(CoralogixAttributes.INTERACTION_EVENT_NAME, e.type);
            if (eventTarget && eventTarget instanceof HTMLElement) [
                [
                    CoralogixAttributes.ELEMENT_ID,
                    id
                ],
                [
                    CoralogixAttributes.ELEMENT_CLASSES,
                    className
                ],
                [
                    CoralogixAttributes.TARGET_ELEMENT_TYPE,
                    type
                ],
                [
                    CoralogixAttributes.ELEMENT_INNER_TEXT,
                    elementText === null || elementText === void 0 ? void 0 : elementText.slice(0, MAX_INTERACTION_ELEMENT_SIZE)
                ],
                [
                    CoralogixAttributes.TARGET_ELEMENT,
                    nodeName
                ]
            ].forEach(function(_a) {
                var _b = (0, $8yqJh.__read)(_a, 2), key = _b[0], value = _b[1];
                span.setAttribute(key, value);
            });
            span.end();
        };
        var eventsMap = (0, $8yqJh.__assign)((0, $8yqJh.__assign)({}, DEFAULT_INSTRUMENTED_EVENTS), (_a = this._config) === null || _a === void 0 ? void 0 : _a['events']);
        var eventNames = Object.entries(eventsMap).filter(function(_a) {
            var _b = (0, $8yqJh.__read)(_a, 2);
            _b[0];
            var enabled = _b[1];
            return enabled;
        }).map(function(_a) {
            var _b = (0, $8yqJh.__read)(_a, 1), eventName = _b[0];
            return eventName;
        });
        this.stop = addEventListeners(document, eventNames, this.handler, {
            capture: true,
            passive: true
        }).stop;
    };
    CoralogixUserInteractionInstrumentation.prototype.disable = function() {
        this.stop();
    };
    CoralogixUserInteractionInstrumentation.prototype.init = function() {};
    return CoralogixUserInteractionInstrumentation;
}((0, $fZlMi.InstrumentationBase));
var MEMORY_USAGE_INSTRUMENTATION_NAME = 'memory_usage';
var MEMORY_USAGE_INSTRUMENTATION_VERSION = '1.0.0';
var MEMORY_USAGE_DEFAULT_INTERVAL = 300000;
function isMeasureUserAgentSpecificMemoryAllowed() {
    if (!CxGlobal.crossOriginIsolated) {
        console.debug('Coralogix Browser SDK - measureUserAgentSpecificMemory() is only available in cross-origin-isolated pages.');
        return false;
    }
    if (!performance.measureUserAgentSpecificMemory) {
        console.debug('Coralogix Browser SDK - measureUserAgentSpecificMemory() is not available in this browser');
        return false;
    }
    return true;
}
function mapMemoryUsageEntries(memoryUsage) {
    var e_1, _a;
    var uuid = generateUUID();
    var parentEntry = {
        uuid: uuid,
        isParent: true,
        bytes: memoryUsage.bytes
    };
    var breakdownEntries = [];
    try {
        for(var _b = (0, $8yqJh.__values)(memoryUsage.breakdown), _c = _b.next(); !_c.done; _c = _b.next()){
            var entry = _c.value;
            if (entry.bytes > 0) breakdownEntries.push({
                uuid: uuid,
                bytes: entry.bytes,
                attribution: entry.attribution,
                types: entry.types.sort().join(', ')
            });
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return (0, $8yqJh.__spreadArray)([
        parentEntry
    ], (0, $8yqJh.__read)(breakdownEntries), false);
}
var CoralogixMemoryUsageInstrumentation = function(_super) {
    (0, $8yqJh.__extends)(CoralogixMemoryUsageInstrumentation, _super);
    function CoralogixMemoryUsageInstrumentation(config) {
        var _this = _super.call(this, MEMORY_USAGE_INSTRUMENTATION_NAME, MEMORY_USAGE_INSTRUMENTATION_VERSION, config) || this;
        _this.memoryUsageInterval = getSdkConfig().memoryUsageConfig.interval;
        return _this;
    }
    CoralogixMemoryUsageInstrumentation.prototype.disable = function() {
        this.clearMeasurementsInterval();
    };
    CoralogixMemoryUsageInstrumentation.prototype.enable = function() {
        this.startTrackingMemoryUsage();
    };
    CoralogixMemoryUsageInstrumentation.prototype.init = function() {};
    CoralogixMemoryUsageInstrumentation.prototype.startTrackingMemoryUsage = function() {
        var _this = this;
        this.clearMeasurementsInterval();
        this.createMemorySample().then(function() {
            return _this.runMemoryMeasurements();
        });
    };
    CoralogixMemoryUsageInstrumentation.prototype.createMemorySample = function() {
        return (0, $8yqJh.__awaiter)(this, void 0, void 0, function() {
            var memoryUsage, memoryUsageEntries, memoryUsageEntries_1, memoryUsageEntries_1_1, entry, memoryUsageSpan, error_1;
            var e_1, _a;
            return (0, $8yqJh.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _b.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            performance.measureUserAgentSpecificMemory()
                        ];
                    case 1:
                        memoryUsage = _b.sent();
                        memoryUsageEntries = mapMemoryUsageEntries(memoryUsage);
                        try {
                            for(memoryUsageEntries_1 = (0, $8yqJh.__values)(memoryUsageEntries), memoryUsageEntries_1_1 = memoryUsageEntries_1.next(); !memoryUsageEntries_1_1.done; memoryUsageEntries_1_1 = memoryUsageEntries_1.next()){
                                entry = memoryUsageEntries_1_1.value;
                                memoryUsageSpan = this.tracer.startSpan(MEMORY_USAGE_INSTRUMENTATION_NAME);
                                memoryUsageSpan[CoralogixAttributes.EVENT_TYPE] = CoralogixEventType.MEMORY_USAGE;
                                memoryUsageSpan[CoralogixAttributes.MEMORY_USAGE_CONTEXT] = entry;
                                memoryUsageSpan.end();
                            }
                        } catch (e_1_1) {
                            e_1 = {
                                error: e_1_1
                            };
                        } finally{
                            try {
                                if (memoryUsageEntries_1_1 && !memoryUsageEntries_1_1.done && (_a = memoryUsageEntries_1.return)) _a.call(memoryUsageEntries_1);
                            } finally{
                                if (e_1) throw e_1.error;
                            }
                        }
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error_1 = _b.sent();
                        console.warn('Memory usage measurement failed', error_1);
                        this.clearMeasurementsInterval();
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
    };
    CoralogixMemoryUsageInstrumentation.prototype.runMemoryMeasurements = function() {
        var _this = this;
        this.timeoutId = cxSetTimeout(function() {
            return _this.measureMemoryUsage();
        }, this.memoryUsageInterval);
    };
    CoralogixMemoryUsageInstrumentation.prototype.measureMemoryUsage = function() {
        return (0, $8yqJh.__awaiter)(this, void 0, void 0, function() {
            return (0, $8yqJh.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4,
                            this.createMemorySample()
                        ];
                    case 1:
                        _a.sent();
                        this.runMemoryMeasurements();
                        return [
                            2
                        ];
                }
            });
        });
    };
    CoralogixMemoryUsageInstrumentation.prototype.clearMeasurementsInterval = function() {
        if (this.timeoutId) cxClearTimeout(this.timeoutId);
    };
    return CoralogixMemoryUsageInstrumentation;
}((0, $fZlMi.InstrumentationBase));
var SCREENSHOT_INSTRUMENTATION_NAME = 'screenshot';
var SCREENSHOT_INSTRUMENTATION_VERSION = '1.0.0';
var CoralogixScreenshotInstrumentation = function(_super) {
    (0, $8yqJh.__extends)(CoralogixScreenshotInstrumentation, _super);
    function CoralogixScreenshotInstrumentation(config) {
        return _super.call(this, SCREENSHOT_INSTRUMENTATION_NAME, SCREENSHOT_INSTRUMENTATION_VERSION, config) || this;
    }
    CoralogixScreenshotInstrumentation.prototype.init = function() {};
    CoralogixScreenshotInstrumentation.prototype.disable = function() {};
    CoralogixScreenshotInstrumentation.prototype.enable = function() {};
    CoralogixScreenshotInstrumentation.prototype.screenshot = function(id, description) {
        if (!getSessionRecorder()) return;
        var span = this.tracer.startSpan(CoralogixEventType.SCREENSHOT);
        span.setAttribute(CoralogixAttributes.EVENT_TYPE, CoralogixEventType.SCREENSHOT);
        span.setAttribute(CoralogixAttributes.SEVERITY, CoralogixLogSeverity.Info);
        span[CoralogixAttributes.SCREENSHOT_CONTEXT] = {
            id: id,
            description: description
        };
        span.end();
    };
    return CoralogixScreenshotInstrumentation;
}((0, $fZlMi.InstrumentationBase));
var TimeMeasurementTracker = function() {
    function TimeMeasurementTracker() {
        this.measurements = new Map();
    }
    TimeMeasurementTracker.prototype.startMeasurement = function(key, labels) {
        this.checkAndResetIfSessionExpired();
        if (this.measurements.has(key) || !key.trim()) {
            this.logDebug("Invalid or duplicate key: \"".concat(key, "\"."));
            return;
        }
        this.measurements.set(key, {
            startTime: Date.now(),
            labels: labels
        });
    };
    TimeMeasurementTracker.prototype.getMeasurement = function(key) {
        this.checkAndResetIfSessionExpired();
        if (!this.measurements.has(key) || !key.trim()) {
            this.logDebug("Invalid or duplicate key: \"".concat(key, "\"."));
            return undefined;
        }
        var _a = this.measurements.get(key), startTime = _a.startTime, labels = _a.labels;
        this.measurements.delete(key);
        return {
            duration: Date.now() - startTime,
            labels: labels
        };
    };
    TimeMeasurementTracker.prototype.checkAndResetIfSessionExpired = function() {
        if (getSessionManager().isIdleActive) this.measurements.clear();
    };
    TimeMeasurementTracker.prototype.logDebug = function(message) {
        if (getSdkConfig().debug) console.debug("Coralogix Browser SDK - ".concat(message));
    };
    return TimeMeasurementTracker;
}();
var CoralogixCustomMeasurementInstrumentation = function(_super) {
    (0, $8yqJh.__extends)(CoralogixCustomMeasurementInstrumentation, _super);
    function CoralogixCustomMeasurementInstrumentation(config) {
        return _super.call(this, CUSTOM_MEASUREMENT_INSTRUMENTATION_NAME, CUSTOM_MEASUREMENT_INSTRUMENTATION_VERSION, config) || this;
    }
    CoralogixCustomMeasurementInstrumentation.prototype.init = function() {};
    CoralogixCustomMeasurementInstrumentation.prototype.disable = function() {};
    CoralogixCustomMeasurementInstrumentation.prototype.enable = function() {};
    CoralogixCustomMeasurementInstrumentation.prototype.createCustomMeasurement = function(name, value, labels) {
        var customMeasurementSpan = this.tracer.startSpan(CUSTOM_MEASUREMENT_INSTRUMENTATION_NAME);
        customMeasurementSpan[CoralogixAttributes.EVENT_TYPE] = CoralogixEventType.CUSTOM_MEASUREMENT;
        customMeasurementSpan[CoralogixAttributes.CUSTOM_MEASUREMENT_CONTEXT] = {
            name: name,
            value: value
        };
        if (Object.keys(labels || {}).length > 0) customMeasurementSpan.setAttribute(CoralogixAttributes.CUSTOM_LABELS, JSON.stringify(labels));
        customMeasurementSpan.end();
    };
    return CoralogixCustomMeasurementInstrumentation;
}((0, $fZlMi.InstrumentationBase));
var INTERNAL_INSTRUMENTATION_VERSION = '1';
var CoralogixInternalInstrumentation = function(_super) {
    (0, $8yqJh.__extends)(CoralogixInternalInstrumentation, _super);
    function CoralogixInternalInstrumentation(config) {
        return _super.call(this, CoralogixEventType.INTERNAL, INTERNAL_INSTRUMENTATION_VERSION, config) || this;
    }
    CoralogixInternalInstrumentation.prototype.init = function() {};
    CoralogixInternalInstrumentation.prototype.disable = function() {};
    CoralogixInternalInstrumentation.prototype.enable = function() {};
    CoralogixInternalInstrumentation.prototype.reportInternalEvent = function(event, message) {
        if (message === void 0) message = '';
        var span = this.tracer.startSpan(CoralogixEventType.INTERNAL);
        var data;
        span.setAttribute(CoralogixAttributes.EVENT_TYPE, CoralogixEventType.INTERNAL);
        span.setAttribute(CoralogixAttributes.SEVERITY, CoralogixLogSeverity.Info);
        switch(event){
            case 'init':
                var config = omit(getSdkConfig(), 'public_key', 'coralogixDomain');
                data = this.stringifyConfig(config);
                break;
            case 'recording-start':
                break;
            case 'recording-stop':
                data = message;
                break;
        }
        span.setAttribute(CoralogixAttributes.INTERNAL, JSON.stringify({
            event: event,
            data: data
        }));
        span.end();
    };
    CoralogixInternalInstrumentation.prototype.stringifyConfig = function(config) {
        var replacer = function(key, value) {
            if (value instanceof RegExp) return value.toString();
            if (typeof value === 'function') return value.toString().slice(0, 8) + '...';
            return value;
        };
        return JSON.stringify(config, replacer, 2);
    };
    return CoralogixInternalInstrumentation;
}((0, $fZlMi.InstrumentationBase));
var CoralogixDOMInstrumentation = function(_super) {
    (0, $8yqJh.__extends)(CoralogixDOMInstrumentation, _super);
    function CoralogixDOMInstrumentation(config) {
        var _this = _super.call(this, DOM_INSTRUMENTATION_NAME, DOM_INSTRUMENTATION_VERSION, config) || this;
        _this.visibilityChangeHandler = function() {
            if (document.hidden) {
                var domSpan = _this.tracer.startSpan(DOM_INSTRUMENTATION_NAME);
                domSpan.setAttribute(CoralogixAttributes.EVENT_TYPE, CoralogixEventType.DOM);
                domSpan.end();
            }
        };
        return _this;
    }
    CoralogixDOMInstrumentation.prototype.registerToDOMEvents = function() {
        var originalAddEventListener = getZoneJsOriginalDom(document, 'addEventListener');
        originalAddEventListener.call(document, 'visibilitychange', this.visibilityChangeHandler);
    };
    CoralogixDOMInstrumentation.prototype.unregisterFromDOMEvents = function() {
        var originalRemoveEventListener = getZoneJsOriginalDom(document, 'removeEventListener');
        originalRemoveEventListener.call(document, 'visibilitychange', this.visibilityChangeHandler);
    };
    CoralogixDOMInstrumentation.prototype.init = function() {};
    CoralogixDOMInstrumentation.prototype.disable = function() {
        this.unregisterFromDOMEvents();
    };
    CoralogixDOMInstrumentation.prototype.enable = function() {
        var _this = this;
        cxSetTimeout(function() {
            _this.registerToDOMEvents();
        });
    };
    return CoralogixDOMInstrumentation;
}((0, $fZlMi.InstrumentationBase));
var ERROR_TYPES = {
    RUNTIME: 'web-worker-runtime-error',
    MESSAGE_ERROR: 'web-worker-messageerror'
};
var ERROR_MESSAGES = {
    UNKNOWN_RUNTIME: 'Unknown worker runtime error',
    DESERIALIZATION_FAILED: 'Failed to deserialize message from worker'
};
var WORKER_EVENTS = {
    ERROR: 'error',
    MESSAGE_ERROR: 'messageerror'
};
var CoralogixWorkerInstrumentation = function(_super) {
    (0, $8yqJh.__extends)(CoralogixWorkerInstrumentation, _super);
    function CoralogixWorkerInstrumentation(config, errorInstrumentation, coralogixRum) {
        var _this = _super.call(this, WORKER_INSTRUMENTATION, WORKER_INSTRUMENTATION_VERSION, config) || this;
        _this.errorInstrumentation = errorInstrumentation;
        _this.coralogixRum = coralogixRum;
        _this.init();
        return _this;
    }
    CoralogixWorkerInstrumentation.prototype.disable = function() {};
    CoralogixWorkerInstrumentation.prototype.enable = function() {};
    CoralogixWorkerInstrumentation.prototype.init = function() {
        var globalObj = CxGlobal;
        var OriginalWorker = globalObj.Worker;
        globalObj.Worker = this.createCxWorker(OriginalWorker);
    };
    CoralogixWorkerInstrumentation.prototype.createCxWorker = function(OriginalWorker) {
        var self1 = this;
        function CxWorker(scriptURL, options) {
            var worker = new OriginalWorker(scriptURL, options);
            worker.CoralogixRum = self1.coralogixRum;
            self1.attachWorkerErrorHandlers(worker, scriptURL);
            return worker;
        }
        CxWorker.prototype = OriginalWorker.prototype;
        Object.defineProperties(CxWorker, Object.getOwnPropertyDescriptors(OriginalWorker));
        return CxWorker;
    };
    CoralogixWorkerInstrumentation.prototype.attachWorkerErrorHandlers = function(worker, scriptURL) {
        var _this = this;
        var source = scriptURL.toString();
        worker.addEventListener(WORKER_EVENTS.ERROR, function(event) {
            var message = event.message || ERROR_MESSAGES.UNKNOWN_RUNTIME;
            _this.reportWorkerError(message, {
                scriptURL: source,
                filename: event.filename,
                lineno: event.lineno,
                colno: event.colno,
                originalError: event.error || null
            }, {
                type: ERROR_TYPES.RUNTIME
            });
        });
        worker.addEventListener(WORKER_EVENTS.MESSAGE_ERROR, function(event) {
            _this.reportWorkerError(ERROR_MESSAGES.DESERIALIZATION_FAILED, {
                scriptURL: source,
                event: event
            }, {
                type: ERROR_TYPES.MESSAGE_ERROR
            });
        });
    };
    CoralogixWorkerInstrumentation.prototype.reportWorkerError = function(message, customData, labels) {
        var _a;
        (_a = this.errorInstrumentation) === null || _a === void 0 || _a.reportError(ErrorSource.WEB_WORKER, new Error(message), customData, labels);
    };
    return CoralogixWorkerInstrumentation;
}((0, $fZlMi.InstrumentationBase));
var CORALOGIX_LOGS_URL_SUFFIX = '/browser/v1beta/logs';
var CORALOGIX_RECORDING_URL_SUFFIX = '/sessionrecording';
var MAX_EXPORT_BATCH_SIZE = 50;
var MAX_INTERACTION_ELEMENT_SIZE = 1024;
var MAX_CHARACTERS = 1024;
var SCHEDULE_DELAY_MILLIS = 2 * millisecondsPerSecond;
var REQUIRED_CONFIG_KEYS = [
    'application',
    'version',
    'coralogixDomain'
];
var ID_MASK_KEY = '{id}';
var UUID_REGEX = /[0-9a-fA-F-]{36}/g;
var NANOID_REGEX = /^[a-zA-Z0-9-_]{21}$/;
var PAGE_URL_LABEL_PROVIDERS_KEY = 'PAGE_URL_LABEL_PROVIDERS';
var NETWORK_URL_LABEL_PROVIDERS_KEY = 'NETWORK_URL_LABEL_PROVIDERS';
var RUM_INTERNAL_DATA_KEY = 'rumInternalData';
var MASKED_TEXT = '***';
var MASK_CLASS_DEFAULT = 'cx-mask';
var MASK_INPUT_TYPES_DEFAULT = [
    'password',
    'email',
    'tel'
];
var FINGER_PRINT_KEY = 'cx-fingerprint';
var idPatterns = [
    {
        pattern: new RegExp(UUID_REGEX),
        replacement: ID_MASK_KEY
    },
    {
        pattern: new RegExp(NANOID_REGEX),
        replacement: ID_MASK_KEY
    }
];
var PATH_ID_PLACEHOLDER = '/{id}';
var NUMERIC_PATH_SEGMENT_REGEX = /\/(?![vV]\d{1,2}\/)([^/\d?]*\d+[^/?]*)/g;
function replaceNumericPathSegments(url) {
    var replacePath = function(s) {
        return s.replace(NUMERIC_PATH_SEGMENT_REGEX, PATH_ID_PLACEHOLDER);
    };
    try {
        var origin_1 = new URL(url).origin;
        if (origin_1 === 'null' || !url.startsWith(origin_1)) return url;
        return origin_1 + replacePath(url.slice(origin_1.length));
    } catch (_a) {
        return replacePath(url);
    }
}
var defaultUrlBlueprinters = {
    pageUrlBlueprinters: [
        function(url) {
            return replaceNumericPathSegments(replacePatternsInUrl({
                patterns: idPatterns,
                url: url
            }));
        }
    ]
};
var OPTIONS_DEFAULTS = {
    ignoreUrls: [
        new RegExp(CORALOGIX_LOGS_URL_SUFFIX),
        new RegExp(CORALOGIX_RECORDING_URL_SUFFIX)
    ],
    user_context: {
        user_id: '',
        user_name: ''
    },
    labels: {},
    urlBlueprinters: defaultUrlBlueprinters,
    collectIPData: true
};
var INSTRUMENTATIONS = [
    {
        Instrument: CoralogixErrorInstrumentation,
        confKey: ERROR_INSTRUMENTATION_NAME,
        disable: false
    },
    {
        Instrument: CoralogixFetchInstrumentation,
        confKey: FETCH_INSTRUMENTATION_NAME,
        disable: false
    },
    {
        Instrument: CoralogixXhrInstrumentation,
        confKey: XHR_INSTRUMENTATION_NAME,
        disable: false
    },
    {
        Instrument: CoralogixCustomLogInstrumentation,
        confKey: CUSTOM_INSTRUMENTATION_NAME,
        disable: false
    },
    {
        Instrument: CoralogixUserInteractionInstrumentation,
        confKey: USER_INTERACTION_INSTRUMENTATION_NAME,
        disable: false
    },
    {
        Instrument: CoralogixWebVitalsInstrumentation,
        confKey: WEB_VITALS_INSTRUMENTATION_NAME,
        disable: false
    },
    {
        Instrument: CoralogixLongTaskInstrumentation,
        confKey: LONG_TASKS_INSTRUMENTATION_NAME,
        disable: false
    },
    {
        Instrument: CoralogixResourcesInstrumentation,
        confKey: RESOURCES_INSTRUMENTATION_NAME,
        disable: false
    },
    {
        Instrument: CoralogixInternalInstrumentation,
        confKey: CoralogixEventType.INTERNAL,
        disable: false
    },
    {
        Instrument: CoralogixDOMInstrumentation,
        confKey: CoralogixEventType.DOM,
        disable: false
    },
    {
        Instrument: CoralogixCustomMeasurementInstrumentation,
        confKey: CoralogixEventType.CUSTOM_MEASUREMENT,
        disable: false
    },
    {
        Instrument: CoralogixMemoryUsageInstrumentation,
        confKey: CoralogixEventType.MEMORY_USAGE,
        disable: false
    },
    {
        Instrument: CoralogixScreenshotInstrumentation,
        confKey: CoralogixEventType.SCREENSHOT,
        disable: false
    },
    {
        Instrument: CoralogixWorkerInstrumentation,
        confKey: CoralogixEventType.WORKER,
        disable: false
    }
];
var CoralogixAttributes = {
    EVENT_TYPE: 'event_type',
    SEVERITY: 'severity',
    APPLICATION_CONTEXT: 'application_context',
    USER_CONTEXT: 'user_context',
    CUSTOM_MEASUREMENT_CONTEXT: 'custom_measurement_context',
    MEMORY_USAGE_CONTEXT: 'memory_usage_context',
    SOURCE: 'source',
    ERROR: ErrorAttributes,
    LOG: 'cx_log',
    CUSTOM_LABELS: 'custom_labels',
    ENVIRONMENT: 'environment',
    INTERACTION_EVENT_NAME: 'interaction_event_name',
    ELEMENT_INNER_TEXT: 'element_inner_text',
    ELEMENT_ID: 'element_id',
    ELEMENT_CLASSES: 'element_classes',
    TARGET_ELEMENT: 'target_element',
    TARGET_ELEMENT_TYPE: 'target_element_type',
    TIMESTAMP: 'timestamp',
    INTERNAL: 'internal',
    PAGE_CONTEXT: 'page_context',
    IS_NAVIGATION_EVENT: 'is_navigation_event',
    SCREENSHOT_CONTEXT: 'screenshot_context'
};
var CoralogixDomainsApiUrlMap = {
    EU1: 'https://ingress.eu1.rum-ingress-coralogix.com',
    EU2: 'https://ingress.eu2.rum-ingress-coralogix.com',
    US1: 'https://ingress.us1.rum-ingress-coralogix.com',
    US2: 'https://ingress.us2.rum-ingress-coralogix.com',
    US3: 'https://ingress.us3.rum-ingress-coralogix.com',
    AP1: 'https://ingress.ap1.rum-ingress-coralogix.com',
    AP2: 'https://ingress.ap2.rum-ingress-coralogix.com',
    AP3: 'https://ingress.ap3.rum-ingress-coralogix.com',
    STAGING: 'https://ingress.staging.rum-ingress-coralogix.com'
};
var PROXY_CX_FORWARD_PARAMETER = 'cxforward';
var CX_MAPPED_SPAN = 'cx_mapped_span';
var BASE_PATH = '/';
var HASH_SEPARATOR = '#';
var PARAMS_SEPARATOR = '?';
var PROTOCOL_SEPARATOR = '://';
function saveInternalRumData(key, value) {
    if (!CxGlobal[RUM_INTERNAL_DATA_KEY]) CxGlobal[RUM_INTERNAL_DATA_KEY] = {};
    CxGlobal[RUM_INTERNAL_DATA_KEY][key] = value;
}
function getInternalRumData(key) {
    var _a;
    return (_a = CxGlobal[RUM_INTERNAL_DATA_KEY]) === null || _a === void 0 ? void 0 : _a[key];
}
var _a$2;
var supportedPerformanceTypes = !((_a$2 = CxGlobal === null || CxGlobal === void 0 ? void 0 : CxGlobal.PerformanceObserver) === null || _a$2 === void 0 ? void 0 : _a$2.supportedEntryTypes) ? new Set() : new Set(CxGlobal.PerformanceObserver.supportedEntryTypes);
function valueEndWithOrInclude(value, extensions) {
    return extensions.some(function(ex) {
        return value.endsWith(ex) || value.includes(ex);
    });
}
function getInstrumentationConfig(value, defaults, defaultDisable) {
    if (value === false) return value;
    if (value === undefined && defaultDisable) return false;
    if ((value === null || value === void 0 ? void 0 : value.enabled) === false) return false;
    return Object.assign({}, defaults, value);
}
var hrTimeToMilliseconds = function(_a) {
    var _b = (0, $8yqJh.__read)(_a, 2), seconds = _b[0], nanoseconds = _b[1];
    return seconds * 1000 + Math.round(nanoseconds / 1e6);
};
var isNetworkError = function(status) {
    if (!status) return false;
    return status >= 400;
};
var getUrlFragments = function(url) {
    var _a, _b;
    if (!url) return '';
    var withoutProtocol = ((_a = url.split(PROTOCOL_SEPARATOR)) === null || _a === void 0 ? void 0 : _a[1]) || url;
    var startPath = (_b = withoutProtocol.split(BASE_PATH)) === null || _b === void 0 ? void 0 : _b[1];
    if (startPath === null || startPath === void 0 ? void 0 : startPath.startsWith(HASH_SEPARATOR)) {
        var fragments = withoutProtocol.split(HASH_SEPARATOR)[1];
        var cleanedFragments = fragments.split(PARAMS_SEPARATOR)[0];
        var pathFragments = cleanedFragments.split(BASE_PATH);
        if (pathFragments.length) pathFragments.shift();
        return pathFragments.join(BASE_PATH) || BASE_PATH;
    } else try {
        if (url.startsWith('blob:')) return url;
        return decodeURIComponent(new URL(url).pathname.substring(1)) || BASE_PATH;
    } catch (err) {
        console.warn('Coralogix Browser SDK - Error parsing URL', err);
        return url;
    }
};
function parseUserAgent(userAgent) {
    var e_1, _a, e_2, _b, e_3, _c;
    var _d, _e, _f;
    var browsers = {
        Edge: /Edge\/([\d.]+)|Edg\/([\d.]+)/,
        Chrome: /Chrome\/([\d.]+)/,
        Firefox: /Firefox\/([\d.]+)/,
        Safari: /Version\/([\d.]+).*Safari|Safari\/([\d.]+)/,
        Opera: /Opera\/([\d.]+)/,
        IE: /Trident.*rv:([\d.]+)/
    };
    var operatingSystems = {
        Windows: /Windows NT ([\d.]+)/,
        MacOS: /Mac OS X ([\d._]+)/,
        webOS: /Web0S/,
        Linux: /Linux(?: ([\d.]+))?/,
        iOS: /CPU(?: iPhone)? OS (\d+([._]\d+)*)/,
        Android: /Android (\d+([._]\d+)*)/,
        Tizen: /Tizen ([\d.]+)/
    };
    var devices = {
        Mobile: /Mobile|Android|iPhone|iPod|BlackBerry|IEMobile|Windows Phone|webOS|Opera Mini/,
        Tablet: /Tablet|iPad/,
        'Smart-TV': /SMART-TV|SmartTV/
    };
    var browser = 'Unknown';
    var browserVersion = 'Unknown';
    var os = 'Unknown';
    var osVersion = 'Unknown';
    var device = 'Desktop';
    try {
        for(var _g = (0, $8yqJh.__values)(Object.entries(browsers)), _h = _g.next(); !_h.done; _h = _g.next()){
            var _j = (0, $8yqJh.__read)(_h.value, 2), name_1 = _j[0], regex = _j[1];
            var match = userAgent.match(regex);
            if (match) {
                browser = name_1;
                browserVersion = ((_d = match.slice(1)) === null || _d === void 0 ? void 0 : _d.find(function(v) {
                    return !!v;
                })) || 'Unknown';
                break;
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_h && !_h.done && (_a = _g.return)) _a.call(_g);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    try {
        for(var _k = (0, $8yqJh.__values)(Object.entries(operatingSystems)), _l = _k.next(); !_l.done; _l = _k.next()){
            var _m = (0, $8yqJh.__read)(_l.value, 2), name_2 = _m[0], regex = _m[1];
            var match = userAgent.match(regex);
            if (match) {
                os = name_2;
                osVersion = ((_f = (_e = match[1]) === null || _e === void 0 ? void 0 : _e.split('_')) === null || _f === void 0 ? void 0 : _f.join('.')) || 'Unknown';
                break;
            }
        }
    } catch (e_2_1) {
        e_2 = {
            error: e_2_1
        };
    } finally{
        try {
            if (_l && !_l.done && (_b = _k.return)) _b.call(_k);
        } finally{
            if (e_2) throw e_2.error;
        }
    }
    try {
        for(var _o = (0, $8yqJh.__values)(Object.entries(devices)), _p = _o.next(); !_p.done; _p = _o.next()){
            var _q = (0, $8yqJh.__read)(_p.value, 2), name_3 = _q[0], regex = _q[1];
            var match = userAgent.match(regex);
            if (match) {
                device = name_3;
                break;
            }
        }
    } catch (e_3_1) {
        e_3 = {
            error: e_3_1
        };
    } finally{
        try {
            if (_p && !_p.done && (_c = _o.return)) _c.call(_o);
        } finally{
            if (e_3) throw e_3.error;
        }
    }
    return {
        browser: browser,
        browserVersion: browserVersion,
        os: os,
        osVersion: osVersion,
        device: device
    };
}
function calculateTotalBlockingTime(list) {
    return list.reduce(function(total, entry) {
        total += entry.duration - LONGTASK_DURATION;
        return total;
    }, 0);
}
function generateWebVitalUniqueID() {
    return "v3-".concat(getNowTime(), "-").concat(Math.floor(Math.random() * (9e12 - 1)) + 1e12);
}
function rateForTBTMetricValue(value) {
    switch(true){
        case value > 600:
            return 'poor';
        case value > 200 && value <= 600:
            return 'needs-improvement';
        default:
            return 'good';
    }
}
var getCircularReplacer = function() {
    var seen = new WeakSet();
    return function(key, value) {
        if (typeof value === 'object' && value !== null) {
            if (seen.has(value)) return;
            seen.add(value);
        }
        return value;
    };
};
function replacePatternsInUrl(_a) {
    var e_5, _b;
    var patterns = _a.patterns, url = _a.url;
    var modifiedUrl = url;
    try {
        for(var patterns_1 = (0, $8yqJh.__values)(patterns), patterns_1_1 = patterns_1.next(); !patterns_1_1.done; patterns_1_1 = patterns_1.next()){
            var _c = patterns_1_1.value, pattern = _c.pattern, replacement = _c.replacement;
            modifiedUrl = modifiedUrl.replace(pattern, replacement);
        }
    } catch (e_5_1) {
        e_5 = {
            error: e_5_1
        };
    } finally{
        try {
            if (patterns_1_1 && !patterns_1_1.done && (_b = patterns_1.return)) _b.call(patterns_1);
        } finally{
            if (e_5) throw e_5.error;
        }
    }
    return modifiedUrl;
}
function applyUrlBluePrinters(_a) {
    var url = _a.url, blueprinters = _a.blueprinters;
    var blueprintedUrl = url;
    blueprinters === null || blueprinters === void 0 || blueprinters.forEach(function(urlBlueprinter) {
        return blueprintedUrl = urlBlueprinter(blueprintedUrl);
    });
    return blueprintedUrl;
}
function resolvePageContext(url) {
    var _a;
    var page_url_blueprint = applyUrlBluePrinters({
        url: url,
        blueprinters: (_a = getSdkConfig().urlBlueprinters) === null || _a === void 0 ? void 0 : _a.pageUrlBlueprinters
    });
    var page_fragments = getUrlFragments(page_url_blueprint);
    return {
        page_url: url.slice(0, MAX_CHARACTERS),
        page_url_blueprint: page_url_blueprint,
        page_fragments: page_fragments,
        referrer: document.referrer
    };
}
function deepClone(obj) {
    return JSON.parse(JSON.stringify(obj));
}
function partition(array, predicate) {
    var e_6, _a;
    var truthyValues = [];
    var falsyValues = [];
    try {
        for(var array_1 = (0, $8yqJh.__values)(array), array_1_1 = array_1.next(); !array_1_1.done; array_1_1 = array_1.next()){
            var element = array_1_1.value;
            if (predicate(element)) truthyValues.push(element);
            else falsyValues.push(element);
        }
    } catch (e_6_1) {
        e_6 = {
            error: e_6_1
        };
    } finally{
        try {
            if (array_1_1 && !array_1_1.done && (_a = array_1.return)) _a.call(array_1);
        } finally{
            if (e_6) throw e_6.error;
        }
    }
    return [
        truthyValues,
        falsyValues
    ];
}
var CoralogixSpanAttributesProcessor = function() {
    function CoralogixSpanAttributesProcessor(labels) {
        var _a;
        this.labels = (_a = {}, _a[CoralogixAttributes.CUSTOM_LABELS] = '{}', _a);
        if (labels) this.labels = labels;
    }
    CoralogixSpanAttributesProcessor.prototype.setCustomLabels = function(labels) {
        this.labels[CoralogixAttributes.CUSTOM_LABELS] = JSON.stringify(labels !== null && labels !== void 0 ? labels : {});
    };
    CoralogixSpanAttributesProcessor.prototype.setInternalLabels = function(labels) {
        var _a;
        this.labels = (0, $8yqJh.__assign)((_a = {}, _a[CoralogixAttributes.CUSTOM_LABELS] = this.labels[CoralogixAttributes.CUSTOM_LABELS], _a), labels ? this.stringifyValues(labels) : {});
    };
    CoralogixSpanAttributesProcessor.prototype.getLabels = function() {
        return JSON.parse(JSON.stringify(this.labels));
    };
    CoralogixSpanAttributesProcessor.prototype.getCustomLabels = function() {
        return JSON.parse(this.labels[CoralogixAttributes.CUSTOM_LABELS]);
    };
    CoralogixSpanAttributesProcessor.prototype.getInternalLabels = function() {
        var labels = (0, $8yqJh.__assign)({}, this.labels);
        delete labels[CoralogixAttributes.CUSTOM_LABELS];
        return labels;
    };
    CoralogixSpanAttributesProcessor.prototype.getUserContext = function() {
        var userContext = this.labels[CoralogixAttributes.USER_CONTEXT];
        return userContext ? JSON.parse("".concat(userContext)) : undefined;
    };
    CoralogixSpanAttributesProcessor.prototype.forceFlush = function() {
        return Promise.resolve();
    };
    CoralogixSpanAttributesProcessor.prototype.onStart = function(span) {
        span.setAttribute(CoralogixAttributes.TIMESTAMP, getNowTime());
        span.setAttributes(this.labels);
    };
    CoralogixSpanAttributesProcessor.prototype.onEnd = function() {};
    CoralogixSpanAttributesProcessor.prototype.shutdown = function() {
        return Promise.resolve();
    };
    CoralogixSpanAttributesProcessor.prototype.stringifyValues = function(labels) {
        var resolvedLabels = {};
        for(var key in labels)resolvedLabels[key] = typeof labels[key] === 'string' ? labels[key] : JSON.stringify(labels[key]);
        return resolvedLabels;
    };
    return CoralogixSpanAttributesProcessor;
}();
var SUPPRESS_TRACING_KEY = (0, $jVu0G.createContextKey)('OpenTelemetry SDK Context Key SUPPRESS_TRACING');
function isTracingSuppressed(context) {
    return context.getValue(SUPPRESS_TRACING_KEY) === true;
}
var BAGGAGE_KEY_PAIR_SEPARATOR = '=';
var BAGGAGE_PROPERTIES_SEPARATOR = ';';
var BAGGAGE_ITEMS_SEPARATOR = ',';
var BAGGAGE_HEADER = 'baggage';
var BAGGAGE_MAX_NAME_VALUE_PAIRS = 180;
var BAGGAGE_MAX_PER_NAME_VALUE_PAIRS = 4096;
var BAGGAGE_MAX_TOTAL_LENGTH = 8192;
var __read = function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
function serializeKeyPairs(keyPairs) {
    return keyPairs.reduce(function(hValue, current) {
        var value = "" + hValue + (hValue !== '' ? BAGGAGE_ITEMS_SEPARATOR : '') + current;
        return value.length > BAGGAGE_MAX_TOTAL_LENGTH ? hValue : value;
    }, '');
}
function getKeyPairs(baggage) {
    return baggage.getAllEntries().map(function(_a) {
        var _b = __read(_a, 2), key = _b[0], value = _b[1];
        var entry = encodeURIComponent(key) + "=" + encodeURIComponent(value.value);
        if (value.metadata !== undefined) entry += BAGGAGE_PROPERTIES_SEPARATOR + value.metadata.toString();
        return entry;
    });
}
function parsePairKeyValue(entry) {
    var valueProps = entry.split(BAGGAGE_PROPERTIES_SEPARATOR);
    if (valueProps.length <= 0) return;
    var keyPairPart = valueProps.shift();
    if (!keyPairPart) return;
    var separatorIndex = keyPairPart.indexOf(BAGGAGE_KEY_PAIR_SEPARATOR);
    if (separatorIndex <= 0) return;
    var key = decodeURIComponent(keyPairPart.substring(0, separatorIndex).trim());
    var value = decodeURIComponent(keyPairPart.substring(separatorIndex + 1).trim());
    var metadata;
    if (valueProps.length > 0) metadata = (0, $3mSe3.baggageEntryMetadataFromString)(valueProps.join(BAGGAGE_PROPERTIES_SEPARATOR));
    return {
        key: key,
        value: value,
        metadata: metadata
    };
}
var W3CBaggagePropagator = function() {
    function W3CBaggagePropagator() {}
    W3CBaggagePropagator.prototype.inject = function(context, carrier, setter) {
        var baggage = (0, $6b1Zv.propagation).getBaggage(context);
        if (!baggage || isTracingSuppressed(context)) return;
        var keyPairs = getKeyPairs(baggage).filter(function(pair) {
            return pair.length <= BAGGAGE_MAX_PER_NAME_VALUE_PAIRS;
        }).slice(0, BAGGAGE_MAX_NAME_VALUE_PAIRS);
        var headerValue = serializeKeyPairs(keyPairs);
        if (headerValue.length > 0) setter.set(carrier, BAGGAGE_HEADER, headerValue);
    };
    W3CBaggagePropagator.prototype.extract = function(context, carrier, getter) {
        var headerValue = getter.get(carrier, BAGGAGE_HEADER);
        var baggageString = Array.isArray(headerValue) ? headerValue.join(BAGGAGE_ITEMS_SEPARATOR) : headerValue;
        if (!baggageString) return context;
        var baggage = {};
        if (baggageString.length === 0) return context;
        var pairs = baggageString.split(BAGGAGE_ITEMS_SEPARATOR);
        pairs.forEach(function(entry) {
            var keyPair = parsePairKeyValue(entry);
            if (keyPair) {
                var baggageEntry = {
                    value: keyPair.value
                };
                if (keyPair.metadata) baggageEntry.metadata = keyPair.metadata;
                baggage[keyPair.key] = baggageEntry;
            }
        });
        if (Object.entries(baggage).length === 0) return context;
        return (0, $6b1Zv.propagation).setBaggage(context, (0, $6b1Zv.propagation).createBaggage(baggage));
    };
    W3CBaggagePropagator.prototype.fields = function() {
        return [
            BAGGAGE_HEADER
        ];
    };
    return W3CBaggagePropagator;
}();
var ExportResultCode;
(function(ExportResultCode) {
    ExportResultCode[ExportResultCode["SUCCESS"] = 0] = "SUCCESS";
    ExportResultCode[ExportResultCode["FAILED"] = 1] = "FAILED";
})(ExportResultCode || (ExportResultCode = {}));
var __values = function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var CompositePropagator = function() {
    function CompositePropagator(config) {
        if (config === void 0) config = {};
        var _a;
        this._propagators = (_a = config.propagators) !== null && _a !== void 0 ? _a : [];
        this._fields = Array.from(new Set(this._propagators.map(function(p) {
            return typeof p.fields === 'function' ? p.fields() : [];
        }).reduce(function(x, y) {
            return x.concat(y);
        }, [])));
    }
    CompositePropagator.prototype.inject = function(context, carrier, setter) {
        var e_1, _a;
        try {
            for(var _b = __values(this._propagators), _c = _b.next(); !_c.done; _c = _b.next()){
                var propagator = _c.value;
                try {
                    propagator.inject(context, carrier, setter);
                } catch (err) {
                    (0, $7Y52R.diag).warn("Failed to inject with " + propagator.constructor.name + ". Err: " + err.message);
                }
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b["return"])) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    };
    CompositePropagator.prototype.extract = function(context, carrier, getter) {
        return this._propagators.reduce(function(ctx, propagator) {
            try {
                return propagator.extract(ctx, carrier, getter);
            } catch (err) {
                (0, $7Y52R.diag).warn("Failed to inject with " + propagator.constructor.name + ". Err: " + err.message);
            }
            return ctx;
        }, context);
    };
    CompositePropagator.prototype.fields = function() {
        return this._fields.slice();
    };
    return CompositePropagator;
}();
var VALID_KEY_CHAR_RANGE = '[_0-9a-z-*/]';
var VALID_KEY = "[a-z]" + VALID_KEY_CHAR_RANGE + "{0,255}";
var VALID_VENDOR_KEY = "[a-z0-9]" + VALID_KEY_CHAR_RANGE + "{0,240}@[a-z]" + VALID_KEY_CHAR_RANGE + "{0,13}";
var VALID_KEY_REGEX = new RegExp("^(?:" + VALID_KEY + "|" + VALID_VENDOR_KEY + ")$");
var VALID_VALUE_BASE_REGEX = /^[ -~]{0,255}[!-~]$/;
var INVALID_VALUE_COMMA_EQUAL_REGEX = /,|=/;
function validateKey(key) {
    return VALID_KEY_REGEX.test(key);
}
function validateValue(value) {
    return VALID_VALUE_BASE_REGEX.test(value) && !INVALID_VALUE_COMMA_EQUAL_REGEX.test(value);
}
var MAX_TRACE_STATE_ITEMS = 32;
var MAX_TRACE_STATE_LEN = 512;
var LIST_MEMBERS_SEPARATOR = ',';
var LIST_MEMBER_KEY_VALUE_SPLITTER = '=';
var TraceState = function() {
    function TraceState(rawTraceState) {
        this._internalState = new Map();
        if (rawTraceState) this._parse(rawTraceState);
    }
    TraceState.prototype.set = function(key, value) {
        var traceState = this._clone();
        if (traceState._internalState.has(key)) traceState._internalState["delete"](key);
        traceState._internalState.set(key, value);
        return traceState;
    };
    TraceState.prototype.unset = function(key) {
        var traceState = this._clone();
        traceState._internalState["delete"](key);
        return traceState;
    };
    TraceState.prototype.get = function(key) {
        return this._internalState.get(key);
    };
    TraceState.prototype.serialize = function() {
        var _this = this;
        return this._keys().reduce(function(agg, key) {
            agg.push(key + LIST_MEMBER_KEY_VALUE_SPLITTER + _this.get(key));
            return agg;
        }, []).join(LIST_MEMBERS_SEPARATOR);
    };
    TraceState.prototype._parse = function(rawTraceState) {
        if (rawTraceState.length > MAX_TRACE_STATE_LEN) return;
        this._internalState = rawTraceState.split(LIST_MEMBERS_SEPARATOR).reverse().reduce(function(agg, part) {
            var listMember = part.trim();
            var i = listMember.indexOf(LIST_MEMBER_KEY_VALUE_SPLITTER);
            if (i !== -1) {
                var key = listMember.slice(0, i);
                var value = listMember.slice(i + 1, part.length);
                if (validateKey(key) && validateValue(value)) agg.set(key, value);
            }
            return agg;
        }, new Map());
        if (this._internalState.size > MAX_TRACE_STATE_ITEMS) this._internalState = new Map(Array.from(this._internalState.entries()).reverse().slice(0, MAX_TRACE_STATE_ITEMS));
    };
    TraceState.prototype._keys = function() {
        return Array.from(this._internalState.keys()).reverse();
    };
    TraceState.prototype._clone = function() {
        var traceState = new TraceState();
        traceState._internalState = new Map(this._internalState);
        return traceState;
    };
    return TraceState;
}();
var TRACE_PARENT_HEADER = 'traceparent';
var TRACE_STATE_HEADER = 'tracestate';
var VERSION = '00';
var VERSION_PART = '(?!ff)[\\da-f]{2}';
var TRACE_ID_PART = '(?![0]{32})[\\da-f]{32}';
var PARENT_ID_PART = '(?![0]{16})[\\da-f]{16}';
var FLAGS_PART = '[\\da-f]{2}';
var TRACE_PARENT_REGEX = new RegExp("^\\s?(" + VERSION_PART + ")-(" + TRACE_ID_PART + ")-(" + PARENT_ID_PART + ")-(" + FLAGS_PART + ")(-.*)?\\s?$");
function parseTraceParent(traceParent) {
    var match = TRACE_PARENT_REGEX.exec(traceParent);
    if (!match) return null;
    if (match[1] === '00' && match[5]) return null;
    return {
        traceId: match[2],
        spanId: match[3],
        traceFlags: parseInt(match[4], 16)
    };
}
var W3CTraceContextPropagator = function() {
    function W3CTraceContextPropagator() {}
    W3CTraceContextPropagator.prototype.inject = function(context, carrier, setter) {
        var spanContext = (0, $g4DKS.trace).getSpanContext(context);
        if (!spanContext || isTracingSuppressed(context) || !(0, $laija.isSpanContextValid)(spanContext)) return;
        var traceParent = VERSION + "-" + spanContext.traceId + "-" + spanContext.spanId + "-0" + Number(spanContext.traceFlags || (0, $kxoQ4.TraceFlags).NONE).toString(16);
        setter.set(carrier, TRACE_PARENT_HEADER, traceParent);
        if (spanContext.traceState) setter.set(carrier, TRACE_STATE_HEADER, spanContext.traceState.serialize());
    };
    W3CTraceContextPropagator.prototype.extract = function(context, carrier, getter) {
        var traceParentHeader = getter.get(carrier, TRACE_PARENT_HEADER);
        if (!traceParentHeader) return context;
        var traceParent = Array.isArray(traceParentHeader) ? traceParentHeader[0] : traceParentHeader;
        if (typeof traceParent !== 'string') return context;
        var spanContext = parseTraceParent(traceParent);
        if (!spanContext) return context;
        spanContext.isRemote = true;
        var traceStateHeader = getter.get(carrier, TRACE_STATE_HEADER);
        if (traceStateHeader) {
            var state = Array.isArray(traceStateHeader) ? traceStateHeader.join(',') : traceStateHeader;
            spanContext.traceState = new TraceState(typeof state === 'string' ? state : undefined);
        }
        return (0, $g4DKS.trace).setSpanContext(context, spanContext);
    };
    W3CTraceContextPropagator.prototype.fields = function() {
        return [
            TRACE_PARENT_HEADER,
            TRACE_STATE_HEADER
        ];
    };
    return W3CTraceContextPropagator;
}();
var _a$1;
var MAX_RUM_EVENTS_PER_REQUEST = 500;
var MAX_RUM_EVENTS = 20000;
var MAX_MS_RECORD_TIME = 60000;
var DEFAULT_RUM_EVENTS = 5000;
var DEFAULT_MS_RECORD_TIME = 10000;
_a$1 = {}, _a$1[CoralogixEventType.WEB_VITALS] = true;
var Request = function() {
    function Request(requestConfig) {
        this.requestConfig = requestConfig;
        this.resolvedUrl = '';
        this.resolvedHeaders = {};
        this.init();
    }
    Request.prototype.getResolvedUrl = function(config) {
        var coralogixDomain = config.coralogixDomain, proxyUrl = config.proxyUrl, ignoreProxyUrlParams = config.ignoreProxyUrlParams;
        var cxEndpoint = "".concat(CoralogixDomainsApiUrlMap[coralogixDomain]).concat(this.requestConfig.suffix);
        if (!proxyUrl) return cxEndpoint;
        if (ignoreProxyUrlParams) return proxyUrl;
        return "".concat(proxyUrl, "?").concat(PROXY_CX_FORWARD_PARAMETER, "=").concat(encodeURIComponent(cxEndpoint));
    };
    Request.prototype.init = function() {
        var _a = getSdkConfig(), proxyUrl = _a.proxyUrl, ignoreProxyUrlParams = _a.ignoreProxyUrlParams, coralogixDomain = _a.coralogixDomain, public_key = _a.public_key;
        var headers = this.requestConfig.headers;
        this.resolvedUrl = this.getResolvedUrl({
            proxyUrl: proxyUrl,
            ignoreProxyUrlParams: ignoreProxyUrlParams,
            coralogixDomain: coralogixDomain
        });
        if (public_key) headers['Authorization'] = "Bearer ".concat(public_key);
        this.resolvedHeaders = headers;
    };
    Request.prototype.send = function(body) {
        return fetch(this.resolvedUrl, {
            method: 'POST',
            headers: this.resolvedHeaders,
            body: body
        }).catch(function(e) {
            return e;
        });
    };
    return Request;
}();
var CxCustomSampler = function() {
    function CxCustomSampler() {}
    CxCustomSampler.prototype.shouldSample = function() {
        return {
            decision: (0, $3ALgF.SamplingDecision).RECORD
        };
    };
    return CxCustomSampler;
}();
function resolveMaxRumEvents(maxRumEvents) {
    if (!maxRumEvents) return DEFAULT_RUM_EVENTS;
    return maxRumEvents > MAX_RUM_EVENTS ? MAX_RUM_EVENTS : maxRumEvents;
}
function resolveMaxRecordTime(maxRecordTime) {
    if (!maxRecordTime) return DEFAULT_MS_RECORD_TIME;
    return maxRecordTime > MAX_MS_RECORD_TIME ? MAX_MS_RECORD_TIME : maxRecordTime;
}
function resolveSessionWithErrorsConfig(config) {
    var _a;
    var _b;
    if (!config) return {
        enable: false
    };
    return (0, $8yqJh.__assign)((0, $8yqJh.__assign)({}, config), {
        maxRumEvents: resolveMaxRumEvents(config.maxRumEvents),
        maxRecordTime: resolveMaxRecordTime(config.maxRecordTime),
        instrumentationsToSend: (_b = config.instrumentationsToSend) !== null && _b !== void 0 ? _b : (_a = {}, _a[CoralogixEventType.WEB_VITALS] = true, _a)
    });
}
function resolveSessionConfig(config) {
    var _a;
    if (!config) return DEFAULT_SESSION_CONFIG;
    return (0, $8yqJh.__assign)((0, $8yqJh.__assign)({}, config), {
        sessionSampleRate: (_a = config.sessionSampleRate) !== null && _a !== void 0 ? _a : 100,
        onlyWithErrorConfig: resolveSessionWithErrorsConfig(config.onlyWithErrorConfig)
    });
}
function resolveSessionRecordingConfig(config) {
    var _a;
    if (config) return (0, $8yqJh.__assign)((0, $8yqJh.__assign)({}, config), {
        sessionRecordingSampleRate: (_a = config.sessionRecordingSampleRate) !== null && _a !== void 0 ? _a : 100
    });
    return;
}
function isSamplingOn(threshold) {
    return threshold > 0 && Math.random() * 100 <= threshold;
}
var isSessionWithError = function() {
    var _a = getSessionManager(), onlySessionWithErrorMode = _a.onlySessionWithErrorMode, cachedLogsSent = _a.cachedLogsSent;
    return onlySessionWithErrorMode && !cachedLogsSent;
};
function getResolvedSampler(resolvedOptions) {
    var sampler = new (0, $3eG03.AlwaysOnSampler)();
    var sessionSampleRate = resolvedOptions.sessionSampleRate, sessionConfig = resolvedOptions.sessionConfig, debug = resolvedOptions.debug, sessionRecordingConfig = resolvedOptions.sessionRecordingConfig;
    var shouldNotTrackSession = !isSamplingOn(sessionSampleRate) || !isSamplingOn(sessionConfig.sessionSampleRate);
    if (shouldNotTrackSession) {
        var shouldAlwaysTrackSessionsWithErrors = sessionConfig === null || sessionConfig === void 0 ? void 0 : sessionConfig.alwaysTrackSessionsWithErrors;
        if (shouldAlwaysTrackSessionsWithErrors) sessionConfig.onlyWithErrorConfig = (0, $8yqJh.__assign)((0, $8yqJh.__assign)({}, sessionConfig.onlyWithErrorConfig), {
            enable: true
        });
        else {
            if (debug) console.debug('CoralogixRum: Session tracking is disabled due to sampling rate');
            sampler = new CxCustomSampler();
            if (sessionRecordingConfig) sessionRecordingConfig.enable = false;
            resolvedOptions.instrumentations = (0, $8yqJh.__assign)((0, $8yqJh.__assign)({}, resolvedOptions.instrumentations), {
                errors: false,
                custom: false,
                web_vitals: false,
                interactions: false,
                long_tasks: false,
                resources: false
            });
        }
    }
    return sampler;
}
function isProcessorShouldStop(isActive) {
    var _a;
    return !isActive || !!((_a = getSessionManager()) === null || _a === void 0 ? void 0 : _a.isIdleActive);
}
var NANOS_IN_SECOND = 1000000000;
var NANOS_PER_MILLISECOND = 1000000;
var MAX_FUTURE_NANOS = 3600 * NANOS_IN_SECOND;
var MAX_PAST_NANOS = 86400 * NANOS_IN_SECOND;
function toOtlpKeyValue(key, value) {
    if (!value) return {
        key: key,
        value: {
            string_value: ''
        }
    };
    switch(typeof value){
        case 'string':
            return {
                key: key,
                value: {
                    string_value: value
                }
            };
        case 'number':
            if (!Number.isFinite(value)) return {
                key: key,
                value: {
                    string_value: String(value)
                }
            };
            return Number.isInteger(value) ? {
                key: key,
                value: {
                    int_value: value
                }
            } : {
                key: key,
                value: {
                    double_value: value
                }
            };
        case 'boolean':
            return {
                key: key,
                value: {
                    bool_value: value
                }
            };
        default:
            return {
                key: key,
                value: {
                    string_value: ''
                }
            };
    }
}
function toOtlpAttributes(attributes) {
    if (!attributes) return [];
    return Object.entries(attributes).map(function(_a) {
        var _b = (0, $8yqJh.__read)(_a, 2), k = _b[0], v = _b[1];
        return toOtlpKeyValue(k, v);
    });
}
function timestampToNanosNumber(timestamp) {
    var _a = (0, $8yqJh.__read)(timestamp, 2), seconds = _a[0], nanos = _a[1];
    return seconds * NANOS_IN_SECOND + nanos;
}
function timestampToNanosString(timestamp) {
    var _a = (0, $8yqJh.__read)(timestamp, 2), seconds = _a[0], nanos = _a[1];
    var secondsPart = String(seconds);
    var nanosPart = String(nanos).padStart(9, '0');
    return secondsPart + nanosPart;
}
function mapStatusCodeToOtlp(code) {
    var _a;
    if (code == null) return undefined;
    var STATUS_CODE_MAP = {
        0: 'STATUS_CODE_UNSET',
        1: 'STATUS_CODE_OK',
        2: 'STATUS_CODE_ERROR'
    };
    return (_a = STATUS_CODE_MAP[code]) !== null && _a !== void 0 ? _a : 'STATUS_CODE_UNSET';
}
function toOtlpStatus(spanStatus) {
    if (!spanStatus) return undefined;
    var code = mapStatusCodeToOtlp(spanStatus.code);
    var message = spanStatus.message;
    if (!code && !message) return undefined;
    return (0, $8yqJh.__assign)({
        code: code !== null && code !== void 0 ? code : 'STATUS_CODE_UNSET'
    }, message ? {
        message: message
    } : {});
}
function isWithinAllowedWindow(start, now) {
    return start <= now + MAX_FUTURE_NANOS && start >= now - MAX_PAST_NANOS;
}
function buildExporterPayload(logs) {
    var e_1, _a;
    var _b;
    var resourceSpans = [];
    var nowUnixNano = Date.now() * NANOS_PER_MILLISECOND;
    try {
        for(var logs_1 = (0, $8yqJh.__values)(logs), logs_1_1 = logs_1.next(); !logs_1_1.done; logs_1_1 = logs_1.next()){
            var entry = logs_1_1.value;
            var instrumentationData = entry.instrumentation_data;
            if (!instrumentationData) continue;
            var spanJson = mapCxSpanToOtlpSpan(instrumentationData.otelSpan);
            if (!spanJson) continue;
            var startNanos = timestampToNanosNumber(instrumentationData.otelSpan.startTime);
            if (!isWithinAllowedWindow(startNanos, nowUnixNano)) continue;
            var resource = mapEntryToOtlpResource(entry, (_b = instrumentationData.otelResource) === null || _b === void 0 ? void 0 : _b.attributes);
            var scopeSpans = {
                spans: [
                    spanJson
                ]
            };
            resourceSpans.push({
                resource: resource,
                scope_spans: [
                    scopeSpans
                ]
            });
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (logs_1_1 && !logs_1_1.done && (_a = logs_1.return)) _a.call(logs_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return {
        resource_spans: resourceSpans
    };
}
function stripOtelFieldsFromLogs(logs) {
    return logs.map(function(_a) {
        _a.instrumentation_data;
        var rest = (0, $8yqJh.__rest)(_a, [
            "instrumentation_data"
        ]);
        return rest;
    });
}
function mapCxSpanToOtlpSpan(span) {
    var _a;
    if (!span.traceId || !span.spanId || !span.name) {
        if (getSdkConfig().debug) {
            console.debug('Missing required span fields: traceId, spanId, name', span);
            return null;
        }
    }
    if (!span.startTime || !span.endTime) {
        if (getSdkConfig().debug) console.debug('Missing span timestamps', span);
        return null;
    }
    var startUnixNano = timestampToNanosString(span.startTime);
    var endUnixNano = timestampToNanosString(span.endTime);
    return (0, $8yqJh.__assign)((0, $8yqJh.__assign)((0, $8yqJh.__assign)({
        trace_id: span.traceId,
        span_id: span.spanId
    }, span.parentSpanId ? {
        parentSpanId: span.parentSpanId
    } : {}), {
        name: (_a = span.name) !== null && _a !== void 0 ? _a : '',
        kind: 'SPAN_KIND_CLIENT',
        start_time_unix_nano: startUnixNano,
        end_time_unix_nano: endUnixNano,
        attributes: toOtlpAttributes(span.attributes)
    }), span.status ? {
        status: toOtlpStatus(span.status)
    } : {});
}
function mapEntryToOtlpResource(entry, extra) {
    var _a;
    var base = {
        'cx.application.name': entry.applicationName,
        'cx.subsystem.name': entry.subsystemName
    };
    var merged = (0, $8yqJh.__assign)((0, $8yqJh.__assign)({}, base), extra !== null && extra !== void 0 ? extra : {});
    if (!('service.name' in merged)) merged['service.name'] = entry.applicationName;
    var version = (_a = entry.version_metadata) === null || _a === void 0 ? void 0 : _a.app_version;
    if (version && !('service.version' in merged)) merged['service.version'] = version;
    var attributes = toOtlpAttributes(merged);
    return attributes.length ? {
        attributes: attributes
    } : {};
}
function buildCustomTraces(logs) {
    var tracesPayload = buildExporterPayload(logs);
    var strippedLogs = stripOtelFieldsFromLogs(logs);
    return {
        tracesPayload: tracesPayload,
        strippedLogs: strippedLogs
    };
}
var CoralogixExporter = function() {
    function CoralogixExporter() {
        var _this = this;
        this.isActive = true;
        this.sdkConfig = getSdkConfig();
        this.request = new Request({
            suffix: CORALOGIX_LOGS_URL_SUFFIX,
            headers: {
                'Content-Type': 'application/json'
            }
        });
        this.batchTimeDelay = BATCH_TIME_DELAY;
        this.invokeLogRequest = function(logs, markCachedLogsSent) {
            if (logs === null || logs === void 0 ? void 0 : logs.length) {
                if (_this.sdkConfig.tracesExporter) logs = _this.buildAndExportOtelTraces(logs);
                _this.request.send(JSON.stringify({
                    logs: logs,
                    skip_enrichment_with_ip: !_this.sdkConfig.collectIPData
                })).then(function() {
                    if (markCachedLogsSent) getSessionManager().cachedLogsSent = true;
                });
            }
        };
    }
    CoralogixExporter.prototype.export = function(spans, resultCallback) {
        if (isProcessorShouldStop(this.isActive)) {
            resultCallback({
                code: ExportResultCode.SUCCESS
            });
            return;
        }
        var currentSpans = spans.reduce(function(cxSpans, span) {
            if (span[CX_MAPPED_SPAN]) cxSpans.push(span[CX_MAPPED_SPAN]);
            return cxSpans;
        }, []);
        if (isSessionWithError()) this.handleSessionWithError(currentSpans);
        else this.invokeLogRequest(currentSpans);
        resultCallback({
            code: ExportResultCode.SUCCESS
        });
    };
    CoralogixExporter.prototype.handleSessionWithError = function(currentSpans) {
        var _this = this;
        var _a = getSessionManager(), maxRumEventsForSessionWithError = _a.maxRumEventsForSessionWithError, instrumentationsToSend = _a.instrumentationsToSend, sessionHasError = _a.sessionHasError;
        var instrumentationLogs = [];
        currentSpans = currentSpans.reduce(function(cxSpans, current) {
            if (instrumentationsToSend && instrumentationsToSend[current.text.cx_rum.event_context.type]) instrumentationLogs.push(current);
            else cxSpans.push(current);
            return cxSpans;
        }, []);
        this.invokeLogRequest(instrumentationLogs);
        var cachedLogs = CxGlobal.cachedLogs = (0, $8yqJh.__spreadArray)((0, $8yqJh.__spreadArray)([], (0, $8yqJh.__read)(CxGlobal.cachedLogs || []), false), (0, $8yqJh.__read)(currentSpans), false);
        var logsCounter = cachedLogs.length;
        if (logsCounter > maxRumEventsForSessionWithError && !sessionHasError) this.clearCachedDataForSessionWithError();
        else if (sessionHasError) {
            if (logsCounter > MAX_RUM_EVENTS_PER_REQUEST) {
                var chunks = [];
                for(var i = 0; i < logsCounter; i += MAX_RUM_EVENTS_PER_REQUEST)chunks.push(cachedLogs.slice(i, i + MAX_RUM_EVENTS_PER_REQUEST));
                chunks.forEach(function(chunk) {
                    cxSetTimeout(function() {
                        return _this.invokeLogRequest(chunk, true);
                    }, _this.batchTimeDelay);
                    _this.batchTimeDelay += BATCH_TIME_DELAY;
                });
                this.clearCachedDataForSessionWithError();
            } else {
                this.invokeLogRequest(cachedLogs, true);
                this.clearCachedDataForSessionWithError();
            }
        }
    };
    CoralogixExporter.prototype.buildAndExportOtelTraces = function(logs) {
        var hasOtelSpanData = logs.some(function(log) {
            return !!log.instrumentation_data;
        });
        if (!hasOtelSpanData) return logs;
        var _a = buildCustomTraces(logs), tracesPayload = _a.tracesPayload, strippedLogs = _a.strippedLogs;
        this.sdkConfig.tracesExporter(tracesPayload);
        return strippedLogs;
    };
    CoralogixExporter.prototype.clearCachedDataForSessionWithError = function() {
        CxGlobal.cachedLogs = [];
        this.batchTimeDelay = BATCH_TIME_DELAY;
    };
    CoralogixExporter.prototype.shutdown = function() {
        this.isActive = false;
        return Promise.resolve();
    };
    return CoralogixExporter;
}();
var CoralogixWebTracerProvider = function(_super) {
    (0, $8yqJh.__extends)(CoralogixWebTracerProvider, _super);
    function CoralogixWebTracerProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return CoralogixWebTracerProvider;
}((0, $a4zuf.WebTracerProvider));
var SessionIdle = function() {
    function SessionIdle(idleConfig) {
        var _this = this;
        this.idleConfig = idleConfig;
        this._isIdleActive = false;
        this.lastResetTime = 0;
        this.THROTTLE_MS = 1000;
        this.stopCallbacks = {};
        this.resetTimeout = function() {
            var _a, _b;
            (_b = (_a = _this.stopCallbacks).clearTimeout) === null || _b === void 0 || _b.call(_a);
            var id = cxSetTimeout(function() {
                _this._isIdleActive = true;
                _this.idleConfig.onIdle();
            }, _this.idleConfig.timeoutDelay);
            _this.stopCallbacks.clearTimeout = function() {
                return cxClearTimeout(id);
            };
        };
        this.idlenessEventsHandler = function() {
            if (_this._isIdleActive) {
                _this._isIdleActive = false;
                _this.idleConfig.onActive();
            }
            var now = Date.now();
            if (now - _this.lastResetTime >= _this.THROTTLE_MS) {
                _this.lastResetTime = now;
                _this.resetTimeout();
            }
        };
    }
    Object.defineProperty(SessionIdle.prototype, "isIdleActive", {
        get: function() {
            return this._isIdleActive;
        },
        enumerable: false,
        configurable: true
    });
    SessionIdle.prototype.startIdleListener = function() {
        this.resetTimeout();
        this.trackActivity();
    };
    SessionIdle.prototype.stopIdleListener = function() {
        Object.values(this.stopCallbacks).forEach(function(cb) {
            return cb();
        });
    };
    SessionIdle.prototype.trackActivity = function() {
        var _a, _b;
        (_b = (_a = this.stopCallbacks).removeActivityListeners) === null || _b === void 0 || _b.call(_a);
        if (typeof CxGlobal.addEventListener === 'function') {
            var stop_1 = addEventListeners(CxGlobal, [
                "touchstart",
                "keydown",
                "mousemove"
            ], this.idlenessEventsHandler, {
                capture: true,
                passive: true
            }).stop;
            this.stopCallbacks.removeActivityListeners = stop_1;
        }
    };
    return SessionIdle;
}();
var _a;
var instrumentationsCompatibility = (_a = {}, _a[XHR_INSTRUMENTATION_NAME] = {
    browsers: [
        {
            name: 'Chrome',
            minVersion: 43
        }
    ],
    warningText: 'XHR'
}, _a[SESSION_RECORDING_INSTRUMENTATION_NAME] = {
    browsers: [
        {
            name: 'Chrome',
            minVersion: 45
        }
    ],
    warningText: 'Session Recording'
}, _a);
function isInstrumentationCompatible(confKey) {
    var _a = getUserAgentData(), browserVersion = _a.browserVersion, browser = _a.browser;
    var majorVersion = parseInt(browserVersion.split('.')[0]);
    var compatibility = instrumentationsCompatibility[confKey];
    if (!compatibility) return true;
    var matchedBrowser = compatibility.browsers.find(function(compatibleBrowser) {
        return compatibleBrowser.name === browser;
    });
    if (!matchedBrowser) return true;
    if (!isNaN(majorVersion) && majorVersion < matchedBrowser.minVersion) {
        console.debug("Coralogix Browser SDK - ".concat(compatibility.warningText, " is not supported on this browser"));
        return false;
    }
    return true;
}

var SessionManager = function(_super) {
    (0, $8yqJh.__extends)(SessionManager, _super);
    function SessionManager(recordConfig) {
        var _a;
        var _this = _super.call(this, {
            timeoutDelay: SESSION_IDLE_TIME,
            onIdle: function() {
                return _this.clearSessionWhenIdle();
            },
            onActive: function() {
                return _this.setSession(true);
            }
        }) || this;
        _this._sessionConfig = getSdkConfig().sessionConfig;
        _this._sessionHasError = false;
        _this._cachedLogsSent = false;
        _this._currentPageTimestamp = getNowTime();
        _this.debugMode = !!((_a = getSdkConfig()) === null || _a === void 0 ? void 0 : _a.debug);
        _this.getPrevSession = function() {
            var _a;
            return JSON.parse((_a = CxGlobal.sessionStorage) === null || _a === void 0 ? void 0 : _a.getItem(PREV_SESSION_KEY));
        };
        _this.getSession = function() {
            var _a;
            var storedSession = JSON.parse((_a = CxGlobal.sessionStorage) === null || _a === void 0 ? void 0 : _a.getItem(SESSION_KEY));
            var now = getNowTime();
            var session;
            if (storedSession) {
                if (storedSession.sessionExpirationDate > now) session = storedSession;
                else {
                    _this.clearSessionWhenIdle();
                    session = _this.setSession(true);
                }
            }
            return session;
        };
        _this.setSession = function(afterIdle) {
            var _a, _b, _c, _d;
            if (afterIdle === void 0) afterIdle = false;
            var shouldkeepSessionAfterReload = (_a = _this._sessionConfig) === null || _a === void 0 ? void 0 : _a.keepSessionAfterReload;
            if (shouldkeepSessionAfterReload) _this.handleRefreshedSessions();
            else _this.createNewSession();
            (_b = CxGlobal.sessionStorage) === null || _b === void 0 || _b.setItem(SESSION_KEY, JSON.stringify(_this.activeSession));
            var sessionRecorder = getSessionRecorder();
            var shouldStartRecordingAfterIdle = afterIdle && !!(sessionRecorder === null || sessionRecorder === void 0 ? void 0 : sessionRecorder.recordingStopDueToTimeout) && !!((_c = _this.sessionRecorderConfig) === null || _c === void 0 ? void 0 : _c.enable);
            if (shouldStartRecordingAfterIdle || (sessionRecorder === null || sessionRecorder === void 0 ? void 0 : sessionRecorder.getIsAutoStartRecording())) (_d = _this.sessionRecorder) === null || _d === void 0 || _d.startRecording();
            return _this.activeSession;
        };
        _this.initializeSession(recordConfig);
        return _this;
    }
    Object.defineProperty(SessionManager.prototype, "currentPageTimestamp", {
        get: function() {
            return this._currentPageTimestamp;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SessionManager.prototype, "currentPageFragment", {
        get: function() {
            return this._currentPageFragment;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SessionManager.prototype, "sessionConfig", {
        get: function() {
            return this._sessionConfig;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SessionManager.prototype, "onlySessionWithErrorMode", {
        get: function() {
            return this._sessionConfig.onlyWithErrorConfig.enable;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SessionManager.prototype, "maxRumEventsForSessionWithError", {
        get: function() {
            return this._sessionConfig.onlyWithErrorConfig.maxRumEvents || 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SessionManager.prototype, "maxRecordTimeForSessionWithError", {
        get: function() {
            return this._sessionConfig.onlyWithErrorConfig.maxRecordTime || 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SessionManager.prototype, "instrumentationsToSend", {
        get: function() {
            return this._sessionConfig.onlyWithErrorConfig.instrumentationsToSend;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SessionManager.prototype, "cachedLogsSent", {
        get: function() {
            return this._cachedLogsSent;
        },
        set: function(val) {
            this._cachedLogsSent = val;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SessionManager.prototype, "sessionHasError", {
        get: function() {
            return this._sessionHasError;
        },
        set: function(value) {
            this._sessionHasError = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SessionManager.prototype, "fingerPrint", {
        get: function() {
            return this._fingerPrint;
        },
        enumerable: false,
        configurable: true
    });
    SessionManager.prototype.updateCurrentPage = function(fragment) {
        if (this.isIdleActive) {
            this._currentPageFragment = undefined;
            return;
        }
        this._currentPageFragment = fragment;
        this._currentPageTimestamp = getNowTime();
    };
    SessionManager.prototype.getSessionKey = function() {
        return SESSION_KEY;
    };
    SessionManager.prototype.getActiveSession = function() {
        return this.activeSession;
    };
    SessionManager.prototype.start = function() {
        this.startIdleListener();
        this.clearPrevSession();
        this.setSession();
        this.setFingerPrint();
    };
    SessionManager.prototype.stop = function() {
        this.stopIdleListener();
    };
    SessionManager.prototype.initializeSession = function(recordConfig) {
        return (0, $8yqJh.__awaiter)(this, void 0, void 0, function() {
            var recordingSamplingEnabled, isSessionRecordingCompatible, SessionRecorder_1;
            return (0, $8yqJh.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        CxGlobal[SESSION_MANAGER_KEY] = this;
                        this.sessionRecorderConfig = recordConfig;
                        if (!(recordConfig === null || recordConfig === void 0 ? void 0 : recordConfig.enable)) return [
                            3,
                            3
                        ];
                        recordingSamplingEnabled = isSamplingOn(recordConfig.sessionRecordingSampleRate);
                        isSessionRecordingCompatible = isInstrumentationCompatible(SESSION_RECORDING_INSTRUMENTATION_NAME);
                        if (!(recordingSamplingEnabled && isSessionRecordingCompatible)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            (parcelRequire("lqIkD"))
                        ];
                    case 1:
                        SessionRecorder_1 = _a.sent().SessionRecorder;
                        this.sessionRecorder = new SessionRecorder_1(this, recordConfig);
                        return [
                            3,
                            3
                        ];
                    case 2:
                        if (getSdkConfig().debug) console.debug('Coralogix Browser SDK - Session recording is disabled');
                        _a.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
    };
    SessionManager.prototype.clearSessionWhenIdle = function() {
        var _a;
        if ((_a = this.sessionRecorder) === null || _a === void 0 ? void 0 : _a.getSessionHasRecording()) this.sessionRecorder.recordingStopDueToTimeout = true;
        this.clearSession();
    };
    SessionManager.prototype.clearPrevSession = function() {
        var _a;
        (_a = CxGlobal.sessionStorage) === null || _a === void 0 || _a.removeItem(PREV_SESSION_KEY);
    };
    SessionManager.prototype.clearSession = function() {
        var _a, _b, _c, _d, _e, _f;
        if (this.debugMode) console.debug('Coralogix Browser SDK - Session expired, clearing session');
        (_a = CxGlobal.sessionStorage) === null || _a === void 0 || _a.setItem(PREV_SESSION_KEY, JSON.stringify((0, $8yqJh.__assign)((0, $8yqJh.__assign)({}, this.activeSession), {
            hasRecording: (_b = this.sessionRecorder) === null || _b === void 0 ? void 0 : _b.getSessionHasRecording(),
            hasScreenshot: (_c = this.sessionRecorder) === null || _c === void 0 ? void 0 : _c.getSessionHasScreenshot()
        })));
        this.clearGlobalSpans();
        this.clearSessionWithErrorMode();
        (_d = getSnapshotManager()) === null || _d === void 0 || _d.resetSnapshot();
        this._currentPageFragment = undefined;
        (_e = this.sessionRecorder) === null || _e === void 0 || _e.stopRecording();
        (_f = CxGlobal.sessionStorage) === null || _f === void 0 || _f.removeItem(SESSION_KEY);
    };
    SessionManager.prototype.clearGlobalSpans = function() {
        var _a;
        (_a = getGlobalSpan()) === null || _a === void 0 || _a.endSpan();
        clearGlobalSpan();
        clearGlobalSpanMap();
    };
    SessionManager.prototype.clearSessionWithErrorMode = function() {
        this.sessionHasError = false;
        this.cachedLogsSent = false;
    };
    SessionManager.prototype.handleRefreshedSessions = function() {
        var _a, _b;
        this.activeSession = this.getSession();
        var recordingSegmentMapFromStorage = JSON.parse(((_a = CxGlobal.sessionStorage) === null || _a === void 0 ? void 0 : _a.getItem(SESSION_RECORDER_SEGMENTS_MAP)) || '{}');
        if (this.activeSession) (_b = getSessionRecorder()) === null || _b === void 0 || _b.updateSegmentIndexCounter(recordingSegmentMapFromStorage);
        else this.createNewSession();
    };
    SessionManager.prototype.createNewSession = function() {
        var now = getNowTime();
        if (this.debugMode) console.debug('Coralogix Browser SDK - Creating new session');
        this.activeSession = {
            sessionId: generateUUID(),
            sessionCreationDate: now,
            sessionExpirationDate: now + SESSION_EXPIRATION_TIME
        };
    };
    SessionManager.prototype.setFingerPrint = function() {
        var generateFingerPrint = function() {
            return generateUUID();
        };
        var storedFingerPrint = CxGlobal.localStorage.getItem(FINGER_PRINT_KEY);
        if (storedFingerPrint) {
            this._fingerPrint = storedFingerPrint;
            return;
        }
        var newFingerPrint = generateFingerPrint();
        CxGlobal.localStorage.setItem(FINGER_PRINT_KEY, newFingerPrint);
        this._fingerPrint = newFingerPrint;
    };
    return SessionManager;
}(SessionIdle);
var reportInternalEvent = function(event, message) {
    var internalInstrumentation = getInternalRumData(INTERNAL_INSTRUMENTATION_NAME);
    internalInstrumentation === null || internalInstrumentation === void 0 || internalInstrumentation.reportInternalEvent(event, message);
};
function handlePropagators(config, tracerProvider) {
    return (0, $8yqJh.__awaiter)(this, void 0, void 0, function() {
        var propagators, _a, propagateB3TraceHeader, propagateAwsXrayTraceHeader, propagateCustomTraceHeader, singleHeader, multiHeader;
        var _b, _c;
        return (0, $8yqJh.__generator)(this, function(_d) {
            if ((_b = config.traceParentInHeader) === null || _b === void 0 ? void 0 : _b.enabled) {
                propagators = [];
                _a = ((_c = config.traceParentInHeader) === null || _c === void 0 ? void 0 : _c.options) || {}, propagateB3TraceHeader = _a.propagateB3TraceHeader, propagateAwsXrayTraceHeader = _a.propagateAwsXrayTraceHeader, propagateCustomTraceHeader = _a.propagateCustomTraceHeader;
                if (!propagateAwsXrayTraceHeader && !propagateB3TraceHeader) propagators = (0, $8yqJh.__spreadArray)((0, $8yqJh.__spreadArray)([], (0, $8yqJh.__read)(propagators), false), [
                    new W3CBaggagePropagator(),
                    new W3CTraceContextPropagator()
                ], false);
                if (propagateAwsXrayTraceHeader) propagators.push(new (0, $9xOok.AWSXRayPropagator)());
                if (propagateB3TraceHeader) {
                    singleHeader = propagateB3TraceHeader.singleHeader, multiHeader = propagateB3TraceHeader.multiHeader;
                    if (singleHeader) propagators.push(new (0, $aUPqT.B3Propagator)());
                    if (multiHeader) propagators.push(new (0, $aUPqT.B3Propagator)({
                        injectEncoding: (0, $iF5nx.B3InjectEncoding).MULTI_HEADER
                    }));
                }
                if (propagateCustomTraceHeader) propagators.push(propagateCustomTraceHeader);
                tracerProvider.register({
                    propagator: new CxPropagator(config, new CompositePropagator({
                        propagators: propagators
                    }))
                });
            }
            return [
                2
            ];
        });
    });
}
var CxPropagator = function() {
    function CxPropagator(config, internalPropagator) {
        this.config = config;
        this.internalPropagator = internalPropagator;
    }
    CxPropagator.prototype.extract = function(context, carrier, getter) {
        return this.internalPropagator.extract(context, carrier, getter);
    };
    CxPropagator.prototype.fields = function() {
        return this.internalPropagator.fields();
    };
    CxPropagator.prototype.inject = function(context, carrier, setter) {
        var _a, _b;
        function checkSpanContextChanges() {
            if (shouldAttachSpanToGlobalSpan(CoralogixEventType.NETWORK_REQUEST)) {
                var globalSpan = getGlobalSpan();
                var currentSpanContext = (0, $g4DKS.trace).getSpanContext(context);
                var globalTraceId = globalSpan.span.spanContext().traceId;
                if (currentSpanContext) {
                    currentSpanContext.traceId = globalTraceId;
                    context = (0, $g4DKS.trace).setSpanContext(context, currentSpanContext);
                }
            }
        }
        var allowedUrls = (_b = (_a = this.config.traceParentInHeader) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.allowedTracingUrls;
        var shouldInjectContext = true;
        if (allowedUrls) {
            var span = (0, $g4DKS.trace).getSpan(context);
            var url = span.attributes[OtelNetworkAttrs.URL];
            shouldInjectContext = isPatternMatch(url, allowedUrls, 'allowedTracingUrls');
        }
        if (shouldInjectContext) {
            checkSpanContextChanges();
            this.internalPropagator.inject(context, carrier, setter);
        }
    };
    return CxPropagator;
}();
function isInitialConfigValid(initConfig) {
    var e_1, _a;
    if (!initConfig) {
        console.warn('CoralogixRum: Initialization configuration missing');
        return;
    }
    if (!initConfig.proxyUrl && !initConfig.public_key) {
        console.warn('CoralogixRum: Public key is missing');
        return;
    }
    try {
        for(var REQUIRED_CONFIG_KEYS_1 = (0, $8yqJh.__values)(REQUIRED_CONFIG_KEYS), REQUIRED_CONFIG_KEYS_1_1 = REQUIRED_CONFIG_KEYS_1.next(); !REQUIRED_CONFIG_KEYS_1_1.done; REQUIRED_CONFIG_KEYS_1_1 = REQUIRED_CONFIG_KEYS_1.next()){
            var requiredProp = REQUIRED_CONFIG_KEYS_1_1.value;
            if (isNil(initConfig[requiredProp])) {
                console.error("CoralogixRum: Initialization aborted. Please provide the required property \"".concat(requiredProp, "\"."));
                return;
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (REQUIRED_CONFIG_KEYS_1_1 && !REQUIRED_CONFIG_KEYS_1_1.done && (_a = REQUIRED_CONFIG_KEYS_1.return)) _a.call(REQUIRED_CONFIG_KEYS_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return true;
}
function validateAndResolveInitConfig(config) {
    var _a, _b, _c, _d;
    if (!isInitialConfigValid(config)) return;
    var ignoreUrls = config.ignoreUrls, urlBlueprinters = config.urlBlueprinters, proxyUrl = config.proxyUrl;
    var resolvedIgnoreUrls = [];
    ignoreUrls && resolvedIgnoreUrls.push.apply(resolvedIgnoreUrls, (0, $8yqJh.__spreadArray)([], (0, $8yqJh.__read)(ignoreUrls), false));
    if (proxyUrl) resolvedIgnoreUrls.push(new RegExp(proxyUrl));
    OPTIONS_DEFAULTS.ignoreUrls && resolvedIgnoreUrls.push.apply(resolvedIgnoreUrls, (0, $8yqJh.__spreadArray)([], (0, $8yqJh.__read)(OPTIONS_DEFAULTS.ignoreUrls), false));
    return (0, $8yqJh.__assign)((0, $8yqJh.__assign)((0, $8yqJh.__assign)({}, OPTIONS_DEFAULTS), config), {
        maskInputTypes: (_a = config.maskInputTypes) !== null && _a !== void 0 ? _a : MASK_INPUT_TYPES_DEFAULT,
        maskClass: (_b = config.maskClass) !== null && _b !== void 0 ? _b : MASK_CLASS_DEFAULT,
        ignoreUrls: resolvedIgnoreUrls,
        urlBlueprinters: resolveUrlBlueprinters(urlBlueprinters),
        sessionSampleRate: (_c = config.sessionSampleRate) !== null && _c !== void 0 ? _c : 100,
        sessionConfig: resolveSessionConfig(config.sessionConfig),
        sessionRecordingConfig: resolveSessionRecordingConfig(config.sessionRecordingConfig),
        memoryUsageConfig: resolveMemoryUsageConfig(config.memoryUsageConfig),
        trackSoftNavigations: !!config.trackSoftNavigations,
        supportMfe: !!config.supportMfe,
        runOutsideAngularZone: (_d = config.runOutsideAngularZone) !== null && _d !== void 0 ? _d : true
    });
}
function resolveMemoryUsageConfig(memoryUsageConfig) {
    var _a;
    if (!memoryUsageConfig) return {
        enabled: false
    };
    return (0, $8yqJh.__assign)((0, $8yqJh.__assign)({}, memoryUsageConfig), {
        interval: (_a = memoryUsageConfig.interval) !== null && _a !== void 0 ? _a : MEMORY_USAGE_DEFAULT_INTERVAL
    });
}
function resolveUrlBlueprinters(urlBlueprinters) {
    if (!urlBlueprinters) return OPTIONS_DEFAULTS.urlBlueprinters;
    var resolvedUrlBlueprinters = {
        pageUrlBlueprinters: [],
        networkUrlBlueprinters: []
    };
    var concatBlueprinters = function(urlBlueprinters) {
        var _a, _b;
        var _c = urlBlueprinters || {}, pageUrlBlueprinters = _c.pageUrlBlueprinters, networkUrlBlueprinters = _c.networkUrlBlueprinters;
        if (pageUrlBlueprinters) (_a = resolvedUrlBlueprinters.pageUrlBlueprinters).push.apply(_a, (0, $8yqJh.__spreadArray)([], (0, $8yqJh.__read)(pageUrlBlueprinters), false));
        if (networkUrlBlueprinters) (_b = resolvedUrlBlueprinters.networkUrlBlueprinters).push.apply(_b, (0, $8yqJh.__spreadArray)([], (0, $8yqJh.__read)(networkUrlBlueprinters), false));
    };
    concatBlueprinters(urlBlueprinters);
    if (OPTIONS_DEFAULTS.urlBlueprinters) concatBlueprinters(OPTIONS_DEFAULTS.urlBlueprinters);
    return resolvedUrlBlueprinters;
}
var SDK_VERSION = '3.7.1';
function shouldDropEvent(cxRumEvent, options) {
    if (isDocumentErrorWithoutMessage(cxRumEvent)) {
        options.debug && console.warn('Document error without message dropped.');
        return true;
    }
    if (isIgnoredError(cxRumEvent, options.ignoreErrors)) {
        options.debug && console.warn('Ignored error dropped.');
        return true;
    }
    return false;
}
function isDocumentErrorWithoutMessage(cxRumEvent) {
    var _a = cxRumEvent || {}, event_context = _a.event_context, error_context = _a.error_context;
    return event_context.type === CoralogixEventType.ERROR && event_context.source === ErrorSource.DOCUMENT && !(error_context === null || error_context === void 0 ? void 0 : error_context.error_message);
}
function isIgnoredError(cxRumEvent, ignoreErrors) {
    if (!cxRumEvent.error_context || !(ignoreErrors === null || ignoreErrors === void 0 ? void 0 : ignoreErrors.length)) return false;
    var errorMessage = cxRumEvent.error_context.error_message || '';
    return stringMatchesSomePattern(errorMessage, ignoreErrors);
}
function processBeforeSend(cxSpan, options) {
    if (!(options === null || options === void 0 ? void 0 : options.beforeSend)) return cxSpan;
    var cxRumEvent = cxSpan.text.cx_rum;
    var editableCxRumEvent = cxRumEventToEditable(cxRumEvent);
    var beforeSendResult = options.beforeSend(editableCxRumEvent);
    if (!validateBeforeSendResult(beforeSendResult)) return null;
    var _a = beforeSendResult, applicationName = _a.version_metadata.app_name, severity = _a.event_context.severity;
    return (0, $8yqJh.__assign)((0, $8yqJh.__assign)({}, cxSpan), {
        applicationName: applicationName,
        severity: severity,
        text: {
            cx_rum: editableToCxRumEvent(beforeSendResult, cxRumEvent)
        }
    });
}
function validateBeforeSendResult(beforeSendResult) {
    if (beforeSendResult == null) return null;
    var requiredKeys = [
        'version_metadata',
        'session_context',
        'page_context',
        'event_context'
    ];
    var isMissingRequiredKey = function() {
        return requiredKeys.some(function(key) {
            return !(beforeSendResult === null || beforeSendResult === void 0 ? void 0 : beforeSendResult[key]);
        });
    };
    if (!isObject(beforeSendResult) || isMissingRequiredKey()) {
        console.warn('CoralogixRum: beforeSend must return null, undefined or a valid event.');
        return null;
    }
    return beforeSendResult;
}
function cxRumEventToEditable(cxRumEvent) {
    var _a = cxRumEvent.session_context, user_id = _a.user_id, user_name = _a.user_name, user_email = _a.user_email, user_metadata = _a.user_metadata;
    cxRumEvent.browser_sdk;
    cxRumEvent.timestamp;
    var rest = (0, $8yqJh.__rest)(cxRumEvent, [
        "session_context",
        "browser_sdk",
        "timestamp"
    ]);
    return (0, $8yqJh.__assign)((0, $8yqJh.__assign)({}, rest), {
        session_context: {
            user_id: user_id,
            user_email: user_email,
            user_name: user_name,
            user_metadata: user_metadata
        }
    });
}
function editableToCxRumEvent(editable, cxRumEvent) {
    return (0, $8yqJh.__assign)((0, $8yqJh.__assign)((0, $8yqJh.__assign)({}, cxRumEvent), editable), {
        session_context: (0, $8yqJh.__assign)((0, $8yqJh.__assign)({}, cxRumEvent.session_context), editable.session_context)
    });
}
function buildCxRumSpanAttributes(attrs) {
    var e_1, _a;
    var result = {};
    try {
        for(var _b = (0, $8yqJh.__values)(Object.entries(attrs)), _c = _b.next(); !_c.done; _c = _b.next()){
            var _d = (0, $8yqJh.__read)(_c.value, 2), key = _d[0], value = _d[1];
            if (value !== undefined && value !== null) result[key] = value;
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return result;
}
function flattenToAttributes(obj, prefix) {
    var e_2, _a;
    var result = {};
    if (!obj) return result;
    try {
        for(var _b = (0, $8yqJh.__values)(Object.entries(obj)), _c = _b.next(); !_c.done; _c = _b.next()){
            var _d = (0, $8yqJh.__read)(_c.value, 2), key = _d[0], value = _d[1];
            if (value != null) result["".concat(prefix).concat(key)] = typeof value === 'string' ? value : JSON.stringify(value);
        }
    } catch (e_2_1) {
        e_2 = {
            error: e_2_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_2) throw e_2.error;
        }
    }
    return result;
}
function buildRumContextAttributes(cxRumEvent, resolvedLabels) {
    var session_context = cxRumEvent.session_context, page_context = cxRumEvent.page_context, event_context = cxRumEvent.event_context, error_context = cxRumEvent.error_context, network_request_context = cxRumEvent.network_request_context;
    var prefixedLabels = flattenToAttributes(resolvedLabels, 'cx_rum.labels.');
    return buildCxRumSpanAttributes((0, $8yqJh.__assign)((0, $8yqJh.__assign)({
        'cx_rum.browser_sdk.version': cxRumEvent.browser_sdk.version,
        'cx_rum.platform': cxRumEvent.platform,
        'cx_rum.environment': cxRumEvent.environment,
        'cx_rum.version_metadata.app_name': cxRumEvent.version_metadata.app_name,
        'cx_rum.version_metadata.app_version': cxRumEvent.version_metadata.app_version
    }, prefixedLabels), {
        'cx_rum.session_context.session_id': session_context === null || session_context === void 0 ? void 0 : session_context.session_id,
        'cx_rum.session_context.os': session_context === null || session_context === void 0 ? void 0 : session_context.os,
        'cx_rum.session_context.osVersion': session_context === null || session_context === void 0 ? void 0 : session_context.osVersion,
        'cx_rum.session_context.browser': session_context === null || session_context === void 0 ? void 0 : session_context.browser,
        'cx_rum.session_context.browserVersion': session_context === null || session_context === void 0 ? void 0 : session_context.browserVersion,
        'cx_rum.session_context.device': session_context === null || session_context === void 0 ? void 0 : session_context.device,
        'cx_rum.session_context.user_agent': session_context === null || session_context === void 0 ? void 0 : session_context.user_agent,
        'cx_rum.session_context.user_email': session_context === null || session_context === void 0 ? void 0 : session_context.user_email,
        'cx_rum.session_context.user_id': session_context === null || session_context === void 0 ? void 0 : session_context.user_id,
        'cx_rum.session_context.user_name': session_context === null || session_context === void 0 ? void 0 : session_context.user_name,
        'cx_rum.page_context.page_fragments': page_context === null || page_context === void 0 ? void 0 : page_context.page_fragments,
        'cx_rum.page_context.page_url_blueprint': page_context === null || page_context === void 0 ? void 0 : page_context.page_url_blueprint,
        'cx_rum.event_context.type': event_context === null || event_context === void 0 ? void 0 : event_context.type,
        'cx_rum.event_context.severity': event_context === null || event_context === void 0 ? void 0 : event_context.severity,
        'cx_rum.error_context.error_type': error_context === null || error_context === void 0 ? void 0 : error_context.error_type,
        'cx_rum.error_context.error_message': error_context === null || error_context === void 0 ? void 0 : error_context.error_message,
        'cx_rum.network_request_context.fragments': network_request_context === null || network_request_context === void 0 ? void 0 : network_request_context.fragments,
        'cx_rum.network_request_context.url': network_request_context === null || network_request_context === void 0 ? void 0 : network_request_context.url,
        'cx_rum.network_request_context.status_code': network_request_context === null || network_request_context === void 0 ? void 0 : network_request_context.status_code,
        'cx_rum.network_request_context.method': network_request_context === null || network_request_context === void 0 ? void 0 : network_request_context.method
    }));
}
var CoralogixSpanMapProcessor = function() {
    function CoralogixSpanMapProcessor() {
        this.sdkConfig = getSdkConfig();
        this.isActive = true;
    }
    CoralogixSpanMapProcessor.prototype.onEnd = function(span) {
        var _a, _b;
        if (isProcessorShouldStop(this.isActive)) return;
        var _c = getSessionManager(), onlySessionWithErrorMode = _c.onlySessionWithErrorMode, getPrevSession = _c.getPrevSession, getSession = _c.getSession, setSession = _c.setSession;
        var session = getSession() || setSession();
        var sessionHasRecording = !!((_a = getSessionRecorder()) === null || _a === void 0 ? void 0 : _a.getSessionHasRecording());
        var sessionHasScreenshot = !!((_b = getSessionRecorder()) === null || _b === void 0 ? void 0 : _b.getSessionHasScreenshot());
        var mappedCxSpan = this._mapToCxSpan(span, session, getPrevSession(), sessionHasRecording, sessionHasScreenshot, onlySessionWithErrorMode);
        if (!shouldDropEvent(mappedCxSpan.text.cx_rum, this.sdkConfig)) {
            var resolvedCxSpan = processBeforeSend(mappedCxSpan, this.sdkConfig);
            if (resolvedCxSpan) {
                var isSeverityError = resolvedCxSpan.severity === CoralogixLogSeverity.Error;
                var sessionHasError = getSessionManager().sessionHasError;
                if (onlySessionWithErrorMode && (isSeverityError || sessionHasError)) {
                    getSessionManager().sessionHasError = true;
                    resolvedCxSpan.text.cx_rum.session_context.hasError = true;
                }
                span[CX_MAPPED_SPAN] = resolvedCxSpan;
            }
        }
    };
    CoralogixSpanMapProcessor.prototype.onStart = function() {};
    CoralogixSpanMapProcessor.prototype.shutdown = function() {
        this.isActive = false;
        return Promise.resolve();
    };
    CoralogixSpanMapProcessor.prototype.forceFlush = function() {
        return Promise.resolve(undefined);
    };
    CoralogixSpanMapProcessor.prototype._mapToCxSpan = function(span, session, prevSession, sessionHasRecording, sessionHasScreenshot, onlySessionWithErrorMode) {
        var _a, _b;
        var _c = session || {}, sessionId = _c.sessionId, sessionCreationDate = _c.sessionCreationDate;
        var _d = prevSession || {}, prevSessionId = _d.sessionId, prevSessionCreationDate = _d.sessionCreationDate, prevSessionHasRecording = _d.hasRecording, prevSessionHasScreenshot = _d.hasScreenshot;
        var attributes = span.attributes, startTime = span.startTime, parentSpanId = span.parentSpanId, name = span.name, endTime = span.endTime, status = span.status, duration = span.duration, kind = span.kind;
        var user_context = JSON.parse(attributes[CoralogixAttributes.USER_CONTEXT]);
        var application_context = JSON.parse(attributes[CoralogixAttributes.APPLICATION_CONTEXT]);
        var application = application_context.application, version = application_context.version;
        var eventType = attributes[CoralogixAttributes.EVENT_TYPE] || span[CoralogixAttributes.EVENT_TYPE];
        var eventTypeContext = this._getEventTypeContext(attributes, eventType, span);
        var _e = span.spanContext(), spanId = _e.spanId, traceId = _e.traceId;
        var resourceAttributes = (0, $8yqJh.__assign)((0, $8yqJh.__assign)({}, (_a = span.resource) === null || _a === void 0 ? void 0 : _a.attributes), {
            'service.name': application
        });
        var fingerPrint = getSessionManager().fingerPrint;
        var labels = JSON.parse(attributes[CoralogixAttributes.CUSTOM_LABELS]);
        var isErrorWithStacktrace = !!((_b = eventTypeContext === null || eventTypeContext === void 0 ? void 0 : eventTypeContext.error_context) === null || _b === void 0 ? void 0 : _b.original_stacktrace);
        var version_metadata = {
            app_name: application,
            app_version: version
        };
        var severity = (attributes === null || attributes === void 0 ? void 0 : attributes[CoralogixAttributes.SEVERITY]) || CoralogixLogSeverity.Info;
        var timestamp = attributes[CoralogixAttributes.TIMESTAMP] || getNowTime();
        if (timestamp < sessionCreationDate) timestamp = getNowTime();
        var cxSpan = {
            version_metadata: version_metadata,
            applicationName: application,
            subsystemName: 'cx_rum',
            isErrorWithStacktrace: isErrorWithStacktrace,
            severity: severity,
            timestamp: timestamp,
            text: {
                cx_rum: (0, $8yqJh.__assign)((0, $8yqJh.__assign)({
                    fingerPrint: fingerPrint,
                    platform: 'browser',
                    timestamp: timestamp
                }, eventTypeContext), {
                    browser_sdk: {
                        version: SDK_VERSION
                    },
                    version_metadata: version_metadata,
                    session_context: (0, $8yqJh.__assign)((0, $8yqJh.__assign)((0, $8yqJh.__assign)((0, $8yqJh.__assign)({}, user_context), {
                        session_id: sessionId,
                        session_creation_date: sessionCreationDate,
                        prev_session: prevSessionId ? {
                            session_id: prevSessionId,
                            session_creation_date: prevSessionCreationDate,
                            hasRecording: prevSessionHasRecording,
                            hasScreenshot: prevSessionHasScreenshot
                        } : undefined,
                        hasRecording: sessionHasRecording,
                        hasScreenshot: sessionHasScreenshot,
                        user_agent: navigator.userAgent
                    }), getUserAgentData()), {
                        onlyWithErrorMode: onlySessionWithErrorMode
                    }),
                    page_context: span[CoralogixAttributes.PAGE_CONTEXT],
                    isNavigationEvent: !!span[CoralogixAttributes.IS_NAVIGATION_EVENT],
                    event_context: {
                        type: eventType,
                        source: attributes[CoralogixAttributes.SOURCE],
                        severity: severity
                    },
                    labels: labels,
                    environment: attributes[CoralogixAttributes.ENVIRONMENT] || ''
                })
            }
        };
        var resolvedLabels = this.resolveLabels(cxSpan.text.cx_rum);
        if (shouldAddOtelAttr(span)) {
            cxSpan.text.cx_rum.spanId = spanId;
            cxSpan.text.cx_rum.traceId = traceId;
            cxSpan.text.cx_rum.parentSpanId = parentSpanId;
            cxSpan.instrumentation_data = {
                otelSpan: {
                    spanId: spanId,
                    traceId: traceId,
                    parentSpanId: parentSpanId,
                    startTime: startTime,
                    endTime: endTime,
                    status: severity === CoralogixLogSeverity.Error ? (0, $8yqJh.__assign)((0, $8yqJh.__assign)({}, status), {
                        code: SpanStatusCode.ERROR
                    }) : status,
                    kind: kind,
                    duration: duration,
                    sessionId: sessionId,
                    name: name,
                    attributes: buildRumContextAttributes(cxSpan.text.cx_rum, resolvedLabels)
                },
                otelResource: {
                    attributes: resourceAttributes
                }
            };
        }
        this.resolveContextFromSpan(cxSpan, span, eventType);
        cxSpan.text.cx_rum.labels = resolvedLabels;
        return cxSpan;
    };
    CoralogixSpanMapProcessor.prototype.resolveContextFromSpan = function(cxSpan, span, eventType) {
        switch(eventType){
            case CoralogixEventType.CUSTOM_MEASUREMENT:
                cxSpan.text.cx_rum.custom_measurement_context = span[CoralogixAttributes.CUSTOM_MEASUREMENT_CONTEXT];
                break;
            case CoralogixEventType.MEMORY_USAGE:
                cxSpan.text.cx_rum.memory_usage_context = span[CoralogixAttributes.MEMORY_USAGE_CONTEXT];
                break;
            case CoralogixEventType.SCREENSHOT:
                cxSpan.text.cx_rum.screenshot_context = span[CoralogixAttributes.SCREENSHOT_CONTEXT];
                break;
        }
    };
    CoralogixSpanMapProcessor.prototype._getEventTypeContext = function(spanAttributes, eventType, span) {
        var _a;
        switch(eventType){
            case CoralogixEventType.ERROR:
                var errorMessage = spanAttributes[CoralogixAttributes.ERROR.MESSAGE];
                var errorCustomData = span[ErrorAttributes.DATA];
                var originalStackTrace = span[ErrorAttributes.STACK];
                return {
                    error_context: {
                        error_type: spanAttributes[CoralogixAttributes.ERROR.TYPE],
                        error_message: errorMessage,
                        original_stacktrace: originalStackTrace,
                        error_custom_data: errorCustomData
                    }
                };
            case CoralogixEventType.NETWORK_REQUEST:
                var url = spanAttributes[OtelNetworkAttrs.URL];
                var url_blueprint = applyUrlBluePrinters({
                    url: url,
                    blueprinters: (_a = this.sdkConfig.urlBlueprinters) === null || _a === void 0 ? void 0 : _a.networkUrlBlueprinters
                });
                return {
                    network_request_context: {
                        method: spanAttributes[OtelNetworkAttrs.METHOD],
                        status_code: spanAttributes[OtelNetworkAttrs.STATUS_CODE],
                        url: url,
                        url_blueprint: url_blueprint,
                        fragments: getUrlFragments(url_blueprint),
                        host: spanAttributes[OtelNetworkAttrs.HOST],
                        schema: spanAttributes[OtelNetworkAttrs.SCHEME],
                        status_text: spanAttributes[OtelNetworkAttrs.STATUS_TEXT],
                        duration: hrTimeToMilliseconds(span === null || span === void 0 ? void 0 : span.duration),
                        source: spanAttributes[CoralogixAttributes.SOURCE],
                        response_content_length: spanAttributes[OtelNetworkAttrs.RESPONSE_CONTENT_LENGTH],
                        request_headers: span[NetworkInstrumentationAttributes.REQUEST_HEADERS],
                        request_payload: span[NetworkInstrumentationAttributes.REQUEST_PAYLOAD],
                        response_headers: span[NetworkInstrumentationAttributes.RESPONSE_HEADERS],
                        response_payload: span[NetworkInstrumentationAttributes.RESPONSE_PAYLOAD]
                    }
                };
            case CoralogixEventType.LOG:
                if (spanAttributes[CoralogixAttributes.LOG]) {
                    var cxLog = JSON.parse(spanAttributes[CoralogixAttributes.LOG]);
                    return {
                        log_context: {
                            message: cxLog.message,
                            data: cxLog === null || cxLog === void 0 ? void 0 : cxLog.data
                        }
                    };
                }
                return {
                    log_context: {
                        message: ''
                    }
                };
            case CoralogixEventType.INTERNAL:
                var internalContext = JSON.parse(spanAttributes[CoralogixAttributes.INTERNAL]);
                var _b = internalContext || {}, event_1 = _b.event, data = _b.data;
                return {
                    internal_context: {
                        event: event_1,
                        data: data
                    }
                };
            case CoralogixEventType.USER_INTERACTION:
                return {
                    interaction_context: {
                        target_element: spanAttributes[CoralogixAttributes.TARGET_ELEMENT],
                        event_name: spanAttributes[CoralogixAttributes.INTERACTION_EVENT_NAME],
                        target_element_inner_text: spanAttributes[CoralogixAttributes.ELEMENT_INNER_TEXT],
                        element_id: spanAttributes[CoralogixAttributes.ELEMENT_ID],
                        element_classes: spanAttributes[CoralogixAttributes.ELEMENT_CLASSES],
                        target_element_type: spanAttributes[CoralogixAttributes.TARGET_ELEMENT_TYPE]
                    }
                };
            case CoralogixEventType.WEB_VITALS:
                var webVitalsContext = JSON.parse(spanAttributes[WEB_VITALS_INSTRUMENTATION_NAME]);
                return {
                    web_vitals_context: webVitalsContext
                };
            case CoralogixEventType.LONG_TASK:
                var longTaskContext = JSON.parse(spanAttributes[CoralogixEventType.LONG_TASK]);
                return {
                    longtask_context: longTaskContext
                };
            case CoralogixEventType.RESOURCES:
                var resourceContext = JSON.parse(spanAttributes[RESOURCES_INSTRUMENTATION_NAME]);
                var fragments = getUrlFragments(resourceContext.name);
                return {
                    resource_context: (0, $8yqJh.__assign)((0, $8yqJh.__assign)({}, resourceContext), {
                        fragments: fragments
                    })
                };
        }
        return {};
    };
    CoralogixSpanMapProcessor.prototype.resolveLabels = function(cxRumEvent) {
        var _a, _b, _c;
        var allLabels = cxRumEvent.labels;
        var labelProviders = (_a = this.sdkConfig) === null || _a === void 0 ? void 0 : _a.labelProviders;
        if (labelProviders === null || labelProviders === void 0 ? void 0 : labelProviders.length) {
            var pageUrlLabelProviders = getInternalRumData(PAGE_URL_LABEL_PROVIDERS_KEY);
            var networkUrlLabelProviders = getInternalRumData(NETWORK_URL_LABEL_PROVIDERS_KEY);
            var networkRequestFragment = (_b = cxRumEvent.network_request_context) === null || _b === void 0 ? void 0 : _b.fragments;
            var pageFragment = (_c = cxRumEvent.page_context) === null || _c === void 0 ? void 0 : _c.page_fragments;
            var labelsFromProviders = (0, $8yqJh.__assign)((0, $8yqJh.__assign)({}, pageFragment ? this.getLabelsByLabelProviders(pageUrlLabelProviders, cxRumEvent, pageFragment) : {}), networkRequestFragment ? this.getLabelsByLabelProviders(networkUrlLabelProviders, cxRumEvent, networkRequestFragment) : {});
            allLabels = (0, $8yqJh.__assign)((0, $8yqJh.__assign)({}, allLabels), labelsFromProviders);
        }
        return allLabels;
    };
    CoralogixSpanMapProcessor.prototype.getLabelsByLabelProviders = function(labelProviders, cxRumEvent, url) {
        var e_1, _a;
        var allLabels = {};
        var cxRumEventClone = deepClone(cxRumEvent);
        try {
            for(var labelProviders_1 = (0, $8yqJh.__values)(labelProviders), labelProviders_1_1 = labelProviders_1.next(); !labelProviders_1_1.done; labelProviders_1_1 = labelProviders_1.next()){
                var labelProvider = labelProviders_1_1.value;
                allLabels = (0, $8yqJh.__assign)((0, $8yqJh.__assign)({}, allLabels), labelProvider.providerFunc(url, cxRumEventClone));
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (labelProviders_1_1 && !labelProviders_1_1.done && (_a = labelProviders_1.return)) _a.call(labelProviders_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return allLabels;
    };
    return CoralogixSpanMapProcessor;
}();
var CoralogixSnapshotSpanProcessor = function() {
    function CoralogixSnapshotSpanProcessor() {
        this.isActive = true;
    }
    CoralogixSnapshotSpanProcessor.prototype.forceFlush = function() {
        return Promise.resolve();
    };
    CoralogixSnapshotSpanProcessor.prototype.onEnd = function(span) {
        if (isProcessorShouldStop(this.isActive) || !span[CX_MAPPED_SPAN]) return;
        var cxSpan = span[CX_MAPPED_SPAN];
        if (this.isSnapshotPrepared(span)) this.createSnapshot(cxSpan);
        else cxSpan.text.cx_rum.isSnapshotEvent = false;
    };
    CoralogixSnapshotSpanProcessor.prototype.onStart = function(span, parentContext) {};
    CoralogixSnapshotSpanProcessor.prototype.shutdown = function() {
        this.isActive = false;
        return Promise.resolve();
    };
    CoralogixSnapshotSpanProcessor.prototype.createSnapshot = function(cxSpan) {
        var _a = getSnapshotManager().currentSnapshot;
        _a.timestamp;
        var snapshotContext = (0, $8yqJh.__rest)(_a, [
            "timestamp"
        ]);
        cxSpan.text.cx_rum.isSnapshotEvent = true;
        cxSpan.text.cx_rum.snapshot_context = snapshotContext;
    };
    CoralogixSnapshotSpanProcessor.prototype.isSnapshotPrepared = function(span) {
        var _a;
        var _b = span.attributes, _c = CoralogixAttributes.TIMESTAMP, spanTimestamp = _b[_c], _d = CoralogixAttributes.EVENT_TYPE, spanType = _b[_d], _e = CoralogixAttributes.SEVERITY, spanSeverity = _b[_e];
        var shouldCreateSnapshot = false;
        var _f = getSnapshotManager(), fragmentsState = _f.fragmentsState, updateSnapshot = _f.updateSnapshot, currentSnapshot = _f.currentSnapshot, isSnapshotSentDueToRecording = _f.isSnapshotSentDueToRecording;
        var snapshotTimestamp = currentSnapshot.timestamp, actionCount = currentSnapshot.actionCount, errorCount = currentSnapshot.errorCount;
        var pageContext = span[CoralogixAttributes.PAGE_CONTEXT];
        if (pageContext && !fragmentsState.has(pageContext.page_fragments)) {
            fragmentsState.add(pageContext.page_fragments);
            updateSnapshot({
                timestamp: getNowTime(),
                viewCount: fragmentsState.size
            });
            shouldCreateSnapshot = true;
        }
        if (spanSeverity === CoralogixLogSeverity.Error) {
            updateSnapshot({
                timestamp: getNowTime(),
                errorCount: errorCount + 1
            });
            shouldCreateSnapshot = true;
        }
        if (((_a = getSessionRecorder()) === null || _a === void 0 ? void 0 : _a.getSessionHasRecording()) && !isSnapshotSentDueToRecording) {
            updateSnapshot({
                timestamp: getNowTime(),
                hasRecording: true
            });
            getSnapshotManager().isSnapshotSentDueToRecording = true;
            shouldCreateSnapshot = true;
        }
        if (spanType === CoralogixEventType.DOM) {
            updateSnapshot({
                timestamp: getNowTime()
            });
            shouldCreateSnapshot = true;
        }
        if (spanType === CoralogixEventType.SCREENSHOT) updateSnapshot({
            hasScreenshot: true
        });
        if (spanTimestamp - snapshotTimestamp >= millisecondsPerMinute) {
            updateSnapshot({
                timestamp: getNowTime()
            });
            shouldCreateSnapshot = true;
        }
        if (spanType === CoralogixEventType.USER_INTERACTION) updateSnapshot({
            actionCount: actionCount + 1
        });
        if (getSnapshotManager().shouldTriggerSnapshotContext) {
            shouldCreateSnapshot = true;
            getSnapshotManager().shouldTriggerSnapshotContext = false;
        }
        return shouldCreateSnapshot;
    };
    return CoralogixSnapshotSpanProcessor;
}();
var SnapshotManager = function() {
    function SnapshotManager() {
        var _this = this;
        this._shouldTriggerSnapshotContext = false;
        this.updateSnapshot = function(overrides) {
            _this._currentSnapshot = (0, $8yqJh.__assign)((0, $8yqJh.__assign)({}, _this._currentSnapshot), overrides);
        };
        this.resetSnapshot = function() {
            _this._currentSnapshot = (0, $8yqJh.__assign)((0, $8yqJh.__assign)({}, INITIAL_SNAPSHOT_CONTEXT), {
                timestamp: getNowTime()
            });
            _this._fragmentsState = new Set();
            _this._isSnapshotSentDueToRecording = false;
        };
        CxGlobal[SNAPSHOT_MANAGER_KEY] = this;
        this.resetSnapshot();
    }
    Object.defineProperty(SnapshotManager.prototype, "fragmentsState", {
        get: function() {
            return this._fragmentsState;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SnapshotManager.prototype, "currentSnapshot", {
        get: function() {
            return this._currentSnapshot;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SnapshotManager.prototype, "isSnapshotSentDueToRecording", {
        get: function() {
            return this._isSnapshotSentDueToRecording;
        },
        set: function(value) {
            this._isSnapshotSentDueToRecording = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SnapshotManager.prototype, "shouldTriggerSnapshotContext", {
        get: function() {
            return this._shouldTriggerSnapshotContext;
        },
        set: function(value) {
            this._shouldTriggerSnapshotContext = value;
        },
        enumerable: false,
        configurable: true
    });
    return SnapshotManager;
}();
var CoralogixNavigationProcessor = function() {
    function CoralogixNavigationProcessor() {
        this.isResolving = false;
    }
    CoralogixNavigationProcessor.prototype.forceFlush = function() {
        return Promise.resolve();
    };
    CoralogixNavigationProcessor.prototype.onEnd = function(span) {};
    CoralogixNavigationProcessor.prototype.onStart = function(span) {
        if (this.isResolving) return;
        this.isResolving = true;
        try {
            var pageContext = resolvePageContext(location.href);
            if (pageContext) {
                span[CoralogixAttributes.PAGE_CONTEXT] = pageContext;
                var currentPageFragment = getSessionManager().currentPageFragment;
                var page_fragments = pageContext.page_fragments;
                if (currentPageFragment !== page_fragments) {
                    getSessionManager().updateCurrentPage(page_fragments);
                    span[CoralogixAttributes.IS_NAVIGATION_EVENT] = true;
                }
            }
        } finally{
            this.isResolving = false;
        }
    };
    CoralogixNavigationProcessor.prototype.shutdown = function() {
        return Promise.resolve();
    };
    return CoralogixNavigationProcessor;
}();
function getTiming(duration) {
    if (typeof duration === 'number') return duration;
    return getNowTime() - getSessionManager().currentPageTimestamp;
}
if (supportedPerformanceTypes === null || supportedPerformanceTypes === void 0 ? void 0 : supportedPerformanceTypes.has(PerformanceTypes.LongTask)) {
    var ttiHandler_1 = CxGlobal.__tti = {
        e: []
    };
    ttiHandler_1.o = new PerformanceObserver(function(list) {
        ttiHandler_1.e = ttiHandler_1.e.concat(list.getEntries());
    });
    observeIfSupported(ttiHandler_1.o, PerformanceTypes.LongTask);
}
var isInited = false;
var _deregisterInstrumentations;
var _customInstrumentation;
var errorsInstrumentation;
var customMeasurementInstrumentation;
var memoryUsageInstrumentation;
var screenshotInstrumentation;
var tracerProvider;
var attributesProcessor;
var snapshotProcessor;
var spanMapProcessor;
var navigationProcessor;
var exporter;
var timeMeasurementTracker;
var CoralogixRum = {
    get isInited () {
        return isInited;
    },
    init: function(options) {
        var _a, _b;
        var _this = this;
        try {
            if (isInited) {
                if (options === null || options === void 0 ? void 0 : options.debug) console.debug('CoralogixRum already initialized, skipping init');
                return;
            }
            if (!CxGlobal.sessionStorage) {
                console.warn('CoralogixRum: Non-browser environment detected, aborting');
                return;
            }
            if (typeof Symbol !== 'function') {
                console.warn('CoralogixRum: browser not supported, disabling instrumentation.');
                return;
            }
            var resolvedOptions_1 = validateAndResolveInitConfig(options);
            if (!resolvedOptions_1) return;
            CxGlobal[USER_AGENT_KEY] = parseUserAgent(navigator.userAgent);
            CxGlobal[SDK_CONFIG_KEY] = resolvedOptions_1;
            var sampler = getResolvedSampler(resolvedOptions_1);
            if (!resolvedOptions_1.debug && !resolvedOptions_1.public_key) console.warn('rumAuth will be required in the future');
            timeMeasurementTracker = new TimeMeasurementTracker();
            new SessionManager(resolvedOptions_1.sessionRecordingConfig).start();
            var ignoreUrls_1 = resolvedOptions_1.ignoreUrls, labels = resolvedOptions_1.labels, user_context = resolvedOptions_1.user_context, application = resolvedOptions_1.application, version = resolvedOptions_1.version, traceParentInHeader_1 = resolvedOptions_1.traceParentInHeader, environment = resolvedOptions_1.environment;
            tracerProvider = new CoralogixWebTracerProvider({
                sampler: sampler
            });
            var pluginDefaults_1 = {};
            var instrumentations = INSTRUMENTATIONS.map(function(_a) {
                var _b, _c;
                var Instrument = _a.Instrument, confKey = _a.confKey, disable = _a.disable;
                var pluginConf = getInstrumentationConfig((_b = resolvedOptions_1 === null || resolvedOptions_1 === void 0 ? void 0 : resolvedOptions_1.instrumentations) === null || _b === void 0 ? void 0 : _b[confKey], pluginDefaults_1, disable);
                if (pluginConf) {
                    var instrumentation = void 0;
                    switch(confKey){
                        case CoralogixEventType.WORKER:
                            if (resolvedOptions_1.workerSupport) instrumentation = new Instrument(pluginConf, errorsInstrumentation, _this);
                            break;
                        case ERROR_INSTRUMENTATION_NAME:
                            instrumentation = new Instrument(pluginConf);
                            errorsInstrumentation = instrumentation;
                            break;
                        case FETCH_INSTRUMENTATION_NAME:
                        case XHR_INSTRUMENTATION_NAME:
                            if (confKey === XHR_INSTRUMENTATION_NAME) {
                                var isXhrCompatible = isInstrumentationCompatible(XHR_INSTRUMENTATION_NAME);
                                if (!isXhrCompatible) return;
                            }
                            instrumentation = new Instrument((0, $8yqJh.__assign)((0, $8yqJh.__assign)({}, pluginConf), {
                                ignoreUrls: ignoreUrls_1,
                                traceParentInHeader: traceParentInHeader_1
                            }));
                            break;
                        case CoralogixEventType.INTERNAL:
                            instrumentation = new Instrument(pluginConf);
                            saveInternalRumData(INTERNAL_INSTRUMENTATION_NAME, instrumentation);
                            break;
                        case CoralogixEventType.SCREENSHOT:
                            if ((_c = resolvedOptions_1.sessionRecordingConfig) === null || _c === void 0 ? void 0 : _c.enable) {
                                instrumentation = new Instrument(pluginConf);
                                screenshotInstrumentation = instrumentation;
                            }
                            break;
                        case CoralogixEventType.MEMORY_USAGE:
                            if (resolvedOptions_1.memoryUsageConfig.enabled && isMeasureUserAgentSpecificMemoryAllowed()) {
                                instrumentation = new Instrument(pluginConf);
                                memoryUsageInstrumentation = instrumentation;
                            }
                            break;
                        default:
                            instrumentation = new Instrument(pluginConf);
                    }
                    if (instrumentation instanceof CoralogixCustomLogInstrumentation) _customInstrumentation = instrumentation;
                    if (instrumentation instanceof CoralogixCustomMeasurementInstrumentation) customMeasurementInstrumentation = instrumentation;
                    return instrumentation;
                }
                return null;
            }).filter(function(instrument) {
                return Boolean(instrument);
            });
            var mergedUserContext = (0, $8yqJh.__assign)((0, $8yqJh.__assign)({}, OPTIONS_DEFAULTS.user_context), user_context);
            attributesProcessor = new CoralogixSpanAttributesProcessor((0, $8yqJh.__assign)((_a = {}, _a[CoralogixAttributes.APPLICATION_CONTEXT] = JSON.stringify({
                application: application,
                version: version
            }), _a[CoralogixAttributes.USER_CONTEXT] = JSON.stringify(mergedUserContext), _a), environment ? (_b = {}, _b[CoralogixAttributes.ENVIRONMENT] = environment, _b) : {}));
            if (labels) attributesProcessor.setCustomLabels(labels);
            setAttrProcessor(attributesProcessor);
            tracerProvider.addSpanProcessor(attributesProcessor);
            navigationProcessor = new CoralogixNavigationProcessor();
            tracerProvider.addSpanProcessor(navigationProcessor);
            spanMapProcessor = new CoralogixSpanMapProcessor();
            tracerProvider.addSpanProcessor(spanMapProcessor);
            new SnapshotManager();
            snapshotProcessor = new CoralogixSnapshotSpanProcessor();
            tracerProvider.addSpanProcessor(snapshotProcessor);
            tracerProvider.addSpanProcessor(new (0, $956M5.BatchSpanProcessor)(exporter = new CoralogixExporter(), {
                maxExportBatchSize: MAX_EXPORT_BATCH_SIZE,
                scheduledDelayMillis: SCHEDULE_DELAY_MILLIS
            }));
            handlePropagators(options, tracerProvider);
            _deregisterInstrumentations = (0, $5i7vv.registerInstrumentations)({
                tracerProvider: tracerProvider,
                instrumentations: instrumentations
            });
            var _c = (0, $8yqJh.__read)(partition(resolvedOptions_1.labelProviders || [], function(_a) {
                var urlType = _a.urlType;
                return urlType === UrlType.PAGE || !urlType;
            }), 2), pageUrlLabelProviders = _c[0], networkUrlLabelProviders = _c[1];
            saveInternalRumData(PAGE_URL_LABEL_PROVIDERS_KEY, pageUrlLabelProviders);
            saveInternalRumData(NETWORK_URL_LABEL_PROVIDERS_KEY, networkUrlLabelProviders);
            isInited = true;
            if (options === null || options === void 0 ? void 0 : options.debug) console.debug('Coralogix Browser SDK - initialization has completed');
            reportInternalEvent('init');
        } catch (err) {
            console.warn('Coralogix Browser SDK - initialization failed: ', err);
        }
    },
    getCustomTracer: function(ignoredList) {
        var _a, _b;
        if (!isInited) {
            console.debug('CoralogixRum must be initiated before getting custom tracer');
            return;
        }
        if (!((_b = (_a = getSdkConfig()) === null || _a === void 0 ? void 0 : _a.traceParentInHeader) === null || _b === void 0 ? void 0 : _b.enabled)) {
            console.debug('Coralogix Browser SDK - TraceParentInHeader is not enabled');
            return;
        }
        if (getActiveCustomTracer()) {
            console.warn('Coralogix Browser SDK - Custom tracer already exists');
            return;
        }
        var tracer = tracerProvider.getTracer(MAIN_TRACER_KEY);
        setCustomTracer(tracer);
        return {
            startGlobalSpan: function(name, labels) {
                if (getGlobalSpan()) {
                    console.warn('Coralogix Browser SDK - Global span already exists');
                    return;
                }
                setCustomTracerIgnoredInstruments((ignoredList === null || ignoredList === void 0 ? void 0 : ignoredList.ignoredInstruments) || []);
                var globalSpan = tracer.startSpan(name);
                globalSpan[CoralogixAttributes.EVENT_TYPE] = CoralogixEventType.CUSTOM_SPAN;
                if (labels) setCustomLabelsForSpan(globalSpan, labels);
                markSpanAsOtelToSend(globalSpan);
                var globalSpanModel = {
                    span: globalSpan,
                    withContext: function(fn) {
                        return (0, $4e6si.context).with((0, $g4DKS.trace).setSpan((0, $4e6si.context).active(), globalSpan), fn);
                    },
                    endSpan: function() {
                        globalSpan === null || globalSpan === void 0 || globalSpan.end();
                        clearGlobalSpan();
                    },
                    startCustomSpan: function(name, labels) {
                        var customSpan;
                        (0, $4e6si.context).with((0, $g4DKS.trace).setSpan((0, $4e6si.context).active(), globalSpan), function() {
                            customSpan = tracer.startSpan(name);
                            customSpan[CoralogixAttributes.EVENT_TYPE] = CoralogixEventType.CUSTOM_SPAN;
                            if (labels) setCustomLabelsForSpan(customSpan, labels);
                            markSpanAsOtelToSend(customSpan);
                        });
                        return {
                            span: customSpan,
                            endSpan: function() {
                                customSpan === null || customSpan === void 0 || customSpan.end();
                            }
                        };
                    }
                };
                setGlobalSpan(globalSpanModel);
                addGlobalSpanByTraceId(globalSpan.spanContext().traceId, globalSpanModel);
                return globalSpanModel;
            }
        };
    },
    shutdown: function() {
        var _a, _b;
        if (!isInited) return;
        _deregisterInstrumentations === null || _deregisterInstrumentations === void 0 || _deregisterInstrumentations();
        _deregisterInstrumentations = undefined;
        this.stopSessionRecording();
        (_a = getSessionManager()) === null || _a === void 0 || _a.stop();
        attributesProcessor === null || attributesProcessor === void 0 || attributesProcessor.shutdown();
        navigationProcessor === null || navigationProcessor === void 0 || navigationProcessor.shutdown();
        spanMapProcessor === null || spanMapProcessor === void 0 || spanMapProcessor.shutdown();
        snapshotProcessor === null || snapshotProcessor === void 0 || snapshotProcessor.shutdown();
        exporter === null || exporter === void 0 || exporter.shutdown();
        isInited = false;
        if ((_b = getSdkConfig()) === null || _b === void 0 ? void 0 : _b.debug) console.debug('Coralogix Browser SDK - shutdown has completed');
    },
    setApplicationContext: function(applicationContext) {
        var _a;
        if (!isInited) {
            console.debug('CoralogixRum must be initiated before setting application context');
            return;
        }
        attributesProcessor === null || attributesProcessor === void 0 || attributesProcessor.setInternalLabels((0, $8yqJh.__assign)((0, $8yqJh.__assign)({}, attributesProcessor.getInternalLabels()), (_a = {}, _a[CoralogixAttributes.APPLICATION_CONTEXT] = applicationContext, _a)));
    },
    captureError: function(error, customData, labels) {
        if (!isInited) {
            console.debug('CoralogixRum must be initiated before reporting errors');
            return;
        }
        errorsInstrumentation === null || errorsInstrumentation === void 0 || errorsInstrumentation.reportError(ErrorSource.CAPTURED, error, customData, labels);
    },
    sendCustomMeasurement: function(name, value) {
        if (!isInited) {
            console.debug('CoralogixRum must be initiated before sending custom measurement');
            return;
        }
        customMeasurementInstrumentation === null || customMeasurementInstrumentation === void 0 || customMeasurementInstrumentation.createCustomMeasurement(name, value);
    },
    addTiming: function(name, duration) {
        if (!isInited) {
            console.debug('CoralogixRum must be initiated before adding timing');
            return;
        }
        this.sendCustomMeasurement(name, getTiming(duration));
    },
    measureUserAgentSpecificMemory: function() {
        if (!isInited) {
            console.debug('CoralogixRum must be initiated before measuring user agent specific memory');
            return;
        }
        if (!memoryUsageInstrumentation) {
            console.debug('Memory usage instrumentation is not enabled');
            return;
        }
        memoryUsageInstrumentation.startTrackingMemoryUsage();
    },
    stopSessionRecording: function() {
        var _a;
        (_a = getSessionRecorder()) === null || _a === void 0 || _a.stopRecording();
    },
    startSessionRecording: function() {
        var _a;
        if (!isInited) {
            if ((_a = getSdkConfig()) === null || _a === void 0 ? void 0 : _a.debug) console.debug('Coralogix Browser SDK - CoralogixRum must be initiated before starting session recording');
            return;
        }
        if (getSessionRecorder()) {
            getSessionRecorder().startRecording();
            return;
        }
        var intervalId = cxSetInterval(function() {
            if (getSessionRecorder()) {
                cxClearInterval(intervalId);
                getSessionRecorder().startRecording();
            }
        }, 300);
        cxSetTimeout(function() {
            return cxClearInterval(intervalId);
        }, 3000);
    },
    screenshot: function(description) {
        var _a;
        if (!isInited) {
            console.debug('CoralogixRum must be initiated before capturing screenshot');
            return;
        }
        var id = generateUUID();
        screenshotInstrumentation === null || screenshotInstrumentation === void 0 || screenshotInstrumentation.screenshot(id, description);
        (_a = getSessionRecorder()) === null || _a === void 0 || _a.screenshot(id);
        return id;
    },
    setUserContext: function(userContext) {
        var _a;
        if (!isInited) {
            console.debug('CoralogixRum must be initiated before setting user context');
            return;
        }
        getSnapshotManager().shouldTriggerSnapshotContext = true;
        attributesProcessor === null || attributesProcessor === void 0 || attributesProcessor.setInternalLabels((0, $8yqJh.__assign)((0, $8yqJh.__assign)({}, attributesProcessor.getInternalLabels()), (_a = {}, _a[CoralogixAttributes.USER_CONTEXT] = userContext, _a)));
    },
    getUserContext: function() {
        return attributesProcessor === null || attributesProcessor === void 0 ? void 0 : attributesProcessor.getUserContext();
    },
    setLabels: function(labels) {
        attributesProcessor === null || attributesProcessor === void 0 || attributesProcessor.setCustomLabels(labels);
    },
    getLabels: function() {
        return (attributesProcessor === null || attributesProcessor === void 0 ? void 0 : attributesProcessor.getCustomLabels()) || {};
    },
    getSessionId: function() {
        var _a, _b;
        return (_b = (_a = getSessionManager()) === null || _a === void 0 ? void 0 : _a.getSession()) === null || _b === void 0 ? void 0 : _b.sessionId;
    },
    log: function(severity, message, data, labels) {
        if (!isInited) {
            console.debug('CoralogixRum must be initiated before using log');
            return;
        }
        if (!_customInstrumentation) {
            console.warn('Log was reported, but custom instrumentation is disabled.');
            return;
        }
        _customInstrumentation === null || _customInstrumentation === void 0 || _customInstrumentation.log({
            severity: severity,
            message: message,
            data: data,
            labels: labels
        });
    },
    debug: function(message, data, labels) {
        this.log(CoralogixLogSeverity.Debug, message, data, labels);
    },
    verbose: function(message, data, labels) {
        this.log(CoralogixLogSeverity.Verbose, message, data, labels);
    },
    info: function(message, data, labels) {
        this.log(CoralogixLogSeverity.Info, message, data, labels);
    },
    warn: function(message, data, labels) {
        this.log(CoralogixLogSeverity.Warn, message, data, labels);
    },
    error: function(message, data, labels) {
        this.log(CoralogixLogSeverity.Error, message, data, labels);
    },
    critical: function(message, data, labels) {
        this.log(CoralogixLogSeverity.Critical, message, data, labels);
    },
    startTimeMeasure: function(key, labels) {
        if (!isInited) {
            console.debug('CoralogixRum must be initiated before starting time measurement.');
            return;
        }
        timeMeasurementTracker === null || timeMeasurementTracker === void 0 || timeMeasurementTracker.startMeasurement(key, labels);
    },
    endTimeMeasure: function(key) {
        var measurement = timeMeasurementTracker === null || timeMeasurementTracker === void 0 ? void 0 : timeMeasurementTracker.getMeasurement(key);
        if (measurement) {
            var duration = measurement.duration, labels = measurement.labels;
            customMeasurementInstrumentation === null || customMeasurementInstrumentation === void 0 || customMeasurementInstrumentation.createCustomMeasurement(key, duration, getCustomMergedLabels(labels));
        }
    }
};
CxGlobal.CoralogixRum = CoralogixRum;
var UrlBasedLabelProvider = function() {
    function UrlBasedLabelProvider(config) {
        var urlPatterns = config.urlPatterns, defaultLabels = config.defaultLabels, urlType = config.urlType;
        var compiledRegexps = urlPatterns.map(function(_a) {
            var regexps = _a.regexps;
            return regexps.map(function(regexp) {
                return new RegExp(regexp);
            });
        });
        this.urlType = urlType;
        this.providerFunc = function(url, _) {
            var e_1, _a;
            var providerLabels = {};
            try {
                outerLoop: for(var _b = (0, $8yqJh.__values)(compiledRegexps.entries()), _c = _b.next(); !_c.done; _c = _b.next()){
                    var _d = (0, $8yqJh.__read)(_c.value, 2), index = _d[0], compiledRegex = _d[1];
                    var labels = urlPatterns[index].labels;
                    if (compiledRegex.some(function(regexp) {
                        return regexp.test(url);
                    })) {
                        providerLabels = (0, $8yqJh.__assign)((0, $8yqJh.__assign)({}, providerLabels), labels);
                        break outerLoop;
                    }
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            var shouldAddDefaultLabels = isEmpty(providerLabels) && isNotEmpty(defaultLabels);
            if (shouldAddDefaultLabels) providerLabels = (0, $8yqJh.__assign)((0, $8yqJh.__assign)({}, providerLabels), defaultLabels);
            return providerLabels;
        };
    }
    return UrlBasedLabelProvider;
}();
var SessionRecordingEventType;
(function(SessionRecordingEventType) {
    SessionRecordingEventType[SessionRecordingEventType["DomContentLoaded"] = 0] = "DomContentLoaded";
    SessionRecordingEventType[SessionRecordingEventType["Load"] = 1] = "Load";
    SessionRecordingEventType[SessionRecordingEventType["FullSnapshot"] = 2] = "FullSnapshot";
    SessionRecordingEventType[SessionRecordingEventType["IncrementalSnapshot"] = 3] = "IncrementalSnapshot";
    SessionRecordingEventType[SessionRecordingEventType["Meta"] = 4] = "Meta";
    SessionRecordingEventType[SessionRecordingEventType["Custom"] = 5] = "Custom";
    SessionRecordingEventType[SessionRecordingEventType["Plugin"] = 6] = "Plugin";
})(SessionRecordingEventType || (SessionRecordingEventType = {}));

});
parcelRegister("8yqJh", function(module, exports) {

$parcel$export(module.exports, "__extends", function () { return $63a63b92010ab25c$export$a8ba968b8961cb8a; });
$parcel$export(module.exports, "__assign", function () { return $63a63b92010ab25c$export$18ce0697a983be9b; });
$parcel$export(module.exports, "__rest", function () { return $63a63b92010ab25c$export$3c9a16f847548506; });
$parcel$export(module.exports, "__awaiter", function () { return $63a63b92010ab25c$export$1050f835b63b671e; });
$parcel$export(module.exports, "__generator", function () { return $63a63b92010ab25c$export$67ebef60e6f28a6; });
$parcel$export(module.exports, "__values", function () { return $63a63b92010ab25c$export$19a8beecd37a4c45; });
$parcel$export(module.exports, "__read", function () { return $63a63b92010ab25c$export$8d051b38c9118094; });
$parcel$export(module.exports, "__spreadArray", function () { return $63a63b92010ab25c$export$1216008129fb82ed; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $63a63b92010ab25c$var$extendStatics = function(d, b) {
    $63a63b92010ab25c$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $63a63b92010ab25c$var$extendStatics(d, b);
};
function $63a63b92010ab25c$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $63a63b92010ab25c$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $63a63b92010ab25c$export$18ce0697a983be9b = function() {
    $63a63b92010ab25c$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $63a63b92010ab25c$export$18ce0697a983be9b.apply(this, arguments);
};
function $63a63b92010ab25c$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $63a63b92010ab25c$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $63a63b92010ab25c$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $63a63b92010ab25c$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $63a63b92010ab25c$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $63a63b92010ab25c$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $63a63b92010ab25c$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $63a63b92010ab25c$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $63a63b92010ab25c$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $63a63b92010ab25c$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $63a63b92010ab25c$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $63a63b92010ab25c$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $63a63b92010ab25c$export$45d3717a4c69092e(o, m, p);
}
function $63a63b92010ab25c$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $63a63b92010ab25c$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $63a63b92010ab25c$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($63a63b92010ab25c$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $63a63b92010ab25c$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $63a63b92010ab25c$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $63a63b92010ab25c$export$10c90e4f7922046c(v) {
    return this instanceof $63a63b92010ab25c$export$10c90e4f7922046c ? (this.v = v, this) : new $63a63b92010ab25c$export$10c90e4f7922046c(v);
}
function $63a63b92010ab25c$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $63a63b92010ab25c$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $63a63b92010ab25c$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $63a63b92010ab25c$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $63a63b92010ab25c$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $63a63b92010ab25c$export$19a8beecd37a4c45 === "function" ? $63a63b92010ab25c$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $63a63b92010ab25c$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $63a63b92010ab25c$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $63a63b92010ab25c$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $63a63b92010ab25c$export$45d3717a4c69092e(result, mod, k);
    }
    $63a63b92010ab25c$var$__setModuleDefault(result, mod);
    return result;
}
function $63a63b92010ab25c$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $63a63b92010ab25c$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $63a63b92010ab25c$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $63a63b92010ab25c$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $63a63b92010ab25c$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $63a63b92010ab25c$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $63a63b92010ab25c$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $63a63b92010ab25c$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $63a63b92010ab25c$export$2e2bcd8739ae039 = {
    __extends: $63a63b92010ab25c$export$a8ba968b8961cb8a,
    __assign: $63a63b92010ab25c$export$18ce0697a983be9b,
    __rest: $63a63b92010ab25c$export$3c9a16f847548506,
    __decorate: $63a63b92010ab25c$export$29e00dfd3077644b,
    __param: $63a63b92010ab25c$export$d5ad3fd78186038f,
    __metadata: $63a63b92010ab25c$export$f1db080c865becb9,
    __awaiter: $63a63b92010ab25c$export$1050f835b63b671e,
    __generator: $63a63b92010ab25c$export$67ebef60e6f28a6,
    __createBinding: $63a63b92010ab25c$export$45d3717a4c69092e,
    __exportStar: $63a63b92010ab25c$export$f33643c0debef087,
    __values: $63a63b92010ab25c$export$19a8beecd37a4c45,
    __read: $63a63b92010ab25c$export$8d051b38c9118094,
    __spread: $63a63b92010ab25c$export$afc72e2116322959,
    __spreadArrays: $63a63b92010ab25c$export$6388937ca91ccae8,
    __spreadArray: $63a63b92010ab25c$export$1216008129fb82ed,
    __await: $63a63b92010ab25c$export$10c90e4f7922046c,
    __asyncGenerator: $63a63b92010ab25c$export$e427f37a30a4de9b,
    __asyncDelegator: $63a63b92010ab25c$export$bbd80228419bb833,
    __asyncValues: $63a63b92010ab25c$export$e3b29a3d6162315f,
    __makeTemplateObject: $63a63b92010ab25c$export$4fb47efe1390b86f,
    __importStar: $63a63b92010ab25c$export$c21735bcef00d192,
    __importDefault: $63a63b92010ab25c$export$da59b14a69baef04,
    __classPrivateFieldGet: $63a63b92010ab25c$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $63a63b92010ab25c$export$d40a35129aaff81f,
    __classPrivateFieldIn: $63a63b92010ab25c$export$81fdc39f203e4e04,
    __addDisposableResource: $63a63b92010ab25c$export$88ac25d8e944e405,
    __disposeResources: $63a63b92010ab25c$export$8f076105dc360e92
};

});

parcelRegister("3eG03", function(module, exports) {

$parcel$export(module.exports, "AlwaysOnSampler", function () { return $25b34232771ce5ee$export$653f832afb4ffa27; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $3ALgF = parcelRequire("3ALgF");
/** Sampler that samples all traces. */ var $25b34232771ce5ee$export$653f832afb4ffa27 = /** @class */ function() {
    function AlwaysOnSampler() {}
    AlwaysOnSampler.prototype.shouldSample = function() {
        return {
            decision: (0, $3ALgF.SamplingDecision).RECORD_AND_SAMPLED
        };
    };
    AlwaysOnSampler.prototype.toString = function() {
        return 'AlwaysOnSampler';
    };
    return AlwaysOnSampler;
}();

});
parcelRegister("3ALgF", function(module, exports) {

$parcel$export(module.exports, "SamplingDecision", function () { return $29d966510ff8bc93$export$94df7a7a96a92f7b; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A sampling decision that determines how a {@link Span} will be recorded
 * and collected.
 */ var $29d966510ff8bc93$export$94df7a7a96a92f7b;
(function(SamplingDecision) {
    /**
     * `Span.isRecording() === false`, span will not be recorded and all events
     * and attributes will be dropped.
     */ SamplingDecision[SamplingDecision["NOT_RECORD"] = 0] = "NOT_RECORD";
    /**
     * `Span.isRecording() === true`, but `Sampled` flag in {@link TraceFlags}
     * MUST NOT be set.
     */ SamplingDecision[SamplingDecision["RECORD"] = 1] = "RECORD";
    /**
     * `Span.isRecording() === true` AND `Sampled` flag in {@link TraceFlags}
     * MUST be set.
     */ SamplingDecision[SamplingDecision["RECORD_AND_SAMPLED"] = 2] = "RECORD_AND_SAMPLED";
})($29d966510ff8bc93$export$94df7a7a96a92f7b || ($29d966510ff8bc93$export$94df7a7a96a92f7b = {}));

});


parcelRegister("956M5", function(module, exports) {

$parcel$export(module.exports, "BatchSpanProcessor", function () { return $69c9d5f49ea52ba2$export$237547059fd543f9; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $72JjV = parcelRequire("72JjV");
var $69c9d5f49ea52ba2$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $69c9d5f49ea52ba2$export$237547059fd543f9 = /** @class */ function(_super) {
    $69c9d5f49ea52ba2$var$__extends(BatchSpanProcessor, _super);
    function BatchSpanProcessor(_exporter, config) {
        var _this = _super.call(this, _exporter, config) || this;
        _this.onInit(config);
        return _this;
    }
    BatchSpanProcessor.prototype.onInit = function(config) {
        var _this = this;
        if ((config === null || config === void 0 ? void 0 : config.disableAutoFlushOnDocumentHide) !== true && typeof document !== 'undefined') {
            this._visibilityChangeListener = function() {
                if (document.visibilityState === 'hidden') _this.forceFlush();
            };
            this._pageHideListener = function() {
                _this.forceFlush();
            };
            document.addEventListener('visibilitychange', this._visibilityChangeListener);
            // use 'pagehide' event as a fallback for Safari; see https://bugs.webkit.org/show_bug.cgi?id=116769
            document.addEventListener('pagehide', this._pageHideListener);
        }
    };
    BatchSpanProcessor.prototype.onShutdown = function() {
        if (typeof document !== 'undefined') {
            if (this._visibilityChangeListener) document.removeEventListener('visibilitychange', this._visibilityChangeListener);
            if (this._pageHideListener) document.removeEventListener('pagehide', this._pageHideListener);
        }
    };
    return BatchSpanProcessor;
}((0, $72JjV.BatchSpanProcessorBase));

});
parcelRegister("72JjV", function(module, exports) {

$parcel$export(module.exports, "BatchSpanProcessorBase", function () { return $520bdffb7d93fd2b$export$54ea939f5d39e8a2; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ parcelRequire("ckckF");
var $4e6si = parcelRequire("4e6si");
var $7Y52R = parcelRequire("7Y52R");
var $kxoQ4 = parcelRequire("kxoQ4");

var $5p0rJ = parcelRequire("5p0rJ");
var $61V2D = parcelRequire("61V2D");
var $d2oti = parcelRequire("d2oti");
var $5ytUs = parcelRequire("5ytUs");
var $3WAuq = parcelRequire("3WAuq");
var $lNcy1 = parcelRequire("lNcy1");
/**
 * Implementation of the {@link SpanProcessor} that batches spans exported by
 * the SDK then pushes them to the exporter pipeline.
 */ var $520bdffb7d93fd2b$export$54ea939f5d39e8a2 = /** @class */ function() {
    function BatchSpanProcessorBase(_exporter, config) {
        this._exporter = _exporter;
        this._isExporting = false;
        this._finishedSpans = [];
        this._droppedSpansCount = 0;
        var env = (0, $d2oti.getEnv)();
        this._maxExportBatchSize = typeof (config === null || config === void 0 ? void 0 : config.maxExportBatchSize) === 'number' ? config.maxExportBatchSize : env.OTEL_BSP_MAX_EXPORT_BATCH_SIZE;
        this._maxQueueSize = typeof (config === null || config === void 0 ? void 0 : config.maxQueueSize) === 'number' ? config.maxQueueSize : env.OTEL_BSP_MAX_QUEUE_SIZE;
        this._scheduledDelayMillis = typeof (config === null || config === void 0 ? void 0 : config.scheduledDelayMillis) === 'number' ? config.scheduledDelayMillis : env.OTEL_BSP_SCHEDULE_DELAY;
        this._exportTimeoutMillis = typeof (config === null || config === void 0 ? void 0 : config.exportTimeoutMillis) === 'number' ? config.exportTimeoutMillis : env.OTEL_BSP_EXPORT_TIMEOUT;
        this._shutdownOnce = new (0, $5p0rJ.BindOnceFuture)(this._shutdown, this);
        if (this._maxExportBatchSize > this._maxQueueSize) {
            (0, $7Y52R.diag).warn('BatchSpanProcessor: maxExportBatchSize must be smaller or equal to maxQueueSize, setting maxExportBatchSize to match maxQueueSize');
            this._maxExportBatchSize = this._maxQueueSize;
        }
    }
    BatchSpanProcessorBase.prototype.forceFlush = function() {
        if (this._shutdownOnce.isCalled) return this._shutdownOnce.promise;
        return this._flushAll();
    };
    // does nothing.
    BatchSpanProcessorBase.prototype.onStart = function(_span, _parentContext) {};
    BatchSpanProcessorBase.prototype.onEnd = function(span) {
        if (this._shutdownOnce.isCalled) return;
        if ((span.spanContext().traceFlags & (0, $kxoQ4.TraceFlags).SAMPLED) === 0) return;
        this._addToBuffer(span);
    };
    BatchSpanProcessorBase.prototype.shutdown = function() {
        return this._shutdownOnce.call();
    };
    BatchSpanProcessorBase.prototype._shutdown = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.onShutdown();
        }).then(function() {
            return _this._flushAll();
        }).then(function() {
            return _this._exporter.shutdown();
        });
    };
    /** Add a span in the buffer. */ BatchSpanProcessorBase.prototype._addToBuffer = function(span) {
        if (this._finishedSpans.length >= this._maxQueueSize) {
            // limit reached, drop span
            if (this._droppedSpansCount === 0) (0, $7Y52R.diag).debug('maxQueueSize reached, dropping spans');
            this._droppedSpansCount++;
            return;
        }
        if (this._droppedSpansCount > 0) {
            // some spans were dropped, log once with count of spans dropped
            (0, $7Y52R.diag).warn("Dropped " + this._droppedSpansCount + " spans because maxQueueSize reached");
            this._droppedSpansCount = 0;
        }
        this._finishedSpans.push(span);
        this._maybeStartTimer();
    };
    /**
     * Send all spans to the exporter respecting the batch size limit
     * This function is used only on forceFlush or shutdown,
     * for all other cases _flush should be used
     * */ BatchSpanProcessorBase.prototype._flushAll = function() {
        var _this = this;
        return new Promise(function(resolve, reject) {
            var promises = [];
            // calculate number of batches
            var count = Math.ceil(_this._finishedSpans.length / _this._maxExportBatchSize);
            for(var i = 0, j = count; i < j; i++)promises.push(_this._flushOneBatch());
            Promise.all(promises).then(function() {
                resolve();
            }).catch(reject);
        });
    };
    BatchSpanProcessorBase.prototype._flushOneBatch = function() {
        var _this = this;
        this._clearTimer();
        if (this._finishedSpans.length === 0) return Promise.resolve();
        return new Promise(function(resolve, reject) {
            var timer = setTimeout(function() {
                // don't wait anymore for export, this way the next batch can start
                reject(new Error('Timeout'));
            }, _this._exportTimeoutMillis);
            // prevent downstream exporter calls from generating spans
            (0, $4e6si.context).with((0, $3WAuq.suppressTracing)((0, $4e6si.context).active()), function() {
                // Reset the finished spans buffer here because the next invocations of the _flush method
                // could pass the same finished spans to the exporter if the buffer is cleared
                // outside the execution of this callback.
                var spans;
                if (_this._finishedSpans.length <= _this._maxExportBatchSize) {
                    spans = _this._finishedSpans;
                    _this._finishedSpans = [];
                } else spans = _this._finishedSpans.splice(0, _this._maxExportBatchSize);
                var doExport = function() {
                    return _this._exporter.export(spans, function(result) {
                        var _a;
                        clearTimeout(timer);
                        if (result.code === (0, $61V2D.ExportResultCode).SUCCESS) resolve();
                        else reject((_a = result.error) !== null && _a !== void 0 ? _a : new Error('BatchSpanProcessor: span export failed'));
                    });
                };
                var pendingResources = null;
                for(var i = 0, len = spans.length; i < len; i++){
                    var span = spans[i];
                    if (span.resource.asyncAttributesPending && span.resource.waitForAsyncAttributes) {
                        pendingResources !== null && pendingResources !== void 0 ? pendingResources : pendingResources = [];
                        pendingResources.push(span.resource.waitForAsyncAttributes());
                    }
                }
                // Avoid scheduling a promise to make the behavior more predictable and easier to test
                if (pendingResources === null) doExport();
                else Promise.all(pendingResources).then(doExport, function(err) {
                    (0, $5ytUs.globalErrorHandler)(err);
                    reject(err);
                });
            });
        });
    };
    BatchSpanProcessorBase.prototype._maybeStartTimer = function() {
        var _this = this;
        if (this._isExporting) return;
        var flush = function() {
            _this._isExporting = true;
            _this._flushOneBatch().finally(function() {
                _this._isExporting = false;
                if (_this._finishedSpans.length > 0) {
                    _this._clearTimer();
                    _this._maybeStartTimer();
                }
            }).catch(function(e) {
                _this._isExporting = false;
                (0, $5ytUs.globalErrorHandler)(e);
            });
        };
        // we only wait if the queue doesn't have enough elements yet
        if (this._finishedSpans.length >= this._maxExportBatchSize) return flush();
        if (this._timer !== undefined) return;
        this._timer = setTimeout(function() {
            return flush();
        }, this._scheduledDelayMillis);
        (0, $lNcy1.unrefTimer)(this._timer);
    };
    BatchSpanProcessorBase.prototype._clearTimer = function() {
        if (this._timer !== undefined) {
            clearTimeout(this._timer);
            this._timer = undefined;
        }
    };
    return BatchSpanProcessorBase;
}();

});
parcelRegister("ckckF", function(module, exports) {

$parcel$export(module.exports, "context", function () { return (parcelRequire("4e6si")).context; });
$parcel$export(module.exports, "diag", function () { return (parcelRequire("7Y52R")).diag; });
$parcel$export(module.exports, "metrics", function () { return (parcelRequire("3C1qe")).metrics; });
$parcel$export(module.exports, "propagation", function () { return (parcelRequire("6b1Zv")).propagation; });
$parcel$export(module.exports, "trace", function () { return (parcelRequire("g4DKS")).trace; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $3mSe3 = parcelRequire("3mSe3");

var $jVu0G = parcelRequire("jVu0G");


var $kPWiP = parcelRequire("kPWiP");






var $lbCBL = parcelRequire("lbCBL");

var $iS6Md = parcelRequire("iS6Md");

var $3UoQo = parcelRequire("3UoQo");

var $kxoQ4 = parcelRequire("kxoQ4");


var $laija = parcelRequire("laija");

var $gRjnF = parcelRequire("gRjnF");

var $4e6si = parcelRequire("4e6si");

var $7Y52R = parcelRequire("7Y52R");

var $3C1qe = parcelRequire("3C1qe");

var $6b1Zv = parcelRequire("6b1Zv");

var $g4DKS = parcelRequire("g4DKS");
var // Default export.
$8f90eb3af7d9b196$export$2e2bcd8739ae039 = {
    context: (0, $4e6si.context),
    diag: (0, $7Y52R.diag),
    metrics: (0, $3C1qe.metrics),
    propagation: (0, $6b1Zv.propagation),
    trace: (0, $g4DKS.trace)
};

});
parcelRegister("3mSe3", function(module, exports) {

$parcel$export(module.exports, "createBaggage", function () { return $273d7d43c6faf0b4$export$1034a425c7384452; });
$parcel$export(module.exports, "baggageEntryMetadataFromString", function () { return $273d7d43c6faf0b4$export$c491cedc1b2b6e9e; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $b7uAP = parcelRequire("b7uAP");

var $6TiA3 = parcelRequire("6TiA3");

var $8GrH4 = parcelRequire("8GrH4");
var $273d7d43c6faf0b4$var$diag = (0, $b7uAP.DiagAPI).instance();
function $273d7d43c6faf0b4$export$1034a425c7384452(entries) {
    if (entries === void 0) entries = {};
    return new (0, $6TiA3.BaggageImpl)(new Map(Object.entries(entries)));
}
function $273d7d43c6faf0b4$export$c491cedc1b2b6e9e(str) {
    if (typeof str !== 'string') {
        $273d7d43c6faf0b4$var$diag.error("Cannot create baggage metadata from unknown type: " + typeof str);
        str = '';
    }
    return {
        __TYPE__: (0, $8GrH4.baggageEntryMetadataSymbol),
        toString: function() {
            return str;
        }
    };
}

});
parcelRegister("b7uAP", function(module, exports) {

$parcel$export(module.exports, "DiagAPI", function () { return $8188144930921c94$export$5c8937ffc688cfd3; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $bZpH4 = parcelRequire("bZpH4");

var $1o00Q = parcelRequire("1o00Q");

var $kPWiP = parcelRequire("kPWiP");

var $a5GVl = parcelRequire("a5GVl");
var $8188144930921c94$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $8188144930921c94$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $8188144930921c94$var$API_NAME = 'diag';
/**
 * Singleton object which represents the entry point to the OpenTelemetry internal
 * diagnostic API
 */ var $8188144930921c94$export$5c8937ffc688cfd3 = /** @class */ function() {
    /**
     * Private internal constructor
     * @private
     */ function DiagAPI() {
        function _logProxy(funcName) {
            return function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                var logger = (0, $a5GVl.getGlobal)('diag');
                // shortcut if logger not set
                if (!logger) return;
                return logger[funcName].apply(logger, $8188144930921c94$var$__spreadArray([], $8188144930921c94$var$__read(args), false));
            };
        }
        // Using self local variable for minification purposes as 'this' cannot be minified
        var self = this;
        // DiagAPI specific functions
        var setLogger = function(logger, optionsOrLogLevel) {
            var _a, _b, _c;
            if (optionsOrLogLevel === void 0) optionsOrLogLevel = {
                logLevel: (0, $kPWiP.DiagLogLevel).INFO
            };
            if (logger === self) {
                // There isn't much we can do here.
                // Logging to the console might break the user application.
                // Try to log to self. If a logger was previously registered it will receive the log.
                var err = new Error('Cannot use diag as the logger for itself. Please use a DiagLogger implementation like ConsoleDiagLogger or a custom implementation');
                self.error((_a = err.stack) !== null && _a !== void 0 ? _a : err.message);
                return false;
            }
            if (typeof optionsOrLogLevel === 'number') optionsOrLogLevel = {
                logLevel: optionsOrLogLevel
            };
            var oldLogger = (0, $a5GVl.getGlobal)('diag');
            var newLogger = (0, $1o00Q.createLogLevelDiagLogger)((_b = optionsOrLogLevel.logLevel) !== null && _b !== void 0 ? _b : (0, $kPWiP.DiagLogLevel).INFO, logger);
            // There already is an logger registered. We'll let it know before overwriting it.
            if (oldLogger && !optionsOrLogLevel.suppressOverrideMessage) {
                var stack = (_c = new Error().stack) !== null && _c !== void 0 ? _c : '<failed to generate stacktrace>';
                oldLogger.warn("Current logger will be overwritten from " + stack);
                newLogger.warn("Current logger will overwrite one already registered from " + stack);
            }
            return (0, $a5GVl.registerGlobal)('diag', newLogger, self, true);
        };
        self.setLogger = setLogger;
        self.disable = function() {
            (0, $a5GVl.unregisterGlobal)($8188144930921c94$var$API_NAME, self);
        };
        self.createComponentLogger = function(options) {
            return new (0, $bZpH4.DiagComponentLogger)(options);
        };
        self.verbose = _logProxy('verbose');
        self.debug = _logProxy('debug');
        self.info = _logProxy('info');
        self.warn = _logProxy('warn');
        self.error = _logProxy('error');
    }
    /** Get the singleton instance of the DiagAPI API */ DiagAPI.instance = function() {
        if (!this._instance) this._instance = new DiagAPI();
        return this._instance;
    };
    return DiagAPI;
}();

});
parcelRegister("bZpH4", function(module, exports) {

$parcel$export(module.exports, "DiagComponentLogger", function () { return $8ba952719cbfc78c$export$b4bccc12f5b13129; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $a5GVl = parcelRequire("a5GVl");
var $8ba952719cbfc78c$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $8ba952719cbfc78c$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * Component Logger which is meant to be used as part of any component which
 * will add automatically additional namespace in front of the log message.
 * It will then forward all message to global diag logger
 * @example
 * const cLogger = diag.createComponentLogger({ namespace: '@opentelemetry/instrumentation-http' });
 * cLogger.debug('test');
 * // @opentelemetry/instrumentation-http test
 */ var $8ba952719cbfc78c$export$b4bccc12f5b13129 = /** @class */ function() {
    function DiagComponentLogger(props) {
        this._namespace = props.namespace || 'DiagComponentLogger';
    }
    DiagComponentLogger.prototype.debug = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $8ba952719cbfc78c$var$logProxy('debug', this._namespace, args);
    };
    DiagComponentLogger.prototype.error = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $8ba952719cbfc78c$var$logProxy('error', this._namespace, args);
    };
    DiagComponentLogger.prototype.info = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $8ba952719cbfc78c$var$logProxy('info', this._namespace, args);
    };
    DiagComponentLogger.prototype.warn = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $8ba952719cbfc78c$var$logProxy('warn', this._namespace, args);
    };
    DiagComponentLogger.prototype.verbose = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $8ba952719cbfc78c$var$logProxy('verbose', this._namespace, args);
    };
    return DiagComponentLogger;
}();
function $8ba952719cbfc78c$var$logProxy(funcName, namespace, args) {
    var logger = (0, $a5GVl.getGlobal)('diag');
    // shortcut if logger not set
    if (!logger) return;
    args.unshift(namespace);
    return logger[funcName].apply(logger, $8ba952719cbfc78c$var$__spreadArray([], $8ba952719cbfc78c$var$__read(args), false));
}

});
parcelRegister("a5GVl", function(module, exports) {

$parcel$export(module.exports, "registerGlobal", function () { return $758baaccb8805fd1$export$d586ae880b433238; });
$parcel$export(module.exports, "getGlobal", function () { return $758baaccb8805fd1$export$a4e55266d2135a7f; });
$parcel$export(module.exports, "unregisterGlobal", function () { return $758baaccb8805fd1$export$d42ac835f38d1fb2; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $elVmS = parcelRequire("elVmS");

var $7g00h = parcelRequire("7g00h");

var $jmwP3 = parcelRequire("jmwP3");
var $758baaccb8805fd1$var$major = (0, $7g00h.VERSION).split('.')[0];
var $758baaccb8805fd1$var$GLOBAL_OPENTELEMETRY_API_KEY = Symbol.for("opentelemetry.js.api." + $758baaccb8805fd1$var$major);
var $758baaccb8805fd1$var$_global = (0, $elVmS._globalThis);
function $758baaccb8805fd1$export$d586ae880b433238(type, instance, diag, allowOverride) {
    var _a;
    if (allowOverride === void 0) allowOverride = false;
    var api = $758baaccb8805fd1$var$_global[$758baaccb8805fd1$var$GLOBAL_OPENTELEMETRY_API_KEY] = (_a = $758baaccb8805fd1$var$_global[$758baaccb8805fd1$var$GLOBAL_OPENTELEMETRY_API_KEY]) !== null && _a !== void 0 ? _a : {
        version: (0, $7g00h.VERSION)
    };
    if (!allowOverride && api[type]) {
        // already registered an API of this type
        var err = new Error("@opentelemetry/api: Attempted duplicate registration of API: " + type);
        diag.error(err.stack || err.message);
        return false;
    }
    if (api.version !== (0, $7g00h.VERSION)) {
        // All registered APIs must be of the same version exactly
        var err = new Error("@opentelemetry/api: Registration of version v" + api.version + " for " + type + " does not match previously registered API v" + (0, $7g00h.VERSION));
        diag.error(err.stack || err.message);
        return false;
    }
    api[type] = instance;
    diag.debug("@opentelemetry/api: Registered a global for " + type + " v" + (0, $7g00h.VERSION) + ".");
    return true;
}
function $758baaccb8805fd1$export$a4e55266d2135a7f(type) {
    var _a, _b;
    var globalVersion = (_a = $758baaccb8805fd1$var$_global[$758baaccb8805fd1$var$GLOBAL_OPENTELEMETRY_API_KEY]) === null || _a === void 0 ? void 0 : _a.version;
    if (!globalVersion || !(0, $jmwP3.isCompatible)(globalVersion)) return;
    return (_b = $758baaccb8805fd1$var$_global[$758baaccb8805fd1$var$GLOBAL_OPENTELEMETRY_API_KEY]) === null || _b === void 0 ? void 0 : _b[type];
}
function $758baaccb8805fd1$export$d42ac835f38d1fb2(type, diag) {
    diag.debug("@opentelemetry/api: Unregistering a global for " + type + " v" + (0, $7g00h.VERSION) + ".");
    var api = $758baaccb8805fd1$var$_global[$758baaccb8805fd1$var$GLOBAL_OPENTELEMETRY_API_KEY];
    if (api) delete api[type];
}

});
parcelRegister("elVmS", function(module, exports) {

$parcel$export(module.exports, "_globalThis", function () { return $a72f86f1a38d61ca$export$5c524ddf7208c00c; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Updates to this file should also be replicated to @opentelemetry/core too.
/**
 * - globalThis (New standard)
 * - self (Will return the current window instance for supported browsers)
 * - window (fallback for older browser implementations)
 * - global (NodeJS implementation)
 * - <object> (When all else fails)
 */ /** only globals that common to node and browsers are allowed */ // eslint-disable-next-line node/no-unsupported-features/es-builtins, no-undef
var $a72f86f1a38d61ca$export$5c524ddf7208c00c = typeof globalThis === 'object' ? globalThis : typeof self === 'object' ? self : typeof window === 'object' ? window : typeof $parcel$global === 'object' ? $parcel$global : {};

});

parcelRegister("7g00h", function(module, exports) {

$parcel$export(module.exports, "VERSION", function () { return $548a07b346b50a75$export$a4ad2735b021c132; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // this is autogenerated file, see scripts/version-update.js
var $548a07b346b50a75$export$a4ad2735b021c132 = '1.9.0';

});

parcelRegister("jmwP3", function(module, exports) {

$parcel$export(module.exports, "isCompatible", function () { return $e189883ebe7034e9$export$7fc0d8c3ab188c4c; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $7g00h = parcelRequire("7g00h");
var $e189883ebe7034e9$var$re = /^(\d+)\.(\d+)\.(\d+)(-(.+))?$/;
function $e189883ebe7034e9$export$a5733a4d26a1ec61(ownVersion) {
    var acceptedVersions = new Set([
        ownVersion
    ]);
    var rejectedVersions = new Set();
    var myVersionMatch = ownVersion.match($e189883ebe7034e9$var$re);
    if (!myVersionMatch) // we cannot guarantee compatibility so we always return noop
    return function() {
        return false;
    };
    var ownVersionParsed = {
        major: +myVersionMatch[1],
        minor: +myVersionMatch[2],
        patch: +myVersionMatch[3],
        prerelease: myVersionMatch[4]
    };
    // if ownVersion has a prerelease tag, versions must match exactly
    if (ownVersionParsed.prerelease != null) return function isExactmatch(globalVersion) {
        return globalVersion === ownVersion;
    };
    function _reject(v) {
        rejectedVersions.add(v);
        return false;
    }
    function _accept(v) {
        acceptedVersions.add(v);
        return true;
    }
    return function isCompatible(globalVersion) {
        if (acceptedVersions.has(globalVersion)) return true;
        if (rejectedVersions.has(globalVersion)) return false;
        var globalVersionMatch = globalVersion.match($e189883ebe7034e9$var$re);
        if (!globalVersionMatch) // cannot parse other version
        // we cannot guarantee compatibility so we always noop
        return _reject(globalVersion);
        var globalVersionParsed = {
            major: +globalVersionMatch[1],
            minor: +globalVersionMatch[2],
            patch: +globalVersionMatch[3],
            prerelease: globalVersionMatch[4]
        };
        // if globalVersion has a prerelease tag, versions must match exactly
        if (globalVersionParsed.prerelease != null) return _reject(globalVersion);
        // major versions must match
        if (ownVersionParsed.major !== globalVersionParsed.major) return _reject(globalVersion);
        if (ownVersionParsed.major === 0) {
            if (ownVersionParsed.minor === globalVersionParsed.minor && ownVersionParsed.patch <= globalVersionParsed.patch) return _accept(globalVersion);
            return _reject(globalVersion);
        }
        if (ownVersionParsed.minor <= globalVersionParsed.minor) return _accept(globalVersion);
        return _reject(globalVersion);
    };
}
var $e189883ebe7034e9$export$7fc0d8c3ab188c4c = $e189883ebe7034e9$export$a5733a4d26a1ec61((0, $7g00h.VERSION));

});



parcelRegister("1o00Q", function(module, exports) {

$parcel$export(module.exports, "createLogLevelDiagLogger", function () { return $10280ad6104d7d35$export$9a9cc475abb19689; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $kPWiP = parcelRequire("kPWiP");
function $10280ad6104d7d35$export$9a9cc475abb19689(maxLevel, logger) {
    if (maxLevel < (0, $kPWiP.DiagLogLevel).NONE) maxLevel = (0, $kPWiP.DiagLogLevel).NONE;
    else if (maxLevel > (0, $kPWiP.DiagLogLevel).ALL) maxLevel = (0, $kPWiP.DiagLogLevel).ALL;
    // In case the logger is null or undefined
    logger = logger || {};
    function _filterFunc(funcName, theLevel) {
        var theFunc = logger[funcName];
        if (typeof theFunc === 'function' && maxLevel >= theLevel) return theFunc.bind(logger);
        return function() {};
    }
    return {
        error: _filterFunc('error', (0, $kPWiP.DiagLogLevel).ERROR),
        warn: _filterFunc('warn', (0, $kPWiP.DiagLogLevel).WARN),
        info: _filterFunc('info', (0, $kPWiP.DiagLogLevel).INFO),
        debug: _filterFunc('debug', (0, $kPWiP.DiagLogLevel).DEBUG),
        verbose: _filterFunc('verbose', (0, $kPWiP.DiagLogLevel).VERBOSE)
    };
}

});
parcelRegister("kPWiP", function(module, exports) {

$parcel$export(module.exports, "DiagLogLevel", function () { return $f2b5cbbf4ee10c75$export$b7d7b4c0f3c95263; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Defines the available internal logging levels for the diagnostic logger, the numeric values
 * of the levels are defined to match the original values from the initial LogLevel to avoid
 * compatibility/migration issues for any implementation that assume the numeric ordering.
 */ var $f2b5cbbf4ee10c75$export$b7d7b4c0f3c95263;
(function(DiagLogLevel) {
    /** Diagnostic Logging level setting to disable all logging (except and forced logs) */ DiagLogLevel[DiagLogLevel["NONE"] = 0] = "NONE";
    /** Identifies an error scenario */ DiagLogLevel[DiagLogLevel["ERROR"] = 30] = "ERROR";
    /** Identifies a warning scenario */ DiagLogLevel[DiagLogLevel["WARN"] = 50] = "WARN";
    /** General informational log message */ DiagLogLevel[DiagLogLevel["INFO"] = 60] = "INFO";
    /** General debug log message */ DiagLogLevel[DiagLogLevel["DEBUG"] = 70] = "DEBUG";
    /**
     * Detailed trace level logging should only be used for development, should only be set
     * in a development environment.
     */ DiagLogLevel[DiagLogLevel["VERBOSE"] = 80] = "VERBOSE";
    /** Used to set the logging level to include all logging */ DiagLogLevel[DiagLogLevel["ALL"] = 9999] = "ALL";
})($f2b5cbbf4ee10c75$export$b7d7b4c0f3c95263 || ($f2b5cbbf4ee10c75$export$b7d7b4c0f3c95263 = {}));

});



parcelRegister("6TiA3", function(module, exports) {

$parcel$export(module.exports, "BaggageImpl", function () { return $50464ad01a04b311$export$b8c511fa1a5f4987; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $50464ad01a04b311$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $50464ad01a04b311$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $50464ad01a04b311$export$b8c511fa1a5f4987 = /** @class */ function() {
    function BaggageImpl(entries) {
        this._entries = entries ? new Map(entries) : new Map();
    }
    BaggageImpl.prototype.getEntry = function(key) {
        var entry = this._entries.get(key);
        if (!entry) return undefined;
        return Object.assign({}, entry);
    };
    BaggageImpl.prototype.getAllEntries = function() {
        return Array.from(this._entries.entries()).map(function(_a) {
            var _b = $50464ad01a04b311$var$__read(_a, 2), k = _b[0], v = _b[1];
            return [
                k,
                v
            ];
        });
    };
    BaggageImpl.prototype.setEntry = function(key, entry) {
        var newBaggage = new BaggageImpl(this._entries);
        newBaggage._entries.set(key, entry);
        return newBaggage;
    };
    BaggageImpl.prototype.removeEntry = function(key) {
        var newBaggage = new BaggageImpl(this._entries);
        newBaggage._entries.delete(key);
        return newBaggage;
    };
    BaggageImpl.prototype.removeEntries = function() {
        var e_1, _a;
        var keys = [];
        for(var _i = 0; _i < arguments.length; _i++)keys[_i] = arguments[_i];
        var newBaggage = new BaggageImpl(this._entries);
        try {
            for(var keys_1 = $50464ad01a04b311$var$__values(keys), keys_1_1 = keys_1.next(); !keys_1_1.done; keys_1_1 = keys_1.next()){
                var key = keys_1_1.value;
                newBaggage._entries.delete(key);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (keys_1_1 && !keys_1_1.done && (_a = keys_1.return)) _a.call(keys_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return newBaggage;
    };
    BaggageImpl.prototype.clear = function() {
        return new BaggageImpl();
    };
    return BaggageImpl;
}();

});

parcelRegister("8GrH4", function(module, exports) {

$parcel$export(module.exports, "baggageEntryMetadataSymbol", function () { return $01a1ac4bde57f0eb$export$92dd2fe8ddb5cb7; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Symbol used to make BaggageEntryMetadata an opaque type
 */ var $01a1ac4bde57f0eb$export$92dd2fe8ddb5cb7 = Symbol('BaggageEntryMetadata');

});


parcelRegister("jVu0G", function(module, exports) {

$parcel$export(module.exports, "createContextKey", function () { return $e81a9e8d95a8d416$export$b8c322c5a7cfce78; });
$parcel$export(module.exports, "ROOT_CONTEXT", function () { return $e81a9e8d95a8d416$export$78df28f9b2f9a7dc; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Get a key to uniquely identify a context value */ function $e81a9e8d95a8d416$export$b8c322c5a7cfce78(description) {
    // The specification states that for the same input, multiple calls should
    // return different keys. Due to the nature of the JS dependency management
    // system, this creates problems where multiple versions of some package
    // could hold different keys for the same property.
    //
    // Therefore, we use Symbol.for which returns the same key for the same input.
    return Symbol.for(description);
}
var $e81a9e8d95a8d416$var$BaseContext = /** @class */ function() {
    /**
     * Construct a new context which inherits values from an optional parent context.
     *
     * @param parentContext a context from which to inherit values
     */ function BaseContext(parentContext) {
        // for minification
        var self = this;
        self._currentContext = parentContext ? new Map(parentContext) : new Map();
        self.getValue = function(key) {
            return self._currentContext.get(key);
        };
        self.setValue = function(key, value) {
            var context = new BaseContext(self._currentContext);
            context._currentContext.set(key, value);
            return context;
        };
        self.deleteValue = function(key) {
            var context = new BaseContext(self._currentContext);
            context._currentContext.delete(key);
            return context;
        };
    }
    return BaseContext;
}();
var $e81a9e8d95a8d416$export$78df28f9b2f9a7dc = new $e81a9e8d95a8d416$var$BaseContext();

});

parcelRegister("lbCBL", function(module, exports) {

$parcel$export(module.exports, "SamplingDecision", function () { return $f6c892d4b9c53ae0$export$94df7a7a96a92f7b; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @deprecated use the one declared in @opentelemetry/sdk-trace-base instead.
 * A sampling decision that determines how a {@link Span} will be recorded
 * and collected.
 */ var $f6c892d4b9c53ae0$export$94df7a7a96a92f7b;
(function(SamplingDecision) {
    /**
     * `Span.isRecording() === false`, span will not be recorded and all events
     * and attributes will be dropped.
     */ SamplingDecision[SamplingDecision["NOT_RECORD"] = 0] = "NOT_RECORD";
    /**
     * `Span.isRecording() === true`, but `Sampled` flag in {@link TraceFlags}
     * MUST NOT be set.
     */ SamplingDecision[SamplingDecision["RECORD"] = 1] = "RECORD";
    /**
     * `Span.isRecording() === true` AND `Sampled` flag in {@link TraceFlags}
     * MUST be set.
     */ SamplingDecision[SamplingDecision["RECORD_AND_SAMPLED"] = 2] = "RECORD_AND_SAMPLED";
})($f6c892d4b9c53ae0$export$94df7a7a96a92f7b || ($f6c892d4b9c53ae0$export$94df7a7a96a92f7b = {}));

});

parcelRegister("iS6Md", function(module, exports) {

$parcel$export(module.exports, "SpanKind", function () { return $dbd286dca5be8c6c$export$4da4ea8145910e8b; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $dbd286dca5be8c6c$export$4da4ea8145910e8b;
(function(SpanKind) {
    /** Default value. Indicates that the span is used internally. */ SpanKind[SpanKind["INTERNAL"] = 0] = "INTERNAL";
    /**
     * Indicates that the span covers server-side handling of an RPC or other
     * remote request.
     */ SpanKind[SpanKind["SERVER"] = 1] = "SERVER";
    /**
     * Indicates that the span covers the client-side wrapper around an RPC or
     * other remote request.
     */ SpanKind[SpanKind["CLIENT"] = 2] = "CLIENT";
    /**
     * Indicates that the span describes producer sending a message to a
     * broker. Unlike client and server, there is no direct critical path latency
     * relationship between producer and consumer spans.
     */ SpanKind[SpanKind["PRODUCER"] = 3] = "PRODUCER";
    /**
     * Indicates that the span describes consumer receiving a message from a
     * broker. Unlike client and server, there is no direct critical path latency
     * relationship between producer and consumer spans.
     */ SpanKind[SpanKind["CONSUMER"] = 4] = "CONSUMER";
})($dbd286dca5be8c6c$export$4da4ea8145910e8b || ($dbd286dca5be8c6c$export$4da4ea8145910e8b = {}));

});

parcelRegister("3UoQo", function(module, exports) {

$parcel$export(module.exports, "SpanStatusCode", function () { return $2d89df93c17a846d$export$1e28dd9b5d01db83; });
/**
 * An enumeration of status codes.
 */ var $2d89df93c17a846d$export$1e28dd9b5d01db83;
(function(SpanStatusCode) {
    /**
     * The default status.
     */ SpanStatusCode[SpanStatusCode["UNSET"] = 0] = "UNSET";
    /**
     * The operation has been validated by an Application developer or
     * Operator to have completed successfully.
     */ SpanStatusCode[SpanStatusCode["OK"] = 1] = "OK";
    /**
     * The operation contains an error.
     */ SpanStatusCode[SpanStatusCode["ERROR"] = 2] = "ERROR";
})($2d89df93c17a846d$export$1e28dd9b5d01db83 || ($2d89df93c17a846d$export$1e28dd9b5d01db83 = {}));

});

parcelRegister("kxoQ4", function(module, exports) {

$parcel$export(module.exports, "TraceFlags", function () { return $ef3a282c455dc5c0$export$bf9049ad2b0883ff; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $ef3a282c455dc5c0$export$bf9049ad2b0883ff;
(function(TraceFlags) {
    /** Represents no flag set. */ TraceFlags[TraceFlags["NONE"] = 0] = "NONE";
    /** Bit to represent whether trace is sampled in trace flags. */ TraceFlags[TraceFlags["SAMPLED"] = 1] = "SAMPLED";
})($ef3a282c455dc5c0$export$bf9049ad2b0883ff || ($ef3a282c455dc5c0$export$bf9049ad2b0883ff = {}));

});

parcelRegister("laija", function(module, exports) {

$parcel$export(module.exports, "isValidTraceId", function () { return $f688bbbf77b6af27$export$29dd34cf1269f6da; });
$parcel$export(module.exports, "isValidSpanId", function () { return $f688bbbf77b6af27$export$8e51c6d8f0586aff; });
$parcel$export(module.exports, "isSpanContextValid", function () { return $f688bbbf77b6af27$export$e4373b9a2c09216c; });
$parcel$export(module.exports, "wrapSpanContext", function () { return $f688bbbf77b6af27$export$c19cc0f1911bdb85; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gRjnF = parcelRequire("gRjnF");

var $dcT7k = parcelRequire("dcT7k");
var $f688bbbf77b6af27$var$VALID_TRACEID_REGEX = /^([0-9a-f]{32})$/i;
var $f688bbbf77b6af27$var$VALID_SPANID_REGEX = /^[0-9a-f]{16}$/i;
function $f688bbbf77b6af27$export$29dd34cf1269f6da(traceId) {
    return $f688bbbf77b6af27$var$VALID_TRACEID_REGEX.test(traceId) && traceId !== (0, $gRjnF.INVALID_TRACEID);
}
function $f688bbbf77b6af27$export$8e51c6d8f0586aff(spanId) {
    return $f688bbbf77b6af27$var$VALID_SPANID_REGEX.test(spanId) && spanId !== (0, $gRjnF.INVALID_SPANID);
}
function $f688bbbf77b6af27$export$e4373b9a2c09216c(spanContext) {
    return $f688bbbf77b6af27$export$29dd34cf1269f6da(spanContext.traceId) && $f688bbbf77b6af27$export$8e51c6d8f0586aff(spanContext.spanId);
}
function $f688bbbf77b6af27$export$c19cc0f1911bdb85(spanContext) {
    return new (0, $dcT7k.NonRecordingSpan)(spanContext);
}

});
parcelRegister("gRjnF", function(module, exports) {

$parcel$export(module.exports, "INVALID_SPANID", function () { return $c460a13444af844c$export$55cc39fb0d4bb4c0; });
$parcel$export(module.exports, "INVALID_TRACEID", function () { return $c460a13444af844c$export$22be96e88d95e128; });
$parcel$export(module.exports, "INVALID_SPAN_CONTEXT", function () { return $c460a13444af844c$export$8591e4c852b66703; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $kxoQ4 = parcelRequire("kxoQ4");
var $c460a13444af844c$export$55cc39fb0d4bb4c0 = '0000000000000000';
var $c460a13444af844c$export$22be96e88d95e128 = '00000000000000000000000000000000';
var $c460a13444af844c$export$8591e4c852b66703 = {
    traceId: $c460a13444af844c$export$22be96e88d95e128,
    spanId: $c460a13444af844c$export$55cc39fb0d4bb4c0,
    traceFlags: (0, $kxoQ4.TraceFlags).NONE
};

});

parcelRegister("dcT7k", function(module, exports) {

$parcel$export(module.exports, "NonRecordingSpan", function () { return $99d72676076c1a25$export$972d28f7c6a8c6c7; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gRjnF = parcelRequire("gRjnF");
/**
 * The NonRecordingSpan is the default {@link Span} that is used when no Span
 * implementation is available. All operations are no-op including context
 * propagation.
 */ var $99d72676076c1a25$export$972d28f7c6a8c6c7 = /** @class */ function() {
    function NonRecordingSpan(_spanContext) {
        if (_spanContext === void 0) _spanContext = (0, $gRjnF.INVALID_SPAN_CONTEXT);
        this._spanContext = _spanContext;
    }
    // Returns a SpanContext.
    NonRecordingSpan.prototype.spanContext = function() {
        return this._spanContext;
    };
    // By default does nothing
    NonRecordingSpan.prototype.setAttribute = function(_key, _value) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.setAttributes = function(_attributes) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.addEvent = function(_name, _attributes) {
        return this;
    };
    NonRecordingSpan.prototype.addLink = function(_link) {
        return this;
    };
    NonRecordingSpan.prototype.addLinks = function(_links) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.setStatus = function(_status) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.updateName = function(_name) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.end = function(_endTime) {};
    // isRecording always returns false for NonRecordingSpan.
    NonRecordingSpan.prototype.isRecording = function() {
        return false;
    };
    // By default does nothing
    NonRecordingSpan.prototype.recordException = function(_exception, _time) {};
    return NonRecordingSpan;
}();

});


parcelRegister("4e6si", function(module, exports) {

$parcel$export(module.exports, "context", function () { return $313d7a1f83ac513b$export$a078c61943f9dbbe; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.

var $eE7WE = parcelRequire("eE7WE");
var $313d7a1f83ac513b$export$a078c61943f9dbbe = (0, $eE7WE.ContextAPI).getInstance();

});
parcelRegister("eE7WE", function(module, exports) {

$parcel$export(module.exports, "ContextAPI", function () { return $aa9af6d5abccde0e$export$4148866f0a453927; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $e6JI3 = parcelRequire("e6JI3");

var $a5GVl = parcelRequire("a5GVl");

var $b7uAP = parcelRequire("b7uAP");
var $aa9af6d5abccde0e$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $aa9af6d5abccde0e$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $aa9af6d5abccde0e$var$API_NAME = 'context';
var $aa9af6d5abccde0e$var$NOOP_CONTEXT_MANAGER = new (0, $e6JI3.NoopContextManager)();
/**
 * Singleton object which represents the entry point to the OpenTelemetry Context API
 */ var $aa9af6d5abccde0e$export$4148866f0a453927 = /** @class */ function() {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ function ContextAPI() {}
    /** Get the singleton instance of the Context API */ ContextAPI.getInstance = function() {
        if (!this._instance) this._instance = new ContextAPI();
        return this._instance;
    };
    /**
     * Set the current context manager.
     *
     * @returns true if the context manager was successfully registered, else false
     */ ContextAPI.prototype.setGlobalContextManager = function(contextManager) {
        return (0, $a5GVl.registerGlobal)($aa9af6d5abccde0e$var$API_NAME, contextManager, (0, $b7uAP.DiagAPI).instance());
    };
    /**
     * Get the currently active context
     */ ContextAPI.prototype.active = function() {
        return this._getContextManager().active();
    };
    /**
     * Execute a function with an active context
     *
     * @param context context to be active during function execution
     * @param fn function to execute in a context
     * @param thisArg optional receiver to be used for calling fn
     * @param args optional arguments forwarded to fn
     */ ContextAPI.prototype.with = function(context, fn, thisArg) {
        var _a;
        var args = [];
        for(var _i = 3; _i < arguments.length; _i++)args[_i - 3] = arguments[_i];
        return (_a = this._getContextManager()).with.apply(_a, $aa9af6d5abccde0e$var$__spreadArray([
            context,
            fn,
            thisArg
        ], $aa9af6d5abccde0e$var$__read(args), false));
    };
    /**
     * Bind a context to a target function or event emitter
     *
     * @param context context to bind to the event emitter or function. Defaults to the currently active context
     * @param target function or event emitter to bind
     */ ContextAPI.prototype.bind = function(context, target) {
        return this._getContextManager().bind(context, target);
    };
    ContextAPI.prototype._getContextManager = function() {
        return (0, $a5GVl.getGlobal)($aa9af6d5abccde0e$var$API_NAME) || $aa9af6d5abccde0e$var$NOOP_CONTEXT_MANAGER;
    };
    /** Disable and remove the global context manager */ ContextAPI.prototype.disable = function() {
        this._getContextManager().disable();
        (0, $a5GVl.unregisterGlobal)($aa9af6d5abccde0e$var$API_NAME, (0, $b7uAP.DiagAPI).instance());
    };
    return ContextAPI;
}();

});
parcelRegister("e6JI3", function(module, exports) {

$parcel$export(module.exports, "NoopContextManager", function () { return $a4551532fe30f19b$export$a27e5df35d1539a6; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $jVu0G = parcelRequire("jVu0G");
var $a4551532fe30f19b$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $a4551532fe30f19b$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $a4551532fe30f19b$export$a27e5df35d1539a6 = /** @class */ function() {
    function NoopContextManager() {}
    NoopContextManager.prototype.active = function() {
        return 0, $jVu0G.ROOT_CONTEXT;
    };
    NoopContextManager.prototype.with = function(_context, fn, thisArg) {
        var args = [];
        for(var _i = 3; _i < arguments.length; _i++)args[_i - 3] = arguments[_i];
        return fn.call.apply(fn, $a4551532fe30f19b$var$__spreadArray([
            thisArg
        ], $a4551532fe30f19b$var$__read(args), false));
    };
    NoopContextManager.prototype.bind = function(_context, target) {
        return target;
    };
    NoopContextManager.prototype.enable = function() {
        return this;
    };
    NoopContextManager.prototype.disable = function() {
        return this;
    };
    return NoopContextManager;
}();

});



parcelRegister("7Y52R", function(module, exports) {

$parcel$export(module.exports, "diag", function () { return $5cd20cd6d5ad7618$export$c042e7c2f59bc046; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.

var $b7uAP = parcelRequire("b7uAP");
var $5cd20cd6d5ad7618$export$c042e7c2f59bc046 = (0, $b7uAP.DiagAPI).instance();

});

parcelRegister("3C1qe", function(module, exports) {

$parcel$export(module.exports, "metrics", function () { return $2a16061f9be8b490$export$b0c5c2fac8144e54; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.

var $3LSGG = parcelRequire("3LSGG");
var $2a16061f9be8b490$export$b0c5c2fac8144e54 = (0, $3LSGG.MetricsAPI).getInstance();

});
parcelRegister("3LSGG", function(module, exports) {

$parcel$export(module.exports, "MetricsAPI", function () { return $2bf02ea5ea5c8956$export$1339f6eb6111c638; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $440rd = parcelRequire("440rd");

var $a5GVl = parcelRequire("a5GVl");

var $b7uAP = parcelRequire("b7uAP");
var $2bf02ea5ea5c8956$var$API_NAME = 'metrics';
/**
 * Singleton object which represents the entry point to the OpenTelemetry Metrics API
 */ var $2bf02ea5ea5c8956$export$1339f6eb6111c638 = /** @class */ function() {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ function MetricsAPI() {}
    /** Get the singleton instance of the Metrics API */ MetricsAPI.getInstance = function() {
        if (!this._instance) this._instance = new MetricsAPI();
        return this._instance;
    };
    /**
     * Set the current global meter provider.
     * Returns true if the meter provider was successfully registered, else false.
     */ MetricsAPI.prototype.setGlobalMeterProvider = function(provider) {
        return (0, $a5GVl.registerGlobal)($2bf02ea5ea5c8956$var$API_NAME, provider, (0, $b7uAP.DiagAPI).instance());
    };
    /**
     * Returns the global meter provider.
     */ MetricsAPI.prototype.getMeterProvider = function() {
        return (0, $a5GVl.getGlobal)($2bf02ea5ea5c8956$var$API_NAME) || (0, $440rd.NOOP_METER_PROVIDER);
    };
    /**
     * Returns a meter from the global meter provider.
     */ MetricsAPI.prototype.getMeter = function(name, version, options) {
        return this.getMeterProvider().getMeter(name, version, options);
    };
    /** Remove the global meter provider */ MetricsAPI.prototype.disable = function() {
        (0, $a5GVl.unregisterGlobal)($2bf02ea5ea5c8956$var$API_NAME, (0, $b7uAP.DiagAPI).instance());
    };
    return MetricsAPI;
}();

});
parcelRegister("440rd", function(module, exports) {

$parcel$export(module.exports, "NOOP_METER_PROVIDER", function () { return $2f57e0183c943413$export$d21fe83355c56e18; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $koMcZ = parcelRequire("koMcZ");
/**
 * An implementation of the {@link MeterProvider} which returns an impotent Meter
 * for all calls to `getMeter`
 */ var $2f57e0183c943413$export$51c513ea08316108 = /** @class */ function() {
    function NoopMeterProvider() {}
    NoopMeterProvider.prototype.getMeter = function(_name, _version, _options) {
        return 0, $koMcZ.NOOP_METER;
    };
    return NoopMeterProvider;
}();
var $2f57e0183c943413$export$d21fe83355c56e18 = new $2f57e0183c943413$export$51c513ea08316108();

});
parcelRegister("koMcZ", function(module, exports) {

$parcel$export(module.exports, "NOOP_METER", function () { return $ed9b71bac6f1b783$export$65e277d35235a01f; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $ed9b71bac6f1b783$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * NoopMeter is a noop implementation of the {@link Meter} interface. It reuses
 * constant NoopMetrics for all of its methods.
 */ var $ed9b71bac6f1b783$export$c23c6f85dd4fc1e9 = /** @class */ function() {
    function NoopMeter() {}
    /**
     * @see {@link Meter.createGauge}
     */ NoopMeter.prototype.createGauge = function(_name, _options) {
        return $ed9b71bac6f1b783$export$dd01300aacbcec1c;
    };
    /**
     * @see {@link Meter.createHistogram}
     */ NoopMeter.prototype.createHistogram = function(_name, _options) {
        return $ed9b71bac6f1b783$export$689c32a6a552e1a6;
    };
    /**
     * @see {@link Meter.createCounter}
     */ NoopMeter.prototype.createCounter = function(_name, _options) {
        return $ed9b71bac6f1b783$export$e6d19fe5233efc54;
    };
    /**
     * @see {@link Meter.createUpDownCounter}
     */ NoopMeter.prototype.createUpDownCounter = function(_name, _options) {
        return $ed9b71bac6f1b783$export$2f189cd99d2b7429;
    };
    /**
     * @see {@link Meter.createObservableGauge}
     */ NoopMeter.prototype.createObservableGauge = function(_name, _options) {
        return $ed9b71bac6f1b783$export$ea67e3c6ff624776;
    };
    /**
     * @see {@link Meter.createObservableCounter}
     */ NoopMeter.prototype.createObservableCounter = function(_name, _options) {
        return $ed9b71bac6f1b783$export$163422b94c3edbcb;
    };
    /**
     * @see {@link Meter.createObservableUpDownCounter}
     */ NoopMeter.prototype.createObservableUpDownCounter = function(_name, _options) {
        return $ed9b71bac6f1b783$export$5b8be9ab17b673b3;
    };
    /**
     * @see {@link Meter.addBatchObservableCallback}
     */ NoopMeter.prototype.addBatchObservableCallback = function(_callback, _observables) {};
    /**
     * @see {@link Meter.removeBatchObservableCallback}
     */ NoopMeter.prototype.removeBatchObservableCallback = function(_callback) {};
    return NoopMeter;
}();
var $ed9b71bac6f1b783$export$834a616d1cf278b = /** @class */ function() {
    function NoopMetric() {}
    return NoopMetric;
}();
var $ed9b71bac6f1b783$export$b556ba0f560c45b = /** @class */ function(_super) {
    $ed9b71bac6f1b783$var$__extends(NoopCounterMetric, _super);
    function NoopCounterMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopCounterMetric.prototype.add = function(_value, _attributes) {};
    return NoopCounterMetric;
}($ed9b71bac6f1b783$export$834a616d1cf278b);
var $ed9b71bac6f1b783$export$df09a35db160df98 = /** @class */ function(_super) {
    $ed9b71bac6f1b783$var$__extends(NoopUpDownCounterMetric, _super);
    function NoopUpDownCounterMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopUpDownCounterMetric.prototype.add = function(_value, _attributes) {};
    return NoopUpDownCounterMetric;
}($ed9b71bac6f1b783$export$834a616d1cf278b);
var $ed9b71bac6f1b783$export$b7f4a3c7ea16c24 = /** @class */ function(_super) {
    $ed9b71bac6f1b783$var$__extends(NoopGaugeMetric, _super);
    function NoopGaugeMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopGaugeMetric.prototype.record = function(_value, _attributes) {};
    return NoopGaugeMetric;
}($ed9b71bac6f1b783$export$834a616d1cf278b);
var $ed9b71bac6f1b783$export$ef064c3e0426c607 = /** @class */ function(_super) {
    $ed9b71bac6f1b783$var$__extends(NoopHistogramMetric, _super);
    function NoopHistogramMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopHistogramMetric.prototype.record = function(_value, _attributes) {};
    return NoopHistogramMetric;
}($ed9b71bac6f1b783$export$834a616d1cf278b);
var $ed9b71bac6f1b783$export$a5a3e7829c289482 = /** @class */ function() {
    function NoopObservableMetric() {}
    NoopObservableMetric.prototype.addCallback = function(_callback) {};
    NoopObservableMetric.prototype.removeCallback = function(_callback) {};
    return NoopObservableMetric;
}();
var $ed9b71bac6f1b783$export$7a7e4b169d5c93a8 = /** @class */ function(_super) {
    $ed9b71bac6f1b783$var$__extends(NoopObservableCounterMetric, _super);
    function NoopObservableCounterMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NoopObservableCounterMetric;
}($ed9b71bac6f1b783$export$a5a3e7829c289482);
var $ed9b71bac6f1b783$export$6990a2f90809ffc1 = /** @class */ function(_super) {
    $ed9b71bac6f1b783$var$__extends(NoopObservableGaugeMetric, _super);
    function NoopObservableGaugeMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NoopObservableGaugeMetric;
}($ed9b71bac6f1b783$export$a5a3e7829c289482);
var $ed9b71bac6f1b783$export$3ec3555bc6f693a4 = /** @class */ function(_super) {
    $ed9b71bac6f1b783$var$__extends(NoopObservableUpDownCounterMetric, _super);
    function NoopObservableUpDownCounterMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NoopObservableUpDownCounterMetric;
}($ed9b71bac6f1b783$export$a5a3e7829c289482);
var $ed9b71bac6f1b783$export$65e277d35235a01f = new $ed9b71bac6f1b783$export$c23c6f85dd4fc1e9();
var $ed9b71bac6f1b783$export$e6d19fe5233efc54 = new $ed9b71bac6f1b783$export$b556ba0f560c45b();
var $ed9b71bac6f1b783$export$dd01300aacbcec1c = new $ed9b71bac6f1b783$export$b7f4a3c7ea16c24();
var $ed9b71bac6f1b783$export$689c32a6a552e1a6 = new $ed9b71bac6f1b783$export$ef064c3e0426c607();
var $ed9b71bac6f1b783$export$2f189cd99d2b7429 = new $ed9b71bac6f1b783$export$df09a35db160df98();
var $ed9b71bac6f1b783$export$163422b94c3edbcb = new $ed9b71bac6f1b783$export$7a7e4b169d5c93a8();
var $ed9b71bac6f1b783$export$ea67e3c6ff624776 = new $ed9b71bac6f1b783$export$6990a2f90809ffc1();
var $ed9b71bac6f1b783$export$5b8be9ab17b673b3 = new $ed9b71bac6f1b783$export$3ec3555bc6f693a4();
function $ed9b71bac6f1b783$export$bc3a498ccbb5c2b5() {
    return $ed9b71bac6f1b783$export$65e277d35235a01f;
}

});




parcelRegister("6b1Zv", function(module, exports) {

$parcel$export(module.exports, "propagation", function () { return $47f5508b7b31db60$export$3e49040daa9dba20; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.

var $ixaeE = parcelRequire("ixaeE");
var $47f5508b7b31db60$export$3e49040daa9dba20 = (0, $ixaeE.PropagationAPI).getInstance();

});
parcelRegister("ixaeE", function(module, exports) {

$parcel$export(module.exports, "PropagationAPI", function () { return $d7e33f920e17fe5b$export$471eda0a6213cac9; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $a5GVl = parcelRequire("a5GVl");

var $8XhSA = parcelRequire("8XhSA");

var $7f10j = parcelRequire("7f10j");

var $lr6uH = parcelRequire("lr6uH");

var $3mSe3 = parcelRequire("3mSe3");

var $b7uAP = parcelRequire("b7uAP");
var $d7e33f920e17fe5b$var$API_NAME = 'propagation';
var $d7e33f920e17fe5b$var$NOOP_TEXT_MAP_PROPAGATOR = new (0, $8XhSA.NoopTextMapPropagator)();
/**
 * Singleton object which represents the entry point to the OpenTelemetry Propagation API
 */ var $d7e33f920e17fe5b$export$471eda0a6213cac9 = /** @class */ function() {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ function PropagationAPI() {
        this.createBaggage = (0, $3mSe3.createBaggage);
        this.getBaggage = (0, $lr6uH.getBaggage);
        this.getActiveBaggage = (0, $lr6uH.getActiveBaggage);
        this.setBaggage = (0, $lr6uH.setBaggage);
        this.deleteBaggage = (0, $lr6uH.deleteBaggage);
    }
    /** Get the singleton instance of the Propagator API */ PropagationAPI.getInstance = function() {
        if (!this._instance) this._instance = new PropagationAPI();
        return this._instance;
    };
    /**
     * Set the current propagator.
     *
     * @returns true if the propagator was successfully registered, else false
     */ PropagationAPI.prototype.setGlobalPropagator = function(propagator) {
        return (0, $a5GVl.registerGlobal)($d7e33f920e17fe5b$var$API_NAME, propagator, (0, $b7uAP.DiagAPI).instance());
    };
    /**
     * Inject context into a carrier to be propagated inter-process
     *
     * @param context Context carrying tracing data to inject
     * @param carrier carrier to inject context into
     * @param setter Function used to set values on the carrier
     */ PropagationAPI.prototype.inject = function(context, carrier, setter) {
        if (setter === void 0) setter = (0, $7f10j.defaultTextMapSetter);
        return this._getGlobalPropagator().inject(context, carrier, setter);
    };
    /**
     * Extract context from a carrier
     *
     * @param context Context which the newly created context will inherit from
     * @param carrier Carrier to extract context from
     * @param getter Function used to extract keys from a carrier
     */ PropagationAPI.prototype.extract = function(context, carrier, getter) {
        if (getter === void 0) getter = (0, $7f10j.defaultTextMapGetter);
        return this._getGlobalPropagator().extract(context, carrier, getter);
    };
    /**
     * Return a list of all fields which may be used by the propagator.
     */ PropagationAPI.prototype.fields = function() {
        return this._getGlobalPropagator().fields();
    };
    /** Remove the global propagator */ PropagationAPI.prototype.disable = function() {
        (0, $a5GVl.unregisterGlobal)($d7e33f920e17fe5b$var$API_NAME, (0, $b7uAP.DiagAPI).instance());
    };
    PropagationAPI.prototype._getGlobalPropagator = function() {
        return (0, $a5GVl.getGlobal)($d7e33f920e17fe5b$var$API_NAME) || $d7e33f920e17fe5b$var$NOOP_TEXT_MAP_PROPAGATOR;
    };
    return PropagationAPI;
}();

});
parcelRegister("8XhSA", function(module, exports) {

$parcel$export(module.exports, "NoopTextMapPropagator", function () { return $6851b3e88d4eec06$export$8356c7eb3af7963b; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * No-op implementations of {@link TextMapPropagator}.
 */ var $6851b3e88d4eec06$export$8356c7eb3af7963b = /** @class */ function() {
    function NoopTextMapPropagator() {}
    /** Noop inject function does nothing */ NoopTextMapPropagator.prototype.inject = function(_context, _carrier) {};
    /** Noop extract function does nothing and returns the input context */ NoopTextMapPropagator.prototype.extract = function(context, _carrier) {
        return context;
    };
    NoopTextMapPropagator.prototype.fields = function() {
        return [];
    };
    return NoopTextMapPropagator;
}();

});

parcelRegister("7f10j", function(module, exports) {

$parcel$export(module.exports, "defaultTextMapGetter", function () { return $545ab685c64e37d6$export$a0f575f55f38720a; });
$parcel$export(module.exports, "defaultTextMapSetter", function () { return $545ab685c64e37d6$export$f70f1d111fccf1c1; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $545ab685c64e37d6$export$a0f575f55f38720a = {
    get: function(carrier, key) {
        if (carrier == null) return undefined;
        return carrier[key];
    },
    keys: function(carrier) {
        if (carrier == null) return [];
        return Object.keys(carrier);
    }
};
var $545ab685c64e37d6$export$f70f1d111fccf1c1 = {
    set: function(carrier, key, value) {
        if (carrier == null) return;
        carrier[key] = value;
    }
};

});

parcelRegister("lr6uH", function(module, exports) {

$parcel$export(module.exports, "getBaggage", function () { return $f9b1282d590aeafa$export$f3bffa0b5dd10d1e; });
$parcel$export(module.exports, "getActiveBaggage", function () { return $f9b1282d590aeafa$export$120a1756099436ee; });
$parcel$export(module.exports, "setBaggage", function () { return $f9b1282d590aeafa$export$adc9ca19eab3f500; });
$parcel$export(module.exports, "deleteBaggage", function () { return $f9b1282d590aeafa$export$4ca3a8a743c9f633; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $eE7WE = parcelRequire("eE7WE");

var $jVu0G = parcelRequire("jVu0G");
/**
 * Baggage key
 */ var $f9b1282d590aeafa$var$BAGGAGE_KEY = (0, $jVu0G.createContextKey)('OpenTelemetry Baggage Key');
function $f9b1282d590aeafa$export$f3bffa0b5dd10d1e(context) {
    return context.getValue($f9b1282d590aeafa$var$BAGGAGE_KEY) || undefined;
}
function $f9b1282d590aeafa$export$120a1756099436ee() {
    return $f9b1282d590aeafa$export$f3bffa0b5dd10d1e((0, $eE7WE.ContextAPI).getInstance().active());
}
function $f9b1282d590aeafa$export$adc9ca19eab3f500(context, baggage) {
    return context.setValue($f9b1282d590aeafa$var$BAGGAGE_KEY, baggage);
}
function $f9b1282d590aeafa$export$4ca3a8a743c9f633(context) {
    return context.deleteValue($f9b1282d590aeafa$var$BAGGAGE_KEY);
}

});



parcelRegister("g4DKS", function(module, exports) {

$parcel$export(module.exports, "trace", function () { return $bb3bdb9a766f7fb5$export$357889f174732d38; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.

var $CSsqO = parcelRequire("CSsqO");
var $bb3bdb9a766f7fb5$export$357889f174732d38 = (0, $CSsqO.TraceAPI).getInstance();

});
parcelRegister("CSsqO", function(module, exports) {

$parcel$export(module.exports, "TraceAPI", function () { return $074dcadd24e66ec6$export$2cccde6fcc7b568a; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $a5GVl = parcelRequire("a5GVl");

var $j2xNr = parcelRequire("j2xNr");

var $laija = parcelRequire("laija");

var $kC620 = parcelRequire("kC620");

var $b7uAP = parcelRequire("b7uAP");
var $074dcadd24e66ec6$var$API_NAME = 'trace';
/**
 * Singleton object which represents the entry point to the OpenTelemetry Tracing API
 */ var $074dcadd24e66ec6$export$2cccde6fcc7b568a = /** @class */ function() {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ function TraceAPI() {
        this._proxyTracerProvider = new (0, $j2xNr.ProxyTracerProvider)();
        this.wrapSpanContext = (0, $laija.wrapSpanContext);
        this.isSpanContextValid = (0, $laija.isSpanContextValid);
        this.deleteSpan = (0, $kC620.deleteSpan);
        this.getSpan = (0, $kC620.getSpan);
        this.getActiveSpan = (0, $kC620.getActiveSpan);
        this.getSpanContext = (0, $kC620.getSpanContext);
        this.setSpan = (0, $kC620.setSpan);
        this.setSpanContext = (0, $kC620.setSpanContext);
    }
    /** Get the singleton instance of the Trace API */ TraceAPI.getInstance = function() {
        if (!this._instance) this._instance = new TraceAPI();
        return this._instance;
    };
    /**
     * Set the current global tracer.
     *
     * @returns true if the tracer provider was successfully registered, else false
     */ TraceAPI.prototype.setGlobalTracerProvider = function(provider) {
        var success = (0, $a5GVl.registerGlobal)($074dcadd24e66ec6$var$API_NAME, this._proxyTracerProvider, (0, $b7uAP.DiagAPI).instance());
        if (success) this._proxyTracerProvider.setDelegate(provider);
        return success;
    };
    /**
     * Returns the global tracer provider.
     */ TraceAPI.prototype.getTracerProvider = function() {
        return (0, $a5GVl.getGlobal)($074dcadd24e66ec6$var$API_NAME) || this._proxyTracerProvider;
    };
    /**
     * Returns a tracer from the global tracer provider.
     */ TraceAPI.prototype.getTracer = function(name, version) {
        return this.getTracerProvider().getTracer(name, version);
    };
    /** Remove the global tracer provider */ TraceAPI.prototype.disable = function() {
        (0, $a5GVl.unregisterGlobal)($074dcadd24e66ec6$var$API_NAME, (0, $b7uAP.DiagAPI).instance());
        this._proxyTracerProvider = new (0, $j2xNr.ProxyTracerProvider)();
    };
    return TraceAPI;
}();

});
parcelRegister("j2xNr", function(module, exports) {

$parcel$export(module.exports, "ProxyTracerProvider", function () { return $ddc86b802509a04d$export$4137aabcb4254962; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $9WKJu = parcelRequire("9WKJu");

var $ss36f = parcelRequire("ss36f");
var $ddc86b802509a04d$var$NOOP_TRACER_PROVIDER = new (0, $ss36f.NoopTracerProvider)();
/**
 * Tracer provider which provides {@link ProxyTracer}s.
 *
 * Before a delegate is set, tracers provided are NoOp.
 *   When a delegate is set, traces are provided from the delegate.
 *   When a delegate is set after tracers have already been provided,
 *   all tracers already provided will use the provided delegate implementation.
 */ var $ddc86b802509a04d$export$4137aabcb4254962 = /** @class */ function() {
    function ProxyTracerProvider() {}
    /**
     * Get a {@link ProxyTracer}
     */ ProxyTracerProvider.prototype.getTracer = function(name, version, options) {
        var _a;
        return (_a = this.getDelegateTracer(name, version, options)) !== null && _a !== void 0 ? _a : new (0, $9WKJu.ProxyTracer)(this, name, version, options);
    };
    ProxyTracerProvider.prototype.getDelegate = function() {
        var _a;
        return (_a = this._delegate) !== null && _a !== void 0 ? _a : $ddc86b802509a04d$var$NOOP_TRACER_PROVIDER;
    };
    /**
     * Set the delegate tracer provider
     */ ProxyTracerProvider.prototype.setDelegate = function(delegate) {
        this._delegate = delegate;
    };
    ProxyTracerProvider.prototype.getDelegateTracer = function(name, version, options) {
        var _a;
        return (_a = this._delegate) === null || _a === void 0 ? void 0 : _a.getTracer(name, version, options);
    };
    return ProxyTracerProvider;
}();

});
parcelRegister("9WKJu", function(module, exports) {

$parcel$export(module.exports, "ProxyTracer", function () { return $73ddc7f673e764a9$export$df2c38268c6bb6b3; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $cMbUn = parcelRequire("cMbUn");
var $73ddc7f673e764a9$var$NOOP_TRACER = new (0, $cMbUn.NoopTracer)();
/**
 * Proxy tracer provided by the proxy tracer provider
 */ var $73ddc7f673e764a9$export$df2c38268c6bb6b3 = /** @class */ function() {
    function ProxyTracer(_provider, name, version, options) {
        this._provider = _provider;
        this.name = name;
        this.version = version;
        this.options = options;
    }
    ProxyTracer.prototype.startSpan = function(name, options, context) {
        return this._getTracer().startSpan(name, options, context);
    };
    ProxyTracer.prototype.startActiveSpan = function(_name, _options, _context, _fn) {
        var tracer = this._getTracer();
        return Reflect.apply(tracer.startActiveSpan, tracer, arguments);
    };
    /**
     * Try to get a tracer from the proxy tracer provider.
     * If the proxy tracer provider has no delegate, return a noop tracer.
     */ ProxyTracer.prototype._getTracer = function() {
        if (this._delegate) return this._delegate;
        var tracer = this._provider.getDelegateTracer(this.name, this.version, this.options);
        if (!tracer) return $73ddc7f673e764a9$var$NOOP_TRACER;
        this._delegate = tracer;
        return this._delegate;
    };
    return ProxyTracer;
}();

});
parcelRegister("cMbUn", function(module, exports) {

$parcel$export(module.exports, "NoopTracer", function () { return $94d3347d446984b8$export$714c1036cabcd223; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $eE7WE = parcelRequire("eE7WE");

var $kC620 = parcelRequire("kC620");

var $dcT7k = parcelRequire("dcT7k");

var $laija = parcelRequire("laija");
var $94d3347d446984b8$var$contextApi = (0, $eE7WE.ContextAPI).getInstance();
/**
 * No-op implementations of {@link Tracer}.
 */ var $94d3347d446984b8$export$714c1036cabcd223 = /** @class */ function() {
    function NoopTracer() {}
    // startSpan starts a noop span.
    NoopTracer.prototype.startSpan = function(name, options, context) {
        if (context === void 0) context = $94d3347d446984b8$var$contextApi.active();
        var root = Boolean(options === null || options === void 0 ? void 0 : options.root);
        if (root) return new (0, $dcT7k.NonRecordingSpan)();
        var parentFromContext = context && (0, $kC620.getSpanContext)(context);
        if ($94d3347d446984b8$var$isSpanContext(parentFromContext) && (0, $laija.isSpanContextValid)(parentFromContext)) return new (0, $dcT7k.NonRecordingSpan)(parentFromContext);
        else return new (0, $dcT7k.NonRecordingSpan)();
    };
    NoopTracer.prototype.startActiveSpan = function(name, arg2, arg3, arg4) {
        var opts;
        var ctx;
        var fn;
        if (arguments.length < 2) return;
        else if (arguments.length === 2) fn = arg2;
        else if (arguments.length === 3) {
            opts = arg2;
            fn = arg3;
        } else {
            opts = arg2;
            ctx = arg3;
            fn = arg4;
        }
        var parentContext = ctx !== null && ctx !== void 0 ? ctx : $94d3347d446984b8$var$contextApi.active();
        var span = this.startSpan(name, opts, parentContext);
        var contextWithSpanSet = (0, $kC620.setSpan)(parentContext, span);
        return $94d3347d446984b8$var$contextApi.with(contextWithSpanSet, fn, undefined, span);
    };
    return NoopTracer;
}();
function $94d3347d446984b8$var$isSpanContext(spanContext) {
    return typeof spanContext === 'object' && typeof spanContext['spanId'] === 'string' && typeof spanContext['traceId'] === 'string' && typeof spanContext['traceFlags'] === 'number';
}

});
parcelRegister("kC620", function(module, exports) {

$parcel$export(module.exports, "getSpan", function () { return $f01c08f091df3724$export$246e04ba06066af1; });
$parcel$export(module.exports, "getActiveSpan", function () { return $f01c08f091df3724$export$1be426a8e585c83e; });
$parcel$export(module.exports, "setSpan", function () { return $f01c08f091df3724$export$8ab2f2e6ee8ed0a8; });
$parcel$export(module.exports, "deleteSpan", function () { return $f01c08f091df3724$export$a6bbfe9a17f7941c; });
$parcel$export(module.exports, "setSpanContext", function () { return $f01c08f091df3724$export$c90bf5428c14cdb1; });
$parcel$export(module.exports, "getSpanContext", function () { return $f01c08f091df3724$export$1a635f8f0b912781; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $jVu0G = parcelRequire("jVu0G");

var $dcT7k = parcelRequire("dcT7k");

var $eE7WE = parcelRequire("eE7WE");
/**
 * span key
 */ var $f01c08f091df3724$var$SPAN_KEY = (0, $jVu0G.createContextKey)('OpenTelemetry Context Key SPAN');
function $f01c08f091df3724$export$246e04ba06066af1(context) {
    return context.getValue($f01c08f091df3724$var$SPAN_KEY) || undefined;
}
function $f01c08f091df3724$export$1be426a8e585c83e() {
    return $f01c08f091df3724$export$246e04ba06066af1((0, $eE7WE.ContextAPI).getInstance().active());
}
function $f01c08f091df3724$export$8ab2f2e6ee8ed0a8(context, span) {
    return context.setValue($f01c08f091df3724$var$SPAN_KEY, span);
}
function $f01c08f091df3724$export$a6bbfe9a17f7941c(context) {
    return context.deleteValue($f01c08f091df3724$var$SPAN_KEY);
}
function $f01c08f091df3724$export$c90bf5428c14cdb1(context, spanContext) {
    return $f01c08f091df3724$export$8ab2f2e6ee8ed0a8(context, new (0, $dcT7k.NonRecordingSpan)(spanContext));
}
function $f01c08f091df3724$export$1a635f8f0b912781(context) {
    var _a;
    return (_a = $f01c08f091df3724$export$246e04ba06066af1(context)) === null || _a === void 0 ? void 0 : _a.spanContext();
}

});



parcelRegister("ss36f", function(module, exports) {

$parcel$export(module.exports, "NoopTracerProvider", function () { return $05585f9607ee34ac$export$87d8e93756f9e86e; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $cMbUn = parcelRequire("cMbUn");
/**
 * An implementation of the {@link TracerProvider} which returns an impotent
 * Tracer for all calls to `getTracer`.
 *
 * All operations are no-op.
 */ var $05585f9607ee34ac$export$87d8e93756f9e86e = /** @class */ function() {
    function NoopTracerProvider() {}
    NoopTracerProvider.prototype.getTracer = function(_name, _version, _options) {
        return new (0, $cMbUn.NoopTracer)();
    };
    return NoopTracerProvider;
}();

});





parcelRegister("5p0rJ", function(module, exports) {

$parcel$export(module.exports, "BindOnceFuture", function () { return $3eefa232b04d6a27$export$c1f52ab4952184cd; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $7HPqi = parcelRequire("7HPqi");
var $3eefa232b04d6a27$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $3eefa232b04d6a27$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * Bind the callback and only invoke the callback once regardless how many times `BindOnceFuture.call` is invoked.
 */ var $3eefa232b04d6a27$export$c1f52ab4952184cd = /** @class */ function() {
    function BindOnceFuture(_callback, _that) {
        this._callback = _callback;
        this._that = _that;
        this._isCalled = false;
        this._deferred = new (0, $7HPqi.Deferred)();
    }
    Object.defineProperty(BindOnceFuture.prototype, "isCalled", {
        get: function() {
            return this._isCalled;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BindOnceFuture.prototype, "promise", {
        get: function() {
            return this._deferred.promise;
        },
        enumerable: false,
        configurable: true
    });
    BindOnceFuture.prototype.call = function() {
        var _a;
        var _this = this;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (!this._isCalled) {
            this._isCalled = true;
            try {
                Promise.resolve((_a = this._callback).call.apply(_a, $3eefa232b04d6a27$var$__spreadArray([
                    this._that
                ], $3eefa232b04d6a27$var$__read(args), false))).then(function(val) {
                    return _this._deferred.resolve(val);
                }, function(err) {
                    return _this._deferred.reject(err);
                });
            } catch (err) {
                this._deferred.reject(err);
            }
        }
        return this._deferred.promise;
    };
    return BindOnceFuture;
}();

});
parcelRegister("7HPqi", function(module, exports) {

$parcel$export(module.exports, "Deferred", function () { return $59c4701e10bf314c$export$85f6557964517f1a; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $59c4701e10bf314c$export$85f6557964517f1a = /** @class */ function() {
    function Deferred() {
        var _this = this;
        this._promise = new Promise(function(resolve, reject) {
            _this._resolve = resolve;
            _this._reject = reject;
        });
    }
    Object.defineProperty(Deferred.prototype, "promise", {
        get: function() {
            return this._promise;
        },
        enumerable: false,
        configurable: true
    });
    Deferred.prototype.resolve = function(val) {
        this._resolve(val);
    };
    Deferred.prototype.reject = function(err) {
        this._reject(err);
    };
    return Deferred;
}();

});


parcelRegister("61V2D", function(module, exports) {

$parcel$export(module.exports, "ExportResultCode", function () { return $01220cbb3d3fb767$export$ee0fe4df4ef0f3a1; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $01220cbb3d3fb767$export$ee0fe4df4ef0f3a1;
(function(ExportResultCode) {
    ExportResultCode[ExportResultCode["SUCCESS"] = 0] = "SUCCESS";
    ExportResultCode[ExportResultCode["FAILED"] = 1] = "FAILED";
})($01220cbb3d3fb767$export$ee0fe4df4ef0f3a1 || ($01220cbb3d3fb767$export$ee0fe4df4ef0f3a1 = {}));

});

parcelRegister("d2oti", function(module, exports) {

$parcel$export(module.exports, "getEnv", function () { return $97de71caf3757360$export$4bd44a2aa29d3d6e; });
$parcel$export(module.exports, "getEnvWithoutDefaults", function () { return $97de71caf3757360$export$728650dd4748d692; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $88zmq = parcelRequire("88zmq");

var $jxeEy = parcelRequire("jxeEy");
function $97de71caf3757360$export$4bd44a2aa29d3d6e() {
    var globalEnv = (0, $88zmq.parseEnvironment)((0, $jxeEy._globalThis));
    return Object.assign({}, (0, $88zmq.DEFAULT_ENVIRONMENT), globalEnv);
}
function $97de71caf3757360$export$728650dd4748d692() {
    return (0, $88zmq.parseEnvironment)((0, $jxeEy._globalThis));
}

});
parcelRegister("88zmq", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_ATTRIBUTE_VALUE_LENGTH_LIMIT", function () { return $5eca7ff9f3179073$export$d9446f3c1c12def1; });
$parcel$export(module.exports, "DEFAULT_ATTRIBUTE_COUNT_LIMIT", function () { return $5eca7ff9f3179073$export$6ad612be99f9ed48; });
$parcel$export(module.exports, "DEFAULT_ENVIRONMENT", function () { return $5eca7ff9f3179073$export$849dbeeeda01ae98; });
$parcel$export(module.exports, "parseEnvironment", function () { return $5eca7ff9f3179073$export$99f17f8ee99049eb; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $kPWiP = parcelRequire("kPWiP");

var $dxcBp = parcelRequire("dxcBp");
var $5eca7ff9f3179073$var$DEFAULT_LIST_SEPARATOR = ',';
/**
 * Environment interface to define all names
 */ var $5eca7ff9f3179073$var$ENVIRONMENT_BOOLEAN_KEYS = [
    'OTEL_SDK_DISABLED'
];
function $5eca7ff9f3179073$var$isEnvVarABoolean(key) {
    return $5eca7ff9f3179073$var$ENVIRONMENT_BOOLEAN_KEYS.indexOf(key) > -1;
}
var $5eca7ff9f3179073$var$ENVIRONMENT_NUMBERS_KEYS = [
    'OTEL_BSP_EXPORT_TIMEOUT',
    'OTEL_BSP_MAX_EXPORT_BATCH_SIZE',
    'OTEL_BSP_MAX_QUEUE_SIZE',
    'OTEL_BSP_SCHEDULE_DELAY',
    'OTEL_BLRP_EXPORT_TIMEOUT',
    'OTEL_BLRP_MAX_EXPORT_BATCH_SIZE',
    'OTEL_BLRP_MAX_QUEUE_SIZE',
    'OTEL_BLRP_SCHEDULE_DELAY',
    'OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT',
    'OTEL_ATTRIBUTE_COUNT_LIMIT',
    'OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT',
    'OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT',
    'OTEL_LOGRECORD_ATTRIBUTE_VALUE_LENGTH_LIMIT',
    'OTEL_LOGRECORD_ATTRIBUTE_COUNT_LIMIT',
    'OTEL_SPAN_EVENT_COUNT_LIMIT',
    'OTEL_SPAN_LINK_COUNT_LIMIT',
    'OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT',
    'OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT',
    'OTEL_EXPORTER_OTLP_TIMEOUT',
    'OTEL_EXPORTER_OTLP_TRACES_TIMEOUT',
    'OTEL_EXPORTER_OTLP_METRICS_TIMEOUT',
    'OTEL_EXPORTER_OTLP_LOGS_TIMEOUT',
    'OTEL_EXPORTER_JAEGER_AGENT_PORT'
];
function $5eca7ff9f3179073$var$isEnvVarANumber(key) {
    return $5eca7ff9f3179073$var$ENVIRONMENT_NUMBERS_KEYS.indexOf(key) > -1;
}
var $5eca7ff9f3179073$var$ENVIRONMENT_LISTS_KEYS = [
    'OTEL_NO_PATCH_MODULES',
    'OTEL_PROPAGATORS'
];
function $5eca7ff9f3179073$var$isEnvVarAList(key) {
    return $5eca7ff9f3179073$var$ENVIRONMENT_LISTS_KEYS.indexOf(key) > -1;
}
var $5eca7ff9f3179073$export$d9446f3c1c12def1 = Infinity;
var $5eca7ff9f3179073$export$6ad612be99f9ed48 = 128;
var $5eca7ff9f3179073$export$c5bbf26b60de6148 = 128;
var $5eca7ff9f3179073$export$f200b88493991cbe = 128;
var $5eca7ff9f3179073$export$849dbeeeda01ae98 = {
    OTEL_SDK_DISABLED: false,
    CONTAINER_NAME: '',
    ECS_CONTAINER_METADATA_URI_V4: '',
    ECS_CONTAINER_METADATA_URI: '',
    HOSTNAME: '',
    KUBERNETES_SERVICE_HOST: '',
    NAMESPACE: '',
    OTEL_BSP_EXPORT_TIMEOUT: 30000,
    OTEL_BSP_MAX_EXPORT_BATCH_SIZE: 512,
    OTEL_BSP_MAX_QUEUE_SIZE: 2048,
    OTEL_BSP_SCHEDULE_DELAY: 5000,
    OTEL_BLRP_EXPORT_TIMEOUT: 30000,
    OTEL_BLRP_MAX_EXPORT_BATCH_SIZE: 512,
    OTEL_BLRP_MAX_QUEUE_SIZE: 2048,
    OTEL_BLRP_SCHEDULE_DELAY: 5000,
    OTEL_EXPORTER_JAEGER_AGENT_HOST: '',
    OTEL_EXPORTER_JAEGER_AGENT_PORT: 6832,
    OTEL_EXPORTER_JAEGER_ENDPOINT: '',
    OTEL_EXPORTER_JAEGER_PASSWORD: '',
    OTEL_EXPORTER_JAEGER_USER: '',
    OTEL_EXPORTER_OTLP_ENDPOINT: '',
    OTEL_EXPORTER_OTLP_TRACES_ENDPOINT: '',
    OTEL_EXPORTER_OTLP_METRICS_ENDPOINT: '',
    OTEL_EXPORTER_OTLP_LOGS_ENDPOINT: '',
    OTEL_EXPORTER_OTLP_HEADERS: '',
    OTEL_EXPORTER_OTLP_TRACES_HEADERS: '',
    OTEL_EXPORTER_OTLP_METRICS_HEADERS: '',
    OTEL_EXPORTER_OTLP_LOGS_HEADERS: '',
    OTEL_EXPORTER_OTLP_TIMEOUT: 10000,
    OTEL_EXPORTER_OTLP_TRACES_TIMEOUT: 10000,
    OTEL_EXPORTER_OTLP_METRICS_TIMEOUT: 10000,
    OTEL_EXPORTER_OTLP_LOGS_TIMEOUT: 10000,
    OTEL_EXPORTER_ZIPKIN_ENDPOINT: 'http://localhost:9411/api/v2/spans',
    OTEL_LOG_LEVEL: (0, $kPWiP.DiagLogLevel).INFO,
    OTEL_NO_PATCH_MODULES: [],
    OTEL_PROPAGATORS: [
        'tracecontext',
        'baggage'
    ],
    OTEL_RESOURCE_ATTRIBUTES: '',
    OTEL_SERVICE_NAME: '',
    OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT: $5eca7ff9f3179073$export$d9446f3c1c12def1,
    OTEL_ATTRIBUTE_COUNT_LIMIT: $5eca7ff9f3179073$export$6ad612be99f9ed48,
    OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT: $5eca7ff9f3179073$export$d9446f3c1c12def1,
    OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT: $5eca7ff9f3179073$export$6ad612be99f9ed48,
    OTEL_LOGRECORD_ATTRIBUTE_VALUE_LENGTH_LIMIT: $5eca7ff9f3179073$export$d9446f3c1c12def1,
    OTEL_LOGRECORD_ATTRIBUTE_COUNT_LIMIT: $5eca7ff9f3179073$export$6ad612be99f9ed48,
    OTEL_SPAN_EVENT_COUNT_LIMIT: 128,
    OTEL_SPAN_LINK_COUNT_LIMIT: 128,
    OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT: $5eca7ff9f3179073$export$c5bbf26b60de6148,
    OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT: $5eca7ff9f3179073$export$f200b88493991cbe,
    OTEL_TRACES_EXPORTER: '',
    OTEL_TRACES_SAMPLER: (0, $dxcBp.TracesSamplerValues).ParentBasedAlwaysOn,
    OTEL_TRACES_SAMPLER_ARG: '',
    OTEL_LOGS_EXPORTER: '',
    OTEL_EXPORTER_OTLP_INSECURE: '',
    OTEL_EXPORTER_OTLP_TRACES_INSECURE: '',
    OTEL_EXPORTER_OTLP_METRICS_INSECURE: '',
    OTEL_EXPORTER_OTLP_LOGS_INSECURE: '',
    OTEL_EXPORTER_OTLP_CERTIFICATE: '',
    OTEL_EXPORTER_OTLP_TRACES_CERTIFICATE: '',
    OTEL_EXPORTER_OTLP_METRICS_CERTIFICATE: '',
    OTEL_EXPORTER_OTLP_LOGS_CERTIFICATE: '',
    OTEL_EXPORTER_OTLP_COMPRESSION: '',
    OTEL_EXPORTER_OTLP_TRACES_COMPRESSION: '',
    OTEL_EXPORTER_OTLP_METRICS_COMPRESSION: '',
    OTEL_EXPORTER_OTLP_LOGS_COMPRESSION: '',
    OTEL_EXPORTER_OTLP_CLIENT_KEY: '',
    OTEL_EXPORTER_OTLP_TRACES_CLIENT_KEY: '',
    OTEL_EXPORTER_OTLP_METRICS_CLIENT_KEY: '',
    OTEL_EXPORTER_OTLP_LOGS_CLIENT_KEY: '',
    OTEL_EXPORTER_OTLP_CLIENT_CERTIFICATE: '',
    OTEL_EXPORTER_OTLP_TRACES_CLIENT_CERTIFICATE: '',
    OTEL_EXPORTER_OTLP_METRICS_CLIENT_CERTIFICATE: '',
    OTEL_EXPORTER_OTLP_LOGS_CLIENT_CERTIFICATE: '',
    OTEL_EXPORTER_OTLP_PROTOCOL: 'http/protobuf',
    OTEL_EXPORTER_OTLP_TRACES_PROTOCOL: 'http/protobuf',
    OTEL_EXPORTER_OTLP_METRICS_PROTOCOL: 'http/protobuf',
    OTEL_EXPORTER_OTLP_LOGS_PROTOCOL: 'http/protobuf',
    OTEL_EXPORTER_OTLP_METRICS_TEMPORALITY_PREFERENCE: 'cumulative'
};
/**
 * @param key
 * @param environment
 * @param values
 */ function $5eca7ff9f3179073$var$parseBoolean(key, environment, values) {
    if (typeof values[key] === 'undefined') return;
    var value = String(values[key]);
    // support case-insensitive "true"
    environment[key] = value.toLowerCase() === 'true';
}
/**
 * Parses a variable as number with number validation
 * @param name
 * @param environment
 * @param values
 * @param min
 * @param max
 */ function $5eca7ff9f3179073$var$parseNumber(name, environment, values, min, max) {
    if (min === void 0) min = -Infinity;
    if (max === void 0) max = Infinity;
    if (typeof values[name] !== 'undefined') {
        var value = Number(values[name]);
        if (!isNaN(value)) {
            if (value < min) environment[name] = min;
            else if (value > max) environment[name] = max;
            else environment[name] = value;
        }
    }
}
/**
 * Parses list-like strings from input into output.
 * @param name
 * @param environment
 * @param values
 * @param separator
 */ function $5eca7ff9f3179073$var$parseStringList(name, output, input, separator) {
    if (separator === void 0) separator = $5eca7ff9f3179073$var$DEFAULT_LIST_SEPARATOR;
    var givenValue = input[name];
    if (typeof givenValue === 'string') output[name] = givenValue.split(separator).map(function(v) {
        return v.trim();
    });
}
// The support string -> DiagLogLevel mappings
var $5eca7ff9f3179073$var$logLevelMap = {
    ALL: (0, $kPWiP.DiagLogLevel).ALL,
    VERBOSE: (0, $kPWiP.DiagLogLevel).VERBOSE,
    DEBUG: (0, $kPWiP.DiagLogLevel).DEBUG,
    INFO: (0, $kPWiP.DiagLogLevel).INFO,
    WARN: (0, $kPWiP.DiagLogLevel).WARN,
    ERROR: (0, $kPWiP.DiagLogLevel).ERROR,
    NONE: (0, $kPWiP.DiagLogLevel).NONE
};
/**
 * Environmentally sets log level if valid log level string is provided
 * @param key
 * @param environment
 * @param values
 */ function $5eca7ff9f3179073$var$setLogLevelFromEnv(key, environment, values) {
    var value = values[key];
    if (typeof value === 'string') {
        var theLevel = $5eca7ff9f3179073$var$logLevelMap[value.toUpperCase()];
        if (theLevel != null) environment[key] = theLevel;
    }
}
function $5eca7ff9f3179073$export$99f17f8ee99049eb(values) {
    var environment = {};
    for(var env in $5eca7ff9f3179073$export$849dbeeeda01ae98){
        var key = env;
        switch(key){
            case 'OTEL_LOG_LEVEL':
                $5eca7ff9f3179073$var$setLogLevelFromEnv(key, environment, values);
                break;
            default:
                if ($5eca7ff9f3179073$var$isEnvVarABoolean(key)) $5eca7ff9f3179073$var$parseBoolean(key, environment, values);
                else if ($5eca7ff9f3179073$var$isEnvVarANumber(key)) $5eca7ff9f3179073$var$parseNumber(key, environment, values);
                else if ($5eca7ff9f3179073$var$isEnvVarAList(key)) $5eca7ff9f3179073$var$parseStringList(key, environment, values);
                else {
                    var value = values[key];
                    if (typeof value !== 'undefined' && value !== null) environment[key] = String(value);
                }
        }
    }
    return environment;
}

});
parcelRegister("dxcBp", function(module, exports) {

$parcel$export(module.exports, "TracesSamplerValues", function () { return $9da821fdc0d0111d$export$243c1c4fe84ef188; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $9da821fdc0d0111d$export$243c1c4fe84ef188;
(function(TracesSamplerValues) {
    TracesSamplerValues["AlwaysOff"] = "always_off";
    TracesSamplerValues["AlwaysOn"] = "always_on";
    TracesSamplerValues["ParentBasedAlwaysOff"] = "parentbased_always_off";
    TracesSamplerValues["ParentBasedAlwaysOn"] = "parentbased_always_on";
    TracesSamplerValues["ParentBasedTraceIdRatio"] = "parentbased_traceidratio";
    TracesSamplerValues["TraceIdRatio"] = "traceidratio";
})($9da821fdc0d0111d$export$243c1c4fe84ef188 || ($9da821fdc0d0111d$export$243c1c4fe84ef188 = {}));

});


parcelRegister("jxeEy", function(module, exports) {

$parcel$export(module.exports, "_globalThis", function () { return $e38c773480bcf14f$export$5c524ddf7208c00c; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Updates to this file should also be replicated to @opentelemetry/api too.
/**
 * - globalThis (New standard)
 * - self (Will return the current window instance for supported browsers)
 * - window (fallback for older browser implementations)
 * - global (NodeJS implementation)
 * - <object> (When all else fails)
 */ /** only globals that common to node and browsers are allowed */ // eslint-disable-next-line node/no-unsupported-features/es-builtins, no-undef
var $e38c773480bcf14f$export$5c524ddf7208c00c = typeof globalThis === 'object' ? globalThis : typeof self === 'object' ? self : typeof window === 'object' ? window : typeof $parcel$global === 'object' ? $parcel$global : {};

});


parcelRegister("5ytUs", function(module, exports) {

$parcel$export(module.exports, "globalErrorHandler", function () { return $40b754223aa32447$export$54c6946fc34b7cc2; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $5GLh7 = parcelRequire("5GLh7");
/** The global error handler delegate */ var $40b754223aa32447$var$delegateHandler = (0, $5GLh7.loggingErrorHandler)();
function $40b754223aa32447$export$bdff946829732435(handler) {
    $40b754223aa32447$var$delegateHandler = handler;
}
function $40b754223aa32447$export$54c6946fc34b7cc2(ex) {
    try {
        $40b754223aa32447$var$delegateHandler(ex);
    } catch (_a) {} // eslint-disable-line no-empty
}

});
parcelRegister("5GLh7", function(module, exports) {

$parcel$export(module.exports, "loggingErrorHandler", function () { return $42458bd6546fa874$export$cd67a16f6d11e5bd; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ parcelRequire("ckckF");
var $7Y52R = parcelRequire("7Y52R");
function $42458bd6546fa874$export$cd67a16f6d11e5bd() {
    return function(ex) {
        (0, $7Y52R.diag).error($42458bd6546fa874$var$stringifyException(ex));
    };
}
/**
 * Converts an exception into a string representation
 * @param {Exception} ex
 */ function $42458bd6546fa874$var$stringifyException(ex) {
    if (typeof ex === 'string') return ex;
    else return JSON.stringify($42458bd6546fa874$var$flattenException(ex));
}
/**
 * Flattens an exception into key-value pairs by traversing the prototype chain
 * and coercing values to strings. Duplicate properties will not be overwritten;
 * the first insert wins.
 */ function $42458bd6546fa874$var$flattenException(ex) {
    var result = {};
    var current = ex;
    while(current !== null){
        Object.getOwnPropertyNames(current).forEach(function(propertyName) {
            if (result[propertyName]) return;
            var value = current[propertyName];
            if (value) result[propertyName] = String(value);
        });
        current = Object.getPrototypeOf(current);
    }
    return result;
}

});


parcelRegister("3WAuq", function(module, exports) {

$parcel$export(module.exports, "suppressTracing", function () { return $2df317f7f18f5fdf$export$869298f9835abc68; });
$parcel$export(module.exports, "isTracingSuppressed", function () { return $2df317f7f18f5fdf$export$7d5f2376f7cf513; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $jVu0G = parcelRequire("jVu0G");
var $2df317f7f18f5fdf$var$SUPPRESS_TRACING_KEY = (0, $jVu0G.createContextKey)('OpenTelemetry SDK Context Key SUPPRESS_TRACING');
function $2df317f7f18f5fdf$export$869298f9835abc68(context) {
    return context.setValue($2df317f7f18f5fdf$var$SUPPRESS_TRACING_KEY, true);
}
function $2df317f7f18f5fdf$export$a8cb26cef1019d30(context) {
    return context.deleteValue($2df317f7f18f5fdf$var$SUPPRESS_TRACING_KEY);
}
function $2df317f7f18f5fdf$export$7d5f2376f7cf513(context) {
    return context.getValue($2df317f7f18f5fdf$var$SUPPRESS_TRACING_KEY) === true;
}

});

parcelRegister("lNcy1", function(module, exports) {

$parcel$export(module.exports, "unrefTimer", function () { return $fdd7e85064ab6fbd$export$13bcdd8a72da0e8f; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $fdd7e85064ab6fbd$export$13bcdd8a72da0e8f(_timer) {}

});



parcelRegister("5neJ1", function(module, exports) {

$parcel$export(module.exports, "addSpanNetworkEvents", function () { return $3e9a85d42df0ea4a$export$e2385716cf129455; });
$parcel$export(module.exports, "getResource", function () { return $3e9a85d42df0ea4a$export$cdcba7438a7553e8; });
$parcel$export(module.exports, "parseUrl", function () { return $3e9a85d42df0ea4a$export$7a5253c0f62e0150; });
$parcel$export(module.exports, "getElementXPath", function () { return $3e9a85d42df0ea4a$export$fabdebd274ccbd1c; });
$parcel$export(module.exports, "shouldPropagateTraceHeaders", function () { return $3e9a85d42df0ea4a$export$c6501d7e56a5b40a; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $5Tevc = parcelRequire("5Tevc");

var $jL8hu = parcelRequire("jL8hu");
var $b5Rs1 = parcelRequire("b5Rs1");

var $7XDeR = parcelRequire("7XDeR");
// Used to normalize relative URLs
var $3e9a85d42df0ea4a$var$urlNormalizingAnchor;
function $3e9a85d42df0ea4a$var$getUrlNormalizingAnchor() {
    if (!$3e9a85d42df0ea4a$var$urlNormalizingAnchor) $3e9a85d42df0ea4a$var$urlNormalizingAnchor = document.createElement('a');
    return $3e9a85d42df0ea4a$var$urlNormalizingAnchor;
}
function $3e9a85d42df0ea4a$export$94df19ecb868bc1a(obj, key) {
    return key in obj;
}
function $3e9a85d42df0ea4a$export$7e5e8f17966d37d1(span, performanceName, entries, refPerfName) {
    var perfTime = undefined;
    var refTime = undefined;
    if ($3e9a85d42df0ea4a$export$94df19ecb868bc1a(entries, performanceName) && typeof entries[performanceName] === 'number') perfTime = entries[performanceName];
    var refName = refPerfName || (0, $5Tevc.PerformanceTimingNames).FETCH_START;
    // Use a reference time which is the earliest possible value so that the performance timings that are earlier should not be added
    // using FETCH START time in case no reference is provided
    if ($3e9a85d42df0ea4a$export$94df19ecb868bc1a(entries, refName) && typeof entries[refName] === 'number') refTime = entries[refName];
    if (perfTime !== undefined && refTime !== undefined && perfTime >= refTime) {
        span.addEvent(performanceName, perfTime);
        return span;
    }
    return undefined;
}
function $3e9a85d42df0ea4a$export$e2385716cf129455(span, resource) {
    $3e9a85d42df0ea4a$export$7e5e8f17966d37d1(span, (0, $5Tevc.PerformanceTimingNames).FETCH_START, resource);
    $3e9a85d42df0ea4a$export$7e5e8f17966d37d1(span, (0, $5Tevc.PerformanceTimingNames).DOMAIN_LOOKUP_START, resource);
    $3e9a85d42df0ea4a$export$7e5e8f17966d37d1(span, (0, $5Tevc.PerformanceTimingNames).DOMAIN_LOOKUP_END, resource);
    $3e9a85d42df0ea4a$export$7e5e8f17966d37d1(span, (0, $5Tevc.PerformanceTimingNames).CONNECT_START, resource);
    if ($3e9a85d42df0ea4a$export$94df19ecb868bc1a(resource, 'name') && resource['name'].startsWith('https:')) $3e9a85d42df0ea4a$export$7e5e8f17966d37d1(span, (0, $5Tevc.PerformanceTimingNames).SECURE_CONNECTION_START, resource);
    $3e9a85d42df0ea4a$export$7e5e8f17966d37d1(span, (0, $5Tevc.PerformanceTimingNames).CONNECT_END, resource);
    $3e9a85d42df0ea4a$export$7e5e8f17966d37d1(span, (0, $5Tevc.PerformanceTimingNames).REQUEST_START, resource);
    $3e9a85d42df0ea4a$export$7e5e8f17966d37d1(span, (0, $5Tevc.PerformanceTimingNames).RESPONSE_START, resource);
    $3e9a85d42df0ea4a$export$7e5e8f17966d37d1(span, (0, $5Tevc.PerformanceTimingNames).RESPONSE_END, resource);
    var encodedLength = resource[(0, $5Tevc.PerformanceTimingNames).ENCODED_BODY_SIZE];
    if (encodedLength !== undefined) span.setAttribute((0, $7XDeR.SEMATTRS_HTTP_RESPONSE_CONTENT_LENGTH), encodedLength);
    var decodedLength = resource[(0, $5Tevc.PerformanceTimingNames).DECODED_BODY_SIZE];
    // Spec: Not set if transport encoding not used (in which case encoded and decoded sizes match)
    if (decodedLength !== undefined && encodedLength !== decodedLength) span.setAttribute((0, $7XDeR.SEMATTRS_HTTP_RESPONSE_CONTENT_LENGTH_UNCOMPRESSED), decodedLength);
}
function $3e9a85d42df0ea4a$export$5d17283e524de23c(filteredResources) {
    return filteredResources.slice().sort(function(a, b) {
        var valueA = a[(0, $5Tevc.PerformanceTimingNames).FETCH_START];
        var valueB = b[(0, $5Tevc.PerformanceTimingNames).FETCH_START];
        if (valueA > valueB) return 1;
        else if (valueA < valueB) return -1;
        return 0;
    });
}
/** Returns the origin if present (if in browser context). */ function $3e9a85d42df0ea4a$var$getOrigin() {
    return typeof location !== 'undefined' ? location.origin : undefined;
}
function $3e9a85d42df0ea4a$export$cdcba7438a7553e8(spanUrl, startTimeHR, endTimeHR, resources, ignoredResources, initiatorType) {
    if (ignoredResources === void 0) ignoredResources = new WeakSet();
    // de-relativize the URL before usage (does no harm to absolute URLs)
    var parsedSpanUrl = $3e9a85d42df0ea4a$export$7a5253c0f62e0150(spanUrl);
    spanUrl = parsedSpanUrl.toString();
    var filteredResources = $3e9a85d42df0ea4a$var$filterResourcesForSpan(spanUrl, startTimeHR, endTimeHR, resources, ignoredResources, initiatorType);
    if (filteredResources.length === 0) return {
        mainRequest: undefined
    };
    if (filteredResources.length === 1) return {
        mainRequest: filteredResources[0]
    };
    var sorted = $3e9a85d42df0ea4a$export$5d17283e524de23c(filteredResources);
    if (parsedSpanUrl.origin !== $3e9a85d42df0ea4a$var$getOrigin() && sorted.length > 1) {
        var corsPreFlightRequest = sorted[0];
        var mainRequest = $3e9a85d42df0ea4a$var$findMainRequest(sorted, corsPreFlightRequest[(0, $5Tevc.PerformanceTimingNames).RESPONSE_END], endTimeHR);
        var responseEnd = corsPreFlightRequest[(0, $5Tevc.PerformanceTimingNames).RESPONSE_END];
        var fetchStart = mainRequest[(0, $5Tevc.PerformanceTimingNames).FETCH_START];
        // no corsPreFlightRequest
        if (fetchStart < responseEnd) {
            mainRequest = corsPreFlightRequest;
            corsPreFlightRequest = undefined;
        }
        return {
            corsPreFlightRequest: corsPreFlightRequest,
            mainRequest: mainRequest
        };
    } else return {
        mainRequest: filteredResources[0]
    };
}
/**
 * Will find the main request skipping the cors pre flight requests
 * @param resources
 * @param corsPreFlightRequestEndTime
 * @param spanEndTimeHR
 */ function $3e9a85d42df0ea4a$var$findMainRequest(resources, corsPreFlightRequestEndTime, spanEndTimeHR) {
    var spanEndTime = (0, $jL8hu.hrTimeToNanoseconds)(spanEndTimeHR);
    var minTime = (0, $jL8hu.hrTimeToNanoseconds)((0, $jL8hu.timeInputToHrTime)(corsPreFlightRequestEndTime));
    var mainRequest = resources[1];
    var bestGap;
    var length = resources.length;
    for(var i = 1; i < length; i++){
        var resource = resources[i];
        var resourceStartTime = (0, $jL8hu.hrTimeToNanoseconds)((0, $jL8hu.timeInputToHrTime)(resource[(0, $5Tevc.PerformanceTimingNames).FETCH_START]));
        var resourceEndTime = (0, $jL8hu.hrTimeToNanoseconds)((0, $jL8hu.timeInputToHrTime)(resource[(0, $5Tevc.PerformanceTimingNames).RESPONSE_END]));
        var currentGap = spanEndTime - resourceEndTime;
        if (resourceStartTime >= minTime && (!bestGap || currentGap < bestGap)) {
            bestGap = currentGap;
            mainRequest = resource;
        }
    }
    return mainRequest;
}
/**
 * Filter all resources that has started and finished according to span start time and end time.
 *     It will return the closest resource to a start time
 * @param spanUrl
 * @param startTimeHR
 * @param endTimeHR
 * @param resources
 * @param ignoredResources
 */ function $3e9a85d42df0ea4a$var$filterResourcesForSpan(spanUrl, startTimeHR, endTimeHR, resources, ignoredResources, initiatorType) {
    var startTime = (0, $jL8hu.hrTimeToNanoseconds)(startTimeHR);
    var endTime = (0, $jL8hu.hrTimeToNanoseconds)(endTimeHR);
    var filteredResources = resources.filter(function(resource) {
        var resourceStartTime = (0, $jL8hu.hrTimeToNanoseconds)((0, $jL8hu.timeInputToHrTime)(resource[(0, $5Tevc.PerformanceTimingNames).FETCH_START]));
        var resourceEndTime = (0, $jL8hu.hrTimeToNanoseconds)((0, $jL8hu.timeInputToHrTime)(resource[(0, $5Tevc.PerformanceTimingNames).RESPONSE_END]));
        return resource.initiatorType.toLowerCase() === (initiatorType || 'xmlhttprequest') && resource.name === spanUrl && resourceStartTime >= startTime && resourceEndTime <= endTime;
    });
    if (filteredResources.length > 0) filteredResources = filteredResources.filter(function(resource) {
        return !ignoredResources.has(resource);
    });
    return filteredResources;
}
function $3e9a85d42df0ea4a$export$7a5253c0f62e0150(url) {
    if (typeof URL === 'function') return new URL(url, typeof document !== 'undefined' ? document.baseURI : typeof location !== 'undefined' // Some JS runtimes (e.g. Deno) don't define this
     ? location.href : undefined);
    var element = $3e9a85d42df0ea4a$var$getUrlNormalizingAnchor();
    element.href = url;
    return element;
}
function $3e9a85d42df0ea4a$export$6535eb414fa2c8b6(url) {
    var urlLike = $3e9a85d42df0ea4a$export$7a5253c0f62e0150(url);
    return urlLike.href;
}
function $3e9a85d42df0ea4a$export$fabdebd274ccbd1c(target, optimised) {
    if (target.nodeType === Node.DOCUMENT_NODE) return '/';
    var targetValue = $3e9a85d42df0ea4a$var$getNodeValue(target, optimised);
    if (optimised && targetValue.indexOf('@id') > 0) return targetValue;
    var xpath = '';
    if (target.parentNode) xpath += $3e9a85d42df0ea4a$export$fabdebd274ccbd1c(target.parentNode, false);
    xpath += targetValue;
    return xpath;
}
/**
 * get node index within the siblings
 * @param target
 */ function $3e9a85d42df0ea4a$var$getNodeIndex(target) {
    if (!target.parentNode) return 0;
    var allowedTypes = [
        target.nodeType
    ];
    if (target.nodeType === Node.CDATA_SECTION_NODE) allowedTypes.push(Node.TEXT_NODE);
    var elements = Array.from(target.parentNode.childNodes);
    elements = elements.filter(function(element) {
        var localName = element.localName;
        return allowedTypes.indexOf(element.nodeType) >= 0 && localName === target.localName;
    });
    if (elements.length >= 1) return elements.indexOf(target) + 1; // xpath starts from 1
    // if there are no other similar child xpath doesn't need index
    return 0;
}
/**
 * get node value for xpath
 * @param target
 * @param optimised
 */ function $3e9a85d42df0ea4a$var$getNodeValue(target, optimised) {
    var nodeType = target.nodeType;
    var index = $3e9a85d42df0ea4a$var$getNodeIndex(target);
    var nodeValue = '';
    if (nodeType === Node.ELEMENT_NODE) {
        var id = target.getAttribute('id');
        if (optimised && id) return "//*[@id=\"" + id + "\"]";
        nodeValue = target.localName;
    } else if (nodeType === Node.TEXT_NODE || nodeType === Node.CDATA_SECTION_NODE) nodeValue = 'text()';
    else if (nodeType === Node.COMMENT_NODE) nodeValue = 'comment()';
    else return '';
    // if index is 1 it can be omitted in xpath
    if (nodeValue && index > 1) return "/" + nodeValue + "[" + index + "]";
    return "/" + nodeValue;
}
function $3e9a85d42df0ea4a$export$c6501d7e56a5b40a(spanUrl, propagateTraceHeaderCorsUrls) {
    var propagateTraceHeaderUrls = propagateTraceHeaderCorsUrls || [];
    if (typeof propagateTraceHeaderUrls === 'string' || propagateTraceHeaderUrls instanceof RegExp) propagateTraceHeaderUrls = [
        propagateTraceHeaderUrls
    ];
    var parsedSpanUrl = $3e9a85d42df0ea4a$export$7a5253c0f62e0150(spanUrl);
    if (parsedSpanUrl.origin === $3e9a85d42df0ea4a$var$getOrigin()) return true;
    else return propagateTraceHeaderUrls.some(function(propagateTraceHeaderUrl) {
        return (0, $b5Rs1.urlMatches)(spanUrl, propagateTraceHeaderUrl);
    });
}

});
parcelRegister("5Tevc", function(module, exports) {

$parcel$export(module.exports, "PerformanceTimingNames", function () { return $449d56a53037a26a$export$74be52df2d6fd28c; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $449d56a53037a26a$export$74be52df2d6fd28c;
(function(PerformanceTimingNames) {
    PerformanceTimingNames["CONNECT_END"] = "connectEnd";
    PerformanceTimingNames["CONNECT_START"] = "connectStart";
    PerformanceTimingNames["DECODED_BODY_SIZE"] = "decodedBodySize";
    PerformanceTimingNames["DOM_COMPLETE"] = "domComplete";
    PerformanceTimingNames["DOM_CONTENT_LOADED_EVENT_END"] = "domContentLoadedEventEnd";
    PerformanceTimingNames["DOM_CONTENT_LOADED_EVENT_START"] = "domContentLoadedEventStart";
    PerformanceTimingNames["DOM_INTERACTIVE"] = "domInteractive";
    PerformanceTimingNames["DOMAIN_LOOKUP_END"] = "domainLookupEnd";
    PerformanceTimingNames["DOMAIN_LOOKUP_START"] = "domainLookupStart";
    PerformanceTimingNames["ENCODED_BODY_SIZE"] = "encodedBodySize";
    PerformanceTimingNames["FETCH_START"] = "fetchStart";
    PerformanceTimingNames["LOAD_EVENT_END"] = "loadEventEnd";
    PerformanceTimingNames["LOAD_EVENT_START"] = "loadEventStart";
    PerformanceTimingNames["NAVIGATION_START"] = "navigationStart";
    PerformanceTimingNames["REDIRECT_END"] = "redirectEnd";
    PerformanceTimingNames["REDIRECT_START"] = "redirectStart";
    PerformanceTimingNames["REQUEST_START"] = "requestStart";
    PerformanceTimingNames["RESPONSE_END"] = "responseEnd";
    PerformanceTimingNames["RESPONSE_START"] = "responseStart";
    PerformanceTimingNames["SECURE_CONNECTION_START"] = "secureConnectionStart";
    PerformanceTimingNames["UNLOAD_EVENT_END"] = "unloadEventEnd";
    PerformanceTimingNames["UNLOAD_EVENT_START"] = "unloadEventStart";
})($449d56a53037a26a$export$74be52df2d6fd28c || ($449d56a53037a26a$export$74be52df2d6fd28c = {}));

});

parcelRegister("jL8hu", function(module, exports) {

$parcel$export(module.exports, "millisToHrTime", function () { return $e628d48986d3c003$export$e7ec5c82995537b1; });
$parcel$export(module.exports, "getTimeOrigin", function () { return $e628d48986d3c003$export$e752b05e58096a2f; });
$parcel$export(module.exports, "hrTime", function () { return $e628d48986d3c003$export$24b3f7dcd2848fa8; });
$parcel$export(module.exports, "addHrTimes", function () { return $e628d48986d3c003$export$f07bb1dbc72184c3; });
$parcel$export(module.exports, "timeInputToHrTime", function () { return $e628d48986d3c003$export$5f4c8a8ba0e36226; });
$parcel$export(module.exports, "isTimeInputHrTime", function () { return $e628d48986d3c003$export$390c59432f173a9f; });
$parcel$export(module.exports, "hrTimeDuration", function () { return $e628d48986d3c003$export$b783ad6617389e3e; });
$parcel$export(module.exports, "hrTimeToNanoseconds", function () { return $e628d48986d3c003$export$2d91441ae30ebcfc; });
$parcel$export(module.exports, "isTimeInput", function () { return $e628d48986d3c003$export$a5e58227c317ebb9; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $77Kiv = parcelRequire("77Kiv");
var $e628d48986d3c003$var$NANOSECOND_DIGITS = 9;
var $e628d48986d3c003$var$NANOSECOND_DIGITS_IN_MILLIS = 6;
var $e628d48986d3c003$var$MILLISECONDS_TO_NANOSECONDS = Math.pow(10, $e628d48986d3c003$var$NANOSECOND_DIGITS_IN_MILLIS);
var $e628d48986d3c003$var$SECOND_TO_NANOSECONDS = Math.pow(10, $e628d48986d3c003$var$NANOSECOND_DIGITS);
function $e628d48986d3c003$export$e7ec5c82995537b1(epochMillis) {
    var epochSeconds = epochMillis / 1000;
    // Decimals only.
    var seconds = Math.trunc(epochSeconds);
    // Round sub-nanosecond accuracy to nanosecond.
    var nanos = Math.round(epochMillis % 1000 * $e628d48986d3c003$var$MILLISECONDS_TO_NANOSECONDS);
    return [
        seconds,
        nanos
    ];
}
function $e628d48986d3c003$export$e752b05e58096a2f() {
    var timeOrigin = (0, $77Kiv.otperformance).timeOrigin;
    if (typeof timeOrigin !== 'number') {
        var perf = (0, $77Kiv.otperformance);
        timeOrigin = perf.timing && perf.timing.fetchStart;
    }
    return timeOrigin;
}
function $e628d48986d3c003$export$24b3f7dcd2848fa8(performanceNow) {
    var timeOrigin = $e628d48986d3c003$export$e7ec5c82995537b1($e628d48986d3c003$export$e752b05e58096a2f());
    var now = $e628d48986d3c003$export$e7ec5c82995537b1(typeof performanceNow === 'number' ? performanceNow : (0, $77Kiv.otperformance).now());
    return $e628d48986d3c003$export$f07bb1dbc72184c3(timeOrigin, now);
}
function $e628d48986d3c003$export$5f4c8a8ba0e36226(time) {
    // process.hrtime
    if ($e628d48986d3c003$export$390c59432f173a9f(time)) return time;
    else if (typeof time === 'number') {
        // Must be a performance.now() if it's smaller than process start time.
        if (time < $e628d48986d3c003$export$e752b05e58096a2f()) return $e628d48986d3c003$export$24b3f7dcd2848fa8(time);
        else // epoch milliseconds or performance.timeOrigin
        return $e628d48986d3c003$export$e7ec5c82995537b1(time);
    } else if (time instanceof Date) return $e628d48986d3c003$export$e7ec5c82995537b1(time.getTime());
    else throw TypeError('Invalid input type');
}
function $e628d48986d3c003$export$b783ad6617389e3e(startTime, endTime) {
    var seconds = endTime[0] - startTime[0];
    var nanos = endTime[1] - startTime[1];
    // overflow
    if (nanos < 0) {
        seconds -= 1;
        // negate
        nanos += $e628d48986d3c003$var$SECOND_TO_NANOSECONDS;
    }
    return [
        seconds,
        nanos
    ];
}
function $e628d48986d3c003$export$973c1c4fad6103e(time) {
    var precision = $e628d48986d3c003$var$NANOSECOND_DIGITS;
    var tmp = "" + '0'.repeat(precision) + time[1] + "Z";
    var nanoString = tmp.substr(tmp.length - precision - 1);
    var date = new Date(time[0] * 1000).toISOString();
    return date.replace('000Z', nanoString);
}
function $e628d48986d3c003$export$2d91441ae30ebcfc(time) {
    return time[0] * $e628d48986d3c003$var$SECOND_TO_NANOSECONDS + time[1];
}
function $e628d48986d3c003$export$30b3706e4e35edf0(time) {
    return time[0] * 1e3 + time[1] / 1e6;
}
function $e628d48986d3c003$export$95601fd64fa689b7(time) {
    return time[0] * 1e6 + time[1] / 1e3;
}
function $e628d48986d3c003$export$390c59432f173a9f(value) {
    return Array.isArray(value) && value.length === 2 && typeof value[0] === 'number' && typeof value[1] === 'number';
}
function $e628d48986d3c003$export$a5e58227c317ebb9(value) {
    return $e628d48986d3c003$export$390c59432f173a9f(value) || typeof value === 'number' || value instanceof Date;
}
function $e628d48986d3c003$export$f07bb1dbc72184c3(time1, time2) {
    var out = [
        time1[0] + time2[0],
        time1[1] + time2[1]
    ];
    // Nanoseconds
    if (out[1] >= $e628d48986d3c003$var$SECOND_TO_NANOSECONDS) {
        out[1] -= $e628d48986d3c003$var$SECOND_TO_NANOSECONDS;
        out[0] += 1;
    }
    return out;
}

});
parcelRegister("77Kiv", function(module, exports) {

$parcel$export(module.exports, "otperformance", function () { return $52fd19942174af3b$export$b22daef4119238cd; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $52fd19942174af3b$export$b22daef4119238cd = performance;

});


parcelRegister("b5Rs1", function(module, exports) {

$parcel$export(module.exports, "urlMatches", function () { return $81399f9ba3ec53ed$export$c2a944331f80ae92; });
$parcel$export(module.exports, "isUrlIgnored", function () { return $81399f9ba3ec53ed$export$172b5a1c42a6f83d; });
var $81399f9ba3ec53ed$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function $81399f9ba3ec53ed$export$c2a944331f80ae92(url, urlToMatch) {
    if (typeof urlToMatch === 'string') return url === urlToMatch;
    else return !!url.match(urlToMatch);
}
function $81399f9ba3ec53ed$export$172b5a1c42a6f83d(url, ignoredUrls) {
    var e_1, _a;
    if (!ignoredUrls) return false;
    try {
        for(var ignoredUrls_1 = $81399f9ba3ec53ed$var$__values(ignoredUrls), ignoredUrls_1_1 = ignoredUrls_1.next(); !ignoredUrls_1_1.done; ignoredUrls_1_1 = ignoredUrls_1.next()){
            var ignoreUrl = ignoredUrls_1_1.value;
            if ($81399f9ba3ec53ed$export$c2a944331f80ae92(url, ignoreUrl)) return true;
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (ignoredUrls_1_1 && !ignoredUrls_1_1.done && (_a = ignoredUrls_1.return)) _a.call(ignoredUrls_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return false;
}

});

parcelRegister("7XDeR", function(module, exports) {

$parcel$export(module.exports, "SEMATTRS_EXCEPTION_TYPE", function () { return $5cbc7b0f58119792$export$ecc84ea0f5a24384; });
$parcel$export(module.exports, "SEMATTRS_EXCEPTION_MESSAGE", function () { return $5cbc7b0f58119792$export$ff69507dfa9dcf0c; });
$parcel$export(module.exports, "SEMATTRS_EXCEPTION_STACKTRACE", function () { return $5cbc7b0f58119792$export$d9432f0c350b687d; });
$parcel$export(module.exports, "SEMATTRS_HTTP_METHOD", function () { return $5cbc7b0f58119792$export$5ec7d06d671a3fbe; });
$parcel$export(module.exports, "SEMATTRS_HTTP_URL", function () { return $5cbc7b0f58119792$export$2f4ef7e39c2be395; });
$parcel$export(module.exports, "SEMATTRS_HTTP_HOST", function () { return $5cbc7b0f58119792$export$547e24d3f59a53ea; });
$parcel$export(module.exports, "SEMATTRS_HTTP_SCHEME", function () { return $5cbc7b0f58119792$export$a2928efa45f0acf4; });
$parcel$export(module.exports, "SEMATTRS_HTTP_STATUS_CODE", function () { return $5cbc7b0f58119792$export$d381c7525d715413; });
$parcel$export(module.exports, "SEMATTRS_HTTP_USER_AGENT", function () { return $5cbc7b0f58119792$export$7472b18f42d2d02f; });
$parcel$export(module.exports, "SEMATTRS_HTTP_RESPONSE_CONTENT_LENGTH", function () { return $5cbc7b0f58119792$export$58d4fbfe35e08be0; });
$parcel$export(module.exports, "SEMATTRS_HTTP_RESPONSE_CONTENT_LENGTH_UNCOMPRESSED", function () { return $5cbc7b0f58119792$export$b9d3e41cd56c56cc; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $17HEJ = parcelRequire("17HEJ");
//----------------------------------------------------------------------------------------------------------
// DO NOT EDIT, this is an Auto-generated file from scripts/semconv/templates//templates/SemanticAttributes.ts.j2
//----------------------------------------------------------------------------------------------------------
//----------------------------------------------------------------------------------------------------------
// Constant values for SemanticAttributes
//----------------------------------------------------------------------------------------------------------
// Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifable export names for some package types
var $5cbc7b0f58119792$var$TMP_AWS_LAMBDA_INVOKED_ARN = 'aws.lambda.invoked_arn';
var $5cbc7b0f58119792$var$TMP_DB_SYSTEM = 'db.system';
var $5cbc7b0f58119792$var$TMP_DB_CONNECTION_STRING = 'db.connection_string';
var $5cbc7b0f58119792$var$TMP_DB_USER = 'db.user';
var $5cbc7b0f58119792$var$TMP_DB_JDBC_DRIVER_CLASSNAME = 'db.jdbc.driver_classname';
var $5cbc7b0f58119792$var$TMP_DB_NAME = 'db.name';
var $5cbc7b0f58119792$var$TMP_DB_STATEMENT = 'db.statement';
var $5cbc7b0f58119792$var$TMP_DB_OPERATION = 'db.operation';
var $5cbc7b0f58119792$var$TMP_DB_MSSQL_INSTANCE_NAME = 'db.mssql.instance_name';
var $5cbc7b0f58119792$var$TMP_DB_CASSANDRA_KEYSPACE = 'db.cassandra.keyspace';
var $5cbc7b0f58119792$var$TMP_DB_CASSANDRA_PAGE_SIZE = 'db.cassandra.page_size';
var $5cbc7b0f58119792$var$TMP_DB_CASSANDRA_CONSISTENCY_LEVEL = 'db.cassandra.consistency_level';
var $5cbc7b0f58119792$var$TMP_DB_CASSANDRA_TABLE = 'db.cassandra.table';
var $5cbc7b0f58119792$var$TMP_DB_CASSANDRA_IDEMPOTENCE = 'db.cassandra.idempotence';
var $5cbc7b0f58119792$var$TMP_DB_CASSANDRA_SPECULATIVE_EXECUTION_COUNT = 'db.cassandra.speculative_execution_count';
var $5cbc7b0f58119792$var$TMP_DB_CASSANDRA_COORDINATOR_ID = 'db.cassandra.coordinator.id';
var $5cbc7b0f58119792$var$TMP_DB_CASSANDRA_COORDINATOR_DC = 'db.cassandra.coordinator.dc';
var $5cbc7b0f58119792$var$TMP_DB_HBASE_NAMESPACE = 'db.hbase.namespace';
var $5cbc7b0f58119792$var$TMP_DB_REDIS_DATABASE_INDEX = 'db.redis.database_index';
var $5cbc7b0f58119792$var$TMP_DB_MONGODB_COLLECTION = 'db.mongodb.collection';
var $5cbc7b0f58119792$var$TMP_DB_SQL_TABLE = 'db.sql.table';
var $5cbc7b0f58119792$var$TMP_EXCEPTION_TYPE = 'exception.type';
var $5cbc7b0f58119792$var$TMP_EXCEPTION_MESSAGE = 'exception.message';
var $5cbc7b0f58119792$var$TMP_EXCEPTION_STACKTRACE = 'exception.stacktrace';
var $5cbc7b0f58119792$var$TMP_EXCEPTION_ESCAPED = 'exception.escaped';
var $5cbc7b0f58119792$var$TMP_FAAS_TRIGGER = 'faas.trigger';
var $5cbc7b0f58119792$var$TMP_FAAS_EXECUTION = 'faas.execution';
var $5cbc7b0f58119792$var$TMP_FAAS_DOCUMENT_COLLECTION = 'faas.document.collection';
var $5cbc7b0f58119792$var$TMP_FAAS_DOCUMENT_OPERATION = 'faas.document.operation';
var $5cbc7b0f58119792$var$TMP_FAAS_DOCUMENT_TIME = 'faas.document.time';
var $5cbc7b0f58119792$var$TMP_FAAS_DOCUMENT_NAME = 'faas.document.name';
var $5cbc7b0f58119792$var$TMP_FAAS_TIME = 'faas.time';
var $5cbc7b0f58119792$var$TMP_FAAS_CRON = 'faas.cron';
var $5cbc7b0f58119792$var$TMP_FAAS_COLDSTART = 'faas.coldstart';
var $5cbc7b0f58119792$var$TMP_FAAS_INVOKED_NAME = 'faas.invoked_name';
var $5cbc7b0f58119792$var$TMP_FAAS_INVOKED_PROVIDER = 'faas.invoked_provider';
var $5cbc7b0f58119792$var$TMP_FAAS_INVOKED_REGION = 'faas.invoked_region';
var $5cbc7b0f58119792$var$TMP_NET_TRANSPORT = 'net.transport';
var $5cbc7b0f58119792$var$TMP_NET_PEER_IP = 'net.peer.ip';
var $5cbc7b0f58119792$var$TMP_NET_PEER_PORT = 'net.peer.port';
var $5cbc7b0f58119792$var$TMP_NET_PEER_NAME = 'net.peer.name';
var $5cbc7b0f58119792$var$TMP_NET_HOST_IP = 'net.host.ip';
var $5cbc7b0f58119792$var$TMP_NET_HOST_PORT = 'net.host.port';
var $5cbc7b0f58119792$var$TMP_NET_HOST_NAME = 'net.host.name';
var $5cbc7b0f58119792$var$TMP_NET_HOST_CONNECTION_TYPE = 'net.host.connection.type';
var $5cbc7b0f58119792$var$TMP_NET_HOST_CONNECTION_SUBTYPE = 'net.host.connection.subtype';
var $5cbc7b0f58119792$var$TMP_NET_HOST_CARRIER_NAME = 'net.host.carrier.name';
var $5cbc7b0f58119792$var$TMP_NET_HOST_CARRIER_MCC = 'net.host.carrier.mcc';
var $5cbc7b0f58119792$var$TMP_NET_HOST_CARRIER_MNC = 'net.host.carrier.mnc';
var $5cbc7b0f58119792$var$TMP_NET_HOST_CARRIER_ICC = 'net.host.carrier.icc';
var $5cbc7b0f58119792$var$TMP_PEER_SERVICE = 'peer.service';
var $5cbc7b0f58119792$var$TMP_ENDUSER_ID = 'enduser.id';
var $5cbc7b0f58119792$var$TMP_ENDUSER_ROLE = 'enduser.role';
var $5cbc7b0f58119792$var$TMP_ENDUSER_SCOPE = 'enduser.scope';
var $5cbc7b0f58119792$var$TMP_THREAD_ID = 'thread.id';
var $5cbc7b0f58119792$var$TMP_THREAD_NAME = 'thread.name';
var $5cbc7b0f58119792$var$TMP_CODE_FUNCTION = 'code.function';
var $5cbc7b0f58119792$var$TMP_CODE_NAMESPACE = 'code.namespace';
var $5cbc7b0f58119792$var$TMP_CODE_FILEPATH = 'code.filepath';
var $5cbc7b0f58119792$var$TMP_CODE_LINENO = 'code.lineno';
var $5cbc7b0f58119792$var$TMP_HTTP_METHOD = 'http.method';
var $5cbc7b0f58119792$var$TMP_HTTP_URL = 'http.url';
var $5cbc7b0f58119792$var$TMP_HTTP_TARGET = 'http.target';
var $5cbc7b0f58119792$var$TMP_HTTP_HOST = 'http.host';
var $5cbc7b0f58119792$var$TMP_HTTP_SCHEME = 'http.scheme';
var $5cbc7b0f58119792$var$TMP_HTTP_STATUS_CODE = 'http.status_code';
var $5cbc7b0f58119792$var$TMP_HTTP_FLAVOR = 'http.flavor';
var $5cbc7b0f58119792$var$TMP_HTTP_USER_AGENT = 'http.user_agent';
var $5cbc7b0f58119792$var$TMP_HTTP_REQUEST_CONTENT_LENGTH = 'http.request_content_length';
var $5cbc7b0f58119792$var$TMP_HTTP_REQUEST_CONTENT_LENGTH_UNCOMPRESSED = 'http.request_content_length_uncompressed';
var $5cbc7b0f58119792$var$TMP_HTTP_RESPONSE_CONTENT_LENGTH = 'http.response_content_length';
var $5cbc7b0f58119792$var$TMP_HTTP_RESPONSE_CONTENT_LENGTH_UNCOMPRESSED = 'http.response_content_length_uncompressed';
var $5cbc7b0f58119792$var$TMP_HTTP_SERVER_NAME = 'http.server_name';
var $5cbc7b0f58119792$var$TMP_HTTP_ROUTE = 'http.route';
var $5cbc7b0f58119792$var$TMP_HTTP_CLIENT_IP = 'http.client_ip';
var $5cbc7b0f58119792$var$TMP_AWS_DYNAMODB_TABLE_NAMES = 'aws.dynamodb.table_names';
var $5cbc7b0f58119792$var$TMP_AWS_DYNAMODB_CONSUMED_CAPACITY = 'aws.dynamodb.consumed_capacity';
var $5cbc7b0f58119792$var$TMP_AWS_DYNAMODB_ITEM_COLLECTION_METRICS = 'aws.dynamodb.item_collection_metrics';
var $5cbc7b0f58119792$var$TMP_AWS_DYNAMODB_PROVISIONED_READ_CAPACITY = 'aws.dynamodb.provisioned_read_capacity';
var $5cbc7b0f58119792$var$TMP_AWS_DYNAMODB_PROVISIONED_WRITE_CAPACITY = 'aws.dynamodb.provisioned_write_capacity';
var $5cbc7b0f58119792$var$TMP_AWS_DYNAMODB_CONSISTENT_READ = 'aws.dynamodb.consistent_read';
var $5cbc7b0f58119792$var$TMP_AWS_DYNAMODB_PROJECTION = 'aws.dynamodb.projection';
var $5cbc7b0f58119792$var$TMP_AWS_DYNAMODB_LIMIT = 'aws.dynamodb.limit';
var $5cbc7b0f58119792$var$TMP_AWS_DYNAMODB_ATTRIBUTES_TO_GET = 'aws.dynamodb.attributes_to_get';
var $5cbc7b0f58119792$var$TMP_AWS_DYNAMODB_INDEX_NAME = 'aws.dynamodb.index_name';
var $5cbc7b0f58119792$var$TMP_AWS_DYNAMODB_SELECT = 'aws.dynamodb.select';
var $5cbc7b0f58119792$var$TMP_AWS_DYNAMODB_GLOBAL_SECONDARY_INDEXES = 'aws.dynamodb.global_secondary_indexes';
var $5cbc7b0f58119792$var$TMP_AWS_DYNAMODB_LOCAL_SECONDARY_INDEXES = 'aws.dynamodb.local_secondary_indexes';
var $5cbc7b0f58119792$var$TMP_AWS_DYNAMODB_EXCLUSIVE_START_TABLE = 'aws.dynamodb.exclusive_start_table';
var $5cbc7b0f58119792$var$TMP_AWS_DYNAMODB_TABLE_COUNT = 'aws.dynamodb.table_count';
var $5cbc7b0f58119792$var$TMP_AWS_DYNAMODB_SCAN_FORWARD = 'aws.dynamodb.scan_forward';
var $5cbc7b0f58119792$var$TMP_AWS_DYNAMODB_SEGMENT = 'aws.dynamodb.segment';
var $5cbc7b0f58119792$var$TMP_AWS_DYNAMODB_TOTAL_SEGMENTS = 'aws.dynamodb.total_segments';
var $5cbc7b0f58119792$var$TMP_AWS_DYNAMODB_COUNT = 'aws.dynamodb.count';
var $5cbc7b0f58119792$var$TMP_AWS_DYNAMODB_SCANNED_COUNT = 'aws.dynamodb.scanned_count';
var $5cbc7b0f58119792$var$TMP_AWS_DYNAMODB_ATTRIBUTE_DEFINITIONS = 'aws.dynamodb.attribute_definitions';
var $5cbc7b0f58119792$var$TMP_AWS_DYNAMODB_GLOBAL_SECONDARY_INDEX_UPDATES = 'aws.dynamodb.global_secondary_index_updates';
var $5cbc7b0f58119792$var$TMP_MESSAGING_SYSTEM = 'messaging.system';
var $5cbc7b0f58119792$var$TMP_MESSAGING_DESTINATION = 'messaging.destination';
var $5cbc7b0f58119792$var$TMP_MESSAGING_DESTINATION_KIND = 'messaging.destination_kind';
var $5cbc7b0f58119792$var$TMP_MESSAGING_TEMP_DESTINATION = 'messaging.temp_destination';
var $5cbc7b0f58119792$var$TMP_MESSAGING_PROTOCOL = 'messaging.protocol';
var $5cbc7b0f58119792$var$TMP_MESSAGING_PROTOCOL_VERSION = 'messaging.protocol_version';
var $5cbc7b0f58119792$var$TMP_MESSAGING_URL = 'messaging.url';
var $5cbc7b0f58119792$var$TMP_MESSAGING_MESSAGE_ID = 'messaging.message_id';
var $5cbc7b0f58119792$var$TMP_MESSAGING_CONVERSATION_ID = 'messaging.conversation_id';
var $5cbc7b0f58119792$var$TMP_MESSAGING_MESSAGE_PAYLOAD_SIZE_BYTES = 'messaging.message_payload_size_bytes';
var $5cbc7b0f58119792$var$TMP_MESSAGING_MESSAGE_PAYLOAD_COMPRESSED_SIZE_BYTES = 'messaging.message_payload_compressed_size_bytes';
var $5cbc7b0f58119792$var$TMP_MESSAGING_OPERATION = 'messaging.operation';
var $5cbc7b0f58119792$var$TMP_MESSAGING_CONSUMER_ID = 'messaging.consumer_id';
var $5cbc7b0f58119792$var$TMP_MESSAGING_RABBITMQ_ROUTING_KEY = 'messaging.rabbitmq.routing_key';
var $5cbc7b0f58119792$var$TMP_MESSAGING_KAFKA_MESSAGE_KEY = 'messaging.kafka.message_key';
var $5cbc7b0f58119792$var$TMP_MESSAGING_KAFKA_CONSUMER_GROUP = 'messaging.kafka.consumer_group';
var $5cbc7b0f58119792$var$TMP_MESSAGING_KAFKA_CLIENT_ID = 'messaging.kafka.client_id';
var $5cbc7b0f58119792$var$TMP_MESSAGING_KAFKA_PARTITION = 'messaging.kafka.partition';
var $5cbc7b0f58119792$var$TMP_MESSAGING_KAFKA_TOMBSTONE = 'messaging.kafka.tombstone';
var $5cbc7b0f58119792$var$TMP_RPC_SYSTEM = 'rpc.system';
var $5cbc7b0f58119792$var$TMP_RPC_SERVICE = 'rpc.service';
var $5cbc7b0f58119792$var$TMP_RPC_METHOD = 'rpc.method';
var $5cbc7b0f58119792$var$TMP_RPC_GRPC_STATUS_CODE = 'rpc.grpc.status_code';
var $5cbc7b0f58119792$var$TMP_RPC_JSONRPC_VERSION = 'rpc.jsonrpc.version';
var $5cbc7b0f58119792$var$TMP_RPC_JSONRPC_REQUEST_ID = 'rpc.jsonrpc.request_id';
var $5cbc7b0f58119792$var$TMP_RPC_JSONRPC_ERROR_CODE = 'rpc.jsonrpc.error_code';
var $5cbc7b0f58119792$var$TMP_RPC_JSONRPC_ERROR_MESSAGE = 'rpc.jsonrpc.error_message';
var $5cbc7b0f58119792$var$TMP_MESSAGE_TYPE = 'message.type';
var $5cbc7b0f58119792$var$TMP_MESSAGE_ID = 'message.id';
var $5cbc7b0f58119792$var$TMP_MESSAGE_COMPRESSED_SIZE = 'message.compressed_size';
var $5cbc7b0f58119792$var$TMP_MESSAGE_UNCOMPRESSED_SIZE = 'message.uncompressed_size';
var $5cbc7b0f58119792$export$170bb395abfdb74 = $5cbc7b0f58119792$var$TMP_AWS_LAMBDA_INVOKED_ARN;
var $5cbc7b0f58119792$export$4d8f9683caa766fd = $5cbc7b0f58119792$var$TMP_DB_SYSTEM;
var $5cbc7b0f58119792$export$d367aaf68e61a0d5 = $5cbc7b0f58119792$var$TMP_DB_CONNECTION_STRING;
var $5cbc7b0f58119792$export$310240ea93b3fe22 = $5cbc7b0f58119792$var$TMP_DB_USER;
var $5cbc7b0f58119792$export$aa8b483f52799ba9 = $5cbc7b0f58119792$var$TMP_DB_JDBC_DRIVER_CLASSNAME;
var $5cbc7b0f58119792$export$d1ee0266d0ce708f = $5cbc7b0f58119792$var$TMP_DB_NAME;
var $5cbc7b0f58119792$export$ce244300665216c6 = $5cbc7b0f58119792$var$TMP_DB_STATEMENT;
var $5cbc7b0f58119792$export$dfb6a782675c717b = $5cbc7b0f58119792$var$TMP_DB_OPERATION;
var $5cbc7b0f58119792$export$ce5040faeb6d8f08 = $5cbc7b0f58119792$var$TMP_DB_MSSQL_INSTANCE_NAME;
var $5cbc7b0f58119792$export$e241e7101e6d4783 = $5cbc7b0f58119792$var$TMP_DB_CASSANDRA_KEYSPACE;
var $5cbc7b0f58119792$export$8823a63ac409681b = $5cbc7b0f58119792$var$TMP_DB_CASSANDRA_PAGE_SIZE;
var $5cbc7b0f58119792$export$b838c3d1859a7260 = $5cbc7b0f58119792$var$TMP_DB_CASSANDRA_CONSISTENCY_LEVEL;
var $5cbc7b0f58119792$export$3f3068d83ae4cca5 = $5cbc7b0f58119792$var$TMP_DB_CASSANDRA_TABLE;
var $5cbc7b0f58119792$export$17334025dcb96205 = $5cbc7b0f58119792$var$TMP_DB_CASSANDRA_IDEMPOTENCE;
var $5cbc7b0f58119792$export$a63f22381e3297f2 = $5cbc7b0f58119792$var$TMP_DB_CASSANDRA_SPECULATIVE_EXECUTION_COUNT;
var $5cbc7b0f58119792$export$e06ccece5268ed3 = $5cbc7b0f58119792$var$TMP_DB_CASSANDRA_COORDINATOR_ID;
var $5cbc7b0f58119792$export$ab77f08d0cc7144 = $5cbc7b0f58119792$var$TMP_DB_CASSANDRA_COORDINATOR_DC;
var $5cbc7b0f58119792$export$f83bf50700108cdb = $5cbc7b0f58119792$var$TMP_DB_HBASE_NAMESPACE;
var $5cbc7b0f58119792$export$f9c9b189f60bce02 = $5cbc7b0f58119792$var$TMP_DB_REDIS_DATABASE_INDEX;
var $5cbc7b0f58119792$export$b73e684c351bf304 = $5cbc7b0f58119792$var$TMP_DB_MONGODB_COLLECTION;
var $5cbc7b0f58119792$export$5b02e077c84b0dc7 = $5cbc7b0f58119792$var$TMP_DB_SQL_TABLE;
var $5cbc7b0f58119792$export$ecc84ea0f5a24384 = $5cbc7b0f58119792$var$TMP_EXCEPTION_TYPE;
var $5cbc7b0f58119792$export$ff69507dfa9dcf0c = $5cbc7b0f58119792$var$TMP_EXCEPTION_MESSAGE;
var $5cbc7b0f58119792$export$d9432f0c350b687d = $5cbc7b0f58119792$var$TMP_EXCEPTION_STACKTRACE;
var $5cbc7b0f58119792$export$4d3c212dd7c75f9d = $5cbc7b0f58119792$var$TMP_EXCEPTION_ESCAPED;
var $5cbc7b0f58119792$export$7e853a3dbd95b3a2 = $5cbc7b0f58119792$var$TMP_FAAS_TRIGGER;
var $5cbc7b0f58119792$export$68a5b08142e33c1d = $5cbc7b0f58119792$var$TMP_FAAS_EXECUTION;
var $5cbc7b0f58119792$export$f4b6288b42b8d4f8 = $5cbc7b0f58119792$var$TMP_FAAS_DOCUMENT_COLLECTION;
var $5cbc7b0f58119792$export$7e6d28b35ab8e751 = $5cbc7b0f58119792$var$TMP_FAAS_DOCUMENT_OPERATION;
var $5cbc7b0f58119792$export$b36094664197ebd9 = $5cbc7b0f58119792$var$TMP_FAAS_DOCUMENT_TIME;
var $5cbc7b0f58119792$export$2401d669e1b7f304 = $5cbc7b0f58119792$var$TMP_FAAS_DOCUMENT_NAME;
var $5cbc7b0f58119792$export$4630b1edb758007c = $5cbc7b0f58119792$var$TMP_FAAS_TIME;
var $5cbc7b0f58119792$export$4358b4189d5aa75e = $5cbc7b0f58119792$var$TMP_FAAS_CRON;
var $5cbc7b0f58119792$export$18a88fa49bf141a8 = $5cbc7b0f58119792$var$TMP_FAAS_COLDSTART;
var $5cbc7b0f58119792$export$ba620de28d483834 = $5cbc7b0f58119792$var$TMP_FAAS_INVOKED_NAME;
var $5cbc7b0f58119792$export$1ac1158b40ce77df = $5cbc7b0f58119792$var$TMP_FAAS_INVOKED_PROVIDER;
var $5cbc7b0f58119792$export$e8b3f54186b03f93 = $5cbc7b0f58119792$var$TMP_FAAS_INVOKED_REGION;
var $5cbc7b0f58119792$export$958ce88767ff5cae = $5cbc7b0f58119792$var$TMP_NET_TRANSPORT;
var $5cbc7b0f58119792$export$5f5e19d7784bcab5 = $5cbc7b0f58119792$var$TMP_NET_PEER_IP;
var $5cbc7b0f58119792$export$83ab392b303d5cc4 = $5cbc7b0f58119792$var$TMP_NET_PEER_PORT;
var $5cbc7b0f58119792$export$869dc6e245da8a3c = $5cbc7b0f58119792$var$TMP_NET_PEER_NAME;
var $5cbc7b0f58119792$export$8363f5dd3626d1c7 = $5cbc7b0f58119792$var$TMP_NET_HOST_IP;
var $5cbc7b0f58119792$export$7c05177443136588 = $5cbc7b0f58119792$var$TMP_NET_HOST_PORT;
var $5cbc7b0f58119792$export$67ebd91e5927c9b6 = $5cbc7b0f58119792$var$TMP_NET_HOST_NAME;
var $5cbc7b0f58119792$export$b4399aff72c58221 = $5cbc7b0f58119792$var$TMP_NET_HOST_CONNECTION_TYPE;
var $5cbc7b0f58119792$export$29124138bf62c161 = $5cbc7b0f58119792$var$TMP_NET_HOST_CONNECTION_SUBTYPE;
var $5cbc7b0f58119792$export$a1a35234333f42fa = $5cbc7b0f58119792$var$TMP_NET_HOST_CARRIER_NAME;
var $5cbc7b0f58119792$export$593e7f806b5bd9d0 = $5cbc7b0f58119792$var$TMP_NET_HOST_CARRIER_MCC;
var $5cbc7b0f58119792$export$92c4882b0877ce0 = $5cbc7b0f58119792$var$TMP_NET_HOST_CARRIER_MNC;
var $5cbc7b0f58119792$export$7158946157fdda52 = $5cbc7b0f58119792$var$TMP_NET_HOST_CARRIER_ICC;
var $5cbc7b0f58119792$export$706484bff197aa2f = $5cbc7b0f58119792$var$TMP_PEER_SERVICE;
var $5cbc7b0f58119792$export$37fdcbb3cc34507a = $5cbc7b0f58119792$var$TMP_ENDUSER_ID;
var $5cbc7b0f58119792$export$7486a34c0c780913 = $5cbc7b0f58119792$var$TMP_ENDUSER_ROLE;
var $5cbc7b0f58119792$export$c531f20a7a107be = $5cbc7b0f58119792$var$TMP_ENDUSER_SCOPE;
var $5cbc7b0f58119792$export$96304c684b1fe5bd = $5cbc7b0f58119792$var$TMP_THREAD_ID;
var $5cbc7b0f58119792$export$b1c76a722c30a73e = $5cbc7b0f58119792$var$TMP_THREAD_NAME;
var $5cbc7b0f58119792$export$f5b0a970f81eb82 = $5cbc7b0f58119792$var$TMP_CODE_FUNCTION;
var $5cbc7b0f58119792$export$ebd9bc6b684ae79f = $5cbc7b0f58119792$var$TMP_CODE_NAMESPACE;
var $5cbc7b0f58119792$export$f5c7dbf024e089b1 = $5cbc7b0f58119792$var$TMP_CODE_FILEPATH;
var $5cbc7b0f58119792$export$9bc82da636767e36 = $5cbc7b0f58119792$var$TMP_CODE_LINENO;
var $5cbc7b0f58119792$export$5ec7d06d671a3fbe = $5cbc7b0f58119792$var$TMP_HTTP_METHOD;
var $5cbc7b0f58119792$export$2f4ef7e39c2be395 = $5cbc7b0f58119792$var$TMP_HTTP_URL;
var $5cbc7b0f58119792$export$5284fc3356124326 = $5cbc7b0f58119792$var$TMP_HTTP_TARGET;
var $5cbc7b0f58119792$export$547e24d3f59a53ea = $5cbc7b0f58119792$var$TMP_HTTP_HOST;
var $5cbc7b0f58119792$export$a2928efa45f0acf4 = $5cbc7b0f58119792$var$TMP_HTTP_SCHEME;
var $5cbc7b0f58119792$export$d381c7525d715413 = $5cbc7b0f58119792$var$TMP_HTTP_STATUS_CODE;
var $5cbc7b0f58119792$export$1e443919b8f6a42e = $5cbc7b0f58119792$var$TMP_HTTP_FLAVOR;
var $5cbc7b0f58119792$export$7472b18f42d2d02f = $5cbc7b0f58119792$var$TMP_HTTP_USER_AGENT;
var $5cbc7b0f58119792$export$616f2909238995e9 = $5cbc7b0f58119792$var$TMP_HTTP_REQUEST_CONTENT_LENGTH;
var $5cbc7b0f58119792$export$4352992cf528a286 = $5cbc7b0f58119792$var$TMP_HTTP_REQUEST_CONTENT_LENGTH_UNCOMPRESSED;
var $5cbc7b0f58119792$export$58d4fbfe35e08be0 = $5cbc7b0f58119792$var$TMP_HTTP_RESPONSE_CONTENT_LENGTH;
var $5cbc7b0f58119792$export$b9d3e41cd56c56cc = $5cbc7b0f58119792$var$TMP_HTTP_RESPONSE_CONTENT_LENGTH_UNCOMPRESSED;
var $5cbc7b0f58119792$export$ae4c9cf5cd38f75e = $5cbc7b0f58119792$var$TMP_HTTP_SERVER_NAME;
var $5cbc7b0f58119792$export$391e30d1bcbfedd6 = $5cbc7b0f58119792$var$TMP_HTTP_ROUTE;
var $5cbc7b0f58119792$export$f21601c3f29048e9 = $5cbc7b0f58119792$var$TMP_HTTP_CLIENT_IP;
var $5cbc7b0f58119792$export$22c9c5cd37ccec8d = $5cbc7b0f58119792$var$TMP_AWS_DYNAMODB_TABLE_NAMES;
var $5cbc7b0f58119792$export$636d932d69359471 = $5cbc7b0f58119792$var$TMP_AWS_DYNAMODB_CONSUMED_CAPACITY;
var $5cbc7b0f58119792$export$79414a2a1b36e0e4 = $5cbc7b0f58119792$var$TMP_AWS_DYNAMODB_ITEM_COLLECTION_METRICS;
var $5cbc7b0f58119792$export$a17bc449a5f10183 = $5cbc7b0f58119792$var$TMP_AWS_DYNAMODB_PROVISIONED_READ_CAPACITY;
var $5cbc7b0f58119792$export$6d8e225848319009 = $5cbc7b0f58119792$var$TMP_AWS_DYNAMODB_PROVISIONED_WRITE_CAPACITY;
var $5cbc7b0f58119792$export$2daa7ca667f19522 = $5cbc7b0f58119792$var$TMP_AWS_DYNAMODB_CONSISTENT_READ;
var $5cbc7b0f58119792$export$d04f1e16b6682958 = $5cbc7b0f58119792$var$TMP_AWS_DYNAMODB_PROJECTION;
var $5cbc7b0f58119792$export$9017e26d3dee82a7 = $5cbc7b0f58119792$var$TMP_AWS_DYNAMODB_LIMIT;
var $5cbc7b0f58119792$export$734476f2cddb4e = $5cbc7b0f58119792$var$TMP_AWS_DYNAMODB_ATTRIBUTES_TO_GET;
var $5cbc7b0f58119792$export$6ffa6129be32f13f = $5cbc7b0f58119792$var$TMP_AWS_DYNAMODB_INDEX_NAME;
var $5cbc7b0f58119792$export$e439ba599235e943 = $5cbc7b0f58119792$var$TMP_AWS_DYNAMODB_SELECT;
var $5cbc7b0f58119792$export$691e052bf6ec1b50 = $5cbc7b0f58119792$var$TMP_AWS_DYNAMODB_GLOBAL_SECONDARY_INDEXES;
var $5cbc7b0f58119792$export$4a8114ba4973adf9 = $5cbc7b0f58119792$var$TMP_AWS_DYNAMODB_LOCAL_SECONDARY_INDEXES;
var $5cbc7b0f58119792$export$3d3dcdb04b37b602 = $5cbc7b0f58119792$var$TMP_AWS_DYNAMODB_EXCLUSIVE_START_TABLE;
var $5cbc7b0f58119792$export$a3ed03c10bfca049 = $5cbc7b0f58119792$var$TMP_AWS_DYNAMODB_TABLE_COUNT;
var $5cbc7b0f58119792$export$70f2263412a5d6f8 = $5cbc7b0f58119792$var$TMP_AWS_DYNAMODB_SCAN_FORWARD;
var $5cbc7b0f58119792$export$cc291bca867c839c = $5cbc7b0f58119792$var$TMP_AWS_DYNAMODB_SEGMENT;
var $5cbc7b0f58119792$export$2bd41520dd577767 = $5cbc7b0f58119792$var$TMP_AWS_DYNAMODB_TOTAL_SEGMENTS;
var $5cbc7b0f58119792$export$e3002f59defbb848 = $5cbc7b0f58119792$var$TMP_AWS_DYNAMODB_COUNT;
var $5cbc7b0f58119792$export$338ee58c976503fa = $5cbc7b0f58119792$var$TMP_AWS_DYNAMODB_SCANNED_COUNT;
var $5cbc7b0f58119792$export$9ef2d520d3111ebb = $5cbc7b0f58119792$var$TMP_AWS_DYNAMODB_ATTRIBUTE_DEFINITIONS;
var $5cbc7b0f58119792$export$50eb8413f579535b = $5cbc7b0f58119792$var$TMP_AWS_DYNAMODB_GLOBAL_SECONDARY_INDEX_UPDATES;
var $5cbc7b0f58119792$export$e907440d5c8aa7ea = $5cbc7b0f58119792$var$TMP_MESSAGING_SYSTEM;
var $5cbc7b0f58119792$export$331bf1abb96af02c = $5cbc7b0f58119792$var$TMP_MESSAGING_DESTINATION;
var $5cbc7b0f58119792$export$ca3944a0a0fdb278 = $5cbc7b0f58119792$var$TMP_MESSAGING_DESTINATION_KIND;
var $5cbc7b0f58119792$export$b1f595d071164a5c = $5cbc7b0f58119792$var$TMP_MESSAGING_TEMP_DESTINATION;
var $5cbc7b0f58119792$export$734e634f7ff28b65 = $5cbc7b0f58119792$var$TMP_MESSAGING_PROTOCOL;
var $5cbc7b0f58119792$export$62c96eec39d4f8fa = $5cbc7b0f58119792$var$TMP_MESSAGING_PROTOCOL_VERSION;
var $5cbc7b0f58119792$export$8185788dec47d17c = $5cbc7b0f58119792$var$TMP_MESSAGING_URL;
var $5cbc7b0f58119792$export$6465ca78c6aedebd = $5cbc7b0f58119792$var$TMP_MESSAGING_MESSAGE_ID;
var $5cbc7b0f58119792$export$9e29dbd41c4d02d5 = $5cbc7b0f58119792$var$TMP_MESSAGING_CONVERSATION_ID;
var $5cbc7b0f58119792$export$ded3a3185a1522d5 = $5cbc7b0f58119792$var$TMP_MESSAGING_MESSAGE_PAYLOAD_SIZE_BYTES;
var $5cbc7b0f58119792$export$c42edeca94088e4d = $5cbc7b0f58119792$var$TMP_MESSAGING_MESSAGE_PAYLOAD_COMPRESSED_SIZE_BYTES;
var $5cbc7b0f58119792$export$b0a29003262c7994 = $5cbc7b0f58119792$var$TMP_MESSAGING_OPERATION;
var $5cbc7b0f58119792$export$283c55d09fbdb92c = $5cbc7b0f58119792$var$TMP_MESSAGING_CONSUMER_ID;
var $5cbc7b0f58119792$export$78385ca43d0e8556 = $5cbc7b0f58119792$var$TMP_MESSAGING_RABBITMQ_ROUTING_KEY;
var $5cbc7b0f58119792$export$b6969aab3cf94e74 = $5cbc7b0f58119792$var$TMP_MESSAGING_KAFKA_MESSAGE_KEY;
var $5cbc7b0f58119792$export$45eb738152aa5dd4 = $5cbc7b0f58119792$var$TMP_MESSAGING_KAFKA_CONSUMER_GROUP;
var $5cbc7b0f58119792$export$bc66f788b071fbad = $5cbc7b0f58119792$var$TMP_MESSAGING_KAFKA_CLIENT_ID;
var $5cbc7b0f58119792$export$ff4aad497ab5213e = $5cbc7b0f58119792$var$TMP_MESSAGING_KAFKA_PARTITION;
var $5cbc7b0f58119792$export$256d25d7635b3a79 = $5cbc7b0f58119792$var$TMP_MESSAGING_KAFKA_TOMBSTONE;
var $5cbc7b0f58119792$export$8b1a1f43d7106aea = $5cbc7b0f58119792$var$TMP_RPC_SYSTEM;
var $5cbc7b0f58119792$export$7eb60929eaa797de = $5cbc7b0f58119792$var$TMP_RPC_SERVICE;
var $5cbc7b0f58119792$export$c6d175d5e9b8105b = $5cbc7b0f58119792$var$TMP_RPC_METHOD;
var $5cbc7b0f58119792$export$ccc8405c8a911fb7 = $5cbc7b0f58119792$var$TMP_RPC_GRPC_STATUS_CODE;
var $5cbc7b0f58119792$export$ce0f2ec42ba79570 = $5cbc7b0f58119792$var$TMP_RPC_JSONRPC_VERSION;
var $5cbc7b0f58119792$export$2e981273bb2873ea = $5cbc7b0f58119792$var$TMP_RPC_JSONRPC_REQUEST_ID;
var $5cbc7b0f58119792$export$214058615970c3e4 = $5cbc7b0f58119792$var$TMP_RPC_JSONRPC_ERROR_CODE;
var $5cbc7b0f58119792$export$2ad4f2a86baa9b1e = $5cbc7b0f58119792$var$TMP_RPC_JSONRPC_ERROR_MESSAGE;
var $5cbc7b0f58119792$export$e6c57355a990f7ee = $5cbc7b0f58119792$var$TMP_MESSAGE_TYPE;
var $5cbc7b0f58119792$export$ba8e66ad5476d59f = $5cbc7b0f58119792$var$TMP_MESSAGE_ID;
var $5cbc7b0f58119792$export$16f3d59837418b1f = $5cbc7b0f58119792$var$TMP_MESSAGE_COMPRESSED_SIZE;
var $5cbc7b0f58119792$export$4b889081ab98b61 = $5cbc7b0f58119792$var$TMP_MESSAGE_UNCOMPRESSED_SIZE;
var $5cbc7b0f58119792$export$949e366c5c69d2e9 = /*#__PURE__*/ (0, $17HEJ.createConstMap)([
    $5cbc7b0f58119792$var$TMP_AWS_LAMBDA_INVOKED_ARN,
    $5cbc7b0f58119792$var$TMP_DB_SYSTEM,
    $5cbc7b0f58119792$var$TMP_DB_CONNECTION_STRING,
    $5cbc7b0f58119792$var$TMP_DB_USER,
    $5cbc7b0f58119792$var$TMP_DB_JDBC_DRIVER_CLASSNAME,
    $5cbc7b0f58119792$var$TMP_DB_NAME,
    $5cbc7b0f58119792$var$TMP_DB_STATEMENT,
    $5cbc7b0f58119792$var$TMP_DB_OPERATION,
    $5cbc7b0f58119792$var$TMP_DB_MSSQL_INSTANCE_NAME,
    $5cbc7b0f58119792$var$TMP_DB_CASSANDRA_KEYSPACE,
    $5cbc7b0f58119792$var$TMP_DB_CASSANDRA_PAGE_SIZE,
    $5cbc7b0f58119792$var$TMP_DB_CASSANDRA_CONSISTENCY_LEVEL,
    $5cbc7b0f58119792$var$TMP_DB_CASSANDRA_TABLE,
    $5cbc7b0f58119792$var$TMP_DB_CASSANDRA_IDEMPOTENCE,
    $5cbc7b0f58119792$var$TMP_DB_CASSANDRA_SPECULATIVE_EXECUTION_COUNT,
    $5cbc7b0f58119792$var$TMP_DB_CASSANDRA_COORDINATOR_ID,
    $5cbc7b0f58119792$var$TMP_DB_CASSANDRA_COORDINATOR_DC,
    $5cbc7b0f58119792$var$TMP_DB_HBASE_NAMESPACE,
    $5cbc7b0f58119792$var$TMP_DB_REDIS_DATABASE_INDEX,
    $5cbc7b0f58119792$var$TMP_DB_MONGODB_COLLECTION,
    $5cbc7b0f58119792$var$TMP_DB_SQL_TABLE,
    $5cbc7b0f58119792$var$TMP_EXCEPTION_TYPE,
    $5cbc7b0f58119792$var$TMP_EXCEPTION_MESSAGE,
    $5cbc7b0f58119792$var$TMP_EXCEPTION_STACKTRACE,
    $5cbc7b0f58119792$var$TMP_EXCEPTION_ESCAPED,
    $5cbc7b0f58119792$var$TMP_FAAS_TRIGGER,
    $5cbc7b0f58119792$var$TMP_FAAS_EXECUTION,
    $5cbc7b0f58119792$var$TMP_FAAS_DOCUMENT_COLLECTION,
    $5cbc7b0f58119792$var$TMP_FAAS_DOCUMENT_OPERATION,
    $5cbc7b0f58119792$var$TMP_FAAS_DOCUMENT_TIME,
    $5cbc7b0f58119792$var$TMP_FAAS_DOCUMENT_NAME,
    $5cbc7b0f58119792$var$TMP_FAAS_TIME,
    $5cbc7b0f58119792$var$TMP_FAAS_CRON,
    $5cbc7b0f58119792$var$TMP_FAAS_COLDSTART,
    $5cbc7b0f58119792$var$TMP_FAAS_INVOKED_NAME,
    $5cbc7b0f58119792$var$TMP_FAAS_INVOKED_PROVIDER,
    $5cbc7b0f58119792$var$TMP_FAAS_INVOKED_REGION,
    $5cbc7b0f58119792$var$TMP_NET_TRANSPORT,
    $5cbc7b0f58119792$var$TMP_NET_PEER_IP,
    $5cbc7b0f58119792$var$TMP_NET_PEER_PORT,
    $5cbc7b0f58119792$var$TMP_NET_PEER_NAME,
    $5cbc7b0f58119792$var$TMP_NET_HOST_IP,
    $5cbc7b0f58119792$var$TMP_NET_HOST_PORT,
    $5cbc7b0f58119792$var$TMP_NET_HOST_NAME,
    $5cbc7b0f58119792$var$TMP_NET_HOST_CONNECTION_TYPE,
    $5cbc7b0f58119792$var$TMP_NET_HOST_CONNECTION_SUBTYPE,
    $5cbc7b0f58119792$var$TMP_NET_HOST_CARRIER_NAME,
    $5cbc7b0f58119792$var$TMP_NET_HOST_CARRIER_MCC,
    $5cbc7b0f58119792$var$TMP_NET_HOST_CARRIER_MNC,
    $5cbc7b0f58119792$var$TMP_NET_HOST_CARRIER_ICC,
    $5cbc7b0f58119792$var$TMP_PEER_SERVICE,
    $5cbc7b0f58119792$var$TMP_ENDUSER_ID,
    $5cbc7b0f58119792$var$TMP_ENDUSER_ROLE,
    $5cbc7b0f58119792$var$TMP_ENDUSER_SCOPE,
    $5cbc7b0f58119792$var$TMP_THREAD_ID,
    $5cbc7b0f58119792$var$TMP_THREAD_NAME,
    $5cbc7b0f58119792$var$TMP_CODE_FUNCTION,
    $5cbc7b0f58119792$var$TMP_CODE_NAMESPACE,
    $5cbc7b0f58119792$var$TMP_CODE_FILEPATH,
    $5cbc7b0f58119792$var$TMP_CODE_LINENO,
    $5cbc7b0f58119792$var$TMP_HTTP_METHOD,
    $5cbc7b0f58119792$var$TMP_HTTP_URL,
    $5cbc7b0f58119792$var$TMP_HTTP_TARGET,
    $5cbc7b0f58119792$var$TMP_HTTP_HOST,
    $5cbc7b0f58119792$var$TMP_HTTP_SCHEME,
    $5cbc7b0f58119792$var$TMP_HTTP_STATUS_CODE,
    $5cbc7b0f58119792$var$TMP_HTTP_FLAVOR,
    $5cbc7b0f58119792$var$TMP_HTTP_USER_AGENT,
    $5cbc7b0f58119792$var$TMP_HTTP_REQUEST_CONTENT_LENGTH,
    $5cbc7b0f58119792$var$TMP_HTTP_REQUEST_CONTENT_LENGTH_UNCOMPRESSED,
    $5cbc7b0f58119792$var$TMP_HTTP_RESPONSE_CONTENT_LENGTH,
    $5cbc7b0f58119792$var$TMP_HTTP_RESPONSE_CONTENT_LENGTH_UNCOMPRESSED,
    $5cbc7b0f58119792$var$TMP_HTTP_SERVER_NAME,
    $5cbc7b0f58119792$var$TMP_HTTP_ROUTE,
    $5cbc7b0f58119792$var$TMP_HTTP_CLIENT_IP,
    $5cbc7b0f58119792$var$TMP_AWS_DYNAMODB_TABLE_NAMES,
    $5cbc7b0f58119792$var$TMP_AWS_DYNAMODB_CONSUMED_CAPACITY,
    $5cbc7b0f58119792$var$TMP_AWS_DYNAMODB_ITEM_COLLECTION_METRICS,
    $5cbc7b0f58119792$var$TMP_AWS_DYNAMODB_PROVISIONED_READ_CAPACITY,
    $5cbc7b0f58119792$var$TMP_AWS_DYNAMODB_PROVISIONED_WRITE_CAPACITY,
    $5cbc7b0f58119792$var$TMP_AWS_DYNAMODB_CONSISTENT_READ,
    $5cbc7b0f58119792$var$TMP_AWS_DYNAMODB_PROJECTION,
    $5cbc7b0f58119792$var$TMP_AWS_DYNAMODB_LIMIT,
    $5cbc7b0f58119792$var$TMP_AWS_DYNAMODB_ATTRIBUTES_TO_GET,
    $5cbc7b0f58119792$var$TMP_AWS_DYNAMODB_INDEX_NAME,
    $5cbc7b0f58119792$var$TMP_AWS_DYNAMODB_SELECT,
    $5cbc7b0f58119792$var$TMP_AWS_DYNAMODB_GLOBAL_SECONDARY_INDEXES,
    $5cbc7b0f58119792$var$TMP_AWS_DYNAMODB_LOCAL_SECONDARY_INDEXES,
    $5cbc7b0f58119792$var$TMP_AWS_DYNAMODB_EXCLUSIVE_START_TABLE,
    $5cbc7b0f58119792$var$TMP_AWS_DYNAMODB_TABLE_COUNT,
    $5cbc7b0f58119792$var$TMP_AWS_DYNAMODB_SCAN_FORWARD,
    $5cbc7b0f58119792$var$TMP_AWS_DYNAMODB_SEGMENT,
    $5cbc7b0f58119792$var$TMP_AWS_DYNAMODB_TOTAL_SEGMENTS,
    $5cbc7b0f58119792$var$TMP_AWS_DYNAMODB_COUNT,
    $5cbc7b0f58119792$var$TMP_AWS_DYNAMODB_SCANNED_COUNT,
    $5cbc7b0f58119792$var$TMP_AWS_DYNAMODB_ATTRIBUTE_DEFINITIONS,
    $5cbc7b0f58119792$var$TMP_AWS_DYNAMODB_GLOBAL_SECONDARY_INDEX_UPDATES,
    $5cbc7b0f58119792$var$TMP_MESSAGING_SYSTEM,
    $5cbc7b0f58119792$var$TMP_MESSAGING_DESTINATION,
    $5cbc7b0f58119792$var$TMP_MESSAGING_DESTINATION_KIND,
    $5cbc7b0f58119792$var$TMP_MESSAGING_TEMP_DESTINATION,
    $5cbc7b0f58119792$var$TMP_MESSAGING_PROTOCOL,
    $5cbc7b0f58119792$var$TMP_MESSAGING_PROTOCOL_VERSION,
    $5cbc7b0f58119792$var$TMP_MESSAGING_URL,
    $5cbc7b0f58119792$var$TMP_MESSAGING_MESSAGE_ID,
    $5cbc7b0f58119792$var$TMP_MESSAGING_CONVERSATION_ID,
    $5cbc7b0f58119792$var$TMP_MESSAGING_MESSAGE_PAYLOAD_SIZE_BYTES,
    $5cbc7b0f58119792$var$TMP_MESSAGING_MESSAGE_PAYLOAD_COMPRESSED_SIZE_BYTES,
    $5cbc7b0f58119792$var$TMP_MESSAGING_OPERATION,
    $5cbc7b0f58119792$var$TMP_MESSAGING_CONSUMER_ID,
    $5cbc7b0f58119792$var$TMP_MESSAGING_RABBITMQ_ROUTING_KEY,
    $5cbc7b0f58119792$var$TMP_MESSAGING_KAFKA_MESSAGE_KEY,
    $5cbc7b0f58119792$var$TMP_MESSAGING_KAFKA_CONSUMER_GROUP,
    $5cbc7b0f58119792$var$TMP_MESSAGING_KAFKA_CLIENT_ID,
    $5cbc7b0f58119792$var$TMP_MESSAGING_KAFKA_PARTITION,
    $5cbc7b0f58119792$var$TMP_MESSAGING_KAFKA_TOMBSTONE,
    $5cbc7b0f58119792$var$TMP_RPC_SYSTEM,
    $5cbc7b0f58119792$var$TMP_RPC_SERVICE,
    $5cbc7b0f58119792$var$TMP_RPC_METHOD,
    $5cbc7b0f58119792$var$TMP_RPC_GRPC_STATUS_CODE,
    $5cbc7b0f58119792$var$TMP_RPC_JSONRPC_VERSION,
    $5cbc7b0f58119792$var$TMP_RPC_JSONRPC_REQUEST_ID,
    $5cbc7b0f58119792$var$TMP_RPC_JSONRPC_ERROR_CODE,
    $5cbc7b0f58119792$var$TMP_RPC_JSONRPC_ERROR_MESSAGE,
    $5cbc7b0f58119792$var$TMP_MESSAGE_TYPE,
    $5cbc7b0f58119792$var$TMP_MESSAGE_ID,
    $5cbc7b0f58119792$var$TMP_MESSAGE_COMPRESSED_SIZE,
    $5cbc7b0f58119792$var$TMP_MESSAGE_UNCOMPRESSED_SIZE
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for DbSystemValues enum definition
 *
 * An identifier for the database management system (DBMS) product being used. See below for a list of well-known identifiers.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifable export names for some package types
var $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_OTHER_SQL = 'other_sql';
var $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_MSSQL = 'mssql';
var $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_MYSQL = 'mysql';
var $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_ORACLE = 'oracle';
var $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_DB2 = 'db2';
var $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_POSTGRESQL = 'postgresql';
var $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_REDSHIFT = 'redshift';
var $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_HIVE = 'hive';
var $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_CLOUDSCAPE = 'cloudscape';
var $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_HSQLDB = 'hsqldb';
var $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_PROGRESS = 'progress';
var $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_MAXDB = 'maxdb';
var $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_HANADB = 'hanadb';
var $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_INGRES = 'ingres';
var $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_FIRSTSQL = 'firstsql';
var $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_EDB = 'edb';
var $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_CACHE = 'cache';
var $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_ADABAS = 'adabas';
var $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_FIREBIRD = 'firebird';
var $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_DERBY = 'derby';
var $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_FILEMAKER = 'filemaker';
var $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_INFORMIX = 'informix';
var $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_INSTANTDB = 'instantdb';
var $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_INTERBASE = 'interbase';
var $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_MARIADB = 'mariadb';
var $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_NETEZZA = 'netezza';
var $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_PERVASIVE = 'pervasive';
var $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_POINTBASE = 'pointbase';
var $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_SQLITE = 'sqlite';
var $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_SYBASE = 'sybase';
var $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_TERADATA = 'teradata';
var $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_VERTICA = 'vertica';
var $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_H2 = 'h2';
var $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_COLDFUSION = 'coldfusion';
var $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_CASSANDRA = 'cassandra';
var $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_HBASE = 'hbase';
var $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_MONGODB = 'mongodb';
var $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_REDIS = 'redis';
var $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_COUCHBASE = 'couchbase';
var $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_COUCHDB = 'couchdb';
var $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_COSMOSDB = 'cosmosdb';
var $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_DYNAMODB = 'dynamodb';
var $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_NEO4J = 'neo4j';
var $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_GEODE = 'geode';
var $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_ELASTICSEARCH = 'elasticsearch';
var $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_MEMCACHED = 'memcached';
var $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_COCKROACHDB = 'cockroachdb';
var $5cbc7b0f58119792$export$a8dac6c506518069 = $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_OTHER_SQL;
var $5cbc7b0f58119792$export$ea0447329a58abf0 = $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_MSSQL;
var $5cbc7b0f58119792$export$f10ddff4d378463e = $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_MYSQL;
var $5cbc7b0f58119792$export$1187a6d6f356ed08 = $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_ORACLE;
var $5cbc7b0f58119792$export$c99652dcdf96b994 = $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_DB2;
var $5cbc7b0f58119792$export$fa83a16930a97d3b = $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_POSTGRESQL;
var $5cbc7b0f58119792$export$502f4a0041906d71 = $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_REDSHIFT;
var $5cbc7b0f58119792$export$9ca2599ef62580aa = $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_HIVE;
var $5cbc7b0f58119792$export$910728553bdc4f2 = $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_CLOUDSCAPE;
var $5cbc7b0f58119792$export$927252a026981dbc = $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_HSQLDB;
var $5cbc7b0f58119792$export$1d4496dd2fb6e5bf = $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_PROGRESS;
var $5cbc7b0f58119792$export$eeac513ec469c0cd = $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_MAXDB;
var $5cbc7b0f58119792$export$accdcd0fb0e8e3f2 = $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_HANADB;
var $5cbc7b0f58119792$export$3dcc190bf239314c = $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_INGRES;
var $5cbc7b0f58119792$export$ff4c8094bbcf5fa7 = $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_FIRSTSQL;
var $5cbc7b0f58119792$export$3277e5141d071eb2 = $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_EDB;
var $5cbc7b0f58119792$export$4a79cae41e08a0dd = $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_CACHE;
var $5cbc7b0f58119792$export$cf3b85811d34c73b = $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_ADABAS;
var $5cbc7b0f58119792$export$48eca9ca7c84a995 = $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_FIREBIRD;
var $5cbc7b0f58119792$export$bc5d7654a3e6dc01 = $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_DERBY;
var $5cbc7b0f58119792$export$422940b84b884f99 = $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_FILEMAKER;
var $5cbc7b0f58119792$export$a49658a36841921 = $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_INFORMIX;
var $5cbc7b0f58119792$export$dd1bda064bc12f55 = $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_INSTANTDB;
var $5cbc7b0f58119792$export$3845f6f803a923b1 = $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_INTERBASE;
var $5cbc7b0f58119792$export$1b74fece6a0567e8 = $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_MARIADB;
var $5cbc7b0f58119792$export$8fc04abe03bce8d5 = $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_NETEZZA;
var $5cbc7b0f58119792$export$f9406b4f00b760b4 = $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_PERVASIVE;
var $5cbc7b0f58119792$export$5bc787da6daf8e9c = $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_POINTBASE;
var $5cbc7b0f58119792$export$92e0362f5610565 = $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_SQLITE;
var $5cbc7b0f58119792$export$ec03fbd64421b165 = $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_SYBASE;
var $5cbc7b0f58119792$export$486b763280f7312f = $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_TERADATA;
var $5cbc7b0f58119792$export$424b3c529411045a = $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_VERTICA;
var $5cbc7b0f58119792$export$5b4c7807bd4e54d0 = $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_H2;
var $5cbc7b0f58119792$export$998c3a6fdfbcf7df = $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_COLDFUSION;
var $5cbc7b0f58119792$export$dc18027519a667a3 = $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_CASSANDRA;
var $5cbc7b0f58119792$export$a3cbb4bc103ae284 = $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_HBASE;
var $5cbc7b0f58119792$export$b1615e3bbcf0dea5 = $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_MONGODB;
var $5cbc7b0f58119792$export$e236e209844f1272 = $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_REDIS;
var $5cbc7b0f58119792$export$a3861a07874f1889 = $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_COUCHBASE;
var $5cbc7b0f58119792$export$f84afd1ccf7f622f = $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_COUCHDB;
var $5cbc7b0f58119792$export$408510df30ac38f0 = $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_COSMOSDB;
var $5cbc7b0f58119792$export$f704654eab77c7c7 = $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_DYNAMODB;
var $5cbc7b0f58119792$export$5eea4c4dfe97cf90 = $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_NEO4J;
var $5cbc7b0f58119792$export$f6740c7ce8d8a59 = $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_GEODE;
var $5cbc7b0f58119792$export$25d0355c3ecc82d5 = $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_ELASTICSEARCH;
var $5cbc7b0f58119792$export$3566ede46e0a8a41 = $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_MEMCACHED;
var $5cbc7b0f58119792$export$2844c6dfa3d1660a = $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_COCKROACHDB;
var $5cbc7b0f58119792$export$53ce5c6571db6866 = /*#__PURE__*/ (0, $17HEJ.createConstMap)([
    $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_OTHER_SQL,
    $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_MSSQL,
    $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_MYSQL,
    $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_ORACLE,
    $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_DB2,
    $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_POSTGRESQL,
    $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_REDSHIFT,
    $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_HIVE,
    $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_CLOUDSCAPE,
    $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_HSQLDB,
    $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_PROGRESS,
    $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_MAXDB,
    $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_HANADB,
    $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_INGRES,
    $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_FIRSTSQL,
    $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_EDB,
    $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_CACHE,
    $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_ADABAS,
    $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_FIREBIRD,
    $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_DERBY,
    $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_FILEMAKER,
    $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_INFORMIX,
    $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_INSTANTDB,
    $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_INTERBASE,
    $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_MARIADB,
    $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_NETEZZA,
    $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_PERVASIVE,
    $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_POINTBASE,
    $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_SQLITE,
    $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_SYBASE,
    $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_TERADATA,
    $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_VERTICA,
    $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_H2,
    $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_COLDFUSION,
    $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_CASSANDRA,
    $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_HBASE,
    $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_MONGODB,
    $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_REDIS,
    $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_COUCHBASE,
    $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_COUCHDB,
    $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_COSMOSDB,
    $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_DYNAMODB,
    $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_NEO4J,
    $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_GEODE,
    $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_ELASTICSEARCH,
    $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_MEMCACHED,
    $5cbc7b0f58119792$var$TMP_DBSYSTEMVALUES_COCKROACHDB
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for DbCassandraConsistencyLevelValues enum definition
 *
 * The consistency level of the query. Based on consistency values from [CQL](https://docs.datastax.com/en/cassandra-oss/3.0/cassandra/dml/dmlConfigConsistency.html).
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifable export names for some package types
var $5cbc7b0f58119792$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_ALL = 'all';
var $5cbc7b0f58119792$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_EACH_QUORUM = 'each_quorum';
var $5cbc7b0f58119792$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_QUORUM = 'quorum';
var $5cbc7b0f58119792$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_QUORUM = 'local_quorum';
var $5cbc7b0f58119792$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_ONE = 'one';
var $5cbc7b0f58119792$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_TWO = 'two';
var $5cbc7b0f58119792$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_THREE = 'three';
var $5cbc7b0f58119792$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_ONE = 'local_one';
var $5cbc7b0f58119792$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_ANY = 'any';
var $5cbc7b0f58119792$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_SERIAL = 'serial';
var $5cbc7b0f58119792$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_SERIAL = 'local_serial';
var $5cbc7b0f58119792$export$8c965dbb4c30de17 = $5cbc7b0f58119792$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_ALL;
var $5cbc7b0f58119792$export$28269849572f223a = $5cbc7b0f58119792$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_EACH_QUORUM;
var $5cbc7b0f58119792$export$c31be6925d18faf4 = $5cbc7b0f58119792$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_QUORUM;
var $5cbc7b0f58119792$export$dd2d046c43b425dc = $5cbc7b0f58119792$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_QUORUM;
var $5cbc7b0f58119792$export$d567e6085f609657 = $5cbc7b0f58119792$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_ONE;
var $5cbc7b0f58119792$export$2638f2ef2b3637ea = $5cbc7b0f58119792$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_TWO;
var $5cbc7b0f58119792$export$444dff27642c23a3 = $5cbc7b0f58119792$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_THREE;
var $5cbc7b0f58119792$export$be0e7a9b9b7460eb = $5cbc7b0f58119792$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_ONE;
var $5cbc7b0f58119792$export$9cda430306f12b08 = $5cbc7b0f58119792$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_ANY;
var $5cbc7b0f58119792$export$79a04d8aacdacbe9 = $5cbc7b0f58119792$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_SERIAL;
var $5cbc7b0f58119792$export$42bf18043dacb777 = $5cbc7b0f58119792$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_SERIAL;
var $5cbc7b0f58119792$export$a6eeaa6fe6488373 = /*#__PURE__*/ (0, $17HEJ.createConstMap)([
    $5cbc7b0f58119792$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_ALL,
    $5cbc7b0f58119792$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_EACH_QUORUM,
    $5cbc7b0f58119792$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_QUORUM,
    $5cbc7b0f58119792$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_QUORUM,
    $5cbc7b0f58119792$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_ONE,
    $5cbc7b0f58119792$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_TWO,
    $5cbc7b0f58119792$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_THREE,
    $5cbc7b0f58119792$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_ONE,
    $5cbc7b0f58119792$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_ANY,
    $5cbc7b0f58119792$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_SERIAL,
    $5cbc7b0f58119792$var$TMP_DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_SERIAL
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for FaasTriggerValues enum definition
 *
 * Type of the trigger on which the function is executed.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifable export names for some package types
var $5cbc7b0f58119792$var$TMP_FAASTRIGGERVALUES_DATASOURCE = 'datasource';
var $5cbc7b0f58119792$var$TMP_FAASTRIGGERVALUES_HTTP = 'http';
var $5cbc7b0f58119792$var$TMP_FAASTRIGGERVALUES_PUBSUB = 'pubsub';
var $5cbc7b0f58119792$var$TMP_FAASTRIGGERVALUES_TIMER = 'timer';
var $5cbc7b0f58119792$var$TMP_FAASTRIGGERVALUES_OTHER = 'other';
var $5cbc7b0f58119792$export$a116a6c98ad82a77 = $5cbc7b0f58119792$var$TMP_FAASTRIGGERVALUES_DATASOURCE;
var $5cbc7b0f58119792$export$1b8130a1d4406030 = $5cbc7b0f58119792$var$TMP_FAASTRIGGERVALUES_HTTP;
var $5cbc7b0f58119792$export$2c3c25968f77e7b3 = $5cbc7b0f58119792$var$TMP_FAASTRIGGERVALUES_PUBSUB;
var $5cbc7b0f58119792$export$f1adafe5047573a = $5cbc7b0f58119792$var$TMP_FAASTRIGGERVALUES_TIMER;
var $5cbc7b0f58119792$export$2aa5343c84c7d0a6 = $5cbc7b0f58119792$var$TMP_FAASTRIGGERVALUES_OTHER;
var $5cbc7b0f58119792$export$8bd13b593ef4858d = /*#__PURE__*/ (0, $17HEJ.createConstMap)([
    $5cbc7b0f58119792$var$TMP_FAASTRIGGERVALUES_DATASOURCE,
    $5cbc7b0f58119792$var$TMP_FAASTRIGGERVALUES_HTTP,
    $5cbc7b0f58119792$var$TMP_FAASTRIGGERVALUES_PUBSUB,
    $5cbc7b0f58119792$var$TMP_FAASTRIGGERVALUES_TIMER,
    $5cbc7b0f58119792$var$TMP_FAASTRIGGERVALUES_OTHER
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for FaasDocumentOperationValues enum definition
 *
 * Describes the type of the operation that was performed on the data.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifable export names for some package types
var $5cbc7b0f58119792$var$TMP_FAASDOCUMENTOPERATIONVALUES_INSERT = 'insert';
var $5cbc7b0f58119792$var$TMP_FAASDOCUMENTOPERATIONVALUES_EDIT = 'edit';
var $5cbc7b0f58119792$var$TMP_FAASDOCUMENTOPERATIONVALUES_DELETE = 'delete';
var $5cbc7b0f58119792$export$58594a32d0721c01 = $5cbc7b0f58119792$var$TMP_FAASDOCUMENTOPERATIONVALUES_INSERT;
var $5cbc7b0f58119792$export$fb5981e11be92c91 = $5cbc7b0f58119792$var$TMP_FAASDOCUMENTOPERATIONVALUES_EDIT;
var $5cbc7b0f58119792$export$8617289d67ca4e43 = $5cbc7b0f58119792$var$TMP_FAASDOCUMENTOPERATIONVALUES_DELETE;
var $5cbc7b0f58119792$export$d6463783e5bb27f9 = /*#__PURE__*/ (0, $17HEJ.createConstMap)([
    $5cbc7b0f58119792$var$TMP_FAASDOCUMENTOPERATIONVALUES_INSERT,
    $5cbc7b0f58119792$var$TMP_FAASDOCUMENTOPERATIONVALUES_EDIT,
    $5cbc7b0f58119792$var$TMP_FAASDOCUMENTOPERATIONVALUES_DELETE
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for FaasInvokedProviderValues enum definition
 *
 * The cloud provider of the invoked function.
 *
 * Note: SHOULD be equal to the `cloud.provider` resource attribute of the invoked function.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifable export names for some package types
var $5cbc7b0f58119792$var$TMP_FAASINVOKEDPROVIDERVALUES_ALIBABA_CLOUD = 'alibaba_cloud';
var $5cbc7b0f58119792$var$TMP_FAASINVOKEDPROVIDERVALUES_AWS = 'aws';
var $5cbc7b0f58119792$var$TMP_FAASINVOKEDPROVIDERVALUES_AZURE = 'azure';
var $5cbc7b0f58119792$var$TMP_FAASINVOKEDPROVIDERVALUES_GCP = 'gcp';
var $5cbc7b0f58119792$export$a7a256059bf89bd1 = $5cbc7b0f58119792$var$TMP_FAASINVOKEDPROVIDERVALUES_ALIBABA_CLOUD;
var $5cbc7b0f58119792$export$8716f61e9f3c2aeb = $5cbc7b0f58119792$var$TMP_FAASINVOKEDPROVIDERVALUES_AWS;
var $5cbc7b0f58119792$export$ec924dafe3d951e3 = $5cbc7b0f58119792$var$TMP_FAASINVOKEDPROVIDERVALUES_AZURE;
var $5cbc7b0f58119792$export$40370ddcd5c5f6d7 = $5cbc7b0f58119792$var$TMP_FAASINVOKEDPROVIDERVALUES_GCP;
var $5cbc7b0f58119792$export$668b545a1de0448 = /*#__PURE__*/ (0, $17HEJ.createConstMap)([
    $5cbc7b0f58119792$var$TMP_FAASINVOKEDPROVIDERVALUES_ALIBABA_CLOUD,
    $5cbc7b0f58119792$var$TMP_FAASINVOKEDPROVIDERVALUES_AWS,
    $5cbc7b0f58119792$var$TMP_FAASINVOKEDPROVIDERVALUES_AZURE,
    $5cbc7b0f58119792$var$TMP_FAASINVOKEDPROVIDERVALUES_GCP
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for NetTransportValues enum definition
 *
 * Transport protocol used. See note below.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifable export names for some package types
var $5cbc7b0f58119792$var$TMP_NETTRANSPORTVALUES_IP_TCP = 'ip_tcp';
var $5cbc7b0f58119792$var$TMP_NETTRANSPORTVALUES_IP_UDP = 'ip_udp';
var $5cbc7b0f58119792$var$TMP_NETTRANSPORTVALUES_IP = 'ip';
var $5cbc7b0f58119792$var$TMP_NETTRANSPORTVALUES_UNIX = 'unix';
var $5cbc7b0f58119792$var$TMP_NETTRANSPORTVALUES_PIPE = 'pipe';
var $5cbc7b0f58119792$var$TMP_NETTRANSPORTVALUES_INPROC = 'inproc';
var $5cbc7b0f58119792$var$TMP_NETTRANSPORTVALUES_OTHER = 'other';
var $5cbc7b0f58119792$export$98ad64057f1fab9f = $5cbc7b0f58119792$var$TMP_NETTRANSPORTVALUES_IP_TCP;
var $5cbc7b0f58119792$export$efc9b6ce6290a881 = $5cbc7b0f58119792$var$TMP_NETTRANSPORTVALUES_IP_UDP;
var $5cbc7b0f58119792$export$f3aeea475f2d61eb = $5cbc7b0f58119792$var$TMP_NETTRANSPORTVALUES_IP;
var $5cbc7b0f58119792$export$2ff43587ce3a6428 = $5cbc7b0f58119792$var$TMP_NETTRANSPORTVALUES_UNIX;
var $5cbc7b0f58119792$export$8a59379768b7dcc2 = $5cbc7b0f58119792$var$TMP_NETTRANSPORTVALUES_PIPE;
var $5cbc7b0f58119792$export$24d541ca01c48083 = $5cbc7b0f58119792$var$TMP_NETTRANSPORTVALUES_INPROC;
var $5cbc7b0f58119792$export$61986d2ea3f68e4 = $5cbc7b0f58119792$var$TMP_NETTRANSPORTVALUES_OTHER;
var $5cbc7b0f58119792$export$3818cf83a3542239 = /*#__PURE__*/ (0, $17HEJ.createConstMap)([
    $5cbc7b0f58119792$var$TMP_NETTRANSPORTVALUES_IP_TCP,
    $5cbc7b0f58119792$var$TMP_NETTRANSPORTVALUES_IP_UDP,
    $5cbc7b0f58119792$var$TMP_NETTRANSPORTVALUES_IP,
    $5cbc7b0f58119792$var$TMP_NETTRANSPORTVALUES_UNIX,
    $5cbc7b0f58119792$var$TMP_NETTRANSPORTVALUES_PIPE,
    $5cbc7b0f58119792$var$TMP_NETTRANSPORTVALUES_INPROC,
    $5cbc7b0f58119792$var$TMP_NETTRANSPORTVALUES_OTHER
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for NetHostConnectionTypeValues enum definition
 *
 * The internet connection type currently being used by the host.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifable export names for some package types
var $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONTYPEVALUES_WIFI = 'wifi';
var $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONTYPEVALUES_WIRED = 'wired';
var $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONTYPEVALUES_CELL = 'cell';
var $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONTYPEVALUES_UNAVAILABLE = 'unavailable';
var $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONTYPEVALUES_UNKNOWN = 'unknown';
var $5cbc7b0f58119792$export$9f02ba1730e68d64 = $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONTYPEVALUES_WIFI;
var $5cbc7b0f58119792$export$ff976cfa645183ea = $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONTYPEVALUES_WIRED;
var $5cbc7b0f58119792$export$9dac5d5db0d7302d = $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONTYPEVALUES_CELL;
var $5cbc7b0f58119792$export$856320690b0a4ede = $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONTYPEVALUES_UNAVAILABLE;
var $5cbc7b0f58119792$export$b93b5033f8372e2b = $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONTYPEVALUES_UNKNOWN;
var $5cbc7b0f58119792$export$a5c9a789b3c34827 = /*#__PURE__*/ (0, $17HEJ.createConstMap)([
    $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONTYPEVALUES_WIFI,
    $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONTYPEVALUES_WIRED,
    $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONTYPEVALUES_CELL,
    $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONTYPEVALUES_UNAVAILABLE,
    $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONTYPEVALUES_UNKNOWN
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for NetHostConnectionSubtypeValues enum definition
 *
 * This describes more details regarding the connection.type. It may be the type of cell technology connection, but it could be used for describing details about a wifi connection.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifable export names for some package types
var $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_GPRS = 'gprs';
var $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EDGE = 'edge';
var $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_UMTS = 'umts';
var $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_CDMA = 'cdma';
var $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_0 = 'evdo_0';
var $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_A = 'evdo_a';
var $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_CDMA2000_1XRTT = 'cdma2000_1xrtt';
var $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSDPA = 'hsdpa';
var $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSUPA = 'hsupa';
var $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSPA = 'hspa';
var $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_IDEN = 'iden';
var $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_B = 'evdo_b';
var $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_LTE = 'lte';
var $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EHRPD = 'ehrpd';
var $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSPAP = 'hspap';
var $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_GSM = 'gsm';
var $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_TD_SCDMA = 'td_scdma';
var $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_IWLAN = 'iwlan';
var $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_NR = 'nr';
var $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_NRNSA = 'nrnsa';
var $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_LTE_CA = 'lte_ca';
var $5cbc7b0f58119792$export$b3928d079bcf0650 = $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_GPRS;
var $5cbc7b0f58119792$export$869e5d9e2d7d058f = $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EDGE;
var $5cbc7b0f58119792$export$4fb8dba98d516457 = $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_UMTS;
var $5cbc7b0f58119792$export$4c80eef388ebaccf = $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_CDMA;
var $5cbc7b0f58119792$export$fa867825f37e79db = $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_0;
var $5cbc7b0f58119792$export$27a67e3163ce1ca1 = $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_A;
var $5cbc7b0f58119792$export$64eea596575c6ac7 = $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_CDMA2000_1XRTT;
var $5cbc7b0f58119792$export$ac76a80a244a93c4 = $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSDPA;
var $5cbc7b0f58119792$export$1f6c75de7c7b16c8 = $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSUPA;
var $5cbc7b0f58119792$export$546b89c4781a174b = $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSPA;
var $5cbc7b0f58119792$export$76ada84046ded2cf = $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_IDEN;
var $5cbc7b0f58119792$export$cbc44b2ef04c23f2 = $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_B;
var $5cbc7b0f58119792$export$7df810136272d3ca = $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_LTE;
var $5cbc7b0f58119792$export$6d0261a99bb34b75 = $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EHRPD;
var $5cbc7b0f58119792$export$f5609166f18e0da4 = $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSPAP;
var $5cbc7b0f58119792$export$bb1d1d2dc1514ff9 = $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_GSM;
var $5cbc7b0f58119792$export$f39e3589dec1b486 = $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_TD_SCDMA;
var $5cbc7b0f58119792$export$2ea90d5cadafeb66 = $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_IWLAN;
var $5cbc7b0f58119792$export$dacf20f714c7dfe3 = $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_NR;
var $5cbc7b0f58119792$export$3057d75e98c27a82 = $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_NRNSA;
var $5cbc7b0f58119792$export$ac7da250598a79b7 = $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_LTE_CA;
var $5cbc7b0f58119792$export$2f6476d8343c332 = /*#__PURE__*/ (0, $17HEJ.createConstMap)([
    $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_GPRS,
    $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EDGE,
    $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_UMTS,
    $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_CDMA,
    $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_0,
    $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_A,
    $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_CDMA2000_1XRTT,
    $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSDPA,
    $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSUPA,
    $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSPA,
    $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_IDEN,
    $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_B,
    $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_LTE,
    $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EHRPD,
    $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSPAP,
    $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_GSM,
    $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_TD_SCDMA,
    $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_IWLAN,
    $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_NR,
    $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_NRNSA,
    $5cbc7b0f58119792$var$TMP_NETHOSTCONNECTIONSUBTYPEVALUES_LTE_CA
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for HttpFlavorValues enum definition
 *
 * Kind of HTTP protocol used.
 *
 * Note: If `net.transport` is not specified, it can be assumed to be `IP.TCP` except if `http.flavor` is `QUIC`, in which case `IP.UDP` is assumed.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifable export names for some package types
var $5cbc7b0f58119792$var$TMP_HTTPFLAVORVALUES_HTTP_1_0 = '1.0';
var $5cbc7b0f58119792$var$TMP_HTTPFLAVORVALUES_HTTP_1_1 = '1.1';
var $5cbc7b0f58119792$var$TMP_HTTPFLAVORVALUES_HTTP_2_0 = '2.0';
var $5cbc7b0f58119792$var$TMP_HTTPFLAVORVALUES_SPDY = 'SPDY';
var $5cbc7b0f58119792$var$TMP_HTTPFLAVORVALUES_QUIC = 'QUIC';
var $5cbc7b0f58119792$export$a5eaf604e08c3278 = $5cbc7b0f58119792$var$TMP_HTTPFLAVORVALUES_HTTP_1_0;
var $5cbc7b0f58119792$export$90c81a0909f2ae50 = $5cbc7b0f58119792$var$TMP_HTTPFLAVORVALUES_HTTP_1_1;
var $5cbc7b0f58119792$export$76fedb424c637ab1 = $5cbc7b0f58119792$var$TMP_HTTPFLAVORVALUES_HTTP_2_0;
var $5cbc7b0f58119792$export$64a9fa17294d693a = $5cbc7b0f58119792$var$TMP_HTTPFLAVORVALUES_SPDY;
var $5cbc7b0f58119792$export$71f9f90e022dd018 = $5cbc7b0f58119792$var$TMP_HTTPFLAVORVALUES_QUIC;
var $5cbc7b0f58119792$export$98fa65d23b3ad768 = {
    HTTP_1_0: $5cbc7b0f58119792$var$TMP_HTTPFLAVORVALUES_HTTP_1_0,
    HTTP_1_1: $5cbc7b0f58119792$var$TMP_HTTPFLAVORVALUES_HTTP_1_1,
    HTTP_2_0: $5cbc7b0f58119792$var$TMP_HTTPFLAVORVALUES_HTTP_2_0,
    SPDY: $5cbc7b0f58119792$var$TMP_HTTPFLAVORVALUES_SPDY,
    QUIC: $5cbc7b0f58119792$var$TMP_HTTPFLAVORVALUES_QUIC
};
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for MessagingDestinationKindValues enum definition
 *
 * The kind of message destination.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifable export names for some package types
var $5cbc7b0f58119792$var$TMP_MESSAGINGDESTINATIONKINDVALUES_QUEUE = 'queue';
var $5cbc7b0f58119792$var$TMP_MESSAGINGDESTINATIONKINDVALUES_TOPIC = 'topic';
var $5cbc7b0f58119792$export$3c00656cec2b971b = $5cbc7b0f58119792$var$TMP_MESSAGINGDESTINATIONKINDVALUES_QUEUE;
var $5cbc7b0f58119792$export$5b3434288d57e9db = $5cbc7b0f58119792$var$TMP_MESSAGINGDESTINATIONKINDVALUES_TOPIC;
var $5cbc7b0f58119792$export$c97cf0959c06f2eb = /*#__PURE__*/ (0, $17HEJ.createConstMap)([
    $5cbc7b0f58119792$var$TMP_MESSAGINGDESTINATIONKINDVALUES_QUEUE,
    $5cbc7b0f58119792$var$TMP_MESSAGINGDESTINATIONKINDVALUES_TOPIC
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for MessagingOperationValues enum definition
 *
 * A string identifying the kind of message consumption as defined in the [Operation names](#operation-names) section above. If the operation is &#34;send&#34;, this attribute MUST NOT be set, since the operation can be inferred from the span kind in that case.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifable export names for some package types
var $5cbc7b0f58119792$var$TMP_MESSAGINGOPERATIONVALUES_RECEIVE = 'receive';
var $5cbc7b0f58119792$var$TMP_MESSAGINGOPERATIONVALUES_PROCESS = 'process';
var $5cbc7b0f58119792$export$84220b734749f5b0 = $5cbc7b0f58119792$var$TMP_MESSAGINGOPERATIONVALUES_RECEIVE;
var $5cbc7b0f58119792$export$e4e81e41cac54813 = $5cbc7b0f58119792$var$TMP_MESSAGINGOPERATIONVALUES_PROCESS;
var $5cbc7b0f58119792$export$4a89c511599cd2ec = /*#__PURE__*/ (0, $17HEJ.createConstMap)([
    $5cbc7b0f58119792$var$TMP_MESSAGINGOPERATIONVALUES_RECEIVE,
    $5cbc7b0f58119792$var$TMP_MESSAGINGOPERATIONVALUES_PROCESS
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for RpcGrpcStatusCodeValues enum definition
 *
 * The [numeric status code](https://github.com/grpc/grpc/blob/v1.33.2/doc/statuscodes.md) of the gRPC request.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifable export names for some package types
var $5cbc7b0f58119792$var$TMP_RPCGRPCSTATUSCODEVALUES_OK = 0;
var $5cbc7b0f58119792$var$TMP_RPCGRPCSTATUSCODEVALUES_CANCELLED = 1;
var $5cbc7b0f58119792$var$TMP_RPCGRPCSTATUSCODEVALUES_UNKNOWN = 2;
var $5cbc7b0f58119792$var$TMP_RPCGRPCSTATUSCODEVALUES_INVALID_ARGUMENT = 3;
var $5cbc7b0f58119792$var$TMP_RPCGRPCSTATUSCODEVALUES_DEADLINE_EXCEEDED = 4;
var $5cbc7b0f58119792$var$TMP_RPCGRPCSTATUSCODEVALUES_NOT_FOUND = 5;
var $5cbc7b0f58119792$var$TMP_RPCGRPCSTATUSCODEVALUES_ALREADY_EXISTS = 6;
var $5cbc7b0f58119792$var$TMP_RPCGRPCSTATUSCODEVALUES_PERMISSION_DENIED = 7;
var $5cbc7b0f58119792$var$TMP_RPCGRPCSTATUSCODEVALUES_RESOURCE_EXHAUSTED = 8;
var $5cbc7b0f58119792$var$TMP_RPCGRPCSTATUSCODEVALUES_FAILED_PRECONDITION = 9;
var $5cbc7b0f58119792$var$TMP_RPCGRPCSTATUSCODEVALUES_ABORTED = 10;
var $5cbc7b0f58119792$var$TMP_RPCGRPCSTATUSCODEVALUES_OUT_OF_RANGE = 11;
var $5cbc7b0f58119792$var$TMP_RPCGRPCSTATUSCODEVALUES_UNIMPLEMENTED = 12;
var $5cbc7b0f58119792$var$TMP_RPCGRPCSTATUSCODEVALUES_INTERNAL = 13;
var $5cbc7b0f58119792$var$TMP_RPCGRPCSTATUSCODEVALUES_UNAVAILABLE = 14;
var $5cbc7b0f58119792$var$TMP_RPCGRPCSTATUSCODEVALUES_DATA_LOSS = 15;
var $5cbc7b0f58119792$var$TMP_RPCGRPCSTATUSCODEVALUES_UNAUTHENTICATED = 16;
var $5cbc7b0f58119792$export$949d8f2733439fe0 = $5cbc7b0f58119792$var$TMP_RPCGRPCSTATUSCODEVALUES_OK;
var $5cbc7b0f58119792$export$3ab4e217bae3a065 = $5cbc7b0f58119792$var$TMP_RPCGRPCSTATUSCODEVALUES_CANCELLED;
var $5cbc7b0f58119792$export$82114f8ba92008f1 = $5cbc7b0f58119792$var$TMP_RPCGRPCSTATUSCODEVALUES_UNKNOWN;
var $5cbc7b0f58119792$export$4747f09ec996ed1a = $5cbc7b0f58119792$var$TMP_RPCGRPCSTATUSCODEVALUES_INVALID_ARGUMENT;
var $5cbc7b0f58119792$export$2f64e796efee7806 = $5cbc7b0f58119792$var$TMP_RPCGRPCSTATUSCODEVALUES_DEADLINE_EXCEEDED;
var $5cbc7b0f58119792$export$c2b894d36cd1d993 = $5cbc7b0f58119792$var$TMP_RPCGRPCSTATUSCODEVALUES_NOT_FOUND;
var $5cbc7b0f58119792$export$e675f9346907cdbf = $5cbc7b0f58119792$var$TMP_RPCGRPCSTATUSCODEVALUES_ALREADY_EXISTS;
var $5cbc7b0f58119792$export$ee7173f54f1f7e52 = $5cbc7b0f58119792$var$TMP_RPCGRPCSTATUSCODEVALUES_PERMISSION_DENIED;
var $5cbc7b0f58119792$export$a2e4b937aa6d8799 = $5cbc7b0f58119792$var$TMP_RPCGRPCSTATUSCODEVALUES_RESOURCE_EXHAUSTED;
var $5cbc7b0f58119792$export$ef9ed8d6d4e5cd73 = $5cbc7b0f58119792$var$TMP_RPCGRPCSTATUSCODEVALUES_FAILED_PRECONDITION;
var $5cbc7b0f58119792$export$5186c1c5a9145ea6 = $5cbc7b0f58119792$var$TMP_RPCGRPCSTATUSCODEVALUES_ABORTED;
var $5cbc7b0f58119792$export$e67583738364c597 = $5cbc7b0f58119792$var$TMP_RPCGRPCSTATUSCODEVALUES_OUT_OF_RANGE;
var $5cbc7b0f58119792$export$90f86b1e23bb678f = $5cbc7b0f58119792$var$TMP_RPCGRPCSTATUSCODEVALUES_UNIMPLEMENTED;
var $5cbc7b0f58119792$export$133efbe81a3e3b7a = $5cbc7b0f58119792$var$TMP_RPCGRPCSTATUSCODEVALUES_INTERNAL;
var $5cbc7b0f58119792$export$8d87e3aaaab1d8c1 = $5cbc7b0f58119792$var$TMP_RPCGRPCSTATUSCODEVALUES_UNAVAILABLE;
var $5cbc7b0f58119792$export$2acca698ff2f1632 = $5cbc7b0f58119792$var$TMP_RPCGRPCSTATUSCODEVALUES_DATA_LOSS;
var $5cbc7b0f58119792$export$fc7c44549e950bf = $5cbc7b0f58119792$var$TMP_RPCGRPCSTATUSCODEVALUES_UNAUTHENTICATED;
var $5cbc7b0f58119792$export$759a06c32b696c70 = {
    OK: $5cbc7b0f58119792$var$TMP_RPCGRPCSTATUSCODEVALUES_OK,
    CANCELLED: $5cbc7b0f58119792$var$TMP_RPCGRPCSTATUSCODEVALUES_CANCELLED,
    UNKNOWN: $5cbc7b0f58119792$var$TMP_RPCGRPCSTATUSCODEVALUES_UNKNOWN,
    INVALID_ARGUMENT: $5cbc7b0f58119792$var$TMP_RPCGRPCSTATUSCODEVALUES_INVALID_ARGUMENT,
    DEADLINE_EXCEEDED: $5cbc7b0f58119792$var$TMP_RPCGRPCSTATUSCODEVALUES_DEADLINE_EXCEEDED,
    NOT_FOUND: $5cbc7b0f58119792$var$TMP_RPCGRPCSTATUSCODEVALUES_NOT_FOUND,
    ALREADY_EXISTS: $5cbc7b0f58119792$var$TMP_RPCGRPCSTATUSCODEVALUES_ALREADY_EXISTS,
    PERMISSION_DENIED: $5cbc7b0f58119792$var$TMP_RPCGRPCSTATUSCODEVALUES_PERMISSION_DENIED,
    RESOURCE_EXHAUSTED: $5cbc7b0f58119792$var$TMP_RPCGRPCSTATUSCODEVALUES_RESOURCE_EXHAUSTED,
    FAILED_PRECONDITION: $5cbc7b0f58119792$var$TMP_RPCGRPCSTATUSCODEVALUES_FAILED_PRECONDITION,
    ABORTED: $5cbc7b0f58119792$var$TMP_RPCGRPCSTATUSCODEVALUES_ABORTED,
    OUT_OF_RANGE: $5cbc7b0f58119792$var$TMP_RPCGRPCSTATUSCODEVALUES_OUT_OF_RANGE,
    UNIMPLEMENTED: $5cbc7b0f58119792$var$TMP_RPCGRPCSTATUSCODEVALUES_UNIMPLEMENTED,
    INTERNAL: $5cbc7b0f58119792$var$TMP_RPCGRPCSTATUSCODEVALUES_INTERNAL,
    UNAVAILABLE: $5cbc7b0f58119792$var$TMP_RPCGRPCSTATUSCODEVALUES_UNAVAILABLE,
    DATA_LOSS: $5cbc7b0f58119792$var$TMP_RPCGRPCSTATUSCODEVALUES_DATA_LOSS,
    UNAUTHENTICATED: $5cbc7b0f58119792$var$TMP_RPCGRPCSTATUSCODEVALUES_UNAUTHENTICATED
};
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for MessageTypeValues enum definition
 *
 * Whether this is a received or sent message.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifable export names for some package types
var $5cbc7b0f58119792$var$TMP_MESSAGETYPEVALUES_SENT = 'SENT';
var $5cbc7b0f58119792$var$TMP_MESSAGETYPEVALUES_RECEIVED = 'RECEIVED';
var $5cbc7b0f58119792$export$10fb24096e4ea8a3 = $5cbc7b0f58119792$var$TMP_MESSAGETYPEVALUES_SENT;
var $5cbc7b0f58119792$export$e520006d57a4745f = $5cbc7b0f58119792$var$TMP_MESSAGETYPEVALUES_RECEIVED;
var $5cbc7b0f58119792$export$c83b17f5976c727c = /*#__PURE__*/ (0, $17HEJ.createConstMap)([
    $5cbc7b0f58119792$var$TMP_MESSAGETYPEVALUES_SENT,
    $5cbc7b0f58119792$var$TMP_MESSAGETYPEVALUES_RECEIVED
]);

});
parcelRegister("17HEJ", function(module, exports) {

$parcel$export(module.exports, "createConstMap", function () { return $0d184f14497e920a$export$8796db7ca257d576; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Creates a const map from the given values
 * @param values - An array of values to be used as keys and values in the map.
 * @returns A populated version of the map with the values and keys derived from the values.
 */ /*#__NO_SIDE_EFFECTS__*/ function $0d184f14497e920a$export$8796db7ca257d576(values) {
    // eslint-disable-next-line prefer-const, @typescript-eslint/no-explicit-any
    var res = {};
    var len = values.length;
    for(var lp = 0; lp < len; lp++){
        var val = values[lp];
        if (val) res[String(val).toUpperCase().replace(/[-.]/g, '_')] = val;
    }
    return res;
}

});



parcelRegister("a4zuf", function(module, exports) {

$parcel$export(module.exports, "WebTracerProvider", function () { return $7555ce12af623568$export$a785009afeee3453; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $ehhlK = parcelRequire("ehhlK");

var $5tvc5 = parcelRequire("5tvc5");
var $7555ce12af623568$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * This class represents a web tracer with {@link StackContextManager}
 */ var $7555ce12af623568$export$a785009afeee3453 = /** @class */ function(_super) {
    $7555ce12af623568$var$__extends(WebTracerProvider, _super);
    /**
     * Constructs a new Tracer instance.
     * @param config Web Tracer config
     */ function WebTracerProvider(config) {
        if (config === void 0) config = {};
        var _this = _super.call(this, config) || this;
        if (config.contextManager) throw "contextManager should be defined in register method not in constructor";
        if (config.propagator) throw 'propagator should be defined in register method not in constructor';
        return _this;
    }
    /**
     * Register this TracerProvider for use with the OpenTelemetry API.
     * Undefined values may be replaced with defaults, and
     * null values will be skipped.
     *
     * @param config Configuration object for SDK registration
     */ WebTracerProvider.prototype.register = function(config) {
        if (config === void 0) config = {};
        if (config.contextManager === undefined) config.contextManager = new (0, $5tvc5.StackContextManager)();
        if (config.contextManager) config.contextManager.enable();
        _super.prototype.register.call(this, config);
    };
    return WebTracerProvider;
}((0, $ehhlK.BasicTracerProvider));

});
parcelRegister("ehhlK", function(module, exports) {

$parcel$export(module.exports, "BasicTracerProvider", function () { return $a6501c84b955c0f6$export$1f2f0f67f5ecff3b; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ parcelRequire("ckckF");
var $4e6si = parcelRequire("4e6si");
var $7Y52R = parcelRequire("7Y52R");
var $6b1Zv = parcelRequire("6b1Zv");
var $g4DKS = parcelRequire("g4DKS");

var $4lRaZ = parcelRequire("4lRaZ");
var $d2oti = parcelRequire("d2oti");
var $4xjqS = parcelRequire("4xjqS");
var $fFFzD = parcelRequire("fFFzD");
var $jW1H8 = parcelRequire("jW1H8");

var $8LZdq = parcelRequire("8LZdq");

var $a8xL4 = parcelRequire("a8xL4");

var $iwVME = parcelRequire("iwVME");

var $k2jVS = parcelRequire("k2jVS");

var $bfDTQ = parcelRequire("bfDTQ");

var $956M5 = parcelRequire("956M5");

var $jxLjW = parcelRequire("jxLjW");
var $a6501c84b955c0f6$export$11a85395fcf5a7f0;
(function(ForceFlushState) {
    ForceFlushState[ForceFlushState["resolved"] = 0] = "resolved";
    ForceFlushState[ForceFlushState["timeout"] = 1] = "timeout";
    ForceFlushState[ForceFlushState["error"] = 2] = "error";
    ForceFlushState[ForceFlushState["unresolved"] = 3] = "unresolved";
})($a6501c84b955c0f6$export$11a85395fcf5a7f0 || ($a6501c84b955c0f6$export$11a85395fcf5a7f0 = {}));
/**
 * This class represents a basic tracer provider which platform libraries can extend
 */ var $a6501c84b955c0f6$export$1f2f0f67f5ecff3b = /** @class */ function() {
    function BasicTracerProvider(config) {
        if (config === void 0) config = {};
        var _a;
        this._registeredSpanProcessors = [];
        this._tracers = new Map();
        var mergedConfig = (0, $4xjqS.merge)({}, (0, $iwVME.loadDefaultConfig)(), (0, $jxLjW.reconfigureLimits)(config));
        this.resource = (_a = mergedConfig.resource) !== null && _a !== void 0 ? _a : (0, $8LZdq.Resource).empty();
        this.resource = (0, $8LZdq.Resource).default().merge(this.resource);
        this._config = Object.assign({}, mergedConfig, {
            resource: this.resource
        });
        var defaultExporter = this._buildExporterFromEnv();
        if (defaultExporter !== undefined) {
            var batchProcessor = new (0, $956M5.BatchSpanProcessor)(defaultExporter);
            this.activeSpanProcessor = batchProcessor;
        } else this.activeSpanProcessor = new (0, $bfDTQ.NoopSpanProcessor)();
    }
    BasicTracerProvider.prototype.getTracer = function(name, version, options) {
        var key = name + "@" + (version || '') + ":" + ((options === null || options === void 0 ? void 0 : options.schemaUrl) || '');
        if (!this._tracers.has(key)) this._tracers.set(key, new (0, $a8xL4.Tracer)({
            name: name,
            version: version,
            schemaUrl: options === null || options === void 0 ? void 0 : options.schemaUrl
        }, this._config, this));
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return this._tracers.get(key);
    };
    /**
     * Adds a new {@link SpanProcessor} to this tracer.
     * @param spanProcessor the new SpanProcessor to be added.
     */ BasicTracerProvider.prototype.addSpanProcessor = function(spanProcessor) {
        if (this._registeredSpanProcessors.length === 0) // since we might have enabled by default a batchProcessor, we disable it
        // before adding the new one
        this.activeSpanProcessor.shutdown().catch(function(err) {
            return (0, $7Y52R.diag).error('Error while trying to shutdown current span processor', err);
        });
        this._registeredSpanProcessors.push(spanProcessor);
        this.activeSpanProcessor = new (0, $k2jVS.MultiSpanProcessor)(this._registeredSpanProcessors);
    };
    BasicTracerProvider.prototype.getActiveSpanProcessor = function() {
        return this.activeSpanProcessor;
    };
    /**
     * Register this TracerProvider for use with the OpenTelemetry API.
     * Undefined values may be replaced with defaults, and
     * null values will be skipped.
     *
     * @param config Configuration object for SDK registration
     */ BasicTracerProvider.prototype.register = function(config) {
        if (config === void 0) config = {};
        (0, $g4DKS.trace).setGlobalTracerProvider(this);
        if (config.propagator === undefined) config.propagator = this._buildPropagatorFromEnv();
        if (config.contextManager) (0, $4e6si.context).setGlobalContextManager(config.contextManager);
        if (config.propagator) (0, $6b1Zv.propagation).setGlobalPropagator(config.propagator);
    };
    BasicTracerProvider.prototype.forceFlush = function() {
        var timeout = this._config.forceFlushTimeoutMillis;
        var promises = this._registeredSpanProcessors.map(function(spanProcessor) {
            return new Promise(function(resolve) {
                var state;
                var timeoutInterval = setTimeout(function() {
                    resolve(new Error("Span processor did not completed within timeout period of " + timeout + " ms"));
                    state = $a6501c84b955c0f6$export$11a85395fcf5a7f0.timeout;
                }, timeout);
                spanProcessor.forceFlush().then(function() {
                    clearTimeout(timeoutInterval);
                    if (state !== $a6501c84b955c0f6$export$11a85395fcf5a7f0.timeout) {
                        state = $a6501c84b955c0f6$export$11a85395fcf5a7f0.resolved;
                        resolve(state);
                    }
                }).catch(function(error) {
                    clearTimeout(timeoutInterval);
                    state = $a6501c84b955c0f6$export$11a85395fcf5a7f0.error;
                    resolve(error);
                });
            });
        });
        return new Promise(function(resolve, reject) {
            Promise.all(promises).then(function(results) {
                var errors = results.filter(function(result) {
                    return result !== $a6501c84b955c0f6$export$11a85395fcf5a7f0.resolved;
                });
                if (errors.length > 0) reject(errors);
                else resolve();
            }).catch(function(error) {
                return reject([
                    error
                ]);
            });
        });
    };
    BasicTracerProvider.prototype.shutdown = function() {
        return this.activeSpanProcessor.shutdown();
    };
    /**
     * TS cannot yet infer the type of this.constructor:
     * https://github.com/Microsoft/TypeScript/issues/3841#issuecomment-337560146
     * There is no need to override either of the getters in your child class.
     * The type of the registered component maps should be the same across all
     * classes in the inheritance tree.
     */ BasicTracerProvider.prototype._getPropagator = function(name) {
        var _a;
        return (_a = this.constructor._registeredPropagators.get(name)) === null || _a === void 0 ? void 0 : _a();
    };
    BasicTracerProvider.prototype._getSpanExporter = function(name) {
        var _a;
        return (_a = this.constructor._registeredExporters.get(name)) === null || _a === void 0 ? void 0 : _a();
    };
    BasicTracerProvider.prototype._buildPropagatorFromEnv = function() {
        var _this = this;
        // per spec, propagators from env must be deduplicated
        var uniquePropagatorNames = Array.from(new Set((0, $d2oti.getEnv)().OTEL_PROPAGATORS));
        var propagators = uniquePropagatorNames.map(function(name) {
            var propagator = _this._getPropagator(name);
            if (!propagator) (0, $7Y52R.diag).warn("Propagator \"" + name + "\" requested through environment variable is unavailable.");
            return propagator;
        });
        var validPropagators = propagators.reduce(function(list, item) {
            if (item) list.push(item);
            return list;
        }, []);
        if (validPropagators.length === 0) return;
        else if (uniquePropagatorNames.length === 1) return validPropagators[0];
        else return new (0, $4lRaZ.CompositePropagator)({
            propagators: validPropagators
        });
    };
    BasicTracerProvider.prototype._buildExporterFromEnv = function() {
        var exporterName = (0, $d2oti.getEnv)().OTEL_TRACES_EXPORTER;
        if (exporterName === 'none' || exporterName === '') return;
        var exporter = this._getSpanExporter(exporterName);
        if (!exporter) (0, $7Y52R.diag).error("Exporter \"" + exporterName + "\" requested through environment variable is unavailable.");
        return exporter;
    };
    BasicTracerProvider._registeredPropagators = new Map([
        [
            'tracecontext',
            function() {
                return new (0, $jW1H8.W3CTraceContextPropagator)();
            }
        ],
        [
            'baggage',
            function() {
                return new (0, $fFFzD.W3CBaggagePropagator)();
            }
        ]
    ]);
    BasicTracerProvider._registeredExporters = new Map();
    return BasicTracerProvider;
}();

});
parcelRegister("4lRaZ", function(module, exports) {

$parcel$export(module.exports, "CompositePropagator", function () { return $32b25f4c1c6bf4ce$export$4beb26f46770357f; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ parcelRequire("ckckF");
var $7Y52R = parcelRequire("7Y52R");
var $32b25f4c1c6bf4ce$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/** Combines multiple propagators into a single propagator. */ var $32b25f4c1c6bf4ce$export$4beb26f46770357f = /** @class */ function() {
    /**
     * Construct a composite propagator from a list of propagators.
     *
     * @param [config] Configuration object for composite propagator
     */ function CompositePropagator(config) {
        if (config === void 0) config = {};
        var _a;
        this._propagators = (_a = config.propagators) !== null && _a !== void 0 ? _a : [];
        this._fields = Array.from(new Set(this._propagators// older propagators may not have fields function, null check to be sure
        .map(function(p) {
            return typeof p.fields === 'function' ? p.fields() : [];
        }).reduce(function(x, y) {
            return x.concat(y);
        }, [])));
    }
    /**
     * Run each of the configured propagators with the given context and carrier.
     * Propagators are run in the order they are configured, so if multiple
     * propagators write the same carrier key, the propagator later in the list
     * will "win".
     *
     * @param context Context to inject
     * @param carrier Carrier into which context will be injected
     */ CompositePropagator.prototype.inject = function(context, carrier, setter) {
        var e_1, _a;
        try {
            for(var _b = $32b25f4c1c6bf4ce$var$__values(this._propagators), _c = _b.next(); !_c.done; _c = _b.next()){
                var propagator = _c.value;
                try {
                    propagator.inject(context, carrier, setter);
                } catch (err) {
                    (0, $7Y52R.diag).warn("Failed to inject with " + propagator.constructor.name + ". Err: " + err.message);
                }
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    };
    /**
     * Run each of the configured propagators with the given context and carrier.
     * Propagators are run in the order they are configured, so if multiple
     * propagators write the same context key, the propagator later in the list
     * will "win".
     *
     * @param context Context to add values to
     * @param carrier Carrier from which to extract context
     */ CompositePropagator.prototype.extract = function(context, carrier, getter) {
        return this._propagators.reduce(function(ctx, propagator) {
            try {
                return propagator.extract(ctx, carrier, getter);
            } catch (err) {
                (0, $7Y52R.diag).warn("Failed to inject with " + propagator.constructor.name + ". Err: " + err.message);
            }
            return ctx;
        }, context);
    };
    CompositePropagator.prototype.fields = function() {
        // return a new array so our fields cannot be modified
        return this._fields.slice();
    };
    return CompositePropagator;
}();

});

parcelRegister("4xjqS", function(module, exports) {

$parcel$export(module.exports, "merge", function () { return $34d95163774f17fb$export$4950aa0f605343fb; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /* eslint-disable @typescript-eslint/no-explicit-any */ 
var $ca1Nj = parcelRequire("ca1Nj");
var $34d95163774f17fb$var$MAX_LEVEL = 20;
function $34d95163774f17fb$export$4950aa0f605343fb() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var result = args.shift();
    var objects = new WeakMap();
    while(args.length > 0)result = $34d95163774f17fb$var$mergeTwoObjects(result, args.shift(), 0, objects);
    return result;
}
function $34d95163774f17fb$var$takeValue(value) {
    if ($34d95163774f17fb$var$isArray(value)) return value.slice();
    return value;
}
/**
 * Merges two objects
 * @param one - first object
 * @param two - second object
 * @param level - current deep level
 * @param objects - objects holder that has been already referenced - to prevent
 * cyclic dependency
 */ function $34d95163774f17fb$var$mergeTwoObjects(one, two, level, objects) {
    if (level === void 0) level = 0;
    var result;
    if (level > $34d95163774f17fb$var$MAX_LEVEL) return undefined;
    level++;
    if ($34d95163774f17fb$var$isPrimitive(one) || $34d95163774f17fb$var$isPrimitive(two) || $34d95163774f17fb$var$isFunction(two)) result = $34d95163774f17fb$var$takeValue(two);
    else if ($34d95163774f17fb$var$isArray(one)) {
        result = one.slice();
        if ($34d95163774f17fb$var$isArray(two)) for(var i = 0, j = two.length; i < j; i++)result.push($34d95163774f17fb$var$takeValue(two[i]));
        else if ($34d95163774f17fb$var$isObject(two)) {
            var keys = Object.keys(two);
            for(var i = 0, j = keys.length; i < j; i++){
                var key = keys[i];
                result[key] = $34d95163774f17fb$var$takeValue(two[key]);
            }
        }
    } else if ($34d95163774f17fb$var$isObject(one)) {
        if ($34d95163774f17fb$var$isObject(two)) {
            if (!$34d95163774f17fb$var$shouldMerge(one, two)) return two;
            result = Object.assign({}, one);
            var keys = Object.keys(two);
            for(var i = 0, j = keys.length; i < j; i++){
                var key = keys[i];
                var twoValue = two[key];
                if ($34d95163774f17fb$var$isPrimitive(twoValue)) {
                    if (typeof twoValue === 'undefined') delete result[key];
                    else // result[key] = takeValue(twoValue);
                    result[key] = twoValue;
                } else {
                    var obj1 = result[key];
                    var obj2 = twoValue;
                    if ($34d95163774f17fb$var$wasObjectReferenced(one, key, objects) || $34d95163774f17fb$var$wasObjectReferenced(two, key, objects)) delete result[key];
                    else {
                        if ($34d95163774f17fb$var$isObject(obj1) && $34d95163774f17fb$var$isObject(obj2)) {
                            var arr1 = objects.get(obj1) || [];
                            var arr2 = objects.get(obj2) || [];
                            arr1.push({
                                obj: one,
                                key: key
                            });
                            arr2.push({
                                obj: two,
                                key: key
                            });
                            objects.set(obj1, arr1);
                            objects.set(obj2, arr2);
                        }
                        result[key] = $34d95163774f17fb$var$mergeTwoObjects(result[key], twoValue, level, objects);
                    }
                }
            }
        } else result = two;
    }
    return result;
}
/**
 * Function to check if object has been already reference
 * @param obj
 * @param key
 * @param objects
 */ function $34d95163774f17fb$var$wasObjectReferenced(obj, key, objects) {
    var arr = objects.get(obj[key]) || [];
    for(var i = 0, j = arr.length; i < j; i++){
        var info = arr[i];
        if (info.key === key && info.obj === obj) return true;
    }
    return false;
}
function $34d95163774f17fb$var$isArray(value) {
    return Array.isArray(value);
}
function $34d95163774f17fb$var$isFunction(value) {
    return typeof value === 'function';
}
function $34d95163774f17fb$var$isObject(value) {
    return !$34d95163774f17fb$var$isPrimitive(value) && !$34d95163774f17fb$var$isArray(value) && !$34d95163774f17fb$var$isFunction(value) && typeof value === 'object';
}
function $34d95163774f17fb$var$isPrimitive(value) {
    return typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean' || typeof value === 'undefined' || value instanceof Date || value instanceof RegExp || value === null;
}
function $34d95163774f17fb$var$shouldMerge(one, two) {
    if (!(0, $ca1Nj.isPlainObject)(one) || !(0, $ca1Nj.isPlainObject)(two)) return false;
    return true;
}

});
parcelRegister("ca1Nj", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", function () { return $8da7cf86256f2658$export$53b83ca8eaab0383; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * based on lodash in order to support esm builds without esModuleInterop.
 * lodash is using MIT License.
 **/ var $8da7cf86256f2658$var$objectTag = '[object Object]';
var $8da7cf86256f2658$var$nullTag = '[object Null]';
var $8da7cf86256f2658$var$undefinedTag = '[object Undefined]';
var $8da7cf86256f2658$var$funcProto = Function.prototype;
var $8da7cf86256f2658$var$funcToString = $8da7cf86256f2658$var$funcProto.toString;
var $8da7cf86256f2658$var$objectCtorString = $8da7cf86256f2658$var$funcToString.call(Object);
var $8da7cf86256f2658$var$getPrototype = $8da7cf86256f2658$var$overArg(Object.getPrototypeOf, Object);
var $8da7cf86256f2658$var$objectProto = Object.prototype;
var $8da7cf86256f2658$var$hasOwnProperty = $8da7cf86256f2658$var$objectProto.hasOwnProperty;
var $8da7cf86256f2658$var$symToStringTag = Symbol ? Symbol.toStringTag : undefined;
var $8da7cf86256f2658$var$nativeObjectToString = $8da7cf86256f2658$var$objectProto.toString;
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $8da7cf86256f2658$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
function $8da7cf86256f2658$export$53b83ca8eaab0383(value) {
    if (!$8da7cf86256f2658$var$isObjectLike(value) || $8da7cf86256f2658$var$baseGetTag(value) !== $8da7cf86256f2658$var$objectTag) return false;
    var proto = $8da7cf86256f2658$var$getPrototype(value);
    if (proto === null) return true;
    var Ctor = $8da7cf86256f2658$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $8da7cf86256f2658$var$funcToString.call(Ctor) === $8da7cf86256f2658$var$objectCtorString;
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $8da7cf86256f2658$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $8da7cf86256f2658$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $8da7cf86256f2658$var$undefinedTag : $8da7cf86256f2658$var$nullTag;
    return $8da7cf86256f2658$var$symToStringTag && $8da7cf86256f2658$var$symToStringTag in Object(value) ? $8da7cf86256f2658$var$getRawTag(value) : $8da7cf86256f2658$var$objectToString(value);
}
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $8da7cf86256f2658$var$getRawTag(value) {
    var isOwn = $8da7cf86256f2658$var$hasOwnProperty.call(value, $8da7cf86256f2658$var$symToStringTag), tag = value[$8da7cf86256f2658$var$symToStringTag];
    var unmasked = false;
    try {
        value[$8da7cf86256f2658$var$symToStringTag] = undefined;
        unmasked = true;
    } catch (e) {
    // silence
    }
    var result = $8da7cf86256f2658$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$8da7cf86256f2658$var$symToStringTag] = tag;
        else delete value[$8da7cf86256f2658$var$symToStringTag];
    }
    return result;
}
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $8da7cf86256f2658$var$objectToString(value) {
    return $8da7cf86256f2658$var$nativeObjectToString.call(value);
}

});


parcelRegister("fFFzD", function(module, exports) {

$parcel$export(module.exports, "W3CBaggagePropagator", function () { return $b68aef08556682a6$export$604bcc7f2bff6bb; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ parcelRequire("ckckF");
var $6b1Zv = parcelRequire("6b1Zv");

var $3WAuq = parcelRequire("3WAuq");

var $hrHV9 = parcelRequire("hrHV9");

var $3OLEB = parcelRequire("3OLEB");
/**
 * Propagates {@link Baggage} through Context format propagation.
 *
 * Based on the Baggage specification:
 * https://w3c.github.io/baggage/
 */ var $b68aef08556682a6$export$604bcc7f2bff6bb = /** @class */ function() {
    function W3CBaggagePropagator() {}
    W3CBaggagePropagator.prototype.inject = function(context, carrier, setter) {
        var baggage = (0, $6b1Zv.propagation).getBaggage(context);
        if (!baggage || (0, $3WAuq.isTracingSuppressed)(context)) return;
        var keyPairs = (0, $3OLEB.getKeyPairs)(baggage).filter(function(pair) {
            return pair.length <= (0, $hrHV9.BAGGAGE_MAX_PER_NAME_VALUE_PAIRS);
        }).slice(0, (0, $hrHV9.BAGGAGE_MAX_NAME_VALUE_PAIRS));
        var headerValue = (0, $3OLEB.serializeKeyPairs)(keyPairs);
        if (headerValue.length > 0) setter.set(carrier, (0, $hrHV9.BAGGAGE_HEADER), headerValue);
    };
    W3CBaggagePropagator.prototype.extract = function(context, carrier, getter) {
        var headerValue = getter.get(carrier, (0, $hrHV9.BAGGAGE_HEADER));
        var baggageString = Array.isArray(headerValue) ? headerValue.join((0, $hrHV9.BAGGAGE_ITEMS_SEPARATOR)) : headerValue;
        if (!baggageString) return context;
        var baggage = {};
        if (baggageString.length === 0) return context;
        var pairs = baggageString.split((0, $hrHV9.BAGGAGE_ITEMS_SEPARATOR));
        pairs.forEach(function(entry) {
            var keyPair = (0, $3OLEB.parsePairKeyValue)(entry);
            if (keyPair) {
                var baggageEntry = {
                    value: keyPair.value
                };
                if (keyPair.metadata) baggageEntry.metadata = keyPair.metadata;
                baggage[keyPair.key] = baggageEntry;
            }
        });
        if (Object.entries(baggage).length === 0) return context;
        return (0, $6b1Zv.propagation).setBaggage(context, (0, $6b1Zv.propagation).createBaggage(baggage));
    };
    W3CBaggagePropagator.prototype.fields = function() {
        return [
            (0, $hrHV9.BAGGAGE_HEADER)
        ];
    };
    return W3CBaggagePropagator;
}();

});
parcelRegister("hrHV9", function(module, exports) {

$parcel$export(module.exports, "BAGGAGE_KEY_PAIR_SEPARATOR", function () { return $cb37070eaded56de$export$3043215ef908d54f; });
$parcel$export(module.exports, "BAGGAGE_PROPERTIES_SEPARATOR", function () { return $cb37070eaded56de$export$393a3f9e6e76438; });
$parcel$export(module.exports, "BAGGAGE_ITEMS_SEPARATOR", function () { return $cb37070eaded56de$export$1ab471785c2cf557; });
$parcel$export(module.exports, "BAGGAGE_HEADER", function () { return $cb37070eaded56de$export$a6199dd4fe419e69; });
$parcel$export(module.exports, "BAGGAGE_MAX_NAME_VALUE_PAIRS", function () { return $cb37070eaded56de$export$9a50757016085e99; });
$parcel$export(module.exports, "BAGGAGE_MAX_PER_NAME_VALUE_PAIRS", function () { return $cb37070eaded56de$export$c7d9e39bb295c1f; });
$parcel$export(module.exports, "BAGGAGE_MAX_TOTAL_LENGTH", function () { return $cb37070eaded56de$export$dd0527bee1f518e7; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $cb37070eaded56de$export$3043215ef908d54f = '=';
var $cb37070eaded56de$export$393a3f9e6e76438 = ';';
var $cb37070eaded56de$export$1ab471785c2cf557 = ',';
var $cb37070eaded56de$export$a6199dd4fe419e69 = 'baggage';
var $cb37070eaded56de$export$9a50757016085e99 = 180;
var $cb37070eaded56de$export$c7d9e39bb295c1f = 4096;
var $cb37070eaded56de$export$dd0527bee1f518e7 = 8192;

});

parcelRegister("3OLEB", function(module, exports) {

$parcel$export(module.exports, "serializeKeyPairs", function () { return $2c7b01aa03cd29f9$export$790fc82b2ff5bf87; });
$parcel$export(module.exports, "getKeyPairs", function () { return $2c7b01aa03cd29f9$export$ed4c06f0919b1951; });
$parcel$export(module.exports, "parsePairKeyValue", function () { return $2c7b01aa03cd29f9$export$62659c450b08e504; });

var $3mSe3 = parcelRequire("3mSe3");

var $hrHV9 = parcelRequire("hrHV9");
var $2c7b01aa03cd29f9$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
function $2c7b01aa03cd29f9$export$790fc82b2ff5bf87(keyPairs) {
    return keyPairs.reduce(function(hValue, current) {
        var value = "" + hValue + (hValue !== '' ? (0, $hrHV9.BAGGAGE_ITEMS_SEPARATOR) : '') + current;
        return value.length > (0, $hrHV9.BAGGAGE_MAX_TOTAL_LENGTH) ? hValue : value;
    }, '');
}
function $2c7b01aa03cd29f9$export$ed4c06f0919b1951(baggage) {
    return baggage.getAllEntries().map(function(_a) {
        var _b = $2c7b01aa03cd29f9$var$__read(_a, 2), key = _b[0], value = _b[1];
        var entry = encodeURIComponent(key) + "=" + encodeURIComponent(value.value);
        // include opaque metadata if provided
        // NOTE: we intentionally don't URI-encode the metadata - that responsibility falls on the metadata implementation
        if (value.metadata !== undefined) entry += (0, $hrHV9.BAGGAGE_PROPERTIES_SEPARATOR) + value.metadata.toString();
        return entry;
    });
}
function $2c7b01aa03cd29f9$export$62659c450b08e504(entry) {
    var valueProps = entry.split((0, $hrHV9.BAGGAGE_PROPERTIES_SEPARATOR));
    if (valueProps.length <= 0) return;
    var keyPairPart = valueProps.shift();
    if (!keyPairPart) return;
    var separatorIndex = keyPairPart.indexOf((0, $hrHV9.BAGGAGE_KEY_PAIR_SEPARATOR));
    if (separatorIndex <= 0) return;
    var key = decodeURIComponent(keyPairPart.substring(0, separatorIndex).trim());
    var value = decodeURIComponent(keyPairPart.substring(separatorIndex + 1).trim());
    var metadata;
    if (valueProps.length > 0) metadata = (0, $3mSe3.baggageEntryMetadataFromString)(valueProps.join((0, $hrHV9.BAGGAGE_PROPERTIES_SEPARATOR)));
    return {
        key: key,
        value: value,
        metadata: metadata
    };
}
function $2c7b01aa03cd29f9$export$1259660ed6830e21(value) {
    if (typeof value !== 'string' || value.length === 0) return {};
    return value.split((0, $hrHV9.BAGGAGE_ITEMS_SEPARATOR)).map(function(entry) {
        return $2c7b01aa03cd29f9$export$62659c450b08e504(entry);
    }).filter(function(keyPair) {
        return keyPair !== undefined && keyPair.value.length > 0;
    }).reduce(function(headers, keyPair) {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        headers[keyPair.key] = keyPair.value;
        return headers;
    }, {});
}

});


parcelRegister("jW1H8", function(module, exports) {

$parcel$export(module.exports, "W3CTraceContextPropagator", function () { return $e834bfa72b370fce$export$737c747d043a1f7b; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $laija = parcelRequire("laija");parcelRequire("ckckF");
var $g4DKS = parcelRequire("g4DKS");
var $kxoQ4 = parcelRequire("kxoQ4");

var $3WAuq = parcelRequire("3WAuq");

var $8XEsO = parcelRequire("8XEsO");
var $e834bfa72b370fce$export$830e05fa2746348 = 'traceparent';
var $e834bfa72b370fce$export$2b12ed38dcfae2ae = 'tracestate';
var $e834bfa72b370fce$var$VERSION = '00';
var $e834bfa72b370fce$var$VERSION_PART = '(?!ff)[\\da-f]{2}';
var $e834bfa72b370fce$var$TRACE_ID_PART = '(?![0]{32})[\\da-f]{32}';
var $e834bfa72b370fce$var$PARENT_ID_PART = '(?![0]{16})[\\da-f]{16}';
var $e834bfa72b370fce$var$FLAGS_PART = '[\\da-f]{2}';
var $e834bfa72b370fce$var$TRACE_PARENT_REGEX = new RegExp("^\\s?(" + $e834bfa72b370fce$var$VERSION_PART + ")-(" + $e834bfa72b370fce$var$TRACE_ID_PART + ")-(" + $e834bfa72b370fce$var$PARENT_ID_PART + ")-(" + $e834bfa72b370fce$var$FLAGS_PART + ")(-.*)?\\s?$");
function $e834bfa72b370fce$export$f4d87f8901a93f5d(traceParent) {
    var match = $e834bfa72b370fce$var$TRACE_PARENT_REGEX.exec(traceParent);
    if (!match) return null;
    // According to the specification the implementation should be compatible
    // with future versions. If there are more parts, we only reject it if it's using version 00
    // See https://www.w3.org/TR/trace-context/#versioning-of-traceparent
    if (match[1] === '00' && match[5]) return null;
    return {
        traceId: match[2],
        spanId: match[3],
        traceFlags: parseInt(match[4], 16)
    };
}
/**
 * Propagates {@link SpanContext} through Trace Context format propagation.
 *
 * Based on the Trace Context specification:
 * https://www.w3.org/TR/trace-context/
 */ var $e834bfa72b370fce$export$737c747d043a1f7b = /** @class */ function() {
    function W3CTraceContextPropagator() {}
    W3CTraceContextPropagator.prototype.inject = function(context, carrier, setter) {
        var spanContext = (0, $g4DKS.trace).getSpanContext(context);
        if (!spanContext || (0, $3WAuq.isTracingSuppressed)(context) || !(0, $laija.isSpanContextValid)(spanContext)) return;
        var traceParent = $e834bfa72b370fce$var$VERSION + "-" + spanContext.traceId + "-" + spanContext.spanId + "-0" + Number(spanContext.traceFlags || (0, $kxoQ4.TraceFlags).NONE).toString(16);
        setter.set(carrier, $e834bfa72b370fce$export$830e05fa2746348, traceParent);
        if (spanContext.traceState) setter.set(carrier, $e834bfa72b370fce$export$2b12ed38dcfae2ae, spanContext.traceState.serialize());
    };
    W3CTraceContextPropagator.prototype.extract = function(context, carrier, getter) {
        var traceParentHeader = getter.get(carrier, $e834bfa72b370fce$export$830e05fa2746348);
        if (!traceParentHeader) return context;
        var traceParent = Array.isArray(traceParentHeader) ? traceParentHeader[0] : traceParentHeader;
        if (typeof traceParent !== 'string') return context;
        var spanContext = $e834bfa72b370fce$export$f4d87f8901a93f5d(traceParent);
        if (!spanContext) return context;
        spanContext.isRemote = true;
        var traceStateHeader = getter.get(carrier, $e834bfa72b370fce$export$2b12ed38dcfae2ae);
        if (traceStateHeader) {
            // If more than one `tracestate` header is found, we merge them into a
            // single header.
            var state = Array.isArray(traceStateHeader) ? traceStateHeader.join(',') : traceStateHeader;
            spanContext.traceState = new (0, $8XEsO.TraceState)(typeof state === 'string' ? state : undefined);
        }
        return (0, $g4DKS.trace).setSpanContext(context, spanContext);
    };
    W3CTraceContextPropagator.prototype.fields = function() {
        return [
            $e834bfa72b370fce$export$830e05fa2746348,
            $e834bfa72b370fce$export$2b12ed38dcfae2ae
        ];
    };
    return W3CTraceContextPropagator;
}();

});
parcelRegister("8XEsO", function(module, exports) {

$parcel$export(module.exports, "TraceState", function () { return $686338aaf495f877$export$b0addedc390b67c2; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $eoVVt = parcelRequire("eoVVt");
var $686338aaf495f877$var$MAX_TRACE_STATE_ITEMS = 32;
var $686338aaf495f877$var$MAX_TRACE_STATE_LEN = 512;
var $686338aaf495f877$var$LIST_MEMBERS_SEPARATOR = ',';
var $686338aaf495f877$var$LIST_MEMBER_KEY_VALUE_SPLITTER = '=';
/**
 * TraceState must be a class and not a simple object type because of the spec
 * requirement (https://www.w3.org/TR/trace-context/#tracestate-field).
 *
 * Here is the list of allowed mutations:
 * - New key-value pair should be added into the beginning of the list
 * - The value of any key can be updated. Modified keys MUST be moved to the
 * beginning of the list.
 */ var $686338aaf495f877$export$b0addedc390b67c2 = /** @class */ function() {
    function TraceState(rawTraceState) {
        this._internalState = new Map();
        if (rawTraceState) this._parse(rawTraceState);
    }
    TraceState.prototype.set = function(key, value) {
        // TODO: Benchmark the different approaches(map vs list) and
        // use the faster one.
        var traceState = this._clone();
        if (traceState._internalState.has(key)) traceState._internalState.delete(key);
        traceState._internalState.set(key, value);
        return traceState;
    };
    TraceState.prototype.unset = function(key) {
        var traceState = this._clone();
        traceState._internalState.delete(key);
        return traceState;
    };
    TraceState.prototype.get = function(key) {
        return this._internalState.get(key);
    };
    TraceState.prototype.serialize = function() {
        var _this = this;
        return this._keys().reduce(function(agg, key) {
            agg.push(key + $686338aaf495f877$var$LIST_MEMBER_KEY_VALUE_SPLITTER + _this.get(key));
            return agg;
        }, []).join($686338aaf495f877$var$LIST_MEMBERS_SEPARATOR);
    };
    TraceState.prototype._parse = function(rawTraceState) {
        if (rawTraceState.length > $686338aaf495f877$var$MAX_TRACE_STATE_LEN) return;
        this._internalState = rawTraceState.split($686338aaf495f877$var$LIST_MEMBERS_SEPARATOR).reverse() // Store in reverse so new keys (.set(...)) will be placed at the beginning
        .reduce(function(agg, part) {
            var listMember = part.trim(); // Optional Whitespace (OWS) handling
            var i = listMember.indexOf($686338aaf495f877$var$LIST_MEMBER_KEY_VALUE_SPLITTER);
            if (i !== -1) {
                var key = listMember.slice(0, i);
                var value = listMember.slice(i + 1, part.length);
                if ((0, $eoVVt.validateKey)(key) && (0, $eoVVt.validateValue)(value)) agg.set(key, value);
            }
            return agg;
        }, new Map());
        // Because of the reverse() requirement, trunc must be done after map is created
        if (this._internalState.size > $686338aaf495f877$var$MAX_TRACE_STATE_ITEMS) this._internalState = new Map(Array.from(this._internalState.entries()).reverse() // Use reverse same as original tracestate parse chain
        .slice(0, $686338aaf495f877$var$MAX_TRACE_STATE_ITEMS));
    };
    TraceState.prototype._keys = function() {
        return Array.from(this._internalState.keys()).reverse();
    };
    TraceState.prototype._clone = function() {
        var traceState = new TraceState();
        traceState._internalState = new Map(this._internalState);
        return traceState;
    };
    return TraceState;
}();

});
parcelRegister("eoVVt", function(module, exports) {

$parcel$export(module.exports, "validateKey", function () { return $a7c03d7c29fcb3cf$export$469cc9c479301ba6; });
$parcel$export(module.exports, "validateValue", function () { return $a7c03d7c29fcb3cf$export$b76e9316566cc26e; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $a7c03d7c29fcb3cf$var$VALID_KEY_CHAR_RANGE = '[_0-9a-z-*/]';
var $a7c03d7c29fcb3cf$var$VALID_KEY = "[a-z]" + $a7c03d7c29fcb3cf$var$VALID_KEY_CHAR_RANGE + "{0,255}";
var $a7c03d7c29fcb3cf$var$VALID_VENDOR_KEY = "[a-z0-9]" + $a7c03d7c29fcb3cf$var$VALID_KEY_CHAR_RANGE + "{0,240}@[a-z]" + $a7c03d7c29fcb3cf$var$VALID_KEY_CHAR_RANGE + "{0,13}";
var $a7c03d7c29fcb3cf$var$VALID_KEY_REGEX = new RegExp("^(?:" + $a7c03d7c29fcb3cf$var$VALID_KEY + "|" + $a7c03d7c29fcb3cf$var$VALID_VENDOR_KEY + ")$");
var $a7c03d7c29fcb3cf$var$VALID_VALUE_BASE_REGEX = /^[ -~]{0,255}[!-~]$/;
var $a7c03d7c29fcb3cf$var$INVALID_VALUE_COMMA_EQUAL_REGEX = /,|=/;
function $a7c03d7c29fcb3cf$export$469cc9c479301ba6(key) {
    return $a7c03d7c29fcb3cf$var$VALID_KEY_REGEX.test(key);
}
function $a7c03d7c29fcb3cf$export$b76e9316566cc26e(value) {
    return $a7c03d7c29fcb3cf$var$VALID_VALUE_BASE_REGEX.test(value) && !$a7c03d7c29fcb3cf$var$INVALID_VALUE_COMMA_EQUAL_REGEX.test(value);
}

});



parcelRegister("8LZdq", function(module, exports) {

$parcel$export(module.exports, "Resource", function () { return $663232a1bf237ab2$export$39a853cfb5a94a63; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ parcelRequire("ckckF");
var $7Y52R = parcelRequire("7Y52R");

var $j8yJK = parcelRequire("j8yJK");

var $4lMum = parcelRequire("4lMum");

var $c20na = parcelRequire("c20na");
var $663232a1bf237ab2$var$__assign = undefined && undefined.__assign || function() {
    $663232a1bf237ab2$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $663232a1bf237ab2$var$__assign.apply(this, arguments);
};
var $663232a1bf237ab2$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $663232a1bf237ab2$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $663232a1bf237ab2$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
/**
 * A Resource describes the entity for which a signals (metrics or trace) are
 * collected.
 */ var $663232a1bf237ab2$export$39a853cfb5a94a63 = /** @class */ function() {
    function Resource(/**
     * A dictionary of attributes with string keys and values that provide
     * information about the entity as numbers, strings or booleans
     * TODO: Consider to add check/validation on attributes.
     */ attributes, asyncAttributesPromise) {
        var _this = this;
        var _a;
        this._attributes = attributes;
        this.asyncAttributesPending = asyncAttributesPromise != null;
        this._syncAttributes = (_a = this._attributes) !== null && _a !== void 0 ? _a : {};
        this._asyncAttributesPromise = asyncAttributesPromise === null || asyncAttributesPromise === void 0 ? void 0 : asyncAttributesPromise.then(function(asyncAttributes) {
            _this._attributes = Object.assign({}, _this._attributes, asyncAttributes);
            _this.asyncAttributesPending = false;
            return asyncAttributes;
        }, function(err) {
            (0, $7Y52R.diag).debug("a resource's async attributes promise rejected: %s", err);
            _this.asyncAttributesPending = false;
            return {};
        });
    }
    /**
     * Returns an empty Resource
     */ Resource.empty = function() {
        return Resource.EMPTY;
    };
    /**
     * Returns a Resource that identifies the SDK in use.
     */ Resource.default = function() {
        var _a;
        return new Resource((_a = {}, _a[0, $j8yJK.SEMRESATTRS_SERVICE_NAME] = (0, $c20na.defaultServiceName)(), _a[0, $j8yJK.SEMRESATTRS_TELEMETRY_SDK_LANGUAGE] = (0, $4lMum.SDK_INFO)[0, $j8yJK.SEMRESATTRS_TELEMETRY_SDK_LANGUAGE], _a[0, $j8yJK.SEMRESATTRS_TELEMETRY_SDK_NAME] = (0, $4lMum.SDK_INFO)[0, $j8yJK.SEMRESATTRS_TELEMETRY_SDK_NAME], _a[0, $j8yJK.SEMRESATTRS_TELEMETRY_SDK_VERSION] = (0, $4lMum.SDK_INFO)[0, $j8yJK.SEMRESATTRS_TELEMETRY_SDK_VERSION], _a));
    };
    Object.defineProperty(Resource.prototype, "attributes", {
        get: function() {
            var _a;
            if (this.asyncAttributesPending) (0, $7Y52R.diag).error('Accessing resource attributes before async attributes settled');
            return (_a = this._attributes) !== null && _a !== void 0 ? _a : {};
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Returns a promise that will never be rejected. Resolves when all async attributes have finished being added to
     * this Resource's attributes. This is useful in exporters to block until resource detection
     * has finished.
     */ Resource.prototype.waitForAsyncAttributes = function() {
        return $663232a1bf237ab2$var$__awaiter(this, void 0, void 0, function() {
            return $663232a1bf237ab2$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.asyncAttributesPending) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this._asyncAttributesPromise
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Returns a new, merged {@link Resource} by merging the current Resource
     * with the other Resource. In case of a collision, other Resource takes
     * precedence.
     *
     * @param other the Resource that will be merged with this.
     * @returns the newly merged Resource.
     */ Resource.prototype.merge = function(other) {
        var _this = this;
        var _a;
        if (!other) return this;
        // SpanAttributes from other resource overwrite attributes from this resource.
        var mergedSyncAttributes = $663232a1bf237ab2$var$__assign($663232a1bf237ab2$var$__assign({}, this._syncAttributes), (_a = other._syncAttributes) !== null && _a !== void 0 ? _a : other.attributes);
        if (!this._asyncAttributesPromise && !other._asyncAttributesPromise) return new Resource(mergedSyncAttributes);
        var mergedAttributesPromise = Promise.all([
            this._asyncAttributesPromise,
            other._asyncAttributesPromise
        ]).then(function(_a) {
            var _b;
            var _c = $663232a1bf237ab2$var$__read(_a, 2), thisAsyncAttributes = _c[0], otherAsyncAttributes = _c[1];
            return $663232a1bf237ab2$var$__assign($663232a1bf237ab2$var$__assign($663232a1bf237ab2$var$__assign($663232a1bf237ab2$var$__assign({}, _this._syncAttributes), thisAsyncAttributes), (_b = other._syncAttributes) !== null && _b !== void 0 ? _b : other.attributes), otherAsyncAttributes);
        });
        return new Resource(mergedSyncAttributes, mergedAttributesPromise);
    };
    Resource.EMPTY = new Resource({});
    return Resource;
}();

});
parcelRegister("j8yJK", function(module, exports) {

$parcel$export(module.exports, "SEMRESATTRS_PROCESS_RUNTIME_NAME", function () { return $dee9b5b0c130c986$export$6c52ea893832d871; });
$parcel$export(module.exports, "SEMRESATTRS_SERVICE_NAME", function () { return $dee9b5b0c130c986$export$48c68257f49298c9; });
$parcel$export(module.exports, "SEMRESATTRS_TELEMETRY_SDK_NAME", function () { return $dee9b5b0c130c986$export$2d668a3bde1cddea; });
$parcel$export(module.exports, "SEMRESATTRS_TELEMETRY_SDK_LANGUAGE", function () { return $dee9b5b0c130c986$export$b5c1717bbc4c6044; });
$parcel$export(module.exports, "SEMRESATTRS_TELEMETRY_SDK_VERSION", function () { return $dee9b5b0c130c986$export$e0b67501ecc1df37; });
$parcel$export(module.exports, "TELEMETRYSDKLANGUAGEVALUES_WEBJS", function () { return $dee9b5b0c130c986$export$1414beb1e03cac7c; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $17HEJ = parcelRequire("17HEJ");
//----------------------------------------------------------------------------------------------------------
// DO NOT EDIT, this is an Auto-generated file from scripts/semconv/templates//templates/SemanticAttributes.ts.j2
//----------------------------------------------------------------------------------------------------------
//----------------------------------------------------------------------------------------------------------
// Constant values for SemanticResourceAttributes
//----------------------------------------------------------------------------------------------------------
// Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifable export names for some package types
var $dee9b5b0c130c986$var$TMP_CLOUD_PROVIDER = 'cloud.provider';
var $dee9b5b0c130c986$var$TMP_CLOUD_ACCOUNT_ID = 'cloud.account.id';
var $dee9b5b0c130c986$var$TMP_CLOUD_REGION = 'cloud.region';
var $dee9b5b0c130c986$var$TMP_CLOUD_AVAILABILITY_ZONE = 'cloud.availability_zone';
var $dee9b5b0c130c986$var$TMP_CLOUD_PLATFORM = 'cloud.platform';
var $dee9b5b0c130c986$var$TMP_AWS_ECS_CONTAINER_ARN = 'aws.ecs.container.arn';
var $dee9b5b0c130c986$var$TMP_AWS_ECS_CLUSTER_ARN = 'aws.ecs.cluster.arn';
var $dee9b5b0c130c986$var$TMP_AWS_ECS_LAUNCHTYPE = 'aws.ecs.launchtype';
var $dee9b5b0c130c986$var$TMP_AWS_ECS_TASK_ARN = 'aws.ecs.task.arn';
var $dee9b5b0c130c986$var$TMP_AWS_ECS_TASK_FAMILY = 'aws.ecs.task.family';
var $dee9b5b0c130c986$var$TMP_AWS_ECS_TASK_REVISION = 'aws.ecs.task.revision';
var $dee9b5b0c130c986$var$TMP_AWS_EKS_CLUSTER_ARN = 'aws.eks.cluster.arn';
var $dee9b5b0c130c986$var$TMP_AWS_LOG_GROUP_NAMES = 'aws.log.group.names';
var $dee9b5b0c130c986$var$TMP_AWS_LOG_GROUP_ARNS = 'aws.log.group.arns';
var $dee9b5b0c130c986$var$TMP_AWS_LOG_STREAM_NAMES = 'aws.log.stream.names';
var $dee9b5b0c130c986$var$TMP_AWS_LOG_STREAM_ARNS = 'aws.log.stream.arns';
var $dee9b5b0c130c986$var$TMP_CONTAINER_NAME = 'container.name';
var $dee9b5b0c130c986$var$TMP_CONTAINER_ID = 'container.id';
var $dee9b5b0c130c986$var$TMP_CONTAINER_RUNTIME = 'container.runtime';
var $dee9b5b0c130c986$var$TMP_CONTAINER_IMAGE_NAME = 'container.image.name';
var $dee9b5b0c130c986$var$TMP_CONTAINER_IMAGE_TAG = 'container.image.tag';
var $dee9b5b0c130c986$var$TMP_DEPLOYMENT_ENVIRONMENT = 'deployment.environment';
var $dee9b5b0c130c986$var$TMP_DEVICE_ID = 'device.id';
var $dee9b5b0c130c986$var$TMP_DEVICE_MODEL_IDENTIFIER = 'device.model.identifier';
var $dee9b5b0c130c986$var$TMP_DEVICE_MODEL_NAME = 'device.model.name';
var $dee9b5b0c130c986$var$TMP_FAAS_NAME = 'faas.name';
var $dee9b5b0c130c986$var$TMP_FAAS_ID = 'faas.id';
var $dee9b5b0c130c986$var$TMP_FAAS_VERSION = 'faas.version';
var $dee9b5b0c130c986$var$TMP_FAAS_INSTANCE = 'faas.instance';
var $dee9b5b0c130c986$var$TMP_FAAS_MAX_MEMORY = 'faas.max_memory';
var $dee9b5b0c130c986$var$TMP_HOST_ID = 'host.id';
var $dee9b5b0c130c986$var$TMP_HOST_NAME = 'host.name';
var $dee9b5b0c130c986$var$TMP_HOST_TYPE = 'host.type';
var $dee9b5b0c130c986$var$TMP_HOST_ARCH = 'host.arch';
var $dee9b5b0c130c986$var$TMP_HOST_IMAGE_NAME = 'host.image.name';
var $dee9b5b0c130c986$var$TMP_HOST_IMAGE_ID = 'host.image.id';
var $dee9b5b0c130c986$var$TMP_HOST_IMAGE_VERSION = 'host.image.version';
var $dee9b5b0c130c986$var$TMP_K8S_CLUSTER_NAME = 'k8s.cluster.name';
var $dee9b5b0c130c986$var$TMP_K8S_NODE_NAME = 'k8s.node.name';
var $dee9b5b0c130c986$var$TMP_K8S_NODE_UID = 'k8s.node.uid';
var $dee9b5b0c130c986$var$TMP_K8S_NAMESPACE_NAME = 'k8s.namespace.name';
var $dee9b5b0c130c986$var$TMP_K8S_POD_UID = 'k8s.pod.uid';
var $dee9b5b0c130c986$var$TMP_K8S_POD_NAME = 'k8s.pod.name';
var $dee9b5b0c130c986$var$TMP_K8S_CONTAINER_NAME = 'k8s.container.name';
var $dee9b5b0c130c986$var$TMP_K8S_REPLICASET_UID = 'k8s.replicaset.uid';
var $dee9b5b0c130c986$var$TMP_K8S_REPLICASET_NAME = 'k8s.replicaset.name';
var $dee9b5b0c130c986$var$TMP_K8S_DEPLOYMENT_UID = 'k8s.deployment.uid';
var $dee9b5b0c130c986$var$TMP_K8S_DEPLOYMENT_NAME = 'k8s.deployment.name';
var $dee9b5b0c130c986$var$TMP_K8S_STATEFULSET_UID = 'k8s.statefulset.uid';
var $dee9b5b0c130c986$var$TMP_K8S_STATEFULSET_NAME = 'k8s.statefulset.name';
var $dee9b5b0c130c986$var$TMP_K8S_DAEMONSET_UID = 'k8s.daemonset.uid';
var $dee9b5b0c130c986$var$TMP_K8S_DAEMONSET_NAME = 'k8s.daemonset.name';
var $dee9b5b0c130c986$var$TMP_K8S_JOB_UID = 'k8s.job.uid';
var $dee9b5b0c130c986$var$TMP_K8S_JOB_NAME = 'k8s.job.name';
var $dee9b5b0c130c986$var$TMP_K8S_CRONJOB_UID = 'k8s.cronjob.uid';
var $dee9b5b0c130c986$var$TMP_K8S_CRONJOB_NAME = 'k8s.cronjob.name';
var $dee9b5b0c130c986$var$TMP_OS_TYPE = 'os.type';
var $dee9b5b0c130c986$var$TMP_OS_DESCRIPTION = 'os.description';
var $dee9b5b0c130c986$var$TMP_OS_NAME = 'os.name';
var $dee9b5b0c130c986$var$TMP_OS_VERSION = 'os.version';
var $dee9b5b0c130c986$var$TMP_PROCESS_PID = 'process.pid';
var $dee9b5b0c130c986$var$TMP_PROCESS_EXECUTABLE_NAME = 'process.executable.name';
var $dee9b5b0c130c986$var$TMP_PROCESS_EXECUTABLE_PATH = 'process.executable.path';
var $dee9b5b0c130c986$var$TMP_PROCESS_COMMAND = 'process.command';
var $dee9b5b0c130c986$var$TMP_PROCESS_COMMAND_LINE = 'process.command_line';
var $dee9b5b0c130c986$var$TMP_PROCESS_COMMAND_ARGS = 'process.command_args';
var $dee9b5b0c130c986$var$TMP_PROCESS_OWNER = 'process.owner';
var $dee9b5b0c130c986$var$TMP_PROCESS_RUNTIME_NAME = 'process.runtime.name';
var $dee9b5b0c130c986$var$TMP_PROCESS_RUNTIME_VERSION = 'process.runtime.version';
var $dee9b5b0c130c986$var$TMP_PROCESS_RUNTIME_DESCRIPTION = 'process.runtime.description';
var $dee9b5b0c130c986$var$TMP_SERVICE_NAME = 'service.name';
var $dee9b5b0c130c986$var$TMP_SERVICE_NAMESPACE = 'service.namespace';
var $dee9b5b0c130c986$var$TMP_SERVICE_INSTANCE_ID = 'service.instance.id';
var $dee9b5b0c130c986$var$TMP_SERVICE_VERSION = 'service.version';
var $dee9b5b0c130c986$var$TMP_TELEMETRY_SDK_NAME = 'telemetry.sdk.name';
var $dee9b5b0c130c986$var$TMP_TELEMETRY_SDK_LANGUAGE = 'telemetry.sdk.language';
var $dee9b5b0c130c986$var$TMP_TELEMETRY_SDK_VERSION = 'telemetry.sdk.version';
var $dee9b5b0c130c986$var$TMP_TELEMETRY_AUTO_VERSION = 'telemetry.auto.version';
var $dee9b5b0c130c986$var$TMP_WEBENGINE_NAME = 'webengine.name';
var $dee9b5b0c130c986$var$TMP_WEBENGINE_VERSION = 'webengine.version';
var $dee9b5b0c130c986$var$TMP_WEBENGINE_DESCRIPTION = 'webengine.description';
var $dee9b5b0c130c986$export$9fa486cd651f5f18 = $dee9b5b0c130c986$var$TMP_CLOUD_PROVIDER;
var $dee9b5b0c130c986$export$3b9e160fb5fd0b48 = $dee9b5b0c130c986$var$TMP_CLOUD_ACCOUNT_ID;
var $dee9b5b0c130c986$export$7dda4a2b7e6f2925 = $dee9b5b0c130c986$var$TMP_CLOUD_REGION;
var $dee9b5b0c130c986$export$ba02b007970def42 = $dee9b5b0c130c986$var$TMP_CLOUD_AVAILABILITY_ZONE;
var $dee9b5b0c130c986$export$112df106e7dd2eda = $dee9b5b0c130c986$var$TMP_CLOUD_PLATFORM;
var $dee9b5b0c130c986$export$a43adfce130205e = $dee9b5b0c130c986$var$TMP_AWS_ECS_CONTAINER_ARN;
var $dee9b5b0c130c986$export$2ba3c01be08dc7b1 = $dee9b5b0c130c986$var$TMP_AWS_ECS_CLUSTER_ARN;
var $dee9b5b0c130c986$export$323329f2ad65b2aa = $dee9b5b0c130c986$var$TMP_AWS_ECS_LAUNCHTYPE;
var $dee9b5b0c130c986$export$5275732a76e56248 = $dee9b5b0c130c986$var$TMP_AWS_ECS_TASK_ARN;
var $dee9b5b0c130c986$export$fb3f0b7a7be1babd = $dee9b5b0c130c986$var$TMP_AWS_ECS_TASK_FAMILY;
var $dee9b5b0c130c986$export$3ed6f78d5dfa8242 = $dee9b5b0c130c986$var$TMP_AWS_ECS_TASK_REVISION;
var $dee9b5b0c130c986$export$a7708dae05d391dc = $dee9b5b0c130c986$var$TMP_AWS_EKS_CLUSTER_ARN;
var $dee9b5b0c130c986$export$bf434df1f3c89b1 = $dee9b5b0c130c986$var$TMP_AWS_LOG_GROUP_NAMES;
var $dee9b5b0c130c986$export$c522b98ccd83a439 = $dee9b5b0c130c986$var$TMP_AWS_LOG_GROUP_ARNS;
var $dee9b5b0c130c986$export$40794b06cac6b1bc = $dee9b5b0c130c986$var$TMP_AWS_LOG_STREAM_NAMES;
var $dee9b5b0c130c986$export$c9f081f4b744b01b = $dee9b5b0c130c986$var$TMP_AWS_LOG_STREAM_ARNS;
var $dee9b5b0c130c986$export$3e6fef409a60fc1e = $dee9b5b0c130c986$var$TMP_CONTAINER_NAME;
var $dee9b5b0c130c986$export$4d0381aa96fe1c3b = $dee9b5b0c130c986$var$TMP_CONTAINER_ID;
var $dee9b5b0c130c986$export$8806c0adf7bb0584 = $dee9b5b0c130c986$var$TMP_CONTAINER_RUNTIME;
var $dee9b5b0c130c986$export$44771c6519c06259 = $dee9b5b0c130c986$var$TMP_CONTAINER_IMAGE_NAME;
var $dee9b5b0c130c986$export$9f5798300d33c86b = $dee9b5b0c130c986$var$TMP_CONTAINER_IMAGE_TAG;
var $dee9b5b0c130c986$export$4783aaf4e8f7afa0 = $dee9b5b0c130c986$var$TMP_DEPLOYMENT_ENVIRONMENT;
var $dee9b5b0c130c986$export$6e497113334fabdb = $dee9b5b0c130c986$var$TMP_DEVICE_ID;
var $dee9b5b0c130c986$export$73c71cc1c141692b = $dee9b5b0c130c986$var$TMP_DEVICE_MODEL_IDENTIFIER;
var $dee9b5b0c130c986$export$44e87b3b8704bc8a = $dee9b5b0c130c986$var$TMP_DEVICE_MODEL_NAME;
var $dee9b5b0c130c986$export$fe110625e5aee93d = $dee9b5b0c130c986$var$TMP_FAAS_NAME;
var $dee9b5b0c130c986$export$6bbd0c1523702b22 = $dee9b5b0c130c986$var$TMP_FAAS_ID;
var $dee9b5b0c130c986$export$b1cb8996c7f671f1 = $dee9b5b0c130c986$var$TMP_FAAS_VERSION;
var $dee9b5b0c130c986$export$aa4a460944af09fe = $dee9b5b0c130c986$var$TMP_FAAS_INSTANCE;
var $dee9b5b0c130c986$export$a099969737f46339 = $dee9b5b0c130c986$var$TMP_FAAS_MAX_MEMORY;
var $dee9b5b0c130c986$export$e0a684ea09b55cf4 = $dee9b5b0c130c986$var$TMP_HOST_ID;
var $dee9b5b0c130c986$export$3b62edd76224926e = $dee9b5b0c130c986$var$TMP_HOST_NAME;
var $dee9b5b0c130c986$export$ba26ec134241ab05 = $dee9b5b0c130c986$var$TMP_HOST_TYPE;
var $dee9b5b0c130c986$export$4ef6e9b690c5d3ad = $dee9b5b0c130c986$var$TMP_HOST_ARCH;
var $dee9b5b0c130c986$export$80c1be409ca0daf7 = $dee9b5b0c130c986$var$TMP_HOST_IMAGE_NAME;
var $dee9b5b0c130c986$export$ae211b0849dd0d75 = $dee9b5b0c130c986$var$TMP_HOST_IMAGE_ID;
var $dee9b5b0c130c986$export$729ea06c32794759 = $dee9b5b0c130c986$var$TMP_HOST_IMAGE_VERSION;
var $dee9b5b0c130c986$export$9e0ac736c1d187bc = $dee9b5b0c130c986$var$TMP_K8S_CLUSTER_NAME;
var $dee9b5b0c130c986$export$e2479edf033ed1cd = $dee9b5b0c130c986$var$TMP_K8S_NODE_NAME;
var $dee9b5b0c130c986$export$a348ce0508cee2d8 = $dee9b5b0c130c986$var$TMP_K8S_NODE_UID;
var $dee9b5b0c130c986$export$f74f5d90b490f9a6 = $dee9b5b0c130c986$var$TMP_K8S_NAMESPACE_NAME;
var $dee9b5b0c130c986$export$341429c1b099564 = $dee9b5b0c130c986$var$TMP_K8S_POD_UID;
var $dee9b5b0c130c986$export$9e6f11bbfd666f4d = $dee9b5b0c130c986$var$TMP_K8S_POD_NAME;
var $dee9b5b0c130c986$export$ee1ae14ab5631334 = $dee9b5b0c130c986$var$TMP_K8S_CONTAINER_NAME;
var $dee9b5b0c130c986$export$845974e52d5d977b = $dee9b5b0c130c986$var$TMP_K8S_REPLICASET_UID;
var $dee9b5b0c130c986$export$1735237e4ef99ddc = $dee9b5b0c130c986$var$TMP_K8S_REPLICASET_NAME;
var $dee9b5b0c130c986$export$ff557043393b8413 = $dee9b5b0c130c986$var$TMP_K8S_DEPLOYMENT_UID;
var $dee9b5b0c130c986$export$1b29810364e6fd87 = $dee9b5b0c130c986$var$TMP_K8S_DEPLOYMENT_NAME;
var $dee9b5b0c130c986$export$fd37db901d73f6dc = $dee9b5b0c130c986$var$TMP_K8S_STATEFULSET_UID;
var $dee9b5b0c130c986$export$8030a8ee6a430fb9 = $dee9b5b0c130c986$var$TMP_K8S_STATEFULSET_NAME;
var $dee9b5b0c130c986$export$6369d5a7f9c03019 = $dee9b5b0c130c986$var$TMP_K8S_DAEMONSET_UID;
var $dee9b5b0c130c986$export$f55c2f841978e686 = $dee9b5b0c130c986$var$TMP_K8S_DAEMONSET_NAME;
var $dee9b5b0c130c986$export$1618e60c71672510 = $dee9b5b0c130c986$var$TMP_K8S_JOB_UID;
var $dee9b5b0c130c986$export$fae3f547adbfd628 = $dee9b5b0c130c986$var$TMP_K8S_JOB_NAME;
var $dee9b5b0c130c986$export$c6a5d371a9279cc4 = $dee9b5b0c130c986$var$TMP_K8S_CRONJOB_UID;
var $dee9b5b0c130c986$export$2411967a413e48d4 = $dee9b5b0c130c986$var$TMP_K8S_CRONJOB_NAME;
var $dee9b5b0c130c986$export$832bf06644fbf55d = $dee9b5b0c130c986$var$TMP_OS_TYPE;
var $dee9b5b0c130c986$export$5ea67b5ceab8e5b2 = $dee9b5b0c130c986$var$TMP_OS_DESCRIPTION;
var $dee9b5b0c130c986$export$ba2bcf7e30621987 = $dee9b5b0c130c986$var$TMP_OS_NAME;
var $dee9b5b0c130c986$export$e0381cc218bde593 = $dee9b5b0c130c986$var$TMP_OS_VERSION;
var $dee9b5b0c130c986$export$f184e78598ab0d4c = $dee9b5b0c130c986$var$TMP_PROCESS_PID;
var $dee9b5b0c130c986$export$e2e53a1071096d12 = $dee9b5b0c130c986$var$TMP_PROCESS_EXECUTABLE_NAME;
var $dee9b5b0c130c986$export$cc1c2bacfc72d251 = $dee9b5b0c130c986$var$TMP_PROCESS_EXECUTABLE_PATH;
var $dee9b5b0c130c986$export$1921c91b182b21e6 = $dee9b5b0c130c986$var$TMP_PROCESS_COMMAND;
var $dee9b5b0c130c986$export$33d6a2745a92e4bf = $dee9b5b0c130c986$var$TMP_PROCESS_COMMAND_LINE;
var $dee9b5b0c130c986$export$1a3243771890bbd7 = $dee9b5b0c130c986$var$TMP_PROCESS_COMMAND_ARGS;
var $dee9b5b0c130c986$export$5bc9efe4d24f374b = $dee9b5b0c130c986$var$TMP_PROCESS_OWNER;
var $dee9b5b0c130c986$export$6c52ea893832d871 = $dee9b5b0c130c986$var$TMP_PROCESS_RUNTIME_NAME;
var $dee9b5b0c130c986$export$7c038ff97737b111 = $dee9b5b0c130c986$var$TMP_PROCESS_RUNTIME_VERSION;
var $dee9b5b0c130c986$export$cae71c4fbbf205fb = $dee9b5b0c130c986$var$TMP_PROCESS_RUNTIME_DESCRIPTION;
var $dee9b5b0c130c986$export$48c68257f49298c9 = $dee9b5b0c130c986$var$TMP_SERVICE_NAME;
var $dee9b5b0c130c986$export$77c0752ab7c26c9 = $dee9b5b0c130c986$var$TMP_SERVICE_NAMESPACE;
var $dee9b5b0c130c986$export$bb5ecf41777e0d0c = $dee9b5b0c130c986$var$TMP_SERVICE_INSTANCE_ID;
var $dee9b5b0c130c986$export$202d10b361b87ab2 = $dee9b5b0c130c986$var$TMP_SERVICE_VERSION;
var $dee9b5b0c130c986$export$2d668a3bde1cddea = $dee9b5b0c130c986$var$TMP_TELEMETRY_SDK_NAME;
var $dee9b5b0c130c986$export$b5c1717bbc4c6044 = $dee9b5b0c130c986$var$TMP_TELEMETRY_SDK_LANGUAGE;
var $dee9b5b0c130c986$export$e0b67501ecc1df37 = $dee9b5b0c130c986$var$TMP_TELEMETRY_SDK_VERSION;
var $dee9b5b0c130c986$export$3d43fbbcabb62eca = $dee9b5b0c130c986$var$TMP_TELEMETRY_AUTO_VERSION;
var $dee9b5b0c130c986$export$a6b7ffad45e0c20b = $dee9b5b0c130c986$var$TMP_WEBENGINE_NAME;
var $dee9b5b0c130c986$export$589250d7a0c7cee4 = $dee9b5b0c130c986$var$TMP_WEBENGINE_VERSION;
var $dee9b5b0c130c986$export$3318c199ccb51731 = $dee9b5b0c130c986$var$TMP_WEBENGINE_DESCRIPTION;
var $dee9b5b0c130c986$export$85d6ffe28a084c78 = /*#__PURE__*/ (0, $17HEJ.createConstMap)([
    $dee9b5b0c130c986$var$TMP_CLOUD_PROVIDER,
    $dee9b5b0c130c986$var$TMP_CLOUD_ACCOUNT_ID,
    $dee9b5b0c130c986$var$TMP_CLOUD_REGION,
    $dee9b5b0c130c986$var$TMP_CLOUD_AVAILABILITY_ZONE,
    $dee9b5b0c130c986$var$TMP_CLOUD_PLATFORM,
    $dee9b5b0c130c986$var$TMP_AWS_ECS_CONTAINER_ARN,
    $dee9b5b0c130c986$var$TMP_AWS_ECS_CLUSTER_ARN,
    $dee9b5b0c130c986$var$TMP_AWS_ECS_LAUNCHTYPE,
    $dee9b5b0c130c986$var$TMP_AWS_ECS_TASK_ARN,
    $dee9b5b0c130c986$var$TMP_AWS_ECS_TASK_FAMILY,
    $dee9b5b0c130c986$var$TMP_AWS_ECS_TASK_REVISION,
    $dee9b5b0c130c986$var$TMP_AWS_EKS_CLUSTER_ARN,
    $dee9b5b0c130c986$var$TMP_AWS_LOG_GROUP_NAMES,
    $dee9b5b0c130c986$var$TMP_AWS_LOG_GROUP_ARNS,
    $dee9b5b0c130c986$var$TMP_AWS_LOG_STREAM_NAMES,
    $dee9b5b0c130c986$var$TMP_AWS_LOG_STREAM_ARNS,
    $dee9b5b0c130c986$var$TMP_CONTAINER_NAME,
    $dee9b5b0c130c986$var$TMP_CONTAINER_ID,
    $dee9b5b0c130c986$var$TMP_CONTAINER_RUNTIME,
    $dee9b5b0c130c986$var$TMP_CONTAINER_IMAGE_NAME,
    $dee9b5b0c130c986$var$TMP_CONTAINER_IMAGE_TAG,
    $dee9b5b0c130c986$var$TMP_DEPLOYMENT_ENVIRONMENT,
    $dee9b5b0c130c986$var$TMP_DEVICE_ID,
    $dee9b5b0c130c986$var$TMP_DEVICE_MODEL_IDENTIFIER,
    $dee9b5b0c130c986$var$TMP_DEVICE_MODEL_NAME,
    $dee9b5b0c130c986$var$TMP_FAAS_NAME,
    $dee9b5b0c130c986$var$TMP_FAAS_ID,
    $dee9b5b0c130c986$var$TMP_FAAS_VERSION,
    $dee9b5b0c130c986$var$TMP_FAAS_INSTANCE,
    $dee9b5b0c130c986$var$TMP_FAAS_MAX_MEMORY,
    $dee9b5b0c130c986$var$TMP_HOST_ID,
    $dee9b5b0c130c986$var$TMP_HOST_NAME,
    $dee9b5b0c130c986$var$TMP_HOST_TYPE,
    $dee9b5b0c130c986$var$TMP_HOST_ARCH,
    $dee9b5b0c130c986$var$TMP_HOST_IMAGE_NAME,
    $dee9b5b0c130c986$var$TMP_HOST_IMAGE_ID,
    $dee9b5b0c130c986$var$TMP_HOST_IMAGE_VERSION,
    $dee9b5b0c130c986$var$TMP_K8S_CLUSTER_NAME,
    $dee9b5b0c130c986$var$TMP_K8S_NODE_NAME,
    $dee9b5b0c130c986$var$TMP_K8S_NODE_UID,
    $dee9b5b0c130c986$var$TMP_K8S_NAMESPACE_NAME,
    $dee9b5b0c130c986$var$TMP_K8S_POD_UID,
    $dee9b5b0c130c986$var$TMP_K8S_POD_NAME,
    $dee9b5b0c130c986$var$TMP_K8S_CONTAINER_NAME,
    $dee9b5b0c130c986$var$TMP_K8S_REPLICASET_UID,
    $dee9b5b0c130c986$var$TMP_K8S_REPLICASET_NAME,
    $dee9b5b0c130c986$var$TMP_K8S_DEPLOYMENT_UID,
    $dee9b5b0c130c986$var$TMP_K8S_DEPLOYMENT_NAME,
    $dee9b5b0c130c986$var$TMP_K8S_STATEFULSET_UID,
    $dee9b5b0c130c986$var$TMP_K8S_STATEFULSET_NAME,
    $dee9b5b0c130c986$var$TMP_K8S_DAEMONSET_UID,
    $dee9b5b0c130c986$var$TMP_K8S_DAEMONSET_NAME,
    $dee9b5b0c130c986$var$TMP_K8S_JOB_UID,
    $dee9b5b0c130c986$var$TMP_K8S_JOB_NAME,
    $dee9b5b0c130c986$var$TMP_K8S_CRONJOB_UID,
    $dee9b5b0c130c986$var$TMP_K8S_CRONJOB_NAME,
    $dee9b5b0c130c986$var$TMP_OS_TYPE,
    $dee9b5b0c130c986$var$TMP_OS_DESCRIPTION,
    $dee9b5b0c130c986$var$TMP_OS_NAME,
    $dee9b5b0c130c986$var$TMP_OS_VERSION,
    $dee9b5b0c130c986$var$TMP_PROCESS_PID,
    $dee9b5b0c130c986$var$TMP_PROCESS_EXECUTABLE_NAME,
    $dee9b5b0c130c986$var$TMP_PROCESS_EXECUTABLE_PATH,
    $dee9b5b0c130c986$var$TMP_PROCESS_COMMAND,
    $dee9b5b0c130c986$var$TMP_PROCESS_COMMAND_LINE,
    $dee9b5b0c130c986$var$TMP_PROCESS_COMMAND_ARGS,
    $dee9b5b0c130c986$var$TMP_PROCESS_OWNER,
    $dee9b5b0c130c986$var$TMP_PROCESS_RUNTIME_NAME,
    $dee9b5b0c130c986$var$TMP_PROCESS_RUNTIME_VERSION,
    $dee9b5b0c130c986$var$TMP_PROCESS_RUNTIME_DESCRIPTION,
    $dee9b5b0c130c986$var$TMP_SERVICE_NAME,
    $dee9b5b0c130c986$var$TMP_SERVICE_NAMESPACE,
    $dee9b5b0c130c986$var$TMP_SERVICE_INSTANCE_ID,
    $dee9b5b0c130c986$var$TMP_SERVICE_VERSION,
    $dee9b5b0c130c986$var$TMP_TELEMETRY_SDK_NAME,
    $dee9b5b0c130c986$var$TMP_TELEMETRY_SDK_LANGUAGE,
    $dee9b5b0c130c986$var$TMP_TELEMETRY_SDK_VERSION,
    $dee9b5b0c130c986$var$TMP_TELEMETRY_AUTO_VERSION,
    $dee9b5b0c130c986$var$TMP_WEBENGINE_NAME,
    $dee9b5b0c130c986$var$TMP_WEBENGINE_VERSION,
    $dee9b5b0c130c986$var$TMP_WEBENGINE_DESCRIPTION
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for CloudProviderValues enum definition
 *
 * Name of the cloud provider.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifable export names for some package types
var $dee9b5b0c130c986$var$TMP_CLOUDPROVIDERVALUES_ALIBABA_CLOUD = 'alibaba_cloud';
var $dee9b5b0c130c986$var$TMP_CLOUDPROVIDERVALUES_AWS = 'aws';
var $dee9b5b0c130c986$var$TMP_CLOUDPROVIDERVALUES_AZURE = 'azure';
var $dee9b5b0c130c986$var$TMP_CLOUDPROVIDERVALUES_GCP = 'gcp';
var $dee9b5b0c130c986$export$1f18298beaae37d3 = $dee9b5b0c130c986$var$TMP_CLOUDPROVIDERVALUES_ALIBABA_CLOUD;
var $dee9b5b0c130c986$export$f56ad4bf836470f2 = $dee9b5b0c130c986$var$TMP_CLOUDPROVIDERVALUES_AWS;
var $dee9b5b0c130c986$export$a607df3e2371e436 = $dee9b5b0c130c986$var$TMP_CLOUDPROVIDERVALUES_AZURE;
var $dee9b5b0c130c986$export$b5cb559e526f402a = $dee9b5b0c130c986$var$TMP_CLOUDPROVIDERVALUES_GCP;
var $dee9b5b0c130c986$export$c2664345bd8aad14 = /*#__PURE__*/ (0, $17HEJ.createConstMap)([
    $dee9b5b0c130c986$var$TMP_CLOUDPROVIDERVALUES_ALIBABA_CLOUD,
    $dee9b5b0c130c986$var$TMP_CLOUDPROVIDERVALUES_AWS,
    $dee9b5b0c130c986$var$TMP_CLOUDPROVIDERVALUES_AZURE,
    $dee9b5b0c130c986$var$TMP_CLOUDPROVIDERVALUES_GCP
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for CloudPlatformValues enum definition
 *
 * The cloud platform in use.
 *
 * Note: The prefix of the service SHOULD match the one specified in `cloud.provider`.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifable export names for some package types
var $dee9b5b0c130c986$var$TMP_CLOUDPLATFORMVALUES_ALIBABA_CLOUD_ECS = 'alibaba_cloud_ecs';
var $dee9b5b0c130c986$var$TMP_CLOUDPLATFORMVALUES_ALIBABA_CLOUD_FC = 'alibaba_cloud_fc';
var $dee9b5b0c130c986$var$TMP_CLOUDPLATFORMVALUES_AWS_EC2 = 'aws_ec2';
var $dee9b5b0c130c986$var$TMP_CLOUDPLATFORMVALUES_AWS_ECS = 'aws_ecs';
var $dee9b5b0c130c986$var$TMP_CLOUDPLATFORMVALUES_AWS_EKS = 'aws_eks';
var $dee9b5b0c130c986$var$TMP_CLOUDPLATFORMVALUES_AWS_LAMBDA = 'aws_lambda';
var $dee9b5b0c130c986$var$TMP_CLOUDPLATFORMVALUES_AWS_ELASTIC_BEANSTALK = 'aws_elastic_beanstalk';
var $dee9b5b0c130c986$var$TMP_CLOUDPLATFORMVALUES_AZURE_VM = 'azure_vm';
var $dee9b5b0c130c986$var$TMP_CLOUDPLATFORMVALUES_AZURE_CONTAINER_INSTANCES = 'azure_container_instances';
var $dee9b5b0c130c986$var$TMP_CLOUDPLATFORMVALUES_AZURE_AKS = 'azure_aks';
var $dee9b5b0c130c986$var$TMP_CLOUDPLATFORMVALUES_AZURE_FUNCTIONS = 'azure_functions';
var $dee9b5b0c130c986$var$TMP_CLOUDPLATFORMVALUES_AZURE_APP_SERVICE = 'azure_app_service';
var $dee9b5b0c130c986$var$TMP_CLOUDPLATFORMVALUES_GCP_COMPUTE_ENGINE = 'gcp_compute_engine';
var $dee9b5b0c130c986$var$TMP_CLOUDPLATFORMVALUES_GCP_CLOUD_RUN = 'gcp_cloud_run';
var $dee9b5b0c130c986$var$TMP_CLOUDPLATFORMVALUES_GCP_KUBERNETES_ENGINE = 'gcp_kubernetes_engine';
var $dee9b5b0c130c986$var$TMP_CLOUDPLATFORMVALUES_GCP_CLOUD_FUNCTIONS = 'gcp_cloud_functions';
var $dee9b5b0c130c986$var$TMP_CLOUDPLATFORMVALUES_GCP_APP_ENGINE = 'gcp_app_engine';
var $dee9b5b0c130c986$export$b7ccb6b2de7534ed = $dee9b5b0c130c986$var$TMP_CLOUDPLATFORMVALUES_ALIBABA_CLOUD_ECS;
var $dee9b5b0c130c986$export$5e031b328860dffd = $dee9b5b0c130c986$var$TMP_CLOUDPLATFORMVALUES_ALIBABA_CLOUD_FC;
var $dee9b5b0c130c986$export$f0e8dec51b6cf37d = $dee9b5b0c130c986$var$TMP_CLOUDPLATFORMVALUES_AWS_EC2;
var $dee9b5b0c130c986$export$a325ac849a598ed7 = $dee9b5b0c130c986$var$TMP_CLOUDPLATFORMVALUES_AWS_ECS;
var $dee9b5b0c130c986$export$9c3f60b2b4d542e1 = $dee9b5b0c130c986$var$TMP_CLOUDPLATFORMVALUES_AWS_EKS;
var $dee9b5b0c130c986$export$1edcff8a13326911 = $dee9b5b0c130c986$var$TMP_CLOUDPLATFORMVALUES_AWS_LAMBDA;
var $dee9b5b0c130c986$export$2f7128c57ade0d50 = $dee9b5b0c130c986$var$TMP_CLOUDPLATFORMVALUES_AWS_ELASTIC_BEANSTALK;
var $dee9b5b0c130c986$export$10256094f96cd373 = $dee9b5b0c130c986$var$TMP_CLOUDPLATFORMVALUES_AZURE_VM;
var $dee9b5b0c130c986$export$ed505d4ca2b4d712 = $dee9b5b0c130c986$var$TMP_CLOUDPLATFORMVALUES_AZURE_CONTAINER_INSTANCES;
var $dee9b5b0c130c986$export$83131f1a1f001ee = $dee9b5b0c130c986$var$TMP_CLOUDPLATFORMVALUES_AZURE_AKS;
var $dee9b5b0c130c986$export$36f98571cef96af7 = $dee9b5b0c130c986$var$TMP_CLOUDPLATFORMVALUES_AZURE_FUNCTIONS;
var $dee9b5b0c130c986$export$66faee8e64625c5d = $dee9b5b0c130c986$var$TMP_CLOUDPLATFORMVALUES_AZURE_APP_SERVICE;
var $dee9b5b0c130c986$export$dd043c2707119e75 = $dee9b5b0c130c986$var$TMP_CLOUDPLATFORMVALUES_GCP_COMPUTE_ENGINE;
var $dee9b5b0c130c986$export$d0a1ecf47fa77b8b = $dee9b5b0c130c986$var$TMP_CLOUDPLATFORMVALUES_GCP_CLOUD_RUN;
var $dee9b5b0c130c986$export$649c271f5295d71e = $dee9b5b0c130c986$var$TMP_CLOUDPLATFORMVALUES_GCP_KUBERNETES_ENGINE;
var $dee9b5b0c130c986$export$e9becd93e8daa01a = $dee9b5b0c130c986$var$TMP_CLOUDPLATFORMVALUES_GCP_CLOUD_FUNCTIONS;
var $dee9b5b0c130c986$export$5862836e4b24761c = $dee9b5b0c130c986$var$TMP_CLOUDPLATFORMVALUES_GCP_APP_ENGINE;
var $dee9b5b0c130c986$export$fe811090f8b1259c = /*#__PURE__*/ (0, $17HEJ.createConstMap)([
    $dee9b5b0c130c986$var$TMP_CLOUDPLATFORMVALUES_ALIBABA_CLOUD_ECS,
    $dee9b5b0c130c986$var$TMP_CLOUDPLATFORMVALUES_ALIBABA_CLOUD_FC,
    $dee9b5b0c130c986$var$TMP_CLOUDPLATFORMVALUES_AWS_EC2,
    $dee9b5b0c130c986$var$TMP_CLOUDPLATFORMVALUES_AWS_ECS,
    $dee9b5b0c130c986$var$TMP_CLOUDPLATFORMVALUES_AWS_EKS,
    $dee9b5b0c130c986$var$TMP_CLOUDPLATFORMVALUES_AWS_LAMBDA,
    $dee9b5b0c130c986$var$TMP_CLOUDPLATFORMVALUES_AWS_ELASTIC_BEANSTALK,
    $dee9b5b0c130c986$var$TMP_CLOUDPLATFORMVALUES_AZURE_VM,
    $dee9b5b0c130c986$var$TMP_CLOUDPLATFORMVALUES_AZURE_CONTAINER_INSTANCES,
    $dee9b5b0c130c986$var$TMP_CLOUDPLATFORMVALUES_AZURE_AKS,
    $dee9b5b0c130c986$var$TMP_CLOUDPLATFORMVALUES_AZURE_FUNCTIONS,
    $dee9b5b0c130c986$var$TMP_CLOUDPLATFORMVALUES_AZURE_APP_SERVICE,
    $dee9b5b0c130c986$var$TMP_CLOUDPLATFORMVALUES_GCP_COMPUTE_ENGINE,
    $dee9b5b0c130c986$var$TMP_CLOUDPLATFORMVALUES_GCP_CLOUD_RUN,
    $dee9b5b0c130c986$var$TMP_CLOUDPLATFORMVALUES_GCP_KUBERNETES_ENGINE,
    $dee9b5b0c130c986$var$TMP_CLOUDPLATFORMVALUES_GCP_CLOUD_FUNCTIONS,
    $dee9b5b0c130c986$var$TMP_CLOUDPLATFORMVALUES_GCP_APP_ENGINE
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for AwsEcsLaunchtypeValues enum definition
 *
 * The [launch type](https://docs.aws.amazon.com/AmazonECS/latest/developerguide/launch_types.html) for an ECS task.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifable export names for some package types
var $dee9b5b0c130c986$var$TMP_AWSECSLAUNCHTYPEVALUES_EC2 = 'ec2';
var $dee9b5b0c130c986$var$TMP_AWSECSLAUNCHTYPEVALUES_FARGATE = 'fargate';
var $dee9b5b0c130c986$export$54d16708f9a4cde = $dee9b5b0c130c986$var$TMP_AWSECSLAUNCHTYPEVALUES_EC2;
var $dee9b5b0c130c986$export$7bf660b6e44fe06e = $dee9b5b0c130c986$var$TMP_AWSECSLAUNCHTYPEVALUES_FARGATE;
var $dee9b5b0c130c986$export$6945fb1e4f2852ef = /*#__PURE__*/ (0, $17HEJ.createConstMap)([
    $dee9b5b0c130c986$var$TMP_AWSECSLAUNCHTYPEVALUES_EC2,
    $dee9b5b0c130c986$var$TMP_AWSECSLAUNCHTYPEVALUES_FARGATE
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for HostArchValues enum definition
 *
 * The CPU architecture the host system is running on.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifable export names for some package types
var $dee9b5b0c130c986$var$TMP_HOSTARCHVALUES_AMD64 = 'amd64';
var $dee9b5b0c130c986$var$TMP_HOSTARCHVALUES_ARM32 = 'arm32';
var $dee9b5b0c130c986$var$TMP_HOSTARCHVALUES_ARM64 = 'arm64';
var $dee9b5b0c130c986$var$TMP_HOSTARCHVALUES_IA64 = 'ia64';
var $dee9b5b0c130c986$var$TMP_HOSTARCHVALUES_PPC32 = 'ppc32';
var $dee9b5b0c130c986$var$TMP_HOSTARCHVALUES_PPC64 = 'ppc64';
var $dee9b5b0c130c986$var$TMP_HOSTARCHVALUES_X86 = 'x86';
var $dee9b5b0c130c986$export$6050a837e7da966a = $dee9b5b0c130c986$var$TMP_HOSTARCHVALUES_AMD64;
var $dee9b5b0c130c986$export$3c7341cec70023f0 = $dee9b5b0c130c986$var$TMP_HOSTARCHVALUES_ARM32;
var $dee9b5b0c130c986$export$2fac5f715b596c6d = $dee9b5b0c130c986$var$TMP_HOSTARCHVALUES_ARM64;
var $dee9b5b0c130c986$export$231235882f6e6443 = $dee9b5b0c130c986$var$TMP_HOSTARCHVALUES_IA64;
var $dee9b5b0c130c986$export$c4a24e52d6385d55 = $dee9b5b0c130c986$var$TMP_HOSTARCHVALUES_PPC32;
var $dee9b5b0c130c986$export$18594ce63eac5c97 = $dee9b5b0c130c986$var$TMP_HOSTARCHVALUES_PPC64;
var $dee9b5b0c130c986$export$1af722303cbf3f49 = $dee9b5b0c130c986$var$TMP_HOSTARCHVALUES_X86;
var $dee9b5b0c130c986$export$f31e10d6db5b428b = /*#__PURE__*/ (0, $17HEJ.createConstMap)([
    $dee9b5b0c130c986$var$TMP_HOSTARCHVALUES_AMD64,
    $dee9b5b0c130c986$var$TMP_HOSTARCHVALUES_ARM32,
    $dee9b5b0c130c986$var$TMP_HOSTARCHVALUES_ARM64,
    $dee9b5b0c130c986$var$TMP_HOSTARCHVALUES_IA64,
    $dee9b5b0c130c986$var$TMP_HOSTARCHVALUES_PPC32,
    $dee9b5b0c130c986$var$TMP_HOSTARCHVALUES_PPC64,
    $dee9b5b0c130c986$var$TMP_HOSTARCHVALUES_X86
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for OsTypeValues enum definition
 *
 * The operating system type.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifable export names for some package types
var $dee9b5b0c130c986$var$TMP_OSTYPEVALUES_WINDOWS = 'windows';
var $dee9b5b0c130c986$var$TMP_OSTYPEVALUES_LINUX = 'linux';
var $dee9b5b0c130c986$var$TMP_OSTYPEVALUES_DARWIN = 'darwin';
var $dee9b5b0c130c986$var$TMP_OSTYPEVALUES_FREEBSD = 'freebsd';
var $dee9b5b0c130c986$var$TMP_OSTYPEVALUES_NETBSD = 'netbsd';
var $dee9b5b0c130c986$var$TMP_OSTYPEVALUES_OPENBSD = 'openbsd';
var $dee9b5b0c130c986$var$TMP_OSTYPEVALUES_DRAGONFLYBSD = 'dragonflybsd';
var $dee9b5b0c130c986$var$TMP_OSTYPEVALUES_HPUX = 'hpux';
var $dee9b5b0c130c986$var$TMP_OSTYPEVALUES_AIX = 'aix';
var $dee9b5b0c130c986$var$TMP_OSTYPEVALUES_SOLARIS = 'solaris';
var $dee9b5b0c130c986$var$TMP_OSTYPEVALUES_Z_OS = 'z_os';
var $dee9b5b0c130c986$export$9e247b47b87a5e98 = $dee9b5b0c130c986$var$TMP_OSTYPEVALUES_WINDOWS;
var $dee9b5b0c130c986$export$79d9a21d50f1d11b = $dee9b5b0c130c986$var$TMP_OSTYPEVALUES_LINUX;
var $dee9b5b0c130c986$export$29d1fb472dabfab5 = $dee9b5b0c130c986$var$TMP_OSTYPEVALUES_DARWIN;
var $dee9b5b0c130c986$export$41f1a684ef8f38a0 = $dee9b5b0c130c986$var$TMP_OSTYPEVALUES_FREEBSD;
var $dee9b5b0c130c986$export$d11e84640954119d = $dee9b5b0c130c986$var$TMP_OSTYPEVALUES_NETBSD;
var $dee9b5b0c130c986$export$cf6bab1412b5a24 = $dee9b5b0c130c986$var$TMP_OSTYPEVALUES_OPENBSD;
var $dee9b5b0c130c986$export$e902e17ab5ff9bad = $dee9b5b0c130c986$var$TMP_OSTYPEVALUES_DRAGONFLYBSD;
var $dee9b5b0c130c986$export$9a4c793b18e0bd5e = $dee9b5b0c130c986$var$TMP_OSTYPEVALUES_HPUX;
var $dee9b5b0c130c986$export$bdec18d31f5e2d9d = $dee9b5b0c130c986$var$TMP_OSTYPEVALUES_AIX;
var $dee9b5b0c130c986$export$6226a44babc07d2d = $dee9b5b0c130c986$var$TMP_OSTYPEVALUES_SOLARIS;
var $dee9b5b0c130c986$export$a81b7e7863a06968 = $dee9b5b0c130c986$var$TMP_OSTYPEVALUES_Z_OS;
var $dee9b5b0c130c986$export$efc6a8b7a61f5577 = /*#__PURE__*/ (0, $17HEJ.createConstMap)([
    $dee9b5b0c130c986$var$TMP_OSTYPEVALUES_WINDOWS,
    $dee9b5b0c130c986$var$TMP_OSTYPEVALUES_LINUX,
    $dee9b5b0c130c986$var$TMP_OSTYPEVALUES_DARWIN,
    $dee9b5b0c130c986$var$TMP_OSTYPEVALUES_FREEBSD,
    $dee9b5b0c130c986$var$TMP_OSTYPEVALUES_NETBSD,
    $dee9b5b0c130c986$var$TMP_OSTYPEVALUES_OPENBSD,
    $dee9b5b0c130c986$var$TMP_OSTYPEVALUES_DRAGONFLYBSD,
    $dee9b5b0c130c986$var$TMP_OSTYPEVALUES_HPUX,
    $dee9b5b0c130c986$var$TMP_OSTYPEVALUES_AIX,
    $dee9b5b0c130c986$var$TMP_OSTYPEVALUES_SOLARIS,
    $dee9b5b0c130c986$var$TMP_OSTYPEVALUES_Z_OS
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for TelemetrySdkLanguageValues enum definition
 *
 * The language of the telemetry SDK.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifable export names for some package types
var $dee9b5b0c130c986$var$TMP_TELEMETRYSDKLANGUAGEVALUES_CPP = 'cpp';
var $dee9b5b0c130c986$var$TMP_TELEMETRYSDKLANGUAGEVALUES_DOTNET = 'dotnet';
var $dee9b5b0c130c986$var$TMP_TELEMETRYSDKLANGUAGEVALUES_ERLANG = 'erlang';
var $dee9b5b0c130c986$var$TMP_TELEMETRYSDKLANGUAGEVALUES_GO = 'go';
var $dee9b5b0c130c986$var$TMP_TELEMETRYSDKLANGUAGEVALUES_JAVA = 'java';
var $dee9b5b0c130c986$var$TMP_TELEMETRYSDKLANGUAGEVALUES_NODEJS = 'nodejs';
var $dee9b5b0c130c986$var$TMP_TELEMETRYSDKLANGUAGEVALUES_PHP = 'php';
var $dee9b5b0c130c986$var$TMP_TELEMETRYSDKLANGUAGEVALUES_PYTHON = 'python';
var $dee9b5b0c130c986$var$TMP_TELEMETRYSDKLANGUAGEVALUES_RUBY = 'ruby';
var $dee9b5b0c130c986$var$TMP_TELEMETRYSDKLANGUAGEVALUES_WEBJS = 'webjs';
var $dee9b5b0c130c986$export$bb305b29d3ff12b2 = $dee9b5b0c130c986$var$TMP_TELEMETRYSDKLANGUAGEVALUES_CPP;
var $dee9b5b0c130c986$export$36f70c7fec241585 = $dee9b5b0c130c986$var$TMP_TELEMETRYSDKLANGUAGEVALUES_DOTNET;
var $dee9b5b0c130c986$export$9254854c1a90f699 = $dee9b5b0c130c986$var$TMP_TELEMETRYSDKLANGUAGEVALUES_ERLANG;
var $dee9b5b0c130c986$export$870f3d5bf5403ac2 = $dee9b5b0c130c986$var$TMP_TELEMETRYSDKLANGUAGEVALUES_GO;
var $dee9b5b0c130c986$export$a115dae9eb65ef38 = $dee9b5b0c130c986$var$TMP_TELEMETRYSDKLANGUAGEVALUES_JAVA;
var $dee9b5b0c130c986$export$f599ed80e3c8d29a = $dee9b5b0c130c986$var$TMP_TELEMETRYSDKLANGUAGEVALUES_NODEJS;
var $dee9b5b0c130c986$export$42ae93f6bda608ef = $dee9b5b0c130c986$var$TMP_TELEMETRYSDKLANGUAGEVALUES_PHP;
var $dee9b5b0c130c986$export$7f6f8205f1621418 = $dee9b5b0c130c986$var$TMP_TELEMETRYSDKLANGUAGEVALUES_PYTHON;
var $dee9b5b0c130c986$export$3dd620b466e18cf = $dee9b5b0c130c986$var$TMP_TELEMETRYSDKLANGUAGEVALUES_RUBY;
var $dee9b5b0c130c986$export$1414beb1e03cac7c = $dee9b5b0c130c986$var$TMP_TELEMETRYSDKLANGUAGEVALUES_WEBJS;
var $dee9b5b0c130c986$export$b43162e16168dba6 = /*#__PURE__*/ (0, $17HEJ.createConstMap)([
    $dee9b5b0c130c986$var$TMP_TELEMETRYSDKLANGUAGEVALUES_CPP,
    $dee9b5b0c130c986$var$TMP_TELEMETRYSDKLANGUAGEVALUES_DOTNET,
    $dee9b5b0c130c986$var$TMP_TELEMETRYSDKLANGUAGEVALUES_ERLANG,
    $dee9b5b0c130c986$var$TMP_TELEMETRYSDKLANGUAGEVALUES_GO,
    $dee9b5b0c130c986$var$TMP_TELEMETRYSDKLANGUAGEVALUES_JAVA,
    $dee9b5b0c130c986$var$TMP_TELEMETRYSDKLANGUAGEVALUES_NODEJS,
    $dee9b5b0c130c986$var$TMP_TELEMETRYSDKLANGUAGEVALUES_PHP,
    $dee9b5b0c130c986$var$TMP_TELEMETRYSDKLANGUAGEVALUES_PYTHON,
    $dee9b5b0c130c986$var$TMP_TELEMETRYSDKLANGUAGEVALUES_RUBY,
    $dee9b5b0c130c986$var$TMP_TELEMETRYSDKLANGUAGEVALUES_WEBJS
]);

});

parcelRegister("4lMum", function(module, exports) {

$parcel$export(module.exports, "SDK_INFO", function () { return $32aebc751da6155a$export$3c44663382dce232; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $1qKIg = parcelRequire("1qKIg");

var $j8yJK = parcelRequire("j8yJK");
var $32aebc751da6155a$var$_a;
var $32aebc751da6155a$export$3c44663382dce232 = ($32aebc751da6155a$var$_a = {}, $32aebc751da6155a$var$_a[0, $j8yJK.SEMRESATTRS_TELEMETRY_SDK_NAME] = 'opentelemetry', $32aebc751da6155a$var$_a[0, $j8yJK.SEMRESATTRS_PROCESS_RUNTIME_NAME] = 'browser', $32aebc751da6155a$var$_a[0, $j8yJK.SEMRESATTRS_TELEMETRY_SDK_LANGUAGE] = (0, $j8yJK.TELEMETRYSDKLANGUAGEVALUES_WEBJS), $32aebc751da6155a$var$_a[0, $j8yJK.SEMRESATTRS_TELEMETRY_SDK_VERSION] = (0, $1qKIg.VERSION), $32aebc751da6155a$var$_a);

});
parcelRegister("1qKIg", function(module, exports) {

$parcel$export(module.exports, "VERSION", function () { return $10ac745bee054cbe$export$a4ad2735b021c132; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // this is autogenerated file, see scripts/version-update.js
var $10ac745bee054cbe$export$a4ad2735b021c132 = '1.25.1';

});


parcelRegister("c20na", function(module, exports) {

$parcel$export(module.exports, "defaultServiceName", function () { return $8c25f5edbe2d1b3e$export$b8c2abd2a6cf7c10; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $8c25f5edbe2d1b3e$export$b8c2abd2a6cf7c10() {
    return 'unknown_service';
}

});


parcelRegister("a8xL4", function(module, exports) {

$parcel$export(module.exports, "Tracer", function () { return $7614d66ec269e025$export$c4b9363e2fc65361; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ parcelRequire("ckckF");
var $4e6si = parcelRequire("4e6si");
var $7Y52R = parcelRequire("7Y52R");
var $g4DKS = parcelRequire("g4DKS");
var $gRjnF = parcelRequire("gRjnF");
var $lbCBL = parcelRequire("lbCBL");
var $iS6Md = parcelRequire("iS6Md");
var $kxoQ4 = parcelRequire("kxoQ4");

var $3WAuq = parcelRequire("3WAuq");
var $2i66W = parcelRequire("2i66W");

var $bxflq = parcelRequire("bxflq");

var $jxLjW = parcelRequire("jxLjW");

var $cPLNF = parcelRequire("cPLNF");
/**
 * This class represents a basic tracer.
 */ var $7614d66ec269e025$export$c4b9363e2fc65361 = /** @class */ function() {
    /**
     * Constructs a new Tracer instance.
     */ function Tracer(instrumentationLibrary, config, _tracerProvider) {
        this._tracerProvider = _tracerProvider;
        var localConfig = (0, $jxLjW.mergeConfig)(config);
        this._sampler = localConfig.sampler;
        this._generalLimits = localConfig.generalLimits;
        this._spanLimits = localConfig.spanLimits;
        this._idGenerator = config.idGenerator || new (0, $cPLNF.RandomIdGenerator)();
        this.resource = _tracerProvider.resource;
        this.instrumentationLibrary = instrumentationLibrary;
    }
    /**
     * Starts a new Span or returns the default NoopSpan based on the sampling
     * decision.
     */ Tracer.prototype.startSpan = function(name, options, context) {
        var _a, _b, _c;
        if (options === void 0) options = {};
        if (context === void 0) context = $4e6si.context.active();
        // remove span from context in case a root span is requested via options
        if (options.root) context = $g4DKS.trace.deleteSpan(context);
        var parentSpan = $g4DKS.trace.getSpan(context);
        if ((0, $3WAuq.isTracingSuppressed)(context)) {
            $7Y52R.diag.debug('Instrumentation suppressed, returning Noop Span');
            var nonRecordingSpan = $g4DKS.trace.wrapSpanContext($gRjnF.INVALID_SPAN_CONTEXT);
            return nonRecordingSpan;
        }
        var parentSpanContext = parentSpan === null || parentSpan === void 0 ? void 0 : parentSpan.spanContext();
        var spanId = this._idGenerator.generateSpanId();
        var traceId;
        var traceState;
        var parentSpanId;
        if (!parentSpanContext || !$g4DKS.trace.isSpanContextValid(parentSpanContext)) // New root span.
        traceId = this._idGenerator.generateTraceId();
        else {
            // New child span.
            traceId = parentSpanContext.traceId;
            traceState = parentSpanContext.traceState;
            parentSpanId = parentSpanContext.spanId;
        }
        var spanKind = (_a = options.kind) !== null && _a !== void 0 ? _a : $iS6Md.SpanKind.INTERNAL;
        var links = ((_b = options.links) !== null && _b !== void 0 ? _b : []).map(function(link) {
            return {
                context: link.context,
                attributes: (0, $2i66W.sanitizeAttributes)(link.attributes)
            };
        });
        var attributes = (0, $2i66W.sanitizeAttributes)(options.attributes);
        // make sampling decision
        var samplingResult = this._sampler.shouldSample(context, traceId, name, spanKind, attributes, links);
        traceState = (_c = samplingResult.traceState) !== null && _c !== void 0 ? _c : traceState;
        var traceFlags = samplingResult.decision === $lbCBL.SamplingDecision.RECORD_AND_SAMPLED ? $kxoQ4.TraceFlags.SAMPLED : $kxoQ4.TraceFlags.NONE;
        var spanContext = {
            traceId: traceId,
            spanId: spanId,
            traceFlags: traceFlags,
            traceState: traceState
        };
        if (samplingResult.decision === $lbCBL.SamplingDecision.NOT_RECORD) {
            $7Y52R.diag.debug('Recording is off, propagating context in a non-recording span');
            var nonRecordingSpan = $g4DKS.trace.wrapSpanContext(spanContext);
            return nonRecordingSpan;
        }
        // Set initial span attributes. The attributes object may have been mutated
        // by the sampler, so we sanitize the merged attributes before setting them.
        var initAttributes = (0, $2i66W.sanitizeAttributes)(Object.assign(attributes, samplingResult.attributes));
        var span = new (0, $bxflq.Span)(this, context, name, spanContext, spanKind, parentSpanId, links, options.startTime, undefined, initAttributes);
        return span;
    };
    Tracer.prototype.startActiveSpan = function(name, arg2, arg3, arg4) {
        var opts;
        var ctx;
        var fn;
        if (arguments.length < 2) return;
        else if (arguments.length === 2) fn = arg2;
        else if (arguments.length === 3) {
            opts = arg2;
            fn = arg3;
        } else {
            opts = arg2;
            ctx = arg3;
            fn = arg4;
        }
        var parentContext = ctx !== null && ctx !== void 0 ? ctx : $4e6si.context.active();
        var span = this.startSpan(name, opts, parentContext);
        var contextWithSpanSet = $g4DKS.trace.setSpan(parentContext, span);
        return $4e6si.context.with(contextWithSpanSet, fn, undefined, span);
    };
    /** Returns the active {@link GeneralLimits}. */ Tracer.prototype.getGeneralLimits = function() {
        return this._generalLimits;
    };
    /** Returns the active {@link SpanLimits}. */ Tracer.prototype.getSpanLimits = function() {
        return this._spanLimits;
    };
    Tracer.prototype.getActiveSpanProcessor = function() {
        return this._tracerProvider.getActiveSpanProcessor();
    };
    return Tracer;
}();

});
parcelRegister("2i66W", function(module, exports) {

$parcel$export(module.exports, "sanitizeAttributes", function () { return $1ab200bd53f45a0b$export$b0663eba150d60c9; });
$parcel$export(module.exports, "isAttributeValue", function () { return $1ab200bd53f45a0b$export$1daad3d2aacf48c5; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ parcelRequire("ckckF");
var $7Y52R = parcelRequire("7Y52R");
var $1ab200bd53f45a0b$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $1ab200bd53f45a0b$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
function $1ab200bd53f45a0b$export$b0663eba150d60c9(attributes) {
    var e_1, _a;
    var out = {};
    if (typeof attributes !== 'object' || attributes == null) return out;
    try {
        for(var _b = $1ab200bd53f45a0b$var$__values(Object.entries(attributes)), _c = _b.next(); !_c.done; _c = _b.next()){
            var _d = $1ab200bd53f45a0b$var$__read(_c.value, 2), key = _d[0], val = _d[1];
            if (!$1ab200bd53f45a0b$export$d3dd8ead6a0318c3(key)) {
                (0, $7Y52R.diag).warn("Invalid attribute key: " + key);
                continue;
            }
            if (!$1ab200bd53f45a0b$export$1daad3d2aacf48c5(val)) {
                (0, $7Y52R.diag).warn("Invalid attribute value set for key: " + key);
                continue;
            }
            if (Array.isArray(val)) out[key] = val.slice();
            else out[key] = val;
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return out;
}
function $1ab200bd53f45a0b$export$d3dd8ead6a0318c3(key) {
    return typeof key === 'string' && key.length > 0;
}
function $1ab200bd53f45a0b$export$1daad3d2aacf48c5(val) {
    if (val == null) return true;
    if (Array.isArray(val)) return $1ab200bd53f45a0b$var$isHomogeneousAttributeValueArray(val);
    return $1ab200bd53f45a0b$var$isValidPrimitiveAttributeValue(val);
}
function $1ab200bd53f45a0b$var$isHomogeneousAttributeValueArray(arr) {
    var e_2, _a;
    var type;
    try {
        for(var arr_1 = $1ab200bd53f45a0b$var$__values(arr), arr_1_1 = arr_1.next(); !arr_1_1.done; arr_1_1 = arr_1.next()){
            var element = arr_1_1.value;
            // null/undefined elements are allowed
            if (element == null) continue;
            if (!type) {
                if ($1ab200bd53f45a0b$var$isValidPrimitiveAttributeValue(element)) {
                    type = typeof element;
                    continue;
                }
                // encountered an invalid primitive
                return false;
            }
            if (typeof element === type) continue;
            return false;
        }
    } catch (e_2_1) {
        e_2 = {
            error: e_2_1
        };
    } finally{
        try {
            if (arr_1_1 && !arr_1_1.done && (_a = arr_1.return)) _a.call(arr_1);
        } finally{
            if (e_2) throw e_2.error;
        }
    }
    return true;
}
function $1ab200bd53f45a0b$var$isValidPrimitiveAttributeValue(val) {
    switch(typeof val){
        case 'number':
        case 'boolean':
        case 'string':
            return true;
    }
    return false;
}

});

parcelRegister("bxflq", function(module, exports) {

$parcel$export(module.exports, "Span", function () { return $865eade59c4b025c$export$5f1714a13ed34c01; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ parcelRequire("ckckF");
var $7Y52R = parcelRequire("7Y52R");
var $3UoQo = parcelRequire("3UoQo");

var $jL8hu = parcelRequire("jL8hu");
var $2i66W = parcelRequire("2i66W");
var $77Kiv = parcelRequire("77Kiv");

var $7XDeR = parcelRequire("7XDeR");

var $01Syj = parcelRequire("01Syj");
var $865eade59c4b025c$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $865eade59c4b025c$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $865eade59c4b025c$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * This class represents a span.
 */ var $865eade59c4b025c$export$5f1714a13ed34c01 = /** @class */ function() {
    /**
     * Constructs a new Span instance.
     *
     * @deprecated calling Span constructor directly is not supported. Please use tracer.startSpan.
     * */ function Span(parentTracer, context, spanName, spanContext, kind, parentSpanId, links, startTime, _deprecatedClock, attributes) {
        if (links === void 0) links = [];
        this.attributes = {};
        this.links = [];
        this.events = [];
        this._droppedAttributesCount = 0;
        this._droppedEventsCount = 0;
        this._droppedLinksCount = 0;
        this.status = {
            code: (0, $3UoQo.SpanStatusCode).UNSET
        };
        this.endTime = [
            0,
            0
        ];
        this._ended = false;
        this._duration = [
            -1,
            -1
        ];
        this.name = spanName;
        this._spanContext = spanContext;
        this.parentSpanId = parentSpanId;
        this.kind = kind;
        this.links = links;
        var now = Date.now();
        this._performanceStartTime = (0, $77Kiv.otperformance).now();
        this._performanceOffset = now - (this._performanceStartTime + (0, $jL8hu.getTimeOrigin)());
        this._startTimeProvided = startTime != null;
        this.startTime = this._getTime(startTime !== null && startTime !== void 0 ? startTime : now);
        this.resource = parentTracer.resource;
        this.instrumentationLibrary = parentTracer.instrumentationLibrary;
        this._spanLimits = parentTracer.getSpanLimits();
        this._attributeValueLengthLimit = this._spanLimits.attributeValueLengthLimit || 0;
        if (attributes != null) this.setAttributes(attributes);
        this._spanProcessor = parentTracer.getActiveSpanProcessor();
        this._spanProcessor.onStart(this, context);
    }
    Span.prototype.spanContext = function() {
        return this._spanContext;
    };
    Span.prototype.setAttribute = function(key, value) {
        if (value == null || this._isSpanEnded()) return this;
        if (key.length === 0) {
            (0, $7Y52R.diag).warn("Invalid attribute key: " + key);
            return this;
        }
        if (!(0, $2i66W.isAttributeValue)(value)) {
            (0, $7Y52R.diag).warn("Invalid attribute value set for key: " + key);
            return this;
        }
        if (Object.keys(this.attributes).length >= this._spanLimits.attributeCountLimit && !Object.prototype.hasOwnProperty.call(this.attributes, key)) {
            this._droppedAttributesCount++;
            return this;
        }
        this.attributes[key] = this._truncateToSize(value);
        return this;
    };
    Span.prototype.setAttributes = function(attributes) {
        var e_1, _a;
        try {
            for(var _b = $865eade59c4b025c$var$__values(Object.entries(attributes)), _c = _b.next(); !_c.done; _c = _b.next()){
                var _d = $865eade59c4b025c$var$__read(_c.value, 2), k = _d[0], v = _d[1];
                this.setAttribute(k, v);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return this;
    };
    /**
     *
     * @param name Span Name
     * @param [attributesOrStartTime] Span attributes or start time
     *     if type is {@type TimeInput} and 3rd param is undefined
     * @param [timeStamp] Specified time stamp for the event
     */ Span.prototype.addEvent = function(name, attributesOrStartTime, timeStamp) {
        if (this._isSpanEnded()) return this;
        if (this._spanLimits.eventCountLimit === 0) {
            (0, $7Y52R.diag).warn('No events allowed.');
            this._droppedEventsCount++;
            return this;
        }
        if (this.events.length >= this._spanLimits.eventCountLimit) {
            if (this._droppedEventsCount === 0) (0, $7Y52R.diag).debug('Dropping extra events.');
            this.events.shift();
            this._droppedEventsCount++;
        }
        if ((0, $jL8hu.isTimeInput)(attributesOrStartTime)) {
            if (!(0, $jL8hu.isTimeInput)(timeStamp)) timeStamp = attributesOrStartTime;
            attributesOrStartTime = undefined;
        }
        var attributes = (0, $2i66W.sanitizeAttributes)(attributesOrStartTime);
        this.events.push({
            name: name,
            attributes: attributes,
            time: this._getTime(timeStamp),
            droppedAttributesCount: 0
        });
        return this;
    };
    Span.prototype.addLink = function(link) {
        this.links.push(link);
        return this;
    };
    Span.prototype.addLinks = function(links) {
        var _a;
        (_a = this.links).push.apply(_a, $865eade59c4b025c$var$__spreadArray([], $865eade59c4b025c$var$__read(links), false));
        return this;
    };
    Span.prototype.setStatus = function(status) {
        if (this._isSpanEnded()) return this;
        this.status = status;
        return this;
    };
    Span.prototype.updateName = function(name) {
        if (this._isSpanEnded()) return this;
        this.name = name;
        return this;
    };
    Span.prototype.end = function(endTime) {
        if (this._isSpanEnded()) {
            (0, $7Y52R.diag).error(this.name + " " + this._spanContext.traceId + "-" + this._spanContext.spanId + " - You can only call end() on a span once.");
            return;
        }
        this._ended = true;
        this.endTime = this._getTime(endTime);
        this._duration = (0, $jL8hu.hrTimeDuration)(this.startTime, this.endTime);
        if (this._duration[0] < 0) {
            (0, $7Y52R.diag).warn('Inconsistent start and end time, startTime > endTime. Setting span duration to 0ms.', this.startTime, this.endTime);
            this.endTime = this.startTime.slice();
            this._duration = [
                0,
                0
            ];
        }
        if (this._droppedEventsCount > 0) (0, $7Y52R.diag).warn("Dropped " + this._droppedEventsCount + " events because eventCountLimit reached");
        this._spanProcessor.onEnd(this);
    };
    Span.prototype._getTime = function(inp) {
        if (typeof inp === 'number' && inp < (0, $77Kiv.otperformance).now()) // must be a performance timestamp
        // apply correction and convert to hrtime
        return (0, $jL8hu.hrTime)(inp + this._performanceOffset);
        if (typeof inp === 'number') return (0, $jL8hu.millisToHrTime)(inp);
        if (inp instanceof Date) return (0, $jL8hu.millisToHrTime)(inp.getTime());
        if ((0, $jL8hu.isTimeInputHrTime)(inp)) return inp;
        if (this._startTimeProvided) // if user provided a time for the start manually
        // we can't use duration to calculate event/end times
        return (0, $jL8hu.millisToHrTime)(Date.now());
        var msDuration = (0, $77Kiv.otperformance).now() - this._performanceStartTime;
        return (0, $jL8hu.addHrTimes)(this.startTime, (0, $jL8hu.millisToHrTime)(msDuration));
    };
    Span.prototype.isRecording = function() {
        return this._ended === false;
    };
    Span.prototype.recordException = function(exception, time) {
        var attributes = {};
        if (typeof exception === 'string') attributes[0, $7XDeR.SEMATTRS_EXCEPTION_MESSAGE] = exception;
        else if (exception) {
            if (exception.code) attributes[0, $7XDeR.SEMATTRS_EXCEPTION_TYPE] = exception.code.toString();
            else if (exception.name) attributes[0, $7XDeR.SEMATTRS_EXCEPTION_TYPE] = exception.name;
            if (exception.message) attributes[0, $7XDeR.SEMATTRS_EXCEPTION_MESSAGE] = exception.message;
            if (exception.stack) attributes[0, $7XDeR.SEMATTRS_EXCEPTION_STACKTRACE] = exception.stack;
        }
        // these are minimum requirements from spec
        if (attributes[0, $7XDeR.SEMATTRS_EXCEPTION_TYPE] || attributes[0, $7XDeR.SEMATTRS_EXCEPTION_MESSAGE]) this.addEvent((0, $01Syj.ExceptionEventName), attributes, time);
        else (0, $7Y52R.diag).warn("Failed to record an exception " + exception);
    };
    Object.defineProperty(Span.prototype, "duration", {
        get: function() {
            return this._duration;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Span.prototype, "ended", {
        get: function() {
            return this._ended;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Span.prototype, "droppedAttributesCount", {
        get: function() {
            return this._droppedAttributesCount;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Span.prototype, "droppedEventsCount", {
        get: function() {
            return this._droppedEventsCount;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Span.prototype, "droppedLinksCount", {
        get: function() {
            return this._droppedLinksCount;
        },
        enumerable: false,
        configurable: true
    });
    Span.prototype._isSpanEnded = function() {
        if (this._ended) (0, $7Y52R.diag).warn("Can not execute the operation on ended Span {traceId: " + this._spanContext.traceId + ", spanId: " + this._spanContext.spanId + "}");
        return this._ended;
    };
    // Utility function to truncate given value within size
    // for value type of string, will truncate to given limit
    // for type of non-string, will return same value
    Span.prototype._truncateToLimitUtil = function(value, limit) {
        if (value.length <= limit) return value;
        return value.substr(0, limit);
    };
    /**
     * If the given attribute value is of type string and has more characters than given {@code attributeValueLengthLimit} then
     * return string with truncated to {@code attributeValueLengthLimit} characters
     *
     * If the given attribute value is array of strings then
     * return new array of strings with each element truncated to {@code attributeValueLengthLimit} characters
     *
     * Otherwise return same Attribute {@code value}
     *
     * @param value Attribute value
     * @returns truncated attribute value if required, otherwise same value
     */ Span.prototype._truncateToSize = function(value) {
        var _this = this;
        var limit = this._attributeValueLengthLimit;
        // Check limit
        if (limit <= 0) {
            // Negative values are invalid, so do not truncate
            (0, $7Y52R.diag).warn("Attribute value limit must be positive, got " + limit);
            return value;
        }
        // String
        if (typeof value === 'string') return this._truncateToLimitUtil(value, limit);
        // Array of strings
        if (Array.isArray(value)) return value.map(function(val) {
            return typeof val === 'string' ? _this._truncateToLimitUtil(val, limit) : val;
        });
        // Other types, no need to apply value length limit
        return value;
    };
    return Span;
}();

});
parcelRegister("01Syj", function(module, exports) {

$parcel$export(module.exports, "ExceptionEventName", function () { return $005a69188b6039ec$export$a0fff09a5370d06f; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Event name definitions
var $005a69188b6039ec$export$a0fff09a5370d06f = 'exception';

});


parcelRegister("jxLjW", function(module, exports) {

$parcel$export(module.exports, "mergeConfig", function () { return $e3a5ce46a1100ba7$export$7ec1ebcfa9d8bd6a; });
$parcel$export(module.exports, "reconfigureLimits", function () { return $e3a5ce46a1100ba7$export$9f9fb435f8494555; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $iwVME = parcelRequire("iwVME");

var $88zmq = parcelRequire("88zmq");
var $d2oti = parcelRequire("d2oti");
function $e3a5ce46a1100ba7$export$7ec1ebcfa9d8bd6a(userConfig) {
    var perInstanceDefaults = {
        sampler: (0, $iwVME.buildSamplerFromEnv)()
    };
    var DEFAULT_CONFIG = (0, $iwVME.loadDefaultConfig)();
    var target = Object.assign({}, DEFAULT_CONFIG, perInstanceDefaults, userConfig);
    target.generalLimits = Object.assign({}, DEFAULT_CONFIG.generalLimits, userConfig.generalLimits || {});
    target.spanLimits = Object.assign({}, DEFAULT_CONFIG.spanLimits, userConfig.spanLimits || {});
    return target;
}
function $e3a5ce46a1100ba7$export$9f9fb435f8494555(userConfig) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    var spanLimits = Object.assign({}, userConfig.spanLimits);
    var parsedEnvConfig = (0, $d2oti.getEnvWithoutDefaults)();
    /**
     * Reassign span attribute count limit to use first non null value defined by user or use default value
     */ spanLimits.attributeCountLimit = (_f = (_e = (_d = (_b = (_a = userConfig.spanLimits) === null || _a === void 0 ? void 0 : _a.attributeCountLimit) !== null && _b !== void 0 ? _b : (_c = userConfig.generalLimits) === null || _c === void 0 ? void 0 : _c.attributeCountLimit) !== null && _d !== void 0 ? _d : parsedEnvConfig.OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT) !== null && _e !== void 0 ? _e : parsedEnvConfig.OTEL_ATTRIBUTE_COUNT_LIMIT) !== null && _f !== void 0 ? _f : (0, $88zmq.DEFAULT_ATTRIBUTE_COUNT_LIMIT);
    /**
     * Reassign span attribute value length limit to use first non null value defined by user or use default value
     */ spanLimits.attributeValueLengthLimit = (_m = (_l = (_k = (_h = (_g = userConfig.spanLimits) === null || _g === void 0 ? void 0 : _g.attributeValueLengthLimit) !== null && _h !== void 0 ? _h : (_j = userConfig.generalLimits) === null || _j === void 0 ? void 0 : _j.attributeValueLengthLimit) !== null && _k !== void 0 ? _k : parsedEnvConfig.OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT) !== null && _l !== void 0 ? _l : parsedEnvConfig.OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT) !== null && _m !== void 0 ? _m : (0, $88zmq.DEFAULT_ATTRIBUTE_VALUE_LENGTH_LIMIT);
    return Object.assign({}, userConfig, {
        spanLimits: spanLimits
    });
}

});
parcelRegister("iwVME", function(module, exports) {

$parcel$export(module.exports, "loadDefaultConfig", function () { return $d7d809d0c0cdb6f2$export$d25a2c2f78a5e968; });
$parcel$export(module.exports, "buildSamplerFromEnv", function () { return $d7d809d0c0cdb6f2$export$534308d7e73f0e71; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ parcelRequire("ckckF");
var $7Y52R = parcelRequire("7Y52R");

var $d2oti = parcelRequire("d2oti");
var $dxcBp = parcelRequire("dxcBp");

var $ktZjs = parcelRequire("ktZjs");

var $3eG03 = parcelRequire("3eG03");

var $aVuOc = parcelRequire("aVuOc");

var $3GSZO = parcelRequire("3GSZO");
var $d7d809d0c0cdb6f2$var$env = (0, $d2oti.getEnv)();
var $d7d809d0c0cdb6f2$var$FALLBACK_OTEL_TRACES_SAMPLER = (0, $dxcBp.TracesSamplerValues).AlwaysOn;
var $d7d809d0c0cdb6f2$var$DEFAULT_RATIO = 1;
function $d7d809d0c0cdb6f2$export$d25a2c2f78a5e968() {
    return {
        sampler: $d7d809d0c0cdb6f2$export$534308d7e73f0e71($d7d809d0c0cdb6f2$var$env),
        forceFlushTimeoutMillis: 30000,
        generalLimits: {
            attributeValueLengthLimit: (0, $d2oti.getEnv)().OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT,
            attributeCountLimit: (0, $d2oti.getEnv)().OTEL_ATTRIBUTE_COUNT_LIMIT
        },
        spanLimits: {
            attributeValueLengthLimit: (0, $d2oti.getEnv)().OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT,
            attributeCountLimit: (0, $d2oti.getEnv)().OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT,
            linkCountLimit: (0, $d2oti.getEnv)().OTEL_SPAN_LINK_COUNT_LIMIT,
            eventCountLimit: (0, $d2oti.getEnv)().OTEL_SPAN_EVENT_COUNT_LIMIT,
            attributePerEventCountLimit: (0, $d2oti.getEnv)().OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT,
            attributePerLinkCountLimit: (0, $d2oti.getEnv)().OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT
        }
    };
}
function $d7d809d0c0cdb6f2$export$534308d7e73f0e71(environment) {
    if (environment === void 0) environment = (0, $d2oti.getEnv)();
    switch(environment.OTEL_TRACES_SAMPLER){
        case (0, $dxcBp.TracesSamplerValues).AlwaysOn:
            return new (0, $3eG03.AlwaysOnSampler)();
        case (0, $dxcBp.TracesSamplerValues).AlwaysOff:
            return new (0, $ktZjs.AlwaysOffSampler)();
        case (0, $dxcBp.TracesSamplerValues).ParentBasedAlwaysOn:
            return new (0, $aVuOc.ParentBasedSampler)({
                root: new (0, $3eG03.AlwaysOnSampler)()
            });
        case (0, $dxcBp.TracesSamplerValues).ParentBasedAlwaysOff:
            return new (0, $aVuOc.ParentBasedSampler)({
                root: new (0, $ktZjs.AlwaysOffSampler)()
            });
        case (0, $dxcBp.TracesSamplerValues).TraceIdRatio:
            return new (0, $3GSZO.TraceIdRatioBasedSampler)($d7d809d0c0cdb6f2$var$getSamplerProbabilityFromEnv(environment));
        case (0, $dxcBp.TracesSamplerValues).ParentBasedTraceIdRatio:
            return new (0, $aVuOc.ParentBasedSampler)({
                root: new (0, $3GSZO.TraceIdRatioBasedSampler)($d7d809d0c0cdb6f2$var$getSamplerProbabilityFromEnv(environment))
            });
        default:
            (0, $7Y52R.diag).error("OTEL_TRACES_SAMPLER value \"" + environment.OTEL_TRACES_SAMPLER + " invalid, defaulting to " + $d7d809d0c0cdb6f2$var$FALLBACK_OTEL_TRACES_SAMPLER + "\".");
            return new (0, $3eG03.AlwaysOnSampler)();
    }
}
function $d7d809d0c0cdb6f2$var$getSamplerProbabilityFromEnv(environment) {
    if (environment.OTEL_TRACES_SAMPLER_ARG === undefined || environment.OTEL_TRACES_SAMPLER_ARG === '') {
        (0, $7Y52R.diag).error("OTEL_TRACES_SAMPLER_ARG is blank, defaulting to " + $d7d809d0c0cdb6f2$var$DEFAULT_RATIO + ".");
        return $d7d809d0c0cdb6f2$var$DEFAULT_RATIO;
    }
    var probability = Number(environment.OTEL_TRACES_SAMPLER_ARG);
    if (isNaN(probability)) {
        (0, $7Y52R.diag).error("OTEL_TRACES_SAMPLER_ARG=" + environment.OTEL_TRACES_SAMPLER_ARG + " was given, but it is invalid, defaulting to " + $d7d809d0c0cdb6f2$var$DEFAULT_RATIO + ".");
        return $d7d809d0c0cdb6f2$var$DEFAULT_RATIO;
    }
    if (probability < 0 || probability > 1) {
        (0, $7Y52R.diag).error("OTEL_TRACES_SAMPLER_ARG=" + environment.OTEL_TRACES_SAMPLER_ARG + " was given, but it is out of range ([0..1]), defaulting to " + $d7d809d0c0cdb6f2$var$DEFAULT_RATIO + ".");
        return $d7d809d0c0cdb6f2$var$DEFAULT_RATIO;
    }
    return probability;
}

});
parcelRegister("ktZjs", function(module, exports) {

$parcel$export(module.exports, "AlwaysOffSampler", function () { return $ee961388729a5f82$export$abc5f11618c4d6a3; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $3ALgF = parcelRequire("3ALgF");
/** Sampler that samples no traces. */ var $ee961388729a5f82$export$abc5f11618c4d6a3 = /** @class */ function() {
    function AlwaysOffSampler() {}
    AlwaysOffSampler.prototype.shouldSample = function() {
        return {
            decision: (0, $3ALgF.SamplingDecision).NOT_RECORD
        };
    };
    AlwaysOffSampler.prototype.toString = function() {
        return 'AlwaysOffSampler';
    };
    return AlwaysOffSampler;
}();

});

parcelRegister("aVuOc", function(module, exports) {

$parcel$export(module.exports, "ParentBasedSampler", function () { return $7f4720374133ea40$export$2bc0b1b09c2e3b47; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $laija = parcelRequire("laija");parcelRequire("ckckF");
var $g4DKS = parcelRequire("g4DKS");
var $kxoQ4 = parcelRequire("kxoQ4");

var $5ytUs = parcelRequire("5ytUs");

var $ktZjs = parcelRequire("ktZjs");

var $3eG03 = parcelRequire("3eG03");
/**
 * A composite sampler that either respects the parent span's sampling decision
 * or delegates to `delegateSampler` for root spans.
 */ var $7f4720374133ea40$export$2bc0b1b09c2e3b47 = /** @class */ function() {
    function ParentBasedSampler(config) {
        var _a, _b, _c, _d;
        this._root = config.root;
        if (!this._root) {
            (0, $5ytUs.globalErrorHandler)(new Error('ParentBasedSampler must have a root sampler configured'));
            this._root = new (0, $3eG03.AlwaysOnSampler)();
        }
        this._remoteParentSampled = (_a = config.remoteParentSampled) !== null && _a !== void 0 ? _a : new (0, $3eG03.AlwaysOnSampler)();
        this._remoteParentNotSampled = (_b = config.remoteParentNotSampled) !== null && _b !== void 0 ? _b : new (0, $ktZjs.AlwaysOffSampler)();
        this._localParentSampled = (_c = config.localParentSampled) !== null && _c !== void 0 ? _c : new (0, $3eG03.AlwaysOnSampler)();
        this._localParentNotSampled = (_d = config.localParentNotSampled) !== null && _d !== void 0 ? _d : new (0, $ktZjs.AlwaysOffSampler)();
    }
    ParentBasedSampler.prototype.shouldSample = function(context, traceId, spanName, spanKind, attributes, links) {
        var parentContext = (0, $g4DKS.trace).getSpanContext(context);
        if (!parentContext || !(0, $laija.isSpanContextValid)(parentContext)) return this._root.shouldSample(context, traceId, spanName, spanKind, attributes, links);
        if (parentContext.isRemote) {
            if (parentContext.traceFlags & (0, $kxoQ4.TraceFlags).SAMPLED) return this._remoteParentSampled.shouldSample(context, traceId, spanName, spanKind, attributes, links);
            return this._remoteParentNotSampled.shouldSample(context, traceId, spanName, spanKind, attributes, links);
        }
        if (parentContext.traceFlags & (0, $kxoQ4.TraceFlags).SAMPLED) return this._localParentSampled.shouldSample(context, traceId, spanName, spanKind, attributes, links);
        return this._localParentNotSampled.shouldSample(context, traceId, spanName, spanKind, attributes, links);
    };
    ParentBasedSampler.prototype.toString = function() {
        return "ParentBased{root=" + this._root.toString() + ", remoteParentSampled=" + this._remoteParentSampled.toString() + ", remoteParentNotSampled=" + this._remoteParentNotSampled.toString() + ", localParentSampled=" + this._localParentSampled.toString() + ", localParentNotSampled=" + this._localParentNotSampled.toString() + "}";
    };
    return ParentBasedSampler;
}();

});

parcelRegister("3GSZO", function(module, exports) {

$parcel$export(module.exports, "TraceIdRatioBasedSampler", function () { return $2afff4623ecbea1f$export$f1624f887f708bbf; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $laija = parcelRequire("laija");

var $3ALgF = parcelRequire("3ALgF");
/** Sampler that samples a given fraction of traces based of trace id deterministically. */ var $2afff4623ecbea1f$export$f1624f887f708bbf = /** @class */ function() {
    function TraceIdRatioBasedSampler(_ratio) {
        if (_ratio === void 0) _ratio = 0;
        this._ratio = _ratio;
        this._ratio = this._normalize(_ratio);
        this._upperBound = Math.floor(this._ratio * 0xffffffff);
    }
    TraceIdRatioBasedSampler.prototype.shouldSample = function(context, traceId) {
        return {
            decision: (0, $laija.isValidTraceId)(traceId) && this._accumulate(traceId) < this._upperBound ? (0, $3ALgF.SamplingDecision).RECORD_AND_SAMPLED : (0, $3ALgF.SamplingDecision).NOT_RECORD
        };
    };
    TraceIdRatioBasedSampler.prototype.toString = function() {
        return "TraceIdRatioBased{" + this._ratio + "}";
    };
    TraceIdRatioBasedSampler.prototype._normalize = function(ratio) {
        if (typeof ratio !== 'number' || isNaN(ratio)) return 0;
        return ratio >= 1 ? 1 : ratio <= 0 ? 0 : ratio;
    };
    TraceIdRatioBasedSampler.prototype._accumulate = function(traceId) {
        var accumulation = 0;
        for(var i = 0; i < traceId.length / 8; i++){
            var pos = i * 8;
            var part = parseInt(traceId.slice(pos, pos + 8), 16);
            accumulation = (accumulation ^ part) >>> 0;
        }
        return accumulation;
    };
    return TraceIdRatioBasedSampler;
}();

});



parcelRegister("cPLNF", function(module, exports) {

$parcel$export(module.exports, "RandomIdGenerator", function () { return $957f538b155925fb$export$97307207ef48da75; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $957f538b155925fb$var$SPAN_ID_BYTES = 8;
var $957f538b155925fb$var$TRACE_ID_BYTES = 16;
var $957f538b155925fb$export$97307207ef48da75 = /** @class */ function() {
    function RandomIdGenerator() {
        /**
         * Returns a random 16-byte trace ID formatted/encoded as a 32 lowercase hex
         * characters corresponding to 128 bits.
         */ this.generateTraceId = $957f538b155925fb$var$getIdGenerator($957f538b155925fb$var$TRACE_ID_BYTES);
        /**
         * Returns a random 8-byte span ID formatted/encoded as a 16 lowercase hex
         * characters corresponding to 64 bits.
         */ this.generateSpanId = $957f538b155925fb$var$getIdGenerator($957f538b155925fb$var$SPAN_ID_BYTES);
    }
    return RandomIdGenerator;
}();
var $957f538b155925fb$var$SHARED_CHAR_CODES_ARRAY = Array(32);
function $957f538b155925fb$var$getIdGenerator(bytes) {
    return function generateId() {
        for(var i = 0; i < bytes * 2; i++){
            $957f538b155925fb$var$SHARED_CHAR_CODES_ARRAY[i] = Math.floor(Math.random() * 16) + 48;
            // valid hex characters in the range 48-57 and 97-102
            if ($957f538b155925fb$var$SHARED_CHAR_CODES_ARRAY[i] >= 58) $957f538b155925fb$var$SHARED_CHAR_CODES_ARRAY[i] += 39;
        }
        return String.fromCharCode.apply(null, $957f538b155925fb$var$SHARED_CHAR_CODES_ARRAY.slice(0, bytes * 2));
    };
}

});


parcelRegister("k2jVS", function(module, exports) {

$parcel$export(module.exports, "MultiSpanProcessor", function () { return $e96374b5367c094c$export$3012fe5a49154394; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $5ytUs = parcelRequire("5ytUs");
var $e96374b5367c094c$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/**
 * Implementation of the {@link SpanProcessor} that simply forwards all
 * received events to a list of {@link SpanProcessor}s.
 */ var $e96374b5367c094c$export$3012fe5a49154394 = /** @class */ function() {
    function MultiSpanProcessor(_spanProcessors) {
        this._spanProcessors = _spanProcessors;
    }
    MultiSpanProcessor.prototype.forceFlush = function() {
        var e_1, _a;
        var promises = [];
        try {
            for(var _b = $e96374b5367c094c$var$__values(this._spanProcessors), _c = _b.next(); !_c.done; _c = _b.next()){
                var spanProcessor = _c.value;
                promises.push(spanProcessor.forceFlush());
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return new Promise(function(resolve) {
            Promise.all(promises).then(function() {
                resolve();
            }).catch(function(error) {
                (0, $5ytUs.globalErrorHandler)(error || new Error('MultiSpanProcessor: forceFlush failed'));
                resolve();
            });
        });
    };
    MultiSpanProcessor.prototype.onStart = function(span, context) {
        var e_2, _a;
        try {
            for(var _b = $e96374b5367c094c$var$__values(this._spanProcessors), _c = _b.next(); !_c.done; _c = _b.next()){
                var spanProcessor = _c.value;
                spanProcessor.onStart(span, context);
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
    };
    MultiSpanProcessor.prototype.onEnd = function(span) {
        var e_3, _a;
        try {
            for(var _b = $e96374b5367c094c$var$__values(this._spanProcessors), _c = _b.next(); !_c.done; _c = _b.next()){
                var spanProcessor = _c.value;
                spanProcessor.onEnd(span);
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
    };
    MultiSpanProcessor.prototype.shutdown = function() {
        var e_4, _a;
        var promises = [];
        try {
            for(var _b = $e96374b5367c094c$var$__values(this._spanProcessors), _c = _b.next(); !_c.done; _c = _b.next()){
                var spanProcessor = _c.value;
                promises.push(spanProcessor.shutdown());
            }
        } catch (e_4_1) {
            e_4 = {
                error: e_4_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_4) throw e_4.error;
            }
        }
        return new Promise(function(resolve, reject) {
            Promise.all(promises).then(function() {
                resolve();
            }, reject);
        });
    };
    return MultiSpanProcessor;
}();

});

parcelRegister("bfDTQ", function(module, exports) {

$parcel$export(module.exports, "NoopSpanProcessor", function () { return $83100baf0a143807$export$27767823ad33d189; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** No-op implementation of SpanProcessor */ var $83100baf0a143807$export$27767823ad33d189 = /** @class */ function() {
    function NoopSpanProcessor() {}
    NoopSpanProcessor.prototype.onStart = function(_span, _context) {};
    NoopSpanProcessor.prototype.onEnd = function(_span) {};
    NoopSpanProcessor.prototype.shutdown = function() {
        return Promise.resolve();
    };
    NoopSpanProcessor.prototype.forceFlush = function() {
        return Promise.resolve();
    };
    return NoopSpanProcessor;
}();

});


parcelRegister("5tvc5", function(module, exports) {

$parcel$export(module.exports, "StackContextManager", function () { return $3fc7dba7fba38756$export$3dfe62dd209faf13; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $jVu0G = parcelRequire("jVu0G");
var $3fc7dba7fba38756$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $3fc7dba7fba38756$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * Stack Context Manager for managing the state in web
 * it doesn't fully support the async calls though
 */ var $3fc7dba7fba38756$export$3dfe62dd209faf13 = /** @class */ function() {
    function StackContextManager() {
        /**
         * whether the context manager is enabled or not
         */ this._enabled = false;
        /**
         * Keeps the reference to current context
         */ this._currentContext = (0, $jVu0G.ROOT_CONTEXT);
    }
    /**
     *
     * @param context
     * @param target Function to be executed within the context
     */ // eslint-disable-next-line @typescript-eslint/ban-types
    StackContextManager.prototype._bindFunction = function(context, target) {
        if (context === void 0) context = (0, $jVu0G.ROOT_CONTEXT);
        var manager = this;
        var contextWrapper = function() {
            var _this = this;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return manager.with(context, function() {
                return target.apply(_this, args);
            });
        };
        Object.defineProperty(contextWrapper, 'length', {
            enumerable: false,
            configurable: true,
            writable: false,
            value: target.length
        });
        return contextWrapper;
    };
    /**
     * Returns the active context
     */ StackContextManager.prototype.active = function() {
        return this._currentContext;
    };
    /**
     * Binds a the certain context or the active one to the target function and then returns the target
     * @param context A context (span) to be bind to target
     * @param target a function or event emitter. When target or one of its callbacks is called,
     *  the provided context will be used as the active context for the duration of the call.
     */ StackContextManager.prototype.bind = function(context, target) {
        // if no specific context to propagate is given, we use the current one
        if (context === undefined) context = this.active();
        if (typeof target === 'function') return this._bindFunction(context, target);
        return target;
    };
    /**
     * Disable the context manager (clears the current context)
     */ StackContextManager.prototype.disable = function() {
        this._currentContext = (0, $jVu0G.ROOT_CONTEXT);
        this._enabled = false;
        return this;
    };
    /**
     * Enables the context manager and creates a default(root) context
     */ StackContextManager.prototype.enable = function() {
        if (this._enabled) return this;
        this._enabled = true;
        this._currentContext = (0, $jVu0G.ROOT_CONTEXT);
        return this;
    };
    /**
     * Calls the callback function [fn] with the provided [context]. If [context] is undefined then it will use the window.
     * The context will be set as active
     * @param context
     * @param fn Callback function
     * @param thisArg optional receiver to be used for calling fn
     * @param args optional arguments forwarded to fn
     */ StackContextManager.prototype.with = function(context, fn, thisArg) {
        var args = [];
        for(var _i = 3; _i < arguments.length; _i++)args[_i - 3] = arguments[_i];
        var previousContext = this._currentContext;
        this._currentContext = context || (0, $jVu0G.ROOT_CONTEXT);
        try {
            return fn.call.apply(fn, $3fc7dba7fba38756$var$__spreadArray([
                thisArg
            ], $3fc7dba7fba38756$var$__read(args), false));
        } finally{
            this._currentContext = previousContext;
        }
    };
    return StackContextManager;
}();

});


parcelRegister("fZlMi", function(module, exports) {

$parcel$export(module.exports, "InstrumentationBase", function () { return $0300fdb668b414c9$export$436b1c2bf7e9756b; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $3ESwR = parcelRequire("3ESwR");
var $0300fdb668b414c9$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Base abstract class for instrumenting web plugins
 */ var $0300fdb668b414c9$export$436b1c2bf7e9756b = /** @class */ function(_super) {
    $0300fdb668b414c9$var$__extends(InstrumentationBase, _super);
    function InstrumentationBase(instrumentationName, instrumentationVersion, config) {
        var _this = _super.call(this, instrumentationName, instrumentationVersion, config) || this;
        if (_this._config.enabled) _this.enable();
        return _this;
    }
    return InstrumentationBase;
}((0, $3ESwR.InstrumentationAbstract));

});
parcelRegister("3ESwR", function(module, exports) {

$parcel$export(module.exports, "InstrumentationAbstract", function () { return $2a9f67d6c9d60a52$export$74c31cfd4e541b89; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ parcelRequire("ckckF");
var $7Y52R = parcelRequire("7Y52R");
var $3C1qe = parcelRequire("3C1qe");
var $g4DKS = parcelRequire("g4DKS");

var $gxS2L = parcelRequire("gxS2L");

var $az0Q4 = parcelRequire("az0Q4");
var $2a9f67d6c9d60a52$var$__assign = undefined && undefined.__assign || function() {
    $2a9f67d6c9d60a52$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2a9f67d6c9d60a52$var$__assign.apply(this, arguments);
};
/**
 * Base abstract internal class for instrumenting node and web plugins
 */ var $2a9f67d6c9d60a52$export$74c31cfd4e541b89 = /** @class */ function() {
    function InstrumentationAbstract(instrumentationName, instrumentationVersion, config) {
        this.instrumentationName = instrumentationName;
        this.instrumentationVersion = instrumentationVersion;
        /* Api to wrap instrumented method */ this._wrap = $az0Q4.wrap;
        /* Api to unwrap instrumented methods */ this._unwrap = $az0Q4.unwrap;
        /* Api to mass wrap instrumented method */ this._massWrap = $az0Q4.massWrap;
        /* Api to mass unwrap instrumented methods */ this._massUnwrap = $az0Q4.massUnwrap;
        // copy config first level properties to ensure they are immutable.
        // nested properties are not copied, thus are mutable from the outside.
        this._config = $2a9f67d6c9d60a52$var$__assign({
            enabled: true
        }, config);
        this._diag = (0, $7Y52R.diag).createComponentLogger({
            namespace: instrumentationName
        });
        this._tracer = (0, $g4DKS.trace).getTracer(instrumentationName, instrumentationVersion);
        this._meter = (0, $3C1qe.metrics).getMeter(instrumentationName, instrumentationVersion);
        this._logger = (0, $gxS2L.logs).getLogger(instrumentationName, instrumentationVersion);
        this._updateMetricInstruments();
    }
    Object.defineProperty(InstrumentationAbstract.prototype, "meter", {
        /* Returns meter */ get: function() {
            return this._meter;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Sets MeterProvider to this plugin
     * @param meterProvider
     */ InstrumentationAbstract.prototype.setMeterProvider = function(meterProvider) {
        this._meter = meterProvider.getMeter(this.instrumentationName, this.instrumentationVersion);
        this._updateMetricInstruments();
    };
    Object.defineProperty(InstrumentationAbstract.prototype, "logger", {
        /* Returns logger */ get: function() {
            return this._logger;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Sets LoggerProvider to this plugin
     * @param loggerProvider
     */ InstrumentationAbstract.prototype.setLoggerProvider = function(loggerProvider) {
        this._logger = loggerProvider.getLogger(this.instrumentationName, this.instrumentationVersion);
    };
    /**
     * @experimental
     *
     * Get module definitions defined by {@link init}.
     * This can be used for experimental compile-time instrumentation.
     *
     * @returns an array of {@link InstrumentationModuleDefinition}
     */ InstrumentationAbstract.prototype.getModuleDefinitions = function() {
        var _a;
        var initResult = (_a = this.init()) !== null && _a !== void 0 ? _a : [];
        if (!Array.isArray(initResult)) return [
            initResult
        ];
        return initResult;
    };
    /**
     * Sets the new metric instruments with the current Meter.
     */ InstrumentationAbstract.prototype._updateMetricInstruments = function() {
        return;
    };
    /* Returns InstrumentationConfig */ InstrumentationAbstract.prototype.getConfig = function() {
        return this._config;
    };
    /**
     * Sets InstrumentationConfig to this plugin
     * @param InstrumentationConfig
     */ InstrumentationAbstract.prototype.setConfig = function(config) {
        // copy config first level properties to ensure they are immutable.
        // nested properties are not copied, thus are mutable from the outside.
        this._config = $2a9f67d6c9d60a52$var$__assign({}, config);
    };
    /**
     * Sets TraceProvider to this plugin
     * @param tracerProvider
     */ InstrumentationAbstract.prototype.setTracerProvider = function(tracerProvider) {
        this._tracer = tracerProvider.getTracer(this.instrumentationName, this.instrumentationVersion);
    };
    Object.defineProperty(InstrumentationAbstract.prototype, "tracer", {
        /* Returns tracer */ get: function() {
            return this._tracer;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Execute span customization hook, if configured, and log any errors.
     * Any semantics of the trigger and info are defined by the specific instrumentation.
     * @param hookHandler The optional hook handler which the user has configured via instrumentation config
     * @param triggerName The name of the trigger for executing the hook for logging purposes
     * @param span The span to which the hook should be applied
     * @param info The info object to be passed to the hook, with useful data the hook may use
     */ InstrumentationAbstract.prototype._runSpanCustomizationHook = function(hookHandler, triggerName, span, info) {
        if (!hookHandler) return;
        try {
            hookHandler(span, info);
        } catch (e) {
            this._diag.error("Error running span customization hook due to exception in handler", {
                triggerName: triggerName
            }, e);
        }
    };
    return InstrumentationAbstract;
}();

});
parcelRegister("gxS2L", function(module, exports) {

$parcel$export(module.exports, "logs", function () { return $c0b9a657fd91d650$export$fa0831f497706bad; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 







var $bCyKg = parcelRequire("bCyKg");
var $c0b9a657fd91d650$export$fa0831f497706bad = (0, $bCyKg.LogsAPI).getInstance();

});
parcelRegister("bCyKg", function(module, exports) {

$parcel$export(module.exports, "LogsAPI", function () { return $875e31f7d1984e60$export$f8e63508eb6a0fc1; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $3pQZt = parcelRequire("3pQZt");

var $8KV0T = parcelRequire("8KV0T");
var $875e31f7d1984e60$export$f8e63508eb6a0fc1 = /** @class */ function() {
    function LogsAPI() {}
    LogsAPI.getInstance = function() {
        if (!this._instance) this._instance = new LogsAPI();
        return this._instance;
    };
    LogsAPI.prototype.setGlobalLoggerProvider = function(provider) {
        if ((0, $3pQZt._global)[0, $3pQZt.GLOBAL_LOGS_API_KEY]) return this.getLoggerProvider();
        (0, $3pQZt._global)[0, $3pQZt.GLOBAL_LOGS_API_KEY] = (0, $3pQZt.makeGetter)((0, $3pQZt.API_BACKWARDS_COMPATIBILITY_VERSION), provider, (0, $8KV0T.NOOP_LOGGER_PROVIDER));
        return provider;
    };
    /**
     * Returns the global logger provider.
     *
     * @returns LoggerProvider
     */ LogsAPI.prototype.getLoggerProvider = function() {
        var _a, _b;
        return (_b = (_a = (0, $3pQZt._global)[0, $3pQZt.GLOBAL_LOGS_API_KEY]) === null || _a === void 0 ? void 0 : _a.call((0, $3pQZt._global), (0, $3pQZt.API_BACKWARDS_COMPATIBILITY_VERSION))) !== null && _b !== void 0 ? _b : (0, $8KV0T.NOOP_LOGGER_PROVIDER);
    };
    /**
     * Returns a logger from the global logger provider.
     *
     * @returns Logger
     */ LogsAPI.prototype.getLogger = function(name, version, options) {
        return this.getLoggerProvider().getLogger(name, version, options);
    };
    /** Remove the global logger provider */ LogsAPI.prototype.disable = function() {
        delete (0, $3pQZt._global)[0, $3pQZt.GLOBAL_LOGS_API_KEY];
    };
    return LogsAPI;
}();

});
parcelRegister("3pQZt", function(module, exports) {

$parcel$export(module.exports, "GLOBAL_LOGS_API_KEY", function () { return $27cccfb0b2bca05b$export$be5e405504011951; });
$parcel$export(module.exports, "_global", function () { return $27cccfb0b2bca05b$export$fb1208122242c205; });
$parcel$export(module.exports, "makeGetter", function () { return $27cccfb0b2bca05b$export$bf9e00ce1090794f; });
$parcel$export(module.exports, "API_BACKWARDS_COMPATIBILITY_VERSION", function () { return $27cccfb0b2bca05b$export$41e8763f7160bb4; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $jiW00 = parcelRequire("jiW00");
var $27cccfb0b2bca05b$export$be5e405504011951 = Symbol.for('io.opentelemetry.js.api.logs');
var $27cccfb0b2bca05b$export$fb1208122242c205 = (0, $jiW00._globalThis);
function $27cccfb0b2bca05b$export$bf9e00ce1090794f(requiredVersion, instance, fallback) {
    return function(version) {
        return version === requiredVersion ? instance : fallback;
    };
}
var $27cccfb0b2bca05b$export$41e8763f7160bb4 = 1;

});
parcelRegister("jiW00", function(module, exports) {

$parcel$export(module.exports, "_globalThis", function () { return $e0dcb0309bfff638$export$5c524ddf7208c00c; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Updates to this file should also be replicated to @opentelemetry/api and
// @opentelemetry/core too.
/**
 * - globalThis (New standard)
 * - self (Will return the current window instance for supported browsers)
 * - window (fallback for older browser implementations)
 * - global (NodeJS implementation)
 * - <object> (When all else fails)
 */ /** only globals that common to node and browsers are allowed */ // eslint-disable-next-line node/no-unsupported-features/es-builtins, no-undef
var $e0dcb0309bfff638$export$5c524ddf7208c00c = typeof globalThis === 'object' ? globalThis : typeof self === 'object' ? self : typeof window === 'object' ? window : typeof $parcel$global === 'object' ? $parcel$global : {};

});


parcelRegister("8KV0T", function(module, exports) {

$parcel$export(module.exports, "NOOP_LOGGER_PROVIDER", function () { return $65fed84695679bc7$export$ade97358fd6ba8df; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gugHP = parcelRequire("gugHP");
var $65fed84695679bc7$export$8d7f6fb42e615208 = /** @class */ function() {
    function NoopLoggerProvider() {}
    NoopLoggerProvider.prototype.getLogger = function(_name, _version, _options) {
        return new (0, $gugHP.NoopLogger)();
    };
    return NoopLoggerProvider;
}();
var $65fed84695679bc7$export$ade97358fd6ba8df = new $65fed84695679bc7$export$8d7f6fb42e615208();

});
parcelRegister("gugHP", function(module, exports) {

$parcel$export(module.exports, "NoopLogger", function () { return $c00c681ae895e53d$export$d16ba98760c74dd5; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $c00c681ae895e53d$export$d16ba98760c74dd5 = /** @class */ function() {
    function NoopLogger() {}
    NoopLogger.prototype.emit = function(_logRecord) {};
    return NoopLogger;
}();
var $c00c681ae895e53d$export$f5681b99b7ff4eb3 = new $c00c681ae895e53d$export$d16ba98760c74dd5();

});




parcelRegister("az0Q4", function(module, exports) {
'use strict';
function $7b0dd2dc259c0757$var$isFunction(funktion) {
    return typeof funktion === 'function';
}
// Default to complaining loudly when things don't go according to plan.
var $7b0dd2dc259c0757$var$logger = console.error.bind(console);
// Sets a property on an object, preserving its enumerability.
// This function assumes that the property is already writable.
function $7b0dd2dc259c0757$var$defineProperty(obj, name, value) {
    var enumerable = !!obj[name] && obj.propertyIsEnumerable(name);
    Object.defineProperty(obj, name, {
        configurable: true,
        enumerable: enumerable,
        writable: true,
        value: value
    });
}
// Keep initialization idempotent.
function $7b0dd2dc259c0757$var$shimmer(options) {
    if (options && options.logger) {
        if (!$7b0dd2dc259c0757$var$isFunction(options.logger)) $7b0dd2dc259c0757$var$logger("new logger isn't a function, not replacing");
        else $7b0dd2dc259c0757$var$logger = options.logger;
    }
}
function $7b0dd2dc259c0757$var$wrap(nodule, name, wrapper) {
    if (!nodule || !nodule[name]) {
        $7b0dd2dc259c0757$var$logger('no original function ' + name + ' to wrap');
        return;
    }
    if (!wrapper) {
        $7b0dd2dc259c0757$var$logger('no wrapper function');
        $7b0dd2dc259c0757$var$logger(new Error().stack);
        return;
    }
    if (!$7b0dd2dc259c0757$var$isFunction(nodule[name]) || !$7b0dd2dc259c0757$var$isFunction(wrapper)) {
        $7b0dd2dc259c0757$var$logger('original object and wrapper must be functions');
        return;
    }
    var original = nodule[name];
    var wrapped = wrapper(original, name);
    $7b0dd2dc259c0757$var$defineProperty(wrapped, '__original', original);
    $7b0dd2dc259c0757$var$defineProperty(wrapped, '__unwrap', function() {
        if (nodule[name] === wrapped) $7b0dd2dc259c0757$var$defineProperty(nodule, name, original);
    });
    $7b0dd2dc259c0757$var$defineProperty(wrapped, '__wrapped', true);
    $7b0dd2dc259c0757$var$defineProperty(nodule, name, wrapped);
    return wrapped;
}
function $7b0dd2dc259c0757$var$massWrap(nodules, names, wrapper) {
    if (!nodules) {
        $7b0dd2dc259c0757$var$logger('must provide one or more modules to patch');
        $7b0dd2dc259c0757$var$logger(new Error().stack);
        return;
    } else if (!Array.isArray(nodules)) nodules = [
        nodules
    ];
    if (!(names && Array.isArray(names))) {
        $7b0dd2dc259c0757$var$logger('must provide one or more functions to wrap on modules');
        return;
    }
    nodules.forEach(function(nodule) {
        names.forEach(function(name) {
            $7b0dd2dc259c0757$var$wrap(nodule, name, wrapper);
        });
    });
}
function $7b0dd2dc259c0757$var$unwrap(nodule, name) {
    if (!nodule || !nodule[name]) {
        $7b0dd2dc259c0757$var$logger('no function to unwrap.');
        $7b0dd2dc259c0757$var$logger(new Error().stack);
        return;
    }
    if (!nodule[name].__unwrap) $7b0dd2dc259c0757$var$logger('no original to unwrap to -- has ' + name + ' already been unwrapped?');
    else return nodule[name].__unwrap();
}
function $7b0dd2dc259c0757$var$massUnwrap(nodules, names) {
    if (!nodules) {
        $7b0dd2dc259c0757$var$logger('must provide one or more modules to patch');
        $7b0dd2dc259c0757$var$logger(new Error().stack);
        return;
    } else if (!Array.isArray(nodules)) nodules = [
        nodules
    ];
    if (!(names && Array.isArray(names))) {
        $7b0dd2dc259c0757$var$logger('must provide one or more functions to unwrap on modules');
        return;
    }
    nodules.forEach(function(nodule) {
        names.forEach(function(name) {
            $7b0dd2dc259c0757$var$unwrap(nodule, name);
        });
    });
}
$7b0dd2dc259c0757$var$shimmer.wrap = $7b0dd2dc259c0757$var$wrap;
$7b0dd2dc259c0757$var$shimmer.massWrap = $7b0dd2dc259c0757$var$massWrap;
$7b0dd2dc259c0757$var$shimmer.unwrap = $7b0dd2dc259c0757$var$unwrap;
$7b0dd2dc259c0757$var$shimmer.massUnwrap = $7b0dd2dc259c0757$var$massUnwrap;
module.exports = $7b0dd2dc259c0757$var$shimmer;

});



parcelRegister("5i7vv", function(module, exports) {

$parcel$export(module.exports, "registerInstrumentations", function () { return $3da474f55ef7e42d$export$fc0a1ca5231d826a; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ parcelRequire("ckckF");
var $3C1qe = parcelRequire("3C1qe");
var $g4DKS = parcelRequire("g4DKS");

var $gxS2L = parcelRequire("gxS2L");

var $1lPma = parcelRequire("1lPma");
function $3da474f55ef7e42d$export$fc0a1ca5231d826a(options) {
    var _a, _b;
    var tracerProvider = options.tracerProvider || (0, $g4DKS.trace).getTracerProvider();
    var meterProvider = options.meterProvider || (0, $3C1qe.metrics).getMeterProvider();
    var loggerProvider = options.loggerProvider || (0, $gxS2L.logs).getLoggerProvider();
    var instrumentations = (_b = (_a = options.instrumentations) === null || _a === void 0 ? void 0 : _a.flat()) !== null && _b !== void 0 ? _b : [];
    (0, $1lPma.enableInstrumentations)(instrumentations, tracerProvider, meterProvider, loggerProvider);
    return function() {
        (0, $1lPma.disableInstrumentations)(instrumentations);
    };
}

});
parcelRegister("1lPma", function(module, exports) {

$parcel$export(module.exports, "enableInstrumentations", function () { return $0fbf96efec5412fd$export$56a6415128a54b1; });
$parcel$export(module.exports, "disableInstrumentations", function () { return $0fbf96efec5412fd$export$c7d87b302116dc69; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Enable instrumentations
 * @param instrumentations
 * @param tracerProvider
 * @param meterProvider
 */ function $0fbf96efec5412fd$export$56a6415128a54b1(instrumentations, tracerProvider, meterProvider, loggerProvider) {
    for(var i = 0, j = instrumentations.length; i < j; i++){
        var instrumentation = instrumentations[i];
        if (tracerProvider) instrumentation.setTracerProvider(tracerProvider);
        if (meterProvider) instrumentation.setMeterProvider(meterProvider);
        if (loggerProvider && instrumentation.setLoggerProvider) instrumentation.setLoggerProvider(loggerProvider);
        // instrumentations have been already enabled during creation
        // so enable only if user prevented that by setting enabled to false
        // this is to prevent double enabling but when calling register all
        // instrumentations should be now enabled
        if (!instrumentation.getConfig().enabled) instrumentation.enable();
    }
}
function $0fbf96efec5412fd$export$c7d87b302116dc69(instrumentations) {
    instrumentations.forEach(function(instrumentation) {
        return instrumentation.disable();
    });
}

});


parcelRegister("djhfc", function(module, exports) {

(function(root, factory) {
    'use strict';
    // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.
    /* istanbul ignore next */ if (typeof define === 'function' && define.amd) define('error-stack-parser', [
        'stackframe'
    ], factory);
    else module.exports = factory((parcelRequire("b2eXQ")));
})(module.exports, function ErrorStackParser(StackFrame) {
    'use strict';
    var FIREFOX_SAFARI_STACK_REGEXP = /(^|@)\S+:\d+/;
    var CHROME_IE_STACK_REGEXP = /^\s*at .*(\S+:\d+|\(native\))/m;
    var SAFARI_NATIVE_CODE_REGEXP = /^(eval@)?(\[native code])?$/;
    return {
        /**
         * Given an Error object, extract the most information from it.
         *
         * @param {Error} error object
         * @return {Array} of StackFrames
         */ parse: function ErrorStackParser$$parse(error) {
            if (typeof error.stacktrace !== 'undefined' || typeof error['opera#sourceloc'] !== 'undefined') return this.parseOpera(error);
            else if (error.stack && error.stack.match(CHROME_IE_STACK_REGEXP)) return this.parseV8OrIE(error);
            else if (error.stack) return this.parseFFOrSafari(error);
            else throw new Error('Cannot parse given Error object');
        },
        // Separate line and column numbers from a string of the form: (URI:Line:Column)
        extractLocation: function ErrorStackParser$$extractLocation(urlLike) {
            // Fail-fast but return locations like "(native)"
            if (urlLike.indexOf(':') === -1) return [
                urlLike
            ];
            var regExp = /(.+?)(?::(\d+))?(?::(\d+))?$/;
            var parts = regExp.exec(urlLike.replace(/[()]/g, ''));
            return [
                parts[1],
                parts[2] || undefined,
                parts[3] || undefined
            ];
        },
        parseV8OrIE: function ErrorStackParser$$parseV8OrIE(error) {
            var filtered = error.stack.split('\n').filter(function(line) {
                return !!line.match(CHROME_IE_STACK_REGEXP);
            }, this);
            return filtered.map(function(line) {
                if (line.indexOf('(eval ') > -1) // Throw away eval information until we implement stacktrace.js/stackframe#8
                line = line.replace(/eval code/g, 'eval').replace(/(\(eval at [^()]*)|(,.*$)/g, '');
                var sanitizedLine = line.replace(/^\s+/, '').replace(/\(eval code/g, '(').replace(/^.*?\s+/, '');
                // capture and preseve the parenthesized location "(/foo/my bar.js:12:87)" in
                // case it has spaces in it, as the string is split on \s+ later on
                var location = sanitizedLine.match(/ (\(.+\)$)/);
                // remove the parenthesized location from the line, if it was matched
                sanitizedLine = location ? sanitizedLine.replace(location[0], '') : sanitizedLine;
                // if a location was matched, pass it to extractLocation() otherwise pass all sanitizedLine
                // because this line doesn't have function name
                var locationParts = this.extractLocation(location ? location[1] : sanitizedLine);
                var functionName = location && sanitizedLine || undefined;
                var fileName = [
                    'eval',
                    '<anonymous>'
                ].indexOf(locationParts[0]) > -1 ? undefined : locationParts[0];
                return new StackFrame({
                    functionName: functionName,
                    fileName: fileName,
                    lineNumber: locationParts[1],
                    columnNumber: locationParts[2],
                    source: line
                });
            }, this);
        },
        parseFFOrSafari: function ErrorStackParser$$parseFFOrSafari(error) {
            var filtered = error.stack.split('\n').filter(function(line) {
                return !line.match(SAFARI_NATIVE_CODE_REGEXP);
            }, this);
            return filtered.map(function(line) {
                // Throw away eval information until we implement stacktrace.js/stackframe#8
                if (line.indexOf(' > eval') > -1) line = line.replace(/ line (\d+)(?: > eval line \d+)* > eval:\d+:\d+/g, ':$1');
                if (line.indexOf('@') === -1 && line.indexOf(':') === -1) // Safari eval frames only have function names and nothing else
                return new StackFrame({
                    functionName: line
                });
                else {
                    var functionNameRegex = /((.*".+"[^@]*)?[^@]*)(?:@)/;
                    var matches = line.match(functionNameRegex);
                    var functionName = matches && matches[1] ? matches[1] : undefined;
                    var locationParts = this.extractLocation(line.replace(functionNameRegex, ''));
                    return new StackFrame({
                        functionName: functionName,
                        fileName: locationParts[0],
                        lineNumber: locationParts[1],
                        columnNumber: locationParts[2],
                        source: line
                    });
                }
            }, this);
        },
        parseOpera: function ErrorStackParser$$parseOpera(e) {
            if (!e.stacktrace || e.message.indexOf('\n') > -1 && e.message.split('\n').length > e.stacktrace.split('\n').length) return this.parseOpera9(e);
            else if (!e.stack) return this.parseOpera10(e);
            else return this.parseOpera11(e);
        },
        parseOpera9: function ErrorStackParser$$parseOpera9(e) {
            var lineRE = /Line (\d+).*script (?:in )?(\S+)/i;
            var lines = e.message.split('\n');
            var result = [];
            for(var i = 2, len = lines.length; i < len; i += 2){
                var match = lineRE.exec(lines[i]);
                if (match) result.push(new StackFrame({
                    fileName: match[2],
                    lineNumber: match[1],
                    source: lines[i]
                }));
            }
            return result;
        },
        parseOpera10: function ErrorStackParser$$parseOpera10(e) {
            var lineRE = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i;
            var lines = e.stacktrace.split('\n');
            var result = [];
            for(var i = 0, len = lines.length; i < len; i += 2){
                var match = lineRE.exec(lines[i]);
                if (match) result.push(new StackFrame({
                    functionName: match[3] || undefined,
                    fileName: match[2],
                    lineNumber: match[1],
                    source: lines[i]
                }));
            }
            return result;
        },
        // Opera 10.65+ Error.stack very similar to FF/Safari
        parseOpera11: function ErrorStackParser$$parseOpera11(error) {
            var filtered = error.stack.split('\n').filter(function(line) {
                return !!line.match(FIREFOX_SAFARI_STACK_REGEXP) && !line.match(/^Error created at/);
            }, this);
            return filtered.map(function(line) {
                var tokens = line.split('@');
                var locationParts = this.extractLocation(tokens.pop());
                var functionCall = tokens.shift() || '';
                var functionName = functionCall.replace(/<anonymous function(: (\w+))?>/, '$2').replace(/\([^)]*\)/g, '') || undefined;
                var argsRaw;
                if (functionCall.match(/\(([^)]*)\)/)) argsRaw = functionCall.replace(/^[^(]+\(([^)]*)\)$/, '$1');
                var args = argsRaw === undefined || argsRaw === '[arguments not available]' ? undefined : argsRaw.split(',');
                return new StackFrame({
                    functionName: functionName,
                    args: args,
                    fileName: locationParts[0],
                    lineNumber: locationParts[1],
                    columnNumber: locationParts[2],
                    source: line
                });
            }, this);
        }
    };
});

});
parcelRegister("b2eXQ", function(module, exports) {
(function(root, factory) {
    'use strict';
    // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.
    /* istanbul ignore next */ if (typeof define === 'function' && define.amd) define('stackframe', [], factory);
    else module.exports = factory();
})(module.exports, function() {
    'use strict';
    function _isNumber(n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
    }
    function _capitalize(str) {
        return str.charAt(0).toUpperCase() + str.substring(1);
    }
    function _getter(p) {
        return function() {
            return this[p];
        };
    }
    var booleanProps = [
        'isConstructor',
        'isEval',
        'isNative',
        'isToplevel'
    ];
    var numericProps = [
        'columnNumber',
        'lineNumber'
    ];
    var stringProps = [
        'fileName',
        'functionName',
        'source'
    ];
    var arrayProps = [
        'args'
    ];
    var objectProps = [
        'evalOrigin'
    ];
    var props = booleanProps.concat(numericProps, stringProps, arrayProps, objectProps);
    function StackFrame(obj) {
        if (!obj) return;
        for(var i = 0; i < props.length; i++)if (obj[props[i]] !== undefined) this['set' + _capitalize(props[i])](obj[props[i]]);
    }
    StackFrame.prototype = {
        getArgs: function() {
            return this.args;
        },
        setArgs: function(v) {
            if (Object.prototype.toString.call(v) !== '[object Array]') throw new TypeError('Args must be an Array');
            this.args = v;
        },
        getEvalOrigin: function() {
            return this.evalOrigin;
        },
        setEvalOrigin: function(v) {
            if (v instanceof StackFrame) this.evalOrigin = v;
            else if (v instanceof Object) this.evalOrigin = new StackFrame(v);
            else throw new TypeError('Eval Origin must be an Object or StackFrame');
        },
        toString: function() {
            var fileName = this.getFileName() || '';
            var lineNumber = this.getLineNumber() || '';
            var columnNumber = this.getColumnNumber() || '';
            var functionName = this.getFunctionName() || '';
            if (this.getIsEval()) {
                if (fileName) return '[eval] (' + fileName + ':' + lineNumber + ':' + columnNumber + ')';
                return '[eval]:' + lineNumber + ':' + columnNumber;
            }
            if (functionName) return functionName + ' (' + fileName + ':' + lineNumber + ':' + columnNumber + ')';
            return fileName + ':' + lineNumber + ':' + columnNumber;
        }
    };
    StackFrame.fromString = function StackFrame$$fromString(str) {
        var argsStartIndex = str.indexOf('(');
        var argsEndIndex = str.lastIndexOf(')');
        var functionName = str.substring(0, argsStartIndex);
        var args = str.substring(argsStartIndex + 1, argsEndIndex).split(',');
        var locationString = str.substring(argsEndIndex + 1);
        if (locationString.indexOf('@') === 0) {
            var parts = /@(.+?)(?::(\d+))?(?::(\d+))?$/.exec(locationString, '');
            var fileName = parts[1];
            var lineNumber = parts[2];
            var columnNumber = parts[3];
        }
        return new StackFrame({
            functionName: functionName,
            args: args || undefined,
            fileName: fileName,
            lineNumber: lineNumber || undefined,
            columnNumber: columnNumber || undefined
        });
    };
    for(var i = 0; i < booleanProps.length; i++){
        StackFrame.prototype['get' + _capitalize(booleanProps[i])] = _getter(booleanProps[i]);
        StackFrame.prototype['set' + _capitalize(booleanProps[i])] = function(p) {
            return function(v) {
                this[p] = Boolean(v);
            };
        }(booleanProps[i]);
    }
    for(var j = 0; j < numericProps.length; j++){
        StackFrame.prototype['get' + _capitalize(numericProps[j])] = _getter(numericProps[j]);
        StackFrame.prototype['set' + _capitalize(numericProps[j])] = function(p) {
            return function(v) {
                if (!_isNumber(v)) throw new TypeError(p + ' must be a Number');
                this[p] = Number(v);
            };
        }(numericProps[j]);
    }
    for(var k = 0; k < stringProps.length; k++){
        StackFrame.prototype['get' + _capitalize(stringProps[k])] = _getter(stringProps[k]);
        StackFrame.prototype['set' + _capitalize(stringProps[k])] = function(p) {
            return function(v) {
                this[p] = String(v);
            };
        }(stringProps[k]);
    }
    return StackFrame;
});

});


parcelRegister("6mRKV", function(module, exports) {

$parcel$export(module.exports, "FetchInstrumentation", function () { return $4a2e7eef932d2af9$export$f922a490458c98a8; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ parcelRequire("ckckF");
var $4e6si = parcelRequire("4e6si");
var $6b1Zv = parcelRequire("6b1Zv");
var $g4DKS = parcelRequire("g4DKS");
var $iS6Md = parcelRequire("iS6Md");

var $fZlMi = parcelRequire("fZlMi");
var $dr8VI = parcelRequire("dr8VI");

var $jxeEy = parcelRequire("jxeEy");
var $jL8hu = parcelRequire("jL8hu");
var $b5Rs1 = parcelRequire("b5Rs1");

var $5neJ1 = parcelRequire("5neJ1");
var $5Tevc = parcelRequire("5Tevc");

var $2Oi9Y = parcelRequire("2Oi9Y");

var $7XDeR = parcelRequire("7XDeR");

var $1qQ2R = parcelRequire("1qQ2R");
var $4a2e7eef932d2af9$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $4a2e7eef932d2af9$var$_a;
// how long to wait for observer to collect information about resources
// this is needed as event "load" is called before observer
// hard to say how long it should really wait, seems like 300ms is
// safe enough
var $4a2e7eef932d2af9$var$OBSERVER_WAIT_TIME_MS = 300;
var $4a2e7eef932d2af9$var$isNode = false;
/**
 * This class represents a fetch plugin for auto instrumentation
 */ var $4a2e7eef932d2af9$export$f922a490458c98a8 = /** @class */ function(_super) {
    $4a2e7eef932d2af9$var$__extends(FetchInstrumentation, _super);
    function FetchInstrumentation(config) {
        if (config === void 0) config = {};
        var _this = _super.call(this, '@opentelemetry/instrumentation-fetch', (0, $1qQ2R.VERSION), config) || this;
        _this.component = 'fetch';
        _this.version = (0, $1qQ2R.VERSION);
        _this.moduleName = _this.component;
        _this._usedResources = new WeakSet();
        _this._tasksCount = 0;
        return _this;
    }
    FetchInstrumentation.prototype.init = function() {};
    /**
     * Add cors pre flight child span
     * @param span
     * @param corsPreFlightRequest
     */ FetchInstrumentation.prototype._addChildSpan = function(span, corsPreFlightRequest) {
        var childSpan = this.tracer.startSpan('CORS Preflight', {
            startTime: corsPreFlightRequest[$5Tevc.PerformanceTimingNames.FETCH_START]
        }, $g4DKS.trace.setSpan($4e6si.context.active(), span));
        if (!this.getConfig().ignoreNetworkEvents) $5neJ1.addSpanNetworkEvents(childSpan, corsPreFlightRequest);
        childSpan.end(corsPreFlightRequest[$5Tevc.PerformanceTimingNames.RESPONSE_END]);
    };
    /**
     * Adds more attributes to span just before ending it
     * @param span
     * @param response
     */ FetchInstrumentation.prototype._addFinalSpanAttributes = function(span, response) {
        var parsedUrl = $5neJ1.parseUrl(response.url);
        span.setAttribute((0, $7XDeR.SEMATTRS_HTTP_STATUS_CODE), response.status);
        if (response.statusText != null) span.setAttribute((0, $2Oi9Y.AttributeNames).HTTP_STATUS_TEXT, response.statusText);
        span.setAttribute((0, $7XDeR.SEMATTRS_HTTP_HOST), parsedUrl.host);
        span.setAttribute((0, $7XDeR.SEMATTRS_HTTP_SCHEME), parsedUrl.protocol.replace(':', ''));
        if (typeof navigator !== 'undefined') span.setAttribute((0, $7XDeR.SEMATTRS_HTTP_USER_AGENT), navigator.userAgent);
    };
    /**
     * Add headers
     * @param options
     * @param spanUrl
     */ FetchInstrumentation.prototype._addHeaders = function(options, spanUrl) {
        if (!$5neJ1.shouldPropagateTraceHeaders(spanUrl, this.getConfig().propagateTraceHeaderCorsUrls)) {
            var headers = {};
            $6b1Zv.propagation.inject($4e6si.context.active(), headers);
            if (Object.keys(headers).length > 0) this._diag.debug('headers inject skipped due to CORS policy');
            return;
        }
        if (options instanceof Request) $6b1Zv.propagation.inject($4e6si.context.active(), options.headers, {
            set: function(h, k, v) {
                return h.set(k, typeof v === 'string' ? v : String(v));
            }
        });
        else if (options.headers instanceof Headers) $6b1Zv.propagation.inject($4e6si.context.active(), options.headers, {
            set: function(h, k, v) {
                return h.set(k, typeof v === 'string' ? v : String(v));
            }
        });
        else if (options.headers instanceof Map) $6b1Zv.propagation.inject($4e6si.context.active(), options.headers, {
            set: function(h, k, v) {
                return h.set(k, typeof v === 'string' ? v : String(v));
            }
        });
        else {
            var headers = {};
            $6b1Zv.propagation.inject($4e6si.context.active(), headers);
            options.headers = Object.assign({}, headers, options.headers || {});
        }
    };
    /**
     * Clears the resource timings and all resources assigned with spans
     *     when {@link FetchPluginConfig.clearTimingResources} is
     *     set to true (default false)
     * @private
     */ FetchInstrumentation.prototype._clearResources = function() {
        if (this._tasksCount === 0 && this.getConfig().clearTimingResources) {
            performance.clearResourceTimings();
            this._usedResources = new WeakSet();
        }
    };
    /**
     * Creates a new span
     * @param url
     * @param options
     */ FetchInstrumentation.prototype._createSpan = function(url, options) {
        var _a;
        if (options === void 0) options = {};
        if ($b5Rs1.isUrlIgnored(url, this.getConfig().ignoreUrls)) {
            this._diag.debug('ignoring span as url matches ignored url');
            return;
        }
        var method = (options.method || 'GET').toUpperCase();
        var spanName = "HTTP " + method;
        return this.tracer.startSpan(spanName, {
            kind: $iS6Md.SpanKind.CLIENT,
            attributes: (_a = {}, _a[(0, $2Oi9Y.AttributeNames).COMPONENT] = this.moduleName, _a[0, $7XDeR.SEMATTRS_HTTP_METHOD] = method, _a[0, $7XDeR.SEMATTRS_HTTP_URL] = url, _a)
        });
    };
    /**
     * Finds appropriate resource and add network events to the span
     * @param span
     * @param resourcesObserver
     * @param endTime
     */ FetchInstrumentation.prototype._findResourceAndAddNetworkEvents = function(span, resourcesObserver, endTime) {
        var resources = resourcesObserver.entries;
        if (!resources.length) {
            if (!performance.getEntriesByType) return;
            // fallback - either Observer is not available or it took longer
            // then OBSERVER_WAIT_TIME_MS and observer didn't collect enough
            // information
            resources = performance.getEntriesByType('resource');
        }
        var resource = $5neJ1.getResource(resourcesObserver.spanUrl, resourcesObserver.startTime, endTime, resources, this._usedResources, 'fetch');
        if (resource.mainRequest) {
            var mainRequest = resource.mainRequest;
            this._markResourceAsUsed(mainRequest);
            var corsPreFlightRequest = resource.corsPreFlightRequest;
            if (corsPreFlightRequest) {
                this._addChildSpan(span, corsPreFlightRequest);
                this._markResourceAsUsed(corsPreFlightRequest);
            }
            if (!this.getConfig().ignoreNetworkEvents) $5neJ1.addSpanNetworkEvents(span, mainRequest);
        }
    };
    /**
     * Marks certain [resource]{@link PerformanceResourceTiming} when information
     * from this is used to add events to span.
     * This is done to avoid reusing the same resource again for next span
     * @param resource
     */ FetchInstrumentation.prototype._markResourceAsUsed = function(resource) {
        this._usedResources.add(resource);
    };
    /**
     * Finish span, add attributes, network events etc.
     * @param span
     * @param spanData
     * @param response
     */ FetchInstrumentation.prototype._endSpan = function(span, spanData, response) {
        var _this = this;
        var endTime = $jL8hu.millisToHrTime(Date.now());
        var performanceEndTime = $jL8hu.hrTime();
        this._addFinalSpanAttributes(span, response);
        setTimeout(function() {
            var _a;
            (_a = spanData.observer) === null || _a === void 0 || _a.disconnect();
            _this._findResourceAndAddNetworkEvents(span, spanData, performanceEndTime);
            _this._tasksCount--;
            _this._clearResources();
            span.end(endTime);
        }, $4a2e7eef932d2af9$var$OBSERVER_WAIT_TIME_MS);
    };
    /**
     * Patches the constructor of fetch
     */ FetchInstrumentation.prototype._patchConstructor = function() {
        var _this = this;
        return function(original) {
            var plugin = _this;
            return function patchConstructor() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                var self = this;
                var url = $5neJ1.parseUrl(args[0] instanceof Request ? args[0].url : String(args[0])).href;
                var options = args[0] instanceof Request ? args[0] : args[1] || {};
                var createdSpan = plugin._createSpan(url, options);
                if (!createdSpan) return original.apply(this, args);
                var spanData = plugin._prepareSpanData(url);
                function endSpanOnError(span, error) {
                    plugin._applyAttributesAfterFetch(span, options, error);
                    plugin._endSpan(span, spanData, {
                        status: error.status || 0,
                        statusText: error.message,
                        url: url
                    });
                }
                function endSpanOnSuccess(span, response) {
                    plugin._applyAttributesAfterFetch(span, options, response);
                    if (response.status >= 200 && response.status < 400) plugin._endSpan(span, spanData, response);
                    else plugin._endSpan(span, spanData, {
                        status: response.status,
                        statusText: response.statusText,
                        url: url
                    });
                }
                function onSuccess(span, resolve, response) {
                    try {
                        var resClone = response.clone();
                        var resClone4Hook_1 = response.clone();
                        var body = resClone.body;
                        if (body) {
                            var reader_1 = body.getReader();
                            var read_1 = function() {
                                reader_1.read().then(function(_a) {
                                    var done = _a.done;
                                    if (done) endSpanOnSuccess(span, resClone4Hook_1);
                                    else read_1();
                                }, function(error) {
                                    endSpanOnError(span, error);
                                });
                            };
                            read_1();
                        } else // some older browsers don't have .body implemented
                        endSpanOnSuccess(span, response);
                    } finally{
                        resolve(response);
                    }
                }
                function onError(span, reject, error) {
                    try {
                        endSpanOnError(span, error);
                    } finally{
                        reject(error);
                    }
                }
                return new Promise(function(resolve, reject) {
                    return $4e6si.context.with($g4DKS.trace.setSpan($4e6si.context.active(), createdSpan), function() {
                        plugin._addHeaders(options, url);
                        plugin._tasksCount++;
                        // TypeScript complains about arrow function captured a this typed as globalThis
                        // ts(7041)
                        return original.apply(self, options instanceof Request ? [
                            options
                        ] : [
                            url,
                            options
                        ]).then(onSuccess.bind(self, createdSpan, resolve), onError.bind(self, createdSpan, reject));
                    });
                });
            };
        };
    };
    FetchInstrumentation.prototype._applyAttributesAfterFetch = function(span, request, result) {
        var _this = this;
        var applyCustomAttributesOnSpan = this.getConfig().applyCustomAttributesOnSpan;
        if (applyCustomAttributesOnSpan) (0, $dr8VI.safeExecuteInTheMiddle)(function() {
            return applyCustomAttributesOnSpan(span, request, result);
        }, function(error) {
            if (!error) return;
            _this._diag.error('applyCustomAttributesOnSpan', error);
        }, true);
    };
    /**
     * Prepares a span data - needed later for matching appropriate network
     *     resources
     * @param spanUrl
     */ FetchInstrumentation.prototype._prepareSpanData = function(spanUrl) {
        var startTime = $jL8hu.hrTime();
        var entries = [];
        if (typeof PerformanceObserver !== 'function') return {
            entries: entries,
            startTime: startTime,
            spanUrl: spanUrl
        };
        var observer = new PerformanceObserver(function(list) {
            var perfObsEntries = list.getEntries();
            perfObsEntries.forEach(function(entry) {
                if (entry.initiatorType === 'fetch' && entry.name === spanUrl) entries.push(entry);
            });
        });
        observer.observe({
            entryTypes: [
                'resource'
            ]
        });
        return {
            entries: entries,
            observer: observer,
            startTime: startTime,
            spanUrl: spanUrl
        };
    };
    /**
     * implements enable function
     */ FetchInstrumentation.prototype.enable = function() {
        if ($4a2e7eef932d2af9$var$isNode) {
            // Node.js v18+ *does* have a global `fetch()`, but this package does not
            // support instrumenting it.
            this._diag.warn("this instrumentation is intended for web usage only, it does not instrument Node.js's fetch()");
            return;
        }
        if ((0, $dr8VI.isWrapped)(fetch)) {
            this._unwrap((0, $jxeEy._globalThis), 'fetch');
            this._diag.debug('removing previous patch for constructor');
        }
        this._wrap((0, $jxeEy._globalThis), 'fetch', this._patchConstructor());
    };
    /**
     * implements unpatch function
     */ FetchInstrumentation.prototype.disable = function() {
        if ($4a2e7eef932d2af9$var$isNode) return;
        this._unwrap((0, $jxeEy._globalThis), 'fetch');
        this._usedResources = new WeakSet();
    };
    return FetchInstrumentation;
}((0, $fZlMi.InstrumentationBase));

});
parcelRegister("dr8VI", function(module, exports) {

$parcel$export(module.exports, "safeExecuteInTheMiddle", function () { return $9c84b9488004e23f$export$fdff7e10f8ca069e; });
$parcel$export(module.exports, "isWrapped", function () { return $9c84b9488004e23f$export$ec0fd572751979bc; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $9c84b9488004e23f$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $9c84b9488004e23f$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
function $9c84b9488004e23f$export$fdff7e10f8ca069e(execute, onFinish, preventThrowingError) {
    var error;
    var result;
    try {
        result = execute();
    } catch (e) {
        error = e;
    } finally{
        onFinish(error, result);
        if (error && !preventThrowingError) // eslint-disable-next-line no-unsafe-finally
        throw error;
        // eslint-disable-next-line no-unsafe-finally
        return result;
    }
}
function $9c84b9488004e23f$export$75852fe3c08f1502(execute, onFinish, preventThrowingError) {
    return $9c84b9488004e23f$var$__awaiter(this, void 0, void 0, function() {
        var error, result, e_1;
        return $9c84b9488004e23f$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    _a.trys.push([
                        0,
                        2,
                        3,
                        4
                    ]);
                    return [
                        4 /*yield*/ ,
                        execute()
                    ];
                case 1:
                    result = _a.sent();
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    e_1 = _a.sent();
                    error = e_1;
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 3:
                    onFinish(error, result);
                    if (error && !preventThrowingError) // eslint-disable-next-line no-unsafe-finally
                    throw error;
                    // eslint-disable-next-line no-unsafe-finally
                    return [
                        2 /*return*/ ,
                        result
                    ];
                case 4:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
function $9c84b9488004e23f$export$ec0fd572751979bc(func) {
    return typeof func === 'function' && typeof func.__original === 'function' && typeof func.__unwrap === 'function' && func.__wrapped === true;
}

});

parcelRegister("2Oi9Y", function(module, exports) {

$parcel$export(module.exports, "AttributeNames", function () { return $20be5671a118bda3$export$668754fb61dd076c; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * https://github.com/open-telemetry/opentelemetry-specification/blob/master/specification/trace/semantic_conventions/http.md
 */ var $20be5671a118bda3$export$668754fb61dd076c;
(function(AttributeNames) {
    AttributeNames["COMPONENT"] = "component";
    AttributeNames["HTTP_ERROR_NAME"] = "http.error_name";
    AttributeNames["HTTP_STATUS_TEXT"] = "http.status_text";
})($20be5671a118bda3$export$668754fb61dd076c || ($20be5671a118bda3$export$668754fb61dd076c = {}));

});

parcelRegister("1qQ2R", function(module, exports) {

$parcel$export(module.exports, "VERSION", function () { return $10b09736600e61f9$export$a4ad2735b021c132; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // this is autogenerated file, see scripts/version-update.js
var $10b09736600e61f9$export$a4ad2735b021c132 = '0.52.1';

});


parcelRegister("gILhI", function(module, exports) {

$parcel$export(module.exports, "XMLHttpRequestInstrumentation", function () { return $c2c56f2d95f939ec$export$35de81ee328d915e; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ parcelRequire("ckckF");
var $4e6si = parcelRequire("4e6si");
var $6b1Zv = parcelRequire("6b1Zv");
var $g4DKS = parcelRequire("g4DKS");
var $iS6Md = parcelRequire("iS6Md");

var $fZlMi = parcelRequire("fZlMi");
var $dr8VI = parcelRequire("dr8VI");

var $jL8hu = parcelRequire("jL8hu");
var $b5Rs1 = parcelRequire("b5Rs1");
var $77Kiv = parcelRequire("77Kiv");

var $7XDeR = parcelRequire("7XDeR");

var $5neJ1 = parcelRequire("5neJ1");
var $5Tevc = parcelRequire("5Tevc");

var $9ZkgI = parcelRequire("9ZkgI");

var $fQjq6 = parcelRequire("fQjq6");

var $a0qAQ = parcelRequire("a0qAQ");
var $c2c56f2d95f939ec$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
// how long to wait for observer to collect information about resources
// this is needed as event "load" is called before observer
// hard to say how long it should really wait, seems like 300ms is
// safe enough
var $c2c56f2d95f939ec$var$OBSERVER_WAIT_TIME_MS = 300;
/**
 * This class represents a XMLHttpRequest plugin for auto instrumentation
 */ var $c2c56f2d95f939ec$export$35de81ee328d915e = /** @class */ function(_super) {
    $c2c56f2d95f939ec$var$__extends(XMLHttpRequestInstrumentation, _super);
    function XMLHttpRequestInstrumentation(config) {
        if (config === void 0) config = {};
        var _this = _super.call(this, '@opentelemetry/instrumentation-xml-http-request', (0, $fQjq6.VERSION), config) || this;
        _this.component = 'xml-http-request';
        _this.version = (0, $fQjq6.VERSION);
        _this.moduleName = _this.component;
        _this._tasksCount = 0;
        _this._xhrMem = new WeakMap();
        _this._usedResources = new WeakSet();
        return _this;
    }
    XMLHttpRequestInstrumentation.prototype.init = function() {};
    /**
     * Adds custom headers to XMLHttpRequest
     * @param xhr
     * @param spanUrl
     * @private
     */ XMLHttpRequestInstrumentation.prototype._addHeaders = function(xhr, spanUrl) {
        var url = (0, $5neJ1.parseUrl)(spanUrl).href;
        if (!(0, $5neJ1.shouldPropagateTraceHeaders)(url, this.getConfig().propagateTraceHeaderCorsUrls)) {
            var headers_1 = {};
            $6b1Zv.propagation.inject($4e6si.context.active(), headers_1);
            if (Object.keys(headers_1).length > 0) this._diag.debug('headers inject skipped due to CORS policy');
            return;
        }
        var headers = {};
        $6b1Zv.propagation.inject($4e6si.context.active(), headers);
        Object.keys(headers).forEach(function(key) {
            xhr.setRequestHeader(key, String(headers[key]));
        });
    };
    /**
     * Add cors pre flight child span
     * @param span
     * @param corsPreFlightRequest
     * @private
     */ XMLHttpRequestInstrumentation.prototype._addChildSpan = function(span, corsPreFlightRequest) {
        var _this = this;
        $4e6si.context.with($g4DKS.trace.setSpan($4e6si.context.active(), span), function() {
            var childSpan = _this.tracer.startSpan('CORS Preflight', {
                startTime: corsPreFlightRequest[(0, $5Tevc.PerformanceTimingNames).FETCH_START]
            });
            if (!_this.getConfig().ignoreNetworkEvents) (0, $5neJ1.addSpanNetworkEvents)(childSpan, corsPreFlightRequest);
            childSpan.end(corsPreFlightRequest[(0, $5Tevc.PerformanceTimingNames).RESPONSE_END]);
        });
    };
    /**
     * Add attributes when span is going to end
     * @param span
     * @param xhr
     * @param spanUrl
     * @private
     */ XMLHttpRequestInstrumentation.prototype._addFinalSpanAttributes = function(span, xhrMem, spanUrl) {
        if (typeof spanUrl === 'string') {
            var parsedUrl = (0, $5neJ1.parseUrl)(spanUrl);
            if (xhrMem.status !== undefined) span.setAttribute((0, $7XDeR.SEMATTRS_HTTP_STATUS_CODE), xhrMem.status);
            if (xhrMem.statusText !== undefined) span.setAttribute((0, $a0qAQ.AttributeNames).HTTP_STATUS_TEXT, xhrMem.statusText);
            span.setAttribute((0, $7XDeR.SEMATTRS_HTTP_HOST), parsedUrl.host);
            span.setAttribute((0, $7XDeR.SEMATTRS_HTTP_SCHEME), parsedUrl.protocol.replace(':', ''));
            // @TODO do we want to collect this or it will be collected earlier once only or
            //    maybe when parent span is not available ?
            span.setAttribute((0, $7XDeR.SEMATTRS_HTTP_USER_AGENT), navigator.userAgent);
        }
    };
    XMLHttpRequestInstrumentation.prototype._applyAttributesAfterXHR = function(span, xhr) {
        var _this = this;
        var applyCustomAttributesOnSpan = this.getConfig().applyCustomAttributesOnSpan;
        if (typeof applyCustomAttributesOnSpan === 'function') (0, $dr8VI.safeExecuteInTheMiddle)(function() {
            return applyCustomAttributesOnSpan(span, xhr);
        }, function(error) {
            if (!error) return;
            _this._diag.error('applyCustomAttributesOnSpan', error);
        }, true);
    };
    /**
     * will collect information about all resources created
     * between "send" and "end" with additional waiting for main resource
     * @param xhr
     * @param spanUrl
     * @private
     */ XMLHttpRequestInstrumentation.prototype._addResourceObserver = function(xhr, spanUrl) {
        var xhrMem = this._xhrMem.get(xhr);
        if (!xhrMem || typeof PerformanceObserver !== 'function' || typeof PerformanceResourceTiming !== 'function') return;
        xhrMem.createdResources = {
            observer: new PerformanceObserver(function(list) {
                var entries = list.getEntries();
                var parsedUrl = (0, $5neJ1.parseUrl)(spanUrl);
                entries.forEach(function(entry) {
                    if (entry.initiatorType === 'xmlhttprequest' && entry.name === parsedUrl.href) {
                        if (xhrMem.createdResources) xhrMem.createdResources.entries.push(entry);
                    }
                });
            }),
            entries: []
        };
        xhrMem.createdResources.observer.observe({
            entryTypes: [
                'resource'
            ]
        });
    };
    /**
     * Clears the resource timings and all resources assigned with spans
     *     when {@link XMLHttpRequestInstrumentationConfig.clearTimingResources} is
     *     set to true (default false)
     * @private
     */ XMLHttpRequestInstrumentation.prototype._clearResources = function() {
        if (this._tasksCount === 0 && this.getConfig().clearTimingResources) {
            (0, $77Kiv.otperformance).clearResourceTimings();
            this._xhrMem = new WeakMap();
            this._usedResources = new WeakSet();
        }
    };
    /**
     * Finds appropriate resource and add network events to the span
     * @param span
     */ XMLHttpRequestInstrumentation.prototype._findResourceAndAddNetworkEvents = function(xhrMem, span, spanUrl, startTime, endTime) {
        if (!spanUrl || !startTime || !endTime || !xhrMem.createdResources) return;
        var resources = xhrMem.createdResources.entries;
        if (!resources || !resources.length) // fallback - either Observer is not available or it took longer
        // then OBSERVER_WAIT_TIME_MS and observer didn't collect enough
        // information
        // ts thinks this is the perf_hooks module, but it is the browser performance api
        resources = (0, $77Kiv.otperformance).getEntriesByType('resource');
        var resource = (0, $5neJ1.getResource)((0, $5neJ1.parseUrl)(spanUrl).href, startTime, endTime, resources, this._usedResources);
        if (resource.mainRequest) {
            var mainRequest = resource.mainRequest;
            this._markResourceAsUsed(mainRequest);
            var corsPreFlightRequest = resource.corsPreFlightRequest;
            if (corsPreFlightRequest) {
                this._addChildSpan(span, corsPreFlightRequest);
                this._markResourceAsUsed(corsPreFlightRequest);
            }
            if (!this.getConfig().ignoreNetworkEvents) (0, $5neJ1.addSpanNetworkEvents)(span, mainRequest);
        }
    };
    /**
     * Removes the previous information about span.
     * This might happened when the same xhr is used again.
     * @param xhr
     * @private
     */ XMLHttpRequestInstrumentation.prototype._cleanPreviousSpanInformation = function(xhr) {
        var xhrMem = this._xhrMem.get(xhr);
        if (xhrMem) {
            var callbackToRemoveEvents = xhrMem.callbackToRemoveEvents;
            if (callbackToRemoveEvents) callbackToRemoveEvents();
            this._xhrMem.delete(xhr);
        }
    };
    /**
     * Creates a new span when method "open" is called
     * @param xhr
     * @param url
     * @param method
     * @private
     */ XMLHttpRequestInstrumentation.prototype._createSpan = function(xhr, url, method) {
        var _a;
        if ((0, $b5Rs1.isUrlIgnored)(url, this.getConfig().ignoreUrls)) {
            this._diag.debug('ignoring span as url matches ignored url');
            return;
        }
        var spanName = method.toUpperCase();
        var currentSpan = this.tracer.startSpan(spanName, {
            kind: $iS6Md.SpanKind.CLIENT,
            attributes: (_a = {}, _a[0, $7XDeR.SEMATTRS_HTTP_METHOD] = method, _a[0, $7XDeR.SEMATTRS_HTTP_URL] = (0, $5neJ1.parseUrl)(url).toString(), _a)
        });
        currentSpan.addEvent((0, $9ZkgI.EventNames).METHOD_OPEN);
        this._cleanPreviousSpanInformation(xhr);
        this._xhrMem.set(xhr, {
            span: currentSpan,
            spanUrl: url
        });
        return currentSpan;
    };
    /**
     * Marks certain [resource]{@link PerformanceResourceTiming} when information
     * from this is used to add events to span.
     * This is done to avoid reusing the same resource again for next span
     * @param resource
     * @private
     */ XMLHttpRequestInstrumentation.prototype._markResourceAsUsed = function(resource) {
        this._usedResources.add(resource);
    };
    /**
     * Patches the method open
     * @private
     */ XMLHttpRequestInstrumentation.prototype._patchOpen = function() {
        var _this = this;
        return function(original) {
            var plugin = _this;
            return function patchOpen() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                var method = args[0];
                var url = args[1];
                plugin._createSpan(this, url, method);
                return original.apply(this, args);
            };
        };
    };
    /**
     * Patches the method send
     * @private
     */ XMLHttpRequestInstrumentation.prototype._patchSend = function() {
        var plugin = this;
        function endSpanTimeout(eventName, xhrMem, performanceEndTime, endTime) {
            var callbackToRemoveEvents = xhrMem.callbackToRemoveEvents;
            if (typeof callbackToRemoveEvents === 'function') callbackToRemoveEvents();
            var span = xhrMem.span, spanUrl = xhrMem.spanUrl, sendStartTime = xhrMem.sendStartTime;
            if (span) {
                plugin._findResourceAndAddNetworkEvents(xhrMem, span, spanUrl, sendStartTime, performanceEndTime);
                span.addEvent(eventName, endTime);
                plugin._addFinalSpanAttributes(span, xhrMem, spanUrl);
                span.end(endTime);
                plugin._tasksCount--;
            }
            plugin._clearResources();
        }
        function endSpan(eventName, xhr) {
            var xhrMem = plugin._xhrMem.get(xhr);
            if (!xhrMem) return;
            xhrMem.status = xhr.status;
            xhrMem.statusText = xhr.statusText;
            plugin._xhrMem.delete(xhr);
            if (xhrMem.span) plugin._applyAttributesAfterXHR(xhrMem.span, xhr);
            var performanceEndTime = (0, $jL8hu.hrTime)();
            var endTime = Date.now();
            // the timeout is needed as observer doesn't have yet information
            // when event "load" is called. Also the time may differ depends on
            // browser and speed of computer
            setTimeout(function() {
                endSpanTimeout(eventName, xhrMem, performanceEndTime, endTime);
            }, $c2c56f2d95f939ec$var$OBSERVER_WAIT_TIME_MS);
        }
        function onError() {
            endSpan((0, $9ZkgI.EventNames).EVENT_ERROR, this);
        }
        function onAbort() {
            endSpan((0, $9ZkgI.EventNames).EVENT_ABORT, this);
        }
        function onTimeout() {
            endSpan((0, $9ZkgI.EventNames).EVENT_TIMEOUT, this);
        }
        function onLoad() {
            if (this.status < 299) endSpan((0, $9ZkgI.EventNames).EVENT_LOAD, this);
            else endSpan((0, $9ZkgI.EventNames).EVENT_ERROR, this);
        }
        function unregister(xhr) {
            xhr.removeEventListener('abort', onAbort);
            xhr.removeEventListener('error', onError);
            xhr.removeEventListener('load', onLoad);
            xhr.removeEventListener('timeout', onTimeout);
            var xhrMem = plugin._xhrMem.get(xhr);
            if (xhrMem) xhrMem.callbackToRemoveEvents = undefined;
        }
        return function(original) {
            return function patchSend() {
                var _this = this;
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                var xhrMem = plugin._xhrMem.get(this);
                if (!xhrMem) return original.apply(this, args);
                var currentSpan = xhrMem.span;
                var spanUrl = xhrMem.spanUrl;
                if (currentSpan && spanUrl) $4e6si.context.with($g4DKS.trace.setSpan($4e6si.context.active(), currentSpan), function() {
                    plugin._tasksCount++;
                    xhrMem.sendStartTime = (0, $jL8hu.hrTime)();
                    currentSpan.addEvent((0, $9ZkgI.EventNames).METHOD_SEND);
                    _this.addEventListener('abort', onAbort);
                    _this.addEventListener('error', onError);
                    _this.addEventListener('load', onLoad);
                    _this.addEventListener('timeout', onTimeout);
                    xhrMem.callbackToRemoveEvents = function() {
                        unregister(_this);
                        if (xhrMem.createdResources) xhrMem.createdResources.observer.disconnect();
                    };
                    plugin._addHeaders(_this, spanUrl);
                    plugin._addResourceObserver(_this, spanUrl);
                });
                return original.apply(this, args);
            };
        };
    };
    /**
     * implements enable function
     */ XMLHttpRequestInstrumentation.prototype.enable = function() {
        this._diag.debug('applying patch to', this.moduleName, this.version);
        if ((0, $dr8VI.isWrapped)(XMLHttpRequest.prototype.open)) {
            this._unwrap(XMLHttpRequest.prototype, 'open');
            this._diag.debug('removing previous patch from method open');
        }
        if ((0, $dr8VI.isWrapped)(XMLHttpRequest.prototype.send)) {
            this._unwrap(XMLHttpRequest.prototype, 'send');
            this._diag.debug('removing previous patch from method send');
        }
        this._wrap(XMLHttpRequest.prototype, 'open', this._patchOpen());
        this._wrap(XMLHttpRequest.prototype, 'send', this._patchSend());
    };
    /**
     * implements disable function
     */ XMLHttpRequestInstrumentation.prototype.disable = function() {
        this._diag.debug('removing patch from', this.moduleName, this.version);
        this._unwrap(XMLHttpRequest.prototype, 'open');
        this._unwrap(XMLHttpRequest.prototype, 'send');
        this._tasksCount = 0;
        this._xhrMem = new WeakMap();
        this._usedResources = new WeakSet();
    };
    return XMLHttpRequestInstrumentation;
}((0, $fZlMi.InstrumentationBase));

});
parcelRegister("9ZkgI", function(module, exports) {

$parcel$export(module.exports, "EventNames", function () { return $7459887ed6ae03b9$export$3fd36d65bf762270; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $7459887ed6ae03b9$export$3fd36d65bf762270;
(function(EventNames) {
    EventNames["METHOD_OPEN"] = "open";
    EventNames["METHOD_SEND"] = "send";
    EventNames["EVENT_ABORT"] = "abort";
    EventNames["EVENT_ERROR"] = "error";
    EventNames["EVENT_LOAD"] = "loaded";
    EventNames["EVENT_TIMEOUT"] = "timeout";
})($7459887ed6ae03b9$export$3fd36d65bf762270 || ($7459887ed6ae03b9$export$3fd36d65bf762270 = {}));

});

parcelRegister("fQjq6", function(module, exports) {

$parcel$export(module.exports, "VERSION", function () { return $b88ac6c6d943fe55$export$a4ad2735b021c132; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // this is autogenerated file, see scripts/version-update.js
var $b88ac6c6d943fe55$export$a4ad2735b021c132 = '0.52.1';

});

parcelRegister("a0qAQ", function(module, exports) {

$parcel$export(module.exports, "AttributeNames", function () { return $748e885238375835$export$668754fb61dd076c; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * https://github.com/open-telemetry/opentelemetry-specification/blob/master/specification/trace/semantic_conventions/http.md
 */ var $748e885238375835$export$668754fb61dd076c;
(function(AttributeNames) {
    AttributeNames["HTTP_STATUS_TEXT"] = "http.status_text";
})($748e885238375835$export$668754fb61dd076c || ($748e885238375835$export$668754fb61dd076c = {}));

});


parcelRegister("ejUix", function(module, exports) {
$parcel$export(module.exports, "onCLS", function () { return (parcelRequire("kTKKO")).onCLS; });
$parcel$export(module.exports, "onFCP", function () { return (parcelRequire("kTKKO")).onFCP; });
$parcel$export(module.exports, "onFID", function () { return (parcelRequire("kTKKO")).onFID; });
$parcel$export(module.exports, "onINP", function () { return (parcelRequire("kTKKO")).onINP; });
$parcel$export(module.exports, "onLCP", function () { return (parcelRequire("kTKKO")).onLCP; });
$parcel$export(module.exports, "onTTFB", function () { return (parcelRequire("kTKKO")).onTTFB; });
/*
 Copyright 2022 Google LLC
 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

     https://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/ // Creates the `web-vitals/attribution` import in node-based bundlers.
// This will not be needed when export maps are widely supported.
parcelRequire("kTKKO");

});
parcelRegister("kTKKO", function(module, exports) {

$parcel$export(module.exports, "onCLS", function () { return $f36d361701e4001f$export$a7873055838e5ad8; });
$parcel$export(module.exports, "onFCP", function () { return $f36d361701e4001f$export$fe3c86b74e15d5de; });
$parcel$export(module.exports, "onINP", function () { return $f36d361701e4001f$export$7df4b36ecaed99e1; });
$parcel$export(module.exports, "onLCP", function () { return $f36d361701e4001f$export$947b1626ab8d5632; });
$parcel$export(module.exports, "onTTFB", function () { return $f36d361701e4001f$export$33a01e6c5f2c7e33; });
$parcel$export(module.exports, "onFID", function () { return $f36d361701e4001f$export$39705a25c49af873; });
var $f36d361701e4001f$var$t, $f36d361701e4001f$var$n, $f36d361701e4001f$var$e = function() {
    var t = self.performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
    if (t && t.responseStart > 0 && t.responseStart < performance.now()) return t;
}, $f36d361701e4001f$var$i = function(t) {
    if ("loading" === document.readyState) return "loading";
    var n = $f36d361701e4001f$var$e();
    if (n) {
        if (t < n.domInteractive) return "loading";
        if (0 === n.domContentLoadedEventStart || t < n.domContentLoadedEventStart) return "dom-interactive";
        if (0 === n.domComplete || t < n.domComplete) return "dom-content-loaded";
    }
    return "complete";
}, $f36d361701e4001f$var$a = function(t) {
    var n = t.nodeName;
    return 1 === t.nodeType ? n.toLowerCase() : n.toUpperCase().replace(/^#/, "");
}, $f36d361701e4001f$var$r = function(t, n) {
    var e = "";
    try {
        for(; t && 9 !== t.nodeType;){
            var i = t, r = i.id ? "#" + i.id : $f36d361701e4001f$var$a(i) + (i.classList && i.classList.value && i.classList.value.trim() && i.classList.value.trim().length ? "." + i.classList.value.trim().replace(/\s+/g, ".") : "");
            if (e.length + r.length > (n || 100) - 1) return e || r;
            if (e = e ? r + ">" + e : r, i.id) break;
            t = i.parentNode;
        }
    } catch (t) {}
    return e;
}, $f36d361701e4001f$var$o = function(t, n, e, i) {
    var a, r;
    return function(o) {
        n.value >= 0 && (o || i) && ((r = n.value - (a || 0)) || void 0 === a) && (a = n.value, n.delta = r, n.rating = function(t, n) {
            return t > n[1] ? "poor" : t > n[0] ? "needs-improvement" : "good";
        }(n.value, e), t(n));
    };
}, $f36d361701e4001f$var$c = function(t) {
    requestAnimationFrame(function() {
        return requestAnimationFrame(function() {
            return t();
        });
    });
}, $f36d361701e4001f$var$s = -1, $f36d361701e4001f$var$u = function() {
    return $f36d361701e4001f$var$s;
}, $f36d361701e4001f$var$f = function(t) {
    addEventListener("pageshow", function(n) {
        n.persisted && ($f36d361701e4001f$var$s = n.timeStamp, t(n));
    }, !0);
}, $f36d361701e4001f$var$v = function() {
    var t = $f36d361701e4001f$var$e();
    return t && t.activationStart || 0;
}, $f36d361701e4001f$var$d = function(t, n, i, a) {
    var r, o = (null === (r = $f36d361701e4001f$var$e()) || void 0 === r ? void 0 : r.navigationId) || "1", c = $f36d361701e4001f$var$e(), s = "navigate";
    i ? s = i : $f36d361701e4001f$var$u() >= 0 ? s = "back-forward-cache" : c && (document.prerendering || $f36d361701e4001f$var$v() > 0 ? s = "prerender" : document.wasDiscarded ? s = "restore" : c.type && (s = c.type.replace(/_/g, "-")));
    return {
        name: t,
        value: void 0 === n ? -1 : n,
        rating: "good",
        delta: 0,
        entries: [],
        id: "v4-".concat(Date.now(), "-").concat(Math.floor(8999999999999 * Math.random()) + 1e12),
        navigationType: s,
        navigationId: a || o
    };
}, $f36d361701e4001f$var$g = function(t) {
    return PerformanceObserver.supportedEntryTypes.includes("soft-navigation") && t && t.reportSoftNavs;
}, $f36d361701e4001f$var$l = function(t) {
    if (t) {
        var n = window.performance.getEntriesByType("soft-navigation").filter(function(n) {
            return n.navigationId === t;
        });
        return n ? n[0] : void 0;
    }
}, $f36d361701e4001f$var$m = function(t, n, e) {
    var i = $f36d361701e4001f$var$g(e);
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(t)) {
            var a = new PerformanceObserver(function(t) {
                Promise.resolve().then(function() {
                    n(t.getEntries());
                });
            });
            return a.observe(Object.assign({
                type: t,
                buffered: !0,
                includeSoftNavigationObservations: i
            }, e || {})), a;
        }
    } catch (t) {}
}, $f36d361701e4001f$var$p = function(t) {
    document.addEventListener("visibilitychange", function() {
        "hidden" === document.visibilityState && t();
    });
}, $f36d361701e4001f$var$h = function(t) {
    var n = !1;
    return function() {
        n || (t(), n = !0);
    };
}, $f36d361701e4001f$var$T = -1, $f36d361701e4001f$var$I = function() {
    return "hidden" !== document.visibilityState || document.prerendering ? 1 / 0 : 0;
}, $f36d361701e4001f$var$y = function(t) {
    "hidden" === document.visibilityState && $f36d361701e4001f$var$T > -1 && ($f36d361701e4001f$var$T = "visibilitychange" === t.type ? t.timeStamp : 0, $f36d361701e4001f$var$S());
}, $f36d361701e4001f$var$E = function() {
    addEventListener("visibilitychange", $f36d361701e4001f$var$y, !0), addEventListener("prerenderingchange", $f36d361701e4001f$var$y, !0);
}, $f36d361701e4001f$var$S = function() {
    removeEventListener("visibilitychange", $f36d361701e4001f$var$y, !0), removeEventListener("prerenderingchange", $f36d361701e4001f$var$y, !0);
}, $f36d361701e4001f$var$b = function() {
    return arguments.length > 0 && void 0 !== arguments[0] && arguments[0] && ($f36d361701e4001f$var$T = -1), $f36d361701e4001f$var$T < 0 && ($f36d361701e4001f$var$T = $f36d361701e4001f$var$I(), $f36d361701e4001f$var$E(), $f36d361701e4001f$var$f(function() {
        setTimeout(function() {
            $f36d361701e4001f$var$T = $f36d361701e4001f$var$I(), $f36d361701e4001f$var$E();
        }, 0);
    })), {
        get firstHiddenTime () {
            return $f36d361701e4001f$var$T;
        }
    };
}, $f36d361701e4001f$var$C = function(t) {
    document.prerendering ? addEventListener("prerenderingchange", function() {
        return t();
    }, !0) : t();
}, $f36d361701e4001f$export$e610c735b5510cec = [
    1800,
    3e3
], $f36d361701e4001f$var$L = function(t, n) {
    var i, a = $f36d361701e4001f$var$g(n = n || {}), r = 0, s = (null === (i = $f36d361701e4001f$var$e()) || void 0 === i ? void 0 : i.navigationId) || "1";
    $f36d361701e4001f$var$C(function() {
        var e, i = $f36d361701e4001f$var$b(), u = $f36d361701e4001f$var$d("FCP"), g = $f36d361701e4001f$var$m("paint", function(c) {
            c.forEach(function(c) {
                if ("first-contentful-paint" === c.name) {
                    a ? c.navigationId && c.navigationId !== u.navigationId && function(a, c) {
                        if (u = $f36d361701e4001f$var$d("FCP", 0, a, c), e = $f36d361701e4001f$var$o(t, u, $f36d361701e4001f$export$e610c735b5510cec, n.reportAllChanges), "soft-navigation" === a) {
                            i = $f36d361701e4001f$var$b(!0);
                            var s = c ? $f36d361701e4001f$var$l(c) : null;
                            r = s && s.startTime || 0;
                        }
                    }("soft-navigation", c.navigationId) : g.disconnect();
                    var f = 0;
                    if (c.navigationId && c.navigationId !== s) {
                        var m = $f36d361701e4001f$var$l(c.navigationId), p = m && m.startTime ? m.startTime : 0;
                        f = Math.max(c.startTime - p, 0);
                    } else f = Math.max(c.startTime - $f36d361701e4001f$var$v(), 0);
                    var h = a && c.navigationId ? $f36d361701e4001f$var$l(c.navigationId) : null, T = h && h.startTime ? h.startTime : 0;
                    (c.startTime < i.firstHiddenTime || a && c.navigationId && c.navigationId !== u.navigationId && c.navigationId !== s && T > r) && (u.value = f, u.entries.push(c), u.navigationId = c.navigationId || "1", e(!0));
                }
            });
        }, n);
        g && (e = $f36d361701e4001f$var$o(t, u, $f36d361701e4001f$export$e610c735b5510cec, n.reportAllChanges), $f36d361701e4001f$var$f(function(i) {
            u = $f36d361701e4001f$var$d("FCP", 0, "back-forward-cache", u.navigationId), e = $f36d361701e4001f$var$o(t, u, $f36d361701e4001f$export$e610c735b5510cec, n.reportAllChanges), $f36d361701e4001f$var$c(function() {
                u.value = performance.now() - i.timeStamp, e(!0);
            });
        }));
    });
}, $f36d361701e4001f$export$3f20d8e089ac35b2 = [
    .1,
    .25
], $f36d361701e4001f$export$a7873055838e5ad8 = function(t, n) {
    !function(t, n) {
        var e = $f36d361701e4001f$var$g(n = n || {}), i = !1, a = 0;
        $f36d361701e4001f$var$L($f36d361701e4001f$var$h(function() {
            var r, s = $f36d361701e4001f$var$d("CLS", 0), u = 0, v = [], g = function(e, c) {
                if (s = $f36d361701e4001f$var$d("CLS", 0, e, c), r = $f36d361701e4001f$var$o(t, s, $f36d361701e4001f$export$3f20d8e089ac35b2, n.reportAllChanges), u = 0, i = !1, "soft-navigation" === e) {
                    var f = $f36d361701e4001f$var$l(c);
                    a = f && f.startTime || 0;
                }
            }, h = function(t) {
                t.forEach(function(t) {
                    if (e && t.navigationId && t.navigationId !== s.navigationId && (u > s.value && (s.value = u, s.entries = v), r(!0), g("soft-navigation", t.navigationId)), !t.hadRecentInput) {
                        var n = v[0], i = v[v.length - 1];
                        u && t.startTime - i.startTime < 1e3 && t.startTime - n.startTime < 5e3 ? (u += t.value, v.push(t)) : (u = t.value, v = [
                            t
                        ]);
                    }
                }), u > s.value && (s.value = u, s.entries = v, r());
            }, T = $f36d361701e4001f$var$m("layout-shift", h, n);
            T && (r = $f36d361701e4001f$var$o(t, s, $f36d361701e4001f$export$3f20d8e089ac35b2, n.reportAllChanges), $f36d361701e4001f$var$p(function() {
                h(T.takeRecords()), r(!0), i = !0;
            }), $f36d361701e4001f$var$f(function() {
                g("back-forward-cache", s.navigationId), $f36d361701e4001f$var$c(function() {
                    return r();
                });
            }), e && $f36d361701e4001f$var$m("soft-navigation", function(e) {
                e.forEach(function(e) {
                    var c = e.navigationId, u = c ? $f36d361701e4001f$var$l(c) : null;
                    c && c !== s.navigationId && u && (u.startTime || 0) > a && (i || r(!0), g("soft-navigation", e.navigationId), r = $f36d361701e4001f$var$o(t, s, $f36d361701e4001f$export$3f20d8e089ac35b2, n.reportAllChanges));
                });
            }, n), setTimeout(r, 0));
        }));
    }(function(n) {
        var e = function(t) {
            var n, e = {};
            if (t.entries.length) {
                var a = t.entries.reduce(function(t, n) {
                    return t && t.value > n.value ? t : n;
                });
                if (a && a.sources && a.sources.length) {
                    var o = (n = a.sources).find(function(t) {
                        return t.node && 1 === t.node.nodeType;
                    }) || n[0];
                    o && (e = {
                        largestShiftTarget: $f36d361701e4001f$var$r(o.node),
                        largestShiftTime: a.startTime,
                        largestShiftValue: a.value,
                        largestShiftSource: o,
                        largestShiftEntry: a,
                        loadState: $f36d361701e4001f$var$i(a.startTime)
                    });
                }
            }
            return Object.assign(t, {
                attribution: e
            });
        }(n);
        t(e);
    }, n);
}, $f36d361701e4001f$export$fe3c86b74e15d5de = function(t, n) {
    $f36d361701e4001f$var$L(function(n) {
        var a = function(t) {
            var n, a = (null === (n = $f36d361701e4001f$var$e()) || void 0 === n ? void 0 : n.navigationId) || "1", r = {
                timeToFirstByte: 0,
                firstByteToFCP: t.value,
                loadState: $f36d361701e4001f$var$i($f36d361701e4001f$var$u())
            };
            if (t.entries.length) {
                var o, c = t.entries[t.entries.length - 1], s = 0;
                if (t.navigationId && t.navigationId !== a) s = (o = $f36d361701e4001f$var$l(t.navigationId)) ? o.startTime : 0;
                else if (o = $f36d361701e4001f$var$e()) {
                    var f = o.responseStart, v = o.activationStart || 0;
                    s = Math.max(0, f - v);
                }
                o && (r = {
                    timeToFirstByte: s,
                    firstByteToFCP: t.value - s,
                    loadState: $f36d361701e4001f$var$i(t.entries[0].startTime),
                    navigationEntry: o,
                    fcpEntry: c
                });
            }
            return Object.assign(t, {
                attribution: r
            });
        }(n);
        t(a);
    }, n);
}, $f36d361701e4001f$var$x = 0, $f36d361701e4001f$var$A = 1 / 0, $f36d361701e4001f$var$F = 0, $f36d361701e4001f$var$P = "", $f36d361701e4001f$var$B = !1, $f36d361701e4001f$var$O = function(t) {
    var n;
    $f36d361701e4001f$var$P || ($f36d361701e4001f$var$P = (null === (n = $f36d361701e4001f$var$e()) || void 0 === n ? void 0 : n.navigationId) || "1"), t.forEach(function(t) {
        t.interactionId && ($f36d361701e4001f$var$B && t.navigationId && t.navigationId !== $f36d361701e4001f$var$P && ($f36d361701e4001f$var$P = t.navigationId, $f36d361701e4001f$var$x = 0, $f36d361701e4001f$var$A = 1 / 0, $f36d361701e4001f$var$F = 0), $f36d361701e4001f$var$A = Math.min($f36d361701e4001f$var$A, t.interactionId), $f36d361701e4001f$var$F = Math.max($f36d361701e4001f$var$F, t.interactionId), $f36d361701e4001f$var$x = $f36d361701e4001f$var$F ? ($f36d361701e4001f$var$F - $f36d361701e4001f$var$A) / 7 + 1 : 0);
    });
}, $f36d361701e4001f$var$N = function() {
    return $f36d361701e4001f$var$t ? $f36d361701e4001f$var$x : performance.interactionCount || 0;
}, $f36d361701e4001f$var$R = function(n) {
    "interactionCount" in performance || $f36d361701e4001f$var$t || ($f36d361701e4001f$var$t = $f36d361701e4001f$var$m("event", $f36d361701e4001f$var$O, {
        type: "event",
        buffered: !0,
        durationThreshold: 0,
        includeSoftNavigationObservations: $f36d361701e4001f$var$B = n || !1
    }));
}, $f36d361701e4001f$var$j = [], $f36d361701e4001f$var$q = new Map, $f36d361701e4001f$var$H = 0, $f36d361701e4001f$var$W = function() {
    $f36d361701e4001f$var$H = $f36d361701e4001f$var$N(), $f36d361701e4001f$var$j.length = 0, $f36d361701e4001f$var$q.clear();
}, $f36d361701e4001f$var$z = function() {
    var t = Math.min($f36d361701e4001f$var$j.length - 1, Math.floor(($f36d361701e4001f$var$N() - $f36d361701e4001f$var$H) / 50));
    return $f36d361701e4001f$var$j[t];
}, $f36d361701e4001f$var$U = [], $f36d361701e4001f$var$V = function(t) {
    if ($f36d361701e4001f$var$U.forEach(function(n) {
        return n(t);
    }), t.interactionId || "first-input" === t.entryType) {
        var n = $f36d361701e4001f$var$j[$f36d361701e4001f$var$j.length - 1], e = $f36d361701e4001f$var$q.get(t.interactionId);
        if (e || $f36d361701e4001f$var$j.length < 10 || t.duration > n.latency) {
            if (e) t.duration > e.latency ? (e.entries = [
                t
            ], e.latency = t.duration) : t.duration === e.latency && t.startTime === e.entries[0].startTime && e.entries.push(t);
            else {
                var i = {
                    id: t.interactionId,
                    latency: t.duration,
                    entries: [
                        t
                    ]
                };
                $f36d361701e4001f$var$q.set(i.id, i), $f36d361701e4001f$var$j.push(i);
            }
            $f36d361701e4001f$var$j.sort(function(t, n) {
                return n.latency - t.latency;
            }), $f36d361701e4001f$var$j.length > 10 && $f36d361701e4001f$var$j.splice(10).forEach(function(t) {
                return $f36d361701e4001f$var$q.delete(t.id);
            });
        }
    }
}, $f36d361701e4001f$var$_ = function(t) {
    var n = self.requestIdleCallback || self.setTimeout, e = -1;
    return t = $f36d361701e4001f$var$h(t), "hidden" === document.visibilityState ? t() : (e = n(t), $f36d361701e4001f$var$p(t)), e;
}, $f36d361701e4001f$export$7f4cb060ded9173c = [
    200,
    500
], $f36d361701e4001f$var$J = function(t, n) {
    if ("PerformanceEventTiming" in self && "interactionId" in PerformanceEventTiming.prototype) {
        var e = $f36d361701e4001f$var$g(n = n || {}), i = !1, a = 0;
        $f36d361701e4001f$var$C(function() {
            var r;
            $f36d361701e4001f$var$R(e);
            var s, u = $f36d361701e4001f$var$d("INP"), v = function(e, r) {
                if ($f36d361701e4001f$var$W(), u = $f36d361701e4001f$var$d("INP", 0, e, r), s = $f36d361701e4001f$var$o(t, u, $f36d361701e4001f$export$7f4cb060ded9173c, n.reportAllChanges), i = !1, "soft-navigation" === e) {
                    var c = $f36d361701e4001f$var$l(r);
                    a = c && c.startTime ? c.startTime : 0;
                }
            }, g = function(t) {
                $f36d361701e4001f$var$_(function() {
                    var e;
                    t.forEach($f36d361701e4001f$var$V), (e = $f36d361701e4001f$var$z()) && (e.latency !== u.value || n && n.reportAllChanges) && (u.value = e.latency, u.entries = e.entries), s();
                });
            }, h = $f36d361701e4001f$var$m("event", g, {
                durationThreshold: null !== (r = n.durationThreshold) && void 0 !== r ? r : 40,
                opts: n
            });
            if (s = $f36d361701e4001f$var$o(t, u, $f36d361701e4001f$export$7f4cb060ded9173c, n.reportAllChanges), h) {
                h.observe({
                    type: "first-input",
                    buffered: !0,
                    includeSoftNavigationObservations: e
                }), $f36d361701e4001f$var$p(function() {
                    g(h.takeRecords()), s(!0);
                }), $f36d361701e4001f$var$f(function() {
                    $f36d361701e4001f$var$W(), v("back-forward-cache", u.navigationId), $f36d361701e4001f$var$c(function() {
                        return s();
                    });
                });
                e && $f36d361701e4001f$var$m("soft-navigation", function(e) {
                    e.forEach(function(e) {
                        var r = $f36d361701e4001f$var$l(e.navigationId), c = r && r.startTime ? r.startTime : 0;
                        e.navigationId && e.navigationId !== u.navigationId && c > a && (!i && u.value > 0 && s(!0), v("soft-navigation", e.navigationId), s = $f36d361701e4001f$var$o(t, u, $f36d361701e4001f$export$7f4cb060ded9173c, n.reportAllChanges));
                    });
                }, n);
            }
        });
    }
}, $f36d361701e4001f$var$K = [], $f36d361701e4001f$var$Q = [], $f36d361701e4001f$var$X = 0, $f36d361701e4001f$var$Y = new WeakMap, $f36d361701e4001f$var$Z = new Map, $f36d361701e4001f$var$$ = -1, $f36d361701e4001f$var$tt = function(t) {
    $f36d361701e4001f$var$K = $f36d361701e4001f$var$K.concat(t), $f36d361701e4001f$var$nt();
}, $f36d361701e4001f$var$nt = function() {
    $f36d361701e4001f$var$$ < 0 && ($f36d361701e4001f$var$$ = $f36d361701e4001f$var$_($f36d361701e4001f$var$et));
}, $f36d361701e4001f$var$et = function() {
    $f36d361701e4001f$var$Z.size > 10 && $f36d361701e4001f$var$Z.forEach(function(t, n) {
        $f36d361701e4001f$var$q.has(n) || $f36d361701e4001f$var$Z.delete(n);
    });
    var t = $f36d361701e4001f$var$j.map(function(t) {
        return $f36d361701e4001f$var$Y.get(t.entries[0]);
    }), n = $f36d361701e4001f$var$Q.length - 50;
    $f36d361701e4001f$var$Q = $f36d361701e4001f$var$Q.filter(function(e, i) {
        return i >= n || t.includes(e);
    });
    for(var e = new Set, i = 0; i < $f36d361701e4001f$var$Q.length; i++){
        var a = $f36d361701e4001f$var$Q[i];
        $f36d361701e4001f$var$ct(a.startTime, a.processingEnd).forEach(function(t) {
            e.add(t);
        });
    }
    var r = $f36d361701e4001f$var$K.length - 1 - 50;
    $f36d361701e4001f$var$K = $f36d361701e4001f$var$K.filter(function(t, n) {
        return t.startTime > $f36d361701e4001f$var$X && n > r || e.has(t);
    }), $f36d361701e4001f$var$$ = -1;
};
$f36d361701e4001f$var$U.push(function(t) {
    t.interactionId && t.target && !$f36d361701e4001f$var$Z.has(t.interactionId) && $f36d361701e4001f$var$Z.set(t.interactionId, t.target);
}, function(t) {
    var n, e = t.startTime + t.duration;
    $f36d361701e4001f$var$X = Math.max($f36d361701e4001f$var$X, t.processingEnd);
    for(var i = $f36d361701e4001f$var$Q.length - 1; i >= 0; i--){
        var a = $f36d361701e4001f$var$Q[i];
        if (Math.abs(e - a.renderTime) <= 8) {
            (n = a).startTime = Math.min(t.startTime, n.startTime), n.processingStart = Math.min(t.processingStart, n.processingStart), n.processingEnd = Math.max(t.processingEnd, n.processingEnd), n.entries.push(t);
            break;
        }
    }
    n || (n = {
        startTime: t.startTime,
        processingStart: t.processingStart,
        processingEnd: t.processingEnd,
        renderTime: e,
        entries: [
            t
        ]
    }, $f36d361701e4001f$var$Q.push(n)), (t.interactionId || "first-input" === t.entryType) && $f36d361701e4001f$var$Y.set(t, n), $f36d361701e4001f$var$nt();
});
var $f36d361701e4001f$var$it, $f36d361701e4001f$var$at, $f36d361701e4001f$var$rt, $f36d361701e4001f$var$ot, $f36d361701e4001f$var$ct = function(t, n) {
    for(var e, i = [], a = 0; e = $f36d361701e4001f$var$K[a]; a++)if (!(e.startTime + e.duration < t)) {
        if (e.startTime > n) break;
        i.push(e);
    }
    return i;
}, $f36d361701e4001f$export$7df4b36ecaed99e1 = function(t, e) {
    $f36d361701e4001f$var$n || ($f36d361701e4001f$var$n = $f36d361701e4001f$var$m("long-animation-frame", $f36d361701e4001f$var$tt)), $f36d361701e4001f$var$J(function(n) {
        var e = function(t) {
            var n = t.entries[0], e = $f36d361701e4001f$var$Y.get(n), a = n.processingStart, o = e.processingEnd, c = e.entries.sort(function(t, n) {
                return t.processingStart - n.processingStart;
            }), s = $f36d361701e4001f$var$ct(n.startTime, o), u = t.entries.find(function(t) {
                return t.target;
            }), f = u && u.target || $f36d361701e4001f$var$Z.get(n.interactionId), v = [
                n.startTime + n.duration,
                o
            ].concat(s.map(function(t) {
                return t.startTime + t.duration;
            })), d = Math.max.apply(Math, v), g = {
                interactionTarget: $f36d361701e4001f$var$r(f),
                interactionTargetElement: f,
                interactionType: n.name.startsWith("key") ? "keyboard" : "pointer",
                interactionTime: n.startTime,
                nextPaintTime: d,
                processedEventEntries: c,
                longAnimationFrameEntries: s,
                inputDelay: a - n.startTime,
                processingDuration: o - a,
                presentationDelay: Math.max(d - o, 0),
                loadState: $f36d361701e4001f$var$i(n.startTime)
            };
            return Object.assign(t, {
                attribution: g
            });
        }(n);
        t(e);
    }, e);
}, $f36d361701e4001f$export$948521ca5b0e1b17 = [
    2500,
    4e3
], $f36d361701e4001f$export$947b1626ab8d5632 = function(t, n) {
    !function(t, n) {
        var i, a = !1, r = $f36d361701e4001f$var$g(n = n || {}), s = 0, u = (null === (i = $f36d361701e4001f$var$e()) || void 0 === i ? void 0 : i.navigationId) || "1", h = "";
        $f36d361701e4001f$var$C(function() {
            var e, i = $f36d361701e4001f$var$b(), g = $f36d361701e4001f$var$d("LCP"), T = function(r, c) {
                if (g = $f36d361701e4001f$var$d("LCP", 0, r, c), e = $f36d361701e4001f$var$o(t, g, $f36d361701e4001f$export$948521ca5b0e1b17, n.reportAllChanges), a = !1, "soft-navigation" === r) {
                    i = $f36d361701e4001f$var$b(!0);
                    var u = $f36d361701e4001f$var$l(c);
                    s = u && u.startTime ? u.startTime : 0;
                }
                E();
            }, I = function(t) {
                t.forEach(function(t) {
                    if (t) {
                        r && t.navigationId && t.navigationId !== g.navigationId && (a || e(!0), T("soft-navigation", t.navigationId));
                        var n = 0;
                        if (t.navigationId && t.navigationId !== u) {
                            var o = $f36d361701e4001f$var$l(t.navigationId), c = o && o.startTime ? o.startTime : 0;
                            n = Math.max(t.startTime - c, 0);
                        } else n = Math.max(t.startTime - $f36d361701e4001f$var$v(), 0);
                        t.startTime < i.firstHiddenTime && (g.value = n, g.entries = [
                            t
                        ], g.navigationId = t.navigationId || u, e());
                    }
                });
            }, y = function() {
                S(), a || (I(w.takeRecords()), r || w.disconnect(), g.navigationId === h && (a = !0, e(!0)));
            }, E = function() {
                [
                    "keydown",
                    "click"
                ].forEach(function(t) {
                    addEventListener(t, function() {
                        return C();
                    }, !0);
                });
            }, S = function() {
                [
                    "keydown",
                    "click"
                ].forEach(function(t) {
                    removeEventListener(t, function() {
                        return C();
                    }, !0);
                });
            }, C = function() {
                h = g.navigationId, $f36d361701e4001f$var$_(y);
            }, w = $f36d361701e4001f$var$m("largest-contentful-paint", I, n);
            w && (e = $f36d361701e4001f$var$o(t, g, $f36d361701e4001f$export$948521ca5b0e1b17, n.reportAllChanges), E(), $f36d361701e4001f$var$p(function() {
                h = g.navigationId, y();
            }), $f36d361701e4001f$var$f(function(t) {
                T("back-forward-cache", g.navigationId), $f36d361701e4001f$var$c(function() {
                    g.value = performance.now() - t.timeStamp, a = !0, e(!0);
                });
            }), r && $f36d361701e4001f$var$m("soft-navigation", function(t) {
                t.forEach(function(t) {
                    var n = t.navigationId ? $f36d361701e4001f$var$l(t.navigationId) : null;
                    t.navigationId && t.navigationId !== g.navigationId && n && (n.startTime || 0) > s && (a || e(!0), T("soft-navigation", t.navigationId));
                });
            }, n));
        });
    }(function(n) {
        var i = function(t) {
            var n, i = (null === (n = $f36d361701e4001f$var$e()) || void 0 === n ? void 0 : n.navigationId) || "1", a = {
                timeToFirstByte: 0,
                resourceLoadDelay: 0,
                resourceLoadDuration: 0,
                elementRenderDelay: t.value
            };
            if (t.entries.length) {
                var o, c = 0, s = 0, u = 0;
                if (t.navigationId && t.navigationId !== i ? c = u = (o = $f36d361701e4001f$var$l(t.navigationId)) ? o.startTime : 0 : (c = (o = $f36d361701e4001f$var$e()) && o.activationStart ? o.activationStart : 0, s = o && o.responseStart ? o.responseStart : 0), o) {
                    var f = t.entries[t.entries.length - 1], v = f.url && performance.getEntriesByType("resource").filter(function(t) {
                        return t.name === f.url;
                    })[0], d = Math.max(0, s - c), g = Math.max(d, v ? (v.requestStart || v.startTime) - c : 0), m = Math.max(g - u, v ? v.responseEnd - c : 0, 0), p = Math.max(m - u, f ? f.startTime - c : 0, 0);
                    a = {
                        element: $f36d361701e4001f$var$r(f.element),
                        timeToFirstByte: d,
                        resourceLoadDelay: g - d,
                        resourceLoadDuration: m - g,
                        elementRenderDelay: p - m,
                        navigationEntry: o,
                        lcpEntry: f
                    }, f.url && (a.url = f.url), v && (a.lcpResourceEntry = v);
                }
            }
            return Object.assign(t, {
                attribution: a
            });
        }(n);
        t(i);
    }, n);
}, $f36d361701e4001f$export$65c59ea8064668fc = [
    800,
    1800
], $f36d361701e4001f$var$dt = function t(n) {
    document.prerendering ? $f36d361701e4001f$var$C(function() {
        return t(n);
    }) : "complete" !== document.readyState ? addEventListener("load", function() {
        return t(n);
    }, !0) : setTimeout(n, 0);
}, $f36d361701e4001f$var$gt = function(t, n) {
    var i = $f36d361701e4001f$var$g(n = n || {}), a = $f36d361701e4001f$var$d("TTFB"), r = $f36d361701e4001f$var$o(t, a, $f36d361701e4001f$export$65c59ea8064668fc, n.reportAllChanges);
    $f36d361701e4001f$var$dt(function() {
        var c = $f36d361701e4001f$var$e();
        if (c) {
            var s = c.responseStart;
            a.value = Math.max(s - $f36d361701e4001f$var$v(), 0), a.entries = [
                c
            ], r(!0), $f36d361701e4001f$var$f(function() {
                a = $f36d361701e4001f$var$d("TTFB", 0, "back-forward-cache", a.navigationId), (r = $f36d361701e4001f$var$o(t, a, $f36d361701e4001f$export$65c59ea8064668fc, n.reportAllChanges))(!0);
            });
            i && $f36d361701e4001f$var$m("soft-navigation", function(e) {
                e.forEach(function(e) {
                    e.navigationId && ((a = $f36d361701e4001f$var$d("TTFB", 0, "soft-navigation", e.navigationId)).entries = [
                        e
                    ], (r = $f36d361701e4001f$var$o(t, a, $f36d361701e4001f$export$65c59ea8064668fc, n.reportAllChanges))(!0));
                });
            }, n);
        }
    });
}, $f36d361701e4001f$export$33a01e6c5f2c7e33 = function(t, n) {
    $f36d361701e4001f$var$gt(function(n) {
        var e = function(t) {
            var n = {
                waitingDuration: 0,
                cacheDuration: 0,
                dnsDuration: 0,
                connectionDuration: 0,
                requestDuration: 0
            };
            if (t.entries.length) {
                var e = t.entries[0], i = e.activationStart || 0, a = Math.max((e.workerStart || e.fetchStart) - i, 0), r = Math.max(e.domainLookupStart - i || 0, 0), o = Math.max(e.connectStart - i || 0, 0), c = Math.max(e.connectEnd - i || 0, 0);
                n = {
                    waitingDuration: a,
                    cacheDuration: r - a,
                    dnsDuration: o - r,
                    connectionDuration: c - o,
                    requestDuration: t.value - c,
                    navigationEntry: e
                };
            }
            return Object.assign(t, {
                attribution: n
            });
        }(n);
        t(e);
    }, n);
}, $f36d361701e4001f$var$mt = {
    passive: !0,
    capture: !0
}, $f36d361701e4001f$var$pt = new Date, $f36d361701e4001f$var$ht = function(t, n) {
    $f36d361701e4001f$var$it || ($f36d361701e4001f$var$it = n, $f36d361701e4001f$var$at = t, $f36d361701e4001f$var$rt = new Date, $f36d361701e4001f$var$yt(removeEventListener), $f36d361701e4001f$var$Tt());
}, $f36d361701e4001f$var$Tt = function() {
    if ($f36d361701e4001f$var$at >= 0 && $f36d361701e4001f$var$at < $f36d361701e4001f$var$rt - $f36d361701e4001f$var$pt) {
        var t = {
            entryType: "first-input",
            name: $f36d361701e4001f$var$it.type,
            target: $f36d361701e4001f$var$it.target,
            cancelable: $f36d361701e4001f$var$it.cancelable,
            startTime: $f36d361701e4001f$var$it.timeStamp,
            processingStart: $f36d361701e4001f$var$it.timeStamp + $f36d361701e4001f$var$at
        };
        $f36d361701e4001f$var$ot.forEach(function(n) {
            n([
                t
            ]);
        }), $f36d361701e4001f$var$ot = [];
    }
}, $f36d361701e4001f$var$It = function(t) {
    if (t.cancelable) {
        var n = (t.timeStamp > 1e12 ? new Date : performance.now()) - t.timeStamp;
        "pointerdown" == t.type ? function(t, n) {
            var e = function() {
                $f36d361701e4001f$var$ht(t, n), a();
            }, i = function() {
                a();
            }, a = function() {
                removeEventListener("pointerup", e, $f36d361701e4001f$var$mt), removeEventListener("pointercancel", i, $f36d361701e4001f$var$mt);
            };
            addEventListener("pointerup", e, $f36d361701e4001f$var$mt), addEventListener("pointercancel", i, $f36d361701e4001f$var$mt);
        }(n, t) : $f36d361701e4001f$var$ht(n, t);
    }
}, $f36d361701e4001f$var$yt = function(t) {
    [
        "mousedown",
        "keydown",
        "touchstart",
        "pointerdown"
    ].forEach(function(n) {
        return t(n, $f36d361701e4001f$var$It, $f36d361701e4001f$var$mt);
    });
}, $f36d361701e4001f$export$8f7f3c48ca6fbe34 = [
    100,
    300
], $f36d361701e4001f$var$St = function(t, n) {
    var i, a = $f36d361701e4001f$var$g(n = n || {}), r = (null === (i = $f36d361701e4001f$var$e()) || void 0 === i ? void 0 : i.navigationId) || "1";
    $f36d361701e4001f$var$C(function() {
        var e, i = $f36d361701e4001f$var$b(), c = $f36d361701e4001f$var$d("FID"), s = function(s) {
            s.forEach(function(s) {
                var f, v;
                a ? s.navigationId && s.navigationId !== c.navigationId && (f = "soft-navigation", v = s.navigationId, "soft-navigation" === f && (i = $f36d361701e4001f$var$b(!0)), c = $f36d361701e4001f$var$d("FID", 0, f, v), e = $f36d361701e4001f$var$o(t, c, $f36d361701e4001f$export$8f7f3c48ca6fbe34, n.reportAllChanges)) : u.disconnect(), s.startTime < i.firstHiddenTime && (c.value = s.processingStart - s.startTime, c.entries.push(s), c.navigationId = s.navigationId || r, e(!0));
            });
        }, u = $f36d361701e4001f$var$m("first-input", s, n);
        e = $f36d361701e4001f$var$o(t, c, $f36d361701e4001f$export$8f7f3c48ca6fbe34, n.reportAllChanges), u && ($f36d361701e4001f$var$p(function() {
            s(u.takeRecords()), a || u.disconnect();
        }), $f36d361701e4001f$var$f(function() {
            var i;
            c = $f36d361701e4001f$var$d("FID", 0, "back-forward-cache", c.navigationId), e = $f36d361701e4001f$var$o(t, c, $f36d361701e4001f$export$8f7f3c48ca6fbe34, n.reportAllChanges), $f36d361701e4001f$var$ot = [], $f36d361701e4001f$var$at = -1, $f36d361701e4001f$var$it = null, $f36d361701e4001f$var$yt(addEventListener), i = s, $f36d361701e4001f$var$ot.push(i), $f36d361701e4001f$var$Tt();
        }));
    });
}, $f36d361701e4001f$export$39705a25c49af873 = function(t, n) {
    $f36d361701e4001f$var$St(function(n) {
        var e = function(t) {
            var n = t.entries[0], e = {
                eventTarget: $f36d361701e4001f$var$r(n.target),
                eventType: n.name,
                eventTime: n.startTime,
                eventEntry: n,
                loadState: $f36d361701e4001f$var$i(n.startTime)
            };
            return Object.assign(t, {
                attribution: e
            });
        }(n);
        t(e);
    }, n);
};

});


parcelRegister("iF5nx", function(module, exports) {

$parcel$export(module.exports, "B3InjectEncoding", function () { return $d9603a69081c9bb3$export$9b1a75a25efd2ef; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Enumeration of B3 inject encodings */ var $d9603a69081c9bb3$export$9b1a75a25efd2ef;
(function(B3InjectEncoding) {
    B3InjectEncoding[B3InjectEncoding["SINGLE_HEADER"] = 0] = "SINGLE_HEADER";
    B3InjectEncoding[B3InjectEncoding["MULTI_HEADER"] = 1] = "MULTI_HEADER";
})($d9603a69081c9bb3$export$9b1a75a25efd2ef || ($d9603a69081c9bb3$export$9b1a75a25efd2ef = {}));

});

parcelRegister("aUPqT", function(module, exports) {

$parcel$export(module.exports, "B3Propagator", function () { return $7f2707d5f5c1844d$export$747385d38c2fe3e6; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $3WAuq = parcelRequire("3WAuq");

var $8sD7x = parcelRequire("8sD7x");

var $3KOJw = parcelRequire("3KOJw");

var $iL7wP = parcelRequire("iL7wP");

var $iF5nx = parcelRequire("iF5nx");
/**
 * Propagator that extracts B3 context in both single and multi-header variants,
 * with configurable injection format defaulting to B3 single-header. Due to
 * the asymmetry in injection and extraction formats this is not suitable to
 * be implemented as a composite propagator.
 * Based on: https://github.com/openzipkin/b3-propagation
 */ var $7f2707d5f5c1844d$export$747385d38c2fe3e6 = /** @class */ function() {
    function B3Propagator(config) {
        if (config === void 0) config = {};
        this._b3MultiPropagator = new (0, $8sD7x.B3MultiPropagator)();
        this._b3SinglePropagator = new (0, $3KOJw.B3SinglePropagator)();
        if (config.injectEncoding === (0, $iF5nx.B3InjectEncoding).MULTI_HEADER) {
            this._inject = this._b3MultiPropagator.inject;
            this._fields = this._b3MultiPropagator.fields();
        } else {
            this._inject = this._b3SinglePropagator.inject;
            this._fields = this._b3SinglePropagator.fields();
        }
    }
    B3Propagator.prototype.inject = function(context, carrier, setter) {
        if ((0, $3WAuq.isTracingSuppressed)(context)) return;
        this._inject(context, carrier, setter);
    };
    B3Propagator.prototype.extract = function(context, carrier, getter) {
        var header = getter.get(carrier, (0, $iL7wP.B3_CONTEXT_HEADER));
        var b3Context = Array.isArray(header) ? header[0] : header;
        if (b3Context) return this._b3SinglePropagator.extract(context, carrier, getter);
        else return this._b3MultiPropagator.extract(context, carrier, getter);
    };
    B3Propagator.prototype.fields = function() {
        return this._fields;
    };
    return B3Propagator;
}();

});
parcelRegister("8sD7x", function(module, exports) {

$parcel$export(module.exports, "B3MultiPropagator", function () { return $628f48cd553cfc69$export$ffacb7c0473a450a; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $laija = parcelRequire("laija");parcelRequire("ckckF");
var $g4DKS = parcelRequire("g4DKS");
var $kxoQ4 = parcelRequire("kxoQ4");

var $3WAuq = parcelRequire("3WAuq");

var $hasRB = parcelRequire("hasRB");

var $iL7wP = parcelRequire("iL7wP");
var $628f48cd553cfc69$var$VALID_SAMPLED_VALUES = new Set([
    true,
    'true',
    'True',
    '1',
    1
]);
var $628f48cd553cfc69$var$VALID_UNSAMPLED_VALUES = new Set([
    false,
    'false',
    'False',
    '0',
    0
]);
function $628f48cd553cfc69$var$isValidSampledValue(sampled) {
    return sampled === (0, $kxoQ4.TraceFlags).SAMPLED || sampled === (0, $kxoQ4.TraceFlags).NONE;
}
function $628f48cd553cfc69$var$parseHeader(header) {
    return Array.isArray(header) ? header[0] : header;
}
function $628f48cd553cfc69$var$getHeaderValue(carrier, getter, key) {
    var header = getter.get(carrier, key);
    return $628f48cd553cfc69$var$parseHeader(header);
}
function $628f48cd553cfc69$var$getTraceId(carrier, getter) {
    var traceId = $628f48cd553cfc69$var$getHeaderValue(carrier, getter, (0, $iL7wP.X_B3_TRACE_ID));
    if (typeof traceId === 'string') return traceId.padStart(32, '0');
    return '';
}
function $628f48cd553cfc69$var$getSpanId(carrier, getter) {
    var spanId = $628f48cd553cfc69$var$getHeaderValue(carrier, getter, (0, $iL7wP.X_B3_SPAN_ID));
    if (typeof spanId === 'string') return spanId;
    return '';
}
function $628f48cd553cfc69$var$getDebug(carrier, getter) {
    var debug = $628f48cd553cfc69$var$getHeaderValue(carrier, getter, (0, $iL7wP.X_B3_FLAGS));
    return debug === '1' ? '1' : undefined;
}
function $628f48cd553cfc69$var$getTraceFlags(carrier, getter) {
    var traceFlags = $628f48cd553cfc69$var$getHeaderValue(carrier, getter, (0, $iL7wP.X_B3_SAMPLED));
    var debug = $628f48cd553cfc69$var$getDebug(carrier, getter);
    if (debug === '1' || $628f48cd553cfc69$var$VALID_SAMPLED_VALUES.has(traceFlags)) return (0, $kxoQ4.TraceFlags).SAMPLED;
    if (traceFlags === undefined || $628f48cd553cfc69$var$VALID_UNSAMPLED_VALUES.has(traceFlags)) return (0, $kxoQ4.TraceFlags).NONE;
    // This indicates to isValidSampledValue that this is not valid
    return;
}
/**
 * Propagator for the B3 multiple-header HTTP format.
 * Based on: https://github.com/openzipkin/b3-propagation
 */ var $628f48cd553cfc69$export$ffacb7c0473a450a = /** @class */ function() {
    function B3MultiPropagator() {}
    B3MultiPropagator.prototype.inject = function(context, carrier, setter) {
        var spanContext = (0, $g4DKS.trace).getSpanContext(context);
        if (!spanContext || !(0, $laija.isSpanContextValid)(spanContext) || (0, $3WAuq.isTracingSuppressed)(context)) return;
        var debug = context.getValue((0, $hasRB.B3_DEBUG_FLAG_KEY));
        setter.set(carrier, (0, $iL7wP.X_B3_TRACE_ID), spanContext.traceId);
        setter.set(carrier, (0, $iL7wP.X_B3_SPAN_ID), spanContext.spanId);
        // According to the B3 spec, if the debug flag is set,
        // the sampled flag shouldn't be propagated as well.
        if (debug === '1') setter.set(carrier, (0, $iL7wP.X_B3_FLAGS), debug);
        else if (spanContext.traceFlags !== undefined) // We set the header only if there is an existing sampling decision.
        // Otherwise we will omit it => Absent.
        setter.set(carrier, (0, $iL7wP.X_B3_SAMPLED), ((0, $kxoQ4.TraceFlags).SAMPLED & spanContext.traceFlags) === (0, $kxoQ4.TraceFlags).SAMPLED ? '1' : '0');
    };
    B3MultiPropagator.prototype.extract = function(context, carrier, getter) {
        var traceId = $628f48cd553cfc69$var$getTraceId(carrier, getter);
        var spanId = $628f48cd553cfc69$var$getSpanId(carrier, getter);
        var traceFlags = $628f48cd553cfc69$var$getTraceFlags(carrier, getter);
        var debug = $628f48cd553cfc69$var$getDebug(carrier, getter);
        if ((0, $laija.isValidTraceId)(traceId) && (0, $laija.isValidSpanId)(spanId) && $628f48cd553cfc69$var$isValidSampledValue(traceFlags)) {
            context = context.setValue((0, $hasRB.B3_DEBUG_FLAG_KEY), debug);
            return (0, $g4DKS.trace).setSpanContext(context, {
                traceId: traceId,
                spanId: spanId,
                isRemote: true,
                traceFlags: traceFlags
            });
        }
        return context;
    };
    B3MultiPropagator.prototype.fields = function() {
        return [
            (0, $iL7wP.X_B3_TRACE_ID),
            (0, $iL7wP.X_B3_SPAN_ID),
            (0, $iL7wP.X_B3_FLAGS),
            (0, $iL7wP.X_B3_SAMPLED),
            (0, $iL7wP.X_B3_PARENT_SPAN_ID)
        ];
    };
    return B3MultiPropagator;
}();

});
parcelRegister("hasRB", function(module, exports) {

$parcel$export(module.exports, "B3_DEBUG_FLAG_KEY", function () { return $c7f9c290ec073d85$export$836548966ac99b89; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $jVu0G = parcelRequire("jVu0G");
var $c7f9c290ec073d85$export$836548966ac99b89 = (0, $jVu0G.createContextKey)('OpenTelemetry Context Key B3 Debug Flag');

});

parcelRegister("iL7wP", function(module, exports) {

$parcel$export(module.exports, "B3_CONTEXT_HEADER", function () { return $da8274c2e327d12f$export$94e6935bdd9b0818; });
$parcel$export(module.exports, "X_B3_TRACE_ID", function () { return $da8274c2e327d12f$export$1f4cf23c514997ff; });
$parcel$export(module.exports, "X_B3_SPAN_ID", function () { return $da8274c2e327d12f$export$19a1ecbf87c23d34; });
$parcel$export(module.exports, "X_B3_SAMPLED", function () { return $da8274c2e327d12f$export$ea73cf0e861a50ec; });
$parcel$export(module.exports, "X_B3_PARENT_SPAN_ID", function () { return $da8274c2e327d12f$export$6e96159c1ba2392; });
$parcel$export(module.exports, "X_B3_FLAGS", function () { return $da8274c2e327d12f$export$e1e8a5fee7ddb0ec; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** B3 single-header key */ var $da8274c2e327d12f$export$94e6935bdd9b0818 = 'b3';
var $da8274c2e327d12f$export$1f4cf23c514997ff = 'x-b3-traceid';
var $da8274c2e327d12f$export$19a1ecbf87c23d34 = 'x-b3-spanid';
var $da8274c2e327d12f$export$ea73cf0e861a50ec = 'x-b3-sampled';
var $da8274c2e327d12f$export$6e96159c1ba2392 = 'x-b3-parentspanid';
var $da8274c2e327d12f$export$e1e8a5fee7ddb0ec = 'x-b3-flags';

});


parcelRegister("3KOJw", function(module, exports) {

$parcel$export(module.exports, "B3SinglePropagator", function () { return $2bbd058ce87c6b93$export$9292d1c5b0a43a99; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $laija = parcelRequire("laija");parcelRequire("ckckF");
var $g4DKS = parcelRequire("g4DKS");
var $kxoQ4 = parcelRequire("kxoQ4");

var $3WAuq = parcelRequire("3WAuq");

var $hasRB = parcelRequire("hasRB");

var $iL7wP = parcelRequire("iL7wP");
var $2bbd058ce87c6b93$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $2bbd058ce87c6b93$var$B3_CONTEXT_REGEX = /((?:[0-9a-f]{16}){1,2})-([0-9a-f]{16})(?:-([01d](?![0-9a-f])))?(?:-([0-9a-f]{16}))?/;
var $2bbd058ce87c6b93$var$PADDING = '0'.repeat(16);
var $2bbd058ce87c6b93$var$SAMPLED_VALUES = new Set([
    'd',
    '1'
]);
var $2bbd058ce87c6b93$var$DEBUG_STATE = 'd';
function $2bbd058ce87c6b93$var$convertToTraceId128(traceId) {
    return traceId.length === 32 ? traceId : "" + $2bbd058ce87c6b93$var$PADDING + traceId;
}
function $2bbd058ce87c6b93$var$convertToTraceFlags(samplingState) {
    if (samplingState && $2bbd058ce87c6b93$var$SAMPLED_VALUES.has(samplingState)) return (0, $kxoQ4.TraceFlags).SAMPLED;
    return (0, $kxoQ4.TraceFlags).NONE;
}
/**
 * Propagator for the B3 single-header HTTP format.
 * Based on: https://github.com/openzipkin/b3-propagation
 */ var $2bbd058ce87c6b93$export$9292d1c5b0a43a99 = /** @class */ function() {
    function B3SinglePropagator() {}
    B3SinglePropagator.prototype.inject = function(context, carrier, setter) {
        var spanContext = (0, $g4DKS.trace).getSpanContext(context);
        if (!spanContext || !(0, $laija.isSpanContextValid)(spanContext) || (0, $3WAuq.isTracingSuppressed)(context)) return;
        var samplingState = context.getValue((0, $hasRB.B3_DEBUG_FLAG_KEY)) || spanContext.traceFlags & 0x1;
        var value = spanContext.traceId + "-" + spanContext.spanId + "-" + samplingState;
        setter.set(carrier, (0, $iL7wP.B3_CONTEXT_HEADER), value);
    };
    B3SinglePropagator.prototype.extract = function(context, carrier, getter) {
        var header = getter.get(carrier, (0, $iL7wP.B3_CONTEXT_HEADER));
        var b3Context = Array.isArray(header) ? header[0] : header;
        if (typeof b3Context !== 'string') return context;
        var match = b3Context.match($2bbd058ce87c6b93$var$B3_CONTEXT_REGEX);
        if (!match) return context;
        var _a = $2bbd058ce87c6b93$var$__read(match, 4), extractedTraceId = _a[1], spanId = _a[2], samplingState = _a[3];
        var traceId = $2bbd058ce87c6b93$var$convertToTraceId128(extractedTraceId);
        if (!(0, $laija.isValidTraceId)(traceId) || !(0, $laija.isValidSpanId)(spanId)) return context;
        var traceFlags = $2bbd058ce87c6b93$var$convertToTraceFlags(samplingState);
        if (samplingState === $2bbd058ce87c6b93$var$DEBUG_STATE) context = context.setValue((0, $hasRB.B3_DEBUG_FLAG_KEY), samplingState);
        return (0, $g4DKS.trace).setSpanContext(context, {
            traceId: traceId,
            spanId: spanId,
            isRemote: true,
            traceFlags: traceFlags
        });
    };
    B3SinglePropagator.prototype.fields = function() {
        return [
            (0, $iL7wP.B3_CONTEXT_HEADER)
        ];
    };
    return B3SinglePropagator;
}();

});


parcelRegister("3IGjv", function(module, exports) {
$parcel$export(module.exports, "AWSXRayPropagator", function () { return (parcelRequire("9xOok")).AWSXRayPropagator; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ parcelRequire("9xOok");

});
parcelRegister("9xOok", function(module, exports) {

$parcel$export(module.exports, "AWSXRayPropagator", function () { return $6f2e48d443cac5ec$export$991b302bc9e7a8d2; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gRjnF = parcelRequire("gRjnF");
var $laija = parcelRequire("laija");parcelRequire("ckckF");
var $g4DKS = parcelRequire("g4DKS");
var $kxoQ4 = parcelRequire("kxoQ4");
var $6f2e48d443cac5ec$export$37ee519acfd93cf7 = 'x-amzn-trace-id';
var $6f2e48d443cac5ec$var$TRACE_HEADER_DELIMITER = ';';
var $6f2e48d443cac5ec$var$KV_DELIMITER = '=';
var $6f2e48d443cac5ec$var$TRACE_ID_KEY = 'Root';
var $6f2e48d443cac5ec$var$TRACE_ID_LENGTH = 35;
var $6f2e48d443cac5ec$var$TRACE_ID_VERSION = '1';
var $6f2e48d443cac5ec$var$TRACE_ID_DELIMITER = '-';
var $6f2e48d443cac5ec$var$TRACE_ID_DELIMITER_INDEX_1 = 1;
var $6f2e48d443cac5ec$var$TRACE_ID_DELIMITER_INDEX_2 = 10;
var $6f2e48d443cac5ec$var$TRACE_ID_FIRST_PART_LENGTH = 8;
var $6f2e48d443cac5ec$var$PARENT_ID_KEY = 'Parent';
var $6f2e48d443cac5ec$var$SAMPLED_FLAG_KEY = 'Sampled';
var $6f2e48d443cac5ec$var$IS_SAMPLED = '1';
var $6f2e48d443cac5ec$var$NOT_SAMPLED = '0';
/**
 * Implementation of the AWS X-Ray Trace Header propagation protocol. See <a href=
 * https://https://docs.aws.amazon.com/xray/latest/devguide/xray-concepts.html#xray-concepts-tracingheader>AWS
 * Tracing header spec</a>
 *
 * An example AWS Xray Tracing Header is shown below:
 * X-Amzn-Trace-Id: Root=1-5759e988-bd862e3fe1be46a994272793;Parent=53995c3f42cd8ad8;Sampled=1
 */ var $6f2e48d443cac5ec$export$991b302bc9e7a8d2 = /** @class */ function() {
    function AWSXRayPropagator() {}
    AWSXRayPropagator.prototype.inject = function(context, carrier, setter) {
        var _a;
        var spanContext = (_a = (0, $g4DKS.trace).getSpan(context)) === null || _a === void 0 ? void 0 : _a.spanContext();
        if (!spanContext || !(0, $laija.isSpanContextValid)(spanContext)) return;
        var otTraceId = spanContext.traceId;
        var timestamp = otTraceId.substring(0, $6f2e48d443cac5ec$var$TRACE_ID_FIRST_PART_LENGTH);
        var randomNumber = otTraceId.substring($6f2e48d443cac5ec$var$TRACE_ID_FIRST_PART_LENGTH);
        var parentId = spanContext.spanId;
        var samplingFlag = ((0, $kxoQ4.TraceFlags).SAMPLED & spanContext.traceFlags) === (0, $kxoQ4.TraceFlags).SAMPLED ? $6f2e48d443cac5ec$var$IS_SAMPLED : $6f2e48d443cac5ec$var$NOT_SAMPLED;
        // TODO: Add OT trace state to the X-Ray trace header
        var traceHeader = "Root=1-" + timestamp + "-" + randomNumber + ";Parent=" + parentId + ";Sampled=" + samplingFlag;
        setter.set(carrier, $6f2e48d443cac5ec$export$37ee519acfd93cf7, traceHeader);
    };
    AWSXRayPropagator.prototype.extract = function(context, carrier, getter) {
        var spanContext = this.getSpanContextFromHeader(carrier, getter);
        if (!(0, $laija.isSpanContextValid)(spanContext)) return context;
        return (0, $g4DKS.trace).setSpan(context, (0, $g4DKS.trace).wrapSpanContext(spanContext));
    };
    AWSXRayPropagator.prototype.fields = function() {
        return [
            $6f2e48d443cac5ec$export$37ee519acfd93cf7
        ];
    };
    AWSXRayPropagator.prototype.getSpanContextFromHeader = function(carrier, getter) {
        var headerKeys = getter.keys(carrier);
        var relevantHeaderKey = headerKeys.find(function(e) {
            return e.toLowerCase() === $6f2e48d443cac5ec$export$37ee519acfd93cf7;
        });
        if (!relevantHeaderKey) return 0, $gRjnF.INVALID_SPAN_CONTEXT;
        var traceHeader = getter.get(carrier, relevantHeaderKey);
        if (!traceHeader || typeof traceHeader !== 'string') return 0, $gRjnF.INVALID_SPAN_CONTEXT;
        var pos = 0;
        var trimmedPart;
        var parsedTraceId = (0, $gRjnF.INVALID_TRACEID);
        var parsedSpanId = (0, $gRjnF.INVALID_SPANID);
        var parsedTraceFlags = null;
        while(pos < traceHeader.length){
            var delimiterIndex = traceHeader.indexOf($6f2e48d443cac5ec$var$TRACE_HEADER_DELIMITER, pos);
            if (delimiterIndex >= 0) {
                trimmedPart = traceHeader.substring(pos, delimiterIndex).trim();
                pos = delimiterIndex + 1;
            } else {
                //last part
                trimmedPart = traceHeader.substring(pos).trim();
                pos = traceHeader.length;
            }
            var equalsIndex = trimmedPart.indexOf($6f2e48d443cac5ec$var$KV_DELIMITER);
            var value = trimmedPart.substring(equalsIndex + 1);
            if (trimmedPart.startsWith($6f2e48d443cac5ec$var$TRACE_ID_KEY)) parsedTraceId = AWSXRayPropagator._parseTraceId(value);
            else if (trimmedPart.startsWith($6f2e48d443cac5ec$var$PARENT_ID_KEY)) parsedSpanId = AWSXRayPropagator._parseSpanId(value);
            else if (trimmedPart.startsWith($6f2e48d443cac5ec$var$SAMPLED_FLAG_KEY)) parsedTraceFlags = AWSXRayPropagator._parseTraceFlag(value);
        }
        if (parsedTraceFlags === null) return 0, $gRjnF.INVALID_SPAN_CONTEXT;
        var resultSpanContext = {
            traceId: parsedTraceId,
            spanId: parsedSpanId,
            traceFlags: parsedTraceFlags,
            isRemote: true
        };
        if (!(0, $laija.isSpanContextValid)(resultSpanContext)) return 0, $gRjnF.INVALID_SPAN_CONTEXT;
        return resultSpanContext;
    };
    AWSXRayPropagator._parseTraceId = function(xrayTraceId) {
        // Check length of trace id
        if (xrayTraceId.length !== $6f2e48d443cac5ec$var$TRACE_ID_LENGTH) return 0, $gRjnF.INVALID_TRACEID;
        // Check version trace id version
        if (!xrayTraceId.startsWith($6f2e48d443cac5ec$var$TRACE_ID_VERSION)) return 0, $gRjnF.INVALID_TRACEID;
        // Check delimiters
        if (xrayTraceId.charAt($6f2e48d443cac5ec$var$TRACE_ID_DELIMITER_INDEX_1) !== $6f2e48d443cac5ec$var$TRACE_ID_DELIMITER || xrayTraceId.charAt($6f2e48d443cac5ec$var$TRACE_ID_DELIMITER_INDEX_2) !== $6f2e48d443cac5ec$var$TRACE_ID_DELIMITER) return 0, $gRjnF.INVALID_TRACEID;
        var epochPart = xrayTraceId.substring($6f2e48d443cac5ec$var$TRACE_ID_DELIMITER_INDEX_1 + 1, $6f2e48d443cac5ec$var$TRACE_ID_DELIMITER_INDEX_2);
        var uniquePart = xrayTraceId.substring($6f2e48d443cac5ec$var$TRACE_ID_DELIMITER_INDEX_2 + 1, $6f2e48d443cac5ec$var$TRACE_ID_LENGTH);
        var resTraceId = epochPart + uniquePart;
        // Check the content of trace id
        if (!(0, $laija.isValidTraceId)(resTraceId)) return 0, $gRjnF.INVALID_TRACEID;
        return resTraceId;
    };
    AWSXRayPropagator._parseSpanId = function(xrayParentId) {
        return (0, $laija.isValidSpanId)(xrayParentId) ? xrayParentId : (0, $gRjnF.INVALID_SPANID);
    };
    AWSXRayPropagator._parseTraceFlag = function(xraySampledFlag) {
        if (xraySampledFlag === $6f2e48d443cac5ec$var$NOT_SAMPLED) return (0, $kxoQ4.TraceFlags).NONE;
        if (xraySampledFlag === $6f2e48d443cac5ec$var$IS_SAMPLED) return (0, $kxoQ4.TraceFlags).SAMPLED;
        return null;
    };
    return AWSXRayPropagator;
}();

});


parcelRegister("lqIkD", function(module, exports) {

module.exports = (parcelRequire("zmwvs"))($parcel$resolve("i1Mgs")).then(()=>parcelRequire('cduY9'));

});
parcelRegister("zmwvs", function(module, exports) {
"use strict";

var $hI40B = parcelRequire("hI40B");
module.exports = $hI40B(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

});
parcelRegister("hI40B", function(module, exports) {
"use strict";
var $ce49a7c510e8503d$var$cachedBundles = {};
var $ce49a7c510e8503d$var$cachedPreloads = {};
var $ce49a7c510e8503d$var$cachedPrefetches = {};
function $ce49a7c510e8503d$var$getCache(type) {
    switch(type){
        case 'preload':
            return $ce49a7c510e8503d$var$cachedPreloads;
        case 'prefetch':
            return $ce49a7c510e8503d$var$cachedPrefetches;
        default:
            return $ce49a7c510e8503d$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $ce49a7c510e8503d$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});




parcelRegister("fxvWq", function(module, exports) {
"use strict";

var $cQcg2 = parcelRequire("cQcg2");
Object.keys($cQcg2).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $cQcg2[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cQcg2[key];
        }
    });
});

var $pg1qm = parcelRequire("pg1qm");
Object.keys($pg1qm).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $pg1qm[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $pg1qm[key];
        }
    });
});

var $cBVis = parcelRequire("cBVis");
Object.keys($cBVis).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $cBVis[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cBVis[key];
        }
    });
});

var $ghcs4 = parcelRequire("ghcs4");
Object.keys($ghcs4).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $ghcs4[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ghcs4[key];
        }
    });
});

var $hmVkE = parcelRequire("hmVkE");
Object.keys($hmVkE).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hmVkE[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hmVkE[key];
        }
    });
});

var $hveYv = parcelRequire("hveYv");
Object.keys($hveYv).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hveYv[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hveYv[key];
        }
    });
});

var $84Jkb = parcelRequire("84Jkb");
Object.keys($84Jkb).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $84Jkb[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $84Jkb[key];
        }
    });
});

var $fIUbm = parcelRequire("fIUbm");
Object.keys($fIUbm).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $fIUbm[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fIUbm[key];
        }
    });
});

var $7IMv5 = parcelRequire("7IMv5");
Object.keys($7IMv5).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7IMv5[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7IMv5[key];
        }
    });
});

var $3WSWZ = parcelRequire("3WSWZ");
Object.keys($3WSWZ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $3WSWZ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3WSWZ[key];
        }
    });
});

var $iiBmk = parcelRequire("iiBmk");
Object.keys($iiBmk).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $iiBmk[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $iiBmk[key];
        }
    });
});

var $joePE = parcelRequire("joePE");
Object.keys($joePE).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $joePE[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $joePE[key];
        }
    });
});

var $hik0U = parcelRequire("hik0U");
Object.keys($hik0U).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hik0U[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hik0U[key];
        }
    });
});

var $hXeRg = parcelRequire("hXeRg");
Object.keys($hXeRg).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hXeRg[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hXeRg[key];
        }
    });
});

var $gnEyH = parcelRequire("gnEyH");
Object.keys($gnEyH).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $gnEyH[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gnEyH[key];
        }
    });
});

var $9ORvi = parcelRequire("9ORvi");
Object.keys($9ORvi).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $9ORvi[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9ORvi[key];
        }
    });
});

var $6klPK = parcelRequire("6klPK");
Object.keys($6klPK).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $6klPK[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6klPK[key];
        }
    });
});

var $gsQ3F = parcelRequire("gsQ3F");
Object.keys($gsQ3F).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $gsQ3F[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gsQ3F[key];
        }
    });
});

var $02yAu = parcelRequire("02yAu");
Object.keys($02yAu).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $02yAu[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $02yAu[key];
        }
    });
});

var $oVfas = parcelRequire("oVfas");
Object.keys($oVfas).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $oVfas[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $oVfas[key];
        }
    });
});

var $jSXjx = parcelRequire("jSXjx");
Object.keys($jSXjx).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $jSXjx[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $jSXjx[key];
        }
    });
});

var $1wnvX = parcelRequire("1wnvX");
Object.keys($1wnvX).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $1wnvX[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1wnvX[key];
        }
    });
});

var $fctE0 = parcelRequire("fctE0");
Object.keys($fctE0).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $fctE0[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fctE0[key];
        }
    });
});

var $iPbge = parcelRequire("iPbge");
Object.keys($iPbge).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $iPbge[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $iPbge[key];
        }
    });
});

var $e7CD4 = parcelRequire("e7CD4");
Object.keys($e7CD4).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $e7CD4[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $e7CD4[key];
        }
    });
});

var $eUT4w = parcelRequire("eUT4w");
Object.keys($eUT4w).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $eUT4w[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $eUT4w[key];
        }
    });
});

var $ilnvA = parcelRequire("ilnvA");
Object.keys($ilnvA).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $ilnvA[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ilnvA[key];
        }
    });
});

var $gDfuA = parcelRequire("gDfuA");
Object.keys($gDfuA).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $gDfuA[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gDfuA[key];
        }
    });
});

var $bnwnB = parcelRequire("bnwnB");
Object.keys($bnwnB).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $bnwnB[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bnwnB[key];
        }
    });
});

var $7t70d = parcelRequire("7t70d");
Object.keys($7t70d).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7t70d[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7t70d[key];
        }
    });
});

var $exRu4 = parcelRequire("exRu4");
Object.keys($exRu4).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $exRu4[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $exRu4[key];
        }
    });
});

var $fpdO5 = parcelRequire("fpdO5");
Object.keys($fpdO5).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $fpdO5[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fpdO5[key];
        }
    });
});

var $55YJb = parcelRequire("55YJb");
Object.keys($55YJb).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $55YJb[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $55YJb[key];
        }
    });
});

var $cOBKs = parcelRequire("cOBKs");
Object.keys($cOBKs).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $cOBKs[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cOBKs[key];
        }
    });
});

var $klNiQ = parcelRequire("klNiQ");
Object.keys($klNiQ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $klNiQ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $klNiQ[key];
        }
    });
});

var $efBf4 = parcelRequire("efBf4");
Object.keys($efBf4).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $efBf4[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $efBf4[key];
        }
    });
});

var $hfEAx = parcelRequire("hfEAx");
Object.keys($hfEAx).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hfEAx[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hfEAx[key];
        }
    });
});

var $guHFh = parcelRequire("guHFh");
Object.keys($guHFh).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $guHFh[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $guHFh[key];
        }
    });
});

var $5np6K = parcelRequire("5np6K");
Object.keys($5np6K).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5np6K[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5np6K[key];
        }
    });
});

var $dorkS = parcelRequire("dorkS");
Object.keys($dorkS).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $dorkS[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dorkS[key];
        }
    });
});

var $fZxIC = parcelRequire("fZxIC");
Object.keys($fZxIC).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $fZxIC[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fZxIC[key];
        }
    });
});

var $aB3EM = parcelRequire("aB3EM");
Object.keys($aB3EM).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $aB3EM[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $aB3EM[key];
        }
    });
});

var $eZBWn = parcelRequire("eZBWn");
Object.keys($eZBWn).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $eZBWn[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $eZBWn[key];
        }
    });
});

var $2ZLo2 = parcelRequire("2ZLo2");
Object.keys($2ZLo2).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $2ZLo2[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2ZLo2[key];
        }
    });
});

var $bHENy = parcelRequire("bHENy");
Object.keys($bHENy).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $bHENy[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bHENy[key];
        }
    });
});

var $j4hO1 = parcelRequire("j4hO1");
Object.keys($j4hO1).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $j4hO1[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $j4hO1[key];
        }
    });
});

var $K9CGJ = parcelRequire("K9CGJ");
Object.keys($K9CGJ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $K9CGJ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $K9CGJ[key];
        }
    });
});

var $kWnFf = parcelRequire("kWnFf");
Object.keys($kWnFf).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $kWnFf[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $kWnFf[key];
        }
    });
});

var $5Xvkn = parcelRequire("5Xvkn");
Object.keys($5Xvkn).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5Xvkn[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5Xvkn[key];
        }
    });
});

var $ikjzL = parcelRequire("ikjzL");
Object.keys($ikjzL).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $ikjzL[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ikjzL[key];
        }
    });
});

var $4oAaJ = parcelRequire("4oAaJ");
Object.keys($4oAaJ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4oAaJ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4oAaJ[key];
        }
    });
});

var $4cpr6 = parcelRequire("4cpr6");
Object.keys($4cpr6).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4cpr6[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4cpr6[key];
        }
    });
});

var $aSGj5 = parcelRequire("aSGj5");
Object.keys($aSGj5).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $aSGj5[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $aSGj5[key];
        }
    });
});

var $luaY7 = parcelRequire("luaY7");
Object.keys($luaY7).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $luaY7[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $luaY7[key];
        }
    });
});

var $gG2Rj = parcelRequire("gG2Rj");
Object.keys($gG2Rj).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $gG2Rj[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gG2Rj[key];
        }
    });
});

var $5pWy6 = parcelRequire("5pWy6");
Object.keys($5pWy6).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5pWy6[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5pWy6[key];
        }
    });
});

var $7Kxax = parcelRequire("7Kxax");
Object.keys($7Kxax).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7Kxax[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7Kxax[key];
        }
    });
});

var $kTeTI = parcelRequire("kTeTI");
Object.keys($kTeTI).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $kTeTI[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $kTeTI[key];
        }
    });
});

var $bBRPg = parcelRequire("bBRPg");
Object.keys($bBRPg).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $bBRPg[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bBRPg[key];
        }
    });
});

var $ldkTO = parcelRequire("ldkTO");
Object.keys($ldkTO).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $ldkTO[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ldkTO[key];
        }
    });
});

var $frXCW = parcelRequire("frXCW");
Object.keys($frXCW).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $frXCW[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $frXCW[key];
        }
    });
});

var $k041Q = parcelRequire("k041Q");
Object.keys($k041Q).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $k041Q[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $k041Q[key];
        }
    });
});

var $kOusr = parcelRequire("kOusr");
Object.keys($kOusr).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $kOusr[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $kOusr[key];
        }
    });
});

var $9YOIL = parcelRequire("9YOIL");
Object.keys($9YOIL).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $9YOIL[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9YOIL[key];
        }
    });
});

var $dtOy9 = parcelRequire("dtOy9");
Object.keys($dtOy9).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $dtOy9[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dtOy9[key];
        }
    });
});

var $d338J = parcelRequire("d338J");
Object.keys($d338J).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $d338J[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $d338J[key];
        }
    });
});

var $dT9KE = parcelRequire("dT9KE");
Object.keys($dT9KE).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $dT9KE[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dT9KE[key];
        }
    });
});

var $j2wrH = parcelRequire("j2wrH");
Object.keys($j2wrH).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $j2wrH[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $j2wrH[key];
        }
    });
});

var $aQGj5 = parcelRequire("aQGj5");
Object.keys($aQGj5).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $aQGj5[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $aQGj5[key];
        }
    });
});

var $b9Nks = parcelRequire("b9Nks");
Object.keys($b9Nks).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $b9Nks[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $b9Nks[key];
        }
    });
});

var $450S4 = parcelRequire("450S4");
Object.keys($450S4).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $450S4[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $450S4[key];
        }
    });
});

var $eEnm8 = parcelRequire("eEnm8");
Object.keys($eEnm8).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $eEnm8[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $eEnm8[key];
        }
    });
});

var $f41HL = parcelRequire("f41HL");
Object.keys($f41HL).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $f41HL[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $f41HL[key];
        }
    });
});

var $fIylp = parcelRequire("fIylp");
Object.keys($fIylp).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $fIylp[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fIylp[key];
        }
    });
});

var $iKKb4 = parcelRequire("iKKb4");
Object.keys($iKKb4).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $iKKb4[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $iKKb4[key];
        }
    });
});

var $bbwBU = parcelRequire("bbwBU");
Object.keys($bbwBU).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $bbwBU[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bbwBU[key];
        }
    });
});

var $egMd8 = parcelRequire("egMd8");
Object.keys($egMd8).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $egMd8[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $egMd8[key];
        }
    });
});

var $kvN19 = parcelRequire("kvN19");
Object.keys($kvN19).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $kvN19[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $kvN19[key];
        }
    });
});

var $kScSL = parcelRequire("kScSL");
Object.keys($kScSL).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $kScSL[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $kScSL[key];
        }
    });
});

var $9HF9I = parcelRequire("9HF9I");
Object.keys($9HF9I).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $9HF9I[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9HF9I[key];
        }
    });
});

var $1jHsG = parcelRequire("1jHsG");
Object.keys($1jHsG).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $1jHsG[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1jHsG[key];
        }
    });
});

var $g4Yc6 = parcelRequire("g4Yc6");
Object.keys($g4Yc6).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $g4Yc6[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $g4Yc6[key];
        }
    });
});

var $vaZLu = parcelRequire("vaZLu");
Object.keys($vaZLu).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $vaZLu[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $vaZLu[key];
        }
    });
});

var $7mqxe = parcelRequire("7mqxe");
Object.keys($7mqxe).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7mqxe[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7mqxe[key];
        }
    });
});

var $i19EH = parcelRequire("i19EH");
Object.keys($i19EH).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $i19EH[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $i19EH[key];
        }
    });
});

var $dGxHQ = parcelRequire("dGxHQ");
Object.keys($dGxHQ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $dGxHQ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dGxHQ[key];
        }
    });
});

var $43yjM = parcelRequire("43yjM");
Object.keys($43yjM).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $43yjM[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $43yjM[key];
        }
    });
});

var $hKW5C = parcelRequire("hKW5C");
Object.keys($hKW5C).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hKW5C[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hKW5C[key];
        }
    });
});

var $hypv5 = parcelRequire("hypv5");
Object.keys($hypv5).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hypv5[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hypv5[key];
        }
    });
});

var $dJJxk = parcelRequire("dJJxk");
Object.keys($dJJxk).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $dJJxk[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dJJxk[key];
        }
    });
});

var $96SbU = parcelRequire("96SbU");
Object.keys($96SbU).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $96SbU[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $96SbU[key];
        }
    });
});

var $aSryK = parcelRequire("aSryK");
Object.keys($aSryK).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $aSryK[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $aSryK[key];
        }
    });
});

var $ieGzH = parcelRequire("ieGzH");
Object.keys($ieGzH).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $ieGzH[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ieGzH[key];
        }
    });
});

var $9l3oy = parcelRequire("9l3oy");
Object.keys($9l3oy).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $9l3oy[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9l3oy[key];
        }
    });
});

var $dEs1B = parcelRequire("dEs1B");
Object.keys($dEs1B).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $dEs1B[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dEs1B[key];
        }
    });
});

var $h65sp = parcelRequire("h65sp");
Object.keys($h65sp).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $h65sp[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $h65sp[key];
        }
    });
});

var $8S0vk = parcelRequire("8S0vk");
Object.keys($8S0vk).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $8S0vk[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8S0vk[key];
        }
    });
});

var $wNfjT = parcelRequire("wNfjT");
Object.keys($wNfjT).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $wNfjT[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $wNfjT[key];
        }
    });
});

var $aY23c = parcelRequire("aY23c");
Object.keys($aY23c).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $aY23c[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $aY23c[key];
        }
    });
});

var $7VWhP = parcelRequire("7VWhP");
Object.keys($7VWhP).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7VWhP[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7VWhP[key];
        }
    });
});

var $c5nsv = parcelRequire("c5nsv");
Object.keys($c5nsv).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $c5nsv[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $c5nsv[key];
        }
    });
});

var $5K7uY = parcelRequire("5K7uY");
Object.keys($5K7uY).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5K7uY[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5K7uY[key];
        }
    });
});

var $azNIw = parcelRequire("azNIw");
Object.keys($azNIw).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $azNIw[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $azNIw[key];
        }
    });
});

var $lL9om = parcelRequire("lL9om");
Object.keys($lL9om).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $lL9om[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $lL9om[key];
        }
    });
});

var $bUAAN = parcelRequire("bUAAN");
Object.keys($bUAAN).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $bUAAN[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bUAAN[key];
        }
    });
});

var $iiMzW = parcelRequire("iiMzW");
Object.keys($iiMzW).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $iiMzW[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $iiMzW[key];
        }
    });
});

var $iys0V = parcelRequire("iys0V");
Object.keys($iys0V).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $iys0V[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $iys0V[key];
        }
    });
});

var $ggy2b = parcelRequire("ggy2b");
Object.keys($ggy2b).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $ggy2b[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ggy2b[key];
        }
    });
});

var $4akuu = parcelRequire("4akuu");
Object.keys($4akuu).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4akuu[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4akuu[key];
        }
    });
});

var $kLebH = parcelRequire("kLebH");
Object.keys($kLebH).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $kLebH[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $kLebH[key];
        }
    });
});

var $jGg0G = parcelRequire("jGg0G");
Object.keys($jGg0G).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $jGg0G[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $jGg0G[key];
        }
    });
});

var $477Vo = parcelRequire("477Vo");
Object.keys($477Vo).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $477Vo[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $477Vo[key];
        }
    });
});

var $dXNmw = parcelRequire("dXNmw");
Object.keys($dXNmw).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $dXNmw[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dXNmw[key];
        }
    });
});

var $4haoU = parcelRequire("4haoU");
Object.keys($4haoU).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4haoU[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4haoU[key];
        }
    });
});

var $iLwCL = parcelRequire("iLwCL");
Object.keys($iLwCL).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $iLwCL[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $iLwCL[key];
        }
    });
});

var $7oPq9 = parcelRequire("7oPq9");
Object.keys($7oPq9).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7oPq9[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7oPq9[key];
        }
    });
});

var $5qKoS = parcelRequire("5qKoS");
Object.keys($5qKoS).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5qKoS[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5qKoS[key];
        }
    });
});

var $eZ7WM = parcelRequire("eZ7WM");
Object.keys($eZ7WM).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $eZ7WM[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $eZ7WM[key];
        }
    });
});

var $fKesV = parcelRequire("fKesV");
Object.keys($fKesV).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $fKesV[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fKesV[key];
        }
    });
});

var $d9lEw = parcelRequire("d9lEw");
Object.keys($d9lEw).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $d9lEw[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $d9lEw[key];
        }
    });
});

var $cfnvH = parcelRequire("cfnvH");
Object.keys($cfnvH).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $cfnvH[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cfnvH[key];
        }
    });
});

var $8w9BL = parcelRequire("8w9BL");
Object.keys($8w9BL).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $8w9BL[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8w9BL[key];
        }
    });
});

var $cXBC2 = parcelRequire("cXBC2");
Object.keys($cXBC2).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $cXBC2[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cXBC2[key];
        }
    });
});

var $eQTkQ = parcelRequire("eQTkQ");
Object.keys($eQTkQ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $eQTkQ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $eQTkQ[key];
        }
    });
});

var $5GK3U = parcelRequire("5GK3U");
Object.keys($5GK3U).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5GK3U[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5GK3U[key];
        }
    });
});

var $13QzU = parcelRequire("13QzU");
Object.keys($13QzU).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $13QzU[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $13QzU[key];
        }
    });
});

var $6ON3R = parcelRequire("6ON3R");
Object.keys($6ON3R).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $6ON3R[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6ON3R[key];
        }
    });
});

var $AQVHH = parcelRequire("AQVHH");
Object.keys($AQVHH).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $AQVHH[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $AQVHH[key];
        }
    });
});

var $l7P5p = parcelRequire("l7P5p");
Object.keys($l7P5p).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $l7P5p[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $l7P5p[key];
        }
    });
});

var $9ErNi = parcelRequire("9ErNi");
Object.keys($9ErNi).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $9ErNi[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9ErNi[key];
        }
    });
});

var $ltZPS = parcelRequire("ltZPS");
Object.keys($ltZPS).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $ltZPS[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ltZPS[key];
        }
    });
});

var $7HPf8 = parcelRequire("7HPf8");
Object.keys($7HPf8).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7HPf8[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7HPf8[key];
        }
    });
});

var $5t2jQ = parcelRequire("5t2jQ");
Object.keys($5t2jQ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5t2jQ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5t2jQ[key];
        }
    });
});

var $boE47 = parcelRequire("boE47");
Object.keys($boE47).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $boE47[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $boE47[key];
        }
    });
});

var $3vAI0 = parcelRequire("3vAI0");
Object.keys($3vAI0).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $3vAI0[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3vAI0[key];
        }
    });
});

var $hAjXN = parcelRequire("hAjXN");
Object.keys($hAjXN).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hAjXN[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hAjXN[key];
        }
    });
});

var $6Gv6n = parcelRequire("6Gv6n");
Object.keys($6Gv6n).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $6Gv6n[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6Gv6n[key];
        }
    });
});

var $8C1ii = parcelRequire("8C1ii");
Object.keys($8C1ii).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $8C1ii[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8C1ii[key];
        }
    });
});

var $1OwQr = parcelRequire("1OwQr");
Object.keys($1OwQr).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $1OwQr[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1OwQr[key];
        }
    });
});

var $jeQ8V = parcelRequire("jeQ8V");
Object.keys($jeQ8V).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $jeQ8V[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $jeQ8V[key];
        }
    });
});

var $6wSSW = parcelRequire("6wSSW");
Object.keys($6wSSW).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $6wSSW[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6wSSW[key];
        }
    });
});

var $9r1vT = parcelRequire("9r1vT");
Object.keys($9r1vT).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $9r1vT[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9r1vT[key];
        }
    });
});

var $4HLso = parcelRequire("4HLso");
Object.keys($4HLso).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4HLso[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4HLso[key];
        }
    });
});

var $1TDNp = parcelRequire("1TDNp");
Object.keys($1TDNp).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $1TDNp[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1TDNp[key];
        }
    });
});

var $lKhK2 = parcelRequire("lKhK2");
Object.keys($lKhK2).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $lKhK2[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $lKhK2[key];
        }
    });
});

var $cmplH = parcelRequire("cmplH");
Object.keys($cmplH).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $cmplH[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cmplH[key];
        }
    });
});

var $3ulbk = parcelRequire("3ulbk");
Object.keys($3ulbk).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $3ulbk[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3ulbk[key];
        }
    });
});

var $jsxIt = parcelRequire("jsxIt");
Object.keys($jsxIt).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $jsxIt[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $jsxIt[key];
        }
    });
});

var $438Ab = parcelRequire("438Ab");
Object.keys($438Ab).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $438Ab[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $438Ab[key];
        }
    });
});

var $2EjjN = parcelRequire("2EjjN");
Object.keys($2EjjN).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $2EjjN[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2EjjN[key];
        }
    });
});

var $lM2Ew = parcelRequire("lM2Ew");
Object.keys($lM2Ew).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $lM2Ew[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $lM2Ew[key];
        }
    });
});

var $5KX3n = parcelRequire("5KX3n");
Object.keys($5KX3n).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5KX3n[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5KX3n[key];
        }
    });
});

var $d1Zcu = parcelRequire("d1Zcu");
Object.keys($d1Zcu).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $d1Zcu[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $d1Zcu[key];
        }
    });
});

var $cxPYU = parcelRequire("cxPYU");
Object.keys($cxPYU).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $cxPYU[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cxPYU[key];
        }
    });
});

var $5LfhK = parcelRequire("5LfhK");
Object.keys($5LfhK).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5LfhK[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5LfhK[key];
        }
    });
});

var $bBBIn = parcelRequire("bBBIn");
Object.keys($bBBIn).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $bBBIn[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bBBIn[key];
        }
    });
});

var $5At12 = parcelRequire("5At12");
Object.keys($5At12).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5At12[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5At12[key];
        }
    });
});

var $1KR3r = parcelRequire("1KR3r");
Object.keys($1KR3r).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $1KR3r[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1KR3r[key];
        }
    });
});

var $kmUtk = parcelRequire("kmUtk");
Object.keys($kmUtk).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $kmUtk[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $kmUtk[key];
        }
    });
});

var $lMw2H = parcelRequire("lMw2H");
Object.keys($lMw2H).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $lMw2H[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $lMw2H[key];
        }
    });
});

var $iHZDD = parcelRequire("iHZDD");
Object.keys($iHZDD).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $iHZDD[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $iHZDD[key];
        }
    });
});

var $973rn = parcelRequire("973rn");
Object.keys($973rn).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $973rn[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $973rn[key];
        }
    });
});

var $ac1eo = parcelRequire("ac1eo");
Object.keys($ac1eo).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $ac1eo[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ac1eo[key];
        }
    });
});

var $eiMgd = parcelRequire("eiMgd");
Object.keys($eiMgd).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $eiMgd[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $eiMgd[key];
        }
    });
});

var $6yYay = parcelRequire("6yYay");
Object.keys($6yYay).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $6yYay[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6yYay[key];
        }
    });
});

var $bdOxS = parcelRequire("bdOxS");
Object.keys($bdOxS).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $bdOxS[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bdOxS[key];
        }
    });
});

var $7Vtb9 = parcelRequire("7Vtb9");
Object.keys($7Vtb9).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7Vtb9[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7Vtb9[key];
        }
    });
});

var $cRtuT = parcelRequire("cRtuT");
Object.keys($cRtuT).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $cRtuT[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cRtuT[key];
        }
    });
});

var $eBOJa = parcelRequire("eBOJa");
Object.keys($eBOJa).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $eBOJa[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $eBOJa[key];
        }
    });
});

var $3nQMq = parcelRequire("3nQMq");
Object.keys($3nQMq).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $3nQMq[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3nQMq[key];
        }
    });
});

var $3v7oA = parcelRequire("3v7oA");
Object.keys($3v7oA).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $3v7oA[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3v7oA[key];
        }
    });
});

var $de7fk = parcelRequire("de7fk");
Object.keys($de7fk).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $de7fk[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $de7fk[key];
        }
    });
});

var $bxkfc = parcelRequire("bxkfc");
Object.keys($bxkfc).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $bxkfc[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bxkfc[key];
        }
    });
});

var $552MX = parcelRequire("552MX");
Object.keys($552MX).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $552MX[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $552MX[key];
        }
    });
});

var $9FGqf = parcelRequire("9FGqf");
Object.keys($9FGqf).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $9FGqf[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9FGqf[key];
        }
    });
});

var $d16Mv = parcelRequire("d16Mv");
Object.keys($d16Mv).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $d16Mv[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $d16Mv[key];
        }
    });
});

var $bLAGf = parcelRequire("bLAGf");
Object.keys($bLAGf).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $bLAGf[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bLAGf[key];
        }
    });
});

var $dZnFS = parcelRequire("dZnFS");
Object.keys($dZnFS).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $dZnFS[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dZnFS[key];
        }
    });
});

var $hbpCX = parcelRequire("hbpCX");
Object.keys($hbpCX).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hbpCX[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hbpCX[key];
        }
    });
});

var $9fj9e = parcelRequire("9fj9e");
Object.keys($9fj9e).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $9fj9e[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9fj9e[key];
        }
    });
});

var $3PuqO = parcelRequire("3PuqO");
Object.keys($3PuqO).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $3PuqO[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3PuqO[key];
        }
    });
});

var $jRpm6 = parcelRequire("jRpm6");
Object.keys($jRpm6).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $jRpm6[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $jRpm6[key];
        }
    });
});

var $kkX8H = parcelRequire("kkX8H");
Object.keys($kkX8H).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $kkX8H[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $kkX8H[key];
        }
    });
});

var $6oRLT = parcelRequire("6oRLT");
Object.keys($6oRLT).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $6oRLT[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6oRLT[key];
        }
    });
});

var $n3yTs = parcelRequire("n3yTs");
Object.keys($n3yTs).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $n3yTs[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $n3yTs[key];
        }
    });
});

var $jFMQZ = parcelRequire("jFMQZ");
Object.keys($jFMQZ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $jFMQZ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $jFMQZ[key];
        }
    });
});

var $fRpOA = parcelRequire("fRpOA");
Object.keys($fRpOA).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $fRpOA[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fRpOA[key];
        }
    });
});

var $16Un7 = parcelRequire("16Un7");
Object.keys($16Un7).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $16Un7[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $16Un7[key];
        }
    });
});

var $9ai94 = parcelRequire("9ai94");
Object.keys($9ai94).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $9ai94[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9ai94[key];
        }
    });
});

var $k4Wvo = parcelRequire("k4Wvo");
Object.keys($k4Wvo).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $k4Wvo[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $k4Wvo[key];
        }
    });
});

var $fAa5v = parcelRequire("fAa5v");
Object.keys($fAa5v).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $fAa5v[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fAa5v[key];
        }
    });
});

var $e5iTd = parcelRequire("e5iTd");
Object.keys($e5iTd).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $e5iTd[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $e5iTd[key];
        }
    });
});

var $8oQSv = parcelRequire("8oQSv");
Object.keys($8oQSv).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $8oQSv[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8oQSv[key];
        }
    });
});

var $bTQA0 = parcelRequire("bTQA0");
Object.keys($bTQA0).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $bTQA0[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bTQA0[key];
        }
    });
});

var $lN9IU = parcelRequire("lN9IU");
Object.keys($lN9IU).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $lN9IU[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $lN9IU[key];
        }
    });
});

var $3OIEn = parcelRequire("3OIEn");
Object.keys($3OIEn).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $3OIEn[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3OIEn[key];
        }
    });
});

var $52EB0 = parcelRequire("52EB0");
Object.keys($52EB0).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $52EB0[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $52EB0[key];
        }
    });
});

var $eROmU = parcelRequire("eROmU");
Object.keys($eROmU).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $eROmU[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $eROmU[key];
        }
    });
});

var $erDQf = parcelRequire("erDQf");
Object.keys($erDQf).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $erDQf[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $erDQf[key];
        }
    });
});

var $73uS3 = parcelRequire("73uS3");
Object.keys($73uS3).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $73uS3[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $73uS3[key];
        }
    });
});

var $2qbw1 = parcelRequire("2qbw1");
Object.keys($2qbw1).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $2qbw1[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2qbw1[key];
        }
    });
});

var $85MYC = parcelRequire("85MYC");
Object.keys($85MYC).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $85MYC[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $85MYC[key];
        }
    });
});

var $bSZqj = parcelRequire("bSZqj");
Object.keys($bSZqj).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $bSZqj[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bSZqj[key];
        }
    });
});

var $kdcG1 = parcelRequire("kdcG1");
Object.keys($kdcG1).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $kdcG1[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $kdcG1[key];
        }
    });
});

var $lSadI = parcelRequire("lSadI");
Object.keys($lSadI).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $lSadI[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $lSadI[key];
        }
    });
});

var $avSVV = parcelRequire("avSVV");
Object.keys($avSVV).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $avSVV[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $avSVV[key];
        }
    });
});

var $fMQT4 = parcelRequire("fMQT4");
Object.keys($fMQT4).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $fMQT4[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fMQT4[key];
        }
    });
});

var $5OQUm = parcelRequire("5OQUm");
Object.keys($5OQUm).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5OQUm[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5OQUm[key];
        }
    });
});

var $8UzgH = parcelRequire("8UzgH");
Object.keys($8UzgH).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $8UzgH[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8UzgH[key];
        }
    });
});

var $2zwzb = parcelRequire("2zwzb");
Object.keys($2zwzb).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $2zwzb[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2zwzb[key];
        }
    });
});

var $6oS25 = parcelRequire("6oS25");
Object.keys($6oS25).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $6oS25[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6oS25[key];
        }
    });
});

var $gfq0K = parcelRequire("gfq0K");
Object.keys($gfq0K).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $gfq0K[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gfq0K[key];
        }
    });
});

var $aorCW = parcelRequire("aorCW");
Object.keys($aorCW).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $aorCW[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $aorCW[key];
        }
    });
});

var $pHAlK = parcelRequire("pHAlK");
Object.keys($pHAlK).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $pHAlK[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $pHAlK[key];
        }
    });
});

var $ea7Pp = parcelRequire("ea7Pp");
Object.keys($ea7Pp).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $ea7Pp[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ea7Pp[key];
        }
    });
});

var $4x8aw = parcelRequire("4x8aw");
Object.keys($4x8aw).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4x8aw[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4x8aw[key];
        }
    });
});

var $f44li = parcelRequire("f44li");
Object.keys($f44li).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $f44li[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $f44li[key];
        }
    });
});

var $h18wW = parcelRequire("h18wW");
Object.keys($h18wW).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $h18wW[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $h18wW[key];
        }
    });
});

var $Gd0bX = parcelRequire("Gd0bX");
Object.keys($Gd0bX).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $Gd0bX[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $Gd0bX[key];
        }
    });
});

var $7KsKS = parcelRequire("7KsKS");
Object.keys($7KsKS).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7KsKS[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7KsKS[key];
        }
    });
});

var $kJOxR = parcelRequire("kJOxR");
Object.keys($kJOxR).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $kJOxR[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $kJOxR[key];
        }
    });
});

var $aDwxJ = parcelRequire("aDwxJ");
Object.keys($aDwxJ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $aDwxJ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $aDwxJ[key];
        }
    });
});

var $lkhBu = parcelRequire("lkhBu");
Object.keys($lkhBu).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $lkhBu[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $lkhBu[key];
        }
    });
});

var $isuGI = parcelRequire("isuGI");
Object.keys($isuGI).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $isuGI[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $isuGI[key];
        }
    });
});

var $1pqul = parcelRequire("1pqul");
Object.keys($1pqul).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $1pqul[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1pqul[key];
        }
    });
});

var $bnoYK = parcelRequire("bnoYK");
Object.keys($bnoYK).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $bnoYK[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bnoYK[key];
        }
    });
});

var $fV1is = parcelRequire("fV1is");
Object.keys($fV1is).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $fV1is[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fV1is[key];
        }
    });
});

var $kfUjo = parcelRequire("kfUjo");
Object.keys($kfUjo).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $kfUjo[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $kfUjo[key];
        }
    });
});

var $1zlEH = parcelRequire("1zlEH");
Object.keys($1zlEH).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $1zlEH[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1zlEH[key];
        }
    });
});

var $lbcdn = parcelRequire("lbcdn");
Object.keys($lbcdn).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $lbcdn[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $lbcdn[key];
        }
    });
});

var $isPKD = parcelRequire("isPKD");
Object.keys($isPKD).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $isPKD[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $isPKD[key];
        }
    });
});

var $6MrzR = parcelRequire("6MrzR");
Object.keys($6MrzR).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $6MrzR[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6MrzR[key];
        }
    });
});

var $4eDQi = parcelRequire("4eDQi");
Object.keys($4eDQi).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4eDQi[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4eDQi[key];
        }
    });
});

var $ffQEb = parcelRequire("ffQEb");
Object.keys($ffQEb).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $ffQEb[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ffQEb[key];
        }
    });
});

var $4hV23 = parcelRequire("4hV23");
Object.keys($4hV23).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4hV23[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4hV23[key];
        }
    });
});

var $bz9Dw = parcelRequire("bz9Dw");
Object.keys($bz9Dw).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $bz9Dw[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bz9Dw[key];
        }
    });
});

var $iWQ9A = parcelRequire("iWQ9A");
Object.keys($iWQ9A).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $iWQ9A[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $iWQ9A[key];
        }
    });
});

var $9DOwY = parcelRequire("9DOwY");
Object.keys($9DOwY).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $9DOwY[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9DOwY[key];
        }
    });
});

var $2qVDZ = parcelRequire("2qVDZ");
Object.keys($2qVDZ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $2qVDZ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2qVDZ[key];
        }
    });
});

var $b3MCU = parcelRequire("b3MCU");
Object.keys($b3MCU).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $b3MCU[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $b3MCU[key];
        }
    });
});

var $bCb32 = parcelRequire("bCb32");
Object.keys($bCb32).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $bCb32[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bCb32[key];
        }
    });
});

var $4Lv6S = parcelRequire("4Lv6S");
Object.keys($4Lv6S).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4Lv6S[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4Lv6S[key];
        }
    });
});

var $9hhu5 = parcelRequire("9hhu5");
Object.keys($9hhu5).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $9hhu5[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9hhu5[key];
        }
    });
});

var $5GxCF = parcelRequire("5GxCF");
Object.keys($5GxCF).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5GxCF[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5GxCF[key];
        }
    });
});

var $ebRmU = parcelRequire("ebRmU");
Object.keys($ebRmU).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $ebRmU[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ebRmU[key];
        }
    });
});

});
parcelRegister("cQcg2", function(module, exports) {

$parcel$export(module.exports, "add", function () { return $9593d97c9f5d9e6b$export$e16d8520af44a096; }, function (v) { return $9593d97c9f5d9e6b$export$e16d8520af44a096 = v; });
var $9593d97c9f5d9e6b$export$e16d8520af44a096;
"use strict";
$9593d97c9f5d9e6b$export$e16d8520af44a096 = $9593d97c9f5d9e6b$var$add;

var $cBVis = parcelRequire("cBVis");

var $fIUbm = parcelRequire("fIUbm");

var $02yAu = parcelRequire("02yAu");

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name add
 * @category Common Helpers
 * @summary Add the specified years, months, weeks, days, hours, minutes and seconds to the given date.
 *
 * @description
 * Add the specified years, months, weeks, days, hours, minutes and seconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param duration - The object with years, months, weeks, days, hours, minutes and seconds to be added.
 *
 * | Key            | Description                        |
 * |----------------|------------------------------------|
 * | years          | Amount of years to be added        |
 * | months         | Amount of months to be added       |
 * | weeks          | Amount of weeks to be added        |
 * | days           | Amount of days to be added         |
 * | hours          | Amount of hours to be added        |
 * | minutes        | Amount of minutes to be added      |
 * | seconds        | Amount of seconds to be added      |
 *
 * All values default to 0
 *
 * @returns The new date with the seconds added
 *
 * @example
 * // Add the following duration to 1 September 2014, 10:19:50
 * const result = add(new Date(2014, 8, 1, 10, 19, 50), {
 *   years: 2,
 *   months: 9,
 *   weeks: 1,
 *   days: 7,
 *   hours: 5,\\-7
 *   minutes: 9,
 *   seconds: 30,
 * })
 * //=> Thu Jun 15 2017 15:29:20
 */ function $9593d97c9f5d9e6b$var$add(date, duration) {
    const { years: years = 0, months: months = 0, weeks: weeks = 0, days: days = 0, hours: hours = 0, minutes: minutes = 0, seconds: seconds = 0 } = duration;
    // Add years and months
    const _date = (0, $b3MCU.toDate)(date);
    const dateWithMonths = months || years ? (0, $fIUbm.addMonths)(_date, months + years * 12) : _date;
    // Add weeks and days
    const dateWithDays = days || weeks ? (0, $cBVis.addDays)(dateWithMonths, days + weeks * 7) : dateWithMonths;
    // Add days, hours, minutes and seconds
    const minutesToAdd = minutes + hours * 60;
    const secondsToAdd = seconds + minutesToAdd * 60;
    const msToAdd = secondsToAdd * 1000;
    const finalDate = (0, $02yAu.constructFrom)(date, dateWithDays.getTime() + msToAdd);
    return finalDate;
}

});
parcelRegister("cBVis", function(module, exports) {

$parcel$export(module.exports, "addDays", function () { return $92e562a841a443dc$export$dd412b56f1e4d8aa; }, function (v) { return $92e562a841a443dc$export$dd412b56f1e4d8aa = v; });
var $92e562a841a443dc$export$dd412b56f1e4d8aa;
"use strict";
$92e562a841a443dc$export$dd412b56f1e4d8aa = $92e562a841a443dc$var$addDays;

var $b3MCU = parcelRequire("b3MCU");

var $02yAu = parcelRequire("02yAu");
/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of days to be added.
 *
 * @returns The new date with the days added
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */ function $92e562a841a443dc$var$addDays(date, amount) {
    const _date = (0, $b3MCU.toDate)(date);
    if (isNaN(amount)) return (0, $02yAu.constructFrom)(date, NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return _date;
    _date.setDate(_date.getDate() + amount);
    return _date;
}

});
parcelRegister("b3MCU", function(module, exports) {

$parcel$export(module.exports, "toDate", function () { return $80d5b1bec1893b25$export$e67a095c620b86fe; }, function (v) { return $80d5b1bec1893b25$export$e67a095c620b86fe = v; });
var $80d5b1bec1893b25$export$e67a095c620b86fe;
"use strict";
$80d5b1bec1893b25$export$e67a095c620b86fe = $80d5b1bec1893b25$var$toDate;
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param argument - The value to convert
 *
 * @returns The parsed date in the local time zone
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */ function $80d5b1bec1893b25$var$toDate(argument) {
    const argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || typeof argument === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new argument.constructor(+argument);
    else if (typeof argument === "number" || argStr === "[object Number]" || typeof argument === "string" || argStr === "[object String]") // TODO: Can we get rid of as?
    return new Date(argument);
    else // TODO: Can we get rid of as?
    return new Date(NaN);
}

});

parcelRegister("02yAu", function(module, exports) {

$parcel$export(module.exports, "constructFrom", function () { return $007b045ff4179093$export$ead8a1812b171991; }, function (v) { return $007b045ff4179093$export$ead8a1812b171991 = v; });
var $007b045ff4179093$export$ead8a1812b171991;
"use strict";
$007b045ff4179093$export$ead8a1812b171991 = $007b045ff4179093$var$constructFrom;
/**
 * @name constructFrom
 * @category Generic Helpers
 * @summary Constructs a date using the reference date and the value
 *
 * @description
 * The function constructs a new date using the constructor from the reference
 * date and the given value. It helps to build generic functions that accept
 * date extensions.
 *
 * It defaults to `Date` if the passed reference date is a number or a string.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The reference date to take constructor from
 * @param value - The value to create the date
 *
 * @returns Date initialized using the given date and value
 *
 * @example
 * import { constructFrom } from 'date-fns'
 *
 * // A function that clones a date preserving the original type
 * function cloneDate<DateType extends Date(date: DateType): DateType {
 *   return constructFrom(
 *     date, // Use contrustor from the given date
 *     date.getTime() // Use the date value to create a new date
 *   )
 * }
 */ function $007b045ff4179093$var$constructFrom(date, value) {
    if (date instanceof Date) return new date.constructor(value);
    else return new Date(value);
}

});


parcelRegister("fIUbm", function(module, exports) {

$parcel$export(module.exports, "addMonths", function () { return $b7268bb0740eb7a5$export$17c93e242b2d3a22; }, function (v) { return $b7268bb0740eb7a5$export$17c93e242b2d3a22 = v; });
var $b7268bb0740eb7a5$export$17c93e242b2d3a22;
"use strict";
$b7268bb0740eb7a5$export$17c93e242b2d3a22 = $b7268bb0740eb7a5$var$addMonths;

var $b3MCU = parcelRequire("b3MCU");

var $02yAu = parcelRequire("02yAu");
/**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of months to be added.
 *
 * @returns The new date with the months added
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * const result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 *
 * // Add one month to 30 January 2023:
 * const result = addMonths(new Date(2023, 0, 30), 1)
 * //=> Tue Feb 28 2023 00:00:00
 */ function $b7268bb0740eb7a5$var$addMonths(date, amount) {
    const _date = (0, $b3MCU.toDate)(date);
    if (isNaN(amount)) return (0, $02yAu.constructFrom)(date, NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return _date;
    const dayOfMonth = _date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    const endOfDesiredMonth = (0, $02yAu.constructFrom)(date, _date.getTime());
    endOfDesiredMonth.setMonth(_date.getMonth() + amount + 1, 0);
    const daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        _date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return _date;
    }
}

});


parcelRegister("pg1qm", function(module, exports) {

$parcel$export(module.exports, "addBusinessDays", function () { return $04bec38b4a5127f3$export$f087b9ada3136ae9; }, function (v) { return $04bec38b4a5127f3$export$f087b9ada3136ae9 = v; });
var $04bec38b4a5127f3$export$f087b9ada3136ae9;
"use strict";
$04bec38b4a5127f3$export$f087b9ada3136ae9 = $04bec38b4a5127f3$var$addBusinessDays;

var $02yAu = parcelRequire("02yAu");

var $7HPf8 = parcelRequire("7HPf8");

var $5t2jQ = parcelRequire("5t2jQ");

var $jsxIt = parcelRequire("jsxIt");

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name addBusinessDays
 * @category Date Extension Helpers
 * @summary Add the specified number of business days (mon - fri) to the given date.
 *
 * @description
 * Add the specified number of business days (mon - fri) to the given date, ignoring weekends.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of business days to be added.
 *
 * @returns The new date with the business days added
 *
 * @example
 * // Add 10 business days to 1 September 2014:
 * const result = addBusinessDays(new Date(2014, 8, 1), 10)
 * //=> Mon Sep 15 2014 00:00:00 (skipped weekend days)
 */ function $04bec38b4a5127f3$var$addBusinessDays(date, amount) {
    const _date = (0, $b3MCU.toDate)(date);
    const startedOnWeekend = (0, $jsxIt.isWeekend)(_date);
    if (isNaN(amount)) return (0, $02yAu.constructFrom)(date, NaN);
    const hours = _date.getHours();
    const sign = amount < 0 ? -1 : 1;
    const fullWeeks = Math.trunc(amount / 5);
    _date.setDate(_date.getDate() + fullWeeks * 7);
    // Get remaining days not part of a full week
    let restDays = Math.abs(amount % 5);
    // Loops over remaining days
    while(restDays > 0){
        _date.setDate(_date.getDate() + sign);
        if (!(0, $jsxIt.isWeekend)(_date)) restDays -= 1;
    }
    // If the date is a weekend day and we reduce a dividable of
    // 5 from it, we land on a weekend date.
    // To counter this, we add days accordingly to land on the next business day
    if (startedOnWeekend && (0, $jsxIt.isWeekend)(_date) && amount !== 0) {
        // If we're reducing days, we want to add days until we land on a weekday
        // If we're adding days we want to reduce days until we land on a weekday
        if ((0, $7HPf8.isSaturday)(_date)) _date.setDate(_date.getDate() + (sign < 0 ? 2 : -1));
        if ((0, $5t2jQ.isSunday)(_date)) _date.setDate(_date.getDate() + (sign < 0 ? 1 : -2));
    }
    // Restore hours to avoid DST lag
    _date.setHours(hours);
    return _date;
}

});
parcelRegister("7HPf8", function(module, exports) {

$parcel$export(module.exports, "isSaturday", function () { return $59c44c58b216e2ef$export$def9f260655b3a76; }, function (v) { return $59c44c58b216e2ef$export$def9f260655b3a76 = v; });
var $59c44c58b216e2ef$export$def9f260655b3a76;
"use strict";
$59c44c58b216e2ef$export$def9f260655b3a76 = $59c44c58b216e2ef$var$isSaturday;

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name isSaturday
 * @category Weekday Helpers
 * @summary Is the given date Saturday?
 *
 * @description
 * Is the given date Saturday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Saturday
 *
 * @example
 * // Is 27 September 2014 Saturday?
 * const result = isSaturday(new Date(2014, 8, 27))
 * //=> true
 */ function $59c44c58b216e2ef$var$isSaturday(date) {
    return (0, $b3MCU.toDate)(date).getDay() === 6;
}

});

parcelRegister("5t2jQ", function(module, exports) {

$parcel$export(module.exports, "isSunday", function () { return $3fb175b09bbe88ca$export$70f720dfc6028987; }, function (v) { return $3fb175b09bbe88ca$export$70f720dfc6028987 = v; });
var $3fb175b09bbe88ca$export$70f720dfc6028987;
"use strict";
$3fb175b09bbe88ca$export$70f720dfc6028987 = $3fb175b09bbe88ca$var$isSunday;

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name isSunday
 * @category Weekday Helpers
 * @summary Is the given date Sunday?
 *
 * @description
 * Is the given date Sunday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Sunday
 *
 * @example
 * // Is 21 September 2014 Sunday?
 * const result = isSunday(new Date(2014, 8, 21))
 * //=> true
 */ function $3fb175b09bbe88ca$var$isSunday(date) {
    return (0, $b3MCU.toDate)(date).getDay() === 0;
}

});

parcelRegister("jsxIt", function(module, exports) {

$parcel$export(module.exports, "isWeekend", function () { return $e2aac93308ebf704$export$618d60ea299da42; }, function (v) { return $e2aac93308ebf704$export$618d60ea299da42 = v; });
var $e2aac93308ebf704$export$618d60ea299da42;
"use strict";
$e2aac93308ebf704$export$618d60ea299da42 = $e2aac93308ebf704$var$isWeekend;

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name isWeekend
 * @category Weekday Helpers
 * @summary Does the given date fall on a weekend?
 *
 * @description
 * Does the given date fall on a weekend?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date falls on a weekend
 *
 * @example
 * // Does 5 October 2014 fall on a weekend?
 * const result = isWeekend(new Date(2014, 9, 5))
 * //=> true
 */ function $e2aac93308ebf704$var$isWeekend(date) {
    const day = (0, $b3MCU.toDate)(date).getDay();
    return day === 0 || day === 6;
}

});


parcelRegister("ghcs4", function(module, exports) {

$parcel$export(module.exports, "addHours", function () { return $bd97e4837be1fd80$export$4a4306ad4fa0e5e6; }, function (v) { return $bd97e4837be1fd80$export$4a4306ad4fa0e5e6 = v; });
var $bd97e4837be1fd80$export$4a4306ad4fa0e5e6;
"use strict";
$bd97e4837be1fd80$export$4a4306ad4fa0e5e6 = $bd97e4837be1fd80$var$addHours;

var $hveYv = parcelRequire("hveYv");

var $7MMvH = parcelRequire("7MMvH");
/**
 * @name addHours
 * @category Hour Helpers
 * @summary Add the specified number of hours to the given date.
 *
 * @description
 * Add the specified number of hours to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of hours to be added.
 *
 * @returns The new date with the hours added
 *
 * @example
 * // Add 2 hours to 10 July 2014 23:00:00:
 * const result = addHours(new Date(2014, 6, 10, 23, 0), 2)
 * //=> Fri Jul 11 2014 01:00:00
 */ function $bd97e4837be1fd80$var$addHours(date, amount) {
    return (0, $hveYv.addMilliseconds)(date, amount * $7MMvH.millisecondsInHour);
}

});
parcelRegister("hveYv", function(module, exports) {

$parcel$export(module.exports, "addMilliseconds", function () { return $cbe0f29e863f0c1b$export$baf757aaf0c95c94; }, function (v) { return $cbe0f29e863f0c1b$export$baf757aaf0c95c94 = v; });
var $cbe0f29e863f0c1b$export$baf757aaf0c95c94;
"use strict";
$cbe0f29e863f0c1b$export$baf757aaf0c95c94 = $cbe0f29e863f0c1b$var$addMilliseconds;

var $b3MCU = parcelRequire("b3MCU");

var $02yAu = parcelRequire("02yAu");
/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of milliseconds to be added.
 *
 * @returns The new date with the milliseconds added
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */ function $cbe0f29e863f0c1b$var$addMilliseconds(date, amount) {
    const timestamp = +(0, $b3MCU.toDate)(date);
    return (0, $02yAu.constructFrom)(date, timestamp + amount);
}

});

parcelRegister("7MMvH", function(module, exports) {

$parcel$export(module.exports, "secondsInYear", function () { return $5ab2a53bd62f4313$export$7271e9e3478110d1; }, function (v) { return $5ab2a53bd62f4313$export$7271e9e3478110d1 = v; });
$parcel$export(module.exports, "secondsInWeek", function () { return $5ab2a53bd62f4313$export$34804a017b31e2fe; }, function (v) { return $5ab2a53bd62f4313$export$34804a017b31e2fe = v; });
$parcel$export(module.exports, "secondsInQuarter", function () { return $5ab2a53bd62f4313$export$be1dccf2de902d31; }, function (v) { return $5ab2a53bd62f4313$export$be1dccf2de902d31 = v; });
$parcel$export(module.exports, "secondsInMonth", function () { return $5ab2a53bd62f4313$export$8e6600bbdee7dabb; }, function (v) { return $5ab2a53bd62f4313$export$8e6600bbdee7dabb = v; });
$parcel$export(module.exports, "secondsInMinute", function () { return $5ab2a53bd62f4313$export$a77c1a7ebebe2a5a; }, function (v) { return $5ab2a53bd62f4313$export$a77c1a7ebebe2a5a = v; });
$parcel$export(module.exports, "secondsInHour", function () { return $5ab2a53bd62f4313$export$698aec755e92c695; }, function (v) { return $5ab2a53bd62f4313$export$698aec755e92c695 = v; });
$parcel$export(module.exports, "secondsInDay", function () { return $5ab2a53bd62f4313$export$815a9362476d2fe3; }, function (v) { return $5ab2a53bd62f4313$export$815a9362476d2fe3 = v; });
$parcel$export(module.exports, "quartersInYear", function () { return $5ab2a53bd62f4313$export$4db7641526e3241f; }, function (v) { return $5ab2a53bd62f4313$export$4db7641526e3241f = v; });
$parcel$export(module.exports, "monthsInYear", function () { return $5ab2a53bd62f4313$export$80d7e435f744f319; }, function (v) { return $5ab2a53bd62f4313$export$80d7e435f744f319 = v; });
$parcel$export(module.exports, "monthsInQuarter", function () { return $5ab2a53bd62f4313$export$3c58128db900d44e; }, function (v) { return $5ab2a53bd62f4313$export$3c58128db900d44e = v; });
$parcel$export(module.exports, "minutesInYear", function () { return $5ab2a53bd62f4313$export$3633035e63cee86a; }, function (v) { return $5ab2a53bd62f4313$export$3633035e63cee86a = v; });
$parcel$export(module.exports, "minutesInMonth", function () { return $5ab2a53bd62f4313$export$ab7da2ccd1075c38; }, function (v) { return $5ab2a53bd62f4313$export$ab7da2ccd1075c38 = v; });
$parcel$export(module.exports, "minutesInHour", function () { return $5ab2a53bd62f4313$export$f2f5ae5a8e2d8f9f; }, function (v) { return $5ab2a53bd62f4313$export$f2f5ae5a8e2d8f9f = v; });
$parcel$export(module.exports, "minutesInDay", function () { return $5ab2a53bd62f4313$export$2423174df8cd3cd2; }, function (v) { return $5ab2a53bd62f4313$export$2423174df8cd3cd2 = v; });
$parcel$export(module.exports, "millisecondsInWeek", function () { return $5ab2a53bd62f4313$export$4fad13613e88edc8; }, function (v) { return $5ab2a53bd62f4313$export$4fad13613e88edc8 = v; });
$parcel$export(module.exports, "millisecondsInSecond", function () { return $5ab2a53bd62f4313$export$397c2d5776aa9055; }, function (v) { return $5ab2a53bd62f4313$export$397c2d5776aa9055 = v; });
$parcel$export(module.exports, "millisecondsInMinute", function () { return $5ab2a53bd62f4313$export$91246f0b9bd9beff; }, function (v) { return $5ab2a53bd62f4313$export$91246f0b9bd9beff = v; });
$parcel$export(module.exports, "millisecondsInHour", function () { return $5ab2a53bd62f4313$export$7f72910d6dfd237a; }, function (v) { return $5ab2a53bd62f4313$export$7f72910d6dfd237a = v; });
$parcel$export(module.exports, "millisecondsInDay", function () { return $5ab2a53bd62f4313$export$b76b1809a2898f9a; }, function (v) { return $5ab2a53bd62f4313$export$b76b1809a2898f9a = v; });
$parcel$export(module.exports, "daysInYear", function () { return $5ab2a53bd62f4313$export$3913210603d8e9ae; }, function (v) { return $5ab2a53bd62f4313$export$3913210603d8e9ae = v; });
$parcel$export(module.exports, "daysInWeek", function () { return $5ab2a53bd62f4313$export$dfd9b671c89acc8e; }, function (v) { return $5ab2a53bd62f4313$export$dfd9b671c89acc8e = v; });
var $5ab2a53bd62f4313$export$7271e9e3478110d1;
var $5ab2a53bd62f4313$export$34804a017b31e2fe;
var $5ab2a53bd62f4313$export$be1dccf2de902d31;
var $5ab2a53bd62f4313$export$8e6600bbdee7dabb;
var $5ab2a53bd62f4313$export$a77c1a7ebebe2a5a;
var $5ab2a53bd62f4313$export$698aec755e92c695;
var $5ab2a53bd62f4313$export$815a9362476d2fe3;
var $5ab2a53bd62f4313$export$4db7641526e3241f;
var $5ab2a53bd62f4313$export$80d7e435f744f319;
var $5ab2a53bd62f4313$export$3c58128db900d44e;
var $5ab2a53bd62f4313$export$3633035e63cee86a;
var $5ab2a53bd62f4313$export$ab7da2ccd1075c38;
var $5ab2a53bd62f4313$export$f2f5ae5a8e2d8f9f;
var $5ab2a53bd62f4313$export$2423174df8cd3cd2;
var $5ab2a53bd62f4313$export$4dec998e48f9c246;
var $5ab2a53bd62f4313$export$4fad13613e88edc8;
var $5ab2a53bd62f4313$export$397c2d5776aa9055;
var $5ab2a53bd62f4313$export$91246f0b9bd9beff;
var $5ab2a53bd62f4313$export$7f72910d6dfd237a;
var $5ab2a53bd62f4313$export$b76b1809a2898f9a;
var $5ab2a53bd62f4313$export$81caae6e1cc7a622;
var $5ab2a53bd62f4313$export$3913210603d8e9ae;
var $5ab2a53bd62f4313$export$dfd9b671c89acc8e;
"use strict";
$5ab2a53bd62f4313$export$7271e9e3478110d1 = $5ab2a53bd62f4313$export$34804a017b31e2fe = $5ab2a53bd62f4313$export$be1dccf2de902d31 = $5ab2a53bd62f4313$export$8e6600bbdee7dabb = $5ab2a53bd62f4313$export$a77c1a7ebebe2a5a = $5ab2a53bd62f4313$export$698aec755e92c695 = $5ab2a53bd62f4313$export$815a9362476d2fe3 = $5ab2a53bd62f4313$export$4db7641526e3241f = $5ab2a53bd62f4313$export$80d7e435f744f319 = $5ab2a53bd62f4313$export$3c58128db900d44e = $5ab2a53bd62f4313$export$3633035e63cee86a = $5ab2a53bd62f4313$export$ab7da2ccd1075c38 = $5ab2a53bd62f4313$export$f2f5ae5a8e2d8f9f = $5ab2a53bd62f4313$export$2423174df8cd3cd2 = $5ab2a53bd62f4313$export$4dec998e48f9c246 = $5ab2a53bd62f4313$export$4fad13613e88edc8 = $5ab2a53bd62f4313$export$397c2d5776aa9055 = $5ab2a53bd62f4313$export$91246f0b9bd9beff = $5ab2a53bd62f4313$export$7f72910d6dfd237a = $5ab2a53bd62f4313$export$b76b1809a2898f9a = $5ab2a53bd62f4313$export$81caae6e1cc7a622 = $5ab2a53bd62f4313$export$3913210603d8e9ae = $5ab2a53bd62f4313$export$dfd9b671c89acc8e = void 0; /**
 * @module constants
 * @summary Useful constants
 * @description
 * Collection of useful date constants.
 *
 * The constants could be imported from `date-fns/constants`:
 *
 * ```ts
 * import { maxTime, minTime } from "date-fns/constants";
 *
 * function isAllowedTime(time) {
 *   return time <= maxTime && time >= minTime;
 * }
 * ```
 */ 
/**
 * @constant
 * @name daysInWeek
 * @summary Days in 1 week.
 */ const $5ab2a53bd62f4313$var$daysInWeek = $5ab2a53bd62f4313$export$dfd9b671c89acc8e = 7;
/**
 * @constant
 * @name daysInYear
 * @summary Days in 1 year.
 *
 * @description
 * How many days in a year.
 *
 * One years equals 365.2425 days according to the formula:
 *
 * > Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
 * > 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
 */ const $5ab2a53bd62f4313$var$daysInYear = $5ab2a53bd62f4313$export$3913210603d8e9ae = 365.2425;
/**
 * @constant
 * @name maxTime
 * @summary Maximum allowed time.
 *
 * @example
 * import { maxTime } from "date-fns/constants";
 *
 * const isValid = 8640000000000001 <= maxTime;
 * //=> false
 *
 * new Date(8640000000000001);
 * //=> Invalid Date
 */ const $5ab2a53bd62f4313$var$maxTime = $5ab2a53bd62f4313$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
/**
 * @constant
 * @name minTime
 * @summary Minimum allowed time.
 *
 * @example
 * import { minTime } from "date-fns/constants";
 *
 * const isValid = -8640000000000001 >= minTime;
 * //=> false
 *
 * new Date(-8640000000000001)
 * //=> Invalid Date
 */ const $5ab2a53bd62f4313$var$minTime = $5ab2a53bd62f4313$export$4dec998e48f9c246 = -$5ab2a53bd62f4313$var$maxTime;
/**
 * @constant
 * @name millisecondsInWeek
 * @summary Milliseconds in 1 week.
 */ const $5ab2a53bd62f4313$var$millisecondsInWeek = $5ab2a53bd62f4313$export$4fad13613e88edc8 = 604800000;
/**
 * @constant
 * @name millisecondsInDay
 * @summary Milliseconds in 1 day.
 */ const $5ab2a53bd62f4313$var$millisecondsInDay = $5ab2a53bd62f4313$export$b76b1809a2898f9a = 86400000;
/**
 * @constant
 * @name millisecondsInMinute
 * @summary Milliseconds in 1 minute
 */ const $5ab2a53bd62f4313$var$millisecondsInMinute = $5ab2a53bd62f4313$export$91246f0b9bd9beff = 60000;
/**
 * @constant
 * @name millisecondsInHour
 * @summary Milliseconds in 1 hour
 */ const $5ab2a53bd62f4313$var$millisecondsInHour = $5ab2a53bd62f4313$export$7f72910d6dfd237a = 3600000;
/**
 * @constant
 * @name millisecondsInSecond
 * @summary Milliseconds in 1 second
 */ const $5ab2a53bd62f4313$var$millisecondsInSecond = $5ab2a53bd62f4313$export$397c2d5776aa9055 = 1000;
/**
 * @constant
 * @name minutesInYear
 * @summary Minutes in 1 year.
 */ const $5ab2a53bd62f4313$var$minutesInYear = $5ab2a53bd62f4313$export$3633035e63cee86a = 525600;
/**
 * @constant
 * @name minutesInMonth
 * @summary Minutes in 1 month.
 */ const $5ab2a53bd62f4313$var$minutesInMonth = $5ab2a53bd62f4313$export$ab7da2ccd1075c38 = 43200;
/**
 * @constant
 * @name minutesInDay
 * @summary Minutes in 1 day.
 */ const $5ab2a53bd62f4313$var$minutesInDay = $5ab2a53bd62f4313$export$2423174df8cd3cd2 = 1440;
/**
 * @constant
 * @name minutesInHour
 * @summary Minutes in 1 hour.
 */ const $5ab2a53bd62f4313$var$minutesInHour = $5ab2a53bd62f4313$export$f2f5ae5a8e2d8f9f = 60;
/**
 * @constant
 * @name monthsInQuarter
 * @summary Months in 1 quarter.
 */ const $5ab2a53bd62f4313$var$monthsInQuarter = $5ab2a53bd62f4313$export$3c58128db900d44e = 3;
/**
 * @constant
 * @name monthsInYear
 * @summary Months in 1 year.
 */ const $5ab2a53bd62f4313$var$monthsInYear = $5ab2a53bd62f4313$export$80d7e435f744f319 = 12;
/**
 * @constant
 * @name quartersInYear
 * @summary Quarters in 1 year
 */ const $5ab2a53bd62f4313$var$quartersInYear = $5ab2a53bd62f4313$export$4db7641526e3241f = 4;
/**
 * @constant
 * @name secondsInHour
 * @summary Seconds in 1 hour.
 */ const $5ab2a53bd62f4313$var$secondsInHour = $5ab2a53bd62f4313$export$698aec755e92c695 = 3600;
/**
 * @constant
 * @name secondsInMinute
 * @summary Seconds in 1 minute.
 */ const $5ab2a53bd62f4313$var$secondsInMinute = $5ab2a53bd62f4313$export$a77c1a7ebebe2a5a = 60;
/**
 * @constant
 * @name secondsInDay
 * @summary Seconds in 1 day.
 */ const $5ab2a53bd62f4313$var$secondsInDay = $5ab2a53bd62f4313$export$815a9362476d2fe3 = $5ab2a53bd62f4313$var$secondsInHour * 24;
/**
 * @constant
 * @name secondsInWeek
 * @summary Seconds in 1 week.
 */ const $5ab2a53bd62f4313$var$secondsInWeek = $5ab2a53bd62f4313$export$34804a017b31e2fe = $5ab2a53bd62f4313$var$secondsInDay * 7;
/**
 * @constant
 * @name secondsInYear
 * @summary Seconds in 1 year.
 */ const $5ab2a53bd62f4313$var$secondsInYear = $5ab2a53bd62f4313$export$7271e9e3478110d1 = $5ab2a53bd62f4313$var$secondsInDay * $5ab2a53bd62f4313$var$daysInYear;
/**
 * @constant
 * @name secondsInMonth
 * @summary Seconds in 1 month
 */ const $5ab2a53bd62f4313$var$secondsInMonth = $5ab2a53bd62f4313$export$8e6600bbdee7dabb = $5ab2a53bd62f4313$var$secondsInYear / 12;
/**
 * @constant
 * @name secondsInQuarter
 * @summary Seconds in 1 quarter.
 */ const $5ab2a53bd62f4313$var$secondsInQuarter = $5ab2a53bd62f4313$export$be1dccf2de902d31 = $5ab2a53bd62f4313$var$secondsInMonth * 3;

});


parcelRegister("hmVkE", function(module, exports) {

$parcel$export(module.exports, "addISOWeekYears", function () { return $ca50f6b6e34cdee9$export$c8240694da10d5f; }, function (v) { return $ca50f6b6e34cdee9$export$c8240694da10d5f = v; });
var $ca50f6b6e34cdee9$export$c8240694da10d5f;
"use strict";
$ca50f6b6e34cdee9$export$c8240694da10d5f = $ca50f6b6e34cdee9$var$addISOWeekYears;

var $43yjM = parcelRequire("43yjM");

var $kdcG1 = parcelRequire("kdcG1");
/**
 * @name addISOWeekYears
 * @category ISO Week-Numbering Year Helpers
 * @summary Add the specified number of ISO week-numbering years to the given date.
 *
 * @description
 * Add the specified number of ISO week-numbering years to the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of ISO week-numbering years to be added.
 *
 * @returns The new date with the ISO week-numbering years added
 *
 * @example
 * // Add 5 ISO week-numbering years to 2 July 2010:
 * const result = addISOWeekYears(new Date(2010, 6, 2), 5)
 * //=> Fri Jn 26 2015 00:00:00
 */ function $ca50f6b6e34cdee9$var$addISOWeekYears(date, amount) {
    return (0, $kdcG1.setISOWeekYear)(date, (0, $43yjM.getISOWeekYear)(date) + amount);
}

});
parcelRegister("43yjM", function(module, exports) {

$parcel$export(module.exports, "getISOWeekYear", function () { return $2f42101110950841$export$3dbc52535f6f8fcc; }, function (v) { return $2f42101110950841$export$3dbc52535f6f8fcc = v; });
var $2f42101110950841$export$3dbc52535f6f8fcc;
"use strict";
$2f42101110950841$export$3dbc52535f6f8fcc = $2f42101110950841$var$getISOWeekYear;

var $02yAu = parcelRequire("02yAu");

var $4x8aw = parcelRequire("4x8aw");

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name getISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the ISO week-numbering year of the given date.
 *
 * @description
 * Get the ISO week-numbering year of the given date,
 * which always starts 3 days before the year's first Thursday.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The ISO week-numbering year
 *
 * @example
 * // Which ISO-week numbering year is 2 January 2005?
 * const result = getISOWeekYear(new Date(2005, 0, 2))
 * //=> 2004
 */ function $2f42101110950841$var$getISOWeekYear(date) {
    const _date = (0, $b3MCU.toDate)(date);
    const year = _date.getFullYear();
    const fourthOfJanuaryOfNextYear = (0, $02yAu.constructFrom)(date, 0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $4x8aw.startOfISOWeek)(fourthOfJanuaryOfNextYear);
    const fourthOfJanuaryOfThisYear = (0, $02yAu.constructFrom)(date, 0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $4x8aw.startOfISOWeek)(fourthOfJanuaryOfThisYear);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});
parcelRegister("4x8aw", function(module, exports) {

$parcel$export(module.exports, "startOfISOWeek", function () { return $34d094a3c833040c$export$6173213f95a4431e; }, function (v) { return $34d094a3c833040c$export$6173213f95a4431e = v; });
var $34d094a3c833040c$export$6173213f95a4431e;
"use strict";
$34d094a3c833040c$export$6173213f95a4431e = $34d094a3c833040c$var$startOfISOWeek;

var $isuGI = parcelRequire("isuGI");
/**
 * @name startOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the start of an ISO week for the given date.
 *
 * @description
 * Return the start of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of an ISO week
 *
 * @example
 * // The start of an ISO week for 2 September 2014 11:55:00:
 * const result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */ function $34d094a3c833040c$var$startOfISOWeek(date) {
    return (0, $isuGI.startOfWeek)(date, {
        weekStartsOn: 1
    });
}

});
parcelRegister("isuGI", function(module, exports) {

$parcel$export(module.exports, "startOfWeek", function () { return $d702a5821c076937$export$42c81a444fbfb5d4; }, function (v) { return $d702a5821c076937$export$42c81a444fbfb5d4 = v; });
var $d702a5821c076937$export$42c81a444fbfb5d4;
"use strict";
$d702a5821c076937$export$42c81a444fbfb5d4 = $d702a5821c076937$var$startOfWeek;

var $b3MCU = parcelRequire("b3MCU");

var $lJvf9 = parcelRequire("lJvf9");
/**
 * The {@link startOfWeek} function options.
 */ /**
 * @name startOfWeek
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of a week
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Mon Sep 01 2014 00:00:00
 */ function $d702a5821c076937$var$startOfWeek(date, options) {
    const defaultOptions = (0, $lJvf9.getDefaultOptions)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $b3MCU.toDate)(date);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    _date.setDate(_date.getDate() - diff);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

});
parcelRegister("lJvf9", function(module, exports) {

$parcel$export(module.exports, "getDefaultOptions", function () { return $fd26093e4dd5325b$export$430a3269e24b912e; }, function (v) { return $fd26093e4dd5325b$export$430a3269e24b912e = v; });
$parcel$export(module.exports, "setDefaultOptions", function () { return $fd26093e4dd5325b$export$95365be1b0704abc; }, function (v) { return $fd26093e4dd5325b$export$95365be1b0704abc = v; });
var $fd26093e4dd5325b$export$430a3269e24b912e;
var $fd26093e4dd5325b$export$95365be1b0704abc;
"use strict";
$fd26093e4dd5325b$export$430a3269e24b912e = $fd26093e4dd5325b$var$getDefaultOptions;
$fd26093e4dd5325b$export$95365be1b0704abc = $fd26093e4dd5325b$var$setDefaultOptions;
let $fd26093e4dd5325b$var$defaultOptions = {};
function $fd26093e4dd5325b$var$getDefaultOptions() {
    return $fd26093e4dd5325b$var$defaultOptions;
}
function $fd26093e4dd5325b$var$setDefaultOptions(newOptions) {
    $fd26093e4dd5325b$var$defaultOptions = newOptions;
}

});




parcelRegister("kdcG1", function(module, exports) {

$parcel$export(module.exports, "setISOWeekYear", function () { return $eb6edae54c029ab4$export$814397aabf10ab77; }, function (v) { return $eb6edae54c029ab4$export$814397aabf10ab77 = v; });
var $eb6edae54c029ab4$export$814397aabf10ab77;
"use strict";
$eb6edae54c029ab4$export$814397aabf10ab77 = $eb6edae54c029ab4$var$setISOWeekYear;

var $02yAu = parcelRequire("02yAu");

var $fctE0 = parcelRequire("fctE0");

var $f44li = parcelRequire("f44li");

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name setISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Set the ISO week-numbering year to the given date.
 *
 * @description
 * Set the ISO week-numbering year to the given date,
 * saving the week number and the weekday number.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param weekYear - The ISO week-numbering year of the new date
 *
 * @returns The new date with the ISO week-numbering year set
 *
 * @example
 * // Set ISO week-numbering year 2007 to 29 December 2008:
 * const result = setISOWeekYear(new Date(2008, 11, 29), 2007)
 * //=> Mon Jan 01 2007 00:00:00
 */ function $eb6edae54c029ab4$var$setISOWeekYear(date, weekYear) {
    let _date = (0, $b3MCU.toDate)(date);
    const diff = (0, $fctE0.differenceInCalendarDays)(_date, (0, $f44li.startOfISOWeekYear)(_date));
    const fourthOfJanuary = (0, $02yAu.constructFrom)(date, 0);
    fourthOfJanuary.setFullYear(weekYear, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    _date = (0, $f44li.startOfISOWeekYear)(fourthOfJanuary);
    _date.setDate(_date.getDate() + diff);
    return _date;
}

});
parcelRegister("fctE0", function(module, exports) {

$parcel$export(module.exports, "differenceInCalendarDays", function () { return $b10ef8b6c0edf759$export$4a02e9c37dab4871; }, function (v) { return $b10ef8b6c0edf759$export$4a02e9c37dab4871 = v; });
var $b10ef8b6c0edf759$export$4a02e9c37dab4871;
"use strict";
$b10ef8b6c0edf759$export$4a02e9c37dab4871 = $b10ef8b6c0edf759$var$differenceInCalendarDays;

var $7MMvH = parcelRequire("7MMvH");

var $aorCW = parcelRequire("aorCW");

var $izS8L = parcelRequire("izS8L");
/**
 * @name differenceInCalendarDays
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates. This means that the times are removed
 * from the dates and then the difference in days is calculated.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar days
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 * // How many calendar days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInCalendarDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 1
 */ function $b10ef8b6c0edf759$var$differenceInCalendarDays(dateLeft, dateRight) {
    const startOfDayLeft = (0, $aorCW.startOfDay)(dateLeft);
    const startOfDayRight = (0, $aorCW.startOfDay)(dateRight);
    const timestampLeft = +startOfDayLeft - (0, $izS8L.getTimezoneOffsetInMilliseconds)(startOfDayLeft);
    const timestampRight = +startOfDayRight - (0, $izS8L.getTimezoneOffsetInMilliseconds)(startOfDayRight);
    // Round the number of days to the nearest integer because the number of
    // milliseconds in a day is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((timestampLeft - timestampRight) / $7MMvH.millisecondsInDay);
}

});
parcelRegister("aorCW", function(module, exports) {

$parcel$export(module.exports, "startOfDay", function () { return $79119374efd7de08$export$63fa379ae8a9ba2; }, function (v) { return $79119374efd7de08$export$63fa379ae8a9ba2 = v; });
var $79119374efd7de08$export$63fa379ae8a9ba2;
"use strict";
$79119374efd7de08$export$63fa379ae8a9ba2 = $79119374efd7de08$var$startOfDay;

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a day
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */ function $79119374efd7de08$var$startOfDay(date) {
    const _date = (0, $b3MCU.toDate)(date);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

});

parcelRegister("izS8L", function(module, exports) {

$parcel$export(module.exports, "getTimezoneOffsetInMilliseconds", function () { return $d8657e05e8efd27c$export$113002b5eff6e430; }, function (v) { return $d8657e05e8efd27c$export$113002b5eff6e430 = v; });
var $d8657e05e8efd27c$export$113002b5eff6e430;
"use strict";
$d8657e05e8efd27c$export$113002b5eff6e430 = $d8657e05e8efd27c$var$getTimezoneOffsetInMilliseconds;

var $b3MCU = parcelRequire("b3MCU");
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $d8657e05e8efd27c$var$getTimezoneOffsetInMilliseconds(date) {
    const _date = (0, $b3MCU.toDate)(date);
    const utcDate = new Date(Date.UTC(_date.getFullYear(), _date.getMonth(), _date.getDate(), _date.getHours(), _date.getMinutes(), _date.getSeconds(), _date.getMilliseconds()));
    utcDate.setUTCFullYear(_date.getFullYear());
    return +date - +utcDate;
}

});


parcelRegister("f44li", function(module, exports) {

$parcel$export(module.exports, "startOfISOWeekYear", function () { return $af7a990f7bea48c3$export$236bdfa374eb69a9; }, function (v) { return $af7a990f7bea48c3$export$236bdfa374eb69a9 = v; });
var $af7a990f7bea48c3$export$236bdfa374eb69a9;
"use strict";
$af7a990f7bea48c3$export$236bdfa374eb69a9 = $af7a990f7bea48c3$var$startOfISOWeekYear;

var $43yjM = parcelRequire("43yjM");

var $4x8aw = parcelRequire("4x8aw");

var $02yAu = parcelRequire("02yAu");
/**
 * @name startOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the start of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the start of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of an ISO week-numbering year
 *
 * @example
 * // The start of an ISO week-numbering year for 2 July 2005:
 * const result = startOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Mon Jan 03 2005 00:00:00
 */ function $af7a990f7bea48c3$var$startOfISOWeekYear(date) {
    const year = (0, $43yjM.getISOWeekYear)(date);
    const fourthOfJanuary = (0, $02yAu.constructFrom)(date, 0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    return (0, $4x8aw.startOfISOWeek)(fourthOfJanuary);
}

});



parcelRegister("84Jkb", function(module, exports) {

$parcel$export(module.exports, "addMinutes", function () { return $5e11daf3e4c3ba71$export$2287e3d29250119e; }, function (v) { return $5e11daf3e4c3ba71$export$2287e3d29250119e = v; });
var $5e11daf3e4c3ba71$export$2287e3d29250119e;
"use strict";
$5e11daf3e4c3ba71$export$2287e3d29250119e = $5e11daf3e4c3ba71$var$addMinutes;

var $hveYv = parcelRequire("hveYv");

var $7MMvH = parcelRequire("7MMvH");
/**
 * @name addMinutes
 * @category Minute Helpers
 * @summary Add the specified number of minutes to the given date.
 *
 * @description
 * Add the specified number of minutes to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of minutes to be added.
 *
 * @returns The new date with the minutes added
 *
 * @example
 * // Add 30 minutes to 10 July 2014 12:00:00:
 * const result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 12:30:00
 */ function $5e11daf3e4c3ba71$var$addMinutes(date, amount) {
    return (0, $hveYv.addMilliseconds)(date, amount * $7MMvH.millisecondsInMinute);
}

});

parcelRegister("7IMv5", function(module, exports) {

$parcel$export(module.exports, "addQuarters", function () { return $59f2439c0c5fb8f3$export$c252a41d0fbed2ce; }, function (v) { return $59f2439c0c5fb8f3$export$c252a41d0fbed2ce = v; });
var $59f2439c0c5fb8f3$export$c252a41d0fbed2ce;
"use strict";
$59f2439c0c5fb8f3$export$c252a41d0fbed2ce = $59f2439c0c5fb8f3$var$addQuarters;

var $fIUbm = parcelRequire("fIUbm");
/**
 * @name addQuarters
 * @category Quarter Helpers
 * @summary Add the specified number of year quarters to the given date.
 *
 * @description
 * Add the specified number of year quarters to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of quarters to be added.
 *
 * @returns The new date with the quarters added
 *
 * @example
 * // Add 1 quarter to 1 September 2014:
 * const result = addQuarters(new Date(2014, 8, 1), 1)
 * //=> Mon Dec 01 2014 00:00:00
 */ function $59f2439c0c5fb8f3$var$addQuarters(date, amount) {
    const months = amount * 3;
    return (0, $fIUbm.addMonths)(date, months);
}

});

parcelRegister("3WSWZ", function(module, exports) {

$parcel$export(module.exports, "addSeconds", function () { return $2e0169e6b7426b0a$export$3cb31b0df13be68; }, function (v) { return $2e0169e6b7426b0a$export$3cb31b0df13be68 = v; });
var $2e0169e6b7426b0a$export$3cb31b0df13be68;
"use strict";
$2e0169e6b7426b0a$export$3cb31b0df13be68 = $2e0169e6b7426b0a$var$addSeconds;

var $hveYv = parcelRequire("hveYv");
/**
 * @name addSeconds
 * @category Second Helpers
 * @summary Add the specified number of seconds to the given date.
 *
 * @description
 * Add the specified number of seconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of seconds to be added.
 *
 * @returns The new date with the seconds added
 *
 * @example
 * // Add 30 seconds to 10 July 2014 12:45:00:
 * const result = addSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
 * //=> Thu Jul 10 2014 12:45:30
 */ function $2e0169e6b7426b0a$var$addSeconds(date, amount) {
    return (0, $hveYv.addMilliseconds)(date, amount * 1000);
}

});

parcelRegister("iiBmk", function(module, exports) {

$parcel$export(module.exports, "addWeeks", function () { return $d526e32cb11124a9$export$ef501a2bb4f3ee6b; }, function (v) { return $d526e32cb11124a9$export$ef501a2bb4f3ee6b = v; });
var $d526e32cb11124a9$export$ef501a2bb4f3ee6b;
"use strict";
$d526e32cb11124a9$export$ef501a2bb4f3ee6b = $d526e32cb11124a9$var$addWeeks;

var $cBVis = parcelRequire("cBVis");
/**
 * @name addWeeks
 * @category Week Helpers
 * @summary Add the specified number of weeks to the given date.
 *
 * @description
 * Add the specified number of week to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of weeks to be added.
 *
 * @returns The new date with the weeks added
 *
 * @example
 * // Add 4 weeks to 1 September 2014:
 * const result = addWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Sep 29 2014 00:00:00
 */ function $d526e32cb11124a9$var$addWeeks(date, amount) {
    const days = amount * 7;
    return (0, $cBVis.addDays)(date, days);
}

});

parcelRegister("joePE", function(module, exports) {

$parcel$export(module.exports, "addYears", function () { return $e1dbc38871a2d0b9$export$3d83eec43f4ea476; }, function (v) { return $e1dbc38871a2d0b9$export$3d83eec43f4ea476 = v; });
var $e1dbc38871a2d0b9$export$3d83eec43f4ea476;
"use strict";
$e1dbc38871a2d0b9$export$3d83eec43f4ea476 = $e1dbc38871a2d0b9$var$addYears;

var $fIUbm = parcelRequire("fIUbm");
/**
 * @name addYears
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of years to be added.
 *
 * @returns The new date with the years added
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * const result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */ function $e1dbc38871a2d0b9$var$addYears(date, amount) {
    return (0, $fIUbm.addMonths)(date, amount * 12);
}

});

parcelRegister("hik0U", function(module, exports) {

$parcel$export(module.exports, "areIntervalsOverlapping", function () { return $c973a4662af1fa17$export$2bf3385645436101; }, function (v) { return $c973a4662af1fa17$export$2bf3385645436101 = v; });
var $c973a4662af1fa17$export$2bf3385645436101;
"use strict";
$c973a4662af1fa17$export$2bf3385645436101 = $c973a4662af1fa17$var$areIntervalsOverlapping;

var $b3MCU = parcelRequire("b3MCU");
/**
 * The {@link areIntervalsOverlapping} function options.
 */ /**
 * @name areIntervalsOverlapping
 * @category Interval Helpers
 * @summary Is the given time interval overlapping with another time interval?
 *
 * @description
 * Is the given time interval overlapping with another time interval? Adjacent intervals do not count as overlapping unless `inclusive` is set to `true`.
 *
 * @param intervalLeft - The first interval to compare.
 * @param intervalRight - The second interval to compare.
 * @param options - The object with options
 *
 * @returns Whether the time intervals are overlapping
 *
 * @example
 * // For overlapping time intervals:
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 17), end: new Date(2014, 0, 21) }
 * )
 * //=> true
 *
 * @example
 * // For non-overlapping time intervals:
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 21), end: new Date(2014, 0, 22) }
 * )
 * //=> false
 *
 * @example
 * // For adjacent time intervals:
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 30) }
 * )
 * //=> false
 *
 * @example
 * // Using the inclusive option:
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 24) }
 * )
 * //=> false
 *
 * @example
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 24) },
 *   { inclusive: true }
 * )
 * //=> true
 */ function $c973a4662af1fa17$var$areIntervalsOverlapping(intervalLeft, intervalRight, options) {
    const [leftStartTime, leftEndTime] = [
        +(0, $b3MCU.toDate)(intervalLeft.start),
        +(0, $b3MCU.toDate)(intervalLeft.end)
    ].sort((a, b)=>a - b);
    const [rightStartTime, rightEndTime] = [
        +(0, $b3MCU.toDate)(intervalRight.start),
        +(0, $b3MCU.toDate)(intervalRight.end)
    ].sort((a, b)=>a - b);
    if (options?.inclusive) return leftStartTime <= rightEndTime && rightStartTime <= leftEndTime;
    return leftStartTime < rightEndTime && rightStartTime < leftEndTime;
}

});

parcelRegister("hXeRg", function(module, exports) {

$parcel$export(module.exports, "clamp", function () { return $d12378e382edf5dc$export$7d15b64cf5a3a4c4; }, function (v) { return $d12378e382edf5dc$export$7d15b64cf5a3a4c4 = v; });
var $d12378e382edf5dc$export$7d15b64cf5a3a4c4;
"use strict";
$d12378e382edf5dc$export$7d15b64cf5a3a4c4 = $d12378e382edf5dc$var$clamp;

var $kmUtk = parcelRequire("kmUtk");

var $eiMgd = parcelRequire("eiMgd");
/**
 * @name clamp
 * @category Interval Helpers
 * @summary Return a date bounded by the start and the end of the given interval
 *
 * @description
 * Clamps a date to the lower bound with the start of the interval and the upper
 * bound with the end of the interval.
 *
 * - When the date is less than the start of the interval, the start is returned.
 * - When the date is greater than the end of the interval, the end is returned.
 * - Otherwise the date is returned.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be bounded
 * @param interval - The interval to bound to
 *
 * @returns The date bounded by the start and the end of the interval
 *
 * @example
 * // What is Mar, 21, 2021 bounded to an interval starting at Mar, 22, 2021 and ending at Apr, 01, 2021
 * const result = clamp(new Date(2021, 2, 21), {
 *   start: new Date(2021, 2, 22),
 *   end: new Date(2021, 3, 1),
 * })
 * //=> Mon Mar 22 2021 00:00:00
 */ function $d12378e382edf5dc$var$clamp(date, interval) {
    return (0, $eiMgd.min)([
        (0, $kmUtk.max)([
            date,
            interval.start
        ]),
        interval.end
    ]);
}

});
parcelRegister("kmUtk", function(module, exports) {

$parcel$export(module.exports, "max", function () { return $ed41aaeaf027c943$export$8960430cfd85939f; }, function (v) { return $ed41aaeaf027c943$export$8960430cfd85939f = v; });
var $ed41aaeaf027c943$export$8960430cfd85939f;
"use strict";
$ed41aaeaf027c943$export$8960430cfd85939f = $ed41aaeaf027c943$var$max;

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name max
 * @category Common Helpers
 * @summary Return the latest of the given dates.
 *
 * @description
 * Return the latest of the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dates - The dates to compare
 *
 * @returns The latest of the dates
 *
 * @example
 * // Which of these dates is the latest?
 * const result = max([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Sun Jul 02 1995 00:00:00
 */ function $ed41aaeaf027c943$var$max(dates) {
    let result;
    dates.forEach(function(dirtyDate) {
        const currentDate = (0, $b3MCU.toDate)(dirtyDate);
        if (result === undefined || result < currentDate || isNaN(Number(currentDate))) result = currentDate;
    });
    return result || new Date(NaN);
}

});

parcelRegister("eiMgd", function(module, exports) {

$parcel$export(module.exports, "min", function () { return $a6982ea7990019fa$export$96ec731ed4dcb222; }, function (v) { return $a6982ea7990019fa$export$96ec731ed4dcb222 = v; });
var $a6982ea7990019fa$export$96ec731ed4dcb222;
"use strict";
$a6982ea7990019fa$export$96ec731ed4dcb222 = $a6982ea7990019fa$var$min;

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name min
 * @category Common Helpers
 * @summary Returns the earliest of the given dates.
 *
 * @description
 * Returns the earliest of the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dates - The dates to compare
 *
 * @returns The earliest of the dates
 *
 * @example
 * // Which of these dates is the earliest?
 * const result = min([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Wed Feb 11 1987 00:00:00
 */ function $a6982ea7990019fa$var$min(dates) {
    let result;
    dates.forEach((dirtyDate)=>{
        const date = (0, $b3MCU.toDate)(dirtyDate);
        if (!result || result > date || isNaN(+date)) result = date;
    });
    return result || new Date(NaN);
}

});


parcelRegister("gnEyH", function(module, exports) {

$parcel$export(module.exports, "closestIndexTo", function () { return $bece41718f703a4a$export$42127b72a9d091c7; }, function (v) { return $bece41718f703a4a$export$42127b72a9d091c7 = v; });
var $bece41718f703a4a$export$42127b72a9d091c7;
"use strict";
$bece41718f703a4a$export$42127b72a9d091c7 = $bece41718f703a4a$var$closestIndexTo;

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name closestIndexTo
 * @category Common Helpers
 * @summary Return an index of the closest date from the array comparing to the given date.
 *
 * @description
 * Return an index of the closest date from the array comparing to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateToCompare - The date to compare with
 * @param dates - The array to search
 *
 * @returns An index of the date closest to the given date or undefined if no valid value is given
 *
 * @example
 * // Which date is closer to 6 September 2015?
 * const dateToCompare = new Date(2015, 8, 6)
 * const datesArray = [
 *   new Date(2015, 0, 1),
 *   new Date(2016, 0, 1),
 *   new Date(2017, 0, 1)
 * ]
 * const result = closestIndexTo(dateToCompare, datesArray)
 * //=> 1
 */ function $bece41718f703a4a$var$closestIndexTo(dateToCompare, dates) {
    const date = (0, $b3MCU.toDate)(dateToCompare);
    if (isNaN(Number(date))) return NaN;
    const timeToCompare = date.getTime();
    let result;
    let minDistance;
    dates.forEach(function(dirtyDate, index) {
        const currentDate = (0, $b3MCU.toDate)(dirtyDate);
        if (isNaN(Number(currentDate))) {
            result = NaN;
            minDistance = NaN;
            return;
        }
        const distance = Math.abs(timeToCompare - currentDate.getTime());
        if (result == null || distance < minDistance) {
            result = index;
            minDistance = distance;
        }
    });
    return result;
}

});

parcelRegister("9ORvi", function(module, exports) {

$parcel$export(module.exports, "closestTo", function () { return $7262495294ad71af$export$73858b464497125a; }, function (v) { return $7262495294ad71af$export$73858b464497125a = v; });
var $7262495294ad71af$export$73858b464497125a;
"use strict";
$7262495294ad71af$export$73858b464497125a = $7262495294ad71af$var$closestTo;

var $02yAu = parcelRequire("02yAu");

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name closestTo
 * @category Common Helpers
 * @summary Return a date from the array closest to the given date.
 *
 * @description
 * Return a date from the array closest to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateToCompare - The date to compare with
 * @param dates - The array to search
 *
 * @returns The date from the array closest to the given date or undefined if no valid value is given
 *
 * @example
 * // Which date is closer to 6 September 2015: 1 January 2000 or 1 January 2030?
 * const dateToCompare = new Date(2015, 8, 6)
 * const result = closestTo(dateToCompare, [
 *   new Date(2000, 0, 1),
 *   new Date(2030, 0, 1)
 * ])
 * //=> Tue Jan 01 2030 00:00:00
 */ function $7262495294ad71af$var$closestTo(dateToCompare, dates) {
    const date = (0, $b3MCU.toDate)(dateToCompare);
    if (isNaN(Number(date))) return (0, $02yAu.constructFrom)(dateToCompare, NaN);
    const timeToCompare = date.getTime();
    let result;
    let minDistance;
    dates.forEach((dirtyDate)=>{
        const currentDate = (0, $b3MCU.toDate)(dirtyDate);
        if (isNaN(Number(currentDate))) {
            result = (0, $02yAu.constructFrom)(dateToCompare, NaN);
            minDistance = NaN;
            return;
        }
        const distance = Math.abs(timeToCompare - currentDate.getTime());
        if (result == null || distance < minDistance) {
            result = currentDate;
            minDistance = distance;
        }
    });
    return result;
}

});

parcelRegister("6klPK", function(module, exports) {

$parcel$export(module.exports, "compareAsc", function () { return $49b58c09ba75c0e9$export$fe114145ae75d197; }, function (v) { return $49b58c09ba75c0e9$export$fe114145ae75d197 = v; });
var $49b58c09ba75c0e9$export$fe114145ae75d197;
"use strict";
$49b58c09ba75c0e9$export$fe114145ae75d197 = $49b58c09ba75c0e9$var$compareAsc;

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name compareAsc
 * @category Common Helpers
 * @summary Compare the two dates and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return 1 if the first date is after the second,
 * -1 if the first date is before the second or 0 if dates are equal.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to compare
 * @param dateRight - The second date to compare
 *
 * @returns The result of the comparison
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989:
 * const result = compareAsc(new Date(1987, 1, 11), new Date(1989, 6, 10))
 * //=> -1
 *
 * @example
 * // Sort the array of dates:
 * const result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareAsc)
 * //=> [
 * //   Wed Feb 11 1987 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Sun Jul 02 1995 00:00:00
 * // ]
 */ function $49b58c09ba75c0e9$var$compareAsc(dateLeft, dateRight) {
    const _dateLeft = (0, $b3MCU.toDate)(dateLeft);
    const _dateRight = (0, $b3MCU.toDate)(dateRight);
    const diff = _dateLeft.getTime() - _dateRight.getTime();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}

});

parcelRegister("gsQ3F", function(module, exports) {

$parcel$export(module.exports, "compareDesc", function () { return $bfc7a48493b9825b$export$ed84005ac9356f7a; }, function (v) { return $bfc7a48493b9825b$export$ed84005ac9356f7a = v; });
var $bfc7a48493b9825b$export$ed84005ac9356f7a;
"use strict";
$bfc7a48493b9825b$export$ed84005ac9356f7a = $bfc7a48493b9825b$var$compareDesc;

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name compareDesc
 * @category Common Helpers
 * @summary Compare the two dates reverse chronologically and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return -1 if the first date is after the second,
 * 1 if the first date is before the second or 0 if dates are equal.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to compare
 * @param dateRight - The second date to compare
 *
 * @returns The result of the comparison
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989 reverse chronologically:
 * const result = compareDesc(new Date(1987, 1, 11), new Date(1989, 6, 10))
 * //=> 1
 *
 * @example
 * // Sort the array of dates in reverse chronological order:
 * const result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareDesc)
 * //=> [
 * //   Sun Jul 02 1995 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Wed Feb 11 1987 00:00:00
 * // ]
 */ function $bfc7a48493b9825b$var$compareDesc(dateLeft, dateRight) {
    const _dateLeft = (0, $b3MCU.toDate)(dateLeft);
    const _dateRight = (0, $b3MCU.toDate)(dateRight);
    const diff = _dateLeft.getTime() - _dateRight.getTime();
    if (diff > 0) return -1;
    else if (diff < 0) return 1;
    else return diff;
}

});

parcelRegister("oVfas", function(module, exports) {

$parcel$export(module.exports, "constructNow", function () { return $04aea5665e1c5e3f$export$18c3c6510fb97afc; }, function (v) { return $04aea5665e1c5e3f$export$18c3c6510fb97afc = v; });
var $04aea5665e1c5e3f$export$18c3c6510fb97afc;
"use strict";
$04aea5665e1c5e3f$export$18c3c6510fb97afc = $04aea5665e1c5e3f$var$constructNow;

var $02yAu = parcelRequire("02yAu");
/**
 * @name constructNow
 * @category Generic Helpers
 * @summary Constructs a new current date using the passed value constructor.
 * @pure false
 *
 * @description
 * The function constructs a new current date using the constructor from
 * the reference date. It helps to build generic functions that accept date
 * extensions and use the current date.
 *
 * It defaults to `Date` if the passed reference date is a number or a string.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The reference date to take constructor from
 *
 * @returns Current date initialized using the given date constructor
 *
 * @example
 * import { constructNow, isSameDay } from 'date-fns'
 *
 * function isToday<DateType extends Date>(
 *   date: DateType | number | string,
 * ): boolean {
 *   // If we were to use `new Date()` directly, the function would  behave
 *   // differently in different timezones and return false for the same date.
 *   return isSameDay(date, constructNow(date));
 * }
 */ function $04aea5665e1c5e3f$var$constructNow(date) {
    return (0, $02yAu.constructFrom)(date, Date.now());
}

});

parcelRegister("jSXjx", function(module, exports) {

$parcel$export(module.exports, "daysToWeeks", function () { return $e7a1120278eb22f5$export$66d8b66cbb6006a8; }, function (v) { return $e7a1120278eb22f5$export$66d8b66cbb6006a8 = v; });
var $e7a1120278eb22f5$export$66d8b66cbb6006a8;
"use strict";
$e7a1120278eb22f5$export$66d8b66cbb6006a8 = $e7a1120278eb22f5$var$daysToWeeks;

var $7MMvH = parcelRequire("7MMvH");
/**
 * @name daysToWeeks
 * @category Conversion Helpers
 * @summary Convert days to weeks.
 *
 * @description
 * Convert a number of days to a full number of weeks.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param days - The number of days to be converted
 *
 * @returns The number of days converted in weeks
 *
 * @example
 * // Convert 14 days to weeks:
 * const result = daysToWeeks(14)
 * //=> 2
 *
 * @example
 * // It uses trunc rounding:
 * const result = daysToWeeks(13)
 * //=> 1
 */ function $e7a1120278eb22f5$var$daysToWeeks(days) {
    const weeks = days / $7MMvH.daysInWeek;
    const result = Math.trunc(weeks);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});

parcelRegister("1wnvX", function(module, exports) {

$parcel$export(module.exports, "differenceInBusinessDays", function () { return $11bb0519cbd0e926$export$f30d3269a6c53cb9; }, function (v) { return $11bb0519cbd0e926$export$f30d3269a6c53cb9 = v; });
var $11bb0519cbd0e926$export$f30d3269a6c53cb9;
"use strict";
$11bb0519cbd0e926$export$f30d3269a6c53cb9 = $11bb0519cbd0e926$var$differenceInBusinessDays;

var $cBVis = parcelRequire("cBVis");

var $fctE0 = parcelRequire("fctE0");

var $8w9BL = parcelRequire("8w9BL");

var $cmplH = parcelRequire("cmplH");

var $jsxIt = parcelRequire("jsxIt");

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name differenceInBusinessDays
 * @category Day Helpers
 * @summary Get the number of business days between the given dates.
 *
 * @description
 * Get the number of business day periods between the given dates.
 * Business days being days that arent in the weekend.
 * Like `differenceInCalendarDays`, the function removes the times from
 * the dates before calculating the difference.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of business days
 *
 * @example
 * // How many business days are between
 * // 10 January 2014 and 20 July 2014?
 * const result = differenceInBusinessDays(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 0, 10)
 * )
 * //=> 136
 *
 * // How many business days are between
 * // 30 November 2021 and 1 November 2021?
 * const result = differenceInBusinessDays(
 *   new Date(2021, 10, 30),
 *   new Date(2021, 10, 1)
 * )
 * //=> 21
 *
 * // How many business days are between
 * // 1 November 2021 and 1 December 2021?
 * const result = differenceInBusinessDays(
 *   new Date(2021, 10, 1),
 *   new Date(2021, 11, 1)
 * )
 * //=> -22
 *
 * // How many business days are between
 * // 1 November 2021 and 1 November 2021 ?
 * const result = differenceInBusinessDays(
 *   new Date(2021, 10, 1),
 *   new Date(2021, 10, 1)
 * )
 * //=> 0
 */ function $11bb0519cbd0e926$var$differenceInBusinessDays(dateLeft, dateRight) {
    const _dateLeft = (0, $b3MCU.toDate)(dateLeft);
    let _dateRight = (0, $b3MCU.toDate)(dateRight);
    if (!(0, $cmplH.isValid)(_dateLeft) || !(0, $cmplH.isValid)(_dateRight)) return NaN;
    const calendarDifference = (0, $fctE0.differenceInCalendarDays)(_dateLeft, _dateRight);
    const sign = calendarDifference < 0 ? -1 : 1;
    const weeks = Math.trunc(calendarDifference / 7);
    let result = weeks * 5;
    _dateRight = (0, $cBVis.addDays)(_dateRight, weeks * 7);
    // the loop below will run at most 6 times to account for the remaining days that don't makeup a full week
    while(!(0, $8w9BL.isSameDay)(_dateLeft, _dateRight)){
        // sign is used to account for both negative and positive differences
        result += (0, $jsxIt.isWeekend)(_dateRight) ? 0 : sign;
        _dateRight = (0, $cBVis.addDays)(_dateRight, sign);
    }
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});
parcelRegister("8w9BL", function(module, exports) {

$parcel$export(module.exports, "isSameDay", function () { return $6338c3dab803bc56$export$ea39ec197993aef0; }, function (v) { return $6338c3dab803bc56$export$ea39ec197993aef0 = v; });
var $6338c3dab803bc56$export$ea39ec197993aef0;
"use strict";
$6338c3dab803bc56$export$ea39ec197993aef0 = $6338c3dab803bc56$var$isSameDay;

var $aorCW = parcelRequire("aorCW");
/**
 * @name isSameDay
 * @category Day Helpers
 * @summary Are the given dates in the same day (and year and month)?
 *
 * @description
 * Are the given dates in the same day (and year and month)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check

 * @returns The dates are in the same day (and year and month)
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
 * //=> true
 *
 * @example
 * // Are 4 September and 4 October in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2014, 9, 4))
 * //=> false
 *
 * @example
 * // Are 4 September, 2014 and 4 September, 2015 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2015, 8, 4))
 * //=> false
 */ function $6338c3dab803bc56$var$isSameDay(dateLeft, dateRight) {
    const dateLeftStartOfDay = (0, $aorCW.startOfDay)(dateLeft);
    const dateRightStartOfDay = (0, $aorCW.startOfDay)(dateRight);
    return +dateLeftStartOfDay === +dateRightStartOfDay;
}

});

parcelRegister("cmplH", function(module, exports) {

$parcel$export(module.exports, "isValid", function () { return $8ffb33dfea898dff$export$1ea939691cdc45b8; }, function (v) { return $8ffb33dfea898dff$export$1ea939691cdc45b8 = v; });
var $8ffb33dfea898dff$export$1ea939691cdc45b8;
"use strict";
$8ffb33dfea898dff$export$1ea939691cdc45b8 = $8ffb33dfea898dff$var$isValid;

var $jGg0G = parcelRequire("jGg0G");

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate](https://date-fns.org/docs/toDate)
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is valid
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */ function $8ffb33dfea898dff$var$isValid(date) {
    if (!(0, $jGg0G.isDate)(date) && typeof date !== "number") return false;
    const _date = (0, $b3MCU.toDate)(date);
    return !isNaN(Number(_date));
}

});
parcelRegister("jGg0G", function(module, exports) {

$parcel$export(module.exports, "isDate", function () { return $e53e5bd244cb0dc1$export$871608497c498473; }, function (v) { return $e53e5bd244cb0dc1$export$871608497c498473 = v; });
var $e53e5bd244cb0dc1$export$871608497c498473;
"use strict";
$e53e5bd244cb0dc1$export$871608497c498473 = $e53e5bd244cb0dc1$var$isDate; /**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param value - The value to check
 *
 * @returns True if the given value is a date
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */ 
function $e53e5bd244cb0dc1$var$isDate(value) {
    return value instanceof Date || typeof value === "object" && Object.prototype.toString.call(value) === "[object Date]";
}

});



parcelRegister("iPbge", function(module, exports) {

$parcel$export(module.exports, "differenceInCalendarISOWeekYears", function () { return $db45b9952d5bdf1d$export$7f8a73dc2e50a070; }, function (v) { return $db45b9952d5bdf1d$export$7f8a73dc2e50a070 = v; });
var $db45b9952d5bdf1d$export$7f8a73dc2e50a070;
"use strict";
$db45b9952d5bdf1d$export$7f8a73dc2e50a070 = $db45b9952d5bdf1d$var$differenceInCalendarISOWeekYears;

var $43yjM = parcelRequire("43yjM");
/**
 * @name differenceInCalendarISOWeekYears
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of calendar ISO week-numbering years between the given dates.
 *
 * @description
 * Get the number of calendar ISO week-numbering years between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar ISO week-numbering years
 *
 * @example
 * // How many calendar ISO week-numbering years are 1 January 2010 and 1 January 2012?
 * const result = differenceInCalendarISOWeekYears(
 *   new Date(2012, 0, 1),
 *   new Date(2010, 0, 1)
 * )
 * //=> 2
 */ function $db45b9952d5bdf1d$var$differenceInCalendarISOWeekYears(dateLeft, dateRight) {
    return (0, $43yjM.getISOWeekYear)(dateLeft) - (0, $43yjM.getISOWeekYear)(dateRight);
}

});

parcelRegister("e7CD4", function(module, exports) {

$parcel$export(module.exports, "differenceInCalendarISOWeeks", function () { return $a47faf12eadee448$export$28df1cb58b17e450; }, function (v) { return $a47faf12eadee448$export$28df1cb58b17e450 = v; });
var $a47faf12eadee448$export$28df1cb58b17e450;
"use strict";
$a47faf12eadee448$export$28df1cb58b17e450 = $a47faf12eadee448$var$differenceInCalendarISOWeeks;

var $7MMvH = parcelRequire("7MMvH");

var $4x8aw = parcelRequire("4x8aw");

var $izS8L = parcelRequire("izS8L");
/**
 * @name differenceInCalendarISOWeeks
 * @category ISO Week Helpers
 * @summary Get the number of calendar ISO weeks between the given dates.
 *
 * @description
 * Get the number of calendar ISO weeks between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar ISO weeks
 *
 * @example
 * // How many calendar ISO weeks are between 6 July 2014 and 21 July 2014?
 * const result = differenceInCalendarISOWeeks(
 *   new Date(2014, 6, 21),
 *   new Date(2014, 6, 6)
 * )
 * //=> 3
 */ function $a47faf12eadee448$var$differenceInCalendarISOWeeks(dateLeft, dateRight) {
    const startOfISOWeekLeft = (0, $4x8aw.startOfISOWeek)(dateLeft);
    const startOfISOWeekRight = (0, $4x8aw.startOfISOWeek)(dateRight);
    const timestampLeft = +startOfISOWeekLeft - (0, $izS8L.getTimezoneOffsetInMilliseconds)(startOfISOWeekLeft);
    const timestampRight = +startOfISOWeekRight - (0, $izS8L.getTimezoneOffsetInMilliseconds)(startOfISOWeekRight);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((timestampLeft - timestampRight) / $7MMvH.millisecondsInWeek);
}

});

parcelRegister("eUT4w", function(module, exports) {

$parcel$export(module.exports, "differenceInCalendarMonths", function () { return $adc103cbc7cbc94d$export$489984ac7c996389; }, function (v) { return $adc103cbc7cbc94d$export$489984ac7c996389 = v; });
var $adc103cbc7cbc94d$export$489984ac7c996389;
"use strict";
$adc103cbc7cbc94d$export$489984ac7c996389 = $adc103cbc7cbc94d$var$differenceInCalendarMonths;

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name differenceInCalendarMonths
 * @category Month Helpers
 * @summary Get the number of calendar months between the given dates.
 *
 * @description
 * Get the number of calendar months between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar months
 *
 * @example
 * // How many calendar months are between 31 January 2014 and 1 September 2014?
 * const result = differenceInCalendarMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 8
 */ function $adc103cbc7cbc94d$var$differenceInCalendarMonths(dateLeft, dateRight) {
    const _dateLeft = (0, $b3MCU.toDate)(dateLeft);
    const _dateRight = (0, $b3MCU.toDate)(dateRight);
    const yearDiff = _dateLeft.getFullYear() - _dateRight.getFullYear();
    const monthDiff = _dateLeft.getMonth() - _dateRight.getMonth();
    return yearDiff * 12 + monthDiff;
}

});

parcelRegister("ilnvA", function(module, exports) {

$parcel$export(module.exports, "differenceInCalendarQuarters", function () { return $d5ac6c79da8aad5d$export$f62ae9fb13958c7a; }, function (v) { return $d5ac6c79da8aad5d$export$f62ae9fb13958c7a = v; });
var $d5ac6c79da8aad5d$export$f62ae9fb13958c7a;
"use strict";
$d5ac6c79da8aad5d$export$f62ae9fb13958c7a = $d5ac6c79da8aad5d$var$differenceInCalendarQuarters;

var $ieGzH = parcelRequire("ieGzH");

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name differenceInCalendarQuarters
 * @category Quarter Helpers
 * @summary Get the number of calendar quarters between the given dates.
 *
 * @description
 * Get the number of calendar quarters between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date

 * @returns The number of calendar quarters
 *
 * @example
 * // How many calendar quarters are between 31 December 2013 and 2 July 2014?
 * const result = differenceInCalendarQuarters(
 *   new Date(2014, 6, 2),
 *   new Date(2013, 11, 31)
 * )
 * //=> 3
 */ function $d5ac6c79da8aad5d$var$differenceInCalendarQuarters(dateLeft, dateRight) {
    const _dateLeft = (0, $b3MCU.toDate)(dateLeft);
    const _dateRight = (0, $b3MCU.toDate)(dateRight);
    const yearDiff = _dateLeft.getFullYear() - _dateRight.getFullYear();
    const quarterDiff = (0, $ieGzH.getQuarter)(_dateLeft) - (0, $ieGzH.getQuarter)(_dateRight);
    return yearDiff * 4 + quarterDiff;
}

});
parcelRegister("ieGzH", function(module, exports) {

$parcel$export(module.exports, "getQuarter", function () { return $d46a8f47cefe55e4$export$de90a4bb31c25221; }, function (v) { return $d46a8f47cefe55e4$export$de90a4bb31c25221 = v; });
var $d46a8f47cefe55e4$export$de90a4bb31c25221;
"use strict";
$d46a8f47cefe55e4$export$de90a4bb31c25221 = $d46a8f47cefe55e4$var$getQuarter;

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name getQuarter
 * @category Quarter Helpers
 * @summary Get the year quarter of the given date.
 *
 * @description
 * Get the year quarter of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The quarter
 *
 * @example
 * // Which quarter is 2 July 2014?
 * const result = getQuarter(new Date(2014, 6, 2))
 * //=> 3
 */ function $d46a8f47cefe55e4$var$getQuarter(date) {
    const _date = (0, $b3MCU.toDate)(date);
    const quarter = Math.trunc(_date.getMonth() / 3) + 1;
    return quarter;
}

});


parcelRegister("gDfuA", function(module, exports) {

$parcel$export(module.exports, "differenceInCalendarWeeks", function () { return $c1bc4e4c6706639d$export$6ed034ce62348e4; }, function (v) { return $c1bc4e4c6706639d$export$6ed034ce62348e4 = v; });
var $c1bc4e4c6706639d$export$6ed034ce62348e4;
"use strict";
$c1bc4e4c6706639d$export$6ed034ce62348e4 = $c1bc4e4c6706639d$var$differenceInCalendarWeeks;

var $7MMvH = parcelRequire("7MMvH");

var $isuGI = parcelRequire("isuGI");

var $izS8L = parcelRequire("izS8L");
/**
 * The {@link differenceInCalendarWeeks} function options.
 */ /**
 * @name differenceInCalendarWeeks
 * @category Week Helpers
 * @summary Get the number of calendar weeks between the given dates.
 *
 * @description
 * Get the number of calendar weeks between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of calendar weeks
 *
 * @example
 * // How many calendar weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5)
 * )
 * //=> 3
 *
 * @example
 * // If the week starts on Monday,
 * // how many calendar weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5),
 *   { weekStartsOn: 1 }
 * )
 * //=> 2
 */ function $c1bc4e4c6706639d$var$differenceInCalendarWeeks(dateLeft, dateRight, options) {
    const startOfWeekLeft = (0, $isuGI.startOfWeek)(dateLeft, options);
    const startOfWeekRight = (0, $isuGI.startOfWeek)(dateRight, options);
    const timestampLeft = +startOfWeekLeft - (0, $izS8L.getTimezoneOffsetInMilliseconds)(startOfWeekLeft);
    const timestampRight = +startOfWeekRight - (0, $izS8L.getTimezoneOffsetInMilliseconds)(startOfWeekRight);
    // Round the number of days to the nearest integer because the number of
    // milliseconds in a days is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((timestampLeft - timestampRight) / $7MMvH.millisecondsInWeek);
}

});

parcelRegister("bnwnB", function(module, exports) {

$parcel$export(module.exports, "differenceInCalendarYears", function () { return $848af5a35723f995$export$c06dce8b38891685; }, function (v) { return $848af5a35723f995$export$c06dce8b38891685 = v; });
var $848af5a35723f995$export$c06dce8b38891685;
"use strict";
$848af5a35723f995$export$c06dce8b38891685 = $848af5a35723f995$var$differenceInCalendarYears;

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name differenceInCalendarYears
 * @category Year Helpers
 * @summary Get the number of calendar years between the given dates.
 *
 * @description
 * Get the number of calendar years between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date

 * @returns The number of calendar years
 *
 * @example
 * // How many calendar years are between 31 December 2013 and 11 February 2015?
 * const result = differenceInCalendarYears(
 *   new Date(2015, 1, 11),
 *   new Date(2013, 11, 31)
 * )
 * //=> 2
 */ function $848af5a35723f995$var$differenceInCalendarYears(dateLeft, dateRight) {
    const _dateLeft = (0, $b3MCU.toDate)(dateLeft);
    const _dateRight = (0, $b3MCU.toDate)(dateRight);
    return _dateLeft.getFullYear() - _dateRight.getFullYear();
}

});

parcelRegister("7t70d", function(module, exports) {

$parcel$export(module.exports, "differenceInDays", function () { return $5700ac5e2baddde3$export$86415ebf4eb36b8c; }, function (v) { return $5700ac5e2baddde3$export$86415ebf4eb36b8c = v; });
var $5700ac5e2baddde3$export$86415ebf4eb36b8c;
"use strict";
$5700ac5e2baddde3$export$86415ebf4eb36b8c = $5700ac5e2baddde3$var$differenceInDays;

var $fctE0 = parcelRequire("fctE0");

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name differenceInDays
 * @category Day Helpers
 * @summary Get the number of full days between the given dates.
 *
 * @description
 * Get the number of full day periods between two dates. Fractional days are
 * truncated towards zero.
 *
 * One "full day" is the distance between a local time in one day to the same
 * local time on the next or previous day. A full day can sometimes be less than
 * or more than 24 hours if a daylight savings change happens between two dates.
 *
 * To ignore DST and only measure exact 24-hour periods, use this instead:
 * `Math.trunc(differenceInHours(dateLeft, dateRight)/24)|0`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of full days according to the local timezone
 *
 * @example
 * // How many full days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 365
 *
 * @example
 * // How many full days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 0
 *
 * @example
 * // How many full days are between
 * // 1 March 2020 0:00 and 1 June 2020 0:00 ?
 * // Note: because local time is used, the
 * // result will always be 92 days, even in
 * // time zones where DST starts and the
 * // period has only 92*24-1 hours.
 * const result = differenceInDays(
 *   new Date(2020, 5, 1),
 *   new Date(2020, 2, 1)
 * )
 * //=> 92
 */ function $5700ac5e2baddde3$var$differenceInDays(dateLeft, dateRight) {
    const _dateLeft = (0, $b3MCU.toDate)(dateLeft);
    const _dateRight = (0, $b3MCU.toDate)(dateRight);
    const sign = $5700ac5e2baddde3$var$compareLocalAsc(_dateLeft, _dateRight);
    const difference = Math.abs((0, $fctE0.differenceInCalendarDays)(_dateLeft, _dateRight));
    _dateLeft.setDate(_dateLeft.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    const isLastDayNotFull = Number($5700ac5e2baddde3$var$compareLocalAsc(_dateLeft, _dateRight) === -sign);
    const result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}
// Like `compareAsc` but uses local time not UTC, which is needed
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function $5700ac5e2baddde3$var$compareLocalAsc(dateLeft, dateRight) {
    const diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}

});

parcelRegister("exRu4", function(module, exports) {

$parcel$export(module.exports, "differenceInHours", function () { return $a96da29480046ae2$export$5436ca250d4d6872; }, function (v) { return $a96da29480046ae2$export$5436ca250d4d6872 = v; });
var $a96da29480046ae2$export$5436ca250d4d6872;
"use strict";
$a96da29480046ae2$export$5436ca250d4d6872 = $a96da29480046ae2$var$differenceInHours;

var $bumqY = parcelRequire("bumqY");

var $7MMvH = parcelRequire("7MMvH");

var $55YJb = parcelRequire("55YJb");
/**
 * The {@link differenceInHours} function options.
 */ /**
 * @name differenceInHours
 * @category Hour Helpers
 * @summary Get the number of hours between the given dates.
 *
 * @description
 * Get the number of hours between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of hours
 *
 * @example
 * // How many hours are between 2 July 2014 06:50:00 and 2 July 2014 19:00:00?
 * const result = differenceInHours(
 *   new Date(2014, 6, 2, 19, 0),
 *   new Date(2014, 6, 2, 6, 50)
 * )
 * //=> 12
 */ function $a96da29480046ae2$var$differenceInHours(dateLeft, dateRight, options) {
    const diff = (0, $55YJb.differenceInMilliseconds)(dateLeft, dateRight) / $7MMvH.millisecondsInHour;
    return (0, $bumqY.getRoundingMethod)(options?.roundingMethod)(diff);
}

});
parcelRegister("bumqY", function(module, exports) {

$parcel$export(module.exports, "getRoundingMethod", function () { return $85d3e5fa0364bf3a$export$b6474a47258c1211; }, function (v) { return $85d3e5fa0364bf3a$export$b6474a47258c1211 = v; });
var $85d3e5fa0364bf3a$export$b6474a47258c1211;
"use strict";
$85d3e5fa0364bf3a$export$b6474a47258c1211 = $85d3e5fa0364bf3a$var$getRoundingMethod;
function $85d3e5fa0364bf3a$var$getRoundingMethod(method) {
    return (number)=>{
        const round = method ? Math[method] : Math.trunc;
        const result = round(number);
        // Prevent negative zero
        return result === 0 ? 0 : result;
    };
}

});

parcelRegister("55YJb", function(module, exports) {

$parcel$export(module.exports, "differenceInMilliseconds", function () { return $3b5c86a11a474140$export$7be94d13716b4bf6; }, function (v) { return $3b5c86a11a474140$export$7be94d13716b4bf6 = v; });
var $3b5c86a11a474140$export$7be94d13716b4bf6;
"use strict";
$3b5c86a11a474140$export$7be94d13716b4bf6 = $3b5c86a11a474140$var$differenceInMilliseconds;

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name differenceInMilliseconds
 * @category Millisecond Helpers
 * @summary Get the number of milliseconds between the given dates.
 *
 * @description
 * Get the number of milliseconds between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of milliseconds
 *
 * @example
 * // How many milliseconds are between
 * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
 * const result = differenceInMilliseconds(
 *   new Date(2014, 6, 2, 12, 30, 21, 700),
 *   new Date(2014, 6, 2, 12, 30, 20, 600)
 * )
 * //=> 1100
 */ function $3b5c86a11a474140$var$differenceInMilliseconds(dateLeft, dateRight) {
    return +(0, $b3MCU.toDate)(dateLeft) - +(0, $b3MCU.toDate)(dateRight);
}

});


parcelRegister("fpdO5", function(module, exports) {

$parcel$export(module.exports, "differenceInISOWeekYears", function () { return $b373e68f7ce4cc2f$export$bf7bde0b3bf8913a; }, function (v) { return $b373e68f7ce4cc2f$export$bf7bde0b3bf8913a = v; });
var $b373e68f7ce4cc2f$export$bf7bde0b3bf8913a;
"use strict";
$b373e68f7ce4cc2f$export$bf7bde0b3bf8913a = $b373e68f7ce4cc2f$var$differenceInISOWeekYears;

var $6klPK = parcelRequire("6klPK");

var $iPbge = parcelRequire("iPbge");

var $6MrzR = parcelRequire("6MrzR");

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name differenceInISOWeekYears
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of full ISO week-numbering years between the given dates.
 *
 * @description
 * Get the number of full ISO week-numbering years between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of full ISO week-numbering years
 *
 * @example
 * // How many full ISO week-numbering years are between 1 January 2010 and 1 January 2012?
 * const result = differenceInISOWeekYears(
 *   new Date(2012, 0, 1),
 *   new Date(2010, 0, 1)
 * )
 * //=> 1
 */ function $b373e68f7ce4cc2f$var$differenceInISOWeekYears(dateLeft, dateRight) {
    let _dateLeft = (0, $b3MCU.toDate)(dateLeft);
    const _dateRight = (0, $b3MCU.toDate)(dateRight);
    const sign = (0, $6klPK.compareAsc)(_dateLeft, _dateRight);
    const difference = Math.abs((0, $iPbge.differenceInCalendarISOWeekYears)(_dateLeft, _dateRight));
    _dateLeft = (0, $6MrzR.subISOWeekYears)(_dateLeft, sign * difference);
    // Math.abs(diff in full ISO years - diff in calendar ISO years) === 1
    // if last calendar ISO year is not full
    // If so, result must be decreased by 1 in absolute value
    const isLastISOWeekYearNotFull = Number((0, $6klPK.compareAsc)(_dateLeft, _dateRight) === -sign);
    const result = sign * (difference - isLastISOWeekYearNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});
parcelRegister("6MrzR", function(module, exports) {

$parcel$export(module.exports, "subISOWeekYears", function () { return $4efc9e1364e9eec9$export$4f7d47b952f4a0aa; }, function (v) { return $4efc9e1364e9eec9$export$4f7d47b952f4a0aa = v; });
var $4efc9e1364e9eec9$export$4f7d47b952f4a0aa;
"use strict";
$4efc9e1364e9eec9$export$4f7d47b952f4a0aa = $4efc9e1364e9eec9$var$subISOWeekYears;

var $hmVkE = parcelRequire("hmVkE");
/**
 * @name subISOWeekYears
 * @category ISO Week-Numbering Year Helpers
 * @summary Subtract the specified number of ISO week-numbering years from the given date.
 *
 * @description
 * Subtract the specified number of ISO week-numbering years from the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of ISO week-numbering years to be subtracted.
 *
 * @returns The new date with the ISO week-numbering years subtracted
 *
 * @example
 * // Subtract 5 ISO week-numbering years from 1 September 2014:
 * const result = subISOWeekYears(new Date(2014, 8, 1), 5)
 * //=> Mon Aug 31 2009 00:00:00
 */ function $4efc9e1364e9eec9$var$subISOWeekYears(date, amount) {
    return (0, $hmVkE.addISOWeekYears)(date, -amount);
}

});


parcelRegister("cOBKs", function(module, exports) {

$parcel$export(module.exports, "differenceInMinutes", function () { return $95476f8f25bfb6d3$export$d904251335be481a; }, function (v) { return $95476f8f25bfb6d3$export$d904251335be481a = v; });
var $95476f8f25bfb6d3$export$d904251335be481a;
"use strict";
$95476f8f25bfb6d3$export$d904251335be481a = $95476f8f25bfb6d3$var$differenceInMinutes;

var $bumqY = parcelRequire("bumqY");

var $7MMvH = parcelRequire("7MMvH");

var $55YJb = parcelRequire("55YJb");
/**
 * The {@link differenceInMinutes} function options.
 */ /**
 * @name differenceInMinutes
 * @category Minute Helpers
 * @summary Get the number of minutes between the given dates.
 *
 * @description
 * Get the signed number of full (rounded towards 0) minutes between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of minutes
 *
 * @example
 * // How many minutes are between 2 July 2014 12:07:59 and 2 July 2014 12:20:00?
 * const result = differenceInMinutes(
 *   new Date(2014, 6, 2, 12, 20, 0),
 *   new Date(2014, 6, 2, 12, 7, 59)
 * )
 * //=> 12
 *
 * @example
 * // How many minutes are between 10:01:59 and 10:00:00
 * const result = differenceInMinutes(
 *   new Date(2000, 0, 1, 10, 0, 0),
 *   new Date(2000, 0, 1, 10, 1, 59)
 * )
 * //=> -1
 */ function $95476f8f25bfb6d3$var$differenceInMinutes(dateLeft, dateRight, options) {
    const diff = (0, $55YJb.differenceInMilliseconds)(dateLeft, dateRight) / $7MMvH.millisecondsInMinute;
    return (0, $bumqY.getRoundingMethod)(options?.roundingMethod)(diff);
}

});

parcelRegister("klNiQ", function(module, exports) {

$parcel$export(module.exports, "differenceInMonths", function () { return $ed0c035f94831a42$export$fc1ed482c2861792; }, function (v) { return $ed0c035f94831a42$export$fc1ed482c2861792 = v; });
var $ed0c035f94831a42$export$fc1ed482c2861792;
"use strict";
$ed0c035f94831a42$export$fc1ed482c2861792 = $ed0c035f94831a42$var$differenceInMonths;

var $6klPK = parcelRequire("6klPK");

var $eUT4w = parcelRequire("eUT4w");

var $5qKoS = parcelRequire("5qKoS");

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name differenceInMonths
 * @category Month Helpers
 * @summary Get the number of full months between the given dates.
 *
 * @description
 * Get the number of full months between the given dates using trunc as a default rounding method.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of full months
 *
 * @example
 * // How many full months are between 31 January 2014 and 1 September 2014?
 * const result = differenceInMonths(new Date(2014, 8, 1), new Date(2014, 0, 31))
 * //=> 7
 */ function $ed0c035f94831a42$var$differenceInMonths(dateLeft, dateRight) {
    const _dateLeft = (0, $b3MCU.toDate)(dateLeft);
    const _dateRight = (0, $b3MCU.toDate)(dateRight);
    const sign = (0, $6klPK.compareAsc)(_dateLeft, _dateRight);
    const difference = Math.abs((0, $eUT4w.differenceInCalendarMonths)(_dateLeft, _dateRight));
    let result;
    // Check for the difference of less than month
    if (difference < 1) result = 0;
    else {
        if (_dateLeft.getMonth() === 1 && _dateLeft.getDate() > 27) // This will check if the date is end of Feb and assign a higher end of month date
        // to compare it with Jan
        _dateLeft.setDate(30);
        _dateLeft.setMonth(_dateLeft.getMonth() - sign * difference);
        // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
        // If so, result must be decreased by 1 in absolute value
        let isLastMonthNotFull = (0, $6klPK.compareAsc)(_dateLeft, _dateRight) === -sign;
        // Check for cases of one full calendar month
        if ((0, $5qKoS.isLastDayOfMonth)((0, $b3MCU.toDate)(dateLeft)) && difference === 1 && (0, $6klPK.compareAsc)(dateLeft, _dateRight) === 1) isLastMonthNotFull = false;
        result = sign * (difference - Number(isLastMonthNotFull));
    }
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});
parcelRegister("5qKoS", function(module, exports) {

$parcel$export(module.exports, "isLastDayOfMonth", function () { return $3f435f91eb1eb3a0$export$c817d0312007ea5e; }, function (v) { return $3f435f91eb1eb3a0$export$c817d0312007ea5e = v; });
var $3f435f91eb1eb3a0$export$c817d0312007ea5e;
"use strict";
$3f435f91eb1eb3a0$export$c817d0312007ea5e = $3f435f91eb1eb3a0$var$isLastDayOfMonth;

var $ikjzL = parcelRequire("ikjzL");

var $5pWy6 = parcelRequire("5pWy6");

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name isLastDayOfMonth
 * @category Month Helpers
 * @summary Is the given date the last day of a month?
 *
 * @description
 * Is the given date the last day of a month?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check

 * @returns The date is the last day of a month
 *
 * @example
 * // Is 28 February 2014 the last day of a month?
 * const result = isLastDayOfMonth(new Date(2014, 1, 28))
 * //=> true
 */ function $3f435f91eb1eb3a0$var$isLastDayOfMonth(date) {
    const _date = (0, $b3MCU.toDate)(date);
    return +(0, $ikjzL.endOfDay)(_date) === +(0, $5pWy6.endOfMonth)(_date);
}

});
parcelRegister("ikjzL", function(module, exports) {

$parcel$export(module.exports, "endOfDay", function () { return $d579479b453f2e27$export$eb9a03f0e9aa6cea; }, function (v) { return $d579479b453f2e27$export$eb9a03f0e9aa6cea = v; });
var $d579479b453f2e27$export$eb9a03f0e9aa6cea;
"use strict";
$d579479b453f2e27$export$eb9a03f0e9aa6cea = $d579479b453f2e27$var$endOfDay;

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name endOfDay
 * @category Day Helpers
 * @summary Return the end of a day for the given date.
 *
 * @description
 * Return the end of a day for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a day
 *
 * @example
 * // The end of a day for 2 September 2014 11:55:00:
 * const result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 23:59:59.999
 */ function $d579479b453f2e27$var$endOfDay(date) {
    const _date = (0, $b3MCU.toDate)(date);
    _date.setHours(23, 59, 59, 999);
    return _date;
}

});

parcelRegister("5pWy6", function(module, exports) {

$parcel$export(module.exports, "endOfMonth", function () { return $3f1cb42a700e4cca$export$a2258d9c4118825c; }, function (v) { return $3f1cb42a700e4cca$export$a2258d9c4118825c = v; });
var $3f1cb42a700e4cca$export$a2258d9c4118825c;
"use strict";
$3f1cb42a700e4cca$export$a2258d9c4118825c = $3f1cb42a700e4cca$var$endOfMonth;

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name endOfMonth
 * @category Month Helpers
 * @summary Return the end of a month for the given date.
 *
 * @description
 * Return the end of a month for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a month
 *
 * @example
 * // The end of a month for 2 September 2014 11:55:00:
 * const result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */ function $3f1cb42a700e4cca$var$endOfMonth(date) {
    const _date = (0, $b3MCU.toDate)(date);
    const month = _date.getMonth();
    _date.setFullYear(_date.getFullYear(), month + 1, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}

});



parcelRegister("efBf4", function(module, exports) {

$parcel$export(module.exports, "differenceInQuarters", function () { return $a5ff5ae9828e99e6$export$74b5c4055a405552; }, function (v) { return $a5ff5ae9828e99e6$export$74b5c4055a405552 = v; });
var $a5ff5ae9828e99e6$export$74b5c4055a405552;
"use strict";
$a5ff5ae9828e99e6$export$74b5c4055a405552 = $a5ff5ae9828e99e6$var$differenceInQuarters;

var $bumqY = parcelRequire("bumqY");

var $klNiQ = parcelRequire("klNiQ");
/**
 * The {@link differenceInQuarters} function options.
 */ /**
 * @name differenceInQuarters
 * @category Quarter Helpers
 * @summary Get the number of quarters between the given dates.
 *
 * @description
 * Get the number of quarters between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of full quarters
 *
 * @example
 * // How many full quarters are between 31 December 2013 and 2 July 2014?
 * const result = differenceInQuarters(new Date(2014, 6, 2), new Date(2013, 11, 31))
 * //=> 2
 */ function $a5ff5ae9828e99e6$var$differenceInQuarters(dateLeft, dateRight, options) {
    const diff = (0, $klNiQ.differenceInMonths)(dateLeft, dateRight) / 3;
    return (0, $bumqY.getRoundingMethod)(options?.roundingMethod)(diff);
}

});

parcelRegister("hfEAx", function(module, exports) {

$parcel$export(module.exports, "differenceInSeconds", function () { return $c8f35266394f174b$export$c1889aec51783710; }, function (v) { return $c8f35266394f174b$export$c1889aec51783710 = v; });
var $c8f35266394f174b$export$c1889aec51783710;
"use strict";
$c8f35266394f174b$export$c1889aec51783710 = $c8f35266394f174b$var$differenceInSeconds;

var $bumqY = parcelRequire("bumqY");

var $55YJb = parcelRequire("55YJb");
/**
 * The {@link differenceInSeconds} function options.
 */ /**
 * @name differenceInSeconds
 * @category Second Helpers
 * @summary Get the number of seconds between the given dates.
 *
 * @description
 * Get the number of seconds between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of seconds
 *
 * @example
 * // How many seconds are between
 * // 2 July 2014 12:30:07.999 and 2 July 2014 12:30:20.000?
 * const result = differenceInSeconds(
 *   new Date(2014, 6, 2, 12, 30, 20, 0),
 *   new Date(2014, 6, 2, 12, 30, 7, 999)
 * )
 * //=> 12
 */ function $c8f35266394f174b$var$differenceInSeconds(dateLeft, dateRight, options) {
    const diff = (0, $55YJb.differenceInMilliseconds)(dateLeft, dateRight) / 1000;
    return (0, $bumqY.getRoundingMethod)(options?.roundingMethod)(diff);
}

});

parcelRegister("guHFh", function(module, exports) {

$parcel$export(module.exports, "differenceInWeeks", function () { return $c0215197b623a881$export$b5147a91dc40ddb7; }, function (v) { return $c0215197b623a881$export$b5147a91dc40ddb7 = v; });
var $c0215197b623a881$export$b5147a91dc40ddb7;
"use strict";
$c0215197b623a881$export$b5147a91dc40ddb7 = $c0215197b623a881$var$differenceInWeeks;

var $bumqY = parcelRequire("bumqY");

var $7t70d = parcelRequire("7t70d");
/**
 * The {@link differenceInWeeks} function options.
 */ /**
 * @name differenceInWeeks
 * @category Week Helpers
 * @summary Get the number of full weeks between the given dates.
 *
 * @description
 * Get the number of full weeks between two dates. Fractional weeks are
 * truncated towards zero by default.
 *
 * One "full week" is the distance between a local time in one day to the same
 * local time 7 days earlier or later. A full week can sometimes be less than
 * or more than 7*24 hours if a daylight savings change happens between two dates.
 *
 * To ignore DST and only measure exact 7*24-hour periods, use this instead:
 * `Math.trunc(differenceInHours(dateLeft, dateRight)/(7*24))|0`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options
 *
 * @returns The number of full weeks
 *
 * @example
 * // How many full weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInWeeks(new Date(2014, 6, 20), new Date(2014, 6, 5))
 * //=> 2
 *
 * @example
 * // How many full weeks are between
 * // 1 March 2020 0:00 and 6 June 2020 0:00 ?
 * // Note: because local time is used, the
 * // result will always be 8 weeks (54 days),
 * // even if DST starts and the period has
 * // only 54*24-1 hours.
 * const result = differenceInWeeks(
 *   new Date(2020, 5, 1),
 *   new Date(2020, 2, 6)
 * )
 * //=> 8
 */ function $c0215197b623a881$var$differenceInWeeks(dateLeft, dateRight, options) {
    const diff = (0, $7t70d.differenceInDays)(dateLeft, dateRight) / 7;
    return (0, $bumqY.getRoundingMethod)(options?.roundingMethod)(diff);
}

});

parcelRegister("5np6K", function(module, exports) {

$parcel$export(module.exports, "differenceInYears", function () { return $3ea2939c0b10ffa4$export$ed6bf486f68899ca; }, function (v) { return $3ea2939c0b10ffa4$export$ed6bf486f68899ca = v; });
var $3ea2939c0b10ffa4$export$ed6bf486f68899ca;
"use strict";
$3ea2939c0b10ffa4$export$ed6bf486f68899ca = $3ea2939c0b10ffa4$var$differenceInYears;

var $6klPK = parcelRequire("6klPK");

var $bnwnB = parcelRequire("bnwnB");

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name differenceInYears
 * @category Year Helpers
 * @summary Get the number of full years between the given dates.
 *
 * @description
 * Get the number of full years between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of full years
 *
 * @example
 * // How many full years are between 31 December 2013 and 11 February 2015?
 * const result = differenceInYears(new Date(2015, 1, 11), new Date(2013, 11, 31))
 * //=> 1
 */ function $3ea2939c0b10ffa4$var$differenceInYears(dateLeft, dateRight) {
    const _dateLeft = (0, $b3MCU.toDate)(dateLeft);
    const _dateRight = (0, $b3MCU.toDate)(dateRight);
    const sign = (0, $6klPK.compareAsc)(_dateLeft, _dateRight);
    const difference = Math.abs((0, $bnwnB.differenceInCalendarYears)(_dateLeft, _dateRight));
    // Set both dates to a valid leap year for accurate comparison when dealing
    // with leap days
    _dateLeft.setFullYear(1584);
    _dateRight.setFullYear(1584);
    // Math.abs(diff in full years - diff in calendar years) === 1 if last calendar year is not full
    // If so, result must be decreased by 1 in absolute value
    const isLastYearNotFull = (0, $6klPK.compareAsc)(_dateLeft, _dateRight) === -sign;
    const result = sign * (difference - +isLastYearNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});

parcelRegister("dorkS", function(module, exports) {

$parcel$export(module.exports, "eachDayOfInterval", function () { return $9c02b89376e79c96$export$7a337e5923c7ceb5; }, function (v) { return $9c02b89376e79c96$export$7a337e5923c7ceb5 = v; });
var $9c02b89376e79c96$export$7a337e5923c7ceb5;
"use strict";
$9c02b89376e79c96$export$7a337e5923c7ceb5 = $9c02b89376e79c96$var$eachDayOfInterval;

var $b3MCU = parcelRequire("b3MCU");
/**
 * The {@link eachDayOfInterval} function options.
 */ /**
 * @name eachDayOfInterval
 * @category Interval Helpers
 * @summary Return the array of dates within the specified time interval.
 *
 * @description
 * Return the array of dates within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 * @param options - An object with options.
 *
 * @returns The array with starts of days from the day of the interval start to the day of the interval end
 *
 * @example
 * // Each day between 6 October 2014 and 10 October 2014:
 * const result = eachDayOfInterval({
 *   start: new Date(2014, 9, 6),
 *   end: new Date(2014, 9, 10)
 * })
 * //=> [
 * //   Mon Oct 06 2014 00:00:00,
 * //   Tue Oct 07 2014 00:00:00,
 * //   Wed Oct 08 2014 00:00:00,
 * //   Thu Oct 09 2014 00:00:00,
 * //   Fri Oct 10 2014 00:00:00
 * // ]
 */ function $9c02b89376e79c96$var$eachDayOfInterval(interval, options) {
    const startDate = (0, $b3MCU.toDate)(interval.start);
    const endDate = (0, $b3MCU.toDate)(interval.end);
    let reversed = +startDate > +endDate;
    const endTime = reversed ? +startDate : +endDate;
    const currentDate = reversed ? endDate : startDate;
    currentDate.setHours(0, 0, 0, 0);
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        dates.push((0, $b3MCU.toDate)(currentDate));
        currentDate.setDate(currentDate.getDate() + step);
        currentDate.setHours(0, 0, 0, 0);
    }
    return reversed ? dates.reverse() : dates;
}

});

parcelRegister("fZxIC", function(module, exports) {

$parcel$export(module.exports, "eachHourOfInterval", function () { return $ba46b55791028a61$export$bb4f48fee90ea86e; }, function (v) { return $ba46b55791028a61$export$bb4f48fee90ea86e = v; });
var $ba46b55791028a61$export$bb4f48fee90ea86e;
"use strict";
$ba46b55791028a61$export$bb4f48fee90ea86e = $ba46b55791028a61$var$eachHourOfInterval;

var $ghcs4 = parcelRequire("ghcs4");

var $b3MCU = parcelRequire("b3MCU");
/**
 * The {@link eachHourOfInterval} function options.
 */ /**
 * @name eachHourOfInterval
 * @category Interval Helpers
 * @summary Return the array of hours within the specified time interval.
 *
 * @description
 * Return the array of hours within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 * @param options - An object with options.
 *
 * @returns The array with starts of hours from the hour of the interval start to the hour of the interval end
 *
 * @example
 * // Each hour between 6 October 2014, 12:00 and 6 October 2014, 15:00
 * const result = eachHourOfInterval({
 *   start: new Date(2014, 9, 6, 12),
 *   end: new Date(2014, 9, 6, 15)
 * })
 * //=> [
 * //   Mon Oct 06 2014 12:00:00,
 * //   Mon Oct 06 2014 13:00:00,
 * //   Mon Oct 06 2014 14:00:00,
 * //   Mon Oct 06 2014 15:00:00
 * // ]
 */ function $ba46b55791028a61$var$eachHourOfInterval(interval, options) {
    const startDate = (0, $b3MCU.toDate)(interval.start);
    const endDate = (0, $b3MCU.toDate)(interval.end);
    let reversed = +startDate > +endDate;
    const endTime = reversed ? +startDate : +endDate;
    let currentDate = reversed ? endDate : startDate;
    currentDate.setMinutes(0, 0, 0);
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        dates.push((0, $b3MCU.toDate)(currentDate));
        currentDate = (0, $ghcs4.addHours)(currentDate, step);
    }
    return reversed ? dates.reverse() : dates;
}

});

parcelRegister("aB3EM", function(module, exports) {

$parcel$export(module.exports, "eachMinuteOfInterval", function () { return $7b7032398df53d48$export$82e17d693ce9eb6c; }, function (v) { return $7b7032398df53d48$export$82e17d693ce9eb6c = v; });
var $7b7032398df53d48$export$82e17d693ce9eb6c;
"use strict";
$7b7032398df53d48$export$82e17d693ce9eb6c = $7b7032398df53d48$var$eachMinuteOfInterval;

var $84Jkb = parcelRequire("84Jkb");

var $h18wW = parcelRequire("h18wW");

var $b3MCU = parcelRequire("b3MCU");
/**
 * The {@link eachMinuteOfInterval} function options.
 */ /**
 * @name eachMinuteOfInterval
 * @category Interval Helpers
 * @summary Return the array of minutes within the specified time interval.
 *
 * @description
 * Returns the array of minutes within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 * @param options - An object with options.
 *
 * @returns The array with starts of minutes from the minute of the interval start to the minute of the interval end
 *
 * @example
 * // Each minute between 14 October 2020, 13:00 and 14 October 2020, 13:03
 * const result = eachMinuteOfInterval({
 *   start: new Date(2014, 9, 14, 13),
 *   end: new Date(2014, 9, 14, 13, 3)
 * })
 * //=> [
 * //   Wed Oct 14 2014 13:00:00,
 * //   Wed Oct 14 2014 13:01:00,
 * //   Wed Oct 14 2014 13:02:00,
 * //   Wed Oct 14 2014 13:03:00
 * // ]
 */ function $7b7032398df53d48$var$eachMinuteOfInterval(interval, options) {
    const startDate = (0, $h18wW.startOfMinute)((0, $b3MCU.toDate)(interval.start));
    const endDate = (0, $b3MCU.toDate)(interval.end);
    let reversed = +startDate > +endDate;
    const endTime = reversed ? +startDate : +endDate;
    let currentDate = reversed ? endDate : startDate;
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        dates.push((0, $b3MCU.toDate)(currentDate));
        currentDate = (0, $84Jkb.addMinutes)(currentDate, step);
    }
    return reversed ? dates.reverse() : dates;
}

});
parcelRegister("h18wW", function(module, exports) {

$parcel$export(module.exports, "startOfMinute", function () { return $c6392597ec42f8ab$export$c66440458c6aa793; }, function (v) { return $c6392597ec42f8ab$export$c66440458c6aa793 = v; });
var $c6392597ec42f8ab$export$c66440458c6aa793;
"use strict";
$c6392597ec42f8ab$export$c66440458c6aa793 = $c6392597ec42f8ab$var$startOfMinute;

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name startOfMinute
 * @category Minute Helpers
 * @summary Return the start of a minute for the given date.
 *
 * @description
 * Return the start of a minute for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a minute
 *
 * @example
 * // The start of a minute for 1 December 2014 22:15:45.400:
 * const result = startOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:00
 */ function $c6392597ec42f8ab$var$startOfMinute(date) {
    const _date = (0, $b3MCU.toDate)(date);
    _date.setSeconds(0, 0);
    return _date;
}

});


parcelRegister("eZBWn", function(module, exports) {

$parcel$export(module.exports, "eachMonthOfInterval", function () { return $aea4316241f233f5$export$1c9322f2d2a5eed3; }, function (v) { return $aea4316241f233f5$export$1c9322f2d2a5eed3 = v; });
var $aea4316241f233f5$export$1c9322f2d2a5eed3;
"use strict";
$aea4316241f233f5$export$1c9322f2d2a5eed3 = $aea4316241f233f5$var$eachMonthOfInterval;

var $b3MCU = parcelRequire("b3MCU");
/**
 * The {@link eachMonthOfInterval} function options.
 */ /**
 * @name eachMonthOfInterval
 * @category Interval Helpers
 * @summary Return the array of months within the specified time interval.
 *
 * @description
 * Return the array of months within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval
 *
 * @returns The array with starts of months from the month of the interval start to the month of the interval end
 *
 * @example
 * // Each month between 6 February 2014 and 10 August 2014:
 * const result = eachMonthOfInterval({
 *   start: new Date(2014, 1, 6),
 *   end: new Date(2014, 7, 10)
 * })
 * //=> [
 * //   Sat Feb 01 2014 00:00:00,
 * //   Sat Mar 01 2014 00:00:00,
 * //   Tue Apr 01 2014 00:00:00,
 * //   Thu May 01 2014 00:00:00,
 * //   Sun Jun 01 2014 00:00:00,
 * //   Tue Jul 01 2014 00:00:00,
 * //   Fri Aug 01 2014 00:00:00
 * // ]
 */ function $aea4316241f233f5$var$eachMonthOfInterval(interval, options) {
    const startDate = (0, $b3MCU.toDate)(interval.start);
    const endDate = (0, $b3MCU.toDate)(interval.end);
    let reversed = +startDate > +endDate;
    const endTime = reversed ? +startDate : +endDate;
    const currentDate = reversed ? endDate : startDate;
    currentDate.setHours(0, 0, 0, 0);
    currentDate.setDate(1);
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        dates.push((0, $b3MCU.toDate)(currentDate));
        currentDate.setMonth(currentDate.getMonth() + step);
    }
    return reversed ? dates.reverse() : dates;
}

});

parcelRegister("2ZLo2", function(module, exports) {

$parcel$export(module.exports, "eachQuarterOfInterval", function () { return $22e6094b702fa145$export$96790a0abfab0078; }, function (v) { return $22e6094b702fa145$export$96790a0abfab0078 = v; });
var $22e6094b702fa145$export$96790a0abfab0078;
"use strict";
$22e6094b702fa145$export$96790a0abfab0078 = $22e6094b702fa145$var$eachQuarterOfInterval;

var $7IMv5 = parcelRequire("7IMv5");

var $7KsKS = parcelRequire("7KsKS");

var $b3MCU = parcelRequire("b3MCU");
/**
 * The {@link eachQuarterOfInterval} function options.
 */ /**
 * @name eachQuarterOfInterval
 * @category Interval Helpers
 * @summary Return the array of quarters within the specified time interval.
 *
 * @description
 * Return the array of quarters within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval
 *
 * @returns The array with starts of quarters from the quarter of the interval start to the quarter of the interval end
 *
 * @example
 * // Each quarter within interval 6 February 2014 - 10 August 2014:
 * const result = eachQuarterOfInterval({
 *   start: new Date(2014, 1, 6),
 *   end: new Date(2014, 7, 10)
 * })
 * //=> [
 * //   Wed Jan 01 2014 00:00:00,
 * //   Tue Apr 01 2014 00:00:00,
 * //   Tue Jul 01 2014 00:00:00,
 * // ]
 */ function $22e6094b702fa145$var$eachQuarterOfInterval(interval, options) {
    const startDate = (0, $b3MCU.toDate)(interval.start);
    const endDate = (0, $b3MCU.toDate)(interval.end);
    let reversed = +startDate > +endDate;
    const endTime = reversed ? +(0, $7KsKS.startOfQuarter)(startDate) : +(0, $7KsKS.startOfQuarter)(endDate);
    let currentDate = reversed ? (0, $7KsKS.startOfQuarter)(endDate) : (0, $7KsKS.startOfQuarter)(startDate);
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        dates.push((0, $b3MCU.toDate)(currentDate));
        currentDate = (0, $7IMv5.addQuarters)(currentDate, step);
    }
    return reversed ? dates.reverse() : dates;
}

});
parcelRegister("7KsKS", function(module, exports) {

$parcel$export(module.exports, "startOfQuarter", function () { return $5a43226a8d1d4221$export$69be7267a042ecb3; }, function (v) { return $5a43226a8d1d4221$export$69be7267a042ecb3 = v; });
var $5a43226a8d1d4221$export$69be7267a042ecb3;
"use strict";
$5a43226a8d1d4221$export$69be7267a042ecb3 = $5a43226a8d1d4221$var$startOfQuarter;

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name startOfQuarter
 * @category Quarter Helpers
 * @summary Return the start of a year quarter for the given date.
 *
 * @description
 * Return the start of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a quarter
 *
 * @example
 * // The start of a quarter for 2 September 2014 11:55:00:
 * const result = startOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Jul 01 2014 00:00:00
 */ function $5a43226a8d1d4221$var$startOfQuarter(date) {
    const _date = (0, $b3MCU.toDate)(date);
    const currentMonth = _date.getMonth();
    const month = currentMonth - currentMonth % 3;
    _date.setMonth(month, 1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

});


parcelRegister("bHENy", function(module, exports) {

$parcel$export(module.exports, "eachWeekOfInterval", function () { return $88535b910475641d$export$d31a8caec75fa456; }, function (v) { return $88535b910475641d$export$d31a8caec75fa456 = v; });
var $88535b910475641d$export$d31a8caec75fa456;
"use strict";
$88535b910475641d$export$d31a8caec75fa456 = $88535b910475641d$var$eachWeekOfInterval;

var $iiBmk = parcelRequire("iiBmk");

var $isuGI = parcelRequire("isuGI");

var $b3MCU = parcelRequire("b3MCU");
/**
 * The {@link eachWeekOfInterval} function options.
 */ /**
 * @name eachWeekOfInterval
 * @category Interval Helpers
 * @summary Return the array of weeks within the specified time interval.
 *
 * @description
 * Return the array of weeks within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 * @param options - An object with options.
 *
 * @returns The array with starts of weeks from the week of the interval start to the week of the interval end
 *
 * @example
 * // Each week within interval 6 October 2014 - 23 November 2014:
 * const result = eachWeekOfInterval({
 *   start: new Date(2014, 9, 6),
 *   end: new Date(2014, 10, 23)
 * })
 * //=> [
 * //   Sun Oct 05 2014 00:00:00,
 * //   Sun Oct 12 2014 00:00:00,
 * //   Sun Oct 19 2014 00:00:00,
 * //   Sun Oct 26 2014 00:00:00,
 * //   Sun Nov 02 2014 00:00:00,
 * //   Sun Nov 09 2014 00:00:00,
 * //   Sun Nov 16 2014 00:00:00,
 * //   Sun Nov 23 2014 00:00:00
 * // ]
 */ function $88535b910475641d$var$eachWeekOfInterval(interval, options) {
    const startDate = (0, $b3MCU.toDate)(interval.start);
    const endDate = (0, $b3MCU.toDate)(interval.end);
    let reversed = +startDate > +endDate;
    const startDateWeek = reversed ? (0, $isuGI.startOfWeek)(endDate, options) : (0, $isuGI.startOfWeek)(startDate, options);
    const endDateWeek = reversed ? (0, $isuGI.startOfWeek)(startDate, options) : (0, $isuGI.startOfWeek)(endDate, options);
    // Some timezones switch DST at midnight, making start of day unreliable in these timezones, 3pm is a safe bet
    startDateWeek.setHours(15);
    endDateWeek.setHours(15);
    const endTime = +endDateWeek.getTime();
    let currentDate = startDateWeek;
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        currentDate.setHours(0);
        dates.push((0, $b3MCU.toDate)(currentDate));
        currentDate = (0, $iiBmk.addWeeks)(currentDate, step);
        currentDate.setHours(15);
    }
    return reversed ? dates.reverse() : dates;
}

});

parcelRegister("j4hO1", function(module, exports) {

$parcel$export(module.exports, "eachWeekendOfInterval", function () { return $de1c33e8d71512f1$export$a2ae85dd849354a8; }, function (v) { return $de1c33e8d71512f1$export$a2ae85dd849354a8 = v; });
var $de1c33e8d71512f1$export$a2ae85dd849354a8;
"use strict";
$de1c33e8d71512f1$export$a2ae85dd849354a8 = $de1c33e8d71512f1$var$eachWeekendOfInterval;

var $dorkS = parcelRequire("dorkS");

var $jsxIt = parcelRequire("jsxIt");
/**
 * @name eachWeekendOfInterval
 * @category Interval Helpers
 * @summary List all the Saturdays and Sundays in the given date interval.
 *
 * @description
 * Get all the Saturdays and Sundays in the given date interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The given interval
 *
 * @returns An array containing all the Saturdays and Sundays
 *
 * @example
 * // Lists all Saturdays and Sundays in the given date interval
 * const result = eachWeekendOfInterval({
 *   start: new Date(2018, 8, 17),
 *   end: new Date(2018, 8, 30)
 * })
 * //=> [
 * //   Sat Sep 22 2018 00:00:00,
 * //   Sun Sep 23 2018 00:00:00,
 * //   Sat Sep 29 2018 00:00:00,
 * //   Sun Sep 30 2018 00:00:00
 * // ]
 */ function $de1c33e8d71512f1$var$eachWeekendOfInterval(interval) {
    const dateInterval = (0, $dorkS.eachDayOfInterval)(interval);
    const weekends = [];
    let index = 0;
    while(index < dateInterval.length){
        const date = dateInterval[index++];
        if ((0, $jsxIt.isWeekend)(date)) weekends.push(date);
    }
    return weekends;
}

});

parcelRegister("K9CGJ", function(module, exports) {

$parcel$export(module.exports, "eachWeekendOfMonth", function () { return $08abc2eba2f15f0b$export$f9a185d0ad232d17; }, function (v) { return $08abc2eba2f15f0b$export$f9a185d0ad232d17 = v; });
var $08abc2eba2f15f0b$export$f9a185d0ad232d17;
"use strict";
$08abc2eba2f15f0b$export$f9a185d0ad232d17 = $08abc2eba2f15f0b$var$eachWeekendOfMonth;

var $j4hO1 = parcelRequire("j4hO1");

var $5pWy6 = parcelRequire("5pWy6");

var $Gd0bX = parcelRequire("Gd0bX");
/**
 * @name eachWeekendOfMonth
 * @category Month Helpers
 * @summary List all the Saturdays and Sundays in the given month.
 *
 * @description
 * Get all the Saturdays and Sundays in the given month.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given month
 *
 * @returns An array containing all the Saturdays and Sundays
 *
 * @example
 * // Lists all Saturdays and Sundays in the given month
 * const result = eachWeekendOfMonth(new Date(2022, 1, 1))
 * //=> [
 * //   Sat Feb 05 2022 00:00:00,
 * //   Sun Feb 06 2022 00:00:00,
 * //   Sat Feb 12 2022 00:00:00,
 * //   Sun Feb 13 2022 00:00:00,
 * //   Sat Feb 19 2022 00:00:00,
 * //   Sun Feb 20 2022 00:00:00,
 * //   Sat Feb 26 2022 00:00:00,
 * //   Sun Feb 27 2022 00:00:00
 * // ]
 */ function $08abc2eba2f15f0b$var$eachWeekendOfMonth(date) {
    const start = (0, $Gd0bX.startOfMonth)(date);
    const end = (0, $5pWy6.endOfMonth)(date);
    return (0, $j4hO1.eachWeekendOfInterval)({
        start: start,
        end: end
    });
}

});
parcelRegister("Gd0bX", function(module, exports) {

$parcel$export(module.exports, "startOfMonth", function () { return $07ee024dc20c24b1$export$a5a3b454ada2268e; }, function (v) { return $07ee024dc20c24b1$export$a5a3b454ada2268e = v; });
var $07ee024dc20c24b1$export$a5a3b454ada2268e;
"use strict";
$07ee024dc20c24b1$export$a5a3b454ada2268e = $07ee024dc20c24b1$var$startOfMonth;

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name startOfMonth
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a month
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * const result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */ function $07ee024dc20c24b1$var$startOfMonth(date) {
    const _date = (0, $b3MCU.toDate)(date);
    _date.setDate(1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

});


parcelRegister("kWnFf", function(module, exports) {

$parcel$export(module.exports, "eachWeekendOfYear", function () { return $f3eb94a58675504f$export$d4a9e5efc1ddceb9; }, function (v) { return $f3eb94a58675504f$export$d4a9e5efc1ddceb9 = v; });
var $f3eb94a58675504f$export$d4a9e5efc1ddceb9;
"use strict";
$f3eb94a58675504f$export$d4a9e5efc1ddceb9 = $f3eb94a58675504f$var$eachWeekendOfYear;

var $j4hO1 = parcelRequire("j4hO1");

var $k041Q = parcelRequire("k041Q");

var $bnoYK = parcelRequire("bnoYK");
/**
 * @name eachWeekendOfYear
 * @category Year Helpers
 * @summary List all the Saturdays and Sundays in the year.
 *
 * @description
 * Get all the Saturdays and Sundays in the year.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given year
 *
 * @returns An array containing all the Saturdays and Sundays
 *
 * @example
 * // Lists all Saturdays and Sundays in the year
 * const result = eachWeekendOfYear(new Date(2020, 1, 1))
 * //=> [
 * //   Sat Jan 03 2020 00:00:00,
 * //   Sun Jan 04 2020 00:00:00,
 * //   ...
 * //   Sun Dec 27 2020 00:00:00
 * // ]
 * ]
 */ function $f3eb94a58675504f$var$eachWeekendOfYear(date) {
    const start = (0, $bnoYK.startOfYear)(date);
    const end = (0, $k041Q.endOfYear)(date);
    return (0, $j4hO1.eachWeekendOfInterval)({
        start: start,
        end: end
    });
}

});
parcelRegister("k041Q", function(module, exports) {

$parcel$export(module.exports, "endOfYear", function () { return $e8f6eec0912ee95b$export$8b7aa55c66d5569e; }, function (v) { return $e8f6eec0912ee95b$export$8b7aa55c66d5569e = v; });
var $e8f6eec0912ee95b$export$8b7aa55c66d5569e;
"use strict";
$e8f6eec0912ee95b$export$8b7aa55c66d5569e = $e8f6eec0912ee95b$var$endOfYear;

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name endOfYear
 * @category Year Helpers
 * @summary Return the end of a year for the given date.
 *
 * @description
 * Return the end of a year for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a year
 *
 * @example
 * // The end of a year for 2 September 2014 11:55:00:
 * const result = endOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 23:59:59.999
 */ function $e8f6eec0912ee95b$var$endOfYear(date) {
    const _date = (0, $b3MCU.toDate)(date);
    const year = _date.getFullYear();
    _date.setFullYear(year + 1, 0, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}

});

parcelRegister("bnoYK", function(module, exports) {

$parcel$export(module.exports, "startOfYear", function () { return $848537fc9b7ac339$export$f91e89d3d0406102; }, function (v) { return $848537fc9b7ac339$export$f91e89d3d0406102 = v; });
var $848537fc9b7ac339$export$f91e89d3d0406102;
"use strict";
$848537fc9b7ac339$export$f91e89d3d0406102 = $848537fc9b7ac339$var$startOfYear;

var $b3MCU = parcelRequire("b3MCU");

var $02yAu = parcelRequire("02yAu");
/**
 * @name startOfYear
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a year
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * const result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */ function $848537fc9b7ac339$var$startOfYear(date) {
    const cleanDate = (0, $b3MCU.toDate)(date);
    const _date = (0, $02yAu.constructFrom)(date, 0);
    _date.setFullYear(cleanDate.getFullYear(), 0, 1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

});


parcelRegister("5Xvkn", function(module, exports) {

$parcel$export(module.exports, "eachYearOfInterval", function () { return $456ac376de4ffc57$export$9b7f165f0a71d2a5; }, function (v) { return $456ac376de4ffc57$export$9b7f165f0a71d2a5 = v; });
var $456ac376de4ffc57$export$9b7f165f0a71d2a5;
"use strict";
$456ac376de4ffc57$export$9b7f165f0a71d2a5 = $456ac376de4ffc57$var$eachYearOfInterval;

var $b3MCU = parcelRequire("b3MCU");
/**
 * The {@link eachYearOfInterval} function options.
 */ /**
 * @name eachYearOfInterval
 * @category Interval Helpers
 * @summary Return the array of yearly timestamps within the specified time interval.
 *
 * @description
 * Return the array of yearly timestamps within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 *
 * @returns The array with starts of yearly timestamps from the month of the interval start to the month of the interval end
 *
 * @example
 * // Each year between 6 February 2014 and 10 August 2017:
 * const result = eachYearOfInterval({
 *   start: new Date(2014, 1, 6),
 *   end: new Date(2017, 7, 10)
 * })
 * //=> [
 * //   Wed Jan 01 2014 00:00:00,
 * //   Thu Jan 01 2015 00:00:00,
 * //   Fri Jan 01 2016 00:00:00,
 * //   Sun Jan 01 2017 00:00:00
 * // ]
 */ function $456ac376de4ffc57$var$eachYearOfInterval(interval, options) {
    const startDate = (0, $b3MCU.toDate)(interval.start);
    const endDate = (0, $b3MCU.toDate)(interval.end);
    let reversed = +startDate > +endDate;
    const endTime = reversed ? +startDate : +endDate;
    const currentDate = reversed ? endDate : startDate;
    currentDate.setHours(0, 0, 0, 0);
    currentDate.setMonth(0, 1);
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        dates.push((0, $b3MCU.toDate)(currentDate));
        currentDate.setFullYear(currentDate.getFullYear() + step);
    }
    return reversed ? dates.reverse() : dates;
}

});

parcelRegister("4oAaJ", function(module, exports) {

$parcel$export(module.exports, "endOfDecade", function () { return $33357652f6b68394$export$b922ac31d5bbe7a6; }, function (v) { return $33357652f6b68394$export$b922ac31d5bbe7a6 = v; });
var $33357652f6b68394$export$b922ac31d5bbe7a6;
"use strict";
$33357652f6b68394$export$b922ac31d5bbe7a6 = $33357652f6b68394$var$endOfDecade;

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name endOfDecade
 * @category Decade Helpers
 * @summary Return the end of a decade for the given date.
 *
 * @description
 * Return the end of a decade for the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a decade
 *
 * @example
 * // The end of a decade for 12 May 1984 00:00:00:
 * const result = endOfDecade(new Date(1984, 4, 12, 00, 00, 00))
 * //=> Dec 31 1989 23:59:59.999
 */ function $33357652f6b68394$var$endOfDecade(date) {
    // TODO: Switch to more technical definition in of decades that start with 1
    // end with 0. I.e. 2001-2010 instead of current 2000-2009. It's a breaking
    // change, so it can only be done in 4.0.
    const _date = (0, $b3MCU.toDate)(date);
    const year = _date.getFullYear();
    const decade = 9 + Math.floor(year / 10) * 10;
    _date.setFullYear(decade, 11, 31);
    _date.setHours(23, 59, 59, 999);
    return _date;
}

});

parcelRegister("4cpr6", function(module, exports) {

$parcel$export(module.exports, "endOfHour", function () { return $30ec037c522b5c02$export$95ae95d2176c5f0; }, function (v) { return $30ec037c522b5c02$export$95ae95d2176c5f0 = v; });
var $30ec037c522b5c02$export$95ae95d2176c5f0;
"use strict";
$30ec037c522b5c02$export$95ae95d2176c5f0 = $30ec037c522b5c02$var$endOfHour;

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name endOfHour
 * @category Hour Helpers
 * @summary Return the end of an hour for the given date.
 *
 * @description
 * Return the end of an hour for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of an hour
 *
 * @example
 * // The end of an hour for 2 September 2014 11:55:00:
 * const result = endOfHour(new Date(2014, 8, 2, 11, 55))
 * //=> Tue Sep 02 2014 11:59:59.999
 */ function $30ec037c522b5c02$var$endOfHour(date) {
    const _date = (0, $b3MCU.toDate)(date);
    _date.setMinutes(59, 59, 999);
    return _date;
}

});

parcelRegister("aSGj5", function(module, exports) {

$parcel$export(module.exports, "endOfISOWeek", function () { return $7ebfc3c96f445cd8$export$186cd934f32084be; }, function (v) { return $7ebfc3c96f445cd8$export$186cd934f32084be = v; });
var $7ebfc3c96f445cd8$export$186cd934f32084be;
"use strict";
$7ebfc3c96f445cd8$export$186cd934f32084be = $7ebfc3c96f445cd8$var$endOfISOWeek;

var $frXCW = parcelRequire("frXCW");
/**
 * @name endOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the end of an ISO week for the given date.
 *
 * @description
 * Return the end of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of an ISO week
 *
 * @example
 * // The end of an ISO week for 2 September 2014 11:55:00:
 * const result = endOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Sep 07 2014 23:59:59.999
 */ function $7ebfc3c96f445cd8$var$endOfISOWeek(date) {
    return (0, $frXCW.endOfWeek)(date, {
        weekStartsOn: 1
    });
}

});
parcelRegister("frXCW", function(module, exports) {

$parcel$export(module.exports, "endOfWeek", function () { return $b3f7a1549df22cae$export$ef8b6d9133084f4e; }, function (v) { return $b3f7a1549df22cae$export$ef8b6d9133084f4e = v; });
var $b3f7a1549df22cae$export$ef8b6d9133084f4e;
"use strict";
$b3f7a1549df22cae$export$ef8b6d9133084f4e = $b3f7a1549df22cae$var$endOfWeek;

var $b3MCU = parcelRequire("b3MCU");

var $lJvf9 = parcelRequire("lJvf9");
/**
 * The {@link endOfWeek} function options.
 */ /**
 * @name endOfWeek
 * @category Week Helpers
 * @summary Return the end of a week for the given date.
 *
 * @description
 * Return the end of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The end of a week
 *
 * @example
 * // The end of a week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 23:59:59.999
 *
 * @example
 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 23:59:59.999
 */ function $b3f7a1549df22cae$var$endOfWeek(date, options) {
    const defaultOptions = (0, $lJvf9.getDefaultOptions)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $b3MCU.toDate)(date);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    _date.setDate(_date.getDate() + diff);
    _date.setHours(23, 59, 59, 999);
    return _date;
}

});


parcelRegister("luaY7", function(module, exports) {

$parcel$export(module.exports, "endOfISOWeekYear", function () { return $fa44e8705decdbbc$export$73068f3824c9c1d; }, function (v) { return $fa44e8705decdbbc$export$73068f3824c9c1d = v; });
var $fa44e8705decdbbc$export$73068f3824c9c1d;
"use strict";
$fa44e8705decdbbc$export$73068f3824c9c1d = $fa44e8705decdbbc$var$endOfISOWeekYear;

var $43yjM = parcelRequire("43yjM");

var $4x8aw = parcelRequire("4x8aw");

var $02yAu = parcelRequire("02yAu");
/**
 * @name endOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the end of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the end of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of an ISO week-numbering year
 *
 * @example
 * // The end of an ISO week-numbering year for 2 July 2005:
 * const result = endOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Sun Jan 01 2006 23:59:59.999
 */ function $fa44e8705decdbbc$var$endOfISOWeekYear(date) {
    const year = (0, $43yjM.getISOWeekYear)(date);
    const fourthOfJanuaryOfNextYear = (0, $02yAu.constructFrom)(date, 0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    const _date = (0, $4x8aw.startOfISOWeek)(fourthOfJanuaryOfNextYear);
    _date.setMilliseconds(_date.getMilliseconds() - 1);
    return _date;
}

});

parcelRegister("gG2Rj", function(module, exports) {

$parcel$export(module.exports, "endOfMinute", function () { return $c242c95044ac9d99$export$a06a772fc63bff07; }, function (v) { return $c242c95044ac9d99$export$a06a772fc63bff07 = v; });
var $c242c95044ac9d99$export$a06a772fc63bff07;
"use strict";
$c242c95044ac9d99$export$a06a772fc63bff07 = $c242c95044ac9d99$var$endOfMinute;

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name endOfMinute
 * @category Minute Helpers
 * @summary Return the end of a minute for the given date.
 *
 * @description
 * Return the end of a minute for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a minute
 *
 * @example
 * // The end of a minute for 1 December 2014 22:15:45.400:
 * const result = endOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:59.999
 */ function $c242c95044ac9d99$var$endOfMinute(date) {
    const _date = (0, $b3MCU.toDate)(date);
    _date.setSeconds(59, 999);
    return _date;
}

});

parcelRegister("7Kxax", function(module, exports) {

$parcel$export(module.exports, "endOfQuarter", function () { return $5a468ef7d65b08c4$export$5f53493861eef879; }, function (v) { return $5a468ef7d65b08c4$export$5f53493861eef879 = v; });
var $5a468ef7d65b08c4$export$5f53493861eef879;
"use strict";
$5a468ef7d65b08c4$export$5f53493861eef879 = $5a468ef7d65b08c4$var$endOfQuarter;

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name endOfQuarter
 * @category Quarter Helpers
 * @summary Return the end of a year quarter for the given date.
 *
 * @description
 * Return the end of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a quarter
 *
 * @example
 * // The end of a quarter for 2 September 2014 11:55:00:
 * const result = endOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */ function $5a468ef7d65b08c4$var$endOfQuarter(date) {
    const _date = (0, $b3MCU.toDate)(date);
    const currentMonth = _date.getMonth();
    const month = currentMonth - currentMonth % 3 + 3;
    _date.setMonth(month, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}

});

parcelRegister("kTeTI", function(module, exports) {

$parcel$export(module.exports, "endOfSecond", function () { return $f35480098b8484c8$export$ef560ab2fa7b52a2; }, function (v) { return $f35480098b8484c8$export$ef560ab2fa7b52a2 = v; });
var $f35480098b8484c8$export$ef560ab2fa7b52a2;
"use strict";
$f35480098b8484c8$export$ef560ab2fa7b52a2 = $f35480098b8484c8$var$endOfSecond;

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name endOfSecond
 * @category Second Helpers
 * @summary Return the end of a second for the given date.
 *
 * @description
 * Return the end of a second for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a second
 *
 * @example
 * // The end of a second for 1 December 2014 22:15:45.400:
 * const result = endOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:45.999
 */ function $f35480098b8484c8$var$endOfSecond(date) {
    const _date = (0, $b3MCU.toDate)(date);
    _date.setMilliseconds(999);
    return _date;
}

});

parcelRegister("bBRPg", function(module, exports) {

$parcel$export(module.exports, "endOfToday", function () { return $873ce71a35e97677$export$1b7031a80bd92a6e; }, function (v) { return $873ce71a35e97677$export$1b7031a80bd92a6e = v; });
var $873ce71a35e97677$export$1b7031a80bd92a6e;
"use strict";
$873ce71a35e97677$export$1b7031a80bd92a6e = $873ce71a35e97677$var$endOfToday;

var $ikjzL = parcelRequire("ikjzL");
/**
 * @name endOfToday
 * @category Day Helpers
 * @summary Return the end of today.
 * @pure false
 *
 * @description
 * Return the end of today.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @returns The end of today
 *
 * @example
 * // If today is 6 October 2014:
 * const result = endOfToday()
 * //=> Mon Oct 6 2014 23:59:59.999
 */ function $873ce71a35e97677$var$endOfToday() {
    return (0, $ikjzL.endOfDay)(Date.now());
}

});

parcelRegister("ldkTO", function(module, exports) {

$parcel$export(module.exports, "endOfTomorrow", function () { return $f71b060307816d70$export$d788ac27ae2a54ea; }, function (v) { return $f71b060307816d70$export$d788ac27ae2a54ea = v; });
var $f71b060307816d70$export$d788ac27ae2a54ea;
"use strict";
$f71b060307816d70$export$d788ac27ae2a54ea = $f71b060307816d70$var$endOfTomorrow; /**
 * @name endOfTomorrow
 * @category Day Helpers
 * @summary Return the end of tomorrow.
 * @pure false
 *
 * @description
 * Return the end of tomorrow.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @returns The end of tomorrow
 *
 * @example
 * // If today is 6 October 2014:
 * const result = endOfTomorrow()
 * //=> Tue Oct 7 2014 23:59:59.999
 */ 
function $f71b060307816d70$var$endOfTomorrow() {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();
    const day = now.getDate();
    const date = new Date(0);
    date.setFullYear(year, month, day + 1);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("kOusr", function(module, exports) {

$parcel$export(module.exports, "endOfYesterday", function () { return $f2701a6de838a0a2$export$45190faf1024f97a; }, function (v) { return $f2701a6de838a0a2$export$45190faf1024f97a = v; });
var $f2701a6de838a0a2$export$45190faf1024f97a;
"use strict";
$f2701a6de838a0a2$export$45190faf1024f97a = $f2701a6de838a0a2$var$endOfYesterday; /**
 * @name endOfYesterday
 * @category Day Helpers
 * @summary Return the end of yesterday.
 * @pure false
 *
 * @description
 * Return the end of yesterday.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @returns The end of yesterday
 *
 * @example
 * // If today is 6 October 2014:
 * const result = endOfYesterday()
 * //=> Sun Oct 5 2014 23:59:59.999
 */ 
function $f2701a6de838a0a2$var$endOfYesterday() {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();
    const day = now.getDate();
    const date = new Date(0);
    date.setFullYear(year, month, day - 1);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("9YOIL", function(module, exports) {
"use strict";
module.exports.format = module.exports.formatDate = $74410fca59286bb5$var$format;
Object.defineProperty(module.exports, "formatters", {
    enumerable: true,
    get: function() {
        return $c9GDQ.formatters;
    }
});
Object.defineProperty(module.exports, "longFormatters", {
    enumerable: true,
    get: function() {
        return $cXalR.longFormatters;
    }
});

var $lpy2g = parcelRequire("lpy2g");

var $lJvf9 = parcelRequire("lJvf9");

var $c9GDQ = parcelRequire("c9GDQ");

var $cXalR = parcelRequire("cXalR");

var $8H04k = parcelRequire("8H04k");

var $cmplH = parcelRequire("cmplH");

var $b3MCU = parcelRequire("b3MCU");
// Rexports of internal for libraries to use.
// See: https://github.com/date-fns/date-fns/issues/3638#issuecomment-1877082874
// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $74410fca59286bb5$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const $74410fca59286bb5$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const $74410fca59286bb5$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $74410fca59286bb5$var$doubleQuoteRegExp = /''/g;
const $74410fca59286bb5$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * The {@link format} function options.
 */ /**
 * @name format
 * @alias formatDate
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear](https://date-fns.org/docs/getISOWeekYear)
 *    and [getWeekYear](https://date-fns.org/docs/getWeekYear)).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param format - The string of tokens
 * @param options - An object with options
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 * @throws `options.locale` must contain `localize` property
 * @throws `options.locale` must contain `formatLong` property
 * @throws use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */ function $74410fca59286bb5$var$format(date, formatStr, options) {
    const defaultOptions = (0, $lJvf9.getDefaultOptions)();
    const locale = options?.locale ?? defaultOptions.locale ?? $lpy2g.defaultLocale;
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const originalDate = (0, $b3MCU.toDate)(date);
    if (!(0, $cmplH.isValid)(originalDate)) throw new RangeError("Invalid time value");
    let parts = formatStr.match($74410fca59286bb5$var$longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            const longFormatter = $cXalR.longFormatters[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($74410fca59286bb5$var$formattingTokensRegExp).map((substring)=>{
        // Replace two single quote characters with one single quote character
        if (substring === "''") return {
            isToken: false,
            value: "'"
        };
        const firstCharacter = substring[0];
        if (firstCharacter === "'") return {
            isToken: false,
            value: $74410fca59286bb5$var$cleanEscapedString(substring)
        };
        if ($c9GDQ.formatters[firstCharacter]) return {
            isToken: true,
            value: substring
        };
        if (firstCharacter.match($74410fca59286bb5$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return {
            isToken: false,
            value: substring
        };
    });
    // invoke localize preprocessor (only for french locales at the moment)
    if (locale.localize.preprocessor) parts = locale.localize.preprocessor(originalDate, parts);
    const formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    return parts.map((part)=>{
        if (!part.isToken) return part.value;
        const token = part.value;
        if (!options?.useAdditionalWeekYearTokens && (0, $8H04k.isProtectedWeekYearToken)(token) || !options?.useAdditionalDayOfYearTokens && (0, $8H04k.isProtectedDayOfYearToken)(token)) (0, $8H04k.warnOrThrowProtectedError)(token, formatStr, String(date));
        const formatter = $c9GDQ.formatters[token[0]];
        return formatter(originalDate, token, locale.localize, formatterOptions);
    }).join("");
}
function $74410fca59286bb5$var$cleanEscapedString(input) {
    const matched = input.match($74410fca59286bb5$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($74410fca59286bb5$var$doubleQuoteRegExp, "'");
}

});
parcelRegister("lpy2g", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "defaultLocale", {
    enumerable: true,
    get: function() {
        return $k0heU.enUS;
    }
});

var $k0heU = parcelRequire("k0heU");

});
parcelRegister("k0heU", function(module, exports) {

$parcel$export(module.exports, "enUS", function () { return $e9012e1e9890b812$export$137380d9ce54f7f; }, function (v) { return $e9012e1e9890b812$export$137380d9ce54f7f = v; });
var $e9012e1e9890b812$export$137380d9ce54f7f;
"use strict";
$e9012e1e9890b812$export$137380d9ce54f7f = void 0;

var $c6WKC = parcelRequire("c6WKC");

var $9V5sk = parcelRequire("9V5sk");

var $hv8WS = parcelRequire("hv8WS");

var $kXuIl = parcelRequire("kXuIl");

var $89jyM = parcelRequire("89jyM");
/**
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp](https://github.com/kossnocorp)
 * @author Lesha Koss [@leshakoss](https://github.com/leshakoss)
 */ const $e9012e1e9890b812$var$enUS = $e9012e1e9890b812$export$137380d9ce54f7f = {
    code: "en-US",
    formatDistance: $c6WKC.formatDistance,
    formatLong: $9V5sk.formatLong,
    formatRelative: $hv8WS.formatRelative,
    localize: $kXuIl.localize,
    match: $89jyM.match,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRegister("c6WKC", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $8d139e464b37be5e$export$2c14ff85d6318973; }, function (v) { return $8d139e464b37be5e$export$2c14ff85d6318973 = v; });
var $8d139e464b37be5e$export$2c14ff85d6318973;
"use strict";
$8d139e464b37be5e$export$2c14ff85d6318973 = void 0;
const $8d139e464b37be5e$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
const $8d139e464b37be5e$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $8d139e464b37be5e$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};
$8d139e464b37be5e$export$2c14ff85d6318973 = $8d139e464b37be5e$var$formatDistance;

});

parcelRegister("9V5sk", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $738dab60cb01fd34$export$cbf60ecb96cbb82f; }, function (v) { return $738dab60cb01fd34$export$cbf60ecb96cbb82f = v; });
var $738dab60cb01fd34$export$cbf60ecb96cbb82f;
"use strict";
$738dab60cb01fd34$export$cbf60ecb96cbb82f = void 0;

var $f72FK = parcelRequire("f72FK");
const $738dab60cb01fd34$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
const $738dab60cb01fd34$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $738dab60cb01fd34$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $738dab60cb01fd34$var$formatLong = $738dab60cb01fd34$export$cbf60ecb96cbb82f = {
    date: (0, $f72FK.buildFormatLongFn)({
        formats: $738dab60cb01fd34$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $f72FK.buildFormatLongFn)({
        formats: $738dab60cb01fd34$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $f72FK.buildFormatLongFn)({
        formats: $738dab60cb01fd34$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});
parcelRegister("f72FK", function(module, exports) {

$parcel$export(module.exports, "buildFormatLongFn", function () { return $b0099522d88ec61d$export$38e44e97ce4dbb7d; }, function (v) { return $b0099522d88ec61d$export$38e44e97ce4dbb7d = v; });
var $b0099522d88ec61d$export$38e44e97ce4dbb7d;
"use strict";
$b0099522d88ec61d$export$38e44e97ce4dbb7d = $b0099522d88ec61d$var$buildFormatLongFn;
function $b0099522d88ec61d$var$buildFormatLongFn(args) {
    return (options = {})=>{
        // TODO: Remove String()
        const width = options.width ? String(options.width) : args.defaultWidth;
        const format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}

});


parcelRegister("hv8WS", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $cbdc45e949df1a9a$export$8fbbfd65594f46a0; }, function (v) { return $cbdc45e949df1a9a$export$8fbbfd65594f46a0 = v; });
var $cbdc45e949df1a9a$export$8fbbfd65594f46a0;
"use strict";
$cbdc45e949df1a9a$export$8fbbfd65594f46a0 = void 0;
const $cbdc45e949df1a9a$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
const $cbdc45e949df1a9a$var$formatRelative = (token, _date, _baseDate, _options)=>$cbdc45e949df1a9a$var$formatRelativeLocale[token];
$cbdc45e949df1a9a$export$8fbbfd65594f46a0 = $cbdc45e949df1a9a$var$formatRelative;

});

parcelRegister("kXuIl", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $f4212488d46f67dc$export$b3bd0bc58e36cd63; }, function (v) { return $f4212488d46f67dc$export$b3bd0bc58e36cd63 = v; });
var $f4212488d46f67dc$export$b3bd0bc58e36cd63;
"use strict";
$f4212488d46f67dc$export$b3bd0bc58e36cd63 = void 0;

var $aQ5po = parcelRequire("aQ5po");
const $f4212488d46f67dc$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
const $f4212488d46f67dc$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $f4212488d46f67dc$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
const $f4212488d46f67dc$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
const $f4212488d46f67dc$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
const $f4212488d46f67dc$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
const $f4212488d46f67dc$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    const rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
const $f4212488d46f67dc$var$localize = $f4212488d46f67dc$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $f4212488d46f67dc$var$ordinalNumber,
    era: (0, $aQ5po.buildLocalizeFn)({
        values: $f4212488d46f67dc$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $aQ5po.buildLocalizeFn)({
        values: $f4212488d46f67dc$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $aQ5po.buildLocalizeFn)({
        values: $f4212488d46f67dc$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $aQ5po.buildLocalizeFn)({
        values: $f4212488d46f67dc$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $aQ5po.buildLocalizeFn)({
        values: $f4212488d46f67dc$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $f4212488d46f67dc$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});
parcelRegister("aQ5po", function(module, exports) {

$parcel$export(module.exports, "buildLocalizeFn", function () { return $7e42f4b926971275$export$63596d6ee8878b25; }, function (v) { return $7e42f4b926971275$export$63596d6ee8878b25 = v; });
var $7e42f4b926971275$export$63596d6ee8878b25;
"use strict";
$7e42f4b926971275$export$63596d6ee8878b25 = $7e42f4b926971275$var$buildLocalizeFn; /* eslint-disable no-unused-vars */ 
/**
 * The localize function argument callback which allows to convert raw value to
 * the actual type.
 *
 * @param value - The value to convert
 *
 * @returns The converted value
 */ /**
 * The map of localized values for each width.
 */ /**
 * The index type of the locale unit value. It types conversion of units of
 * values that don't start at 0 (i.e. quarters).
 */ /**
 * Converts the unit value to the tuple of values.
 */ /**
 * The tuple of localized era values. The first element represents BC,
 * the second element represents AD.
 */ /**
 * The tuple of localized quarter values. The first element represents Q1.
 */ /**
 * The tuple of localized day values. The first element represents Sunday.
 */ /**
 * The tuple of localized month values. The first element represents January.
 */ function $7e42f4b926971275$var$buildLocalizeFn(args) {
    return (value, options)=>{
        const context = options?.context ? String(options.context) : "standalone";
        let valuesArray;
        if (context === "formatting" && args.formattingValues) {
            const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            const width = options?.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            const defaultWidth = args.defaultWidth;
            const width = options?.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[width] || args.values[defaultWidth];
        }
        const index = args.argumentCallback ? args.argumentCallback(value) : value;
        // @ts-expect-error - For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}

});


parcelRegister("89jyM", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $5eee5631aeacb968$export$4659b591c19bdf3d; }, function (v) { return $5eee5631aeacb968$export$4659b591c19bdf3d = v; });
var $5eee5631aeacb968$export$4659b591c19bdf3d;
"use strict";
$5eee5631aeacb968$export$4659b591c19bdf3d = void 0;

var $4uy7n = parcelRequire("4uy7n");

var $68Pft = parcelRequire("68Pft");
const $5eee5631aeacb968$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const $5eee5631aeacb968$var$parseOrdinalNumberPattern = /\d+/i;
const $5eee5631aeacb968$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
const $5eee5631aeacb968$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
const $5eee5631aeacb968$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
const $5eee5631aeacb968$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $5eee5631aeacb968$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
const $5eee5631aeacb968$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $5eee5631aeacb968$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
const $5eee5631aeacb968$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
const $5eee5631aeacb968$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
const $5eee5631aeacb968$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
const $5eee5631aeacb968$var$match = $5eee5631aeacb968$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $68Pft.buildMatchPatternFn)({
        matchPattern: $5eee5631aeacb968$var$matchOrdinalNumberPattern,
        parsePattern: $5eee5631aeacb968$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $4uy7n.buildMatchFn)({
        matchPatterns: $5eee5631aeacb968$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $5eee5631aeacb968$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $4uy7n.buildMatchFn)({
        matchPatterns: $5eee5631aeacb968$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $5eee5631aeacb968$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $4uy7n.buildMatchFn)({
        matchPatterns: $5eee5631aeacb968$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $5eee5631aeacb968$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $4uy7n.buildMatchFn)({
        matchPatterns: $5eee5631aeacb968$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $5eee5631aeacb968$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $4uy7n.buildMatchFn)({
        matchPatterns: $5eee5631aeacb968$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $5eee5631aeacb968$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});
parcelRegister("4uy7n", function(module, exports) {

$parcel$export(module.exports, "buildMatchFn", function () { return $34546de9340f6654$export$1430a0f35710914d; }, function (v) { return $34546de9340f6654$export$1430a0f35710914d = v; });
var $34546de9340f6654$export$1430a0f35710914d;
"use strict";
$34546de9340f6654$export$1430a0f35710914d = $34546de9340f6654$var$buildMatchFn;
function $34546de9340f6654$var$buildMatchFn(args) {
    return (string, options = {})=>{
        const width = options.width;
        const matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        const matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        const key = Array.isArray(parsePatterns) ? $34546de9340f6654$var$findIndex(parsePatterns, (pattern)=>pattern.test(matchedString)) : $34546de9340f6654$var$findKey(parsePatterns, (pattern)=>pattern.test(matchedString));
        let value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $34546de9340f6654$var$findKey(object, predicate) {
    for(const key in object){
        if (Object.prototype.hasOwnProperty.call(object, key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $34546de9340f6654$var$findIndex(array, predicate) {
    for(let key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}

});

parcelRegister("68Pft", function(module, exports) {

$parcel$export(module.exports, "buildMatchPatternFn", function () { return $478b3e4e6b8b5b47$export$fdaf2fd6d7edde95; }, function (v) { return $478b3e4e6b8b5b47$export$fdaf2fd6d7edde95 = v; });
var $478b3e4e6b8b5b47$export$fdaf2fd6d7edde95;
"use strict";
$478b3e4e6b8b5b47$export$fdaf2fd6d7edde95 = $478b3e4e6b8b5b47$var$buildMatchPatternFn;
function $478b3e4e6b8b5b47$var$buildMatchPatternFn(args) {
    return (string, options = {})=>{
        const matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        let value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}

});




parcelRegister("c9GDQ", function(module, exports) {

$parcel$export(module.exports, "formatters", function () { return $8d976711ada6960d$export$fe98a034cfb96d55; }, function (v) { return $8d976711ada6960d$export$fe98a034cfb96d55 = v; });
var $8d976711ada6960d$export$fe98a034cfb96d55;
"use strict";
$8d976711ada6960d$export$fe98a034cfb96d55 = void 0;

var $kScSL = parcelRequire("kScSL");

var $dGxHQ = parcelRequire("dGxHQ");

var $43yjM = parcelRequire("43yjM");

var $8S0vk = parcelRequire("8S0vk");

var $aY23c = parcelRequire("aY23c");

var $5F97c = parcelRequire("5F97c");

var $8E1N1 = parcelRequire("8E1N1");
const $8d976711ada6960d$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ const $8d976711ada6960d$var$formatters = $8d976711ada6960d$export$fe98a034cfb96d55 = {
    // Era
    G: function(date, token, localize) {
        const era = date.getFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            const signedYear = date.getFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            const year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return $8E1N1.lightFormatters.y(date, token);
    },
    // Local week-numbering year
    Y: function(date, token, localize, options) {
        const signedWeekYear = (0, $aY23c.getWeekYear)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            const twoDigitYear = weekYear % 100;
            return (0, $5F97c.addLeadingZeros)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, $5F97c.addLeadingZeros)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function(date, token) {
        const isoWeekYear = (0, $43yjM.getISOWeekYear)(date);
        // Padding
        return (0, $5F97c.addLeadingZeros)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(date, token) {
        const year = date.getFullYear();
        return (0, $5F97c.addLeadingZeros)(year, token.length);
    },
    // Quarter
    Q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $5F97c.addLeadingZeros)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $5F97c.addLeadingZeros)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            case "M":
            case "MM":
                return $8E1N1.lightFormatters.M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $5F97c.addLeadingZeros)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function(date, token, localize, options) {
        const week = (0, $8S0vk.getWeek)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $5F97c.addLeadingZeros)(week, token.length);
    },
    // ISO week of year
    I: function(date, token, localize) {
        const isoWeek = (0, $dGxHQ.getISOWeek)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $5F97c.addLeadingZeros)(isoWeek, token.length);
    },
    // Day of the month
    d: function(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getDate(), {
            unit: "date"
        });
        return $8E1N1.lightFormatters.d(date, token);
    },
    // Day of year
    D: function(date, token, localize) {
        const dayOfYear = (0, $kScSL.getDayOfYear)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $5F97c.addLeadingZeros)(dayOfYear, token.length);
    },
    // Day of week
    E: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $5F97c.addLeadingZeros)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $5F97c.addLeadingZeros)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        const isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $5F97c.addLeadingZeros)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function(date, token, localize) {
        const hours = date.getHours();
        const dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $8d976711ada6960d$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $8d976711ada6960d$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $8d976711ada6960d$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $8d976711ada6960d$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $8d976711ada6960d$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $8d976711ada6960d$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function(date, token, localize) {
        if (token === "ho") {
            let hours = date.getHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return $8E1N1.lightFormatters.h(date, token);
    },
    // Hour [0-23]
    H: function(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getHours(), {
            unit: "hour"
        });
        return $8E1N1.lightFormatters.H(date, token);
    },
    // Hour [0-11]
    K: function(date, token, localize) {
        const hours = date.getHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $5F97c.addLeadingZeros)(hours, token.length);
    },
    // Hour [1-24]
    k: function(date, token, localize) {
        let hours = date.getHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $5F97c.addLeadingZeros)(hours, token.length);
    },
    // Minute
    m: function(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getMinutes(), {
            unit: "minute"
        });
        return $8E1N1.lightFormatters.m(date, token);
    },
    // Second
    s: function(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getSeconds(), {
            unit: "second"
        });
        return $8E1N1.lightFormatters.s(date, token);
    },
    // Fraction of second
    S: function(date, token) {
        return $8E1N1.lightFormatters.S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $8d976711ada6960d$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                return $8d976711ada6960d$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $8d976711ada6960d$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $8d976711ada6960d$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                return $8d976711ada6960d$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $8d976711ada6960d$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $8d976711ada6960d$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $8d976711ada6960d$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $8d976711ada6960d$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $8d976711ada6960d$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function(date, token, _localize) {
        const timestamp = Math.trunc(date.getTime() / 1000);
        return (0, $5F97c.addLeadingZeros)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function(date, token, _localize) {
        const timestamp = date.getTime();
        return (0, $5F97c.addLeadingZeros)(timestamp, token.length);
    }
};
function $8d976711ada6960d$var$formatTimezoneShort(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = Math.trunc(absOffset / 60);
    const minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    return sign + String(hours) + delimiter + (0, $5F97c.addLeadingZeros)(minutes, 2);
}
function $8d976711ada6960d$var$formatTimezoneWithOptionalMinutes(offset, delimiter) {
    if (offset % 60 === 0) {
        const sign = offset > 0 ? "-" : "+";
        return sign + (0, $5F97c.addLeadingZeros)(Math.abs(offset) / 60, 2);
    }
    return $8d976711ada6960d$var$formatTimezone(offset, delimiter);
}
function $8d976711ada6960d$var$formatTimezone(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = (0, $5F97c.addLeadingZeros)(Math.trunc(absOffset / 60), 2);
    const minutes = (0, $5F97c.addLeadingZeros)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}

});
parcelRegister("kScSL", function(module, exports) {

$parcel$export(module.exports, "getDayOfYear", function () { return $f322d7f6078d84e3$export$d3b42cd8452deec; }, function (v) { return $f322d7f6078d84e3$export$d3b42cd8452deec = v; });
var $f322d7f6078d84e3$export$d3b42cd8452deec;
"use strict";
$f322d7f6078d84e3$export$d3b42cd8452deec = $f322d7f6078d84e3$var$getDayOfYear;

var $fctE0 = parcelRequire("fctE0");

var $bnoYK = parcelRequire("bnoYK");

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name getDayOfYear
 * @category Day Helpers
 * @summary Get the day of the year of the given date.
 *
 * @description
 * Get the day of the year of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of year
 *
 * @example
 * // Which day of the year is 2 July 2014?
 * const result = getDayOfYear(new Date(2014, 6, 2))
 * //=> 183
 */ function $f322d7f6078d84e3$var$getDayOfYear(date) {
    const _date = (0, $b3MCU.toDate)(date);
    const diff = (0, $fctE0.differenceInCalendarDays)(_date, (0, $bnoYK.startOfYear)(_date));
    const dayOfYear = diff + 1;
    return dayOfYear;
}

});

parcelRegister("dGxHQ", function(module, exports) {

$parcel$export(module.exports, "getISOWeek", function () { return $9f6957f0bbdd28d8$export$7cabdc5698b63e2f; }, function (v) { return $9f6957f0bbdd28d8$export$7cabdc5698b63e2f = v; });
var $9f6957f0bbdd28d8$export$7cabdc5698b63e2f;
"use strict";
$9f6957f0bbdd28d8$export$7cabdc5698b63e2f = $9f6957f0bbdd28d8$var$getISOWeek;

var $7MMvH = parcelRequire("7MMvH");

var $4x8aw = parcelRequire("4x8aw");

var $f44li = parcelRequire("f44li");

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name getISOWeek
 * @category ISO Week Helpers
 * @summary Get the ISO week of the given date.
 *
 * @description
 * Get the ISO week of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The ISO week
 *
 * @example
 * // Which week of the ISO-week numbering year is 2 January 2005?
 * const result = getISOWeek(new Date(2005, 0, 2))
 * //=> 53
 */ function $9f6957f0bbdd28d8$var$getISOWeek(date) {
    const _date = (0, $b3MCU.toDate)(date);
    const diff = +(0, $4x8aw.startOfISOWeek)(_date) - +(0, $f44li.startOfISOWeekYear)(_date);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / $7MMvH.millisecondsInWeek) + 1;
}

});

parcelRegister("8S0vk", function(module, exports) {

$parcel$export(module.exports, "getWeek", function () { return $6753c20907d75cd3$export$efe19b760242b2fc; }, function (v) { return $6753c20907d75cd3$export$efe19b760242b2fc = v; });
var $6753c20907d75cd3$export$efe19b760242b2fc;
"use strict";
$6753c20907d75cd3$export$efe19b760242b2fc = $6753c20907d75cd3$var$getWeek;

var $7MMvH = parcelRequire("7MMvH");

var $isuGI = parcelRequire("isuGI");

var $1pqul = parcelRequire("1pqul");

var $b3MCU = parcelRequire("b3MCU");
/**
 * The {@link getWeek} function options.
 */ /**
 * @name getWeek
 * @category Week Helpers
 * @summary Get the local week index of the given date.
 *
 * @description
 * Get the local week index of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options
 *
 * @returns The week
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005 with default options?
 * const result = getWeek(new Date(2005, 0, 2))
 * //=> 2
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005,
 * // if Monday is the first day of the week,
 * // and the first week of the year always contains 4 January?
 * const result = getWeek(new Date(2005, 0, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> 53
 */ function $6753c20907d75cd3$var$getWeek(date, options) {
    const _date = (0, $b3MCU.toDate)(date);
    const diff = +(0, $isuGI.startOfWeek)(_date, options) - +(0, $1pqul.startOfWeekYear)(_date, options);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / $7MMvH.millisecondsInWeek) + 1;
}

});
parcelRegister("1pqul", function(module, exports) {

$parcel$export(module.exports, "startOfWeekYear", function () { return $106cac48c8eec2fa$export$bb7b45bb8e74da0f; }, function (v) { return $106cac48c8eec2fa$export$bb7b45bb8e74da0f = v; });
var $106cac48c8eec2fa$export$bb7b45bb8e74da0f;
"use strict";
$106cac48c8eec2fa$export$bb7b45bb8e74da0f = $106cac48c8eec2fa$var$startOfWeekYear;

var $02yAu = parcelRequire("02yAu");

var $aY23c = parcelRequire("aY23c");

var $isuGI = parcelRequire("isuGI");

var $lJvf9 = parcelRequire("lJvf9");
/**
 * The {@link startOfWeekYear} function options.
 */ /**
 * @name startOfWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Return the start of a local week-numbering year for the given date.
 *
 * @description
 * Return the start of a local week-numbering year.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of a week-numbering year
 *
 * @example
 * // The start of an a week-numbering year for 2 July 2005 with default settings:
 * const result = startOfWeekYear(new Date(2005, 6, 2))
 * //=> Sun Dec 26 2004 00:00:00
 *
 * @example
 * // The start of a week-numbering year for 2 July 2005
 * // if Monday is the first day of week
 * // and 4 January is always in the first week of the year:
 * const result = startOfWeekYear(new Date(2005, 6, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Mon Jan 03 2005 00:00:00
 */ function $106cac48c8eec2fa$var$startOfWeekYear(date, options) {
    const defaultOptions = (0, $lJvf9.getDefaultOptions)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const year = (0, $aY23c.getWeekYear)(date, options);
    const firstWeek = (0, $02yAu.constructFrom)(date, 0);
    firstWeek.setFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    const _date = (0, $isuGI.startOfWeek)(firstWeek, options);
    return _date;
}

});
parcelRegister("aY23c", function(module, exports) {

$parcel$export(module.exports, "getWeekYear", function () { return $7fc1192d629088c5$export$12d572480ceb6e58; }, function (v) { return $7fc1192d629088c5$export$12d572480ceb6e58 = v; });
var $7fc1192d629088c5$export$12d572480ceb6e58;
"use strict";
$7fc1192d629088c5$export$12d572480ceb6e58 = $7fc1192d629088c5$var$getWeekYear;

var $02yAu = parcelRequire("02yAu");

var $isuGI = parcelRequire("isuGI");

var $b3MCU = parcelRequire("b3MCU");

var $lJvf9 = parcelRequire("lJvf9");
/**
 * The {@link getWeekYear} function options.
 */ /**
 * @name getWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Get the local week-numbering year of the given date.
 *
 * @description
 * Get the local week-numbering year of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The local week-numbering year
 *
 * @example
 * // Which week numbering year is 26 December 2004 with the default settings?
 * const result = getWeekYear(new Date(2004, 11, 26))
 * //=> 2005
 *
 * @example
 * // Which week numbering year is 26 December 2004 if week starts on Saturday?
 * const result = getWeekYear(new Date(2004, 11, 26), { weekStartsOn: 6 })
 * //=> 2004
 *
 * @example
 * // Which week numbering year is 26 December 2004 if the first week contains 4 January?
 * const result = getWeekYear(new Date(2004, 11, 26), { firstWeekContainsDate: 4 })
 * //=> 2004
 */ function $7fc1192d629088c5$var$getWeekYear(date, options) {
    const _date = (0, $b3MCU.toDate)(date);
    const year = _date.getFullYear();
    const defaultOptions = (0, $lJvf9.getDefaultOptions)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const firstWeekOfNextYear = (0, $02yAu.constructFrom)(date, 0);
    firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $isuGI.startOfWeek)(firstWeekOfNextYear, options);
    const firstWeekOfThisYear = (0, $02yAu.constructFrom)(date, 0);
    firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $isuGI.startOfWeek)(firstWeekOfThisYear, options);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("5F97c", function(module, exports) {

$parcel$export(module.exports, "addLeadingZeros", function () { return $41f7da2f24b4266f$export$c8306e720e213c0f; }, function (v) { return $41f7da2f24b4266f$export$c8306e720e213c0f = v; });
var $41f7da2f24b4266f$export$c8306e720e213c0f;
"use strict";
$41f7da2f24b4266f$export$c8306e720e213c0f = $41f7da2f24b4266f$var$addLeadingZeros;
function $41f7da2f24b4266f$var$addLeadingZeros(number, targetLength) {
    const sign = number < 0 ? "-" : "";
    const output = Math.abs(number).toString().padStart(targetLength, "0");
    return sign + output;
}

});

parcelRegister("8E1N1", function(module, exports) {

$parcel$export(module.exports, "lightFormatters", function () { return $64b3729231ce855c$export$b0d4b338e1516f13; }, function (v) { return $64b3729231ce855c$export$b0d4b338e1516f13 = v; });
var $64b3729231ce855c$export$b0d4b338e1516f13;
"use strict";
$64b3729231ce855c$export$b0d4b338e1516f13 = void 0;

var $5F97c = parcelRequire("5F97c");
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ const $64b3729231ce855c$var$lightFormatters = $64b3729231ce855c$export$b0d4b338e1516f13 = {
    // Year
    y (date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        const signedYear = date.getFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $5F97c.addLeadingZeros)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M (date, token) {
        const month = date.getMonth();
        return token === "M" ? String(month + 1) : (0, $5F97c.addLeadingZeros)(month + 1, 2);
    },
    // Day of the month
    d (date, token) {
        return (0, $5F97c.addLeadingZeros)(date.getDate(), token.length);
    },
    // AM or PM
    a (date, token) {
        const dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h (date, token) {
        return (0, $5F97c.addLeadingZeros)(date.getHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H (date, token) {
        return (0, $5F97c.addLeadingZeros)(date.getHours(), token.length);
    },
    // Minute
    m (date, token) {
        return (0, $5F97c.addLeadingZeros)(date.getMinutes(), token.length);
    },
    // Second
    s (date, token) {
        return (0, $5F97c.addLeadingZeros)(date.getSeconds(), token.length);
    },
    // Fraction of second
    S (date, token) {
        const numberOfDigits = token.length;
        const milliseconds = date.getMilliseconds();
        const fractionalSeconds = Math.trunc(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $5F97c.addLeadingZeros)(fractionalSeconds, token.length);
    }
};

});


parcelRegister("cXalR", function(module, exports) {

$parcel$export(module.exports, "longFormatters", function () { return $96e30659b021b22d$export$70cc8fd02856fd58; }, function (v) { return $96e30659b021b22d$export$70cc8fd02856fd58 = v; });
var $96e30659b021b22d$export$70cc8fd02856fd58;
"use strict";
$96e30659b021b22d$export$70cc8fd02856fd58 = void 0;
const $96e30659b021b22d$var$dateLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
const $96e30659b021b22d$var$timeLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
const $96e30659b021b22d$var$dateTimeLongFormatter = (pattern, formatLong)=>{
    const matchResult = pattern.match(/(P+)(p+)?/) || [];
    const datePattern = matchResult[1];
    const timePattern = matchResult[2];
    if (!timePattern) return $96e30659b021b22d$var$dateLongFormatter(pattern, formatLong);
    let dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $96e30659b021b22d$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $96e30659b021b22d$var$timeLongFormatter(timePattern, formatLong));
};
const $96e30659b021b22d$var$longFormatters = $96e30659b021b22d$export$70cc8fd02856fd58 = {
    p: $96e30659b021b22d$var$timeLongFormatter,
    P: $96e30659b021b22d$var$dateTimeLongFormatter
};

});

parcelRegister("8H04k", function(module, exports) {

$parcel$export(module.exports, "isProtectedDayOfYearToken", function () { return $6542648f1fc704fd$export$c6cc36aa33304772; }, function (v) { return $6542648f1fc704fd$export$c6cc36aa33304772 = v; });
$parcel$export(module.exports, "isProtectedWeekYearToken", function () { return $6542648f1fc704fd$export$c6b49d6dceb604a1; }, function (v) { return $6542648f1fc704fd$export$c6b49d6dceb604a1 = v; });
$parcel$export(module.exports, "warnOrThrowProtectedError", function () { return $6542648f1fc704fd$export$f5f38f90ecaaf879; }, function (v) { return $6542648f1fc704fd$export$f5f38f90ecaaf879 = v; });
var $6542648f1fc704fd$export$c6cc36aa33304772;
var $6542648f1fc704fd$export$c6b49d6dceb604a1;
var $6542648f1fc704fd$export$f5f38f90ecaaf879;
"use strict";
$6542648f1fc704fd$export$c6cc36aa33304772 = $6542648f1fc704fd$var$isProtectedDayOfYearToken;
$6542648f1fc704fd$export$c6b49d6dceb604a1 = $6542648f1fc704fd$var$isProtectedWeekYearToken;
$6542648f1fc704fd$export$f5f38f90ecaaf879 = $6542648f1fc704fd$var$warnOrThrowProtectedError;
const $6542648f1fc704fd$var$dayOfYearTokenRE = /^D+$/;
const $6542648f1fc704fd$var$weekYearTokenRE = /^Y+$/;
const $6542648f1fc704fd$var$throwTokens = [
    "D",
    "DD",
    "YY",
    "YYYY"
];
function $6542648f1fc704fd$var$isProtectedDayOfYearToken(token) {
    return $6542648f1fc704fd$var$dayOfYearTokenRE.test(token);
}
function $6542648f1fc704fd$var$isProtectedWeekYearToken(token) {
    return $6542648f1fc704fd$var$weekYearTokenRE.test(token);
}
function $6542648f1fc704fd$var$warnOrThrowProtectedError(token, format, input) {
    const _message = $6542648f1fc704fd$var$message(token, format, input);
    console.warn(_message);
    if ($6542648f1fc704fd$var$throwTokens.includes(token)) throw new RangeError(_message);
}
function $6542648f1fc704fd$var$message(token, format, input) {
    const subject = token[0] === "Y" ? "years" : "days of the month";
    return `Use \`${token.toLowerCase()}\` instead of \`${token}\` (in \`${format}\`) for formatting ${subject} to the input \`${input}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}

});


parcelRegister("dtOy9", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $9d0531ef543151d9$export$2c14ff85d6318973; }, function (v) { return $9d0531ef543151d9$export$2c14ff85d6318973 = v; });
var $9d0531ef543151d9$export$2c14ff85d6318973;
"use strict";
$9d0531ef543151d9$export$2c14ff85d6318973 = $9d0531ef543151d9$var$formatDistance;

var $6klPK = parcelRequire("6klPK");

var $7MMvH = parcelRequire("7MMvH");

var $klNiQ = parcelRequire("klNiQ");

var $hfEAx = parcelRequire("hfEAx");

var $b3MCU = parcelRequire("b3MCU");

var $lpy2g = parcelRequire("lpy2g");

var $lJvf9 = parcelRequire("lJvf9");

var $izS8L = parcelRequire("izS8L");
/**
 * The {@link formatDistance} function options.
 */ /**
 * @name formatDistance
 * @category Common Helpers
 * @summary Return the distance between the given dates in words.
 *
 * @description
 * Return the distance between the given dates in words.
 *
 * | Distance between dates                                            | Result              |
 * |-------------------------------------------------------------------|---------------------|
 * | 0 ... 30 secs                                                     | less than a minute  |
 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
 * | N yrs ... N yrs 3 months                                          | about N years       |
 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
 *
 * With `options.includeSeconds == true`:
 * | Distance between dates | Result               |
 * |------------------------|----------------------|
 * | 0 secs ... 5 secs      | less than 5 seconds  |
 * | 5 secs ... 10 secs     | less than 10 seconds |
 * | 10 secs ... 20 secs    | less than 20 seconds |
 * | 20 secs ... 40 secs    | half a minute        |
 * | 40 secs ... 60 secs    | less than a minute   |
 * | 60 secs ... 90 secs    | 1 minute             |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date
 * @param baseDate - The date to compare with
 * @param options - An object with options
 *
 * @returns The distance in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `baseDate` must not be Invalid Date
 * @throws `options.locale` must contain `formatDistance` property
 *
 * @example
 * // What is the distance between 2 July 2014 and 1 January 2015?
 * const result = formatDistance(new Date(2014, 6, 2), new Date(2015, 0, 1))
 * //=> '6 months'
 *
 * @example
 * // What is the distance between 1 January 2015 00:00:15
 * // and 1 January 2015 00:00:00, including seconds?
 * const result = formatDistance(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   new Date(2015, 0, 1, 0, 0, 0),
 *   { includeSeconds: true }
 * )
 * //=> 'less than 20 seconds'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, with a suffix?
 * const result = formatDistance(new Date(2015, 0, 1), new Date(2016, 0, 1), {
 *   addSuffix: true
 * })
 * //=> 'about 1 year ago'
 *
 * @example
 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = formatDistance(new Date(2016, 7, 1), new Date(2015, 0, 1), {
 *   locale: eoLocale
 * })
 * //=> 'pli ol 1 jaro'
 */ function $9d0531ef543151d9$var$formatDistance(date, baseDate, options) {
    const defaultOptions = (0, $lJvf9.getDefaultOptions)();
    const locale = options?.locale ?? defaultOptions.locale ?? $lpy2g.defaultLocale;
    const minutesInAlmostTwoDays = 2520;
    const comparison = (0, $6klPK.compareAsc)(date, baseDate);
    if (isNaN(comparison)) throw new RangeError("Invalid time value");
    const localizeOptions = Object.assign({}, options, {
        addSuffix: options?.addSuffix,
        comparison: comparison
    });
    let dateLeft;
    let dateRight;
    if (comparison > 0) {
        dateLeft = (0, $b3MCU.toDate)(baseDate);
        dateRight = (0, $b3MCU.toDate)(date);
    } else {
        dateLeft = (0, $b3MCU.toDate)(date);
        dateRight = (0, $b3MCU.toDate)(baseDate);
    }
    const seconds = (0, $hfEAx.differenceInSeconds)(dateRight, dateLeft);
    const offsetInSeconds = ((0, $izS8L.getTimezoneOffsetInMilliseconds)(dateRight) - (0, $izS8L.getTimezoneOffsetInMilliseconds)(dateLeft)) / 1000;
    const minutes = Math.round((seconds - offsetInSeconds) / 60);
    let months;
    // 0 up to 2 mins
    if (minutes < 2) {
        if (options?.includeSeconds) {
            if (seconds < 5) return locale.formatDistance("lessThanXSeconds", 5, localizeOptions);
            else if (seconds < 10) return locale.formatDistance("lessThanXSeconds", 10, localizeOptions);
            else if (seconds < 20) return locale.formatDistance("lessThanXSeconds", 20, localizeOptions);
            else if (seconds < 40) return locale.formatDistance("halfAMinute", 0, localizeOptions);
            else if (seconds < 60) return locale.formatDistance("lessThanXMinutes", 1, localizeOptions);
            else return locale.formatDistance("xMinutes", 1, localizeOptions);
        } else {
            if (minutes === 0) return locale.formatDistance("lessThanXMinutes", 1, localizeOptions);
            else return locale.formatDistance("xMinutes", minutes, localizeOptions);
        }
    } else if (minutes < 45) return locale.formatDistance("xMinutes", minutes, localizeOptions);
    else if (minutes < 90) return locale.formatDistance("aboutXHours", 1, localizeOptions);
    else if (minutes < $7MMvH.minutesInDay) {
        const hours = Math.round(minutes / 60);
        return locale.formatDistance("aboutXHours", hours, localizeOptions);
    // 1 day up to 1.75 days
    } else if (minutes < minutesInAlmostTwoDays) return locale.formatDistance("xDays", 1, localizeOptions);
    else if (minutes < $7MMvH.minutesInMonth) {
        const days = Math.round(minutes / $7MMvH.minutesInDay);
        return locale.formatDistance("xDays", days, localizeOptions);
    // 1 month up to 2 months
    } else if (minutes < $7MMvH.minutesInMonth * 2) {
        months = Math.round(minutes / $7MMvH.minutesInMonth);
        return locale.formatDistance("aboutXMonths", months, localizeOptions);
    }
    months = (0, $klNiQ.differenceInMonths)(dateRight, dateLeft);
    // 2 months up to 12 months
    if (months < 12) {
        const nearestMonth = Math.round(minutes / $7MMvH.minutesInMonth);
        return locale.formatDistance("xMonths", nearestMonth, localizeOptions);
    // 1 year up to max Date
    } else {
        const monthsSinceStartOfYear = months % 12;
        const years = Math.trunc(months / 12);
        // N years up to 1 years 3 months
        if (monthsSinceStartOfYear < 3) return locale.formatDistance("aboutXYears", years, localizeOptions);
        else if (monthsSinceStartOfYear < 9) return locale.formatDistance("overXYears", years, localizeOptions);
        else return locale.formatDistance("almostXYears", years + 1, localizeOptions);
    }
}

});

parcelRegister("d338J", function(module, exports) {

$parcel$export(module.exports, "formatDistanceStrict", function () { return $97fdfdacd5f90c8a$export$e4be225b8ee0a759; }, function (v) { return $97fdfdacd5f90c8a$export$e4be225b8ee0a759 = v; });
var $97fdfdacd5f90c8a$export$e4be225b8ee0a759;
"use strict";
$97fdfdacd5f90c8a$export$e4be225b8ee0a759 = $97fdfdacd5f90c8a$var$formatDistanceStrict;

var $lpy2g = parcelRequire("lpy2g");

var $lJvf9 = parcelRequire("lJvf9");

var $bumqY = parcelRequire("bumqY");

var $izS8L = parcelRequire("izS8L");

var $6klPK = parcelRequire("6klPK");

var $7MMvH = parcelRequire("7MMvH");

var $b3MCU = parcelRequire("b3MCU");
/**
 * The {@link formatDistanceStrict} function options.
 */ /**
 * The unit used to format the distance in {@link formatDistanceStrict}.
 */ /**
 * @name formatDistanceStrict
 * @category Common Helpers
 * @summary Return the distance between the given dates in words.
 *
 * @description
 * Return the distance between the given dates in words, using strict units.
 * This is like `formatDistance`, but does not use helpers like 'almost', 'over',
 * 'less than' and the like.
 *
 * | Distance between dates | Result              |
 * |------------------------|---------------------|
 * | 0 ... 59 secs          | [0..59] seconds     |
 * | 1 ... 59 mins          | [1..59] minutes     |
 * | 1 ... 23 hrs           | [1..23] hours       |
 * | 1 ... 29 days          | [1..29] days        |
 * | 1 ... 11 months        | [1..11] months      |
 * | 1 ... N years          | [1..N]  years       |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date
 * @param baseDate - The date to compare with
 * @param options - An object with options
 *
 * @returns The distance in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `baseDate` must not be Invalid Date
 * @throws `options.unit` must be 'second', 'minute', 'hour', 'day', 'month' or 'year'
 * @throws `options.locale` must contain `formatDistance` property
 *
 * @example
 * // What is the distance between 2 July 2014 and 1 January 2015?
 * const result = formatDistanceStrict(new Date(2014, 6, 2), new Date(2015, 0, 2))
 * //=> '6 months'
 *
 * @example
 * // What is the distance between 1 January 2015 00:00:15
 * // and 1 January 2015 00:00:00?
 * const result = formatDistanceStrict(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   new Date(2015, 0, 1, 0, 0, 0)
 * )
 * //=> '15 seconds'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, with a suffix?
 * const result = formatDistanceStrict(new Date(2015, 0, 1), new Date(2016, 0, 1), {
 *   addSuffix: true
 * })
 * //=> '1 year ago'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, in minutes?
 * const result = formatDistanceStrict(new Date(2016, 0, 1), new Date(2015, 0, 1), {
 *   unit: 'minute'
 * })
 * //=> '525600 minutes'
 *
 * @example
 * // What is the distance from 1 January 2015
 * // to 28 January 2015, in months, rounded up?
 * const result = formatDistanceStrict(new Date(2015, 0, 28), new Date(2015, 0, 1), {
 *   unit: 'month',
 *   roundingMethod: 'ceil'
 * })
 * //=> '1 month'
 *
 * @example
 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = formatDistanceStrict(new Date(2016, 7, 1), new Date(2015, 0, 1), {
 *   locale: eoLocale
 * })
 * //=> '1 jaro'
 */ function $97fdfdacd5f90c8a$var$formatDistanceStrict(date, baseDate, options) {
    const defaultOptions = (0, $lJvf9.getDefaultOptions)();
    const locale = options?.locale ?? defaultOptions.locale ?? $lpy2g.defaultLocale;
    const comparison = (0, $6klPK.compareAsc)(date, baseDate);
    if (isNaN(comparison)) throw new RangeError("Invalid time value");
    const localizeOptions = Object.assign({}, options, {
        addSuffix: options?.addSuffix,
        comparison: comparison
    });
    let dateLeft;
    let dateRight;
    if (comparison > 0) {
        dateLeft = (0, $b3MCU.toDate)(baseDate);
        dateRight = (0, $b3MCU.toDate)(date);
    } else {
        dateLeft = (0, $b3MCU.toDate)(date);
        dateRight = (0, $b3MCU.toDate)(baseDate);
    }
    const roundingMethod = (0, $bumqY.getRoundingMethod)(options?.roundingMethod ?? "round");
    const milliseconds = dateRight.getTime() - dateLeft.getTime();
    const minutes = milliseconds / $7MMvH.millisecondsInMinute;
    const timezoneOffset = (0, $izS8L.getTimezoneOffsetInMilliseconds)(dateRight) - (0, $izS8L.getTimezoneOffsetInMilliseconds)(dateLeft);
    // Use DST-normalized difference in minutes for years, months and days;
    // use regular difference in minutes for hours, minutes and seconds.
    const dstNormalizedMinutes = (milliseconds - timezoneOffset) / $7MMvH.millisecondsInMinute;
    const defaultUnit = options?.unit;
    let unit;
    if (!defaultUnit) {
        if (minutes < 1) unit = "second";
        else if (minutes < 60) unit = "minute";
        else if (minutes < $7MMvH.minutesInDay) unit = "hour";
        else if (dstNormalizedMinutes < $7MMvH.minutesInMonth) unit = "day";
        else if (dstNormalizedMinutes < $7MMvH.minutesInYear) unit = "month";
        else unit = "year";
    } else unit = defaultUnit;
    // 0 up to 60 seconds
    if (unit === "second") {
        const seconds = roundingMethod(milliseconds / 1000);
        return locale.formatDistance("xSeconds", seconds, localizeOptions);
    // 1 up to 60 mins
    } else if (unit === "minute") {
        const roundedMinutes = roundingMethod(minutes);
        return locale.formatDistance("xMinutes", roundedMinutes, localizeOptions);
    // 1 up to 24 hours
    } else if (unit === "hour") {
        const hours = roundingMethod(minutes / 60);
        return locale.formatDistance("xHours", hours, localizeOptions);
    // 1 up to 30 days
    } else if (unit === "day") {
        const days = roundingMethod(dstNormalizedMinutes / $7MMvH.minutesInDay);
        return locale.formatDistance("xDays", days, localizeOptions);
    // 1 up to 12 months
    } else if (unit === "month") {
        const months = roundingMethod(dstNormalizedMinutes / $7MMvH.minutesInMonth);
        return months === 12 && defaultUnit !== "month" ? locale.formatDistance("xYears", 1, localizeOptions) : locale.formatDistance("xMonths", months, localizeOptions);
    // 1 year up to max Date
    } else {
        const years = roundingMethod(dstNormalizedMinutes / $7MMvH.minutesInYear);
        return locale.formatDistance("xYears", years, localizeOptions);
    }
}

});

parcelRegister("dT9KE", function(module, exports) {

$parcel$export(module.exports, "formatDistanceToNow", function () { return $a1c7f9d990e9629e$export$d130c20a256f8817; }, function (v) { return $a1c7f9d990e9629e$export$d130c20a256f8817 = v; });
var $a1c7f9d990e9629e$export$d130c20a256f8817;
"use strict";
$a1c7f9d990e9629e$export$d130c20a256f8817 = $a1c7f9d990e9629e$var$formatDistanceToNow;

var $oVfas = parcelRequire("oVfas");

var $dtOy9 = parcelRequire("dtOy9");
/**
 * The {@link formatDistanceToNow} function options.
 */ /**
 * @name formatDistanceToNow
 * @category Common Helpers
 * @summary Return the distance between the given date and now in words.
 * @pure false
 *
 * @description
 * Return the distance between the given date and now in words.
 *
 * | Distance to now                                                   | Result              |
 * |-------------------------------------------------------------------|---------------------|
 * | 0 ... 30 secs                                                     | less than a minute  |
 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
 * | N yrs ... N yrs 3 months                                          | about N years       |
 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
 *
 * With `options.includeSeconds == true`:
 * | Distance to now     | Result               |
 * |---------------------|----------------------|
 * | 0 secs ... 5 secs   | less than 5 seconds  |
 * | 5 secs ... 10 secs  | less than 10 seconds |
 * | 10 secs ... 20 secs | less than 20 seconds |
 * | 20 secs ... 40 secs | half a minute        |
 * | 40 secs ... 60 secs | less than a minute   |
 * | 60 secs ... 90 secs | 1 minute             |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - The object with options
 *
 * @returns The distance in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `options.locale` must contain `formatDistance` property
 *
 * @example
 * // If today is 1 January 2015, what is the distance to 2 July 2014?
 * const result = formatDistanceToNow(
 *   new Date(2014, 6, 2)
 * )
 * //=> '6 months'
 *
 * @example
 * // If now is 1 January 2015 00:00:00,
 * // what is the distance to 1 January 2015 00:00:15, including seconds?
 * const result = formatDistanceToNow(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   {includeSeconds: true}
 * )
 * //=> 'less than 20 seconds'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 January 2016, with a suffix?
 * const result = formatDistanceToNow(
 *   new Date(2016, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> 'in about 1 year'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 August 2016 in Esperanto?
 * const eoLocale = require('date-fns/locale/eo')
 * const result = formatDistanceToNow(
 *   new Date(2016, 7, 1),
 *   {locale: eoLocale}
 * )
 * //=> 'pli ol 1 jaro'
 */ function $a1c7f9d990e9629e$var$formatDistanceToNow(date, options) {
    return (0, $dtOy9.formatDistance)(date, (0, $oVfas.constructNow)(date), options);
}

});

parcelRegister("j2wrH", function(module, exports) {

$parcel$export(module.exports, "formatDistanceToNowStrict", function () { return $ddc75f4355d3758f$export$d0e02d4eb1ad1e32; }, function (v) { return $ddc75f4355d3758f$export$d0e02d4eb1ad1e32 = v; });
var $ddc75f4355d3758f$export$d0e02d4eb1ad1e32;
"use strict";
$ddc75f4355d3758f$export$d0e02d4eb1ad1e32 = $ddc75f4355d3758f$var$formatDistanceToNowStrict;

var $d338J = parcelRequire("d338J");

var $oVfas = parcelRequire("oVfas");
/**
 * The {@link formatDistanceToNowStrict} function options.
 */ /**
 * @name formatDistanceToNowStrict
 * @category Common Helpers
 * @summary Return the distance between the given date and now in words.
 * @pure false
 *
 * @description
 * Return the distance between the given dates in words, using strict units.
 * This is like `formatDistance`, but does not use helpers like 'almost', 'over',
 * 'less than' and the like.
 *
 * | Distance between dates | Result              |
 * |------------------------|---------------------|
 * | 0 ... 59 secs          | [0..59] seconds     |
 * | 1 ... 59 mins          | [1..59] minutes     |
 * | 1 ... 23 hrs           | [1..23] hours       |
 * | 1 ... 29 days          | [1..29] days        |
 * | 1 ... 11 months        | [1..11] months      |
 * | 1 ... N years          | [1..N]  years       |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The distance in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `options.locale` must contain `formatDistance` property
 *
 * @example
 * // If today is 1 January 2015, what is the distance to 2 July 2014?
 * const result = formatDistanceToNowStrict(
 *   new Date(2014, 6, 2)
 * )
 * //=> '6 months'
 *
 * @example
 * // If now is 1 January 2015 00:00:00,
 * // what is the distance to 1 January 2015 00:00:15, including seconds?
 * const result = formatDistanceToNowStrict(
 *   new Date(2015, 0, 1, 0, 0, 15)
 * )
 * //=> '15 seconds'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 January 2016, with a suffix?
 * const result = formatDistanceToNowStrict(
 *   new Date(2016, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> 'in 1 year'
 *
 * @example
 * // If today is 28 January 2015,
 * // what is the distance to 1 January 2015, in months, rounded up??
 * const result = formatDistanceToNowStrict(new Date(2015, 0, 1), {
 *   unit: 'month',
 *   roundingMethod: 'ceil'
 * })
 * //=> '1 month'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 January 2016 in Esperanto?
 * const eoLocale = require('date-fns/locale/eo')
 * const result = formatDistanceToNowStrict(
 *   new Date(2016, 0, 1),
 *   {locale: eoLocale}
 * )
 * //=> '1 jaro'
 */ function $ddc75f4355d3758f$var$formatDistanceToNowStrict(date, options) {
    return (0, $d338J.formatDistanceStrict)(date, (0, $oVfas.constructNow)(date), options);
}

});

parcelRegister("aQGj5", function(module, exports) {

$parcel$export(module.exports, "formatDuration", function () { return $7e5f93f254bece65$export$bc733b0c5cbb3e8a; }, function (v) { return $7e5f93f254bece65$export$bc733b0c5cbb3e8a = v; });
var $7e5f93f254bece65$export$bc733b0c5cbb3e8a;
"use strict";
$7e5f93f254bece65$export$bc733b0c5cbb3e8a = $7e5f93f254bece65$var$formatDuration;

var $lpy2g = parcelRequire("lpy2g");

var $lJvf9 = parcelRequire("lJvf9");
/**
 * The {@link formatDuration} function options.
 */ const $7e5f93f254bece65$var$defaultFormat = [
    "years",
    "months",
    "weeks",
    "days",
    "hours",
    "minutes",
    "seconds"
];
/**
 * @name formatDuration
 * @category Common Helpers
 * @summary Formats a duration in human-readable format
 *
 * @description
 * Return human-readable duration string i.e. "9 months 2 days"
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param duration - The duration to format
 * @param options - An object with options.
 *
 * @returns The formatted date string
 *
 * @example
 * // Format full duration
 * formatDuration({
 *   years: 2,
 *   months: 9,
 *   weeks: 1,
 *   days: 7,
 *   hours: 5,
 *   minutes: 9,
 *   seconds: 30
 * })
 * //=> '2 years 9 months 1 week 7 days 5 hours 9 minutes 30 seconds'
 *
 * @example
 * // Format partial duration
 * formatDuration({ months: 9, days: 2 })
 * //=> '9 months 2 days'
 *
 * @example
 * // Customize the format
 * formatDuration(
 *   {
 *     years: 2,
 *     months: 9,
 *     weeks: 1,
 *     days: 7,
 *     hours: 5,
 *     minutes: 9,
 *     seconds: 30
 *   },
 *   { format: ['months', 'weeks'] }
 * ) === '9 months 1 week'
 *
 * @example
 * // Customize the zeros presence
 * formatDuration({ years: 0, months: 9 })
 * //=> '9 months'
 * formatDuration({ years: 0, months: 9 }, { zero: true })
 * //=> '0 years 9 months'
 *
 * @example
 * // Customize the delimiter
 * formatDuration({ years: 2, months: 9, weeks: 3 }, { delimiter: ', ' })
 * //=> '2 years, 9 months, 3 weeks'
 */ function $7e5f93f254bece65$var$formatDuration(duration, options) {
    const defaultOptions = (0, $lJvf9.getDefaultOptions)();
    const locale = options?.locale ?? defaultOptions.locale ?? $lpy2g.defaultLocale;
    const format = options?.format ?? $7e5f93f254bece65$var$defaultFormat;
    const zero = options?.zero ?? false;
    const delimiter = options?.delimiter ?? " ";
    if (!locale.formatDistance) return "";
    const result = format.reduce((acc, unit)=>{
        const token = `x${unit.replace(/(^.)/, (m)=>m.toUpperCase())}`;
        const value = duration[unit];
        if (value !== undefined && (zero || duration[unit])) return acc.concat(locale.formatDistance(token, value));
        return acc;
    }, []).join(delimiter);
    return result;
}

});

parcelRegister("b9Nks", function(module, exports) {

$parcel$export(module.exports, "formatISO", function () { return $81f6cca6d3528d30$export$3c826ac3ab9da76c; }, function (v) { return $81f6cca6d3528d30$export$3c826ac3ab9da76c = v; });
var $81f6cca6d3528d30$export$3c826ac3ab9da76c;
"use strict";
$81f6cca6d3528d30$export$3c826ac3ab9da76c = $81f6cca6d3528d30$var$formatISO;

var $b3MCU = parcelRequire("b3MCU");

var $5F97c = parcelRequire("5F97c");
/**
 * The {@link formatISO} function options.
 */ /**
 * @name formatISO
 * @category Common Helpers
 * @summary Format the date according to the ISO 8601 standard (https://support.sas.com/documentation/cdl/en/lrdict/64316/HTML/default/viewer.htm#a003169814.htm).
 *
 * @description
 * Return the formatted date string in ISO 8601 format. Options may be passed to control the parts and notations of the date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options.
 *
 * @returns The formatted date string (in loca.l time zone)
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601 format (local time zone is UTC):
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52))
 * //=> '2019-09-18T19:00:52Z'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601, short format (local time zone is UTC):
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { format: 'basic' })
 * //=> '20190918T190052'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601 format, date only:
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { representation: 'date' })
 * //=> '2019-09-18'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601 format, time only (local time zone is UTC):
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { representation: 'time' })
 * //=> '19:00:52Z'
 */ function $81f6cca6d3528d30$var$formatISO(date, options) {
    const _date = (0, $b3MCU.toDate)(date);
    if (isNaN(_date.getTime())) throw new RangeError("Invalid time value");
    const format = options?.format ?? "extended";
    const representation = options?.representation ?? "complete";
    let result = "";
    let tzOffset = "";
    const dateDelimiter = format === "extended" ? "-" : "";
    const timeDelimiter = format === "extended" ? ":" : "";
    // Representation is either 'date' or 'complete'
    if (representation !== "time") {
        const day = (0, $5F97c.addLeadingZeros)(_date.getDate(), 2);
        const month = (0, $5F97c.addLeadingZeros)(_date.getMonth() + 1, 2);
        const year = (0, $5F97c.addLeadingZeros)(_date.getFullYear(), 4);
        // yyyyMMdd or yyyy-MM-dd.
        result = `${year}${dateDelimiter}${month}${dateDelimiter}${day}`;
    }
    // Representation is either 'time' or 'complete'
    if (representation !== "date") {
        // Add the timezone.
        const offset = _date.getTimezoneOffset();
        if (offset !== 0) {
            const absoluteOffset = Math.abs(offset);
            const hourOffset = (0, $5F97c.addLeadingZeros)(Math.trunc(absoluteOffset / 60), 2);
            const minuteOffset = (0, $5F97c.addLeadingZeros)(absoluteOffset % 60, 2);
            // If less than 0, the sign is +, because it is ahead of time.
            const sign = offset < 0 ? "+" : "-";
            tzOffset = `${sign}${hourOffset}:${minuteOffset}`;
        } else tzOffset = "Z";
        const hour = (0, $5F97c.addLeadingZeros)(_date.getHours(), 2);
        const minute = (0, $5F97c.addLeadingZeros)(_date.getMinutes(), 2);
        const second = (0, $5F97c.addLeadingZeros)(_date.getSeconds(), 2);
        // If there's also date, separate it with time with 'T'
        const separator = result === "" ? "" : "T";
        // Creates a time string consisting of hour, minute, and second, separated by delimiters, if defined.
        const time = [
            hour,
            minute,
            second
        ].join(timeDelimiter);
        // HHmmss or HH:mm:ss.
        result = `${result}${separator}${time}${tzOffset}`;
    }
    return result;
}

});

parcelRegister("450S4", function(module, exports) {

$parcel$export(module.exports, "formatISO9075", function () { return $2f884e07ceaab6d9$export$a673944250043fa4; }, function (v) { return $2f884e07ceaab6d9$export$a673944250043fa4 = v; });
var $2f884e07ceaab6d9$export$a673944250043fa4;
"use strict";
$2f884e07ceaab6d9$export$a673944250043fa4 = $2f884e07ceaab6d9$var$formatISO9075;

var $cmplH = parcelRequire("cmplH");

var $b3MCU = parcelRequire("b3MCU");

var $5F97c = parcelRequire("5F97c");
/**
 * The {@link formatISO9075} function options.
 */ /**
 * @name formatISO9075
 * @category Common Helpers
 * @summary Format the date according to the ISO 9075 standard (https://dev.mysql.com/doc/refman/5.7/en/date-and-time-functions.html#function_get-format).
 *
 * @description
 * Return the formatted date string in ISO 9075 format. Options may be passed to control the parts and notations of the date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options.
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 18 September 2019 in ISO 9075 format:
 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52))
 * //=> '2019-09-18 19:00:52'
 *
 * @example
 * // Represent 18 September 2019 in ISO 9075, short format:
 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { format: 'basic' })
 * //=> '20190918 190052'
 *
 * @example
 * // Represent 18 September 2019 in ISO 9075 format, date only:
 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { representation: 'date' })
 * //=> '2019-09-18'
 *
 * @example
 * // Represent 18 September 2019 in ISO 9075 format, time only:
 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { representation: 'time' })
 * //=> '19:00:52'
 */ function $2f884e07ceaab6d9$var$formatISO9075(date, options) {
    const _date = (0, $b3MCU.toDate)(date);
    if (!(0, $cmplH.isValid)(_date)) throw new RangeError("Invalid time value");
    const format = options?.format ?? "extended";
    const representation = options?.representation ?? "complete";
    let result = "";
    const dateDelimiter = format === "extended" ? "-" : "";
    const timeDelimiter = format === "extended" ? ":" : "";
    // Representation is either 'date' or 'complete'
    if (representation !== "time") {
        const day = (0, $5F97c.addLeadingZeros)(_date.getDate(), 2);
        const month = (0, $5F97c.addLeadingZeros)(_date.getMonth() + 1, 2);
        const year = (0, $5F97c.addLeadingZeros)(_date.getFullYear(), 4);
        // yyyyMMdd or yyyy-MM-dd.
        result = `${year}${dateDelimiter}${month}${dateDelimiter}${day}`;
    }
    // Representation is either 'time' or 'complete'
    if (representation !== "date") {
        const hour = (0, $5F97c.addLeadingZeros)(_date.getHours(), 2);
        const minute = (0, $5F97c.addLeadingZeros)(_date.getMinutes(), 2);
        const second = (0, $5F97c.addLeadingZeros)(_date.getSeconds(), 2);
        // If there's also date, separate it with time with a space
        const separator = result === "" ? "" : " ";
        // HHmmss or HH:mm:ss.
        result = `${result}${separator}${hour}${timeDelimiter}${minute}${timeDelimiter}${second}`;
    }
    return result;
}

});

parcelRegister("eEnm8", function(module, exports) {

$parcel$export(module.exports, "formatISODuration", function () { return $aaa6eb24f945e043$export$437c31ab743f6b26; }, function (v) { return $aaa6eb24f945e043$export$437c31ab743f6b26 = v; });
var $aaa6eb24f945e043$export$437c31ab743f6b26;
"use strict";
$aaa6eb24f945e043$export$437c31ab743f6b26 = $aaa6eb24f945e043$var$formatISODuration;
/**
 * @name formatISODuration
 * @category Common Helpers
 * @summary Format a duration object according as ISO 8601 duration string
 *
 * @description
 * Format a duration object according to the ISO 8601 duration standard (https://www.digi.com/resources/documentation/digidocs//90001488-13/reference/r_iso_8601_duration_format.htm)
 *
 * @param duration - The duration to format
 *
 * @returns The ISO 8601 duration string
 *
 * @example
 * // Format the given duration as ISO 8601 string
 * const result = formatISODuration({
 *   years: 39,
 *   months: 2,
 *   days: 20,
 *   hours: 7,
 *   minutes: 5,
 *   seconds: 0
 * })
 * //=> 'P39Y2M20DT0H0M0S'
 */ function $aaa6eb24f945e043$var$formatISODuration(duration) {
    const { years: years = 0, months: months = 0, days: days = 0, hours: hours = 0, minutes: minutes = 0, seconds: seconds = 0 } = duration;
    return `P${years}Y${months}M${days}DT${hours}H${minutes}M${seconds}S`;
}

});

parcelRegister("f41HL", function(module, exports) {

$parcel$export(module.exports, "formatRFC3339", function () { return $af788d446d97a382$export$6d441bffeec6bd6c; }, function (v) { return $af788d446d97a382$export$6d441bffeec6bd6c = v; });
var $af788d446d97a382$export$6d441bffeec6bd6c;
"use strict";
$af788d446d97a382$export$6d441bffeec6bd6c = $af788d446d97a382$var$formatRFC3339;

var $cmplH = parcelRequire("cmplH");

var $b3MCU = parcelRequire("b3MCU");

var $5F97c = parcelRequire("5F97c");
/**
 * The {@link formatRFC3339} function options.
 */ /**
 * @name formatRFC3339
 * @category Common Helpers
 * @summary Format the date according to the RFC 3339 standard (https://tools.ietf.org/html/rfc3339#section-5.6).
 *
 * @description
 * Return the formatted date string in RFC 3339 format. Options may be passed to control the parts and notations of the date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options.
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 18 September 2019 in RFC 3339 format:
 * formatRFC3339(new Date(2019, 8, 18, 19, 0, 52))
 * //=> '2019-09-18T19:00:52Z'
 *
 * @example
 * // Represent 18 September 2019 in RFC 3339 format, 3 digits of second fraction
 * formatRFC3339(new Date(2019, 8, 18, 19, 0, 52, 234), {
 *   fractionDigits: 3
 * })
 * //=> '2019-09-18T19:00:52.234Z'
 */ function $af788d446d97a382$var$formatRFC3339(date, options) {
    const _date = (0, $b3MCU.toDate)(date);
    if (!(0, $cmplH.isValid)(_date)) throw new RangeError("Invalid time value");
    const fractionDigits = options?.fractionDigits ?? 0;
    const day = (0, $5F97c.addLeadingZeros)(_date.getDate(), 2);
    const month = (0, $5F97c.addLeadingZeros)(_date.getMonth() + 1, 2);
    const year = _date.getFullYear();
    const hour = (0, $5F97c.addLeadingZeros)(_date.getHours(), 2);
    const minute = (0, $5F97c.addLeadingZeros)(_date.getMinutes(), 2);
    const second = (0, $5F97c.addLeadingZeros)(_date.getSeconds(), 2);
    let fractionalSecond = "";
    if (fractionDigits > 0) {
        const milliseconds = _date.getMilliseconds();
        const fractionalSeconds = Math.trunc(milliseconds * Math.pow(10, fractionDigits - 3));
        fractionalSecond = "." + (0, $5F97c.addLeadingZeros)(fractionalSeconds, fractionDigits);
    }
    let offset = "";
    const tzOffset = _date.getTimezoneOffset();
    if (tzOffset !== 0) {
        const absoluteOffset = Math.abs(tzOffset);
        const hourOffset = (0, $5F97c.addLeadingZeros)(Math.trunc(absoluteOffset / 60), 2);
        const minuteOffset = (0, $5F97c.addLeadingZeros)(absoluteOffset % 60, 2);
        // If less than 0, the sign is +, because it is ahead of time.
        const sign = tzOffset < 0 ? "+" : "-";
        offset = `${sign}${hourOffset}:${minuteOffset}`;
    } else offset = "Z";
    return `${year}-${month}-${day}T${hour}:${minute}:${second}${fractionalSecond}${offset}`;
}

});

parcelRegister("fIylp", function(module, exports) {

$parcel$export(module.exports, "formatRFC7231", function () { return $b7159b22f4824809$export$7add2e4539ce658a; }, function (v) { return $b7159b22f4824809$export$7add2e4539ce658a = v; });
var $b7159b22f4824809$export$7add2e4539ce658a;
"use strict";
$b7159b22f4824809$export$7add2e4539ce658a = $b7159b22f4824809$var$formatRFC7231;

var $cmplH = parcelRequire("cmplH");

var $b3MCU = parcelRequire("b3MCU");

var $5F97c = parcelRequire("5F97c");
const $b7159b22f4824809$var$days = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat"
];
const $b7159b22f4824809$var$months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
/**
 * @name formatRFC7231
 * @category Common Helpers
 * @summary Format the date according to the RFC 7231 standard (https://tools.ietf.org/html/rfc7231#section-7.1.1.1).
 *
 * @description
 * Return the formatted date string in RFC 7231 format.
 * The result will always be in UTC timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 18 September 2019 in RFC 7231 format:
 * const result = formatRFC7231(new Date(2019, 8, 18, 19, 0, 52))
 * //=> 'Wed, 18 Sep 2019 19:00:52 GMT'
 */ function $b7159b22f4824809$var$formatRFC7231(date) {
    const _date = (0, $b3MCU.toDate)(date);
    if (!(0, $cmplH.isValid)(_date)) throw new RangeError("Invalid time value");
    const dayName = $b7159b22f4824809$var$days[_date.getUTCDay()];
    const dayOfMonth = (0, $5F97c.addLeadingZeros)(_date.getUTCDate(), 2);
    const monthName = $b7159b22f4824809$var$months[_date.getUTCMonth()];
    const year = _date.getUTCFullYear();
    const hour = (0, $5F97c.addLeadingZeros)(_date.getUTCHours(), 2);
    const minute = (0, $5F97c.addLeadingZeros)(_date.getUTCMinutes(), 2);
    const second = (0, $5F97c.addLeadingZeros)(_date.getUTCSeconds(), 2);
    // Result variables.
    return `${dayName}, ${dayOfMonth} ${monthName} ${year} ${hour}:${minute}:${second} GMT`;
}

});

parcelRegister("iKKb4", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $da7057cb2fd2065b$export$8fbbfd65594f46a0; }, function (v) { return $da7057cb2fd2065b$export$8fbbfd65594f46a0 = v; });
var $da7057cb2fd2065b$export$8fbbfd65594f46a0;
"use strict";
$da7057cb2fd2065b$export$8fbbfd65594f46a0 = $da7057cb2fd2065b$var$formatRelative;

var $fctE0 = parcelRequire("fctE0");

var $9YOIL = parcelRequire("9YOIL");

var $b3MCU = parcelRequire("b3MCU");

var $lpy2g = parcelRequire("lpy2g");

var $lJvf9 = parcelRequire("lJvf9");
/**
 * The {@link formatRelative} function options.
 */ /**
 * @name formatRelative
 * @category Common Helpers
 * @summary Represent the date in words relative to the given base date.
 *
 * @description
 * Represent the date in words relative to the given base date.
 *
 * | Distance to the base date | Result                    |
 * |---------------------------|---------------------------|
 * | Previous 6 days           | last Sunday at 04:30 AM   |
 * | Last day                  | yesterday at 04:30 AM     |
 * | Same day                  | today at 04:30 AM         |
 * | Next day                  | tomorrow at 04:30 AM      |
 * | Next 6 days               | Sunday at 04:30 AM        |
 * | Other                     | 12/31/2017                |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 * @param baseDate - The date to compare with
 * @param options - An object with options
 *
 * @returns The date in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `baseDate` must not be Invalid Date
 * @throws `options.locale` must contain `localize` property
 * @throws `options.locale` must contain `formatLong` property
 * @throws `options.locale` must contain `formatRelative` property
 *
 * @example
 * // Represent the date of 6 days ago in words relative to the given base date. In this example, today is Wednesday
 * const result = formatRelative(subDays(new Date(), 6), new Date())
 * //=> "last Thursday at 12:45 AM"
 */ function $da7057cb2fd2065b$var$formatRelative(date, baseDate, options) {
    const _date = (0, $b3MCU.toDate)(date);
    const _baseDate = (0, $b3MCU.toDate)(baseDate);
    const defaultOptions = (0, $lJvf9.getDefaultOptions)();
    const locale = options?.locale ?? defaultOptions.locale ?? $lpy2g.defaultLocale;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const diff = (0, $fctE0.differenceInCalendarDays)(_date, _baseDate);
    if (isNaN(diff)) throw new RangeError("Invalid time value");
    let token;
    if (diff < -6) token = "other";
    else if (diff < -1) token = "lastWeek";
    else if (diff < 0) token = "yesterday";
    else if (diff < 1) token = "today";
    else if (diff < 2) token = "tomorrow";
    else if (diff < 7) token = "nextWeek";
    else token = "other";
    const formatStr = locale.formatRelative(token, _date, _baseDate, {
        locale: locale,
        weekStartsOn: weekStartsOn
    });
    return (0, $9YOIL.format)(_date, formatStr, {
        locale: locale,
        weekStartsOn: weekStartsOn
    });
}

});

parcelRegister("bbwBU", function(module, exports) {

$parcel$export(module.exports, "fromUnixTime", function () { return $824a048ded1702b5$export$3664df8597731ed4; }, function (v) { return $824a048ded1702b5$export$3664df8597731ed4 = v; });
var $824a048ded1702b5$export$3664df8597731ed4;
"use strict";
$824a048ded1702b5$export$3664df8597731ed4 = $824a048ded1702b5$var$fromUnixTime;

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name fromUnixTime
 * @category Timestamp Helpers
 * @summary Create a date from a Unix timestamp.
 *
 * @description
 * Create a date from a Unix timestamp (in seconds). Decimal values will be discarded.
 *
 * @param unixTime - The given Unix timestamp (in seconds)
 *
 * @returns The date
 *
 * @example
 * // Create the date 29 February 2012 11:45:05:
 * const result = fromUnixTime(1330515905)
 * //=> Wed Feb 29 2012 11:45:05
 */ function $824a048ded1702b5$var$fromUnixTime(unixTime) {
    return (0, $b3MCU.toDate)(unixTime * 1000);
}

});

parcelRegister("egMd8", function(module, exports) {

$parcel$export(module.exports, "getDate", function () { return $a637f4fcfde32446$export$aa350b96d91cd94; }, function (v) { return $a637f4fcfde32446$export$aa350b96d91cd94 = v; });
var $a637f4fcfde32446$export$aa350b96d91cd94;
"use strict";
$a637f4fcfde32446$export$aa350b96d91cd94 = $a637f4fcfde32446$var$getDate;

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name getDate
 * @category Day Helpers
 * @summary Get the day of the month of the given date.
 *
 * @description
 * Get the day of the month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of month
 *
 * @example
 * // Which day of the month is 29 February 2012?
 * const result = getDate(new Date(2012, 1, 29))
 * //=> 29
 */ function $a637f4fcfde32446$var$getDate(date) {
    const _date = (0, $b3MCU.toDate)(date);
    const dayOfMonth = _date.getDate();
    return dayOfMonth;
}

});

parcelRegister("kvN19", function(module, exports) {

$parcel$export(module.exports, "getDay", function () { return $eeecb9beb10bc6e3$export$1b64bc9c5306ed54; }, function (v) { return $eeecb9beb10bc6e3$export$1b64bc9c5306ed54 = v; });
var $eeecb9beb10bc6e3$export$1b64bc9c5306ed54;
"use strict";
$eeecb9beb10bc6e3$export$1b64bc9c5306ed54 = $eeecb9beb10bc6e3$var$getDay;

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name getDay
 * @category Weekday Helpers
 * @summary Get the day of the week of the given date.
 *
 * @description
 * Get the day of the week of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of week, 0 represents Sunday
 *
 * @example
 * // Which day of the week is 29 February 2012?
 * const result = getDay(new Date(2012, 1, 29))
 * //=> 3
 */ function $eeecb9beb10bc6e3$var$getDay(date) {
    const _date = (0, $b3MCU.toDate)(date);
    const day = _date.getDay();
    return day;
}

});

parcelRegister("9HF9I", function(module, exports) {

$parcel$export(module.exports, "getDaysInMonth", function () { return $71080de093f861d9$export$f645ddd439eb259d; }, function (v) { return $71080de093f861d9$export$f645ddd439eb259d = v; });
var $71080de093f861d9$export$f645ddd439eb259d;
"use strict";
$71080de093f861d9$export$f645ddd439eb259d = $71080de093f861d9$var$getDaysInMonth;

var $b3MCU = parcelRequire("b3MCU");

var $02yAu = parcelRequire("02yAu");
/**
 * @name getDaysInMonth
 * @category Month Helpers
 * @summary Get the number of days in a month of the given date.
 *
 * @description
 * Get the number of days in a month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The number of days in a month
 *
 * @example
 * // How many days are in February 2000?
 * const result = getDaysInMonth(new Date(2000, 1))
 * //=> 29
 */ function $71080de093f861d9$var$getDaysInMonth(date) {
    const _date = (0, $b3MCU.toDate)(date);
    const year = _date.getFullYear();
    const monthIndex = _date.getMonth();
    const lastDayOfMonth = (0, $02yAu.constructFrom)(date, 0);
    lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
    lastDayOfMonth.setHours(0, 0, 0, 0);
    return lastDayOfMonth.getDate();
}

});

parcelRegister("1jHsG", function(module, exports) {

$parcel$export(module.exports, "getDaysInYear", function () { return $0f59475ef87ea442$export$63a4a9fc49e3550e; }, function (v) { return $0f59475ef87ea442$export$63a4a9fc49e3550e = v; });
var $0f59475ef87ea442$export$63a4a9fc49e3550e;
"use strict";
$0f59475ef87ea442$export$63a4a9fc49e3550e = $0f59475ef87ea442$var$getDaysInYear;

var $eZ7WM = parcelRequire("eZ7WM");

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name getDaysInYear
 * @category Year Helpers
 * @summary Get the number of days in a year of the given date.
 *
 * @description
 * Get the number of days in a year of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The number of days in a year
 *
 * @example
 * // How many days are in 2012?
 * const result = getDaysInYear(new Date(2012, 0, 1))
 * //=> 366
 */ function $0f59475ef87ea442$var$getDaysInYear(date) {
    const _date = (0, $b3MCU.toDate)(date);
    if (String(new Date(_date)) === "Invalid Date") return NaN;
    return (0, $eZ7WM.isLeapYear)(_date) ? 366 : 365;
}

});
parcelRegister("eZ7WM", function(module, exports) {

$parcel$export(module.exports, "isLeapYear", function () { return $ae8ced516b11b0fe$export$553d7fa8e3805fc0; }, function (v) { return $ae8ced516b11b0fe$export$553d7fa8e3805fc0 = v; });
var $ae8ced516b11b0fe$export$553d7fa8e3805fc0;
"use strict";
$ae8ced516b11b0fe$export$553d7fa8e3805fc0 = $ae8ced516b11b0fe$var$isLeapYear;

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name isLeapYear
 * @category Year Helpers
 * @summary Is the given date in the leap year?
 *
 * @description
 * Is the given date in the leap year?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in the leap year
 *
 * @example
 * // Is 1 September 2012 in the leap year?
 * const result = isLeapYear(new Date(2012, 8, 1))
 * //=> true
 */ function $ae8ced516b11b0fe$var$isLeapYear(date) {
    const _date = (0, $b3MCU.toDate)(date);
    const year = _date.getFullYear();
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

});


parcelRegister("g4Yc6", function(module, exports) {

$parcel$export(module.exports, "getDecade", function () { return $bb4bb65af74b0aa7$export$5bc0f4decfc52b64; }, function (v) { return $bb4bb65af74b0aa7$export$5bc0f4decfc52b64 = v; });
var $bb4bb65af74b0aa7$export$5bc0f4decfc52b64;
"use strict";
$bb4bb65af74b0aa7$export$5bc0f4decfc52b64 = $bb4bb65af74b0aa7$var$getDecade;

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name getDecade
 * @category Decade Helpers
 * @summary Get the decade of the given date.
 *
 * @description
 * Get the decade of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The year of decade
 *
 * @example
 * // Which decade belongs 27 November 1942?
 * const result = getDecade(new Date(1942, 10, 27))
 * //=> 1940
 */ function $bb4bb65af74b0aa7$var$getDecade(date) {
    // TODO: Switch to more technical definition in of decades that start with 1
    // end with 0. I.e. 2001-2010 instead of current 2000-2009. It's a breaking
    // change, so it can only be done in 4.0.
    const _date = (0, $b3MCU.toDate)(date);
    const year = _date.getFullYear();
    const decade = Math.floor(year / 10) * 10;
    return decade;
}

});

parcelRegister("vaZLu", function(module, exports) {

$parcel$export(module.exports, "getDefaultOptions", function () { return $05db6cc8c841087b$export$430a3269e24b912e; }, function (v) { return $05db6cc8c841087b$export$430a3269e24b912e = v; });
var $05db6cc8c841087b$export$430a3269e24b912e;
"use strict";
$05db6cc8c841087b$export$430a3269e24b912e = $05db6cc8c841087b$var$getDefaultOptions;

var $lJvf9 = parcelRequire("lJvf9");
/**
 * @name getDefaultOptions
 * @category Common Helpers
 * @summary Get default options.
 * @pure false
 *
 * @description
 * Returns an object that contains defaults for
 * `options.locale`, `options.weekStartsOn` and `options.firstWeekContainsDate`
 * arguments for all functions.
 *
 * You can change these with [setDefaultOptions](https://date-fns.org/docs/setDefaultOptions).
 *
 * @returns The default options
 *
 * @example
 * const result = getDefaultOptions()
 * //=> {}
 *
 * @example
 * setDefaultOptions({ weekStarsOn: 1, firstWeekContainsDate: 4 })
 * const result = getDefaultOptions()
 * //=> { weekStarsOn: 1, firstWeekContainsDate: 4 }
 */ function $05db6cc8c841087b$var$getDefaultOptions() {
    return Object.assign({}, (0, $lJvf9.getDefaultOptions)());
}

});

parcelRegister("7mqxe", function(module, exports) {

$parcel$export(module.exports, "getHours", function () { return $55bf2bcbc2c93700$export$257b40f71c07d58f; }, function (v) { return $55bf2bcbc2c93700$export$257b40f71c07d58f = v; });
var $55bf2bcbc2c93700$export$257b40f71c07d58f;
"use strict";
$55bf2bcbc2c93700$export$257b40f71c07d58f = $55bf2bcbc2c93700$var$getHours;

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name getHours
 * @category Hour Helpers
 * @summary Get the hours of the given date.
 *
 * @description
 * Get the hours of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The hours
 *
 * @example
 * // Get the hours of 29 February 2012 11:45:00:
 * const result = getHours(new Date(2012, 1, 29, 11, 45))
 * //=> 11
 */ function $55bf2bcbc2c93700$var$getHours(date) {
    const _date = (0, $b3MCU.toDate)(date);
    const hours = _date.getHours();
    return hours;
}

});

parcelRegister("i19EH", function(module, exports) {

$parcel$export(module.exports, "getISODay", function () { return $d1dfcf5d49e2d630$export$c514f4c1a8ed5e9e; }, function (v) { return $d1dfcf5d49e2d630$export$c514f4c1a8ed5e9e = v; });
var $d1dfcf5d49e2d630$export$c514f4c1a8ed5e9e;
"use strict";
$d1dfcf5d49e2d630$export$c514f4c1a8ed5e9e = $d1dfcf5d49e2d630$var$getISODay;

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name getISODay
 * @category Weekday Helpers
 * @summary Get the day of the ISO week of the given date.
 *
 * @description
 * Get the day of the ISO week of the given date,
 * which is 7 for Sunday, 1 for Monday etc.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of ISO week
 *
 * @example
 * // Which day of the ISO week is 26 February 2012?
 * const result = getISODay(new Date(2012, 1, 26))
 * //=> 7
 */ function $d1dfcf5d49e2d630$var$getISODay(date) {
    const _date = (0, $b3MCU.toDate)(date);
    let day = _date.getDay();
    if (day === 0) day = 7;
    return day;
}

});

parcelRegister("hKW5C", function(module, exports) {

$parcel$export(module.exports, "getISOWeeksInYear", function () { return $ced3caeb8739a2ba$export$822983242a16750f; }, function (v) { return $ced3caeb8739a2ba$export$822983242a16750f = v; });
var $ced3caeb8739a2ba$export$822983242a16750f;
"use strict";
$ced3caeb8739a2ba$export$822983242a16750f = $ced3caeb8739a2ba$var$getISOWeeksInYear;

var $iiBmk = parcelRequire("iiBmk");

var $7MMvH = parcelRequire("7MMvH");

var $f44li = parcelRequire("f44li");
/**
 * @name getISOWeeksInYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of weeks in an ISO week-numbering year of the given date.
 *
 * @description
 * Get the number of weeks in an ISO week-numbering year of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The number of ISO weeks in a year
 *
 * @example
 * // How many weeks are in ISO week-numbering year 2015?
 * const result = getISOWeeksInYear(new Date(2015, 1, 11))
 * //=> 53
 */ function $ced3caeb8739a2ba$var$getISOWeeksInYear(date) {
    const thisYear = (0, $f44li.startOfISOWeekYear)(date);
    const nextYear = (0, $f44li.startOfISOWeekYear)((0, $iiBmk.addWeeks)(thisYear, 60));
    const diff = +nextYear - +thisYear;
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / $7MMvH.millisecondsInWeek);
}

});

parcelRegister("hypv5", function(module, exports) {

$parcel$export(module.exports, "getMilliseconds", function () { return $cc79647f9b67a4b2$export$b8e4380f312797af; }, function (v) { return $cc79647f9b67a4b2$export$b8e4380f312797af = v; });
var $cc79647f9b67a4b2$export$b8e4380f312797af;
"use strict";
$cc79647f9b67a4b2$export$b8e4380f312797af = $cc79647f9b67a4b2$var$getMilliseconds;

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name getMilliseconds
 * @category Millisecond Helpers
 * @summary Get the milliseconds of the given date.
 *
 * @description
 * Get the milliseconds of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The milliseconds
 *
 * @example
 * // Get the milliseconds of 29 February 2012 11:45:05.123:
 * const result = getMilliseconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 123
 */ function $cc79647f9b67a4b2$var$getMilliseconds(date) {
    const _date = (0, $b3MCU.toDate)(date);
    const milliseconds = _date.getMilliseconds();
    return milliseconds;
}

});

parcelRegister("dJJxk", function(module, exports) {

$parcel$export(module.exports, "getMinutes", function () { return $a002cceb9ad5f434$export$b7f1bc3ea3ac4145; }, function (v) { return $a002cceb9ad5f434$export$b7f1bc3ea3ac4145 = v; });
var $a002cceb9ad5f434$export$b7f1bc3ea3ac4145;
"use strict";
$a002cceb9ad5f434$export$b7f1bc3ea3ac4145 = $a002cceb9ad5f434$var$getMinutes;

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name getMinutes
 * @category Minute Helpers
 * @summary Get the minutes of the given date.
 *
 * @description
 * Get the minutes of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The minutes
 *
 * @example
 * // Get the minutes of 29 February 2012 11:45:05:
 * const result = getMinutes(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 45
 */ function $a002cceb9ad5f434$var$getMinutes(date) {
    const _date = (0, $b3MCU.toDate)(date);
    const minutes = _date.getMinutes();
    return minutes;
}

});

parcelRegister("96SbU", function(module, exports) {

$parcel$export(module.exports, "getMonth", function () { return $6a1eb5d536c1b166$export$6ce1b5acc29cb53b; }, function (v) { return $6a1eb5d536c1b166$export$6ce1b5acc29cb53b = v; });
var $6a1eb5d536c1b166$export$6ce1b5acc29cb53b;
"use strict";
$6a1eb5d536c1b166$export$6ce1b5acc29cb53b = $6a1eb5d536c1b166$var$getMonth;

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name getMonth
 * @category Month Helpers
 * @summary Get the month of the given date.
 *
 * @description
 * Get the month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The month index (0-11)
 *
 * @example
 * // Which month is 29 February 2012?
 * const result = getMonth(new Date(2012, 1, 29))
 * //=> 1
 */ function $6a1eb5d536c1b166$var$getMonth(date) {
    const _date = (0, $b3MCU.toDate)(date);
    const month = _date.getMonth();
    return month;
}

});

parcelRegister("aSryK", function(module, exports) {

$parcel$export(module.exports, "getOverlappingDaysInIntervals", function () { return $7eb4534907cdfde3$export$baae148532bd1d46; }, function (v) { return $7eb4534907cdfde3$export$baae148532bd1d46 = v; });
var $7eb4534907cdfde3$export$baae148532bd1d46;
"use strict";
$7eb4534907cdfde3$export$baae148532bd1d46 = $7eb4534907cdfde3$var$getOverlappingDaysInIntervals;

var $izS8L = parcelRequire("izS8L");

var $7MMvH = parcelRequire("7MMvH");

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name getOverlappingDaysInIntervals
 * @category Interval Helpers
 * @summary Get the number of days that overlap in two time intervals
 *
 * @description
 * Get the number of days that overlap in two time intervals. It uses the time
 * between dates to calculate the number of days, rounding it up to include
 * partial days.
 *
 * Two equal 0-length intervals will result in 0. Two equal 1ms intervals will
 * result in 1.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param intervalLeft - The first interval to compare.
 * @param intervalRight - The second interval to compare.
 *
 * @returns The number of days that overlap in two time intervals
 *
 * @example
 * // For overlapping time intervals adds 1 for each started overlapping day:
 * getOverlappingDaysInIntervals(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 17), end: new Date(2014, 0, 21) }
 * )
 * //=> 3
 *
 * @example
 * // For non-overlapping time intervals returns 0:
 * getOverlappingDaysInIntervals(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 21), end: new Date(2014, 0, 22) }
 * )
 * //=> 0
 */ function $7eb4534907cdfde3$var$getOverlappingDaysInIntervals(intervalLeft, intervalRight) {
    const [leftStart, leftEnd] = [
        +(0, $b3MCU.toDate)(intervalLeft.start),
        +(0, $b3MCU.toDate)(intervalLeft.end)
    ].sort((a, b)=>a - b);
    const [rightStart, rightEnd] = [
        +(0, $b3MCU.toDate)(intervalRight.start),
        +(0, $b3MCU.toDate)(intervalRight.end)
    ].sort((a, b)=>a - b);
    // Prevent NaN result if intervals don't overlap at all.
    const isOverlapping = leftStart < rightEnd && rightStart < leftEnd;
    if (!isOverlapping) return 0;
    // Remove the timezone offset to negate the DST effect on calculations.
    const overlapLeft = rightStart < leftStart ? leftStart : rightStart;
    const left = overlapLeft - (0, $izS8L.getTimezoneOffsetInMilliseconds)(overlapLeft);
    const overlapRight = rightEnd > leftEnd ? leftEnd : rightEnd;
    const right = overlapRight - (0, $izS8L.getTimezoneOffsetInMilliseconds)(overlapRight);
    // Ceil the number to include partial days too.
    return Math.ceil((right - left) / $7MMvH.millisecondsInDay);
}

});

parcelRegister("9l3oy", function(module, exports) {

$parcel$export(module.exports, "getSeconds", function () { return $6cc8b561c1d52342$export$5e9417507ff28427; }, function (v) { return $6cc8b561c1d52342$export$5e9417507ff28427 = v; });
var $6cc8b561c1d52342$export$5e9417507ff28427;
"use strict";
$6cc8b561c1d52342$export$5e9417507ff28427 = $6cc8b561c1d52342$var$getSeconds;

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name getSeconds
 * @category Second Helpers
 * @summary Get the seconds of the given date.
 *
 * @description
 * Get the seconds of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The seconds
 *
 * @example
 * // Get the seconds of 29 February 2012 11:45:05.123:
 * const result = getSeconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 5
 */ function $6cc8b561c1d52342$var$getSeconds(date) {
    const _date = (0, $b3MCU.toDate)(date);
    const seconds = _date.getSeconds();
    return seconds;
}

});

parcelRegister("dEs1B", function(module, exports) {

$parcel$export(module.exports, "getTime", function () { return $9f04bff6a6796568$export$1428f42a7de81803; }, function (v) { return $9f04bff6a6796568$export$1428f42a7de81803 = v; });
var $9f04bff6a6796568$export$1428f42a7de81803;
"use strict";
$9f04bff6a6796568$export$1428f42a7de81803 = $9f04bff6a6796568$var$getTime;

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name getTime
 * @category Timestamp Helpers
 * @summary Get the milliseconds timestamp of the given date.
 *
 * @description
 * Get the milliseconds timestamp of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The timestamp
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05.123:
 * const result = getTime(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 1330515905123
 */ function $9f04bff6a6796568$var$getTime(date) {
    const _date = (0, $b3MCU.toDate)(date);
    const timestamp = _date.getTime();
    return timestamp;
}

});

parcelRegister("h65sp", function(module, exports) {

$parcel$export(module.exports, "getUnixTime", function () { return $c7273aeb5bfee89e$export$1f77c0008d16313; }, function (v) { return $c7273aeb5bfee89e$export$1f77c0008d16313 = v; });
var $c7273aeb5bfee89e$export$1f77c0008d16313;
"use strict";
$c7273aeb5bfee89e$export$1f77c0008d16313 = $c7273aeb5bfee89e$var$getUnixTime;

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name getUnixTime
 * @category Timestamp Helpers
 * @summary Get the seconds timestamp of the given date.
 *
 * @description
 * Get the seconds timestamp of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The timestamp
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05 CET:
 * const result = getUnixTime(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 1330512305
 */ function $c7273aeb5bfee89e$var$getUnixTime(date) {
    return Math.trunc(+(0, $b3MCU.toDate)(date) / 1000);
}

});

parcelRegister("wNfjT", function(module, exports) {

$parcel$export(module.exports, "getWeekOfMonth", function () { return $062930859469a55e$export$59fb9b85a4d8d027; }, function (v) { return $062930859469a55e$export$59fb9b85a4d8d027 = v; });
var $062930859469a55e$export$59fb9b85a4d8d027;
"use strict";
$062930859469a55e$export$59fb9b85a4d8d027 = $062930859469a55e$var$getWeekOfMonth;

var $egMd8 = parcelRequire("egMd8");

var $kvN19 = parcelRequire("kvN19");

var $Gd0bX = parcelRequire("Gd0bX");

var $lJvf9 = parcelRequire("lJvf9");
/**
 * The {@link getWeekOfMonth} function options.
 */ /**
 * @name getWeekOfMonth
 * @category Week Helpers
 * @summary Get the week of the month of the given date.
 *
 * @description
 * Get the week of the month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The week of month
 *
 * @example
 * // Which week of the month is 9 November 2017?
 * const result = getWeekOfMonth(new Date(2017, 10, 9))
 * //=> 2
 */ function $062930859469a55e$var$getWeekOfMonth(date, options) {
    const defaultOptions = (0, $lJvf9.getDefaultOptions)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const currentDayOfMonth = (0, $egMd8.getDate)(date);
    if (isNaN(currentDayOfMonth)) return NaN;
    const startWeekDay = (0, $kvN19.getDay)((0, $Gd0bX.startOfMonth)(date));
    let lastDayOfFirstWeek = weekStartsOn - startWeekDay;
    if (lastDayOfFirstWeek <= 0) lastDayOfFirstWeek += 7;
    const remainingDaysAfterFirstWeek = currentDayOfMonth - lastDayOfFirstWeek;
    return Math.ceil(remainingDaysAfterFirstWeek / 7) + 1;
}

});

parcelRegister("7VWhP", function(module, exports) {

$parcel$export(module.exports, "getWeeksInMonth", function () { return $5c6b11cb5b557334$export$ccc1b2479e7dd654; }, function (v) { return $5c6b11cb5b557334$export$ccc1b2479e7dd654 = v; });
var $5c6b11cb5b557334$export$ccc1b2479e7dd654;
"use strict";
$5c6b11cb5b557334$export$ccc1b2479e7dd654 = $5c6b11cb5b557334$var$getWeeksInMonth;

var $gDfuA = parcelRequire("gDfuA");

var $cxPYU = parcelRequire("cxPYU");

var $Gd0bX = parcelRequire("Gd0bX");
/**
 * The {@link getWeeksInMonth} function options.
 */ /**
 * @name getWeeksInMonth
 * @category Week Helpers
 * @summary Get the number of calendar weeks a month spans.
 *
 * @description
 * Get the number of calendar weeks the month in the given date spans.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The number of calendar weeks
 *
 * @example
 * // How many calendar weeks does February 2015 span?
 * const result = getWeeksInMonth(new Date(2015, 1, 8))
 * //=> 4
 *
 * @example
 * // If the week starts on Monday,
 * // how many calendar weeks does July 2017 span?
 * const result = getWeeksInMonth(new Date(2017, 6, 5), { weekStartsOn: 1 })
 * //=> 6
 */ function $5c6b11cb5b557334$var$getWeeksInMonth(date, options) {
    return (0, $gDfuA.differenceInCalendarWeeks)((0, $cxPYU.lastDayOfMonth)(date), (0, $Gd0bX.startOfMonth)(date), options) + 1;
}

});
parcelRegister("cxPYU", function(module, exports) {

$parcel$export(module.exports, "lastDayOfMonth", function () { return $9220e38a34f6278b$export$36818250d6c87922; }, function (v) { return $9220e38a34f6278b$export$36818250d6c87922 = v; });
var $9220e38a34f6278b$export$36818250d6c87922;
"use strict";
$9220e38a34f6278b$export$36818250d6c87922 = $9220e38a34f6278b$var$lastDayOfMonth;

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name lastDayOfMonth
 * @category Month Helpers
 * @summary Return the last day of a month for the given date.
 *
 * @description
 * Return the last day of a month for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of a month
 *
 * @example
 * // The last day of a month for 2 September 2014 11:55:00:
 * const result = lastDayOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 00:00:00
 */ function $9220e38a34f6278b$var$lastDayOfMonth(date) {
    const _date = (0, $b3MCU.toDate)(date);
    const month = _date.getMonth();
    _date.setFullYear(_date.getFullYear(), month + 1, 0);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

});


parcelRegister("c5nsv", function(module, exports) {

$parcel$export(module.exports, "getYear", function () { return $8cc82615cea5b6e9$export$5846dc2d57a5c860; }, function (v) { return $8cc82615cea5b6e9$export$5846dc2d57a5c860 = v; });
var $8cc82615cea5b6e9$export$5846dc2d57a5c860;
"use strict";
$8cc82615cea5b6e9$export$5846dc2d57a5c860 = $8cc82615cea5b6e9$var$getYear;

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name getYear
 * @category Year Helpers
 * @summary Get the year of the given date.
 *
 * @description
 * Get the year of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The year
 *
 * @example
 * // Which year is 2 July 2014?
 * const result = getYear(new Date(2014, 6, 2))
 * //=> 2014
 */ function $8cc82615cea5b6e9$var$getYear(date) {
    return (0, $b3MCU.toDate)(date).getFullYear();
}

});

parcelRegister("5K7uY", function(module, exports) {

$parcel$export(module.exports, "hoursToMilliseconds", function () { return $42e710b5f3db4807$export$5b42ab7a22898b69; }, function (v) { return $42e710b5f3db4807$export$5b42ab7a22898b69 = v; });
var $42e710b5f3db4807$export$5b42ab7a22898b69;
"use strict";
$42e710b5f3db4807$export$5b42ab7a22898b69 = $42e710b5f3db4807$var$hoursToMilliseconds;

var $7MMvH = parcelRequire("7MMvH");
/**
 * @name hoursToMilliseconds
 * @category  Conversion Helpers
 * @summary Convert hours to milliseconds.
 *
 * @description
 * Convert a number of hours to a full number of milliseconds.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param hours - number of hours to be converted
 *
 * @returns The number of hours converted to milliseconds
 *
 * @example
 * // Convert 2 hours to milliseconds:
 * const result = hoursToMilliseconds(2)
 * //=> 7200000
 */ function $42e710b5f3db4807$var$hoursToMilliseconds(hours) {
    return Math.trunc(hours * $7MMvH.millisecondsInHour);
}

});

parcelRegister("azNIw", function(module, exports) {

$parcel$export(module.exports, "hoursToMinutes", function () { return $7b33bd0d4316d14e$export$83bfc73cdf89a4d8; }, function (v) { return $7b33bd0d4316d14e$export$83bfc73cdf89a4d8 = v; });
var $7b33bd0d4316d14e$export$83bfc73cdf89a4d8;
"use strict";
$7b33bd0d4316d14e$export$83bfc73cdf89a4d8 = $7b33bd0d4316d14e$var$hoursToMinutes;

var $7MMvH = parcelRequire("7MMvH");
/**
 * @name hoursToMinutes
 * @category Conversion Helpers
 * @summary Convert hours to minutes.
 *
 * @description
 * Convert a number of hours to a full number of minutes.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param hours - number of hours to be converted
 *
 * @returns The number of hours converted in minutes
 *
 * @example
 * // Convert 2 hours to minutes:
 * const result = hoursToMinutes(2)
 * //=> 120
 */ function $7b33bd0d4316d14e$var$hoursToMinutes(hours) {
    return Math.trunc(hours * $7MMvH.minutesInHour);
}

});

parcelRegister("lL9om", function(module, exports) {

$parcel$export(module.exports, "hoursToSeconds", function () { return $fd7545cf130fd9db$export$59b1396ccbd5a4e1; }, function (v) { return $fd7545cf130fd9db$export$59b1396ccbd5a4e1 = v; });
var $fd7545cf130fd9db$export$59b1396ccbd5a4e1;
"use strict";
$fd7545cf130fd9db$export$59b1396ccbd5a4e1 = $fd7545cf130fd9db$var$hoursToSeconds;

var $7MMvH = parcelRequire("7MMvH");
/**
 * @name hoursToSeconds
 * @category Conversion Helpers
 * @summary Convert hours to seconds.
 *
 * @description
 * Convert a number of hours to a full number of seconds.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param hours - The number of hours to be converted
 *
 * @returns The number of hours converted in seconds
 *
 * @example
 * // Convert 2 hours to seconds:
 * const result = hoursToSeconds(2)
 * //=> 7200
 */ function $fd7545cf130fd9db$var$hoursToSeconds(hours) {
    return Math.trunc(hours * $7MMvH.secondsInHour);
}

});

parcelRegister("bUAAN", function(module, exports) {

$parcel$export(module.exports, "interval", function () { return $8ac14f2b5ab7db14$export$3174cdbf0a0cbc84; }, function (v) { return $8ac14f2b5ab7db14$export$3174cdbf0a0cbc84 = v; });
var $8ac14f2b5ab7db14$export$3174cdbf0a0cbc84;
"use strict";
$8ac14f2b5ab7db14$export$3174cdbf0a0cbc84 = $8ac14f2b5ab7db14$var$interval;

var $b3MCU = parcelRequire("b3MCU");
/**
 * The {@link interval} function options.
 */ /**
 * @name interval
 * @category Interval Helpers
 * @summary Creates an interval object and validates its values.
 *
 * @description
 * Creates a normalized interval object and validates its values. If the interval is invalid, an exception is thrown.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param start - The start of the interval.
 * @param end - The end of the interval.
 * @param options - The options object.
 *
 * @throws `Start date is invalid` when `start` is invalid.
 * @throws `End date is invalid` when `end` is invalid.
 * @throws `End date must be after start date` when end is before `start` and `options.assertPositive` is true.
 *
 * @returns The normalized and validated interval object.
 */ function $8ac14f2b5ab7db14$var$interval(start, end, options) {
    const _start = (0, $b3MCU.toDate)(start);
    if (isNaN(+_start)) throw new TypeError("Start date is invalid");
    const _end = (0, $b3MCU.toDate)(end);
    if (isNaN(+_end)) throw new TypeError("End date is invalid");
    if (options?.assertPositive && +_start > +_end) throw new TypeError("End date must be after start date");
    return {
        start: _start,
        end: _end
    };
}

});

parcelRegister("iiMzW", function(module, exports) {

$parcel$export(module.exports, "intervalToDuration", function () { return $d52f97279c5119bf$export$7b6c9a626316863; }, function (v) { return $d52f97279c5119bf$export$7b6c9a626316863 = v; });
var $d52f97279c5119bf$export$7b6c9a626316863;
"use strict";
$d52f97279c5119bf$export$7b6c9a626316863 = $d52f97279c5119bf$var$intervalToDuration;

var $cQcg2 = parcelRequire("cQcg2");

var $7t70d = parcelRequire("7t70d");

var $exRu4 = parcelRequire("exRu4");

var $cOBKs = parcelRequire("cOBKs");

var $klNiQ = parcelRequire("klNiQ");

var $hfEAx = parcelRequire("hfEAx");

var $5np6K = parcelRequire("5np6K");

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name intervalToDuration
 * @category Common Helpers
 * @summary Convert interval to duration
 *
 * @description
 * Convert a interval object to a duration object.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval to convert to duration
 *
 * @returns The duration object
 *
 * @example
 * // Get the duration between January 15, 1929 and April 4, 1968.
 * intervalToDuration({
 *   start: new Date(1929, 0, 15, 12, 0, 0),
 *   end: new Date(1968, 3, 4, 19, 5, 0)
 * })
 * // => { years: 39, months: 2, days: 20, hours: 7, minutes: 5, seconds: 0 }
 */ function $d52f97279c5119bf$var$intervalToDuration(interval) {
    const start = (0, $b3MCU.toDate)(interval.start);
    const end = (0, $b3MCU.toDate)(interval.end);
    const duration = {};
    const years = (0, $5np6K.differenceInYears)(end, start);
    if (years) duration.years = years;
    const remainingMonths = (0, $cQcg2.add)(start, {
        years: duration.years
    });
    const months = (0, $klNiQ.differenceInMonths)(end, remainingMonths);
    if (months) duration.months = months;
    const remainingDays = (0, $cQcg2.add)(remainingMonths, {
        months: duration.months
    });
    const days = (0, $7t70d.differenceInDays)(end, remainingDays);
    if (days) duration.days = days;
    const remainingHours = (0, $cQcg2.add)(remainingDays, {
        days: duration.days
    });
    const hours = (0, $exRu4.differenceInHours)(end, remainingHours);
    if (hours) duration.hours = hours;
    const remainingMinutes = (0, $cQcg2.add)(remainingHours, {
        hours: duration.hours
    });
    const minutes = (0, $cOBKs.differenceInMinutes)(end, remainingMinutes);
    if (minutes) duration.minutes = minutes;
    const remainingSeconds = (0, $cQcg2.add)(remainingMinutes, {
        minutes: duration.minutes
    });
    const seconds = (0, $hfEAx.differenceInSeconds)(end, remainingSeconds);
    if (seconds) duration.seconds = seconds;
    return duration;
}

});

parcelRegister("iys0V", function(module, exports) {

$parcel$export(module.exports, "intlFormat", function () { return $d82121eddb205105$export$f58f1234eed71f82; }, function (v) { return $d82121eddb205105$export$f58f1234eed71f82 = v; });
var $d82121eddb205105$export$f58f1234eed71f82;
"use strict";
$d82121eddb205105$export$f58f1234eed71f82 = $d82121eddb205105$var$intlFormat;

var $b3MCU = parcelRequire("b3MCU");
/**
 * The locale string (see: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locales_argument).
 */ /**
 * The format options (see: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat#options)
 */ /**
 * The locale options.
 */ /**
 * @name intlFormat
 * @category Common Helpers
 * @summary Format the date with Intl.DateTimeFormat (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat).
 *
 * @description
 * Return the formatted date string in the given format.
 * The method uses [`Intl.DateTimeFormat`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat) inside.
 * formatOptions are the same as [`Intl.DateTimeFormat` options](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat#using_options)
 *
 * > ⚠️ Please note that before Node version 13.0.0, only the locale data for en-US is available by default.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 4 October 2019 in middle-endian format:
 * const result = intlFormat(new Date(2019, 9, 4, 12, 30, 13, 456))
 * //=> 10/4/2019
 */ /**
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 * @param localeOptions - An object with locale
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 4 October 2019 in Korean.
 * // Convert the date with locale's options.
 * const result = intlFormat(new Date(2019, 9, 4, 12, 30, 13, 456), {
 *   locale: 'ko-KR',
 * })
 * //=> 2019. 10. 4.
 */ /**
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 * @param formatOptions - The format options
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 4 October 2019.
 * // Convert the date with format's options.
 * const result = intlFormat.default(new Date(2019, 9, 4, 12, 30, 13, 456), {
 *   year: 'numeric',
 *   month: 'numeric',
 *   day: 'numeric',
 *   hour: 'numeric',
 * })
 * //=> 10/4/2019, 12 PM
 */ /**
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 * @param formatOptions - The format options
 * @param localeOptions - An object with locale
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 4 October 2019 in German.
 * // Convert the date with format's options and locale's options.
 * const result = intlFormat(new Date(2019, 9, 4, 12, 30, 13, 456), {
 *   weekday: 'long',
 *   year: 'numeric',
 *   month: 'long',
 *   day: 'numeric',
 * }, {
 *   locale: 'de-DE',
 * })
 * //=> Freitag, 4. Oktober 2019
 */ function $d82121eddb205105$var$intlFormat(date, formatOrLocale, localeOptions) {
    let formatOptions;
    if ($d82121eddb205105$var$isFormatOptions(formatOrLocale)) formatOptions = formatOrLocale;
    else localeOptions = formatOrLocale;
    return new Intl.DateTimeFormat(localeOptions?.locale, formatOptions).format((0, $b3MCU.toDate)(date));
}
function $d82121eddb205105$var$isFormatOptions(opts) {
    return opts !== undefined && !("locale" in opts);
}

});

parcelRegister("ggy2b", function(module, exports) {

$parcel$export(module.exports, "intlFormatDistance", function () { return $bd788a780af3e0e2$export$a110a4020280fd5; }, function (v) { return $bd788a780af3e0e2$export$a110a4020280fd5 = v; });
var $bd788a780af3e0e2$export$a110a4020280fd5;
"use strict";
$bd788a780af3e0e2$export$a110a4020280fd5 = $bd788a780af3e0e2$var$intlFormatDistance;

var $7MMvH = parcelRequire("7MMvH");

var $fctE0 = parcelRequire("fctE0");

var $eUT4w = parcelRequire("eUT4w");

var $ilnvA = parcelRequire("ilnvA");

var $gDfuA = parcelRequire("gDfuA");

var $bnwnB = parcelRequire("bnwnB");

var $exRu4 = parcelRequire("exRu4");

var $cOBKs = parcelRequire("cOBKs");

var $hfEAx = parcelRequire("hfEAx");

var $b3MCU = parcelRequire("b3MCU");
/**
 * The {@link intlFormatDistance} function options.
 */ /**
 * The unit used to format the distance in {@link intlFormatDistance}.
 */ /**
 * @name intlFormatDistance
 * @category Common Helpers
 * @summary Formats distance between two dates in a human-readable format
 * @description
 * The function calculates the difference between two dates and formats it as a human-readable string.
 *
 * The function will pick the most appropriate unit depending on the distance between dates. For example, if the distance is a few hours, it might return `x hours`. If the distance is a few months, it might return `x months`.
 *
 * You can also specify a unit to force using it regardless of the distance to get a result like `123456 hours`.
 *
 * See the table below for the unit picking logic:
 *
 * | Distance between dates | Result (past)  | Result (future) |
 * | ---------------------- | -------------- | --------------- |
 * | 0 seconds              | now            | now             |
 * | 1-59 seconds           | X seconds ago  | in X seconds    |
 * | 1-59 minutes           | X minutes ago  | in X minutes    |
 * | 1-23 hours             | X hours ago    | in X hours      |
 * | 1 day                  | yesterday      | tomorrow        |
 * | 2-6 days               | X days ago     | in X days       |
 * | 7 days                 | last week      | next week       |
 * | 8 days-1 month         | X weeks ago    | in X weeks      |
 * | 1 month                | last month     | next month      |
 * | 2-3 months             | X months ago   | in X months     |
 * | 1 quarter              | last quarter   | next quarter    |
 * | 2-3 quarters           | X quarters ago | in X quarters   |
 * | 1 year                 | last year      | next year       |
 * | 2+ years               | X years ago    | in X years      |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date
 * @param baseDate - The date to compare with.
 * @param options - An object with options.
 * See MDN for details [Locale identification and negotiation](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locale_identification_and_negotiation)
 * The narrow one could be similar to the short one for some locales.
 *
 * @returns The distance in words according to language-sensitive relative time formatting.
 *
 * @throws `date` must not be Invalid Date
 * @throws `baseDate` must not be Invalid Date
 * @throws `options.unit` must not be invalid Unit
 * @throws `options.locale` must not be invalid locale
 * @throws `options.localeMatcher` must not be invalid localeMatcher
 * @throws `options.numeric` must not be invalid numeric
 * @throws `options.style` must not be invalid style
 *
 * @example
 * // What is the distance between the dates when the fist date is after the second?
 * intlFormatDistance(
 *   new Date(1986, 3, 4, 11, 30, 0),
 *   new Date(1986, 3, 4, 10, 30, 0)
 * )
 * //=> 'in 1 hour'
 *
 * // What is the distance between the dates when the fist date is before the second?
 * intlFormatDistance(
 *   new Date(1986, 3, 4, 10, 30, 0),
 *   new Date(1986, 3, 4, 11, 30, 0)
 * )
 * //=> '1 hour ago'
 *
 * @example
 * // Use the unit option to force the function to output the result in quarters. Without setting it, the example would return "next year"
 * intlFormatDistance(
 *   new Date(1987, 6, 4, 10, 30, 0),
 *   new Date(1986, 3, 4, 10, 30, 0),
 *   { unit: 'quarter' }
 * )
 * //=> 'in 5 quarters'
 *
 * @example
 * // Use the locale option to get the result in Spanish. Without setting it, the example would return "in 1 hour".
 * intlFormatDistance(
 *   new Date(1986, 3, 4, 11, 30, 0),
 *   new Date(1986, 3, 4, 10, 30, 0),
 *   { locale: 'es' }
 * )
 * //=> 'dentro de 1 hora'
 *
 * @example
 * // Use the numeric option to force the function to use numeric values. Without setting it, the example would return "tomorrow".
 * intlFormatDistance(
 *   new Date(1986, 3, 5, 11, 30, 0),
 *   new Date(1986, 3, 4, 11, 30, 0),
 *   { numeric: 'always' }
 * )
 * //=> 'in 1 day'
 *
 * @example
 * // Use the style option to force the function to use short values. Without setting it, the example would return "in 2 years".
 * intlFormatDistance(
 *   new Date(1988, 3, 4, 11, 30, 0),
 *   new Date(1986, 3, 4, 11, 30, 0),
 *   { style: 'short' }
 * )
 * //=> 'in 2 yr'
 */ function $bd788a780af3e0e2$var$intlFormatDistance(date, baseDate, options) {
    let value = 0;
    let unit;
    const dateLeft = (0, $b3MCU.toDate)(date);
    const dateRight = (0, $b3MCU.toDate)(baseDate);
    if (!options?.unit) {
        // Get the unit based on diffInSeconds calculations if no unit is specified
        const diffInSeconds = (0, $hfEAx.differenceInSeconds)(dateLeft, dateRight); // The smallest unit
        if (Math.abs(diffInSeconds) < $7MMvH.secondsInMinute) {
            value = (0, $hfEAx.differenceInSeconds)(dateLeft, dateRight);
            unit = "second";
        } else if (Math.abs(diffInSeconds) < $7MMvH.secondsInHour) {
            value = (0, $cOBKs.differenceInMinutes)(dateLeft, dateRight);
            unit = "minute";
        } else if (Math.abs(diffInSeconds) < $7MMvH.secondsInDay && Math.abs((0, $fctE0.differenceInCalendarDays)(dateLeft, dateRight)) < 1) {
            value = (0, $exRu4.differenceInHours)(dateLeft, dateRight);
            unit = "hour";
        } else if (Math.abs(diffInSeconds) < $7MMvH.secondsInWeek && (value = (0, $fctE0.differenceInCalendarDays)(dateLeft, dateRight)) && Math.abs(value) < 7) unit = "day";
        else if (Math.abs(diffInSeconds) < $7MMvH.secondsInMonth) {
            value = (0, $gDfuA.differenceInCalendarWeeks)(dateLeft, dateRight);
            unit = "week";
        } else if (Math.abs(diffInSeconds) < $7MMvH.secondsInQuarter) {
            value = (0, $eUT4w.differenceInCalendarMonths)(dateLeft, dateRight);
            unit = "month";
        } else if (Math.abs(diffInSeconds) < $7MMvH.secondsInYear) {
            if ((0, $ilnvA.differenceInCalendarQuarters)(dateLeft, dateRight) < 4) {
                // To filter out cases that are less than a year but match 4 quarters
                value = (0, $ilnvA.differenceInCalendarQuarters)(dateLeft, dateRight);
                unit = "quarter";
            } else {
                value = (0, $bnwnB.differenceInCalendarYears)(dateLeft, dateRight);
                unit = "year";
            }
        } else {
            value = (0, $bnwnB.differenceInCalendarYears)(dateLeft, dateRight);
            unit = "year";
        }
    } else {
        // Get the value if unit is specified
        unit = options?.unit;
        if (unit === "second") value = (0, $hfEAx.differenceInSeconds)(dateLeft, dateRight);
        else if (unit === "minute") value = (0, $cOBKs.differenceInMinutes)(dateLeft, dateRight);
        else if (unit === "hour") value = (0, $exRu4.differenceInHours)(dateLeft, dateRight);
        else if (unit === "day") value = (0, $fctE0.differenceInCalendarDays)(dateLeft, dateRight);
        else if (unit === "week") value = (0, $gDfuA.differenceInCalendarWeeks)(dateLeft, dateRight);
        else if (unit === "month") value = (0, $eUT4w.differenceInCalendarMonths)(dateLeft, dateRight);
        else if (unit === "quarter") value = (0, $ilnvA.differenceInCalendarQuarters)(dateLeft, dateRight);
        else if (unit === "year") value = (0, $bnwnB.differenceInCalendarYears)(dateLeft, dateRight);
    }
    const rtf = new Intl.RelativeTimeFormat(options?.locale, {
        localeMatcher: options?.localeMatcher,
        numeric: options?.numeric || "auto",
        style: options?.style
    });
    return rtf.format(value, unit);
}

});

parcelRegister("4akuu", function(module, exports) {

$parcel$export(module.exports, "isAfter", function () { return $3087fda56757b551$export$e4de839670987035; }, function (v) { return $3087fda56757b551$export$e4de839670987035 = v; });
var $3087fda56757b551$export$e4de839670987035;
"use strict";
$3087fda56757b551$export$e4de839670987035 = $3087fda56757b551$var$isAfter;

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date that should be after the other one to return true
 * @param dateToCompare - The date to compare with
 *
 * @returns The first date is after the second date
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * const result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */ function $3087fda56757b551$var$isAfter(date, dateToCompare) {
    const _date = (0, $b3MCU.toDate)(date);
    const _dateToCompare = (0, $b3MCU.toDate)(dateToCompare);
    return _date.getTime() > _dateToCompare.getTime();
}

});

parcelRegister("kLebH", function(module, exports) {

$parcel$export(module.exports, "isBefore", function () { return $f1d333cd8c84a69d$export$5c007e10c6929c95; }, function (v) { return $f1d333cd8c84a69d$export$5c007e10c6929c95 = v; });
var $f1d333cd8c84a69d$export$5c007e10c6929c95;
"use strict";
$f1d333cd8c84a69d$export$5c007e10c6929c95 = $f1d333cd8c84a69d$var$isBefore;

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name isBefore
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date that should be before the other one to return true
 * @param dateToCompare - The date to compare with
 *
 * @returns The first date is before the second date
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * const result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */ function $f1d333cd8c84a69d$var$isBefore(date, dateToCompare) {
    const _date = (0, $b3MCU.toDate)(date);
    const _dateToCompare = (0, $b3MCU.toDate)(dateToCompare);
    return +_date < +_dateToCompare;
}

});

parcelRegister("477Vo", function(module, exports) {

$parcel$export(module.exports, "isEqual", function () { return $2fedf68ce689ac7d$export$248d38f6296296c5; }, function (v) { return $2fedf68ce689ac7d$export$248d38f6296296c5 = v; });
var $2fedf68ce689ac7d$export$248d38f6296296c5;
"use strict";
$2fedf68ce689ac7d$export$248d38f6296296c5 = $2fedf68ce689ac7d$var$isEqual;

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name isEqual
 * @category Common Helpers
 * @summary Are the given dates equal?
 *
 * @description
 * Are the given dates equal?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to compare
 * @param dateRight - The second date to compare
 *
 * @returns The dates are equal
 *
 * @example
 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
 * const result = isEqual(
 *   new Date(2014, 6, 2, 6, 30, 45, 0),
 *   new Date(2014, 6, 2, 6, 30, 45, 500)
 * )
 * //=> false
 */ function $2fedf68ce689ac7d$var$isEqual(leftDate, rightDate) {
    const _dateLeft = (0, $b3MCU.toDate)(leftDate);
    const _dateRight = (0, $b3MCU.toDate)(rightDate);
    return +_dateLeft === +_dateRight;
}

});

parcelRegister("dXNmw", function(module, exports) {

$parcel$export(module.exports, "isExists", function () { return $a2a713637ab1e70c$export$127519e0edcdc58b; }, function (v) { return $a2a713637ab1e70c$export$127519e0edcdc58b = v; });
var $a2a713637ab1e70c$export$127519e0edcdc58b;
"use strict";
$a2a713637ab1e70c$export$127519e0edcdc58b = $a2a713637ab1e70c$var$isExists; /**
 * @name isExists
 * @category Common Helpers
 * @summary Is the given date exists?
 *
 * @description
 * Checks if the given arguments convert to an existing date.
 *
 * @param year - The year of the date to check
 * @param month - The month of the date to check
 * @param day - The day of the date to check
 *
 * @returns `true` if the date exists
 *
 * @example
 * // For the valid date:
 * const result = isExists(2018, 0, 31)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isExists(2018, 1, 31)
 * //=> false
 */ 
function $a2a713637ab1e70c$var$isExists(year, month, day) {
    const date = new Date(year, month, day);
    return date.getFullYear() === year && date.getMonth() === month && date.getDate() === day;
}

});

parcelRegister("4haoU", function(module, exports) {

$parcel$export(module.exports, "isFirstDayOfMonth", function () { return $31d0d155582fd87e$export$2716a425049f51dd; }, function (v) { return $31d0d155582fd87e$export$2716a425049f51dd = v; });
var $31d0d155582fd87e$export$2716a425049f51dd;
"use strict";
$31d0d155582fd87e$export$2716a425049f51dd = $31d0d155582fd87e$var$isFirstDayOfMonth;

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name isFirstDayOfMonth
 * @category Month Helpers
 * @summary Is the given date the first day of a month?
 *
 * @description
 * Is the given date the first day of a month?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check

 * @returns The date is the first day of a month
 *
 * @example
 * // Is 1 September 2014 the first day of a month?
 * const result = isFirstDayOfMonth(new Date(2014, 8, 1))
 * //=> true
 */ function $31d0d155582fd87e$var$isFirstDayOfMonth(date) {
    return (0, $b3MCU.toDate)(date).getDate() === 1;
}

});

parcelRegister("iLwCL", function(module, exports) {

$parcel$export(module.exports, "isFriday", function () { return $da95ec4473fe2b57$export$3b7d89f127884993; }, function (v) { return $da95ec4473fe2b57$export$3b7d89f127884993 = v; });
var $da95ec4473fe2b57$export$3b7d89f127884993;
"use strict";
$da95ec4473fe2b57$export$3b7d89f127884993 = $da95ec4473fe2b57$var$isFriday;

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name isFriday
 * @category Weekday Helpers
 * @summary Is the given date Friday?
 *
 * @description
 * Is the given date Friday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Friday
 *
 * @example
 * // Is 26 September 2014 Friday?
 * const result = isFriday(new Date(2014, 8, 26))
 * //=> true
 */ function $da95ec4473fe2b57$var$isFriday(date) {
    return (0, $b3MCU.toDate)(date).getDay() === 5;
}

});

parcelRegister("7oPq9", function(module, exports) {

$parcel$export(module.exports, "isFuture", function () { return $5632a95f947c048c$export$2baac2df6018cd7; }, function (v) { return $5632a95f947c048c$export$2baac2df6018cd7 = v; });
var $5632a95f947c048c$export$2baac2df6018cd7;
"use strict";
$5632a95f947c048c$export$2baac2df6018cd7 = $5632a95f947c048c$var$isFuture;

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name isFuture
 * @category Common Helpers
 * @summary Is the given date in the future?
 * @pure false
 *
 * @description
 * Is the given date in the future?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in the future
 *
 * @example
 * // If today is 6 October 2014, is 31 December 2014 in the future?
 * const result = isFuture(new Date(2014, 11, 31))
 * //=> true
 */ function $5632a95f947c048c$var$isFuture(date) {
    return +(0, $b3MCU.toDate)(date) > Date.now();
}

});

parcelRegister("fKesV", function(module, exports) {

$parcel$export(module.exports, "isMatch", function () { return $b7665f76690a0efc$export$b74c33566721f70f; }, function (v) { return $b7665f76690a0efc$export$b74c33566721f70f = v; });
var $b7665f76690a0efc$export$b74c33566721f70f;
"use strict";
$b7665f76690a0efc$export$b74c33566721f70f = $b7665f76690a0efc$var$isMatch;

var $cmplH = parcelRequire("cmplH");

var $dZnFS = parcelRequire("dZnFS");
/**
 * The {@link isMatch} function options.
 */ /**
 * @name isMatch
 * @category Common Helpers
 * @summary validates the date string against given formats
 *
 * @description
 * Return the true if given date is string correct against the given format else
 * will return false.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters in the format string wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the format string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 5 below the table).
 *
 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
 *
 * ```javascript
 * isMatch('23 AM', 'HH a')
 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
 * ```
 *
 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
 *
 * Accepted format string patterns:
 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
 * |---------------------------------|-----|---------|-----------------------------------|-------|
 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 |     | GGGGG   | A, B                              |       |
 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
 * |                                 |     | yyyyy   | ...                               | 2,4   |
 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
 * |                                 |     | YYYYY   | ...                               | 2,4   |
 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
 * |                                 |     | uuuuu   | ...                               | 2,4   |
 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 |     | DDDD    | ...                               | 2     |
 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
 * |                                 |     | iii     | Mon, Tue, Wed, ..., Su            | 5     |
 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
 * |                                 |     | eee     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
 * |                                 |     | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
 * |                                 |     | tt      | ...                               | 2     |
 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
 * |                                 |     | SSS     | 000, 001, ..., 999                |       |
 * |                                 |     | SSSS    | ...                               | 2     |
 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
 * |                                 |     | TT      | ...                               | 2     |
 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
 * |                                 |     | XX      | -0800, +0530, Z                   |       |
 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
 * |                                 |     | xx      | -0800, +0530, +0000               |       |
 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
 * |                                 |     | PP      | May 29, 1453                      |       |
 * |                                 |     | PPP     | May 29th, 1453                    |       |
 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
 * |                                 |     | pp      | 12:00:00 AM                       |       |
 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular.
 *    In `format` function, they will produce different result:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 *    `isMatch` will try to match both formatting and stand-alone units interchangably.
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table:
 *    - for numerical units (`yyyyyyyy`) `isMatch` will try to match a number
 *      as wide as the sequence
 *    - for text units (`MMMMMMMM`) `isMatch` will try to match the widest variation of the unit.
 *      These variations are marked with "2" in the last column of the table.
 *
 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 4. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
 *
 *    `isMatch('50', 'yy') //=> true`
 *
 *    `isMatch('75', 'yy') //=> true`
 *
 *    while `uu` will use the year as is:
 *
 *    `isMatch('50', 'uu') //=> true`
 *
 *    `isMatch('75', 'uu') //=> true`
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear](https://date-fns.org/docs/setISOWeekYear)
 *    and [setWeekYear](https://date-fns.org/docs/setWeekYear)).
 *
 * 5. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
 *    on the given locale.
 *
 *    using `en-US` locale: `P` => `MM/dd/yyyy`
 *    using `en-US` locale: `p` => `hh:mm a`
 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
 *    using `pt-BR` locale: `p` => `HH:mm`
 *
 * Values will be checked in the descending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are matched (e.g. when matching string 'January 1st' without a year),
 * the values will be taken from today's using `new Date()` date which works as a context of parsing.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateStr - The date string to verify
 * @param format - The string of tokens
 * @param options - An object with options.
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @returns Is format string a match for date string?
 *
 * @throws `options.locale` must contain `match` property
 * @throws use `yyyy` instead of `YYYY` for formatting years; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `yy` instead of `YY` for formatting years; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `d` instead of `D` for formatting days of the month; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `dd` instead of `DD` for formatting days of the month; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * // Match 11 February 2014 from middle-endian format:
 * const result = isMatch('02/11/2014', 'MM/dd/yyyy')
 * //=> true
 *
 * @example
 * // Match 28th of February in Esperanto locale in the context of 2010 year:
 * import eo from 'date-fns/locale/eo'
 * const result = isMatch('28-a de februaro', "do 'de' MMMM", {
 *   locale: eo
 * })
 * //=> true
 */ function $b7665f76690a0efc$var$isMatch(dateStr, formatStr, options) {
    return (0, $cmplH.isValid)((0, $dZnFS.parse)(dateStr, formatStr, new Date(), options));
}

});
parcelRegister("dZnFS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "longFormatters", {
    enumerable: true,
    get: function() {
        return $cXalR.longFormatters;
    }
});
module.exports.parse = $a2f3561f924cf32a$var$parse;
Object.defineProperty(module.exports, "parsers", {
    enumerable: true,
    get: function() {
        return $ifgd0.parsers;
    }
});

var $02yAu = parcelRequire("02yAu");

var $vaZLu = parcelRequire("vaZLu");

var $lpy2g = parcelRequire("lpy2g");

var $b3MCU = parcelRequire("b3MCU");

var $cXalR = parcelRequire("cXalR");

var $8H04k = parcelRequire("8H04k");

var $ifgd0 = parcelRequire("ifgd0");

var $TlhMn = parcelRequire("TlhMn");
// Rexports of internal for libraries to use.
// See: https://github.com/date-fns/date-fns/issues/3638#issuecomment-1877082874
/**
 * The {@link parse} function options.
 */ // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $a2f3561f924cf32a$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const $a2f3561f924cf32a$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const $a2f3561f924cf32a$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $a2f3561f924cf32a$var$doubleQuoteRegExp = /''/g;
const $a2f3561f924cf32a$var$notWhitespaceRegExp = /\S/;
const $a2f3561f924cf32a$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name parse
 * @category Common Helpers
 * @summary Parse the date.
 *
 * @description
 * Return the date parsed from string using the given format string.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters in the format string wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the format string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 5 below the table).
 *
 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
 *
 * ```javascript
 * parse('23 AM', 'HH a', new Date())
 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
 * ```
 *
 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
 *
 * Accepted format string patterns:
 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
 * |---------------------------------|-----|---------|-----------------------------------|-------|
 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 |     | GGGGG   | A, B                              |       |
 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
 * |                                 |     | yyyyy   | ...                               | 2,4   |
 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
 * |                                 |     | YYYYY   | ...                               | 2,4   |
 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
 * |                                 |     | uuuuu   | ...                               | 2,4   |
 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 |     | DDDD    | ...                               | 2     |
 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
 * |                                 |     | iii     | Mon, Tue, Wed, ..., Sun           | 5     |
 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
 * |                                 |     | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
 * |                                 |     | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
 * |                                 |     | tt      | ...                               | 2     |
 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
 * |                                 |     | SSS     | 000, 001, ..., 999                |       |
 * |                                 |     | SSSS    | ...                               | 2     |
 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
 * |                                 |     | TT      | ...                               | 2     |
 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
 * |                                 |     | XX      | -0800, +0530, Z                   |       |
 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
 * |                                 |     | xx      | -0800, +0530, +0000               |       |
 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
 * |                                 |     | PP      | May 29, 1453                      |       |
 * |                                 |     | PPP     | May 29th, 1453                    |       |
 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
 * |                                 |     | pp      | 12:00:00 AM                       |       |
 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular.
 *    In `format` function, they will produce different result:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 *    `parse` will try to match both formatting and stand-alone units interchangably.
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table:
 *    - for numerical units (`yyyyyyyy`) `parse` will try to match a number
 *      as wide as the sequence
 *    - for text units (`MMMMMMMM`) `parse` will try to match the widest variation of the unit.
 *      These variations are marked with "2" in the last column of the table.
 *
 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 4. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
 *
 *    `parse('50', 'yy', new Date(2018, 0, 1)) //=> Sat Jan 01 2050 00:00:00`
 *
 *    `parse('75', 'yy', new Date(2018, 0, 1)) //=> Wed Jan 01 1975 00:00:00`
 *
 *    while `uu` will just assign the year as is:
 *
 *    `parse('50', 'uu', new Date(2018, 0, 1)) //=> Sat Jan 01 0050 00:00:00`
 *
 *    `parse('75', 'uu', new Date(2018, 0, 1)) //=> Tue Jan 01 0075 00:00:00`
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear](https://date-fns.org/docs/setISOWeekYear)
 *    and [setWeekYear](https://date-fns.org/docs/setWeekYear)).
 *
 * 5. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
 *    on the given locale.
 *
 *    using `en-US` locale: `P` => `MM/dd/yyyy`
 *    using `en-US` locale: `p` => `hh:mm a`
 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
 *    using `pt-BR` locale: `p` => `HH:mm`
 *
 * Values will be assigned to the date in the descending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
 * the values will be taken from 3rd argument `referenceDate` which works as a context of parsing.
 *
 * `referenceDate` must be passed for correct work of the function.
 * If you're not sure which `referenceDate` to supply, create a new instance of Date:
 * `parse('02/11/2014', 'MM/dd/yyyy', new Date())`
 * In this case parsing will be done in the context of the current date.
 * If `referenceDate` is `Invalid Date` or a value not convertible to valid `Date`,
 * then `Invalid Date` will be returned.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
 *
 * If parsing failed, `Invalid Date` will be returned.
 * Invalid Date is a Date, whose time value is NaN.
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateStr - The string to parse
 * @param formatStr - The string of tokens
 * @param referenceDate - defines values missing from the parsed dateString
 * @param options - An object with options.
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @returns The parsed date
 *
 * @throws `options.locale` must contain `match` property
 * @throws use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * // Parse 11 February 2014 from middle-endian format:
 * var result = parse('02/11/2014', 'MM/dd/yyyy', new Date())
 * //=> Tue Feb 11 2014 00:00:00
 *
 * @example
 * // Parse 28th of February in Esperanto locale in the context of 2010 year:
 * import eo from 'date-fns/locale/eo'
 * var result = parse('28-a de februaro', "do 'de' MMMM", new Date(2010, 0, 1), {
 *   locale: eo
 * })
 * //=> Sun Feb 28 2010 00:00:00
 */ function $a2f3561f924cf32a$var$parse(dateStr, formatStr, referenceDate, options) {
    const defaultOptions = (0, $vaZLu.getDefaultOptions)();
    const locale = options?.locale ?? defaultOptions.locale ?? $lpy2g.defaultLocale;
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    if (formatStr === "") {
        if (dateStr === "") return (0, $b3MCU.toDate)(referenceDate);
        else return (0, $02yAu.constructFrom)(referenceDate, NaN);
    }
    const subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will be set to the system timezone
    const setters = [
        new $TlhMn.DateToSystemTimezoneSetter()
    ];
    const tokens = formatStr.match($a2f3561f924cf32a$var$longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter in $cXalR.longFormatters) {
            const longFormatter = $cXalR.longFormatters[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($a2f3561f924cf32a$var$formattingTokensRegExp);
    const usedTokens = [];
    for (let token of tokens){
        if (!options?.useAdditionalWeekYearTokens && (0, $8H04k.isProtectedWeekYearToken)(token)) (0, $8H04k.warnOrThrowProtectedError)(token, formatStr, dateStr);
        if (!options?.useAdditionalDayOfYearTokens && (0, $8H04k.isProtectedDayOfYearToken)(token)) (0, $8H04k.warnOrThrowProtectedError)(token, formatStr, dateStr);
        const firstCharacter = token[0];
        const parser = $ifgd0.parsers[firstCharacter];
        if (parser) {
            const { incompatibleTokens: incompatibleTokens } = parser;
            if (Array.isArray(incompatibleTokens)) {
                const incompatibleToken = usedTokens.find((usedToken)=>incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter);
                if (incompatibleToken) throw new RangeError(`The format string mustn't contain \`${incompatibleToken.fullToken}\` and \`${token}\` at the same time`);
            } else if (parser.incompatibleTokens === "*" && usedTokens.length > 0) throw new RangeError(`The format string mustn't contain \`${token}\` and any other token at the same time`);
            usedTokens.push({
                token: firstCharacter,
                fullToken: token
            });
            const parseResult = parser.run(dateStr, token, locale.match, subFnOptions);
            if (!parseResult) return (0, $02yAu.constructFrom)(referenceDate, NaN);
            setters.push(parseResult.setter);
            dateStr = parseResult.rest;
        } else {
            if (firstCharacter.match($a2f3561f924cf32a$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
            // Replace two single quote characters with one single quote character
            if (token === "''") token = "'";
            else if (firstCharacter === "'") token = $a2f3561f924cf32a$var$cleanEscapedString(token);
            // Cut token from string, or, if string doesn't match the token, return Invalid Date
            if (dateStr.indexOf(token) === 0) dateStr = dateStr.slice(token.length);
            else return (0, $02yAu.constructFrom)(referenceDate, NaN);
        }
    }
    // Check if the remaining input contains something other than whitespace
    if (dateStr.length > 0 && $a2f3561f924cf32a$var$notWhitespaceRegExp.test(dateStr)) return (0, $02yAu.constructFrom)(referenceDate, NaN);
    const uniquePrioritySetters = setters.map((setter)=>setter.priority).sort((a, b)=>b - a).filter((priority, index, array)=>array.indexOf(priority) === index).map((priority)=>setters.filter((setter)=>setter.priority === priority).sort((a, b)=>b.subPriority - a.subPriority)).map((setterArray)=>setterArray[0]);
    let date = (0, $b3MCU.toDate)(referenceDate);
    if (isNaN(date.getTime())) return (0, $02yAu.constructFrom)(referenceDate, NaN);
    const flags = {};
    for (const setter of uniquePrioritySetters){
        if (!setter.validate(date, subFnOptions)) return (0, $02yAu.constructFrom)(referenceDate, NaN);
        const result = setter.set(date, flags, subFnOptions);
        // Result is tuple (date, flags)
        if (Array.isArray(result)) {
            date = result[0];
            Object.assign(flags, result[1]);
        // Result is date
        } else date = result;
    }
    return (0, $02yAu.constructFrom)(referenceDate, date);
}
function $a2f3561f924cf32a$var$cleanEscapedString(input) {
    return input.match($a2f3561f924cf32a$var$escapedStringRegExp)[1].replace($a2f3561f924cf32a$var$doubleQuoteRegExp, "'");
}

});
parcelRegister("ifgd0", function(module, exports) {

$parcel$export(module.exports, "parsers", function () { return $d48633737e5beaeb$export$19131010e7fd8373; }, function (v) { return $d48633737e5beaeb$export$19131010e7fd8373 = v; });
var $d48633737e5beaeb$export$19131010e7fd8373;
"use strict";
$d48633737e5beaeb$export$19131010e7fd8373 = void 0;

var $f9Hjo = parcelRequire("f9Hjo");

var $gzz2V = parcelRequire("gzz2V");

var $ksPCt = parcelRequire("ksPCt");

var $tZOQp = parcelRequire("tZOQp");

var $bdQql = parcelRequire("bdQql");

var $lH7Pa = parcelRequire("lH7Pa");

var $ad9zr = parcelRequire("ad9zr");

var $l5WxN = parcelRequire("l5WxN");

var $9Srm8 = parcelRequire("9Srm8");

var $axzsB = parcelRequire("axzsB");

var $ldXwh = parcelRequire("ldXwh");

var $9YyKE = parcelRequire("9YyKE");

var $89sxi = parcelRequire("89sxi");

var $d1uav = parcelRequire("d1uav");

var $cWMDO = parcelRequire("cWMDO");

var $eZTqi = parcelRequire("eZTqi");

var $1yFoQ = parcelRequire("1yFoQ");

var $bEGcN = parcelRequire("bEGcN");

var $kFLpL = parcelRequire("kFLpL");

var $89EMg = parcelRequire("89EMg");

var $7f0GZ = parcelRequire("7f0GZ");

var $kImdH = parcelRequire("kImdH");

var $7wPsV = parcelRequire("7wPsV");

var $04Rzk = parcelRequire("04Rzk");

var $3z7C4 = parcelRequire("3z7C4");

var $eDKiy = parcelRequire("eDKiy");

var $BG5gQ = parcelRequire("BG5gQ");

var $41B6A = parcelRequire("41B6A");

var $hLrTY = parcelRequire("hLrTY");

var $ampPL = parcelRequire("ampPL");

var $8shGF = parcelRequire("8shGF");
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
 * |  p  |                                |  P  |                                |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any -- It's ok, we want any here
const $d48633737e5beaeb$var$parsers = $d48633737e5beaeb$export$19131010e7fd8373 = {
    G: new $f9Hjo.EraParser(),
    y: new $gzz2V.YearParser(),
    Y: new $ksPCt.LocalWeekYearParser(),
    R: new $tZOQp.ISOWeekYearParser(),
    u: new $bdQql.ExtendedYearParser(),
    Q: new $lH7Pa.QuarterParser(),
    q: new $ad9zr.StandAloneQuarterParser(),
    M: new $l5WxN.MonthParser(),
    L: new $9Srm8.StandAloneMonthParser(),
    w: new $axzsB.LocalWeekParser(),
    I: new $ldXwh.ISOWeekParser(),
    d: new $9YyKE.DateParser(),
    D: new $89sxi.DayOfYearParser(),
    E: new $d1uav.DayParser(),
    e: new $cWMDO.LocalDayParser(),
    c: new $eZTqi.StandAloneLocalDayParser(),
    i: new $1yFoQ.ISODayParser(),
    a: new $bEGcN.AMPMParser(),
    b: new $kFLpL.AMPMMidnightParser(),
    B: new $89EMg.DayPeriodParser(),
    h: new $7f0GZ.Hour1to12Parser(),
    H: new $kImdH.Hour0to23Parser(),
    K: new $7wPsV.Hour0To11Parser(),
    k: new $04Rzk.Hour1To24Parser(),
    m: new $3z7C4.MinuteParser(),
    s: new $eDKiy.SecondParser(),
    S: new $BG5gQ.FractionOfSecondParser(),
    X: new $41B6A.ISOTimezoneWithZParser(),
    x: new $hLrTY.ISOTimezoneParser(),
    t: new $ampPL.TimestampSecondsParser(),
    T: new $8shGF.TimestampMillisecondsParser()
};

});
parcelRegister("f9Hjo", function(module, exports) {

$parcel$export(module.exports, "EraParser", function () { return $b0894b1b9136022e$export$8e5a1d3f85a9688; }, function (v) { return $b0894b1b9136022e$export$8e5a1d3f85a9688 = v; });
var $b0894b1b9136022e$export$8e5a1d3f85a9688;
"use strict";
$b0894b1b9136022e$export$8e5a1d3f85a9688 = void 0;

var $2cMli = parcelRequire("2cMli");
class $b0894b1b9136022e$var$EraParser extends $2cMli.Parser {
    priority = 140;
    parse(dateString, token, match) {
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return match.era(dateString, {
                    width: "abbreviated"
                }) || match.era(dateString, {
                    width: "narrow"
                });
            // A, B
            case "GGGGG":
                return match.era(dateString, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return match.era(dateString, {
                    width: "wide"
                }) || match.era(dateString, {
                    width: "abbreviated"
                }) || match.era(dateString, {
                    width: "narrow"
                });
        }
    }
    set(date, flags, value) {
        flags.era = value;
        date.setFullYear(value, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "R",
        "u",
        "t",
        "T"
    ];
}
$b0894b1b9136022e$export$8e5a1d3f85a9688 = $b0894b1b9136022e$var$EraParser;

});
parcelRegister("2cMli", function(module, exports) {

$parcel$export(module.exports, "Parser", function () { return $19b23394c4ed79f8$export$7acfa6ed01010e37; }, function (v) { return $19b23394c4ed79f8$export$7acfa6ed01010e37 = v; });
var $19b23394c4ed79f8$export$7acfa6ed01010e37;
"use strict";
$19b23394c4ed79f8$export$7acfa6ed01010e37 = void 0;

var $TlhMn = parcelRequire("TlhMn");
class $19b23394c4ed79f8$var$Parser {
    run(dateString, token, match, options) {
        const result = this.parse(dateString, token, match, options);
        if (!result) return null;
        return {
            setter: new $TlhMn.ValueSetter(result.value, this.validate, this.set, this.priority, this.subPriority),
            rest: result.rest
        };
    }
    validate(_utcDate, _value, _options) {
        return true;
    }
}
$19b23394c4ed79f8$export$7acfa6ed01010e37 = $19b23394c4ed79f8$var$Parser;

});
parcelRegister("TlhMn", function(module, exports) {

$parcel$export(module.exports, "ValueSetter", function () { return $0a65a613f4c2409f$export$9a09e32dd4990fd5; }, function (v) { return $0a65a613f4c2409f$export$9a09e32dd4990fd5 = v; });
$parcel$export(module.exports, "DateToSystemTimezoneSetter", function () { return $0a65a613f4c2409f$export$5aaf7ff7f09ea4ee; }, function (v) { return $0a65a613f4c2409f$export$5aaf7ff7f09ea4ee = v; });
var $0a65a613f4c2409f$export$9a09e32dd4990fd5;
var $0a65a613f4c2409f$export$81d53e3678089a6;
var $0a65a613f4c2409f$export$5aaf7ff7f09ea4ee;
"use strict";
$0a65a613f4c2409f$export$9a09e32dd4990fd5 = $0a65a613f4c2409f$export$81d53e3678089a6 = $0a65a613f4c2409f$export$5aaf7ff7f09ea4ee = void 0;

var $bCb32 = parcelRequire("bCb32");

var $02yAu = parcelRequire("02yAu");
const $0a65a613f4c2409f$var$TIMEZONE_UNIT_PRIORITY = 10;
class $0a65a613f4c2409f$var$Setter {
    subPriority = 0;
    validate(_utcDate, _options) {
        return true;
    }
}
$0a65a613f4c2409f$export$81d53e3678089a6 = $0a65a613f4c2409f$var$Setter;
class $0a65a613f4c2409f$var$ValueSetter extends $0a65a613f4c2409f$var$Setter {
    constructor(value, validateValue, setValue, priority, subPriority){
        super();
        this.value = value;
        this.validateValue = validateValue;
        this.setValue = setValue;
        this.priority = priority;
        if (subPriority) this.subPriority = subPriority;
    }
    validate(date, options) {
        return this.validateValue(date, this.value, options);
    }
    set(date, flags, options) {
        return this.setValue(date, flags, this.value, options);
    }
}
$0a65a613f4c2409f$export$9a09e32dd4990fd5 = $0a65a613f4c2409f$var$ValueSetter;
class $0a65a613f4c2409f$var$DateToSystemTimezoneSetter extends $0a65a613f4c2409f$var$Setter {
    priority = $0a65a613f4c2409f$var$TIMEZONE_UNIT_PRIORITY;
    subPriority = -1;
    set(date, flags) {
        if (flags.timestampIsSet) return date;
        return (0, $02yAu.constructFrom)(date, (0, $bCb32.transpose)(date, Date));
    }
}
$0a65a613f4c2409f$export$5aaf7ff7f09ea4ee = $0a65a613f4c2409f$var$DateToSystemTimezoneSetter;

});
parcelRegister("bCb32", function(module, exports) {

$parcel$export(module.exports, "transpose", function () { return $874bd03dd29c01f5$export$9cb09a71b7d66923; }, function (v) { return $874bd03dd29c01f5$export$9cb09a71b7d66923 = v; });
var $874bd03dd29c01f5$export$9cb09a71b7d66923;
"use strict";
$874bd03dd29c01f5$export$9cb09a71b7d66923 = $874bd03dd29c01f5$var$transpose;

var $02yAu = parcelRequire("02yAu");
/**
 * @name transpose
 * @category Generic Helpers
 * @summary Transpose the date to the given constructor.
 *
 * @description
 * The function transposes the date to the given constructor. It helps you
 * to transpose the date in the system time zone to say `UTCDate` or any other
 * date extension.
 *
 * @typeParam DateInputType - The input `Date` type derived from the passed argument.
 * @typeParam DateOutputType - The output `Date` type derived from the passed constructor.
 *
 * @param fromDate - The date to use values from
 * @param constructor - The date constructor to use
 *
 * @returns Date transposed to the given constructor
 *
 * @example
 * // Create July 10, 2022 00:00 in locale time zone
 * const date = new Date(2022, 6, 10)
 * //=> 'Sun Jul 10 2022 00:00:00 GMT+0800 (Singapore Standard Time)'
 *
 * @example
 * // Transpose the date to July 10, 2022 00:00 in UTC
 * transpose(date, UTCDate)
 * //=> 'Sun Jul 10 2022 00:00:00 GMT+0000 (Coordinated Universal Time)'
 */ function $874bd03dd29c01f5$var$transpose(fromDate, constructor) {
    const date = constructor instanceof Date ? (0, $02yAu.constructFrom)(constructor, 0) : new constructor(0);
    date.setFullYear(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate());
    date.setHours(fromDate.getHours(), fromDate.getMinutes(), fromDate.getSeconds(), fromDate.getMilliseconds());
    return date;
}

});




parcelRegister("gzz2V", function(module, exports) {

$parcel$export(module.exports, "YearParser", function () { return $c10b19ae5b33b37b$export$48d352de7cd4a988; }, function (v) { return $c10b19ae5b33b37b$export$48d352de7cd4a988 = v; });
var $c10b19ae5b33b37b$export$48d352de7cd4a988;
"use strict";
$c10b19ae5b33b37b$export$48d352de7cd4a988 = void 0;

var $2cMli = parcelRequire("2cMli");

var $lJRPt = parcelRequire("lJRPt");
// From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
// | Year     |     y | yy |   yyy |  yyyy | yyyyy |
// |----------|-------|----|-------|-------|-------|
// | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
// | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
// | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
// | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
// | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
class $c10b19ae5b33b37b$var$YearParser extends $2cMli.Parser {
    priority = 130;
    incompatibleTokens = [
        "Y",
        "R",
        "u",
        "w",
        "I",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
    parse(dateString, token, match) {
        const valueCallback = (year)=>({
                year: year,
                isTwoDigitYear: token === "yy"
            });
        switch(token){
            case "y":
                return (0, $lJRPt.mapValue)((0, $lJRPt.parseNDigits)(4, dateString), valueCallback);
            case "yo":
                return (0, $lJRPt.mapValue)(match.ordinalNumber(dateString, {
                    unit: "year"
                }), valueCallback);
            default:
                return (0, $lJRPt.mapValue)((0, $lJRPt.parseNDigits)(token.length, dateString), valueCallback);
        }
    }
    validate(_date, value) {
        return value.isTwoDigitYear || value.year > 0;
    }
    set(date, flags, value) {
        const currentYear = date.getFullYear();
        if (value.isTwoDigitYear) {
            const normalizedTwoDigitYear = (0, $lJRPt.normalizeTwoDigitYear)(value.year, currentYear);
            date.setFullYear(normalizedTwoDigitYear, 0, 1);
            date.setHours(0, 0, 0, 0);
            return date;
        }
        const year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
        date.setFullYear(year, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
}
$c10b19ae5b33b37b$export$48d352de7cd4a988 = $c10b19ae5b33b37b$var$YearParser;

});
parcelRegister("lJRPt", function(module, exports) {

$parcel$export(module.exports, "dayPeriodEnumToHours", function () { return $fd378e53808b4e99$export$fb506d2676e7f207; }, function (v) { return $fd378e53808b4e99$export$fb506d2676e7f207 = v; });
$parcel$export(module.exports, "isLeapYearIndex", function () { return $fd378e53808b4e99$export$3d50627710b84d75; }, function (v) { return $fd378e53808b4e99$export$3d50627710b84d75 = v; });
$parcel$export(module.exports, "mapValue", function () { return $fd378e53808b4e99$export$4f84e3a82c7b538; }, function (v) { return $fd378e53808b4e99$export$4f84e3a82c7b538 = v; });
$parcel$export(module.exports, "normalizeTwoDigitYear", function () { return $fd378e53808b4e99$export$29126f735cbf69f7; }, function (v) { return $fd378e53808b4e99$export$29126f735cbf69f7 = v; });
$parcel$export(module.exports, "parseAnyDigitsSigned", function () { return $fd378e53808b4e99$export$d931c43c4608a164; }, function (v) { return $fd378e53808b4e99$export$d931c43c4608a164 = v; });
$parcel$export(module.exports, "parseNDigits", function () { return $fd378e53808b4e99$export$513bb01536146ab6; }, function (v) { return $fd378e53808b4e99$export$513bb01536146ab6 = v; });
$parcel$export(module.exports, "parseNDigitsSigned", function () { return $fd378e53808b4e99$export$2c9307b2e29c533c; }, function (v) { return $fd378e53808b4e99$export$2c9307b2e29c533c = v; });
$parcel$export(module.exports, "parseNumericPattern", function () { return $fd378e53808b4e99$export$cc7cc9e2a3ff9388; }, function (v) { return $fd378e53808b4e99$export$cc7cc9e2a3ff9388 = v; });
$parcel$export(module.exports, "parseTimezonePattern", function () { return $fd378e53808b4e99$export$6497f4c0ecdfba8e; }, function (v) { return $fd378e53808b4e99$export$6497f4c0ecdfba8e = v; });
var $fd378e53808b4e99$export$fb506d2676e7f207;
var $fd378e53808b4e99$export$3d50627710b84d75;
var $fd378e53808b4e99$export$4f84e3a82c7b538;
var $fd378e53808b4e99$export$29126f735cbf69f7;
var $fd378e53808b4e99$export$d931c43c4608a164;
var $fd378e53808b4e99$export$513bb01536146ab6;
var $fd378e53808b4e99$export$2c9307b2e29c533c;
var $fd378e53808b4e99$export$cc7cc9e2a3ff9388;
var $fd378e53808b4e99$export$6497f4c0ecdfba8e;
"use strict";
$fd378e53808b4e99$export$fb506d2676e7f207 = $fd378e53808b4e99$var$dayPeriodEnumToHours;
$fd378e53808b4e99$export$3d50627710b84d75 = $fd378e53808b4e99$var$isLeapYearIndex;
$fd378e53808b4e99$export$4f84e3a82c7b538 = $fd378e53808b4e99$var$mapValue;
$fd378e53808b4e99$export$29126f735cbf69f7 = $fd378e53808b4e99$var$normalizeTwoDigitYear;
$fd378e53808b4e99$export$d931c43c4608a164 = $fd378e53808b4e99$var$parseAnyDigitsSigned;
$fd378e53808b4e99$export$513bb01536146ab6 = $fd378e53808b4e99$var$parseNDigits;
$fd378e53808b4e99$export$2c9307b2e29c533c = $fd378e53808b4e99$var$parseNDigitsSigned;
$fd378e53808b4e99$export$cc7cc9e2a3ff9388 = $fd378e53808b4e99$var$parseNumericPattern;
$fd378e53808b4e99$export$6497f4c0ecdfba8e = $fd378e53808b4e99$var$parseTimezonePattern;

var $7MMvH = parcelRequire("7MMvH");

var $ezdGm = parcelRequire("ezdGm");
function $fd378e53808b4e99$var$mapValue(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function $fd378e53808b4e99$var$parseNumericPattern(pattern, dateString) {
    const matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $fd378e53808b4e99$var$parseTimezonePattern(pattern, dateString) {
    const matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === "Z") return {
        value: 0,
        rest: dateString.slice(1)
    };
    const sign = matchResult[1] === "+" ? 1 : -1;
    const hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    const minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    const seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * $7MMvH.millisecondsInHour + minutes * $7MMvH.millisecondsInMinute + seconds * $7MMvH.millisecondsInSecond),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $fd378e53808b4e99$var$parseAnyDigitsSigned(dateString) {
    return $fd378e53808b4e99$var$parseNumericPattern($ezdGm.numericPatterns.anyDigitsSigned, dateString);
}
function $fd378e53808b4e99$var$parseNDigits(n, dateString) {
    switch(n){
        case 1:
            return $fd378e53808b4e99$var$parseNumericPattern($ezdGm.numericPatterns.singleDigit, dateString);
        case 2:
            return $fd378e53808b4e99$var$parseNumericPattern($ezdGm.numericPatterns.twoDigits, dateString);
        case 3:
            return $fd378e53808b4e99$var$parseNumericPattern($ezdGm.numericPatterns.threeDigits, dateString);
        case 4:
            return $fd378e53808b4e99$var$parseNumericPattern($ezdGm.numericPatterns.fourDigits, dateString);
        default:
            return $fd378e53808b4e99$var$parseNumericPattern(new RegExp("^\\d{1," + n + "}"), dateString);
    }
}
function $fd378e53808b4e99$var$parseNDigitsSigned(n, dateString) {
    switch(n){
        case 1:
            return $fd378e53808b4e99$var$parseNumericPattern($ezdGm.numericPatterns.singleDigitSigned, dateString);
        case 2:
            return $fd378e53808b4e99$var$parseNumericPattern($ezdGm.numericPatterns.twoDigitsSigned, dateString);
        case 3:
            return $fd378e53808b4e99$var$parseNumericPattern($ezdGm.numericPatterns.threeDigitsSigned, dateString);
        case 4:
            return $fd378e53808b4e99$var$parseNumericPattern($ezdGm.numericPatterns.fourDigitsSigned, dateString);
        default:
            return $fd378e53808b4e99$var$parseNumericPattern(new RegExp("^-?\\d{1," + n + "}"), dateString);
    }
}
function $fd378e53808b4e99$var$dayPeriodEnumToHours(dayPeriod) {
    switch(dayPeriod){
        case "morning":
            return 4;
        case "evening":
            return 17;
        case "pm":
        case "noon":
        case "afternoon":
            return 12;
        case "am":
        case "midnight":
        case "night":
        default:
            return 0;
    }
}
function $fd378e53808b4e99$var$normalizeTwoDigitYear(twoDigitYear, currentYear) {
    const isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    const absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    let result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        const rangeEnd = absCurrentYear + 50;
        const rangeEndCentury = Math.trunc(rangeEnd / 100) * 100;
        const isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function $fd378e53808b4e99$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

});
parcelRegister("ezdGm", function(module, exports) {

$parcel$export(module.exports, "timezonePatterns", function () { return $a9aef29346221758$export$a7ee192b982af9c1; }, function (v) { return $a9aef29346221758$export$a7ee192b982af9c1 = v; });
$parcel$export(module.exports, "numericPatterns", function () { return $a9aef29346221758$export$c123ee06d9da8480; }, function (v) { return $a9aef29346221758$export$c123ee06d9da8480 = v; });
var $a9aef29346221758$export$a7ee192b982af9c1;
var $a9aef29346221758$export$c123ee06d9da8480;
"use strict";
$a9aef29346221758$export$a7ee192b982af9c1 = $a9aef29346221758$export$c123ee06d9da8480 = void 0;
const $a9aef29346221758$var$numericPatterns = $a9aef29346221758$export$c123ee06d9da8480 = {
    month: /^(1[0-2]|0?\d)/,
    date: /^(3[0-1]|[0-2]?\d)/,
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    week: /^(5[0-3]|[0-4]?\d)/,
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    hour11h: /^(1[0-1]|0?\d)/,
    hour12h: /^(1[0-2]|0?\d)/,
    minute: /^[0-5]?\d/,
    second: /^[0-5]?\d/,
    singleDigit: /^\d/,
    twoDigits: /^\d{1,2}/,
    threeDigits: /^\d{1,3}/,
    fourDigits: /^\d{1,4}/,
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    twoDigitsSigned: /^-?\d{1,2}/,
    threeDigitsSigned: /^-?\d{1,3}/,
    fourDigitsSigned: /^-?\d{1,4}/
};
const $a9aef29346221758$var$timezonePatterns = $a9aef29346221758$export$a7ee192b982af9c1 = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};

});



parcelRegister("ksPCt", function(module, exports) {

$parcel$export(module.exports, "LocalWeekYearParser", function () { return $ee5e76bca1e61bf2$export$b8ef38dfcf05d5db; }, function (v) { return $ee5e76bca1e61bf2$export$b8ef38dfcf05d5db = v; });
var $ee5e76bca1e61bf2$export$b8ef38dfcf05d5db;
"use strict";
$ee5e76bca1e61bf2$export$b8ef38dfcf05d5db = void 0;

var $aY23c = parcelRequire("aY23c");

var $isuGI = parcelRequire("isuGI");

var $2cMli = parcelRequire("2cMli");

var $lJRPt = parcelRequire("lJRPt");
// Local week-numbering year
class $ee5e76bca1e61bf2$var$LocalWeekYearParser extends $2cMli.Parser {
    priority = 130;
    parse(dateString, token, match) {
        const valueCallback = (year)=>({
                year: year,
                isTwoDigitYear: token === "YY"
            });
        switch(token){
            case "Y":
                return (0, $lJRPt.mapValue)((0, $lJRPt.parseNDigits)(4, dateString), valueCallback);
            case "Yo":
                return (0, $lJRPt.mapValue)(match.ordinalNumber(dateString, {
                    unit: "year"
                }), valueCallback);
            default:
                return (0, $lJRPt.mapValue)((0, $lJRPt.parseNDigits)(token.length, dateString), valueCallback);
        }
    }
    validate(_date, value) {
        return value.isTwoDigitYear || value.year > 0;
    }
    set(date, flags, value, options) {
        const currentYear = (0, $aY23c.getWeekYear)(date, options);
        if (value.isTwoDigitYear) {
            const normalizedTwoDigitYear = (0, $lJRPt.normalizeTwoDigitYear)(value.year, currentYear);
            date.setFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
            date.setHours(0, 0, 0, 0);
            return (0, $isuGI.startOfWeek)(date, options);
        }
        const year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
        date.setFullYear(year, 0, options.firstWeekContainsDate);
        date.setHours(0, 0, 0, 0);
        return (0, $isuGI.startOfWeek)(date, options);
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "Q",
        "q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "i",
        "t",
        "T"
    ];
}
$ee5e76bca1e61bf2$export$b8ef38dfcf05d5db = $ee5e76bca1e61bf2$var$LocalWeekYearParser;

});

parcelRegister("tZOQp", function(module, exports) {

$parcel$export(module.exports, "ISOWeekYearParser", function () { return $05a2a986f90b8e18$export$951d1df011fde06f; }, function (v) { return $05a2a986f90b8e18$export$951d1df011fde06f = v; });
var $05a2a986f90b8e18$export$951d1df011fde06f;
"use strict";
$05a2a986f90b8e18$export$951d1df011fde06f = void 0;

var $4x8aw = parcelRequire("4x8aw");

var $02yAu = parcelRequire("02yAu");

var $2cMli = parcelRequire("2cMli");

var $lJRPt = parcelRequire("lJRPt");
// ISO week-numbering year
class $05a2a986f90b8e18$var$ISOWeekYearParser extends $2cMli.Parser {
    priority = 130;
    parse(dateString, token) {
        if (token === "R") return (0, $lJRPt.parseNDigitsSigned)(4, dateString);
        return (0, $lJRPt.parseNDigitsSigned)(token.length, dateString);
    }
    set(date, _flags, value) {
        const firstWeekOfYear = (0, $02yAu.constructFrom)(date, 0);
        firstWeekOfYear.setFullYear(value, 0, 4);
        firstWeekOfYear.setHours(0, 0, 0, 0);
        return (0, $4x8aw.startOfISOWeek)(firstWeekOfYear);
    }
    incompatibleTokens = [
        "G",
        "y",
        "Y",
        "u",
        "Q",
        "q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "e",
        "c",
        "t",
        "T"
    ];
}
$05a2a986f90b8e18$export$951d1df011fde06f = $05a2a986f90b8e18$var$ISOWeekYearParser;

});

parcelRegister("bdQql", function(module, exports) {

$parcel$export(module.exports, "ExtendedYearParser", function () { return $82b992ecb7dd6063$export$bad9d2ea38e8f1a; }, function (v) { return $82b992ecb7dd6063$export$bad9d2ea38e8f1a = v; });
var $82b992ecb7dd6063$export$bad9d2ea38e8f1a;
"use strict";
$82b992ecb7dd6063$export$bad9d2ea38e8f1a = void 0;

var $2cMli = parcelRequire("2cMli");

var $lJRPt = parcelRequire("lJRPt");
class $82b992ecb7dd6063$var$ExtendedYearParser extends $2cMli.Parser {
    priority = 130;
    parse(dateString, token) {
        if (token === "u") return (0, $lJRPt.parseNDigitsSigned)(4, dateString);
        return (0, $lJRPt.parseNDigitsSigned)(token.length, dateString);
    }
    set(date, _flags, value) {
        date.setFullYear(value, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "G",
        "y",
        "Y",
        "R",
        "w",
        "I",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$82b992ecb7dd6063$export$bad9d2ea38e8f1a = $82b992ecb7dd6063$var$ExtendedYearParser;

});

parcelRegister("lH7Pa", function(module, exports) {

$parcel$export(module.exports, "QuarterParser", function () { return $fcb3aee29e6a3438$export$5cb0f701186dde1d; }, function (v) { return $fcb3aee29e6a3438$export$5cb0f701186dde1d = v; });
var $fcb3aee29e6a3438$export$5cb0f701186dde1d;
"use strict";
$fcb3aee29e6a3438$export$5cb0f701186dde1d = void 0;

var $2cMli = parcelRequire("2cMli");

var $lJRPt = parcelRequire("lJRPt");
class $fcb3aee29e6a3438$var$QuarterParser extends $2cMli.Parser {
    priority = 120;
    parse(dateString, token, match) {
        switch(token){
            // 1, 2, 3, 4
            case "Q":
            case "QQ":
                return (0, $lJRPt.parseNDigits)(token.length, dateString);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return match.ordinalNumber(dateString, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return match.quarter(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return match.quarter(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 4;
    }
    set(date, _flags, value) {
        date.setMonth((value - 1) * 3, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$fcb3aee29e6a3438$export$5cb0f701186dde1d = $fcb3aee29e6a3438$var$QuarterParser;

});

parcelRegister("ad9zr", function(module, exports) {

$parcel$export(module.exports, "StandAloneQuarterParser", function () { return $76f28ac99106b54f$export$300c0c2990e20e6d; }, function (v) { return $76f28ac99106b54f$export$300c0c2990e20e6d = v; });
var $76f28ac99106b54f$export$300c0c2990e20e6d;
"use strict";
$76f28ac99106b54f$export$300c0c2990e20e6d = void 0;

var $2cMli = parcelRequire("2cMli");

var $lJRPt = parcelRequire("lJRPt");
class $76f28ac99106b54f$var$StandAloneQuarterParser extends $2cMli.Parser {
    priority = 120;
    parse(dateString, token, match) {
        switch(token){
            // 1, 2, 3, 4
            case "q":
            case "qq":
                return (0, $lJRPt.parseNDigits)(token.length, dateString);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return match.ordinalNumber(dateString, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return match.quarter(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return match.quarter(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 4;
    }
    set(date, _flags, value) {
        date.setMonth((value - 1) * 3, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "Q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$76f28ac99106b54f$export$300c0c2990e20e6d = $76f28ac99106b54f$var$StandAloneQuarterParser;

});

parcelRegister("l5WxN", function(module, exports) {

$parcel$export(module.exports, "MonthParser", function () { return $f5b77a40a274029a$export$400dd8b40ef138a3; }, function (v) { return $f5b77a40a274029a$export$400dd8b40ef138a3 = v; });
var $f5b77a40a274029a$export$400dd8b40ef138a3;
"use strict";
$f5b77a40a274029a$export$400dd8b40ef138a3 = void 0;

var $ezdGm = parcelRequire("ezdGm");

var $2cMli = parcelRequire("2cMli");

var $lJRPt = parcelRequire("lJRPt");
class $f5b77a40a274029a$var$MonthParser extends $2cMli.Parser {
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "L",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
    priority = 110;
    parse(dateString, token, match) {
        const valueCallback = (value)=>value - 1;
        switch(token){
            // 1, 2, ..., 12
            case "M":
                return (0, $lJRPt.mapValue)((0, $lJRPt.parseNumericPattern)($ezdGm.numericPatterns.month, dateString), valueCallback);
            // 01, 02, ..., 12
            case "MM":
                return (0, $lJRPt.mapValue)((0, $lJRPt.parseNDigits)(2, dateString), valueCallback);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return (0, $lJRPt.mapValue)(match.ordinalNumber(dateString, {
                    unit: "month"
                }), valueCallback);
            // Jan, Feb, ..., Dec
            case "MMM":
                return match.month(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return match.month(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        date.setMonth(value, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
}
$f5b77a40a274029a$export$400dd8b40ef138a3 = $f5b77a40a274029a$var$MonthParser;

});

parcelRegister("9Srm8", function(module, exports) {

$parcel$export(module.exports, "StandAloneMonthParser", function () { return $730e609003f4731c$export$1d7eaa53eaa5deba; }, function (v) { return $730e609003f4731c$export$1d7eaa53eaa5deba = v; });
var $730e609003f4731c$export$1d7eaa53eaa5deba;
"use strict";
$730e609003f4731c$export$1d7eaa53eaa5deba = void 0;

var $ezdGm = parcelRequire("ezdGm");

var $2cMli = parcelRequire("2cMli");

var $lJRPt = parcelRequire("lJRPt");
class $730e609003f4731c$var$StandAloneMonthParser extends $2cMli.Parser {
    priority = 110;
    parse(dateString, token, match) {
        const valueCallback = (value)=>value - 1;
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return (0, $lJRPt.mapValue)((0, $lJRPt.parseNumericPattern)($ezdGm.numericPatterns.month, dateString), valueCallback);
            // 01, 02, ..., 12
            case "LL":
                return (0, $lJRPt.mapValue)((0, $lJRPt.parseNDigits)(2, dateString), valueCallback);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return (0, $lJRPt.mapValue)(match.ordinalNumber(dateString, {
                    unit: "month"
                }), valueCallback);
            // Jan, Feb, ..., Dec
            case "LLL":
                return match.month(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return match.month(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        date.setMonth(value, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "M",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$730e609003f4731c$export$1d7eaa53eaa5deba = $730e609003f4731c$var$StandAloneMonthParser;

});

parcelRegister("axzsB", function(module, exports) {

$parcel$export(module.exports, "LocalWeekParser", function () { return $7ac87e28231dade8$export$c4005ffc174e07c0; }, function (v) { return $7ac87e28231dade8$export$c4005ffc174e07c0 = v; });
var $7ac87e28231dade8$export$c4005ffc174e07c0;
"use strict";
$7ac87e28231dade8$export$c4005ffc174e07c0 = void 0;

var $2zwzb = parcelRequire("2zwzb");

var $isuGI = parcelRequire("isuGI");

var $ezdGm = parcelRequire("ezdGm");

var $2cMli = parcelRequire("2cMli");

var $lJRPt = parcelRequire("lJRPt");
// Local week of year
class $7ac87e28231dade8$var$LocalWeekParser extends $2cMli.Parser {
    priority = 100;
    parse(dateString, token, match) {
        switch(token){
            case "w":
                return (0, $lJRPt.parseNumericPattern)($ezdGm.numericPatterns.week, dateString);
            case "wo":
                return match.ordinalNumber(dateString, {
                    unit: "week"
                });
            default:
                return (0, $lJRPt.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 53;
    }
    set(date, _flags, value, options) {
        return (0, $isuGI.startOfWeek)((0, $2zwzb.setWeek)(date, value, options), options);
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "i",
        "t",
        "T"
    ];
}
$7ac87e28231dade8$export$c4005ffc174e07c0 = $7ac87e28231dade8$var$LocalWeekParser;

});
parcelRegister("2zwzb", function(module, exports) {

$parcel$export(module.exports, "setWeek", function () { return $1df81cab76c25275$export$4b3066ce4afafd88; }, function (v) { return $1df81cab76c25275$export$4b3066ce4afafd88 = v; });
var $1df81cab76c25275$export$4b3066ce4afafd88;
"use strict";
$1df81cab76c25275$export$4b3066ce4afafd88 = $1df81cab76c25275$var$setWeek;

var $8S0vk = parcelRequire("8S0vk");

var $b3MCU = parcelRequire("b3MCU");
/**
 * The {@link setWeek} function options.
 */ /**
 * @name setWeek
 * @category Week Helpers
 * @summary Set the local week to the given date.
 *
 * @description
 * Set the local week to the given date, saving the weekday number.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param week - The week of the new date
 * @param options - An object with options
 *
 * @returns The new date with the local week set
 *
 * @example
 * // Set the 1st week to 2 January 2005 with default options:
 * const result = setWeek(new Date(2005, 0, 2), 1)
 * //=> Sun Dec 26 2004 00:00:00
 *
 * @example
 * // Set the 1st week to 2 January 2005,
 * // if Monday is the first day of the week,
 * // and the first week of the year always contains 4 January:
 * const result = setWeek(new Date(2005, 0, 2), 1, {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Sun Jan 4 2004 00:00:00
 */ function $1df81cab76c25275$var$setWeek(date, week, options) {
    const _date = (0, $b3MCU.toDate)(date);
    const diff = (0, $8S0vk.getWeek)(_date, options) - week;
    _date.setDate(_date.getDate() - diff * 7);
    return _date;
}

});


parcelRegister("ldXwh", function(module, exports) {

$parcel$export(module.exports, "ISOWeekParser", function () { return $f738fb41547dcb31$export$6fc8dbedd560a6af; }, function (v) { return $f738fb41547dcb31$export$6fc8dbedd560a6af = v; });
var $f738fb41547dcb31$export$6fc8dbedd560a6af;
"use strict";
$f738fb41547dcb31$export$6fc8dbedd560a6af = void 0;

var $bSZqj = parcelRequire("bSZqj");

var $4x8aw = parcelRequire("4x8aw");

var $ezdGm = parcelRequire("ezdGm");

var $2cMli = parcelRequire("2cMli");

var $lJRPt = parcelRequire("lJRPt");
// ISO week of year
class $f738fb41547dcb31$var$ISOWeekParser extends $2cMli.Parser {
    priority = 100;
    parse(dateString, token, match) {
        switch(token){
            case "I":
                return (0, $lJRPt.parseNumericPattern)($ezdGm.numericPatterns.week, dateString);
            case "Io":
                return match.ordinalNumber(dateString, {
                    unit: "week"
                });
            default:
                return (0, $lJRPt.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 53;
    }
    set(date, _flags, value) {
        return (0, $4x8aw.startOfISOWeek)((0, $bSZqj.setISOWeek)(date, value));
    }
    incompatibleTokens = [
        "y",
        "Y",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "e",
        "c",
        "t",
        "T"
    ];
}
$f738fb41547dcb31$export$6fc8dbedd560a6af = $f738fb41547dcb31$var$ISOWeekParser;

});
parcelRegister("bSZqj", function(module, exports) {

$parcel$export(module.exports, "setISOWeek", function () { return $8a746241c82d07ea$export$6542bebf6be94082; }, function (v) { return $8a746241c82d07ea$export$6542bebf6be94082 = v; });
var $8a746241c82d07ea$export$6542bebf6be94082;
"use strict";
$8a746241c82d07ea$export$6542bebf6be94082 = $8a746241c82d07ea$var$setISOWeek;

var $dGxHQ = parcelRequire("dGxHQ");

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name setISOWeek
 * @category ISO Week Helpers
 * @summary Set the ISO week to the given date.
 *
 * @description
 * Set the ISO week to the given date, saving the weekday number.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param week - The ISO week of the new date
 *
 * @returns The new date with the ISO week set
 *
 * @example
 * // Set the 53rd ISO week to 7 August 2004:
 * const result = setISOWeek(new Date(2004, 7, 7), 53)
 * //=> Sat Jan 01 2005 00:00:00
 */ function $8a746241c82d07ea$var$setISOWeek(date, week) {
    const _date = (0, $b3MCU.toDate)(date);
    const diff = (0, $dGxHQ.getISOWeek)(_date) - week;
    _date.setDate(_date.getDate() - diff * 7);
    return _date;
}

});


parcelRegister("9YyKE", function(module, exports) {

$parcel$export(module.exports, "DateParser", function () { return $7434ac944ea6aa3b$export$e8d4b28a20981dd2; }, function (v) { return $7434ac944ea6aa3b$export$e8d4b28a20981dd2 = v; });
var $7434ac944ea6aa3b$export$e8d4b28a20981dd2;
"use strict";
$7434ac944ea6aa3b$export$e8d4b28a20981dd2 = void 0;

var $ezdGm = parcelRequire("ezdGm");

var $2cMli = parcelRequire("2cMli");

var $lJRPt = parcelRequire("lJRPt");
const $7434ac944ea6aa3b$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
const $7434ac944ea6aa3b$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
// Day of the month
class $7434ac944ea6aa3b$var$DateParser extends $2cMli.Parser {
    priority = 90;
    subPriority = 1;
    parse(dateString, token, match) {
        switch(token){
            case "d":
                return (0, $lJRPt.parseNumericPattern)($ezdGm.numericPatterns.date, dateString);
            case "do":
                return match.ordinalNumber(dateString, {
                    unit: "date"
                });
            default:
                return (0, $lJRPt.parseNDigits)(token.length, dateString);
        }
    }
    validate(date, value) {
        const year = date.getFullYear();
        const isLeapYear = (0, $lJRPt.isLeapYearIndex)(year);
        const month = date.getMonth();
        if (isLeapYear) return value >= 1 && value <= $7434ac944ea6aa3b$var$DAYS_IN_MONTH_LEAP_YEAR[month];
        else return value >= 1 && value <= $7434ac944ea6aa3b$var$DAYS_IN_MONTH[month];
    }
    set(date, _flags, value) {
        date.setDate(value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$7434ac944ea6aa3b$export$e8d4b28a20981dd2 = $7434ac944ea6aa3b$var$DateParser;

});

parcelRegister("89sxi", function(module, exports) {

$parcel$export(module.exports, "DayOfYearParser", function () { return $5ef54cac60897076$export$6cfe0d613455f615; }, function (v) { return $5ef54cac60897076$export$6cfe0d613455f615 = v; });
var $5ef54cac60897076$export$6cfe0d613455f615;
"use strict";
$5ef54cac60897076$export$6cfe0d613455f615 = void 0;

var $ezdGm = parcelRequire("ezdGm");

var $2cMli = parcelRequire("2cMli");

var $lJRPt = parcelRequire("lJRPt");
class $5ef54cac60897076$var$DayOfYearParser extends $2cMli.Parser {
    priority = 90;
    subpriority = 1;
    parse(dateString, token, match) {
        switch(token){
            case "D":
            case "DD":
                return (0, $lJRPt.parseNumericPattern)($ezdGm.numericPatterns.dayOfYear, dateString);
            case "Do":
                return match.ordinalNumber(dateString, {
                    unit: "date"
                });
            default:
                return (0, $lJRPt.parseNDigits)(token.length, dateString);
        }
    }
    validate(date, value) {
        const year = date.getFullYear();
        const isLeapYear = (0, $lJRPt.isLeapYearIndex)(year);
        if (isLeapYear) return value >= 1 && value <= 366;
        else return value >= 1 && value <= 365;
    }
    set(date, _flags, value) {
        date.setMonth(0, value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "E",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$5ef54cac60897076$export$6cfe0d613455f615 = $5ef54cac60897076$var$DayOfYearParser;

});

parcelRegister("d1uav", function(module, exports) {

$parcel$export(module.exports, "DayParser", function () { return $97b2c5293b016028$export$1b03c8b76262f7bd; }, function (v) { return $97b2c5293b016028$export$1b03c8b76262f7bd = v; });
var $97b2c5293b016028$export$1b03c8b76262f7bd;
"use strict";
$97b2c5293b016028$export$1b03c8b76262f7bd = void 0;

var $eROmU = parcelRequire("eROmU");

var $2cMli = parcelRequire("2cMli");
// Day of week
class $97b2c5293b016028$var$DayParser extends $2cMli.Parser {
    priority = 90;
    parse(dateString, token, match) {
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $eROmU.setDay)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$97b2c5293b016028$export$1b03c8b76262f7bd = $97b2c5293b016028$var$DayParser;

});
parcelRegister("eROmU", function(module, exports) {

$parcel$export(module.exports, "setDay", function () { return $ad2d161376151a70$export$b04fdcda82decc6c; }, function (v) { return $ad2d161376151a70$export$b04fdcda82decc6c = v; });
var $ad2d161376151a70$export$b04fdcda82decc6c;
"use strict";
$ad2d161376151a70$export$b04fdcda82decc6c = $ad2d161376151a70$var$setDay;

var $cBVis = parcelRequire("cBVis");

var $b3MCU = parcelRequire("b3MCU");

var $lJvf9 = parcelRequire("lJvf9");
/**
 * The {@link setDay} function options.
 */ /**
 * @name setDay
 * @category Weekday Helpers
 * @summary Set the day of the week to the given date.
 *
 * @description
 * Set the day of the week to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param day - The day of the week of the new date
 * @param options - An object with options.
 *
 * @returns The new date with the day of the week set
 *
 * @example
 * // Set week day to Sunday, with the default weekStartsOn of Sunday:
 * const result = setDay(new Date(2014, 8, 1), 0)
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // Set week day to Sunday, with a weekStartsOn of Monday:
 * const result = setDay(new Date(2014, 8, 1), 0, { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 00:00:00
 */ function $ad2d161376151a70$var$setDay(date, day, options) {
    const defaultOptions = (0, $lJvf9.getDefaultOptions)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $b3MCU.toDate)(date);
    const currentDay = _date.getDay();
    const remainder = day % 7;
    const dayIndex = (remainder + 7) % 7;
    const delta = 7 - weekStartsOn;
    const diff = day < 0 || day > 6 ? day - (currentDay + delta) % 7 : (dayIndex + delta) % 7 - (currentDay + delta) % 7;
    return (0, $cBVis.addDays)(_date, diff);
}

});


parcelRegister("cWMDO", function(module, exports) {

$parcel$export(module.exports, "LocalDayParser", function () { return $96d0a1efffec6725$export$44d1c127ab42c480; }, function (v) { return $96d0a1efffec6725$export$44d1c127ab42c480 = v; });
var $96d0a1efffec6725$export$44d1c127ab42c480;
"use strict";
$96d0a1efffec6725$export$44d1c127ab42c480 = void 0;

var $eROmU = parcelRequire("eROmU");

var $2cMli = parcelRequire("2cMli");

var $lJRPt = parcelRequire("lJRPt");
// Local day of week
class $96d0a1efffec6725$var$LocalDayParser extends $2cMli.Parser {
    priority = 90;
    parse(dateString, token, match, options) {
        const valueCallback = (value)=>{
            // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
            const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
            return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
        };
        switch(token){
            // 3
            case "e":
            case "ee":
                return (0, $lJRPt.mapValue)((0, $lJRPt.parseNDigits)(token.length, dateString), valueCallback);
            // 3rd
            case "eo":
                return (0, $lJRPt.mapValue)(match.ordinalNumber(dateString, {
                    unit: "day"
                }), valueCallback);
            // Tue
            case "eee":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $eROmU.setDay)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "E",
        "i",
        "c",
        "t",
        "T"
    ];
}
$96d0a1efffec6725$export$44d1c127ab42c480 = $96d0a1efffec6725$var$LocalDayParser;

});

parcelRegister("eZTqi", function(module, exports) {

$parcel$export(module.exports, "StandAloneLocalDayParser", function () { return $aeb1c10ee54aeb56$export$e447a647caaaec1d; }, function (v) { return $aeb1c10ee54aeb56$export$e447a647caaaec1d = v; });
var $aeb1c10ee54aeb56$export$e447a647caaaec1d;
"use strict";
$aeb1c10ee54aeb56$export$e447a647caaaec1d = void 0;

var $eROmU = parcelRequire("eROmU");

var $2cMli = parcelRequire("2cMli");

var $lJRPt = parcelRequire("lJRPt");
// Stand-alone local day of week
class $aeb1c10ee54aeb56$var$StandAloneLocalDayParser extends $2cMli.Parser {
    priority = 90;
    parse(dateString, token, match, options) {
        const valueCallback = (value)=>{
            // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
            const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
            return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
        };
        switch(token){
            // 3
            case "c":
            case "cc":
                return (0, $lJRPt.mapValue)((0, $lJRPt.parseNDigits)(token.length, dateString), valueCallback);
            // 3rd
            case "co":
                return (0, $lJRPt.mapValue)(match.ordinalNumber(dateString, {
                    unit: "day"
                }), valueCallback);
            // Tue
            case "ccc":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $eROmU.setDay)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "E",
        "i",
        "e",
        "t",
        "T"
    ];
}
$aeb1c10ee54aeb56$export$e447a647caaaec1d = $aeb1c10ee54aeb56$var$StandAloneLocalDayParser;

});

parcelRegister("1yFoQ", function(module, exports) {

$parcel$export(module.exports, "ISODayParser", function () { return $1229148a0c87bf9f$export$693fb1e525095b2a; }, function (v) { return $1229148a0c87bf9f$export$693fb1e525095b2a = v; });
var $1229148a0c87bf9f$export$693fb1e525095b2a;
"use strict";
$1229148a0c87bf9f$export$693fb1e525095b2a = void 0;

var $85MYC = parcelRequire("85MYC");

var $2cMli = parcelRequire("2cMli");

var $lJRPt = parcelRequire("lJRPt");
// ISO day of week
class $1229148a0c87bf9f$var$ISODayParser extends $2cMli.Parser {
    priority = 90;
    parse(dateString, token, match) {
        const valueCallback = (value)=>{
            if (value === 0) return 7;
            return value;
        };
        switch(token){
            // 2
            case "i":
            case "ii":
                return (0, $lJRPt.parseNDigits)(token.length, dateString);
            // 2nd
            case "io":
                return match.ordinalNumber(dateString, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return (0, $lJRPt.mapValue)(match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // T
            case "iiiii":
                return (0, $lJRPt.mapValue)(match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // Tu
            case "iiiiii":
                return (0, $lJRPt.mapValue)(match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // Tuesday
            case "iiii":
            default:
                return (0, $lJRPt.mapValue)(match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 7;
    }
    set(date, _flags, value) {
        date = (0, $85MYC.setISODay)(date, value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "Y",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "E",
        "e",
        "c",
        "t",
        "T"
    ];
}
$1229148a0c87bf9f$export$693fb1e525095b2a = $1229148a0c87bf9f$var$ISODayParser;

});
parcelRegister("85MYC", function(module, exports) {

$parcel$export(module.exports, "setISODay", function () { return $5e44c818923b157d$export$1fd9df65adb0d1aa; }, function (v) { return $5e44c818923b157d$export$1fd9df65adb0d1aa = v; });
var $5e44c818923b157d$export$1fd9df65adb0d1aa;
"use strict";
$5e44c818923b157d$export$1fd9df65adb0d1aa = $5e44c818923b157d$var$setISODay;

var $cBVis = parcelRequire("cBVis");

var $i19EH = parcelRequire("i19EH");

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name setISODay
 * @category Weekday Helpers
 * @summary Set the day of the ISO week to the given date.
 *
 * @description
 * Set the day of the ISO week to the given date.
 * ISO week starts with Monday.
 * 7 is the index of Sunday, 1 is the index of Monday etc.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param day - The day of the ISO week of the new date
 *
 * @returns The new date with the day of the ISO week set
 *
 * @example
 * // Set Sunday to 1 September 2014:
 * const result = setISODay(new Date(2014, 8, 1), 7)
 * //=> Sun Sep 07 2014 00:00:00
 */ function $5e44c818923b157d$var$setISODay(date, day) {
    const _date = (0, $b3MCU.toDate)(date);
    const currentDay = (0, $i19EH.getISODay)(_date);
    const diff = day - currentDay;
    return (0, $cBVis.addDays)(_date, diff);
}

});


parcelRegister("bEGcN", function(module, exports) {

$parcel$export(module.exports, "AMPMParser", function () { return $87c42b41e4639ee8$export$8d1e08492351df91; }, function (v) { return $87c42b41e4639ee8$export$8d1e08492351df91 = v; });
var $87c42b41e4639ee8$export$8d1e08492351df91;
"use strict";
$87c42b41e4639ee8$export$8d1e08492351df91 = void 0;

var $2cMli = parcelRequire("2cMli");

var $lJRPt = parcelRequire("lJRPt");
class $87c42b41e4639ee8$var$AMPMParser extends $2cMli.Parser {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "a":
            case "aa":
            case "aaa":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaaa":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $lJRPt.dayPeriodEnumToHours)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "b",
        "B",
        "H",
        "k",
        "t",
        "T"
    ];
}
$87c42b41e4639ee8$export$8d1e08492351df91 = $87c42b41e4639ee8$var$AMPMParser;

});

parcelRegister("kFLpL", function(module, exports) {

$parcel$export(module.exports, "AMPMMidnightParser", function () { return $f0cc6a8ae9858ffe$export$73ca2bd0a17d273; }, function (v) { return $f0cc6a8ae9858ffe$export$73ca2bd0a17d273 = v; });
var $f0cc6a8ae9858ffe$export$73ca2bd0a17d273;
"use strict";
$f0cc6a8ae9858ffe$export$73ca2bd0a17d273 = void 0;

var $2cMli = parcelRequire("2cMli");

var $lJRPt = parcelRequire("lJRPt");
class $f0cc6a8ae9858ffe$var$AMPMMidnightParser extends $2cMli.Parser {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "b":
            case "bb":
            case "bbb":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbbb":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $lJRPt.dayPeriodEnumToHours)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "B",
        "H",
        "k",
        "t",
        "T"
    ];
}
$f0cc6a8ae9858ffe$export$73ca2bd0a17d273 = $f0cc6a8ae9858ffe$var$AMPMMidnightParser;

});

parcelRegister("89EMg", function(module, exports) {

$parcel$export(module.exports, "DayPeriodParser", function () { return $5efecb87d0ce1ef5$export$bb9212adf05373db; }, function (v) { return $5efecb87d0ce1ef5$export$bb9212adf05373db = v; });
var $5efecb87d0ce1ef5$export$bb9212adf05373db;
"use strict";
$5efecb87d0ce1ef5$export$bb9212adf05373db = void 0;

var $2cMli = parcelRequire("2cMli");

var $lJRPt = parcelRequire("lJRPt");
// in the morning, in the afternoon, in the evening, at night
class $5efecb87d0ce1ef5$var$DayPeriodParser extends $2cMli.Parser {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBBB":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $lJRPt.dayPeriodEnumToHours)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "t",
        "T"
    ];
}
$5efecb87d0ce1ef5$export$bb9212adf05373db = $5efecb87d0ce1ef5$var$DayPeriodParser;

});

parcelRegister("7f0GZ", function(module, exports) {

$parcel$export(module.exports, "Hour1to12Parser", function () { return $545a78965ada77f1$export$8a04050a727a1756; }, function (v) { return $545a78965ada77f1$export$8a04050a727a1756 = v; });
var $545a78965ada77f1$export$8a04050a727a1756;
"use strict";
$545a78965ada77f1$export$8a04050a727a1756 = void 0;

var $ezdGm = parcelRequire("ezdGm");

var $2cMli = parcelRequire("2cMli");

var $lJRPt = parcelRequire("lJRPt");
class $545a78965ada77f1$var$Hour1to12Parser extends $2cMli.Parser {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "h":
                return (0, $lJRPt.parseNumericPattern)($ezdGm.numericPatterns.hour12h, dateString);
            case "ho":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $lJRPt.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 12;
    }
    set(date, _flags, value) {
        const isPM = date.getHours() >= 12;
        if (isPM && value < 12) date.setHours(value + 12, 0, 0, 0);
        else if (!isPM && value === 12) date.setHours(0, 0, 0, 0);
        else date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "H",
        "K",
        "k",
        "t",
        "T"
    ];
}
$545a78965ada77f1$export$8a04050a727a1756 = $545a78965ada77f1$var$Hour1to12Parser;

});

parcelRegister("kImdH", function(module, exports) {

$parcel$export(module.exports, "Hour0to23Parser", function () { return $f14927231a35f43e$export$e56f4dea2c3e56dd; }, function (v) { return $f14927231a35f43e$export$e56f4dea2c3e56dd = v; });
var $f14927231a35f43e$export$e56f4dea2c3e56dd;
"use strict";
$f14927231a35f43e$export$e56f4dea2c3e56dd = void 0;

var $ezdGm = parcelRequire("ezdGm");

var $2cMli = parcelRequire("2cMli");

var $lJRPt = parcelRequire("lJRPt");
class $f14927231a35f43e$var$Hour0to23Parser extends $2cMli.Parser {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "H":
                return (0, $lJRPt.parseNumericPattern)($ezdGm.numericPatterns.hour23h, dateString);
            case "Ho":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $lJRPt.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 23;
    }
    set(date, _flags, value) {
        date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "h",
        "K",
        "k",
        "t",
        "T"
    ];
}
$f14927231a35f43e$export$e56f4dea2c3e56dd = $f14927231a35f43e$var$Hour0to23Parser;

});

parcelRegister("7wPsV", function(module, exports) {

$parcel$export(module.exports, "Hour0To11Parser", function () { return $57b3718f982d014b$export$cbbe855312f87d77; }, function (v) { return $57b3718f982d014b$export$cbbe855312f87d77 = v; });
var $57b3718f982d014b$export$cbbe855312f87d77;
"use strict";
$57b3718f982d014b$export$cbbe855312f87d77 = void 0;

var $ezdGm = parcelRequire("ezdGm");

var $2cMli = parcelRequire("2cMli");

var $lJRPt = parcelRequire("lJRPt");
class $57b3718f982d014b$var$Hour0To11Parser extends $2cMli.Parser {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "K":
                return (0, $lJRPt.parseNumericPattern)($ezdGm.numericPatterns.hour11h, dateString);
            case "Ko":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $lJRPt.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        const isPM = date.getHours() >= 12;
        if (isPM && value < 12) date.setHours(value + 12, 0, 0, 0);
        else date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "h",
        "H",
        "k",
        "t",
        "T"
    ];
}
$57b3718f982d014b$export$cbbe855312f87d77 = $57b3718f982d014b$var$Hour0To11Parser;

});

parcelRegister("04Rzk", function(module, exports) {

$parcel$export(module.exports, "Hour1To24Parser", function () { return $00e9ed76f4839688$export$6008046d2b34b6a5; }, function (v) { return $00e9ed76f4839688$export$6008046d2b34b6a5 = v; });
var $00e9ed76f4839688$export$6008046d2b34b6a5;
"use strict";
$00e9ed76f4839688$export$6008046d2b34b6a5 = void 0;

var $ezdGm = parcelRequire("ezdGm");

var $2cMli = parcelRequire("2cMli");

var $lJRPt = parcelRequire("lJRPt");
class $00e9ed76f4839688$var$Hour1To24Parser extends $2cMli.Parser {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "k":
                return (0, $lJRPt.parseNumericPattern)($ezdGm.numericPatterns.hour24h, dateString);
            case "ko":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $lJRPt.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 24;
    }
    set(date, _flags, value) {
        const hours = value <= 24 ? value % 24 : value;
        date.setHours(hours, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "h",
        "H",
        "K",
        "t",
        "T"
    ];
}
$00e9ed76f4839688$export$6008046d2b34b6a5 = $00e9ed76f4839688$var$Hour1To24Parser;

});

parcelRegister("3z7C4", function(module, exports) {

$parcel$export(module.exports, "MinuteParser", function () { return $298a8bbf5a684cf7$export$2b52670d9e2be53; }, function (v) { return $298a8bbf5a684cf7$export$2b52670d9e2be53 = v; });
var $298a8bbf5a684cf7$export$2b52670d9e2be53;
"use strict";
$298a8bbf5a684cf7$export$2b52670d9e2be53 = void 0;

var $ezdGm = parcelRequire("ezdGm");

var $2cMli = parcelRequire("2cMli");

var $lJRPt = parcelRequire("lJRPt");
class $298a8bbf5a684cf7$var$MinuteParser extends $2cMli.Parser {
    priority = 60;
    parse(dateString, token, match) {
        switch(token){
            case "m":
                return (0, $lJRPt.parseNumericPattern)($ezdGm.numericPatterns.minute, dateString);
            case "mo":
                return match.ordinalNumber(dateString, {
                    unit: "minute"
                });
            default:
                return (0, $lJRPt.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 59;
    }
    set(date, _flags, value) {
        date.setMinutes(value, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}
$298a8bbf5a684cf7$export$2b52670d9e2be53 = $298a8bbf5a684cf7$var$MinuteParser;

});

parcelRegister("eDKiy", function(module, exports) {

$parcel$export(module.exports, "SecondParser", function () { return $aa889f12107c4a76$export$94d46d540cf1366a; }, function (v) { return $aa889f12107c4a76$export$94d46d540cf1366a = v; });
var $aa889f12107c4a76$export$94d46d540cf1366a;
"use strict";
$aa889f12107c4a76$export$94d46d540cf1366a = void 0;

var $ezdGm = parcelRequire("ezdGm");

var $2cMli = parcelRequire("2cMli");

var $lJRPt = parcelRequire("lJRPt");
class $aa889f12107c4a76$var$SecondParser extends $2cMli.Parser {
    priority = 50;
    parse(dateString, token, match) {
        switch(token){
            case "s":
                return (0, $lJRPt.parseNumericPattern)($ezdGm.numericPatterns.second, dateString);
            case "so":
                return match.ordinalNumber(dateString, {
                    unit: "second"
                });
            default:
                return (0, $lJRPt.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 59;
    }
    set(date, _flags, value) {
        date.setSeconds(value, 0);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}
$aa889f12107c4a76$export$94d46d540cf1366a = $aa889f12107c4a76$var$SecondParser;

});

parcelRegister("BG5gQ", function(module, exports) {

$parcel$export(module.exports, "FractionOfSecondParser", function () { return $071419d306d6da3a$export$b8e6f8b2d70893b1; }, function (v) { return $071419d306d6da3a$export$b8e6f8b2d70893b1 = v; });
var $071419d306d6da3a$export$b8e6f8b2d70893b1;
"use strict";
$071419d306d6da3a$export$b8e6f8b2d70893b1 = void 0;

var $2cMli = parcelRequire("2cMli");

var $lJRPt = parcelRequire("lJRPt");
class $071419d306d6da3a$var$FractionOfSecondParser extends $2cMli.Parser {
    priority = 30;
    parse(dateString, token) {
        const valueCallback = (value)=>Math.trunc(value * Math.pow(10, -token.length + 3));
        return (0, $lJRPt.mapValue)((0, $lJRPt.parseNDigits)(token.length, dateString), valueCallback);
    }
    set(date, _flags, value) {
        date.setMilliseconds(value);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}
$071419d306d6da3a$export$b8e6f8b2d70893b1 = $071419d306d6da3a$var$FractionOfSecondParser;

});

parcelRegister("41B6A", function(module, exports) {

$parcel$export(module.exports, "ISOTimezoneWithZParser", function () { return $2ee409bd97ee38f3$export$104d901d49fea29b; }, function (v) { return $2ee409bd97ee38f3$export$104d901d49fea29b = v; });
var $2ee409bd97ee38f3$export$104d901d49fea29b;
"use strict";
$2ee409bd97ee38f3$export$104d901d49fea29b = void 0;

var $02yAu = parcelRequire("02yAu");

var $izS8L = parcelRequire("izS8L");

var $ezdGm = parcelRequire("ezdGm");

var $2cMli = parcelRequire("2cMli");

var $lJRPt = parcelRequire("lJRPt");
// Timezone (ISO-8601. +00:00 is `'Z'`)
class $2ee409bd97ee38f3$var$ISOTimezoneWithZParser extends $2cMli.Parser {
    priority = 10;
    parse(dateString, token) {
        switch(token){
            case "X":
                return (0, $lJRPt.parseTimezonePattern)($ezdGm.timezonePatterns.basicOptionalMinutes, dateString);
            case "XX":
                return (0, $lJRPt.parseTimezonePattern)($ezdGm.timezonePatterns.basic, dateString);
            case "XXXX":
                return (0, $lJRPt.parseTimezonePattern)($ezdGm.timezonePatterns.basicOptionalSeconds, dateString);
            case "XXXXX":
                return (0, $lJRPt.parseTimezonePattern)($ezdGm.timezonePatterns.extendedOptionalSeconds, dateString);
            case "XXX":
            default:
                return (0, $lJRPt.parseTimezonePattern)($ezdGm.timezonePatterns.extended, dateString);
        }
    }
    set(date, flags, value) {
        if (flags.timestampIsSet) return date;
        return (0, $02yAu.constructFrom)(date, date.getTime() - (0, $izS8L.getTimezoneOffsetInMilliseconds)(date) - value);
    }
    incompatibleTokens = [
        "t",
        "T",
        "x"
    ];
}
$2ee409bd97ee38f3$export$104d901d49fea29b = $2ee409bd97ee38f3$var$ISOTimezoneWithZParser;

});

parcelRegister("hLrTY", function(module, exports) {

$parcel$export(module.exports, "ISOTimezoneParser", function () { return $ceec782788f26748$export$12910e5204b52b9; }, function (v) { return $ceec782788f26748$export$12910e5204b52b9 = v; });
var $ceec782788f26748$export$12910e5204b52b9;
"use strict";
$ceec782788f26748$export$12910e5204b52b9 = void 0;

var $02yAu = parcelRequire("02yAu");

var $izS8L = parcelRequire("izS8L");

var $ezdGm = parcelRequire("ezdGm");

var $2cMli = parcelRequire("2cMli");

var $lJRPt = parcelRequire("lJRPt");
// Timezone (ISO-8601)
class $ceec782788f26748$var$ISOTimezoneParser extends $2cMli.Parser {
    priority = 10;
    parse(dateString, token) {
        switch(token){
            case "x":
                return (0, $lJRPt.parseTimezonePattern)($ezdGm.timezonePatterns.basicOptionalMinutes, dateString);
            case "xx":
                return (0, $lJRPt.parseTimezonePattern)($ezdGm.timezonePatterns.basic, dateString);
            case "xxxx":
                return (0, $lJRPt.parseTimezonePattern)($ezdGm.timezonePatterns.basicOptionalSeconds, dateString);
            case "xxxxx":
                return (0, $lJRPt.parseTimezonePattern)($ezdGm.timezonePatterns.extendedOptionalSeconds, dateString);
            case "xxx":
            default:
                return (0, $lJRPt.parseTimezonePattern)($ezdGm.timezonePatterns.extended, dateString);
        }
    }
    set(date, flags, value) {
        if (flags.timestampIsSet) return date;
        return (0, $02yAu.constructFrom)(date, date.getTime() - (0, $izS8L.getTimezoneOffsetInMilliseconds)(date) - value);
    }
    incompatibleTokens = [
        "t",
        "T",
        "X"
    ];
}
$ceec782788f26748$export$12910e5204b52b9 = $ceec782788f26748$var$ISOTimezoneParser;

});

parcelRegister("ampPL", function(module, exports) {

$parcel$export(module.exports, "TimestampSecondsParser", function () { return $78afff88ad02c297$export$2cd8bf877a05e96; }, function (v) { return $78afff88ad02c297$export$2cd8bf877a05e96 = v; });
var $78afff88ad02c297$export$2cd8bf877a05e96;
"use strict";
$78afff88ad02c297$export$2cd8bf877a05e96 = void 0;

var $02yAu = parcelRequire("02yAu");

var $2cMli = parcelRequire("2cMli");

var $lJRPt = parcelRequire("lJRPt");
class $78afff88ad02c297$var$TimestampSecondsParser extends $2cMli.Parser {
    priority = 40;
    parse(dateString) {
        return (0, $lJRPt.parseAnyDigitsSigned)(dateString);
    }
    set(date, _flags, value) {
        return [
            (0, $02yAu.constructFrom)(date, value * 1000),
            {
                timestampIsSet: true
            }
        ];
    }
    incompatibleTokens = "*";
}
$78afff88ad02c297$export$2cd8bf877a05e96 = $78afff88ad02c297$var$TimestampSecondsParser;

});

parcelRegister("8shGF", function(module, exports) {

$parcel$export(module.exports, "TimestampMillisecondsParser", function () { return $627ea88a9559fcab$export$6d8f69c6906d6368; }, function (v) { return $627ea88a9559fcab$export$6d8f69c6906d6368 = v; });
var $627ea88a9559fcab$export$6d8f69c6906d6368;
"use strict";
$627ea88a9559fcab$export$6d8f69c6906d6368 = void 0;

var $02yAu = parcelRequire("02yAu");

var $2cMli = parcelRequire("2cMli");

var $lJRPt = parcelRequire("lJRPt");
class $627ea88a9559fcab$var$TimestampMillisecondsParser extends $2cMli.Parser {
    priority = 20;
    parse(dateString) {
        return (0, $lJRPt.parseAnyDigitsSigned)(dateString);
    }
    set(date, _flags, value) {
        return [
            (0, $02yAu.constructFrom)(date, value),
            {
                timestampIsSet: true
            }
        ];
    }
    incompatibleTokens = "*";
}
$627ea88a9559fcab$export$6d8f69c6906d6368 = $627ea88a9559fcab$var$TimestampMillisecondsParser;

});




parcelRegister("d9lEw", function(module, exports) {

$parcel$export(module.exports, "isMonday", function () { return $992ce966cd682f77$export$9573fe9b7c9ac3f5; }, function (v) { return $992ce966cd682f77$export$9573fe9b7c9ac3f5 = v; });
var $992ce966cd682f77$export$9573fe9b7c9ac3f5;
"use strict";
$992ce966cd682f77$export$9573fe9b7c9ac3f5 = $992ce966cd682f77$var$isMonday;

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name isMonday
 * @category Weekday Helpers
 * @summary Is the given date Monday?
 *
 * @description
 * Is the given date Monday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Monday
 *
 * @example
 * // Is 22 September 2014 Monday?
 * const result = isMonday(new Date(2014, 8, 22))
 * //=> true
 */ function $992ce966cd682f77$var$isMonday(date) {
    return (0, $b3MCU.toDate)(date).getDay() === 1;
}

});

parcelRegister("cfnvH", function(module, exports) {

$parcel$export(module.exports, "isPast", function () { return $8ea91f69302c8ea7$export$fc5014aa3db48558; }, function (v) { return $8ea91f69302c8ea7$export$fc5014aa3db48558 = v; });
var $8ea91f69302c8ea7$export$fc5014aa3db48558;
"use strict";
$8ea91f69302c8ea7$export$fc5014aa3db48558 = $8ea91f69302c8ea7$var$isPast;

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name isPast
 * @category Common Helpers
 * @summary Is the given date in the past?
 * @pure false
 *
 * @description
 * Is the given date in the past?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in the past
 *
 * @example
 * // If today is 6 October 2014, is 2 July 2014 in the past?
 * const result = isPast(new Date(2014, 6, 2))
 * //=> true
 */ function $8ea91f69302c8ea7$var$isPast(date) {
    return +(0, $b3MCU.toDate)(date) < Date.now();
}

});

parcelRegister("cXBC2", function(module, exports) {

$parcel$export(module.exports, "isSameHour", function () { return $96f82bcf2c721693$export$f9f3a94a0371013; }, function (v) { return $96f82bcf2c721693$export$f9f3a94a0371013 = v; });
var $96f82bcf2c721693$export$f9f3a94a0371013;
"use strict";
$96f82bcf2c721693$export$f9f3a94a0371013 = $96f82bcf2c721693$var$isSameHour;

var $ea7Pp = parcelRequire("ea7Pp");
/**
 * @name isSameHour
 * @category Hour Helpers
 * @summary Are the given dates in the same hour (and same day)?
 *
 * @description
 * Are the given dates in the same hour (and same day)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same hour (and same day)
 *
 * @example
 * // Are 4 September 2014 06:00:00 and 4 September 06:30:00 in the same hour?
 * const result = isSameHour(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 6, 30))
 * //=> true
 *
 * @example
 * // Are 4 September 2014 06:00:00 and 5 September 06:00:00 in the same hour?
 * const result = isSameHour(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 5, 6, 0))
 * //=> false
 */ function $96f82bcf2c721693$var$isSameHour(dateLeft, dateRight) {
    const dateLeftStartOfHour = (0, $ea7Pp.startOfHour)(dateLeft);
    const dateRightStartOfHour = (0, $ea7Pp.startOfHour)(dateRight);
    return +dateLeftStartOfHour === +dateRightStartOfHour;
}

});
parcelRegister("ea7Pp", function(module, exports) {

$parcel$export(module.exports, "startOfHour", function () { return $a4f8126123829823$export$24f91f68e7c9d9d5; }, function (v) { return $a4f8126123829823$export$24f91f68e7c9d9d5 = v; });
var $a4f8126123829823$export$24f91f68e7c9d9d5;
"use strict";
$a4f8126123829823$export$24f91f68e7c9d9d5 = $a4f8126123829823$var$startOfHour;

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name startOfHour
 * @category Hour Helpers
 * @summary Return the start of an hour for the given date.
 *
 * @description
 * Return the start of an hour for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of an hour
 *
 * @example
 * // The start of an hour for 2 September 2014 11:55:00:
 * const result = startOfHour(new Date(2014, 8, 2, 11, 55))
 * //=> Tue Sep 02 2014 11:00:00
 */ function $a4f8126123829823$var$startOfHour(date) {
    const _date = (0, $b3MCU.toDate)(date);
    _date.setMinutes(0, 0, 0);
    return _date;
}

});


parcelRegister("eQTkQ", function(module, exports) {

$parcel$export(module.exports, "isSameISOWeek", function () { return $ad00d86db44056e8$export$1c6e74e3c7b27764; }, function (v) { return $ad00d86db44056e8$export$1c6e74e3c7b27764 = v; });
var $ad00d86db44056e8$export$1c6e74e3c7b27764;
"use strict";
$ad00d86db44056e8$export$1c6e74e3c7b27764 = $ad00d86db44056e8$var$isSameISOWeek;

var $9ErNi = parcelRequire("9ErNi");
/**
 * @name isSameISOWeek
 * @category ISO Week Helpers
 * @summary Are the given dates in the same ISO week (and year)?
 *
 * @description
 * Are the given dates in the same ISO week (and year)?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same ISO week (and year)
 *
 * @example
 * // Are 1 September 2014 and 7 September 2014 in the same ISO week?
 * const result = isSameISOWeek(new Date(2014, 8, 1), new Date(2014, 8, 7))
 * //=> true
 *
 * @example
 * // Are 1 September 2014 and 1 September 2015 in the same ISO week?
 * const result = isSameISOWeek(new Date(2014, 8, 1), new Date(2015, 8, 1))
 * //=> false
 */ function $ad00d86db44056e8$var$isSameISOWeek(dateLeft, dateRight) {
    return (0, $9ErNi.isSameWeek)(dateLeft, dateRight, {
        weekStartsOn: 1
    });
}

});
parcelRegister("9ErNi", function(module, exports) {

$parcel$export(module.exports, "isSameWeek", function () { return $706d68d6a11234a2$export$6ea683876c36b8d2; }, function (v) { return $706d68d6a11234a2$export$6ea683876c36b8d2 = v; });
var $706d68d6a11234a2$export$6ea683876c36b8d2;
"use strict";
$706d68d6a11234a2$export$6ea683876c36b8d2 = $706d68d6a11234a2$var$isSameWeek;

var $isuGI = parcelRequire("isuGI");
/**
 * The {@link isSameWeek} function options.
 */ /**
 * @name isSameWeek
 * @category Week Helpers
 * @summary Are the given dates in the same week (and month and year)?
 *
 * @description
 * Are the given dates in the same week (and month and year)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 * @param options - An object with options
 *
 * @returns The dates are in the same week (and month and year)
 *
 * @example
 * // Are 31 August 2014 and 4 September 2014 in the same week?
 * const result = isSameWeek(new Date(2014, 7, 31), new Date(2014, 8, 4))
 * //=> true
 *
 * @example
 * // If week starts with Monday,
 * // are 31 August 2014 and 4 September 2014 in the same week?
 * const result = isSameWeek(new Date(2014, 7, 31), new Date(2014, 8, 4), {
 *   weekStartsOn: 1
 * })
 * //=> false
 *
 * @example
 * // Are 1 January 2014 and 1 January 2015 in the same week?
 * const result = isSameWeek(new Date(2014, 0, 1), new Date(2015, 0, 1))
 * //=> false
 */ function $706d68d6a11234a2$var$isSameWeek(dateLeft, dateRight, options) {
    const dateLeftStartOfWeek = (0, $isuGI.startOfWeek)(dateLeft, options);
    const dateRightStartOfWeek = (0, $isuGI.startOfWeek)(dateRight, options);
    return +dateLeftStartOfWeek === +dateRightStartOfWeek;
}

});


parcelRegister("5GK3U", function(module, exports) {

$parcel$export(module.exports, "isSameISOWeekYear", function () { return $42449af65d52d4b4$export$5f55dbf38a1aee81; }, function (v) { return $42449af65d52d4b4$export$5f55dbf38a1aee81 = v; });
var $42449af65d52d4b4$export$5f55dbf38a1aee81;
"use strict";
$42449af65d52d4b4$export$5f55dbf38a1aee81 = $42449af65d52d4b4$var$isSameISOWeekYear;

var $f44li = parcelRequire("f44li");
/**
 * @name isSameISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Are the given dates in the same ISO week-numbering year?
 *
 * @description
 * Are the given dates in the same ISO week-numbering year?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same ISO week-numbering year
 *
 * @example
 * // Are 29 December 2003 and 2 January 2005 in the same ISO week-numbering year?
 * const result = isSameISOWeekYear(new Date(2003, 11, 29), new Date(2005, 0, 2))
 * //=> true
 */ function $42449af65d52d4b4$var$isSameISOWeekYear(dateLeft, dateRight) {
    const dateLeftStartOfYear = (0, $f44li.startOfISOWeekYear)(dateLeft);
    const dateRightStartOfYear = (0, $f44li.startOfISOWeekYear)(dateRight);
    return +dateLeftStartOfYear === +dateRightStartOfYear;
}

});

parcelRegister("13QzU", function(module, exports) {

$parcel$export(module.exports, "isSameMinute", function () { return $0c5edb2b6519ff4a$export$5d274bf63c8705cb; }, function (v) { return $0c5edb2b6519ff4a$export$5d274bf63c8705cb = v; });
var $0c5edb2b6519ff4a$export$5d274bf63c8705cb;
"use strict";
$0c5edb2b6519ff4a$export$5d274bf63c8705cb = $0c5edb2b6519ff4a$var$isSameMinute;

var $h18wW = parcelRequire("h18wW");
/**
 * @name isSameMinute
 * @category Minute Helpers
 * @summary Are the given dates in the same minute (and hour and day)?
 *
 * @description
 * Are the given dates in the same minute (and hour and day)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same minute (and hour and day)
 *
 * @example
 * // Are 4 September 2014 06:30:00 and 4 September 2014 06:30:15 in the same minute?
 * const result = isSameMinute(
 *   new Date(2014, 8, 4, 6, 30),
 *   new Date(2014, 8, 4, 6, 30, 15)
 * )
 * //=> true
 *
 * @example
 * // Are 4 September 2014 06:30:00 and 5 September 2014 06:30:00 in the same minute?
 * const result = isSameMinute(
 *   new Date(2014, 8, 4, 6, 30),
 *   new Date(2014, 8, 5, 6, 30)
 * )
 * //=> false
 */ function $0c5edb2b6519ff4a$var$isSameMinute(dateLeft, dateRight) {
    const dateLeftStartOfMinute = (0, $h18wW.startOfMinute)(dateLeft);
    const dateRightStartOfMinute = (0, $h18wW.startOfMinute)(dateRight);
    return +dateLeftStartOfMinute === +dateRightStartOfMinute;
}

});

parcelRegister("6ON3R", function(module, exports) {

$parcel$export(module.exports, "isSameMonth", function () { return $4f6d7822ffd9de2f$export$a18c89cbd24170ff; }, function (v) { return $4f6d7822ffd9de2f$export$a18c89cbd24170ff = v; });
var $4f6d7822ffd9de2f$export$a18c89cbd24170ff;
"use strict";
$4f6d7822ffd9de2f$export$a18c89cbd24170ff = $4f6d7822ffd9de2f$var$isSameMonth;

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name isSameMonth
 * @category Month Helpers
 * @summary Are the given dates in the same month (and year)?
 *
 * @description
 * Are the given dates in the same month (and year)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same month (and year)
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 *
 * @example
 * // Are 2 September 2014 and 25 September 2015 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2015, 8, 25))
 * //=> false
 */ function $4f6d7822ffd9de2f$var$isSameMonth(dateLeft, dateRight) {
    const _dateLeft = (0, $b3MCU.toDate)(dateLeft);
    const _dateRight = (0, $b3MCU.toDate)(dateRight);
    return _dateLeft.getFullYear() === _dateRight.getFullYear() && _dateLeft.getMonth() === _dateRight.getMonth();
}

});

parcelRegister("AQVHH", function(module, exports) {

$parcel$export(module.exports, "isSameQuarter", function () { return $06ec6ba50a7a30b9$export$5c60e4190867161c; }, function (v) { return $06ec6ba50a7a30b9$export$5c60e4190867161c = v; });
var $06ec6ba50a7a30b9$export$5c60e4190867161c;
"use strict";
$06ec6ba50a7a30b9$export$5c60e4190867161c = $06ec6ba50a7a30b9$var$isSameQuarter;

var $7KsKS = parcelRequire("7KsKS");
/**
 * @name isSameQuarter
 * @category Quarter Helpers
 * @summary Are the given dates in the same quarter (and year)?
 *
 * @description
 * Are the given dates in the same quarter (and year)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check

 * @returns The dates are in the same quarter (and year)
 *
 * @example
 * // Are 1 January 2014 and 8 March 2014 in the same quarter?
 * const result = isSameQuarter(new Date(2014, 0, 1), new Date(2014, 2, 8))
 * //=> true
 *
 * @example
 * // Are 1 January 2014 and 1 January 2015 in the same quarter?
 * const result = isSameQuarter(new Date(2014, 0, 1), new Date(2015, 0, 1))
 * //=> false
 */ function $06ec6ba50a7a30b9$var$isSameQuarter(dateLeft, dateRight) {
    const dateLeftStartOfQuarter = (0, $7KsKS.startOfQuarter)(dateLeft);
    const dateRightStartOfQuarter = (0, $7KsKS.startOfQuarter)(dateRight);
    return +dateLeftStartOfQuarter === +dateRightStartOfQuarter;
}

});

parcelRegister("l7P5p", function(module, exports) {

$parcel$export(module.exports, "isSameSecond", function () { return $f611e10fc7bbfddf$export$b88fbcfe038f3498; }, function (v) { return $f611e10fc7bbfddf$export$b88fbcfe038f3498 = v; });
var $f611e10fc7bbfddf$export$b88fbcfe038f3498;
"use strict";
$f611e10fc7bbfddf$export$b88fbcfe038f3498 = $f611e10fc7bbfddf$var$isSameSecond;

var $kJOxR = parcelRequire("kJOxR");
/**
 * @name isSameSecond
 * @category Second Helpers
 * @summary Are the given dates in the same second (and hour and day)?
 *
 * @description
 * Are the given dates in the same second (and hour and day)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same second (and hour and day)
 *
 * @example
 * // Are 4 September 2014 06:30:15.000 and 4 September 2014 06:30.15.500 in the same second?
 * const result = isSameSecond(
 *   new Date(2014, 8, 4, 6, 30, 15),
 *   new Date(2014, 8, 4, 6, 30, 15, 500)
 * )
 * //=> true
 *
 * @example
 * // Are 4 September 2014 06:00:15.000 and 4 September 2014 06:01.15.000 in the same second?
 * const result = isSameSecond(
 *   new Date(2014, 8, 4, 6, 0, 15),
 *   new Date(2014, 8, 4, 6, 1, 15)
 * )
 * //=> false
 *
 * @example
 * // Are 4 September 2014 06:00:15.000 and 5 September 2014 06:00.15.000 in the same second?
 * const result = isSameSecond(
 *   new Date(2014, 8, 4, 6, 0, 15),
 *   new Date(2014, 8, 5, 6, 0, 15)
 * )
 * //=> false
 */ function $f611e10fc7bbfddf$var$isSameSecond(dateLeft, dateRight) {
    const dateLeftStartOfSecond = (0, $kJOxR.startOfSecond)(dateLeft);
    const dateRightStartOfSecond = (0, $kJOxR.startOfSecond)(dateRight);
    return +dateLeftStartOfSecond === +dateRightStartOfSecond;
}

});
parcelRegister("kJOxR", function(module, exports) {

$parcel$export(module.exports, "startOfSecond", function () { return $f18f37da73c75173$export$66c51f9715fdbff5; }, function (v) { return $f18f37da73c75173$export$66c51f9715fdbff5 = v; });
var $f18f37da73c75173$export$66c51f9715fdbff5;
"use strict";
$f18f37da73c75173$export$66c51f9715fdbff5 = $f18f37da73c75173$var$startOfSecond;

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name startOfSecond
 * @category Second Helpers
 * @summary Return the start of a second for the given date.
 *
 * @description
 * Return the start of a second for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a second
 *
 * @example
 * // The start of a second for 1 December 2014 22:15:45.400:
 * const result = startOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:45.000
 */ function $f18f37da73c75173$var$startOfSecond(date) {
    const _date = (0, $b3MCU.toDate)(date);
    _date.setMilliseconds(0);
    return _date;
}

});


parcelRegister("ltZPS", function(module, exports) {

$parcel$export(module.exports, "isSameYear", function () { return $fa3c45b7f5f9b42f$export$5841f9eb9773f25f; }, function (v) { return $fa3c45b7f5f9b42f$export$5841f9eb9773f25f = v; });
var $fa3c45b7f5f9b42f$export$5841f9eb9773f25f;
"use strict";
$fa3c45b7f5f9b42f$export$5841f9eb9773f25f = $fa3c45b7f5f9b42f$var$isSameYear;

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name isSameYear
 * @category Year Helpers
 * @summary Are the given dates in the same year?
 *
 * @description
 * Are the given dates in the same year?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same year
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same year?
 * const result = isSameYear(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 */ function $fa3c45b7f5f9b42f$var$isSameYear(dateLeft, dateRight) {
    const _dateLeft = (0, $b3MCU.toDate)(dateLeft);
    const _dateRight = (0, $b3MCU.toDate)(dateRight);
    return _dateLeft.getFullYear() === _dateRight.getFullYear();
}

});

parcelRegister("boE47", function(module, exports) {

$parcel$export(module.exports, "isThisHour", function () { return $84c103c50d73d18a$export$5d41bdc7172839b9; }, function (v) { return $84c103c50d73d18a$export$5d41bdc7172839b9 = v; });
var $84c103c50d73d18a$export$5d41bdc7172839b9;
"use strict";
$84c103c50d73d18a$export$5d41bdc7172839b9 = $84c103c50d73d18a$var$isThisHour;

var $oVfas = parcelRequire("oVfas");

var $cXBC2 = parcelRequire("cXBC2");
/**
 * @name isThisHour
 * @category Hour Helpers
 * @summary Is the given date in the same hour as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same hour as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this hour
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:00:00 in this hour?
 * const result = isThisHour(new Date(2014, 8, 25, 18))
 * //=> true
 */ function $84c103c50d73d18a$var$isThisHour(date) {
    return (0, $cXBC2.isSameHour)(date, (0, $oVfas.constructNow)(date));
}

});

parcelRegister("3vAI0", function(module, exports) {

$parcel$export(module.exports, "isThisISOWeek", function () { return $28e0bdec4fa73aed$export$4e987896c721f753; }, function (v) { return $28e0bdec4fa73aed$export$4e987896c721f753 = v; });
var $28e0bdec4fa73aed$export$4e987896c721f753;
"use strict";
$28e0bdec4fa73aed$export$4e987896c721f753 = $28e0bdec4fa73aed$var$isThisISOWeek;

var $oVfas = parcelRequire("oVfas");

var $eQTkQ = parcelRequire("eQTkQ");
/**
 * @name isThisISOWeek
 * @category ISO Week Helpers
 * @summary Is the given date in the same ISO week as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same ISO week as the current date?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this ISO week
 *
 * @example
 * // If today is 25 September 2014, is 22 September 2014 in this ISO week?
 * const result = isThisISOWeek(new Date(2014, 8, 22))
 * //=> true
 */ function $28e0bdec4fa73aed$var$isThisISOWeek(date) {
    return (0, $eQTkQ.isSameISOWeek)(date, (0, $oVfas.constructNow)(date));
}

});

parcelRegister("hAjXN", function(module, exports) {

$parcel$export(module.exports, "isThisMinute", function () { return $ccd548c460dd6935$export$fa55b7d29d8d957a; }, function (v) { return $ccd548c460dd6935$export$fa55b7d29d8d957a = v; });
var $ccd548c460dd6935$export$fa55b7d29d8d957a;
"use strict";
$ccd548c460dd6935$export$fa55b7d29d8d957a = $ccd548c460dd6935$var$isThisMinute;

var $oVfas = parcelRequire("oVfas");

var $13QzU = parcelRequire("13QzU");
/**
 * @name isThisMinute
 * @category Minute Helpers
 * @summary Is the given date in the same minute as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same minute as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this minute
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:30:00 in this minute?
 * const result = isThisMinute(new Date(2014, 8, 25, 18, 30))
 * //=> true
 */ function $ccd548c460dd6935$var$isThisMinute(date) {
    return (0, $13QzU.isSameMinute)(date, (0, $oVfas.constructNow)(date));
}

});

parcelRegister("6Gv6n", function(module, exports) {

$parcel$export(module.exports, "isThisMonth", function () { return $4ddeca7b1848235a$export$173f1e1d92847276; }, function (v) { return $4ddeca7b1848235a$export$173f1e1d92847276 = v; });
var $4ddeca7b1848235a$export$173f1e1d92847276;
"use strict";
$4ddeca7b1848235a$export$173f1e1d92847276 = $4ddeca7b1848235a$var$isThisMonth;

var $oVfas = parcelRequire("oVfas");

var $6ON3R = parcelRequire("6ON3R");
/**
 * @name isThisMonth
 * @category Month Helpers
 * @summary Is the given date in the same month as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same month as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this month
 *
 * @example
 * // If today is 25 September 2014, is 15 September 2014 in this month?
 * const result = isThisMonth(new Date(2014, 8, 15))
 * //=> true
 */ function $4ddeca7b1848235a$var$isThisMonth(date) {
    return (0, $6ON3R.isSameMonth)(date, (0, $oVfas.constructNow)(date));
}

});

parcelRegister("8C1ii", function(module, exports) {

$parcel$export(module.exports, "isThisQuarter", function () { return $6452e0511e9ad6f6$export$3d88fd18ab599ccc; }, function (v) { return $6452e0511e9ad6f6$export$3d88fd18ab599ccc = v; });
var $6452e0511e9ad6f6$export$3d88fd18ab599ccc;
"use strict";
$6452e0511e9ad6f6$export$3d88fd18ab599ccc = $6452e0511e9ad6f6$var$isThisQuarter;

var $oVfas = parcelRequire("oVfas");

var $AQVHH = parcelRequire("AQVHH");
/**
 * @name isThisQuarter
 * @category Quarter Helpers
 * @summary Is the given date in the same quarter as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same quarter as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this quarter
 *
 * @example
 * // If today is 25 September 2014, is 2 July 2014 in this quarter?
 * const result = isThisQuarter(new Date(2014, 6, 2))
 * //=> true
 */ function $6452e0511e9ad6f6$var$isThisQuarter(date) {
    return (0, $AQVHH.isSameQuarter)(date, (0, $oVfas.constructNow)(date));
}

});

parcelRegister("1OwQr", function(module, exports) {

$parcel$export(module.exports, "isThisSecond", function () { return $1523f044d82d40c2$export$8d7059b5bca087e6; }, function (v) { return $1523f044d82d40c2$export$8d7059b5bca087e6 = v; });
var $1523f044d82d40c2$export$8d7059b5bca087e6;
"use strict";
$1523f044d82d40c2$export$8d7059b5bca087e6 = $1523f044d82d40c2$var$isThisSecond;

var $oVfas = parcelRequire("oVfas");

var $l7P5p = parcelRequire("l7P5p");
/**
 * @name isThisSecond
 * @category Second Helpers
 * @summary Is the given date in the same second as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same second as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this second
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:30:15.000 in this second?
 * const result = isThisSecond(new Date(2014, 8, 25, 18, 30, 15))
 * //=> true
 */ function $1523f044d82d40c2$var$isThisSecond(date) {
    return (0, $l7P5p.isSameSecond)(date, (0, $oVfas.constructNow)(date));
}

});

parcelRegister("jeQ8V", function(module, exports) {

$parcel$export(module.exports, "isThisWeek", function () { return $e017c59c429e8a91$export$cfe4b66a69cdd8a; }, function (v) { return $e017c59c429e8a91$export$cfe4b66a69cdd8a = v; });
var $e017c59c429e8a91$export$cfe4b66a69cdd8a;
"use strict";
$e017c59c429e8a91$export$cfe4b66a69cdd8a = $e017c59c429e8a91$var$isThisWeek;

var $oVfas = parcelRequire("oVfas");

var $9ErNi = parcelRequire("9ErNi");
/**
 * The {@link isThisWeek} function options.
 */ /**
 * @name isThisWeek
 * @category Week Helpers
 * @summary Is the given date in the same week as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same week as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 * @param options - The object with options
 *
 * @returns The date is in this week
 *
 * @example
 * // If today is 25 September 2014, is 21 September 2014 in this week?
 * const result = isThisWeek(new Date(2014, 8, 21))
 * //=> true
 *
 * @example
 * // If today is 25 September 2014 and week starts with Monday
 * // is 21 September 2014 in this week?
 * const result = isThisWeek(new Date(2014, 8, 21), { weekStartsOn: 1 })
 * //=> false
 */ function $e017c59c429e8a91$var$isThisWeek(date, options) {
    return (0, $9ErNi.isSameWeek)(date, (0, $oVfas.constructNow)(date), options);
}

});

parcelRegister("6wSSW", function(module, exports) {

$parcel$export(module.exports, "isThisYear", function () { return $4c104e4f36c2e9e6$export$a28c94941893a5ac; }, function (v) { return $4c104e4f36c2e9e6$export$a28c94941893a5ac = v; });
var $4c104e4f36c2e9e6$export$a28c94941893a5ac;
"use strict";
$4c104e4f36c2e9e6$export$a28c94941893a5ac = $4c104e4f36c2e9e6$var$isThisYear;

var $oVfas = parcelRequire("oVfas");

var $ltZPS = parcelRequire("ltZPS");
/**
 * @name isThisYear
 * @category Year Helpers
 * @summary Is the given date in the same year as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same year as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this year
 *
 * @example
 * // If today is 25 September 2014, is 2 July 2014 in this year?
 * const result = isThisYear(new Date(2014, 6, 2))
 * //=> true
 */ function $4c104e4f36c2e9e6$var$isThisYear(date) {
    return (0, $ltZPS.isSameYear)(date, (0, $oVfas.constructNow)(date));
}

});

parcelRegister("9r1vT", function(module, exports) {

$parcel$export(module.exports, "isThursday", function () { return $6de7cf31f0cda072$export$c8e7c906983ea347; }, function (v) { return $6de7cf31f0cda072$export$c8e7c906983ea347 = v; });
var $6de7cf31f0cda072$export$c8e7c906983ea347;
"use strict";
$6de7cf31f0cda072$export$c8e7c906983ea347 = $6de7cf31f0cda072$var$isThursday;

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name isThursday
 * @category Weekday Helpers
 * @summary Is the given date Thursday?
 *
 * @description
 * Is the given date Thursday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Thursday
 *
 * @example
 * // Is 25 September 2014 Thursday?
 * const result = isThursday(new Date(2014, 8, 25))
 * //=> true
 */ function $6de7cf31f0cda072$var$isThursday(date) {
    return (0, $b3MCU.toDate)(date).getDay() === 4;
}

});

parcelRegister("4HLso", function(module, exports) {

$parcel$export(module.exports, "isToday", function () { return $36cffd85494a1dbd$export$629b0a497aa65267; }, function (v) { return $36cffd85494a1dbd$export$629b0a497aa65267 = v; });
var $36cffd85494a1dbd$export$629b0a497aa65267;
"use strict";
$36cffd85494a1dbd$export$629b0a497aa65267 = $36cffd85494a1dbd$var$isToday;

var $oVfas = parcelRequire("oVfas");

var $8w9BL = parcelRequire("8w9BL");
/**
 * @name isToday
 * @category Day Helpers
 * @summary Is the given date today?
 * @pure false
 *
 * @description
 * Is the given date today?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is today
 *
 * @example
 * // If today is 6 October 2014, is 6 October 14:00:00 today?
 * const result = isToday(new Date(2014, 9, 6, 14, 0))
 * //=> true
 */ function $36cffd85494a1dbd$var$isToday(date) {
    return (0, $8w9BL.isSameDay)(date, (0, $oVfas.constructNow)(date));
}

});

parcelRegister("1TDNp", function(module, exports) {

$parcel$export(module.exports, "isTomorrow", function () { return $1619cc28055bacec$export$d6365ba92f0647f1; }, function (v) { return $1619cc28055bacec$export$d6365ba92f0647f1 = v; });
var $1619cc28055bacec$export$d6365ba92f0647f1;
"use strict";
$1619cc28055bacec$export$d6365ba92f0647f1 = $1619cc28055bacec$var$isTomorrow;

var $cBVis = parcelRequire("cBVis");

var $oVfas = parcelRequire("oVfas");

var $8w9BL = parcelRequire("8w9BL");
/**
 * @name isTomorrow
 * @category Day Helpers
 * @summary Is the given date tomorrow?
 * @pure false
 *
 * @description
 * Is the given date tomorrow?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is tomorrow
 *
 * @example
 * // If today is 6 October 2014, is 7 October 14:00:00 tomorrow?
 * const result = isTomorrow(new Date(2014, 9, 7, 14, 0))
 * //=> true
 */ function $1619cc28055bacec$var$isTomorrow(date) {
    return (0, $8w9BL.isSameDay)(date, (0, $cBVis.addDays)((0, $oVfas.constructNow)(date), 1));
}

});

parcelRegister("lKhK2", function(module, exports) {

$parcel$export(module.exports, "isTuesday", function () { return $fd4ba7f97867e8f0$export$90d50b8f209f5ac3; }, function (v) { return $fd4ba7f97867e8f0$export$90d50b8f209f5ac3 = v; });
var $fd4ba7f97867e8f0$export$90d50b8f209f5ac3;
"use strict";
$fd4ba7f97867e8f0$export$90d50b8f209f5ac3 = $fd4ba7f97867e8f0$var$isTuesday;

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name isTuesday
 * @category Weekday Helpers
 * @summary Is the given date Tuesday?
 *
 * @description
 * Is the given date Tuesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Tuesday
 *
 * @example
 * // Is 23 September 2014 Tuesday?
 * const result = isTuesday(new Date(2014, 8, 23))
 * //=> true
 */ function $fd4ba7f97867e8f0$var$isTuesday(date) {
    return (0, $b3MCU.toDate)(date).getDay() === 2;
}

});

parcelRegister("3ulbk", function(module, exports) {

$parcel$export(module.exports, "isWednesday", function () { return $28a49ab051749d68$export$ec9de642cdd62944; }, function (v) { return $28a49ab051749d68$export$ec9de642cdd62944 = v; });
var $28a49ab051749d68$export$ec9de642cdd62944;
"use strict";
$28a49ab051749d68$export$ec9de642cdd62944 = $28a49ab051749d68$var$isWednesday;

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name isWednesday
 * @category Weekday Helpers
 * @summary Is the given date Wednesday?
 *
 * @description
 * Is the given date Wednesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Wednesday
 *
 * @example
 * // Is 24 September 2014 Wednesday?
 * const result = isWednesday(new Date(2014, 8, 24))
 * //=> true
 */ function $28a49ab051749d68$var$isWednesday(date) {
    return (0, $b3MCU.toDate)(date).getDay() === 3;
}

});

parcelRegister("438Ab", function(module, exports) {

$parcel$export(module.exports, "isWithinInterval", function () { return $2f2e198c46d5cf20$export$d7deef7a3738e19d; }, function (v) { return $2f2e198c46d5cf20$export$d7deef7a3738e19d = v; });
var $2f2e198c46d5cf20$export$d7deef7a3738e19d;
"use strict";
$2f2e198c46d5cf20$export$d7deef7a3738e19d = $2f2e198c46d5cf20$var$isWithinInterval;

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name isWithinInterval
 * @category Interval Helpers
 * @summary Is the given date within the interval?
 *
 * @description
 * Is the given date within the interval? (Including start and end.)
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 * @param interval - The interval to check
 *
 * @returns The date is within the interval
 *
 * @example
 * // For the date within the interval:
 * isWithinInterval(new Date(2014, 0, 3), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> true
 *
 * @example
 * // For the date outside of the interval:
 * isWithinInterval(new Date(2014, 0, 10), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> false
 *
 * @example
 * // For date equal to interval start:
 * isWithinInterval(date, { start, end: date })
 * // => true
 *
 * @example
 * // For date equal to interval end:
 * isWithinInterval(date, { start: date, end })
 * // => true
 */ function $2f2e198c46d5cf20$var$isWithinInterval(date, interval) {
    const time = +(0, $b3MCU.toDate)(date);
    const [startTime, endTime] = [
        +(0, $b3MCU.toDate)(interval.start),
        +(0, $b3MCU.toDate)(interval.end)
    ].sort((a, b)=>a - b);
    return time >= startTime && time <= endTime;
}

});

parcelRegister("2EjjN", function(module, exports) {

$parcel$export(module.exports, "isYesterday", function () { return $1ede4d66873cb7d7$export$221990270ebfe867; }, function (v) { return $1ede4d66873cb7d7$export$221990270ebfe867 = v; });
var $1ede4d66873cb7d7$export$221990270ebfe867;
"use strict";
$1ede4d66873cb7d7$export$221990270ebfe867 = $1ede4d66873cb7d7$var$isYesterday;

var $oVfas = parcelRequire("oVfas");

var $8w9BL = parcelRequire("8w9BL");

var $lbcdn = parcelRequire("lbcdn");
/**
 * @name isYesterday
 * @category Day Helpers
 * @summary Is the given date yesterday?
 * @pure false
 *
 * @description
 * Is the given date yesterday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is yesterday
 *
 * @example
 * // If today is 6 October 2014, is 5 October 14:00:00 yesterday?
 * const result = isYesterday(new Date(2014, 9, 5, 14, 0))
 * //=> true
 */ function $1ede4d66873cb7d7$var$isYesterday(date) {
    return (0, $8w9BL.isSameDay)(date, (0, $lbcdn.subDays)((0, $oVfas.constructNow)(date), 1));
}

});
parcelRegister("lbcdn", function(module, exports) {

$parcel$export(module.exports, "subDays", function () { return $f6b419aa9c462219$export$70823084e2deb1ea; }, function (v) { return $f6b419aa9c462219$export$70823084e2deb1ea = v; });
var $f6b419aa9c462219$export$70823084e2deb1ea;
"use strict";
$f6b419aa9c462219$export$70823084e2deb1ea = $f6b419aa9c462219$var$subDays;

var $cBVis = parcelRequire("cBVis");
/**
 * @name subDays
 * @category Day Helpers
 * @summary Subtract the specified number of days from the given date.
 *
 * @description
 * Subtract the specified number of days from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of days to be subtracted.
 *
 * @returns The new date with the days subtracted
 *
 * @example
 * // Subtract 10 days from 1 September 2014:
 * const result = subDays(new Date(2014, 8, 1), 10)
 * //=> Fri Aug 22 2014 00:00:00
 */ function $f6b419aa9c462219$var$subDays(date, amount) {
    return (0, $cBVis.addDays)(date, -amount);
}

});


parcelRegister("lM2Ew", function(module, exports) {

$parcel$export(module.exports, "lastDayOfDecade", function () { return $fda0236414d0c020$export$2aaf6241f57dd605; }, function (v) { return $fda0236414d0c020$export$2aaf6241f57dd605 = v; });
var $fda0236414d0c020$export$2aaf6241f57dd605;
"use strict";
$fda0236414d0c020$export$2aaf6241f57dd605 = $fda0236414d0c020$var$lastDayOfDecade;

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name lastDayOfDecade
 * @category Decade Helpers
 * @summary Return the last day of a decade for the given date.
 *
 * @description
 * Return the last day of a decade for the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of a decade
 *
 * @example
 * // The last day of a decade for 21 December 2012 21:12:00:
 * const result = lastDayOfDecade(new Date(2012, 11, 21, 21, 12, 00))
 * //=> Wed Dec 31 2019 00:00:00
 */ function $fda0236414d0c020$var$lastDayOfDecade(date) {
    // TODO: Switch to more technical definition in of decades that start with 1
    // end with 0. I.e. 2001-2010 instead of current 2000-2009. It's a breaking
    // change, so it can only be done in 4.0.
    const _date = (0, $b3MCU.toDate)(date);
    const year = _date.getFullYear();
    const decade = 9 + Math.floor(year / 10) * 10;
    _date.setFullYear(decade + 1, 0, 0);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

});

parcelRegister("5KX3n", function(module, exports) {

$parcel$export(module.exports, "lastDayOfISOWeek", function () { return $430f0e6e0b4f93c9$export$b08a8fc26ae6d94b; }, function (v) { return $430f0e6e0b4f93c9$export$b08a8fc26ae6d94b = v; });
var $430f0e6e0b4f93c9$export$b08a8fc26ae6d94b;
"use strict";
$430f0e6e0b4f93c9$export$b08a8fc26ae6d94b = $430f0e6e0b4f93c9$var$lastDayOfISOWeek;

var $bBBIn = parcelRequire("bBBIn");
/**
 * @name lastDayOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the last day of an ISO week for the given date.
 *
 * @description
 * Return the last day of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of an ISO week
 *
 * @example
 * // The last day of an ISO week for 2 September 2014 11:55:00:
 * const result = lastDayOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Sep 07 2014 00:00:00
 */ function $430f0e6e0b4f93c9$var$lastDayOfISOWeek(date) {
    return (0, $bBBIn.lastDayOfWeek)(date, {
        weekStartsOn: 1
    });
}

});
parcelRegister("bBBIn", function(module, exports) {

$parcel$export(module.exports, "lastDayOfWeek", function () { return $873067c42de45eee$export$b73502c35a293b0a; }, function (v) { return $873067c42de45eee$export$b73502c35a293b0a = v; });
var $873067c42de45eee$export$b73502c35a293b0a;
"use strict";
$873067c42de45eee$export$b73502c35a293b0a = $873067c42de45eee$var$lastDayOfWeek;

var $b3MCU = parcelRequire("b3MCU");

var $lJvf9 = parcelRequire("lJvf9");
/**
 * The {@link lastDayOfWeek} function options.
 */ /**
 * @name lastDayOfWeek
 * @category Week Helpers
 * @summary Return the last day of a week for the given date.
 *
 * @description
 * Return the last day of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The last day of a week
 *
 * @example
 * // The last day of a week for 2 September 2014 11:55:00:
 * const result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the last day of the week for 2 September 2014 11:55:00:
 * const result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 00:00:00
 */ function $873067c42de45eee$var$lastDayOfWeek(date, options) {
    const defaultOptions = (0, $lJvf9.getDefaultOptions)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $b3MCU.toDate)(date);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    _date.setHours(0, 0, 0, 0);
    _date.setDate(_date.getDate() + diff);
    return _date;
}

});


parcelRegister("d1Zcu", function(module, exports) {

$parcel$export(module.exports, "lastDayOfISOWeekYear", function () { return $97cad77992d9df70$export$1810bada8cd02ee1; }, function (v) { return $97cad77992d9df70$export$1810bada8cd02ee1 = v; });
var $97cad77992d9df70$export$1810bada8cd02ee1;
"use strict";
$97cad77992d9df70$export$1810bada8cd02ee1 = $97cad77992d9df70$var$lastDayOfISOWeekYear;

var $43yjM = parcelRequire("43yjM");

var $4x8aw = parcelRequire("4x8aw");

var $02yAu = parcelRequire("02yAu");
/**
 * @name lastDayOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the last day of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the last day of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of an ISO week-numbering year
 *
 * @example
 * // The last day of an ISO week-numbering year for 2 July 2005:
 * const result = lastDayOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Sun Jan 01 2006 00:00:00
 */ function $97cad77992d9df70$var$lastDayOfISOWeekYear(date) {
    const year = (0, $43yjM.getISOWeekYear)(date);
    const fourthOfJanuary = (0, $02yAu.constructFrom)(date, 0);
    fourthOfJanuary.setFullYear(year + 1, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    const _date = (0, $4x8aw.startOfISOWeek)(fourthOfJanuary);
    _date.setDate(_date.getDate() - 1);
    return _date;
}

});

parcelRegister("5LfhK", function(module, exports) {

$parcel$export(module.exports, "lastDayOfQuarter", function () { return $431d32de917c1711$export$8693c04228304c7; }, function (v) { return $431d32de917c1711$export$8693c04228304c7 = v; });
var $431d32de917c1711$export$8693c04228304c7;
"use strict";
$431d32de917c1711$export$8693c04228304c7 = $431d32de917c1711$var$lastDayOfQuarter;

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name lastDayOfQuarter
 * @category Quarter Helpers
 * @summary Return the last day of a year quarter for the given date.
 *
 * @description
 * Return the last day of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of a quarter
 *
 * @example
 * // The last day of a quarter for 2 September 2014 11:55:00:
 * const result = lastDayOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 00:00:00
 */ function $431d32de917c1711$var$lastDayOfQuarter(date) {
    const _date = (0, $b3MCU.toDate)(date);
    const currentMonth = _date.getMonth();
    const month = currentMonth - currentMonth % 3 + 3;
    _date.setMonth(month, 0);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

});

parcelRegister("5At12", function(module, exports) {

$parcel$export(module.exports, "lastDayOfYear", function () { return $4116d27ba4327a4d$export$323f7bc07b828bed; }, function (v) { return $4116d27ba4327a4d$export$323f7bc07b828bed = v; });
var $4116d27ba4327a4d$export$323f7bc07b828bed;
"use strict";
$4116d27ba4327a4d$export$323f7bc07b828bed = $4116d27ba4327a4d$var$lastDayOfYear;

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name lastDayOfYear
 * @category Year Helpers
 * @summary Return the last day of a year for the given date.
 *
 * @description
 * Return the last day of a year for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of a year
 *
 * @example
 * // The last day of a year for 2 September 2014 11:55:00:
 * const result = lastDayOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 00:00:00
 */ function $4116d27ba4327a4d$var$lastDayOfYear(date) {
    const _date = (0, $b3MCU.toDate)(date);
    const year = _date.getFullYear();
    _date.setFullYear(year + 1, 0, 0);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

});

parcelRegister("1KR3r", function(module, exports) {
"use strict";
module.exports.lightFormat = $14733dd9a43274a1$var$lightFormat;
Object.defineProperty(module.exports, "lightFormatters", {
    enumerable: true,
    get: function() {
        return $8E1N1.lightFormatters;
    }
});

var $cmplH = parcelRequire("cmplH");

var $b3MCU = parcelRequire("b3MCU");

var $8E1N1 = parcelRequire("8E1N1");
// Rexports of internal for libraries to use.
// See: https://github.com/date-fns/date-fns/issues/3638#issuecomment-1877082874
// This RegExp consists of three parts separated by `|`:
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $14733dd9a43274a1$var$formattingTokensRegExp = /(\w)\1*|''|'(''|[^'])+('|$)|./g;
const $14733dd9a43274a1$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $14733dd9a43274a1$var$doubleQuoteRegExp = /''/g;
const $14733dd9a43274a1$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @private
 */ /**
 * @name lightFormat
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. Unlike `format`,
 * `lightFormat` doesn't use locales and outputs date using the most popular tokens.
 *
 * > ⚠️ Please note that the `lightFormat` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   |
 * |---------------------------------|---------|-----------------------------------|
 * | AM, PM                          | a..aaa  | AM, PM                            |
 * |                                 | aaaa    | a.m., p.m.                        |
 * |                                 | aaaaa   | a, p                              |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 |
 * |                                 | yy      | 44, 01, 00, 17                    |
 * |                                 | yyy     | 044, 001, 000, 017                |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |
 * |                                 | MM      | 01, 02, ..., 12                   |
 * | Day of month                    | d       | 1, 2, ..., 31                     |
 * |                                 | dd      | 01, 02, ..., 31                   |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |
 * |                                 | hh      | 01, 02, ..., 11, 12               |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |
 * |                                 | HH      | 00, 01, 02, ..., 23               |
 * | Minute                          | m       | 0, 1, ..., 59                     |
 * |                                 | mm      | 00, 01, ..., 59                   |
 * | Second                          | s       | 0, 1, ..., 59                     |
 * |                                 | ss      | 00, 01, ..., 59                   |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |
 * |                                 | SS      | 00, 01, ..., 99                   |
 * |                                 | SSS     | 000, 001, ..., 999                |
 * |                                 | SSSS    | ...                               |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param format - The string of tokens
 *
 * @returns The formatted date string
 *
 * @throws `Invalid time value` if the date is invalid
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * const result = lightFormat(new Date(2014, 1, 11), 'yyyy-MM-dd')
 * //=> '2014-02-11'
 */ function $14733dd9a43274a1$var$lightFormat(date, formatStr) {
    const _date = (0, $b3MCU.toDate)(date);
    if (!(0, $cmplH.isValid)(_date)) throw new RangeError("Invalid time value");
    const tokens = formatStr.match($14733dd9a43274a1$var$formattingTokensRegExp);
    // The only case when formattingTokensRegExp doesn't match the string is when it's empty
    if (!tokens) return "";
    const result = tokens.map((substring)=>{
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        const firstCharacter = substring[0];
        if (firstCharacter === "'") return $14733dd9a43274a1$var$cleanEscapedString(substring);
        const formatter = $8E1N1.lightFormatters[firstCharacter];
        if (formatter) return formatter(_date, substring);
        if (firstCharacter.match($14733dd9a43274a1$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return substring;
    }).join("");
    return result;
}
function $14733dd9a43274a1$var$cleanEscapedString(input) {
    const matches = input.match($14733dd9a43274a1$var$escapedStringRegExp);
    if (!matches) return input;
    return matches[1].replace($14733dd9a43274a1$var$doubleQuoteRegExp, "'");
}

});

parcelRegister("lMw2H", function(module, exports) {

$parcel$export(module.exports, "milliseconds", function () { return $fdb6efa5c69df747$export$9a27fac83d67afd3; }, function (v) { return $fdb6efa5c69df747$export$9a27fac83d67afd3 = v; });
var $fdb6efa5c69df747$export$9a27fac83d67afd3;
"use strict";
$fdb6efa5c69df747$export$9a27fac83d67afd3 = $fdb6efa5c69df747$var$milliseconds;

var $7MMvH = parcelRequire("7MMvH");
/**
 * @name milliseconds
 * @category Millisecond Helpers
 * @summary
 * Returns the number of milliseconds in the specified, years, months, weeks, days, hours, minutes and seconds.
 *
 * @description
 * Returns the number of milliseconds in the specified, years, months, weeks, days, hours, minutes and seconds.
 *
 * One years equals 365.2425 days according to the formula:
 *
 * > Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
 * > 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
 *
 * One month is a year divided by 12.
 *
 * @param duration - The object with years, months, weeks, days, hours, minutes and seconds to be added.
 *
 * @returns The milliseconds
 *
 * @example
 * // 1 year in milliseconds
 * milliseconds({ years: 1 })
 * //=> 31556952000
 *
 * // 3 months in milliseconds
 * milliseconds({ months: 3 })
 * //=> 7889238000
 */ function $fdb6efa5c69df747$var$milliseconds({ years: years, months: months, weeks: weeks, days: days, hours: hours, minutes: minutes, seconds: seconds }) {
    let totalDays = 0;
    if (years) totalDays += years * $7MMvH.daysInYear;
    if (months) totalDays += months * ($7MMvH.daysInYear / 12);
    if (weeks) totalDays += weeks * 7;
    if (days) totalDays += days;
    let totalSeconds = totalDays * 86400;
    if (hours) totalSeconds += hours * 3600;
    if (minutes) totalSeconds += minutes * 60;
    if (seconds) totalSeconds += seconds;
    return Math.trunc(totalSeconds * 1000);
}

});

parcelRegister("iHZDD", function(module, exports) {

$parcel$export(module.exports, "millisecondsToHours", function () { return $d9ec0e3c8ca27d25$export$689a412b29fa9ed5; }, function (v) { return $d9ec0e3c8ca27d25$export$689a412b29fa9ed5 = v; });
var $d9ec0e3c8ca27d25$export$689a412b29fa9ed5;
"use strict";
$d9ec0e3c8ca27d25$export$689a412b29fa9ed5 = $d9ec0e3c8ca27d25$var$millisecondsToHours;

var $7MMvH = parcelRequire("7MMvH");
/**
 * @name millisecondsToHours
 * @category Conversion Helpers
 * @summary Convert milliseconds to hours.
 *
 * @description
 * Convert a number of milliseconds to a full number of hours.
 *
 * @param milliseconds - The number of milliseconds to be converted
 *
 * @returns The number of milliseconds converted in hours
 *
 * @example
 * // Convert 7200000 milliseconds to hours:
 * const result = millisecondsToHours(7200000)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = millisecondsToHours(7199999)
 * //=> 1
 */ function $d9ec0e3c8ca27d25$var$millisecondsToHours(milliseconds) {
    const hours = milliseconds / $7MMvH.millisecondsInHour;
    return Math.trunc(hours);
}

});

parcelRegister("973rn", function(module, exports) {

$parcel$export(module.exports, "millisecondsToMinutes", function () { return $6a276fb6f0561a33$export$a5f974e81e48cfc0; }, function (v) { return $6a276fb6f0561a33$export$a5f974e81e48cfc0 = v; });
var $6a276fb6f0561a33$export$a5f974e81e48cfc0;
"use strict";
$6a276fb6f0561a33$export$a5f974e81e48cfc0 = $6a276fb6f0561a33$var$millisecondsToMinutes;

var $7MMvH = parcelRequire("7MMvH");
/**
 * @name millisecondsToMinutes
 * @category Conversion Helpers
 * @summary Convert milliseconds to minutes.
 *
 * @description
 * Convert a number of milliseconds to a full number of minutes.
 *
 * @param milliseconds - The number of milliseconds to be converted
 *
 * @returns The number of milliseconds converted in minutes
 *
 * @example
 * // Convert 60000 milliseconds to minutes:
 * const result = millisecondsToMinutes(60000)
 * //=> 1
 *
 * @example
 * // It uses floor rounding:
 * const result = millisecondsToMinutes(119999)
 * //=> 1
 */ function $6a276fb6f0561a33$var$millisecondsToMinutes(milliseconds) {
    const minutes = milliseconds / $7MMvH.millisecondsInMinute;
    return Math.trunc(minutes);
}

});

parcelRegister("ac1eo", function(module, exports) {

$parcel$export(module.exports, "millisecondsToSeconds", function () { return $76bbfad3b629e511$export$f64c3bfbc58eec0f; }, function (v) { return $76bbfad3b629e511$export$f64c3bfbc58eec0f = v; });
var $76bbfad3b629e511$export$f64c3bfbc58eec0f;
"use strict";
$76bbfad3b629e511$export$f64c3bfbc58eec0f = $76bbfad3b629e511$var$millisecondsToSeconds;

var $7MMvH = parcelRequire("7MMvH");
/**
 * @name millisecondsToSeconds
 * @category Conversion Helpers
 * @summary Convert milliseconds to seconds.
 *
 * @description
 * Convert a number of milliseconds to a full number of seconds.
 *
 * @param milliseconds - The number of milliseconds to be converted
 *
 * @returns The number of milliseconds converted in seconds
 *
 * @example
 * // Convert 1000 miliseconds to seconds:
 * const result = millisecondsToSeconds(1000)
 * //=> 1
 *
 * @example
 * // It uses floor rounding:
 * const result = millisecondsToSeconds(1999)
 * //=> 1
 */ function $76bbfad3b629e511$var$millisecondsToSeconds(milliseconds) {
    const seconds = milliseconds / $7MMvH.millisecondsInSecond;
    return Math.trunc(seconds);
}

});

parcelRegister("6yYay", function(module, exports) {

$parcel$export(module.exports, "minutesToHours", function () { return $4c749762ce040fd4$export$815164eb42530ae7; }, function (v) { return $4c749762ce040fd4$export$815164eb42530ae7 = v; });
var $4c749762ce040fd4$export$815164eb42530ae7;
"use strict";
$4c749762ce040fd4$export$815164eb42530ae7 = $4c749762ce040fd4$var$minutesToHours;

var $7MMvH = parcelRequire("7MMvH");
/**
 * @name minutesToHours
 * @category Conversion Helpers
 * @summary Convert minutes to hours.
 *
 * @description
 * Convert a number of minutes to a full number of hours.
 *
 * @param minutes - The number of minutes to be converted
 *
 * @returns The number of minutes converted in hours
 *
 * @example
 * // Convert 140 minutes to hours:
 * const result = minutesToHours(120)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = minutesToHours(179)
 * //=> 2
 */ function $4c749762ce040fd4$var$minutesToHours(minutes) {
    const hours = minutes / $7MMvH.minutesInHour;
    return Math.trunc(hours);
}

});

parcelRegister("bdOxS", function(module, exports) {

$parcel$export(module.exports, "minutesToMilliseconds", function () { return $82b81ddd1dc23dab$export$f6b9795ef9056e3d; }, function (v) { return $82b81ddd1dc23dab$export$f6b9795ef9056e3d = v; });
var $82b81ddd1dc23dab$export$f6b9795ef9056e3d;
"use strict";
$82b81ddd1dc23dab$export$f6b9795ef9056e3d = $82b81ddd1dc23dab$var$minutesToMilliseconds;

var $7MMvH = parcelRequire("7MMvH");
/**
 * @name minutesToMilliseconds
 * @category Conversion Helpers
 * @summary Convert minutes to milliseconds.
 *
 * @description
 * Convert a number of minutes to a full number of milliseconds.
 *
 * @param minutes - The number of minutes to be converted
 *
 * @returns The number of minutes converted in milliseconds
 *
 * @example
 * // Convert 2 minutes to milliseconds
 * const result = minutesToMilliseconds(2)
 * //=> 120000
 */ function $82b81ddd1dc23dab$var$minutesToMilliseconds(minutes) {
    return Math.trunc(minutes * $7MMvH.millisecondsInMinute);
}

});

parcelRegister("7Vtb9", function(module, exports) {

$parcel$export(module.exports, "minutesToSeconds", function () { return $5c547d9a91280939$export$81ded4628c655103; }, function (v) { return $5c547d9a91280939$export$81ded4628c655103 = v; });
var $5c547d9a91280939$export$81ded4628c655103;
"use strict";
$5c547d9a91280939$export$81ded4628c655103 = $5c547d9a91280939$var$minutesToSeconds;

var $7MMvH = parcelRequire("7MMvH");
/**
 * @name minutesToSeconds
 * @category Conversion Helpers
 * @summary Convert minutes to seconds.
 *
 * @description
 * Convert a number of minutes to a full number of seconds.
 *
 * @param minutes - The number of minutes to be converted
 *
 * @returns The number of minutes converted in seconds
 *
 * @example
 * // Convert 2 minutes to seconds
 * const result = minutesToSeconds(2)
 * //=> 120
 */ function $5c547d9a91280939$var$minutesToSeconds(minutes) {
    return Math.trunc(minutes * $7MMvH.secondsInMinute);
}

});

parcelRegister("cRtuT", function(module, exports) {

$parcel$export(module.exports, "monthsToQuarters", function () { return $95d150d303a9e198$export$1932fa2a2068c849; }, function (v) { return $95d150d303a9e198$export$1932fa2a2068c849 = v; });
var $95d150d303a9e198$export$1932fa2a2068c849;
"use strict";
$95d150d303a9e198$export$1932fa2a2068c849 = $95d150d303a9e198$var$monthsToQuarters;

var $7MMvH = parcelRequire("7MMvH");
/**
 * @name monthsToQuarters
 * @category Conversion Helpers
 * @summary Convert number of months to quarters.
 *
 * @description
 * Convert a number of months to a full number of quarters.
 *
 * @param months - The number of months to be converted.
 *
 * @returns The number of months converted in quarters
 *
 * @example
 * // Convert 6 months to quarters:
 * const result = monthsToQuarters(6)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = monthsToQuarters(7)
 * //=> 2
 */ function $95d150d303a9e198$var$monthsToQuarters(months) {
    const quarters = months / $7MMvH.monthsInQuarter;
    return Math.trunc(quarters);
}

});

parcelRegister("eBOJa", function(module, exports) {

$parcel$export(module.exports, "monthsToYears", function () { return $aa2bded637fd8588$export$7489026ed27fc925; }, function (v) { return $aa2bded637fd8588$export$7489026ed27fc925 = v; });
var $aa2bded637fd8588$export$7489026ed27fc925;
"use strict";
$aa2bded637fd8588$export$7489026ed27fc925 = $aa2bded637fd8588$var$monthsToYears;

var $7MMvH = parcelRequire("7MMvH");
/**
 * @name monthsToYears
 * @category Conversion Helpers
 * @summary Convert number of months to years.
 *
 * @description
 * Convert a number of months to a full number of years.
 *
 * @param months - The number of months to be converted
 *
 * @returns The number of months converted in years
 *
 * @example
 * // Convert 36 months to years:
 * const result = monthsToYears(36)
 * //=> 3
 *
 * // It uses floor rounding:
 * const result = monthsToYears(40)
 * //=> 3
 */ function $aa2bded637fd8588$var$monthsToYears(months) {
    const years = months / $7MMvH.monthsInYear;
    return Math.trunc(years);
}

});

parcelRegister("3nQMq", function(module, exports) {

$parcel$export(module.exports, "nextDay", function () { return $276c7613118bf96c$export$992728922317ffc8; }, function (v) { return $276c7613118bf96c$export$992728922317ffc8 = v; });
var $276c7613118bf96c$export$992728922317ffc8;
"use strict";
$276c7613118bf96c$export$992728922317ffc8 = $276c7613118bf96c$var$nextDay;

var $cBVis = parcelRequire("cBVis");

var $kvN19 = parcelRequire("kvN19");
/**
 * @name nextDay
 * @category Weekday Helpers
 * @summary When is the next day of the week?
 *
 * @description
 * When is the next day of the week? 0-6 the day of the week, 0 represents Sunday.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 * @param day - day of the week
 *
 * @returns The date is the next day of week
 *
 * @example
 * // When is the next Monday after Mar, 20, 2020?
 * const result = nextDay(new Date(2020, 2, 20), 1)
 * //=> Mon Mar 23 2020 00:00:00
 *
 * @example
 * // When is the next Tuesday after Mar, 21, 2020?
 * const result = nextDay(new Date(2020, 2, 21), 2)
 * //=> Tue Mar 24 2020 00:00:00
 */ function $276c7613118bf96c$var$nextDay(date, day) {
    let delta = day - (0, $kvN19.getDay)(date);
    if (delta <= 0) delta += 7;
    return (0, $cBVis.addDays)(date, delta);
}

});

parcelRegister("3v7oA", function(module, exports) {

$parcel$export(module.exports, "nextFriday", function () { return $28ca00f8d8241070$export$21d76934fce76327; }, function (v) { return $28ca00f8d8241070$export$21d76934fce76327 = v; });
var $28ca00f8d8241070$export$21d76934fce76327;
"use strict";
$28ca00f8d8241070$export$21d76934fce76327 = $28ca00f8d8241070$var$nextFriday;

var $3nQMq = parcelRequire("3nQMq");
/**
 * @name nextFriday
 * @category Weekday Helpers
 * @summary When is the next Friday?
 *
 * @description
 * When is the next Friday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Friday
 *
 * @example
 * // When is the next Friday after Mar, 22, 2020?
 * const result = nextFriday(new Date(2020, 2, 22))
 * //=> Fri Mar 27 2020 00:00:00
 */ function $28ca00f8d8241070$var$nextFriday(date) {
    return (0, $3nQMq.nextDay)(date, 5);
}

});

parcelRegister("de7fk", function(module, exports) {

$parcel$export(module.exports, "nextMonday", function () { return $9a12341d7df5bcfb$export$a20373bb0df6efdd; }, function (v) { return $9a12341d7df5bcfb$export$a20373bb0df6efdd = v; });
var $9a12341d7df5bcfb$export$a20373bb0df6efdd;
"use strict";
$9a12341d7df5bcfb$export$a20373bb0df6efdd = $9a12341d7df5bcfb$var$nextMonday;

var $3nQMq = parcelRequire("3nQMq");
/**
 * @name nextMonday
 * @category Weekday Helpers
 * @summary When is the next Monday?
 *
 * @description
 * When is the next Monday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Monday
 *
 * @example
 * // When is the next Monday after Mar, 22, 2020?
 * const result = nextMonday(new Date(2020, 2, 22))
 * //=> Mon Mar 23 2020 00:00:00
 */ function $9a12341d7df5bcfb$var$nextMonday(date) {
    return (0, $3nQMq.nextDay)(date, 1);
}

});

parcelRegister("bxkfc", function(module, exports) {

$parcel$export(module.exports, "nextSaturday", function () { return $86627adcfd7ee35b$export$c52f069246f7b032; }, function (v) { return $86627adcfd7ee35b$export$c52f069246f7b032 = v; });
var $86627adcfd7ee35b$export$c52f069246f7b032;
"use strict";
$86627adcfd7ee35b$export$c52f069246f7b032 = $86627adcfd7ee35b$var$nextSaturday;

var $3nQMq = parcelRequire("3nQMq");
/**
 * @name nextSaturday
 * @category Weekday Helpers
 * @summary When is the next Saturday?
 *
 * @description
 * When is the next Saturday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Saturday
 *
 * @example
 * // When is the next Saturday after Mar, 22, 2020?
 * const result = nextSaturday(new Date(2020, 2, 22))
 * //=> Sat Mar 28 2020 00:00:00
 */ function $86627adcfd7ee35b$var$nextSaturday(date) {
    return (0, $3nQMq.nextDay)(date, 6);
}

});

parcelRegister("552MX", function(module, exports) {

$parcel$export(module.exports, "nextSunday", function () { return $3b2f9526c388767c$export$a30adaa3ef47f854; }, function (v) { return $3b2f9526c388767c$export$a30adaa3ef47f854 = v; });
var $3b2f9526c388767c$export$a30adaa3ef47f854;
"use strict";
$3b2f9526c388767c$export$a30adaa3ef47f854 = $3b2f9526c388767c$var$nextSunday;

var $3nQMq = parcelRequire("3nQMq");
/**
 * @name nextSunday
 * @category Weekday Helpers
 * @summary When is the next Sunday?
 *
 * @description
 * When is the next Sunday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Sunday
 *
 * @example
 * // When is the next Sunday after Mar, 22, 2020?
 * const result = nextSunday(new Date(2020, 2, 22))
 * //=> Sun Mar 29 2020 00:00:00
 */ function $3b2f9526c388767c$var$nextSunday(date) {
    return (0, $3nQMq.nextDay)(date, 0);
}

});

parcelRegister("9FGqf", function(module, exports) {

$parcel$export(module.exports, "nextThursday", function () { return $70a8d992ace4ce24$export$36d9a8523a98d5a4; }, function (v) { return $70a8d992ace4ce24$export$36d9a8523a98d5a4 = v; });
var $70a8d992ace4ce24$export$36d9a8523a98d5a4;
"use strict";
$70a8d992ace4ce24$export$36d9a8523a98d5a4 = $70a8d992ace4ce24$var$nextThursday;

var $3nQMq = parcelRequire("3nQMq");
/**
 * @name nextThursday
 * @category Weekday Helpers
 * @summary When is the next Thursday?
 *
 * @description
 * When is the next Thursday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Thursday
 *
 * @example
 * // When is the next Thursday after Mar, 22, 2020?
 * const result = nextThursday(new Date(2020, 2, 22))
 * //=> Thur Mar 26 2020 00:00:00
 */ function $70a8d992ace4ce24$var$nextThursday(date) {
    return (0, $3nQMq.nextDay)(date, 4);
}

});

parcelRegister("d16Mv", function(module, exports) {

$parcel$export(module.exports, "nextTuesday", function () { return $97a0a0f9a911d7d0$export$391d63ff7dc2f668; }, function (v) { return $97a0a0f9a911d7d0$export$391d63ff7dc2f668 = v; });
var $97a0a0f9a911d7d0$export$391d63ff7dc2f668;
"use strict";
$97a0a0f9a911d7d0$export$391d63ff7dc2f668 = $97a0a0f9a911d7d0$var$nextTuesday;

var $3nQMq = parcelRequire("3nQMq");
/**
 * @name nextTuesday
 * @category Weekday Helpers
 * @summary When is the next Tuesday?
 *
 * @description
 * When is the next Tuesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Tuesday
 *
 * @example
 * // When is the next Tuesday after Mar, 22, 2020?
 * const result = nextTuesday(new Date(2020, 2, 22))
 * //=> Tue Mar 24 2020 00:00:00
 */ function $97a0a0f9a911d7d0$var$nextTuesday(date) {
    return (0, $3nQMq.nextDay)(date, 2);
}

});

parcelRegister("bLAGf", function(module, exports) {

$parcel$export(module.exports, "nextWednesday", function () { return $89108970edfeacda$export$7a895c1ff204304e; }, function (v) { return $89108970edfeacda$export$7a895c1ff204304e = v; });
var $89108970edfeacda$export$7a895c1ff204304e;
"use strict";
$89108970edfeacda$export$7a895c1ff204304e = $89108970edfeacda$var$nextWednesday;

var $3nQMq = parcelRequire("3nQMq");
/**
 * @name nextWednesday
 * @category Weekday Helpers
 * @summary When is the next Wednesday?
 *
 * @description
 * When is the next Wednesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Wednesday
 *
 * @example
 * // When is the next Wednesday after Mar, 22, 2020?
 * const result = nextWednesday(new Date(2020, 2, 22))
 * //=> Wed Mar 25 2020 00:00:00
 */ function $89108970edfeacda$var$nextWednesday(date) {
    return (0, $3nQMq.nextDay)(date, 3);
}

});

parcelRegister("hbpCX", function(module, exports) {

$parcel$export(module.exports, "parseISO", function () { return $c82757c875d609d0$export$4393d2ccbbedb219; }, function (v) { return $c82757c875d609d0$export$4393d2ccbbedb219 = v; });
var $c82757c875d609d0$export$4393d2ccbbedb219;
"use strict";
$c82757c875d609d0$export$4393d2ccbbedb219 = $c82757c875d609d0$var$parseISO;

var $7MMvH = parcelRequire("7MMvH");
/**
 * The {@link parseISO} function options.
 */ /**
 * @name parseISO
 * @category Common Helpers
 * @summary Parse ISO string
 *
 * @description
 * Parse the given string in ISO 8601 format and return an instance of Date.
 *
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If the argument isn't a string, the function cannot parse the string or
 * the values are invalid, it returns Invalid Date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param argument - The value to convert
 * @param options - An object with options
 *
 * @returns The parsed date in the local time zone
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * const result = parseISO('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * const result = parseISO('+02014101', { additionalDigits: 1 })
 * //=> Fri Apr 11 2014 00:00:00
 */ function $c82757c875d609d0$var$parseISO(argument, options) {
    const additionalDigits = options?.additionalDigits ?? 2;
    const dateStrings = $c82757c875d609d0$var$splitDateString(argument);
    let date;
    if (dateStrings.date) {
        const parseYearResult = $c82757c875d609d0$var$parseYear(dateStrings.date, additionalDigits);
        date = $c82757c875d609d0$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    const timestamp = date.getTime();
    let time = 0;
    let offset;
    if (dateStrings.time) {
        time = $c82757c875d609d0$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $c82757c875d609d0$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        const dirtyDate = new Date(timestamp + time);
        // JS parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        const result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
const $c82757c875d609d0$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
const $c82757c875d609d0$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
const $c82757c875d609d0$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
const $c82757c875d609d0$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $c82757c875d609d0$var$splitDateString(dateString) {
    const dateStrings = {};
    const array = dateString.split($c82757c875d609d0$var$patterns.dateTimeDelimiter);
    let timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($c82757c875d609d0$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($c82757c875d609d0$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        const token = $c82757c875d609d0$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], "");
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $c82757c875d609d0$var$parseYear(dateString, additionalDigits) {
    const regex = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + additionalDigits) + "})|(\\d{2}|[+-]\\d{" + (2 + additionalDigits) + "})$)");
    const captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ""
    };
    const year = captures[1] ? parseInt(captures[1]) : null;
    const century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $c82757c875d609d0$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    const captures = dateString.match($c82757c875d609d0$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    const isWeekDate = !!captures[4];
    const dayOfYear = $c82757c875d609d0$var$parseDateUnit(captures[1]);
    const month = $c82757c875d609d0$var$parseDateUnit(captures[2]) - 1;
    const day = $c82757c875d609d0$var$parseDateUnit(captures[3]);
    const week = $c82757c875d609d0$var$parseDateUnit(captures[4]);
    const dayOfWeek = $c82757c875d609d0$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$c82757c875d609d0$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $c82757c875d609d0$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        const date = new Date(0);
        if (!$c82757c875d609d0$var$validateDate(year, month, day) || !$c82757c875d609d0$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $c82757c875d609d0$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $c82757c875d609d0$var$parseTime(timeString) {
    const captures = timeString.match($c82757c875d609d0$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    const hours = $c82757c875d609d0$var$parseTimeUnit(captures[1]);
    const minutes = $c82757c875d609d0$var$parseTimeUnit(captures[2]);
    const seconds = $c82757c875d609d0$var$parseTimeUnit(captures[3]);
    if (!$c82757c875d609d0$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * $7MMvH.millisecondsInHour + minutes * $7MMvH.millisecondsInMinute + seconds * 1000;
}
function $c82757c875d609d0$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(",", ".")) || 0;
}
function $c82757c875d609d0$var$parseTimezone(timezoneString) {
    if (timezoneString === "Z") return 0;
    const captures = timezoneString.match($c82757c875d609d0$var$timezoneRegex);
    if (!captures) return 0;
    const sign = captures[1] === "+" ? -1 : 1;
    const hours = parseInt(captures[2]);
    const minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$c82757c875d609d0$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * $7MMvH.millisecondsInHour + minutes * $7MMvH.millisecondsInMinute);
}
function $c82757c875d609d0$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    const date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    const fourthOfJanuaryDay = date.getUTCDay() || 7;
    const diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
const $c82757c875d609d0$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $c82757c875d609d0$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $c82757c875d609d0$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($c82757c875d609d0$var$daysInMonths[month] || ($c82757c875d609d0$var$isLeapYearIndex(year) ? 29 : 28));
}
function $c82757c875d609d0$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($c82757c875d609d0$var$isLeapYearIndex(year) ? 366 : 365);
}
function $c82757c875d609d0$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $c82757c875d609d0$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $c82757c875d609d0$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}

});

parcelRegister("9fj9e", function(module, exports) {

$parcel$export(module.exports, "parseJSON", function () { return $6bb45e204fd84314$export$27924e57e9afff7f; }, function (v) { return $6bb45e204fd84314$export$27924e57e9afff7f = v; });
var $6bb45e204fd84314$export$27924e57e9afff7f;
"use strict";
$6bb45e204fd84314$export$27924e57e9afff7f = $6bb45e204fd84314$var$parseJSON; /**
 * @name parseJSON
 * @category Common Helpers
 * @summary Parse a JSON date string
 *
 * @description
 * Converts a complete ISO date string in UTC time, the typical format for transmitting
 * a date in JSON, to a JavaScript `Date` instance.
 *
 * This is a minimal implementation for converting dates retrieved from a JSON API to
 * a `Date` instance which can be used with other functions in the `date-fns` library.
 * The following formats are supported:
 *
 * - `2000-03-15T05:20:10.123Z`: The output of `.toISOString()` and `JSON.stringify(new Date())`
 * - `2000-03-15T05:20:10Z`: Without milliseconds
 * - `2000-03-15T05:20:10+00:00`: With a zero offset, the default JSON encoded format in some other languages
 * - `2000-03-15T05:20:10+05:45`: With a positive or negative offset, the default JSON encoded format in some other languages
 * - `2000-03-15T05:20:10+0000`: With a zero offset without a colon
 * - `2000-03-15T05:20:10`: Without a trailing 'Z' symbol
 * - `2000-03-15T05:20:10.1234567`: Up to 7 digits in milliseconds field. Only first 3 are taken into account since JS does not allow fractional milliseconds
 * - `2000-03-15 05:20:10`: With a space instead of a 'T' separator for APIs returning a SQL date without reformatting
 *
 * For convenience and ease of use these other input types are also supported
 * via [toDate](https://date-fns.org/docs/toDate):
 *
 * - A `Date` instance will be cloned
 * - A `number` will be treated as a timestamp
 *
 * Any other input type or invalid date strings will return an `Invalid Date`.
 *
 * @param dateStr - A fully formed ISO8601 date string to convert
 *
 * @returns The parsed date in the local time zone
 */ 
function $6bb45e204fd84314$var$parseJSON(dateStr) {
    const parts = dateStr.match(/(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(?:\.(\d{0,7}))?(?:Z|(.)(\d{2}):?(\d{2})?)?/);
    if (parts) // Group 8 matches the sign
    return new Date(Date.UTC(+parts[1], +parts[2] - 1, +parts[3], +parts[4] - (+parts[9] || 0) * (parts[8] == "-" ? -1 : 1), +parts[5] - (+parts[10] || 0) * (parts[8] == "-" ? -1 : 1), +parts[6], +((parts[7] || "0") + "00").substring(0, 3)));
    return new Date(NaN);
}

});

parcelRegister("3PuqO", function(module, exports) {

$parcel$export(module.exports, "previousDay", function () { return $2c9dbd93cb40f6a6$export$4caccb62df4eacc0; }, function (v) { return $2c9dbd93cb40f6a6$export$4caccb62df4eacc0 = v; });
var $2c9dbd93cb40f6a6$export$4caccb62df4eacc0;
"use strict";
$2c9dbd93cb40f6a6$export$4caccb62df4eacc0 = $2c9dbd93cb40f6a6$var$previousDay;

var $kvN19 = parcelRequire("kvN19");

var $lbcdn = parcelRequire("lbcdn");
/**
 * @name previousDay
 * @category Weekday Helpers
 * @summary When is the previous day of the week?
 *
 * @description
 * When is the previous day of the week? 0-6 the day of the week, 0 represents Sunday.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 * @param day - The day of the week
 *
 * @returns The date is the previous day of week
 *
 * @example
 * // When is the previous Monday before Mar, 20, 2020?
 * const result = previousDay(new Date(2020, 2, 20), 1)
 * //=> Mon Mar 16 2020 00:00:00
 *
 * @example
 * // When is the previous Tuesday before Mar, 21, 2020?
 * const result = previousDay(new Date(2020, 2, 21), 2)
 * //=> Tue Mar 17 2020 00:00:00
 */ function $2c9dbd93cb40f6a6$var$previousDay(date, day) {
    let delta = (0, $kvN19.getDay)(date) - day;
    if (delta <= 0) delta += 7;
    return (0, $lbcdn.subDays)(date, delta);
}

});

parcelRegister("jRpm6", function(module, exports) {

$parcel$export(module.exports, "previousFriday", function () { return $e756a2a4b0924cb4$export$32d52646c338c11d; }, function (v) { return $e756a2a4b0924cb4$export$32d52646c338c11d = v; });
var $e756a2a4b0924cb4$export$32d52646c338c11d;
"use strict";
$e756a2a4b0924cb4$export$32d52646c338c11d = $e756a2a4b0924cb4$var$previousFriday;

var $3PuqO = parcelRequire("3PuqO");
/**
 * @name previousFriday
 * @category Weekday Helpers
 * @summary When is the previous Friday?
 *
 * @description
 * When is the previous Friday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Friday
 *
 * @example
 * // When is the previous Friday before Jun, 19, 2021?
 * const result = previousFriday(new Date(2021, 5, 19))
 * //=> Fri June 18 2021 00:00:00
 */ function $e756a2a4b0924cb4$var$previousFriday(date) {
    return (0, $3PuqO.previousDay)(date, 5);
}

});

parcelRegister("kkX8H", function(module, exports) {

$parcel$export(module.exports, "previousMonday", function () { return $ece38cc2798a2f8d$export$398437ab6f45c582; }, function (v) { return $ece38cc2798a2f8d$export$398437ab6f45c582 = v; });
var $ece38cc2798a2f8d$export$398437ab6f45c582;
"use strict";
$ece38cc2798a2f8d$export$398437ab6f45c582 = $ece38cc2798a2f8d$var$previousMonday;

var $3PuqO = parcelRequire("3PuqO");
/**
 * @name previousMonday
 * @category Weekday Helpers
 * @summary When is the previous Monday?
 *
 * @description
 * When is the previous Monday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Monday
 *
 * @example
 * // When is the previous Monday before Jun, 18, 2021?
 * const result = previousMonday(new Date(2021, 5, 18))
 * //=> Mon June 14 2021 00:00:00
 */ function $ece38cc2798a2f8d$var$previousMonday(date) {
    return (0, $3PuqO.previousDay)(date, 1);
}

});

parcelRegister("6oRLT", function(module, exports) {

$parcel$export(module.exports, "previousSaturday", function () { return $4a8eb1e1302e525e$export$36767a7e6101ecb0; }, function (v) { return $4a8eb1e1302e525e$export$36767a7e6101ecb0 = v; });
var $4a8eb1e1302e525e$export$36767a7e6101ecb0;
"use strict";
$4a8eb1e1302e525e$export$36767a7e6101ecb0 = $4a8eb1e1302e525e$var$previousSaturday;

var $3PuqO = parcelRequire("3PuqO");
/**
 * @name previousSaturday
 * @category Weekday Helpers
 * @summary When is the previous Saturday?
 *
 * @description
 * When is the previous Saturday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Saturday
 *
 * @example
 * // When is the previous Saturday before Jun, 20, 2021?
 * const result = previousSaturday(new Date(2021, 5, 20))
 * //=> Sat June 19 2021 00:00:00
 */ function $4a8eb1e1302e525e$var$previousSaturday(date) {
    return (0, $3PuqO.previousDay)(date, 6);
}

});

parcelRegister("n3yTs", function(module, exports) {

$parcel$export(module.exports, "previousSunday", function () { return $0454e9656100f92a$export$7d3d7d8fc5e81fd4; }, function (v) { return $0454e9656100f92a$export$7d3d7d8fc5e81fd4 = v; });
var $0454e9656100f92a$export$7d3d7d8fc5e81fd4;
"use strict";
$0454e9656100f92a$export$7d3d7d8fc5e81fd4 = $0454e9656100f92a$var$previousSunday;

var $3PuqO = parcelRequire("3PuqO");
/**
 * @name previousSunday
 * @category Weekday Helpers
 * @summary When is the previous Sunday?
 *
 * @description
 * When is the previous Sunday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Sunday
 *
 * @example
 * // When is the previous Sunday before Jun, 21, 2021?
 * const result = previousSunday(new Date(2021, 5, 21))
 * //=> Sun June 20 2021 00:00:00
 */ function $0454e9656100f92a$var$previousSunday(date) {
    return (0, $3PuqO.previousDay)(date, 0);
}

});

parcelRegister("jFMQZ", function(module, exports) {

$parcel$export(module.exports, "previousThursday", function () { return $e527bdff2be3716f$export$1975b5b1f6b0e34e; }, function (v) { return $e527bdff2be3716f$export$1975b5b1f6b0e34e = v; });
var $e527bdff2be3716f$export$1975b5b1f6b0e34e;
"use strict";
$e527bdff2be3716f$export$1975b5b1f6b0e34e = $e527bdff2be3716f$var$previousThursday;

var $3PuqO = parcelRequire("3PuqO");
/**
 * @name previousThursday
 * @category Weekday Helpers
 * @summary When is the previous Thursday?
 *
 * @description
 * When is the previous Thursday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Thursday
 *
 * @example
 * // When is the previous Thursday before Jun, 18, 2021?
 * const result = previousThursday(new Date(2021, 5, 18))
 * //=> Thu June 17 2021 00:00:00
 */ function $e527bdff2be3716f$var$previousThursday(date) {
    return (0, $3PuqO.previousDay)(date, 4);
}

});

parcelRegister("fRpOA", function(module, exports) {

$parcel$export(module.exports, "previousTuesday", function () { return $b8bfd48ee000de28$export$a034a75f093bcfaf; }, function (v) { return $b8bfd48ee000de28$export$a034a75f093bcfaf = v; });
var $b8bfd48ee000de28$export$a034a75f093bcfaf;
"use strict";
$b8bfd48ee000de28$export$a034a75f093bcfaf = $b8bfd48ee000de28$var$previousTuesday;

var $3PuqO = parcelRequire("3PuqO");
/**
 * @name previousTuesday
 * @category Weekday Helpers
 * @summary When is the previous Tuesday?
 *
 * @description
 * When is the previous Tuesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Tuesday
 *
 * @example
 * // When is the previous Tuesday before Jun, 18, 2021?
 * const result = previousTuesday(new Date(2021, 5, 18))
 * //=> Tue June 15 2021 00:00:00
 */ function $b8bfd48ee000de28$var$previousTuesday(date) {
    return (0, $3PuqO.previousDay)(date, 2);
}

});

parcelRegister("16Un7", function(module, exports) {

$parcel$export(module.exports, "previousWednesday", function () { return $0cf2144929b6daec$export$26334f591e4ce672; }, function (v) { return $0cf2144929b6daec$export$26334f591e4ce672 = v; });
var $0cf2144929b6daec$export$26334f591e4ce672;
"use strict";
$0cf2144929b6daec$export$26334f591e4ce672 = $0cf2144929b6daec$var$previousWednesday;

var $3PuqO = parcelRequire("3PuqO");
/**
 * @name previousWednesday
 * @category Weekday Helpers
 * @summary When is the previous Wednesday?
 *
 * @description
 * When is the previous Wednesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Wednesday
 *
 * @example
 * // When is the previous Wednesday before Jun, 18, 2021?
 * const result = previousWednesday(new Date(2021, 5, 18))
 * //=> Wed June 16 2021 00:00:00
 */ function $0cf2144929b6daec$var$previousWednesday(date) {
    return (0, $3PuqO.previousDay)(date, 3);
}

});

parcelRegister("9ai94", function(module, exports) {

$parcel$export(module.exports, "quartersToMonths", function () { return $6ac31f80ffb57294$export$a29d19ce21d74c57; }, function (v) { return $6ac31f80ffb57294$export$a29d19ce21d74c57 = v; });
var $6ac31f80ffb57294$export$a29d19ce21d74c57;
"use strict";
$6ac31f80ffb57294$export$a29d19ce21d74c57 = $6ac31f80ffb57294$var$quartersToMonths;

var $7MMvH = parcelRequire("7MMvH");
/**
 * @name quartersToMonths
 * @category Conversion Helpers
 * @summary Convert number of quarters to months.
 *
 * @description
 * Convert a number of quarters to a full number of months.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param quarters - The number of quarters to be converted
 *
 * @returns The number of quarters converted in months
 *
 * @example
 * // Convert 2 quarters to months
 * const result = quartersToMonths(2)
 * //=> 6
 */ function $6ac31f80ffb57294$var$quartersToMonths(quarters) {
    return Math.trunc(quarters * $7MMvH.monthsInQuarter);
}

});

parcelRegister("k4Wvo", function(module, exports) {

$parcel$export(module.exports, "quartersToYears", function () { return $03c5b3e057146418$export$c309fa8f184b4648; }, function (v) { return $03c5b3e057146418$export$c309fa8f184b4648 = v; });
var $03c5b3e057146418$export$c309fa8f184b4648;
"use strict";
$03c5b3e057146418$export$c309fa8f184b4648 = $03c5b3e057146418$var$quartersToYears;

var $7MMvH = parcelRequire("7MMvH");
/**
 * @name quartersToYears
 * @category Conversion Helpers
 * @summary Convert number of quarters to years.
 *
 * @description
 * Convert a number of quarters to a full number of years.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param quarters - The number of quarters to be converted
 *
 * @returns The number of quarters converted in years
 *
 * @example
 * // Convert 8 quarters to years
 * const result = quartersToYears(8)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = quartersToYears(11)
 * //=> 2
 */ function $03c5b3e057146418$var$quartersToYears(quarters) {
    const years = quarters / $7MMvH.quartersInYear;
    return Math.trunc(years);
}

});

parcelRegister("fAa5v", function(module, exports) {

$parcel$export(module.exports, "roundToNearestHours", function () { return $b5820b04529d49a5$export$a8b87649ebc0e3c2; }, function (v) { return $b5820b04529d49a5$export$a8b87649ebc0e3c2 = v; });
var $b5820b04529d49a5$export$a8b87649ebc0e3c2;
"use strict";
$b5820b04529d49a5$export$a8b87649ebc0e3c2 = $b5820b04529d49a5$var$roundToNearestHours;

var $bumqY = parcelRequire("bumqY");

var $02yAu = parcelRequire("02yAu");

var $b3MCU = parcelRequire("b3MCU");
/**
 * The {@link roundToNearestHours} function options.
 */ /**
 * @name roundToNearestHours
 * @category Hour Helpers
 * @summary Rounds the given date to the nearest hour
 *
 * @description
 * Rounds the given date to the nearest hour (or number of hours).
 * Rounds up when the given date is exactly between the nearest round hours.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to round
 * @param options - An object with options.
 *
 * @returns The new date rounded to the closest hour
 *
 * @example
 * // Round 10 July 2014 12:34:56 to nearest hour:
 * const result = roundToNearestHours(new Date(2014, 6, 10, 12, 34, 56))
 * //=> Thu Jul 10 2014 13:00:00
 *
 * @example
 * // Round 10 July 2014 12:34:56 to nearest half hour:
 * const result = roundToNearestHours(new Date(2014, 6, 10, 12, 34, 56), { nearestTo: 6 })
 * //=> Thu Jul 10 2014 12:00:00

 * @example
 * // Round 10 July 2014 12:34:56 to nearest half hour:
 * const result = roundToNearestHours(new Date(2014, 6, 10, 12, 34, 56), { nearestTo: 8 })
 * //=> Thu Jul 10 2014 16:00:00

* @example
 * // Floor (rounds down) 10 July 2014 12:34:56 to nearest hour:
 * const result = roundToNearestHours(new Date(2014, 6, 10, 1, 23, 45), { roundingMethod: 'ceil' })
 * //=> Thu Jul 10 2014 02:00:00
 *
 * @example
 * // Ceil (rounds up) 10 July 2014 12:34:56 to nearest quarter hour:
 * const result = roundToNearestHours(new Date(2014, 6, 10, 12, 34, 56), { roundingMethod: 'floor', nearestTo: 8 })
 * //=> Thu Jul 10 2014 08:00:00
 */ function $b5820b04529d49a5$var$roundToNearestHours(date, options) {
    const nearestTo = options?.nearestTo ?? 1;
    if (nearestTo < 1 || nearestTo > 12) return (0, $02yAu.constructFrom)(date, NaN);
    const _date = (0, $b3MCU.toDate)(date);
    const fractionalMinutes = _date.getMinutes() / 60;
    const fractionalSeconds = _date.getSeconds() / 60 / 60;
    const fractionalMilliseconds = _date.getMilliseconds() / 1000 / 60 / 60;
    const hours = _date.getHours() + fractionalMinutes + fractionalSeconds + fractionalMilliseconds;
    // Unlike the `differenceIn*` functions, the default rounding behavior is `round` and not 'trunc'
    const method = options?.roundingMethod ?? "round";
    const roundingMethod = (0, $bumqY.getRoundingMethod)(method);
    // nearestTo option does not care daylight savings time
    const roundedHours = roundingMethod(hours / nearestTo) * nearestTo;
    const result = (0, $02yAu.constructFrom)(date, _date);
    result.setHours(roundedHours, 0, 0, 0);
    return result;
}

});

parcelRegister("e5iTd", function(module, exports) {

$parcel$export(module.exports, "roundToNearestMinutes", function () { return $a4102f67f4de019e$export$d97410bb8cd0dff; }, function (v) { return $a4102f67f4de019e$export$d97410bb8cd0dff = v; });
var $a4102f67f4de019e$export$d97410bb8cd0dff;
"use strict";
$a4102f67f4de019e$export$d97410bb8cd0dff = $a4102f67f4de019e$var$roundToNearestMinutes;

var $bumqY = parcelRequire("bumqY");

var $02yAu = parcelRequire("02yAu");

var $b3MCU = parcelRequire("b3MCU");
/**
 * The {@link roundToNearestMinutes} function options.
 */ /**
 * @name roundToNearestMinutes
 * @category Minute Helpers
 * @summary Rounds the given date to the nearest minute
 *
 * @description
 * Rounds the given date to the nearest minute (or number of minutes).
 * Rounds up when the given date is exactly between the nearest round minutes.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to round
 * @param options - An object with options.
 *
 * @returns The new date rounded to the closest minute
 *
 * @example
 * // Round 10 July 2014 12:12:34 to nearest minute:
 * const result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34))
 * //=> Thu Jul 10 2014 12:13:00
 *
 * @example
 * // Round 10 July 2014 12:12:34 to nearest quarter hour:
 * const result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34), { nearestTo: 15 })
 * //=> Thu Jul 10 2014 12:15:00
 *
 * @example
 * // Floor (rounds down) 10 July 2014 12:12:34 to nearest minute:
 * const result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34), { roundingMethod: 'floor' })
 * //=> Thu Jul 10 2014 12:12:00
 *
 * @example
 * // Ceil (rounds up) 10 July 2014 12:12:34 to nearest half hour:
 * const result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34), { roundingMethod: 'ceil', nearestTo: 30 })
 * //=> Thu Jul 10 2014 12:30:00
 */ function $a4102f67f4de019e$var$roundToNearestMinutes(date, options) {
    const nearestTo = options?.nearestTo ?? 1;
    if (nearestTo < 1 || nearestTo > 30) return (0, $02yAu.constructFrom)(date, NaN);
    const _date = (0, $b3MCU.toDate)(date);
    const fractionalSeconds = _date.getSeconds() / 60;
    const fractionalMilliseconds = _date.getMilliseconds() / 1000 / 60;
    const minutes = _date.getMinutes() + fractionalSeconds + fractionalMilliseconds;
    // Unlike the `differenceIn*` functions, the default rounding behavior is `round` and not 'trunc'
    const method = options?.roundingMethod ?? "round";
    const roundingMethod = (0, $bumqY.getRoundingMethod)(method);
    const roundedMinutes = roundingMethod(minutes / nearestTo) * nearestTo;
    const result = (0, $02yAu.constructFrom)(date, _date);
    result.setMinutes(roundedMinutes, 0, 0);
    return result;
}

});

parcelRegister("8oQSv", function(module, exports) {

$parcel$export(module.exports, "secondsToHours", function () { return $61d9951c339d0811$export$47d555ff5354096f; }, function (v) { return $61d9951c339d0811$export$47d555ff5354096f = v; });
var $61d9951c339d0811$export$47d555ff5354096f;
"use strict";
$61d9951c339d0811$export$47d555ff5354096f = $61d9951c339d0811$var$secondsToHours;

var $7MMvH = parcelRequire("7MMvH");
/**
 * @name secondsToHours
 * @category Conversion Helpers
 * @summary Convert seconds to hours.
 *
 * @description
 * Convert a number of seconds to a full number of hours.
 *
 * @param seconds - The number of seconds to be converted
 *
 * @returns The number of seconds converted in hours
 *
 * @example
 * // Convert 7200 seconds into hours
 * const result = secondsToHours(7200)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = secondsToHours(7199)
 * //=> 1
 */ function $61d9951c339d0811$var$secondsToHours(seconds) {
    const hours = seconds / $7MMvH.secondsInHour;
    return Math.trunc(hours);
}

});

parcelRegister("bTQA0", function(module, exports) {

$parcel$export(module.exports, "secondsToMilliseconds", function () { return $8a9d9dfb51fef4a0$export$fc3e7e8557f8c8c7; }, function (v) { return $8a9d9dfb51fef4a0$export$fc3e7e8557f8c8c7 = v; });
var $8a9d9dfb51fef4a0$export$fc3e7e8557f8c8c7;
"use strict";
$8a9d9dfb51fef4a0$export$fc3e7e8557f8c8c7 = $8a9d9dfb51fef4a0$var$secondsToMilliseconds;

var $7MMvH = parcelRequire("7MMvH");
/**
 * @name secondsToMilliseconds
 * @category Conversion Helpers
 * @summary Convert seconds to milliseconds.
 *
 * @description
 * Convert a number of seconds to a full number of milliseconds.
 *
 * @param seconds - The number of seconds to be converted
 *
 * @returns The number of seconds converted in milliseconds
 *
 * @example
 * // Convert 2 seconds into milliseconds
 * const result = secondsToMilliseconds(2)
 * //=> 2000
 */ function $8a9d9dfb51fef4a0$var$secondsToMilliseconds(seconds) {
    return seconds * $7MMvH.millisecondsInSecond;
}

});

parcelRegister("lN9IU", function(module, exports) {

$parcel$export(module.exports, "secondsToMinutes", function () { return $fdd5b7682e4d77b5$export$ed657adb62398e99; }, function (v) { return $fdd5b7682e4d77b5$export$ed657adb62398e99 = v; });
var $fdd5b7682e4d77b5$export$ed657adb62398e99;
"use strict";
$fdd5b7682e4d77b5$export$ed657adb62398e99 = $fdd5b7682e4d77b5$var$secondsToMinutes;

var $7MMvH = parcelRequire("7MMvH");
/**
 * @name secondsToMinutes
 * @category Conversion Helpers
 * @summary Convert seconds to minutes.
 *
 * @description
 * Convert a number of seconds to a full number of minutes.
 *
 * @param seconds - The number of seconds to be converted
 *
 * @returns The number of seconds converted in minutes
 *
 * @example
 * // Convert 120 seconds into minutes
 * const result = secondsToMinutes(120)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = secondsToMinutes(119)
 * //=> 1
 */ function $fdd5b7682e4d77b5$var$secondsToMinutes(seconds) {
    const minutes = seconds / $7MMvH.secondsInMinute;
    return Math.trunc(minutes);
}

});

parcelRegister("3OIEn", function(module, exports) {

$parcel$export(module.exports, "set", function () { return $2c78ad31d7e02107$export$adaa4cf7ef1b65be; }, function (v) { return $2c78ad31d7e02107$export$adaa4cf7ef1b65be = v; });
var $2c78ad31d7e02107$export$adaa4cf7ef1b65be;
"use strict";
$2c78ad31d7e02107$export$adaa4cf7ef1b65be = $2c78ad31d7e02107$var$set;

var $02yAu = parcelRequire("02yAu");

var $fMQT4 = parcelRequire("fMQT4");

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name set
 * @category Common Helpers
 * @summary Set date values to a given date.
 *
 * @description
 * Set date values to a given date.
 *
 * Sets time values to date from object `values`.
 * A value is not set if it is undefined or null or doesn't exist in `values`.
 *
 * Note about bundle size: `set` does not internally use `setX` functions from date-fns but instead opts
 * to use native `Date#setX` methods. If you use this function, you may not want to include the
 * other `setX` functions that date-fns provides if you are concerned about the bundle size.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param values - The date values to be set
 *
 * @returns The new date with options set
 *
 * @example
 * // Transform 1 September 2014 into 20 October 2015 in a single line:
 * const result = set(new Date(2014, 8, 20), { year: 2015, month: 9, date: 20 })
 * //=> Tue Oct 20 2015 00:00:00
 *
 * @example
 * // Set 12 PM to 1 September 2014 01:23:45 to 1 September 2014 12:00:00:
 * const result = set(new Date(2014, 8, 1, 1, 23, 45), { hours: 12 })
 * //=> Mon Sep 01 2014 12:23:45
 */ function $2c78ad31d7e02107$var$set(date, values) {
    let _date = (0, $b3MCU.toDate)(date);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(+_date)) return (0, $02yAu.constructFrom)(date, NaN);
    if (values.year != null) _date.setFullYear(values.year);
    if (values.month != null) _date = (0, $fMQT4.setMonth)(_date, values.month);
    if (values.date != null) _date.setDate(values.date);
    if (values.hours != null) _date.setHours(values.hours);
    if (values.minutes != null) _date.setMinutes(values.minutes);
    if (values.seconds != null) _date.setSeconds(values.seconds);
    if (values.milliseconds != null) _date.setMilliseconds(values.milliseconds);
    return _date;
}

});
parcelRegister("fMQT4", function(module, exports) {

$parcel$export(module.exports, "setMonth", function () { return $b7e45d04c139300e$export$63264690f8e36790; }, function (v) { return $b7e45d04c139300e$export$63264690f8e36790 = v; });
var $b7e45d04c139300e$export$63264690f8e36790;
"use strict";
$b7e45d04c139300e$export$63264690f8e36790 = $b7e45d04c139300e$var$setMonth;

var $02yAu = parcelRequire("02yAu");

var $9HF9I = parcelRequire("9HF9I");

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name setMonth
 * @category Month Helpers
 * @summary Set the month to the given date.
 *
 * @description
 * Set the month to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param month - The month index to set (0-11)
 *
 * @returns The new date with the month set
 *
 * @example
 * // Set February to 1 September 2014:
 * const result = setMonth(new Date(2014, 8, 1), 1)
 * //=> Sat Feb 01 2014 00:00:00
 */ function $b7e45d04c139300e$var$setMonth(date, month) {
    const _date = (0, $b3MCU.toDate)(date);
    const year = _date.getFullYear();
    const day = _date.getDate();
    const dateWithDesiredMonth = (0, $02yAu.constructFrom)(date, 0);
    dateWithDesiredMonth.setFullYear(year, month, 15);
    dateWithDesiredMonth.setHours(0, 0, 0, 0);
    const daysInMonth = (0, $9HF9I.getDaysInMonth)(dateWithDesiredMonth);
    // Set the last day of the new month
    // if the original date was the last day of the longer month
    _date.setMonth(month, Math.min(day, daysInMonth));
    return _date;
}

});


parcelRegister("52EB0", function(module, exports) {

$parcel$export(module.exports, "setDate", function () { return $3abca12776dcb779$export$566174fa40823587; }, function (v) { return $3abca12776dcb779$export$566174fa40823587 = v; });
var $3abca12776dcb779$export$566174fa40823587;
"use strict";
$3abca12776dcb779$export$566174fa40823587 = $3abca12776dcb779$var$setDate;

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name setDate
 * @category Day Helpers
 * @summary Set the day of the month to the given date.
 *
 * @description
 * Set the day of the month to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param dayOfMonth - The day of the month of the new date
 *
 * @returns The new date with the day of the month set
 *
 * @example
 * // Set the 30th day of the month to 1 September 2014:
 * const result = setDate(new Date(2014, 8, 1), 30)
 * //=> Tue Sep 30 2014 00:00:00
 */ function $3abca12776dcb779$var$setDate(date, dayOfMonth) {
    const _date = (0, $b3MCU.toDate)(date);
    _date.setDate(dayOfMonth);
    return _date;
}

});

parcelRegister("erDQf", function(module, exports) {

$parcel$export(module.exports, "setDayOfYear", function () { return $a8427e08fb89ff27$export$2af590ffc7e7d7c5; }, function (v) { return $a8427e08fb89ff27$export$2af590ffc7e7d7c5 = v; });
var $a8427e08fb89ff27$export$2af590ffc7e7d7c5;
"use strict";
$a8427e08fb89ff27$export$2af590ffc7e7d7c5 = $a8427e08fb89ff27$var$setDayOfYear;

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name setDayOfYear
 * @category Day Helpers
 * @summary Set the day of the year to the given date.
 *
 * @description
 * Set the day of the year to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param dayOfYear - The day of the year of the new date
 *
 * @returns The new date with the day of the year set
 *
 * @example
 * // Set the 2nd day of the year to 2 July 2014:
 * const result = setDayOfYear(new Date(2014, 6, 2), 2)
 * //=> Thu Jan 02 2014 00:00:00
 */ function $a8427e08fb89ff27$var$setDayOfYear(date, dayOfYear) {
    const _date = (0, $b3MCU.toDate)(date);
    _date.setMonth(0);
    _date.setDate(dayOfYear);
    return _date;
}

});

parcelRegister("73uS3", function(module, exports) {

$parcel$export(module.exports, "setDefaultOptions", function () { return $5230c281e770391c$export$95365be1b0704abc; }, function (v) { return $5230c281e770391c$export$95365be1b0704abc = v; });
var $5230c281e770391c$export$95365be1b0704abc;
"use strict";
$5230c281e770391c$export$95365be1b0704abc = $5230c281e770391c$var$setDefaultOptions;

var $lJvf9 = parcelRequire("lJvf9");
/**
 * @name setDefaultOptions
 * @category Common Helpers
 * @summary Set default options including locale.
 * @pure false
 *
 * @description
 * Sets the defaults for
 * `options.locale`, `options.weekStartsOn` and `options.firstWeekContainsDate`
 * arguments for all functions.
 *
 * @param options - An object with options
 *
 * @example
 * // Set global locale:
 * import { es } from 'date-fns/locale'
 * setDefaultOptions({ locale: es })
 * const result = format(new Date(2014, 8, 2), 'PPPP')
 * //=> 'martes, 2 de septiembre de 2014'
 *
 * @example
 * // Start of the week for 2 September 2014:
 * const result = startOfWeek(new Date(2014, 8, 2))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // Start of the week for 2 September 2014,
 * // when we set that week starts on Monday by default:
 * setDefaultOptions({ weekStartsOn: 1 })
 * const result = startOfWeek(new Date(2014, 8, 2))
 * //=> Mon Sep 01 2014 00:00:00
 *
 * @example
 * // Manually set options take priority over default options:
 * setDefaultOptions({ weekStartsOn: 1 })
 * const result = startOfWeek(new Date(2014, 8, 2), { weekStartsOn: 0 })
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // Remove the option by setting it to `undefined`:
 * setDefaultOptions({ weekStartsOn: 1 })
 * setDefaultOptions({ weekStartsOn: undefined })
 * const result = startOfWeek(new Date(2014, 8, 2))
 * //=> Sun Aug 31 2014 00:00:00
 */ function $5230c281e770391c$var$setDefaultOptions(options) {
    const result = {};
    const defaultOptions = (0, $lJvf9.getDefaultOptions)();
    for(const property in defaultOptions)if (Object.prototype.hasOwnProperty.call(defaultOptions, property)) // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
    result[property] = defaultOptions[property];
    for(const property in options)if (Object.prototype.hasOwnProperty.call(options, property)) {
        if (options[property] === undefined) // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
        delete result[property];
        else // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
        result[property] = options[property];
    }
    (0, $lJvf9.setDefaultOptions)(result);
}

});

parcelRegister("2qbw1", function(module, exports) {

$parcel$export(module.exports, "setHours", function () { return $1c36f13b080ff72d$export$f86b797a4659b781; }, function (v) { return $1c36f13b080ff72d$export$f86b797a4659b781 = v; });
var $1c36f13b080ff72d$export$f86b797a4659b781;
"use strict";
$1c36f13b080ff72d$export$f86b797a4659b781 = $1c36f13b080ff72d$var$setHours;

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name setHours
 * @category Hour Helpers
 * @summary Set the hours to the given date.
 *
 * @description
 * Set the hours to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param hours - The hours of the new date
 *
 * @returns The new date with the hours set
 *
 * @example
 * // Set 4 hours to 1 September 2014 11:30:00:
 * const result = setHours(new Date(2014, 8, 1, 11, 30), 4)
 * //=> Mon Sep 01 2014 04:30:00
 */ function $1c36f13b080ff72d$var$setHours(date, hours) {
    const _date = (0, $b3MCU.toDate)(date);
    _date.setHours(hours);
    return _date;
}

});

parcelRegister("lSadI", function(module, exports) {

$parcel$export(module.exports, "setMilliseconds", function () { return $fec691a4a0b2b84d$export$de5664029b35e06d; }, function (v) { return $fec691a4a0b2b84d$export$de5664029b35e06d = v; });
var $fec691a4a0b2b84d$export$de5664029b35e06d;
"use strict";
$fec691a4a0b2b84d$export$de5664029b35e06d = $fec691a4a0b2b84d$var$setMilliseconds;

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name setMilliseconds
 * @category Millisecond Helpers
 * @summary Set the milliseconds to the given date.
 *
 * @description
 * Set the milliseconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param milliseconds - The milliseconds of the new date
 *
 * @returns The new date with the milliseconds set
 *
 * @example
 * // Set 300 milliseconds to 1 September 2014 11:30:40.500:
 * const result = setMilliseconds(new Date(2014, 8, 1, 11, 30, 40, 500), 300)
 * //=> Mon Sep 01 2014 11:30:40.300
 */ function $fec691a4a0b2b84d$var$setMilliseconds(date, milliseconds) {
    const _date = (0, $b3MCU.toDate)(date);
    _date.setMilliseconds(milliseconds);
    return _date;
}

});

parcelRegister("avSVV", function(module, exports) {

$parcel$export(module.exports, "setMinutes", function () { return $7a776941c10f6062$export$ad569bf1c79ea89d; }, function (v) { return $7a776941c10f6062$export$ad569bf1c79ea89d = v; });
var $7a776941c10f6062$export$ad569bf1c79ea89d;
"use strict";
$7a776941c10f6062$export$ad569bf1c79ea89d = $7a776941c10f6062$var$setMinutes;

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name setMinutes
 * @category Minute Helpers
 * @summary Set the minutes to the given date.
 *
 * @description
 * Set the minutes to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param minutes - The minutes of the new date
 *
 * @returns The new date with the minutes set
 *
 * @example
 * // Set 45 minutes to 1 September 2014 11:30:40:
 * const result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:45:40
 */ function $7a776941c10f6062$var$setMinutes(date, minutes) {
    const _date = (0, $b3MCU.toDate)(date);
    _date.setMinutes(minutes);
    return _date;
}

});

parcelRegister("5OQUm", function(module, exports) {

$parcel$export(module.exports, "setQuarter", function () { return $43caa9b2dadd6f23$export$8924d1de7efe1755; }, function (v) { return $43caa9b2dadd6f23$export$8924d1de7efe1755 = v; });
var $43caa9b2dadd6f23$export$8924d1de7efe1755;
"use strict";
$43caa9b2dadd6f23$export$8924d1de7efe1755 = $43caa9b2dadd6f23$var$setQuarter;

var $fMQT4 = parcelRequire("fMQT4");

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name setQuarter
 * @category Quarter Helpers
 * @summary Set the year quarter to the given date.
 *
 * @description
 * Set the year quarter to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param quarter - The quarter of the new date
 *
 * @returns The new date with the quarter set
 *
 * @example
 * // Set the 2nd quarter to 2 July 2014:
 * const result = setQuarter(new Date(2014, 6, 2), 2)
 * //=> Wed Apr 02 2014 00:00:00
 */ function $43caa9b2dadd6f23$var$setQuarter(date, quarter) {
    const _date = (0, $b3MCU.toDate)(date);
    const oldQuarter = Math.trunc(_date.getMonth() / 3) + 1;
    const diff = quarter - oldQuarter;
    return (0, $fMQT4.setMonth)(_date, _date.getMonth() + diff * 3);
}

});

parcelRegister("8UzgH", function(module, exports) {

$parcel$export(module.exports, "setSeconds", function () { return $67cee942440e05d8$export$aec44746644cbf43; }, function (v) { return $67cee942440e05d8$export$aec44746644cbf43 = v; });
var $67cee942440e05d8$export$aec44746644cbf43;
"use strict";
$67cee942440e05d8$export$aec44746644cbf43 = $67cee942440e05d8$var$setSeconds;

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name setSeconds
 * @category Second Helpers
 * @summary Set the seconds to the given date.
 *
 * @description
 * Set the seconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param seconds - The seconds of the new date
 *
 * @returns The new date with the seconds set
 *
 * @example
 * // Set 45 seconds to 1 September 2014 11:30:40:
 * const result = setSeconds(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:30:45
 */ function $67cee942440e05d8$var$setSeconds(date, seconds) {
    const _date = (0, $b3MCU.toDate)(date);
    _date.setSeconds(seconds);
    return _date;
}

});

parcelRegister("6oS25", function(module, exports) {

$parcel$export(module.exports, "setWeekYear", function () { return $4a8ee5b5cce22928$export$4340968d5939835e; }, function (v) { return $4a8ee5b5cce22928$export$4340968d5939835e = v; });
var $4a8ee5b5cce22928$export$4340968d5939835e;
"use strict";
$4a8ee5b5cce22928$export$4340968d5939835e = $4a8ee5b5cce22928$var$setWeekYear;

var $02yAu = parcelRequire("02yAu");

var $fctE0 = parcelRequire("fctE0");

var $1pqul = parcelRequire("1pqul");

var $b3MCU = parcelRequire("b3MCU");

var $lJvf9 = parcelRequire("lJvf9");
/**
 * The {@link setWeekYear} function options.
 */ /**
 * @name setWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Set the local week-numbering year to the given date.
 *
 * @description
 * Set the local week-numbering year to the given date,
 * saving the week number and the weekday number.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param weekYear - The local week-numbering year of the new date
 * @param options - An object with options
 *
 * @returns The new date with the local week-numbering year set
 *
 * @example
 * // Set the local week-numbering year 2004 to 2 January 2010 with default options:
 * const result = setWeekYear(new Date(2010, 0, 2), 2004)
 * //=> Sat Jan 03 2004 00:00:00
 *
 * @example
 * // Set the local week-numbering year 2004 to 2 January 2010,
 * // if Monday is the first day of week
 * // and 4 January is always in the first week of the year:
 * const result = setWeekYear(new Date(2010, 0, 2), 2004, {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Sat Jan 01 2005 00:00:00
 */ function $4a8ee5b5cce22928$var$setWeekYear(date, weekYear, options) {
    const defaultOptions = (0, $lJvf9.getDefaultOptions)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    let _date = (0, $b3MCU.toDate)(date);
    const diff = (0, $fctE0.differenceInCalendarDays)(_date, (0, $1pqul.startOfWeekYear)(_date, options));
    const firstWeek = (0, $02yAu.constructFrom)(date, 0);
    firstWeek.setFullYear(weekYear, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    _date = (0, $1pqul.startOfWeekYear)(firstWeek, options);
    _date.setDate(_date.getDate() + diff);
    return _date;
}

});

parcelRegister("gfq0K", function(module, exports) {

$parcel$export(module.exports, "setYear", function () { return $bd423953c84a1c44$export$a8408b6c5639cab7; }, function (v) { return $bd423953c84a1c44$export$a8408b6c5639cab7 = v; });
var $bd423953c84a1c44$export$a8408b6c5639cab7;
"use strict";
$bd423953c84a1c44$export$a8408b6c5639cab7 = $bd423953c84a1c44$var$setYear;

var $02yAu = parcelRequire("02yAu");

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name setYear
 * @category Year Helpers
 * @summary Set the year to the given date.
 *
 * @description
 * Set the year to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param year - The year of the new date
 *
 * @returns The new date with the year set
 *
 * @example
 * // Set year 2013 to 1 September 2014:
 * const result = setYear(new Date(2014, 8, 1), 2013)
 * //=> Sun Sep 01 2013 00:00:00
 */ function $bd423953c84a1c44$var$setYear(date, year) {
    const _date = (0, $b3MCU.toDate)(date);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(+_date)) return (0, $02yAu.constructFrom)(date, NaN);
    _date.setFullYear(year);
    return _date;
}

});

parcelRegister("pHAlK", function(module, exports) {

$parcel$export(module.exports, "startOfDecade", function () { return $04d4250b458a5f58$export$730492981c634308; }, function (v) { return $04d4250b458a5f58$export$730492981c634308 = v; });
var $04d4250b458a5f58$export$730492981c634308;
"use strict";
$04d4250b458a5f58$export$730492981c634308 = $04d4250b458a5f58$var$startOfDecade;

var $b3MCU = parcelRequire("b3MCU");
/**
 * @name startOfDecade
 * @category Decade Helpers
 * @summary Return the start of a decade for the given date.
 *
 * @description
 * Return the start of a decade for the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a decade
 *
 * @example
 * // The start of a decade for 21 October 2015 00:00:00:
 * const result = startOfDecade(new Date(2015, 9, 21, 00, 00, 00))
 * //=> Jan 01 2010 00:00:00
 */ function $04d4250b458a5f58$var$startOfDecade(date) {
    // TODO: Switch to more technical definition in of decades that start with 1
    // end with 0. I.e. 2001-2010 instead of current 2000-2009. It's a breaking
    // change, so it can only be done in 4.0.
    const _date = (0, $b3MCU.toDate)(date);
    const year = _date.getFullYear();
    const decade = Math.floor(year / 10) * 10;
    _date.setFullYear(decade, 0, 1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

});

parcelRegister("aDwxJ", function(module, exports) {

$parcel$export(module.exports, "startOfToday", function () { return $7be6ca4449a48b58$export$444d742fd5a45a57; }, function (v) { return $7be6ca4449a48b58$export$444d742fd5a45a57 = v; });
var $7be6ca4449a48b58$export$444d742fd5a45a57;
"use strict";
$7be6ca4449a48b58$export$444d742fd5a45a57 = $7be6ca4449a48b58$var$startOfToday;

var $aorCW = parcelRequire("aorCW");
/**
 * @name startOfToday
 * @category Day Helpers
 * @summary Return the start of today.
 * @pure false
 *
 * @description
 * Return the start of today.
 *
 * @returns The start of today
 *
 * @example
 * // If today is 6 October 2014:
 * const result = startOfToday()
 * //=> Mon Oct 6 2014 00:00:00
 */ function $7be6ca4449a48b58$var$startOfToday() {
    return (0, $aorCW.startOfDay)(Date.now());
}

});

parcelRegister("lkhBu", function(module, exports) {

$parcel$export(module.exports, "startOfTomorrow", function () { return $f8691ef7bbe85363$export$7e8566c79d5bee07; }, function (v) { return $f8691ef7bbe85363$export$7e8566c79d5bee07 = v; });
var $f8691ef7bbe85363$export$7e8566c79d5bee07;
"use strict";
$f8691ef7bbe85363$export$7e8566c79d5bee07 = $f8691ef7bbe85363$var$startOfTomorrow; /**
 * @name startOfTomorrow
 * @category Day Helpers
 * @summary Return the start of tomorrow.
 * @pure false
 *
 * @description
 * Return the start of tomorrow.
 *
 * @returns The start of tomorrow
 *
 * @example
 * // If today is 6 October 2014:
 * const result = startOfTomorrow()
 * //=> Tue Oct 7 2014 00:00:00
 */ 
function $f8691ef7bbe85363$var$startOfTomorrow() {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();
    const day = now.getDate();
    const date = new Date(0);
    date.setFullYear(year, month, day + 1);
    date.setHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("fV1is", function(module, exports) {

$parcel$export(module.exports, "startOfYesterday", function () { return $b96d2f6633d2432c$export$23a16f3c6d143ce9; }, function (v) { return $b96d2f6633d2432c$export$23a16f3c6d143ce9 = v; });
var $b96d2f6633d2432c$export$23a16f3c6d143ce9;
"use strict";
$b96d2f6633d2432c$export$23a16f3c6d143ce9 = $b96d2f6633d2432c$var$startOfYesterday; /**
 * @name startOfYesterday
 * @category Day Helpers
 * @summary Return the start of yesterday.
 * @pure false
 *
 * @description
 * Return the start of yesterday.
 *
 * @returns The start of yesterday
 *
 * @example
 * // If today is 6 October 2014:
 * const result = startOfYesterday()
 * //=> Sun Oct 5 2014 00:00:00
 */ 
function $b96d2f6633d2432c$var$startOfYesterday() {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();
    const day = now.getDate();
    const date = new Date(0);
    date.setFullYear(year, month, day - 1);
    date.setHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("kfUjo", function(module, exports) {

$parcel$export(module.exports, "sub", function () { return $ebf0e3bb5008108a$export$f93b5905241a7cca; }, function (v) { return $ebf0e3bb5008108a$export$f93b5905241a7cca = v; });
var $ebf0e3bb5008108a$export$f93b5905241a7cca;
"use strict";
$ebf0e3bb5008108a$export$f93b5905241a7cca = $ebf0e3bb5008108a$var$sub;

var $lbcdn = parcelRequire("lbcdn");

var $4hV23 = parcelRequire("4hV23");

var $02yAu = parcelRequire("02yAu");
/**
 * @name sub
 * @category Common Helpers
 * @summary Subtract the specified years, months, weeks, days, hours, minutes and seconds from the given date.
 *
 * @description
 * Subtract the specified years, months, weeks, days, hours, minutes and seconds from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param duration - The object with years, months, weeks, days, hours, minutes and seconds to be subtracted
 *
 * | Key     | Description                        |
 * |---------|------------------------------------|
 * | years   | Amount of years to be subtracted   |
 * | months  | Amount of months to be subtracted  |
 * | weeks   | Amount of weeks to be subtracted   |
 * | days    | Amount of days to be subtracted    |
 * | hours   | Amount of hours to be subtracted   |
 * | minutes | Amount of minutes to be subtracted |
 * | seconds | Amount of seconds to be subtracted |
 *
 * All values default to 0
 *
 * @returns The new date with the seconds subtracted
 *
 * @example
 * // Subtract the following duration from 15 June 2017 15:29:20
 * const result = sub(new Date(2017, 5, 15, 15, 29, 20), {
 *   years: 2,
 *   months: 9,
 *   weeks: 1,
 *   days: 7,
 *   hours: 5,
 *   minutes: 9,
 *   seconds: 30
 * })
 * //=> Mon Sep 1 2014 10:19:50
 */ function $ebf0e3bb5008108a$var$sub(date, duration) {
    const { years: years = 0, months: months = 0, weeks: weeks = 0, days: days = 0, hours: hours = 0, minutes: minutes = 0, seconds: seconds = 0 } = duration;
    // Subtract years and months
    const dateWithoutMonths = (0, $4hV23.subMonths)(date, months + years * 12);
    // Subtract weeks and days
    const dateWithoutDays = (0, $lbcdn.subDays)(dateWithoutMonths, days + weeks * 7);
    // Subtract hours, minutes and seconds
    const minutestoSub = minutes + hours * 60;
    const secondstoSub = seconds + minutestoSub * 60;
    const mstoSub = secondstoSub * 1000;
    const finalDate = (0, $02yAu.constructFrom)(date, dateWithoutDays.getTime() - mstoSub);
    return finalDate;
}

});
parcelRegister("4hV23", function(module, exports) {

$parcel$export(module.exports, "subMonths", function () { return $31f4fd599c974ef7$export$73d1c15a21f9fae5; }, function (v) { return $31f4fd599c974ef7$export$73d1c15a21f9fae5 = v; });
var $31f4fd599c974ef7$export$73d1c15a21f9fae5;
"use strict";
$31f4fd599c974ef7$export$73d1c15a21f9fae5 = $31f4fd599c974ef7$var$subMonths;

var $fIUbm = parcelRequire("fIUbm");
/**
 * @name subMonths
 * @category Month Helpers
 * @summary Subtract the specified number of months from the given date.
 *
 * @description
 * Subtract the specified number of months from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of months to be subtracted.
 *
 * @returns The new date with the months subtracted
 *
 * @example
 * // Subtract 5 months from 1 February 2015:
 * const result = subMonths(new Date(2015, 1, 1), 5)
 * //=> Mon Sep 01 2014 00:00:00
 */ function $31f4fd599c974ef7$var$subMonths(date, amount) {
    return (0, $fIUbm.addMonths)(date, -amount);
}

});


parcelRegister("1zlEH", function(module, exports) {

$parcel$export(module.exports, "subBusinessDays", function () { return $1249dba081891c88$export$e5cc51ae28664a93; }, function (v) { return $1249dba081891c88$export$e5cc51ae28664a93 = v; });
var $1249dba081891c88$export$e5cc51ae28664a93;
"use strict";
$1249dba081891c88$export$e5cc51ae28664a93 = $1249dba081891c88$var$subBusinessDays;

var $pg1qm = parcelRequire("pg1qm");
/**
 * @name subBusinessDays
 * @category Day Helpers
 * @summary Substract the specified number of business days (mon - fri) to the given date.
 *
 * @description
 * Substract the specified number of business days (mon - fri) to the given date, ignoring weekends.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of business days to be subtracted.
 *
 * @returns The new date with the business days subtracted
 *
 * @example
 * // Substract 10 business days from 1 September 2014:
 * const result = subBusinessDays(new Date(2014, 8, 1), 10)
 * //=> Mon Aug 18 2014 00:00:00 (skipped weekend days)
 */ function $1249dba081891c88$var$subBusinessDays(date, amount) {
    return (0, $pg1qm.addBusinessDays)(date, -amount);
}

});

parcelRegister("isPKD", function(module, exports) {

$parcel$export(module.exports, "subHours", function () { return $d712fc34ceaa321e$export$5e9fa51cd5bb1e71; }, function (v) { return $d712fc34ceaa321e$export$5e9fa51cd5bb1e71 = v; });
var $d712fc34ceaa321e$export$5e9fa51cd5bb1e71;
"use strict";
$d712fc34ceaa321e$export$5e9fa51cd5bb1e71 = $d712fc34ceaa321e$var$subHours;

var $ghcs4 = parcelRequire("ghcs4");
/**
 * @name subHours
 * @category Hour Helpers
 * @summary Subtract the specified number of hours from the given date.
 *
 * @description
 * Subtract the specified number of hours from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of hours to be subtracted.
 *
 * @returns The new date with the hours subtracted
 *
 * @example
 * // Subtract 2 hours from 11 July 2014 01:00:00:
 * const result = subHours(new Date(2014, 6, 11, 1, 0), 2)
 * //=> Thu Jul 10 2014 23:00:00
 */ function $d712fc34ceaa321e$var$subHours(date, amount) {
    return (0, $ghcs4.addHours)(date, -amount);
}

});

parcelRegister("4eDQi", function(module, exports) {

$parcel$export(module.exports, "subMilliseconds", function () { return $31576023a62ec8f9$export$5abaf57ab8e91640; }, function (v) { return $31576023a62ec8f9$export$5abaf57ab8e91640 = v; });
var $31576023a62ec8f9$export$5abaf57ab8e91640;
"use strict";
$31576023a62ec8f9$export$5abaf57ab8e91640 = $31576023a62ec8f9$var$subMilliseconds;

var $hveYv = parcelRequire("hveYv");
/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of milliseconds to be subtracted.
 *
 * @returns The new date with the milliseconds subtracted
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */ function $31576023a62ec8f9$var$subMilliseconds(date, amount) {
    return (0, $hveYv.addMilliseconds)(date, -amount);
}

});

parcelRegister("ffQEb", function(module, exports) {

$parcel$export(module.exports, "subMinutes", function () { return $b1b118584521e713$export$e12a970efb73fce5; }, function (v) { return $b1b118584521e713$export$e12a970efb73fce5 = v; });
var $b1b118584521e713$export$e12a970efb73fce5;
"use strict";
$b1b118584521e713$export$e12a970efb73fce5 = $b1b118584521e713$var$subMinutes;

var $84Jkb = parcelRequire("84Jkb");
/**
 * @name subMinutes
 * @category Minute Helpers
 * @summary Subtract the specified number of minutes from the given date.
 *
 * @description
 * Subtract the specified number of minutes from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of minutes to be subtracted.
 *
 * @returns The new date with the minutes subtracted
 *
 * @example
 * // Subtract 30 minutes from 10 July 2014 12:00:00:
 * const result = subMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 11:30:00
 */ function $b1b118584521e713$var$subMinutes(date, amount) {
    return (0, $84Jkb.addMinutes)(date, -amount);
}

});

parcelRegister("bz9Dw", function(module, exports) {

$parcel$export(module.exports, "subQuarters", function () { return $86ba70346de59650$export$a31bfeeeee80cce6; }, function (v) { return $86ba70346de59650$export$a31bfeeeee80cce6 = v; });
var $86ba70346de59650$export$a31bfeeeee80cce6;
"use strict";
$86ba70346de59650$export$a31bfeeeee80cce6 = $86ba70346de59650$var$subQuarters;

var $7IMv5 = parcelRequire("7IMv5");
/**
 * @name subQuarters
 * @category Quarter Helpers
 * @summary Subtract the specified number of year quarters from the given date.
 *
 * @description
 * Subtract the specified number of year quarters from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of quarters to be subtracted.
 *
 * @returns The new date with the quarters subtracted
 *
 * @example
 * // Subtract 3 quarters from 1 September 2014:
 * const result = subQuarters(new Date(2014, 8, 1), 3)
 * //=> Sun Dec 01 2013 00:00:00
 */ function $86ba70346de59650$var$subQuarters(date, amount) {
    return (0, $7IMv5.addQuarters)(date, -amount);
}

});

parcelRegister("iWQ9A", function(module, exports) {

$parcel$export(module.exports, "subSeconds", function () { return $dcb6196874416921$export$e95d8ad9981db689; }, function (v) { return $dcb6196874416921$export$e95d8ad9981db689 = v; });
var $dcb6196874416921$export$e95d8ad9981db689;
"use strict";
$dcb6196874416921$export$e95d8ad9981db689 = $dcb6196874416921$var$subSeconds;

var $3WSWZ = parcelRequire("3WSWZ");
/**
 * @name subSeconds
 * @category Second Helpers
 * @summary Subtract the specified number of seconds from the given date.
 *
 * @description
 * Subtract the specified number of seconds from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of seconds to be subtracted.
 *
 * @returns The new date with the seconds subtracted
 *
 * @example
 * // Subtract 30 seconds from 10 July 2014 12:45:00:
 * const result = subSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
 * //=> Thu Jul 10 2014 12:44:30
 */ function $dcb6196874416921$var$subSeconds(date, amount) {
    return (0, $3WSWZ.addSeconds)(date, -amount);
}

});

parcelRegister("9DOwY", function(module, exports) {

$parcel$export(module.exports, "subWeeks", function () { return $704ef3f3f643cf70$export$b4d8ae6376193efb; }, function (v) { return $704ef3f3f643cf70$export$b4d8ae6376193efb = v; });
var $704ef3f3f643cf70$export$b4d8ae6376193efb;
"use strict";
$704ef3f3f643cf70$export$b4d8ae6376193efb = $704ef3f3f643cf70$var$subWeeks;

var $iiBmk = parcelRequire("iiBmk");
/**
 * @name subWeeks
 * @category Week Helpers
 * @summary Subtract the specified number of weeks from the given date.
 *
 * @description
 * Subtract the specified number of weeks from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of weeks to be subtracted.
 *
 * @returns The new date with the weeks subtracted
 *
 * @example
 * // Subtract 4 weeks from 1 September 2014:
 * const result = subWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Aug 04 2014 00:00:00
 */ function $704ef3f3f643cf70$var$subWeeks(date, amount) {
    return (0, $iiBmk.addWeeks)(date, -amount);
}

});

parcelRegister("2qVDZ", function(module, exports) {

$parcel$export(module.exports, "subYears", function () { return $1c5ab95bf0e7b2a5$export$14867687ff6c92e2; }, function (v) { return $1c5ab95bf0e7b2a5$export$14867687ff6c92e2 = v; });
var $1c5ab95bf0e7b2a5$export$14867687ff6c92e2;
"use strict";
$1c5ab95bf0e7b2a5$export$14867687ff6c92e2 = $1c5ab95bf0e7b2a5$var$subYears;

var $joePE = parcelRequire("joePE");
/**
 * @name subYears
 * @category Year Helpers
 * @summary Subtract the specified number of years from the given date.
 *
 * @description
 * Subtract the specified number of years from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of years to be subtracted.
 *
 * @returns The new date with the years subtracted
 *
 * @example
 * // Subtract 5 years from 1 September 2014:
 * const result = subYears(new Date(2014, 8, 1), 5)
 * //=> Tue Sep 01 2009 00:00:00
 */ function $1c5ab95bf0e7b2a5$var$subYears(date, amount) {
    return (0, $joePE.addYears)(date, -amount);
}

});

parcelRegister("4Lv6S", function(module, exports) {

$parcel$export(module.exports, "weeksToDays", function () { return $3783aef7b38d2b11$export$b696b6eeb89501ad; }, function (v) { return $3783aef7b38d2b11$export$b696b6eeb89501ad = v; });
var $3783aef7b38d2b11$export$b696b6eeb89501ad;
"use strict";
$3783aef7b38d2b11$export$b696b6eeb89501ad = $3783aef7b38d2b11$var$weeksToDays;

var $7MMvH = parcelRequire("7MMvH");
/**
 * @name weeksToDays
 * @category Conversion Helpers
 * @summary Convert weeks to days.
 *
 * @description
 * Convert a number of weeks to a full number of days.
 *
 * @param weeks - The number of weeks to be converted
 *
 * @returns The number of weeks converted in days
 *
 * @example
 * // Convert 2 weeks into days
 * const result = weeksToDays(2)
 * //=> 14
 */ function $3783aef7b38d2b11$var$weeksToDays(weeks) {
    return Math.trunc(weeks * $7MMvH.daysInWeek);
}

});

parcelRegister("9hhu5", function(module, exports) {

$parcel$export(module.exports, "yearsToDays", function () { return $6c13439a3ddf9785$export$862cb7b6e45c3b17; }, function (v) { return $6c13439a3ddf9785$export$862cb7b6e45c3b17 = v; });
var $6c13439a3ddf9785$export$862cb7b6e45c3b17;
"use strict";
$6c13439a3ddf9785$export$862cb7b6e45c3b17 = $6c13439a3ddf9785$var$yearsToDays;

var $7MMvH = parcelRequire("7MMvH");
/**
 * @name yearsToDays
 * @category Conversion Helpers
 * @summary Convert years to days.
 *
 * @description
 * Convert a number of years to a full number of days.
 *
 * @param years - The number of years to be converted
 *
 * @returns The number of years converted in days
 *
 * @example
 * // Convert 2 years into days
 * const result = yearsToDays(2)
 * //=> 730
 */ function $6c13439a3ddf9785$var$yearsToDays(years) {
    return Math.trunc(years * $7MMvH.daysInYear);
}

});

parcelRegister("5GxCF", function(module, exports) {

$parcel$export(module.exports, "yearsToMonths", function () { return $423af4c733881174$export$894abb0747b9a00; }, function (v) { return $423af4c733881174$export$894abb0747b9a00 = v; });
var $423af4c733881174$export$894abb0747b9a00;
"use strict";
$423af4c733881174$export$894abb0747b9a00 = $423af4c733881174$var$yearsToMonths;

var $7MMvH = parcelRequire("7MMvH");
/**
 * @name yearsToMonths
 * @category Conversion Helpers
 * @summary Convert years to months.
 *
 * @description
 * Convert a number of years to a full number of months.
 *
 * @param years - The number of years to be converted
 *
 * @returns The number of years converted in months
 *
 * @example
 * // Convert 2 years into months
 * const result = yearsToMonths(2)
 * //=> 24
 */ function $423af4c733881174$var$yearsToMonths(years) {
    return Math.trunc(years * $7MMvH.monthsInYear);
}

});

parcelRegister("ebRmU", function(module, exports) {

$parcel$export(module.exports, "yearsToQuarters", function () { return $a54b7d9f1a0e8235$export$ab26576e5e7379d7; }, function (v) { return $a54b7d9f1a0e8235$export$ab26576e5e7379d7 = v; });
var $a54b7d9f1a0e8235$export$ab26576e5e7379d7;
"use strict";
$a54b7d9f1a0e8235$export$ab26576e5e7379d7 = $a54b7d9f1a0e8235$var$yearsToQuarters;

var $7MMvH = parcelRequire("7MMvH");
/**
 * @name yearsToQuarters
 * @category Conversion Helpers
 * @summary Convert years to quarters.
 *
 * @description
 * Convert a number of years to a full number of quarters.
 *
 * @param years - The number of years to be converted
 *
 * @returns The number of years converted in quarters
 *
 * @example
 * // Convert 2 years to quarters
 * const result = yearsToQuarters(2)
 * //=> 8
 */ function $a54b7d9f1a0e8235$var$yearsToQuarters(years) {
    return Math.trunc(years * $7MMvH.quartersInYear);
}

});


parcelRegister("cCao2", function(module, exports) {

$parcel$export(module.exports, "useMergeRefs", function () { return $92f1173bc75d6d9e$export$74665b213cb5c4cf; });
$parcel$export(module.exports, "FloatingList", function () { return $92f1173bc75d6d9e$export$ffe15b0e64951704; });
$parcel$export(module.exports, "useListItem", function () { return $92f1173bc75d6d9e$export$dcdc7ff5149f7d1a; });
$parcel$export(module.exports, "Composite", function () { return $92f1173bc75d6d9e$export$43586241d9db0c6d; });
$parcel$export(module.exports, "CompositeItem", function () { return $92f1173bc75d6d9e$export$ef1ef7a3a43ace8e; });
$parcel$export(module.exports, "useId", function () { return $92f1173bc75d6d9e$export$f680877a34711e37; });
$parcel$export(module.exports, "FloatingArrow", function () { return $92f1173bc75d6d9e$export$33511391554732bc; });
$parcel$export(module.exports, "useFloatingParentNodeId", function () { return $92f1173bc75d6d9e$export$165209eae06d3488; });
$parcel$export(module.exports, "useFloatingTree", function () { return $92f1173bc75d6d9e$export$db0c2a7c7a2a4f69; });
$parcel$export(module.exports, "useFloatingNodeId", function () { return $92f1173bc75d6d9e$export$9b136e0e758a42f4; });
$parcel$export(module.exports, "FloatingNode", function () { return $92f1173bc75d6d9e$export$ca00a83b5b253862; });
$parcel$export(module.exports, "FloatingTree", function () { return $92f1173bc75d6d9e$export$587b60129641c4c8; });
$parcel$export(module.exports, "useHover", function () { return $92f1173bc75d6d9e$export$ae780daf29e6d456; });
$parcel$export(module.exports, "useDelayGroupContext", function () { return $92f1173bc75d6d9e$export$e2411914b150383d; });
$parcel$export(module.exports, "FloatingDelayGroup", function () { return $92f1173bc75d6d9e$export$718279509ff1e241; });
$parcel$export(module.exports, "useDelayGroup", function () { return $92f1173bc75d6d9e$export$560fc8be89c8b4a8; });
$parcel$export(module.exports, "NextFloatingDelayGroup", function () { return $92f1173bc75d6d9e$export$e766ee16075bdf6b; });
$parcel$export(module.exports, "useNextDelayGroup", function () { return $92f1173bc75d6d9e$export$f86f270cee1e809c; });
$parcel$export(module.exports, "useFloatingPortalNode", function () { return $92f1173bc75d6d9e$export$ac107512f3c5cca6; });
$parcel$export(module.exports, "FloatingPortal", function () { return $92f1173bc75d6d9e$export$31fa5d718fa2ac09; });
$parcel$export(module.exports, "FloatingFocusManager", function () { return $92f1173bc75d6d9e$export$8aeee49171ded61a; });
$parcel$export(module.exports, "FloatingOverlay", function () { return $92f1173bc75d6d9e$export$a35954495955337b; });
$parcel$export(module.exports, "useClick", function () { return $92f1173bc75d6d9e$export$98524f11226063fc; });
$parcel$export(module.exports, "useClientPoint", function () { return $92f1173bc75d6d9e$export$7fe170a73a621816; });
$parcel$export(module.exports, "useDismiss", function () { return $92f1173bc75d6d9e$export$fcdf1ba5fafc089b; });
$parcel$export(module.exports, "useFloatingRootContext", function () { return $92f1173bc75d6d9e$export$1df81146f8ad8e4c; });
$parcel$export(module.exports, "useFloating", function () { return $92f1173bc75d6d9e$export$4e02a5c1d08bac65; });
$parcel$export(module.exports, "useFocus", function () { return $92f1173bc75d6d9e$export$f8168d8dd8fd66e6; });
$parcel$export(module.exports, "useInteractions", function () { return $92f1173bc75d6d9e$export$a519f7794e446ddd; });
$parcel$export(module.exports, "useListNavigation", function () { return $92f1173bc75d6d9e$export$b5d22cac4ad33f40; });
$parcel$export(module.exports, "useRole", function () { return $92f1173bc75d6d9e$export$f66572793fa256a1; });
$parcel$export(module.exports, "useTransitionStatus", function () { return $92f1173bc75d6d9e$export$b2ef21706733f7e5; });
$parcel$export(module.exports, "useTransitionStyles", function () { return $92f1173bc75d6d9e$export$769fba13884bc2f4; });
$parcel$export(module.exports, "useTypeahead", function () { return $92f1173bc75d6d9e$export$d8d674d50b73ba93; });
$parcel$export(module.exports, "inner", function () { return $92f1173bc75d6d9e$export$4ae363f1d88fb658; });
$parcel$export(module.exports, "useInnerOffset", function () { return $92f1173bc75d6d9e$export$3d74b0dda7cc82ff; });
$parcel$export(module.exports, "safePolygon", function () { return $92f1173bc75d6d9e$export$7484214ab62358d2; });
$parcel$export(module.exports, "arrow", function () { return (parcelRequire("dA4dV")).arrow; });
$parcel$export(module.exports, "autoPlacement", function () { return (parcelRequire("dA4dV")).autoPlacement; });
$parcel$export(module.exports, "autoUpdate", function () { return (parcelRequire("af8LA")).autoUpdate; });
$parcel$export(module.exports, "computePosition", function () { return (parcelRequire("af8LA")).computePosition; });
$parcel$export(module.exports, "detectOverflow", function () { return (parcelRequire("af8LA")).detectOverflow; });
$parcel$export(module.exports, "flip", function () { return (parcelRequire("dA4dV")).flip; });
$parcel$export(module.exports, "getOverflowAncestors", function () { return (parcelRequire("g7YZX")).getOverflowAncestors; });
$parcel$export(module.exports, "hide", function () { return (parcelRequire("dA4dV")).hide; });
$parcel$export(module.exports, "inline", function () { return (parcelRequire("dA4dV")).inline; });
$parcel$export(module.exports, "limitShift", function () { return (parcelRequire("dA4dV")).limitShift; });
$parcel$export(module.exports, "offset", function () { return (parcelRequire("dA4dV")).offset; });
$parcel$export(module.exports, "platform", function () { return (parcelRequire("af8LA")).platform; });
$parcel$export(module.exports, "shift", function () { return (parcelRequire("dA4dV")).shift; });
$parcel$export(module.exports, "size", function () { return (parcelRequire("dA4dV")).size; });

var $cQQee = parcelRequire("cQQee");

var $5BFeN = parcelRequire("5BFeN");

var $7Tw3V = parcelRequire("7Tw3V");

var $g7YZX = parcelRequire("g7YZX");

var $9DaiF = parcelRequire("9DaiF");

var $kC364 = parcelRequire("kC364");

var $dA4dV = parcelRequire("dA4dV");
var $af8LA = parcelRequire("af8LA");
var $af8LA = parcelRequire("af8LA");
var $g7YZX = parcelRequire("g7YZX");

var $g3pjJ = parcelRequire("g3pjJ");
/**
 * Merges an array of refs into a single memoized callback ref or `null`.
 * @see https://floating-ui.com/docs/react-utils#usemergerefs
 */ function $92f1173bc75d6d9e$export$74665b213cb5c4cf(refs) {
    const cleanupRef = $cQQee.useRef(undefined);
    const refEffect = $cQQee.useCallback((instance)=>{
        const cleanups = refs.map((ref)=>{
            if (ref == null) return;
            if (typeof ref === 'function') {
                const refCallback = ref;
                const refCleanup = refCallback(instance);
                return typeof refCleanup === 'function' ? refCleanup : ()=>{
                    refCallback(null);
                };
            }
            ref.current = instance;
            return ()=>{
                ref.current = null;
            };
        });
        return ()=>{
            cleanups.forEach((refCleanup)=>refCleanup == null ? void 0 : refCleanup());
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
    return $cQQee.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (value)=>{
            if (cleanupRef.current) {
                cleanupRef.current();
                cleanupRef.current = undefined;
            }
            if (value != null) cleanupRef.current = refEffect(value);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}
function $92f1173bc75d6d9e$var$sortByDocumentPosition(a, b) {
    const position = a.compareDocumentPosition(b);
    if (position & Node.DOCUMENT_POSITION_FOLLOWING || position & Node.DOCUMENT_POSITION_CONTAINED_BY) return -1;
    if (position & Node.DOCUMENT_POSITION_PRECEDING || position & Node.DOCUMENT_POSITION_CONTAINS) return 1;
    return 0;
}
const $92f1173bc75d6d9e$var$FloatingListContext = /*#__PURE__*/ $cQQee.createContext({
    register: ()=>{},
    unregister: ()=>{},
    map: /*#__PURE__*/ new Map(),
    elementsRef: {
        current: []
    }
});
/**
 * Provides context for a list of items within the floating element.
 * @see https://floating-ui.com/docs/FloatingList
 */ function $92f1173bc75d6d9e$export$ffe15b0e64951704(props) {
    const { children: children, elementsRef: elementsRef, labelsRef: labelsRef } = props;
    const [nodes, setNodes] = $cQQee.useState(()=>new Set());
    const register = $cQQee.useCallback((node)=>{
        setNodes((prevSet)=>new Set(prevSet).add(node));
    }, []);
    const unregister = $cQQee.useCallback((node)=>{
        setNodes((prevSet)=>{
            const set = new Set(prevSet);
            set.delete(node);
            return set;
        });
    }, []);
    const map = $cQQee.useMemo(()=>{
        const newMap = new Map();
        const sortedNodes = Array.from(nodes.keys()).sort($92f1173bc75d6d9e$var$sortByDocumentPosition);
        sortedNodes.forEach((node, index)=>{
            newMap.set(node, index);
        });
        return newMap;
    }, [
        nodes
    ]);
    return /*#__PURE__*/ (0, $7Tw3V.jsx)($92f1173bc75d6d9e$var$FloatingListContext.Provider, {
        value: $cQQee.useMemo(()=>({
                register: register,
                unregister: unregister,
                map: map,
                elementsRef: elementsRef,
                labelsRef: labelsRef
            }), [
            register,
            unregister,
            map,
            elementsRef,
            labelsRef
        ]),
        children: children
    });
}
/**
 * Used to register a list item and its index (DOM position) in the
 * `FloatingList`.
 * @see https://floating-ui.com/docs/FloatingList#uselistitem
 */ function $92f1173bc75d6d9e$export$dcdc7ff5149f7d1a(props) {
    if (props === void 0) props = {};
    const { label: label } = props;
    const { register: register, unregister: unregister, map: map, elementsRef: elementsRef, labelsRef: labelsRef } = $cQQee.useContext($92f1173bc75d6d9e$var$FloatingListContext);
    const [index, setIndex] = $cQQee.useState(null);
    const componentRef = $cQQee.useRef(null);
    const ref = $cQQee.useCallback((node)=>{
        componentRef.current = node;
        if (index !== null) {
            elementsRef.current[index] = node;
            if (labelsRef) {
                var _node$textContent;
                const isLabelDefined = label !== undefined;
                labelsRef.current[index] = isLabelDefined ? label : (_node$textContent = node == null ? void 0 : node.textContent) != null ? _node$textContent : null;
            }
        }
    }, [
        index,
        elementsRef,
        labelsRef,
        label
    ]);
    (0, $5BFeN.useModernLayoutEffect)(()=>{
        const node = componentRef.current;
        if (node) {
            register(node);
            return ()=>{
                unregister(node);
            };
        }
    }, [
        register,
        unregister
    ]);
    (0, $5BFeN.useModernLayoutEffect)(()=>{
        const index = componentRef.current ? map.get(componentRef.current) : null;
        if (index != null) setIndex(index);
    }, [
        map
    ]);
    return $cQQee.useMemo(()=>({
            ref: ref,
            index: index == null ? -1 : index
        }), [
        index,
        ref
    ]);
}
const $92f1173bc75d6d9e$var$FOCUSABLE_ATTRIBUTE = 'data-floating-ui-focusable';
const $92f1173bc75d6d9e$var$ACTIVE_KEY = 'active';
const $92f1173bc75d6d9e$var$SELECTED_KEY = 'selected';
const $92f1173bc75d6d9e$var$ARROW_LEFT = 'ArrowLeft';
const $92f1173bc75d6d9e$var$ARROW_RIGHT = 'ArrowRight';
const $92f1173bc75d6d9e$var$ARROW_UP = 'ArrowUp';
const $92f1173bc75d6d9e$var$ARROW_DOWN = 'ArrowDown';
function $92f1173bc75d6d9e$var$renderJsx(render, computedProps) {
    if (typeof render === 'function') return render(computedProps);
    if (render) return /*#__PURE__*/ $cQQee.cloneElement(render, computedProps);
    return /*#__PURE__*/ (0, $7Tw3V.jsx)("div", {
        ...computedProps
    });
}
const $92f1173bc75d6d9e$var$CompositeContext = /*#__PURE__*/ $cQQee.createContext({
    activeIndex: 0,
    onNavigate: ()=>{}
});
const $92f1173bc75d6d9e$var$horizontalKeys = [
    $92f1173bc75d6d9e$var$ARROW_LEFT,
    $92f1173bc75d6d9e$var$ARROW_RIGHT
];
const $92f1173bc75d6d9e$var$verticalKeys = [
    $92f1173bc75d6d9e$var$ARROW_UP,
    $92f1173bc75d6d9e$var$ARROW_DOWN
];
const $92f1173bc75d6d9e$var$allKeys = [
    ...$92f1173bc75d6d9e$var$horizontalKeys,
    ...$92f1173bc75d6d9e$var$verticalKeys
];
/**
 * Creates a single tab stop whose items are navigated by arrow keys, which
 * provides list navigation outside of floating element contexts.
 *
 * This is useful to enable navigation of a list of items that aren’t part of a
 * floating element. A menubar is an example of a composite, with each reference
 * element being an item.
 * @see https://floating-ui.com/docs/Composite
 */ const $92f1173bc75d6d9e$export$43586241d9db0c6d = /*#__PURE__*/ $cQQee.forwardRef(function Composite(props, forwardedRef) {
    const { render: render, orientation: orientation = 'both', loop: loop = true, rtl: rtl = false, cols: cols = 1, disabledIndices: disabledIndices, activeIndex: externalActiveIndex, onNavigate: externalSetActiveIndex, itemSizes: itemSizes, dense: dense = false, ...domProps } = props;
    const [internalActiveIndex, internalSetActiveIndex] = $cQQee.useState(0);
    const activeIndex = externalActiveIndex != null ? externalActiveIndex : internalActiveIndex;
    const onNavigate = (0, $5BFeN.useEffectEvent)(externalSetActiveIndex != null ? externalSetActiveIndex : internalSetActiveIndex);
    const elementsRef = $cQQee.useRef([]);
    const renderElementProps = render && typeof render !== 'function' ? render.props : {};
    const contextValue = $cQQee.useMemo(()=>({
            activeIndex: activeIndex,
            onNavigate: onNavigate
        }), [
        activeIndex,
        onNavigate
    ]);
    const isGrid = cols > 1;
    function handleKeyDown(event) {
        if (!$92f1173bc75d6d9e$var$allKeys.includes(event.key)) return;
        let nextIndex = activeIndex;
        const minIndex = (0, $5BFeN.getMinListIndex)(elementsRef, disabledIndices);
        const maxIndex = (0, $5BFeN.getMaxListIndex)(elementsRef, disabledIndices);
        const horizontalEndKey = rtl ? $92f1173bc75d6d9e$var$ARROW_LEFT : $92f1173bc75d6d9e$var$ARROW_RIGHT;
        const horizontalStartKey = rtl ? $92f1173bc75d6d9e$var$ARROW_RIGHT : $92f1173bc75d6d9e$var$ARROW_LEFT;
        if (isGrid) {
            const sizes = itemSizes || Array.from({
                length: elementsRef.current.length
            }, ()=>({
                    width: 1,
                    height: 1
                }));
            // To calculate movements on the grid, we use hypothetical cell indices
            // as if every item was 1x1, then convert back to real indices.
            const cellMap = (0, $5BFeN.createGridCellMap)(sizes, cols, dense);
            const minGridIndex = cellMap.findIndex((index)=>index != null && !(0, $5BFeN.isListIndexDisabled)(elementsRef, index, disabledIndices));
            // last enabled index
            const maxGridIndex = cellMap.reduce((foundIndex, index, cellIndex)=>index != null && !(0, $5BFeN.isListIndexDisabled)(elementsRef, index, disabledIndices) ? cellIndex : foundIndex, -1);
            const maybeNextIndex = cellMap[(0, $5BFeN.getGridNavigatedIndex)({
                current: cellMap.map((itemIndex)=>itemIndex ? elementsRef.current[itemIndex] : null)
            }, {
                event: event,
                orientation: orientation,
                loop: loop,
                rtl: rtl,
                cols: cols,
                // treat undefined (empty grid spaces) as disabled indices so we
                // don't end up in them
                disabledIndices: (0, $5BFeN.getGridCellIndices)([
                    ...(typeof disabledIndices !== 'function' ? disabledIndices : null) || elementsRef.current.map((_, index)=>(0, $5BFeN.isListIndexDisabled)(elementsRef, index, disabledIndices) ? index : undefined),
                    undefined
                ], cellMap),
                minIndex: minGridIndex,
                maxIndex: maxGridIndex,
                prevIndex: (0, $5BFeN.getGridCellIndexOfCorner)(activeIndex > maxIndex ? minIndex : activeIndex, sizes, cellMap, cols, // use a corner matching the edge closest to the direction we're
                // moving in so we don't end up in the same item. Prefer
                // top/left over bottom/right.
                event.key === $92f1173bc75d6d9e$var$ARROW_DOWN ? 'bl' : event.key === horizontalEndKey ? 'tr' : 'tl')
            })];
            if (maybeNextIndex != null) nextIndex = maybeNextIndex;
        }
        const toEndKeys = {
            horizontal: [
                horizontalEndKey
            ],
            vertical: [
                $92f1173bc75d6d9e$var$ARROW_DOWN
            ],
            both: [
                horizontalEndKey,
                $92f1173bc75d6d9e$var$ARROW_DOWN
            ]
        }[orientation];
        const toStartKeys = {
            horizontal: [
                horizontalStartKey
            ],
            vertical: [
                $92f1173bc75d6d9e$var$ARROW_UP
            ],
            both: [
                horizontalStartKey,
                $92f1173bc75d6d9e$var$ARROW_UP
            ]
        }[orientation];
        const preventedKeys = isGrid ? $92f1173bc75d6d9e$var$allKeys : ({
            horizontal: $92f1173bc75d6d9e$var$horizontalKeys,
            vertical: $92f1173bc75d6d9e$var$verticalKeys,
            both: $92f1173bc75d6d9e$var$allKeys
        })[orientation];
        if (nextIndex === activeIndex && [
            ...toEndKeys,
            ...toStartKeys
        ].includes(event.key)) {
            if (loop && nextIndex === maxIndex && toEndKeys.includes(event.key)) nextIndex = minIndex;
            else if (loop && nextIndex === minIndex && toStartKeys.includes(event.key)) nextIndex = maxIndex;
            else nextIndex = (0, $5BFeN.findNonDisabledListIndex)(elementsRef, {
                startingIndex: nextIndex,
                decrement: toStartKeys.includes(event.key),
                disabledIndices: disabledIndices
            });
        }
        if (nextIndex !== activeIndex && !(0, $5BFeN.isIndexOutOfListBounds)(elementsRef, nextIndex)) {
            var _elementsRef$current$;
            event.stopPropagation();
            if (preventedKeys.includes(event.key)) event.preventDefault();
            onNavigate(nextIndex);
            (_elementsRef$current$ = elementsRef.current[nextIndex]) == null || _elementsRef$current$.focus();
        }
    }
    const computedProps = {
        ...domProps,
        ...renderElementProps,
        ref: forwardedRef,
        'aria-orientation': orientation === 'both' ? undefined : orientation,
        onKeyDown (e) {
            domProps.onKeyDown == null || domProps.onKeyDown(e);
            renderElementProps.onKeyDown == null || renderElementProps.onKeyDown(e);
            handleKeyDown(e);
        }
    };
    return /*#__PURE__*/ (0, $7Tw3V.jsx)($92f1173bc75d6d9e$var$CompositeContext.Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $7Tw3V.jsx)($92f1173bc75d6d9e$export$ffe15b0e64951704, {
            elementsRef: elementsRef,
            children: $92f1173bc75d6d9e$var$renderJsx(render, computedProps)
        })
    });
});
/**
 * @see https://floating-ui.com/docs/Composite
 */ const $92f1173bc75d6d9e$export$ef1ef7a3a43ace8e = /*#__PURE__*/ $cQQee.forwardRef(function CompositeItem(props, forwardedRef) {
    const { render: render, ...domProps } = props;
    const renderElementProps = render && typeof render !== 'function' ? render.props : {};
    const { activeIndex: activeIndex, onNavigate: onNavigate } = $cQQee.useContext($92f1173bc75d6d9e$var$CompositeContext);
    const { ref: ref, index: index } = $92f1173bc75d6d9e$export$dcdc7ff5149f7d1a();
    const mergedRef = $92f1173bc75d6d9e$export$74665b213cb5c4cf([
        ref,
        forwardedRef,
        renderElementProps.ref
    ]);
    const isActive = activeIndex === index;
    const computedProps = {
        ...domProps,
        ...renderElementProps,
        ref: mergedRef,
        tabIndex: isActive ? 0 : -1,
        'data-active': isActive ? '' : undefined,
        onFocus (e) {
            domProps.onFocus == null || domProps.onFocus(e);
            renderElementProps.onFocus == null || renderElementProps.onFocus(e);
            onNavigate(index);
        }
    };
    return $92f1173bc75d6d9e$var$renderJsx(render, computedProps);
});
// https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379
const $92f1173bc75d6d9e$var$SafeReact = {
    ...$cQQee
};
let $92f1173bc75d6d9e$var$serverHandoffComplete = false;
let $92f1173bc75d6d9e$var$count = 0;
const $92f1173bc75d6d9e$var$genId = ()=>// on <React 18
    "floating-ui-" + Math.random().toString(36).slice(2, 6) + $92f1173bc75d6d9e$var$count++;
function $92f1173bc75d6d9e$var$useFloatingId() {
    const [id, setId] = $cQQee.useState(()=>$92f1173bc75d6d9e$var$serverHandoffComplete ? $92f1173bc75d6d9e$var$genId() : undefined);
    (0, $5BFeN.useModernLayoutEffect)(()=>{
        if (id == null) setId($92f1173bc75d6d9e$var$genId());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $cQQee.useEffect(()=>{
        $92f1173bc75d6d9e$var$serverHandoffComplete = true;
    }, []);
    return id;
}
const $92f1173bc75d6d9e$var$useReactId = $92f1173bc75d6d9e$var$SafeReact.useId;
/**
 * Uses React 18's built-in `useId()` when available, or falls back to a
 * slightly less performant (requiring a double render) implementation for
 * earlier React versions.
 * @see https://floating-ui.com/docs/react-utils#useid
 */ const $92f1173bc75d6d9e$export$f680877a34711e37 = $92f1173bc75d6d9e$var$useReactId || $92f1173bc75d6d9e$var$useFloatingId;
let $92f1173bc75d6d9e$var$devMessageSet;
function $92f1173bc75d6d9e$var$warn() {
    var _devMessageSet;
    for(var _len = arguments.length, messages = new Array(_len), _key = 0; _key < _len; _key++)messages[_key] = arguments[_key];
    const message = "Floating UI: " + messages.join(' ');
    if (!((_devMessageSet = $92f1173bc75d6d9e$var$devMessageSet) != null && _devMessageSet.has(message))) {
        var _devMessageSet2;
        (_devMessageSet2 = $92f1173bc75d6d9e$var$devMessageSet) == null || _devMessageSet2.add(message);
        console.warn(message);
    }
}
function $92f1173bc75d6d9e$var$error() {
    var _devMessageSet3;
    for(var _len2 = arguments.length, messages = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)messages[_key2] = arguments[_key2];
    const message = "Floating UI: " + messages.join(' ');
    if (!((_devMessageSet3 = $92f1173bc75d6d9e$var$devMessageSet) != null && _devMessageSet3.has(message))) {
        var _devMessageSet4;
        (_devMessageSet4 = $92f1173bc75d6d9e$var$devMessageSet) == null || _devMessageSet4.add(message);
        console.error(message);
    }
}
/**
 * Renders a pointing arrow triangle.
 * @see https://floating-ui.com/docs/FloatingArrow
 */ const $92f1173bc75d6d9e$export$33511391554732bc = /*#__PURE__*/ $cQQee.forwardRef(function FloatingArrow(props, ref) {
    const { context: { placement: placement, elements: { floating: floating }, middlewareData: { arrow: arrow, shift: shift } }, width: width = 14, height: height = 7, tipRadius: tipRadius = 0, strokeWidth: strokeWidth = 0, staticOffset: staticOffset, stroke: stroke, d: d, style: { transform: transform, ...restStyle } = {}, ...rest } = props;
    const clipPathId = $92f1173bc75d6d9e$export$f680877a34711e37();
    const [isRTL, setIsRTL] = $cQQee.useState(false);
    // https://github.com/floating-ui/floating-ui/issues/2932
    (0, $5BFeN.useModernLayoutEffect)(()=>{
        if (!floating) return;
        const isRTL = (0, $g7YZX.getComputedStyle)(floating).direction === 'rtl';
        if (isRTL) setIsRTL(true);
    }, [
        floating
    ]);
    if (!floating) return null;
    const [side, alignment] = placement.split('-');
    const isVerticalSide = side === 'top' || side === 'bottom';
    let computedStaticOffset = staticOffset;
    if (isVerticalSide && shift != null && shift.x || !isVerticalSide && shift != null && shift.y) computedStaticOffset = null;
    // Strokes must be double the border width, this ensures the stroke's width
    // works as you'd expect.
    const computedStrokeWidth = strokeWidth * 2;
    const halfStrokeWidth = computedStrokeWidth / 2;
    const svgX = width / 2 * (tipRadius / -8 + 1);
    const svgY = height / 2 * tipRadius / 4;
    const isCustomShape = !!d;
    const yOffsetProp = computedStaticOffset && alignment === 'end' ? 'bottom' : 'top';
    let xOffsetProp = computedStaticOffset && alignment === 'end' ? 'right' : 'left';
    if (computedStaticOffset && isRTL) xOffsetProp = alignment === 'end' ? 'left' : 'right';
    const arrowX = (arrow == null ? void 0 : arrow.x) != null ? computedStaticOffset || arrow.x : '';
    const arrowY = (arrow == null ? void 0 : arrow.y) != null ? computedStaticOffset || arrow.y : '';
    const dValue = d || 'M0,0' + (" H" + width) + (" L" + (width - svgX) + "," + (height - svgY)) + (" Q" + width / 2 + "," + height + " " + svgX + "," + (height - svgY)) + ' Z';
    const rotation = {
        top: isCustomShape ? 'rotate(180deg)' : '',
        left: isCustomShape ? 'rotate(90deg)' : 'rotate(-90deg)',
        bottom: isCustomShape ? '' : 'rotate(180deg)',
        right: isCustomShape ? 'rotate(-90deg)' : 'rotate(90deg)'
    }[side];
    return /*#__PURE__*/ (0, $7Tw3V.jsxs)("svg", {
        ...rest,
        "aria-hidden": true,
        ref: ref,
        width: isCustomShape ? width : width + computedStrokeWidth,
        height: width,
        viewBox: "0 0 " + width + " " + (height > width ? height : width),
        style: {
            position: 'absolute',
            pointerEvents: 'none',
            [xOffsetProp]: arrowX,
            [yOffsetProp]: arrowY,
            [side]: isVerticalSide || isCustomShape ? '100%' : "calc(100% - " + computedStrokeWidth / 2 + "px)",
            transform: [
                rotation,
                transform
            ].filter((t)=>!!t).join(' '),
            ...restStyle
        },
        children: [
            computedStrokeWidth > 0 && /*#__PURE__*/ (0, $7Tw3V.jsx)("path", {
                clipPath: "url(#" + clipPathId + ")",
                fill: "none",
                stroke: stroke,
                strokeWidth: computedStrokeWidth + (d ? 0 : 1),
                d: dValue
            }),
            /*#__PURE__*/ (0, $7Tw3V.jsx)("path", {
                stroke: computedStrokeWidth && !d ? rest.fill : 'none',
                d: dValue
            }),
            /*#__PURE__*/ (0, $7Tw3V.jsx)("clipPath", {
                id: clipPathId,
                children: /*#__PURE__*/ (0, $7Tw3V.jsx)("rect", {
                    x: -halfStrokeWidth,
                    y: halfStrokeWidth * (isCustomShape ? -1 : 1),
                    width: width + computedStrokeWidth,
                    height: width
                })
            })
        ]
    });
});
function $92f1173bc75d6d9e$var$createEventEmitter() {
    const map = new Map();
    return {
        emit (event, data) {
            var _map$get;
            (_map$get = map.get(event)) == null || _map$get.forEach((listener)=>listener(data));
        },
        on (event, listener) {
            if (!map.has(event)) map.set(event, new Set());
            map.get(event).add(listener);
        },
        off (event, listener) {
            var _map$get2;
            (_map$get2 = map.get(event)) == null || _map$get2.delete(listener);
        }
    };
}
const $92f1173bc75d6d9e$var$FloatingNodeContext = /*#__PURE__*/ $cQQee.createContext(null);
const $92f1173bc75d6d9e$var$FloatingTreeContext = /*#__PURE__*/ $cQQee.createContext(null);
/**
 * Returns the parent node id for nested floating elements, if available.
 * Returns `null` for top-level floating elements.
 */ const $92f1173bc75d6d9e$export$165209eae06d3488 = ()=>{
    var _React$useContext;
    return ((_React$useContext = $cQQee.useContext($92f1173bc75d6d9e$var$FloatingNodeContext)) == null ? void 0 : _React$useContext.id) || null;
};
/**
 * Returns the nearest floating tree context, if available.
 */ const $92f1173bc75d6d9e$export$db0c2a7c7a2a4f69 = ()=>$cQQee.useContext($92f1173bc75d6d9e$var$FloatingTreeContext);
/**
 * Registers a node into the `FloatingTree`, returning its id.
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $92f1173bc75d6d9e$export$9b136e0e758a42f4(customParentId) {
    const id = $92f1173bc75d6d9e$export$f680877a34711e37();
    const tree = $92f1173bc75d6d9e$export$db0c2a7c7a2a4f69();
    const reactParentId = $92f1173bc75d6d9e$export$165209eae06d3488();
    const parentId = customParentId || reactParentId;
    (0, $5BFeN.useModernLayoutEffect)(()=>{
        if (!id) return;
        const node = {
            id: id,
            parentId: parentId
        };
        tree == null || tree.addNode(node);
        return ()=>{
            tree == null || tree.removeNode(node);
        };
    }, [
        tree,
        id,
        parentId
    ]);
    return id;
}
/**
 * Provides parent node context for nested floating elements.
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $92f1173bc75d6d9e$export$ca00a83b5b253862(props) {
    const { children: children, id: id } = props;
    const parentId = $92f1173bc75d6d9e$export$165209eae06d3488();
    return /*#__PURE__*/ (0, $7Tw3V.jsx)($92f1173bc75d6d9e$var$FloatingNodeContext.Provider, {
        value: $cQQee.useMemo(()=>({
                id: id,
                parentId: parentId
            }), [
            id,
            parentId
        ]),
        children: children
    });
}
/**
 * Provides context for nested floating elements when they are not children of
 * each other on the DOM.
 * This is not necessary in all cases, except when there must be explicit communication between parent and child floating elements. It is necessary for:
 * - The `bubbles` option in the `useDismiss()` Hook
 * - Nested virtual list navigation
 * - Nested floating elements that each open on hover
 * - Custom communication between parent and child floating elements
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $92f1173bc75d6d9e$export$587b60129641c4c8(props) {
    const { children: children } = props;
    const nodesRef = $cQQee.useRef([]);
    const addNode = $cQQee.useCallback((node)=>{
        nodesRef.current = [
            ...nodesRef.current,
            node
        ];
    }, []);
    const removeNode = $cQQee.useCallback((node)=>{
        nodesRef.current = nodesRef.current.filter((n)=>n !== node);
    }, []);
    const [events] = $cQQee.useState(()=>$92f1173bc75d6d9e$var$createEventEmitter());
    return /*#__PURE__*/ (0, $7Tw3V.jsx)($92f1173bc75d6d9e$var$FloatingTreeContext.Provider, {
        value: $cQQee.useMemo(()=>({
                nodesRef: nodesRef,
                addNode: addNode,
                removeNode: removeNode,
                events: events
            }), [
            addNode,
            removeNode,
            events
        ]),
        children: children
    });
}
function $92f1173bc75d6d9e$var$createAttribute(name) {
    return "data-floating-ui-" + name;
}
function $92f1173bc75d6d9e$var$clearTimeoutIfSet(timeoutRef) {
    if (timeoutRef.current !== -1) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = -1;
    }
}
const $92f1173bc75d6d9e$var$safePolygonIdentifier = /*#__PURE__*/ $92f1173bc75d6d9e$var$createAttribute('safe-polygon');
function $92f1173bc75d6d9e$var$getDelay(value, prop, pointerType) {
    if (pointerType && !(0, $5BFeN.isMouseLikePointerType)(pointerType)) return 0;
    if (typeof value === 'number') return value;
    if (typeof value === 'function') {
        const result = value();
        if (typeof result === 'number') return result;
        return result == null ? void 0 : result[prop];
    }
    return value == null ? void 0 : value[prop];
}
function $92f1173bc75d6d9e$var$getRestMs(value) {
    if (typeof value === 'function') return value();
    return value;
}
/**
 * Opens the floating element while hovering over the reference element, like
 * CSS `:hover`.
 * @see https://floating-ui.com/docs/useHover
 */ function $92f1173bc75d6d9e$export$ae780daf29e6d456(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, dataRef: dataRef, events: events, elements: elements } = context;
    const { enabled: enabled = true, delay: delay = 0, handleClose: handleClose = null, mouseOnly: mouseOnly = false, restMs: restMs = 0, move: move = true } = props;
    const tree = $92f1173bc75d6d9e$export$db0c2a7c7a2a4f69();
    const parentId = $92f1173bc75d6d9e$export$165209eae06d3488();
    const handleCloseRef = (0, $5BFeN.useLatestRef)(handleClose);
    const delayRef = (0, $5BFeN.useLatestRef)(delay);
    const openRef = (0, $5BFeN.useLatestRef)(open);
    const restMsRef = (0, $5BFeN.useLatestRef)(restMs);
    const pointerTypeRef = $cQQee.useRef();
    const timeoutRef = $cQQee.useRef(-1);
    const handlerRef = $cQQee.useRef();
    const restTimeoutRef = $cQQee.useRef(-1);
    const blockMouseMoveRef = $cQQee.useRef(true);
    const performedPointerEventsMutationRef = $cQQee.useRef(false);
    const unbindMouseMoveRef = $cQQee.useRef(()=>{});
    const restTimeoutPendingRef = $cQQee.useRef(false);
    const isHoverOpen = (0, $5BFeN.useEffectEvent)(()=>{
        var _dataRef$current$open;
        const type = (_dataRef$current$open = dataRef.current.openEvent) == null ? void 0 : _dataRef$current$open.type;
        return (type == null ? void 0 : type.includes('mouse')) && type !== 'mousedown';
    });
    // When closing before opening, clear the delay timeouts to cancel it
    // from showing.
    $cQQee.useEffect(()=>{
        if (!enabled) return;
        function onOpenChange(_ref) {
            let { open: open } = _ref;
            if (!open) {
                $92f1173bc75d6d9e$var$clearTimeoutIfSet(timeoutRef);
                $92f1173bc75d6d9e$var$clearTimeoutIfSet(restTimeoutRef);
                blockMouseMoveRef.current = true;
                restTimeoutPendingRef.current = false;
            }
        }
        events.on('openchange', onOpenChange);
        return ()=>{
            events.off('openchange', onOpenChange);
        };
    }, [
        enabled,
        events
    ]);
    $cQQee.useEffect(()=>{
        if (!enabled) return;
        if (!handleCloseRef.current) return;
        if (!open) return;
        function onLeave(event) {
            if (isHoverOpen()) onOpenChange(false, event, 'hover');
        }
        const html = (0, $5BFeN.getDocument)(elements.floating).documentElement;
        html.addEventListener('mouseleave', onLeave);
        return ()=>{
            html.removeEventListener('mouseleave', onLeave);
        };
    }, [
        elements.floating,
        open,
        onOpenChange,
        enabled,
        handleCloseRef,
        isHoverOpen
    ]);
    const closeWithDelay = $cQQee.useCallback(function(event, runElseBranch, reason) {
        if (runElseBranch === void 0) runElseBranch = true;
        if (reason === void 0) reason = 'hover';
        const closeDelay = $92f1173bc75d6d9e$var$getDelay(delayRef.current, 'close', pointerTypeRef.current);
        if (closeDelay && !handlerRef.current) {
            $92f1173bc75d6d9e$var$clearTimeoutIfSet(timeoutRef);
            timeoutRef.current = window.setTimeout(()=>onOpenChange(false, event, reason), closeDelay);
        } else if (runElseBranch) {
            $92f1173bc75d6d9e$var$clearTimeoutIfSet(timeoutRef);
            onOpenChange(false, event, reason);
        }
    }, [
        delayRef,
        onOpenChange
    ]);
    const cleanupMouseMoveHandler = (0, $5BFeN.useEffectEvent)(()=>{
        unbindMouseMoveRef.current();
        handlerRef.current = undefined;
    });
    const clearPointerEvents = (0, $5BFeN.useEffectEvent)(()=>{
        if (performedPointerEventsMutationRef.current) {
            const body = (0, $5BFeN.getDocument)(elements.floating).body;
            body.style.pointerEvents = '';
            body.removeAttribute($92f1173bc75d6d9e$var$safePolygonIdentifier);
            performedPointerEventsMutationRef.current = false;
        }
    });
    const isClickLikeOpenEvent = (0, $5BFeN.useEffectEvent)(()=>{
        return dataRef.current.openEvent ? [
            'click',
            'mousedown'
        ].includes(dataRef.current.openEvent.type) : false;
    });
    // Registering the mouse events on the reference directly to bypass React's
    // delegation system. If the cursor was on a disabled element and then entered
    // the reference (no gap), `mouseenter` doesn't fire in the delegation system.
    $cQQee.useEffect(()=>{
        if (!enabled) return;
        function onReferenceMouseEnter(event) {
            $92f1173bc75d6d9e$var$clearTimeoutIfSet(timeoutRef);
            blockMouseMoveRef.current = false;
            if (mouseOnly && !(0, $5BFeN.isMouseLikePointerType)(pointerTypeRef.current) || $92f1173bc75d6d9e$var$getRestMs(restMsRef.current) > 0 && !$92f1173bc75d6d9e$var$getDelay(delayRef.current, 'open')) return;
            const openDelay = $92f1173bc75d6d9e$var$getDelay(delayRef.current, 'open', pointerTypeRef.current);
            if (openDelay) timeoutRef.current = window.setTimeout(()=>{
                if (!openRef.current) onOpenChange(true, event, 'hover');
            }, openDelay);
            else if (!open) onOpenChange(true, event, 'hover');
        }
        function onReferenceMouseLeave(event) {
            if (isClickLikeOpenEvent()) {
                clearPointerEvents();
                return;
            }
            unbindMouseMoveRef.current();
            const doc = (0, $5BFeN.getDocument)(elements.floating);
            $92f1173bc75d6d9e$var$clearTimeoutIfSet(restTimeoutRef);
            restTimeoutPendingRef.current = false;
            if (handleCloseRef.current && dataRef.current.floatingContext) {
                // Prevent clearing `onScrollMouseLeave` timeout.
                if (!open) $92f1173bc75d6d9e$var$clearTimeoutIfSet(timeoutRef);
                handlerRef.current = handleCloseRef.current({
                    ...dataRef.current.floatingContext,
                    tree: tree,
                    x: event.clientX,
                    y: event.clientY,
                    onClose () {
                        clearPointerEvents();
                        cleanupMouseMoveHandler();
                        if (!isClickLikeOpenEvent()) closeWithDelay(event, true, 'safe-polygon');
                    }
                });
                const handler = handlerRef.current;
                doc.addEventListener('mousemove', handler);
                unbindMouseMoveRef.current = ()=>{
                    doc.removeEventListener('mousemove', handler);
                };
                return;
            }
            // Allow interactivity without `safePolygon` on touch devices. With a
            // pointer, a short close delay is an alternative, so it should work
            // consistently.
            const shouldClose = pointerTypeRef.current === 'touch' ? !(0, $5BFeN.contains)(elements.floating, event.relatedTarget) : true;
            if (shouldClose) closeWithDelay(event);
        }
        // Ensure the floating element closes after scrolling even if the pointer
        // did not move.
        // https://github.com/floating-ui/floating-ui/discussions/1692
        function onScrollMouseLeave(event) {
            if (isClickLikeOpenEvent()) return;
            if (!dataRef.current.floatingContext) return;
            handleCloseRef.current == null || handleCloseRef.current({
                ...dataRef.current.floatingContext,
                tree: tree,
                x: event.clientX,
                y: event.clientY,
                onClose () {
                    clearPointerEvents();
                    cleanupMouseMoveHandler();
                    if (!isClickLikeOpenEvent()) closeWithDelay(event);
                }
            })(event);
        }
        function onFloatingMouseEnter() {
            $92f1173bc75d6d9e$var$clearTimeoutIfSet(timeoutRef);
        }
        function onFloatingMouseLeave(event) {
            if (!isClickLikeOpenEvent()) closeWithDelay(event, false);
        }
        if ((0, $g7YZX.isElement)(elements.domReference)) {
            const reference = elements.domReference;
            const floating = elements.floating;
            if (open) reference.addEventListener('mouseleave', onScrollMouseLeave);
            if (move) reference.addEventListener('mousemove', onReferenceMouseEnter, {
                once: true
            });
            reference.addEventListener('mouseenter', onReferenceMouseEnter);
            reference.addEventListener('mouseleave', onReferenceMouseLeave);
            if (floating) {
                floating.addEventListener('mouseleave', onScrollMouseLeave);
                floating.addEventListener('mouseenter', onFloatingMouseEnter);
                floating.addEventListener('mouseleave', onFloatingMouseLeave);
            }
            return ()=>{
                if (open) reference.removeEventListener('mouseleave', onScrollMouseLeave);
                if (move) reference.removeEventListener('mousemove', onReferenceMouseEnter);
                reference.removeEventListener('mouseenter', onReferenceMouseEnter);
                reference.removeEventListener('mouseleave', onReferenceMouseLeave);
                if (floating) {
                    floating.removeEventListener('mouseleave', onScrollMouseLeave);
                    floating.removeEventListener('mouseenter', onFloatingMouseEnter);
                    floating.removeEventListener('mouseleave', onFloatingMouseLeave);
                }
            };
        }
    }, [
        elements,
        enabled,
        context,
        mouseOnly,
        move,
        closeWithDelay,
        cleanupMouseMoveHandler,
        clearPointerEvents,
        onOpenChange,
        open,
        openRef,
        tree,
        delayRef,
        handleCloseRef,
        dataRef,
        isClickLikeOpenEvent,
        restMsRef
    ]);
    // Block pointer-events of every element other than the reference and floating
    // while the floating element is open and has a `handleClose` handler. Also
    // handles nested floating elements.
    // https://github.com/floating-ui/floating-ui/issues/1722
    (0, $5BFeN.useModernLayoutEffect)(()=>{
        var _handleCloseRef$curre;
        if (!enabled) return;
        if (open && (_handleCloseRef$curre = handleCloseRef.current) != null && (_handleCloseRef$curre = _handleCloseRef$curre.__options) != null && _handleCloseRef$curre.blockPointerEvents && isHoverOpen()) {
            performedPointerEventsMutationRef.current = true;
            const floatingEl = elements.floating;
            if ((0, $g7YZX.isElement)(elements.domReference) && floatingEl) {
                var _tree$nodesRef$curren;
                const body = (0, $5BFeN.getDocument)(elements.floating).body;
                body.setAttribute($92f1173bc75d6d9e$var$safePolygonIdentifier, '');
                const ref = elements.domReference;
                const parentFloating = tree == null || (_tree$nodesRef$curren = tree.nodesRef.current.find((node)=>node.id === parentId)) == null || (_tree$nodesRef$curren = _tree$nodesRef$curren.context) == null ? void 0 : _tree$nodesRef$curren.elements.floating;
                if (parentFloating) parentFloating.style.pointerEvents = '';
                body.style.pointerEvents = 'none';
                ref.style.pointerEvents = 'auto';
                floatingEl.style.pointerEvents = 'auto';
                return ()=>{
                    body.style.pointerEvents = '';
                    ref.style.pointerEvents = '';
                    floatingEl.style.pointerEvents = '';
                };
            }
        }
    }, [
        enabled,
        open,
        parentId,
        elements,
        tree,
        handleCloseRef,
        isHoverOpen
    ]);
    (0, $5BFeN.useModernLayoutEffect)(()=>{
        if (!open) {
            pointerTypeRef.current = undefined;
            restTimeoutPendingRef.current = false;
            cleanupMouseMoveHandler();
            clearPointerEvents();
        }
    }, [
        open,
        cleanupMouseMoveHandler,
        clearPointerEvents
    ]);
    $cQQee.useEffect(()=>{
        return ()=>{
            cleanupMouseMoveHandler();
            $92f1173bc75d6d9e$var$clearTimeoutIfSet(timeoutRef);
            $92f1173bc75d6d9e$var$clearTimeoutIfSet(restTimeoutRef);
            clearPointerEvents();
        };
    }, [
        enabled,
        elements.domReference,
        cleanupMouseMoveHandler,
        clearPointerEvents
    ]);
    const reference = $cQQee.useMemo(()=>{
        function setPointerRef(event) {
            pointerTypeRef.current = event.pointerType;
        }
        return {
            onPointerDown: setPointerRef,
            onPointerEnter: setPointerRef,
            onMouseMove (event) {
                const { nativeEvent: nativeEvent } = event;
                function handleMouseMove() {
                    if (!blockMouseMoveRef.current && !openRef.current) onOpenChange(true, nativeEvent, 'hover');
                }
                if (mouseOnly && !(0, $5BFeN.isMouseLikePointerType)(pointerTypeRef.current)) return;
                if (open || $92f1173bc75d6d9e$var$getRestMs(restMsRef.current) === 0) return;
                // Ignore insignificant movements to account for tremors.
                if (restTimeoutPendingRef.current && event.movementX ** 2 + event.movementY ** 2 < 2) return;
                $92f1173bc75d6d9e$var$clearTimeoutIfSet(restTimeoutRef);
                if (pointerTypeRef.current === 'touch') handleMouseMove();
                else {
                    restTimeoutPendingRef.current = true;
                    restTimeoutRef.current = window.setTimeout(handleMouseMove, $92f1173bc75d6d9e$var$getRestMs(restMsRef.current));
                }
            }
        };
    }, [
        mouseOnly,
        onOpenChange,
        open,
        openRef,
        restMsRef
    ]);
    return $cQQee.useMemo(()=>enabled ? {
            reference: reference
        } : {}, [
        enabled,
        reference
    ]);
}
const $92f1173bc75d6d9e$var$NOOP = ()=>{};
const $92f1173bc75d6d9e$var$FloatingDelayGroupContext = /*#__PURE__*/ $cQQee.createContext({
    delay: 0,
    initialDelay: 0,
    timeoutMs: 0,
    currentId: null,
    setCurrentId: $92f1173bc75d6d9e$var$NOOP,
    setState: $92f1173bc75d6d9e$var$NOOP,
    isInstantPhase: false
});
/**
 * @deprecated
 * Use the return value of `useDelayGroup()` instead.
 */ const $92f1173bc75d6d9e$export$e2411914b150383d = ()=>$cQQee.useContext($92f1173bc75d6d9e$var$FloatingDelayGroupContext);
/**
 * Provides context for a group of floating elements that should share a
 * `delay`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ function $92f1173bc75d6d9e$export$718279509ff1e241(props) {
    const { children: children, delay: delay, timeoutMs: timeoutMs = 0 } = props;
    const [state, setState] = $cQQee.useReducer((prev, next)=>({
            ...prev,
            ...next
        }), {
        delay: delay,
        timeoutMs: timeoutMs,
        initialDelay: delay,
        currentId: null,
        isInstantPhase: false
    });
    const initialCurrentIdRef = $cQQee.useRef(null);
    const setCurrentId = $cQQee.useCallback((currentId)=>{
        setState({
            currentId: currentId
        });
    }, []);
    (0, $5BFeN.useModernLayoutEffect)(()=>{
        if (state.currentId) {
            if (initialCurrentIdRef.current === null) initialCurrentIdRef.current = state.currentId;
            else if (!state.isInstantPhase) setState({
                isInstantPhase: true
            });
        } else {
            if (state.isInstantPhase) setState({
                isInstantPhase: false
            });
            initialCurrentIdRef.current = null;
        }
    }, [
        state.currentId,
        state.isInstantPhase
    ]);
    return /*#__PURE__*/ (0, $7Tw3V.jsx)($92f1173bc75d6d9e$var$FloatingDelayGroupContext.Provider, {
        value: $cQQee.useMemo(()=>({
                ...state,
                setState: setState,
                setCurrentId: setCurrentId
            }), [
            state,
            setCurrentId
        ]),
        children: children
    });
}
/**
 * Enables grouping when called inside a component that's a child of a
 * `FloatingDelayGroup`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ function $92f1173bc75d6d9e$export$560fc8be89c8b4a8(context, options) {
    if (options === void 0) options = {};
    const { open: open, onOpenChange: onOpenChange, floatingId: floatingId } = context;
    const { id: optionId, enabled: enabled = true } = options;
    const id = optionId != null ? optionId : floatingId;
    const groupContext = $92f1173bc75d6d9e$export$e2411914b150383d();
    const { currentId: currentId, setCurrentId: setCurrentId, initialDelay: initialDelay, setState: setState, timeoutMs: timeoutMs } = groupContext;
    (0, $5BFeN.useModernLayoutEffect)(()=>{
        if (!enabled) return;
        if (!currentId) return;
        setState({
            delay: {
                open: 1,
                close: $92f1173bc75d6d9e$var$getDelay(initialDelay, 'close')
            }
        });
        if (currentId !== id) onOpenChange(false);
    }, [
        enabled,
        id,
        onOpenChange,
        setState,
        currentId,
        initialDelay
    ]);
    (0, $5BFeN.useModernLayoutEffect)(()=>{
        function unset() {
            onOpenChange(false);
            setState({
                delay: initialDelay,
                currentId: null
            });
        }
        if (!enabled) return;
        if (!currentId) return;
        if (!open && currentId === id) {
            if (timeoutMs) {
                const timeout = window.setTimeout(unset, timeoutMs);
                return ()=>{
                    clearTimeout(timeout);
                };
            }
            unset();
        }
    }, [
        enabled,
        open,
        setState,
        currentId,
        id,
        onOpenChange,
        initialDelay,
        timeoutMs
    ]);
    (0, $5BFeN.useModernLayoutEffect)(()=>{
        if (!enabled) return;
        if (setCurrentId === $92f1173bc75d6d9e$var$NOOP || !open) return;
        setCurrentId(id);
    }, [
        enabled,
        open,
        setCurrentId,
        id
    ]);
    return groupContext;
}
const $92f1173bc75d6d9e$var$NextFloatingDelayGroupContext = /*#__PURE__*/ $cQQee.createContext({
    hasProvider: false,
    timeoutMs: 0,
    delayRef: {
        current: 0
    },
    initialDelayRef: {
        current: 0
    },
    timeoutIdRef: {
        current: -1
    },
    currentIdRef: {
        current: null
    },
    currentContextRef: {
        current: null
    }
});
/**
 * Experimental next version of `FloatingDelayGroup` to become the default
 * in the future. This component is not yet stable.
 * Provides context for a group of floating elements that should share a
 * `delay`. Unlike `FloatingDelayGroup`, `useNextDelayGroup` with this
 * component does not cause a re-render of unrelated consumers of the
 * context when the delay changes.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ function $92f1173bc75d6d9e$export$e766ee16075bdf6b(props) {
    const { children: children, delay: delay, timeoutMs: timeoutMs = 0 } = props;
    const delayRef = $cQQee.useRef(delay);
    const initialDelayRef = $cQQee.useRef(delay);
    const currentIdRef = $cQQee.useRef(null);
    const currentContextRef = $cQQee.useRef(null);
    const timeoutIdRef = $cQQee.useRef(-1);
    return /*#__PURE__*/ (0, $7Tw3V.jsx)($92f1173bc75d6d9e$var$NextFloatingDelayGroupContext.Provider, {
        value: $cQQee.useMemo(()=>({
                hasProvider: true,
                delayRef: delayRef,
                initialDelayRef: initialDelayRef,
                currentIdRef: currentIdRef,
                timeoutMs: timeoutMs,
                currentContextRef: currentContextRef,
                timeoutIdRef: timeoutIdRef
            }), [
            timeoutMs
        ]),
        children: children
    });
}
/**
 * Enables grouping when called inside a component that's a child of a
 * `NextFloatingDelayGroup`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ function $92f1173bc75d6d9e$export$f86f270cee1e809c(context, options) {
    if (options === void 0) options = {};
    const { open: open, onOpenChange: onOpenChange, floatingId: floatingId } = context;
    const { enabled: enabled = true } = options;
    const groupContext = $cQQee.useContext($92f1173bc75d6d9e$var$NextFloatingDelayGroupContext);
    const { currentIdRef: currentIdRef, delayRef: delayRef, timeoutMs: timeoutMs, initialDelayRef: initialDelayRef, currentContextRef: currentContextRef, hasProvider: hasProvider, timeoutIdRef: timeoutIdRef } = groupContext;
    const [isInstantPhase, setIsInstantPhase] = $cQQee.useState(false);
    (0, $5BFeN.useModernLayoutEffect)(()=>{
        function unset() {
            var _currentContextRef$cu;
            setIsInstantPhase(false);
            (_currentContextRef$cu = currentContextRef.current) == null || _currentContextRef$cu.setIsInstantPhase(false);
            currentIdRef.current = null;
            currentContextRef.current = null;
            delayRef.current = initialDelayRef.current;
        }
        if (!enabled) return;
        if (!currentIdRef.current) return;
        if (!open && currentIdRef.current === floatingId) {
            setIsInstantPhase(false);
            if (timeoutMs) {
                timeoutIdRef.current = window.setTimeout(unset, timeoutMs);
                return ()=>{
                    clearTimeout(timeoutIdRef.current);
                };
            }
            unset();
        }
    }, [
        enabled,
        open,
        floatingId,
        currentIdRef,
        delayRef,
        timeoutMs,
        initialDelayRef,
        currentContextRef,
        timeoutIdRef
    ]);
    (0, $5BFeN.useModernLayoutEffect)(()=>{
        if (!enabled) return;
        if (!open) return;
        const prevContext = currentContextRef.current;
        const prevId = currentIdRef.current;
        currentContextRef.current = {
            onOpenChange: onOpenChange,
            setIsInstantPhase: setIsInstantPhase
        };
        currentIdRef.current = floatingId;
        delayRef.current = {
            open: 0,
            close: $92f1173bc75d6d9e$var$getDelay(initialDelayRef.current, 'close')
        };
        if (prevId !== null && prevId !== floatingId) {
            $92f1173bc75d6d9e$var$clearTimeoutIfSet(timeoutIdRef);
            setIsInstantPhase(true);
            prevContext == null || prevContext.setIsInstantPhase(true);
            prevContext == null || prevContext.onOpenChange(false);
        } else {
            setIsInstantPhase(false);
            prevContext == null || prevContext.setIsInstantPhase(false);
        }
    }, [
        enabled,
        open,
        floatingId,
        onOpenChange,
        currentIdRef,
        delayRef,
        timeoutMs,
        initialDelayRef,
        currentContextRef,
        timeoutIdRef
    ]);
    (0, $5BFeN.useModernLayoutEffect)(()=>{
        return ()=>{
            currentContextRef.current = null;
        };
    }, [
        currentContextRef
    ]);
    return $cQQee.useMemo(()=>({
            hasProvider: hasProvider,
            delayRef: delayRef,
            isInstantPhase: isInstantPhase
        }), [
        hasProvider,
        delayRef,
        isInstantPhase
    ]);
}
let $92f1173bc75d6d9e$var$rafId = 0;
function $92f1173bc75d6d9e$var$enqueueFocus(el, options) {
    if (options === void 0) options = {};
    const { preventScroll: preventScroll = false, cancelPrevious: cancelPrevious = true, sync: sync = false } = options;
    cancelPrevious && cancelAnimationFrame($92f1173bc75d6d9e$var$rafId);
    const exec = ()=>el == null ? void 0 : el.focus({
            preventScroll: preventScroll
        });
    if (sync) exec();
    else $92f1173bc75d6d9e$var$rafId = requestAnimationFrame(exec);
}
function $92f1173bc75d6d9e$var$contains(parent, child) {
    if (!parent || !child) return false;
    const rootNode = child.getRootNode == null ? void 0 : child.getRootNode();
    // First, attempt with faster native method
    if (parent.contains(child)) return true;
    // then fallback to custom implementation with Shadow DOM support
    if (rootNode && (0, $g7YZX.isShadowRoot)(rootNode)) {
        let next = child;
        while(next){
            if (parent === next) return true;
            // @ts-ignore
            next = next.parentNode || next.host;
        }
    }
    // Give up, the result is false
    return false;
}
function $92f1173bc75d6d9e$var$getTarget(event) {
    if ('composedPath' in event) return event.composedPath()[0];
    // TS thinks `event` is of type never as it assumes all browsers support
    // `composedPath()`, but browsers without shadow DOM don't.
    return event.target;
}
function $92f1173bc75d6d9e$var$getDocument(node) {
    return (node == null ? void 0 : node.ownerDocument) || document;
}
// Modified to add conditional `aria-hidden` support:
// https://github.com/theKashey/aria-hidden/blob/9220c8f4a4fd35f63bee5510a9f41a37264382d4/src/index.ts
const $92f1173bc75d6d9e$var$counters = {
    inert: /*#__PURE__*/ new WeakMap(),
    'aria-hidden': /*#__PURE__*/ new WeakMap(),
    none: /*#__PURE__*/ new WeakMap()
};
function $92f1173bc75d6d9e$var$getCounterMap(control) {
    if (control === 'inert') return $92f1173bc75d6d9e$var$counters.inert;
    if (control === 'aria-hidden') return $92f1173bc75d6d9e$var$counters['aria-hidden'];
    return $92f1173bc75d6d9e$var$counters.none;
}
let $92f1173bc75d6d9e$var$uncontrolledElementsSet = /*#__PURE__*/ new WeakSet();
let $92f1173bc75d6d9e$var$markerMap = {};
let $92f1173bc75d6d9e$var$lockCount$1 = 0;
const $92f1173bc75d6d9e$var$supportsInert = ()=>typeof HTMLElement !== 'undefined' && 'inert' in HTMLElement.prototype;
function $92f1173bc75d6d9e$var$unwrapHost(node) {
    if (!node) return null;
    return (0, $g7YZX.isShadowRoot)(node) ? node.host : $92f1173bc75d6d9e$var$unwrapHost(node.parentNode);
}
const $92f1173bc75d6d9e$var$correctElements = (parent, targets)=>targets.map((target)=>{
        if (parent.contains(target)) return target;
        const correctedTarget = $92f1173bc75d6d9e$var$unwrapHost(target);
        if (parent.contains(correctedTarget)) return correctedTarget;
        return null;
    }).filter((x)=>x != null);
function $92f1173bc75d6d9e$var$applyAttributeToOthers(uncorrectedAvoidElements, body, ariaHidden, inert) {
    const markerName = 'data-floating-ui-inert';
    const controlAttribute = inert ? 'inert' : ariaHidden ? 'aria-hidden' : null;
    const avoidElements = $92f1173bc75d6d9e$var$correctElements(body, uncorrectedAvoidElements);
    const elementsToKeep = new Set();
    const elementsToStop = new Set(avoidElements);
    const hiddenElements = [];
    if (!$92f1173bc75d6d9e$var$markerMap[markerName]) $92f1173bc75d6d9e$var$markerMap[markerName] = new WeakMap();
    const markerCounter = $92f1173bc75d6d9e$var$markerMap[markerName];
    avoidElements.forEach(keep);
    deep(body);
    elementsToKeep.clear();
    function keep(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        el.parentNode && keep(el.parentNode);
    }
    function deep(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        [].forEach.call(parent.children, (node)=>{
            if ((0, $g7YZX.getNodeName)(node) === 'script') return;
            if (elementsToKeep.has(node)) deep(node);
            else {
                const attr = controlAttribute ? node.getAttribute(controlAttribute) : null;
                const alreadyHidden = attr !== null && attr !== 'false';
                const counterMap = $92f1173bc75d6d9e$var$getCounterMap(controlAttribute);
                const counterValue = (counterMap.get(node) || 0) + 1;
                const markerValue = (markerCounter.get(node) || 0) + 1;
                counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenElements.push(node);
                if (counterValue === 1 && alreadyHidden) $92f1173bc75d6d9e$var$uncontrolledElementsSet.add(node);
                if (markerValue === 1) node.setAttribute(markerName, '');
                if (!alreadyHidden && controlAttribute) node.setAttribute(controlAttribute, controlAttribute === 'inert' ? '' : 'true');
            }
        });
    }
    $92f1173bc75d6d9e$var$lockCount$1++;
    return ()=>{
        hiddenElements.forEach((element)=>{
            const counterMap = $92f1173bc75d6d9e$var$getCounterMap(controlAttribute);
            const currentCounterValue = counterMap.get(element) || 0;
            const counterValue = currentCounterValue - 1;
            const markerValue = (markerCounter.get(element) || 0) - 1;
            counterMap.set(element, counterValue);
            markerCounter.set(element, markerValue);
            if (!counterValue) {
                if (!$92f1173bc75d6d9e$var$uncontrolledElementsSet.has(element) && controlAttribute) element.removeAttribute(controlAttribute);
                $92f1173bc75d6d9e$var$uncontrolledElementsSet.delete(element);
            }
            if (!markerValue) element.removeAttribute(markerName);
        });
        $92f1173bc75d6d9e$var$lockCount$1--;
        if (!$92f1173bc75d6d9e$var$lockCount$1) {
            $92f1173bc75d6d9e$var$counters.inert = new WeakMap();
            $92f1173bc75d6d9e$var$counters['aria-hidden'] = new WeakMap();
            $92f1173bc75d6d9e$var$counters.none = new WeakMap();
            $92f1173bc75d6d9e$var$uncontrolledElementsSet = new WeakSet();
            $92f1173bc75d6d9e$var$markerMap = {};
        }
    };
}
function $92f1173bc75d6d9e$var$markOthers(avoidElements, ariaHidden, inert) {
    if (ariaHidden === void 0) ariaHidden = false;
    if (inert === void 0) inert = false;
    const body = $92f1173bc75d6d9e$var$getDocument(avoidElements[0]).body;
    return $92f1173bc75d6d9e$var$applyAttributeToOthers(avoidElements.concat(Array.from(body.querySelectorAll('[aria-live],[role="status"],output'))), body, ariaHidden, inert);
}
const $92f1173bc75d6d9e$var$HIDDEN_STYLES = {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: 0,
    position: 'fixed',
    whiteSpace: 'nowrap',
    width: '1px',
    top: 0,
    left: 0
};
const $92f1173bc75d6d9e$var$FocusGuard = /*#__PURE__*/ $cQQee.forwardRef(function FocusGuard(props, ref) {
    const [role, setRole] = $cQQee.useState();
    (0, $5BFeN.useModernLayoutEffect)(()=>{
        if ((0, $5BFeN.isSafari)()) // Unlike other screen readers such as NVDA and JAWS, the virtual cursor
        // on VoiceOver does trigger the onFocus event, so we can use the focus
        // trap element. On Safari, only buttons trigger the onFocus event.
        // NB: "group" role in the Sandbox no longer appears to work, must be a
        // button role.
        setRole('button');
    }, []);
    const restProps = {
        ref: ref,
        tabIndex: 0,
        role: // Role is only for VoiceOver
        role,
        'aria-hidden': role ? undefined : true,
        [$92f1173bc75d6d9e$var$createAttribute('focus-guard')]: '',
        style: $92f1173bc75d6d9e$var$HIDDEN_STYLES
    };
    return /*#__PURE__*/ (0, $7Tw3V.jsx)("span", {
        ...props,
        ...restProps
    });
});
const $92f1173bc75d6d9e$var$HIDDEN_OWNER_STYLES = {
    clipPath: 'inset(50%)',
    position: 'fixed',
    top: 0,
    left: 0
};
const $92f1173bc75d6d9e$var$PortalContext = /*#__PURE__*/ $cQQee.createContext(null);
const $92f1173bc75d6d9e$var$attr = /*#__PURE__*/ $92f1173bc75d6d9e$var$createAttribute('portal');
/**
 * @see https://floating-ui.com/docs/FloatingPortal#usefloatingportalnode
 */ function $92f1173bc75d6d9e$export$ac107512f3c5cca6(props) {
    if (props === void 0) props = {};
    const { id: id, root: root } = props;
    const uniqueId = $92f1173bc75d6d9e$export$f680877a34711e37();
    const portalContext = $92f1173bc75d6d9e$var$usePortalContext();
    const [portalNode, setPortalNode] = $cQQee.useState(null);
    const portalNodeRef = $cQQee.useRef(null);
    (0, $5BFeN.useModernLayoutEffect)(()=>{
        return ()=>{
            portalNode == null || portalNode.remove();
            // Allow the subsequent layout effects to create a new node on updates.
            // The portal node will still be cleaned up on unmount.
            // https://github.com/floating-ui/floating-ui/issues/2454
            queueMicrotask(()=>{
                portalNodeRef.current = null;
            });
        };
    }, [
        portalNode
    ]);
    (0, $5BFeN.useModernLayoutEffect)(()=>{
        // Wait for the uniqueId to be generated before creating the portal node in
        // React <18 (using `useFloatingId` instead of the native `useId`).
        // https://github.com/floating-ui/floating-ui/issues/2778
        if (!uniqueId) return;
        if (portalNodeRef.current) return;
        const existingIdRoot = id ? document.getElementById(id) : null;
        if (!existingIdRoot) return;
        const subRoot = document.createElement('div');
        subRoot.id = uniqueId;
        subRoot.setAttribute($92f1173bc75d6d9e$var$attr, '');
        existingIdRoot.appendChild(subRoot);
        portalNodeRef.current = subRoot;
        setPortalNode(subRoot);
    }, [
        id,
        uniqueId
    ]);
    (0, $5BFeN.useModernLayoutEffect)(()=>{
        // Wait for the root to exist before creating the portal node. The root must
        // be stored in state, not a ref, for this to work reactively.
        if (root === null) return;
        if (!uniqueId) return;
        if (portalNodeRef.current) return;
        let container = root || (portalContext == null ? void 0 : portalContext.portalNode);
        if (container && !(0, $g7YZX.isNode)(container)) container = container.current;
        container = container || document.body;
        let idWrapper = null;
        if (id) {
            idWrapper = document.createElement('div');
            idWrapper.id = id;
            container.appendChild(idWrapper);
        }
        const subRoot = document.createElement('div');
        subRoot.id = uniqueId;
        subRoot.setAttribute($92f1173bc75d6d9e$var$attr, '');
        container = idWrapper || container;
        container.appendChild(subRoot);
        portalNodeRef.current = subRoot;
        setPortalNode(subRoot);
    }, [
        id,
        root,
        uniqueId,
        portalContext
    ]);
    return portalNode;
}
/**
 * Portals the floating element into a given container element — by default,
 * outside of the app root and into the body.
 * This is necessary to ensure the floating element can appear outside any
 * potential parent containers that cause clipping (such as `overflow: hidden`),
 * while retaining its location in the React tree.
 * @see https://floating-ui.com/docs/FloatingPortal
 */ function $92f1173bc75d6d9e$export$31fa5d718fa2ac09(props) {
    const { children: children, id: id, root: root, preserveTabOrder: preserveTabOrder = true } = props;
    const portalNode = $92f1173bc75d6d9e$export$ac107512f3c5cca6({
        id: id,
        root: root
    });
    const [focusManagerState, setFocusManagerState] = $cQQee.useState(null);
    const beforeOutsideRef = $cQQee.useRef(null);
    const afterOutsideRef = $cQQee.useRef(null);
    const beforeInsideRef = $cQQee.useRef(null);
    const afterInsideRef = $cQQee.useRef(null);
    const modal = focusManagerState == null ? void 0 : focusManagerState.modal;
    const open = focusManagerState == null ? void 0 : focusManagerState.open;
    const shouldRenderGuards = // The FocusManager and therefore floating element are currently open/
    // rendered.
    !!focusManagerState && // Guards are only for non-modal focus management.
    !focusManagerState.modal && // Don't render if unmount is transitioning.
    focusManagerState.open && preserveTabOrder && !!(root || portalNode);
    // https://codesandbox.io/s/tabbable-portal-f4tng?file=/src/TabbablePortal.tsx
    $cQQee.useEffect(()=>{
        if (!portalNode || !preserveTabOrder || modal) return;
        // Make sure elements inside the portal element are tabbable only when the
        // portal has already been focused, either by tabbing into a focus trap
        // element outside or using the mouse.
        function onFocus(event) {
            if (portalNode && (0, $5BFeN.isOutsideEvent)(event)) {
                const focusing = event.type === 'focusin';
                const manageFocus = focusing ? (0, $5BFeN.enableFocusInside) : (0, $5BFeN.disableFocusInside);
                manageFocus(portalNode);
            }
        }
        // Listen to the event on the capture phase so they run before the focus
        // trap elements onFocus prop is called.
        portalNode.addEventListener('focusin', onFocus, true);
        portalNode.addEventListener('focusout', onFocus, true);
        return ()=>{
            portalNode.removeEventListener('focusin', onFocus, true);
            portalNode.removeEventListener('focusout', onFocus, true);
        };
    }, [
        portalNode,
        preserveTabOrder,
        modal
    ]);
    $cQQee.useEffect(()=>{
        if (!portalNode) return;
        if (open) return;
        (0, $5BFeN.enableFocusInside)(portalNode);
    }, [
        open,
        portalNode
    ]);
    return /*#__PURE__*/ (0, $7Tw3V.jsxs)($92f1173bc75d6d9e$var$PortalContext.Provider, {
        value: $cQQee.useMemo(()=>({
                preserveTabOrder: preserveTabOrder,
                beforeOutsideRef: beforeOutsideRef,
                afterOutsideRef: afterOutsideRef,
                beforeInsideRef: beforeInsideRef,
                afterInsideRef: afterInsideRef,
                portalNode: portalNode,
                setFocusManagerState: setFocusManagerState
            }), [
            preserveTabOrder,
            portalNode
        ]),
        children: [
            shouldRenderGuards && portalNode && /*#__PURE__*/ (0, $7Tw3V.jsx)($92f1173bc75d6d9e$var$FocusGuard, {
                "data-type": "outside",
                ref: beforeOutsideRef,
                onFocus: (event)=>{
                    if ((0, $5BFeN.isOutsideEvent)(event, portalNode)) {
                        var _beforeInsideRef$curr;
                        (_beforeInsideRef$curr = beforeInsideRef.current) == null || _beforeInsideRef$curr.focus();
                    } else {
                        const domReference = focusManagerState ? focusManagerState.domReference : null;
                        const prevTabbable = (0, $5BFeN.getPreviousTabbable)(domReference);
                        prevTabbable == null || prevTabbable.focus();
                    }
                }
            }),
            shouldRenderGuards && portalNode && /*#__PURE__*/ (0, $7Tw3V.jsx)("span", {
                "aria-owns": portalNode.id,
                style: $92f1173bc75d6d9e$var$HIDDEN_OWNER_STYLES
            }),
            portalNode && /*#__PURE__*/ $kC364.createPortal(children, portalNode),
            shouldRenderGuards && portalNode && /*#__PURE__*/ (0, $7Tw3V.jsx)($92f1173bc75d6d9e$var$FocusGuard, {
                "data-type": "outside",
                ref: afterOutsideRef,
                onFocus: (event)=>{
                    if ((0, $5BFeN.isOutsideEvent)(event, portalNode)) {
                        var _afterInsideRef$curre;
                        (_afterInsideRef$curre = afterInsideRef.current) == null || _afterInsideRef$curre.focus();
                    } else {
                        const domReference = focusManagerState ? focusManagerState.domReference : null;
                        const nextTabbable = (0, $5BFeN.getNextTabbable)(domReference);
                        nextTabbable == null || nextTabbable.focus();
                        (focusManagerState == null ? void 0 : focusManagerState.closeOnFocusOut) && (focusManagerState == null || focusManagerState.onOpenChange(false, event.nativeEvent, 'focus-out'));
                    }
                }
            })
        ]
    });
}
const $92f1173bc75d6d9e$var$usePortalContext = ()=>$cQQee.useContext($92f1173bc75d6d9e$var$PortalContext);
function $92f1173bc75d6d9e$var$useLiteMergeRefs(refs) {
    return $cQQee.useMemo(()=>{
        return (value)=>{
            refs.forEach((ref)=>{
                if (ref) ref.current = value;
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}
const $92f1173bc75d6d9e$var$LIST_LIMIT = 20;
let $92f1173bc75d6d9e$var$previouslyFocusedElements = [];
function $92f1173bc75d6d9e$var$clearDisconnectedPreviouslyFocusedElements() {
    $92f1173bc75d6d9e$var$previouslyFocusedElements = $92f1173bc75d6d9e$var$previouslyFocusedElements.filter((elementRef)=>{
        var _elementRef$deref;
        return (_elementRef$deref = elementRef.deref()) == null ? void 0 : _elementRef$deref.isConnected;
    });
}
function $92f1173bc75d6d9e$var$addPreviouslyFocusedElement(element) {
    $92f1173bc75d6d9e$var$clearDisconnectedPreviouslyFocusedElements();
    if (element && (0, $g7YZX.getNodeName)(element) !== 'body') {
        $92f1173bc75d6d9e$var$previouslyFocusedElements.push(new WeakRef(element));
        if ($92f1173bc75d6d9e$var$previouslyFocusedElements.length > $92f1173bc75d6d9e$var$LIST_LIMIT) $92f1173bc75d6d9e$var$previouslyFocusedElements = $92f1173bc75d6d9e$var$previouslyFocusedElements.slice(-$92f1173bc75d6d9e$var$LIST_LIMIT);
    }
}
function $92f1173bc75d6d9e$var$getPreviouslyFocusedElement() {
    $92f1173bc75d6d9e$var$clearDisconnectedPreviouslyFocusedElements();
    const elementRef = $92f1173bc75d6d9e$var$previouslyFocusedElements[$92f1173bc75d6d9e$var$previouslyFocusedElements.length - 1];
    return elementRef == null ? void 0 : elementRef.deref();
}
function $92f1173bc75d6d9e$var$getFirstTabbableElement(container) {
    const tabbableOptions = (0, $5BFeN.getTabbableOptions)();
    if ((0, $9DaiF.isTabbable)(container, tabbableOptions)) return container;
    return (0, $9DaiF.tabbable)(container, tabbableOptions)[0] || container;
}
function $92f1173bc75d6d9e$var$handleTabIndex(floatingFocusElement, orderRef) {
    var _floatingFocusElement;
    if (!orderRef.current.includes('floating') && !((_floatingFocusElement = floatingFocusElement.getAttribute('role')) != null && _floatingFocusElement.includes('dialog'))) return;
    const options = (0, $5BFeN.getTabbableOptions)();
    const focusableElements = (0, $9DaiF.focusable)(floatingFocusElement, options);
    const tabbableContent = focusableElements.filter((element)=>{
        const dataTabIndex = element.getAttribute('data-tabindex') || '';
        return (0, $9DaiF.isTabbable)(element, options) || element.hasAttribute('data-tabindex') && !dataTabIndex.startsWith('-');
    });
    const tabIndex = floatingFocusElement.getAttribute('tabindex');
    if (orderRef.current.includes('floating') || tabbableContent.length === 0) {
        if (tabIndex !== '0') floatingFocusElement.setAttribute('tabindex', '0');
    } else if (tabIndex !== '-1' || floatingFocusElement.hasAttribute('data-tabindex') && floatingFocusElement.getAttribute('data-tabindex') !== '-1') {
        floatingFocusElement.setAttribute('tabindex', '-1');
        floatingFocusElement.setAttribute('data-tabindex', '-1');
    }
}
const $92f1173bc75d6d9e$var$VisuallyHiddenDismiss = /*#__PURE__*/ $cQQee.forwardRef(function VisuallyHiddenDismiss(props, ref) {
    return /*#__PURE__*/ (0, $7Tw3V.jsx)("button", {
        ...props,
        type: "button",
        ref: ref,
        tabIndex: -1,
        style: $92f1173bc75d6d9e$var$HIDDEN_STYLES
    });
});
/**
 * Provides focus management for the floating element.
 * @see https://floating-ui.com/docs/FloatingFocusManager
 */ function $92f1173bc75d6d9e$export$8aeee49171ded61a(props) {
    const { context: context, children: children, disabled: disabled = false, order: order = [
        'content'
    ], guards: _guards = true, initialFocus: initialFocus = 0, returnFocus: returnFocus = true, restoreFocus: restoreFocus = false, modal: modal = true, visuallyHiddenDismiss: visuallyHiddenDismiss = false, closeOnFocusOut: closeOnFocusOut = true, outsideElementsInert: outsideElementsInert = false, getInsideElements: _getInsideElements = ()=>[] } = props;
    const { open: open, onOpenChange: onOpenChange, events: events, dataRef: dataRef, elements: { domReference: domReference, floating: floating } } = context;
    const getNodeId = (0, $5BFeN.useEffectEvent)(()=>{
        var _dataRef$current$floa;
        return (_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.nodeId;
    });
    const getInsideElements = (0, $5BFeN.useEffectEvent)(_getInsideElements);
    const ignoreInitialFocus = typeof initialFocus === 'number' && initialFocus < 0;
    // If the reference is a combobox and is typeable (e.g. input/textarea),
    // there are different focus semantics. The guards should not be rendered, but
    // aria-hidden should be applied to all nodes still. Further, the visually
    // hidden dismiss button should only appear at the end of the list, not the
    // start.
    const isUntrappedTypeableCombobox = (0, $5BFeN.isTypeableCombobox)(domReference) && ignoreInitialFocus;
    // Force the guards to be rendered if the `inert` attribute is not supported.
    const inertSupported = $92f1173bc75d6d9e$var$supportsInert();
    const guards = inertSupported ? _guards : true;
    const useInert = !guards || inertSupported && outsideElementsInert;
    const orderRef = (0, $5BFeN.useLatestRef)(order);
    const initialFocusRef = (0, $5BFeN.useLatestRef)(initialFocus);
    const returnFocusRef = (0, $5BFeN.useLatestRef)(returnFocus);
    const tree = $92f1173bc75d6d9e$export$db0c2a7c7a2a4f69();
    const portalContext = $92f1173bc75d6d9e$var$usePortalContext();
    const startDismissButtonRef = $cQQee.useRef(null);
    const endDismissButtonRef = $cQQee.useRef(null);
    const preventReturnFocusRef = $cQQee.useRef(false);
    const isPointerDownRef = $cQQee.useRef(false);
    const tabbableIndexRef = $cQQee.useRef(-1);
    const blurTimeoutRef = $cQQee.useRef(-1);
    const isInsidePortal = portalContext != null;
    const floatingFocusElement = (0, $5BFeN.getFloatingFocusElement)(floating);
    const getTabbableContent = (0, $5BFeN.useEffectEvent)(function(container) {
        if (container === void 0) container = floatingFocusElement;
        return container ? (0, $9DaiF.tabbable)(container, (0, $5BFeN.getTabbableOptions)()) : [];
    });
    const getTabbableElements = (0, $5BFeN.useEffectEvent)((container)=>{
        const content = getTabbableContent(container);
        return orderRef.current.map((type)=>{
            if (domReference && type === 'reference') return domReference;
            if (floatingFocusElement && type === 'floating') return floatingFocusElement;
            return content;
        }).filter(Boolean).flat();
    });
    $cQQee.useEffect(()=>{
        if (disabled) return;
        if (!modal) return;
        function onKeyDown(event) {
            if (event.key === 'Tab') {
                // The focus guards have nothing to focus, so we need to stop the event.
                if ((0, $5BFeN.contains)(floatingFocusElement, (0, $5BFeN.activeElement)((0, $5BFeN.getDocument)(floatingFocusElement))) && getTabbableContent().length === 0 && !isUntrappedTypeableCombobox) (0, $5BFeN.stopEvent)(event);
                const els = getTabbableElements();
                const target = (0, $5BFeN.getTarget)(event);
                if (orderRef.current[0] === 'reference' && target === domReference) {
                    (0, $5BFeN.stopEvent)(event);
                    if (event.shiftKey) $92f1173bc75d6d9e$var$enqueueFocus(els[els.length - 1]);
                    else $92f1173bc75d6d9e$var$enqueueFocus(els[1]);
                }
                if (orderRef.current[1] === 'floating' && target === floatingFocusElement && event.shiftKey) {
                    (0, $5BFeN.stopEvent)(event);
                    $92f1173bc75d6d9e$var$enqueueFocus(els[0]);
                }
            }
        }
        const doc = (0, $5BFeN.getDocument)(floatingFocusElement);
        doc.addEventListener('keydown', onKeyDown);
        return ()=>{
            doc.removeEventListener('keydown', onKeyDown);
        };
    }, [
        disabled,
        domReference,
        floatingFocusElement,
        modal,
        orderRef,
        isUntrappedTypeableCombobox,
        getTabbableContent,
        getTabbableElements
    ]);
    $cQQee.useEffect(()=>{
        if (disabled) return;
        if (!floating) return;
        function handleFocusIn(event) {
            const target = (0, $5BFeN.getTarget)(event);
            const tabbableContent = getTabbableContent();
            const tabbableIndex = tabbableContent.indexOf(target);
            if (tabbableIndex !== -1) tabbableIndexRef.current = tabbableIndex;
        }
        floating.addEventListener('focusin', handleFocusIn);
        return ()=>{
            floating.removeEventListener('focusin', handleFocusIn);
        };
    }, [
        disabled,
        floating,
        getTabbableContent
    ]);
    $cQQee.useEffect(()=>{
        if (disabled) return;
        if (!closeOnFocusOut) return;
        // In Safari, buttons lose focus when pressing them.
        function handlePointerDown() {
            isPointerDownRef.current = true;
            setTimeout(()=>{
                isPointerDownRef.current = false;
            });
        }
        function handleFocusOutside(event) {
            const relatedTarget = event.relatedTarget;
            const currentTarget = event.currentTarget;
            const target = (0, $5BFeN.getTarget)(event);
            queueMicrotask(()=>{
                const nodeId = getNodeId();
                const movedToUnrelatedNode = !((0, $5BFeN.contains)(domReference, relatedTarget) || (0, $5BFeN.contains)(floating, relatedTarget) || (0, $5BFeN.contains)(relatedTarget, floating) || (0, $5BFeN.contains)(portalContext == null ? void 0 : portalContext.portalNode, relatedTarget) || relatedTarget != null && relatedTarget.hasAttribute($92f1173bc75d6d9e$var$createAttribute('focus-guard')) || tree && ((0, $5BFeN.getNodeChildren)(tree.nodesRef.current, nodeId).find((node)=>{
                    var _node$context, _node$context2;
                    return (0, $5BFeN.contains)((_node$context = node.context) == null ? void 0 : _node$context.elements.floating, relatedTarget) || (0, $5BFeN.contains)((_node$context2 = node.context) == null ? void 0 : _node$context2.elements.domReference, relatedTarget);
                }) || (0, $5BFeN.getNodeAncestors)(tree.nodesRef.current, nodeId).find((node)=>{
                    var _node$context3, _node$context4, _node$context5;
                    return [
                        (_node$context3 = node.context) == null ? void 0 : _node$context3.elements.floating,
                        (0, $5BFeN.getFloatingFocusElement)((_node$context4 = node.context) == null ? void 0 : _node$context4.elements.floating)
                    ].includes(relatedTarget) || ((_node$context5 = node.context) == null ? void 0 : _node$context5.elements.domReference) === relatedTarget;
                })));
                if (currentTarget === domReference && floatingFocusElement) $92f1173bc75d6d9e$var$handleTabIndex(floatingFocusElement, orderRef);
                // Restore focus to the previous tabbable element index to prevent
                // focus from being lost outside the floating tree.
                if (restoreFocus && currentTarget !== domReference && !(target != null && target.isConnected) && (0, $5BFeN.activeElement)((0, $5BFeN.getDocument)(floatingFocusElement)) === (0, $5BFeN.getDocument)(floatingFocusElement).body) {
                    // Let `FloatingPortal` effect knows that focus is still inside the
                    // floating tree.
                    if ((0, $g7YZX.isHTMLElement)(floatingFocusElement)) floatingFocusElement.focus();
                    const prevTabbableIndex = tabbableIndexRef.current;
                    const tabbableContent = getTabbableContent();
                    const nodeToFocus = tabbableContent[prevTabbableIndex] || tabbableContent[tabbableContent.length - 1] || floatingFocusElement;
                    if ((0, $g7YZX.isHTMLElement)(nodeToFocus)) nodeToFocus.focus();
                }
                // https://github.com/floating-ui/floating-ui/issues/3060
                if (dataRef.current.insideReactTree) {
                    dataRef.current.insideReactTree = false;
                    return;
                }
                // Focus did not move inside the floating tree, and there are no tabbable
                // portal guards to handle closing.
                if ((isUntrappedTypeableCombobox ? true : !modal) && relatedTarget && movedToUnrelatedNode && !isPointerDownRef.current && // Fix React 18 Strict Mode returnFocus due to double rendering.
                relatedTarget !== $92f1173bc75d6d9e$var$getPreviouslyFocusedElement()) {
                    preventReturnFocusRef.current = true;
                    onOpenChange(false, event, 'focus-out');
                }
            });
        }
        const shouldHandleBlurCapture = Boolean(!tree && portalContext);
        function markInsideReactTree() {
            $92f1173bc75d6d9e$var$clearTimeoutIfSet(blurTimeoutRef);
            dataRef.current.insideReactTree = true;
            blurTimeoutRef.current = window.setTimeout(()=>{
                dataRef.current.insideReactTree = false;
            });
        }
        if (floating && (0, $g7YZX.isHTMLElement)(domReference)) {
            domReference.addEventListener('focusout', handleFocusOutside);
            domReference.addEventListener('pointerdown', handlePointerDown);
            floating.addEventListener('focusout', handleFocusOutside);
            if (shouldHandleBlurCapture) floating.addEventListener('focusout', markInsideReactTree, true);
            return ()=>{
                domReference.removeEventListener('focusout', handleFocusOutside);
                domReference.removeEventListener('pointerdown', handlePointerDown);
                floating.removeEventListener('focusout', handleFocusOutside);
                if (shouldHandleBlurCapture) floating.removeEventListener('focusout', markInsideReactTree, true);
            };
        }
    }, [
        disabled,
        domReference,
        floating,
        floatingFocusElement,
        modal,
        tree,
        portalContext,
        onOpenChange,
        closeOnFocusOut,
        restoreFocus,
        getTabbableContent,
        isUntrappedTypeableCombobox,
        getNodeId,
        orderRef,
        dataRef
    ]);
    const beforeGuardRef = $cQQee.useRef(null);
    const afterGuardRef = $cQQee.useRef(null);
    const mergedBeforeGuardRef = $92f1173bc75d6d9e$var$useLiteMergeRefs([
        beforeGuardRef,
        portalContext == null ? void 0 : portalContext.beforeInsideRef
    ]);
    const mergedAfterGuardRef = $92f1173bc75d6d9e$var$useLiteMergeRefs([
        afterGuardRef,
        portalContext == null ? void 0 : portalContext.afterInsideRef
    ]);
    $cQQee.useEffect(()=>{
        var _portalContext$portal, _ancestors$find;
        if (disabled) return;
        if (!floating) return;
        // Don't hide portals nested within the parent portal.
        const portalNodes = Array.from((portalContext == null || (_portalContext$portal = portalContext.portalNode) == null ? void 0 : _portalContext$portal.querySelectorAll("[" + $92f1173bc75d6d9e$var$createAttribute('portal') + "]")) || []);
        const ancestors = tree ? (0, $5BFeN.getNodeAncestors)(tree.nodesRef.current, getNodeId()) : [];
        const rootAncestorComboboxDomReference = (_ancestors$find = ancestors.find((node)=>{
            var _node$context6;
            return (0, $5BFeN.isTypeableCombobox)(((_node$context6 = node.context) == null ? void 0 : _node$context6.elements.domReference) || null);
        })) == null || (_ancestors$find = _ancestors$find.context) == null ? void 0 : _ancestors$find.elements.domReference;
        const insideElements = [
            floating,
            rootAncestorComboboxDomReference,
            ...portalNodes,
            ...getInsideElements(),
            startDismissButtonRef.current,
            endDismissButtonRef.current,
            beforeGuardRef.current,
            afterGuardRef.current,
            portalContext == null ? void 0 : portalContext.beforeOutsideRef.current,
            portalContext == null ? void 0 : portalContext.afterOutsideRef.current,
            orderRef.current.includes('reference') || isUntrappedTypeableCombobox ? domReference : null
        ].filter((x)=>x != null);
        const cleanup = modal || isUntrappedTypeableCombobox ? $92f1173bc75d6d9e$var$markOthers(insideElements, !useInert, useInert) : $92f1173bc75d6d9e$var$markOthers(insideElements);
        return ()=>{
            cleanup();
        };
    }, [
        disabled,
        domReference,
        floating,
        modal,
        orderRef,
        portalContext,
        isUntrappedTypeableCombobox,
        guards,
        useInert,
        tree,
        getNodeId,
        getInsideElements
    ]);
    (0, $5BFeN.useModernLayoutEffect)(()=>{
        if (disabled || !(0, $g7YZX.isHTMLElement)(floatingFocusElement)) return;
        const doc = (0, $5BFeN.getDocument)(floatingFocusElement);
        const previouslyFocusedElement = (0, $5BFeN.activeElement)(doc);
        // Wait for any layout effect state setters to execute to set `tabIndex`.
        queueMicrotask(()=>{
            const focusableElements = getTabbableElements(floatingFocusElement);
            const initialFocusValue = initialFocusRef.current;
            const elToFocus = (typeof initialFocusValue === 'number' ? focusableElements[initialFocusValue] : initialFocusValue.current) || floatingFocusElement;
            const focusAlreadyInsideFloatingEl = (0, $5BFeN.contains)(floatingFocusElement, previouslyFocusedElement);
            if (!ignoreInitialFocus && !focusAlreadyInsideFloatingEl && open) $92f1173bc75d6d9e$var$enqueueFocus(elToFocus, {
                preventScroll: elToFocus === floatingFocusElement
            });
        });
    }, [
        disabled,
        open,
        floatingFocusElement,
        ignoreInitialFocus,
        getTabbableElements,
        initialFocusRef
    ]);
    (0, $5BFeN.useModernLayoutEffect)(()=>{
        if (disabled || !floatingFocusElement) return;
        const doc = (0, $5BFeN.getDocument)(floatingFocusElement);
        const previouslyFocusedElement = (0, $5BFeN.activeElement)(doc);
        $92f1173bc75d6d9e$var$addPreviouslyFocusedElement(previouslyFocusedElement);
        // Dismissing via outside press should always ignore `returnFocus` to
        // prevent unwanted scrolling.
        function onOpenChange(_ref) {
            let { reason: reason, event: event, nested: nested } = _ref;
            if ([
                'hover',
                'safe-polygon'
            ].includes(reason) && event.type === 'mouseleave') preventReturnFocusRef.current = true;
            if (reason !== 'outside-press') return;
            if (nested) preventReturnFocusRef.current = false;
            else if ((0, $5BFeN.isVirtualClick)(event) || (0, $5BFeN.isVirtualPointerEvent)(event)) preventReturnFocusRef.current = false;
            else {
                let isPreventScrollSupported = false;
                document.createElement('div').focus({
                    get preventScroll () {
                        isPreventScrollSupported = true;
                        return false;
                    }
                });
                if (isPreventScrollSupported) preventReturnFocusRef.current = false;
                else preventReturnFocusRef.current = true;
            }
        }
        events.on('openchange', onOpenChange);
        const fallbackEl = doc.createElement('span');
        fallbackEl.setAttribute('tabindex', '-1');
        fallbackEl.setAttribute('aria-hidden', 'true');
        Object.assign(fallbackEl.style, $92f1173bc75d6d9e$var$HIDDEN_STYLES);
        if (isInsidePortal && domReference) domReference.insertAdjacentElement('afterend', fallbackEl);
        function getReturnElement() {
            if (typeof returnFocusRef.current === 'boolean') {
                const el = domReference || $92f1173bc75d6d9e$var$getPreviouslyFocusedElement();
                return el && el.isConnected ? el : fallbackEl;
            }
            return returnFocusRef.current.current || fallbackEl;
        }
        return ()=>{
            events.off('openchange', onOpenChange);
            const activeEl = (0, $5BFeN.activeElement)(doc);
            const isFocusInsideFloatingTree = (0, $5BFeN.contains)(floating, activeEl) || tree && (0, $5BFeN.getNodeChildren)(tree.nodesRef.current, getNodeId(), false).some((node)=>{
                var _node$context7;
                return (0, $5BFeN.contains)((_node$context7 = node.context) == null ? void 0 : _node$context7.elements.floating, activeEl);
            });
            const returnElement = getReturnElement();
            queueMicrotask(()=>{
                // This is `returnElement`, if it's tabbable, or its first tabbable child.
                const tabbableReturnElement = $92f1173bc75d6d9e$var$getFirstTabbableElement(returnElement);
                if (// eslint-disable-next-line react-hooks/exhaustive-deps
                returnFocusRef.current && !preventReturnFocusRef.current && (0, $g7YZX.isHTMLElement)(tabbableReturnElement) && // If the focus moved somewhere else after mount, avoid returning focus
                // since it likely entered a different element which should be
                // respected: https://github.com/floating-ui/floating-ui/issues/2607
                (tabbableReturnElement !== activeEl && activeEl !== doc.body ? isFocusInsideFloatingTree : true)) tabbableReturnElement.focus({
                    preventScroll: true
                });
                fallbackEl.remove();
            });
        };
    }, [
        disabled,
        floating,
        floatingFocusElement,
        returnFocusRef,
        dataRef,
        events,
        tree,
        isInsidePortal,
        domReference,
        getNodeId
    ]);
    $cQQee.useEffect(()=>{
        // The `returnFocus` cleanup behavior is inside a microtask; ensure we
        // wait for it to complete before resetting the flag.
        queueMicrotask(()=>{
            preventReturnFocusRef.current = false;
        });
        return ()=>{
            queueMicrotask($92f1173bc75d6d9e$var$clearDisconnectedPreviouslyFocusedElements);
        };
    }, [
        disabled
    ]);
    // Synchronize the `context` & `modal` value to the FloatingPortal context.
    // It will decide whether or not it needs to render its own guards.
    (0, $5BFeN.useModernLayoutEffect)(()=>{
        if (disabled) return;
        if (!portalContext) return;
        portalContext.setFocusManagerState({
            modal: modal,
            closeOnFocusOut: closeOnFocusOut,
            open: open,
            onOpenChange: onOpenChange,
            domReference: domReference
        });
        return ()=>{
            portalContext.setFocusManagerState(null);
        };
    }, [
        disabled,
        portalContext,
        modal,
        open,
        onOpenChange,
        closeOnFocusOut,
        domReference
    ]);
    (0, $5BFeN.useModernLayoutEffect)(()=>{
        if (disabled) return;
        if (!floatingFocusElement) return;
        $92f1173bc75d6d9e$var$handleTabIndex(floatingFocusElement, orderRef);
    }, [
        disabled,
        floatingFocusElement,
        orderRef
    ]);
    function renderDismissButton(location) {
        if (disabled || !visuallyHiddenDismiss || !modal) return null;
        return /*#__PURE__*/ (0, $7Tw3V.jsx)($92f1173bc75d6d9e$var$VisuallyHiddenDismiss, {
            ref: location === 'start' ? startDismissButtonRef : endDismissButtonRef,
            onClick: (event)=>onOpenChange(false, event.nativeEvent),
            children: typeof visuallyHiddenDismiss === 'string' ? visuallyHiddenDismiss : 'Dismiss'
        });
    }
    const shouldRenderGuards = !disabled && guards && (modal ? !isUntrappedTypeableCombobox : true) && (isInsidePortal || modal);
    return /*#__PURE__*/ (0, $7Tw3V.jsxs)((0, $7Tw3V.Fragment), {
        children: [
            shouldRenderGuards && /*#__PURE__*/ (0, $7Tw3V.jsx)($92f1173bc75d6d9e$var$FocusGuard, {
                "data-type": "inside",
                ref: mergedBeforeGuardRef,
                onFocus: (event)=>{
                    if (modal) {
                        const els = getTabbableElements();
                        $92f1173bc75d6d9e$var$enqueueFocus(order[0] === 'reference' ? els[0] : els[els.length - 1]);
                    } else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
                        preventReturnFocusRef.current = false;
                        if ((0, $5BFeN.isOutsideEvent)(event, portalContext.portalNode)) {
                            const nextTabbable = (0, $5BFeN.getNextTabbable)(domReference);
                            nextTabbable == null || nextTabbable.focus();
                        } else {
                            var _portalContext$before;
                            (_portalContext$before = portalContext.beforeOutsideRef.current) == null || _portalContext$before.focus();
                        }
                    }
                }
            }),
            !isUntrappedTypeableCombobox && renderDismissButton('start'),
            children,
            renderDismissButton('end'),
            shouldRenderGuards && /*#__PURE__*/ (0, $7Tw3V.jsx)($92f1173bc75d6d9e$var$FocusGuard, {
                "data-type": "inside",
                ref: mergedAfterGuardRef,
                onFocus: (event)=>{
                    if (modal) $92f1173bc75d6d9e$var$enqueueFocus(getTabbableElements()[0]);
                    else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
                        if (closeOnFocusOut) preventReturnFocusRef.current = true;
                        if ((0, $5BFeN.isOutsideEvent)(event, portalContext.portalNode)) {
                            const prevTabbable = (0, $5BFeN.getPreviousTabbable)(domReference);
                            prevTabbable == null || prevTabbable.focus();
                        } else {
                            var _portalContext$afterO;
                            (_portalContext$afterO = portalContext.afterOutsideRef.current) == null || _portalContext$afterO.focus();
                        }
                    }
                }
            })
        ]
    });
}
let $92f1173bc75d6d9e$var$lockCount = 0;
const $92f1173bc75d6d9e$var$scrollbarProperty = '--floating-ui-scrollbar-width';
function $92f1173bc75d6d9e$var$enableScrollLock() {
    const platform = (0, $5BFeN.getPlatform)();
    const isIOS = /iP(hone|ad|od)|iOS/.test(platform) || // iPads can claim to be MacIntel
    platform === 'MacIntel' && navigator.maxTouchPoints > 1;
    const bodyStyle = document.body.style;
    // RTL <body> scrollbar
    const scrollbarX = Math.round(document.documentElement.getBoundingClientRect().left) + document.documentElement.scrollLeft;
    const paddingProp = scrollbarX ? 'paddingLeft' : 'paddingRight';
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    const scrollX = bodyStyle.left ? parseFloat(bodyStyle.left) : window.scrollX;
    const scrollY = bodyStyle.top ? parseFloat(bodyStyle.top) : window.scrollY;
    bodyStyle.overflow = 'hidden';
    bodyStyle.setProperty($92f1173bc75d6d9e$var$scrollbarProperty, scrollbarWidth + "px");
    if (scrollbarWidth) bodyStyle[paddingProp] = scrollbarWidth + "px";
    // Only iOS doesn't respect `overflow: hidden` on document.body, and this
    // technique has fewer side effects.
    if (isIOS) {
        var _window$visualViewpor, _window$visualViewpor2;
        // iOS 12 does not support `visualViewport`.
        const offsetLeft = ((_window$visualViewpor = window.visualViewport) == null ? void 0 : _window$visualViewpor.offsetLeft) || 0;
        const offsetTop = ((_window$visualViewpor2 = window.visualViewport) == null ? void 0 : _window$visualViewpor2.offsetTop) || 0;
        Object.assign(bodyStyle, {
            position: 'fixed',
            top: -(scrollY - Math.floor(offsetTop)) + "px",
            left: -(scrollX - Math.floor(offsetLeft)) + "px",
            right: '0'
        });
    }
    return ()=>{
        Object.assign(bodyStyle, {
            overflow: '',
            [paddingProp]: ''
        });
        bodyStyle.removeProperty($92f1173bc75d6d9e$var$scrollbarProperty);
        if (isIOS) {
            Object.assign(bodyStyle, {
                position: '',
                top: '',
                left: '',
                right: ''
            });
            window.scrollTo(scrollX, scrollY);
        }
    };
}
let $92f1173bc75d6d9e$var$cleanup = ()=>{};
/**
 * Provides base styling for a fixed overlay element to dim content or block
 * pointer events behind a floating element.
 * It's a regular `<div>`, so it can be styled via any CSS solution you prefer.
 * @see https://floating-ui.com/docs/FloatingOverlay
 */ const $92f1173bc75d6d9e$export$a35954495955337b = /*#__PURE__*/ $cQQee.forwardRef(function FloatingOverlay(props, ref) {
    const { lockScroll: lockScroll = false, ...rest } = props;
    (0, $5BFeN.useModernLayoutEffect)(()=>{
        if (!lockScroll) return;
        $92f1173bc75d6d9e$var$lockCount++;
        if ($92f1173bc75d6d9e$var$lockCount === 1) $92f1173bc75d6d9e$var$cleanup = $92f1173bc75d6d9e$var$enableScrollLock();
        return ()=>{
            $92f1173bc75d6d9e$var$lockCount--;
            if ($92f1173bc75d6d9e$var$lockCount === 0) $92f1173bc75d6d9e$var$cleanup();
        };
    }, [
        lockScroll
    ]);
    return /*#__PURE__*/ (0, $7Tw3V.jsx)("div", {
        ref: ref,
        ...rest,
        style: {
            position: 'fixed',
            overflow: 'auto',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            ...rest.style
        }
    });
});
function $92f1173bc75d6d9e$var$isButtonTarget(event) {
    return (0, $g7YZX.isHTMLElement)(event.target) && event.target.tagName === 'BUTTON';
}
function $92f1173bc75d6d9e$var$isAnchorTarget(event) {
    return (0, $g7YZX.isHTMLElement)(event.target) && event.target.tagName === 'A';
}
function $92f1173bc75d6d9e$var$isSpaceIgnored(element) {
    return (0, $5BFeN.isTypeableElement)(element);
}
/**
 * Opens or closes the floating element when clicking the reference element.
 * @see https://floating-ui.com/docs/useClick
 */ function $92f1173bc75d6d9e$export$98524f11226063fc(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, dataRef: dataRef, elements: { domReference: domReference } } = context;
    const { enabled: enabled = true, event: eventOption = 'click', toggle: toggle = true, ignoreMouse: ignoreMouse = false, keyboardHandlers: keyboardHandlers = true, stickIfOpen: stickIfOpen = true } = props;
    const pointerTypeRef = $cQQee.useRef();
    const didKeyDownRef = $cQQee.useRef(false);
    const reference = $cQQee.useMemo(()=>({
            onPointerDown (event) {
                pointerTypeRef.current = event.pointerType;
            },
            onMouseDown (event) {
                const pointerType = pointerTypeRef.current;
                // Ignore all buttons except for the "main" button.
                // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
                if (event.button !== 0) return;
                if (eventOption === 'click') return;
                if ((0, $5BFeN.isMouseLikePointerType)(pointerType, true) && ignoreMouse) return;
                if (open && toggle && (dataRef.current.openEvent && stickIfOpen ? dataRef.current.openEvent.type === 'mousedown' : true)) onOpenChange(false, event.nativeEvent, 'click');
                else {
                    // Prevent stealing focus from the floating element
                    event.preventDefault();
                    onOpenChange(true, event.nativeEvent, 'click');
                }
            },
            onClick (event) {
                const pointerType = pointerTypeRef.current;
                if (eventOption === 'mousedown' && pointerTypeRef.current) {
                    pointerTypeRef.current = undefined;
                    return;
                }
                if ((0, $5BFeN.isMouseLikePointerType)(pointerType, true) && ignoreMouse) return;
                if (open && toggle && (dataRef.current.openEvent && stickIfOpen ? dataRef.current.openEvent.type === 'click' : true)) onOpenChange(false, event.nativeEvent, 'click');
                else onOpenChange(true, event.nativeEvent, 'click');
            },
            onKeyDown (event) {
                pointerTypeRef.current = undefined;
                if (event.defaultPrevented || !keyboardHandlers || $92f1173bc75d6d9e$var$isButtonTarget(event)) return;
                if (event.key === ' ' && !$92f1173bc75d6d9e$var$isSpaceIgnored(domReference)) {
                    // Prevent scrolling
                    event.preventDefault();
                    didKeyDownRef.current = true;
                }
                if ($92f1173bc75d6d9e$var$isAnchorTarget(event)) return;
                if (event.key === 'Enter') {
                    if (open && toggle) onOpenChange(false, event.nativeEvent, 'click');
                    else onOpenChange(true, event.nativeEvent, 'click');
                }
            },
            onKeyUp (event) {
                if (event.defaultPrevented || !keyboardHandlers || $92f1173bc75d6d9e$var$isButtonTarget(event) || $92f1173bc75d6d9e$var$isSpaceIgnored(domReference)) return;
                if (event.key === ' ' && didKeyDownRef.current) {
                    didKeyDownRef.current = false;
                    if (open && toggle) onOpenChange(false, event.nativeEvent, 'click');
                    else onOpenChange(true, event.nativeEvent, 'click');
                }
            }
        }), [
        dataRef,
        domReference,
        eventOption,
        ignoreMouse,
        keyboardHandlers,
        onOpenChange,
        open,
        stickIfOpen,
        toggle
    ]);
    return $cQQee.useMemo(()=>enabled ? {
            reference: reference
        } : {}, [
        enabled,
        reference
    ]);
}
function $92f1173bc75d6d9e$var$createVirtualElement(domElement, data) {
    let offsetX = null;
    let offsetY = null;
    let isAutoUpdateEvent = false;
    return {
        contextElement: domElement || undefined,
        getBoundingClientRect () {
            var _data$dataRef$current;
            const domRect = (domElement == null ? void 0 : domElement.getBoundingClientRect()) || {
                width: 0,
                height: 0,
                x: 0,
                y: 0
            };
            const isXAxis = data.axis === 'x' || data.axis === 'both';
            const isYAxis = data.axis === 'y' || data.axis === 'both';
            const canTrackCursorOnAutoUpdate = [
                'mouseenter',
                'mousemove'
            ].includes(((_data$dataRef$current = data.dataRef.current.openEvent) == null ? void 0 : _data$dataRef$current.type) || '') && data.pointerType !== 'touch';
            let width = domRect.width;
            let height = domRect.height;
            let x = domRect.x;
            let y = domRect.y;
            if (offsetX == null && data.x && isXAxis) offsetX = domRect.x - data.x;
            if (offsetY == null && data.y && isYAxis) offsetY = domRect.y - data.y;
            x -= offsetX || 0;
            y -= offsetY || 0;
            width = 0;
            height = 0;
            if (!isAutoUpdateEvent || canTrackCursorOnAutoUpdate) {
                width = data.axis === 'y' ? domRect.width : 0;
                height = data.axis === 'x' ? domRect.height : 0;
                x = isXAxis && data.x != null ? data.x : x;
                y = isYAxis && data.y != null ? data.y : y;
            } else if (isAutoUpdateEvent && !canTrackCursorOnAutoUpdate) {
                height = data.axis === 'x' ? domRect.height : height;
                width = data.axis === 'y' ? domRect.width : width;
            }
            isAutoUpdateEvent = true;
            return {
                width: width,
                height: height,
                x: x,
                y: y,
                top: y,
                right: x + width,
                bottom: y + height,
                left: x
            };
        }
    };
}
function $92f1173bc75d6d9e$var$isMouseBasedEvent(event) {
    return event != null && event.clientX != null;
}
/**
 * Positions the floating element relative to a client point (in the viewport),
 * such as the mouse position. By default, it follows the mouse cursor.
 * @see https://floating-ui.com/docs/useClientPoint
 */ function $92f1173bc75d6d9e$export$7fe170a73a621816(context, props) {
    if (props === void 0) props = {};
    const { open: open, dataRef: dataRef, elements: { floating: floating, domReference: domReference }, refs: refs } = context;
    const { enabled: enabled = true, axis: axis = 'both', x: x = null, y: y = null } = props;
    const initialRef = $cQQee.useRef(false);
    const cleanupListenerRef = $cQQee.useRef(null);
    const [pointerType, setPointerType] = $cQQee.useState();
    const [reactive, setReactive] = $cQQee.useState([]);
    const setReference = (0, $5BFeN.useEffectEvent)((x, y)=>{
        if (initialRef.current) return;
        // Prevent setting if the open event was not a mouse-like one
        // (e.g. focus to open, then hover over the reference element).
        // Only apply if the event exists.
        if (dataRef.current.openEvent && !$92f1173bc75d6d9e$var$isMouseBasedEvent(dataRef.current.openEvent)) return;
        refs.setPositionReference($92f1173bc75d6d9e$var$createVirtualElement(domReference, {
            x: x,
            y: y,
            axis: axis,
            dataRef: dataRef,
            pointerType: pointerType
        }));
    });
    const handleReferenceEnterOrMove = (0, $5BFeN.useEffectEvent)((event)=>{
        if (x != null || y != null) return;
        if (!open) setReference(event.clientX, event.clientY);
        else if (!cleanupListenerRef.current) // If there's no cleanup, there's no listener, but we want to ensure
        // we add the listener if the cursor landed on the floating element and
        // then back on the reference (i.e. it's interactive).
        setReactive([]);
    });
    // If the pointer is a mouse-like pointer, we want to continue following the
    // mouse even if the floating element is transitioning out. On touch
    // devices, this is undesirable because the floating element will move to
    // the dismissal touch point.
    const openCheck = (0, $5BFeN.isMouseLikePointerType)(pointerType) ? floating : open;
    const addListener = $cQQee.useCallback(()=>{
        // Explicitly specified `x`/`y` coordinates shouldn't add a listener.
        if (!openCheck || !enabled || x != null || y != null) return;
        const win = (0, $g7YZX.getWindow)(floating);
        function handleMouseMove(event) {
            const target = (0, $5BFeN.getTarget)(event);
            if (!(0, $5BFeN.contains)(floating, target)) setReference(event.clientX, event.clientY);
            else {
                win.removeEventListener('mousemove', handleMouseMove);
                cleanupListenerRef.current = null;
            }
        }
        if (!dataRef.current.openEvent || $92f1173bc75d6d9e$var$isMouseBasedEvent(dataRef.current.openEvent)) {
            win.addEventListener('mousemove', handleMouseMove);
            const cleanup = ()=>{
                win.removeEventListener('mousemove', handleMouseMove);
                cleanupListenerRef.current = null;
            };
            cleanupListenerRef.current = cleanup;
            return cleanup;
        }
        refs.setPositionReference(domReference);
    }, [
        openCheck,
        enabled,
        x,
        y,
        floating,
        dataRef,
        refs,
        domReference,
        setReference
    ]);
    $cQQee.useEffect(()=>{
        return addListener();
    }, [
        addListener,
        reactive
    ]);
    $cQQee.useEffect(()=>{
        if (enabled && !floating) initialRef.current = false;
    }, [
        enabled,
        floating
    ]);
    $cQQee.useEffect(()=>{
        if (!enabled && open) initialRef.current = true;
    }, [
        enabled,
        open
    ]);
    (0, $5BFeN.useModernLayoutEffect)(()=>{
        if (enabled && (x != null || y != null)) {
            initialRef.current = false;
            setReference(x, y);
        }
    }, [
        enabled,
        x,
        y,
        setReference
    ]);
    const reference = $cQQee.useMemo(()=>{
        function setPointerTypeRef(_ref) {
            let { pointerType: pointerType } = _ref;
            setPointerType(pointerType);
        }
        return {
            onPointerDown: setPointerTypeRef,
            onPointerEnter: setPointerTypeRef,
            onMouseMove: handleReferenceEnterOrMove,
            onMouseEnter: handleReferenceEnterOrMove
        };
    }, [
        handleReferenceEnterOrMove
    ]);
    return $cQQee.useMemo(()=>enabled ? {
            reference: reference
        } : {}, [
        enabled,
        reference
    ]);
}
const $92f1173bc75d6d9e$var$bubbleHandlerKeys = {
    pointerdown: 'onPointerDown',
    mousedown: 'onMouseDown',
    click: 'onClick'
};
const $92f1173bc75d6d9e$var$captureHandlerKeys = {
    pointerdown: 'onPointerDownCapture',
    mousedown: 'onMouseDownCapture',
    click: 'onClickCapture'
};
const $92f1173bc75d6d9e$var$normalizeProp = (normalizable)=>{
    var _normalizable$escapeK, _normalizable$outside;
    return {
        escapeKey: typeof normalizable === 'boolean' ? normalizable : (_normalizable$escapeK = normalizable == null ? void 0 : normalizable.escapeKey) != null ? _normalizable$escapeK : false,
        outsidePress: typeof normalizable === 'boolean' ? normalizable : (_normalizable$outside = normalizable == null ? void 0 : normalizable.outsidePress) != null ? _normalizable$outside : true
    };
};
/**
 * Closes the floating element when a dismissal is requested — by default, when
 * the user presses the `escape` key or outside of the floating element.
 * @see https://floating-ui.com/docs/useDismiss
 */ function $92f1173bc75d6d9e$export$fcdf1ba5fafc089b(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, elements: elements, dataRef: dataRef } = context;
    const { enabled: enabled = true, escapeKey: escapeKey = true, outsidePress: unstable_outsidePress = true, outsidePressEvent: outsidePressEvent = 'pointerdown', referencePress: referencePress = false, referencePressEvent: referencePressEvent = 'pointerdown', ancestorScroll: ancestorScroll = false, bubbles: bubbles, capture: capture } = props;
    const tree = $92f1173bc75d6d9e$export$db0c2a7c7a2a4f69();
    const outsidePressFn = (0, $5BFeN.useEffectEvent)(typeof unstable_outsidePress === 'function' ? unstable_outsidePress : ()=>false);
    const outsidePress = typeof unstable_outsidePress === 'function' ? outsidePressFn : unstable_outsidePress;
    const endedOrStartedInsideRef = $cQQee.useRef(false);
    const { escapeKey: escapeKeyBubbles, outsidePress: outsidePressBubbles } = $92f1173bc75d6d9e$var$normalizeProp(bubbles);
    const { escapeKey: escapeKeyCapture, outsidePress: outsidePressCapture } = $92f1173bc75d6d9e$var$normalizeProp(capture);
    const isComposingRef = $cQQee.useRef(false);
    const closeOnEscapeKeyDown = (0, $5BFeN.useEffectEvent)((event)=>{
        var _dataRef$current$floa;
        if (!open || !enabled || !escapeKey || event.key !== 'Escape') return;
        // Wait until IME is settled. Pressing `Escape` while composing should
        // close the compose menu, but not the floating element.
        if (isComposingRef.current) return;
        const nodeId = (_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.nodeId;
        const children = tree ? (0, $5BFeN.getNodeChildren)(tree.nodesRef.current, nodeId) : [];
        if (!escapeKeyBubbles) {
            event.stopPropagation();
            if (children.length > 0) {
                let shouldDismiss = true;
                children.forEach((child)=>{
                    var _child$context;
                    if ((_child$context = child.context) != null && _child$context.open && !child.context.dataRef.current.__escapeKeyBubbles) {
                        shouldDismiss = false;
                        return;
                    }
                });
                if (!shouldDismiss) return;
            }
        }
        onOpenChange(false, (0, $5BFeN.isReactEvent)(event) ? event.nativeEvent : event, 'escape-key');
    });
    const closeOnEscapeKeyDownCapture = (0, $5BFeN.useEffectEvent)((event)=>{
        var _getTarget2;
        const callback = ()=>{
            var _getTarget;
            closeOnEscapeKeyDown(event);
            (_getTarget = (0, $5BFeN.getTarget)(event)) == null || _getTarget.removeEventListener('keydown', callback);
        };
        (_getTarget2 = (0, $5BFeN.getTarget)(event)) == null || _getTarget2.addEventListener('keydown', callback);
    });
    const closeOnPressOutside = (0, $5BFeN.useEffectEvent)((event)=>{
        var _dataRef$current$floa2;
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = dataRef.current.insideReactTree;
        dataRef.current.insideReactTree = false;
        // When click outside is lazy (`click` event), handle dragging.
        // Don't close if:
        // - The click started inside the floating element.
        // - The click ended inside the floating element.
        const endedOrStartedInside = endedOrStartedInsideRef.current;
        endedOrStartedInsideRef.current = false;
        if (outsidePressEvent === 'click' && endedOrStartedInside) return;
        if (insideReactTree) return;
        if (typeof outsidePress === 'function' && !outsidePress(event)) return;
        const target = (0, $5BFeN.getTarget)(event);
        const inertSelector = "[" + $92f1173bc75d6d9e$var$createAttribute('inert') + "]";
        const markers = (0, $5BFeN.getDocument)(elements.floating).querySelectorAll(inertSelector);
        let targetRootAncestor = (0, $g7YZX.isElement)(target) ? target : null;
        while(targetRootAncestor && !(0, $g7YZX.isLastTraversableNode)(targetRootAncestor)){
            const nextParent = (0, $g7YZX.getParentNode)(targetRootAncestor);
            if ((0, $g7YZX.isLastTraversableNode)(nextParent) || !(0, $g7YZX.isElement)(nextParent)) break;
            targetRootAncestor = nextParent;
        }
        // Check if the click occurred on a third-party element injected after the
        // floating element rendered.
        if (markers.length && (0, $g7YZX.isElement)(target) && !(0, $5BFeN.isRootElement)(target) && // Clicked on a direct ancestor (e.g. FloatingOverlay).
        !(0, $5BFeN.contains)(target, elements.floating) && // If the target root element contains none of the markers, then the
        // element was injected after the floating element rendered.
        Array.from(markers).every((marker)=>!(0, $5BFeN.contains)(targetRootAncestor, marker))) return;
        // Check if the click occurred on the scrollbar
        if ((0, $g7YZX.isHTMLElement)(target) && floating) {
            const lastTraversableNode = (0, $g7YZX.isLastTraversableNode)(target);
            const style = (0, $g7YZX.getComputedStyle)(target);
            const scrollRe = /auto|scroll/;
            const isScrollableX = lastTraversableNode || scrollRe.test(style.overflowX);
            const isScrollableY = lastTraversableNode || scrollRe.test(style.overflowY);
            const canScrollX = isScrollableX && target.clientWidth > 0 && target.scrollWidth > target.clientWidth;
            const canScrollY = isScrollableY && target.clientHeight > 0 && target.scrollHeight > target.clientHeight;
            const isRTL = style.direction === 'rtl';
            // Check click position relative to scrollbar.
            // In some browsers it is possible to change the <body> (or window)
            // scrollbar to the left side, but is very rare and is difficult to
            // check for. Plus, for modal dialogs with backdrops, it is more
            // important that the backdrop is checked but not so much the window.
            const pressedVerticalScrollbar = canScrollY && (isRTL ? event.offsetX <= target.offsetWidth - target.clientWidth : event.offsetX > target.clientWidth);
            const pressedHorizontalScrollbar = canScrollX && event.offsetY > target.clientHeight;
            if (pressedVerticalScrollbar || pressedHorizontalScrollbar) return;
        }
        const nodeId = (_dataRef$current$floa2 = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa2.nodeId;
        const targetIsInsideChildren = tree && (0, $5BFeN.getNodeChildren)(tree.nodesRef.current, nodeId).some((node)=>{
            var _node$context;
            return (0, $5BFeN.isEventTargetWithin)(event, (_node$context = node.context) == null ? void 0 : _node$context.elements.floating);
        });
        if ((0, $5BFeN.isEventTargetWithin)(event, elements.floating) || (0, $5BFeN.isEventTargetWithin)(event, elements.domReference) || targetIsInsideChildren) return;
        const children = tree ? (0, $5BFeN.getNodeChildren)(tree.nodesRef.current, nodeId) : [];
        if (children.length > 0) {
            let shouldDismiss = true;
            children.forEach((child)=>{
                var _child$context2;
                if ((_child$context2 = child.context) != null && _child$context2.open && !child.context.dataRef.current.__outsidePressBubbles) {
                    shouldDismiss = false;
                    return;
                }
            });
            if (!shouldDismiss) return;
        }
        onOpenChange(false, event, 'outside-press');
    });
    const closeOnPressOutsideCapture = (0, $5BFeN.useEffectEvent)((event)=>{
        var _getTarget4;
        const callback = ()=>{
            var _getTarget3;
            closeOnPressOutside(event);
            (_getTarget3 = (0, $5BFeN.getTarget)(event)) == null || _getTarget3.removeEventListener(outsidePressEvent, callback);
        };
        (_getTarget4 = (0, $5BFeN.getTarget)(event)) == null || _getTarget4.addEventListener(outsidePressEvent, callback);
    });
    $cQQee.useEffect(()=>{
        if (!open || !enabled) return;
        dataRef.current.__escapeKeyBubbles = escapeKeyBubbles;
        dataRef.current.__outsidePressBubbles = outsidePressBubbles;
        let compositionTimeout = -1;
        function onScroll(event) {
            onOpenChange(false, event, 'ancestor-scroll');
        }
        function handleCompositionStart() {
            window.clearTimeout(compositionTimeout);
            isComposingRef.current = true;
        }
        function handleCompositionEnd() {
            // Safari fires `compositionend` before `keydown`, so we need to wait
            // until the next tick to set `isComposing` to `false`.
            // https://bugs.webkit.org/show_bug.cgi?id=165004
            compositionTimeout = window.setTimeout(()=>{
                isComposingRef.current = false;
            }, // 0ms or 1ms don't work in Safari. 5ms appears to consistently work.
            // Only apply to WebKit for the test to remain 0ms.
            (0, $g7YZX.isWebKit)() ? 5 : 0);
        }
        const doc = (0, $5BFeN.getDocument)(elements.floating);
        if (escapeKey) {
            doc.addEventListener('keydown', escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
            doc.addEventListener('compositionstart', handleCompositionStart);
            doc.addEventListener('compositionend', handleCompositionEnd);
        }
        outsidePress && doc.addEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
        let ancestors = [];
        if (ancestorScroll) {
            if ((0, $g7YZX.isElement)(elements.domReference)) ancestors = (0, $g7YZX.getOverflowAncestors)(elements.domReference);
            if ((0, $g7YZX.isElement)(elements.floating)) ancestors = ancestors.concat((0, $g7YZX.getOverflowAncestors)(elements.floating));
            if (!(0, $g7YZX.isElement)(elements.reference) && elements.reference && elements.reference.contextElement) ancestors = ancestors.concat((0, $g7YZX.getOverflowAncestors)(elements.reference.contextElement));
        }
        // Ignore the visual viewport for scrolling dismissal (allow pinch-zoom)
        ancestors = ancestors.filter((ancestor)=>{
            var _doc$defaultView;
            return ancestor !== ((_doc$defaultView = doc.defaultView) == null ? void 0 : _doc$defaultView.visualViewport);
        });
        ancestors.forEach((ancestor)=>{
            ancestor.addEventListener('scroll', onScroll);
        });
        return ()=>{
            if (escapeKey) {
                doc.removeEventListener('keydown', escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
                doc.removeEventListener('compositionstart', handleCompositionStart);
                doc.removeEventListener('compositionend', handleCompositionEnd);
            }
            outsidePress && doc.removeEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
            ancestors.forEach((ancestor)=>{
                ancestor.removeEventListener('scroll', onScroll);
            });
            window.clearTimeout(compositionTimeout);
        };
    }, [
        dataRef,
        elements,
        escapeKey,
        outsidePress,
        outsidePressEvent,
        open,
        onOpenChange,
        ancestorScroll,
        enabled,
        escapeKeyBubbles,
        outsidePressBubbles,
        closeOnEscapeKeyDown,
        escapeKeyCapture,
        closeOnEscapeKeyDownCapture,
        closeOnPressOutside,
        outsidePressCapture,
        closeOnPressOutsideCapture
    ]);
    $cQQee.useEffect(()=>{
        dataRef.current.insideReactTree = false;
    }, [
        dataRef,
        outsidePress,
        outsidePressEvent
    ]);
    const reference = $cQQee.useMemo(()=>({
            onKeyDown: closeOnEscapeKeyDown,
            ...referencePress && {
                [$92f1173bc75d6d9e$var$bubbleHandlerKeys[referencePressEvent]]: (event)=>{
                    onOpenChange(false, event.nativeEvent, 'reference-press');
                },
                ...referencePressEvent !== 'click' && {
                    onClick (event) {
                        onOpenChange(false, event.nativeEvent, 'reference-press');
                    }
                }
            }
        }), [
        closeOnEscapeKeyDown,
        onOpenChange,
        referencePress,
        referencePressEvent
    ]);
    const floating = $cQQee.useMemo(()=>{
        function setMouseDownOrUpInside(event) {
            if (event.button !== 0) return;
            endedOrStartedInsideRef.current = true;
        }
        return {
            onKeyDown: closeOnEscapeKeyDown,
            onMouseDown: setMouseDownOrUpInside,
            onMouseUp: setMouseDownOrUpInside,
            [$92f1173bc75d6d9e$var$captureHandlerKeys[outsidePressEvent]]: ()=>{
                dataRef.current.insideReactTree = true;
            }
        };
    }, [
        closeOnEscapeKeyDown,
        outsidePressEvent,
        dataRef
    ]);
    return $cQQee.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating
        } : {}, [
        enabled,
        reference,
        floating
    ]);
}
function $92f1173bc75d6d9e$export$1df81146f8ad8e4c(options) {
    const { open: open = false, onOpenChange: onOpenChangeProp, elements: elementsProp } = options;
    const floatingId = $92f1173bc75d6d9e$export$f680877a34711e37();
    const dataRef = $cQQee.useRef({});
    const [events] = $cQQee.useState(()=>$92f1173bc75d6d9e$var$createEventEmitter());
    const nested = $92f1173bc75d6d9e$export$165209eae06d3488() != null;
    const [positionReference, setPositionReference] = $cQQee.useState(elementsProp.reference);
    const onOpenChange = (0, $5BFeN.useEffectEvent)((open, event, reason)=>{
        dataRef.current.openEvent = open ? event : undefined;
        events.emit('openchange', {
            open: open,
            event: event,
            reason: reason,
            nested: nested
        });
        onOpenChangeProp == null || onOpenChangeProp(open, event, reason);
    });
    const refs = $cQQee.useMemo(()=>({
            setPositionReference: setPositionReference
        }), []);
    const elements = $cQQee.useMemo(()=>({
            reference: positionReference || elementsProp.reference || null,
            floating: elementsProp.floating || null,
            domReference: elementsProp.reference
        }), [
        positionReference,
        elementsProp.reference,
        elementsProp.floating
    ]);
    return $cQQee.useMemo(()=>({
            dataRef: dataRef,
            open: open,
            onOpenChange: onOpenChange,
            elements: elements,
            events: events,
            floatingId: floatingId,
            refs: refs
        }), [
        open,
        onOpenChange,
        elements,
        events,
        floatingId,
        refs
    ]);
}
/**
 * Provides data to position a floating element and context to add interactions.
 * @see https://floating-ui.com/docs/useFloating
 */ function $92f1173bc75d6d9e$export$4e02a5c1d08bac65(_temp) {
    var _elementsOption$refer, _elementsOption$float;
    let { elements: elementsOption, ...options } = _temp === void 0 ? {} : _temp;
    const { nodeId: nodeId } = options;
    const internalRootContext = $92f1173bc75d6d9e$export$1df81146f8ad8e4c({
        ...options,
        elements: {
            reference: (_elementsOption$refer = elementsOption == null ? void 0 : elementsOption.reference) != null ? _elementsOption$refer : null,
            floating: (_elementsOption$float = elementsOption == null ? void 0 : elementsOption.floating) != null ? _elementsOption$float : null
        }
    });
    const rootContext = options.rootContext || internalRootContext;
    const computedElements = rootContext.elements;
    const [_domReference, setDomReference] = $cQQee.useState(null);
    const [positionReference, _setPositionReference] = $cQQee.useState(null);
    const optionDomReference = computedElements == null ? void 0 : computedElements.domReference;
    const domReference = optionDomReference || _domReference;
    const domReferenceRef = $cQQee.useRef(null);
    const tree = $92f1173bc75d6d9e$export$db0c2a7c7a2a4f69();
    (0, $5BFeN.useModernLayoutEffect)(()=>{
        if (domReference) domReferenceRef.current = domReference;
    }, [
        domReference
    ]);
    const position = (0, $dA4dV.useFloating)({
        ...options,
        elements: {
            ...computedElements,
            ...positionReference && {
                reference: positionReference
            }
        }
    });
    const setPositionReference = $cQQee.useCallback((node)=>{
        const computedPositionReference = (0, $g7YZX.isElement)(node) ? {
            getBoundingClientRect: ()=>node.getBoundingClientRect(),
            getClientRects: ()=>node.getClientRects(),
            contextElement: node
        } : node;
        // Store the positionReference in state if the DOM reference is specified externally via the
        // `elements.reference` option. This ensures that it won't be overridden on future renders.
        _setPositionReference(computedPositionReference);
        position.refs.setReference(computedPositionReference);
    }, [
        position.refs
    ]);
    const setReference = $cQQee.useCallback((node)=>{
        if ((0, $g7YZX.isElement)(node) || node === null) {
            domReferenceRef.current = node;
            setDomReference(node);
        }
        // Backwards-compatibility for passing a virtual element to `reference`
        // after it has set the DOM reference.
        if ((0, $g7YZX.isElement)(position.refs.reference.current) || position.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
        // `null` to support `positionReference` + an unstable `reference`
        // callback ref.
        node !== null && !(0, $g7YZX.isElement)(node)) position.refs.setReference(node);
    }, [
        position.refs
    ]);
    const refs = $cQQee.useMemo(()=>({
            ...position.refs,
            setReference: setReference,
            setPositionReference: setPositionReference,
            domReference: domReferenceRef
        }), [
        position.refs,
        setReference,
        setPositionReference
    ]);
    const elements = $cQQee.useMemo(()=>({
            ...position.elements,
            domReference: domReference
        }), [
        position.elements,
        domReference
    ]);
    const context = $cQQee.useMemo(()=>({
            ...position,
            ...rootContext,
            refs: refs,
            elements: elements,
            nodeId: nodeId
        }), [
        position,
        refs,
        elements,
        nodeId,
        rootContext
    ]);
    (0, $5BFeN.useModernLayoutEffect)(()=>{
        rootContext.dataRef.current.floatingContext = context;
        const node = tree == null ? void 0 : tree.nodesRef.current.find((node)=>node.id === nodeId);
        if (node) node.context = context;
    });
    return $cQQee.useMemo(()=>({
            ...position,
            context: context,
            refs: refs,
            elements: elements
        }), [
        position,
        refs,
        elements,
        context
    ]);
}
function $92f1173bc75d6d9e$var$isMacSafari() {
    return (0, $5BFeN.isMac)() && (0, $5BFeN.isSafari)();
}
/**
 * Opens the floating element while the reference element has focus, like CSS
 * `:focus`.
 * @see https://floating-ui.com/docs/useFocus
 */ function $92f1173bc75d6d9e$export$f8168d8dd8fd66e6(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, events: events, dataRef: dataRef, elements: elements } = context;
    const { enabled: enabled = true, visibleOnly: visibleOnly = true } = props;
    const blockFocusRef = $cQQee.useRef(false);
    const timeoutRef = $cQQee.useRef(-1);
    const keyboardModalityRef = $cQQee.useRef(true);
    $cQQee.useEffect(()=>{
        if (!enabled) return;
        const win = (0, $g7YZX.getWindow)(elements.domReference);
        // If the reference was focused and the user left the tab/window, and the
        // floating element was not open, the focus should be blocked when they
        // return to the tab/window.
        function onBlur() {
            if (!open && (0, $g7YZX.isHTMLElement)(elements.domReference) && elements.domReference === (0, $5BFeN.activeElement)((0, $5BFeN.getDocument)(elements.domReference))) blockFocusRef.current = true;
        }
        function onKeyDown() {
            keyboardModalityRef.current = true;
        }
        function onPointerDown() {
            keyboardModalityRef.current = false;
        }
        win.addEventListener('blur', onBlur);
        if ($92f1173bc75d6d9e$var$isMacSafari()) {
            win.addEventListener('keydown', onKeyDown, true);
            win.addEventListener('pointerdown', onPointerDown, true);
        }
        return ()=>{
            win.removeEventListener('blur', onBlur);
            if ($92f1173bc75d6d9e$var$isMacSafari()) {
                win.removeEventListener('keydown', onKeyDown, true);
                win.removeEventListener('pointerdown', onPointerDown, true);
            }
        };
    }, [
        elements.domReference,
        open,
        enabled
    ]);
    $cQQee.useEffect(()=>{
        if (!enabled) return;
        function onOpenChange(_ref) {
            let { reason: reason } = _ref;
            if (reason === 'reference-press' || reason === 'escape-key') blockFocusRef.current = true;
        }
        events.on('openchange', onOpenChange);
        return ()=>{
            events.off('openchange', onOpenChange);
        };
    }, [
        events,
        enabled
    ]);
    $cQQee.useEffect(()=>{
        return ()=>{
            $92f1173bc75d6d9e$var$clearTimeoutIfSet(timeoutRef);
        };
    }, []);
    const reference = $cQQee.useMemo(()=>({
            onMouseLeave () {
                blockFocusRef.current = false;
            },
            onFocus (event) {
                if (blockFocusRef.current) return;
                const target = (0, $5BFeN.getTarget)(event.nativeEvent);
                if (visibleOnly && (0, $g7YZX.isElement)(target)) {
                    // Safari fails to match `:focus-visible` if focus was initially
                    // outside the document.
                    if ($92f1173bc75d6d9e$var$isMacSafari() && !event.relatedTarget) {
                        if (!keyboardModalityRef.current && !(0, $5BFeN.isTypeableElement)(target)) return;
                    } else if (!(0, $5BFeN.matchesFocusVisible)(target)) return;
                }
                onOpenChange(true, event.nativeEvent, 'focus');
            },
            onBlur (event) {
                blockFocusRef.current = false;
                const relatedTarget = event.relatedTarget;
                const nativeEvent = event.nativeEvent;
                // Hit the non-modal focus management portal guard. Focus will be
                // moved into the floating element immediately after.
                const movedToFocusGuard = (0, $g7YZX.isElement)(relatedTarget) && relatedTarget.hasAttribute($92f1173bc75d6d9e$var$createAttribute('focus-guard')) && relatedTarget.getAttribute('data-type') === 'outside';
                // Wait for the window blur listener to fire.
                timeoutRef.current = window.setTimeout(()=>{
                    var _dataRef$current$floa;
                    const activeEl = (0, $5BFeN.activeElement)(elements.domReference ? elements.domReference.ownerDocument : document);
                    // Focus left the page, keep it open.
                    if (!relatedTarget && activeEl === elements.domReference) return;
                    // When focusing the reference element (e.g. regular click), then
                    // clicking into the floating element, prevent it from hiding.
                    // Note: it must be focusable, e.g. `tabindex="-1"`.
                    // We can not rely on relatedTarget to point to the correct element
                    // as it will only point to the shadow host of the newly focused element
                    // and not the element that actually has received focus if it is located
                    // inside a shadow root.
                    if ((0, $5BFeN.contains)((_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.refs.floating.current, activeEl) || (0, $5BFeN.contains)(elements.domReference, activeEl) || movedToFocusGuard) return;
                    onOpenChange(false, nativeEvent, 'focus');
                });
            }
        }), [
        dataRef,
        elements.domReference,
        onOpenChange,
        visibleOnly
    ]);
    return $cQQee.useMemo(()=>enabled ? {
            reference: reference
        } : {}, [
        enabled,
        reference
    ]);
}
function $92f1173bc75d6d9e$var$mergeProps(userProps, propsList, elementKey) {
    const map = new Map();
    const isItem = elementKey === 'item';
    let domUserProps = userProps;
    if (isItem && userProps) {
        const { [$92f1173bc75d6d9e$var$ACTIVE_KEY]: _, [$92f1173bc75d6d9e$var$SELECTED_KEY]: __, ...validProps } = userProps;
        domUserProps = validProps;
    }
    return {
        ...elementKey === 'floating' && {
            tabIndex: -1,
            [$92f1173bc75d6d9e$var$FOCUSABLE_ATTRIBUTE]: ''
        },
        ...domUserProps,
        ...propsList.map((value)=>{
            const propsOrGetProps = value ? value[elementKey] : null;
            if (typeof propsOrGetProps === 'function') return userProps ? propsOrGetProps(userProps) : null;
            return propsOrGetProps;
        }).concat(userProps).reduce((acc, props)=>{
            if (!props) return acc;
            Object.entries(props).forEach((_ref)=>{
                let [key, value] = _ref;
                if (isItem && [
                    $92f1173bc75d6d9e$var$ACTIVE_KEY,
                    $92f1173bc75d6d9e$var$SELECTED_KEY
                ].includes(key)) return;
                if (key.indexOf('on') === 0) {
                    if (!map.has(key)) map.set(key, []);
                    if (typeof value === 'function') {
                        var _map$get;
                        (_map$get = map.get(key)) == null || _map$get.push(value);
                        acc[key] = function() {
                            var _map$get2;
                            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                            return (_map$get2 = map.get(key)) == null ? void 0 : _map$get2.map((fn)=>fn(...args)).find((val)=>val !== undefined);
                        };
                    }
                } else acc[key] = value;
            });
            return acc;
        }, {})
    };
}
/**
 * Merges an array of interaction hooks' props into prop getters, allowing
 * event handler functions to be composed together without overwriting one
 * another.
 * @see https://floating-ui.com/docs/useInteractions
 */ function $92f1173bc75d6d9e$export$a519f7794e446ddd(propsList) {
    if (propsList === void 0) propsList = [];
    const referenceDeps = propsList.map((key)=>key == null ? void 0 : key.reference);
    const floatingDeps = propsList.map((key)=>key == null ? void 0 : key.floating);
    const itemDeps = propsList.map((key)=>key == null ? void 0 : key.item);
    const getReferenceProps = $cQQee.useCallback((userProps)=>$92f1173bc75d6d9e$var$mergeProps(userProps, propsList, 'reference'), // eslint-disable-next-line react-hooks/exhaustive-deps
    referenceDeps);
    const getFloatingProps = $cQQee.useCallback((userProps)=>$92f1173bc75d6d9e$var$mergeProps(userProps, propsList, 'floating'), // eslint-disable-next-line react-hooks/exhaustive-deps
    floatingDeps);
    const getItemProps = $cQQee.useCallback((userProps)=>$92f1173bc75d6d9e$var$mergeProps(userProps, propsList, 'item'), // eslint-disable-next-line react-hooks/exhaustive-deps
    itemDeps);
    return $cQQee.useMemo(()=>({
            getReferenceProps: getReferenceProps,
            getFloatingProps: getFloatingProps,
            getItemProps: getItemProps
        }), [
        getReferenceProps,
        getFloatingProps,
        getItemProps
    ]);
}
const $92f1173bc75d6d9e$var$ESCAPE = 'Escape';
function $92f1173bc75d6d9e$var$doSwitch(orientation, vertical, horizontal) {
    switch(orientation){
        case 'vertical':
            return vertical;
        case 'horizontal':
            return horizontal;
        default:
            return vertical || horizontal;
    }
}
function $92f1173bc75d6d9e$var$isMainOrientationKey(key, orientation) {
    const vertical = key === $92f1173bc75d6d9e$var$ARROW_UP || key === $92f1173bc75d6d9e$var$ARROW_DOWN;
    const horizontal = key === $92f1173bc75d6d9e$var$ARROW_LEFT || key === $92f1173bc75d6d9e$var$ARROW_RIGHT;
    return $92f1173bc75d6d9e$var$doSwitch(orientation, vertical, horizontal);
}
function $92f1173bc75d6d9e$var$isMainOrientationToEndKey(key, orientation, rtl) {
    const vertical = key === $92f1173bc75d6d9e$var$ARROW_DOWN;
    const horizontal = rtl ? key === $92f1173bc75d6d9e$var$ARROW_LEFT : key === $92f1173bc75d6d9e$var$ARROW_RIGHT;
    return $92f1173bc75d6d9e$var$doSwitch(orientation, vertical, horizontal) || key === 'Enter' || key === ' ' || key === '';
}
function $92f1173bc75d6d9e$var$isCrossOrientationOpenKey(key, orientation, rtl) {
    const vertical = rtl ? key === $92f1173bc75d6d9e$var$ARROW_LEFT : key === $92f1173bc75d6d9e$var$ARROW_RIGHT;
    const horizontal = key === $92f1173bc75d6d9e$var$ARROW_DOWN;
    return $92f1173bc75d6d9e$var$doSwitch(orientation, vertical, horizontal);
}
function $92f1173bc75d6d9e$var$isCrossOrientationCloseKey(key, orientation, rtl, cols) {
    const vertical = rtl ? key === $92f1173bc75d6d9e$var$ARROW_RIGHT : key === $92f1173bc75d6d9e$var$ARROW_LEFT;
    const horizontal = key === $92f1173bc75d6d9e$var$ARROW_UP;
    if (orientation === 'both' || orientation === 'horizontal' && cols && cols > 1) return key === $92f1173bc75d6d9e$var$ESCAPE;
    return $92f1173bc75d6d9e$var$doSwitch(orientation, vertical, horizontal);
}
/**
 * Adds arrow key-based navigation of a list of items, either using real DOM
 * focus or virtual focus.
 * @see https://floating-ui.com/docs/useListNavigation
 */ function $92f1173bc75d6d9e$export$b5d22cac4ad33f40(context, props) {
    const { open: open, onOpenChange: onOpenChange, elements: elements, floatingId: floatingId } = context;
    const { listRef: listRef, activeIndex: activeIndex, onNavigate: unstable_onNavigate = ()=>{}, enabled: enabled = true, selectedIndex: selectedIndex = null, allowEscape: allowEscape = false, loop: loop = false, nested: nested = false, rtl: rtl = false, virtual: virtual = false, focusItemOnOpen: focusItemOnOpen = 'auto', focusItemOnHover: focusItemOnHover = true, openOnArrowKeyDown: openOnArrowKeyDown = true, disabledIndices: disabledIndices, orientation: orientation = 'vertical', parentOrientation: parentOrientation, cols: cols = 1, scrollItemIntoView: scrollItemIntoView = true, virtualItemRef: virtualItemRef, itemSizes: itemSizes, dense: dense = false } = props;
    const floatingFocusElement = (0, $5BFeN.getFloatingFocusElement)(elements.floating);
    const floatingFocusElementRef = (0, $5BFeN.useLatestRef)(floatingFocusElement);
    const parentId = $92f1173bc75d6d9e$export$165209eae06d3488();
    const tree = $92f1173bc75d6d9e$export$db0c2a7c7a2a4f69();
    (0, $5BFeN.useModernLayoutEffect)(()=>{
        context.dataRef.current.orientation = orientation;
    }, [
        context,
        orientation
    ]);
    const onNavigate = (0, $5BFeN.useEffectEvent)(()=>{
        unstable_onNavigate(indexRef.current === -1 ? null : indexRef.current);
    });
    const typeableComboboxReference = (0, $5BFeN.isTypeableCombobox)(elements.domReference);
    const focusItemOnOpenRef = $cQQee.useRef(focusItemOnOpen);
    const indexRef = $cQQee.useRef(selectedIndex != null ? selectedIndex : -1);
    const keyRef = $cQQee.useRef(null);
    const isPointerModalityRef = $cQQee.useRef(true);
    const previousOnNavigateRef = $cQQee.useRef(onNavigate);
    const previousMountedRef = $cQQee.useRef(!!elements.floating);
    const previousOpenRef = $cQQee.useRef(open);
    const forceSyncFocusRef = $cQQee.useRef(false);
    const forceScrollIntoViewRef = $cQQee.useRef(false);
    const disabledIndicesRef = (0, $5BFeN.useLatestRef)(disabledIndices);
    const latestOpenRef = (0, $5BFeN.useLatestRef)(open);
    const scrollItemIntoViewRef = (0, $5BFeN.useLatestRef)(scrollItemIntoView);
    const selectedIndexRef = (0, $5BFeN.useLatestRef)(selectedIndex);
    const [activeId, setActiveId] = $cQQee.useState();
    const [virtualId, setVirtualId] = $cQQee.useState();
    const focusItem = (0, $5BFeN.useEffectEvent)(()=>{
        function runFocus(item) {
            if (virtual) {
                var _item$id;
                if ((_item$id = item.id) != null && _item$id.endsWith('-fui-option')) item.id = floatingId + "-" + Math.random().toString(16).slice(2, 10);
                setActiveId(item.id);
                tree == null || tree.events.emit('virtualfocus', item);
                if (virtualItemRef) virtualItemRef.current = item;
            } else $92f1173bc75d6d9e$var$enqueueFocus(item, {
                sync: forceSyncFocusRef.current,
                preventScroll: true
            });
        }
        const initialItem = listRef.current[indexRef.current];
        const forceScrollIntoView = forceScrollIntoViewRef.current;
        if (initialItem) runFocus(initialItem);
        const scheduler = forceSyncFocusRef.current ? (v)=>v() : requestAnimationFrame;
        scheduler(()=>{
            const waitedItem = listRef.current[indexRef.current] || initialItem;
            if (!waitedItem) return;
            if (!initialItem) runFocus(waitedItem);
            const scrollIntoViewOptions = scrollItemIntoViewRef.current;
            const shouldScrollIntoView = scrollIntoViewOptions && item && (forceScrollIntoView || !isPointerModalityRef.current);
            if (shouldScrollIntoView) // JSDOM doesn't support `.scrollIntoView()` but it's widely supported
            // by all browsers.
            waitedItem.scrollIntoView == null || waitedItem.scrollIntoView(typeof scrollIntoViewOptions === 'boolean' ? {
                block: 'nearest',
                inline: 'nearest'
            } : scrollIntoViewOptions);
        });
    });
    // Sync `selectedIndex` to be the `activeIndex` upon opening the floating
    // element. Also, reset `activeIndex` upon closing the floating element.
    (0, $5BFeN.useModernLayoutEffect)(()=>{
        if (!enabled) return;
        if (open && elements.floating) {
            if (focusItemOnOpenRef.current && selectedIndex != null) {
                // Regardless of the pointer modality, we want to ensure the selected
                // item comes into view when the floating element is opened.
                forceScrollIntoViewRef.current = true;
                indexRef.current = selectedIndex;
                onNavigate();
            }
        } else if (previousMountedRef.current) {
            // Since the user can specify `onNavigate` conditionally
            // (onNavigate: open ? setActiveIndex : setSelectedIndex),
            // we store and call the previous function.
            indexRef.current = -1;
            previousOnNavigateRef.current();
        }
    }, [
        enabled,
        open,
        elements.floating,
        selectedIndex,
        onNavigate
    ]);
    // Sync `activeIndex` to be the focused item while the floating element is
    // open.
    (0, $5BFeN.useModernLayoutEffect)(()=>{
        if (!enabled) return;
        if (!open) return;
        if (!elements.floating) return;
        if (activeIndex == null) {
            forceSyncFocusRef.current = false;
            if (selectedIndexRef.current != null) return;
            // Reset while the floating element was open (e.g. the list changed).
            if (previousMountedRef.current) {
                indexRef.current = -1;
                focusItem();
            }
            // Initial sync.
            if ((!previousOpenRef.current || !previousMountedRef.current) && focusItemOnOpenRef.current && (keyRef.current != null || focusItemOnOpenRef.current === true && keyRef.current == null)) {
                let runs = 0;
                const waitForListPopulated = ()=>{
                    if (listRef.current[0] == null) {
                        // Avoid letting the browser paint if possible on the first try,
                        // otherwise use rAF. Don't try more than twice, since something
                        // is wrong otherwise.
                        if (runs < 2) {
                            const scheduler = runs ? requestAnimationFrame : queueMicrotask;
                            scheduler(waitForListPopulated);
                        }
                        runs++;
                    } else {
                        indexRef.current = keyRef.current == null || $92f1173bc75d6d9e$var$isMainOrientationToEndKey(keyRef.current, orientation, rtl) || nested ? (0, $5BFeN.getMinListIndex)(listRef, disabledIndicesRef.current) : (0, $5BFeN.getMaxListIndex)(listRef, disabledIndicesRef.current);
                        keyRef.current = null;
                        onNavigate();
                    }
                };
                waitForListPopulated();
            }
        } else if (!(0, $5BFeN.isIndexOutOfListBounds)(listRef, activeIndex)) {
            indexRef.current = activeIndex;
            focusItem();
            forceScrollIntoViewRef.current = false;
        }
    }, [
        enabled,
        open,
        elements.floating,
        activeIndex,
        selectedIndexRef,
        nested,
        listRef,
        orientation,
        rtl,
        onNavigate,
        focusItem,
        disabledIndicesRef
    ]);
    // Ensure the parent floating element has focus when a nested child closes
    // to allow arrow key navigation to work after the pointer leaves the child.
    (0, $5BFeN.useModernLayoutEffect)(()=>{
        var _nodes$find;
        if (!enabled || elements.floating || !tree || virtual || !previousMountedRef.current) return;
        const nodes = tree.nodesRef.current;
        const parent = (_nodes$find = nodes.find((node)=>node.id === parentId)) == null || (_nodes$find = _nodes$find.context) == null ? void 0 : _nodes$find.elements.floating;
        const activeEl = (0, $5BFeN.activeElement)((0, $5BFeN.getDocument)(elements.floating));
        const treeContainsActiveEl = nodes.some((node)=>node.context && (0, $5BFeN.contains)(node.context.elements.floating, activeEl));
        if (parent && !treeContainsActiveEl && isPointerModalityRef.current) parent.focus({
            preventScroll: true
        });
    }, [
        enabled,
        elements.floating,
        tree,
        parentId,
        virtual
    ]);
    (0, $5BFeN.useModernLayoutEffect)(()=>{
        if (!enabled) return;
        if (!tree) return;
        if (!virtual) return;
        if (parentId) return;
        function handleVirtualFocus(item) {
            setVirtualId(item.id);
            if (virtualItemRef) virtualItemRef.current = item;
        }
        tree.events.on('virtualfocus', handleVirtualFocus);
        return ()=>{
            tree.events.off('virtualfocus', handleVirtualFocus);
        };
    }, [
        enabled,
        tree,
        virtual,
        parentId,
        virtualItemRef
    ]);
    (0, $5BFeN.useModernLayoutEffect)(()=>{
        previousOnNavigateRef.current = onNavigate;
        previousOpenRef.current = open;
        previousMountedRef.current = !!elements.floating;
    });
    (0, $5BFeN.useModernLayoutEffect)(()=>{
        if (!open) {
            keyRef.current = null;
            focusItemOnOpenRef.current = focusItemOnOpen;
        }
    }, [
        open,
        focusItemOnOpen
    ]);
    const hasActiveIndex = activeIndex != null;
    const item = $cQQee.useMemo(()=>{
        function syncCurrentTarget(currentTarget) {
            if (!latestOpenRef.current) return;
            const index = listRef.current.indexOf(currentTarget);
            if (index !== -1 && indexRef.current !== index) {
                indexRef.current = index;
                onNavigate();
            }
        }
        const props = {
            onFocus (_ref) {
                let { currentTarget: currentTarget } = _ref;
                forceSyncFocusRef.current = true;
                syncCurrentTarget(currentTarget);
            },
            onClick: (_ref2)=>{
                let { currentTarget: currentTarget } = _ref2;
                return currentTarget.focus({
                    preventScroll: true
                });
            },
            // Safari
            onMouseMove (_ref3) {
                let { currentTarget: currentTarget } = _ref3;
                forceSyncFocusRef.current = true;
                forceScrollIntoViewRef.current = false;
                if (focusItemOnHover) syncCurrentTarget(currentTarget);
            },
            onPointerLeave (_ref4) {
                let { pointerType: pointerType } = _ref4;
                if (!isPointerModalityRef.current || pointerType === 'touch') return;
                forceSyncFocusRef.current = true;
                if (!focusItemOnHover) return;
                indexRef.current = -1;
                onNavigate();
                if (!virtual) {
                    var _floatingFocusElement;
                    (_floatingFocusElement = floatingFocusElementRef.current) == null || _floatingFocusElement.focus({
                        preventScroll: true
                    });
                }
            }
        };
        return props;
    }, [
        latestOpenRef,
        floatingFocusElementRef,
        focusItemOnHover,
        listRef,
        onNavigate,
        virtual
    ]);
    const getParentOrientation = $cQQee.useCallback(()=>{
        var _tree$nodesRef$curren;
        return parentOrientation != null ? parentOrientation : tree == null || (_tree$nodesRef$curren = tree.nodesRef.current.find((node)=>node.id === parentId)) == null || (_tree$nodesRef$curren = _tree$nodesRef$curren.context) == null || (_tree$nodesRef$curren = _tree$nodesRef$curren.dataRef) == null ? void 0 : _tree$nodesRef$curren.current.orientation;
    }, [
        parentId,
        tree,
        parentOrientation
    ]);
    const commonOnKeyDown = (0, $5BFeN.useEffectEvent)((event)=>{
        isPointerModalityRef.current = false;
        forceSyncFocusRef.current = true;
        // When composing a character, Chrome fires ArrowDown twice. Firefox/Safari
        // don't appear to suffer from this. `event.isComposing` is avoided due to
        // Safari not supporting it properly (although it's not needed in the first
        // place for Safari, just avoiding any possible issues).
        if (event.which === 229) return;
        // If the floating element is animating out, ignore navigation. Otherwise,
        // the `activeIndex` gets set to 0 despite not being open so the next time
        // the user ArrowDowns, the first item won't be focused.
        if (!latestOpenRef.current && event.currentTarget === floatingFocusElementRef.current) return;
        if (nested && $92f1173bc75d6d9e$var$isCrossOrientationCloseKey(event.key, orientation, rtl, cols)) {
            // If the nested list's close key is also the parent navigation key,
            // let the parent navigate. Otherwise, stop propagating the event.
            if (!$92f1173bc75d6d9e$var$isMainOrientationKey(event.key, getParentOrientation())) (0, $5BFeN.stopEvent)(event);
            onOpenChange(false, event.nativeEvent, 'list-navigation');
            if ((0, $g7YZX.isHTMLElement)(elements.domReference)) {
                if (virtual) tree == null || tree.events.emit('virtualfocus', elements.domReference);
                else elements.domReference.focus();
            }
            return;
        }
        const currentIndex = indexRef.current;
        const minIndex = (0, $5BFeN.getMinListIndex)(listRef, disabledIndices);
        const maxIndex = (0, $5BFeN.getMaxListIndex)(listRef, disabledIndices);
        if (!typeableComboboxReference) {
            if (event.key === 'Home') {
                (0, $5BFeN.stopEvent)(event);
                indexRef.current = minIndex;
                onNavigate();
            }
            if (event.key === 'End') {
                (0, $5BFeN.stopEvent)(event);
                indexRef.current = maxIndex;
                onNavigate();
            }
        }
        // Grid navigation.
        if (cols > 1) {
            const sizes = itemSizes || Array.from({
                length: listRef.current.length
            }, ()=>({
                    width: 1,
                    height: 1
                }));
            // To calculate movements on the grid, we use hypothetical cell indices
            // as if every item was 1x1, then convert back to real indices.
            const cellMap = (0, $5BFeN.createGridCellMap)(sizes, cols, dense);
            const minGridIndex = cellMap.findIndex((index)=>index != null && !(0, $5BFeN.isListIndexDisabled)(listRef, index, disabledIndices));
            // last enabled index
            const maxGridIndex = cellMap.reduce((foundIndex, index, cellIndex)=>index != null && !(0, $5BFeN.isListIndexDisabled)(listRef, index, disabledIndices) ? cellIndex : foundIndex, -1);
            const index = cellMap[(0, $5BFeN.getGridNavigatedIndex)({
                current: cellMap.map((itemIndex)=>itemIndex != null ? listRef.current[itemIndex] : null)
            }, {
                event: event,
                orientation: orientation,
                loop: loop,
                rtl: rtl,
                cols: cols,
                // treat undefined (empty grid spaces) as disabled indices so we
                // don't end up in them
                disabledIndices: (0, $5BFeN.getGridCellIndices)([
                    ...(typeof disabledIndices !== 'function' ? disabledIndices : null) || listRef.current.map((_, index)=>(0, $5BFeN.isListIndexDisabled)(listRef, index, disabledIndices) ? index : undefined),
                    undefined
                ], cellMap),
                minIndex: minGridIndex,
                maxIndex: maxGridIndex,
                prevIndex: (0, $5BFeN.getGridCellIndexOfCorner)(indexRef.current > maxIndex ? minIndex : indexRef.current, sizes, cellMap, cols, // use a corner matching the edge closest to the direction
                // we're moving in so we don't end up in the same item. Prefer
                // top/left over bottom/right.
                event.key === $92f1173bc75d6d9e$var$ARROW_DOWN ? 'bl' : event.key === (rtl ? $92f1173bc75d6d9e$var$ARROW_LEFT : $92f1173bc75d6d9e$var$ARROW_RIGHT) ? 'tr' : 'tl'),
                stopEvent: true
            })];
            if (index != null) {
                indexRef.current = index;
                onNavigate();
            }
            if (orientation === 'both') return;
        }
        if ($92f1173bc75d6d9e$var$isMainOrientationKey(event.key, orientation)) {
            (0, $5BFeN.stopEvent)(event);
            // Reset the index if no item is focused.
            if (open && !virtual && (0, $5BFeN.activeElement)(event.currentTarget.ownerDocument) === event.currentTarget) {
                indexRef.current = $92f1173bc75d6d9e$var$isMainOrientationToEndKey(event.key, orientation, rtl) ? minIndex : maxIndex;
                onNavigate();
                return;
            }
            if ($92f1173bc75d6d9e$var$isMainOrientationToEndKey(event.key, orientation, rtl)) {
                if (loop) indexRef.current = currentIndex >= maxIndex ? allowEscape && currentIndex !== listRef.current.length ? -1 : minIndex : (0, $5BFeN.findNonDisabledListIndex)(listRef, {
                    startingIndex: currentIndex,
                    disabledIndices: disabledIndices
                });
                else indexRef.current = Math.min(maxIndex, (0, $5BFeN.findNonDisabledListIndex)(listRef, {
                    startingIndex: currentIndex,
                    disabledIndices: disabledIndices
                }));
            } else if (loop) indexRef.current = currentIndex <= minIndex ? allowEscape && currentIndex !== -1 ? listRef.current.length : maxIndex : (0, $5BFeN.findNonDisabledListIndex)(listRef, {
                startingIndex: currentIndex,
                decrement: true,
                disabledIndices: disabledIndices
            });
            else indexRef.current = Math.max(minIndex, (0, $5BFeN.findNonDisabledListIndex)(listRef, {
                startingIndex: currentIndex,
                decrement: true,
                disabledIndices: disabledIndices
            }));
            if ((0, $5BFeN.isIndexOutOfListBounds)(listRef, indexRef.current)) indexRef.current = -1;
            onNavigate();
        }
    });
    const ariaActiveDescendantProp = $cQQee.useMemo(()=>{
        return virtual && open && hasActiveIndex && {
            'aria-activedescendant': virtualId || activeId
        };
    }, [
        virtual,
        open,
        hasActiveIndex,
        virtualId,
        activeId
    ]);
    const floating = $cQQee.useMemo(()=>{
        return {
            'aria-orientation': orientation === 'both' ? undefined : orientation,
            ...!typeableComboboxReference ? ariaActiveDescendantProp : {},
            onKeyDown: commonOnKeyDown,
            onPointerMove () {
                isPointerModalityRef.current = true;
            }
        };
    }, [
        ariaActiveDescendantProp,
        commonOnKeyDown,
        orientation,
        typeableComboboxReference
    ]);
    const reference = $cQQee.useMemo(()=>{
        function checkVirtualMouse(event) {
            if (focusItemOnOpen === 'auto' && (0, $5BFeN.isVirtualClick)(event.nativeEvent)) focusItemOnOpenRef.current = true;
        }
        function checkVirtualPointer(event) {
            // `pointerdown` fires first, reset the state then perform the checks.
            focusItemOnOpenRef.current = focusItemOnOpen;
            if (focusItemOnOpen === 'auto' && (0, $5BFeN.isVirtualPointerEvent)(event.nativeEvent)) focusItemOnOpenRef.current = true;
        }
        return {
            ...ariaActiveDescendantProp,
            onKeyDown (event) {
                isPointerModalityRef.current = false;
                const isArrowKey = event.key.startsWith('Arrow');
                const isHomeOrEndKey = [
                    'Home',
                    'End'
                ].includes(event.key);
                const isMoveKey = isArrowKey || isHomeOrEndKey;
                const isCrossOpenKey = $92f1173bc75d6d9e$var$isCrossOrientationOpenKey(event.key, orientation, rtl);
                const isCrossCloseKey = $92f1173bc75d6d9e$var$isCrossOrientationCloseKey(event.key, orientation, rtl, cols);
                const isParentCrossOpenKey = $92f1173bc75d6d9e$var$isCrossOrientationOpenKey(event.key, getParentOrientation(), rtl);
                const isMainKey = $92f1173bc75d6d9e$var$isMainOrientationKey(event.key, orientation);
                const isNavigationKey = (nested ? isParentCrossOpenKey : isMainKey) || event.key === 'Enter' || event.key.trim() === '';
                if (virtual && open) {
                    const rootNode = tree == null ? void 0 : tree.nodesRef.current.find((node)=>node.parentId == null);
                    const deepestNode = tree && rootNode ? (0, $5BFeN.getDeepestNode)(tree.nodesRef.current, rootNode.id) : null;
                    if (isMoveKey && deepestNode && virtualItemRef) {
                        const eventObject = new KeyboardEvent('keydown', {
                            key: event.key,
                            bubbles: true
                        });
                        if (isCrossOpenKey || isCrossCloseKey) {
                            var _deepestNode$context, _deepestNode$context2;
                            const isCurrentTarget = ((_deepestNode$context = deepestNode.context) == null ? void 0 : _deepestNode$context.elements.domReference) === event.currentTarget;
                            const dispatchItem = isCrossCloseKey && !isCurrentTarget ? (_deepestNode$context2 = deepestNode.context) == null ? void 0 : _deepestNode$context2.elements.domReference : isCrossOpenKey ? listRef.current.find((item)=>(item == null ? void 0 : item.id) === activeId) : null;
                            if (dispatchItem) {
                                (0, $5BFeN.stopEvent)(event);
                                dispatchItem.dispatchEvent(eventObject);
                                setVirtualId(undefined);
                            }
                        }
                        if ((isMainKey || isHomeOrEndKey) && deepestNode.context) {
                            if (deepestNode.context.open && deepestNode.parentId && event.currentTarget !== deepestNode.context.elements.domReference) {
                                var _deepestNode$context$;
                                (0, $5BFeN.stopEvent)(event);
                                (_deepestNode$context$ = deepestNode.context.elements.domReference) == null || _deepestNode$context$.dispatchEvent(eventObject);
                                return;
                            }
                        }
                    }
                    return commonOnKeyDown(event);
                }
                // If a floating element should not open on arrow key down, avoid
                // setting `activeIndex` while it's closed.
                if (!open && !openOnArrowKeyDown && isArrowKey) return;
                if (isNavigationKey) {
                    const isParentMainKey = $92f1173bc75d6d9e$var$isMainOrientationKey(event.key, getParentOrientation());
                    keyRef.current = nested && isParentMainKey ? null : event.key;
                }
                if (nested) {
                    if (isParentCrossOpenKey) {
                        (0, $5BFeN.stopEvent)(event);
                        if (open) {
                            indexRef.current = (0, $5BFeN.getMinListIndex)(listRef, disabledIndicesRef.current);
                            onNavigate();
                        } else onOpenChange(true, event.nativeEvent, 'list-navigation');
                    }
                    return;
                }
                if (isMainKey) {
                    if (selectedIndex != null) indexRef.current = selectedIndex;
                    (0, $5BFeN.stopEvent)(event);
                    if (!open && openOnArrowKeyDown) onOpenChange(true, event.nativeEvent, 'list-navigation');
                    else commonOnKeyDown(event);
                    if (open) onNavigate();
                }
            },
            onFocus () {
                if (open && !virtual) {
                    indexRef.current = -1;
                    onNavigate();
                }
            },
            onPointerDown: checkVirtualPointer,
            onPointerEnter: checkVirtualPointer,
            onMouseDown: checkVirtualMouse,
            onClick: checkVirtualMouse
        };
    }, [
        activeId,
        ariaActiveDescendantProp,
        cols,
        commonOnKeyDown,
        disabledIndicesRef,
        focusItemOnOpen,
        listRef,
        nested,
        onNavigate,
        onOpenChange,
        open,
        openOnArrowKeyDown,
        orientation,
        getParentOrientation,
        rtl,
        selectedIndex,
        tree,
        virtual,
        virtualItemRef
    ]);
    return $cQQee.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating,
            item: item
        } : {}, [
        enabled,
        reference,
        floating,
        item
    ]);
}
const $92f1173bc75d6d9e$var$componentRoleToAriaRoleMap = /*#__PURE__*/ new Map([
    [
        'select',
        'listbox'
    ],
    [
        'combobox',
        'listbox'
    ],
    [
        'label',
        false
    ]
]);
/**
 * Adds base screen reader props to the reference and floating elements for a
 * given floating element `role`.
 * @see https://floating-ui.com/docs/useRole
 */ function $92f1173bc75d6d9e$export$f66572793fa256a1(context, props) {
    var _elements$domReferenc, _componentRoleToAriaR;
    if (props === void 0) props = {};
    const { open: open, elements: elements, floatingId: defaultFloatingId } = context;
    const { enabled: enabled = true, role: role = 'dialog' } = props;
    const defaultReferenceId = $92f1173bc75d6d9e$export$f680877a34711e37();
    const referenceId = ((_elements$domReferenc = elements.domReference) == null ? void 0 : _elements$domReferenc.id) || defaultReferenceId;
    const floatingId = $cQQee.useMemo(()=>{
        var _getFloatingFocusElem;
        return ((_getFloatingFocusElem = (0, $5BFeN.getFloatingFocusElement)(elements.floating)) == null ? void 0 : _getFloatingFocusElem.id) || defaultFloatingId;
    }, [
        elements.floating,
        defaultFloatingId
    ]);
    const ariaRole = (_componentRoleToAriaR = $92f1173bc75d6d9e$var$componentRoleToAriaRoleMap.get(role)) != null ? _componentRoleToAriaR : role;
    const parentId = $92f1173bc75d6d9e$export$165209eae06d3488();
    const isNested = parentId != null;
    const reference = $cQQee.useMemo(()=>{
        if (ariaRole === 'tooltip' || role === 'label') return {
            ["aria-" + (role === 'label' ? 'labelledby' : 'describedby')]: open ? floatingId : undefined
        };
        return {
            'aria-expanded': open ? 'true' : 'false',
            'aria-haspopup': ariaRole === 'alertdialog' ? 'dialog' : ariaRole,
            'aria-controls': open ? floatingId : undefined,
            ...ariaRole === 'listbox' && {
                role: 'combobox'
            },
            ...ariaRole === 'menu' && {
                id: referenceId
            },
            ...ariaRole === 'menu' && isNested && {
                role: 'menuitem'
            },
            ...role === 'select' && {
                'aria-autocomplete': 'none'
            },
            ...role === 'combobox' && {
                'aria-autocomplete': 'list'
            }
        };
    }, [
        ariaRole,
        floatingId,
        isNested,
        open,
        referenceId,
        role
    ]);
    const floating = $cQQee.useMemo(()=>{
        const floatingProps = {
            id: floatingId,
            ...ariaRole && {
                role: ariaRole
            }
        };
        if (ariaRole === 'tooltip' || role === 'label') return floatingProps;
        return {
            ...floatingProps,
            ...ariaRole === 'menu' && {
                'aria-labelledby': referenceId
            }
        };
    }, [
        ariaRole,
        floatingId,
        referenceId,
        role
    ]);
    const item = $cQQee.useCallback((_ref)=>{
        let { active: active, selected: selected } = _ref;
        const commonProps = {
            role: 'option',
            ...active && {
                id: floatingId + "-fui-option"
            }
        };
        // For `menu`, we are unable to tell if the item is a `menuitemradio`
        // or `menuitemcheckbox`. For backwards-compatibility reasons, also
        // avoid defaulting to `menuitem` as it may overwrite custom role props.
        switch(role){
            case 'select':
            case 'combobox':
                return {
                    ...commonProps,
                    'aria-selected': selected
                };
        }
        return {};
    }, [
        floatingId,
        role
    ]);
    return $cQQee.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating,
            item: item
        } : {}, [
        enabled,
        reference,
        floating,
        item
    ]);
}
// Converts a JS style key like `backgroundColor` to a CSS transition-property
// like `background-color`.
const $92f1173bc75d6d9e$var$camelCaseToKebabCase = (str)=>str.replace(/[A-Z]+(?![a-z])|[A-Z]/g, ($, ofs)=>(ofs ? '-' : '') + $.toLowerCase());
function $92f1173bc75d6d9e$var$execWithArgsOrReturn(valueOrFn, args) {
    return typeof valueOrFn === 'function' ? valueOrFn(args) : valueOrFn;
}
function $92f1173bc75d6d9e$var$useDelayUnmount(open, durationMs) {
    const [isMounted, setIsMounted] = $cQQee.useState(open);
    if (open && !isMounted) setIsMounted(true);
    $cQQee.useEffect(()=>{
        if (!open && isMounted) {
            const timeout = setTimeout(()=>setIsMounted(false), durationMs);
            return ()=>clearTimeout(timeout);
        }
    }, [
        open,
        isMounted,
        durationMs
    ]);
    return isMounted;
}
/**
 * Provides a status string to apply CSS transitions to a floating element,
 * correctly handling placement-aware transitions.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstatus
 */ function $92f1173bc75d6d9e$export$b2ef21706733f7e5(context, props) {
    if (props === void 0) props = {};
    const { open: open, elements: { floating: floating } } = context;
    const { duration: duration = 250 } = props;
    const isNumberDuration = typeof duration === 'number';
    const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
    const [status, setStatus] = $cQQee.useState('unmounted');
    const isMounted = $92f1173bc75d6d9e$var$useDelayUnmount(open, closeDuration);
    if (!isMounted && status === 'close') setStatus('unmounted');
    (0, $5BFeN.useModernLayoutEffect)(()=>{
        if (!floating) return;
        if (open) {
            setStatus('initial');
            const frame = requestAnimationFrame(()=>{
                // Ensure it opens before paint. With `FloatingDelayGroup`,
                // this avoids a flicker when moving between floating elements
                // to ensure one is always open with no missing frames.
                $kC364.flushSync(()=>{
                    setStatus('open');
                });
            });
            return ()=>{
                cancelAnimationFrame(frame);
            };
        }
        setStatus('close');
    }, [
        open,
        floating
    ]);
    return {
        isMounted: isMounted,
        status: status
    };
}
/**
 * Provides styles to apply CSS transitions to a floating element, correctly
 * handling placement-aware transitions. Wrapper around `useTransitionStatus`.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstyles
 */ function $92f1173bc75d6d9e$export$769fba13884bc2f4(context, props) {
    if (props === void 0) props = {};
    const { initial: unstable_initial = {
        opacity: 0
    }, open: unstable_open, close: unstable_close, common: unstable_common, duration: duration = 250 } = props;
    const placement = context.placement;
    const side = placement.split('-')[0];
    const fnArgs = $cQQee.useMemo(()=>({
            side: side,
            placement: placement
        }), [
        side,
        placement
    ]);
    const isNumberDuration = typeof duration === 'number';
    const openDuration = (isNumberDuration ? duration : duration.open) || 0;
    const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
    const [styles, setStyles] = $cQQee.useState(()=>({
            ...$92f1173bc75d6d9e$var$execWithArgsOrReturn(unstable_common, fnArgs),
            ...$92f1173bc75d6d9e$var$execWithArgsOrReturn(unstable_initial, fnArgs)
        }));
    const { isMounted: isMounted, status: status } = $92f1173bc75d6d9e$export$b2ef21706733f7e5(context, {
        duration: duration
    });
    const initialRef = (0, $5BFeN.useLatestRef)(unstable_initial);
    const openRef = (0, $5BFeN.useLatestRef)(unstable_open);
    const closeRef = (0, $5BFeN.useLatestRef)(unstable_close);
    const commonRef = (0, $5BFeN.useLatestRef)(unstable_common);
    (0, $5BFeN.useModernLayoutEffect)(()=>{
        const initialStyles = $92f1173bc75d6d9e$var$execWithArgsOrReturn(initialRef.current, fnArgs);
        const closeStyles = $92f1173bc75d6d9e$var$execWithArgsOrReturn(closeRef.current, fnArgs);
        const commonStyles = $92f1173bc75d6d9e$var$execWithArgsOrReturn(commonRef.current, fnArgs);
        const openStyles = $92f1173bc75d6d9e$var$execWithArgsOrReturn(openRef.current, fnArgs) || Object.keys(initialStyles).reduce((acc, key)=>{
            acc[key] = '';
            return acc;
        }, {});
        if (status === 'initial') setStyles((styles)=>({
                transitionProperty: styles.transitionProperty,
                ...commonStyles,
                ...initialStyles
            }));
        if (status === 'open') setStyles({
            transitionProperty: Object.keys(openStyles).map($92f1173bc75d6d9e$var$camelCaseToKebabCase).join(','),
            transitionDuration: openDuration + "ms",
            ...commonStyles,
            ...openStyles
        });
        if (status === 'close') {
            const styles = closeStyles || initialStyles;
            setStyles({
                transitionProperty: Object.keys(styles).map($92f1173bc75d6d9e$var$camelCaseToKebabCase).join(','),
                transitionDuration: closeDuration + "ms",
                ...commonStyles,
                ...styles
            });
        }
    }, [
        closeDuration,
        closeRef,
        initialRef,
        openRef,
        commonRef,
        openDuration,
        status,
        fnArgs
    ]);
    return {
        isMounted: isMounted,
        styles: styles
    };
}
/**
 * Provides a matching callback that can be used to focus an item as the user
 * types, often used in tandem with `useListNavigation()`.
 * @see https://floating-ui.com/docs/useTypeahead
 */ function $92f1173bc75d6d9e$export$d8d674d50b73ba93(context, props) {
    var _ref;
    const { open: open, dataRef: dataRef } = context;
    const { listRef: listRef, activeIndex: activeIndex, onMatch: unstable_onMatch, onTypingChange: unstable_onTypingChange, enabled: enabled = true, findMatch: findMatch = null, resetMs: resetMs = 750, ignoreKeys: ignoreKeys = [], selectedIndex: selectedIndex = null } = props;
    const timeoutIdRef = $cQQee.useRef(-1);
    const stringRef = $cQQee.useRef('');
    const prevIndexRef = $cQQee.useRef((_ref = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref : -1);
    const matchIndexRef = $cQQee.useRef(null);
    const onMatch = (0, $5BFeN.useEffectEvent)(unstable_onMatch);
    const onTypingChange = (0, $5BFeN.useEffectEvent)(unstable_onTypingChange);
    const findMatchRef = (0, $5BFeN.useLatestRef)(findMatch);
    const ignoreKeysRef = (0, $5BFeN.useLatestRef)(ignoreKeys);
    (0, $5BFeN.useModernLayoutEffect)(()=>{
        if (open) {
            $92f1173bc75d6d9e$var$clearTimeoutIfSet(timeoutIdRef);
            matchIndexRef.current = null;
            stringRef.current = '';
        }
    }, [
        open
    ]);
    (0, $5BFeN.useModernLayoutEffect)(()=>{
        // Sync arrow key navigation but not typeahead navigation.
        if (open && stringRef.current === '') {
            var _ref2;
            prevIndexRef.current = (_ref2 = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref2 : -1;
        }
    }, [
        open,
        selectedIndex,
        activeIndex
    ]);
    const setTypingChange = (0, $5BFeN.useEffectEvent)((value)=>{
        if (value) {
            if (!dataRef.current.typing) {
                dataRef.current.typing = value;
                onTypingChange(value);
            }
        } else if (dataRef.current.typing) {
            dataRef.current.typing = value;
            onTypingChange(value);
        }
    });
    const onKeyDown = (0, $5BFeN.useEffectEvent)((event)=>{
        function getMatchingIndex(list, orderedList, string) {
            const str = findMatchRef.current ? findMatchRef.current(orderedList, string) : orderedList.find((text)=>(text == null ? void 0 : text.toLocaleLowerCase().indexOf(string.toLocaleLowerCase())) === 0);
            return str ? list.indexOf(str) : -1;
        }
        const listContent = listRef.current;
        if (stringRef.current.length > 0 && stringRef.current[0] !== ' ') {
            if (getMatchingIndex(listContent, listContent, stringRef.current) === -1) setTypingChange(false);
            else if (event.key === ' ') (0, $5BFeN.stopEvent)(event);
        }
        if (listContent == null || ignoreKeysRef.current.includes(event.key) || // Character key.
        event.key.length !== 1 || // Modifier key.
        event.ctrlKey || event.metaKey || event.altKey) return;
        if (open && event.key !== ' ') {
            (0, $5BFeN.stopEvent)(event);
            setTypingChange(true);
        }
        // Bail out if the list contains a word like "llama" or "aaron". TODO:
        // allow it in this case, too.
        const allowRapidSuccessionOfFirstLetter = listContent.every((text)=>{
            var _text$, _text$2;
            return text ? ((_text$ = text[0]) == null ? void 0 : _text$.toLocaleLowerCase()) !== ((_text$2 = text[1]) == null ? void 0 : _text$2.toLocaleLowerCase()) : true;
        });
        // Allows the user to cycle through items that start with the same letter
        // in rapid succession.
        if (allowRapidSuccessionOfFirstLetter && stringRef.current === event.key) {
            stringRef.current = '';
            prevIndexRef.current = matchIndexRef.current;
        }
        stringRef.current += event.key;
        $92f1173bc75d6d9e$var$clearTimeoutIfSet(timeoutIdRef);
        timeoutIdRef.current = window.setTimeout(()=>{
            stringRef.current = '';
            prevIndexRef.current = matchIndexRef.current;
            setTypingChange(false);
        }, resetMs);
        const prevIndex = prevIndexRef.current;
        const index = getMatchingIndex(listContent, [
            ...listContent.slice((prevIndex || 0) + 1),
            ...listContent.slice(0, (prevIndex || 0) + 1)
        ], stringRef.current);
        if (index !== -1) {
            onMatch(index);
            matchIndexRef.current = index;
        } else if (event.key !== ' ') {
            stringRef.current = '';
            setTypingChange(false);
        }
    });
    const reference = $cQQee.useMemo(()=>({
            onKeyDown: onKeyDown
        }), [
        onKeyDown
    ]);
    const floating = $cQQee.useMemo(()=>{
        return {
            onKeyDown: onKeyDown,
            onKeyUp (event) {
                if (event.key === ' ') setTypingChange(false);
            }
        };
    }, [
        onKeyDown,
        setTypingChange
    ]);
    return $cQQee.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating
        } : {}, [
        enabled,
        reference,
        floating
    ]);
}
function $92f1173bc75d6d9e$var$getArgsWithCustomFloatingHeight(state, height) {
    return {
        ...state,
        rects: {
            ...state.rects,
            floating: {
                ...state.rects.floating,
                height: height
            }
        }
    };
}
/**
 * Positions the floating element such that an inner element inside of it is
 * anchored to the reference element.
 * @see https://floating-ui.com/docs/inner
 * @deprecated
 */ const $92f1173bc75d6d9e$export$4ae363f1d88fb658 = (props)=>({
        name: 'inner',
        options: props,
        async fn (state) {
            const { listRef: listRef, overflowRef: overflowRef, onFallbackChange: onFallbackChange, offset: innerOffset = 0, index: index = 0, minItemsVisible: minItemsVisible = 4, referenceOverflowThreshold: referenceOverflowThreshold = 0, scrollRef: scrollRef, ...detectOverflowOptions } = (0, $g3pjJ.evaluate)(props, state);
            const { rects: rects, platform: platform, elements: { floating: floating } } = state;
            const item = listRef.current[index];
            const scrollEl = (scrollRef == null ? void 0 : scrollRef.current) || floating;
            // Valid combinations:
            // 1. Floating element is the scrollRef and has a border (default)
            // 2. Floating element is not the scrollRef, floating element has a border
            // 3. Floating element is not the scrollRef, scrollRef has a border
            // Floating > {...getFloatingProps()} wrapper > scrollRef > items is not
            // allowed as VoiceOver doesn't work.
            const clientTop = floating.clientTop || scrollEl.clientTop;
            const floatingIsBordered = floating.clientTop !== 0;
            const scrollElIsBordered = scrollEl.clientTop !== 0;
            const floatingIsScrollEl = floating === scrollEl;
            if (!item) return {};
            const nextArgs = {
                ...state,
                ...await (0, $dA4dV.offset)(-item.offsetTop - floating.clientTop - rects.reference.height / 2 - item.offsetHeight / 2 - innerOffset).fn(state)
            };
            const overflow = await platform.detectOverflow($92f1173bc75d6d9e$var$getArgsWithCustomFloatingHeight(nextArgs, scrollEl.scrollHeight + clientTop + floating.clientTop), detectOverflowOptions);
            const refOverflow = await platform.detectOverflow(nextArgs, {
                ...detectOverflowOptions,
                elementContext: 'reference'
            });
            const diffY = (0, $g3pjJ.max)(0, overflow.top);
            const nextY = nextArgs.y + diffY;
            const isScrollable = scrollEl.scrollHeight > scrollEl.clientHeight;
            const rounder = isScrollable ? (v)=>v : (0, $g3pjJ.round);
            const maxHeight = rounder((0, $g3pjJ.max)(0, scrollEl.scrollHeight + (floatingIsBordered && floatingIsScrollEl || scrollElIsBordered ? clientTop * 2 : 0) - diffY - (0, $g3pjJ.max)(0, overflow.bottom)));
            scrollEl.style.maxHeight = maxHeight + "px";
            scrollEl.scrollTop = diffY;
            // There is not enough space, fallback to standard anchored positioning
            if (onFallbackChange) {
                const shouldFallback = scrollEl.offsetHeight < item.offsetHeight * (0, $g3pjJ.min)(minItemsVisible, listRef.current.length) - 1 || refOverflow.top >= -referenceOverflowThreshold || refOverflow.bottom >= -referenceOverflowThreshold;
                $kC364.flushSync(()=>onFallbackChange(shouldFallback));
            }
            if (overflowRef) overflowRef.current = await platform.detectOverflow($92f1173bc75d6d9e$var$getArgsWithCustomFloatingHeight({
                ...nextArgs,
                y: nextY
            }, scrollEl.offsetHeight + clientTop + floating.clientTop), detectOverflowOptions);
            return {
                y: nextY
            };
        }
    });
/**
 * Changes the `inner` middleware's `offset` upon a `wheel` event to
 * expand the floating element's height, revealing more list items.
 * @see https://floating-ui.com/docs/inner
 * @deprecated
 */ function $92f1173bc75d6d9e$export$3d74b0dda7cc82ff(context, props) {
    const { open: open, elements: elements } = context;
    const { enabled: enabled = true, overflowRef: overflowRef, scrollRef: scrollRef, onChange: unstable_onChange } = props;
    const onChange = (0, $5BFeN.useEffectEvent)(unstable_onChange);
    const controlledScrollingRef = $cQQee.useRef(false);
    const prevScrollTopRef = $cQQee.useRef(null);
    const initialOverflowRef = $cQQee.useRef(null);
    $cQQee.useEffect(()=>{
        if (!enabled) return;
        function onWheel(e) {
            if (e.ctrlKey || !el || overflowRef.current == null) return;
            const dY = e.deltaY;
            const isAtTop = overflowRef.current.top >= -0.5;
            const isAtBottom = overflowRef.current.bottom >= -0.5;
            const remainingScroll = el.scrollHeight - el.clientHeight;
            const sign = dY < 0 ? -1 : 1;
            const method = dY < 0 ? 'max' : 'min';
            if (el.scrollHeight <= el.clientHeight) return;
            if (!isAtTop && dY > 0 || !isAtBottom && dY < 0) {
                e.preventDefault();
                $kC364.flushSync(()=>{
                    onChange((d)=>d + Math[method](dY, remainingScroll * sign));
                });
            } else if (/firefox/i.test((0, $5BFeN.getUserAgent)())) // Needed to propagate scrolling during momentum scrolling phase once
            // it gets limited by the boundary. UX improvement, not critical.
            el.scrollTop += dY;
        }
        const el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
        if (open && el) {
            el.addEventListener('wheel', onWheel);
            // Wait for the position to be ready.
            requestAnimationFrame(()=>{
                prevScrollTopRef.current = el.scrollTop;
                if (overflowRef.current != null) initialOverflowRef.current = {
                    ...overflowRef.current
                };
            });
            return ()=>{
                prevScrollTopRef.current = null;
                initialOverflowRef.current = null;
                el.removeEventListener('wheel', onWheel);
            };
        }
    }, [
        enabled,
        open,
        elements.floating,
        overflowRef,
        scrollRef,
        onChange
    ]);
    const floating = $cQQee.useMemo(()=>({
            onKeyDown () {
                controlledScrollingRef.current = true;
            },
            onWheel () {
                controlledScrollingRef.current = false;
            },
            onPointerMove () {
                controlledScrollingRef.current = false;
            },
            onScroll () {
                const el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
                if (!overflowRef.current || !el || !controlledScrollingRef.current) return;
                if (prevScrollTopRef.current !== null) {
                    const scrollDiff = el.scrollTop - prevScrollTopRef.current;
                    if (overflowRef.current.bottom < -0.5 && scrollDiff < -1 || overflowRef.current.top < -0.5 && scrollDiff > 1) $kC364.flushSync(()=>onChange((d)=>d + scrollDiff));
                }
                // [Firefox] Wait for the height change to have been applied.
                requestAnimationFrame(()=>{
                    prevScrollTopRef.current = el.scrollTop;
                });
            }
        }), [
        elements.floating,
        onChange,
        overflowRef,
        scrollRef
    ]);
    return $cQQee.useMemo(()=>enabled ? {
            floating: floating
        } : {}, [
        enabled,
        floating
    ]);
}
function $92f1173bc75d6d9e$var$getNodeChildren(nodes, id, onlyOpenChildren) {
    if (onlyOpenChildren === void 0) onlyOpenChildren = true;
    const directChildren = nodes.filter((node)=>{
        var _node$context;
        return node.parentId === id && (!onlyOpenChildren || ((_node$context = node.context) == null ? void 0 : _node$context.open));
    });
    return directChildren.flatMap((child)=>[
            child,
            ...$92f1173bc75d6d9e$var$getNodeChildren(nodes, child.id, onlyOpenChildren)
        ]);
}
function $92f1173bc75d6d9e$var$isPointInPolygon(point, polygon) {
    const [x, y] = point;
    let isInside = false;
    const length = polygon.length;
    for(let i = 0, j = length - 1; i < length; j = i++){
        const [xi, yi] = polygon[i] || [
            0,
            0
        ];
        const [xj, yj] = polygon[j] || [
            0,
            0
        ];
        const intersect = yi >= y !== yj >= y && x <= (xj - xi) * (y - yi) / (yj - yi) + xi;
        if (intersect) isInside = !isInside;
    }
    return isInside;
}
function $92f1173bc75d6d9e$var$isInside(point, rect) {
    return point[0] >= rect.x && point[0] <= rect.x + rect.width && point[1] >= rect.y && point[1] <= rect.y + rect.height;
}
/**
 * Generates a safe polygon area that the user can traverse without closing the
 * floating element once leaving the reference element.
 * @see https://floating-ui.com/docs/useHover#safepolygon
 */ function $92f1173bc75d6d9e$export$7484214ab62358d2(options) {
    if (options === void 0) options = {};
    const { buffer: buffer = 0.5, blockPointerEvents: blockPointerEvents = false, requireIntent: requireIntent = true } = options;
    const timeoutRef = {
        current: -1
    };
    let hasLanded = false;
    let lastX = null;
    let lastY = null;
    let lastCursorTime = typeof performance !== 'undefined' ? performance.now() : 0;
    function getCursorSpeed(x, y) {
        const currentTime = performance.now();
        const elapsedTime = currentTime - lastCursorTime;
        if (lastX === null || lastY === null || elapsedTime === 0) {
            lastX = x;
            lastY = y;
            lastCursorTime = currentTime;
            return null;
        }
        const deltaX = x - lastX;
        const deltaY = y - lastY;
        const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
        const speed = distance / elapsedTime; // px / ms
        lastX = x;
        lastY = y;
        lastCursorTime = currentTime;
        return speed;
    }
    const fn = (_ref)=>{
        let { x: x, y: y, placement: placement, elements: elements, onClose: onClose, nodeId: nodeId, tree: tree } = _ref;
        return function onMouseMove(event) {
            function close() {
                $92f1173bc75d6d9e$var$clearTimeoutIfSet(timeoutRef);
                onClose();
            }
            $92f1173bc75d6d9e$var$clearTimeoutIfSet(timeoutRef);
            if (!elements.domReference || !elements.floating || placement == null || x == null || y == null) return;
            const { clientX: clientX, clientY: clientY } = event;
            const clientPoint = [
                clientX,
                clientY
            ];
            const target = $92f1173bc75d6d9e$var$getTarget(event);
            const isLeave = event.type === 'mouseleave';
            const isOverFloatingEl = $92f1173bc75d6d9e$var$contains(elements.floating, target);
            const isOverReferenceEl = $92f1173bc75d6d9e$var$contains(elements.domReference, target);
            const refRect = elements.domReference.getBoundingClientRect();
            const rect = elements.floating.getBoundingClientRect();
            const side = placement.split('-')[0];
            const cursorLeaveFromRight = x > rect.right - rect.width / 2;
            const cursorLeaveFromBottom = y > rect.bottom - rect.height / 2;
            const isOverReferenceRect = $92f1173bc75d6d9e$var$isInside(clientPoint, refRect);
            const isFloatingWider = rect.width > refRect.width;
            const isFloatingTaller = rect.height > refRect.height;
            const left = (isFloatingWider ? refRect : rect).left;
            const right = (isFloatingWider ? refRect : rect).right;
            const top = (isFloatingTaller ? refRect : rect).top;
            const bottom = (isFloatingTaller ? refRect : rect).bottom;
            if (isOverFloatingEl) {
                hasLanded = true;
                if (!isLeave) return;
            }
            if (isOverReferenceEl) hasLanded = false;
            if (isOverReferenceEl && !isLeave) {
                hasLanded = true;
                return;
            }
            // Prevent overlapping floating element from being stuck in an open-close
            // loop: https://github.com/floating-ui/floating-ui/issues/1910
            if (isLeave && (0, $g7YZX.isElement)(event.relatedTarget) && $92f1173bc75d6d9e$var$contains(elements.floating, event.relatedTarget)) return;
            // If any nested child is open, abort.
            if (tree && $92f1173bc75d6d9e$var$getNodeChildren(tree.nodesRef.current, nodeId).length) return;
            // If the pointer is leaving from the opposite side, the "buffer" logic
            // creates a point where the floating element remains open, but should be
            // ignored.
            // A constant of 1 handles floating point rounding errors.
            if (side === 'top' && y >= refRect.bottom - 1 || side === 'bottom' && y <= refRect.top + 1 || side === 'left' && x >= refRect.right - 1 || side === 'right' && x <= refRect.left + 1) return close();
            // Ignore when the cursor is within the rectangular trough between the
            // two elements. Since the triangle is created from the cursor point,
            // which can start beyond the ref element's edge, traversing back and
            // forth from the ref to the floating element can cause it to close. This
            // ensures it always remains open in that case.
            let rectPoly = [];
            switch(side){
                case 'top':
                    rectPoly = [
                        [
                            left,
                            refRect.top + 1
                        ],
                        [
                            left,
                            rect.bottom - 1
                        ],
                        [
                            right,
                            rect.bottom - 1
                        ],
                        [
                            right,
                            refRect.top + 1
                        ]
                    ];
                    break;
                case 'bottom':
                    rectPoly = [
                        [
                            left,
                            rect.top + 1
                        ],
                        [
                            left,
                            refRect.bottom - 1
                        ],
                        [
                            right,
                            refRect.bottom - 1
                        ],
                        [
                            right,
                            rect.top + 1
                        ]
                    ];
                    break;
                case 'left':
                    rectPoly = [
                        [
                            rect.right - 1,
                            bottom
                        ],
                        [
                            rect.right - 1,
                            top
                        ],
                        [
                            refRect.left + 1,
                            top
                        ],
                        [
                            refRect.left + 1,
                            bottom
                        ]
                    ];
                    break;
                case 'right':
                    rectPoly = [
                        [
                            refRect.right - 1,
                            bottom
                        ],
                        [
                            refRect.right - 1,
                            top
                        ],
                        [
                            rect.left + 1,
                            top
                        ],
                        [
                            rect.left + 1,
                            bottom
                        ]
                    ];
                    break;
            }
            function getPolygon(_ref2) {
                let [x, y] = _ref2;
                switch(side){
                    case 'top':
                        {
                            const cursorPointOne = [
                                isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y + buffer + 1
                            ];
                            const cursorPointTwo = [
                                isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y + buffer + 1
                            ];
                            const commonPoints = [
                                [
                                    rect.left,
                                    cursorLeaveFromRight ? rect.bottom - buffer : isFloatingWider ? rect.bottom - buffer : rect.top
                                ],
                                [
                                    rect.right,
                                    cursorLeaveFromRight ? isFloatingWider ? rect.bottom - buffer : rect.top : rect.bottom - buffer
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                    case 'bottom':
                        {
                            const cursorPointOne = [
                                isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y - buffer
                            ];
                            const cursorPointTwo = [
                                isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y - buffer
                            ];
                            const commonPoints = [
                                [
                                    rect.left,
                                    cursorLeaveFromRight ? rect.top + buffer : isFloatingWider ? rect.top + buffer : rect.bottom
                                ],
                                [
                                    rect.right,
                                    cursorLeaveFromRight ? isFloatingWider ? rect.top + buffer : rect.bottom : rect.top + buffer
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                    case 'left':
                        {
                            const cursorPointOne = [
                                x + buffer + 1,
                                isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const cursorPointTwo = [
                                x + buffer + 1,
                                isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const commonPoints = [
                                [
                                    cursorLeaveFromBottom ? rect.right - buffer : isFloatingTaller ? rect.right - buffer : rect.left,
                                    rect.top
                                ],
                                [
                                    cursorLeaveFromBottom ? isFloatingTaller ? rect.right - buffer : rect.left : rect.right - buffer,
                                    rect.bottom
                                ]
                            ];
                            return [
                                ...commonPoints,
                                cursorPointOne,
                                cursorPointTwo
                            ];
                        }
                    case 'right':
                        {
                            const cursorPointOne = [
                                x - buffer,
                                isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const cursorPointTwo = [
                                x - buffer,
                                isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const commonPoints = [
                                [
                                    cursorLeaveFromBottom ? rect.left + buffer : isFloatingTaller ? rect.left + buffer : rect.right,
                                    rect.top
                                ],
                                [
                                    cursorLeaveFromBottom ? isFloatingTaller ? rect.left + buffer : rect.right : rect.left + buffer,
                                    rect.bottom
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                }
            }
            if ($92f1173bc75d6d9e$var$isPointInPolygon([
                clientX,
                clientY
            ], rectPoly)) return;
            if (hasLanded && !isOverReferenceRect) return close();
            if (!isLeave && requireIntent) {
                const cursorSpeed = getCursorSpeed(event.clientX, event.clientY);
                const cursorSpeedThreshold = 0.1;
                if (cursorSpeed !== null && cursorSpeed < cursorSpeedThreshold) return close();
            }
            if (!$92f1173bc75d6d9e$var$isPointInPolygon([
                clientX,
                clientY
            ], getPolygon([
                x,
                y
            ]))) close();
            else if (!hasLanded && requireIntent) timeoutRef.current = window.setTimeout(close, 40);
        };
    };
    fn.__options = {
        blockPointerEvents: blockPointerEvents
    };
    return fn;
}

});
parcelRegister("5BFeN", function(module, exports) {

$parcel$export(module.exports, "getPlatform", function () { return $4150656a089a918b$export$867a782338812cb4; });
$parcel$export(module.exports, "getUserAgent", function () { return $4150656a089a918b$export$7935961ef7719cb0; });
$parcel$export(module.exports, "isSafari", function () { return $4150656a089a918b$export$95df08bae54cb4df; });
$parcel$export(module.exports, "isMac", function () { return $4150656a089a918b$export$9ac100e40613ea10; });
$parcel$export(module.exports, "activeElement", function () { return $4150656a089a918b$export$da980962bd2147a4; });
$parcel$export(module.exports, "contains", function () { return $4150656a089a918b$export$2344b14b097df817; });
$parcel$export(module.exports, "getTarget", function () { return $4150656a089a918b$export$c22522a4dfa48e9c; });
$parcel$export(module.exports, "isEventTargetWithin", function () { return $4150656a089a918b$export$43c3154d5bf2c6c2; });
$parcel$export(module.exports, "isRootElement", function () { return $4150656a089a918b$export$7b296c28e0fa3aed; });
$parcel$export(module.exports, "getDocument", function () { return $4150656a089a918b$export$f65ca476c09acec0; });
$parcel$export(module.exports, "isTypeableElement", function () { return $4150656a089a918b$export$42ad131c32f0fb8d; });
$parcel$export(module.exports, "isTypeableCombobox", function () { return $4150656a089a918b$export$259ba5ae38188551; });
$parcel$export(module.exports, "matchesFocusVisible", function () { return $4150656a089a918b$export$65750043c2fb2f40; });
$parcel$export(module.exports, "getFloatingFocusElement", function () { return $4150656a089a918b$export$9b0901b5e9b45fc7; });
$parcel$export(module.exports, "getNodeChildren", function () { return $4150656a089a918b$export$1f1998cc3c6b56fb; });
$parcel$export(module.exports, "getDeepestNode", function () { return $4150656a089a918b$export$e7e88d43cb97db79; });
$parcel$export(module.exports, "getNodeAncestors", function () { return $4150656a089a918b$export$5d8eb345316b65c0; });
$parcel$export(module.exports, "stopEvent", function () { return $4150656a089a918b$export$7ae4cd3a66c1e050; });
$parcel$export(module.exports, "isReactEvent", function () { return $4150656a089a918b$export$94781ce41a161222; });
$parcel$export(module.exports, "isVirtualClick", function () { return $4150656a089a918b$export$60278871457622de; });
$parcel$export(module.exports, "isVirtualPointerEvent", function () { return $4150656a089a918b$export$29bf1b5f2c56cf63; });
$parcel$export(module.exports, "isMouseLikePointerType", function () { return $4150656a089a918b$export$81cf264172d31e51; });
$parcel$export(module.exports, "useModernLayoutEffect", function () { return $4150656a089a918b$export$bb3b3b3acfd7447f; });
$parcel$export(module.exports, "useLatestRef", function () { return $4150656a089a918b$export$bcd07ba85a740103; });
$parcel$export(module.exports, "useEffectEvent", function () { return $4150656a089a918b$export$7f54fc3180508a52; });
$parcel$export(module.exports, "isIndexOutOfListBounds", function () { return $4150656a089a918b$export$75effb89758ec596; });
$parcel$export(module.exports, "getMinListIndex", function () { return $4150656a089a918b$export$53f691ee0acc6058; });
$parcel$export(module.exports, "findNonDisabledListIndex", function () { return $4150656a089a918b$export$3fc3ea4a67cf714; });
$parcel$export(module.exports, "getMaxListIndex", function () { return $4150656a089a918b$export$b585558af466e926; });
$parcel$export(module.exports, "isListIndexDisabled", function () { return $4150656a089a918b$export$446656ed0410fd9; });
$parcel$export(module.exports, "getGridNavigatedIndex", function () { return $4150656a089a918b$export$342fcce33a2688bc; });
$parcel$export(module.exports, "createGridCellMap", function () { return $4150656a089a918b$export$5334c96856356f08; });
$parcel$export(module.exports, "getGridCellIndexOfCorner", function () { return $4150656a089a918b$export$dab2b2ce7761f8e4; });
$parcel$export(module.exports, "getGridCellIndices", function () { return $4150656a089a918b$export$50d8709b2ccc23f9; });
$parcel$export(module.exports, "getTabbableOptions", function () { return $4150656a089a918b$export$6324a2bbae6a332f; });
$parcel$export(module.exports, "getNextTabbable", function () { return $4150656a089a918b$export$28f33206776129a7; });
$parcel$export(module.exports, "getPreviousTabbable", function () { return $4150656a089a918b$export$2e5518c3303f364a; });
$parcel$export(module.exports, "isOutsideEvent", function () { return $4150656a089a918b$export$6e0c4e272f3faa2; });
$parcel$export(module.exports, "disableFocusInside", function () { return $4150656a089a918b$export$3995dd353b80da11; });
$parcel$export(module.exports, "enableFocusInside", function () { return $4150656a089a918b$export$a65f4028abb17f36; });

var $g7YZX = parcelRequire("g7YZX");

var $cQQee = parcelRequire("cQQee");

var $g3pjJ = parcelRequire("g3pjJ");

var $9DaiF = parcelRequire("9DaiF");
// Avoid Chrome DevTools blue warning.
function $4150656a089a918b$export$867a782338812cb4() {
    const uaData = navigator.userAgentData;
    if (uaData != null && uaData.platform) return uaData.platform;
    return navigator.platform;
}
function $4150656a089a918b$export$7935961ef7719cb0() {
    const uaData = navigator.userAgentData;
    if (uaData && Array.isArray(uaData.brands)) return uaData.brands.map((_ref)=>{
        let { brand: brand, version: version } = _ref;
        return brand + "/" + version;
    }).join(' ');
    return navigator.userAgent;
}
function $4150656a089a918b$export$95df08bae54cb4df() {
    // Chrome DevTools does not complain about navigator.vendor
    return /apple/i.test(navigator.vendor);
}
function $4150656a089a918b$export$a11b0059900ceec8() {
    const re = /android/i;
    return re.test($4150656a089a918b$export$867a782338812cb4()) || re.test($4150656a089a918b$export$7935961ef7719cb0());
}
function $4150656a089a918b$export$9ac100e40613ea10() {
    return $4150656a089a918b$export$867a782338812cb4().toLowerCase().startsWith('mac') && !navigator.maxTouchPoints;
}
function $4150656a089a918b$export$c8f880a2d81914c4() {
    return $4150656a089a918b$export$7935961ef7719cb0().includes('jsdom/');
}
const $4150656a089a918b$var$FOCUSABLE_ATTRIBUTE = 'data-floating-ui-focusable';
const $4150656a089a918b$var$TYPEABLE_SELECTOR = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
const $4150656a089a918b$var$ARROW_LEFT = 'ArrowLeft';
const $4150656a089a918b$var$ARROW_RIGHT = 'ArrowRight';
const $4150656a089a918b$var$ARROW_UP = 'ArrowUp';
const $4150656a089a918b$var$ARROW_DOWN = 'ArrowDown';
function $4150656a089a918b$export$da980962bd2147a4(doc) {
    let activeElement = doc.activeElement;
    while(((_activeElement = activeElement) == null || (_activeElement = _activeElement.shadowRoot) == null ? void 0 : _activeElement.activeElement) != null){
        var _activeElement;
        activeElement = activeElement.shadowRoot.activeElement;
    }
    return activeElement;
}
function $4150656a089a918b$export$2344b14b097df817(parent, child) {
    if (!parent || !child) return false;
    const rootNode = child.getRootNode == null ? void 0 : child.getRootNode();
    // First, attempt with faster native method
    if (parent.contains(child)) return true;
    // then fallback to custom implementation with Shadow DOM support
    if (rootNode && (0, $g7YZX.isShadowRoot)(rootNode)) {
        let next = child;
        while(next){
            if (parent === next) return true;
            // @ts-ignore
            next = next.parentNode || next.host;
        }
    }
    // Give up, the result is false
    return false;
}
function $4150656a089a918b$export$c22522a4dfa48e9c(event) {
    if ('composedPath' in event) return event.composedPath()[0];
    // TS thinks `event` is of type never as it assumes all browsers support
    // `composedPath()`, but browsers without shadow DOM don't.
    return event.target;
}
function $4150656a089a918b$export$43c3154d5bf2c6c2(event, node) {
    if (node == null) return false;
    if ('composedPath' in event) return event.composedPath().includes(node);
    // TS thinks `event` is of type never as it assumes all browsers support composedPath, but browsers without shadow dom don't
    const e = event;
    return e.target != null && node.contains(e.target);
}
function $4150656a089a918b$export$7b296c28e0fa3aed(element) {
    return element.matches('html,body');
}
function $4150656a089a918b$export$f65ca476c09acec0(node) {
    return (node == null ? void 0 : node.ownerDocument) || document;
}
function $4150656a089a918b$export$42ad131c32f0fb8d(element) {
    return (0, $g7YZX.isHTMLElement)(element) && element.matches($4150656a089a918b$var$TYPEABLE_SELECTOR);
}
function $4150656a089a918b$export$259ba5ae38188551(element) {
    if (!element) return false;
    return element.getAttribute('role') === 'combobox' && $4150656a089a918b$export$42ad131c32f0fb8d(element);
}
function $4150656a089a918b$export$65750043c2fb2f40(element) {
    // We don't want to block focus from working with `visibleOnly`
    // (JSDOM doesn't match `:focus-visible` when the element has `:focus`)
    if (!element || $4150656a089a918b$export$c8f880a2d81914c4()) return true;
    try {
        return element.matches(':focus-visible');
    } catch (_e) {
        return true;
    }
}
function $4150656a089a918b$export$9b0901b5e9b45fc7(floatingElement) {
    if (!floatingElement) return null;
    // Try to find the element that has `{...getFloatingProps()}` spread on it.
    // This indicates the floating element is acting as a positioning wrapper, and
    // so focus should be managed on the child element with the event handlers and
    // aria props.
    return floatingElement.hasAttribute($4150656a089a918b$var$FOCUSABLE_ATTRIBUTE) ? floatingElement : floatingElement.querySelector("[" + $4150656a089a918b$var$FOCUSABLE_ATTRIBUTE + "]") || floatingElement;
}
function $4150656a089a918b$export$1f1998cc3c6b56fb(nodes, id, onlyOpenChildren) {
    if (onlyOpenChildren === void 0) onlyOpenChildren = true;
    const directChildren = nodes.filter((node)=>{
        var _node$context;
        return node.parentId === id && (!onlyOpenChildren || ((_node$context = node.context) == null ? void 0 : _node$context.open));
    });
    return directChildren.flatMap((child)=>[
            child,
            ...$4150656a089a918b$export$1f1998cc3c6b56fb(nodes, child.id, onlyOpenChildren)
        ]);
}
function $4150656a089a918b$export$e7e88d43cb97db79(nodes, id) {
    let deepestNodeId;
    let maxDepth = -1;
    function findDeepest(nodeId, depth) {
        if (depth > maxDepth) {
            deepestNodeId = nodeId;
            maxDepth = depth;
        }
        const children = $4150656a089a918b$export$1f1998cc3c6b56fb(nodes, nodeId);
        children.forEach((child)=>{
            findDeepest(child.id, depth + 1);
        });
    }
    findDeepest(id, 0);
    return nodes.find((node)=>node.id === deepestNodeId);
}
function $4150656a089a918b$export$5d8eb345316b65c0(nodes, id) {
    var _nodes$find;
    let allAncestors = [];
    let currentParentId = (_nodes$find = nodes.find((node)=>node.id === id)) == null ? void 0 : _nodes$find.parentId;
    while(currentParentId){
        const currentNode = nodes.find((node)=>node.id === currentParentId);
        currentParentId = currentNode == null ? void 0 : currentNode.parentId;
        if (currentNode) allAncestors = allAncestors.concat(currentNode);
    }
    return allAncestors;
}
function $4150656a089a918b$export$7ae4cd3a66c1e050(event) {
    event.preventDefault();
    event.stopPropagation();
}
function $4150656a089a918b$export$94781ce41a161222(event) {
    return 'nativeEvent' in event;
}
// License: https://github.com/adobe/react-spectrum/blob/b35d5c02fe900badccd0cf1a8f23bb593419f238/packages/@react-aria/utils/src/isVirtualEvent.ts
function $4150656a089a918b$export$60278871457622de(event) {
    // FIXME: Firefox is now emitting a deprecation warning for `mozInputSource`.
    // Try to find a workaround for this. `react-aria` source still has the check.
    if (event.mozInputSource === 0 && event.isTrusted) return true;
    if ($4150656a089a918b$export$a11b0059900ceec8() && event.pointerType) return event.type === 'click' && event.buttons === 1;
    return event.detail === 0 && !event.pointerType;
}
function $4150656a089a918b$export$29bf1b5f2c56cf63(event) {
    if ($4150656a089a918b$export$c8f880a2d81914c4()) return false;
    return !$4150656a089a918b$export$a11b0059900ceec8() && event.width === 0 && event.height === 0 || $4150656a089a918b$export$a11b0059900ceec8() && event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === 'mouse' || // iOS VoiceOver returns 0.333• for width/height.
    event.width < 1 && event.height < 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === 'touch';
}
function $4150656a089a918b$export$81cf264172d31e51(pointerType, strict) {
    // On some Linux machines with Chromium, mouse inputs return a `pointerType`
    // of "pen": https://github.com/floating-ui/floating-ui/issues/2015
    const values = [
        'mouse',
        'pen'
    ];
    if (!strict) values.push('', undefined);
    return values.includes(pointerType);
}
var $4150656a089a918b$var$isClient = typeof document !== 'undefined';
var $4150656a089a918b$var$noop = function noop() {};
var $4150656a089a918b$export$bb3b3b3acfd7447f = $4150656a089a918b$var$isClient ? (0, $cQQee.useLayoutEffect) : $4150656a089a918b$var$noop;
// https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379
const $4150656a089a918b$var$SafeReact = {
    ...$cQQee
};
function $4150656a089a918b$export$bcd07ba85a740103(value) {
    const ref = $cQQee.useRef(value);
    $4150656a089a918b$export$bb3b3b3acfd7447f(()=>{
        ref.current = value;
    });
    return ref;
}
const $4150656a089a918b$var$useInsertionEffect = $4150656a089a918b$var$SafeReact.useInsertionEffect;
const $4150656a089a918b$var$useSafeInsertionEffect = $4150656a089a918b$var$useInsertionEffect || ((fn)=>fn());
function $4150656a089a918b$export$7f54fc3180508a52(callback) {
    const ref = $cQQee.useRef(()=>{});
    $4150656a089a918b$var$useSafeInsertionEffect(()=>{
        ref.current = callback;
    });
    return $cQQee.useCallback(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return ref.current == null ? void 0 : ref.current(...args);
    }, []);
}
function $4150656a089a918b$export$709046525cac3019(index, cols, prevRow) {
    return Math.floor(index / cols) !== prevRow;
}
function $4150656a089a918b$export$75effb89758ec596(listRef, index) {
    return index < 0 || index >= listRef.current.length;
}
function $4150656a089a918b$export$53f691ee0acc6058(listRef, disabledIndices) {
    return $4150656a089a918b$export$3fc3ea4a67cf714(listRef, {
        disabledIndices: disabledIndices
    });
}
function $4150656a089a918b$export$b585558af466e926(listRef, disabledIndices) {
    return $4150656a089a918b$export$3fc3ea4a67cf714(listRef, {
        decrement: true,
        startingIndex: listRef.current.length,
        disabledIndices: disabledIndices
    });
}
function $4150656a089a918b$export$3fc3ea4a67cf714(listRef, _temp) {
    let { startingIndex: startingIndex = -1, decrement: decrement = false, disabledIndices: disabledIndices, amount: amount = 1 } = _temp === void 0 ? {} : _temp;
    let index = startingIndex;
    do index += decrement ? -amount : amount;
    while (index >= 0 && index <= listRef.current.length - 1 && $4150656a089a918b$export$446656ed0410fd9(listRef, index, disabledIndices));
    return index;
}
function $4150656a089a918b$export$342fcce33a2688bc(listRef, _ref) {
    let { event: event, orientation: orientation, loop: loop, rtl: rtl, cols: cols, disabledIndices: disabledIndices, minIndex: minIndex, maxIndex: maxIndex, prevIndex: prevIndex, stopEvent: stop = false } = _ref;
    let nextIndex = prevIndex;
    if (event.key === $4150656a089a918b$var$ARROW_UP) {
        stop && $4150656a089a918b$export$7ae4cd3a66c1e050(event);
        if (prevIndex === -1) nextIndex = maxIndex;
        else {
            nextIndex = $4150656a089a918b$export$3fc3ea4a67cf714(listRef, {
                startingIndex: nextIndex,
                amount: cols,
                decrement: true,
                disabledIndices: disabledIndices
            });
            if (loop && (prevIndex - cols < minIndex || nextIndex < 0)) {
                const col = prevIndex % cols;
                const maxCol = maxIndex % cols;
                const offset = maxIndex - (maxCol - col);
                if (maxCol === col) nextIndex = maxIndex;
                else nextIndex = maxCol > col ? offset : offset - cols;
            }
        }
        if ($4150656a089a918b$export$75effb89758ec596(listRef, nextIndex)) nextIndex = prevIndex;
    }
    if (event.key === $4150656a089a918b$var$ARROW_DOWN) {
        stop && $4150656a089a918b$export$7ae4cd3a66c1e050(event);
        if (prevIndex === -1) nextIndex = minIndex;
        else {
            nextIndex = $4150656a089a918b$export$3fc3ea4a67cf714(listRef, {
                startingIndex: prevIndex,
                amount: cols,
                disabledIndices: disabledIndices
            });
            if (loop && prevIndex + cols > maxIndex) nextIndex = $4150656a089a918b$export$3fc3ea4a67cf714(listRef, {
                startingIndex: prevIndex % cols - cols,
                amount: cols,
                disabledIndices: disabledIndices
            });
        }
        if ($4150656a089a918b$export$75effb89758ec596(listRef, nextIndex)) nextIndex = prevIndex;
    }
    // Remains on the same row/column.
    if (orientation === 'both') {
        const prevRow = (0, $g3pjJ.floor)(prevIndex / cols);
        if (event.key === (rtl ? $4150656a089a918b$var$ARROW_LEFT : $4150656a089a918b$var$ARROW_RIGHT)) {
            stop && $4150656a089a918b$export$7ae4cd3a66c1e050(event);
            if (prevIndex % cols !== cols - 1) {
                nextIndex = $4150656a089a918b$export$3fc3ea4a67cf714(listRef, {
                    startingIndex: prevIndex,
                    disabledIndices: disabledIndices
                });
                if (loop && $4150656a089a918b$export$709046525cac3019(nextIndex, cols, prevRow)) nextIndex = $4150656a089a918b$export$3fc3ea4a67cf714(listRef, {
                    startingIndex: prevIndex - prevIndex % cols - 1,
                    disabledIndices: disabledIndices
                });
            } else if (loop) nextIndex = $4150656a089a918b$export$3fc3ea4a67cf714(listRef, {
                startingIndex: prevIndex - prevIndex % cols - 1,
                disabledIndices: disabledIndices
            });
            if ($4150656a089a918b$export$709046525cac3019(nextIndex, cols, prevRow)) nextIndex = prevIndex;
        }
        if (event.key === (rtl ? $4150656a089a918b$var$ARROW_RIGHT : $4150656a089a918b$var$ARROW_LEFT)) {
            stop && $4150656a089a918b$export$7ae4cd3a66c1e050(event);
            if (prevIndex % cols !== 0) {
                nextIndex = $4150656a089a918b$export$3fc3ea4a67cf714(listRef, {
                    startingIndex: prevIndex,
                    decrement: true,
                    disabledIndices: disabledIndices
                });
                if (loop && $4150656a089a918b$export$709046525cac3019(nextIndex, cols, prevRow)) nextIndex = $4150656a089a918b$export$3fc3ea4a67cf714(listRef, {
                    startingIndex: prevIndex + (cols - prevIndex % cols),
                    decrement: true,
                    disabledIndices: disabledIndices
                });
            } else if (loop) nextIndex = $4150656a089a918b$export$3fc3ea4a67cf714(listRef, {
                startingIndex: prevIndex + (cols - prevIndex % cols),
                decrement: true,
                disabledIndices: disabledIndices
            });
            if ($4150656a089a918b$export$709046525cac3019(nextIndex, cols, prevRow)) nextIndex = prevIndex;
        }
        const lastRow = (0, $g3pjJ.floor)(maxIndex / cols) === prevRow;
        if ($4150656a089a918b$export$75effb89758ec596(listRef, nextIndex)) {
            if (loop && lastRow) nextIndex = event.key === (rtl ? $4150656a089a918b$var$ARROW_RIGHT : $4150656a089a918b$var$ARROW_LEFT) ? maxIndex : $4150656a089a918b$export$3fc3ea4a67cf714(listRef, {
                startingIndex: prevIndex - prevIndex % cols - 1,
                disabledIndices: disabledIndices
            });
            else nextIndex = prevIndex;
        }
    }
    return nextIndex;
}
/** For each cell index, gets the item index that occupies that cell */ function $4150656a089a918b$export$5334c96856356f08(sizes, cols, dense) {
    const cellMap = [];
    let startIndex = 0;
    sizes.forEach((_ref2, index)=>{
        let { width: width, height: height } = _ref2;
        let itemPlaced = false;
        if (dense) startIndex = 0;
        while(!itemPlaced){
            const targetCells = [];
            for(let i = 0; i < width; i++)for(let j = 0; j < height; j++)targetCells.push(startIndex + i + j * cols);
            if (startIndex % cols + width <= cols && targetCells.every((cell)=>cellMap[cell] == null)) {
                targetCells.forEach((cell)=>{
                    cellMap[cell] = index;
                });
                itemPlaced = true;
            } else startIndex++;
        }
    });
    // convert into a non-sparse array
    return [
        ...cellMap
    ];
}
/** Gets cell index of an item's corner or -1 when index is -1. */ function $4150656a089a918b$export$dab2b2ce7761f8e4(index, sizes, cellMap, cols, corner) {
    if (index === -1) return -1;
    const firstCellIndex = cellMap.indexOf(index);
    const sizeItem = sizes[index];
    switch(corner){
        case 'tl':
            return firstCellIndex;
        case 'tr':
            if (!sizeItem) return firstCellIndex;
            return firstCellIndex + sizeItem.width - 1;
        case 'bl':
            if (!sizeItem) return firstCellIndex;
            return firstCellIndex + (sizeItem.height - 1) * cols;
        case 'br':
            return cellMap.lastIndexOf(index);
    }
}
/** Gets all cell indices that correspond to the specified indices */ function $4150656a089a918b$export$50d8709b2ccc23f9(indices, cellMap) {
    return cellMap.flatMap((index, cellIndex)=>indices.includes(index) ? [
            cellIndex
        ] : []);
}
function $4150656a089a918b$export$446656ed0410fd9(listRef, index, disabledIndices) {
    if (typeof disabledIndices === 'function') return disabledIndices(index);
    else if (disabledIndices) return disabledIndices.includes(index);
    const element = listRef.current[index];
    return element == null || element.hasAttribute('disabled') || element.getAttribute('aria-disabled') === 'true';
}
const $4150656a089a918b$export$6324a2bbae6a332f = ()=>({
        getShadowRoot: true,
        displayCheck: // JSDOM does not support the `tabbable` library. To solve this we can
        // check if `ResizeObserver` is a real function (not polyfilled), which
        // determines if the current environment is JSDOM-like.
        typeof ResizeObserver === 'function' && ResizeObserver.toString().includes('[native code]') ? 'full' : 'none'
    });
function $4150656a089a918b$var$getTabbableIn(container, dir) {
    const list = (0, $9DaiF.tabbable)(container, $4150656a089a918b$export$6324a2bbae6a332f());
    const len = list.length;
    if (len === 0) return;
    const active = $4150656a089a918b$export$da980962bd2147a4($4150656a089a918b$export$f65ca476c09acec0(container));
    const index = list.indexOf(active);
    const nextIndex = index === -1 ? dir === 1 ? 0 : len - 1 : index + dir;
    return list[nextIndex];
}
function $4150656a089a918b$export$28f33206776129a7(referenceElement) {
    return $4150656a089a918b$var$getTabbableIn($4150656a089a918b$export$f65ca476c09acec0(referenceElement).body, 1) || referenceElement;
}
function $4150656a089a918b$export$2e5518c3303f364a(referenceElement) {
    return $4150656a089a918b$var$getTabbableIn($4150656a089a918b$export$f65ca476c09acec0(referenceElement).body, -1) || referenceElement;
}
function $4150656a089a918b$export$6e0c4e272f3faa2(event, container) {
    const containerElement = container || event.currentTarget;
    const relatedTarget = event.relatedTarget;
    return !relatedTarget || !$4150656a089a918b$export$2344b14b097df817(containerElement, relatedTarget);
}
function $4150656a089a918b$export$3995dd353b80da11(container) {
    const tabbableElements = (0, $9DaiF.tabbable)(container, $4150656a089a918b$export$6324a2bbae6a332f());
    tabbableElements.forEach((element)=>{
        element.dataset.tabindex = element.getAttribute('tabindex') || '';
        element.setAttribute('tabindex', '-1');
    });
}
function $4150656a089a918b$export$a65f4028abb17f36(container) {
    const elements = container.querySelectorAll('[data-tabindex]');
    elements.forEach((element)=>{
        const tabindex = element.dataset.tabindex;
        delete element.dataset.tabindex;
        if (tabindex) element.setAttribute('tabindex', tabindex);
        else element.removeAttribute('tabindex');
    });
}

});
parcelRegister("g7YZX", function(module, exports) {

$parcel$export(module.exports, "getNodeName", function () { return $bbdc9dc7be928366$export$651544f548703224; });
$parcel$export(module.exports, "isNode", function () { return $bbdc9dc7be928366$export$8ee0fc9ee280b4ee; });
$parcel$export(module.exports, "getWindow", function () { return $bbdc9dc7be928366$export$38b2d434cce3ea22; });
$parcel$export(module.exports, "getDocumentElement", function () { return $bbdc9dc7be928366$export$e495491855dc5418; });
$parcel$export(module.exports, "isElement", function () { return $bbdc9dc7be928366$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isHTMLElement", function () { return $bbdc9dc7be928366$export$1b3bfaa9684536aa; });
$parcel$export(module.exports, "isShadowRoot", function () { return $bbdc9dc7be928366$export$af51f0f06c0f328a; });
$parcel$export(module.exports, "isOverflowElement", function () { return $bbdc9dc7be928366$export$989e911fa9af580a; });
$parcel$export(module.exports, "getComputedStyle", function () { return $bbdc9dc7be928366$export$3735103072e4a80; });
$parcel$export(module.exports, "isTableElement", function () { return $bbdc9dc7be928366$export$71535ffaa902797f; });
$parcel$export(module.exports, "isTopLayer", function () { return $bbdc9dc7be928366$export$89e651af02346cd4; });
$parcel$export(module.exports, "isContainingBlock", function () { return $bbdc9dc7be928366$export$d6c4e8150c35fed1; });
$parcel$export(module.exports, "isWebKit", function () { return $bbdc9dc7be928366$export$78551043582a6a98; });
$parcel$export(module.exports, "getContainingBlock", function () { return $bbdc9dc7be928366$export$940d8225183e1404; });
$parcel$export(module.exports, "getParentNode", function () { return $bbdc9dc7be928366$export$4e12058fc4d51d56; });
$parcel$export(module.exports, "isLastTraversableNode", function () { return $bbdc9dc7be928366$export$d1162fb0b6d4cd51; });
$parcel$export(module.exports, "getNodeScroll", function () { return $bbdc9dc7be928366$export$dc8fc79fa2800137; });
$parcel$export(module.exports, "getOverflowAncestors", function () { return $bbdc9dc7be928366$export$3b57c1601291186b; });
$parcel$export(module.exports, "getFrameElement", function () { return $bbdc9dc7be928366$export$7bf1f8740e3e34af; });
function $bbdc9dc7be928366$var$hasWindow() {
    return typeof window !== 'undefined';
}
function $bbdc9dc7be928366$export$651544f548703224(node) {
    if ($bbdc9dc7be928366$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $bbdc9dc7be928366$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $bbdc9dc7be928366$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($bbdc9dc7be928366$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $bbdc9dc7be928366$export$8ee0fc9ee280b4ee(value) {
    if (!$bbdc9dc7be928366$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $bbdc9dc7be928366$export$38b2d434cce3ea22(value).Node;
}
function $bbdc9dc7be928366$export$45a5e7f76e0caa8d(value) {
    if (!$bbdc9dc7be928366$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $bbdc9dc7be928366$export$38b2d434cce3ea22(value).Element;
}
function $bbdc9dc7be928366$export$1b3bfaa9684536aa(value) {
    if (!$bbdc9dc7be928366$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $bbdc9dc7be928366$export$38b2d434cce3ea22(value).HTMLElement;
}
function $bbdc9dc7be928366$export$af51f0f06c0f328a(value) {
    if (!$bbdc9dc7be928366$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $bbdc9dc7be928366$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $bbdc9dc7be928366$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $bbdc9dc7be928366$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && display !== 'inline' && display !== 'contents';
}
function $bbdc9dc7be928366$export$71535ffaa902797f(element) {
    return /^(table|td|th)$/.test($bbdc9dc7be928366$export$651544f548703224(element));
}
function $bbdc9dc7be928366$export$89e651af02346cd4(element) {
    try {
        if (element.matches(':popover-open')) return true;
    } catch (_e) {
    // no-op
    }
    try {
        return element.matches(':modal');
    } catch (_e) {
        return false;
    }
}
const $bbdc9dc7be928366$var$willChangeRe = /transform|translate|scale|rotate|perspective|filter/;
const $bbdc9dc7be928366$var$containRe = /paint|layout|strict|content/;
const $bbdc9dc7be928366$var$isNotNone = (value)=>!!value && value !== 'none';
let $bbdc9dc7be928366$var$isWebKitValue;
function $bbdc9dc7be928366$export$d6c4e8150c35fed1(elementOrCss) {
    const css = $bbdc9dc7be928366$export$45a5e7f76e0caa8d(elementOrCss) ? $bbdc9dc7be928366$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    // https://drafts.csswg.org/css-transforms-2/#individual-transforms
    return $bbdc9dc7be928366$var$isNotNone(css.transform) || $bbdc9dc7be928366$var$isNotNone(css.translate) || $bbdc9dc7be928366$var$isNotNone(css.scale) || $bbdc9dc7be928366$var$isNotNone(css.rotate) || $bbdc9dc7be928366$var$isNotNone(css.perspective) || !$bbdc9dc7be928366$export$78551043582a6a98() && ($bbdc9dc7be928366$var$isNotNone(css.backdropFilter) || $bbdc9dc7be928366$var$isNotNone(css.filter)) || $bbdc9dc7be928366$var$willChangeRe.test(css.willChange || '') || $bbdc9dc7be928366$var$containRe.test(css.contain || '');
}
function $bbdc9dc7be928366$export$940d8225183e1404(element) {
    let currentNode = $bbdc9dc7be928366$export$4e12058fc4d51d56(element);
    while($bbdc9dc7be928366$export$1b3bfaa9684536aa(currentNode) && !$bbdc9dc7be928366$export$d1162fb0b6d4cd51(currentNode)){
        if ($bbdc9dc7be928366$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($bbdc9dc7be928366$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $bbdc9dc7be928366$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $bbdc9dc7be928366$export$78551043582a6a98() {
    if ($bbdc9dc7be928366$var$isWebKitValue == null) $bbdc9dc7be928366$var$isWebKitValue = typeof CSS !== 'undefined' && CSS.supports && CSS.supports('-webkit-backdrop-filter', 'none');
    return $bbdc9dc7be928366$var$isWebKitValue;
}
function $bbdc9dc7be928366$export$d1162fb0b6d4cd51(node) {
    return /^(html|body|#document)$/.test($bbdc9dc7be928366$export$651544f548703224(node));
}
function $bbdc9dc7be928366$export$3735103072e4a80(element) {
    return $bbdc9dc7be928366$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $bbdc9dc7be928366$export$dc8fc79fa2800137(element) {
    if ($bbdc9dc7be928366$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $bbdc9dc7be928366$export$4e12058fc4d51d56(node) {
    if ($bbdc9dc7be928366$export$651544f548703224(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $bbdc9dc7be928366$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $bbdc9dc7be928366$export$e495491855dc5418(node);
    return $bbdc9dc7be928366$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $bbdc9dc7be928366$export$7cd01a57c8ca906c(node) {
    const parentNode = $bbdc9dc7be928366$export$4e12058fc4d51d56(node);
    if ($bbdc9dc7be928366$export$d1162fb0b6d4cd51(parentNode)) return (node.ownerDocument || node).body;
    if ($bbdc9dc7be928366$export$1b3bfaa9684536aa(parentNode) && $bbdc9dc7be928366$export$989e911fa9af580a(parentNode)) return parentNode;
    return $bbdc9dc7be928366$export$7cd01a57c8ca906c(parentNode);
}
function $bbdc9dc7be928366$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $bbdc9dc7be928366$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $bbdc9dc7be928366$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $bbdc9dc7be928366$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $bbdc9dc7be928366$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $bbdc9dc7be928366$export$3b57c1601291186b(frameElement) : []);
    } else return list.concat(scrollableAncestor, $bbdc9dc7be928366$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $bbdc9dc7be928366$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}

});

parcelRegister("g3pjJ", function(module, exports) {

$parcel$export(module.exports, "sides", function () { return $bb0090a080b83b47$export$832b6fa47fa053d2; });
$parcel$export(module.exports, "placements", function () { return $bb0090a080b83b47$export$803cd8101b6c182b; });
$parcel$export(module.exports, "min", function () { return $bb0090a080b83b47$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "max", function () { return $bb0090a080b83b47$export$8960430cfd85939f; });
$parcel$export(module.exports, "round", function () { return $bb0090a080b83b47$export$2077e0241d6afd3c; });
$parcel$export(module.exports, "floor", function () { return $bb0090a080b83b47$export$a3fe094919f356fd; });
$parcel$export(module.exports, "createCoords", function () { return $bb0090a080b83b47$export$a397704b5e280835; });
$parcel$export(module.exports, "clamp", function () { return $bb0090a080b83b47$export$7d15b64cf5a3a4c4; });
$parcel$export(module.exports, "evaluate", function () { return $bb0090a080b83b47$export$fef61f332f2c0afc; });
$parcel$export(module.exports, "getSide", function () { return $bb0090a080b83b47$export$3c915306cb7fc97a; });
$parcel$export(module.exports, "getAlignment", function () { return $bb0090a080b83b47$export$f0989780f32bfcda; });
$parcel$export(module.exports, "getOppositeAxis", function () { return $bb0090a080b83b47$export$8a000a963141ac32; });
$parcel$export(module.exports, "getAxisLength", function () { return $bb0090a080b83b47$export$320bd9d53520c68a; });
$parcel$export(module.exports, "getSideAxis", function () { return $bb0090a080b83b47$export$f28e8f882010718a; });
$parcel$export(module.exports, "getAlignmentAxis", function () { return $bb0090a080b83b47$export$2b57e0052a6d6d4c; });
$parcel$export(module.exports, "getAlignmentSides", function () { return $bb0090a080b83b47$export$be42861551f17911; });
$parcel$export(module.exports, "getOppositePlacement", function () { return $bb0090a080b83b47$export$9c5e28bad23365fa; });
$parcel$export(module.exports, "getExpandedPlacements", function () { return $bb0090a080b83b47$export$496432a3699e50b1; });
$parcel$export(module.exports, "getOppositeAlignmentPlacement", function () { return $bb0090a080b83b47$export$2b182c584985588b; });
$parcel$export(module.exports, "getOppositeAxisPlacements", function () { return $bb0090a080b83b47$export$a9b6fb18fd92c3ec; });
$parcel$export(module.exports, "getPaddingObject", function () { return $bb0090a080b83b47$export$598c291c29bc2e71; });
$parcel$export(module.exports, "rectToClientRect", function () { return $bb0090a080b83b47$export$ee05aea0aeecbad4; });
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $bb0090a080b83b47$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $bb0090a080b83b47$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
const $bb0090a080b83b47$export$803cd8101b6c182b = /*#__PURE__*/ $bb0090a080b83b47$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $bb0090a080b83b47$export$27b07d8a310ed8b5[0], side + "-" + $bb0090a080b83b47$export$27b07d8a310ed8b5[1]), []);
const $bb0090a080b83b47$export$96ec731ed4dcb222 = Math.min;
const $bb0090a080b83b47$export$8960430cfd85939f = Math.max;
const $bb0090a080b83b47$export$2077e0241d6afd3c = Math.round;
const $bb0090a080b83b47$export$a3fe094919f356fd = Math.floor;
const $bb0090a080b83b47$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $bb0090a080b83b47$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $bb0090a080b83b47$export$7d15b64cf5a3a4c4(start, value, end) {
    return $bb0090a080b83b47$export$8960430cfd85939f(start, $bb0090a080b83b47$export$96ec731ed4dcb222(value, end));
}
function $bb0090a080b83b47$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $bb0090a080b83b47$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $bb0090a080b83b47$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $bb0090a080b83b47$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $bb0090a080b83b47$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function $bb0090a080b83b47$export$f28e8f882010718a(placement) {
    const firstChar = placement[0];
    return firstChar === 't' || firstChar === 'b' ? 'y' : 'x';
}
function $bb0090a080b83b47$export$2b57e0052a6d6d4c(placement) {
    return $bb0090a080b83b47$export$8a000a963141ac32($bb0090a080b83b47$export$f28e8f882010718a(placement));
}
function $bb0090a080b83b47$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $bb0090a080b83b47$export$f0989780f32bfcda(placement);
    const alignmentAxis = $bb0090a080b83b47$export$2b57e0052a6d6d4c(placement);
    const length = $bb0090a080b83b47$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $bb0090a080b83b47$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $bb0090a080b83b47$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $bb0090a080b83b47$export$496432a3699e50b1(placement) {
    const oppositePlacement = $bb0090a080b83b47$export$9c5e28bad23365fa(placement);
    return [
        $bb0090a080b83b47$export$2b182c584985588b(placement),
        oppositePlacement,
        $bb0090a080b83b47$export$2b182c584985588b(oppositePlacement)
    ];
}
function $bb0090a080b83b47$export$2b182c584985588b(placement) {
    return placement.includes('start') ? placement.replace('start', 'end') : placement.replace('end', 'start');
}
const $bb0090a080b83b47$var$lrPlacement = [
    'left',
    'right'
];
const $bb0090a080b83b47$var$rlPlacement = [
    'right',
    'left'
];
const $bb0090a080b83b47$var$tbPlacement = [
    'top',
    'bottom'
];
const $bb0090a080b83b47$var$btPlacement = [
    'bottom',
    'top'
];
function $bb0090a080b83b47$var$getSideList(side, isStart, rtl) {
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? $bb0090a080b83b47$var$rlPlacement : $bb0090a080b83b47$var$lrPlacement;
            return isStart ? $bb0090a080b83b47$var$lrPlacement : $bb0090a080b83b47$var$rlPlacement;
        case 'left':
        case 'right':
            return isStart ? $bb0090a080b83b47$var$tbPlacement : $bb0090a080b83b47$var$btPlacement;
        default:
            return [];
    }
}
function $bb0090a080b83b47$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $bb0090a080b83b47$export$f0989780f32bfcda(placement);
    let list = $bb0090a080b83b47$var$getSideList($bb0090a080b83b47$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($bb0090a080b83b47$export$2b182c584985588b));
    }
    return list;
}
function $bb0090a080b83b47$export$9c5e28bad23365fa(placement) {
    const side = $bb0090a080b83b47$export$3c915306cb7fc97a(placement);
    return $bb0090a080b83b47$var$oppositeSideMap[side] + placement.slice(side.length);
}
function $bb0090a080b83b47$export$1c66dbf1a9e34223(padding) {
    var _padding$top, _padding$right, _padding$bottom, _padding$left;
    return {
        top: (_padding$top = padding.top) != null ? _padding$top : 0,
        right: (_padding$right = padding.right) != null ? _padding$right : 0,
        bottom: (_padding$bottom = padding.bottom) != null ? _padding$bottom : 0,
        left: (_padding$left = padding.left) != null ? _padding$left : 0
    };
}
function $bb0090a080b83b47$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $bb0090a080b83b47$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $bb0090a080b83b47$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}

});

parcelRegister("9DaiF", function(module, exports) {

$parcel$export(module.exports, "tabbable", function () { return $702fbef9d8e3b98f$export$17100aea90429aa7; });
$parcel$export(module.exports, "focusable", function () { return $702fbef9d8e3b98f$export$ecc6d1fcdff4f700; });
$parcel$export(module.exports, "isTabbable", function () { return $702fbef9d8e3b98f$export$bebd5a1431fec25d; });
/*!
* tabbable 6.5.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/ // NOTE: separate `:not()` selectors has broader browser support than the newer
//  `:not([inert], [inert] *)` (Feb 2023)
var $702fbef9d8e3b98f$var$candidateSelectors = [
    'input:not([inert]):not([inert] *)',
    'select:not([inert]):not([inert] *)',
    'textarea:not([inert]):not([inert] *)',
    'a[href]:not([inert]):not([inert] *)',
    'area[href]:not([inert]):not([inert] *)',
    'button:not([inert]):not([inert] *)',
    '[tabindex]:not(slot):not([inert]):not([inert] *)',
    'audio[controls]:not([inert]):not([inert] *)',
    'video[controls]:not([inert]):not([inert] *)',
    '[contenteditable]:not([contenteditable="false"]):not([inert]):not([inert] *)',
    'details>summary:first-of-type:not([inert]):not([inert] *)',
    'details:not([inert]):not([inert] *)'
];
var $702fbef9d8e3b98f$var$candidateSelector = /* #__PURE__ */ $702fbef9d8e3b98f$var$candidateSelectors.join(',');
var $702fbef9d8e3b98f$var$NoElement = typeof Element === 'undefined';
var $702fbef9d8e3b98f$var$matches = $702fbef9d8e3b98f$var$NoElement ? function() {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var $702fbef9d8e3b98f$var$getRootNode = !$702fbef9d8e3b98f$var$NoElement && Element.prototype.getRootNode ? function(element) {
    var _element$getRootNode;
    return element === null || element === void 0 ? void 0 : (_element$getRootNode = element.getRootNode) === null || _element$getRootNode === void 0 ? void 0 : _element$getRootNode.call(element);
} : function(element) {
    return element === null || element === void 0 ? void 0 : element.ownerDocument;
};
/**
 * Determines if a node is inert or in an inert ancestor.
 * @param {Node} [node]
 * @param {boolean} [lookUp] If true and `node` is not inert, looks up at ancestors to
 *  see if any of them are inert. If false, only `node` itself is considered.
 * @returns {boolean} True if inert itself or by way of being in an inert ancestor.
 *  False if `node` is falsy.
 */ var $702fbef9d8e3b98f$var$_isInert = function isInert(node, lookUp) {
    var _node$getAttribute;
    if (lookUp === void 0) lookUp = true;
    // CAREFUL: JSDom does not support inert at all, so we can't use the `HTMLElement.inert`
    //  JS API property; we have to check the attribute, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's an active element
    var inertAtt = node === null || node === void 0 ? void 0 : (_node$getAttribute = node.getAttribute) === null || _node$getAttribute === void 0 ? void 0 : _node$getAttribute.call(node, 'inert');
    var inert = inertAtt === '' || inertAtt === 'true';
    // NOTE: this could also be handled with `node.matches('[inert], :is([inert] *)')`
    //  if it weren't for `matches()` not being a function on shadow roots; the following
    //  code works for any kind of node
    var result = inert || lookUp && node && // closest does not exist on shadow roots, so we fall back to a manual
    // lookup upward, in case it is not defined.
    (typeof node.closest === 'function' ? node.closest('[inert]') : $702fbef9d8e3b98f$var$_isInert(node.parentNode));
    return result;
};
/**
 * Determines if a node's content is editable.
 * @param {Element} [node]
 * @returns True if it's content-editable; false if it's not or `node` is falsy.
 */ var $702fbef9d8e3b98f$var$isContentEditable = function isContentEditable(node) {
    var _node$getAttribute2;
    // CAREFUL: JSDom does not support the `HTMLElement.isContentEditable` API so we have
    //  to use the attribute directly to check for this, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's a non-editable element
    var attValue = node === null || node === void 0 ? void 0 : (_node$getAttribute2 = node.getAttribute) === null || _node$getAttribute2 === void 0 ? void 0 : _node$getAttribute2.call(node, 'contenteditable');
    return attValue === '' || attValue === 'true';
};
/**
 * @param {Element} el container to check in
 * @param {boolean} includeContainer add container to check
 * @param {(node: Element) => boolean} filter filter candidates
 * @returns {Element[]}
 */ var $702fbef9d8e3b98f$var$getCandidates = function getCandidates(el, includeContainer, filter) {
    // even if `includeContainer=false`, we still have to check it for inertness because
    //  if it's inert (either by itself or via its parent), then all its children are inert
    if ($702fbef9d8e3b98f$var$_isInert(el)) return [];
    var candidates = Array.prototype.slice.apply(el.querySelectorAll($702fbef9d8e3b98f$var$candidateSelector));
    if (includeContainer && $702fbef9d8e3b98f$var$matches.call(el, $702fbef9d8e3b98f$var$candidateSelector)) candidates.unshift(el);
    candidates = candidates.filter(filter);
    return candidates;
};
/**
 * @callback GetShadowRoot
 * @param {Element} element to check for shadow root
 * @returns {ShadowRoot|boolean} ShadowRoot if available or boolean indicating if a shadowRoot is attached but not available.
 */ /**
 * @callback ShadowRootFilter
 * @param {Element} shadowHostNode the element which contains shadow content
 * @returns {boolean} true if a shadow root could potentially contain valid candidates.
 */ /**
 * @typedef {Object} CandidateScope
 * @property {Element} scopeParent contains inner candidates
 * @property {Element[]} candidates list of candidates found in the scope parent
 */ /**
 * @typedef {Object} IterativeOptions
 * @property {GetShadowRoot|boolean} getShadowRoot true if shadow support is enabled; falsy if not;
 *  if a function, implies shadow support is enabled and either returns the shadow root of an element
 *  or a boolean stating if it has an undisclosed shadow root
 * @property {(node: Element) => boolean} filter filter candidates
 * @property {boolean} flatten if true then result will flatten any CandidateScope into the returned list
 * @property {ShadowRootFilter} shadowRootFilter filter shadow roots;
 */ /**
 * @param {Element[]} elements list of element containers to match candidates from
 * @param {boolean} includeContainer add container list to check
 * @param {IterativeOptions} options
 * @returns {Array.<Element|CandidateScope>}
 */ var $702fbef9d8e3b98f$var$_getCandidatesIteratively = function getCandidatesIteratively(elements, includeContainer, options) {
    var candidates = [];
    var elementsToCheck = Array.from(elements);
    while(elementsToCheck.length){
        var element = elementsToCheck.shift();
        if ($702fbef9d8e3b98f$var$_isInert(element, false)) continue;
        if (element.tagName === 'SLOT') {
            // add shadow dom slot scope (slot itself cannot be focusable)
            var assigned = element.assignedElements();
            var content = assigned.length ? assigned : element.children;
            var nestedCandidates = $702fbef9d8e3b98f$var$_getCandidatesIteratively(content, true, options);
            if (options.flatten) candidates.push.apply(candidates, nestedCandidates);
            else candidates.push({
                scopeParent: element,
                candidates: nestedCandidates
            });
        } else {
            // check candidate element
            var validCandidate = $702fbef9d8e3b98f$var$matches.call(element, $702fbef9d8e3b98f$var$candidateSelector);
            if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) candidates.push(element);
            // iterate over shadow content if possible
            var shadowRoot = element.shadowRoot || // check for an undisclosed shadow
            typeof options.getShadowRoot === 'function' && options.getShadowRoot(element);
            // no inert look up because we're already drilling down and checking for inertness
            //  on the way down, so all containers to this root node should have already been
            //  vetted as non-inert
            var validShadowRoot = !$702fbef9d8e3b98f$var$_isInert(shadowRoot, false) && (!options.shadowRootFilter || options.shadowRootFilter(element));
            if (shadowRoot && validShadowRoot) {
                // add shadow dom scope IIF a shadow root node was given; otherwise, an undisclosed
                //  shadow exists, so look at light dom children as fallback BUT create a scope for any
                //  child candidates found because they're likely slotted elements (elements that are
                //  children of the web component element (which has the shadow), in the light dom, but
                //  slotted somewhere _inside_ the undisclosed shadow) -- the scope is created below,
                //  _after_ we return from this recursive call
                var _nestedCandidates = $702fbef9d8e3b98f$var$_getCandidatesIteratively(shadowRoot === true ? element.children : shadowRoot.children, true, options);
                if (options.flatten) candidates.push.apply(candidates, _nestedCandidates);
                else candidates.push({
                    scopeParent: element,
                    candidates: _nestedCandidates
                });
            } else // there's not shadow so just dig into the element's (light dom) children
            //  __without__ giving the element special scope treatment
            elementsToCheck.unshift.apply(elementsToCheck, element.children);
        }
    }
    return candidates;
};
/**
 * @private
 * Determines if the node has an explicitly specified `tabindex` attribute.
 * @param {HTMLElement} node
 * @returns {boolean} True if so; false if not.
 */ var $702fbef9d8e3b98f$var$hasTabIndex = function hasTabIndex(node) {
    return !isNaN(parseInt(node.getAttribute('tabindex'), 10));
};
/**
 * Determine the tab index of a given node.
 * @param {HTMLElement} node
 * @returns {number} Tab order (negative, 0, or positive number).
 * @throws {Error} If `node` is falsy.
 */ var $702fbef9d8e3b98f$export$a4672efddb4181b8 = function getTabIndex(node) {
    if (!node) throw new Error('No node provided');
    if (node.tabIndex < 0) {
        // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
        // `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
        // yet they are still part of the regular tab order; in FF, they get a default
        // `tabIndex` of 0; since Chrome still puts those elements in the regular tab
        // order, consider their tab index to be 0.
        // Also browsers do not return `tabIndex` correctly for contentEditable nodes;
        // so if they don't have a tabindex attribute specifically set, assume it's 0.
        if ((/^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || $702fbef9d8e3b98f$var$isContentEditable(node)) && !$702fbef9d8e3b98f$var$hasTabIndex(node)) return 0;
    }
    return node.tabIndex;
};
/**
 * Determine the tab index of a given node __for sort order purposes__.
 * @param {HTMLElement} node
 * @param {boolean} [isScope] True for a custom element with shadow root or slot that, by default,
 *  has tabIndex -1, but needs to be sorted by document order in order for its content to be
 *  inserted into the correct sort position.
 * @returns {number} Tab order (negative, 0, or positive number).
 */ var $702fbef9d8e3b98f$var$getSortOrderTabIndex = function getSortOrderTabIndex(node, isScope) {
    var tabIndex = $702fbef9d8e3b98f$export$a4672efddb4181b8(node);
    if (tabIndex < 0 && isScope && !$702fbef9d8e3b98f$var$hasTabIndex(node)) return 0;
    return tabIndex;
};
var $702fbef9d8e3b98f$var$sortOrderedTabbables = function sortOrderedTabbables(a, b) {
    return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var $702fbef9d8e3b98f$var$isInput = function isInput(node) {
    return node.tagName === 'INPUT';
};
var $702fbef9d8e3b98f$var$isHiddenInput = function isHiddenInput(node) {
    return $702fbef9d8e3b98f$var$isInput(node) && node.type === 'hidden';
};
var $702fbef9d8e3b98f$var$isDetailsWithSummary = function isDetailsWithSummary(node) {
    var r = node.tagName === 'DETAILS' && Array.prototype.slice.apply(node.children).some(function(child) {
        return child.tagName === 'SUMMARY';
    });
    return r;
};
var $702fbef9d8e3b98f$var$getCheckedRadio = function getCheckedRadio(nodes, form) {
    for(var i = 0; i < nodes.length; i++){
        if (nodes[i].checked && nodes[i].form === form) return nodes[i];
    }
};
var $702fbef9d8e3b98f$var$isTabbableRadio = function isTabbableRadio(node) {
    if (!node.name) return true;
    var radioScope = node.form || $702fbef9d8e3b98f$var$getRootNode(node);
    var queryRadios = function queryRadios(name) {
        return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
    };
    var radioSet;
    if (typeof window !== 'undefined' && typeof window.CSS !== 'undefined' && typeof window.CSS.escape === 'function') radioSet = queryRadios(window.CSS.escape(node.name));
    else try {
        radioSet = queryRadios(node.name);
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error('Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s', err.message);
        return false;
    }
    var checked = $702fbef9d8e3b98f$var$getCheckedRadio(radioSet, node.form);
    return !checked || checked === node;
};
var $702fbef9d8e3b98f$var$isRadio = function isRadio(node) {
    return $702fbef9d8e3b98f$var$isInput(node) && node.type === 'radio';
};
var $702fbef9d8e3b98f$var$isNonTabbableRadio = function isNonTabbableRadio(node) {
    return $702fbef9d8e3b98f$var$isRadio(node) && !$702fbef9d8e3b98f$var$isTabbableRadio(node);
};
// determines if a node is ultimately attached to the window's document
var $702fbef9d8e3b98f$var$isNodeAttached = function isNodeAttached(node) {
    var _nodeRoot;
    // The root node is the shadow root if the node is in a shadow DOM; some document otherwise
    //  (but NOT _the_ document; see second 'If' comment below for more).
    // If rootNode is shadow root, it'll have a host, which is the element to which the shadow
    //  is attached, and the one we need to check if it's in the document or not (because the
    //  shadow, and all nodes it contains, is never considered in the document since shadows
    //  behave like self-contained DOMs; but if the shadow's HOST, which is part of the document,
    //  is hidden, or is not in the document itself but is detached, it will affect the shadow's
    //  visibility, including all the nodes it contains). The host could be any normal node,
    //  or a custom element (i.e. web component). Either way, that's the one that is considered
    //  part of the document, not the shadow root, nor any of its children (i.e. the node being
    //  tested).
    // To further complicate things, we have to look all the way up until we find a shadow HOST
    //  that is attached (or find none) because the node might be in nested shadows...
    // If rootNode is not a shadow root, it won't have a host, and so rootNode should be the
    //  document (per the docs) and while it's a Document-type object, that document does not
    //  appear to be the same as the node's `ownerDocument` for some reason, so it's safer
    //  to ignore the rootNode at this point, and use `node.ownerDocument`. Otherwise,
    //  using `rootNode.contains(node)` will _always_ be true we'll get false-positives when
    //  node is actually detached.
    // NOTE: If `nodeRootHost` or `node` happens to be the `document` itself (which is possible
    //  if a tabbable/focusable node was quickly added to the DOM, focused, and then removed
    //  from the DOM as in https://github.com/focus-trap/focus-trap-react/issues/905), then
    //  `ownerDocument` will be `null`, hence the optional chaining on it.
    var nodeRoot = node && $702fbef9d8e3b98f$var$getRootNode(node);
    var nodeRootHost = (_nodeRoot = nodeRoot) === null || _nodeRoot === void 0 ? void 0 : _nodeRoot.host;
    // in some cases, a detached node will return itself as the root instead of a document or
    //  shadow root object, in which case, we shouldn't try to look further up the host chain
    var attached = false;
    if (nodeRoot && nodeRoot !== node) {
        var _nodeRootHost, _nodeRootHost$ownerDo, _node$ownerDocument;
        attached = !!((_nodeRootHost = nodeRootHost) !== null && _nodeRootHost !== void 0 && (_nodeRootHost$ownerDo = _nodeRootHost.ownerDocument) !== null && _nodeRootHost$ownerDo !== void 0 && _nodeRootHost$ownerDo.contains(nodeRootHost) || node !== null && node !== void 0 && (_node$ownerDocument = node.ownerDocument) !== null && _node$ownerDocument !== void 0 && _node$ownerDocument.contains(node));
        while(!attached && nodeRootHost){
            var _nodeRoot2, _nodeRootHost2, _nodeRootHost2$ownerD;
            // since it's not attached and we have a root host, the node MUST be in a nested shadow DOM,
            //  which means we need to get the host's host and check if that parent host is contained
            //  in (i.e. attached to) the document
            nodeRoot = $702fbef9d8e3b98f$var$getRootNode(nodeRootHost);
            nodeRootHost = (_nodeRoot2 = nodeRoot) === null || _nodeRoot2 === void 0 ? void 0 : _nodeRoot2.host;
            attached = !!((_nodeRootHost2 = nodeRootHost) !== null && _nodeRootHost2 !== void 0 && (_nodeRootHost2$ownerD = _nodeRootHost2.ownerDocument) !== null && _nodeRootHost2$ownerD !== void 0 && _nodeRootHost2$ownerD.contains(nodeRootHost));
        }
    }
    return attached;
};
var $702fbef9d8e3b98f$var$isZeroArea = function isZeroArea(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(), width = _node$getBoundingClie.width, height = _node$getBoundingClie.height;
    return width === 0 && height === 0;
};
var $702fbef9d8e3b98f$var$isHidden = function isHidden(node, _ref) {
    var displayCheck = _ref.displayCheck, getShadowRoot = _ref.getShadowRoot;
    if (displayCheck === 'full-native') {
        if ('checkVisibility' in node) {
            // Chrome >= 105, Edge >= 105, Firefox >= 106, Safari >= 17.4
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Element/checkVisibility#browser_compatibility
            var visible = node.checkVisibility({
                // Checking opacity might be desirable for some use cases, but natively,
                // opacity zero elements _are_ focusable and tabbable.
                checkOpacity: false,
                opacityProperty: false,
                contentVisibilityAuto: true,
                visibilityProperty: true,
                // This is an alias for `visibilityProperty`. Contemporary browsers
                // support both. However, this alias has wider browser support (Chrome
                // >= 105 and Firefox >= 106, vs. Chrome >= 121 and Firefox >= 122), so
                // we include it anyway.
                checkVisibilityCSS: true
            });
            return !visible;
        }
    }
    // NOTE: visibility will be `undefined` if node is detached from the document
    //  (see notes about this further down), which means we will consider it visible
    //  (this is legacy behavior from a very long way back)
    // NOTE: we check this regardless of `displayCheck="none"` because this is a
    //  _visibility_ check, not a _display_ check
    var _getComputedStyle = getComputedStyle(node), visibility = _getComputedStyle.visibility;
    if (visibility === 'hidden' || visibility === 'collapse') return true;
    var isDirectSummary = $702fbef9d8e3b98f$var$matches.call(node, 'details>summary:first-of-type');
    var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
    if ($702fbef9d8e3b98f$var$matches.call(nodeUnderDetails, 'details:not([open]) *')) return true;
    if (!displayCheck || displayCheck === 'full' || // full-native can run this branch when it falls through in case
    // Element#checkVisibility is unsupported
    displayCheck === 'full-native' || displayCheck === 'legacy-full') {
        if (typeof getShadowRoot === 'function') {
            // figure out if we should consider the node to be in an undisclosed shadow and use the
            //  'non-zero-area' fallback
            var originalNode = node;
            while(node){
                var parentElement = node.parentElement;
                var rootNode = $702fbef9d8e3b98f$var$getRootNode(node);
                if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true // check if there's an undisclosed shadow
                ) // node has an undisclosed shadow which means we can only treat it as a black box, so we
                //  fall back to a non-zero-area test
                return $702fbef9d8e3b98f$var$isZeroArea(node);
                else if (node.assignedSlot) // iterate up slot
                node = node.assignedSlot;
                else if (!parentElement && rootNode !== node.ownerDocument) // cross shadow boundary
                node = rootNode.host;
                else // iterate up normal dom
                node = parentElement;
            }
            node = originalNode;
        }
        // else, `getShadowRoot` might be true, but all that does is enable shadow DOM support
        //  (i.e. it does not also presume that all nodes might have undisclosed shadows); or
        //  it might be a falsy value, which means shadow DOM support is disabled
        // Since we didn't find it sitting in an undisclosed shadow (or shadows are disabled)
        //  now we can just test to see if it would normally be visible or not, provided it's
        //  attached to the main document.
        // NOTE: We must consider case where node is inside a shadow DOM and given directly to
        //  `isTabbable()` or `isFocusable()` -- regardless of `getShadowRoot` option setting.
        if ($702fbef9d8e3b98f$var$isNodeAttached(node)) // this works wherever the node is: if there's at least one client rect, it's
        //  somehow displayed; it also covers the CSS 'display: contents' case where the
        //  node itself is hidden in place of its contents; and there's no need to search
        //  up the hierarchy either
        return !node.getClientRects().length;
        // Else, the node isn't attached to the document, which means the `getClientRects()`
        //  API will __always__ return zero rects (this can happen, for example, if React
        //  is used to render nodes onto a detached tree, as confirmed in this thread:
        //  https://github.com/facebook/react/issues/9117#issuecomment-284228870)
        //
        // It also means that even window.getComputedStyle(node).display will return `undefined`
        //  because styles are only computed for nodes that are in the document.
        //
        // NOTE: THIS HAS BEEN THE CASE FOR YEARS. It is not new, nor is it caused by tabbable
        //  somehow. Though it was never stated officially, anyone who has ever used tabbable
        //  APIs on nodes in detached containers has actually implicitly used tabbable in what
        //  was later (as of v5.2.0 on Apr 9, 2021) called `displayCheck="none"` mode -- essentially
        //  considering __everything__ to be visible because of the innability to determine styles.
        //
        // v6.0.0: As of this major release, the default 'full' option __no longer treats detached
        //  nodes as visible with the 'none' fallback.__
        if (displayCheck !== 'legacy-full') return true; // hidden
    // else, fallback to 'none' mode and consider the node visible
    } else if (displayCheck === 'non-zero-area') // NOTE: Even though this tests that the node's client rect is non-zero to determine
    //  whether it's displayed, and that a detached node will __always__ have a zero-area
    //  client rect, we don't special-case for whether the node is attached or not. In
    //  this mode, we do want to consider nodes that have a zero area to be hidden at all
    //  times, and that includes attached or not.
    return $702fbef9d8e3b98f$var$isZeroArea(node);
    // visible, as far as we can tell, or per current `displayCheck=none` mode, we assume
    //  it's visible
    return false;
};
// form fields (nested) inside a disabled fieldset are not focusable/tabbable
//  unless they are in the _first_ <legend> element of the top-most disabled
//  fieldset
var $702fbef9d8e3b98f$var$isDisabledFromFieldset = function isDisabledFromFieldset(node) {
    if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
        var parentNode = node.parentElement;
        // check if `node` is contained in a disabled <fieldset>
        while(parentNode){
            if (parentNode.tagName === 'FIELDSET' && parentNode.disabled) {
                // look for the first <legend> among the children of the disabled <fieldset>
                for(var i = 0; i < parentNode.children.length; i++){
                    var child = parentNode.children.item(i);
                    // when the first <legend> (in document order) is found
                    if (child.tagName === 'LEGEND') // if its parent <fieldset> is not nested in another disabled <fieldset>,
                    // return whether `node` is a descendant of its first <legend>
                    return $702fbef9d8e3b98f$var$matches.call(parentNode, 'fieldset[disabled] *') ? true : !child.contains(node);
                }
                // the disabled <fieldset> containing `node` has no <legend>
                return true;
            }
            parentNode = parentNode.parentElement;
        }
    }
    // else, node's tabbable/focusable state should not be affected by a fieldset's
    //  enabled/disabled state
    return false;
};
var $702fbef9d8e3b98f$var$isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
    if (node.disabled || $702fbef9d8e3b98f$var$isHiddenInput(node) || $702fbef9d8e3b98f$var$isHidden(node, options) || // For a details element with a summary, the summary element gets the focus
    $702fbef9d8e3b98f$var$isDetailsWithSummary(node) || $702fbef9d8e3b98f$var$isDisabledFromFieldset(node)) return false;
    return true;
};
var $702fbef9d8e3b98f$var$isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
    if ($702fbef9d8e3b98f$var$isNonTabbableRadio(node) || $702fbef9d8e3b98f$export$a4672efddb4181b8(node) < 0 || !$702fbef9d8e3b98f$var$isNodeMatchingSelectorFocusable(options, node)) return false;
    return true;
};
var $702fbef9d8e3b98f$var$isShadowRootTabbable = function isShadowRootTabbable(shadowHostNode) {
    var tabIndex = parseInt(shadowHostNode.getAttribute('tabindex'), 10);
    if (isNaN(tabIndex) || tabIndex >= 0) return true;
    // If a custom element has an explicit negative tabindex,
    // browsers will not allow tab targeting said element's children.
    return false;
};
/**
 * @param {Array.<Element|CandidateScope>} candidates
 * @returns Element[]
 */ var $702fbef9d8e3b98f$var$_sortByOrder = function sortByOrder(candidates) {
    var regularTabbables = [];
    var orderedTabbables = [];
    candidates.forEach(function(item, i) {
        var isScope = !!item.scopeParent;
        var element = isScope ? item.scopeParent : item;
        var candidateTabindex = $702fbef9d8e3b98f$var$getSortOrderTabIndex(element, isScope);
        var elements = isScope ? $702fbef9d8e3b98f$var$_sortByOrder(item.candidates) : element;
        if (candidateTabindex === 0) isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
        else orderedTabbables.push({
            documentOrder: i,
            tabIndex: candidateTabindex,
            item: item,
            isScope: isScope,
            content: elements
        });
    });
    return orderedTabbables.sort($702fbef9d8e3b98f$var$sortOrderedTabbables).reduce(function(acc, sortable) {
        sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
        return acc;
    }, []).concat(regularTabbables);
};
var $702fbef9d8e3b98f$export$17100aea90429aa7 = function tabbable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $702fbef9d8e3b98f$var$_getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $702fbef9d8e3b98f$var$isNodeMatchingSelectorTabbable.bind(null, options),
        flatten: false,
        getShadowRoot: options.getShadowRoot,
        shadowRootFilter: $702fbef9d8e3b98f$var$isShadowRootTabbable
    });
    else candidates = $702fbef9d8e3b98f$var$getCandidates(container, options.includeContainer, $702fbef9d8e3b98f$var$isNodeMatchingSelectorTabbable.bind(null, options));
    return $702fbef9d8e3b98f$var$_sortByOrder(candidates);
};
var $702fbef9d8e3b98f$export$ecc6d1fcdff4f700 = function focusable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $702fbef9d8e3b98f$var$_getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $702fbef9d8e3b98f$var$isNodeMatchingSelectorFocusable.bind(null, options),
        flatten: true,
        getShadowRoot: options.getShadowRoot
    });
    else candidates = $702fbef9d8e3b98f$var$getCandidates(container, options.includeContainer, $702fbef9d8e3b98f$var$isNodeMatchingSelectorFocusable.bind(null, options));
    return candidates;
};
var $702fbef9d8e3b98f$export$bebd5a1431fec25d = function isTabbable(node, options) {
    options = options || {};
    if (!node) throw new Error('No node provided');
    if ($702fbef9d8e3b98f$var$matches.call(node, $702fbef9d8e3b98f$var$candidateSelector) === false) return false;
    return $702fbef9d8e3b98f$var$isNodeMatchingSelectorTabbable(options, node);
};
var $702fbef9d8e3b98f$var$focusableCandidateSelector = /* #__PURE__ */ $702fbef9d8e3b98f$var$candidateSelectors.concat('iframe:not([inert]):not([inert] *)').join(',');
var $702fbef9d8e3b98f$export$4c063cf1350e6fed = function isFocusable(node, options) {
    options = options || {};
    if (!node) throw new Error('No node provided');
    if ($702fbef9d8e3b98f$var$matches.call(node, $702fbef9d8e3b98f$var$focusableCandidateSelector) === false) return false;
    return $702fbef9d8e3b98f$var$isNodeMatchingSelectorFocusable(options, node);
};

});


parcelRegister("7Tw3V", function(module, exports) {
'use strict';

module.exports = (parcelRequire("g4RT4"));

});

parcelRegister("dA4dV", function(module, exports) {

$parcel$export(module.exports, "useFloating", function () { return $9e31e9e36f545519$export$4e02a5c1d08bac65; });
$parcel$export(module.exports, "offset", function () { return $9e31e9e36f545519$export$cc800923e997bb8; });
$parcel$export(module.exports, "shift", function () { return $9e31e9e36f545519$export$fba63a578e423eb; });
$parcel$export(module.exports, "limitShift", function () { return $9e31e9e36f545519$export$7bf07e38f3dc4b69; });
$parcel$export(module.exports, "flip", function () { return $9e31e9e36f545519$export$8a83211c878a3f1f; });
$parcel$export(module.exports, "size", function () { return $9e31e9e36f545519$export$346677f925de839c; });
$parcel$export(module.exports, "autoPlacement", function () { return $9e31e9e36f545519$export$91fb6ecbd551914; });
$parcel$export(module.exports, "hide", function () { return $9e31e9e36f545519$export$fe8985bb6374093c; });
$parcel$export(module.exports, "inline", function () { return $9e31e9e36f545519$export$18c8ad048e32c7d5; });
$parcel$export(module.exports, "arrow", function () { return $9e31e9e36f545519$export$f2120bbfa5450bd2; });
$parcel$export(module.exports, "computePosition", function () { return (parcelRequire("af8LA")).computePosition; });

var $af8LA = parcelRequire("af8LA");
var $g7YZX = parcelRequire("g7YZX");

var $cQQee = parcelRequire("cQQee");

var $kC364 = parcelRequire("kC364");
var $9e31e9e36f545519$var$isClient = typeof document !== 'undefined';
var $9e31e9e36f545519$var$noop = function noop() {};
var $9e31e9e36f545519$var$index = $9e31e9e36f545519$var$isClient ? (0, $cQQee.useLayoutEffect) : $9e31e9e36f545519$var$noop;
// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function $9e31e9e36f545519$var$deepEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (typeof a === 'function' && a.toString() === b.toString()) return true;
    let length;
    let i;
    let keys;
    if (a && b && typeof a === 'object') {
        if (Array.isArray(a)) {
            length = a.length;
            if (length !== b.length) return false;
            for(i = length; i-- !== 0;){
                if (!$9e31e9e36f545519$var$deepEqual(a[i], b[i])) return false;
            }
            return true;
        }
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;){
            if (!({}).hasOwnProperty.call(b, keys[i])) return false;
        }
        for(i = length; i-- !== 0;){
            const key = keys[i];
            if (key === '_owner' && a.$$typeof) continue;
            if (!$9e31e9e36f545519$var$deepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
}
function $9e31e9e36f545519$var$getDPR(element) {
    if (typeof window === 'undefined') return 1;
    const win = element.ownerDocument.defaultView || window;
    return win.devicePixelRatio || 1;
}
function $9e31e9e36f545519$var$roundByDPR(element, value) {
    const dpr = $9e31e9e36f545519$var$getDPR(element);
    return Math.round(value * dpr) / dpr;
}
function $9e31e9e36f545519$var$useLatestRef(value) {
    const ref = $cQQee.useRef(value);
    $9e31e9e36f545519$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/useFloating
 */ function $9e31e9e36f545519$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform, elements: { reference: externalReference, floating: externalFloating } = {}, transform: transform = true, whileElementsMounted: whileElementsMounted, open: open } = options;
    const [data, setData] = $cQQee.useState({
        x: 0,
        y: 0,
        strategy: strategy,
        placement: placement,
        middlewareData: {},
        isPositioned: false
    });
    const [latestMiddleware, setLatestMiddleware] = $cQQee.useState(middleware);
    if (!$9e31e9e36f545519$var$deepEqual(latestMiddleware, middleware)) setLatestMiddleware(middleware);
    const [_reference, _setReference] = $cQQee.useState(null);
    const [_floating, _setFloating] = $cQQee.useState(null);
    const setReference = $cQQee.useCallback((node)=>{
        if (node !== referenceRef.current) {
            referenceRef.current = node;
            _setReference(node);
        }
    }, []);
    const setFloating = $cQQee.useCallback((node)=>{
        if (node !== floatingRef.current) {
            floatingRef.current = node;
            _setFloating(node);
        }
    }, []);
    const referenceEl = externalReference || _reference;
    const floatingEl = externalFloating || _floating;
    const referenceRef = $cQQee.useRef(null);
    const floatingRef = $cQQee.useRef(null);
    const dataRef = $cQQee.useRef(data);
    const hasWhileElementsMounted = whileElementsMounted != null;
    const whileElementsMountedRef = $9e31e9e36f545519$var$useLatestRef(whileElementsMounted);
    const platformRef = $9e31e9e36f545519$var$useLatestRef(platform);
    const openRef = $9e31e9e36f545519$var$useLatestRef(open);
    const update = $cQQee.useCallback(()=>{
        if (!referenceRef.current || !floatingRef.current) return;
        const config = {
            placement: placement,
            strategy: strategy,
            middleware: latestMiddleware
        };
        if (platformRef.current) config.platform = platformRef.current;
        (0, $af8LA.computePosition)(referenceRef.current, floatingRef.current, config).then((data)=>{
            const fullData = {
                ...data,
                // The floating element's position may be recomputed while it's closed
                // but still mounted (such as when transitioning out). To ensure
                // `isPositioned` will be `false` initially on the next open, avoid
                // setting it to `true` when `open === false` (must be specified).
                isPositioned: openRef.current !== false
            };
            if (isMountedRef.current && !$9e31e9e36f545519$var$deepEqual(dataRef.current, fullData)) {
                dataRef.current = fullData;
                $kC364.flushSync(()=>{
                    setData(fullData);
                });
            }
        });
    }, [
        latestMiddleware,
        placement,
        strategy,
        platformRef,
        openRef
    ]);
    $9e31e9e36f545519$var$index(()=>{
        if (open === false && dataRef.current.isPositioned) {
            dataRef.current.isPositioned = false;
            setData((data)=>({
                    ...data,
                    isPositioned: false
                }));
        }
    }, [
        open
    ]);
    const isMountedRef = $cQQee.useRef(false);
    $9e31e9e36f545519$var$index(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    $9e31e9e36f545519$var$index(()=>{
        if (referenceEl) referenceRef.current = referenceEl;
        if (floatingEl) floatingRef.current = floatingEl;
        if (referenceEl && floatingEl) {
            if (whileElementsMountedRef.current) return whileElementsMountedRef.current(referenceEl, floatingEl, update);
            update();
        }
    }, [
        referenceEl,
        floatingEl,
        update,
        whileElementsMountedRef,
        hasWhileElementsMounted
    ]);
    const refs = $cQQee.useMemo(()=>({
            reference: referenceRef,
            floating: floatingRef,
            setReference: setReference,
            setFloating: setFloating
        }), [
        setReference,
        setFloating
    ]);
    const elements = $cQQee.useMemo(()=>({
            reference: referenceEl,
            floating: floatingEl
        }), [
        referenceEl,
        floatingEl
    ]);
    const floatingStyles = $cQQee.useMemo(()=>{
        const initialStyles = {
            position: strategy,
            left: 0,
            top: 0
        };
        if (!elements.floating) return initialStyles;
        const x = $9e31e9e36f545519$var$roundByDPR(elements.floating, data.x);
        const y = $9e31e9e36f545519$var$roundByDPR(elements.floating, data.y);
        if (transform) return {
            ...initialStyles,
            transform: "translate(" + x + "px, " + y + "px)",
            ...$9e31e9e36f545519$var$getDPR(elements.floating) >= 1.5 && {
                willChange: 'transform'
            }
        };
        return {
            position: strategy,
            left: x,
            top: y
        };
    }, [
        strategy,
        transform,
        elements.floating,
        data.x,
        data.y
    ]);
    return $cQQee.useMemo(()=>({
            ...data,
            update: update,
            refs: refs,
            elements: elements,
            floatingStyles: floatingStyles
        }), [
        data,
        update,
        refs,
        elements,
        floatingStyles
    ]);
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $9e31e9e36f545519$var$arrow$1 = (options)=>{
    function isRef(value) {
        return ({}).hasOwnProperty.call(value, 'current');
    }
    return {
        name: 'arrow',
        options: options,
        fn (state) {
            const { element: element, padding: padding } = typeof options === 'function' ? options(state) : options;
            if (element && isRef(element)) {
                if (element.current != null) return (0, $af8LA.arrow)({
                    element: element.current,
                    padding: padding
                }).fn(state);
                return {};
            }
            if (element) return (0, $af8LA.arrow)({
                element: element,
                padding: padding
            }).fn(state);
            return {};
        }
    };
};
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $9e31e9e36f545519$export$cc800923e997bb8 = (options, deps)=>{
    const result = (0, $af8LA.offset)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $9e31e9e36f545519$export$fba63a578e423eb = (options, deps)=>{
    const result = (0, $af8LA.shift)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $9e31e9e36f545519$export$7bf07e38f3dc4b69 = (options, deps)=>{
    const result = (0, $af8LA.limitShift)(options);
    return {
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $9e31e9e36f545519$export$8a83211c878a3f1f = (options, deps)=>{
    const result = (0, $af8LA.flip)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $9e31e9e36f545519$export$346677f925de839c = (options, deps)=>{
    const result = (0, $af8LA.size)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $9e31e9e36f545519$export$91fb6ecbd551914 = (options, deps)=>{
    const result = (0, $af8LA.autoPlacement)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $9e31e9e36f545519$export$fe8985bb6374093c = (options, deps)=>{
    const result = (0, $af8LA.hide)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $9e31e9e36f545519$export$18c8ad048e32c7d5 = (options, deps)=>{
    const result = (0, $af8LA.inline)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $9e31e9e36f545519$export$f2120bbfa5450bd2 = (options, deps)=>{
    const result = $9e31e9e36f545519$var$arrow$1(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};

});
parcelRegister("af8LA", function(module, exports) {

$parcel$export(module.exports, "platform", function () { return $77521af34b29829f$export$722a64dea1b767dc; });
$parcel$export(module.exports, "autoUpdate", function () { return $77521af34b29829f$export$deee3a793edee05f; });
$parcel$export(module.exports, "detectOverflow", function () { return $77521af34b29829f$export$37b6bde19b108ecc; });
$parcel$export(module.exports, "offset", function () { return $77521af34b29829f$export$cc800923e997bb8; });
$parcel$export(module.exports, "autoPlacement", function () { return $77521af34b29829f$export$91fb6ecbd551914; });
$parcel$export(module.exports, "shift", function () { return $77521af34b29829f$export$fba63a578e423eb; });
$parcel$export(module.exports, "flip", function () { return $77521af34b29829f$export$8a83211c878a3f1f; });
$parcel$export(module.exports, "size", function () { return $77521af34b29829f$export$346677f925de839c; });
$parcel$export(module.exports, "hide", function () { return $77521af34b29829f$export$fe8985bb6374093c; });
$parcel$export(module.exports, "arrow", function () { return $77521af34b29829f$export$f2120bbfa5450bd2; });
$parcel$export(module.exports, "inline", function () { return $77521af34b29829f$export$18c8ad048e32c7d5; });
$parcel$export(module.exports, "limitShift", function () { return $77521af34b29829f$export$7bf07e38f3dc4b69; });
$parcel$export(module.exports, "computePosition", function () { return $77521af34b29829f$export$48a53dcb22e581d0; });
$parcel$export(module.exports, "getOverflowAncestors", function () { return (parcelRequire("g7YZX")).getOverflowAncestors; });

var $8RFsK = parcelRequire("8RFsK");
var $g3pjJ = parcelRequire("g3pjJ");

var $g3pjJ = parcelRequire("g3pjJ");

var $g7YZX = parcelRequire("g7YZX");
function $77521af34b29829f$var$getCssDimensions(element) {
    const css = (0, $g7YZX.getComputedStyle)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $g7YZX.isHTMLElement)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $g3pjJ.round)(width) !== offsetWidth || (0, $g3pjJ.round)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $77521af34b29829f$var$unwrapElement(element) {
    return !(0, $g7YZX.isElement)(element) ? element.contextElement : element;
}
function $77521af34b29829f$var$getScale(element) {
    const domElement = $77521af34b29829f$var$unwrapElement(element);
    if (!(0, $g7YZX.isHTMLElement)(domElement)) return (0, $g3pjJ.createCoords)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $77521af34b29829f$var$getCssDimensions(domElement);
    let x = ($ ? (0, $g3pjJ.round)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $g3pjJ.round)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $77521af34b29829f$var$noOffsets = /*#__PURE__*/ (0, $g3pjJ.createCoords)(0);
function $77521af34b29829f$var$getVisualOffsets(element) {
    const win = (0, $g7YZX.getWindow)(element);
    if (!(0, $g7YZX.isWebKit)() || !win.visualViewport) return $77521af34b29829f$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $77521af34b29829f$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    return !!floatingOffsetParent && isFixed && floatingOffsetParent === (0, $g7YZX.getWindow)(element);
}
function $77521af34b29829f$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $77521af34b29829f$var$unwrapElement(element);
    let scale = (0, $g3pjJ.createCoords)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $g7YZX.isElement)(offsetParent)) scale = $77521af34b29829f$var$getScale(offsetParent);
        } else scale = $77521af34b29829f$var$getScale(element);
    }
    const visualOffsets = $77521af34b29829f$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $77521af34b29829f$var$getVisualOffsets(domElement) : (0, $g3pjJ.createCoords)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement && offsetParent) {
        const win = (0, $g7YZX.getWindow)(domElement);
        const offsetWin = (0, $g7YZX.isElement)(offsetParent) ? (0, $g7YZX.getWindow)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $g7YZX.getFrameElement)(currentWin);
        while(currentIFrame && offsetWin !== currentWin){
            const iframeScale = $77521af34b29829f$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $g7YZX.getComputedStyle)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $g7YZX.getWindow)(currentIFrame);
            currentIFrame = (0, $g7YZX.getFrameElement)(currentWin);
        }
    }
    return (0, $g3pjJ.rectToClientRect)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $77521af34b29829f$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $g7YZX.getNodeScroll)(element).scrollLeft;
    if (!rect) return $77521af34b29829f$var$getBoundingClientRect((0, $g7YZX.getDocumentElement)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $77521af34b29829f$var$getHTMLOffset(documentElement, scroll) {
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - $77521af34b29829f$var$getWindowScrollBarX(documentElement, htmlRect);
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $77521af34b29829f$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, $g7YZX.getDocumentElement)(offsetParent);
    const topLayer = elements ? (0, $g7YZX.isTopLayer)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $g3pjJ.createCoords)(1);
    const offsets = (0, $g3pjJ.createCoords)(0);
    const isOffsetParentAnElement = (0, $g7YZX.isHTMLElement)(offsetParent);
    if (isOffsetParentAnElement || !isFixed) {
        if ((0, $g7YZX.getNodeName)(offsetParent) !== 'body' || (0, $g7YZX.isOverflowElement)(documentElement)) scroll = (0, $g7YZX.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $77521af34b29829f$var$getBoundingClientRect(offsetParent);
            scale = $77521af34b29829f$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $77521af34b29829f$var$getHTMLOffset(documentElement, scroll) : (0, $g3pjJ.createCoords)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $77521af34b29829f$var$getClientRects(element) {
    return element.getClientRects ? Array.from(element.getClientRects()) : [];
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $77521af34b29829f$var$getDocumentRect(html) {
    const scroll = (0, $g7YZX.getNodeScroll)(html);
    const body = html.ownerDocument.body;
    const width = (0, $g3pjJ.max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $g3pjJ.max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $77521af34b29829f$var$getWindowScrollBarX(html);
    const y = -scroll.scrollTop;
    if ((0, $g7YZX.getComputedStyle)(body).direction === 'rtl') x += (0, $g3pjJ.max)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Safety check: ensure the scrollbar space is reasonable in case this
// calculation is affected by unusual styles.
// Most scrollbars leave 15-18px of space.
const $77521af34b29829f$var$SCROLLBAR_MAX = 25;
function $77521af34b29829f$var$getViewportRect(element, strategy, rootBoundary) {
    if (rootBoundary === void 0) rootBoundary = 'viewport';
    const isLayoutViewport = rootBoundary === 'layoutViewport';
    const win = (0, $g7YZX.getWindow)(element);
    const html = (0, $g7YZX.getDocumentElement)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        // Client coordinates are relative to the layout viewport, except in
        // WebKit with an `absolute` strategy, where they are relative to the
        // visual viewport.
        const layoutRelativeClientCoords = !(0, $g7YZX.isWebKit)() || strategy === 'fixed';
        if (isLayoutViewport) {
            if (!layoutRelativeClientCoords) {
                x = -visualViewport.offsetLeft;
                y = -visualViewport.offsetTop;
            }
        } else {
            width = visualViewport.width;
            height = visualViewport.height;
            if (layoutRelativeClientCoords) {
                x = visualViewport.offsetLeft;
                y = visualViewport.offsetTop;
            }
        }
    }
    const windowScrollbarX = $77521af34b29829f$var$getWindowScrollBarX(html);
    // `scrollbar-gutter: stable` on the <html> reserves gutter space that shrinks
    // the visual width but isn't reflected in `html.clientWidth`, so subtract it.
    // Only the inline-end (right) gutter can hold the scrollbar; `both-edges` also
    // reserves an empty inline-start gutter that clips nothing, so exclude just
    // the one scrollbar-side gutter — halve the measured (two-gutter) total. A
    // left-side scrollbar (`windowScrollbarX > 0`) is already handled by
    // `getHTMLOffset`/`visualViewport.width`; skip it here.
    if (windowScrollbarX <= 0) {
        const doc = html.ownerDocument;
        const body = doc.body;
        const bodyStyles = getComputedStyle(body);
        const bodyMarginInline = doc.compatMode === 'CSS1Compat' ? parseFloat(bodyStyles.marginLeft) + parseFloat(bodyStyles.marginRight) || 0 : 0;
        const reservedWidth = Math.abs(html.clientWidth - body.clientWidth - bodyMarginInline);
        const gutter = getComputedStyle(html).scrollbarGutter === 'stable both-edges' ? reservedWidth / 2 : reservedWidth;
        if (gutter <= $77521af34b29829f$var$SCROLLBAR_MAX) width -= gutter;
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $77521af34b29829f$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $77521af34b29829f$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = $77521af34b29829f$var$getScale(element);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $77521af34b29829f$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport' || clippingAncestor === 'layoutViewport') rect = $77521af34b29829f$var$getViewportRect(element, strategy, clippingAncestor);
    else if (clippingAncestor === 'document') rect = $77521af34b29829f$var$getDocumentRect((0, $g7YZX.getDocumentElement)(element));
    else if ((0, $g7YZX.isElement)(clippingAncestor)) rect = $77521af34b29829f$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $77521af34b29829f$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $g3pjJ.rectToClientRect)(rect);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $77521af34b29829f$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $g7YZX.getOverflowAncestors)(element, [], false).filter((el)=>(0, $g7YZX.isElement)(el) && (0, $g7YZX.getNodeName)(el) !== 'body');
    let lastKeptComputedStyle = null;
    const elementIsFixed = (0, $g7YZX.getComputedStyle)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, $g7YZX.getParentNode)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $g7YZX.isElement)(currentNode) && !(0, $g7YZX.isLastTraversableNode)(currentNode)){
        const computedStyle = (0, $g7YZX.getComputedStyle)(currentNode);
        const currentNodeIsContaining = (0, $g7YZX.isContainingBlock)(currentNode);
        // Position of the containing block chain below the current node. A fixed
        // element whose containing block hasn't been found yet is a fixed chain.
        const lastPosition = lastKeptComputedStyle ? lastKeptComputedStyle.position : elementIsFixed ? 'fixed' : '';
        // A non-containing ancestor does not clip the element when the chain
        // below it escapes it: a fixed chain escapes all ancestors up to the
        // next containing block, an absolute chain escapes static ancestors.
        const shouldDropCurrentNode = !currentNodeIsContaining && (lastPosition === 'fixed' || lastPosition === 'absolute' && computedStyle.position === 'static');
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // The kept node carries the chain position for the next iteration.
        lastKeptComputedStyle = computedStyle;
        currentNode = (0, $g7YZX.getParentNode)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $77521af34b29829f$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, $g7YZX.isTopLayer)(element) ? [] : $77521af34b29829f$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstRect = $77521af34b29829f$var$getClientRectFromClippingAncestor(element, clippingAncestors[0], strategy);
    let top = firstRect.top;
    let right = firstRect.right;
    let bottom = firstRect.bottom;
    let left = firstRect.left;
    for(let i = 1; i < clippingAncestors.length; i++){
        const rect = $77521af34b29829f$var$getClientRectFromClippingAncestor(element, clippingAncestors[i], strategy);
        top = (0, $g3pjJ.max)(rect.top, top);
        right = (0, $g3pjJ.min)(rect.right, right);
        bottom = (0, $g3pjJ.min)(rect.bottom, bottom);
        left = (0, $g3pjJ.max)(rect.left, left);
    }
    return {
        width: right - left,
        height: bottom - top,
        x: left,
        y: top
    };
}
function $77521af34b29829f$var$getDimensions(element) {
    const { width: width, height: height } = $77521af34b29829f$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $77521af34b29829f$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $g7YZX.isHTMLElement)(offsetParent);
    const documentElement = (0, $g7YZX.getDocumentElement)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = $77521af34b29829f$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $g3pjJ.createCoords)(0);
    if (isOffsetParentAnElement || !isFixed) {
        if ((0, $g7YZX.getNodeName)(offsetParent) !== 'body' || (0, $g7YZX.isOverflowElement)(documentElement)) scroll = (0, $g7YZX.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $77521af34b29829f$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
    // Firefox with layout.scrollbar.side = 3 in about:config to test this.
    if (!isOffsetParentAnElement && documentElement) offsets.x = $77521af34b29829f$var$getWindowScrollBarX(documentElement);
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $77521af34b29829f$var$getHTMLOffset(documentElement, scroll) : (0, $g3pjJ.createCoords)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $77521af34b29829f$var$isStaticPositioned(element) {
    return (0, $g7YZX.getComputedStyle)(element).position === 'static';
}
function $77521af34b29829f$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $g7YZX.isHTMLElement)(element) || (0, $g7YZX.getComputedStyle)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $g7YZX.getDocumentElement)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $77521af34b29829f$var$getOffsetParent(element, polyfill) {
    const win = (0, $g7YZX.getWindow)(element);
    if ((0, $g7YZX.isTopLayer)(element)) return win;
    if (!(0, $g7YZX.isHTMLElement)(element)) {
        let svgOffsetParent = (0, $g7YZX.getParentNode)(element);
        while(svgOffsetParent && !(0, $g7YZX.isLastTraversableNode)(svgOffsetParent)){
            if ((0, $g7YZX.isElement)(svgOffsetParent) && !$77521af34b29829f$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $g7YZX.getParentNode)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $77521af34b29829f$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $g7YZX.isTableElement)(offsetParent) && $77521af34b29829f$var$isStaticPositioned(offsetParent))offsetParent = $77521af34b29829f$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $g7YZX.isLastTraversableNode)(offsetParent) && $77521af34b29829f$var$isStaticPositioned(offsetParent) && !(0, $g7YZX.isContainingBlock)(offsetParent)) return win;
    return offsetParent || (0, $g7YZX.getContainingBlock)(element) || win;
}
const $77521af34b29829f$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $77521af34b29829f$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $77521af34b29829f$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $77521af34b29829f$var$isRTL(element) {
    return (0, $g7YZX.getComputedStyle)(element).direction === 'rtl';
}
const $77521af34b29829f$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $77521af34b29829f$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $g7YZX.getDocumentElement,
    getClippingRect: $77521af34b29829f$var$getClippingRect,
    getOffsetParent: $77521af34b29829f$var$getOffsetParent,
    getElementRects: $77521af34b29829f$var$getElementRects,
    getClientRects: $77521af34b29829f$var$getClientRects,
    getDimensions: $77521af34b29829f$var$getDimensions,
    getScale: $77521af34b29829f$var$getScale,
    isElement: $g7YZX.isElement,
    isRTL: $77521af34b29829f$var$isRTL
};
function $77521af34b29829f$var$rectsAreEqual(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
// https://samthor.au/2021/observing-dom/
function $77521af34b29829f$var$observeMove(element, onMove, ancestorResize) {
    let io = null;
    let timeoutId;
    const root = (0, $g7YZX.getDocumentElement)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const elementRectForRootMargin = element.getBoundingClientRect();
        const { left: left, top: top, width: width, height: height } = elementRectForRootMargin;
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $g3pjJ.floor)(top);
        const insetRight = (0, $g3pjJ.floor)(root.clientWidth - (left + width));
        const insetBottom = (0, $g3pjJ.floor)(root.clientHeight - (top + height));
        const insetLeft = (0, $g3pjJ.floor)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $g3pjJ.max)(0, (0, $g3pjJ.min)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            // The entry is a snapshot, so the reference may have moved since the
            // intersection was computed (under performance constraints, or between
            // consecutive frames of a multi-frame layout shift). The reported ratio
            // and the observed area are stale in that case and cannot be trusted to
            // detect subsequent movement, so refresh regardless of the ratio.
            if (!$77521af34b29829f$var$rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) return refresh();
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped in place, the ratio is 0. Throttle
                // the refresh to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (_e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    const win = (0, $g7YZX.getWindow)(element);
    // The window is a resize ancestor, so when `ancestorResize` is enabled its
    // listener already runs the update on resize. Here we only need to rebuild
    // the `IntersectionObserver` for the new root size, skipping a redundant
    // update. When `ancestorResize` is disabled, this becomes the sole update.
    const handleResize = ()=>refresh(ancestorResize);
    win.addEventListener('resize', handleResize);
    refresh(true);
    return ()=>{
        win.removeEventListener('resize', handleResize);
        cleanup();
    };
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $77521af34b29829f$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
    const referenceEl = $77521af34b29829f$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $g7YZX.getOverflowAncestors)(referenceEl) : [],
        ...floating ? (0, $g7YZX.getOverflowAncestors)(floating) : []
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update);
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? $77521af34b29829f$var$observeMove(referenceEl, update, ancestorResize) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver && floating) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        if (floating) resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $77521af34b29829f$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $77521af34b29829f$var$getBoundingClientRect(reference);
        if (prevRefRect && !$77521af34b29829f$var$rectsAreEqual(prevRefRect, nextRefRect)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $77521af34b29829f$export$37b6bde19b108ecc = (0, $8RFsK.detectOverflow);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $77521af34b29829f$export$cc800923e997bb8 = (0, $8RFsK.offset);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $77521af34b29829f$export$91fb6ecbd551914 = (0, $8RFsK.autoPlacement);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $77521af34b29829f$export$fba63a578e423eb = (0, $8RFsK.shift);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $77521af34b29829f$export$8a83211c878a3f1f = (0, $8RFsK.flip);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $77521af34b29829f$export$346677f925de839c = (0, $8RFsK.size);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $77521af34b29829f$export$fe8985bb6374093c = (0, $8RFsK.hide);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $77521af34b29829f$export$f2120bbfa5450bd2 = (0, $8RFsK.arrow);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $77521af34b29829f$export$18c8ad048e32c7d5 = (0, $8RFsK.inline);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $77521af34b29829f$export$7bf07e38f3dc4b69 = (0, $8RFsK.limitShift);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $77521af34b29829f$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = options != null ? options : {};
    const platformWithCache = {
        ...$77521af34b29829f$export$722a64dea1b767dc,
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $8RFsK.computePosition)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};

});
parcelRegister("8RFsK", function(module, exports) {

$parcel$export(module.exports, "detectOverflow", function () { return $67436f9433f8fef2$export$37b6bde19b108ecc; });
$parcel$export(module.exports, "computePosition", function () { return $67436f9433f8fef2$export$48a53dcb22e581d0; });
$parcel$export(module.exports, "arrow", function () { return $67436f9433f8fef2$export$f2120bbfa5450bd2; });
$parcel$export(module.exports, "autoPlacement", function () { return $67436f9433f8fef2$export$91fb6ecbd551914; });
$parcel$export(module.exports, "flip", function () { return $67436f9433f8fef2$export$8a83211c878a3f1f; });
$parcel$export(module.exports, "hide", function () { return $67436f9433f8fef2$export$fe8985bb6374093c; });
$parcel$export(module.exports, "inline", function () { return $67436f9433f8fef2$export$18c8ad048e32c7d5; });
$parcel$export(module.exports, "offset", function () { return $67436f9433f8fef2$export$cc800923e997bb8; });
$parcel$export(module.exports, "shift", function () { return $67436f9433f8fef2$export$fba63a578e423eb; });
$parcel$export(module.exports, "limitShift", function () { return $67436f9433f8fef2$export$7bf07e38f3dc4b69; });
$parcel$export(module.exports, "size", function () { return $67436f9433f8fef2$export$346677f925de839c; });
$parcel$export(module.exports, "rectToClientRect", function () { return (parcelRequire("g3pjJ")).rectToClientRect; });

var $g3pjJ = parcelRequire("g3pjJ");
function $67436f9433f8fef2$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $g3pjJ.getSideAxis)(placement);
    const alignmentAxis = (0, $g3pjJ.getAlignmentAxis)(placement);
    const alignLength = (0, $g3pjJ.getAxisLength)(alignmentAxis);
    const side = (0, $g3pjJ.getSide)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    const alignment = (0, $g3pjJ.getAlignment)(placement);
    if (alignment) coords[alignmentAxis] += commonAlign * (alignment === 'end' ? 1 : -1) * (rtl && isVertical ? -1 : 1);
    return coords;
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $67436f9433f8fef2$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, $g3pjJ.evaluate)(options, state);
    const paddingObject = (0, $g3pjJ.getPaddingObject)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $g3pjJ.rectToClientRect)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) && await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $g3pjJ.rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
// Maximum number of resets that can occur before bailing to avoid infinite reset loops.
const $67436f9433f8fef2$var$MAX_RESET_COUNT = 50;
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $67436f9433f8fef2$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const platformWithDetectOverflow = platform.detectOverflow ? platform : {
        ...platform,
        detectOverflow: $67436f9433f8fef2$export$37b6bde19b108ecc
    };
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $67436f9433f8fef2$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let resetCount = 0;
    const middlewareData = {};
    for(let i = 0; i < middleware.length; i++){
        const currentMiddleware = middleware[i];
        if (!currentMiddleware) continue;
        const { name: name, fn: fn } = currentMiddleware;
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platformWithDetectOverflow,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData[name] = {
            ...middlewareData[name],
            ...data
        };
        if (reset && resetCount < $67436f9433f8fef2$var$MAX_RESET_COUNT) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $67436f9433f8fef2$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $67436f9433f8fef2$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $g3pjJ.evaluate)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $g3pjJ.getPaddingObject)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $g3pjJ.getAlignmentAxis)(placement);
            const length = (0, $g3pjJ.getAxisLength)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $g3pjJ.min)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $g3pjJ.min)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $g3pjJ.clamp)(minPadding, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $g3pjJ.getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < minPadding ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < minPadding ? center - minPadding : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $67436f9433f8fef2$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $g3pjJ.getAlignment)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $g3pjJ.getAlignment)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $g3pjJ.getSide)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $g3pjJ.getAlignment)(placement) === alignment || (autoAlignment ? (0, $g3pjJ.getOppositeAlignmentPlacement)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $67436f9433f8fef2$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $g3pjJ.placements), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $g3pjJ.evaluate)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $g3pjJ.placements) ? $67436f9433f8fef2$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const alignmentSides = (0, $g3pjJ.getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            const currentOverflows = [
                overflow[(0, $g3pjJ.getSide)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $g3pjJ.getAlignment)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $g3pjJ.getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $67436f9433f8fef2$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $g3pjJ.evaluate)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $g3pjJ.getSide)(placement);
            const initialSideAxis = (0, $g3pjJ.getSideAxis)(initialPlacement);
            const isBasePlacement = (0, $g3pjJ.getSide)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $g3pjJ.getOppositePlacement)(initialPlacement)
            ] : (0, $g3pjJ.getExpandedPlacements)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $g3pjJ.getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $g3pjJ.getAlignmentSides)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) {
                    const ignoreCrossAxisOverflow = checkCrossAxis === 'alignment' ? initialSideAxis !== (0, $g3pjJ.getSideAxis)(nextPlacement) : false;
                    if (!ignoreCrossAxisOverflow || // We leave the current main axis only if every placement on that axis
                    // overflows the main axis.
                    overflowsData.every((d)=>(0, $g3pjJ.getSideAxis)(d.placement) === initialSideAxis ? d.overflows[0] > 0 : true)) // Try next placement and re-run the lifecycle.
                    return {
                        data: {
                            index: nextIndex,
                            overflows: overflowsData
                        },
                        reset: {
                            placement: nextPlacement
                        }
                    };
                }
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $g3pjJ.getSideAxis)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $67436f9433f8fef2$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $67436f9433f8fef2$var$isAnySideFullyClipped(overflow) {
    return (0, $g3pjJ.sides).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $67436f9433f8fef2$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (state) {
            const { rects: rects, platform: platform } = state;
            const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, $g3pjJ.evaluate)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await platform.detectOverflow(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = $67436f9433f8fef2$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $67436f9433f8fef2$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await platform.detectOverflow(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $67436f9433f8fef2$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $67436f9433f8fef2$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $67436f9433f8fef2$var$getBoundingRect(rects) {
    const minX = (0, $g3pjJ.min)(...rects.map((rect)=>rect.left));
    const minY = (0, $g3pjJ.min)(...rects.map((rect)=>rect.top));
    const maxX = (0, $g3pjJ.max)(...rects.map((rect)=>rect.right));
    const maxY = (0, $g3pjJ.max)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $67436f9433f8fef2$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $g3pjJ.rectToClientRect)($67436f9433f8fef2$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $67436f9433f8fef2$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $g3pjJ.evaluate)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            // No rects (e.g. a hidden or detached reference, or a collapsed range) —
            // keep the existing reference rect rather than resetting to an invalid
            // one with non-finite values.
            if (!nativeClientRects.length) return {};
            const clientRects = $67436f9433f8fef2$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $g3pjJ.rectToClientRect)($67436f9433f8fef2$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $g3pjJ.getPaddingObject)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && (clientRects[0].left > clientRects[1].right || clientRects[1].left > clientRects[0].right) && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $g3pjJ.getSideAxis)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $g3pjJ.getSide)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        return (0, $g3pjJ.rectToClientRect)({
                            x: left,
                            y: top,
                            width: right - left,
                            height: bottom - top
                        });
                    }
                    const isLeftSide = (0, $g3pjJ.getSide)(placement) === 'left';
                    const maxRight = (0, $g3pjJ.max)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $g3pjJ.min)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    return (0, $g3pjJ.rectToClientRect)({
                        x: minLeft,
                        y: top,
                        width: maxRight - minLeft,
                        height: bottom - top
                    });
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
const $67436f9433f8fef2$var$originSides = /*#__PURE__*/ new Set([
    'left',
    'top'
]);
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $67436f9433f8fef2$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $g3pjJ.getSide)(placement);
    const alignment = (0, $g3pjJ.getAlignment)(placement);
    const isVertical = (0, $g3pjJ.getSideAxis)(placement) === 'y';
    const mainAxisMulti = $67436f9433f8fef2$var$originSides.has(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $g3pjJ.evaluate)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $67436f9433f8fef2$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $67436f9433f8fef2$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $67436f9433f8fef2$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, platform: platform } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $g3pjJ.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const crossAxis = (0, $g3pjJ.getSideAxis)(placement);
            const mainAxis = (0, $g3pjJ.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const clampCoord = (axis, coord)=>(0, $g3pjJ.clamp)(coord + overflow[axis === 'y' ? 'top' : 'left'], coord, coord - overflow[axis === 'y' ? 'bottom' : 'right']);
            if (checkMainAxis) mainAxisCoord = clampCoord(mainAxis, mainAxisCoord);
            if (checkCrossAxis) crossAxisCoord = clampCoord(crossAxis, crossAxisCoord);
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $67436f9433f8fef2$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            var _rawOffset$mainAxis, _rawOffset$crossAxis;
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $g3pjJ.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $g3pjJ.getSideAxis)(placement);
            const mainAxis = (0, $g3pjJ.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $g3pjJ.evaluate)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: (_rawOffset$mainAxis = rawOffset.mainAxis) != null ? _rawOffset$mainAxis : 0,
                crossAxis: (_rawOffset$crossAxis = rawOffset.crossAxis) != null ? _rawOffset$crossAxis : 0
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = $67436f9433f8fef2$var$originSides.has((0, $g3pjJ.getSide)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
// Method syntax keeps callback parameters bivariant, but expressing the
// explicit `| undefined` required by `exactOptionalPropertyTypes` needs
// property syntax, which is contravariant under `strictFunctionTypes`.
// Extracting the function from a method position restores that bivariance so
// consumers can still assign callbacks with narrower parameter types.
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $67436f9433f8fef2$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $g3pjJ.evaluate)(options, state);
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const side = (0, $g3pjJ.getSide)(placement);
            const alignment = (0, $g3pjJ.getAlignment)(placement);
            const isYAxis = (0, $g3pjJ.getSideAxis)(placement) === 'y';
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $g3pjJ.min)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $g3pjJ.min)(width - overflow[widthSide], maximumClippingWidth);
            const shiftData = state.middlewareData.shift;
            const noShift = !shiftData;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if (shiftData != null && shiftData.enabled.x) availableWidth = maximumClippingWidth;
            if (shiftData != null && shiftData.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                if (isYAxis) availableWidth = width - 2 * (0, $g3pjJ.max)(overflow.left, overflow.right);
                else availableHeight = height - 2 * (0, $g3pjJ.max)(overflow.top, overflow.bottom);
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};

});




var $428785cd2551e059$exports = {};
$parcel$extendImportMap({
    "i1Mgs": "sessionRecorder.esm.ff5287ea.js",
    "e5Zmh": "lsq_goto.5bc4c2e9.svg",
    "4OKPn": "lsq_reset.837f149f.svg",
    "bwR9B": "empty.7f21f7fb.svg",
    "eomgF": "error.3716ddb1.svg",
    "3P9iH": "lsq_todo.b73b174e.svg",
    "ktfa5": "lsq_appointment.ba5442a8.svg",
    "edSbf": "lsq_user_icon.59e3655a.svg",
    "h6v4l": "lsq_opportunity_icon.ee39f9c7.svg",
    "dhyLL": "lsq_tick.6cf901c6.svg",
    "5RoJZ": "lsq_sync.b4ec5e73.svg",
    "iTHaD": "info_icon.b138a5d7.svg"
});


var $7Tw3V = parcelRequire("7Tw3V");
parcelRequire("cQQee");

var $kC364 = parcelRequire("kC364");

var $7Tw3V = parcelRequire("7Tw3V");

var $cQQee = parcelRequire("cQQee");

var $7Tw3V = parcelRequire("7Tw3V");

var $cQQee = parcelRequire("cQQee");
var $1b9f63ff6bd81065$exports = {};

$1b9f63ff6bd81065$exports = (parcelRequire("pWRJW")).default;

$1b9f63ff6bd81065$exports.utils = (parcelRequire("29Wdk"));

$1b9f63ff6bd81065$exports.calculateUtils = (parcelRequire("bXTFA"));

$1b9f63ff6bd81065$exports.Responsive = (parcelRequire("eQFMR")).default;

$1b9f63ff6bd81065$exports.Responsive.utils = (parcelRequire("fldjZ"));

$1b9f63ff6bd81065$exports.WidthProvider = (parcelRequire("9fCNy")).default;



var $7Tw3V = parcelRequire("7Tw3V");

var $cQQee = parcelRequire("cQQee");

var $7Tw3V = parcelRequire("7Tw3V");
parcelRequire("cQQee");

var $7Tw3V = parcelRequire("7Tw3V");
parcelRequire("cQQee");

// Parcel's `--public-url ./` already resolves every bundled asset relative to wherever the bundle
// is served from. CSS and icons opted out of that by being built from a host map keyed on
// window.location.host, so they break the moment the bundle moves to a custom-domain subpath --
// the map misses and falls through to a hardcoded (and wrong-environment) CDN. Reading the
// bundle's own URL puts them back on the same mechanism, so one artifact is correct at any prefix.
//
// The Vite loader is the authoritative source. It computes the dist root from its own src and
// then appends the hashed app script, which Vite emits to <root>/static/js/. Reading
// document.currentScript from inside that app script therefore yields <root>/static/js, one level
// too deep, and every icon and stylesheet URL built from it 404s -- on the normal CDN as much as
// on a custom domain. So prefer the value the loader published.
//
// The key is per-app on purpose: swlite can mount casa-web and lead-360 on the same page from
// different prefixes, and a shared global would leave whichever loaded second resolving its
// assets against the other's base.
const $debc221b24698e68$var$LOADER_BASE_KEY = "__CASA_WEB_BUNDLE_BASE__";
const $debc221b24698e68$var$stripTrailingSlash = (url)=>String(url).replace(/\/$/, "");
const $debc221b24698e68$var$loaderBase = typeof window !== "undefined" ? window[$debc221b24698e68$var$LOADER_BASE_KEY] : undefined;
// Fallback for the legacy Parcel entry, which sits at the dist root, so its own URL is the base.
// document.currentScript is read at module scope on purpose: it is only populated while the
// classic script is executing synchronously, which is exactly when this module body runs.
// import.meta.url is NOT an alternative here -- Parcel compiles it to a build-time literal
// ("file:///src/entry.js"), which would silently produce broken URLs rather than failing loudly.
// The /static/js strip only matters if the Vite bundle is ever loaded without its loader.
const $debc221b24698e68$var$script = typeof document !== "undefined" ? document.currentScript : null;
const $debc221b24698e68$var$scriptBase = $debc221b24698e68$var$script ? $debc221b24698e68$var$stripTrailingSlash(new URL(".", $debc221b24698e68$var$script.src).href).replace(/\/static\/js$/, "") : "";
const $debc221b24698e68$export$d2b5531ce9550fb0 = $debc221b24698e68$var$loaderBase ? $debc221b24698e68$var$stripTrailingSlash($debc221b24698e68$var$loaderBase) : $debc221b24698e68$var$scriptBase;


const $8a8f1a678e6f48e2$var$hostMapping = {
    "app.crm4b2c.com": "fieldsales.crm4b2c.com",
    "app.lsq-staging.com": "fieldsales.lsq-staging.com",
    "app.leadsquared.com": "fieldsales-in21.leadsquared.com",
    "app-us11.leadsquared.com": "fieldsales-in21.leadsquared.com",
    "app-ca12.leadsquared.com": "fieldsales-in21.leadsquared.com",
    "app-ir31.leadsquared.com": "fieldsales-in21.leadsquared.com",
    "app-in21.leadsquared.com": "fieldsales-in21.leadsquared.com",
    "app-in22.leadsquared.com": "fieldsales-in22.leadsquared.com",
    "run.crm4b2c.com": "fieldsales.crm4b2c.com",
    "run.lsq-staging.com": "fieldsales.lsq-staging.com",
    "in21.leadsquared.com": "fieldsales-in21.leadsquared.com",
    "us11.leadsquared.com": "fieldsales-in21.leadsquared.com",
    "ir31.leadsquared.com": "fieldsales-in21.leadsquared.com",
    "ca12.leadsquared.com": "fieldsales-in21.leadsquared.com",
    "run.leadsquared.com": "fieldsales-in21.leadsquared.com",
    "in22.leadsquared.com": "fieldsales-in22.leadsquared.com"
};
const $8a8f1a678e6f48e2$var$mavisHostMapping = {
    "app.crm4b2c.com": "https://mavis-api.crm4b2c.com/",
    "app.lsq-staging.com": "https://mavis-api-in21.lsq-staging.com/",
    "app.leadsquared.com": "https://mavis-rest.leadsquared.com/",
    "app-us11.leadsquared.com": "https://mavis-rest-us11.leadsquared.com/",
    "app-ca12.leadsquared.com": "https://mavis-rest-ca12.leadsquared.com/",
    "app-in21.leadsquared.com": "https://mavis-rest-in21.leadsquared.com/",
    "app-in22.leadsquared.com": "https://mavis-rest-in22.leadsquared.com/",
    "app-ir31.leadsquared.com": "https://mavis-rest-ir31.leadsquared.com/",
    "run.crm4b2c.com": "https://mavis-api.crm4b2c.com/",
    "run.lsq-staging.com": "https://mavis-api-in21.lsq-staging.com/",
    "run.leadsquared.com": "https://mavis-rest.leadsquared.com/",
    "us11.leadsquared.com": "https://mavis-rest-us11.leadsquared.com/",
    "ca12.leadsquared.com": "https://mavis-rest-ca12.leadsquared.com/",
    "in21.leadsquared.com": "https://mavis-rest-in21.leadsquared.com/",
    "in22.leadsquared.com": "https://mavis-rest-in22.leadsquared.com/",
    "ir31.leadsquared.com": "https://mavis-rest-ir31.leadsquared.com/"
};
const $8a8f1a678e6f48e2$var$cssHostMapping = {
    "app.crm4b2c.com": ".fieldsales.crm4b2c.com",
    "app.lsq-staging.com": ".fieldsales.lsq-staging.com",
    "app.leadsquared.com": "-in21.leadsquared.com",
    "app-us11.leadsquared.com": "-in21.leadsquared.com",
    "app-ca12.leadsquared.com": "-in21.leadsquared.com",
    "app-ir31.leadsquared.com": "-in21.leadsquared.com",
    "app-in21.leadsquared.com": "-in21.leadsquared.com",
    "app-in22.leadsquared.com": "-in22.leadsquared.com",
    "run.crm4b2c.com": ".fieldsales.crm4b2c.com",
    "run.lsq-staging.com": ".fieldsales.lsq-staging.com",
    "in21.leadsquared.com": "-in21.leadsquared.com",
    "us11.leadsquared.com": "-in21.leadsquared.com",
    "ir31.leadsquared.com": "-in21.leadsquared.com",
    "ca12.leadsquared.com": "-in21.leadsquared.com",
    "run.leadsquared.com": "-in21.leadsquared.com",
    "in22.leadsquared.com": "-in22.leadsquared.com"
};
const $8a8f1a678e6f48e2$var$getHostMapping = (host)=>{
    if (host.includes("staging")) return $8a8f1a678e6f48e2$var$hostMapping["run.lsq-staging.com"];
    else if (host.includes("leadsquared.com")) return $8a8f1a678e6f48e2$var$hostMapping["run.leadsquared.com"];
    return $8a8f1a678e6f48e2$var$hostMapping["run.crm4b2c.com"];
};
const $8a8f1a678e6f48e2$export$95913207f5793e03 = $8a8f1a678e6f48e2$var$mavisHostMapping?.[window.location.host] || $8a8f1a678e6f48e2$var$mavisHostMapping["run.leadsquared.com"];
// "https://casa-web" moves here from the call sites: cssHost is now a full base URL rather
// than a domain suffix. The map is kept as a fallback so behaviour on the existing CDN is
// unchanged when the bundle URL cannot be read.
const $8a8f1a678e6f48e2$var$legacyCssHost = `https://casa-web${$8a8f1a678e6f48e2$var$cssHostMapping?.[window.location.host] || $8a8f1a678e6f48e2$var$cssHostMapping["run.leadsquared.com"]}`;
const $8a8f1a678e6f48e2$export$3d9f1402b79f9a49 = (0, $debc221b24698e68$export$d2b5531ce9550fb0) || $8a8f1a678e6f48e2$var$legacyCssHost;
const $8a8f1a678e6f48e2$export$5e032988b71f6158 = $8a8f1a678e6f48e2$var$hostMapping?.[window.location.host] || $8a8f1a678e6f48e2$var$getHostMapping(window.location.host);
/**
 * The NextGen shell publishes its resolved environment config on the window it shares with this
 * microfrontend, under the key its own helpers read (`___env_var___`). IS_CUSTOM_DOMAIN is added
 * to that config by one script -- the shell's custom-domain deploy step -- so its presence is an
 * exact signal, not a heuristic on the hostname, and it is the same flag the shell's own rest
 * client gates its encryption on.
 */ const $8a8f1a678e6f48e2$var$PLATFORM_ENV_KEY = "___env_var___";
const $8a8f1a678e6f48e2$var$platformEnvConfig = (key)=>typeof window === "undefined" ? undefined : window[$8a8f1a678e6f48e2$var$PLATFORM_ENV_KEY]?.[key];
const $8a8f1a678e6f48e2$export$97f4c254b641e719 = ()=>Boolean($8a8f1a678e6f48e2$var$platformEnvConfig("IS_CUSTOM_DOMAIN"));
const $8a8f1a678e6f48e2$export$8391516e4e7c9635 = ()=>$8a8f1a678e6f48e2$var$platformEnvConfig("GATEWAY_BASE_URL") || "";
const $8a8f1a678e6f48e2$export$a0867b79bace5897 = $8a8f1a678e6f48e2$export$97f4c254b641e719() ? `${window.location.origin}/api/fs/casa-service/v1` : `https://${$8a8f1a678e6f48e2$export$5e032988b71f6158}/api/casa-service/v1`;
const $8a8f1a678e6f48e2$var$getRumEnvironment = ()=>{
    const host = window.location.host;
    if (host.endsWith("marketxpander.net")) return "dev";
    if (host.endsWith("crm4b2c.com")) return "test";
    if (host.endsWith("lsq-staging.com")) return "staging";
    if (host.endsWith("leadsquared.com")) return "production";
    return "local";
};
const $8a8f1a678e6f48e2$export$2ff27294bb84f577 = {
    application: "casa-web-dashboard",
    environment: $8a8f1a678e6f48e2$var$getRumEnvironment(),
    public_key: $8a8f1a678e6f48e2$var$getRumEnvironment() === 'production' ? "cxtp_AtFnTPIcfKimzRaLhp8iRBkMtRImoF" : "cxtp_4ECIztsvCt3wwS4V0czszy3JIqooOc",
    coralogixDomain: "AP1",
    version: "1.0.0",
    sessionRecordingConfig: {
        enable: false
    },
    instrumentations: {
        errors: true,
        fetch: true,
        xhr: true,
        web_vitals: true,
        interactions: true,
        resources: false,
        long_tasks: false,
        custom: true
    }
};


// Per-deploy asset path segment, injected ONLY by the new (Vite) build as
// "static/<version>" so public images resolve to the cache-busted, 1-year
// immutable /static tree. The legacy Parcel build does not set it, so it falls
// back to the unversioned path and its output is unchanged.
const $2f0a72dbc6470dcd$var$assetVersion = undefined;
const $2f0a72dbc6470dcd$var$Icon = ({ src: src, isWidgetIcon: isWidgetIcon = true, className: className = "", ...props })=>{
    const iconSrc = `${(0, $8a8f1a678e6f48e2$export$3d9f1402b79f9a49)}/${$2f0a72dbc6470dcd$var$assetVersion ? `${$2f0a72dbc6470dcd$var$assetVersion}/` : ""}${src}`;
    return /*#__PURE__*/ (0, $7Tw3V.jsx)("img", {
        src: iconSrc,
        ...props,
        className: `${className} ${isWidgetIcon && "widget-icon"}`
    });
};
var $2f0a72dbc6470dcd$export$2e2bcd8739ae039 = $2f0a72dbc6470dcd$var$Icon;


let $8a9518f7458123dc$var$auth = null;
const $8a9518f7458123dc$var$AUTH_STORAGE_KEY = 'auth';
const $8a9518f7458123dc$export$f88ba925622e17f1 = ()=>{
    const authDetails = localStorage.getItem($8a9518f7458123dc$var$AUTH_STORAGE_KEY) || sessionStorage.getItem($8a9518f7458123dc$var$AUTH_STORAGE_KEY);
    if (!authDetails) {
        $8a9518f7458123dc$var$auth = null;
        return;
    }
    try {
        $8a9518f7458123dc$var$auth = JSON.parse(authDetails);
    } catch (error) {
        // Corrupt storage shouldn't crash dashboard init; getters already treat null auth as signed out.
        console.error("Failed to parse stored auth details:", error);
        $8a9518f7458123dc$var$auth = null;
    }
};
const $8a9518f7458123dc$export$714d3544202969b = ()=>{
    if (!$8a9518f7458123dc$var$auth) $8a9518f7458123dc$export$f88ba925622e17f1();
    return $8a9518f7458123dc$var$auth?.User;
};
const $8a9518f7458123dc$export$550ea6e0aa9f31e3 = ()=>{
    if (!$8a9518f7458123dc$var$auth) $8a9518f7458123dc$export$f88ba925622e17f1();
    return $8a9518f7458123dc$var$auth?.Tokens?.Token;
};
const $8a9518f7458123dc$export$b64ebfa99e8dc2a0 = ()=>{
    if (!$8a9518f7458123dc$var$auth) $8a9518f7458123dc$export$f88ba925622e17f1();
    return $8a9518f7458123dc$var$auth?.Tenant?.RegionId;
};
const $8a9518f7458123dc$export$aacd81ffe42ab171 = ()=>{
    if (!$8a9518f7458123dc$var$auth) $8a9518f7458123dc$export$f88ba925622e17f1();
    return $8a9518f7458123dc$var$auth?.Tenant?.DisplayName;
};


const $4b9f68b1938e412c$export$2a1f9a4a898c1733 = {
    requestPending: "pending",
    requestFullfilled: "fullfilled",
    requestRejected: "rejected"
};
const $4b9f68b1938e412c$export$588c7fdda06fbb0a = {
    countCacheName: "casa-web-counts",
    lastForceRefreshedTime: "lastForceRefreshedTime"
};
const $4b9f68b1938e412c$export$a7a3b6940d66e1a4 = {
    "TASKS": "tasks",
    "LEADS": "leads",
    "OPPORTUNITY": "opportunity",
    "SMARTVIEWS": "smartviews",
    "ACTIVITES": "activities"
};
const $4b9f68b1938e412c$export$45f3f39dac49db7f = {
    SingleCounter: "singlecounter",
    SpeedoMeter: "speedometer",
    ProgressBar: "progressbar",
    Banner: "banner",
    Calendar: "calendarview",
    IconLauncher: "iconlauncher"
};
const $4b9f68b1938e412c$export$2451a7d68a533c8e = {
    "Lead/Form": {
        name: "Lead/Form",
        formEntity: 0,
        PermissionEntityType: "LEAD"
    },
    "Opportunity/Form": {
        name: "Opportunity/Form",
        formEntity: 1,
        PermissionEntityType: "OPPORTUNITY"
    },
    "Activity/Form": {
        name: "Activity/Form",
        formEntity: 2,
        PermissionEntityType: "ACTIVITY"
    },
    "Task/Form": {
        name: "Task/Form",
        formEntity: 3,
        PermissionEntityType: "TASK"
    },
    "Account/Form": {
        name: "Account/Form",
        formEntity: 5,
        PermissionEntityType: "ACCOUNTS"
    }
};
const $4b9f68b1938e412c$export$20139851dc7757d2 = {
    somethingWentWrong: "Something Went Wrong",
    noTasksScheduled: "No Tasks Scheduled",
    noAppointmentsScheduled: "No Appointments Scheduled",
    retry: 'Retry'
};


const $b61f740b64a51955$export$c7f596c9dd03e70c = {
    none: {
        includeOverdue: true,
        statusCode: "-1"
    },
    all: {
        includeOverdue: true,
        statusCode: "-1"
    },
    cancelled: {
        includeOverdue: false,
        statusCode: "2"
    },
    completed: {
        includeOverdue: false,
        statusCode: "1"
    },
    pending: {
        includeOverdue: false,
        statusCode: "0"
    },
    "pending_and_overdue": {
        includeOverdue: true,
        statusCode: "0"
    },
    overdue: {
        includeOnlyOverdue: true,
        statusCode: "0"
    }
};
const $b61f740b64a51955$export$6c9d0c3cc08fd961 = {
    1: "completed",
    0: "pending"
};
const $b61f740b64a51955$export$b9e1badb9711e940 = (widget = {})=>{
    const { config: config = {} } = widget;
    const { taskStatus: taskStatus, taskTypes: taskTypes, objectType: objectType } = config;
    const user = (0, $8a9518f7458123dc$export$714d3544202969b)();
    let userID = "";
    if (user) userID = user.Id;
    let filters = {
        lookupName: "OwnerId",
        lookupValue: userID,
        leadType: objectType?.InternalName || null
    };
    if (taskStatus && taskStatus.id) {
        const statusParams = $b61f740b64a51955$export$c7f596c9dd03e70c[taskStatus.id];
        if (statusParams) filters = {
            ...filters,
            ...statusParams
        };
    }
    if (taskTypes) {
        if (Array.isArray(taskTypes.category) && taskTypes.category.length > 0) filters.taskTypeId = taskTypes.category[0];
        else filters.taskTypeId = [
            ...taskTypes.appointmentId,
            ...taskTypes.todoId
        ].join(",");
    }
    return {
        pageIndex: 0,
        pageSize: 100,
        sortField: "DueDate",
        sortDirection: 0,
        includeCsv: null,
        excludeCsv: null,
        filters: filters
    };
};
const $b61f740b64a51955$export$2e3dcc09723f1d05 = (dateFilterId)=>{
    const today = new Date();
    let from, to;
    const formatDate = (date)=>{
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    };
    switch(dateFilterId){
        case "today":
            to = formatDate(today);
            from = to;
            return {
                from: from,
                to: to
            };
        case "yesterday":
            {
                const yesterday = new Date(today);
                yesterday.setDate(yesterday.getDate() - 1);
                to = formatDate(yesterday);
                from = to;
                return {
                    from: from,
                    to: to
                };
            }
        case "tomorrow":
            {
                const tomorrow = new Date(today);
                tomorrow.setDate(tomorrow.getDate() + 1);
                to = formatDate(tomorrow);
                from = to;
                return {
                    from: from,
                    to: to
                };
            }
        case "last_7_days":
            to = formatDate(today);
            from = new Date(today);
            from.setDate(today.getDate() - 6);
            from = formatDate(from);
            break;
        case "next_7_days":
            {
                const tomorrow = new Date(today);
                tomorrow.setDate(today.getDate() + 1);
                from = formatDate(tomorrow);
                const next7Days = new Date(today);
                next7Days.setDate(today.getDate() + 7);
                to = formatDate(next7Days);
                break;
            }
        case "last_30_days":
            to = formatDate(today);
            from = new Date(today);
            from.setDate(today.getDate() - 29);
            from = formatDate(from);
            break;
        case "last_month":
            {
                const lastMonthStart = new Date(today.getFullYear(), today.getMonth() - 1, 1);
                const lastMonthEnd = new Date(today.getFullYear(), today.getMonth(), 0);
                from = formatDate(lastMonthStart);
                to = formatDate(lastMonthEnd);
                break;
            }
        case "next_month":
            {
                const nextMonthStart = new Date(today.getFullYear(), today.getMonth() + 1, 1);
                const nextMonthEnd = new Date(today.getFullYear(), today.getMonth() + 2, 0);
                from = formatDate(nextMonthStart);
                to = formatDate(nextMonthEnd);
                break;
            }
        case "this_week":
            {
                const startOfThisWeek = new Date(today);
                startOfThisWeek.setDate(today.getDate() - today.getDay() + 1);
                from = formatDate(startOfThisWeek);
                const endOfThisWeek = new Date(startOfThisWeek);
                endOfThisWeek.setDate(startOfThisWeek.getDate() + 6);
                to = formatDate(endOfThisWeek);
                break;
            }
        case "next_week":
            {
                const startOfNextWeek = new Date(today);
                startOfNextWeek.setDate(today.getDate() + (7 - today.getDay()) + 1);
                from = formatDate(startOfNextWeek);
                const endOfNextWeek = new Date(startOfNextWeek);
                endOfNextWeek.setDate(startOfNextWeek.getDate() + 6);
                to = formatDate(endOfNextWeek);
                break;
            }
        case "this_month":
            {
                const thisMonthStart = new Date(today.getFullYear(), today.getMonth(), 1);
                const thisMonthEnd = new Date(today.getFullYear(), today.getMonth() + 1, 0);
                from = formatDate(thisMonthStart);
                to = formatDate(thisMonthEnd);
                break;
            }
        case "this_year":
            {
                const thisYearStart = new Date(today.getFullYear(), 0, 1);
                const thisYearEnd = new Date(today.getFullYear(), 11, 31);
                from = formatDate(thisYearStart);
                to = formatDate(thisYearEnd);
                break;
            }
        case "next_year":
            {
                const nextYearStart = new Date(today.getFullYear() + 1, 0, 1);
                const nextYearEnd = new Date(today.getFullYear() + 1, 11, 31);
                from = formatDate(nextYearStart);
                to = formatDate(nextYearEnd);
                break;
            }
        case "last_week":
            {
                const startOfLastWeek = new Date(today);
                startOfLastWeek.setDate(today.getDate() - today.getDay() - 6);
                from = formatDate(startOfLastWeek);
                const endOfLastWeek = new Date(startOfLastWeek);
                endOfLastWeek.setDate(startOfLastWeek.getDate() + 6);
                to = formatDate(endOfLastWeek);
                break;
            }
        case "all_time":
            from = "1970-01-01";
            to = formatDate(today);
            break;
        default:
            throw new Error(`Unknown date filter id: ${dateFilterId}`);
    }
    return {
        from: from,
        to: to
    };
};
const $b61f740b64a51955$var$noPermissionMessage = "You don't have permission to create this form";
const $b61f740b64a51955$export$f7dc72e91f29c7d7 = (type, message)=>{
    window?.casaHelperUtils?.showNotification(type, message);
};
const $b61f740b64a51955$export$ade3ab3891e57f44 = (url)=>{
    window.open(url, "_blank");
};
const $b61f740b64a51955$export$49ea986df00e87cc = async (item)=>{
    const permissionEntityType = (0, $4b9f68b1938e412c$export$2451a7d68a533c8e)[item?.navigateTo?.id]?.PermissionEntityType;
    const entityId = item?.internalLink?.id;
    if (permissionEntityType === (0, $4b9f68b1938e412c$export$2451a7d68a533c8e)["Task/Form"].PermissionEntityType) return true;
    const isRestricted = await window?.casaHelperUtils?.getIsRestricted({
        permissionEntityType: permissionEntityType,
        actionType: "CREATE",
        entityId: entityId
    });
    if (isRestricted) {
        $b61f740b64a51955$export$f7dc72e91f29c7d7(2, $b61f740b64a51955$var$noPermissionMessage);
        return false;
    }
    return true;
};
const $b61f740b64a51955$export$be43b7b93a15fd35 = (item)=>{
    const formConfig = {
        IsDefaultForm: true,
        FormId: null,
        Entity: (0, $4b9f68b1938e412c$export$2451a7d68a533c8e)[item?.navigateTo?.id]?.formEntity
    };
    if (item.navigateTo.id === (0, $4b9f68b1938e412c$export$2451a7d68a533c8e)["Opportunity/Form"]?.name) formConfig.EntityType = item?.internalLink?.code?.toString();
    else if (item.navigateTo.id !== (0, $4b9f68b1938e412c$export$2451a7d68a533c8e)["Lead/Form"]?.name) formConfig.EntityType = item?.internalLink?.id;
    else formConfig.EntityType = item?.internalLink?.internalName;
    window?.casaHelperUtils?.showForms(formConfig);
};
const $b61f740b64a51955$export$a50f19128275f667 = (item)=>{
    const { FormId: FormId, ProcessAutoId: ProcessAutoId, ActionId: ActionId, ExecutionId: ExecutionId } = item?.internalLink?.form?.process?.RelatedForms?.[0] || {};
    const formConfig = {
        FormId: FormId,
        ProcessAutoId: ProcessAutoId,
        ActionId: ActionId,
        ExecutionId: ExecutionId
    };
    window?.casaHelperUtils?.showForms(formConfig);
};
const $b61f740b64a51955$var$handleNavigationRedirect = (item)=>{
    const navigationLevels = [
        'navigationLevel4',
        'navigationLevel3',
        'navigationLevel2',
        'internalLink'
    ];
    for (const level of navigationLevels){
        const navigationObj = item[level];
        if (navigationObj && navigationObj.path) {
            const redirectUrl = `${window.location.origin}${navigationObj.path}`;
            $b61f740b64a51955$export$ade3ab3891e57f44(redirectUrl);
            return;
        }
    }
};
const $b61f740b64a51955$export$aadfb17cbf18b44d = async (item = {})=>{
    const { navigateTo: navigateTo, externalLink: externalLink } = item;
    if (!navigateTo) return;
    if (navigateTo.id === "ExternalLink" && externalLink) {
        $b61f740b64a51955$export$ade3ab3891e57f44(externalLink);
        return;
    }
    if (navigateTo.type === "navigation") {
        $b61f740b64a51955$var$handleNavigationRedirect(item);
        return;
    }
    if (Object.keys((0, $4b9f68b1938e412c$export$2451a7d68a533c8e)).includes(navigateTo.id)) {
        const havePermission = await $b61f740b64a51955$export$49ea986df00e87cc(item);
        if (!havePermission) return;
        $b61f740b64a51955$export$be43b7b93a15fd35(item);
        return;
    }
    if (navigateTo.id === "Dynamic/Form") $b61f740b64a51955$export$a50f19128275f667(item);
};
const $b61f740b64a51955$export$ca01301d9ffa7ece = (name)=>{
    return document.cookie.split(";").some((cookie)=>cookie.trim().startsWith(name + "="));
};
const $b61f740b64a51955$export$7399c75a75430f4d = (configData = {})=>{
    const { config: config = {} } = configData;
    const { count: count = 0, thresholds: thresholds, maxCount: maxCount, min: min = 0, max: max = 100 } = config;
    const clampedCount = Math.min(count, maxCount || max);
    const range = max - min || 1;
    let width = Math.max(1, Math.min(clampedCount - min, range));
    const widthPercentage = width / range * 100;
    if (!thresholds) return {
        color: "rgb(var(--ng-neutral-70))",
        width: clampedCount / (maxCount || max) * 100 || 0
    };
    const { min: thresholdMin = 0, max: thresholdMax = 100 } = thresholds;
    return {
        color: count <= min ? "rgb(var(--ng-neutral-70))" : widthPercentage < thresholdMin ? "rgb(var(--ng-error-50))" : widthPercentage < thresholdMax ? "rgb(var(--ng-yellow-40))" : "rgb(var(--ng-green-40))",
        width: widthPercentage
    };
};
const $b61f740b64a51955$export$bdcb7d5b3e07911b = ()=>{
    return !!document?.getElementById("mip_pre_reqdata");
};
const $b61f740b64a51955$export$e21ff368c7512d8e = (entity)=>{
    switch(entity){
        case "Lead":
            return $b61f740b64a51955$export$bdcb7d5b3e07911b() ? "/LeadManagement" : "";
        case "Opportunity":
            return $b61f740b64a51955$export$bdcb7d5b3e07911b() ? "/OpportunityManagement" : "";
        case "Tasks":
            return "/Tasks/AllTasks";
        default:
            return "";
    }
};




var $7Tw3V = parcelRequire("7Tw3V");
var $0997d5d05703dc6c$exports = {};

$parcel$export($0997d5d05703dc6c$exports, "title", function () { return $0997d5d05703dc6c$export$fb184b623420d9be; }, function (v) { return $0997d5d05703dc6c$export$fb184b623420d9be = v; });
var $0997d5d05703dc6c$export$fb184b623420d9be;
$0997d5d05703dc6c$export$fb184b623420d9be = `je6m5a_title`;


const $f1c5bbf999dfd19f$var$Title = ({ text: text, className: className, ...props })=>{
    return /*#__PURE__*/ (0, $7Tw3V.jsx)("div", {
        className: `ng_p_1_sb ${className} ${(0, (/*@__PURE__*/$parcel$interopDefault($0997d5d05703dc6c$exports))).title}`,
        ...props,
        children: text
    });
};
var $f1c5bbf999dfd19f$export$2e2bcd8739ae039 = $f1c5bbf999dfd19f$var$Title;


const $f60dce9bb66797b7$var$SingleCounterPreview = ({ configData: configData = {} })=>{
    const { config: config = {} } = configData;
    const { setThresholds: setThresholds, count: count, maxCount: maxCount, name: name, icon: icon } = config;
    const color = (0, $b61f740b64a51955$export$7399c75a75430f4d)(configData).color;
    const iconImgName = icon?.imgName || "lsq_copy";
    return /*#__PURE__*/ (0, $7Tw3V.jsxs)("div", {
        className: "single-counter",
        children: [
            /*#__PURE__*/ (0, $7Tw3V.jsxs)("div", {
                className: "content overflow-ellipsis",
                children: [
                    /*#__PURE__*/ (0, $7Tw3V.jsxs)("div", {
                        className: "count-content",
                        children: [
                            setThresholds && /*#__PURE__*/ (0, $7Tw3V.jsx)("span", {
                                className: "threshold-color",
                                role: "threshold-color",
                                style: {
                                    backgroundColor: color
                                }
                            }),
                            /*#__PURE__*/ (0, $7Tw3V.jsx)("span", {
                                className: "ng_h_2_b",
                                children: count
                            }),
                            count > -1 && maxCount > -1 && /*#__PURE__*/ (0, $7Tw3V.jsx)("span", {
                                className: " total-count ng_h_5_m",
                                children: maxCount ? `/${maxCount}` : ""
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7Tw3V.jsx)((0, $f1c5bbf999dfd19f$export$2e2bcd8739ae039), {
                        text: name || "Tasks"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7Tw3V.jsx)((0, $2f0a72dbc6470dcd$export$2e2bcd8739ae039), {
                src: `images/${iconImgName}.svg`,
                alt: "icon"
            })
        ]
    });
};
var $f60dce9bb66797b7$export$2e2bcd8739ae039 = $f60dce9bb66797b7$var$SingleCounterPreview;



var $7Tw3V = parcelRequire("7Tw3V");
parcelRequire("cQQee");




var $7Tw3V = parcelRequire("7Tw3V");
parcelRequire("cQQee");

const $8c47c98383d174db$var$ThresholdBG = ({ thresholds: thresholds })=>{
    if (!thresholds) return /*#__PURE__*/ (0, $7Tw3V.jsx)("div", {
        className: "no-threshold-bg",
        "data-testid": "no-threshold-bg"
    });
    const firstWidth = thresholds.min;
    const secondWidth = thresholds.max - thresholds.min;
    const thirdWidth = 100 - thresholds.max;
    const widths = [
        firstWidth,
        secondWidth,
        thirdWidth
    ];
    return /*#__PURE__*/ (0, $7Tw3V.jsx)("div", {
        className: "threshold-bg",
        "data-testid": "threshold-bg",
        children: widths.map((width, index)=>/*#__PURE__*/ (0, $7Tw3V.jsx)("div", {
                style: {
                    width: `${width}%`
                }
            }, index))
    });
};
var $8c47c98383d174db$export$2e2bcd8739ae039 = $8c47c98383d174db$var$ThresholdBG;



const $4226cecac5d28e15$var$ProgressBarPreview = ({ configData: configData = {} })=>{
    const thresholds = configData?.config?.setThresholds && configData?.config?.thresholds;
    const { config: config } = configData;
    const { color: color, width: width } = (0, $b61f740b64a51955$export$7399c75a75430f4d)(configData);
    return /*#__PURE__*/ (0, $7Tw3V.jsxs)("div", {
        className: "progress-bar-preview",
        children: [
            /*#__PURE__*/ (0, $7Tw3V.jsx)("div", {
                className: "icon-container",
                children: /*#__PURE__*/ (0, $7Tw3V.jsx)((0, $2f0a72dbc6470dcd$export$2e2bcd8739ae039), {
                    src: `images/${config?.icon?.imgName || "lsq_copy"}.svg`,
                    alt: "icon",
                    className: "icon"
                })
            }),
            /*#__PURE__*/ (0, $7Tw3V.jsxs)("div", {
                className: "info-container",
                children: [
                    /*#__PURE__*/ (0, $7Tw3V.jsx)((0, $f1c5bbf999dfd19f$export$2e2bcd8739ae039), {
                        text: config?.name
                    }),
                    config?.count > -1 && /*#__PURE__*/ (0, $7Tw3V.jsxs)("span", {
                        className: "count-container",
                        children: [
                            /*#__PURE__*/ (0, $7Tw3V.jsx)("span", {
                                className: "ng_h_5_b",
                                children: config?.count
                            }),
                            /*#__PURE__*/ (0, $7Tw3V.jsx)("span", {
                                className: "max-count ng_p_1_m",
                                children: config?.maxCount ? `/${config.maxCount}` : ""
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7Tw3V.jsxs)("div", {
                className: "progress-containers",
                children: [
                    /*#__PURE__*/ (0, $7Tw3V.jsx)((0, $8c47c98383d174db$export$2e2bcd8739ae039), {
                        thresholds: thresholds
                    }),
                    /*#__PURE__*/ (0, $7Tw3V.jsx)("div", {
                        role: "progressbar",
                        style: {
                            width: `${width}%`,
                            backgroundColor: color
                        }
                    })
                ]
            })
        ]
    });
};
var $4226cecac5d28e15$export$2e2bcd8739ae039 = $4226cecac5d28e15$var$ProgressBarPreview;



var $7Tw3V = parcelRequire("7Tw3V");
parcelRequire("cQQee");



var $7Tw3V = parcelRequire("7Tw3V");
parcelRequire("cQQee");


const $2f0d5ef2ccd13b79$var$ThresholdBG = ({ configData: configData })=>{
    const { color: color, width: width } = (0, $b61f740b64a51955$export$7399c75a75430f4d)(configData);
    const thresholds = configData?.config?.setThresholds && configData?.config?.thresholds;
    let percentages;
    if (!thresholds) percentages = [
        75,
        25
    ];
    else {
        const min = thresholds.min;
        const max = thresholds.max;
        const firstWidth = min * 75 / 100;
        const secondWidth = (max - min) * 75 / 100;
        const thirdWidth = (100 - max) * 75 / 100;
        percentages = [
            firstWidth,
            secondWidth,
            thirdWidth,
            25
        ];
    }
    const radius = 50;
    const circumference = 2 * Math.PI * radius;
    let offset = 0;
    return /*#__PURE__*/ (0, $7Tw3V.jsxs)("svg", {
        width: "100%",
        height: "100%",
        viewBox: "0 0 120 120",
        className: `threshold-bg-speedometer ${thresholds ? "thresholds" : "no-thresholds"}`,
        children: [
            percentages.map((percentage, index)=>{
                const strokeDash = percentage / 100 * circumference;
                offset += strokeDash;
                const strokeDashOffset = circumference + offset;
                return /*#__PURE__*/ (0, $7Tw3V.jsx)("circle", {
                    cx: "60",
                    cy: "60",
                    r: radius,
                    fill: "none",
                    strokeWidth: 4,
                    strokeDasharray: `${strokeDash} ${circumference}`,
                    strokeDashoffset: -strokeDashOffset,
                    transform: "rotate(135 60 60)"
                }, index);
            }),
            width > 0 && /*#__PURE__*/ (0, $7Tw3V.jsx)("circle", {
                cx: "60",
                cy: "60",
                r: radius,
                fill: "none",
                strokeWidth: 4,
                style: {
                    stroke: color
                },
                strokeDasharray: `${circumference * 75 / 100 * width / 100} ${circumference}`,
                strokeDashoffset: 0,
                transform: "rotate(135 60 60)",
                strokeLinecap: "round"
            })
        ]
    });
};
var $2f0d5ef2ccd13b79$export$2e2bcd8739ae039 = $2f0d5ef2ccd13b79$var$ThresholdBG;



const $9a1c7191c1ad3066$var$SpeedoMeterPreview = ({ configData: configData = {} })=>{
    const { config: config = {} } = configData;
    const { name: name, icon: icon = {} } = config;
    const iconImgName = icon?.imgName || "lsq_copy";
    return /*#__PURE__*/ (0, $7Tw3V.jsxs)("div", {
        className: "speedo-meter",
        children: [
            /*#__PURE__*/ (0, $7Tw3V.jsxs)("div", {
                className: "speedo-meter-container",
                children: [
                    /*#__PURE__*/ (0, $7Tw3V.jsx)("div", {
                        className: "speedo-meter-bg",
                        children: /*#__PURE__*/ (0, $7Tw3V.jsx)((0, $2f0d5ef2ccd13b79$export$2e2bcd8739ae039), {
                            configData: configData
                        })
                    }),
                    config?.count > -1 && /*#__PURE__*/ (0, $7Tw3V.jsxs)("div", {
                        className: "count-content",
                        children: [
                            /*#__PURE__*/ (0, $7Tw3V.jsx)("span", {
                                className: "count ng_d_3_b",
                                children: config?.count
                            }),
                            /*#__PURE__*/ (0, $7Tw3V.jsx)("div", {
                                className: "max-count ng_p_1_m",
                                children: config?.maxCount > 0 && `Out of ${config.maxCount}`
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7Tw3V.jsx)((0, $f1c5bbf999dfd19f$export$2e2bcd8739ae039), {
                className: "title",
                text: name || "Tasks"
            }),
            /*#__PURE__*/ (0, $7Tw3V.jsx)((0, $2f0a72dbc6470dcd$export$2e2bcd8739ae039), {
                className: "icon",
                src: `images/${iconImgName}.svg`,
                alt: "icon"
            })
        ]
    });
};
var $9a1c7191c1ad3066$export$2e2bcd8739ae039 = $9a1c7191c1ad3066$var$SpeedoMeterPreview;



var $7Tw3V = parcelRequire("7Tw3V");
parcelRequire("cQQee");

const $0e4b252bf2d52338$var$Shimmer = ({ width: width, height: height })=>{
    return /*#__PURE__*/ (0, $7Tw3V.jsx)("div", {
        className: "shimmer-wrapper",
        role: "shimmer-wrapper",
        style: {
            width: width,
            height: height
        },
        children: /*#__PURE__*/ (0, $7Tw3V.jsx)("div", {
            className: "shimmer"
        })
    });
};
var $0e4b252bf2d52338$export$2e2bcd8739ae039 = $0e4b252bf2d52338$var$Shimmer;



var $cQQee = parcelRequire("cQQee");
'use strict';
function $dbca83f1be06ed58$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $774febe52dcf2b32$var$toString } = Object.prototype;
const { getPrototypeOf: $774febe52dcf2b32$var$getPrototypeOf } = Object;
const { iterator: $774febe52dcf2b32$var$iterator, toStringTag: $774febe52dcf2b32$var$toStringTag } = Symbol;
const $774febe52dcf2b32$var$kindOf = ((cache)=>(thing)=>{
        const str = $774febe52dcf2b32$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $774febe52dcf2b32$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$774febe52dcf2b32$var$kindOf(thing) === type;
};
const $774febe52dcf2b32$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is a non-null object
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $774febe52dcf2b32$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $774febe52dcf2b32$var$isUndefined = $774febe52dcf2b32$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $774febe52dcf2b32$var$isBuffer(val) {
    return val !== null && !$774febe52dcf2b32$var$isUndefined(val) && val.constructor !== null && !$774febe52dcf2b32$var$isUndefined(val.constructor) && $774febe52dcf2b32$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $774febe52dcf2b32$var$isArrayBuffer = $774febe52dcf2b32$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $774febe52dcf2b32$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $774febe52dcf2b32$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $774febe52dcf2b32$var$isString = $774febe52dcf2b32$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $774febe52dcf2b32$var$isFunction = $774febe52dcf2b32$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $774febe52dcf2b32$var$isNumber = $774febe52dcf2b32$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $774febe52dcf2b32$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $774febe52dcf2b32$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $774febe52dcf2b32$var$isPlainObject = (val)=>{
    if ($774febe52dcf2b32$var$kindOf(val) !== 'object') return false;
    const prototype = $774febe52dcf2b32$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !($774febe52dcf2b32$var$toStringTag in val) && !($774febe52dcf2b32$var$iterator in val);
};
/**
 * Determine if a value is an empty object (safely handles Buffers)
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an empty object, otherwise false
 */ const $774febe52dcf2b32$var$isEmptyObject = (val)=>{
    // Early return for non-objects or Buffers to prevent RangeError
    if (!$774febe52dcf2b32$var$isObject(val) || $774febe52dcf2b32$var$isBuffer(val)) return false;
    try {
        return Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
    } catch (e) {
        // Fallback for any other objects that might cause RangeError with Object.keys()
        return false;
    }
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $774febe52dcf2b32$var$isDate = $774febe52dcf2b32$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $774febe52dcf2b32$var$isFile = $774febe52dcf2b32$var$kindOfTest('File');
/**
 * Determine if a value is a React Native Blob
 * React Native "blob": an object with a `uri` attribute. Optionally, it can
 * also have a `name` and `type` attribute to specify filename and content type
 *
 * @see https://github.com/facebook/react-native/blob/26684cf3adf4094eb6c405d345a75bf8c7c0bf88/Libraries/Network/FormData.js#L68-L71
 *
 * @param {*} value The value to test
 *
 * @returns {boolean} True if value is a React Native Blob, otherwise false
 */ const $774febe52dcf2b32$var$isReactNativeBlob = (value)=>{
    return !!(value && typeof value.uri !== 'undefined');
};
/**
 * Determine if environment is React Native
 * ReactNative `FormData` has a non-standard `getParts()` method
 *
 * @param {*} formData The formData to test
 *
 * @returns {boolean} True if environment is React Native, otherwise false
 */ const $774febe52dcf2b32$var$isReactNative = (formData)=>formData && typeof formData.getParts !== 'undefined';
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $774febe52dcf2b32$var$isBlob = $774febe52dcf2b32$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a FileList, otherwise false
 */ const $774febe52dcf2b32$var$isFileList = $774febe52dcf2b32$var$kindOfTest('FileList');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $774febe52dcf2b32$var$isStream = (val)=>$774febe52dcf2b32$var$isObject(val) && $774febe52dcf2b32$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $774febe52dcf2b32$var$getGlobal() {
    if (typeof globalThis !== 'undefined') return globalThis;
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    return {};
}
const $774febe52dcf2b32$var$G = $774febe52dcf2b32$var$getGlobal();
const $774febe52dcf2b32$var$FormDataCtor = typeof $774febe52dcf2b32$var$G.FormData !== 'undefined' ? $774febe52dcf2b32$var$G.FormData : undefined;
const $774febe52dcf2b32$var$isFormData = (thing)=>{
    if (!thing) return false;
    if ($774febe52dcf2b32$var$FormDataCtor && thing instanceof $774febe52dcf2b32$var$FormDataCtor) return true;
    // Reject plain objects inheriting directly from Object.prototype so prototype-pollution gadgets can't spoof FormData.
    const proto = $774febe52dcf2b32$var$getPrototypeOf(thing);
    if (!proto || proto === Object.prototype) return false;
    if (!$774febe52dcf2b32$var$isFunction(thing.append)) return false;
    const kind = $774febe52dcf2b32$var$kindOf(thing);
    return kind === 'formdata' || // detect form-data instance
    kind === 'object' && $774febe52dcf2b32$var$isFunction(thing.toString) && thing.toString() === '[object FormData]';
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $774febe52dcf2b32$var$isURLSearchParams = $774febe52dcf2b32$var$kindOfTest('URLSearchParams');
const [$774febe52dcf2b32$var$isReadableStream, $774febe52dcf2b32$var$isRequest, $774febe52dcf2b32$var$isResponse, $774febe52dcf2b32$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($774febe52dcf2b32$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $774febe52dcf2b32$var$trim = (str)=>{
    return str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
};
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array<unknown>} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys = false]
 * @returns {any}
 */ function $774febe52dcf2b32$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($774febe52dcf2b32$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Buffer check
        if ($774febe52dcf2b32$var$isBuffer(obj)) return;
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
/**
 * Finds a key in an object, case-insensitive, returning the actual key name.
 * Returns null if the object is a Buffer or if no match is found.
 *
 * @param {Object} obj - The object to search.
 * @param {string} key - The key to find (case-insensitive).
 * @returns {?string} The actual key name if found, otherwise null.
 */ function $774febe52dcf2b32$var$findKey(obj, key) {
    if ($774febe52dcf2b32$var$isBuffer(obj)) return null;
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $774febe52dcf2b32$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== 'undefined') return globalThis;
    return typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $774febe52dcf2b32$var$isContextDefined = (context)=>!$774febe52dcf2b32$var$isUndefined(context) && context !== $774febe52dcf2b32$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * const result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $774febe52dcf2b32$var$merge(...objs) {
    const { caseless: caseless, skipUndefined: skipUndefined } = $774febe52dcf2b32$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        // Skip dangerous property names to prevent prototype pollution
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return;
        // findKey lowercases the key, so caseless lookup only applies to strings —
        // symbol keys are identity-matched.
        const targetKey = caseless && typeof key === 'string' && $774febe52dcf2b32$var$findKey(result, key) || key;
        // Read via own-prop only — a bare `result[targetKey]` walks the prototype
        // chain, so a polluted Object.prototype value could surface here and get
        // copied into the merged result.
        const existing = $774febe52dcf2b32$var$hasOwnProperty(result, targetKey) ? result[targetKey] : undefined;
        if ($774febe52dcf2b32$var$isPlainObject(existing) && $774febe52dcf2b32$var$isPlainObject(val)) result[targetKey] = $774febe52dcf2b32$var$merge(existing, val);
        else if ($774febe52dcf2b32$var$isPlainObject(val)) result[targetKey] = $774febe52dcf2b32$var$merge({}, val);
        else if ($774febe52dcf2b32$var$isArray(val)) result[targetKey] = val.slice();
        else if (!skipUndefined || !$774febe52dcf2b32$var$isUndefined(val)) result[targetKey] = val;
    };
    for(let i = 0, l = objs.length; i < l; i++){
        const source = objs[i];
        if (!source || $774febe52dcf2b32$var$isBuffer(source)) continue;
        $774febe52dcf2b32$var$forEach(source, assignValue);
        if (typeof source !== 'object' || $774febe52dcf2b32$var$isArray(source)) continue;
        const symbols = Object.getOwnPropertySymbols(source);
        for(let j = 0; j < symbols.length; j++){
            const symbol = symbols[j];
            if ($774febe52dcf2b32$var$propertyIsEnumerable.call(source, symbol)) assignValue(source[symbol], symbol);
        }
    }
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $774febe52dcf2b32$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $774febe52dcf2b32$var$forEach(b, (val, key)=>{
        if (thisArg && $774febe52dcf2b32$var$isFunction(val)) Object.defineProperty(a, key, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot
            // hijack defineProperty's accessor-vs-data resolution.
            __proto__: null,
            value: (0, $dbca83f1be06ed58$export$2e2bcd8739ae039)(val, thisArg),
            writable: true,
            enumerable: true,
            configurable: true
        });
        else Object.defineProperty(a, key, {
            __proto__: null,
            value: val,
            writable: true,
            enumerable: true,
            configurable: true
        });
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $774febe52dcf2b32$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xfeff) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $774febe52dcf2b32$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    Object.defineProperty(constructor.prototype, 'constructor', {
        __proto__: null,
        value: constructor,
        writable: true,
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(constructor, 'super', {
        __proto__: null,
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $774febe52dcf2b32$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $774febe52dcf2b32$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $774febe52dcf2b32$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $774febe52dcf2b32$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($774febe52dcf2b32$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$774febe52dcf2b32$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $774febe52dcf2b32$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $774febe52dcf2b32$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $774febe52dcf2b32$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[$774febe52dcf2b32$var$iterator];
    const _iterator = generator.call(obj);
    let result;
    while((result = _iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $774febe52dcf2b32$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $774febe52dcf2b32$var$isHTMLForm = $774febe52dcf2b32$var$kindOfTest('HTMLFormElement');
const $774febe52dcf2b32$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $774febe52dcf2b32$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
const { propertyIsEnumerable: $774febe52dcf2b32$var$propertyIsEnumerable } = Object.prototype;
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $774febe52dcf2b32$var$isRegExp = $774febe52dcf2b32$var$kindOfTest('RegExp');
const $774febe52dcf2b32$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $774febe52dcf2b32$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $774febe52dcf2b32$var$freezeMethods = (obj)=>{
    $774febe52dcf2b32$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($774febe52dcf2b32$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].includes(name)) return false;
        const value = obj[name];
        if (!$774febe52dcf2b32$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
/**
 * Converts an array or a delimited string into an object set with values as keys and true as values.
 * Useful for fast membership checks.
 *
 * @param {Array|string} arrayOrString - The array or string to convert.
 * @param {string} delimiter - The delimiter to use if input is a string.
 * @returns {Object} An object with keys from the array or string, values set to true.
 */ const $774febe52dcf2b32$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $774febe52dcf2b32$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $774febe52dcf2b32$var$noop = ()=>{};
const $774febe52dcf2b32$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $774febe52dcf2b32$var$isSpecCompliantForm(thing) {
    return !!(thing && $774febe52dcf2b32$var$isFunction(thing.append) && thing[$774febe52dcf2b32$var$toStringTag] === 'FormData' && thing[$774febe52dcf2b32$var$iterator]);
}
/**
 * Recursively converts an object to a JSON-compatible object, handling circular references and Buffers.
 *
 * @param {Object} obj - The object to convert.
 * @returns {Object} The JSON-compatible object.
 */ const $774febe52dcf2b32$var$toJSONObject = (obj)=>{
    const visited = new WeakSet();
    const visit = (source)=>{
        if ($774febe52dcf2b32$var$isObject(source)) {
            if (visited.has(source)) return;
            //Buffer check
            if ($774febe52dcf2b32$var$isBuffer(source)) return source;
            if (!('toJSON' in source)) {
                // add-on descent / delete-on-ascent: preserves path semantics, so DAG nodes serialise at every occurrence (see #7230).
                visited.add(source);
                const target = $774febe52dcf2b32$var$isArray(source) ? [] : {};
                $774febe52dcf2b32$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value);
                    !$774febe52dcf2b32$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                visited.delete(source);
                return target;
            }
        }
        return source;
    };
    return visit(obj);
};
/**
 * Determines if a value is an async function.
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is an async function, otherwise false.
 */ const $774febe52dcf2b32$var$isAsyncFn = $774febe52dcf2b32$var$kindOfTest('AsyncFunction');
/**
 * Determines if a value is thenable (has then and catch methods).
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is thenable, otherwise false.
 */ const $774febe52dcf2b32$var$isThenable = (thing)=>thing && ($774febe52dcf2b32$var$isObject(thing) || $774febe52dcf2b32$var$isFunction(thing)) && $774febe52dcf2b32$var$isFunction(thing.then) && $774febe52dcf2b32$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
/**
 * Provides a cross-platform setImmediate implementation.
 * Uses native setImmediate if available, otherwise falls back to postMessage or setTimeout.
 *
 * @param {boolean} setImmediateSupported - Whether setImmediate is supported.
 * @param {boolean} postMessageSupported - Whether postMessage is supported.
 * @returns {Function} A function to schedule a callback asynchronously.
 */ const $774febe52dcf2b32$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $774febe52dcf2b32$var$_global.addEventListener('message', ({ source: source, data: data })=>{
            if (source === $774febe52dcf2b32$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $774febe52dcf2b32$var$_global.postMessage(token, '*');
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $774febe52dcf2b32$var$isFunction($774febe52dcf2b32$var$_global.postMessage));
/**
 * Schedules a microtask or asynchronous callback as soon as possible.
 * Uses queueMicrotask if available, otherwise falls back to process.nextTick or _setImmediate.
 *
 * @type {Function}
 */ const $774febe52dcf2b32$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($774febe52dcf2b32$var$_global) : $774febe52dcf2b32$var$_setImmediate;
// *********************
const $774febe52dcf2b32$var$isIterable = (thing)=>thing != null && $774febe52dcf2b32$var$isFunction(thing[$774febe52dcf2b32$var$iterator]);
var $774febe52dcf2b32$export$2e2bcd8739ae039 = {
    isArray: $774febe52dcf2b32$var$isArray,
    isArrayBuffer: $774febe52dcf2b32$var$isArrayBuffer,
    isBuffer: $774febe52dcf2b32$var$isBuffer,
    isFormData: $774febe52dcf2b32$var$isFormData,
    isArrayBufferView: $774febe52dcf2b32$var$isArrayBufferView,
    isString: $774febe52dcf2b32$var$isString,
    isNumber: $774febe52dcf2b32$var$isNumber,
    isBoolean: $774febe52dcf2b32$var$isBoolean,
    isObject: $774febe52dcf2b32$var$isObject,
    isPlainObject: $774febe52dcf2b32$var$isPlainObject,
    isEmptyObject: $774febe52dcf2b32$var$isEmptyObject,
    isReadableStream: $774febe52dcf2b32$var$isReadableStream,
    isRequest: $774febe52dcf2b32$var$isRequest,
    isResponse: $774febe52dcf2b32$var$isResponse,
    isHeaders: $774febe52dcf2b32$var$isHeaders,
    isUndefined: $774febe52dcf2b32$var$isUndefined,
    isDate: $774febe52dcf2b32$var$isDate,
    isFile: $774febe52dcf2b32$var$isFile,
    isReactNativeBlob: $774febe52dcf2b32$var$isReactNativeBlob,
    isReactNative: $774febe52dcf2b32$var$isReactNative,
    isBlob: $774febe52dcf2b32$var$isBlob,
    isRegExp: $774febe52dcf2b32$var$isRegExp,
    isFunction: $774febe52dcf2b32$var$isFunction,
    isStream: $774febe52dcf2b32$var$isStream,
    isURLSearchParams: $774febe52dcf2b32$var$isURLSearchParams,
    isTypedArray: $774febe52dcf2b32$var$isTypedArray,
    isFileList: $774febe52dcf2b32$var$isFileList,
    forEach: $774febe52dcf2b32$var$forEach,
    merge: $774febe52dcf2b32$var$merge,
    extend: $774febe52dcf2b32$var$extend,
    trim: $774febe52dcf2b32$var$trim,
    stripBOM: $774febe52dcf2b32$var$stripBOM,
    inherits: $774febe52dcf2b32$var$inherits,
    toFlatObject: $774febe52dcf2b32$var$toFlatObject,
    kindOf: $774febe52dcf2b32$var$kindOf,
    kindOfTest: $774febe52dcf2b32$var$kindOfTest,
    endsWith: $774febe52dcf2b32$var$endsWith,
    toArray: $774febe52dcf2b32$var$toArray,
    forEachEntry: $774febe52dcf2b32$var$forEachEntry,
    matchAll: $774febe52dcf2b32$var$matchAll,
    isHTMLForm: $774febe52dcf2b32$var$isHTMLForm,
    hasOwnProperty: $774febe52dcf2b32$var$hasOwnProperty,
    hasOwnProp: $774febe52dcf2b32$var$hasOwnProperty,
    reduceDescriptors: $774febe52dcf2b32$var$reduceDescriptors,
    freezeMethods: $774febe52dcf2b32$var$freezeMethods,
    toObjectSet: $774febe52dcf2b32$var$toObjectSet,
    toCamelCase: $774febe52dcf2b32$var$toCamelCase,
    noop: $774febe52dcf2b32$var$noop,
    toFiniteNumber: $774febe52dcf2b32$var$toFiniteNumber,
    findKey: $774febe52dcf2b32$var$findKey,
    global: $774febe52dcf2b32$var$_global,
    isContextDefined: $774febe52dcf2b32$var$isContextDefined,
    isSpecCompliantForm: $774febe52dcf2b32$var$isSpecCompliantForm,
    toJSONObject: $774febe52dcf2b32$var$toJSONObject,
    isAsyncFn: $774febe52dcf2b32$var$isAsyncFn,
    isThenable: $774febe52dcf2b32$var$isThenable,
    setImmediate: $774febe52dcf2b32$var$_setImmediate,
    asap: $774febe52dcf2b32$var$asap,
    isIterable: $774febe52dcf2b32$var$isIterable
};









'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $a5cfe0ed8b644500$var$ignoreDuplicateOf = (0, $774febe52dcf2b32$export$2e2bcd8739ae039).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $a5cfe0ed8b644500$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $a5cfe0ed8b644500$var$ignoreDuplicateOf[key]) return;
        if (key === 'set-cookie') {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};



'use strict';
function $4c7c42a80b5c1c07$var$trimSPorHTAB(str) {
    let start = 0;
    let end = str.length;
    while(start < end){
        const code = str.charCodeAt(start);
        if (code !== 0x09 && code !== 0x20) break;
        start += 1;
    }
    while(end > start){
        const code = str.charCodeAt(end - 1);
        if (code !== 0x09 && code !== 0x20) break;
        end -= 1;
    }
    return start === 0 && end === str.length ? str : str.slice(start, end);
}
// The control-code ranges are intentional: header sanitization strips C0/DEL bytes.
// eslint-disable-next-line no-control-regex
const $4c7c42a80b5c1c07$var$INVALID_UNICODE_HEADER_VALUE_CHARS = new RegExp('[\\u0000-\\u0008\\u000a-\\u001f\\u007f]+', 'g');
// eslint-disable-next-line no-control-regex
const $4c7c42a80b5c1c07$var$INVALID_BYTE_STRING_HEADER_VALUE_CHARS = new RegExp('[^\\u0009\\u0020-\\u007e\\u0080-\\u00ff]+', 'g');
function $4c7c42a80b5c1c07$var$sanitizeValue(value, invalidChars) {
    if ((0, $774febe52dcf2b32$export$2e2bcd8739ae039).isArray(value)) return value.map((item)=>$4c7c42a80b5c1c07$var$sanitizeValue(item, invalidChars));
    return $4c7c42a80b5c1c07$var$trimSPorHTAB(String(value).replace(invalidChars, ''));
}
const $4c7c42a80b5c1c07$export$9e344cffce061a22 = (value)=>$4c7c42a80b5c1c07$var$sanitizeValue(value, $4c7c42a80b5c1c07$var$INVALID_UNICODE_HEADER_VALUE_CHARS);
const $4c7c42a80b5c1c07$export$59dd66c2a12d8f62 = (value)=>$4c7c42a80b5c1c07$var$sanitizeValue(value, $4c7c42a80b5c1c07$var$INVALID_BYTE_STRING_HEADER_VALUE_CHARS);
function $4c7c42a80b5c1c07$export$c30c72bb7e677d54(headers) {
    const byteStringHeaders = Object.create(null);
    (0, $774febe52dcf2b32$export$2e2bcd8739ae039).forEach(headers.toJSON(), (value, header)=>{
        byteStringHeaders[header] = $4c7c42a80b5c1c07$export$59dd66c2a12d8f62(value);
    });
    return byteStringHeaders;
}


'use strict';
const $8f6208361ca0a857$var$$internals = Symbol('internals');
function $8f6208361ca0a857$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $8f6208361ca0a857$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $774febe52dcf2b32$export$2e2bcd8739ae039).isArray(value) ? value.map($8f6208361ca0a857$var$normalizeValue) : (0, $4c7c42a80b5c1c07$export$9e344cffce061a22)(String(value));
}
function $8f6208361ca0a857$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $8f6208361ca0a857$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $8f6208361ca0a857$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $774febe52dcf2b32$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $774febe52dcf2b32$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $774febe52dcf2b32$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $774febe52dcf2b32$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $8f6208361ca0a857$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $8f6208361ca0a857$var$buildAccessors(obj, header) {
    const accessorName = (0, $774febe52dcf2b32$export$2e2bcd8739ae039).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $8f6208361ca0a857$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $8f6208361ca0a857$var$normalizeHeader(_header);
            if (!lHeader) return;
            const key = (0, $774febe52dcf2b32$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $8f6208361ca0a857$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $774febe52dcf2b32$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $774febe52dcf2b32$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $774febe52dcf2b32$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$8f6208361ca0a857$var$isValidHeaderName(header)) setHeaders((0, $a5cfe0ed8b644500$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $774febe52dcf2b32$export$2e2bcd8739ae039).isObject(header) && (0, $774febe52dcf2b32$export$2e2bcd8739ae039).isIterable(header)) {
            let obj = {}, dest, key;
            for (const entry of header){
                if (!(0, $774febe52dcf2b32$export$2e2bcd8739ae039).isArray(entry)) throw new TypeError('Object iterator must return a key-value pair');
                obj[key = entry[0]] = (dest = obj[key]) ? (0, $774febe52dcf2b32$export$2e2bcd8739ae039).isArray(dest) ? [
                    ...dest,
                    entry[1]
                ] : [
                    dest,
                    entry[1]
                ] : entry[1];
            }
            setHeaders(obj, valueOrRewrite);
        } else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $8f6208361ca0a857$var$normalizeHeader(header);
        if (header) {
            const key = (0, $774febe52dcf2b32$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $8f6208361ca0a857$var$parseTokens(value);
                if ((0, $774febe52dcf2b32$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $774febe52dcf2b32$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $8f6208361ca0a857$var$normalizeHeader(header);
        if (header) {
            const key = (0, $774febe52dcf2b32$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $8f6208361ca0a857$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $8f6208361ca0a857$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $774febe52dcf2b32$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $8f6208361ca0a857$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $774febe52dcf2b32$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $8f6208361ca0a857$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $774febe52dcf2b32$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $774febe52dcf2b32$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $8f6208361ca0a857$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $8f6208361ca0a857$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $8f6208361ca0a857$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $774febe52dcf2b32$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $774febe52dcf2b32$export$2e2bcd8739ae039).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    getSetCookie() {
        return this.get('set-cookie') || [];
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$8f6208361ca0a857$var$$internals] = this[$8f6208361ca0a857$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $8f6208361ca0a857$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $8f6208361ca0a857$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $774febe52dcf2b32$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$8f6208361ca0a857$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $774febe52dcf2b32$export$2e2bcd8739ae039).reduceDescriptors($8f6208361ca0a857$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $774febe52dcf2b32$export$2e2bcd8739ae039).freezeMethods($8f6208361ca0a857$var$AxiosHeaders);
var $8f6208361ca0a857$export$2e2bcd8739ae039 = $8f6208361ca0a857$var$AxiosHeaders;


'use strict';
const $8b3b4a5a8260bec3$var$REDACTED = '[REDACTED ****]';
function $8b3b4a5a8260bec3$var$hasOwnOrPrototypeToJSON(source) {
    if ((0, $774febe52dcf2b32$export$2e2bcd8739ae039).hasOwnProp(source, 'toJSON')) return true;
    let prototype = Object.getPrototypeOf(source);
    while(prototype && prototype !== Object.prototype){
        if ((0, $774febe52dcf2b32$export$2e2bcd8739ae039).hasOwnProp(prototype, 'toJSON')) return true;
        prototype = Object.getPrototypeOf(prototype);
    }
    return false;
}
// Build a plain-object snapshot of `config` and replace the value of any key
// (case-insensitive) listed in `redactKeys` with REDACTED. Walks through arrays
// and AxiosHeaders, and short-circuits on circular references.
function $8b3b4a5a8260bec3$var$redactConfig(config, redactKeys) {
    const lowerKeys = new Set(redactKeys.map((k)=>String(k).toLowerCase()));
    const seen = [];
    const visit = (source)=>{
        if (source === null || typeof source !== 'object') return source;
        if ((0, $774febe52dcf2b32$export$2e2bcd8739ae039).isBuffer(source)) return source;
        if (seen.indexOf(source) !== -1) return undefined;
        if (source instanceof (0, $8f6208361ca0a857$export$2e2bcd8739ae039)) source = source.toJSON();
        seen.push(source);
        let result;
        if ((0, $774febe52dcf2b32$export$2e2bcd8739ae039).isArray(source)) {
            result = [];
            source.forEach((v, i)=>{
                const reducedValue = visit(v);
                if (!(0, $774febe52dcf2b32$export$2e2bcd8739ae039).isUndefined(reducedValue)) result[i] = reducedValue;
            });
        } else {
            if (!(0, $774febe52dcf2b32$export$2e2bcd8739ae039).isPlainObject(source) && $8b3b4a5a8260bec3$var$hasOwnOrPrototypeToJSON(source)) {
                seen.pop();
                return source;
            }
            result = Object.create(null);
            for (const [key, value] of Object.entries(source)){
                const reducedValue = lowerKeys.has(key.toLowerCase()) ? $8b3b4a5a8260bec3$var$REDACTED : visit(value);
                if (!(0, $774febe52dcf2b32$export$2e2bcd8739ae039).isUndefined(reducedValue)) result[key] = reducedValue;
            }
        }
        seen.pop();
        return result;
    };
    return visit(config);
}
class $8b3b4a5a8260bec3$var$AxiosError extends Error {
    static from(error, code, config, request, response, customProps) {
        const axiosError = new $8b3b4a5a8260bec3$var$AxiosError(error.message, code || error.code, config, request, response);
        axiosError.cause = error;
        axiosError.name = error.name;
        // Preserve status from the original error if not already set from response
        if (error.status != null && axiosError.status == null) axiosError.status = error.status;
        customProps && Object.assign(axiosError, customProps);
        return axiosError;
    }
    /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [config] The config.
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   *
   * @returns {Error} The created error.
   */ constructor(message, code, config, request, response){
        super(message);
        // Make message enumerable to maintain backward compatibility
        // The native Error constructor sets message as non-enumerable,
        // but axios < v1.13.3 had it as enumerable
        Object.defineProperty(this, 'message', {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: message,
            enumerable: true,
            writable: true,
            configurable: true
        });
        this.name = 'AxiosError';
        this.isAxiosError = true;
        code && (this.code = code);
        config && (this.config = config);
        request && (this.request = request);
        if (response) {
            this.response = response;
            this.status = response.status;
        }
    }
    toJSON() {
        // Opt-in redaction: when the request config carries a `redact` array, the
        // value of any matching key (case-insensitive, at any depth) is replaced
        // with REDACTED in the serialized snapshot. Undefined or empty leaves the
        // existing serialization behavior unchanged.
        const config = this.config;
        const redactKeys = config && (0, $774febe52dcf2b32$export$2e2bcd8739ae039).hasOwnProp(config, 'redact') ? config.redact : undefined;
        const serializedConfig = (0, $774febe52dcf2b32$export$2e2bcd8739ae039).isArray(redactKeys) && redactKeys.length > 0 ? $8b3b4a5a8260bec3$var$redactConfig(config, redactKeys) : (0, $774febe52dcf2b32$export$2e2bcd8739ae039).toJSONObject(config);
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: serializedConfig,
            code: this.code,
            status: this.status
        };
    }
}
// This can be changed to static properties as soon as the parser options in .eslint.cjs are updated.
$8b3b4a5a8260bec3$var$AxiosError.ERR_BAD_OPTION_VALUE = 'ERR_BAD_OPTION_VALUE';
$8b3b4a5a8260bec3$var$AxiosError.ERR_BAD_OPTION = 'ERR_BAD_OPTION';
$8b3b4a5a8260bec3$var$AxiosError.ECONNABORTED = 'ECONNABORTED';
$8b3b4a5a8260bec3$var$AxiosError.ETIMEDOUT = 'ETIMEDOUT';
$8b3b4a5a8260bec3$var$AxiosError.ECONNREFUSED = 'ECONNREFUSED';
$8b3b4a5a8260bec3$var$AxiosError.ERR_NETWORK = 'ERR_NETWORK';
$8b3b4a5a8260bec3$var$AxiosError.ERR_FR_TOO_MANY_REDIRECTS = 'ERR_FR_TOO_MANY_REDIRECTS';
$8b3b4a5a8260bec3$var$AxiosError.ERR_DEPRECATED = 'ERR_DEPRECATED';
$8b3b4a5a8260bec3$var$AxiosError.ERR_BAD_RESPONSE = 'ERR_BAD_RESPONSE';
$8b3b4a5a8260bec3$var$AxiosError.ERR_BAD_REQUEST = 'ERR_BAD_REQUEST';
$8b3b4a5a8260bec3$var$AxiosError.ERR_CANCELED = 'ERR_CANCELED';
$8b3b4a5a8260bec3$var$AxiosError.ERR_NOT_SUPPORT = 'ERR_NOT_SUPPORT';
$8b3b4a5a8260bec3$var$AxiosError.ERR_INVALID_URL = 'ERR_INVALID_URL';
$8b3b4a5a8260bec3$var$AxiosError.ERR_FORM_DATA_DEPTH_EXCEEDED = 'ERR_FORM_DATA_DEPTH_EXCEEDED';
var $8b3b4a5a8260bec3$export$2e2bcd8739ae039 = $8b3b4a5a8260bec3$var$AxiosError;


// eslint-disable-next-line strict
var $d9db0af325ed2d73$export$2e2bcd8739ae039 = null;


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $42d8f97bad551175$export$a143d493d941bafc;
var $42d8f97bad551175$export$e4cf37d7f6fb9e0a;
var $42d8f97bad551175$export$f99ded8fe4b79145;
var $42d8f97bad551175$export$599f31c3813fae4d;
'use strict';
var $315084220e030bc4$export$a48f0734ac7c2329;
var $315084220e030bc4$export$d622b2ad8d90c771;
var $315084220e030bc4$export$6100ba28696e12de;
'use strict';
$315084220e030bc4$export$a48f0734ac7c2329 = $315084220e030bc4$var$byteLength;
$315084220e030bc4$export$d622b2ad8d90c771 = $315084220e030bc4$var$toByteArray;
$315084220e030bc4$export$6100ba28696e12de = $315084220e030bc4$var$fromByteArray;
var $315084220e030bc4$var$lookup = [];
var $315084220e030bc4$var$revLookup = [];
var $315084220e030bc4$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $315084220e030bc4$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $315084220e030bc4$var$i = 0, $315084220e030bc4$var$len = $315084220e030bc4$var$code.length; $315084220e030bc4$var$i < $315084220e030bc4$var$len; ++$315084220e030bc4$var$i){
    $315084220e030bc4$var$lookup[$315084220e030bc4$var$i] = $315084220e030bc4$var$code[$315084220e030bc4$var$i];
    $315084220e030bc4$var$revLookup[$315084220e030bc4$var$code.charCodeAt($315084220e030bc4$var$i)] = $315084220e030bc4$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$315084220e030bc4$var$revLookup['-'.charCodeAt(0)] = 62;
$315084220e030bc4$var$revLookup['_'.charCodeAt(0)] = 63;
function $315084220e030bc4$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $315084220e030bc4$var$byteLength(b64) {
    var lens = $315084220e030bc4$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $315084220e030bc4$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $315084220e030bc4$var$toByteArray(b64) {
    var tmp;
    var lens = $315084220e030bc4$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $315084220e030bc4$var$Arr($315084220e030bc4$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $315084220e030bc4$var$revLookup[b64.charCodeAt(i)] << 18 | $315084220e030bc4$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $315084220e030bc4$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $315084220e030bc4$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $315084220e030bc4$var$revLookup[b64.charCodeAt(i)] << 2 | $315084220e030bc4$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $315084220e030bc4$var$revLookup[b64.charCodeAt(i)] << 10 | $315084220e030bc4$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $315084220e030bc4$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $315084220e030bc4$var$tripletToBase64(num) {
    return $315084220e030bc4$var$lookup[num >> 18 & 0x3F] + $315084220e030bc4$var$lookup[num >> 12 & 0x3F] + $315084220e030bc4$var$lookup[num >> 6 & 0x3F] + $315084220e030bc4$var$lookup[num & 0x3F];
}
function $315084220e030bc4$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($315084220e030bc4$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $315084220e030bc4$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($315084220e030bc4$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($315084220e030bc4$var$lookup[tmp >> 2] + $315084220e030bc4$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($315084220e030bc4$var$lookup[tmp >> 10] + $315084220e030bc4$var$lookup[tmp >> 4 & 0x3F] + $315084220e030bc4$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $52c04c7d68ded0b0$export$aafa59e2e03f2942;
var $52c04c7d68ded0b0$export$68d8715fc104d294;
$52c04c7d68ded0b0$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$52c04c7d68ded0b0$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $42d8f97bad551175$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$42d8f97bad551175$export$a143d493d941bafc = $42d8f97bad551175$var$Buffer;
$42d8f97bad551175$export$e4cf37d7f6fb9e0a = $42d8f97bad551175$var$SlowBuffer;
$42d8f97bad551175$export$f99ded8fe4b79145 = 50;
const $42d8f97bad551175$var$K_MAX_LENGTH = 0x7fffffff;
$42d8f97bad551175$export$599f31c3813fae4d = $42d8f97bad551175$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $42d8f97bad551175$var$Buffer.TYPED_ARRAY_SUPPORT = $42d8f97bad551175$var$typedArraySupport();
if (!$42d8f97bad551175$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $42d8f97bad551175$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($42d8f97bad551175$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$42d8f97bad551175$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($42d8f97bad551175$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$42d8f97bad551175$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $42d8f97bad551175$var$createBuffer(length) {
    if (length > $42d8f97bad551175$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $42d8f97bad551175$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $42d8f97bad551175$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $42d8f97bad551175$var$allocUnsafe(arg);
    }
    return $42d8f97bad551175$var$from(arg, encodingOrOffset, length);
}
$42d8f97bad551175$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $42d8f97bad551175$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $42d8f97bad551175$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $42d8f97bad551175$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($42d8f97bad551175$var$isInstance(value, ArrayBuffer) || value && $42d8f97bad551175$var$isInstance(value.buffer, ArrayBuffer)) return $42d8f97bad551175$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($42d8f97bad551175$var$isInstance(value, SharedArrayBuffer) || value && $42d8f97bad551175$var$isInstance(value.buffer, SharedArrayBuffer))) return $42d8f97bad551175$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $42d8f97bad551175$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $42d8f97bad551175$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $42d8f97bad551175$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $42d8f97bad551175$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $42d8f97bad551175$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($42d8f97bad551175$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($42d8f97bad551175$var$Buffer, Uint8Array);
function $42d8f97bad551175$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $42d8f97bad551175$var$alloc(size, fill, encoding) {
    $42d8f97bad551175$var$assertSize(size);
    if (size <= 0) return $42d8f97bad551175$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $42d8f97bad551175$var$createBuffer(size).fill(fill, encoding) : $42d8f97bad551175$var$createBuffer(size).fill(fill);
    return $42d8f97bad551175$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $42d8f97bad551175$var$Buffer.alloc = function(size, fill, encoding) {
    return $42d8f97bad551175$var$alloc(size, fill, encoding);
};
function $42d8f97bad551175$var$allocUnsafe(size) {
    $42d8f97bad551175$var$assertSize(size);
    return $42d8f97bad551175$var$createBuffer(size < 0 ? 0 : $42d8f97bad551175$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $42d8f97bad551175$var$Buffer.allocUnsafe = function(size) {
    return $42d8f97bad551175$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $42d8f97bad551175$var$Buffer.allocUnsafeSlow = function(size) {
    return $42d8f97bad551175$var$allocUnsafe(size);
};
function $42d8f97bad551175$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$42d8f97bad551175$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $42d8f97bad551175$var$byteLength(string, encoding) | 0;
    let buf = $42d8f97bad551175$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $42d8f97bad551175$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $42d8f97bad551175$var$checked(array.length) | 0;
    const buf = $42d8f97bad551175$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $42d8f97bad551175$var$fromArrayView(arrayView) {
    if ($42d8f97bad551175$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $42d8f97bad551175$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $42d8f97bad551175$var$fromArrayLike(arrayView);
}
function $42d8f97bad551175$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $42d8f97bad551175$var$Buffer.prototype);
    return buf;
}
function $42d8f97bad551175$var$fromObject(obj) {
    if ($42d8f97bad551175$var$Buffer.isBuffer(obj)) {
        const len = $42d8f97bad551175$var$checked(obj.length) | 0;
        const buf = $42d8f97bad551175$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $42d8f97bad551175$var$numberIsNaN(obj.length)) return $42d8f97bad551175$var$createBuffer(0);
        return $42d8f97bad551175$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $42d8f97bad551175$var$fromArrayLike(obj.data);
}
function $42d8f97bad551175$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $42d8f97bad551175$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $42d8f97bad551175$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $42d8f97bad551175$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $42d8f97bad551175$var$Buffer.alloc(+length);
}
$42d8f97bad551175$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $42d8f97bad551175$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$42d8f97bad551175$var$Buffer.compare = function compare(a, b) {
    if ($42d8f97bad551175$var$isInstance(a, Uint8Array)) a = $42d8f97bad551175$var$Buffer.from(a, a.offset, a.byteLength);
    if ($42d8f97bad551175$var$isInstance(b, Uint8Array)) b = $42d8f97bad551175$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$42d8f97bad551175$var$Buffer.isBuffer(a) || !$42d8f97bad551175$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$42d8f97bad551175$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$42d8f97bad551175$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $42d8f97bad551175$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $42d8f97bad551175$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($42d8f97bad551175$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$42d8f97bad551175$var$Buffer.isBuffer(buf)) buf = $42d8f97bad551175$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$42d8f97bad551175$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $42d8f97bad551175$var$byteLength(string, encoding) {
    if ($42d8f97bad551175$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $42d8f97bad551175$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $42d8f97bad551175$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $42d8f97bad551175$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $42d8f97bad551175$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$42d8f97bad551175$var$Buffer.byteLength = $42d8f97bad551175$var$byteLength;
function $42d8f97bad551175$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $42d8f97bad551175$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $42d8f97bad551175$var$utf8Slice(this, start, end);
        case 'ascii':
            return $42d8f97bad551175$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $42d8f97bad551175$var$latin1Slice(this, start, end);
        case 'base64':
            return $42d8f97bad551175$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $42d8f97bad551175$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$42d8f97bad551175$var$Buffer.prototype._isBuffer = true;
function $42d8f97bad551175$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$42d8f97bad551175$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$42d8f97bad551175$var$swap(this, i, i + 1);
    return this;
};
$42d8f97bad551175$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $42d8f97bad551175$var$swap(this, i, i + 3);
        $42d8f97bad551175$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$42d8f97bad551175$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $42d8f97bad551175$var$swap(this, i, i + 7);
        $42d8f97bad551175$var$swap(this, i + 1, i + 6);
        $42d8f97bad551175$var$swap(this, i + 2, i + 5);
        $42d8f97bad551175$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$42d8f97bad551175$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $42d8f97bad551175$var$utf8Slice(this, 0, length);
    return $42d8f97bad551175$var$slowToString.apply(this, arguments);
};
$42d8f97bad551175$var$Buffer.prototype.toLocaleString = $42d8f97bad551175$var$Buffer.prototype.toString;
$42d8f97bad551175$var$Buffer.prototype.equals = function equals(b) {
    if (!$42d8f97bad551175$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $42d8f97bad551175$var$Buffer.compare(this, b) === 0;
};
$42d8f97bad551175$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $42d8f97bad551175$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($42d8f97bad551175$var$customInspectSymbol) $42d8f97bad551175$var$Buffer.prototype[$42d8f97bad551175$var$customInspectSymbol] = $42d8f97bad551175$var$Buffer.prototype.inspect;
$42d8f97bad551175$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($42d8f97bad551175$var$isInstance(target, Uint8Array)) target = $42d8f97bad551175$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$42d8f97bad551175$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $42d8f97bad551175$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($42d8f97bad551175$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $42d8f97bad551175$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($42d8f97bad551175$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $42d8f97bad551175$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $42d8f97bad551175$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $42d8f97bad551175$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$42d8f97bad551175$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$42d8f97bad551175$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $42d8f97bad551175$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$42d8f97bad551175$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $42d8f97bad551175$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $42d8f97bad551175$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($42d8f97bad551175$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $42d8f97bad551175$var$utf8Write(buf, string, offset, length) {
    return $42d8f97bad551175$var$blitBuffer($42d8f97bad551175$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $42d8f97bad551175$var$asciiWrite(buf, string, offset, length) {
    return $42d8f97bad551175$var$blitBuffer($42d8f97bad551175$var$asciiToBytes(string), buf, offset, length);
}
function $42d8f97bad551175$var$base64Write(buf, string, offset, length) {
    return $42d8f97bad551175$var$blitBuffer($42d8f97bad551175$var$base64ToBytes(string), buf, offset, length);
}
function $42d8f97bad551175$var$ucs2Write(buf, string, offset, length) {
    return $42d8f97bad551175$var$blitBuffer($42d8f97bad551175$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$42d8f97bad551175$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $42d8f97bad551175$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $42d8f97bad551175$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $42d8f97bad551175$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $42d8f97bad551175$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $42d8f97bad551175$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$42d8f97bad551175$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $42d8f97bad551175$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $315084220e030bc4$export$6100ba28696e12de(buf);
    else return $315084220e030bc4$export$6100ba28696e12de(buf.slice(start, end));
}
function $42d8f97bad551175$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $42d8f97bad551175$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $42d8f97bad551175$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $42d8f97bad551175$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $42d8f97bad551175$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $42d8f97bad551175$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $42d8f97bad551175$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $42d8f97bad551175$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $42d8f97bad551175$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $42d8f97bad551175$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $42d8f97bad551175$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$42d8f97bad551175$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $42d8f97bad551175$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $42d8f97bad551175$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$42d8f97bad551175$var$Buffer.prototype.readUintLE = $42d8f97bad551175$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $42d8f97bad551175$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$42d8f97bad551175$var$Buffer.prototype.readUintBE = $42d8f97bad551175$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $42d8f97bad551175$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$42d8f97bad551175$var$Buffer.prototype.readUint8 = $42d8f97bad551175$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $42d8f97bad551175$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$42d8f97bad551175$var$Buffer.prototype.readUint16LE = $42d8f97bad551175$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $42d8f97bad551175$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$42d8f97bad551175$var$Buffer.prototype.readUint16BE = $42d8f97bad551175$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $42d8f97bad551175$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$42d8f97bad551175$var$Buffer.prototype.readUint32LE = $42d8f97bad551175$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $42d8f97bad551175$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$42d8f97bad551175$var$Buffer.prototype.readUint32BE = $42d8f97bad551175$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $42d8f97bad551175$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$42d8f97bad551175$var$Buffer.prototype.readBigUInt64LE = $42d8f97bad551175$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $42d8f97bad551175$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $42d8f97bad551175$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$42d8f97bad551175$var$Buffer.prototype.readBigUInt64BE = $42d8f97bad551175$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $42d8f97bad551175$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $42d8f97bad551175$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$42d8f97bad551175$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $42d8f97bad551175$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$42d8f97bad551175$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $42d8f97bad551175$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$42d8f97bad551175$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $42d8f97bad551175$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$42d8f97bad551175$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $42d8f97bad551175$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$42d8f97bad551175$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $42d8f97bad551175$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$42d8f97bad551175$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $42d8f97bad551175$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$42d8f97bad551175$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $42d8f97bad551175$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$42d8f97bad551175$var$Buffer.prototype.readBigInt64LE = $42d8f97bad551175$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $42d8f97bad551175$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $42d8f97bad551175$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$42d8f97bad551175$var$Buffer.prototype.readBigInt64BE = $42d8f97bad551175$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $42d8f97bad551175$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $42d8f97bad551175$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$42d8f97bad551175$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $42d8f97bad551175$var$checkOffset(offset, 4, this.length);
    return $52c04c7d68ded0b0$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$42d8f97bad551175$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $42d8f97bad551175$var$checkOffset(offset, 4, this.length);
    return $52c04c7d68ded0b0$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$42d8f97bad551175$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $42d8f97bad551175$var$checkOffset(offset, 8, this.length);
    return $52c04c7d68ded0b0$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$42d8f97bad551175$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $42d8f97bad551175$var$checkOffset(offset, 8, this.length);
    return $52c04c7d68ded0b0$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $42d8f97bad551175$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$42d8f97bad551175$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$42d8f97bad551175$var$Buffer.prototype.writeUintLE = $42d8f97bad551175$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $42d8f97bad551175$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$42d8f97bad551175$var$Buffer.prototype.writeUintBE = $42d8f97bad551175$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $42d8f97bad551175$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$42d8f97bad551175$var$Buffer.prototype.writeUint8 = $42d8f97bad551175$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $42d8f97bad551175$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$42d8f97bad551175$var$Buffer.prototype.writeUint16LE = $42d8f97bad551175$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $42d8f97bad551175$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$42d8f97bad551175$var$Buffer.prototype.writeUint16BE = $42d8f97bad551175$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $42d8f97bad551175$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$42d8f97bad551175$var$Buffer.prototype.writeUint32LE = $42d8f97bad551175$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $42d8f97bad551175$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$42d8f97bad551175$var$Buffer.prototype.writeUint32BE = $42d8f97bad551175$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $42d8f97bad551175$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $42d8f97bad551175$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $42d8f97bad551175$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $42d8f97bad551175$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $42d8f97bad551175$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$42d8f97bad551175$var$Buffer.prototype.writeBigUInt64LE = $42d8f97bad551175$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $42d8f97bad551175$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$42d8f97bad551175$var$Buffer.prototype.writeBigUInt64BE = $42d8f97bad551175$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $42d8f97bad551175$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$42d8f97bad551175$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $42d8f97bad551175$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$42d8f97bad551175$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $42d8f97bad551175$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$42d8f97bad551175$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $42d8f97bad551175$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$42d8f97bad551175$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $42d8f97bad551175$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$42d8f97bad551175$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $42d8f97bad551175$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$42d8f97bad551175$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $42d8f97bad551175$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$42d8f97bad551175$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $42d8f97bad551175$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$42d8f97bad551175$var$Buffer.prototype.writeBigInt64LE = $42d8f97bad551175$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $42d8f97bad551175$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$42d8f97bad551175$var$Buffer.prototype.writeBigInt64BE = $42d8f97bad551175$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $42d8f97bad551175$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $42d8f97bad551175$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $42d8f97bad551175$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $42d8f97bad551175$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $52c04c7d68ded0b0$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$42d8f97bad551175$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $42d8f97bad551175$var$writeFloat(this, value, offset, true, noAssert);
};
$42d8f97bad551175$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $42d8f97bad551175$var$writeFloat(this, value, offset, false, noAssert);
};
function $42d8f97bad551175$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $42d8f97bad551175$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $52c04c7d68ded0b0$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$42d8f97bad551175$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $42d8f97bad551175$var$writeDouble(this, value, offset, true, noAssert);
};
$42d8f97bad551175$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $42d8f97bad551175$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$42d8f97bad551175$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$42d8f97bad551175$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$42d8f97bad551175$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$42d8f97bad551175$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $42d8f97bad551175$var$Buffer.isBuffer(val) ? val : $42d8f97bad551175$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $42d8f97bad551175$var$errors = {};
function $42d8f97bad551175$var$E(sym, getMessage, Base) {
    $42d8f97bad551175$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$42d8f97bad551175$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$42d8f97bad551175$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$42d8f97bad551175$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $42d8f97bad551175$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $42d8f97bad551175$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $42d8f97bad551175$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $42d8f97bad551175$var$checkBounds(buf, offset, byteLength) {
    $42d8f97bad551175$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $42d8f97bad551175$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $42d8f97bad551175$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $42d8f97bad551175$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $42d8f97bad551175$var$checkBounds(buf, offset, byteLength);
}
function $42d8f97bad551175$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $42d8f97bad551175$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $42d8f97bad551175$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $42d8f97bad551175$var$validateNumber(value, type);
        throw new $42d8f97bad551175$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $42d8f97bad551175$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $42d8f97bad551175$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $42d8f97bad551175$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $42d8f97bad551175$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($42d8f97bad551175$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $42d8f97bad551175$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $42d8f97bad551175$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $42d8f97bad551175$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $42d8f97bad551175$var$base64ToBytes(str) {
    return $315084220e030bc4$export$d622b2ad8d90c771($42d8f97bad551175$var$base64clean(str));
}
function $42d8f97bad551175$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $42d8f97bad551175$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $42d8f97bad551175$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $42d8f97bad551175$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $42d8f97bad551175$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $42d8f97bad551175$var$BufferBigIntNotDefined : fn;
}
function $42d8f97bad551175$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $d4cf365b45bc1ebb$require$Buffer = $42d8f97bad551175$export$a143d493d941bafc;
'use strict';
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $d4cf365b45bc1ebb$var$isVisitable(thing) {
    return (0, $774febe52dcf2b32$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $774febe52dcf2b32$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $d4cf365b45bc1ebb$var$removeBrackets(key) {
    return (0, $774febe52dcf2b32$export$2e2bcd8739ae039).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $d4cf365b45bc1ebb$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $d4cf365b45bc1ebb$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $d4cf365b45bc1ebb$var$isFlatArray(arr) {
    return (0, $774febe52dcf2b32$export$2e2bcd8739ae039).isArray(arr) && !arr.some($d4cf365b45bc1ebb$var$isVisitable);
}
const $d4cf365b45bc1ebb$var$predicates = (0, $774febe52dcf2b32$export$2e2bcd8739ae039).toFlatObject((0, $774febe52dcf2b32$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $d4cf365b45bc1ebb$var$toFormData(obj, formData, options) {
    if (!(0, $774febe52dcf2b32$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $d9db0af325ed2d73$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $774febe52dcf2b32$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $774febe52dcf2b32$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    const maxDepth = options.maxDepth === undefined ? 100 : options.maxDepth;
    const useBlob = _Blob && (0, $774febe52dcf2b32$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $774febe52dcf2b32$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $774febe52dcf2b32$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if ((0, $774febe52dcf2b32$export$2e2bcd8739ae039).isBoolean(value)) return value.toString();
        if (!useBlob && (0, $774febe52dcf2b32$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $8b3b4a5a8260bec3$export$2e2bcd8739ae039)('Blob is not supported. Use a Buffer instead.');
        if ((0, $774febe52dcf2b32$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $774febe52dcf2b32$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === 'function' ? new Blob([
            value
        ]) : $d4cf365b45bc1ebb$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if ((0, $774febe52dcf2b32$export$2e2bcd8739ae039).isReactNative(formData) && (0, $774febe52dcf2b32$export$2e2bcd8739ae039).isReactNativeBlob(value)) {
            formData.append($d4cf365b45bc1ebb$var$renderKey(path, key, dots), convertValue(value));
            return false;
        }
        if (value && !path && typeof value === 'object') {
            if ((0, $774febe52dcf2b32$export$2e2bcd8739ae039).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $774febe52dcf2b32$export$2e2bcd8739ae039).isArray(value) && $d4cf365b45bc1ebb$var$isFlatArray(value) || ((0, $774febe52dcf2b32$export$2e2bcd8739ae039).isFileList(value) || (0, $774febe52dcf2b32$export$2e2bcd8739ae039).endsWith(key, '[]')) && (arr = (0, $774febe52dcf2b32$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $d4cf365b45bc1ebb$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $774febe52dcf2b32$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $d4cf365b45bc1ebb$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($d4cf365b45bc1ebb$var$isVisitable(value)) return true;
        formData.append($d4cf365b45bc1ebb$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($d4cf365b45bc1ebb$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $d4cf365b45bc1ebb$var$isVisitable
    });
    function build(value, path, depth = 0) {
        if ((0, $774febe52dcf2b32$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (depth > maxDepth) throw new (0, $8b3b4a5a8260bec3$export$2e2bcd8739ae039)('Object is too deeply nested (' + depth + ' levels). Max depth: ' + maxDepth, (0, $8b3b4a5a8260bec3$export$2e2bcd8739ae039).ERR_FORM_DATA_DEPTH_EXCEEDED);
        if (stack.indexOf(value) !== -1) throw new Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $774febe52dcf2b32$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $774febe52dcf2b32$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $774febe52dcf2b32$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ], depth + 1);
        });
        stack.pop();
    }
    if (!(0, $774febe52dcf2b32$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $d4cf365b45bc1ebb$export$2e2bcd8739ae039 = $d4cf365b45bc1ebb$var$toFormData;


'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $5efdc4f3bb5fd854$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $5efdc4f3bb5fd854$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $d4cf365b45bc1ebb$export$2e2bcd8739ae039)(params, this, options);
}
const $5efdc4f3bb5fd854$var$prototype = $5efdc4f3bb5fd854$var$AxiosURLSearchParams.prototype;
$5efdc4f3bb5fd854$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$5efdc4f3bb5fd854$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $5efdc4f3bb5fd854$var$encode);
    } : $5efdc4f3bb5fd854$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $5efdc4f3bb5fd854$export$2e2bcd8739ae039 = $5efdc4f3bb5fd854$var$AxiosURLSearchParams;


'use strict';
function $3391ff6e5abae8f4$export$c564cdbbe6da493(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+');
}
function $3391ff6e5abae8f4$export$2e2bcd8739ae039(url, params, options) {
    if (!params) return url;
    const _encode = options && options.encode || $3391ff6e5abae8f4$export$c564cdbbe6da493;
    const _options = (0, $774febe52dcf2b32$export$2e2bcd8739ae039).isFunction(options) ? {
        serialize: options
    } : options;
    const serializeFn = _options && _options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, _options);
    else serializedParams = (0, $774febe52dcf2b32$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $5efdc4f3bb5fd854$export$2e2bcd8739ae039)(params, _options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}



'use strict';
class $fcbf904c649fd851$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $774febe52dcf2b32$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $fcbf904c649fd851$export$2e2bcd8739ae039 = $fcbf904c649fd851$var$InterceptorManager;





'use strict';
var $cb94483360bfaa94$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false,
    legacyInterceptorReqResOrdering: true,
    advertiseZstdAcceptEncoding: false
};






'use strict';
var $34f4d0a3a23f1ff5$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $5efdc4f3bb5fd854$export$2e2bcd8739ae039);


'use strict';
var $33bcb1bd0f30e866$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;


'use strict';
var $4f6fedf052ae02dd$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;


var $1779a47ad0012141$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $34f4d0a3a23f1ff5$export$2e2bcd8739ae039,
        FormData: $33bcb1bd0f30e866$export$2e2bcd8739ae039,
        Blob: $4f6fedf052ae02dd$export$2e2bcd8739ae039
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};


var $212fd0c323983291$exports = {};

$parcel$export($212fd0c323983291$exports, "hasBrowserEnv", function () { return $212fd0c323983291$export$c4996c4b7b93b0bf; });
$parcel$export($212fd0c323983291$exports, "navigator", function () { return $212fd0c323983291$export$ec7c8efa7f5790ae; });
$parcel$export($212fd0c323983291$exports, "hasStandardBrowserEnv", function () { return $212fd0c323983291$export$c0bcc9250309d66; });
$parcel$export($212fd0c323983291$exports, "hasStandardBrowserWebWorkerEnv", function () { return $212fd0c323983291$export$c81692cf5af97dac; });
$parcel$export($212fd0c323983291$exports, "origin", function () { return $212fd0c323983291$export$f710a83a91838a36; });
const $212fd0c323983291$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $212fd0c323983291$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $212fd0c323983291$export$c0bcc9250309d66 = $212fd0c323983291$export$c4996c4b7b93b0bf && (!$212fd0c323983291$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($212fd0c323983291$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $212fd0c323983291$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $212fd0c323983291$export$f710a83a91838a36 = $212fd0c323983291$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';


var $81b1c604b898e780$export$2e2bcd8739ae039 = {
    ...$212fd0c323983291$exports,
    ...(0, $1779a47ad0012141$export$2e2bcd8739ae039)
};


'use strict';
function $0db19fd4089983ce$export$2e2bcd8739ae039(data, options) {
    return (0, $d4cf365b45bc1ebb$export$2e2bcd8739ae039)(data, new (0, $81b1c604b898e780$export$2e2bcd8739ae039).classes.URLSearchParams(), {
        visitor: function(value, key, path, helpers) {
            if ((0, $81b1c604b898e780$export$2e2bcd8739ae039).isNode && (0, $774febe52dcf2b32$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        },
        ...options
    });
}




'use strict';
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $a7fa9fb3b95a39f8$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $774febe52dcf2b32$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === '[]' ? '' : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $a7fa9fb3b95a39f8$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $a7fa9fb3b95a39f8$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $774febe52dcf2b32$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $774febe52dcf2b32$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = (0, $774febe52dcf2b32$export$2e2bcd8739ae039).isArray(target[name]) ? target[name].concat(value) : [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!(0, $774febe52dcf2b32$export$2e2bcd8739ae039).hasOwnProp(target, name) || !(0, $774febe52dcf2b32$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $774febe52dcf2b32$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $a7fa9fb3b95a39f8$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $774febe52dcf2b32$export$2e2bcd8739ae039).isFormData(formData) && (0, $774febe52dcf2b32$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $774febe52dcf2b32$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($a7fa9fb3b95a39f8$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $a7fa9fb3b95a39f8$export$2e2bcd8739ae039 = $a7fa9fb3b95a39f8$var$formDataToJSON;


'use strict';
const $fa12654d0ac47b00$var$own = (obj, key)=>obj != null && (0, $774febe52dcf2b32$export$2e2bcd8739ae039).hasOwnProp(obj, key) ? obj[key] : undefined;
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $fa12654d0ac47b00$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $774febe52dcf2b32$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $774febe52dcf2b32$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $fa12654d0ac47b00$var$defaults = {
    transitional: (0, $cb94483360bfaa94$export$2e2bcd8739ae039),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $774febe52dcf2b32$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $774febe52dcf2b32$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $774febe52dcf2b32$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $a7fa9fb3b95a39f8$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $774febe52dcf2b32$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $774febe52dcf2b32$export$2e2bcd8739ae039).isBuffer(data) || (0, $774febe52dcf2b32$export$2e2bcd8739ae039).isStream(data) || (0, $774febe52dcf2b32$export$2e2bcd8739ae039).isFile(data) || (0, $774febe52dcf2b32$export$2e2bcd8739ae039).isBlob(data) || (0, $774febe52dcf2b32$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $774febe52dcf2b32$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $774febe52dcf2b32$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                const formSerializer = $fa12654d0ac47b00$var$own(this, 'formSerializer');
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $0db19fd4089983ce$export$2e2bcd8739ae039)(data, formSerializer).toString();
                if ((isFileList = (0, $774febe52dcf2b32$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const env = $fa12654d0ac47b00$var$own(this, 'env');
                    const _FormData = env && env.FormData;
                    return (0, $d4cf365b45bc1ebb$export$2e2bcd8739ae039)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $fa12654d0ac47b00$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = $fa12654d0ac47b00$var$own(this, 'transitional') || $fa12654d0ac47b00$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const responseType = $fa12654d0ac47b00$var$own(this, 'responseType');
            const JSONRequested = responseType === 'json';
            if ((0, $774febe52dcf2b32$export$2e2bcd8739ae039).isResponse(data) || (0, $774febe52dcf2b32$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $774febe52dcf2b32$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data, $fa12654d0ac47b00$var$own(this, 'parseReviver'));
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $8b3b4a5a8260bec3$export$2e2bcd8739ae039).from(e, (0, $8b3b4a5a8260bec3$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, $fa12654d0ac47b00$var$own(this, 'response'));
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $81b1c604b898e780$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $81b1c604b898e780$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $774febe52dcf2b32$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch',
    'query'
], (method)=>{
    $fa12654d0ac47b00$var$defaults.headers[method] = {};
});
var $fa12654d0ac47b00$export$2e2bcd8739ae039 = $fa12654d0ac47b00$var$defaults;



'use strict';
function $df974ad6b3a85dd2$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $fa12654d0ac47b00$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $8f6208361ca0a857$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $774febe52dcf2b32$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


'use strict';
function $7cb7d237d94ec9ca$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}




'use strict';
class $c43fbfb81b86bb34$var$CanceledError extends (0, $8b3b4a5a8260bec3$export$2e2bcd8739ae039) {
    /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */ constructor(message, config, request){
        super(message == null ? 'canceled' : message, (0, $8b3b4a5a8260bec3$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
        this.name = 'CanceledError';
        this.__CANCEL__ = true;
    }
}
var $c43fbfb81b86bb34$export$2e2bcd8739ae039 = $c43fbfb81b86bb34$var$CanceledError;







'use strict';
function $fd5ead3f1b421dac$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $8b3b4a5a8260bec3$export$2e2bcd8739ae039)('Request failed with status code ' + response.status, response.status >= 400 && response.status < 500 ? (0, $8b3b4a5a8260bec3$export$2e2bcd8739ae039).ERR_BAD_REQUEST : (0, $8b3b4a5a8260bec3$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, response.config, response.request, response));
}





'use strict';
function $bfaa2bbc4cdc262f$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25}):(?:\/\/)?/.exec(url);
    return match && match[1] || '';
}




'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $fd53f19c10d0aada$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $fd53f19c10d0aada$export$2e2bcd8739ae039 = $fd53f19c10d0aada$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $517caca9f1d32168$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn(...args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $517caca9f1d32168$export$2e2bcd8739ae039 = $517caca9f1d32168$var$throttle;



const $6a56045cdc547765$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $fd53f19c10d0aada$export$2e2bcd8739ae039)(50, 250);
    return (0, $517caca9f1d32168$export$2e2bcd8739ae039)((e)=>{
        if (!e || typeof e.loaded !== 'number') return;
        const rawLoaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const loaded = total != null ? Math.min(rawLoaded, total) : rawLoaded;
        const progressBytes = Math.max(0, loaded - bytesNotified);
        const rate = _speedometer(progressBytes);
        bytesNotified = Math.max(bytesNotified, loaded);
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $6a56045cdc547765$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $6a56045cdc547765$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $774febe52dcf2b32$export$2e2bcd8739ae039).asap(()=>fn(...args));





var $973a13a4169e862f$export$2e2bcd8739ae039 = (0, $81b1c604b898e780$export$2e2bcd8739ae039).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $81b1c604b898e780$export$2e2bcd8739ae039).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $81b1c604b898e780$export$2e2bcd8739ae039).origin), (0, $81b1c604b898e780$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $81b1c604b898e780$export$2e2bcd8739ae039).navigator.userAgent)) : ()=>true;




var $d24b6d284968d418$export$2e2bcd8739ae039 = (0, $81b1c604b898e780$export$2e2bcd8739ae039).hasStandardBrowserEnv ? {
    write (name, value, expires, path, domain, secure, sameSite) {
        if (typeof document === 'undefined') return;
        const cookie = [
            `${name}=${encodeURIComponent(value)}`
        ];
        if ((0, $774febe52dcf2b32$export$2e2bcd8739ae039).isNumber(expires)) cookie.push(`expires=${new Date(expires).toUTCString()}`);
        if ((0, $774febe52dcf2b32$export$2e2bcd8739ae039).isString(path)) cookie.push(`path=${path}`);
        if ((0, $774febe52dcf2b32$export$2e2bcd8739ae039).isString(domain)) cookie.push(`domain=${domain}`);
        if (secure === true) cookie.push('secure');
        if ((0, $774febe52dcf2b32$export$2e2bcd8739ae039).isString(sameSite)) cookie.push(`SameSite=${sameSite}`);
        document.cookie = cookie.join('; ');
    },
    read (name) {
        if (typeof document === 'undefined') return null;
        // Match name=value by splitting on the semicolon separator instead of building a
        // RegExp from `name` — interpolating an unescaped string into a RegExp would let
        // metacharacters (e.g. `.+?` in an attacker-influenced cookie name) cause ReDoS or
        // match the wrong cookie. Browsers may serialize cookie pairs as either ";" or
        // "; ", so ignore optional whitespace before each cookie name.
        const cookies = document.cookie.split(';');
        for(let i = 0; i < cookies.length; i++){
            const cookie = cookies[i].replace(/^\s+/, '');
            const eq = cookie.indexOf('=');
            if (eq !== -1 && cookie.slice(0, eq) === name) return decodeURIComponent(cookie.slice(eq + 1));
        }
        return null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000, '/');
    }
} : {
    write () {},
    read () {
        return null;
    },
    remove () {}
};


'use strict';
function $df6bdeb4ee0bf791$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    if (typeof url !== 'string') return false;
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


'use strict';
function $8f3247ccc5b41455$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}


'use strict';
function $952e81de05946e25$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls) {
    let isRelativeUrl = !(0, $df6bdeb4ee0bf791$export$2e2bcd8739ae039)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls === false)) return (0, $8f3247ccc5b41455$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}




'use strict';
const $6a9a2304cf2da185$var$headersToObject = (thing)=>thing instanceof (0, $8f6208361ca0a857$export$2e2bcd8739ae039) ? {
        ...thing
    } : thing;
function $6a9a2304cf2da185$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    // Use a null-prototype object so that downstream reads such as `config.auth`
    // or `config.baseURL` cannot inherit polluted values from Object.prototype.
    // `hasOwnProperty` is restored as a non-enumerable own slot to preserve
    // ergonomics for user code that relies on it.
    const config = Object.create(null);
    Object.defineProperty(config, 'hasOwnProperty', {
        // Null-proto descriptor so a polluted Object.prototype.get cannot turn
        // this data descriptor into an accessor descriptor on the way in.
        __proto__: null,
        value: Object.prototype.hasOwnProperty,
        enumerable: false,
        writable: true,
        configurable: true
    });
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $774febe52dcf2b32$export$2e2bcd8739ae039).isPlainObject(target) && (0, $774febe52dcf2b32$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $774febe52dcf2b32$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $774febe52dcf2b32$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $774febe52dcf2b32$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $774febe52dcf2b32$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $774febe52dcf2b32$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $774febe52dcf2b32$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $774febe52dcf2b32$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $774febe52dcf2b32$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $774febe52dcf2b32$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if ((0, $774febe52dcf2b32$export$2e2bcd8739ae039).hasOwnProp(config2, prop)) return getMergedValue(a, b);
        else if ((0, $774febe52dcf2b32$export$2e2bcd8739ae039).hasOwnProp(config1, prop)) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        allowedSocketPaths: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($6a9a2304cf2da185$var$headersToObject(a), $6a9a2304cf2da185$var$headersToObject(b), prop, true)
    };
    (0, $774febe52dcf2b32$export$2e2bcd8739ae039).forEach(Object.keys({
        ...config1,
        ...config2
    }), function computeConfigValue(prop) {
        if (prop === '__proto__' || prop === 'constructor' || prop === 'prototype') return;
        const merge = (0, $774febe52dcf2b32$export$2e2bcd8739ae039).hasOwnProp(mergeMap, prop) ? mergeMap[prop] : mergeDeepProperties;
        const a = (0, $774febe52dcf2b32$export$2e2bcd8739ae039).hasOwnProp(config1, prop) ? config1[prop] : undefined;
        const b = (0, $774febe52dcf2b32$export$2e2bcd8739ae039).hasOwnProp(config2, prop) ? config2[prop] : undefined;
        const configValue = merge(a, b, prop);
        (0, $774febe52dcf2b32$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}




const $b1400a61780f1983$var$FORM_DATA_CONTENT_HEADERS = [
    'content-type',
    'content-length'
];
function $b1400a61780f1983$var$setFormDataHeaders(headers, formHeaders, policy) {
    if (policy !== 'content-only') {
        headers.set(formHeaders);
        return;
    }
    Object.entries(formHeaders).forEach(([key, val])=>{
        if ($b1400a61780f1983$var$FORM_DATA_CONTENT_HEADERS.includes(key.toLowerCase())) headers.set(key, val);
    });
}
/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ const $b1400a61780f1983$var$encodeUTF8 = (str)=>encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));
function $b1400a61780f1983$var$resolveConfig(config) {
    const newConfig = (0, $6a9a2304cf2da185$export$2e2bcd8739ae039)({}, config);
    // Read only own properties to prevent prototype pollution gadgets
    // (e.g. Object.prototype.baseURL = 'https://evil.com').
    const own = (key)=>(0, $774febe52dcf2b32$export$2e2bcd8739ae039).hasOwnProp(newConfig, key) ? newConfig[key] : undefined;
    const data = own('data');
    let withXSRFToken = own('withXSRFToken');
    const xsrfHeaderName = own('xsrfHeaderName');
    const xsrfCookieName = own('xsrfCookieName');
    let headers = own('headers');
    const auth = own('auth');
    const baseURL = own('baseURL');
    const allowAbsoluteUrls = own('allowAbsoluteUrls');
    const url = own('url');
    newConfig.headers = headers = (0, $8f6208361ca0a857$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $3391ff6e5abae8f4$export$2e2bcd8739ae039)((0, $952e81de05946e25$export$2e2bcd8739ae039)(baseURL, url, allowAbsoluteUrls), own('params'), own('paramsSerializer'));
    // HTTP basic authentication
    if (auth) headers.set('Authorization', 'Basic ' + btoa((auth.username || '') + ':' + (auth.password ? $b1400a61780f1983$var$encodeUTF8(auth.password) : '')));
    if ((0, $774febe52dcf2b32$export$2e2bcd8739ae039).isFormData(data)) {
        if ((0, $81b1c604b898e780$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $81b1c604b898e780$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv || (0, $774febe52dcf2b32$export$2e2bcd8739ae039).isReactNative(data)) headers.setContentType(undefined); // browser/web worker/RN handles it
        else if ((0, $774febe52dcf2b32$export$2e2bcd8739ae039).isFunction(data.getHeaders)) // Node.js FormData (like form-data package)
        $b1400a61780f1983$var$setFormDataHeaders(headers, data.getHeaders(), own('formDataHeaderPolicy'));
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $81b1c604b898e780$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        if ((0, $774febe52dcf2b32$export$2e2bcd8739ae039).isFunction(withXSRFToken)) withXSRFToken = withXSRFToken(newConfig);
        // Strict boolean check — prevents proto-pollution gadgets (e.g. Object.prototype.withXSRFToken = 1)
        // and misconfigurations (e.g. "false") from short-circuiting the same-origin check and leaking
        // the XSRF token cross-origin.
        const shouldSendXSRF = withXSRFToken === true || withXSRFToken == null && (0, $973a13a4169e862f$export$2e2bcd8739ae039)(newConfig.url);
        if (shouldSendXSRF) {
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $d24b6d284968d418$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
}
var $b1400a61780f1983$export$2e2bcd8739ae039 = $b1400a61780f1983$var$resolveConfig;



const $d7ecb5075454d99b$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $d7ecb5075454d99b$export$2e2bcd8739ae039 = $d7ecb5075454d99b$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $b1400a61780f1983$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $8f6208361ca0a857$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $8f6208361ca0a857$export$2e2bcd8739ae039).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $fd5ead3f1b421dac$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.startsWith('file:'))) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $8b3b4a5a8260bec3$export$2e2bcd8739ae039)('Request aborted', (0, $8b3b4a5a8260bec3$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError(event) {
            // Browsers deliver a ProgressEvent in XHR onerror
            // (message may be empty; when present, surface it)
            // See https://developer.mozilla.org/docs/Web/API/XMLHttpRequest/error_event
            const msg = event && event.message ? event.message : 'Network Error';
            const err = new (0, $8b3b4a5a8260bec3$export$2e2bcd8739ae039)(msg, (0, $8b3b4a5a8260bec3$export$2e2bcd8739ae039).ERR_NETWORK, config, request);
            // attach the underlying event for consumers who want details
            err.event = event || null;
            reject(err);
            done();
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $cb94483360bfaa94$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $8b3b4a5a8260bec3$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $8b3b4a5a8260bec3$export$2e2bcd8739ae039).ETIMEDOUT : (0, $8b3b4a5a8260bec3$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $774febe52dcf2b32$export$2e2bcd8739ae039).forEach((0, $4c7c42a80b5c1c07$export$c30c72bb7e677d54)(requestHeaders), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $774febe52dcf2b32$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $6a56045cdc547765$export$c1b28109d46c3592)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $6a56045cdc547765$export$c1b28109d46c3592)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $c43fbfb81b86bb34$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                done();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $bfaa2bbc4cdc262f$export$2e2bcd8739ae039)(_config.url);
        if (protocol && !(0, $81b1c604b898e780$export$2e2bcd8739ae039).protocols.includes(protocol)) {
            reject(new (0, $8b3b4a5a8260bec3$export$2e2bcd8739ae039)('Unsupported protocol ' + protocol + ':', (0, $8b3b4a5a8260bec3$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};








const $e25342f7c98f1192$var$composeSignals = (signals, timeout)=>{
    signals = signals ? signals.filter(Boolean) : [];
    if (!timeout && !signals.length) return;
    const controller = new AbortController();
    let aborted = false;
    const onabort = function(reason) {
        if (!aborted) {
            aborted = true;
            unsubscribe();
            const err = reason instanceof Error ? reason : this.reason;
            controller.abort(err instanceof (0, $8b3b4a5a8260bec3$export$2e2bcd8739ae039) ? err : new (0, $c43fbfb81b86bb34$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
        }
    };
    let timer = timeout && setTimeout(()=>{
        timer = null;
        onabort(new (0, $8b3b4a5a8260bec3$export$2e2bcd8739ae039)(`timeout of ${timeout}ms exceeded`, (0, $8b3b4a5a8260bec3$export$2e2bcd8739ae039).ETIMEDOUT));
    }, timeout);
    const unsubscribe = ()=>{
        if (!signals) return;
        timer && clearTimeout(timer);
        timer = null;
        signals.forEach((signal)=>{
            signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
        });
        signals = null;
    };
    signals.forEach((signal)=>signal.addEventListener('abort', onabort));
    const { signal: signal } = controller;
    signal.unsubscribe = ()=>(0, $774febe52dcf2b32$export$2e2bcd8739ae039).asap(unsubscribe);
    return signal;
};
var $e25342f7c98f1192$export$2e2bcd8739ae039 = $e25342f7c98f1192$var$composeSignals;


const $3d90eb0cbe72a59f$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $3d90eb0cbe72a59f$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $3d90eb0cbe72a59f$var$readStream(iterable))yield* $3d90eb0cbe72a59f$export$71b051935044bd5d(chunk, chunkSize);
};
const $3d90eb0cbe72a59f$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $3d90eb0cbe72a59f$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $3d90eb0cbe72a59f$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






/**
 * Estimate decoded byte length of a data:// URL *without* allocating large buffers.
 * - For base64: compute exact decoded size using length and padding;
 *               handle %XX at the character-count level (no string allocation).
 * - For non-base64: use UTF-8 byteLength of the encoded body as a safe upper bound.
 *
 * @param {string} url
 * @returns {number}
 */ 
var $0a173e8959fbcc6f$require$Buffer = $42d8f97bad551175$export$a143d493d941bafc;
function $0a173e8959fbcc6f$export$2e2bcd8739ae039(url) {
    if (!url || typeof url !== 'string') return 0;
    if (!url.startsWith('data:')) return 0;
    const comma = url.indexOf(',');
    if (comma < 0) return 0;
    const meta = url.slice(5, comma);
    const body = url.slice(comma + 1);
    const isBase64 = /;base64/i.test(meta);
    if (isBase64) {
        let effectiveLen = body.length;
        const len = body.length; // cache length
        for(let i = 0; i < len; i++)if (body.charCodeAt(i) === 37 /* '%' */  && i + 2 < len) {
            const a = body.charCodeAt(i + 1);
            const b = body.charCodeAt(i + 2);
            const isHex = (a >= 48 && a <= 57 || a >= 65 && a <= 70 || a >= 97 && a <= 102) && (b >= 48 && b <= 57 || b >= 65 && b <= 70 || b >= 97 && b <= 102);
            if (isHex) {
                effectiveLen -= 2;
                i += 2;
            }
        }
        let pad = 0;
        let idx = len - 1;
        const tailIsPct3D = (j)=>j >= 2 && body.charCodeAt(j - 2) === 37 && // '%'
            body.charCodeAt(j - 1) === 51 && // '3'
            (body.charCodeAt(j) === 68 || body.charCodeAt(j) === 100); // 'D' or 'd'
        if (idx >= 0) {
            if (body.charCodeAt(idx) === 61 /* '=' */ ) {
                pad++;
                idx--;
            } else if (tailIsPct3D(idx)) {
                pad++;
                idx -= 3;
            }
        }
        if (pad === 1 && idx >= 0) {
            if (body.charCodeAt(idx) === 61 /* '=' */ ) pad++;
            else if (tailIsPct3D(idx)) pad++;
        }
        const groups = Math.floor(effectiveLen / 4);
        const bytes = groups * 3 - (pad || 0);
        return bytes > 0 ? bytes : 0;
    }
    if (typeof $0a173e8959fbcc6f$require$Buffer !== 'undefined' && typeof $0a173e8959fbcc6f$require$Buffer.byteLength === 'function') return $0a173e8959fbcc6f$require$Buffer.byteLength(body, 'utf8');
    // Compute UTF-8 byte length directly from UTF-16 code units without allocating
    // a byte buffer (TextEncoder.encode would defeat the DoS guard on large bodies).
    // Using body.length here would undercount non-ASCII (e.g. '€' is 1 code unit
    // but 3 UTF-8 bytes).
    let bytes = 0;
    for(let i = 0, len = body.length; i < len; i++){
        const c = body.charCodeAt(i);
        if (c < 0x80) bytes += 1;
        else if (c < 0x800) bytes += 2;
        else if (c >= 0xd800 && c <= 0xdbff && i + 1 < len) {
            const next = body.charCodeAt(i + 1);
            if (next >= 0xdc00 && next <= 0xdfff) {
                bytes += 4;
                i++;
            } else bytes += 3;
        } else bytes += 3;
    }
    return bytes;
}


const $c8bab86bab9757f9$export$a4ad2735b021c132 = "1.17.0";



const $968f46742e45c8ac$var$DEFAULT_CHUNK_SIZE = 65536;
const { isFunction: $968f46742e45c8ac$var$isFunction } = (0, $774febe52dcf2b32$export$2e2bcd8739ae039);
/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ const $968f46742e45c8ac$var$encodeUTF8 = (str)=>encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));
// Node's WHATWG URL parser returns `username` and `password` percent-encoded.
// Decode before composing the `auth` option so credentials such as
// `my%40email.com:pass` are sent as `my@email.com:pass`. Falls back to the
// original value for malformed input so a bad encoding never throws.
const $968f46742e45c8ac$var$decodeURIComponentSafe = (value)=>{
    if (!(0, $774febe52dcf2b32$export$2e2bcd8739ae039).isString(value)) return value;
    try {
        return decodeURIComponent(value);
    } catch (error) {
        return value;
    }
};
const $968f46742e45c8ac$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $968f46742e45c8ac$var$maybeWithAuthCredentials = (url)=>{
    const protocolIndex = url.indexOf('://');
    let urlToCheck = url;
    if (protocolIndex !== -1) urlToCheck = urlToCheck.slice(protocolIndex + 3);
    return urlToCheck.includes('@') || urlToCheck.includes(':');
};
const $968f46742e45c8ac$var$factory = (env)=>{
    const globalObject = (0, $774febe52dcf2b32$export$2e2bcd8739ae039).global !== undefined && (0, $774febe52dcf2b32$export$2e2bcd8739ae039).global !== null ? (0, $774febe52dcf2b32$export$2e2bcd8739ae039).global : globalThis;
    const { ReadableStream: ReadableStream, TextEncoder: TextEncoder } = globalObject;
    env = (0, $774febe52dcf2b32$export$2e2bcd8739ae039).merge.call({
        skipUndefined: true
    }, {
        Request: globalObject.Request,
        Response: globalObject.Response
    }, env);
    const { fetch: envFetch, Request: Request, Response: Response } = env;
    const isFetchSupported = envFetch ? $968f46742e45c8ac$var$isFunction(envFetch) : typeof fetch === 'function';
    const isRequestSupported = $968f46742e45c8ac$var$isFunction(Request);
    const isResponseSupported = $968f46742e45c8ac$var$isFunction(Response);
    if (!isFetchSupported) return false;
    const isReadableStreamSupported = isFetchSupported && $968f46742e45c8ac$var$isFunction(ReadableStream);
    const encodeText = isFetchSupported && (typeof TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Request(str).arrayBuffer()));
    const supportsRequestStream = isRequestSupported && isReadableStreamSupported && $968f46742e45c8ac$var$test(()=>{
        let duplexAccessed = false;
        const request = new Request((0, $81b1c604b898e780$export$2e2bcd8739ae039).origin, {
            body: new ReadableStream(),
            method: 'POST',
            get duplex () {
                duplexAccessed = true;
                return 'half';
            }
        });
        const hasContentType = request.headers.has('Content-Type');
        if (request.body != null) request.body.cancel();
        return duplexAccessed && !hasContentType;
    });
    const supportsResponseStream = isResponseSupported && isReadableStreamSupported && $968f46742e45c8ac$var$test(()=>(0, $774febe52dcf2b32$export$2e2bcd8739ae039).isReadableStream(new Response('').body));
    const resolvers = {
        stream: supportsResponseStream && ((res)=>res.body)
    };
    isFetchSupported && (()=>{
        [
            'text',
            'arrayBuffer',
            'blob',
            'formData',
            'stream'
        ].forEach((type)=>{
            !resolvers[type] && (resolvers[type] = (res, config)=>{
                let method = res && res[type];
                if (method) return method.call(res);
                throw new (0, $8b3b4a5a8260bec3$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $8b3b4a5a8260bec3$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
            });
        });
    })();
    const getBodyLength = async (body)=>{
        if (body == null) return 0;
        if ((0, $774febe52dcf2b32$export$2e2bcd8739ae039).isBlob(body)) return body.size;
        if ((0, $774febe52dcf2b32$export$2e2bcd8739ae039).isSpecCompliantForm(body)) {
            const _request = new Request((0, $81b1c604b898e780$export$2e2bcd8739ae039).origin, {
                method: 'POST',
                body: body
            });
            return (await _request.arrayBuffer()).byteLength;
        }
        if ((0, $774febe52dcf2b32$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $774febe52dcf2b32$export$2e2bcd8739ae039).isArrayBuffer(body)) return body.byteLength;
        if ((0, $774febe52dcf2b32$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + '';
        if ((0, $774febe52dcf2b32$export$2e2bcd8739ae039).isString(body)) return (await encodeText(body)).byteLength;
    };
    const resolveBodyLength = async (headers, body)=>{
        const length = (0, $774febe52dcf2b32$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
        return length == null ? getBodyLength(body) : length;
    };
    return async (config)=>{
        let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions, maxContentLength: maxContentLength, maxBodyLength: maxBodyLength } = (0, $b1400a61780f1983$export$2e2bcd8739ae039)(config);
        const hasMaxContentLength = (0, $774febe52dcf2b32$export$2e2bcd8739ae039).isNumber(maxContentLength) && maxContentLength > -1;
        const hasMaxBodyLength = (0, $774febe52dcf2b32$export$2e2bcd8739ae039).isNumber(maxBodyLength) && maxBodyLength > -1;
        const own = (key)=>(0, $774febe52dcf2b32$export$2e2bcd8739ae039).hasOwnProp(config, key) ? config[key] : undefined;
        let _fetch = envFetch || fetch;
        responseType = responseType ? (responseType + '').toLowerCase() : 'text';
        let composedSignal = (0, $e25342f7c98f1192$export$2e2bcd8739ae039)([
            signal,
            cancelToken && cancelToken.toAbortSignal()
        ], timeout);
        let request = null;
        const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
            composedSignal.unsubscribe();
        });
        let requestContentLength;
        try {
            // HTTP basic authentication
            let auth = undefined;
            const configAuth = own('auth');
            if (configAuth) {
                const username = configAuth.username || '';
                const password = configAuth.password || '';
                auth = {
                    username: username,
                    password: password
                };
            }
            if ($968f46742e45c8ac$var$maybeWithAuthCredentials(url)) {
                const parsedURL = new URL(url, (0, $81b1c604b898e780$export$2e2bcd8739ae039).origin);
                if (!auth && (parsedURL.username || parsedURL.password)) {
                    const urlUsername = $968f46742e45c8ac$var$decodeURIComponentSafe(parsedURL.username);
                    const urlPassword = $968f46742e45c8ac$var$decodeURIComponentSafe(parsedURL.password);
                    auth = {
                        username: urlUsername,
                        password: urlPassword
                    };
                }
                if (parsedURL.username || parsedURL.password) {
                    parsedURL.username = '';
                    parsedURL.password = '';
                    url = parsedURL.href;
                }
            }
            if (auth) {
                headers.delete('authorization');
                headers.set('Authorization', 'Basic ' + btoa($968f46742e45c8ac$var$encodeUTF8((auth.username || '') + ':' + (auth.password || ''))));
            }
            // Enforce maxContentLength for data: URLs up-front so we never materialize
            // an oversized payload. The HTTP adapter applies the same check (see http.js
            // "if (protocol === 'data:')" branch).
            if (hasMaxContentLength && typeof url === 'string' && url.startsWith('data:')) {
                const estimated = (0, $0a173e8959fbcc6f$export$2e2bcd8739ae039)(url);
                if (estimated > maxContentLength) throw new (0, $8b3b4a5a8260bec3$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $8b3b4a5a8260bec3$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
            }
            // Enforce maxBodyLength against the outbound request body before dispatch.
            // Mirrors http.js behavior (ERR_BAD_REQUEST / 'Request body larger than
            // maxBodyLength limit'). Skip when the body length cannot be determined
            // (e.g. a live ReadableStream supplied by the caller).
            if (hasMaxBodyLength && method !== 'get' && method !== 'head') {
                const outboundLength = await resolveBodyLength(headers, data);
                if (typeof outboundLength === 'number' && isFinite(outboundLength) && outboundLength > maxBodyLength) throw new (0, $8b3b4a5a8260bec3$export$2e2bcd8739ae039)('Request body larger than maxBodyLength limit', (0, $8b3b4a5a8260bec3$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config, request);
            }
            if (onUploadProgress && supportsRequestStream && method !== 'get' && method !== 'head' && (requestContentLength = await resolveBodyLength(headers, data)) !== 0) {
                let _request = new Request(url, {
                    method: 'POST',
                    body: data,
                    duplex: 'half'
                });
                let contentTypeHeader;
                if ((0, $774febe52dcf2b32$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
                if (_request.body) {
                    const [onProgress, flush] = (0, $6a56045cdc547765$export$d9fadd12586c18d6)(requestContentLength, (0, $6a56045cdc547765$export$c1b28109d46c3592)((0, $6a56045cdc547765$export$5d35863c355a22a9)(onUploadProgress)));
                    data = (0, $3d90eb0cbe72a59f$export$b0119225647bd83)(_request.body, $968f46742e45c8ac$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
                }
            }
            if (!(0, $774febe52dcf2b32$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
            // Cloudflare Workers throws when credentials are defined
            // see https://github.com/cloudflare/workerd/issues/902
            const isCredentialsSupported = isRequestSupported && 'credentials' in Request.prototype;
            // If data is FormData and Content-Type is multipart/form-data without boundary,
            // delete it so fetch can set it correctly with the boundary
            if ((0, $774febe52dcf2b32$export$2e2bcd8739ae039).isFormData(data)) {
                const contentType = headers.getContentType();
                if (contentType && /^multipart\/form-data/i.test(contentType) && !/boundary=/i.test(contentType)) headers.delete('content-type');
            }
            // Set User-Agent header if not already set (fetch defaults to 'node' in Node.js)
            headers.set('User-Agent', 'axios/' + (0, $c8bab86bab9757f9$export$a4ad2735b021c132), false);
            const resolvedOptions = {
                ...fetchOptions,
                signal: composedSignal,
                method: method.toUpperCase(),
                headers: (0, $4c7c42a80b5c1c07$export$c30c72bb7e677d54)(headers.normalize()),
                body: data,
                duplex: 'half',
                credentials: isCredentialsSupported ? withCredentials : undefined
            };
            request = isRequestSupported && new Request(url, resolvedOptions);
            let response = await (isRequestSupported ? _fetch(request, fetchOptions) : _fetch(url, resolvedOptions));
            // Cheap pre-check: if the server honestly declares a content-length that
            // already exceeds the cap, reject before we start streaming.
            if (hasMaxContentLength) {
                const declaredLength = (0, $774febe52dcf2b32$export$2e2bcd8739ae039).toFiniteNumber(response.headers.get('content-length'));
                if (declaredLength != null && declaredLength > maxContentLength) throw new (0, $8b3b4a5a8260bec3$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $8b3b4a5a8260bec3$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
            }
            const isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');
            if (supportsResponseStream && response.body && (onDownloadProgress || hasMaxContentLength || isStreamResponse && unsubscribe)) {
                const options = {};
                [
                    'status',
                    'statusText',
                    'headers'
                ].forEach((prop)=>{
                    options[prop] = response[prop];
                });
                const responseContentLength = (0, $774febe52dcf2b32$export$2e2bcd8739ae039).toFiniteNumber(response.headers.get('content-length'));
                const [onProgress, flush] = onDownloadProgress && (0, $6a56045cdc547765$export$d9fadd12586c18d6)(responseContentLength, (0, $6a56045cdc547765$export$c1b28109d46c3592)((0, $6a56045cdc547765$export$5d35863c355a22a9)(onDownloadProgress), true)) || [];
                let bytesRead = 0;
                const onChunkProgress = (loadedBytes)=>{
                    if (hasMaxContentLength) {
                        bytesRead = loadedBytes;
                        if (bytesRead > maxContentLength) throw new (0, $8b3b4a5a8260bec3$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $8b3b4a5a8260bec3$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
                    }
                    onProgress && onProgress(loadedBytes);
                };
                response = new Response((0, $3d90eb0cbe72a59f$export$b0119225647bd83)(response.body, $968f46742e45c8ac$var$DEFAULT_CHUNK_SIZE, onChunkProgress, ()=>{
                    flush && flush();
                    unsubscribe && unsubscribe();
                }), options);
            }
            responseType = responseType || 'text';
            let responseData = await resolvers[(0, $774febe52dcf2b32$export$2e2bcd8739ae039).findKey(resolvers, responseType) || 'text'](response, config);
            // Fallback enforcement for environments without ReadableStream support
            // (legacy runtimes). Detect materialized size from typed output; skip
            // streams/Response passthrough since the user will read those themselves.
            if (hasMaxContentLength && !supportsResponseStream && !isStreamResponse) {
                let materializedSize;
                if (responseData != null) {
                    if (typeof responseData.byteLength === 'number') materializedSize = responseData.byteLength;
                    else if (typeof responseData.size === 'number') materializedSize = responseData.size;
                    else if (typeof responseData === 'string') materializedSize = typeof TextEncoder === 'function' ? new TextEncoder().encode(responseData).byteLength : responseData.length;
                }
                if (typeof materializedSize === 'number' && materializedSize > maxContentLength) throw new (0, $8b3b4a5a8260bec3$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $8b3b4a5a8260bec3$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
            }
            !isStreamResponse && unsubscribe && unsubscribe();
            return await new Promise((resolve, reject)=>{
                (0, $fd5ead3f1b421dac$export$2e2bcd8739ae039)(resolve, reject, {
                    data: responseData,
                    headers: (0, $8f6208361ca0a857$export$2e2bcd8739ae039).from(response.headers),
                    status: response.status,
                    statusText: response.statusText,
                    config: config,
                    request: request
                });
            });
        } catch (err) {
            unsubscribe && unsubscribe();
            // Safari can surface fetch aborts as a DOMException-like object whose
            // branded getters throw. Prefer our composed signal reason before reading
            // the caught error, preserving timeout vs cancellation semantics.
            if (composedSignal && composedSignal.aborted && composedSignal.reason instanceof (0, $8b3b4a5a8260bec3$export$2e2bcd8739ae039)) {
                const canceledError = composedSignal.reason;
                canceledError.config = config;
                request && (canceledError.request = request);
                err !== canceledError && (canceledError.cause = err);
                throw canceledError;
            }
            if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) throw Object.assign(new (0, $8b3b4a5a8260bec3$export$2e2bcd8739ae039)('Network Error', (0, $8b3b4a5a8260bec3$export$2e2bcd8739ae039).ERR_NETWORK, config, request, err && err.response), {
                cause: err.cause || err
            });
            throw (0, $8b3b4a5a8260bec3$export$2e2bcd8739ae039).from(err, err && err.code, config, request, err && err.response);
        }
    };
};
const $968f46742e45c8ac$var$seedCache = new Map();
const $968f46742e45c8ac$export$3105c6651375d4fa = (config)=>{
    let env = config && config.env || {};
    const { fetch: fetch1, Request: Request, Response: Response } = env;
    const seeds = [
        Request,
        Response,
        fetch1
    ];
    let len = seeds.length, i = len, seed, target, map = $968f46742e45c8ac$var$seedCache;
    while(i--){
        seed = seeds[i];
        target = map.get(seed);
        target === undefined && map.set(seed, target = i ? new Map() : $968f46742e45c8ac$var$factory(env));
        map = target;
    }
    return target;
};
const $968f46742e45c8ac$var$adapter = $968f46742e45c8ac$export$3105c6651375d4fa();
var $968f46742e45c8ac$export$2e2bcd8739ae039 = $968f46742e45c8ac$var$adapter;



/**
 * Known adapters mapping.
 * Provides environment-specific adapters for Axios:
 * - `http` for Node.js
 * - `xhr` for browsers
 * - `fetch` for fetch API-based requests
 *
 * @type {Object<string, Function|Object>}
 */ const $21455cc94e3d92ac$var$knownAdapters = {
    http: (0, $d9db0af325ed2d73$export$2e2bcd8739ae039),
    xhr: (0, $d7ecb5075454d99b$export$2e2bcd8739ae039),
    fetch: {
        get: $968f46742e45c8ac$export$3105c6651375d4fa
    }
};
// Assign adapter names for easier debugging and identification
(0, $774febe52dcf2b32$export$2e2bcd8739ae039).forEach($21455cc94e3d92ac$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            // Null-proto descriptors so a polluted Object.prototype.get cannot turn
            // these data descriptors into accessor descriptors on the way in.
            Object.defineProperty(fn, 'name', {
                __proto__: null,
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            __proto__: null,
            value: value
        });
    }
});
/**
 * Render a rejection reason string for unknown or unsupported adapters
 *
 * @param {string} reason
 * @returns {string}
 */ const $21455cc94e3d92ac$var$renderReason = (reason)=>`- ${reason}`;
/**
 * Check if the adapter is resolved (function, null, or false)
 *
 * @param {Function|null|false} adapter
 * @returns {boolean}
 */ const $21455cc94e3d92ac$var$isResolvedHandle = (adapter)=>(0, $774febe52dcf2b32$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
/**
 * Get the first suitable adapter from the provided list.
 * Tries each adapter in order until a supported one is found.
 * Throws an AxiosError if no adapter is suitable.
 *
 * @param {Array<string|Function>|string|Function} adapters - Adapter(s) by name or function.
 * @param {Object} config - Axios request configuration
 * @throws {AxiosError} If no suitable adapter is available
 * @returns {Function} The resolved adapter function
 */ function $21455cc94e3d92ac$var$getAdapter(adapters, config) {
    adapters = (0, $774febe52dcf2b32$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
        adapters
    ];
    const { length: length } = adapters;
    let nameOrAdapter;
    let adapter;
    const rejectedReasons = {};
    for(let i = 0; i < length; i++){
        nameOrAdapter = adapters[i];
        let id;
        adapter = nameOrAdapter;
        if (!$21455cc94e3d92ac$var$isResolvedHandle(nameOrAdapter)) {
            adapter = $21455cc94e3d92ac$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
            if (adapter === undefined) throw new (0, $8b3b4a5a8260bec3$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
        }
        if (adapter && ((0, $774febe52dcf2b32$export$2e2bcd8739ae039).isFunction(adapter) || (adapter = adapter.get(config)))) break;
        rejectedReasons[id || '#' + i] = adapter;
    }
    if (!adapter) {
        const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
        let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($21455cc94e3d92ac$var$renderReason).join('\n') : ' ' + $21455cc94e3d92ac$var$renderReason(reasons[0]) : 'as no adapter specified';
        throw new (0, $8b3b4a5a8260bec3$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, 'ERR_NOT_SUPPORT');
    }
    return adapter;
}
var /**
 * Exports Axios adapters and utility to resolve an adapter
 */ $21455cc94e3d92ac$export$2e2bcd8739ae039 = {
    getAdapter: /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */ $21455cc94e3d92ac$var$getAdapter,
    /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */ adapters: $21455cc94e3d92ac$var$knownAdapters
};


'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $bfa415807ce32911$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $c43fbfb81b86bb34$export$2e2bcd8739ae039)(null, config);
}
function $bfa415807ce32911$export$2e2bcd8739ae039(config) {
    $bfa415807ce32911$var$throwIfCancellationRequested(config);
    config.headers = (0, $8f6208361ca0a857$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $df974ad6b3a85dd2$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $21455cc94e3d92ac$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $fa12654d0ac47b00$export$2e2bcd8739ae039).adapter, config);
    return adapter(config).then(function onAdapterResolution(response) {
        $bfa415807ce32911$var$throwIfCancellationRequested(config);
        // Expose the current response on config so that transformResponse can
        // attach it to any AxiosError it throws (e.g. on JSON parse failure).
        // We clean it up afterwards to avoid polluting the config object.
        config.response = response;
        try {
            response.data = (0, $df974ad6b3a85dd2$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        } finally{
            delete config.response;
        }
        response.headers = (0, $8f6208361ca0a857$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $7cb7d237d94ec9ca$export$2e2bcd8739ae039)(reason)) {
            $bfa415807ce32911$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                config.response = reason.response;
                try {
                    reason.response.data = (0, $df974ad6b3a85dd2$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                } finally{
                    delete config.response;
                }
                reason.response.headers = (0, $8f6208361ca0a857$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}






'use strict';
const $28e219cd299b00f5$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $28e219cd299b00f5$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $28e219cd299b00f5$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $28e219cd299b00f5$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $c8bab86bab9757f9$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $8b3b4a5a8260bec3$export$2e2bcd8739ae039)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $8b3b4a5a8260bec3$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$28e219cd299b00f5$var$deprecatedWarnings[opt]) {
            $28e219cd299b00f5$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$28e219cd299b00f5$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $28e219cd299b00f5$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new (0, $8b3b4a5a8260bec3$export$2e2bcd8739ae039)('options must be an object', (0, $8b3b4a5a8260bec3$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        // Use hasOwnProperty so a polluted Object.prototype.<opt> cannot supply
        // a non-function validator and cause a TypeError.
        const validator = Object.prototype.hasOwnProperty.call(schema, opt) ? schema[opt] : undefined;
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $8b3b4a5a8260bec3$export$2e2bcd8739ae039)('option ' + opt + ' must be ' + result, (0, $8b3b4a5a8260bec3$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $8b3b4a5a8260bec3$export$2e2bcd8739ae039)('Unknown option ' + opt, (0, $8b3b4a5a8260bec3$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $28e219cd299b00f5$export$2e2bcd8739ae039 = {
    assertOptions: $28e219cd299b00f5$var$assertOptions,
    validators: $28e219cd299b00f5$var$validators
};




'use strict';
const $eb8c724ee41d3ac5$var$validators = (0, $28e219cd299b00f5$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $eb8c724ee41d3ac5$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, $fcbf904c649fd851$export$2e2bcd8739ae039)(),
            response: new (0, $fcbf904c649fd851$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = (()=>{
                    if (!dummy.stack) return '';
                    const firstNewlineIndex = dummy.stack.indexOf('\n');
                    return firstNewlineIndex === -1 ? '' : dummy.stack.slice(firstNewlineIndex + 1);
                })();
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack) {
                        const firstNewlineIndex = stack.indexOf('\n');
                        const secondNewlineIndex = firstNewlineIndex === -1 ? -1 : stack.indexOf('\n', firstNewlineIndex + 1);
                        const stackWithoutTwoTopLines = secondNewlineIndex === -1 ? '' : stack.slice(secondNewlineIndex + 1);
                        if (!String(err.stack).endsWith(stackWithoutTwoTopLines)) err.stack += '\n' + stack;
                    }
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $6a9a2304cf2da185$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $28e219cd299b00f5$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $eb8c724ee41d3ac5$var$validators.transitional($eb8c724ee41d3ac5$var$validators.boolean),
            forcedJSONParsing: $eb8c724ee41d3ac5$var$validators.transitional($eb8c724ee41d3ac5$var$validators.boolean),
            clarifyTimeoutError: $eb8c724ee41d3ac5$var$validators.transitional($eb8c724ee41d3ac5$var$validators.boolean),
            legacyInterceptorReqResOrdering: $eb8c724ee41d3ac5$var$validators.transitional($eb8c724ee41d3ac5$var$validators.boolean),
            advertiseZstdAcceptEncoding: $eb8c724ee41d3ac5$var$validators.transitional($eb8c724ee41d3ac5$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $774febe52dcf2b32$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $28e219cd299b00f5$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $eb8c724ee41d3ac5$var$validators.function,
                serialize: $eb8c724ee41d3ac5$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $28e219cd299b00f5$export$2e2bcd8739ae039).assertOptions(config, {
            baseUrl: $eb8c724ee41d3ac5$var$validators.spelling('baseURL'),
            withXsrfToken: $eb8c724ee41d3ac5$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $774febe52dcf2b32$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $774febe52dcf2b32$export$2e2bcd8739ae039).forEach([
            'delete',
            'get',
            'head',
            'post',
            'put',
            'patch',
            'query',
            'common'
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $8f6208361ca0a857$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            const transitional = config.transitional || (0, $cb94483360bfaa94$export$2e2bcd8739ae039);
            const legacyInterceptorReqResOrdering = transitional && transitional.legacyInterceptorReqResOrdering;
            if (legacyInterceptorReqResOrdering) requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
            else requestInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $bfa415807ce32911$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift(...requestInterceptorChain);
            chain.push(...responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $bfa415807ce32911$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $6a9a2304cf2da185$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $952e81de05946e25$export$2e2bcd8739ae039)(config.baseURL, config.url, config.allowAbsoluteUrls);
        return (0, $3391ff6e5abae8f4$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $774febe52dcf2b32$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $eb8c724ee41d3ac5$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $6a9a2304cf2da185$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $774febe52dcf2b32$export$2e2bcd8739ae039).forEach([
    'post',
    'put',
    'patch',
    'query'
], function forEachMethodWithData(method) {
    function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $6a9a2304cf2da185$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $eb8c724ee41d3ac5$var$Axios.prototype[method] = generateHTTPMethod();
    // QUERY is a safe/idempotent read method; multipart form bodies don't fit
    // its semantics, so no queryForm shorthand is generated.
    if (method !== 'query') $eb8c724ee41d3ac5$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $eb8c724ee41d3ac5$export$2e2bcd8739ae039 = $eb8c724ee41d3ac5$var$Axios;







'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $2be4ce26a8fe0b57$var$CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $c43fbfb81b86bb34$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $2be4ce26a8fe0b57$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $2be4ce26a8fe0b57$export$2e2bcd8739ae039 = $2be4ce26a8fe0b57$var$CancelToken;






'use strict';
function $5842441b6e4bdcbc$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



'use strict';
function $6eacbcf64cbe073d$export$2e2bcd8739ae039(payload) {
    return (0, $774febe52dcf2b32$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $dafe9de74b68527c$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511,
    WebServerIsDown: 521,
    ConnectionTimedOut: 522,
    OriginIsUnreachable: 523,
    TimeoutOccurred: 524,
    SslHandshakeFailed: 525,
    InvalidSslCertificate: 526
};
Object.entries($dafe9de74b68527c$var$HttpStatusCode).forEach(([key, value])=>{
    $dafe9de74b68527c$var$HttpStatusCode[value] = key;
});
var $dafe9de74b68527c$export$2e2bcd8739ae039 = $dafe9de74b68527c$var$HttpStatusCode;


'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $0a757f15441211e8$var$createInstance(defaultConfig) {
    const context = new (0, $eb8c724ee41d3ac5$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $dbca83f1be06ed58$export$2e2bcd8739ae039)((0, $eb8c724ee41d3ac5$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $774febe52dcf2b32$export$2e2bcd8739ae039).extend(instance, (0, $eb8c724ee41d3ac5$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $774febe52dcf2b32$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $0a757f15441211e8$var$createInstance((0, $6a9a2304cf2da185$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $0a757f15441211e8$var$axios = $0a757f15441211e8$var$createInstance((0, $fa12654d0ac47b00$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$0a757f15441211e8$var$axios.Axios = (0, $eb8c724ee41d3ac5$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$0a757f15441211e8$var$axios.CanceledError = (0, $c43fbfb81b86bb34$export$2e2bcd8739ae039);
$0a757f15441211e8$var$axios.CancelToken = (0, $2be4ce26a8fe0b57$export$2e2bcd8739ae039);
$0a757f15441211e8$var$axios.isCancel = (0, $7cb7d237d94ec9ca$export$2e2bcd8739ae039);
$0a757f15441211e8$var$axios.VERSION = (0, $c8bab86bab9757f9$export$a4ad2735b021c132);
$0a757f15441211e8$var$axios.toFormData = (0, $d4cf365b45bc1ebb$export$2e2bcd8739ae039);
// Expose AxiosError class
$0a757f15441211e8$var$axios.AxiosError = (0, $8b3b4a5a8260bec3$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$0a757f15441211e8$var$axios.Cancel = $0a757f15441211e8$var$axios.CanceledError;
// Expose all/spread
$0a757f15441211e8$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$0a757f15441211e8$var$axios.spread = (0, $5842441b6e4bdcbc$export$2e2bcd8739ae039);
// Expose isAxiosError
$0a757f15441211e8$var$axios.isAxiosError = (0, $6eacbcf64cbe073d$export$2e2bcd8739ae039);
// Expose mergeConfig
$0a757f15441211e8$var$axios.mergeConfig = (0, $6a9a2304cf2da185$export$2e2bcd8739ae039);
$0a757f15441211e8$var$axios.AxiosHeaders = (0, $8f6208361ca0a857$export$2e2bcd8739ae039);
$0a757f15441211e8$var$axios.formToJSON = (thing)=>(0, $a7fa9fb3b95a39f8$export$2e2bcd8739ae039)((0, $774febe52dcf2b32$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$0a757f15441211e8$var$axios.getAdapter = (0, $21455cc94e3d92ac$export$2e2bcd8739ae039).getAdapter;
$0a757f15441211e8$var$axios.HttpStatusCode = (0, $dafe9de74b68527c$export$2e2bcd8739ae039);
$0a757f15441211e8$var$axios.default = $0a757f15441211e8$var$axios;
var // this module should only have a default export
$0a757f15441211e8$export$2e2bcd8739ae039 = $0a757f15441211e8$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $4af2f79b7360f1f0$export$1c00760e9e5a4e95, AxiosError: $4af2f79b7360f1f0$export$c1fbed17c2f6a328, CanceledError: $4af2f79b7360f1f0$export$1ab0c6b20d94fa14, isCancel: $4af2f79b7360f1f0$export$3b22524397b493c6, CancelToken: $4af2f79b7360f1f0$export$fd08e3cb425f0d61, VERSION: $4af2f79b7360f1f0$export$a4ad2735b021c132, all: $4af2f79b7360f1f0$export$84bf76cd7afc7469, Cancel: $4af2f79b7360f1f0$export$848c9b7ead0df967, isAxiosError: $4af2f79b7360f1f0$export$fbafdbe06a5b5a9a, spread: $4af2f79b7360f1f0$export$3ae0fd4797ed47c8, toFormData: $4af2f79b7360f1f0$export$10ae0d317ea97f8b, AxiosHeaders: $4af2f79b7360f1f0$export$4e7d6ff0f3e6520, HttpStatusCode: $4af2f79b7360f1f0$export$a972f69c851492b3, formToJSON: $4af2f79b7360f1f0$export$86d7c59254d6a2c9, getAdapter: $4af2f79b7360f1f0$export$17ddc20a97d669e2, mergeConfig: $4af2f79b7360f1f0$export$7ec1ebcfa9d8bd6a, create: $4af2f79b7360f1f0$export$185802fd694ee1f5 } = (0, $0a757f15441211e8$export$2e2bcd8739ae039);




const $895fdb2cf61ec4c8$export$2fb87bbf5418dbe1 = ()=>{
    if (window?.casaHelperUtils?.handleLogOut) window?.casaHelperUtils?.handleLogOut();
    else console.error("unable to redirect to login");
};




var $299WK = parcelRequire("299WK");




parcelRequire("djhfc");


parcelRequire("ejUix");


parcelRequire("3IGjv");


var $299WK = parcelRequire("299WK");
const $de5bf67cbc950cd2$var$getRegion = ()=>{
    const host = window.location.host;
    if (host.includes("us11")) return "us-east-1";
    if (host.includes("ca12")) return "ca-central-1";
    if (host.includes("ir31")) return "eu-west-1";
    if (host.includes("in22")) return "ap-south-2";
    if (host.endsWith("crm4b2c.com")) return "ap-southeast-1";
    if (host.endsWith("lsq-staging.com")) return "ap-south-1";
    if (host.endsWith("leadsquared.com")) return "ap-south-1";
    return "local";
};
const $de5bf67cbc950cd2$export$b24072b01ab59bb6 = ({ userId: userId, orgCode: orgCode } = {})=>{
    try {
        (0, $299WK.p).setUserContext({
            user_id: userId ? String(userId) : undefined,
            user_metadata: {
                ...orgCode && {
                    org_code: String(orgCode)
                },
                cloud_region: $de5bf67cbc950cd2$var$getRegion()
            }
        });
    } catch (_) {}
};
const $de5bf67cbc950cd2$export$9fec4d97f1922e0b = (key, value)=>{
    try {
        (0, $299WK.p).setLabels({
            [key]: String(value)
        });
    } catch (_) {}
};
const $de5bf67cbc950cd2$export$e3d8a4342ef77d1b = (error, context)=>{
    try {
        (0, $299WK.p).reportError(error, context);
    } catch (_) {}
};
const $de5bf67cbc950cd2$export$73d0a139caca1fee = (name, data)=>{
    try {
        (0, $299WK.p).log(3, name, {
            ...data
        });
    } catch (_) {}
};
const $de5bf67cbc950cd2$export$2c1c6d1a3de9fe41 = (name, data)=>{
    try {
        (0, $299WK.p).log(1, name, {
            ...data
        });
    } catch (_) {}
};


const $3e1393dc3782b6fe$var$user = (0, $8a9518f7458123dc$export$714d3544202969b)();
const $3e1393dc3782b6fe$var$tenantName = (0, $8a9518f7458123dc$export$aacd81ffe42ab171)();
const $3e1393dc3782b6fe$export$a95a94f41a22cc93 = (apiRes)=>{
    const data = {
        api: apiRes.request.responseURL,
        method: apiRes.config.method,
        status: apiRes?.status >= 400 ? "Failed" : "Success",
        appEnvironment: $3e1393dc3782b6fe$var$getEnv(),
        traceId: apiRes.headers?.["x-b3-traceid"],
        responseTime: apiRes.responseTime,
        orgCode: $3e1393dc3782b6fe$var$user?.OrgCode,
        orgName: $3e1393dc3782b6fe$var$tenantName,
        userId: $3e1393dc3782b6fe$var$user?.Id
    };
    (0, $de5bf67cbc950cd2$export$73d0a139caca1fee)($3e1393dc3782b6fe$var$extractApiWord(apiRes.request.responseURL) + " WebRequests", data);
};
const $3e1393dc3782b6fe$var$extractApiWord = (url)=>{
    const match = /api\/([^/]+)/.exec(url);
    if (match && match[1]) return match[1];
    else return null;
};
const $3e1393dc3782b6fe$var$getEnv = ()=>{
    const host = window.location.host;
    if (host.endsWith("marketxpander.net")) return "dev";
    else if (host.endsWith("crm4b2c.com")) return "test";
    else if (host.endsWith("lsq-staging.com")) return "stage";
    else if (host.endsWith("leadsquared.com")) return "prod";
    else return "local";
};
const $3e1393dc3782b6fe$export$d4a625cede2da71b = ()=>{
    const host = window.location.host;
    if (host.includes("us11")) return "us-east-1";
    if (host.includes("ca12")) return "ca-central-1";
    if (host.includes("ir31")) return "eu-west-1";
    if (host.includes("in22")) return "ap-south-2";
    if (host.endsWith("crm4b2c.com")) return "ap-southeast-1";
    if (host.endsWith("lsq-staging.com")) return "ap-south-1";
    if (host.endsWith("leadsquared.com")) return "ap-south-1";
    return "local";
};




/**
 * Axios adapter over the platform's payload-crypto library, for the NextGen custom-domain
 * deployment (PK-5181).
 *
 * This app is a microfrontend: the NextGen shell appends its bundle as a <script> into its OWN
 * document, so there is no build of ours to put a <script src=".../payload-crypto.min.js"> tag
 * into. The shell already loads that library -- gated on its custom-domain build -- and it lands
 * on the one window we share with it. So the library is never bundled and never loaded here; it
 * is borrowed.
 *
 * Two consequences the plumbing below depends on:
 *
 *  - configure() is NOT called. window.PayloadCrypto is a single instance shared with the shell,
 *    which has already configured it with its own error reporting. Configuring it again would
 *    replace that, and the handshake, session key and IndexedDB record are shared either way.
 *
 *  - Every call is guarded rather than the interceptors being registered once. Our bundle is
 *    appended at an arbitrary point in the shell's lifecycle, so the library may not be resolved
 *    yet; a missing library degrades to plaintext instead of throwing.
 *
 * No crypto happens here. Everything below is plumbing between that library and axios.
 */ 
const $1c891e7043e88eb6$var$REINIT_HEADER = "x-lsq-enc-reinit";
const $1c891e7043e88eb6$var$lib = ()=>typeof window === "undefined" ? undefined : window.PayloadCrypto;
const $1c891e7043e88eb6$export$5371678af074b76 = ()=>Boolean($1c891e7043e88eb6$var$lib());
const $1c891e7043e88eb6$var$parseIfJson = (value)=>{
    if (typeof value !== "string") return value;
    try {
        return JSON.parse(value);
    } catch  {
        // A sealed response that is not JSON is legitimate; hand back the plaintext untouched.
        return value;
    }
};
/**
 * axios splits a request across url/params/data, but prepareRequest wants one url string and one
 * body. getUri with an empty baseURL applies the instance's own param serializer, so arrays and
 * null params serialize exactly as they would on an unencrypted request.
 */ const $1c891e7043e88eb6$var$toRequestUrl = (instance, config)=>{
    try {
        return instance.getUri({
            ...config,
            baseURL: ""
        });
    } catch  {
        return config.url;
    }
};
/**
 * 409 is the gateway rejecting a ticket it can no longer unseal -- an expired or rotated session.
 * Anything else, or a request that has already been replayed once, is handed straight back so a
 * persistent 409 cannot loop.
 */ const $1c891e7043e88eb6$var$shouldReplayAfterReinit = (payloadCrypto, error)=>{
    if (!payloadCrypto) return false;
    if (error?.response?.status !== 409) return false;
    return Boolean(error.config) && !error.config.lsqCryptoRetried;
};
/**
 * Unseal a sealed error body in place.
 *
 * The success interceptor unseals; the error path did not, and it is the only other place a
 * sealed body reaches a call site. Call sites read error.response.data.message, which on a
 * sealed body is a property of a JWE string rather than an object, so it comes back undefined
 * and the UI falls back to a generic message, losing what the server actually said.
 *
 * decryptResponse returns its input unchanged when the body is not sealed, so this is inert on
 * plaintext errors. A failure here must never replace the original error: the caller needs the
 * status it actually got, not a decryption fault.
 */ const $1c891e7043e88eb6$var$unsealErrorBody = async (payloadCrypto, error)=>{
    const response = error?.response;
    if (!payloadCrypto || !response || response.data === undefined || response.data === null) return;
    try {
        const decrypted = await payloadCrypto.decryptResponse(response.data);
        if (decrypted !== response.data) response.data = $1c891e7043e88eb6$var$parseIfJson(decrypted);
    } catch  {
    /* leave the body exactly as it arrived */ }
};
function $1c891e7043e88eb6$export$1801e4d5dec3e576(instance) {
    // Off the custom domain there is no gateway at `${window.location.origin}/api/gw` to hand a
    // sealed request to, and the API calls are cross-origin anyway. Register nothing at all there
    // rather than pay an interceptor hop per request for a branch that never fires.
    if (!(0, $8a8f1a678e6f48e2$export$97f4c254b641e719)()) return instance;
    instance.interceptors.request.use(async (config)=>{
        const payloadCrypto = $1c891e7043e88eb6$var$lib();
        if (!payloadCrypto) return config;
        const gatewayBaseUrl = (0, $8a8f1a678e6f48e2$export$8391516e4e7c9635)();
        // Stashed before anything is sealed so a 409 retry re-seals from the original rather than
        // sealing the ciphertext a second time.
        if (!config.lsqCryptoOriginal) config.lsqCryptoOriginal = {
            url: config.url,
            params: config.params,
            data: config.data
        };
        // prepareRequest resolves to { url, body, encrypted, headers } -- an object, not a tuple.
        const prepared = await payloadCrypto.prepareRequest($1c891e7043e88eb6$var$toRequestUrl(instance, config), {
            body: config.data,
            gatewayBaseUrl: gatewayBaseUrl
        });
        config.url = prepared.url;
        // The params are now inside `url`; leaving them set would append them a second time.
        config.params = undefined;
        if (prepared.body !== null && prepared.body !== undefined) config.data = prepared.body;
        // Its headers carry the ticket and, once a body has been sealed, Content-Type:
        // application/jose. The instance default of application/json would make the gateway
        // read a JWE as JSON, so these have to win over the instance headers.
        config.headers = {
            ...config.headers,
            ...prepared.headers
        };
        return config;
    });
    instance.interceptors.response.use(async (response)=>{
        const payloadCrypto = $1c891e7043e88eb6$var$lib();
        if (!payloadCrypto) return response;
        const decrypted = await payloadCrypto.decryptResponse(response.data);
        if (decrypted !== response.data) response.data = $1c891e7043e88eb6$var$parseIfJson(decrypted);
        // The gateway asks for a fresh session out of band; renewing now keeps the cost off the
        // next request's critical path.
        if (response.headers?.[$1c891e7043e88eb6$var$REINIT_HEADER]) await payloadCrypto.reinit({
            gatewayBaseUrl: (0, $8a8f1a678e6f48e2$export$8391516e4e7c9635)()
        });
        return response;
    }, async (error)=>{
        const payloadCrypto = $1c891e7043e88eb6$var$lib();
        // Before any early return, and for every status: a sealed body is lost either way.
        await $1c891e7043e88eb6$var$unsealErrorBody(payloadCrypto, error);
        if (!$1c891e7043e88eb6$var$shouldReplayAfterReinit(payloadCrypto, error)) return Promise.reject(error);
        try {
            await payloadCrypto.reinit({
                gatewayBaseUrl: (0, $8a8f1a678e6f48e2$export$8391516e4e7c9635)()
            });
        } catch  {
            return Promise.reject(error);
        }
        const { config: config } = error;
        return instance.request({
            ...config,
            ...config.lsqCryptoOriginal || {},
            lsqCryptoOriginal: undefined,
            lsqCryptoRetried: true
        });
    });
    return instance;
}


// Function to get the authorization token
const $d439188c8c506a1b$var$axiosInstanceWeb = (0, $0a757f15441211e8$export$2e2bcd8739ae039).create({
    baseURL: (0, $8a8f1a678e6f48e2$export$a0867b79bace5897),
    headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
        "User-Agent": false
    },
    // Kept true for the MiP path, which authenticates by cookie. The branch below switches the
    // non-MiP path to fetch + 'omit'; unlike casa-lead-360 there is no else here, so MiP relies on
    // this default.
    withCredentials: true
});
// Payload encryption (FSP-5412). Registered before the response interceptor below on purpose:
// axios runs response interceptors in registration order, so this one opens a sealed body before
// the handler below reads it, and retries a 409 from an expired session before anything can
// surface it to the user. It is a no-op outside the NextGen custom-domain deployment.
(0, $1c891e7043e88eb6$export$1801e4d5dec3e576)($d439188c8c506a1b$var$axiosInstanceWeb);
if (!(0, $b61f740b64a51955$export$bdcb7d5b3e07911b)() && (0, $8a9518f7458123dc$export$550ea6e0aa9f31e3)() && (0, $8a9518f7458123dc$export$b64ebfa99e8dc2a0)()) {
    // Use the fetch adapter so same-origin requests don't carry cookies. XHR always sends them
    // same-origin regardless of withCredentials; fetch honours credentials: 'omit'. Requires
    // axios >= 1.7. Mirrors casa-lead-360 11ef902.
    $d439188c8c506a1b$var$axiosInstanceWeb.defaults.adapter = "fetch";
    $d439188c8c506a1b$var$axiosInstanceWeb.defaults.withCredentials = "omit";
    $d439188c8c506a1b$var$axiosInstanceWeb.defaults.headers.common["x-lsq-marvin-token"] = (0, $8a9518f7458123dc$export$550ea6e0aa9f31e3)();
    $d439188c8c506a1b$var$axiosInstanceWeb.defaults.headers.common["x-lsq-regionId"] = (0, $8a9518f7458123dc$export$b64ebfa99e8dc2a0)();
}
// Add a request interceptor to capture the start time  
$d439188c8c506a1b$var$axiosInstanceWeb.interceptors.request.use((config)=>{
    config.startTime = performance.now(); // Record the start time  
    return config;
});
$d439188c8c506a1b$var$axiosInstanceWeb.interceptors.response.use((response)=>{
    const endTime = performance.now(); // Record the end time  
    const duration = endTime - response.config.startTime;
    response.responseTime = duration;
    if (response.headers?.authorization) {
        const encryptedToken = (0, $42d8f97bad551175$export$a143d493d941bafc).from(response.headers.authorization, "utf-8").toString("base64");
        sessionStorage.setItem("casa-authorization-token", encryptedToken);
        $d439188c8c506a1b$var$axiosInstanceWeb.defaults.headers.common["authorization"] = (0, $42d8f97bad551175$export$a143d493d941bafc).from(encryptedToken, "base64").toString("utf-8");
    }
    (0, $3e1393dc3782b6fe$export$a95a94f41a22cc93)(response);
    return response;
}, (error)=>{
    if (error?.response?.status === 401) (0, $895fdb2cf61ec4c8$export$2fb87bbf5418dbe1)();
    return Promise.reject(error);
});
var $d439188c8c506a1b$export$2e2bcd8739ae039 = $d439188c8c506a1b$var$axiosInstanceWeb;


const $3a9d902ac0f87e31$var$API_URL_TASK_COUNT = "tasks/count";
const $3a9d902ac0f87e31$var$API_URL_TASK = "tasks";
const $3a9d902ac0f87e31$var$API_URL_SMARTVIEW = "/smartviews";
const $3a9d902ac0f87e31$export$79d30295dc4df8b3 = async (postBody)=>{
    try {
        const response = await (0, $d439188c8c506a1b$export$2e2bcd8739ae039).post($3a9d902ac0f87e31$var$API_URL_TASK_COUNT, postBody);
        return response.data;
    } catch (error) {
        console.error("Error fetching task count:", error);
        return null; // Return null if there's an error
    }
};
const $3a9d902ac0f87e31$export$580824bfae42b08e = async (postBody, type)=>{
    try {
        const response = await (0, $d439188c8c506a1b$export$2e2bcd8739ae039).post(`${$3a9d902ac0f87e31$var$API_URL_SMARTVIEW}/${type}`, postBody);
        return {
            count: response?.data?.recordCount
        };
    } catch (error) {
        console.error("Error fetching task count:", error);
        return null; // Return null if there's an error
    }
};
const $3a9d902ac0f87e31$export$604816b052fb037f = async (postBody)=>{
    try {
        const response = await (0, $d439188c8c506a1b$export$2e2bcd8739ae039).post($3a9d902ac0f87e31$var$API_URL_TASK, postBody);
        return response.data;
    } catch (error) {
        console.error("Error fetching task count:", error);
        return null; // Return null if there's an error
    }
};
const $3a9d902ac0f87e31$export$7d6bd1533a29d86c = async (postBody, type)=>{
    try {
        const response = await (0, $d439188c8c506a1b$export$2e2bcd8739ae039).post(`${$3a9d902ac0f87e31$var$API_URL_SMARTVIEW}/${type}`, postBody);
        return response.data;
    } catch (error) {
        console.error("Error fetching task count:", error);
        return null; // Return null if there's an error
    }
};
const $3a9d902ac0f87e31$export$ce73dddd9960dbb3 = async ()=>{
    try {
        const response = await (0, $d439188c8c506a1b$export$2e2bcd8739ae039).get("/launchers/user");
        return response.data;
    } catch (error) {
        console.error("Error fetching launch bar data:", error);
        return {
            payload: {
                config: []
            }
        };
    }
};
const $3a9d902ac0f87e31$export$73b84337c4da92bc = async (key)=>{
    try {
        const response = await (0, $d439188c8c506a1b$export$2e2bcd8739ae039).post(`/widgets/signedUrl`, {
            keys: [
                key
            ]
        });
        return response.data.urls[0]; // Adjust the response to match the actual structure of your API response
    } catch (error) {
        console.error("Error fetching image URL:", error);
        return null; // Return null if there's an error
    }
};








const $e5ce57aa1df93daf$var$timezones = [
    {
        label: 'IST - (GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi',
        value: 'India Standard Time$Asia/Kolkata'
    },
    {
        label: 'SMST - (GMT-11:00) Midway Island, Samoa',
        value: 'Samoa Standard Time$Pacific/Samoa'
    },
    {
        label: 'HAST - (GMT-10:00) Hawaii',
        value: 'Hawaiian Standard Time$US/Hawaii'
    },
    {
        label: 'AK - (GMT-09:00) Alaska',
        value: 'Alaskan Standard Time$US/Alaska'
    },
    {
        label: 'PT - (GMT-08:00) Pacific Time (US and Canada), Tijuana',
        value: 'Pacific Standard Time$US/Pacific'
    },
    {
        label: 'MST - (GMT-07:00) Arizona',
        value: 'US Mountain Standard Time$US/Arizona'
    },
    {
        label: 'MSTM - (GMT-07:00) Chihuahua, La Paz, Mazatlan',
        value: 'Mountain Standard Time (Mexico)$Canada/Mountain'
    },
    {
        label: 'MT - (GMT-07:00) Mountain Time (US and Canada)',
        value: 'Mountain Standard Time$US/Mountain'
    },
    {
        label: 'CST - (GMT-06:00) Guadalajara, Mexico City, Monterrey',
        value: 'Central Standard Time (Mexico)$America/Mexico_City'
    },
    {
        label: 'CT - (GMT-06:00) Central Time (US and Canada)',
        value: 'Central Standard Time$US/Central'
    },
    {
        label: 'CAST - (GMT-06:00) Central America',
        value: 'Central America Standard Time$America/Guatemala'
    },
    {
        label: 'CCST - (GMT-06:00) Saskatchewan',
        value: 'Canada Central Standard Time$Canada/Saskatchewan'
    },
    {
        label: 'EST - (GMT-05:00) Indiana (East)',
        value: 'US Eastern Standard Time$US/East-Indiana'
    },
    {
        label: 'SAPST - (GMT-05:00) Bogota, Lima, Quito',
        value: 'SA Pacific Standard Time$America/Bogota'
    },
    {
        label: 'ET - (GMT-05:00) Eastern Time (US and Canada)',
        value: 'Eastern Standard Time$US/Eastern'
    },
    {
        label: 'CBST - (GMT-04:00) Manaus',
        value: 'Central Brazilian Standard Time$America/Manaus'
    },
    {
        label: 'SAWST - (GMT-04:00) Caracas, La Paz',
        value: 'SA Western Standard Time$America/Caracas'
    },
    {
        label: 'PSAST - (GMT-04:00) Santiago',
        value: 'Pacific SA Standard Time$America/Santiago'
    },
    {
        label: 'AST - (GMT-04:00) Atlantic Time (Canada)',
        value: 'Atlantic Standard Time$Canada/Atlantic'
    },
    {
        label: 'NST - (GMT-03:30) Newfoundland and Labrador',
        value: 'Newfoundland Standard Time$Canada/Newfoundland'
    },
    {
        label: 'SAEST - (GMT-03:00) Buenos Aires, Georgetown',
        value: 'SA Eastern Standard Time$America/Argentina/Buenos_Aires'
    },
    {
        label: 'GNST - (GMT-03:00) Greenland',
        value: 'Greenland Standard Time$America/Godthab'
    },
    {
        label: 'ESAST - (GMT-03:00) Brasilia',
        value: 'E. South America Standard Time$America/Bahia'
    },
    {
        label: 'UTC02 - (GMT-02:00) Mid-Atlantic',
        value: 'Mid-Atlantic Standard Time$Etc/GMT-2'
    },
    {
        label: 'CVT - (GMT-01:00) Cape Verde Islands',
        value: 'Cape Verde Standard Time$Atlantic/Cape_Verde'
    },
    {
        label: 'AZOST - (GMT-01:00) Azores',
        value: 'Azores Standard Time$Atlantic/Azores'
    },
    {
        label: 'GST - (GMT-00:00) Casablanca, Monrovia',
        value: 'Greenwich Standard Time$Africa/Casablanca'
    },
    {
        label: 'GMT - (GMT-00:00) Greenwich Mean Time : Dublin, Edinburgh, Lisbon, London',
        value: 'GMT Standard Time$Europe/London'
    },
    {
        label: 'WET - (GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna',
        value: 'W. Europe Standard Time$Europe/Amsterdam'
    },
    {
        label: 'ECT - (GMT+01:00) West Central Africa',
        value: 'W. Central Africa Standard Time$Africa/Algiers'
    },
    {
        label: 'RST - (GMT+01:00) Brussels, Copenhagen, Madrid, Paris',
        value: 'Romance Standard Time$Europe/Brussels'
    },
    {
        label: 'CEST - (GMT+01:00) Sarajevo, Skopje, Warsaw, Zagreb',
        value: 'Central European Standard Time$Europe/Sarajevo'
    },
    {
        label: 'CET - (GMT+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague',
        value: 'Central Europe Standard Time$Europe/Belgrade'
    },
    {
        label: 'NMST - (GMT+02:00) Windhoek',
        value: 'Namibia Standard Time$Africa/Windhoek'
    },
    {
        label: 'SAST - (GMT+02:00) Harare, Pretoria',
        value: 'South Africa Standard Time$Africa/Harare'
    },
    {
        label: 'ISST - (GMT+02:00) Jerusalem',
        value: 'Israel Standard Time$Asia/Jerusalem'
    },
    {
        label: 'GTBST - (GMT+02:00) Athens, Bucharest, Istanbul',
        value: 'GTB Standard Time$Europe/Athens'
    },
    {
        label: 'EET - (GMT+02:00) Helsinki, Kiev, Riga, Sofia, Tallinn, Vilnius',
        value: 'FLE Standard Time$Europe/Kiev'
    },
    {
        label: 'EGST - (GMT+02:00) Cairo',
        value: 'Egypt Standard Time$Egypt'
    },
    {
        label: 'EEST - (GMT+02:00) Minsk',
        value: 'E. Europe Standard Time$Europe/Minsk'
    },
    {
        label: 'MSK - (GMT+03:00) Moscow, St. Petersburg, Volgograd',
        value: 'Russian Standard Time$Europe/Moscow'
    },
    {
        label: 'EAT - (GMT+03:00) Nairobi',
        value: 'E. Africa Standard Time$Africa/Nairobi'
    },
    {
        label: 'ARST - (GMT+03:00) Baghdad',
        value: 'Arabic Standard Time$Asia/Baghdad'
    },
    {
        label: 'ABST - (GMT+03:00) Kuwait, Riyadh',
        value: 'Arab Standard Time$Asia/Kuwait'
    },
    {
        label: 'IRST - (GMT+03:30) Tehran',
        value: 'Iran Standard Time$Asia/Tehran'
    },
    {
        label: 'GET - (GMT+04:00) Tblisi',
        value: 'Georgian Standard Time$Asia/Tbilisi'
    },
    {
        label: 'AZT - (GMT+04:00) Baku',
        value: 'Azerbaijan Standard Time$Asia/Baku'
    },
    {
        label: 'AMT - (GMT+04:00) Yerevan',
        value: 'Caucasus Standard Time$Asia/Yerevan'
    },
    {
        label: 'ARBST - (GMT+04:00) Abu Dhabi, Muscat',
        value: 'Arabian Standard Time$Asia/Muscat'
    },
    {
        label: 'AFT - (GMT+04:30) Kabul',
        value: 'Afghanistan Standard Time$Asia/Kabul'
    },
    {
        label: 'WAST - (GMT+05:00) Islamabad, Karachi, Tashkent',
        value: 'West Asia Standard Time$Asia/Karachi'
    },
    {
        label: 'YEKT - (GMT+05:00) Ekaterinburg',
        value: 'Ekaterinburg Standard Time$Asia/Yekaterinburg'
    },
    {
        label: 'IST - (GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi',
        value: 'India Standard Time$Asia/Kolkata'
    },
    {
        label: 'NPT - (GMT+05:45) Kathmandu',
        value: 'Nepal Standard Time$Asia/Katmandu'
    },
    {
        label: 'SLT - (GMT+06:00) Sri Jayawardenepura',
        value: 'Sri Lanka Standard Time$Asia/Colombo'
    },
    {
        label: 'NCAST - (GMT+06:00) Almaty, Novosibirsk',
        value: 'N. Central Asia Standard Time$Asia/Almaty'
    },
    {
        label: 'BTT - (GMT+06:00) Astana, Dhaka',
        value: 'Central Asia Standard Time$Asia/Dhaka'
    },
    {
        label: 'MYST - (GMT+06:30) Yangon (Rangoon)',
        value: 'Myanmar Standard Time$Asia/Rangoon'
    },
    {
        label: 'THA - (GMT+07:00) Bangkok, Hanoi, Jakarta',
        value: 'SE Asia Standard Time$Asia/Bangkok'
    },
    {
        label: 'KRAT - (GMT+07:00) Krasnoyarsk',
        value: 'North Asia Standard Time$Asia/Krasnoyarsk'
    },
    {
        label: 'AWST - (GMT+08:00) Perth',
        value: 'W. Australia Standard Time$Australia/Perth'
    },
    {
        label: 'TIST - (GMT+08:00) Taipei',
        value: 'Taipei Standard Time$Asia/Taipei'
    },
    {
        label: 'SNST - (GMT+08:00) Kuala Lumpur, Singapore',
        value: 'Singapore Standard Time$Asia/Singapore'
    },
    {
        label: 'IRKT - (GMT+08:00) Irkutsk, Ulaanbaatar',
        value: 'North Asia East Standard Time$Asia/Irkutsk'
    },
    {
        label: 'CST - (GMT+08:00) Beijing, Chongqing, Hong Kong SAR, Urumqi',
        value: 'China Standard Time$Asia/Chongqing'
    },
    {
        label: 'YAKT - (GMT+09:00) Yakutsk',
        value: 'Yakutsk Standard Time$Asia/Yakutsk'
    },
    {
        label: 'TST - (GMT+09:00) Osaka, Sapporo, Tokyo',
        value: 'Tokyo Standard Time$Asia/Tokyo'
    },
    {
        label: 'KST - (GMT+09:00) Seoul',
        value: 'Korea Standard Time$Asia/Seoul'
    },
    {
        label: 'CAUST - (GMT+09:30) Adelaide',
        value: 'Cen. Australia Standard Time$Australia/Adelaide'
    },
    {
        label: 'ACST - (GMT+09:30) Darwin',
        value: 'AUS Central Standard Time$Australia/Darwin'
    },
    {
        label: 'WPST - (GMT+10:00) Guam, Port Moresby',
        value: 'West Pacific Standard Time$Pacific/Guam'
    },
    {
        label: 'VLAT - (GMT+10:00) Vladivostok',
        value: 'Vladivostok Standard Time$Asia/Vladivostok'
    },
    {
        label: 'TAST - (GMT+10:00) Hobart',
        value: 'Tasmania Standard Time$Australia/Hobart'
    },
    {
        label: 'EAST - (GMT+10:00) Brisbane',
        value: 'E. Australia Standard Time$Australia/Brisbane'
    },
    {
        label: 'AEST - (GMT+10:00) Canberra, Melbourne, Sydney',
        value: 'AUS Eastern Standard Time$Australia/Canberra'
    },
    {
        label: 'SBT - (GMT+11:00) Magadan, Solomon Islands, New Caledonia',
        value: 'Central Pacific Standard Time$Asia/Magadan'
    },
    {
        label: 'NZST - (GMT+12:00) Auckland, Wellington',
        value: 'New Zealand Standard Time$Pacific/Auckland'
    },
    {
        label: 'FJT - (GMT+12:00) Fiji Islands, Kamchatka, Marshall Islands',
        value: 'Fiji Standard Time$Pacific/Fiji'
    },
    {
        label: "PHOT - (GMT+13:00) Nuku'alofa",
        value: 'Tonga Standard Time$Pacific/Tongatapu'
    }
];
const $e5ce57aa1df93daf$export$8750010911c9f8b9 = ()=>{
    const userDetails = (0, $8a9518f7458123dc$export$714d3544202969b)();
    const userTimezone = $e5ce57aa1df93daf$var$timezones.find((timezone)=>timezone.value.split('$')[1] === userDetails?.TimeZone);
    return userTimezone?.value?.split('$')[0] ?? '';
};
const $e5ce57aa1df93daf$export$37b98dd400808613 = {
    0: "leads",
    1: "activities",
    2: "tasks",
    4: "accounts",
    5: "opportunity",
    99: "custom_entity"
};
const $e5ce57aa1df93daf$export$94065feca67a578c = {
    'LEADS': 0,
    'ACTIVITIES': 1,
    'TASKS': 2,
    'ACCOUNTS': 4,
    'OPPORTUNITY': 5,
    'CUSTOM_ENTITY': 99
};
const $e5ce57aa1df93daf$var$ConditionType = {
    'AND': 'and',
    'OR': 'or'
};
const $e5ce57aa1df93daf$export$f5c1eb4d7fbc8f38 = (smartViewTab)=>{
    const typeKey = smartViewTab.Type === $e5ce57aa1df93daf$export$94065feca67a578c.ACCOUNTS ? "accountTypeId" : "ActivityCode";
    return JSON.parse(smartViewTab?.tabContentConfigurationResponseDto?.fetchCriteria?.filters)[typeKey];
};
const $e5ce57aa1df93daf$export$f5e75e7a00a50e13 = (smartViewTab)=>{
    let AdvancedSearchText = smartViewTab?.tabContentConfigurationResponseDto?.fetchCriteria?.additionalData && JSON.parse(smartViewTab.tabContentConfigurationResponseDto.fetchCriteria.additionalData).Marvin?.AdvancedSearchText || smartViewTab.tabContentConfigurationResponseDto.fetchCriteria.advancedSearchText;
    if (!AdvancedSearchText && [
        $e5ce57aa1df93daf$export$94065feca67a578c.ACTIVITIES,
        $e5ce57aa1df93daf$export$94065feca67a578c.OPPORTUNITY
    ].includes(smartViewTab.type)) {
        const queryTimeZone = $e5ce57aa1df93daf$export$8750010911c9f8b9();
        AdvancedSearchText = JSON.stringify({
            GrpConOp: $e5ce57aa1df93daf$var$ConditionType.AND,
            QueryTimeZone: queryTimeZone,
            Conditions: [
                {
                    "Type": "Activity",
                    "ConOp": $e5ce57aa1df93daf$var$ConditionType.AND,
                    RowCondition: [
                        {
                            "SubConOp": "And",
                            "LSO": "ActivityEvent",
                            "LSO_Type": "PAEvent",
                            "Operator": "eq",
                            "RSO": $e5ce57aa1df93daf$export$f5c1eb4d7fbc8f38(smartViewTab)
                        }
                    ]
                }
            ]
        });
    }
    return AdvancedSearchText;
};
const $e5ce57aa1df93daf$export$87cbdc2ba79bea53 = (smartViewTab)=>{
    const advancedSearchText = $e5ce57aa1df93daf$export$f5e75e7a00a50e13(smartViewTab);
    const query = JSON.parse(advancedSearchText);
    const taskTypeCondition = query?.Conditions?.[0]?.RowCondition?.find((condition)=>{
        return condition.LSO === "TaskType" && condition.LSO_Type === "UTType";
    });
    return taskTypeCondition?.RSO;
};
const $e5ce57aa1df93daf$export$a0a573ce9de8d6ae = (code, leadTypeConfiguration)=>{
    if (typeof leadTypeConfiguration === "string") try {
        leadTypeConfiguration = JSON.parse(leadTypeConfiguration);
    } catch (error) {
        console.error("Error parsing leadTypes JSON:", error);
        return null;
    }
    const queryTimeZone = $e5ce57aa1df93daf$export$8750010911c9f8b9();
    const queries = {
        "30": {
            RSO: "0"
        },
        "31": {
            RSO: "1"
        }
    };
    const query = queries[code];
    const combinedQuery = query ? {
        Conditions: [
            ...leadTypeConfiguration?.Conditions || [],
            {
                Type: "Activity",
                ConOp: $e5ce57aa1df93daf$var$ConditionType.AND,
                RowCondition: [
                    {
                        RSO_IsMailMerged: false,
                        RSO: query.RSO,
                        Operator: "eq",
                        LSO_Type: "PAEvent",
                        LSO: "StatusReason",
                        SubConOp: $e5ce57aa1df93daf$var$ConditionType.AND
                    }
                ]
            }
        ],
        GrpConOp: $e5ce57aa1df93daf$var$ConditionType.AND,
        QueryTimeZone: queryTimeZone
    } : leadTypeConfiguration;
    return JSON.stringify(combinedQuery);
};
const $e5ce57aa1df93daf$export$3bea500327f2899b = (leadTypes)=>{
    if (typeof leadTypes === "string") try {
        leadTypes = JSON.parse(leadTypes);
    } catch (error) {
        console.error("Error parsing leadTypes JSON:", error);
        return null;
    }
    if (!Array.isArray(leadTypes)) {
        console.error("Invalid leadTypes format:", leadTypes);
        return null;
    }
    const queryTimeZone = $e5ce57aa1df93daf$export$8750010911c9f8b9();
    return JSON.stringify({
        GrpConOp: $e5ce57aa1df93daf$var$ConditionType.AND,
        QueryTimeZone: queryTimeZone,
        Conditions: [
            {
                Type: "Lead",
                ConOp: $e5ce57aa1df93daf$var$ConditionType.AND,
                RowCondition: [
                    {
                        SubConOp: $e5ce57aa1df93daf$var$ConditionType.AND,
                        LSO: "LeadType",
                        LSO_Type: leadTypes.length > 1 ? "SearchablePickList" : "Dropdown",
                        Operator: "eq",
                        RSO_IsMailMerged: false,
                        IsMarvinRequest: true,
                        RSO: leadTypes.map((leadType)=>leadType.LeadTypeInternalName).join("MXDATASEPERATOR")
                    }
                ]
            }
        ]
    });
};



const $e679a7ba462dea27$export$e2575ed62a2f107b = ()=>{
    return JSON.parse(localStorage.getItem((0, $4b9f68b1938e412c$export$588c7fdda06fbb0a).countCacheName) || "{}");
};
const $e679a7ba462dea27$export$34a87f4e876e484b = ()=>{
    const authDetails = JSON.parse(localStorage.getItem("auth") || "{}");
    const userId = authDetails?.User?.Id;
    const counterCache = $e679a7ba462dea27$export$e2575ed62a2f107b();
    if (counterCache.userId && counterCache.userId === userId) return counterCache;
    return {
        userId: userId
    };
};
const $e679a7ba462dea27$export$430426a47cc1c8dd = (dashboards = [])=>{
    const counterCache = $e679a7ba462dea27$export$34a87f4e876e484b();
    const temp = {
        userId: counterCache.userId
    };
    const currentTime = new Date().toISOString();
    dashboards.forEach((dashboard)=>{
        const dashboardCache = counterCache?.[dashboard.id] || {};
        const updatedWidgets = {};
        dashboard?.layout?.widgets?.forEach((widget)=>{
            if (widget.widgetType === (0, $4b9f68b1938e412c$export$45f3f39dac49db7f).SingleCounter || widget.widgetType === (0, $4b9f68b1938e412c$export$45f3f39dac49db7f).ProgressBar || widget.widgetType === (0, $4b9f68b1938e412c$export$45f3f39dac49db7f).SpeedoMeter || widget.widgetType === (0, $4b9f68b1938e412c$export$45f3f39dac49db7f).Calendar || widget.widgetType === (0, $4b9f68b1938e412c$export$45f3f39dac49db7f).Banner) updatedWidgets[widget.id] = dashboardCache[widget.id] || {};
        });
        temp[dashboard.id] = {
            ...updatedWidgets,
            [(0, $4b9f68b1938e412c$export$588c7fdda06fbb0a).lastForceRefreshedTime]: dashboardCache[(0, $4b9f68b1938e412c$export$588c7fdda06fbb0a).lastForceRefreshedTime] || currentTime
        };
    });
    localStorage.setItem((0, $4b9f68b1938e412c$export$588c7fdda06fbb0a).countCacheName, JSON.stringify(temp));
};
const $e679a7ba462dea27$export$7e6a07abfc29ad16 = 10;
const $e679a7ba462dea27$export$86165a58bbc2b5ab = true;
const $e679a7ba462dea27$var$countCacheName = (0, $4b9f68b1938e412c$export$588c7fdda06fbb0a).countCacheName;
const $e679a7ba462dea27$export$877bd841cf3755de = $e679a7ba462dea27$export$7e6a07abfc29ad16 * 60000;
const $e679a7ba462dea27$export$86b4d9d091ee17fe = (forceRefresh, widgetCache, updatedAt, cacheExpirationTime)=>{
    const currentTime = Date.now();
    if ($e679a7ba462dea27$export$86165a58bbc2b5ab && !forceRefresh && widgetCache?.timestamp && widgetCache.data && currentTime - widgetCache.timestamp < cacheExpirationTime && new Date(updatedAt) < new Date(widgetCache.timestamp)) return widgetCache.data;
    return null;
};
const $e679a7ba462dea27$export$27bf7c127620d921 = async ()=>{
    let authorizationHeader = sessionStorage.getItem('casa_mavis_authorization_header');
    try {
        if (!authorizationHeader) {
            const { data: data } = await (0, $0a757f15441211e8$export$2e2bcd8739ae039).post(`${(0, $8a8f1a678e6f48e2$export$95913207f5793e03)}api/external/Authentication`, {}, {
                headers: {
                    "MarvinToken": (0, $8a9518f7458123dc$export$550ea6e0aa9f31e3)()
                }
            });
            authorizationHeader = data?.AuthKey;
        }
        sessionStorage.setItem('casa_mavis_authorization_header', authorizationHeader);
    } catch (error) {
        console.error("Error fetching mavis auth header:", error);
        return null; // Return null if there's an error
    }
    return authorizationHeader;
};
const $e679a7ba462dea27$export$28a87a2baaec74a0 = (smartViewTab)=>{
    return smartViewTab?.tabContentConfigurationResponseDto?.fetchCriteria?.additionalData && JSON.parse(smartViewTab.tabContentConfigurationResponseDto.fetchCriteria.additionalData).Marvin?.AdvancedSearchText || JSON.parse(smartViewTab.tabContentConfigurationResponseDto.fetchCriteria.advancedSearchText);
};
const $e679a7ba462dea27$export$7b540483ce6b2192 = (smartViewTab)=>{
    const AdvancedSearchText = $e679a7ba462dea27$export$28a87a2baaec74a0(smartViewTab);
    return AdvancedSearchText?.smartviewToken;
};
const $e679a7ba462dea27$export$aec90ee41908b892 = (smartViewTab)=>{
    const advancedSearchText = $e679a7ba462dea27$export$28a87a2baaec74a0(smartViewTab);
    const databaseId = advancedSearchText?.DatabaseId;
    const tableId = advancedSearchText?.TableId;
    const filter = advancedSearchText?.filter;
    const marvinToken = $e679a7ba462dea27$export$7b540483ce6b2192(smartViewTab);
    const requestBody = {
        "Paging": {
            "PageIndex": 1,
            "PageSize": 1
        },
        "Select": [
            "mv_RowId"
        ],
        "AdminFilter": {
            [filter?.AndCriteria || '$and']: filter?.filterRows?.map((row)=>{
                return {
                    [row?.column]: {
                        [row?.operator]: [
                            row?.value
                        ]
                    }
                };
            })
        }
    };
    return {
        databaseId: databaseId,
        tableId: tableId,
        requestBody: requestBody,
        marvinToken: marvinToken
    };
};
const $e679a7ba462dea27$export$7361fee419908840 = async (requestData)=>{
    try {
        const mavisAuthHeader = await $e679a7ba462dea27$export$27bf7c127620d921();
        const { databaseId: databaseId, tableId: tableId, requestBody: requestBody, marvinToken: marvinToken } = requestData;
        const response = await (0, $0a757f15441211e8$export$2e2bcd8739ae039).post(`${(0, $8a8f1a678e6f48e2$export$95913207f5793e03)}api/external/${databaseId}/${tableId}/rows/query`, requestBody, {
            headers: {
                "authorization": mavisAuthHeader,
                "externalauthkey": marvinToken
            }
        });
        return {
            count: response.data?.count
        };
    } catch (error) {
        console.error("Error fetching smart view mavis count:", error);
        return null; // Return null if there's an error
    }
};
const $e679a7ba462dea27$export$8134c072fddab6a5 = async (body, mappedText)=>{
    if (mappedText === (0, $e5ce57aa1df93daf$export$37b98dd400808613)[99]) return await $e679a7ba462dea27$export$7361fee419908840(body);
    if (mappedText) return (0, $3a9d902ac0f87e31$export$580824bfae42b08e)(body, mappedText);
    return (0, $3a9d902ac0f87e31$export$79d30295dc4df8b3)(body);
};
const $e679a7ba462dea27$export$8f130c338353ac35 = (activeDashboardId, id, newCacheData)=>{
    const currentTime = Date.now();
    const counterCache = JSON.parse(localStorage.getItem($e679a7ba462dea27$var$countCacheName) || "{}");
    counterCache[activeDashboardId] = {
        ...counterCache[activeDashboardId],
        [id]: {
            data: newCacheData,
            timestamp: currentTime
        }
    };
    localStorage.setItem($e679a7ba462dea27$var$countCacheName, JSON.stringify(counterCache));
};
const $e679a7ba462dea27$export$fe37d777356ded95 = async (forceRefresh, widget, activeDashboardId, postBody, getTotalCount, mappedText)=>{
    const { id: id, updatedAt: updatedAt } = widget;
    const counterCache = JSON.parse(localStorage.getItem($e679a7ba462dea27$var$countCacheName) || "{}");
    const widgetCache = counterCache?.[activeDashboardId]?.[id];
    const cachedData = $e679a7ba462dea27$export$86b4d9d091ee17fe(forceRefresh, widgetCache, updatedAt, $e679a7ba462dea27$export$877bd841cf3755de);
    if (cachedData) return cachedData;
    try {
        const apis = [
            $e679a7ba462dea27$export$8134c072fddab6a5(postBody, mappedText)
        ];
        if (getTotalCount) {
            const totalPostBody = {
                ...postBody,
                filters: {
                    ...postBody.filters,
                    statusCode: "-1",
                    includeOverdue: false
                }
            };
            apis.push($e679a7ba462dea27$export$8134c072fddab6a5(totalPostBody));
        }
        const [fetchedData = {}, maxCountData = {}] = await Promise.all(apis);
        const newCacheData = getTotalCount ? {
            count: fetchedData?.count,
            maxCount: maxCountData?.count
        } : {
            count: fetchedData?.count
        };
        $e679a7ba462dea27$export$8f130c338353ac35(activeDashboardId, id, newCacheData);
        return newCacheData;
    } catch (error) {
        console.error("Error fetching counts data:", error);
        throw error;
    }
};



const $d3ec3d5546f90f60$export$260f1342281499a4 = async (setWidgetData, config)=>{
    if (config?.image) {
        const imageUrlData = await (0, $3a9d902ac0f87e31$export$73b84337c4da92bc)(config.image.imageKey);
        if (imageUrlData) setWidgetData((prevData)=>({
                ...prevData,
                imageURL: imageUrlData
            }));
    }
};
const $d3ec3d5546f90f60$export$9675cbdc3cbec5ca = async (config, forceRefresh, setWidgetData, activeDashboardId, widget)=>{
    let postBody = (0, $b61f740b64a51955$export$b9e1badb9711e940)({
        config: config
    });
    if (config.dateFilters && config.dateFilters.id) {
        const dateRange = (0, $b61f740b64a51955$export$2e3dcc09723f1d05)(config.dateFilters.id);
        postBody.filters = {
            ...postBody.filters,
            ...dateRange
        };
    }
    const getTotalCount = !config.setThresholds && !config?.max && config.taskStatus.id === "completed";
    const taskCountData = await (0, $e679a7ba462dea27$export$fe37d777356ded95)(forceRefresh, widget, activeDashboardId, postBody, getTotalCount);
    // If maxCount is not provided, fetch it
    if (getTotalCount) setWidgetData((prevData)=>({
            ...prevData,
            ...taskCountData
        }));
    else if (!config.setThresholds && !config?.max && config.taskStatus.id !== "completed") setWidgetData((prevData)=>({
            ...prevData,
            count: taskCountData?.count,
            maxCount: false
        }));
    else setWidgetData((prevData)=>({
            ...prevData,
            count: taskCountData?.count,
            maxCount: config?.max
        }));
};
const $d3ec3d5546f90f60$var$useWidgetData = (widget, smartviewsConfig, activeDashboardId, forceRefresh)=>{
    const { id: id, widgetType: type, config: config } = widget;
    const [widgetData, setWidgetData] = (0, $cQQee.useState)(config);
    const [initialLoad, setInitialLoading] = (0, $cQQee.useState)(true);
    const [loading, setLoading] = (0, $cQQee.useState)(true);
    const loadData = async (forceRefresh = false)=>{
        setLoading(true);
        try {
            if (config && config.entity && config.entity.id === "tasks") await $d3ec3d5546f90f60$export$9675cbdc3cbec5ca(config, forceRefresh, setWidgetData, activeDashboardId, widget);
            if (config && config.entity && config.entity.id === "smartviews") {
                if (smartviewsConfig && smartviewsConfig.tabs) {
                    const matchedTab = smartviewsConfig.tabs.find((tab)=>tab.id === config.smartViewTab.id);
                    let mappedText = (0, $e5ce57aa1df93daf$export$37b98dd400808613)[matchedTab.type];
                    let leadTypeConfiguration = matchedTab?.tabContentConfigurationResponseDto?.fetchCriteria?.leadTypeConfiguration ? (0, $e5ce57aa1df93daf$export$3bea500327f2899b)(matchedTab.tabContentConfigurationResponseDto.fetchCriteria.leadTypeConfiguration) : null;
                    // Construct the post body for the API call
                    let postBody = {
                        advancedSearch: (0, $e5ce57aa1df93daf$export$f5e75e7a00a50e13)(matchedTab),
                        customFilters: leadTypeConfiguration,
                        pageIndex: 1,
                        pageSize: 1
                    };
                    switch(mappedText){
                        case "tasks":
                            postBody.pageIndex = 0;
                            postBody.pageSize = 0;
                            postBody.type = (0, $e5ce57aa1df93daf$export$87cbdc2ba79bea53)(matchedTab);
                            break;
                        case "activities":
                            postBody.code = (0, $e5ce57aa1df93daf$export$f5c1eb4d7fbc8f38)(matchedTab);
                            postBody.customFilters = postBody.code ? (0, $e5ce57aa1df93daf$export$a0a573ce9de8d6ae)(postBody.code, leadTypeConfiguration) : null;
                            postBody.isOpportunity = false;
                            break;
                        case "opportunity":
                            postBody.code = (0, $e5ce57aa1df93daf$export$f5c1eb4d7fbc8f38)(matchedTab);
                            postBody.isOpportunity = true;
                            mappedText = "activities";
                            break;
                        case "accounts":
                            postBody.type = (0, $e5ce57aa1df93daf$export$f5c1eb4d7fbc8f38)(matchedTab);
                            break;
                        case "custom_entity":
                            postBody = (0, $e679a7ba462dea27$export$aec90ee41908b892)(matchedTab);
                            break;
                        default:
                            break;
                    }
                    // Fetch smart views count with the mapped text as an argument
                    const taskCountData = await (0, $e679a7ba462dea27$export$fe37d777356ded95)(forceRefresh, widget, activeDashboardId, postBody, false, mappedText);
                    setWidgetData((prevData)=>({
                            ...prevData,
                            ...taskCountData,
                            maxCount: config?.max
                        }));
                }
            }
            // Fetch image URL if applicable
            await $d3ec3d5546f90f60$export$260f1342281499a4(setWidgetData, config);
        } catch (error) {
            console.error(`Error loading data for widget ${id}:`, error);
        } finally{
            setLoading(false);
        }
    };
    (0, $cQQee.useEffect)(()=>{
        loadData();
    }, [
        id,
        type,
        config,
        smartviewsConfig
    ]);
    (0, $cQQee.useEffect)(()=>{
        if (initialLoad) setInitialLoading(false);
        else loadData(true);
    }, [
        forceRefresh
    ]);
    return {
        widgetData: widgetData,
        loading: loading
    };
};
var $d3ec3d5546f90f60$export$2e2bcd8739ae039 = $d3ec3d5546f90f60$var$useWidgetData;



var $7Tw3V = parcelRequire("7Tw3V");
parcelRequire("cQQee");




var $cQQee = parcelRequire("cQQee");



const $83e7ad590f94dc0f$export$fe58198efe02b173 = async (activeDashboardId, widget, setBannerData, forceFetch)=>{
    const { id: id, config: config } = widget;
    const counterCache = (0, $e679a7ba462dea27$export$e2575ed62a2f107b)();
    const activeWidgetCache = counterCache?.[activeDashboardId]?.[id];
    if (!forceFetch && activeWidgetCache?.image === config.image.imageKey) setBannerData((prevData)=>({
            ...prevData,
            imageURL: activeWidgetCache.imageURL
        }));
    else {
        const imageUrlData = await (0, $3a9d902ac0f87e31$export$73b84337c4da92bc)(config.image.imageKey);
        if (imageUrlData) {
            setBannerData((prevData)=>({
                    ...prevData,
                    imageURL: imageUrlData
                }));
            const tempCounterCache = (0, $e679a7ba462dea27$export$e2575ed62a2f107b)();
            const updatedCache = {
                ...tempCounterCache,
                [activeDashboardId]: {
                    ...tempCounterCache[activeDashboardId],
                    [id]: {
                        image: config.image.imageKey,
                        imageURL: imageUrlData
                    }
                }
            };
            localStorage.setItem((0, $4b9f68b1938e412c$export$588c7fdda06fbb0a).countCacheName, JSON.stringify(updatedCache));
        }
    }
};
const $83e7ad590f94dc0f$var$useBannerData = (widget, activeDashboardId)=>{
    const { id: id, config: config } = widget;
    const [bannerData, setBannerData] = (0, $cQQee.useState)(config);
    const [loading, setLoading] = (0, $cQQee.useState)(true);
    const [reloaded, setReloaded] = (0, $cQQee.useState)(false);
    const loadData = async (forceFetch)=>{
        setLoading(true);
        try {
            if (config?.image) await $83e7ad590f94dc0f$export$fe58198efe02b173(activeDashboardId, widget, setBannerData, forceFetch);
        } catch (error) {
            console.error(`Error loading data for widget ${id}:`, error);
        } finally{
            setLoading(false);
        }
    };
    const reloadImage = ()=>{
        if (!reloaded) loadData(true);
        setReloaded(true);
    };
    (0, $cQQee.useEffect)(()=>{
        loadData();
    }, []);
    return {
        bannerData: bannerData,
        loading: loading,
        reloadImage: reloadImage
    };
};
var $83e7ad590f94dc0f$export$2e2bcd8739ae039 = $83e7ad590f94dc0f$var$useBannerData;


// Import the functions you need from the SDKs you need
const $1b03d6122c0e60f7$export$6d3c090e66a883b1 = ()=>undefined;


/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */ const $156de25e040d63b6$export$588c7fdda06fbb0a = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */ NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */ NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */ SDK_VERSION: '${JSCORE_VERSION}'
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Throws an error if the provided assertion is falsy
 */ const $156de25e040d63b6$export$a7a9523472993e97 = function(assertion, message) {
    if (!assertion) throw $156de25e040d63b6$export$a39cad550e7ab28a(message);
};
/**
 * Returns an Error object suitable for throwing.
 */ const $156de25e040d63b6$export$a39cad550e7ab28a = function(message) {
    return new Error('Firebase Database (' + $156de25e040d63b6$export$588c7fdda06fbb0a.SDK_VERSION + ') INTERNAL ASSERT FAILED: ' + message);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $156de25e040d63b6$var$stringToByteArray$1 = function(str) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if ((c & 0xfc00) === 0xd800 && i + 1 < str.length && (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param bytes Array of numbers representing characters.
 * @return Stringification of the array.
 */ const $156de25e040d63b6$var$byteArrayToString = function(bytes) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let pos = 0, c = 0;
    while(pos < bytes.length){
        const c1 = bytes[pos++];
        if (c1 < 128) out[c++] = String.fromCharCode(c1);
        else if (c1 > 191 && c1 < 224) {
            const c2 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 31) << 6 | c2 & 63);
        } else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            const c4 = bytes[pos++];
            const u = ((c1 & 7) << 18 | (c2 & 63) << 12 | (c3 & 63) << 6 | c4 & 63) - 0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        } else {
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
        }
    }
    return out.join('');
};
// We define it as an object literal instead of a class because a class compiled down to es5 can't
// be treeshaked. https://github.com/rollup/rollup/issues/1691
// Static lookup maps, lazily populated by init_()
// TODO(dlarocque): Define this as a class, since we no longer target ES5.
const $156de25e040d63b6$export$b3b2de96497acc47 = {
    /**
     * Maps bytes to characters.
     */ byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     */ charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @private
     */ byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @private
     */ charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     */ ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     */ get ENCODED_VALS () {
        return this.ENCODED_VALS_BASE + '+/=';
    },
    /**
     * Our websafe alphabet.
     */ get ENCODED_VALS_WEBSAFE () {
        return this.ENCODED_VALS_BASE + '-_.';
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     */ HAS_NATIVE_SUPPORT: typeof atob === 'function',
    /**
     * Base64-encode an array of bytes.
     *
     * @param input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeByteArray (input, webSafe) {
        if (!Array.isArray(input)) throw Error('encodeByteArray takes an array as a parameter');
        this.init_();
        const byteToCharMap = webSafe ? this.byteToCharMapWebSafe_ : this.byteToCharMap_;
        const output = [];
        for(let i = 0; i < input.length; i += 3){
            const byte1 = input[i];
            const haveByte2 = i + 1 < input.length;
            const byte2 = haveByte2 ? input[i + 1] : 0;
            const haveByte3 = i + 2 < input.length;
            const byte3 = haveByte3 ? input[i + 2] : 0;
            const outByte1 = byte1 >> 2;
            const outByte2 = (byte1 & 0x03) << 4 | byte2 >> 4;
            let outByte3 = (byte2 & 0x0f) << 2 | byte3 >> 6;
            let outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) outByte3 = 64;
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join('');
    },
    /**
     * Base64-encode a string.
     *
     * @param input A string to encode.
     * @param webSafe If true, we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return btoa(input);
        return this.encodeByteArray($156de25e040d63b6$var$stringToByteArray$1(input), webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param input to decode.
     * @param webSafe True if we should use the
     *     alternative alphabet.
     * @return string representing the decoded value.
     */ decodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return atob(input);
        return $156de25e040d63b6$var$byteArrayToString(this.decodeStringToByteArray(input, webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param input Input to decode.
     * @param webSafe True if we should use the web-safe alphabet.
     * @return bytes representing the decoded value.
     */ decodeStringToByteArray (input, webSafe) {
        this.init_();
        const charToByteMap = webSafe ? this.charToByteMapWebSafe_ : this.charToByteMap_;
        const output = [];
        for(let i = 0; i < input.length;){
            const byte1 = charToByteMap[input.charAt(i++)];
            const haveByte2 = i < input.length;
            const byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            const haveByte3 = i < input.length;
            const byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            const haveByte4 = i < input.length;
            const byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) throw new $156de25e040d63b6$export$55ca9d4bee46aeb3();
            const outByte1 = byte1 << 2 | byte2 >> 4;
            output.push(outByte1);
            if (byte3 !== 64) {
                const outByte2 = byte2 << 4 & 0xf0 | byte3 >> 2;
                output.push(outByte2);
                if (byte4 !== 64) {
                    const outByte3 = byte3 << 6 & 0xc0 | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */ init_ () {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for(let i = 0; i < this.ENCODED_VALS.length; i++){
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * An error encountered while decoding base64 string.
 */ class $156de25e040d63b6$export$55ca9d4bee46aeb3 extends Error {
    constructor(){
        super(...arguments);
        this.name = 'DecodeBase64StringError';
    }
}
/**
 * URL-safe base64 encoding
 */ const $156de25e040d63b6$export$e510a73ee562749 = function(str) {
    const utf8Bytes = $156de25e040d63b6$var$stringToByteArray$1(str);
    return $156de25e040d63b6$export$b3b2de96497acc47.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 encoding (without "." padding in the end).
 * e.g. Used in JSON Web Token (JWT) parts.
 */ const $156de25e040d63b6$export$4b5284a3025a455 = function(str) {
    // Use base64url encoding and remove padding in the end (dot characters).
    return $156de25e040d63b6$export$e510a73ee562749(str).replace(/\./g, '');
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param str To be decoded
 * @return Decoded result, if possible
 */ const $156de25e040d63b6$export$c62426fdd000a97e = function(str) {
    try {
        return $156de25e040d63b6$export$b3b2de96497acc47.decodeString(str, true);
    } catch (e) {
        console.error('base64Decode failed: ', e);
    }
    return null;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */ function $156de25e040d63b6$export$6c40052bed430212(value) {
    return $156de25e040d63b6$export$54e9fb29908872fa(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 *
 * Note: we don't merge __proto__ to prevent prototype pollution
 */ function $156de25e040d63b6$export$54e9fb29908872fa(target, source) {
    if (!(source instanceof Object)) return source;
    switch(source.constructor){
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            const dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) target = {};
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for(const prop in source){
        // use isValidKey to guard against prototype pollution. See https://snyk.io/vuln/SNYK-JS-LODASH-450202
        if (!source.hasOwnProperty(prop) || !$156de25e040d63b6$var$isValidKey(prop)) continue;
        target[prop] = $156de25e040d63b6$export$54e9fb29908872fa(target[prop], source[prop]);
    }
    return target;
}
function $156de25e040d63b6$var$isValidKey(key) {
    return key !== '__proto__';
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Polyfill for `globalThis` object.
 * @returns the `globalThis` object for the given environment.
 * @public
 */ function $156de25e040d63b6$export$a4e55266d2135a7f() {
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    throw new Error('Unable to locate global object.');
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $156de25e040d63b6$var$getDefaultsFromGlobal = ()=>$156de25e040d63b6$export$a4e55266d2135a7f().__FIREBASE_DEFAULTS__;
/**
 * Attempt to read defaults from a JSON string provided to
 * process(.)env(.)__FIREBASE_DEFAULTS__ or a JSON file whose path is in
 * process(.)env(.)__FIREBASE_DEFAULTS_PATH__
 * The dots are in parens because certain compilers (Vite?) cannot
 * handle seeing that variable in comments.
 * See https://github.com/firebase/firebase-js-sdk/issues/6838
 */ const $156de25e040d63b6$var$getDefaultsFromEnvVariable = ()=>{
    return;
};
const $156de25e040d63b6$var$getDefaultsFromCookie = ()=>{
    if (typeof document === 'undefined') return;
    let match;
    try {
        match = document.cookie.match(/__FIREBASE_DEFAULTS__=([^;]+)/);
    } catch (e) {
        // Some environments such as Angular Universal SSR have a
        // `document` object but error on accessing `document.cookie`.
        return;
    }
    const decoded = match && $156de25e040d63b6$export$c62426fdd000a97e(match[1]);
    return decoded && JSON.parse(decoded);
};
/**
 * Get the __FIREBASE_DEFAULTS__ object. It checks in order:
 * (1) if such an object exists as a property of `globalThis`
 * (2) if such an object was provided on a shell environment variable
 * (3) if such an object exists in a cookie
 * @public
 */ const $156de25e040d63b6$export$212bb2fc580a90a8 = ()=>{
    try {
        return (0, $1b03d6122c0e60f7$export$6d3c090e66a883b1)() || $156de25e040d63b6$var$getDefaultsFromGlobal() || $156de25e040d63b6$var$getDefaultsFromEnvVariable() || $156de25e040d63b6$var$getDefaultsFromCookie();
    } catch (e) {
        /**
         * Catch-all for being unable to get __FIREBASE_DEFAULTS__ due
         * to any environment case we have not accounted for. Log to
         * info instead of swallowing so we can find these unknown cases
         * and add paths for them if needed.
         */ console.info(`Unable to get __FIREBASE_DEFAULTS__ due to: ${e}`);
        return;
    }
};
/**
 * Returns emulator host stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a URL host formatted like `127.0.0.1:9999` or `[::1]:4000` if available
 * @public
 */ const $156de25e040d63b6$export$9c11895284c8adad = (productName)=>{
    var _a, _b;
    return (_b = (_a = $156de25e040d63b6$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.emulatorHosts) === null || _b === void 0 ? void 0 : _b[productName];
};
/**
 * Returns emulator hostname and port stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a pair of hostname and port like `["::1", 4000]` if available
 * @public
 */ const $156de25e040d63b6$export$a3febcf1f14a3a0c = (productName)=>{
    const host = $156de25e040d63b6$export$9c11895284c8adad(productName);
    if (!host) return undefined;
    const separatorIndex = host.lastIndexOf(':'); // Finding the last since IPv6 addr also has colons.
    if (separatorIndex <= 0 || separatorIndex + 1 === host.length) throw new Error(`Invalid host ${host} with no separate hostname and port!`);
    // eslint-disable-next-line no-restricted-globals
    const port = parseInt(host.substring(separatorIndex + 1), 10);
    if (host[0] === '[') // Bracket-quoted `[ipv6addr]:port` => return "ipv6addr" (without brackets).
    return [
        host.substring(1, separatorIndex - 1),
        port
    ];
    else return [
        host.substring(0, separatorIndex),
        port
    ];
};
/**
 * Returns Firebase app config stored in the __FIREBASE_DEFAULTS__ object.
 * @public
 */ const $156de25e040d63b6$export$3dfb6827a9f89756 = ()=>{
    var _a;
    return (_a = $156de25e040d63b6$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.config;
};
/**
 * Returns an experimental setting on the __FIREBASE_DEFAULTS__ object (properties
 * prefixed by "_")
 * @public
 */ const $156de25e040d63b6$export$5539a1a3afe87d6 = (name)=>{
    var _a;
    return (_a = $156de25e040d63b6$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a[`_${name}`];
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $156de25e040d63b6$export$85f6557964517f1a {
    constructor(){
        this.reject = ()=>{};
        this.resolve = ()=>{};
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
    /**
     * Our API internals are not promisified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     */ wrapCallback(callback) {
        return (error, value)=>{
            if (error) this.reject(error);
            else this.resolve(value);
            if (typeof callback === 'function') {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                this.promise.catch(()=>{});
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) callback(error);
                else callback(error, value);
            }
        };
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Checks whether host is a cloud workstation or not.
 * @public
 */ function $156de25e040d63b6$export$5b4d24b45140ad90(url) {
    // `isCloudWorkstation` is called without protocol in certain connect*Emulator functions
    // In HTTP request builders, it's called with the protocol.
    // If called with protocol prefix, it's a valid URL, so we extract the hostname
    // If called without, we assume the string is the hostname.
    try {
        const host = url.startsWith('http://') || url.startsWith('https://') ? new URL(url).hostname : url;
        return host.endsWith('.cloudworkstations.dev');
    } catch (_a) {
        return false;
    }
}
/**
 * Makes a fetch request to the given server.
 * Mostly used for forwarding cookies in Firebase Studio.
 * @public
 */ async function $156de25e040d63b6$export$c0f0d0ce4283a937(endpoint) {
    const result = await fetch(endpoint, {
        credentials: 'include'
    });
    return result.ok;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $156de25e040d63b6$export$367bf224123348f1(token, projectId) {
    if (token.uid) throw new Error('The "uid" field is no longer supported by mockUserToken. Please use "sub" instead for Firebase Auth User ID.');
    // Unsecured JWTs use "none" as the algorithm.
    const header = {
        alg: 'none',
        type: 'JWT'
    };
    const project = projectId || 'demo-project';
    const iat = token.iat || 0;
    const sub = token.sub || token.user_id;
    if (!sub) throw new Error("mockUserToken must contain 'sub' or 'user_id' field!");
    const payload = Object.assign({
        // Set all required fields to decent defaults
        iss: `https://securetoken.google.com/${project}`,
        aud: project,
        iat: iat,
        exp: iat + 3600,
        auth_time: iat,
        sub: sub,
        user_id: sub,
        firebase: {
            sign_in_provider: 'custom',
            identities: {}
        }
    }, token);
    // Unsecured JWTs use the empty string as a signature.
    const signature = '';
    return [
        $156de25e040d63b6$export$4b5284a3025a455(JSON.stringify(header)),
        $156de25e040d63b6$export$4b5284a3025a455(JSON.stringify(payload)),
        signature
    ].join('.');
}
const $156de25e040d63b6$var$emulatorStatus = {};
// Checks whether any products are running on an emulator
function $156de25e040d63b6$var$getEmulatorSummary() {
    const summary = {
        prod: [],
        emulator: []
    };
    for (const key of Object.keys($156de25e040d63b6$var$emulatorStatus))if ($156de25e040d63b6$var$emulatorStatus[key]) summary.emulator.push(key);
    else summary.prod.push(key);
    return summary;
}
function $156de25e040d63b6$var$getOrCreateEl(id) {
    let parentDiv = document.getElementById(id);
    let created = false;
    if (!parentDiv) {
        parentDiv = document.createElement('div');
        parentDiv.setAttribute('id', id);
        created = true;
    }
    return {
        created: created,
        element: parentDiv
    };
}
let $156de25e040d63b6$var$previouslyDismissed = false;
/**
 * Updates Emulator Banner. Primarily used for Firebase Studio
 * @param name
 * @param isRunningEmulator
 * @public
 */ function $156de25e040d63b6$export$fd3d2954543183b1(name, isRunningEmulator) {
    if (typeof window === 'undefined' || typeof document === 'undefined' || !$156de25e040d63b6$export$5b4d24b45140ad90(window.location.host) || $156de25e040d63b6$var$emulatorStatus[name] === isRunningEmulator || $156de25e040d63b6$var$emulatorStatus[name] || // If already set to use emulator, can't go back to prod.
    $156de25e040d63b6$var$previouslyDismissed) return;
    $156de25e040d63b6$var$emulatorStatus[name] = isRunningEmulator;
    function prefixedId(id) {
        return `__firebase__banner__${id}`;
    }
    const bannerId = '__firebase__banner';
    const summary = $156de25e040d63b6$var$getEmulatorSummary();
    const showError = summary.prod.length > 0;
    function tearDown() {
        const element = document.getElementById(bannerId);
        if (element) element.remove();
    }
    function setupBannerStyles(bannerEl) {
        bannerEl.style.display = 'flex';
        bannerEl.style.background = '#7faaf0';
        bannerEl.style.position = 'fixed';
        bannerEl.style.bottom = '5px';
        bannerEl.style.left = '5px';
        bannerEl.style.padding = '.5em';
        bannerEl.style.borderRadius = '5px';
        bannerEl.style.alignItems = 'center';
    }
    function setupIconStyles(prependIcon, iconId) {
        prependIcon.setAttribute('width', '24');
        prependIcon.setAttribute('id', iconId);
        prependIcon.setAttribute('height', '24');
        prependIcon.setAttribute('viewBox', '0 0 24 24');
        prependIcon.setAttribute('fill', 'none');
        prependIcon.style.marginLeft = '-6px';
    }
    function setupCloseBtn() {
        const closeBtn = document.createElement('span');
        closeBtn.style.cursor = 'pointer';
        closeBtn.style.marginLeft = '16px';
        closeBtn.style.fontSize = '24px';
        closeBtn.innerHTML = ' &times;';
        closeBtn.onclick = ()=>{
            $156de25e040d63b6$var$previouslyDismissed = true;
            tearDown();
        };
        return closeBtn;
    }
    function setupLinkStyles(learnMoreLink, learnMoreId) {
        learnMoreLink.setAttribute('id', learnMoreId);
        learnMoreLink.innerText = 'Learn more';
        learnMoreLink.href = 'https://firebase.google.com/docs/studio/preview-apps#preview-backend';
        learnMoreLink.setAttribute('target', '__blank');
        learnMoreLink.style.paddingLeft = '5px';
        learnMoreLink.style.textDecoration = 'underline';
    }
    function setupDom() {
        const banner = $156de25e040d63b6$var$getOrCreateEl(bannerId);
        const firebaseTextId = prefixedId('text');
        const firebaseText = document.getElementById(firebaseTextId) || document.createElement('span');
        const learnMoreId = prefixedId('learnmore');
        const learnMoreLink = document.getElementById(learnMoreId) || document.createElement('a');
        const prependIconId = prefixedId('preprendIcon');
        const prependIcon = document.getElementById(prependIconId) || document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        if (banner.created) {
            // update styles
            const bannerEl = banner.element;
            setupBannerStyles(bannerEl);
            setupLinkStyles(learnMoreLink, learnMoreId);
            const closeBtn = setupCloseBtn();
            setupIconStyles(prependIcon, prependIconId);
            bannerEl.append(prependIcon, firebaseText, learnMoreLink, closeBtn);
            document.body.appendChild(bannerEl);
        }
        if (showError) {
            firebaseText.innerText = `Preview backend disconnected.`;
            prependIcon.innerHTML = `<g clip-path="url(#clip0_6013_33858)">
<path d="M4.8 17.6L12 5.6L19.2 17.6H4.8ZM6.91667 16.4H17.0833L12 7.93333L6.91667 16.4ZM12 15.6C12.1667 15.6 12.3056 15.5444 12.4167 15.4333C12.5389 15.3111 12.6 15.1667 12.6 15C12.6 14.8333 12.5389 14.6944 12.4167 14.5833C12.3056 14.4611 12.1667 14.4 12 14.4C11.8333 14.4 11.6889 14.4611 11.5667 14.5833C11.4556 14.6944 11.4 14.8333 11.4 15C11.4 15.1667 11.4556 15.3111 11.5667 15.4333C11.6889 15.5444 11.8333 15.6 12 15.6ZM11.4 13.6H12.6V10.4H11.4V13.6Z" fill="#212121"/>
</g>
<defs>
<clipPath id="clip0_6013_33858">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>`;
        } else {
            prependIcon.innerHTML = `<g clip-path="url(#clip0_6083_34804)">
<path d="M11.4 15.2H12.6V11.2H11.4V15.2ZM12 10C12.1667 10 12.3056 9.94444 12.4167 9.83333C12.5389 9.71111 12.6 9.56667 12.6 9.4C12.6 9.23333 12.5389 9.09444 12.4167 8.98333C12.3056 8.86111 12.1667 8.8 12 8.8C11.8333 8.8 11.6889 8.86111 11.5667 8.98333C11.4556 9.09444 11.4 9.23333 11.4 9.4C11.4 9.56667 11.4556 9.71111 11.5667 9.83333C11.6889 9.94444 11.8333 10 12 10ZM12 18.4C11.1222 18.4 10.2944 18.2333 9.51667 17.9C8.73889 17.5667 8.05556 17.1111 7.46667 16.5333C6.88889 15.9444 6.43333 15.2611 6.1 14.4833C5.76667 13.7056 5.6 12.8778 5.6 12C5.6 11.1111 5.76667 10.2833 6.1 9.51667C6.43333 8.73889 6.88889 8.06111 7.46667 7.48333C8.05556 6.89444 8.73889 6.43333 9.51667 6.1C10.2944 5.76667 11.1222 5.6 12 5.6C12.8889 5.6 13.7167 5.76667 14.4833 6.1C15.2611 6.43333 15.9389 6.89444 16.5167 7.48333C17.1056 8.06111 17.5667 8.73889 17.9 9.51667C18.2333 10.2833 18.4 11.1111 18.4 12C18.4 12.8778 18.2333 13.7056 17.9 14.4833C17.5667 15.2611 17.1056 15.9444 16.5167 16.5333C15.9389 17.1111 15.2611 17.5667 14.4833 17.9C13.7167 18.2333 12.8889 18.4 12 18.4ZM12 17.2C13.4444 17.2 14.6722 16.6944 15.6833 15.6833C16.6944 14.6722 17.2 13.4444 17.2 12C17.2 10.5556 16.6944 9.32778 15.6833 8.31667C14.6722 7.30555 13.4444 6.8 12 6.8C10.5556 6.8 9.32778 7.30555 8.31667 8.31667C7.30556 9.32778 6.8 10.5556 6.8 12C6.8 13.4444 7.30556 14.6722 8.31667 15.6833C9.32778 16.6944 10.5556 17.2 12 17.2Z" fill="#212121"/>
</g>
<defs>
<clipPath id="clip0_6083_34804">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>`;
            firebaseText.innerText = 'Preview backend running in this workspace.';
        }
        firebaseText.setAttribute('id', firebaseTextId);
    }
    if (document.readyState === 'loading') window.addEventListener('DOMContentLoaded', setupDom);
    else setupDom();
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return user agent string
 */ function $156de25e040d63b6$export$c36915b22ce77c19() {
    if (typeof navigator !== 'undefined' && typeof navigator['userAgent'] === 'string') return navigator['userAgent'];
    else return '';
}
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
 * wait for a callback.
 */ function $156de25e040d63b6$export$872f8323f01d7ae0() {
    return typeof window !== 'undefined' && // @ts-ignore Setting up an broadly applicable index signature for Window
    // just to deal with this case would probably be a bad idea.
    !!(window['cordova'] || window['phonegap'] || window['PhoneGap']) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test($156de25e040d63b6$export$c36915b22ce77c19());
}
/**
 * Detect Node.js.
 *
 * @return true if Node.js environment is detected or specified.
 */ // Node detection logic from: https://github.com/iliakan/detect-node/
function $156de25e040d63b6$export$8ee0fc9ee280b4ee() {
    var _a;
    const forceEnvironment = (_a = $156de25e040d63b6$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.forceEnvironment;
    if (forceEnvironment === 'node') return true;
    else if (forceEnvironment === 'browser') return false;
    try {
        return Object.prototype.toString.call($parcel$global.process) === '[object process]';
    } catch (e) {
        return false;
    }
}
/**
 * Detect Browser Environment.
 * Note: This will return true for certain test frameworks that are incompletely
 * mimicking a browser, and should not lead to assuming all browser APIs are
 * available.
 */ function $156de25e040d63b6$export$4e09c449d6c407f7() {
    return typeof window !== 'undefined' || $156de25e040d63b6$export$97b87b8868ff7a3c();
}
/**
 * Detect Web Worker context.
 */ function $156de25e040d63b6$export$97b87b8868ff7a3c() {
    return typeof WorkerGlobalScope !== 'undefined' && typeof self !== 'undefined' && self instanceof WorkerGlobalScope;
}
/**
 * Detect Cloudflare Worker context.
 */ function $156de25e040d63b6$export$ad9e9b75cb9fb797() {
    return typeof navigator !== 'undefined' && navigator.userAgent === 'Cloudflare-Workers';
}
function $156de25e040d63b6$export$caa8774a9107a58e() {
    const runtime = typeof chrome === 'object' ? chrome.runtime : typeof browser === 'object' ? browser.runtime : undefined;
    return typeof runtime === 'object' && runtime.id !== undefined;
}
/**
 * Detect React Native.
 *
 * @return true if ReactNative environment is detected.
 */ function $156de25e040d63b6$export$f7a1e23e542d38e3() {
    return typeof navigator === 'object' && navigator['product'] === 'ReactNative';
}
/** Detects Electron apps. */ function $156de25e040d63b6$export$f2f6a8999f8ebd30() {
    return $156de25e040d63b6$export$c36915b22ce77c19().indexOf('Electron/') >= 0;
}
/** Detects Internet Explorer. */ function $156de25e040d63b6$export$7e7b1a9668aaed8() {
    const ua = $156de25e040d63b6$export$c36915b22ce77c19();
    return ua.indexOf('MSIE ') >= 0 || ua.indexOf('Trident/') >= 0;
}
/** Detects Universal Windows Platform apps. */ function $156de25e040d63b6$export$202944b2d2824246() {
    return $156de25e040d63b6$export$c36915b22ce77c19().indexOf('MSAppHost/') >= 0;
}
/**
 * Detect whether the current SDK build is the Node version.
 *
 * @return true if it's the Node SDK build.
 */ function $156de25e040d63b6$export$5d1d834fbbf8bab7() {
    return $156de25e040d63b6$export$588c7fdda06fbb0a.NODE_CLIENT === true || $156de25e040d63b6$export$588c7fdda06fbb0a.NODE_ADMIN === true;
}
/** Returns true if we are running in Safari. */ function $156de25e040d63b6$export$95df08bae54cb4df() {
    return !$156de25e040d63b6$export$8ee0fc9ee280b4ee() && !!navigator.userAgent && navigator.userAgent.includes('Safari') && !navigator.userAgent.includes('Chrome');
}
/** Returns true if we are running in Safari or WebKit */ function $156de25e040d63b6$export$ef10bcfb06572016() {
    return !$156de25e040d63b6$export$8ee0fc9ee280b4ee() && !!navigator.userAgent && (navigator.userAgent.includes('Safari') || navigator.userAgent.includes('WebKit')) && !navigator.userAgent.includes('Chrome');
}
/**
 * This method checks if indexedDB is supported by current browser/service worker context
 * @return true if indexedDB is supported by current browser/service worker context
 */ function $156de25e040d63b6$export$3865db50535c2055() {
    try {
        return typeof indexedDB === 'object';
    } catch (e) {
        return false;
    }
}
/**
 * This method validates browser/sw context for indexedDB by opening a dummy indexedDB database and reject
 * if errors occur during the database open operation.
 *
 * @throws exception if current browser/sw context can't run idb.open (ex: Safari iframe, Firefox
 * private browsing)
 */ function $156de25e040d63b6$export$a8a3018f3d187a4d() {
    return new Promise((resolve, reject)=>{
        try {
            let preExist = true;
            const DB_CHECK_NAME = 'validate-browser-context-for-indexeddb-analytics-module';
            const request = self.indexedDB.open(DB_CHECK_NAME);
            request.onsuccess = ()=>{
                request.result.close();
                // delete database only when it doesn't pre-exist
                if (!preExist) self.indexedDB.deleteDatabase(DB_CHECK_NAME);
                resolve(true);
            };
            request.onupgradeneeded = ()=>{
                preExist = false;
            };
            request.onerror = ()=>{
                var _a;
                reject(((_a = request.error) === null || _a === void 0 ? void 0 : _a.message) || '');
            };
        } catch (error) {
            reject(error);
        }
    });
}
/**
 *
 * This method checks whether cookie is enabled within current browser
 * @return true if cookie is enabled within current browser
 */ function $156de25e040d63b6$export$f172b7eb6cf60599() {
    if (typeof navigator === 'undefined' || !navigator.cookieEnabled) return false;
    return true;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Standardized Firebase Error.
 *
 * Usage:
 *
 *   // TypeScript string literals for type-safe codes
 *   type Err =
 *     'unknown' |
 *     'object-not-found'
 *     ;
 *
 *   // Closure enum for type-safe error codes
 *   // at-enum {string}
 *   var Err = {
 *     UNKNOWN: 'unknown',
 *     OBJECT_NOT_FOUND: 'object-not-found',
 *   }
 *
 *   let errors: Map<Err, string> = {
 *     'generic-error': "Unknown error",
 *     'file-not-found': "Could not find file: {$file}",
 *   };
 *
 *   // Type-safe function - must pass a valid error code as param.
 *   let error = new ErrorFactory<Err>('service', 'Service', errors);
 *
 *   ...
 *   throw error.create(Err.GENERIC);
 *   ...
 *   throw error.create(Err.FILE_NOT_FOUND, {'file': fileName});
 *   ...
 *   // Service: Could not file file: foo.txt (service/file-not-found).
 *
 *   catch (e) {
 *     assert(e.message === "Could not find file: foo.txt.");
 *     if ((e as FirebaseError)?.code === 'service/file-not-found') {
 *       console.log("Could not read file: " + e['file']);
 *     }
 *   }
 */ const $156de25e040d63b6$var$ERROR_NAME = 'FirebaseError';
// Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
class $156de25e040d63b6$export$dd24e9cd51226c56 extends Error {
    constructor(/** The error code for this error. */ code, message, /** Custom data for this error. */ customData){
        super(message);
        this.code = code;
        this.customData = customData;
        /** The custom name for all FirebaseErrors. */ this.name = $156de25e040d63b6$var$ERROR_NAME;
        // Fix For ES5
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        // TODO(dlarocque): Replace this with `new.target`: https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        //                   which we can now use since we no longer target ES5.
        Object.setPrototypeOf(this, $156de25e040d63b6$export$dd24e9cd51226c56.prototype);
        // Maintains proper stack trace for where our error was thrown.
        // Only available on V8.
        if (Error.captureStackTrace) Error.captureStackTrace(this, $156de25e040d63b6$export$3fa6e1b18a3b2d40.prototype.create);
    }
}
class $156de25e040d63b6$export$3fa6e1b18a3b2d40 {
    constructor(service, serviceName, errors){
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
    }
    create(code, ...data) {
        const customData = data[0] || {};
        const fullCode = `${this.service}/${code}`;
        const template = this.errors[code];
        const message = template ? $156de25e040d63b6$var$replaceTemplate(template, customData) : 'Error';
        // Service Name: Error message (service/code).
        const fullMessage = `${this.serviceName}: ${message} (${fullCode}).`;
        const error = new $156de25e040d63b6$export$dd24e9cd51226c56(fullCode, fullMessage, customData);
        return error;
    }
}
function $156de25e040d63b6$var$replaceTemplate(template, data) {
    return template.replace($156de25e040d63b6$var$PATTERN, (_, key)=>{
        const value = data[key];
        return value != null ? String(value) : `<${key}?>`;
    });
}
const $156de25e040d63b6$var$PATTERN = /\{\$([^}]+)}/g;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */ function $156de25e040d63b6$export$c5a53ce6a17cf18d(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data JavaScript object to be stringified.
 * @return {string} The JSON contents of the object.
 */ function $156de25e040d63b6$export$fac44ee5b035f737(data) {
    return JSON.stringify(data);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $156de25e040d63b6$export$2f872c0f2117be69 = function(token) {
    let header = {}, claims = {}, data = {}, signature = '';
    try {
        const parts = token.split('.');
        header = $156de25e040d63b6$export$c5a53ce6a17cf18d($156de25e040d63b6$export$c62426fdd000a97e(parts[0]) || '');
        claims = $156de25e040d63b6$export$c5a53ce6a17cf18d($156de25e040d63b6$export$c62426fdd000a97e(parts[1]) || '');
        signature = parts[2];
        data = claims['d'] || {};
        delete claims['d'];
    } catch (e) {}
    return {
        header: header,
        claims: claims,
        data: data,
        signature: signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $156de25e040d63b6$export$5f870fcca7ae6a88 = function(token) {
    const claims = $156de25e040d63b6$export$2f872c0f2117be69(token).claims;
    const now = Math.floor(new Date().getTime() / 1000);
    let validSince = 0, validUntil = 0;
    if (typeof claims === 'object') {
        if (claims.hasOwnProperty('nbf')) validSince = claims['nbf'];
        else if (claims.hasOwnProperty('iat')) validSince = claims['iat'];
        if (claims.hasOwnProperty('exp')) validUntil = claims['exp'];
        else // token will expire after 24h by default
        validUntil = validSince + 86400;
    }
    return !!now && !!validSince && !!validUntil && now >= validSince && now <= validUntil;
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $156de25e040d63b6$export$701c661ec91095f2 = function(token) {
    const claims = $156de25e040d63b6$export$2f872c0f2117be69(token).claims;
    if (typeof claims === 'object' && claims.hasOwnProperty('iat')) return claims['iat'];
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $156de25e040d63b6$export$9565ca3d387f8aa0 = function(token) {
    const decoded = $156de25e040d63b6$export$2f872c0f2117be69(token), claims = decoded.claims;
    return !!claims && typeof claims === 'object' && claims.hasOwnProperty('iat');
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $156de25e040d63b6$export$fc970ed23da99565 = function(token) {
    const claims = $156de25e040d63b6$export$2f872c0f2117be69(token).claims;
    return typeof claims === 'object' && claims['admin'] === true;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $156de25e040d63b6$export$2344b14b097df817(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function $156de25e040d63b6$export$e51ae4db7b428f67(obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) return obj[key];
    else return undefined;
}
function $156de25e040d63b6$export$dd1bc94b04021eeb(obj) {
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
}
function $156de25e040d63b6$export$871de8747c9eaa88(obj, fn, contextObj) {
    const res = {};
    for(const key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res[key] = fn.call(contextObj, obj[key], key, obj);
    return res;
}
/**
 * Deep equal two objects. Support Arrays and Objects.
 */ function $156de25e040d63b6$export$9cb4719e2e525b7a(a, b) {
    if (a === b) return true;
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    for (const k of aKeys){
        if (!bKeys.includes(k)) return false;
        const aProp = a[k];
        const bProp = b[k];
        if ($156de25e040d63b6$var$isObject(aProp) && $156de25e040d63b6$var$isObject(bProp)) {
            if (!$156de25e040d63b6$export$9cb4719e2e525b7a(aProp, bProp)) return false;
        } else if (aProp !== bProp) return false;
    }
    for (const k of bKeys){
        if (!aKeys.includes(k)) return false;
    }
    return true;
}
function $156de25e040d63b6$var$isObject(thing) {
    return thing !== null && typeof thing === 'object';
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Rejects if the given promise doesn't resolve in timeInMS milliseconds.
 * @internal
 */ function $156de25e040d63b6$export$a9cd205a244d9f54(promise, timeInMS = 2000) {
    const deferredPromise = new $156de25e040d63b6$export$85f6557964517f1a();
    setTimeout(()=>deferredPromise.reject('timeout!'), timeInMS);
    promise.then(deferredPromise.resolve, deferredPromise.reject);
    return deferredPromise.promise;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a
 * params object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 */ function $156de25e040d63b6$export$ac4103b836844853(querystringParams) {
    const params = [];
    for (const [key, value] of Object.entries(querystringParams))if (Array.isArray(value)) value.forEach((arrayVal)=>{
        params.push(encodeURIComponent(key) + '=' + encodeURIComponent(arrayVal));
    });
    else params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
    return params.length ? '&' + params.join('&') : '';
}
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object
 * (e.g. {arg: 'val', arg2: 'val2'})
 */ function $156de25e040d63b6$export$c1271ca4c8a70741(querystring) {
    const obj = {};
    const tokens = querystring.replace(/^\?/, '').split('&');
    tokens.forEach((token)=>{
        if (token) {
            const [key, value] = token.split('=');
            obj[decodeURIComponent(key)] = decodeURIComponent(value);
        }
    });
    return obj;
}
/**
 * Extract the query string part of a URL, including the leading question mark (if present).
 */ function $156de25e040d63b6$export$1a8408415472d8ed(url) {
    const queryStart = url.indexOf('?');
    if (!queryStart) return '';
    const fragmentStart = url.indexOf('#', queryStart);
    return url.substring(queryStart, fragmentStart > 0 ? fragmentStart : undefined);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */ /**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @final
 * @struct
 */ class $156de25e040d63b6$export$c85d589bf4e25fef {
    constructor(){
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @private
         */ this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @private
         */ this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @private
         */ this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @private
         */ this.pad_ = [];
        /**
         * @private {number}
         */ this.inbuf_ = 0;
        /**
         * @private {number}
         */ this.total_ = 0;
        this.blockSize = 64;
        this.pad_[0] = 128;
        for(let i = 1; i < this.blockSize; ++i)this.pad_[i] = 0;
        this.reset();
    }
    reset() {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    }
    /**
     * Internal compress helper function.
     * @param buf Block to compress.
     * @param offset Offset of the block in the buffer.
     * @private
     */ compress_(buf, offset) {
        if (!offset) offset = 0;
        const W = this.W_;
        // get 16 big endian words
        if (typeof buf === 'string') for(let i = 0; i < 16; i++){
            // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
            // have a bug that turns the post-increment ++ operator into pre-increment
            // during JIT compilation.  We have code that depends heavily on SHA-1 for
            // correctness and which is affected by this bug, so I've removed all uses
            // of post-increment ++ in which the result value is used.  We can revert
            // this change once the Safari bug
            // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
            // most clients have been updated.
            W[i] = buf.charCodeAt(offset) << 24 | buf.charCodeAt(offset + 1) << 16 | buf.charCodeAt(offset + 2) << 8 | buf.charCodeAt(offset + 3);
            offset += 4;
        }
        else for(let i = 0; i < 16; i++){
            W[i] = buf[offset] << 24 | buf[offset + 1] << 16 | buf[offset + 2] << 8 | buf[offset + 3];
            offset += 4;
        }
        // expand to 80 words
        for(let i = 16; i < 80; i++){
            const t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = (t << 1 | t >>> 31) & 0xffffffff;
        }
        let a = this.chain_[0];
        let b = this.chain_[1];
        let c = this.chain_[2];
        let d = this.chain_[3];
        let e = this.chain_[4];
        let f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for(let i = 0; i < 80; i++){
            if (i < 40) {
                if (i < 20) {
                    f = d ^ b & (c ^ d);
                    k = 0x5a827999;
                } else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            } else if (i < 60) {
                f = b & c | d & (b | c);
                k = 0x8f1bbcdc;
            } else {
                f = b ^ c ^ d;
                k = 0xca62c1d6;
            }
            const t = (a << 5 | a >>> 27) + f + e + k + W[i] & 0xffffffff;
            e = d;
            d = c;
            c = (b << 30 | b >>> 2) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = this.chain_[0] + a & 0xffffffff;
        this.chain_[1] = this.chain_[1] + b & 0xffffffff;
        this.chain_[2] = this.chain_[2] + c & 0xffffffff;
        this.chain_[3] = this.chain_[3] + d & 0xffffffff;
        this.chain_[4] = this.chain_[4] + e & 0xffffffff;
    }
    update(bytes, length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) return;
        if (length === undefined) length = bytes.length;
        const lengthMinusBlock = length - this.blockSize;
        let n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        const buf = this.buf_;
        let inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while(n < length){
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf === 0) while(n <= lengthMinusBlock){
                this.compress_(bytes, n);
                n += this.blockSize;
            }
            if (typeof bytes === 'string') while(n < length){
                buf[inbuf] = bytes.charCodeAt(n);
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
            else while(n < length){
                buf[inbuf] = bytes[n];
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += length;
    }
    /** @override */ digest() {
        const digest = [];
        let totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) this.update(this.pad_, 56 - this.inbuf_);
        else this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        // Add # bits.
        for(let i = this.blockSize - 1; i >= 56; i--){
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        let n = 0;
        for(let i = 0; i < 5; i++)for(let j = 24; j >= 0; j -= 8){
            digest[n] = this.chain_[i] >> j & 255;
            ++n;
        }
        return digest;
    }
}
/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */ function $156de25e040d63b6$export$364097d812234b3f(executor, onNoObservers) {
    const proxy = new $156de25e040d63b6$var$ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */ class $156de25e040d63b6$var$ObserverProxy {
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */ constructor(executor, onNoObservers){
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task.then(()=>{
            executor(this);
        }).catch((e)=>{
            this.error(e);
        });
    }
    next(value) {
        this.forEachObserver((observer)=>{
            observer.next(value);
        });
    }
    error(error) {
        this.forEachObserver((observer)=>{
            observer.error(error);
        });
        this.close(error);
    }
    complete() {
        this.forEachObserver((observer)=>{
            observer.complete();
        });
        this.close();
    }
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber synchronously to their
     *   call to subscribe().
     */ subscribe(nextOrObserver, error, complete) {
        let observer;
        if (nextOrObserver === undefined && error === undefined && complete === undefined) throw new Error('Missing Observer.');
        // Assemble an Observer object when passed as callback functions.
        if ($156de25e040d63b6$var$implementsAnyMethods(nextOrObserver, [
            'next',
            'error',
            'complete'
        ])) observer = nextOrObserver;
        else observer = {
            next: nextOrObserver,
            error: error,
            complete: complete
        };
        if (observer.next === undefined) observer.next = $156de25e040d63b6$var$noop;
        if (observer.error === undefined) observer.error = $156de25e040d63b6$var$noop;
        if (observer.complete === undefined) observer.complete = $156de25e040d63b6$var$noop;
        const unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            try {
                if (this.finalError) observer.error(this.finalError);
                else observer.complete();
            } catch (e) {
            // nothing
            }
            return;
        });
        this.observers.push(observer);
        return unsub;
    }
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    unsubscribeOne(i) {
        if (this.observers === undefined || this.observers[i] === undefined) return;
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) this.onNoObservers(this);
    }
    forEachObserver(fn) {
        if (this.finalized) // Already closed by previous event....just eat the additional values.
        return;
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for(let i = 0; i < this.observers.length; i++)this.sendOne(i, fn);
    }
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    sendOne(i, fn) {
        // Execute the callback asynchronously
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            if (this.observers !== undefined && this.observers[i] !== undefined) try {
                fn(this.observers[i]);
            } catch (e) {
                // Ignore exceptions raised in Observers or missing methods of an
                // Observer.
                // Log error to console. b/31404806
                if (typeof console !== 'undefined' && console.error) console.error(e);
            }
        });
    }
    close(err) {
        if (this.finalized) return;
        this.finalized = true;
        if (err !== undefined) this.finalError = err;
        // Proxy is no longer needed - garbage collect references
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            this.observers = undefined;
            this.onNoObservers = undefined;
        });
    }
}
/** Turn synchronous function into one called asynchronously. */ // eslint-disable-next-line @typescript-eslint/ban-types
function $156de25e040d63b6$export$12af436354f1a4f7(fn, onError) {
    return (...args)=>{
        Promise.resolve(true).then(()=>{
            fn(...args);
        }).catch((error)=>{
            if (onError) onError(error);
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */ function $156de25e040d63b6$var$implementsAnyMethods(obj, methods) {
    if (typeof obj !== 'object' || obj === null) return false;
    for (const method of methods){
        if (method in obj && typeof obj[method] === 'function') return true;
    }
    return false;
}
function $156de25e040d63b6$var$noop() {
// do nothing
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param fnName The function name
 * @param minCount The minimum number of arguments to allow for the function call
 * @param maxCount The maximum number of argument to allow for the function call
 * @param argCount The actual number of arguments provided.
 */ const $156de25e040d63b6$export$20164226a0ed35c3 = function(fnName, minCount, maxCount, argCount) {
    let argError;
    if (argCount < minCount) argError = 'at least ' + minCount;
    else if (argCount > maxCount) argError = maxCount === 0 ? 'none' : 'no more than ' + maxCount;
    if (argError) {
        const error = fnName + ' failed: Was called with ' + argCount + (argCount === 1 ? ' argument.' : ' arguments.') + ' Expects ' + argError + '.';
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param fnName The function name
 * @param argName The name of the argument
 * @return The prefix to add to the error thrown for validation.
 */ function $156de25e040d63b6$export$adea4917e02d93dc(fnName, argName) {
    return `${fnName} failed: ${argName} argument `;
}
/**
 * @param fnName
 * @param argumentNumber
 * @param namespace
 * @param optional
 */ function $156de25e040d63b6$export$8eef22622e725943(fnName, namespace, optional) {
    if (optional && !namespace) return;
    if (typeof namespace !== 'string') //TODO: I should do more validation here. We only allow certain chars in namespaces.
    throw new Error($156de25e040d63b6$export$adea4917e02d93dc(fnName, 'namespace') + 'must be a valid firebase namespace.');
}
function $156de25e040d63b6$export$5bcd2a2eb6640dfa(fnName, argumentName, // eslint-disable-next-line @typescript-eslint/ban-types
callback, optional) {
    if (optional && !callback) return;
    if (typeof callback !== 'function') throw new Error($156de25e040d63b6$export$adea4917e02d93dc(fnName, argumentName) + 'must be a valid function.');
}
function $156de25e040d63b6$export$df77539402cfb523(fnName, argumentName, context, optional) {
    if (optional && !context) return;
    if (typeof context !== 'object' || context === null) throw new Error($156de25e040d63b6$export$adea4917e02d93dc(fnName, argumentName) + 'must be a valid context object.');
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in JavaScript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */ const $156de25e040d63b6$export$655666783217a925 = function(str) {
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            const high = c - 0xd800; // the high 10 bits.
            i++;
            $156de25e040d63b6$export$a7a9523472993e97(i < str.length, 'Surrogate pair missing trail surrogate.');
            const low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if (c < 65536) {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */ const $156de25e040d63b6$export$9536dc0a75b20bf9 = function(str) {
    let p = 0;
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 128) p++;
        else if (c < 2048) p += 2;
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        } else p += 3;
    }
    return p;
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The amount of milliseconds to exponentially increase.
 */ const $156de25e040d63b6$var$DEFAULT_INTERVAL_MILLIS = 1000;
/**
 * The factor to backoff by.
 * Should be a number greater than 1.
 */ const $156de25e040d63b6$var$DEFAULT_BACKOFF_FACTOR = 2;
/**
 * The maximum milliseconds to increase to.
 *
 * <p>Visible for testing
 */ const $156de25e040d63b6$export$bdf1213ffbdb096e = 14400000; // Four hours, like iOS and Android.
/**
 * The percentage of backoff time to randomize by.
 * See
 * http://go/safe-client-behavior#step-1-determine-the-appropriate-retry-interval-to-handle-spike-traffic
 * for context.
 *
 * <p>Visible for testing
 */ const $156de25e040d63b6$export$3518ed2cfe61fa30 = 0.5;
/**
 * Based on the backoff method from
 * https://github.com/google/closure-library/blob/master/closure/goog/math/exponentialbackoff.js.
 * Extracted here so we don't need to pass metadata and a stateful ExponentialBackoff object around.
 */ function $156de25e040d63b6$export$4d810c0ca64ed8e9(backoffCount, intervalMillis = $156de25e040d63b6$var$DEFAULT_INTERVAL_MILLIS, backoffFactor = $156de25e040d63b6$var$DEFAULT_BACKOFF_FACTOR) {
    // Calculates an exponentially increasing value.
    // Deviation: calculates value from count and a constant interval, so we only need to save value
    // and count to restore state.
    const currBaseValue = intervalMillis * Math.pow(backoffFactor, backoffCount);
    // A random "fuzz" to avoid waves of retries.
    // Deviation: randomFactor is required.
    const randomWait = Math.round(// A fraction of the backoff value to add/subtract.
    // Deviation: changes multiplication order to improve readability.
    $156de25e040d63b6$export$3518ed2cfe61fa30 * currBaseValue * // A random float (rounded to int by Math.round above) in the range [-1, 1]. Determines
    // if we add or subtract.
    (Math.random() - 0.5) * 2);
    // Limits backoff to max to avoid effectively permanent backoff.
    return Math.min($156de25e040d63b6$export$bdf1213ffbdb096e, currBaseValue + randomWait);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provide English ordinal letters after a number
 */ function $156de25e040d63b6$export$7bb39f879164e4ac(i) {
    if (!Number.isFinite(i)) return `${i}`;
    return i + $156de25e040d63b6$var$indicator(i);
}
function $156de25e040d63b6$var$indicator(i) {
    i = Math.abs(i);
    const cent = i % 100;
    if (cent >= 10 && cent <= 20) return 'th';
    const dec = i % 10;
    if (dec === 1) return 'st';
    if (dec === 2) return 'nd';
    if (dec === 3) return 'rd';
    return 'th';
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $156de25e040d63b6$export$4befe9b5fa509a1b(service) {
    if (service && service._delegate) return service._delegate;
    else return service;
}


/**
 * Component for service name T, e.g. `auth`, `auth-internal`
 */ class $90e6a618aa3f286c$export$16fa2f45be04daa8 {
    /**
     *
     * @param name The public service name, e.g. app, auth, firestore, database
     * @param instanceFactory Service factory responsible for creating the public interface
     * @param type whether the service provided by the component is public or private
     */ constructor(name, instanceFactory, type){
        this.name = name;
        this.instanceFactory = instanceFactory;
        this.type = type;
        this.multipleInstances = false;
        /**
         * Properties to be added to the service namespace
         */ this.serviceProps = {};
        this.instantiationMode = "LAZY" /* InstantiationMode.LAZY */ ;
        this.onInstanceCreated = null;
    }
    setInstantiationMode(mode) {
        this.instantiationMode = mode;
        return this;
    }
    setMultipleInstances(multipleInstances) {
        this.multipleInstances = multipleInstances;
        return this;
    }
    setServiceProps(props) {
        this.serviceProps = props;
        return this;
    }
    setInstanceCreatedCallback(callback) {
        this.onInstanceCreated = callback;
        return this;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $90e6a618aa3f286c$var$DEFAULT_ENTRY_NAME = '[DEFAULT]';
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for instance for service name T, e.g. 'auth', 'auth-internal'
 * NameServiceMapping[T] is an alias for the type of the instance
 */ class $90e6a618aa3f286c$export$2881499e37b75b9a {
    constructor(name, container){
        this.name = name;
        this.container = container;
        this.component = null;
        this.instances = new Map();
        this.instancesDeferred = new Map();
        this.instancesOptions = new Map();
        this.onInitCallbacks = new Map();
    }
    /**
     * @param identifier A provider can provide multiple instances of a service
     * if this.component.multipleInstances is true.
     */ get(identifier) {
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        if (!this.instancesDeferred.has(normalizedIdentifier)) {
            const deferred = new (0, $156de25e040d63b6$export$85f6557964517f1a)();
            this.instancesDeferred.set(normalizedIdentifier, deferred);
            if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) // initialize the service if it can be auto-initialized
            try {
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                if (instance) deferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception during get(), it should not cause
            // a fatal error. We just return the unresolved promise in this case.
            }
        }
        return this.instancesDeferred.get(normalizedIdentifier).promise;
    }
    getImmediate(options) {
        var _a;
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(options === null || options === void 0 ? void 0 : options.identifier);
        const optional = (_a = options === null || options === void 0 ? void 0 : options.optional) !== null && _a !== void 0 ? _a : false;
        if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) try {
            return this.getOrInitializeService({
                instanceIdentifier: normalizedIdentifier
            });
        } catch (e) {
            if (optional) return null;
            else throw e;
        }
        else {
            // In case a component is not initialized and should/cannot be auto-initialized at the moment, return null if the optional flag is set, or throw
            if (optional) return null;
            else throw Error(`Service ${this.name} is not available`);
        }
    }
    getComponent() {
        return this.component;
    }
    setComponent(component) {
        if (component.name !== this.name) throw Error(`Mismatching Component ${component.name} for Provider ${this.name}.`);
        if (this.component) throw Error(`Component for ${this.name} has already been provided`);
        this.component = component;
        // return early without attempting to initialize the component if the component requires explicit initialization (calling `Provider.initialize()`)
        if (!this.shouldAutoInitialize()) return;
        // if the service is eager, initialize the default instance
        if ($90e6a618aa3f286c$var$isComponentEager(component)) try {
            this.getOrInitializeService({
                instanceIdentifier: $90e6a618aa3f286c$var$DEFAULT_ENTRY_NAME
            });
        } catch (e) {
        // when the instance factory for an eager Component throws an exception during the eager
        // initialization, it should not cause a fatal error.
        // TODO: Investigate if we need to make it configurable, because some component may want to cause
        // a fatal error in this case?
        }
        // Create service instances for the pending promises and resolve them
        // NOTE: if this.multipleInstances is false, only the default instance will be created
        // and all promises with resolve with it regardless of the identifier.
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            try {
                // `getOrInitializeService()` should always return a valid instance since a component is guaranteed. use ! to make typescript happy.
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                instanceDeferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception, it should not cause
            // a fatal error. We just leave the promise unresolved.
            }
        }
    }
    clearInstance(identifier = $90e6a618aa3f286c$var$DEFAULT_ENTRY_NAME) {
        this.instancesDeferred.delete(identifier);
        this.instancesOptions.delete(identifier);
        this.instances.delete(identifier);
    }
    // app.delete() will call this method on every provider to delete the services
    // TODO: should we mark the provider as deleted?
    async delete() {
        const services = Array.from(this.instances.values());
        await Promise.all([
            ...services.filter((service)=>'INTERNAL' in service) // legacy services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service.INTERNAL.delete()),
            ...services.filter((service)=>'_delete' in service) // modularized services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service._delete())
        ]);
    }
    isComponentSet() {
        return this.component != null;
    }
    isInitialized(identifier = $90e6a618aa3f286c$var$DEFAULT_ENTRY_NAME) {
        return this.instances.has(identifier);
    }
    getOptions(identifier = $90e6a618aa3f286c$var$DEFAULT_ENTRY_NAME) {
        return this.instancesOptions.get(identifier) || {};
    }
    initialize(opts = {}) {
        const { options: options = {} } = opts;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(opts.instanceIdentifier);
        if (this.isInitialized(normalizedIdentifier)) throw Error(`${this.name}(${normalizedIdentifier}) has already been initialized`);
        if (!this.isComponentSet()) throw Error(`Component ${this.name} has not been registered yet`);
        const instance = this.getOrInitializeService({
            instanceIdentifier: normalizedIdentifier,
            options: options
        });
        // resolve any pending promise waiting for the service instance
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedDeferredIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            if (normalizedIdentifier === normalizedDeferredIdentifier) instanceDeferred.resolve(instance);
        }
        return instance;
    }
    /**
     *
     * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
     * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
     *
     * @param identifier An optional instance identifier
     * @returns a function to unregister the callback
     */ onInit(callback, identifier) {
        var _a;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        const existingCallbacks = (_a = this.onInitCallbacks.get(normalizedIdentifier)) !== null && _a !== void 0 ? _a : new Set();
        existingCallbacks.add(callback);
        this.onInitCallbacks.set(normalizedIdentifier, existingCallbacks);
        const existingInstance = this.instances.get(normalizedIdentifier);
        if (existingInstance) callback(existingInstance, normalizedIdentifier);
        return ()=>{
            existingCallbacks.delete(callback);
        };
    }
    /**
     * Invoke onInit callbacks synchronously
     * @param instance the service instance`
     */ invokeOnInitCallbacks(instance, identifier) {
        const callbacks = this.onInitCallbacks.get(identifier);
        if (!callbacks) return;
        for (const callback of callbacks)try {
            callback(instance, identifier);
        } catch (_a) {
        // ignore errors in the onInit callback
        }
    }
    getOrInitializeService({ instanceIdentifier: instanceIdentifier, options: options = {} }) {
        let instance = this.instances.get(instanceIdentifier);
        if (!instance && this.component) {
            instance = this.component.instanceFactory(this.container, {
                instanceIdentifier: $90e6a618aa3f286c$var$normalizeIdentifierForFactory(instanceIdentifier),
                options: options
            });
            this.instances.set(instanceIdentifier, instance);
            this.instancesOptions.set(instanceIdentifier, options);
            /**
             * Invoke onInit listeners.
             * Note this.component.onInstanceCreated is different, which is used by the component creator,
             * while onInit listeners are registered by consumers of the provider.
             */ this.invokeOnInitCallbacks(instance, instanceIdentifier);
            /**
             * Order is important
             * onInstanceCreated() should be called after this.instances.set(instanceIdentifier, instance); which
             * makes `isInitialized()` return true.
             */ if (this.component.onInstanceCreated) try {
                this.component.onInstanceCreated(this.container, instanceIdentifier, instance);
            } catch (_a) {
            // ignore errors in the onInstanceCreatedCallback
            }
        }
        return instance || null;
    }
    normalizeInstanceIdentifier(identifier = $90e6a618aa3f286c$var$DEFAULT_ENTRY_NAME) {
        if (this.component) return this.component.multipleInstances ? identifier : $90e6a618aa3f286c$var$DEFAULT_ENTRY_NAME;
        else return identifier; // assume multiple instances are supported before the component is provided.
    }
    shouldAutoInitialize() {
        return !!this.component && this.component.instantiationMode !== "EXPLICIT" /* InstantiationMode.EXPLICIT */ ;
    }
}
// undefined should be passed to the service factory for the default instance
function $90e6a618aa3f286c$var$normalizeIdentifierForFactory(identifier) {
    return identifier === $90e6a618aa3f286c$var$DEFAULT_ENTRY_NAME ? undefined : identifier;
}
function $90e6a618aa3f286c$var$isComponentEager(component) {
    return component.instantiationMode === "EAGER" /* InstantiationMode.EAGER */ ;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * ComponentContainer that provides Providers for service name T, e.g. `auth`, `auth-internal`
 */ class $90e6a618aa3f286c$export$436a80eea5d5c0c5 {
    constructor(name){
        this.name = name;
        this.providers = new Map();
    }
    /**
     *
     * @param component Component being added
     * @param overwrite When a component with the same name has already been registered,
     * if overwrite is true: overwrite the existing component with the new component and create a new
     * provider with the new component. It can be useful in tests where you want to use different mocks
     * for different tests.
     * if overwrite is false: throw an exception
     */ addComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) throw new Error(`Component ${component.name} has already been registered with ${this.name}`);
        provider.setComponent(component);
    }
    addOrOverwriteComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) // delete the existing provider from the container, so we can register the new component
        this.providers.delete(component.name);
        this.addComponent(component);
    }
    /**
     * getProvider provides a type safe interface where it can only be called with a field name
     * present in NameServiceMapping interface.
     *
     * Firebase SDKs providing services should extend NameServiceMapping interface to register
     * themselves.
     */ getProvider(name) {
        if (this.providers.has(name)) return this.providers.get(name);
        // create a Provider for a service that hasn't registered with Firebase
        const provider = new $90e6a618aa3f286c$export$2881499e37b75b9a(name, this);
        this.providers.set(name, provider);
        return provider;
    }
    getProviders() {
        return Array.from(this.providers.values());
    }
}


/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A container for all of the Logger instances
 */ const $65bf8d3396e16cb5$var$instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */ var $65bf8d3396e16cb5$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})($65bf8d3396e16cb5$export$243e62d78d3b544d || ($65bf8d3396e16cb5$export$243e62d78d3b544d = {}));
const $65bf8d3396e16cb5$var$levelStringToEnum = {
    'debug': $65bf8d3396e16cb5$export$243e62d78d3b544d.DEBUG,
    'verbose': $65bf8d3396e16cb5$export$243e62d78d3b544d.VERBOSE,
    'info': $65bf8d3396e16cb5$export$243e62d78d3b544d.INFO,
    'warn': $65bf8d3396e16cb5$export$243e62d78d3b544d.WARN,
    'error': $65bf8d3396e16cb5$export$243e62d78d3b544d.ERROR,
    'silent': $65bf8d3396e16cb5$export$243e62d78d3b544d.SILENT
};
/**
 * The default log level
 */ const $65bf8d3396e16cb5$var$defaultLogLevel = $65bf8d3396e16cb5$export$243e62d78d3b544d.INFO;
/**
 * By default, `console.debug` is not displayed in the developer console (in
 * chrome). To avoid forcing users to have to opt-in to these logs twice
 * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
 * logs to the `console.log` function.
 */ const $65bf8d3396e16cb5$var$ConsoleMethod = {
    [$65bf8d3396e16cb5$export$243e62d78d3b544d.DEBUG]: 'log',
    [$65bf8d3396e16cb5$export$243e62d78d3b544d.VERBOSE]: 'log',
    [$65bf8d3396e16cb5$export$243e62d78d3b544d.INFO]: 'info',
    [$65bf8d3396e16cb5$export$243e62d78d3b544d.WARN]: 'warn',
    [$65bf8d3396e16cb5$export$243e62d78d3b544d.ERROR]: 'error'
};
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */ const $65bf8d3396e16cb5$var$defaultLogHandler = (instance, logType, ...args)=>{
    if (logType < instance.logLevel) return;
    const now = new Date().toISOString();
    const method = $65bf8d3396e16cb5$var$ConsoleMethod[logType];
    if (method) console[method](`[${now}]  ${instance.name}:`, ...args);
    else throw new Error(`Attempted to log a message with an invalid logType (value: ${logType})`);
};
class $65bf8d3396e16cb5$export$efa9a398d6368992 {
    /**
     * Gives you an instance of a Logger to capture messages according to
     * Firebase's logging scheme.
     *
     * @param name The name that the logs will be associated with
     */ constructor(name){
        this.name = name;
        /**
         * The log level of the given Logger instance.
         */ this._logLevel = $65bf8d3396e16cb5$var$defaultLogLevel;
        /**
         * The main (internal) log handler for the Logger instance.
         * Can be set to a new function in internal package code but not by user.
         */ this._logHandler = $65bf8d3396e16cb5$var$defaultLogHandler;
        /**
         * The optional, additional, user-defined log handler for the Logger instance.
         */ this._userLogHandler = null;
        /**
         * Capture the current instance for later use
         */ $65bf8d3396e16cb5$var$instances.push(this);
    }
    get logLevel() {
        return this._logLevel;
    }
    set logLevel(val) {
        if (!(val in $65bf8d3396e16cb5$export$243e62d78d3b544d)) throw new TypeError(`Invalid value "${val}" assigned to \`logLevel\``);
        this._logLevel = val;
    }
    // Workaround for setter/getter having to be the same type.
    setLogLevel(val) {
        this._logLevel = typeof val === 'string' ? $65bf8d3396e16cb5$var$levelStringToEnum[val] : val;
    }
    get logHandler() {
        return this._logHandler;
    }
    set logHandler(val) {
        if (typeof val !== 'function') throw new TypeError('Value assigned to `logHandler` must be a function');
        this._logHandler = val;
    }
    get userLogHandler() {
        return this._userLogHandler;
    }
    set userLogHandler(val) {
        this._userLogHandler = val;
    }
    /**
     * The functions below are all based on the `console` interface
     */ debug(...args) {
        this._userLogHandler && this._userLogHandler(this, $65bf8d3396e16cb5$export$243e62d78d3b544d.DEBUG, ...args);
        this._logHandler(this, $65bf8d3396e16cb5$export$243e62d78d3b544d.DEBUG, ...args);
    }
    log(...args) {
        this._userLogHandler && this._userLogHandler(this, $65bf8d3396e16cb5$export$243e62d78d3b544d.VERBOSE, ...args);
        this._logHandler(this, $65bf8d3396e16cb5$export$243e62d78d3b544d.VERBOSE, ...args);
    }
    info(...args) {
        this._userLogHandler && this._userLogHandler(this, $65bf8d3396e16cb5$export$243e62d78d3b544d.INFO, ...args);
        this._logHandler(this, $65bf8d3396e16cb5$export$243e62d78d3b544d.INFO, ...args);
    }
    warn(...args) {
        this._userLogHandler && this._userLogHandler(this, $65bf8d3396e16cb5$export$243e62d78d3b544d.WARN, ...args);
        this._logHandler(this, $65bf8d3396e16cb5$export$243e62d78d3b544d.WARN, ...args);
    }
    error(...args) {
        this._userLogHandler && this._userLogHandler(this, $65bf8d3396e16cb5$export$243e62d78d3b544d.ERROR, ...args);
        this._logHandler(this, $65bf8d3396e16cb5$export$243e62d78d3b544d.ERROR, ...args);
    }
}
function $65bf8d3396e16cb5$export$c622e99c0ce7b1c9(level) {
    $65bf8d3396e16cb5$var$instances.forEach((inst)=>{
        inst.setLogLevel(level);
    });
}
function $65bf8d3396e16cb5$export$29577d29c84db5f6(logCallback, options) {
    for (const instance of $65bf8d3396e16cb5$var$instances){
        let customLogLevel = null;
        if (options && options.level) customLogLevel = $65bf8d3396e16cb5$var$levelStringToEnum[options.level];
        if (logCallback === null) instance.userLogHandler = null;
        else instance.userLogHandler = (instance, level, ...args)=>{
            const message = args.map((arg)=>{
                if (arg == null) return null;
                else if (typeof arg === 'string') return arg;
                else if (typeof arg === 'number' || typeof arg === 'boolean') return arg.toString();
                else if (arg instanceof Error) return arg.message;
                else try {
                    return JSON.stringify(arg);
                } catch (ignored) {
                    return null;
                }
            }).filter((arg)=>arg).join(' ');
            if (level >= (customLogLevel !== null && customLogLevel !== void 0 ? customLogLevel : instance.logLevel)) logCallback({
                level: $65bf8d3396e16cb5$export$243e62d78d3b544d[level].toLowerCase(),
                message: message,
                args: args,
                type: instance.name
            });
        };
    }
}



const $64067f21f298d958$export$23f2a1d2818174ef = (object, constructors)=>constructors.some((c)=>object instanceof c);
let $64067f21f298d958$var$idbProxyableTypes;
let $64067f21f298d958$var$cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function $64067f21f298d958$var$getIdbProxyableTypes() {
    return $64067f21f298d958$var$idbProxyableTypes || ($64067f21f298d958$var$idbProxyableTypes = [
        IDBDatabase,
        IDBObjectStore,
        IDBIndex,
        IDBCursor,
        IDBTransaction
    ]);
}
// This is a function to prevent it throwing up in node environments.
function $64067f21f298d958$var$getCursorAdvanceMethods() {
    return $64067f21f298d958$var$cursorAdvanceMethods || ($64067f21f298d958$var$cursorAdvanceMethods = [
        IDBCursor.prototype.advance,
        IDBCursor.prototype.continue,
        IDBCursor.prototype.continuePrimaryKey
    ]);
}
const $64067f21f298d958$var$cursorRequestMap = new WeakMap();
const $64067f21f298d958$var$transactionDoneMap = new WeakMap();
const $64067f21f298d958$var$transactionStoreNamesMap = new WeakMap();
const $64067f21f298d958$var$transformCache = new WeakMap();
const $64067f21f298d958$export$407448d2b89b1813 = new WeakMap();
function $64067f21f298d958$var$promisifyRequest(request) {
    const promise = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            request.removeEventListener('success', success);
            request.removeEventListener('error', error);
        };
        const success = ()=>{
            resolve($64067f21f298d958$export$efccba1c4a2ef57b(request.result));
            unlisten();
        };
        const error = ()=>{
            reject(request.error);
            unlisten();
        };
        request.addEventListener('success', success);
        request.addEventListener('error', error);
    });
    promise.then((value)=>{
        // Since cursoring reuses the IDBRequest (*sigh*), we cache it for later retrieval
        // (see wrapFunction).
        if (value instanceof IDBCursor) $64067f21f298d958$var$cursorRequestMap.set(value, request);
    // Catching to avoid "Uncaught Promise exceptions"
    }).catch(()=>{});
    // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    $64067f21f298d958$export$407448d2b89b1813.set(promise, request);
    return promise;
}
function $64067f21f298d958$var$cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if ($64067f21f298d958$var$transactionDoneMap.has(tx)) return;
    const done = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            tx.removeEventListener('complete', complete);
            tx.removeEventListener('error', error);
            tx.removeEventListener('abort', error);
        };
        const complete = ()=>{
            resolve();
            unlisten();
        };
        const error = ()=>{
            reject(tx.error || new DOMException('AbortError', 'AbortError'));
            unlisten();
        };
        tx.addEventListener('complete', complete);
        tx.addEventListener('error', error);
        tx.addEventListener('abort', error);
    });
    // Cache it for later retrieval.
    $64067f21f298d958$var$transactionDoneMap.set(tx, done);
}
let $64067f21f298d958$var$idbProxyTraps = {
    get (target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === 'done') return $64067f21f298d958$var$transactionDoneMap.get(target);
            // Polyfill for objectStoreNames because of Edge.
            if (prop === 'objectStoreNames') return target.objectStoreNames || $64067f21f298d958$var$transactionStoreNamesMap.get(target);
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === 'store') return receiver.objectStoreNames[1] ? undefined : receiver.objectStore(receiver.objectStoreNames[0]);
        }
        // Else transform whatever we get back.
        return $64067f21f298d958$export$efccba1c4a2ef57b(target[prop]);
    },
    set (target, prop, value) {
        target[prop] = value;
        return true;
    },
    has (target, prop) {
        if (target instanceof IDBTransaction && (prop === 'done' || prop === 'store')) return true;
        return prop in target;
    }
};
function $64067f21f298d958$export$43caf9889c228507(callback) {
    $64067f21f298d958$var$idbProxyTraps = callback($64067f21f298d958$var$idbProxyTraps);
}
function $64067f21f298d958$var$wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Edge doesn't support objectStoreNames (booo), so we polyfill it here.
    if (func === IDBDatabase.prototype.transaction && !('objectStoreNames' in IDBTransaction.prototype)) return function(storeNames, ...args) {
        const tx = func.call($64067f21f298d958$export$3b14a55fb2447963(this), storeNames, ...args);
        $64067f21f298d958$var$transactionStoreNamesMap.set(tx, storeNames.sort ? storeNames.sort() : [
            storeNames
        ]);
        return $64067f21f298d958$export$efccba1c4a2ef57b(tx);
    };
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if ($64067f21f298d958$var$getCursorAdvanceMethods().includes(func)) return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        func.apply($64067f21f298d958$export$3b14a55fb2447963(this), args);
        return $64067f21f298d958$export$efccba1c4a2ef57b($64067f21f298d958$var$cursorRequestMap.get(this));
    };
    return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return $64067f21f298d958$export$efccba1c4a2ef57b(func.apply($64067f21f298d958$export$3b14a55fb2447963(this), args));
    };
}
function $64067f21f298d958$var$transformCachableValue(value) {
    if (typeof value === 'function') return $64067f21f298d958$var$wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction) $64067f21f298d958$var$cacheDonePromiseForTransaction(value);
    if ($64067f21f298d958$export$23f2a1d2818174ef(value, $64067f21f298d958$var$getIdbProxyableTypes())) return new Proxy(value, $64067f21f298d958$var$idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function $64067f21f298d958$export$efccba1c4a2ef57b(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest) return $64067f21f298d958$var$promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if ($64067f21f298d958$var$transformCache.has(value)) return $64067f21f298d958$var$transformCache.get(value);
    const newValue = $64067f21f298d958$var$transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        $64067f21f298d958$var$transformCache.set(value, newValue);
        $64067f21f298d958$export$407448d2b89b1813.set(newValue, value);
    }
    return newValue;
}
const $64067f21f298d958$export$3b14a55fb2447963 = (value)=>$64067f21f298d958$export$407448d2b89b1813.get(value);


/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */ function $df013b049e1dc2b4$export$ca0ed41b1a2af7e(name, version, { blocked: blocked, upgrade: upgrade, blocking: blocking, terminated: terminated } = {}) {
    const request = indexedDB.open(name, version);
    const openPromise = (0, $64067f21f298d958$export$efccba1c4a2ef57b)(request);
    if (upgrade) request.addEventListener('upgradeneeded', (event)=>{
        upgrade((0, $64067f21f298d958$export$efccba1c4a2ef57b)(request.result), event.oldVersion, event.newVersion, (0, $64067f21f298d958$export$efccba1c4a2ef57b)(request.transaction), event);
    });
    if (blocked) request.addEventListener('blocked', (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event.newVersion, event));
    openPromise.then((db)=>{
        if (terminated) db.addEventListener('close', ()=>terminated());
        if (blocking) db.addEventListener('versionchange', (event)=>blocking(event.oldVersion, event.newVersion, event));
    }).catch(()=>{});
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */ function $df013b049e1dc2b4$export$9d6df0ac66a98bb2(name, { blocked: blocked } = {}) {
    const request = indexedDB.deleteDatabase(name);
    if (blocked) request.addEventListener('blocked', (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event));
    return (0, $64067f21f298d958$export$efccba1c4a2ef57b)(request).then(()=>undefined);
}
const $df013b049e1dc2b4$var$readMethods = [
    'get',
    'getKey',
    'getAll',
    'getAllKeys',
    'count'
];
const $df013b049e1dc2b4$var$writeMethods = [
    'put',
    'add',
    'delete',
    'clear'
];
const $df013b049e1dc2b4$var$cachedMethods = new Map();
function $df013b049e1dc2b4$var$getMethod(target, prop) {
    if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === 'string')) return;
    if ($df013b049e1dc2b4$var$cachedMethods.get(prop)) return $df013b049e1dc2b4$var$cachedMethods.get(prop);
    const targetFuncName = prop.replace(/FromIndex$/, '');
    const useIndex = prop !== targetFuncName;
    const isWrite = $df013b049e1dc2b4$var$writeMethods.includes(targetFuncName);
    if (// Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || $df013b049e1dc2b4$var$readMethods.includes(targetFuncName))) return;
    const method = async function(storeName, ...args) {
        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
        const tx = this.transaction(storeName, isWrite ? 'readwrite' : 'readonly');
        let target = tx.store;
        if (useIndex) target = target.index(args.shift());
        // Must reject if op rejects.
        // If it's a write operation, must reject if tx.done rejects.
        // Must reject with op rejection first.
        // Must resolve with op value.
        // Must handle both promises (no unhandled rejections)
        return (await Promise.all([
            target[targetFuncName](...args),
            isWrite && tx.done
        ]))[0];
    };
    $df013b049e1dc2b4$var$cachedMethods.set(prop, method);
    return method;
}
(0, $64067f21f298d958$export$43caf9889c228507)((oldTraps)=>({
        ...oldTraps,
        get: (target, prop, receiver)=>$df013b049e1dc2b4$var$getMethod(target, prop) || oldTraps.get(target, prop, receiver),
        has: (target, prop)=>!!$df013b049e1dc2b4$var$getMethod(target, prop) || oldTraps.has(target, prop)
    }));


/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $48fcf96884780cca$var$PlatformLoggerServiceImpl {
    constructor(container){
        this.container = container;
    }
    // In initial implementation, this will be called by installations on
    // auth token refresh, and installations will send this string.
    getPlatformInfoString() {
        const providers = this.container.getProviders();
        // Loop through providers and get library/version pairs from any that are
        // version components.
        return providers.map((provider)=>{
            if ($48fcf96884780cca$var$isVersionServiceProvider(provider)) {
                const service = provider.getImmediate();
                return `${service.library}/${service.version}`;
            } else return null;
        }).filter((logString)=>logString).join(' ');
    }
}
/**
 *
 * @param provider check if this provider provides a VersionService
 *
 * NOTE: Using Provider<'app-version'> is a hack to indicate that the provider
 * provides VersionService. The provider is not necessarily a 'app-version'
 * provider.
 */ function $48fcf96884780cca$var$isVersionServiceProvider(provider) {
    const component = provider.getComponent();
    return (component === null || component === void 0 ? void 0 : component.type) === "VERSION" /* ComponentType.VERSION */ ;
}
const $48fcf96884780cca$var$name$q = "@firebase/app";
const $48fcf96884780cca$var$version$1 = "0.13.2";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $48fcf96884780cca$var$logger = new (0, $65bf8d3396e16cb5$export$efa9a398d6368992)('@firebase/app');
const $48fcf96884780cca$var$name$p = "@firebase/app-compat";
const $48fcf96884780cca$var$name$o = "@firebase/analytics-compat";
const $48fcf96884780cca$var$name$n = "@firebase/analytics";
const $48fcf96884780cca$var$name$m = "@firebase/app-check-compat";
const $48fcf96884780cca$var$name$l = "@firebase/app-check";
const $48fcf96884780cca$var$name$k = "@firebase/auth";
const $48fcf96884780cca$var$name$j = "@firebase/auth-compat";
const $48fcf96884780cca$var$name$i = "@firebase/database";
const $48fcf96884780cca$var$name$h = "@firebase/data-connect";
const $48fcf96884780cca$var$name$g = "@firebase/database-compat";
const $48fcf96884780cca$var$name$f = "@firebase/functions";
const $48fcf96884780cca$var$name$e = "@firebase/functions-compat";
const $48fcf96884780cca$var$name$d = "@firebase/installations";
const $48fcf96884780cca$var$name$c = "@firebase/installations-compat";
const $48fcf96884780cca$var$name$b = "@firebase/messaging";
const $48fcf96884780cca$var$name$a = "@firebase/messaging-compat";
const $48fcf96884780cca$var$name$9 = "@firebase/performance";
const $48fcf96884780cca$var$name$8 = "@firebase/performance-compat";
const $48fcf96884780cca$var$name$7 = "@firebase/remote-config";
const $48fcf96884780cca$var$name$6 = "@firebase/remote-config-compat";
const $48fcf96884780cca$var$name$5 = "@firebase/storage";
const $48fcf96884780cca$var$name$4 = "@firebase/storage-compat";
const $48fcf96884780cca$var$name$3 = "@firebase/firestore";
const $48fcf96884780cca$var$name$2 = "@firebase/ai";
const $48fcf96884780cca$var$name$1 = "@firebase/firestore-compat";
const $48fcf96884780cca$var$name = "firebase";
const $48fcf96884780cca$var$version = "11.10.0";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The default app name
 *
 * @internal
 */ const $48fcf96884780cca$export$9f30fa0c10967f7f = '[DEFAULT]';
const $48fcf96884780cca$var$PLATFORM_LOG_STRING = {
    [$48fcf96884780cca$var$name$q]: 'fire-core',
    [$48fcf96884780cca$var$name$p]: 'fire-core-compat',
    [$48fcf96884780cca$var$name$n]: 'fire-analytics',
    [$48fcf96884780cca$var$name$o]: 'fire-analytics-compat',
    [$48fcf96884780cca$var$name$l]: 'fire-app-check',
    [$48fcf96884780cca$var$name$m]: 'fire-app-check-compat',
    [$48fcf96884780cca$var$name$k]: 'fire-auth',
    [$48fcf96884780cca$var$name$j]: 'fire-auth-compat',
    [$48fcf96884780cca$var$name$i]: 'fire-rtdb',
    [$48fcf96884780cca$var$name$h]: 'fire-data-connect',
    [$48fcf96884780cca$var$name$g]: 'fire-rtdb-compat',
    [$48fcf96884780cca$var$name$f]: 'fire-fn',
    [$48fcf96884780cca$var$name$e]: 'fire-fn-compat',
    [$48fcf96884780cca$var$name$d]: 'fire-iid',
    [$48fcf96884780cca$var$name$c]: 'fire-iid-compat',
    [$48fcf96884780cca$var$name$b]: 'fire-fcm',
    [$48fcf96884780cca$var$name$a]: 'fire-fcm-compat',
    [$48fcf96884780cca$var$name$9]: 'fire-perf',
    [$48fcf96884780cca$var$name$8]: 'fire-perf-compat',
    [$48fcf96884780cca$var$name$7]: 'fire-rc',
    [$48fcf96884780cca$var$name$6]: 'fire-rc-compat',
    [$48fcf96884780cca$var$name$5]: 'fire-gcs',
    [$48fcf96884780cca$var$name$4]: 'fire-gcs-compat',
    [$48fcf96884780cca$var$name$3]: 'fire-fst',
    [$48fcf96884780cca$var$name$1]: 'fire-fst-compat',
    [$48fcf96884780cca$var$name$2]: 'fire-vertex',
    'fire-js': 'fire-js',
    [$48fcf96884780cca$var$name]: 'fire-js-all'
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ const $48fcf96884780cca$export$b4e3c36c855b14b5 = new Map();
/**
 * @internal
 */ const $48fcf96884780cca$export$fb03ad8d3d5c5f76 = new Map();
/**
 * Registered components.
 *
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $48fcf96884780cca$export$9566bce3835c0f28 = new Map();
/**
 * @param component - the component being added to this app's container
 *
 * @internal
 */ function $48fcf96884780cca$export$fa5244b94c62d36a(app, component) {
    try {
        app.container.addComponent(component);
    } catch (e) {
        $48fcf96884780cca$var$logger.debug(`Component ${component.name} failed to register with FirebaseApp ${app.name}`, e);
    }
}
/**
 *
 * @internal
 */ function $48fcf96884780cca$export$4393112b42e2b41d(app, component) {
    app.container.addOrOverwriteComponent(component);
}
/**
 *
 * @param component - the component to register
 * @returns whether or not the component is registered successfully
 *
 * @internal
 */ function $48fcf96884780cca$export$c930050e7bb63965(component) {
    const componentName = component.name;
    if ($48fcf96884780cca$export$9566bce3835c0f28.has(componentName)) {
        $48fcf96884780cca$var$logger.debug(`There were multiple attempts to register component ${componentName}.`);
        return false;
    }
    $48fcf96884780cca$export$9566bce3835c0f28.set(componentName, component);
    // add the component to existing app instances
    for (const app of $48fcf96884780cca$export$b4e3c36c855b14b5.values())$48fcf96884780cca$export$fa5244b94c62d36a(app, component);
    for (const serverApp of $48fcf96884780cca$export$fb03ad8d3d5c5f76.values())$48fcf96884780cca$export$fa5244b94c62d36a(serverApp, component);
    return true;
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 *
 * @returns the provider for the service with the matching name
 *
 * @internal
 */ function $48fcf96884780cca$export$fa0d6da0f5838f50(app, name) {
    const heartbeatController = app.container.getProvider('heartbeat').getImmediate({
        optional: true
    });
    if (heartbeatController) heartbeatController.triggerHeartbeat();
    return app.container.getProvider(name);
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 * @param instanceIdentifier - service instance identifier in case the service supports multiple instances
 *
 * @internal
 */ function $48fcf96884780cca$export$48d18de2ff1c45a5(app, name, instanceIdentifier = $48fcf96884780cca$export$9f30fa0c10967f7f) {
    $48fcf96884780cca$export$fa0d6da0f5838f50(app, name).clearInstance(instanceIdentifier);
}
/**
 *
 * @param obj - an object of type FirebaseApp or FirebaseOptions.
 *
 * @returns true if the provide object is of type FirebaseApp.
 *
 * @internal
 */ function $48fcf96884780cca$export$110778f8e98b8257(obj) {
    return obj.options !== undefined;
}
/**
 *
 * @param obj - an object of type FirebaseApp.
 *
 * @returns true if the provided object is of type FirebaseServerAppImpl.
 *
 * @internal
 */ function $48fcf96884780cca$export$643c8bc6c389f34e(obj) {
    if (obj === null || obj === undefined) return false;
    return obj.settings !== undefined;
}
/**
 * Test only
 *
 * @internal
 */ function $48fcf96884780cca$export$3685d89b9c3cdfaf() {
    $48fcf96884780cca$export$9566bce3835c0f28.clear();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $48fcf96884780cca$var$ERRORS = {
    ["no-app" /* AppError.NO_APP */ ]: "No Firebase App '{$appName}' has been created - call initializeApp() first",
    ["bad-app-name" /* AppError.BAD_APP_NAME */ ]: "Illegal App name: '{$appName}'",
    ["duplicate-app" /* AppError.DUPLICATE_APP */ ]: "Firebase App named '{$appName}' already exists with different options or config",
    ["app-deleted" /* AppError.APP_DELETED */ ]: "Firebase App named '{$appName}' already deleted",
    ["server-app-deleted" /* AppError.SERVER_APP_DELETED */ ]: 'Firebase Server App has been deleted',
    ["no-options" /* AppError.NO_OPTIONS */ ]: 'Need to provide options, when not being deployed to hosting via source.',
    ["invalid-app-argument" /* AppError.INVALID_APP_ARGUMENT */ ]: "firebase.{$appName}() takes either no argument or a Firebase App instance.",
    ["invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ ]: 'First argument to `onLog` must be null or a function.',
    ["idb-open" /* AppError.IDB_OPEN */ ]: 'Error thrown when opening IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-get" /* AppError.IDB_GET */ ]: 'Error thrown when reading from IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-set" /* AppError.IDB_WRITE */ ]: 'Error thrown when writing to IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-delete" /* AppError.IDB_DELETE */ ]: 'Error thrown when deleting from IndexedDB. Original error: {$originalErrorMessage}.',
    ["finalization-registry-not-supported" /* AppError.FINALIZATION_REGISTRY_NOT_SUPPORTED */ ]: 'FirebaseServerApp deleteOnDeref field defined but the JS runtime does not support FinalizationRegistry.',
    ["invalid-server-app-environment" /* AppError.INVALID_SERVER_APP_ENVIRONMENT */ ]: 'FirebaseServerApp is not for use in browser environments.'
};
const $48fcf96884780cca$var$ERROR_FACTORY = new (0, $156de25e040d63b6$export$3fa6e1b18a3b2d40)('app', 'Firebase', $48fcf96884780cca$var$ERRORS);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $48fcf96884780cca$var$FirebaseAppImpl {
    constructor(options, config, container){
        this._isDeleted = false;
        this._options = Object.assign({}, options);
        this._config = Object.assign({}, config);
        this._name = config.name;
        this._automaticDataCollectionEnabled = config.automaticDataCollectionEnabled;
        this._container = container;
        this.container.addComponent(new (0, $90e6a618aa3f286c$export$16fa2f45be04daa8)('app', ()=>this, "PUBLIC" /* ComponentType.PUBLIC */ ));
    }
    get automaticDataCollectionEnabled() {
        this.checkDestroyed();
        return this._automaticDataCollectionEnabled;
    }
    set automaticDataCollectionEnabled(val) {
        this.checkDestroyed();
        this._automaticDataCollectionEnabled = val;
    }
    get name() {
        this.checkDestroyed();
        return this._name;
    }
    get options() {
        this.checkDestroyed();
        return this._options;
    }
    get config() {
        this.checkDestroyed();
        return this._config;
    }
    get container() {
        return this._container;
    }
    get isDeleted() {
        return this._isDeleted;
    }
    set isDeleted(val) {
        this._isDeleted = val;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ checkDestroyed() {
        if (this.isDeleted) throw $48fcf96884780cca$var$ERROR_FACTORY.create("app-deleted" /* AppError.APP_DELETED */ , {
            appName: this._name
        });
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Parse the token and check to see if the `exp` claim is in the future.
// Reports an error to the console if the token or claim could not be parsed, or if `exp` is in
// the past.
function $48fcf96884780cca$var$validateTokenTTL(base64Token, tokenName) {
    const secondPart = (0, $156de25e040d63b6$export$c62426fdd000a97e)(base64Token.split('.')[1]);
    if (secondPart === null) {
        console.error(`FirebaseServerApp ${tokenName} is invalid: second part could not be parsed.`);
        return;
    }
    const expClaim = JSON.parse(secondPart).exp;
    if (expClaim === undefined) {
        console.error(`FirebaseServerApp ${tokenName} is invalid: expiration claim could not be parsed`);
        return;
    }
    const exp = JSON.parse(secondPart).exp * 1000;
    const now = new Date().getTime();
    const diff = exp - now;
    if (diff <= 0) console.error(`FirebaseServerApp ${tokenName} is invalid: the token has expired.`);
}
class $48fcf96884780cca$var$FirebaseServerAppImpl extends $48fcf96884780cca$var$FirebaseAppImpl {
    constructor(options, serverConfig, name, container){
        // Build configuration parameters for the FirebaseAppImpl base class.
        const automaticDataCollectionEnabled = serverConfig.automaticDataCollectionEnabled !== undefined ? serverConfig.automaticDataCollectionEnabled : true;
        // Create the FirebaseAppSettings object for the FirebaseAppImp constructor.
        const config = {
            name: name,
            automaticDataCollectionEnabled: automaticDataCollectionEnabled
        };
        if (options.apiKey !== undefined) // Construct the parent FirebaseAppImp object.
        super(options, config, container);
        else {
            const appImpl = options;
            super(appImpl.options, config, container);
        }
        // Now construct the data for the FirebaseServerAppImpl.
        this._serverConfig = Object.assign({
            automaticDataCollectionEnabled: automaticDataCollectionEnabled
        }, serverConfig);
        // Ensure that the current time is within the `authIdtoken` window of validity.
        if (this._serverConfig.authIdToken) $48fcf96884780cca$var$validateTokenTTL(this._serverConfig.authIdToken, 'authIdToken');
        // Ensure that the current time is within the `appCheckToken` window of validity.
        if (this._serverConfig.appCheckToken) $48fcf96884780cca$var$validateTokenTTL(this._serverConfig.appCheckToken, 'appCheckToken');
        this._finalizationRegistry = null;
        if (typeof FinalizationRegistry !== 'undefined') this._finalizationRegistry = new FinalizationRegistry(()=>{
            this.automaticCleanup();
        });
        this._refCount = 0;
        this.incRefCount(this._serverConfig.releaseOnDeref);
        // Do not retain a hard reference to the dref object, otherwise the FinalizationRegistry
        // will never trigger.
        this._serverConfig.releaseOnDeref = undefined;
        serverConfig.releaseOnDeref = undefined;
        $48fcf96884780cca$export$d29d5299a7137abc($48fcf96884780cca$var$name$q, $48fcf96884780cca$var$version$1, 'serverapp');
    }
    toJSON() {
        return undefined;
    }
    get refCount() {
        return this._refCount;
    }
    // Increment the reference count of this server app. If an object is provided, register it
    // with the finalization registry.
    incRefCount(obj) {
        if (this.isDeleted) return;
        this._refCount++;
        if (obj !== undefined && this._finalizationRegistry !== null) this._finalizationRegistry.register(obj, this);
    }
    // Decrement the reference count.
    decRefCount() {
        if (this.isDeleted) return 0;
        return --this._refCount;
    }
    // Invoked by the FinalizationRegistry callback to note that this app should go through its
    // reference counts and delete itself if no reference count remain. The coordinating logic that
    // handles this is in deleteApp(...).
    automaticCleanup() {
        $48fcf96884780cca$export$6eec44aa53d5ea34(this);
    }
    get settings() {
        this.checkDestroyed();
        return this._serverConfig;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ checkDestroyed() {
        if (this.isDeleted) throw $48fcf96884780cca$var$ERROR_FACTORY.create("server-app-deleted" /* AppError.SERVER_APP_DELETED */ );
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The current SDK version.
 *
 * @public
 */ const $48fcf96884780cca$export$31499a9cd224b78c = $48fcf96884780cca$var$version;
function $48fcf96884780cca$export$c55cfd413944906d(_options, rawConfig = {}) {
    let options = _options;
    if (typeof rawConfig !== 'object') {
        const name = rawConfig;
        rawConfig = {
            name: name
        };
    }
    const config = Object.assign({
        name: $48fcf96884780cca$export$9f30fa0c10967f7f,
        automaticDataCollectionEnabled: true
    }, rawConfig);
    const name = config.name;
    if (typeof name !== 'string' || !name) throw $48fcf96884780cca$var$ERROR_FACTORY.create("bad-app-name" /* AppError.BAD_APP_NAME */ , {
        appName: String(name)
    });
    options || (options = (0, $156de25e040d63b6$export$3dfb6827a9f89756)());
    if (!options) throw $48fcf96884780cca$var$ERROR_FACTORY.create("no-options" /* AppError.NO_OPTIONS */ );
    const existingApp = $48fcf96884780cca$export$b4e3c36c855b14b5.get(name);
    if (existingApp) {
        // return the existing app if options and config deep equal the ones in the existing app.
        if ((0, $156de25e040d63b6$export$9cb4719e2e525b7a)(options, existingApp.options) && (0, $156de25e040d63b6$export$9cb4719e2e525b7a)(config, existingApp.config)) return existingApp;
        else throw $48fcf96884780cca$var$ERROR_FACTORY.create("duplicate-app" /* AppError.DUPLICATE_APP */ , {
            appName: name
        });
    }
    const container = new (0, $90e6a618aa3f286c$export$436a80eea5d5c0c5)(name);
    for (const component of $48fcf96884780cca$export$9566bce3835c0f28.values())container.addComponent(component);
    const newApp = new $48fcf96884780cca$var$FirebaseAppImpl(options, config, container);
    $48fcf96884780cca$export$b4e3c36c855b14b5.set(name, newApp);
    return newApp;
}
function $48fcf96884780cca$export$45a407ab953b136b(_options, _serverAppConfig) {
    if ((0, $156de25e040d63b6$export$4e09c449d6c407f7)() && !(0, $156de25e040d63b6$export$97b87b8868ff7a3c)()) // FirebaseServerApp isn't designed to be run in browsers.
    throw $48fcf96884780cca$var$ERROR_FACTORY.create("invalid-server-app-environment" /* AppError.INVALID_SERVER_APP_ENVIRONMENT */ );
    if (_serverAppConfig.automaticDataCollectionEnabled === undefined) _serverAppConfig.automaticDataCollectionEnabled = true;
    let appOptions;
    if ($48fcf96884780cca$export$110778f8e98b8257(_options)) appOptions = _options.options;
    else appOptions = _options;
    // Build an app name based on a hash of the configuration options.
    const nameObj = Object.assign(Object.assign({}, _serverAppConfig), appOptions);
    // However, Do not mangle the name based on releaseOnDeref, since it will vary between the
    // construction of FirebaseServerApp instances. For example, if the object is the request headers.
    if (nameObj.releaseOnDeref !== undefined) delete nameObj.releaseOnDeref;
    const hashCode = (s)=>{
        return [
            ...s
        ].reduce((hash, c)=>Math.imul(31, hash) + c.charCodeAt(0) | 0, 0);
    };
    if (_serverAppConfig.releaseOnDeref !== undefined) {
        if (typeof FinalizationRegistry === 'undefined') throw $48fcf96884780cca$var$ERROR_FACTORY.create("finalization-registry-not-supported" /* AppError.FINALIZATION_REGISTRY_NOT_SUPPORTED */ , {});
    }
    const nameString = '' + hashCode(JSON.stringify(nameObj));
    const existingApp = $48fcf96884780cca$export$fb03ad8d3d5c5f76.get(nameString);
    if (existingApp) {
        existingApp.incRefCount(_serverAppConfig.releaseOnDeref);
        return existingApp;
    }
    const container = new (0, $90e6a618aa3f286c$export$436a80eea5d5c0c5)(nameString);
    for (const component of $48fcf96884780cca$export$9566bce3835c0f28.values())container.addComponent(component);
    const newApp = new $48fcf96884780cca$var$FirebaseServerAppImpl(appOptions, _serverAppConfig, nameString, container);
    $48fcf96884780cca$export$fb03ad8d3d5c5f76.set(nameString, newApp);
    return newApp;
}
/**
 * Retrieves a {@link @firebase/app#FirebaseApp} instance.
 *
 * When called with no arguments, the default app is returned. When an app name
 * is provided, the app corresponding to that name is returned.
 *
 * An exception is thrown if the app being retrieved has not yet been
 * initialized.
 *
 * @example
 * ```javascript
 * // Return the default app
 * const app = getApp();
 * ```
 *
 * @example
 * ```javascript
 * // Return a named app
 * const otherApp = getApp("otherApp");
 * ```
 *
 * @param name - Optional name of the app to return. If no name is
 *   provided, the default is `"[DEFAULT]"`.
 *
 * @returns The app corresponding to the provided app name.
 *   If no app name is provided, the default app is returned.
 *
 * @public
 */ function $48fcf96884780cca$export$f9962582c9e66d99(name = $48fcf96884780cca$export$9f30fa0c10967f7f) {
    const app = $48fcf96884780cca$export$b4e3c36c855b14b5.get(name);
    if (!app && name === $48fcf96884780cca$export$9f30fa0c10967f7f && (0, $156de25e040d63b6$export$3dfb6827a9f89756)()) return $48fcf96884780cca$export$c55cfd413944906d();
    if (!app) throw $48fcf96884780cca$var$ERROR_FACTORY.create("no-app" /* AppError.NO_APP */ , {
        appName: name
    });
    return app;
}
/**
 * A (read-only) array of all initialized apps.
 * @public
 */ function $48fcf96884780cca$export$68ddedf7d44b3bdf() {
    return Array.from($48fcf96884780cca$export$b4e3c36c855b14b5.values());
}
/**
 * Renders this app unusable and frees the resources of all associated
 * services.
 *
 * @example
 * ```javascript
 * deleteApp(app)
 *   .then(function() {
 *     console.log("App deleted successfully");
 *   })
 *   .catch(function(error) {
 *     console.log("Error deleting app:", error);
 *   });
 * ```
 *
 * @public
 */ async function $48fcf96884780cca$export$6eec44aa53d5ea34(app) {
    let cleanupProviders = false;
    const name = app.name;
    if ($48fcf96884780cca$export$b4e3c36c855b14b5.has(name)) {
        cleanupProviders = true;
        $48fcf96884780cca$export$b4e3c36c855b14b5.delete(name);
    } else if ($48fcf96884780cca$export$fb03ad8d3d5c5f76.has(name)) {
        const firebaseServerApp = app;
        if (firebaseServerApp.decRefCount() <= 0) {
            $48fcf96884780cca$export$fb03ad8d3d5c5f76.delete(name);
            cleanupProviders = true;
        }
    }
    if (cleanupProviders) {
        await Promise.all(app.container.getProviders().map((provider)=>provider.delete()));
        app.isDeleted = true;
    }
}
/**
 * Registers a library's name and version for platform logging purposes.
 * @param library - Name of 1p or 3p library (e.g. firestore, angularfire)
 * @param version - Current version of that library.
 * @param variant - Bundle variant, e.g., node, rn, etc.
 *
 * @public
 */ function $48fcf96884780cca$export$d29d5299a7137abc(libraryKeyOrName, version, variant) {
    var _a;
    // TODO: We can use this check to whitelist strings when/if we set up
    // a good whitelist system.
    let library = (_a = $48fcf96884780cca$var$PLATFORM_LOG_STRING[libraryKeyOrName]) !== null && _a !== void 0 ? _a : libraryKeyOrName;
    if (variant) library += `-${variant}`;
    const libraryMismatch = library.match(/\s|\//);
    const versionMismatch = version.match(/\s|\//);
    if (libraryMismatch || versionMismatch) {
        const warning = [
            `Unable to register library "${library}" with version "${version}":`
        ];
        if (libraryMismatch) warning.push(`library name "${library}" contains illegal characters (whitespace or "/")`);
        if (libraryMismatch && versionMismatch) warning.push('and');
        if (versionMismatch) warning.push(`version name "${version}" contains illegal characters (whitespace or "/")`);
        $48fcf96884780cca$var$logger.warn(warning.join(' '));
        return;
    }
    $48fcf96884780cca$export$c930050e7bb63965(new (0, $90e6a618aa3f286c$export$16fa2f45be04daa8)(`${library}-version`, ()=>({
            library: library,
            version: version
        }), "VERSION" /* ComponentType.VERSION */ ));
}
/**
 * Sets log handler for all Firebase SDKs.
 * @param logCallback - An optional custom log handler that executes user code whenever
 * the Firebase SDK makes a logging call.
 *
 * @public
 */ function $48fcf96884780cca$export$a82ad227dc8163dc(logCallback, options) {
    if (logCallback !== null && typeof logCallback !== 'function') throw $48fcf96884780cca$var$ERROR_FACTORY.create("invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ );
    (0, $65bf8d3396e16cb5$export$29577d29c84db5f6)(logCallback, options);
}
/**
 * Sets log level for all Firebase SDKs.
 *
 * All of the log types above the current log level are captured (i.e. if
 * you set the log level to `info`, errors are logged, but `debug` and
 * `verbose` logs are not).
 *
 * @public
 */ function $48fcf96884780cca$export$c622e99c0ce7b1c9(logLevel) {
    (0, $65bf8d3396e16cb5$export$c622e99c0ce7b1c9)(logLevel);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $48fcf96884780cca$var$DB_NAME = 'firebase-heartbeat-database';
const $48fcf96884780cca$var$DB_VERSION = 1;
const $48fcf96884780cca$var$STORE_NAME = 'firebase-heartbeat-store';
let $48fcf96884780cca$var$dbPromise = null;
function $48fcf96884780cca$var$getDbPromise() {
    if (!$48fcf96884780cca$var$dbPromise) $48fcf96884780cca$var$dbPromise = (0, $df013b049e1dc2b4$export$ca0ed41b1a2af7e)($48fcf96884780cca$var$DB_NAME, $48fcf96884780cca$var$DB_VERSION, {
        upgrade: (db, oldVersion)=>{
            // We don't use 'break' in this switch statement, the fall-through
            // behavior is what we want, because if there are multiple versions between
            // the old version and the current version, we want ALL the migrations
            // that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch(oldVersion){
                case 0:
                    try {
                        db.createObjectStore($48fcf96884780cca$var$STORE_NAME);
                    } catch (e) {
                        // Safari/iOS browsers throw occasional exceptions on
                        // db.createObjectStore() that may be a bug. Avoid blocking
                        // the rest of the app functionality.
                        console.warn(e);
                    }
            }
        }
    }).catch((e)=>{
        throw $48fcf96884780cca$var$ERROR_FACTORY.create("idb-open" /* AppError.IDB_OPEN */ , {
            originalErrorMessage: e.message
        });
    });
    return $48fcf96884780cca$var$dbPromise;
}
async function $48fcf96884780cca$var$readHeartbeatsFromIndexedDB(app) {
    try {
        const db = await $48fcf96884780cca$var$getDbPromise();
        const tx = db.transaction($48fcf96884780cca$var$STORE_NAME);
        const result = await tx.objectStore($48fcf96884780cca$var$STORE_NAME).get($48fcf96884780cca$var$computeKey(app));
        // We already have the value but tx.done can throw,
        // so we need to await it here to catch errors
        await tx.done;
        return result;
    } catch (e) {
        if (e instanceof (0, $156de25e040d63b6$export$dd24e9cd51226c56)) $48fcf96884780cca$var$logger.warn(e.message);
        else {
            const idbGetError = $48fcf96884780cca$var$ERROR_FACTORY.create("idb-get" /* AppError.IDB_GET */ , {
                originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
            });
            $48fcf96884780cca$var$logger.warn(idbGetError.message);
        }
    }
}
async function $48fcf96884780cca$var$writeHeartbeatsToIndexedDB(app, heartbeatObject) {
    try {
        const db = await $48fcf96884780cca$var$getDbPromise();
        const tx = db.transaction($48fcf96884780cca$var$STORE_NAME, 'readwrite');
        const objectStore = tx.objectStore($48fcf96884780cca$var$STORE_NAME);
        await objectStore.put(heartbeatObject, $48fcf96884780cca$var$computeKey(app));
        await tx.done;
    } catch (e) {
        if (e instanceof (0, $156de25e040d63b6$export$dd24e9cd51226c56)) $48fcf96884780cca$var$logger.warn(e.message);
        else {
            const idbGetError = $48fcf96884780cca$var$ERROR_FACTORY.create("idb-set" /* AppError.IDB_WRITE */ , {
                originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
            });
            $48fcf96884780cca$var$logger.warn(idbGetError.message);
        }
    }
}
function $48fcf96884780cca$var$computeKey(app) {
    return `${app.name}!${app.options.appId}`;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $48fcf96884780cca$var$MAX_HEADER_BYTES = 1024;
const $48fcf96884780cca$var$MAX_NUM_STORED_HEARTBEATS = 30;
class $48fcf96884780cca$var$HeartbeatServiceImpl {
    constructor(container){
        this.container = container;
        /**
         * In-memory cache for heartbeats, used by getHeartbeatsHeader() to generate
         * the header string.
         * Stores one record per date. This will be consolidated into the standard
         * format of one record per user agent string before being sent as a header.
         * Populated from indexedDB when the controller is instantiated and should
         * be kept in sync with indexedDB.
         * Leave public for easier testing.
         */ this._heartbeatsCache = null;
        const app = this.container.getProvider('app').getImmediate();
        this._storage = new $48fcf96884780cca$var$HeartbeatStorageImpl(app);
        this._heartbeatsCachePromise = this._storage.read().then((result)=>{
            this._heartbeatsCache = result;
            return result;
        });
    }
    /**
     * Called to report a heartbeat. The function will generate
     * a HeartbeatsByUserAgent object, update heartbeatsCache, and persist it
     * to IndexedDB.
     * Note that we only store one heartbeat per day. So if a heartbeat for today is
     * already logged, subsequent calls to this function in the same day will be ignored.
     */ async triggerHeartbeat() {
        var _a, _b;
        try {
            const platformLogger = this.container.getProvider('platform-logger').getImmediate();
            // This is the "Firebase user agent" string from the platform logger
            // service, not the browser user agent.
            const agent = platformLogger.getPlatformInfoString();
            const date = $48fcf96884780cca$var$getUTCDateString();
            if (((_a = this._heartbeatsCache) === null || _a === void 0 ? void 0 : _a.heartbeats) == null) {
                this._heartbeatsCache = await this._heartbeatsCachePromise;
                // If we failed to construct a heartbeats cache, then return immediately.
                if (((_b = this._heartbeatsCache) === null || _b === void 0 ? void 0 : _b.heartbeats) == null) return;
            }
            // Do not store a heartbeat if one is already stored for this day
            // or if a header has already been sent today.
            if (this._heartbeatsCache.lastSentHeartbeatDate === date || this._heartbeatsCache.heartbeats.some((singleDateHeartbeat)=>singleDateHeartbeat.date === date)) return;
            else {
                // There is no entry for this date. Create one.
                this._heartbeatsCache.heartbeats.push({
                    date: date,
                    agent: agent
                });
                // If the number of stored heartbeats exceeds the maximum number of stored heartbeats, remove the heartbeat with the earliest date.
                // Since this is executed each time a heartbeat is pushed, the limit can only be exceeded by one, so only one needs to be removed.
                if (this._heartbeatsCache.heartbeats.length > $48fcf96884780cca$var$MAX_NUM_STORED_HEARTBEATS) {
                    const earliestHeartbeatIdx = $48fcf96884780cca$var$getEarliestHeartbeatIdx(this._heartbeatsCache.heartbeats);
                    this._heartbeatsCache.heartbeats.splice(earliestHeartbeatIdx, 1);
                }
            }
            return this._storage.overwrite(this._heartbeatsCache);
        } catch (e) {
            $48fcf96884780cca$var$logger.warn(e);
        }
    }
    /**
     * Returns a base64 encoded string which can be attached to the heartbeat-specific header directly.
     * It also clears all heartbeats from memory as well as in IndexedDB.
     *
     * NOTE: Consuming product SDKs should not send the header if this method
     * returns an empty string.
     */ async getHeartbeatsHeader() {
        var _a;
        try {
            if (this._heartbeatsCache === null) await this._heartbeatsCachePromise;
            // If it's still null or the array is empty, there is no data to send.
            if (((_a = this._heartbeatsCache) === null || _a === void 0 ? void 0 : _a.heartbeats) == null || this._heartbeatsCache.heartbeats.length === 0) return '';
            const date = $48fcf96884780cca$var$getUTCDateString();
            // Extract as many heartbeats from the cache as will fit under the size limit.
            const { heartbeatsToSend: heartbeatsToSend, unsentEntries: unsentEntries } = $48fcf96884780cca$var$extractHeartbeatsForHeader(this._heartbeatsCache.heartbeats);
            const headerString = (0, $156de25e040d63b6$export$4b5284a3025a455)(JSON.stringify({
                version: 2,
                heartbeats: heartbeatsToSend
            }));
            // Store last sent date to prevent another being logged/sent for the same day.
            this._heartbeatsCache.lastSentHeartbeatDate = date;
            if (unsentEntries.length > 0) {
                // Store any unsent entries if they exist.
                this._heartbeatsCache.heartbeats = unsentEntries;
                // This seems more likely than emptying the array (below) to lead to some odd state
                // since the cache isn't empty and this will be called again on the next request,
                // and is probably safest if we await it.
                await this._storage.overwrite(this._heartbeatsCache);
            } else {
                this._heartbeatsCache.heartbeats = [];
                // Do not wait for this, to reduce latency.
                this._storage.overwrite(this._heartbeatsCache);
            }
            return headerString;
        } catch (e) {
            $48fcf96884780cca$var$logger.warn(e);
            return '';
        }
    }
}
function $48fcf96884780cca$var$getUTCDateString() {
    const today = new Date();
    // Returns date format 'YYYY-MM-DD'
    return today.toISOString().substring(0, 10);
}
function $48fcf96884780cca$var$extractHeartbeatsForHeader(heartbeatsCache, maxSize = $48fcf96884780cca$var$MAX_HEADER_BYTES) {
    // Heartbeats grouped by user agent in the standard format to be sent in
    // the header.
    const heartbeatsToSend = [];
    // Single date format heartbeats that are not sent.
    let unsentEntries = heartbeatsCache.slice();
    for (const singleDateHeartbeat of heartbeatsCache){
        // Look for an existing entry with the same user agent.
        const heartbeatEntry = heartbeatsToSend.find((hb)=>hb.agent === singleDateHeartbeat.agent);
        if (!heartbeatEntry) {
            // If no entry for this user agent exists, create one.
            heartbeatsToSend.push({
                agent: singleDateHeartbeat.agent,
                dates: [
                    singleDateHeartbeat.date
                ]
            });
            if ($48fcf96884780cca$var$countBytes(heartbeatsToSend) > maxSize) {
                // If the header would exceed max size, remove the added heartbeat
                // entry and stop adding to the header.
                heartbeatsToSend.pop();
                break;
            }
        } else {
            heartbeatEntry.dates.push(singleDateHeartbeat.date);
            // If the header would exceed max size, remove the added date
            // and stop adding to the header.
            if ($48fcf96884780cca$var$countBytes(heartbeatsToSend) > maxSize) {
                heartbeatEntry.dates.pop();
                break;
            }
        }
        // Pop unsent entry from queue. (Skipped if adding the entry exceeded
        // quota and the loop breaks early.)
        unsentEntries = unsentEntries.slice(1);
    }
    return {
        heartbeatsToSend: heartbeatsToSend,
        unsentEntries: unsentEntries
    };
}
class $48fcf96884780cca$var$HeartbeatStorageImpl {
    constructor(app){
        this.app = app;
        this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck();
    }
    async runIndexedDBEnvironmentCheck() {
        if (!(0, $156de25e040d63b6$export$3865db50535c2055)()) return false;
        else return (0, $156de25e040d63b6$export$a8a3018f3d187a4d)().then(()=>true).catch(()=>false);
    }
    /**
     * Read all heartbeats.
     */ async read() {
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return {
            heartbeats: []
        };
        else {
            const idbHeartbeatObject = await $48fcf96884780cca$var$readHeartbeatsFromIndexedDB(this.app);
            if (idbHeartbeatObject === null || idbHeartbeatObject === void 0 ? void 0 : idbHeartbeatObject.heartbeats) return idbHeartbeatObject;
            else return {
                heartbeats: []
            };
        }
    }
    // overwrite the storage with the provided heartbeats
    async overwrite(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return $48fcf96884780cca$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: heartbeatsObject.heartbeats
            });
        }
    }
    // add heartbeats
    async add(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return $48fcf96884780cca$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: [
                    ...existingHeartbeatsObject.heartbeats,
                    ...heartbeatsObject.heartbeats
                ]
            });
        }
    }
}
/**
 * Calculate bytes of a HeartbeatsByUserAgent array after being wrapped
 * in a platform logging header JSON object, stringified, and converted
 * to base 64.
 */ function $48fcf96884780cca$var$countBytes(heartbeatsCache) {
    // base64 has a restricted set of characters, all of which should be 1 byte.
    return (0, $156de25e040d63b6$export$4b5284a3025a455)(// heartbeatsCache wrapper properties
    JSON.stringify({
        version: 2,
        heartbeats: heartbeatsCache
    })).length;
}
/**
 * Returns the index of the heartbeat with the earliest date.
 * If the heartbeats array is empty, -1 is returned.
 */ function $48fcf96884780cca$var$getEarliestHeartbeatIdx(heartbeats) {
    if (heartbeats.length === 0) return -1;
    let earliestHeartbeatIdx = 0;
    let earliestHeartbeatDate = heartbeats[0].date;
    for(let i = 1; i < heartbeats.length; i++)if (heartbeats[i].date < earliestHeartbeatDate) {
        earliestHeartbeatDate = heartbeats[i].date;
        earliestHeartbeatIdx = i;
    }
    return earliestHeartbeatIdx;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $48fcf96884780cca$var$registerCoreComponents(variant) {
    $48fcf96884780cca$export$c930050e7bb63965(new (0, $90e6a618aa3f286c$export$16fa2f45be04daa8)('platform-logger', (container)=>new $48fcf96884780cca$var$PlatformLoggerServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    $48fcf96884780cca$export$c930050e7bb63965(new (0, $90e6a618aa3f286c$export$16fa2f45be04daa8)('heartbeat', (container)=>new $48fcf96884780cca$var$HeartbeatServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    // Register `app` package.
    $48fcf96884780cca$export$d29d5299a7137abc($48fcf96884780cca$var$name$q, $48fcf96884780cca$var$version$1, variant);
    // BUILD_TARGET will be replaced by values like esm2017, cjs2017, etc during the compilation
    $48fcf96884780cca$export$d29d5299a7137abc($48fcf96884780cca$var$name$q, $48fcf96884780cca$var$version$1, 'esm2017');
    // Register platform SDK identifier (no version).
    $48fcf96884780cca$export$d29d5299a7137abc('fire-js', '');
}
/**
 * Firebase App
 *
 * @remarks This package coordinates the communication between the different Firebase components
 * @packageDocumentation
 */ $48fcf96884780cca$var$registerCoreComponents('');


var $9065237aa7e09818$var$name = "firebase";
var $9065237aa7e09818$var$version = "11.10.0";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $48fcf96884780cca$export$d29d5299a7137abc)($9065237aa7e09818$var$name, $9065237aa7e09818$var$version, 'app');










const $400b78d2aed30a3c$var$name = "@firebase/installations";
const $400b78d2aed30a3c$var$version = "0.6.18";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $400b78d2aed30a3c$var$PENDING_TIMEOUT_MS = 10000;
const $400b78d2aed30a3c$var$PACKAGE_VERSION = `w:${$400b78d2aed30a3c$var$version}`;
const $400b78d2aed30a3c$var$INTERNAL_AUTH_VERSION = 'FIS_v2';
const $400b78d2aed30a3c$var$INSTALLATIONS_API_URL = 'https://firebaseinstallations.googleapis.com/v1';
const $400b78d2aed30a3c$var$TOKEN_EXPIRATION_BUFFER = 3600000; // One hour
const $400b78d2aed30a3c$var$SERVICE = 'installations';
const $400b78d2aed30a3c$var$SERVICE_NAME = 'Installations';
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $400b78d2aed30a3c$var$ERROR_DESCRIPTION_MAP = {
    ["missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */ ]: 'Missing App configuration value: "{$valueName}"',
    ["not-registered" /* ErrorCode.NOT_REGISTERED */ ]: 'Firebase Installation is not registered.',
    ["installation-not-found" /* ErrorCode.INSTALLATION_NOT_FOUND */ ]: 'Firebase Installation not found.',
    ["request-failed" /* ErrorCode.REQUEST_FAILED */ ]: '{$requestName} request failed with error "{$serverCode} {$serverStatus}: {$serverMessage}"',
    ["app-offline" /* ErrorCode.APP_OFFLINE */ ]: 'Could not process request. Application offline.',
    ["delete-pending-registration" /* ErrorCode.DELETE_PENDING_REGISTRATION */ ]: "Can't delete installation while there is a pending registration request."
};
const $400b78d2aed30a3c$var$ERROR_FACTORY = new (0, $156de25e040d63b6$export$3fa6e1b18a3b2d40)($400b78d2aed30a3c$var$SERVICE, $400b78d2aed30a3c$var$SERVICE_NAME, $400b78d2aed30a3c$var$ERROR_DESCRIPTION_MAP);
/** Returns true if error is a FirebaseError that is based on an error from the server. */ function $400b78d2aed30a3c$var$isServerError(error) {
    return error instanceof (0, $156de25e040d63b6$export$dd24e9cd51226c56) && error.code.includes("request-failed" /* ErrorCode.REQUEST_FAILED */ );
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $400b78d2aed30a3c$var$getInstallationsEndpoint({ projectId: projectId }) {
    return `${$400b78d2aed30a3c$var$INSTALLATIONS_API_URL}/projects/${projectId}/installations`;
}
function $400b78d2aed30a3c$var$extractAuthTokenInfoFromResponse(response) {
    return {
        token: response.token,
        requestStatus: 2 /* RequestStatus.COMPLETED */ ,
        expiresIn: $400b78d2aed30a3c$var$getExpiresInFromResponseExpiresIn(response.expiresIn),
        creationTime: Date.now()
    };
}
async function $400b78d2aed30a3c$var$getErrorFromResponse(requestName, response) {
    const responseJson = await response.json();
    const errorData = responseJson.error;
    return $400b78d2aed30a3c$var$ERROR_FACTORY.create("request-failed" /* ErrorCode.REQUEST_FAILED */ , {
        requestName: requestName,
        serverCode: errorData.code,
        serverMessage: errorData.message,
        serverStatus: errorData.status
    });
}
function $400b78d2aed30a3c$var$getHeaders({ apiKey: apiKey }) {
    return new Headers({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'x-goog-api-key': apiKey
    });
}
function $400b78d2aed30a3c$var$getHeadersWithAuth(appConfig, { refreshToken: refreshToken }) {
    const headers = $400b78d2aed30a3c$var$getHeaders(appConfig);
    headers.append('Authorization', $400b78d2aed30a3c$var$getAuthorizationHeader(refreshToken));
    return headers;
}
/**
 * Calls the passed in fetch wrapper and returns the response.
 * If the returned response has a status of 5xx, re-runs the function once and
 * returns the response.
 */ async function $400b78d2aed30a3c$var$retryIfServerError(fn) {
    const result = await fn();
    if (result.status >= 500 && result.status < 600) // Internal Server Error. Retry request.
    return fn();
    return result;
}
function $400b78d2aed30a3c$var$getExpiresInFromResponseExpiresIn(responseExpiresIn) {
    // This works because the server will never respond with fractions of a second.
    return Number(responseExpiresIn.replace('s', '000'));
}
function $400b78d2aed30a3c$var$getAuthorizationHeader(refreshToken) {
    return `${$400b78d2aed30a3c$var$INTERNAL_AUTH_VERSION} ${refreshToken}`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $400b78d2aed30a3c$var$createInstallationRequest({ appConfig: appConfig, heartbeatServiceProvider: heartbeatServiceProvider }, { fid: fid }) {
    const endpoint = $400b78d2aed30a3c$var$getInstallationsEndpoint(appConfig);
    const headers = $400b78d2aed30a3c$var$getHeaders(appConfig);
    // If heartbeat service exists, add the heartbeat string to the header.
    const heartbeatService = heartbeatServiceProvider.getImmediate({
        optional: true
    });
    if (heartbeatService) {
        const heartbeatsHeader = await heartbeatService.getHeartbeatsHeader();
        if (heartbeatsHeader) headers.append('x-firebase-client', heartbeatsHeader);
    }
    const body = {
        fid: fid,
        authVersion: $400b78d2aed30a3c$var$INTERNAL_AUTH_VERSION,
        appId: appConfig.appId,
        sdkVersion: $400b78d2aed30a3c$var$PACKAGE_VERSION
    };
    const request = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(body)
    };
    const response = await $400b78d2aed30a3c$var$retryIfServerError(()=>fetch(endpoint, request));
    if (response.ok) {
        const responseValue = await response.json();
        const registeredInstallationEntry = {
            fid: responseValue.fid || fid,
            registrationStatus: 2 /* RequestStatus.COMPLETED */ ,
            refreshToken: responseValue.refreshToken,
            authToken: $400b78d2aed30a3c$var$extractAuthTokenInfoFromResponse(responseValue.authToken)
        };
        return registeredInstallationEntry;
    } else throw await $400b78d2aed30a3c$var$getErrorFromResponse('Create Installation', response);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Returns a promise that resolves after given time passes. */ function $400b78d2aed30a3c$var$sleep(ms) {
    return new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $400b78d2aed30a3c$var$bufferToBase64UrlSafe(array) {
    const b64 = btoa(String.fromCharCode(...array));
    return b64.replace(/\+/g, '-').replace(/\//g, '_');
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $400b78d2aed30a3c$var$VALID_FID_PATTERN = /^[cdef][\w-]{21}$/;
const $400b78d2aed30a3c$var$INVALID_FID = '';
/**
 * Generates a new FID using random values from Web Crypto API.
 * Returns an empty string if FID generation fails for any reason.
 */ function $400b78d2aed30a3c$var$generateFid() {
    try {
        // A valid FID has exactly 22 base64 characters, which is 132 bits, or 16.5
        // bytes. our implementation generates a 17 byte array instead.
        const fidByteArray = new Uint8Array(17);
        const crypto = self.crypto || self.msCrypto;
        crypto.getRandomValues(fidByteArray);
        // Replace the first 4 random bits with the constant FID header of 0b0111.
        fidByteArray[0] = 112 + fidByteArray[0] % 16;
        const fid = $400b78d2aed30a3c$var$encode(fidByteArray);
        return $400b78d2aed30a3c$var$VALID_FID_PATTERN.test(fid) ? fid : $400b78d2aed30a3c$var$INVALID_FID;
    } catch (_a) {
        // FID generation errored
        return $400b78d2aed30a3c$var$INVALID_FID;
    }
}
/** Converts a FID Uint8Array to a base64 string representation. */ function $400b78d2aed30a3c$var$encode(fidByteArray) {
    const b64String = $400b78d2aed30a3c$var$bufferToBase64UrlSafe(fidByteArray);
    // Remove the 23rd character that was added because of the extra 4 bits at the
    // end of our 17 byte array, and the '=' padding.
    return b64String.substr(0, 22);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Returns a string key that can be used to identify the app. */ function $400b78d2aed30a3c$var$getKey(appConfig) {
    return `${appConfig.appName}!${appConfig.appId}`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $400b78d2aed30a3c$var$fidChangeCallbacks = new Map();
/**
 * Calls the onIdChange callbacks with the new FID value, and broadcasts the
 * change to other tabs.
 */ function $400b78d2aed30a3c$var$fidChanged(appConfig, fid) {
    const key = $400b78d2aed30a3c$var$getKey(appConfig);
    $400b78d2aed30a3c$var$callFidChangeCallbacks(key, fid);
    $400b78d2aed30a3c$var$broadcastFidChange(key, fid);
}
function $400b78d2aed30a3c$var$addCallback(appConfig, callback) {
    // Open the broadcast channel if it's not already open,
    // to be able to listen to change events from other tabs.
    $400b78d2aed30a3c$var$getBroadcastChannel();
    const key = $400b78d2aed30a3c$var$getKey(appConfig);
    let callbackSet = $400b78d2aed30a3c$var$fidChangeCallbacks.get(key);
    if (!callbackSet) {
        callbackSet = new Set();
        $400b78d2aed30a3c$var$fidChangeCallbacks.set(key, callbackSet);
    }
    callbackSet.add(callback);
}
function $400b78d2aed30a3c$var$removeCallback(appConfig, callback) {
    const key = $400b78d2aed30a3c$var$getKey(appConfig);
    const callbackSet = $400b78d2aed30a3c$var$fidChangeCallbacks.get(key);
    if (!callbackSet) return;
    callbackSet.delete(callback);
    if (callbackSet.size === 0) $400b78d2aed30a3c$var$fidChangeCallbacks.delete(key);
    // Close broadcast channel if there are no more callbacks.
    $400b78d2aed30a3c$var$closeBroadcastChannel();
}
function $400b78d2aed30a3c$var$callFidChangeCallbacks(key, fid) {
    const callbacks = $400b78d2aed30a3c$var$fidChangeCallbacks.get(key);
    if (!callbacks) return;
    for (const callback of callbacks)callback(fid);
}
function $400b78d2aed30a3c$var$broadcastFidChange(key, fid) {
    const channel = $400b78d2aed30a3c$var$getBroadcastChannel();
    if (channel) channel.postMessage({
        key: key,
        fid: fid
    });
    $400b78d2aed30a3c$var$closeBroadcastChannel();
}
let $400b78d2aed30a3c$var$broadcastChannel = null;
/** Opens and returns a BroadcastChannel if it is supported by the browser. */ function $400b78d2aed30a3c$var$getBroadcastChannel() {
    if (!$400b78d2aed30a3c$var$broadcastChannel && 'BroadcastChannel' in self) {
        $400b78d2aed30a3c$var$broadcastChannel = new BroadcastChannel('[Firebase] FID Change');
        $400b78d2aed30a3c$var$broadcastChannel.onmessage = (e)=>{
            $400b78d2aed30a3c$var$callFidChangeCallbacks(e.data.key, e.data.fid);
        };
    }
    return $400b78d2aed30a3c$var$broadcastChannel;
}
function $400b78d2aed30a3c$var$closeBroadcastChannel() {
    if ($400b78d2aed30a3c$var$fidChangeCallbacks.size === 0 && $400b78d2aed30a3c$var$broadcastChannel) {
        $400b78d2aed30a3c$var$broadcastChannel.close();
        $400b78d2aed30a3c$var$broadcastChannel = null;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $400b78d2aed30a3c$var$DATABASE_NAME = 'firebase-installations-database';
const $400b78d2aed30a3c$var$DATABASE_VERSION = 1;
const $400b78d2aed30a3c$var$OBJECT_STORE_NAME = 'firebase-installations-store';
let $400b78d2aed30a3c$var$dbPromise = null;
function $400b78d2aed30a3c$var$getDbPromise() {
    if (!$400b78d2aed30a3c$var$dbPromise) $400b78d2aed30a3c$var$dbPromise = (0, $df013b049e1dc2b4$export$ca0ed41b1a2af7e)($400b78d2aed30a3c$var$DATABASE_NAME, $400b78d2aed30a3c$var$DATABASE_VERSION, {
        upgrade: (db, oldVersion)=>{
            // We don't use 'break' in this switch statement, the fall-through
            // behavior is what we want, because if there are multiple versions between
            // the old version and the current version, we want ALL the migrations
            // that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch(oldVersion){
                case 0:
                    db.createObjectStore($400b78d2aed30a3c$var$OBJECT_STORE_NAME);
            }
        }
    });
    return $400b78d2aed30a3c$var$dbPromise;
}
/** Assigns or overwrites the record for the given key with the given value. */ async function $400b78d2aed30a3c$var$set(appConfig, value) {
    const key = $400b78d2aed30a3c$var$getKey(appConfig);
    const db = await $400b78d2aed30a3c$var$getDbPromise();
    const tx = db.transaction($400b78d2aed30a3c$var$OBJECT_STORE_NAME, 'readwrite');
    const objectStore = tx.objectStore($400b78d2aed30a3c$var$OBJECT_STORE_NAME);
    const oldValue = await objectStore.get(key);
    await objectStore.put(value, key);
    await tx.done;
    if (!oldValue || oldValue.fid !== value.fid) $400b78d2aed30a3c$var$fidChanged(appConfig, value.fid);
    return value;
}
/** Removes record(s) from the objectStore that match the given key. */ async function $400b78d2aed30a3c$var$remove(appConfig) {
    const key = $400b78d2aed30a3c$var$getKey(appConfig);
    const db = await $400b78d2aed30a3c$var$getDbPromise();
    const tx = db.transaction($400b78d2aed30a3c$var$OBJECT_STORE_NAME, 'readwrite');
    await tx.objectStore($400b78d2aed30a3c$var$OBJECT_STORE_NAME).delete(key);
    await tx.done;
}
/**
 * Atomically updates a record with the result of updateFn, which gets
 * called with the current value. If newValue is undefined, the record is
 * deleted instead.
 * @return Updated value
 */ async function $400b78d2aed30a3c$var$update(appConfig, updateFn) {
    const key = $400b78d2aed30a3c$var$getKey(appConfig);
    const db = await $400b78d2aed30a3c$var$getDbPromise();
    const tx = db.transaction($400b78d2aed30a3c$var$OBJECT_STORE_NAME, 'readwrite');
    const store = tx.objectStore($400b78d2aed30a3c$var$OBJECT_STORE_NAME);
    const oldValue = await store.get(key);
    const newValue = updateFn(oldValue);
    if (newValue === undefined) await store.delete(key);
    else await store.put(newValue, key);
    await tx.done;
    if (newValue && (!oldValue || oldValue.fid !== newValue.fid)) $400b78d2aed30a3c$var$fidChanged(appConfig, newValue.fid);
    return newValue;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates and returns the InstallationEntry from the database.
 * Also triggers a registration request if it is necessary and possible.
 */ async function $400b78d2aed30a3c$var$getInstallationEntry(installations) {
    let registrationPromise;
    const installationEntry = await $400b78d2aed30a3c$var$update(installations.appConfig, (oldEntry)=>{
        const installationEntry = $400b78d2aed30a3c$var$updateOrCreateInstallationEntry(oldEntry);
        const entryWithPromise = $400b78d2aed30a3c$var$triggerRegistrationIfNecessary(installations, installationEntry);
        registrationPromise = entryWithPromise.registrationPromise;
        return entryWithPromise.installationEntry;
    });
    if (installationEntry.fid === $400b78d2aed30a3c$var$INVALID_FID) // FID generation failed. Waiting for the FID from the server.
    return {
        installationEntry: await registrationPromise
    };
    return {
        installationEntry: installationEntry,
        registrationPromise: registrationPromise
    };
}
/**
 * Creates a new Installation Entry if one does not exist.
 * Also clears timed out pending requests.
 */ function $400b78d2aed30a3c$var$updateOrCreateInstallationEntry(oldEntry) {
    const entry = oldEntry || {
        fid: $400b78d2aed30a3c$var$generateFid(),
        registrationStatus: 0 /* RequestStatus.NOT_STARTED */ 
    };
    return $400b78d2aed30a3c$var$clearTimedOutRequest(entry);
}
/**
 * If the Firebase Installation is not registered yet, this will trigger the
 * registration and return an InProgressInstallationEntry.
 *
 * If registrationPromise does not exist, the installationEntry is guaranteed
 * to be registered.
 */ function $400b78d2aed30a3c$var$triggerRegistrationIfNecessary(installations, installationEntry) {
    if (installationEntry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */ ) {
        if (!navigator.onLine) {
            // Registration required but app is offline.
            const registrationPromiseWithError = Promise.reject($400b78d2aed30a3c$var$ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */ ));
            return {
                installationEntry: installationEntry,
                registrationPromise: registrationPromiseWithError
            };
        }
        // Try registering. Change status to IN_PROGRESS.
        const inProgressEntry = {
            fid: installationEntry.fid,
            registrationStatus: 1 /* RequestStatus.IN_PROGRESS */ ,
            registrationTime: Date.now()
        };
        const registrationPromise = $400b78d2aed30a3c$var$registerInstallation(installations, inProgressEntry);
        return {
            installationEntry: inProgressEntry,
            registrationPromise: registrationPromise
        };
    } else if (installationEntry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */ ) return {
        installationEntry: installationEntry,
        registrationPromise: $400b78d2aed30a3c$var$waitUntilFidRegistration(installations)
    };
    else return {
        installationEntry: installationEntry
    };
}
/** This will be executed only once for each new Firebase Installation. */ async function $400b78d2aed30a3c$var$registerInstallation(installations, installationEntry) {
    try {
        const registeredInstallationEntry = await $400b78d2aed30a3c$var$createInstallationRequest(installations, installationEntry);
        return $400b78d2aed30a3c$var$set(installations.appConfig, registeredInstallationEntry);
    } catch (e) {
        if ($400b78d2aed30a3c$var$isServerError(e) && e.customData.serverCode === 409) // Server returned a "FID cannot be used" error.
        // Generate a new ID next time.
        await $400b78d2aed30a3c$var$remove(installations.appConfig);
        else // Registration failed. Set FID as not registered.
        await $400b78d2aed30a3c$var$set(installations.appConfig, {
            fid: installationEntry.fid,
            registrationStatus: 0 /* RequestStatus.NOT_STARTED */ 
        });
        throw e;
    }
}
/** Call if FID registration is pending in another request. */ async function $400b78d2aed30a3c$var$waitUntilFidRegistration(installations) {
    // Unfortunately, there is no way of reliably observing when a value in
    // IndexedDB changes (yet, see https://github.com/WICG/indexed-db-observers),
    // so we need to poll.
    let entry = await $400b78d2aed30a3c$var$updateInstallationRequest(installations.appConfig);
    while(entry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */ ){
        // createInstallation request still in progress.
        await $400b78d2aed30a3c$var$sleep(100);
        entry = await $400b78d2aed30a3c$var$updateInstallationRequest(installations.appConfig);
    }
    if (entry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */ ) {
        // The request timed out or failed in a different call. Try again.
        const { installationEntry: installationEntry, registrationPromise: registrationPromise } = await $400b78d2aed30a3c$var$getInstallationEntry(installations);
        if (registrationPromise) return registrationPromise;
        else // if there is no registrationPromise, entry is registered.
        return installationEntry;
    }
    return entry;
}
/**
 * Called only if there is a CreateInstallation request in progress.
 *
 * Updates the InstallationEntry in the DB based on the status of the
 * CreateInstallation request.
 *
 * Returns the updated InstallationEntry.
 */ function $400b78d2aed30a3c$var$updateInstallationRequest(appConfig) {
    return $400b78d2aed30a3c$var$update(appConfig, (oldEntry)=>{
        if (!oldEntry) throw $400b78d2aed30a3c$var$ERROR_FACTORY.create("installation-not-found" /* ErrorCode.INSTALLATION_NOT_FOUND */ );
        return $400b78d2aed30a3c$var$clearTimedOutRequest(oldEntry);
    });
}
function $400b78d2aed30a3c$var$clearTimedOutRequest(entry) {
    if ($400b78d2aed30a3c$var$hasInstallationRequestTimedOut(entry)) return {
        fid: entry.fid,
        registrationStatus: 0 /* RequestStatus.NOT_STARTED */ 
    };
    return entry;
}
function $400b78d2aed30a3c$var$hasInstallationRequestTimedOut(installationEntry) {
    return installationEntry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */  && installationEntry.registrationTime + $400b78d2aed30a3c$var$PENDING_TIMEOUT_MS < Date.now();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $400b78d2aed30a3c$var$generateAuthTokenRequest({ appConfig: appConfig, heartbeatServiceProvider: heartbeatServiceProvider }, installationEntry) {
    const endpoint = $400b78d2aed30a3c$var$getGenerateAuthTokenEndpoint(appConfig, installationEntry);
    const headers = $400b78d2aed30a3c$var$getHeadersWithAuth(appConfig, installationEntry);
    // If heartbeat service exists, add the heartbeat string to the header.
    const heartbeatService = heartbeatServiceProvider.getImmediate({
        optional: true
    });
    if (heartbeatService) {
        const heartbeatsHeader = await heartbeatService.getHeartbeatsHeader();
        if (heartbeatsHeader) headers.append('x-firebase-client', heartbeatsHeader);
    }
    const body = {
        installation: {
            sdkVersion: $400b78d2aed30a3c$var$PACKAGE_VERSION,
            appId: appConfig.appId
        }
    };
    const request = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(body)
    };
    const response = await $400b78d2aed30a3c$var$retryIfServerError(()=>fetch(endpoint, request));
    if (response.ok) {
        const responseValue = await response.json();
        const completedAuthToken = $400b78d2aed30a3c$var$extractAuthTokenInfoFromResponse(responseValue);
        return completedAuthToken;
    } else throw await $400b78d2aed30a3c$var$getErrorFromResponse('Generate Auth Token', response);
}
function $400b78d2aed30a3c$var$getGenerateAuthTokenEndpoint(appConfig, { fid: fid }) {
    return `${$400b78d2aed30a3c$var$getInstallationsEndpoint(appConfig)}/${fid}/authTokens:generate`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a valid authentication token for the installation. Generates a new
 * token if one doesn't exist, is expired or about to expire.
 *
 * Should only be called if the Firebase Installation is registered.
 */ async function $400b78d2aed30a3c$var$refreshAuthToken(installations, forceRefresh = false) {
    let tokenPromise;
    const entry = await $400b78d2aed30a3c$var$update(installations.appConfig, (oldEntry)=>{
        if (!$400b78d2aed30a3c$var$isEntryRegistered(oldEntry)) throw $400b78d2aed30a3c$var$ERROR_FACTORY.create("not-registered" /* ErrorCode.NOT_REGISTERED */ );
        const oldAuthToken = oldEntry.authToken;
        if (!forceRefresh && $400b78d2aed30a3c$var$isAuthTokenValid(oldAuthToken)) // There is a valid token in the DB.
        return oldEntry;
        else if (oldAuthToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */ ) {
            // There already is a token request in progress.
            tokenPromise = $400b78d2aed30a3c$var$waitUntilAuthTokenRequest(installations, forceRefresh);
            return oldEntry;
        } else {
            // No token or token expired.
            if (!navigator.onLine) throw $400b78d2aed30a3c$var$ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */ );
            const inProgressEntry = $400b78d2aed30a3c$var$makeAuthTokenRequestInProgressEntry(oldEntry);
            tokenPromise = $400b78d2aed30a3c$var$fetchAuthTokenFromServer(installations, inProgressEntry);
            return inProgressEntry;
        }
    });
    const authToken = tokenPromise ? await tokenPromise : entry.authToken;
    return authToken;
}
/**
 * Call only if FID is registered and Auth Token request is in progress.
 *
 * Waits until the current pending request finishes. If the request times out,
 * tries once in this thread as well.
 */ async function $400b78d2aed30a3c$var$waitUntilAuthTokenRequest(installations, forceRefresh) {
    // Unfortunately, there is no way of reliably observing when a value in
    // IndexedDB changes (yet, see https://github.com/WICG/indexed-db-observers),
    // so we need to poll.
    let entry = await $400b78d2aed30a3c$var$updateAuthTokenRequest(installations.appConfig);
    while(entry.authToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */ ){
        // generateAuthToken still in progress.
        await $400b78d2aed30a3c$var$sleep(100);
        entry = await $400b78d2aed30a3c$var$updateAuthTokenRequest(installations.appConfig);
    }
    const authToken = entry.authToken;
    if (authToken.requestStatus === 0 /* RequestStatus.NOT_STARTED */ ) // The request timed out or failed in a different call. Try again.
    return $400b78d2aed30a3c$var$refreshAuthToken(installations, forceRefresh);
    else return authToken;
}
/**
 * Called only if there is a GenerateAuthToken request in progress.
 *
 * Updates the InstallationEntry in the DB based on the status of the
 * GenerateAuthToken request.
 *
 * Returns the updated InstallationEntry.
 */ function $400b78d2aed30a3c$var$updateAuthTokenRequest(appConfig) {
    return $400b78d2aed30a3c$var$update(appConfig, (oldEntry)=>{
        if (!$400b78d2aed30a3c$var$isEntryRegistered(oldEntry)) throw $400b78d2aed30a3c$var$ERROR_FACTORY.create("not-registered" /* ErrorCode.NOT_REGISTERED */ );
        const oldAuthToken = oldEntry.authToken;
        if ($400b78d2aed30a3c$var$hasAuthTokenRequestTimedOut(oldAuthToken)) return Object.assign(Object.assign({}, oldEntry), {
            authToken: {
                requestStatus: 0 /* RequestStatus.NOT_STARTED */ 
            }
        });
        return oldEntry;
    });
}
async function $400b78d2aed30a3c$var$fetchAuthTokenFromServer(installations, installationEntry) {
    try {
        const authToken = await $400b78d2aed30a3c$var$generateAuthTokenRequest(installations, installationEntry);
        const updatedInstallationEntry = Object.assign(Object.assign({}, installationEntry), {
            authToken: authToken
        });
        await $400b78d2aed30a3c$var$set(installations.appConfig, updatedInstallationEntry);
        return authToken;
    } catch (e) {
        if ($400b78d2aed30a3c$var$isServerError(e) && (e.customData.serverCode === 401 || e.customData.serverCode === 404)) // Server returned a "FID not found" or a "Invalid authentication" error.
        // Generate a new ID next time.
        await $400b78d2aed30a3c$var$remove(installations.appConfig);
        else {
            const updatedInstallationEntry = Object.assign(Object.assign({}, installationEntry), {
                authToken: {
                    requestStatus: 0 /* RequestStatus.NOT_STARTED */ 
                }
            });
            await $400b78d2aed30a3c$var$set(installations.appConfig, updatedInstallationEntry);
        }
        throw e;
    }
}
function $400b78d2aed30a3c$var$isEntryRegistered(installationEntry) {
    return installationEntry !== undefined && installationEntry.registrationStatus === 2 /* RequestStatus.COMPLETED */ ;
}
function $400b78d2aed30a3c$var$isAuthTokenValid(authToken) {
    return authToken.requestStatus === 2 /* RequestStatus.COMPLETED */  && !$400b78d2aed30a3c$var$isAuthTokenExpired(authToken);
}
function $400b78d2aed30a3c$var$isAuthTokenExpired(authToken) {
    const now = Date.now();
    return now < authToken.creationTime || authToken.creationTime + authToken.expiresIn < now + $400b78d2aed30a3c$var$TOKEN_EXPIRATION_BUFFER;
}
/** Returns an updated InstallationEntry with an InProgressAuthToken. */ function $400b78d2aed30a3c$var$makeAuthTokenRequestInProgressEntry(oldEntry) {
    const inProgressAuthToken = {
        requestStatus: 1 /* RequestStatus.IN_PROGRESS */ ,
        requestTime: Date.now()
    };
    return Object.assign(Object.assign({}, oldEntry), {
        authToken: inProgressAuthToken
    });
}
function $400b78d2aed30a3c$var$hasAuthTokenRequestTimedOut(authToken) {
    return authToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */  && authToken.requestTime + $400b78d2aed30a3c$var$PENDING_TIMEOUT_MS < Date.now();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Creates a Firebase Installation if there isn't one for the app and
 * returns the Installation ID.
 * @param installations - The `Installations` instance.
 *
 * @public
 */ async function $400b78d2aed30a3c$export$218c8c3169c024d2(installations) {
    const installationsImpl = installations;
    const { installationEntry: installationEntry, registrationPromise: registrationPromise } = await $400b78d2aed30a3c$var$getInstallationEntry(installationsImpl);
    if (registrationPromise) registrationPromise.catch(console.error);
    else // If the installation is already registered, update the authentication
    // token if needed.
    $400b78d2aed30a3c$var$refreshAuthToken(installationsImpl).catch(console.error);
    return installationEntry.fid;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a Firebase Installations auth token, identifying the current
 * Firebase Installation.
 * @param installations - The `Installations` instance.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ async function $400b78d2aed30a3c$export$257b2d10b709d8ef(installations, forceRefresh = false) {
    const installationsImpl = installations;
    await $400b78d2aed30a3c$var$completeInstallationRegistration(installationsImpl);
    // At this point we either have a Registered Installation in the DB, or we've
    // already thrown an error.
    const authToken = await $400b78d2aed30a3c$var$refreshAuthToken(installationsImpl, forceRefresh);
    return authToken.token;
}
async function $400b78d2aed30a3c$var$completeInstallationRegistration(installations) {
    const { registrationPromise: registrationPromise } = await $400b78d2aed30a3c$var$getInstallationEntry(installations);
    if (registrationPromise) // A createInstallation request is in progress. Wait until it finishes.
    await registrationPromise;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $400b78d2aed30a3c$var$deleteInstallationRequest(appConfig, installationEntry) {
    const endpoint = $400b78d2aed30a3c$var$getDeleteEndpoint(appConfig, installationEntry);
    const headers = $400b78d2aed30a3c$var$getHeadersWithAuth(appConfig, installationEntry);
    const request = {
        method: 'DELETE',
        headers: headers
    };
    const response = await $400b78d2aed30a3c$var$retryIfServerError(()=>fetch(endpoint, request));
    if (!response.ok) throw await $400b78d2aed30a3c$var$getErrorFromResponse('Delete Installation', response);
}
function $400b78d2aed30a3c$var$getDeleteEndpoint(appConfig, { fid: fid }) {
    return `${$400b78d2aed30a3c$var$getInstallationsEndpoint(appConfig)}/${fid}`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Deletes the Firebase Installation and all associated data.
 * @param installations - The `Installations` instance.
 *
 * @public
 */ async function $400b78d2aed30a3c$export$5f6b87a08674814c(installations) {
    const { appConfig: appConfig } = installations;
    const entry = await $400b78d2aed30a3c$var$update(appConfig, (oldEntry)=>{
        if (oldEntry && oldEntry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */ ) // Delete the unregistered entry without sending a deleteInstallation request.
        return undefined;
        return oldEntry;
    });
    if (entry) {
        if (entry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */ ) // Can't delete while trying to register.
        throw $400b78d2aed30a3c$var$ERROR_FACTORY.create("delete-pending-registration" /* ErrorCode.DELETE_PENDING_REGISTRATION */ );
        else if (entry.registrationStatus === 2 /* RequestStatus.COMPLETED */ ) {
            if (!navigator.onLine) throw $400b78d2aed30a3c$var$ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */ );
            else {
                await $400b78d2aed30a3c$var$deleteInstallationRequest(appConfig, entry);
                await $400b78d2aed30a3c$var$remove(appConfig);
            }
        }
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sets a new callback that will get called when Installation ID changes.
 * Returns an unsubscribe function that will remove the callback when called.
 * @param installations - The `Installations` instance.
 * @param callback - The callback function that is invoked when FID changes.
 * @returns A function that can be called to unsubscribe.
 *
 * @public
 */ function $400b78d2aed30a3c$export$ceb4c11381bc36e8(installations, callback) {
    const { appConfig: appConfig } = installations;
    $400b78d2aed30a3c$var$addCallback(appConfig, callback);
    return ()=>{
        $400b78d2aed30a3c$var$removeCallback(appConfig, callback);
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns an instance of {@link Installations} associated with the given
 * {@link @firebase/app#FirebaseApp} instance.
 * @param app - The {@link @firebase/app#FirebaseApp} instance.
 *
 * @public
 */ function $400b78d2aed30a3c$export$9bfc115e43431ff5(app = (0, $48fcf96884780cca$export$f9962582c9e66d99)()) {
    const installationsImpl = (0, $48fcf96884780cca$export$fa0d6da0f5838f50)(app, 'installations').getImmediate();
    return installationsImpl;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $400b78d2aed30a3c$var$extractAppConfig(app) {
    if (!app || !app.options) throw $400b78d2aed30a3c$var$getMissingValueError('App Configuration');
    if (!app.name) throw $400b78d2aed30a3c$var$getMissingValueError('App Name');
    // Required app config keys
    const configKeys = [
        'projectId',
        'apiKey',
        'appId'
    ];
    for (const keyName of configKeys){
        if (!app.options[keyName]) throw $400b78d2aed30a3c$var$getMissingValueError(keyName);
    }
    return {
        appName: app.name,
        projectId: app.options.projectId,
        apiKey: app.options.apiKey,
        appId: app.options.appId
    };
}
function $400b78d2aed30a3c$var$getMissingValueError(valueName) {
    return $400b78d2aed30a3c$var$ERROR_FACTORY.create("missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */ , {
        valueName: valueName
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $400b78d2aed30a3c$var$INSTALLATIONS_NAME = 'installations';
const $400b78d2aed30a3c$var$INSTALLATIONS_NAME_INTERNAL = 'installations-internal';
const $400b78d2aed30a3c$var$publicFactory = (container)=>{
    const app = container.getProvider('app').getImmediate();
    // Throws if app isn't configured properly.
    const appConfig = $400b78d2aed30a3c$var$extractAppConfig(app);
    const heartbeatServiceProvider = (0, $48fcf96884780cca$export$fa0d6da0f5838f50)(app, 'heartbeat');
    const installationsImpl = {
        app: app,
        appConfig: appConfig,
        heartbeatServiceProvider: heartbeatServiceProvider,
        _delete: ()=>Promise.resolve()
    };
    return installationsImpl;
};
const $400b78d2aed30a3c$var$internalFactory = (container)=>{
    const app = container.getProvider('app').getImmediate();
    // Internal FIS instance relies on public FIS instance.
    const installations = (0, $48fcf96884780cca$export$fa0d6da0f5838f50)(app, $400b78d2aed30a3c$var$INSTALLATIONS_NAME).getImmediate();
    const installationsInternal = {
        getId: ()=>$400b78d2aed30a3c$export$218c8c3169c024d2(installations),
        getToken: (forceRefresh)=>$400b78d2aed30a3c$export$257b2d10b709d8ef(installations, forceRefresh)
    };
    return installationsInternal;
};
function $400b78d2aed30a3c$var$registerInstallations() {
    (0, $48fcf96884780cca$export$c930050e7bb63965)(new (0, $90e6a618aa3f286c$export$16fa2f45be04daa8)($400b78d2aed30a3c$var$INSTALLATIONS_NAME, $400b78d2aed30a3c$var$publicFactory, "PUBLIC" /* ComponentType.PUBLIC */ ));
    (0, $48fcf96884780cca$export$c930050e7bb63965)(new (0, $90e6a618aa3f286c$export$16fa2f45be04daa8)($400b78d2aed30a3c$var$INSTALLATIONS_NAME_INTERNAL, $400b78d2aed30a3c$var$internalFactory, "PRIVATE" /* ComponentType.PRIVATE */ ));
}
/**
 * The Firebase Installations Web SDK.
 * This SDK does not work in a Node.js environment.
 *
 * @packageDocumentation
 */ $400b78d2aed30a3c$var$registerInstallations();
(0, $48fcf96884780cca$export$d29d5299a7137abc)($400b78d2aed30a3c$var$name, $400b78d2aed30a3c$var$version);
// BUILD_TARGET will be replaced by values like esm2017, cjs2017, etc during the compilation
(0, $48fcf96884780cca$export$d29d5299a7137abc)($400b78d2aed30a3c$var$name, $400b78d2aed30a3c$var$version, 'esm2017');


/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Type constant for Firebase Analytics.
 */ const $ece272441bf93110$var$ANALYTICS_TYPE = 'analytics';
// Key to attach FID to in gtag params.
const $ece272441bf93110$var$GA_FID_KEY = 'firebase_id';
const $ece272441bf93110$var$ORIGIN_KEY = 'origin';
const $ece272441bf93110$var$FETCH_TIMEOUT_MILLIS = 60000;
const $ece272441bf93110$var$DYNAMIC_CONFIG_URL = 'https://firebase.googleapis.com/v1alpha/projects/-/apps/{app-id}/webConfig';
const $ece272441bf93110$var$GTAG_URL = 'https://www.googletagmanager.com/gtag/js';
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $ece272441bf93110$var$logger = new (0, $65bf8d3396e16cb5$export$efa9a398d6368992)('@firebase/analytics');
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $ece272441bf93110$var$ERRORS = {
    ["already-exists" /* AnalyticsError.ALREADY_EXISTS */ ]: "A Firebase Analytics instance with the appId {$id}  already exists. Only one Firebase Analytics instance can be created for each appId.",
    ["already-initialized" /* AnalyticsError.ALREADY_INITIALIZED */ ]: "initializeAnalytics() cannot be called again with different options than those it was initially called with. It can be called again with the same options to return the existing instance, or getAnalytics() can be used to get a reference to the already-initialized instance.",
    ["already-initialized-settings" /* AnalyticsError.ALREADY_INITIALIZED_SETTINGS */ ]: "Firebase Analytics has already been initialized.settings() must be called before initializing any Analytics instanceor it will have no effect.",
    ["interop-component-reg-failed" /* AnalyticsError.INTEROP_COMPONENT_REG_FAILED */ ]: 'Firebase Analytics Interop Component failed to instantiate: {$reason}',
    ["invalid-analytics-context" /* AnalyticsError.INVALID_ANALYTICS_CONTEXT */ ]: "Firebase Analytics is not supported in this environment. Wrap initialization of analytics in analytics.isSupported() to prevent initialization in unsupported environments. Details: {$errorInfo}",
    ["indexeddb-unavailable" /* AnalyticsError.INDEXEDDB_UNAVAILABLE */ ]: "IndexedDB unavailable or restricted in this environment. Wrap initialization of analytics in analytics.isSupported() to prevent initialization in unsupported environments. Details: {$errorInfo}",
    ["fetch-throttle" /* AnalyticsError.FETCH_THROTTLE */ ]: "The config fetch request timed out while in an exponential backoff state. Unix timestamp in milliseconds when fetch request throttling ends: {$throttleEndTimeMillis}.",
    ["config-fetch-failed" /* AnalyticsError.CONFIG_FETCH_FAILED */ ]: 'Dynamic config fetch failed: [{$httpStatus}] {$responseMessage}',
    ["no-api-key" /* AnalyticsError.NO_API_KEY */ ]: 'The "apiKey" field is empty in the local Firebase config. Firebase Analytics requires this field tocontain a valid API key.',
    ["no-app-id" /* AnalyticsError.NO_APP_ID */ ]: 'The "appId" field is empty in the local Firebase config. Firebase Analytics requires this field tocontain a valid app ID.',
    ["no-client-id" /* AnalyticsError.NO_CLIENT_ID */ ]: 'The "client_id" field is empty.',
    ["invalid-gtag-resource" /* AnalyticsError.INVALID_GTAG_RESOURCE */ ]: 'Trusted Types detected an invalid gtag resource: {$gtagURL}.'
};
const $ece272441bf93110$var$ERROR_FACTORY = new (0, $156de25e040d63b6$export$3fa6e1b18a3b2d40)('analytics', 'Analytics', $ece272441bf93110$var$ERRORS);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Verifies and creates a TrustedScriptURL.
 */ function $ece272441bf93110$var$createGtagTrustedTypesScriptURL(url) {
    if (!url.startsWith($ece272441bf93110$var$GTAG_URL)) {
        const err = $ece272441bf93110$var$ERROR_FACTORY.create("invalid-gtag-resource" /* AnalyticsError.INVALID_GTAG_RESOURCE */ , {
            gtagURL: url
        });
        $ece272441bf93110$var$logger.warn(err.message);
        return '';
    }
    return url;
}
/**
 * Makeshift polyfill for Promise.allSettled(). Resolves when all promises
 * have either resolved or rejected.
 *
 * @param promises Array of promises to wait for.
 */ function $ece272441bf93110$var$promiseAllSettled(promises) {
    return Promise.all(promises.map((promise)=>promise.catch((e)=>e)));
}
/**
 * Creates a TrustedTypePolicy object that implements the rules passed as policyOptions.
 *
 * @param policyName A string containing the name of the policy
 * @param policyOptions Object containing implementations of instance methods for TrustedTypesPolicy, see {@link https://developer.mozilla.org/en-US/docs/Web/API/TrustedTypePolicy#instance_methods
 * | the TrustedTypePolicy reference documentation}.
 */ function $ece272441bf93110$var$createTrustedTypesPolicy(policyName, policyOptions) {
    // Create a TrustedTypes policy that we can use for updating src
    // properties
    let trustedTypesPolicy;
    if (window.trustedTypes) trustedTypesPolicy = window.trustedTypes.createPolicy(policyName, policyOptions);
    return trustedTypesPolicy;
}
/**
 * Inserts gtag script tag into the page to asynchronously download gtag.
 * @param dataLayerName Name of datalayer (most often the default, "_dataLayer").
 */ function $ece272441bf93110$var$insertScriptTag(dataLayerName, measurementId) {
    const trustedTypesPolicy = $ece272441bf93110$var$createTrustedTypesPolicy('firebase-js-sdk-policy', {
        createScriptURL: $ece272441bf93110$var$createGtagTrustedTypesScriptURL
    });
    const script = document.createElement('script');
    // We are not providing an analyticsId in the URL because it would trigger a `page_view`
    // without fid. We will initialize ga-id using gtag (config) command together with fid.
    const gtagScriptURL = `${$ece272441bf93110$var$GTAG_URL}?l=${dataLayerName}&id=${measurementId}`;
    script.src = trustedTypesPolicy ? trustedTypesPolicy === null || trustedTypesPolicy === void 0 ? void 0 : trustedTypesPolicy.createScriptURL(gtagScriptURL) : gtagScriptURL;
    script.async = true;
    document.head.appendChild(script);
}
/**
 * Get reference to, or create, global datalayer.
 * @param dataLayerName Name of datalayer (most often the default, "_dataLayer").
 */ function $ece272441bf93110$var$getOrCreateDataLayer(dataLayerName) {
    // Check for existing dataLayer and create if needed.
    let dataLayer = [];
    if (Array.isArray(window[dataLayerName])) dataLayer = window[dataLayerName];
    else window[dataLayerName] = dataLayer;
    return dataLayer;
}
/**
 * Wrapped gtag logic when gtag is called with 'config' command.
 *
 * @param gtagCore Basic gtag function that just appends to dataLayer.
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementIdToAppId Map of GA measurementIDs to corresponding Firebase appId.
 * @param measurementId GA Measurement ID to set config for.
 * @param gtagParams Gtag config params to set.
 */ async function $ece272441bf93110$var$gtagOnConfig(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId, measurementId, gtagParams) {
    // If config is already fetched, we know the appId and can use it to look up what FID promise we
    /// are waiting for, and wait only on that one.
    const correspondingAppId = measurementIdToAppId[measurementId];
    try {
        if (correspondingAppId) await initializationPromisesMap[correspondingAppId];
        else {
            // If config is not fetched yet, wait for all configs (we don't know which one we need) and
            // find the appId (if any) corresponding to this measurementId. If there is one, wait on
            // that appId's initialization promise. If there is none, promise resolves and gtag
            // call goes through.
            const dynamicConfigResults = await $ece272441bf93110$var$promiseAllSettled(dynamicConfigPromisesList);
            const foundConfig = dynamicConfigResults.find((config)=>config.measurementId === measurementId);
            if (foundConfig) await initializationPromisesMap[foundConfig.appId];
        }
    } catch (e) {
        $ece272441bf93110$var$logger.error(e);
    }
    gtagCore("config" /* GtagCommand.CONFIG */ , measurementId, gtagParams);
}
/**
 * Wrapped gtag logic when gtag is called with 'event' command.
 *
 * @param gtagCore Basic gtag function that just appends to dataLayer.
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementId GA Measurement ID to log event to.
 * @param gtagParams Params to log with this event.
 */ async function $ece272441bf93110$var$gtagOnEvent(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementId, gtagParams) {
    try {
        let initializationPromisesToWaitFor = [];
        // If there's a 'send_to' param, check if any ID specified matches
        // an initializeIds() promise we are waiting for.
        if (gtagParams && gtagParams['send_to']) {
            let gaSendToList = gtagParams['send_to'];
            // Make it an array if is isn't, so it can be dealt with the same way.
            if (!Array.isArray(gaSendToList)) gaSendToList = [
                gaSendToList
            ];
            // Checking 'send_to' fields requires having all measurement ID results back from
            // the dynamic config fetch.
            const dynamicConfigResults = await $ece272441bf93110$var$promiseAllSettled(dynamicConfigPromisesList);
            for (const sendToId of gaSendToList){
                // Any fetched dynamic measurement ID that matches this 'send_to' ID
                const foundConfig = dynamicConfigResults.find((config)=>config.measurementId === sendToId);
                const initializationPromise = foundConfig && initializationPromisesMap[foundConfig.appId];
                if (initializationPromise) initializationPromisesToWaitFor.push(initializationPromise);
                else {
                    // Found an item in 'send_to' that is not associated
                    // directly with an FID, possibly a group.  Empty this array,
                    // exit the loop early, and let it get populated below.
                    initializationPromisesToWaitFor = [];
                    break;
                }
            }
        }
        // This will be unpopulated if there was no 'send_to' field , or
        // if not all entries in the 'send_to' field could be mapped to
        // a FID. In these cases, wait on all pending initialization promises.
        if (initializationPromisesToWaitFor.length === 0) /* eslint-disable-next-line @typescript-eslint/no-floating-promises */ initializationPromisesToWaitFor = Object.values(initializationPromisesMap);
        // Run core gtag function with args after all relevant initialization
        // promises have been resolved.
        await Promise.all(initializationPromisesToWaitFor);
        // Workaround for http://b/141370449 - third argument cannot be undefined.
        gtagCore("event" /* GtagCommand.EVENT */ , measurementId, gtagParams || {});
    } catch (e) {
        $ece272441bf93110$var$logger.error(e);
    }
}
/**
 * Wraps a standard gtag function with extra code to wait for completion of
 * relevant initialization promises before sending requests.
 *
 * @param gtagCore Basic gtag function that just appends to dataLayer.
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementIdToAppId Map of GA measurementIDs to corresponding Firebase appId.
 */ function $ece272441bf93110$var$wrapGtag(gtagCore, /**
 * Allows wrapped gtag calls to wait on whichever initialization promises are required,
 * depending on the contents of the gtag params' `send_to` field, if any.
 */ initializationPromisesMap, /**
 * Wrapped gtag calls sometimes require all dynamic config fetches to have returned
 * before determining what initialization promises (which include FIDs) to wait for.
 */ dynamicConfigPromisesList, /**
 * Wrapped gtag config calls can narrow down which initialization promise (with FID)
 * to wait for if the measurementId is already fetched, by getting the corresponding appId,
 * which is the key for the initialization promises map.
 */ measurementIdToAppId) {
    /**
     * Wrapper around gtag that ensures FID is sent with gtag calls.
     * @param command Gtag command type.
     * @param idOrNameOrParams Measurement ID if command is EVENT/CONFIG, params if command is SET.
     * @param gtagParams Params if event is EVENT/CONFIG.
     */ async function gtagWrapper(command, ...args) {
        try {
            // If event, check that relevant initialization promises have completed.
            if (command === "event" /* GtagCommand.EVENT */ ) {
                const [measurementId, gtagParams] = args;
                // If EVENT, second arg must be measurementId.
                await $ece272441bf93110$var$gtagOnEvent(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementId, gtagParams);
            } else if (command === "config" /* GtagCommand.CONFIG */ ) {
                const [measurementId, gtagParams] = args;
                // If CONFIG, second arg must be measurementId.
                await $ece272441bf93110$var$gtagOnConfig(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId, measurementId, gtagParams);
            } else if (command === "consent" /* GtagCommand.CONSENT */ ) {
                const [consentAction, gtagParams] = args;
                // consentAction can be one of 'default' or 'update'.
                gtagCore("consent" /* GtagCommand.CONSENT */ , consentAction, gtagParams);
            } else if (command === "get" /* GtagCommand.GET */ ) {
                const [measurementId, fieldName, callback] = args;
                gtagCore("get" /* GtagCommand.GET */ , measurementId, fieldName, callback);
            } else if (command === "set" /* GtagCommand.SET */ ) {
                const [customParams] = args;
                // If SET, second arg must be params.
                gtagCore("set" /* GtagCommand.SET */ , customParams);
            } else gtagCore(command, ...args);
        } catch (e) {
            $ece272441bf93110$var$logger.error(e);
        }
    }
    return gtagWrapper;
}
/**
 * Creates global gtag function or wraps existing one if found.
 * This wrapped function attaches Firebase instance ID (FID) to gtag 'config' and
 * 'event' calls that belong to the GAID associated with this Firebase instance.
 *
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementIdToAppId Map of GA measurementIDs to corresponding Firebase appId.
 * @param dataLayerName Name of global GA datalayer array.
 * @param gtagFunctionName Name of global gtag function ("gtag" if not user-specified).
 */ function $ece272441bf93110$var$wrapOrCreateGtag(initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId, dataLayerName, gtagFunctionName) {
    // Create a basic core gtag function
    let gtagCore = function(..._args) {
        // Must push IArguments object, not an array.
        window[dataLayerName].push(arguments);
    };
    // Replace it with existing one if found
    if (window[gtagFunctionName] && typeof window[gtagFunctionName] === 'function') // @ts-ignore
    gtagCore = window[gtagFunctionName];
    window[gtagFunctionName] = $ece272441bf93110$var$wrapGtag(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId);
    return {
        gtagCore: gtagCore,
        wrappedGtag: window[gtagFunctionName]
    };
}
/**
 * Returns the script tag in the DOM matching both the gtag url pattern
 * and the provided data layer name.
 */ function $ece272441bf93110$var$findGtagScriptOnPage(dataLayerName) {
    const scriptTags = window.document.getElementsByTagName('script');
    for (const tag of Object.values(scriptTags)){
        if (tag.src && tag.src.includes($ece272441bf93110$var$GTAG_URL) && tag.src.includes(dataLayerName)) return tag;
    }
    return null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Backoff factor for 503 errors, which we want to be conservative about
 * to avoid overloading servers. Each retry interval will be
 * BASE_INTERVAL_MILLIS * LONG_RETRY_FACTOR ^ retryCount, so the second one
 * will be ~30 seconds (with fuzzing).
 */ const $ece272441bf93110$var$LONG_RETRY_FACTOR = 30;
/**
 * Base wait interval to multiplied by backoffFactor^backoffCount.
 */ const $ece272441bf93110$var$BASE_INTERVAL_MILLIS = 1000;
/**
 * Stubbable retry data storage class.
 */ class $ece272441bf93110$var$RetryData {
    constructor(throttleMetadata = {}, intervalMillis = $ece272441bf93110$var$BASE_INTERVAL_MILLIS){
        this.throttleMetadata = throttleMetadata;
        this.intervalMillis = intervalMillis;
    }
    getThrottleMetadata(appId) {
        return this.throttleMetadata[appId];
    }
    setThrottleMetadata(appId, metadata) {
        this.throttleMetadata[appId] = metadata;
    }
    deleteThrottleMetadata(appId) {
        delete this.throttleMetadata[appId];
    }
}
const $ece272441bf93110$var$defaultRetryData = new $ece272441bf93110$var$RetryData();
/**
 * Set GET request headers.
 * @param apiKey App API key.
 */ function $ece272441bf93110$var$getHeaders(apiKey) {
    return new Headers({
        Accept: 'application/json',
        'x-goog-api-key': apiKey
    });
}
/**
 * Fetches dynamic config from backend.
 * @param app Firebase app to fetch config for.
 */ async function $ece272441bf93110$var$fetchDynamicConfig(appFields) {
    var _a;
    const { appId: appId, apiKey: apiKey } = appFields;
    const request = {
        method: 'GET',
        headers: $ece272441bf93110$var$getHeaders(apiKey)
    };
    const appUrl = $ece272441bf93110$var$DYNAMIC_CONFIG_URL.replace('{app-id}', appId);
    const response = await fetch(appUrl, request);
    if (response.status !== 200 && response.status !== 304) {
        let errorMessage = '';
        try {
            // Try to get any error message text from server response.
            const jsonResponse = await response.json();
            if ((_a = jsonResponse.error) === null || _a === void 0 ? void 0 : _a.message) errorMessage = jsonResponse.error.message;
        } catch (_ignored) {}
        throw $ece272441bf93110$var$ERROR_FACTORY.create("config-fetch-failed" /* AnalyticsError.CONFIG_FETCH_FAILED */ , {
            httpStatus: response.status,
            responseMessage: errorMessage
        });
    }
    return response.json();
}
/**
 * Fetches dynamic config from backend, retrying if failed.
 * @param app Firebase app to fetch config for.
 */ async function $ece272441bf93110$var$fetchDynamicConfigWithRetry(app, // retryData and timeoutMillis are parameterized to allow passing a different value for testing.
retryData = $ece272441bf93110$var$defaultRetryData, timeoutMillis) {
    const { appId: appId, apiKey: apiKey, measurementId: measurementId } = app.options;
    if (!appId) throw $ece272441bf93110$var$ERROR_FACTORY.create("no-app-id" /* AnalyticsError.NO_APP_ID */ );
    if (!apiKey) {
        if (measurementId) return {
            measurementId: measurementId,
            appId: appId
        };
        throw $ece272441bf93110$var$ERROR_FACTORY.create("no-api-key" /* AnalyticsError.NO_API_KEY */ );
    }
    const throttleMetadata = retryData.getThrottleMetadata(appId) || {
        backoffCount: 0,
        throttleEndTimeMillis: Date.now()
    };
    const signal = new $ece272441bf93110$var$AnalyticsAbortSignal();
    setTimeout(async ()=>{
        // Note a very low delay, eg < 10ms, can elapse before listeners are initialized.
        signal.abort();
    }, timeoutMillis !== undefined ? timeoutMillis : $ece272441bf93110$var$FETCH_TIMEOUT_MILLIS);
    return $ece272441bf93110$var$attemptFetchDynamicConfigWithRetry({
        appId: appId,
        apiKey: apiKey,
        measurementId: measurementId
    }, throttleMetadata, signal, retryData);
}
/**
 * Runs one retry attempt.
 * @param appFields Necessary app config fields.
 * @param throttleMetadata Ongoing metadata to determine throttling times.
 * @param signal Abort signal.
 */ async function $ece272441bf93110$var$attemptFetchDynamicConfigWithRetry(appFields, { throttleEndTimeMillis: throttleEndTimeMillis, backoffCount: backoffCount }, signal, retryData = $ece272441bf93110$var$defaultRetryData // for testing
) {
    var _a;
    const { appId: appId, measurementId: measurementId } = appFields;
    // Starts with a (potentially zero) timeout to support resumption from stored state.
    // Ensures the throttle end time is honored if the last attempt timed out.
    // Note the SDK will never make a request if the fetch timeout expires at this point.
    try {
        await $ece272441bf93110$var$setAbortableTimeout(signal, throttleEndTimeMillis);
    } catch (e) {
        if (measurementId) {
            $ece272441bf93110$var$logger.warn(`Timed out fetching this Firebase app's measurement ID from the server.` + ` Falling back to the measurement ID ${measurementId}` + ` provided in the "measurementId" field in the local Firebase config. [${e === null || e === void 0 ? void 0 : e.message}]`);
            return {
                appId: appId,
                measurementId: measurementId
            };
        }
        throw e;
    }
    try {
        const response = await $ece272441bf93110$var$fetchDynamicConfig(appFields);
        // Note the SDK only clears throttle state if response is success or non-retriable.
        retryData.deleteThrottleMetadata(appId);
        return response;
    } catch (e) {
        const error = e;
        if (!$ece272441bf93110$var$isRetriableError(error)) {
            retryData.deleteThrottleMetadata(appId);
            if (measurementId) {
                $ece272441bf93110$var$logger.warn(`Failed to fetch this Firebase app's measurement ID from the server.` + ` Falling back to the measurement ID ${measurementId}` + ` provided in the "measurementId" field in the local Firebase config. [${error === null || error === void 0 ? void 0 : error.message}]`);
                return {
                    appId: appId,
                    measurementId: measurementId
                };
            } else throw e;
        }
        const backoffMillis = Number((_a = error === null || error === void 0 ? void 0 : error.customData) === null || _a === void 0 ? void 0 : _a.httpStatus) === 503 ? (0, $156de25e040d63b6$export$4d810c0ca64ed8e9)(backoffCount, retryData.intervalMillis, $ece272441bf93110$var$LONG_RETRY_FACTOR) : (0, $156de25e040d63b6$export$4d810c0ca64ed8e9)(backoffCount, retryData.intervalMillis);
        // Increments backoff state.
        const throttleMetadata = {
            throttleEndTimeMillis: Date.now() + backoffMillis,
            backoffCount: backoffCount + 1
        };
        // Persists state.
        retryData.setThrottleMetadata(appId, throttleMetadata);
        $ece272441bf93110$var$logger.debug(`Calling attemptFetch again in ${backoffMillis} millis`);
        return $ece272441bf93110$var$attemptFetchDynamicConfigWithRetry(appFields, throttleMetadata, signal, retryData);
    }
}
/**
 * Supports waiting on a backoff by:
 *
 * <ul>
 *   <li>Promisifying setTimeout, so we can set a timeout in our Promise chain</li>
 *   <li>Listening on a signal bus for abort events, just like the Fetch API</li>
 *   <li>Failing in the same way the Fetch API fails, so timing out a live request and a throttled
 *       request appear the same.</li>
 * </ul>
 *
 * <p>Visible for testing.
 */ function $ece272441bf93110$var$setAbortableTimeout(signal, throttleEndTimeMillis) {
    return new Promise((resolve, reject)=>{
        // Derives backoff from given end time, normalizing negative numbers to zero.
        const backoffMillis = Math.max(throttleEndTimeMillis - Date.now(), 0);
        const timeout = setTimeout(resolve, backoffMillis);
        // Adds listener, rather than sets onabort, because signal is a shared object.
        signal.addEventListener(()=>{
            clearTimeout(timeout);
            // If the request completes before this timeout, the rejection has no effect.
            reject($ece272441bf93110$var$ERROR_FACTORY.create("fetch-throttle" /* AnalyticsError.FETCH_THROTTLE */ , {
                throttleEndTimeMillis: throttleEndTimeMillis
            }));
        });
    });
}
/**
 * Returns true if the {@link Error} indicates a fetch request may succeed later.
 */ function $ece272441bf93110$var$isRetriableError(e) {
    if (!(e instanceof (0, $156de25e040d63b6$export$dd24e9cd51226c56)) || !e.customData) return false;
    // Uses string index defined by ErrorData, which FirebaseError implements.
    const httpStatus = Number(e.customData['httpStatus']);
    return httpStatus === 429 || httpStatus === 500 || httpStatus === 503 || httpStatus === 504;
}
/**
 * Shims a minimal AbortSignal (copied from Remote Config).
 *
 * <p>AbortController's AbortSignal conveniently decouples fetch timeout logic from other aspects
 * of networking, such as retries. Firebase doesn't use AbortController enough to justify a
 * polyfill recommendation, like we do with the Fetch API, but this minimal shim can easily be
 * swapped out if/when we do.
 */ class $ece272441bf93110$var$AnalyticsAbortSignal {
    constructor(){
        this.listeners = [];
    }
    addEventListener(listener) {
        this.listeners.push(listener);
    }
    abort() {
        this.listeners.forEach((listener)=>listener());
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Event parameters to set on 'gtag' during initialization.
 */ let $ece272441bf93110$var$defaultEventParametersForInit;
/**
 * Logs an analytics event through the Firebase SDK.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param eventName Google Analytics event name, choose from standard list or use a custom string.
 * @param eventParams Analytics event parameters.
 */ async function $ece272441bf93110$var$logEvent$1(gtagFunction, initializationPromise, eventName, eventParams, options) {
    if (options && options.global) {
        gtagFunction("event" /* GtagCommand.EVENT */ , eventName, eventParams);
        return;
    } else {
        const measurementId = await initializationPromise;
        const params = Object.assign(Object.assign({}, eventParams), {
            'send_to': measurementId
        });
        gtagFunction("event" /* GtagCommand.EVENT */ , eventName, params);
    }
}
/**
 * Set screen_name parameter for this Google Analytics ID.
 *
 * @deprecated Use {@link logEvent} with `eventName` as 'screen_view' and add relevant `eventParams`.
 * See {@link https://firebase.google.com/docs/analytics/screenviews | Track Screenviews}.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param screenName Screen name string to set.
 */ async function $ece272441bf93110$var$setCurrentScreen$1(gtagFunction, initializationPromise, screenName, options) {
    if (options && options.global) {
        gtagFunction("set" /* GtagCommand.SET */ , {
            'screen_name': screenName
        });
        return Promise.resolve();
    } else {
        const measurementId = await initializationPromise;
        gtagFunction("config" /* GtagCommand.CONFIG */ , measurementId, {
            update: true,
            'screen_name': screenName
        });
    }
}
/**
 * Set user_id parameter for this Google Analytics ID.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param id User ID string to set
 */ async function $ece272441bf93110$var$setUserId$1(gtagFunction, initializationPromise, id, options) {
    if (options && options.global) {
        gtagFunction("set" /* GtagCommand.SET */ , {
            'user_id': id
        });
        return Promise.resolve();
    } else {
        const measurementId = await initializationPromise;
        gtagFunction("config" /* GtagCommand.CONFIG */ , measurementId, {
            update: true,
            'user_id': id
        });
    }
}
/**
 * Set all other user properties other than user_id and screen_name.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param properties Map of user properties to set
 */ async function $ece272441bf93110$var$setUserProperties$1(gtagFunction, initializationPromise, properties, options) {
    if (options && options.global) {
        const flatProperties = {};
        for (const key of Object.keys(properties))// use dot notation for merge behavior in gtag.js
        flatProperties[`user_properties.${key}`] = properties[key];
        gtagFunction("set" /* GtagCommand.SET */ , flatProperties);
        return Promise.resolve();
    } else {
        const measurementId = await initializationPromise;
        gtagFunction("config" /* GtagCommand.CONFIG */ , measurementId, {
            update: true,
            'user_properties': properties
        });
    }
}
/**
 * Retrieves a unique Google Analytics identifier for the web client.
 * See {@link https://developers.google.com/analytics/devguides/collection/ga4/reference/config#client_id | client_id}.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 */ async function $ece272441bf93110$var$internalGetGoogleAnalyticsClientId(gtagFunction, initializationPromise) {
    const measurementId = await initializationPromise;
    return new Promise((resolve, reject)=>{
        gtagFunction("get" /* GtagCommand.GET */ , measurementId, 'client_id', (clientId)=>{
            if (!clientId) reject($ece272441bf93110$var$ERROR_FACTORY.create("no-client-id" /* AnalyticsError.NO_CLIENT_ID */ ));
            resolve(clientId);
        });
    });
}
/**
 * Set whether collection is enabled for this ID.
 *
 * @param enabled If true, collection is enabled for this ID.
 */ async function $ece272441bf93110$var$setAnalyticsCollectionEnabled$1(initializationPromise, enabled) {
    const measurementId = await initializationPromise;
    window[`ga-disable-${measurementId}`] = !enabled;
}
/**
 * Consent parameters to default to during 'gtag' initialization.
 */ let $ece272441bf93110$var$defaultConsentSettingsForInit;
/**
 * Sets the variable {@link defaultConsentSettingsForInit} for use in the initialization of
 * analytics.
 *
 * @param consentSettings Maps the applicable end user consent state for gtag.js.
 */ function $ece272441bf93110$var$_setConsentDefaultForInit(consentSettings) {
    $ece272441bf93110$var$defaultConsentSettingsForInit = consentSettings;
}
/**
 * Sets the variable `defaultEventParametersForInit` for use in the initialization of
 * analytics.
 *
 * @param customParams Any custom params the user may pass to gtag.js.
 */ function $ece272441bf93110$var$_setDefaultEventParametersForInit(customParams) {
    $ece272441bf93110$var$defaultEventParametersForInit = customParams;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $ece272441bf93110$var$validateIndexedDB() {
    if (!(0, $156de25e040d63b6$export$3865db50535c2055)()) {
        $ece272441bf93110$var$logger.warn($ece272441bf93110$var$ERROR_FACTORY.create("indexeddb-unavailable" /* AnalyticsError.INDEXEDDB_UNAVAILABLE */ , {
            errorInfo: 'IndexedDB is not available in this environment.'
        }).message);
        return false;
    } else try {
        await (0, $156de25e040d63b6$export$a8a3018f3d187a4d)();
    } catch (e) {
        $ece272441bf93110$var$logger.warn($ece272441bf93110$var$ERROR_FACTORY.create("indexeddb-unavailable" /* AnalyticsError.INDEXEDDB_UNAVAILABLE */ , {
            errorInfo: e === null || e === void 0 ? void 0 : e.toString()
        }).message);
        return false;
    }
    return true;
}
/**
 * Initialize the analytics instance in gtag.js by calling config command with fid.
 *
 * NOTE: We combine analytics initialization and setting fid together because we want fid to be
 * part of the `page_view` event that's sent during the initialization
 * @param app Firebase app
 * @param gtagCore The gtag function that's not wrapped.
 * @param dynamicConfigPromisesList Array of all dynamic config promises.
 * @param measurementIdToAppId Maps measurementID to appID.
 * @param installations _FirebaseInstallationsInternal instance.
 *
 * @returns Measurement ID.
 */ async function $ece272441bf93110$var$_initializeAnalytics(app, dynamicConfigPromisesList, measurementIdToAppId, installations, gtagCore, dataLayerName, options) {
    var _a;
    const dynamicConfigPromise = $ece272441bf93110$var$fetchDynamicConfigWithRetry(app);
    // Once fetched, map measurementIds to appId, for ease of lookup in wrapped gtag function.
    dynamicConfigPromise.then((config)=>{
        measurementIdToAppId[config.measurementId] = config.appId;
        if (app.options.measurementId && config.measurementId !== app.options.measurementId) $ece272441bf93110$var$logger.warn(`The measurement ID in the local Firebase config (${app.options.measurementId})` + ` does not match the measurement ID fetched from the server (${config.measurementId}).` + ` To ensure analytics events are always sent to the correct Analytics property,` + ` update the` + ` measurement ID field in the local config or remove it from the local config.`);
    }).catch((e)=>$ece272441bf93110$var$logger.error(e));
    // Add to list to track state of all dynamic config promises.
    dynamicConfigPromisesList.push(dynamicConfigPromise);
    const fidPromise = $ece272441bf93110$var$validateIndexedDB().then((envIsValid)=>{
        if (envIsValid) return installations.getId();
        else return undefined;
    });
    const [dynamicConfig, fid] = await Promise.all([
        dynamicConfigPromise,
        fidPromise
    ]);
    // Detect if user has already put the gtag <script> tag on this page with the passed in
    // data layer name.
    if (!$ece272441bf93110$var$findGtagScriptOnPage(dataLayerName)) $ece272441bf93110$var$insertScriptTag(dataLayerName, dynamicConfig.measurementId);
    // Detects if there are consent settings that need to be configured.
    if ($ece272441bf93110$var$defaultConsentSettingsForInit) {
        gtagCore("consent" /* GtagCommand.CONSENT */ , 'default', $ece272441bf93110$var$defaultConsentSettingsForInit);
        $ece272441bf93110$var$_setConsentDefaultForInit(undefined);
    }
    // This command initializes gtag.js and only needs to be called once for the entire web app,
    // but since it is idempotent, we can call it multiple times.
    // We keep it together with other initialization logic for better code structure.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    gtagCore('js', new Date());
    // User config added first. We don't want users to accidentally overwrite
    // base Firebase config properties.
    const configProperties = (_a = options === null || options === void 0 ? void 0 : options.config) !== null && _a !== void 0 ? _a : {};
    // guard against developers accidentally setting properties with prefix `firebase_`
    configProperties[$ece272441bf93110$var$ORIGIN_KEY] = 'firebase';
    configProperties.update = true;
    if (fid != null) configProperties[$ece272441bf93110$var$GA_FID_KEY] = fid;
    // It should be the first config command called on this GA-ID
    // Initialize this GA-ID and set FID on it using the gtag config API.
    // Note: This will trigger a page_view event unless 'send_page_view' is set to false in
    // `configProperties`.
    gtagCore("config" /* GtagCommand.CONFIG */ , dynamicConfig.measurementId, configProperties);
    // Detects if there is data that will be set on every event logged from the SDK.
    if ($ece272441bf93110$var$defaultEventParametersForInit) {
        gtagCore("set" /* GtagCommand.SET */ , $ece272441bf93110$var$defaultEventParametersForInit);
        $ece272441bf93110$var$_setDefaultEventParametersForInit(undefined);
    }
    return dynamicConfig.measurementId;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Analytics Service class.
 */ class $ece272441bf93110$var$AnalyticsService {
    constructor(app){
        this.app = app;
    }
    _delete() {
        delete $ece272441bf93110$var$initializationPromisesMap[this.app.options.appId];
        return Promise.resolve();
    }
}
/**
 * Maps appId to full initialization promise. Wrapped gtag calls must wait on
 * all or some of these, depending on the call's `send_to` param and the status
 * of the dynamic config fetches (see below).
 */ let $ece272441bf93110$var$initializationPromisesMap = {};
/**
 * List of dynamic config fetch promises. In certain cases, wrapped gtag calls
 * wait on all these to be complete in order to determine if it can selectively
 * wait for only certain initialization (FID) promises or if it must wait for all.
 */ let $ece272441bf93110$var$dynamicConfigPromisesList = [];
/**
 * Maps fetched measurementIds to appId. Populated when the app's dynamic config
 * fetch completes. If already populated, gtag config calls can use this to
 * selectively wait for only this app's initialization promise (FID) instead of all
 * initialization promises.
 */ const $ece272441bf93110$var$measurementIdToAppId = {};
/**
 * Name for window global data layer array used by GA: defaults to 'dataLayer'.
 */ let $ece272441bf93110$var$dataLayerName = 'dataLayer';
/**
 * Name for window global gtag function used by GA: defaults to 'gtag'.
 */ let $ece272441bf93110$var$gtagName = 'gtag';
/**
 * Reproduction of standard gtag function or reference to existing
 * gtag function on window object.
 */ let $ece272441bf93110$var$gtagCoreFunction;
/**
 * Wrapper around gtag function that ensures FID is sent with all
 * relevant event and config calls.
 */ let $ece272441bf93110$var$wrappedGtagFunction;
/**
 * Flag to ensure page initialization steps (creation or wrapping of
 * dataLayer and gtag script) are only run once per page load.
 */ let $ece272441bf93110$var$globalInitDone = false;
/**
 * Configures Firebase Analytics to use custom `gtag` or `dataLayer` names.
 * Intended to be used if `gtag.js` script has been installed on
 * this page independently of Firebase Analytics, and is using non-default
 * names for either the `gtag` function or for `dataLayer`.
 * Must be called before calling `getAnalytics()` or it won't
 * have any effect.
 *
 * @public
 *
 * @param options - Custom gtag and dataLayer names.
 */ function $ece272441bf93110$export$a5a6e0b888b2c992(options) {
    if ($ece272441bf93110$var$globalInitDone) throw $ece272441bf93110$var$ERROR_FACTORY.create("already-initialized" /* AnalyticsError.ALREADY_INITIALIZED */ );
    if (options.dataLayerName) $ece272441bf93110$var$dataLayerName = options.dataLayerName;
    if (options.gtagName) $ece272441bf93110$var$gtagName = options.gtagName;
}
/**
 * Returns true if no environment mismatch is found.
 * If environment mismatches are found, throws an INVALID_ANALYTICS_CONTEXT
 * error that also lists details for each mismatch found.
 */ function $ece272441bf93110$var$warnOnBrowserContextMismatch() {
    const mismatchedEnvMessages = [];
    if ((0, $156de25e040d63b6$export$caa8774a9107a58e)()) mismatchedEnvMessages.push('This is a browser extension environment.');
    if (!(0, $156de25e040d63b6$export$f172b7eb6cf60599)()) mismatchedEnvMessages.push('Cookies are not available.');
    if (mismatchedEnvMessages.length > 0) {
        const details = mismatchedEnvMessages.map((message, index)=>`(${index + 1}) ${message}`).join(' ');
        const err = $ece272441bf93110$var$ERROR_FACTORY.create("invalid-analytics-context" /* AnalyticsError.INVALID_ANALYTICS_CONTEXT */ , {
            errorInfo: details
        });
        $ece272441bf93110$var$logger.warn(err.message);
    }
}
/**
 * Analytics instance factory.
 * @internal
 */ function $ece272441bf93110$var$factory(app, installations, options) {
    $ece272441bf93110$var$warnOnBrowserContextMismatch();
    const appId = app.options.appId;
    if (!appId) throw $ece272441bf93110$var$ERROR_FACTORY.create("no-app-id" /* AnalyticsError.NO_APP_ID */ );
    if (!app.options.apiKey) {
        if (app.options.measurementId) $ece272441bf93110$var$logger.warn(`The "apiKey" field is empty in the local Firebase config. This is needed to fetch the latest` + ` measurement ID for this Firebase app. Falling back to the measurement ID ${app.options.measurementId}` + ` provided in the "measurementId" field in the local Firebase config.`);
        else throw $ece272441bf93110$var$ERROR_FACTORY.create("no-api-key" /* AnalyticsError.NO_API_KEY */ );
    }
    if ($ece272441bf93110$var$initializationPromisesMap[appId] != null) throw $ece272441bf93110$var$ERROR_FACTORY.create("already-exists" /* AnalyticsError.ALREADY_EXISTS */ , {
        id: appId
    });
    if (!$ece272441bf93110$var$globalInitDone) {
        // Steps here should only be done once per page: creation or wrapping
        // of dataLayer and global gtag function.
        $ece272441bf93110$var$getOrCreateDataLayer($ece272441bf93110$var$dataLayerName);
        const { wrappedGtag: wrappedGtag, gtagCore: gtagCore } = $ece272441bf93110$var$wrapOrCreateGtag($ece272441bf93110$var$initializationPromisesMap, $ece272441bf93110$var$dynamicConfigPromisesList, $ece272441bf93110$var$measurementIdToAppId, $ece272441bf93110$var$dataLayerName, $ece272441bf93110$var$gtagName);
        $ece272441bf93110$var$wrappedGtagFunction = wrappedGtag;
        $ece272441bf93110$var$gtagCoreFunction = gtagCore;
        $ece272441bf93110$var$globalInitDone = true;
    }
    // Async but non-blocking.
    // This map reflects the completion state of all promises for each appId.
    $ece272441bf93110$var$initializationPromisesMap[appId] = $ece272441bf93110$var$_initializeAnalytics(app, $ece272441bf93110$var$dynamicConfigPromisesList, $ece272441bf93110$var$measurementIdToAppId, installations, $ece272441bf93110$var$gtagCoreFunction, $ece272441bf93110$var$dataLayerName, options);
    const analyticsInstance = new $ece272441bf93110$var$AnalyticsService(app);
    return analyticsInstance;
}
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Returns an {@link Analytics} instance for the given app.
 *
 * @public
 *
 * @param app - The {@link @firebase/app#FirebaseApp} to use.
 */ function $ece272441bf93110$export$b0297573c90085aa(app = (0, $48fcf96884780cca$export$f9962582c9e66d99)()) {
    app = (0, $156de25e040d63b6$export$4befe9b5fa509a1b)(app);
    // Dependencies
    const analyticsProvider = (0, $48fcf96884780cca$export$fa0d6da0f5838f50)(app, $ece272441bf93110$var$ANALYTICS_TYPE);
    if (analyticsProvider.isInitialized()) return analyticsProvider.getImmediate();
    return $ece272441bf93110$export$e1ffb6ba450b0317(app);
}
/**
 * Returns an {@link Analytics} instance for the given app.
 *
 * @public
 *
 * @param app - The {@link @firebase/app#FirebaseApp} to use.
 */ function $ece272441bf93110$export$e1ffb6ba450b0317(app, options = {}) {
    // Dependencies
    const analyticsProvider = (0, $48fcf96884780cca$export$fa0d6da0f5838f50)(app, $ece272441bf93110$var$ANALYTICS_TYPE);
    if (analyticsProvider.isInitialized()) {
        const existingInstance = analyticsProvider.getImmediate();
        if ((0, $156de25e040d63b6$export$9cb4719e2e525b7a)(options, analyticsProvider.getOptions())) return existingInstance;
        else throw $ece272441bf93110$var$ERROR_FACTORY.create("already-initialized" /* AnalyticsError.ALREADY_INITIALIZED */ );
    }
    const analyticsInstance = analyticsProvider.initialize({
        options: options
    });
    return analyticsInstance;
}
/**
 * This is a public static method provided to users that wraps four different checks:
 *
 * 1. Check if it's not a browser extension environment.
 * 2. Check if cookies are enabled in current browser.
 * 3. Check if IndexedDB is supported by the browser environment.
 * 4. Check if the current browser context is valid for using `IndexedDB.open()`.
 *
 * @public
 *
 */ async function $ece272441bf93110$export$48c17662a6902497() {
    if ((0, $156de25e040d63b6$export$caa8774a9107a58e)()) return false;
    if (!(0, $156de25e040d63b6$export$f172b7eb6cf60599)()) return false;
    if (!(0, $156de25e040d63b6$export$3865db50535c2055)()) return false;
    try {
        const isDBOpenable = await (0, $156de25e040d63b6$export$a8a3018f3d187a4d)();
        return isDBOpenable;
    } catch (error) {
        return false;
    }
}
/**
 * Use gtag `config` command to set `screen_name`.
 *
 * @public
 *
 * @deprecated Use {@link logEvent} with `eventName` as 'screen_view' and add relevant `eventParams`.
 * See {@link https://firebase.google.com/docs/analytics/screenviews | Track Screenviews}.
 *
 * @param analyticsInstance - The {@link Analytics} instance.
 * @param screenName - Screen name to set.
 */ function $ece272441bf93110$export$a364c5ef84862575(analyticsInstance, screenName, options) {
    analyticsInstance = (0, $156de25e040d63b6$export$4befe9b5fa509a1b)(analyticsInstance);
    $ece272441bf93110$var$setCurrentScreen$1($ece272441bf93110$var$wrappedGtagFunction, $ece272441bf93110$var$initializationPromisesMap[analyticsInstance.app.options.appId], screenName, options).catch((e)=>$ece272441bf93110$var$logger.error(e));
}
/**
 * Retrieves a unique Google Analytics identifier for the web client.
 * See {@link https://developers.google.com/analytics/devguides/collection/ga4/reference/config#client_id | client_id}.
 *
 * @public
 *
 * @param app - The {@link @firebase/app#FirebaseApp} to use.
 */ async function $ece272441bf93110$export$108b704ce5c937fe(analyticsInstance) {
    analyticsInstance = (0, $156de25e040d63b6$export$4befe9b5fa509a1b)(analyticsInstance);
    return $ece272441bf93110$var$internalGetGoogleAnalyticsClientId($ece272441bf93110$var$wrappedGtagFunction, $ece272441bf93110$var$initializationPromisesMap[analyticsInstance.app.options.appId]);
}
/**
 * Use gtag `config` command to set `user_id`.
 *
 * @public
 *
 * @param analyticsInstance - The {@link Analytics} instance.
 * @param id - User ID to set.
 */ function $ece272441bf93110$export$7f5abdb7f5093137(analyticsInstance, id, options) {
    analyticsInstance = (0, $156de25e040d63b6$export$4befe9b5fa509a1b)(analyticsInstance);
    $ece272441bf93110$var$setUserId$1($ece272441bf93110$var$wrappedGtagFunction, $ece272441bf93110$var$initializationPromisesMap[analyticsInstance.app.options.appId], id, options).catch((e)=>$ece272441bf93110$var$logger.error(e));
}
/**
 * Use gtag `config` command to set all params specified.
 *
 * @public
 */ function $ece272441bf93110$export$d0e176862bf869b8(analyticsInstance, properties, options) {
    analyticsInstance = (0, $156de25e040d63b6$export$4befe9b5fa509a1b)(analyticsInstance);
    $ece272441bf93110$var$setUserProperties$1($ece272441bf93110$var$wrappedGtagFunction, $ece272441bf93110$var$initializationPromisesMap[analyticsInstance.app.options.appId], properties, options).catch((e)=>$ece272441bf93110$var$logger.error(e));
}
/**
 * Sets whether Google Analytics collection is enabled for this app on this device.
 * Sets global `window['ga-disable-analyticsId'] = true;`
 *
 * @public
 *
 * @param analyticsInstance - The {@link Analytics} instance.
 * @param enabled - If true, enables collection, if false, disables it.
 */ function $ece272441bf93110$export$7d544a250c4ed423(analyticsInstance, enabled) {
    analyticsInstance = (0, $156de25e040d63b6$export$4befe9b5fa509a1b)(analyticsInstance);
    $ece272441bf93110$var$setAnalyticsCollectionEnabled$1($ece272441bf93110$var$initializationPromisesMap[analyticsInstance.app.options.appId], enabled).catch((e)=>$ece272441bf93110$var$logger.error(e));
}
/**
 * Adds data that will be set on every event logged from the SDK, including automatic ones.
 * With gtag's "set" command, the values passed persist on the current page and are passed with
 * all subsequent events.
 * @public
 * @param customParams - Any custom params the user may pass to gtag.js.
 */ function $ece272441bf93110$export$9bde4a1551d6c3ba(customParams) {
    // Check if reference to existing gtag function on window object exists
    if ($ece272441bf93110$var$wrappedGtagFunction) $ece272441bf93110$var$wrappedGtagFunction("set" /* GtagCommand.SET */ , customParams);
    else $ece272441bf93110$var$_setDefaultEventParametersForInit(customParams);
}
/**
 * Sends a Google Analytics event with given `eventParams`. This method
 * automatically associates this logged event with this Firebase web
 * app instance on this device.
 * List of official event parameters can be found in the gtag.js
 * reference documentation:
 * {@link https://developers.google.com/gtagjs/reference/ga4-events
 * | the GA4 reference documentation}.
 *
 * @public
 */ function $ece272441bf93110$export$5e9eec8001665ac5(analyticsInstance, eventName, eventParams, options) {
    analyticsInstance = (0, $156de25e040d63b6$export$4befe9b5fa509a1b)(analyticsInstance);
    $ece272441bf93110$var$logEvent$1($ece272441bf93110$var$wrappedGtagFunction, $ece272441bf93110$var$initializationPromisesMap[analyticsInstance.app.options.appId], eventName, eventParams, options).catch((e)=>$ece272441bf93110$var$logger.error(e));
}
/**
 * Sets the applicable end user consent state for this web app across all gtag references once
 * Firebase Analytics is initialized.
 *
 * Use the {@link ConsentSettings} to specify individual consent type values. By default consent
 * types are set to "granted".
 * @public
 * @param consentSettings - Maps the applicable end user consent state for gtag.js.
 */ function $ece272441bf93110$export$ff06c4c0781050d7(consentSettings) {
    // Check if reference to existing gtag function on window object exists
    if ($ece272441bf93110$var$wrappedGtagFunction) $ece272441bf93110$var$wrappedGtagFunction("consent" /* GtagCommand.CONSENT */ , 'update', consentSettings);
    else $ece272441bf93110$var$_setConsentDefaultForInit(consentSettings);
}
const $ece272441bf93110$var$name = "@firebase/analytics";
const $ece272441bf93110$var$version = "0.10.17";
/**
 * The Firebase Analytics Web SDK.
 * This SDK does not work in a Node.js environment.
 *
 * @packageDocumentation
 */ function $ece272441bf93110$var$registerAnalytics() {
    (0, $48fcf96884780cca$export$c930050e7bb63965)(new (0, $90e6a618aa3f286c$export$16fa2f45be04daa8)($ece272441bf93110$var$ANALYTICS_TYPE, (container, { options: analyticsOptions })=>{
        // getImmediate for FirebaseApp will always succeed
        const app = container.getProvider('app').getImmediate();
        const installations = container.getProvider('installations-internal').getImmediate();
        return $ece272441bf93110$var$factory(app, installations, analyticsOptions);
    }, "PUBLIC" /* ComponentType.PUBLIC */ ));
    (0, $48fcf96884780cca$export$c930050e7bb63965)(new (0, $90e6a618aa3f286c$export$16fa2f45be04daa8)('analytics-internal', internalFactory, "PRIVATE" /* ComponentType.PRIVATE */ ));
    (0, $48fcf96884780cca$export$d29d5299a7137abc)($ece272441bf93110$var$name, $ece272441bf93110$var$version);
    // BUILD_TARGET will be replaced by values like esm2017, cjs2017, etc during the compilation
    (0, $48fcf96884780cca$export$d29d5299a7137abc)($ece272441bf93110$var$name, $ece272441bf93110$var$version, 'esm2017');
    function internalFactory(container) {
        try {
            const analytics = container.getProvider($ece272441bf93110$var$ANALYTICS_TYPE).getImmediate();
            return {
                logEvent: (eventName, eventParams, options)=>$ece272441bf93110$export$5e9eec8001665ac5(analytics, eventName, eventParams, options)
            };
        } catch (e) {
            throw $ece272441bf93110$var$ERROR_FACTORY.create("interop-component-reg-failed" /* AnalyticsError.INTEROP_COMPONENT_REG_FAILED */ , {
                reason: e
            });
        }
    }
}
$ece272441bf93110$var$registerAnalytics();





// https://firebase.google.com/docs/web/setup#available-libraries
// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const $0efbd8a8be009329$var$firebaseConfig = {
    apiKey: "AIzaSyCK_MqJtbOgcAVrF_iaKkzZCZe3dYjZVzY",
    authDomain: "casa-web-dashboard.firebaseapp.com",
    projectId: "casa-web-dashboard",
    storageBucket: "casa-web-dashboard.firebasestorage.app",
    messagingSenderId: "515185483111",
    appId: "1:515185483111:web:1c59b727f5e887286c23c2",
    measurementId: "G-1WC9FT04BW"
};
const $0efbd8a8be009329$var$userAttributesToInclude = {
    'EmailAddress': true,
    'FullName': true,
    'Id': true,
    'OrgCode': true,
    'Role': true
};
// Tenants that have opted out of Google Analytics entirely, as a comma separated
// list of org codes baked in at build time (Bitbucket deployment variable).
// Empty/absent means GA stays enabled for everyone, i.e. no behaviour change.
const $0efbd8a8be009329$var$disabledOrgs = new Set("34468,79719,80218,71154".split(',').map((orgCode)=>orgCode.trim().toUpperCase()).filter(Boolean));
let $0efbd8a8be009329$var$blocked = null;
// The firebase SDK only injects the googletagmanager gtag script on the first
// getAnalytics() call, so gating every getAnalytics() call here blocks GA
// completely: no script download, no cookies, no hits. OrgCode comes from
// localStorage synchronously, so it is already known by the time anything
// renders.
const $0efbd8a8be009329$var$isBlocked = ()=>{
    if ($0efbd8a8be009329$var$disabledOrgs.size === 0) return false;
    if ($0efbd8a8be009329$var$blocked === null) {
        const orgCode = (0, $8a9518f7458123dc$export$714d3544202969b)()?.OrgCode;
        // Until the tenant is known, stay blocked rather than risk a leak, and
        // do not memoise so a later call can resolve it properly.
        if (!orgCode) return true;
        $0efbd8a8be009329$var$blocked = $0efbd8a8be009329$var$disabledOrgs.has(String(orgCode).trim().toUpperCase());
    }
    return $0efbd8a8be009329$var$blocked;
};
// initializeApp is deliberately unconditional: it loads no gtag, sets no cookies
// and makes no network call, and gating it would leave a later getAnalytics() to
// throw on an uninitialised app if the tenant only resolves after mount.
const $0efbd8a8be009329$var$init = ()=>{
    (0, $48fcf96884780cca$export$c55cfd413944906d)($0efbd8a8be009329$var$firebaseConfig);
};
const $0efbd8a8be009329$var$sendEvent = (action, payload)=>{
    {
        if ($0efbd8a8be009329$var$isBlocked()) return;
        const analytics = (0, $ece272441bf93110$export$b0297573c90085aa)();
        const finalPayload = {
            project: "casa_end_user_dashboard",
            ...payload
        };
        (0, $ece272441bf93110$export$5e9eec8001665ac5)(analytics, action, finalPayload);
    }
};
const $0efbd8a8be009329$var$setUser = (user)=>{
    if (!user || $0efbd8a8be009329$var$isBlocked()) return;
    const analytics = (0, $ece272441bf93110$export$b0297573c90085aa)();
    (0, $ece272441bf93110$export$7f5abdb7f5093137)(analytics, user.Id);
    for(let key in user){
        const userProp = {
            [key]: user[key]
        };
        if ($0efbd8a8be009329$var$userAttributesToInclude[key]) (0, $ece272441bf93110$export$d0e176862bf869b8)(analytics, userProp);
    }
};
var $0efbd8a8be009329$export$2e2bcd8739ae039 = {
    init: $0efbd8a8be009329$var$init,
    sendEvent: $0efbd8a8be009329$var$sendEvent,
    setUser: $0efbd8a8be009329$var$setUser
};


function $10caf7b1ba15e44b$export$2e2bcd8739ae039({ widget: widget, activeDashboardId: activeDashboardId }) {
    const { config: config = {} } = widget;
    const { bannerData: bannerData, loading: loading, reloadImage: reloadImage } = (0, $83e7ad590f94dc0f$export$2e2bcd8739ae039)(widget, activeDashboardId);
    const onBannerClick = ()=>{
        (0, $b61f740b64a51955$export$aadfb17cbf18b44d)(config);
        const analyticsData = {
            category: "widget_click",
            type: "click"
        };
        (0, $0efbd8a8be009329$export$2e2bcd8739ae039).sendEvent(`banner widget clicked`, analyticsData);
    };
    return /*#__PURE__*/ (0, $7Tw3V.jsxs)("div", {
        className: `banner-container ${config?.navigateTo && "navigate-to"} ${config?.showFrame && "show-frame"}`,
        role: "banner",
        children: [
            /*#__PURE__*/ (0, $7Tw3V.jsx)("div", {
                className: "image-container",
                onClick: onBannerClick,
                children: loading || !bannerData?.imageURL ? /*#__PURE__*/ (0, $7Tw3V.jsx)("span", {
                    className: "overflow-ellipsis",
                    children: config.name || "Banner"
                }) : /*#__PURE__*/ (0, $7Tw3V.jsx)("img", {
                    src: `${bannerData?.imageURL}`,
                    alt: "img",
                    onError: reloadImage
                })
            }),
            config.name && /*#__PURE__*/ (0, $7Tw3V.jsx)((0, $f1c5bbf999dfd19f$export$2e2bcd8739ae039), {
                className: 'banner-name',
                text: config.name
            })
        ]
    });
}



var $7Tw3V = parcelRequire("7Tw3V");

var $cQQee = parcelRequire("cQQee");
var $499aff9742b81a59$var$__defProp = Object.defineProperty;
var $499aff9742b81a59$var$__name = (target, value)=>$499aff9742b81a59$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
// src/primitive.tsx
var $499aff9742b81a59$export$71594e8a50f746f4 = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function $499aff9742b81a59$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented: checkForDefaultPrevented = true } = {}) {
    return /* @__PURE__ */ $499aff9742b81a59$var$__name(function handleEvent(event) {
        originalEventHandler?.(event);
        if (checkForDefaultPrevented === false || !event || !event.defaultPrevented) return ourEventHandler?.(event);
    }, "handleEvent");
}
$499aff9742b81a59$var$__name($499aff9742b81a59$export$b9ecd428b558ff10, "composeEventHandlers");
function $499aff9742b81a59$export$f21a1ffae260145a(element) {
    if (!$499aff9742b81a59$export$71594e8a50f746f4) throw new Error("Cannot access window outside of the DOM");
    return element?.ownerDocument?.defaultView ?? window;
}
$499aff9742b81a59$var$__name($499aff9742b81a59$export$f21a1ffae260145a, "getOwnerWindow");
function $499aff9742b81a59$export$b204af158042fbac(element) {
    if (!$499aff9742b81a59$export$71594e8a50f746f4) throw new Error("Cannot access document outside of the DOM");
    return element?.ownerDocument ?? document;
}
$499aff9742b81a59$var$__name($499aff9742b81a59$export$b204af158042fbac, "getOwnerDocument");
function $499aff9742b81a59$export$cd4e5573fbe2b576(node, activeDescendant = false) {
    const { activeElement: activeElement } = $499aff9742b81a59$export$b204af158042fbac(node);
    if (!activeElement?.nodeName) return null;
    if ($499aff9742b81a59$export$6a12f24039de8f3a(activeElement) && activeElement.contentDocument) return $499aff9742b81a59$export$cd4e5573fbe2b576(activeElement.contentDocument.body, activeDescendant);
    if (activeDescendant) {
        const id = activeElement.getAttribute("aria-activedescendant");
        if (id) {
            const element = $499aff9742b81a59$export$b204af158042fbac(activeElement).getElementById(id);
            if (element) return element;
        }
    }
    return activeElement;
}
$499aff9742b81a59$var$__name($499aff9742b81a59$export$cd4e5573fbe2b576, "getActiveElement");
function $499aff9742b81a59$export$6a12f24039de8f3a(element) {
    return element.tagName === "IFRAME";
}
$499aff9742b81a59$var$__name($499aff9742b81a59$export$6a12f24039de8f3a, "isFrame");



var $cQQee = parcelRequire("cQQee");
var $898ea3439c4e83fa$var$__defProp = Object.defineProperty;
var $898ea3439c4e83fa$var$__name = (target, value)=>$898ea3439c4e83fa$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
function $898ea3439c4e83fa$var$setRef(ref, value) {
    if (typeof ref === "function") return ref(value);
    else if (ref !== null && ref !== void 0) ref.current = value;
}
$898ea3439c4e83fa$var$__name($898ea3439c4e83fa$var$setRef, "setRef");
function $898ea3439c4e83fa$export$43e446d32b3d21af(...refs) {
    return (node)=>{
        let hasCleanup = false;
        const cleanups = refs.map((ref)=>{
            const cleanup = $898ea3439c4e83fa$var$setRef(ref, node);
            if (!hasCleanup && typeof cleanup == "function") hasCleanup = true;
            return cleanup;
        });
        if (hasCleanup) return ()=>{
            for(let i = 0; i < cleanups.length; i++){
                const cleanup = cleanups[i];
                if (typeof cleanup == "function") cleanup();
                else $898ea3439c4e83fa$var$setRef(refs[i], null);
            }
        };
    };
}
$898ea3439c4e83fa$var$__name($898ea3439c4e83fa$export$43e446d32b3d21af, "composeRefs");
function $898ea3439c4e83fa$export$c7b2cbe3552a0d05(...refs) {
    return $cQQee.useCallback($898ea3439c4e83fa$export$43e446d32b3d21af(...refs), refs);
}
$898ea3439c4e83fa$var$__name($898ea3439c4e83fa$export$c7b2cbe3552a0d05, "useComposedRefs");



var $cQQee = parcelRequire("cQQee");

var $7Tw3V = parcelRequire("7Tw3V");
var $b23ab9d11414cfe7$var$__defProp = Object.defineProperty;
var $b23ab9d11414cfe7$var$__name = (target, value)=>$b23ab9d11414cfe7$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
// @__NO_SIDE_EFFECTS__
function $b23ab9d11414cfe7$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const Context = $cQQee.createContext(defaultContext);
    Context.displayName = rootComponentName + "Context";
    const Provider = /* @__PURE__ */ $b23ab9d11414cfe7$var$__name((props)=>{
        const { children: children, ...context } = props;
        const value = $cQQee.useMemo(()=>context, Object.values(context));
        return /* @__PURE__ */ (0, $7Tw3V.jsx)(Context.Provider, {
            value: value,
            children: children
        });
    }, "Provider");
    Provider.displayName = rootComponentName + "Provider";
    function useContext2(consumerName, options = {}) {
        const { optional: optional = false } = options;
        const context = $cQQee.useContext(Context);
        if (context) return context;
        if (defaultContext !== void 0) return defaultContext;
        if (optional) return void 0;
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    $b23ab9d11414cfe7$var$__name(useContext2, "useContext");
    return [
        Provider,
        useContext2
    ];
}
$b23ab9d11414cfe7$var$__name($b23ab9d11414cfe7$export$fd42f52fd3ae1109, "createContext");
// @__NO_SIDE_EFFECTS__
function $b23ab9d11414cfe7$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    function createContext3(rootComponentName, defaultContext) {
        const BaseContext = $cQQee.createContext(defaultContext);
        BaseContext.displayName = rootComponentName + "Context";
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        const Provider = /* @__PURE__ */ $b23ab9d11414cfe7$var$__name((props)=>{
            const { scope: scope, children: children, ...context } = props;
            const Context = scope?.[scopeName]?.[index] || BaseContext;
            const value = $cQQee.useMemo(()=>context, Object.values(context));
            return /* @__PURE__ */ (0, $7Tw3V.jsx)(Context.Provider, {
                value: value,
                children: children
            });
        }, "Provider");
        Provider.displayName = rootComponentName + "Provider";
        function useContext2(consumerName, scope, options = {}) {
            const { optional: optional = false } = options;
            const Context = scope?.[scopeName]?.[index] || BaseContext;
            const context = $cQQee.useContext(Context);
            if (context) return context;
            if (defaultContext !== void 0) return defaultContext;
            if (optional) return void 0;
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        $b23ab9d11414cfe7$var$__name(useContext2, "useContext");
        return [
            Provider,
            useContext2
        ];
    }
    $b23ab9d11414cfe7$var$__name(createContext3, "createContext");
    const createScope = /* @__PURE__ */ $b23ab9d11414cfe7$var$__name(()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return $cQQee.createContext(defaultContext);
        });
        return /* @__PURE__ */ $b23ab9d11414cfe7$var$__name(function useScope(scope) {
            const contexts = scope?.[scopeName] || scopeContexts;
            return $cQQee.useMemo(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                }), [
                scope,
                contexts
            ]);
        }, "useScope");
    }, "createScope");
    createScope.scopeName = scopeName;
    return [
        createContext3,
        $b23ab9d11414cfe7$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
$b23ab9d11414cfe7$var$__name($b23ab9d11414cfe7$export$50c7b4e9d9f19c1, "createContextScope");
function $b23ab9d11414cfe7$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope = /* @__PURE__ */ $b23ab9d11414cfe7$var$__name(()=>{
        const scopeHooks = scopes.map((createScope2)=>({
                useScope: createScope2(),
                scopeName: createScope2.scopeName
            }));
        return /* @__PURE__ */ $b23ab9d11414cfe7$var$__name(function useComposedScopes(overrideScopes) {
            const nextScopes = scopeHooks.reduce((nextScopes2, { useScope: useScope, scopeName: scopeName })=>{
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes2,
                    ...currentScope
                };
            }, {});
            return $cQQee.useMemo(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes
                }), [
                nextScopes
            ]);
        }, "useComposedScopes");
    }, "createScope");
    createScope.scopeName = baseScope.scopeName;
    return createScope;
}
$b23ab9d11414cfe7$var$__name($b23ab9d11414cfe7$var$composeContextScopes, "composeContextScopes");



var $cQQee = parcelRequire("cQQee");


var $cQQee = parcelRequire("cQQee");

var $kC364 = parcelRequire("kC364");

var $cQQee = parcelRequire("cQQee");

var $3611aa24d70d795c$var$__defProp = Object.defineProperty;
var $3611aa24d70d795c$var$__name = (target, value)=>$3611aa24d70d795c$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
// @__NO_SIDE_EFFECTS__
function $3611aa24d70d795c$export$e88b45bda5c13eb9(ownerName) {
    const Slot2 = $cQQee.forwardRef((props, forwardedRef)=>{
        let { children: children, ...slotProps } = props;
        let slottableElement = null;
        let hasSlottable = false;
        const newChildren = [];
        if ($3611aa24d70d795c$var$isLazyComponent(children) && typeof $3611aa24d70d795c$var$use === "function") children = $3611aa24d70d795c$var$use(children._payload);
        $cQQee.Children.forEach(children, (maybeSlottable)=>{
            if ($3611aa24d70d795c$var$isSlottable(maybeSlottable)) {
                hasSlottable = true;
                const slottable = maybeSlottable;
                let child = "child" in slottable.props ? slottable.props.child : slottable.props.children;
                if ($3611aa24d70d795c$var$isLazyComponent(child) && typeof $3611aa24d70d795c$var$use === "function") child = $3611aa24d70d795c$var$use(child._payload);
                slottableElement = $3611aa24d70d795c$var$getSlottableElementFromSlottable(slottable, child);
                newChildren.push(slottableElement?.props?.children);
            } else newChildren.push(maybeSlottable);
        });
        if (slottableElement) slottableElement = $cQQee.cloneElement(slottableElement, void 0, newChildren);
        else if (// A `Slottable` was found but it didn't resolve to a single element (e.g.
        // it wrapped multiple elements, text, or a render-prop `child` that
        // wasn't an element). Don't fall back to treating the `Slottable` wrapper
        // itself as the slot target — throw a descriptive error below instead.
        !hasSlottable && $cQQee.Children.count(children) === 1 && $cQQee.isValidElement(children)) slottableElement = children;
        const slottableElementRef = slottableElement ? $3611aa24d70d795c$var$getElementRef(slottableElement) : void 0;
        const composedRef = (0, $898ea3439c4e83fa$export$c7b2cbe3552a0d05)(forwardedRef, slottableElementRef);
        if (!slottableElement) {
            if (children || children === 0) throw new Error(hasSlottable ? $3611aa24d70d795c$var$createSlottableError(ownerName) : $3611aa24d70d795c$var$createSlotError(ownerName));
            return children;
        }
        const mergedProps = $3611aa24d70d795c$var$mergeProps(slotProps, slottableElement.props ?? {});
        if (slottableElement.type !== $cQQee.Fragment) mergedProps.ref = forwardedRef ? composedRef : slottableElementRef;
        return $cQQee.cloneElement(slottableElement, mergedProps);
    });
    Slot2.displayName = `${ownerName}.Slot`;
    return Slot2;
}
$3611aa24d70d795c$var$__name($3611aa24d70d795c$export$e88b45bda5c13eb9, "createSlot");
var $3611aa24d70d795c$export$be92b6f5f03c0fe9 = /* @__PURE__ */ $3611aa24d70d795c$export$e88b45bda5c13eb9("Slot");
var $3611aa24d70d795c$var$SLOTTABLE_IDENTIFIER = Symbol.for("radix.slottable");
// @__NO_SIDE_EFFECTS__
function $3611aa24d70d795c$export$bf68c29d8281d0f7(ownerName) {
    const Slottable2 = /* @__PURE__ */ $3611aa24d70d795c$var$__name((props)=>"child" in props ? props.children(props.child) : props.children, "Slottable");
    Slottable2.displayName = `${ownerName}.Slottable`;
    Slottable2.__radixId = $3611aa24d70d795c$var$SLOTTABLE_IDENTIFIER;
    return Slottable2;
}
$3611aa24d70d795c$var$__name($3611aa24d70d795c$export$bf68c29d8281d0f7, "createSlottable");
var $3611aa24d70d795c$export$d9f1ccf0bdb05d45 = /* @__PURE__ */ $3611aa24d70d795c$export$bf68c29d8281d0f7("Slottable");
var $3611aa24d70d795c$var$getSlottableElementFromSlottable = /* @__PURE__ */ $3611aa24d70d795c$var$__name((slottable, child)=>{
    if ("child" in slottable.props) {
        const child2 = slottable.props.child;
        if (!$cQQee.isValidElement(child2)) return null;
        return $cQQee.cloneElement(child2, void 0, slottable.props.children(child2.props.children));
    }
    return $cQQee.isValidElement(child) ? child : null;
}, "getSlottableElementFromSlottable");
function $3611aa24d70d795c$var$mergeProps(slotProps, childProps) {
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            if (slotPropValue && childPropValue) overrideProps[propName] = (...args)=>{
                const result = childPropValue(...args);
                slotPropValue(...args);
                return result;
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === "style") overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === "className") overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(" ");
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
$3611aa24d70d795c$var$__name($3611aa24d70d795c$var$mergeProps, "mergeProps");
function $3611aa24d70d795c$var$getElementRef(element) {
    let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}
$3611aa24d70d795c$var$__name($3611aa24d70d795c$var$getElementRef, "getElementRef");
function $3611aa24d70d795c$var$isSlottable(child) {
    return $cQQee.isValidElement(child) && typeof child.type === "function" && "__radixId" in child.type && child.type.__radixId === $3611aa24d70d795c$var$SLOTTABLE_IDENTIFIER;
}
$3611aa24d70d795c$var$__name($3611aa24d70d795c$var$isSlottable, "isSlottable");
var $3611aa24d70d795c$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
function $3611aa24d70d795c$var$isLazyComponent(element) {
    return element != null && typeof element === "object" && "$$typeof" in element && element.$$typeof === $3611aa24d70d795c$var$REACT_LAZY_TYPE && "_payload" in element && $3611aa24d70d795c$var$isPromiseLike(element._payload);
}
$3611aa24d70d795c$var$__name($3611aa24d70d795c$var$isLazyComponent, "isLazyComponent");
function $3611aa24d70d795c$var$isPromiseLike(value) {
    return typeof value === "object" && value !== null && "then" in value;
}
$3611aa24d70d795c$var$__name($3611aa24d70d795c$var$isPromiseLike, "isPromiseLike");
var $3611aa24d70d795c$var$createSlotError = /* @__PURE__ */ $3611aa24d70d795c$var$__name((ownerName)=>{
    return `${ownerName} failed to slot onto its children. Expected a single React element child or \`Slottable\`.`;
}, "createSlotError");
var $3611aa24d70d795c$var$createSlottableError = /* @__PURE__ */ $3611aa24d70d795c$var$__name((ownerName)=>{
    return `${ownerName} failed to slot onto its \`Slottable\`. Expected \`Slottable\` to receive a single React element child.`;
}, "createSlottableError");
var $3611aa24d70d795c$var$use = $cQQee[" use ".trim().toString()];



var $7Tw3V = parcelRequire("7Tw3V");
var $a8cf614ad7e764cf$var$__defProp = Object.defineProperty;
var $a8cf614ad7e764cf$var$__name = (target, value)=>$a8cf614ad7e764cf$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
var $a8cf614ad7e764cf$var$NODES = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "select",
    "span",
    "svg",
    "ul"
];
var $a8cf614ad7e764cf$export$250ffa63cdc0d034 = $a8cf614ad7e764cf$var$NODES.reduce((primitive, node)=>{
    const Slot = (0, $3611aa24d70d795c$export$e88b45bda5c13eb9)(`Primitive.${node}`);
    const Node = $cQQee.forwardRef((props, forwardedRef)=>{
        const { asChild: asChild, ...primitiveProps } = props;
        const Comp = asChild ? Slot : node;
        if (typeof window !== "undefined") window[Symbol.for("radix-ui")] = true;
        return /* @__PURE__ */ (0, $7Tw3V.jsx)(Comp, {
            ...primitiveProps,
            ref: forwardedRef
        });
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
function $a8cf614ad7e764cf$export$6d1a0317bde7de7f(target, event) {
    if (target) $kC364.flushSync(()=>target.dispatchEvent(event));
}
$a8cf614ad7e764cf$var$__name($a8cf614ad7e764cf$export$6d1a0317bde7de7f, "dispatchDiscreteCustomEvent");
var $a8cf614ad7e764cf$export$be92b6f5f03c0fe9 = $a8cf614ad7e764cf$export$250ffa63cdc0d034;




var $cQQee = parcelRequire("cQQee");
var $2c2ab34d464a7123$var$__defProp = Object.defineProperty;
var $2c2ab34d464a7123$var$__name = (target, value)=>$2c2ab34d464a7123$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
function $2c2ab34d464a7123$export$25bec8c6f54ee79a(callback) {
    const callbackRef = $cQQee.useRef(callback);
    $cQQee.useEffect(()=>{
        callbackRef.current = callback;
    });
    return $cQQee.useMemo(()=>(...args)=>callbackRef.current?.(...args), []);
}
$2c2ab34d464a7123$var$__name($2c2ab34d464a7123$export$25bec8c6f54ee79a, "useCallbackRef");



var $7Tw3V = parcelRequire("7Tw3V");
"use client";
var $0bf4fdec12e296d5$var$__defProp = Object.defineProperty;
var $0bf4fdec12e296d5$var$__name = (target, value)=>$0bf4fdec12e296d5$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
var $0bf4fdec12e296d5$var$CONTEXT_UPDATE = "dismissableLayer.update";
var $0bf4fdec12e296d5$var$POINTER_DOWN_OUTSIDE = "dismissableLayer.pointerDownOutside";
var $0bf4fdec12e296d5$var$FOCUS_OUTSIDE = "dismissableLayer.focusOutside";
var $0bf4fdec12e296d5$var$originalBodyPointerEvents;
var $0bf4fdec12e296d5$var$DismissableLayerContext = $cQQee.createContext({
    layers: /* @__PURE__ */ new Set(),
    layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
    branches: /* @__PURE__ */ new Set(),
    // Outside elements that belong to a layer's own dismiss affordance (eg, a
    // dialog overlay). Pressing them should dismiss the layer regardless of
    // whether or not they stop propagation.
    //
    // See https://github.com/radix-ui/primitives/issues/3346
    dismissableSurfaces: /* @__PURE__ */ new Set()
});
var $0bf4fdec12e296d5$export$177fb62ff3ec1f22 = /* @__PURE__ */ $cQQee.forwardRef(// blank line to reduce diff noise
/* @__PURE__ */ $0bf4fdec12e296d5$var$__name(function DismissableLayer2(props, forwardedRef) {
    const { disableOutsidePointerEvents: disableOutsidePointerEvents = false, deferPointerDownOutside: deferPointerDownOutside = false, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, onFocusOutside: onFocusOutside, onInteractOutside: onInteractOutside, onDismiss: onDismiss, ...layerProps } = props;
    const context = $cQQee.useContext($0bf4fdec12e296d5$var$DismissableLayerContext);
    const [node, setNode] = $cQQee.useState(null);
    const ownerDocument = node?.ownerDocument ?? globalThis?.document;
    const [, force] = $cQQee.useState({});
    const composedRefs = (0, $898ea3439c4e83fa$export$c7b2cbe3552a0d05)(forwardedRef, setNode);
    const layers = Array.from(context.layers);
    const [highestLayerWithOutsidePointerEventsDisabled] = [
        ...context.layersWithOutsidePointerEventsDisabled
    ].slice(-1);
    const highestLayerWithOutsidePointerEventsDisabledIndex = highestLayerWithOutsidePointerEventsDisabled ? layers.indexOf(highestLayerWithOutsidePointerEventsDisabled) : -1;
    const index = node ? layers.indexOf(node) : -1;
    const isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0;
    const isPointerEventsEnabled = index >= highestLayerWithOutsidePointerEventsDisabledIndex;
    const isDeferredPointerDownOutsideRef = $cQQee.useRef(false);
    const pointerDownOutside = $0bf4fdec12e296d5$var$usePointerDownOutside((event)=>{
        onPointerDownOutside?.(event);
        onInteractOutside?.(event);
        if (!event.defaultPrevented) onDismiss?.();
    }, {
        ownerDocument: ownerDocument,
        deferPointerDownOutside: deferPointerDownOutside,
        isDeferredPointerDownOutsideRef: isDeferredPointerDownOutsideRef,
        dismissableSurfaces: context.dismissableSurfaces,
        shouldHandlePointerDownOutside: $cQQee.useCallback((target)=>{
            if (!(target instanceof Node)) return false;
            const isPointerDownOnBranch = [
                ...context.branches
            ].some((branch)=>branch.contains(target));
            return isPointerEventsEnabled && !isPointerDownOnBranch;
        }, [
            context.branches,
            isPointerEventsEnabled
        ])
    });
    const focusOutside = $0bf4fdec12e296d5$var$useFocusOutside((event)=>{
        if (deferPointerDownOutside && isDeferredPointerDownOutsideRef.current) return;
        const target = event.target;
        const isFocusInBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (isFocusInBranch) return;
        onFocusOutside?.(event);
        onInteractOutside?.(event);
        if (!event.defaultPrevented) onDismiss?.();
    }, ownerDocument);
    const isHighestLayer = node ? index === layers.length - 1 : false;
    const handleKeyDown = (0, $2c2ab34d464a7123$export$25bec8c6f54ee79a)((event)=>{
        if (event.key !== "Escape") return;
        onEscapeKeyDown?.(event);
        if (!event.defaultPrevented && onDismiss) {
            event.preventDefault();
            onDismiss();
        }
    });
    $cQQee.useEffect(()=>{
        if (!isHighestLayer) return;
        ownerDocument.addEventListener("keydown", handleKeyDown, {
            capture: true
        });
        return ()=>ownerDocument.removeEventListener("keydown", handleKeyDown, {
                capture: true
            });
    }, [
        ownerDocument,
        isHighestLayer,
        handleKeyDown
    ]);
    $cQQee.useEffect(()=>{
        if (!node) return;
        if (disableOutsidePointerEvents) {
            if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
                $0bf4fdec12e296d5$var$originalBodyPointerEvents = ownerDocument.body.style.pointerEvents;
                ownerDocument.body.style.pointerEvents = "none";
            }
            context.layersWithOutsidePointerEventsDisabled.add(node);
        }
        context.layers.add(node);
        $0bf4fdec12e296d5$var$dispatchUpdate();
        return ()=>{
            if (disableOutsidePointerEvents) {
                context.layersWithOutsidePointerEventsDisabled.delete(node);
                if (context.layersWithOutsidePointerEventsDisabled.size === 0) ownerDocument.body.style.pointerEvents = $0bf4fdec12e296d5$var$originalBodyPointerEvents;
            }
        };
    }, [
        node,
        ownerDocument,
        disableOutsidePointerEvents,
        context
    ]);
    $cQQee.useEffect(()=>{
        return ()=>{
            if (!node) return;
            context.layers.delete(node);
            context.layersWithOutsidePointerEventsDisabled.delete(node);
            $0bf4fdec12e296d5$var$dispatchUpdate();
        };
    }, [
        node,
        context
    ]);
    $cQQee.useEffect(()=>{
        const handleUpdate = /* @__PURE__ */ $0bf4fdec12e296d5$var$__name(()=>force({}), "handleUpdate");
        document.addEventListener($0bf4fdec12e296d5$var$CONTEXT_UPDATE, handleUpdate);
        return ()=>document.removeEventListener($0bf4fdec12e296d5$var$CONTEXT_UPDATE, handleUpdate);
    }, []);
    return /* @__PURE__ */ (0, $7Tw3V.jsx)((0, $a8cf614ad7e764cf$export$250ffa63cdc0d034).div, {
        ...layerProps,
        ref: composedRefs,
        style: {
            pointerEvents: isBodyPointerEventsDisabled ? isPointerEventsEnabled ? "auto" : "none" : void 0,
            ...props.style
        },
        onFocusCapture: (0, $499aff9742b81a59$export$b9ecd428b558ff10)(props.onFocusCapture, focusOutside.onFocusCapture),
        onBlurCapture: (0, $499aff9742b81a59$export$b9ecd428b558ff10)(props.onBlurCapture, focusOutside.onBlurCapture),
        onPointerDownCapture: (0, $499aff9742b81a59$export$b9ecd428b558ff10)(props.onPointerDownCapture, pointerDownOutside.onPointerDownCapture)
    });
}, "DismissableLayer"));
var $0bf4fdec12e296d5$export$4d5eb2109db14228 = /* @__PURE__ */ $cQQee.forwardRef(/* @__PURE__ */ $0bf4fdec12e296d5$var$__name(function DismissableLayerBranch2(props, forwardedRef) {
    const context = $cQQee.useContext($0bf4fdec12e296d5$var$DismissableLayerContext);
    const ref = $cQQee.useRef(null);
    const composedRefs = (0, $898ea3439c4e83fa$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    $cQQee.useEffect(()=>{
        const node = ref.current;
        if (node) {
            context.branches.add(node);
            return ()=>{
                context.branches.delete(node);
            };
        }
    }, [
        context.branches
    ]);
    return /* @__PURE__ */ (0, $7Tw3V.jsx)((0, $a8cf614ad7e764cf$export$250ffa63cdc0d034).div, {
        ...props,
        ref: composedRefs
    });
}, "DismissableLayerBranch"));
function $0bf4fdec12e296d5$export$210785236bdfcb27() {
    const context = $cQQee.useContext($0bf4fdec12e296d5$var$DismissableLayerContext);
    const [node, setNode] = $cQQee.useState(null);
    $cQQee.useEffect(()=>{
        if (!node) return;
        context.dismissableSurfaces.add(node);
        return ()=>{
            context.dismissableSurfaces.delete(node);
        };
    }, [
        node,
        context.dismissableSurfaces
    ]);
    return setNode;
}
$0bf4fdec12e296d5$var$__name($0bf4fdec12e296d5$export$210785236bdfcb27, "useDismissableLayerSurface");
var $0bf4fdec12e296d5$var$IS_TRUE = /* @__PURE__ */ $0bf4fdec12e296d5$var$__name(()=>true, "IS_TRUE");
function $0bf4fdec12e296d5$var$usePointerDownOutside(onPointerDownOutside, args) {
    const { ownerDocument: ownerDocument = globalThis?.document, deferPointerDownOutside: deferPointerDownOutside = false, isDeferredPointerDownOutsideRef: isDeferredPointerDownOutsideRef, dismissableSurfaces: dismissableSurfaces, shouldHandlePointerDownOutside: shouldHandlePointerDownOutside = $0bf4fdec12e296d5$var$IS_TRUE } = args;
    const handlePointerDownOutside = (0, $2c2ab34d464a7123$export$25bec8c6f54ee79a)(onPointerDownOutside);
    const isPointerInsideReactTreeRef = $cQQee.useRef(false);
    const isPointerDownOutsideRef = $cQQee.useRef(false);
    const interceptedOutsideInteractionEventsRef = $cQQee.useRef(/* @__PURE__ */ new Map());
    const handleClickRef = $cQQee.useRef(()=>{});
    $cQQee.useEffect(()=>{
        function resetOutsideInteraction() {
            isPointerDownOutsideRef.current = false;
            isDeferredPointerDownOutsideRef.current = false;
            interceptedOutsideInteractionEventsRef.current.clear();
        }
        $0bf4fdec12e296d5$var$__name(resetOutsideInteraction, "resetOutsideInteraction");
        function isOutsideInteractionIntercepted() {
            return Array.from(interceptedOutsideInteractionEventsRef.current.values()).some(Boolean);
        }
        $0bf4fdec12e296d5$var$__name(isOutsideInteractionIntercepted, "isOutsideInteractionIntercepted");
        function handleInteractionCapture(event) {
            if (!isPointerDownOutsideRef.current) return;
            const target = event.target;
            const isDismissableSurface = target instanceof Node && [
                ...dismissableSurfaces
            ].some((surface)=>surface.contains(target));
            if (!isDismissableSurface) interceptedOutsideInteractionEventsRef.current.set(event.type, true);
            if (event.type === "click") window.setTimeout(()=>{
                if (isPointerDownOutsideRef.current) handleClickRef.current();
            }, 0);
        }
        $0bf4fdec12e296d5$var$__name(handleInteractionCapture, "handleInteractionCapture");
        function handleInteractionBubble(event) {
            if (isPointerDownOutsideRef.current) interceptedOutsideInteractionEventsRef.current.set(event.type, false);
        }
        $0bf4fdec12e296d5$var$__name(handleInteractionBubble, "handleInteractionBubble");
        const handlePointerDown = /* @__PURE__ */ $0bf4fdec12e296d5$var$__name((event)=>{
            if (event.target && !isPointerInsideReactTreeRef.current) {
                let handleAndDispatchPointerDownOutsideEvent2 = function() {
                    ownerDocument.removeEventListener("click", handleClickRef.current);
                    const wasOutsideInteractionIntercepted = isOutsideInteractionIntercepted();
                    resetOutsideInteraction();
                    if (!wasOutsideInteractionIntercepted) $0bf4fdec12e296d5$var$handleAndDispatchCustomEvent($0bf4fdec12e296d5$var$POINTER_DOWN_OUTSIDE, handlePointerDownOutside, eventDetail, {
                        discrete: true
                    });
                };
                var handleAndDispatchPointerDownOutsideEvent = handleAndDispatchPointerDownOutsideEvent2;
                $0bf4fdec12e296d5$var$__name(handleAndDispatchPointerDownOutsideEvent2, "handleAndDispatchPointerDownOutsideEvent");
                if (!shouldHandlePointerDownOutside(event.target)) {
                    ownerDocument.removeEventListener("click", handleClickRef.current);
                    resetOutsideInteraction();
                    isPointerInsideReactTreeRef.current = false;
                    return;
                }
                const eventDetail = {
                    originalEvent: event
                };
                isPointerDownOutsideRef.current = true;
                isDeferredPointerDownOutsideRef.current = deferPointerDownOutside && event.button === 0;
                interceptedOutsideInteractionEventsRef.current.clear();
                if (!deferPointerDownOutside || event.button !== 0) handleAndDispatchPointerDownOutsideEvent2();
                else {
                    ownerDocument.removeEventListener("click", handleClickRef.current);
                    handleClickRef.current = handleAndDispatchPointerDownOutsideEvent2;
                    ownerDocument.addEventListener("click", handleClickRef.current, {
                        once: true
                    });
                }
            } else {
                ownerDocument.removeEventListener("click", handleClickRef.current);
                resetOutsideInteraction();
            }
            isPointerInsideReactTreeRef.current = false;
        }, "handlePointerDown");
        const outsideInteractionEvents = [
            "pointerup",
            "mousedown",
            "mouseup",
            "touchstart",
            "touchend",
            "click"
        ];
        for (const eventName of outsideInteractionEvents){
            ownerDocument.addEventListener(eventName, handleInteractionCapture, true);
            ownerDocument.addEventListener(eventName, handleInteractionBubble);
        }
        const timerId = window.setTimeout(()=>{
            ownerDocument.addEventListener("pointerdown", handlePointerDown);
        }, 0);
        return ()=>{
            window.clearTimeout(timerId);
            ownerDocument.removeEventListener("pointerdown", handlePointerDown);
            ownerDocument.removeEventListener("click", handleClickRef.current);
            for (const eventName of outsideInteractionEvents){
                ownerDocument.removeEventListener(eventName, handleInteractionCapture, true);
                ownerDocument.removeEventListener(eventName, handleInteractionBubble);
            }
        };
    }, [
        ownerDocument,
        handlePointerDownOutside,
        deferPointerDownOutside,
        isDeferredPointerDownOutsideRef,
        dismissableSurfaces,
        shouldHandlePointerDownOutside
    ]);
    return {
        // ensures we check React component tree (not just DOM tree)
        onPointerDownCapture: /* @__PURE__ */ $0bf4fdec12e296d5$var$__name(()=>isPointerInsideReactTreeRef.current = true, "onPointerDownCapture")
    };
}
$0bf4fdec12e296d5$var$__name($0bf4fdec12e296d5$var$usePointerDownOutside, "usePointerDownOutside");
function $0bf4fdec12e296d5$var$useFocusOutside(onFocusOutside, ownerDocument = globalThis?.document) {
    const handleFocusOutside = (0, $2c2ab34d464a7123$export$25bec8c6f54ee79a)(onFocusOutside);
    const isFocusInsideReactTreeRef = $cQQee.useRef(false);
    $cQQee.useEffect(()=>{
        const handleFocus = /* @__PURE__ */ $0bf4fdec12e296d5$var$__name((event)=>{
            if (event.target && !isFocusInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                $0bf4fdec12e296d5$var$handleAndDispatchCustomEvent($0bf4fdec12e296d5$var$FOCUS_OUTSIDE, handleFocusOutside, eventDetail, {
                    discrete: false
                });
            }
        }, "handleFocus");
        ownerDocument.addEventListener("focusin", handleFocus);
        return ()=>ownerDocument.removeEventListener("focusin", handleFocus);
    }, [
        ownerDocument,
        handleFocusOutside
    ]);
    return {
        onFocusCapture: /* @__PURE__ */ $0bf4fdec12e296d5$var$__name(()=>isFocusInsideReactTreeRef.current = true, "onFocusCapture"),
        onBlurCapture: /* @__PURE__ */ $0bf4fdec12e296d5$var$__name(()=>isFocusInsideReactTreeRef.current = false, "onBlurCapture")
    };
}
$0bf4fdec12e296d5$var$__name($0bf4fdec12e296d5$var$useFocusOutside, "useFocusOutside");
function $0bf4fdec12e296d5$var$dispatchUpdate() {
    const event = new CustomEvent($0bf4fdec12e296d5$var$CONTEXT_UPDATE);
    document.dispatchEvent(event);
}
$0bf4fdec12e296d5$var$__name($0bf4fdec12e296d5$var$dispatchUpdate, "dispatchUpdate");
function $0bf4fdec12e296d5$var$handleAndDispatchCustomEvent(name, handler, detail, { discrete: discrete }) {
    const target = detail.originalEvent.target;
    const event = new CustomEvent(name, {
        bubbles: false,
        cancelable: true,
        detail: detail
    });
    if (handler) target.addEventListener(name, handler, {
        once: true
    });
    if (discrete) (0, $a8cf614ad7e764cf$export$6d1a0317bde7de7f)(target, event);
    else target.dispatchEvent(event);
}
$0bf4fdec12e296d5$var$__name($0bf4fdec12e296d5$var$handleAndDispatchCustomEvent, "handleAndDispatchCustomEvent");
var $0bf4fdec12e296d5$export$be92b6f5f03c0fe9 = $0bf4fdec12e296d5$export$177fb62ff3ec1f22;
var $0bf4fdec12e296d5$export$aecb2ddcb55c95be = $0bf4fdec12e296d5$export$4d5eb2109db14228;



var $cQQee = parcelRequire("cQQee");
"use client";
var $50bed90f65457fd0$var$__defProp = Object.defineProperty;
var $50bed90f65457fd0$var$__name = (target, value)=>$50bed90f65457fd0$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
var $50bed90f65457fd0$var$count = 0;
var $50bed90f65457fd0$var$guards = null;
function $50bed90f65457fd0$export$ac5b58043b79449b(props) {
    $50bed90f65457fd0$export$b7ece24a22aeda8c();
    return props.children;
}
$50bed90f65457fd0$var$__name($50bed90f65457fd0$export$ac5b58043b79449b, "FocusGuards");
function $50bed90f65457fd0$export$b7ece24a22aeda8c() {
    $cQQee.useEffect(()=>{
        if (!$50bed90f65457fd0$var$guards) $50bed90f65457fd0$var$guards = {
            start: $50bed90f65457fd0$var$createFocusGuard(),
            end: $50bed90f65457fd0$var$createFocusGuard()
        };
        const { start: start, end: end } = $50bed90f65457fd0$var$guards;
        if (document.body.firstElementChild !== start) document.body.insertAdjacentElement("afterbegin", start);
        if (document.body.lastElementChild !== end) document.body.insertAdjacentElement("beforeend", end);
        $50bed90f65457fd0$var$count++;
        return ()=>{
            if ($50bed90f65457fd0$var$count === 1) {
                $50bed90f65457fd0$var$guards?.start.remove();
                $50bed90f65457fd0$var$guards?.end.remove();
                $50bed90f65457fd0$var$guards = null;
            }
            $50bed90f65457fd0$var$count = Math.max(0, $50bed90f65457fd0$var$count - 1);
        };
    }, []);
}
$50bed90f65457fd0$var$__name($50bed90f65457fd0$export$b7ece24a22aeda8c, "useFocusGuards");
function $50bed90f65457fd0$var$createFocusGuard() {
    const element = document.createElement("span");
    element.setAttribute("data-radix-focus-guard", "");
    element.tabIndex = 0;
    element.style.outline = "none";
    element.style.opacity = "0";
    element.style.position = "fixed";
    element.style.pointerEvents = "none";
    return element;
}
$50bed90f65457fd0$var$__name($50bed90f65457fd0$var$createFocusGuard, "createFocusGuard");



var $cQQee = parcelRequire("cQQee");




var $7Tw3V = parcelRequire("7Tw3V");
"use client";
var $d9d0da6206cbd1f8$var$__defProp = Object.defineProperty;
var $d9d0da6206cbd1f8$var$__name = (target, value)=>$d9d0da6206cbd1f8$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
var $d9d0da6206cbd1f8$var$AUTOFOCUS_ON_MOUNT = "focusScope.autoFocusOnMount";
var $d9d0da6206cbd1f8$var$AUTOFOCUS_ON_UNMOUNT = "focusScope.autoFocusOnUnmount";
var $d9d0da6206cbd1f8$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
var $d9d0da6206cbd1f8$export$20e40289641fbbb6 = /* @__PURE__ */ $cQQee.forwardRef(/* @__PURE__ */ $d9d0da6206cbd1f8$var$__name(function FocusScope2(props, forwardedRef) {
    const { loop: loop = false, trapped: trapped = false, onMountAutoFocus: onMountAutoFocusProp, onUnmountAutoFocus: onUnmountAutoFocusProp, ...scopeProps } = props;
    const [container, setContainer] = $cQQee.useState(null);
    const onMountAutoFocus = (0, $2c2ab34d464a7123$export$25bec8c6f54ee79a)(onMountAutoFocusProp);
    const onUnmountAutoFocus = (0, $2c2ab34d464a7123$export$25bec8c6f54ee79a)(onUnmountAutoFocusProp);
    const lastFocusedElementRef = $cQQee.useRef(null);
    const composedRefs = (0, $898ea3439c4e83fa$export$c7b2cbe3552a0d05)(forwardedRef, setContainer);
    const focusScope = $cQQee.useRef({
        paused: false,
        pause () {
            this.paused = true;
        },
        resume () {
            this.paused = false;
        }
    }).current;
    $cQQee.useEffect(()=>{
        if (trapped) {
            let handleFocusIn2 = function(event) {
                if (focusScope.paused || !container) return;
                const target = event.target;
                if (container.contains(target)) lastFocusedElementRef.current = target;
                else $d9d0da6206cbd1f8$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }, handleFocusOut2 = function(event) {
                if (focusScope.paused || !container) return;
                const relatedTarget = event.relatedTarget;
                if (relatedTarget === null) return;
                if (!container.contains(relatedTarget)) $d9d0da6206cbd1f8$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }, handleMutations2 = function(mutations) {
                const focusedElement = document.activeElement;
                if (focusedElement !== document.body) return;
                for (const mutation of mutations)if (mutation.removedNodes.length > 0) $d9d0da6206cbd1f8$var$focus(container);
            };
            var handleFocusIn = handleFocusIn2, handleFocusOut = handleFocusOut2, handleMutations = handleMutations2;
            $d9d0da6206cbd1f8$var$__name(handleFocusIn2, "handleFocusIn");
            $d9d0da6206cbd1f8$var$__name(handleFocusOut2, "handleFocusOut");
            $d9d0da6206cbd1f8$var$__name(handleMutations2, "handleMutations");
            document.addEventListener("focusin", handleFocusIn2);
            document.addEventListener("focusout", handleFocusOut2);
            const mutationObserver = new MutationObserver(handleMutations2);
            if (container) mutationObserver.observe(container, {
                childList: true,
                subtree: true
            });
            return ()=>{
                document.removeEventListener("focusin", handleFocusIn2);
                document.removeEventListener("focusout", handleFocusOut2);
                mutationObserver.disconnect();
            };
        }
    }, [
        trapped,
        container,
        focusScope.paused
    ]);
    $cQQee.useEffect(()=>{
        if (container) {
            $d9d0da6206cbd1f8$var$focusScopesStack.add(focusScope);
            const previouslyFocusedElement = document.activeElement;
            const hasFocusedCandidate = container.contains(previouslyFocusedElement);
            if (!hasFocusedCandidate) {
                const mountEvent = new CustomEvent($d9d0da6206cbd1f8$var$AUTOFOCUS_ON_MOUNT, $d9d0da6206cbd1f8$var$EVENT_OPTIONS);
                container.addEventListener($d9d0da6206cbd1f8$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                container.dispatchEvent(mountEvent);
                if (!mountEvent.defaultPrevented) {
                    $d9d0da6206cbd1f8$var$focusFirst($d9d0da6206cbd1f8$var$removeLinks($d9d0da6206cbd1f8$var$getTabbableCandidates(container)), {
                        select: true
                    });
                    if (document.activeElement === previouslyFocusedElement) $d9d0da6206cbd1f8$var$focus(container);
                }
            }
            return ()=>{
                container.removeEventListener($d9d0da6206cbd1f8$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                setTimeout(()=>{
                    const unmountEvent = new CustomEvent($d9d0da6206cbd1f8$var$AUTOFOCUS_ON_UNMOUNT, $d9d0da6206cbd1f8$var$EVENT_OPTIONS);
                    container.addEventListener($d9d0da6206cbd1f8$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    container.dispatchEvent(unmountEvent);
                    if (!unmountEvent.defaultPrevented) $d9d0da6206cbd1f8$var$focus(previouslyFocusedElement ?? document.body, {
                        select: true
                    });
                    container.removeEventListener($d9d0da6206cbd1f8$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    $d9d0da6206cbd1f8$var$focusScopesStack.remove(focusScope);
                }, 0);
            };
        }
    }, [
        container,
        onMountAutoFocus,
        onUnmountAutoFocus,
        focusScope
    ]);
    const handleKeyDown = $cQQee.useCallback((event)=>{
        if (!loop && !trapped) return;
        if (focusScope.paused) return;
        const isTabKey = event.key === "Tab" && !event.altKey && !event.ctrlKey && !event.metaKey;
        const focusedElement = document.activeElement;
        if (isTabKey && focusedElement) {
            const container2 = event.currentTarget;
            const [first, last] = $d9d0da6206cbd1f8$var$getTabbableEdges(container2);
            const hasTabbableElementsInside = first && last;
            if (!hasTabbableElementsInside) {
                if (focusedElement === container2) event.preventDefault();
            } else {
                if (!event.shiftKey && focusedElement === last) {
                    event.preventDefault();
                    if (loop) $d9d0da6206cbd1f8$var$focus(first, {
                        select: true
                    });
                } else if (event.shiftKey && focusedElement === first) {
                    event.preventDefault();
                    if (loop) $d9d0da6206cbd1f8$var$focus(last, {
                        select: true
                    });
                }
            }
        }
    }, [
        loop,
        trapped,
        focusScope.paused
    ]);
    return /* @__PURE__ */ (0, $7Tw3V.jsx)((0, $a8cf614ad7e764cf$export$250ffa63cdc0d034).div, {
        tabIndex: -1,
        ...scopeProps,
        ref: composedRefs,
        onKeyDown: handleKeyDown
    });
}, "FocusScope"));
function $d9d0da6206cbd1f8$var$focusFirst(candidates, { select: select = false } = {}) {
    const previouslyFocusedElement = document.activeElement;
    for (const candidate of candidates){
        $d9d0da6206cbd1f8$var$focus(candidate, {
            select: select
        });
        if (document.activeElement !== previouslyFocusedElement) return;
    }
}
$d9d0da6206cbd1f8$var$__name($d9d0da6206cbd1f8$var$focusFirst, "focusFirst");
function $d9d0da6206cbd1f8$var$getTabbableEdges(container) {
    const candidates = $d9d0da6206cbd1f8$var$getTabbableCandidates(container);
    const first = $d9d0da6206cbd1f8$var$findVisible(candidates, container);
    const last = $d9d0da6206cbd1f8$var$findVisible(candidates.reverse(), container);
    return [
        first,
        last
    ];
}
$d9d0da6206cbd1f8$var$__name($d9d0da6206cbd1f8$var$getTabbableEdges, "getTabbableEdges");
function $d9d0da6206cbd1f8$var$getTabbableCandidates(container) {
    const nodes = [];
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
        acceptNode: /* @__PURE__ */ $d9d0da6206cbd1f8$var$__name((node)=>{
            const isHiddenInput = node.tagName === "INPUT" && node.type === "hidden";
            if (node.disabled || node.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP;
            return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }, "acceptNode")
    });
    while(walker.nextNode())nodes.push(walker.currentNode);
    return nodes;
}
$d9d0da6206cbd1f8$var$__name($d9d0da6206cbd1f8$var$getTabbableCandidates, "getTabbableCandidates");
function $d9d0da6206cbd1f8$var$findVisible(elements, container) {
    const canUseCheckVisibility = typeof container.checkVisibility === "function" && container.checkVisibility({
        checkVisibilityCSS: true
    });
    for (const element of elements){
        const hidden = canUseCheckVisibility ? !element.checkVisibility({
            checkVisibilityCSS: true
        }) : $d9d0da6206cbd1f8$var$isHidden(element, {
            upTo: container
        });
        if (!hidden) return element;
    }
}
$d9d0da6206cbd1f8$var$__name($d9d0da6206cbd1f8$var$findVisible, "findVisible");
function $d9d0da6206cbd1f8$var$isHidden(node, { upTo: upTo }) {
    if (getComputedStyle(node).visibility === "hidden") return true;
    while(node){
        if (upTo !== void 0 && node === upTo) return false;
        if (getComputedStyle(node).display === "none") return true;
        node = node.parentElement;
    }
    return false;
}
$d9d0da6206cbd1f8$var$__name($d9d0da6206cbd1f8$var$isHidden, "isHidden");
function $d9d0da6206cbd1f8$var$isSelectableInput(element) {
    return element instanceof HTMLInputElement && "select" in element;
}
$d9d0da6206cbd1f8$var$__name($d9d0da6206cbd1f8$var$isSelectableInput, "isSelectableInput");
function $d9d0da6206cbd1f8$var$focus(element, { select: select = false } = {}) {
    if (element && element.focus) {
        const previouslyFocusedElement = document.activeElement;
        element.focus({
            preventScroll: true
        });
        if (element !== previouslyFocusedElement && $d9d0da6206cbd1f8$var$isSelectableInput(element) && select) element.select();
    }
}
$d9d0da6206cbd1f8$var$__name($d9d0da6206cbd1f8$var$focus, "focus");
var $d9d0da6206cbd1f8$var$focusScopesStack = $d9d0da6206cbd1f8$var$createFocusScopesStack();
function $d9d0da6206cbd1f8$var$createFocusScopesStack() {
    let stack = [];
    return {
        add (focusScope) {
            const activeFocusScope = stack[0];
            if (focusScope !== activeFocusScope) activeFocusScope?.pause();
            stack = $d9d0da6206cbd1f8$var$arrayRemove(stack, focusScope);
            stack.unshift(focusScope);
        },
        remove (focusScope) {
            stack = $d9d0da6206cbd1f8$var$arrayRemove(stack, focusScope);
            stack[0]?.resume();
        }
    };
}
$d9d0da6206cbd1f8$var$__name($d9d0da6206cbd1f8$var$createFocusScopesStack, "createFocusScopesStack");
function $d9d0da6206cbd1f8$var$arrayRemove(array, item) {
    const updatedArray = [
        ...array
    ];
    const index = updatedArray.indexOf(item);
    if (index !== -1) updatedArray.splice(index, 1);
    return updatedArray;
}
$d9d0da6206cbd1f8$var$__name($d9d0da6206cbd1f8$var$arrayRemove, "arrayRemove");
function $d9d0da6206cbd1f8$var$removeLinks(items) {
    return items.filter((item)=>item.tagName !== "A");
}
$d9d0da6206cbd1f8$var$__name($d9d0da6206cbd1f8$var$removeLinks, "removeLinks");
var $d9d0da6206cbd1f8$export$be92b6f5f03c0fe9 = $d9d0da6206cbd1f8$export$20e40289641fbbb6;



var $cQQee = parcelRequire("cQQee");
// src/use-layout-effect.tsx

var $cQQee = parcelRequire("cQQee");
var $29c1a045563e5cda$export$e5c5a5f917a5871c = globalThis?.document ? $cQQee.useLayoutEffect : ()=>{};


var $3761db9c30567852$var$__defProp = Object.defineProperty;
var $3761db9c30567852$var$__name = (target, value)=>$3761db9c30567852$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
var $3761db9c30567852$var$useReactId = $cQQee[" useId ".trim().toString()] || (()=>void 0);
var $3761db9c30567852$var$count = 0;
function $3761db9c30567852$export$f680877a34711e37(deterministicId) {
    const [id, setId] = $cQQee.useState($3761db9c30567852$var$useReactId());
    (0, $29c1a045563e5cda$export$e5c5a5f917a5871c)(()=>{
        if (!deterministicId) setId((reactId)=>reactId ?? String($3761db9c30567852$var$count++));
    }, [
        deterministicId
    ]);
    return deterministicId || (id ? `radix-${id}` : "");
}
$3761db9c30567852$var$__name($3761db9c30567852$export$f680877a34711e37, "useId");



var $cQQee = parcelRequire("cQQee");

var $dA4dV = parcelRequire("dA4dV");
var $af8LA = parcelRequire("af8LA");

var $cQQee = parcelRequire("cQQee");


var $7Tw3V = parcelRequire("7Tw3V");
var $1bc2bd169cc3c862$var$__defProp = Object.defineProperty;
var $1bc2bd169cc3c862$var$__name = (target, value)=>$1bc2bd169cc3c862$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
var $1bc2bd169cc3c862$export$21b07c8f274aebd5 = /* @__PURE__ */ $cQQee.forwardRef(/* @__PURE__ */ $1bc2bd169cc3c862$var$__name(function Arrow2(props, forwardedRef) {
    const { children: children, width: width = 10, height: height = 5, ...arrowProps } = props;
    return /* @__PURE__ */ (0, $7Tw3V.jsx)((0, $a8cf614ad7e764cf$export$250ffa63cdc0d034).svg, {
        ...arrowProps,
        ref: forwardedRef,
        width: width,
        height: height,
        viewBox: "0 0 30 10",
        preserveAspectRatio: "none",
        children: props.asChild ? children : /* @__PURE__ */ (0, $7Tw3V.jsx)("polygon", {
            points: "0,0 30,0 15,10"
        })
    });
}, "Arrow"));
var $1bc2bd169cc3c862$export$be92b6f5f03c0fe9 = $1bc2bd169cc3c862$export$21b07c8f274aebd5;








var $cQQee = parcelRequire("cQQee");

var $81d91b27d58cdcd8$var$__defProp = Object.defineProperty;
var $81d91b27d58cdcd8$var$__name = (target, value)=>$81d91b27d58cdcd8$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
function $81d91b27d58cdcd8$export$1ab7ae714698c4b8(element) {
    const [size, setSize] = $cQQee.useState(void 0);
    (0, $29c1a045563e5cda$export$e5c5a5f917a5871c)(()=>{
        if (element) {
            setSize({
                width: element.offsetWidth,
                height: element.offsetHeight
            });
            const resizeObserver = new ResizeObserver((entries)=>{
                if (!Array.isArray(entries)) return;
                if (!entries.length) return;
                const entry = entries[0];
                let width;
                let height;
                if ("borderBoxSize" in entry) {
                    const borderSizeEntry = entry["borderBoxSize"];
                    const borderSize = Array.isArray(borderSizeEntry) ? borderSizeEntry[0] : borderSizeEntry;
                    width = borderSize["inlineSize"];
                    height = borderSize["blockSize"];
                } else {
                    width = element.offsetWidth;
                    height = element.offsetHeight;
                }
                setSize({
                    width: width,
                    height: height
                });
            });
            resizeObserver.observe(element, {
                box: "border-box"
            });
            return ()=>resizeObserver.unobserve(element);
        } else setSize(void 0);
    }, [
        element
    ]);
    return size;
}
$81d91b27d58cdcd8$var$__name($81d91b27d58cdcd8$export$1ab7ae714698c4b8, "useSize");



var $7Tw3V = parcelRequire("7Tw3V");
"use client";
var $be9d1e0b513c1068$var$__defProp = Object.defineProperty;
var $be9d1e0b513c1068$var$__name = (target, value)=>$be9d1e0b513c1068$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
var $be9d1e0b513c1068$export$36f0086da09c4b9f = [
    "top",
    "right",
    "bottom",
    "left"
];
var $be9d1e0b513c1068$export$3671ffab7b302fc9 = [
    "start",
    "center",
    "end"
];
var $be9d1e0b513c1068$var$POPPER_NAME = "Popper";
var [$be9d1e0b513c1068$var$createPopperContext, $be9d1e0b513c1068$export$722aac194ae923] = (0, $b23ab9d11414cfe7$export$50c7b4e9d9f19c1)($be9d1e0b513c1068$var$POPPER_NAME);
var [$be9d1e0b513c1068$var$PopperProvider, $be9d1e0b513c1068$var$usePopperContext] = $be9d1e0b513c1068$var$createPopperContext($be9d1e0b513c1068$var$POPPER_NAME);
var $be9d1e0b513c1068$export$badac9ada3a0bdf9 = /* @__PURE__ */ $be9d1e0b513c1068$var$__name((props)=>{
    const { __scopePopper: __scopePopper, children: children } = props;
    const [anchor, setAnchor] = $cQQee.useState(null);
    const [placementState, setPlacementState] = $cQQee.useState(void 0);
    return /* @__PURE__ */ (0, $7Tw3V.jsx)($be9d1e0b513c1068$var$PopperProvider, {
        scope: __scopePopper,
        anchor: anchor,
        onAnchorChange: setAnchor,
        placementState: placementState,
        setPlacementState: setPlacementState,
        children: children
    });
}, "Popper");
var $be9d1e0b513c1068$var$ANCHOR_NAME = "PopperAnchor";
var $be9d1e0b513c1068$export$ecd4e1ccab6ed6d = /* @__PURE__ */ $cQQee.forwardRef(/* @__PURE__ */ $be9d1e0b513c1068$var$__name(function PopperAnchor2(props, forwardedRef) {
    const { __scopePopper: __scopePopper, virtualRef: virtualRef, ...anchorProps } = props;
    const context = $be9d1e0b513c1068$var$usePopperContext($be9d1e0b513c1068$var$ANCHOR_NAME, __scopePopper);
    const ref = $cQQee.useRef(null);
    const onAnchorChange = context.onAnchorChange;
    const callbackRef = $cQQee.useCallback((node)=>{
        ref.current = node;
        if (node) onAnchorChange(node);
    }, [
        onAnchorChange
    ]);
    const composedRefs = (0, $898ea3439c4e83fa$export$c7b2cbe3552a0d05)(forwardedRef, callbackRef);
    const anchorRef = $cQQee.useRef(null);
    $cQQee.useEffect(()=>{
        if (!virtualRef) return;
        const previousAnchor = anchorRef.current;
        anchorRef.current = virtualRef.current;
        if (previousAnchor !== anchorRef.current) onAnchorChange(anchorRef.current);
    });
    const sideAndAlign = context.placementState && $be9d1e0b513c1068$var$getSideAndAlignFromPlacement(context.placementState);
    const placedSide = sideAndAlign?.[0];
    const placedAlign = sideAndAlign?.[1];
    return virtualRef ? null : /* @__PURE__ */ (0, $7Tw3V.jsx)((0, $a8cf614ad7e764cf$export$250ffa63cdc0d034).div, {
        "data-radix-popper-side": placedSide,
        "data-radix-popper-align": placedAlign,
        ...anchorProps,
        ref: composedRefs
    });
}, "PopperAnchor"));
var $be9d1e0b513c1068$var$CONTENT_NAME = "PopperContent";
var [$be9d1e0b513c1068$var$PopperContentProvider, $be9d1e0b513c1068$var$useContentContext] = $be9d1e0b513c1068$var$createPopperContext($be9d1e0b513c1068$var$CONTENT_NAME);
var $be9d1e0b513c1068$export$bc4ae5855d3c4fc = /* @__PURE__ */ $cQQee.forwardRef(/* @__PURE__ */ $be9d1e0b513c1068$var$__name(function PopperContent2(props, forwardedRef) {
    const { __scopePopper: __scopePopper, side: side = "bottom", sideOffset: sideOffset = 0, align: align = "center", alignOffset: alignOffset = 0, arrowPadding: arrowPadding = 0, avoidCollisions: avoidCollisions = true, collisionBoundary: collisionBoundary = [], collisionPadding: collisionPaddingProp = 0, sticky: sticky = "partial", hideWhenDetached: hideWhenDetached = false, updatePositionStrategy: updatePositionStrategy = "optimized", onPlaced: onPlaced, ...contentProps } = props;
    const context = $be9d1e0b513c1068$var$usePopperContext($be9d1e0b513c1068$var$CONTENT_NAME, __scopePopper);
    const [content, setContent] = $cQQee.useState(null);
    const composedRefs = (0, $898ea3439c4e83fa$export$c7b2cbe3552a0d05)(forwardedRef, setContent);
    const [arrow, setArrow] = $cQQee.useState(null);
    const arrowSize = (0, $81d91b27d58cdcd8$export$1ab7ae714698c4b8)(arrow);
    const arrowWidth = arrowSize?.width ?? 0;
    const arrowHeight = arrowSize?.height ?? 0;
    const desiredPlacement = side + (align !== "center" ? "-" + align : "");
    const collisionPadding = typeof collisionPaddingProp === "number" ? collisionPaddingProp : {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...collisionPaddingProp
    };
    const boundary = Array.isArray(collisionBoundary) ? collisionBoundary : [
        collisionBoundary
    ];
    const hasExplicitBoundaries = boundary.length > 0;
    const detectOverflowOptions = {
        padding: collisionPadding,
        boundary: boundary.filter($be9d1e0b513c1068$var$isNotNull),
        // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
        altBoundary: hasExplicitBoundaries
    };
    const { refs: refs, floatingStyles: floatingStyles, placement: placement, isPositioned: isPositioned, middlewareData: middlewareData } = (0, $dA4dV.useFloating)({
        // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
        strategy: "fixed",
        placement: desiredPlacement,
        whileElementsMounted: /* @__PURE__ */ $be9d1e0b513c1068$var$__name((...args)=>{
            const cleanup = (0, $af8LA.autoUpdate)(...args, {
                animationFrame: updatePositionStrategy === "always"
            });
            return cleanup;
        }, "whileElementsMounted"),
        elements: {
            reference: context.anchor
        },
        middleware: [
            (0, $dA4dV.offset)({
                mainAxis: sideOffset + arrowHeight,
                alignmentAxis: alignOffset
            }),
            avoidCollisions && (0, $dA4dV.shift)({
                mainAxis: true,
                crossAxis: false,
                limiter: sticky === "partial" ? (0, $dA4dV.limitShift)() : void 0,
                ...detectOverflowOptions
            }),
            avoidCollisions && (0, $dA4dV.flip)({
                ...detectOverflowOptions
            }),
            (0, $dA4dV.size)({
                ...detectOverflowOptions,
                apply: /* @__PURE__ */ $be9d1e0b513c1068$var$__name(({ elements: elements, rects: rects, availableWidth: availableWidth, availableHeight: availableHeight })=>{
                    const { width: anchorWidth, height: anchorHeight } = rects.reference;
                    const contentStyle = elements.floating.style;
                    contentStyle.setProperty("--radix-popper-available-width", `${availableWidth}px`);
                    contentStyle.setProperty("--radix-popper-available-height", `${availableHeight}px`);
                    contentStyle.setProperty("--radix-popper-anchor-width", `${anchorWidth}px`);
                    contentStyle.setProperty("--radix-popper-anchor-height", `${anchorHeight}px`);
                }, "apply")
            }),
            arrow && (0, $dA4dV.arrow)({
                element: arrow,
                padding: arrowPadding
            }),
            $be9d1e0b513c1068$var$transformOrigin({
                arrowWidth: arrowWidth,
                arrowHeight: arrowHeight
            }),
            hideWhenDetached && (0, $dA4dV.hide)({
                strategy: "referenceHidden",
                ...detectOverflowOptions,
                // `hide` detects whether the anchor (reference) is clipped, so when
                // no explicit `collisionBoundary` is set we fall back to Floating
                // UI's default clipping ancestors (e.g. a scrollable menu). This
                // lets an occluded submenu hide once its anchor scrolls out of view
                // (#3237). The collision/size middlewares deliberately keep the
                // viewport-based default to avoid clamping content rendered inside
                // transformed or overflow-clipping portal containers.
                boundary: hasExplicitBoundaries ? detectOverflowOptions.boundary : void 0
            })
        ]
    });
    const setPlacementState = context.setPlacementState;
    (0, $29c1a045563e5cda$export$e5c5a5f917a5871c)(()=>{
        setPlacementState(placement);
        return ()=>{
            setPlacementState(void 0);
        };
    }, [
        placement,
        setPlacementState
    ]);
    const [placedSide, placedAlign] = $be9d1e0b513c1068$var$getSideAndAlignFromPlacement(placement);
    const handlePlaced = (0, $2c2ab34d464a7123$export$25bec8c6f54ee79a)(onPlaced);
    (0, $29c1a045563e5cda$export$e5c5a5f917a5871c)(()=>{
        if (isPositioned) handlePlaced?.();
    }, [
        isPositioned,
        handlePlaced
    ]);
    const arrowX = middlewareData.arrow?.x;
    const arrowY = middlewareData.arrow?.y;
    const cannotCenterArrow = middlewareData.arrow?.centerOffset !== 0;
    const [contentZIndex, setContentZIndex] = $cQQee.useState();
    (0, $29c1a045563e5cda$export$e5c5a5f917a5871c)(()=>{
        if (content) setContentZIndex(window.getComputedStyle(content).zIndex);
    }, [
        content
    ]);
    return /* @__PURE__ */ (0, $7Tw3V.jsx)("div", {
        ref: refs.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
            ...floatingStyles,
            transform: isPositioned ? floatingStyles.transform : "translate(0, -200%)",
            // keep off the page when measuring
            minWidth: "max-content",
            zIndex: contentZIndex,
            "--radix-popper-transform-origin": [
                middlewareData.transformOrigin?.x,
                middlewareData.transformOrigin?.y
            ].join(" "),
            // hide the content if using the hide middleware and should be hidden
            // set visibility to hidden and disable pointer events so the UI behaves
            // as if the PopperContent isn't there at all
            ...middlewareData.hide?.referenceHidden && {
                visibility: "hidden",
                pointerEvents: "none"
            }
        },
        dir: props.dir,
        children: /* @__PURE__ */ (0, $7Tw3V.jsx)($be9d1e0b513c1068$var$PopperContentProvider, {
            scope: __scopePopper,
            placedSide: placedSide,
            placedAlign: placedAlign,
            onArrowChange: setArrow,
            arrowX: arrowX,
            arrowY: arrowY,
            shouldHideArrow: cannotCenterArrow,
            children: /* @__PURE__ */ (0, $7Tw3V.jsx)((0, $a8cf614ad7e764cf$export$250ffa63cdc0d034).div, {
                "data-side": placedSide,
                "data-align": placedAlign,
                ...contentProps,
                ref: composedRefs,
                style: {
                    ...contentProps.style,
                    // if the PopperContent hasn't been placed yet (not all
                    // measurements done) we prevent animations so that users'
                    // animations don't kick in too early from the wrong sides.
                    animation: !isPositioned ? "none" : contentProps.style?.animation
                }
            })
        })
    });
}, "PopperContent"));
var $be9d1e0b513c1068$var$ARROW_NAME = "PopperArrow";
var $be9d1e0b513c1068$var$OPPOSITE_SIDE = {
    top: "bottom",
    right: "left",
    bottom: "top",
    left: "right"
};
var $be9d1e0b513c1068$export$79d62cd4e10a3fd0 = /* @__PURE__ */ $cQQee.forwardRef(/* @__PURE__ */ $be9d1e0b513c1068$var$__name(function PopperArrow2(props, forwardedRef) {
    const { __scopePopper: __scopePopper, ...arrowProps } = props;
    const contentContext = $be9d1e0b513c1068$var$useContentContext($be9d1e0b513c1068$var$ARROW_NAME, __scopePopper);
    const baseSide = $be9d1e0b513c1068$var$OPPOSITE_SIDE[contentContext.placedSide];
    return(// we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ (0, $7Tw3V.jsx)("span", {
        ref: contentContext.onArrowChange,
        style: {
            position: "absolute",
            left: contentContext.arrowX,
            top: contentContext.arrowY,
            [baseSide]: 0,
            transformOrigin: {
                top: "",
                right: "0 0",
                bottom: "center 0",
                left: "100% 0"
            }[contentContext.placedSide],
            transform: {
                top: "translateY(100%)",
                right: "translateY(50%) rotate(90deg) translateX(-50%)",
                bottom: `rotate(180deg)`,
                left: "translateY(50%) rotate(-90deg) translateX(50%)"
            }[contentContext.placedSide],
            visibility: contentContext.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ (0, $7Tw3V.jsx)($1bc2bd169cc3c862$export$be92b6f5f03c0fe9, {
            ...arrowProps,
            ref: forwardedRef,
            style: {
                ...arrowProps.style,
                // ensures the element can be measured correctly (mostly for if SVG)
                display: "block"
            }
        })
    }));
}, "PopperArrow"));
function $be9d1e0b513c1068$var$isNotNull(value) {
    return value !== null;
}
$be9d1e0b513c1068$var$__name($be9d1e0b513c1068$var$isNotNull, "isNotNull");
var $be9d1e0b513c1068$var$transformOrigin = /* @__PURE__ */ $be9d1e0b513c1068$var$__name((options)=>({
        name: "transformOrigin",
        options: options,
        fn (data) {
            const { placement: placement, rects: rects, middlewareData: middlewareData } = data;
            const cannotCenterArrow = middlewareData.arrow?.centerOffset !== 0;
            const isArrowHidden = cannotCenterArrow;
            const arrowWidth = isArrowHidden ? 0 : options.arrowWidth;
            const arrowHeight = isArrowHidden ? 0 : options.arrowHeight;
            const [placedSide, placedAlign] = $be9d1e0b513c1068$var$getSideAndAlignFromPlacement(placement);
            const noArrowAlign = {
                start: "0%",
                center: "50%",
                end: "100%"
            }[placedAlign];
            const arrowXCenter = (middlewareData.arrow?.x ?? 0) + arrowWidth / 2;
            const arrowYCenter = (middlewareData.arrow?.y ?? 0) + arrowHeight / 2;
            let x = "";
            let y = "";
            if (placedSide === "bottom") {
                x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
                y = `${-arrowHeight}px`;
            } else if (placedSide === "top") {
                x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
                y = `${rects.floating.height + arrowHeight}px`;
            } else if (placedSide === "right") {
                x = `${-arrowHeight}px`;
                y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
            } else if (placedSide === "left") {
                x = `${rects.floating.width + arrowHeight}px`;
                y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
            }
            return {
                data: {
                    x: x,
                    y: y
                }
            };
        }
    }), "transformOrigin");
function $be9d1e0b513c1068$var$getSideAndAlignFromPlacement(placement) {
    const [side, align = "center"] = placement.split("-");
    return [
        side,
        align
    ];
}
$be9d1e0b513c1068$var$__name($be9d1e0b513c1068$var$getSideAndAlignFromPlacement, "getSideAndAlignFromPlacement");
var $be9d1e0b513c1068$export$be92b6f5f03c0fe9 = $be9d1e0b513c1068$export$badac9ada3a0bdf9;
var $be9d1e0b513c1068$export$b688253958b8dfe7 = $be9d1e0b513c1068$export$ecd4e1ccab6ed6d;
var $be9d1e0b513c1068$export$7c6e2c02157bb7d2 = $be9d1e0b513c1068$export$bc4ae5855d3c4fc;
var $be9d1e0b513c1068$export$21b07c8f274aebd5 = $be9d1e0b513c1068$export$79d62cd4e10a3fd0;



var $cQQee = parcelRequire("cQQee");

var $kC364 = parcelRequire("kC364");



var $7Tw3V = parcelRequire("7Tw3V");
"use client";
var $073b439c3dd7f8b7$var$__defProp = Object.defineProperty;
var $073b439c3dd7f8b7$var$__name = (target, value)=>$073b439c3dd7f8b7$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
var $073b439c3dd7f8b7$export$602eac185826482c = /* @__PURE__ */ $cQQee.forwardRef(/* @__PURE__ */ $073b439c3dd7f8b7$var$__name(function Portal2(props, forwardedRef) {
    const { container: containerProp, ...portalProps } = props;
    const [mounted, setMounted] = $cQQee.useState(false);
    (0, $29c1a045563e5cda$export$e5c5a5f917a5871c)(()=>setMounted(true), []);
    const container = containerProp || mounted && globalThis?.document?.body;
    return container ? $kC364.createPortal(/* @__PURE__ */ (0, $7Tw3V.jsx)((0, $a8cf614ad7e764cf$export$250ffa63cdc0d034).div, {
        ...portalProps,
        ref: forwardedRef
    }), container) : null;
}, "Portal"));
var $073b439c3dd7f8b7$export$be92b6f5f03c0fe9 = $073b439c3dd7f8b7$export$602eac185826482c;



var $cQQee = parcelRequire("cQQee");

"use client";
var $1f217719234440cb$var$__defProp = Object.defineProperty;
var $1f217719234440cb$var$__name = (target, value)=>$1f217719234440cb$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
function $1f217719234440cb$var$useStateMachine(initialState, machine) {
    return $cQQee.useReducer((state, event)=>{
        const nextState = machine[state][event];
        return nextState ?? state;
    }, initialState);
}
$1f217719234440cb$var$__name($1f217719234440cb$var$useStateMachine, "useStateMachine");
// src/presence.tsx
var $1f217719234440cb$export$99c2b779aa4e8b8b = /* @__PURE__ */ $1f217719234440cb$var$__name((props)=>{
    const { present: present, children: children } = props;
    const presence = $1f217719234440cb$var$usePresence(present);
    const child = typeof children === "function" ? children({
        present: presence.isPresent
    }) : $cQQee.Children.only(children);
    const ref = $1f217719234440cb$var$useStableComposedRefs(presence.ref, $1f217719234440cb$var$getElementRef(child));
    const forceMount = typeof children === "function";
    return forceMount || presence.isPresent ? $cQQee.cloneElement(child, {
        ref: ref
    }) : null;
}, "Presence");
function $1f217719234440cb$var$usePresence(present) {
    const [node, setNode] = $cQQee.useState();
    const stylesRef = $cQQee.useRef(null);
    const prevPresentRef = $cQQee.useRef(present);
    const prevAnimationNameRef = $cQQee.useRef("none");
    const mountAnimationNameRef = $cQQee.useRef(void 0);
    const initialState = present ? "mounted" : "unmounted";
    const [state, send] = $1f217719234440cb$var$useStateMachine(initialState, {
        mounted: {
            UNMOUNT: "unmounted",
            ANIMATION_OUT: "unmountSuspended"
        },
        unmountSuspended: {
            MOUNT: "mounted",
            ANIMATION_END: "unmounted"
        },
        unmounted: {
            MOUNT: "mounted"
        }
    });
    $cQQee.useEffect(()=>{
        if (state === "mounted") {
            prevAnimationNameRef.current = mountAnimationNameRef.current ?? $1f217719234440cb$var$getAnimationName(stylesRef.current);
            mountAnimationNameRef.current = void 0;
        } else prevAnimationNameRef.current = "none";
    }, [
        state
    ]);
    (0, $29c1a045563e5cda$export$e5c5a5f917a5871c)(()=>{
        const styles = stylesRef.current;
        const wasPresent = prevPresentRef.current;
        const hasPresentChanged = wasPresent !== present;
        if (hasPresentChanged) {
            const prevAnimationName = prevAnimationNameRef.current;
            const currentAnimationName = $1f217719234440cb$var$getAnimationName(styles);
            if (present) {
                mountAnimationNameRef.current = currentAnimationName;
                send("MOUNT");
            } else if (currentAnimationName === "none" || styles?.display === "none") send("UNMOUNT");
            else {
                const isAnimating = prevAnimationName !== currentAnimationName;
                if (wasPresent && isAnimating) send("ANIMATION_OUT");
                else send("UNMOUNT");
            }
            prevPresentRef.current = present;
        }
    }, [
        present,
        send
    ]);
    (0, $29c1a045563e5cda$export$e5c5a5f917a5871c)(()=>{
        if (node) {
            let timeoutId;
            const ownerWindow = node.ownerDocument.defaultView ?? window;
            const handleAnimationEnd = /* @__PURE__ */ $1f217719234440cb$var$__name((event)=>{
                const currentAnimationName = $1f217719234440cb$var$getAnimationName(stylesRef.current);
                const isCurrentAnimation = currentAnimationName.includes(CSS.escape(event.animationName));
                if (event.target === node && isCurrentAnimation) {
                    send("ANIMATION_END");
                    if (!prevPresentRef.current) {
                        const currentFillMode = node.style.animationFillMode;
                        node.style.animationFillMode = "forwards";
                        timeoutId = ownerWindow.setTimeout(()=>{
                            if (node.style.animationFillMode === "forwards") node.style.animationFillMode = currentFillMode;
                        });
                    }
                }
            }, "handleAnimationEnd");
            const handleAnimationStart = /* @__PURE__ */ $1f217719234440cb$var$__name((event)=>{
                if (event.target === node) prevAnimationNameRef.current = $1f217719234440cb$var$getAnimationName(stylesRef.current);
            }, "handleAnimationStart");
            node.addEventListener("animationstart", handleAnimationStart);
            node.addEventListener("animationcancel", handleAnimationEnd);
            node.addEventListener("animationend", handleAnimationEnd);
            return ()=>{
                ownerWindow.clearTimeout(timeoutId);
                node.removeEventListener("animationstart", handleAnimationStart);
                node.removeEventListener("animationcancel", handleAnimationEnd);
                node.removeEventListener("animationend", handleAnimationEnd);
            };
        } else send("ANIMATION_END");
    }, [
        node,
        send
    ]);
    return {
        isPresent: [
            "mounted",
            "unmountSuspended"
        ].includes(state),
        ref: $cQQee.useCallback((node2)=>{
            if (node2) {
                const styles = getComputedStyle(node2);
                stylesRef.current = styles;
                mountAnimationNameRef.current = $1f217719234440cb$var$getAnimationName(styles);
            } else stylesRef.current = null;
            setNode(node2);
        }, [])
    };
}
$1f217719234440cb$var$__name($1f217719234440cb$var$usePresence, "usePresence");
function $1f217719234440cb$var$setRef(ref, value) {
    if (typeof ref === "function") return ref(value);
    else if (ref !== null && ref !== void 0) ref.current = value;
}
$1f217719234440cb$var$__name($1f217719234440cb$var$setRef, "setRef");
function $1f217719234440cb$var$useStableComposedRefs(...refs) {
    const refsRef = $cQQee.useRef(refs);
    refsRef.current = refs;
    return $cQQee.useCallback((node)=>{
        const currentRefs = refsRef.current;
        let hasCleanup = false;
        const cleanups = currentRefs.map((ref)=>{
            const cleanup = $1f217719234440cb$var$setRef(ref, node);
            if (!hasCleanup && typeof cleanup === "function") hasCleanup = true;
            return cleanup;
        });
        if (hasCleanup) return ()=>{
            for(let i = 0; i < cleanups.length; i++){
                const cleanup = cleanups[i];
                if (typeof cleanup === "function") cleanup();
                else $1f217719234440cb$var$setRef(currentRefs[i], null);
            }
        };
    }, []);
}
$1f217719234440cb$var$__name($1f217719234440cb$var$useStableComposedRefs, "useStableComposedRefs");
function $1f217719234440cb$var$getAnimationName(styles) {
    return styles?.animationName || "none";
}
$1f217719234440cb$var$__name($1f217719234440cb$var$getAnimationName, "getAnimationName");
function $1f217719234440cb$var$getElementRef(element) {
    let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}
$1f217719234440cb$var$__name($1f217719234440cb$var$getElementRef, "getElementRef");
var $1f217719234440cb$export$be92b6f5f03c0fe9 = $1f217719234440cb$export$99c2b779aa4e8b8b;





var $cQQee = parcelRequire("cQQee");
var $26270b9982262086$exports = {};
"use strict";
var $26270b9982262086$var$__defProp = Object.defineProperty;
var $26270b9982262086$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $26270b9982262086$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $26270b9982262086$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $26270b9982262086$var$__export = (target, all)=>{
    for(var name in all)$26270b9982262086$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $26270b9982262086$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $26270b9982262086$var$__getOwnPropNames(from))if (!$26270b9982262086$var$__hasOwnProp.call(to, key) && key !== except) $26270b9982262086$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $26270b9982262086$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $26270b9982262086$var$__toCommonJS = (mod)=>$26270b9982262086$var$__copyProps($26270b9982262086$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
// src/internal/is-development.false.ts
var $26270b9982262086$var$is_development_false_exports = {};
$26270b9982262086$var$__export($26270b9982262086$var$is_development_false_exports, {
    IS_DEVELOPMENT: ()=>$26270b9982262086$var$IS_DEVELOPMENT
});
$26270b9982262086$exports = $26270b9982262086$var$__toCommonJS($26270b9982262086$var$is_development_false_exports);
var $26270b9982262086$var$IS_DEVELOPMENT = false;





var $cQQee = parcelRequire("cQQee");
var $aeb0fccefb3e5e02$var$__defProp = Object.defineProperty;
var $aeb0fccefb3e5e02$var$__name = (target, value)=>$aeb0fccefb3e5e02$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
var $aeb0fccefb3e5e02$var$useReactEffectEvent = $cQQee[" useEffectEvent ".trim().toString()];
var $aeb0fccefb3e5e02$var$useReactInsertionEffect = $cQQee[" useInsertionEffect ".trim().toString()];
function $aeb0fccefb3e5e02$export$7f54fc3180508a52(callback) {
    if (typeof $aeb0fccefb3e5e02$var$useReactEffectEvent === "function") return $aeb0fccefb3e5e02$var$useReactEffectEvent(callback);
    const ref = $cQQee.useRef(()=>{
        throw new Error("Cannot call an event handler while rendering.");
    });
    if (typeof $aeb0fccefb3e5e02$var$useReactInsertionEffect === "function") $aeb0fccefb3e5e02$var$useReactInsertionEffect(()=>{
        ref.current = callback;
    });
    else (0, $29c1a045563e5cda$export$e5c5a5f917a5871c)(()=>{
        ref.current = callback;
    });
    return $cQQee.useMemo(()=>(...args)=>ref.current?.(...args), []);
}
$aeb0fccefb3e5e02$var$__name($aeb0fccefb3e5e02$export$7f54fc3180508a52, "useEffectEvent");


var $46f0199588a47798$var$__defProp = Object.defineProperty;
var $46f0199588a47798$var$__name = (target, value)=>$46f0199588a47798$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
var $46f0199588a47798$var$useInsertionEffect = $cQQee[" useInsertionEffect ".trim().toString()] || (0, $29c1a045563e5cda$export$e5c5a5f917a5871c);
function $46f0199588a47798$export$6f32135080cb4c3({ prop: prop, defaultProp: defaultProp, onChange: onChange = /* @__PURE__ */ $46f0199588a47798$var$__name(()=>{}, "onChange"), caller: caller }) {
    const [uncontrolledProp, setUncontrolledProp, onChangeRef] = $46f0199588a47798$var$useUncontrolledState({
        defaultProp: defaultProp,
        onChange: onChange
    });
    const isControlled = prop !== void 0;
    const value = isControlled ? prop : uncontrolledProp;
    if (0, $26270b9982262086$exports.IS_DEVELOPMENT) {
        const isControlledRef = $cQQee.useRef(prop !== void 0);
        $cQQee.useEffect(()=>{
            const wasControlled = isControlledRef.current;
            if (wasControlled !== isControlled) {
                const from = wasControlled ? "controlled" : "uncontrolled";
                const to = isControlled ? "controlled" : "uncontrolled";
                console.warn(`${caller} is changing from ${from} to ${to}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`);
            }
            isControlledRef.current = isControlled;
        }, [
            isControlled,
            caller
        ]);
    }
    const setValue = $cQQee.useCallback((nextValue)=>{
        if (isControlled) {
            const value2 = $46f0199588a47798$var$isFunction(nextValue) ? nextValue(prop) : nextValue;
            if (value2 !== prop) onChangeRef.current?.(value2);
        } else setUncontrolledProp(nextValue);
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        onChangeRef
    ]);
    return [
        value,
        setValue
    ];
}
$46f0199588a47798$var$__name($46f0199588a47798$export$6f32135080cb4c3, "useControllableState");
function $46f0199588a47798$var$useUncontrolledState({ defaultProp: defaultProp, onChange: onChange }) {
    const [value, setValue] = $cQQee.useState(defaultProp);
    const prevValueRef = $cQQee.useRef(value);
    const onChangeRef = $cQQee.useRef(onChange);
    $46f0199588a47798$var$useInsertionEffect(()=>{
        onChangeRef.current = onChange;
    }, [
        onChange
    ]);
    $cQQee.useEffect(()=>{
        if (prevValueRef.current !== value) {
            onChangeRef.current?.(value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef
    ]);
    return [
        value,
        setValue,
        onChangeRef
    ];
}
$46f0199588a47798$var$__name($46f0199588a47798$var$useUncontrolledState, "useUncontrolledState");
function $46f0199588a47798$var$isFunction(value) {
    return typeof value === "function";
}
$46f0199588a47798$var$__name($46f0199588a47798$var$isFunction, "isFunction");
var $46f0199588a47798$var$SYNC_STATE = Symbol("RADIX:SYNC_STATE");
function $46f0199588a47798$export$bf6fc034f0c038af(reducer, userArgs, initialArg, init) {
    const { prop: controlledState, defaultProp: defaultProp, onChange: onChangeProp, caller: caller } = userArgs;
    const isControlled = controlledState !== void 0;
    const onChange = (0, $aeb0fccefb3e5e02$export$7f54fc3180508a52)(onChangeProp);
    if (0, $26270b9982262086$exports.IS_DEVELOPMENT) {
        const isControlledRef = $cQQee.useRef(controlledState !== void 0);
        $cQQee.useEffect(()=>{
            const wasControlled = isControlledRef.current;
            if (wasControlled !== isControlled) {
                const from = wasControlled ? "controlled" : "uncontrolled";
                const to = isControlled ? "controlled" : "uncontrolled";
                console.warn(`${caller} is changing from ${from} to ${to}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`);
            }
            isControlledRef.current = isControlled;
        }, [
            isControlled,
            caller
        ]);
    }
    const args = [
        {
            ...initialArg,
            state: defaultProp
        }
    ];
    if (init) args.push(init);
    const [internalState, dispatch] = $cQQee.useReducer((state2, action)=>{
        if (action.type === $46f0199588a47798$var$SYNC_STATE) return {
            ...state2,
            state: action.state
        };
        const next = reducer(state2, action);
        if (isControlled && !Object.is(next.state, state2.state)) onChange(next.state);
        return next;
    }, ...args);
    const uncontrolledState = internalState.state;
    const prevValueRef = $cQQee.useRef(uncontrolledState);
    $cQQee.useEffect(()=>{
        if (prevValueRef.current !== uncontrolledState) {
            prevValueRef.current = uncontrolledState;
            if (!isControlled) onChange(uncontrolledState);
        }
    }, [
        uncontrolledState,
        prevValueRef,
        isControlled
    ]);
    const state = $cQQee.useMemo(()=>{
        const isControlled2 = controlledState !== void 0;
        if (isControlled2) return {
            ...internalState,
            state: controlledState
        };
        return internalState;
    }, [
        internalState,
        controlledState
    ]);
    $cQQee.useEffect(()=>{
        if (isControlled && !Object.is(controlledState, internalState.state)) dispatch({
            type: $46f0199588a47798$var$SYNC_STATE,
            state: controlledState
        });
    }, [
        controlledState,
        internalState.state,
        isControlled
    ]);
    return [
        state,
        dispatch
    ];
}
$46f0199588a47798$var$__name($46f0199588a47798$export$bf6fc034f0c038af, "useControllableStateReducer");


var $af600d42805563b0$var$getDefaultParent = function(originalTarget) {
    if (typeof document === 'undefined') return null;
    var sampleTarget = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
    return sampleTarget.ownerDocument.body;
};
var $af600d42805563b0$var$counterMap = new WeakMap();
var $af600d42805563b0$var$uncontrolledNodes = new WeakMap();
var $af600d42805563b0$var$markerMap = {};
var $af600d42805563b0$var$lockCount = 0;
var $af600d42805563b0$var$unwrapHost = function(node) {
    return node && (node.host || $af600d42805563b0$var$unwrapHost(node.parentNode));
};
var $af600d42805563b0$var$correctTargets = function(parent, targets) {
    return targets.map(function(target) {
        if (parent.contains(target)) return target;
        var correctedTarget = $af600d42805563b0$var$unwrapHost(target);
        if (correctedTarget && parent.contains(correctedTarget)) return correctedTarget;
        console.error('aria-hidden', target, 'in not contained inside', parent, '. Doing nothing');
        return null;
    }).filter(function(x) {
        return Boolean(x);
    });
};
/**
 * Marks everything except given node(or nodes) as aria-hidden
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @param {String} [controlAttribute] - html Attribute to control
 * @return {Undo} undo command
 */ var $af600d42805563b0$var$applyAttributeToOthers = function(originalTarget, parentNode, markerName, controlAttribute) {
    var targets = $af600d42805563b0$var$correctTargets(parentNode, Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    if (!$af600d42805563b0$var$markerMap[markerName]) $af600d42805563b0$var$markerMap[markerName] = new WeakMap();
    var markerCounter = $af600d42805563b0$var$markerMap[markerName];
    var hiddenNodes = [];
    var elementsToKeep = new Set();
    var elementsToStop = new Set(targets);
    var keep = function(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        keep(el.parentNode);
    };
    targets.forEach(keep);
    var deep = function(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        Array.prototype.forEach.call(parent.children, function(node) {
            if (elementsToKeep.has(node)) deep(node);
            else try {
                var attr = node.getAttribute(controlAttribute);
                var alreadyHidden = attr !== null && attr !== 'false';
                var counterValue = ($af600d42805563b0$var$counterMap.get(node) || 0) + 1;
                var markerValue = (markerCounter.get(node) || 0) + 1;
                $af600d42805563b0$var$counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenNodes.push(node);
                if (counterValue === 1 && alreadyHidden) $af600d42805563b0$var$uncontrolledNodes.set(node, true);
                if (markerValue === 1) node.setAttribute(markerName, 'true');
                if (!alreadyHidden) node.setAttribute(controlAttribute, 'true');
            } catch (e) {
                console.error('aria-hidden: cannot operate on ', node, e);
            }
        });
    };
    deep(parentNode);
    elementsToKeep.clear();
    $af600d42805563b0$var$lockCount++;
    return function() {
        hiddenNodes.forEach(function(node) {
            var counterValue = $af600d42805563b0$var$counterMap.get(node) - 1;
            var markerValue = markerCounter.get(node) - 1;
            $af600d42805563b0$var$counterMap.set(node, counterValue);
            markerCounter.set(node, markerValue);
            if (!counterValue) {
                if (!$af600d42805563b0$var$uncontrolledNodes.has(node)) node.removeAttribute(controlAttribute);
                $af600d42805563b0$var$uncontrolledNodes.delete(node);
            }
            if (!markerValue) node.removeAttribute(markerName);
        });
        $af600d42805563b0$var$lockCount--;
        if (!$af600d42805563b0$var$lockCount) {
            // clear
            $af600d42805563b0$var$counterMap = new WeakMap();
            $af600d42805563b0$var$counterMap = new WeakMap();
            $af600d42805563b0$var$uncontrolledNodes = new WeakMap();
            $af600d42805563b0$var$markerMap = {};
        }
    };
};
var $af600d42805563b0$export$6e33d16126ed003c = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = 'data-aria-hidden';
    var targets = Array.from(Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    var activeParentNode = parentNode || $af600d42805563b0$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    // we should not hide aria-live elements - https://github.com/theKashey/aria-hidden/issues/10
    // and script elements, as they have no impact on accessibility.
    targets.push.apply(targets, Array.from(activeParentNode.querySelectorAll('[aria-live], script')));
    return $af600d42805563b0$var$applyAttributeToOthers(targets, activeParentNode, markerName, 'aria-hidden');
};
var $af600d42805563b0$export$59151cc8db999a24 = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = 'data-inert-ed';
    var activeParentNode = parentNode || $af600d42805563b0$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    return $af600d42805563b0$var$applyAttributeToOthers(originalTarget, activeParentNode, markerName, 'inert');
};
var $af600d42805563b0$export$cc95fea82d705fca = function() {
    return typeof HTMLElement !== 'undefined' && HTMLElement.prototype.hasOwnProperty('inert');
};
var $af600d42805563b0$export$9845d4b6bdad192b = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = 'data-suppressed';
    return ($af600d42805563b0$export$cc95fea82d705fca() ? $af600d42805563b0$export$59151cc8db999a24 : $af600d42805563b0$export$6e33d16126ed003c)(originalTarget, parentNode, markerName);
};



var $8yqJh = parcelRequire("8yqJh");

var $cQQee = parcelRequire("cQQee");

var $8yqJh = parcelRequire("8yqJh");

var $cQQee = parcelRequire("cQQee");
var $6d21f714cfb04b43$export$1da7500147d4bc3 = 'right-scroll-bar-position';
var $6d21f714cfb04b43$export$898e37bbd2a0ae4e = 'width-before-scroll-bar';
var $6d21f714cfb04b43$export$bb813dfbbc432abc = 'with-scroll-bars-hidden';
var $6d21f714cfb04b43$export$63d0edf80fea83b1 = '--removed-body-scroll-bar-size';



var $cQQee = parcelRequire("cQQee");
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $c46d28466f79a822$export$d734136a7b018efe(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
    return ref;
}



var $cQQee = parcelRequire("cQQee");
function $7f3b4d3703a7c4ae$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $cQQee.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}


var $556eb9253412ad47$var$useIsomorphicLayoutEffect = typeof window !== 'undefined' ? $cQQee.useLayoutEffect : $cQQee.useEffect;
var $556eb9253412ad47$var$currentValues = new WeakMap();
function $556eb9253412ad47$export$74665b213cb5c4cf(refs, defaultValue) {
    var callbackRef = (0, $7f3b4d3703a7c4ae$export$25bec8c6f54ee79a)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $c46d28466f79a822$export$d734136a7b018efe)(ref, newValue);
        });
    });
    // handle refs changes - added or removed
    $556eb9253412ad47$var$useIsomorphicLayoutEffect(function() {
        var oldValue = $556eb9253412ad47$var$currentValues.get(callbackRef);
        if (oldValue) {
            var prevRefs_1 = new Set(oldValue);
            var nextRefs_1 = new Set(refs);
            var current_1 = callbackRef.current;
            prevRefs_1.forEach(function(ref) {
                if (!nextRefs_1.has(ref)) (0, $c46d28466f79a822$export$d734136a7b018efe)(ref, null);
            });
            nextRefs_1.forEach(function(ref) {
                if (!prevRefs_1.has(ref)) (0, $c46d28466f79a822$export$d734136a7b018efe)(ref, current_1);
            });
        }
        $556eb9253412ad47$var$currentValues.set(callbackRef, refs);
    }, [
        refs
    ]);
    return callbackRef;
}



var $8yqJh = parcelRequire("8yqJh");
function $8139c95d5e42be86$var$ItoI(a) {
    return a;
}
function $8139c95d5e42be86$var$innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = $8139c95d5e42be86$var$ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error('Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.');
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $8139c95d5e42be86$export$9ffbfcaf067b02c6(defaults, middleware) {
    if (middleware === void 0) middleware = $8139c95d5e42be86$var$ItoI;
    return $8139c95d5e42be86$var$innerCreateMedium(defaults, middleware);
}
function $8139c95d5e42be86$export$e13ec7dd7a14088d(options) {
    if (options === void 0) options = {};
    var medium = $8139c95d5e42be86$var$innerCreateMedium(null);
    medium.options = (0, $8yqJh.__assign)({
        async: true,
        ssr: false
    }, options);
    return medium;
}


var $8dc049b3fc62824d$export$e27363444bedfeac = (0, $8139c95d5e42be86$export$e13ec7dd7a14088d)();


var $58a368ebe73421a4$var$nothing = function() {
    return;
};
/**
 * Removes scrollbar from the page and contain the scroll within the Lock
 */ var $58a368ebe73421a4$export$22940b497e769dee = $cQQee.forwardRef(function(props, parentRef) {
    var ref = $cQQee.useRef(null);
    var _a = $cQQee.useState({
        onScrollCapture: $58a368ebe73421a4$var$nothing,
        onWheelCapture: $58a368ebe73421a4$var$nothing,
        onTouchMoveCapture: $58a368ebe73421a4$var$nothing
    }), callbacks = _a[0], setCallbacks = _a[1];
    var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noRelative = props.noRelative, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container = _b === void 0 ? 'div' : _b, gapMode = props.gapMode, rest = (0, $8yqJh.__rest)(props, [
        "forwardProps",
        "children",
        "className",
        "removeScrollBar",
        "enabled",
        "shards",
        "sideCar",
        "noRelative",
        "noIsolation",
        "inert",
        "allowPinchZoom",
        "as",
        "gapMode"
    ]);
    var SideCar = sideCar;
    var containerRef = (0, $556eb9253412ad47$export$74665b213cb5c4cf)([
        ref,
        parentRef
    ]);
    var containerProps = (0, $8yqJh.__assign)((0, $8yqJh.__assign)({}, rest), callbacks);
    return $cQQee.createElement($cQQee.Fragment, null, enabled && $cQQee.createElement(SideCar, {
        sideCar: (0, $8dc049b3fc62824d$export$e27363444bedfeac),
        removeScrollBar: removeScrollBar,
        shards: shards,
        noRelative: noRelative,
        noIsolation: noIsolation,
        inert: inert,
        setCallbacks: setCallbacks,
        allowPinchZoom: !!allowPinchZoom,
        lockRef: ref,
        gapMode: gapMode
    }), forwardProps ? $cQQee.cloneElement($cQQee.Children.only(children), (0, $8yqJh.__assign)((0, $8yqJh.__assign)({}, containerProps), {
        ref: containerRef
    })) : $cQQee.createElement(Container, (0, $8yqJh.__assign)({}, containerProps, {
        className: className,
        ref: containerRef
    }), children));
});
$58a368ebe73421a4$export$22940b497e769dee.defaultProps = {
    enabled: true,
    removeScrollBar: true,
    inert: false
};
$58a368ebe73421a4$export$22940b497e769dee.classNames = {
    fullWidth: (0, $6d21f714cfb04b43$export$898e37bbd2a0ae4e),
    zeroRight: (0, $6d21f714cfb04b43$export$1da7500147d4bc3)
};



var $8yqJh = parcelRequire("8yqJh");

var $cQQee = parcelRequire("cQQee");
var $349aa91acc83f070$var$SideCar = function(_a) {
    var sideCar = _a.sideCar, rest = (0, $8yqJh.__rest)(_a, [
        "sideCar"
    ]);
    if (!sideCar) throw new Error('Sidecar: please provide `sideCar` property to import the right car');
    var Target = sideCar.read();
    if (!Target) throw new Error('Sidecar medium not found');
    return $cQQee.createElement(Target, (0, $8yqJh.__assign)({}, rest));
};
$349aa91acc83f070$var$SideCar.isSideCarExport = true;
function $349aa91acc83f070$export$6cacc8fb0a9b94ce(medium, exported) {
    medium.useMedium(exported);
    return $349aa91acc83f070$var$SideCar;
}



var $8yqJh = parcelRequire("8yqJh");

var $cQQee = parcelRequire("cQQee");

var $cQQee = parcelRequire("cQQee");

var $cQQee = parcelRequire("cQQee");
var $7b05cbd96a77362c$var$currentNonce;
var $7b05cbd96a77362c$export$c5f670b24c0ae95a = function(nonce) {
    $7b05cbd96a77362c$var$currentNonce = nonce;
};
var $7b05cbd96a77362c$export$2b85b721e524d74b = function() {
    if ($7b05cbd96a77362c$var$currentNonce) return $7b05cbd96a77362c$var$currentNonce;
    if (typeof __webpack_nonce__ !== 'undefined') return __webpack_nonce__;
    return undefined;
};


function $e3fc20832d0ec9da$var$makeStyleTag() {
    if (!document) return null;
    var tag = document.createElement('style');
    tag.type = 'text/css';
    var nonce = (0, $7b05cbd96a77362c$export$2b85b721e524d74b)();
    if (nonce) tag.setAttribute('nonce', nonce);
    return tag;
}
function $e3fc20832d0ec9da$var$injectStyles(tag, css) {
    // @ts-ignore
    if (tag.styleSheet) // @ts-ignore
    tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $e3fc20832d0ec9da$var$insertStyleTag(tag) {
    var head = document.head || document.getElementsByTagName('head')[0];
    head.appendChild(tag);
}
var $e3fc20832d0ec9da$export$7c74eec858d5d226 = function() {
    var counter = 0;
    var stylesheet = null;
    return {
        add: function(style) {
            if (counter == 0) {
                if (stylesheet = $e3fc20832d0ec9da$var$makeStyleTag()) {
                    $e3fc20832d0ec9da$var$injectStyles(stylesheet, style);
                    $e3fc20832d0ec9da$var$insertStyleTag(stylesheet);
                }
            }
            counter++;
        },
        remove: function() {
            counter--;
            if (!counter && stylesheet) {
                stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
                stylesheet = null;
            }
        }
    };
};


var $d05124d3048d2769$export$7d7b35c2d250e94c = function() {
    var sheet = (0, $e3fc20832d0ec9da$export$7c74eec858d5d226)();
    return function(styles, isDynamic) {
        $cQQee.useEffect(function() {
            sheet.add(styles);
            return function() {
                sheet.remove();
            };
        }, [
            styles && isDynamic
        ]);
    };
};


var $0006a7e43e7f0d4c$export$c1248ee86ba532c8 = function() {
    var useStyle = (0, $d05124d3048d2769$export$7d7b35c2d250e94c)();
    var Sheet = function(_a) {
        var styles = _a.styles, dynamic = _a.dynamic;
        useStyle(styles, dynamic);
        return null;
    };
    return Sheet;
};







var $65a03583916b7f3b$export$efed13b5d0ca3386 = {
    left: 0,
    top: 0,
    right: 0,
    gap: 0
};
var $65a03583916b7f3b$var$parse = function(x) {
    return parseInt(x || '', 10) || 0;
};
var $65a03583916b7f3b$var$getOffset = function(gapMode) {
    var cs = window.getComputedStyle(document.body);
    var left = cs[gapMode === 'padding' ? 'paddingLeft' : 'marginLeft'];
    var top = cs[gapMode === 'padding' ? 'paddingTop' : 'marginTop'];
    var right = cs[gapMode === 'padding' ? 'paddingRight' : 'marginRight'];
    return [
        $65a03583916b7f3b$var$parse(left),
        $65a03583916b7f3b$var$parse(top),
        $65a03583916b7f3b$var$parse(right)
    ];
};
var $65a03583916b7f3b$export$75f2ca8f029c77f4 = function(gapMode) {
    if (gapMode === void 0) gapMode = 'margin';
    if (typeof window === 'undefined') return $65a03583916b7f3b$export$efed13b5d0ca3386;
    var offsets = $65a03583916b7f3b$var$getOffset(gapMode);
    var documentWidth = document.documentElement.clientWidth;
    var windowWidth = window.innerWidth;
    return {
        left: offsets[0],
        top: offsets[1],
        right: offsets[2],
        gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0])
    };
};


var $bdaa81001df6dd51$var$Style = (0, $0006a7e43e7f0d4c$export$c1248ee86ba532c8)();
var $bdaa81001df6dd51$export$65254d5f26cb9564 = 'data-scroll-locked';
// important tip - once we measure scrollBar width and remove them
// we could not repeat this operation
// thus we are using style-singleton - only the first "yet correct" style will be applied.
var $bdaa81001df6dd51$var$getStyles = function(_a, allowRelative, gapMode, important) {
    var left = _a.left, top = _a.top, right = _a.right, gap = _a.gap;
    if (gapMode === void 0) gapMode = 'margin';
    return "\n  .".concat((0, $6d21f714cfb04b43$export$bb813dfbbc432abc), " {\n   overflow: hidden ").concat(important, ";\n   padding-right: ").concat(gap, "px ").concat(important, ";\n  }\n  body[").concat($bdaa81001df6dd51$export$65254d5f26cb9564, "] {\n    overflow: hidden ").concat(important, ";\n    overscroll-behavior: contain;\n    ").concat([
        allowRelative && "position: relative ".concat(important, ";"),
        gapMode === 'margin' && "\n    padding-left: ".concat(left, "px;\n    padding-top: ").concat(top, "px;\n    padding-right: ").concat(right, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important, ";\n    "),
        gapMode === 'padding' && "padding-right: ".concat(gap, "px ").concat(important, ";")
    ].filter(Boolean).join(''), "\n  }\n  \n  .").concat((0, $6d21f714cfb04b43$export$1da7500147d4bc3), " {\n    right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $6d21f714cfb04b43$export$898e37bbd2a0ae4e), " {\n    margin-right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $6d21f714cfb04b43$export$1da7500147d4bc3), " .").concat((0, $6d21f714cfb04b43$export$1da7500147d4bc3), " {\n    right: 0 ").concat(important, ";\n  }\n  \n  .").concat((0, $6d21f714cfb04b43$export$898e37bbd2a0ae4e), " .").concat((0, $6d21f714cfb04b43$export$898e37bbd2a0ae4e), " {\n    margin-right: 0 ").concat(important, ";\n  }\n  \n  body[").concat($bdaa81001df6dd51$export$65254d5f26cb9564, "] {\n    ").concat((0, $6d21f714cfb04b43$export$63d0edf80fea83b1), ": ").concat(gap, "px;\n  }\n");
};
var $bdaa81001df6dd51$var$getCurrentUseCounter = function() {
    var counter = parseInt(document.body.getAttribute($bdaa81001df6dd51$export$65254d5f26cb9564) || '0', 10);
    return isFinite(counter) ? counter : 0;
};
var $bdaa81001df6dd51$export$a1939b1f9f9b02dc = function() {
    $cQQee.useEffect(function() {
        document.body.setAttribute($bdaa81001df6dd51$export$65254d5f26cb9564, ($bdaa81001df6dd51$var$getCurrentUseCounter() + 1).toString());
        return function() {
            var newCounter = $bdaa81001df6dd51$var$getCurrentUseCounter() - 1;
            if (newCounter <= 0) document.body.removeAttribute($bdaa81001df6dd51$export$65254d5f26cb9564);
            else document.body.setAttribute($bdaa81001df6dd51$export$65254d5f26cb9564, newCounter.toString());
        };
    }, []);
};
var $bdaa81001df6dd51$export$9aa43b459c5ae9b9 = function(_a) {
    var noRelative = _a.noRelative, noImportant = _a.noImportant, _b = _a.gapMode, gapMode = _b === void 0 ? 'margin' : _b;
    $bdaa81001df6dd51$export$a1939b1f9f9b02dc();
    /*
     gap will be measured on every component mount
     however it will be used only by the "first" invocation
     due to singleton nature of <Style
     */ var gap = $cQQee.useMemo(function() {
        return (0, $65a03583916b7f3b$export$75f2ca8f029c77f4)(gapMode);
    }, [
        gapMode
    ]);
    return $cQQee.createElement($bdaa81001df6dd51$var$Style, {
        styles: $bdaa81001df6dd51$var$getStyles(gap, !noRelative, gapMode, !noImportant ? '!important' : '')
    });
};







var $2ce53e4fd7c77ec2$var$passiveSupported = false;
if (typeof window !== 'undefined') try {
    var $2ce53e4fd7c77ec2$var$options = Object.defineProperty({}, 'passive', {
        get: function() {
            $2ce53e4fd7c77ec2$var$passiveSupported = true;
            return true;
        }
    });
    // @ts-ignore
    window.addEventListener('test', $2ce53e4fd7c77ec2$var$options, $2ce53e4fd7c77ec2$var$options);
    // @ts-ignore
    window.removeEventListener('test', $2ce53e4fd7c77ec2$var$options, $2ce53e4fd7c77ec2$var$options);
} catch (err) {
    $2ce53e4fd7c77ec2$var$passiveSupported = false;
}
var $2ce53e4fd7c77ec2$export$10a6e88623fa9454 = $2ce53e4fd7c77ec2$var$passiveSupported ? {
    passive: false
} : false;


var $fd75ceb70fb8d2ad$var$alwaysContainsScroll = function(node) {
    // textarea will always _contain_ scroll inside self. It only can be hidden
    return node.tagName === 'TEXTAREA';
};
var $fd75ceb70fb8d2ad$var$elementCanBeScrolled = function(node, overflow) {
    if (!(node instanceof Element)) return false;
    var styles = window.getComputedStyle(node);
    return(// not-not-scrollable
    styles[overflow] !== 'hidden' && // contains scroll inside self
    !(styles.overflowY === styles.overflowX && !$fd75ceb70fb8d2ad$var$alwaysContainsScroll(node) && styles[overflow] === 'visible'));
};
var $fd75ceb70fb8d2ad$var$elementCouldBeVScrolled = function(node) {
    return $fd75ceb70fb8d2ad$var$elementCanBeScrolled(node, 'overflowY');
};
var $fd75ceb70fb8d2ad$var$elementCouldBeHScrolled = function(node) {
    return $fd75ceb70fb8d2ad$var$elementCanBeScrolled(node, 'overflowX');
};
var $fd75ceb70fb8d2ad$export$9ec64480cae49817 = function(axis, node) {
    var ownerDocument = node.ownerDocument;
    var current = node;
    do {
        // Skip over shadow root
        if (typeof ShadowRoot !== 'undefined' && current instanceof ShadowRoot) current = current.host;
        var isScrollable = $fd75ceb70fb8d2ad$var$elementCouldBeScrolled(axis, current);
        if (isScrollable) {
            var _a = $fd75ceb70fb8d2ad$var$getScrollVariables(axis, current), scrollHeight = _a[1], clientHeight = _a[2];
            if (scrollHeight > clientHeight) return true;
        }
        current = current.parentNode;
    }while (current && current !== ownerDocument.body);
    return false;
};
var $fd75ceb70fb8d2ad$var$getVScrollVariables = function(_a) {
    var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
    return [
        scrollTop,
        scrollHeight,
        clientHeight
    ];
};
var $fd75ceb70fb8d2ad$var$getHScrollVariables = function(_a) {
    var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
    return [
        scrollLeft,
        scrollWidth,
        clientWidth
    ];
};
var $fd75ceb70fb8d2ad$var$elementCouldBeScrolled = function(axis, node) {
    return axis === 'v' ? $fd75ceb70fb8d2ad$var$elementCouldBeVScrolled(node) : $fd75ceb70fb8d2ad$var$elementCouldBeHScrolled(node);
};
var $fd75ceb70fb8d2ad$var$getScrollVariables = function(axis, node) {
    return axis === 'v' ? $fd75ceb70fb8d2ad$var$getVScrollVariables(node) : $fd75ceb70fb8d2ad$var$getHScrollVariables(node);
};
var $fd75ceb70fb8d2ad$var$getDirectionFactor = function(axis, direction) {
    /**
     * If the element's direction is rtl (right-to-left), then scrollLeft is 0 when the scrollbar is at its rightmost position,
     * and then increasingly negative as you scroll towards the end of the content.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollLeft
     */ return axis === 'h' && direction === 'rtl' ? -1 : 1;
};
var $fd75ceb70fb8d2ad$export$dde0441bd4a6ded8 = function(axis, endTarget, event, sourceDelta, noOverscroll) {
    var directionFactor = $fd75ceb70fb8d2ad$var$getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
    var delta = directionFactor * sourceDelta;
    // find scrollable target
    var target = event.target;
    var targetInLock = endTarget.contains(target);
    var shouldCancelScroll = false;
    var isDeltaPositive = delta > 0;
    var availableScroll = 0;
    var availableScrollTop = 0;
    do {
        if (!target) break;
        var _a = $fd75ceb70fb8d2ad$var$getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
        var elementScroll = scroll_1 - capacity - directionFactor * position;
        if (position || elementScroll) {
            if ($fd75ceb70fb8d2ad$var$elementCouldBeScrolled(axis, target)) {
                availableScroll += elementScroll;
                availableScrollTop += position;
            }
        }
        var parent_1 = target.parentNode;
        // we will "bubble" from ShadowDom in case we are, or just to the parent in normal case
        // this is the same logic used in focus-lock
        target = parent_1 && parent_1.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? parent_1.host : parent_1;
    }while (// portaled content
    !targetInLock && target !== document.body || // self content
    targetInLock && (endTarget.contains(target) || endTarget === target));
    // handle epsilon around 0 (non standard zoom levels)
    if (isDeltaPositive && (noOverscroll && Math.abs(availableScroll) < 1 || !noOverscroll && delta > availableScroll)) shouldCancelScroll = true;
    else if (!isDeltaPositive && (noOverscroll && Math.abs(availableScrollTop) < 1 || !noOverscroll && -delta > availableScrollTop)) shouldCancelScroll = true;
    return shouldCancelScroll;
};


var $d84d4ad4285694aa$export$6e085704a79f4f56 = function(event) {
    return 'changedTouches' in event ? [
        event.changedTouches[0].clientX,
        event.changedTouches[0].clientY
    ] : [
        0,
        0
    ];
};
var $d84d4ad4285694aa$export$39efaa2ca254a28d = function(event) {
    return [
        event.deltaX,
        event.deltaY
    ];
};
var $d84d4ad4285694aa$var$extractRef = function(ref) {
    return ref && 'current' in ref ? ref.current : ref;
};
var $d84d4ad4285694aa$var$deltaCompare = function(x, y) {
    return x[0] === y[0] && x[1] === y[1];
};
var $d84d4ad4285694aa$var$generateStyle = function(id) {
    return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n");
};
var $d84d4ad4285694aa$var$idCounter = 0;
var $d84d4ad4285694aa$var$lockStack = [];
function $d84d4ad4285694aa$export$a09dbff87b5da2d(props) {
    var shouldPreventQueue = $cQQee.useRef([]);
    var touchStartRef = $cQQee.useRef([
        0,
        0
    ]);
    var activeAxis = $cQQee.useRef();
    var id = $cQQee.useState($d84d4ad4285694aa$var$idCounter++)[0];
    var Style = $cQQee.useState((0, $0006a7e43e7f0d4c$export$c1248ee86ba532c8))[0];
    var lastProps = $cQQee.useRef(props);
    $cQQee.useEffect(function() {
        lastProps.current = props;
    }, [
        props
    ]);
    $cQQee.useEffect(function() {
        if (props.inert) {
            document.body.classList.add("block-interactivity-".concat(id));
            var allow_1 = (0, $8yqJh.__spreadArray)([
                props.lockRef.current
            ], (props.shards || []).map($d84d4ad4285694aa$var$extractRef), true).filter(Boolean);
            allow_1.forEach(function(el) {
                return el.classList.add("allow-interactivity-".concat(id));
            });
            return function() {
                document.body.classList.remove("block-interactivity-".concat(id));
                allow_1.forEach(function(el) {
                    return el.classList.remove("allow-interactivity-".concat(id));
                });
            };
        }
        return;
    }, [
        props.inert,
        props.lockRef.current,
        props.shards
    ]);
    var shouldCancelEvent = $cQQee.useCallback(function(event, parent) {
        if ('touches' in event && event.touches.length === 2 || event.type === 'wheel' && event.ctrlKey) return !lastProps.current.allowPinchZoom;
        var touch = $d84d4ad4285694aa$export$6e085704a79f4f56(event);
        var touchStart = touchStartRef.current;
        var deltaX = 'deltaX' in event ? event.deltaX : touchStart[0] - touch[0];
        var deltaY = 'deltaY' in event ? event.deltaY : touchStart[1] - touch[1];
        var currentAxis;
        var target = event.target;
        var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? 'h' : 'v';
        // allow horizontal touch move on Range inputs. They will not cause any scroll
        if ('touches' in event && moveDirection === 'h' && target.type === 'range') return false;
        // allow drag selection (iOS); check if selection's anchorNode is the same as target or contains target
        var selection = window.getSelection();
        var anchorNode = selection && selection.anchorNode;
        var isTouchingSelection = anchorNode ? anchorNode === target || anchorNode.contains(target) : false;
        if (isTouchingSelection) return false;
        var canBeScrolledInMainDirection = (0, $fd75ceb70fb8d2ad$export$9ec64480cae49817)(moveDirection, target);
        if (!canBeScrolledInMainDirection) return true;
        if (canBeScrolledInMainDirection) currentAxis = moveDirection;
        else {
            currentAxis = moveDirection === 'v' ? 'h' : 'v';
            canBeScrolledInMainDirection = (0, $fd75ceb70fb8d2ad$export$9ec64480cae49817)(moveDirection, target);
        // other axis might be not scrollable
        }
        if (!canBeScrolledInMainDirection) return false;
        if (!activeAxis.current && 'changedTouches' in event && (deltaX || deltaY)) activeAxis.current = currentAxis;
        if (!currentAxis) return true;
        var cancelingAxis = activeAxis.current || currentAxis;
        return (0, $fd75ceb70fb8d2ad$export$dde0441bd4a6ded8)(cancelingAxis, parent, event, cancelingAxis === 'h' ? deltaX : deltaY, true);
    }, []);
    var shouldPrevent = $cQQee.useCallback(function(_event) {
        var event = _event;
        if (!$d84d4ad4285694aa$var$lockStack.length || $d84d4ad4285694aa$var$lockStack[$d84d4ad4285694aa$var$lockStack.length - 1] !== Style) // not the last active
        return;
        var delta = 'deltaY' in event ? $d84d4ad4285694aa$export$39efaa2ca254a28d(event) : $d84d4ad4285694aa$export$6e085704a79f4f56(event);
        var sourceEvent = shouldPreventQueue.current.filter(function(e) {
            return e.name === event.type && (e.target === event.target || event.target === e.shadowParent) && $d84d4ad4285694aa$var$deltaCompare(e.delta, delta);
        })[0];
        // self event, and should be canceled
        if (sourceEvent && sourceEvent.should) {
            if (event.cancelable) event.preventDefault();
            return;
        }
        // outside or shard event
        if (!sourceEvent) {
            var shardNodes = (lastProps.current.shards || []).map($d84d4ad4285694aa$var$extractRef).filter(Boolean).filter(function(node) {
                return node.contains(event.target);
            });
            var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
            if (shouldStop) {
                if (event.cancelable) event.preventDefault();
            }
        }
    }, []);
    var shouldCancel = $cQQee.useCallback(function(name, delta, target, should) {
        var event = {
            name: name,
            delta: delta,
            target: target,
            should: should,
            shadowParent: $d84d4ad4285694aa$var$getOutermostShadowParent(target)
        };
        shouldPreventQueue.current.push(event);
        setTimeout(function() {
            shouldPreventQueue.current = shouldPreventQueue.current.filter(function(e) {
                return e !== event;
            });
        }, 1);
    }, []);
    var scrollTouchStart = $cQQee.useCallback(function(event) {
        touchStartRef.current = $d84d4ad4285694aa$export$6e085704a79f4f56(event);
        activeAxis.current = undefined;
    }, []);
    var scrollWheel = $cQQee.useCallback(function(event) {
        shouldCancel(event.type, $d84d4ad4285694aa$export$39efaa2ca254a28d(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    var scrollTouchMove = $cQQee.useCallback(function(event) {
        shouldCancel(event.type, $d84d4ad4285694aa$export$6e085704a79f4f56(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    $cQQee.useEffect(function() {
        $d84d4ad4285694aa$var$lockStack.push(Style);
        props.setCallbacks({
            onScrollCapture: scrollWheel,
            onWheelCapture: scrollWheel,
            onTouchMoveCapture: scrollTouchMove
        });
        document.addEventListener('wheel', shouldPrevent, (0, $2ce53e4fd7c77ec2$export$10a6e88623fa9454));
        document.addEventListener('touchmove', shouldPrevent, (0, $2ce53e4fd7c77ec2$export$10a6e88623fa9454));
        document.addEventListener('touchstart', scrollTouchStart, (0, $2ce53e4fd7c77ec2$export$10a6e88623fa9454));
        return function() {
            $d84d4ad4285694aa$var$lockStack = $d84d4ad4285694aa$var$lockStack.filter(function(inst) {
                return inst !== Style;
            });
            document.removeEventListener('wheel', shouldPrevent, (0, $2ce53e4fd7c77ec2$export$10a6e88623fa9454));
            document.removeEventListener('touchmove', shouldPrevent, (0, $2ce53e4fd7c77ec2$export$10a6e88623fa9454));
            document.removeEventListener('touchstart', scrollTouchStart, (0, $2ce53e4fd7c77ec2$export$10a6e88623fa9454));
        };
    }, []);
    var removeScrollBar = props.removeScrollBar, inert = props.inert;
    return $cQQee.createElement($cQQee.Fragment, null, inert ? $cQQee.createElement(Style, {
        styles: $d84d4ad4285694aa$var$generateStyle(id)
    }) : null, removeScrollBar ? $cQQee.createElement((0, $bdaa81001df6dd51$export$9aa43b459c5ae9b9), {
        noRelative: props.noRelative,
        gapMode: props.gapMode
    }) : null);
}
function $d84d4ad4285694aa$var$getOutermostShadowParent(node) {
    var shadowParent = null;
    while(node !== null){
        if (node instanceof ShadowRoot) {
            shadowParent = node.host;
            node = node.host;
        }
        node = node.parentNode;
    }
    return shadowParent;
}



var $ebd7851d08d99136$export$2e2bcd8739ae039 = (0, $349aa91acc83f070$export$6cacc8fb0a9b94ce)((0, $8dc049b3fc62824d$export$e27363444bedfeac), (0, $d84d4ad4285694aa$export$a09dbff87b5da2d));


var $12e3d08240e8653e$var$ReactRemoveScroll = $cQQee.forwardRef(function(props, ref) {
    return $cQQee.createElement((0, $58a368ebe73421a4$export$22940b497e769dee), (0, $8yqJh.__assign)({}, props, {
        ref: ref,
        sideCar: (0, $ebd7851d08d99136$export$2e2bcd8739ae039)
    }));
});
$12e3d08240e8653e$var$ReactRemoveScroll.classNames = (0, $58a368ebe73421a4$export$22940b497e769dee).classNames;
var $12e3d08240e8653e$export$2e2bcd8739ae039 = $12e3d08240e8653e$var$ReactRemoveScroll;



var $7Tw3V = parcelRequire("7Tw3V");
"use client";
var $ec2f1683b2f8aff6$var$__defProp = Object.defineProperty;
var $ec2f1683b2f8aff6$var$__name = (target, value)=>$ec2f1683b2f8aff6$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
var $ec2f1683b2f8aff6$var$POPOVER_NAME = "Popover";
var [$ec2f1683b2f8aff6$var$createPopoverContext, $ec2f1683b2f8aff6$export$c8393c9e73286932] = (0, $b23ab9d11414cfe7$export$50c7b4e9d9f19c1)($ec2f1683b2f8aff6$var$POPOVER_NAME, [
    (0, $be9d1e0b513c1068$export$722aac194ae923)
]);
var $ec2f1683b2f8aff6$var$usePopperScope = (0, $be9d1e0b513c1068$export$722aac194ae923)();
var [$ec2f1683b2f8aff6$var$PopoverProvider, $ec2f1683b2f8aff6$var$usePopoverContext] = $ec2f1683b2f8aff6$var$createPopoverContext($ec2f1683b2f8aff6$var$POPOVER_NAME);
var $ec2f1683b2f8aff6$export$5b6b19405a83ff9d = /* @__PURE__ */ $ec2f1683b2f8aff6$var$__name((props)=>{
    const { __scopePopover: __scopePopover, children: children, open: openProp, defaultOpen: defaultOpen, onOpenChange: onOpenChange, modal: modal = false } = props;
    const popperScope = $ec2f1683b2f8aff6$var$usePopperScope(__scopePopover);
    const triggerRef = $cQQee.useRef(null);
    const [hasCustomAnchor, setHasCustomAnchor] = $cQQee.useState(false);
    const [open, setOpen] = (0, $46f0199588a47798$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen ?? false,
        onChange: onOpenChange,
        caller: $ec2f1683b2f8aff6$var$POPOVER_NAME
    });
    return /* @__PURE__ */ (0, $7Tw3V.jsx)($be9d1e0b513c1068$export$be92b6f5f03c0fe9, {
        ...popperScope,
        children: /* @__PURE__ */ (0, $7Tw3V.jsx)($ec2f1683b2f8aff6$var$PopoverProvider, {
            scope: __scopePopover,
            contentId: (0, $3761db9c30567852$export$f680877a34711e37)(),
            triggerRef: triggerRef,
            open: open,
            onOpenChange: setOpen,
            onOpenToggle: $cQQee.useCallback(()=>setOpen((prevOpen)=>!prevOpen), [
                setOpen
            ]),
            hasCustomAnchor: hasCustomAnchor,
            onCustomAnchorAdd: $cQQee.useCallback(()=>setHasCustomAnchor(true), []),
            onCustomAnchorRemove: $cQQee.useCallback(()=>setHasCustomAnchor(false), []),
            modal: modal,
            children: children
        })
    });
}, "Popover");
var $ec2f1683b2f8aff6$var$ANCHOR_NAME = "PopoverAnchor";
var $ec2f1683b2f8aff6$export$96e5381f42521a79 = /* @__PURE__ */ $cQQee.forwardRef(/* @__PURE__ */ $ec2f1683b2f8aff6$var$__name(function PopoverAnchor2(props, forwardedRef) {
    const { __scopePopover: __scopePopover, ...anchorProps } = props;
    const context = $ec2f1683b2f8aff6$var$usePopoverContext($ec2f1683b2f8aff6$var$ANCHOR_NAME, __scopePopover);
    const popperScope = $ec2f1683b2f8aff6$var$usePopperScope(__scopePopover);
    const { onCustomAnchorAdd: onCustomAnchorAdd, onCustomAnchorRemove: onCustomAnchorRemove } = context;
    $cQQee.useEffect(()=>{
        onCustomAnchorAdd();
        return ()=>onCustomAnchorRemove();
    }, [
        onCustomAnchorAdd,
        onCustomAnchorRemove
    ]);
    return /* @__PURE__ */ (0, $7Tw3V.jsx)($be9d1e0b513c1068$export$b688253958b8dfe7, {
        ...popperScope,
        ...anchorProps,
        ref: forwardedRef
    });
}, "PopoverAnchor"));
var $ec2f1683b2f8aff6$var$TRIGGER_NAME = "PopoverTrigger";
var $ec2f1683b2f8aff6$export$7dacb05d26466c3 = /* @__PURE__ */ $cQQee.forwardRef(/* @__PURE__ */ $ec2f1683b2f8aff6$var$__name(function PopoverTrigger2(props, forwardedRef) {
    const { __scopePopover: __scopePopover, ...triggerProps } = props;
    const context = $ec2f1683b2f8aff6$var$usePopoverContext($ec2f1683b2f8aff6$var$TRIGGER_NAME, __scopePopover);
    const popperScope = $ec2f1683b2f8aff6$var$usePopperScope(__scopePopover);
    const composedTriggerRef = (0, $898ea3439c4e83fa$export$c7b2cbe3552a0d05)(forwardedRef, context.triggerRef);
    const trigger = /* @__PURE__ */ (0, $7Tw3V.jsx)((0, $a8cf614ad7e764cf$export$250ffa63cdc0d034).button, {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": context.open,
        "aria-controls": context.open ? context.contentId : void 0,
        "data-state": $ec2f1683b2f8aff6$var$getState(context.open),
        ...triggerProps,
        ref: composedTriggerRef,
        onClick: (0, $499aff9742b81a59$export$b9ecd428b558ff10)(props.onClick, context.onOpenToggle)
    });
    return context.hasCustomAnchor ? trigger : /* @__PURE__ */ (0, $7Tw3V.jsx)($be9d1e0b513c1068$export$b688253958b8dfe7, {
        asChild: true,
        ...popperScope,
        children: trigger
    });
}, "PopoverTrigger"));
var $ec2f1683b2f8aff6$var$PORTAL_NAME = "PopoverPortal";
var [$ec2f1683b2f8aff6$var$PortalProvider, $ec2f1683b2f8aff6$var$usePortalContext] = $ec2f1683b2f8aff6$var$createPopoverContext($ec2f1683b2f8aff6$var$PORTAL_NAME, {
    forceMount: void 0
});
var $ec2f1683b2f8aff6$export$dd679ffb4362d2d4 = /* @__PURE__ */ $ec2f1683b2f8aff6$var$__name((props)=>{
    const { __scopePopover: __scopePopover, forceMount: forceMount, children: children, container: container } = props;
    const context = $ec2f1683b2f8aff6$var$usePopoverContext($ec2f1683b2f8aff6$var$PORTAL_NAME, __scopePopover);
    return /* @__PURE__ */ (0, $7Tw3V.jsx)($ec2f1683b2f8aff6$var$PortalProvider, {
        scope: __scopePopover,
        forceMount: forceMount,
        children: /* @__PURE__ */ (0, $7Tw3V.jsx)((0, $1f217719234440cb$export$99c2b779aa4e8b8b), {
            present: forceMount || context.open,
            children: /* @__PURE__ */ (0, $7Tw3V.jsx)((0, $073b439c3dd7f8b7$export$602eac185826482c), {
                asChild: true,
                container: container,
                children: children
            })
        })
    });
}, "PopoverPortal");
var $ec2f1683b2f8aff6$var$CONTENT_NAME = "PopoverContent";
var $ec2f1683b2f8aff6$export$d7e1f420b25549ff = /* @__PURE__ */ $cQQee.forwardRef(// blank line to reduce diff noise
/* @__PURE__ */ $ec2f1683b2f8aff6$var$__name(function PopoverContent2(props, forwardedRef) {
    const portalContext = $ec2f1683b2f8aff6$var$usePortalContext($ec2f1683b2f8aff6$var$CONTENT_NAME, props.__scopePopover);
    const { forceMount: forceMount = portalContext.forceMount, ...contentProps } = props;
    const context = $ec2f1683b2f8aff6$var$usePopoverContext($ec2f1683b2f8aff6$var$CONTENT_NAME, props.__scopePopover);
    return /* @__PURE__ */ (0, $7Tw3V.jsx)((0, $1f217719234440cb$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open,
        children: context.modal ? /* @__PURE__ */ (0, $7Tw3V.jsx)($ec2f1683b2f8aff6$var$PopoverContentModal, {
            ...contentProps,
            ref: forwardedRef
        }) : /* @__PURE__ */ (0, $7Tw3V.jsx)($ec2f1683b2f8aff6$var$PopoverContentNonModal, {
            ...contentProps,
            ref: forwardedRef
        })
    });
}, "PopoverContent"));
var $ec2f1683b2f8aff6$var$Slot = (0, $3611aa24d70d795c$export$e88b45bda5c13eb9)("PopoverContent.RemoveScroll");
var $ec2f1683b2f8aff6$var$PopoverContentModal = /* @__PURE__ */ $cQQee.forwardRef(// blank line to reduce diff noise
/* @__PURE__ */ $ec2f1683b2f8aff6$var$__name(function PopoverContentModal2(props, forwardedRef) {
    const context = $ec2f1683b2f8aff6$var$usePopoverContext($ec2f1683b2f8aff6$var$CONTENT_NAME, props.__scopePopover);
    const contentRef = $cQQee.useRef(null);
    const composedRefs = (0, $898ea3439c4e83fa$export$c7b2cbe3552a0d05)(forwardedRef, contentRef);
    const isRightClickOutsideRef = $cQQee.useRef(false);
    $cQQee.useEffect(()=>{
        const content = contentRef.current;
        if (content) return (0, $af600d42805563b0$export$6e33d16126ed003c)(content);
    }, []);
    return /* @__PURE__ */ (0, $7Tw3V.jsx)((0, $12e3d08240e8653e$export$2e2bcd8739ae039), {
        as: $ec2f1683b2f8aff6$var$Slot,
        allowPinchZoom: true,
        children: /* @__PURE__ */ (0, $7Tw3V.jsx)($ec2f1683b2f8aff6$var$PopoverContentImpl, {
            ...props,
            ref: composedRefs,
            trapFocus: context.open,
            disableOutsidePointerEvents: true,
            onCloseAutoFocus: (0, $499aff9742b81a59$export$b9ecd428b558ff10)(props.onCloseAutoFocus, (event)=>{
                event.preventDefault();
                if (!isRightClickOutsideRef.current) context.triggerRef.current?.focus();
            }),
            onPointerDownOutside: (0, $499aff9742b81a59$export$b9ecd428b558ff10)(props.onPointerDownOutside, (event)=>{
                const originalEvent = event.detail.originalEvent;
                const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
                const isRightClick = originalEvent.button === 2 || ctrlLeftClick;
                isRightClickOutsideRef.current = isRightClick;
            }, {
                checkForDefaultPrevented: false
            }),
            onFocusOutside: (0, $499aff9742b81a59$export$b9ecd428b558ff10)(props.onFocusOutside, (event)=>event.preventDefault(), {
                checkForDefaultPrevented: false
            })
        })
    });
}, "PopoverContentModal"));
var $ec2f1683b2f8aff6$var$PopoverContentNonModal = /* @__PURE__ */ $cQQee.forwardRef(// blank line to reduce diff noise
/* @__PURE__ */ $ec2f1683b2f8aff6$var$__name(function PopoverContentNonModal2(props, forwardedRef) {
    const context = $ec2f1683b2f8aff6$var$usePopoverContext($ec2f1683b2f8aff6$var$CONTENT_NAME, props.__scopePopover);
    const hasInteractedOutsideRef = $cQQee.useRef(false);
    const hasPointerDownOutsideRef = $cQQee.useRef(false);
    return /* @__PURE__ */ (0, $7Tw3V.jsx)($ec2f1683b2f8aff6$var$PopoverContentImpl, {
        ...props,
        ref: forwardedRef,
        trapFocus: false,
        disableOutsidePointerEvents: false,
        onCloseAutoFocus: (event)=>{
            props.onCloseAutoFocus?.(event);
            if (!event.defaultPrevented) {
                if (!hasInteractedOutsideRef.current) context.triggerRef.current?.focus();
                event.preventDefault();
            }
            hasInteractedOutsideRef.current = false;
            hasPointerDownOutsideRef.current = false;
        },
        onInteractOutside: (event)=>{
            props.onInteractOutside?.(event);
            if (!event.defaultPrevented) {
                hasInteractedOutsideRef.current = true;
                if (event.detail.originalEvent.type === "pointerdown") hasPointerDownOutsideRef.current = true;
            }
            const target = event.target;
            const targetIsTrigger = context.triggerRef.current?.contains(target);
            if (targetIsTrigger) event.preventDefault();
            if (event.detail.originalEvent.type === "focusin" && hasPointerDownOutsideRef.current) event.preventDefault();
        }
    });
}, "PopoverContentNonModal"));
var $ec2f1683b2f8aff6$var$PopoverContentImpl = /* @__PURE__ */ $cQQee.forwardRef(// blank line to reduce diff noise
/* @__PURE__ */ $ec2f1683b2f8aff6$var$__name(function PopoverContentImpl2(props, forwardedRef) {
    const { __scopePopover: __scopePopover, trapFocus: trapFocus, onOpenAutoFocus: onOpenAutoFocus, onCloseAutoFocus: onCloseAutoFocus, disableOutsidePointerEvents: disableOutsidePointerEvents, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, onFocusOutside: onFocusOutside, onInteractOutside: onInteractOutside, ...contentProps } = props;
    const context = $ec2f1683b2f8aff6$var$usePopoverContext($ec2f1683b2f8aff6$var$CONTENT_NAME, __scopePopover);
    const popperScope = $ec2f1683b2f8aff6$var$usePopperScope(__scopePopover);
    (0, $50bed90f65457fd0$export$b7ece24a22aeda8c)();
    return /* @__PURE__ */ (0, $7Tw3V.jsx)((0, $d9d0da6206cbd1f8$export$20e40289641fbbb6), {
        asChild: true,
        loop: true,
        trapped: trapFocus,
        onMountAutoFocus: onOpenAutoFocus,
        onUnmountAutoFocus: onCloseAutoFocus,
        children: /* @__PURE__ */ (0, $7Tw3V.jsx)((0, $0bf4fdec12e296d5$export$177fb62ff3ec1f22), {
            asChild: true,
            disableOutsidePointerEvents: disableOutsidePointerEvents,
            onInteractOutside: onInteractOutside,
            onEscapeKeyDown: onEscapeKeyDown,
            onPointerDownOutside: onPointerDownOutside,
            onFocusOutside: onFocusOutside,
            onDismiss: ()=>context.onOpenChange(false),
            deferPointerDownOutside: true,
            children: /* @__PURE__ */ (0, $7Tw3V.jsx)($be9d1e0b513c1068$export$7c6e2c02157bb7d2, {
                "data-state": $ec2f1683b2f8aff6$var$getState(context.open),
                role: "dialog",
                id: context.contentId,
                ...popperScope,
                ...contentProps,
                ref: forwardedRef,
                style: {
                    ...contentProps.style,
                    "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                    "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                    "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                    "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                    "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
                }
            })
        })
    });
}, "PopoverContentImpl"));
var $ec2f1683b2f8aff6$var$CLOSE_NAME = "PopoverClose";
var $ec2f1683b2f8aff6$export$d6ac43ebaa40d53e = /* @__PURE__ */ $cQQee.forwardRef(/* @__PURE__ */ $ec2f1683b2f8aff6$var$__name(function PopoverClose2(props, forwardedRef) {
    const { __scopePopover: __scopePopover, ...closeProps } = props;
    const context = $ec2f1683b2f8aff6$var$usePopoverContext($ec2f1683b2f8aff6$var$CLOSE_NAME, __scopePopover);
    return /* @__PURE__ */ (0, $7Tw3V.jsx)((0, $a8cf614ad7e764cf$export$250ffa63cdc0d034).button, {
        type: "button",
        ...closeProps,
        ref: forwardedRef,
        onClick: (0, $499aff9742b81a59$export$b9ecd428b558ff10)(props.onClick, ()=>context.onOpenChange(false))
    });
}, "PopoverClose"));
var $ec2f1683b2f8aff6$export$3152841115e061b2 = /* @__PURE__ */ $cQQee.forwardRef(/* @__PURE__ */ $ec2f1683b2f8aff6$var$__name(function PopoverArrow2(props, forwardedRef) {
    const { __scopePopover: __scopePopover, ...arrowProps } = props;
    const popperScope = $ec2f1683b2f8aff6$var$usePopperScope(__scopePopover);
    return /* @__PURE__ */ (0, $7Tw3V.jsx)($be9d1e0b513c1068$export$21b07c8f274aebd5, {
        ...popperScope,
        ...arrowProps,
        ref: forwardedRef
    });
}, "PopoverArrow"));
function $ec2f1683b2f8aff6$var$getState(open) {
    return open ? "open" : "closed";
}
$ec2f1683b2f8aff6$var$__name($ec2f1683b2f8aff6$var$getState, "getState");
var $ec2f1683b2f8aff6$export$be92b6f5f03c0fe9 = $ec2f1683b2f8aff6$export$5b6b19405a83ff9d;
var $ec2f1683b2f8aff6$export$b688253958b8dfe7 = $ec2f1683b2f8aff6$export$96e5381f42521a79;
var $ec2f1683b2f8aff6$export$41fb9f06171c75f4 = $ec2f1683b2f8aff6$export$7dacb05d26466c3;
var $ec2f1683b2f8aff6$export$602eac185826482c = $ec2f1683b2f8aff6$export$dd679ffb4362d2d4;
var $ec2f1683b2f8aff6$export$7c6e2c02157bb7d2 = $ec2f1683b2f8aff6$export$d7e1f420b25549ff;
var $ec2f1683b2f8aff6$export$f39c2d165cd861fe = $ec2f1683b2f8aff6$export$d6ac43ebaa40d53e;
var $ec2f1683b2f8aff6$export$21b07c8f274aebd5 = $ec2f1683b2f8aff6$export$3152841115e061b2;


var $031ff11a3f2cd676$exports = {};

$parcel$export($031ff11a3f2cd676$exports, "casaPopoverContent", function () { return $031ff11a3f2cd676$export$b8b8923c71c87ca5; }, function (v) { return $031ff11a3f2cd676$export$b8b8923c71c87ca5 = v; });
$parcel$export($031ff11a3f2cd676$exports, "triggerWrapper", function () { return $031ff11a3f2cd676$export$61533625d778d03b; }, function (v) { return $031ff11a3f2cd676$export$61533625d778d03b = v; });
var $031ff11a3f2cd676$export$b8b8923c71c87ca5;
var $031ff11a3f2cd676$export$61533625d778d03b;
$031ff11a3f2cd676$export$b8b8923c71c87ca5 = `ZDYIXq_casaPopoverContent`;
$031ff11a3f2cd676$export$61533625d778d03b = `ZDYIXq_triggerWrapper`;


const $18539ff951b37e9a$var$Popover = ({ trigger: trigger, children: children, onOpen: onOpen, onClose: onClose })=>{
    return /*#__PURE__*/ (0, $7Tw3V.jsxs)($ec2f1683b2f8aff6$export$be92b6f5f03c0fe9, {
        modal: true,
        children: [
            /*#__PURE__*/ (0, $7Tw3V.jsx)($ec2f1683b2f8aff6$export$41fb9f06171c75f4, {
                asChild: true,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($031ff11a3f2cd676$exports))).triggerWrapper,
                children: /*#__PURE__*/ (0, $7Tw3V.jsx)("div", {
                    "data-testid": "popover-trigger",
                    children: trigger
                })
            }),
            /*#__PURE__*/ (0, $7Tw3V.jsx)($ec2f1683b2f8aff6$export$602eac185826482c, {
                children: /*#__PURE__*/ (0, $7Tw3V.jsx)($ec2f1683b2f8aff6$export$7c6e2c02157bb7d2, {
                    side: "right",
                    align: "start",
                    sideOffset: 8,
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($031ff11a3f2cd676$exports))).casaPopoverContent,
                    onCloseAutoFocus: ()=>{
                        onClose && onClose();
                    },
                    onOpenAutoFocus: (e)=>{
                        e.preventDefault();
                        onOpen && onOpen();
                    },
                    children: children
                })
            })
        ]
    });
};
var $18539ff951b37e9a$export$2e2bcd8739ae039 = $18539ff951b37e9a$var$Popover;



var $7Tw3V = parcelRequire("7Tw3V");

var $45bd5d196563da38$exports = {};
$45bd5d196563da38$exports = $parcel$resolve("e5Zmh");


var $56b1974d94f7f2aa$exports = {};
$56b1974d94f7f2aa$exports = $parcel$resolve("4OKPn");


var $0f507b3559112c10$exports = {};
$0f507b3559112c10$exports = $parcel$resolve("bwR9B");


var $022fd4bd14aa1f5a$exports = {};
$022fd4bd14aa1f5a$exports = $parcel$resolve("eomgF");






const $737000ecf5dd669d$export$d1d65c78874e7716 = (type, config, smartviewsConfig, count)=>{
    if (!count) return false;
    const entity = config?.entity?.id;
    if (entity === (0, $4b9f68b1938e412c$export$a7a3b6940d66e1a4).TASKS && (type === (0, $4b9f68b1938e412c$export$45f3f39dac49db7f).ProgressBar || type === (0, $4b9f68b1938e412c$export$45f3f39dac49db7f).SpeedoMeter || type === (0, $4b9f68b1938e412c$export$45f3f39dac49db7f).SingleCounter)) return true;
    else if (entity === (0, $4b9f68b1938e412c$export$a7a3b6940d66e1a4).SMARTVIEWS && (0, $4b9f68b1938e412c$export$45f3f39dac49db7f).SingleCounter) {
        const allowedTypes = [
            (0, $e5ce57aa1df93daf$export$94065feca67a578c)["LEADS"],
            (0, $e5ce57aa1df93daf$export$94065feca67a578c)["OPPORTUNITY"],
            (0, $e5ce57aa1df93daf$export$94065feca67a578c)["TASKS"]
        ];
        const tabId = config?.smartViewTab?.id;
        const matchedTab = smartviewsConfig?.tabs?.find((tab)=>tab.id === tabId);
        const isTypeAllowed = allowedTypes.includes(matchedTab?.type);
        return isTypeAllowed;
    }
    return false;
};
const $737000ecf5dd669d$export$3b74d66213a915a1 = (config)=>{
    let payload = (0, $b61f740b64a51955$export$b9e1badb9711e940)({
        config: config
    });
    if (config?.dateFilters?.id) {
        const dateRange = (0, $b61f740b64a51955$export$2e3dcc09723f1d05)(config.dateFilters.id);
        payload["pageSize"] = 10;
        payload["filters"] = {
            ...payload.filters,
            ...dateRange
        };
    }
    return payload;
};
const $737000ecf5dd669d$export$73fffd6dda5144e = async (config, smartviewsConfig)=>{
    const entity = config?.entity?.id;
    if (entity === (0, $4b9f68b1938e412c$export$a7a3b6940d66e1a4).TASKS) {
        const payload = $737000ecf5dd669d$export$3b74d66213a915a1(config);
        const { taskList: taskList } = await (0, $3a9d902ac0f87e31$export$604816b052fb037f)(payload);
        return taskList;
    } else if (entity === (0, $4b9f68b1938e412c$export$a7a3b6940d66e1a4).SMARTVIEWS) {
        const tabId = config?.smartViewTab?.id;
        const matchedTab = smartviewsConfig?.tabs?.find((tab)=>tab.id === tabId);
        let payload;
        if (matchedTab?.type === (0, $e5ce57aa1df93daf$export$94065feca67a578c)["TASKS"]) {
            payload = {
                advancedSearch: (0, $e5ce57aa1df93daf$export$f5e75e7a00a50e13)(matchedTab),
                pageIndex: 1,
                pageSize: 10,
                type: (0, $e5ce57aa1df93daf$export$87cbdc2ba79bea53)(matchedTab),
                columns: "Name"
            };
            const { taskList: taskList } = await (0, $3a9d902ac0f87e31$export$7d6bd1533a29d86c)(payload, (0, $4b9f68b1938e412c$export$a7a3b6940d66e1a4).TASKS);
            return taskList;
        } else if (matchedTab?.type === (0, $e5ce57aa1df93daf$export$94065feca67a578c)["OPPORTUNITY"]) {
            payload = {
                advancedSearch: (0, $e5ce57aa1df93daf$export$f5e75e7a00a50e13)(matchedTab),
                pageIndex: 0,
                pageSize: 10,
                code: (0, $e5ce57aa1df93daf$export$f5c1eb4d7fbc8f38)(matchedTab),
                isOpportunity: true
            };
            const response = await (0, $3a9d902ac0f87e31$export$7d6bd1533a29d86c)(payload, (0, $4b9f68b1938e412c$export$a7a3b6940d66e1a4).ACTIVITES);
            const list = response?.activityList?.map((item)=>{
                item["name"] = item["mx_Custom_1"];
                return item;
            });
            return list;
        } else if (matchedTab?.type === (0, $e5ce57aa1df93daf$export$94065feca67a578c)["LEADS"]) {
            payload = {
                advancedSearch: (0, $e5ce57aa1df93daf$export$f5e75e7a00a50e13)(matchedTab),
                pageIndex: 0,
                pageSize: 10
            };
            const response = await (0, $3a9d902ac0f87e31$export$7d6bd1533a29d86c)(payload, (0, $4b9f68b1938e412c$export$a7a3b6940d66e1a4).LEADS);
            const leadsList = response?.leads?.map((lead)=>{
                const properties = Object.fromEntries(lead?.leadPropertyList?.map((p)=>[
                        p?.attribute,
                        p?.value
                    ]));
                return {
                    leadId: properties.ProspectID,
                    name: `${properties?.FirstName || ""} ${properties?.LastName || ""}`.trim() || "[No Name]"
                };
            });
            return leadsList;
        }
        return [];
    }
};
const $737000ecf5dd669d$export$8277f0dc87523523 = (config, id)=>{
    let newUrl = new URL(window.location.href);
    const pathPrefix = (0, $b61f740b64a51955$export$e21ff368c7512d8e)('Lead');
    if (config?.entity?.id === "tasks") {
        newUrl.pathname = (0, $b61f740b64a51955$export$e21ff368c7512d8e)('Tasks');
        newUrl.searchParams.set("activeTab", "manage-tasks");
        newUrl.searchParams.set("leadType", config?.objectType?.InternalName);
        newUrl.searchParams.set("dashletId", id);
    } else if (config?.entity?.id === "smartviews") {
        newUrl.pathname = `${pathPrefix}/SmartViews`;
        newUrl.searchParams.set("activeTab", config?.smartViewTab?.id || "");
        newUrl.searchParams.delete("dashletId");
    } else {
        newUrl.pathname = `${pathPrefix}/SmartViews`;
        newUrl.searchParams.set("activeTab", id || ""); // Default case for other widget types
    }
    window.open(newUrl.toString(), "_blank");
};





const $c715ae85941a3e83$export$90f8e1afc5451df8 = (entityDetails, config, smartviewsConfig)=>{
    const entity = config?.entity?.id;
    let newUrl = new URL(window.location.href);
    if (entity === (0, $4b9f68b1938e412c$export$a7a3b6940d66e1a4).TASKS && entityDetails?.userTaskAutoId) newUrl = $c715ae85941a3e83$var$createUrlForTasks(newUrl, entityDetails);
    else if (entity === (0, $4b9f68b1938e412c$export$a7a3b6940d66e1a4).SMARTVIEWS) {
        const tabId = config?.smartViewTab?.id;
        const matchedTab = smartviewsConfig?.tabs?.find((tab)=>tab.id === tabId);
        if (matchedTab?.type === (0, $e5ce57aa1df93daf$export$94065feca67a578c)["TASKS"]) newUrl = $c715ae85941a3e83$var$createUrlForTasks(newUrl, entityDetails);
        else if (matchedTab?.type === (0, $e5ce57aa1df93daf$export$94065feca67a578c)["LEADS"]) newUrl = $c715ae85941a3e83$var$createUrlForLeads(newUrl, entityDetails);
        else if (matchedTab?.type === (0, $e5ce57aa1df93daf$export$94065feca67a578c)["OPPORTUNITY"]) newUrl = $c715ae85941a3e83$var$createUrlForOpportunites(newUrl, entityDetails);
    }
    window.open(newUrl.toString(), "_blank");
};
const $c715ae85941a3e83$var$createUrlForTasks = (url, entityDetails)=>{
    url.pathname = (0, $b61f740b64a51955$export$e21ff368c7512d8e)("Tasks");
    url.searchParams.set("activeTab", "manage-tasks");
    url.searchParams.set("taskAutoId", entityDetails?.userTaskAutoId);
    url.searchParams.set("leadType", entityDetails?.relatedEntity?.relatedEntityType);
    return url;
};
const $c715ae85941a3e83$var$createUrlForLeads = (url, entityDetails)=>{
    url.pathname = `${(0, $b61f740b64a51955$export$e21ff368c7512d8e)("Lead")}/LeadDetails`;
    url.searchParams.set("LeadID", entityDetails?.leadId);
    return url;
};
const $c715ae85941a3e83$var$createUrlForOpportunites = (url, entityDetails)=>{
    url.pathname = `${(0, $b61f740b64a51955$export$e21ff368c7512d8e)("Opportunity")}/OpportunityDetails`;
    url.searchParams.set("activeTab", "Tasks");
    url.searchParams.set("opportunityId", entityDetails?.prospectActivityId);
    url.searchParams.set("opportunityEvent", entityDetails?.activityEvent);
    return url;
};


var $b56dbdfd3053667d$exports = {};

$parcel$export($b56dbdfd3053667d$exports, "heading", function () { return $b56dbdfd3053667d$export$46e4a324ac90507f; }, function (v) { return $b56dbdfd3053667d$export$46e4a324ac90507f = v; });
$parcel$export($b56dbdfd3053667d$exports, "illustrationWrapper", function () { return $b56dbdfd3053667d$export$837a6cc01458e748; }, function (v) { return $b56dbdfd3053667d$export$837a6cc01458e748 = v; });
$parcel$export($b56dbdfd3053667d$exports, "listItem", function () { return $b56dbdfd3053667d$export$76c7e83ecc9cdf05; }, function (v) { return $b56dbdfd3053667d$export$76c7e83ecc9cdf05 = v; });
$parcel$export($b56dbdfd3053667d$exports, "listWrapper", function () { return $b56dbdfd3053667d$export$2b41fff34b4391de; }, function (v) { return $b56dbdfd3053667d$export$2b41fff34b4391de = v; });
$parcel$export($b56dbdfd3053667d$exports, "parentWrapper", function () { return $b56dbdfd3053667d$export$d45d45b2c4a7441e; }, function (v) { return $b56dbdfd3053667d$export$d45d45b2c4a7441e = v; });
$parcel$export($b56dbdfd3053667d$exports, "retryButton", function () { return $b56dbdfd3053667d$export$2e85e6a48fc253cd; }, function (v) { return $b56dbdfd3053667d$export$2e85e6a48fc253cd = v; });
$parcel$export($b56dbdfd3053667d$exports, "shimmerWrapper", function () { return $b56dbdfd3053667d$export$e43906f94426ecee; }, function (v) { return $b56dbdfd3053667d$export$e43906f94426ecee = v; });
$parcel$export($b56dbdfd3053667d$exports, "subHeading", function () { return $b56dbdfd3053667d$export$628dc1c0324367d; }, function (v) { return $b56dbdfd3053667d$export$628dc1c0324367d = v; });
var $b56dbdfd3053667d$export$46e4a324ac90507f;
var $b56dbdfd3053667d$export$837a6cc01458e748;
var $b56dbdfd3053667d$export$76c7e83ecc9cdf05;
var $b56dbdfd3053667d$export$2b41fff34b4391de;
var $b56dbdfd3053667d$export$d45d45b2c4a7441e;
var $b56dbdfd3053667d$export$2e85e6a48fc253cd;
var $b56dbdfd3053667d$export$e43906f94426ecee;
var $b56dbdfd3053667d$export$628dc1c0324367d;
$b56dbdfd3053667d$export$46e4a324ac90507f = `H4wjYW_heading`;
$b56dbdfd3053667d$export$837a6cc01458e748 = `H4wjYW_illustrationWrapper`;
$b56dbdfd3053667d$export$76c7e83ecc9cdf05 = `H4wjYW_listItem`;
$b56dbdfd3053667d$export$2b41fff34b4391de = `H4wjYW_listWrapper`;
$b56dbdfd3053667d$export$d45d45b2c4a7441e = `H4wjYW_parentWrapper`;
$b56dbdfd3053667d$export$2e85e6a48fc253cd = `H4wjYW_retryButton`;
$b56dbdfd3053667d$export$e43906f94426ecee = `H4wjYW_shimmerWrapper`;
$b56dbdfd3053667d$export$628dc1c0324367d = `H4wjYW_subHeading`;


const $da6377851d04d0c0$var$ListInterface = ({ data: data = {} })=>{
    const { list: list, isListLoading: isListLoading, config: config, smartviewsConfig: smartviewsConfig, isError: isError, retryHandler: retryHandler, count: count = 10 } = data;
    const isListEmpty = !isListLoading && !list?.length;
    const handleGoto = ()=>{
        const { config: config, id: id, type: type } = data;
        (0, $737000ecf5dd669d$export$8277f0dc87523523)(config, id, type);
    };
    /*===========================================
  ************* SKELETON LOADER ***************
  ============================================*/ if (isListLoading) return /*#__PURE__*/ (0, $7Tw3V.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($b56dbdfd3053667d$exports))).parentWrapper,
        "data-testid": "list-loader",
        children: [
            /*#__PURE__*/ (0, $7Tw3V.jsxs)("div", {
                className: `${(0, (/*@__PURE__*/$parcel$interopDefault($b56dbdfd3053667d$exports))).heading} ng_sh_sb`,
                children: [
                    /*#__PURE__*/ (0, $7Tw3V.jsx)((0, $0e4b252bf2d52338$export$2e2bcd8739ae039), {
                        width: "60%",
                        height: "20px"
                    }),
                    /*#__PURE__*/ (0, $7Tw3V.jsx)((0, $0e4b252bf2d52338$export$2e2bcd8739ae039), {
                        width: "20px",
                        height: "20px"
                    })
                ]
            }),
            [
                ...new Array(count < 10 ? count : 10).fill("_")
            ].map((value, index)=>{
                return /*#__PURE__*/ (0, $7Tw3V.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($b56dbdfd3053667d$exports))).shimmerWrapper,
                    children: /*#__PURE__*/ (0, $7Tw3V.jsx)((0, $0e4b252bf2d52338$export$2e2bcd8739ae039), {
                        width: "100%",
                        height: "28px"
                    })
                }, value + index);
            })
        ]
    });
    else if (isError) return /*#__PURE__*/ (0, $7Tw3V.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($b56dbdfd3053667d$exports))).parentWrapper,
        "data-testid": "list-error",
        children: [
            /*#__PURE__*/ (0, $7Tw3V.jsx)("div", {
                className: `${(0, (/*@__PURE__*/$parcel$interopDefault($b56dbdfd3053667d$exports))).heading} ng_sh_sb`,
                children: /*#__PURE__*/ (0, $7Tw3V.jsx)("div", {
                    children: config?.name
                })
            }),
            /*#__PURE__*/ (0, $7Tw3V.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($b56dbdfd3053667d$exports))).illustrationWrapper,
                children: [
                    /*#__PURE__*/ (0, $7Tw3V.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($022fd4bd14aa1f5a$exports))),
                        alt: "Error"
                    }),
                    /*#__PURE__*/ (0, $7Tw3V.jsx)("div", {
                        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($b56dbdfd3053667d$exports))).subHeading} ng_p_1_sb`,
                        children: "Couldn't fetch the data"
                    }),
                    /*#__PURE__*/ (0, $7Tw3V.jsxs)("button", {
                        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($b56dbdfd3053667d$exports))).retryButton} ng_p_1_b`,
                        onClick: retryHandler,
                        children: [
                            /*#__PURE__*/ (0, $7Tw3V.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($56b1974d94f7f2aa$exports))),
                                alt: "Reset"
                            }),
                            /*#__PURE__*/ (0, $7Tw3V.jsx)("span", {
                                children: "Retry"
                            })
                        ]
                    })
                ]
            })
        ]
    });
    /*===========================================
  ************ RETURNING LIST UI **************
  ============================================*/ return /*#__PURE__*/ (0, $7Tw3V.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($b56dbdfd3053667d$exports))).parentWrapper,
        children: [
            /*#__PURE__*/ (0, $7Tw3V.jsxs)("div", {
                className: `${(0, (/*@__PURE__*/$parcel$interopDefault($b56dbdfd3053667d$exports))).heading} ng_sh_sb`,
                children: [
                    /*#__PURE__*/ (0, $7Tw3V.jsx)("div", {
                        children: config?.name
                    }),
                    !isListEmpty && /*#__PURE__*/ (0, $7Tw3V.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($45bd5d196563da38$exports))),
                        alt: "Goto",
                        onClick: handleGoto,
                        "data-testid": "goto-button"
                    })
                ]
            }),
            isListEmpty ? /*#__PURE__*/ (0, $7Tw3V.jsx)($da6377851d04d0c0$var$EmptyListIllustration, {}) : /*#__PURE__*/ (0, $7Tw3V.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($b56dbdfd3053667d$exports))).listWrapper,
                children: list?.map((entityDetails, index)=>/*#__PURE__*/ (0, $7Tw3V.jsx)("div", {
                        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($b56dbdfd3053667d$exports))).listItem} ng_p_1_r`,
                        title: entityDetails?.name,
                        onClick: ()=>(0, $c715ae85941a3e83$export$90f8e1afc5451df8)(entityDetails, config, smartviewsConfig),
                        children: entityDetails?.name
                    }, entityDetails?.name + index))
            })
        ]
    });
};
const $da6377851d04d0c0$var$EmptyListIllustration = ()=>{
    return /*#__PURE__*/ (0, $7Tw3V.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($b56dbdfd3053667d$exports))).illustrationWrapper,
        children: [
            /*#__PURE__*/ (0, $7Tw3V.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($0f507b3559112c10$exports))),
                alt: "List Empty"
            }),
            /*#__PURE__*/ (0, $7Tw3V.jsx)("div", {
                className: `${(0, (/*@__PURE__*/$parcel$interopDefault($b56dbdfd3053667d$exports))).subHeading} ng_p_1_sb`,
                children: "No data found"
            })
        ]
    });
};
var $da6377851d04d0c0$export$2e2bcd8739ae039 = $da6377851d04d0c0$var$ListInterface;






const $7d5511bc1c73cbfa$var$Widget = ({ widget: widget, smartviewsConfig: smartviewsConfig, activeDashboardId: activeDashboardId, forceRefresh: forceRefresh })=>{
    const { id: id, widgetType: type, config: config } = widget;
    const [list, setList] = (0, $cQQee.useState)([]);
    const [isError, setIsError] = (0, $cQQee.useState)(null);
    const [isListLoading, setIsListLoading] = (0, $cQQee.useState)(true);
    const { widgetData: widgetData, loading: loading } = (0, $d3ec3d5546f90f60$export$2e2bcd8739ae039)(widget, smartviewsConfig, activeDashboardId, forceRefresh);
    const count = widgetData?.count;
    const widgetMap = {
        progressbar: /*#__PURE__*/ (0, $7Tw3V.jsx)((0, $4226cecac5d28e15$export$2e2bcd8739ae039), {
            configData: {
                config: widgetData
            }
        }),
        singlecounter: /*#__PURE__*/ (0, $7Tw3V.jsx)((0, $f60dce9bb66797b7$export$2e2bcd8739ae039), {
            configData: {
                config: widgetData
            }
        }),
        speedometer: /*#__PURE__*/ (0, $7Tw3V.jsx)((0, $9a1c7191c1ad3066$export$2e2bcd8739ae039), {
            configData: {
                config: widgetData
            }
        }),
        banner: /*#__PURE__*/ (0, $7Tw3V.jsx)((0, $10caf7b1ba15e44b$export$2e2bcd8739ae039), {
            configData: {
                config: widgetData
            }
        })
    };
    const handleOpenList = async ()=>{
        try {
            setIsListLoading(true);
            const list = await (0, $737000ecf5dd669d$export$73fffd6dda5144e)(config, smartviewsConfig);
            setList(list);
        } catch (error) {
            setIsError(error);
        } finally{
            setIsListLoading(false);
        }
        const analyticsData = {
            category: "widget_click",
            type: "click"
        };
        (0, $0efbd8a8be009329$export$2e2bcd8739ae039).sendEvent(`${type} widget clicked`, analyticsData);
    };
    const handleCloseList = ()=>{
        setList([]);
        setIsError(null);
    };
    const content = widgetMap[type] || /*#__PURE__*/ (0, $7Tw3V.jsx)("div", {
        role: "unknown-widget",
        children: "Unknown Widget Type"
    });
    const showListInterface = (0, $737000ecf5dd669d$export$d1d65c78874e7716)(type, config, smartviewsConfig, count);
    /*===========================================
  *************** RETURNING UI ****************
  ============================================*/ if (loading) return /*#__PURE__*/ (0, $7Tw3V.jsx)("div", {
        className: "widget-container",
        children: /*#__PURE__*/ (0, $7Tw3V.jsx)((0, $0e4b252bf2d52338$export$2e2bcd8739ae039), {
            width: "100%",
            height: "100%"
        })
    });
    else if (showListInterface) return /*#__PURE__*/ (0, $7Tw3V.jsx)("div", {
        className: "widget-container",
        children: /*#__PURE__*/ (0, $7Tw3V.jsx)("div", {
            className: "widget-content",
            role: "widget-content",
            children: /*#__PURE__*/ (0, $7Tw3V.jsx)((0, $18539ff951b37e9a$export$2e2bcd8739ae039), {
                trigger: content,
                onOpen: handleOpenList,
                onClose: handleCloseList,
                children: /*#__PURE__*/ (0, $7Tw3V.jsx)((0, $da6377851d04d0c0$export$2e2bcd8739ae039), {
                    data: {
                        config: config,
                        smartviewsConfig: smartviewsConfig,
                        id: id,
                        type: type,
                        list: list,
                        isListLoading: isListLoading,
                        isError: isError,
                        count: count,
                        retryHandler: handleOpenList
                    }
                })
            })
        })
    });
    else if (type === (0, $4b9f68b1938e412c$export$45f3f39dac49db7f).SingleCounter && !showListInterface || !count) return /*#__PURE__*/ (0, $7Tw3V.jsx)("div", {
        className: "widget-container",
        children: /*#__PURE__*/ (0, $7Tw3V.jsx)("div", {
            className: "widget-content",
            role: "widget-content",
            onClick: ()=>(0, $737000ecf5dd669d$export$8277f0dc87523523)(config, id),
            children: content
        })
    });
    return /*#__PURE__*/ (0, $7Tw3V.jsx)("div", {
        className: "widget-container",
        children: content
    });
};
var $7d5511bc1c73cbfa$export$2e2bcd8739ae039 = $7d5511bc1c73cbfa$var$Widget;



var $7Tw3V = parcelRequire("7Tw3V");

var $cQQee = parcelRequire("cQQee");




var $7Tw3V = parcelRequire("7Tw3V");
parcelRequire("cQQee");


var $7Tw3V = parcelRequire("7Tw3V");

var $cQQee = parcelRequire("cQQee");

var $7Tw3V = parcelRequire("7Tw3V");




var $0331f6d4294d0750$exports = {};
$0331f6d4294d0750$exports = $parcel$resolve("3P9iH");


var $0e7b8893cd3bf54c$exports = {};
$0e7b8893cd3bf54c$exports = $parcel$resolve("ktfa5");





const $104918bc44385884$var$formatDateKey = (date)=>{
    return date.toISOString().split("T")[0];
};
const $104918bc44385884$var$formatTaskData = (calendarData)=>(calendarData?.taskList || []).sort((a, b)=>{
        const dateA = new Date(a.auditDetails?.dueDateLocalTime);
        const dateB = new Date(b.auditDetails?.dueDateLocalTime);
        return dateA - dateB;
    }).map(({ name: name, auditDetails: auditDetails, relatedEntity: relatedEntity, category: category, color: color, userTaskAutoId: userTaskAutoId, status: status })=>({
            userTaskAutoId: userTaskAutoId,
            name: name,
            color: color,
            category: category,
            auditDetails: {
                dueDateLocalTime: auditDetails?.dueDateLocalTime,
                endDateLocalTime: auditDetails?.endDateLocalTime
            },
            status: {
                status: status?.status
            },
            relatedEntity: {
                relatedEntityIdName: relatedEntity?.relatedEntityIdName,
                relatedEntityId: relatedEntity?.relatedEntityId,
                relatedSubEntityIsOpportunity: relatedEntity?.relatedSubEntityIsOpportunity,
                relatedSubEntityName: relatedEntity?.relatedSubEntityName,
                relatedSubEntityId: relatedEntity?.relatedSubEntityId,
                relatedSubEntityEvent: relatedEntity?.relatedSubEntityEvent,
                relatedEntityType: relatedEntity?.relatedEntityType
            }
        }));
function $104918bc44385884$var$getIsDate(selectedDate) {
    const today = new Date();
    // Normalize both dates to remove time component
    const selected = new Date(selectedDate);
    selected.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);
    return selected.getTime() === today.getTime();
}
const $104918bc44385884$export$9e647c1614df7d99 = (activeDashboardId, widget, forceRefresh)=>{
    const { id: id, updatedAt: updatedAt } = widget;
    const counterCache = (0, $e679a7ba462dea27$export$e2575ed62a2f107b)();
    const widgetCache = counterCache?.[activeDashboardId]?.[id];
    const currentTime = Date.now();
    if ((0, $e679a7ba462dea27$export$86165a58bbc2b5ab) && !forceRefresh && widgetCache?.timestamp && widgetCache.data && currentTime - widgetCache.timestamp < (0, $e679a7ba462dea27$export$877bd841cf3755de) && new Date(updatedAt) < new Date(widgetCache.timestamp)) return widgetCache.data;
    return null;
};
const $104918bc44385884$export$ff8cf4de893780b6 = async (selectedDate, setTasks, activeDashboardId, widget, forceRefresh)=>{
    const cachedData = $104918bc44385884$export$9e647c1614df7d99(activeDashboardId, widget, forceRefresh);
    const isToday = $104918bc44385884$var$getIsDate(selectedDate);
    if (isToday && cachedData) return setTasks({
        responseStatus: (0, $4b9f68b1938e412c$export$2a1f9a4a898c1733).requestFullfilled,
        response: cachedData
    });
    setTasks({
        responseStatus: (0, $4b9f68b1938e412c$export$2a1f9a4a898c1733).requestPending
    });
    let postBody = (0, $b61f740b64a51955$export$b9e1badb9711e940)({
        config: widget.config
    });
    postBody.filters = {
        ...postBody.filters,
        from: $104918bc44385884$var$formatDateKey(selectedDate),
        to: $104918bc44385884$var$formatDateKey(selectedDate)
    };
    const calendarData = await (0, $3a9d902ac0f87e31$export$604816b052fb037f)(postBody);
    const response = $104918bc44385884$var$formatTaskData(calendarData);
    setTasks(calendarData ? {
        responseStatus: (0, $4b9f68b1938e412c$export$2a1f9a4a898c1733).requestFullfilled,
        response: response
    } : {
        responseStatus: (0, $4b9f68b1938e412c$export$2a1f9a4a898c1733).requestRejected
    });
    if (isToday) (0, $e679a7ba462dea27$export$8f130c338353ac35)(activeDashboardId, widget.id, response);
};
const $104918bc44385884$export$48001ea8b7ba2aff = (event)=>{
    let newUrl = new URL(window.location.href);
    if (event?.userTaskAutoId) {
        newUrl.pathname = (0, $b61f740b64a51955$export$e21ff368c7512d8e)("Tasks");
        newUrl.searchParams.set("activeTab", "manage-tasks");
        newUrl.searchParams.set("taskAutoId", event?.userTaskAutoId);
        newUrl.searchParams.set("leadType", event?.relatedEntity?.relatedEntityType);
    }
    window.open(newUrl.toString(), "_blank");
    const analyticsData = {
        category: "widget_click",
        type: "click"
    };
    (0, $0efbd8a8be009329$export$2e2bcd8739ae039).sendEvent("calendarview task card clicked", analyticsData);
};
const $104918bc44385884$export$147f4af846000df3 = (event)=>{
    let newUrl = new URL(window.location.href);
    if (event?.relatedEntity?.relatedEntityId) {
        newUrl.pathname = `${(0, $b61f740b64a51955$export$e21ff368c7512d8e)("Lead")}/LeadDetails`;
        newUrl.searchParams.delete("activeTab", "manage-tasks");
        newUrl.searchParams.set("LeadID", event?.relatedEntity?.relatedEntityId);
    }
    window.open(newUrl.toString(), "_blank");
    const analyticsData = {
        category: "widget_click",
        type: "click"
    };
    (0, $0efbd8a8be009329$export$2e2bcd8739ae039).sendEvent("calendarview task card - lead entity clicked", analyticsData);
};
const $104918bc44385884$export$60c92902999b62f7 = (event)=>{
    let newUrl = new URL(window.location.href);
    if (event?.relatedEntity?.relatedEntityId) {
        newUrl.pathname = `${(0, $b61f740b64a51955$export$e21ff368c7512d8e)("Opportunity")}/OpportunityDetails`;
        newUrl.searchParams.set("activeTab", "Tasks");
        newUrl.searchParams.set("opportunityId", event?.relatedEntity?.relatedSubEntityId);
        newUrl.searchParams.set("opportunityEvent", event?.relatedEntity?.relatedSubEntityEvent);
    }
    window.open(newUrl.toString(), "_blank");
    const analyticsData = {
        category: "widget_click",
        type: "click"
    };
    (0, $0efbd8a8be009329$export$2e2bcd8739ae039).sendEvent("calendarview task card - opportunity entity clicked", analyticsData);
};
const $104918bc44385884$export$f19af34d3c5a4d7c = (event)=>{
    const dueDate = new Date(event.auditDetails?.dueDateLocalTime);
    const endDate = new Date(event.auditDetails?.endDateLocalTime);
    const startPosition = dueDate.getHours() * (0, $da9248f3cd4351e3$export$18e9cce81e8335f8) + dueDate.getMinutes() / 60 * (0, $da9248f3cd4351e3$export$18e9cce81e8335f8);
    const endPosition = endDate.getHours() * (0, $da9248f3cd4351e3$export$18e9cce81e8335f8) + endDate.getMinutes() / 60 * (0, $da9248f3cd4351e3$export$18e9cce81e8335f8);
    return {
        startPosition: startPosition,
        endPosition: endPosition
    };
};
const $104918bc44385884$export$c2f42b50d7a3b8c0 = (event, selectedDate)=>{
    const dueDate = new Date(event.auditDetails?.dueDateLocalTime);
    let endDate = new Date(event.auditDetails?.endDateLocalTime);
    const timeDifference = endDate.getTime() - dueDate.getTime();
    if (timeDifference < 900000) endDate = new Date(dueDate.getTime() + 900000);
    const selectedDateStartOfDay = new Date(selectedDate).setHours(0, 0, 0, 0);
    const dueDateStartOfDay = new Date(dueDate).setHours(0, 0, 0, 0);
    const endDateStartOfDay = new Date(endDate).setHours(0, 0, 0, 0);
    let startPosition = 0;
    if (selectedDateStartOfDay <= dueDateStartOfDay) startPosition = dueDate.getHours() * (0, $da9248f3cd4351e3$export$18e9cce81e8335f8) + dueDate.getMinutes() / 60 * (0, $da9248f3cd4351e3$export$18e9cce81e8335f8);
    let endPosition = 0;
    if (selectedDateStartOfDay < endDateStartOfDay) endPosition = 24 * (0, $da9248f3cd4351e3$export$18e9cce81e8335f8);
    else if (selectedDateStartOfDay === endDateStartOfDay) endPosition = endDate.getHours() * (0, $da9248f3cd4351e3$export$18e9cce81e8335f8) + endDate.getMinutes() / 60 * (0, $da9248f3cd4351e3$export$18e9cce81e8335f8);
    return {
        startPosition: startPosition,
        endPosition: endPosition
    };
};
const $104918bc44385884$export$7ecb76505f3f02fe = ({ event: event = {} })=>{
    const isTodo = event.category === 1;
    const eventColor = event.color || "rgb(var(--ng-grey-50))";
    const Icon = isTodo ? (0, $0331f6d4294d0750$exports.ReactComponent) : (0, $0e7b8893cd3bf54c$exports.ReactComponent);
    // Convert hex to rgba with 0.15 opacity
    const hexToRgba = (hex, alpha)=>{
        const r = parseInt(hex.slice(1, 3), 16);
        const g = parseInt(hex.slice(3, 5), 16);
        const b = parseInt(hex.slice(5, 7), 16);
        return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    };
    return /*#__PURE__*/ (0, $7Tw3V.jsx)("div", {
        role: "task-icon",
        className: "calander-task-icon text-xs",
        style: {
            backgroundColor: hexToRgba(eventColor, 0.3)
        },
        children: /*#__PURE__*/ (0, $7Tw3V.jsx)(Icon, {
            className: "calander-task-icon-svg",
            style: {
                color: eventColor
            }
        })
    });
};
const $104918bc44385884$export$88475b6d339d4121 = (smooth, timelineRef)=>{
    if (timelineRef.current) {
        const now = new Date();
        const currentTimePosition = $104918bc44385884$export$f19af34d3c5a4d7c({
            auditDetails: {
                dueDateLocalTime: now
            }
        });
        const containerHeight = timelineRef.current.clientHeight;
        const scrollPosition = Math.max(0, currentTimePosition?.startPosition - containerHeight / 2);
        if (smooth) timelineRef.current.scrollTo({
            top: scrollPosition,
            behavior: "smooth"
        });
        else timelineRef.current.scrollTop = scrollPosition;
    }
};
const $104918bc44385884$var$parseDate = (dateStr)=>new Date(dateStr);
const $104918bc44385884$export$364ef265938c178a = (events)=>{
    let maxOverlapCount = 0;
    const updatedTasks = events.map((task, index, arr)=>{
        let position;
        const startTime = $104918bc44385884$var$parseDate(task.auditDetails?.dueDateLocalTime);
        const endTime = $104918bc44385884$var$parseDate(task.auditDetails?.endDateLocalTime);
        let overlapCount = 0;
        arr.forEach((otherTask, i)=>{
            if (i !== index) {
                const otherStartTime = $104918bc44385884$var$parseDate(otherTask.auditDetails?.dueDateLocalTime);
                const otherEndTime = $104918bc44385884$var$parseDate(otherTask.auditDetails?.endDateLocalTime);
                if (startTime < otherEndTime && endTime > otherStartTime) overlapCount++;
            } else position = overlapCount;
        });
        overlapCount++;
        maxOverlapCount = maxOverlapCount > overlapCount ? maxOverlapCount : overlapCount;
        return {
            ...task,
            overlapCount: overlapCount,
            position: position
        };
    });
    return [
        updatedTasks,
        maxOverlapCount
    ];
};



var $7Tw3V = parcelRequire("7Tw3V");
parcelRequire("cQQee");
var $189a9b421bc6918b$exports = {};
$189a9b421bc6918b$exports = $parcel$resolve("edSbf");


var $806b85d14d3d7f1c$exports = {};
$806b85d14d3d7f1c$exports = $parcel$resolve("h6v4l");




const $7fa81b69ca1e4b37$var$AssociatedEntity = ({ event: event = {} })=>{
    const { relatedEntity: relatedEntity, category: category, auditDetails: auditDetails } = event;
    if (!relatedEntity) return null;
    const isUpcoming = category === 1 || auditDetails?.dueDateLocalTime && new Date(auditDetails?.dueDateLocalTime) - new Date() <= 900000 && auditDetails?.endDateLocalTime && new Date(auditDetails?.endDateLocalTime) > new Date();
    const { relatedSubEntityIsOpportunity: relatedSubEntityIsOpportunity, relatedSubEntityName: relatedSubEntityName, relatedEntityIdName: relatedEntityIdName } = relatedEntity;
    const handleClick = relatedSubEntityIsOpportunity ? (0, $104918bc44385884$export$60c92902999b62f7) : (0, $104918bc44385884$export$147f4af846000df3);
    const entityName = relatedSubEntityIsOpportunity ? relatedSubEntityName : relatedEntityIdName;
    const Icon = relatedSubEntityIsOpportunity ? (0, (/*@__PURE__*/$parcel$interopDefault($806b85d14d3d7f1c$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($189a9b421bc6918b$exports)));
    return entityName && /*#__PURE__*/ (0, $7Tw3V.jsxs)("span", {
        className: `associated-entity ${isUpcoming && "is-upcoming"}`,
        onClick: (e)=>{
            e.stopPropagation();
            handleClick(event);
        },
        children: [
            /*#__PURE__*/ (0, $7Tw3V.jsx)("img", {
                src: Icon,
                alt: "associated entity"
            }),
            /*#__PURE__*/ (0, $7Tw3V.jsx)("label", {
                className: "overflow-ellipsis ng_p_2_sb",
                children: entityName
            })
        ]
    });
};
var $7fa81b69ca1e4b37$export$2e2bcd8739ae039 = $7fa81b69ca1e4b37$var$AssociatedEntity;



var $7Tw3V = parcelRequire("7Tw3V");
parcelRequire("cQQee");
var $3df119d327fe7858$exports = {};
$3df119d327fe7858$exports = $parcel$resolve("dhyLL");




const $c71775c0d6bb5fa7$var$TastStatus = ({ event: event })=>{
    const dateToCheck = new Date(event?.auditDetails?.endDateLocalTime);
    const currentDate = new Date();
    let status = (0, $b61f740b64a51955$export$6c9d0c3cc08fd961)?.[event?.status?.status];
    if (status === "pending" && dateToCheck < currentDate) status = "overdue";
    return /*#__PURE__*/ (0, $7Tw3V.jsxs)("div", {
        className: `task-status ng_p_2_r ${status}`,
        children: [
            status === "overdue" ? status : "",
            status === "completed" && /*#__PURE__*/ (0, $7Tw3V.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($3df119d327fe7858$exports))),
                alt: "icon",
                style: {
                    width: "12px",
                    height: "12px"
                }
            })
        ]
    });
};
var $c71775c0d6bb5fa7$export$2e2bcd8739ae039 = $c71775c0d6bb5fa7$var$TastStatus;


const $6fde404c193d0fbc$var$AgendaTaskCard = ({ event: event, showTime: showTime = true })=>{
    const isTodo = event.category === 1;
    // Memoize the formatted time and position calculation
    const formattedTime = (0, $cQQee.useMemo)(()=>new Date(event.auditDetails?.dueDateLocalTime).toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true
        }).toUpperCase(), [
        event.auditDetails.dueDateLocalTime
    ]);
    const { startPosition: startPosition, endPosition: endPosition } = (0, $104918bc44385884$export$f19af34d3c5a4d7c)(event);
    const time = (0, $cQQee.useMemo)(()=>endPosition - startPosition, [
        startPosition,
        endPosition
    ]);
    return /*#__PURE__*/ (0, $7Tw3V.jsxs)("div", {
        className: "agenda-task-card ng_p_2_r",
        children: [
            showTime && /*#__PURE__*/ (0, $7Tw3V.jsxs)("div", {
                className: "time-details",
                children: [
                    /*#__PURE__*/ (0, $7Tw3V.jsx)("label", {
                        className: "time",
                        children: formattedTime
                    }),
                    !isTodo && /*#__PURE__*/ (0, $7Tw3V.jsxs)("label", {
                        className: "duration",
                        children: [
                            time,
                            " min"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7Tw3V.jsxs)("div", {
                className: "task-card-content overflow-ellipsis ng_p_2_r",
                children: [
                    /*#__PURE__*/ (0, $7Tw3V.jsx)((0, $c71775c0d6bb5fa7$export$2e2bcd8739ae039), {
                        event: event
                    }),
                    /*#__PURE__*/ (0, $7Tw3V.jsx)((0, $104918bc44385884$export$7ecb76505f3f02fe), {
                        event: event
                    }),
                    /*#__PURE__*/ (0, $7Tw3V.jsxs)("div", {
                        className: "task-name-lead overflow-ellipsis",
                        children: [
                            /*#__PURE__*/ (0, $7Tw3V.jsx)("div", {
                                className: "event-name overflow-ellipsis ng_p_2_sb",
                                onClick: ()=>(0, $104918bc44385884$export$48001ea8b7ba2aff)(event),
                                children: event.name
                            }),
                            event.relatedEntity?.relatedEntityIdName && /*#__PURE__*/ (0, $7Tw3V.jsx)((0, $7fa81b69ca1e4b37$export$2e2bcd8739ae039), {
                                event: event
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $6fde404c193d0fbc$export$2e2bcd8739ae039 = $6fde404c193d0fbc$var$AgendaTaskCard;



var $7Tw3V = parcelRequire("7Tw3V");
parcelRequire("cQQee");

/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ /**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $cQQee = parcelRequire("cQQee");
/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $82bffa568e762a5c$export$73bda83cddbc7187 = (string)=>string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
const $82bffa568e762a5c$export$3d46f4579dba46e5 = (...classes)=>classes.filter((className, index, array)=>{
        return Boolean(className) && array.indexOf(className) === index;
    }).join(" ");


/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $cQQee = parcelRequire("cQQee");
/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var $cd25a1f191bbdc0f$export$2e2bcd8739ae039 = {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
};



const $d2ebc4ad3bd253df$export$2e2bcd8739ae039 = (0, $cQQee.forwardRef)(({ color: color = "currentColor", size: size = 24, strokeWidth: strokeWidth = 2, absoluteStrokeWidth: absoluteStrokeWidth, className: className = "", children: children, iconNode: iconNode, ...rest }, ref)=>{
    return (0, $cQQee.createElement)("svg", {
        ref: ref,
        ...(0, $cd25a1f191bbdc0f$export$2e2bcd8739ae039),
        width: size,
        height: size,
        stroke: color,
        strokeWidth: absoluteStrokeWidth ? Number(strokeWidth) * 24 / Number(size) : strokeWidth,
        className: (0, $82bffa568e762a5c$export$3d46f4579dba46e5)("lucide", className),
        ...rest
    }, [
        ...iconNode.map(([tag, attrs])=>(0, $cQQee.createElement)(tag, attrs)),
        ...Array.isArray(children) ? children : [
            children
        ]
    ]);
});


const $b86367cb1f7486a4$export$2e2bcd8739ae039 = (iconName, iconNode)=>{
    const Component = (0, $cQQee.forwardRef)(({ className: className, ...props }, ref)=>(0, $cQQee.createElement)((0, $d2ebc4ad3bd253df$export$2e2bcd8739ae039), {
            ref: ref,
            iconNode: iconNode,
            className: (0, $82bffa568e762a5c$export$3d46f4579dba46e5)(`lucide-${(0, $82bffa568e762a5c$export$73bda83cddbc7187)(iconName)}`, className),
            ...props
        }));
    Component.displayName = `${iconName}`;
    return Component;
};


const $b20b57f6d9a55509$export$2e2bcd8739ae039 = (0, $b86367cb1f7486a4$export$2e2bcd8739ae039)("ChevronLeft", [
    [
        "path",
        {
            d: "m15 18-6-6 6-6",
            key: "1wnfg3"
        }
    ]
]);

/**
 * @license lucide-react v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $27c7f318cede5560$export$2e2bcd8739ae039 = (0, $b86367cb1f7486a4$export$2e2bcd8739ae039)("ChevronRight", [
    [
        "path",
        {
            d: "m9 18 6-6-6-6",
            key: "mthhwq"
        }
    ]
]);


const $95bd063ab9ed7b61$var$TasksHeader = ({ todos: todos, appointments: appointments, showScroll: showScroll = true, children: children, refObj: refObj })=>{
    const scrollLeft = ()=>{
        if (refObj?.current) refObj.current.scrollBy({
            left: -170,
            behavior: "smooth"
        });
    };
    const scrollRight = ()=>{
        if (refObj?.current) refObj.current.scrollBy({
            left: 170,
            behavior: "smooth"
        });
    };
    return /*#__PURE__*/ (0, $7Tw3V.jsxs)("div", {
        className: "tasks-header ng_p_2_r",
        role: "tasks-header",
        children: [
            /*#__PURE__*/ (0, $7Tw3V.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7Tw3V.jsxs)("label", {
                        children: [
                            todos !== undefined && `${todos} To-dos`,
                            todos !== undefined && appointments !== undefined && ", ",
                            appointments !== undefined && `${appointments} Appointments`
                        ]
                    }),
                    showScroll && /*#__PURE__*/ (0, $7Tw3V.jsxs)("div", {
                        className: "header-buttons",
                        role: "header-buttons",
                        children: [
                            /*#__PURE__*/ (0, $7Tw3V.jsx)("button", {
                                onClick: scrollLeft,
                                className: "scroll-button",
                                role: "left-button",
                                children: /*#__PURE__*/ (0, $7Tw3V.jsx)((0, $b20b57f6d9a55509$export$2e2bcd8739ae039), {
                                    size: 20
                                })
                            }),
                            /*#__PURE__*/ (0, $7Tw3V.jsx)("button", {
                                onClick: scrollRight,
                                className: "scroll-button",
                                role: "right-button",
                                children: /*#__PURE__*/ (0, $7Tw3V.jsx)((0, $27c7f318cede5560$export$2e2bcd8739ae039), {
                                    size: 20
                                })
                            })
                        ]
                    })
                ]
            }),
            children
        ]
    });
};
var $95bd063ab9ed7b61$export$2e2bcd8739ae039 = $95bd063ab9ed7b61$var$TasksHeader;


const $889e2c52f6e388ac$var$AgendaTasks = ({ events: events = [] })=>{
    let todos = 0;
    let appointments = 0;
    events.forEach((event)=>{
        if (event.category === 1) todos++;
        else appointments++;
    });
    return /*#__PURE__*/ (0, $7Tw3V.jsx)((0, $95bd063ab9ed7b61$export$2e2bcd8739ae039), {
        todos: todos,
        appointments: appointments,
        showScroll: false,
        children: /*#__PURE__*/ (0, $7Tw3V.jsx)("div", {
            className: "agenda-tasks-list",
            children: events.map((event)=>/*#__PURE__*/ (0, $7Tw3V.jsx)((0, $6fde404c193d0fbc$export$2e2bcd8739ae039), {
                    event: event
                }, event.userTaskId))
        })
    });
};
var $889e2c52f6e388ac$export$2e2bcd8739ae039 = $889e2c52f6e388ac$var$AgendaTasks;




var $7Tw3V = parcelRequire("7Tw3V");

var $cQQee = parcelRequire("cQQee");


var $7Tw3V = parcelRequire("7Tw3V");

var $cQQee = parcelRequire("cQQee");



var $7Tw3V = parcelRequire("7Tw3V");
parcelRequire("cQQee");


const $a1cc2aff46efa16b$var$CalendarTaskCard = ({ event: event, showLead: showLead = true })=>{
    return /*#__PURE__*/ (0, $7Tw3V.jsxs)("div", {
        className: `calendar-task-card ${showLead || "small-card-variant"}`,
        children: [
            /*#__PURE__*/ (0, $7Tw3V.jsx)("div", {
                className: "event-name",
                style: {
                    background: event?.color || "rgb(var(--ng-grey-50))"
                }
            }),
            /*#__PURE__*/ (0, $7Tw3V.jsx)("div", {
                className: "task-name overflow-ellipsis ng_p_2_sb",
                title: event?.name,
                children: event?.name
            }),
            showLead && /*#__PURE__*/ (0, $7Tw3V.jsx)((0, $7fa81b69ca1e4b37$export$2e2bcd8739ae039), {
                event: event
            })
        ]
    });
};
var $a1cc2aff46efa16b$export$2e2bcd8739ae039 = $a1cc2aff46efa16b$var$CalendarTaskCard;




const $8cc308a3dc63ae05$var$TodoList = ({ todos: todos = [] })=>{
    const ref = (0, $cQQee.useRef)();
    if (todos.length === 0) return;
    return /*#__PURE__*/ (0, $7Tw3V.jsx)("div", {
        className: "todo-list",
        role: "todo-list",
        children: /*#__PURE__*/ (0, $7Tw3V.jsx)((0, $95bd063ab9ed7b61$export$2e2bcd8739ae039), {
            todos: todos.length,
            refObj: ref,
            children: /*#__PURE__*/ (0, $7Tw3V.jsx)("div", {
                className: "list-container",
                ref: ref,
                children: todos.map((todo)=>/*#__PURE__*/ (0, $7Tw3V.jsxs)("div", {
                        onClick: ()=>(0, $104918bc44385884$export$48001ea8b7ba2aff)(todo),
                        children: [
                            /*#__PURE__*/ (0, $7Tw3V.jsx)((0, $c71775c0d6bb5fa7$export$2e2bcd8739ae039), {
                                event: todo
                            }),
                            /*#__PURE__*/ (0, $7Tw3V.jsx)((0, $a1cc2aff46efa16b$export$2e2bcd8739ae039), {
                                event: todo
                            })
                        ]
                    }))
            })
        })
    });
};
var $8cc308a3dc63ae05$export$2e2bcd8739ae039 = $8cc308a3dc63ae05$var$TodoList;



var $7Tw3V = parcelRequire("7Tw3V");

var $cQQee = parcelRequire("cQQee");

var $7Tw3V = parcelRequire("7Tw3V");
parcelRequire("cQQee");

const $31a33a21d5a6cb6e$var$LSQFrame = ({ children: children, type: type = "frame1", className: className, role: role })=>{
    return /*#__PURE__*/ (0, $7Tw3V.jsx)("div", {
        className: `lsq-frame ${className} ${type}`,
        role: role,
        children: children
    });
};
var $31a33a21d5a6cb6e$export$2e2bcd8739ae039 = $31a33a21d5a6cb6e$var$LSQFrame;





var $7Tw3V = parcelRequire("7Tw3V");
parcelRequire("cQQee");


const $c7c8be1a33380b21$var$HoursIndicate = ({ calculatedWidth: calculatedWidth })=>{
    const halfHours = Array.from({
        length: 48
    }, (_, i)=>i / 2);
    return /*#__PURE__*/ (0, $7Tw3V.jsx)((0, $7Tw3V.Fragment), {
        children: halfHours.map((hour, index)=>/*#__PURE__*/ (0, $7Tw3V.jsxs)("div", {
                role: "hour-line",
                className: "hours-indicator",
                style: {
                    top: `${hour * (0, $da9248f3cd4351e3$export$18e9cce81e8335f8)}px`,
                    height: `${(0, $da9248f3cd4351e3$export$18e9cce81e8335f8) / 2}px`,
                    width: calculatedWidth
                },
                children: [
                    /*#__PURE__*/ (0, $7Tw3V.jsx)("div", {
                        className: "hour-label ng_p_1_sb",
                        children: `${Math.floor(hour).toString().padStart(2, "0")}:${index % 2 === 0 ? "00" : "30"}`
                    }),
                    /*#__PURE__*/ (0, $7Tw3V.jsx)("div", {
                        className: `hour-line ${index % 2 === 0 && "dotted-border"}`
                    }),
                    /*#__PURE__*/ (0, $7Tw3V.jsx)("div", {
                        className: "hour-left-line"
                    })
                ]
            }, hour))
    });
};
var $c7c8be1a33380b21$export$2e2bcd8739ae039 = $c7c8be1a33380b21$var$HoursIndicate;



var $7Tw3V = parcelRequire("7Tw3V");

var $cQQee = parcelRequire("cQQee");


const $4db734036c585bd2$var$CurrentTime = ({ calculatedWidth: calculatedWidth })=>{
    const [currentTime, setCurrentTime] = (0, $cQQee.useState)(new Date());
    (0, $cQQee.useEffect)(()=>{
        const timer = setInterval(()=>{
            setCurrentTime(new Date());
        }, 30000);
        return ()=>clearInterval(timer);
    }, []);
    return /*#__PURE__*/ (0, $7Tw3V.jsx)("div", {
        className: "current-time",
        role: "current-time",
        style: {
            top: `${(0, $104918bc44385884$export$f19af34d3c5a4d7c)({
                auditDetails: {
                    dueDateLocalTime: currentTime
                }
            })?.startPosition}px`,
            width: calculatedWidth
        },
        children: /*#__PURE__*/ (0, $7Tw3V.jsx)("div", {
            className: "time-label ng_p_2_b",
            children: /*#__PURE__*/ (0, $7Tw3V.jsxs)("span", {
                children: [
                    currentTime.getHours().toString().padStart(2, "0"),
                    ":",
                    currentTime.getMinutes().toString().padStart(2, "0")
                ]
            })
        })
    });
};
var $4db734036c585bd2$export$2e2bcd8739ae039 = $4db734036c585bd2$var$CurrentTime;






var $7Tw3V = parcelRequire("7Tw3V");
parcelRequire("cQQee");




const $825b2c63f454c483$var$List = ({ updatedTasks: updatedTasks = [], selectedDate: selectedDate })=>{
    return /*#__PURE__*/ (0, $7Tw3V.jsx)((0, $7Tw3V.Fragment), {
        children: updatedTasks.map((event)=>{
            const { startPosition: startPosition = 0, endPosition: endPosition = 0 } = (0, $104918bc44385884$export$c2f42b50d7a3b8c0)(event, selectedDate) || {};
            const eventHeight = endPosition - startPosition;
            let width = 75;
            if (event.overlapCount !== 1) width = 100 / (event.overlapCount > (0, $da9248f3cd4351e3$export$d4b87150515e8d33) ? (0, $da9248f3cd4351e3$export$d4b87150515e8d33) : event.overlapCount);
            return /*#__PURE__*/ (0, $7Tw3V.jsxs)("div", {
                role: "appointment-card",
                onClick: ()=>(0, $104918bc44385884$export$48001ea8b7ba2aff)(event),
                className: `calendar-task overflow-ellipsis`,
                style: {
                    top: `${startPosition}px`,
                    left: `${event.position * 100 / (event.overlapCount > (0, $da9248f3cd4351e3$export$d4b87150515e8d33) ? (0, $da9248f3cd4351e3$export$d4b87150515e8d33) : event.overlapCount)}%`,
                    height: `${eventHeight}px`,
                    width: `calc(${width}% - 4px)`
                },
                children: [
                    /*#__PURE__*/ (0, $7Tw3V.jsx)((0, $c71775c0d6bb5fa7$export$2e2bcd8739ae039), {
                        event: event
                    }),
                    /*#__PURE__*/ (0, $7Tw3V.jsx)((0, $a1cc2aff46efa16b$export$2e2bcd8739ae039), {
                        event: event,
                        showLead: eventHeight >= 45
                    })
                ]
            }, event.userTaskId);
        })
    });
};
var $825b2c63f454c483$export$2e2bcd8739ae039 = $825b2c63f454c483$var$List;


const $22f43d476b5d337d$var$CalendarTasks = ({ selectedDate: selectedDate, appointments: appointments })=>{
    const [updatedTasks, maxOverlapCount] = (0, $104918bc44385884$export$364ef265938c178a)(appointments);
    const timelineRef = (0, $cQQee.useRef)();
    const timelineHeight = (0, $da9248f3cd4351e3$export$18e9cce81e8335f8) * 24;
    const calculatedWidth = maxOverlapCount > (0, $da9248f3cd4351e3$export$d4b87150515e8d33) ? `calc(${maxOverlapCount * 100 / (0, $da9248f3cd4351e3$export$d4b87150515e8d33)}% + 50px)` : "100%";
    (0, $cQQee.useEffect)(()=>{
        (0, $104918bc44385884$export$88475b6d339d4121)(true, timelineRef);
        const intervalId = setInterval(()=>(0, $104918bc44385884$export$88475b6d339d4121)(false, timelineRef), 60000);
        return ()=>clearInterval(intervalId);
    }, []);
    if (updatedTasks.length === 0) return /*#__PURE__*/ (0, $7Tw3V.jsxs)((0, $31a33a21d5a6cb6e$export$2e2bcd8739ae039), {
        className: "calender-empty",
        role: "appointments-empty",
        children: [
            /*#__PURE__*/ (0, $7Tw3V.jsx)((0, $2f0a72dbc6470dcd$export$2e2bcd8739ae039), {
                src: "assets/icons/empty_state.svg",
                alt: "icon",
                isWidgetIcon: false
            }),
            /*#__PURE__*/ (0, $7Tw3V.jsx)("label", {
                children: (0, $4b9f68b1938e412c$export$20139851dc7757d2).noAppointmentsScheduled
            })
        ]
    });
    return /*#__PURE__*/ (0, $7Tw3V.jsx)((0, $95bd063ab9ed7b61$export$2e2bcd8739ae039), {
        appointments: updatedTasks.length,
        refObj: timelineRef,
        children: /*#__PURE__*/ (0, $7Tw3V.jsx)("div", {
            ref: timelineRef,
            className: "timeline-container",
            children: /*#__PURE__*/ (0, $7Tw3V.jsxs)("div", {
                style: {
                    height: `${timelineHeight}px`
                },
                children: [
                    /*#__PURE__*/ (0, $7Tw3V.jsx)((0, $c7c8be1a33380b21$export$2e2bcd8739ae039), {
                        calculatedWidth: calculatedWidth
                    }),
                    /*#__PURE__*/ (0, $7Tw3V.jsx)((0, $4db734036c585bd2$export$2e2bcd8739ae039), {
                        calculatedWidth: calculatedWidth
                    }),
                    /*#__PURE__*/ (0, $7Tw3V.jsx)((0, $825b2c63f454c483$export$2e2bcd8739ae039), {
                        selectedDate: selectedDate,
                        updatedTasks: updatedTasks
                    })
                ]
            })
        })
    });
};
var $22f43d476b5d337d$export$2e2bcd8739ae039 = $22f43d476b5d337d$var$CalendarTasks;


const $b0b6539449af1892$var$TimeLine = ({ events: events, selectedDate: selectedDate })=>{
    const { appointments: appointments, todos: todos } = (0, $cQQee.useMemo)(()=>{
        const appointments = [];
        const todos = [];
        events.forEach((event)=>(event.category === 1 ? todos : appointments).push(event));
        return {
            appointments: appointments,
            todos: todos
        };
    }, [
        events
    ]);
    return /*#__PURE__*/ (0, $7Tw3V.jsxs)("div", {
        className: "calender-tasks",
        children: [
            /*#__PURE__*/ (0, $7Tw3V.jsx)((0, $8cc308a3dc63ae05$export$2e2bcd8739ae039), {
                todos: todos
            }),
            /*#__PURE__*/ (0, $7Tw3V.jsx)((0, $22f43d476b5d337d$export$2e2bcd8739ae039), {
                selectedDate: selectedDate,
                appointments: appointments
            })
        ]
    });
};
var $b0b6539449af1892$export$2e2bcd8739ae039 = $b0b6539449af1892$var$TimeLine;




var $7Tw3V = parcelRequire("7Tw3V");

var $cQQee = parcelRequire("cQQee");

var $9AqQV = parcelRequire("9AqQV");
var $bf9b8d1577f662f3$export$5edeffb658f039f4 = {
    exports: {}
};


var $cd2f896d748da4bc$export$362abb7de8d8bb41 = {};



var $cQQee = parcelRequire("cQQee");
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $77b4ffeb2a02b0a1$var$hasRequiredReactJsxRuntime_production_min;
function $77b4ffeb2a02b0a1$export$b88c30a9414655a0() {
    if ($77b4ffeb2a02b0a1$var$hasRequiredReactJsxRuntime_production_min) return 0, $cd2f896d748da4bc$export$362abb7de8d8bb41;
    $77b4ffeb2a02b0a1$var$hasRequiredReactJsxRuntime_production_min = 1;
    var f = (0, (/*@__PURE__*/$parcel$interopDefault($cQQee))), k = Symbol.for("react.element"), l = Symbol.for("react.fragment"), m = Object.prototype.hasOwnProperty, n = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, p = {
        key: true,
        ref: true,
        __self: true,
        __source: true
    };
    function q(c, a, g) {
        var b, d = {}, e = null, h = null;
        void 0 !== g && (e = "" + g);
        void 0 !== a.key && (e = "" + a.key);
        void 0 !== a.ref && (h = a.ref);
        for(b in a)m.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
        if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
        return {
            $$typeof: k,
            type: c,
            key: e,
            ref: h,
            props: d,
            _owner: n.current
        };
    }
    (0, $cd2f896d748da4bc$export$362abb7de8d8bb41).Fragment = l;
    (0, $cd2f896d748da4bc$export$362abb7de8d8bb41).jsx = q;
    (0, $cd2f896d748da4bc$export$362abb7de8d8bb41).jsxs = q;
    return 0, $cd2f896d748da4bc$export$362abb7de8d8bb41;
}


var $fd0623da7a5da0b2$export$362abb7de8d8bb41 = {};


parcelRequire("cQQee");
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $5de583964432560c$var$hasRequiredReactJsxRuntime_development;
function $5de583964432560c$export$b88c30a9414655a0() {
    if ($5de583964432560c$var$hasRequiredReactJsxRuntime_development) return 0, $fd0623da7a5da0b2$export$362abb7de8d8bb41;
    $5de583964432560c$var$hasRequiredReactJsxRuntime_development = 1;
    return 0, $fd0623da7a5da0b2$export$362abb7de8d8bb41;
}


(0, $bf9b8d1577f662f3$export$5edeffb658f039f4).exports = (0, $77b4ffeb2a02b0a1$export$b88c30a9414655a0)();
var $81ee76508714b94a$export$35e795649ee09318 = (0, $bf9b8d1577f662f3$export$5edeffb658f039f4).exports;



var $cQQee = parcelRequire("cQQee");
function $4df8c7bf7afa5170$export$2e2bcd8739ae039(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === 'undefined') return;
    var head = document.head || document.getElementsByTagName('head')[0];
    var style = document.createElement('style');
    style.type = 'text/css';
    if (insertAt === 'top') {
        if (head.firstChild) head.insertBefore(style, head.firstChild);
        else head.appendChild(style);
    } else head.appendChild(style);
    if (style.styleSheet) style.styleSheet.cssText = css;
    else style.appendChild(document.createTextNode(css));
}


var $fd4af592836a3392$var$css_248z = ".aHai8lLLx48-{align-items:center;background:rgb(var(--ng-neutral-0));border-bottom:1px solid rgb(var(--ng-neutral-30));border-radius:var(--ng-rd-8);-moz-column-gap:var(--ng-gp-8);column-gap:var(--ng-gp-8);display:grid;grid-template-columns:1fr auto 1fr;overflow:hidden;padding:var(--ng-gp-12)}._7QZ1OG0R-8w-,.jx1rd7EVmBE-,.oWGoUTR9wn4-{align-items:center;display:flex;gap:var(--ng-gp-8);overflow:auto;width:100%}.oWGoUTR9wn4-{justify-content:start;min-width:0}.jx1rd7EVmBE-{justify-content:center;min-width:0}._7QZ1OG0R-8w->:first-child{margin-left:auto}._6agqwYNgSjE-{color:rgb(var(--ng-neutral-90));font-size:var(--ng-h-5-sb);font-weight:600;line-height:1.4;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}._2SupB5fsbKI-{align-items:center;display:inline-flex}.pAlYKkmI234-{align-items:center;background:rgb(var(--ng-neutral-0));border:1px solid rgb(var(--ng-neutral-30));border-radius:var(--ng-rd-8);display:flex;gap:var(--ng-gp-8);padding:var(--ng-gp-6) var(--ng-gp-12)}.xE2yRMNaEkc-{display:inline-flex}.ct7ufFXpAFY-,.xE2yRMNaEkc-{color:rgb(var(--ng-neutral-80))}.FhNlAV-Symw-,.XrvduYVs0WE-{fill:currentColor}.FhNlAV-Symw-{height:var(--ng-s-20);width:var(--ng-s-20)}";
var $fd4af592836a3392$export$2e2bcd8739ae039 = {
    "form_header_main": "aHai8lLLx48-",
    "form_header_left": "oWGoUTR9wn4-",
    "form_header_center": "jx1rd7EVmBE-",
    "form_header_right": "_7QZ1OG0R-8w-",
    "form_header_title": "_6agqwYNgSjE-",
    "form_header_tabs": "_2SupB5fsbKI-",
    "form_header_preview_frame": "pAlYKkmI234-",
    "form_header_preview_icon": "xE2yRMNaEkc-",
    "form_header_preview_label": "ct7ufFXpAFY-",
    "combo_dropdown_trigger_icon": "XrvduYVs0WE-"
};
(0, $4df8c7bf7afa5170$export$2e2bcd8739ae039)($fd4af592836a3392$var$css_248z);


var $f1c8443d9545a1c1$export$14faa19a0f3bbeb2;
(function(Theme) {
    Theme["Dark"] = "dark";
    Theme["Light"] = "light";
})($f1c8443d9545a1c1$export$14faa19a0f3bbeb2 || ($f1c8443d9545a1c1$export$14faa19a0f3bbeb2 = {}));
var $f1c8443d9545a1c1$export$cf8dec8cfeb9cb3;
(function(AvailableTheme) {
    AvailableTheme["Dark"] = "DARK";
    AvailableTheme["Default"] = "DEFAULT";
    AvailableTheme["HighContrast"] = "HIGH_CONTRAST";
})($f1c8443d9545a1c1$export$cf8dec8cfeb9cb3 || ($f1c8443d9545a1c1$export$cf8dec8cfeb9cb3 = {}));
var $f1c8443d9545a1c1$export$8eda7e02f8f033b2;
(function(EntityType) {
    EntityType["Lead"] = "lead";
    EntityType["Opportunity"] = "opportunity";
    EntityType["Account"] = "account";
    EntityType["Activity"] = "activity";
    EntityType["Task"] = "task";
    EntityType["AccountActivity"] = "account-activity";
    EntityType["Lists"] = "lists";
    EntityType["Ticket"] = "ticket";
})($f1c8443d9545a1c1$export$8eda7e02f8f033b2 || ($f1c8443d9545a1c1$export$8eda7e02f8f033b2 = {}));
var $f1c8443d9545a1c1$export$45c69700ee30a78c;
(function(DataType) {
    DataType["Text"] = "Text";
    DataType["Email"] = "Email";
    DataType["Phone"] = "Phone";
    DataType["Website"] = "Website";
    DataType["Url"] = "Url";
    DataType["IP"] = "IP";
    DataType["Select"] = "Select";
    DataType["Time"] = "Time";
    DataType["Boolean"] = "Boolean";
    DataType["TimeZone"] = "TimeZone";
    DataType["Country"] = "Country";
    DataType["MultiSelect"] = "MultiSelect";
    DataType["Number"] = "Number";
    DataType["DateTime"] = "DateTime";
    DataType["SearchableDropdown"] = "SearchableDropdown";
    DataType["LargeOptionSet"] = "LargeOptionSet";
    DataType["Dropdown"] = "Dropdown";
    DataType["ActiveUsers"] = "ActiveUsers";
    DataType['ActivityEvent_Note'] = "ActivityEvent_Note";
    DataType["Product"] = "Product";
    DataType["CustomObject"] = "CustomObject";
    DataType["String"] = "String";
    DataType["File"] = "File";
    DataType["Title"] = "Title";
    DataType["Form"] = "Form";
    DataType["Process"] = "Process";
    DataType["Lead"] = "Lead";
    DataType["Date"] = "Date";
    DataType["MediaLink"] = "MediaLink";
    DataType["GeoLocation"] = "GeoLocation";
    DataType["Audio"] = "Audio";
    DataType["DueDate"] = "DueDate";
    DataType["CustomObjectFieldString"] = "CustomObjectField-String";
})($f1c8443d9545a1c1$export$45c69700ee30a78c || ($f1c8443d9545a1c1$export$45c69700ee30a78c = {}));
var $f1c8443d9545a1c1$export$64ed4f32859160d1;
(function(AccessType) {
    AccessType["PartialAccess"] = "PartialAccess";
    AccessType["NoAccess"] = "NoAccess";
    AccessType["FullAccess"] = "FullAccess";
})($f1c8443d9545a1c1$export$64ed4f32859160d1 || ($f1c8443d9545a1c1$export$64ed4f32859160d1 = {}));
var $f1c8443d9545a1c1$export$f074ac291ab7c14e;
(function(RowHeightType) {
    RowHeightType["Sm"] = "sm";
    RowHeightType["Default"] = "default";
    RowHeightType["Lg"] = "lg";
    RowHeightType["Xl"] = "xl";
})($f1c8443d9545a1c1$export$f074ac291ab7c14e || ($f1c8443d9545a1c1$export$f074ac291ab7c14e = {}));


const $e99e5f020fa3ffc8$export$e772c8ff12451969 = async (timeout)=>new Promise((r)=>setTimeout(r, timeout));
function $e99e5f020fa3ffc8$export$2e2bcd8739ae039(...inputRefs) {
    const filteredInputRefs = inputRefs.filter(Boolean);
    return function mergedRefs(ref) {
        for (const inputRef of filteredInputRefs)if (inputRef) inputRef.current = ref;
    };
}
const $e99e5f020fa3ffc8$export$41e2e80e2d68907a = (currentTheme)=>{
    return currentTheme === (0, $f1c8443d9545a1c1$export$cf8dec8cfeb9cb3).Dark;
};
const $e99e5f020fa3ffc8$export$1343a74baacb0543 = (...classes)=>{
    return classes?.filter((className)=>className)?.join(' ');
};
const $e99e5f020fa3ffc8$export$61fc7d43ac8f84b0 = (callback, delay = 200)=>{
    let timeoutId;
    return async (...args)=>{
        return new Promise((resolve, reject)=>{
            if (timeoutId) clearTimeout(timeoutId);
            timeoutId = setTimeout(async ()=>{
                try {
                    const result = await callback(...args);
                    resolve(result);
                } catch (error) {
                    reject(error instanceof Error ? error : new Error(String(error)));
                }
            }, delay);
        });
    };
};
const $e99e5f020fa3ffc8$export$b6d465111d914331 = (pathName)=>pathName.replace(/\/$/, '');





var $011955f17211bc58$var$css_248z = ".moD6L-dYZqU-{align-items:center;background:none;border:none;cursor:pointer;display:inline-flex;justify-content:center}.kFT7J8PLQ-g-{display:flex;max-width:135px;min-width:0;overflow:hidden;position:relative;text-overflow:ellipsis;white-space:nowrap}.kFT7J8PLQ-g->div>div{height:16px!important;width:16px!important}.jAX1HNmQsds-{align-items:center;display:flex;justify-content:center;margin-inline-start:var(--ng-gp-8)}:where(.NnWL00I-zes-){-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;border:0;color:inherit;cursor:pointer;font:inherit;letter-spacing:inherit;margin:0;padding:0;text-align:inherit}:where(.NnWL00I-zes-:disabled){cursor:default}.zW9M-1z1XH4-{display:block}.bl5iHuvKWXQ-{display:inline}.azC-jMvqTNY-{display:flex}.LW6p6-NRj80-{display:inline-flex}.h04Mid2U-2w-{width:100%}.tiUzDc9S2FM-{gap:var(--ng-gp-8);height:24px;min-width:60px;padding:var(--ng-gp-4) var(--ng-gp-8)}.YQGJ-JCXCXI-,.tiUzDc9S2FM-{border-radius:var(--ng-rd-6)}.YQGJ-JCXCXI-{gap:var(--ng-gp-4);height:28px;min-width:92px;padding:var(--ng-gp-4) var(--ng-gp-12)}.-CQ0c-FoBAE-{border-radius:var(--ng-rd-8);gap:var(--ng-gp-4);height:32px;padding:var(--ng-gp-8) var(--ng-gp-12)}.aW0CzdL1L0A-{height:36px;padding:var(--ng-gp-8) var(--ng-gp-16)}.LvnKI8p9vFk-,.aW0CzdL1L0A-{border-radius:var(--ng-rd-8);gap:var(--ng-gp-8)}.LvnKI8p9vFk-{height:44px;padding:var(--ng-gp-12) var(--ng-gp-16)}.yWDRaCQfQ40-{height:24px;width:24px}.kqiJwBzBCkE-,.yWDRaCQfQ40-{border-radius:var(--ng-rd-6);padding:var(--ng-gp-4)}.kqiJwBzBCkE-{height:28px;width:28px}.LeYm-KrEXD0-{height:32px;width:32px}.LeYm-KrEXD0-,._24ZlE7NH2Xg-{border-radius:var(--ng-rd-8);padding:var(--ng-gp-8)}._24ZlE7NH2Xg-{height:36px;width:36px}.alCGZoA4uoM-{border-radius:var(--ng-rd-8);height:44px;padding:var(--ng-gp-12);width:44px}.p1f8OkPeT4g-{background:rgb(var(--ng-primary-30));border:1px solid rgb(var(--ng-primary-30));color:rgb(var(--ng-neutral-white))}.p1f8OkPeT4g-:hover{background:rgb(var(--ng-primary-40));border:1px solid rgb(var(--ng-primary-40))}.p1f8OkPeT4g-:focus{background:rgb(var(--ng-primary-30));border:1px solid rgb(var(--ng-primary-30))}.p1f8OkPeT4g-:disabled{background:rgb(var(--ng-neutral-10));border:1px solid rgb(var(--ng-neutral-20));color:rgb(var(--ng-neutral-50));cursor:not-allowed}.PGldQssaLjs-{background:rgb(var(--ng-error-60));border:1px solid rgb(var(--ng-error-60));color:rgb(var(--ng-neutral-white))}.PGldQssaLjs-:hover{background:rgb(var(--ng-error-70));border:1px solid rgb(var(--ng-error-70))}.PGldQssaLjs-:focus{background:rgb(var(--ng-error-60));border:1px solid rgb(var(--ng-error-60))}.PGldQssaLjs-:disabled{background:rgb(var(--ng-neutral-10));border:1px solid rgb(var(--ng-neutral-20));color:rgb(var(--ng-neutral-50));cursor:not-allowed}.WQ2iBzf1-zQ-{background:rgb(var(--ng-neutral-0));border:1px solid rgb(var(--ng-neutral-30));color:rgb(var(--ng-neutral-80))}.WQ2iBzf1-zQ- svg,.WQ2iBzf1-zQ- svg path{fill:rgb(var(--ng-neutral-80))}.WQ2iBzf1-zQ-:hover{background:rgb(var(--ng-neutral-10))}.WQ2iBzf1-zQ-:focus,.WQ2iBzf1-zQ-:hover{border:1px solid rgb(var(--ng-neutral-30))}.WQ2iBzf1-zQ-:focus{background:rgb(var(--ng-neutral-20))}.WQ2iBzf1-zQ-:disabled{background:rgb(var(--ng-neutral-0));border:1px solid rgb(var(--ng-neutral-30));color:rgb(var(--ng-neutral-50));cursor:not-allowed}.WQ2iBzf1-zQ-:disabled svg,.WQ2iBzf1-zQ-:disabled svg path{fill:rgb(var(--ng-neutral-50))}.dKaAMY9fHtw-{background:rgb(var(--ng-error-0));color:rgb(var(--ng-error-60))}.dKaAMY9fHtw-:hover{background:rgb(var(--ng-error-10))}.dKaAMY9fHtw-:focus{background:rgb(var(--ng-error-0));color:rgb(var(--ng-error-60))}.dKaAMY9fHtw-:disabled{background:rgb(var(--ng-neutral-0));color:rgb(var(--ng-neutral-50));cursor:not-allowed}.YfCCIvyDK-Y-{background:rgb(var(--ng-neutral-0));border:1px solid rgb(var(--ng-secondary-content-icon));color:rgb(var(--ng-secondary-content-icon))}.YfCCIvyDK-Y-:hover{background:rgb(var(--ng-secondary-0));border:1px solid rgb(var(--ng-secondary-20))}.YfCCIvyDK-Y-:focus{background:rgb(var(--ng-neutral-0));border:1px solid rgb(var(--ng-secondary-10))}.YfCCIvyDK-Y-:disabled{background:rgb(var(--ng-neutral-0));border:1px solid rgb(var(--ng-neutral-20));color:rgb(var(--ng-neutral-50));cursor:not-allowed}.m-oPpxvZFYQ-{color:rgb(var(--ng-neutral-80))}.m-oPpxvZFYQ- svg,.m-oPpxvZFYQ- svg path{fill:rgb(var(--ng-neutral-80))}.m-oPpxvZFYQ-:hover{background:rgb(var(--ng-neutral-10))}.m-oPpxvZFYQ-._0fhQzOU18OM-,.m-oPpxvZFYQ-:focus{background:rgb(var(--ng-neutral-20))}.m-oPpxvZFYQ-:disabled{background:rgb(var(--ng-neutral-0));color:rgb(var(--ng-neutral-50));cursor:not-allowed}.m-oPpxvZFYQ-:disabled svg,.m-oPpxvZFYQ-:disabled svg path{fill:rgb(var(--ng-neutral-50))}.pkTjNsyr6-s-{color:rgb(var(--ng-error-60))}.pkTjNsyr6-s-:hover{background:rgb(var(--ng-error-10))}.pkTjNsyr6-s-:focus{color:rgb(var(--ng-error-60))}.pkTjNsyr6-s-:disabled{background:rgb(var(--ng-neutral-0));color:rgb(var(--ng-neutral-50));cursor:not-allowed}.Y0M6w5-1KUE-{background:rgb(var(--ng-secondary-0));color:rgb(var(--ng-secondary-content-icon))}.Y0M6w5-1KUE-:focus,.Y0M6w5-1KUE-:hover{background:rgb(var(--ng-secondary-10))}.Y0M6w5-1KUE-:disabled{background:rgb(var(--ng-neutral-0));color:rgb(var(--ng-neutral-50));cursor:not-allowed}.fBZQMDP46nI-{background:none;border:none;color:rgb(var(--ng-secondary-30))}.fBZQMDP46nI-:hover{color:rgb(var(--ng-secondary-40));text-decoration:underline}.fBZQMDP46nI-:focus{color:rgb(var(--ng-secondary-50));text-decoration:underline}.fBZQMDP46nI-:disabled{color:rgb(var(--ng-neutral-50));cursor:not-allowed}.doYfHXWOI2U-{background:none;border:none;color:rgb(var(--ng-error-60))}.doYfHXWOI2U-:hover{color:rgb(var(--ng-error-70));text-decoration:underline}.doYfHXWOI2U-:focus{color:rgb(var(--ng-error-50));text-decoration:underline}.doYfHXWOI2U-:disabled{color:rgb(var(--ng-neutral-50));cursor:not-allowed}";
var $011955f17211bc58$export$2e2bcd8739ae039 = {
    "button_base": "moD6L-dYZqU-",
    "text_wrapper": "kFT7J8PLQ-g-",
    "loading_spinner": "jAX1HNmQsds-",
    "button_unstyled": "NnWL00I-zes-",
    "unstyled_layout_block": "zW9M-1z1XH4-",
    "unstyled_layout_inline": "bl5iHuvKWXQ-",
    "unstyled_layout_flex": "azC-jMvqTNY-",
    "unstyled_layout_inline_flex": "LW6p6-NRj80-",
    "unstyled_stretch": "h04Mid2U-2w-",
    "button_size_xs": "tiUzDc9S2FM-",
    "button_size_sm": "YQGJ-JCXCXI-",
    "button_size_md": "-CQ0c-FoBAE-",
    "button_size_lg": "aW0CzdL1L0A-",
    "button_size_xl": "LvnKI8p9vFk-",
    "icon_button_size_xs": "yWDRaCQfQ40-",
    "icon_button_size_sm": "kqiJwBzBCkE-",
    "icon_button_size_md": "LeYm-KrEXD0-",
    "icon_button_size_lg": "_24ZlE7NH2Xg-",
    "icon_button_size_xl": "alCGZoA4uoM-",
    "button_hierarchy_primary": "p1f8OkPeT4g-",
    "button_hierarchy_primary_error": "PGldQssaLjs-",
    "button_hierarchy_secondary_gray": "WQ2iBzf1-zQ-",
    "button_hierarchy_secondary_error": "dKaAMY9fHtw-",
    "button_hierarchy_secondary_color": "YfCCIvyDK-Y-",
    "button_hierarchy_tertiary_gray": "m-oPpxvZFYQ-",
    "focused": "_0fhQzOU18OM-",
    "button_hierarchy_tertiary_error": "pkTjNsyr6-s-",
    "button_hierarchy_tertiary_color": "Y0M6w5-1KUE-",
    "button_hierarchy_link_text": "fBZQMDP46nI-",
    "button_hierarchy_link_text_error": "doYfHXWOI2U-"
};
(0, $4df8c7bf7afa5170$export$2e2bcd8739ae039)($011955f17211bc58$var$css_248z);




var $6172a18e08af7908$var$css_248z = ".I2N6LjT0LhU-{display:flex}.RaHsUQp6y7c-{border-bottom-right-radius:0;border-top-right-radius:0}.RaHsUQp6y7c-.Q13Tnv6pOgo-{pointer-events:none}.dyg9u4hqYBM-{border-bottom-left-radius:0;border-top-left-radius:0}._34hsitSZA-Q-{align-self:stretch;width:1px}.I2N6LjT0LhU-.cybLSP9JBlk- ._34hsitSZA-Q-{background:rgb(var(--ng-primary-600))}.I2N6LjT0LhU-._975uGw7jO90- ._34hsitSZA-Q-{display:none}.I2N6LjT0LhU-._975uGw7jO90- .dyg9u4hqYBM-{border-left:none}.I2N6LjT0LhU-.GRMu98Pf6sM- ._34hsitSZA-Q-{display:none}.I2N6LjT0LhU-.GRMu98Pf6sM- .dyg9u4hqYBM-{border-left:none}.I2N6LjT0LhU-.lDy3YfVcing- ._34hsitSZA-Q-{background:rgb(var(--ng-neutral-30))}.I2N6LjT0LhU-.BJt-UVzM9-s- ._34hsitSZA-Q-,.I2N6LjT0LhU-.ax1XCQ2R1L8- ._34hsitSZA-Q-{background:rgb(var(--ng-secondary-10))}.I2N6LjT0LhU-._4hphyvrcjlY- ._34hsitSZA-Q-{background:rgb(var(--ng-error-600))}.I2N6LjT0LhU-._7oJH7mAubOM- ._34hsitSZA-Q-,.I2N6LjT0LhU-.sOLv18tcfzg- ._34hsitSZA-Q-{background:rgb(var(--ng-error-20))}.I2N6LjT0LhU-.T0GWPY50054- ._34hsitSZA-Q-{background:transparent}";
var $6172a18e08af7908$export$2e2bcd8739ae039 = {
    "combo_button_wrapper": "I2N6LjT0LhU-",
    "combo_button_main": "RaHsUQp6y7c-",
    "combo_button_main_disabled": "Q13Tnv6pOgo-",
    "combo_button_icon": "dyg9u4hqYBM-",
    "separator": "_34hsitSZA-Q-",
    "primary": "cybLSP9JBlk-",
    "secondary_gray": "_975uGw7jO90-",
    "secondary": "GRMu98Pf6sM-",
    "tertiary_gray": "lDy3YfVcing-",
    "tertiary": "BJt-UVzM9-s-",
    "link": "ax1XCQ2R1L8-",
    "primary_error": "_4hphyvrcjlY-",
    "secondary_error": "sOLv18tcfzg-",
    "tertiary_error": "_7oJH7mAubOM-",
    "link_error": "T0GWPY50054-"
};
(0, $4df8c7bf7afa5170$export$2e2bcd8739ae039)($6172a18e08af7908$var$css_248z);


const $bb5cb732fec4bdcf$export$fa9867bfbde55a2 = {
    [`button-xs`]: `${(0, $011955f17211bc58$export$2e2bcd8739ae039).button_size_xs} ng_p_1_sb`,
    [`button-sm`]: `${(0, $011955f17211bc58$export$2e2bcd8739ae039).button_size_sm} ng_btn_2_sb`,
    [`button-md`]: `${(0, $011955f17211bc58$export$2e2bcd8739ae039).button_size_md} ng_btn_2_b`,
    [`button-lg`]: `${(0, $011955f17211bc58$export$2e2bcd8739ae039).button_size_lg} ng_btn_1_sb`,
    [`button-xl`]: `${(0, $011955f17211bc58$export$2e2bcd8739ae039).button_size_xl} ng_btn_1_sb`,
    [`icon-xs`]: `${(0, $011955f17211bc58$export$2e2bcd8739ae039).icon_button_size_xs} ng_btn_1_r`,
    [`icon-sm`]: `${(0, $011955f17211bc58$export$2e2bcd8739ae039).icon_button_size_sm} ng_h_3_r`,
    [`icon-md`]: `${(0, $011955f17211bc58$export$2e2bcd8739ae039).icon_button_size_md} ng_h_3_r`,
    [`icon-lg`]: `${(0, $011955f17211bc58$export$2e2bcd8739ae039).icon_button_size_lg} ng_h_3_r`,
    [`icon-xl`]: `${(0, $011955f17211bc58$export$2e2bcd8739ae039).icon_button_size_xl} ng_h_3_r`
};
const $bb5cb732fec4bdcf$export$6db14c04340daea = {
    ['block']: (0, $011955f17211bc58$export$2e2bcd8739ae039).unstyled_layout_block,
    ['inline']: (0, $011955f17211bc58$export$2e2bcd8739ae039).unstyled_layout_inline,
    ['flex']: (0, $011955f17211bc58$export$2e2bcd8739ae039).unstyled_layout_flex,
    ['inline-flex']: (0, $011955f17211bc58$export$2e2bcd8739ae039).unstyled_layout_inline_flex
};
const $bb5cb732fec4bdcf$export$ada48a0f901b7bfd = {
    ['link']: (0, $011955f17211bc58$export$2e2bcd8739ae039).button_hierarchy_link_text,
    ['link-error']: (0, $011955f17211bc58$export$2e2bcd8739ae039).button_hierarchy_link_text_error,
    ['primary']: (0, $011955f17211bc58$export$2e2bcd8739ae039).button_hierarchy_primary,
    ['primary-error']: (0, $011955f17211bc58$export$2e2bcd8739ae039).button_hierarchy_primary_error,
    ['secondary']: (0, $011955f17211bc58$export$2e2bcd8739ae039).button_hierarchy_secondary_color,
    ['secondary-error']: (0, $011955f17211bc58$export$2e2bcd8739ae039).button_hierarchy_secondary_error,
    ['secondary-gray']: (0, $011955f17211bc58$export$2e2bcd8739ae039).button_hierarchy_secondary_gray,
    ['tertiary']: (0, $011955f17211bc58$export$2e2bcd8739ae039).button_hierarchy_tertiary_color,
    ['tertiary-error']: (0, $011955f17211bc58$export$2e2bcd8739ae039).button_hierarchy_tertiary_error,
    ['tertiary-gray']: (0, $011955f17211bc58$export$2e2bcd8739ae039).button_hierarchy_tertiary_gray
};
const $bb5cb732fec4bdcf$export$1673bc02d763f04a = {
    ['primary']: (0, $6172a18e08af7908$export$2e2bcd8739ae039).primary,
    ['secondary-gray']: (0, $6172a18e08af7908$export$2e2bcd8739ae039).secondary_gray,
    ['secondary']: (0, $6172a18e08af7908$export$2e2bcd8739ae039).secondary,
    ['tertiary-gray']: (0, $6172a18e08af7908$export$2e2bcd8739ae039).tertiary_gray,
    ['tertiary']: (0, $6172a18e08af7908$export$2e2bcd8739ae039).tertiary,
    ['link']: (0, $6172a18e08af7908$export$2e2bcd8739ae039).link,
    ['primary-error']: (0, $6172a18e08af7908$export$2e2bcd8739ae039).primary_error,
    ['secondary-error']: (0, $6172a18e08af7908$export$2e2bcd8739ae039).secondary_error,
    ['tertiary-error']: (0, $6172a18e08af7908$export$2e2bcd8739ae039).tertiary_error,
    ['link-error']: (0, $6172a18e08af7908$export$2e2bcd8739ae039).link_error
};




var $8d95b4d01ee7c674$var$css_248z = ".ePtdJqaUsMs-{animation:Wg35o9OcGTo- 1s linear infinite;border:2.5px solid #006fd6;border-left-color:rgba(0,0,0,.1);border-radius:50%;box-sizing:border-box;display:inline-block}.ePtdJqaUsMs-.Ln6Po2u8eUI-{border-width:4px;height:32px;width:32px}.ePtdJqaUsMs-.ifuphTzZOWo-{border-width:3px;height:24px;width:24px}.ePtdJqaUsMs-.GHRzFJRC5c8-{border-width:2px;height:12px;width:12px}.ePtdJqaUsMs-.ZIHVtgbArls-{height:16px;width:16px}@keyframes Wg35o9OcGTo-{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}";
var $8d95b4d01ee7c674$export$2e2bcd8739ae039 = {
    "spinner_container": "ePtdJqaUsMs-",
    "lg": "Ln6Po2u8eUI-",
    "md": "ifuphTzZOWo-",
    "sm": "GHRzFJRC5c8-",
    "default": "ZIHVtgbArls-"
};
(0, $4df8c7bf7afa5170$export$2e2bcd8739ae039)($8d95b4d01ee7c674$var$css_248z);


var $e2b1504937c35bc1$export$11e6017846e949;
(function(SpinnerSize) {
    SpinnerSize["SM"] = "sm";
    SpinnerSize["MD"] = "md";
    SpinnerSize["LG"] = "lg";
    SpinnerSize["DEFAULT"] = "Default";
})($e2b1504937c35bc1$export$11e6017846e949 || ($e2b1504937c35bc1$export$11e6017846e949 = {}));


const $412609df5def4b81$var$getSpinnerSizeClassName = (spinnerSize)=>{
    switch(spinnerSize){
        case (0, $e2b1504937c35bc1$export$11e6017846e949).LG:
            return (0, $8d95b4d01ee7c674$export$2e2bcd8739ae039).lg;
        case (0, $e2b1504937c35bc1$export$11e6017846e949).SM:
            return (0, $8d95b4d01ee7c674$export$2e2bcd8739ae039).sm;
        case (0, $e2b1504937c35bc1$export$11e6017846e949).MD:
            return (0, $8d95b4d01ee7c674$export$2e2bcd8739ae039).md;
        default:
            return (0, $8d95b4d01ee7c674$export$2e2bcd8739ae039).default;
    }
};
const $412609df5def4b81$export$2e2bcd8739ae039 = (props)=>{
    const { customStyleClass: customStyleClass = '', size: size = (0, $e2b1504937c35bc1$export$11e6017846e949).DEFAULT, ariaLabel: ariaLabel = 'Loading' } = props;
    return (0, $81ee76508714b94a$export$35e795649ee09318).jsx("div", {
        className: `${customStyleClass} spinner-container`,
        role: "status",
        "aria-live": "polite",
        "aria-label": ariaLabel,
        children: (0, $81ee76508714b94a$export$35e795649ee09318).jsx("div", {
            className: `${(0, $8d95b4d01ee7c674$export$2e2bcd8739ae039).spinner_container} ${$412609df5def4b81$var$getSpinnerSizeClassName(size)} spinner`,
            "data-testid": "spinner",
            "aria-hidden": "true"
        })
    });
};



const $992ecf6e5fba59bc$var$getUnstyledClassName = ({ layout: layout, stretch: stretch, customStyleClass: customStyleClass })=>{
    return (0, $e99e5f020fa3ffc8$export$1343a74baacb0543)((0, $011955f17211bc58$export$2e2bcd8739ae039).button_unstyled, layout ? (0, $bb5cb732fec4bdcf$export$6db14c04340daea)[layout] : '', stretch ? (0, $011955f17211bc58$export$2e2bcd8739ae039).unstyled_stretch : '', customStyleClass ?? '');
};
const $992ecf6e5fba59bc$export$2e2bcd8739ae039 = ({ text: text, onClick: onClick, variant: variant = 'secondary-gray', size: size = 'md', icon: icon, customStyleClass: customStyleClass, dataTestId: dataTestId, rightIcon: rightIcon, isLoading: isLoading, buttonType: buttonType, state: state = 'default', layout: layout, stretch: stretch, children: children, ...props })=>{
    const isUnstyled = buttonType === 'unstyled';
    const getClassName = ()=>{
        if (isUnstyled) return $992ecf6e5fba59bc$var$getUnstyledClassName({
            layout: layout,
            stretch: stretch,
            customStyleClass: customStyleClass
        });
        return [
            (0, $011955f17211bc58$export$2e2bcd8739ae039).button_base,
            (0, $bb5cb732fec4bdcf$export$ada48a0f901b7bfd)?.[variant],
            (0, $bb5cb732fec4bdcf$export$fa9867bfbde55a2)?.[`${buttonType}-${size}`],
            customStyleClass,
            'marvin_btn',
            state === 'focused' ? (0, $011955f17211bc58$export$2e2bcd8739ae039).focused : ''
        ].join(' ');
    };
    const getButtonText = ()=>{
        if (text) {
            const textClass = (0, $e99e5f020fa3ffc8$export$1343a74baacb0543)((0, $011955f17211bc58$export$2e2bcd8739ae039).text_wrapper, 'button_text', 'ng_v2_style');
            return (0, $81ee76508714b94a$export$35e795649ee09318).jsxs("div", {
                className: textClass,
                title: props.title,
                children: [
                    text,
                    isLoading ? (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $412609df5def4b81$export$2e2bcd8739ae039), {
                        customStyleClass: (0, $011955f17211bc58$export$2e2bcd8739ae039).loading_spinner
                    }) : null
                ]
            });
        }
        return null;
    };
    return (0, $81ee76508714b94a$export$35e795649ee09318).jsx("button", {
        type: "button",
        onClick: async (event)=>{
            await onClick(event);
        },
        className: getClassName(),
        "data-testid": dataTestId,
        "aria-label": isUnstyled ? undefined : props.title ?? text,
        ...props,
        children: isUnstyled ? children : (0, $81ee76508714b94a$export$35e795649ee09318).jsxs((0, $81ee76508714b94a$export$35e795649ee09318).Fragment, {
            children: [
                icon,
                getButtonText(),
                rightIcon
            ]
        })
    });
};
$992ecf6e5fba59bc$export$2e2bcd8739ae039.defaultProps = {
    text: undefined,
    icon: undefined,
    customStyleClass: '',
    dataTestId: '',
    rightIcon: (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $81ee76508714b94a$export$35e795649ee09318).Fragment, {}),
    isLoading: false,
    state: 'default',
    layout: undefined,
    stretch: false
};


const $dbb74cb604a2ffe4$export$2e2bcd8739ae039 = (props)=>{
    return (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $992ecf6e5fba59bc$export$2e2bcd8739ae039), {
        ...props,
        buttonType: 'icon'
    });
};




const $93eff1b09ae4008c$export$2e2bcd8739ae039 = ({ type: type = 'button', ...props })=>{
    return (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $992ecf6e5fba59bc$export$2e2bcd8739ae039), {
        ...props,
        buttonType: type
    });
};




var $cQQee = parcelRequire("cQQee");






var $cQQee = parcelRequire("cQQee");
// packages/core/primitive/src/primitive.tsx
function $a6afd3c22f4adf72$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented: checkForDefaultPrevented = true } = {}) {
    return function handleEvent(event) {
        originalEventHandler?.(event);
        if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler?.(event);
    };
}



var $cQQee = parcelRequire("cQQee");
// packages/react/compose-refs/src/compose-refs.tsx
function $5565e7805f78287d$var$setRef(ref, value) {
    if (typeof ref === "function") return ref(value);
    else if (ref !== null && ref !== void 0) ref.current = value;
}
function $5565e7805f78287d$export$43e446d32b3d21af(...refs) {
    return (node)=>{
        let hasCleanup = false;
        const cleanups = refs.map((ref)=>{
            const cleanup = $5565e7805f78287d$var$setRef(ref, node);
            if (!hasCleanup && typeof cleanup == "function") hasCleanup = true;
            return cleanup;
        });
        if (hasCleanup) return ()=>{
            for(let i = 0; i < cleanups.length; i++){
                const cleanup = cleanups[i];
                if (typeof cleanup == "function") cleanup();
                else $5565e7805f78287d$var$setRef(refs[i], null);
            }
        };
    };
}
function $5565e7805f78287d$export$c7b2cbe3552a0d05(...refs) {
    return $cQQee.useCallback($5565e7805f78287d$export$43e446d32b3d21af(...refs), refs);
}



var $cQQee = parcelRequire("cQQee");

// packages/react/context/src/create-context.tsx
function $f7850bc89e2b37d9$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    function createContext3(rootComponentName, defaultContext) {
        const BaseContext = $cQQee.createContext(defaultContext);
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        const Provider = (props)=>{
            const { scope: scope, children: children, ...context } = props;
            const Context = scope?.[scopeName]?.[index] || BaseContext;
            const value = $cQQee.useMemo(()=>context, Object.values(context));
            return /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx(Context.Provider, {
                value: value,
                children: children
            });
        };
        Provider.displayName = rootComponentName + "Provider";
        function useContext2(consumerName, scope) {
            const Context = scope?.[scopeName]?.[index] || BaseContext;
            const context = $cQQee.useContext(Context);
            if (context) return context;
            if (defaultContext !== void 0) return defaultContext;
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        return [
            Provider,
            useContext2
        ];
    }
    const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return $cQQee.createContext(defaultContext);
        });
        return function useScope(scope) {
            const contexts = scope?.[scopeName] || scopeContexts;
            return $cQQee.useMemo(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                }), [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        createContext3,
        $f7850bc89e2b37d9$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
function $f7850bc89e2b37d9$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope = ()=>{
        const scopeHooks = scopes.map((createScope2)=>({
                useScope: createScope2(),
                scopeName: createScope2.scopeName
            }));
        return function useComposedScopes(overrideScopes) {
            const nextScopes = scopeHooks.reduce((nextScopes2, { useScope: useScope, scopeName: scopeName })=>{
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes2,
                    ...currentScope
                };
            }, {});
            return $cQQee.useMemo(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes
                }), [
                nextScopes
            ]);
        };
    };
    createScope.scopeName = baseScope.scopeName;
    return createScope;
}



var $cQQee = parcelRequire("cQQee");

var $cQQee = parcelRequire("cQQee");
// packages/react/use-layout-effect/src/use-layout-effect.tsx
var $18ec559a74924a74$export$e5c5a5f917a5871c = globalThis?.document ? $cQQee.useLayoutEffect : ()=>{};


// src/use-controllable-state.tsx
var $5525618e90d8a4e3$var$useInsertionEffect = $cQQee[" useInsertionEffect ".trim().toString()] || (0, $18ec559a74924a74$export$e5c5a5f917a5871c);
function $5525618e90d8a4e3$export$6f32135080cb4c3({ prop: prop, defaultProp: defaultProp, onChange: onChange = ()=>{}, caller: caller }) {
    const [uncontrolledProp, setUncontrolledProp, onChangeRef] = $5525618e90d8a4e3$var$useUncontrolledState({
        defaultProp: defaultProp,
        onChange: onChange
    });
    const isControlled = prop !== void 0;
    const value = isControlled ? prop : uncontrolledProp;
    {
        const isControlledRef = $cQQee.useRef(prop !== void 0);
        $cQQee.useEffect(()=>{
            const wasControlled = isControlledRef.current;
            if (wasControlled !== isControlled) {
                const from = wasControlled ? "controlled" : "uncontrolled";
                const to = isControlled ? "controlled" : "uncontrolled";
                console.warn(`${caller} is changing from ${from} to ${to}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`);
            }
            isControlledRef.current = isControlled;
        }, [
            isControlled,
            caller
        ]);
    }
    const setValue = $cQQee.useCallback((nextValue)=>{
        if (isControlled) {
            const value2 = $5525618e90d8a4e3$var$isFunction(nextValue) ? nextValue(prop) : nextValue;
            if (value2 !== prop) onChangeRef.current?.(value2);
        } else setUncontrolledProp(nextValue);
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        onChangeRef
    ]);
    return [
        value,
        setValue
    ];
}
function $5525618e90d8a4e3$var$useUncontrolledState({ defaultProp: defaultProp, onChange: onChange }) {
    const [value, setValue] = $cQQee.useState(defaultProp);
    const prevValueRef = $cQQee.useRef(value);
    const onChangeRef = $cQQee.useRef(onChange);
    $5525618e90d8a4e3$var$useInsertionEffect(()=>{
        onChangeRef.current = onChange;
    }, [
        onChange
    ]);
    $cQQee.useEffect(()=>{
        if (prevValueRef.current !== value) {
            onChangeRef.current?.(value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef
    ]);
    return [
        value,
        setValue,
        onChangeRef
    ];
}
function $5525618e90d8a4e3$var$isFunction(value) {
    return typeof value === "function";
}



var $cQQee = parcelRequire("cQQee");

var $kC364 = parcelRequire("kC364");

var $cQQee = parcelRequire("cQQee");


// packages/react/slot/src/slot.tsx
// @__NO_SIDE_EFFECTS__
function $050d5aa66f6347e9$export$e88b45bda5c13eb9(ownerName) {
    const SlotClone = /* @__PURE__ */ $050d5aa66f6347e9$var$createSlotClone(ownerName);
    const Slot2 = $cQQee.forwardRef((props, forwardedRef)=>{
        const { children: children, ...slotProps } = props;
        const childrenArray = $cQQee.Children.toArray(children);
        const slottable = childrenArray.find($050d5aa66f6347e9$var$isSlottable);
        if (slottable) {
            const newElement = slottable.props.children;
            const newChildren = childrenArray.map((child)=>{
                if (child === slottable) {
                    if ($cQQee.Children.count(newElement) > 1) return $cQQee.Children.only(null);
                    return $cQQee.isValidElement(newElement) ? newElement.props.children : null;
                } else return child;
            });
            return /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx(SlotClone, {
                ...slotProps,
                ref: forwardedRef,
                children: $cQQee.isValidElement(newElement) ? $cQQee.cloneElement(newElement, void 0, newChildren) : null
            });
        }
        return /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx(SlotClone, {
            ...slotProps,
            ref: forwardedRef,
            children: children
        });
    });
    Slot2.displayName = `${ownerName}.Slot`;
    return Slot2;
}
// @__NO_SIDE_EFFECTS__
function $050d5aa66f6347e9$var$createSlotClone(ownerName) {
    const SlotClone = $cQQee.forwardRef((props, forwardedRef)=>{
        const { children: children, ...slotProps } = props;
        if ($cQQee.isValidElement(children)) {
            const childrenRef = $050d5aa66f6347e9$var$getElementRef(children);
            const props2 = $050d5aa66f6347e9$var$mergeProps(slotProps, children.props);
            if (children.type !== $cQQee.Fragment) props2.ref = forwardedRef ? (0, $5565e7805f78287d$export$43e446d32b3d21af)(forwardedRef, childrenRef) : childrenRef;
            return $cQQee.cloneElement(children, props2);
        }
        return $cQQee.Children.count(children) > 1 ? $cQQee.Children.only(null) : null;
    });
    SlotClone.displayName = `${ownerName}.SlotClone`;
    return SlotClone;
}
var $050d5aa66f6347e9$var$SLOTTABLE_IDENTIFIER = Symbol("radix.slottable");
// @__NO_SIDE_EFFECTS__
function $050d5aa66f6347e9$export$bf68c29d8281d0f7(ownerName) {
    const Slottable2 = ({ children: children })=>{
        return /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $81ee76508714b94a$export$35e795649ee09318).Fragment, {
            children: children
        });
    };
    Slottable2.displayName = `${ownerName}.Slottable`;
    Slottable2.__radixId = $050d5aa66f6347e9$var$SLOTTABLE_IDENTIFIER;
    return Slottable2;
}
function $050d5aa66f6347e9$var$isSlottable(child) {
    return $cQQee.isValidElement(child) && typeof child.type === "function" && "__radixId" in child.type && child.type.__radixId === $050d5aa66f6347e9$var$SLOTTABLE_IDENTIFIER;
}
function $050d5aa66f6347e9$var$mergeProps(slotProps, childProps) {
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            if (slotPropValue && childPropValue) overrideProps[propName] = (...args)=>{
                childPropValue(...args);
                slotPropValue(...args);
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === "style") overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === "className") overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(" ");
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
function $050d5aa66f6347e9$var$getElementRef(element) {
    let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}



// src/primitive.tsx
var $f679bf6067493560$var$NODES = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "select",
    "span",
    "svg",
    "ul"
];
var $f679bf6067493560$export$250ffa63cdc0d034 = $f679bf6067493560$var$NODES.reduce((primitive, node)=>{
    const Slot = (0, $050d5aa66f6347e9$export$e88b45bda5c13eb9)(`Primitive.${node}`);
    const Node = $cQQee.forwardRef((props, forwardedRef)=>{
        const { asChild: asChild, ...primitiveProps } = props;
        const Comp = asChild ? Slot : node;
        if (typeof window !== "undefined") window[Symbol.for("radix-ui")] = true;
        return /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx(Comp, {
            ...primitiveProps,
            ref: forwardedRef
        });
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
function $f679bf6067493560$export$6d1a0317bde7de7f(target, event) {
    if (target) $kC364.flushSync(()=>target.dispatchEvent(event));
}



var $cQQee = parcelRequire("cQQee");


var $cQQee = parcelRequire("cQQee");




function $731ecf065eed212e$export$c74125a8e3af6bb2(name) {
    const PROVIDER_NAME = name + "CollectionProvider";
    const [createCollectionContext, createCollectionScope] = (0, $f7850bc89e2b37d9$export$50c7b4e9d9f19c1)(PROVIDER_NAME);
    const [CollectionProviderImpl, useCollectionContext] = createCollectionContext(PROVIDER_NAME, {
        collectionRef: {
            current: null
        },
        itemMap: /* @__PURE__ */ new Map()
    });
    const CollectionProvider = (props)=>{
        const { scope: scope, children: children } = props;
        const ref = (0, (/*@__PURE__*/$parcel$interopDefault($cQQee))).useRef(null);
        const itemMap = (0, (/*@__PURE__*/$parcel$interopDefault($cQQee))).useRef(/* @__PURE__ */ new Map()).current;
        return /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx(CollectionProviderImpl, {
            scope: scope,
            itemMap: itemMap,
            collectionRef: ref,
            children: children
        });
    };
    CollectionProvider.displayName = PROVIDER_NAME;
    const COLLECTION_SLOT_NAME = name + "CollectionSlot";
    const CollectionSlotImpl = (0, $050d5aa66f6347e9$export$e88b45bda5c13eb9)(COLLECTION_SLOT_NAME);
    const CollectionSlot = (0, (/*@__PURE__*/$parcel$interopDefault($cQQee))).forwardRef((props, forwardedRef)=>{
        const { scope: scope, children: children } = props;
        const context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
        const composedRefs = (0, $5565e7805f78287d$export$c7b2cbe3552a0d05)(forwardedRef, context.collectionRef);
        return /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx(CollectionSlotImpl, {
            ref: composedRefs,
            children: children
        });
    });
    CollectionSlot.displayName = COLLECTION_SLOT_NAME;
    const ITEM_SLOT_NAME = name + "CollectionItemSlot";
    const ITEM_DATA_ATTR = "data-radix-collection-item";
    const CollectionItemSlotImpl = (0, $050d5aa66f6347e9$export$e88b45bda5c13eb9)(ITEM_SLOT_NAME);
    const CollectionItemSlot = (0, (/*@__PURE__*/$parcel$interopDefault($cQQee))).forwardRef((props, forwardedRef)=>{
        const { scope: scope, children: children, ...itemData } = props;
        const ref = (0, (/*@__PURE__*/$parcel$interopDefault($cQQee))).useRef(null);
        const composedRefs = (0, $5565e7805f78287d$export$c7b2cbe3552a0d05)(forwardedRef, ref);
        const context = useCollectionContext(ITEM_SLOT_NAME, scope);
        (0, (/*@__PURE__*/$parcel$interopDefault($cQQee))).useEffect(()=>{
            context.itemMap.set(ref, {
                ref: ref,
                ...itemData
            });
            return ()=>void context.itemMap.delete(ref);
        });
        return /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx(CollectionItemSlotImpl, {
            [ITEM_DATA_ATTR]: "",
            ref: composedRefs,
            children: children
        });
    });
    CollectionItemSlot.displayName = ITEM_SLOT_NAME;
    function useCollection(scope) {
        const context = useCollectionContext(name + "CollectionConsumer", scope);
        const getItems = (0, (/*@__PURE__*/$parcel$interopDefault($cQQee))).useCallback(()=>{
            const collectionNode = context.collectionRef.current;
            if (!collectionNode) return [];
            const orderedNodes = Array.from(collectionNode.querySelectorAll(`[${ITEM_DATA_ATTR}]`));
            const items = Array.from(context.itemMap.values());
            const orderedItems = items.sort((a, b)=>orderedNodes.indexOf(a.ref.current) - orderedNodes.indexOf(b.ref.current));
            return orderedItems;
        }, [
            context.collectionRef,
            context.itemMap
        ]);
        return getItems;
    }
    return [
        {
            Provider: CollectionProvider,
            Slot: CollectionSlot,
            ItemSlot: CollectionItemSlot
        },
        useCollection,
        createCollectionScope
    ];
}





var $cQQee = parcelRequire("cQQee");

// packages/react/direction/src/direction.tsx
var $7cc50a31b296c1eb$var$DirectionContext = $cQQee.createContext(void 0);
function $7cc50a31b296c1eb$export$b39126d51d94e6f3(localDir) {
    const globalDir = $cQQee.useContext($7cc50a31b296c1eb$var$DirectionContext);
    return localDir || globalDir || "ltr";
}



var $cQQee = parcelRequire("cQQee");




var $cQQee = parcelRequire("cQQee");
// packages/react/use-callback-ref/src/use-callback-ref.tsx
function $5188b0f5094d0afc$export$25bec8c6f54ee79a(callback) {
    const callbackRef = $cQQee.useRef(callback);
    $cQQee.useEffect(()=>{
        callbackRef.current = callback;
    });
    return $cQQee.useMemo(()=>(...args)=>callbackRef.current?.(...args), []);
}



var $cQQee = parcelRequire("cQQee");

// packages/react/use-escape-keydown/src/use-escape-keydown.tsx
function $b78d46cb7adf499c$export$3a72a57244d6e765(onEscapeKeyDownProp, ownerDocument = globalThis?.document) {
    const onEscapeKeyDown = (0, $5188b0f5094d0afc$export$25bec8c6f54ee79a)(onEscapeKeyDownProp);
    $cQQee.useEffect(()=>{
        const handleKeyDown = (event)=>{
            if (event.key === "Escape") onEscapeKeyDown(event);
        };
        ownerDocument.addEventListener("keydown", handleKeyDown, {
            capture: true
        });
        return ()=>ownerDocument.removeEventListener("keydown", handleKeyDown, {
                capture: true
            });
    }, [
        onEscapeKeyDown,
        ownerDocument
    ]);
}



var $cee95a2911ba3da8$var$DISMISSABLE_LAYER_NAME = "DismissableLayer";
var $cee95a2911ba3da8$var$CONTEXT_UPDATE = "dismissableLayer.update";
var $cee95a2911ba3da8$var$POINTER_DOWN_OUTSIDE = "dismissableLayer.pointerDownOutside";
var $cee95a2911ba3da8$var$FOCUS_OUTSIDE = "dismissableLayer.focusOutside";
var $cee95a2911ba3da8$var$originalBodyPointerEvents;
var $cee95a2911ba3da8$var$DismissableLayerContext = $cQQee.createContext({
    layers: /* @__PURE__ */ new Set(),
    layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
    branches: /* @__PURE__ */ new Set()
});
var $cee95a2911ba3da8$export$177fb62ff3ec1f22 = $cQQee.forwardRef((props, forwardedRef)=>{
    const { disableOutsidePointerEvents: disableOutsidePointerEvents = false, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, onFocusOutside: onFocusOutside, onInteractOutside: onInteractOutside, onDismiss: onDismiss, ...layerProps } = props;
    const context = $cQQee.useContext($cee95a2911ba3da8$var$DismissableLayerContext);
    const [node, setNode] = $cQQee.useState(null);
    const ownerDocument = node?.ownerDocument ?? globalThis?.document;
    const [, force] = $cQQee.useState({});
    const composedRefs = (0, $5565e7805f78287d$export$c7b2cbe3552a0d05)(forwardedRef, (node2)=>setNode(node2));
    const layers = Array.from(context.layers);
    const [highestLayerWithOutsidePointerEventsDisabled] = [
        ...context.layersWithOutsidePointerEventsDisabled
    ].slice(-1);
    const highestLayerWithOutsidePointerEventsDisabledIndex = layers.indexOf(highestLayerWithOutsidePointerEventsDisabled);
    const index = node ? layers.indexOf(node) : -1;
    const isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0;
    const isPointerEventsEnabled = index >= highestLayerWithOutsidePointerEventsDisabledIndex;
    const pointerDownOutside = $cee95a2911ba3da8$var$usePointerDownOutside((event)=>{
        const target = event.target;
        const isPointerDownOnBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (!isPointerEventsEnabled || isPointerDownOnBranch) return;
        onPointerDownOutside?.(event);
        onInteractOutside?.(event);
        if (!event.defaultPrevented) onDismiss?.();
    }, ownerDocument);
    const focusOutside = $cee95a2911ba3da8$var$useFocusOutside((event)=>{
        const target = event.target;
        const isFocusInBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (isFocusInBranch) return;
        onFocusOutside?.(event);
        onInteractOutside?.(event);
        if (!event.defaultPrevented) onDismiss?.();
    }, ownerDocument);
    (0, $b78d46cb7adf499c$export$3a72a57244d6e765)((event)=>{
        const isHighestLayer = index === context.layers.size - 1;
        if (!isHighestLayer) return;
        onEscapeKeyDown?.(event);
        if (!event.defaultPrevented && onDismiss) {
            event.preventDefault();
            onDismiss();
        }
    }, ownerDocument);
    $cQQee.useEffect(()=>{
        if (!node) return;
        if (disableOutsidePointerEvents) {
            if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
                $cee95a2911ba3da8$var$originalBodyPointerEvents = ownerDocument.body.style.pointerEvents;
                ownerDocument.body.style.pointerEvents = "none";
            }
            context.layersWithOutsidePointerEventsDisabled.add(node);
        }
        context.layers.add(node);
        $cee95a2911ba3da8$var$dispatchUpdate();
        return ()=>{
            if (disableOutsidePointerEvents && context.layersWithOutsidePointerEventsDisabled.size === 1) ownerDocument.body.style.pointerEvents = $cee95a2911ba3da8$var$originalBodyPointerEvents;
        };
    }, [
        node,
        ownerDocument,
        disableOutsidePointerEvents,
        context
    ]);
    $cQQee.useEffect(()=>{
        return ()=>{
            if (!node) return;
            context.layers.delete(node);
            context.layersWithOutsidePointerEventsDisabled.delete(node);
            $cee95a2911ba3da8$var$dispatchUpdate();
        };
    }, [
        node,
        context
    ]);
    $cQQee.useEffect(()=>{
        const handleUpdate = ()=>force({});
        document.addEventListener($cee95a2911ba3da8$var$CONTEXT_UPDATE, handleUpdate);
        return ()=>document.removeEventListener($cee95a2911ba3da8$var$CONTEXT_UPDATE, handleUpdate);
    }, []);
    return /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $f679bf6067493560$export$250ffa63cdc0d034).div, {
        ...layerProps,
        ref: composedRefs,
        style: {
            pointerEvents: isBodyPointerEventsDisabled ? isPointerEventsEnabled ? "auto" : "none" : void 0,
            ...props.style
        },
        onFocusCapture: (0, $a6afd3c22f4adf72$export$b9ecd428b558ff10)(props.onFocusCapture, focusOutside.onFocusCapture),
        onBlurCapture: (0, $a6afd3c22f4adf72$export$b9ecd428b558ff10)(props.onBlurCapture, focusOutside.onBlurCapture),
        onPointerDownCapture: (0, $a6afd3c22f4adf72$export$b9ecd428b558ff10)(props.onPointerDownCapture, pointerDownOutside.onPointerDownCapture)
    });
});
$cee95a2911ba3da8$export$177fb62ff3ec1f22.displayName = $cee95a2911ba3da8$var$DISMISSABLE_LAYER_NAME;
var $cee95a2911ba3da8$var$BRANCH_NAME = "DismissableLayerBranch";
var $cee95a2911ba3da8$export$4d5eb2109db14228 = $cQQee.forwardRef((props, forwardedRef)=>{
    const context = $cQQee.useContext($cee95a2911ba3da8$var$DismissableLayerContext);
    const ref = $cQQee.useRef(null);
    const composedRefs = (0, $5565e7805f78287d$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    $cQQee.useEffect(()=>{
        const node = ref.current;
        if (node) {
            context.branches.add(node);
            return ()=>{
                context.branches.delete(node);
            };
        }
    }, [
        context.branches
    ]);
    return /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $f679bf6067493560$export$250ffa63cdc0d034).div, {
        ...props,
        ref: composedRefs
    });
});
$cee95a2911ba3da8$export$4d5eb2109db14228.displayName = $cee95a2911ba3da8$var$BRANCH_NAME;
function $cee95a2911ba3da8$var$usePointerDownOutside(onPointerDownOutside, ownerDocument = globalThis?.document) {
    const handlePointerDownOutside = (0, $5188b0f5094d0afc$export$25bec8c6f54ee79a)(onPointerDownOutside);
    const isPointerInsideReactTreeRef = $cQQee.useRef(false);
    const handleClickRef = $cQQee.useRef(()=>{});
    $cQQee.useEffect(()=>{
        const handlePointerDown = (event)=>{
            if (event.target && !isPointerInsideReactTreeRef.current) {
                let handleAndDispatchPointerDownOutsideEvent2 = function() {
                    $cee95a2911ba3da8$var$handleAndDispatchCustomEvent($cee95a2911ba3da8$var$POINTER_DOWN_OUTSIDE, handlePointerDownOutside, eventDetail, {
                        discrete: true
                    });
                };
                const eventDetail = {
                    originalEvent: event
                };
                if (event.pointerType === "touch") {
                    ownerDocument.removeEventListener("click", handleClickRef.current);
                    handleClickRef.current = handleAndDispatchPointerDownOutsideEvent2;
                    ownerDocument.addEventListener("click", handleClickRef.current, {
                        once: true
                    });
                } else handleAndDispatchPointerDownOutsideEvent2();
            } else ownerDocument.removeEventListener("click", handleClickRef.current);
            isPointerInsideReactTreeRef.current = false;
        };
        const timerId = window.setTimeout(()=>{
            ownerDocument.addEventListener("pointerdown", handlePointerDown);
        }, 0);
        return ()=>{
            window.clearTimeout(timerId);
            ownerDocument.removeEventListener("pointerdown", handlePointerDown);
            ownerDocument.removeEventListener("click", handleClickRef.current);
        };
    }, [
        ownerDocument,
        handlePointerDownOutside
    ]);
    return {
        // ensures we check React component tree (not just DOM tree)
        onPointerDownCapture: ()=>isPointerInsideReactTreeRef.current = true
    };
}
function $cee95a2911ba3da8$var$useFocusOutside(onFocusOutside, ownerDocument = globalThis?.document) {
    const handleFocusOutside = (0, $5188b0f5094d0afc$export$25bec8c6f54ee79a)(onFocusOutside);
    const isFocusInsideReactTreeRef = $cQQee.useRef(false);
    $cQQee.useEffect(()=>{
        const handleFocus = (event)=>{
            if (event.target && !isFocusInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                $cee95a2911ba3da8$var$handleAndDispatchCustomEvent($cee95a2911ba3da8$var$FOCUS_OUTSIDE, handleFocusOutside, eventDetail, {
                    discrete: false
                });
            }
        };
        ownerDocument.addEventListener("focusin", handleFocus);
        return ()=>ownerDocument.removeEventListener("focusin", handleFocus);
    }, [
        ownerDocument,
        handleFocusOutside
    ]);
    return {
        onFocusCapture: ()=>isFocusInsideReactTreeRef.current = true,
        onBlurCapture: ()=>isFocusInsideReactTreeRef.current = false
    };
}
function $cee95a2911ba3da8$var$dispatchUpdate() {
    const event = new CustomEvent($cee95a2911ba3da8$var$CONTEXT_UPDATE);
    document.dispatchEvent(event);
}
function $cee95a2911ba3da8$var$handleAndDispatchCustomEvent(name, handler, detail, { discrete: discrete }) {
    const target = detail.originalEvent.target;
    const event = new CustomEvent(name, {
        bubbles: false,
        cancelable: true,
        detail: detail
    });
    if (handler) target.addEventListener(name, handler, {
        once: true
    });
    if (discrete) (0, $f679bf6067493560$export$6d1a0317bde7de7f)(target, event);
    else target.dispatchEvent(event);
}



var $cQQee = parcelRequire("cQQee");
var $2901e484e8d3cb24$var$count = 0;
function $2901e484e8d3cb24$export$b7ece24a22aeda8c() {
    $cQQee.useEffect(()=>{
        const edgeGuards = document.querySelectorAll("[data-radix-focus-guard]");
        document.body.insertAdjacentElement("afterbegin", edgeGuards[0] ?? $2901e484e8d3cb24$var$createFocusGuard());
        document.body.insertAdjacentElement("beforeend", edgeGuards[1] ?? $2901e484e8d3cb24$var$createFocusGuard());
        $2901e484e8d3cb24$var$count++;
        return ()=>{
            if ($2901e484e8d3cb24$var$count === 1) document.querySelectorAll("[data-radix-focus-guard]").forEach((node)=>node.remove());
            $2901e484e8d3cb24$var$count--;
        };
    }, []);
}
function $2901e484e8d3cb24$var$createFocusGuard() {
    const element = document.createElement("span");
    element.setAttribute("data-radix-focus-guard", "");
    element.tabIndex = 0;
    element.style.outline = "none";
    element.style.opacity = "0";
    element.style.position = "fixed";
    element.style.pointerEvents = "none";
    return element;
}



var $cQQee = parcelRequire("cQQee");




var $071a7a863660ec8d$var$AUTOFOCUS_ON_MOUNT = "focusScope.autoFocusOnMount";
var $071a7a863660ec8d$var$AUTOFOCUS_ON_UNMOUNT = "focusScope.autoFocusOnUnmount";
var $071a7a863660ec8d$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
var $071a7a863660ec8d$var$FOCUS_SCOPE_NAME = "FocusScope";
var $071a7a863660ec8d$export$20e40289641fbbb6 = $cQQee.forwardRef((props, forwardedRef)=>{
    const { loop: loop = false, trapped: trapped = false, onMountAutoFocus: onMountAutoFocusProp, onUnmountAutoFocus: onUnmountAutoFocusProp, ...scopeProps } = props;
    const [container, setContainer] = $cQQee.useState(null);
    const onMountAutoFocus = (0, $5188b0f5094d0afc$export$25bec8c6f54ee79a)(onMountAutoFocusProp);
    const onUnmountAutoFocus = (0, $5188b0f5094d0afc$export$25bec8c6f54ee79a)(onUnmountAutoFocusProp);
    const lastFocusedElementRef = $cQQee.useRef(null);
    const composedRefs = (0, $5565e7805f78287d$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setContainer(node));
    const focusScope = $cQQee.useRef({
        paused: false,
        pause () {
            this.paused = true;
        },
        resume () {
            this.paused = false;
        }
    }).current;
    $cQQee.useEffect(()=>{
        if (trapped) {
            let handleFocusIn2 = function(event) {
                if (focusScope.paused || !container) return;
                const target = event.target;
                if (container.contains(target)) lastFocusedElementRef.current = target;
                else $071a7a863660ec8d$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }, handleFocusOut2 = function(event) {
                if (focusScope.paused || !container) return;
                const relatedTarget = event.relatedTarget;
                if (relatedTarget === null) return;
                if (!container.contains(relatedTarget)) $071a7a863660ec8d$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }, handleMutations2 = function(mutations) {
                const focusedElement = document.activeElement;
                if (focusedElement !== document.body) return;
                for (const mutation of mutations)if (mutation.removedNodes.length > 0) $071a7a863660ec8d$var$focus(container);
            };
            document.addEventListener("focusin", handleFocusIn2);
            document.addEventListener("focusout", handleFocusOut2);
            const mutationObserver = new MutationObserver(handleMutations2);
            if (container) mutationObserver.observe(container, {
                childList: true,
                subtree: true
            });
            return ()=>{
                document.removeEventListener("focusin", handleFocusIn2);
                document.removeEventListener("focusout", handleFocusOut2);
                mutationObserver.disconnect();
            };
        }
    }, [
        trapped,
        container,
        focusScope.paused
    ]);
    $cQQee.useEffect(()=>{
        if (container) {
            $071a7a863660ec8d$var$focusScopesStack.add(focusScope);
            const previouslyFocusedElement = document.activeElement;
            const hasFocusedCandidate = container.contains(previouslyFocusedElement);
            if (!hasFocusedCandidate) {
                const mountEvent = new CustomEvent($071a7a863660ec8d$var$AUTOFOCUS_ON_MOUNT, $071a7a863660ec8d$var$EVENT_OPTIONS);
                container.addEventListener($071a7a863660ec8d$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                container.dispatchEvent(mountEvent);
                if (!mountEvent.defaultPrevented) {
                    $071a7a863660ec8d$var$focusFirst($071a7a863660ec8d$var$removeLinks($071a7a863660ec8d$var$getTabbableCandidates(container)), {
                        select: true
                    });
                    if (document.activeElement === previouslyFocusedElement) $071a7a863660ec8d$var$focus(container);
                }
            }
            return ()=>{
                container.removeEventListener($071a7a863660ec8d$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                setTimeout(()=>{
                    const unmountEvent = new CustomEvent($071a7a863660ec8d$var$AUTOFOCUS_ON_UNMOUNT, $071a7a863660ec8d$var$EVENT_OPTIONS);
                    container.addEventListener($071a7a863660ec8d$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    container.dispatchEvent(unmountEvent);
                    if (!unmountEvent.defaultPrevented) $071a7a863660ec8d$var$focus(previouslyFocusedElement ?? document.body, {
                        select: true
                    });
                    container.removeEventListener($071a7a863660ec8d$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    $071a7a863660ec8d$var$focusScopesStack.remove(focusScope);
                }, 0);
            };
        }
    }, [
        container,
        onMountAutoFocus,
        onUnmountAutoFocus,
        focusScope
    ]);
    const handleKeyDown = $cQQee.useCallback((event)=>{
        if (!loop && !trapped) return;
        if (focusScope.paused) return;
        const isTabKey = event.key === "Tab" && !event.altKey && !event.ctrlKey && !event.metaKey;
        const focusedElement = document.activeElement;
        if (isTabKey && focusedElement) {
            const container2 = event.currentTarget;
            const [first, last] = $071a7a863660ec8d$var$getTabbableEdges(container2);
            const hasTabbableElementsInside = first && last;
            if (!hasTabbableElementsInside) {
                if (focusedElement === container2) event.preventDefault();
            } else {
                if (!event.shiftKey && focusedElement === last) {
                    event.preventDefault();
                    if (loop) $071a7a863660ec8d$var$focus(first, {
                        select: true
                    });
                } else if (event.shiftKey && focusedElement === first) {
                    event.preventDefault();
                    if (loop) $071a7a863660ec8d$var$focus(last, {
                        select: true
                    });
                }
            }
        }
    }, [
        loop,
        trapped,
        focusScope.paused
    ]);
    return /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $f679bf6067493560$export$250ffa63cdc0d034).div, {
        tabIndex: -1,
        ...scopeProps,
        ref: composedRefs,
        onKeyDown: handleKeyDown
    });
});
$071a7a863660ec8d$export$20e40289641fbbb6.displayName = $071a7a863660ec8d$var$FOCUS_SCOPE_NAME;
function $071a7a863660ec8d$var$focusFirst(candidates, { select: select = false } = {}) {
    const previouslyFocusedElement = document.activeElement;
    for (const candidate of candidates){
        $071a7a863660ec8d$var$focus(candidate, {
            select: select
        });
        if (document.activeElement !== previouslyFocusedElement) return;
    }
}
function $071a7a863660ec8d$var$getTabbableEdges(container) {
    const candidates = $071a7a863660ec8d$var$getTabbableCandidates(container);
    const first = $071a7a863660ec8d$var$findVisible(candidates, container);
    const last = $071a7a863660ec8d$var$findVisible(candidates.reverse(), container);
    return [
        first,
        last
    ];
}
function $071a7a863660ec8d$var$getTabbableCandidates(container) {
    const nodes = [];
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
        acceptNode: (node)=>{
            const isHiddenInput = node.tagName === "INPUT" && node.type === "hidden";
            if (node.disabled || node.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP;
            return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
    });
    while(walker.nextNode())nodes.push(walker.currentNode);
    return nodes;
}
function $071a7a863660ec8d$var$findVisible(elements, container) {
    for (const element of elements){
        if (!$071a7a863660ec8d$var$isHidden(element, {
            upTo: container
        })) return element;
    }
}
function $071a7a863660ec8d$var$isHidden(node, { upTo: upTo }) {
    if (getComputedStyle(node).visibility === "hidden") return true;
    while(node){
        if (upTo !== void 0 && node === upTo) return false;
        if (getComputedStyle(node).display === "none") return true;
        node = node.parentElement;
    }
    return false;
}
function $071a7a863660ec8d$var$isSelectableInput(element) {
    return element instanceof HTMLInputElement && "select" in element;
}
function $071a7a863660ec8d$var$focus(element, { select: select = false } = {}) {
    if (element && element.focus) {
        const previouslyFocusedElement = document.activeElement;
        element.focus({
            preventScroll: true
        });
        if (element !== previouslyFocusedElement && $071a7a863660ec8d$var$isSelectableInput(element) && select) element.select();
    }
}
var $071a7a863660ec8d$var$focusScopesStack = $071a7a863660ec8d$var$createFocusScopesStack();
function $071a7a863660ec8d$var$createFocusScopesStack() {
    let stack = [];
    return {
        add (focusScope) {
            const activeFocusScope = stack[0];
            if (focusScope !== activeFocusScope) activeFocusScope?.pause();
            stack = $071a7a863660ec8d$var$arrayRemove(stack, focusScope);
            stack.unshift(focusScope);
        },
        remove (focusScope) {
            stack = $071a7a863660ec8d$var$arrayRemove(stack, focusScope);
            stack[0]?.resume();
        }
    };
}
function $071a7a863660ec8d$var$arrayRemove(array, item) {
    const updatedArray = [
        ...array
    ];
    const index = updatedArray.indexOf(item);
    if (index !== -1) updatedArray.splice(index, 1);
    return updatedArray;
}
function $071a7a863660ec8d$var$removeLinks(items) {
    return items.filter((item)=>item.tagName !== "A");
}



var $cQQee = parcelRequire("cQQee");

// packages/react/id/src/id.tsx
var $2a35bb07bdc6a9cb$var$useReactId = $cQQee[" useId ".trim().toString()] || (()=>void 0);
var $2a35bb07bdc6a9cb$var$count = 0;
function $2a35bb07bdc6a9cb$export$f680877a34711e37(deterministicId) {
    const [id, setId] = $cQQee.useState($2a35bb07bdc6a9cb$var$useReactId());
    (0, $18ec559a74924a74$export$e5c5a5f917a5871c)(()=>{
        setId((reactId)=>reactId ?? String($2a35bb07bdc6a9cb$var$count++));
    }, [
        deterministicId
    ]);
    return id ? `radix-${id}` : "";
}



var $cQQee = parcelRequire("cQQee");
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $8309a587e68d0450$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $8309a587e68d0450$export$96ec731ed4dcb222 = Math.min;
const $8309a587e68d0450$export$8960430cfd85939f = Math.max;
const $8309a587e68d0450$export$2077e0241d6afd3c = Math.round;
const $8309a587e68d0450$export$a3fe094919f356fd = Math.floor;
const $8309a587e68d0450$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $8309a587e68d0450$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
const $8309a587e68d0450$var$oppositeAlignmentMap = {
    start: 'end',
    end: 'start'
};
function $8309a587e68d0450$export$7d15b64cf5a3a4c4(start, value, end) {
    return $8309a587e68d0450$export$8960430cfd85939f(start, $8309a587e68d0450$export$96ec731ed4dcb222(value, end));
}
function $8309a587e68d0450$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $8309a587e68d0450$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $8309a587e68d0450$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $8309a587e68d0450$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $8309a587e68d0450$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function $8309a587e68d0450$export$f28e8f882010718a(placement) {
    return [
        'top',
        'bottom'
    ].includes($8309a587e68d0450$export$3c915306cb7fc97a(placement)) ? 'y' : 'x';
}
function $8309a587e68d0450$export$2b57e0052a6d6d4c(placement) {
    return $8309a587e68d0450$export$8a000a963141ac32($8309a587e68d0450$export$f28e8f882010718a(placement));
}
function $8309a587e68d0450$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $8309a587e68d0450$export$f0989780f32bfcda(placement);
    const alignmentAxis = $8309a587e68d0450$export$2b57e0052a6d6d4c(placement);
    const length = $8309a587e68d0450$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $8309a587e68d0450$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $8309a587e68d0450$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $8309a587e68d0450$export$496432a3699e50b1(placement) {
    const oppositePlacement = $8309a587e68d0450$export$9c5e28bad23365fa(placement);
    return [
        $8309a587e68d0450$export$2b182c584985588b(placement),
        oppositePlacement,
        $8309a587e68d0450$export$2b182c584985588b(oppositePlacement)
    ];
}
function $8309a587e68d0450$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$8309a587e68d0450$var$oppositeAlignmentMap[alignment]);
}
function $8309a587e68d0450$var$getSideList(side, isStart, rtl) {
    const lr = [
        'left',
        'right'
    ];
    const rl = [
        'right',
        'left'
    ];
    const tb = [
        'top',
        'bottom'
    ];
    const bt = [
        'bottom',
        'top'
    ];
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case 'left':
        case 'right':
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $8309a587e68d0450$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $8309a587e68d0450$export$f0989780f32bfcda(placement);
    let list = $8309a587e68d0450$var$getSideList($8309a587e68d0450$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($8309a587e68d0450$export$2b182c584985588b));
    }
    return list;
}
function $8309a587e68d0450$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$8309a587e68d0450$var$oppositeSideMap[side]);
}
function $8309a587e68d0450$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $8309a587e68d0450$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $8309a587e68d0450$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $8309a587e68d0450$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}


function $e4246ba20f4ecc65$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $8309a587e68d0450$export$f28e8f882010718a)(placement);
    const alignmentAxis = (0, $8309a587e68d0450$export$2b57e0052a6d6d4c)(placement);
    const alignLength = (0, $8309a587e68d0450$export$320bd9d53520c68a)(alignmentAxis);
    const side = (0, $8309a587e68d0450$export$3c915306cb7fc97a)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $8309a587e68d0450$export$f0989780f32bfcda)(placement)){
        case 'start':
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case 'end':
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $e4246ba20f4ecc65$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $e4246ba20f4ecc65$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $e4246ba20f4ecc65$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $e4246ba20f4ecc65$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, $8309a587e68d0450$export$fef61f332f2c0afc)(options, state);
    const paddingObject = (0, $8309a587e68d0450$export$598c291c29bc2e71)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $8309a587e68d0450$export$ee05aea0aeecbad4)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $8309a587e68d0450$export$ee05aea0aeecbad4)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $e4246ba20f4ecc65$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $8309a587e68d0450$export$fef61f332f2c0afc)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $8309a587e68d0450$export$598c291c29bc2e71)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $8309a587e68d0450$export$2b57e0052a6d6d4c)(placement);
            const length = (0, $8309a587e68d0450$export$320bd9d53520c68a)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $8309a587e68d0450$export$96ec731ed4dcb222)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $8309a587e68d0450$export$96ec731ed4dcb222)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $8309a587e68d0450$export$7d15b64cf5a3a4c4)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $8309a587e68d0450$export$f0989780f32bfcda)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $e4246ba20f4ecc65$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $8309a587e68d0450$export$fef61f332f2c0afc)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $8309a587e68d0450$export$3c915306cb7fc97a)(placement);
            const initialSideAxis = (0, $8309a587e68d0450$export$f28e8f882010718a)(initialPlacement);
            const isBasePlacement = (0, $8309a587e68d0450$export$3c915306cb7fc97a)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $8309a587e68d0450$export$9c5e28bad23365fa)(initialPlacement)
            ] : (0, $8309a587e68d0450$export$496432a3699e50b1)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $8309a587e68d0450$export$a9b6fb18fd92c3ec)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $e4246ba20f4ecc65$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $8309a587e68d0450$export$be42861551f17911)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $8309a587e68d0450$export$f28e8f882010718a)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $e4246ba20f4ecc65$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $e4246ba20f4ecc65$var$isAnySideFullyClipped(overflow) {
    return (0, $8309a587e68d0450$export$832b6fa47fa053d2).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $e4246ba20f4ecc65$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, $8309a587e68d0450$export$fef61f332f2c0afc)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await $e4246ba20f4ecc65$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = $e4246ba20f4ecc65$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $e4246ba20f4ecc65$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await $e4246ba20f4ecc65$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $e4246ba20f4ecc65$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $e4246ba20f4ecc65$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $e4246ba20f4ecc65$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $8309a587e68d0450$export$3c915306cb7fc97a)(placement);
    const alignment = (0, $8309a587e68d0450$export$f0989780f32bfcda)(placement);
    const isVertical = (0, $8309a587e68d0450$export$f28e8f882010718a)(placement) === 'y';
    const mainAxisMulti = [
        'left',
        'top'
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $8309a587e68d0450$export$fef61f332f2c0afc)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $e4246ba20f4ecc65$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $e4246ba20f4ecc65$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $e4246ba20f4ecc65$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $8309a587e68d0450$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $e4246ba20f4ecc65$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $8309a587e68d0450$export$f28e8f882010718a)((0, $8309a587e68d0450$export$3c915306cb7fc97a)(placement));
            const mainAxis = (0, $8309a587e68d0450$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === 'y' ? 'top' : 'left';
                const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $8309a587e68d0450$export$7d15b64cf5a3a4c4)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === 'y' ? 'top' : 'left';
                const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $8309a587e68d0450$export$7d15b64cf5a3a4c4)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $e4246ba20f4ecc65$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $8309a587e68d0450$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $8309a587e68d0450$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $8309a587e68d0450$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $8309a587e68d0450$export$fef61f332f2c0afc)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = [
                    'top',
                    'left'
                ].includes((0, $8309a587e68d0450$export$3c915306cb7fc97a)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $e4246ba20f4ecc65$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $8309a587e68d0450$export$fef61f332f2c0afc)(options, state);
            const overflow = await $e4246ba20f4ecc65$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $8309a587e68d0450$export$3c915306cb7fc97a)(placement);
            const alignment = (0, $8309a587e68d0450$export$f0989780f32bfcda)(placement);
            const isYAxis = (0, $8309a587e68d0450$export$f28e8f882010718a)(placement) === 'y';
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $8309a587e68d0450$export$96ec731ed4dcb222)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $8309a587e68d0450$export$96ec731ed4dcb222)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $8309a587e68d0450$export$8960430cfd85939f)(overflow.left, 0);
                const xMax = (0, $8309a587e68d0450$export$8960430cfd85939f)(overflow.right, 0);
                const yMin = (0, $8309a587e68d0450$export$8960430cfd85939f)(overflow.top, 0);
                const yMax = (0, $8309a587e68d0450$export$8960430cfd85939f)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $8309a587e68d0450$export$8960430cfd85939f)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $8309a587e68d0450$export$8960430cfd85939f)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};



function $60bfc1c73d855eb0$var$hasWindow() {
    return typeof window !== 'undefined';
}
function $60bfc1c73d855eb0$export$651544f548703224(node) {
    if ($60bfc1c73d855eb0$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $60bfc1c73d855eb0$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $60bfc1c73d855eb0$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($60bfc1c73d855eb0$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $60bfc1c73d855eb0$export$8ee0fc9ee280b4ee(value) {
    if (!$60bfc1c73d855eb0$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $60bfc1c73d855eb0$export$38b2d434cce3ea22(value).Node;
}
function $60bfc1c73d855eb0$export$45a5e7f76e0caa8d(value) {
    if (!$60bfc1c73d855eb0$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $60bfc1c73d855eb0$export$38b2d434cce3ea22(value).Element;
}
function $60bfc1c73d855eb0$export$1b3bfaa9684536aa(value) {
    if (!$60bfc1c73d855eb0$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $60bfc1c73d855eb0$export$38b2d434cce3ea22(value).HTMLElement;
}
function $60bfc1c73d855eb0$export$af51f0f06c0f328a(value) {
    if (!$60bfc1c73d855eb0$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $60bfc1c73d855eb0$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $60bfc1c73d855eb0$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $60bfc1c73d855eb0$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        'inline',
        'contents'
    ].includes(display);
}
function $60bfc1c73d855eb0$export$71535ffaa902797f(element) {
    return [
        'table',
        'td',
        'th'
    ].includes($60bfc1c73d855eb0$export$651544f548703224(element));
}
function $60bfc1c73d855eb0$export$89e651af02346cd4(element) {
    return [
        ':popover-open',
        ':modal'
    ].some((selector)=>{
        try {
            return element.matches(selector);
        } catch (e) {
            return false;
        }
    });
}
function $60bfc1c73d855eb0$export$d6c4e8150c35fed1(elementOrCss) {
    const webkit = $60bfc1c73d855eb0$export$78551043582a6a98();
    const css = $60bfc1c73d855eb0$export$45a5e7f76e0caa8d(elementOrCss) ? $60bfc1c73d855eb0$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    // https://drafts.csswg.org/css-transforms-2/#individual-transforms
    return [
        'transform',
        'translate',
        'scale',
        'rotate',
        'perspective'
    ].some((value)=>css[value] ? css[value] !== 'none' : false) || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || [
        'transform',
        'translate',
        'scale',
        'rotate',
        'perspective',
        'filter'
    ].some((value)=>(css.willChange || '').includes(value)) || [
        'paint',
        'layout',
        'strict',
        'content'
    ].some((value)=>(css.contain || '').includes(value));
}
function $60bfc1c73d855eb0$export$940d8225183e1404(element) {
    let currentNode = $60bfc1c73d855eb0$export$4e12058fc4d51d56(element);
    while($60bfc1c73d855eb0$export$1b3bfaa9684536aa(currentNode) && !$60bfc1c73d855eb0$export$d1162fb0b6d4cd51(currentNode)){
        if ($60bfc1c73d855eb0$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($60bfc1c73d855eb0$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $60bfc1c73d855eb0$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $60bfc1c73d855eb0$export$78551043582a6a98() {
    if (typeof CSS === 'undefined' || !CSS.supports) return false;
    return CSS.supports('-webkit-backdrop-filter', 'none');
}
function $60bfc1c73d855eb0$export$d1162fb0b6d4cd51(node) {
    return [
        'html',
        'body',
        '#document'
    ].includes($60bfc1c73d855eb0$export$651544f548703224(node));
}
function $60bfc1c73d855eb0$export$3735103072e4a80(element) {
    return $60bfc1c73d855eb0$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $60bfc1c73d855eb0$export$dc8fc79fa2800137(element) {
    if ($60bfc1c73d855eb0$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $60bfc1c73d855eb0$export$4e12058fc4d51d56(node) {
    if ($60bfc1c73d855eb0$export$651544f548703224(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $60bfc1c73d855eb0$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $60bfc1c73d855eb0$export$e495491855dc5418(node);
    return $60bfc1c73d855eb0$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $60bfc1c73d855eb0$export$7cd01a57c8ca906c(node) {
    const parentNode = $60bfc1c73d855eb0$export$4e12058fc4d51d56(node);
    if ($60bfc1c73d855eb0$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($60bfc1c73d855eb0$export$1b3bfaa9684536aa(parentNode) && $60bfc1c73d855eb0$export$989e911fa9af580a(parentNode)) return parentNode;
    return $60bfc1c73d855eb0$export$7cd01a57c8ca906c(parentNode);
}
function $60bfc1c73d855eb0$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $60bfc1c73d855eb0$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $60bfc1c73d855eb0$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $60bfc1c73d855eb0$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $60bfc1c73d855eb0$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $60bfc1c73d855eb0$export$3b57c1601291186b(frameElement) : []);
    }
    return list.concat(scrollableAncestor, $60bfc1c73d855eb0$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $60bfc1c73d855eb0$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}


function $6893d4083cc86ed8$var$getCssDimensions(element) {
    const css = (0, $60bfc1c73d855eb0$export$3735103072e4a80)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $60bfc1c73d855eb0$export$1b3bfaa9684536aa)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $8309a587e68d0450$export$2077e0241d6afd3c)(width) !== offsetWidth || (0, $8309a587e68d0450$export$2077e0241d6afd3c)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $6893d4083cc86ed8$var$unwrapElement(element) {
    return !(0, $60bfc1c73d855eb0$export$45a5e7f76e0caa8d)(element) ? element.contextElement : element;
}
function $6893d4083cc86ed8$var$getScale(element) {
    const domElement = $6893d4083cc86ed8$var$unwrapElement(element);
    if (!(0, $60bfc1c73d855eb0$export$1b3bfaa9684536aa)(domElement)) return (0, $8309a587e68d0450$export$a397704b5e280835)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $6893d4083cc86ed8$var$getCssDimensions(domElement);
    let x = ($ ? (0, $8309a587e68d0450$export$2077e0241d6afd3c)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $8309a587e68d0450$export$2077e0241d6afd3c)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $6893d4083cc86ed8$var$noOffsets = /*#__PURE__*/ (0, $8309a587e68d0450$export$a397704b5e280835)(0);
function $6893d4083cc86ed8$var$getVisualOffsets(element) {
    const win = (0, $60bfc1c73d855eb0$export$38b2d434cce3ea22)(element);
    if (!(0, $60bfc1c73d855eb0$export$78551043582a6a98)() || !win.visualViewport) return $6893d4083cc86ed8$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $6893d4083cc86ed8$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $60bfc1c73d855eb0$export$38b2d434cce3ea22)(element)) return false;
    return isFixed;
}
function $6893d4083cc86ed8$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $6893d4083cc86ed8$var$unwrapElement(element);
    let scale = (0, $8309a587e68d0450$export$a397704b5e280835)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $60bfc1c73d855eb0$export$45a5e7f76e0caa8d)(offsetParent)) scale = $6893d4083cc86ed8$var$getScale(offsetParent);
        } else scale = $6893d4083cc86ed8$var$getScale(element);
    }
    const visualOffsets = $6893d4083cc86ed8$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $6893d4083cc86ed8$var$getVisualOffsets(domElement) : (0, $8309a587e68d0450$export$a397704b5e280835)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $60bfc1c73d855eb0$export$38b2d434cce3ea22)(domElement);
        const offsetWin = offsetParent && (0, $60bfc1c73d855eb0$export$45a5e7f76e0caa8d)(offsetParent) ? (0, $60bfc1c73d855eb0$export$38b2d434cce3ea22)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $60bfc1c73d855eb0$export$7bf1f8740e3e34af)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $6893d4083cc86ed8$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $60bfc1c73d855eb0$export$3735103072e4a80)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $60bfc1c73d855eb0$export$38b2d434cce3ea22)(currentIFrame);
            currentIFrame = (0, $60bfc1c73d855eb0$export$7bf1f8740e3e34af)(currentWin);
        }
    }
    return (0, $8309a587e68d0450$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $6893d4083cc86ed8$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $60bfc1c73d855eb0$export$dc8fc79fa2800137)(element).scrollLeft;
    if (!rect) return $6893d4083cc86ed8$var$getBoundingClientRect((0, $60bfc1c73d855eb0$export$e495491855dc5418)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $6893d4083cc86ed8$var$getHTMLOffset(documentElement, scroll, ignoreScrollbarX) {
    if (ignoreScrollbarX === void 0) ignoreScrollbarX = false;
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - (ignoreScrollbarX ? 0 : // RTL <body> scrollbar.
    $6893d4083cc86ed8$var$getWindowScrollBarX(documentElement, htmlRect));
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $6893d4083cc86ed8$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, $60bfc1c73d855eb0$export$e495491855dc5418)(offsetParent);
    const topLayer = elements ? (0, $60bfc1c73d855eb0$export$89e651af02346cd4)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $8309a587e68d0450$export$a397704b5e280835)(1);
    const offsets = (0, $8309a587e68d0450$export$a397704b5e280835)(0);
    const isOffsetParentAnElement = (0, $60bfc1c73d855eb0$export$1b3bfaa9684536aa)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $60bfc1c73d855eb0$export$651544f548703224)(offsetParent) !== 'body' || (0, $60bfc1c73d855eb0$export$989e911fa9af580a)(documentElement)) scroll = (0, $60bfc1c73d855eb0$export$dc8fc79fa2800137)(offsetParent);
        if ((0, $60bfc1c73d855eb0$export$1b3bfaa9684536aa)(offsetParent)) {
            const offsetRect = $6893d4083cc86ed8$var$getBoundingClientRect(offsetParent);
            scale = $6893d4083cc86ed8$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $6893d4083cc86ed8$var$getHTMLOffset(documentElement, scroll, true) : (0, $8309a587e68d0450$export$a397704b5e280835)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $6893d4083cc86ed8$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $6893d4083cc86ed8$var$getDocumentRect(element) {
    const html = (0, $60bfc1c73d855eb0$export$e495491855dc5418)(element);
    const scroll = (0, $60bfc1c73d855eb0$export$dc8fc79fa2800137)(element);
    const body = element.ownerDocument.body;
    const width = (0, $8309a587e68d0450$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $8309a587e68d0450$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $6893d4083cc86ed8$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $60bfc1c73d855eb0$export$3735103072e4a80)(body).direction === 'rtl') x += (0, $8309a587e68d0450$export$8960430cfd85939f)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $6893d4083cc86ed8$var$getViewportRect(element, strategy) {
    const win = (0, $60bfc1c73d855eb0$export$38b2d434cce3ea22)(element);
    const html = (0, $60bfc1c73d855eb0$export$e495491855dc5418)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $60bfc1c73d855eb0$export$78551043582a6a98)();
        if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $6893d4083cc86ed8$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $6893d4083cc86ed8$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $60bfc1c73d855eb0$export$1b3bfaa9684536aa)(element) ? $6893d4083cc86ed8$var$getScale(element) : (0, $8309a587e68d0450$export$a397704b5e280835)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $6893d4083cc86ed8$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport') rect = $6893d4083cc86ed8$var$getViewportRect(element, strategy);
    else if (clippingAncestor === 'document') rect = $6893d4083cc86ed8$var$getDocumentRect((0, $60bfc1c73d855eb0$export$e495491855dc5418)(element));
    else if ((0, $60bfc1c73d855eb0$export$45a5e7f76e0caa8d)(clippingAncestor)) rect = $6893d4083cc86ed8$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $6893d4083cc86ed8$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $8309a587e68d0450$export$ee05aea0aeecbad4)(rect);
}
function $6893d4083cc86ed8$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $60bfc1c73d855eb0$export$4e12058fc4d51d56)(element);
    if (parentNode === stopNode || !(0, $60bfc1c73d855eb0$export$45a5e7f76e0caa8d)(parentNode) || (0, $60bfc1c73d855eb0$export$d1162fb0b6d4cd51)(parentNode)) return false;
    return (0, $60bfc1c73d855eb0$export$3735103072e4a80)(parentNode).position === 'fixed' || $6893d4083cc86ed8$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $6893d4083cc86ed8$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $60bfc1c73d855eb0$export$3b57c1601291186b)(element, [], false).filter((el)=>(0, $60bfc1c73d855eb0$export$45a5e7f76e0caa8d)(el) && (0, $60bfc1c73d855eb0$export$651544f548703224)(el) !== 'body');
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $60bfc1c73d855eb0$export$3735103072e4a80)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, $60bfc1c73d855eb0$export$4e12058fc4d51d56)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $60bfc1c73d855eb0$export$45a5e7f76e0caa8d)(currentNode) && !(0, $60bfc1c73d855eb0$export$d1162fb0b6d4cd51)(currentNode)){
        const computedStyle = (0, $60bfc1c73d855eb0$export$3735103072e4a80)(currentNode);
        const currentNodeIsContaining = (0, $60bfc1c73d855eb0$export$d6c4e8150c35fed1)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && [
            'absolute',
            'fixed'
        ].includes(currentContainingBlockComputedStyle.position) || (0, $60bfc1c73d855eb0$export$989e911fa9af580a)(currentNode) && !currentNodeIsContaining && $6893d4083cc86ed8$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $60bfc1c73d855eb0$export$4e12058fc4d51d56)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $6893d4083cc86ed8$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, $60bfc1c73d855eb0$export$89e651af02346cd4)(element) ? [] : $6893d4083cc86ed8$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $6893d4083cc86ed8$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $8309a587e68d0450$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $8309a587e68d0450$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $8309a587e68d0450$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $8309a587e68d0450$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $6893d4083cc86ed8$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $6893d4083cc86ed8$var$getDimensions(element) {
    const { width: width, height: height } = $6893d4083cc86ed8$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $6893d4083cc86ed8$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $60bfc1c73d855eb0$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $60bfc1c73d855eb0$export$e495491855dc5418)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = $6893d4083cc86ed8$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $8309a587e68d0450$export$a397704b5e280835)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $60bfc1c73d855eb0$export$651544f548703224)(offsetParent) !== 'body' || (0, $60bfc1c73d855eb0$export$989e911fa9af580a)(documentElement)) scroll = (0, $60bfc1c73d855eb0$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $6893d4083cc86ed8$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
        // Firefox with layout.scrollbar.side = 3 in about:config to test this.
        offsets.x = $6893d4083cc86ed8$var$getWindowScrollBarX(documentElement);
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $6893d4083cc86ed8$var$getHTMLOffset(documentElement, scroll) : (0, $8309a587e68d0450$export$a397704b5e280835)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $6893d4083cc86ed8$var$isStaticPositioned(element) {
    return (0, $60bfc1c73d855eb0$export$3735103072e4a80)(element).position === 'static';
}
function $6893d4083cc86ed8$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $60bfc1c73d855eb0$export$1b3bfaa9684536aa)(element) || (0, $60bfc1c73d855eb0$export$3735103072e4a80)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $60bfc1c73d855eb0$export$e495491855dc5418)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $6893d4083cc86ed8$var$getOffsetParent(element, polyfill) {
    const win = (0, $60bfc1c73d855eb0$export$38b2d434cce3ea22)(element);
    if ((0, $60bfc1c73d855eb0$export$89e651af02346cd4)(element)) return win;
    if (!(0, $60bfc1c73d855eb0$export$1b3bfaa9684536aa)(element)) {
        let svgOffsetParent = (0, $60bfc1c73d855eb0$export$4e12058fc4d51d56)(element);
        while(svgOffsetParent && !(0, $60bfc1c73d855eb0$export$d1162fb0b6d4cd51)(svgOffsetParent)){
            if ((0, $60bfc1c73d855eb0$export$45a5e7f76e0caa8d)(svgOffsetParent) && !$6893d4083cc86ed8$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $60bfc1c73d855eb0$export$4e12058fc4d51d56)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $6893d4083cc86ed8$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $60bfc1c73d855eb0$export$71535ffaa902797f)(offsetParent) && $6893d4083cc86ed8$var$isStaticPositioned(offsetParent))offsetParent = $6893d4083cc86ed8$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $60bfc1c73d855eb0$export$d1162fb0b6d4cd51)(offsetParent) && $6893d4083cc86ed8$var$isStaticPositioned(offsetParent) && !(0, $60bfc1c73d855eb0$export$d6c4e8150c35fed1)(offsetParent)) return win;
    return offsetParent || (0, $60bfc1c73d855eb0$export$940d8225183e1404)(element) || win;
}
const $6893d4083cc86ed8$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $6893d4083cc86ed8$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $6893d4083cc86ed8$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $6893d4083cc86ed8$var$isRTL(element) {
    return (0, $60bfc1c73d855eb0$export$3735103072e4a80)(element).direction === 'rtl';
}
const $6893d4083cc86ed8$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $6893d4083cc86ed8$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $60bfc1c73d855eb0$export$e495491855dc5418,
    getClippingRect: $6893d4083cc86ed8$var$getClippingRect,
    getOffsetParent: $6893d4083cc86ed8$var$getOffsetParent,
    getElementRects: $6893d4083cc86ed8$var$getElementRects,
    getClientRects: $6893d4083cc86ed8$var$getClientRects,
    getDimensions: $6893d4083cc86ed8$var$getDimensions,
    getScale: $6893d4083cc86ed8$var$getScale,
    isElement: $60bfc1c73d855eb0$export$45a5e7f76e0caa8d,
    isRTL: $6893d4083cc86ed8$var$isRTL
};
function $6893d4083cc86ed8$var$rectsAreEqual(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
// https://samthor.au/2021/observing-dom/
function $6893d4083cc86ed8$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $60bfc1c73d855eb0$export$e495491855dc5418)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const elementRectForRootMargin = element.getBoundingClientRect();
        const { left: left, top: top, width: width, height: height } = elementRectForRootMargin;
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $8309a587e68d0450$export$a3fe094919f356fd)(top);
        const insetRight = (0, $8309a587e68d0450$export$a3fe094919f356fd)(root.clientWidth - (left + width));
        const insetBottom = (0, $8309a587e68d0450$export$a3fe094919f356fd)(root.clientHeight - (top + height));
        const insetLeft = (0, $8309a587e68d0450$export$a3fe094919f356fd)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $8309a587e68d0450$export$8960430cfd85939f)(0, (0, $8309a587e68d0450$export$96ec731ed4dcb222)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            if (ratio === 1 && !$6893d4083cc86ed8$var$rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) // It's possible that even though the ratio is reported as 1, the
            // element is not actually fully within the IntersectionObserver's root
            // area anymore. This can happen under performance constraints. This may
            // be a bug in the browser's IntersectionObserver implementation. To
            // work around this, we compare the element's bounding rect now with
            // what it was at the time we created the IntersectionObserver. If they
            // are not equal then the element moved, so we refresh.
            refresh();
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $6893d4083cc86ed8$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
    const referenceEl = $6893d4083cc86ed8$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $60bfc1c73d855eb0$export$3b57c1601291186b)(referenceEl) : [],
        ...(0, $60bfc1c73d855eb0$export$3b57c1601291186b)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? $6893d4083cc86ed8$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $6893d4083cc86ed8$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $6893d4083cc86ed8$var$getBoundingClientRect(reference);
        if (prevRefRect && !$6893d4083cc86ed8$var$rectsAreEqual(prevRefRect, nextRefRect)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $6893d4083cc86ed8$export$cc800923e997bb8 = (0, $e4246ba20f4ecc65$export$cc800923e997bb8);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $6893d4083cc86ed8$export$fba63a578e423eb = (0, $e4246ba20f4ecc65$export$fba63a578e423eb);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $6893d4083cc86ed8$export$8a83211c878a3f1f = (0, $e4246ba20f4ecc65$export$8a83211c878a3f1f);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $6893d4083cc86ed8$export$346677f925de839c = (0, $e4246ba20f4ecc65$export$346677f925de839c);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $6893d4083cc86ed8$export$fe8985bb6374093c = (0, $e4246ba20f4ecc65$export$fe8985bb6374093c);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $6893d4083cc86ed8$export$f2120bbfa5450bd2 = (0, $e4246ba20f4ecc65$export$f2120bbfa5450bd2);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $6893d4083cc86ed8$export$7bf07e38f3dc4b69 = (0, $e4246ba20f4ecc65$export$7bf07e38f3dc4b69);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $6893d4083cc86ed8$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $6893d4083cc86ed8$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $e4246ba20f4ecc65$export$48a53dcb22e581d0)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};



var $cQQee = parcelRequire("cQQee");

var $kC364 = parcelRequire("kC364");
var $7f5afe61140090df$var$index = typeof document !== 'undefined' ? (0, $cQQee.useLayoutEffect) : (0, $cQQee.useEffect);
// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function $7f5afe61140090df$var$deepEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (typeof a === 'function' && a.toString() === b.toString()) return true;
    let length;
    let i;
    let keys;
    if (a && b && typeof a === 'object') {
        if (Array.isArray(a)) {
            length = a.length;
            if (length !== b.length) return false;
            for(i = length; i-- !== 0;){
                if (!$7f5afe61140090df$var$deepEqual(a[i], b[i])) return false;
            }
            return true;
        }
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;){
            if (!({}).hasOwnProperty.call(b, keys[i])) return false;
        }
        for(i = length; i-- !== 0;){
            const key = keys[i];
            if (key === '_owner' && a.$$typeof) continue;
            if (!$7f5afe61140090df$var$deepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
}
function $7f5afe61140090df$var$getDPR(element) {
    if (typeof window === 'undefined') return 1;
    const win = element.ownerDocument.defaultView || window;
    return win.devicePixelRatio || 1;
}
function $7f5afe61140090df$var$roundByDPR(element, value) {
    const dpr = $7f5afe61140090df$var$getDPR(element);
    return Math.round(value * dpr) / dpr;
}
function $7f5afe61140090df$var$useLatestRef(value) {
    const ref = $cQQee.useRef(value);
    $7f5afe61140090df$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/useFloating
 */ function $7f5afe61140090df$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform, elements: { reference: externalReference, floating: externalFloating } = {}, transform: transform = true, whileElementsMounted: whileElementsMounted, open: open } = options;
    const [data, setData] = $cQQee.useState({
        x: 0,
        y: 0,
        strategy: strategy,
        placement: placement,
        middlewareData: {},
        isPositioned: false
    });
    const [latestMiddleware, setLatestMiddleware] = $cQQee.useState(middleware);
    if (!$7f5afe61140090df$var$deepEqual(latestMiddleware, middleware)) setLatestMiddleware(middleware);
    const [_reference, _setReference] = $cQQee.useState(null);
    const [_floating, _setFloating] = $cQQee.useState(null);
    const setReference = $cQQee.useCallback((node)=>{
        if (node !== referenceRef.current) {
            referenceRef.current = node;
            _setReference(node);
        }
    }, []);
    const setFloating = $cQQee.useCallback((node)=>{
        if (node !== floatingRef.current) {
            floatingRef.current = node;
            _setFloating(node);
        }
    }, []);
    const referenceEl = externalReference || _reference;
    const floatingEl = externalFloating || _floating;
    const referenceRef = $cQQee.useRef(null);
    const floatingRef = $cQQee.useRef(null);
    const dataRef = $cQQee.useRef(data);
    const hasWhileElementsMounted = whileElementsMounted != null;
    const whileElementsMountedRef = $7f5afe61140090df$var$useLatestRef(whileElementsMounted);
    const platformRef = $7f5afe61140090df$var$useLatestRef(platform);
    const openRef = $7f5afe61140090df$var$useLatestRef(open);
    const update = $cQQee.useCallback(()=>{
        if (!referenceRef.current || !floatingRef.current) return;
        const config = {
            placement: placement,
            strategy: strategy,
            middleware: latestMiddleware
        };
        if (platformRef.current) config.platform = platformRef.current;
        (0, $6893d4083cc86ed8$export$48a53dcb22e581d0)(referenceRef.current, floatingRef.current, config).then((data)=>{
            const fullData = {
                ...data,
                // The floating element's position may be recomputed while it's closed
                // but still mounted (such as when transitioning out). To ensure
                // `isPositioned` will be `false` initially on the next open, avoid
                // setting it to `true` when `open === false` (must be specified).
                isPositioned: openRef.current !== false
            };
            if (isMountedRef.current && !$7f5afe61140090df$var$deepEqual(dataRef.current, fullData)) {
                dataRef.current = fullData;
                $kC364.flushSync(()=>{
                    setData(fullData);
                });
            }
        });
    }, [
        latestMiddleware,
        placement,
        strategy,
        platformRef,
        openRef
    ]);
    $7f5afe61140090df$var$index(()=>{
        if (open === false && dataRef.current.isPositioned) {
            dataRef.current.isPositioned = false;
            setData((data)=>({
                    ...data,
                    isPositioned: false
                }));
        }
    }, [
        open
    ]);
    const isMountedRef = $cQQee.useRef(false);
    $7f5afe61140090df$var$index(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    $7f5afe61140090df$var$index(()=>{
        if (referenceEl) referenceRef.current = referenceEl;
        if (floatingEl) floatingRef.current = floatingEl;
        if (referenceEl && floatingEl) {
            if (whileElementsMountedRef.current) return whileElementsMountedRef.current(referenceEl, floatingEl, update);
            update();
        }
    }, [
        referenceEl,
        floatingEl,
        update,
        whileElementsMountedRef,
        hasWhileElementsMounted
    ]);
    const refs = $cQQee.useMemo(()=>({
            reference: referenceRef,
            floating: floatingRef,
            setReference: setReference,
            setFloating: setFloating
        }), [
        setReference,
        setFloating
    ]);
    const elements = $cQQee.useMemo(()=>({
            reference: referenceEl,
            floating: floatingEl
        }), [
        referenceEl,
        floatingEl
    ]);
    const floatingStyles = $cQQee.useMemo(()=>{
        const initialStyles = {
            position: strategy,
            left: 0,
            top: 0
        };
        if (!elements.floating) return initialStyles;
        const x = $7f5afe61140090df$var$roundByDPR(elements.floating, data.x);
        const y = $7f5afe61140090df$var$roundByDPR(elements.floating, data.y);
        if (transform) return {
            ...initialStyles,
            transform: "translate(" + x + "px, " + y + "px)",
            ...$7f5afe61140090df$var$getDPR(elements.floating) >= 1.5 && {
                willChange: 'transform'
            }
        };
        return {
            position: strategy,
            left: x,
            top: y
        };
    }, [
        strategy,
        transform,
        elements.floating,
        data.x,
        data.y
    ]);
    return $cQQee.useMemo(()=>({
            ...data,
            update: update,
            refs: refs,
            elements: elements,
            floatingStyles: floatingStyles
        }), [
        data,
        update,
        refs,
        elements,
        floatingStyles
    ]);
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $7f5afe61140090df$var$arrow$1 = (options)=>{
    function isRef(value) {
        return ({}).hasOwnProperty.call(value, 'current');
    }
    return {
        name: 'arrow',
        options: options,
        fn (state) {
            const { element: element, padding: padding } = typeof options === 'function' ? options(state) : options;
            if (element && isRef(element)) {
                if (element.current != null) return (0, $6893d4083cc86ed8$export$f2120bbfa5450bd2)({
                    element: element.current,
                    padding: padding
                }).fn(state);
                return {};
            }
            if (element) return (0, $6893d4083cc86ed8$export$f2120bbfa5450bd2)({
                element: element,
                padding: padding
            }).fn(state);
            return {};
        }
    };
};
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $7f5afe61140090df$export$cc800923e997bb8 = (options, deps)=>({
        ...(0, $6893d4083cc86ed8$export$cc800923e997bb8)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $7f5afe61140090df$export$fba63a578e423eb = (options, deps)=>({
        ...(0, $6893d4083cc86ed8$export$fba63a578e423eb)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $7f5afe61140090df$export$7bf07e38f3dc4b69 = (options, deps)=>({
        ...(0, $6893d4083cc86ed8$export$7bf07e38f3dc4b69)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $7f5afe61140090df$export$8a83211c878a3f1f = (options, deps)=>({
        ...(0, $6893d4083cc86ed8$export$8a83211c878a3f1f)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $7f5afe61140090df$export$346677f925de839c = (options, deps)=>({
        ...(0, $6893d4083cc86ed8$export$346677f925de839c)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $7f5afe61140090df$export$fe8985bb6374093c = (options, deps)=>({
        ...(0, $6893d4083cc86ed8$export$fe8985bb6374093c)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $7f5afe61140090df$export$f2120bbfa5450bd2 = (options, deps)=>({
        ...$7f5afe61140090df$var$arrow$1(options),
        options: [
            options,
            deps
        ]
    });



var $cQQee = parcelRequire("cQQee");


// src/arrow.tsx
var $1c2c78819aad667c$var$NAME = "Arrow";
var $1c2c78819aad667c$export$21b07c8f274aebd5 = $cQQee.forwardRef((props, forwardedRef)=>{
    const { children: children, width: width = 10, height: height = 5, ...arrowProps } = props;
    return /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $f679bf6067493560$export$250ffa63cdc0d034).svg, {
        ...arrowProps,
        ref: forwardedRef,
        width: width,
        height: height,
        viewBox: "0 0 30 10",
        preserveAspectRatio: "none",
        children: props.asChild ? children : /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx("polygon", {
            points: "0,0 30,0 15,10"
        })
    });
});
$1c2c78819aad667c$export$21b07c8f274aebd5.displayName = $1c2c78819aad667c$var$NAME;
var $1c2c78819aad667c$export$be92b6f5f03c0fe9 = $1c2c78819aad667c$export$21b07c8f274aebd5;








var $cQQee = parcelRequire("cQQee");

// packages/react/use-size/src/use-size.tsx
function $dd793b2039b2c880$export$1ab7ae714698c4b8(element) {
    const [size, setSize] = $cQQee.useState(void 0);
    (0, $18ec559a74924a74$export$e5c5a5f917a5871c)(()=>{
        if (element) {
            setSize({
                width: element.offsetWidth,
                height: element.offsetHeight
            });
            const resizeObserver = new ResizeObserver((entries)=>{
                if (!Array.isArray(entries)) return;
                if (!entries.length) return;
                const entry = entries[0];
                let width;
                let height;
                if ("borderBoxSize" in entry) {
                    const borderSizeEntry = entry["borderBoxSize"];
                    const borderSize = Array.isArray(borderSizeEntry) ? borderSizeEntry[0] : borderSizeEntry;
                    width = borderSize["inlineSize"];
                    height = borderSize["blockSize"];
                } else {
                    width = element.offsetWidth;
                    height = element.offsetHeight;
                }
                setSize({
                    width: width,
                    height: height
                });
            });
            resizeObserver.observe(element, {
                box: "border-box"
            });
            return ()=>resizeObserver.unobserve(element);
        } else setSize(void 0);
    }, [
        element
    ]);
    return size;
}




var $90b52e5df71f6cb7$var$POPPER_NAME = "Popper";
var [$90b52e5df71f6cb7$var$createPopperContext, $90b52e5df71f6cb7$export$722aac194ae923] = (0, $f7850bc89e2b37d9$export$50c7b4e9d9f19c1)($90b52e5df71f6cb7$var$POPPER_NAME);
var [$90b52e5df71f6cb7$var$PopperProvider, $90b52e5df71f6cb7$var$usePopperContext] = $90b52e5df71f6cb7$var$createPopperContext($90b52e5df71f6cb7$var$POPPER_NAME);
var $90b52e5df71f6cb7$export$badac9ada3a0bdf9 = (props)=>{
    const { __scopePopper: __scopePopper, children: children } = props;
    const [anchor, setAnchor] = $cQQee.useState(null);
    return /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx($90b52e5df71f6cb7$var$PopperProvider, {
        scope: __scopePopper,
        anchor: anchor,
        onAnchorChange: setAnchor,
        children: children
    });
};
$90b52e5df71f6cb7$export$badac9ada3a0bdf9.displayName = $90b52e5df71f6cb7$var$POPPER_NAME;
var $90b52e5df71f6cb7$var$ANCHOR_NAME = "PopperAnchor";
var $90b52e5df71f6cb7$export$ecd4e1ccab6ed6d = $cQQee.forwardRef((props, forwardedRef)=>{
    const { __scopePopper: __scopePopper, virtualRef: virtualRef, ...anchorProps } = props;
    const context = $90b52e5df71f6cb7$var$usePopperContext($90b52e5df71f6cb7$var$ANCHOR_NAME, __scopePopper);
    const ref = $cQQee.useRef(null);
    const composedRefs = (0, $5565e7805f78287d$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    $cQQee.useEffect(()=>{
        context.onAnchorChange(virtualRef?.current || ref.current);
    });
    return virtualRef ? null : /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $f679bf6067493560$export$250ffa63cdc0d034).div, {
        ...anchorProps,
        ref: composedRefs
    });
});
$90b52e5df71f6cb7$export$ecd4e1ccab6ed6d.displayName = $90b52e5df71f6cb7$var$ANCHOR_NAME;
var $90b52e5df71f6cb7$var$CONTENT_NAME = "PopperContent";
var [$90b52e5df71f6cb7$var$PopperContentProvider, $90b52e5df71f6cb7$var$useContentContext] = $90b52e5df71f6cb7$var$createPopperContext($90b52e5df71f6cb7$var$CONTENT_NAME);
var $90b52e5df71f6cb7$export$bc4ae5855d3c4fc = $cQQee.forwardRef((props, forwardedRef)=>{
    const { __scopePopper: __scopePopper, side: side = "bottom", sideOffset: sideOffset = 0, align: align = "center", alignOffset: alignOffset = 0, arrowPadding: arrowPadding = 0, avoidCollisions: avoidCollisions = true, collisionBoundary: collisionBoundary = [], collisionPadding: collisionPaddingProp = 0, sticky: sticky = "partial", hideWhenDetached: hideWhenDetached = false, updatePositionStrategy: updatePositionStrategy = "optimized", onPlaced: onPlaced, ...contentProps } = props;
    const context = $90b52e5df71f6cb7$var$usePopperContext($90b52e5df71f6cb7$var$CONTENT_NAME, __scopePopper);
    const [content, setContent] = $cQQee.useState(null);
    const composedRefs = (0, $5565e7805f78287d$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setContent(node));
    const [arrow$1, setArrow] = $cQQee.useState(null);
    const arrowSize = (0, $dd793b2039b2c880$export$1ab7ae714698c4b8)(arrow$1);
    const arrowWidth = arrowSize?.width ?? 0;
    const arrowHeight = arrowSize?.height ?? 0;
    const desiredPlacement = side + (align !== "center" ? "-" + align : "");
    const collisionPadding = typeof collisionPaddingProp === "number" ? collisionPaddingProp : {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...collisionPaddingProp
    };
    const boundary = Array.isArray(collisionBoundary) ? collisionBoundary : [
        collisionBoundary
    ];
    const hasExplicitBoundaries = boundary.length > 0;
    const detectOverflowOptions = {
        padding: collisionPadding,
        boundary: boundary.filter($90b52e5df71f6cb7$var$isNotNull),
        // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
        altBoundary: hasExplicitBoundaries
    };
    const { refs: refs, floatingStyles: floatingStyles, placement: placement, isPositioned: isPositioned, middlewareData: middlewareData } = (0, $7f5afe61140090df$export$4e02a5c1d08bac65)({
        // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
        strategy: "fixed",
        placement: desiredPlacement,
        whileElementsMounted: (...args)=>{
            const cleanup = (0, $6893d4083cc86ed8$export$deee3a793edee05f)(...args, {
                animationFrame: updatePositionStrategy === "always"
            });
            return cleanup;
        },
        elements: {
            reference: context.anchor
        },
        middleware: [
            (0, $7f5afe61140090df$export$cc800923e997bb8)({
                mainAxis: sideOffset + arrowHeight,
                alignmentAxis: alignOffset
            }),
            avoidCollisions && (0, $7f5afe61140090df$export$fba63a578e423eb)({
                mainAxis: true,
                crossAxis: false,
                limiter: sticky === "partial" ? (0, $7f5afe61140090df$export$7bf07e38f3dc4b69)() : void 0,
                ...detectOverflowOptions
            }),
            avoidCollisions && (0, $7f5afe61140090df$export$8a83211c878a3f1f)({
                ...detectOverflowOptions
            }),
            (0, $7f5afe61140090df$export$346677f925de839c)({
                ...detectOverflowOptions,
                apply: ({ elements: elements, rects: rects, availableWidth: availableWidth, availableHeight: availableHeight })=>{
                    const { width: anchorWidth, height: anchorHeight } = rects.reference;
                    const contentStyle = elements.floating.style;
                    contentStyle.setProperty("--radix-popper-available-width", `${availableWidth}px`);
                    contentStyle.setProperty("--radix-popper-available-height", `${availableHeight}px`);
                    contentStyle.setProperty("--radix-popper-anchor-width", `${anchorWidth}px`);
                    contentStyle.setProperty("--radix-popper-anchor-height", `${anchorHeight}px`);
                }
            }),
            arrow$1 && (0, $7f5afe61140090df$export$f2120bbfa5450bd2)({
                element: arrow$1,
                padding: arrowPadding
            }),
            $90b52e5df71f6cb7$var$transformOrigin({
                arrowWidth: arrowWidth,
                arrowHeight: arrowHeight
            }),
            hideWhenDetached && (0, $7f5afe61140090df$export$fe8985bb6374093c)({
                strategy: "referenceHidden",
                ...detectOverflowOptions
            })
        ]
    });
    const [placedSide, placedAlign] = $90b52e5df71f6cb7$var$getSideAndAlignFromPlacement(placement);
    const handlePlaced = (0, $5188b0f5094d0afc$export$25bec8c6f54ee79a)(onPlaced);
    (0, $18ec559a74924a74$export$e5c5a5f917a5871c)(()=>{
        if (isPositioned) handlePlaced?.();
    }, [
        isPositioned,
        handlePlaced
    ]);
    const arrowX = middlewareData.arrow?.x;
    const arrowY = middlewareData.arrow?.y;
    const cannotCenterArrow = middlewareData.arrow?.centerOffset !== 0;
    const [contentZIndex, setContentZIndex] = $cQQee.useState();
    (0, $18ec559a74924a74$export$e5c5a5f917a5871c)(()=>{
        if (content) setContentZIndex(window.getComputedStyle(content).zIndex);
    }, [
        content
    ]);
    return /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx("div", {
        ref: refs.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
            ...floatingStyles,
            transform: isPositioned ? floatingStyles.transform : "translate(0, -200%)",
            // keep off the page when measuring
            minWidth: "max-content",
            zIndex: contentZIndex,
            ["--radix-popper-transform-origin"]: [
                middlewareData.transformOrigin?.x,
                middlewareData.transformOrigin?.y
            ].join(" "),
            // hide the content if using the hide middleware and should be hidden
            // set visibility to hidden and disable pointer events so the UI behaves
            // as if the PopperContent isn't there at all
            ...middlewareData.hide?.referenceHidden && {
                visibility: "hidden",
                pointerEvents: "none"
            }
        },
        dir: props.dir,
        children: /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx($90b52e5df71f6cb7$var$PopperContentProvider, {
            scope: __scopePopper,
            placedSide: placedSide,
            onArrowChange: setArrow,
            arrowX: arrowX,
            arrowY: arrowY,
            shouldHideArrow: cannotCenterArrow,
            children: /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $f679bf6067493560$export$250ffa63cdc0d034).div, {
                "data-side": placedSide,
                "data-align": placedAlign,
                ...contentProps,
                ref: composedRefs,
                style: {
                    ...contentProps.style,
                    // if the PopperContent hasn't been placed yet (not all measurements done)
                    // we prevent animations so that users's animation don't kick in too early referring wrong sides
                    animation: !isPositioned ? "none" : void 0
                }
            })
        })
    });
});
$90b52e5df71f6cb7$export$bc4ae5855d3c4fc.displayName = $90b52e5df71f6cb7$var$CONTENT_NAME;
var $90b52e5df71f6cb7$var$ARROW_NAME = "PopperArrow";
var $90b52e5df71f6cb7$var$OPPOSITE_SIDE = {
    top: "bottom",
    right: "left",
    bottom: "top",
    left: "right"
};
var $90b52e5df71f6cb7$export$79d62cd4e10a3fd0 = $cQQee.forwardRef(function PopperArrow2(props, forwardedRef) {
    const { __scopePopper: __scopePopper, ...arrowProps } = props;
    const contentContext = $90b52e5df71f6cb7$var$useContentContext($90b52e5df71f6cb7$var$ARROW_NAME, __scopePopper);
    const baseSide = $90b52e5df71f6cb7$var$OPPOSITE_SIDE[contentContext.placedSide];
    return(// we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx("span", {
        ref: contentContext.onArrowChange,
        style: {
            position: "absolute",
            left: contentContext.arrowX,
            top: contentContext.arrowY,
            [baseSide]: 0,
            transformOrigin: {
                top: "",
                right: "0 0",
                bottom: "center 0",
                left: "100% 0"
            }[contentContext.placedSide],
            transform: {
                top: "translateY(100%)",
                right: "translateY(50%) rotate(90deg) translateX(-50%)",
                bottom: `rotate(180deg)`,
                left: "translateY(50%) rotate(-90deg) translateX(50%)"
            }[contentContext.placedSide],
            visibility: contentContext.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $1c2c78819aad667c$export$be92b6f5f03c0fe9), {
            ...arrowProps,
            ref: forwardedRef,
            style: {
                ...arrowProps.style,
                // ensures the element can be measured correctly (mostly for if SVG)
                display: "block"
            }
        })
    }));
});
$90b52e5df71f6cb7$export$79d62cd4e10a3fd0.displayName = $90b52e5df71f6cb7$var$ARROW_NAME;
function $90b52e5df71f6cb7$var$isNotNull(value) {
    return value !== null;
}
var $90b52e5df71f6cb7$var$transformOrigin = (options)=>({
        name: "transformOrigin",
        options: options,
        fn (data) {
            const { placement: placement, rects: rects, middlewareData: middlewareData } = data;
            const cannotCenterArrow = middlewareData.arrow?.centerOffset !== 0;
            const isArrowHidden = cannotCenterArrow;
            const arrowWidth = isArrowHidden ? 0 : options.arrowWidth;
            const arrowHeight = isArrowHidden ? 0 : options.arrowHeight;
            const [placedSide, placedAlign] = $90b52e5df71f6cb7$var$getSideAndAlignFromPlacement(placement);
            const noArrowAlign = {
                start: "0%",
                center: "50%",
                end: "100%"
            }[placedAlign];
            const arrowXCenter = (middlewareData.arrow?.x ?? 0) + arrowWidth / 2;
            const arrowYCenter = (middlewareData.arrow?.y ?? 0) + arrowHeight / 2;
            let x = "";
            let y = "";
            if (placedSide === "bottom") {
                x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
                y = `${-arrowHeight}px`;
            } else if (placedSide === "top") {
                x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
                y = `${rects.floating.height + arrowHeight}px`;
            } else if (placedSide === "right") {
                x = `${-arrowHeight}px`;
                y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
            } else if (placedSide === "left") {
                x = `${rects.floating.width + arrowHeight}px`;
                y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
            }
            return {
                data: {
                    x: x,
                    y: y
                }
            };
        }
    });
function $90b52e5df71f6cb7$var$getSideAndAlignFromPlacement(placement) {
    const [side, align = "center"] = placement.split("-");
    return [
        side,
        align
    ];
}
var $90b52e5df71f6cb7$export$be92b6f5f03c0fe9 = $90b52e5df71f6cb7$export$badac9ada3a0bdf9;
var $90b52e5df71f6cb7$export$b688253958b8dfe7 = $90b52e5df71f6cb7$export$ecd4e1ccab6ed6d;
var $90b52e5df71f6cb7$export$7c6e2c02157bb7d2 = $90b52e5df71f6cb7$export$bc4ae5855d3c4fc;
var $90b52e5df71f6cb7$export$21b07c8f274aebd5 = $90b52e5df71f6cb7$export$79d62cd4e10a3fd0;



var $cQQee = parcelRequire("cQQee");

var $kC364 = parcelRequire("kC364");



var $1351f96eec88c257$var$PORTAL_NAME = "Portal";
var $1351f96eec88c257$export$602eac185826482c = $cQQee.forwardRef((props, forwardedRef)=>{
    const { container: containerProp, ...portalProps } = props;
    const [mounted, setMounted] = $cQQee.useState(false);
    (0, $18ec559a74924a74$export$e5c5a5f917a5871c)(()=>setMounted(true), []);
    const container = containerProp || mounted && globalThis?.document?.body;
    return container ? (0, (/*@__PURE__*/$parcel$interopDefault($kC364))).createPortal(/* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $f679bf6067493560$export$250ffa63cdc0d034).div, {
        ...portalProps,
        ref: forwardedRef
    }), container) : null;
});
$1351f96eec88c257$export$602eac185826482c.displayName = $1351f96eec88c257$var$PORTAL_NAME;



var $cQQee = parcelRequire("cQQee");


function $5061915239745df7$var$useStateMachine(initialState, machine) {
    return $cQQee.useReducer((state, event)=>{
        const nextState = machine[state][event];
        return nextState ?? state;
    }, initialState);
}
// src/presence.tsx
var $5061915239745df7$export$99c2b779aa4e8b8b = (props)=>{
    const { present: present, children: children } = props;
    const presence = $5061915239745df7$var$usePresence(present);
    const child = typeof children === "function" ? children({
        present: presence.isPresent
    }) : $cQQee.Children.only(children);
    const ref = (0, $5565e7805f78287d$export$c7b2cbe3552a0d05)(presence.ref, $5061915239745df7$var$getElementRef(child));
    const forceMount = typeof children === "function";
    return forceMount || presence.isPresent ? $cQQee.cloneElement(child, {
        ref: ref
    }) : null;
};
$5061915239745df7$export$99c2b779aa4e8b8b.displayName = "Presence";
function $5061915239745df7$var$usePresence(present) {
    const [node, setNode] = $cQQee.useState();
    const stylesRef = $cQQee.useRef(null);
    const prevPresentRef = $cQQee.useRef(present);
    const prevAnimationNameRef = $cQQee.useRef("none");
    const initialState = present ? "mounted" : "unmounted";
    const [state, send] = $5061915239745df7$var$useStateMachine(initialState, {
        mounted: {
            UNMOUNT: "unmounted",
            ANIMATION_OUT: "unmountSuspended"
        },
        unmountSuspended: {
            MOUNT: "mounted",
            ANIMATION_END: "unmounted"
        },
        unmounted: {
            MOUNT: "mounted"
        }
    });
    $cQQee.useEffect(()=>{
        const currentAnimationName = $5061915239745df7$var$getAnimationName(stylesRef.current);
        prevAnimationNameRef.current = state === "mounted" ? currentAnimationName : "none";
    }, [
        state
    ]);
    (0, $18ec559a74924a74$export$e5c5a5f917a5871c)(()=>{
        const styles = stylesRef.current;
        const wasPresent = prevPresentRef.current;
        const hasPresentChanged = wasPresent !== present;
        if (hasPresentChanged) {
            const prevAnimationName = prevAnimationNameRef.current;
            const currentAnimationName = $5061915239745df7$var$getAnimationName(styles);
            if (present) send("MOUNT");
            else if (currentAnimationName === "none" || styles?.display === "none") send("UNMOUNT");
            else {
                const isAnimating = prevAnimationName !== currentAnimationName;
                if (wasPresent && isAnimating) send("ANIMATION_OUT");
                else send("UNMOUNT");
            }
            prevPresentRef.current = present;
        }
    }, [
        present,
        send
    ]);
    (0, $18ec559a74924a74$export$e5c5a5f917a5871c)(()=>{
        if (node) {
            let timeoutId;
            const ownerWindow = node.ownerDocument.defaultView ?? window;
            const handleAnimationEnd = (event)=>{
                const currentAnimationName = $5061915239745df7$var$getAnimationName(stylesRef.current);
                const isCurrentAnimation = currentAnimationName.includes(event.animationName);
                if (event.target === node && isCurrentAnimation) {
                    send("ANIMATION_END");
                    if (!prevPresentRef.current) {
                        const currentFillMode = node.style.animationFillMode;
                        node.style.animationFillMode = "forwards";
                        timeoutId = ownerWindow.setTimeout(()=>{
                            if (node.style.animationFillMode === "forwards") node.style.animationFillMode = currentFillMode;
                        });
                    }
                }
            };
            const handleAnimationStart = (event)=>{
                if (event.target === node) prevAnimationNameRef.current = $5061915239745df7$var$getAnimationName(stylesRef.current);
            };
            node.addEventListener("animationstart", handleAnimationStart);
            node.addEventListener("animationcancel", handleAnimationEnd);
            node.addEventListener("animationend", handleAnimationEnd);
            return ()=>{
                ownerWindow.clearTimeout(timeoutId);
                node.removeEventListener("animationstart", handleAnimationStart);
                node.removeEventListener("animationcancel", handleAnimationEnd);
                node.removeEventListener("animationend", handleAnimationEnd);
            };
        } else send("ANIMATION_END");
    }, [
        node,
        send
    ]);
    return {
        isPresent: [
            "mounted",
            "unmountSuspended"
        ].includes(state),
        ref: $cQQee.useCallback((node2)=>{
            stylesRef.current = node2 ? getComputedStyle(node2) : null;
            setNode(node2);
        }, [])
    };
}
function $5061915239745df7$var$getAnimationName(styles) {
    return styles?.animationName || "none";
}
function $5061915239745df7$var$getElementRef(element) {
    let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}




var $cQQee = parcelRequire("cQQee");










var $e1ae38f5dc9abf75$var$ENTRY_FOCUS = "rovingFocusGroup.onEntryFocus";
var $e1ae38f5dc9abf75$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
var $e1ae38f5dc9abf75$var$GROUP_NAME = "RovingFocusGroup";
var [$e1ae38f5dc9abf75$var$Collection, $e1ae38f5dc9abf75$var$useCollection, $e1ae38f5dc9abf75$var$createCollectionScope] = (0, $731ecf065eed212e$export$c74125a8e3af6bb2)($e1ae38f5dc9abf75$var$GROUP_NAME);
var [$e1ae38f5dc9abf75$var$createRovingFocusGroupContext, $e1ae38f5dc9abf75$export$c7109489551a4f4] = (0, $f7850bc89e2b37d9$export$50c7b4e9d9f19c1)($e1ae38f5dc9abf75$var$GROUP_NAME, [
    $e1ae38f5dc9abf75$var$createCollectionScope
]);
var [$e1ae38f5dc9abf75$var$RovingFocusProvider, $e1ae38f5dc9abf75$var$useRovingFocusContext] = $e1ae38f5dc9abf75$var$createRovingFocusGroupContext($e1ae38f5dc9abf75$var$GROUP_NAME);
var $e1ae38f5dc9abf75$export$8699f7c8af148338 = $cQQee.forwardRef((props, forwardedRef)=>{
    return /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx($e1ae38f5dc9abf75$var$Collection.Provider, {
        scope: props.__scopeRovingFocusGroup,
        children: /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx($e1ae38f5dc9abf75$var$Collection.Slot, {
            scope: props.__scopeRovingFocusGroup,
            children: /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx($e1ae38f5dc9abf75$var$RovingFocusGroupImpl, {
                ...props,
                ref: forwardedRef
            })
        })
    });
});
$e1ae38f5dc9abf75$export$8699f7c8af148338.displayName = $e1ae38f5dc9abf75$var$GROUP_NAME;
var $e1ae38f5dc9abf75$var$RovingFocusGroupImpl = $cQQee.forwardRef((props, forwardedRef)=>{
    const { __scopeRovingFocusGroup: __scopeRovingFocusGroup, orientation: orientation, loop: loop = false, dir: dir, currentTabStopId: currentTabStopIdProp, defaultCurrentTabStopId: defaultCurrentTabStopId, onCurrentTabStopIdChange: onCurrentTabStopIdChange, onEntryFocus: onEntryFocus, preventScrollOnEntryFocus: preventScrollOnEntryFocus = false, ...groupProps } = props;
    const ref = $cQQee.useRef(null);
    const composedRefs = (0, $5565e7805f78287d$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const direction = (0, $7cc50a31b296c1eb$export$b39126d51d94e6f3)(dir);
    const [currentTabStopId, setCurrentTabStopId] = (0, $5525618e90d8a4e3$export$6f32135080cb4c3)({
        prop: currentTabStopIdProp,
        defaultProp: defaultCurrentTabStopId ?? null,
        onChange: onCurrentTabStopIdChange,
        caller: $e1ae38f5dc9abf75$var$GROUP_NAME
    });
    const [isTabbingBackOut, setIsTabbingBackOut] = $cQQee.useState(false);
    const handleEntryFocus = (0, $5188b0f5094d0afc$export$25bec8c6f54ee79a)(onEntryFocus);
    const getItems = $e1ae38f5dc9abf75$var$useCollection(__scopeRovingFocusGroup);
    const isClickFocusRef = $cQQee.useRef(false);
    const [focusableItemsCount, setFocusableItemsCount] = $cQQee.useState(0);
    $cQQee.useEffect(()=>{
        const node = ref.current;
        if (node) {
            node.addEventListener($e1ae38f5dc9abf75$var$ENTRY_FOCUS, handleEntryFocus);
            return ()=>node.removeEventListener($e1ae38f5dc9abf75$var$ENTRY_FOCUS, handleEntryFocus);
        }
    }, [
        handleEntryFocus
    ]);
    return /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx($e1ae38f5dc9abf75$var$RovingFocusProvider, {
        scope: __scopeRovingFocusGroup,
        orientation: orientation,
        dir: direction,
        loop: loop,
        currentTabStopId: currentTabStopId,
        onItemFocus: $cQQee.useCallback((tabStopId)=>setCurrentTabStopId(tabStopId), [
            setCurrentTabStopId
        ]),
        onItemShiftTab: $cQQee.useCallback(()=>setIsTabbingBackOut(true), []),
        onFocusableItemAdd: $cQQee.useCallback(()=>setFocusableItemsCount((prevCount)=>prevCount + 1), []),
        onFocusableItemRemove: $cQQee.useCallback(()=>setFocusableItemsCount((prevCount)=>prevCount - 1), []),
        children: /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $f679bf6067493560$export$250ffa63cdc0d034).div, {
            tabIndex: isTabbingBackOut || focusableItemsCount === 0 ? -1 : 0,
            "data-orientation": orientation,
            ...groupProps,
            ref: composedRefs,
            style: {
                outline: "none",
                ...props.style
            },
            onMouseDown: (0, $a6afd3c22f4adf72$export$b9ecd428b558ff10)(props.onMouseDown, ()=>{
                isClickFocusRef.current = true;
            }),
            onFocus: (0, $a6afd3c22f4adf72$export$b9ecd428b558ff10)(props.onFocus, (event)=>{
                const isKeyboardFocus = !isClickFocusRef.current;
                if (event.target === event.currentTarget && isKeyboardFocus && !isTabbingBackOut) {
                    const entryFocusEvent = new CustomEvent($e1ae38f5dc9abf75$var$ENTRY_FOCUS, $e1ae38f5dc9abf75$var$EVENT_OPTIONS);
                    event.currentTarget.dispatchEvent(entryFocusEvent);
                    if (!entryFocusEvent.defaultPrevented) {
                        const items = getItems().filter((item)=>item.focusable);
                        const activeItem = items.find((item)=>item.active);
                        const currentItem = items.find((item)=>item.id === currentTabStopId);
                        const candidateItems = [
                            activeItem,
                            currentItem,
                            ...items
                        ].filter(Boolean);
                        const candidateNodes = candidateItems.map((item)=>item.ref.current);
                        $e1ae38f5dc9abf75$var$focusFirst(candidateNodes, preventScrollOnEntryFocus);
                    }
                }
                isClickFocusRef.current = false;
            }),
            onBlur: (0, $a6afd3c22f4adf72$export$b9ecd428b558ff10)(props.onBlur, ()=>setIsTabbingBackOut(false))
        })
    });
});
var $e1ae38f5dc9abf75$var$ITEM_NAME = "RovingFocusGroupItem";
var $e1ae38f5dc9abf75$export$ab9df7c53fe8454 = $cQQee.forwardRef((props, forwardedRef)=>{
    const { __scopeRovingFocusGroup: __scopeRovingFocusGroup, focusable: focusable = true, active: active = false, tabStopId: tabStopId, children: children, ...itemProps } = props;
    const autoId = (0, $2a35bb07bdc6a9cb$export$f680877a34711e37)();
    const id = tabStopId || autoId;
    const context = $e1ae38f5dc9abf75$var$useRovingFocusContext($e1ae38f5dc9abf75$var$ITEM_NAME, __scopeRovingFocusGroup);
    const isCurrentTabStop = context.currentTabStopId === id;
    const getItems = $e1ae38f5dc9abf75$var$useCollection(__scopeRovingFocusGroup);
    const { onFocusableItemAdd: onFocusableItemAdd, onFocusableItemRemove: onFocusableItemRemove, currentTabStopId: currentTabStopId } = context;
    $cQQee.useEffect(()=>{
        if (focusable) {
            onFocusableItemAdd();
            return ()=>onFocusableItemRemove();
        }
    }, [
        focusable,
        onFocusableItemAdd,
        onFocusableItemRemove
    ]);
    return /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx($e1ae38f5dc9abf75$var$Collection.ItemSlot, {
        scope: __scopeRovingFocusGroup,
        id: id,
        focusable: focusable,
        active: active,
        children: /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $f679bf6067493560$export$250ffa63cdc0d034).span, {
            tabIndex: isCurrentTabStop ? 0 : -1,
            "data-orientation": context.orientation,
            ...itemProps,
            ref: forwardedRef,
            onMouseDown: (0, $a6afd3c22f4adf72$export$b9ecd428b558ff10)(props.onMouseDown, (event)=>{
                if (!focusable) event.preventDefault();
                else context.onItemFocus(id);
            }),
            onFocus: (0, $a6afd3c22f4adf72$export$b9ecd428b558ff10)(props.onFocus, ()=>context.onItemFocus(id)),
            onKeyDown: (0, $a6afd3c22f4adf72$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
                if (event.key === "Tab" && event.shiftKey) {
                    context.onItemShiftTab();
                    return;
                }
                if (event.target !== event.currentTarget) return;
                const focusIntent = $e1ae38f5dc9abf75$var$getFocusIntent(event, context.orientation, context.dir);
                if (focusIntent !== void 0) {
                    if (event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return;
                    event.preventDefault();
                    const items = getItems().filter((item)=>item.focusable);
                    let candidateNodes = items.map((item)=>item.ref.current);
                    if (focusIntent === "last") candidateNodes.reverse();
                    else if (focusIntent === "prev" || focusIntent === "next") {
                        if (focusIntent === "prev") candidateNodes.reverse();
                        const currentIndex = candidateNodes.indexOf(event.currentTarget);
                        candidateNodes = context.loop ? $e1ae38f5dc9abf75$var$wrapArray(candidateNodes, currentIndex + 1) : candidateNodes.slice(currentIndex + 1);
                    }
                    setTimeout(()=>$e1ae38f5dc9abf75$var$focusFirst(candidateNodes));
                }
            }),
            children: typeof children === "function" ? children({
                isCurrentTabStop: isCurrentTabStop,
                hasTabStop: currentTabStopId != null
            }) : children
        })
    });
});
$e1ae38f5dc9abf75$export$ab9df7c53fe8454.displayName = $e1ae38f5dc9abf75$var$ITEM_NAME;
var $e1ae38f5dc9abf75$var$MAP_KEY_TO_FOCUS_INTENT = {
    ArrowLeft: "prev",
    ArrowUp: "prev",
    ArrowRight: "next",
    ArrowDown: "next",
    PageUp: "first",
    Home: "first",
    PageDown: "last",
    End: "last"
};
function $e1ae38f5dc9abf75$var$getDirectionAwareKey(key, dir) {
    if (dir !== "rtl") return key;
    return key === "ArrowLeft" ? "ArrowRight" : key === "ArrowRight" ? "ArrowLeft" : key;
}
function $e1ae38f5dc9abf75$var$getFocusIntent(event, orientation, dir) {
    const key = $e1ae38f5dc9abf75$var$getDirectionAwareKey(event.key, dir);
    if (orientation === "vertical" && [
        "ArrowLeft",
        "ArrowRight"
    ].includes(key)) return void 0;
    if (orientation === "horizontal" && [
        "ArrowUp",
        "ArrowDown"
    ].includes(key)) return void 0;
    return $e1ae38f5dc9abf75$var$MAP_KEY_TO_FOCUS_INTENT[key];
}
function $e1ae38f5dc9abf75$var$focusFirst(candidates, preventScroll = false) {
    const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
    for (const candidate of candidates){
        if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
        candidate.focus({
            preventScroll: preventScroll
        });
        if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
    }
}
function $e1ae38f5dc9abf75$var$wrapArray(array, startIndex) {
    return array.map((_, index)=>array[(startIndex + index) % array.length]);
}
var $e1ae38f5dc9abf75$export$be92b6f5f03c0fe9 = $e1ae38f5dc9abf75$export$8699f7c8af148338;
var $e1ae38f5dc9abf75$export$6d08773d2e66f8f2 = $e1ae38f5dc9abf75$export$ab9df7c53fe8454;




var $a262c27d5452b164$var$getDefaultParent = function(originalTarget) {
    if (typeof document === 'undefined') return null;
    var sampleTarget = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
    return sampleTarget.ownerDocument.body;
};
var $a262c27d5452b164$var$counterMap = new WeakMap();
var $a262c27d5452b164$var$uncontrolledNodes = new WeakMap();
var $a262c27d5452b164$var$markerMap = {};
var $a262c27d5452b164$var$lockCount = 0;
var $a262c27d5452b164$var$unwrapHost = function(node) {
    return node && (node.host || $a262c27d5452b164$var$unwrapHost(node.parentNode));
};
var $a262c27d5452b164$var$correctTargets = function(parent, targets) {
    return targets.map(function(target) {
        if (parent.contains(target)) return target;
        var correctedTarget = $a262c27d5452b164$var$unwrapHost(target);
        if (correctedTarget && parent.contains(correctedTarget)) return correctedTarget;
        console.error('aria-hidden', target, 'in not contained inside', parent, '. Doing nothing');
        return null;
    }).filter(function(x) {
        return Boolean(x);
    });
};
/**
 * Marks everything except given node(or nodes) as aria-hidden
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @param {String} [controlAttribute] - html Attribute to control
 * @return {Undo} undo command
 */ var $a262c27d5452b164$var$applyAttributeToOthers = function(originalTarget, parentNode, markerName, controlAttribute) {
    var targets = $a262c27d5452b164$var$correctTargets(parentNode, Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    if (!$a262c27d5452b164$var$markerMap[markerName]) $a262c27d5452b164$var$markerMap[markerName] = new WeakMap();
    var markerCounter = $a262c27d5452b164$var$markerMap[markerName];
    var hiddenNodes = [];
    var elementsToKeep = new Set();
    var elementsToStop = new Set(targets);
    var keep = function(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        keep(el.parentNode);
    };
    targets.forEach(keep);
    var deep = function(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        Array.prototype.forEach.call(parent.children, function(node) {
            if (elementsToKeep.has(node)) deep(node);
            else try {
                var attr = node.getAttribute(controlAttribute);
                var alreadyHidden = attr !== null && attr !== 'false';
                var counterValue = ($a262c27d5452b164$var$counterMap.get(node) || 0) + 1;
                var markerValue = (markerCounter.get(node) || 0) + 1;
                $a262c27d5452b164$var$counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenNodes.push(node);
                if (counterValue === 1 && alreadyHidden) $a262c27d5452b164$var$uncontrolledNodes.set(node, true);
                if (markerValue === 1) node.setAttribute(markerName, 'true');
                if (!alreadyHidden) node.setAttribute(controlAttribute, 'true');
            } catch (e) {
                console.error('aria-hidden: cannot operate on ', node, e);
            }
        });
    };
    deep(parentNode);
    elementsToKeep.clear();
    $a262c27d5452b164$var$lockCount++;
    return function() {
        hiddenNodes.forEach(function(node) {
            var counterValue = $a262c27d5452b164$var$counterMap.get(node) - 1;
            var markerValue = markerCounter.get(node) - 1;
            $a262c27d5452b164$var$counterMap.set(node, counterValue);
            markerCounter.set(node, markerValue);
            if (!counterValue) {
                if (!$a262c27d5452b164$var$uncontrolledNodes.has(node)) node.removeAttribute(controlAttribute);
                $a262c27d5452b164$var$uncontrolledNodes.delete(node);
            }
            if (!markerValue) node.removeAttribute(markerName);
        });
        $a262c27d5452b164$var$lockCount--;
        if (!$a262c27d5452b164$var$lockCount) {
            // clear
            $a262c27d5452b164$var$counterMap = new WeakMap();
            $a262c27d5452b164$var$counterMap = new WeakMap();
            $a262c27d5452b164$var$uncontrolledNodes = new WeakMap();
            $a262c27d5452b164$var$markerMap = {};
        }
    };
};
/**
 * Marks everything except given node(or nodes) as aria-hidden
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @return {Undo} undo command
 */ var $a262c27d5452b164$export$6e33d16126ed003c = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = 'data-aria-hidden';
    var targets = Array.from(Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    var activeParentNode = $a262c27d5452b164$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    // we should not hide ariaLive elements - https://github.com/theKashey/aria-hidden/issues/10
    targets.push.apply(targets, Array.from(activeParentNode.querySelectorAll('[aria-live]')));
    return $a262c27d5452b164$var$applyAttributeToOthers(targets, activeParentNode, markerName, 'aria-hidden');
};


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $ff54387876abfcda$export$18ce0697a983be9b = function() {
    $ff54387876abfcda$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ff54387876abfcda$export$18ce0697a983be9b.apply(this, arguments);
};
function $ff54387876abfcda$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $ff54387876abfcda$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
typeof SuppressedError === "function" && SuppressedError;



var $cQQee = parcelRequire("cQQee");


var $cQQee = parcelRequire("cQQee");
var $883e689b04587636$export$1da7500147d4bc3 = 'right-scroll-bar-position';
var $883e689b04587636$export$898e37bbd2a0ae4e = 'width-before-scroll-bar';
var $883e689b04587636$export$bb813dfbbc432abc = 'with-scroll-bars-hidden';
/**
 * Name of a CSS variable containing the amount of "hidden" scrollbar
 * ! might be undefined ! use will fallback!
 */ var $883e689b04587636$export$63d0edf80fea83b1 = '--removed-body-scroll-bar-size';



function $6c79f38fc3dfbb1b$var$ItoI(a) {
    return a;
}
function $6c79f38fc3dfbb1b$var$innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = $6c79f38fc3dfbb1b$var$ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error('Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.');
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
// eslint-disable-next-line @typescript-eslint/ban-types
function $6c79f38fc3dfbb1b$export$e13ec7dd7a14088d(options) {
    if (options === void 0) options = {};
    var medium = $6c79f38fc3dfbb1b$var$innerCreateMedium(null);
    medium.options = (0, $ff54387876abfcda$export$18ce0697a983be9b)({
        async: true,
        ssr: false
    }, options);
    return medium;
}


var $4397ba3331631515$export$e27363444bedfeac = (0, $6c79f38fc3dfbb1b$export$e13ec7dd7a14088d)();



var $cQQee = parcelRequire("cQQee");
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $e798fdd9c2bd219c$export$d734136a7b018efe(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
    return ref;
}



var $cQQee = parcelRequire("cQQee");
/**
 * creates a MutableRef with ref change callback
 * @param initialValue - initial ref value
 * @param {Function} callback - a callback to run when value changes
 *
 * @example
 * const ref = useCallbackRef(0, (newValue, oldValue) => console.log(oldValue, '->', newValue);
 * ref.current = 1;
 * // prints 0 -> 1
 *
 * @see https://reactjs.org/docs/hooks-reference.html#useref
 * @see https://github.com/theKashey/use-callback-ref#usecallbackref---to-replace-reactuseref
 * @returns {MutableRefObject}
 */ function $31ab921a1fb4881c$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $cQQee.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}


var $c16861775c7cbb8b$var$useIsomorphicLayoutEffect = typeof window !== 'undefined' ? $cQQee.useLayoutEffect : $cQQee.useEffect;
var $c16861775c7cbb8b$var$currentValues = new WeakMap();
/**
 * Merges two or more refs together providing a single interface to set their value
 * @param {RefObject|Ref} refs
 * @returns {MutableRefObject} - a new ref, which translates all changes to {refs}
 *
 * @see {@link mergeRefs} a version without buit-in memoization
 * @see https://github.com/theKashey/use-callback-ref#usemergerefs
 * @example
 * const Component = React.forwardRef((props, ref) => {
 *   const ownRef = useRef();
 *   const domRef = useMergeRefs([ref, ownRef]); // 👈 merge together
 *   return <div ref={domRef}>...</div>
 * }
 */ function $c16861775c7cbb8b$export$74665b213cb5c4cf(refs, defaultValue) {
    var callbackRef = (0, $31ab921a1fb4881c$export$25bec8c6f54ee79a)(null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $e798fdd9c2bd219c$export$d734136a7b018efe)(ref, newValue);
        });
    });
    // handle refs changes - added or removed
    $c16861775c7cbb8b$var$useIsomorphicLayoutEffect(function() {
        var oldValue = $c16861775c7cbb8b$var$currentValues.get(callbackRef);
        if (oldValue) {
            var prevRefs_1 = new Set(oldValue);
            var nextRefs_1 = new Set(refs);
            var current_1 = callbackRef.current;
            prevRefs_1.forEach(function(ref) {
                if (!nextRefs_1.has(ref)) (0, $e798fdd9c2bd219c$export$d734136a7b018efe)(ref, null);
            });
            nextRefs_1.forEach(function(ref) {
                if (!prevRefs_1.has(ref)) (0, $e798fdd9c2bd219c$export$d734136a7b018efe)(ref, current_1);
            });
        }
        $c16861775c7cbb8b$var$currentValues.set(callbackRef, refs);
    }, [
        refs
    ]);
    return callbackRef;
}


var $517afd3554135303$var$nothing = function() {
    return;
};
/**
 * Removes scrollbar from the page and contain the scroll within the Lock
 */ var $517afd3554135303$export$22940b497e769dee = $cQQee.forwardRef(function(props, parentRef) {
    var ref = $cQQee.useRef(null);
    var _a = $cQQee.useState({
        onScrollCapture: $517afd3554135303$var$nothing,
        onWheelCapture: $517afd3554135303$var$nothing,
        onTouchMoveCapture: $517afd3554135303$var$nothing
    }), callbacks = _a[0], setCallbacks = _a[1];
    var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container = _b === void 0 ? 'div' : _b, gapMode = props.gapMode, rest = (0, $ff54387876abfcda$export$3c9a16f847548506)(props, [
        "forwardProps",
        "children",
        "className",
        "removeScrollBar",
        "enabled",
        "shards",
        "sideCar",
        "noIsolation",
        "inert",
        "allowPinchZoom",
        "as",
        "gapMode"
    ]);
    var SideCar = sideCar;
    var containerRef = (0, $c16861775c7cbb8b$export$74665b213cb5c4cf)([
        ref,
        parentRef
    ]);
    var containerProps = (0, $ff54387876abfcda$export$18ce0697a983be9b)((0, $ff54387876abfcda$export$18ce0697a983be9b)({}, rest), callbacks);
    return $cQQee.createElement($cQQee.Fragment, null, enabled && $cQQee.createElement(SideCar, {
        sideCar: (0, $4397ba3331631515$export$e27363444bedfeac),
        removeScrollBar: removeScrollBar,
        shards: shards,
        noIsolation: noIsolation,
        inert: inert,
        setCallbacks: setCallbacks,
        allowPinchZoom: !!allowPinchZoom,
        lockRef: ref,
        gapMode: gapMode
    }), forwardProps ? $cQQee.cloneElement($cQQee.Children.only(children), (0, $ff54387876abfcda$export$18ce0697a983be9b)((0, $ff54387876abfcda$export$18ce0697a983be9b)({}, containerProps), {
        ref: containerRef
    })) : $cQQee.createElement(Container, (0, $ff54387876abfcda$export$18ce0697a983be9b)({}, containerProps, {
        className: className,
        ref: containerRef
    }), children));
});
$517afd3554135303$export$22940b497e769dee.defaultProps = {
    enabled: true,
    removeScrollBar: true,
    inert: false
};
$517afd3554135303$export$22940b497e769dee.classNames = {
    fullWidth: (0, $883e689b04587636$export$898e37bbd2a0ae4e),
    zeroRight: (0, $883e689b04587636$export$1da7500147d4bc3)
};




var $cQQee = parcelRequire("cQQee");

var $cQQee = parcelRequire("cQQee");

var $cQQee = parcelRequire("cQQee");
var $5b2b793f28af7514$export$2b85b721e524d74b = function() {
    if (typeof __webpack_nonce__ !== 'undefined') return __webpack_nonce__;
    return undefined;
};


function $73a3a30b3a441151$var$makeStyleTag() {
    if (!document) return null;
    var tag = document.createElement('style');
    tag.type = 'text/css';
    var nonce = (0, $5b2b793f28af7514$export$2b85b721e524d74b)();
    if (nonce) tag.setAttribute('nonce', nonce);
    return tag;
}
function $73a3a30b3a441151$var$injectStyles(tag, css) {
    // @ts-ignore
    if (tag.styleSheet) // @ts-ignore
    tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $73a3a30b3a441151$var$insertStyleTag(tag) {
    var head = document.head || document.getElementsByTagName('head')[0];
    head.appendChild(tag);
}
var $73a3a30b3a441151$export$7c74eec858d5d226 = function() {
    var counter = 0;
    var stylesheet = null;
    return {
        add: function(style) {
            if (counter == 0) {
                if (stylesheet = $73a3a30b3a441151$var$makeStyleTag()) {
                    $73a3a30b3a441151$var$injectStyles(stylesheet, style);
                    $73a3a30b3a441151$var$insertStyleTag(stylesheet);
                }
            }
            counter++;
        },
        remove: function() {
            counter--;
            if (!counter && stylesheet) {
                stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
                stylesheet = null;
            }
        }
    };
};


/**
 * creates a hook to control style singleton
 * @see {@link styleSingleton} for a safer component version
 * @example
 * ```tsx
 * const useStyle = styleHookSingleton();
 * ///
 * useStyle('body { overflow: hidden}');
 */ var $3ab6774c3ac31450$export$7d7b35c2d250e94c = function() {
    var sheet = (0, $73a3a30b3a441151$export$7c74eec858d5d226)();
    return function(styles, isDynamic) {
        $cQQee.useEffect(function() {
            sheet.add(styles);
            return function() {
                sheet.remove();
            };
        }, [
            styles && isDynamic
        ]);
    };
};


/**
 * create a Component to add styles on demand
 * - styles are added when first instance is mounted
 * - styles are removed when the last instance is unmounted
 * - changing styles in runtime does nothing unless dynamic is set. But with multiple components that can lead to the undefined behavior
 */ var $641046ce2694817e$export$c1248ee86ba532c8 = function() {
    var useStyle = (0, $3ab6774c3ac31450$export$7d7b35c2d250e94c)();
    var Sheet = function(_a) {
        var styles = _a.styles, dynamic = _a.dynamic;
        useStyle(styles, dynamic);
        return null;
    };
    return Sheet;
};



var $18dc4f3d9730e1de$export$efed13b5d0ca3386 = {
    left: 0,
    top: 0,
    right: 0,
    gap: 0
};
var $18dc4f3d9730e1de$var$parse = function(x) {
    return parseInt(x || '', 10) || 0;
};
var $18dc4f3d9730e1de$var$getOffset = function(gapMode) {
    var cs = window.getComputedStyle(document.body);
    var left = cs[gapMode === 'padding' ? 'paddingLeft' : 'marginLeft'];
    var top = cs[gapMode === 'padding' ? 'paddingTop' : 'marginTop'];
    var right = cs[gapMode === 'padding' ? 'paddingRight' : 'marginRight'];
    return [
        $18dc4f3d9730e1de$var$parse(left),
        $18dc4f3d9730e1de$var$parse(top),
        $18dc4f3d9730e1de$var$parse(right)
    ];
};
var $18dc4f3d9730e1de$export$75f2ca8f029c77f4 = function(gapMode) {
    if (gapMode === void 0) gapMode = 'margin';
    if (typeof window === 'undefined') return $18dc4f3d9730e1de$export$efed13b5d0ca3386;
    var offsets = $18dc4f3d9730e1de$var$getOffset(gapMode);
    var documentWidth = document.documentElement.clientWidth;
    var windowWidth = window.innerWidth;
    return {
        left: offsets[0],
        top: offsets[1],
        right: offsets[2],
        gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0])
    };
};


var $53c34570ffc78c04$var$Style = (0, $641046ce2694817e$export$c1248ee86ba532c8)();
var $53c34570ffc78c04$export$65254d5f26cb9564 = 'data-scroll-locked';
// important tip - once we measure scrollBar width and remove them
// we could not repeat this operation
// thus we are using style-singleton - only the first "yet correct" style will be applied.
var $53c34570ffc78c04$var$getStyles = function(_a, allowRelative, gapMode, important) {
    var left = _a.left, top = _a.top, right = _a.right, gap = _a.gap;
    if (gapMode === void 0) gapMode = 'margin';
    return "\n  .".concat((0, $883e689b04587636$export$bb813dfbbc432abc), " {\n   overflow: hidden ").concat(important, ";\n   padding-right: ").concat(gap, "px ").concat(important, ";\n  }\n  body[").concat($53c34570ffc78c04$export$65254d5f26cb9564, "] {\n    overflow: hidden ").concat(important, ";\n    overscroll-behavior: contain;\n    ").concat([
        allowRelative && "position: relative ".concat(important, ";"),
        gapMode === 'margin' && "\n    padding-left: ".concat(left, "px;\n    padding-top: ").concat(top, "px;\n    padding-right: ").concat(right, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important, ";\n    "),
        gapMode === 'padding' && "padding-right: ".concat(gap, "px ").concat(important, ";")
    ].filter(Boolean).join(''), "\n  }\n  \n  .").concat((0, $883e689b04587636$export$1da7500147d4bc3), " {\n    right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $883e689b04587636$export$898e37bbd2a0ae4e), " {\n    margin-right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $883e689b04587636$export$1da7500147d4bc3), " .").concat((0, $883e689b04587636$export$1da7500147d4bc3), " {\n    right: 0 ").concat(important, ";\n  }\n  \n  .").concat((0, $883e689b04587636$export$898e37bbd2a0ae4e), " .").concat((0, $883e689b04587636$export$898e37bbd2a0ae4e), " {\n    margin-right: 0 ").concat(important, ";\n  }\n  \n  body[").concat($53c34570ffc78c04$export$65254d5f26cb9564, "] {\n    ").concat((0, $883e689b04587636$export$63d0edf80fea83b1), ": ").concat(gap, "px;\n  }\n");
};
var $53c34570ffc78c04$var$getCurrentUseCounter = function() {
    var counter = parseInt(document.body.getAttribute($53c34570ffc78c04$export$65254d5f26cb9564) || '0', 10);
    return isFinite(counter) ? counter : 0;
};
var $53c34570ffc78c04$export$a1939b1f9f9b02dc = function() {
    $cQQee.useEffect(function() {
        document.body.setAttribute($53c34570ffc78c04$export$65254d5f26cb9564, ($53c34570ffc78c04$var$getCurrentUseCounter() + 1).toString());
        return function() {
            var newCounter = $53c34570ffc78c04$var$getCurrentUseCounter() - 1;
            if (newCounter <= 0) document.body.removeAttribute($53c34570ffc78c04$export$65254d5f26cb9564);
            else document.body.setAttribute($53c34570ffc78c04$export$65254d5f26cb9564, newCounter.toString());
        };
    }, []);
};
/**
 * Removes page scrollbar and blocks page scroll when mounted
 */ var $53c34570ffc78c04$export$9aa43b459c5ae9b9 = function(_a) {
    var noRelative = _a.noRelative, noImportant = _a.noImportant, _b = _a.gapMode, gapMode = _b === void 0 ? 'margin' : _b;
    $53c34570ffc78c04$export$a1939b1f9f9b02dc();
    /*
     gap will be measured on every component mount
     however it will be used only by the "first" invocation
     due to singleton nature of <Style
     */ var gap = $cQQee.useMemo(function() {
        return (0, $18dc4f3d9730e1de$export$75f2ca8f029c77f4)(gapMode);
    }, [
        gapMode
    ]);
    return $cQQee.createElement($53c34570ffc78c04$var$Style, {
        styles: $53c34570ffc78c04$var$getStyles(gap, !noRelative, gapMode, !noImportant ? '!important' : '')
    });
};



var $473cb7ea6733d0bc$var$passiveSupported = false;
if (typeof window !== 'undefined') try {
    var $473cb7ea6733d0bc$var$options = Object.defineProperty({}, 'passive', {
        get: function() {
            $473cb7ea6733d0bc$var$passiveSupported = true;
            return true;
        }
    });
    // @ts-ignore
    window.addEventListener('test', $473cb7ea6733d0bc$var$options, $473cb7ea6733d0bc$var$options);
    // @ts-ignore
    window.removeEventListener('test', $473cb7ea6733d0bc$var$options, $473cb7ea6733d0bc$var$options);
} catch (err) {
    $473cb7ea6733d0bc$var$passiveSupported = false;
}
var $473cb7ea6733d0bc$export$10a6e88623fa9454 = $473cb7ea6733d0bc$var$passiveSupported ? {
    passive: false
} : false;


var $2def4b208ba681bb$var$alwaysContainsScroll = function(node) {
    // textarea will always _contain_ scroll inside self. It only can be hidden
    return node.tagName === 'TEXTAREA';
};
var $2def4b208ba681bb$var$elementCanBeScrolled = function(node, overflow) {
    if (!(node instanceof Element)) return false;
    var styles = window.getComputedStyle(node);
    return(// not-not-scrollable
    styles[overflow] !== 'hidden' && // contains scroll inside self
    !(styles.overflowY === styles.overflowX && !$2def4b208ba681bb$var$alwaysContainsScroll(node) && styles[overflow] === 'visible'));
};
var $2def4b208ba681bb$var$elementCouldBeVScrolled = function(node) {
    return $2def4b208ba681bb$var$elementCanBeScrolled(node, 'overflowY');
};
var $2def4b208ba681bb$var$elementCouldBeHScrolled = function(node) {
    return $2def4b208ba681bb$var$elementCanBeScrolled(node, 'overflowX');
};
var $2def4b208ba681bb$export$9ec64480cae49817 = function(axis, node) {
    var ownerDocument = node.ownerDocument;
    var current = node;
    do {
        // Skip over shadow root
        if (typeof ShadowRoot !== 'undefined' && current instanceof ShadowRoot) current = current.host;
        var isScrollable = $2def4b208ba681bb$var$elementCouldBeScrolled(axis, current);
        if (isScrollable) {
            var _a = $2def4b208ba681bb$var$getScrollVariables(axis, current), scrollHeight = _a[1], clientHeight = _a[2];
            if (scrollHeight > clientHeight) return true;
        }
        current = current.parentNode;
    }while (current && current !== ownerDocument.body);
    return false;
};
var $2def4b208ba681bb$var$getVScrollVariables = function(_a) {
    var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
    return [
        scrollTop,
        scrollHeight,
        clientHeight
    ];
};
var $2def4b208ba681bb$var$getHScrollVariables = function(_a) {
    var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
    return [
        scrollLeft,
        scrollWidth,
        clientWidth
    ];
};
var $2def4b208ba681bb$var$elementCouldBeScrolled = function(axis, node) {
    return axis === 'v' ? $2def4b208ba681bb$var$elementCouldBeVScrolled(node) : $2def4b208ba681bb$var$elementCouldBeHScrolled(node);
};
var $2def4b208ba681bb$var$getScrollVariables = function(axis, node) {
    return axis === 'v' ? $2def4b208ba681bb$var$getVScrollVariables(node) : $2def4b208ba681bb$var$getHScrollVariables(node);
};
var $2def4b208ba681bb$var$getDirectionFactor = function(axis, direction) {
    /**
     * If the element's direction is rtl (right-to-left), then scrollLeft is 0 when the scrollbar is at its rightmost position,
     * and then increasingly negative as you scroll towards the end of the content.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollLeft
     */ return axis === 'h' && direction === 'rtl' ? -1 : 1;
};
var $2def4b208ba681bb$export$dde0441bd4a6ded8 = function(axis, endTarget, event, sourceDelta, noOverscroll) {
    var directionFactor = $2def4b208ba681bb$var$getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
    var delta = directionFactor * sourceDelta;
    // find scrollable target
    var target = event.target;
    var targetInLock = endTarget.contains(target);
    var shouldCancelScroll = false;
    var isDeltaPositive = delta > 0;
    var availableScroll = 0;
    var availableScrollTop = 0;
    do {
        var _a = $2def4b208ba681bb$var$getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
        var elementScroll = scroll_1 - capacity - directionFactor * position;
        if (position || elementScroll) {
            if ($2def4b208ba681bb$var$elementCouldBeScrolled(axis, target)) {
                availableScroll += elementScroll;
                availableScrollTop += position;
            }
        }
        if (target instanceof ShadowRoot) target = target.host;
        else target = target.parentNode;
    }while (// portaled content
    !targetInLock && target !== document.body || // self content
    targetInLock && (endTarget.contains(target) || endTarget === target));
    // handle epsilon around 0 (non standard zoom levels)
    if (isDeltaPositive && (Math.abs(availableScroll) < 1 || false)) shouldCancelScroll = true;
    else if (!isDeltaPositive && (Math.abs(availableScrollTop) < 1 || false)) shouldCancelScroll = true;
    return shouldCancelScroll;
};


var $43e25a6b661277ea$export$6e085704a79f4f56 = function(event) {
    return 'changedTouches' in event ? [
        event.changedTouches[0].clientX,
        event.changedTouches[0].clientY
    ] : [
        0,
        0
    ];
};
var $43e25a6b661277ea$export$39efaa2ca254a28d = function(event) {
    return [
        event.deltaX,
        event.deltaY
    ];
};
var $43e25a6b661277ea$var$extractRef = function(ref) {
    return ref && 'current' in ref ? ref.current : ref;
};
var $43e25a6b661277ea$var$deltaCompare = function(x, y) {
    return x[0] === y[0] && x[1] === y[1];
};
var $43e25a6b661277ea$var$generateStyle = function(id) {
    return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n");
};
var $43e25a6b661277ea$var$idCounter = 0;
var $43e25a6b661277ea$var$lockStack = [];
function $43e25a6b661277ea$export$a09dbff87b5da2d(props) {
    var shouldPreventQueue = $cQQee.useRef([]);
    var touchStartRef = $cQQee.useRef([
        0,
        0
    ]);
    var activeAxis = $cQQee.useRef();
    var id = $cQQee.useState($43e25a6b661277ea$var$idCounter++)[0];
    var Style = $cQQee.useState((0, $641046ce2694817e$export$c1248ee86ba532c8))[0];
    var lastProps = $cQQee.useRef(props);
    $cQQee.useEffect(function() {
        lastProps.current = props;
    }, [
        props
    ]);
    $cQQee.useEffect(function() {
        if (props.inert) {
            document.body.classList.add("block-interactivity-".concat(id));
            var allow_1 = (0, $ff54387876abfcda$export$1216008129fb82ed)([
                props.lockRef.current
            ], (props.shards || []).map($43e25a6b661277ea$var$extractRef), true).filter(Boolean);
            allow_1.forEach(function(el) {
                return el.classList.add("allow-interactivity-".concat(id));
            });
            return function() {
                document.body.classList.remove("block-interactivity-".concat(id));
                allow_1.forEach(function(el) {
                    return el.classList.remove("allow-interactivity-".concat(id));
                });
            };
        }
        return;
    }, [
        props.inert,
        props.lockRef.current,
        props.shards
    ]);
    var shouldCancelEvent = $cQQee.useCallback(function(event, parent) {
        if ('touches' in event && event.touches.length === 2 || event.type === 'wheel' && event.ctrlKey) return !lastProps.current.allowPinchZoom;
        var touch = $43e25a6b661277ea$export$6e085704a79f4f56(event);
        var touchStart = touchStartRef.current;
        var deltaX = 'deltaX' in event ? event.deltaX : touchStart[0] - touch[0];
        var deltaY = 'deltaY' in event ? event.deltaY : touchStart[1] - touch[1];
        var currentAxis;
        var target = event.target;
        var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? 'h' : 'v';
        // allow horizontal touch move on Range inputs. They will not cause any scroll
        if ('touches' in event && moveDirection === 'h' && target.type === 'range') return false;
        var canBeScrolledInMainDirection = (0, $2def4b208ba681bb$export$9ec64480cae49817)(moveDirection, target);
        if (!canBeScrolledInMainDirection) return true;
        if (canBeScrolledInMainDirection) currentAxis = moveDirection;
        else {
            currentAxis = moveDirection === 'v' ? 'h' : 'v';
            canBeScrolledInMainDirection = (0, $2def4b208ba681bb$export$9ec64480cae49817)(moveDirection, target);
        // other axis might be not scrollable
        }
        if (!canBeScrolledInMainDirection) return false;
        if (!activeAxis.current && 'changedTouches' in event && (deltaX || deltaY)) activeAxis.current = currentAxis;
        if (!currentAxis) return true;
        var cancelingAxis = activeAxis.current || currentAxis;
        return (0, $2def4b208ba681bb$export$dde0441bd4a6ded8)(cancelingAxis, parent, event, cancelingAxis === 'h' ? deltaX : deltaY);
    }, []);
    var shouldPrevent = $cQQee.useCallback(function(_event) {
        var event = _event;
        if (!$43e25a6b661277ea$var$lockStack.length || $43e25a6b661277ea$var$lockStack[$43e25a6b661277ea$var$lockStack.length - 1] !== Style) // not the last active
        return;
        var delta = 'deltaY' in event ? $43e25a6b661277ea$export$39efaa2ca254a28d(event) : $43e25a6b661277ea$export$6e085704a79f4f56(event);
        var sourceEvent = shouldPreventQueue.current.filter(function(e) {
            return e.name === event.type && (e.target === event.target || event.target === e.shadowParent) && $43e25a6b661277ea$var$deltaCompare(e.delta, delta);
        })[0];
        // self event, and should be canceled
        if (sourceEvent && sourceEvent.should) {
            if (event.cancelable) event.preventDefault();
            return;
        }
        // outside or shard event
        if (!sourceEvent) {
            var shardNodes = (lastProps.current.shards || []).map($43e25a6b661277ea$var$extractRef).filter(Boolean).filter(function(node) {
                return node.contains(event.target);
            });
            var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
            if (shouldStop) {
                if (event.cancelable) event.preventDefault();
            }
        }
    }, []);
    var shouldCancel = $cQQee.useCallback(function(name, delta, target, should) {
        var event = {
            name: name,
            delta: delta,
            target: target,
            should: should,
            shadowParent: $43e25a6b661277ea$var$getOutermostShadowParent(target)
        };
        shouldPreventQueue.current.push(event);
        setTimeout(function() {
            shouldPreventQueue.current = shouldPreventQueue.current.filter(function(e) {
                return e !== event;
            });
        }, 1);
    }, []);
    var scrollTouchStart = $cQQee.useCallback(function(event) {
        touchStartRef.current = $43e25a6b661277ea$export$6e085704a79f4f56(event);
        activeAxis.current = undefined;
    }, []);
    var scrollWheel = $cQQee.useCallback(function(event) {
        shouldCancel(event.type, $43e25a6b661277ea$export$39efaa2ca254a28d(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    var scrollTouchMove = $cQQee.useCallback(function(event) {
        shouldCancel(event.type, $43e25a6b661277ea$export$6e085704a79f4f56(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    $cQQee.useEffect(function() {
        $43e25a6b661277ea$var$lockStack.push(Style);
        props.setCallbacks({
            onScrollCapture: scrollWheel,
            onWheelCapture: scrollWheel,
            onTouchMoveCapture: scrollTouchMove
        });
        document.addEventListener('wheel', shouldPrevent, (0, $473cb7ea6733d0bc$export$10a6e88623fa9454));
        document.addEventListener('touchmove', shouldPrevent, (0, $473cb7ea6733d0bc$export$10a6e88623fa9454));
        document.addEventListener('touchstart', scrollTouchStart, (0, $473cb7ea6733d0bc$export$10a6e88623fa9454));
        return function() {
            $43e25a6b661277ea$var$lockStack = $43e25a6b661277ea$var$lockStack.filter(function(inst) {
                return inst !== Style;
            });
            document.removeEventListener('wheel', shouldPrevent, (0, $473cb7ea6733d0bc$export$10a6e88623fa9454));
            document.removeEventListener('touchmove', shouldPrevent, (0, $473cb7ea6733d0bc$export$10a6e88623fa9454));
            document.removeEventListener('touchstart', scrollTouchStart, (0, $473cb7ea6733d0bc$export$10a6e88623fa9454));
        };
    }, []);
    var removeScrollBar = props.removeScrollBar, inert = props.inert;
    return $cQQee.createElement($cQQee.Fragment, null, inert ? $cQQee.createElement(Style, {
        styles: $43e25a6b661277ea$var$generateStyle(id)
    }) : null, removeScrollBar ? $cQQee.createElement((0, $53c34570ffc78c04$export$9aa43b459c5ae9b9), {
        gapMode: props.gapMode
    }) : null);
}
function $43e25a6b661277ea$var$getOutermostShadowParent(node) {
    var shadowParent = null;
    while(node !== null){
        if (node instanceof ShadowRoot) {
            shadowParent = node.host;
            node = node.host;
        }
        node = node.parentNode;
    }
    return shadowParent;
}





var $cQQee = parcelRequire("cQQee");
var $7fa3e6f849350b5a$var$SideCar = function(_a) {
    var sideCar = _a.sideCar, rest = (0, $ff54387876abfcda$export$3c9a16f847548506)(_a, [
        "sideCar"
    ]);
    if (!sideCar) throw new Error('Sidecar: please provide `sideCar` property to import the right car');
    var Target = sideCar.read();
    if (!Target) throw new Error('Sidecar medium not found');
    return $cQQee.createElement(Target, (0, $ff54387876abfcda$export$18ce0697a983be9b)({}, rest));
};
$7fa3e6f849350b5a$var$SideCar.isSideCarExport = true;
function $7fa3e6f849350b5a$export$6cacc8fb0a9b94ce(medium, exported) {
    medium.useMedium(exported);
    return $7fa3e6f849350b5a$var$SideCar;
}


var $aac7493b55ad7f26$export$2e2bcd8739ae039 = (0, $7fa3e6f849350b5a$export$6cacc8fb0a9b94ce)((0, $4397ba3331631515$export$e27363444bedfeac), (0, $43e25a6b661277ea$export$a09dbff87b5da2d));


var $c10ec145eb399856$export$2e2bcd8739ae039 = $cQQee.forwardRef(function(props, ref) {
    return $cQQee.createElement((0, $517afd3554135303$export$22940b497e769dee), (0, $ff54387876abfcda$export$18ce0697a983be9b)({}, props, {
        ref: ref,
        sideCar: (0, $aac7493b55ad7f26$export$2e2bcd8739ae039)
    }));
});
$c10ec145eb399856$export$2e2bcd8739ae039.classNames = (0, $517afd3554135303$export$22940b497e769dee).classNames;



var $d239a2fd778c1d9c$var$SELECTION_KEYS = [
    "Enter",
    " "
];
var $d239a2fd778c1d9c$var$FIRST_KEYS = [
    "ArrowDown",
    "PageUp",
    "Home"
];
var $d239a2fd778c1d9c$var$LAST_KEYS = [
    "ArrowUp",
    "PageDown",
    "End"
];
var $d239a2fd778c1d9c$var$FIRST_LAST_KEYS = [
    ...$d239a2fd778c1d9c$var$FIRST_KEYS,
    ...$d239a2fd778c1d9c$var$LAST_KEYS
];
var $d239a2fd778c1d9c$var$SUB_OPEN_KEYS = {
    ltr: [
        ...$d239a2fd778c1d9c$var$SELECTION_KEYS,
        "ArrowRight"
    ],
    rtl: [
        ...$d239a2fd778c1d9c$var$SELECTION_KEYS,
        "ArrowLeft"
    ]
};
var $d239a2fd778c1d9c$var$SUB_CLOSE_KEYS = {
    ltr: [
        "ArrowLeft"
    ],
    rtl: [
        "ArrowRight"
    ]
};
var $d239a2fd778c1d9c$var$MENU_NAME = "Menu";
var [$d239a2fd778c1d9c$var$Collection, $d239a2fd778c1d9c$var$useCollection, $d239a2fd778c1d9c$var$createCollectionScope] = (0, $731ecf065eed212e$export$c74125a8e3af6bb2)($d239a2fd778c1d9c$var$MENU_NAME);
var [$d239a2fd778c1d9c$var$createMenuContext, $d239a2fd778c1d9c$export$4027731b685e72eb] = (0, $f7850bc89e2b37d9$export$50c7b4e9d9f19c1)($d239a2fd778c1d9c$var$MENU_NAME, [
    $d239a2fd778c1d9c$var$createCollectionScope,
    (0, $90b52e5df71f6cb7$export$722aac194ae923),
    (0, $e1ae38f5dc9abf75$export$c7109489551a4f4)
]);
var $d239a2fd778c1d9c$var$usePopperScope = (0, $90b52e5df71f6cb7$export$722aac194ae923)();
var $d239a2fd778c1d9c$var$useRovingFocusGroupScope = (0, $e1ae38f5dc9abf75$export$c7109489551a4f4)();
var [$d239a2fd778c1d9c$var$MenuProvider, $d239a2fd778c1d9c$var$useMenuContext] = $d239a2fd778c1d9c$var$createMenuContext($d239a2fd778c1d9c$var$MENU_NAME);
var [$d239a2fd778c1d9c$var$MenuRootProvider, $d239a2fd778c1d9c$var$useMenuRootContext] = $d239a2fd778c1d9c$var$createMenuContext($d239a2fd778c1d9c$var$MENU_NAME);
var $d239a2fd778c1d9c$export$d9b273488cd8ce6f = (props)=>{
    const { __scopeMenu: __scopeMenu, open: open = false, children: children, dir: dir, onOpenChange: onOpenChange, modal: modal = true } = props;
    const popperScope = $d239a2fd778c1d9c$var$usePopperScope(__scopeMenu);
    const [content, setContent] = $cQQee.useState(null);
    const isUsingKeyboardRef = $cQQee.useRef(false);
    const handleOpenChange = (0, $5188b0f5094d0afc$export$25bec8c6f54ee79a)(onOpenChange);
    const direction = (0, $7cc50a31b296c1eb$export$b39126d51d94e6f3)(dir);
    $cQQee.useEffect(()=>{
        const handleKeyDown = ()=>{
            isUsingKeyboardRef.current = true;
            document.addEventListener("pointerdown", handlePointer, {
                capture: true,
                once: true
            });
            document.addEventListener("pointermove", handlePointer, {
                capture: true,
                once: true
            });
        };
        const handlePointer = ()=>isUsingKeyboardRef.current = false;
        document.addEventListener("keydown", handleKeyDown, {
            capture: true
        });
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown, {
                capture: true
            });
            document.removeEventListener("pointerdown", handlePointer, {
                capture: true
            });
            document.removeEventListener("pointermove", handlePointer, {
                capture: true
            });
        };
    }, []);
    return /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $90b52e5df71f6cb7$export$be92b6f5f03c0fe9), {
        ...popperScope,
        children: /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx($d239a2fd778c1d9c$var$MenuProvider, {
            scope: __scopeMenu,
            open: open,
            onOpenChange: handleOpenChange,
            content: content,
            onContentChange: setContent,
            children: /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx($d239a2fd778c1d9c$var$MenuRootProvider, {
                scope: __scopeMenu,
                onClose: $cQQee.useCallback(()=>handleOpenChange(false), [
                    handleOpenChange
                ]),
                isUsingKeyboardRef: isUsingKeyboardRef,
                dir: direction,
                modal: modal,
                children: children
            })
        })
    });
};
$d239a2fd778c1d9c$export$d9b273488cd8ce6f.displayName = $d239a2fd778c1d9c$var$MENU_NAME;
var $d239a2fd778c1d9c$var$ANCHOR_NAME = "MenuAnchor";
var $d239a2fd778c1d9c$export$9fa5ebd18bee4d43 = $cQQee.forwardRef((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu, ...anchorProps } = props;
    const popperScope = $d239a2fd778c1d9c$var$usePopperScope(__scopeMenu);
    return /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $90b52e5df71f6cb7$export$b688253958b8dfe7), {
        ...popperScope,
        ...anchorProps,
        ref: forwardedRef
    });
});
$d239a2fd778c1d9c$export$9fa5ebd18bee4d43.displayName = $d239a2fd778c1d9c$var$ANCHOR_NAME;
var $d239a2fd778c1d9c$var$PORTAL_NAME = "MenuPortal";
var [$d239a2fd778c1d9c$var$PortalProvider, $d239a2fd778c1d9c$var$usePortalContext] = $d239a2fd778c1d9c$var$createMenuContext($d239a2fd778c1d9c$var$PORTAL_NAME, {
    forceMount: void 0
});
var $d239a2fd778c1d9c$export$793392f970497feb = (props)=>{
    const { __scopeMenu: __scopeMenu, forceMount: forceMount, children: children, container: container } = props;
    const context = $d239a2fd778c1d9c$var$useMenuContext($d239a2fd778c1d9c$var$PORTAL_NAME, __scopeMenu);
    return /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx($d239a2fd778c1d9c$var$PortalProvider, {
        scope: __scopeMenu,
        forceMount: forceMount,
        children: /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $5061915239745df7$export$99c2b779aa4e8b8b), {
            present: forceMount || context.open,
            children: /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $1351f96eec88c257$export$602eac185826482c), {
                asChild: true,
                container: container,
                children: children
            })
        })
    });
};
$d239a2fd778c1d9c$export$793392f970497feb.displayName = $d239a2fd778c1d9c$var$PORTAL_NAME;
var $d239a2fd778c1d9c$var$CONTENT_NAME = "MenuContent";
var [$d239a2fd778c1d9c$var$MenuContentProvider, $d239a2fd778c1d9c$var$useMenuContentContext] = $d239a2fd778c1d9c$var$createMenuContext($d239a2fd778c1d9c$var$CONTENT_NAME);
var $d239a2fd778c1d9c$export$479f0f2f71193efe = $cQQee.forwardRef((props, forwardedRef)=>{
    const portalContext = $d239a2fd778c1d9c$var$usePortalContext($d239a2fd778c1d9c$var$CONTENT_NAME, props.__scopeMenu);
    const { forceMount: forceMount = portalContext.forceMount, ...contentProps } = props;
    const context = $d239a2fd778c1d9c$var$useMenuContext($d239a2fd778c1d9c$var$CONTENT_NAME, props.__scopeMenu);
    const rootContext = $d239a2fd778c1d9c$var$useMenuRootContext($d239a2fd778c1d9c$var$CONTENT_NAME, props.__scopeMenu);
    return /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx($d239a2fd778c1d9c$var$Collection.Provider, {
        scope: props.__scopeMenu,
        children: /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $5061915239745df7$export$99c2b779aa4e8b8b), {
            present: forceMount || context.open,
            children: /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx($d239a2fd778c1d9c$var$Collection.Slot, {
                scope: props.__scopeMenu,
                children: rootContext.modal ? /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx($d239a2fd778c1d9c$var$MenuRootContentModal, {
                    ...contentProps,
                    ref: forwardedRef
                }) : /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx($d239a2fd778c1d9c$var$MenuRootContentNonModal, {
                    ...contentProps,
                    ref: forwardedRef
                })
            })
        })
    });
});
var $d239a2fd778c1d9c$var$MenuRootContentModal = $cQQee.forwardRef((props, forwardedRef)=>{
    const context = $d239a2fd778c1d9c$var$useMenuContext($d239a2fd778c1d9c$var$CONTENT_NAME, props.__scopeMenu);
    const ref = $cQQee.useRef(null);
    const composedRefs = (0, $5565e7805f78287d$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    $cQQee.useEffect(()=>{
        const content = ref.current;
        if (content) return (0, $a262c27d5452b164$export$6e33d16126ed003c)(content);
    }, []);
    return /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx($d239a2fd778c1d9c$var$MenuContentImpl, {
        ...props,
        ref: composedRefs,
        trapFocus: context.open,
        disableOutsidePointerEvents: context.open,
        disableOutsideScroll: true,
        onFocusOutside: (0, $a6afd3c22f4adf72$export$b9ecd428b558ff10)(props.onFocusOutside, (event)=>event.preventDefault(), {
            checkForDefaultPrevented: false
        }),
        onDismiss: ()=>context.onOpenChange(false)
    });
});
var $d239a2fd778c1d9c$var$MenuRootContentNonModal = $cQQee.forwardRef((props, forwardedRef)=>{
    const context = $d239a2fd778c1d9c$var$useMenuContext($d239a2fd778c1d9c$var$CONTENT_NAME, props.__scopeMenu);
    return /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx($d239a2fd778c1d9c$var$MenuContentImpl, {
        ...props,
        ref: forwardedRef,
        trapFocus: false,
        disableOutsidePointerEvents: false,
        disableOutsideScroll: false,
        onDismiss: ()=>context.onOpenChange(false)
    });
});
var $d239a2fd778c1d9c$var$Slot = (0, $050d5aa66f6347e9$export$e88b45bda5c13eb9)("MenuContent.ScrollLock");
var $d239a2fd778c1d9c$var$MenuContentImpl = $cQQee.forwardRef((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu, loop: loop = false, trapFocus: trapFocus, onOpenAutoFocus: onOpenAutoFocus, onCloseAutoFocus: onCloseAutoFocus, disableOutsidePointerEvents: disableOutsidePointerEvents, onEntryFocus: onEntryFocus, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, onFocusOutside: onFocusOutside, onInteractOutside: onInteractOutside, onDismiss: onDismiss, disableOutsideScroll: disableOutsideScroll, ...contentProps } = props;
    const context = $d239a2fd778c1d9c$var$useMenuContext($d239a2fd778c1d9c$var$CONTENT_NAME, __scopeMenu);
    const rootContext = $d239a2fd778c1d9c$var$useMenuRootContext($d239a2fd778c1d9c$var$CONTENT_NAME, __scopeMenu);
    const popperScope = $d239a2fd778c1d9c$var$usePopperScope(__scopeMenu);
    const rovingFocusGroupScope = $d239a2fd778c1d9c$var$useRovingFocusGroupScope(__scopeMenu);
    const getItems = $d239a2fd778c1d9c$var$useCollection(__scopeMenu);
    const [currentItemId, setCurrentItemId] = $cQQee.useState(null);
    const contentRef = $cQQee.useRef(null);
    const composedRefs = (0, $5565e7805f78287d$export$c7b2cbe3552a0d05)(forwardedRef, contentRef, context.onContentChange);
    const timerRef = $cQQee.useRef(0);
    const searchRef = $cQQee.useRef("");
    const pointerGraceTimerRef = $cQQee.useRef(0);
    const pointerGraceIntentRef = $cQQee.useRef(null);
    const pointerDirRef = $cQQee.useRef("right");
    const lastPointerXRef = $cQQee.useRef(0);
    const ScrollLockWrapper = disableOutsideScroll ? (0, $c10ec145eb399856$export$2e2bcd8739ae039) : $cQQee.Fragment;
    const scrollLockWrapperProps = disableOutsideScroll ? {
        as: $d239a2fd778c1d9c$var$Slot,
        allowPinchZoom: true
    } : void 0;
    const handleTypeaheadSearch = (key)=>{
        const search = searchRef.current + key;
        const items = getItems().filter((item)=>!item.disabled);
        const currentItem = document.activeElement;
        const currentMatch = items.find((item)=>item.ref.current === currentItem)?.textValue;
        const values = items.map((item)=>item.textValue);
        const nextMatch = $d239a2fd778c1d9c$var$getNextMatch(values, search, currentMatch);
        const newItem = items.find((item)=>item.textValue === nextMatch)?.ref.current;
        (function updateSearch(value) {
            searchRef.current = value;
            window.clearTimeout(timerRef.current);
            if (value !== "") timerRef.current = window.setTimeout(()=>updateSearch(""), 1e3);
        })(search);
        if (newItem) setTimeout(()=>newItem.focus());
    };
    $cQQee.useEffect(()=>{
        return ()=>window.clearTimeout(timerRef.current);
    }, []);
    (0, $2901e484e8d3cb24$export$b7ece24a22aeda8c)();
    const isPointerMovingToSubmenu = $cQQee.useCallback((event)=>{
        const isMovingTowards = pointerDirRef.current === pointerGraceIntentRef.current?.side;
        return isMovingTowards && $d239a2fd778c1d9c$var$isPointerInGraceArea(event, pointerGraceIntentRef.current?.area);
    }, []);
    return /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx($d239a2fd778c1d9c$var$MenuContentProvider, {
        scope: __scopeMenu,
        searchRef: searchRef,
        onItemEnter: $cQQee.useCallback((event)=>{
            if (isPointerMovingToSubmenu(event)) event.preventDefault();
        }, [
            isPointerMovingToSubmenu
        ]),
        onItemLeave: $cQQee.useCallback((event)=>{
            if (isPointerMovingToSubmenu(event)) return;
            contentRef.current?.focus();
            setCurrentItemId(null);
        }, [
            isPointerMovingToSubmenu
        ]),
        onTriggerLeave: $cQQee.useCallback((event)=>{
            if (isPointerMovingToSubmenu(event)) event.preventDefault();
        }, [
            isPointerMovingToSubmenu
        ]),
        pointerGraceTimerRef: pointerGraceTimerRef,
        onPointerGraceIntentChange: $cQQee.useCallback((intent)=>{
            pointerGraceIntentRef.current = intent;
        }, []),
        children: /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx(ScrollLockWrapper, {
            ...scrollLockWrapperProps,
            children: /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $071a7a863660ec8d$export$20e40289641fbbb6), {
                asChild: true,
                trapped: trapFocus,
                onMountAutoFocus: (0, $a6afd3c22f4adf72$export$b9ecd428b558ff10)(onOpenAutoFocus, (event)=>{
                    event.preventDefault();
                    contentRef.current?.focus({
                        preventScroll: true
                    });
                }),
                onUnmountAutoFocus: onCloseAutoFocus,
                children: /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $cee95a2911ba3da8$export$177fb62ff3ec1f22), {
                    asChild: true,
                    disableOutsidePointerEvents: disableOutsidePointerEvents,
                    onEscapeKeyDown: onEscapeKeyDown,
                    onPointerDownOutside: onPointerDownOutside,
                    onFocusOutside: onFocusOutside,
                    onInteractOutside: onInteractOutside,
                    onDismiss: onDismiss,
                    children: /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $e1ae38f5dc9abf75$export$be92b6f5f03c0fe9), {
                        asChild: true,
                        ...rovingFocusGroupScope,
                        dir: rootContext.dir,
                        orientation: "vertical",
                        loop: loop,
                        currentTabStopId: currentItemId,
                        onCurrentTabStopIdChange: setCurrentItemId,
                        onEntryFocus: (0, $a6afd3c22f4adf72$export$b9ecd428b558ff10)(onEntryFocus, (event)=>{
                            if (!rootContext.isUsingKeyboardRef.current) event.preventDefault();
                        }),
                        preventScrollOnEntryFocus: true,
                        children: /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $90b52e5df71f6cb7$export$7c6e2c02157bb7d2), {
                            role: "menu",
                            "aria-orientation": "vertical",
                            "data-state": $d239a2fd778c1d9c$var$getOpenState(context.open),
                            "data-radix-menu-content": "",
                            dir: rootContext.dir,
                            ...popperScope,
                            ...contentProps,
                            ref: composedRefs,
                            style: {
                                outline: "none",
                                ...contentProps.style
                            },
                            onKeyDown: (0, $a6afd3c22f4adf72$export$b9ecd428b558ff10)(contentProps.onKeyDown, (event)=>{
                                const target = event.target;
                                const isKeyDownInside = target.closest("[data-radix-menu-content]") === event.currentTarget;
                                const isModifierKey = event.ctrlKey || event.altKey || event.metaKey;
                                const isCharacterKey = event.key.length === 1;
                                if (isKeyDownInside) {
                                    if (event.key === "Tab") event.preventDefault();
                                    if (!isModifierKey && isCharacterKey) handleTypeaheadSearch(event.key);
                                }
                                const content = contentRef.current;
                                if (event.target !== content) return;
                                if (!$d239a2fd778c1d9c$var$FIRST_LAST_KEYS.includes(event.key)) return;
                                event.preventDefault();
                                const items = getItems().filter((item)=>!item.disabled);
                                const candidateNodes = items.map((item)=>item.ref.current);
                                if ($d239a2fd778c1d9c$var$LAST_KEYS.includes(event.key)) candidateNodes.reverse();
                                $d239a2fd778c1d9c$var$focusFirst(candidateNodes);
                            }),
                            onBlur: (0, $a6afd3c22f4adf72$export$b9ecd428b558ff10)(props.onBlur, (event)=>{
                                if (!event.currentTarget.contains(event.target)) {
                                    window.clearTimeout(timerRef.current);
                                    searchRef.current = "";
                                }
                            }),
                            onPointerMove: (0, $a6afd3c22f4adf72$export$b9ecd428b558ff10)(props.onPointerMove, $d239a2fd778c1d9c$var$whenMouse((event)=>{
                                const target = event.target;
                                const pointerXHasChanged = lastPointerXRef.current !== event.clientX;
                                if (event.currentTarget.contains(target) && pointerXHasChanged) {
                                    const newDir = event.clientX > lastPointerXRef.current ? "right" : "left";
                                    pointerDirRef.current = newDir;
                                    lastPointerXRef.current = event.clientX;
                                }
                            }))
                        })
                    })
                })
            })
        })
    });
});
$d239a2fd778c1d9c$export$479f0f2f71193efe.displayName = $d239a2fd778c1d9c$var$CONTENT_NAME;
var $d239a2fd778c1d9c$var$GROUP_NAME = "MenuGroup";
var $d239a2fd778c1d9c$export$22a631d1f72787bb = $cQQee.forwardRef((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu, ...groupProps } = props;
    return /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $f679bf6067493560$export$250ffa63cdc0d034).div, {
        role: "group",
        ...groupProps,
        ref: forwardedRef
    });
});
$d239a2fd778c1d9c$export$22a631d1f72787bb.displayName = $d239a2fd778c1d9c$var$GROUP_NAME;
var $d239a2fd778c1d9c$var$LABEL_NAME = "MenuLabel";
var $d239a2fd778c1d9c$export$dd37bec0e8a99143 = $cQQee.forwardRef((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu, ...labelProps } = props;
    return /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $f679bf6067493560$export$250ffa63cdc0d034).div, {
        ...labelProps,
        ref: forwardedRef
    });
});
$d239a2fd778c1d9c$export$dd37bec0e8a99143.displayName = $d239a2fd778c1d9c$var$LABEL_NAME;
var $d239a2fd778c1d9c$var$ITEM_NAME = "MenuItem";
var $d239a2fd778c1d9c$var$ITEM_SELECT = "menu.itemSelect";
var $d239a2fd778c1d9c$export$2ce376c2cc3355c8 = $cQQee.forwardRef((props, forwardedRef)=>{
    const { disabled: disabled = false, onSelect: onSelect, ...itemProps } = props;
    const ref = $cQQee.useRef(null);
    const rootContext = $d239a2fd778c1d9c$var$useMenuRootContext($d239a2fd778c1d9c$var$ITEM_NAME, props.__scopeMenu);
    const contentContext = $d239a2fd778c1d9c$var$useMenuContentContext($d239a2fd778c1d9c$var$ITEM_NAME, props.__scopeMenu);
    const composedRefs = (0, $5565e7805f78287d$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const isPointerDownRef = $cQQee.useRef(false);
    const handleSelect = ()=>{
        const menuItem = ref.current;
        if (!disabled && menuItem) {
            const itemSelectEvent = new CustomEvent($d239a2fd778c1d9c$var$ITEM_SELECT, {
                bubbles: true,
                cancelable: true
            });
            menuItem.addEventListener($d239a2fd778c1d9c$var$ITEM_SELECT, (event)=>onSelect?.(event), {
                once: true
            });
            (0, $f679bf6067493560$export$6d1a0317bde7de7f)(menuItem, itemSelectEvent);
            if (itemSelectEvent.defaultPrevented) isPointerDownRef.current = false;
            else rootContext.onClose();
        }
    };
    return /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx($d239a2fd778c1d9c$var$MenuItemImpl, {
        ...itemProps,
        ref: composedRefs,
        disabled: disabled,
        onClick: (0, $a6afd3c22f4adf72$export$b9ecd428b558ff10)(props.onClick, handleSelect),
        onPointerDown: (event)=>{
            props.onPointerDown?.(event);
            isPointerDownRef.current = true;
        },
        onPointerUp: (0, $a6afd3c22f4adf72$export$b9ecd428b558ff10)(props.onPointerUp, (event)=>{
            if (!isPointerDownRef.current) event.currentTarget?.click();
        }),
        onKeyDown: (0, $a6afd3c22f4adf72$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
            const isTypingAhead = contentContext.searchRef.current !== "";
            if (disabled || isTypingAhead && event.key === " ") return;
            if ($d239a2fd778c1d9c$var$SELECTION_KEYS.includes(event.key)) {
                event.currentTarget.click();
                event.preventDefault();
            }
        })
    });
});
$d239a2fd778c1d9c$export$2ce376c2cc3355c8.displayName = $d239a2fd778c1d9c$var$ITEM_NAME;
var $d239a2fd778c1d9c$var$MenuItemImpl = $cQQee.forwardRef((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu, disabled: disabled = false, textValue: textValue, ...itemProps } = props;
    const contentContext = $d239a2fd778c1d9c$var$useMenuContentContext($d239a2fd778c1d9c$var$ITEM_NAME, __scopeMenu);
    const rovingFocusGroupScope = $d239a2fd778c1d9c$var$useRovingFocusGroupScope(__scopeMenu);
    const ref = $cQQee.useRef(null);
    const composedRefs = (0, $5565e7805f78287d$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const [isFocused, setIsFocused] = $cQQee.useState(false);
    const [textContent, setTextContent] = $cQQee.useState("");
    $cQQee.useEffect(()=>{
        const menuItem = ref.current;
        if (menuItem) setTextContent((menuItem.textContent ?? "").trim());
    }, [
        itemProps.children
    ]);
    return /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx($d239a2fd778c1d9c$var$Collection.ItemSlot, {
        scope: __scopeMenu,
        disabled: disabled,
        textValue: textValue ?? textContent,
        children: /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $e1ae38f5dc9abf75$export$6d08773d2e66f8f2), {
            asChild: true,
            ...rovingFocusGroupScope,
            focusable: !disabled,
            children: /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $f679bf6067493560$export$250ffa63cdc0d034).div, {
                role: "menuitem",
                "data-highlighted": isFocused ? "" : void 0,
                "aria-disabled": disabled || void 0,
                "data-disabled": disabled ? "" : void 0,
                ...itemProps,
                ref: composedRefs,
                onPointerMove: (0, $a6afd3c22f4adf72$export$b9ecd428b558ff10)(props.onPointerMove, $d239a2fd778c1d9c$var$whenMouse((event)=>{
                    if (disabled) contentContext.onItemLeave(event);
                    else {
                        contentContext.onItemEnter(event);
                        if (!event.defaultPrevented) {
                            const item = event.currentTarget;
                            item.focus({
                                preventScroll: true
                            });
                        }
                    }
                })),
                onPointerLeave: (0, $a6afd3c22f4adf72$export$b9ecd428b558ff10)(props.onPointerLeave, $d239a2fd778c1d9c$var$whenMouse((event)=>contentContext.onItemLeave(event))),
                onFocus: (0, $a6afd3c22f4adf72$export$b9ecd428b558ff10)(props.onFocus, ()=>setIsFocused(true)),
                onBlur: (0, $a6afd3c22f4adf72$export$b9ecd428b558ff10)(props.onBlur, ()=>setIsFocused(false))
            })
        })
    });
});
var $d239a2fd778c1d9c$var$CHECKBOX_ITEM_NAME = "MenuCheckboxItem";
var $d239a2fd778c1d9c$export$f6f243521332502d = $cQQee.forwardRef((props, forwardedRef)=>{
    const { checked: checked = false, onCheckedChange: onCheckedChange, ...checkboxItemProps } = props;
    return /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx($d239a2fd778c1d9c$var$ItemIndicatorProvider, {
        scope: props.__scopeMenu,
        checked: checked,
        children: /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx($d239a2fd778c1d9c$export$2ce376c2cc3355c8, {
            role: "menuitemcheckbox",
            "aria-checked": $d239a2fd778c1d9c$var$isIndeterminate(checked) ? "mixed" : checked,
            ...checkboxItemProps,
            ref: forwardedRef,
            "data-state": $d239a2fd778c1d9c$var$getCheckedState(checked),
            onSelect: (0, $a6afd3c22f4adf72$export$b9ecd428b558ff10)(checkboxItemProps.onSelect, ()=>onCheckedChange?.($d239a2fd778c1d9c$var$isIndeterminate(checked) ? true : !checked), {
                checkForDefaultPrevented: false
            })
        })
    });
});
$d239a2fd778c1d9c$export$f6f243521332502d.displayName = $d239a2fd778c1d9c$var$CHECKBOX_ITEM_NAME;
var $d239a2fd778c1d9c$var$RADIO_GROUP_NAME = "MenuRadioGroup";
var [$d239a2fd778c1d9c$var$RadioGroupProvider, $d239a2fd778c1d9c$var$useRadioGroupContext] = $d239a2fd778c1d9c$var$createMenuContext($d239a2fd778c1d9c$var$RADIO_GROUP_NAME, {
    value: void 0,
    onValueChange: ()=>{}
});
var $d239a2fd778c1d9c$export$ea2200c9eee416b3 = $cQQee.forwardRef((props, forwardedRef)=>{
    const { value: value, onValueChange: onValueChange, ...groupProps } = props;
    const handleValueChange = (0, $5188b0f5094d0afc$export$25bec8c6f54ee79a)(onValueChange);
    return /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx($d239a2fd778c1d9c$var$RadioGroupProvider, {
        scope: props.__scopeMenu,
        value: value,
        onValueChange: handleValueChange,
        children: /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx($d239a2fd778c1d9c$export$22a631d1f72787bb, {
            ...groupProps,
            ref: forwardedRef
        })
    });
});
$d239a2fd778c1d9c$export$ea2200c9eee416b3.displayName = $d239a2fd778c1d9c$var$RADIO_GROUP_NAME;
var $d239a2fd778c1d9c$var$RADIO_ITEM_NAME = "MenuRadioItem";
var $d239a2fd778c1d9c$export$69bd225e9817f6d0 = $cQQee.forwardRef((props, forwardedRef)=>{
    const { value: value, ...radioItemProps } = props;
    const context = $d239a2fd778c1d9c$var$useRadioGroupContext($d239a2fd778c1d9c$var$RADIO_ITEM_NAME, props.__scopeMenu);
    const checked = value === context.value;
    return /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx($d239a2fd778c1d9c$var$ItemIndicatorProvider, {
        scope: props.__scopeMenu,
        checked: checked,
        children: /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx($d239a2fd778c1d9c$export$2ce376c2cc3355c8, {
            role: "menuitemradio",
            "aria-checked": checked,
            ...radioItemProps,
            ref: forwardedRef,
            "data-state": $d239a2fd778c1d9c$var$getCheckedState(checked),
            onSelect: (0, $a6afd3c22f4adf72$export$b9ecd428b558ff10)(radioItemProps.onSelect, ()=>context.onValueChange?.(value), {
                checkForDefaultPrevented: false
            })
        })
    });
});
$d239a2fd778c1d9c$export$69bd225e9817f6d0.displayName = $d239a2fd778c1d9c$var$RADIO_ITEM_NAME;
var $d239a2fd778c1d9c$var$ITEM_INDICATOR_NAME = "MenuItemIndicator";
var [$d239a2fd778c1d9c$var$ItemIndicatorProvider, $d239a2fd778c1d9c$var$useItemIndicatorContext] = $d239a2fd778c1d9c$var$createMenuContext($d239a2fd778c1d9c$var$ITEM_INDICATOR_NAME, {
    checked: false
});
var $d239a2fd778c1d9c$export$a2593e23056970a3 = $cQQee.forwardRef((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu, forceMount: forceMount, ...itemIndicatorProps } = props;
    const indicatorContext = $d239a2fd778c1d9c$var$useItemIndicatorContext($d239a2fd778c1d9c$var$ITEM_INDICATOR_NAME, __scopeMenu);
    return /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $5061915239745df7$export$99c2b779aa4e8b8b), {
        present: forceMount || $d239a2fd778c1d9c$var$isIndeterminate(indicatorContext.checked) || indicatorContext.checked === true,
        children: /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $f679bf6067493560$export$250ffa63cdc0d034).span, {
            ...itemIndicatorProps,
            ref: forwardedRef,
            "data-state": $d239a2fd778c1d9c$var$getCheckedState(indicatorContext.checked)
        })
    });
});
$d239a2fd778c1d9c$export$a2593e23056970a3.displayName = $d239a2fd778c1d9c$var$ITEM_INDICATOR_NAME;
var $d239a2fd778c1d9c$var$SEPARATOR_NAME = "MenuSeparator";
var $d239a2fd778c1d9c$export$1cec7dcdd713e220 = $cQQee.forwardRef((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu, ...separatorProps } = props;
    return /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $f679bf6067493560$export$250ffa63cdc0d034).div, {
        role: "separator",
        "aria-orientation": "horizontal",
        ...separatorProps,
        ref: forwardedRef
    });
});
$d239a2fd778c1d9c$export$1cec7dcdd713e220.displayName = $d239a2fd778c1d9c$var$SEPARATOR_NAME;
var $d239a2fd778c1d9c$var$ARROW_NAME = "MenuArrow";
var $d239a2fd778c1d9c$export$bcdda4773debf5fa = $cQQee.forwardRef((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu, ...arrowProps } = props;
    const popperScope = $d239a2fd778c1d9c$var$usePopperScope(__scopeMenu);
    return /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $90b52e5df71f6cb7$export$21b07c8f274aebd5), {
        ...popperScope,
        ...arrowProps,
        ref: forwardedRef
    });
});
$d239a2fd778c1d9c$export$bcdda4773debf5fa.displayName = $d239a2fd778c1d9c$var$ARROW_NAME;
var $d239a2fd778c1d9c$var$SUB_NAME = "MenuSub";
var [$d239a2fd778c1d9c$var$MenuSubProvider, $d239a2fd778c1d9c$var$useMenuSubContext] = $d239a2fd778c1d9c$var$createMenuContext($d239a2fd778c1d9c$var$SUB_NAME);
var $d239a2fd778c1d9c$export$71bdb9d1e2909932 = (props)=>{
    const { __scopeMenu: __scopeMenu, children: children, open: open = false, onOpenChange: onOpenChange } = props;
    const parentMenuContext = $d239a2fd778c1d9c$var$useMenuContext($d239a2fd778c1d9c$var$SUB_NAME, __scopeMenu);
    const popperScope = $d239a2fd778c1d9c$var$usePopperScope(__scopeMenu);
    const [trigger, setTrigger] = $cQQee.useState(null);
    const [content, setContent] = $cQQee.useState(null);
    const handleOpenChange = (0, $5188b0f5094d0afc$export$25bec8c6f54ee79a)(onOpenChange);
    $cQQee.useEffect(()=>{
        if (parentMenuContext.open === false) handleOpenChange(false);
        return ()=>handleOpenChange(false);
    }, [
        parentMenuContext.open,
        handleOpenChange
    ]);
    return /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $90b52e5df71f6cb7$export$be92b6f5f03c0fe9), {
        ...popperScope,
        children: /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx($d239a2fd778c1d9c$var$MenuProvider, {
            scope: __scopeMenu,
            open: open,
            onOpenChange: handleOpenChange,
            content: content,
            onContentChange: setContent,
            children: /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx($d239a2fd778c1d9c$var$MenuSubProvider, {
                scope: __scopeMenu,
                contentId: (0, $2a35bb07bdc6a9cb$export$f680877a34711e37)(),
                triggerId: (0, $2a35bb07bdc6a9cb$export$f680877a34711e37)(),
                trigger: trigger,
                onTriggerChange: setTrigger,
                children: children
            })
        })
    });
};
$d239a2fd778c1d9c$export$71bdb9d1e2909932.displayName = $d239a2fd778c1d9c$var$SUB_NAME;
var $d239a2fd778c1d9c$var$SUB_TRIGGER_NAME = "MenuSubTrigger";
var $d239a2fd778c1d9c$export$5fbbb3ba7297405f = $cQQee.forwardRef((props, forwardedRef)=>{
    const context = $d239a2fd778c1d9c$var$useMenuContext($d239a2fd778c1d9c$var$SUB_TRIGGER_NAME, props.__scopeMenu);
    const rootContext = $d239a2fd778c1d9c$var$useMenuRootContext($d239a2fd778c1d9c$var$SUB_TRIGGER_NAME, props.__scopeMenu);
    const subContext = $d239a2fd778c1d9c$var$useMenuSubContext($d239a2fd778c1d9c$var$SUB_TRIGGER_NAME, props.__scopeMenu);
    const contentContext = $d239a2fd778c1d9c$var$useMenuContentContext($d239a2fd778c1d9c$var$SUB_TRIGGER_NAME, props.__scopeMenu);
    const openTimerRef = $cQQee.useRef(null);
    const { pointerGraceTimerRef: pointerGraceTimerRef, onPointerGraceIntentChange: onPointerGraceIntentChange } = contentContext;
    const scope = {
        __scopeMenu: props.__scopeMenu
    };
    const clearOpenTimer = $cQQee.useCallback(()=>{
        if (openTimerRef.current) window.clearTimeout(openTimerRef.current);
        openTimerRef.current = null;
    }, []);
    $cQQee.useEffect(()=>clearOpenTimer, [
        clearOpenTimer
    ]);
    $cQQee.useEffect(()=>{
        const pointerGraceTimer = pointerGraceTimerRef.current;
        return ()=>{
            window.clearTimeout(pointerGraceTimer);
            onPointerGraceIntentChange(null);
        };
    }, [
        pointerGraceTimerRef,
        onPointerGraceIntentChange
    ]);
    return /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx($d239a2fd778c1d9c$export$9fa5ebd18bee4d43, {
        asChild: true,
        ...scope,
        children: /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx($d239a2fd778c1d9c$var$MenuItemImpl, {
            id: subContext.triggerId,
            "aria-haspopup": "menu",
            "aria-expanded": context.open,
            "aria-controls": subContext.contentId,
            "data-state": $d239a2fd778c1d9c$var$getOpenState(context.open),
            ...props,
            ref: (0, $5565e7805f78287d$export$43e446d32b3d21af)(forwardedRef, subContext.onTriggerChange),
            onClick: (event)=>{
                props.onClick?.(event);
                if (props.disabled || event.defaultPrevented) return;
                event.currentTarget.focus();
                if (!context.open) context.onOpenChange(true);
            },
            onPointerMove: (0, $a6afd3c22f4adf72$export$b9ecd428b558ff10)(props.onPointerMove, $d239a2fd778c1d9c$var$whenMouse((event)=>{
                contentContext.onItemEnter(event);
                if (event.defaultPrevented) return;
                if (!props.disabled && !context.open && !openTimerRef.current) {
                    contentContext.onPointerGraceIntentChange(null);
                    openTimerRef.current = window.setTimeout(()=>{
                        context.onOpenChange(true);
                        clearOpenTimer();
                    }, 100);
                }
            })),
            onPointerLeave: (0, $a6afd3c22f4adf72$export$b9ecd428b558ff10)(props.onPointerLeave, $d239a2fd778c1d9c$var$whenMouse((event)=>{
                clearOpenTimer();
                const contentRect = context.content?.getBoundingClientRect();
                if (contentRect) {
                    const side = context.content?.dataset.side;
                    const rightSide = side === "right";
                    const bleed = rightSide ? -5 : 5;
                    const contentNearEdge = contentRect[rightSide ? "left" : "right"];
                    const contentFarEdge = contentRect[rightSide ? "right" : "left"];
                    contentContext.onPointerGraceIntentChange({
                        area: [
                            // Apply a bleed on clientX to ensure that our exit point is
                            // consistently within polygon bounds
                            {
                                x: event.clientX + bleed,
                                y: event.clientY
                            },
                            {
                                x: contentNearEdge,
                                y: contentRect.top
                            },
                            {
                                x: contentFarEdge,
                                y: contentRect.top
                            },
                            {
                                x: contentFarEdge,
                                y: contentRect.bottom
                            },
                            {
                                x: contentNearEdge,
                                y: contentRect.bottom
                            }
                        ],
                        side: side
                    });
                    window.clearTimeout(pointerGraceTimerRef.current);
                    pointerGraceTimerRef.current = window.setTimeout(()=>contentContext.onPointerGraceIntentChange(null), 300);
                } else {
                    contentContext.onTriggerLeave(event);
                    if (event.defaultPrevented) return;
                    contentContext.onPointerGraceIntentChange(null);
                }
            })),
            onKeyDown: (0, $a6afd3c22f4adf72$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
                const isTypingAhead = contentContext.searchRef.current !== "";
                if (props.disabled || isTypingAhead && event.key === " ") return;
                if ($d239a2fd778c1d9c$var$SUB_OPEN_KEYS[rootContext.dir].includes(event.key)) {
                    context.onOpenChange(true);
                    context.content?.focus();
                    event.preventDefault();
                }
            })
        })
    });
});
$d239a2fd778c1d9c$export$5fbbb3ba7297405f.displayName = $d239a2fd778c1d9c$var$SUB_TRIGGER_NAME;
var $d239a2fd778c1d9c$var$SUB_CONTENT_NAME = "MenuSubContent";
var $d239a2fd778c1d9c$export$e7142ab31822bde6 = $cQQee.forwardRef((props, forwardedRef)=>{
    const portalContext = $d239a2fd778c1d9c$var$usePortalContext($d239a2fd778c1d9c$var$CONTENT_NAME, props.__scopeMenu);
    const { forceMount: forceMount = portalContext.forceMount, ...subContentProps } = props;
    const context = $d239a2fd778c1d9c$var$useMenuContext($d239a2fd778c1d9c$var$CONTENT_NAME, props.__scopeMenu);
    const rootContext = $d239a2fd778c1d9c$var$useMenuRootContext($d239a2fd778c1d9c$var$CONTENT_NAME, props.__scopeMenu);
    const subContext = $d239a2fd778c1d9c$var$useMenuSubContext($d239a2fd778c1d9c$var$SUB_CONTENT_NAME, props.__scopeMenu);
    const ref = $cQQee.useRef(null);
    const composedRefs = (0, $5565e7805f78287d$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    return /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx($d239a2fd778c1d9c$var$Collection.Provider, {
        scope: props.__scopeMenu,
        children: /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $5061915239745df7$export$99c2b779aa4e8b8b), {
            present: forceMount || context.open,
            children: /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx($d239a2fd778c1d9c$var$Collection.Slot, {
                scope: props.__scopeMenu,
                children: /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx($d239a2fd778c1d9c$var$MenuContentImpl, {
                    id: subContext.contentId,
                    "aria-labelledby": subContext.triggerId,
                    ...subContentProps,
                    ref: composedRefs,
                    align: "start",
                    side: rootContext.dir === "rtl" ? "left" : "right",
                    disableOutsidePointerEvents: false,
                    disableOutsideScroll: false,
                    trapFocus: false,
                    onOpenAutoFocus: (event)=>{
                        if (rootContext.isUsingKeyboardRef.current) ref.current?.focus();
                        event.preventDefault();
                    },
                    onCloseAutoFocus: (event)=>event.preventDefault(),
                    onFocusOutside: (0, $a6afd3c22f4adf72$export$b9ecd428b558ff10)(props.onFocusOutside, (event)=>{
                        if (event.target !== subContext.trigger) context.onOpenChange(false);
                    }),
                    onEscapeKeyDown: (0, $a6afd3c22f4adf72$export$b9ecd428b558ff10)(props.onEscapeKeyDown, (event)=>{
                        rootContext.onClose();
                        event.preventDefault();
                    }),
                    onKeyDown: (0, $a6afd3c22f4adf72$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
                        const isKeyDownInside = event.currentTarget.contains(event.target);
                        const isCloseKey = $d239a2fd778c1d9c$var$SUB_CLOSE_KEYS[rootContext.dir].includes(event.key);
                        if (isKeyDownInside && isCloseKey) {
                            context.onOpenChange(false);
                            subContext.trigger?.focus();
                            event.preventDefault();
                        }
                    })
                })
            })
        })
    });
});
$d239a2fd778c1d9c$export$e7142ab31822bde6.displayName = $d239a2fd778c1d9c$var$SUB_CONTENT_NAME;
function $d239a2fd778c1d9c$var$getOpenState(open) {
    return open ? "open" : "closed";
}
function $d239a2fd778c1d9c$var$isIndeterminate(checked) {
    return checked === "indeterminate";
}
function $d239a2fd778c1d9c$var$getCheckedState(checked) {
    return $d239a2fd778c1d9c$var$isIndeterminate(checked) ? "indeterminate" : checked ? "checked" : "unchecked";
}
function $d239a2fd778c1d9c$var$focusFirst(candidates) {
    const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
    for (const candidate of candidates){
        if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
        candidate.focus();
        if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
    }
}
function $d239a2fd778c1d9c$var$wrapArray(array, startIndex) {
    return array.map((_, index)=>array[(startIndex + index) % array.length]);
}
function $d239a2fd778c1d9c$var$getNextMatch(values, search, currentMatch) {
    const isRepeated = search.length > 1 && Array.from(search).every((char)=>char === search[0]);
    const normalizedSearch = isRepeated ? search[0] : search;
    const currentMatchIndex = currentMatch ? values.indexOf(currentMatch) : -1;
    let wrappedValues = $d239a2fd778c1d9c$var$wrapArray(values, Math.max(currentMatchIndex, 0));
    const excludeCurrentMatch = normalizedSearch.length === 1;
    if (excludeCurrentMatch) wrappedValues = wrappedValues.filter((v)=>v !== currentMatch);
    const nextMatch = wrappedValues.find((value)=>value.toLowerCase().startsWith(normalizedSearch.toLowerCase()));
    return nextMatch !== currentMatch ? nextMatch : void 0;
}
function $d239a2fd778c1d9c$var$isPointInPolygon(point, polygon) {
    const { x: x, y: y } = point;
    let inside = false;
    for(let i = 0, j = polygon.length - 1; i < polygon.length; j = i++){
        const ii = polygon[i];
        const jj = polygon[j];
        const xi = ii.x;
        const yi = ii.y;
        const xj = jj.x;
        const yj = jj.y;
        const intersect = yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi;
        if (intersect) inside = !inside;
    }
    return inside;
}
function $d239a2fd778c1d9c$var$isPointerInGraceArea(event, area) {
    if (!area) return false;
    const cursorPos = {
        x: event.clientX,
        y: event.clientY
    };
    return $d239a2fd778c1d9c$var$isPointInPolygon(cursorPos, area);
}
function $d239a2fd778c1d9c$var$whenMouse(handler) {
    return (event)=>event.pointerType === "mouse" ? handler(event) : void 0;
}
var $d239a2fd778c1d9c$export$be92b6f5f03c0fe9 = $d239a2fd778c1d9c$export$d9b273488cd8ce6f;
var $d239a2fd778c1d9c$export$b688253958b8dfe7 = $d239a2fd778c1d9c$export$9fa5ebd18bee4d43;
var $d239a2fd778c1d9c$export$602eac185826482c = $d239a2fd778c1d9c$export$793392f970497feb;
var $d239a2fd778c1d9c$export$7c6e2c02157bb7d2 = $d239a2fd778c1d9c$export$479f0f2f71193efe;
var $d239a2fd778c1d9c$export$eb2fcfdbd7ba97d4 = $d239a2fd778c1d9c$export$22a631d1f72787bb;
var $d239a2fd778c1d9c$export$b04be29aa201d4f5 = $d239a2fd778c1d9c$export$dd37bec0e8a99143;
var $d239a2fd778c1d9c$export$6d08773d2e66f8f2 = $d239a2fd778c1d9c$export$2ce376c2cc3355c8;
var $d239a2fd778c1d9c$export$16ce288f89fa631c = $d239a2fd778c1d9c$export$f6f243521332502d;
var $d239a2fd778c1d9c$export$a98f0dcb43a68a25 = $d239a2fd778c1d9c$export$ea2200c9eee416b3;
var $d239a2fd778c1d9c$export$371ab307eab489c0 = $d239a2fd778c1d9c$export$69bd225e9817f6d0;
var $d239a2fd778c1d9c$export$c3468e2714d175fa = $d239a2fd778c1d9c$export$a2593e23056970a3;
var $d239a2fd778c1d9c$export$1ff3c3f08ae963c0 = $d239a2fd778c1d9c$export$1cec7dcdd713e220;
var $d239a2fd778c1d9c$export$21b07c8f274aebd5 = $d239a2fd778c1d9c$export$bcdda4773debf5fa;
var $d239a2fd778c1d9c$export$d7a01e11500dfb6f = $d239a2fd778c1d9c$export$71bdb9d1e2909932;
var $d239a2fd778c1d9c$export$2ea8a7a591ac5eac = $d239a2fd778c1d9c$export$5fbbb3ba7297405f;
var $d239a2fd778c1d9c$export$6d4de93b380beddf = $d239a2fd778c1d9c$export$e7142ab31822bde6;




var $e1429381663cd924$var$DROPDOWN_MENU_NAME = "DropdownMenu";
var [$e1429381663cd924$var$createDropdownMenuContext, $e1429381663cd924$export$c0623cd925aeb687] = (0, $f7850bc89e2b37d9$export$50c7b4e9d9f19c1)($e1429381663cd924$var$DROPDOWN_MENU_NAME, [
    (0, $d239a2fd778c1d9c$export$4027731b685e72eb)
]);
var $e1429381663cd924$var$useMenuScope = (0, $d239a2fd778c1d9c$export$4027731b685e72eb)();
var [$e1429381663cd924$var$DropdownMenuProvider, $e1429381663cd924$var$useDropdownMenuContext] = $e1429381663cd924$var$createDropdownMenuContext($e1429381663cd924$var$DROPDOWN_MENU_NAME);
var $e1429381663cd924$export$e44a253a59704894 = (props)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, children: children, dir: dir, open: openProp, defaultOpen: defaultOpen, onOpenChange: onOpenChange, modal: modal = true } = props;
    const menuScope = $e1429381663cd924$var$useMenuScope(__scopeDropdownMenu);
    const triggerRef = $cQQee.useRef(null);
    const [open, setOpen] = (0, $5525618e90d8a4e3$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen ?? false,
        onChange: onOpenChange,
        caller: $e1429381663cd924$var$DROPDOWN_MENU_NAME
    });
    return /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx($e1429381663cd924$var$DropdownMenuProvider, {
        scope: __scopeDropdownMenu,
        triggerId: (0, $2a35bb07bdc6a9cb$export$f680877a34711e37)(),
        triggerRef: triggerRef,
        contentId: (0, $2a35bb07bdc6a9cb$export$f680877a34711e37)(),
        open: open,
        onOpenChange: setOpen,
        onOpenToggle: $cQQee.useCallback(()=>setOpen((prevOpen)=>!prevOpen), [
            setOpen
        ]),
        modal: modal,
        children: /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $d239a2fd778c1d9c$export$be92b6f5f03c0fe9), {
            ...menuScope,
            open: open,
            onOpenChange: setOpen,
            dir: dir,
            modal: modal,
            children: children
        })
    });
};
$e1429381663cd924$export$e44a253a59704894.displayName = $e1429381663cd924$var$DROPDOWN_MENU_NAME;
var $e1429381663cd924$var$TRIGGER_NAME = "DropdownMenuTrigger";
var $e1429381663cd924$export$d2469213b3befba9 = $cQQee.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, disabled: disabled = false, ...triggerProps } = props;
    const context = $e1429381663cd924$var$useDropdownMenuContext($e1429381663cd924$var$TRIGGER_NAME, __scopeDropdownMenu);
    const menuScope = $e1429381663cd924$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $d239a2fd778c1d9c$export$b688253958b8dfe7), {
        asChild: true,
        ...menuScope,
        children: /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $f679bf6067493560$export$250ffa63cdc0d034).button, {
            type: "button",
            id: context.triggerId,
            "aria-haspopup": "menu",
            "aria-expanded": context.open,
            "aria-controls": context.open ? context.contentId : void 0,
            "data-state": context.open ? "open" : "closed",
            "data-disabled": disabled ? "" : void 0,
            disabled: disabled,
            ...triggerProps,
            ref: (0, $5565e7805f78287d$export$43e446d32b3d21af)(forwardedRef, context.triggerRef),
            onPointerDown: (0, $a6afd3c22f4adf72$export$b9ecd428b558ff10)(props.onPointerDown, (event)=>{
                if (!disabled && event.button === 0 && event.ctrlKey === false) {
                    context.onOpenToggle();
                    if (!context.open) event.preventDefault();
                }
            }),
            onKeyDown: (0, $a6afd3c22f4adf72$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
                if (disabled) return;
                if ([
                    "Enter",
                    " "
                ].includes(event.key)) context.onOpenToggle();
                if (event.key === "ArrowDown") context.onOpenChange(true);
                if ([
                    "Enter",
                    " ",
                    "ArrowDown"
                ].includes(event.key)) event.preventDefault();
            })
        })
    });
});
$e1429381663cd924$export$d2469213b3befba9.displayName = $e1429381663cd924$var$TRIGGER_NAME;
var $e1429381663cd924$var$PORTAL_NAME = "DropdownMenuPortal";
var $e1429381663cd924$export$cd369b4d4d54efc9 = (props)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...portalProps } = props;
    const menuScope = $e1429381663cd924$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $d239a2fd778c1d9c$export$602eac185826482c), {
        ...menuScope,
        ...portalProps
    });
};
$e1429381663cd924$export$cd369b4d4d54efc9.displayName = $e1429381663cd924$var$PORTAL_NAME;
var $e1429381663cd924$var$CONTENT_NAME = "DropdownMenuContent";
var $e1429381663cd924$export$6e76d93a37c01248 = $cQQee.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...contentProps } = props;
    const context = $e1429381663cd924$var$useDropdownMenuContext($e1429381663cd924$var$CONTENT_NAME, __scopeDropdownMenu);
    const menuScope = $e1429381663cd924$var$useMenuScope(__scopeDropdownMenu);
    const hasInteractedOutsideRef = $cQQee.useRef(false);
    return /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $d239a2fd778c1d9c$export$7c6e2c02157bb7d2), {
        id: context.contentId,
        "aria-labelledby": context.triggerId,
        ...menuScope,
        ...contentProps,
        ref: forwardedRef,
        onCloseAutoFocus: (0, $a6afd3c22f4adf72$export$b9ecd428b558ff10)(props.onCloseAutoFocus, (event)=>{
            if (!hasInteractedOutsideRef.current) context.triggerRef.current?.focus();
            hasInteractedOutsideRef.current = false;
            event.preventDefault();
        }),
        onInteractOutside: (0, $a6afd3c22f4adf72$export$b9ecd428b558ff10)(props.onInteractOutside, (event)=>{
            const originalEvent = event.detail.originalEvent;
            const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
            const isRightClick = originalEvent.button === 2 || ctrlLeftClick;
            if (!context.modal || isRightClick) hasInteractedOutsideRef.current = true;
        }),
        style: {
            ...props.style,
            "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
            "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
            "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
            "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
            "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
    });
});
$e1429381663cd924$export$6e76d93a37c01248.displayName = $e1429381663cd924$var$CONTENT_NAME;
var $e1429381663cd924$var$GROUP_NAME = "DropdownMenuGroup";
var $e1429381663cd924$export$246bebaba3a2f70e = $cQQee.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...groupProps } = props;
    const menuScope = $e1429381663cd924$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $d239a2fd778c1d9c$export$eb2fcfdbd7ba97d4), {
        ...menuScope,
        ...groupProps,
        ref: forwardedRef
    });
});
$e1429381663cd924$export$246bebaba3a2f70e.displayName = $e1429381663cd924$var$GROUP_NAME;
var $e1429381663cd924$var$LABEL_NAME = "DropdownMenuLabel";
var $e1429381663cd924$export$76e48c5b57f24495 = $cQQee.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...labelProps } = props;
    const menuScope = $e1429381663cd924$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $d239a2fd778c1d9c$export$b04be29aa201d4f5), {
        ...menuScope,
        ...labelProps,
        ref: forwardedRef
    });
});
$e1429381663cd924$export$76e48c5b57f24495.displayName = $e1429381663cd924$var$LABEL_NAME;
var $e1429381663cd924$var$ITEM_NAME = "DropdownMenuItem";
var $e1429381663cd924$export$ed97964d1871885d = $cQQee.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...itemProps } = props;
    const menuScope = $e1429381663cd924$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $d239a2fd778c1d9c$export$6d08773d2e66f8f2), {
        ...menuScope,
        ...itemProps,
        ref: forwardedRef
    });
});
$e1429381663cd924$export$ed97964d1871885d.displayName = $e1429381663cd924$var$ITEM_NAME;
var $e1429381663cd924$var$CHECKBOX_ITEM_NAME = "DropdownMenuCheckboxItem";
var $e1429381663cd924$export$53a69729da201fa9 = $cQQee.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...checkboxItemProps } = props;
    const menuScope = $e1429381663cd924$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $d239a2fd778c1d9c$export$16ce288f89fa631c), {
        ...menuScope,
        ...checkboxItemProps,
        ref: forwardedRef
    });
});
$e1429381663cd924$export$53a69729da201fa9.displayName = $e1429381663cd924$var$CHECKBOX_ITEM_NAME;
var $e1429381663cd924$var$RADIO_GROUP_NAME = "DropdownMenuRadioGroup";
var $e1429381663cd924$export$3323ad73d55f587e = $cQQee.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...radioGroupProps } = props;
    const menuScope = $e1429381663cd924$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $d239a2fd778c1d9c$export$a98f0dcb43a68a25), {
        ...menuScope,
        ...radioGroupProps,
        ref: forwardedRef
    });
});
$e1429381663cd924$export$3323ad73d55f587e.displayName = $e1429381663cd924$var$RADIO_GROUP_NAME;
var $e1429381663cd924$var$RADIO_ITEM_NAME = "DropdownMenuRadioItem";
var $e1429381663cd924$export$e4f69b41b1637536 = $cQQee.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...radioItemProps } = props;
    const menuScope = $e1429381663cd924$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $d239a2fd778c1d9c$export$371ab307eab489c0), {
        ...menuScope,
        ...radioItemProps,
        ref: forwardedRef
    });
});
$e1429381663cd924$export$e4f69b41b1637536.displayName = $e1429381663cd924$var$RADIO_ITEM_NAME;
var $e1429381663cd924$var$INDICATOR_NAME = "DropdownMenuItemIndicator";
var $e1429381663cd924$export$42355ae145153fb6 = $cQQee.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...itemIndicatorProps } = props;
    const menuScope = $e1429381663cd924$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $d239a2fd778c1d9c$export$c3468e2714d175fa), {
        ...menuScope,
        ...itemIndicatorProps,
        ref: forwardedRef
    });
});
$e1429381663cd924$export$42355ae145153fb6.displayName = $e1429381663cd924$var$INDICATOR_NAME;
var $e1429381663cd924$var$SEPARATOR_NAME = "DropdownMenuSeparator";
var $e1429381663cd924$export$da160178fd3bc7e9 = $cQQee.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...separatorProps } = props;
    const menuScope = $e1429381663cd924$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $d239a2fd778c1d9c$export$1ff3c3f08ae963c0), {
        ...menuScope,
        ...separatorProps,
        ref: forwardedRef
    });
});
$e1429381663cd924$export$da160178fd3bc7e9.displayName = $e1429381663cd924$var$SEPARATOR_NAME;
var $e1429381663cd924$var$ARROW_NAME = "DropdownMenuArrow";
var $e1429381663cd924$export$34b8980744021ec5 = $cQQee.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...arrowProps } = props;
    const menuScope = $e1429381663cd924$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $d239a2fd778c1d9c$export$21b07c8f274aebd5), {
        ...menuScope,
        ...arrowProps,
        ref: forwardedRef
    });
});
$e1429381663cd924$export$34b8980744021ec5.displayName = $e1429381663cd924$var$ARROW_NAME;
var $e1429381663cd924$export$2f307d81a64f5442 = (props)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, children: children, open: openProp, onOpenChange: onOpenChange, defaultOpen: defaultOpen } = props;
    const menuScope = $e1429381663cd924$var$useMenuScope(__scopeDropdownMenu);
    const [open, setOpen] = (0, $5525618e90d8a4e3$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen ?? false,
        onChange: onOpenChange,
        caller: "DropdownMenuSub"
    });
    return /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $d239a2fd778c1d9c$export$d7a01e11500dfb6f), {
        ...menuScope,
        open: open,
        onOpenChange: setOpen,
        children: children
    });
};
var $e1429381663cd924$var$SUB_TRIGGER_NAME = "DropdownMenuSubTrigger";
var $e1429381663cd924$export$21dcb7ec56f874cf = $cQQee.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...subTriggerProps } = props;
    const menuScope = $e1429381663cd924$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $d239a2fd778c1d9c$export$2ea8a7a591ac5eac), {
        ...menuScope,
        ...subTriggerProps,
        ref: forwardedRef
    });
});
$e1429381663cd924$export$21dcb7ec56f874cf.displayName = $e1429381663cd924$var$SUB_TRIGGER_NAME;
var $e1429381663cd924$var$SUB_CONTENT_NAME = "DropdownMenuSubContent";
var $e1429381663cd924$export$f34ec8bc2482cc5f = $cQQee.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...subContentProps } = props;
    const menuScope = $e1429381663cd924$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $d239a2fd778c1d9c$export$6d4de93b380beddf), {
        ...menuScope,
        ...subContentProps,
        ref: forwardedRef,
        style: {
            ...props.style,
            "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
            "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
            "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
            "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
            "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
    });
});
$e1429381663cd924$export$f34ec8bc2482cc5f.displayName = $e1429381663cd924$var$SUB_CONTENT_NAME;
var $e1429381663cd924$export$be92b6f5f03c0fe9 = $e1429381663cd924$export$e44a253a59704894;
var $e1429381663cd924$export$41fb9f06171c75f4 = $e1429381663cd924$export$d2469213b3befba9;
var $e1429381663cd924$export$602eac185826482c = $e1429381663cd924$export$cd369b4d4d54efc9;
var $e1429381663cd924$export$7c6e2c02157bb7d2 = $e1429381663cd924$export$6e76d93a37c01248;
var $e1429381663cd924$export$6d08773d2e66f8f2 = $e1429381663cd924$export$ed97964d1871885d;
var $e1429381663cd924$export$16ce288f89fa631c = $e1429381663cd924$export$53a69729da201fa9;
var $e1429381663cd924$export$a98f0dcb43a68a25 = $e1429381663cd924$export$3323ad73d55f587e;
var $e1429381663cd924$export$371ab307eab489c0 = $e1429381663cd924$export$e4f69b41b1637536;
var $e1429381663cd924$export$1ff3c3f08ae963c0 = $e1429381663cd924$export$da160178fd3bc7e9;
var $e1429381663cd924$export$d7a01e11500dfb6f = $e1429381663cd924$export$2f307d81a64f5442;
var $e1429381663cd924$export$2ea8a7a591ac5eac = $e1429381663cd924$export$21dcb7ec56f874cf;
var $e1429381663cd924$export$6d4de93b380beddf = $e1429381663cd924$export$f34ec8bc2482cc5f;



var $cQQee = parcelRequire("cQQee");

var $880e0ccd81749192$var$css_248z = ".-NgXgn-Seno-{align-self:stretch;overflow:hidden auto}.-NgXgn-Seno-,.x6K35-yq-cM-{display:flex;flex-direction:column}.x6K35-yq-cM-{align-items:flex-start;border:1px solid rgba(var(--ng-neutral-30));border-radius:var(--ng-rd-8);box-shadow:0 12px 16px -4px rgba(var(--ng-shadow-black-8)),0 4px 6px -2px rgba(var(--ng-shadow-black-3));box-sizing:border-box;font-family:Mulish,serif;padding:var(--ng-gp-4) 0;width:260px;z-index:var(--marvin-base-z-index)}.JEmeBtwPsS8-,.x6K35-yq-cM-{background:rgba(var(--ng-neutral-0))}.JEmeBtwPsS8-{align-items:center;border-radius:var(--ng-rd-6);color:rgba(var(--ng-neutral-80));display:flex;gap:var(--ng-gp-8);min-height:28px;padding:var(--ng-gp-2) var(--ng-gp-8)}.JEmeBtwPsS8-:hover{background:rgba(var(--ng-neutral-20))}.kj4cKLVDKzA-{cursor:pointer;outline:none;padding:var(--ng-gp-2) var(--ng-gp-4)}.kj4cKLVDKzA-:focus-within .JEmeBtwPsS8-{background:rgba(var(--ng-neutral-20))}.wk1NzBiCC0o-{align-items:center;background:rgba(var(--ng-neutral-0));border-radius:var(--ng-rd-6);color:rgba(var(--ng-neutral-80));display:flex;min-height:28px;overflow:hidden;padding:var(--ng-gp-2) var(--ng-gp-8);text-overflow:ellipsis;white-space:nowrap;width:100%}.wk1NzBiCC0o-:hover{background:rgba(var(--ng-neutral-20))}.D3W8ex57FC4-{align-items:center;align-self:stretch;cursor:pointer;display:flex;gap:var(--ng-gp-0);outline:none;padding:var(--ng-gp-2) var(--ng-gp-4)}.D3W8ex57FC4-:focus-within .wk1NzBiCC0o-{background:rgba(var(--ng-neutral-20))}.D3W8ex57FC4-[data-state=checked] .wk1NzBiCC0o-{background:rgba(var(--ng-primary-0))}.CZfA18WwhHw-{align-items:center;align-self:stretch;box-sizing:unset!important;display:flex;flex-direction:column;margin:var(--ng-gp-2) 0;padding:2px 8px}.xEvoCgeLLPU-{align-self:stretch;background-color:rgba(var(--ng-neutral-30));height:1px}.TNLqfgiHMJk->*{all:unset}.D-vGntf-1-8-{align-self:stretch;cursor:pointer;outline:none;padding:var(--ng-gp-2) var(--ng-gp-4)}.D-vGntf-1-8-[data-disabled]{color:rgba(var(--ng-neutral-50));cursor:not-allowed}.A1-d3vk3hiQ-{align-items:center;border-radius:var(--ng-rd-6);display:flex;font-family:Mulish,serif;gap:var(--ng-gp-4);min-height:28px;padding:var(--ng-gp-2) var(--ng-gp-8)}.A1-d3vk3hiQ-:hover{background:rgba(var(--ng-neutral-20))}.e1XftOtCuKU-{color:rgba(var(--ng-neutral-50));pointer-events:none}.zQlYInZ0DSY-{align-self:center;padding:calc(var(--ng-gp-12) + var(--ng-gp-2)) var(--ng-gp-12)}.aZb7J-KJW60- [class*=spinner]{height:16px!important;width:16px!important}.Is2nCDpzX2I-{padding:var(--ng-gp-12) var(--ng-gp-12)}.Is2nCDpzX2I-,.JQxGmAUWYsw-{align-items:center;color:rgba(var(--ng-neutral-50));display:flex;height:28px}.JQxGmAUWYsw-{padding:var(--ng-gp-4) var(--ng-gp-12)}";
var $880e0ccd81749192$export$2e2bcd8739ae039 = {
    "scrollable_content": "-NgXgn-Seno-",
    "content": "x6K35-yq-cM-",
    "checkbox_item_content": "JEmeBtwPsS8-",
    "checkbox_item": "kj4cKLVDKzA-",
    "radio_item_content": "wk1NzBiCC0o-",
    "radio_item": "D3W8ex57FC4-",
    "separator": "CZfA18WwhHw-",
    "separator_content": "xEvoCgeLLPU-",
    "unset_style": "TNLqfgiHMJk-",
    "item": "D-vGntf-1-8-",
    "item_content": "A1-d3vk3hiQ-",
    "section_header": "e1XftOtCuKU-",
    "loader_container": "zQlYInZ0DSY-",
    "spinner": "aZb7J-KJW60-",
    "no_options": "Is2nCDpzX2I-",
    "search_results": "JQxGmAUWYsw-"
};
(0, $4df8c7bf7afa5170$export$2e2bcd8739ae039)($880e0ccd81749192$var$css_248z);




var $67b554ed80f1256e$var$css_248z = ".Q6FmKIDnNJE-{animation:g99zRlB7dqE- 1s linear infinite;border-bottom:2px solid rgb(var(--marvin-divider-1));border:2px solid rgb(var(--marvin-divider-1));border-bottom-color:rgb(var(--marvin-primary));border-radius:50%;box-sizing:border-box;display:inline-block;height:48px;width:48px}@keyframes g99zRlB7dqE-{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}";
var $67b554ed80f1256e$export$2e2bcd8739ae039 = {
    "spinner_container": "Q6FmKIDnNJE-"
};
(0, $4df8c7bf7afa5170$export$2e2bcd8739ae039)($67b554ed80f1256e$var$css_248z);


const $87fc6be9e6cdc6fc$export$2e2bcd8739ae039 = (props)=>{
    const { customStyleClass: customStyleClass } = props;
    return (0, $81ee76508714b94a$export$35e795649ee09318).jsx("div", {
        className: `${customStyleClass} spinner-container`,
        children: (0, $81ee76508714b94a$export$35e795649ee09318).jsx("div", {
            className: `${(0, $67b554ed80f1256e$export$2e2bcd8739ae039).spinner_container} spinner`,
            "data-testid": "spinner"
        })
    });
};
$87fc6be9e6cdc6fc$export$2e2bcd8739ae039.defaultProps = {
    customStyleClass: ''
};



const $4c36f96585c995c5$export$e7eb525bc415b4b4 = (0, $e1429381663cd924$export$41fb9f06171c75f4);
const $4c36f96585c995c5$export$6fde95e347518364 = (0, $e1429381663cd924$export$602eac185826482c);
const $4c36f96585c995c5$export$52f1a7a531420fda = (0, $e1429381663cd924$export$d7a01e11500dfb6f);
const $4c36f96585c995c5$export$ecce04aae80c5d4c = (0, $e1429381663cd924$export$2ea8a7a591ac5eac);
const $4c36f96585c995c5$export$ae384999a6452cea = (0, (/*@__PURE__*/$parcel$interopDefault($cQQee))).forwardRef(({ className: className = '', ...props }, ref)=>(0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $e1429381663cd924$export$a98f0dcb43a68a25), {
        ref: ref,
        className: (0, $e99e5f020fa3ffc8$export$1343a74baacb0543)('ng_scrollbar', (0, $880e0ccd81749192$export$2e2bcd8739ae039).scrollable_content, className),
        ...props
    }));
$4c36f96585c995c5$export$ae384999a6452cea.displayName = 'DropdownRadioGroup';
const $4c36f96585c995c5$export$a07767dbf4087719 = (props)=>(0, $81ee76508714b94a$export$35e795649ee09318).jsx("div", {
        className: (0, $e99e5f020fa3ffc8$export$1343a74baacb0543)((0, $880e0ccd81749192$export$2e2bcd8739ae039).unset_style, 'ng_v2_style'),
        children: (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $e1429381663cd924$export$be92b6f5f03c0fe9), {
            ...props
        })
    });
$4c36f96585c995c5$export$a07767dbf4087719.displayName = 'DropdownRoot';
const $4c36f96585c995c5$export$59308621e1a05692 = (0, (/*@__PURE__*/$parcel$interopDefault($cQQee))).forwardRef(({ className: className = '', ...props }, ref)=>(0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $e1429381663cd924$export$7c6e2c02157bb7d2), {
        ref: ref,
        className: (0, $e99e5f020fa3ffc8$export$1343a74baacb0543)((0, $880e0ccd81749192$export$2e2bcd8739ae039).content, 'ng-dd-content', 'ng_v2_style', className),
        align: 'start',
        sideOffset: 8,
        ...props
    }));
$4c36f96585c995c5$export$59308621e1a05692.displayName = 'DropdownContent';
const $4c36f96585c995c5$export$c9857b4e7233160f = (0, (/*@__PURE__*/$parcel$interopDefault($cQQee))).forwardRef(({ className: className = '', ...props }, ref)=>(0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $e1429381663cd924$export$6d4de93b380beddf), {
        ref: ref,
        className: (0, $e99e5f020fa3ffc8$export$1343a74baacb0543)((0, $880e0ccd81749192$export$2e2bcd8739ae039).content, 'ng-dd-sub-content', className),
        ...props
    }));
$4c36f96585c995c5$export$c9857b4e7233160f.displayName = 'DropdownSubContent';
const $4c36f96585c995c5$export$24a794dc4c46209 = (0, (/*@__PURE__*/$parcel$interopDefault($cQQee))).forwardRef(({ className: className = '', ...props }, ref)=>(0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $e1429381663cd924$export$16ce288f89fa631c), {
        ref: ref,
        className: (0, $e99e5f020fa3ffc8$export$1343a74baacb0543)((0, $880e0ccd81749192$export$2e2bcd8739ae039).checkbox_item, 'ng_p_1_sb', 'ng-dd-checkbox-item', className),
        ...props,
        children: (0, $81ee76508714b94a$export$35e795649ee09318).jsx("div", {
            className: (0, $e99e5f020fa3ffc8$export$1343a74baacb0543)((0, $880e0ccd81749192$export$2e2bcd8739ae039).checkbox_item_content, 'ng-dd-checkbox-item-content'),
            children: props.children
        })
    }));
$4c36f96585c995c5$export$24a794dc4c46209.displayName = 'DropdownCheckboxItem';
const $4c36f96585c995c5$export$861bf084e8e7e3 = (0, (/*@__PURE__*/$parcel$interopDefault($cQQee))).forwardRef(({ className: className = '', ...props }, ref)=>(0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $e1429381663cd924$export$371ab307eab489c0), {
        ref: ref,
        className: (0, $e99e5f020fa3ffc8$export$1343a74baacb0543)((0, $880e0ccd81749192$export$2e2bcd8739ae039).radio_item, 'ng_p_1_sb', 'ng-dd-radio-item', className),
        ...props,
        children: (0, $81ee76508714b94a$export$35e795649ee09318).jsx("div", {
            className: (0, $e99e5f020fa3ffc8$export$1343a74baacb0543)((0, $880e0ccd81749192$export$2e2bcd8739ae039).radio_item_content, 'ng-dd-radio-item-content'),
            children: props.children
        })
    }));
$4c36f96585c995c5$export$861bf084e8e7e3.displayName = 'DropdownRadioItem';
const $4c36f96585c995c5$export$c0340fdc1581055e = (0, (/*@__PURE__*/$parcel$interopDefault($cQQee))).forwardRef(({ className: className = '', ...props }, ref)=>(0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $e1429381663cd924$export$1ff3c3f08ae963c0), {
        ref: ref,
        className: (0, $e99e5f020fa3ffc8$export$1343a74baacb0543)((0, $880e0ccd81749192$export$2e2bcd8739ae039).separator, 'ng-dd-separator', className),
        ...props,
        children: (0, $81ee76508714b94a$export$35e795649ee09318).jsx("span", {
            className: (0, $880e0ccd81749192$export$2e2bcd8739ae039).separator_content
        })
    }));
$4c36f96585c995c5$export$c0340fdc1581055e.displayName = 'DropdownSeparator';
const $4c36f96585c995c5$export$6648d5fa18559e7f = (0, (/*@__PURE__*/$parcel$interopDefault($cQQee))).forwardRef(({ className: className = '', children: children, ...props }, ref)=>(0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $e1429381663cd924$export$6d08773d2e66f8f2), {
        ref: ref,
        className: (0, $e99e5f020fa3ffc8$export$1343a74baacb0543)((0, $880e0ccd81749192$export$2e2bcd8739ae039).item, 'ng_p_1_sb', 'ng-dd-dropdown-item', className),
        ...props,
        children: (0, $81ee76508714b94a$export$35e795649ee09318).jsx("div", {
            className: (0, $e99e5f020fa3ffc8$export$1343a74baacb0543)((0, $880e0ccd81749192$export$2e2bcd8739ae039).item_content, 'ng-dd-dropdown-item-content'),
            children: children
        })
    }));
$4c36f96585c995c5$export$6648d5fa18559e7f.displayName = 'DropdownItem';
const $4c36f96585c995c5$export$8b9f0d993a06de28 = ({ children: children, className: className = '' })=>(0, $81ee76508714b94a$export$35e795649ee09318).jsx("div", {
        className: (0, $e99e5f020fa3ffc8$export$1343a74baacb0543)((0, $880e0ccd81749192$export$2e2bcd8739ae039).item, 'ng_p_1_sb', 'ng-dd-sub-trigger', className),
        children: (0, $81ee76508714b94a$export$35e795649ee09318).jsx("div", {
            className: (0, $e99e5f020fa3ffc8$export$1343a74baacb0543)((0, $880e0ccd81749192$export$2e2bcd8739ae039).item_content, 'ng-dd-sub-trigger-item', className),
            children: children
        })
    });
$4c36f96585c995c5$export$8b9f0d993a06de28.defaultProps = {
    className: ''
};
const $4c36f96585c995c5$export$79454d4d81898eb3 = ({ children: children })=>{
    return (0, $81ee76508714b94a$export$35e795649ee09318).jsx("div", {
        className: (0, $e99e5f020fa3ffc8$export$1343a74baacb0543)((0, $880e0ccd81749192$export$2e2bcd8739ae039).item, 'ng_p_2_sb', 'ng-dd-dropdown-item', (0, $880e0ccd81749192$export$2e2bcd8739ae039).section_header),
        role: "presentation",
        children: (0, $81ee76508714b94a$export$35e795649ee09318).jsx("div", {
            className: (0, $e99e5f020fa3ffc8$export$1343a74baacb0543)((0, $880e0ccd81749192$export$2e2bcd8739ae039).item_content, 'ng-dd-dropdown-item-content'),
            children: children
        })
    });
};
$4c36f96585c995c5$export$79454d4d81898eb3.defaultProps = {
    children: undefined
};
const $4c36f96585c995c5$export$4f9e3eba4089012f = ()=>{
    return (0, $81ee76508714b94a$export$35e795649ee09318).jsx("div", {
        className: (0, $880e0ccd81749192$export$2e2bcd8739ae039).loader_container,
        children: (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $87fc6be9e6cdc6fc$export$2e2bcd8739ae039), {
            customStyleClass: (0, $880e0ccd81749192$export$2e2bcd8739ae039).spinner
        })
    });
};
$4c36f96585c995c5$export$4f9e3eba4089012f.displayName = 'DropdownLoader';
const $4c36f96585c995c5$export$92055648c6190852 = ()=>{
    return (0, $81ee76508714b94a$export$35e795649ee09318).jsx("div", {
        className: (0, $e99e5f020fa3ffc8$export$1343a74baacb0543)('ng_p_1_sb', (0, $880e0ccd81749192$export$2e2bcd8739ae039).no_options),
        children: "No options available"
    });
};
$4c36f96585c995c5$export$92055648c6190852.displayName = 'DropdownNoOptions';
const $4c36f96585c995c5$export$2780f4609e67c67a = ({ noOfResults: noOfResults })=>{
    const getResultsText = ()=>{
        switch(noOfResults){
            case 0:
                return 'No search results found';
            case 1:
                return '1 search result found';
            default:
                return `${noOfResults} search results found`;
        }
    };
    return (0, $81ee76508714b94a$export$35e795649ee09318).jsx("div", {
        className: (0, $e99e5f020fa3ffc8$export$1343a74baacb0543)('ng_p_1_sb', (0, $880e0ccd81749192$export$2e2bcd8739ae039).search_results),
        children: getResultsText()
    });
};
$4c36f96585c995c5$export$2780f4609e67c67a.displayName = 'DropdownSearchResults';



const $006da0d336faf0a2$var$DEFAULT_VARIANT = 'secondary-gray';
const $006da0d336faf0a2$var$DEFAULT_SIZE = 'md';
const $006da0d336faf0a2$var$DEFAULT_STATE = 'default';
/* ------------------------------------------------------------------ */ /* Compound (bits-and-pieces) pieces                                   */ /* ------------------------------------------------------------------ */ /** The flex wrapper. `variant` drives the per-variant separator styling. */ const $006da0d336faf0a2$export$d955ba71187c4fcd = (0, (/*@__PURE__*/$parcel$interopDefault($cQQee))).forwardRef(({ children: children, variant: variant = $006da0d336faf0a2$var$DEFAULT_VARIANT, className: className = '', ...props }, ref)=>(0, $81ee76508714b94a$export$35e795649ee09318).jsx("div", {
        ref: ref,
        className: (0, $e99e5f020fa3ffc8$export$1343a74baacb0543)((0, $6172a18e08af7908$export$2e2bcd8739ae039).combo_button_wrapper, (0, $bb5cb732fec4bdcf$export$1673bc02d763f04a)[variant], className),
        ...props,
        children: children
    }));
$006da0d336faf0a2$export$d955ba71187c4fcd.displayName = 'ComboButtonRoot';
/** The primary action button. Display-only (non-interactive) when `onClick` is omitted. */ const $006da0d336faf0a2$export$280adfbd0d0992a3 = ({ text: text, icon: icon, onClick: onClick, variant: variant = $006da0d336faf0a2$var$DEFAULT_VARIANT, size: size = $006da0d336faf0a2$var$DEFAULT_SIZE, disabled: disabled = false, isLoading: isLoading = false, state: state = $006da0d336faf0a2$var$DEFAULT_STATE, dataTestId: dataTestId, customStyleClass: customStyleClass = '', ...restProps })=>(0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $93eff1b09ae4008c$export$2e2bcd8739ae039), {
        text: text,
        icon: icon,
        onClick: ()=>onClick?.(),
        variant: variant,
        size: size,
        disabled: disabled,
        isLoading: isLoading,
        state: state,
        dataTestId: dataTestId,
        customStyleClass: (0, $e99e5f020fa3ffc8$export$1343a74baacb0543)((0, $6172a18e08af7908$export$2e2bcd8739ae039).combo_button_main, onClick ? '' : (0, $6172a18e08af7908$export$2e2bcd8739ae039).combo_button_main_disabled, customStyleClass),
        ...restProps
    });
$006da0d336faf0a2$export$280adfbd0d0992a3.displayName = 'ComboButtonMain';
/** Divider between the main button and the dropdown trigger. Styled per variant by the Root. */ const $006da0d336faf0a2$export$b7e2597d139edf17 = (0, (/*@__PURE__*/$parcel$interopDefault($cQQee))).forwardRef(({ className: className = '', ...props }, ref)=>(0, $81ee76508714b94a$export$35e795649ee09318).jsx("div", {
        ref: ref,
        className: (0, $e99e5f020fa3ffc8$export$1343a74baacb0543)((0, $6172a18e08af7908$export$2e2bcd8739ae039).separator, className),
        ...props
    }));
$006da0d336faf0a2$export$b7e2597d139edf17.displayName = 'ComboButtonSeparator';
/**
 * The dropdown trigger container. Render inside a `DropdownRoot` (paired with
 * `DropdownPortal`/`DropdownContent`) to wire up the menu. Pass custom trigger
 * content as `children`; when omitted it falls back to a default IconButton
 * built from `icon` (+ variant/size/disabled/state). Standard div attributes and
 * a `ref` pass through to the container element.
 */ const $006da0d336faf0a2$export$e14f5e5d34fac50f = (0, (/*@__PURE__*/$parcel$interopDefault($cQQee))).forwardRef(({ children: children, icon: icon, variant: variant = $006da0d336faf0a2$var$DEFAULT_VARIANT, size: size = $006da0d336faf0a2$var$DEFAULT_SIZE, disabled: disabled = false, state: state = $006da0d336faf0a2$var$DEFAULT_STATE, dataTestId: dataTestId, className: className = '', ...props }, ref)=>{
    const defaultTrigger = icon ? (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $dbb74cb604a2ffe4$export$2e2bcd8739ae039), {
        icon: icon,
        variant: variant,
        size: size,
        onClick: ()=>{},
        disabled: disabled,
        state: state,
        dataTestId: dataTestId,
        customStyleClass: (0, $6172a18e08af7908$export$2e2bcd8739ae039).combo_button_icon,
        "aria-label": "More actions"
    }) : null;
    const content = children ?? defaultTrigger;
    return (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $4c36f96585c995c5$export$e7eb525bc415b4b4), {
        disabled: disabled,
        asChild: true,
        children: (0, $81ee76508714b94a$export$35e795649ee09318).jsx("div", {
            ref: ref,
            className: className,
            ...props,
            children: content
        })
    });
});
$006da0d336faf0a2$export$e14f5e5d34fac50f.displayName = 'ComboButtonTrigger';
/* ------------------------------------------------------------------ */ /* Monolithic component, composed from the pieces above                */ /* ------------------------------------------------------------------ */ const $006da0d336faf0a2$var$ComboButton = ({ text: text, icon: icon, onMainClick: onMainClick, dropdownIcon: dropdownIcon, actions: actions = [], variant: variant = $006da0d336faf0a2$var$DEFAULT_VARIANT, size: size = $006da0d336faf0a2$var$DEFAULT_SIZE, disabled: disabled = false, isLoading: isLoading = false, customStyleClass: customStyleClass = '', dataTestId: dataTestId, state: state = $006da0d336faf0a2$var$DEFAULT_STATE, ...restProps })=>{
    const handleMainClick = (0, $cQQee.useCallback)(()=>{
        onMainClick?.();
    }, [
        onMainClick
    ]);
    return (0, $81ee76508714b94a$export$35e795649ee09318).jsxs($006da0d336faf0a2$export$d955ba71187c4fcd, {
        variant: variant,
        className: customStyleClass,
        children: [
            (0, $81ee76508714b94a$export$35e795649ee09318).jsx($006da0d336faf0a2$export$280adfbd0d0992a3, {
                text: text,
                icon: icon,
                onClick: onMainClick ? handleMainClick : undefined,
                variant: variant,
                size: size,
                disabled: disabled,
                isLoading: isLoading,
                state: state,
                dataTestId: dataTestId ? `${dataTestId}-main` : undefined,
                ...restProps
            }),
            (0, $81ee76508714b94a$export$35e795649ee09318).jsx($006da0d336faf0a2$export$b7e2597d139edf17, {}),
            (0, $81ee76508714b94a$export$35e795649ee09318).jsxs((0, $4c36f96585c995c5$export$a07767dbf4087719), {
                children: [
                    (0, $81ee76508714b94a$export$35e795649ee09318).jsx($006da0d336faf0a2$export$e14f5e5d34fac50f, {
                        icon: dropdownIcon,
                        variant: variant,
                        size: size,
                        disabled: disabled,
                        state: state,
                        dataTestId: dataTestId ? `${dataTestId}-dropdown` : undefined
                    }),
                    (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $4c36f96585c995c5$export$6fde95e347518364), {
                        children: (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $4c36f96585c995c5$export$59308621e1a05692), {
                            align: "end",
                            sideOffset: 4,
                            children: actions.map((action)=>(0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $4c36f96585c995c5$export$6648d5fa18559e7f), {
                                    disabled: action.disabled,
                                    onSelect: action.onSelect,
                                    children: action.label
                                }, action.value))
                        })
                    })
                ]
            })
        ]
    });
};
const $006da0d336faf0a2$export$2e2bcd8739ae039 = (0, $cQQee.memo)($006da0d336faf0a2$var$ComboButton);




var $39167f15a0271333$var$css_248z = ".wltBHckjpBw-{background-color:rgba(var(--ng-neutral-30));border:none;border-radius:var(--ng-rd-2);display:flex}";
var $39167f15a0271333$export$2e2bcd8739ae039 = {
    "separator": "wltBHckjpBw-"
};
(0, $4df8c7bf7afa5170$export$2e2bcd8739ae039)($39167f15a0271333$var$css_248z);



/**
 * Displays a separator line. Requires orientation and length of the line.
 */ const $cc0bb6c392922fb5$export$2e2bcd8739ae039 = ({ orientation: orientation, customStyleClass: customStyleClass = '', length: length })=>{
    return (0, $81ee76508714b94a$export$35e795649ee09318).jsx("hr", {
        style: {
            width: orientation === 'horizontal' ? length : '1px',
            height: orientation === 'vertical' ? length : '1px'
        },
        "aria-orientation": orientation,
        className: (0, $e99e5f020fa3ffc8$export$1343a74baacb0543)((0, $39167f15a0271333$export$2e2bcd8739ae039).separator, customStyleClass)
    });
};
$cc0bb6c392922fb5$export$2e2bcd8739ae039.defaultProps = {
    customStyleClass: ''
};




var $cQQee = parcelRequire("cQQee");





var $cQQee = parcelRequire("cQQee");
// packages/react/use-previous/src/use-previous.tsx
function $9c12db7b01360db9$export$5cae361ad82dce8b(value) {
    const ref = $cQQee.useRef({
        value: value,
        previous: value
    });
    return $cQQee.useMemo(()=>{
        if (ref.current.value !== value) {
            ref.current.previous = ref.current.value;
            ref.current.value = value;
        }
        return ref.current.previous;
    }, [
        value
    ]);
}





var $447dc0e87b2e44c0$var$SWITCH_NAME = "Switch";
var [$447dc0e87b2e44c0$var$createSwitchContext, $447dc0e87b2e44c0$export$cf7f5f17f69cbd43] = (0, $f7850bc89e2b37d9$export$50c7b4e9d9f19c1)($447dc0e87b2e44c0$var$SWITCH_NAME);
var [$447dc0e87b2e44c0$var$SwitchProvider, $447dc0e87b2e44c0$var$useSwitchContext] = $447dc0e87b2e44c0$var$createSwitchContext($447dc0e87b2e44c0$var$SWITCH_NAME);
var $447dc0e87b2e44c0$export$b5d5cf8927ab7262 = $cQQee.forwardRef((props, forwardedRef)=>{
    const { __scopeSwitch: __scopeSwitch, name: name, checked: checkedProp, defaultChecked: defaultChecked, required: required, disabled: disabled, value: value = "on", onCheckedChange: onCheckedChange, form: form, ...switchProps } = props;
    const [button, setButton] = $cQQee.useState(null);
    const composedRefs = (0, $5565e7805f78287d$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setButton(node));
    const hasConsumerStoppedPropagationRef = $cQQee.useRef(false);
    const isFormControl = button ? form || !!button.closest("form") : true;
    const [checked, setChecked] = (0, $5525618e90d8a4e3$export$6f32135080cb4c3)({
        prop: checkedProp,
        defaultProp: defaultChecked ?? false,
        onChange: onCheckedChange,
        caller: $447dc0e87b2e44c0$var$SWITCH_NAME
    });
    return /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsxs($447dc0e87b2e44c0$var$SwitchProvider, {
        scope: __scopeSwitch,
        checked: checked,
        disabled: disabled,
        children: [
            /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $f679bf6067493560$export$250ffa63cdc0d034).button, {
                type: "button",
                role: "switch",
                "aria-checked": checked,
                "aria-required": required,
                "data-state": $447dc0e87b2e44c0$var$getState(checked),
                "data-disabled": disabled ? "" : void 0,
                disabled: disabled,
                value: value,
                ...switchProps,
                ref: composedRefs,
                onClick: (0, $a6afd3c22f4adf72$export$b9ecd428b558ff10)(props.onClick, (event)=>{
                    setChecked((prevChecked)=>!prevChecked);
                    if (isFormControl) {
                        hasConsumerStoppedPropagationRef.current = event.isPropagationStopped();
                        if (!hasConsumerStoppedPropagationRef.current) event.stopPropagation();
                    }
                })
            }),
            isFormControl && /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx($447dc0e87b2e44c0$var$SwitchBubbleInput, {
                control: button,
                bubbles: !hasConsumerStoppedPropagationRef.current,
                name: name,
                value: value,
                checked: checked,
                required: required,
                disabled: disabled,
                form: form,
                style: {
                    transform: "translateX(-100%)"
                }
            })
        ]
    });
});
$447dc0e87b2e44c0$export$b5d5cf8927ab7262.displayName = $447dc0e87b2e44c0$var$SWITCH_NAME;
var $447dc0e87b2e44c0$var$THUMB_NAME = "SwitchThumb";
var $447dc0e87b2e44c0$export$4d07bf653ea69106 = $cQQee.forwardRef((props, forwardedRef)=>{
    const { __scopeSwitch: __scopeSwitch, ...thumbProps } = props;
    const context = $447dc0e87b2e44c0$var$useSwitchContext($447dc0e87b2e44c0$var$THUMB_NAME, __scopeSwitch);
    return /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $f679bf6067493560$export$250ffa63cdc0d034).span, {
        "data-state": $447dc0e87b2e44c0$var$getState(context.checked),
        "data-disabled": context.disabled ? "" : void 0,
        ...thumbProps,
        ref: forwardedRef
    });
});
$447dc0e87b2e44c0$export$4d07bf653ea69106.displayName = $447dc0e87b2e44c0$var$THUMB_NAME;
var $447dc0e87b2e44c0$var$BUBBLE_INPUT_NAME = "SwitchBubbleInput";
var $447dc0e87b2e44c0$var$SwitchBubbleInput = $cQQee.forwardRef(({ __scopeSwitch: __scopeSwitch, control: control, checked: checked, bubbles: bubbles = true, ...props }, forwardedRef)=>{
    const ref = $cQQee.useRef(null);
    const composedRefs = (0, $5565e7805f78287d$export$c7b2cbe3552a0d05)(ref, forwardedRef);
    const prevChecked = (0, $9c12db7b01360db9$export$5cae361ad82dce8b)(checked);
    const controlSize = (0, $dd793b2039b2c880$export$1ab7ae714698c4b8)(control);
    $cQQee.useEffect(()=>{
        const input = ref.current;
        if (!input) return;
        const inputProto = window.HTMLInputElement.prototype;
        const descriptor = Object.getOwnPropertyDescriptor(inputProto, "checked");
        const setChecked = descriptor.set;
        if (prevChecked !== checked && setChecked) {
            const event = new Event("click", {
                bubbles: bubbles
            });
            setChecked.call(input, checked);
            input.dispatchEvent(event);
        }
    }, [
        prevChecked,
        checked,
        bubbles
    ]);
    return /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx("input", {
        type: "checkbox",
        "aria-hidden": true,
        defaultChecked: checked,
        ...props,
        tabIndex: -1,
        ref: composedRefs,
        style: {
            ...props.style,
            ...controlSize,
            position: "absolute",
            pointerEvents: "none",
            opacity: 0,
            margin: 0
        }
    });
});
$447dc0e87b2e44c0$var$SwitchBubbleInput.displayName = $447dc0e87b2e44c0$var$BUBBLE_INPUT_NAME;
function $447dc0e87b2e44c0$var$getState(checked) {
    return checked ? "checked" : "unchecked";
}
var $447dc0e87b2e44c0$export$be92b6f5f03c0fe9 = $447dc0e87b2e44c0$export$b5d5cf8927ab7262;
var $447dc0e87b2e44c0$export$6521433ed15a34db = $447dc0e87b2e44c0$export$4d07bf653ea69106;



var $a7d6ff740d6d489b$var$css_248z = ".USPRK3URuds-{all:unset;background-color:rgba(var(--ng-neutral-20));border:1px solid rgba(var(--ng-neutral-40));border-radius:9999px;cursor:pointer;display:block;position:relative;transition:background-color .2s}.USPRK3URuds-,.USPRK3URuds- *{box-sizing:border-box}.USPRK3URuds-:hover{background-color:rgba(var(--ng-neutral-40))}.USPRK3URuds-:focus{background-color:rgba(var(--ng-neutral-20))}.USPRK3URuds-[data-disabled]{background-color:rgba(var(--ng-neutral-0));cursor:not-allowed}.USPRK3URuds-[data-state=checked]{background-color:rgba(var(--ng-secondary-30));border-color:rgba(var(--ng-secondary-30))}.USPRK3URuds-[data-state=checked]:hover{background-color:rgba(var(--ng-secondary-40));border-color:rgba(var(--ng-secondary-40))}.USPRK3URuds-[data-state=checked]:focus{background-color:rgba(var(--ng-secondary-30));border-color:rgba(var(--ng-secondary-40))}.USPRK3URuds-[data-state=checked][data-disabled]{background-color:rgba(var(--ng-neutral-0));border-color:rgba(var(--ng-neutral-40));cursor:not-allowed}.OP8p6mEuKtg-{height:16px;max-height:16px;max-width:28px;min-height:16px;min-width:28px;width:28px}._2yG5IRd1wg4-{height:20px;max-height:20px;max-width:36px;min-height:20px;min-width:36px;width:36px}.W16Ybl7yAtE-{height:24px;max-height:24px;max-width:44px;min-height:24px;min-width:44px;width:44px}.GoG9RYorZmM-{background-color:rgba(var(--ng-neutral-0));border-radius:9999px;box-shadow:0 1px 3px 0 rgba(16,24,40,.1),0 1px 2px 0 rgb(16 24 40/6%);display:block;transform:translateX(1px);transition:transform .2s;will-change:transform}.GoG9RYorZmM-[data-disabled]{background-color:rgba(var(--ng-neutral-40))}.GoG9RYorZmM-[data-state=checked]{background-color:rgba(var(--ng-secondary-0))}.GoG9RYorZmM-[data-state=checked][data-disabled]{background-color:rgba(var(--ng-neutral-40))}._61wC8RilPdA-{height:12px;max-height:12px;max-width:12px;min-height:12px;min-width:12px;width:12px}._61wC8RilPdA-[data-state=checked]{transform:translateX(13px)}.arrZetH9HEQ-{height:16px;max-height:16px;max-width:16px;min-height:16px;min-width:16px;width:16px}.arrZetH9HEQ-[data-state=checked]{transform:translateX(17px)}._7QrkUDnXFbo-{height:20px;max-height:20px;max-width:20px;min-height:20px;min-width:20px;width:20px}._7QrkUDnXFbo-[data-state=checked]{transform:translateX(21px)}";
var $a7d6ff740d6d489b$export$2e2bcd8739ae039 = {
    "root": "USPRK3URuds-",
    "root_sm": "OP8p6mEuKtg-",
    "root_md": "_2yG5IRd1wg4-",
    "root_lg": "W16Ybl7yAtE-",
    "thumb": "GoG9RYorZmM-",
    "thumb_sm": "_61wC8RilPdA-",
    "thumb_md": "arrZetH9HEQ-",
    "thumb_lg": "_7QrkUDnXFbo-"
};
(0, $4df8c7bf7afa5170$export$2e2bcd8739ae039)($a7d6ff740d6d489b$var$css_248z);



const $8168608572f5d798$var$sizeClassMap = {
    sm: {
        root: (0, $a7d6ff740d6d489b$export$2e2bcd8739ae039).root_sm,
        thumb: (0, $a7d6ff740d6d489b$export$2e2bcd8739ae039).thumb_sm
    },
    md: {
        root: (0, $a7d6ff740d6d489b$export$2e2bcd8739ae039).root_md,
        thumb: (0, $a7d6ff740d6d489b$export$2e2bcd8739ae039).thumb_md
    },
    lg: {
        root: (0, $a7d6ff740d6d489b$export$2e2bcd8739ae039).root_lg,
        thumb: (0, $a7d6ff740d6d489b$export$2e2bcd8739ae039).thumb_lg
    }
};
const $8168608572f5d798$export$90cdcc302a60edc = (size)=>{
    const sizeClasses = $8168608572f5d798$var$sizeClassMap[size];
    return {
        root: (0, $e99e5f020fa3ffc8$export$1343a74baacb0543)((0, $a7d6ff740d6d489b$export$2e2bcd8739ae039).root, sizeClasses.root),
        thumb: (0, $e99e5f020fa3ffc8$export$1343a74baacb0543)((0, $a7d6ff740d6d489b$export$2e2bcd8739ae039).thumb, sizeClasses.thumb)
    };
};



var $cQQee = parcelRequire("cQQee");
const $c61e96086977e038$export$2e2bcd8739ae039 = ({ label: label, size: size = 'md', checked: checked = false, disabled: disabled = false, onCheckedChange: onCheckedChange })=>{
    const { root: root, thumb: thumb } = (0, $cQQee.useMemo)(()=>(0, $8168608572f5d798$export$90cdcc302a60edc)(size), [
        size
    ]);
    return (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $447dc0e87b2e44c0$export$be92b6f5f03c0fe9), {
        "aria-label": `Toggle ${label} switch`,
        "data-testid": `${label}-switch`,
        className: root,
        checked: checked,
        disabled: disabled,
        onCheckedChange: onCheckedChange,
        children: (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $447dc0e87b2e44c0$export$6521433ed15a34db), {
            className: thumb
        })
    });
};
$c61e96086977e038$export$2e2bcd8739ae039.defaultProps = {
    disabled: false
};




var $cQQee = parcelRequire("cQQee");









var $4bdfeb660b0a3461$var$TABS_NAME = "Tabs";
var [$4bdfeb660b0a3461$var$createTabsContext, $4bdfeb660b0a3461$export$355f5bd209d7b13a] = (0, $f7850bc89e2b37d9$export$50c7b4e9d9f19c1)($4bdfeb660b0a3461$var$TABS_NAME, [
    (0, $e1ae38f5dc9abf75$export$c7109489551a4f4)
]);
var $4bdfeb660b0a3461$var$useRovingFocusGroupScope = (0, $e1ae38f5dc9abf75$export$c7109489551a4f4)();
var [$4bdfeb660b0a3461$var$TabsProvider, $4bdfeb660b0a3461$var$useTabsContext] = $4bdfeb660b0a3461$var$createTabsContext($4bdfeb660b0a3461$var$TABS_NAME);
var $4bdfeb660b0a3461$export$b2539bed5023c21c = $cQQee.forwardRef((props, forwardedRef)=>{
    const { __scopeTabs: __scopeTabs, value: valueProp, onValueChange: onValueChange, defaultValue: defaultValue, orientation: orientation = "horizontal", dir: dir, activationMode: activationMode = "automatic", ...tabsProps } = props;
    const direction = (0, $7cc50a31b296c1eb$export$b39126d51d94e6f3)(dir);
    const [value, setValue] = (0, $5525618e90d8a4e3$export$6f32135080cb4c3)({
        prop: valueProp,
        onChange: onValueChange,
        defaultProp: defaultValue ?? "",
        caller: $4bdfeb660b0a3461$var$TABS_NAME
    });
    return /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx($4bdfeb660b0a3461$var$TabsProvider, {
        scope: __scopeTabs,
        baseId: (0, $2a35bb07bdc6a9cb$export$f680877a34711e37)(),
        value: value,
        onValueChange: setValue,
        orientation: orientation,
        dir: direction,
        activationMode: activationMode,
        children: /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $f679bf6067493560$export$250ffa63cdc0d034).div, {
            dir: direction,
            "data-orientation": orientation,
            ...tabsProps,
            ref: forwardedRef
        })
    });
});
$4bdfeb660b0a3461$export$b2539bed5023c21c.displayName = $4bdfeb660b0a3461$var$TABS_NAME;
var $4bdfeb660b0a3461$var$TAB_LIST_NAME = "TabsList";
var $4bdfeb660b0a3461$export$9712d22edc0d78c1 = $cQQee.forwardRef((props, forwardedRef)=>{
    const { __scopeTabs: __scopeTabs, loop: loop = true, ...listProps } = props;
    const context = $4bdfeb660b0a3461$var$useTabsContext($4bdfeb660b0a3461$var$TAB_LIST_NAME, __scopeTabs);
    const rovingFocusGroupScope = $4bdfeb660b0a3461$var$useRovingFocusGroupScope(__scopeTabs);
    return /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $e1ae38f5dc9abf75$export$be92b6f5f03c0fe9), {
        asChild: true,
        ...rovingFocusGroupScope,
        orientation: context.orientation,
        dir: context.dir,
        loop: loop,
        children: /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $f679bf6067493560$export$250ffa63cdc0d034).div, {
            role: "tablist",
            "aria-orientation": context.orientation,
            ...listProps,
            ref: forwardedRef
        })
    });
});
$4bdfeb660b0a3461$export$9712d22edc0d78c1.displayName = $4bdfeb660b0a3461$var$TAB_LIST_NAME;
var $4bdfeb660b0a3461$var$TRIGGER_NAME = "TabsTrigger";
var $4bdfeb660b0a3461$export$8114b9fdfdf9f3ba = $cQQee.forwardRef((props, forwardedRef)=>{
    const { __scopeTabs: __scopeTabs, value: value, disabled: disabled = false, ...triggerProps } = props;
    const context = $4bdfeb660b0a3461$var$useTabsContext($4bdfeb660b0a3461$var$TRIGGER_NAME, __scopeTabs);
    const rovingFocusGroupScope = $4bdfeb660b0a3461$var$useRovingFocusGroupScope(__scopeTabs);
    const triggerId = $4bdfeb660b0a3461$var$makeTriggerId(context.baseId, value);
    const contentId = $4bdfeb660b0a3461$var$makeContentId(context.baseId, value);
    const isSelected = value === context.value;
    return /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $e1ae38f5dc9abf75$export$6d08773d2e66f8f2), {
        asChild: true,
        ...rovingFocusGroupScope,
        focusable: !disabled,
        active: isSelected,
        children: /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $f679bf6067493560$export$250ffa63cdc0d034).button, {
            type: "button",
            role: "tab",
            "aria-selected": isSelected,
            "aria-controls": contentId,
            "data-state": isSelected ? "active" : "inactive",
            "data-disabled": disabled ? "" : void 0,
            disabled: disabled,
            id: triggerId,
            ...triggerProps,
            ref: forwardedRef,
            onMouseDown: (0, $a6afd3c22f4adf72$export$b9ecd428b558ff10)(props.onMouseDown, (event)=>{
                if (!disabled && event.button === 0 && event.ctrlKey === false) context.onValueChange(value);
                else event.preventDefault();
            }),
            onKeyDown: (0, $a6afd3c22f4adf72$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
                if ([
                    " ",
                    "Enter"
                ].includes(event.key)) context.onValueChange(value);
            }),
            onFocus: (0, $a6afd3c22f4adf72$export$b9ecd428b558ff10)(props.onFocus, ()=>{
                const isAutomaticActivation = context.activationMode !== "manual";
                if (!isSelected && !disabled && isAutomaticActivation) context.onValueChange(value);
            })
        })
    });
});
$4bdfeb660b0a3461$export$8114b9fdfdf9f3ba.displayName = $4bdfeb660b0a3461$var$TRIGGER_NAME;
var $4bdfeb660b0a3461$var$CONTENT_NAME = "TabsContent";
var $4bdfeb660b0a3461$export$bd905d70e8fd2ebb = $cQQee.forwardRef((props, forwardedRef)=>{
    const { __scopeTabs: __scopeTabs, value: value, forceMount: forceMount, children: children, ...contentProps } = props;
    const context = $4bdfeb660b0a3461$var$useTabsContext($4bdfeb660b0a3461$var$CONTENT_NAME, __scopeTabs);
    const triggerId = $4bdfeb660b0a3461$var$makeTriggerId(context.baseId, value);
    const contentId = $4bdfeb660b0a3461$var$makeContentId(context.baseId, value);
    const isSelected = value === context.value;
    const isMountAnimationPreventedRef = $cQQee.useRef(isSelected);
    $cQQee.useEffect(()=>{
        const rAF = requestAnimationFrame(()=>isMountAnimationPreventedRef.current = false);
        return ()=>cancelAnimationFrame(rAF);
    }, []);
    return /* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $5061915239745df7$export$99c2b779aa4e8b8b), {
        present: forceMount || isSelected,
        children: ({ present: present })=>/* @__PURE__ */ (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $f679bf6067493560$export$250ffa63cdc0d034).div, {
                "data-state": isSelected ? "active" : "inactive",
                "data-orientation": context.orientation,
                role: "tabpanel",
                "aria-labelledby": triggerId,
                hidden: !present,
                id: contentId,
                tabIndex: 0,
                ...contentProps,
                ref: forwardedRef,
                style: {
                    ...props.style,
                    animationDuration: isMountAnimationPreventedRef.current ? "0s" : void 0
                },
                children: present && children
            })
    });
});
$4bdfeb660b0a3461$export$bd905d70e8fd2ebb.displayName = $4bdfeb660b0a3461$var$CONTENT_NAME;
function $4bdfeb660b0a3461$var$makeTriggerId(baseId, value) {
    return `${baseId}-trigger-${value}`;
}
function $4bdfeb660b0a3461$var$makeContentId(baseId, value) {
    return `${baseId}-content-${value}`;
}
var $4bdfeb660b0a3461$export$be92b6f5f03c0fe9 = $4bdfeb660b0a3461$export$b2539bed5023c21c;
var $4bdfeb660b0a3461$export$54c2e3dc7acea9f5 = $4bdfeb660b0a3461$export$9712d22edc0d78c1;
var $4bdfeb660b0a3461$export$41fb9f06171c75f4 = $4bdfeb660b0a3461$export$8114b9fdfdf9f3ba;
var $4bdfeb660b0a3461$export$7c6e2c02157bb7d2 = $4bdfeb660b0a3461$export$bd905d70e8fd2ebb;



var $7f6da9ee832de078$var$css_248z = "._1d6pvC8lAcA-{display:flex;flex-direction:column;height:100%;width:100%}._1d6pvC8lAcA- *{box-sizing:border-box}.S7LQJsHe8j8-{height:100%;width:100%}._7Nlb8VFH44Q-{background:rgb(var(--ng-neutral-20));border:1px solid rgb(var(--ng-border));border-radius:var(--ng-rd-8);flex-direction:row;flex-shrink:0;gap:var(--ng-gp-4);padding:var(--ng-gp-4);width:100%}.JpZf5R8P12c-,._7Nlb8VFH44Q-{align-items:center;display:flex;justify-content:center}.JpZf5R8P12c-{background:inherit;border:none;border-radius:var(--ng-rd-6);color:rgb(var(--ng-tertiary-text));cursor:pointer;flex:1;position:relative;transition:background .2s ease,box-shadow .2s ease;-webkit-user-select:none;-moz-user-select:none;user-select:none}.JpZf5R8P12c-:hover,.JpZf5R8P12c-[data-state=active]{background:rgb(var(--ng-neutral-0));color:rgb(var(--ng-primary-text))}.JpZf5R8P12c-[data-state=active]{box-shadow:0 1px 3px 0 rgba(var(--ng-shadow-black-8)),0 1px 2px 0 rgba(var(--ng-shadow-black-5))}";
var $7f6da9ee832de078$export$2e2bcd8739ae039 = {
    "root": "_1d6pvC8lAcA-",
    "content": "S7LQJsHe8j8-",
    "list": "_7Nlb8VFH44Q-",
    "trigger": "JpZf5R8P12c-"
};
(0, $4df8c7bf7afa5170$export$2e2bcd8739ae039)($7f6da9ee832de078$var$css_248z);



const $47b0b482b2d793ba$export$b4e0482aa0287ef0 = ({ ref: ref, className: className = '', ...props })=>{
    return (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $4bdfeb660b0a3461$export$be92b6f5f03c0fe9), {
        ref: ref,
        className: (0, $e99e5f020fa3ffc8$export$1343a74baacb0543)((0, $7f6da9ee832de078$export$2e2bcd8739ae039).root, className),
        ...props
    });
};
$47b0b482b2d793ba$export$b4e0482aa0287ef0.defaultProps = {
    className: '',
    ref: undefined
};
$47b0b482b2d793ba$export$b4e0482aa0287ef0.displayName = 'TabRoot';
const $47b0b482b2d793ba$export$e51a686c67fdaa2d = ({ ref: ref, className: className = '', ...props })=>{
    return (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $4bdfeb660b0a3461$export$54c2e3dc7acea9f5), {
        className: (0, $e99e5f020fa3ffc8$export$1343a74baacb0543)((0, $7f6da9ee832de078$export$2e2bcd8739ae039).list, className),
        ref: ref,
        ...props
    });
};
$47b0b482b2d793ba$export$e51a686c67fdaa2d.defaultProps = {
    className: '',
    ref: undefined
};
$47b0b482b2d793ba$export$e51a686c67fdaa2d.displayName = 'TabList';
const $47b0b482b2d793ba$export$9c591276dfd5d919 = ({ ref: ref, className: className = '', ...props })=>{
    return (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $4bdfeb660b0a3461$export$7c6e2c02157bb7d2), {
        ref: ref,
        className: (0, $e99e5f020fa3ffc8$export$1343a74baacb0543)((0, $7f6da9ee832de078$export$2e2bcd8739ae039).content, className),
        ...props
    });
};
$47b0b482b2d793ba$export$9c591276dfd5d919.defaultProps = {
    className: '',
    ref: undefined
};
$47b0b482b2d793ba$export$9c591276dfd5d919.displayName = 'TabContent';
const $47b0b482b2d793ba$export$f3811e092470e96d = ({ ref: ref, className: className = '', ...props })=>{
    return (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $4bdfeb660b0a3461$export$41fb9f06171c75f4), {
        ref: ref,
        className: (0, $e99e5f020fa3ffc8$export$1343a74baacb0543)((0, $7f6da9ee832de078$export$2e2bcd8739ae039).trigger, className, 'ng_v2_style'),
        ...props
    });
};
$47b0b482b2d793ba$export$f3811e092470e96d.defaultProps = {
    className: '',
    ref: undefined
};
$47b0b482b2d793ba$export$f3811e092470e96d.displayName = 'TabTrigger';


var $5bd23c586d1a9976$export$cb6da89c6af1a8ec;
(function(Size) {
    Size["SM"] = "sm";
    Size["LG"] = "lg";
})($5bd23c586d1a9976$export$cb6da89c6af1a8ec || ($5bd23c586d1a9976$export$cb6da89c6af1a8ec = {}));



var $5e0bbe752ef01215$var$css_248z = ".UnWr9chlf58-{height:32px}.aB7Cq8cosbY-{height:44px}.ggeNHMKs90g-{height:24px;max-height:24px}.e1y2tP0SwUc-{height:36px;max-height:36px}";
var $5e0bbe752ef01215$export$2e2bcd8739ae039 = {
    "list_size_sm": "UnWr9chlf58-",
    "list_size_lg": "aB7Cq8cosbY-",
    "trigger_size_sm": "ggeNHMKs90g-",
    "trigger_size_lg": "e1y2tP0SwUc-"
};
(0, $4df8c7bf7afa5170$export$2e2bcd8739ae039)($5e0bbe752ef01215$var$css_248z);


const $8377b7aa7d87d911$export$440efd74d8dddf4e = {
    [(0, $5bd23c586d1a9976$export$cb6da89c6af1a8ec).SM]: `${(0, $5e0bbe752ef01215$export$2e2bcd8739ae039).trigger_size_sm} ng_p_1_sb`,
    [(0, $5bd23c586d1a9976$export$cb6da89c6af1a8ec).LG]: `${(0, $5e0bbe752ef01215$export$2e2bcd8739ae039).trigger_size_lg} ng_btn_2_sb`
};
const $8377b7aa7d87d911$export$37b1f8f968e371f8 = {
    [(0, $5bd23c586d1a9976$export$cb6da89c6af1a8ec).SM]: `${(0, $5e0bbe752ef01215$export$2e2bcd8739ae039).list_size_sm}`,
    [(0, $5bd23c586d1a9976$export$cb6da89c6af1a8ec).LG]: `${(0, $5e0bbe752ef01215$export$2e2bcd8739ae039).list_size_lg}`
};




const $8dbe5fd4326e62ea$export$2e2bcd8739ae039 = (props)=>{
    const { className: className } = props;
    return (0, $81ee76508714b94a$export$35e795649ee09318).jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "none",
        className: className,
        children: (0, $81ee76508714b94a$export$35e795649ee09318).jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.5303 6.46967C12.8232 6.76256 12.8232 7.23744 12.5303 7.53033L8.81066 11.25H17C17.4142 11.25 17.75 11.5858 17.75 12C17.75 12.4142 17.4142 12.75 17 12.75H8.81066L12.5303 16.4697C12.8232 16.7626 12.8232 17.2374 12.5303 17.5303C12.2374 17.8232 11.7626 17.8232 11.4697 17.5303L6.46967 12.5303C6.17678 12.2374 6.17678 11.7626 6.46967 11.4697L11.4697 6.46967C11.7626 6.17678 12.2374 6.17678 12.5303 6.46967Z",
            fill: "#27313F"
        })
    });
};



const $b966e5236b52e36f$export$2e2bcd8739ae039 = ({ type: type = 'outline', ...rest })=>{
    if (type === 'outline') return (0, $81ee76508714b94a$export$35e795649ee09318).jsxs("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            (0, $81ee76508714b94a$export$35e795649ee09318).jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.66663 3.95833C5.63109 3.95833 4.79163 4.7978 4.79163 5.83333V14.1667C4.79163 15.2022 5.63109 16.0417 6.66663 16.0417H13.3333C14.3688 16.0417 15.2083 15.2022 15.2083 14.1667V8.64467C15.2083 8.28807 15.1066 7.93887 14.9152 7.63803L13.1261 4.82669C12.782 4.28585 12.1853 3.95833 11.5443 3.95833H6.66663ZM3.54163 5.83333C3.54163 4.10744 4.94074 2.70833 6.66663 2.70833H11.5443C12.6127 2.70833 13.6071 3.2542 14.1807 4.1556L15.9697 6.96693C16.2888 7.46834 16.4583 8.05034 16.4583 8.64467V14.1667C16.4583 15.8926 15.0592 17.2917 13.3333 17.2917H6.66663C4.94074 17.2917 3.54163 15.8926 3.54163 14.1667V5.83333Z",
                fill: "currentColor"
            }),
            (0, $81ee76508714b94a$export$35e795649ee09318).jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.66663 2.70833C7.0118 2.70833 7.29163 2.98815 7.29163 3.33333V5.83333C7.29163 5.94839 7.3849 6.04167 7.49996 6.04167H10.8333C10.9484 6.04167 11.0416 5.94839 11.0416 5.83333V3.33335C11.0416 2.98817 11.3214 2.70835 11.6666 2.70835C12.0118 2.70835 12.2916 2.98817 12.2916 3.33335V5.83333C12.2916 6.63875 11.6387 7.29167 10.8333 7.29167H7.49996C6.69454 7.29167 6.04163 6.63875 6.04163 5.83333V3.33333C6.04163 2.98815 6.32145 2.70833 6.66663 2.70833Z",
                fill: "currentColor"
            }),
            (0, $81ee76508714b94a$export$35e795649ee09318).jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.5 17.2917C12.1548 17.2917 11.875 17.0118 11.875 16.6667L11.875 12.5C11.875 12.3849 11.7817 12.2917 11.6667 12.2917L7.5 12.2917C7.38494 12.2917 7.29167 12.3849 7.29167 12.5L7.29167 16.6666C7.29167 17.0118 7.01184 17.2916 6.66667 17.2916C6.32149 17.2916 6.04167 17.0118 6.04167 16.6666L6.04167 12.5C6.04167 11.6946 6.69459 11.0417 7.5 11.0417L11.6667 11.0417C12.4721 11.0417 13.125 11.6946 13.125 12.5L13.125 16.6667C13.125 17.0118 12.8452 17.2917 12.5 17.2917Z",
                fill: "currentColor"
            })
        ]
    });
};
$b966e5236b52e36f$export$2e2bcd8739ae039.displayName = 'Save';



const $ceccd22facf02b64$export$2e2bcd8739ae039 = ({ type: type = 'outline', ...rest })=>{
    if (type === 'outline') return (0, $81ee76508714b94a$export$35e795649ee09318).jsxs("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            (0, $81ee76508714b94a$export$35e795649ee09318).jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.4955 10.2817C15.4955 10.2816 15.4954 10.2815 15.4953 10.2814L15.4955 10.2817ZM15.4953 10.2814L15.4953 10.2813L15.4919 10.2753L15.4753 10.2465C15.4598 10.2201 15.4357 10.1797 15.4032 10.1271C15.3381 10.0219 15.2395 9.8689 15.1094 9.684C14.8484 9.3131 14.4644 8.81974 13.9732 8.32845C12.9779 7.33317 11.6181 6.42017 10 6.42017C8.382 6.42017 7.02219 7.33317 6.02691 8.32845C5.53562 8.81974 5.15167 9.3131 4.89066 9.684C4.76055 9.8689 4.66199 10.0219 4.59689 10.1271C4.56436 10.1797 4.54025 10.2201 4.52479 10.2465L4.50815 10.2753L4.50477 10.2813L4.50471 10.2814C4.50465 10.2815 4.50459 10.2816 4.50453 10.2817L4.50441 10.2819C4.33663 10.5833 3.9564 10.6917 3.65483 10.5242C3.3531 10.3566 3.24438 9.97607 3.41201 9.67433L3.92222 9.95778C3.41202 9.67432 3.41213 9.67413 3.41224 9.67392L3.41252 9.67341L3.41325 9.67211L3.41535 9.66837L3.42213 9.6564C3.42779 9.64647 3.43574 9.63265 3.44594 9.61522C3.46634 9.58036 3.49578 9.53098 3.53406 9.46916C3.61055 9.34559 3.72258 9.17185 3.86841 8.96463C4.15929 8.55127 4.58863 7.99896 5.14302 7.44457C6.23909 6.34851 7.90011 5.17017 10 5.17017C12.1 5.17017 13.761 6.34851 14.857 7.44457C15.4114 7.99896 15.8408 8.55127 16.1317 8.96463C16.2775 9.17185 16.3895 9.34559 16.466 9.46916C16.5043 9.53098 16.5337 9.58036 16.5541 9.61522C16.5643 9.63265 16.5723 9.64647 16.5779 9.6564L16.5847 9.66837L16.5868 9.67211L16.5875 9.67341L16.5878 9.67392C16.5879 9.67413 16.588 9.67432 16.067 9.96381L16.588 9.67433C16.7557 9.97607 16.647 10.3566 16.3452 10.5242C16.0436 10.6918 15.6632 10.5832 15.4955 10.2817",
                fill: "currentColor"
            }),
            (0, $81ee76508714b94a$export$35e795649ee09318).jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M4.50454 9.71827C4.5046 9.71837 4.50466 9.71848 4.50471 9.71858L4.50454 9.71827ZM4.50471 9.71858L4.50477 9.71868L4.50816 9.72465L4.5248 9.75342C4.54025 9.77983 4.56436 9.82032 4.59689 9.87286C4.662 9.97804 4.76055 10.1311 4.89067 10.316C5.15167 10.6869 5.53563 11.1802 6.02691 11.6715C7.02219 12.6668 8.38201 13.5798 10 13.5798C11.6181 13.5798 12.9779 12.6668 13.9732 11.6715C14.4644 11.1802 14.8484 10.6869 15.1094 10.316C15.2395 10.1311 15.3381 9.97804 15.4032 9.87286C15.4357 9.82032 15.4598 9.77983 15.4753 9.75342L15.4919 9.72465L15.4953 9.71868L15.4954 9.71858C15.4954 9.71848 15.4955 9.71837 15.4955 9.71827L15.4956 9.71805C15.6634 9.41672 16.0437 9.30823 16.3452 9.47576C16.647 9.6434 16.7557 10.0239 16.588 10.3256L16.0778 10.0422C16.588 10.3256 16.5879 10.3258 16.5878 10.326L16.5875 10.3266L16.5868 10.3279L16.5847 10.3316L16.5779 10.3436C16.5723 10.3535 16.5643 10.3673 16.5541 10.3847C16.5337 10.4196 16.5043 10.469 16.466 10.5308C16.3895 10.6544 16.2775 10.8281 16.1317 11.0353C15.8408 11.4487 15.4114 12.001 14.857 12.5554C13.761 13.6515 12.1 14.8298 10 14.8298C7.90011 14.8298 6.23909 13.6515 5.14303 12.5554C4.58864 12.001 4.15929 11.4487 3.86841 11.0353C3.72259 10.8281 3.61055 10.6544 3.53406 10.5308C3.49579 10.469 3.46634 10.4196 3.44594 10.3847C3.43574 10.3673 3.4278 10.3535 3.42213 10.3436L3.41536 10.3316L3.41326 10.3279L3.41253 10.3266L3.41225 10.326C3.41213 10.3258 3.41202 10.3256 3.93308 10.0362L3.41202 10.3256C3.24438 10.0239 3.3531 9.6434 3.65484 9.47576C3.95647 9.30819 4.33682 9.41677 4.50454 9.71827",
                fill: "currentColor"
            }),
            (0, $81ee76508714b94a$export$35e795649ee09318).jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10 11.0737C9.40701 11.0737 8.92629 10.593 8.92629 9.99999C8.92629 9.40699 9.40701 8.92627 10 8.92627C10.593 8.92627 11.0737 9.40699 11.0737 9.99999C11.0737 10.593 10.593 11.0737 10 11.0737ZM10 12.3237C8.71666 12.3237 7.67629 11.2833 7.67629 9.99999C7.67629 8.71663 8.71666 7.67627 10 7.67627C11.2834 7.67627 12.3237 8.71663 12.3237 9.99999C12.3237 11.2833 11.2834 12.3237 10 12.3237Z",
                fill: "currentColor"
            })
        ]
    });
};
$ceccd22facf02b64$export$2e2bcd8739ae039.displayName = 'View';



const $7b83763c49875f48$export$2e2bcd8739ae039 = (props)=>{
    const { className: className } = props;
    return (0, $81ee76508714b94a$export$35e795649ee09318).jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 18 18",
        className: className,
        children: (0, $81ee76508714b94a$export$35e795649ee09318).jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M6.10225 7.10225C6.32192 6.88258 6.67808 6.88258 6.89775 7.10225L9.5 9.7045L12.1023 7.10225C12.3219 6.88258 12.6781 6.88258 12.8977 7.10225C13.1174 7.32192 13.1174 7.67808 12.8977 7.89775L9.89775 10.8977C9.67808 11.1174 9.32192 11.1174 9.10225 10.8977L6.10225 7.89775C5.88258 7.67808 5.88258 7.32192 6.10225 7.10225Z"
        })
    });
};
$7b83763c49875f48$export$2e2bcd8739ae039.defaultProps = {
    className: ''
};


// Shared default tokens (extracted to avoid duplicated string literals).
const $3b13960fa685cf4d$var$DEFAULT_SIZE_SM = 'sm';
const $3b13960fa685cf4d$var$DEFAULT_PREVIEW_LABEL = 'Preview';
/**
 * FormHeader — a flat set of compound components for form builder headers.
 *
 * Layout is consumer-driven: there is no auto-placement. Consumers import the
 * pieces individually and nest them to compose the header, exactly like the
 * Dropdown components:
 *
 *   <FormHeaderRoot>
 *     <FormHeaderLeft>
 *       <FormHeaderBackButton onClick={goBack} />
 *       <FormHeaderSeparator />
 *       <FormHeaderTitle>New Form 1</FormHeaderTitle>
 *     </FormHeaderLeft>
 *     <FormHeaderCenter>
 *       <FormHeaderTabs tabs={tabs} activeTab={t} onTabChange={setT} />
 *     </FormHeaderCenter>
 *     <FormHeaderRight>
 *       <FormHeaderPrimaryAction text="Save" onClick={save} />
 *       <FormHeaderPrimaryComboAction text="Publish" onMainClick={pub} actions={actions} />
 *     </FormHeaderRight>
 *   </FormHeaderRoot>
 *
 * The action slots provide design-system DEFAULTS for tokens like `variant` and
 * `size`, but every default stays overridable — the spread comes after the
 * defaults, so consumer props win.
 */ /**
 * FormHeaderRoot — outer layout container (the flex row that holds the
 * sections). Owns the root styling and the `ng_v2_style` wrapper; forwards a
 * `ref` and any standard `div` attributes (including `className`) to the element.
 */ const $3b13960fa685cf4d$export$7754e718c248a715 = (0, (/*@__PURE__*/$parcel$interopDefault($cQQee))).forwardRef(({ children: children, className: className = '', ...props }, ref)=>(0, $81ee76508714b94a$export$35e795649ee09318).jsx("div", {
        ref: ref,
        className: (0, $e99e5f020fa3ffc8$export$1343a74baacb0543)((0, $fd4af592836a3392$export$2e2bcd8739ae039).form_header_main, 'ng_v2_style', className),
        ...props,
        children: children
    }));
$3b13960fa685cf4d$export$7754e718c248a715.displayName = 'FormHeaderRoot';
/**
 * FormHeaderLeft — left section wrapper (BackButton, Separator, Title).
 */ const $3b13960fa685cf4d$export$6e2c9c2a8ecac6a8 = (0, (/*@__PURE__*/$parcel$interopDefault($cQQee))).forwardRef(({ children: children, className: className = '', ...props }, ref)=>(0, $81ee76508714b94a$export$35e795649ee09318).jsx("div", {
        ref: ref,
        className: (0, $e99e5f020fa3ffc8$export$1343a74baacb0543)((0, $fd4af592836a3392$export$2e2bcd8739ae039).form_header_left, className),
        ...props,
        children: children
    }));
$3b13960fa685cf4d$export$6e2c9c2a8ecac6a8.displayName = 'FormHeaderLeft';
/**
 * FormHeaderCenter — center section wrapper (Tabs). Grows to fill space.
 */ const $3b13960fa685cf4d$export$12c350cc054ce842 = (0, (/*@__PURE__*/$parcel$interopDefault($cQQee))).forwardRef(({ children: children, className: className = '', ...props }, ref)=>(0, $81ee76508714b94a$export$35e795649ee09318).jsx("div", {
        ref: ref,
        className: (0, $e99e5f020fa3ffc8$export$1343a74baacb0543)((0, $fd4af592836a3392$export$2e2bcd8739ae039).form_header_center, className),
        ...props,
        children: children
    }));
$3b13960fa685cf4d$export$12c350cc054ce842.displayName = 'FormHeaderCenter';
/**
 * FormHeaderRight — right section wrapper (PrimaryAction, PrimaryComboAction).
 */ const $3b13960fa685cf4d$export$7c66797c78d3fb9b = (0, (/*@__PURE__*/$parcel$interopDefault($cQQee))).forwardRef(({ children: children, className: className = '', ...props }, ref)=>(0, $81ee76508714b94a$export$35e795649ee09318).jsx("div", {
        ref: ref,
        className: (0, $e99e5f020fa3ffc8$export$1343a74baacb0543)((0, $fd4af592836a3392$export$2e2bcd8739ae039).form_header_right, className),
        ...props,
        children: children
    }));
$3b13960fa685cf4d$export$7c66797c78d3fb9b.displayName = 'FormHeaderRight';
/**
 * FormHeaderBackButton — left-section back affordance. Defaults `variant`,
 * `size`, `icon` (a back arrow) and the accessible `title`; all overridable
 * since `{...rest}` follows the defaults. Consumers who need a different icon
 * button can use the shared IconButton directly.
 */ const $3b13960fa685cf4d$export$72546349900c403b = ({ title: title = 'Back', variant: variant = 'secondary-gray', size: size = $3b13960fa685cf4d$var$DEFAULT_SIZE_SM, icon: icon = (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $8dbe5fd4326e62ea$export$2e2bcd8739ae039), {}), ...rest })=>{
    return (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $dbb74cb604a2ffe4$export$2e2bcd8739ae039), {
        variant: variant,
        size: size,
        icon: icon,
        title: title,
        ...rest
    });
};
/**
 * FormHeaderTitle — pass-through left-section title slot. Renders children
 * as-is so consumers can drop in text or their own inline-editor component.
 */ const $3b13960fa685cf4d$export$979afebc6a69047 = (0, (/*@__PURE__*/$parcel$interopDefault($cQQee))).forwardRef(({ children: children, className: className = '', title: title, ...props }, ref)=>{
    const text = typeof children === 'string' ? children : undefined;
    return (0, $81ee76508714b94a$export$35e795649ee09318).jsx("span", {
        ref: ref,
        className: (0, $e99e5f020fa3ffc8$export$1343a74baacb0543)((0, $fd4af592836a3392$export$2e2bcd8739ae039).form_header_title, className),
        title: title ?? text,
        ...props,
        children: children
    });
});
$3b13960fa685cf4d$export$979afebc6a69047.displayName = 'FormHeaderTitle';
/**
 * FormHeaderSeparator — vertical divider for the left section. Defaults
 * `orientation` and `length`, both overridable.
 */ const $3b13960fa685cf4d$export$eaf04fc8aa0a690a = (0, (/*@__PURE__*/$parcel$interopDefault($cQQee))).forwardRef(({ orientation: orientation = 'vertical', length: length = 'var(--ng-s-20)', className: className = '', ...props }, ref)=>(0, $81ee76508714b94a$export$35e795649ee09318).jsx("div", {
        ref: ref,
        className: (0, $e99e5f020fa3ffc8$export$1343a74baacb0543)(className),
        ...props,
        children: (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $cc0bb6c392922fb5$export$2e2bcd8739ae039), {
            orientation: orientation,
            length: length
        })
    }));
$3b13960fa685cf4d$export$eaf04fc8aa0a690a.displayName = 'FormHeaderSeparator';
/**
 * FormHeaderTabs — center-section tab selector. A controlled, selector-only tab
 * strip built on the shared Tabs primitives; renders NO content panels. The
 * inline-flex wrapper keeps the strip at its content width.
 *
 * NOTE: the public `Tabs` component always renders a Content panel, which the
 * header does not want — so this intentionally mirrors `tabs/List.tsx`, reusing
 * the same primitives (TabRoot/TabList/TabTrigger) and the same style-class maps
 * (`listStyleClassMap`/`triggerStyleClassMap`). Keep this body in sync with
 * `tabs/List.tsx` if the tabs module changes how a size maps to classes.
 */ const $3b13960fa685cf4d$export$444e1d5fba5f7771 = (0, (/*@__PURE__*/$parcel$interopDefault($cQQee))).forwardRef(({ tabs: tabs, activeTab: activeTab, onTabChange: onTabChange, size: size = (0, $5bd23c586d1a9976$export$cb6da89c6af1a8ec).SM, className: className = '', ...props }, ref)=>(0, $81ee76508714b94a$export$35e795649ee09318).jsx("div", {
        ref: ref,
        className: (0, $e99e5f020fa3ffc8$export$1343a74baacb0543)((0, $fd4af592836a3392$export$2e2bcd8739ae039).form_header_tabs, className),
        ...props,
        children: (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $47b0b482b2d793ba$export$b4e0482aa0287ef0), {
            value: activeTab,
            defaultValue: tabs?.[0]?.id,
            onValueChange: onTabChange,
            children: (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $47b0b482b2d793ba$export$e51a686c67fdaa2d), {
                className: (0, $e99e5f020fa3ffc8$export$1343a74baacb0543)('tabs-list', (0, $8377b7aa7d87d911$export$37b1f8f968e371f8)?.[size]),
                children: tabs?.map((tab)=>(0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $47b0b482b2d793ba$export$f3811e092470e96d), {
                        value: tab.id,
                        disabled: tab.disabled,
                        className: (0, $e99e5f020fa3ffc8$export$1343a74baacb0543)('trigger', (0, $8377b7aa7d87d911$export$440efd74d8dddf4e)?.[size]),
                        children: tab.title
                    }, `trigger-${tab.id}`))
            })
        })
    }));
$3b13960fa685cf4d$export$444e1d5fba5f7771.displayName = 'FormHeaderTabs';
/**
 * FormHeaderPrimaryAction — right-section button slot. Defaults `variant` and
 * `size` (`primary`/`sm`), both overridable.
 */ const $3b13960fa685cf4d$export$86e3a47e346e180a = ({ variant: variant = 'primary', size: size = $3b13960fa685cf4d$var$DEFAULT_SIZE_SM, ...rest })=>{
    return (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $93eff1b09ae4008c$export$2e2bcd8739ae039), {
        variant: variant,
        size: size,
        ...rest
    });
};
/**
 * FormHeaderSecondaryAction — right-section button slot for lower-emphasis
 * actions. Defaults `variant`, `size` (`secondary`/`sm`) and all overridable.
 */ const $3b13960fa685cf4d$export$84f37cd221ac9bac = ({ variant: variant = 'secondary', size: size = $3b13960fa685cf4d$var$DEFAULT_SIZE_SM, ...rest })=>{
    return (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $93eff1b09ae4008c$export$2e2bcd8739ae039), {
        variant: variant,
        size: size,
        ...rest
    });
};
/**
 * FormHeaderPrimaryComboAction — split button (main action + dropdown) slot.
 * Defaults `dropdownIcon`, `variant` and `size`, all overridable.
 */ const $3b13960fa685cf4d$export$9be100aadb15f6fa = ({ dropdownIcon: dropdownIcon = (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $7b83763c49875f48$export$2e2bcd8739ae039), {
    className: (0, $fd4af592836a3392$export$2e2bcd8739ae039).combo_dropdown_trigger_icon
}), variant: variant = 'primary', size: size = $3b13960fa685cf4d$var$DEFAULT_SIZE_SM, ...rest })=>{
    return (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $006da0d336faf0a2$export$2e2bcd8739ae039), {
        dropdownIcon: dropdownIcon,
        variant: variant,
        size: size,
        ...rest
    });
};
/**
 * FormHeaderSaveIconButton — icon-only save affordance. Defaults `variant`
 * (`secondary`), `size`, `icon` (a save glyph) and the accessible `title`; all
 * overridable since `{...rest}` follows the defaults.
 */ const $3b13960fa685cf4d$export$cea79ba491fd3352 = ({ title: title = 'Save', variant: variant = 'secondary', size: size = $3b13960fa685cf4d$var$DEFAULT_SIZE_SM, icon: icon = (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $b966e5236b52e36f$export$2e2bcd8739ae039), {}), ...rest })=>{
    return (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $dbb74cb604a2ffe4$export$2e2bcd8739ae039), {
        variant: variant,
        size: size,
        icon: icon,
        title: title,
        ...rest
    });
};
/**
 * FormHeaderPreviewFrame — bordered pill wrapper for the preview toggle's
 * pieces. Presentational only; lay out icon/label/switch as children.
 */ const $3b13960fa685cf4d$export$fa351e565276b464 = (0, (/*@__PURE__*/$parcel$interopDefault($cQQee))).forwardRef(({ children: children, className: className = '', ...props }, ref)=>(0, $81ee76508714b94a$export$35e795649ee09318).jsx("div", {
        ref: ref,
        className: (0, $e99e5f020fa3ffc8$export$1343a74baacb0543)((0, $fd4af592836a3392$export$2e2bcd8739ae039).form_header_preview_frame, className),
        ...props,
        children: children
    }));
$3b13960fa685cf4d$export$fa351e565276b464.displayName = 'FormHeaderPreviewFrame';
/**
 * FormHeaderPreviewIcon — leading icon for the preview toggle. Defaults to an
 * eye glyph; override by passing different children.
 */ const $3b13960fa685cf4d$export$817df09df1207503 = (0, (/*@__PURE__*/$parcel$interopDefault($cQQee))).forwardRef(({ children: children = (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $ceccd22facf02b64$export$2e2bcd8739ae039), {
    type: "outline"
}), className: className = '', ...props }, ref)=>(0, $81ee76508714b94a$export$35e795649ee09318).jsx("span", {
        ref: ref,
        className: (0, $e99e5f020fa3ffc8$export$1343a74baacb0543)((0, $fd4af592836a3392$export$2e2bcd8739ae039).form_header_preview_icon, className),
        ...props,
        children: children
    }));
$3b13960fa685cf4d$export$817df09df1207503.displayName = 'FormHeaderPreviewIcon';
/**
 * FormHeaderPreviewLabel — text for the preview toggle. Defaults to "Preview";
 * override by passing different children.
 */ const $3b13960fa685cf4d$export$6672b88d53f182a4 = (0, (/*@__PURE__*/$parcel$interopDefault($cQQee))).forwardRef(({ children: children = $3b13960fa685cf4d$var$DEFAULT_PREVIEW_LABEL, className: className = '', title: title, ...props }, ref)=>{
    const text = typeof children === 'string' ? children : undefined;
    return (0, $81ee76508714b94a$export$35e795649ee09318).jsx("span", {
        ref: ref,
        className: (0, $e99e5f020fa3ffc8$export$1343a74baacb0543)('ng_sh_b', (0, $fd4af592836a3392$export$2e2bcd8739ae039).form_header_preview_label, className),
        title: title ?? text,
        ...props,
        children: children
    });
});
$3b13960fa685cf4d$export$6672b88d53f182a4.displayName = 'FormHeaderPreviewLabel';
/**
 * FormHeaderPreviewSwitch — controlled pass-through to the shared Switch.
 * Defaults `label` (aria-only) to "Preview" and `size` to 'sm', both overridable.
 */ const $3b13960fa685cf4d$export$76917fd93792a5e6 = ({ label: label = $3b13960fa685cf4d$var$DEFAULT_PREVIEW_LABEL, size: size = $3b13960fa685cf4d$var$DEFAULT_SIZE_SM, ...rest })=>{
    return (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $c61e96086977e038$export$2e2bcd8739ae039), {
        label: label,
        size: size,
        ...rest
    });
};
/**
 * FormHeaderPreviewToggle — convenience preset rendering the canonical
 * arrangement of the four preview blocks (frame > icon + label + switch). Full
 * pass-through: each prop forwards to the matching block. For non-canonical
 * layouts, compose the four blocks directly.
 */ const $3b13960fa685cf4d$export$3ba6f98b74cf45b3 = (0, (/*@__PURE__*/$parcel$interopDefault($cQQee))).forwardRef(({ checked: checked, onCheckedChange: onCheckedChange, label: label = $3b13960fa685cf4d$var$DEFAULT_PREVIEW_LABEL, icon: icon = (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $ceccd22facf02b64$export$2e2bcd8739ae039), {
    type: "outline"
}), size: size = $3b13960fa685cf4d$var$DEFAULT_SIZE_SM, disabled: disabled, className: className = '', ...props }, ref)=>(0, $81ee76508714b94a$export$35e795649ee09318).jsxs($3b13960fa685cf4d$export$fa351e565276b464, {
        ref: ref,
        className: className,
        ...props,
        children: [
            (0, $81ee76508714b94a$export$35e795649ee09318).jsx($3b13960fa685cf4d$export$817df09df1207503, {
                children: icon
            }),
            (0, $81ee76508714b94a$export$35e795649ee09318).jsx($3b13960fa685cf4d$export$6672b88d53f182a4, {
                children: label
            }),
            (0, $81ee76508714b94a$export$35e795649ee09318).jsx($3b13960fa685cf4d$export$76917fd93792a5e6, {
                checked: checked,
                onCheckedChange: onCheckedChange,
                label: label,
                size: size,
                disabled: disabled
            })
        ]
    }));
$3b13960fa685cf4d$export$3ba6f98b74cf45b3.displayName = 'FormHeaderPreviewToggle';


const $e6b31b84f595e6b6$var$LSQTabMenu = ({ className: className, options: // optionClassName,
options, onTabChange: onTabChange, activeIndex: activeIndex = 0, ...restProps })=>{
    const tabs = options.map((option)=>({
            id: option.id || option.label,
            title: option.label,
            disabled: option.disabled || false
        }));
    const [activeTab, setActiveTab] = (0, $cQQee.useState)(tabs[activeIndex]?.id || tabs[0]?.id);
    (0, $cQQee.useEffect)(()=>{
        const newActiveId = tabs[activeIndex]?.id;
        if (newActiveId && newActiveId !== activeTab) setActiveTab(newActiveId);
    }, [
        activeIndex,
        tabs,
        activeTab
    ]);
    const handleTabChange = (tabId)=>{
        setActiveTab(tabId);
        const index = tabs.findIndex((tab)=>tab.id === tabId);
        if (index !== -1 && onTabChange) onTabChange({
            index: index,
            value: options[index]
        });
    };
    if (options?.length > 0) return /*#__PURE__*/ (0, $7Tw3V.jsx)((0, $3b13960fa685cf4d$export$444e1d5fba5f7771), {
        tabs: tabs,
        activeTab: activeTab,
        onTabChange: handleTabChange,
        className: className,
        ...restProps
    });
};
$e6b31b84f595e6b6$var$LSQTabMenu.propTypes = {
    className: (0, (/*@__PURE__*/$parcel$interopDefault($9AqQV))).string,
    optionClassName: (0, (/*@__PURE__*/$parcel$interopDefault($9AqQV))).string,
    options: (0, (/*@__PURE__*/$parcel$interopDefault($9AqQV))).array.isRequired,
    onTabChange: (0, (/*@__PURE__*/$parcel$interopDefault($9AqQV))).func,
    activeIndex: (0, (/*@__PURE__*/$parcel$interopDefault($9AqQV))).number
};
var $e6b31b84f595e6b6$export$2e2bcd8739ae039 = $e6b31b84f595e6b6$var$LSQTabMenu;



var $7Tw3V = parcelRequire("7Tw3V");

var $cQQee = parcelRequire("cQQee");


var $7Tw3V = parcelRequire("7Tw3V");
parcelRequire("cQQee");
var $58479eac843bef17$exports = {};
/*!
  react-datepicker v7.6.0
  https://github.com/Hacker0x01/react-datepicker
  Released under the MIT License.
*/ 































































!function(e, t) {
    t($58479eac843bef17$exports, (parcelRequire("lY25K")), (parcelRequire("cQQee")), (parcelRequire("fxvWq")), (parcelRequire("cBVis")), (parcelRequire("ghcs4")), (parcelRequire("84Jkb")), (parcelRequire("fIUbm")), (parcelRequire("7IMv5")), (parcelRequire("3WSWZ")), (parcelRequire("iiBmk")), (parcelRequire("joePE")), (parcelRequire("fctE0")), (parcelRequire("eUT4w")), (parcelRequire("ilnvA")), (parcelRequire("bnwnB")), (parcelRequire("ikjzL")), (parcelRequire("5pWy6")), (parcelRequire("frXCW")), (parcelRequire("k041Q")), (parcelRequire("9YOIL")), (parcelRequire("egMd8")), (parcelRequire("kvN19")), (parcelRequire("7mqxe")), (parcelRequire("dGxHQ")), (parcelRequire("dJJxk")), (parcelRequire("96SbU")), (parcelRequire("ieGzH")), (parcelRequire("9l3oy")), (parcelRequire("dEs1B")), (parcelRequire("c5nsv")), (parcelRequire("4akuu")), (parcelRequire("kLebH")), (parcelRequire("jGg0G")), (parcelRequire("477Vo")), (parcelRequire("8w9BL")), (parcelRequire("6ON3R")), (parcelRequire("AQVHH")), (parcelRequire("ltZPS")), (parcelRequire("cmplH")), (parcelRequire("438Ab")), (parcelRequire("kmUtk")), (parcelRequire("eiMgd")), (parcelRequire("dZnFS")), (parcelRequire("hbpCX")), (parcelRequire("3OIEn")), (parcelRequire("2qbw1")), (parcelRequire("avSVV")), (parcelRequire("fMQT4")), (parcelRequire("5OQUm")), (parcelRequire("8UzgH")), (parcelRequire("gfq0K")), (parcelRequire("aorCW")), (parcelRequire("Gd0bX")), (parcelRequire("7KsKS")), (parcelRequire("isuGI")), (parcelRequire("bnoYK")), (parcelRequire("lbcdn")), (parcelRequire("4hV23")), (parcelRequire("bz9Dw")), (parcelRequire("9DOwY")), (parcelRequire("2qVDZ")), (parcelRequire("b3MCU")), (parcelRequire("cCao2")), (parcelRequire("kC364")));
}($58479eac843bef17$exports, function(e, t, r, n, a, o, s, i, l, c, d, p, u, f, h, m, v, g, D, y, k, w, S, b, M, C, _, E, P, Y, x, O, N, T, I, R, L, F, A, W, H, Q, q, K, B, V, j, U, $, z, X, G, J, Z, ee, te, re, ne, ae, oe, se, ie, le, ce, de) {
    "use strict";
    function pe(e) {
        return e && "object" == typeof e && "default" in e ? e : {
            default: e
        };
    }
    var ue = pe(r), fe = pe(de), he = function(e, t) {
        return he = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(e, t) {
            e.__proto__ = t;
        } || function(e, t) {
            for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
        }, he(e, t);
    };
    function me(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function r() {
            this.constructor = e;
        }
        he(e, t), e.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r);
    }
    var ve = function() {
        return ve = Object.assign || function(e) {
            for(var t, r = 1, n = arguments.length; r < n; r++)for(var a in t = arguments[r])Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
            return e;
        }, ve.apply(this, arguments);
    };
    function ge(e, t, r) {
        if (r || 2 === arguments.length) for(var n, a = 0, o = t.length; a < o; a++)!n && a in t || (n || (n = Array.prototype.slice.call(t, 0, a)), n[a] = t[a]);
        return e.concat(n || Array.prototype.slice.call(t));
    }
    "function" == typeof SuppressedError && SuppressedError;
    var De, ye = function(e) {
        var t = e.showTimeSelectOnly, r = void 0 !== t && t, n = e.showTime, a = void 0 !== n && n, o = e.className, s = e.children, i = r ? "Choose Time" : "Choose Date".concat(a ? " and Time" : "");
        return ue.default.createElement("div", {
            className: o,
            role: "dialog",
            "aria-label": i,
            "aria-modal": "true"
        }, s);
    }, ke = function(e) {
        var t = e.children, n = e.onClickOutside, a = e.className, o = e.containerRef, s = e.style, i = function(e, t) {
            var n = r.useRef(null), a = r.useRef(e);
            a.current = e;
            var o = r.useCallback(function(e) {
                var r;
                n.current && !n.current.contains(e.target) && (t && e.target instanceof HTMLElement && e.target.classList.contains(t) || null === (r = a.current) || void 0 === r || r.call(a, e));
            }, [
                t
            ]);
            return r.useEffect(function() {
                return document.addEventListener("mousedown", o), function() {
                    document.removeEventListener("mousedown", o);
                };
            }, [
                o
            ]), n;
        }(n, e.ignoreClass);
        return ue.default.createElement("div", {
            className: a,
            style: s,
            ref: function(e) {
                i.current = e, o && (o.current = e);
            }
        }, t);
    };
    function we() {
        return "undefined" != typeof window ? window : globalThis;
    }
    !function(e) {
        e.ArrowUp = "ArrowUp", e.ArrowDown = "ArrowDown", e.ArrowLeft = "ArrowLeft", e.ArrowRight = "ArrowRight", e.PageUp = "PageUp", e.PageDown = "PageDown", e.Home = "Home", e.End = "End", e.Enter = "Enter", e.Space = " ", e.Tab = "Tab", e.Escape = "Escape", e.Backspace = "Backspace", e.X = "x";
    }(De || (De = {}));
    var Se = 12, be = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
    function Me(e) {
        if (null == e) return new Date;
        var t = "string" == typeof e ? B.parseISO(e) : le.toDate(e);
        return _e(t) ? t : new Date;
    }
    function Ce(e, t, r, n, a) {
        var o, s = null, i = Ve(r) || Ve(Be()), l = !0;
        if (Array.isArray(t)) return t.forEach(function(t) {
            var o = K.parse(e, t, new Date, {
                locale: i,
                useAdditionalWeekYearTokens: !0,
                useAdditionalDayOfYearTokens: !0
            });
            n && (l = _e(o, a) && e === Ee(o, t, r)), _e(o, a) && l && (s = o);
        }), s;
        if (s = K.parse(e, t, new Date, {
            locale: i,
            useAdditionalWeekYearTokens: !0,
            useAdditionalDayOfYearTokens: !0
        }), n) l = _e(s) && e === Ee(s, t, r);
        else if (!_e(s)) {
            var c = (null !== (o = t.match(be)) && void 0 !== o ? o : []).map(function(e) {
                var t = e[0];
                if ("p" === t || "P" === t) {
                    var r = k.longFormatters[t];
                    return i ? r(e, i.formatLong) : t;
                }
                return e;
            }).join("");
            e.length > 0 && (s = K.parse(e, c.slice(0, e.length), new Date, {
                useAdditionalWeekYearTokens: !0,
                useAdditionalDayOfYearTokens: !0
            })), _e(s) || (s = new Date(e));
        }
        return _e(s) && l ? s : null;
    }
    function _e(e, t) {
        return W.isValid(e) && !N.isBefore(e, null != t ? t : new Date("1/1/1800"));
    }
    function Ee(e, t, r) {
        if ("en" === r) return k.format(e, t, {
            useAdditionalWeekYearTokens: !0,
            useAdditionalDayOfYearTokens: !0
        });
        var n = r ? Ve(r) : void 0;
        return r && !n && console.warn('A locale object was not found for the provided string ["'.concat(r, '"].')), !n && Be() && Ve(Be()) && (n = Ve(Be())), k.format(e, t, {
            locale: n,
            useAdditionalWeekYearTokens: !0,
            useAdditionalDayOfYearTokens: !0
        });
    }
    function Pe(e, t) {
        var r = t.dateFormat, n = t.locale, a = Array.isArray(r) && r.length > 0 ? r[0] : r;
        return e && Ee(e, a, n) || "";
    }
    function Ye(e, t) {
        var r = t.hour, n = void 0 === r ? 0 : r, a = t.minute, o = void 0 === a ? 0 : a, s = t.second, i = void 0 === s ? 0 : s;
        return j.setHours(U.setMinutes(X.setSeconds(e, i), o), n);
    }
    function xe(e) {
        return J.startOfDay(e);
    }
    function Oe(e, t, r) {
        var n = Ve(t || Be());
        return te.startOfWeek(e, {
            locale: n,
            weekStartsOn: r
        });
    }
    function Ne(e) {
        return Z.startOfMonth(e);
    }
    function Te(e) {
        return re.startOfYear(e);
    }
    function Ie(e) {
        return ee.startOfQuarter(e);
    }
    function Re() {
        return J.startOfDay(Me());
    }
    function Le(e) {
        return v.endOfDay(e);
    }
    function Fe(e) {
        return g.endOfMonth(e);
    }
    function Ae(e, t) {
        return e && t ? A.isSameYear(e, t) : !e && !t;
    }
    function We(e, t) {
        return e && t ? L.isSameMonth(e, t) : !e && !t;
    }
    function He(e, t) {
        return e && t ? F.isSameQuarter(e, t) : !e && !t;
    }
    function Qe(e, t) {
        return e && t ? R.isSameDay(e, t) : !e && !t;
    }
    function qe(e, t) {
        return e && t ? I.isEqual(e, t) : !e && !t;
    }
    function Ke(e, t, r) {
        var n, a = J.startOfDay(t), o = v.endOfDay(r);
        try {
            n = H.isWithinInterval(e, {
                start: a,
                end: o
            });
        } catch (e) {
            n = !1;
        }
        return n;
    }
    function Be() {
        return we().__localeId__;
    }
    function Ve(e) {
        if ("string" == typeof e) {
            var t = we();
            return t.__localeData__ ? t.__localeData__[e] : void 0;
        }
        return e;
    }
    function je(e, t) {
        return Ee($.setMonth(Me(), e), "LLLL", t);
    }
    function Ue(e, t) {
        return Ee($.setMonth(Me(), e), "LLL", t);
    }
    function $e(e, t) {
        var r = void 0 === t ? {} : t, n = r.minDate, a = r.maxDate, o = r.excludeDates, s = r.excludeDateIntervals, i = r.includeDates, l = r.includeDateIntervals, c = r.filterDate;
        return nt(e, {
            minDate: n,
            maxDate: a
        }) || o && o.some(function(t) {
            return t instanceof Date ? Qe(e, t) : Qe(e, t.date);
        }) || s && s.some(function(t) {
            var r = t.start, n = t.end;
            return H.isWithinInterval(e, {
                start: r,
                end: n
            });
        }) || i && !i.some(function(t) {
            return Qe(e, t);
        }) || l && !l.some(function(t) {
            var r = t.start, n = t.end;
            return H.isWithinInterval(e, {
                start: r,
                end: n
            });
        }) || c && !c(Me(e)) || !1;
    }
    function ze(e, t) {
        var r = void 0 === t ? {} : t, n = r.excludeDates, a = r.excludeDateIntervals;
        return a && a.length > 0 ? a.some(function(t) {
            var r = t.start, n = t.end;
            return H.isWithinInterval(e, {
                start: r,
                end: n
            });
        }) : n && n.some(function(t) {
            var r;
            return t instanceof Date ? Qe(e, t) : Qe(e, null !== (r = t.date) && void 0 !== r ? r : new Date);
        }) || !1;
    }
    function Xe(e, t) {
        var r = void 0 === t ? {} : t, n = r.minDate, a = r.maxDate, o = r.excludeDates, s = r.includeDates, i = r.filterDate;
        return nt(e, {
            minDate: n ? Z.startOfMonth(n) : void 0,
            maxDate: a ? g.endOfMonth(a) : void 0
        }) || (null == o ? void 0 : o.some(function(t) {
            return We(e, t instanceof Date ? t : t.date);
        })) || s && !s.some(function(t) {
            return We(e, t);
        }) || i && !i(Me(e)) || !1;
    }
    function Ge(e, t, r, n) {
        var a = x.getYear(e), o = _.getMonth(e), s = x.getYear(t), i = _.getMonth(t), l = x.getYear(n);
        return a === s && a === l ? o <= r && r <= i : a < s && (l === a && o <= r || l === s && i >= r || l < s && l > a);
    }
    function Je(e, t) {
        var r = void 0 === t ? {} : t, n = r.minDate, a = r.maxDate, o = r.excludeDates, s = r.includeDates;
        return nt(e, {
            minDate: n,
            maxDate: a
        }) || o && o.some(function(t) {
            return We(t instanceof Date ? t : t.date, e);
        }) || s && !s.some(function(t) {
            return We(t, e);
        }) || !1;
    }
    function Ze(e, t) {
        var r = void 0 === t ? {} : t, n = r.minDate, a = r.maxDate, o = r.excludeDates, s = r.includeDates, i = r.filterDate;
        return nt(e, {
            minDate: n,
            maxDate: a
        }) || (null == o ? void 0 : o.some(function(t) {
            return He(e, t instanceof Date ? t : t.date);
        })) || s && !s.some(function(t) {
            return He(e, t);
        }) || i && !i(Me(e)) || !1;
    }
    function et(e, t, r) {
        if (!t || !r) return !1;
        if (!W.isValid(t) || !W.isValid(r)) return !1;
        var n = x.getYear(t), a = x.getYear(r);
        return n <= e && a >= e;
    }
    function tt(e, t) {
        var r = void 0 === t ? {} : t, n = r.minDate, a = r.maxDate, o = r.excludeDates, s = r.includeDates, i = r.filterDate, l = new Date(e, 0, 1);
        return nt(l, {
            minDate: n ? re.startOfYear(n) : void 0,
            maxDate: a ? y.endOfYear(a) : void 0
        }) || (null == o ? void 0 : o.some(function(e) {
            return Ae(l, e instanceof Date ? e : e.date);
        })) || s && !s.some(function(e) {
            return Ae(l, e);
        }) || i && !i(Me(l)) || !1;
    }
    function rt(e, t, r, n) {
        var a = x.getYear(e), o = E.getQuarter(e), s = x.getYear(t), i = E.getQuarter(t), l = x.getYear(n);
        return a === s && a === l ? o <= r && r <= i : a < s && (l === a && o <= r || l === s && i >= r || l < s && l > a);
    }
    function nt(e, t) {
        var r, n = void 0 === t ? {} : t, a = n.minDate, o = n.maxDate;
        return null !== (r = a && u.differenceInCalendarDays(e, a) < 0 || o && u.differenceInCalendarDays(e, o) > 0) && void 0 !== r && r;
    }
    function at(e, t) {
        return t.some(function(t) {
            return b.getHours(t) === b.getHours(e) && C.getMinutes(t) === C.getMinutes(e) && P.getSeconds(t) === P.getSeconds(e);
        });
    }
    function ot(e, t) {
        var r = void 0 === t ? {} : t, n = r.excludeTimes, a = r.includeTimes, o = r.filterTime;
        return n && at(e, n) || a && !at(e, a) || o && !o(e) || !1;
    }
    function st(e, t) {
        var r = t.minTime, n = t.maxTime;
        if (!r || !n) throw new Error("Both minTime and maxTime props required");
        var a = Me();
        a = j.setHours(a, b.getHours(e)), a = U.setMinutes(a, C.getMinutes(e)), a = X.setSeconds(a, P.getSeconds(e));
        var o = Me();
        o = j.setHours(o, b.getHours(r)), o = U.setMinutes(o, C.getMinutes(r)), o = X.setSeconds(o, P.getSeconds(r));
        var s, i = Me();
        i = j.setHours(i, b.getHours(n)), i = U.setMinutes(i, C.getMinutes(n)), i = X.setSeconds(i, P.getSeconds(n));
        try {
            s = !H.isWithinInterval(a, {
                start: o,
                end: i
            });
        } catch (e) {
            s = !1;
        }
        return s;
    }
    function it(e, t) {
        var r = void 0 === t ? {} : t, n = r.minDate, a = r.includeDates, o = ae.subMonths(e, 1);
        return n && f.differenceInCalendarMonths(n, o) > 0 || a && a.every(function(e) {
            return f.differenceInCalendarMonths(e, o) > 0;
        }) || !1;
    }
    function lt(e, t) {
        var r = void 0 === t ? {} : t, n = r.maxDate, a = r.includeDates, o = i.addMonths(e, 1);
        return n && f.differenceInCalendarMonths(o, n) > 0 || a && a.every(function(e) {
            return f.differenceInCalendarMonths(o, e) > 0;
        }) || !1;
    }
    function ct(e, t) {
        var r = void 0 === t ? {} : t, n = r.minDate, a = r.includeDates, o = ie.subYears(e, 1);
        return n && m.differenceInCalendarYears(n, o) > 0 || a && a.every(function(e) {
            return m.differenceInCalendarYears(e, o) > 0;
        }) || !1;
    }
    function dt(e, t) {
        var r = void 0 === t ? {} : t, n = r.maxDate, a = r.includeDates, o = p.addYears(e, 1);
        return n && m.differenceInCalendarYears(o, n) > 0 || a && a.every(function(e) {
            return m.differenceInCalendarYears(o, e) > 0;
        }) || !1;
    }
    function pt(e) {
        var t = e.minDate, r = e.includeDates;
        if (r && t) {
            var n = r.filter(function(e) {
                return u.differenceInCalendarDays(e, t) >= 0;
            });
            return q.min(n);
        }
        return r ? q.min(r) : t;
    }
    function ut(e) {
        var t = e.maxDate, r = e.includeDates;
        if (r && t) {
            var n = r.filter(function(e) {
                return u.differenceInCalendarDays(e, t) <= 0;
            });
            return Q.max(n);
        }
        return r ? Q.max(r) : t;
    }
    function ft(e, t) {
        var r;
        void 0 === e && (e = []), void 0 === t && (t = "react-datepicker__day--highlighted");
        for(var n = new Map, a = 0, o = e.length; a < o; a++){
            var s = e[a];
            if (T.isDate(s)) {
                var i = Ee(s, "MM.dd.yyyy");
                (f = n.get(i) || []).includes(t) || (f.push(t), n.set(i, f));
            } else if ("object" == typeof s) {
                var l = null !== (r = Object.keys(s)[0]) && void 0 !== r ? r : "", c = s[l];
                if ("string" == typeof l && Array.isArray(c)) for(var d = 0, p = c.length; d < p; d++){
                    var u = c[d];
                    if (u) {
                        var f;
                        i = Ee(u, "MM.dd.yyyy");
                        (f = n.get(i) || []).includes(l) || (f.push(l), n.set(i, f));
                    }
                }
            }
        }
        return n;
    }
    function ht(e, t) {
        void 0 === e && (e = []), void 0 === t && (t = "react-datepicker__day--holidays");
        var r = new Map;
        return e.forEach(function(e) {
            var n = e.date, a = e.holidayName;
            if (T.isDate(n)) {
                var o = Ee(n, "MM.dd.yyyy"), s = r.get(o) || {
                    className: "",
                    holidayNames: []
                };
                if (!("className" in s) || s.className !== t || (i = s.holidayNames, l = [
                    a
                ], i.length !== l.length || !i.every(function(e, t) {
                    return e === l[t];
                }))) {
                    var i, l;
                    s.className = t;
                    var c = s.holidayNames;
                    s.holidayNames = c ? ge(ge([], c, !0), [
                        a
                    ], !1) : [
                        a
                    ], r.set(o, s);
                }
            }
        }), r;
    }
    function mt(e, t, r, n, a) {
        for(var i = a.length, l = [], d = 0; d < i; d++){
            var p = e, u = a[d];
            u && (p = o.addHours(p, b.getHours(u)), p = s.addMinutes(p, C.getMinutes(u)), p = c.addSeconds(p, P.getSeconds(u)));
            var f = s.addMinutes(e, (r + 1) * n);
            O.isAfter(p, t) && N.isBefore(p, f) && null != u && l.push(u);
        }
        return l;
    }
    function vt(e) {
        return e < 10 ? "0".concat(e) : "".concat(e);
    }
    function gt(e, t) {
        void 0 === t && (t = Se);
        var r = Math.ceil(x.getYear(e) / t) * t;
        return {
            startPeriod: r - (t - 1),
            endPeriod: r
        };
    }
    function Dt(e) {
        var t = e.getSeconds(), r = e.getMilliseconds();
        return le.toDate(e.getTime() - 1e3 * t - r);
    }
    function yt(e) {
        if (!T.isDate(e)) throw new Error("Invalid date");
        var t = new Date(e);
        return t.setHours(0, 0, 0, 0), t;
    }
    function kt(e, t) {
        if (!T.isDate(e) || !T.isDate(t)) throw new Error("Invalid date received");
        var r = yt(e), n = yt(t);
        return N.isBefore(r, n);
    }
    function wt(e) {
        return e.key === De.Space;
    }
    var St, bt = function(e) {
        function t(t) {
            var n = e.call(this, t) || this;
            return n.inputRef = ue.default.createRef(), n.onTimeChange = function(e) {
                var t, r;
                n.setState({
                    time: e
                });
                var a = n.props.date, o = a instanceof Date && !isNaN(+a) ? a : new Date;
                if (null == e ? void 0 : e.includes(":")) {
                    var s = e.split(":"), i = s[0], l = s[1];
                    o.setHours(Number(i)), o.setMinutes(Number(l));
                }
                null === (r = (t = n.props).onChange) || void 0 === r || r.call(t, o);
            }, n.renderTimeInput = function() {
                var e = n.state.time, t = n.props, a = t.date, o = t.timeString, s = t.customTimeInput;
                return s ? r.cloneElement(s, {
                    date: a,
                    value: e,
                    onChange: n.onTimeChange
                }) : ue.default.createElement("input", {
                    type: "time",
                    className: "react-datepicker-time__input",
                    placeholder: "Time",
                    name: "time-input",
                    ref: n.inputRef,
                    onClick: function() {
                        var e;
                        null === (e = n.inputRef.current) || void 0 === e || e.focus();
                    },
                    required: !0,
                    value: e,
                    onChange: function(e) {
                        n.onTimeChange(e.target.value || o);
                    }
                });
            }, n.state = {
                time: n.props.timeString
            }, n;
        }
        return me(t, e), t.getDerivedStateFromProps = function(e, t) {
            return e.timeString !== t.time ? {
                time: e.timeString
            } : null;
        }, t.prototype.render = function() {
            return ue.default.createElement("div", {
                className: "react-datepicker__input-time-container"
            }, ue.default.createElement("div", {
                className: "react-datepicker-time__caption"
            }, this.props.timeInputLabel), ue.default.createElement("div", {
                className: "react-datepicker-time__input-container"
            }, ue.default.createElement("div", {
                className: "react-datepicker-time__input"
            }, this.renderTimeInput())));
        }, t;
    }(r.Component), Mt = function(e) {
        function n() {
            var n = null !== e && e.apply(this, arguments) || this;
            return n.dayEl = r.createRef(), n.handleClick = function(e) {
                !n.isDisabled() && n.props.onClick && n.props.onClick(e);
            }, n.handleMouseEnter = function(e) {
                !n.isDisabled() && n.props.onMouseEnter && n.props.onMouseEnter(e);
            }, n.handleOnKeyDown = function(e) {
                var t, r;
                e.key === De.Space && (e.preventDefault(), e.key = De.Enter), null === (r = (t = n.props).handleOnKeyDown) || void 0 === r || r.call(t, e);
            }, n.isSameDay = function(e) {
                return Qe(n.props.day, e);
            }, n.isKeyboardSelected = function() {
                var e;
                if (n.props.disabledKeyboardNavigation) return !1;
                var t = n.props.selectsMultiple ? null === (e = n.props.selectedDates) || void 0 === e ? void 0 : e.some(function(e) {
                    return n.isSameDayOrWeek(e);
                }) : n.isSameDayOrWeek(n.props.selected), r = n.props.preSelection && n.isDisabled(n.props.preSelection);
                return !t && n.isSameDayOrWeek(n.props.preSelection) && !r;
            }, n.isDisabled = function(e) {
                return void 0 === e && (e = n.props.day), $e(e, {
                    minDate: n.props.minDate,
                    maxDate: n.props.maxDate,
                    excludeDates: n.props.excludeDates,
                    excludeDateIntervals: n.props.excludeDateIntervals,
                    includeDateIntervals: n.props.includeDateIntervals,
                    includeDates: n.props.includeDates,
                    filterDate: n.props.filterDate
                });
            }, n.isExcluded = function() {
                return ze(n.props.day, {
                    excludeDates: n.props.excludeDates,
                    excludeDateIntervals: n.props.excludeDateIntervals
                });
            }, n.isStartOfWeek = function() {
                return Qe(n.props.day, Oe(n.props.day, n.props.locale, n.props.calendarStartDay));
            }, n.isSameWeek = function(e) {
                return n.props.showWeekPicker && Qe(e, Oe(n.props.day, n.props.locale, n.props.calendarStartDay));
            }, n.isSameDayOrWeek = function(e) {
                return n.isSameDay(e) || n.isSameWeek(e);
            }, n.getHighLightedClass = function() {
                var e = n.props, t = e.day, r = e.highlightDates;
                if (!r) return !1;
                var a = Ee(t, "MM.dd.yyyy");
                return r.get(a);
            }, n.getHolidaysClass = function() {
                var e, t = n.props, r = t.day, a = t.holidays;
                if (!a) return [
                    void 0
                ];
                var o = Ee(r, "MM.dd.yyyy");
                return a.has(o) ? [
                    null === (e = a.get(o)) || void 0 === e ? void 0 : e.className
                ] : [
                    void 0
                ];
            }, n.isInRange = function() {
                var e = n.props, t = e.day, r = e.startDate, a = e.endDate;
                return !(!r || !a) && Ke(t, r, a);
            }, n.isInSelectingRange = function() {
                var e, t = n.props, r = t.day, a = t.selectsStart, o = t.selectsEnd, s = t.selectsRange, i = t.selectsDisabledDaysInRange, l = t.startDate, c = t.endDate, d = null !== (e = n.props.selectingDate) && void 0 !== e ? e : n.props.preSelection;
                return !(!(a || o || s) || !d || !i && n.isDisabled()) && (a && c && (N.isBefore(d, c) || qe(d, c)) ? Ke(r, d, c) : (o && l && (O.isAfter(d, l) || qe(d, l)) || !(!s || !l || c || !O.isAfter(d, l) && !qe(d, l))) && Ke(r, l, d));
            }, n.isSelectingRangeStart = function() {
                var e;
                if (!n.isInSelectingRange()) return !1;
                var t = n.props, r = t.day, a = t.startDate, o = t.selectsStart, s = null !== (e = n.props.selectingDate) && void 0 !== e ? e : n.props.preSelection;
                return Qe(r, o ? s : a);
            }, n.isSelectingRangeEnd = function() {
                var e;
                if (!n.isInSelectingRange()) return !1;
                var t = n.props, r = t.day, a = t.endDate, o = t.selectsEnd, s = t.selectsRange, i = null !== (e = n.props.selectingDate) && void 0 !== e ? e : n.props.preSelection;
                return Qe(r, o || s ? i : a);
            }, n.isRangeStart = function() {
                var e = n.props, t = e.day, r = e.startDate, a = e.endDate;
                return !(!r || !a) && Qe(r, t);
            }, n.isRangeEnd = function() {
                var e = n.props, t = e.day, r = e.startDate, a = e.endDate;
                return !(!r || !a) && Qe(a, t);
            }, n.isWeekend = function() {
                var e = S.getDay(n.props.day);
                return 0 === e || 6 === e;
            }, n.isAfterMonth = function() {
                return void 0 !== n.props.month && (n.props.month + 1) % 12 === _.getMonth(n.props.day);
            }, n.isBeforeMonth = function() {
                return void 0 !== n.props.month && (_.getMonth(n.props.day) + 1) % 12 === n.props.month;
            }, n.isCurrentDay = function() {
                return n.isSameDay(Me());
            }, n.isSelected = function() {
                var e;
                return n.props.selectsMultiple ? null === (e = n.props.selectedDates) || void 0 === e ? void 0 : e.some(function(e) {
                    return n.isSameDayOrWeek(e);
                }) : n.isSameDayOrWeek(n.props.selected);
            }, n.getClassNames = function(e) {
                var r, a = n.props.dayClassName ? n.props.dayClassName(e) : void 0;
                return t.clsx("react-datepicker__day", a, "react-datepicker__day--" + Ee(n.props.day, "ddd", r), {
                    "react-datepicker__day--disabled": n.isDisabled(),
                    "react-datepicker__day--excluded": n.isExcluded(),
                    "react-datepicker__day--selected": n.isSelected(),
                    "react-datepicker__day--keyboard-selected": n.isKeyboardSelected(),
                    "react-datepicker__day--range-start": n.isRangeStart(),
                    "react-datepicker__day--range-end": n.isRangeEnd(),
                    "react-datepicker__day--in-range": n.isInRange(),
                    "react-datepicker__day--in-selecting-range": n.isInSelectingRange(),
                    "react-datepicker__day--selecting-range-start": n.isSelectingRangeStart(),
                    "react-datepicker__day--selecting-range-end": n.isSelectingRangeEnd(),
                    "react-datepicker__day--today": n.isCurrentDay(),
                    "react-datepicker__day--weekend": n.isWeekend(),
                    "react-datepicker__day--outside-month": n.isAfterMonth() || n.isBeforeMonth()
                }, n.getHighLightedClass(), n.getHolidaysClass());
            }, n.getAriaLabel = function() {
                var e = n.props, t = e.day, r = e.ariaLabelPrefixWhenEnabled, a = void 0 === r ? "Choose" : r, o = e.ariaLabelPrefixWhenDisabled, s = void 0 === o ? "Not available" : o, i = n.isDisabled() || n.isExcluded() ? s : a;
                return "".concat(i, " ").concat(Ee(t, "PPPP", n.props.locale));
            }, n.getTitle = function() {
                var e = n.props, t = e.day, r = e.holidays, a = void 0 === r ? new Map : r, o = e.excludeDates, s = Ee(t, "MM.dd.yyyy"), i = [];
                return a.has(s) && i.push.apply(i, a.get(s).holidayNames), n.isExcluded() && i.push(null == o ? void 0 : o.filter(function(e) {
                    return e instanceof Date ? Qe(e, t) : Qe(null == e ? void 0 : e.date, t);
                }).map(function(e) {
                    if (!(e instanceof Date)) return null == e ? void 0 : e.message;
                })), i.join(", ");
            }, n.getTabIndex = function() {
                var e = n.props.selected, t = n.props.preSelection;
                return (!n.props.showWeekPicker || !n.props.showWeekNumber && n.isStartOfWeek()) && (n.isKeyboardSelected() || n.isSameDay(e) && Qe(t, e)) ? 0 : -1;
            }, n.handleFocusDay = function() {
                var e;
                n.shouldFocusDay() && (null === (e = n.dayEl.current) || void 0 === e || e.focus({
                    preventScroll: !0
                }));
            }, n.renderDayContents = function() {
                return n.props.monthShowsDuplicateDaysEnd && n.isAfterMonth() || n.props.monthShowsDuplicateDaysStart && n.isBeforeMonth() ? null : n.props.renderDayContents ? n.props.renderDayContents(w.getDate(n.props.day), n.props.day) : w.getDate(n.props.day);
            }, n.render = function() {
                return ue.default.createElement("div", {
                    ref: n.dayEl,
                    className: n.getClassNames(n.props.day),
                    onKeyDown: n.handleOnKeyDown,
                    onClick: n.handleClick,
                    onMouseEnter: n.props.usePointerEvent ? void 0 : n.handleMouseEnter,
                    onPointerEnter: n.props.usePointerEvent ? n.handleMouseEnter : void 0,
                    tabIndex: n.getTabIndex(),
                    "aria-label": n.getAriaLabel(),
                    role: "option",
                    title: n.getTitle(),
                    "aria-disabled": n.isDisabled(),
                    "aria-current": n.isCurrentDay() ? "date" : void 0,
                    "aria-selected": n.isSelected() || n.isInRange()
                }, n.renderDayContents(), "" !== n.getTitle() && ue.default.createElement("span", {
                    className: "overlay"
                }, n.getTitle()));
            }, n;
        }
        return me(n, e), n.prototype.componentDidMount = function() {
            this.handleFocusDay();
        }, n.prototype.componentDidUpdate = function() {
            this.handleFocusDay();
        }, n.prototype.shouldFocusDay = function() {
            var e = !1;
            return 0 === this.getTabIndex() && this.isSameDay(this.props.preSelection) && (document.activeElement && document.activeElement !== document.body || (e = !0), this.props.inline && !this.props.shouldFocusDayInline && (e = !1), this.isDayActiveElement() && (e = !0), this.isDuplicateDay() && (e = !1)), e;
        }, n.prototype.isDayActiveElement = function() {
            var e, t, r;
            return (null === (t = null === (e = this.props.containerRef) || void 0 === e ? void 0 : e.current) || void 0 === t ? void 0 : t.contains(document.activeElement)) && (null === (r = document.activeElement) || void 0 === r ? void 0 : r.classList.contains("react-datepicker__day"));
        }, n.prototype.isDuplicateDay = function() {
            return this.props.monthShowsDuplicateDaysEnd && this.isAfterMonth() || this.props.monthShowsDuplicateDaysStart && this.isBeforeMonth();
        }, n;
    }(r.Component), Ct = function(e) {
        function n() {
            var t = null !== e && e.apply(this, arguments) || this;
            return t.weekNumberEl = r.createRef(), t.handleClick = function(e) {
                t.props.onClick && t.props.onClick(e);
            }, t.handleOnKeyDown = function(e) {
                var r, n;
                e.key === De.Space && (e.preventDefault(), e.key = De.Enter), null === (n = (r = t.props).handleOnKeyDown) || void 0 === n || n.call(r, e);
            }, t.isKeyboardSelected = function() {
                return !t.props.disabledKeyboardNavigation && !Qe(t.props.date, t.props.selected) && Qe(t.props.date, t.props.preSelection);
            }, t.getTabIndex = function() {
                return t.props.showWeekPicker && t.props.showWeekNumber && (t.isKeyboardSelected() || Qe(t.props.date, t.props.selected) && Qe(t.props.preSelection, t.props.selected)) ? 0 : -1;
            }, t.handleFocusWeekNumber = function(e) {
                var r = !1;
                0 === t.getTabIndex() && !(null == e ? void 0 : e.isInputFocused) && Qe(t.props.date, t.props.preSelection) && (document.activeElement && document.activeElement !== document.body || (r = !0), t.props.inline && !t.props.shouldFocusDayInline && (r = !1), t.props.containerRef && t.props.containerRef.current && t.props.containerRef.current.contains(document.activeElement) && document.activeElement && document.activeElement.classList.contains("react-datepicker__week-number") && (r = !0)), r && t.weekNumberEl.current && t.weekNumberEl.current.focus({
                    preventScroll: !0
                });
            }, t;
        }
        return me(n, e), Object.defineProperty(n, "defaultProps", {
            get: function() {
                return {
                    ariaLabelPrefix: "week "
                };
            },
            enumerable: !1,
            configurable: !0
        }), n.prototype.componentDidMount = function() {
            this.handleFocusWeekNumber();
        }, n.prototype.componentDidUpdate = function(e) {
            this.handleFocusWeekNumber(e);
        }, n.prototype.render = function() {
            var e = this.props, r = e.weekNumber, a = e.isWeekDisabled, o = e.ariaLabelPrefix, s = void 0 === o ? n.defaultProps.ariaLabelPrefix : o, i = e.onClick, l = {
                "react-datepicker__week-number": !0,
                "react-datepicker__week-number--clickable": !!i && !a,
                "react-datepicker__week-number--selected": !!i && Qe(this.props.date, this.props.selected)
            };
            return ue.default.createElement("div", {
                ref: this.weekNumberEl,
                className: t.clsx(l),
                "aria-label": "".concat(s, " ").concat(this.props.weekNumber),
                onClick: this.handleClick,
                onKeyDown: this.handleOnKeyDown,
                tabIndex: this.getTabIndex()
            }, r);
        }, n;
    }(r.Component), _t = function(e) {
        function r() {
            var t = null !== e && e.apply(this, arguments) || this;
            return t.isDisabled = function(e) {
                return $e(e, {
                    minDate: t.props.minDate,
                    maxDate: t.props.maxDate,
                    excludeDates: t.props.excludeDates,
                    excludeDateIntervals: t.props.excludeDateIntervals,
                    includeDateIntervals: t.props.includeDateIntervals,
                    includeDates: t.props.includeDates,
                    filterDate: t.props.filterDate
                });
            }, t.handleDayClick = function(e, r) {
                t.props.onDayClick && t.props.onDayClick(e, r);
            }, t.handleDayMouseEnter = function(e) {
                t.props.onDayMouseEnter && t.props.onDayMouseEnter(e);
            }, t.handleWeekClick = function(e, n, a) {
                for(var o, s, i, l = new Date(e), c = 0; c < 7; c++){
                    var d = new Date(e);
                    if (d.setDate(d.getDate() + c), !t.isDisabled(d)) {
                        l = d;
                        break;
                    }
                }
                "function" == typeof t.props.onWeekSelect && t.props.onWeekSelect(l, n, a), t.props.showWeekPicker && t.handleDayClick(l, a), (null !== (o = t.props.shouldCloseOnSelect) && void 0 !== o ? o : r.defaultProps.shouldCloseOnSelect) && (null === (i = (s = t.props).setOpen) || void 0 === i || i.call(s, !1));
            }, t.formatWeekNumber = function(e) {
                return t.props.formatWeekNumber ? t.props.formatWeekNumber(e) : function(e) {
                    return M.getISOWeek(e);
                }(e);
            }, t.isWeekDisabled = function() {
                for(var e = t.startOfWeek(), r = a.addDays(e, 6), n = new Date(e); n <= r;){
                    if (!t.isDisabled(n)) return !1;
                    n = a.addDays(n, 1);
                }
                return !0;
            }, t.renderDays = function() {
                var e = t.startOfWeek(), n = [], o = t.formatWeekNumber(e);
                if (t.props.showWeekNumber) {
                    var s = t.props.onWeekSelect || t.props.showWeekPicker ? t.handleWeekClick.bind(t, e, o) : void 0;
                    n.push(ue.default.createElement(Ct, ve({
                        key: "W"
                    }, r.defaultProps, t.props, {
                        weekNumber: o,
                        isWeekDisabled: t.isWeekDisabled(),
                        date: e,
                        onClick: s
                    })));
                }
                return n.concat([
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6
                ].map(function(n) {
                    var o = a.addDays(e, n);
                    return ue.default.createElement(Mt, ve({}, r.defaultProps, t.props, {
                        ariaLabelPrefixWhenEnabled: t.props.chooseDayAriaLabelPrefix,
                        ariaLabelPrefixWhenDisabled: t.props.disabledDayAriaLabelPrefix,
                        key: o.valueOf(),
                        day: o,
                        onClick: t.handleDayClick.bind(t, o),
                        onMouseEnter: t.handleDayMouseEnter.bind(t, o)
                    }));
                }));
            }, t.startOfWeek = function() {
                return Oe(t.props.day, t.props.locale, t.props.calendarStartDay);
            }, t.isKeyboardSelected = function() {
                return !t.props.disabledKeyboardNavigation && !Qe(t.startOfWeek(), t.props.selected) && Qe(t.startOfWeek(), t.props.preSelection);
            }, t;
        }
        return me(r, e), Object.defineProperty(r, "defaultProps", {
            get: function() {
                return {
                    shouldCloseOnSelect: !0
                };
            },
            enumerable: !1,
            configurable: !0
        }), r.prototype.render = function() {
            var e = {
                "react-datepicker__week": !0,
                "react-datepicker__week--selected": Qe(this.startOfWeek(), this.props.selected),
                "react-datepicker__week--keyboard-selected": this.isKeyboardSelected()
            };
            return ue.default.createElement("div", {
                className: t.clsx(e)
            }, this.renderDays());
        }, r;
    }(r.Component), Et = "two_columns", Pt = "three_columns", Yt = "four_columns", xt = ((St = {})[Et] = {
        grid: [
            [
                0,
                1
            ],
            [
                2,
                3
            ],
            [
                4,
                5
            ],
            [
                6,
                7
            ],
            [
                8,
                9
            ],
            [
                10,
                11
            ]
        ],
        verticalNavigationOffset: 2
    }, St[Pt] = {
        grid: [
            [
                0,
                1,
                2
            ],
            [
                3,
                4,
                5
            ],
            [
                6,
                7,
                8
            ],
            [
                9,
                10,
                11
            ]
        ],
        verticalNavigationOffset: 3
    }, St[Yt] = {
        grid: [
            [
                0,
                1,
                2,
                3
            ],
            [
                4,
                5,
                6,
                7
            ],
            [
                8,
                9,
                10,
                11
            ]
        ],
        verticalNavigationOffset: 4
    }, St);
    function Ot(e, t) {
        return e ? Yt : t ? Et : Pt;
    }
    var Nt = function(e) {
        function n() {
            var n = null !== e && e.apply(this, arguments) || this;
            return n.MONTH_REFS = ge([], Array(12), !0).map(function() {
                return r.createRef();
            }), n.QUARTER_REFS = ge([], Array(4), !0).map(function() {
                return r.createRef();
            }), n.isDisabled = function(e) {
                return $e(e, {
                    minDate: n.props.minDate,
                    maxDate: n.props.maxDate,
                    excludeDates: n.props.excludeDates,
                    excludeDateIntervals: n.props.excludeDateIntervals,
                    includeDateIntervals: n.props.includeDateIntervals,
                    includeDates: n.props.includeDates,
                    filterDate: n.props.filterDate
                });
            }, n.isExcluded = function(e) {
                return ze(e, {
                    excludeDates: n.props.excludeDates,
                    excludeDateIntervals: n.props.excludeDateIntervals
                });
            }, n.handleDayClick = function(e, t) {
                var r, a;
                null === (a = (r = n.props).onDayClick) || void 0 === a || a.call(r, e, t, n.props.orderInDisplay);
            }, n.handleDayMouseEnter = function(e) {
                var t, r;
                null === (r = (t = n.props).onDayMouseEnter) || void 0 === r || r.call(t, e);
            }, n.handleMouseLeave = function() {
                var e, t;
                null === (t = (e = n.props).onMouseLeave) || void 0 === t || t.call(e);
            }, n.isRangeStartMonth = function(e) {
                var t = n.props, r = t.day, a = t.startDate, o = t.endDate;
                return !(!a || !o) && We($.setMonth(r, e), a);
            }, n.isRangeStartQuarter = function(e) {
                var t = n.props, r = t.day, a = t.startDate, o = t.endDate;
                return !(!a || !o) && He(z.setQuarter(r, e), a);
            }, n.isRangeEndMonth = function(e) {
                var t = n.props, r = t.day, a = t.startDate, o = t.endDate;
                return !(!a || !o) && We($.setMonth(r, e), o);
            }, n.isRangeEndQuarter = function(e) {
                var t = n.props, r = t.day, a = t.startDate, o = t.endDate;
                return !(!a || !o) && He(z.setQuarter(r, e), o);
            }, n.isInSelectingRangeMonth = function(e) {
                var t, r = n.props, a = r.day, o = r.selectsStart, s = r.selectsEnd, i = r.selectsRange, l = r.startDate, c = r.endDate, d = null !== (t = n.props.selectingDate) && void 0 !== t ? t : n.props.preSelection;
                return !(!(o || s || i) || !d) && (o && c ? Ge(d, c, e, a) : (s && l || !(!i || !l || c)) && Ge(l, d, e, a));
            }, n.isSelectingMonthRangeStart = function(e) {
                var t;
                if (!n.isInSelectingRangeMonth(e)) return !1;
                var r = n.props, a = r.day, o = r.startDate, s = r.selectsStart, i = $.setMonth(a, e), l = null !== (t = n.props.selectingDate) && void 0 !== t ? t : n.props.preSelection;
                return We(i, s ? l : o);
            }, n.isSelectingMonthRangeEnd = function(e) {
                var t;
                if (!n.isInSelectingRangeMonth(e)) return !1;
                var r = n.props, a = r.day, o = r.endDate, s = r.selectsEnd, i = r.selectsRange, l = $.setMonth(a, e), c = null !== (t = n.props.selectingDate) && void 0 !== t ? t : n.props.preSelection;
                return We(l, s || i ? c : o);
            }, n.isInSelectingRangeQuarter = function(e) {
                var t, r = n.props, a = r.day, o = r.selectsStart, s = r.selectsEnd, i = r.selectsRange, l = r.startDate, c = r.endDate, d = null !== (t = n.props.selectingDate) && void 0 !== t ? t : n.props.preSelection;
                return !(!(o || s || i) || !d) && (o && c ? rt(d, c, e, a) : (s && l || !(!i || !l || c)) && rt(l, d, e, a));
            }, n.isWeekInMonth = function(e) {
                var t = n.props.day, r = a.addDays(e, 6);
                return We(e, t) || We(r, t);
            }, n.isCurrentMonth = function(e, t) {
                return x.getYear(e) === x.getYear(Me()) && t === _.getMonth(Me());
            }, n.isCurrentQuarter = function(e, t) {
                return x.getYear(e) === x.getYear(Me()) && t === E.getQuarter(Me());
            }, n.isSelectedMonth = function(e, t, r) {
                return _.getMonth(r) === t && x.getYear(e) === x.getYear(r);
            }, n.isSelectMonthInList = function(e, t, r) {
                return r.some(function(r) {
                    return n.isSelectedMonth(e, t, r);
                });
            }, n.isSelectedQuarter = function(e, t, r) {
                return E.getQuarter(e) === t && x.getYear(e) === x.getYear(r);
            }, n.renderWeeks = function() {
                for(var e = [], t = n.props.fixedHeight, r = 0, a = !1, o = Oe(Ne(n.props.day), n.props.locale, n.props.calendarStartDay), s = n.props.selected ? function(e) {
                    return n.props.showWeekPicker ? Oe(e, n.props.locale, n.props.calendarStartDay) : n.props.selected;
                }(n.props.selected) : void 0, i = n.props.preSelection ? function(e) {
                    return n.props.showWeekPicker ? Oe(e, n.props.locale, n.props.calendarStartDay) : n.props.preSelection;
                }(n.props.preSelection) : void 0; e.push(ue.default.createElement(_t, ve({}, n.props, {
                    ariaLabelPrefix: n.props.weekAriaLabelPrefix,
                    key: r,
                    day: o,
                    month: _.getMonth(n.props.day),
                    onDayClick: n.handleDayClick,
                    onDayMouseEnter: n.handleDayMouseEnter,
                    selected: s,
                    preSelection: i,
                    showWeekNumber: n.props.showWeekNumbers
                }))), !a;){
                    r++, o = d.addWeeks(o, 1);
                    var l = t && r >= 6, c = !t && !n.isWeekInMonth(o);
                    if (l || c) {
                        if (!n.props.peekNextMonth) break;
                        a = !0;
                    }
                }
                return e;
            }, n.onMonthClick = function(e, t) {
                var r = n.isMonthDisabledForLabelDate(t), a = r.isDisabled, o = r.labelDate;
                a || n.handleDayClick(Ne(o), e);
            }, n.onMonthMouseEnter = function(e) {
                var t = n.isMonthDisabledForLabelDate(e), r = t.isDisabled, a = t.labelDate;
                r || n.handleDayMouseEnter(Ne(a));
            }, n.handleMonthNavigation = function(e, t) {
                var r, a, o, s;
                null === (a = (r = n.props).setPreSelection) || void 0 === a || a.call(r, t), null === (s = null === (o = n.MONTH_REFS[e]) || void 0 === o ? void 0 : o.current) || void 0 === s || s.focus();
            }, n.handleKeyboardNavigation = function(e, t, r) {
                var a, o = n.props, s = o.selected, l = o.preSelection, c = o.setPreSelection, d = o.minDate, p = o.maxDate, u = o.showFourColumnMonthYearPicker, f = o.showTwoColumnMonthYearPicker;
                if (l) {
                    var h = Ot(u, f), m = n.getVerticalOffset(h), v = null === (a = xt[h]) || void 0 === a ? void 0 : a.grid, g = function(e, t, r) {
                        var n, a, o = t, s = r;
                        switch(e){
                            case De.ArrowRight:
                                o = i.addMonths(t, 1), s = 11 === r ? 0 : r + 1;
                                break;
                            case De.ArrowLeft:
                                o = ae.subMonths(t, 1), s = 0 === r ? 11 : r - 1;
                                break;
                            case De.ArrowUp:
                                o = ae.subMonths(t, m), s = (null === (n = null == v ? void 0 : v[0]) || void 0 === n ? void 0 : n.includes(r)) ? r + 12 - m : r - m;
                                break;
                            case De.ArrowDown:
                                o = i.addMonths(t, m), s = (null === (a = null == v ? void 0 : v[v.length - 1]) || void 0 === a ? void 0 : a.includes(r)) ? r - 12 + m : r + m;
                        }
                        return {
                            newCalculatedDate: o,
                            newCalculatedMonth: s
                        };
                    };
                    if (t !== De.Enter) {
                        var D = function(e, t, r) {
                            for(var a = e, o = !1, s = 0, i = g(a, t, r), l = i.newCalculatedDate, c = i.newCalculatedMonth; !o;){
                                if (s >= 40) {
                                    l = t, c = r;
                                    break;
                                }
                                var u;
                                if (d && l < d) a = De.ArrowRight, l = (u = g(a, l, c)).newCalculatedDate, c = u.newCalculatedMonth;
                                if (p && l > p) a = De.ArrowLeft, l = (u = g(a, l, c)).newCalculatedDate, c = u.newCalculatedMonth;
                                if (Je(l, n.props)) l = (u = g(a, l, c)).newCalculatedDate, c = u.newCalculatedMonth;
                                else o = !0;
                                s++;
                            }
                            return {
                                newCalculatedDate: l,
                                newCalculatedMonth: c
                            };
                        }(t, l, r), y = D.newCalculatedDate, k = D.newCalculatedMonth;
                        switch(t){
                            case De.ArrowRight:
                            case De.ArrowLeft:
                            case De.ArrowUp:
                            case De.ArrowDown:
                                n.handleMonthNavigation(k, y);
                        }
                    } else n.isMonthDisabled(r) || (n.onMonthClick(e, r), null == c || c(s));
                }
            }, n.getVerticalOffset = function(e) {
                var t, r;
                return null !== (r = null === (t = xt[e]) || void 0 === t ? void 0 : t.verticalNavigationOffset) && void 0 !== r ? r : 0;
            }, n.onMonthKeyDown = function(e, t) {
                var r = n.props, a = r.disabledKeyboardNavigation, o = r.handleOnMonthKeyDown, s = e.key;
                s !== De.Tab && e.preventDefault(), a || n.handleKeyboardNavigation(e, s, t), o && o(e);
            }, n.onQuarterClick = function(e, t) {
                var r = z.setQuarter(n.props.day, t);
                Ze(r, n.props) || n.handleDayClick(Ie(r), e);
            }, n.onQuarterMouseEnter = function(e) {
                var t = z.setQuarter(n.props.day, e);
                Ze(t, n.props) || n.handleDayMouseEnter(Ie(t));
            }, n.handleQuarterNavigation = function(e, t) {
                var r, a, o, s;
                n.isDisabled(t) || n.isExcluded(t) || (null === (a = (r = n.props).setPreSelection) || void 0 === a || a.call(r, t), null === (s = null === (o = n.QUARTER_REFS[e - 1]) || void 0 === o ? void 0 : o.current) || void 0 === s || s.focus());
            }, n.onQuarterKeyDown = function(e, t) {
                var r, a, o = e.key;
                if (!n.props.disabledKeyboardNavigation) switch(o){
                    case De.Enter:
                        n.onQuarterClick(e, t), null === (a = (r = n.props).setPreSelection) || void 0 === a || a.call(r, n.props.selected);
                        break;
                    case De.ArrowRight:
                        if (!n.props.preSelection) break;
                        n.handleQuarterNavigation(4 === t ? 1 : t + 1, l.addQuarters(n.props.preSelection, 1));
                        break;
                    case De.ArrowLeft:
                        if (!n.props.preSelection) break;
                        n.handleQuarterNavigation(1 === t ? 4 : t - 1, oe.subQuarters(n.props.preSelection, 1));
                }
            }, n.isMonthDisabledForLabelDate = function(e) {
                var t, r = n.props, a = r.day, o = r.minDate, s = r.maxDate, i = r.excludeDates, l = r.includeDates, c = $.setMonth(a, e);
                return {
                    isDisabled: null !== (t = (o || s || i || l) && Xe(c, n.props)) && void 0 !== t && t,
                    labelDate: c
                };
            }, n.isMonthDisabled = function(e) {
                return n.isMonthDisabledForLabelDate(e).isDisabled;
            }, n.getMonthClassNames = function(e) {
                var r = n.props, a = r.day, o = r.startDate, s = r.endDate, i = r.preSelection, l = r.monthClassName, c = l ? l($.setMonth(a, e)) : void 0, d = n.getSelection();
                return t.clsx("react-datepicker__month-text", "react-datepicker__month-".concat(e), c, {
                    "react-datepicker__month-text--disabled": n.isMonthDisabled(e),
                    "react-datepicker__month-text--selected": d ? n.isSelectMonthInList(a, e, d) : void 0,
                    "react-datepicker__month-text--keyboard-selected": !n.props.disabledKeyboardNavigation && i && n.isSelectedMonth(a, e, i) && !n.isMonthDisabled(e),
                    "react-datepicker__month-text--in-selecting-range": n.isInSelectingRangeMonth(e),
                    "react-datepicker__month-text--in-range": o && s ? Ge(o, s, e, a) : void 0,
                    "react-datepicker__month-text--range-start": n.isRangeStartMonth(e),
                    "react-datepicker__month-text--range-end": n.isRangeEndMonth(e),
                    "react-datepicker__month-text--selecting-range-start": n.isSelectingMonthRangeStart(e),
                    "react-datepicker__month-text--selecting-range-end": n.isSelectingMonthRangeEnd(e),
                    "react-datepicker__month-text--today": n.isCurrentMonth(a, e)
                });
            }, n.getTabIndex = function(e) {
                if (null == n.props.preSelection) return "-1";
                var t = _.getMonth(n.props.preSelection), r = n.isMonthDisabledForLabelDate(t).isDisabled;
                return e !== t || r || n.props.disabledKeyboardNavigation ? "-1" : "0";
            }, n.getQuarterTabIndex = function(e) {
                if (null == n.props.preSelection) return "-1";
                var t = E.getQuarter(n.props.preSelection), r = Ze(n.props.day, n.props);
                return e !== t || r || n.props.disabledKeyboardNavigation ? "-1" : "0";
            }, n.getAriaLabel = function(e) {
                var t = n.props, r = t.chooseDayAriaLabelPrefix, a = void 0 === r ? "Choose" : r, o = t.disabledDayAriaLabelPrefix, s = void 0 === o ? "Not available" : o, i = t.day, l = t.locale, c = $.setMonth(i, e), d = n.isDisabled(c) || n.isExcluded(c) ? s : a;
                return "".concat(d, " ").concat(Ee(c, "MMMM yyyy", l));
            }, n.getQuarterClassNames = function(e) {
                var r = n.props, a = r.day, o = r.startDate, s = r.endDate, i = r.selected, l = r.minDate, c = r.maxDate, d = r.excludeDates, p = r.includeDates, u = r.filterDate, f = r.preSelection, h = r.disabledKeyboardNavigation, m = (l || c || d || p || u) && Ze(z.setQuarter(a, e), n.props);
                return t.clsx("react-datepicker__quarter-text", "react-datepicker__quarter-".concat(e), {
                    "react-datepicker__quarter-text--disabled": m,
                    "react-datepicker__quarter-text--selected": i ? n.isSelectedQuarter(a, e, i) : void 0,
                    "react-datepicker__quarter-text--keyboard-selected": !h && f && n.isSelectedQuarter(a, e, f) && !m,
                    "react-datepicker__quarter-text--in-selecting-range": n.isInSelectingRangeQuarter(e),
                    "react-datepicker__quarter-text--in-range": o && s ? rt(o, s, e, a) : void 0,
                    "react-datepicker__quarter-text--range-start": n.isRangeStartQuarter(e),
                    "react-datepicker__quarter-text--range-end": n.isRangeEndQuarter(e)
                });
            }, n.getMonthContent = function(e) {
                var t = n.props, r = t.showFullMonthYearPicker, a = t.renderMonthContent, o = t.locale, s = t.day, i = Ue(e, o), l = je(e, o);
                return a ? a(e, i, l, s) : r ? l : i;
            }, n.getQuarterContent = function(e) {
                var t, r = n.props, a = r.renderQuarterContent, o = function(e, t) {
                    return Ee(z.setQuarter(Me(), e), "QQQ", t);
                }(e, r.locale);
                return null !== (t = null == a ? void 0 : a(e, o)) && void 0 !== t ? t : o;
            }, n.renderMonths = function() {
                var e, t = n.props, r = t.showTwoColumnMonthYearPicker, a = t.showFourColumnMonthYearPicker, o = t.day, s = t.selected, i = null === (e = xt[Ot(a, r)]) || void 0 === e ? void 0 : e.grid;
                return null == i ? void 0 : i.map(function(e, t) {
                    return ue.default.createElement("div", {
                        className: "react-datepicker__month-wrapper",
                        key: t
                    }, e.map(function(e, t) {
                        return ue.default.createElement("div", {
                            ref: n.MONTH_REFS[e],
                            key: t,
                            onClick: function(t) {
                                n.onMonthClick(t, e);
                            },
                            onKeyDown: function(t) {
                                wt(t) && (t.preventDefault(), t.key = De.Enter), n.onMonthKeyDown(t, e);
                            },
                            onMouseEnter: n.props.usePointerEvent ? void 0 : function() {
                                return n.onMonthMouseEnter(e);
                            },
                            onPointerEnter: n.props.usePointerEvent ? function() {
                                return n.onMonthMouseEnter(e);
                            } : void 0,
                            tabIndex: Number(n.getTabIndex(e)),
                            className: n.getMonthClassNames(e),
                            "aria-disabled": n.isMonthDisabled(e),
                            role: "option",
                            "aria-label": n.getAriaLabel(e),
                            "aria-current": n.isCurrentMonth(o, e) ? "date" : void 0,
                            "aria-selected": s ? n.isSelectedMonth(o, e, s) : void 0
                        }, n.getMonthContent(e));
                    }));
                });
            }, n.renderQuarters = function() {
                var e = n.props, t = e.day, r = e.selected;
                return ue.default.createElement("div", {
                    className: "react-datepicker__quarter-wrapper"
                }, [
                    1,
                    2,
                    3,
                    4
                ].map(function(e, a) {
                    return ue.default.createElement("div", {
                        key: a,
                        ref: n.QUARTER_REFS[a],
                        role: "option",
                        onClick: function(t) {
                            n.onQuarterClick(t, e);
                        },
                        onKeyDown: function(t) {
                            n.onQuarterKeyDown(t, e);
                        },
                        onMouseEnter: n.props.usePointerEvent ? void 0 : function() {
                            return n.onQuarterMouseEnter(e);
                        },
                        onPointerEnter: n.props.usePointerEvent ? function() {
                            return n.onQuarterMouseEnter(e);
                        } : void 0,
                        className: n.getQuarterClassNames(e),
                        "aria-selected": r ? n.isSelectedQuarter(t, e, r) : void 0,
                        tabIndex: Number(n.getQuarterTabIndex(e)),
                        "aria-current": n.isCurrentQuarter(t, e) ? "date" : void 0
                    }, n.getQuarterContent(e));
                }));
            }, n.getClassNames = function() {
                var e = n.props, r = e.selectingDate, a = e.selectsStart, o = e.selectsEnd, s = e.showMonthYearPicker, i = e.showQuarterYearPicker, l = e.showWeekPicker;
                return t.clsx("react-datepicker__month", {
                    "react-datepicker__month--selecting-range": r && (a || o)
                }, {
                    "react-datepicker__monthPicker": s
                }, {
                    "react-datepicker__quarterPicker": i
                }, {
                    "react-datepicker__weekPicker": l
                });
            }, n;
        }
        return me(n, e), n.prototype.getSelection = function() {
            var e = this.props, t = e.selected, r = e.selectedDates;
            return e.selectsMultiple ? r : t ? [
                t
            ] : void 0;
        }, n.prototype.render = function() {
            var e = this.props, t = e.showMonthYearPicker, r = e.showQuarterYearPicker, n = e.day, a = e.ariaLabelPrefix, o = void 0 === a ? "Month " : a, s = o ? o.trim() + " " : "";
            return ue.default.createElement("div", {
                className: this.getClassNames(),
                onMouseLeave: this.props.usePointerEvent ? void 0 : this.handleMouseLeave,
                onPointerLeave: this.props.usePointerEvent ? this.handleMouseLeave : void 0,
                "aria-label": "".concat(s).concat(Ee(n, "MMMM, yyyy", this.props.locale)),
                role: "listbox"
            }, t ? this.renderMonths() : r ? this.renderQuarters() : this.renderWeeks());
        }, n;
    }(r.Component), Tt = function(e) {
        function t() {
            var t = null !== e && e.apply(this, arguments) || this;
            return t.isSelectedMonth = function(e) {
                return t.props.month === e;
            }, t.renderOptions = function() {
                return t.props.monthNames.map(function(e, r) {
                    return ue.default.createElement("div", {
                        className: t.isSelectedMonth(r) ? "react-datepicker__month-option react-datepicker__month-option--selected_month" : "react-datepicker__month-option",
                        key: e,
                        onClick: t.onChange.bind(t, r),
                        "aria-selected": t.isSelectedMonth(r) ? "true" : void 0
                    }, t.isSelectedMonth(r) ? ue.default.createElement("span", {
                        className: "react-datepicker__month-option--selected"
                    }, "\u2713") : "", e);
                });
            }, t.onChange = function(e) {
                return t.props.onChange(e);
            }, t.handleClickOutside = function() {
                return t.props.onCancel();
            }, t;
        }
        return me(t, e), t.prototype.render = function() {
            return ue.default.createElement(ke, {
                className: "react-datepicker__month-dropdown",
                onClickOutside: this.handleClickOutside
            }, this.renderOptions());
        }, t;
    }(r.Component), It = function(e) {
        function t() {
            var t = null !== e && e.apply(this, arguments) || this;
            return t.state = {
                dropdownVisible: !1
            }, t.renderSelectOptions = function(e) {
                return e.map(function(e, t) {
                    return ue.default.createElement("option", {
                        key: e,
                        value: t
                    }, e);
                });
            }, t.renderSelectMode = function(e) {
                return ue.default.createElement("select", {
                    value: t.props.month,
                    className: "react-datepicker__month-select",
                    onChange: function(e) {
                        return t.onChange(parseInt(e.target.value));
                    }
                }, t.renderSelectOptions(e));
            }, t.renderReadView = function(e, r) {
                return ue.default.createElement("div", {
                    key: "read",
                    style: {
                        visibility: e ? "visible" : "hidden"
                    },
                    className: "react-datepicker__month-read-view",
                    onClick: t.toggleDropdown
                }, ue.default.createElement("span", {
                    className: "react-datepicker__month-read-view--down-arrow"
                }), ue.default.createElement("span", {
                    className: "react-datepicker__month-read-view--selected-month"
                }, r[t.props.month]));
            }, t.renderDropdown = function(e) {
                return ue.default.createElement(Tt, ve({
                    key: "dropdown"
                }, t.props, {
                    monthNames: e,
                    onChange: t.onChange,
                    onCancel: t.toggleDropdown
                }));
            }, t.renderScrollMode = function(e) {
                var r = t.state.dropdownVisible, n = [
                    t.renderReadView(!r, e)
                ];
                return r && n.unshift(t.renderDropdown(e)), n;
            }, t.onChange = function(e) {
                t.toggleDropdown(), e !== t.props.month && t.props.onChange(e);
            }, t.toggleDropdown = function() {
                return t.setState({
                    dropdownVisible: !t.state.dropdownVisible
                });
            }, t;
        }
        return me(t, e), t.prototype.render = function() {
            var e, t = this, r = [
                0,
                1,
                2,
                3,
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11
            ].map(this.props.useShortMonthInDropdown ? function(e) {
                return Ue(e, t.props.locale);
            } : function(e) {
                return je(e, t.props.locale);
            });
            switch(this.props.dropdownMode){
                case "scroll":
                    e = this.renderScrollMode(r);
                    break;
                case "select":
                    e = this.renderSelectMode(r);
            }
            return ue.default.createElement("div", {
                className: "react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode)
            }, e);
        }, t;
    }(r.Component);
    function Rt(e, t) {
        for(var r = [], n = Ne(e), a = Ne(t); !O.isAfter(n, a);)r.push(Me(n)), n = i.addMonths(n, 1);
        return r;
    }
    var Lt = function(e) {
        function r(t) {
            var r = e.call(this, t) || this;
            return r.renderOptions = function() {
                return r.state.monthYearsList.map(function(e) {
                    var t = Y.getTime(e), n = Ae(r.props.date, e) && We(r.props.date, e);
                    return ue.default.createElement("div", {
                        className: n ? "react-datepicker__month-year-option--selected_month-year" : "react-datepicker__month-year-option",
                        key: t,
                        onClick: r.onChange.bind(r, t),
                        "aria-selected": n ? "true" : void 0
                    }, n ? ue.default.createElement("span", {
                        className: "react-datepicker__month-year-option--selected"
                    }, "\u2713") : "", Ee(e, r.props.dateFormat, r.props.locale));
                });
            }, r.onChange = function(e) {
                return r.props.onChange(e);
            }, r.handleClickOutside = function() {
                r.props.onCancel();
            }, r.state = {
                monthYearsList: Rt(r.props.minDate, r.props.maxDate)
            }, r;
        }
        return me(r, e), r.prototype.render = function() {
            var e = t.clsx({
                "react-datepicker__month-year-dropdown": !0,
                "react-datepicker__month-year-dropdown--scrollable": this.props.scrollableMonthYearDropdown
            });
            return ue.default.createElement(ke, {
                className: e,
                onClickOutside: this.handleClickOutside
            }, this.renderOptions());
        }, r;
    }(r.Component), Ft = function(e) {
        function t() {
            var t = null !== e && e.apply(this, arguments) || this;
            return t.state = {
                dropdownVisible: !1
            }, t.renderSelectOptions = function() {
                for(var e = Ne(t.props.minDate), r = Ne(t.props.maxDate), n = []; !O.isAfter(e, r);){
                    var a = Y.getTime(e);
                    n.push(ue.default.createElement("option", {
                        key: a,
                        value: a
                    }, Ee(e, t.props.dateFormat, t.props.locale))), e = i.addMonths(e, 1);
                }
                return n;
            }, t.onSelectChange = function(e) {
                t.onChange(parseInt(e.target.value));
            }, t.renderSelectMode = function() {
                return ue.default.createElement("select", {
                    value: Y.getTime(Ne(t.props.date)),
                    className: "react-datepicker__month-year-select",
                    onChange: t.onSelectChange
                }, t.renderSelectOptions());
            }, t.renderReadView = function(e) {
                var r = Ee(t.props.date, t.props.dateFormat, t.props.locale);
                return ue.default.createElement("div", {
                    key: "read",
                    style: {
                        visibility: e ? "visible" : "hidden"
                    },
                    className: "react-datepicker__month-year-read-view",
                    onClick: t.toggleDropdown
                }, ue.default.createElement("span", {
                    className: "react-datepicker__month-year-read-view--down-arrow"
                }), ue.default.createElement("span", {
                    className: "react-datepicker__month-year-read-view--selected-month-year"
                }, r));
            }, t.renderDropdown = function() {
                return ue.default.createElement(Lt, ve({
                    key: "dropdown"
                }, t.props, {
                    onChange: t.onChange,
                    onCancel: t.toggleDropdown
                }));
            }, t.renderScrollMode = function() {
                var e = t.state.dropdownVisible, r = [
                    t.renderReadView(!e)
                ];
                return e && r.unshift(t.renderDropdown()), r;
            }, t.onChange = function(e) {
                t.toggleDropdown();
                var r = Me(e);
                Ae(t.props.date, r) && We(t.props.date, r) || t.props.onChange(r);
            }, t.toggleDropdown = function() {
                return t.setState({
                    dropdownVisible: !t.state.dropdownVisible
                });
            }, t;
        }
        return me(t, e), t.prototype.render = function() {
            var e;
            switch(this.props.dropdownMode){
                case "scroll":
                    e = this.renderScrollMode();
                    break;
                case "select":
                    e = this.renderSelectMode();
            }
            return ue.default.createElement("div", {
                className: "react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode)
            }, e);
        }, t;
    }(r.Component), At = function(e) {
        function t() {
            var r = null !== e && e.apply(this, arguments) || this;
            return r.state = {
                height: null
            }, r.scrollToTheSelectedTime = function() {
                requestAnimationFrame(function() {
                    var e, n, a;
                    r.list && (r.list.scrollTop = null !== (a = r.centerLi && t.calcCenterPosition(r.props.monthRef ? r.props.monthRef.clientHeight - (null !== (n = null === (e = r.header) || void 0 === e ? void 0 : e.clientHeight) && void 0 !== n ? n : 0) : r.list.clientHeight, r.centerLi)) && void 0 !== a ? a : 0);
                });
            }, r.handleClick = function(e) {
                var t, n;
                (r.props.minTime || r.props.maxTime) && st(e, r.props) || (r.props.excludeTimes || r.props.includeTimes || r.props.filterTime) && ot(e, r.props) || null === (n = (t = r.props).onChange) || void 0 === n || n.call(t, e);
            }, r.isSelectedTime = function(e) {
                var t, n;
                return r.props.selected && (t = r.props.selected, n = e, Dt(t).getTime() === Dt(n).getTime());
            }, r.isDisabledTime = function(e) {
                return (r.props.minTime || r.props.maxTime) && st(e, r.props) || (r.props.excludeTimes || r.props.includeTimes || r.props.filterTime) && ot(e, r.props);
            }, r.liClasses = function(e) {
                var n, a = [
                    "react-datepicker__time-list-item",
                    r.props.timeClassName ? r.props.timeClassName(e) : void 0
                ];
                return r.isSelectedTime(e) && a.push("react-datepicker__time-list-item--selected"), r.isDisabledTime(e) && a.push("react-datepicker__time-list-item--disabled"), r.props.injectTimes && (3600 * b.getHours(e) + 60 * C.getMinutes(e) + P.getSeconds(e)) % (60 * (null !== (n = r.props.intervals) && void 0 !== n ? n : t.defaultProps.intervals)) != 0 && a.push("react-datepicker__time-list-item--injected"), a.join(" ");
            }, r.handleOnKeyDown = function(e, t) {
                var n, a;
                e.key === De.Space && (e.preventDefault(), e.key = De.Enter), (e.key === De.ArrowUp || e.key === De.ArrowLeft) && e.target instanceof HTMLElement && e.target.previousSibling && (e.preventDefault(), e.target.previousSibling instanceof HTMLElement && e.target.previousSibling.focus()), (e.key === De.ArrowDown || e.key === De.ArrowRight) && e.target instanceof HTMLElement && e.target.nextSibling && (e.preventDefault(), e.target.nextSibling instanceof HTMLElement && e.target.nextSibling.focus()), e.key === De.Enter && r.handleClick(t), null === (a = (n = r.props).handleOnKeyDown) || void 0 === a || a.call(n, e);
            }, r.renderTimes = function() {
                for(var e, n = [], a = "string" == typeof r.props.format ? r.props.format : "p", o = null !== (e = r.props.intervals) && void 0 !== e ? e : t.defaultProps.intervals, i = r.props.selected || r.props.openToDate || Me(), l = xe(i), c = r.props.injectTimes && r.props.injectTimes.sort(function(e, t) {
                    return e.getTime() - t.getTime();
                }), d = 60 * function(e) {
                    var t = new Date(e.getFullYear(), e.getMonth(), e.getDate()), r = new Date(e.getFullYear(), e.getMonth(), e.getDate(), 24);
                    return Math.round((+r - +t) / 36e5);
                }(i), p = d / o, u = 0; u < p; u++){
                    var f = s.addMinutes(l, u * o);
                    if (n.push(f), c) {
                        var h = mt(l, f, u, o, c);
                        n = n.concat(h);
                    }
                }
                var m = n.reduce(function(e, t) {
                    return t.getTime() <= i.getTime() ? t : e;
                }, n[0]);
                return n.map(function(e) {
                    return ue.default.createElement("li", {
                        key: e.valueOf(),
                        onClick: r.handleClick.bind(r, e),
                        className: r.liClasses(e),
                        ref: function(t) {
                            e === m && (r.centerLi = t);
                        },
                        onKeyDown: function(t) {
                            r.handleOnKeyDown(t, e);
                        },
                        tabIndex: e === m ? 0 : -1,
                        role: "option",
                        "aria-selected": r.isSelectedTime(e) ? "true" : void 0,
                        "aria-disabled": r.isDisabledTime(e) ? "true" : void 0
                    }, Ee(e, a, r.props.locale));
                });
            }, r.renderTimeCaption = function() {
                return !1 === r.props.showTimeCaption ? ue.default.createElement(ue.default.Fragment, null) : ue.default.createElement("div", {
                    className: "react-datepicker__header react-datepicker__header--time ".concat(r.props.showTimeSelectOnly ? "react-datepicker__header--time--only" : ""),
                    ref: function(e) {
                        r.header = e;
                    }
                }, ue.default.createElement("div", {
                    className: "react-datepicker-time__header"
                }, r.props.timeCaption));
            }, r;
        }
        return me(t, e), Object.defineProperty(t, "defaultProps", {
            get: function() {
                return {
                    intervals: 30,
                    todayButton: null,
                    timeCaption: "Time",
                    showTimeCaption: !0
                };
            },
            enumerable: !1,
            configurable: !0
        }), t.prototype.componentDidMount = function() {
            this.scrollToTheSelectedTime(), this.props.monthRef && this.header && this.setState({
                height: this.props.monthRef.clientHeight - this.header.clientHeight
            });
        }, t.prototype.render = function() {
            var e, r = this, n = this.state.height;
            return ue.default.createElement("div", {
                className: "react-datepicker__time-container ".concat((null !== (e = this.props.todayButton) && void 0 !== e ? e : t.defaultProps.todayButton) ? "react-datepicker__time-container--with-today-button" : "")
            }, this.renderTimeCaption(), ue.default.createElement("div", {
                className: "react-datepicker__time"
            }, ue.default.createElement("div", {
                className: "react-datepicker__time-box"
            }, ue.default.createElement("ul", {
                className: "react-datepicker__time-list",
                ref: function(e) {
                    r.list = e;
                },
                style: n ? {
                    height: n
                } : {},
                role: "listbox",
                "aria-label": this.props.timeCaption
            }, this.renderTimes()))));
        }, t.calcCenterPosition = function(e, t) {
            return t.offsetTop - (e / 2 - t.clientHeight / 2);
        }, t;
    }(r.Component), Wt = function(e) {
        function n(n) {
            var a = e.call(this, n) || this;
            return a.YEAR_REFS = ge([], Array(a.props.yearItemNumber), !0).map(function() {
                return r.createRef();
            }), a.isDisabled = function(e) {
                return $e(e, {
                    minDate: a.props.minDate,
                    maxDate: a.props.maxDate,
                    excludeDates: a.props.excludeDates,
                    includeDates: a.props.includeDates,
                    filterDate: a.props.filterDate
                });
            }, a.isExcluded = function(e) {
                return ze(e, {
                    excludeDates: a.props.excludeDates
                });
            }, a.selectingDate = function() {
                var e;
                return null !== (e = a.props.selectingDate) && void 0 !== e ? e : a.props.preSelection;
            }, a.updateFocusOnPaginate = function(e) {
                window.requestAnimationFrame(function() {
                    var t, r;
                    null === (r = null === (t = a.YEAR_REFS[e]) || void 0 === t ? void 0 : t.current) || void 0 === r || r.focus();
                });
            }, a.handleYearClick = function(e, t) {
                a.props.onDayClick && a.props.onDayClick(e, t);
            }, a.handleYearNavigation = function(e, t) {
                var r, n, o, s, i = a.props, l = i.date, c = i.yearItemNumber;
                if (void 0 !== l && void 0 !== c) {
                    var d = gt(l, c).startPeriod;
                    a.isDisabled(t) || a.isExcluded(t) || (null === (n = (r = a.props).setPreSelection) || void 0 === n || n.call(r, t), e - d < 0 ? a.updateFocusOnPaginate(c - (d - e)) : e - d >= c ? a.updateFocusOnPaginate(Math.abs(c - (e - d))) : null === (s = null === (o = a.YEAR_REFS[e - d]) || void 0 === o ? void 0 : o.current) || void 0 === s || s.focus());
                }
            }, a.isSameDay = function(e, t) {
                return Qe(e, t);
            }, a.isCurrentYear = function(e) {
                return e === x.getYear(Me());
            }, a.isRangeStart = function(e) {
                return a.props.startDate && a.props.endDate && Ae(G.setYear(Me(), e), a.props.startDate);
            }, a.isRangeEnd = function(e) {
                return a.props.startDate && a.props.endDate && Ae(G.setYear(Me(), e), a.props.endDate);
            }, a.isInRange = function(e) {
                return et(e, a.props.startDate, a.props.endDate);
            }, a.isInSelectingRange = function(e) {
                var t = a.props, r = t.selectsStart, n = t.selectsEnd, o = t.selectsRange, s = t.startDate, i = t.endDate;
                return !(!(r || n || o) || !a.selectingDate()) && (r && i ? et(e, a.selectingDate(), i) : (n && s || !(!o || !s || i)) && et(e, s, a.selectingDate()));
            }, a.isSelectingRangeStart = function(e) {
                var t;
                if (!a.isInSelectingRange(e)) return !1;
                var r = a.props, n = r.startDate, o = r.selectsStart, s = G.setYear(Me(), e);
                return Ae(s, o ? null !== (t = a.selectingDate()) && void 0 !== t ? t : null : null != n ? n : null);
            }, a.isSelectingRangeEnd = function(e) {
                var t;
                if (!a.isInSelectingRange(e)) return !1;
                var r = a.props, n = r.endDate, o = r.selectsEnd, s = r.selectsRange, i = G.setYear(Me(), e);
                return Ae(i, o || s ? null !== (t = a.selectingDate()) && void 0 !== t ? t : null : null != n ? n : null);
            }, a.isKeyboardSelected = function(e) {
                if (void 0 !== a.props.date && null != a.props.selected && null != a.props.preSelection) {
                    var t = a.props, r = t.minDate, n = t.maxDate, o = t.excludeDates, s = t.includeDates, i = t.filterDate, l = Te(G.setYear(a.props.date, e)), c = (r || n || o || s || i) && tt(e, a.props);
                    return !a.props.disabledKeyboardNavigation && !a.props.inline && !Qe(l, Te(a.props.selected)) && Qe(l, Te(a.props.preSelection)) && !c;
                }
            }, a.onYearClick = function(e, t) {
                var r = a.props.date;
                void 0 !== r && a.handleYearClick(Te(G.setYear(r, t)), e);
            }, a.onYearKeyDown = function(e, t) {
                var r, n, o = e.key, s = a.props, i = s.date, l = s.yearItemNumber, c = s.handleOnKeyDown;
                if (o !== De.Tab && e.preventDefault(), !a.props.disabledKeyboardNavigation) switch(o){
                    case De.Enter:
                        if (null == a.props.selected) break;
                        a.onYearClick(e, t), null === (n = (r = a.props).setPreSelection) || void 0 === n || n.call(r, a.props.selected);
                        break;
                    case De.ArrowRight:
                        if (null == a.props.preSelection) break;
                        a.handleYearNavigation(t + 1, p.addYears(a.props.preSelection, 1));
                        break;
                    case De.ArrowLeft:
                        if (null == a.props.preSelection) break;
                        a.handleYearNavigation(t - 1, ie.subYears(a.props.preSelection, 1));
                        break;
                    case De.ArrowUp:
                        if (void 0 === i || void 0 === l || null == a.props.preSelection) break;
                        var d = gt(i, l).startPeriod;
                        if ((h = t - (f = 3)) < d) {
                            var u = l % f;
                            t >= d && t < d + u ? f = u : f += u, h = t - f;
                        }
                        a.handleYearNavigation(h, ie.subYears(a.props.preSelection, f));
                        break;
                    case De.ArrowDown:
                        if (void 0 === i || void 0 === l || null == a.props.preSelection) break;
                        var f, h, m = gt(i, l).endPeriod;
                        if ((h = t + (f = 3)) > m) {
                            u = l % f;
                            t <= m && t > m - u ? f = u : f += u, h = t + f;
                        }
                        a.handleYearNavigation(h, p.addYears(a.props.preSelection, f));
                }
                c && c(e);
            }, a.getYearClassNames = function(e) {
                var r = a.props, n = r.date, o = r.minDate, s = r.maxDate, i = r.selected, l = r.excludeDates, c = r.includeDates, d = r.filterDate, p = r.yearClassName;
                return t.clsx("react-datepicker__year-text", "react-datepicker__year-".concat(e), n ? null == p ? void 0 : p(G.setYear(n, e)) : void 0, {
                    "react-datepicker__year-text--selected": i ? e === x.getYear(i) : void 0,
                    "react-datepicker__year-text--disabled": (o || s || l || c || d) && tt(e, a.props),
                    "react-datepicker__year-text--keyboard-selected": a.isKeyboardSelected(e),
                    "react-datepicker__year-text--range-start": a.isRangeStart(e),
                    "react-datepicker__year-text--range-end": a.isRangeEnd(e),
                    "react-datepicker__year-text--in-range": a.isInRange(e),
                    "react-datepicker__year-text--in-selecting-range": a.isInSelectingRange(e),
                    "react-datepicker__year-text--selecting-range-start": a.isSelectingRangeStart(e),
                    "react-datepicker__year-text--selecting-range-end": a.isSelectingRangeEnd(e),
                    "react-datepicker__year-text--today": a.isCurrentYear(e)
                });
            }, a.getYearTabIndex = function(e) {
                if (a.props.disabledKeyboardNavigation || null == a.props.preSelection) return "-1";
                var t = x.getYear(a.props.preSelection), r = tt(e, a.props);
                return e !== t || r ? "-1" : "0";
            }, a.getYearContent = function(e) {
                return a.props.renderYearContent ? a.props.renderYearContent(e) : e;
            }, a;
        }
        return me(n, e), n.prototype.render = function() {
            var e = this, t = [], r = this.props, n = r.date, a = r.yearItemNumber, o = r.onYearMouseEnter, s = r.onYearMouseLeave;
            if (void 0 === n) return null;
            for(var i = gt(n, a), l = i.startPeriod, c = i.endPeriod, d = function(r) {
                t.push(ue.default.createElement("div", {
                    ref: p.YEAR_REFS[r - l],
                    onClick: function(t) {
                        e.onYearClick(t, r);
                    },
                    onKeyDown: function(t) {
                        wt(t) && (t.preventDefault(), t.key = De.Enter), e.onYearKeyDown(t, r);
                    },
                    tabIndex: Number(p.getYearTabIndex(r)),
                    className: p.getYearClassNames(r),
                    onMouseEnter: p.props.usePointerEvent ? void 0 : function(e) {
                        return o(e, r);
                    },
                    onPointerEnter: p.props.usePointerEvent ? function(e) {
                        return o(e, r);
                    } : void 0,
                    onMouseLeave: p.props.usePointerEvent ? void 0 : function(e) {
                        return s(e, r);
                    },
                    onPointerLeave: p.props.usePointerEvent ? function(e) {
                        return s(e, r);
                    } : void 0,
                    key: r,
                    "aria-current": p.isCurrentYear(r) ? "date" : void 0
                }, p.getYearContent(r)));
            }, p = this, u = l; u <= c; u++)d(u);
            return ue.default.createElement("div", {
                className: "react-datepicker__year"
            }, ue.default.createElement("div", {
                className: "react-datepicker__year-wrapper",
                onMouseLeave: this.props.usePointerEvent ? void 0 : this.props.clearSelectingDate,
                onPointerLeave: this.props.usePointerEvent ? this.props.clearSelectingDate : void 0
            }, t));
        }, n;
    }(r.Component);
    function Ht(e, t, r, n) {
        for(var a = [], o = 0; o < 2 * t + 1; o++){
            var s = e + t - o, i = !0;
            r && (i = x.getYear(r) <= s), n && i && (i = x.getYear(n) >= s), i && a.push(s);
        }
        return a;
    }
    var Qt = function(e) {
        function n(t) {
            var n = e.call(this, t) || this;
            n.renderOptions = function() {
                var e = n.props.year, t = n.state.yearsList.map(function(t) {
                    return ue.default.createElement("div", {
                        className: e === t ? "react-datepicker__year-option react-datepicker__year-option--selected_year" : "react-datepicker__year-option",
                        key: t,
                        onClick: n.onChange.bind(n, t),
                        "aria-selected": e === t ? "true" : void 0
                    }, e === t ? ue.default.createElement("span", {
                        className: "react-datepicker__year-option--selected"
                    }, "\u2713") : "", t);
                }), r = n.props.minDate ? x.getYear(n.props.minDate) : null, a = n.props.maxDate ? x.getYear(n.props.maxDate) : null;
                return a && n.state.yearsList.find(function(e) {
                    return e === a;
                }) || t.unshift(ue.default.createElement("div", {
                    className: "react-datepicker__year-option",
                    key: "upcoming",
                    onClick: n.incrementYears
                }, ue.default.createElement("a", {
                    className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming"
                }))), r && n.state.yearsList.find(function(e) {
                    return e === r;
                }) || t.push(ue.default.createElement("div", {
                    className: "react-datepicker__year-option",
                    key: "previous",
                    onClick: n.decrementYears
                }, ue.default.createElement("a", {
                    className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous"
                }))), t;
            }, n.onChange = function(e) {
                n.props.onChange(e);
            }, n.handleClickOutside = function() {
                n.props.onCancel();
            }, n.shiftYears = function(e) {
                var t = n.state.yearsList.map(function(t) {
                    return t + e;
                });
                n.setState({
                    yearsList: t
                });
            }, n.incrementYears = function() {
                return n.shiftYears(1);
            }, n.decrementYears = function() {
                return n.shiftYears(-1);
            };
            var a = t.yearDropdownItemNumber, o = t.scrollableYearDropdown, s = a || (o ? 10 : 5);
            return n.state = {
                yearsList: Ht(n.props.year, s, n.props.minDate, n.props.maxDate)
            }, n.dropdownRef = r.createRef(), n;
        }
        return me(n, e), n.prototype.componentDidMount = function() {
            var e = this.dropdownRef.current;
            if (e) {
                var t = e.children ? Array.from(e.children) : null, r = t ? t.find(function(e) {
                    return e.ariaSelected;
                }) : null;
                e.scrollTop = r && r instanceof HTMLElement ? r.offsetTop + (r.clientHeight - e.clientHeight) / 2 : (e.scrollHeight - e.clientHeight) / 2;
            }
        }, n.prototype.render = function() {
            var e = t.clsx({
                "react-datepicker__year-dropdown": !0,
                "react-datepicker__year-dropdown--scrollable": this.props.scrollableYearDropdown
            });
            return ue.default.createElement(ke, {
                className: e,
                containerRef: this.dropdownRef,
                onClickOutside: this.handleClickOutside
            }, this.renderOptions());
        }, n;
    }(r.Component), qt = function(e) {
        function t() {
            var t = null !== e && e.apply(this, arguments) || this;
            return t.state = {
                dropdownVisible: !1
            }, t.renderSelectOptions = function() {
                for(var e = t.props.minDate ? x.getYear(t.props.minDate) : 1900, r = t.props.maxDate ? x.getYear(t.props.maxDate) : 2100, n = [], a = e; a <= r; a++)n.push(ue.default.createElement("option", {
                    key: a,
                    value: a
                }, a));
                return n;
            }, t.onSelectChange = function(e) {
                t.onChange(parseInt(e.target.value));
            }, t.renderSelectMode = function() {
                return ue.default.createElement("select", {
                    value: t.props.year,
                    className: "react-datepicker__year-select",
                    onChange: t.onSelectChange
                }, t.renderSelectOptions());
            }, t.renderReadView = function(e) {
                return ue.default.createElement("div", {
                    key: "read",
                    style: {
                        visibility: e ? "visible" : "hidden"
                    },
                    className: "react-datepicker__year-read-view",
                    onClick: function(e) {
                        return t.toggleDropdown(e);
                    }
                }, ue.default.createElement("span", {
                    className: "react-datepicker__year-read-view--down-arrow"
                }), ue.default.createElement("span", {
                    className: "react-datepicker__year-read-view--selected-year"
                }, t.props.year));
            }, t.renderDropdown = function() {
                return ue.default.createElement(Qt, ve({
                    key: "dropdown"
                }, t.props, {
                    onChange: t.onChange,
                    onCancel: t.toggleDropdown
                }));
            }, t.renderScrollMode = function() {
                var e = t.state.dropdownVisible, r = [
                    t.renderReadView(!e)
                ];
                return e && r.unshift(t.renderDropdown()), r;
            }, t.onChange = function(e) {
                t.toggleDropdown(), e !== t.props.year && t.props.onChange(e);
            }, t.toggleDropdown = function(e) {
                t.setState({
                    dropdownVisible: !t.state.dropdownVisible
                }, function() {
                    t.props.adjustDateOnChange && t.handleYearChange(t.props.date, e);
                });
            }, t.handleYearChange = function(e, r) {
                var n;
                null === (n = t.onSelect) || void 0 === n || n.call(t, e, r), t.setOpen();
            }, t.onSelect = function(e, r) {
                var n, a;
                null === (a = (n = t.props).onSelect) || void 0 === a || a.call(n, e, r);
            }, t.setOpen = function() {
                var e, r;
                null === (r = (e = t.props).setOpen) || void 0 === r || r.call(e, !0);
            }, t;
        }
        return me(t, e), t.prototype.render = function() {
            var e;
            switch(this.props.dropdownMode){
                case "scroll":
                    e = this.renderScrollMode();
                    break;
                case "select":
                    e = this.renderSelectMode();
            }
            return ue.default.createElement("div", {
                className: "react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode)
            }, e);
        }, t;
    }(r.Component), Kt = [
        "react-datepicker__year-select",
        "react-datepicker__month-select",
        "react-datepicker__month-year-select"
    ], Bt = function(e) {
        function o(s) {
            var c = e.call(this, s) || this;
            return c.monthContainer = void 0, c.handleClickOutside = function(e) {
                c.props.onClickOutside(e);
            }, c.setClickOutsideRef = function() {
                return c.containerRef.current;
            }, c.handleDropdownFocus = function(e) {
                var t, r, n, a;
                n = e.target, a = (n.className || "").split(/\s+/), Kt.some(function(e) {
                    return a.indexOf(e) >= 0;
                }) && (null === (r = (t = c.props).onDropdownFocus) || void 0 === r || r.call(t, e));
            }, c.getDateInView = function() {
                var e = c.props, t = e.preSelection, r = e.selected, n = e.openToDate, a = pt(c.props), o = ut(c.props), s = Me(), i = n || r || t;
                return i || (a && N.isBefore(s, a) ? a : o && O.isAfter(s, o) ? o : s);
            }, c.increaseMonth = function() {
                c.setState(function(e) {
                    var t = e.date;
                    return {
                        date: i.addMonths(t, 1)
                    };
                }, function() {
                    return c.handleMonthChange(c.state.date);
                });
            }, c.decreaseMonth = function() {
                c.setState(function(e) {
                    var t = e.date;
                    return {
                        date: ae.subMonths(t, 1)
                    };
                }, function() {
                    return c.handleMonthChange(c.state.date);
                });
            }, c.handleDayClick = function(e, t, r) {
                c.props.onSelect(e, t, r), c.props.setPreSelection && c.props.setPreSelection(e);
            }, c.handleDayMouseEnter = function(e) {
                c.setState({
                    selectingDate: e
                }), c.props.onDayMouseEnter && c.props.onDayMouseEnter(e);
            }, c.handleMonthMouseLeave = function() {
                c.setState({
                    selectingDate: void 0
                }), c.props.onMonthMouseLeave && c.props.onMonthMouseLeave();
            }, c.handleYearMouseEnter = function(e, t) {
                c.setState({
                    selectingDate: G.setYear(Me(), t)
                }), c.props.onYearMouseEnter && c.props.onYearMouseEnter(e, t);
            }, c.handleYearMouseLeave = function(e, t) {
                c.props.onYearMouseLeave && c.props.onYearMouseLeave(e, t);
            }, c.handleYearChange = function(e) {
                var t, r, n, a;
                null === (r = (t = c.props).onYearChange) || void 0 === r || r.call(t, e), c.setState({
                    isRenderAriaLiveMessage: !0
                }), c.props.adjustDateOnChange && (c.props.onSelect(e), null === (a = (n = c.props).setOpen) || void 0 === a || a.call(n, !0)), c.props.setPreSelection && c.props.setPreSelection(e);
            }, c.getEnabledPreSelectionDateForMonth = function(e) {
                if (!$e(e, c.props)) return e;
                for(var t = Ne(e), r = Fe(e), o = n.differenceInDays(r, t), s = null, i = 0; i <= o; i++){
                    var l = a.addDays(t, i);
                    if (!$e(l, c.props)) {
                        s = l;
                        break;
                    }
                }
                return s;
            }, c.handleMonthChange = function(e) {
                var t, r, n, a = null !== (t = c.getEnabledPreSelectionDateForMonth(e)) && void 0 !== t ? t : e;
                c.handleCustomMonthChange(a), c.props.adjustDateOnChange && (c.props.onSelect(a), null === (n = (r = c.props).setOpen) || void 0 === n || n.call(r, !0)), c.props.setPreSelection && c.props.setPreSelection(a);
            }, c.handleCustomMonthChange = function(e) {
                var t, r;
                null === (r = (t = c.props).onMonthChange) || void 0 === r || r.call(t, e), c.setState({
                    isRenderAriaLiveMessage: !0
                });
            }, c.handleMonthYearChange = function(e) {
                c.handleYearChange(e), c.handleMonthChange(e);
            }, c.changeYear = function(e) {
                c.setState(function(t) {
                    var r = t.date;
                    return {
                        date: G.setYear(r, Number(e))
                    };
                }, function() {
                    return c.handleYearChange(c.state.date);
                });
            }, c.changeMonth = function(e) {
                c.setState(function(t) {
                    var r = t.date;
                    return {
                        date: $.setMonth(r, Number(e))
                    };
                }, function() {
                    return c.handleMonthChange(c.state.date);
                });
            }, c.changeMonthYear = function(e) {
                c.setState(function(t) {
                    var r = t.date;
                    return {
                        date: G.setYear($.setMonth(r, _.getMonth(e)), x.getYear(e))
                    };
                }, function() {
                    return c.handleMonthYearChange(c.state.date);
                });
            }, c.header = function(e) {
                void 0 === e && (e = c.state.date);
                var r = Oe(e, c.props.locale, c.props.calendarStartDay), n = [];
                return c.props.showWeekNumbers && n.push(ue.default.createElement("div", {
                    key: "W",
                    className: "react-datepicker__day-name"
                }, c.props.weekLabel || "#")), n.concat([
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6
                ].map(function(e) {
                    var n = a.addDays(r, e), o = c.formatWeekday(n, c.props.locale), s = c.props.weekDayClassName ? c.props.weekDayClassName(n) : void 0;
                    return ue.default.createElement("div", {
                        key: e,
                        "aria-label": Ee(n, "EEEE", c.props.locale),
                        className: t.clsx("react-datepicker__day-name", s)
                    }, o);
                }));
            }, c.formatWeekday = function(e, t) {
                return c.props.formatWeekDay ? function(e, t, r) {
                    return t(Ee(e, "EEEE", r));
                }(e, c.props.formatWeekDay, t) : c.props.useWeekdaysShort ? function(e, t) {
                    return Ee(e, "EEE", t);
                }(e, t) : function(e, t) {
                    return Ee(e, "EEEEEE", t);
                }(e, t);
            }, c.decreaseYear = function() {
                c.setState(function(e) {
                    var t, r = e.date;
                    return {
                        date: ie.subYears(r, c.props.showYearPicker ? null !== (t = c.props.yearItemNumber) && void 0 !== t ? t : o.defaultProps.yearItemNumber : 1)
                    };
                }, function() {
                    return c.handleYearChange(c.state.date);
                });
            }, c.clearSelectingDate = function() {
                c.setState({
                    selectingDate: void 0
                });
            }, c.renderPreviousButton = function() {
                var e, t, r;
                if (!c.props.renderCustomHeader) {
                    var n, a = null !== (e = c.props.monthsShown) && void 0 !== e ? e : o.defaultProps.monthsShown, s = c.props.showPreviousMonths ? a - 1 : 0, i = null !== (t = c.props.monthSelectedIn) && void 0 !== t ? t : s, l = ae.subMonths(c.state.date, i);
                    switch(!0){
                        case c.props.showMonthYearPicker:
                            n = ct(c.state.date, c.props);
                            break;
                        case c.props.showYearPicker:
                            n = function(e, t) {
                                var r = void 0 === t ? {} : t, n = r.minDate, a = r.yearItemNumber, o = void 0 === a ? Se : a, s = gt(Te(ie.subYears(e, o)), o).endPeriod, i = n && x.getYear(n);
                                return i && i > s || !1;
                            }(c.state.date, c.props);
                            break;
                        case c.props.showQuarterYearPicker:
                            n = function(e, t) {
                                var r = void 0 === t ? {} : t, n = r.minDate, a = r.includeDates, o = re.startOfYear(e), s = oe.subQuarters(o, 1);
                                return n && h.differenceInCalendarQuarters(n, s) > 0 || a && a.every(function(e) {
                                    return h.differenceInCalendarQuarters(e, s) > 0;
                                }) || !1;
                            }(c.state.date, c.props);
                            break;
                        default:
                            n = it(l, c.props);
                    }
                    if (((null !== (r = c.props.forceShowMonthNavigation) && void 0 !== r ? r : o.defaultProps.forceShowMonthNavigation) || c.props.showDisabledMonthNavigation || !n) && !c.props.showTimeSelectOnly) {
                        var d = [
                            "react-datepicker__navigation",
                            "react-datepicker__navigation--previous"
                        ], p = c.decreaseMonth;
                        (c.props.showMonthYearPicker || c.props.showQuarterYearPicker || c.props.showYearPicker) && (p = c.decreaseYear), n && c.props.showDisabledMonthNavigation && (d.push("react-datepicker__navigation--previous--disabled"), p = void 0);
                        var u = c.props.showMonthYearPicker || c.props.showQuarterYearPicker || c.props.showYearPicker, f = c.props, m = f.previousMonthButtonLabel, v = void 0 === m ? o.defaultProps.previousMonthButtonLabel : m, g = f.previousYearButtonLabel, D = void 0 === g ? o.defaultProps.previousYearButtonLabel : g, y = c.props, k = y.previousMonthAriaLabel, w = void 0 === k ? "string" == typeof v ? v : "Previous Month" : k, S = y.previousYearAriaLabel, b = void 0 === S ? "string" == typeof D ? D : "Previous Year" : S;
                        return ue.default.createElement("button", {
                            type: "button",
                            className: d.join(" "),
                            onClick: p,
                            onKeyDown: c.props.handleOnKeyDown,
                            "aria-label": u ? b : w
                        }, ue.default.createElement("span", {
                            className: [
                                "react-datepicker__navigation-icon",
                                "react-datepicker__navigation-icon--previous"
                            ].join(" ")
                        }, u ? D : v));
                    }
                }
            }, c.increaseYear = function() {
                c.setState(function(e) {
                    var t, r = e.date;
                    return {
                        date: p.addYears(r, c.props.showYearPicker ? null !== (t = c.props.yearItemNumber) && void 0 !== t ? t : o.defaultProps.yearItemNumber : 1)
                    };
                }, function() {
                    return c.handleYearChange(c.state.date);
                });
            }, c.renderNextButton = function() {
                var e;
                if (!c.props.renderCustomHeader) {
                    var t;
                    switch(!0){
                        case c.props.showMonthYearPicker:
                            t = dt(c.state.date, c.props);
                            break;
                        case c.props.showYearPicker:
                            t = function(e, t) {
                                var r = void 0 === t ? {} : t, n = r.maxDate, a = r.yearItemNumber, o = void 0 === a ? Se : a, s = gt(p.addYears(e, o), o).startPeriod, i = n && x.getYear(n);
                                return i && i < s || !1;
                            }(c.state.date, c.props);
                            break;
                        case c.props.showQuarterYearPicker:
                            t = function(e, t) {
                                var r = void 0 === t ? {} : t, n = r.maxDate, a = r.includeDates, o = y.endOfYear(e), s = l.addQuarters(o, 1);
                                return n && h.differenceInCalendarQuarters(s, n) > 0 || a && a.every(function(e) {
                                    return h.differenceInCalendarQuarters(s, e) > 0;
                                }) || !1;
                            }(c.state.date, c.props);
                            break;
                        default:
                            t = lt(c.state.date, c.props);
                    }
                    if (((null !== (e = c.props.forceShowMonthNavigation) && void 0 !== e ? e : o.defaultProps.forceShowMonthNavigation) || c.props.showDisabledMonthNavigation || !t) && !c.props.showTimeSelectOnly) {
                        var r = [
                            "react-datepicker__navigation",
                            "react-datepicker__navigation--next"
                        ];
                        c.props.showTimeSelect && r.push("react-datepicker__navigation--next--with-time"), c.props.todayButton && r.push("react-datepicker__navigation--next--with-today-button");
                        var n = c.increaseMonth;
                        (c.props.showMonthYearPicker || c.props.showQuarterYearPicker || c.props.showYearPicker) && (n = c.increaseYear), t && c.props.showDisabledMonthNavigation && (r.push("react-datepicker__navigation--next--disabled"), n = void 0);
                        var a = c.props.showMonthYearPicker || c.props.showQuarterYearPicker || c.props.showYearPicker, s = c.props, i = s.nextMonthButtonLabel, d = void 0 === i ? o.defaultProps.nextMonthButtonLabel : i, u = s.nextYearButtonLabel, f = void 0 === u ? o.defaultProps.nextYearButtonLabel : u, m = c.props, v = m.nextMonthAriaLabel, g = void 0 === v ? "string" == typeof d ? d : "Next Month" : v, D = m.nextYearAriaLabel, k = void 0 === D ? "string" == typeof f ? f : "Next Year" : D;
                        return ue.default.createElement("button", {
                            type: "button",
                            className: r.join(" "),
                            onClick: n,
                            onKeyDown: c.props.handleOnKeyDown,
                            "aria-label": a ? k : g
                        }, ue.default.createElement("span", {
                            className: [
                                "react-datepicker__navigation-icon",
                                "react-datepicker__navigation-icon--next"
                            ].join(" ")
                        }, a ? f : d));
                    }
                }
            }, c.renderCurrentMonth = function(e) {
                void 0 === e && (e = c.state.date);
                var t = [
                    "react-datepicker__current-month"
                ];
                return c.props.showYearDropdown && t.push("react-datepicker__current-month--hasYearDropdown"), c.props.showMonthDropdown && t.push("react-datepicker__current-month--hasMonthDropdown"), c.props.showMonthYearDropdown && t.push("react-datepicker__current-month--hasMonthYearDropdown"), ue.default.createElement("h2", {
                    className: t.join(" ")
                }, Ee(e, c.props.dateFormat, c.props.locale));
            }, c.renderYearDropdown = function(e) {
                if (void 0 === e && (e = !1), c.props.showYearDropdown && !e) return ue.default.createElement(qt, ve({}, o.defaultProps, c.props, {
                    date: c.state.date,
                    onChange: c.changeYear,
                    year: x.getYear(c.state.date)
                }));
            }, c.renderMonthDropdown = function(e) {
                if (void 0 === e && (e = !1), c.props.showMonthDropdown && !e) return ue.default.createElement(It, ve({}, o.defaultProps, c.props, {
                    month: _.getMonth(c.state.date),
                    onChange: c.changeMonth
                }));
            }, c.renderMonthYearDropdown = function(e) {
                if (void 0 === e && (e = !1), c.props.showMonthYearDropdown && !e) return ue.default.createElement(Ft, ve({}, o.defaultProps, c.props, {
                    date: c.state.date,
                    onChange: c.changeMonthYear
                }));
            }, c.handleTodayButtonClick = function(e) {
                c.props.onSelect(Re(), e), c.props.setPreSelection && c.props.setPreSelection(Re());
            }, c.renderTodayButton = function() {
                if (c.props.todayButton && !c.props.showTimeSelectOnly) return ue.default.createElement("div", {
                    className: "react-datepicker__today-button",
                    onClick: c.handleTodayButtonClick
                }, c.props.todayButton);
            }, c.renderDefaultHeader = function(e) {
                var t = e.monthDate, r = e.i;
                return ue.default.createElement("div", {
                    className: "react-datepicker__header ".concat(c.props.showTimeSelect ? "react-datepicker__header--has-time-select" : "")
                }, c.renderCurrentMonth(t), ue.default.createElement("div", {
                    className: "react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(c.props.dropdownMode),
                    onFocus: c.handleDropdownFocus
                }, c.renderMonthDropdown(0 !== r), c.renderMonthYearDropdown(0 !== r), c.renderYearDropdown(0 !== r)), ue.default.createElement("div", {
                    className: "react-datepicker__day-names"
                }, c.header(t)));
            }, c.renderCustomHeader = function(e) {
                var t, r, n = e.monthDate, a = e.i;
                if (c.props.showTimeSelect && !c.state.monthContainer || c.props.showTimeSelectOnly) return null;
                var o = it(c.state.date, c.props), s = lt(c.state.date, c.props), i = ct(c.state.date, c.props), l = dt(c.state.date, c.props), d = !c.props.showMonthYearPicker && !c.props.showQuarterYearPicker && !c.props.showYearPicker;
                return ue.default.createElement("div", {
                    className: "react-datepicker__header react-datepicker__header--custom",
                    onFocus: c.props.onDropdownFocus
                }, null === (r = (t = c.props).renderCustomHeader) || void 0 === r ? void 0 : r.call(t, ve(ve({}, c.state), {
                    customHeaderCount: a,
                    monthDate: n,
                    changeMonth: c.changeMonth,
                    changeYear: c.changeYear,
                    decreaseMonth: c.decreaseMonth,
                    increaseMonth: c.increaseMonth,
                    decreaseYear: c.decreaseYear,
                    increaseYear: c.increaseYear,
                    prevMonthButtonDisabled: o,
                    nextMonthButtonDisabled: s,
                    prevYearButtonDisabled: i,
                    nextYearButtonDisabled: l
                })), d && ue.default.createElement("div", {
                    className: "react-datepicker__day-names"
                }, c.header(n)));
            }, c.renderYearHeader = function(e) {
                var t = e.monthDate, r = c.props, n = r.showYearPicker, a = r.yearItemNumber, s = gt(t, void 0 === a ? o.defaultProps.yearItemNumber : a), i = s.startPeriod, l = s.endPeriod;
                return ue.default.createElement("div", {
                    className: "react-datepicker__header react-datepicker-year-header"
                }, n ? "".concat(i, " - ").concat(l) : x.getYear(t));
            }, c.renderHeader = function(e) {
                var t = e.monthDate, r = e.i, n = {
                    monthDate: t,
                    i: void 0 === r ? 0 : r
                };
                switch(!0){
                    case void 0 !== c.props.renderCustomHeader:
                        return c.renderCustomHeader(n);
                    case c.props.showMonthYearPicker || c.props.showQuarterYearPicker || c.props.showYearPicker:
                        return c.renderYearHeader(n);
                    default:
                        return c.renderDefaultHeader(n);
                }
            }, c.renderMonths = function() {
                var e, t;
                if (!c.props.showTimeSelectOnly && !c.props.showYearPicker) {
                    for(var r = [], n = null !== (e = c.props.monthsShown) && void 0 !== e ? e : o.defaultProps.monthsShown, a = c.props.showPreviousMonths ? n - 1 : 0, s = c.props.showMonthYearPicker || c.props.showQuarterYearPicker ? p.addYears(c.state.date, a) : ae.subMonths(c.state.date, a), l = null !== (t = c.props.monthSelectedIn) && void 0 !== t ? t : a, d = 0; d < n; ++d){
                        var u = d - l + a, f = c.props.showMonthYearPicker || c.props.showQuarterYearPicker ? p.addYears(s, u) : i.addMonths(s, u), h = "month-".concat(d), m = d < n - 1, v = d > 0;
                        r.push(ue.default.createElement("div", {
                            key: h,
                            ref: function(e) {
                                c.monthContainer = null != e ? e : void 0;
                            },
                            className: "react-datepicker__month-container"
                        }, c.renderHeader({
                            monthDate: f,
                            i: d
                        }), ue.default.createElement(Nt, ve({}, o.defaultProps, c.props, {
                            ariaLabelPrefix: c.props.monthAriaLabelPrefix,
                            day: f,
                            onDayClick: c.handleDayClick,
                            handleOnKeyDown: c.props.handleOnDayKeyDown,
                            handleOnMonthKeyDown: c.props.handleOnKeyDown,
                            onDayMouseEnter: c.handleDayMouseEnter,
                            onMouseLeave: c.handleMonthMouseLeave,
                            orderInDisplay: d,
                            selectingDate: c.state.selectingDate,
                            monthShowsDuplicateDaysEnd: m,
                            monthShowsDuplicateDaysStart: v
                        }))));
                    }
                    return r;
                }
            }, c.renderYears = function() {
                if (!c.props.showTimeSelectOnly) return c.props.showYearPicker ? ue.default.createElement("div", {
                    className: "react-datepicker__year--container"
                }, c.renderHeader({
                    monthDate: c.state.date
                }), ue.default.createElement(Wt, ve({}, o.defaultProps, c.props, {
                    selectingDate: c.state.selectingDate,
                    date: c.state.date,
                    onDayClick: c.handleDayClick,
                    clearSelectingDate: c.clearSelectingDate,
                    onYearMouseEnter: c.handleYearMouseEnter,
                    onYearMouseLeave: c.handleYearMouseLeave
                }))) : void 0;
            }, c.renderTimeSection = function() {
                if (c.props.showTimeSelect && (c.state.monthContainer || c.props.showTimeSelectOnly)) return ue.default.createElement(At, ve({}, o.defaultProps, c.props, {
                    onChange: c.props.onTimeChange,
                    format: c.props.timeFormat,
                    intervals: c.props.timeIntervals,
                    monthRef: c.state.monthContainer
                }));
            }, c.renderInputTimeSection = function() {
                var e = c.props.selected ? new Date(c.props.selected) : void 0, t = e && _e(e) && Boolean(c.props.selected) ? "".concat(vt(e.getHours()), ":").concat(vt(e.getMinutes())) : "";
                if (c.props.showTimeInput) return ue.default.createElement(bt, ve({}, o.defaultProps, c.props, {
                    date: e,
                    timeString: t,
                    onChange: c.props.onTimeChange
                }));
            }, c.renderAriaLiveRegion = function() {
                var e, t, r = gt(c.state.date, null !== (e = c.props.yearItemNumber) && void 0 !== e ? e : o.defaultProps.yearItemNumber), n = r.startPeriod, a = r.endPeriod;
                return t = c.props.showYearPicker ? "".concat(n, " - ").concat(a) : c.props.showMonthYearPicker || c.props.showQuarterYearPicker ? x.getYear(c.state.date) : "".concat(je(_.getMonth(c.state.date), c.props.locale), " ").concat(x.getYear(c.state.date)), ue.default.createElement("span", {
                    role: "alert",
                    "aria-live": "polite",
                    className: "react-datepicker__aria-live"
                }, c.state.isRenderAriaLiveMessage && t);
            }, c.renderChildren = function() {
                if (c.props.children) return ue.default.createElement("div", {
                    className: "react-datepicker__children-container"
                }, c.props.children);
            }, c.containerRef = r.createRef(), c.state = {
                date: c.getDateInView(),
                selectingDate: void 0,
                monthContainer: void 0,
                isRenderAriaLiveMessage: !1
            }, c;
        }
        return me(o, e), Object.defineProperty(o, "defaultProps", {
            get: function() {
                return {
                    monthsShown: 1,
                    forceShowMonthNavigation: !1,
                    timeCaption: "Time",
                    previousYearButtonLabel: "Previous Year",
                    nextYearButtonLabel: "Next Year",
                    previousMonthButtonLabel: "Previous Month",
                    nextMonthButtonLabel: "Next Month",
                    yearItemNumber: Se
                };
            },
            enumerable: !1,
            configurable: !0
        }), o.prototype.componentDidMount = function() {
            var e = this;
            this.props.showTimeSelect && (this.assignMonthContainer = void e.setState({
                monthContainer: e.monthContainer
            }));
        }, o.prototype.componentDidUpdate = function(e) {
            var t = this;
            if (!this.props.preSelection || Qe(this.props.preSelection, e.preSelection) && this.props.monthSelectedIn === e.monthSelectedIn) this.props.openToDate && !Qe(this.props.openToDate, e.openToDate) && this.setState({
                date: this.props.openToDate
            });
            else {
                var r = !We(this.state.date, this.props.preSelection);
                this.setState({
                    date: this.props.preSelection
                }, function() {
                    return r && t.handleCustomMonthChange(t.state.date);
                });
            }
        }, o.prototype.render = function() {
            var e = this.props.container || ye;
            return ue.default.createElement(ke, {
                onClickOutside: this.handleClickOutside,
                style: {
                    display: "contents"
                },
                containerRef: this.containerRef,
                ignoreClass: this.props.outsideClickIgnoreClass
            }, ue.default.createElement(e, {
                className: t.clsx("react-datepicker", this.props.className, {
                    "react-datepicker--time-only": this.props.showTimeSelectOnly
                }),
                showTime: this.props.showTimeSelect || this.props.showTimeInput,
                showTimeSelectOnly: this.props.showTimeSelectOnly
            }, this.renderAriaLiveRegion(), this.renderPreviousButton(), this.renderNextButton(), this.renderMonths(), this.renderYears(), this.renderTodayButton(), this.renderTimeSection(), this.renderInputTimeSection(), this.renderChildren()));
        }, o;
    }(r.Component), Vt = function(e) {
        var t = e.icon, r = e.className, n = void 0 === r ? "" : r, a = e.onClick, o = "react-datepicker__calendar-icon";
        return "string" == typeof t ? ue.default.createElement("i", {
            className: "".concat(o, " ").concat(t, " ").concat(n),
            "aria-hidden": "true",
            onClick: a
        }) : ue.default.isValidElement(t) ? ue.default.cloneElement(t, {
            className: "".concat(t.props.className || "", " ").concat(o, " ").concat(n),
            onClick: function(e) {
                "function" == typeof t.props.onClick && t.props.onClick(e), "function" == typeof a && a(e);
            }
        }) : ue.default.createElement("svg", {
            className: "".concat(o, " ").concat(n),
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 448 512",
            onClick: a
        }, ue.default.createElement("path", {
            d: "M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192z"
        }));
    }, jt = function(e) {
        function t(t) {
            var r = e.call(this, t) || this;
            return r.portalRoot = null, r.el = document.createElement("div"), r;
        }
        return me(t, e), t.prototype.componentDidMount = function() {
            this.portalRoot = (this.props.portalHost || document).getElementById(this.props.portalId), this.portalRoot || (this.portalRoot = document.createElement("div"), this.portalRoot.setAttribute("id", this.props.portalId), (this.props.portalHost || document.body).appendChild(this.portalRoot)), this.portalRoot.appendChild(this.el);
        }, t.prototype.componentWillUnmount = function() {
            this.portalRoot && this.portalRoot.removeChild(this.el);
        }, t.prototype.render = function() {
            return fe.default.createPortal(this.props.children, this.el);
        }, t;
    }(r.Component), Ut = function(e) {
        return (e instanceof HTMLAnchorElement || !e.disabled) && -1 !== e.tabIndex;
    }, $t = function(e) {
        function t(t) {
            var n = e.call(this, t) || this;
            return n.getTabChildren = function() {
                var e;
                return Array.prototype.slice.call(null === (e = n.tabLoopRef.current) || void 0 === e ? void 0 : e.querySelectorAll("[tabindex], a, button, input, select, textarea"), 1, -1).filter(Ut);
            }, n.handleFocusStart = function() {
                var e = n.getTabChildren();
                e && e.length > 1 && e[e.length - 1].focus();
            }, n.handleFocusEnd = function() {
                var e = n.getTabChildren();
                e && e.length > 1 && e[0].focus();
            }, n.tabLoopRef = r.createRef(), n;
        }
        return me(t, e), t.prototype.render = function() {
            var e;
            return (null !== (e = this.props.enableTabLoop) && void 0 !== e ? e : t.defaultProps.enableTabLoop) ? ue.default.createElement("div", {
                className: "react-datepicker__tab-loop",
                ref: this.tabLoopRef
            }, ue.default.createElement("div", {
                className: "react-datepicker__tab-loop__start",
                tabIndex: 0,
                onFocus: this.handleFocusStart
            }), this.props.children, ue.default.createElement("div", {
                className: "react-datepicker__tab-loop__end",
                tabIndex: 0,
                onFocus: this.handleFocusEnd
            })) : this.props.children;
        }, t.defaultProps = {
            enableTabLoop: !0
        }, t;
    }(r.Component);
    var zt, Xt = function(e) {
        function n() {
            return null !== e && e.apply(this, arguments) || this;
        }
        return me(n, e), Object.defineProperty(n, "defaultProps", {
            get: function() {
                return {
                    hidePopper: !0
                };
            },
            enumerable: !1,
            configurable: !0
        }), n.prototype.render = function() {
            var e = this.props, a = e.className, o = e.wrapperClassName, s = e.hidePopper, i = void 0 === s ? n.defaultProps.hidePopper : s, l = e.popperComponent, c = e.targetComponent, d = e.enableTabLoop, p = e.popperOnKeyDown, u = e.portalId, f = e.portalHost, h = e.popperProps, m = e.showArrow, v = void 0;
            if (!i) {
                var g = t.clsx("react-datepicker-popper", a);
                v = ue.default.createElement($t, {
                    enableTabLoop: d
                }, ue.default.createElement("div", {
                    ref: h.refs.setFloating,
                    style: h.floatingStyles,
                    className: g,
                    "data-placement": h.placement,
                    onKeyDown: p
                }, l, m && ue.default.createElement(ce.FloatingArrow, {
                    ref: h.arrowRef,
                    context: h.context,
                    fill: "currentColor",
                    strokeWidth: 1,
                    height: 8,
                    width: 16,
                    style: {
                        transform: "translateY(-1px)"
                    },
                    className: "react-datepicker__triangle"
                })));
            }
            this.props.popperContainer && (v = r.createElement(this.props.popperContainer, {}, v)), u && !i && (v = ue.default.createElement(jt, {
                portalId: u,
                portalHost: f
            }, v));
            var D = t.clsx("react-datepicker-wrapper", o);
            return ue.default.createElement(ue.default.Fragment, null, ue.default.createElement("div", {
                ref: h.refs.setReference,
                className: D
            }, c), v);
        }, n;
    }(r.Component), Gt = (zt = Xt, function(e) {
        var t, n = "boolean" != typeof e.hidePopper || e.hidePopper, a = r.useRef(null), o = ce.useFloating(ve({
            open: !n,
            whileElementsMounted: ce.autoUpdate,
            placement: e.popperPlacement,
            middleware: ge([
                ce.flip({
                    padding: 15
                }),
                ce.offset(10),
                ce.arrow({
                    element: a
                })
            ], null !== (t = e.popperModifiers) && void 0 !== t ? t : [], !0)
        }, e.popperProps)), s = ve(ve({}, e), {
            hidePopper: n,
            popperProps: ve(ve({}, o), {
                arrowRef: a
            })
        });
        return ue.default.createElement(zt, ve({}, s));
    }), Jt = "react-datepicker-ignore-onclickoutside";
    var Zt = "Date input not valid.", er = function(e) {
        function n(o) {
            var s = e.call(this, o) || this;
            return s.calendar = null, s.input = null, s.getPreSelection = function() {
                return s.props.openToDate ? s.props.openToDate : s.props.selectsEnd && s.props.startDate ? s.props.startDate : s.props.selectsStart && s.props.endDate ? s.props.endDate : Me();
            }, s.modifyHolidays = function() {
                var e;
                return null === (e = s.props.holidays) || void 0 === e ? void 0 : e.reduce(function(e, t) {
                    var r = new Date(t.date);
                    return _e(r) ? ge(ge([], e, !0), [
                        ve(ve({}, t), {
                            date: r
                        })
                    ], !1) : e;
                }, []);
            }, s.calcInitialState = function() {
                var e, t = s.getPreSelection(), r = pt(s.props), n = ut(s.props), a = r && N.isBefore(t, xe(r)) ? r : n && O.isAfter(t, Le(n)) ? n : t;
                return {
                    open: s.props.startOpen || !1,
                    preventFocus: !1,
                    inputValue: null,
                    preSelection: null !== (e = s.props.selectsRange ? s.props.startDate : s.props.selected) && void 0 !== e ? e : a,
                    highlightDates: ft(s.props.highlightDates),
                    focused: !1,
                    shouldFocusDayInline: !1,
                    isRenderAriaLiveMessage: !1,
                    wasHidden: !1
                };
            }, s.resetHiddenStatus = function() {
                s.setState(ve(ve({}, s.state), {
                    wasHidden: !1
                }));
            }, s.setHiddenStatus = function() {
                s.setState(ve(ve({}, s.state), {
                    wasHidden: !0
                }));
            }, s.setHiddenStateOnVisibilityHidden = function() {
                "hidden" === document.visibilityState && s.setHiddenStatus();
            }, s.clearPreventFocusTimeout = function() {
                s.preventFocusTimeout && clearTimeout(s.preventFocusTimeout);
            }, s.safeFocus = function() {
                setTimeout(function() {
                    var e, t;
                    null === (t = null === (e = s.input) || void 0 === e ? void 0 : e.focus) || void 0 === t || t.call(e, {
                        preventScroll: !0
                    });
                }, 0);
            }, s.safeBlur = function() {
                setTimeout(function() {
                    var e, t;
                    null === (t = null === (e = s.input) || void 0 === e ? void 0 : e.blur) || void 0 === t || t.call(e);
                }, 0);
            }, s.setFocus = function() {
                s.safeFocus();
            }, s.setBlur = function() {
                s.safeBlur(), s.cancelFocusInput();
            }, s.setOpen = function(e, t) {
                void 0 === t && (t = !1), s.setState({
                    open: e,
                    preSelection: e && s.state.open ? s.state.preSelection : s.calcInitialState().preSelection,
                    lastPreSelectChange: rr
                }, function() {
                    e || s.setState(function(e) {
                        return {
                            focused: !!t && e.focused
                        };
                    }, function() {
                        !t && s.setBlur(), s.setState({
                            inputValue: null
                        });
                    });
                });
            }, s.inputOk = function() {
                return T.isDate(s.state.preSelection);
            }, s.isCalendarOpen = function() {
                return void 0 === s.props.open ? s.state.open && !s.props.disabled && !s.props.readOnly : s.props.open;
            }, s.handleFocus = function(e) {
                var t, r, n = s.state.wasHidden, a = !n || s.state.open;
                n && s.resetHiddenStatus(), !s.state.preventFocus && a && (null === (r = (t = s.props).onFocus) || void 0 === r || r.call(t, e), s.props.preventOpenOnFocus || s.props.readOnly || s.setOpen(!0)), s.setState({
                    focused: !0
                });
            }, s.sendFocusBackToInput = function() {
                s.preventFocusTimeout && s.clearPreventFocusTimeout(), s.setState({
                    preventFocus: !0
                }, function() {
                    s.preventFocusTimeout = setTimeout(function() {
                        s.setFocus(), s.setState({
                            preventFocus: !1
                        });
                    });
                });
            }, s.cancelFocusInput = function() {
                clearTimeout(s.inputFocusTimeout), s.inputFocusTimeout = void 0;
            }, s.deferFocusInput = function() {
                s.cancelFocusInput(), s.inputFocusTimeout = setTimeout(function() {
                    return s.setFocus();
                }, 1);
            }, s.handleDropdownFocus = function() {
                s.cancelFocusInput();
            }, s.handleBlur = function(e) {
                var t, r;
                (!s.state.open || s.props.withPortal || s.props.showTimeInput) && (null === (r = (t = s.props).onBlur) || void 0 === r || r.call(t, e)), s.setState({
                    focused: !1
                });
            }, s.handleCalendarClickOutside = function(e) {
                var t, r;
                s.props.inline || s.setOpen(!1), null === (r = (t = s.props).onClickOutside) || void 0 === r || r.call(t, e), s.props.withPortal && e.preventDefault();
            }, s.handleChange = function() {
                for(var e, t, r = [], a = 0; a < arguments.length; a++)r[a] = arguments[a];
                var o = r[0];
                if (!s.props.onChangeRaw || (s.props.onChangeRaw.apply(s, r), o && "function" == typeof o.isDefaultPrevented && !o.isDefaultPrevented())) {
                    s.setState({
                        inputValue: (null == o ? void 0 : o.target) instanceof HTMLInputElement ? o.target.value : null,
                        lastPreSelectChange: tr
                    });
                    var i = s.props, l = i.dateFormat, c = void 0 === l ? n.defaultProps.dateFormat : l, d = i.strictParsing, p = void 0 === d ? n.defaultProps.strictParsing : d, u = i.selectsRange, f = i.startDate, h = i.endDate, m = (null == o ? void 0 : o.target) instanceof HTMLInputElement ? o.target.value : "";
                    if (u) {
                        var v = m.split("-", 2).map(function(e) {
                            return e.trim();
                        }), g = v[0], D = v[1], y = Ce(null != g ? g : "", c, s.props.locale, p), k = Ce(null != D ? D : "", c, s.props.locale, p), w = (null == f ? void 0 : f.getTime()) !== (null == y ? void 0 : y.getTime()), S = (null == h ? void 0 : h.getTime()) !== (null == k ? void 0 : k.getTime());
                        if (!w && !S) return;
                        if (y && $e(y, s.props)) return;
                        if (k && $e(k, s.props)) return;
                        null === (t = (e = s.props).onChange) || void 0 === t || t.call(e, [
                            y,
                            k
                        ], o);
                    } else {
                        var M = Ce(m, c, s.props.locale, p, s.props.minDate);
                        s.props.showTimeSelectOnly && s.props.selected && M && !Qe(M, s.props.selected) && (M = V.set(s.props.selected, {
                            hours: b.getHours(M),
                            minutes: C.getMinutes(M),
                            seconds: P.getSeconds(M)
                        })), !M && m || s.setSelected(M, o, !0);
                    }
                }
            }, s.handleSelect = function(e, t, r) {
                if (s.props.shouldCloseOnSelect && !s.props.showTimeSelect && s.sendFocusBackToInput(), s.props.onChangeRaw && s.props.onChangeRaw(t), s.setSelected(e, t, !1, r), s.props.showDateSelect && s.setState({
                    isRenderAriaLiveMessage: !0
                }), !s.props.shouldCloseOnSelect || s.props.showTimeSelect) s.setPreSelection(e);
                else if (!s.props.inline) {
                    s.props.selectsRange || s.setOpen(!1);
                    var n = s.props, a = n.startDate, o = n.endDate;
                    !a || o || !s.props.swapRange && kt(e, a) || s.setOpen(!1);
                }
            }, s.setSelected = function(e, t, r, n) {
                var a, o, i = e;
                if (s.props.showYearPicker) {
                    if (null !== i && tt(x.getYear(i), s.props)) return;
                } else if (s.props.showMonthYearPicker) {
                    if (null !== i && Xe(i, s.props)) return;
                } else if (null !== i && $e(i, s.props)) return;
                var l = s.props, c = l.onChange, d = l.selectsRange, p = l.startDate, u = l.endDate, f = l.selectsMultiple, h = l.selectedDates, m = l.minTime, v = l.swapRange;
                if (!qe(s.props.selected, i) || s.props.allowSameDay || d || f) {
                    if (null !== i && (!s.props.selected || r && (s.props.showTimeSelect || s.props.showTimeSelectOnly || s.props.showTimeInput) || (i = Ye(i, {
                        hour: b.getHours(s.props.selected),
                        minute: C.getMinutes(s.props.selected),
                        second: P.getSeconds(s.props.selected)
                    })), r || !s.props.showTimeSelect && !s.props.showTimeSelectOnly || m && (i = Ye(i, {
                        hour: m.getHours(),
                        minute: m.getMinutes(),
                        second: m.getSeconds()
                    })), s.props.inline || s.setState({
                        preSelection: i
                    }), s.props.focusSelectedMonth || s.setState({
                        monthSelectedIn: n
                    })), d) {
                        var g = p && !u, D = p && u;
                        !p && !u ? null == c || c([
                            i,
                            null
                        ], t) : g && (null === i ? null == c || c([
                            null,
                            null
                        ], t) : kt(i, p) ? v ? null == c || c([
                            i,
                            p
                        ], t) : null == c || c([
                            i,
                            null
                        ], t) : null == c || c([
                            p,
                            i
                        ], t)), D && (null == c || c([
                            i,
                            null
                        ], t));
                    } else if (f) {
                        if (null !== i) {
                            if (null == h ? void 0 : h.length) {
                                if (h.some(function(e) {
                                    return Qe(e, i);
                                })) {
                                    var y = h.filter(function(e) {
                                        return !Qe(e, i);
                                    });
                                    null == c || c(y, t);
                                } else null == c || c(ge(ge([], h, !0), [
                                    i
                                ], !1), t);
                            } else null == c || c([
                                i
                            ], t);
                        }
                    } else null == c || c(i, t);
                }
                r || (null === (o = (a = s.props).onSelect) || void 0 === o || o.call(a, i, t), s.setState({
                    inputValue: null
                }));
            }, s.setPreSelection = function(e) {
                var t = T.isDate(s.props.minDate), r = T.isDate(s.props.maxDate), n = !0;
                if (e) {
                    var a = xe(e);
                    if (t && r) n = Ke(e, s.props.minDate, s.props.maxDate);
                    else if (t) {
                        var o = xe(s.props.minDate);
                        n = O.isAfter(e, o) || qe(a, o);
                    } else if (r) {
                        var i = Le(s.props.maxDate);
                        n = N.isBefore(e, i) || qe(a, i);
                    }
                }
                n && s.setState({
                    preSelection: e
                });
            }, s.toggleCalendar = function() {
                s.setOpen(!s.state.open);
            }, s.handleTimeChange = function(e) {
                var t, r;
                if (!s.props.selectsRange && !s.props.selectsMultiple) {
                    var n = s.props.selected ? s.props.selected : s.getPreSelection(), a = s.props.selected ? e : Ye(n, {
                        hour: b.getHours(e),
                        minute: C.getMinutes(e)
                    });
                    s.setState({
                        preSelection: a
                    }), null === (r = (t = s.props).onChange) || void 0 === r || r.call(t, a), s.props.shouldCloseOnSelect && !s.props.showTimeInput && (s.sendFocusBackToInput(), s.setOpen(!1)), s.props.showTimeInput && s.setOpen(!0), (s.props.showTimeSelectOnly || s.props.showTimeSelect) && s.setState({
                        isRenderAriaLiveMessage: !0
                    }), s.setState({
                        inputValue: null
                    });
                }
            }, s.onInputClick = function() {
                var e, t;
                s.props.disabled || s.props.readOnly || s.setOpen(!0), null === (t = (e = s.props).onInputClick) || void 0 === t || t.call(e);
            }, s.onInputKeyDown = function(e) {
                var t, r, n, a, o, i;
                null === (r = (t = s.props).onKeyDown) || void 0 === r || r.call(t, e);
                var l = e.key;
                if (s.state.open || s.props.inline || s.props.preventOpenOnFocus) {
                    if (s.state.open) {
                        if (l === De.ArrowDown || l === De.ArrowUp) {
                            e.preventDefault();
                            var c = s.props.showTimeSelectOnly ? ".react-datepicker__time-list-item[tabindex='0']" : s.props.showWeekPicker && s.props.showWeekNumbers ? '.react-datepicker__week-number[tabindex="0"]' : s.props.showFullMonthYearPicker || s.props.showMonthYearPicker ? '.react-datepicker__month-text[tabindex="0"]' : '.react-datepicker__day[tabindex="0"]', d = (null === (a = s.calendar) || void 0 === a ? void 0 : a.containerRef.current) instanceof Element && s.calendar.containerRef.current.querySelector(c);
                            return void (d instanceof HTMLElement && d.focus({
                                preventScroll: !0
                            }));
                        }
                        var p = Me(s.state.preSelection);
                        l === De.Enter ? (e.preventDefault(), e.target.blur(), s.inputOk() && s.state.lastPreSelectChange === rr ? (s.handleSelect(p, e), !s.props.shouldCloseOnSelect && s.setPreSelection(p)) : s.setOpen(!1)) : l === De.Escape ? (e.preventDefault(), e.target.blur(), s.sendFocusBackToInput(), s.setOpen(!1)) : l === De.Tab && s.setOpen(!1), s.inputOk() || null === (i = (o = s.props).onInputError) || void 0 === i || i.call(o, {
                            code: 1,
                            msg: Zt
                        });
                    }
                } else l !== De.ArrowDown && l !== De.ArrowUp && l !== De.Enter || null === (n = s.onInputClick) || void 0 === n || n.call(s);
            }, s.onPortalKeyDown = function(e) {
                e.key === De.Escape && (e.preventDefault(), s.setState({
                    preventFocus: !0
                }, function() {
                    s.setOpen(!1), setTimeout(function() {
                        s.setFocus(), s.setState({
                            preventFocus: !1
                        });
                    });
                }));
            }, s.onDayKeyDown = function(e) {
                var t, r, n, o, l, c, u = s.props, f = u.minDate, h = u.maxDate, m = u.disabledKeyboardNavigation, v = u.showWeekPicker, g = u.shouldCloseOnSelect, y = u.locale, k = u.calendarStartDay, w = u.adjustDateOnChange, S = u.inline;
                if (null === (r = (t = s.props).onKeyDown) || void 0 === r || r.call(t, e), !m) {
                    var b = e.key, M = e.shiftKey, C = Me(s.state.preSelection), E = function(e, t) {
                        var r = t;
                        switch(e){
                            case De.ArrowRight:
                                r = v ? d.addWeeks(t, 1) : a.addDays(t, 1);
                                break;
                            case De.ArrowLeft:
                                r = v ? se.subWeeks(t, 1) : ne.subDays(t, 1);
                                break;
                            case De.ArrowUp:
                                r = se.subWeeks(t, 1);
                                break;
                            case De.ArrowDown:
                                r = d.addWeeks(t, 1);
                                break;
                            case De.PageUp:
                                r = M ? ie.subYears(t, 1) : ae.subMonths(t, 1);
                                break;
                            case De.PageDown:
                                r = M ? p.addYears(t, 1) : i.addMonths(t, 1);
                                break;
                            case De.Home:
                                r = Oe(t, y, k);
                                break;
                            case De.End:
                                r = function(e) {
                                    return D.endOfWeek(e);
                                }(t);
                        }
                        return r;
                    };
                    if (b === De.Enter) return e.preventDefault(), s.handleSelect(C, e), void (!g && s.setPreSelection(C));
                    if (b === De.Escape) return e.preventDefault(), s.setOpen(!1), void (s.inputOk() || null === (o = (n = s.props).onInputError) || void 0 === o || o.call(n, {
                        code: 1,
                        msg: Zt
                    }));
                    var P = null;
                    switch(b){
                        case De.ArrowLeft:
                        case De.ArrowRight:
                        case De.ArrowUp:
                        case De.ArrowDown:
                        case De.PageUp:
                        case De.PageDown:
                        case De.Home:
                        case De.End:
                            P = function(e, t) {
                                for(var r = e, n = !1, a = 0, o = E(e, t); !n;){
                                    if (a >= 40) {
                                        o = t;
                                        break;
                                    }
                                    f && o < f && (r = De.ArrowRight, o = $e(f, s.props) ? E(r, o) : f), h && o > h && (r = De.ArrowLeft, o = $e(h, s.props) ? E(r, o) : h), $e(o, s.props) ? (r !== De.PageUp && r !== De.Home || (r = De.ArrowRight), r !== De.PageDown && r !== De.End || (r = De.ArrowLeft), o = E(r, o)) : n = !0, a++;
                                }
                                return o;
                            }(b, C);
                    }
                    if (P) {
                        if (e.preventDefault(), s.setState({
                            lastPreSelectChange: rr
                        }), w && s.setSelected(P), s.setPreSelection(P), S) {
                            var Y = _.getMonth(C), O = _.getMonth(P), N = x.getYear(C), T = x.getYear(P);
                            Y !== O || N !== T ? s.setState({
                                shouldFocusDayInline: !0
                            }) : s.setState({
                                shouldFocusDayInline: !1
                            });
                        }
                    } else null === (c = (l = s.props).onInputError) || void 0 === c || c.call(l, {
                        code: 1,
                        msg: Zt
                    });
                }
            }, s.onPopperKeyDown = function(e) {
                e.key === De.Escape && (e.preventDefault(), s.sendFocusBackToInput());
            }, s.onClearClick = function(e) {
                e && e.preventDefault && e.preventDefault(), s.sendFocusBackToInput();
                var t = s.props, r = t.selectsRange, n = t.onChange;
                r ? null == n || n([
                    null,
                    null
                ], e) : null == n || n(null, e), s.setState({
                    inputValue: null
                });
            }, s.clear = function() {
                s.onClearClick();
            }, s.onScroll = function(e) {
                "boolean" == typeof s.props.closeOnScroll && s.props.closeOnScroll ? e.target !== document && e.target !== document.documentElement && e.target !== document.body || s.setOpen(!1) : "function" == typeof s.props.closeOnScroll && s.props.closeOnScroll(e) && s.setOpen(!1);
            }, s.renderCalendar = function() {
                var e, t;
                return s.props.inline || s.isCalendarOpen() ? ue.default.createElement(Bt, ve({
                    showMonthYearDropdown: void 0,
                    ref: function(e) {
                        s.calendar = e;
                    }
                }, s.props, s.state, {
                    setOpen: s.setOpen,
                    dateFormat: null !== (e = s.props.dateFormatCalendar) && void 0 !== e ? e : n.defaultProps.dateFormatCalendar,
                    onSelect: s.handleSelect,
                    onClickOutside: s.handleCalendarClickOutside,
                    holidays: ht(s.modifyHolidays()),
                    outsideClickIgnoreClass: Jt,
                    onDropdownFocus: s.handleDropdownFocus,
                    onTimeChange: s.handleTimeChange,
                    className: s.props.calendarClassName,
                    container: s.props.calendarContainer,
                    handleOnKeyDown: s.props.onKeyDown,
                    handleOnDayKeyDown: s.onDayKeyDown,
                    setPreSelection: s.setPreSelection,
                    dropdownMode: null !== (t = s.props.dropdownMode) && void 0 !== t ? t : n.defaultProps.dropdownMode
                }), s.props.children) : null;
            }, s.renderAriaLiveRegion = function() {
                var e, t = s.props, r = t.dateFormat, a = void 0 === r ? n.defaultProps.dateFormat : r, o = t.locale, i = s.props.showTimeInput || s.props.showTimeSelect ? "PPPPp" : "PPPP";
                return e = s.props.selectsRange ? "Selected start date: ".concat(Pe(s.props.startDate, {
                    dateFormat: i,
                    locale: o
                }), ". ").concat(s.props.endDate ? "End date: " + Pe(s.props.endDate, {
                    dateFormat: i,
                    locale: o
                }) : "") : s.props.showTimeSelectOnly ? "Selected time: ".concat(Pe(s.props.selected, {
                    dateFormat: a,
                    locale: o
                })) : s.props.showYearPicker ? "Selected year: ".concat(Pe(s.props.selected, {
                    dateFormat: "yyyy",
                    locale: o
                })) : s.props.showMonthYearPicker ? "Selected month: ".concat(Pe(s.props.selected, {
                    dateFormat: "MMMM yyyy",
                    locale: o
                })) : s.props.showQuarterYearPicker ? "Selected quarter: ".concat(Pe(s.props.selected, {
                    dateFormat: "yyyy, QQQ",
                    locale: o
                })) : "Selected date: ".concat(Pe(s.props.selected, {
                    dateFormat: i,
                    locale: o
                })), ue.default.createElement("span", {
                    role: "alert",
                    "aria-live": "polite",
                    className: "react-datepicker__aria-live"
                }, e);
            }, s.renderDateInput = function() {
                var e, a, o, i = t.clsx(s.props.className, ((e = {})[Jt] = s.state.open, e)), l = s.props.customInput || ue.default.createElement("input", {
                    type: "text"
                }), c = s.props.customInputRef || "ref", d = s.props, p = d.dateFormat, u = void 0 === p ? n.defaultProps.dateFormat : p, f = d.locale, h = "string" == typeof s.props.value ? s.props.value : "string" == typeof s.state.inputValue ? s.state.inputValue : s.props.selectsRange ? function(e, t, r) {
                    if (!e) return "";
                    var n = Pe(e, r), a = t ? Pe(t, r) : "";
                    return "".concat(n, " - ").concat(a);
                }(s.props.startDate, s.props.endDate, {
                    dateFormat: u,
                    locale: f
                }) : s.props.selectsMultiple ? function(e, t) {
                    if (!(null == e ? void 0 : e.length)) return "";
                    var r = e[0] ? Pe(e[0], t) : "";
                    if (1 === e.length) return r;
                    if (2 === e.length && e[1]) {
                        var n = Pe(e[1], t);
                        return "".concat(r, ", ").concat(n);
                    }
                    var a = e.length - 1;
                    return "".concat(r, " (+").concat(a, ")");
                }(null !== (o = s.props.selectedDates) && void 0 !== o ? o : [], {
                    dateFormat: u,
                    locale: f
                }) : Pe(s.props.selected, {
                    dateFormat: u,
                    locale: f
                });
                return r.cloneElement(l, ((a = {})[c] = function(e) {
                    s.input = e;
                }, a.value = h, a.onBlur = s.handleBlur, a.onChange = s.handleChange, a.onClick = s.onInputClick, a.onFocus = s.handleFocus, a.onKeyDown = s.onInputKeyDown, a.id = s.props.id, a.name = s.props.name, a.form = s.props.form, a.autoFocus = s.props.autoFocus, a.placeholder = s.props.placeholderText, a.disabled = s.props.disabled, a.autoComplete = s.props.autoComplete, a.className = t.clsx(l.props.className, i), a.title = s.props.title, a.readOnly = s.props.readOnly, a.required = s.props.required, a.tabIndex = s.props.tabIndex, a["aria-describedby"] = s.props.ariaDescribedBy, a["aria-invalid"] = s.props.ariaInvalid, a["aria-labelledby"] = s.props.ariaLabelledBy, a["aria-required"] = s.props.ariaRequired, a));
            }, s.renderClearButton = function() {
                var e = s.props, r = e.isClearable, n = e.disabled, a = e.selected, o = e.startDate, i = e.endDate, l = e.clearButtonTitle, c = e.clearButtonClassName, d = void 0 === c ? "" : c, p = e.ariaLabelClose, u = void 0 === p ? "Close" : p, f = e.selectedDates;
                return r && (null != a || null != o || null != i || (null == f ? void 0 : f.length)) ? ue.default.createElement("button", {
                    type: "button",
                    className: t.clsx("react-datepicker__close-icon", d, {
                        "react-datepicker__close-icon--disabled": n
                    }),
                    disabled: n,
                    "aria-label": u,
                    onClick: s.onClearClick,
                    title: l,
                    tabIndex: -1
                }) : null;
            }, s.state = s.calcInitialState(), s.preventFocusTimeout = void 0, s;
        }
        return me(n, e), Object.defineProperty(n, "defaultProps", {
            get: function() {
                return {
                    allowSameDay: !1,
                    dateFormat: "MM/dd/yyyy",
                    dateFormatCalendar: "LLLL yyyy",
                    disabled: !1,
                    disabledKeyboardNavigation: !1,
                    dropdownMode: "scroll",
                    preventOpenOnFocus: !1,
                    monthsShown: 1,
                    readOnly: !1,
                    withPortal: !1,
                    selectsDisabledDaysInRange: !1,
                    shouldCloseOnSelect: !0,
                    showTimeSelect: !1,
                    showTimeInput: !1,
                    showPreviousMonths: !1,
                    showMonthYearPicker: !1,
                    showFullMonthYearPicker: !1,
                    showTwoColumnMonthYearPicker: !1,
                    showFourColumnMonthYearPicker: !1,
                    showYearPicker: !1,
                    showQuarterYearPicker: !1,
                    showWeekPicker: !1,
                    strictParsing: !1,
                    swapRange: !1,
                    timeIntervals: 30,
                    timeCaption: "Time",
                    previousMonthAriaLabel: "Previous Month",
                    previousMonthButtonLabel: "Previous Month",
                    nextMonthAriaLabel: "Next Month",
                    nextMonthButtonLabel: "Next Month",
                    previousYearAriaLabel: "Previous Year",
                    previousYearButtonLabel: "Previous Year",
                    nextYearAriaLabel: "Next Year",
                    nextYearButtonLabel: "Next Year",
                    timeInputLabel: "Time",
                    enableTabLoop: !0,
                    yearItemNumber: Se,
                    focusSelectedMonth: !1,
                    showPopperArrow: !0,
                    excludeScrollbar: !0,
                    customTimeInput: null,
                    calendarStartDay: void 0,
                    toggleCalendarOnIconClick: !1,
                    usePointerEvent: !1
                };
            },
            enumerable: !1,
            configurable: !0
        }), n.prototype.componentDidMount = function() {
            window.addEventListener("scroll", this.onScroll, !0), document.addEventListener("visibilitychange", this.setHiddenStateOnVisibilityHidden);
        }, n.prototype.componentDidUpdate = function(e, t) {
            var r, n, a, o, s, i;
            e.inline && (s = e.selected, i = this.props.selected, s && i ? _.getMonth(s) !== _.getMonth(i) || x.getYear(s) !== x.getYear(i) : s !== i) && this.setPreSelection(this.props.selected), void 0 !== this.state.monthSelectedIn && e.monthsShown !== this.props.monthsShown && this.setState({
                monthSelectedIn: 0
            }), e.highlightDates !== this.props.highlightDates && this.setState({
                highlightDates: ft(this.props.highlightDates)
            }), t.focused || qe(e.selected, this.props.selected) || this.setState({
                inputValue: null
            }), t.open !== this.state.open && (!1 === t.open && !0 === this.state.open && (null === (n = (r = this.props).onCalendarOpen) || void 0 === n || n.call(r)), !0 === t.open && !1 === this.state.open && (null === (o = (a = this.props).onCalendarClose) || void 0 === o || o.call(a)));
        }, n.prototype.componentWillUnmount = function() {
            this.clearPreventFocusTimeout(), window.removeEventListener("scroll", this.onScroll, !0), document.removeEventListener("visibilitychange", this.setHiddenStateOnVisibilityHidden);
        }, n.prototype.renderInputContainer = function() {
            var e = this.props, r = e.showIcon, n = e.icon, a = e.calendarIconClassname, o = e.calendarIconClassName, s = e.toggleCalendarOnIconClick, i = this.state.open;
            return a && console.warn("calendarIconClassname props is deprecated. should use calendarIconClassName props."), ue.default.createElement("div", {
                className: "react-datepicker__input-container".concat(r ? " react-datepicker__view-calendar-icon" : "")
            }, r && ue.default.createElement(Vt, ve({
                icon: n,
                className: t.clsx(o, !o && a, i && "react-datepicker-ignore-onclickoutside")
            }, s ? {
                onClick: this.toggleCalendar
            } : null)), this.state.isRenderAriaLiveMessage && this.renderAriaLiveRegion(), this.renderDateInput(), this.renderClearButton());
        }, n.prototype.render = function() {
            var e = this.renderCalendar();
            if (this.props.inline) return e;
            if (this.props.withPortal) {
                var t = this.state.open ? ue.default.createElement($t, {
                    enableTabLoop: this.props.enableTabLoop
                }, ue.default.createElement("div", {
                    className: "react-datepicker__portal",
                    tabIndex: -1,
                    onKeyDown: this.onPortalKeyDown
                }, e)) : null;
                return this.state.open && this.props.portalId && (t = ue.default.createElement(jt, ve({
                    portalId: this.props.portalId
                }, this.props), t)), ue.default.createElement("div", null, this.renderInputContainer(), t);
            }
            return ue.default.createElement(Gt, ve({}, this.props, {
                className: this.props.popperClassName,
                hidePopper: !this.isCalendarOpen(),
                targetComponent: this.renderInputContainer(),
                popperComponent: e,
                popperOnKeyDown: this.onPopperKeyDown,
                showArrow: this.props.showPopperArrow
            }));
        }, n;
    }(r.Component), tr = "input", rr = "navigate";
    e.CalendarContainer = ye, e.default = er, e.getDefaultLocale = Be, e.registerLocale = function(e, t) {
        var r = we();
        r.__localeData__ || (r.__localeData__ = {}), r.__localeData__[e] = t;
    }, e.setDefaultLocale = function(e) {
        we().__localeId__ = e;
    }, Object.defineProperty(e, "__esModule", {
        value: !0
    });
});




const $e82f3882e0b8866e$var$CustomHeader = ({ date: date, changeYear: changeYear, changeMonth: changeMonth, decreaseMonth: decreaseMonth, increaseMonth: increaseMonth, prevMonthButtonDisabled: prevMonthButtonDisabled, nextMonthButtonDisabled: nextMonthButtonDisabled })=>{
    const months = Array.from({
        length: 12
    }, (_, i)=>new Date(0, i).toLocaleString("default", {
            month: "long"
        }));
    return /*#__PURE__*/ (0, $7Tw3V.jsxs)("div", {
        className: "custom-header",
        children: [
            /*#__PURE__*/ (0, $7Tw3V.jsxs)("div", {
                className: "month-navigation",
                children: [
                    /*#__PURE__*/ (0, $7Tw3V.jsx)("button", {
                        onClick: decreaseMonth,
                        disabled: prevMonthButtonDisabled,
                        className: "month-nav-btn",
                        children: /*#__PURE__*/ (0, $7Tw3V.jsx)((0, $b20b57f6d9a55509$export$2e2bcd8739ae039), {
                            size: 16
                        })
                    }),
                    /*#__PURE__*/ (0, $7Tw3V.jsx)("select", {
                        value: date.getMonth(),
                        onChange: ({ target: { value: value } })=>changeMonth(parseInt(value)),
                        className: "month-select",
                        children: months.map((month, index)=>/*#__PURE__*/ (0, $7Tw3V.jsx)("option", {
                                value: index,
                                children: month
                            }, month))
                    }),
                    /*#__PURE__*/ (0, $7Tw3V.jsx)("button", {
                        onClick: increaseMonth,
                        disabled: nextMonthButtonDisabled,
                        className: "month-nav-btn",
                        children: /*#__PURE__*/ (0, $7Tw3V.jsx)((0, $27c7f318cede5560$export$2e2bcd8739ae039), {
                            size: 16
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7Tw3V.jsx)("select", {
                value: date.getFullYear(),
                onChange: ({ target: { value: value } })=>changeYear(parseInt(value)),
                className: "year-select",
                children: Array.from({
                    length: 10
                }, (_, i)=>date.getFullYear() - 5 + i).map((year)=>/*#__PURE__*/ (0, $7Tw3V.jsx)("option", {
                        value: year,
                        children: year
                    }, year))
            })
        ]
    });
};
const $e82f3882e0b8866e$var$CustomDatePicker = ({ selectedDate: selectedDate, setSelectedDate: setSelectedDate, setIsDatePickerOpen: setIsDatePickerOpen })=>{
    return /*#__PURE__*/ (0, $7Tw3V.jsx)("div", {
        className: "date-picker-popup",
        children: /*#__PURE__*/ (0, $7Tw3V.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($58479eac843bef17$exports))), {
            selected: selectedDate,
            onChange: (date)=>{
                setSelectedDate(date);
                setIsDatePickerOpen(false);
            },
            inline: true,
            renderCustomHeader: $e82f3882e0b8866e$var$CustomHeader,
            showMonthYearPicker: false,
            showFullMonthYearPicker: false,
            showTwoColumnMonthYearPicker: false,
            showFourColumnMonthYearPicker: false,
            showDateMonthYear: true,
            onClickOutside: ()=>setIsDatePickerOpen(false)
        })
    });
};
var $e82f3882e0b8866e$export$2e2bcd8739ae039 = $e82f3882e0b8866e$var$CustomDatePicker;



const $2bb61c6ffa860387$var$LSQDateSelector = ({ selectedDate: selectedDate, setSelectedDate: setSelectedDate, onDateClick: onDateClick, ...props })=>{
    const [isDatePickerOpen, setIsDatePickerOpen] = (0, $cQQee.useState)(false);
    const datePickerRef = (0, $cQQee.useRef)(null);
    const nextDay = ()=>{
        setSelectedDate(new Date(selectedDate.setDate(selectedDate.getDate() + 1)));
    };
    const previousDay = ()=>{
        setSelectedDate(new Date(selectedDate.setDate(selectedDate.getDate() - 1)));
    };
    const handleDateClick = (value)=>{
        onDateClick && onDateClick();
        setIsDatePickerOpen(value);
    };
    return /*#__PURE__*/ (0, $7Tw3V.jsxs)("div", {
        className: "lsq-date-selector ng_p_2_b",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7Tw3V.jsx)((0, $b20b57f6d9a55509$export$2e2bcd8739ae039), {
                size: 16,
                onClick: previousDay,
                role: "chevron-left",
                className: "chevron-left"
            }),
            /*#__PURE__*/ (0, $7Tw3V.jsx)("span", {
                className: "date-display ng_p_1_sb",
                onClick: ()=>setIsDatePickerOpen(!isDatePickerOpen),
                ref: datePickerRef,
                children: selectedDate.toLocaleDateString("en-US", {
                    day: "numeric",
                    month: "long",
                    year: "numeric"
                })
            }),
            /*#__PURE__*/ (0, $7Tw3V.jsx)((0, $27c7f318cede5560$export$2e2bcd8739ae039), {
                size: 16,
                onClick: nextDay,
                role: "chevron-right",
                className: "chevron-right"
            }),
            isDatePickerOpen && /*#__PURE__*/ (0, $7Tw3V.jsx)((0, $e82f3882e0b8866e$export$2e2bcd8739ae039), {
                selectedDate: selectedDate,
                setSelectedDate: setSelectedDate,
                setIsDatePickerOpen: handleDateClick
            })
        ]
    });
};
var $2bb61c6ffa860387$export$2e2bcd8739ae039 = $2bb61c6ffa860387$var$LSQDateSelector;





const $da9248f3cd4351e3$export$18e9cce81e8335f8 = 90;
const $da9248f3cd4351e3$export$d4b87150515e8d33 = 2;
const $da9248f3cd4351e3$var$Calendar = ({ widget: widget = {}, activeDashboardId: activeDashboardId, forceRefresh: forceRefresh })=>{
    const { config: config } = widget;
    const [selectedDate, setSelectedDate] = (0, $cQQee.useState)(new Date());
    const [tasks, setTasks] = (0, $cQQee.useState)({
        responseStatus: (0, $4b9f68b1938e412c$export$2a1f9a4a898c1733).requestPending
    });
    const [initialLoad, setInitialLoading] = (0, $cQQee.useState)(true);
    const [activeIndex, setActiveIndex] = (0, $cQQee.useState)(0);
    const events = tasks.response || [];
    const fetchData = (forceRefresh = false)=>(0, $104918bc44385884$export$ff8cf4de893780b6)(selectedDate, setTasks, activeDashboardId, widget, forceRefresh);
    (0, $cQQee.useEffect)(()=>{
        fetchData();
    }, [
        selectedDate
    ]);
    (0, $cQQee.useEffect)(()=>{
        if (initialLoad) setInitialLoading(false);
        else fetchData(true);
    }, [
        forceRefresh
    ]);
    let content;
    if (tasks.responseStatus === (0, $4b9f68b1938e412c$export$2a1f9a4a898c1733).requestPending) content = /*#__PURE__*/ (0, $7Tw3V.jsx)((0, $0e4b252bf2d52338$export$2e2bcd8739ae039), {
        width: "100%",
        height: "100%"
    });
    else if (tasks.responseStatus === (0, $4b9f68b1938e412c$export$2a1f9a4a898c1733).requestRejected) content = /*#__PURE__*/ (0, $7Tw3V.jsxs)((0, $31a33a21d5a6cb6e$export$2e2bcd8739ae039), {
        className: "calendar-retry",
        role: "calendar-retry",
        children: [
            /*#__PURE__*/ (0, $7Tw3V.jsx)((0, $2f0a72dbc6470dcd$export$2e2bcd8739ae039), {
                src: "assets/icons/error_state.svg",
                alt: "icon",
                isWidgetIcon: false
            }),
            /*#__PURE__*/ (0, $7Tw3V.jsxs)("div", {
                className: "content",
                children: [
                    /*#__PURE__*/ (0, $7Tw3V.jsx)("label", {
                        className: "ng_sh_r",
                        children: (0, $4b9f68b1938e412c$export$20139851dc7757d2).somethingWentWrong
                    }),
                    /*#__PURE__*/ (0, $7Tw3V.jsx)("button", {
                        className: "ng_sh_r",
                        onClick: fetchData,
                        children: (0, $4b9f68b1938e412c$export$20139851dc7757d2).retry
                    })
                ]
            })
        ]
    });
    else if (tasks.responseStatus === (0, $4b9f68b1938e412c$export$2a1f9a4a898c1733).requestFullfilled && events.length === 0) content = /*#__PURE__*/ (0, $7Tw3V.jsxs)((0, $31a33a21d5a6cb6e$export$2e2bcd8739ae039), {
        className: "calender-empty",
        role: "calendar-empty",
        children: [
            /*#__PURE__*/ (0, $7Tw3V.jsx)((0, $2f0a72dbc6470dcd$export$2e2bcd8739ae039), {
                src: "assets/icons/empty_state.svg",
                alt: "icon",
                isWidgetIcon: false
            }),
            /*#__PURE__*/ (0, $7Tw3V.jsx)("label", {
                className: "ng_sh_r",
                children: (0, $4b9f68b1938e412c$export$20139851dc7757d2).noTasksScheduled
            })
        ]
    });
    const tabMenuOptions = {
        options: [
            {
                label: "Timeline",
                value: 0
            },
            {
                label: "Agenda",
                value: 1
            }
        ],
        activeIndex: activeIndex,
        onTabChange: (e)=>{
            if (e.value.value === activeIndex) return;
            setActiveIndex(e.value.value);
            const analyticsData = {
                category: "widget_click",
                type: "click"
            };
            (0, $0efbd8a8be009329$export$2e2bcd8739ae039).sendEvent(`calendarview tab changed to ${e?.value?.label}`, analyticsData);
        }
    };
    const onDateClick = ()=>{
        const analyticsData = {
            category: "widget_click",
            type: "click"
        };
        (0, $0efbd8a8be009329$export$2e2bcd8739ae039).sendEvent("calendarview datepicker opened", analyticsData);
    };
    return /*#__PURE__*/ (0, $7Tw3V.jsxs)("div", {
        className: "calendar-main",
        children: [
            /*#__PURE__*/ (0, $7Tw3V.jsxs)("div", {
                className: "calendar-header overflow-ellipsis ng_sh_r",
                children: [
                    /*#__PURE__*/ (0, $7Tw3V.jsx)((0, $2f0a72dbc6470dcd$export$2e2bcd8739ae039), {
                        src: `images/${config?.icon?.imgName || "lsq_copy"}.svg`,
                        alt: "icon",
                        isWidgetIcon: false
                    }),
                    /*#__PURE__*/ (0, $7Tw3V.jsx)("label", {
                        className: "overflow-ellipsis ng_sh_sb",
                        title: config?.name,
                        children: config?.name || "Calendar"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7Tw3V.jsx)((0, $e6b31b84f595e6b6$export$2e2bcd8739ae039), {
                optionClassName: "small",
                ...tabMenuOptions
            }),
            /*#__PURE__*/ (0, $7Tw3V.jsx)((0, $2bb61c6ffa860387$export$2e2bcd8739ae039), {
                selectedDate: selectedDate,
                setSelectedDate: setSelectedDate,
                onDateClick: onDateClick
            }),
            content || (activeIndex === 0 ? /*#__PURE__*/ (0, $7Tw3V.jsx)((0, $b0b6539449af1892$export$2e2bcd8739ae039), {
                events: events,
                selectedDate: selectedDate
            }) : /*#__PURE__*/ (0, $7Tw3V.jsx)((0, $889e2c52f6e388ac$export$2e2bcd8739ae039), {
                events: events
            }))
        ]
    });
};
var $da9248f3cd4351e3$export$2e2bcd8739ae039 = $da9248f3cd4351e3$var$Calendar;



var $7Tw3V = parcelRequire("7Tw3V");

var $cQQee = parcelRequire("cQQee");


var $7Tw3V = parcelRequire("7Tw3V");

var $cQQee = parcelRequire("cQQee");
var $1a4743a7a752c221$exports = {};
$1a4743a7a752c221$exports = $parcel$resolve("5RoJZ");





const $23165463e1d74588$export$86404bb73642377b = 1;
const $23165463e1d74588$var$HardRefresh = ({ setForceRefresh: setForceRefresh, activeDashboardId: activeDashboardId, ...props })=>{
    const refreshCooldown = $23165463e1d74588$export$86404bb73642377b * 60000;
    const cacheTimeInMilliseconds = (0, $e679a7ba462dea27$export$7e6a07abfc29ad16) * 60000;
    const [isDisabled, setIsDisabled] = (0, $cQQee.useState)(false);
    const [lastRefreshedTime, setLastRefreshedTime] = (0, $cQQee.useState)(null);
    const [isRotating, setIsRotating] = (0, $cQQee.useState)(false);
    const [timeAgo, setTimeAgo] = (0, $cQQee.useState)("");
    const formatTimeAgo = (date)=>{
        const now = new Date();
        const lastUpdated = new Date(date);
        const diffInMs = now - lastUpdated;
        const diffInMinutes = Math.floor(diffInMs / 60000);
        const diffInHours = Math.floor(diffInMs / 3600000);
        const diffInDays = Math.floor(diffInMs / 86400000);
        if (diffInMinutes < 1) return "Just now";
        else if (diffInMinutes < 60) return `${diffInMinutes} min${diffInMinutes === 1 ? "" : "s"} ago`;
        else if (diffInHours < 24) return `${diffInHours} hour${diffInHours === 1 ? "" : "s"} ago`;
        else return `${diffInDays} day${diffInDays === 1 ? "" : "s"} ago`;
    };
    (0, $cQQee.useEffect)(()=>{
        const counterCache = JSON.parse(localStorage.getItem((0, $4b9f68b1938e412c$export$588c7fdda06fbb0a).countCacheName) || "{}");
        const dashboardCache = counterCache[activeDashboardId] || {};
        const lastRefreshed = dashboardCache[(0, $4b9f68b1938e412c$export$588c7fdda06fbb0a).lastForceRefreshedTime];
        if (lastRefreshed) {
            setLastRefreshedTime(lastRefreshed);
            const now = new Date().getTime();
            const timeSinceLastRefresh = now - new Date(lastRefreshed).getTime();
            if (timeSinceLastRefresh > cacheTimeInMilliseconds) {
                const newLastRefreshed = new Date().toISOString();
                dashboardCache[(0, $4b9f68b1938e412c$export$588c7fdda06fbb0a).lastForceRefreshedTime] = newLastRefreshed;
                counterCache[activeDashboardId] = dashboardCache;
                localStorage.setItem((0, $4b9f68b1938e412c$export$588c7fdda06fbb0a).countCacheName, JSON.stringify(counterCache));
                setLastRefreshedTime(newLastRefreshed);
            }
            if (timeSinceLastRefresh < refreshCooldown) {
                setIsDisabled(true);
                setTimeout(()=>{
                    setIsDisabled(false);
                }, refreshCooldown - timeSinceLastRefresh);
            }
        }
    }, [
        activeDashboardId
    ]);
    // Update time ago every minute
    (0, $cQQee.useEffect)(()=>{
        if (!lastRefreshedTime) return;
        const updateTimeAgo = ()=>{
            setTimeAgo(formatTimeAgo(lastRefreshedTime));
        };
        // Update immediately
        updateTimeAgo();
        // Update every minute
        const interval = setInterval(updateTimeAgo, 60000);
        return ()=>clearInterval(interval);
    }, [
        lastRefreshedTime
    ]);
    const handleRefreshClick = ()=>{
        const now = new Date().toISOString();
        const counterCache = JSON.parse(localStorage.getItem((0, $4b9f68b1938e412c$export$588c7fdda06fbb0a).countCacheName) || "{}");
        const dashboardCache = counterCache[activeDashboardId] || {};
        dashboardCache[(0, $4b9f68b1938e412c$export$588c7fdda06fbb0a).lastForceRefreshedTime] = now;
        counterCache[activeDashboardId] = dashboardCache;
        localStorage.setItem((0, $4b9f68b1938e412c$export$588c7fdda06fbb0a).countCacheName, JSON.stringify(counterCache));
        setForceRefresh((prev)=>prev + 1);
        setIsDisabled(true);
        setLastRefreshedTime(now);
        setIsRotating(true);
        setTimeout(()=>{
            setIsRotating(false);
        }, 1000);
        setTimeout(()=>{
            setIsDisabled(false);
        }, refreshCooldown);
    };
    return /*#__PURE__*/ (0, $7Tw3V.jsxs)("div", {
        className: "hard-refresh ng_p_2_r",
        children: [
            /*#__PURE__*/ (0, $7Tw3V.jsxs)("div", {
                className: "last-updated",
                children: [
                    /*#__PURE__*/ (0, $7Tw3V.jsx)("span", {
                        children: "Last Updated"
                    }),
                    /*#__PURE__*/ (0, $7Tw3V.jsx)("span", {
                        children: lastRefreshedTime ? timeAgo : "Not available"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7Tw3V.jsx)("button", {
                onClick: handleRefreshClick,
                disabled: isDisabled,
                ...props,
                children: /*#__PURE__*/ (0, $7Tw3V.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($1a4743a7a752c221$exports))),
                    alt: "Sync",
                    className: isRotating ? "sync-rotate" : ""
                })
            })
        ]
    });
};
var $23165463e1d74588$export$2e2bcd8739ae039 = $23165463e1d74588$var$HardRefresh;




const $52cfb5d51d98aed4$var$CoverPage = ({ coverPageData: coverPageData = {}, activeDashboard: activeDashboard, setForceRefresh: setForceRefresh })=>{
    const [signedUrl, setSignedUrl] = (0, $cQQee.useState)(null);
    const { selectedColor: selectedColor, customRadio: customRadio, image: image } = coverPageData || {};
    const getSignedUrl = async ()=>{
        if (image?.imageKey) {
            const response = await (0, $3a9d902ac0f87e31$export$73b84337c4da92bc)(image?.imageKey);
            setSignedUrl(response);
        }
    };
    (0, $cQQee.useEffect)(()=>{
        getSignedUrl();
    }, [
        coverPageData
    ]);
    const headerStyle = {
        background: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),${selectedColor || "rgb(var(--ng-neutral-70))"}`,
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), ${customRadio === "image" ? `url(${signedUrl})` : "none"}`
    };
    const userDetails = (0, $8a9518f7458123dc$export$714d3544202969b)() || {};
    const heading = (coverPageData?.heading || "").replace("@{User:FullName,}", userDetails?.FullName || "").replace("@{User:FirstName,}", userDetails?.FirstName || "").replace("@{User:LastName,}", userDetails?.LastName || "").replace("@{User:MiddleName,}", userDetails?.MiddleName || "");
    const description = (coverPageData?.description || "").replace("@{User:FullName,}", userDetails?.FullName || "").replace("@{User:FirstName,}", userDetails?.FirstName || "").replace("@{User:LastName,}", userDetails?.LastName || "").replace("@{User:MiddleName,}", userDetails?.MiddleName || "");
    return /*#__PURE__*/ (0, $7Tw3V.jsxs)("div", {
        className: "welcome-banner",
        style: headerStyle,
        children: [
            /*#__PURE__*/ (0, $7Tw3V.jsx)((0, $23165463e1d74588$export$2e2bcd8739ae039), {
                setForceRefresh: setForceRefresh,
                activeDashboardId: activeDashboard?.id
            }, activeDashboard?.id),
            /*#__PURE__*/ (0, $7Tw3V.jsxs)("div", {
                className: "welcome-container ",
                children: [
                    /*#__PURE__*/ (0, $7Tw3V.jsx)("div", {
                        className: "heading ng_d_4_m",
                        title: heading ?? "",
                        children: heading || `Welcome ${userDetails?.FirstName || ""}`
                    }),
                    /*#__PURE__*/ (0, $7Tw3V.jsx)("p", {
                        className: "description",
                        title: description ?? "",
                        children: description || "Gear up for today, check up on KPIs and required follow-ups"
                    })
                ]
            })
        ]
    });
};
var $52cfb5d51d98aed4$export$2e2bcd8739ae039 = $52cfb5d51d98aed4$var$CoverPage;



var $7Tw3V = parcelRequire("7Tw3V");

var $cQQee = parcelRequire("cQQee");



function $a79ae977edbdefd9$export$2e2bcd8739ae039({ configData: configData = {} }) {
    const { config: config = {} } = configData;
    const src = config?.navigateTo || "https://run.crm4b2c.com/a/HomeBuilder";
    const title = config?.name;
    const [zoomScale, setZoomScale] = (0, $cQQee.useState)("1.0");
    const [zoomPercentage, setZoomPercentage] = (0, $cQQee.useState)("100%");
    const handleZoomIn = ()=>{
        const newZoom = Math.min(Number(zoomScale) + 0.1, 1.5).toFixed(1);
        setZoomPercentage((100 / Number(newZoom)).toFixed(2) + "%");
        setZoomScale(newZoom);
        const analyticsData = {
            category: "widget_click",
            type: "click"
        };
        (0, $0efbd8a8be009329$export$2e2bcd8739ae039).sendEvent("webview widget zoomed in", analyticsData);
    };
    const handleZoomOut = ()=>{
        const newZoom = Math.max(Number(zoomScale) - 0.1, 0.5).toFixed(1);
        setZoomPercentage((100 / Number(newZoom)).toFixed(2) + "%");
        setZoomScale(newZoom);
        const analyticsData = {
            category: "widget_click",
            type: "click"
        };
        (0, $0efbd8a8be009329$export$2e2bcd8739ae039).sendEvent("webview widget zoomed out", analyticsData);
    };
    const openInNewWindow = ()=>{
        window.open(src, "_blank", "noopener,noreferrer");
        const analyticsData = {
            category: "widget_click",
            type: "click"
        };
        (0, $0efbd8a8be009329$export$2e2bcd8739ae039).sendEvent("webview widget goto button clicked", analyticsData);
    };
    return /*#__PURE__*/ (0, $7Tw3V.jsxs)("div", {
        className: `webview-widget widget-container ${title && "show-frame"}`,
        children: [
            /*#__PURE__*/ (0, $7Tw3V.jsx)("button", {
                onClick: openInNewWindow,
                className: "navigate-button",
                "aria-label": "Open in new window",
                children: /*#__PURE__*/ (0, $7Tw3V.jsx)((0, $2f0a72dbc6470dcd$export$2e2bcd8739ae039), {
                    src: `images/${"lsq_external_link_white"}.svg`,
                    alt: "icon",
                    className: "icon",
                    isWidgetIcon: false
                })
            }),
            /*#__PURE__*/ (0, $7Tw3V.jsxs)("div", {
                className: "zoom-controls",
                children: [
                    /*#__PURE__*/ (0, $7Tw3V.jsx)("div", {
                        onClick: handleZoomIn,
                        children: "+"
                    }),
                    /*#__PURE__*/ (0, $7Tw3V.jsx)("div", {
                        onClick: handleZoomOut,
                        children: "-"
                    })
                ]
            }),
            title && /*#__PURE__*/ (0, $7Tw3V.jsx)("div", {
                className: "title overflow-ellipsis ng_h_5_sb",
                children: /*#__PURE__*/ (0, $7Tw3V.jsx)("label", {
                    className: "overflow-ellipsis ng_sh_sb",
                    title: config?.name,
                    children: title
                })
            }),
            /*#__PURE__*/ (0, $7Tw3V.jsx)("div", {
                className: "frame",
                children: /*#__PURE__*/ (0, $7Tw3V.jsx)("iframe", {
                    target: "_parent",
                    src: src,
                    role: "web-view",
                    title: title,
                    style: {
                        width: zoomPercentage,
                        height: zoomPercentage,
                        transform: `scale(${zoomScale})`,
                        transformOrigin: '0% 0%'
                    }
                })
            })
        ]
    });
}





var $7Tw3V = parcelRequire("7Tw3V");
parcelRequire("cQQee");


var $7Tw3V = parcelRequire("7Tw3V");
parcelRequire("cQQee");




const $7ed69d85746da6e2$var$LaunchTile = ({ config: config })=>{
    const { displayName: displayName, icon: icon, width: width, height: height } = config;
    const isSingleLine = height === 36;
    const onLaunchTileClick = ()=>{
        (0, $b61f740b64a51955$export$aadfb17cbf18b44d)(config);
        const analyticsData = {
            category: "widget_click",
            type: "click"
        };
        (0, $0efbd8a8be009329$export$2e2bcd8739ae039).sendEvent(`iconlauncher tile clicked`, analyticsData);
    };
    return /*#__PURE__*/ (0, $7Tw3V.jsxs)("div", {
        className: `launch-tile overflow-ellipsis ${isSingleLine ? "inline" : "multi-line"}`,
        draggable: "false",
        onClick: onLaunchTileClick,
        style: {
            width: width,
            height: height
        },
        children: [
            /*#__PURE__*/ (0, $7Tw3V.jsx)("div", {
                className: "icon-wrapper",
                children: /*#__PURE__*/ (0, $7Tw3V.jsx)((0, $2f0a72dbc6470dcd$export$2e2bcd8739ae039), {
                    src: `images/${icon.imgName}.svg`,
                    alt: displayName,
                    className: "icon icon-launcher",
                    draggable: "false",
                    title: displayName
                })
            }),
            /*#__PURE__*/ (0, $7Tw3V.jsx)("span", {
                className: "label ng_p_2_m overflow-ellipsis",
                title: displayName,
                children: displayName
            })
        ]
    });
};
var $7ed69d85746da6e2$export$2e2bcd8739ae039 = $7ed69d85746da6e2$var$LaunchTile;


const $9acd6d719df0bfe3$var$IconLauncher = ({ widget: widget })=>{
    return /*#__PURE__*/ (0, $7Tw3V.jsxs)("div", {
        className: "icon-launcher-main",
        children: [
            /*#__PURE__*/ (0, $7Tw3V.jsx)("label", {
                className: "overflow-ellipsis ng_sh_sb",
                title: widget?.config?.name,
                children: widget?.config?.name
            }),
            /*#__PURE__*/ (0, $7Tw3V.jsx)("div", {
                children: widget.config.launcherItems.map((config)=>/*#__PURE__*/ (0, $7Tw3V.jsx)((0, $7ed69d85746da6e2$export$2e2bcd8739ae039), {
                        config: config
                    }, config?.id))
            })
        ]
    });
};
var $9acd6d719df0bfe3$export$2e2bcd8739ae039 = $9acd6d719df0bfe3$var$IconLauncher;





var $7Tw3V = parcelRequire("7Tw3V");
parcelRequire("cQQee");

const $188b082ecb187d39$var$CustomTab = ({ dashboards: dashboards = [], activeDashboard: activeDashboard, setActiveDashboard: setActiveDashboard })=>{
    const dashboardCount = dashboards?.length;
    if (dashboardCount > 1) return /*#__PURE__*/ (0, $7Tw3V.jsx)("div", {
        className: "custom-tab-container",
        children: dashboards.map((dashboard)=>/*#__PURE__*/ (0, $7Tw3V.jsx)("div", {
                title: dashboard.name,
                className: `custom-tab ng_p_1_r overflow-ellipsis ${activeDashboard?.id === dashboard.id ? "active" : ""}`,
                onClick: ()=>setActiveDashboard(dashboard),
                children: dashboard.name
            }, dashboard.id))
    });
};
var $188b082ecb187d39$export$2e2bcd8739ae039 = $188b082ecb187d39$var$CustomTab;




var $7Tw3V = parcelRequire("7Tw3V");
parcelRequire("cQQee");
const $04e9d2baab448367$var$SieraDashboard = ({ activeDashboard: activeDashboard })=>{
    if (!activeDashboard?.layout?.url) return null;
    return /*#__PURE__*/ (0, $7Tw3V.jsx)("div", {
        style: {
            width: "100%",
            height: "100vh",
            paddingTop: "71px"
        },
        children: /*#__PURE__*/ (0, $7Tw3V.jsx)("iframe", {
            src: activeDashboard.layout.url,
            title: "Siera Dashboard",
            style: {
                width: "100%",
                height: "100%",
                border: "none"
            }
        })
    });
};
var $04e9d2baab448367$export$2e2bcd8739ae039 = $04e9d2baab448367$var$SieraDashboard;


var $24062c7528aa6915$exports = {};
$24062c7528aa6915$exports = $parcel$resolve("iTHaD");


const $b25983443cec65f4$var$ResponsiveGridLayout = (0, $1b9f63ff6bd81065$exports.WidthProvider)((0, $1b9f63ff6bd81065$exports.Responsive));
const $b25983443cec65f4$var$Dashboard = ({ layoutJSON: layoutJSON = [], coverPageData: coverPageData = {}, dashboards: dashboards, activeDashboard: activeDashboard = {}, setActiveDashboard: setActiveDashboard, smartviewsConfig: smartviewsConfig })=>{
    const [forceRefresh, setForceRefresh] = (0, $cQQee.useState)(1);
    const isRestrictedWidget = (config)=>config?.entity?.id === "smartviews" && !smartviewsConfig?.tabs?.find((tab)=>tab?.id === config?.smartViewTab?.id);
    let flag = 20;
    const onDashboardChange = (data)=>{
        setActiveDashboard(data);
        const analyticsData = {
            category: "tab_change",
            type: "click"
        };
        (0, $0efbd8a8be009329$export$2e2bcd8739ae039).sendEvent("Dashboard tab changed", analyticsData);
    };
    return /*#__PURE__*/ (0, $7Tw3V.jsxs)("div", {
        className: "dashboard-container",
        style: {
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0, $7Tw3V.jsx)("div", {
                className: "custom-navbar",
                children: /*#__PURE__*/ (0, $7Tw3V.jsx)((0, $188b082ecb187d39$export$2e2bcd8739ae039), {
                    dashboards: dashboards,
                    activeDashboard: activeDashboard,
                    setActiveDashboard: onDashboardChange
                })
            }),
            activeDashboard?.type === "SIERA" ? /*#__PURE__*/ (0, $7Tw3V.jsx)((0, $04e9d2baab448367$export$2e2bcd8739ae039), {
                activeDashboard: activeDashboard
            }) : /*#__PURE__*/ (0, $7Tw3V.jsxs)((0, $7Tw3V.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7Tw3V.jsxs)("div", {
                        className: "smallSreenSizeWarning ng_p_1_r",
                        children: [
                            /*#__PURE__*/ (0, $7Tw3V.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($24062c7528aa6915$exports))),
                                alt: "info-icon",
                                className: "infoIcon"
                            }),
                            /*#__PURE__*/ (0, $7Tw3V.jsx)("span", {
                                children: "Please zoom out for a better Casa experience. Homepage is optimized for laptop or desktop."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7Tw3V.jsx)((0, $52cfb5d51d98aed4$export$2e2bcd8739ae039), {
                        coverPageData: coverPageData,
                        activeDashboard: activeDashboard,
                        setForceRefresh: setForceRefresh
                    }),
                    /*#__PURE__*/ (0, $7Tw3V.jsx)("div", {
                        className: "container main",
                        children: /*#__PURE__*/ (0, $7Tw3V.jsx)($b25983443cec65f4$var$ResponsiveGridLayout, {
                            className: "layout",
                            layouts: {
                                lg: layoutJSON
                            },
                            breakpoints: {
                                lg: 956,
                                xxs: 320
                            },
                            cols: {
                                lg: 16,
                                xxs: 4
                            },
                            rowHeight: 20,
                            margin: [
                                15,
                                20
                            ],
                            containerPadding: [
                                5,
                                10
                            ],
                            isDraggable: false,
                            isResizable: false,
                            children: layoutJSON?.map((widget)=>{
                                if (widget.widgetType === (0, $4b9f68b1938e412c$export$45f3f39dac49db7f).IconLauncher) return /*#__PURE__*/ (0, $7Tw3V.jsx)("div", {
                                    "data-grid": widget,
                                    style: {
                                        padding: "0px",
                                        zIndex: 1
                                    },
                                    children: /*#__PURE__*/ (0, $7Tw3V.jsx)((0, $9acd6d719df0bfe3$export$2e2bcd8739ae039), {
                                        widget: widget
                                    })
                                }, widget.id);
                                if (widget?.widgetType === "calendarview") return /*#__PURE__*/ (0, $7Tw3V.jsx)("div", {
                                    "data-grid": widget,
                                    style: {
                                        padding: "0px",
                                        zIndex: flag--
                                    },
                                    children: /*#__PURE__*/ (0, $7Tw3V.jsx)((0, $da9248f3cd4351e3$export$2e2bcd8739ae039), {
                                        widget: widget,
                                        activeDashboardId: activeDashboard?.id,
                                        forceRefresh: forceRefresh
                                    })
                                }, widget.id);
                                if (widget?.widgetType === "banner") return /*#__PURE__*/ (0, $7Tw3V.jsx)("div", {
                                    "data-grid": widget,
                                    style: {
                                        padding: "0px"
                                    },
                                    children: /*#__PURE__*/ (0, $7Tw3V.jsx)((0, $10caf7b1ba15e44b$export$2e2bcd8739ae039), {
                                        widget: widget,
                                        smartviewsConfig: smartviewsConfig,
                                        activeDashboardId: activeDashboard?.id
                                    })
                                }, widget.id);
                                if (widget?.widgetType === "webview") return /*#__PURE__*/ (0, $7Tw3V.jsx)("div", {
                                    "data-grid": widget,
                                    style: {
                                        padding: "0px",
                                        zIndex: 1
                                    },
                                    children: /*#__PURE__*/ (0, $7Tw3V.jsx)((0, $a79ae977edbdefd9$export$2e2bcd8739ae039), {
                                        configData: widget
                                    })
                                }, widget.id);
                                return /*#__PURE__*/ (0, $7Tw3V.jsx)("div", {
                                    "data-grid": widget,
                                    style: {
                                        padding: "0px"
                                    },
                                    children: !isRestrictedWidget(widget.config) && /*#__PURE__*/ (0, $7Tw3V.jsx)((0, $7d5511bc1c73cbfa$export$2e2bcd8739ae039), {
                                        widget: widget,
                                        smartviewsConfig: smartviewsConfig,
                                        activeDashboardId: activeDashboard?.id,
                                        forceRefresh: forceRefresh
                                    })
                                }, widget.id);
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var $b25983443cec65f4$export$2e2bcd8739ae039 = $b25983443cec65f4$var$Dashboard;



var $cQQee = parcelRequire("cQQee");


const $9bcc7ca479fa6d04$export$43cb2457c239645c = async ()=>{
    return await (0, $d439188c8c506a1b$export$2e2bcd8739ae039).get("/dashboards/user").catch((err)=>err.response);
};
const $9bcc7ca479fa6d04$export$9e84d6d86ddd587f = async ()=>{
    return await (0, $d439188c8c506a1b$export$2e2bcd8739ae039).get("/smartviews/configuration").catch((err)=>err.response);
};





const $958a5648d2d0bc08$export$1b2474068ca80b61 = async (setDashboards, setActiveDashboard, processAndStoreData)=>{
    setDashboards({
        responseStatus: (0, $4b9f68b1938e412c$export$2a1f9a4a898c1733).requestPending
    });
    try {
        const response = await (0, $9bcc7ca479fa6d04$export$43cb2457c239645c)();
        if (response.status === 200) {
            const userData = response.data;
            if (userData) {
                (0, $e679a7ba462dea27$export$430426a47cc1c8dd)(userData);
                setDashboards({
                    response: userData,
                    responseStatus: (0, $4b9f68b1938e412c$export$2a1f9a4a898c1733).requestFullfilled
                });
                setActiveDashboard(userData[0]);
                processAndStoreData(userData);
            }
        } else {
            setDashboards({
                responseStatus: (0, $4b9f68b1938e412c$export$2a1f9a4a898c1733).requestRejected
            });
            console.error(`Request failed with status: ${response.status}`);
        }
    } catch (error) {
        console.error("Error fetching user data:", error);
        setDashboards({
            responseStatus: (0, $4b9f68b1938e412c$export$2a1f9a4a898c1733).requestRejected
        });
    }
};
const $958a5648d2d0bc08$export$a567c1d842899804 = async (setSmartviewsConfig)=>{
    setSmartviewsConfig({
        responseStatus: (0, $4b9f68b1938e412c$export$2a1f9a4a898c1733).requestPending
    });
    try {
        const response = await (0, $9bcc7ca479fa6d04$export$9e84d6d86ddd587f)();
        if (response.status === 200) {
            const smartviewdata = response.data;
            if (smartviewdata) setSmartviewsConfig({
                response: smartviewdata,
                responseStatus: (0, $4b9f68b1938e412c$export$2a1f9a4a898c1733).requestFullfilled
            });
        } else {
            setSmartviewsConfig({
                responseStatus: (0, $4b9f68b1938e412c$export$2a1f9a4a898c1733).requestRejected
            });
            console.error(`Request failed with status: ${response.status}`);
        }
    } catch (error) {
        console.error("Error fetching smartviews configuration:", error);
        setSmartviewsConfig({
            responseStatus: (0, $4b9f68b1938e412c$export$2a1f9a4a898c1733).requestRejected
        });
    }
};
const $958a5648d2d0bc08$export$2a47f398eeff8b01 = async (setSmartviewsConfig, setDashboards, setActiveDashboard, processAndStoreData, setCssLoad)=>{
    $958a5648d2d0bc08$export$8b850913fd7982ab(setCssLoad);
    await Promise.all([
        $958a5648d2d0bc08$export$a567c1d842899804(setSmartviewsConfig),
        $958a5648d2d0bc08$export$1b2474068ca80b61(setDashboards, setActiveDashboard, processAndStoreData)
    ]);
};
const $958a5648d2d0bc08$export$e4b5f5a0775d1913 = (dashboards)=>{
    const result = {};
    dashboards.forEach((dashboard)=>{
        const dashboardId = dashboard.id;
        const dashboardName = dashboard.name;
        dashboard?.layout?.widgets?.forEach((widget)=>{
            const widgetId = widget.id;
            const widgetName = widget?.config?.name;
            const widgetConfig = widget.config;
            const status = widgetConfig?.taskStatus ? {
                value: widgetConfig?.taskStatus?.id,
                label: widgetConfig?.taskStatus?.name
            } : null;
            const TaskType = widgetConfig?.taskTypes;
            const DueDate = widgetConfig?.dateFilters ? {
                value: widgetConfig.dateFilters.id,
                label: widgetConfig.dateFilters.name
            } : null;
            const widgetFilters = {
                dashboardId: dashboardId,
                dashboardName: dashboardName,
                widgetId: widgetId,
                widgetName: widgetName,
                filters: {
                    DueDate: DueDate,
                    status: status,
                    TaskType: TaskType
                }
            };
            if (Object.keys(widgetFilters.filters).length > 0) result[widgetId] = widgetFilters;
        });
    });
    localStorage.setItem("casa-web-filters", JSON.stringify(result));
};
const $958a5648d2d0bc08$export$8b850913fd7982ab = (setCssLoad)=>{
    setCssLoad({
        responseStatus: (0, $4b9f68b1938e412c$export$2a1f9a4a898c1733).requestPending
    });
    // The new (Vite) build loads its own hashed CSS via the casadashboardentry
    // loader, which sets __CASA_BUNDLED_CSS__ — so skip injecting the legacy
    // fixed-name entry.css there. The legacy build leaves the flag unset and
    // injects entry.css exactly as before.
    if (typeof window !== "undefined" && window.__CASA_BUNDLED_CSS__) {
        setCssLoad({
            responseStatus: (0, $4b9f68b1938e412c$export$2a1f9a4a898c1733).requestFullfilled
        });
        return;
    }
    try {
        const link2 = document.createElement("link");
        link2.href = `${0, $8a8f1a678e6f48e2$export$3d9f1402b79f9a49}/entry.css`;
        link2.rel = "stylesheet";
        document.head.appendChild(link2);
        setCssLoad({
            responseStatus: (0, $4b9f68b1938e412c$export$2a1f9a4a898c1733).requestFullfilled
        });
    } catch (error) {
        setCssLoad({
            responseStatus: (0, $4b9f68b1938e412c$export$2a1f9a4a898c1733).requestRejected
        });
    }
};
const $958a5648d2d0bc08$var$useInitializeDashboard = ()=>{
    const [layout, setLayout] = (0, $cQQee.useState)([]);
    const [dashboards, setDashboards] = (0, $cQQee.useState)({
        responseStatus: (0, $4b9f68b1938e412c$export$2a1f9a4a898c1733).requestPending
    });
    const [activeDashboard, setActiveDashboard] = (0, $cQQee.useState)(null);
    const [cssLoad, setCssLoad] = (0, $cQQee.useState)({
        responseStatus: (0, $4b9f68b1938e412c$export$2a1f9a4a898c1733).requestPending
    });
    const [smartviewsConfig, setSmartviewsConfig] = (0, $cQQee.useState)({
        responseStatus: (0, $4b9f68b1938e412c$export$2a1f9a4a898c1733).requestPending
    });
    (0, $cQQee.useEffect)(()=>{
        (0, $8a9518f7458123dc$export$f88ba925622e17f1)();
        $958a5648d2d0bc08$export$2a47f398eeff8b01(setSmartviewsConfig, setDashboards, setActiveDashboard, $958a5648d2d0bc08$export$e4b5f5a0775d1913, setCssLoad);
    }, []);
    (0, $cQQee.useEffect)(()=>{
        const fetchDashboardWidgets = async ()=>{
            if (activeDashboard?.layout?.widgets?.length > 0) {
                const widgetLayout = activeDashboard.layout.widgets;
                setLayout([
                    ...widgetLayout
                ]);
            } else setLayout([]); // Reset layout if no widgets are present
        };
        if (activeDashboard) fetchDashboardWidgets();
        else setLayout([]); // Reset layout if no active dashboard is selected
    }, [
        activeDashboard
    ]);
    return {
        layout: layout,
        dashboards: dashboards,
        activeDashboard: activeDashboard,
        cssLoad: cssLoad,
        setActiveDashboard: setActiveDashboard,
        smartviewsConfig: smartviewsConfig,
        initialize: ()=>$958a5648d2d0bc08$export$2a47f398eeff8b01(setSmartviewsConfig, setDashboards, setActiveDashboard, $958a5648d2d0bc08$export$e4b5f5a0775d1913, setCssLoad)
    };
};
var $958a5648d2d0bc08$export$2e2bcd8739ae039 = $958a5648d2d0bc08$var$useInitializeDashboard;



var $7Tw3V = parcelRequire("7Tw3V");
parcelRequire("cQQee");

const $5baaa1ae41951b99$var$CustomLoader = (props)=>{
    return /*#__PURE__*/ (0, $7Tw3V.jsxs)("div", {
        style: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            gap: "20px"
        },
        ...props,
        children: [
            /*#__PURE__*/ (0, $7Tw3V.jsx)((0, $2f0a72dbc6470dcd$export$2e2bcd8739ae039), {
                src: `assets/icons/lsq_casa_logo.svg`,
                alt: "icon"
            }),
            /*#__PURE__*/ (0, $7Tw3V.jsx)("div", {
                style: {
                    width: "20%",
                    height: "4px",
                    backgroundColor: "rgb(var(--ng-neutral-10))",
                    overflow: "hidden",
                    position: "relative"
                },
                children: /*#__PURE__*/ (0, $7Tw3V.jsx)("div", {
                    style: {
                        width: "30%",
                        height: "100%",
                        backgroundColor: "rgb(var(--ng-primary-40))",
                        position: "absolute",
                        left: "-30%",
                        animation: "smooth-loading 2s cubic-bezier(0.4, 0.0, 0.2, 1) infinite"
                    }
                })
            }),
            /*#__PURE__*/ (0, $7Tw3V.jsx)("style", {
                children: `
          @keyframes smooth-loading {
            0% {
              left: -30%;
            }
            50% {
              left: 100%; 
            }
            100% {
              left: 100%; 
            }
          }
        `
            })
        ]
    });
};
var $5baaa1ae41951b99$export$2e2bcd8739ae039 = $5baaa1ae41951b99$var$CustomLoader;



var $7Tw3V = parcelRequire("7Tw3V");

var $cQQee = parcelRequire("cQQee");




const $7b928ddcfbbbd704$export$2e2bcd8739ae039 = (props)=>{
    const { className: className } = props;
    return (0, $81ee76508714b94a$export$35e795649ee09318).jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 12 13",
        className: className,
        children: [
            (0, $81ee76508714b94a$export$35e795649ee09318).jsx("circle", {
                cx: "4",
                cy: "6.5",
                r: "1",
                fill: "#B9C5D4"
            }),
            (0, $81ee76508714b94a$export$35e795649ee09318).jsx("ellipse", {
                cx: "4",
                cy: "2.5",
                rx: "1",
                ry: "1",
                fill: "#B9C5D4"
            }),
            (0, $81ee76508714b94a$export$35e795649ee09318).jsx("ellipse", {
                cx: "4",
                cy: "10.5",
                rx: "1",
                ry: "1",
                fill: "#B9C5D4"
            }),
            (0, $81ee76508714b94a$export$35e795649ee09318).jsx("ellipse", {
                cx: "8",
                cy: "6.5",
                rx: "1",
                ry: "1",
                fill: "#B9C5D4"
            }),
            (0, $81ee76508714b94a$export$35e795649ee09318).jsx("ellipse", {
                cx: "8",
                cy: "2.5",
                rx: "1",
                ry: "1",
                fill: "#B9C5D4"
            }),
            (0, $81ee76508714b94a$export$35e795649ee09318).jsx("ellipse", {
                cx: "8",
                cy: "10.5",
                rx: "1",
                ry: "1",
                fill: "#B9C5D4"
            })
        ]
    });
};
$7b928ddcfbbbd704$export$2e2bcd8739ae039.defaultProps = {
    className: ''
};




const $624b17e4901a3bbe$export$2e2bcd8739ae039 = (props)=>{
    const { className: className, type: type } = props;
    if (type === 'outline') return (0, $81ee76508714b94a$export$35e795649ee09318).jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        viewBox: "0 0 24 25",
        fill: "none",
        children: [
            (0, $81ee76508714b94a$export$35e795649ee09318).jsx("circle", {
                cx: "12",
                cy: "7.15381",
                r: "1.5"
            }),
            (0, $81ee76508714b94a$export$35e795649ee09318).jsx("circle", {
                cx: "12",
                cy: "12.1538",
                r: "1.5"
            }),
            (0, $81ee76508714b94a$export$35e795649ee09318).jsx("circle", {
                cx: "12",
                cy: "17.1538",
                r: "1.5"
            })
        ]
    });
};
$624b17e4901a3bbe$export$2e2bcd8739ae039.defaultProps = {
    className: ''
};



const $9b21246be0527aa9$export$2e2bcd8739ae039 = (props)=>{
    const { className: className } = props;
    return (0, $81ee76508714b94a$export$35e795649ee09318).jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 12 13",
        className: className,
        children: [
            (0, $81ee76508714b94a$export$35e795649ee09318).jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.5303 0.96967C11.8232 1.26256 11.8232 1.73744 11.5303 2.03033L1.53033 12.0303C1.23744 12.3232 0.762563 12.3232 0.46967 12.0303C0.176777 11.7374 0.176777 11.2626 0.46967 10.9697L10.4697 0.96967C10.7626 0.676777 11.2374 0.676777 11.5303 0.96967Z"
            }),
            (0, $81ee76508714b94a$export$35e795649ee09318).jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.5303 12.0303C11.2374 12.3232 10.7626 12.3232 10.4697 12.0303L0.469669 2.03033C0.176776 1.73744 0.176776 1.26256 0.469669 0.969669C0.762563 0.676776 1.23744 0.676776 1.53033 0.969669L11.5303 10.9697C11.8232 11.2626 11.8232 11.7374 11.5303 12.0303Z"
            })
        ]
    });
};
$9b21246be0527aa9$export$2e2bcd8739ae039.defaultProps = {
    className: ''
};



var $ff2225322a61af74$var$css_248z = ".IoqD8I5AGZ4-{align-items:center;background:rgb(var(--ng-neutral-black));border-radius:var(--ng-rd-8);color:rgb(var(--ng-neutral-0));display:inline-flex;gap:var(--ng-gp-4);padding:var(--ng-gp-6) var(--ng-gp-8)}.TQfavxnKlrU-{left:0;position:fixed;top:0;z-index:1000}.BEIoXAkbbHQ-{align-items:center;cursor:grab;display:inline-flex;justify-content:center;padding:var(--ng-gp-6)}.BEIoXAkbbHQ- svg{height:var(--ng-s-16);width:var(--ng-s-16)}.BEIoXAkbbHQ- svg circle,.BEIoXAkbbHQ- svg ellipse{fill:rgb(var(--ng-neutral-60))}.BEIoXAkbbHQ-:active{cursor:grabbing}.ilkf84bEl9k-{color:rgb(var(--ng-neutral-50));font-size:var(--ng-lb-1-fs);font-weight:500;padding:var(--ng-gp-4) var(--ng-gp-8);white-space:nowrap}.-pWJ5OA7omk-{background-color:rgb(var(--ng-neutral-70))}.Noyn8h-JkG8-{align-items:center;display:flex;gap:var(--ng-gp-8)}.wCiqTpc18eQ-{justify-content:flex-start;width:100%}.GD28hVeq4UY-,.GD28hVeq4UY-:focus{background:transparent;border-color:transparent;font-weight:500}.IoqD8I5AGZ4- .GD28hVeq4UY-:active,.Pd5kFi621w0- .GD28hVeq4UY-:active{background:rgb(var(--ng-neutral-dark-black));border-color:rgb(var(--ng-neutral-dark-black));font-weight:500}.GD28hVeq4UY-:hover{background:rgb(var(--ng-neutral-light-black));border-color:rgb(var(--ng-neutral-light-black));font-weight:500}.GD28hVeq4UY-:disabled{background:transparent;border-color:transparent;color:rgb(var(--ng-neutral-60))}.it7bcdPPq1I-{fill:rgb(var(--ng-neutral-0))}.hbcz27ObMUo-{padding:var(--ng-gp-4)}.Pd5kFi621w0-{background:rgba(var(--ng-neutral-black))!important;border:1px solid rgba(var(--ng-neutral-70))!important;gap:var(--ng-gp-4);padding:var(--ng-gp-8)}";
var $ff2225322a61af74$export$2e2bcd8739ae039 = {
    "floating_action_bar_main": "IoqD8I5AGZ4-",
    "floating_action_bar_draggable": "TQfavxnKlrU-",
    "floating_action_bar_drag_icon": "BEIoXAkbbHQ-",
    "floating_action_bar_selected": "ilkf84bEl9k-",
    "floating_action_bar_separator": "-pWJ5OA7omk-",
    "floating_action_bar_actions": "Noyn8h-JkG8-",
    "floating_action_bar_action_menu_button": "wCiqTpc18eQ-",
    "floating_action_bar_button": "GD28hVeq4UY-",
    "floating_action_bar_dropdown_content": "Pd5kFi621w0-",
    "floating_action_bar_icon": "it7bcdPPq1I-",
    "floating_action_bar_close_button": "hbcz27ObMUo-"
};
(0, $4df8c7bf7afa5170$export$2e2bcd8739ae039)($ff2225322a61af74$var$css_248z);






const $4d550b91b2e6e4fb$export$2e2bcd8739ae039 = (props)=>{
    const { className: className } = props;
    return (0, $81ee76508714b94a$export$35e795649ee09318).jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        className: className,
        children: (0, $81ee76508714b94a$export$35e795649ee09318).jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11.2197 17.2803C10.9268 16.9874 10.9268 16.5126 11.2197 16.2197L14.9393 12.5H6.75C6.33579 12.5 6 12.1642 6 11.75C6 11.3358 6.33579 11 6.75 11H14.9393L11.2197 7.28033C10.9268 6.98744 10.9268 6.51256 11.2197 6.21967C11.5126 5.92678 11.9874 5.92678 12.2803 6.21967L17.2803 11.2197C17.5732 11.5126 17.5732 11.9874 17.2803 12.2803L12.2803 17.2803C11.9874 17.5732 11.5126 17.5732 11.2197 17.2803Z",
            fill: "#27313F"
        })
    });
};




var $9e9e0236e89c5749$var$css_248z = ".E4pZvNBfctg-{align-self:stretch;max-height:304px;overflow-y:auto}.HdIRqNhOkFM-{width:166px}.MW4-V1XFkKU-{flex:1}._1xbe07wQciw-{width:100%}._1xbe07wQciw-:focus-visible{outline:none}.SOqX-ic0CWg-{width:100%}";
var $9e9e0236e89c5749$export$2e2bcd8739ae039 = {
    "scrollable_content": "E4pZvNBfctg-",
    "content": "HdIRqNhOkFM-",
    "subtrigger_label": "MW4-V1XFkKU-",
    "sub_trigger": "_1xbe07wQciw-",
    "tooltip_wrapper": "SOqX-ic0CWg-"
};
(0, $4df8c7bf7afa5170$export$2e2bcd8739ae039)($9e9e0236e89c5749$var$css_248z);




var $fbbc04c44bde1e3c$var$css_248z = "@keyframes _1w4Hw-L-Z0Q-{0%{background-position:-468px 0}to{background-position:468px 0}}.oIohJYt36kA-{animation-duration:1s;animation-fill-mode:forwards;animation-iteration-count:infinite;animation-name:_1w4Hw-L-Z0Q-;animation-timing-function:linear;background:rgb(var(--ng-neutral-20));background-image:linear-gradient(to right,rgb(var(--ng-neutral-20)) 0,rgb(var(--ng-neutral-30)) 20%,rgb(var(--ng-neutral-20)) 40%,rgb(var(--ng-neutral-20)) 100%);background-repeat:no-repeat;background-size:800px 104px;border-radius:var(--ng-rd-4);display:inline-block;position:relative}";
var $fbbc04c44bde1e3c$export$2e2bcd8739ae039 = {
    "shimmer_container": "oIohJYt36kA-"
};
(0, $4df8c7bf7afa5170$export$2e2bcd8739ae039)($fbbc04c44bde1e3c$var$css_248z);


const $7a8e5d019e367bdd$export$2e2bcd8739ae039 = ({ width: width, height: height, style: style, className: className })=>{
    return (0, $81ee76508714b94a$export$35e795649ee09318).jsx("div", {
        "data-testid": 'shimmer',
        className: `${(0, $fbbc04c44bde1e3c$export$2e2bcd8739ae039).shimmer_container} ${className}`,
        style: {
            height: height,
            width: width,
            ...style
        },
        "aria-hidden": "true"
    });
};
$7a8e5d019e367bdd$export$2e2bcd8739ae039.defaultProps = {
    height: '',
    width: '',
    style: {},
    className: ''
};





var $cQQee = parcelRequire("cQQee");

var $cbc94436dc8362d9$var$css_248z = "._3gdiIET7-rU-{display:inline-block;position:relative}.PpjT6NoXmFo-{--vertical-tooltip-arrow-position-left:\"50%\";border-radius:2px;font-size:13px;line-height:18px;opacity:0;padding:0;position:absolute;text-align:start;transition:opacity .3s;visibility:hidden;width:-moz-max-content;width:max-content;z-index:var(--marvin-tooltip-z-index)}.PpjT6NoXmFo- .dERfai4jjBc-{max-height:0;max-width:300px;overflow:hidden auto;white-space:normal;word-break:break-all}.r9Qjs1Pd4tI-.PpjT6NoXmFo-{height:-moz-fit-content;height:fit-content;opacity:1;padding:4px 8px;visibility:visible}.r9Qjs1Pd4tI-.PpjT6NoXmFo- .dERfai4jjBc-{max-height:200px}.r9Qjs1Pd4tI-.PpjT6NoXmFo-:after{border-style:solid;content:\"\";position:absolute}.cWtrqnWmXuI-:after{border-width:7px;left:var(--vertical-tooltip-arrow-position-left);margin-inline-start:-7px;top:100%}.hzlu8Kd6n5A-:after{border-width:6px;right:100%;top:45%}._99Zuhe5zFGk-:after{border-width:7px;bottom:100%;left:var(--vertical-tooltip-arrow-position-left);margin-inline-start:-7px}.YBMcYymtRs4-:after{border-width:6px;left:100%;top:45%}.PpjT6NoXmFo-.O5AxMmZ0utQ-{background-color:rgb(var(--marvin-base));box-shadow:0 2px 6px rgba(var(--marvin-primary-text),.2);color:rgb(var(--marvin-secondary-text))}.PpjT6NoXmFo-.O5AxMmZ0utQ-.YBMcYymtRs4-:after{border-color:transparent transparent transparent rgb(var(--marvin-base))}.PpjT6NoXmFo-.O5AxMmZ0utQ-.cWtrqnWmXuI-:after{border-color:rgb(var(--marvin-base)) transparent transparent transparent}.PpjT6NoXmFo-.O5AxMmZ0utQ-._99Zuhe5zFGk-:after{border-color:transparent transparent rgb(var(--marvin-base)) transparent}.PpjT6NoXmFo-.O5AxMmZ0utQ-.hzlu8Kd6n5A-:after{border-color:transparent rgb(var(--marvin-base)) transparent transparent}.PpjT6NoXmFo-.CFBqn-mnxLA-{background-color:rgb(var(--marvin-primary-text));color:rgb(var(--marvin-background-1))}.PpjT6NoXmFo-.CFBqn-mnxLA-.YBMcYymtRs4-:after{border-color:transparent transparent transparent rgb(var(--marvin-primary-text))}.PpjT6NoXmFo-.CFBqn-mnxLA-.cWtrqnWmXuI-:after{border-color:rgb(var(--marvin-primary-text)) transparent transparent transparent}.PpjT6NoXmFo-.CFBqn-mnxLA-._99Zuhe5zFGk-:after{border-color:transparent transparent rgb(var(--marvin-primary-text)) transparent}.PpjT6NoXmFo-.CFBqn-mnxLA-.hzlu8Kd6n5A-:after{border-color:transparent rgb(var(--marvin-primary-text)) transparent transparent}";
var $cbc94436dc8362d9$export$2e2bcd8739ae039 = {
    "tooltip": "_3gdiIET7-rU-",
    "tooltip_text": "PpjT6NoXmFo-",
    "content": "dERfai4jjBc-",
    "visible": "r9Qjs1Pd4tI-",
    "tooltip_top": "cWtrqnWmXuI-",
    "tooltip_right": "hzlu8Kd6n5A-",
    "tooltip_bottom": "_99Zuhe5zFGk-",
    "tooltip_left": "YBMcYymtRs4-",
    "tooltip_light": "O5AxMmZ0utQ-",
    "tooltip_dark": "CFBqn-mnxLA-"
};
(0, $4df8c7bf7afa5170$export$2e2bcd8739ae039)($cbc94436dc8362d9$var$css_248z);


var $ff745e434208042c$export$af2bcbdc04a2d456;
(function(Placement) {
    Placement["Vertical"] = "vertical";
    Placement["Horizontal"] = "horizontal";
})($ff745e434208042c$export$af2bcbdc04a2d456 || ($ff745e434208042c$export$af2bcbdc04a2d456 = {}));
var $ff745e434208042c$export$41fb9f06171c75f4;
(function(Trigger) {
    Trigger["Hover"] = "hover";
    Trigger["Click"] = "click";
    Trigger["Default"] = "default";
})($ff745e434208042c$export$41fb9f06171c75f4 || ($ff745e434208042c$export$41fb9f06171c75f4 = {}));


const $3bacccd4a62fa6dd$export$cbb15408671cd066 = 15;
const $3bacccd4a62fa6dd$export$fe3b15a865b5b018 = (mouseRef, tooltipRef)=>{
    const rect = tooltipRef.getBoundingClientRect();
    const { clientX: clientX, clientY: clientY } = mouseRef;
    return clientX >= rect.left && clientX <= rect.right && clientY >= rect.top && clientY <= rect.bottom;
};
const $3bacccd4a62fa6dd$export$6b30263f9f864720 = (ref)=>{
    const { bottom: bottom, right: right } = ref.getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    const viewportWidth = window.innerWidth;
    const spaceBelow = viewportHeight - bottom;
    const spaceRight = viewportWidth - right;
    return {
        spaceBelow: spaceBelow,
        spaceRight: spaceRight
    };
};
const $3bacccd4a62fa6dd$var$getScrollPos = ()=>(document.documentElement || document.body.parentNode || document.body).scrollTop;
const $3bacccd4a62fa6dd$var$getLeftPosition = ({ left: left, rect: rect, tooltipRect: tooltipRect, tooltipRef: tooltipRef })=>{
    const tooltipRectRight = tooltipRect.width + left;
    if (tooltipRectRight <= window.innerWidth) {
        //Default Arrow position should be in center
        tooltipRef?.style.setProperty('--vertical-tooltip-arrow-position-left', `50%`);
        return left;
    }
    const updatedLeft = left - (tooltipRectRight - window.innerWidth) - 25;
    const updatedTooltipRectRight = tooltipRect.width + updatedLeft;
    //Arrow should be in center of visible part of rect
    //Position of icon from the toolTipLeft
    const arrowIconPosition = (updatedTooltipRectRight - rect.left) / 2 + rect.left - updatedLeft;
    if (arrowIconPosition > 0) tooltipRef?.style.setProperty('--vertical-tooltip-arrow-position-left', `${arrowIconPosition}px`);
    return updatedLeft;
};
const $3bacccd4a62fa6dd$export$931b35c41e37e48f = ({ ref: ref, tooltipRef: tooltipRef, placement: placement })=>{
    const rect = ref?.getBoundingClientRect();
    const tooltipRect = tooltipRef?.getBoundingClientRect();
    if (rect && tooltipRect) {
        const scrollPosition = $3bacccd4a62fa6dd$var$getScrollPos();
        if (placement === (0, $ff745e434208042c$export$af2bcbdc04a2d456).Vertical) {
            const left = (rect.left + rect.right) / 2 - tooltipRect.width / 2;
            let top = rect.bottom + scrollPosition + $3bacccd4a62fa6dd$export$cbb15408671cd066;
            if (window.innerHeight - rect.bottom < tooltipRect.height + $3bacccd4a62fa6dd$export$cbb15408671cd066) top = rect.top + scrollPosition - tooltipRect.height - $3bacccd4a62fa6dd$export$cbb15408671cd066;
            return {
                left: $3bacccd4a62fa6dd$var$getLeftPosition({
                    left: left,
                    rect: rect,
                    tooltipRect: tooltipRect,
                    tooltipRef: tooltipRef
                }),
                top: top
            };
        } else {
            const top = rect.top + scrollPosition - tooltipRect.height / 2;
            let left = rect.right + $3bacccd4a62fa6dd$export$cbb15408671cd066;
            if (window.innerWidth - rect.right < tooltipRect.width + $3bacccd4a62fa6dd$export$cbb15408671cd066) left = rect.left - tooltipRect.width - $3bacccd4a62fa6dd$export$cbb15408671cd066;
            return {
                left: left,
                top: top
            };
        }
    }
    return {};
};






var $kC364 = parcelRequire("kC364");
const $a1556bc82d720cc4$export$2e2bcd8739ae039 = (props)=>{
    const { children: children, content: content, placement: placement, customStyle: customStyle, theme: theme, trigger: trigger, wrapperClass: wrapperClass } = props;
    const [show, setShow] = (0, $cQQee.useState)(trigger?.includes((0, $ff745e434208042c$export$41fb9f06171c75f4).Default));
    const [showContent, setShowContent] = (0, $cQQee.useState)(trigger?.includes((0, $ff745e434208042c$export$41fb9f06171c75f4).Default));
    const [toolTipStyle, setToolTipStyle] = (0, $cQQee.useState)({});
    const ref = (0, $cQQee.useRef)(null);
    const mouseRef = (0, $cQQee.useRef)();
    const tooltipRef = (0, $cQQee.useRef)(null);
    const placementRef = (0, $cQQee.useRef)(placement === (0, $ff745e434208042c$export$af2bcbdc04a2d456).Vertical ? 'bottom' : 'right');
    const handleOutsideClick = ()=>{
        if (trigger?.includes((0, $ff745e434208042c$export$41fb9f06171c75f4).Click) && mouseRef?.current && tooltipRef?.current && ref?.current) {
            const isMouseinside = (0, $3bacccd4a62fa6dd$export$fe3b15a865b5b018)(mouseRef.current, ref.current) || (0, $3bacccd4a62fa6dd$export$fe3b15a865b5b018)(mouseRef.current, tooltipRef.current);
            if (!isMouseinside) setToolTipStyle({});
            setShow(isMouseinside);
        }
    };
    const onMouseLeave = async ()=>{
        if (trigger?.includes((0, $ff745e434208042c$export$41fb9f06171c75f4).Hover)) {
            await (0, $e99e5f020fa3ffc8$export$e772c8ff12451969)(150);
            if (tooltipRef?.current && mouseRef.current && ref.current) {
                const isMouseinside = (0, $3bacccd4a62fa6dd$export$fe3b15a865b5b018)(mouseRef.current, ref.current) || (0, $3bacccd4a62fa6dd$export$fe3b15a865b5b018)(mouseRef.current, tooltipRef.current);
                if (!isMouseinside) setToolTipStyle({});
                setShow(isMouseinside);
            }
        }
    };
    const onMouseMove = (event)=>{
        mouseRef.current = event;
        onMouseLeave();
    };
    const setPlacement = (elementRef, popupRef)=>{
        const { spaceBelow: spaceBelow, spaceRight: spaceRight } = (0, $3bacccd4a62fa6dd$export$6b30263f9f864720)(elementRef);
        const { height: height, width: width } = popupRef.getBoundingClientRect();
        if (placement === (0, $ff745e434208042c$export$af2bcbdc04a2d456).Vertical && spaceBelow < height + (0, $3bacccd4a62fa6dd$export$cbb15408671cd066)) placementRef.current = 'top';
        else if (placement === (0, $ff745e434208042c$export$af2bcbdc04a2d456).Horizontal && spaceRight < width + (0, $3bacccd4a62fa6dd$export$cbb15408671cd066)) placementRef.current = 'left';
    };
    const handleTooltipShow = ()=>{
        if (ref?.current && tooltipRef?.current) {
            document.addEventListener('mousemove', onMouseMove);
            setPlacement(ref?.current, tooltipRef?.current);
            setShow(true);
            if (!Object.keys(toolTipStyle).length) setToolTipStyle((0, $3bacccd4a62fa6dd$export$931b35c41e37e48f)({
                ref: ref.current,
                tooltipRef: tooltipRef.current,
                placement: placement
            }));
            if (!showContent) setShowContent(true);
        }
    };
    const onMouseEnter = ()=>{
        if (trigger?.includes((0, $ff745e434208042c$export$41fb9f06171c75f4).Hover)) handleTooltipShow();
    };
    const handleTooltipClick = ()=>{
        if (trigger?.includes((0, $ff745e434208042c$export$41fb9f06171c75f4).Click)) {
            document.addEventListener('mousedown', handleOutsideClick);
            handleTooltipShow();
        }
    };
    (0, $cQQee.useEffect)(()=>{
        if (!show) {
            document.removeEventListener('mousemove', onMouseMove);
            document.removeEventListener('mousedown', handleOutsideClick);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        show
    ]);
    (0, $cQQee.useEffect)(()=>{
        if (showContent && ref?.current && tooltipRef?.current && !trigger?.includes((0, $ff745e434208042c$export$41fb9f06171c75f4).Default)) setToolTipStyle((0, $3bacccd4a62fa6dd$export$931b35c41e37e48f)({
            ref: ref.current,
            tooltipRef: tooltipRef.current,
            placement: placement
        }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        placement,
        showContent
    ]);
    const getTooltipClassName = ()=>{
        const toolTipClasses = [
            (0, $cbc94436dc8362d9$export$2e2bcd8739ae039).tooltip_text,
            (0, $cbc94436dc8362d9$export$2e2bcd8739ae039)[`tooltip_${placementRef.current}`]
        ];
        if (show) toolTipClasses.push((0, $cbc94436dc8362d9$export$2e2bcd8739ae039).visible);
        if (theme) toolTipClasses.push((0, $cbc94436dc8362d9$export$2e2bcd8739ae039)[`tooltip_${theme}`]);
        return toolTipClasses.join(' ');
    };
    return (0, $81ee76508714b94a$export$35e795649ee09318).jsxs((0, $81ee76508714b94a$export$35e795649ee09318).Fragment, {
        children: [
            (0, $81ee76508714b94a$export$35e795649ee09318).jsx("div", {
                "data-testid": "tooltip",
                ref: ref,
                className: `${(0, $cbc94436dc8362d9$export$2e2bcd8739ae039).tooltip} ${show ? (0, $cbc94436dc8362d9$export$2e2bcd8739ae039).tooltip_open : ''} ${wrapperClass} `,
                onClick: handleTooltipClick,
                onMouseOver: onMouseEnter,
                onMouseLeave: onMouseLeave,
                children: children
            }),
            content ? (0, $kC364.createPortal)((0, $81ee76508714b94a$export$35e795649ee09318).jsx("span", {
                ref: tooltipRef,
                onMouseLeave: onMouseLeave,
                style: {
                    ...customStyle,
                    ...toolTipStyle
                },
                className: getTooltipClassName(),
                children: (0, $81ee76508714b94a$export$35e795649ee09318).jsx("div", {
                    className: (0, $cbc94436dc8362d9$export$2e2bcd8739ae039).content,
                    children: showContent ? (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $81ee76508714b94a$export$35e795649ee09318).Fragment, {
                        children: content
                    }) : null
                })
            }), document.body) : null
        ]
    });
};
$a1556bc82d720cc4$export$2e2bcd8739ae039.defaultProps = {
    customStyle: {},
    theme: (0, $f1c8443d9545a1c1$export$14faa19a0f3bbeb2).Light
};






var $1c1202547ad4e7ff$var$css_248z = "._73gGK9-NeW8-{display:flex;hyphens:auto;max-width:150px;overflow-wrap:break-word;word-break:normal}";
var $1c1202547ad4e7ff$export$2e2bcd8739ae039 = {
    "tooltip_container": "_73gGK9-NeW8-"
};
(0, $4df8c7bf7afa5170$export$2e2bcd8739ae039)($1c1202547ad4e7ff$var$css_248z);


const $3613d1cea7649fa2$export$ff2a3541fad93e8b = ({ text: text, customStyleClass: customStyleClass = '' })=>{
    const styleClasses = [
        'ng_v2_style',
        'ng_p_1_r',
        (0, $1c1202547ad4e7ff$export$2e2bcd8739ae039).tooltip_container,
        customStyleClass
    ]?.filter((className)=>typeof className === 'string')?.join(' ');
    return (0, $81ee76508714b94a$export$35e795649ee09318).jsx("div", {
        className: styleClasses,
        children: text
    });
};


const $b9ee09ab7817bcfb$export$2e2bcd8739ae039 = ({ children: children, toolTipContent: toolTipContent, tooltipTheme: tooltipTheme = (0, $f1c8443d9545a1c1$export$14faa19a0f3bbeb2).Dark, tooltipWrapperClass: tooltipWrapperClass, skipFormatting: skipFormatting, hideTooltip: hideTooltip, placement: placement = (0, $ff745e434208042c$export$af2bcbdc04a2d456).Vertical })=>{
    if (hideTooltip || !toolTipContent) return children;
    return (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $a1556bc82d720cc4$export$2e2bcd8739ae039), {
        content: skipFormatting || typeof toolTipContent !== 'string' ? toolTipContent : (0, $3613d1cea7649fa2$export$ff2a3541fad93e8b)({
            text: toolTipContent
        }),
        placement: placement,
        theme: tooltipTheme,
        wrapperClass: `tooltip-wrapper ${tooltipWrapperClass}`,
        trigger: [
            (0, $ff745e434208042c$export$41fb9f06171c75f4).Hover
        ],
        children: children
    });
};
$b9ee09ab7817bcfb$export$2e2bcd8739ae039.defaultProps = {
    toolTipContent: undefined,
    tooltipTheme: (0, $f1c8443d9545a1c1$export$14faa19a0f3bbeb2).Dark,
    tooltipWrapperClass: undefined,
    skipFormatting: false,
    hideTooltip: false,
    placement: (0, $ff745e434208042c$export$af2bcbdc04a2d456).Vertical
};




const $233097035b829794$export$2e2bcd8739ae039 = ({ action: action, onSelection: onSelection })=>{
    const handleSelection = ()=>{
        if (action.disabled || action.isLoading) return;
        onSelection(action);
    };
    const getTitleContent = ()=>{
        if (action?.useCustomTooltip) return action.label;
        return action.toolTip ?? action.label;
    };
    return (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $81ee76508714b94a$export$35e795649ee09318).Fragment, {
        children: action.subMenu?.length ? (0, $81ee76508714b94a$export$35e795649ee09318).jsxs((0, $4c36f96585c995c5$export$52f1a7a531420fda), {
            children: [
                (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $4c36f96585c995c5$export$ecce04aae80c5d4c), {
                    className: (0, $9e9e0236e89c5749$export$2e2bcd8739ae039).sub_trigger,
                    onClick: action.parentClickable ? (e)=>{
                        e.preventDefault();
                        e.stopPropagation();
                        onSelection(action);
                    } : undefined,
                    children: action?.customComponent ? action?.customComponent : (0, $81ee76508714b94a$export$35e795649ee09318).jsxs((0, $4c36f96585c995c5$export$8b9f0d993a06de28), {
                        children: [
                            (0, $81ee76508714b94a$export$35e795649ee09318).jsx("div", {
                                className: (0, $9e9e0236e89c5749$export$2e2bcd8739ae039).subtrigger_label,
                                children: action.label
                            }),
                            (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $dbb74cb604a2ffe4$export$2e2bcd8739ae039), {
                                variant: "tertiary-gray",
                                size: "xs",
                                onClick: ()=>{},
                                icon: (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $4d550b91b2e6e4fb$export$2e2bcd8739ae039), {})
                            })
                        ]
                    })
                }),
                (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $4c36f96585c995c5$export$c9857b4e7233160f), {
                    className: (0, $9e9e0236e89c5749$export$2e2bcd8739ae039).scrollable_content,
                    children: action.subMenu?.map((subAction)=>(0, $81ee76508714b94a$export$35e795649ee09318).jsx($233097035b829794$export$2e2bcd8739ae039, {
                            action: subAction,
                            onSelection: onSelection
                        }, subAction.value))
                })
            ]
        }) : action?.customComponent ?? (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $b9ee09ab7817bcfb$export$2e2bcd8739ae039), {
            toolTipContent: action.toolTip,
            hideTooltip: !action?.useCustomTooltip,
            tooltipWrapperClass: (0, $9e9e0236e89c5749$export$2e2bcd8739ae039).tooltip_wrapper,
            placement: (0, $ff745e434208042c$export$af2bcbdc04a2d456).Horizontal,
            children: (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $4c36f96585c995c5$export$6648d5fa18559e7f), {
                disabled: action.disabled || action.isLoading,
                onClick: handleSelection,
                title: getTitleContent(),
                children: action.isLoading ? (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $7a8e5d019e367bdd$export$2e2bcd8739ae039), {
                    width: "100%",
                    height: "24px"
                }) : action.label
            })
        })
    });
};




var $cQQee = parcelRequire("cQQee");


const $e5b14801b702957a$export$2e2bcd8739ae039 = (onOpenChange, openDelay)=>{
    const debouncedOpenChange = (0, $e99e5f020fa3ffc8$export$61fc7d43ac8f84b0)(onOpenChange, openDelay ?? 150);
    const onMouseEnter = ()=>{
        debouncedOpenChange(true);
    };
    const onMouseLeave = ()=>{
        debouncedOpenChange(false);
    };
    return {
        triggerProps: {
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave
        },
        contentProps: {
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave
        }
    };
};


const $6caf1b679fa7e67d$export$2e2bcd8739ae039 = (props)=>{
    const { actions: actions, onSelection: onSelection, open: open, onOpenChange: onOpenChange, children: children, modal: modal = false, trigger: trigger = 'hover', portalTarget: portalTarget, customContentClass: customContentClass, triggerAriaLabel: triggerAriaLabel } = props;
    const triggerRef = (0, $cQQee.useRef)(null);
    const { triggerProps: triggerProps, contentProps: contentProps } = (0, $e5b14801b702957a$export$2e2bcd8739ae039)(onOpenChange);
    return (0, $81ee76508714b94a$export$35e795649ee09318).jsxs((0, $4c36f96585c995c5$export$a07767dbf4087719), {
        onOpenChange: onOpenChange,
        modal: modal,
        open: open,
        children: [
            (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $4c36f96585c995c5$export$e7eb525bc415b4b4), {
                ref: triggerRef,
                "aria-label": triggerAriaLabel,
                ...trigger === 'hover' ? triggerProps : {},
                children: children
            }),
            (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $4c36f96585c995c5$export$6fde95e347518364), {
                container: portalTarget,
                children: (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $4c36f96585c995c5$export$59308621e1a05692), {
                    className: (0, $e99e5f020fa3ffc8$export$1343a74baacb0543)('ng_scrollbar', (0, $9e9e0236e89c5749$export$2e2bcd8739ae039).content, (0, $9e9e0236e89c5749$export$2e2bcd8739ae039).scrollable_content, customContentClass || ''),
                    ...trigger === 'hover' ? contentProps : {},
                    children: actions?.map((action)=>(0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $233097035b829794$export$2e2bcd8739ae039), {
                            action: action,
                            onSelection: onSelection
                        }, action.value))
                })
            })
        ]
    });
};
$6caf1b679fa7e67d$export$2e2bcd8739ae039.defaultProps = {
    modal: false,
    children: null,
    trigger: 'hover',
    portalTarget: undefined,
    customContentClass: '',
    triggerAriaLabel: undefined
};



var $cQQee = parcelRequire("cQQee");


var $cQQee = parcelRequire("cQQee");
function $19c294935800915e$export$22b09f878622677a(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}


var $9103dfd4f01d9755$export$5edeffb658f039f4 = {
    exports: {}
};


var $a28b8a79029591f5$export$5edeffb658f039f4 = {
    exports: {}
};


var $302d67038e0e46fb$export$362abb7de8d8bb41 = {};


/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1a13e1721f2a9a13$var$hasRequiredReactIs_production_min;
function $1a13e1721f2a9a13$export$b88c30a9414655a0() {
    if ($1a13e1721f2a9a13$var$hasRequiredReactIs_production_min) return 0, $302d67038e0e46fb$export$362abb7de8d8bb41;
    $1a13e1721f2a9a13$var$hasRequiredReactIs_production_min = 1;
    var b = "function" === typeof Symbol && Symbol.for, c = b ? Symbol.for("react.element") : 60103, d = b ? Symbol.for("react.portal") : 60106, e = b ? Symbol.for("react.fragment") : 60107, f = b ? Symbol.for("react.strict_mode") : 60108, g = b ? Symbol.for("react.profiler") : 60114, h = b ? Symbol.for("react.provider") : 60109, k = b ? Symbol.for("react.context") : 60110, l = b ? Symbol.for("react.async_mode") : 60111, m = b ? Symbol.for("react.concurrent_mode") : 60111, n = b ? Symbol.for("react.forward_ref") : 60112, p = b ? Symbol.for("react.suspense") : 60113, q = b ? Symbol.for("react.suspense_list") : 60120, r = b ? Symbol.for("react.memo") : 60115, t = b ? Symbol.for("react.lazy") : 60116, v = b ? Symbol.for("react.block") : 60121, w = b ? Symbol.for("react.fundamental") : 60117, x = b ? Symbol.for("react.responder") : 60118, y = b ? Symbol.for("react.scope") : 60119;
    function z(a) {
        if ("object" === typeof a && null !== a) {
            var u = a.$$typeof;
            switch(u){
                case c:
                    switch(a = a.type, a){
                        case l:
                        case m:
                        case e:
                        case g:
                        case f:
                        case p:
                            return a;
                        default:
                            switch(a = a && a.$$typeof, a){
                                case k:
                                case n:
                                case t:
                                case r:
                                case h:
                                    return a;
                                default:
                                    return u;
                            }
                    }
                case d:
                    return u;
            }
        }
    }
    function A(a) {
        return z(a) === m;
    }
    (0, $302d67038e0e46fb$export$362abb7de8d8bb41).AsyncMode = l;
    (0, $302d67038e0e46fb$export$362abb7de8d8bb41).ConcurrentMode = m;
    (0, $302d67038e0e46fb$export$362abb7de8d8bb41).ContextConsumer = k;
    (0, $302d67038e0e46fb$export$362abb7de8d8bb41).ContextProvider = h;
    (0, $302d67038e0e46fb$export$362abb7de8d8bb41).Element = c;
    (0, $302d67038e0e46fb$export$362abb7de8d8bb41).ForwardRef = n;
    (0, $302d67038e0e46fb$export$362abb7de8d8bb41).Fragment = e;
    (0, $302d67038e0e46fb$export$362abb7de8d8bb41).Lazy = t;
    (0, $302d67038e0e46fb$export$362abb7de8d8bb41).Memo = r;
    (0, $302d67038e0e46fb$export$362abb7de8d8bb41).Portal = d;
    (0, $302d67038e0e46fb$export$362abb7de8d8bb41).Profiler = g;
    (0, $302d67038e0e46fb$export$362abb7de8d8bb41).StrictMode = f;
    (0, $302d67038e0e46fb$export$362abb7de8d8bb41).Suspense = p;
    (0, $302d67038e0e46fb$export$362abb7de8d8bb41).isAsyncMode = function(a) {
        return A(a) || z(a) === l;
    };
    (0, $302d67038e0e46fb$export$362abb7de8d8bb41).isConcurrentMode = A;
    (0, $302d67038e0e46fb$export$362abb7de8d8bb41).isContextConsumer = function(a) {
        return z(a) === k;
    };
    (0, $302d67038e0e46fb$export$362abb7de8d8bb41).isContextProvider = function(a) {
        return z(a) === h;
    };
    (0, $302d67038e0e46fb$export$362abb7de8d8bb41).isElement = function(a) {
        return "object" === typeof a && null !== a && a.$$typeof === c;
    };
    (0, $302d67038e0e46fb$export$362abb7de8d8bb41).isForwardRef = function(a) {
        return z(a) === n;
    };
    (0, $302d67038e0e46fb$export$362abb7de8d8bb41).isFragment = function(a) {
        return z(a) === e;
    };
    (0, $302d67038e0e46fb$export$362abb7de8d8bb41).isLazy = function(a) {
        return z(a) === t;
    };
    (0, $302d67038e0e46fb$export$362abb7de8d8bb41).isMemo = function(a) {
        return z(a) === r;
    };
    (0, $302d67038e0e46fb$export$362abb7de8d8bb41).isPortal = function(a) {
        return z(a) === d;
    };
    (0, $302d67038e0e46fb$export$362abb7de8d8bb41).isProfiler = function(a) {
        return z(a) === g;
    };
    (0, $302d67038e0e46fb$export$362abb7de8d8bb41).isStrictMode = function(a) {
        return z(a) === f;
    };
    (0, $302d67038e0e46fb$export$362abb7de8d8bb41).isSuspense = function(a) {
        return z(a) === p;
    };
    (0, $302d67038e0e46fb$export$362abb7de8d8bb41).isValidElementType = function(a) {
        return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
    };
    (0, $302d67038e0e46fb$export$362abb7de8d8bb41).typeOf = z;
    return 0, $302d67038e0e46fb$export$362abb7de8d8bb41;
}


var $c1a0ed9661bab26f$export$362abb7de8d8bb41 = {};


/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $badb5a5c78e44999$var$hasRequiredReactIs_development;
function $badb5a5c78e44999$export$b88c30a9414655a0() {
    if ($badb5a5c78e44999$var$hasRequiredReactIs_development) return 0, $c1a0ed9661bab26f$export$362abb7de8d8bb41;
    $badb5a5c78e44999$var$hasRequiredReactIs_development = 1;
    return 0, $c1a0ed9661bab26f$export$362abb7de8d8bb41;
}


var $b7270c8e46ad4a32$var$hasRequiredReactIs;
function $b7270c8e46ad4a32$export$b88c30a9414655a0() {
    if ($b7270c8e46ad4a32$var$hasRequiredReactIs) return (0, $a28b8a79029591f5$export$5edeffb658f039f4).exports;
    $b7270c8e46ad4a32$var$hasRequiredReactIs = 1;
    (0, $a28b8a79029591f5$export$5edeffb658f039f4).exports = (0, $1a13e1721f2a9a13$export$b88c30a9414655a0)();
    return (0, $a28b8a79029591f5$export$5edeffb658f039f4).exports;
}



/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ var $ca151ab10dab4751$var$objectAssign;
var $ca151ab10dab4751$var$hasRequiredObjectAssign;
function $ca151ab10dab4751$export$b88c30a9414655a0() {
    if ($ca151ab10dab4751$var$hasRequiredObjectAssign) return $ca151ab10dab4751$var$objectAssign;
    $ca151ab10dab4751$var$hasRequiredObjectAssign = 1;
    /* eslint-disable no-unused-vars */ var getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var propIsEnumerable = Object.prototype.propertyIsEnumerable;
    function toObject(val) {
        if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
        return Object(val);
    }
    function shouldUseNative() {
        try {
            if (!Object.assign) return false;
            // Detect buggy property enumeration order in older V8 versions.
            // https://bugs.chromium.org/p/v8/issues/detail?id=4118
            var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
            test1[5] = 'de';
            if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
            // https://bugs.chromium.org/p/v8/issues/detail?id=3056
            var test2 = {};
            for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
            var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
                return test2[n];
            });
            if (order2.join('') !== '0123456789') return false;
            // https://bugs.chromium.org/p/v8/issues/detail?id=3056
            var test3 = {};
            'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
                test3[letter] = letter;
            });
            if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
            return true;
        } catch (err) {
            // We don't expect any of the above to throw, but better to be safe.
            return false;
        }
    }
    $ca151ab10dab4751$var$objectAssign = shouldUseNative() ? Object.assign : function(target, source) {
        var from;
        var to = toObject(target);
        var symbols;
        for(var s = 1; s < arguments.length; s++){
            from = Object(arguments[s]);
            for(var key in from)if (hasOwnProperty.call(from, key)) to[key] = from[key];
            if (getOwnPropertySymbols) {
                symbols = getOwnPropertySymbols(from);
                for(var i = 0; i < symbols.length; i++)if (propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
            }
        }
        return to;
    };
    return $ca151ab10dab4751$var$objectAssign;
}


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $28c54605a22548b8$var$ReactPropTypesSecret_1;
var $28c54605a22548b8$var$hasRequiredReactPropTypesSecret;
function $28c54605a22548b8$export$b88c30a9414655a0() {
    if ($28c54605a22548b8$var$hasRequiredReactPropTypesSecret) return $28c54605a22548b8$var$ReactPropTypesSecret_1;
    $28c54605a22548b8$var$hasRequiredReactPropTypesSecret = 1;
    var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
    $28c54605a22548b8$var$ReactPropTypesSecret_1 = ReactPropTypesSecret;
    return $28c54605a22548b8$var$ReactPropTypesSecret_1;
}


var $b6e61df76ad8286a$var$has;
var $b6e61df76ad8286a$var$hasRequiredHas;
function $b6e61df76ad8286a$export$b88c30a9414655a0() {
    if ($b6e61df76ad8286a$var$hasRequiredHas) return $b6e61df76ad8286a$var$has;
    $b6e61df76ad8286a$var$hasRequiredHas = 1;
    $b6e61df76ad8286a$var$has = Function.call.bind(Object.prototype.hasOwnProperty);
    return $b6e61df76ad8286a$var$has;
}




/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $58909f33c28be1e6$var$checkPropTypes_1;
var $58909f33c28be1e6$var$hasRequiredCheckPropTypes;
function $58909f33c28be1e6$export$b88c30a9414655a0() {
    if ($58909f33c28be1e6$var$hasRequiredCheckPropTypes) return $58909f33c28be1e6$var$checkPropTypes_1;
    $58909f33c28be1e6$var$hasRequiredCheckPropTypes = 1;
    var printWarning = function() {};
    var ReactPropTypesSecret, loggedTypeFailures, has;
    /**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */ function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
        var typeSpecName, error, err, ex, stack;
    }
    /**
	 * Resets warning cache when testing.
	 *
	 * @private
	 */ checkPropTypes.resetWarningCache = function() {};
    $58909f33c28be1e6$var$checkPropTypes_1 = checkPropTypes;
    return $58909f33c28be1e6$var$checkPropTypes_1;
}


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0b609822001335d1$var$factoryWithTypeCheckers;
var $0b609822001335d1$var$hasRequiredFactoryWithTypeCheckers;
function $0b609822001335d1$export$b88c30a9414655a0() {
    if ($0b609822001335d1$var$hasRequiredFactoryWithTypeCheckers) return $0b609822001335d1$var$factoryWithTypeCheckers;
    $0b609822001335d1$var$hasRequiredFactoryWithTypeCheckers = 1;
    var ReactIs = (0, $b7270c8e46ad4a32$export$b88c30a9414655a0)();
    var assign = (0, $ca151ab10dab4751$export$b88c30a9414655a0)();
    var ReactPropTypesSecret = (0, $28c54605a22548b8$export$b88c30a9414655a0)();
    var has = (0, $b6e61df76ad8286a$export$b88c30a9414655a0)();
    var checkPropTypes = (0, $58909f33c28be1e6$export$b88c30a9414655a0)();
    var printWarning = function() {};
    function emptyFunctionThatReturnsNull() {
        return null;
    }
    $0b609822001335d1$var$factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
        /* global Symbol */ var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
        var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
        /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */ function getIteratorFn(maybeIterable) {
            var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
            if (typeof iteratorFn === 'function') return iteratorFn;
        }
        /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */ var ANONYMOUS = '<<anonymous>>';
        // Important!
        // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
        var ReactPropTypes = {
            array: createPrimitiveTypeChecker('array'),
            bigint: createPrimitiveTypeChecker('bigint'),
            bool: createPrimitiveTypeChecker('boolean'),
            func: createPrimitiveTypeChecker('function'),
            number: createPrimitiveTypeChecker('number'),
            object: createPrimitiveTypeChecker('object'),
            string: createPrimitiveTypeChecker('string'),
            symbol: createPrimitiveTypeChecker('symbol'),
            any: createAnyTypeChecker(),
            arrayOf: createArrayOfTypeChecker,
            element: createElementTypeChecker(),
            elementType: createElementTypeTypeChecker(),
            instanceOf: createInstanceTypeChecker,
            node: createNodeChecker(),
            objectOf: createObjectOfTypeChecker,
            oneOf: createEnumTypeChecker,
            oneOfType: createUnionTypeChecker,
            shape: createShapeTypeChecker,
            exact: createStrictShapeTypeChecker
        };
        /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */ /*eslint-disable no-self-compare*/ function is(x, y) {
            // SameValue algorithm
            if (x === y) // Steps 1-5, 7-10
            // Steps 6.b-6.e: +0 != -0
            return x !== 0 || 1 / x === 1 / y;
            else // Step 6.a: NaN == NaN
            return x !== x && y !== y;
        }
        /*eslint-enable no-self-compare*/ /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */ function PropTypeError(message, data) {
            this.message = message;
            this.data = data && typeof data === 'object' ? data : {};
            this.stack = '';
        }
        // Make `instanceof Error` still work for returned errors.
        PropTypeError.prototype = Error.prototype;
        function createChainableTypeChecker(validate) {
            var manualPropTypeCallCache, manualPropTypeWarningCount;
            function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
                componentName = componentName || ANONYMOUS;
                propFullName = propFullName || propName;
                if (secret !== ReactPropTypesSecret) {
                    if (throwOnDirectAccess) {
                        // New behavior only for users of `prop-types` package
                        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
                        err.name = 'Invariant Violation';
                        throw err;
                    } else var cacheKey;
                }
                if (props[propName] == null) {
                    if (isRequired) {
                        if (props[propName] === null) return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
                        return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
                    }
                    return null;
                } else return validate(props, propName, componentName, location, propFullName);
            }
            var chainedCheckType = checkType.bind(null, false);
            chainedCheckType.isRequired = checkType.bind(null, true);
            return chainedCheckType;
        }
        function createPrimitiveTypeChecker(expectedType) {
            function validate(props, propName, componentName, location, propFullName, secret) {
                var propValue = props[propName];
                var propType = getPropType(propValue);
                if (propType !== expectedType) {
                    // `propValue` being instance of, say, date/regexp, pass the 'object'
                    // check, but we can offer a more precise error message here rather than
                    // 'of type `object`'.
                    var preciseType = getPreciseType(propValue);
                    return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'), {
                        expectedType: expectedType
                    });
                }
                return null;
            }
            return createChainableTypeChecker(validate);
        }
        function createAnyTypeChecker() {
            return createChainableTypeChecker(emptyFunctionThatReturnsNull);
        }
        function createArrayOfTypeChecker(typeChecker) {
            function validate(props, propName, componentName, location, propFullName) {
                if (typeof typeChecker !== 'function') return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
                var propValue = props[propName];
                if (!Array.isArray(propValue)) {
                    var propType = getPropType(propValue);
                    return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
                }
                for(var i = 0; i < propValue.length; i++){
                    var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
                    if (error instanceof Error) return error;
                }
                return null;
            }
            return createChainableTypeChecker(validate);
        }
        function createElementTypeChecker() {
            function validate(props, propName, componentName, location, propFullName) {
                var propValue = props[propName];
                if (!isValidElement(propValue)) {
                    var propType = getPropType(propValue);
                    return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
                }
                return null;
            }
            return createChainableTypeChecker(validate);
        }
        function createElementTypeTypeChecker() {
            function validate(props, propName, componentName, location, propFullName) {
                var propValue = props[propName];
                if (!ReactIs.isValidElementType(propValue)) {
                    var propType = getPropType(propValue);
                    return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
                }
                return null;
            }
            return createChainableTypeChecker(validate);
        }
        function createInstanceTypeChecker(expectedClass) {
            function validate(props, propName, componentName, location, propFullName) {
                if (!(props[propName] instanceof expectedClass)) {
                    var expectedClassName = expectedClass.name || ANONYMOUS;
                    var actualClassName = getClassName(props[propName]);
                    return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
                }
                return null;
            }
            return createChainableTypeChecker(validate);
        }
        function createEnumTypeChecker(expectedValues) {
            if (!Array.isArray(expectedValues)) return emptyFunctionThatReturnsNull;
            function validate(props, propName, componentName, location, propFullName) {
                var propValue = props[propName];
                for(var i = 0; i < expectedValues.length; i++){
                    if (is(propValue, expectedValues[i])) return null;
                }
                var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
                    var type = getPreciseType(value);
                    if (type === 'symbol') return String(value);
                    return value;
                });
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
            }
            return createChainableTypeChecker(validate);
        }
        function createObjectOfTypeChecker(typeChecker) {
            function validate(props, propName, componentName, location, propFullName) {
                if (typeof typeChecker !== 'function') return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
                var propValue = props[propName];
                var propType = getPropType(propValue);
                if (propType !== 'object') return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
                for(var key in propValue)if (has(propValue, key)) {
                    var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
                    if (error instanceof Error) return error;
                }
                return null;
            }
            return createChainableTypeChecker(validate);
        }
        function createUnionTypeChecker(arrayOfTypeCheckers) {
            if (!Array.isArray(arrayOfTypeCheckers)) return emptyFunctionThatReturnsNull;
            for(var i = 0; i < arrayOfTypeCheckers.length; i++){
                var checker = arrayOfTypeCheckers[i];
                if (typeof checker !== 'function') {
                    printWarning("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
                    return emptyFunctionThatReturnsNull;
                }
            }
            function validate(props, propName, componentName, location, propFullName) {
                var expectedTypes = [];
                for(var i = 0; i < arrayOfTypeCheckers.length; i++){
                    var checker = arrayOfTypeCheckers[i];
                    var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
                    if (checkerResult == null) return null;
                    if (checkerResult.data && has(checkerResult.data, 'expectedType')) expectedTypes.push(checkerResult.data.expectedType);
                }
                var expectedTypesMessage = expectedTypes.length > 0 ? ', expected one of type [' + expectedTypes.join(', ') + ']' : '';
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
            }
            return createChainableTypeChecker(validate);
        }
        function createNodeChecker() {
            function validate(props, propName, componentName, location, propFullName) {
                if (!isNode(props[propName])) return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
                return null;
            }
            return createChainableTypeChecker(validate);
        }
        function invalidValidatorError(componentName, location, propFullName, key, type) {
            return new PropTypeError((componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + type + '`.');
        }
        function createShapeTypeChecker(shapeTypes) {
            function validate(props, propName, componentName, location, propFullName) {
                var propValue = props[propName];
                var propType = getPropType(propValue);
                if (propType !== 'object') return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
                for(var key in shapeTypes){
                    var checker = shapeTypes[key];
                    if (typeof checker !== 'function') return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
                    var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
                    if (error) return error;
                }
                return null;
            }
            return createChainableTypeChecker(validate);
        }
        function createStrictShapeTypeChecker(shapeTypes) {
            function validate(props, propName, componentName, location, propFullName) {
                var propValue = props[propName];
                var propType = getPropType(propValue);
                if (propType !== 'object') return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
                // We need to check all keys in case some are required but missing from props.
                var allKeys = assign({}, props[propName], shapeTypes);
                for(var key in allKeys){
                    var checker = shapeTypes[key];
                    if (has(shapeTypes, key) && typeof checker !== 'function') return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
                    if (!checker) return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
                    var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
                    if (error) return error;
                }
                return null;
            }
            return createChainableTypeChecker(validate);
        }
        function isNode(propValue) {
            switch(typeof propValue){
                case 'number':
                case 'string':
                case 'undefined':
                    return true;
                case 'boolean':
                    return !propValue;
                case 'object':
                    if (Array.isArray(propValue)) return propValue.every(isNode);
                    if (propValue === null || isValidElement(propValue)) return true;
                    var iteratorFn = getIteratorFn(propValue);
                    if (iteratorFn) {
                        var iterator = iteratorFn.call(propValue);
                        var step;
                        if (iteratorFn !== propValue.entries) while(!(step = iterator.next()).done){
                            if (!isNode(step.value)) return false;
                        }
                        else // Iterator will provide entry [k,v] tuples rather than values.
                        while(!(step = iterator.next()).done){
                            var entry = step.value;
                            if (entry) {
                                if (!isNode(entry[1])) return false;
                            }
                        }
                    } else return false;
                    return true;
                default:
                    return false;
            }
        }
        function isSymbol(propType, propValue) {
            // Native Symbol.
            if (propType === 'symbol') return true;
            // falsy value can't be a Symbol
            if (!propValue) return false;
            // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
            if (propValue['@@toStringTag'] === 'Symbol') return true;
            // Fallback for non-spec compliant Symbols which are polyfilled.
            if (typeof Symbol === 'function' && propValue instanceof Symbol) return true;
            return false;
        }
        // Equivalent of `typeof` but with special handling for array and regexp.
        function getPropType(propValue) {
            var propType = typeof propValue;
            if (Array.isArray(propValue)) return 'array';
            if (propValue instanceof RegExp) // Old webkits (at least until Android 4.0) return 'function' rather than
            // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
            // passes PropTypes.object.
            return 'object';
            if (isSymbol(propType, propValue)) return 'symbol';
            return propType;
        }
        // This handles more types than `getPropType`. Only used for error messages.
        // See `createPrimitiveTypeChecker`.
        function getPreciseType(propValue) {
            if (typeof propValue === 'undefined' || propValue === null) return '' + propValue;
            var propType = getPropType(propValue);
            if (propType === 'object') {
                if (propValue instanceof Date) return 'date';
                else if (propValue instanceof RegExp) return 'regexp';
            }
            return propType;
        }
        // Returns a string that is postfixed to a warning about an invalid type.
        // For example, "undefined" or "of type array"
        function getPostfixForTypeWarning(value) {
            var type = getPreciseType(value);
            switch(type){
                case 'array':
                case 'object':
                    return 'an ' + type;
                case 'boolean':
                case 'date':
                case 'regexp':
                    return 'a ' + type;
                default:
                    return type;
            }
        }
        // Returns class name of the object, if any.
        function getClassName(propValue) {
            if (!propValue.constructor || !propValue.constructor.name) return ANONYMOUS;
            return propValue.constructor.name;
        }
        ReactPropTypes.checkPropTypes = checkPropTypes;
        ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
        ReactPropTypes.PropTypes = ReactPropTypes;
        return ReactPropTypes;
    };
    return $0b609822001335d1$var$factoryWithTypeCheckers;
}



/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2c43f2a57909852e$var$factoryWithThrowingShims;
var $2c43f2a57909852e$var$hasRequiredFactoryWithThrowingShims;
function $2c43f2a57909852e$export$b88c30a9414655a0() {
    if ($2c43f2a57909852e$var$hasRequiredFactoryWithThrowingShims) return $2c43f2a57909852e$var$factoryWithThrowingShims;
    $2c43f2a57909852e$var$hasRequiredFactoryWithThrowingShims = 1;
    var ReactPropTypesSecret = (0, $28c54605a22548b8$export$b88c30a9414655a0)();
    function emptyFunction() {}
    function emptyFunctionWithReset() {}
    emptyFunctionWithReset.resetWarningCache = emptyFunction;
    $2c43f2a57909852e$var$factoryWithThrowingShims = function() {
        function shim(props, propName, componentName, location, propFullName, secret) {
            if (secret === ReactPropTypesSecret) // It is still safe when called from React.
            return;
            var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
            err.name = 'Invariant Violation';
            throw err;
        }
        shim.isRequired = shim;
        function getShim() {
            return shim;
        } // Important!
        // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
        var ReactPropTypes = {
            array: shim,
            bigint: shim,
            bool: shim,
            func: shim,
            number: shim,
            object: shim,
            string: shim,
            symbol: shim,
            any: shim,
            arrayOf: getShim,
            element: shim,
            elementType: shim,
            instanceOf: getShim,
            node: shim,
            objectOf: getShim,
            oneOf: getShim,
            oneOfType: getShim,
            shape: getShim,
            exact: getShim,
            checkPropTypes: emptyFunctionWithReset,
            resetWarningCache: emptyFunction
        };
        ReactPropTypes.PropTypes = ReactPropTypes;
        return ReactPropTypes;
    };
    return $2c43f2a57909852e$var$factoryWithThrowingShims;
}


var $4adbb4773332d47d$var$ReactIs, $4adbb4773332d47d$var$throwOnDirectAccess;
// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
(0, $9103dfd4f01d9755$export$5edeffb658f039f4).exports = (0, $2c43f2a57909852e$export$b88c30a9414655a0)()();
var $4adbb4773332d47d$export$ffb5f4729a158638 = (0, $9103dfd4f01d9755$export$5edeffb658f039f4).exports;
var $4adbb4773332d47d$export$2e2bcd8739ae039 = /*@__PURE__*/ (0, $19c294935800915e$export$22b09f878622677a)($4adbb4773332d47d$export$ffb5f4729a158638);



var $kC364 = parcelRequire("kC364");
function $933734227e3f57b2$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $933734227e3f57b2$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $933734227e3f57b2$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $933734227e3f57b2$var$r(e)) && (n && (n += " "), n += t);
    return n;
}


// lib/Draggable.tsx
// lib/utils/shims.ts
function $049fed5922c4202f$var$findInArray(array, callback) {
    for(let i = 0, length = array.length; i < length; i++){
        if (callback.apply(callback, [
            array[i],
            i,
            array
        ])) return array[i];
    }
}
function $049fed5922c4202f$var$isFunction(func) {
    return typeof func === "function" || Object.prototype.toString.call(func) === "[object Function]";
}
function $049fed5922c4202f$var$isNum(num) {
    return typeof num === "number" && !isNaN(num);
}
function $049fed5922c4202f$var$int(a) {
    return parseInt(a, 10);
}
function $049fed5922c4202f$var$dontSetMe(props, propName, componentName) {
    if (props[propName]) return new Error(`Invalid prop ${propName} passed to ${componentName} - do not set this, set it on the child.`);
}
// lib/utils/getPrefix.ts
var $049fed5922c4202f$var$prefixes = [
    "Moz",
    "Webkit",
    "O",
    "ms"
];
function $049fed5922c4202f$var$getPrefix(prop = "transform") {
    var _a, _b;
    if (typeof window === "undefined") return "";
    const style = (_b = (_a = window.document) == null ? void 0 : _a.documentElement) == null ? void 0 : _b.style;
    if (!style) return "";
    if (prop in style) return "";
    for(let i = 0; i < $049fed5922c4202f$var$prefixes.length; i++){
        if ($049fed5922c4202f$var$browserPrefixToKey(prop, $049fed5922c4202f$var$prefixes[i]) in style) return $049fed5922c4202f$var$prefixes[i];
    }
    return "";
}
function $049fed5922c4202f$var$browserPrefixToKey(prop, prefix) {
    return prefix ? `${prefix}${$049fed5922c4202f$var$kebabToTitleCase(prop)}` : prop;
}
function $049fed5922c4202f$var$kebabToTitleCase(str) {
    let out = "";
    let shouldCapitalize = true;
    for(let i = 0; i < str.length; i++){
        if (shouldCapitalize) {
            out += str[i].toUpperCase();
            shouldCapitalize = false;
        } else if (str[i] === "-") shouldCapitalize = true;
        else out += str[i];
    }
    return out;
}
var $049fed5922c4202f$var$getPrefix_default = $049fed5922c4202f$var$getPrefix();
// lib/utils/domFns.ts
var $049fed5922c4202f$var$matchesSelectorFunc = "";
function $049fed5922c4202f$var$matchesSelector(el, selector) {
    var _a;
    if (!$049fed5922c4202f$var$matchesSelectorFunc) $049fed5922c4202f$var$matchesSelectorFunc = (_a = $049fed5922c4202f$var$findInArray([
        "matches",
        "webkitMatchesSelector",
        "mozMatchesSelector",
        "msMatchesSelector",
        "oMatchesSelector"
    ], function(method) {
        return $049fed5922c4202f$var$isFunction(el[method]);
    })) != null ? _a : "";
    const matchFn = el[$049fed5922c4202f$var$matchesSelectorFunc];
    if (!$049fed5922c4202f$var$isFunction(matchFn)) return false;
    return Boolean(matchFn.call(el, selector));
}
function $049fed5922c4202f$var$matchesSelectorAndParentsTo(el, selector, baseNode) {
    let node = el;
    do {
        if ($049fed5922c4202f$var$matchesSelector(node, selector)) return true;
        if (node === baseNode) return false;
        node = node.parentNode;
    }while (node);
    return false;
}
function $049fed5922c4202f$var$addEvent(el, event, handler, inputOptions) {
    if (!el) return;
    const options = {
        capture: true,
        ...inputOptions
    };
    const listener = handler;
    if (el.addEventListener) el.addEventListener(event, listener, options);
    else if (el.attachEvent) el.attachEvent("on" + event, listener);
    else el["on" + event] = listener;
}
function $049fed5922c4202f$var$removeEvent(el, event, handler, inputOptions) {
    if (!el) return;
    const options = {
        capture: true,
        ...inputOptions
    };
    const listener = handler;
    if (el.removeEventListener) el.removeEventListener(event, listener, options);
    else if (el.detachEvent) el.detachEvent("on" + event, listener);
    else el["on" + event] = null;
}
function $049fed5922c4202f$var$outerHeight(node) {
    let height = node.clientHeight;
    const computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    height += $049fed5922c4202f$var$int(computedStyle.borderTopWidth);
    height += $049fed5922c4202f$var$int(computedStyle.borderBottomWidth);
    return height;
}
function $049fed5922c4202f$var$outerWidth(node) {
    let width = node.clientWidth;
    const computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    width += $049fed5922c4202f$var$int(computedStyle.borderLeftWidth);
    width += $049fed5922c4202f$var$int(computedStyle.borderRightWidth);
    return width;
}
function $049fed5922c4202f$var$innerHeight(node) {
    let height = node.clientHeight;
    const computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    height -= $049fed5922c4202f$var$int(computedStyle.paddingTop);
    height -= $049fed5922c4202f$var$int(computedStyle.paddingBottom);
    return height;
}
function $049fed5922c4202f$var$innerWidth(node) {
    let width = node.clientWidth;
    const computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    width -= $049fed5922c4202f$var$int(computedStyle.paddingLeft);
    width -= $049fed5922c4202f$var$int(computedStyle.paddingRight);
    return width;
}
function $049fed5922c4202f$var$offsetXYFromParent(evt, offsetParent, scale) {
    const isBody = offsetParent === offsetParent.ownerDocument.body;
    const offsetParentRect = isBody ? {
        left: 0,
        top: 0
    } : offsetParent.getBoundingClientRect();
    const x = (evt.clientX + offsetParent.scrollLeft - offsetParentRect.left) / scale;
    const y = (evt.clientY + offsetParent.scrollTop - offsetParentRect.top) / scale;
    return {
        x: x,
        y: y
    };
}
function $049fed5922c4202f$var$createCSSTransform(controlPos, positionOffset) {
    const translation = $049fed5922c4202f$var$getTranslation(controlPos, positionOffset, "px");
    return {
        [$049fed5922c4202f$var$browserPrefixToKey("transform", $049fed5922c4202f$var$getPrefix_default)]: translation
    };
}
function $049fed5922c4202f$var$createSVGTransform(controlPos, positionOffset) {
    const translation = $049fed5922c4202f$var$getTranslation(controlPos, positionOffset, "");
    return translation;
}
function $049fed5922c4202f$var$getTranslation({ x: x, y: y }, positionOffset, unitSuffix) {
    let translation = `translate(${x}${unitSuffix},${y}${unitSuffix})`;
    if (positionOffset) {
        const defaultX = `${typeof positionOffset.x === "string" ? positionOffset.x : positionOffset.x + unitSuffix}`;
        const defaultY = `${typeof positionOffset.y === "string" ? positionOffset.y : positionOffset.y + unitSuffix}`;
        translation = `translate(${defaultX}, ${defaultY})` + translation;
    }
    return translation;
}
function $049fed5922c4202f$var$getTouch(e, identifier) {
    return e.targetTouches && $049fed5922c4202f$var$findInArray(e.targetTouches, (t)=>identifier === t.identifier) || e.changedTouches && $049fed5922c4202f$var$findInArray(e.changedTouches, (t)=>identifier === t.identifier);
}
function $049fed5922c4202f$var$getTouchIdentifier(e) {
    if (e.targetTouches && e.targetTouches[0]) return e.targetTouches[0].identifier;
    if (e.changedTouches && e.changedTouches[0]) return e.changedTouches[0].identifier;
}
function $049fed5922c4202f$var$addUserSelectStyles(doc) {
    if (!doc) return;
    let styleEl = doc.getElementById("react-draggable-style-el");
    if (!styleEl) {
        styleEl = doc.createElement("style");
        styleEl.type = "text/css";
        styleEl.id = "react-draggable-style-el";
        styleEl.innerHTML = ".react-draggable-transparent-selection *::-moz-selection {all: inherit;}\n";
        styleEl.innerHTML += ".react-draggable-transparent-selection *::selection {all: inherit;}\n";
        doc.getElementsByTagName("head")[0].appendChild(styleEl);
    }
    if (doc.body) $049fed5922c4202f$var$addClassName(doc.body, "react-draggable-transparent-selection");
}
function $049fed5922c4202f$var$scheduleRemoveUserSelectStyles(doc) {
    if (window.requestAnimationFrame) window.requestAnimationFrame(()=>{
        $049fed5922c4202f$var$removeUserSelectStyles(doc);
    });
    else $049fed5922c4202f$var$removeUserSelectStyles(doc);
}
function $049fed5922c4202f$var$removeUserSelectStyles(doc) {
    if (!doc) return;
    try {
        if (doc.body) $049fed5922c4202f$var$removeClassName(doc.body, "react-draggable-transparent-selection");
        const ieSelection = doc.selection;
        if (ieSelection) ieSelection.empty();
        else {
            const selection = (doc.defaultView || window).getSelection();
            if (selection && selection.type !== "Caret") selection.removeAllRanges();
        }
    } catch  {}
}
function $049fed5922c4202f$var$addClassName(el, className) {
    if (el.classList) el.classList.add(className);
    else if (!el.className.match(new RegExp(`(?:^|\\s)${className}(?!\\S)`))) el.className += ` ${className}`;
}
function $049fed5922c4202f$var$removeClassName(el, className) {
    if (el.classList) el.classList.remove(className);
    else el.className = el.className.replace(new RegExp(`(?:^|\\s)${className}(?!\\S)`, "g"), "");
}
// lib/utils/positionFns.ts
function $049fed5922c4202f$var$getBoundPosition(draggable, x, y) {
    if (!draggable.props.bounds) return [
        x,
        y
    ];
    let { bounds: bounds } = draggable.props;
    bounds = typeof bounds === "string" ? bounds : $049fed5922c4202f$var$cloneBounds(bounds);
    const node = $049fed5922c4202f$var$findDOMNode(draggable);
    if (typeof bounds === "string") {
        const { ownerDocument: ownerDocument } = node;
        const ownerWindow = ownerDocument.defaultView;
        if (!ownerWindow) throw new Error("Cannot resolve the owner window of the draggable node.");
        let boundNode;
        if (bounds === "parent") boundNode = node.parentNode;
        else {
            const rootNode = node.getRootNode();
            boundNode = rootNode.querySelector(bounds);
        }
        if (!(boundNode instanceof ownerWindow.HTMLElement)) throw new Error('Bounds selector "' + bounds + '" could not find an element.');
        const boundNodeEl = boundNode;
        const nodeStyle = ownerWindow.getComputedStyle(node);
        const boundNodeStyle = ownerWindow.getComputedStyle(boundNodeEl);
        bounds = {
            left: -node.offsetLeft + $049fed5922c4202f$var$int(boundNodeStyle.paddingLeft) + $049fed5922c4202f$var$int(nodeStyle.marginLeft),
            top: -node.offsetTop + $049fed5922c4202f$var$int(boundNodeStyle.paddingTop) + $049fed5922c4202f$var$int(nodeStyle.marginTop),
            right: $049fed5922c4202f$var$innerWidth(boundNodeEl) - $049fed5922c4202f$var$outerWidth(node) - node.offsetLeft + $049fed5922c4202f$var$int(boundNodeStyle.paddingRight) - $049fed5922c4202f$var$int(nodeStyle.marginRight),
            bottom: $049fed5922c4202f$var$innerHeight(boundNodeEl) - $049fed5922c4202f$var$outerHeight(node) - node.offsetTop + $049fed5922c4202f$var$int(boundNodeStyle.paddingBottom) - $049fed5922c4202f$var$int(nodeStyle.marginBottom)
        };
    }
    if ($049fed5922c4202f$var$isNum(bounds.right)) x = Math.min(x, bounds.right);
    if ($049fed5922c4202f$var$isNum(bounds.bottom)) y = Math.min(y, bounds.bottom);
    if ($049fed5922c4202f$var$isNum(bounds.left)) x = Math.max(x, bounds.left);
    if ($049fed5922c4202f$var$isNum(bounds.top)) y = Math.max(y, bounds.top);
    return [
        x,
        y
    ];
}
function $049fed5922c4202f$var$snapToGrid(grid, pendingX, pendingY) {
    const x = Math.round(pendingX / grid[0]) * grid[0];
    const y = Math.round(pendingY / grid[1]) * grid[1];
    return [
        x,
        y
    ];
}
function $049fed5922c4202f$var$canDragX(draggable) {
    return draggable.props.axis === "both" || draggable.props.axis === "x";
}
function $049fed5922c4202f$var$canDragY(draggable) {
    return draggable.props.axis === "both" || draggable.props.axis === "y";
}
function $049fed5922c4202f$var$getControlPosition(e, touchIdentifier, draggableCore) {
    const touchObj = typeof touchIdentifier === "number" ? $049fed5922c4202f$var$getTouch(e, touchIdentifier) : null;
    if (typeof touchIdentifier === "number" && !touchObj) return null;
    const node = $049fed5922c4202f$var$findDOMNode(draggableCore);
    const offsetParent = draggableCore.props.offsetParent || node.offsetParent || node.ownerDocument.body;
    return $049fed5922c4202f$var$offsetXYFromParent(touchObj || e, offsetParent, draggableCore.props.scale);
}
function $049fed5922c4202f$var$createCoreData(draggable, x, y) {
    const isStart = !$049fed5922c4202f$var$isNum(draggable.lastX);
    const node = $049fed5922c4202f$var$findDOMNode(draggable);
    if (isStart) return {
        node: node,
        deltaX: 0,
        deltaY: 0,
        lastX: x,
        lastY: y,
        x: x,
        y: y
    };
    else return {
        node: node,
        deltaX: x - draggable.lastX,
        deltaY: y - draggable.lastY,
        lastX: draggable.lastX,
        lastY: draggable.lastY,
        x: x,
        y: y
    };
}
function $049fed5922c4202f$var$createDraggableData(draggable, coreData) {
    const scale = draggable.props.scale;
    return {
        node: coreData.node,
        x: draggable.state.x + coreData.deltaX / scale,
        y: draggable.state.y + coreData.deltaY / scale,
        deltaX: coreData.deltaX / scale,
        deltaY: coreData.deltaY / scale,
        lastX: draggable.state.x,
        lastY: draggable.state.y
    };
}
function $049fed5922c4202f$var$cloneBounds(bounds) {
    return {
        left: bounds.left,
        top: bounds.top,
        right: bounds.right,
        bottom: bounds.bottom
    };
}
function $049fed5922c4202f$var$findDOMNode(draggable) {
    const node = draggable.findDOMNode();
    if (!node) throw new Error("<DraggableCore>: Unmounted during event!");
    return node;
}
// lib/utils/log.ts
function $049fed5922c4202f$var$log(...args) {}
// lib/DraggableCore.tsx
var $049fed5922c4202f$var$eventsFor = {
    touch: {
        start: "touchstart",
        move: "touchmove",
        stop: "touchend"
    },
    mouse: {
        start: "mousedown",
        move: "mousemove",
        stop: "mouseup"
    }
};
var $049fed5922c4202f$var$dragEventFor = $049fed5922c4202f$var$eventsFor.mouse;
var $049fed5922c4202f$export$512ffe43e525b6fc = class extends $cQQee.Component {
    constructor(){
        super(...arguments);
        this.dragging = false;
        // Used while dragging to determine deltas.
        this.lastX = NaN;
        this.lastY = NaN;
        this.touchIdentifier = null;
        this.mounted = false;
        this.handleDragStart = (e)=>{
            this.props.onMouseDown(e);
            if (!this.props.allowAnyClick && (typeof e.button === "number" && e.button !== 0 || e.ctrlKey)) return false;
            const thisNode = this.findDOMNode();
            if (!thisNode || !thisNode.ownerDocument || !thisNode.ownerDocument.body) throw new Error("<DraggableCore> not mounted on DragStart!");
            const { ownerDocument: ownerDocument } = thisNode;
            if (this.props.disabled || !(e.target instanceof ownerDocument.defaultView.Node) || this.props.handle && !$049fed5922c4202f$var$matchesSelectorAndParentsTo(e.target, this.props.handle, thisNode) || this.props.cancel && $049fed5922c4202f$var$matchesSelectorAndParentsTo(e.target, this.props.cancel, thisNode)) return;
            if (e.type === "touchstart" && !this.props.allowMobileScroll) e.preventDefault();
            const touchIdentifier = $049fed5922c4202f$var$getTouchIdentifier(e);
            this.touchIdentifier = touchIdentifier;
            const position = $049fed5922c4202f$var$getControlPosition(e, touchIdentifier, this);
            if (position == null) return;
            const { x: x, y: y } = position;
            const coreEvent = $049fed5922c4202f$var$createCoreData(this, x, y);
            $049fed5922c4202f$var$log("DraggableCore: handleDragStart: %j", coreEvent);
            $049fed5922c4202f$var$log("calling", this.props.onStart);
            const shouldUpdate = this.props.onStart(e, coreEvent);
            if (shouldUpdate === false || this.mounted === false) return;
            if (this.props.enableUserSelectHack) $049fed5922c4202f$var$addUserSelectStyles(ownerDocument);
            this.dragging = true;
            this.lastX = x;
            this.lastY = y;
            $049fed5922c4202f$var$addEvent(ownerDocument, $049fed5922c4202f$var$dragEventFor.move, this.handleDrag);
            $049fed5922c4202f$var$addEvent(ownerDocument, $049fed5922c4202f$var$dragEventFor.stop, this.handleDragStop);
        };
        this.handleDrag = (e)=>{
            const position = $049fed5922c4202f$var$getControlPosition(e, this.touchIdentifier, this);
            if (position == null) return;
            let { x: x, y: y } = position;
            if (Array.isArray(this.props.grid)) {
                let deltaX = x - this.lastX, deltaY = y - this.lastY;
                [deltaX, deltaY] = $049fed5922c4202f$var$snapToGrid(this.props.grid, deltaX, deltaY);
                if (!deltaX && !deltaY) return;
                x = this.lastX + deltaX;
                y = this.lastY + deltaY;
            }
            const coreEvent = $049fed5922c4202f$var$createCoreData(this, x, y);
            $049fed5922c4202f$var$log("DraggableCore: handleDrag: %j", coreEvent);
            const shouldUpdate = this.props.onDrag(e, coreEvent);
            if (shouldUpdate === false || this.mounted === false) {
                try {
                    this.handleDragStop(new MouseEvent("mouseup"));
                } catch  {
                    const event = document.createEvent("MouseEvents");
                    event.initMouseEvent("mouseup", true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
                    this.handleDragStop(event);
                }
                return;
            }
            this.lastX = x;
            this.lastY = y;
        };
        this.handleDragStop = (e)=>{
            if (!this.dragging) return;
            const position = $049fed5922c4202f$var$getControlPosition(e, this.touchIdentifier, this);
            if (position == null) return;
            let { x: x, y: y } = position;
            if (Array.isArray(this.props.grid)) {
                let deltaX = x - this.lastX || 0;
                let deltaY = y - this.lastY || 0;
                [deltaX, deltaY] = $049fed5922c4202f$var$snapToGrid(this.props.grid, deltaX, deltaY);
                x = this.lastX + deltaX;
                y = this.lastY + deltaY;
            }
            const coreEvent = $049fed5922c4202f$var$createCoreData(this, x, y);
            const shouldContinue = this.props.onStop(e, coreEvent);
            if (shouldContinue === false || this.mounted === false) return false;
            const thisNode = this.findDOMNode();
            if (thisNode) {
                if (this.props.enableUserSelectHack) $049fed5922c4202f$var$scheduleRemoveUserSelectStyles(thisNode.ownerDocument);
            }
            $049fed5922c4202f$var$log("DraggableCore: handleDragStop: %j", coreEvent);
            this.dragging = false;
            this.lastX = NaN;
            this.lastY = NaN;
            if (thisNode) {
                $049fed5922c4202f$var$log("DraggableCore: Removing handlers");
                $049fed5922c4202f$var$removeEvent(thisNode.ownerDocument, $049fed5922c4202f$var$dragEventFor.move, this.handleDrag);
                $049fed5922c4202f$var$removeEvent(thisNode.ownerDocument, $049fed5922c4202f$var$dragEventFor.stop, this.handleDragStop);
            }
        };
        this.onMouseDown = (e)=>{
            $049fed5922c4202f$var$dragEventFor = $049fed5922c4202f$var$eventsFor.mouse;
            return this.handleDragStart(e);
        };
        this.onMouseUp = (e)=>{
            $049fed5922c4202f$var$dragEventFor = $049fed5922c4202f$var$eventsFor.mouse;
            return this.handleDragStop(e);
        };
        // Same as onMouseDown (start drag), but now consider this a touch device.
        this.onTouchStart = (e)=>{
            $049fed5922c4202f$var$dragEventFor = $049fed5922c4202f$var$eventsFor.touch;
            return this.handleDragStart(e);
        };
        this.onTouchEnd = (e)=>{
            $049fed5922c4202f$var$dragEventFor = $049fed5922c4202f$var$eventsFor.touch;
            return this.handleDragStop(e);
        };
    }
    componentDidMount() {
        this.mounted = true;
        const thisNode = this.findDOMNode();
        if (thisNode) $049fed5922c4202f$var$addEvent(thisNode, $049fed5922c4202f$var$eventsFor.touch.start, this.onTouchStart, {
            passive: false
        });
    }
    componentWillUnmount() {
        this.mounted = false;
        const thisNode = this.findDOMNode();
        if (thisNode) {
            const { ownerDocument: ownerDocument } = thisNode;
            $049fed5922c4202f$var$removeEvent(ownerDocument, $049fed5922c4202f$var$eventsFor.mouse.move, this.handleDrag);
            $049fed5922c4202f$var$removeEvent(ownerDocument, $049fed5922c4202f$var$eventsFor.touch.move, this.handleDrag);
            $049fed5922c4202f$var$removeEvent(ownerDocument, $049fed5922c4202f$var$eventsFor.mouse.stop, this.handleDragStop);
            $049fed5922c4202f$var$removeEvent(ownerDocument, $049fed5922c4202f$var$eventsFor.touch.stop, this.handleDragStop);
            $049fed5922c4202f$var$removeEvent(thisNode, $049fed5922c4202f$var$eventsFor.touch.start, this.onTouchStart, {
                passive: false
            });
            if (this.props.enableUserSelectHack) $049fed5922c4202f$var$scheduleRemoveUserSelectStyles(ownerDocument);
        }
    }
    // React 19 removed ReactDOM.findDOMNode, so nodeRef is now required.
    // For backward compatibility with React 18 and earlier, we still support findDOMNode if available.
    findDOMNode() {
        var _a;
        if ((_a = this.props) == null ? void 0 : _a.nodeRef) return this.props.nodeRef.current;
        const legacyReactDOM = (0, (/*@__PURE__*/$parcel$interopDefault($kC364)));
        if (typeof legacyReactDOM.findDOMNode === "function") return legacyReactDOM.findDOMNode(this);
        $049fed5922c4202f$var$log("react-draggable: ReactDOM.findDOMNode is not available in React 19+. You must provide a nodeRef prop. See: https://github.com/react-grid-layout/react-draggable#noderef");
        return null;
    }
    render() {
        return $cQQee.cloneElement($cQQee.Children.only(this.props.children), {
            // Note: mouseMove handler is attached to document so it will still function
            // when the user drags quickly and leaves the bounds of the element.
            onMouseDown: this.onMouseDown,
            onMouseUp: this.onMouseUp,
            // onTouchStart is added on `componentDidMount` so they can be added with
            // {passive: false}, which allows it to cancel. See
            // https://developers.google.com/web/updates/2017/01/scrolling-intervention
            onTouchEnd: this.onTouchEnd
        });
    }
};
$049fed5922c4202f$export$512ffe43e525b6fc.displayName = "DraggableCore";
// The index-signature annotation is load-bearing: without it tsc infers the
// PropTypes.Requireable<...> types and emits `import PropTypes from 'prop-types'`
// into the generated public .d.ts, forcing consumers to install
// @types/prop-types (the v4.5.0 hand-written typings had no prop-types dep).
// Do not remove. See lib/Draggable.tsx for the same guard.
$049fed5922c4202f$export$512ffe43e525b6fc.propTypes = {
    /**
   * `allowAnyClick` allows dragging using any mouse button.
   * By default, we only accept the left button.
   *
   * Defaults to `false`.
   */ allowAnyClick: (0, $4adbb4773332d47d$export$2e2bcd8739ae039).bool,
    /**
   * `allowMobileScroll` turns off cancellation of the 'touchstart' event
   * on mobile devices. Only enable this if you are having trouble with click
   * events. Prefer using 'handle' / 'cancel' instead.
   *
   * Defaults to `false`.
   */ allowMobileScroll: (0, $4adbb4773332d47d$export$2e2bcd8739ae039).bool,
    children: (0, $4adbb4773332d47d$export$2e2bcd8739ae039).node.isRequired,
    /**
   * `disabled`, if true, stops the <Draggable> from dragging. All handlers,
   * with the exception of `onMouseDown`, will not fire.
   */ disabled: (0, $4adbb4773332d47d$export$2e2bcd8739ae039).bool,
    /**
   * By default, we add 'user-select:none' attributes to the document body
   * to prevent ugly text selection during drag. If this is causing problems
   * for your app, set this to `false`.
   */ enableUserSelectHack: (0, $4adbb4773332d47d$export$2e2bcd8739ae039).bool,
    /**
   * `offsetParent`, if set, uses the passed DOM node to compute drag offsets
   * instead of using the parent node.
   */ offsetParent: function(props, propName) {
        if (props[propName] && props[propName].nodeType !== 1) throw new Error("Draggable's offsetParent must be a DOM Node.");
    },
    /**
   * `grid` specifies the x and y that dragging should snap to.
   */ grid: (0, $4adbb4773332d47d$export$2e2bcd8739ae039).arrayOf((0, $4adbb4773332d47d$export$2e2bcd8739ae039).number),
    /**
   * `handle` specifies a selector to be used as the handle that initiates drag.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable handle=".handle">
   *              <div>
   *                  <div className="handle">Click me to drag</div>
   *                  <div>This is some other content</div>
   *              </div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */ handle: (0, $4adbb4773332d47d$export$2e2bcd8739ae039).string,
    /**
   * `cancel` specifies a selector to be used to prevent drag initialization.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *           return(
   *               <Draggable cancel=".cancel">
   *                   <div>
   *                     <div className="cancel">You can't drag from here</div>
   *                     <div>Dragging here works fine</div>
   *                   </div>
   *               </Draggable>
   *           );
   *       }
   *   });
   * ```
   */ cancel: (0, $4adbb4773332d47d$export$2e2bcd8739ae039).string,
    /* If running in React Strict mode, ReactDOM.findDOMNode() is deprecated.
   * Unfortunately, in order for <Draggable> to work properly, we need raw access
   * to the underlying DOM node. If you want to avoid the warning, pass a `nodeRef`
   * as in this example:
   *
   * function MyComponent() {
   *   const nodeRef = React.useRef(null);
   *   return (
   *     <Draggable nodeRef={nodeRef}>
   *       <div ref={nodeRef}>Example Target</div>
   *     </Draggable>
   *   );
   * }
   *
   * This can be used for arbitrarily nested components, so long as the ref ends up
   * pointing to the actual child DOM node and not a custom component.
   */ nodeRef: (0, $4adbb4773332d47d$export$2e2bcd8739ae039).object,
    /**
   * Called when dragging starts.
   * If this function returns the boolean false, dragging will be canceled.
   */ onStart: (0, $4adbb4773332d47d$export$2e2bcd8739ae039).func,
    /**
   * Called while dragging.
   * If this function returns the boolean false, dragging will be canceled.
   */ onDrag: (0, $4adbb4773332d47d$export$2e2bcd8739ae039).func,
    /**
   * Called when dragging stops.
   * If this function returns the boolean false, the drag will remain active.
   */ onStop: (0, $4adbb4773332d47d$export$2e2bcd8739ae039).func,
    /**
   * A workaround option which can be passed if onMouseDown needs to be accessed,
   * since it'll always be blocked (as there is internal use of onMouseDown)
   */ onMouseDown: (0, $4adbb4773332d47d$export$2e2bcd8739ae039).func,
    /**
   * `scale`, if set, applies scaling while dragging an element
   */ scale: (0, $4adbb4773332d47d$export$2e2bcd8739ae039).number,
    /**
   * These properties should be defined on the child, not here.
   */ className: $049fed5922c4202f$var$dontSetMe,
    style: $049fed5922c4202f$var$dontSetMe,
    transform: $049fed5922c4202f$var$dontSetMe
};
// Typed as the full `DraggableCoreProps` (not just the default-provided subset)
// so React's JSX LibraryManagedAttributes treats EVERY prop as optional for
// consumers, matching the historical hand-written typings. At runtime only the
// default-able props are actually populated.
$049fed5922c4202f$export$512ffe43e525b6fc.defaultProps = {
    allowAnyClick: false,
    // by default only accept left click
    allowMobileScroll: false,
    disabled: false,
    enableUserSelectHack: true,
    onStart: function() {},
    onDrag: function() {},
    onStop: function() {},
    onMouseDown: function() {},
    scale: 1
};
// lib/Draggable.tsx
var $049fed5922c4202f$export$f2a139e5d18b9882 = class extends $cQQee.Component {
    constructor(props){
        super(props);
        this.onDragStart = (e, coreData)=>{
            $049fed5922c4202f$var$log("Draggable: onDragStart: %j", coreData);
            const shouldStart = this.props.onStart(e, $049fed5922c4202f$var$createDraggableData(this, coreData));
            if (shouldStart === false) return false;
            this.setState({
                dragging: true,
                dragged: true
            });
        };
        this.onDrag = (e, coreData)=>{
            if (!this.state.dragging) return false;
            $049fed5922c4202f$var$log("Draggable: onDrag: %j", coreData);
            const uiData = $049fed5922c4202f$var$createDraggableData(this, coreData);
            const newState = {
                x: uiData.x,
                y: uiData.y,
                slackX: 0,
                slackY: 0
            };
            if (this.props.bounds) {
                const { x: x, y: y } = newState;
                newState.x += this.state.slackX;
                newState.y += this.state.slackY;
                const [newStateX, newStateY] = $049fed5922c4202f$var$getBoundPosition(this, newState.x, newState.y);
                newState.x = newStateX;
                newState.y = newStateY;
                newState.slackX = this.state.slackX + (x - newState.x);
                newState.slackY = this.state.slackY + (y - newState.y);
                uiData.x = newState.x;
                uiData.y = newState.y;
                uiData.deltaX = newState.x - this.state.x;
                uiData.deltaY = newState.y - this.state.y;
            }
            const shouldUpdate = this.props.onDrag(e, uiData);
            if (shouldUpdate === false) return false;
            this.setState(newState);
        };
        this.onDragStop = (e, coreData)=>{
            if (!this.state.dragging) return false;
            const shouldContinue = this.props.onStop(e, $049fed5922c4202f$var$createDraggableData(this, coreData));
            if (shouldContinue === false) return false;
            $049fed5922c4202f$var$log("Draggable: onDragStop: %j", coreData);
            const newState = {
                dragging: false,
                slackX: 0,
                slackY: 0
            };
            const controlled = Boolean(this.props.position);
            if (controlled) {
                const { x: x, y: y } = this.props.position;
                newState.x = x;
                newState.y = y;
            }
            this.setState(newState);
        };
        this.state = {
            // Whether or not we are currently dragging.
            dragging: false,
            // Whether or not we have been dragged before.
            dragged: false,
            // Current transform x and y.
            x: props.position ? props.position.x : props.defaultPosition.x,
            y: props.position ? props.position.y : props.defaultPosition.y,
            prevPropsPosition: {
                ...props.position
            },
            // Used for compensating for out-of-bounds drags
            slackX: 0,
            slackY: 0,
            // Can only determine if SVG after mounting
            isElementSVG: false
        };
        if (props.position && !(props.onDrag || props.onStop)) console.warn("A `position` was applied to this <Draggable>, without drag handlers. This will make this component effectively undraggable. Please attach `onDrag` or `onStop` handlers so you can adjust the `position` of this element.");
    }
    // React 16.3+
    // Arity (props, state)
    static getDerivedStateFromProps({ position: position }, { prevPropsPosition: prevPropsPosition }) {
        if (position && (!prevPropsPosition || position.x !== prevPropsPosition.x || position.y !== prevPropsPosition.y)) {
            $049fed5922c4202f$var$log("Draggable: getDerivedStateFromProps %j", {
                position: position,
                prevPropsPosition: prevPropsPosition
            });
            return {
                x: position.x,
                y: position.y,
                prevPropsPosition: {
                    ...position
                }
            };
        }
        return null;
    }
    componentDidMount() {
        if (typeof window.SVGElement !== "undefined" && this.findDOMNode() instanceof window.SVGElement) this.setState({
            isElementSVG: true
        });
    }
    componentWillUnmount() {
        if (this.state.dragging) this.setState({
            dragging: false
        });
    }
    // React 19 removed ReactDOM.findDOMNode, so nodeRef is now required.
    // For backward compatibility with React 18 and earlier, we still support findDOMNode if available.
    findDOMNode() {
        var _a;
        if ((_a = this.props) == null ? void 0 : _a.nodeRef) return this.props.nodeRef.current;
        const legacyReactDOM = (0, (/*@__PURE__*/$parcel$interopDefault($kC364)));
        if (typeof legacyReactDOM.findDOMNode === "function") return legacyReactDOM.findDOMNode(this);
        return null;
    }
    render() {
        const { axis: axis, bounds: bounds, children: children, defaultPosition: defaultPosition, defaultClassName: defaultClassName, defaultClassNameDragging: defaultClassNameDragging, defaultClassNameDragged: defaultClassNameDragged, position: position, positionOffset: positionOffset, scale: scale, ...draggableCoreProps } = this.props;
        let style = {};
        let svgTransform = null;
        const controlled = Boolean(position);
        const draggable = !controlled || this.state.dragging;
        const validPosition = position || defaultPosition;
        const transformOpts = {
            // Set left if horizontal drag is enabled
            x: $049fed5922c4202f$var$canDragX(this) && draggable ? this.state.x : validPosition.x,
            // Set top if vertical drag is enabled
            y: $049fed5922c4202f$var$canDragY(this) && draggable ? this.state.y : validPosition.y
        };
        if (this.state.isElementSVG) svgTransform = $049fed5922c4202f$var$createSVGTransform(transformOpts, positionOffset);
        else style = $049fed5922c4202f$var$createCSSTransform(transformOpts, positionOffset);
        const onlyChild = $cQQee.Children.only(children);
        const className = (0, $933734227e3f57b2$export$4f5d2d50c9deca37)(onlyChild.props.className || "", defaultClassName, {
            [defaultClassNameDragging]: this.state.dragging,
            [defaultClassNameDragged]: this.state.dragged
        });
        return /* @__PURE__ */ $cQQee.createElement($049fed5922c4202f$export$512ffe43e525b6fc, {
            ...draggableCoreProps,
            onStart: this.onDragStart,
            onDrag: this.onDrag,
            onStop: this.onDragStop
        }, $cQQee.cloneElement(onlyChild, {
            className: className,
            style: {
                ...onlyChild.props.style,
                ...style
            },
            transform: svgTransform
        }));
    }
};
$049fed5922c4202f$export$f2a139e5d18b9882.displayName = "Draggable";
// The index-signature annotation is load-bearing: without it tsc infers the
// PropTypes.Requireable<...> types and emits `import PropTypes from 'prop-types'`
// into the generated public .d.ts, forcing consumers to install
// @types/prop-types (the v4.5.0 hand-written typings had no prop-types dep).
// Do not remove. See lib/DraggableCore.tsx for the same guard.
$049fed5922c4202f$export$f2a139e5d18b9882.propTypes = {
    // Accepts all props <DraggableCore> accepts.
    ...$049fed5922c4202f$export$512ffe43e525b6fc.propTypes,
    /**
   * `axis` determines which axis the draggable can move.
   *
   *  Note that all callbacks will still return data as normal. This only
   *  controls flushing to the DOM.
   *
   * 'both' allows movement horizontally and vertically.
   * 'x' limits movement to horizontal axis.
   * 'y' limits movement to vertical axis.
   * 'none' limits all movement.
   *
   * Defaults to 'both'.
   */ axis: (0, $4adbb4773332d47d$export$2e2bcd8739ae039).oneOf([
        "both",
        "x",
        "y",
        "none"
    ]),
    /**
   * `bounds` determines the range of movement available to the element.
   * Available values are:
   *
   * 'parent' restricts movement within the Draggable's parent node.
   *
   * Alternatively, pass an object with the following properties, all of which are optional:
   *
   * {left: LEFT_BOUND, right: RIGHT_BOUND, bottom: BOTTOM_BOUND, top: TOP_BOUND}
   *
   * All values are in px.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable bounds={{right: 300, bottom: 300}}>
   *              <div>Content</div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */ bounds: (0, $4adbb4773332d47d$export$2e2bcd8739ae039).oneOfType([
        (0, $4adbb4773332d47d$export$2e2bcd8739ae039).shape({
            left: (0, $4adbb4773332d47d$export$2e2bcd8739ae039).number,
            right: (0, $4adbb4773332d47d$export$2e2bcd8739ae039).number,
            top: (0, $4adbb4773332d47d$export$2e2bcd8739ae039).number,
            bottom: (0, $4adbb4773332d47d$export$2e2bcd8739ae039).number
        }),
        (0, $4adbb4773332d47d$export$2e2bcd8739ae039).string,
        (0, $4adbb4773332d47d$export$2e2bcd8739ae039).oneOf([
            false
        ])
    ]),
    defaultClassName: (0, $4adbb4773332d47d$export$2e2bcd8739ae039).string,
    defaultClassNameDragging: (0, $4adbb4773332d47d$export$2e2bcd8739ae039).string,
    defaultClassNameDragged: (0, $4adbb4773332d47d$export$2e2bcd8739ae039).string,
    /**
   * `defaultPosition` specifies the x and y that the dragged item should start at
   *
   * Example:
   *
   * ```jsx
   *      let App = React.createClass({
   *          render: function () {
   *              return (
   *                  <Draggable defaultPosition={{x: 25, y: 25}}>
   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
   *                  </Draggable>
   *              );
   *          }
   *      });
   * ```
   */ defaultPosition: (0, $4adbb4773332d47d$export$2e2bcd8739ae039).shape({
        x: (0, $4adbb4773332d47d$export$2e2bcd8739ae039).number,
        y: (0, $4adbb4773332d47d$export$2e2bcd8739ae039).number
    }),
    positionOffset: (0, $4adbb4773332d47d$export$2e2bcd8739ae039).shape({
        x: (0, $4adbb4773332d47d$export$2e2bcd8739ae039).oneOfType([
            (0, $4adbb4773332d47d$export$2e2bcd8739ae039).number,
            (0, $4adbb4773332d47d$export$2e2bcd8739ae039).string
        ]),
        y: (0, $4adbb4773332d47d$export$2e2bcd8739ae039).oneOfType([
            (0, $4adbb4773332d47d$export$2e2bcd8739ae039).number,
            (0, $4adbb4773332d47d$export$2e2bcd8739ae039).string
        ])
    }),
    /**
   * `position`, if present, defines the current position of the element.
   *
   *  This is similar to how form elements in React work - if no `position` is supplied, the component
   *  is uncontrolled.
   *
   * Example:
   *
   * ```jsx
   *      let App = React.createClass({
   *          render: function () {
   *              return (
   *                  <Draggable position={{x: 25, y: 25}}>
   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
   *                  </Draggable>
   *              );
   *          }
   *      });
   * ```
   */ position: (0, $4adbb4773332d47d$export$2e2bcd8739ae039).shape({
        x: (0, $4adbb4773332d47d$export$2e2bcd8739ae039).number,
        y: (0, $4adbb4773332d47d$export$2e2bcd8739ae039).number
    }),
    /**
   * These properties should be defined on the child, not here.
   */ className: $049fed5922c4202f$var$dontSetMe,
    style: $049fed5922c4202f$var$dontSetMe,
    transform: $049fed5922c4202f$var$dontSetMe
};
// Typed as the full `DraggableProps` (not just the default-provided subset) so
// React's JSX LibraryManagedAttributes treats EVERY prop as optional for
// consumers, matching the historical hand-written typings. At runtime only the
// default-able props are actually populated.
$049fed5922c4202f$export$f2a139e5d18b9882.defaultProps = {
    ...$049fed5922c4202f$export$512ffe43e525b6fc.defaultProps,
    axis: "both",
    bounds: false,
    defaultClassName: "react-draggable",
    defaultClassNameDragging: "react-draggable-dragging",
    defaultClassNameDragged: "react-draggable-dragged",
    defaultPosition: {
        x: 0,
        y: 0
    },
    scale: 1
};


// lib/cjs.ts
var $99b95a19b989800b$export$2e2bcd8739ae039 = (0, $049fed5922c4202f$export$f2a139e5d18b9882);



var $cQQee = parcelRequire("cQQee");
// Gap between the bar and the bottom edge of the viewport on first render
const $337ed5906dc8ba67$var$BOTTOM_OFFSET = 30;
// Max x/y the bar's top-left can take while staying fully inside the viewport.
const $337ed5906dc8ba67$var$getDragBounds = (rect)=>({
        left: 0,
        top: 0,
        right: window.innerWidth - rect.width,
        bottom: window.innerHeight - rect.height
    });
/**
 * Custom hook to manage draggable position for FloatingActionBar.
 *
 * The bar is `position: fixed` with `top: 0; left: 0`, so react-draggable's
 * `transform: translate(x, y)` maps 1:1 to viewport coordinates. That lets us
 * express both the initial placement and the drag `bounds` in plain viewport
 * pixels.
 *
 * @param enabled - Whether positioning should be calculated (draggable prop)
 * @returns Position state, setter, drag bounds, and ref for component element
 */ const $337ed5906dc8ba67$export$a9aefe3396e055e0 = (enabled)=>{
    const [position, setPosition] = (0, $cQQee.useState)({
        x: 0,
        y: 0
    });
    const [bounds, setBounds] = (0, $cQQee.useState)({
        left: 0,
        top: 0,
        right: 0,
        bottom: 0
    });
    const ref = (0, $cQQee.useRef)(null);
    // Initial center-bottom placement, measured after the bar has rendered.
    (0, $cQQee.useLayoutEffect)(()=>{
        if (!enabled || !ref.current) return;
        const nextBounds = $337ed5906dc8ba67$var$getDragBounds(ref.current.getBoundingClientRect());
        setBounds(nextBounds);
        setPosition({
            x: nextBounds.right / 2,
            y: nextBounds.bottom - $337ed5906dc8ba67$var$BOTTOM_OFFSET // 30px above the bottom edge
        });
    }, [
        enabled
    ]);
    // Recompute bounds and keep the bar inside the viewport on resize.
    (0, $cQQee.useEffect)(()=>{
        if (!enabled) return;
        const handleResize = ()=>{
            if (!ref.current) return;
            const nextBounds = $337ed5906dc8ba67$var$getDragBounds(ref.current.getBoundingClientRect());
            setBounds(nextBounds);
            setPosition((prev)=>({
                    x: Math.max(0, Math.min(prev.x, nextBounds.right)),
                    y: Math.max(0, Math.min(prev.y, nextBounds.bottom))
                }));
        };
        window.addEventListener('resize', handleResize);
        return ()=>{
            window.removeEventListener('resize', handleResize);
        };
    }, [
        enabled
    ]);
    return {
        position: position,
        setPosition: setPosition,
        bounds: bounds,
        ref: ref
    };
};


const $cfbdf554930c4fba$var$MAX_VISIBLE_ACTIONS = 5;
const $cfbdf554930c4fba$var$DRAG_HANDLE_CLASS = 'floating_action_bar_drag_handle';
/* ------------------------------------------------------------------ */ /* Compound (bits-and-pieces) pieces                                   */ /* ------------------------------------------------------------------ */ /**
 * The bar container. When `draggable`, owns the drag positioning logic and
 * wraps the bar in react-draggable's Draggable (keyed off the drag handle).
 */ const $cfbdf554930c4fba$export$6d65a6beb80f884d = ({ children: children, className: className, draggable: draggable = false, forwardedRef: forwardedRef, ...props })=>{
    const { position: position, setPosition: setPosition, ref: ref, bounds: bounds } = (0, $337ed5906dc8ba67$export$a9aefe3396e055e0)(draggable);
    const setRefs = (0, $cQQee.useCallback)((node)=>{
        ref.current = node;
        if (typeof forwardedRef === 'function') forwardedRef(node);
        else if (forwardedRef) forwardedRef.current = node;
    }, [
        forwardedRef,
        ref
    ]);
    const content = (0, $81ee76508714b94a$export$35e795649ee09318).jsx("div", {
        ref: setRefs,
        className: (0, $e99e5f020fa3ffc8$export$1343a74baacb0543)((0, $ff2225322a61af74$export$2e2bcd8739ae039).floating_action_bar_main, draggable ? (0, $ff2225322a61af74$export$2e2bcd8739ae039).floating_action_bar_draggable : '', className ?? ''),
        role: "toolbar",
        "aria-label": "Bulk actions toolbar",
        ...props,
        children: children
    });
    if (!draggable) return content;
    return (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $99b95a19b989800b$export$2e2bcd8739ae039), {
        handle: `.${$cfbdf554930c4fba$var$DRAG_HANDLE_CLASS}`,
        position: position,
        bounds: bounds,
        onDrag: (// eslint-disable-next-line @typescript-eslint/naming-convention
        _event, data)=>{
            setPosition({
                x: data.x,
                y: data.y
            });
        },
        children: content
    });
};
$cfbdf554930c4fba$export$6d65a6beb80f884d.displayName = 'FloatingActionBarRoot';
/** Grab handle. react-draggable keys on the `floating_action_bar_drag_handle` class. */ const $cfbdf554930c4fba$export$cceb5053deb5908a = (0, (/*@__PURE__*/$parcel$interopDefault($cQQee))).forwardRef(({ className: className, ...props }, ref)=>(0, $81ee76508714b94a$export$35e795649ee09318).jsx("span", {
        ref: ref,
        className: (0, $e99e5f020fa3ffc8$export$1343a74baacb0543)((0, $ff2225322a61af74$export$2e2bcd8739ae039).floating_action_bar_drag_icon, $cfbdf554930c4fba$var$DRAG_HANDLE_CLASS, className ?? ''),
        "aria-label": "Drag to reposition",
        ...props,
        children: (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $7b928ddcfbbbd704$export$2e2bcd8739ae039), {})
    }));
$cfbdf554930c4fba$export$cceb5053deb5908a.displayName = 'FloatingActionBarDragHandle';
/** "N Selected" label. Renders `count` Selected, or arbitrary children. */ const $cfbdf554930c4fba$export$b8c634a685c78953 = (0, (/*@__PURE__*/$parcel$interopDefault($cQQee))).forwardRef(({ count: count, children: children, className: className, ...props }, ref)=>{
    const content = children ?? `${count ?? 0} Selected`;
    return (0, $81ee76508714b94a$export$35e795649ee09318).jsx("span", {
        ref: ref,
        className: (0, $e99e5f020fa3ffc8$export$1343a74baacb0543)((0, $ff2225322a61af74$export$2e2bcd8739ae039).floating_action_bar_selected, className ?? ''),
        "aria-live": "polite",
        "aria-atomic": "true",
        ...props,
        children: content
    });
});
$cfbdf554930c4fba$export$b8c634a685c78953.displayName = 'FloatingActionBarSelectedCount';
/** Vertical divider styled for the dark bar. */ const $cfbdf554930c4fba$export$39c8c1727ef1e388 = ({ className: className })=>(0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $cc0bb6c392922fb5$export$2e2bcd8739ae039), {
        orientation: "vertical",
        length: "var(--ng-s-16)",
        customStyleClass: (0, $e99e5f020fa3ffc8$export$1343a74baacb0543)((0, $ff2225322a61af74$export$2e2bcd8739ae039).floating_action_bar_separator, className ?? '')
    });
$cfbdf554930c4fba$export$39c8c1727ef1e388.displayName = 'FloatingActionBarSeparator';
/** Flex group container for action buttons. */ const $cfbdf554930c4fba$export$5211cf585049592e = (0, (/*@__PURE__*/$parcel$interopDefault($cQQee))).forwardRef(({ children: children, className: className, ...props }, ref)=>(0, $81ee76508714b94a$export$35e795649ee09318).jsx("div", {
        ref: ref,
        className: (0, $e99e5f020fa3ffc8$export$1343a74baacb0543)((0, $ff2225322a61af74$export$2e2bcd8739ae039).floating_action_bar_actions, className ?? ''),
        ...props,
        children: children
    }));
$cfbdf554930c4fba$export$5211cf585049592e.displayName = 'FloatingActionBarActions';
/** A single action button. */ const $cfbdf554930c4fba$export$f9a285f3c4fd6a4f = ({ action: action, postSelection: postSelection, className: className })=>{
    const handleClick = ()=>{
        action.onSelect();
        postSelection?.();
    };
    return (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $93eff1b09ae4008c$export$2e2bcd8739ae039), {
        text: action.label,
        icon: action.icon,
        onClick: handleClick,
        disabled: action.disabled,
        variant: "primary",
        size: "md",
        customStyleClass: (0, $e99e5f020fa3ffc8$export$1343a74baacb0543)((0, $ff2225322a61af74$export$2e2bcd8739ae039).floating_action_bar_button, className ?? '')
    }, action.value);
};
$cfbdf554930c4fba$export$f9a285f3c4fd6a4f.displayName = 'FloatingActionBarAction';
/** Overflow ("More") menu. Self-contained: owns its own open state. */ const $cfbdf554930c4fba$export$90297f34339487ef = ({ actions: actions, customContentClass: customContentClass })=>{
    const [isMenuOpen, setIsMenuOpen] = (0, $cQQee.useState)(false);
    const handleMenuClose = ()=>{
        setIsMenuOpen(false);
    };
    const menuActions = actions.map((action)=>({
            label: action.label,
            value: action.value,
            customComponent: (0, $81ee76508714b94a$export$35e795649ee09318).jsx($cfbdf554930c4fba$export$f9a285f3c4fd6a4f, {
                action: action,
                postSelection: handleMenuClose,
                className: (0, $ff2225322a61af74$export$2e2bcd8739ae039).floating_action_bar_action_menu_button
            }),
            disabled: action.disabled
        }));
    return (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $6caf1b679fa7e67d$export$2e2bcd8739ae039), {
        actions: menuActions,
        onSelection: ()=>{},
        open: isMenuOpen,
        onOpenChange: setIsMenuOpen,
        trigger: "click",
        customContentClass: (0, $e99e5f020fa3ffc8$export$1343a74baacb0543)((0, $ff2225322a61af74$export$2e2bcd8739ae039).floating_action_bar_dropdown_content, customContentClass ?? ''),
        children: (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $dbb74cb604a2ffe4$export$2e2bcd8739ae039), {
            icon: (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $624b17e4901a3bbe$export$2e2bcd8739ae039), {
                type: "outline",
                className: (0, $ff2225322a61af74$export$2e2bcd8739ae039).floating_action_bar_icon
            }),
            onClick: ()=>{},
            variant: "primary",
            size: "sm",
            customStyleClass: (0, $ff2225322a61af74$export$2e2bcd8739ae039).floating_action_bar_button,
            title: "More actions",
            "aria-label": "More actions"
        })
    });
};
$cfbdf554930c4fba$export$90297f34339487ef.displayName = 'FloatingActionBarMore';
/** Close button. */ const $cfbdf554930c4fba$export$53b7bec5b505dd9a = ({ onClose: onClose, className: className, ...props })=>(0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $dbb74cb604a2ffe4$export$2e2bcd8739ae039), {
        icon: (0, $81ee76508714b94a$export$35e795649ee09318).jsx((0, $9b21246be0527aa9$export$2e2bcd8739ae039), {
            className: (0, $e99e5f020fa3ffc8$export$1343a74baacb0543)((0, $ff2225322a61af74$export$2e2bcd8739ae039).floating_action_bar_close_button, (0, $ff2225322a61af74$export$2e2bcd8739ae039).floating_action_bar_icon)
        }),
        onClick: onClose,
        variant: "primary",
        size: "sm",
        customStyleClass: (0, $e99e5f020fa3ffc8$export$1343a74baacb0543)((0, $ff2225322a61af74$export$2e2bcd8739ae039).floating_action_bar_button, className ?? ''),
        title: "Close",
        ...props
    });
$cfbdf554930c4fba$export$53b7bec5b505dd9a.displayName = 'FloatingActionBarClose';
/* ------------------------------------------------------------------ */ /* Monolithic component, composed from the pieces above                */ /* ------------------------------------------------------------------ */ const $cfbdf554930c4fba$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($cQQee))).forwardRef(({ actions: actions, selectedCount: selectedCount = 0, onClose: onClose, draggable: draggable = false, ...props }, ref)=>{
    const visibleActions = actions.slice(0, $cfbdf554930c4fba$var$MAX_VISIBLE_ACTIONS);
    const hiddenActions = actions.slice($cfbdf554930c4fba$var$MAX_VISIBLE_ACTIONS);
    const hasMoreActions = hiddenActions.length > 0;
    return (0, $81ee76508714b94a$export$35e795649ee09318).jsxs($cfbdf554930c4fba$export$6d65a6beb80f884d, {
        forwardedRef: ref,
        draggable: draggable,
        ...props,
        children: [
            draggable ? (0, $81ee76508714b94a$export$35e795649ee09318).jsx($cfbdf554930c4fba$export$cceb5053deb5908a, {}) : null,
            selectedCount > 0 ? (0, $81ee76508714b94a$export$35e795649ee09318).jsxs((0, $81ee76508714b94a$export$35e795649ee09318).Fragment, {
                children: [
                    (0, $81ee76508714b94a$export$35e795649ee09318).jsx($cfbdf554930c4fba$export$b8c634a685c78953, {
                        count: selectedCount
                    }),
                    (0, $81ee76508714b94a$export$35e795649ee09318).jsx($cfbdf554930c4fba$export$39c8c1727ef1e388, {})
                ]
            }) : null,
            (0, $81ee76508714b94a$export$35e795649ee09318).jsxs($cfbdf554930c4fba$export$5211cf585049592e, {
                children: [
                    visibleActions.map((action)=>(0, $81ee76508714b94a$export$35e795649ee09318).jsx($cfbdf554930c4fba$export$f9a285f3c4fd6a4f, {
                            action: action
                        }, action.value)),
                    hasMoreActions ? (0, $81ee76508714b94a$export$35e795649ee09318).jsx($cfbdf554930c4fba$export$90297f34339487ef, {
                        actions: hiddenActions
                    }) : null
                ]
            }),
            onClose ? (0, $81ee76508714b94a$export$35e795649ee09318).jsxs((0, $81ee76508714b94a$export$35e795649ee09318).Fragment, {
                children: [
                    (0, $81ee76508714b94a$export$35e795649ee09318).jsx($cfbdf554930c4fba$export$39c8c1727ef1e388, {}),
                    (0, $81ee76508714b94a$export$35e795649ee09318).jsx($cfbdf554930c4fba$export$53b7bec5b505dd9a, {
                        onClose: onClose
                    })
                ]
            }) : null
        ]
    });
});
$cfbdf554930c4fba$export$2e2bcd8739ae039.displayName = 'FloatingActionBar';





const $239c5cd45bdd6c58$var$LaunchBar = ()=>{
    const [launchBarConfig, setLaunchBarConfig] = (0, $cQQee.useState)([]);
    const [draggable, setDraggable] = (0, $cQQee.useState)(false);
    (0, $cQQee.useEffect)(()=>{
        const fetchLaunchBarData = async ()=>{
            const initialDashboardData = await (0, $3a9d902ac0f87e31$export$ce73dddd9960dbb3)();
            setLaunchBarConfig(initialDashboardData?.config || []);
        };
        fetchLaunchBarData();
    }, []);
    // react-draggable@4.6.0 calls findDOMNode on drag-start, which returns null
    // if the bar isn't mounted yet. Enable dragging only after mount so the
    // DraggableCore node ref is stable before any drag gesture begins.
    (0, $cQQee.useEffect)(()=>{
        setDraggable(true);
    }, []);
    const actions = (0, $cQQee.useMemo)(()=>launchBarConfig.map((item)=>({
                label: item.displayName,
                value: `${item.id ?? item.displayName}`,
                onSelect: ()=>(0, $b61f740b64a51955$export$aadfb17cbf18b44d)(item),
                icon: /*#__PURE__*/ (0, $7Tw3V.jsx)((0, $2f0a72dbc6470dcd$export$2e2bcd8739ae039), {
                    src: `images/outlined/${item?.icon?.imgName || "lsq_copy"}.svg`,
                    alt: item.displayName,
                    isWidgetIcon: false,
                    title: item.displayName,
                    draggable: "false",
                    style: {
                        filter: "brightness(0) invert(1)"
                    }
                })
            })), [
        launchBarConfig
    ]);
    if (launchBarConfig.length === 0) return;
    return /*#__PURE__*/ (0, $7Tw3V.jsx)((0, $cfbdf554930c4fba$export$2e2bcd8739ae039), {
        draggable: draggable,
        actions: actions
    });
};
var $239c5cd45bdd6c58$export$2e2bcd8739ae039 = $239c5cd45bdd6c58$var$LaunchBar;





var $7Tw3V = parcelRequire("7Tw3V");
parcelRequire("cQQee");

const $22e8cd7a431146cf$var$RetryComponent = ({ onRetry: onRetry = ()=>{} })=>{
    return /*#__PURE__*/ (0, $7Tw3V.jsxs)("div", {
        className: "retry-container",
        children: [
            /*#__PURE__*/ (0, $7Tw3V.jsx)("h2", {
                className: "retry-title ng_h_1_r",
                children: "Something went wrong"
            }),
            /*#__PURE__*/ (0, $7Tw3V.jsx)("p", {
                className: "retry-message ng_h_4_r",
                children: "Please try again."
            }),
            /*#__PURE__*/ (0, $7Tw3V.jsx)("button", {
                className: "retry-button ng_btn_1_r",
                onClick: onRetry,
                children: "Retry"
            })
        ]
    });
};
var $22e8cd7a431146cf$export$2e2bcd8739ae039 = $22e8cd7a431146cf$var$RetryComponent;



var $7Tw3V = parcelRequire("7Tw3V");
parcelRequire("cQQee");


const $f489e2f1a20920be$var$NoWidgetsConfigured = ()=>{
    return /*#__PURE__*/ (0, $7Tw3V.jsxs)("div", {
        className: "no-widgets-message",
        style: {
            textAlign: "center",
            padding: "20px",
            fontSize: "18px"
        },
        children: [
            /*#__PURE__*/ (0, $7Tw3V.jsx)((0, $2f0a72dbc6470dcd$export$2e2bcd8739ae039), {
                src: "assets/icons/no_widgets_available.svg",
                alt: "icon",
                isWidgetIcon: false
            }),
            /*#__PURE__*/ (0, $7Tw3V.jsx)("span", {
                className: "ng_h_4_r",
                children: "No homepage assigned to this team"
            })
        ]
    });
};
var $f489e2f1a20920be$export$2e2bcd8739ae039 = $f489e2f1a20920be$var$NoWidgetsConfigured;




const $8096eac90cc8c7c1$var$App = ()=>{
    const { layout: layout, dashboards: dashboards, activeDashboard: activeDashboard, cssLoad: cssLoad, setActiveDashboard: setActiveDashboard, smartviewsConfig: smartviewsConfig, initialize: initialize } = (0, $958a5648d2d0bc08$export$2e2bcd8739ae039)();
    (0, $cQQee.useEffect)(()=>{
        (0, $0efbd8a8be009329$export$2e2bcd8739ae039).init();
        (0, $0efbd8a8be009329$export$2e2bcd8739ae039).setUser((0, $8a9518f7458123dc$export$714d3544202969b)());
    }, []);
    let content;
    if (dashboards.responseStatus === (0, $4b9f68b1938e412c$export$2a1f9a4a898c1733).requestPending || smartviewsConfig.responseStatus === (0, $4b9f68b1938e412c$export$2a1f9a4a898c1733).requestPending || cssLoad.responseStatus === (0, $4b9f68b1938e412c$export$2a1f9a4a898c1733).requestPending) content = /*#__PURE__*/ (0, $7Tw3V.jsx)((0, $5baaa1ae41951b99$export$2e2bcd8739ae039), {});
    else if (dashboards.responseStatus === (0, $4b9f68b1938e412c$export$2a1f9a4a898c1733).requestRejected || smartviewsConfig.responseStatus === (0, $4b9f68b1938e412c$export$2a1f9a4a898c1733).requestRejected || cssLoad.responseStatus === (0, $4b9f68b1938e412c$export$2a1f9a4a898c1733).requestRejected) content = /*#__PURE__*/ (0, $7Tw3V.jsx)((0, $22e8cd7a431146cf$export$2e2bcd8739ae039), {
        onRetry: initialize
    });
    else if (dashboards.response.length === 0) content = /*#__PURE__*/ (0, $7Tw3V.jsx)((0, $f489e2f1a20920be$export$2e2bcd8739ae039), {});
    else content = /*#__PURE__*/ (0, $7Tw3V.jsx)((0, $b25983443cec65f4$export$2e2bcd8739ae039), {
        layoutJSON: layout,
        coverPageData: activeDashboard?.layout?.coverPage,
        dashboards: dashboards.response,
        activeDashboard: activeDashboard,
        setActiveDashboard: setActiveDashboard,
        smartviewsConfig: smartviewsConfig.response
    });
    return /*#__PURE__*/ (0, $7Tw3V.jsxs)("div", {
        className: "casa-web-dashboard-body custom-app-container",
        style: {
            width: "100%",
            height: "100%"
        },
        children: [
            content,
            /*#__PURE__*/ (0, $7Tw3V.jsx)((0, $239c5cd45bdd6c58$export$2e2bcd8739ae039), {})
        ]
    });
};
var $8096eac90cc8c7c1$export$2e2bcd8739ae039 = $8096eac90cc8c7c1$var$App;







var $cQQee = parcelRequire("cQQee");

var $cQQee = parcelRequire("cQQee");
var $8eb338b7f0cef31f$export$cf8dec8cfeb9cb3;
(function(AvailableTheme) {
    AvailableTheme["Dark"] = "DARK";
    AvailableTheme["Default"] = "DEFAULT";
    AvailableTheme["HighContrast"] = "HIGH_CONTRAST";
})($8eb338b7f0cef31f$export$cf8dec8cfeb9cb3 || ($8eb338b7f0cef31f$export$cf8dec8cfeb9cb3 = {}));


const $e943ff71b2204db0$var$baseZIndex = 100;
/* eslint-disable @typescript-eslint/naming-convention */ const $e943ff71b2204db0$export$9e955aef208055a6 = {
    'marvin-fw-bold': '700',
    'marvin-fw-semibold': '600',
    'marvin-fw-regular': '400',
    'marvin-fw-light': '300',
    'marvin-red-900': '63,15,8',
    'marvin-red-700': '147,36,19',
    'marvin-red-500': '209,51,27',
    'marvin-red-300': '237,173,165',
    'marvin-red-100': '250,235,233',
    'marvin-orange-900': '72,37,10',
    'marvin-orange-700': '166,86,25',
    'marvin-orange-500': '237,123,36',
    'marvin-orange-300': '248,202,168',
    'marvin-orange-100': '253,242,234',
    'marvin-amber-900': '74,53,5',
    'marvin-amber-700': '172,124,26',
    'marvin-amber-500': '237,123,36',
    'marvin-amber-300': '251,224,155',
    'marvin-amber-100': '254,247,230',
    'marvin-yellow-900': '73,70,9',
    'marvin-yellow-700': '172,162,32',
    'marvin-yellow-500': '245,231,51',
    'marvin-yellow-300': '249,241,121',
    'marvin-yellow-100': '254,253,233',
    'marvin-yellow-50': '213,137,7',
    'marvin-light-green-900': '46,65,5',
    'marvin-light-green-700': '105,150,25',
    'marvin-light-green-500': '136,206,39',
    'marvin-light-green-300': '213,239,158',
    'marvin-light-green-100': '245,251,231',
    'marvin-green-900': '18,55,21',
    'marvin-green-700': '41,125,48',
    'marvin-green-500': '59,179,69',
    'marvin-green-300': '178,225,182',
    'marvin-green-100': '236,247,237',
    'marvin-cyan-900': '21,57,60',
    'marvin-cyan-700': '51,134,141',
    'marvin-cyan-500': '70,191,201',
    'marvin-cyan-300': '182,229,234',
    'marvin-cyan-100': '238,249,250',
    'marvin-blue-900': '1,34,64',
    'marvin-blue-700': '8,78,150',
    'marvin-blue-500': '17,111,214',
    'marvin-blue-300': '153,197,239',
    'marvin-blue-100': '231,241,251',
    'marvin-indigo-900': '25,30,59',
    'marvin-indigo-700': '62,69,137',
    'marvin-indigo-500': '88,99,196',
    'marvin-indigo-300': '189,193,231',
    'marvin-indigo-100': '238,239,249',
    'marvin-purple-900': '44,29,65',
    'marvin-purple-700': '103,69,152',
    'marvin-purple-500': '147,98,217',
    'marvin-purple-300': '212,192,240',
    'marvin-purple-100': '244,239,251',
    'marvin-pink-900': '68,13,42',
    'marvin-pink-700': '160,30,99',
    'marvin-pink-500': '227,44,141',
    'marvin-pink-300': '244,170,210',
    'marvin-pink-100': '252,234,244',
    'marvin-brown-900': '33,25,22',
    'marvin-brown-700': '76,60,51',
    'marvin-brown-500': '109,86,74',
    'marvin-brown-300': '194,187,183',
    'marvin-brown-100': '240,237,238',
    'marvin-sky-900': '18,50,70',
    'marvin-sky-700': '50,117,164',
    'marvin-sky-500': '74,167,234',
    'marvin-sky-300': '170,220,246',
    'marvin-sky-100': '234,245,253',
    //z-index variables
    'marvin-base-z-index': `${$e943ff71b2204db0$var$baseZIndex}`,
    'marvin-web-header-z-index': `${300}`,
    'marvin-vcard-z-index': `${$e943ff71b2204db0$var$baseZIndex + 100}`,
    'marvin-overlay-z-index': `${$e943ff71b2204db0$var$baseZIndex + 200}`,
    'action-menu-z-index': `${$e943ff71b2204db0$var$baseZIndex + 300}`,
    'profile-action-menu-z-index': '10002',
    'marvin-modal-z-index': `${$e943ff71b2204db0$var$baseZIndex + 400}`,
    'marvin-side-modal-z-index': `${$e943ff71b2204db0$var$baseZIndex + 9902}`,
    'global-search-z-index': `${$e943ff71b2204db0$var$baseZIndex + 10000}`,
    'marvin-tooltip-z-index': `${$e943ff71b2204db0$var$baseZIndex + 9903}`,
    'marvin-notification-z-index': `${$e943ff71b2204db0$var$baseZIndex + 99999}`,
    'full-screen-z-index': `${$e943ff71b2204db0$var$baseZIndex + 200}`,
    'drag-drop-modal-z-index': `${$e943ff71b2204db0$var$baseZIndex + 1000000}`,
    //END:z-index variables
    'marvin-vcard-height': '96px'
};


/* eslint-disable @typescript-eslint/naming-convention */ const $e68ad2bb8db008fb$export$3e936a8db52a10a0 = {
    id: '0002',
    name: 'dark',
    mode: 'DARK',
    'marvin-blue-darker': '233,245,255',
    'marvin-blue-700': '8,78,150',
    'marvin-amber-500': '237,123,36',
    'marvin-background-1': '29,29,29',
    'marvin-divider-1': '54,54,54',
    'marvin-secondary-text': '220,220,220',
    'marvin-primary': '44,153,253',
    'marvin-primary-text': '250,250,250',
    'marvin-tertiary-text': '173,173,173',
    'marvin-quaternary-text': '128,128,128',
    'marvin-base': '36,36,36',
    'marvin-icon-1': '101,101,101',
    'marvin-background-2': '20,20,20',
    'marvin-border-1': '67,67,67',
    'marvin-danger-1': '253,105,102',
    'marvin-danger-4': '255,240,239',
    'marvin-success-1': '90,209,109',
    'marvin-success-4': '238,251,240',
    'marvin-warning-1': '254,177,90',
    'marvin-warning-4': '255,247,238',
    'marvin-primary-light': '233,245,255',
    'marvin-primary-dark': '23,43,77',
    'marvin-link': '44,153,253',
    'marvin-link-visited': '182,86,232',
    // New Variables
    // Text Colors
    'ng-primary-text': '246, 247, 249' /* ng-neutral-90 */ ,
    'ng-secondary-text': '208, 214, 226' /* ng-neutral-80 */ ,
    'ng-tertiary-text': '160, 172, 197' /* ng-neutral-70 */ ,
    'ng-quaternary-text': '140, 149, 166' /* ng-neutral-60 */ ,
    'ng-disabled-text': '111, 122, 144' /* ng-neutral-50 */ ,
    // Background Colors
    'ng-background-0': '27, 29, 35' /* ng-neutral-0 */ ,
    'ng-background-10': '18, 20, 23' /* ng-neutral-10 */ ,
    'ng-background-20': '0, 0, 0' /* ng-neutral-20 */ ,
    //Others
    'ng-border': '40, 44, 52' /* ng-neutral-30 */ ,
    'ng-icon-white': '255, 255, 255' /* ng-neutral-white */ ,
    'ng-icon-black': '24, 30, 37' /* ng-neutral-black */ ,
    'ng-gradient-full': '27, 29, 35' /* ng-neutral-0 */ ,
    // Main
    'ng-link-text': '41, 112, 255',
    // Neutral
    'ng-neutral-0': '27, 29, 35',
    'ng-neutral-10': '18, 20, 23',
    'ng-neutral-20': '0, 0, 0',
    'ng-neutral-30': '40, 44, 52',
    'ng-neutral-40': '69, 76, 89',
    'ng-neutral-50': '111, 122, 144',
    'ng-neutral-60': '140, 149, 166',
    'ng-neutral-70': '160, 172, 197',
    'ng-neutral-80': '208, 214, 226',
    'ng-neutral-90': '246, 247, 249',
    'ng-neutral-white': '255, 255, 255',
    'ng-neutral-black': '24, 30, 37',
    'ng-neutral-light-black': '39, 49, 63',
    'ng-neutral-dark-black': '0, 0, 0',
    // Primary
    'ng-primary-0': '0, 27, 82',
    'ng-primary-10': '0, 50, 151',
    'ng-primary-20': '0, 78, 235',
    'ng-primary-30': '20, 99, 255',
    'ng-primary-40': '112, 160, 255',
    'ng-primary-50': '153, 187, 255',
    'ng-primary-content-icon': '255, 255, 255',
    // Secondary
    'ng-secondary-0': '29, 36, 103',
    'ng-secondary-10': '37, 45, 131',
    'ng-secondary-20': '43, 52, 151',
    'ng-secondary-30': '48, 61, 177',
    'ng-secondary-40': '131, 140, 221',
    'ng-secondary-50': '159, 166, 229',
    'ng-secondary-content-icon': '255, 255, 255',
    // Extended
    // Red
    'ng-red-0': '83, 9, 16',
    'ng-red-10': '97, 10, 19',
    'ng-red-20': '170, 14, 30',
    'ng-red-30': '210, 20, 39',
    'ng-red-40': '234, 34, 54',
    'ng-red-50': '244, 63, 81',
    'ng-red-60': '254, 164, 173',
    'ng-red-70': '255, 214, 217',
    'ng-red-80': '255, 228, 230',
    'ng-red-90': '255, 242, 242',
    // Brown
    'ng-brown-0': '66, 23, 10',
    'ng-brown-10': '102, 35, 16',
    'ng-brown-20': '118, 40, 18',
    'ng-brown-30': '135, 55, 25',
    'ng-brown-40': '153, 71, 31',
    'ng-brown-50': '210, 97, 40',
    'ng-brown-60': '205, 96, 35',
    'ng-brown-70': '221, 117, 59',
    'ng-brown-80': '234, 145, 95',
    'ng-brown-90': '241, 179, 148',
    // Yellow
    'ng-yellow-0': '76, 47, 0',
    'ng-yellow-10': '117, 82, 0',
    'ng-yellow-20': '184, 135, 0',
    'ng-yellow-30': '194, 142, 0',
    'ng-yellow-40': '255, 183, 0',
    'ng-yellow-50': '254, 193, 52',
    'ng-yellow-60': '255, 209, 84',
    'ng-yellow-70': '247, 222, 131',
    'ng-yellow-80': '251, 235, 180',
    'ng-yellow-90': '253, 248, 226',
    // Green
    'ng-green-0': '15, 51, 5',
    'ng-green-10': '20, 69, 7',
    'ng-green-20': '24, 83, 9',
    'ng-green-30': '33, 94, 18',
    'ng-green-40': '55, 154, 30',
    'ng-green-50': '66, 187, 36',
    'ng-green-60': '99, 197, 74',
    'ng-green-70': '114, 225, 89',
    'ng-green-80': '161, 224, 147',
    'ng-green-90': '198, 238, 189',
    // Teal
    'ng-teal-0': '3, 42, 42',
    'ng-teal-10': '5, 61, 60',
    'ng-teal-20': '15, 94, 94',
    'ng-teal-30': '18, 118, 111',
    'ng-teal-40': '13, 148, 139',
    'ng-teal-50': '16, 163, 153',
    'ng-teal-60': '30, 195, 179',
    'ng-teal-70': '56, 214, 196',
    'ng-teal-80': '122, 235, 233',
    'ng-teal-90': '175, 236, 232',
    // Cyan
    'ng-cyan-0': '6, 44, 60',
    'ng-cyan-10': '8, 55, 74',
    'ng-cyan-20': '21, 94, 116',
    'ng-cyan-30': '14, 116, 144',
    'ng-cyan-40': '3, 145, 177',
    'ng-cyan-50': '2, 183, 213',
    'ng-cyan-60': '32, 211, 238',
    'ng-cyan-70': '103, 232, 249',
    'ng-cyan-80': '165, 243, 253',
    'ng-cyan-90': '208, 250, 254',
    // Sky Blue
    'ng-sky-blue-0': '0, 49, 87',
    'ng-sky-blue-10': '0, 60, 107',
    'ng-sky-blue-20': '0, 106, 168',
    'ng-sky-blue-30': '3, 145, 223',
    'ng-sky-blue-40': '1, 164, 242',
    'ng-sky-blue-50': '2, 179, 255',
    'ng-sky-blue-60': '3, 191, 255',
    'ng-sky-blue-70': '35, 203, 255',
    'ng-sky-blue-80': '117, 218, 254',
    'ng-sky-blue-90': '174, 233, 254',
    // Ink Blue
    'ng-ink-blue-0': '17, 34, 80',
    'ng-ink-blue-10': '22, 46, 111',
    'ng-ink-blue-20': '27, 57, 136',
    'ng-ink-blue-30': '36, 74, 179',
    'ng-ink-blue-40': '51, 95, 214',
    'ng-ink-blue-50': '51, 95, 214',
    'ng-ink-blue-60': '81, 118, 220',
    'ng-ink-blue-70': '122, 154, 240',
    'ng-ink-blue-80': '170, 188, 238',
    'ng-ink-blue-90': '195, 208, 243',
    // Purple
    'ng-purple-0': '32, 18, 104',
    'ng-purple-10': '57, 38, 156',
    'ng-purple-20': '68, 45, 185',
    'ng-purple-30': '90, 66, 209',
    'ng-purple-40': '108, 87, 214',
    'ng-purple-50': '126, 106, 226',
    'ng-purple-60': '146, 128, 234',
    'ng-purple-70': '181, 163, 240',
    'ng-purple-80': '210, 199, 245',
    'ng-purple-90': '227, 220, 249',
    // Violet
    'ng-violet-0': '71, 12, 111',
    'ng-violet-10': '71, 12, 111',
    'ng-violet-20': '87, 25, 128',
    'ng-violet-30': '115, 36, 168',
    'ng-violet-40': '132, 48, 188',
    'ng-violet-50': '138, 54, 194',
    'ng-violet-60': '153, 87, 203',
    'ng-violet-70': '173, 119, 214',
    'ng-violet-80': '197, 160, 225',
    'ng-violet-90': '220, 197, 237',
    // Magenta
    'ng-magenta-0': '57, 20, 61',
    'ng-magenta-10': '80, 27, 78',
    'ng-magenta-20': '113, 38, 105',
    'ng-magenta-30': '113, 38, 105',
    'ng-magenta-40': '137, 35, 122',
    'ng-magenta-50': '141, 47, 121',
    'ng-magenta-60': '176, 59, 148',
    'ng-magenta-70': '198, 83, 170',
    'ng-magenta-80': '214, 132, 194',
    'ng-magenta-90': '230, 181, 218',
    // Lotus Pink
    'ng-lotus-pink-0': '56, 5, 25',
    'ng-lotus-pink-10': '85, 12, 41',
    'ng-lotus-pink-20': '125, 18, 61',
    'ng-lotus-pink-30': '190, 25, 93',
    'ng-lotus-pink-40': '219, 38, 119',
    'ng-lotus-pink-50': '236, 72, 153',
    'ng-lotus-pink-60': '243, 115, 183',
    'ng-lotus-pink-70': '249, 167, 212',
    'ng-lotus-pink-80': '251, 207, 231',
    'ng-lotus-pink-90': '253, 230, 244',
    // Success
    'ng-success-0': '17, 65, 35',
    'ng-success-10': '18, 84, 43',
    'ng-success-20': '22, 100, 52',
    'ng-success-30': '19, 128, 61',
    'ng-success-40': '25, 162, 74',
    'ng-success-50': '34, 197, 95',
    'ng-success-60': '77, 218, 129',
    'ng-success-70': '134, 238, 173',
    'ng-success-80': '175, 244, 199',
    'ng-success-90': '211, 248, 224',
    // Error
    'ng-error-0': '71, 17, 16',
    'ng-error-10': '104, 25, 23',
    'ng-error-20': '153, 27, 27',
    'ng-error-30': '185, 28, 29',
    'ng-error-40': '220, 38, 37',
    'ng-error-50': '239, 68, 68',
    'ng-error-60': '248, 113, 113',
    'ng-error-70': '253, 165, 165',
    'ng-error-80': '254, 202, 202',
    'ng-error-90': '255, 226, 225',
    // Warning
    'ng-warning-0': '96, 37, 5',
    'ng-warning-10': '132, 50, 6',
    'ng-warning-20': '169, 65, 10',
    'ng-warning-30': '189, 69, 5',
    'ng-warning-40': '230, 95, 5',
    'ng-warning-50': '255, 113, 5',
    'ng-warning-60': '255, 143, 46',
    'ng-warning-70': '255, 173, 102',
    'ng-warning-80': '255, 212, 174',
    'ng-warning-90': '255, 233, 213',
    // Ash
    'ng-ash-0': '250, 250, 250',
    'ng-ash-10': '245, 245, 245',
    'ng-ash-20': '229, 229, 229',
    'ng-ash-30': '212, 212, 212',
    'ng-ash-40': '163, 163, 163',
    'ng-ash-50': '115, 115, 115',
    'ng-ash-60': '82, 82, 82',
    'ng-ash-70': '64, 64, 64',
    'ng-ash-80': '38, 38, 38',
    'ng-ash-90': '23, 23, 23',
    // Grey
    'ng-grey-0': '14, 23, 41',
    'ng-grey-10': '30, 40, 58',
    'ng-grey-20': '51, 64, 85',
    'ng-grey-30': '72, 84, 105',
    'ng-grey-40': '100, 115, 139',
    'ng-grey-50': '148, 162, 184',
    'ng-grey-60': '148, 162, 184',
    'ng-grey-70': '203, 213, 224',
    'ng-grey-80': '226, 231, 241',
    'ng-grey-90': '241, 245, 249',
    // Zinc
    'ng-zinc-0': '24, 24, 27',
    'ng-zinc-10': '39, 39, 41',
    'ng-zinc-20': '63, 63, 70',
    'ng-zinc-30': '82, 82, 92',
    'ng-zinc-40': '113, 113, 123',
    'ng-zinc-50': '161, 161, 170',
    'ng-zinc-60': '212, 212, 216',
    'ng-zinc-70': '228, 228, 230',
    'ng-zinc-80': '244, 244, 245',
    'ng-zinc-90': '250, 250, 250',
    // Stone
    'ng-stone-0': '29, 25, 24',
    'ng-stone-10': '41, 37, 36',
    'ng-stone-20': '68, 64, 61',
    'ng-stone-30': '87, 83, 79',
    'ng-stone-40': '120, 113, 108',
    'ng-stone-50': '168, 162, 159',
    'ng-stone-60': '215, 211, 210',
    'ng-stone-70': '230, 229, 228',
    'ng-stone-80': '245, 245, 244',
    'ng-stone-90': '250, 250, 249',
    // Shadows
    'ng-shadow-black-3': '30, 40, 60, 0.16',
    'ng-shadow-black-5': '3, 3, 3, 0.2',
    'ng-shadow-black-8': '3, 3, 3, 0.32',
    'ng-shadow-black-12': '3, 3, 3, 0.48',
    'ng-shadow-black-25': '3, 3, 3, 0.6',
    'ng-shadow-error': '220, 38, 37, 0.24',
    'ng-shadow-success': '66, 187, 36, 0.24',
    'ng-shadow-warning': '255, 229, 98, 0.24',
    'ng-shadow-primary': '0, 55, 165, 1'
};


/* eslint-disable @typescript-eslint/naming-convention */ const $1528d705999d1db8$export$164de7ab8df77ef0 = {
    id: '0001',
    name: 'default',
    mode: 'DEFAULT',
    'marvin-blue-darker': '23,43,77',
    'marvin-background-1': '249,250,251',
    'marvin-divider-1': '223,227,232',
    'marvin-primary': '0,111,214',
    'marvin-base': '255,255,255',
    'marvin-icon-1': '173,186,199',
    'marvin-background-2': '244,246,248',
    'marvin-border-1': '202,211,219',
    'marvin-danger-1': '222,50,59',
    'marvin-danger-4': '255,240,241',
    'marvin-success-1': '24,159,63',
    'marvin-success-4': '240,255,245',
    'marvin-warning-1': '245,128,42',
    'marvin-warning-4': '255,243,235',
    'marvin-primary-light': '240,248,255',
    'marvin-primary-dark': '23,43,77',
    'marvin-primary-text': '33,43,54',
    'marvin-secondary-text': '69,79,91',
    'marvin-tertiary-text': '99,115,129',
    'marvin-quaternary-text': '145,158,171',
    'marvin-link': '0,111,214',
    'marvin-link-visited': '133,27,190',
    // New variables
    // Text Colors
    'ng-primary-text': '16, 20, 25' /* ng-neutral-90 */ ,
    'ng-secondary-text': '29, 37, 48' /* ng-neutral-80 */ ,
    'ng-tertiary-text': '41, 52, 66' /* ng-neutral-70 */ ,
    'ng-quaternary-text': '70, 89, 114' /* ng-neutral-60 */ ,
    'ng-disabled-text': '144, 160, 180' /* ng-neutral-50 */ ,
    // Background Colors
    'ng-background-0': '255, 255, 255' /* ng-neutral-0 */ ,
    'ng-background-10': '249, 250, 251' /* ng-neutral-10 */ ,
    'ng-background-20': '242, 244, 247' /* ng-neutral-20 */ ,
    //Others
    'ng-border': '230, 233, 237' /* ng-neutral-30 */ ,
    'ng-icon-white': '255, 255, 255' /* ng-neutral-white */ ,
    'ng-icon-black': '24, 30, 37' /* ng-neutral-black */ ,
    'ng-gradient-full': '255, 255, 255' /* ng-neutral-0 */ ,
    // Main
    'ng-link-text': '20, 99, 255',
    // Neutral
    'ng-neutral-0': '255, 255, 255',
    'ng-neutral-10': '246, 247, 249',
    'ng-neutral-20': '239, 242, 245',
    'ng-neutral-30': '217, 224, 232',
    'ng-neutral-40': '198, 208, 220',
    'ng-neutral-50': '144, 160, 180',
    'ng-neutral-60': '70, 89, 114',
    'ng-neutral-70': '41, 52, 66',
    'ng-neutral-80': '29, 37, 48',
    'ng-neutral-90': '16, 20, 25',
    'ng-neutral-white': '255, 255, 255',
    'ng-neutral-black': '16, 20, 25',
    'ng-neutral-light-black': '41, 52, 66',
    'ng-neutral-dark-black': '0, 0, 0',
    'ng-neutral-gradient': 'linear-gradient(225deg, #D9E0E8 0%, #90A0B4 100%)',
    // Primary
    'ng-primary-0': '235, 241, 255',
    'ng-primary-10': '194, 214, 255',
    'ng-primary-20': '56, 122, 255',
    'ng-primary-30': '20, 99, 255',
    'ng-primary-40': '0, 63, 189',
    'ng-primary-50': '0, 27, 82',
    'ng-primary-content-icon': '20, 99, 255',
    'ng-primary-gradient': 'linear-gradient(131deg, #7A9AF0 1.65%, #335FD6 76.59%)',
    // Secondary
    'ng-secondary-0': '243, 244, 252',
    'ng-secondary-10': '225, 227, 245',
    'ng-secondary-20': '78, 91, 207',
    'ng-secondary-30': '48, 61, 177',
    'ng-secondary-40': '35, 44, 128',
    'ng-secondary-50': '18, 22, 64',
    'ng-secondary-content-icon': '48, 61, 177',
    'ng-secondary-gradient': 'linear-gradient(105deg, #4E5BCF 21.66%, #232C80 78.82%)',
    // Extended
    // Red
    'ng-red-0': '255, 242, 242',
    'ng-red-10': '255, 228, 230',
    'ng-red-20': '255, 214, 217',
    'ng-red-30': '254, 164, 173',
    'ng-red-40': '251, 113, 127',
    'ng-red-50': '244, 63, 81',
    'ng-red-60': '234, 34, 54',
    'ng-red-70': '196, 16, 34',
    'ng-red-80': '159, 17, 31',
    'ng-red-90': '92, 10, 18',
    'ng-red-gradient': 'linear-gradient(105deg, #FF6E66 21.66%, #E93E35 78.82%)',
    // Brown
    'ng-brown-0': '255, 230, 199',
    'ng-brown-10': '245, 201, 179',
    'ng-brown-20': '241, 179, 148',
    'ng-brown-30': '234, 145, 95',
    'ng-brown-40': '221, 117, 59',
    'ng-brown-50': '205, 96, 35',
    'ng-brown-60': '174, 80, 33',
    'ng-brown-70': '153, 71, 31',
    'ng-brown-80': '135, 55, 25',
    'ng-brown-90': '118, 40, 18',
    'ng-brown-gradient': 'linear-gradient(104deg, #EA915F 20.57%, #CD6023 77.86%)',
    // Yellow
    'ng-yellow-0': '253, 248, 226',
    'ng-yellow-10': '251, 235, 180',
    'ng-yellow-20': '247, 222, 131',
    'ng-yellow-30': '245, 211, 81',
    'ng-yellow-40': '253, 200, 46',
    'ng-yellow-50': '253, 184, 22',
    'ng-yellow-60': '240, 172, 0',
    'ng-yellow-70': '242, 159, 7',
    'ng-yellow-80': '242, 142, 8',
    'ng-yellow-90': '241, 113, 1',
    'ng-yellow-gradient': 'linear-gradient(225deg, #FDB816 0%, #F5D351 100%)',
    // Green
    'ng-green-0': '231, 248, 227',
    'ng-green-10': '198, 238, 189',
    'ng-green-20': '161, 224, 147',
    'ng-green-30': '114, 225, 89',
    'ng-green-40': '99, 197, 74',
    'ng-green-50': '66, 187, 36',
    'ng-green-60': '58, 163, 31',
    'ng-green-70': '38, 134, 14',
    'ng-green-80': '34, 120, 13',
    'ng-green-90': '25, 87, 9',
    'ng-green-gradient': 'linear-gradient(106deg, #86EEAD 23.48%, #22C55F 81.67%)',
    // Teal
    'ng-teal-0': '224, 247, 244',
    'ng-teal-10': '175, 236, 232',
    'ng-teal-20': '122, 235, 233',
    'ng-teal-30': '56, 214, 196',
    'ng-teal-40': '30, 195, 179',
    'ng-teal-50': '16, 163, 153',
    'ng-teal-60': '13, 148, 139',
    'ng-teal-70': '18, 118, 111',
    'ng-teal-80': '15, 94, 94',
    'ng-teal-90': '5, 61, 60',
    'ng-teal-gradient': 'linear-gradient(105deg, #38D6C4 22.86%, #10A399 79.03%)',
    // Cyan
    'ng-cyan-0': '237, 255, 255',
    'ng-cyan-10': '208, 250, 254',
    'ng-cyan-20': '165, 243, 253',
    'ng-cyan-30': '103, 232, 249',
    'ng-cyan-40': '32, 211, 238',
    'ng-cyan-50': '2, 183, 213',
    'ng-cyan-60': '3, 145, 177',
    'ng-cyan-70': '14, 116, 144',
    'ng-cyan-80': '21, 94, 116',
    'ng-cyan-90': '8, 55, 74',
    'ng-cyan-gradient': 'linear-gradient(105deg, #67E8F9 23.55%, #02B7D5 82.52%)',
    // Sky Blue
    'ng-sky-blue-0': '224, 247, 255',
    'ng-sky-blue-10': '174, 233, 254',
    'ng-sky-blue-20': '117, 218, 254',
    'ng-sky-blue-30': '35, 203, 255',
    'ng-sky-blue-40': '3, 191, 255',
    'ng-sky-blue-50': '2, 179, 255',
    'ng-sky-blue-60': '1, 164, 242',
    'ng-sky-blue-70': '3, 145, 223',
    'ng-sky-blue-80': '0, 106, 168',
    'ng-sky-blue-90': '0, 78, 138',
    'ng-sky-blue-gradient': 'linear-gradient(105deg, #23CBFF 21.72%, #02B3FF 80.84%)',
    // Ink Blue
    'ng-ink-blue-0': '225, 232, 249',
    'ng-ink-blue-10': '195, 208, 243',
    'ng-ink-blue-20': '170, 188, 238',
    'ng-ink-blue-30': '122, 154, 240',
    'ng-ink-blue-40': '81, 118, 220',
    'ng-ink-blue-50': '51, 95, 214',
    'ng-ink-blue-60': '36, 74, 179',
    'ng-ink-blue-70': '31, 65, 157',
    'ng-ink-blue-80': '27, 57, 136',
    'ng-ink-blue-90': '21, 43, 102',
    'ng-ink-blue-gradient': 'linear-gradient(107deg, #7A9AF0 21.35%, #335FD6 81.58%)',
    // Purple
    'ng-purple-0': '244, 242, 253',
    'ng-purple-10': '227, 220, 249',
    'ng-purple-20': '210, 199, 245',
    'ng-purple-30': '181, 163, 240',
    'ng-purple-40': '146, 128, 234',
    'ng-purple-50': '126, 106, 226',
    'ng-purple-60': '108, 87, 214',
    'ng-purple-70': '90, 66, 209',
    'ng-purple-80': '68, 45, 185',
    'ng-purple-90': '32, 18, 104',
    'ng-purple-gradient': 'linear-gradient(105deg, #B5A3F0 20.76%, #7E6AE2 79.45%)',
    // Violet
    'ng-violet-0': '241, 232, 247',
    'ng-violet-10': '220, 197, 237',
    'ng-violet-20': '197, 160, 225',
    'ng-violet-30': '173, 119, 214',
    'ng-violet-40': '153, 87, 203',
    'ng-violet-50': '138, 54, 194',
    'ng-violet-60': '132, 48, 188',
    'ng-violet-70': '115, 36, 168',
    'ng-violet-80': '87, 25, 128',
    'ng-violet-90': '71, 12, 111',
    'ng-violet-gradient': 'linear-gradient(106deg, #AD77D6 22.25%, #8A36C2 81.66%)',
    // Magenta
    'ng-magenta-0': '245, 225, 240',
    'ng-magenta-10': '230, 181, 218',
    'ng-magenta-20': '214, 132, 194',
    'ng-magenta-30': '198, 83, 170',
    'ng-magenta-40': '176, 59, 148',
    'ng-magenta-50': '141, 47, 121',
    'ng-magenta-60': '137, 35, 122',
    'ng-magenta-70': '113, 38, 105',
    'ng-magenta-80': '98, 33, 96',
    'ng-magenta-90': '64, 23, 69',
    'ng-magenta-gradient': 'linear-gradient(107deg, #C653AA 22.15%, #8D2F79 82.75%);',
    // Lotus Pink
    'ng-lotuspink-0': '253, 243, 248',
    'ng-lotuspink-10': '253, 230, 244',
    'ng-lotuspink-20': '251, 207, 231',
    'ng-lotuspink-30': '249, 167, 212',
    'ng-lotuspink-40': '243, 115, 183',
    'ng-lotuspink-50': '236, 72, 153',
    'ng-lotuspink-60': '219, 38, 119',
    'ng-lotuspink-70': '190, 25, 93',
    'ng-lotuspink-80': '157, 23, 77',
    'ng-lotuspink-90': '80, 7, 36',
    'ng-lotuspink-gradient': 'linear-gradient(282deg, #EC4899 17.3%, #F9A7D4 82.7%)',
    // Success
    'ng-success-0': '240, 254, 243',
    'ng-success-10': '211, 248, 224',
    'ng-success-20': '175, 244, 199',
    'ng-success-30': '134, 238, 173',
    'ng-success-40': '77, 218, 129',
    'ng-success-50': '34, 197, 95',
    'ng-success-60': '25, 162, 74',
    'ng-success-70': '19, 128, 61',
    'ng-success-80': '22, 100, 52',
    'ng-success-90': '17, 65, 35',
    'ng-success-gradient': ' linear-gradient(106deg, #86EEAD 23.48%, #22C55F 81.67%',
    // Error
    'ng-error-0': '254, 243, 243',
    'ng-error-10': '255, 226, 225',
    'ng-error-20': '254, 202, 202',
    'ng-error-30': '253, 165, 165',
    'ng-error-40': '248, 113, 113',
    'ng-error-50': '239, 68, 68',
    'ng-error-60': '220, 38, 37',
    'ng-error-70': '185, 28, 29',
    'ng-error-80': '153, 27, 27',
    'ng-error-90': '104, 25, 23',
    'ng-error-gradient': 'linear-gradient(106deg, #FDA5A5 23.48%, #EF4444 81.67%)',
    // Warning
    'ng-warning-0': '255, 245, 237',
    'ng-warning-10': '255, 233, 213',
    'ng-warning-20': '255, 212, 174',
    'ng-warning-30': '255, 173, 102',
    'ng-warning-40': '255, 143, 46',
    'ng-warning-50': '255, 113, 5',
    'ng-warning-60': '230, 95, 5',
    'ng-warning-70': '189, 69, 5',
    'ng-warning-80': '154, 60, 9',
    'ng-warning-90': '123, 49, 10',
    'ng-warning-gradient': 'linear-gradient(105deg, #FFAD66 21.59%, #FF7105 80.65%)',
    // Ash
    'ng-ash-0': '250, 250, 250',
    'ng-ash-10': '245, 245, 245',
    'ng-ash-20': '229, 229, 229',
    'ng-ash-30': '212, 212, 212',
    'ng-ash-40': '163, 163, 163',
    'ng-ash-50': '115, 115, 115',
    'ng-ash-60': '82, 82, 82',
    'ng-ash-70': '64, 64, 64',
    'ng-ash-80': '38, 38, 38',
    'ng-ash-90': '23, 23, 23',
    'ng-ash-gradient': 'linear-gradient(105deg, #AFBDC0 21.66%, #5C6E75 78.82%)',
    // Grey
    'ng-grey-0': '249, 250, 252',
    'ng-grey-10': '241, 245, 249',
    'ng-grey-20': '226, 231, 241',
    'ng-grey-30': '203, 213, 224',
    'ng-grey-40': '148, 162, 184',
    'ng-grey-50': '100, 115, 139',
    'ng-grey-60': '72, 84, 105',
    'ng-grey-70': '51, 64, 85',
    'ng-grey-80': '30, 40, 58',
    'ng-grey-90': '14, 23, 41',
    'ng-grey-gradient': 'linear-gradient(105deg, #CCC 21.66%, #8B8B8B 78.82%)',
    // Zinc
    'ng-zinc-0': '250, 250, 250',
    'ng-zinc-10': '244, 244, 245',
    'ng-zinc-20': '228, 228, 230',
    'ng-zinc-30': '212, 212, 216',
    'ng-zinc-40': '161, 161, 170',
    'ng-zinc-50': '113, 113, 123',
    'ng-zinc-60': '82, 82, 92',
    'ng-zinc-70': '63, 63, 70',
    'ng-zinc-80': '39, 39, 41',
    'ng-zinc-90': '24, 24, 27',
    'ng-zinc-gradient': 'linear-gradient(105deg, #D4D4D8 21.66%, #71717B 78.82%)',
    // Stone
    'ng-stone-0': '250, 250, 249',
    'ng-stone-10': '245, 245, 244',
    'ng-stone-20': '230, 229, 228',
    'ng-stone-30': '215, 211, 210',
    'ng-stone-40': '168, 162, 159',
    'ng-stone-50': '120, 113, 108',
    'ng-stone-60': '87, 83, 79',
    'ng-stone-70': '68, 64, 61',
    'ng-stone-80': '41, 37, 36',
    'ng-stone-90': '29, 25, 24',
    'ng-stone-gradient': 'linear-gradient(221deg, #CABFBC 12.39%, #847367 89.58%)',
    // Shadows
    'ng-shadow-black-3': '30, 40, 60, 0.03',
    'ng-shadow-black-5': '3, 3, 3, 0.05',
    'ng-shadow-black-8': '3, 3, 3, 0.08',
    'ng-shadow-black-12': '3, 3, 3, 0.12',
    'ng-shadow-black-25': '3, 3, 3, 0.25',
    'ng-shadow-error': '220, 38, 37, 0.16',
    'ng-shadow-success': '66, 187, 36, 0.16',
    'ng-shadow-warning': '255, 229, 98, 0.24',
    'ng-shadow-primary': '220, 232, 255, 1',
    'ng-shadow-grey-3': '16, 24, 40, 0.03',
    'ng-shadow-grey-8': '16, 24, 40, 0.08'
};


/* eslint-disable @typescript-eslint/naming-convention */ const $20c73cc544f02428$export$ea4bc99e8c54529c = {
    id: '0003',
    name: 'highContrast',
    mode: 'HIGH_CONTRAST',
    'marvin-blue-darker': '23,43,77',
    'marvin-background-1': '249,250,251',
    'marvin-divider-1': '202,211,219',
    'marvin-primary': '0,111,214',
    'marvin-base': '255,255,255',
    'marvin-icon-1': '133,147,160',
    'marvin-background-2': '244,246,248',
    'marvin-border-1': '133,147,160',
    'marvin-danger-1': '209,52,60',
    'marvin-danger-4': '255,240,241',
    'marvin-success-1': '13,131,47',
    'marvin-success-4': '240,255,245',
    'marvin-warning-1': '221,117,28',
    'marvin-warning-4': '255,243,235',
    'marvin-primary-light': '240,248,255',
    'marvin-primary-dark': '23,43,77',
    'marvin-primary-text': '33,43,54',
    'marvin-secondary-text': '69,79,91',
    'marvin-tertiary-text': '99,115,129',
    'marvin-quaternary-text': '99,115,129',
    'marvin-link': '0,111,214',
    'marvin-link-visited': '133,27,190'
};


const $9dea3057a1627c2c$export$1fd8e5fe81e33951 = {
    DEFAULT: (0, $1528d705999d1db8$export$164de7ab8df77ef0),
    DARK: (0, $e68ad2bb8db008fb$export$3e936a8db52a10a0),
    BASE: (0, $e943ff71b2204db0$export$9e955aef208055a6),
    HIGH_CONTRAST: (0, $20c73cc544f02428$export$ea4bc99e8c54529c)
};


const $7cbaea21e70f8a3c$export$42c54008a6b62cbc = '___lsq-marvin-selected-theme-config___';
const $7cbaea21e70f8a3c$export$d8d5f548090d663e = {
    // TODO: need to update this colors for new design
    LINK_VISITED: 'marvin-link-visited',
    PRIMARY: 'marvin-primary',
    PRIMARY_LIGHT: 'marvin-primary-light',
    PRIMARY_DARK: 'marvin-primary-dark'
};



const $c5b562f0ffcc5fd2$var$SelectedThemeLSKey = 'selected-theme';
const $c5b562f0ffcc5fd2$var$setThemeConfigToGlobal = (config)=>{
    try {
        const globalWindow = window || {};
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        globalWindow[0, $7cbaea21e70f8a3c$export$42c54008a6b62cbc] = {
            ...globalWindow[0, $7cbaea21e70f8a3c$export$42c54008a6b62cbc] || {},
            ...config
        };
    } catch (error) {
        console.error(error);
    }
};
const $c5b562f0ffcc5fd2$export$49e16ec648d05eb2 = (selectedThemeConfig)=>{
    if (selectedThemeConfig) {
        const themeObjKeys = Object.keys(selectedThemeConfig);
        if (themeObjKeys?.length) {
            // The final theme variables after calculation/derivation is being set into LS
            // so that it can be accessed and passed to third party applications in context
            $c5b562f0ffcc5fd2$var$setThemeConfigToGlobal(selectedThemeConfig);
            themeObjKeys.forEach((key)=>{
                try {
                    document.documentElement.style.setProperty(`--${key}`, `${selectedThemeConfig[key]}`);
                } catch (error) {
                    console.error(error);
                }
            });
        }
    }
};
const $c5b562f0ffcc5fd2$var$getThemeFromLocalStorage = ()=>{
    try {
        //ToDo: string parsing failing, using localstorage directly
        return localStorage.getItem($c5b562f0ffcc5fd2$var$SelectedThemeLSKey);
    } catch (error) {
        console.error(error);
        return (0, $8eb338b7f0cef31f$export$cf8dec8cfeb9cb3).Default;
    }
};
const $c5b562f0ffcc5fd2$export$8df9cd9071adb18f = (themeName)=>{
    localStorage.setItem($c5b562f0ffcc5fd2$var$SelectedThemeLSKey, themeName);
};
const $c5b562f0ffcc5fd2$export$3bfd0d5209a8006a = (customThemeConfig)=>{
    try {
        if (customThemeConfig) return customThemeConfig?.IsDarkModeEnabled ? (0, $8eb338b7f0cef31f$export$cf8dec8cfeb9cb3).Dark : (0, $8eb338b7f0cef31f$export$cf8dec8cfeb9cb3).Default;
        return $c5b562f0ffcc5fd2$var$getThemeFromLocalStorage();
    } catch (error) {
        return (0, $8eb338b7f0cef31f$export$cf8dec8cfeb9cb3).Default;
    }
};
const $c5b562f0ffcc5fd2$export$5bc7b6373189a44b = (customThemeConfig)=>{
    return customThemeConfig ? customThemeConfig?.IsDarkModeEnabled : $c5b562f0ffcc5fd2$export$3bfd0d5209a8006a() === (0, $8eb338b7f0cef31f$export$cf8dec8cfeb9cb3).Dark;
};
const $c5b562f0ffcc5fd2$export$79ff4507c67dc0b = (launchConfig, customThemeConfig)=>{
    return !$c5b562f0ffcc5fd2$export$5bc7b6373189a44b(customThemeConfig) ? launchConfig?.ThemeColor : launchConfig?.DarkThemeColor;
};
const $c5b562f0ffcc5fd2$var$getLinkVisitedColor = ([primaryH, , primaryL])=>{
    const visitedColor = [
        primaryH + 75,
        50,
        primaryL
    ];
    return visitedColor;
};
function $c5b562f0ffcc5fd2$var$hslToHex(h, s, l) {
    l /= 100;
    const a = s * Math.min(l, 1 - l) / 100;
    const f = (n)=>{
        const k = (n + h / 30) % 12;
        const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
        return Math.round(255 * color).toString(16).padStart(2, '0'); // convert to Hex and prefix "0" if needed
    };
    return `#${f(0)}${f(8)}${f(4)}`;
}
function $c5b562f0ffcc5fd2$var$hexToRGB(color) {
    if (color.startsWith('#')) color = color.slice(1);
    if (color.length === 3) color = color.slice(0, 1) + color.slice(0, 1) + color.slice(1, 2) + color.slice(1, 2) + color.slice(2, 3) + color.slice(2, 3);
    const r = parseInt(`${color.charAt(0)}${color.charAt(1)}`, 16);
    const g = parseInt(`${color.charAt(2)}${color.charAt(3)}`, 16);
    const b = parseInt(`${color.charAt(4)}${color.charAt(5)}`, 16);
    return `${r}, ${g}, ${b}`;
}
function $c5b562f0ffcc5fd2$var$getDerivedColor(selectedColorHSLValues, src) {
    const [h, s, l] = selectedColorHSLValues;
    return Object.entries(src).reduce((acc, curr)=>{
        // eslint-disable-next-line prefer-const
        let [colorName, [customH, customS, customL]] = curr;
        if (colorName === (0, $7cbaea21e70f8a3c$export$d8d5f548090d663e).LINK_VISITED) [customH, customS, customL] = $c5b562f0ffcc5fd2$var$getLinkVisitedColor(selectedColorHSLValues);
        const colorInHex = $c5b562f0ffcc5fd2$var$hslToHex(customH ?? h, customS ?? s, customL ?? l);
        const colorString = $c5b562f0ffcc5fd2$var$hexToRGB(colorInHex);
        return {
            ...acc,
            [colorName]: colorString
        };
    }, {});
}
const $c5b562f0ffcc5fd2$var$colorHSLChanges = {
    [(0, $7cbaea21e70f8a3c$export$d8d5f548090d663e).PRIMARY]: [
        null,
        null,
        null
    ],
    [(0, $7cbaea21e70f8a3c$export$d8d5f548090d663e).PRIMARY_LIGHT]: [
        null,
        100,
        96
    ],
    [(0, $7cbaea21e70f8a3c$export$d8d5f548090d663e).PRIMARY_DARK]: [
        null,
        50,
        12
    ],
    [(0, $7cbaea21e70f8a3c$export$d8d5f548090d663e).LINK_VISITED]: [
        null,
        null,
        null
    ]
};
const $c5b562f0ffcc5fd2$export$8a810bfd75592fee = (color)=>{
    const selectedColorHSLValues = color.split(',').map((text)=>+text.trim());
    return $c5b562f0ffcc5fd2$var$getDerivedColor(selectedColorHSLValues, $c5b562f0ffcc5fd2$var$colorHSLChanges);
};
const $c5b562f0ffcc5fd2$var$updateDocumentClassList = (param)=>{
    document.body.classList.add(param);
};
const $c5b562f0ffcc5fd2$export$e84e5b26db16b6f7 = (themeName)=>{
    try {
        const themeList = [
            'default-mode',
            'dark-mode'
        ];
        themeList.forEach((theme)=>{
            document.body.classList.remove(theme);
        });
        if (themeName) $c5b562f0ffcc5fd2$var$updateDocumentClassList(`${themeName.toLowerCase()}-mode`);
        else $c5b562f0ffcc5fd2$var$updateDocumentClassList('default-mode');
    } catch (error) {
        console.error(error);
    }
};
const $c5b562f0ffcc5fd2$export$c7c10eb22ed08532 = (launchConfig)=>{
    const primaryColor = $c5b562f0ffcc5fd2$export$79ff4507c67dc0b(launchConfig);
    return primaryColor ? $c5b562f0ffcc5fd2$export$8a810bfd75592fee(primaryColor) : {};
};


function $44b96325dc2e3d6d$export$2e2bcd8739ae039() {
    const [themeConfig, setThemeConfig] = (0, $cQQee.useState)({
        ...(0, $9dea3057a1627c2c$export$1fd8e5fe81e33951).BASE,
        ...(0, $9dea3057a1627c2c$export$1fd8e5fe81e33951)[(0, $c5b562f0ffcc5fd2$export$3bfd0d5209a8006a)() || (0, $8eb338b7f0cef31f$export$cf8dec8cfeb9cb3).Default]
    });
    const [themeName, setThemeName] = (0, $cQQee.useState)((0, $c5b562f0ffcc5fd2$export$3bfd0d5209a8006a)() || (0, $8eb338b7f0cef31f$export$cf8dec8cfeb9cb3).Default);
    (0, $cQQee.useEffect)(()=>{
        setThemeConfig((prevThemeConfig)=>{
            const config = {
                ...prevThemeConfig
            };
            (0, $c5b562f0ffcc5fd2$export$49e16ec648d05eb2)(config);
            return config;
        });
    }, [
        themeName
    ]);
    const setTheme = (selectedThemeName, primaryColorConfig, onThemeUpdate)=>{
        const selectedThemeConfig = {
            ...(0, $9dea3057a1627c2c$export$1fd8e5fe81e33951).BASE,
            ...(0, $9dea3057a1627c2c$export$1fd8e5fe81e33951)[selectedThemeName],
            ...primaryColorConfig
        };
        if (selectedThemeName && selectedThemeConfig) {
            (0, $c5b562f0ffcc5fd2$export$8df9cd9071adb18f)(selectedThemeName);
            setThemeConfig(selectedThemeConfig);
            (0, $c5b562f0ffcc5fd2$export$e84e5b26db16b6f7)(selectedThemeName);
            setThemeName(selectedThemeName);
            (0, $c5b562f0ffcc5fd2$export$49e16ec648d05eb2)(selectedThemeConfig);
            if (onThemeUpdate) onThemeUpdate(selectedThemeConfig);
        }
    };
    return {
        theme: themeConfig,
        setTheme: setTheme
    };
}


const $03b366163b79980e$var$ThemeContext = (0, (/*@__PURE__*/$parcel$interopDefault($cQQee))).createContext({
    theme: {},
    setTheme: ()=>{}
});
const $03b366163b79980e$export$2e2bcd8739ae039 = (props)=>{
    const { children: children } = props;
    const { theme: theme, setTheme: setTheme } = (0, $44b96325dc2e3d6d$export$2e2bcd8739ae039)();
    const value = (0, $cQQee.useMemo)(()=>({
            theme: theme,
            setTheme: setTheme
        }), [
        theme,
        setTheme
    ]);
    return (0, $81ee76508714b94a$export$35e795649ee09318).jsx($03b366163b79980e$var$ThemeContext.Provider, {
        value: value,
        children: children
    });
};



var $299WK = parcelRequire("299WK");



(0, $299WK.p).init((0, $8a8f1a678e6f48e2$export$2ff27294bb84f577));
const $a535564da5bc030b$var$_user = (0, $8a9518f7458123dc$export$714d3544202969b)();
(0, $de5bf67cbc950cd2$export$b24072b01ab59bb6)({
    userId: $a535564da5bc030b$var$_user?.Id,
    orgCode: $a535564da5bc030b$var$_user?.OrgCode
});
const $a535564da5bc030b$export$bd45a425ac802846 = (containerId)=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($kC364))).render(/*#__PURE__*/ (0, $7Tw3V.jsx)((0, $03b366163b79980e$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $7Tw3V.jsx)((0, $8096eac90cc8c7c1$export$2e2bcd8739ae039), {})
    }), document.getElementById(containerId));
};




window.ReactApp = {
    renderApp: $a535564da5bc030b$export$bd45a425ac802846
};

})();
//# sourceMappingURL=entry.js.map
